import require$$2$1 from 'util';
import require$$0$1 from 'htmlparser2';
import require$$0$2 from 'url';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

function debounce$1(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  }
  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
}
// Adds compatibility for ES modules
debounce$1.debounce = debounce$1;

var debounce_1 = debounce$1;

var worker = {};

var AnalysisWebWorker$1 = {};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

/**
 * The regular expression for an HTML element.
 *
 * @type {RegExp}
 */
var htmlSplitRegex = function () {
  /* eslint-disable no-multi-spaces */
  var comments = '!' + // Start of comment, after the <.
  '(?:' + // Unroll the loop: Consume everything until --> is found.
  '-(?!->)' + // Dash not followed by end of comment.
  '[^\\-]*' + // Consume non-dashes.
  ')*' + // Loop possessively.
  '(?:-->)?'; // End of comment. If not found, match all input.

  var cdata = '!\\[CDATA\\[' + // Start of comment, after the <.
  '[^\\]]*' + // Consume non-].
  '(?:' + // Unroll the loop: Consume everything until ]]> is found.
  '](?!]>)' + // One ] not followed by end of comment.
  '[^\\]]*' + // Consume non-].
  ')*?' + // Loop possessively.
  '(?:]]>)?'; // End of comment. If not found, match all input.

  var escaped = '(?=' + // Is the element escaped?
  '!--' + '|' + '!\\[CDATA\\[' + ')' + '((?=!-)' + // If yes, which type?
  comments + '|' + cdata + ')';
  var regex = '(' + // Capture the entire match.
  '<' + // Find start of element.
  '(' + // Conditional expression follows.
  escaped + // Find end of escaped element.
  '|' + // ... else ...
  '[^>]*>?' + // Find end of normal element.
  ')' + ')';
  return new RegExp(regex);
  /* eslint-enable no-multi-spaces */
}();
/**
 * Separate HTML elements and comments from the text.
 *
 * @param  {string} input The text which has to be formatted.
 * @return {string[]}        The formatted text.
 */


function htmlSplit(input) {
  var parts = [];
  var workingInput = input;
  var match;

  while (match = workingInput.match(htmlSplitRegex)) {
    // The `match` result, when invoked on a RegExp with the `g` flag (`/foo/g`) will not include `index`.
    // If the `g` flag is omitted, `index` is included.
    // `htmlSplitRegex` does not have the `g` flag so we can assert it will have an index number.
    // Assert `match.index` is a number.
    var index =
    /** @type {number} */
    match.index;
    parts.push(workingInput.slice(0, index));
    parts.push(match[0]);
    workingInput = workingInput.slice(index + match[0].length);
  }

  if (workingInput.length) {
    parts.push(workingInput);
  }

  return parts;
}
/**
 * Replace characters or phrases within HTML elements only.
 *
 * @param  {string}                haystack     The text which has to be formatted.
 * @param  {Record<string,string>} replacePairs In the form {from: 'to', …}.
 * @return {string}                             The formatted text.
 */


function replaceInHtmlTags(haystack, replacePairs) {
  // Find all elements.
  var textArr = htmlSplit(haystack);
  var changed = false; // Extract all needles.

  var needles = Object.keys(replacePairs); // Loop through delimiters (elements) only.

  for (var i = 1; i < textArr.length; i += 2) {
    for (var j = 0; j < needles.length; j++) {
      var needle = needles[j];

      if (-1 !== textArr[i].indexOf(needle)) {
        textArr[i] = textArr[i].replace(new RegExp(needle, 'g'), replacePairs[needle]);
        changed = true; // After one strtr() break out of the foreach loop and look at next element.

        break;
      }
    }
  }

  if (changed) {
    haystack = textArr.join('');
  }

  return haystack;
}
/**
 * Replaces double line-breaks with paragraph elements.
 *
 * A group of regex replaces used to identify text formatted with newlines and
 * replace double line-breaks with HTML paragraph tags. The remaining line-
 * breaks after conversion become `<br />` tags, unless br is set to 'false'.
 *
 * @param  {string}    text The text which has to be formatted.
 * @param  {boolean}   br   Optional. If set, will convert all remaining line-
 *                          breaks after paragraphing. Default true.
 *
 * @example
 *```js
 * import { autop } from '@wordpress/autop';
 * autop( 'my text' ); // "<p>my text</p>"
 * ```
 *
 * @return {string}         Text which has been converted into paragraph tags.
 */


function autop(text) {
  var br = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var preTags = [];

  if (text.trim() === '') {
    return '';
  } // Just to make things a little easier, pad the end.


  text = text + '\n';
  /*
   * Pre tags shouldn't be touched by autop.
   * Replace pre tags with placeholders and bring them back after autop.
   */

  if (text.indexOf('<pre') !== -1) {
    var textParts = text.split('</pre>');
    var lastText = textParts.pop();
    text = '';

    for (var i = 0; i < textParts.length; i++) {
      var textPart = textParts[i];
      var start = textPart.indexOf('<pre'); // Malformed html?

      if (start === -1) {
        text += textPart;
        continue;
      }

      var name = '<pre wp-pre-tag-' + i + '></pre>';
      preTags.push([name, textPart.substr(start) + '</pre>']);
      text += textPart.substr(0, start) + name;
    }

    text += lastText;
  } // Change multiple <br>s into two line breaks, which will turn into paragraphs.


  text = text.replace(/<br\s*\/?>\s*<br\s*\/?>/g, '\n\n');
  var allBlocks = '(?:table|thead|tfoot|caption|col|colgroup|tbody|tr|td|th|div|dl|dd|dt|ul|ol|li|pre|form|map|area|blockquote|address|math|style|p|h[1-6]|hr|fieldset|legend|section|article|aside|hgroup|header|footer|nav|figure|figcaption|details|menu|summary)'; // Add a double line break above block-level opening tags.

  text = text.replace(new RegExp('(<' + allBlocks + '[\\s/>])', 'g'), '\n\n$1'); // Add a double line break below block-level closing tags.

  text = text.replace(new RegExp('(</' + allBlocks + '>)', 'g'), '$1\n\n'); // Standardize newline characters to "\n".

  text = text.replace(/\r\n|\r/g, '\n'); // Find newlines in all elements and add placeholders.

  text = replaceInHtmlTags(text, {
    '\n': ' <!-- wpnl --> '
  }); // Collapse line breaks before and after <option> elements so they don't get autop'd.

  if (text.indexOf('<option') !== -1) {
    text = text.replace(/\s*<option/g, '<option');
    text = text.replace(/<\/option>\s*/g, '</option>');
  }
  /*
   * Collapse line breaks inside <object> elements, before <param> and <embed> elements
   * so they don't get autop'd.
   */


  if (text.indexOf('</object>') !== -1) {
    text = text.replace(/(<object[^>]*>)\s*/g, '$1');
    text = text.replace(/\s*<\/object>/g, '</object>');
    text = text.replace(/\s*(<\/?(?:param|embed)[^>]*>)\s*/g, '$1');
  }
  /*
   * Collapse line breaks inside <audio> and <video> elements,
   * before and after <source> and <track> elements.
   */


  if (text.indexOf('<source') !== -1 || text.indexOf('<track') !== -1) {
    text = text.replace(/([<\[](?:audio|video)[^>\]]*[>\]])\s*/g, '$1');
    text = text.replace(/\s*([<\[]\/(?:audio|video)[>\]])/g, '$1');
    text = text.replace(/\s*(<(?:source|track)[^>]*>)\s*/g, '$1');
  } // Collapse line breaks before and after <figcaption> elements.


  if (text.indexOf('<figcaption') !== -1) {
    text = text.replace(/\s*(<figcaption[^>]*>)/, '$1');
    text = text.replace(/<\/figcaption>\s*/, '</figcaption>');
  } // Remove more than two contiguous line breaks.


  text = text.replace(/\n\n+/g, '\n\n'); // Split up the contents into an array of strings, separated by double line breaks.

  var texts = text.split(/\n\s*\n/).filter(Boolean); // Reset text prior to rebuilding.

  text = ''; // Rebuild the content as a string, wrapping every bit with a <p>.

  texts.forEach(function (textPiece) {
    text += '<p>' + textPiece.replace(/^\n*|\n*$/g, '') + '</p>\n';
  }); // Under certain strange conditions it could create a P of entirely whitespace.

  text = text.replace(/<p>\s*<\/p>/g, ''); // Add a closing <p> inside <div>, <address>, or <form> tag if missing.

  text = text.replace(/<p>([^<]+)<\/(div|address|form)>/g, '<p>$1</p></$2>'); // If an opening or closing block element tag is wrapped in a <p>, unwrap it.

  text = text.replace(new RegExp('<p>\\s*(</?' + allBlocks + '[^>]*>)\\s*</p>', 'g'), '$1'); // In some cases <li> may get wrapped in <p>, fix them.

  text = text.replace(/<p>(<li.+?)<\/p>/g, '$1'); // If a <blockquote> is wrapped with a <p>, move it inside the <blockquote>.

  text = text.replace(/<p><blockquote([^>]*)>/gi, '<blockquote$1><p>');
  text = text.replace(/<\/blockquote><\/p>/g, '</p></blockquote>'); // If an opening or closing block element tag is preceded by an opening <p> tag, remove it.

  text = text.replace(new RegExp('<p>\\s*(</?' + allBlocks + '[^>]*>)', 'g'), '$1'); // If an opening or closing block element tag is followed by a closing <p> tag, remove it.

  text = text.replace(new RegExp('(</?' + allBlocks + '[^>]*>)\\s*</p>', 'g'), '$1'); // Optionally insert line breaks.

  if (br) {
    // Replace newlines that shouldn't be touched with a placeholder.
    text = text.replace(/<(script|style).*?<\/\\1>/g, function (match) {
      return match[0].replace(/\n/g, '<WPPreserveNewline />');
    }); // Normalize <br>

    text = text.replace(/<br>|<br\/>/g, '<br />'); // Replace any new line characters that aren't preceded by a <br /> with a <br />.

    text = text.replace(/(<br \/>)?\s*\n/g, function (a, b) {
      return b ? a : '<br />\n';
    }); // Replace newline placeholders with newlines.

    text = text.replace(/<WPPreserveNewline \/>/g, '\n');
  } // If a <br /> tag is after an opening or closing block tag, remove it.


  text = text.replace(new RegExp('(</?' + allBlocks + '[^>]*>)\\s*<br />', 'g'), '$1'); // If a <br /> tag is before a subset of opening or closing block tags, remove it.

  text = text.replace(/<br \/>(\s*<\/?(?:p|li|div|dl|dd|dt|th|pre|td|ul|ol)[^>]*>)/g, '$1');
  text = text.replace(/\n<\/p>$/g, '</p>'); // Replace placeholder <pre> tags with their original content.

  preTags.forEach(function (preTag) {
    var _preTag = _slicedToArray$1(preTag, 2),
        name = _preTag[0],
        original = _preTag[1];

    text = text.replace(name, original);
  }); // Restore newlines in all elements.

  if (-1 !== text.indexOf('<!-- wpnl -->')) {
    text = text.replace(/\s?<!-- wpnl -->\s?/g, '\n');
  }

  return text;
}
/**
 * Replaces `<p>` tags with two line breaks. "Opposite" of autop().
 *
 * Replaces `<p>` tags with two line breaks except where the `<p>` has attributes.
 * Unifies whitespace. Indents `<li>`, `<dt>` and `<dd>` for better readability.
 *
 * @param  {string} html The content from the editor.
 *
 * @example
 * ```js
 * import { removep } from '@wordpress/autop';
 * removep( '<p>my text</p>' ); // "my text"
 * ```
 *
 * @return {string}      The content with stripped paragraph tags.
 */

function removep(html) {
  var blocklist = 'blockquote|ul|ol|li|dl|dt|dd|table|thead|tbody|tfoot|tr|th|td|h[1-6]|fieldset|figure';
  var blocklist1 = blocklist + '|div|p';
  var blocklist2 = blocklist + '|pre';
  /** @type {string[]} */

  var preserve = [];
  var preserveLinebreaks = false;
  var preserveBr = false;

  if (!html) {
    return '';
  } // Protect script and style tags.


  if (html.indexOf('<script') !== -1 || html.indexOf('<style') !== -1) {
    html = html.replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/g, function (match) {
      preserve.push(match);
      return '<wp-preserve>';
    });
  } // Protect pre tags.


  if (html.indexOf('<pre') !== -1) {
    preserveLinebreaks = true;
    html = html.replace(/<pre[^>]*>[\s\S]+?<\/pre>/g, function (a) {
      a = a.replace(/<br ?\/?>(\r\n|\n)?/g, '<wp-line-break>');
      a = a.replace(/<\/?p( [^>]*)?>(\r\n|\n)?/g, '<wp-line-break>');
      return a.replace(/\r?\n/g, '<wp-line-break>');
    });
  } // Remove line breaks but keep <br> tags inside image captions.


  if (html.indexOf('[caption') !== -1) {
    preserveBr = true;
    html = html.replace(/\[caption[\s\S]+?\[\/caption\]/g, function (a) {
      return a.replace(/<br([^>]*)>/g, '<wp-temp-br$1>').replace(/[\r\n\t]+/, '');
    });
  } // Normalize white space characters before and after block tags.


  html = html.replace(new RegExp('\\s*</(' + blocklist1 + ')>\\s*', 'g'), '</$1>\n');
  html = html.replace(new RegExp('\\s*<((?:' + blocklist1 + ')(?: [^>]*)?)>', 'g'), '\n<$1>'); // Mark </p> if it has any attributes.

  html = html.replace(/(<p [^>]+>[\s\S]*?)<\/p>/g, '$1</p#>'); // Preserve the first <p> inside a <div>.

  html = html.replace(/<div( [^>]*)?>\s*<p>/gi, '<div$1>\n\n'); // Remove paragraph tags.

  html = html.replace(/\s*<p>/gi, '');
  html = html.replace(/\s*<\/p>\s*/gi, '\n\n'); // Normalize white space chars and remove multiple line breaks.

  html = html.replace(/\n[\s\u00a0]+\n/g, '\n\n'); // Replace <br> tags with line breaks.

  html = html.replace(/(\s*)<br ?\/?>\s*/gi, function (_, space) {
    if (space && space.indexOf('\n') !== -1) {
      return '\n\n';
    }

    return '\n';
  }); // Fix line breaks around <div>.

  html = html.replace(/\s*<div/g, '\n<div');
  html = html.replace(/<\/div>\s*/g, '</div>\n'); // Fix line breaks around caption shortcodes.

  html = html.replace(/\s*\[caption([^\[]+)\[\/caption\]\s*/gi, '\n\n[caption$1[/caption]\n\n');
  html = html.replace(/caption\]\n\n+\[caption/g, 'caption]\n\n[caption'); // Pad block elements tags with a line break.

  html = html.replace(new RegExp('\\s*<((?:' + blocklist2 + ')(?: [^>]*)?)\\s*>', 'g'), '\n<$1>');
  html = html.replace(new RegExp('\\s*</(' + blocklist2 + ')>\\s*', 'g'), '</$1>\n'); // Indent <li>, <dt> and <dd> tags.

  html = html.replace(/<((li|dt|dd)[^>]*)>/g, ' \t<$1>'); // Fix line breaks around <select> and <option>.

  if (html.indexOf('<option') !== -1) {
    html = html.replace(/\s*<option/g, '\n<option');
    html = html.replace(/\s*<\/select>/g, '\n</select>');
  } // Pad <hr> with two line breaks.


  if (html.indexOf('<hr') !== -1) {
    html = html.replace(/\s*<hr( [^>]*)?>\s*/g, '\n\n<hr$1>\n\n');
  } // Remove line breaks in <object> tags.


  if (html.indexOf('<object') !== -1) {
    html = html.replace(/<object[\s\S]+?<\/object>/g, function (a) {
      return a.replace(/[\r\n]+/g, '');
    });
  } // Unmark special paragraph closing tags.


  html = html.replace(/<\/p#>/g, '</p>\n'); // Pad remaining <p> tags whit a line break.

  html = html.replace(/\s*(<p [^>]+>[\s\S]*?<\/p>)/g, '\n$1'); // Trim.

  html = html.replace(/^\s+/, '');
  html = html.replace(/[\s\u00a0]+$/, '');

  if (preserveLinebreaks) {
    html = html.replace(/<wp-line-break>/g, '\n');
  }

  if (preserveBr) {
    html = html.replace(/<wp-temp-br([^>]*)>/g, '<br$1>');
  } // Restore preserved tags.


  if (preserve.length) {
    html = html.replace(/<wp-preserve>/g, function () {
      return (
        /** @type {string} */
        preserve.shift()
      );
    });
  }

  return html;
}

var buildModule = /*#__PURE__*/Object.freeze({
	__proto__: null,
	autop: autop,
	removep: removep
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(buildModule);

/**
 * Checks whether the given feature is enabled.
 *
 * @param {string} featureName      The name of the feature to check.
 *
 * @returns {boolean} `true` when the feature is enabled, `false` if not.
 */
const isFeatureEnabled = function( featureName ) {
	if ( self.wpseoFeatureFlags ) {
		return self.wpseoFeatureFlags.includes( featureName );
	}
	return false;
};

/**
 * Enables the features with the given names.
 *
 * @param {string[]} featureNames   A list of names of the features to enable.
 *
 * @returns {void}
 */
const enableFeatures = function( featureNames ) {
	// If no features have been enabled yet, initialize the global array.
	if ( ! self.wpseoFeatureFlags ) {
		self.wpseoFeatureFlags = [];
	}

	// Check whether the features are already enabled, if not: add them.
	featureNames.forEach( name => {
		if ( ! self.wpseoFeatureFlags.includes( name ) ) {
			self.wpseoFeatureFlags.push( name );
		}
	} );
};

/**
 * Returns the list of enabled features.
 *
 * @returns {string[]} The list of enabled features.
 */
const enabledFeatures = function() {
	return self.wpseoFeatureFlags || [];
};

var featureFlag = /*#__PURE__*/Object.freeze({
	__proto__: null,
	isFeatureEnabled: isFeatureEnabled,
	enableFeatures: enableFeatures,
	enabledFeatures: enabledFeatures
});

var require$$1$2 = /*@__PURE__*/getAugmentedNamespace(featureFlag);

var jed = {exports: {}};

/**
 * @preserve jed.js https://github.com/SlexAxton/Jed
 */

(function (module, exports) {
/*
-----------
A gettext compatible i18n library for modern JavaScript Applications

by Alex Sexton - AlexSexton [at] gmail - @SlexAxton

MIT License

A jQuery Foundation project - requires CLA to contribute -
https://contribute.jquery.org/CLA/



Jed offers the entire applicable GNU gettext spec'd set of
functions, but also offers some nicer wrappers around them.
The api for gettext was written for a language with no function
overloading, so Jed allows a little more of that.

Many thanks to Joshua I. Miller - unrtst@cpan.org - who wrote
gettext.js back in 2008. I was able to vet a lot of my ideas
against his. I also made sure Jed passed against his tests
in order to offer easy upgrades -- jsgettext.berlios.de
*/
(function (root, undef) {

  // Set up some underscore-style functions, if you already have
  // underscore, feel free to delete this section, and use it
  // directly, however, the amount of functions used doesn't
  // warrant having underscore as a full dependency.
  // Underscore 1.3.0 was used to port and is licensed
  // under the MIT License by Jeremy Ashkenas.
  var ArrayProto    = Array.prototype,
      ObjProto      = Object.prototype,
      slice         = ArrayProto.slice,
      hasOwnProp    = ObjProto.hasOwnProperty,
      nativeForEach = ArrayProto.forEach,
      breaker       = {};

  // We're not using the OOP style _ so we don't need the
  // extra level of indirection. This still means that you
  // sub out for real `_` though.
  var _ = {
    forEach : function( obj, iterator, context ) {
      var i, l, key;
      if ( obj === null ) {
        return;
      }

      if ( nativeForEach && obj.forEach === nativeForEach ) {
        obj.forEach( iterator, context );
      }
      else if ( obj.length === +obj.length ) {
        for ( i = 0, l = obj.length; i < l; i++ ) {
          if ( i in obj && iterator.call( context, obj[i], i, obj ) === breaker ) {
            return;
          }
        }
      }
      else {
        for ( key in obj) {
          if ( hasOwnProp.call( obj, key ) ) {
            if ( iterator.call (context, obj[key], key, obj ) === breaker ) {
              return;
            }
          }
        }
      }
    },
    extend : function( obj ) {
      this.forEach( slice.call( arguments, 1 ), function ( source ) {
        for ( var prop in source ) {
          obj[prop] = source[prop];
        }
      });
      return obj;
    }
  };
  // END Miniature underscore impl

  // Jed is a constructor function
  var Jed = function ( options ) {
    // Some minimal defaults
    this.defaults = {
      "locale_data" : {
        "messages" : {
          "" : {
            "domain"       : "messages",
            "lang"         : "en",
            "plural_forms" : "nplurals=2; plural=(n != 1);"
          }
          // There are no default keys, though
        }
      },
      // The default domain if one is missing
      "domain" : "messages",
      // enable debug mode to log untranslated strings to the console
      "debug" : false
    };

    // Mix in the sent options with the default options
    this.options = _.extend( {}, this.defaults, options );
    this.textdomain( this.options.domain );

    if ( options.domain && ! this.options.locale_data[ this.options.domain ] ) {
      throw new Error('Text domain set to non-existent domain: `' + options.domain + '`');
    }
  };

  // The gettext spec sets this character as the default
  // delimiter for context lookups.
  // e.g.: context\u0004key
  // If your translation company uses something different,
  // just change this at any time and it will use that instead.
  Jed.context_delimiter = String.fromCharCode( 4 );

  function getPluralFormFunc ( plural_form_string ) {
    return Jed.PF.compile( plural_form_string || "nplurals=2; plural=(n != 1);");
  }

  function Chain( key, i18n ){
    this._key = key;
    this._i18n = i18n;
  }

  // Create a chainable api for adding args prettily
  _.extend( Chain.prototype, {
    onDomain : function ( domain ) {
      this._domain = domain;
      return this;
    },
    withContext : function ( context ) {
      this._context = context;
      return this;
    },
    ifPlural : function ( num, pkey ) {
      this._val = num;
      this._pkey = pkey;
      return this;
    },
    fetch : function ( sArr ) {
      if ( {}.toString.call( sArr ) != '[object Array]' ) {
        sArr = [].slice.call(arguments, 0);
      }
      return ( sArr && sArr.length ? Jed.sprintf : function(x){ return x; } )(
        this._i18n.dcnpgettext(this._domain, this._context, this._key, this._pkey, this._val),
        sArr
      );
    }
  });

  // Add functions to the Jed prototype.
  // These will be the functions on the object that's returned
  // from creating a `new Jed()`
  // These seem redundant, but they gzip pretty well.
  _.extend( Jed.prototype, {
    // The sexier api start point
    translate : function ( key ) {
      return new Chain( key, this );
    },

    textdomain : function ( domain ) {
      if ( ! domain ) {
        return this._textdomain;
      }
      this._textdomain = domain;
    },

    gettext : function ( key ) {
      return this.dcnpgettext.call( this, undef, undef, key );
    },

    dgettext : function ( domain, key ) {
     return this.dcnpgettext.call( this, domain, undef, key );
    },

    dcgettext : function ( domain , key /*, category */ ) {
      // Ignores the category anyways
      return this.dcnpgettext.call( this, domain, undef, key );
    },

    ngettext : function ( skey, pkey, val ) {
      return this.dcnpgettext.call( this, undef, undef, skey, pkey, val );
    },

    dngettext : function ( domain, skey, pkey, val ) {
      return this.dcnpgettext.call( this, domain, undef, skey, pkey, val );
    },

    dcngettext : function ( domain, skey, pkey, val/*, category */) {
      return this.dcnpgettext.call( this, domain, undef, skey, pkey, val );
    },

    pgettext : function ( context, key ) {
      return this.dcnpgettext.call( this, undef, context, key );
    },

    dpgettext : function ( domain, context, key ) {
      return this.dcnpgettext.call( this, domain, context, key );
    },

    dcpgettext : function ( domain, context, key/*, category */) {
      return this.dcnpgettext.call( this, domain, context, key );
    },

    npgettext : function ( context, skey, pkey, val ) {
      return this.dcnpgettext.call( this, undef, context, skey, pkey, val );
    },

    dnpgettext : function ( domain, context, skey, pkey, val ) {
      return this.dcnpgettext.call( this, domain, context, skey, pkey, val );
    },

    // The most fully qualified gettext function. It has every option.
    // Since it has every option, we can use it from every other method.
    // This is the bread and butter.
    // Technically there should be one more argument in this function for 'Category',
    // but since we never use it, we might as well not waste the bytes to define it.
    dcnpgettext : function ( domain, context, singular_key, plural_key, val ) {
      // Set some defaults

      plural_key = plural_key || singular_key;

      // Use the global domain default if one
      // isn't explicitly passed in
      domain = domain || this._textdomain;

      var fallback;

      // Handle special cases

      // No options found
      if ( ! this.options ) {
        // There's likely something wrong, but we'll return the correct key for english
        // We do this by instantiating a brand new Jed instance with the default set
        // for everything that could be broken.
        fallback = new Jed();
        return fallback.dcnpgettext.call( fallback, undefined, undefined, singular_key, plural_key, val );
      }

      // No translation data provided
      if ( ! this.options.locale_data ) {
        throw new Error('No locale data provided.');
      }

      if ( ! this.options.locale_data[ domain ] ) {
        throw new Error('Domain `' + domain + '` was not found.');
      }

      if ( ! this.options.locale_data[ domain ][ "" ] ) {
        throw new Error('No locale meta information provided.');
      }

      // Make sure we have a truthy key. Otherwise we might start looking
      // into the empty string key, which is the options for the locale
      // data.
      if ( ! singular_key ) {
        throw new Error('No translation key found.');
      }

      var key  = context ? context + Jed.context_delimiter + singular_key : singular_key,
          locale_data = this.options.locale_data,
          dict = locale_data[ domain ],
          defaultConf = (locale_data.messages || this.defaults.locale_data.messages)[""],
          pluralForms = dict[""].plural_forms || dict[""]["Plural-Forms"] || dict[""]["plural-forms"] || defaultConf.plural_forms || defaultConf["Plural-Forms"] || defaultConf["plural-forms"],
          val_list,
          res;

      var val_idx;
      if (val === undefined) {
        // No value passed in; assume singular key lookup.
        val_idx = 0;

      } else {
        // Value has been passed in; use plural-forms calculations.

        // Handle invalid numbers, but try casting strings for good measure
        if ( typeof val != 'number' ) {
          val = parseInt( val, 10 );

          if ( isNaN( val ) ) {
            throw new Error('The number that was passed in is not a number.');
          }
        }

        val_idx = getPluralFormFunc(pluralForms)(val);
      }

      // Throw an error if a domain isn't found
      if ( ! dict ) {
        throw new Error('No domain named `' + domain + '` could be found.');
      }

      val_list = dict[ key ];

      // If there is no match, then revert back to
      // english style singular/plural with the keys passed in.
      if ( ! val_list || val_idx > val_list.length ) {
        if (this.options.missing_key_callback) {
          this.options.missing_key_callback(key, domain);
        }
        res = [ singular_key, plural_key ];

        // collect untranslated strings
        if (this.options.debug===true) {
          console.log(res[ getPluralFormFunc(pluralForms)( val ) ]);
        }
        return res[ getPluralFormFunc()( val ) ];
      }

      res = val_list[ val_idx ];

      // This includes empty strings on purpose
      if ( ! res  ) {
        res = [ singular_key, plural_key ];
        return res[ getPluralFormFunc()( val ) ];
      }
      return res;
    }
  });


  // We add in sprintf capabilities for post translation value interolation
  // This is not internally used, so you can remove it if you have this
  // available somewhere else, or want to use a different system.

  // We _slightly_ modify the normal sprintf behavior to more gracefully handle
  // undefined values.

  /**
   sprintf() for JavaScript 0.7-beta1
   http://www.diveintojavascript.com/projects/javascript-sprintf

   Copyright (c) Alexandru Marasteanu <alexaholic [at) gmail (dot] com>
   All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:
       * Redistributions of source code must retain the above copyright
         notice, this list of conditions and the following disclaimer.
       * Redistributions in binary form must reproduce the above copyright
         notice, this list of conditions and the following disclaimer in the
         documentation and/or other materials provided with the distribution.
       * Neither the name of sprintf() for JavaScript nor the
         names of its contributors may be used to endorse or promote products
         derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
   ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
   WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
   DISCLAIMED. IN NO EVENT SHALL Alexandru Marasteanu BE LIABLE FOR ANY
   DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
   (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
   LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
   ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
   (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
  var sprintf = (function() {
    function get_type(variable) {
      return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase();
    }
    function str_repeat(input, multiplier) {
      for (var output = []; multiplier > 0; output[--multiplier] = input) {/* do nothing */}
      return output.join('');
    }

    var str_format = function() {
      if (!str_format.cache.hasOwnProperty(arguments[0])) {
        str_format.cache[arguments[0]] = str_format.parse(arguments[0]);
      }
      return str_format.format.call(null, str_format.cache[arguments[0]], arguments);
    };

    str_format.format = function(parse_tree, argv) {
      var cursor = 1, tree_length = parse_tree.length, node_type = '', arg, output = [], i, k, match, pad, pad_character, pad_length;
      for (i = 0; i < tree_length; i++) {
        node_type = get_type(parse_tree[i]);
        if (node_type === 'string') {
          output.push(parse_tree[i]);
        }
        else if (node_type === 'array') {
          match = parse_tree[i]; // convenience purposes only
          if (match[2]) { // keyword argument
            arg = argv[cursor];
            for (k = 0; k < match[2].length; k++) {
              if (!arg.hasOwnProperty(match[2][k])) {
                throw(sprintf('[sprintf] property "%s" does not exist', match[2][k]));
              }
              arg = arg[match[2][k]];
            }
          }
          else if (match[1]) { // positional argument (explicit)
            arg = argv[match[1]];
          }
          else { // positional argument (implicit)
            arg = argv[cursor++];
          }

          if (/[^s]/.test(match[8]) && (get_type(arg) != 'number')) {
            throw(sprintf('[sprintf] expecting number but found %s', get_type(arg)));
          }

          // Jed EDIT
          if ( typeof arg == 'undefined' || arg === null ) {
            arg = '';
          }
          // Jed EDIT

          switch (match[8]) {
            case 'b': arg = arg.toString(2); break;
            case 'c': arg = String.fromCharCode(arg); break;
            case 'd': arg = parseInt(arg, 10); break;
            case 'e': arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential(); break;
            case 'f': arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg); break;
            case 'o': arg = arg.toString(8); break;
            case 's': arg = ((arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg); break;
            case 'u': arg = Math.abs(arg); break;
            case 'x': arg = arg.toString(16); break;
            case 'X': arg = arg.toString(16).toUpperCase(); break;
          }
          arg = (/[def]/.test(match[8]) && match[3] && arg >= 0 ? '+'+ arg : arg);
          pad_character = match[4] ? match[4] == '0' ? '0' : match[4].charAt(1) : ' ';
          pad_length = match[6] - String(arg).length;
          pad = match[6] ? str_repeat(pad_character, pad_length) : '';
          output.push(match[5] ? arg + pad : pad + arg);
        }
      }
      return output.join('');
    };

    str_format.cache = {};

    str_format.parse = function(fmt) {
      var _fmt = fmt, match = [], parse_tree = [], arg_names = 0;
      while (_fmt) {
        if ((match = /^[^\x25]+/.exec(_fmt)) !== null) {
          parse_tree.push(match[0]);
        }
        else if ((match = /^\x25{2}/.exec(_fmt)) !== null) {
          parse_tree.push('%');
        }
        else if ((match = /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(_fmt)) !== null) {
          if (match[2]) {
            arg_names |= 1;
            var field_list = [], replacement_field = match[2], field_match = [];
            if ((field_match = /^([a-z_][a-z_\d]*)/i.exec(replacement_field)) !== null) {
              field_list.push(field_match[1]);
              while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                if ((field_match = /^\.([a-z_][a-z_\d]*)/i.exec(replacement_field)) !== null) {
                  field_list.push(field_match[1]);
                }
                else if ((field_match = /^\[(\d+)\]/.exec(replacement_field)) !== null) {
                  field_list.push(field_match[1]);
                }
                else {
                  throw('[sprintf] huh?');
                }
              }
            }
            else {
              throw('[sprintf] huh?');
            }
            match[2] = field_list;
          }
          else {
            arg_names |= 2;
          }
          if (arg_names === 3) {
            throw('[sprintf] mixing positional and named placeholders is not (yet) supported');
          }
          parse_tree.push(match);
        }
        else {
          throw('[sprintf] huh?');
        }
        _fmt = _fmt.substring(match[0].length);
      }
      return parse_tree;
    };

    return str_format;
  })();

  var vsprintf = function(fmt, argv) {
    argv.unshift(fmt);
    return sprintf.apply(null, argv);
  };

  Jed.parse_plural = function ( plural_forms, n ) {
    plural_forms = plural_forms.replace(/n/g, n);
    return Jed.parse_expression(plural_forms);
  };

  Jed.sprintf = function ( fmt, args ) {
    if ( {}.toString.call( args ) == '[object Array]' ) {
      return vsprintf( fmt, [].slice.call(args) );
    }
    return sprintf.apply(this, [].slice.call(arguments) );
  };

  Jed.prototype.sprintf = function () {
    return Jed.sprintf.apply(this, arguments);
  };
  // END sprintf Implementation

  // Start the Plural forms section
  // This is a full plural form expression parser. It is used to avoid
  // running 'eval' or 'new Function' directly against the plural
  // forms.
  //
  // This can be important if you get translations done through a 3rd
  // party vendor. I encourage you to use this instead, however, I
  // also will provide a 'precompiler' that you can use at build time
  // to output valid/safe function representations of the plural form
  // expressions. This means you can build this code out for the most
  // part.
  Jed.PF = {};

  Jed.PF.parse = function ( p ) {
    var plural_str = Jed.PF.extractPluralExpr( p );
    return Jed.PF.parser.parse.call(Jed.PF.parser, plural_str);
  };

  Jed.PF.compile = function ( p ) {
    // Handle trues and falses as 0 and 1
    function imply( val ) {
      return (val === true ? 1 : val ? val : 0);
    }

    var ast = Jed.PF.parse( p );
    return function ( n ) {
      return imply( Jed.PF.interpreter( ast )( n ) );
    };
  };

  Jed.PF.interpreter = function ( ast ) {
    return function ( n ) {
      switch ( ast.type ) {
        case 'GROUP':
          return Jed.PF.interpreter( ast.expr )( n );
        case 'TERNARY':
          if ( Jed.PF.interpreter( ast.expr )( n ) ) {
            return Jed.PF.interpreter( ast.truthy )( n );
          }
          return Jed.PF.interpreter( ast.falsey )( n );
        case 'OR':
          return Jed.PF.interpreter( ast.left )( n ) || Jed.PF.interpreter( ast.right )( n );
        case 'AND':
          return Jed.PF.interpreter( ast.left )( n ) && Jed.PF.interpreter( ast.right )( n );
        case 'LT':
          return Jed.PF.interpreter( ast.left )( n ) < Jed.PF.interpreter( ast.right )( n );
        case 'GT':
          return Jed.PF.interpreter( ast.left )( n ) > Jed.PF.interpreter( ast.right )( n );
        case 'LTE':
          return Jed.PF.interpreter( ast.left )( n ) <= Jed.PF.interpreter( ast.right )( n );
        case 'GTE':
          return Jed.PF.interpreter( ast.left )( n ) >= Jed.PF.interpreter( ast.right )( n );
        case 'EQ':
          return Jed.PF.interpreter( ast.left )( n ) == Jed.PF.interpreter( ast.right )( n );
        case 'NEQ':
          return Jed.PF.interpreter( ast.left )( n ) != Jed.PF.interpreter( ast.right )( n );
        case 'MOD':
          return Jed.PF.interpreter( ast.left )( n ) % Jed.PF.interpreter( ast.right )( n );
        case 'VAR':
          return n;
        case 'NUM':
          return ast.val;
        default:
          throw new Error("Invalid Token found.");
      }
    };
  };

  Jed.PF.extractPluralExpr = function ( p ) {
    // trim first
    p = p.replace(/^\s\s*/, '').replace(/\s\s*$/, '');

    if (! /;\s*$/.test(p)) {
      p = p.concat(';');
    }

    var nplurals_re = /nplurals\=(\d+);/,
        plural_re = /plural\=(.*);/,
        nplurals_matches = p.match( nplurals_re ),
        plural_matches;

    // Find the nplurals number
    if ( nplurals_matches.length > 1 ) ;
    else {
      throw new Error('nplurals not found in plural_forms string: ' + p );
    }

    // remove that data to get to the formula
    p = p.replace( nplurals_re, "" );
    plural_matches = p.match( plural_re );

    if (!( plural_matches && plural_matches.length > 1 ) ) {
      throw new Error('`plural` expression not found: ' + p);
    }
    return plural_matches[ 1 ];
  };

  /* Jison generated parser */
  Jed.PF.parser = (function(){

var parser = {trace: function trace() { },
yy: {},
symbols_: {"error":2,"expressions":3,"e":4,"EOF":5,"?":6,":":7,"||":8,"&&":9,"<":10,"<=":11,">":12,">=":13,"!=":14,"==":15,"%":16,"(":17,")":18,"n":19,"NUMBER":20,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",6:"?",7:":",8:"||",9:"&&",10:"<",11:"<=",12:">",13:">=",14:"!=",15:"==",16:"%",17:"(",18:")",19:"n",20:"NUMBER"},
productions_: [0,[3,2],[4,5],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,1],[4,1]],
performAction: function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$) {

var $0 = $$.length - 1;
switch (yystate) {
case 1: return { type : 'GROUP', expr: $$[$0-1] };
case 2:this.$ = { type: 'TERNARY', expr: $$[$0-4], truthy : $$[$0-2], falsey: $$[$0] };
break;
case 3:this.$ = { type: "OR", left: $$[$0-2], right: $$[$0] };
break;
case 4:this.$ = { type: "AND", left: $$[$0-2], right: $$[$0] };
break;
case 5:this.$ = { type: 'LT', left: $$[$0-2], right: $$[$0] };
break;
case 6:this.$ = { type: 'LTE', left: $$[$0-2], right: $$[$0] };
break;
case 7:this.$ = { type: 'GT', left: $$[$0-2], right: $$[$0] };
break;
case 8:this.$ = { type: 'GTE', left: $$[$0-2], right: $$[$0] };
break;
case 9:this.$ = { type: 'NEQ', left: $$[$0-2], right: $$[$0] };
break;
case 10:this.$ = { type: 'EQ', left: $$[$0-2], right: $$[$0] };
break;
case 11:this.$ = { type: 'MOD', left: $$[$0-2], right: $$[$0] };
break;
case 12:this.$ = { type: 'GROUP', expr: $$[$0-1] };
break;
case 13:this.$ = { type: 'VAR' };
break;
case 14:this.$ = { type: 'NUM', val: Number(yytext) };
break;
}
},
table: [{3:1,4:2,17:[1,3],19:[1,4],20:[1,5]},{1:[3]},{5:[1,6],6:[1,7],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16]},{4:17,17:[1,3],19:[1,4],20:[1,5]},{5:[2,13],6:[2,13],7:[2,13],8:[2,13],9:[2,13],10:[2,13],11:[2,13],12:[2,13],13:[2,13],14:[2,13],15:[2,13],16:[2,13],18:[2,13]},{5:[2,14],6:[2,14],7:[2,14],8:[2,14],9:[2,14],10:[2,14],11:[2,14],12:[2,14],13:[2,14],14:[2,14],15:[2,14],16:[2,14],18:[2,14]},{1:[2,1]},{4:18,17:[1,3],19:[1,4],20:[1,5]},{4:19,17:[1,3],19:[1,4],20:[1,5]},{4:20,17:[1,3],19:[1,4],20:[1,5]},{4:21,17:[1,3],19:[1,4],20:[1,5]},{4:22,17:[1,3],19:[1,4],20:[1,5]},{4:23,17:[1,3],19:[1,4],20:[1,5]},{4:24,17:[1,3],19:[1,4],20:[1,5]},{4:25,17:[1,3],19:[1,4],20:[1,5]},{4:26,17:[1,3],19:[1,4],20:[1,5]},{4:27,17:[1,3],19:[1,4],20:[1,5]},{6:[1,7],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[1,28]},{6:[1,7],7:[1,29],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16]},{5:[2,3],6:[2,3],7:[2,3],8:[2,3],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[2,3]},{5:[2,4],6:[2,4],7:[2,4],8:[2,4],9:[2,4],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[2,4]},{5:[2,5],6:[2,5],7:[2,5],8:[2,5],9:[2,5],10:[2,5],11:[2,5],12:[2,5],13:[2,5],14:[2,5],15:[2,5],16:[1,16],18:[2,5]},{5:[2,6],6:[2,6],7:[2,6],8:[2,6],9:[2,6],10:[2,6],11:[2,6],12:[2,6],13:[2,6],14:[2,6],15:[2,6],16:[1,16],18:[2,6]},{5:[2,7],6:[2,7],7:[2,7],8:[2,7],9:[2,7],10:[2,7],11:[2,7],12:[2,7],13:[2,7],14:[2,7],15:[2,7],16:[1,16],18:[2,7]},{5:[2,8],6:[2,8],7:[2,8],8:[2,8],9:[2,8],10:[2,8],11:[2,8],12:[2,8],13:[2,8],14:[2,8],15:[2,8],16:[1,16],18:[2,8]},{5:[2,9],6:[2,9],7:[2,9],8:[2,9],9:[2,9],10:[2,9],11:[2,9],12:[2,9],13:[2,9],14:[2,9],15:[2,9],16:[1,16],18:[2,9]},{5:[2,10],6:[2,10],7:[2,10],8:[2,10],9:[2,10],10:[2,10],11:[2,10],12:[2,10],13:[2,10],14:[2,10],15:[2,10],16:[1,16],18:[2,10]},{5:[2,11],6:[2,11],7:[2,11],8:[2,11],9:[2,11],10:[2,11],11:[2,11],12:[2,11],13:[2,11],14:[2,11],15:[2,11],16:[2,11],18:[2,11]},{5:[2,12],6:[2,12],7:[2,12],8:[2,12],9:[2,12],10:[2,12],11:[2,12],12:[2,12],13:[2,12],14:[2,12],15:[2,12],16:[2,12],18:[2,12]},{4:30,17:[1,3],19:[1,4],20:[1,5]},{5:[2,2],6:[1,7],7:[2,2],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[2,2]}],
defaultActions: {6:[2,1]},
parseError: function parseError(str, hash) {
    throw new Error(str);
},
parse: function parse(input) {
    var self = this,
        stack = [0],
        vstack = [null], // semantic value stack
        lstack = [], // location stack
        table = this.table,
        yytext = '',
        yylineno = 0,
        yyleng = 0,
        recovering = 0,
        TERROR = 2,
        EOF = 1;

    //this.reductionCount = this.shiftCount = 0;

    this.lexer.setInput(input);
    this.lexer.yy = this.yy;
    this.yy.lexer = this.lexer;
    if (typeof this.lexer.yylloc == 'undefined')
        this.lexer.yylloc = {};
    var yyloc = this.lexer.yylloc;
    lstack.push(yyloc);

    if (typeof this.yy.parseError === 'function')
        this.parseError = this.yy.parseError;

    function popStack (n) {
        stack.length = stack.length - 2*n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }

    function lex() {
        var token;
        token = self.lexer.lex() || 1; // $end = 1
        // if token isn't its numeric value, convert
        if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
        }
        return token;
    }

    var symbol, preErrorSymbol, state, action, r, yyval={},p,len,newState, expected;
    while (true) {
        // retreive state number from top of stack
        state = stack[stack.length-1];

        // use default actions if available
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol == null)
                symbol = lex();
            // read action for current state and first input
            action = table[state] && table[state][symbol];
        }

        // handle parse error
        if (typeof action === 'undefined' || !action.length || !action[0]) {

            if (!recovering) {
                // Report error
                expected = [];
                for (p in table[state]) if (this.terminals_[p] && p > 2) {
                    expected.push("'"+this.terminals_[p]+"'");
                }
                var errStr = '';
                if (this.lexer.showPosition) {
                    errStr = 'Parse error on line '+(yylineno+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+expected.join(', ') + ", got '" + this.terminals_[symbol]+ "'";
                } else {
                    errStr = 'Parse error on line '+(yylineno+1)+": Unexpected " +
                                  (symbol == 1 /*EOF*/ ? "end of input" :
                                              ("'"+(this.terminals_[symbol] || symbol)+"'"));
                }
                this.parseError(errStr,
                    {text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected});
            }

            // just recovered from another error
            if (recovering == 3) {
                if (symbol == EOF) {
                    throw new Error(errStr || 'Parsing halted.');
                }

                // discard current lookahead and grab another
                yyleng = this.lexer.yyleng;
                yytext = this.lexer.yytext;
                yylineno = this.lexer.yylineno;
                yyloc = this.lexer.yylloc;
                symbol = lex();
            }

            // try to recover from error
            while (1) {
                // check for error recovery rule in this state
                if ((TERROR.toString()) in table[state]) {
                    break;
                }
                if (state == 0) {
                    throw new Error(errStr || 'Parsing halted.');
                }
                popStack(1);
                state = stack[stack.length-1];
            }

            preErrorSymbol = symbol; // save the lookahead token
            symbol = TERROR;         // insert generic error symbol as new lookahead
            state = stack[stack.length-1];
            action = table[state] && table[state][TERROR];
            recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
        }

        // this shouldn't happen, unless resolve defaults are off
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: '+state+', token: '+symbol);
        }

        switch (action[0]) {

            case 1: // shift
                //this.shiftCount++;

                stack.push(symbol);
                vstack.push(this.lexer.yytext);
                lstack.push(this.lexer.yylloc);
                stack.push(action[1]); // push state
                symbol = null;
                if (!preErrorSymbol) { // normal execution/no error
                    yyleng = this.lexer.yyleng;
                    yytext = this.lexer.yytext;
                    yylineno = this.lexer.yylineno;
                    yyloc = this.lexer.yylloc;
                    if (recovering > 0)
                        recovering--;
                } else { // error just occurred, resume old lookahead f/ before error
                    symbol = preErrorSymbol;
                    preErrorSymbol = null;
                }
                break;

            case 2: // reduce
                //this.reductionCount++;

                len = this.productions_[action[1]][1];

                // perform semantic action
                yyval.$ = vstack[vstack.length-len]; // default to $$ = $1
                // default location, uses first token for firsts, last for lasts
                yyval._$ = {
                    first_line: lstack[lstack.length-(len||1)].first_line,
                    last_line: lstack[lstack.length-1].last_line,
                    first_column: lstack[lstack.length-(len||1)].first_column,
                    last_column: lstack[lstack.length-1].last_column
                };
                r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);

                if (typeof r !== 'undefined') {
                    return r;
                }

                // pop off stack
                if (len) {
                    stack = stack.slice(0,-1*len*2);
                    vstack = vstack.slice(0, -1*len);
                    lstack = lstack.slice(0, -1*len);
                }

                stack.push(this.productions_[action[1]][0]);    // push nonterminal (reduce)
                vstack.push(yyval.$);
                lstack.push(yyval._$);
                // goto new state = table[STATE][NONTERMINAL]
                newState = table[stack[stack.length-2]][stack[stack.length-1]];
                stack.push(newState);
                break;

            case 3: // accept
                return true;
        }

    }

    return true;
}};/* Jison generated lexer */
var lexer = (function(){

var lexer = ({EOF:1,
parseError:function parseError(str, hash) {
        if (this.yy.parseError) {
            this.yy.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },
setInput:function (input) {
        this._input = input;
        this._more = this._less = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {first_line:1,first_column:0,last_line:1,last_column:0};
        return this;
    },
input:function () {
        var ch = this._input[0];
        this.yytext+=ch;
        this.yyleng++;
        this.match+=ch;
        this.matched+=ch;
        var lines = ch.match(/\n/);
        if (lines) this.yylineno++;
        this._input = this._input.slice(1);
        return ch;
    },
unput:function (ch) {
        this._input = ch + this._input;
        return this;
    },
more:function () {
        this._more = true;
        return this;
    },
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20)+(next.length > 20 ? '...':'')).replace(/\n/g, "");
    },
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c+"^";
    },
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) this.done = true;

        var token,
            match,
            lines;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i=0;i < rules.length; i++) {
            match = this._input.match(this.rules[rules[i]]);
            if (match) {
                lines = match[0].match(/\n.*/g);
                if (lines) this.yylineno += lines.length;
                this.yylloc = {first_line: this.yylloc.last_line,
                               last_line: this.yylineno+1,
                               first_column: this.yylloc.last_column,
                               last_column: lines ? lines[lines.length-1].length-1 : this.yylloc.last_column + match[0].length};
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                this._more = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, rules[i],this.conditionStack[this.conditionStack.length-1]);
                if (token) return token;
                else return;
            }
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            this.parseError('Lexical error on line '+(this.yylineno+1)+'. Unrecognized text.\n'+this.showPosition(),
                    {text: "", token: null, line: this.yylineno});
        }
    },
lex:function lex() {
        var r = this.next();
        if (typeof r !== 'undefined') {
            return r;
        } else {
            return this.lex();
        }
    },
begin:function begin(condition) {
        this.conditionStack.push(condition);
    },
popState:function popState() {
        return this.conditionStack.pop();
    },
_currentRules:function _currentRules() {
        return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;
    },
topState:function () {
        return this.conditionStack[this.conditionStack.length-2];
    },
pushState:function begin(condition) {
        this.begin(condition);
    }});
lexer.performAction = function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
switch($avoiding_name_collisions) {
case 0:/* skip whitespace */
break;
case 1:return 20
case 2:return 19
case 3:return 8
case 4:return 9
case 5:return 6
case 6:return 7
case 7:return 11
case 8:return 13
case 9:return 10
case 10:return 12
case 11:return 14
case 12:return 15
case 13:return 16
case 14:return 17
case 15:return 18
case 16:return 5
case 17:return 'INVALID'
}
};
lexer.rules = [/^\s+/,/^[0-9]+(\.[0-9]+)?\b/,/^n\b/,/^\|\|/,/^&&/,/^\?/,/^:/,/^<=/,/^>=/,/^</,/^>/,/^!=/,/^==/,/^%/,/^\(/,/^\)/,/^$/,/^./];
lexer.conditions = {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],"inclusive":true}};return lexer;})();
parser.lexer = lexer;
return parser;
})();
// End parser

  // Handle node, amd, and global systems
  {
    if (module.exports) {
      exports = module.exports = Jed;
    }
    exports.Jed = Jed;
  }

})();
}(jed, jed.exports));

var Jed = jed.exports;

/** Detect free variable `global` from Node.js. */
var freeGlobal$2 = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$9 = freeGlobal$2 || freeSelf$1 || Function('return this')();

/** Built-in value references. */
var Symbol$6 = root$9.Symbol;

/** Used for built-in method references. */
var objectProto$E = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$x = objectProto$E.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$5 = objectProto$E.toString;

/** Built-in value references. */
var symToStringTag$3 = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$2(value) {
  var isOwn = hasOwnProperty$x.call(value, symToStringTag$3),
      tag = value[symToStringTag$3];

  try {
    value[symToStringTag$3] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$5.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag;
    } else {
      delete value[symToStringTag$3];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$D = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$4 = objectProto$D.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$2(value) {
  return nativeObjectToString$4.call(value);
}

/** `Object#toString` result references. */
var nullTag$1 = '[object Null]',
    undefinedTag$1 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$2 = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$7(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return (symToStringTag$2 && symToStringTag$2 in Object(value))
    ? getRawTag$2(value)
    : objectToString$2(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$7(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var symbolTag$5 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$5(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$7(value) && baseGetTag$7(value) == symbolTag$5);
}

/** Used as references for various `Number` constants. */
var NAN$3 = 0 / 0;

/**
 * The base implementation of `_.toNumber` which doesn't ensure correct
 * conversions of binary, hexadecimal, or octal string values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 */
function baseToNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$5(value)) {
    return NAN$3;
  }
  return +value;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap$3(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$b = Array.isArray;

/** Used as references for various `Number` constants. */
var INFINITY$8 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$4 = Symbol$6 ? Symbol$6.prototype : undefined,
    symbolToString$1 = symbolProto$4 ? symbolProto$4.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$2(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$b(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$3(value, baseToString$2) + '';
  }
  if (isSymbol$5(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$8) ? '-0' : result;
}

/**
 * Creates a function that performs a mathematical operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @param {number} [defaultValue] The value used for `undefined` arguments.
 * @returns {Function} Returns the new mathematical operation function.
 */
function createMathOperation(operator, defaultValue) {
  return function(value, other) {
    var result;
    if (value === undefined && other === undefined) {
      return defaultValue;
    }
    if (value !== undefined) {
      result = value;
    }
    if (other !== undefined) {
      if (result === undefined) {
        return other;
      }
      if (typeof value == 'string' || typeof other == 'string') {
        value = baseToString$2(value);
        other = baseToString$2(other);
      } else {
        value = baseToNumber(value);
        other = baseToNumber(other);
      }
      result = operator(value, other);
    }
    return result;
  };
}

/**
 * Adds two numbers.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {number} augend The first number in an addition.
 * @param {number} addend The second number in an addition.
 * @returns {number} Returns the total.
 * @example
 *
 * _.add(6, 4);
 * // => 10
 */
var add = createMathOperation(function(augend, addend) {
  return augend + addend;
}, 0);

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/** Used to match leading whitespace. */
var reTrimStart$2 = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart$2, '')
    : string;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$5(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** Used as references for various `Number` constants. */
var NAN$2 = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$2(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$5(value)) {
    return NAN$2;
  }
  if (isObject$5(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$5(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$2 : +value);
}

/** Used as references for various `Number` constants. */
var INFINITY$7 = 1 / 0,
    MAX_INTEGER$1 = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$2(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber$2(value);
  if (value === INFINITY$7 || value === -INFINITY$7) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER$1;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger$2(value) {
  var result = toFinite$2(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$c = 'Expected a function';

/**
 * The opposite of `_.before`; this method creates a function that invokes
 * `func` once it's called `n` or more times.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {number} n The number of calls before `func` is invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var saves = ['profile', 'settings'];
 *
 * var done = _.after(saves.length, function() {
 *   console.log('done saving!');
 * });
 *
 * _.forEach(saves, function(type) {
 *   asyncSave({ 'type': type, 'complete': done });
 * });
 * // => Logs 'done saving!' after the two async saves have completed.
 */
function after(n, func) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$c);
  }
  n = toInteger$2(n);
  return function() {
    if (--n < 1) {
      return func.apply(this, arguments);
    }
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity$2(value) {
  return value;
}

/** `Object#toString` result references. */
var asyncTag$1 = '[object AsyncFunction]',
    funcTag$4 = '[object Function]',
    genTag$2 = '[object GeneratorFunction]',
    proxyTag$1 = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$3(value) {
  if (!isObject$5(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$7(value);
  return tag == funcTag$4 || tag == genTag$2 || tag == asyncTag$1 || tag == proxyTag$1;
}

/** Used to detect overreaching core-js shims. */
var coreJsData$2 = root$9['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = (function() {
  var uid = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$2(func) {
  return !!maskSrcKey$1 && (maskSrcKey$1 in func);
}

/** Used for built-in method references. */
var funcProto$4 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$4 = funcProto$4.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$3(func) {
  if (func != null) {
    try {
      return funcToString$4.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$2 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$3 = Function.prototype,
    objectProto$C = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$3 = funcProto$3.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$w = objectProto$C.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' +
  funcToString$3.call(hasOwnProperty$w).replace(reRegExpChar$2, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$2(value) {
  if (!isObject$5(value) || isMasked$2(value)) {
    return false;
  }
  var pattern = isFunction$3(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$3(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$2(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue$2(object, key);
  return baseIsNative$2(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative$7(root$9, 'WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap$2 && new WeakMap$2;

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity$2 : function(func, data) {
  metaMap.set(func, data);
  return func;
};

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$5(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject$5(result) ? result : thisBinding;
  };
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$8 = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG$8,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root$9 && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$h = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax$h(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$g = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax$g(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$6 = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH$6;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

/** Used to lookup unminified function names. */
var realNames = {};

/** Used for built-in method references. */
var objectProto$B = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$v = objectProto$B.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty$v.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

/** Used for built-in method references. */
var objectProto$A = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$u = objectProto$A.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash$1(value) {
  if (isObjectLike$7(value) && !isArray$b(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty$u.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash$1.prototype = baseLodash.prototype;
lodash$1.prototype.constructor = lodash$1;

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash$1[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var defineProperty = (function() {
  try {
    var func = getNative$7(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity$2 : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex$2(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN$2(value) {
  return value !== value;
}

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf$2(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$2(array, value, fromIndex) {
  return value === value
    ? strictIndexOf$2(array, value, fromIndex)
    : baseFindIndex$2(array, baseIsNaN$2, fromIndex);
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf$2(array, value, 0) > -1;
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$7 = 1,
    WRAP_BIND_KEY_FLAG$6 = 2,
    WRAP_CURRY_FLAG$6 = 8,
    WRAP_CURRY_RIGHT_FLAG$3 = 16,
    WRAP_PARTIAL_FLAG$6 = 32,
    WRAP_PARTIAL_RIGHT_FLAG$3 = 64,
    WRAP_ARY_FLAG$4 = 128,
    WRAP_REARG_FLAG$3 = 256,
    WRAP_FLIP_FLAG$2 = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG$4],
  ['bind', WRAP_BIND_FLAG$7],
  ['bindKey', WRAP_BIND_KEY_FLAG$6],
  ['curry', WRAP_CURRY_FLAG$6],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG$3],
  ['flip', WRAP_FLIP_FLAG$2],
  ['partial', WRAP_PARTIAL_FLAG$6],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG$3],
  ['rearg', WRAP_REARG_FLAG$3]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$6 = 1,
    WRAP_BIND_KEY_FLAG$5 = 2,
    WRAP_CURRY_BOUND_FLAG$1 = 4,
    WRAP_CURRY_FLAG$5 = 8,
    WRAP_PARTIAL_FLAG$5 = 32,
    WRAP_PARTIAL_RIGHT_FLAG$2 = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG$5,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG$5 : WRAP_PARTIAL_RIGHT_FLAG$2);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG$2 : WRAP_PARTIAL_FLAG$5);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG$1)) {
    bitmask &= ~(WRAP_BIND_FLAG$6 | WRAP_BIND_KEY_FLAG$5);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$7 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$7 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint$1.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$e = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin$e(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex$3(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/** Used as the internal argument placeholder. */
var PLACEHOLDER$1 = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER$1) {
      array[index] = PLACEHOLDER$1;
      result[resIndex++] = index;
    }
  }
  return result;
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$5 = 1,
    WRAP_BIND_KEY_FLAG$4 = 2,
    WRAP_CURRY_FLAG$4 = 8,
    WRAP_CURRY_RIGHT_FLAG$2 = 16,
    WRAP_ARY_FLAG$3 = 128,
    WRAP_FLIP_FLAG$1 = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG$3,
      isBind = bitmask & WRAP_BIND_FLAG$5,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG$4,
      isCurried = bitmask & (WRAP_CURRY_FLAG$4 | WRAP_CURRY_RIGHT_FLAG$2),
      isFlip = bitmask & WRAP_FLIP_FLAG$1,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root$9 && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root$9 && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$4 = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG$4,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root$9 && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$3 = 1,
    WRAP_BIND_KEY_FLAG$3 = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG$3 = 8,
    WRAP_ARY_FLAG$2 = 128,
    WRAP_REARG_FLAG$2 = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$d = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG$3 | WRAP_BIND_KEY_FLAG$3 | WRAP_ARY_FLAG$2);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG$2) && (bitmask == WRAP_CURRY_FLAG$3)) ||
    ((srcBitmask == WRAP_ARY_FLAG$2) && (bitmask == WRAP_REARG_FLAG$2) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG$2 | WRAP_REARG_FLAG$2)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG$3));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG$3) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG$3 ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG$2) {
    data[8] = data[8] == null ? source[8] : nativeMin$d(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$b = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$2 = 1,
    WRAP_BIND_KEY_FLAG$2 = 2,
    WRAP_CURRY_FLAG$2 = 8,
    WRAP_CURRY_RIGHT_FLAG$1 = 16,
    WRAP_PARTIAL_FLAG$4 = 32,
    WRAP_PARTIAL_RIGHT_FLAG$1 = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$f = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG$2;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$b);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG$4 | WRAP_PARTIAL_RIGHT_FLAG$1);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax$f(toInteger$2(ary), 0);
  arity = arity === undefined ? arity : toInteger$2(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG$1) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax$f(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG$2 | WRAP_CURRY_RIGHT_FLAG$1)) {
    bitmask &= ~(WRAP_CURRY_FLAG$2 | WRAP_CURRY_RIGHT_FLAG$1);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG$2) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG$2 || bitmask == WRAP_CURRY_RIGHT_FLAG$1) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG$4 || bitmask == (WRAP_BIND_FLAG$2 | WRAP_PARTIAL_FLAG$4)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG$1 = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG$1, undefined, undefined, undefined, undefined, n);
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$3(value, other) {
  return value === other || (value !== value && other !== other);
}

/** Used for built-in method references. */
var objectProto$z = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$t = objectProto$z.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$t.call(object, key) && eq$3(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$e = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$e(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$e(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity$2), func + '');
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$6 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$4(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$6;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$4(value) {
  return value != null && isLength$4(value.length) && !isFunction$3(value);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject$5(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike$4(object) && isIndex$3(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq$3(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/** Used for built-in method references. */
var objectProto$y = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$2(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$y;

  return value === proto;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes$2(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag$6 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$2(value) {
  return isObjectLike$7(value) && baseGetTag$7(value) == argsTag$6;
}

/** Used for built-in method references. */
var objectProto$x = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$s = objectProto$x.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$3 = objectProto$x.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$3 = baseIsArguments$2(function() { return arguments; }()) ? baseIsArguments$2 : function(value) {
  return isObjectLike$7(value) && hasOwnProperty$s.call(value, 'callee') &&
    !propertyIsEnumerable$3.call(value, 'callee');
};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse$1() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1 = moduleExports$2 ? root$9.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer$3 = nativeIsBuffer || stubFalse$1;

/** `Object#toString` result references. */
var argsTag$5 = '[object Arguments]',
    arrayTag$4 = '[object Array]',
    boolTag$6 = '[object Boolean]',
    dateTag$6 = '[object Date]',
    errorTag$5 = '[object Error]',
    funcTag$3 = '[object Function]',
    mapTag$c = '[object Map]',
    numberTag$6 = '[object Number]',
    objectTag$7 = '[object Object]',
    regexpTag$6 = '[object RegExp]',
    setTag$c = '[object Set]',
    stringTag$7 = '[object String]',
    weakMapTag$5 = '[object WeakMap]';

var arrayBufferTag$6 = '[object ArrayBuffer]',
    dataViewTag$7 = '[object DataView]',
    float32Tag$3 = '[object Float32Array]',
    float64Tag$3 = '[object Float64Array]',
    int8Tag$3 = '[object Int8Array]',
    int16Tag$3 = '[object Int16Array]',
    int32Tag$3 = '[object Int32Array]',
    uint8Tag$3 = '[object Uint8Array]',
    uint8ClampedTag$3 = '[object Uint8ClampedArray]',
    uint16Tag$3 = '[object Uint16Array]',
    uint32Tag$3 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] =
typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] =
typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] =
typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] =
typedArrayTags$1[uint32Tag$3] = true;
typedArrayTags$1[argsTag$5] = typedArrayTags$1[arrayTag$4] =
typedArrayTags$1[arrayBufferTag$6] = typedArrayTags$1[boolTag$6] =
typedArrayTags$1[dataViewTag$7] = typedArrayTags$1[dateTag$6] =
typedArrayTags$1[errorTag$5] = typedArrayTags$1[funcTag$3] =
typedArrayTags$1[mapTag$c] = typedArrayTags$1[numberTag$6] =
typedArrayTags$1[objectTag$7] = typedArrayTags$1[regexpTag$6] =
typedArrayTags$1[setTag$c] = typedArrayTags$1[stringTag$7] =
typedArrayTags$1[weakMapTag$5] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$2(value) {
  return isObjectLike$7(value) &&
    isLength$4(value.length) && !!typedArrayTags$1[baseGetTag$7(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary$2(func) {
  return function(value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal$2.process;

/** Used to access faster Node.js helpers. */
var nodeUtil$1 = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray$1 = nodeUtil$1 && nodeUtil$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$3 = nodeIsTypedArray$1 ? baseUnary$2(nodeIsTypedArray$1) : baseIsTypedArray$2;

/** Used for built-in method references. */
var objectProto$w = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$r = objectProto$w.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$b(value),
      isArg = !isArr && isArguments$3(value),
      isBuff = !isArr && !isArg && isBuffer$3(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$3(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes$2(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$r.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$3(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$2 = overArg$2(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$v = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$q = objectProto$v.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$2(object) {
  if (!isPrototype$2(object)) {
    return nativeKeys$2(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$q.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$5(object) {
  return isArrayLike$4(object) ? arrayLikeKeys$2(object) : baseKeys$2(object);
}

/** Used for built-in method references. */
var objectProto$u = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$p = objectProto$u.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype$2(source) || isArrayLike$4(source)) {
    copyObject(source, keys$5(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty$p.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$t = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$o = objectProto$t.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject$5(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$2(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$o.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike$4(object) ? arrayLikeKeys$2(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = createAssigner(function(object, source) {
  copyObject(source, keysIn(source), object);
});

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/**
 * This method is like `_.assign` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignInWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keys$5(source), object, customizer);
});

/** Used to match property names within property paths. */
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp$1 = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$4(value, object) {
  if (isArray$b(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$5(value)) {
    return true;
  }
  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) ||
    (object != null && value in Object(object));
}

/* Built-in method references that are verified to be native. */
var nativeCreate$5 = getNative$7(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$2() {
  this.__data__ = nativeCreate$5 ? nativeCreate$5(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete$2(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$5 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$s = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$n = objectProto$s.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$2(key) {
  var data = this.__data__;
  if (nativeCreate$5) {
    var result = data[key];
    return result === HASH_UNDEFINED$5 ? undefined : result;
  }
  return hasOwnProperty$n.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$r = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$m = objectProto$r.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$2(key) {
  var data = this.__data__;
  return nativeCreate$5 ? (data[key] !== undefined) : hasOwnProperty$m.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$4 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$2(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate$5 && value === undefined) ? HASH_UNDEFINED$4 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$2(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$2.prototype.clear = hashClear$2;
Hash$2.prototype['delete'] = hashDelete$2;
Hash$2.prototype.get = hashGet$2;
Hash$2.prototype.has = hashHas$2;
Hash$2.prototype.set = hashSet$2;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear$2() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$5(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$3(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto$6 = Array.prototype;

/** Built-in value references. */
var splice$3 = arrayProto$6.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$2(key) {
  var data = this.__data__,
      index = assocIndexOf$5(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$3.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$2(key) {
  var data = this.__data__,
      index = assocIndexOf$5(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$2(key) {
  return assocIndexOf$5(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$2(key, value) {
  var data = this.__data__,
      index = assocIndexOf$5(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$5(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$5.prototype.clear = listCacheClear$2;
ListCache$5.prototype['delete'] = listCacheDelete$2;
ListCache$5.prototype.get = listCacheGet$2;
ListCache$5.prototype.has = listCacheHas$2;
ListCache$5.prototype.set = listCacheSet$2;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$7(root$9, 'Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$2() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$2,
    'map': new (Map$4 || ListCache$5),
    'string': new Hash$2
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable$2(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$5(map, key) {
  var data = map.__data__;
  return isKeyable$2(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$2(key) {
  var result = getMapData$5(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$2(key) {
  return getMapData$5(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$2(key) {
  return getMapData$5(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$2(key, value) {
  var data = getMapData$5(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$4.prototype.clear = mapCacheClear$2;
MapCache$4.prototype['delete'] = mapCacheDelete$2;
MapCache$4.prototype.get = mapCacheGet$2;
MapCache$4.prototype.has = mapCacheHas$2;
MapCache$4.prototype.set = mapCacheSet$2;

/** Error message constants. */
var FUNC_ERROR_TEXT$a = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$2(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$a);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache$4);
  return memoized;
}

// Expose `MapCache`.
memoize$2.Cache = MapCache$4;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE$1 = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$2(func) {
  var result = memoize$2(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE$1) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoizeCapped$2(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString$2(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$3(value, object) {
  if (isArray$b(value)) {
    return value;
  }
  return isKey$4(value, object) ? [value] : stringToPath$2(toString$2(value));
}

/** Used as references for various `Number` constants. */
var INFINITY$6 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$5(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$6) ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$3(object, path) {
  path = castPath$3(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$5(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$2(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$3(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * The base implementation of `_.at` without support for individual paths.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {string[]} paths The property paths to pick.
 * @returns {Array} Returns the picked elements.
 */
function baseAt(object, paths) {
  var index = -1,
      length = paths.length,
      result = Array(length),
      skip = object == null;

  while (++index < length) {
    result[index] = skip ? undefined : get$2(object, paths[index]);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush$2(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Built-in value references. */
var spreadableSymbol = Symbol$6 ? Symbol$6.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray$b(value) || isArguments$3(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$2(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

/**
 * Creates an array of values corresponding to `paths` of `object`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Array} Returns the picked values.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _.at(object, ['a[0].b.c', 'a[1]']);
 * // => [3, 4]
 */
var at = flatRest(baseAt);

/** Built-in value references. */
var getPrototype = overArg$2(Object.getPrototypeOf, Object);

/** `Object#toString` result references. */
var objectTag$6 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$q = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$l = objectProto$q.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike$7(value) || baseGetTag$7(value) != objectTag$6) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$l.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag$4 = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike$7(value)) {
    return false;
  }
  var tag = baseGetTag$7(value);
  return tag == errorTag$4 || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function(func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

/** Error message constants. */
var FUNC_ERROR_TEXT$9 = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$9);
  }
  n = toInteger$2(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG$1 = 1,
    WRAP_PARTIAL_FLAG$3 = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG$1;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG$3;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

/**
 * Binds methods of an object to the object itself, overwriting the existing
 * method.
 *
 * **Note:** This method doesn't set the "length" property of bound functions.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Object} object The object to bind and assign the bound methods to.
 * @param {...(string|string[])} methodNames The object method names to bind.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var view = {
 *   'label': 'docs',
 *   'click': function() {
 *     console.log('clicked ' + this.label);
 *   }
 * };
 *
 * _.bindAll(view, ['click']);
 * jQuery(element).on('click', view.click);
 * // => Logs 'clicked docs' when clicked.
 */
var bindAll = flatRest(function(object, methodNames) {
  arrayEach(methodNames, function(key) {
    key = toKey$5(key);
    baseAssignValue(object, key, bind(object[key], object));
  });
  return object;
});

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG$1 = 2,
    WRAP_PARTIAL_FLAG$2 = 32;

/**
 * Creates a function that invokes the method at `object[key]` with `partials`
 * prepended to the arguments it receives.
 *
 * This method differs from `_.bind` by allowing bound functions to reference
 * methods that may be redefined or don't yet exist. See
 * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
 * for more details.
 *
 * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Function
 * @param {Object} object The object to invoke the method on.
 * @param {string} key The key of the method.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * var object = {
 *   'user': 'fred',
 *   'greet': function(greeting, punctuation) {
 *     return greeting + ' ' + this.user + punctuation;
 *   }
 * };
 *
 * var bound = _.bindKey(object, 'greet', 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * object.greet = function(greeting, punctuation) {
 *   return greeting + 'ya ' + this.user + punctuation;
 * };
 *
 * bound('!');
 * // => 'hiya fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bindKey(object, 'greet', _, '!');
 * bound('hi');
 * // => 'hiya fred!'
 */
var bindKey = baseRest(function(object, key, partials) {
  var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG$1;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bindKey));
    bitmask |= WRAP_PARTIAL_FLAG$2;
  }
  return createWrap(key, bitmask, object, partials, holders);
});

// Assign default placeholders.
bindKey.placeholder = {};

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/** Used to compose unicode character classes. */
var rsAstralRange$3 = '\\ud800-\\udfff',
    rsComboMarksRange$4 = '\\u0300-\\u036f',
    reComboHalfMarksRange$4 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$4 = '\\u20d0-\\u20ff',
    rsComboRange$4 = rsComboMarksRange$4 + reComboHalfMarksRange$4 + rsComboSymbolsRange$4,
    rsVarRange$3 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$3 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$3 + rsAstralRange$3  + rsComboRange$4 + rsVarRange$3 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/** Used to compose unicode character classes. */
var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$3 = '\\u0300-\\u036f',
    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3,
    rsVarRange$2 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral$1 = '[' + rsAstralRange$2 + ']',
    rsCombo$3 = '[' + rsComboRange$3 + ']',
    rsFitz$2 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$2 = '(?:' + rsCombo$3 + '|' + rsFitz$2 + ')',
    rsNonAstral$2 = '[^' + rsAstralRange$2 + ']',
    rsRegional$2 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$2 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod$2 = rsModifier$2 + '?',
    rsOptVar$2 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$2 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$2, rsRegional$2, rsSurrPair$2].join('|') + ')' + rsOptVar$2 + reOptMod$2 + ')*',
    rsSeq$2 = rsOptVar$2 + reOptMod$2 + rsOptJoin$2,
    rsSymbol$1 = '(?:' + [rsNonAstral$2 + rsCombo$3 + '?', rsCombo$3, rsRegional$2, rsSurrPair$2, rsAstral$1].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode$1 = RegExp(rsFitz$2 + '(?=' + rsFitz$2 + ')|' + rsSymbol$1 + rsSeq$2, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode$1) || [];
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString$2(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString$2(string).toLowerCase());
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2;

/** Used to compose unicode capture groups. */
var rsCombo$2 = '[' + rsComboRange$2 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$2, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString$2(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/** Used to compose unicode character classes. */
var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$1 = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboRange$1 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$1 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$1 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$1 = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$1 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString$2(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray$b(value) ? value : [value];
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite$1 = root$9.isFinite,
    nativeMin$c = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber$2(number);
    precision = precision == null ? 0 : nativeMin$c(toInteger$2(precision), 292);
    if (precision && nativeIsFinite$1(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString$2(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString$2(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

/**
 * Computes `number` rounded up to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round up.
 * @param {number} [precision=0] The precision to round up to.
 * @returns {number} Returns the rounded up number.
 * @example
 *
 * _.ceil(4.006);
 * // => 5
 *
 * _.ceil(6.004, 2);
 * // => 6.01
 *
 * _.ceil(6040, -2);
 * // => 6100
 */
var ceil = createRound('ceil');

/**
 * Creates a `lodash` wrapper instance that wraps `value` with explicit method
 * chain sequences enabled. The result of such sequences must be unwrapped
 * with `_#value`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Seq
 * @param {*} value The value to wrap.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36 },
 *   { 'user': 'fred',    'age': 40 },
 *   { 'user': 'pebbles', 'age': 1 }
 * ];
 *
 * var youngest = _
 *   .chain(users)
 *   .sortBy('age')
 *   .map(function(o) {
 *     return o.user + ' is ' + o.age;
 *   })
 *   .head()
 *   .value();
 * // => 'pebbles is 1'
 */
function chain(value) {
  var result = lodash$1(value);
  result.__chain__ = true;
  return result;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil$3 = Math.ceil,
    nativeMax$d = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax$d(toInteger$2(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil$3(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber$2(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber$2(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber$2(number), lower, upper);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$2() {
  this.__data__ = new ListCache$5;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete$2(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet$2(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas$2(key) {
  return this.__data__.has(key);
}

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$3 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$2(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$5) {
    var pairs = data.__data__;
    if (!Map$4 || (pairs.length < LARGE_ARRAY_SIZE$3 - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$4(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$3(entries) {
  var data = this.__data__ = new ListCache$5(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$3.prototype.clear = stackClear$2;
Stack$3.prototype['delete'] = stackDelete$2;
Stack$3.prototype.get = stackGet$2;
Stack$3.prototype.has = stackHas$2;
Stack$3.prototype.set = stackSet$2;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys$5(source), object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root$9.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter$3(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray$2() {
  return [];
}

/** Used for built-in method references. */
var objectProto$p = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$2 = objectProto$p.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$2 = !nativeGetSymbols$2 ? stubArray$2 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$3(nativeGetSymbols$2(object), function(symbol) {
    return propertyIsEnumerable$2.call(object, symbol);
  });
};

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols$2(source), object);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray$2 : function(object) {
  var result = [];
  while (object) {
    arrayPush$2(result, getSymbols$2(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$b(object) ? result : arrayPush$2(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$2(object, keys$5, getSymbols$2);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys$2(object, keysIn, getSymbolsIn);
}

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$7(root$9, 'DataView');

/* Built-in method references that are verified to be native. */
var Promise$3 = getNative$7(root$9, 'Promise');

/* Built-in method references that are verified to be native. */
var Set$2 = getNative$7(root$9, 'Set');

/** `Object#toString` result references. */
var mapTag$b = '[object Map]',
    objectTag$5 = '[object Object]',
    promiseTag$1 = '[object Promise]',
    setTag$b = '[object Set]',
    weakMapTag$4 = '[object WeakMap]';

var dataViewTag$6 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString$1 = toSource$3(DataView$2),
    mapCtorString$1 = toSource$3(Map$4),
    promiseCtorString$1 = toSource$3(Promise$3),
    setCtorString$1 = toSource$3(Set$2),
    weakMapCtorString$1 = toSource$3(WeakMap$2);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$2 = baseGetTag$7;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$2 && getTag$2(new DataView$2(new ArrayBuffer(1))) != dataViewTag$6) ||
    (Map$4 && getTag$2(new Map$4) != mapTag$b) ||
    (Promise$3 && getTag$2(Promise$3.resolve()) != promiseTag$1) ||
    (Set$2 && getTag$2(new Set$2) != setTag$b) ||
    (WeakMap$2 && getTag$2(new WeakMap$2) != weakMapTag$4)) {
  getTag$2 = function(value) {
    var result = baseGetTag$7(value),
        Ctor = result == objectTag$5 ? value.constructor : undefined,
        ctorString = Ctor ? toSource$3(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1: return dataViewTag$6;
        case mapCtorString$1: return mapTag$b;
        case promiseCtorString$1: return promiseTag$1;
        case setCtorString$1: return setTag$b;
        case weakMapCtorString$1: return weakMapTag$4;
      }
    }
    return result;
  };
}

var getTag$3 = getTag$2;

/** Used for built-in method references. */
var objectProto$o = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$k = objectProto$o.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$k.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/** Built-in value references. */
var Uint8Array$2 = root$9.Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags$1 = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags$1.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$3 = Symbol$6 ? Symbol$6.prototype : undefined,
    symbolValueOf$2 = symbolProto$3 ? symbolProto$3.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf$2 ? Object(symbolValueOf$2.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$5 = '[object Boolean]',
    dateTag$5 = '[object Date]',
    mapTag$a = '[object Map]',
    numberTag$5 = '[object Number]',
    regexpTag$5 = '[object RegExp]',
    setTag$a = '[object Set]',
    stringTag$6 = '[object String]',
    symbolTag$4 = '[object Symbol]';

var arrayBufferTag$5 = '[object ArrayBuffer]',
    dataViewTag$5 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$5:
      return cloneArrayBuffer(object);

    case boolTag$5:
    case dateTag$5:
      return new Ctor(+object);

    case dataViewTag$5:
      return cloneDataView(object, isDeep);

    case float32Tag$2: case float64Tag$2:
    case int8Tag$2: case int16Tag$2: case int32Tag$2:
    case uint8Tag$2: case uint8ClampedTag$2: case uint16Tag$2: case uint32Tag$2:
      return cloneTypedArray(object, isDeep);

    case mapTag$a:
      return new Ctor;

    case numberTag$5:
    case stringTag$6:
      return new Ctor(object);

    case regexpTag$5:
      return cloneRegExp(object);

    case setTag$a:
      return new Ctor;

    case symbolTag$4:
      return cloneSymbol(object);
  }
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype$2(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/** `Object#toString` result references. */
var mapTag$9 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike$7(value) && getTag$3(value) == mapTag$9;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap;

/** `Object#toString` result references. */
var setTag$9 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike$7(value) && getTag$3(value) == setTag$9;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary$2(nodeIsSet) : baseIsSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$7 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$5 = 4;

/** `Object#toString` result references. */
var argsTag$4 = '[object Arguments]',
    arrayTag$3 = '[object Array]',
    boolTag$4 = '[object Boolean]',
    dateTag$4 = '[object Date]',
    errorTag$3 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$8 = '[object Map]',
    numberTag$4 = '[object Number]',
    objectTag$4 = '[object Object]',
    regexpTag$4 = '[object RegExp]',
    setTag$8 = '[object Set]',
    stringTag$5 = '[object String]',
    symbolTag$3 = '[object Symbol]',
    weakMapTag$3 = '[object WeakMap]';

var arrayBufferTag$4 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$4] = cloneableTags[arrayTag$3] =
cloneableTags[arrayBufferTag$4] = cloneableTags[dataViewTag$4] =
cloneableTags[boolTag$4] = cloneableTags[dateTag$4] =
cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] =
cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] =
cloneableTags[int32Tag$1] = cloneableTags[mapTag$8] =
cloneableTags[numberTag$4] = cloneableTags[objectTag$4] =
cloneableTags[regexpTag$4] = cloneableTags[setTag$8] =
cloneableTags[stringTag$5] = cloneableTags[symbolTag$3] =
cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] =
cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = true;
cloneableTags[errorTag$3] = cloneableTags[funcTag$2] =
cloneableTags[weakMapTag$3] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$7,
      isFlat = bitmask & CLONE_FLAT_FLAG$1,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$5;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$5(value)) {
    return value;
  }
  var isArr = isArray$b(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$3(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer$3(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$4 || tag == argsTag$4 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack$3);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys$2)
    : (isFlat ? keysIn : keys$5);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG$4 = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG$4);
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$6 = 1,
    CLONE_SYMBOLS_FLAG$3 = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG$6 | CLONE_SYMBOLS_FLAG$3);
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$5 = 1,
    CLONE_SYMBOLS_FLAG$2 = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG$5 | CLONE_SYMBOLS_FLAG$2, customizer);
}

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * This method is like `_.clone` except that it accepts `customizer` which
 * is invoked to produce the cloned value. If `customizer` returns `undefined`,
 * cloning is handled by the method instead. The `customizer` is invoked with
 * up to four arguments; (value [, index|key, object, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeepWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(false);
 *   }
 * }
 *
 * var el = _.cloneWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 0
 */
function cloneWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_SYMBOLS_FLAG$1, customizer);
}

/**
 * Executes the chain sequence and returns the wrapped result.
 *
 * @name commit
 * @memberOf _
 * @since 3.2.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var array = [1, 2];
 * var wrapped = _(array).push(3);
 *
 * console.log(array);
 * // => [1, 2]
 *
 * wrapped = wrapped.commit();
 * console.log(array);
 * // => [1, 2, 3]
 *
 * wrapped.last();
 * // => 3
 *
 * console.log(array);
 * // => [1, 2, 3]
 */
function wrapperCommit() {
  return new LodashWrapper(this.value(), this.__chain__);
}

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return arrayPush$2(isArray$b(array) ? copyArray(array) : [array], baseFlatten(args, 1));
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$2(value) {
  this.__data__.set(value, HASH_UNDEFINED$3);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas$2(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$2(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$4;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd$2;
SetCache$2.prototype.has = setCacheHas$2;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas$2(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$b = 1,
    COMPARE_UNORDERED_FLAG$7 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$3(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$b,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$7) ? new SetCache$2 : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome$2(other, function(othValue, othIndex) {
            if (!cacheHas$2(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray$2(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray$2(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$a = 1,
    COMPARE_UNORDERED_FLAG$6 = 2;

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    mapTag$7 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$7 = '[object Set]',
    stringTag$4 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$6 ? Symbol$6.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$2(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$3:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$3:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;

    case boolTag$3:
    case dateTag$3:
    case numberTag$3:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$3(+object, +other);

    case errorTag$2:
      return object.name == other.name && object.message == other.message;

    case regexpTag$3:
    case stringTag$4:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$7:
      var convert = mapToArray$2;

    case setTag$7:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$a;
      convert || (convert = setToArray$2);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$6;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$3(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$2:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$9 = 1;

/** Used for built-in method references. */
var objectProto$n = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$j = objectProto$n.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$2(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$9,
      objProps = getAllKeys$2(object),
      objLength = objProps.length,
      othProps = getAllKeys$2(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$j.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$8 = 1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var objectProto$m = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$i = objectProto$m.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$2(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$b(object),
      othIsArr = isArray$b(other),
      objTag = objIsArr ? arrayTag$2 : getTag$3(object),
      othTag = othIsArr ? arrayTag$2 : getTag$3(other);

  objTag = objTag == argsTag$3 ? objectTag$3 : objTag;
  othTag = othTag == argsTag$3 ? objectTag$3 : othTag;

  var objIsObj = objTag == objectTag$3,
      othIsObj = othTag == objectTag$3,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$3(object)) {
    if (!isBuffer$3(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$3);
    return (objIsArr || isTypedArray$3(object))
      ? equalArrays$3(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag$2(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$8)) {
    var objIsWrapped = objIsObj && hasOwnProperty$i.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$i.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$3);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$3);
  return equalObjects$2(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$7(value) && !isObjectLike$7(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep$2(value, other, bitmask, customizer, baseIsEqual$3, stack);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$7 = 1,
    COMPARE_UNORDERED_FLAG$5 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$2(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$3;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$3(srcValue, objValue, COMPARE_PARTIAL_FLAG$7 | COMPARE_UNORDERED_FLAG$5, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$3(value) {
  return value === value && !isObject$5(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$2(object) {
  var result = keys$5(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$3(value)];
  }
  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable$3(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$2(source) {
  var matchData = getMatchData$2(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$3(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch$2(object, source, matchData);
  };
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn$2(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$2(object, path, hasFunc) {
  path = castPath$3(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$5(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$4(length) && isIndex$3(key, length) &&
    (isArray$b(object) || isArguments$3(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$2(object, path) {
  return object != null && hasPath$2(object, path, baseHasIn$2);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$6 = 1,
    COMPARE_UNORDERED_FLAG$4 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$2(path, srcValue) {
  if (isKey$4(path) && isStrictComparable$3(srcValue)) {
    return matchesStrictComparable$3(toKey$5(path), srcValue);
  }
  return function(object) {
    var objValue = get$2(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn$2(object, path)
      : baseIsEqual$3(srcValue, objValue, COMPARE_PARTIAL_FLAG$6 | COMPARE_UNORDERED_FLAG$4);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty$2(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$2(path) {
  return function(object) {
    return baseGet$3(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$2(path) {
  return isKey$4(path) ? baseProperty$2(toKey$5(path)) : basePropertyDeep$2(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$2(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$2;
  }
  if (typeof value == 'object') {
    return isArray$b(value)
      ? baseMatchesProperty$2(value[0], value[1])
      : baseMatches$2(value);
  }
  return property$2(value);
}

/** Error message constants. */
var FUNC_ERROR_TEXT$8 = 'Expected a function';

/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */
function cond(pairs) {
  var length = pairs == null ? 0 : pairs.length,
      toIteratee = baseIteratee$2;

  pairs = !length ? [] : arrayMap$3(pairs, function(pair) {
    if (typeof pair[1] != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT$8);
    }
    return [toIteratee(pair[0]), pair[1]];
  });

  return baseRest(function(args) {
    var index = -1;
    while (++index < length) {
      var pair = pairs[index];
      if (apply(pair[0], this, args)) {
        return apply(pair[1], this, args);
      }
    }
  });
}

/**
 * The base implementation of `_.conformsTo` which accepts `props` to check.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 */
function baseConformsTo(object, source, props) {
  var length = props.length;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (length--) {
    var key = props[length],
        predicate = source[key],
        value = object[key];

    if ((value === undefined && !(key in object)) || !predicate(value)) {
      return false;
    }
  }
  return true;
}

/**
 * The base implementation of `_.conforms` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 */
function baseConforms(source) {
  var props = keys$5(source);
  return function(object) {
    return baseConformsTo(object, source, props);
  };
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$4 = 1;

/**
 * Creates a function that invokes the predicate properties of `source` with
 * the corresponding property values of a given object, returning `true` if
 * all predicates return truthy, else `false`.
 *
 * **Note:** The created function is equivalent to `_.conformsTo` with
 * `source` partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 2, 'b': 1 },
 *   { 'a': 1, 'b': 2 }
 * ];
 *
 * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
 * // => [{ 'a': 1, 'b': 2 }]
 */
function conforms(source) {
  return baseConforms(baseClone(source, CLONE_DEEP_FLAG$4));
}

/**
 * Checks if `object` conforms to `source` by invoking the predicate
 * properties of `source` with the corresponding property values of `object`.
 *
 * **Note:** This method is equivalent to `_.conforms` when `source` is
 * partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
 * // => true
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
 * // => false
 */
function conformsTo(object, source) {
  return source == null || baseConformsTo(object, source, keys$5(source));
}

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor$2(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$2 = createBaseFor$2();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$2(object, iteratee) {
  return object && baseFor$2(object, iteratee, keys$5);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$2(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$4(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$2 = createBaseEach$2(baseForOwn$2);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach$2(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray$b(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee$2(iteratee), accumulator);
  };
}

/** Used for built-in method references. */
var objectProto$l = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$h = objectProto$l.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */
var countBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty$h.call(result, key)) {
    ++result[key];
  } else {
    baseAssignValue(result, key, 1);
  }
});

/**
 * Creates an object that inherits from the `prototype` object. If a
 * `properties` object is given, its own enumerable string keyed properties
 * are assigned to the created object.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Object
 * @param {Object} prototype The object to inherit from.
 * @param {Object} [properties] The properties to assign to the object.
 * @returns {Object} Returns the new object.
 * @example
 *
 * function Shape() {
 *   this.x = 0;
 *   this.y = 0;
 * }
 *
 * function Circle() {
 *   Shape.call(this);
 * }
 *
 * Circle.prototype = _.create(Shape.prototype, {
 *   'constructor': Circle
 * });
 *
 * var circle = new Circle;
 * circle instanceof Circle;
 * // => true
 *
 * circle instanceof Shape;
 * // => true
 */
function create(prototype, properties) {
  var result = baseCreate(prototype);
  return properties == null ? result : baseAssign(result, properties);
}

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG$1 = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG$1, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_RIGHT_FLAG = 16;

/**
 * This method is like `_.curry` except that arguments are applied to `func`
 * in the manner of `_.partialRight` instead of `_.partial`.
 *
 * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curryRight(abc);
 *
 * curried(3)(2)(1);
 * // => [1, 2, 3]
 *
 * curried(2, 3)(1);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(3)(1, _)(2);
 * // => [1, 2, 3]
 */
function curryRight(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curryRight.placeholder;
  return result;
}

// Assign default placeholders.
curryRight.placeholder = {};

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root$9.Date.now();
};

/** Error message constants. */
var FUNC_ERROR_TEXT$7 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$c = Math.max,
    nativeMin$b = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$7);
  }
  wait = toNumber$2(wait) || 0;
  if (isObject$5(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$c(toNumber$2(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin$b(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks `value` to determine whether a default value should be returned in
 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
 * or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Util
 * @param {*} value The value to check.
 * @param {*} defaultValue The default value.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * _.defaultTo(1, 10);
 * // => 1
 *
 * _.defaultTo(undefined, 10);
 * // => 10
 */
function defaultTo(value, defaultValue) {
  return (value == null || value !== value) ? defaultValue : value;
}

/** Used for built-in method references. */
var objectProto$k = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$g = objectProto$k.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults$2 = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq$3(value, objectProto$k[key]) && !hasOwnProperty$g.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq$3(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike$7(value) && isArrayLike$4(value);
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray$b(srcValue),
        isBuff = !isArr && isBuffer$3(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray$3(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$b(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments$3(srcValue)) {
      newValue = objValue;
      if (isArguments$3(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject$5(objValue) || isFunction$3(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor$2(source, function(srcValue, key) {
    stack || (stack = new Stack$3);
    if (isObject$5(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject$5(objValue) && isObject$5(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

/** Error message constants. */
var FUNC_ERROR_TEXT$6 = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$6);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */
var defer = baseRest(function(func, args) {
  return baseDelay(func, 1, args);
});

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber$2(wait) || 0, args);
});

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$2 = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap$3(values, baseUnary$2(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE$2) {
    includes = cacheHas$2;
    isCommon = false;
    values = new SetCache$2(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var differenceBy = baseRest(function(array, values) {
  var iteratee = last(values);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee$2(iteratee))
    : [];
});

/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = baseRest(function(array, values) {
  var comparator = last(values);
  if (isArrayLikeObject(comparator)) {
    comparator = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
    : [];
});

/**
 * Divide two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} dividend The first number in a division.
 * @param {number} divisor The second number in a division.
 * @returns {number} Returns the quotient.
 * @example
 *
 * _.divide(6, 4);
 * // => 1.5
 */
var divide = createMathOperation(function(dividend, divisor) {
  return dividend / divisor;
}, 1);

/**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function drop(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger$2(n);
  return baseSlice(array, n < 0 ? 0 : n, length);
}

/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger$2(n);
  n = length - n;
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */
function baseWhile(array, predicate, isDrop, fromRight) {
  var length = array.length,
      index = fromRight ? length : -1;

  while ((fromRight ? index-- : ++index < length) &&
    predicate(array[index], index, array)) {}

  return isDrop
    ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
    : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
}

/**
 * Creates a slice of `array` excluding elements dropped from the end.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.dropRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropRightWhile(users, ['active', false]);
 * // => objects for ['barney']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropRightWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropRightWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee$2(predicate), true, true)
    : [];
}

/**
 * Creates a slice of `array` excluding elements dropped from the beginning.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.dropWhile(users, function(o) { return !o.active; });
 * // => objects for ['pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropWhile(users, ['active', false]);
 * // => objects for ['pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee$2(predicate), true)
    : [];
}

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity$2;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray$b(collection) ? arrayEach : baseEach$2;
  return func(collection, castFunction(iteratee));
}

/**
 * A specialized version of `_.forEachRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEachRight(array, iteratee) {
  var length = array == null ? 0 : array.length;

  while (length--) {
    if (iteratee(array[length], length, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor$2(true);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys$5);
}

/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = createBaseEach$2(baseForOwnRight, true);

/**
 * This method is like `_.forEach` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @alias eachRight
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEach
 * @example
 *
 * _.forEachRight([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `2` then `1`.
 */
function forEachRight(collection, iteratee) {
  var func = isArray$b(collection) ? arrayEachRight : baseEachRight;
  return func(collection, castFunction(iteratee));
}

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */
function endsWith(string, target, position) {
  string = toString$2(string);
  target = baseToString$2(target);

  var length = string.length;
  position = position === undefined
    ? length
    : baseClamp(toInteger$2(position), 0, length);

  var end = position;
  position -= target.length;
  return position >= 0 && string.slice(position, end) == target;
}

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap$3(props, function(key) {
    return [key, object[key]];
  });
}

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

/** `Object#toString` result references. */
var mapTag$6 = '[object Map]',
    setTag$6 = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag$3(object);
    if (tag == mapTag$6) {
      return mapToArray$2(object);
    }
    if (tag == setTag$6) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys$5);

/**
 * Creates an array of own and inherited enumerable string keyed-value pairs
 * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
 * or set, its entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entriesIn
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairsIn(new Foo);
 * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
 */
var toPairsIn = createToPairs(keysIn);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString$2(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar$1.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString$2(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar$1, '\\$&')
    : string;
}

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach$2(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray$b(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee$2(predicate));
}

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$5 = 4294967295;

/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */
function toLength(value) {
  return value ? baseClamp(toInteger$2(value), 0, MAX_ARRAY_LENGTH$5) : 0;
}

/**
 * The base implementation of `_.fill` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 */
function baseFill(array, value, start, end) {
  var length = array.length;

  start = toInteger$2(start);
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = (end === undefined || end > length) ? length : toInteger$2(end);
  if (end < 0) {
    end += length;
  }
  end = start > end ? 0 : toLength(end);
  while (start < end) {
    array[start++] = value;
  }
  return array;
}

/**
 * Fills elements of `array` with `value` from `start` up to, but not
 * including, `end`.
 *
 * **Note:** This method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Array
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.fill(array, 'a');
 * console.log(array);
 * // => ['a', 'a', 'a']
 *
 * _.fill(Array(3), 2);
 * // => [2, 2, 2]
 *
 * _.fill([4, 6, 8, 10], '*', 1, 3);
 * // => [4, '*', '*', 10]
 */
function fill(array, value, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
    start = 0;
    end = length;
  }
  return baseFill(array, value, start, end);
}

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter$2(collection, predicate) {
  var result = [];
  baseEach$2(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter$1(collection, predicate) {
  var func = isArray$b(collection) ? arrayFilter$3 : baseFilter$2;
  return func(collection, baseIteratee$2(predicate));
}

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike$4(collection)) {
      var iteratee = baseIteratee$2(predicate);
      collection = keys$5(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$b = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger$2(fromIndex);
  if (index < 0) {
    index = nativeMax$b(length + index, 0);
  }
  return baseFindIndex$2(array, baseIteratee$2(predicate), index);
}

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return baseFindKey(object, baseIteratee$2(predicate), baseForOwn$2);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$a = Math.max,
    nativeMin$a = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger$2(fromIndex);
    index = fromIndex < 0
      ? nativeMax$a(length + index, 0)
      : nativeMin$a(index, length - 1);
  }
  return baseFindIndex$2(array, baseIteratee$2(predicate), index, true);
}

/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = createFind(findLastIndex);

/**
 * This method is like `_.findKey` except that it iterates over elements of
 * a collection in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findLastKey(users, function(o) { return o.age < 40; });
 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastKey(users, { 'age': 36, 'active': true });
 * // => 'barney'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastKey(users, 'active');
 * // => 'pebbles'
 */
function findLastKey(object, predicate) {
  return baseFindKey(object, baseIteratee$2(predicate), baseForOwnRight);
}

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike$4(collection) ? Array(collection.length) : [];

  baseEach$2(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray$b(collection) ? arrayMap$3 : baseMap;
  return func(collection, baseIteratee$2(iteratee));
}

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

/** Used as references for various `Number` constants. */
var INFINITY$5 = 1 / 0;

/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDeep([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMapDeep(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), INFINITY$5);
}

/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDepth([1, 2], duplicate, 2);
 * // => [[1, 1], [2, 2]]
 */
function flatMapDepth(collection, iteratee, depth) {
  depth = depth === undefined ? 1 : toInteger$2(depth);
  return baseFlatten(map(collection, iteratee), depth);
}

/** Used as references for various `Number` constants. */
var INFINITY$4 = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, INFINITY$4) : [];
}

var flattenDeep$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': flattenDeep
});

/**
 * Recursively flatten `array` up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * var array = [1, [2, [3, [4]], 5]];
 *
 * _.flattenDepth(array, 1);
 * // => [1, 2, [3, [4]], 5]
 *
 * _.flattenDepth(array, 2);
 * // => [1, 2, 3, [4], 5]
 */
function flattenDepth(array, depth) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  depth = depth === undefined ? 1 : toInteger$2(depth);
  return baseFlatten(array, depth);
}

/** Used to compose bitmasks for function metadata. */
var WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that invokes `func` with arguments reversed.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to flip arguments for.
 * @returns {Function} Returns the new flipped function.
 * @example
 *
 * var flipped = _.flip(function() {
 *   return _.toArray(arguments);
 * });
 *
 * flipped('a', 'b', 'c', 'd');
 * // => ['d', 'c', 'b', 'a']
 */
function flip(func) {
  return createWrap(func, WRAP_FLIP_FLAG);
}

/**
 * Computes `number` rounded down to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round down.
 * @param {number} [precision=0] The precision to round down to.
 * @returns {number} Returns the rounded down number.
 * @example
 *
 * _.floor(4.006);
 * // => 4
 *
 * _.floor(0.046, 2);
 * // => 0.04
 *
 * _.floor(4060, -2);
 * // => 4000
 */
var floor = createRound('floor');

/** Error message constants. */
var FUNC_ERROR_TEXT$5 = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG$1 = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG$1 = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT$5);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG$1 | WRAP_REARG_FLAG$1) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray$b(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : baseFor$2(object, castFunction(iteratee), keysIn);
}

/**
 * This method is like `_.forIn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forInRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
 */
function forInRight(object, iteratee) {
  return object == null
    ? object
    : baseForRight(object, castFunction(iteratee), keysIn);
}

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn$2(object, castFunction(iteratee));
}

/**
 * This method is like `_.forOwn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwnRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
 */
function forOwnRight(object, iteratee) {
  return object && baseForOwnRight(object, castFunction(iteratee));
}

/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs == null ? 0 : pairs.length,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

/**
 * The base implementation of `_.functions` which creates an array of
 * `object` function property names filtered from `props`.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} props The property names to filter.
 * @returns {Array} Returns the function names.
 */
function baseFunctions(object, props) {
  return arrayFilter$3(props, function(key) {
    return isFunction$3(object[key]);
  });
}

/**
 * Creates an array of function property names from own enumerable properties
 * of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functionsIn
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functions(new Foo);
 * // => ['a', 'b']
 */
function functions(object) {
  return object == null ? [] : baseFunctions(object, keys$5(object));
}

/**
 * Creates an array of function property names from own and inherited
 * enumerable properties of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functions
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functionsIn(new Foo);
 * // => ['a', 'b', 'c']
 */
function functionsIn(object) {
  return object == null ? [] : baseFunctions(object, keysIn(object));
}

/** Used for built-in method references. */
var objectProto$j = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$j.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty$f.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

/**
 * Creates a function that performs a relational operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @returns {Function} Returns the new relational operation function.
 */
function createRelationalOperation(operator) {
  return function(value, other) {
    if (!(typeof value == 'string' && typeof other == 'string')) {
      value = toNumber$2(value);
      other = toNumber$2(other);
    }
    return operator(value, other);
  };
}

/**
 * Checks if `value` is greater than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 * @see _.lt
 * @example
 *
 * _.gt(3, 1);
 * // => true
 *
 * _.gt(3, 3);
 * // => false
 *
 * _.gt(1, 3);
 * // => false
 */
var gt = createRelationalOperation(baseGt);

/**
 * Checks if `value` is greater than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than or equal to
 *  `other`, else `false`.
 * @see _.lte
 * @example
 *
 * _.gte(3, 1);
 * // => true
 *
 * _.gte(3, 3);
 * // => true
 *
 * _.gte(1, 3);
 * // => false
 */
var gte = createRelationalOperation(function(value, other) {
  return value >= other;
});

/** Used for built-in method references. */
var objectProto$i = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$i.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty$e.call(object, key);
}

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath$2(object, path, baseHas);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$9 = Math.max,
    nativeMin$9 = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= nativeMin$9(start, end) && number < nativeMax$9(start, end);
}

/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange$1(number, start, end) {
  start = toFinite$2(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = toFinite$2(end);
  }
  number = toNumber$2(number);
  return baseInRange(number, start, end);
}

/** `Object#toString` result references. */
var stringTag$3 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString$2(value) {
  return typeof value == 'string' ||
    (!isArray$b(value) && isObjectLike$7(value) && baseGetTag$7(value) == stringTag$3);
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues$2(object, props) {
  return arrayMap$3(props, function(key) {
    return object[key];
  });
}

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values$2(object) {
  return object == null ? [] : baseValues$2(object, keys$5(object));
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$8 = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes$1(collection, value, fromIndex, guard) {
  collection = isArrayLike$4(collection) ? collection : values$2(collection);
  fromIndex = (fromIndex && !guard) ? toInteger$2(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax$8(length + fromIndex, 0);
  }
  return isString$2(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf$2(collection, value, fromIndex) > -1);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$7 = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger$2(fromIndex);
  if (index < 0) {
    index = nativeMax$7(length + index, 0);
  }
  return baseIndexOf$2(array, value, index);
}

/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */
function initial(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 0, -1) : [];
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$8 = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap$3(array, baseUnary$2(iteratee));
    }
    maxLength = nativeMin$8(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache$2(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas$2(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas$2(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap$3(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */
var intersectionBy = baseRest(function(arrays) {
  var iteratee = last(arrays),
      mapped = arrayMap$3(arrays, castArrayLikeObject);

  if (iteratee === last(mapped)) {
    iteratee = undefined;
  } else {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, baseIteratee$2(iteratee))
    : [];
});

/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */
var intersectionWith = baseRest(function(arrays) {
  var comparator = last(arrays),
      mapped = arrayMap$3(arrays, castArrayLikeObject);

  comparator = typeof comparator == 'function' ? comparator : undefined;
  if (comparator) {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, undefined, comparator)
    : [];
});

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn$2(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$3 = objectProto$h.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString$3.call(value);
  }

  result[value] = key;
}, constant(identity$2));

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$g.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$g.toString;

/**
 * This method is like `_.invert` except that the inverted object is generated
 * from the results of running each element of `object` thru `iteratee`. The
 * corresponding inverted value of each inverted key is an array of keys
 * responsible for generating the inverted value. The iteratee is invoked
 * with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Object
 * @param {Object} object The object to invert.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invertBy(object);
 * // => { '1': ['a', 'c'], '2': ['b'] }
 *
 * _.invertBy(object, function(value) {
 *   return 'group' + value;
 * });
 * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
 */
var invertBy = createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString$2.call(value);
  }

  if (hasOwnProperty$d.call(result, value)) {
    result[value].push(key);
  } else {
    result[value] = [key];
  }
}, baseIteratee$2);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet$3(object, baseSlice(path, 0, -1));
}

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = castPath$3(path, object);
  object = parent(object, path);
  var func = object == null ? object : object[toKey$5(last(path))];
  return func == null ? undefined : apply(func, object, args);
}

/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = baseRest(baseInvoke);

/**
 * Invokes the method at `path` of each element in `collection`, returning
 * an array of the results of each invoked method. Any additional arguments
 * are provided to each invoked method. If `path` is a function, it's invoked
 * for, and `this` bound to, each element in `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array|Function|string} path The path of the method to invoke or
 *  the function invoked per iteration.
 * @param {...*} [args] The arguments to invoke each method with.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
 * // => [[1, 5, 7], [1, 2, 3]]
 *
 * _.invokeMap([123, 456], String.prototype.split, '');
 * // => [['1', '2', '3'], ['4', '5', '6']]
 */
var invokeMap = baseRest(function(collection, path, args) {
  var index = -1,
      isFunc = typeof path == 'function',
      result = isArrayLike$4(collection) ? Array(collection.length) : [];

  baseEach$2(collection, function(value) {
    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
  });
  return result;
});

var arrayBufferTag$2 = '[object ArrayBuffer]';

/**
 * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 */
function baseIsArrayBuffer(value) {
  return isObjectLike$7(value) && baseGetTag$7(value) == arrayBufferTag$2;
}

/* Node.js helper references. */
var nodeIsArrayBuffer = nodeUtil$1 && nodeUtil$1.isArrayBuffer;

/**
 * Checks if `value` is classified as an `ArrayBuffer` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 * @example
 *
 * _.isArrayBuffer(new ArrayBuffer(2));
 * // => true
 *
 * _.isArrayBuffer(new Array(2));
 * // => false
 */
var isArrayBuffer = nodeIsArrayBuffer ? baseUnary$2(nodeIsArrayBuffer) : baseIsArrayBuffer;

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike$7(value) && baseGetTag$7(value) == boolTag$2);
}

/** `Object#toString` result references. */
var dateTag$2 = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike$7(value) && baseGetTag$7(value) == dateTag$2;
}

/* Node.js helper references. */
var nodeIsDate = nodeUtil$1 && nodeUtil$1.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary$2(nodeIsDate) : baseIsDate;

/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return isObjectLike$7(value) && value.nodeType === 1 && !isPlainObject(value);
}

/** `Object#toString` result references. */
var mapTag$5 = '[object Map]',
    setTag$5 = '[object Set]';

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$f.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike$4(value) &&
      (isArray$b(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer$3(value) || isTypedArray$3(value) || isArguments$3(value))) {
    return !value.length;
  }
  var tag = getTag$3(value);
  if (tag == mapTag$5 || tag == setTag$5) {
    return !value.size;
  }
  if (isPrototype$2(value)) {
    return !baseKeys$2(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$c.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual$3(value, other);
}

/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? baseIsEqual$3(value, other, undefined, customizer) : !!result;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root$9.isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger$2(value);
}

/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || baseIsMatch$2(object, source, getMatchData$2(source));
}

/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */
function isMatchWith(object, source, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseIsMatch$2(object, source, getMatchData$2(source), customizer);
}

/** `Object#toString` result references. */
var numberTag$2 = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike$7(value) && baseGetTag$7(value) == numberTag$2);
}

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN$1(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

/**
 * Checks if `func` is capable of being masked.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
 */
var isMaskable = coreJsData$2 ? isFunction$3 : stubFalse$1;

/** Error message constants. */
var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.';

/**
 * Checks if `value` is a pristine native function.
 *
 * **Note:** This method can't reliably detect native functions in the presence
 * of the core-js package because core-js circumvents this kind of detection.
 * Despite multiple requests, the core-js maintainer has made it clear: any
 * attempt to fix the detection will be obstructed. As a result, we're left
 * with little choice but to throw an error. Unfortunately, this also affects
 * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
 * which rely on core-js.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (isMaskable(value)) {
    throw new Error(CORE_ERROR_TEXT);
  }
  return baseIsNative$2(value);
}

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

/** `Object#toString` result references. */
var regexpTag$2 = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike$7(value) && baseGetTag$7(value) == regexpTag$2;
}

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil$1 && nodeUtil$1.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary$2(nodeIsRegExp) : baseIsRegExp;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$5 = 9007199254740991;

/**
 * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
 * double precision number which isn't the result of a rounded unsafe integer.
 *
 * **Note:** This method is based on
 * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
 * @example
 *
 * _.isSafeInteger(3);
 * // => true
 *
 * _.isSafeInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isSafeInteger(Infinity);
 * // => false
 *
 * _.isSafeInteger('3');
 * // => false
 */
function isSafeInteger(value) {
  return isInteger(value) && value >= -MAX_SAFE_INTEGER$5 && value <= MAX_SAFE_INTEGER$5;
}

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/** `Object#toString` result references. */
var weakMapTag$2 = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike$7(value) && getTag$3(value) == weakMapTag$2;
}

/** `Object#toString` result references. */
var weakSetTag = '[object WeakSet]';

/**
 * Checks if `value` is classified as a `WeakSet` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
 * @example
 *
 * _.isWeakSet(new WeakSet);
 * // => true
 *
 * _.isWeakSet(new Set);
 * // => false
 */
function isWeakSet(value) {
  return isObjectLike$7(value) && baseGetTag$7(value) == weakSetTag;
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$3 = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee$2(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG$3));
}

/** Used for built-in method references. */
var arrayProto$5 = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto$5.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

/**
 * A specialized version of `_.lastIndexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictLastIndexOf(array, value, fromIndex) {
  var index = fromIndex + 1;
  while (index--) {
    if (array[index] === value) {
      return index;
    }
  }
  return index;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$6 = Math.max,
    nativeMin$7 = Math.min;

/**
 * This method is like `_.indexOf` except that it iterates over elements of
 * `array` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.lastIndexOf([1, 2, 1, 2], 2);
 * // => 3
 *
 * // Search from the `fromIndex`.
 * _.lastIndexOf([1, 2, 1, 2], 2, 2);
 * // => 1
 */
function lastIndexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length;
  if (fromIndex !== undefined) {
    index = toInteger$2(fromIndex);
    index = index < 0 ? nativeMax$6(length + index, 0) : nativeMin$7(index, length - 1);
  }
  return value === value
    ? strictLastIndexOf(array, value, index)
    : baseFindIndex$2(array, baseIsNaN$2, index, true);
}

/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */
var lowerCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toLowerCase();
});

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

/**
 * Checks if `value` is less than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 * @see _.gt
 * @example
 *
 * _.lt(1, 3);
 * // => true
 *
 * _.lt(3, 3);
 * // => false
 *
 * _.lt(3, 1);
 * // => false
 */
var lt = createRelationalOperation(baseLt);

/**
 * Checks if `value` is less than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than or equal to
 *  `other`, else `false`.
 * @see _.gte
 * @example
 *
 * _.lte(1, 3);
 * // => true
 *
 * _.lte(3, 3);
 * // => true
 *
 * _.lte(3, 1);
 * // => false
 */
var lte = createRelationalOperation(function(value, other) {
  return value <= other;
});

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee$2(iteratee);

  baseForOwn$2(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee$2(iteratee);

  baseForOwn$2(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$2 = 1;

/**
 * Creates a function that performs a partial deep comparison between a given
 * object and `source`, returning `true` if the given object has equivalent
 * property values, else `false`.
 *
 * **Note:** The created function is equivalent to `_.isMatch` with `source`
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * **Note:** Multiple values can be checked by combining several matchers
 * using `_.overSome`
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
 * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
 *
 * // Checking for several possible values
 * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
 * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
 */
function matches(source) {
  return baseMatches$2(baseClone(source, CLONE_DEEP_FLAG$2));
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1;

/**
 * Creates a function that performs a partial deep comparison between the
 * value at `path` of a given object to `srcValue`, returning `true` if the
 * object value is equivalent, else `false`.
 *
 * **Note:** Partial comparisons will match empty array and empty object
 * `srcValue` values against any array or object value, respectively. See
 * `_.isEqual` for a list of supported value comparisons.
 *
 * **Note:** Multiple values can be checked by combining several matchers
 * using `_.overSome`
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.find(objects, _.matchesProperty('a', 4));
 * // => { 'a': 4, 'b': 5, 'c': 6 }
 *
 * // Checking for several possible values
 * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
 * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
 */
function matchesProperty(path, srcValue) {
  return baseMatchesProperty$2(path, baseClone(srcValue, CLONE_DEEP_FLAG$1));
}

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol$5(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return (array && array.length)
    ? baseExtremum(array, identity$2, baseGt)
    : undefined;
}

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee$2(iteratee), baseGt)
    : undefined;
}

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */
function baseMean(array, iteratee) {
  var length = array == null ? 0 : array.length;
  return length ? (baseSum(array, iteratee) / length) : NAN$1;
}

/**
 * Computes the mean of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the mean.
 * @example
 *
 * _.mean([4, 2, 8, 6]);
 * // => 5
 */
function mean(array) {
  return baseMean(array, identity$2);
}

/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */
function meanBy(array, iteratee) {
  return baseMean(array, baseIteratee$2(iteratee));
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that invokes the method at `path` of a given object.
 * Any additional arguments are provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': _.constant(2) } },
 *   { 'a': { 'b': _.constant(1) } }
 * ];
 *
 * _.map(objects, _.method('a.b'));
 * // => [2, 1]
 *
 * _.map(objects, _.method(['a', 'b']));
 * // => [2, 1]
 */
var method = baseRest(function(path, args) {
  return function(object) {
    return baseInvoke(object, path, args);
  };
});

/**
 * The opposite of `_.method`; this method creates a function that invokes
 * the method at a given path of `object`. Any additional arguments are
 * provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Object} object The object to query.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var array = _.times(3, _.constant),
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.methodOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
 * // => [2, 0]
 */
var methodOf = baseRest(function(object, args) {
  return function(path) {
    return baseInvoke(object, path, args);
  };
});

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? baseExtremum(array, identity$2, baseLt)
    : undefined;
}

/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee$2(iteratee), baseLt)
    : undefined;
}

/**
 * Adds all own enumerable string keyed function properties of a source
 * object to the destination object. If `object` is a function, then methods
 * are added to its prototype as well.
 *
 * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
 * avoid conflicts caused by modifying the original.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Function|Object} [object=lodash] The destination object.
 * @param {Object} source The object of functions to add.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
 * @returns {Function|Object} Returns `object`.
 * @example
 *
 * function vowels(string) {
 *   return _.filter(string, function(v) {
 *     return /[aeiou]/i.test(v);
 *   });
 * }
 *
 * _.mixin({ 'vowels': vowels });
 * _.vowels('fred');
 * // => ['e']
 *
 * _('fred').vowels().value();
 * // => ['e']
 *
 * _.mixin({ 'vowels': vowels }, { 'chain': false });
 * _('fred').vowels();
 * // => ['e']
 */
function mixin$1(object, source, options) {
  var props = keys$5(source),
      methodNames = baseFunctions(source, props);

  var chain = !(isObject$5(options) && 'chain' in options) || !!options.chain,
      isFunc = isFunction$3(object);

  arrayEach(methodNames, function(methodName) {
    var func = source[methodName];
    object[methodName] = func;
    if (isFunc) {
      object.prototype[methodName] = function() {
        var chainAll = this.__chain__;
        if (chain || chainAll) {
          var result = object(this.__wrapped__),
              actions = result.__actions__ = copyArray(this.__actions__);

          actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
          result.__chain__ = chainAll;
          return result;
        }
        return func.apply(object, arrayPush$2([this.value()], arguments));
      };
    }
  });

  return object;
}

/**
 * Multiply two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} multiplier The first number in a multiplication.
 * @param {number} multiplicand The second number in a multiplication.
 * @returns {number} Returns the product.
 * @example
 *
 * _.multiply(6, 4);
 * // => 24
 */
var multiply = createMathOperation(function(multiplier, multiplicand) {
  return multiplier * multiplicand;
}, 1);

/** Error message constants. */
var FUNC_ERROR_TEXT$4 = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$4);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]',
    setTag$4 = '[object Set]';

/** Built-in value references. */
var symIterator$1 = Symbol$6 ? Symbol$6.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike$4(value)) {
    return isString$2(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator$1 && value[symIterator$1]) {
    return iteratorToArray(value[symIterator$1]());
  }
  var tag = getTag$3(value),
      func = tag == mapTag$4 ? mapToArray$2 : (tag == setTag$4 ? setToArray$2 : values$2);

  return func(value);
}

/**
 * Gets the next value on a wrapped object following the
 * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
 *
 * @name next
 * @memberOf _
 * @since 4.0.0
 * @category Seq
 * @returns {Object} Returns the next iterator value.
 * @example
 *
 * var wrapped = _([1, 2]);
 *
 * wrapped.next();
 * // => { 'done': false, 'value': 1 }
 *
 * wrapped.next();
 * // => { 'done': false, 'value': 2 }
 *
 * wrapped.next();
 * // => { 'done': true, 'value': undefined }
 */
function wrapperNext() {
  if (this.__values__ === undefined) {
    this.__values__ = toArray(this.value());
  }
  var done = this.__index__ >= this.__values__.length,
      value = done ? undefined : this.__values__[this.__index__++];

  return { 'done': done, 'value': value };
}

/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */
function baseNth(array, n) {
  var length = array.length;
  if (!length) {
    return;
  }
  n += n < 0 ? length : 0;
  return isIndex$3(n, length) ? array[n] : undefined;
}

/**
 * Gets the element at index `n` of `array`. If `n` is negative, the nth
 * element from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.11.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=0] The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 *
 * _.nth(array, 1);
 * // => 'b'
 *
 * _.nth(array, -2);
 * // => 'c';
 */
function nth(array, n) {
  return (array && array.length) ? baseNth(array, toInteger$2(n)) : undefined;
}

/**
 * Creates a function that gets the argument at index `n`. If `n` is negative,
 * the nth argument from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [n=0] The index of the argument to return.
 * @returns {Function} Returns the new pass-thru function.
 * @example
 *
 * var func = _.nthArg(1);
 * func('a', 'b', 'c', 'd');
 * // => 'b'
 *
 * var func = _.nthArg(-2);
 * func('a', 'b', 'c', 'd');
 * // => 'c'
 */
function nthArg(n) {
  n = toInteger$2(n);
  return baseRest(function(args) {
    return baseNth(args, n);
  });
}

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath$3(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey$5(last(path))];
}

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap$3(paths, function(path) {
    path = castPath$3(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject$5(object)) {
    return object;
  }
  path = castPath$3(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey$5(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$5(objValue)
          ? objValue
          : (isIndex$3(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet$3(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath$3(path, object), value);
    }
  }
  return result;
}

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap$3(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee$2(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee$2(predicate)));
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol$5(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol$5(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap$3(iteratees, function(iteratee) {
      if (isArray$b(iteratee)) {
        return function(value) {
          return baseGet$3(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity$2];
  }

  var index = -1;
  iteratees = arrayMap$3(iteratees, baseUnary$2(baseIteratee$2));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap$3(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray$b(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray$b(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

/**
 * Creates a function like `_.over`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over iteratees.
 * @returns {Function} Returns the new over function.
 */
function createOver(arrayFunc) {
  return flatRest(function(iteratees) {
    iteratees = arrayMap$3(iteratees, baseUnary$2(baseIteratee$2));
    return baseRest(function(args) {
      var thisArg = this;
      return arrayFunc(iteratees, function(iteratee) {
        return apply(iteratee, thisArg, args);
      });
    });
  });
}

/**
 * Creates a function that invokes `iteratees` with the arguments it receives
 * and returns their results.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.over([Math.max, Math.min]);
 *
 * func(1, 2, 3, 4);
 * // => [4, 1]
 */
var over = createOver(arrayMap$3);

/**
 * A `baseRest` alias which can be replaced with `identity` by module
 * replacement plugins.
 *
 * @private
 * @type {Function}
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
var castRest = baseRest;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$6 = Math.min;

/**
 * Creates a function that invokes `func` with its arguments transformed.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Function
 * @param {Function} func The function to wrap.
 * @param {...(Function|Function[])} [transforms=[_.identity]]
 *  The argument transforms.
 * @returns {Function} Returns the new function.
 * @example
 *
 * function doubled(n) {
 *   return n * 2;
 * }
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var func = _.overArgs(function(x, y) {
 *   return [x, y];
 * }, [square, doubled]);
 *
 * func(9, 3);
 * // => [81, 6]
 *
 * func(10, 5);
 * // => [100, 10]
 */
var overArgs = castRest(function(func, transforms) {
  transforms = (transforms.length == 1 && isArray$b(transforms[0]))
    ? arrayMap$3(transforms[0], baseUnary$2(baseIteratee$2))
    : arrayMap$3(baseFlatten(transforms, 1), baseUnary$2(baseIteratee$2));

  var funcsLength = transforms.length;
  return baseRest(function(args) {
    var index = -1,
        length = nativeMin$6(args.length, funcsLength);

    while (++index < length) {
      args[index] = transforms[index].call(this, args[index]);
    }
    return apply(func, this, args);
  });
});

/**
 * Creates a function that checks if **all** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * Following shorthands are possible for providing predicates.
 * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
 * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overEvery([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => false
 *
 * func(NaN);
 * // => false
 */
var overEvery = createOver(arrayEvery);

/**
 * Creates a function that checks if **any** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * Following shorthands are possible for providing predicates.
 * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
 * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overSome([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => true
 *
 * func(NaN);
 * // => false
 *
 * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
 * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
 */
var overSome = createOver(arraySome$2);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$4 = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor$3 = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER$4) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor$3(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty$2('length');

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil$2 = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : baseToString$2(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil$2(length / stringSize(chars)));
  return hasUnicode(chars)
    ? castSlice(stringToArray(result), 0, length).join('')
    : result.slice(0, length);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil$1 = Math.ceil,
    nativeFloor$2 = Math.floor;

/**
 * Pads `string` on the left and right sides if it's shorter than `length`.
 * Padding characters are truncated if they can't be evenly divided by `length`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.pad('abc', 8);
 * // => '  abc   '
 *
 * _.pad('abc', 8, '_-');
 * // => '_-abc_-_'
 *
 * _.pad('abc', 3);
 * // => 'abc'
 */
function pad(string, length, chars) {
  string = toString$2(string);
  length = toInteger$2(length);

  var strLength = length ? stringSize(string) : 0;
  if (!length || strLength >= length) {
    return string;
  }
  var mid = (length - strLength) / 2;
  return (
    createPadding(nativeFloor$2(mid), chars) +
    string +
    createPadding(nativeCeil$1(mid), chars)
  );
}

/**
 * Pads `string` on the right side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padEnd('abc', 6);
 * // => 'abc   '
 *
 * _.padEnd('abc', 6, '_-');
 * // => 'abc_-_'
 *
 * _.padEnd('abc', 3);
 * // => 'abc'
 */
function padEnd(string, length, chars) {
  string = toString$2(string);
  length = toInteger$2(length);

  var strLength = length ? stringSize(string) : 0;
  return (length && strLength < length)
    ? (string + createPadding(length - strLength, chars))
    : string;
}

/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = toString$2(string);
  length = toInteger$2(length);

  var strLength = length ? stringSize(string) : 0;
  return (length && strLength < length)
    ? (createPadding(length - strLength, chars) + string)
    : string;
}

/** Used to match leading whitespace. */
var reTrimStart$1 = /^\s+/;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeParseInt = root$9.parseInt;

/**
 * Converts `string` to an integer of the specified radix. If `radix` is
 * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
 * hexadecimal, in which case a `radix` of `16` is used.
 *
 * **Note:** This method aligns with the
 * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category String
 * @param {string} string The string to convert.
 * @param {number} [radix=10] The radix to interpret `value` by.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.parseInt('08');
 * // => 8
 *
 * _.map(['6', '08', '10'], _.parseInt);
 * // => [6, 8, 10]
 */
function parseInt$1(string, radix, guard) {
  if (guard || radix == null) {
    radix = 0;
  } else if (radix) {
    radix = +radix;
  }
  return nativeParseInt(toString$2(string).replace(reTrimStart$1, ''), radix || 0);
}

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */
var partialRight = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partialRight));
  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partialRight.placeholder = {};

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */
var partition = createAggregator(function(result, value, key) {
  result[key ? 0 : 1].push(value);
}, function() { return [[], []]; });

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn$2(object, path);
  });
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

/**
 * Creates a clone of the chain sequence planting `value` as the wrapped value.
 *
 * @name plant
 * @memberOf _
 * @since 3.2.0
 * @category Seq
 * @param {*} value The value to plant.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2]).map(square);
 * var other = wrapped.plant([3, 4]);
 *
 * other.value();
 * // => [9, 16]
 *
 * wrapped.value();
 * // => [1, 4]
 */
function wrapperPlant(value) {
  var result,
      parent = this;

  while (parent instanceof baseLodash) {
    var clone = wrapperClone(parent);
    clone.__index__ = 0;
    clone.__values__ = undefined;
    if (result) {
      previous.__wrapped__ = clone;
    } else {
      result = clone;
    }
    var previous = clone;
    parent = parent.__wrapped__;
  }
  previous.__wrapped__ = value;
  return result;
}

/**
 * The opposite of `_.property`; this method creates a function that returns
 * the value at a given path of `object`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var array = [0, 1, 2],
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
 * // => [2, 0]
 */
function propertyOf(object) {
  return function(path) {
    return object == null ? undefined : baseGet$3(object, path);
  };
}

/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto$4 = Array.prototype;

/** Built-in value references. */
var splice$2 = arrayProto$4.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? baseIndexOfWith : baseIndexOf$2,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = copyArray(values);
  }
  if (iteratee) {
    seen = arrayMap$3(array, baseUnary$2(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice$2.call(seen, fromIndex, 1);
      }
      splice$2.call(array, fromIndex, 1);
    }
  }
  return array;
}

/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values)
    : array;
}

/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = baseRest(pullAll);

/**
 * This method is like `_.pullAll` except that it accepts `iteratee` which is
 * invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The iteratee is invoked with one argument: (value).
 *
 * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
 *
 * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
 * console.log(array);
 * // => [{ 'x': 2 }]
 */
function pullAllBy(array, values, iteratee) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values, baseIteratee$2(iteratee))
    : array;
}

/**
 * This method is like `_.pullAll` except that it accepts `comparator` which
 * is invoked to compare elements of `array` to `values`. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
 *
 * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
 * console.log(array);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
 */
function pullAllWith(array, values, comparator) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values, undefined, comparator)
    : array;
}

/** Used for built-in method references. */
var arrayProto$3 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$3.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex$3(index)) {
        splice$1.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

/**
 * Removes elements from `array` corresponding to `indexes` and returns an
 * array of removed elements.
 *
 * **Note:** Unlike `_.at`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...(number|number[])} [indexes] The indexes of elements to remove.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 * var pulled = _.pullAt(array, [1, 3]);
 *
 * console.log(array);
 * // => ['a', 'c']
 *
 * console.log(pulled);
 * // => ['b', 'd']
 */
var pullAt = flatRest(function(array, indexes) {
  var length = array == null ? 0 : array.length,
      result = baseAt(array, indexes);

  basePullAt(array, arrayMap$3(indexes, function(index) {
    return isIndex$3(index, length) ? +index : index;
  }).sort(compareAscending));

  return result;
});

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor$1 = Math.floor,
    nativeRandom$1 = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor$1(nativeRandom$1() * (upper - lower + 1));
}

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$5 = Math.min,
    nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = toFinite$2(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite$2(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom();
    return nativeMin$5(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return baseRandom(lower, upper);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax$5 = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax$5(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite$2(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite$2(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite$2(step);
    return baseRange(start, end, step, fromRight);
  };
}

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

/**
 * This method is like `_.range` except that it populates values in
 * descending order.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.range
 * @example
 *
 * _.rangeRight(4);
 * // => [3, 2, 1, 0]
 *
 * _.rangeRight(-4);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 5);
 * // => [4, 3, 2, 1]
 *
 * _.rangeRight(0, 20, 5);
 * // => [15, 10, 5, 0]
 *
 * _.rangeRight(0, -4, -1);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.rangeRight(0);
 * // => []
 */
var rangeRight = createRange(true);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray$b(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee$2(iteratee), accumulator, initAccum, baseEach$2);
}

/**
 * A specialized version of `_.reduceRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the last element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduceRight(array, iteratee, accumulator, initAccum) {
  var length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[--length];
  }
  while (length--) {
    accumulator = iteratee(accumulator, array[length], length, array);
  }
  return accumulator;
}

/**
 * This method is like `_.reduce` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduce
 * @example
 *
 * var array = [[0, 1], [2, 3], [4, 5]];
 *
 * _.reduceRight(array, function(flattened, other) {
 *   return flattened.concat(other);
 * }, []);
 * // => [4, 5, 2, 3, 0, 1]
 */
function reduceRight(collection, iteratee, accumulator) {
  var func = isArray$b(collection) ? arrayReduceRight : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee$2(iteratee), accumulator, initAccum, baseEachRight);
}

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray$b(collection) ? arrayFilter$3 : baseFilter$2;
  return func(collection, negate(baseIteratee$2(predicate)));
}

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee$2(predicate);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

/**
 * Repeats the given string `n` times.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to repeat.
 * @param {number} [n=1] The number of times to repeat the string.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the repeated string.
 * @example
 *
 * _.repeat('*', 3);
 * // => '***'
 *
 * _.repeat('abc', 2);
 * // => 'abcabc'
 *
 * _.repeat('abc', 0);
 * // => ''
 */
function repeat(string, n, guard) {
  if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = toInteger$2(n);
  }
  return baseRepeat(toString$2(string), n);
}

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString$2(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as
 * an array.
 *
 * **Note:** This method is based on the
 * [rest parameter](https://mdn.io/rest_parameters).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.rest(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function rest(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  start = start === undefined ? start : toInteger$2(start);
  return baseRest(func, start);
}

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = castPath$3(path, object);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    length = 1;
    object = undefined;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey$5(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction$3(value) ? value.call(object) : value;
  }
  return object;
}

/** Used for built-in method references. */
var arrayProto$2 = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeReverse = arrayProto$2.reverse;

/**
 * Reverses `array` so that the first element becomes the last, the second
 * element becomes the second to last, and so on.
 *
 * **Note:** This method mutates `array` and is based on
 * [`Array#reverse`](https://mdn.io/Array/reverse).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.reverse(array);
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function reverse(array) {
  return array == null ? array : nativeReverse.call(array);
}

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */
function arraySample(array) {
  var length = array.length;
  return length ? array[baseRandom(0, length - 1)] : undefined;
}

/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */
function baseSample(collection) {
  return arraySample(values$2(collection));
}

/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */
function sample(collection) {
  var func = isArray$b(collection) ? arraySample : baseSample;
  return func(collection);
}

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
}

/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = values$2(collection);
  return shuffleSelf(array, baseClamp(n, 0, array.length));
}

/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = toInteger$2(n);
  }
  var func = isArray$b(collection) ? arraySampleSize : baseSampleSize;
  return func(collection, n);
}

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseSet(object, path, value, customizer);
}

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values$2(collection));
}

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = isArray$b(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    setTag$3 = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike$4(collection)) {
    return isString$2(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag$3(collection);
  if (tag == mapTag$3 || tag == setTag$3) {
    return collection.size;
  }
  return baseKeys$2(collection).length;
}

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger$2(start);
    end = end === undefined ? length : toInteger$2(end);
  }
  return baseSlice(array, start, end);
}

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach$2(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray$b(collection) ? arraySome$2 : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee$2(predicate));
}

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$4 = 4294967295,
    MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH$4 - 1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeMin$4 = Math.min;

/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndexBy(array, value, iteratee, retHighest) {
  var low = 0,
      high = array == null ? 0 : array.length;
  if (high === 0) {
    return 0;
  }

  value = iteratee(value);
  var valIsNaN = value !== value,
      valIsNull = value === null,
      valIsSymbol = isSymbol$5(value),
      valIsUndefined = value === undefined;

  while (low < high) {
    var mid = nativeFloor((low + high) / 2),
        computed = iteratee(array[mid]),
        othIsDefined = computed !== undefined,
        othIsNull = computed === null,
        othIsReflexive = computed === computed,
        othIsSymbol = isSymbol$5(computed);

    if (valIsNaN) {
      var setLow = retHighest || othIsReflexive;
    } else if (valIsUndefined) {
      setLow = othIsReflexive && (retHighest || othIsDefined);
    } else if (valIsNull) {
      setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
    } else if (valIsSymbol) {
      setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
    } else if (othIsNull || othIsSymbol) {
      setLow = false;
    } else {
      setLow = retHighest ? (computed <= value) : (computed < value);
    }
    if (setLow) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return nativeMin$4(high, MAX_ARRAY_INDEX);
}

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$3 = 4294967295,
    HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH$3 >>> 1;

/**
 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
 * performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndex(array, value, retHighest) {
  var low = 0,
      high = array == null ? low : array.length;

  if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
    while (low < high) {
      var mid = (low + high) >>> 1,
          computed = array[mid];

      if (computed !== null && !isSymbol$5(computed) &&
          (retHighest ? (computed <= value) : (computed < value))) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }
    return high;
  }
  return baseSortedIndexBy(array, value, identity$2, retHighest);
}

/**
 * Uses a binary search to determine the lowest index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedIndex([30, 50], 40);
 * // => 1
 */
function sortedIndex(array, value) {
  return baseSortedIndex(array, value);
}

/**
 * This method is like `_.sortedIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
 * // => 0
 */
function sortedIndexBy(array, value, iteratee) {
  return baseSortedIndexBy(array, value, baseIteratee$2(iteratee));
}

/**
 * This method is like `_.indexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
 * // => 1
 */
function sortedIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = baseSortedIndex(array, value);
    if (index < length && eq$3(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/**
 * This method is like `_.sortedIndex` except that it returns the highest
 * index at which `value` should be inserted into `array` in order to
 * maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
 * // => 4
 */
function sortedLastIndex(array, value) {
  return baseSortedIndex(array, value, true);
}

/**
 * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 1
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
 * // => 1
 */
function sortedLastIndexBy(array, value, iteratee) {
  return baseSortedIndexBy(array, value, baseIteratee$2(iteratee), true);
}

/**
 * This method is like `_.lastIndexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
 * // => 3
 */
function sortedLastIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = baseSortedIndex(array, value, true) - 1;
    if (eq$3(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseSortedUniq(array, iteratee) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    if (!index || !eq$3(computed, seen)) {
      var seen = computed;
      result[resIndex++] = value === 0 ? 0 : value;
    }
  }
  return result;
}

/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */
function sortedUniq(array) {
  return (array && array.length)
    ? baseSortedUniq(array)
    : [];
}

/**
 * This method is like `_.uniqBy` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
 * // => [1.1, 2.3]
 */
function sortedUniqBy(array, iteratee) {
  return (array && array.length)
    ? baseSortedUniq(array, baseIteratee$2(iteratee))
    : [];
}

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$2 = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH$2 : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString$2(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString$2(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$4 = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * create function and an array of arguments much like
 * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
 *
 * **Note:** This method is based on the
 * [spread operator](https://mdn.io/spread_operator).
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Function
 * @param {Function} func The function to spread arguments over.
 * @param {number} [start=0] The start position of the spread.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.spread(function(who, what) {
 *   return who + ' says ' + what;
 * });
 *
 * say(['fred', 'hello']);
 * // => 'fred says hello'
 *
 * var numbers = Promise.all([
 *   Promise.resolve(40),
 *   Promise.resolve(36)
 * ]);
 *
 * numbers.then(_.spread(function(x, y) {
 *   return x + y;
 * }));
 * // => a Promise of 76
 */
function spread(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  start = start == null ? 0 : nativeMax$4(toInteger$2(start), 0);
  return baseRest(function(args) {
    var array = args[start],
        otherArgs = castSlice(args, 0, start);

    if (array) {
      arrayPush$2(otherArgs, array);
    }
    return apply(func, this, otherArgs);
  });
}

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString$2(string);
  position = position == null
    ? 0
    : baseClamp(toInteger$2(position), 0, string.length);

  target = baseToString$2(target);
  return string.slice(position, position + target.length) == target;
}

/**
 * This method returns a new empty object.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Object} Returns the new empty object.
 * @example
 *
 * var objects = _.times(2, _.stubObject);
 *
 * console.log(objects);
 * // => [{}, {}]
 *
 * console.log(objects[0] === objects[1]);
 * // => false
 */
function stubObject() {
  return {};
}

/**
 * This method returns an empty string.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {string} Returns the empty string.
 * @example
 *
 * _.times(2, _.stubString);
 * // => ['', '']
 */
function stubString() {
  return '';
}

/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */
function stubTrue() {
  return true;
}

/**
 * Subtract two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {number} minuend The first number in a subtraction.
 * @param {number} subtrahend The second number in a subtraction.
 * @returns {number} Returns the difference.
 * @example
 *
 * _.subtract(6, 4);
 * // => 2
 */
var subtract = createMathOperation(function(minuend, subtrahend) {
  return minuend - subtrahend;
}, 0);

/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? baseSum(array, identity$2)
    : 0;
}

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee$2(iteratee))
    : 0;
}

/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 1, length) : [];
}

/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger$2(n);
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

/**
 * Creates a slice of `array` with `n` elements taken from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.takeRight([1, 2, 3]);
 * // => [3]
 *
 * _.takeRight([1, 2, 3], 2);
 * // => [2, 3]
 *
 * _.takeRight([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.takeRight([1, 2, 3], 0);
 * // => []
 */
function takeRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger$2(n);
  n = length - n;
  return baseSlice(array, n < 0 ? 0 : n, length);
}

/**
 * Creates a slice of `array` with elements taken from the end. Elements are
 * taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.takeRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeRightWhile(users, ['active', false]);
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeRightWhile(users, 'active');
 * // => []
 */
function takeRightWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee$2(predicate), false, true)
    : [];
}

/**
 * Creates a slice of `array` with elements taken from the beginning. Elements
 * are taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.takeWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeWhile(users, ['active', false]);
 * // => objects for ['barney', 'fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeWhile(users, 'active');
 * // => []
 */
function takeWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee$2(predicate))
    : [];
}

/**
 * This method invokes `interceptor` and returns `value`. The interceptor
 * is invoked with one argument; (value). The purpose of this method is to
 * "tap into" a method chain sequence in order to modify intermediate results.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @param {*} value The value to provide to `interceptor`.
 * @param {Function} interceptor The function to invoke.
 * @returns {*} Returns `value`.
 * @example
 *
 * _([1, 2, 3])
 *  .tap(function(array) {
 *    // Mutate input array.
 *    array.pop();
 *  })
 *  .reverse()
 *  .value();
 * // => [2, 1]
 */
function tap(value, interceptor) {
  interceptor(value);
  return value;
}

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
 * of source objects to the destination object for all destination properties
 * that resolve to `undefined`.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsAssignIn(objValue, srcValue, key, object) {
  if (objValue === undefined ||
      (eq$3(objValue, objectProto$e[key]) && !hasOwnProperty$b.call(object, key))) {
    return srcValue;
  }
  return objValue;
}

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB) as well as ES2015 template strings. Change the
 * following template settings to use alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape }
  }
};

/** Error message constants. */
var INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to validate the `validate` option in `_.template` variable.
 *
 * Forbids characters which could potentially change the meaning of the function argument definition:
 * - "()," (modification of function parameters)
 * - "=" (default value)
 * - "[]{}" (destructuring of function parameters)
 * - "/" (beginning of a comment)
 * - whitespace
 */
var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES template literal delimiter as an "interpolate" delimiter.
 * // Disable support by replacing the "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString$2(string);
  options = assignInWith({}, options, settings, customDefaultsAssignIn);

  var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
      importsKeys = keys$5(imports),
      importsValues = baseValues$2(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp(
    (options.escape || reNoMatch).source + '|' +
    interpolate.source + '|' +
    (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
    (options.evaluate || reNoMatch).source + '|$'
  , 'g');

  // Use a sourceURL for easier debugging.
  // The sourceURL gets injected into the source that's eval-ed, so be careful
  // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
  // and escape the comment, thus injecting code that gets evaled.
  var sourceURL = hasOwnProperty$a.call(options, 'sourceURL')
    ? ('//# sourceURL=' +
       (options.sourceURL + '').replace(/\s/g, ' ') +
       '\n')
    : '';

  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = hasOwnProperty$a.call(options, 'variable') && options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Throw an error if a forbidden character was found in `variable`, to prevent
  // potential command injection attacks.
  else if (reForbiddenIdentifierChars.test(variable)) {
    throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
  }

  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
    .replace(reEmptyStringMiddle, '$1')
    .replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' +
    (variable
      ? ''
      : 'obj || (obj = {});\n'
    ) +
    "var __t, __p = ''" +
    (isEscaping
       ? ', __e = _.escape'
       : ''
    ) +
    (isEvaluating
      ? ', __j = Array.prototype.join;\n' +
        "function print() { __p += __j.call(arguments, '') }\n"
      : ';\n'
    ) +
    source +
    'return __p\n}';

  var result = attempt(function() {
    return Function(importsKeys, sourceURL + 'return ' + source)
      .apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject$5(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * This method is like `_.tap` except that it returns the result of `interceptor`.
 * The purpose of this method is to "pass thru" values replacing intermediate
 * results in a method chain sequence.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Seq
 * @param {*} value The value to provide to `interceptor`.
 * @param {Function} interceptor The function to invoke.
 * @returns {*} Returns the result of `interceptor`.
 * @example
 *
 * _('  abc  ')
 *  .chain()
 *  .trim()
 *  .thru(function(value) {
 *    return [value];
 *  })
 *  .value();
 * // => ['abc']
 */
function thru(value, interceptor) {
  return interceptor(value);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$3 = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH$1 = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$3 = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger$2(n);
  if (n < 1 || n > MAX_SAFE_INTEGER$3) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH$1,
      length = nativeMin$3(n, MAX_ARRAY_LENGTH$1);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH$1;

  var result = baseTimes$2(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

/**
 * Enables the wrapper to be iterable.
 *
 * @name Symbol.iterator
 * @memberOf _
 * @since 4.0.0
 * @category Seq
 * @returns {Object} Returns the wrapper object.
 * @example
 *
 * var wrapped = _([1, 2]);
 *
 * wrapped[Symbol.iterator]() === wrapped;
 * // => true
 *
 * Array.from(wrapped);
 * // => [1, 2]
 */
function wrapperToIterator() {
  return this;
}

/**
 * The base implementation of `wrapperValue` which returns the result of
 * performing a sequence of actions on the unwrapped `value`, where each
 * successive action is supplied the return value of the previous.
 *
 * @private
 * @param {*} value The unwrapped value.
 * @param {Array} actions Actions to perform to resolve the unwrapped value.
 * @returns {*} Returns the resolved value.
 */
function baseWrapperValue(value, actions) {
  var result = value;
  if (result instanceof LazyWrapper) {
    result = result.value();
  }
  return arrayReduce(actions, function(result, action) {
    return action.func.apply(action.thisArg, arrayPush$2([result], action.args));
  }, result);
}

/**
 * Executes the chain sequence to resolve the unwrapped value.
 *
 * @name value
 * @memberOf _
 * @since 0.1.0
 * @alias toJSON, valueOf
 * @category Seq
 * @returns {*} Returns the resolved unwrapped value.
 * @example
 *
 * _([1, 2, 3]).value();
 * // => [1, 2, 3]
 */
function wrapperValue() {
  return baseWrapperValue(this.__wrapped__, this.__actions__);
}

/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */
function toLower(value) {
  return toString$2(value).toLowerCase();
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray$b(value)) {
    return arrayMap$3(value, toKey$5);
  }
  return isSymbol$5(value) ? [value] : copyArray(stringToPath$2(toString$2(value)));
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$2 = 9007199254740991;

/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */
function toSafeInteger(value) {
  return value
    ? baseClamp(toInteger$2(value), -MAX_SAFE_INTEGER$2, MAX_SAFE_INTEGER$2)
    : (value === 0 ? value : 0);
}

/**
 * Converts `string`, as a whole, to upper case just like
 * [String#toUpperCase](https://mdn.io/toUpperCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.toUpper('--foo-bar--');
 * // => '--FOO-BAR--'
 *
 * _.toUpper('fooBar');
 * // => 'FOOBAR'
 *
 * _.toUpper('__foo_bar__');
 * // => '__FOO_BAR__'
 */
function toUpper(value) {
  return toString$2(value).toUpperCase();
}

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray$b(object),
      isArrLike = isArr || isBuffer$3(object) || isTypedArray$3(object);

  iteratee = baseIteratee$2(iteratee);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject$5(object)) {
      accumulator = isFunction$3(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn$2)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf$2(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf$2(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString$2(string);
  if (string && (guard || chars === undefined)) {
    return baseTrim(string);
  }
  if (!string || !(chars = baseToString$2(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */
function trimEnd(string, chars, guard) {
  string = toString$2(string);
  if (string && (guard || chars === undefined)) {
    return string.slice(0, trimmedEndIndex(string) + 1);
  }
  if (!string || !(chars = baseToString$2(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

  return castSlice(strSymbols, 0, end).join('');
}

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */
function trimStart(string, chars, guard) {
  string = toString$2(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimStart, '');
  }
  if (!string || !(chars = baseToString$2(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      start = charsStartIndex(strSymbols, stringToArray(chars));

  return castSlice(strSymbols, start).join('');
}

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (isObject$5(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger$2(options.length) : length;
    omission = 'omission' in options ? baseToString$2(options.omission) : omission;
  }
  string = toString$2(string);

  var strLength = string.length;
  if (hasUnicode(string)) {
    var strSymbols = stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? castSlice(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, toString$2(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(baseToString$2(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

/**
 * Creates a function that accepts up to one argument, ignoring any
 * additional arguments.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.unary(parseInt));
 * // => [6, 8, 10]
 */
function unary(func) {
  return ary(func, 1);
}

/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

/** Used to match HTML entities and HTML characters. */
var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source);

/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */
function unescape(string) {
  string = toString$2(string);
  return (string && reHasEscapedHtml.test(string))
    ? string.replace(reEscapedHtml, unescapeHtmlChar)
    : string;
}

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set$2 && (1 / setToArray$2(new Set$2([,-0]))[1]) == INFINITY$3) ? noop : function(values) {
  return new Set$2(values);
};

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE$1) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray$2(set);
    }
    isCommon = false;
    includes = cacheHas$2;
    seen = new SetCache$2;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee$2(iteratee));
});

/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
});

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee$2(iteratee)) : [];
}

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString$2(prefix) + id;
}

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$3 = Math.max;

/**
 * This method is like `_.zip` except that it accepts an array of grouped
 * elements and creates an array regrouping the elements to their pre-zip
 * configuration.
 *
 * @static
 * @memberOf _
 * @since 1.2.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 *
 * _.unzip(zipped);
 * // => [['a', 'b'], [1, 2], [true, false]]
 */
function unzip(array) {
  if (!(array && array.length)) {
    return [];
  }
  var length = 0;
  array = arrayFilter$3(array, function(group) {
    if (isArrayLikeObject(group)) {
      length = nativeMax$3(group.length, length);
      return true;
    }
  });
  return baseTimes$2(length, function(index) {
    return arrayMap$3(array, baseProperty$2(index));
  });
}

/**
 * This method is like `_.unzip` except that it accepts `iteratee` to specify
 * how regrouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  regrouped values.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
 * // => [[1, 10, 100], [2, 20, 200]]
 *
 * _.unzipWith(zipped, _.add);
 * // => [3, 30, 300]
 */
function unzipWith(array, iteratee) {
  if (!(array && array.length)) {
    return [];
  }
  var result = unzip(array);
  if (iteratee == null) {
    return result;
  }
  return arrayMap$3(result, function(group) {
    return apply(iteratee, undefined, group);
  });
}

/**
 * The base implementation of `_.update`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to update.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseUpdate(object, path, updater, customizer) {
  return baseSet(object, path, updater(baseGet$3(object, path)), customizer);
}

/**
 * This method is like `_.set` except that accepts `updater` to produce the
 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
 * is invoked with one argument: (value).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
 * console.log(object.a[0].b.c);
 * // => 9
 *
 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
 * console.log(object.x[0].y.z);
 * // => 0
 */
function update(object, path, updater) {
  return object == null ? object : baseUpdate(object, path, castFunction(updater));
}

/**
 * This method is like `_.update` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.updateWith(object, '[0][1]', _.constant('a'), Object);
 * // => { '0': { '1': 'a' } }
 */
function updateWith(object, path, updater, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
}

/**
 * Converts `string`, as space separated words, to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.upperCase('--foo-bar');
 * // => 'FOO BAR'
 *
 * _.upperCase('fooBar');
 * // => 'FOO BAR'
 *
 * _.upperCase('__foo_bar__');
 * // => 'FOO BAR'
 */
var upperCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toUpperCase();
});

/**
 * Creates an array of the own and inherited enumerable string keyed property
 * values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.valuesIn(new Foo);
 * // => [1, 2, 3] (iteration order is not guaranteed)
 */
function valuesIn(object) {
  return object == null ? [] : baseValues$2(object, keysIn(object));
}

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

/**
 * Creates a function that provides `value` to `wrapper` as its first
 * argument. Any additional arguments provided to the function are appended
 * to those provided to the `wrapper`. The wrapper is invoked with the `this`
 * binding of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {*} value The value to wrap.
 * @param {Function} [wrapper=identity] The wrapper function.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var p = _.wrap(_.escape, function(func, text) {
 *   return '<p>' + func(text) + '</p>';
 * });
 *
 * p('fred, barney, & pebbles');
 * // => '<p>fred, barney, &amp; pebbles</p>'
 */
function wrap(value, wrapper) {
  return partial(castFunction(wrapper), value);
}

/**
 * This method is the wrapper version of `_.at`.
 *
 * @name at
 * @memberOf _
 * @since 1.0.0
 * @category Seq
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _(object).at(['a[0].b.c', 'a[1]']).value();
 * // => [3, 4]
 */
var wrapperAt = flatRest(function(paths) {
  var length = paths.length,
      start = length ? paths[0] : 0,
      value = this.__wrapped__,
      interceptor = function(object) { return baseAt(object, paths); };

  if (length > 1 || this.__actions__.length ||
      !(value instanceof LazyWrapper) || !isIndex$3(start)) {
    return this.thru(interceptor);
  }
  value = value.slice(start, +start + (length ? 1 : 0));
  value.__actions__.push({
    'func': thru,
    'args': [interceptor],
    'thisArg': undefined
  });
  return new LodashWrapper(value, this.__chain__).thru(function(array) {
    if (length && !array.length) {
      array.push(undefined);
    }
    return array;
  });
});

/**
 * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
 *
 * @name chain
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 }
 * ];
 *
 * // A sequence without explicit chaining.
 * _(users).head();
 * // => { 'user': 'barney', 'age': 36 }
 *
 * // A sequence with explicit chaining.
 * _(users)
 *   .chain()
 *   .head()
 *   .pick('user')
 *   .value();
 * // => { 'user': 'barney' }
 */
function wrapperChain() {
  return chain(this);
}

/**
 * This method is the wrapper version of `_.reverse`.
 *
 * **Note:** This method mutates the wrapped array.
 *
 * @name reverse
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _(array).reverse().value()
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function wrapperReverse() {
  var value = this.__wrapped__;
  if (value instanceof LazyWrapper) {
    var wrapped = value;
    if (this.__actions__.length) {
      wrapped = new LazyWrapper(this);
    }
    wrapped = wrapped.reverse();
    wrapped.__actions__.push({
      'func': thru,
      'args': [reverse],
      'thisArg': undefined
    });
    return new LodashWrapper(wrapped, this.__chain__);
  }
  return this.thru(reverse);
}

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter$3(arrays, isArrayLikeObject));
});

/**
 * This method is like `_.xor` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which by which they're compared. The order of result values is determined
 * by the order they occur in the arrays. The iteratee is invoked with one
 * argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2, 3.4]
 *
 * // The `_.property` iteratee shorthand.
 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var xorBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseXor(arrayFilter$3(arrays, isArrayLikeObject), baseIteratee$2(iteratee));
});

/**
 * This method is like `_.xor` except that it accepts `comparator` which is
 * invoked to compare elements of `arrays`. The order of result values is
 * determined by the order they occur in the arrays. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.xorWith(objects, others, _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var xorWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseXor(arrayFilter$3(arrays, isArrayLikeObject), undefined, comparator);
});

/**
 * Creates an array of grouped elements, the first of which contains the
 * first elements of the given arrays, the second of which contains the
 * second elements of the given arrays, and so on.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 */
var zip = baseRest(unzip);

/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */
function baseZipObject(props, values, assignFunc) {
  var index = -1,
      length = props.length,
      valsLength = values.length,
      result = {};

  while (++index < length) {
    var value = index < valsLength ? values[index] : undefined;
    assignFunc(result, props[index], value);
  }
  return result;
}

/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return baseZipObject(props || [], values || [], assignValue);
}

/**
 * This method is like `_.zipObject` except that it supports property paths.
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
 * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
 */
function zipObjectDeep(props, values) {
  return baseZipObject(props || [], values || [], baseSet);
}

/**
 * This method is like `_.zip` except that it accepts `iteratee` to specify
 * how grouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  grouped values.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
 *   return a + b + c;
 * });
 * // => [111, 222]
 */
var zipWith = baseRest(function(arrays) {
  var length = arrays.length,
      iteratee = length > 1 ? arrays[length - 1] : undefined;

  iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
  return unzipWith(arrays, iteratee);
});

var array = {
  chunk, compact, concat, difference, differenceBy,
  differenceWith, drop, dropRight, dropRightWhile, dropWhile,
  fill, findIndex, findLastIndex, first: head, flatten,
  flattenDeep, flattenDepth, fromPairs, head, indexOf,
  initial, intersection, intersectionBy, intersectionWith, join,
  last, lastIndexOf, nth, pull, pullAll,
  pullAllBy, pullAllWith, pullAt, remove, reverse,
  slice, sortedIndex, sortedIndexBy, sortedIndexOf, sortedLastIndex,
  sortedLastIndexBy, sortedLastIndexOf, sortedUniq, sortedUniqBy, tail,
  take, takeRight, takeRightWhile, takeWhile, union,
  unionBy, unionWith, uniq, uniqBy, uniqWith,
  unzip, unzipWith, without, xor, xorBy,
  xorWith, zip, zipObject, zipObjectDeep, zipWith
};

var collection = {
  countBy, each: forEach, eachRight: forEachRight, every, filter: filter$1,
  find, findLast, flatMap, flatMapDeep, flatMapDepth,
  forEach, forEachRight, groupBy, includes: includes$1, invokeMap,
  keyBy, map, orderBy, partition, reduce,
  reduceRight, reject, sample, sampleSize, shuffle,
  size, some, sortBy
};

var date = {
  now
};

var func = {
  after, ary, before, bind, bindKey,
  curry, curryRight, debounce, defer, delay,
  flip, memoize: memoize$2, negate, once, overArgs,
  partial, partialRight, rearg, rest, spread,
  throttle, unary, wrap
};

var lang = {
  castArray, clone, cloneDeep, cloneDeepWith, cloneWith,
  conformsTo, eq: eq$3, gt, gte, isArguments: isArguments$3,
  isArray: isArray$b, isArrayBuffer, isArrayLike: isArrayLike$4, isArrayLikeObject, isBoolean,
  isBuffer: isBuffer$3, isDate, isElement, isEmpty, isEqual,
  isEqualWith, isError, isFinite, isFunction: isFunction$3, isInteger,
  isLength: isLength$4, isMap, isMatch, isMatchWith, isNaN: isNaN$1,
  isNative, isNil, isNull, isNumber, isObject: isObject$5,
  isObjectLike: isObjectLike$7, isPlainObject, isRegExp, isSafeInteger, isSet,
  isString: isString$2, isSymbol: isSymbol$5, isTypedArray: isTypedArray$3, isUndefined, isWeakMap,
  isWeakSet, lt, lte, toArray, toFinite: toFinite$2,
  toInteger: toInteger$2, toLength, toNumber: toNumber$2, toPlainObject, toSafeInteger,
  toString: toString$2
};

var math = {
  add, ceil, divide, floor, max,
  maxBy, mean, meanBy, min, minBy,
  multiply, round, subtract, sum, sumBy
};

var number = {
  clamp, inRange: inRange$1, random
};

var object = {
  assign, assignIn, assignInWith, assignWith, at,
  create, defaults: defaults$2, defaultsDeep, entries: toPairs, entriesIn: toPairsIn,
  extend: assignIn, extendWith: assignInWith, findKey, findLastKey, forIn,
  forInRight, forOwn, forOwnRight, functions, functionsIn,
  get: get$2, has, hasIn: hasIn$2, invert, invertBy,
  invoke, keys: keys$5, keysIn, mapKeys, mapValues,
  merge, mergeWith, omit, omitBy, pick,
  pickBy, result, set, setWith, toPairs,
  toPairsIn, transform, unset, update, updateWith,
  values: values$2, valuesIn
};

var seq = {
  at: wrapperAt, chain, commit: wrapperCommit, lodash: lodash$1, next: wrapperNext,
  plant: wrapperPlant, reverse: wrapperReverse, tap, thru, toIterator: wrapperToIterator,
  toJSON: wrapperValue, value: wrapperValue, valueOf: wrapperValue, wrapperChain
};

var string$1 = {
  camelCase, capitalize, deburr, endsWith, escape,
  escapeRegExp, kebabCase, lowerCase, lowerFirst, pad,
  padEnd, padStart, parseInt: parseInt$1, repeat, replace,
  snakeCase, split, startCase, startsWith, template,
  templateSettings, toLower, toUpper, trim, trimEnd,
  trimStart, truncate, unescape, upperCase, upperFirst,
  words
};

var util = {
  attempt, bindAll, cond, conforms, constant,
  defaultTo, flow, flowRight, identity: identity$2, iteratee,
  matches, matchesProperty, method, methodOf, mixin: mixin$1,
  noop, nthArg, over, overEvery, overSome,
  property: property$2, propertyOf, range, rangeRight, stubArray: stubArray$2,
  stubFalse: stubFalse$1, stubObject, stubString, stubTrue, times,
  toPath, uniqueId
};

/**
 * Creates a clone of the lazy wrapper object.
 *
 * @private
 * @name clone
 * @memberOf LazyWrapper
 * @returns {Object} Returns the cloned `LazyWrapper` object.
 */
function lazyClone() {
  var result = new LazyWrapper(this.__wrapped__);
  result.__actions__ = copyArray(this.__actions__);
  result.__dir__ = this.__dir__;
  result.__filtered__ = this.__filtered__;
  result.__iteratees__ = copyArray(this.__iteratees__);
  result.__takeCount__ = this.__takeCount__;
  result.__views__ = copyArray(this.__views__);
  return result;
}

/**
 * Reverses the direction of lazy iteration.
 *
 * @private
 * @name reverse
 * @memberOf LazyWrapper
 * @returns {Object} Returns the new reversed `LazyWrapper` object.
 */
function lazyReverse() {
  if (this.__filtered__) {
    var result = new LazyWrapper(this);
    result.__dir__ = -1;
    result.__filtered__ = true;
  } else {
    result = this.clone();
    result.__dir__ *= -1;
  }
  return result;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max,
    nativeMin$2 = Math.min;

/**
 * Gets the view, applying any `transforms` to the `start` and `end` positions.
 *
 * @private
 * @param {number} start The start of the view.
 * @param {number} end The end of the view.
 * @param {Array} transforms The transformations to apply to the view.
 * @returns {Object} Returns an object containing the `start` and `end`
 *  positions of the view.
 */
function getView(start, end, transforms) {
  var index = -1,
      length = transforms.length;

  while (++index < length) {
    var data = transforms[index],
        size = data.size;

    switch (data.type) {
      case 'drop':      start += size; break;
      case 'dropRight': end -= size; break;
      case 'take':      end = nativeMin$2(end, start + size); break;
      case 'takeRight': start = nativeMax$2(start, end - size); break;
    }
  }
  return { 'start': start, 'end': end };
}

/** Used to indicate the type of lazy iteratees. */
var LAZY_FILTER_FLAG$1 = 1,
    LAZY_MAP_FLAG = 2;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin$1 = Math.min;

/**
 * Extracts the unwrapped value from its lazy wrapper.
 *
 * @private
 * @name value
 * @memberOf LazyWrapper
 * @returns {*} Returns the unwrapped value.
 */
function lazyValue() {
  var array = this.__wrapped__.value(),
      dir = this.__dir__,
      isArr = isArray$b(array),
      isRight = dir < 0,
      arrLength = isArr ? array.length : 0,
      view = getView(0, arrLength, this.__views__),
      start = view.start,
      end = view.end,
      length = end - start,
      index = isRight ? end : (start - 1),
      iteratees = this.__iteratees__,
      iterLength = iteratees.length,
      resIndex = 0,
      takeCount = nativeMin$1(length, this.__takeCount__);

  if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
    return baseWrapperValue(array, this.__actions__);
  }
  var result = [];

  outer:
  while (length-- && resIndex < takeCount) {
    index += dir;

    var iterIndex = -1,
        value = array[index];

    while (++iterIndex < iterLength) {
      var data = iteratees[iterIndex],
          iteratee = data.iteratee,
          type = data.type,
          computed = iteratee(value);

      if (type == LAZY_MAP_FLAG) {
        value = computed;
      } else if (!computed) {
        if (type == LAZY_FILTER_FLAG$1) {
          continue outer;
        } else {
          break outer;
        }
      }
    }
    result[resIndex++] = value;
  }
  return result;
}

/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the semantic version number. */
var VERSION = '4.17.21';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_KEY_FLAG = 2;

/** Used to indicate the type of lazy iteratees. */
var LAZY_FILTER_FLAG = 1,
    LAZY_WHILE_FLAG = 3;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype,
    objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/** Built-in value references. */
var symIterator = Symbol$6 ? Symbol$6.iterator : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin = Math.min;

// wrap `_.mixin` so it works when provided only one argument
var mixin = (function(func) {
  return function(object, source, options) {
    if (options == null) {
      var isObj = isObject$5(source),
          props = isObj && keys$5(source),
          methodNames = props && props.length && baseFunctions(source, props);

      if (!(methodNames ? methodNames.length : isObj)) {
        options = source;
        source = object;
        object = this;
      }
    }
    return func(object, source, options);
  };
}(mixin$1));

// Add methods that return wrapped values in chain sequences.
lodash$1.after = func.after;
lodash$1.ary = func.ary;
lodash$1.assign = object.assign;
lodash$1.assignIn = object.assignIn;
lodash$1.assignInWith = object.assignInWith;
lodash$1.assignWith = object.assignWith;
lodash$1.at = object.at;
lodash$1.before = func.before;
lodash$1.bind = func.bind;
lodash$1.bindAll = util.bindAll;
lodash$1.bindKey = func.bindKey;
lodash$1.castArray = lang.castArray;
lodash$1.chain = seq.chain;
lodash$1.chunk = array.chunk;
lodash$1.compact = array.compact;
lodash$1.concat = array.concat;
lodash$1.cond = util.cond;
lodash$1.conforms = util.conforms;
lodash$1.constant = util.constant;
lodash$1.countBy = collection.countBy;
lodash$1.create = object.create;
lodash$1.curry = func.curry;
lodash$1.curryRight = func.curryRight;
lodash$1.debounce = func.debounce;
lodash$1.defaults = object.defaults;
lodash$1.defaultsDeep = object.defaultsDeep;
lodash$1.defer = func.defer;
lodash$1.delay = func.delay;
lodash$1.difference = array.difference;
lodash$1.differenceBy = array.differenceBy;
lodash$1.differenceWith = array.differenceWith;
lodash$1.drop = array.drop;
lodash$1.dropRight = array.dropRight;
lodash$1.dropRightWhile = array.dropRightWhile;
lodash$1.dropWhile = array.dropWhile;
lodash$1.fill = array.fill;
lodash$1.filter = collection.filter;
lodash$1.flatMap = collection.flatMap;
lodash$1.flatMapDeep = collection.flatMapDeep;
lodash$1.flatMapDepth = collection.flatMapDepth;
lodash$1.flatten = array.flatten;
lodash$1.flattenDeep = array.flattenDeep;
lodash$1.flattenDepth = array.flattenDepth;
lodash$1.flip = func.flip;
lodash$1.flow = util.flow;
lodash$1.flowRight = util.flowRight;
lodash$1.fromPairs = array.fromPairs;
lodash$1.functions = object.functions;
lodash$1.functionsIn = object.functionsIn;
lodash$1.groupBy = collection.groupBy;
lodash$1.initial = array.initial;
lodash$1.intersection = array.intersection;
lodash$1.intersectionBy = array.intersectionBy;
lodash$1.intersectionWith = array.intersectionWith;
lodash$1.invert = object.invert;
lodash$1.invertBy = object.invertBy;
lodash$1.invokeMap = collection.invokeMap;
lodash$1.iteratee = util.iteratee;
lodash$1.keyBy = collection.keyBy;
lodash$1.keys = keys$5;
lodash$1.keysIn = object.keysIn;
lodash$1.map = collection.map;
lodash$1.mapKeys = object.mapKeys;
lodash$1.mapValues = object.mapValues;
lodash$1.matches = util.matches;
lodash$1.matchesProperty = util.matchesProperty;
lodash$1.memoize = func.memoize;
lodash$1.merge = object.merge;
lodash$1.mergeWith = object.mergeWith;
lodash$1.method = util.method;
lodash$1.methodOf = util.methodOf;
lodash$1.mixin = mixin;
lodash$1.negate = negate;
lodash$1.nthArg = util.nthArg;
lodash$1.omit = object.omit;
lodash$1.omitBy = object.omitBy;
lodash$1.once = func.once;
lodash$1.orderBy = collection.orderBy;
lodash$1.over = util.over;
lodash$1.overArgs = func.overArgs;
lodash$1.overEvery = util.overEvery;
lodash$1.overSome = util.overSome;
lodash$1.partial = func.partial;
lodash$1.partialRight = func.partialRight;
lodash$1.partition = collection.partition;
lodash$1.pick = object.pick;
lodash$1.pickBy = object.pickBy;
lodash$1.property = util.property;
lodash$1.propertyOf = util.propertyOf;
lodash$1.pull = array.pull;
lodash$1.pullAll = array.pullAll;
lodash$1.pullAllBy = array.pullAllBy;
lodash$1.pullAllWith = array.pullAllWith;
lodash$1.pullAt = array.pullAt;
lodash$1.range = util.range;
lodash$1.rangeRight = util.rangeRight;
lodash$1.rearg = func.rearg;
lodash$1.reject = collection.reject;
lodash$1.remove = array.remove;
lodash$1.rest = func.rest;
lodash$1.reverse = array.reverse;
lodash$1.sampleSize = collection.sampleSize;
lodash$1.set = object.set;
lodash$1.setWith = object.setWith;
lodash$1.shuffle = collection.shuffle;
lodash$1.slice = array.slice;
lodash$1.sortBy = collection.sortBy;
lodash$1.sortedUniq = array.sortedUniq;
lodash$1.sortedUniqBy = array.sortedUniqBy;
lodash$1.split = string$1.split;
lodash$1.spread = func.spread;
lodash$1.tail = array.tail;
lodash$1.take = array.take;
lodash$1.takeRight = array.takeRight;
lodash$1.takeRightWhile = array.takeRightWhile;
lodash$1.takeWhile = array.takeWhile;
lodash$1.tap = seq.tap;
lodash$1.throttle = func.throttle;
lodash$1.thru = thru;
lodash$1.toArray = lang.toArray;
lodash$1.toPairs = object.toPairs;
lodash$1.toPairsIn = object.toPairsIn;
lodash$1.toPath = util.toPath;
lodash$1.toPlainObject = lang.toPlainObject;
lodash$1.transform = object.transform;
lodash$1.unary = func.unary;
lodash$1.union = array.union;
lodash$1.unionBy = array.unionBy;
lodash$1.unionWith = array.unionWith;
lodash$1.uniq = array.uniq;
lodash$1.uniqBy = array.uniqBy;
lodash$1.uniqWith = array.uniqWith;
lodash$1.unset = object.unset;
lodash$1.unzip = array.unzip;
lodash$1.unzipWith = array.unzipWith;
lodash$1.update = object.update;
lodash$1.updateWith = object.updateWith;
lodash$1.values = object.values;
lodash$1.valuesIn = object.valuesIn;
lodash$1.without = array.without;
lodash$1.words = string$1.words;
lodash$1.wrap = func.wrap;
lodash$1.xor = array.xor;
lodash$1.xorBy = array.xorBy;
lodash$1.xorWith = array.xorWith;
lodash$1.zip = array.zip;
lodash$1.zipObject = array.zipObject;
lodash$1.zipObjectDeep = array.zipObjectDeep;
lodash$1.zipWith = array.zipWith;

// Add aliases.
lodash$1.entries = object.toPairs;
lodash$1.entriesIn = object.toPairsIn;
lodash$1.extend = object.assignIn;
lodash$1.extendWith = object.assignInWith;

// Add methods to `lodash.prototype`.
mixin(lodash$1, lodash$1);

// Add methods that return unwrapped values in chain sequences.
lodash$1.add = math.add;
lodash$1.attempt = util.attempt;
lodash$1.camelCase = string$1.camelCase;
lodash$1.capitalize = string$1.capitalize;
lodash$1.ceil = math.ceil;
lodash$1.clamp = number.clamp;
lodash$1.clone = lang.clone;
lodash$1.cloneDeep = lang.cloneDeep;
lodash$1.cloneDeepWith = lang.cloneDeepWith;
lodash$1.cloneWith = lang.cloneWith;
lodash$1.conformsTo = lang.conformsTo;
lodash$1.deburr = string$1.deburr;
lodash$1.defaultTo = util.defaultTo;
lodash$1.divide = math.divide;
lodash$1.endsWith = string$1.endsWith;
lodash$1.eq = lang.eq;
lodash$1.escape = string$1.escape;
lodash$1.escapeRegExp = string$1.escapeRegExp;
lodash$1.every = collection.every;
lodash$1.find = collection.find;
lodash$1.findIndex = array.findIndex;
lodash$1.findKey = object.findKey;
lodash$1.findLast = collection.findLast;
lodash$1.findLastIndex = array.findLastIndex;
lodash$1.findLastKey = object.findLastKey;
lodash$1.floor = math.floor;
lodash$1.forEach = collection.forEach;
lodash$1.forEachRight = collection.forEachRight;
lodash$1.forIn = object.forIn;
lodash$1.forInRight = object.forInRight;
lodash$1.forOwn = object.forOwn;
lodash$1.forOwnRight = object.forOwnRight;
lodash$1.get = object.get;
lodash$1.gt = lang.gt;
lodash$1.gte = lang.gte;
lodash$1.has = object.has;
lodash$1.hasIn = object.hasIn;
lodash$1.head = array.head;
lodash$1.identity = identity$2;
lodash$1.includes = collection.includes;
lodash$1.indexOf = array.indexOf;
lodash$1.inRange = number.inRange;
lodash$1.invoke = object.invoke;
lodash$1.isArguments = lang.isArguments;
lodash$1.isArray = isArray$b;
lodash$1.isArrayBuffer = lang.isArrayBuffer;
lodash$1.isArrayLike = lang.isArrayLike;
lodash$1.isArrayLikeObject = lang.isArrayLikeObject;
lodash$1.isBoolean = lang.isBoolean;
lodash$1.isBuffer = lang.isBuffer;
lodash$1.isDate = lang.isDate;
lodash$1.isElement = lang.isElement;
lodash$1.isEmpty = lang.isEmpty;
lodash$1.isEqual = lang.isEqual;
lodash$1.isEqualWith = lang.isEqualWith;
lodash$1.isError = lang.isError;
lodash$1.isFinite = lang.isFinite;
lodash$1.isFunction = lang.isFunction;
lodash$1.isInteger = lang.isInteger;
lodash$1.isLength = lang.isLength;
lodash$1.isMap = lang.isMap;
lodash$1.isMatch = lang.isMatch;
lodash$1.isMatchWith = lang.isMatchWith;
lodash$1.isNaN = lang.isNaN;
lodash$1.isNative = lang.isNative;
lodash$1.isNil = lang.isNil;
lodash$1.isNull = lang.isNull;
lodash$1.isNumber = lang.isNumber;
lodash$1.isObject = isObject$5;
lodash$1.isObjectLike = lang.isObjectLike;
lodash$1.isPlainObject = lang.isPlainObject;
lodash$1.isRegExp = lang.isRegExp;
lodash$1.isSafeInteger = lang.isSafeInteger;
lodash$1.isSet = lang.isSet;
lodash$1.isString = lang.isString;
lodash$1.isSymbol = lang.isSymbol;
lodash$1.isTypedArray = lang.isTypedArray;
lodash$1.isUndefined = lang.isUndefined;
lodash$1.isWeakMap = lang.isWeakMap;
lodash$1.isWeakSet = lang.isWeakSet;
lodash$1.join = array.join;
lodash$1.kebabCase = string$1.kebabCase;
lodash$1.last = last;
lodash$1.lastIndexOf = array.lastIndexOf;
lodash$1.lowerCase = string$1.lowerCase;
lodash$1.lowerFirst = string$1.lowerFirst;
lodash$1.lt = lang.lt;
lodash$1.lte = lang.lte;
lodash$1.max = math.max;
lodash$1.maxBy = math.maxBy;
lodash$1.mean = math.mean;
lodash$1.meanBy = math.meanBy;
lodash$1.min = math.min;
lodash$1.minBy = math.minBy;
lodash$1.stubArray = util.stubArray;
lodash$1.stubFalse = util.stubFalse;
lodash$1.stubObject = util.stubObject;
lodash$1.stubString = util.stubString;
lodash$1.stubTrue = util.stubTrue;
lodash$1.multiply = math.multiply;
lodash$1.nth = array.nth;
lodash$1.noop = util.noop;
lodash$1.now = date.now;
lodash$1.pad = string$1.pad;
lodash$1.padEnd = string$1.padEnd;
lodash$1.padStart = string$1.padStart;
lodash$1.parseInt = string$1.parseInt;
lodash$1.random = number.random;
lodash$1.reduce = collection.reduce;
lodash$1.reduceRight = collection.reduceRight;
lodash$1.repeat = string$1.repeat;
lodash$1.replace = string$1.replace;
lodash$1.result = object.result;
lodash$1.round = math.round;
lodash$1.sample = collection.sample;
lodash$1.size = collection.size;
lodash$1.snakeCase = string$1.snakeCase;
lodash$1.some = collection.some;
lodash$1.sortedIndex = array.sortedIndex;
lodash$1.sortedIndexBy = array.sortedIndexBy;
lodash$1.sortedIndexOf = array.sortedIndexOf;
lodash$1.sortedLastIndex = array.sortedLastIndex;
lodash$1.sortedLastIndexBy = array.sortedLastIndexBy;
lodash$1.sortedLastIndexOf = array.sortedLastIndexOf;
lodash$1.startCase = string$1.startCase;
lodash$1.startsWith = string$1.startsWith;
lodash$1.subtract = math.subtract;
lodash$1.sum = math.sum;
lodash$1.sumBy = math.sumBy;
lodash$1.template = string$1.template;
lodash$1.times = util.times;
lodash$1.toFinite = lang.toFinite;
lodash$1.toInteger = toInteger$2;
lodash$1.toLength = lang.toLength;
lodash$1.toLower = string$1.toLower;
lodash$1.toNumber = lang.toNumber;
lodash$1.toSafeInteger = lang.toSafeInteger;
lodash$1.toString = lang.toString;
lodash$1.toUpper = string$1.toUpper;
lodash$1.trim = string$1.trim;
lodash$1.trimEnd = string$1.trimEnd;
lodash$1.trimStart = string$1.trimStart;
lodash$1.truncate = string$1.truncate;
lodash$1.unescape = string$1.unescape;
lodash$1.uniqueId = util.uniqueId;
lodash$1.upperCase = string$1.upperCase;
lodash$1.upperFirst = string$1.upperFirst;

// Add aliases.
lodash$1.each = collection.forEach;
lodash$1.eachRight = collection.forEachRight;
lodash$1.first = array.head;

mixin(lodash$1, (function() {
  var source = {};
  baseForOwn$2(lodash$1, function(func, methodName) {
    if (!hasOwnProperty$9.call(lodash$1.prototype, methodName)) {
      source[methodName] = func;
    }
  });
  return source;
}()), { 'chain': false });

/**
 * The semantic version number.
 *
 * @static
 * @memberOf _
 * @type {string}
 */
lodash$1.VERSION = VERSION;
(lodash$1.templateSettings = string$1.templateSettings).imports._ = lodash$1;

// Assign default placeholders.
arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
  lodash$1[methodName].placeholder = lodash$1;
});

// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
arrayEach(['drop', 'take'], function(methodName, index) {
  LazyWrapper.prototype[methodName] = function(n) {
    n = n === undefined ? 1 : nativeMax$1(toInteger$2(n), 0);

    var result = (this.__filtered__ && !index)
      ? new LazyWrapper(this)
      : this.clone();

    if (result.__filtered__) {
      result.__takeCount__ = nativeMin(n, result.__takeCount__);
    } else {
      result.__views__.push({
        'size': nativeMin(n, MAX_ARRAY_LENGTH),
        'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
      });
    }
    return result;
  };

  LazyWrapper.prototype[methodName + 'Right'] = function(n) {
    return this.reverse()[methodName](n).reverse();
  };
});

// Add `LazyWrapper` methods that accept an `iteratee` value.
arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
  var type = index + 1,
      isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

  LazyWrapper.prototype[methodName] = function(iteratee) {
    var result = this.clone();
    result.__iteratees__.push({
      'iteratee': baseIteratee$2(iteratee),
      'type': type
    });
    result.__filtered__ = result.__filtered__ || isFilter;
    return result;
  };
});

// Add `LazyWrapper` methods for `_.head` and `_.last`.
arrayEach(['head', 'last'], function(methodName, index) {
  var takeName = 'take' + (index ? 'Right' : '');

  LazyWrapper.prototype[methodName] = function() {
    return this[takeName](1).value()[0];
  };
});

// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
arrayEach(['initial', 'tail'], function(methodName, index) {
  var dropName = 'drop' + (index ? '' : 'Right');

  LazyWrapper.prototype[methodName] = function() {
    return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
  };
});

LazyWrapper.prototype.compact = function() {
  return this.filter(identity$2);
};

LazyWrapper.prototype.find = function(predicate) {
  return this.filter(predicate).head();
};

LazyWrapper.prototype.findLast = function(predicate) {
  return this.reverse().find(predicate);
};

LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
  if (typeof path == 'function') {
    return new LazyWrapper(this);
  }
  return this.map(function(value) {
    return baseInvoke(value, path, args);
  });
});

LazyWrapper.prototype.reject = function(predicate) {
  return this.filter(negate(baseIteratee$2(predicate)));
};

LazyWrapper.prototype.slice = function(start, end) {
  start = toInteger$2(start);

  var result = this;
  if (result.__filtered__ && (start > 0 || end < 0)) {
    return new LazyWrapper(result);
  }
  if (start < 0) {
    result = result.takeRight(-start);
  } else if (start) {
    result = result.drop(start);
  }
  if (end !== undefined) {
    end = toInteger$2(end);
    result = end < 0 ? result.dropRight(-end) : result.take(end - start);
  }
  return result;
};

LazyWrapper.prototype.takeRightWhile = function(predicate) {
  return this.reverse().takeWhile(predicate).reverse();
};

LazyWrapper.prototype.toArray = function() {
  return this.take(MAX_ARRAY_LENGTH);
};

// Add `LazyWrapper` methods to `lodash.prototype`.
baseForOwn$2(LazyWrapper.prototype, function(func, methodName) {
  var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
      isTaker = /^(?:head|last)$/.test(methodName),
      lodashFunc = lodash$1[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
      retUnwrapped = isTaker || /^find/.test(methodName);

  if (!lodashFunc) {
    return;
  }
  lodash$1.prototype[methodName] = function() {
    var value = this.__wrapped__,
        args = isTaker ? [1] : arguments,
        isLazy = value instanceof LazyWrapper,
        iteratee = args[0],
        useLazy = isLazy || isArray$b(value);

    var interceptor = function(value) {
      var result = lodashFunc.apply(lodash$1, arrayPush$2([value], args));
      return (isTaker && chainAll) ? result[0] : result;
    };

    if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
      // Avoid lazy use if the iteratee has a "length" value other than `1`.
      isLazy = useLazy = false;
    }
    var chainAll = this.__chain__,
        isHybrid = !!this.__actions__.length,
        isUnwrapped = retUnwrapped && !chainAll,
        onlyLazy = isLazy && !isHybrid;

    if (!retUnwrapped && useLazy) {
      value = onlyLazy ? value : new LazyWrapper(this);
      var result = func.apply(value, args);
      result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
      return new LodashWrapper(result, chainAll);
    }
    if (isUnwrapped && onlyLazy) {
      return func.apply(this, args);
    }
    result = this.thru(interceptor);
    return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
  };
});

// Add `Array` methods to `lodash.prototype`.
arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
  var func = arrayProto$1[methodName],
      chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
      retUnwrapped = /^(?:pop|shift)$/.test(methodName);

  lodash$1.prototype[methodName] = function() {
    var args = arguments;
    if (retUnwrapped && !this.__chain__) {
      var value = this.value();
      return func.apply(isArray$b(value) ? value : [], args);
    }
    return this[chainName](function(value) {
      return func.apply(isArray$b(value) ? value : [], args);
    });
  };
});

// Map minified method names to their real names.
baseForOwn$2(LazyWrapper.prototype, function(func, methodName) {
  var lodashFunc = lodash$1[methodName];
  if (lodashFunc) {
    var key = lodashFunc.name + '';
    if (!hasOwnProperty$9.call(realNames, key)) {
      realNames[key] = [];
    }
    realNames[key].push({ 'name': methodName, 'func': lodashFunc });
  }
});

realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
  'name': 'wrapper',
  'func': undefined
}];

// Add methods to `LazyWrapper`.
LazyWrapper.prototype.clone = lazyClone;
LazyWrapper.prototype.reverse = lazyReverse;
LazyWrapper.prototype.value = lazyValue;

// Add chain sequence methods to the `lodash` wrapper.
lodash$1.prototype.at = seq.at;
lodash$1.prototype.chain = seq.wrapperChain;
lodash$1.prototype.commit = seq.commit;
lodash$1.prototype.next = seq.next;
lodash$1.prototype.plant = seq.plant;
lodash$1.prototype.reverse = seq.reverse;
lodash$1.prototype.toJSON = lodash$1.prototype.valueOf = lodash$1.prototype.value = seq.value;

// Add lazy aliases.
lodash$1.prototype.first = lodash$1.prototype.head;

if (symIterator) {
  lodash$1.prototype[symIterator] = seq.toIterator;
}

/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

var lodash = /*#__PURE__*/Object.freeze({
	__proto__: null,
	add: add,
	after: after,
	ary: ary,
	assign: assign,
	assignIn: assignIn,
	assignInWith: assignInWith,
	assignWith: assignWith,
	at: at,
	attempt: attempt,
	before: before,
	bind: bind,
	bindAll: bindAll,
	bindKey: bindKey,
	camelCase: camelCase,
	capitalize: capitalize,
	castArray: castArray,
	ceil: ceil,
	chain: chain,
	chunk: chunk,
	clamp: clamp,
	clone: clone,
	cloneDeep: cloneDeep,
	cloneDeepWith: cloneDeepWith,
	cloneWith: cloneWith,
	commit: wrapperCommit,
	compact: compact,
	concat: concat,
	cond: cond,
	conforms: conforms,
	conformsTo: conformsTo,
	constant: constant,
	countBy: countBy,
	create: create,
	curry: curry,
	curryRight: curryRight,
	debounce: debounce,
	deburr: deburr,
	defaultTo: defaultTo,
	defaults: defaults$2,
	defaultsDeep: defaultsDeep,
	defer: defer,
	delay: delay,
	difference: difference,
	differenceBy: differenceBy,
	differenceWith: differenceWith,
	divide: divide,
	drop: drop,
	dropRight: dropRight,
	dropRightWhile: dropRightWhile,
	dropWhile: dropWhile,
	each: forEach,
	eachRight: forEachRight,
	endsWith: endsWith,
	entries: toPairs,
	entriesIn: toPairsIn,
	eq: eq$3,
	escape: escape,
	escapeRegExp: escapeRegExp,
	every: every,
	extend: assignIn,
	extendWith: assignInWith,
	fill: fill,
	filter: filter$1,
	find: find,
	findIndex: findIndex,
	findKey: findKey,
	findLast: findLast,
	findLastIndex: findLastIndex,
	findLastKey: findLastKey,
	first: head,
	flatMap: flatMap,
	flatMapDeep: flatMapDeep,
	flatMapDepth: flatMapDepth,
	flatten: flatten,
	flattenDeep: flattenDeep,
	flattenDepth: flattenDepth,
	flip: flip,
	floor: floor,
	flow: flow,
	flowRight: flowRight,
	forEach: forEach,
	forEachRight: forEachRight,
	forIn: forIn,
	forInRight: forInRight,
	forOwn: forOwn,
	forOwnRight: forOwnRight,
	fromPairs: fromPairs,
	functions: functions,
	functionsIn: functionsIn,
	get: get$2,
	groupBy: groupBy,
	gt: gt,
	gte: gte,
	has: has,
	hasIn: hasIn$2,
	head: head,
	identity: identity$2,
	inRange: inRange$1,
	includes: includes$1,
	indexOf: indexOf,
	initial: initial,
	intersection: intersection,
	intersectionBy: intersectionBy,
	intersectionWith: intersectionWith,
	invert: invert,
	invertBy: invertBy,
	invoke: invoke,
	invokeMap: invokeMap,
	isArguments: isArguments$3,
	isArray: isArray$b,
	isArrayBuffer: isArrayBuffer,
	isArrayLike: isArrayLike$4,
	isArrayLikeObject: isArrayLikeObject,
	isBoolean: isBoolean,
	isBuffer: isBuffer$3,
	isDate: isDate,
	isElement: isElement,
	isEmpty: isEmpty,
	isEqual: isEqual,
	isEqualWith: isEqualWith,
	isError: isError,
	isFinite: isFinite,
	isFunction: isFunction$3,
	isInteger: isInteger,
	isLength: isLength$4,
	isMap: isMap,
	isMatch: isMatch,
	isMatchWith: isMatchWith,
	isNaN: isNaN$1,
	isNative: isNative,
	isNil: isNil,
	isNull: isNull,
	isNumber: isNumber,
	isObject: isObject$5,
	isObjectLike: isObjectLike$7,
	isPlainObject: isPlainObject,
	isRegExp: isRegExp,
	isSafeInteger: isSafeInteger,
	isSet: isSet,
	isString: isString$2,
	isSymbol: isSymbol$5,
	isTypedArray: isTypedArray$3,
	isUndefined: isUndefined,
	isWeakMap: isWeakMap,
	isWeakSet: isWeakSet,
	iteratee: iteratee,
	join: join,
	kebabCase: kebabCase,
	keyBy: keyBy,
	keys: keys$5,
	keysIn: keysIn,
	last: last,
	lastIndexOf: lastIndexOf,
	lodash: lodash$1,
	lowerCase: lowerCase,
	lowerFirst: lowerFirst,
	lt: lt,
	lte: lte,
	map: map,
	mapKeys: mapKeys,
	mapValues: mapValues,
	matches: matches,
	matchesProperty: matchesProperty,
	max: max,
	maxBy: maxBy,
	mean: mean,
	meanBy: meanBy,
	memoize: memoize$2,
	merge: merge,
	mergeWith: mergeWith,
	method: method,
	methodOf: methodOf,
	min: min,
	minBy: minBy,
	mixin: mixin$1,
	multiply: multiply,
	negate: negate,
	next: wrapperNext,
	noop: noop,
	now: now,
	nth: nth,
	nthArg: nthArg,
	omit: omit,
	omitBy: omitBy,
	once: once,
	orderBy: orderBy,
	over: over,
	overArgs: overArgs,
	overEvery: overEvery,
	overSome: overSome,
	pad: pad,
	padEnd: padEnd,
	padStart: padStart,
	parseInt: parseInt$1,
	partial: partial,
	partialRight: partialRight,
	partition: partition,
	pick: pick,
	pickBy: pickBy,
	plant: wrapperPlant,
	property: property$2,
	propertyOf: propertyOf,
	pull: pull,
	pullAll: pullAll,
	pullAllBy: pullAllBy,
	pullAllWith: pullAllWith,
	pullAt: pullAt,
	random: random,
	range: range,
	rangeRight: rangeRight,
	rearg: rearg,
	reduce: reduce,
	reduceRight: reduceRight,
	reject: reject,
	remove: remove,
	repeat: repeat,
	replace: replace,
	rest: rest,
	result: result,
	reverse: reverse,
	round: round,
	sample: sample,
	sampleSize: sampleSize,
	set: set,
	setWith: setWith,
	shuffle: shuffle,
	size: size,
	slice: slice,
	snakeCase: snakeCase,
	some: some,
	sortBy: sortBy,
	sortedIndex: sortedIndex,
	sortedIndexBy: sortedIndexBy,
	sortedIndexOf: sortedIndexOf,
	sortedLastIndex: sortedLastIndex,
	sortedLastIndexBy: sortedLastIndexBy,
	sortedLastIndexOf: sortedLastIndexOf,
	sortedUniq: sortedUniq,
	sortedUniqBy: sortedUniqBy,
	split: split,
	spread: spread,
	startCase: startCase,
	startsWith: startsWith,
	stubArray: stubArray$2,
	stubFalse: stubFalse$1,
	stubObject: stubObject,
	stubString: stubString,
	stubTrue: stubTrue,
	subtract: subtract,
	sum: sum,
	sumBy: sumBy,
	tail: tail,
	take: take,
	takeRight: takeRight,
	takeRightWhile: takeRightWhile,
	takeWhile: takeWhile,
	tap: tap,
	template: template,
	templateSettings: templateSettings,
	throttle: throttle,
	thru: thru,
	times: times,
	toArray: toArray,
	toFinite: toFinite$2,
	toInteger: toInteger$2,
	toIterator: wrapperToIterator,
	toJSON: wrapperValue,
	toLength: toLength,
	toLower: toLower,
	toNumber: toNumber$2,
	toPairs: toPairs,
	toPairsIn: toPairsIn,
	toPath: toPath,
	toPlainObject: toPlainObject,
	toSafeInteger: toSafeInteger,
	toString: toString$2,
	toUpper: toUpper,
	transform: transform,
	trim: trim,
	trimEnd: trimEnd,
	trimStart: trimStart,
	truncate: truncate,
	unary: unary,
	unescape: unescape,
	union: union,
	unionBy: unionBy,
	unionWith: unionWith,
	uniq: uniq,
	uniqBy: uniqBy,
	uniqWith: uniqWith,
	uniqueId: uniqueId,
	unset: unset,
	unzip: unzip,
	unzipWith: unzipWith,
	update: update,
	updateWith: updateWith,
	upperCase: upperCase,
	upperFirst: upperFirst,
	value: wrapperValue,
	valueOf: wrapperValue,
	values: values$2,
	valuesIn: valuesIn,
	without: without,
	words: words,
	wrap: wrap,
	wrapperAt: wrapperAt,
	wrapperChain: wrapperChain,
	wrapperCommit: wrapperCommit,
	wrapperLodash: lodash$1,
	wrapperNext: wrapperNext,
	wrapperPlant: wrapperPlant,
	wrapperReverse: wrapperReverse,
	wrapperToIterator: wrapperToIterator,
	wrapperValue: wrapperValue,
	xor: xor,
	xorBy: xorBy,
	xorWith: xorWith,
	zip: zip,
	zipObject: zipObject,
	zipObjectDeep: zipObjectDeep,
	zipWith: zipWith,
	'default': lodash$1
});

var require$$1$1 = /*@__PURE__*/getAugmentedNamespace(lodash);

var loglevel = {exports: {}};

/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/

(function (module) {
(function (root, definition) {
    if (module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
}(commonjsGlobal, function () {

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = (typeof window !== undefinedType) && (typeof window.navigator !== undefinedType) && (
        /Trident\/|MSIE /.test(window.navigator.userAgent)
    );

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) {
                console.log.apply(console, arguments);
            } else {
                // In old IE, native console methods themselves don't have apply().
                Function.prototype.apply.apply(console.log, [console, arguments]);
            }
        }
        if (console.trace) console.trace();
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (methodName === 'trace' && isIE) {
            return traceForIE;
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;

      var storageKey = "loglevel";
      if (typeof name === "string") {
        storageKey += ":" + name;
      } else if (typeof name === "symbol") {
        storageKey = undefined;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType || !storageKey) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType || !storageKey) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location !== -1) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.name = name;

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if ((typeof name !== "symbol" && typeof name !== "string") || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    // ES6 default export, for compatibility
    defaultLogger['default'] = defaultLogger;

    return defaultLogger;
}));
}(loglevel));

var assessments$1 = {};

var fleschReadingEaseAssessment = {};

var assessment = {};

Object.defineProperty(assessment, "__esModule", {
	value: true
});
/* eslint-disable no-unused-vars */
/**
 * Represents the defaults of an assessment.
 */
class Assessment {
	/**
  * Executes the assessment and return its result.
  *
  * @param {Paper} paper The paper to run this assessment on.
  * @param {Researcher} researcher The researcher used for the assessment.
  * @param {object} i18n The i18n-object used for parsing translations.
  *
  * @returns {AssessmentResult} The result of the assessment.
  */
	getResult(paper, researcher, i18n) {
		throw "The method getResult is not implemented";
	}

	/**
  * Checks whether the assessment is applicable
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True.
  */
	isApplicable(paper) {
		return true;
	}
}

/* eslint-enable no-unused-vars */

assessment.default = Assessment;

var getLanguageAvailability = {};

var getLanguage = {};

Object.defineProperty(getLanguage, "__esModule", {
  value: true
});

getLanguage.default = function (locale) {
  return locale.split("_")[0];
};

Object.defineProperty(getLanguageAvailability, "__esModule", {
  value: true
});

getLanguageAvailability.default = function (locale, languages) {
  var language = (0, _getLanguage2$l.default)(locale);
  return (0, _lodashEs$1Y.indexOf)(languages, language) > -1;
};

var _lodashEs$1Y = require$$1$1;

var _getLanguage$l = getLanguage;

var _getLanguage2$l = _interopRequireDefault$3i(_getLanguage$l);

function _interopRequireDefault$3i(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shortlinker = {};

var singleton = {};

var Shortlinker$1 = {};

Object.defineProperty(Shortlinker$1, "__esModule", {
	value: true
});

var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Shortlinker to handle appending parameters to a link.
 */
class Shortlinker {
	/**
  * Initialize the Shortlinker class.
  *
  * @param {Object} [config={}] Optional configuration.
  */
	constructor(config = {}) {
		this.configure(config);
	}

	/**
  * Saves the passed configuration.
  *
  * @param {Object} config             The configuration.
  * @param {Object} [config.params={}] The default params to create the query string with.
  *
  * @returns {void}
  */
	configure(config) {
		this._config = _extends$3({
			params: {}
		}, config);
	}

	/**
  * Creates a query string from a params object.
  *
  * @param {Object} params Params for in the query string.
  *
  * @returns {string} URI encoded query string.
  */
	static createQueryString(params) {
		return Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join("&");
	}

	/**
  * Creates a link by combining the params from the config and appending them to the url.
  *
  * @param {string} url         The base url.
  * @param {Object} [params={}] Optional params for in the url.
  *
  * @returns {string} The url with query string.
  */
	append(url, params = {}) {
		let link = encodeURI(url);
		const queryString = Shortlinker.createQueryString(_extends$3({}, this._config.params, params));

		if (queryString !== "") {
			link += "?" + queryString;
		}

		return link;
	}

	/**
  * Creates an anchor opening tag; uses the append function to create the url.
  *
  * @param {string} url         The base url.
  * @param {Object} [params={}] Optional params for in the url.
  *
  * @returns {string} The anchor opening tag.
  */
	createAnchorOpeningTag(url, params = {}) {
		return `<a href='${this.append(url, params)}' target='_blank'>`;
	}
}
Shortlinker$1.default = Shortlinker;

Object.defineProperty(singleton, "__esModule", {
  value: true
});
singleton.configureShortlinker = configureShortlinker;
singleton.createShortlink = createShortlink;
singleton.createAnchorOpeningTag = createAnchorOpeningTag;

var _Shortlinker = Shortlinker$1;

var _Shortlinker2 = _interopRequireDefault$3h(_Shortlinker);

function _interopRequireDefault$3h(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Set global scope.
let globalScope;

// In the browser, window exists so that is the global scope.
if (typeof window === "undefined") {
  // Inside a web worker, self exists so that is the global scope.
  if (typeof self === "undefined") {
    // Fall back tot the `global`, because that is the global scope in Node.JS.
    globalScope = commonjsGlobal;
  } else {
    globalScope = self;
  }
} else {
  globalScope = window;
}

globalScope.yoast = globalScope.yoast || {};
globalScope.yoast.shortlinker = null;

/**
 * Retrieves the Shortlinker instance.
 *
 * @returns {Shortlinker} The Shortlinker.
 */
function getShortlinker() {
  if (globalScope.yoast.shortlinker === null) {
    globalScope.yoast.shortlinker = new _Shortlinker2.default();
  }
  return globalScope.yoast.shortlinker;
}

/**
 * Configures the Shortlinker instance.
 *
 * @param {Object} config             The configuration.
 * @param {Object} [config.params={}] The default params for in the url.
 *
 * @returns {void}
 */
function configureShortlinker(config) {
  getShortlinker().configure(config);
}

/**
 * Creates a link by combining the params from the config and appending them to the url.
 *
 * @param {string} url         The url.
 * @param {Object} [params={}] Optional extra params for in the url.
 *
 * @returns {string} The url with query string.
 */
function createShortlink(url, params = {}) {
  return getShortlinker().append(url, params);
}

/**
 * Creates an anchor opening tag.
 *
 * @param {string} url         The url.
 * @param {Object} [params={}] Optional extra params for in the url.
 *
 * @returns {string} The anchor opening tag.
 */
function createAnchorOpeningTag(url, params = {}) {
  return getShortlinker().createAnchorOpeningTag(url, params);
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _singleton = singleton;

Object.keys(_singleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _singleton[key];
    }
  });
});

}(shortlinker));

var AssessmentResult$1 = {};

var Mark$1 = {};

Object.defineProperty(Mark$1, "__esModule", {
  value: true
});

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodashEs$1X = require$$1$1;

/**
 * Represents a marked piece of text
 *
 * @param {Object} properties The properties of this Mark.
 * @param {string} properties.original The original text that should be marked.
 * @param {string} properties.marked The new text including marks.
 * @constructor
 */
function Mark(properties) {
  (0, _lodashEs$1X.defaults)(properties, { original: "", marked: "" });
  this._properties = properties;
}

/**
 * Returns the original text
 *
 * @returns {string} The original text.
 */
Mark.prototype.getOriginal = function () {
  return this._properties.original;
};

/**
 * Returns the marked text
 *
 * @returns {string} The replaced text.
 */
Mark.prototype.getMarked = function () {
  return this._properties.marked;
};

/**
 * Applies this mark to the given text
 *
 * @param {string} text The original text without the mark applied.
 * @returns {string} The A new text with the mark applied to it.
 */
Mark.prototype.applyWithReplace = function (text) {
  // Cute method to replace everything in a string without using regex.
  return text.split(this._properties.original).join(this._properties.marked);
};

/**
 * Serializes the Mark instance to an object.
 *
 * @returns {Object} The serialized Mark.
 */
Mark.prototype.serialize = function () {
  return _extends$2({
    _parseClass: "Mark"
  }, this._properties);
};

/**
 * Parses the object to a Mark.
 *
 * @param {Object} serialized The serialized object.
 *
 * @returns {Mark} The parsed Mark.
 */
Mark.parse = function (serialized) {
  delete serialized._parseClass;
  return new Mark(serialized);
};

Mark$1.default = Mark;

Object.defineProperty(AssessmentResult$1, "__esModule", {
  value: true
});

var _lodashEs$1W = require$$1$1;

var _Mark$a = Mark$1;

var _Mark2$a = _interopRequireDefault$3g(_Mark$a);

function _interopRequireDefault$3g(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A function that only returns an empty that can be used as an empty marker
 *
 * @returns {Array} A list of empty marks.
 */
var emptyMarker = function emptyMarker() {
  return [];
};

/**
 * Construct the AssessmentResult value object.
 *
 * @param {Object} [values] The values for this assessment result.
 *
 * @constructor
 */
var AssessmentResult = function AssessmentResult(values) {
  this._hasScore = false;
  this._identifier = "";
  this._hasMarks = false;
  this._marker = emptyMarker;
  this.score = 0;
  this.text = "";
  this.marks = [];

  if ((0, _lodashEs$1W.isUndefined)(values)) {
    values = {};
  }

  if (!(0, _lodashEs$1W.isUndefined)(values.score)) {
    this.setScore(values.score);
  }

  if (!(0, _lodashEs$1W.isUndefined)(values.text)) {
    this.setText(values.text);
  }

  if (!(0, _lodashEs$1W.isUndefined)(values.marks)) {
    this.setMarks(values.marks);
  }
};

/**
 * Check if a score is available.
 * @returns {boolean} Whether or not a score is available.
 */
AssessmentResult.prototype.hasScore = function () {
  return this._hasScore;
};

/**
 * Get the available score
 * @returns {number} The score associated with the AssessmentResult.
 */
AssessmentResult.prototype.getScore = function () {
  return this.score;
};

/**
 * Set the score for the assessment.
 * @param {number} score The score to be used for the score property
 * @returns {void}
 */
AssessmentResult.prototype.setScore = function (score) {
  if ((0, _lodashEs$1W.isNumber)(score)) {
    this.score = score;
    this._hasScore = true;
  }
};

/**
 * Check if a text is available.
 * @returns {boolean} Whether or not a text is available.
 */
AssessmentResult.prototype.hasText = function () {
  return this.text !== "";
};

/**
 * Get the available text
 * @returns {string} The text associated with the AssessmentResult.
 */
AssessmentResult.prototype.getText = function () {
  return this.text;
};

/**
 * Set the text for the assessment.
 * @param {string} text The text to be used for the text property
 * @returns {void}
 */
AssessmentResult.prototype.setText = function (text) {
  if ((0, _lodashEs$1W.isUndefined)(text)) {
    text = "";
  }

  this.text = text;
};

/**
 * Gets the available marks.
 *
 * @returns {array} The marks associated with the AssessmentResult.
 */
AssessmentResult.prototype.getMarks = function () {
  return this.marks;
};

/**
 * Sets the marks for the assessment.
 *
 * @param {array} marks The marks to be used for the marks property
 *
 * @returns {void}
 */
AssessmentResult.prototype.setMarks = function (marks) {
  if ((0, _lodashEs$1W.isArray)(marks)) {
    this.marks = marks;
    this._hasMarks = marks.length > 0;
  }
};

/**
 * Sets the identifier
 *
 * @param {string} identifier An alphanumeric identifier for this result.
 * @returns {void}
 */
AssessmentResult.prototype.setIdentifier = function (identifier) {
  this._identifier = identifier;
};

/**
 * Gets the identifier
 *
 * @returns {string} An alphanumeric identifier for this result.
 */
AssessmentResult.prototype.getIdentifier = function () {
  return this._identifier;
};

/**
 * Sets the marker, a pure function that can return the marks for a given Paper
 *
 * @param {Function} marker The marker to set.
 * @returns {void}
 */
AssessmentResult.prototype.setMarker = function (marker) {
  this._marker = marker;
};

/**
 * Returns whether or not this result has a marker that can be used to mark for a given Paper
 *
 * @returns {boolean} Whether or this result has a marker.
 */
AssessmentResult.prototype.hasMarker = function () {
  return this._hasMarks && this._marker !== this.emptyMarker;
};

/**
 * Gets the marker, a pure function that can return the marks for a given Paper
 *
 * @returns {Function} The marker.
 */
AssessmentResult.prototype.getMarker = function () {
  return this._marker;
};

/**
 * Sets the value of _hasMarks to determine if there is something to mark.
 *
 * @param {boolean} hasMarks Is there something to mark.
 * @returns {void}
 */
AssessmentResult.prototype.setHasMarks = function (hasMarks) {
  this._hasMarks = hasMarks;
};

/**
 * Returns the value of _hasMarks to determine if there is something to mark.
 *
 * @returns {boolean} Is there something to mark.
 */
AssessmentResult.prototype.hasMarks = function () {
  return this._hasMarks;
};

/**
 * Serializes the AssessmentResult instance to an object.
 *
 * @returns {Object} The serialized AssessmentResult.
 */
AssessmentResult.prototype.serialize = function () {
  return {
    _parseClass: "AssessmentResult",
    identifier: this._identifier,
    score: this.score,
    text: this.text,
    marks: this.marks.map(mark => mark.serialize())
  };
};

/**
 * Parses the object to an AssessmentResult.
 *
 * @param {Object} serialized The serialized object.
 *
 * @returns {AssessmentResult} The parsed AssessmentResult.
 */
AssessmentResult.parse = function (serialized) {
  const result = new AssessmentResult({
    text: serialized.text,
    score: serialized.score,
    marks: serialized.marks.map(mark => _Mark2$a.default.parse(mark))
  });
  result.setIdentifier(serialized.identifier);

  return result;
};

AssessmentResult$1.default = AssessmentResult;

Object.defineProperty(fleschReadingEaseAssessment, "__esModule", {
	value: true
});

var _lodashEs$1V = require$$1$1;

var _assessment$l = assessment;

var _assessment2$l = _interopRequireDefault$3f(_assessment$l);

var _getLanguageAvailability$5 = getLanguageAvailability;

var _getLanguageAvailability2$5 = _interopRequireDefault$3f(_getLanguageAvailability$5);

var _shortlinker$x = shortlinker;

var _AssessmentResult$y = AssessmentResult$1;

var _AssessmentResult2$y = _interopRequireDefault$3f(_AssessmentResult$y);

function _interopRequireDefault$3f(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const availableLanguages$5 = ["en", "nl", "de", "it", "ru", "fr", "es", "pt"];

/**
 * Assessment to check how readable the text is, based on the Flesch reading ease test.
 */
class FleschReadingEaseAssessment extends _assessment2$l.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} config The configuration to use.
  * @returns {void}
  */
	constructor(config) {
		super();

		const defaultConfig = {
			urlTitle: (0, _shortlinker$x.createAnchorOpeningTag)("https://yoa.st/34r"),
			urlCallToAction: (0, _shortlinker$x.createAnchorOpeningTag)("https://yoa.st/34s")
		};

		this.identifier = "fleschReadingEase";
		this._config = (0, _lodashEs$1V.merge)(defaultConfig, config);
	}

	/**
  * The assessment that runs the FleschReading on the paper.
  *
  * @param {Object} paper The paper to run this assessment on.
  * @param {Object} researcher The researcher used for the assessment.
  * @param {Object} i18n The i18n-object used for parsing translations.
  *
  * @returns {Object} An assessmentResult with the score and formatted text.
  */
	getResult(paper, researcher, i18n) {
		this.fleschReadingResult = researcher.getResearch("calculateFleschReading");
		if (this.isApplicable(paper)) {
			const assessmentResult = new _AssessmentResult2$y.default(i18n);
			const calculatedResult = this.calculateResult(i18n);
			assessmentResult.setScore(calculatedResult.score);
			assessmentResult.setText(calculatedResult.resultText);

			return assessmentResult;
		}
		return null;
	}

	/**
  * Calculates the assessment result based on the fleschReadingScore.
  *
  * @param {Object} i18n The i18n-object used for parsing translations.
  *
  * @returns {Object} Object with score and resultText.
  */
	calculateResult(i18n) {
		// Results must be between 0 and 100;
		if (this.fleschReadingResult < 0) {
			this.fleschReadingResult = 0;
		}

		if (this.fleschReadingResult > 100) {
			this.fleschReadingResult = 100;
		}

		let score = 0;
		let feedback = "";
		let note = i18n.dgettext("js-text-analysis", "Good job!");

		if (this.fleschReadingResult >= this._config.borders.veryEasy) {
			score = this._config.scores.veryEasy;
			feedback = i18n.dgettext("js-text-analysis", "very easy");
		} else if ((0, _lodashEs$1V.inRange)(this.fleschReadingResult, this._config.borders.easy, this._config.borders.veryEasy)) {
			score = this._config.scores.easy;
			feedback = i18n.dgettext("js-text-analysis", "easy");
		} else if ((0, _lodashEs$1V.inRange)(this.fleschReadingResult, this._config.borders.fairlyEasy, this._config.borders.easy)) {
			score = this._config.scores.fairlyEasy;
			feedback = i18n.dgettext("js-text-analysis", "fairly easy");
		} else if ((0, _lodashEs$1V.inRange)(this.fleschReadingResult, this._config.borders.okay, this._config.borders.fairlyEasy)) {
			score = this._config.scores.okay;
			feedback = i18n.dgettext("js-text-analysis", "ok");
		} else if ((0, _lodashEs$1V.inRange)(this.fleschReadingResult, this._config.borders.fairlyDifficult, this._config.borders.okay)) {
			score = this._config.scores.fairlyDifficult;
			feedback = i18n.dgettext("js-text-analysis", "fairly difficult");
			note = i18n.dgettext("js-text-analysis", "Try to make shorter sentences to improve readability");
		} else if ((0, _lodashEs$1V.inRange)(this.fleschReadingResult, this._config.borders.difficult, this._config.borders.fairlyDifficult)) {
			score = this._config.scores.difficult;
			feedback = i18n.dgettext("js-text-analysis", "difficult");
			note = i18n.dgettext("js-text-analysis", "Try to make shorter sentences, using less difficult words to improve readability");
		} else {
			score = this._config.scores.veryDifficult;
			feedback = i18n.dgettext("js-text-analysis", "very difficult");
			note = i18n.dgettext("js-text-analysis", "Try to make shorter sentences, using less difficult words to improve readability");
		}

		// If the score is good, add a "Good job" message without a link to the Call-to-action article.
		if (score >= this._config.scores.okay) {
			return {
				score: score,
				resultText: i18n.sprintf(
				/* Translators: %1$s expands to a link on yoast.com,
    	%2$s to the anchor end tag,
    	%3$s expands to the numeric Flesch reading ease score,
    	%4$s to the easiness of reading,
    	%5$s expands to a call to action based on the score */
				i18n.dgettext("js-text-analysis", "%1$sFlesch Reading Ease%2$s: The copy scores %3$s in the test, which is considered %4$s to read. %5$s"), this._config.urlTitle, "</a>", this.fleschReadingResult, feedback, note)
			};
		}
		// If the score is not good, add a Call-to-action message with a link to the Call-to-action article.
		return {
			score: score,
			resultText: i18n.sprintf(
			/* Translators: %1$s and %5$s expand to a link on yoast.com,
   	%2$s to the anchor end tag,
   	%7$s expands to the anchor end tag and a full stop,
   	%3$s expands to the numeric Flesch reading ease score,
   	%4$s to the easiness of reading,
   	%6$s expands to a call to action based on the score */
			i18n.dgettext("js-text-analysis", "%1$sFlesch Reading Ease%2$s: The copy scores %3$s in the test, which is considered %4$s to read. %5$s%6$s%7$s"), this._config.urlTitle, "</a>", this.fleschReadingResult, feedback, this._config.urlCallToAction, note, "</a>.")
		};
	}

	/**
  * Checks if Flesch reading analysis is available for the language of the paper.
  *
  * @param {Object} paper The paper to have the Flesch score to be calculated for.
  * @returns {boolean} Returns true if the language is available and the paper is not empty.
  */
	isApplicable(paper) {
		const isLanguageAvailable = (0, _getLanguageAvailability2$5.default)(paper.getLocale(), availableLanguages$5);
		return isLanguageAvailable && paper.hasText();
	}
}

fleschReadingEaseAssessment.default = FleschReadingEaseAssessment;

var paragraphTooLongAssessment = {};

var inRange = {};

Object.defineProperty(inRange, "__esModule", {
  value: true
});
/**
 * Checks if `n` is between `start` and `end` but not including `start`.
 *
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function inRangeEndInclusive(number, start, end) {
  return number > start && number <= end;
}

/**
 * Checks if `n` is between `start` and up to, but not including, `end`.
 *
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function inRangeStartInclusive(number, start, end) {
  return number >= start && number < end;
}

/**
 * Checks if `n` is between `start` and `end`, including both.
 *
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function inRangeStartEndInclusive(number, start, end) {
  return number >= start && number <= end;
}

inRange.inRange = inRangeEndInclusive;
inRange.inRangeStartInclusive = inRangeStartInclusive;
inRange.inRangeEndInclusive = inRangeEndInclusive;
inRange.inRangeStartEndInclusive = inRangeStartEndInclusive;
inRange.default = {
  inRange: inRangeEndInclusive,
  inRangeStartInclusive: inRangeStartInclusive,
  inRangeEndInclusive: inRangeEndInclusive,
  inRangeStartEndInclusive: inRangeStartEndInclusive
};

var isValueTooLong = {};

Object.defineProperty(isValueTooLong, "__esModule", {
  value: true
});

isValueTooLong.default = function (recommendedValue, valueLength) {
  return valueLength > recommendedValue;
};

var addMark = {};

Object.defineProperty(addMark, "__esModule", {
  value: true
});

addMark.default = function (text) {
  return "<yoastmark class='yoast-text-mark'>" + text + "</yoastmark>";
};

var stripHTMLTags = {};

var stripSpaces = {};

Object.defineProperty(stripSpaces, "__esModule", {
	value: true
});

stripSpaces.default = function (text) {
	// Replace multiple spaces with single space
	text = text.replace(/\s{2,}/g, " ");

	// Replace spaces followed by periods with only the period.
	text = text.replace(/\s\./g, ".");

	// Remove first/last character if space
	text = text.replace(/^\s+|\s+$/g, "");

	return text;
};

var html = {};

var findMatchingRule = function(rules, text){
  var i;
  for(i=0; i<rules.length; i++)
    if(rules[i].regex.test(text))
      return rules[i];
  return undefined;
};

var findMaxIndexAndRule = function(rules, text){
  var i, rule, last_matching_rule;
  for(i=0; i<text.length; i++){
    rule = findMatchingRule(rules, text.substring(0, i + 1));
    if(rule)
      last_matching_rule = rule;
    else if(last_matching_rule)
      return {max_index: i, rule: last_matching_rule};
  }
  return last_matching_rule ? {max_index: text.length, rule: last_matching_rule} : undefined;
};

var core = function(onToken_orig){
  var buffer = "";
  var rules = [];
  var line = 1;
  var col = 1;

  var onToken = function(src, type){
    onToken_orig({
      type: type,
      src: src,
      line: line,
      col: col
    });
    var lines = src.split("\n");
    line += lines.length - 1;
    col = (lines.length > 1 ? 1 : col) + lines[lines.length - 1].length;
  };

  return {
    addRule: function(regex, type){
      rules.push({regex: regex, type: type});
    },
    onText: function(text){
      var str = buffer + text;
      var m = findMaxIndexAndRule(rules, str);
      while(m && m.max_index !== str.length){
        onToken(str.substring(0, m.max_index), m.rule.type);

        //now find the next token
        str = str.substring(m.max_index);
        m = findMaxIndexAndRule(rules, str);
      }
      buffer = str;
    },
    end: function(){
      if(buffer.length === 0)
        return;

      var rule = findMatchingRule(rules, buffer);
      if(!rule){
        var err = new Error("unable to tokenize");
        err.tokenizer2 = {
          buffer: buffer,
          line: line,
          col: col
        };
        throw err;
      }

      onToken(buffer, rule.type);
    }
  };
};

Object.defineProperty(html, "__esModule", {
	value: true
});
html.getBlocks = html.isInlineElement = html.isBlockElement = html.inlineElements = html.blockElements = undefined;

var _core$1 = core;

var _core2$1 = _interopRequireDefault$3e(_core$1);

var _lodashEs$1U = require$$1$1;

function _interopRequireDefault$3e(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var blockElements = ["address", "article", "aside", "blockquote", "canvas", "dd", "div", "dl", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "li", "main", "nav", "noscript", "ol", "output", "p", "pre", "section", "table", "tfoot", "ul", "video"];
var inlineElements = ["b", "big", "i", "small", "tt", "abbr", "acronym", "cite", "code", "dfn", "em", "kbd", "strong", "samp", "time", "var", "a", "bdo", "br", "img", "map", "object", "q", "script", "span", "sub", "sup", "button", "input", "label", "select", "textarea"];

var blockElementsRegex = new RegExp("^(" + blockElements.join("|") + ")$", "i");
var inlineElementsRegex = new RegExp("^(" + inlineElements.join("|") + ")$", "i");

var blockElementStartRegex$1 = new RegExp("^<(" + blockElements.join("|") + ")[^>]*?>$", "i");
var blockElementEndRegex$1 = new RegExp("^</(" + blockElements.join("|") + ")[^>]*?>$", "i");

var inlineElementStartRegex = new RegExp("^<(" + inlineElements.join("|") + ")[^>]*>$", "i");
var inlineElementEndRegex = new RegExp("^</(" + inlineElements.join("|") + ")[^>]*>$", "i");

var otherElementStartRegex = /^<([^>\s/]+)[^>]*>$/;
var otherElementEndRegex = /^<\/([^>\s]+)[^>]*>$/;

var contentRegex = /^[^<]+$/;
var greaterThanContentRegex = /^<[^><]*$/;

var commentRegex = /<!--(.|[\r\n])*?-->/g;

var tokens = [];
var htmlBlockTokenizer;

/**
 * Creates a tokenizer to tokenize HTML into blocks.
 *
 * @returns {void}
 */
function createTokenizer() {
	tokens = [];

	htmlBlockTokenizer = (0, _core2$1.default)(function (token) {
		tokens.push(token);
	});

	htmlBlockTokenizer.addRule(contentRegex, "content");
	htmlBlockTokenizer.addRule(greaterThanContentRegex, "greater-than-sign-content");

	htmlBlockTokenizer.addRule(blockElementStartRegex$1, "block-start");
	htmlBlockTokenizer.addRule(blockElementEndRegex$1, "block-end");
	htmlBlockTokenizer.addRule(inlineElementStartRegex, "inline-start");
	htmlBlockTokenizer.addRule(inlineElementEndRegex, "inline-end");

	htmlBlockTokenizer.addRule(otherElementStartRegex, "other-element-start");
	htmlBlockTokenizer.addRule(otherElementEndRegex, "other-element-end");
}

/**
 * Returns whether or not the given element name is a block element.
 *
 * @param {string} htmlElementName The name of the HTML element.
 * @returns {boolean} Whether or not it is a block element.
 */
function isBlockElement(htmlElementName) {
	return blockElementsRegex.test(htmlElementName);
}

/**
 * Returns whether or not the given element name is an inline element.
 *
 * @param {string} htmlElementName The name of the HTML element.
 * @returns {boolean} Whether or not it is an inline element.
 */
function isInlineElement(htmlElementName) {
	return inlineElementsRegex.test(htmlElementName);
}

/**
 * Splits a text into blocks based on HTML block elements.
 *
 * @param {string} text The text to split.
 * @returns {Array} A list of blocks based on HTML block elements.
 */
function getBlocks(text) {
	var blocks = [],
	    depth = 0,
	    blockStartTag = "",
	    currentBlock = "",
	    blockEndTag = "";

	// Remove all comments because it is very hard to tokenize them.
	text = text.replace(commentRegex, "");

	createTokenizer();
	htmlBlockTokenizer.onText(text);
	htmlBlockTokenizer.end();

	(0, _lodashEs$1U.forEach)(tokens, function (token, i) {
		var nextToken = tokens[i + 1];

		switch (token.type) {
			case "content":
			case "greater-than-sign-content":
			case "inline-start":
			case "inline-end":
			case "other-tag":
			case "other-element-start":
			case "other-element-end":
			case "greater than sign":
				if (!nextToken || depth === 0 && (nextToken.type === "block-start" || nextToken.type === "block-end")) {
					currentBlock += token.src;

					blocks.push(currentBlock);
					blockStartTag = "";
					currentBlock = "";
					blockEndTag = "";
				} else {
					currentBlock += token.src;
				}
				break;

			case "block-start":
				if (depth !== 0) {
					if (currentBlock.trim() !== "") {
						blocks.push(currentBlock);
					}
					currentBlock = "";
					blockEndTag = "";
				}

				depth++;
				blockStartTag = token.src;
				break;

			case "block-end":
				depth--;
				blockEndTag = token.src;

				/*
     * We try to match the most deep blocks so discard any other blocks that have been started but not
     * finished.
     */
				if ("" !== blockStartTag && "" !== blockEndTag) {
					blocks.push(blockStartTag + currentBlock + blockEndTag);
				} else if ("" !== currentBlock.trim()) {
					blocks.push(currentBlock);
				}
				blockStartTag = "";
				currentBlock = "";
				blockEndTag = "";
				break;
		}

		// Handles HTML with too many closing tags.
		if (depth < 0) {
			depth = 0;
		}
	});

	return blocks;
}

const memoizedGetBlocks = (0, _lodashEs$1U.memoize)(getBlocks);

html.blockElements = blockElements;
html.inlineElements = inlineElements;
html.isBlockElement = isBlockElement;
html.isInlineElement = isInlineElement;
html.getBlocks = memoizedGetBlocks;
html.default = {
	blockElements: blockElements,
	inlineElements: inlineElements,
	isBlockElement: isBlockElement,
	isInlineElement: isInlineElement,
	getBlocks: memoizedGetBlocks
};

Object.defineProperty(stripHTMLTags, "__esModule", {
  value: true
});
stripHTMLTags.stripBlockTagsAtStartEnd = stripHTMLTags.stripIncompleteTags = stripHTMLTags.stripFullTags = undefined;

var _stripSpaces$f = stripSpaces;

var _stripSpaces2$f = _interopRequireDefault$3d(_stripSpaces$f);

var _html$3 = html;

function _interopRequireDefault$3d(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module stringProcessing/stripHTMLTags */

var blockElementStartRegex = new RegExp("^<(" + _html$3.blockElements.join("|") + ")[^>]*?>", "i");
var blockElementEndRegex = new RegExp("</(" + _html$3.blockElements.join("|") + ")[^>]*?>$", "i");

/**
 * Strip incomplete tags within a text. Strips an endtag at the beginning of a string and the start tag at the end of a
 * start of a string.
 * @param {String} text The text to strip the HTML-tags from at the begin and end.
 * @returns {String} The text without HTML-tags at the begin and end.
 */
var stripIncompleteTags = function stripIncompleteTags(text) {
  text = text.replace(/^(<\/([^>]+)>)+/i, "");
  text = text.replace(/(<([^/>]+)>)+$/i, "");
  return text;
};

/**
 * Removes the block element tags at the beginning and end of a string and returns this string.
 *
 * @param {string} text The unformatted string.
 * @returns {string} The text with removed HTML begin and end block elements
 */
var stripBlockTagsAtStartEnd = function stripBlockTagsAtStartEnd(text) {
  text = text.replace(blockElementStartRegex, "");
  text = text.replace(blockElementEndRegex, "");
  return text;
};

/**
 * Strip HTML-tags from text
 *
 * @param {String} text The text to strip the HTML-tags from.
 * @returns {String} The text without HTML-tags.
 */
var stripFullTags = function stripFullTags(text) {
  text = text.replace(/(<([^>]+)>)/ig, " ");
  text = (0, _stripSpaces2$f.default)(text);
  return text;
};

stripHTMLTags.stripFullTags = stripFullTags;
stripHTMLTags.stripIncompleteTags = stripIncompleteTags;
stripHTMLTags.stripBlockTagsAtStartEnd = stripBlockTagsAtStartEnd;
stripHTMLTags.default = {
  stripFullTags: stripFullTags,
  stripIncompleteTags: stripIncompleteTags,
  stripBlockTagsAtStartEnd: stripBlockTagsAtStartEnd
};

Object.defineProperty(paragraphTooLongAssessment, "__esModule", {
	value: true
});

var _lodashEs$1T = require$$1$1;

var _inRange$9 = inRange;

var _isValueTooLong$2 = isValueTooLong;

var _isValueTooLong2$2 = _interopRequireDefault$3c(_isValueTooLong$2);

var _addMark$6 = addMark;

var _addMark2$6 = _interopRequireDefault$3c(_addMark$6);

var _shortlinker$w = shortlinker;

var _stripHTMLTags$c = stripHTMLTags;

var _AssessmentResult$x = AssessmentResult$1;

var _AssessmentResult2$x = _interopRequireDefault$3c(_AssessmentResult$x);

var _Mark$9 = Mark$1;

var _Mark2$9 = _interopRequireDefault$3c(_Mark$9);

function _interopRequireDefault$3c(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 150 is the recommendedValue for the maximum paragraph length.
const recommendedValue$1 = 150;

/**
 * Returns an array containing only the paragraphs longer than the recommended length.
 * @param {array} paragraphsLength The array containing the lengths of individual paragraphs.
 * @returns {number} The number of too long paragraphs.
 */
const getTooLongParagraphs = function getTooLongParagraphs(paragraphsLength) {
	return (0, _lodashEs$1T.filter)(paragraphsLength, function (paragraph) {
		return (0, _isValueTooLong2$2.default)(recommendedValue$1, paragraph.wordCount);
	});
};

/**
 * Returns the scores and text for the ParagraphTooLongAssessment
 * @param {array} paragraphsLength The array containing the lengths of individual paragraphs.
 * @param {number} tooLongParagraphs The number of too long paragraphs.
 * @param {object} i18n The i18n object used for translations.
 * @returns {{score: number, text: string }} the assessmentResult.
 */
const calculateParagraphLengthResult = function calculateParagraphLengthResult(paragraphsLength, tooLongParagraphs, i18n) {
	let score;
	const urlTitle = (0, _shortlinker$w.createAnchorOpeningTag)("https://yoa.st/35d");
	const urlCallToAction = (0, _shortlinker$w.createAnchorOpeningTag)("https://yoa.st/35e");

	if (paragraphsLength.length === 0) {
		return {};
	}

	const longestParagraphLength = paragraphsLength[0].wordCount;

	if (longestParagraphLength <= 150) {
		// Green indicator.
		score = 9;
	}

	if ((0, _inRange$9.inRangeEndInclusive)(longestParagraphLength, 150, 200)) {
		// Orange indicator.
		score = 6;
	}

	if (longestParagraphLength > 200) {
		// Red indicator.
		score = 3;
	}

	if (score >= 7) {
		return {
			score: score,
			hasMarks: false,

			text: i18n.sprintf(
			/* Translators:  %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sParagraph length%2$s: None of the paragraphs are too long. Great job!"), urlTitle, "</a>")
		};
	}
	return {
		score: score,
		hasMarks: true,
		text: i18n.sprintf(
		/* Translators: %1$s and %5$s expand to a link on yoast.com, %2$s expands to the anchor end tag, %3$d expands to the
  number of paragraphs over the recommended word limit, %4$d expands to the word limit */
		i18n.dngettext("js-text-analysis", "%1$sParagraph length%2$s: %3$d of the paragraphs contains more than the recommended maximum of %4$d words." + " %5$sShorten your paragraphs%2$s!", "%1$sParagraph length%2$s: %3$d of the paragraphs contain more than the " + "recommended maximum of %4$d words. %5$sShorten your paragraphs%2$s!", tooLongParagraphs.length), urlTitle, "</a>", tooLongParagraphs.length, recommendedValue$1, urlCallToAction)
	};
};

/**
 * Sort the paragraphs based on word count.
 *
 * @param {Array} paragraphs The array with paragraphs.
 * @returns {Array} The array sorted on word counts.
 */
var sortParagraphs = function sortParagraphs(paragraphs) {
	return paragraphs.sort(function (a, b) {
		return b.wordCount - a.wordCount;
	});
};

/**
 * Creates a marker for the paragraphs.
 *
 * @param {object} paper The paper to use for the assessment.
 * @param {object} researcher The researcher used for calling research.
 * @returns {Array} An array with marked paragraphs.
 */
var paragraphLengthMarker = function paragraphLengthMarker(paper, researcher) {
	var paragraphsLength = researcher.getResearch("getParagraphLength");
	var tooLongParagraphs = getTooLongParagraphs(paragraphsLength);
	return (0, _lodashEs$1T.map)(tooLongParagraphs, function (paragraph) {
		var paragraphText = (0, _stripHTMLTags$c.stripBlockTagsAtStartEnd)(paragraph.text);
		var marked = (0, _addMark2$6.default)(paragraphText);
		return new _Mark2$9.default({
			original: paragraphText,
			marked: marked
		});
	});
};

/**
 * Runs the getParagraphLength module, based on this returns an assessment result with score and text.
 * @param {object} paper The paper to use for the assessment.
 * @param {object} researcher The researcher used for calling research.
 * @param {object} i18n The object used for translations.
 * @returns {object} the Assessmentresult
 */
var paragraphLengthAssessment = function paragraphLengthAssessment(paper, researcher, i18n) {
	var paragraphsLength = researcher.getResearch("getParagraphLength");

	paragraphsLength = sortParagraphs(paragraphsLength);

	var tooLongParagraphs = getTooLongParagraphs(paragraphsLength);
	var paragraphLengthResult = calculateParagraphLengthResult(paragraphsLength, tooLongParagraphs, i18n);
	var assessmentResult = new _AssessmentResult2$x.default();

	assessmentResult.setScore(paragraphLengthResult.score);
	assessmentResult.setText(paragraphLengthResult.text);
	assessmentResult.setHasMarks(paragraphLengthResult.hasMarks);

	return assessmentResult;
};

/**
 * Checks if the paragraphTooLong assessment is applicable to the paper.
 *
 * @param {Paper} paper The paper to check.
 *
 * @returns {boolean} Returns true if the assessment is applicable to the paper.
 */
var isApplicable$7 = function isApplicable(paper) {
	return paper.hasText();
};

paragraphTooLongAssessment.default = {
	identifier: "textParagraphTooLong",
	getResult: paragraphLengthAssessment,
	isApplicable: isApplicable$7,
	getMarks: paragraphLengthMarker
};

var passiveVoiceAssessment$1 = {};

var formatNumber = {};

Object.defineProperty(formatNumber, "__esModule", {
  value: true
});

formatNumber.default = function (number) {
  if (Math.round(number) === number) {
    return Math.round(number);
  }

  return Math.round(number * 10) / 10;
};

Object.defineProperty(passiveVoiceAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1S = require$$1$1;

var _formatNumber$5 = formatNumber;

var _formatNumber2$5 = _interopRequireDefault$3b(_formatNumber$5);

var _getLanguageAvailability$4 = getLanguageAvailability;

var _getLanguageAvailability2$4 = _interopRequireDefault$3b(_getLanguageAvailability$4);

var _inRange$8 = inRange;

var _addMark$5 = addMark;

var _addMark2$5 = _interopRequireDefault$3b(_addMark$5);

var _shortlinker$v = shortlinker;

var _stripHTMLTags$b = stripHTMLTags;

var _AssessmentResult$w = AssessmentResult$1;

var _AssessmentResult2$w = _interopRequireDefault$3b(_AssessmentResult$w);

var _Mark$8 = Mark$1;

var _Mark2$8 = _interopRequireDefault$3b(_Mark$8);

function _interopRequireDefault$3b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const availableLanguages$4 = ["en", "de", "fr", "es", "ru", "it", "nl", "pl", "sv", "pt", "id", "ar", "he", "hu", "tr"];

/**
 * Calculates the result based on the number of sentences and passives.
 * @param {object} passiveVoice The object containing the number of sentences and passives
 * @param {object} i18n The object used for translations.
 * @returns {{score: number, text}} resultobject with score and text.
 */
const calculatePassiveVoiceResult = function calculatePassiveVoiceResult(passiveVoice, i18n) {
	let score;
	let percentage = 0;
	const recommendedValue = 10;
	const urlTitle = (0, _shortlinker$v.createAnchorOpeningTag)("https://yoa.st/34t");
	const urlCallToAction = (0, _shortlinker$v.createAnchorOpeningTag)("https://yoa.st/34u");

	// Prevent division by zero errors.
	if (passiveVoice.total !== 0) {
		percentage = (0, _formatNumber2$5.default)(passiveVoice.passives.length / passiveVoice.total * 100);
	}

	const hasMarks = percentage > 0;

	if (percentage <= 10) {
		// Green indicator.
		score = 9;
	}

	if ((0, _inRange$8.inRangeEndInclusive)(percentage, 10, 15)) {
		// Orange indicator.
		score = 6;
	}

	if (percentage > 15) {
		// Red indicator.
		score = 3;
	}

	if (score >= 7) {
		return {
			score: score,
			hasMarks: hasMarks,
			text: i18n.sprintf(
			/* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag. */
			i18n.dgettext("js-text-analysis", "%1$sPassive voice%2$s: You're using enough active voice. That's great!"), urlTitle, "</a>")
		};
	}
	return {
		score: score,
		hasMarks: hasMarks,
		text: i18n.sprintf(
		/* Translators: %1$s and %5$s expand to a link on yoast.com, %2$s expands to the anchor end tag,
  %3$s expands to the percentage of sentences in passive voice, %4$s expands to the recommended value. */
		i18n.dgettext("js-text-analysis", "%1$sPassive voice%2$s: %3$s of the sentences contain passive voice, which is more than the recommended maximum of %4$s. " + "%5$sTry to use their active counterparts%2$s."), urlTitle, "</a>", percentage + "%", recommendedValue + "%", urlCallToAction)
	};
};

/**
 * Marks all sentences that have the passive voice.
 *
 * @param {object} paper The paper to use for the assessment.
 * @param {object} researcher The researcher used for calling research.
 * @returns {object} All marked sentences.
 */
const passiveVoiceMarker = function passiveVoiceMarker(paper, researcher) {
	const passiveVoice = researcher.getResearch("passiveVoice");
	return (0, _lodashEs$1S.map)(passiveVoice.passives, function (sentence) {
		sentence = (0, _stripHTMLTags$b.stripIncompleteTags)(sentence);
		const marked = (0, _addMark2$5.default)(sentence);
		return new _Mark2$8.default({
			original: sentence,
			marked: marked
		});
	});
};

/**
 * Runs the passiveVoice module, based on this returns an assessment result with score and text.
 * @param {object} paper The paper to use for the assessment.
 * @param {object} researcher The researcher used for calling research.
 * @param {object} i18n The object used for translations.
 * @returns {object} the Assessmentresult
 */
const passiveVoiceAssessment = function passiveVoiceAssessment(paper, researcher, i18n) {
	const passiveVoice = researcher.getResearch("passiveVoice");

	const passiveVoiceResult = calculatePassiveVoiceResult(passiveVoice, i18n);

	const assessmentResult = new _AssessmentResult2$w.default();

	assessmentResult.setScore(passiveVoiceResult.score);
	assessmentResult.setText(passiveVoiceResult.text);
	assessmentResult.setHasMarks(passiveVoiceResult.hasMarks);

	return assessmentResult;
};

/**
 * Checks if passive voice analysis is available for the language of the paper.
 *
 * @param {Object} paper The paper to check.
 *
 * @returns {boolean} Returns true if the language is available and the paper is not empty.
 */
const isApplicable$6 = function isApplicable(paper) {
	const isLanguageAvailable = (0, _getLanguageAvailability2$4.default)(paper.getLocale(), availableLanguages$4);
	return isLanguageAvailable && paper.hasText();
};

passiveVoiceAssessment$1.default = {
	identifier: "passiveVoice",
	getResult: passiveVoiceAssessment,
	isApplicable: isApplicable$6,
	getMarks: passiveVoiceMarker
};

var sentenceBeginningsAssessment$1 = {};

Object.defineProperty(sentenceBeginningsAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1R = require$$1$1;

var _addMark$4 = addMark;

var _addMark2$4 = _interopRequireDefault$3a(_addMark$4);

var _shortlinker$u = shortlinker;

var _stripHTMLTags$a = stripHTMLTags;

var _AssessmentResult$v = AssessmentResult$1;

var _AssessmentResult2$v = _interopRequireDefault$3a(_AssessmentResult$v);

var _Mark$7 = Mark$1;

var _Mark2$7 = _interopRequireDefault$3a(_Mark$7);

var _getLanguageAvailability$3 = getLanguageAvailability;

var _getLanguageAvailability2$3 = _interopRequireDefault$3a(_getLanguageAvailability$3);

function _interopRequireDefault$3a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const maximumConsecutiveDuplicates = 2;

const availableLanguages$3 = ["en", "de", "es", "fr", "nl", "it", "ru", "pl", "sv", "pt", "id", "ar", "he", "hu", "tr"];

/**
 * Counts and groups the number too often used sentence beginnings and determines the lowest count within that group.
 * @param {array} sentenceBeginnings The array containing the objects containing the beginning words and counts.
 * @returns {object} The object containing the total number of too often used beginnings and the lowest count within those.
 */
const groupSentenceBeginnings = function groupSentenceBeginnings(sentenceBeginnings) {
	const tooOften = (0, _lodashEs$1R.partition)(sentenceBeginnings, function (word) {
		return word.count > maximumConsecutiveDuplicates;
	});

	if (tooOften[0].length === 0) {
		return { total: 0 };
	}

	const sortedCounts = (0, _lodashEs$1R.sortBy)(tooOften[0], function (word) {
		return word.count;
	});

	return { total: tooOften[0].length, lowestCount: sortedCounts[0].count };
};

/**
 * Calculates the score based on sentence beginnings.
 * @param {object} groupedSentenceBeginnings The object with grouped sentence beginnings.
 * @param {object} i18n The object used for translations.
 * @returns {{score: number, text: string, hasMarks: boolean}} result object with score and text.
 */
const calculateSentenceBeginningsResult = function calculateSentenceBeginningsResult(groupedSentenceBeginnings, i18n) {
	const urlTitle = (0, _shortlinker$u.createAnchorOpeningTag)("https://yoa.st/35f");
	const urlCallToAction = (0, _shortlinker$u.createAnchorOpeningTag)("https://yoa.st/35g");

	if (groupedSentenceBeginnings.total > 0) {
		return {
			score: 3,
			hasMarks: true,
			text: i18n.sprintf(
			/* Translators: %1$s and %5$s expand to a link on yoast.com, %2$s expands to the anchor end tag,
   %3$d expands to the number of consecutive sentences starting with the same word,
   %4$d expands to the number of instances where 3 or more consecutive sentences start with the same word. */
			i18n.dngettext("js-text-analysis", "%1$sConsecutive sentences%2$s: The text contains %3$d consecutive sentences starting with the same word." + " %5$sTry to mix things up%2$s!", "%1$sConsecutive sentences%2$s: The text contains %4$d instances where" + " %3$d or more consecutive sentences start with the same word. %5$sTry to mix things up%2$s!", groupedSentenceBeginnings.total), urlTitle, "</a>", groupedSentenceBeginnings.lowestCount, groupedSentenceBeginnings.total, urlCallToAction)
		};
	}
	return {
		score: 9,
		hasMarks: false,
		text: i18n.sprintf(
		/* Translators:  %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag */
		i18n.dgettext("js-text-analysis", "%1$sConsecutive sentences%2$s: There is enough variety in your sentences. That's great!"), urlTitle, "</a>")
	};
};

/**
 * Marks all consecutive sentences with the same beginnings.
 * @param {object} paper The paper to use for the assessment.
 * @param {object} researcher The researcher used for calling research.
 * @returns {object} All marked sentences.
 */
const sentenceBeginningMarker = function sentenceBeginningMarker(paper, researcher) {
	let sentenceBeginnings = researcher.getResearch("getSentenceBeginnings");
	sentenceBeginnings = (0, _lodashEs$1R.filter)(sentenceBeginnings, function (sentenceBeginning) {
		return sentenceBeginning.count > maximumConsecutiveDuplicates;
	});

	const sentences = (0, _lodashEs$1R.map)(sentenceBeginnings, function (begin) {
		return begin.sentences;
	});

	return (0, _lodashEs$1R.map)((0, _lodashEs$1R.flatten)(sentences), function (sentence) {
		sentence = (0, _stripHTMLTags$a.stripIncompleteTags)(sentence);
		const marked = (0, _addMark2$4.default)(sentence);
		return new _Mark2$7.default({
			original: sentence,
			marked: marked
		});
	});
};

/**
 * Scores the repetition of sentence beginnings in consecutive sentences.
 * @param {object} paper The paper to use for the assessment.
 * @param {object} researcher The researcher used for calling research.
 * @param {object} i18n The object used for translations.
 * @returns {object} The Assessment result
 */
const sentenceBeginningsAssessment = function sentenceBeginningsAssessment(paper, researcher, i18n) {
	const sentenceBeginnings = researcher.getResearch("getSentenceBeginnings");
	const groupedSentenceBeginnings = groupSentenceBeginnings(sentenceBeginnings);
	const sentenceBeginningsResult = calculateSentenceBeginningsResult(groupedSentenceBeginnings, i18n);
	const assessmentResult = new _AssessmentResult2$v.default();

	assessmentResult.setScore(sentenceBeginningsResult.score);
	assessmentResult.setText(sentenceBeginningsResult.text);
	assessmentResult.setHasMarks(sentenceBeginningsResult.hasMarks);
	return assessmentResult;
};

/**
 * Checks if the sentence beginnings assessment is applicable to the paper.
 *
 * @param {Object} paper The paper to check.
 *
 * @returns {boolean} Returns true if the language is available and the paper is not empty.
 */
const isApplicable$5 = function isApplicable(paper) {
	const isLanguageAvailable = (0, _getLanguageAvailability2$3.default)(paper.getLocale(), availableLanguages$3);
	return isLanguageAvailable && paper.hasText();
};

sentenceBeginningsAssessment$1.default = {
	identifier: "sentenceBeginnings",
	getResult: sentenceBeginningsAssessment,
	isApplicable: isApplicable$5,
	getMarks: sentenceBeginningMarker
};

var sentenceLengthInDescriptionAssessment$1 = {};

var checkForTooLongSentences = {};

Object.defineProperty(checkForTooLongSentences, "__esModule", {
  value: true
});

checkForTooLongSentences.default = function (sentences, recommendedValue) {
  var tooLongSentences = (0, _lodashEs$1Q.filter)(sentences, function (sentence) {
    return (0, _isValueTooLong2$1.default)(recommendedValue, sentence.sentenceLength);
  });

  return tooLongSentences;
};

var _lodashEs$1Q = require$$1$1;

var _isValueTooLong$1 = isValueTooLong;

var _isValueTooLong2$1 = _interopRequireDefault$39(_isValueTooLong$1);

function _interopRequireDefault$39(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(sentenceLengthInDescriptionAssessment$1, "__esModule", {
	value: true
});

var _formatNumber$4 = formatNumber;

var _formatNumber2$4 = _interopRequireDefault$38(_formatNumber$4);

var _inRange$7 = inRange;

var _shortlinker$t = shortlinker;

var _AssessmentResult$u = AssessmentResult$1;

var _AssessmentResult2$u = _interopRequireDefault$38(_AssessmentResult$u);

var _checkForTooLongSentences$1 = checkForTooLongSentences;

var _checkForTooLongSentences2$1 = _interopRequireDefault$38(_checkForTooLongSentences$1);

function _interopRequireDefault$38(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Calculates sentence length score
 * @param {array} sentences The array containing sentences.
 * @param {object} i18n The object used for translations.
 * @returns {object} Object containing score and text.
 */
var calculateSentenceLengthResult = function calculateSentenceLengthResult(sentences, i18n) {
	var score;
	var percentage = 0;
	var recommendedValue = 20;
	var tooLongTotal = (0, _checkForTooLongSentences2$1.default)(sentences, recommendedValue).length;
	const sentenceLengthURL = (0, _shortlinker$t.createAnchorOpeningTag)("https://yoa.st/short-sentences");

	if (sentences.length !== 0) {
		percentage = (0, _formatNumber2$4.default)(tooLongTotal / sentences.length * 100);
	}

	if (percentage <= 20) {
		// Green indicator.
		score = 9;
	}

	if ((0, _inRange$7.inRangeEndInclusive)(percentage, 20, 25)) {
		// Orange indicator.
		score = 6;
	}

	if (percentage > 25) {
		// Red indicator.
		score = 3;
	}

	if (score >= 7) {
		return {
			score: score,
			text: i18n.sprintf(i18n.dgettext("js-text-analysis",
			// Translators: %1$s expands to a link on yoast.com, %2$s expands to the recommended maximum sentence length,
			// %3$s expands to the anchor end tag.
			"The meta description contains no sentences %1$sover %2$s words%3$s."), sentenceLengthURL, recommendedValue, "</a>")
		};
	}
	return {
		score: score,
		text: i18n.sprintf(i18n.dngettext("js-text-analysis",
		// Translators: %1$d expands to number of sentences, %2$s expands to a link on yoast.com,
		// %3$s expands to the recommended maximum sentence length, %4$s expands to the anchor end tag.
		"The meta description contains %1$d sentence %2$sover %3$s words%4$s. Try to shorten this sentence.", "The meta description contains %1$d sentences %2$sover %3$s words%4$s. Try to shorten these sentences.", tooLongTotal), tooLongTotal, sentenceLengthURL, recommendedValue, "</a>")
	};
};

/**
 * Scores the percentage of sentences including more than the recommended number of words.
 *
 * @param {object} paper The paper to use for the assessment.
 * @param {object} researcher The researcher used for calling research.
 * @param {object} i18n The object used for translations.
 * @returns {object} The Assessmentresult
 */
var sentenceLengthInDescriptionAssessment = function sentenceLengthInDescriptionAssessment(paper, researcher, i18n) {
	var sentenceCount = researcher.getResearch("countSentencesFromDescription");
	var sentenceResult = calculateSentenceLengthResult(sentenceCount, i18n);
	var assessmentResult = new _AssessmentResult2$u.default();

	assessmentResult.setScore(sentenceResult.score);
	assessmentResult.setText(sentenceResult.text);

	return assessmentResult;
};

/**
 * Checks if the paper has a metadescription, which is a prerequisite for the assessment to be applicable to the paper.
 *
 * @param {Object} paper The paper to check.
 *
 * @returns {boolean} Returns true if the paper has a meta description.
 */
const isApplicable$4 = function isApplicable(paper) {
	return paper.hasDescription();
};

sentenceLengthInDescriptionAssessment$1.default = {
	identifier: "metaDescriptionSentenceLength",
	getResult: sentenceLengthInDescriptionAssessment,
	isApplicable: isApplicable$4
};

var sentenceLengthInTextAssessment = {};

Object.defineProperty(sentenceLengthInTextAssessment, "__esModule", {
	value: true
});

var _lodashEs$1P = require$$1$1;

var _assessment$k = assessment;

var _assessment2$k = _interopRequireDefault$37(_assessment$k);

var _checkForTooLongSentences = checkForTooLongSentences;

var _checkForTooLongSentences2 = _interopRequireDefault$37(_checkForTooLongSentences);

var _formatNumber$3 = formatNumber;

var _formatNumber2$3 = _interopRequireDefault$37(_formatNumber$3);

var _inRange$6 = inRange;

var _addMark$3 = addMark;

var _addMark2$3 = _interopRequireDefault$37(_addMark$3);

var _shortlinker$s = shortlinker;

var _stripHTMLTags$9 = stripHTMLTags;

var _AssessmentResult$t = AssessmentResult$1;

var _AssessmentResult2$t = _interopRequireDefault$37(_AssessmentResult$t);

var _Mark$6 = Mark$1;

var _Mark2$6 = _interopRequireDefault$37(_Mark$6);

function _interopRequireDefault$37(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents the assessment that will calculate the length of sentences in the text.
 */
class SentenceLengthInTextAssessment extends _assessment2$k.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {object} config The configuration to use.
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			recommendedWordCount: 20,
			slightlyTooMany: 25,
			farTooMany: 30
		};

		this.identifier = "textSentenceLength";
		this._config = (0, _lodashEs$1P.merge)(defaultConfig, config);
	}

	/**
  * Scores the percentage of sentences including more than the recommended number of words.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {object} i18n The object used for translations.
  * @returns {AssessmentResult} The Assessment result.
  */
	getResult(paper, researcher, i18n) {
		const sentences = researcher.getResearch("countSentencesFromText");
		const percentage = this.calculatePercentage(sentences);
		const score = this.calculateScore(percentage);

		const assessmentResult = new _AssessmentResult2$t.default();

		assessmentResult.setScore(score);
		assessmentResult.setText(this.translateScore(score, percentage, i18n));
		assessmentResult.setHasMarks(percentage > 0);

		return assessmentResult;
	}

	/**
  * Checks whether the paper has text.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True when there is text.
  */
	isApplicable(paper) {
		return paper.hasText();
	}

	/**
  * Mark the sentences.
  *
  * @param {Paper} paper The paper to use for the marking.
  * @param {Researcher} researcher The researcher to use.
  *
  * @returns {Array} Array with all the marked sentences.
  */
	getMarks(paper, researcher) {
		const sentenceCount = researcher.getResearch("countSentencesFromText");
		const sentenceObjects = this.getTooLongSentences(sentenceCount);

		return (0, _lodashEs$1P.map)(sentenceObjects, function (sentenceObject) {
			const sentence = (0, _stripHTMLTags$9.stripIncompleteTags)(sentenceObject.sentence);
			return new _Mark2$6.default({
				original: sentence,
				marked: (0, _addMark2$3.default)(sentence)
			});
		});
	}

	/**
  * Translates the score to a message the user can understand.
  *
  * @param {number} score The score.
  * @param {number} percentage The percentage.
  * @param {object} i18n The object used for translations.
  *
  * @returns {string} A string.
  */
	translateScore(score, percentage, i18n) {
		const urlTitle = (0, _shortlinker$s.createAnchorOpeningTag)("https://yoa.st/34v");
		const urlCallToAction = (0, _shortlinker$s.createAnchorOpeningTag)("https://yoa.st/34w");
		if (score >= 7) {
			return i18n.sprintf(
			/* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sSentence length%2$s: Great!"), urlTitle, "</a>");
		}

		return i18n.sprintf(
		/* Translators: %1$s and %6$s expand to a link on yoast.com, %2$s expands to the anchor end tag,
  %3$d expands to percentage of sentences, %4$s expands to the recommended maximum sentence length,
  %5$s expands to the recommended maximum percentage. */
		i18n.dgettext("js-text-analysis", "%1$sSentence length%2$s: %3$s of the sentences contain more than %4$s words, which is more than the recommended maximum of %5$s." + " %6$sTry to shorten the sentences%2$s."), urlTitle, "</a>", percentage + "%", this._config.recommendedWordCount, this._config.slightlyTooMany + "%", urlCallToAction);
	}

	/**
  * Calculates the percentage of sentences that are too long.
  *
  * @param {Array} sentences The sentences to calculate the percentage for.
  * @returns {number} The calculates percentage of too long sentences.
  */
	calculatePercentage(sentences) {
		let percentage = 0;

		if (sentences.length !== 0) {
			const tooLongTotal = this.countTooLongSentences(sentences);

			percentage = (0, _formatNumber2$3.default)(tooLongTotal / sentences.length * 100);
		}

		return percentage;
	}

	/**
  * Calculates the score for the given percentage.
  *
  * @param {number} percentage The percentage to calculate the score for.
  * @returns {number} The calculated score.
  */
	calculateScore(percentage) {
		let score;

		// Green indicator.
		if (percentage <= this._config.slightlyTooMany) {
			score = 9;
		}

		// Orange indicator.
		if ((0, _inRange$6.inRangeEndInclusive)(percentage, this._config.slightlyTooMany, this._config.farTooMany)) {
			score = 6;
		}

		// Red indicator.
		if (percentage > this._config.farTooMany) {
			score = 3;
		}

		return score;
	}

	/**
  * Gets the sentences that are qualified as being too long.
  *
  * @param {array} sentences The sentences to filter through.
  * @returns {array} Array with all the sentences considered to be too long.
  */
	getTooLongSentences(sentences) {
		return (0, _checkForTooLongSentences2.default)(sentences, this._config.recommendedWordCount);
	}

	/**
  * Get the total amount of sentences that are qualified as being too long.
  *
  * @param {Array} sentences The sentences to filter through.
  * @returns {Number} The amount of sentences that are considered too long.
  */
	countTooLongSentences(sentences) {
		return this.getTooLongSentences(sentences).length;
	}
}

sentenceLengthInTextAssessment.default = SentenceLengthInTextAssessment;

var subheadingDistributionTooLongAssessment = {};

var getSubheadings$1 = {};

Object.defineProperty(getSubheadings$1, "__esModule", {
  value: true
});
/**
 * Gets all subheadings from the text and returns these in an array.
 *
 * @param {string} text The text to return the headings from.
 *
 * @returns {Array<string[]>} Matches of subheadings in the text, first key is everything including tags,
 *                            second is the heading level, third is the content of the subheading.
 */
function getSubheadings(text) {
  const subheadings = [];
  const regex = /<h([1-6])(?:[^>]+)?>(.*?)<\/h\1>/ig;
  let match;

  while ((match = regex.exec(text)) !== null) {
    subheadings.push(match);
  }

  return subheadings;
}

/**
 * Gets all the level 2 and 3 subheadings from the text and returns these in an array.
 *
 * @param {string} text The text to return the headings from.
 *
 * @returns {Array<string[]>} Matches of subheadings in the text, first key is everything including tags,
 *                            second is the heading level, third is the content of the subheading.
 */
function getSubheadingsTopLevel(text) {
  const subheadings = [];
  const regex = /<h([2-3])(?:[^>]+)?>(.*?)<\/h\1>/ig;
  let match;

  while ((match = regex.exec(text)) !== null) {
    subheadings.push(match);
  }

  return subheadings;
}

/**
 * Gets the content of subheadings in the text.
 *
 * @param {string} text The text to get the subheading contents from.
 *
 * @returns {string[]} A list of all the subheadings with their content.
 */
function getSubheadingContents(text) {
  const subheadings = getSubheadings(text);

  return subheadings.map(subheading => subheading[0]);
}

/**
 * Gets the content of subheadings h2 and h3 in the text.
 *
 * @param {string} text The text to get the subheading contents from.
 *
 * @returns {string[]} A list of all the subheadings with their content.
 */
function getSubheadingContentsTopLevel(text) {
  const subheadings = getSubheadingsTopLevel(text);

  // Only return the entire string matched, not the rest of the outputs of the regex.exec function.
  return subheadings.map(subheading => subheading[0]);
}

/**
 * Removes all level 2 and 3 subheadings from the text.
 *
 * @param {string} text The text to remove the headings from.
 *
 * @returns {string} The text with removed subheadings.
 */
function removeSubheadingsTopLevel(text) {
  const regex = /<h([2-3])(?:[^>]+)?>(.*?)<\/h\1>/ig;

  return text.replace(regex, "");
}

getSubheadings$1.getSubheadings = getSubheadings;
getSubheadings$1.getSubheadingsTopLevel = getSubheadingsTopLevel;
getSubheadings$1.getSubheadingContents = getSubheadingContents;
getSubheadings$1.getSubheadingContentsTopLevel = getSubheadingContentsTopLevel;
getSubheadings$1.removeSubheadingsTopLevel = removeSubheadingsTopLevel;
getSubheadings$1.default = {
  getSubheadings: getSubheadings,
  getSubheadingsTopLevel: getSubheadingsTopLevel,
  getSubheadingContents: getSubheadingContents,
  getSubheadingContentsTopLevel: getSubheadingContentsTopLevel,
  removeSubheadingsTopLevel: removeSubheadingsTopLevel
};

var getWords = {};

var removePunctuation = {};

Object.defineProperty(removePunctuation, "__esModule", {
  value: true
});

removePunctuation.default = function (text) {
  text = text.replace(punctuationRegexStart$1, "");
  text = text.replace(punctuationRegexEnd$1, "");

  return text;
};

/*
 * \u2014 - em-dash
 * \u00d7 - multiplication sign
 * \u002b - plus sign
 * \u0026 - ampersand
 * \u06d4 - Urdu full stop
 * \u061f - Arabic question mark
 * \u060C - Arabic comma
 * \u061B - Arabic semicolon
 */
var punctuationRegexString$1 = "[\\–\\-\\(\\)_\\[\\]’“”〝〞〟‟„\"'.?!:;,¿¡«»‹›\u2014\u00d7\u002b\u0026\u06d4\u061f\u060C\u061B\\<\>]+";
var punctuationRegexStart$1 = new RegExp("^" + punctuationRegexString$1);
var punctuationRegexEnd$1 = new RegExp(punctuationRegexString$1 + "$");

Object.defineProperty(getWords, "__esModule", {
	value: true
});

getWords.default = function (text) {
	text = (0, _stripSpaces2$e.default)((0, _stripHTMLTags$8.stripFullTags)(text));
	if (text === "") {
		return [];
	}

	var words = text.split(/\s/g);

	words = (0, _lodashEs$1O.map)(words, function (word) {
		return (0, _removePunctuation2$2.default)(word);
	});

	return (0, _lodashEs$1O.filter)(words, function (word) {
		return word.trim() !== "";
	});
};

var _stripHTMLTags$8 = stripHTMLTags;

var _stripSpaces$e = stripSpaces;

var _stripSpaces2$e = _interopRequireDefault$36(_stripSpaces$e);

var _removePunctuation$2 = removePunctuation;

var _removePunctuation2$2 = _interopRequireDefault$36(_removePunctuation$2);

var _lodashEs$1O = require$$1$1;

function _interopRequireDefault$36(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(subheadingDistributionTooLongAssessment, "__esModule", {
	value: true
});

var _lodashEs$1N = require$$1$1;

var _assessment$j = assessment;

var _assessment2$j = _interopRequireDefault$35(_assessment$j);

var _inRange$5 = inRange;

var _isValueTooLong = isValueTooLong;

var _isValueTooLong2 = _interopRequireDefault$35(_isValueTooLong);

var _shortlinker$r = shortlinker;

var _getSubheadings$3 = getSubheadings$1;

var _getWords$i = getWords;

var _getWords2$i = _interopRequireDefault$35(_getWords$i);

var _AssessmentResult$s = AssessmentResult$1;

var _AssessmentResult2$s = _interopRequireDefault$35(_AssessmentResult$s);

function _interopRequireDefault$35(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents the assessment for calculating the text after each subheading.
 */
class SubheadingsDistributionTooLong extends _assessment2$j.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} config The configuration to use.
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			parameters: {
				// The maximum recommended value of the subheading text.
				recommendedMaximumWordCount: 300,
				slightlyTooMany: 300,
				farTooMany: 350
			},
			urlTitle: (0, _shortlinker$r.createAnchorOpeningTag)("https://yoa.st/34x"),
			urlCallToAction: (0, _shortlinker$r.createAnchorOpeningTag)("https://yoa.st/34y"),
			scores: {
				goodShortTextNoSubheadings: 9,
				goodSubheadings: 9,
				okSubheadings: 6,
				badSubheadings: 3,
				badLongTextNoSubheadings: 2
			}
		};

		this.identifier = "subheadingsTooLong";
		this._config = (0, _lodashEs$1N.merge)(defaultConfig, config);
	}

	/**
  * Runs the getSubheadingTextLength research and checks scores based on length.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {Object} i18n The object used for translations.
  *
  * @returns {AssessmentResult} The assessment result.
  */
	getResult(paper, researcher, i18n) {
		this._subheadingTextsLength = researcher.getResearch("getSubheadingTextLengths");

		this._subheadingTextsLength = this._subheadingTextsLength.sort(function (a, b) {
			return b.wordCount - a.wordCount;
		});

		this._tooLongTextsNumber = this.getTooLongSubheadingTexts().length;

		const assessmentResult = new _AssessmentResult2$s.default();
		assessmentResult.setIdentifier(this.identifier);

		this._hasSubheadings = this.hasSubheadings(paper);

		this._textLength = (0, _getWords2$i.default)(paper.getText()).length;

		const calculatedResult = this.calculateResult(i18n);
		calculatedResult.resultTextPlural = calculatedResult.resultTextPlural || "";
		assessmentResult.setScore(calculatedResult.score);
		assessmentResult.setText(calculatedResult.resultText);

		return assessmentResult;
	}

	/**
  * Checks whether the paper has text.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True when there is text.
  */
	isApplicable(paper) {
		return paper.hasText();
	}

	/**
  * Checks whether the paper has subheadings.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True when there is at least one subheading.
  */
	hasSubheadings(paper) {
		const subheadings = (0, _getSubheadings$3.getSubheadings)(paper.getText());
		return subheadings.length > 0;
	}

	/**
  * Counts the number of subheading texts that are too long.
  *
  * @returns {number} The number of subheading texts that are too long.
  */
	getTooLongSubheadingTexts() {
		return (0, _lodashEs$1N.filter)(this._subheadingTextsLength, function (subheading) {
			return (0, _isValueTooLong2.default)(this._config.parameters.recommendedMaximumWordCount, subheading.wordCount);
		}.bind(this));
	}

	/**
  * Calculates the score and creates a feedback string based on the subheading texts length.
  *
  * @param {Object} i18n The object used for translations.
  *
  * @returns {Object} The calculated result.
  */
	calculateResult(i18n) {
		if (this._textLength > 300) {
			if (this._hasSubheadings) {
				const longestSubheadingTextLength = this._subheadingTextsLength[0].wordCount;
				if (longestSubheadingTextLength <= this._config.parameters.slightlyTooMany) {
					// Green indicator.
					return {
						score: this._config.scores.goodSubheadings,
						resultText: i18n.sprintf(
						// Translators: %1$s expands to a link to https://yoa.st/headings, %2$s expands to the link closing tag.
						i18n.dgettext("js-text-analysis", "%1$sSubheading distribution%2$s: Great job!"), this._config.urlTitle, "</a>")
					};
				}

				if ((0, _inRange$5.inRangeEndInclusive)(longestSubheadingTextLength, this._config.parameters.slightlyTooMany, this._config.parameters.farTooMany)) {
					// Orange indicator.
					return {
						score: this._config.scores.okSubheadings,
						resultText: i18n.sprintf(
						/*
       * Translators: %1$s and %5$s expand to a link on yoast.com, %3$d to the number of text sections
       * not separated by subheadings, %4$d expands to the recommended number of words following a
       * subheading, %2$s expands to the link closing tag.
       */
						i18n.dngettext("js-text-analysis", "%1$sSubheading distribution%2$s: %3$d section of your text is longer than %4$d words and" + " is not separated by any subheadings. %5$sAdd subheadings to improve readability%2$s.", "%1$sSubheading distribution%2$s: %3$d sections of your text are longer than %4$d words " + "and are not separated by any subheadings. %5$sAdd subheadings to improve readability%2$s.", this._tooLongTextsNumber), this._config.urlTitle, "</a>", this._tooLongTextsNumber, this._config.parameters.recommendedMaximumWordCount, this._config.urlCallToAction)
					};
				}

				// Red indicator.
				return {
					score: this._config.scores.badSubheadings,
					resultText: i18n.sprintf(
					/* Translators: %1$s and %5$s expand to a link on yoast.com, %3$d to the number of text sections
     not separated by subheadings, %4$d expands to the recommended number of words following a
     subheading, %2$s expands to the link closing tag. */
					i18n.dngettext("js-text-analysis", "%1$sSubheading distribution%2$s: %3$d section of your text is longer than %4$d words and" + " is not separated by any subheadings. %5$sAdd subheadings to improve readability%2$s.", "%1$sSubheading distribution%2$s: %3$d sections of your text are longer than %4$d words " + "and are not separated by any subheadings. %5$sAdd subheadings to improve readability%2$s.", this._tooLongTextsNumber), this._config.urlTitle, "</a>", this._tooLongTextsNumber, this._config.parameters.recommendedMaximumWordCount, this._config.urlCallToAction)
				};
			}
			// Red indicator, use '2' so we can differentiate in external analysis.
			return {
				score: this._config.scores.badLongTextNoSubheadings,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %3$s expand to a link to https://yoa.st/headings, %2$s expands to the link closing tag. */
				i18n.dgettext("js-text-analysis", "%1$sSubheading distribution%2$s: You are not using any subheadings, although your text is rather long." + " %3$sTry and add some subheadings%2$s."), this._config.urlTitle, "</a>", this._config.urlCallToAction)
			};
		}
		if (this._hasSubheadings) {
			// Green indicator.
			return {
				score: this._config.scores.goodSubheadings,
				resultText: i18n.sprintf(
				/* Translators: %1$s expands to a link to https://yoa.st/headings, %2$s expands to the link closing tag. */
				i18n.dgettext("js-text-analysis", "%1$sSubheading distribution%2$s: Great job!"), this._config.urlTitle, "</a>")
			};
		}
		// Green indicator.
		return {
			score: this._config.scores.goodShortTextNoSubheadings,
			resultText: i18n.sprintf(
			/* Translators: %1$s expands to a link to https://yoa.st/headings, %2$s expands to the link closing tag. */
			i18n.dgettext("js-text-analysis", "%1$sSubheading distribution%2$s: You are not using any subheadings, but your text is short enough" + " and probably doesn't need them."), this._config.urlTitle, "</a>")
		};
	}
}

subheadingDistributionTooLongAssessment.default = SubheadingsDistributionTooLong;

var textPresenceAssessment$1 = {};

Object.defineProperty(textPresenceAssessment$1, "__esModule", {
	value: true
});

var _shortlinker$q = shortlinker;

var _stripHTMLTags$7 = stripHTMLTags;

var _AssessmentResult$r = AssessmentResult$1;

var _AssessmentResult2$r = _interopRequireDefault$34(_AssessmentResult$r);

function _interopRequireDefault$34(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assesses that the paper has at least a little bit of content.
 *
 * @param {Paper} paper The paper to assess.
 * @param {Researcher} researcher The researcher.
 * @param {Jed} i18n The translations object.
 * @returns {AssessmentResult} The result of this assessment.
 */
function textPresenceAssessment(paper, researcher, i18n) {
	const text = (0, _stripHTMLTags$7.stripFullTags)(paper.getText());
	const urlTitle = (0, _shortlinker$q.createAnchorOpeningTag)("https://yoa.st/35h");
	const urlCallToAction = (0, _shortlinker$q.createAnchorOpeningTag)("https://yoa.st/35i");

	if (text.length < 50) {
		const result = new _AssessmentResult2$r.default();

		result.setText(i18n.sprintf(
		/* Translators: %1$s and %3$s expand to links to articles on Yoast.com,
  %2$s expands to the anchor end tag*/
		i18n.dgettext("js-text-analysis", "%1$sNot enough content%2$s: %3$sPlease add some content to enable a good analysis%2$s."), urlTitle, "</a>", urlCallToAction));

		result.setScore(3);
		return result;
	}

	return new _AssessmentResult2$r.default();
}

textPresenceAssessment$1.default = {
	identifier: "textPresence",
	getResult: textPresenceAssessment
};

var transitionWordsAssessment$1 = {};

Object.defineProperty(transitionWordsAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1M = require$$1$1;

var _formatNumber$2 = formatNumber;

var _formatNumber2$2 = _interopRequireDefault$33(_formatNumber$2);

var _inRange$4 = inRange;

var _shortlinker$p = shortlinker;

var _stripHTMLTags$6 = stripHTMLTags;

var _AssessmentResult$q = AssessmentResult$1;

var _AssessmentResult2$q = _interopRequireDefault$33(_AssessmentResult$q);

var _Mark$5 = Mark$1;

var _Mark2$5 = _interopRequireDefault$33(_Mark$5);

var _addMark$2 = addMark;

var _addMark2$2 = _interopRequireDefault$33(_addMark$2);

var _getLanguageAvailability$2 = getLanguageAvailability;

var _getLanguageAvailability2$2 = _interopRequireDefault$33(_getLanguageAvailability$2);

function _interopRequireDefault$33(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const availableLanguages$2 = ["en", "de", "es", "fr", "nl", "it", "pt", "ru", "ca", "pl", "sv", "hu", "id", "ar", "he", "tr"];

/**
 * Calculates the actual percentage of transition words in the sentences.
 *
 * @param {object} sentences The object containing the total number of sentences and the number of sentences containing
 * a transition word.
 * @returns {number} The percentage of sentences containing a transition word.
 */
const calculateTransitionWordPercentage = function calculateTransitionWordPercentage(sentences) {
	if (sentences.transitionWordSentences === 0 || sentences.totalSentences === 0) {
		return 0;
	}

	return (0, _formatNumber2$2.default)(sentences.transitionWordSentences / sentences.totalSentences * 100);
};

/**
 * Calculates the score for the assessment based on the percentage of sentences containing transition words.
 *
 * @param {number} percentage The percentage of sentences containing transition words.
 * @returns {number} The score.
 */
const calculateScoreFromPercentage = function calculateScoreFromPercentage(percentage) {
	if (percentage < 20) {
		// Red indicator.
		return 3;
	}

	if ((0, _inRange$4.inRangeStartInclusive)(percentage, 20, 30)) {
		// Orange indicator.
		return 6;
	}

	if (percentage >= 30) {
		// Green indicator.
		return 9;
	}
};

/**
 * Calculates transition word result
 * @param {object} transitionWordSentences The object containing the total number of sentences and the number of sentences containing
 * a transition word.
 * @param {object} i18n The object used for translations.
 * @returns {object} Object containing score and text.
 */
const calculateTransitionWordResult = function calculateTransitionWordResult(transitionWordSentences, i18n) {
	const percentage = calculateTransitionWordPercentage(transitionWordSentences);
	const score = calculateScoreFromPercentage(percentage);
	const hasMarks = percentage > 0;
	const urlTitle = (0, _shortlinker$p.createAnchorOpeningTag)("https://yoa.st/34z");
	const urlCallToAction = (0, _shortlinker$p.createAnchorOpeningTag)("https://yoa.st/35a");

	if (score < 7 && percentage === 0) {
		return {
			score: (0, _formatNumber2$2.default)(score),
			hasMarks: hasMarks,
			text: i18n.sprintf(
			/* Translators: %1$s and %3$s expand to a link to yoast.com, %2$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sTransition words%2$s: None of the sentences contain transition words. %3$sUse some%2$s."), urlTitle, "</a>", urlCallToAction)
		};
	}

	if (score < 7) {
		return {
			score: (0, _formatNumber2$2.default)(score),
			hasMarks: hasMarks,
			text: i18n.sprintf(
			/* Translators: %1$s and %4$s expand to a link to yoast.com, %2$s expands to the anchor end tag,
   %3$s expands to the percentage of sentences containing transition words */
			i18n.dgettext("js-text-analysis", "%1$sTransition words%2$s: Only %3$s of the sentences contain transition words, which is not enough. %4$sUse more of them%2$s."), urlTitle, "</a>", percentage + "%", urlCallToAction)
		};
	}

	return {
		score: (0, _formatNumber2$2.default)(score),
		hasMarks: hasMarks,
		text: i18n.sprintf(
		/* Translators: %1$s expands to a link on yoast.com, %3$s expands to the anchor end tag. */
		i18n.dgettext("js-text-analysis", "%1$sTransition words%2$s: Well done!"), urlTitle, "</a>")
	};
};

/**
 * Scores the percentage of sentences including one or more transition words.
 * @param {object} paper The paper to use for the assessment.
 * @param {object} researcher The researcher used for calling research.
 * @param {object} i18n The object used for translations.
 * @returns {object} The Assessment result.
 */
const transitionWordsAssessment = function transitionWordsAssessment(paper, researcher, i18n) {
	const transitionWordSentences = researcher.getResearch("findTransitionWords");
	const transitionWordResult = calculateTransitionWordResult(transitionWordSentences, i18n);
	const assessmentResult = new _AssessmentResult2$q.default();

	assessmentResult.setScore(transitionWordResult.score);
	assessmentResult.setText(transitionWordResult.text);
	assessmentResult.setHasMarks(transitionWordResult.hasMarks);

	return assessmentResult;
};

/**
 * Marks text for the transition words assessment.
 * @param {Paper} paper The paper to use for the marking.
 * @param {Researcher} researcher The researcher containing the necessary research.
 * @returns {Array<Mark>} A list of marks that should be applied.
 */
const transitionWordsMarker = function transitionWordsMarker(paper, researcher) {
	const transitionWordSentences = researcher.getResearch("findTransitionWords");

	return (0, _lodashEs$1M.map)(transitionWordSentences.sentenceResults, function (sentenceResult) {
		let sentence = sentenceResult.sentence;
		sentence = (0, _stripHTMLTags$6.stripIncompleteTags)(sentence);
		return new _Mark2$5.default({
			original: sentence,
			marked: (0, _addMark2$2.default)(sentence)
		});
	});
};

/**
 * Checks if the transition words assessment is applicable to the paper.
 *
 * @param {Object} paper The paper to check.
 *
 * @returns {boolean} Returns true if the language is available and the paper is not empty.
 */
const isApplicable$3 = function isApplicable(paper) {
	const isLanguageAvailable = (0, _getLanguageAvailability2$2.default)(paper.getLocale(), availableLanguages$2);
	return isLanguageAvailable && paper.hasText();
};

transitionWordsAssessment$1.default = {
	identifier: "textTransitionWords",
	getResult: transitionWordsAssessment,
	isApplicable: isApplicable$3,
	getMarks: transitionWordsMarker
};

var wordComplexityAssessment$1 = {};

var removeSentenceTerminators = {};

Object.defineProperty(removeSentenceTerminators, "__esModule", {
  value: true
});

removeSentenceTerminators.default = function (text) {
  return text.replace(sentenceTerminators, "");
};

// These are sentence terminators, that never should be in the middle of a word.
var sentenceTerminators = /[.?!:;,]/g;

Object.defineProperty(wordComplexityAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1L = require$$1$1;

var _formatNumber$1 = formatNumber;

var _formatNumber2$1 = _interopRequireDefault$32(_formatNumber$1);

var _addMark$1 = addMark;

var _addMark2$1 = _interopRequireDefault$32(_addMark$1);

var _shortlinker$o = shortlinker;

var _removeSentenceTerminators = removeSentenceTerminators;

var _removeSentenceTerminators2 = _interopRequireDefault$32(_removeSentenceTerminators);

var _AssessmentResult$p = AssessmentResult$1;

var _AssessmentResult2$p = _interopRequireDefault$32(_AssessmentResult$p);

var _Mark$4 = Mark$1;

var _Mark2$4 = _interopRequireDefault$32(_Mark$4);

function _interopRequireDefault$32(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The maximum recommended value is 3 syllables. With more than 3 syllables a word is considered complex.
var recommendedValue = 3;

/**
 * Filters the words that aren't too long.
 *
 * @param {Array} words The array with words to filter on complexity.
 * @returns {Array} The filtered list with complex words.
 */
var filterComplexity = function filterComplexity(words) {
	return (0, _lodashEs$1L.filter)(words, function (word) {
		return word.complexity > recommendedValue;
	});
};

/**
 * Calculates the complexity of the text based on the syllables in words.
 * @param {number} wordCount The number of words used.
 * @param {Array} wordComplexity The list of words with their syllable count.
 * @param {Object} i18n The object used for translations.
 * @returns {{score: number, text}} resultobject with score and text.
 */
var calculateComplexity = function calculateComplexity(wordCount, wordComplexity, i18n) {
	var percentage = 0;
	var tooComplexWords = filterComplexity(wordComplexity).length;

	// Prevent division by zero errors.
	if (wordCount !== 0) {
		percentage = tooComplexWords / wordCount * 100;
	}

	percentage = (0, _formatNumber2$1.default)(percentage);
	var hasMarks = percentage > 0;
	var recommendedMaximum = 5;
	var wordComplexityURL = (0, _shortlinker$o.createAnchorOpeningTag)("https://yoa.st/difficult-words");
	// 6 is the number of scorepoints between 3, minscore and 9, maxscore. For scoring we use 10 steps. each step is 0.6
	// Up to 1.7 percent is for scoring a 9, higher percentages give lower scores.
	var score = 9 - Math.max(Math.min(0.6 * (percentage - 1.7), 6), 0);
	score = (0, _formatNumber2$1.default)(score);

	if (score >= 7) {
		return {
			score: score,
			hasMarks: hasMarks,
			text: i18n.sprintf(i18n.dgettext("js-text-analysis",

			// Translators: %1$s expands to the percentage of complex words, %2$s expands to a link on yoast.com,
			// %3$d expands to the recommended maximum number of syllables,
			// %4$s expands to the anchor end tag, %5$s expands to the recommended maximum number of syllables.
			"%1$s of the words contain %2$sover %3$s syllables%4$s, " + "which is less than or equal to the recommended maximum of %5$s."), percentage + "%", wordComplexityURL, recommendedValue, "</a>", recommendedMaximum + "%")
		};
	}

	return {
		score: score,
		hasMarks: hasMarks,
		text: i18n.sprintf(i18n.dgettext("js-text-analysis",

		// Translators: %1$s expands to the percentage of complex words, %2$s expands to a link on yoast.com,
		// %3$d expands to the recommended maximum number of syllables,
		// %4$s expands to the anchor end tag, %5$s expands to the recommended maximum number of syllables.
		"%1$s of the words contain %2$sover %3$s syllables%4$s, " + "which is more than the recommended maximum of %5$s."), percentage + "%", wordComplexityURL, recommendedValue, "</a>", recommendedMaximum + "%")
	};
};

/**
 * Marks complex words in a sentence.
 * @param {string} sentence The sentence to mark complex words in.
 * @param {Array} complexWords The array with complex words.
 * @returns {Array} All marked complex words.
 */
var markComplexWordsInSentence = function markComplexWordsInSentence(sentence, complexWords) {
	var splitWords = sentence.split(/\s+/);

	(0, _lodashEs$1L.forEach)(complexWords, function (complexWord) {
		var wordIndex = complexWord.wordIndex;

		if (complexWord.word === splitWords[wordIndex] || complexWord.word === (0, _removeSentenceTerminators2.default)(splitWords[wordIndex])) {
			splitWords[wordIndex] = splitWords[wordIndex].replace(complexWord.word, (0, _addMark2$1.default)(complexWord.word));
		}
	});
	return splitWords;
};

/**
 * Splits sentence on whitespace
 * @param {string} sentence The sentence to split.
 * @returns {Array} All words from sentence. .
 */
var splitSentenceOnWhitespace = function splitSentenceOnWhitespace(sentence) {
	var whitespace = sentence.split(/\S+/);

	// Drop first and last elements.
	whitespace.pop();
	whitespace.shift();

	return whitespace;
};

/**
 * Creates markers of words that are complex.
 *
 * @param {Paper} paper The Paper object to assess.
 * @param {Researcher} researcher The Researcher object containing all available researches.
 * @returns {Array} A list with markers
 */
var wordComplexityMarker = function wordComplexityMarker(paper, researcher) {
	var wordComplexityResults = researcher.getResearch("wordComplexity");

	return (0, _lodashEs$1L.flatMap)(wordComplexityResults, function (result) {
		var words = result.words;
		var sentence = result.sentence;

		var complexWords = filterComplexity(words);

		if (complexWords.length === 0) {
			return [];
		}

		var splitWords = markComplexWordsInSentence(sentence, complexWords);

		var whitespace = splitSentenceOnWhitespace(sentence);

		// Rebuild the sentence with the marked words.
		var markedSentence = (0, _lodashEs$1L.zip)(splitWords, whitespace);
		markedSentence = (0, _lodashEs$1L.flatten)(markedSentence);
		markedSentence = markedSentence.join("");

		return new _Mark2$4.default({
			original: sentence,
			marked: markedSentence
		});
	});
};

/**
 * Execute the word complexity assessment and return a result based on the syllables in words
 * @param {Paper} paper The Paper object to assess.
 * @param {Researcher} researcher The Researcher object containing all available researches.
 * @param {object} i18n The object used for translations
 * @returns {AssessmentResult} The result of the assessment, containing both a score and a descriptive text.
 */
var wordComplexityAssessment = function wordComplexityAssessment(paper, researcher, i18n) {
	var wordComplexity = researcher.getResearch("wordComplexity");
	wordComplexity = (0, _lodashEs$1L.flatMap)(wordComplexity, function (sentence) {
		return sentence.words;
	});
	var wordCount = wordComplexity.length;

	var complexityResult = calculateComplexity(wordCount, wordComplexity, i18n);
	var assessmentResult = new _AssessmentResult2$p.default();
	assessmentResult.setScore(complexityResult.score);
	assessmentResult.setText(complexityResult.text);
	assessmentResult.setHasMarks(complexityResult.hasMarks);
	return assessmentResult;
};

/**
 * Checks whether the paper has text.
 *
 * @param {Paper} paper The paper to use for the assessment.
 *
 * @returns {boolean} True when there is text.
 */
var isApplicable$2 = function isApplicable(paper) {
	return paper.hasText();
};

wordComplexityAssessment$1.default = {
	identifier: "wordComplexity",
	getResult: wordComplexityAssessment,
	isApplicable: isApplicable$2,
	getMarks: wordComplexityMarker
};

var FunctionWordsInKeyphraseAssessment$1 = {};

Object.defineProperty(FunctionWordsInKeyphraseAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1K = require$$1$1;

var _assessment$i = assessment;

var _assessment2$i = _interopRequireDefault$31(_assessment$i);

var _shortlinker$n = shortlinker;

var _AssessmentResult$o = AssessmentResult$1;

var _AssessmentResult2$o = _interopRequireDefault$31(_AssessmentResult$o);

function _interopRequireDefault$31(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assessment to check whether the keyphrase only contains function words.
 */
class FunctionWordsInKeyphraseAssessment extends _assessment2$i.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  * @param {number} [config.scores.onlyFunctionWords] The score to return if the keyphrase contains only function words.
  * @param {string} [config.urlTitle] The URL to the relevant KB article.
  * @param {string} [config.urlCallToAction] The URL to the call-to-action article.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			scores: {
				onlyFunctionWords: 0
			},
			urlTitle: (0, _shortlinker$n.createAnchorOpeningTag)("https://yoa.st/functionwordskeyphrase-1"),
			urlCallToAction: (0, _shortlinker$n.createAnchorOpeningTag)("https://yoa.st/functionwordskeyphrase-2")
		};

		this.identifier = "functionWordsInKeyphrase";
		this._config = (0, _lodashEs$1K.merge)(defaultConfig, config);
	}

	/**
  * Runs the functionWordsInKeyphrase researcher, based on this returns an assessment result with score.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {AssessmentResult} The result of the assessment.
  */
	getResult(paper, researcher, i18n) {
		this._functionWordsInKeyphrase = researcher.getResearch("functionWordsInKeyphrase");
		this._keyword = (0, _lodashEs$1K.escape)(paper.getKeyword());
		const assessmentResult = new _AssessmentResult2$o.default();

		if (this._functionWordsInKeyphrase) {
			assessmentResult.setScore(this._config.scores.onlyFunctionWords);
			assessmentResult.setText(i18n.sprintf(
			/**
    * Translators:
    * %1$s and %2$s expand to links on yoast.com,
    * %3$s expands to the anchor end tag,
    * %4$s expands to the focus keyphrase of the article.
    */
			i18n.dgettext("js-text-analysis", "%1$sFunction words in keyphrase%3$s: " + "Your keyphrase \"%4$s\" contains function words only. " + "%2$sLearn more about what makes a good keyphrase.%3$s"), this._config.urlTitle, this._config.urlCallToAction, "</a>", this._keyword));
		}

		return assessmentResult;
	}

	/**
  * Checks if assessment is applicable to the paper.
  *
  * @param {Paper} paper The paper to be analyzed.
  *
  * @returns {boolean} Whether the paper has keyword.
  */
	isApplicable(paper) {
		return paper.hasKeyword();
	}
}

FunctionWordsInKeyphraseAssessment$1.default = FunctionWordsInKeyphraseAssessment;

var InternalLinksAssessment$1 = {};

Object.defineProperty(InternalLinksAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1J = require$$1$1;

var _assessment$h = assessment;

var _assessment2$h = _interopRequireDefault$30(_assessment$h);

var _shortlinker$m = shortlinker;

var _AssessmentResult$n = AssessmentResult$1;

var _AssessmentResult2$n = _interopRequireDefault$30(_AssessmentResult$n);

function _interopRequireDefault$30(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assessment to check whether the text has internal links and whether they are followed or no-followed.
 */
class InternalLinksAssessment extends _assessment2$h.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  * @param {number} [config.parameters.recommendedMinimum] The recommended minimum number of internal links in the text.
  * @param {number} [config.scores.allInternalFollow] The score to return if all internal links are do-follow.
  * @param {number} [config.scores.someInternalFollow] The score to return if some but not all internal links are do-follow.
  * @param {number} [config.scores.noneInternalFollow] The score to return if all internal links are no-follow.
  * @param {number} [config.scores.noInternal] The score to return if there are no internal links.
  * @param {string} [config.url] The URL to the relevant KB article.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			parameters: {
				recommendedMinimum: 1
			},
			scores: {
				allInternalFollow: 9,
				someInternalFollow: 8,
				noneInternalFollow: 7,
				noInternal: 3
			},
			urlTitle: (0, _shortlinker$m.createAnchorOpeningTag)("https://yoa.st/33z"),
			urlCallToAction: (0, _shortlinker$m.createAnchorOpeningTag)("https://yoa.st/34a")
		};

		this.identifier = "internalLinks";
		this._config = (0, _lodashEs$1J.merge)(defaultConfig, config);
	}

	/**
  * Runs the getLinkStatistics module, based on this returns an assessment result with score.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {AssessmentResult} The result of the assessment.
  */
	getResult(paper, researcher, i18n) {
		this.linkStatistics = researcher.getResearch("getLinkStatistics");
		const assessmentResult = new _AssessmentResult2$n.default();

		const calculatedResult = this.calculateResult(i18n);
		assessmentResult.setScore(calculatedResult.score);
		assessmentResult.setText(calculatedResult.resultText);

		return assessmentResult;
	}

	/**
  * Checks if assessment is applicable to the paper.
  *
  * @param {Paper} paper The paper to be analyzed.
  *
  * @returns {boolean} Whether the paper has text.
  */
	isApplicable(paper) {
		return paper.hasText();
	}

	/**
  * Returns a score and text based on the linkStatistics object.
  *
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {Object} ResultObject with score and text
  */
	calculateResult(i18n) {
		if (this.linkStatistics.internalTotal === 0) {
			return {
				score: this._config.scores.noInternal,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sInternal links%3$s: " + "No internal links appear in this page, %2$smake sure to add some%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		if (this.linkStatistics.internalNofollow === this.linkStatistics.internalTotal) {
			return {
				score: this._config.scores.noneInternalFollow,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sInternal links%3$s: " + "The internal links in this page are all nofollowed. %2$sAdd some good internal links%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		if (this.linkStatistics.internalDofollow === this.linkStatistics.internalTotal) {
			return {
				score: this._config.scores.allInternalFollow,
				resultText: i18n.sprintf(
				/* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sInternal links%2$s: You have enough internal links. Good job!"), this._config.urlTitle, "</a>")
			};
		}
		return {
			score: this._config.scores.someInternalFollow,
			resultText: i18n.sprintf(
			/* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sInternal links%2$s: There are both nofollowed and normal internal links on this page. Good job!"), this._config.urlTitle, "</a>")
		};
	}
}

InternalLinksAssessment$1.default = InternalLinksAssessment;

var IntroductionKeywordAssessment$1 = {};

Object.defineProperty(IntroductionKeywordAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1I = require$$1$1;

var _assessment$g = assessment;

var _assessment2$g = _interopRequireDefault$2$(_assessment$g);

var _shortlinker$l = shortlinker;

var _AssessmentResult$m = AssessmentResult$1;

var _AssessmentResult2$m = _interopRequireDefault$2$(_AssessmentResult$m);

function _interopRequireDefault$2$(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assessment to check whether the keyphrase or synonyms are encountered in the first paragraph of the article.
 */
class IntroductionKeywordAssessment extends _assessment2$g.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  * @param {number} [config.scores.good] The score to return if there is a match within one sentence in the first paragraph.
  * @param {number} [config.scores.okay] The score to return if all words are matched in the first paragraph.
  * @param {number} [config.scores.bad] The score to return if not all words are matched in the first paragraph.
  * @param {string} [config.url] The URL to the relevant article on Yoast.com.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			scores: {
				good: 9,
				okay: 6,
				bad: 3
			},
			urlTitle: (0, _shortlinker$l.createAnchorOpeningTag)("https://yoa.st/33e"),
			urlCallToAction: (0, _shortlinker$l.createAnchorOpeningTag)("https://yoa.st/33f")
		};

		this.identifier = "introductionKeyword";
		this._config = (0, _lodashEs$1I.merge)(defaultConfig, config);
	}

	/**
  * Assesses the presence of keyphrase or synonyms in the first paragraph.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {AssessmentResult} The result of this assessment.
  */
	getResult(paper, researcher, i18n) {
		const assessmentResult = new _AssessmentResult2$m.default();

		this._firstParagraphMatches = researcher.getResearch("firstParagraph");
		const calculatedResult = this.calculateResult(i18n);

		assessmentResult.setScore(calculatedResult.score);
		assessmentResult.setText(calculatedResult.resultText);

		return assessmentResult;
	}

	/**
  * Checks if the paper has both keyword and text.
  *
  * @param {Paper} paper The paper to be analyzed.
  *
  * @returns {boolean} Whether the assessment is applicable or not.
  */
	isApplicable(paper) {
		return paper.hasKeyword() && paper.hasText();
	}

	/**
  * Returns a result based on the number of occurrences of keyphrase in the first paragraph.
  *
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {Object} result object with a score and translation text.
  */
	calculateResult(i18n) {
		if (this._firstParagraphMatches.foundInOneSentence) {
			return {
				score: this._config.scores.good,
				resultText: i18n.sprintf(
				/* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in introduction%2$s: Well done!"), this._config.urlTitle, "</a>")
			};
		}

		if (this._firstParagraphMatches.foundInParagraph) {
			return {
				score: this._config.scores.okay,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in introduction%3$s:" + "Your keyphrase or its synonyms appear in the first paragraph of the copy, but not within one sentence. %2$sFix that%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		return {
			score: this._config.scores.bad,
			resultText: i18n.sprintf(
			/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag. */
			i18n.dgettext("js-text-analysis", "%1$sKeyphrase in introduction%3$s: Your keyphrase or its synonyms do not appear in the first paragraph. " + "%2$sMake sure the topic is clear immediately%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>")
		};
	}
}

IntroductionKeywordAssessment$1.default = IntroductionKeywordAssessment;

var KeyphraseDistributionAssessment$1 = {};

var getSentences = {};

var unifyWhitespace = {};

Object.defineProperty(unifyWhitespace, "__esModule", {
  value: true
});
/** @module stringProcessing/unifyWhitespace */

/**
 * Replaces a non breaking space with a normal space
 * @param {string} text The string to replace the non breaking space in.
 * @returns {string} The text with unified spaces.
 */
var unifyNonBreakingSpace = function unifyNonBreakingSpace(text) {
  return text.replace(/&nbsp;/g, " ");
};

/**
 * Replaces all whitespaces with a normal space
 * @param {string} text The string to replace the non breaking space in.
 * @returns {string} The text with unified spaces.
 */
var unifyWhiteSpace = function unifyWhiteSpace(text) {
  return text.replace(/\s/g, " ");
};

/**
 * Converts all whitespace to spaces.
 *
 * @param {string} text The text to replace spaces.
 * @returns {string} The text with unified spaces.
 */
var unifyAllSpaces = function unifyAllSpaces(text) {
  text = unifyNonBreakingSpace(text);
  return unifyWhiteSpace(text);
};

unifyWhitespace.unifyNonBreakingSpace = unifyNonBreakingSpace;
unifyWhitespace.unifyWhiteSpace = unifyWhiteSpace;
unifyWhitespace.unifyAllSpaces = unifyAllSpaces;
unifyWhitespace.default = {
  unifyNonBreakingSpace: unifyNonBreakingSpace,
  unifyWhiteSpace: unifyWhiteSpace,
  unifyAllSpaces: unifyAllSpaces
};

var SentenceTokenizer$1 = {};

var quotes = {};

Object.defineProperty(quotes, "__esModule", {
  value: true
});
/**
 * Normalizes single quotes to 'regular' quotes.
 *
 * @param {string} text Text to normalize.
 * @returns {string} The normalized text.
 */
function normalizeSingleQuotes(text) {
  return text.replace(/[‘’‛`]/g, "'");
}

/**
 * Normalizes double quotes to 'regular' quotes.
 *
 * @param {string} text Text to normalize.
 * @returns {string} The normalized text.
 */
function normalizeDoubleQuotes(text) {
  return text.replace(/[“”〝〞〟‟„]/g, "\"");
}

/**
 * Normalizes quotes to 'regular' quotes.
 *
 * @param {string} text Text to normalize.
 * @returns {string} The normalized text.
 */
function normalizeQuotes(text) {
  return normalizeDoubleQuotes(normalizeSingleQuotes(text));
}

quotes.normalizeSingle = normalizeSingleQuotes;
quotes.normalizeDouble = normalizeDoubleQuotes;
quotes.normalize = normalizeQuotes;
quotes.default = {
  normalizeSingle: normalizeSingleQuotes,
  normalizeDouble: normalizeDoubleQuotes,
  normalize: normalizeQuotes
};

Object.defineProperty(SentenceTokenizer$1, "__esModule", {
	value: true
});

var _lodashEs$1H = require$$1$1;

var _core = core;

var _core2 = _interopRequireDefault$2_(_core);

var _quotes$9 = quotes;

function _interopRequireDefault$2_(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// All characters that indicate a sentence delimiter.
const fullStop = ".";
/*
 * \u2026 - ellipsis
 * \u06D4 - Urdu full stop
 * \u061f - Arabic question mark
 */
const sentenceDelimiters = "?!;\u2026\u06d4\u061f";

const fullStopRegex = new RegExp("^[" + fullStop + "]$");
const sentenceDelimiterRegex = new RegExp("^[" + sentenceDelimiters + "]$");
const sentenceRegex = new RegExp("^[^" + fullStop + sentenceDelimiters + "<\\(\\)\\[\\]]+$");
const smallerThanContentRegex = /^<[^><]*$/;
const htmlStartRegex = /^<([^>\s/]+)[^>]*>$/mi;
const htmlEndRegex = /^<\/([^>\s]+)[^>]*>$/mi;

const blockStartRegex = /^\s*[[({]\s*$/;
const blockEndRegex = /^\s*[\])}]\s*$/;

const sentenceEndRegex = new RegExp("[" + fullStop + sentenceDelimiters + "]$");

/**
 * Class for tokenizing a (html) text into sentences.
 */
class SentenceTokenizer {
	/**
  * Returns whether or not a certain character is a number.
  *
  * @param {string} character The character to check.
  * @returns {boolean} Whether or not the character is a capital letter.
  */
	isNumber(character) {
		return !(0, _lodashEs$1H.isNaN)(parseInt(character, 10));
	}

	/**
  * Returns whether or not a given HTML tag is a break tag.
  *
  * @param {string} htmlTag The HTML tag to check.
  * @returns {boolean} Whether or not the given HTML tag is a break tag.
  */
	isBreakTag(htmlTag) {
		return (/<br/.test(htmlTag)
		);
	}

	/**
  * Returns whether or not a given character is quotation mark.
  *
  * @param {string} character The character to check.
  * @returns {boolean} Whether or not the given character is a quotation mark.
  */
	isQuotation(character) {
		character = (0, _quotes$9.normalize)(character);

		return "'" === character || "\"" === character;
	}

	/**
  * Returns whether or not a given character is a punctuation mark that can be at the beginning
  * of a sentence, like ¿ and ¡ used in Spanish.
  *
  * @param {string} character The character to check.
  * @returns {boolean} Whether or not the given character is a punctuation mark.
  */
	isPunctuation(character) {
		return "¿" === character || "¡" === character;
	}

	/**
  * Removes duplicate whitespace from a given text.
  *
  * @param {string} text The text with duplicate whitespace.
  * @returns {string} The text without duplicate whitespace.
  */
	removeDuplicateWhitespace(text) {
		return text.replace(/\s+/, " ");
	}

	/**
  * Returns whether or not a certain character is a capital letter.
  *
  * @param {string} character The character to check.
  * @returns {boolean} Whether or not the character is a capital letter.
  */
	isCapitalLetter(character) {
		return character !== character.toLocaleLowerCase();
	}

	/**
  * Checks whether the given character is a smaller than sign.
  *
  * This function is used to make sure that tokenizing the content after
  * the smaller than sign works as expected.
  * E.g. 'A sentence. < Hello world!' = ['A sentence.', '< Hello world!'].
  *
  * @param {string} character The character to check.
  * @returns {boolean} Whether the character is a smaller than sign ('<') or not.
  */
	isSmallerThanSign(character) {
		return character === "<";
	}

	/**
  * Retrieves the next two characters from an array with the two next tokens.
  *
  * @param {Array} nextTokens The two next tokens. Might be undefined.
  * @returns {string} The next two characters.
  */
	getNextTwoCharacters(nextTokens) {
		let next = "";

		if (!(0, _lodashEs$1H.isUndefined)(nextTokens[0])) {
			next += nextTokens[0].src;
		}

		if (!(0, _lodashEs$1H.isUndefined)(nextTokens[1])) {
			next += nextTokens[1].src;
		}

		next = this.removeDuplicateWhitespace(next);

		return next;
	}

	/**
  * Checks whether a character is from a language that's written from right to left.
  * These languages don't have capital letter forms. Therefore any letter from these languages is a
  * potential sentence beginning.
  *
  * @param {string} letter The letter to check.
  *
  * @returns {boolean} Whether the letter is from an LTR language.
  */
	isLetterfromRTLLanguage(letter) {
		const ltrLetterRanges = [
		// Hebrew characters.
		/^[\u0590-\u05fe]+$/i,
		// Arabic characters (used for Arabic, Farsi, Urdu).
		/^[\u0600-\u06FF]+$/i,
		// Additional Farsi characters.
		/^[\uFB8A\u067E\u0686\u06AF]+$/i];

		return ltrLetterRanges.some(ltrLetterRange => ltrLetterRange.test(letter));
	}

	/**
  * Checks if the sentenceBeginning beginning is a valid beginning.
  *
  * @param {string} sentenceBeginning The beginning of the sentence to validate.
  * @returns {boolean} Returns true if it is a valid beginning, false if it is not.
  */
	isValidSentenceBeginning(sentenceBeginning) {
		return this.isCapitalLetter(sentenceBeginning) || this.isLetterfromRTLLanguage(sentenceBeginning) || this.isNumber(sentenceBeginning) || this.isQuotation(sentenceBeginning) || this.isPunctuation(sentenceBeginning) || this.isSmallerThanSign(sentenceBeginning);
	}

	/**
  * Checks if the token is a valid sentence start.
  *
  * @param {Object} token The token to validate.
  * @returns {boolean} Returns true if the token is valid sentence start, false if it is not.
  */
	isSentenceStart(token) {
		return !(0, _lodashEs$1H.isUndefined)(token) && ("html-start" === token.type || "html-end" === token.type || "block-start" === token.type);
	}

	/**
  * Checks if the token is a valid sentence ending. A valid sentence ending is either a full stop or another
  * delimiter such as "?", "!", etc.
  *
  * @param {Object} token The token to validate.
  * @returns {boolean} Returns true if the token is valid sentence ending, false if it is not.
  */
	isSentenceEnding(token) {
		return !(0, _lodashEs$1H.isUndefined)(token) && (token.type === "full-stop" || token.type === "sentence-delimiter");
	}

	/**
  * Tokens that represent a '<', followed by content until it enters another '<' or '>'
  * gets another pass by the tokenizer.
  *
  * @param {Object} token A token of type 'smaller-than-sign-content'.
  * @param {string[]} tokenSentences The current array of found sentences. Sentences may get added by this method.
  * @param {string} currentSentence The current sentence. Sentence parts may get appended by this method.
  * @returns {{tokenSentences, currentSentence}} The found sentences and the current sentence, appended when necessary.
  */
	tokenizeSmallerThanContent(token, tokenSentences, currentSentence) {
		/*
  	Remove the '<' from the text, to avoid matching this rule
  	recursively again and again.
  	We add it again later on.
  */
		const localText = token.src.substring(1);

		// Tokenize the current smaller-than-content token without the first '<'.
		const tokenizerResult = this.createTokenizer();
		this.tokenize(tokenizerResult.tokenizer, localText);
		const localSentences = this.getSentencesFromTokens(tokenizerResult.tokens, false);

		localSentences[0] = (0, _lodashEs$1H.isUndefined)(localSentences[0]) ? "<" : "<" + localSentences[0];

		/*
   * When the first sentence has a valid sentence beginning.
   * Add the currently build sentence to the sentences.
   * Start building the next sentence.
   */
		if (this.isValidSentenceBeginning(localSentences[0])) {
			tokenSentences.push(currentSentence);
			currentSentence = "";
		}
		currentSentence += localSentences[0];

		if (localSentences.length > 1) {
			/*
   	There is a new sentence after the first,
   	add and reset the current sentence.
    */
			tokenSentences.push(currentSentence);
			currentSentence = "";

			// Remove the first sentence (we do not need to add it again).
			localSentences.shift();
			// Last sentence gets special treatment.
			const lastSentence = localSentences.pop();

			// Add the remaining found sentences.
			localSentences.forEach(sentence => {
				tokenSentences.push(sentence);
			});

			// Check if the last sentence has a valid sentence ending.
			if (lastSentence.match(sentenceEndRegex)) {
				// If so, add it as a sentence.
				tokenSentences.push(lastSentence);
			} else {
				// If not, start making a new one.
				currentSentence = lastSentence;
			}
		}
		return {
			tokenSentences,
			currentSentence
		};
	}

	/**
  * Creates a tokenizer.
  *
  * @returns {Object} The tokenizer and the tokens.
  */
	createTokenizer() {
		const tokens = [];
		const tokenizer = (0, _core2.default)(function (token) {
			tokens.push(token);
		});

		tokenizer.addRule(fullStopRegex, "full-stop");
		tokenizer.addRule(smallerThanContentRegex, "smaller-than-sign-content");
		tokenizer.addRule(htmlStartRegex, "html-start");
		tokenizer.addRule(htmlEndRegex, "html-end");
		tokenizer.addRule(blockStartRegex, "block-start");
		tokenizer.addRule(blockEndRegex, "block-end");
		tokenizer.addRule(sentenceDelimiterRegex, "sentence-delimiter");
		tokenizer.addRule(sentenceRegex, "sentence");

		return {
			tokenizer,
			tokens
		};
	}

	/**
  * Tokenizes the given text using the given tokenizer.
  *
  * @param {Object} tokenizer The tokenizer to use.
  * @param {string} text The text to tokenize.
  * @returns {void}
  */
	tokenize(tokenizer, text) {
		tokenizer.onText(text);

		try {
			tokenizer.end();
		} catch (e) {
			console.error("Tokenizer end error:", e, e.tokenizer2);
		}
	}

	/**
  * Returns an array of sentences for a given array of tokens, assumes that the text has already been split into blocks.
  *
  * @param {Object[]} tokenArray The tokens from the sentence tokenizer.
  * @param {boolean} [trimSentences=true] Whether to trim the sentences at the end or not.
  *
  * @returns {string[]} A list of sentences.
  */
	getSentencesFromTokens(tokenArray, trimSentences = true) {
		let tokenSentences = [],
		    currentSentence = "",
		    nextSentenceStart,
		    sliced;

		// Drop the first and last HTML tag if both are present.
		do {
			sliced = false;
			const firstToken = tokenArray[0];
			const lastToken = tokenArray[tokenArray.length - 1];

			if (firstToken && lastToken && firstToken.type === "html-start" && lastToken.type === "html-end") {
				tokenArray = tokenArray.slice(1, tokenArray.length - 1);

				sliced = true;
			}
		} while (sliced && tokenArray.length > 1);

		tokenArray.forEach((token, i) => {
			let hasNextSentence, nextCharacters, tokenizeResults;
			const nextToken = tokenArray[i + 1];
			const previousToken = tokenArray[i - 1];
			const secondToNextToken = tokenArray[i + 2];

			switch (token.type) {
				case "html-start":
				case "html-end":
					if (this.isBreakTag(token.src)) {
						tokenSentences.push(currentSentence);
						currentSentence = "";
					} else {
						currentSentence += token.src;
					}
					break;

				case "smaller-than-sign-content":
					tokenizeResults = this.tokenizeSmallerThanContent(token, tokenSentences, currentSentence);
					tokenSentences = tokenizeResults.tokenSentences;
					currentSentence = tokenizeResults.currentSentence;
					break;
				case "sentence":
					currentSentence += token.src;
					break;
				case "sentence-delimiter":
					currentSentence += token.src;

					if (!(0, _lodashEs$1H.isUndefined)(nextToken) && "block-end" !== nextToken.type && "sentence-delimiter" !== nextToken.type) {
						tokenSentences.push(currentSentence);
						currentSentence = "";
					}
					break;

				case "full-stop":
					currentSentence += token.src;

					nextCharacters = this.getNextTwoCharacters([nextToken, secondToNextToken]);

					// For a new sentence we need to check the next two characters.
					hasNextSentence = nextCharacters.length >= 2;
					nextSentenceStart = hasNextSentence ? nextCharacters[1] : "";
					// If the next character is a number, never split. For example: IPv4-numbers.
					if (hasNextSentence && this.isNumber(nextCharacters[0])) {
						break;
					}
					// Only split on sentence delimiters when the next sentence looks like the start of a sentence.
					if (hasNextSentence && this.isValidSentenceBeginning(nextSentenceStart) || this.isSentenceStart(nextToken)) {
						tokenSentences.push(currentSentence);
						currentSentence = "";
					}
					break;

				case "block-start":
					currentSentence += token.src;
					break;

				case "block-end":
					currentSentence += token.src;

					nextCharacters = this.getNextTwoCharacters([nextToken, secondToNextToken]);

					// For a new sentence we need to check the next two characters.
					hasNextSentence = nextCharacters.length >= 2;
					nextSentenceStart = hasNextSentence ? nextCharacters[0] : "";

					/* Don't split if:
      * - The next character is a number. For example: IPv4-numbers.
      * - The block end is preceded by a valid sentence ending, but not followed by a valid sentence beginning.
      */
					if (hasNextSentence && this.isNumber(nextCharacters[0]) || this.isSentenceEnding(previousToken) && !(this.isValidSentenceBeginning(nextSentenceStart) || this.isSentenceStart(nextToken))) {
						break;
					}

					/*
      * Split if:
      * - The block end is preceded by a sentence ending and followed by a valid sentence beginning.
      */
					if (this.isSentenceEnding(previousToken) && (this.isValidSentenceBeginning(nextSentenceStart) || this.isSentenceStart(nextToken))) {
						tokenSentences.push(currentSentence);
						currentSentence = "";
					}
					break;
			}
		});

		if ("" !== currentSentence) {
			tokenSentences.push(currentSentence);
		}

		if (trimSentences) {
			tokenSentences = (0, _lodashEs$1H.map)(tokenSentences, function (sentence) {
				return sentence.trim();
			});
		}

		return tokenSentences;
	}
}
SentenceTokenizer$1.default = SentenceTokenizer;

Object.defineProperty(getSentences, "__esModule", {
	value: true
});

getSentences.default = function (text) {
	text = (0, _unifyWhitespace$1.unifyNonBreakingSpace)(text);
	let blocks = (0, _html$2.getBlocks)(text);

	// Split each block on newlines.
	blocks = (0, _lodashEs$1G.flatMap)(blocks, function (block) {
		return block.split(newLineRegex);
	});

	const sentences = (0, _lodashEs$1G.flatMap)(blocks, getSentencesFromBlockCached);

	return (0, _lodashEs$1G.filter)(sentences, (0, _lodashEs$1G.negate)(_lodashEs$1G.isEmpty));
};

var _lodashEs$1G = require$$1$1;

var _html$2 = html;

var _unifyWhitespace$1 = unifyWhitespace;

var _SentenceTokenizer = SentenceTokenizer$1;

var _SentenceTokenizer2 = _interopRequireDefault$2Z(_SentenceTokenizer);

function _interopRequireDefault$2Z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Character classes.
// Lodash imports.
const newLines = "\n\r|\n|\r";

// Regular expressions.


// Internal dependencies.
const newLineRegex = new RegExp(newLines);

/**
 * Returns the sentences from a certain block.
 *
 * @param {string} block The HTML inside a HTML block.
 * @returns {Array<string>} The list of sentences in the block.
 */
function getSentencesFromBlock(block) {
	const sentenceTokenizer = new _SentenceTokenizer2.default();

	var _sentenceTokenizer$cr = sentenceTokenizer.createTokenizer();

	const tokenizer = _sentenceTokenizer$cr.tokenizer,
	      tokens = _sentenceTokenizer$cr.tokens;

	sentenceTokenizer.tokenize(tokenizer, block);

	return tokens.length === 0 ? [] : sentenceTokenizer.getSentencesFromTokens(tokens);
}

const getSentencesFromBlockCached = (0, _lodashEs$1G.memoize)(getSentencesFromBlock);

Object.defineProperty(KeyphraseDistributionAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1F = require$$1$1;

var _assessment$f = assessment;

var _assessment2$f = _interopRequireDefault$2Y(_assessment$f);

var _shortlinker$k = shortlinker;

var _getSentences$d = getSentences;

var _getSentences2$d = _interopRequireDefault$2Y(_getSentences$d);

var _AssessmentResult$l = AssessmentResult$1;

var _AssessmentResult2$l = _interopRequireDefault$2Y(_AssessmentResult$l);

function _interopRequireDefault$2Y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a score based on the largest percentage of text in
 * which no keyword occurs.
 */
class KeyphraseDistributionAssessment extends _assessment2$f.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  * @param {number} [config.parameters.goodDistributionScore]
  *      The average distribution score that needs to be received from the step function to get a GOOD result.
  * @param {number} [config.parameters.acceptableDistributionScore]
  *      The average distribution score that needs to be received from the step function to get an OKAY result.
  * @param {number} [config.scores.good]             The score to return if keyword occurrences are evenly distributed.
  * @param {number} [config.scores.okay]             The score to return if keyword occurrences are somewhat unevenly distributed.
  * @param {number} [config.scores.bad]              The score to return if there is way too much text between keyword occurrences.
  * @param {number} [config.scores.consideration]    The score to return if there are no keyword occurrences.
  * @param {string} [config.url]                     The URL to the relevant KB article.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			parameters: {
				goodDistributionScore: 30,
				acceptableDistributionScore: 50
			},
			scores: {
				good: 9,
				okay: 6,
				bad: 1,
				consideration: 0
			},
			urlTitle: (0, _shortlinker$k.createAnchorOpeningTag)("https://yoa.st/33q"),
			urlCallToAction: (0, _shortlinker$k.createAnchorOpeningTag)("https://yoa.st/33u")
		};

		this.identifier = "keyphraseDistribution";
		this._config = (0, _lodashEs$1F.merge)(defaultConfig, config);
	}

	/**
  * Runs the keyphraseDistribution research and based on this returns an assessment result.
  *
  * @param {Paper}      paper      The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {Jed}        i18n       The object used for translations.
  *
  * @returns {AssessmentResult} The assessment result.
  */
	getResult(paper, researcher, i18n) {
		this._keyphraseDistribution = researcher.getResearch("keyphraseDistribution");

		const assessmentResult = new _AssessmentResult2$l.default();

		const calculatedResult = this.calculateResult(i18n);

		assessmentResult.setScore(calculatedResult.score);
		assessmentResult.setText(calculatedResult.resultText);
		assessmentResult.setHasMarks(this._keyphraseDistribution.sentencesToHighlight.length > 0);

		return assessmentResult;
	}

	/**
  * Calculates the result based on the keyphraseDistribution research.
  *
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {Object} Object with score and feedback text.
  */
	calculateResult(i18n) {
		const distributionScore = this._keyphraseDistribution.keyphraseDistributionScore;

		if (distributionScore === 100) {
			return {
				score: this._config.scores.consideration,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to links to Yoast.com articles,
    %3$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase distribution%3$s: " + "%2$sInclude your keyphrase or its synonyms in the text so that we can check keyphrase distribution%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		if (distributionScore > this._config.parameters.acceptableDistributionScore) {
			return {
				score: this._config.scores.bad,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to links to Yoast.com articles,
    %3$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase distribution%3$s: " + "Very uneven. Large parts of your text do not contain the keyphrase or its synonyms. %2$sDistribute them more evenly%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		if (distributionScore > this._config.parameters.goodDistributionScore && distributionScore <= this._config.parameters.acceptableDistributionScore) {
			return {
				score: this._config.scores.okay,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to links to Yoast.com articles,
    %3$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase distribution%3$s: " + "Uneven. Some parts of your text do not contain the keyphrase or its synonyms. %2$sDistribute them more evenly%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		return {
			score: this._config.scores.good,
			resultText: i18n.sprintf(
			/* Translators: %1$s expands to links to Yoast.com articles, %2$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sKeyphrase distribution%2$s: Good job!"), this._config.urlTitle, "</a>")
		};
	}

	/**
  * Creates a marker for all content words in keyphrase and synonyms.
  *
  * @returns {Array} All markers for the current text.
  */
	getMarks() {
		return this._keyphraseDistribution.sentencesToHighlight;
	}

	/**
  * Checks whether the paper has a text with at least 10 words and a keyword.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True when there is a keyword and a text with 10 words or more.
  */
	isApplicable(paper) {
		return paper.hasText() && paper.hasKeyword() && (0, _getSentences2$d.default)(paper.getText()).length >= 15;
	}
}

KeyphraseDistributionAssessment$1.default = KeyphraseDistributionAssessment;

var KeyphraseLengthAssessment$1 = {};

var getFunctionWordsLanguages = {};

var getFunctionWords$3 = {};

var functionWords$g = {};

var auxiliaries$b = {};

Object.defineProperty(auxiliaries$b, "__esModule", {
	value: true
});

auxiliaries$b.default = function () {
	return {
		participleLike: participleLike,
		otherAuxiliaries: otherAuxiliaries$a.concat(infinitiveAuxiliaries),
		// These auxiliaries are filtered from the beginning and end of word combinations in the prominent words.
		filteredAuxiliaries: participleLike.concat(otherAuxiliaries$a),
		// These auxiliaries are not filtered from the beginning of word combinations in the prominent words.
		infinitiveAuxiliaries: infinitiveAuxiliaries,
		allAuxiliaries: participleLike.concat(otherAuxiliaries$a, infinitiveAuxiliaries)
	};
};

// These passive auxiliaries start with be-, ge- or er- en and with -t, and therefore look like a participle.
var participleLike = ["bekommst", "bekommt", "bekamst", "bekommest", "bekommet", "bekämest", "bekämst", "bekämet", "bekämt", "gekriegt", "gehörst", "gehört", "gehörtest", "gehörtet", "gehörest", "gehöret", "erhältst", "erhält", "erhaltet", "erhielt", "erhieltest", "erhieltst", "erhieltet", "erhaltest"];

// These are all other passive auxiliaries.
var otherAuxiliaries$a = ["werde", "wirst", "wird", "werden", "werdet", "wurde", "ward", "wurdest", "wardst", "wurden", "wurdet", "worden", "werdest", "würde", "würdest", "würden", "würdet", "bekomme", "bekommen", "bekam", "bekamen", "bekäme", "bekämen", "kriege", "kriegst", "kriegt", "kriegen", "kriegte", "kriegtest", "kriegten", "kriegtet", "kriegest", "krieget", "gehöre", "gehören", "gehörte", "gehörten", "erhalte", "erhalten", "erhielten", "erhielte"];

// These first person plural auxiliaries also function as an infinitive.
var infinitiveAuxiliaries = ["werden", "bekommen", "kriegen", "gehören", "erhalten"];

var transitionWords$s = {};

Object.defineProperty(transitionWords$s, "__esModule", {
	value: true
});

transitionWords$s.default = function () {
	return {
		singleWords: singleWords$f,
		multipleWords: multipleWords$f,
		allWords: singleWords$f.concat(multipleWords$f)
	};
};

/** @module config/transitionWords */

const singleWords$f = ["aber", "abschließend", "abschliessend", "alldieweil", "allerdings", "also", "anderenteils", "andererseits", "andernteils", "anfaenglich", "anfänglich", "anfangs", "angenommen", "anschliessend", "anschließend", "aufgrund", "ausgenommen", "ausserdem", "außerdem", "beispielsweise", "bevor", "beziehungsweise", "bspw", "bzw", "d.h", "da", "dabei", "dadurch", "dafuer", "dafür", "dagegen", "daher", "dahingegen", "danach", "dann", "darauf", "darum", "dass", "davor", "dazu", "dementgegen", "dementsprechend", "demgegenüber", "demgegenueber", "demgemaess", "demgemäß", "demzufolge", "denn", "dennoch", "dergestalt", "derweil", "desto", "deshalb", "desungeachtet", "deswegen", "doch", "dort", "drittens", "ebenfalls", "ebenso", "endlich", "ehe", "einerseits", "einesteils", "entsprechend", "entweder", "erst", "erstens", "falls", "ferner", "folgerichtig", "folglich", "fürderhin", "fuerderhin", "genauso", "hierdurch", "hierzu", "hingegen", "immerhin", "indem", "indes", "indessen", "infolge", "infolgedessen", "insofern", "insoweit", "inzwischen", "jedenfalls", "jedoch", "kurzum", "m.a.w", "mitnichten", "mitunter", "möglicherweise", "moeglicherweise", "nachdem", "nebenher", "nichtsdestotrotz", "nichtsdestoweniger", "ob", "obenrein", "obgleich", "obschon", "obwohl", "obzwar", "ohnehin", "richtigerweise", "schliesslich", "schließlich", "seit", "seitdem", "sobald", "sodass", "so dass", "sofern", "sogar", "solang", "solange", "somit", "sondern", "sooft", "soviel", "soweit", "sowie", "sowohl", "statt", "stattdessen", "trotz", "trotzdem", "überdies", "übrigens", "ueberdies", "uebrigens", "ungeachtet", "vielmehr", "vorausgesetzt", "vorher", "waehrend", "während", "währenddessen", "waehrenddessen", "weder", "wegen", "weil", "weiter", "weiterhin", "wenn", "wenngleich", "wennschon", "wennzwar", "weshalb", "widrigenfalls", "wiewohl", "wobei", "wohingegen", "z.b", "zudem", "zuerst", "zufolge", "zuletzt", "zumal", "zuvor", "zwar", "zweitens"];
const multipleWords$f = ["abgesehen von", "abgesehen davon", "als dass", "als ob", "als wenn", "anders ausgedrückt", "anders ausgedrueckt", "anders formuliert", "anders gefasst", "anders gefragt", "anders gesagt", "anders gesprochen", "anstatt dass", "auch wenn", "auf grund", "auf jeden fall", "aus diesem grund", "ausser dass", "außer dass", "ausser wenn", "außer wenn", "besser ausgedrückt", "besser ausgedrueckt", "besser formuliert", "besser gesagt", "besser gesprochen", "bloss dass", "bloß dass", "darüber hinaus", "das heisst", "das heißt", "des weiteren", "dessen ungeachtet", "ebenso wie", "genauso wie", "geschweige denn", "im fall", "im falle", "im folgenden", "im gegensatz dazu", "im gegenteil", "im grunde genommen", "in diesem sinne", "je nachdem", "kurz gesagt", "mit anderen worten", "ohne dass", "so dass", "umso mehr als", "umso weniger als", "umso mehr, als", "umso weniger, als", "unbeschadet dessen", "und zwar", "ungeachtet dessen", "unter dem strich", "zum beispiel", "zunächts einmal"];

Object.defineProperty(functionWords$g, "__esModule", {
	value: true
});

functionWords$g.default = function () {
	return {
		// These word categories are filtered at the beginning of word combinations.
		filteredAtBeginning: [].concat(otherAuxiliariesInfinitive$6, passiveAuxiliariesInfinitive$3, delexicalizedVerbsInfinitive$6, copulaInfinitive$5, interviewVerbsInfinitive$3),

		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(ordinalNumerals$g, generalAdjectivesAdverbs$d),

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(articles$c, prepositions$f, coordinatingConjunctions$b, demonstrativePronouns$c, intensifiers$g, quantifiers$g),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(transitionWords$r, adverbialGenitives$5, personalPronounsNominative$a, personalPronounsAccusative$8, personalPronounsDative$1, reflexivePronouns$d, interjections$g, cardinalNumerals$g, copula$9, interviewVerbs$g, otherAuxiliaries$9, filteredPassiveAuxiliaries$4, delexicalizedVerbs$b, indefinitePronouns$g, correlativeConjunctions$6, subordinatingConjunctions$b, interrogativeProAdverbs$9, locativeAdverbs$9, miscellaneous$f, pronominalAdverbs$5, recipeWords$f, timeWords$g, vagueNouns$g, reciprocalPronouns$1, possessivePronouns$a),

		// This export contains all of the above words.
		all: [].concat(articles$c, cardinalNumerals$g, ordinalNumerals$g, demonstrativePronouns$c, possessivePronouns$a, reflexivePronouns$d, reciprocalPronouns$1, personalPronounsNominative$a, personalPronounsAccusative$8, quantifiers$g, indefinitePronouns$g, interrogativeProAdverbs$9, pronominalAdverbs$5, locativeAdverbs$9, adverbialGenitives$5, filteredPassiveAuxiliaries$4, passiveAuxiliariesInfinitive$3, otherAuxiliaries$9, otherAuxiliariesInfinitive$6, copula$9, copulaInfinitive$5, prepositions$f, coordinatingConjunctions$b, correlativeConjunctions$6, subordinatingConjunctions$b, interviewVerbs$g, interviewVerbsInfinitive$3, transitionWords$r, additionalTransitionWords$9, intensifiers$g, delexicalizedVerbs$b, delexicalizedVerbsInfinitive$6, interjections$g, generalAdjectivesAdverbs$d, recipeWords$f, vagueNouns$g, miscellaneous$f, timeWords$g, titlesPreceding$8, titlesFollowing$5)
	};
};

var _auxiliaries$5 = auxiliaries$b;

var _auxiliaries2$5 = _interopRequireDefault$2X(_auxiliaries$5);

var _transitionWords$b = transitionWords$s;

var _transitionWords2$b = _interopRequireDefault$2X(_transitionWords$b);

function _interopRequireDefault$2X(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const filteredPassiveAuxiliaries$4 = (0, _auxiliaries2$5.default)().filteredAuxiliaries;

const passiveAuxiliariesInfinitive$3 = (0, _auxiliaries2$5.default)().infinitiveAuxiliaries;

const transitionWords$r = (0, _transitionWords2$b.default)().singleWords;

/**
 * Returns an object with exceptions for the prominent words researcher
 * @returns {Object} The object filled with exception arrays.
 */

const articles$c = ["das", "dem", "den", "der", "des", "die", "ein", "eine", "einem", "einen", "einer", "eines"];

const cardinalNumerals$g = ["eins", "zwei", "drei", "vier", "fünf", "sechs", "sieben", "acht", "neun", "zehn", "elf", "zwölf", "zwoelf", "dreizehn", "vierzehn", "fünfzehn", "fuenfzehn", "sechzehn", "siebzehn", "achtzehn", "neunzehn", "zwanzig", "hundert", "einhundert", "zweihundert", "dreihundert", "vierhundert", "fünfhundert", "fuenfhundert", "sechshundert", "siebenhundert", "achthundert", "neunhundert", "tausend", "million", "milliarde", "billion", "billiarde"];

const ordinalNumerals$g = ["erste", "erster", "ersten", "erstem", "erstes", "zweite", "zweites", "zweiter", "zweitem", "zweiten", "dritte", "dritter", "drittes", "dritten", "drittem", "vierter", "vierten", "viertem", "viertes", "vierte", "fünfte", "fünfter", "fünftes", "fünften", "fünftem", "fuenfte", "fuenfter", "fuenftem", "fuenften", "fuenftes", "sechste", "sechster", "sechstes", "sechsten", "sechstem", "siebte", "siebter", "siebten", "siebtem", "siebtes", "achte", "achter", "achten", "achtem", "achtes", "neunte", "neunter", "neuntes", "neunten", "neuntem", "zehnte", "zehnter", "zehnten", "zehntem", "zehntes", "elfte", "elfter", "elftes", "elften", "elftem", "zwölfte", "zwölfter", "zwölften", "zwölftem", "zwölftes", "zwoelfte", "zwoelfter", "zwoelften", "zwoelftem", "zwoelftes", "dreizehnte", "dreizehnter", "dreizehntes", "dreizehnten", "dreizehntem", "vierzehnte", "vierzehnter", "vierzehntes", "vierzehnten", "vierzehntem", "fünfzehnte", "fünfzehnten", "fünfzehntem", "fünfzehnter", "fünfzehntes", "fuenfzehnte", "fuenfzehnten", "fuenfzehntem", "fuenfzehnter", "fuenfzehntes", "sechzehnte", "sechzehnter", "sechzehnten", "sechzehntes", "sechzehntem", "siebzehnte", "siebzehnter", "siebzehntes", "siebzehntem", "siebzehnten", "achtzehnter", "achtzehnten", "achtzehntem", "achtzehntes", "achtzehnte", "nehnzehnte", "nehnzehnter", "nehnzehntem", "nehnzehnten", "nehnzehntes", "zwanzigste", "zwanzigster", "zwanzigstem", "zwanzigsten", "zwanzigstes"];

const personalPronounsNominative$a = ["ich", "du", "er", "sie", "es", "wir", "ihr"];

const personalPronounsAccusative$8 = ["mich", "dich", "ihn", "uns", "euch"];

const personalPronounsDative$1 = ["mir", "dir", "ihm", "ihnen"];

const demonstrativePronouns$c = ["denen", "deren", "derer", "dessen", "diese", "diesem", "diesen", "dieser", "dieses", "jene", "jenem", "jenen", "jener", "jenes", "welch", "welcher", "welches", "derjenige", "desjenigen", "demjenigen", "denjenigen", "diejenige", "derjenigen", "dasjenige", "diejenigen"];

const possessivePronouns$a = ["mein", "meine", "meinem", "meiner", "meines", "meinen", "dein", "deine", "deinem", "deiner", "deines", "deinen", "sein", "seine", "seinem", "seiner", "seines", "ihre", "ihrem", "ihren", "ihrer", "ihres", "unser", "unsere", "unserem", "unseren", "unserer", "unseres", "euer", "eure", "eurem", "euren", "eurer", "eures", "einanders"];

const quantifiers$g = ["manche", "manch", "viele", "viel", "vieler", "vielen", "vielem", "all", "alle", "aller", "alles", "allen", "allem", "allerlei", "solcherlei", "einige", "etliche", "wenige", "weniger", "wenigen", "wenigem", "weniges", "wenig", "wenigerer", "wenigeren", "wenigerem", "wenigere", "wenigeres", "wenig", "bisschen", "paar", "kein", "keines", "keinem", "keinen", "keine", "mehr", "genug", "mehrere", "mehrerer", "mehreren", "mehrerem", "mehreres", "verschiedene", "verschiedener", "verschiedenen", "verschiedenem", "verschiedenes", "verschiedne", "verschiedner", "verschiednen", "verschiednem", "verschiednes", "art", "arten", "sorte", "sorten"];

const reflexivePronouns$d = ["sich"];

const reciprocalPronouns$1 = ["einander"];

// "Welch", "welcher", and "welches" are already included in the demonstrativePronouns.
const indefinitePronouns$g = ["andere", "anderer", "anderem", "anderen", "anderes", "andren", "andern", "andrem", "anderm", "andre", "andrer", "andres", "beide", "beides", "beidem", "beider", "beiden", "etwas", "irgendetwas", "irgendein", "irgendeinen", "irgendeinem", "irgendeines", "irgendeine", "irgendeiner", "irgendwas", "irgendwessen", "irgendwer", "irgendwen", "irgendwem", "irgendwelche", "irgendwelcher", "irgendwelchem", "irgendwelchen", "irgendwelches", "irgendjemand", "irgendjemanden", "irgendjemandem", "irgendjemandes", "irgendwie", "wer", "wen", "wem", "wessen", "was", "welchen", "welchem", "welche", "jeder", "jedes", "jedem", "jeden", "jede", "jedweder", "jedweden", "jedwedem", "jedwedes", "jedwede", "jeglicher", "jeglichen", "jeglichem", "jegliches", "jegliche", "jedermann", "jedermanns", "jemand", "jemanden", "jemandem", "jemands", "jemandes", "man", "meinesgleichen", "sämtlich", "saemtlich", "sämtlicher", "saemtlicher", "sämtlichen", "saemtlichen", "sämtlichem", "saemtlichem", "sämtliches", "saemtliches", "sämtliche", "saemtliche", "solche", "solcher", "solchen", "solchem", "solches", "niemand", "niemanden", "niemandem", "niemandes", "niemands", "nichts", "zweiter"];

const interrogativeProAdverbs$9 = ["warum", "wie", "wo", "woher", "wohin", "wann"];

const pronominalAdverbs$5 = ["dahinter", "damit", "daneben", "daran", "daraus", "darin", "darunter", "darüber", "darueber", "davon", "dazwischen", "hieran", "hierauf", "hieraus", "hierbei", "hierfuer", "hierfür", "hiergegen", "hierhinter", "hierin", "hiermit", "hiernach", "hierum", "hierunter", "hierueber", "hierüber", "hiervor", "hierzwischen", "hierneben", "hiervon", "wodurch", "wofür", "wofuer", "wogegen", "wohinter", "womit", "wonach", "woneben", "woran", "worauf", "woraus", "worin", "worum", "worunter", "worüber", "worueber", "wovon", "wovor", "wozu", "wozwischen"];

const locativeAdverbs$9 = ["hier", "dorthin", "hierher", "dorther"];

const adverbialGenitives$5 = ["allenfalls", "keinesfalls", "anderenfalls", "andernfalls", "andrenfalls", "äußerstenfalls", "bejahendenfalls", "bestenfalls", "eintretendenfalls", "entgegengesetztenfalls", "erforderlichenfalls", "gegebenenfalls", "geringstenfalls", "gleichfalls", "günstigenfalls", "günstigstenfalls", "höchstenfalls", "möglichenfalls", "notfalls", "nötigenfalls", "notwendigenfalls", "schlimmstenfalls", "vorkommendenfalls", "zutreffendenfalls", "keineswegs", "durchwegs", "geradenwegs", "geradeswegs", "geradewegs", "gradenwegs", "halbwegs", "mittwegs", "unterwegs"];

const otherAuxiliaries$9 = ["habe", "hast", "hat", "habt", "habest", "habet", "hatte", "hattest", "hatten", "hätte", "haette", "hättest", "haettest", "hätten", "haetten", "haettet", "hättet", "hab", "bin", "bist", "ist", "sind", "sei", "seiest", "seien", "seiet", "war", "warst", "waren", "wart", "wäre", "waere", "wärest", "waerest", "wärst", "waerst", "wären", "waeren", "wäret", "waeret", "wärt", "waert", "seid", "darf", "darfst", "dürft", "duerft", "dürfe", "duerfe", "dürfest", "duerfest", "dürfet", "duerfet", "durfte", "durftest", "durften", "durftet", "dürfte", "duerfte", "dürftest", "duerftest", "dürften", "duerften", "dürftet", "duerftet", "kann", "kannst", "könnt", "koennt", "könne", "koenne", "könnest", "koennest", "könnet", "koennet", "konnte", "konntest", "konnten", "konntet", "könnte", "koennte", "könntest", "koenntest", "könnten", "koennten", "könntet", "koenntet", "mag", "magst", "mögt", "moegt", "möge", "moege", "mögest", "moegest", "möget", "moeget", "mochte", "mochtest", "mochten", "mochtet", "möchte", "moechte", "möchtest", "moechtest", "möchten", "moechten", "möchtet", "moechtet", "muss", "muß", "musst", "mußt", "müsst", "muesst", "müßt", "mueßt", "müsse", "muesse", "müssest", "muessest", "müsset", "muesset", "musste", "mußte", "musstest", "mußtest", "mussten", "mußten", "musstet", "mußtet", "müsste", "muesste", "müßte", "mueßte", "müsstest", "muesstest", "müßtest", "mueßtest", "müssten", "muessten", "müßten", "mueßten", "müsstet", "muesstet", "müßtet", "mueßtet", "soll", "sollst", "sollt", "solle", "sollest", "sollet", "sollte", "solltest", "sollten", "solltet", "will", "willst", "wollt", "wolle", "wollest", "wollet", "wollte", "wolltest", "wollten", "wolltet", "lasse", "lässt", "laesst", "läßt", "laeßt", "lasst", "laßt", "lassest", "lasset", "ließ", "ließest", "ließt", "ließen", "ließe", "ließet", "liess", "liessest", "liesst", "liessen", "liesse", "liesset"];

const otherAuxiliariesInfinitive$6 = ["haben", "dürfen", "duerfen", "können", "koennen", "mögen", "moegen", "müssen", "muessen", "sollen", "wollen", "lassen"];

// Forms from 'aussehen' with two parts, like 'sehe aus', are not included, because we remove words on an single word basis.
const copula$9 = ["bleibe", "bleibst", "bleibt", "bleibest", "bleibet", "blieb", "bliebst", "bliebt", "blieben", "bliebe", "bliebest", "bliebet", "heiße", "heißt", "heißest", "heißet", "heisse", "heisst", "heissest", "heisset", "hieß", "hießest", "hießt", "hießen", "hieße", "hießet", "hiess", "hiessest", "hiesst", "hiessen", "hiesse", "hiesset", "giltst", "gilt", "geltet", "gelte", "geltest", "galt", "galtest", "galtst", "galten", "galtet", "gälte", "gaelte", "gölte", "goelte", "gältest", "gaeltest", "göltest", "goeltest", "gälten", "gaelten", "gölten", "goelten", "gältet", "gaeltet", "göltet", "goeltet", "aussehe", "aussiehst", "aussieht", "ausseht", "aussehest", "aussehet", "aussah", "aussahst", "aussahen", "aussaht", "aussähe", "aussaehe", "aussähest", "aussaehest", "aussähst", "aussaehst", "aussähet", "aussaehet", "aussäht", "aussaeht", "aussähen", "aussaehen", "scheine", "scheinst", "scheint", "scheinest", "scheinet", "schien", "schienst", "schienen", "schient", "schiene", "schienest", "schienet", "erscheine", "erscheinst", "erscheint", "erscheinest", "erscheinet", "erschien", "erschienst", "erschienen", "erschient", "erschiene", "erschienest", "erschienet"];

const copulaInfinitive$5 = ["bleiben", "heißen", "heissen", "gelten", "aussehen", "scheinen", "erscheinen"];

const prepositions$f = ["a", "à", "ab", "abseits", "abzüglich", "abzueglich", "als", "am", "an", "angelegentlich", "angesichts", "anhand", "anlässlich", "anlaesslich", "ans", "anstatt", "anstelle", "auf", "aufs", "aufseiten", "aus", "ausgangs", "ausschließlich", "ausschliesslich", "außerhalb", "ausserhalb", "ausweislich", "bar", "behufs", "bei", "beidseits", "beiderseits", "beim", "betreffs", "bezüglich", "bezueglich", "binnen", "bis", "contra", "dank", "diesseits", "durch", "einbezüglich", "einbezueglich", "eingangs", "eingedenk", "einschließlich", "einschliesslich", "entgegen", "entlang", "exklusive", "fern", "fernab", "fuer", "für", "fuers", "fürs", "gegen", "gegenüber", "gegenueber", "gelegentlich", "gemäß", "gemaeß", "gen", "getreu", "gleich", "halber", "hinsichtlich", "hinter", "hinterm", "hinters", "im", "in", "inklusive", "inmitten", "innerhalb", "innert", "ins", "je", "jenseits", "kontra", "kraft", "längs", "laengs", "längsseits", "laengsseits", "laut", "links", "mangels", "minus", "mit", "mithilfe", "mitsamt", "mittels", "nach", "nächst", "naechst", "nah", "namens", "neben", "nebst", "nördlich", "noerdlich", "nordöstlich", "nordoestlich", "nordwestlich", "oberhalb", "ohne", "östlich", "oestlich", "per", "plus", "pro", "quer", "rechts", "rücksichtlich", "ruecksichtlich", "samt", "seitens", "seitlich", "seitwärts", "seitwaerts", "südlich", "suedlich", "südöstlich", "suedoestlich", "südwestlich", "suedwestlich", "über", "ueber", "überm", "ueberm", "übern", "uebern", "übers", "uebers", "um", "ums", "unbeschadet", "unerachtet", "unfern", "unter", "unterhalb", "unterm", "untern", "unters", "unweit", "vermittels", "vermittelst", "vermöge", "vermoege", "via", "vom", "von", "vonseiten", "vor", "vorbehaltlich", "wegen", "wider", "zeit", "zu", "zugunsten", "zulieb", "zuliebe", "zum", "zur", "zusätzlich", "zusaetzlich", "zuungunsten", "zuwider", "zuzüglich", "zuzueglich", "zwecks", "zwischen"];

// Many coordinating conjunctions are already included in the transition words list.
const coordinatingConjunctions$b = ["und", "oder", "umso"];

// 'noch' is part of 'weder...noch', 'nur' is part of 'nicht nur...sondern auch'.
const correlativeConjunctions$6 = ["auch", "noch", "nur"];

// Many subordinating conjunctions are already included in the prepositions list, transition words list or pronominal adverbs list.
const subordinatingConjunctions$b = ["nun", "so", "gleichwohl"];

/*
These verbs are frequently used in interviews to indicate questions and answers. 'Frage' and 'fragen' are not included,
because those words are also nouns.
 */
const interviewVerbs$g = ["sage", "sagst", "sagt", "sagest", "saget", "sagte", "sagtest", "sagten", "sagtet", "gesagt", "fragst", "fragt", "fragest", "fraget", "fragte", "fragtest", "fragten", "fragtet", "gefragt", "erkläre", "erklärst", "erklärt", "erklaere", "erklaerst", "erklaert", "erklärte", "erklärtest", "erklärtet", "erklärten", "erklaerte", "erklaertest", "erklaertet", "erklaerten", "denke", "denkst", "denkt", "denkest", "denket", "dachte", "dachtest", "dachten", "dachtet", "dächte", "dächtest", "dächten", "dächtet", "daechte", "daechtest", "daechten", "daechtet", "finde", "findest", "findet", "gefunden"];

const interviewVerbsInfinitive$3 = ["sagen", "erklären", "erklaeren", "denken", "finden"];

// These transition words were not included in the list for the transition word assessment for various reasons.
const additionalTransitionWords$9 = ["etwa", "absolut", "unbedingt", "wieder", "definitiv", "bestimmt", "immer", "äußerst", "aeußerst", "höchst", "hoechst", "sofort", "augenblicklich", "umgehend", "direkt", "unmittelbar", "nämlich", "naemlich", "natürlich", "natuerlich", "besonders", "hauptsächlich", "hauptsaechlich", "jetzt", "eben", "heutzutage", "eindeutig", "wirklich", "echt", "wahrhaft", "ehrlich", "aufrichtig", "wahrheitsgemäß", "letztlich", "einmalig", "unübertrefflich", "normalerweise", "gewöhnlich", "gewoehnlich", "üblicherweise", "ueblicherweise", "sonst", "fast", "nahezu", "beinahe", "knapp", "annähernd", "annaehernd", "geradezu", "bald", "vielleicht", "wahrscheinlich", "wohl", "voraussichtlich", "zugegeben", "ursprünglich", "insgesamt", "tatsächlich", "eigentlich", "wahrhaftig", "bereits", "schon", "oft", "häufig", "haeufig", "regelmäßig", "regelmaeßig", "gleichmäßig", "gleichmaeßig", "einfach", "lediglich", "bloß", "bloss", "halt", "wahlweise", "eventuell", "manchmal", "teilweise", "nie", "niemals", "nimmer", "jemals", "allzeit", "irgendeinmal", "anders", "momentan", "gegenwärtig", "gegenwaertig", "nebenbei", "anderswo", "woanders", "anderswohin", "anderorts", "insbesondere", "namentlich", "sonderlich", "ausdrücklich", "ausdruecklich", "vollends", "kürzlich", "kuerzlich", "jüngst", "juengst", "unlängst", "unlaengst", "neuerdings", "neulich", "letztens", "neuerlich", "verhältnismäßig", "verhaeltnismaessig", "deutlich", "klar", "offenbar", "anscheinend", "genau", "u.a", "damals", "zumindest"];

const intensifiers$g = ["sehr", "recht", "überaus", "ueberaus", "ungemein", "weitaus", "einigermaßen", "einigermassen", "ganz", "schwer", "tierisch", "ungleich", "ziemlich", "übelst", "uebelst", "stark", "volkommen", "durchaus", "gar"];

// These verbs convey little meaning.
const delexicalizedVerbs$b = ["geschienen", "meinst", "meint", "meinest", "meinet", "meinte", "meintest", "meinten", "meintet", "gemeint", "stehe", "stehst", "steht", "gehe", "gehst", "geht", "gegangen", "ging", "gingst", "gingen", "gingt"];

const delexicalizedVerbsInfinitive$6 = ["tun", "machen", "stehen", "wissen", "gehen", "kommen"];

// These adjectives and adverbs are so general, they should never be suggested as a (single) keyword.
// Keyword combinations containing these adjectives/adverbs are fine.
const generalAdjectivesAdverbs$d = ["einerlei", "egal", "neu", "neue", "neuer", "neuen", "neues", "neuem", "neuerer", "neueren", "neuerem", "neueres", "neuere", "neuester", "neuster", "neuesten", "neusten", "neuestem", "neustem", "neuestes", "neustes", "neueste", "neuste", "alt", "alter", "alten", "altem", "altes", "alte", "ältere", "älteren", "älterer", "älteres", "ältester", "ältesten", "ältestem", "ältestes", "älteste", "aeltere", "aelteren", "aelterer", "aelteres", "aeltester", "aeltesten", "aeltestem", "aeltestes", "aelteste", "gut", "guter", "gutem", "guten", "gutes", "gute", "besser", "besserer", "besseren", "besserem", "besseres", "bester", "besten", "bestem", "bestes", "beste", "größte", "grösste", "groß", "großer", "großen", "großem", "großes", "große", "großerer", "großerem", "großeren", "großeres", "großere", "großter", "großten", "großtem", "großtes", "großte", "gross", "grosser", "grossen", "grossem", "grosses", "grosse", "grosserer", "grosserem", "grosseren", "grosseres", "grossere", "grosster", "grossten", "grosstem", "grosstes", "grosste", "einfacher", "einfachen", "einfachem", "einfaches", "einfache", "einfacherer", "einfacheren", "einfacherem", "einfacheres", "einfachere", "einfachste", "einfachster", "einfachsten", "einfachstes", "einfachstem", "schnell", "schneller", "schnellen", "schnellem", "schnelles", "schnelle", "schnellere", "schnellerer", "schnelleren", "schnelleres", "schnellerem", "schnellster", "schnellste", "schnellsten", "schnellstem", "schnellstes", "weit", "weiten", "weitem", "weites", "weiterer", "weiteren", "weiterem", "weiteres", "weitere", "weitester", "weitesten", "weitestem", "weitestes", "weiteste", "eigen", "eigener", "eigenen", "eigenes", "eigenem", "eigene", "eigenerer", "eignerer", "eigeneren", "eigneren", "eigenerem", "eignerem", "eigeneres", "eigneres", "eigenere", "eignere", "eigenster", "eigensten", "eigenstem", "eigenstes", "eigenste", "wenigster", "wenigsten", "wenigstem", "wenigstes", "wenigste", "minderer", "minderen", "minderem", "mindere", "minderes", "mindester", "mindesten", "mindestes", "mindestem", "mindeste", "lang", "langer", "langen", "langem", "langes", "längerer", "längeren", "längerem", "längeres", "längere", "längster", "längsten", "längstem", "längstes", "längste", "laengerer", "laengeren", "laengerem", "laengeres", "laengere", "laengster", "laengsten", "laengstem", "laengstes", "laengste", "tief", "tiefer", "tiefen", "tiefem", "tiefes", "tiefe", "tieferer", "tieferen", "tieferem", "tieferes", "tiefere", "tiefster", "tiefsten", "tiefstem", "tiefste", "tiefstes", "hoch", "hoher", "hohen", "hohem", "hohes", "hohe", "höher", "höherer", "höhere", "höheren", "höherem", "höheres", "hoeherer", "hoehere", "hoeheren", "hoeherem", "hoeheres", "höchster", "höchste", "höchsten", "höchstem", "höchstes", "hoechster", "hoechste", "hoechsten", "hoechstem", "hoechstes", "regulär", "regulärer", "regulären", "regulärem", "reguläres", "reguläre", "regulaer", "regulaerer", "regulaeren", "regulaerem", "regulaeres", "regulaere", "regulärerer", "reguläreren", "regulärerem", "reguläreres", "regulärere", "regulaererer", "regulaereren", "regulaererem", "regulaereres", "regulaerere", "regulärster", "regulärsten", "regulärstem", "regulärstes", "regulärste", "regulaerster", "regulaersten", "regulaerstem", "regulaerstes", "regulaerste", "normal", "normaler", "normalen", "normalem", "normales", "normale", "normalerer", "normaleren", "normalerem", "normaleres", "normalere", "normalster", "normalsten", "normalstem", "normalstes", "normalste", "klein", "kleiner", "kleinen", "kleinem", "kleines", "kleine", "kleinerer", "kleineres", "kleineren", "kleinerem", "kleinere", "kleinster", "kleinsten", "kleinstem", "kleinstes", "kleinste", "winzig", "winziger", "winzigen", "winzigem", "winziges", "winzigerer", "winzigeren", "winzigerem", "winzigeres", "winzigere", "winzigster", "winzigsten", "winzigstem", "winzigste", "winzigstes", "sogenannt", "sogenannter", "sogenannten", "sogenanntem", "sogenanntes", "sogenannte", "kurz", "kurzer", "kurzen", "kurzem", "kurzes", "kurze", "kürzerer", "kürzeres", "kürzeren", "kürzerem", "kürzere", "kuerzerer", "kuerzeres", "kuerzeren", "kuerzerem", "kuerzere", "kürzester", "kürzesten", "kürzestem", "kürzestes", "kürzeste", "kuerzester", "kuerzesten", "kuerzestem", "kuerzestes", "kuerzeste", "wirklicher", "wirklichen", "wirklichem", "wirkliches", "wirkliche", "wirklicherer", "wirklicheren", "wirklicherem", "wirklicheres", "wirklichere", "wirklichster", "wirklichsten", "wirklichstes", "wirklichstem", "wirklichste", "eigentlicher", "eigentlichen", "eigentlichem", "eigentliches", "eigentliche", "schön", "schöner", "schönen", "schönem", "schönes", "schöne", "schönerer", "schöneren", "schönerem", "schöneres", "schönere", "schönster", "schönsten", "schönstem", "schönstes", "schönste", "real", "realer", "realen", "realem", "reales", "realerer", "realeren", "realerem", "realeres", "realere", "realster", "realsten", "realstem", "realstes", "realste", "derselbe", "denselben", "demselben", "desselben", "dasselbe", "dieselbe", "derselben", "dieselben", "gleicher", "gleichen", "gleichem", "gleiches", "gleiche", "gleicherer", "gleicheren", "gleicherem", "gleicheres", "gleichere", "gleichster", "gleichsten", "gleichstem", "gleichstes", "gleichste", "bestimmter", "bestimmten", "bestimmtem", "bestimmtes", "bestimmte", "bestimmtere", "bestimmterer", "bestimmterem", "bestimmteren", "bestimmteres", "bestimmtester", "bestimmtesten", "bestimmtestem", "bestimmtestes", "bestimmteste", "überwiegend", "ueberwiegend", "zumeist", "meistens", "meisten", "meiste", "meistem", "meistes", "großenteils", "grossenteils", "meistenteils", "weithin", "ständig", "staendig", "laufend", "dauernd", "andauernd", "immerfort", "irgendwo", "irgendwann", "ähnlicher", "ähnlichen", "ähnlichem", "ähnliches", "ähnliche", "ähnlich", "ähnlicherer", "ähnlicheren", "ähnlicherem", "ähnlicheres", "ähnlichere", "ähnlichster", "ähnlichsten", "ähnlichstem", "ähnlichstes", "ähnlichste", "schlecht", "schlechter", "schlechten", "schlechtem", "schlechtes", "schlechte", "schlechterer", "schlechteren", "schlechterem", "schlechteres", "schlechtere", "schlechtester", "schlechtesten", "schlechtestem", "schlechtestes", "schlechteste", "schlimm", "schlimmer", "schlimmen", "schlimmem", "schlimmes", "schlimme", "schlimmerer", "schlimmeren", "schlimmerem", "schlimmeres", "schlimmere", "schlimmster", "schlimmsten", "schlimmstem", "schlimmstes", "schlimmste", "toll", "toller", "tollen", "tollem", "tolles", "tolle", "tollerer", "tolleren", "tollerem", "tollere", "tolleres", "tollster", "tollsten", "tollstem", "tollstes", "tollste", "super", "mögliche", "möglicher", "mögliches", "möglichen", "möglichem", "möglich", "moegliche", "moeglicher", "moegliches", "moeglichen", "moeglichem", "moeglich", "nächsten", "nächster", "nächstem", "nächste", "nächstes", "naechsten", "voll", "voller", "vollen", "vollem", "volle", "volles", "vollerer", "volleren", "vollerem", "vollere", "volleres", "vollster", "vollsten", "vollstem", "vollste", "vollstes", "außen", "ganzer", "ganzen", "ganzem", "ganze", "ganzes", "gern", "gerne", "oben", "unten", "zurück", "zurueck", "nicht", "eher", "ehere", "eherem", "eheren", "eheres", "eheste", "ehestem", "ehensten", "ehesten"];

const interjections$g = ["ach", "aha", "oh", "au", "bäh", "baeh", "igitt", "huch", "hurra", "hoppla", "nanu", "oha", "olala", "pfui", "tja", "uups", "wow", "grr", "äh", "aeh", "ähm", "aehm", "öhm", "oehm", "hm", "mei", "mhm", "okay", "richtig", "eijeijeijei"];

// These words and abbreviations are frequently used in recipes in lists of ingredients.
const recipeWords$f = ["g", "el", "tl", "wg", "be", "bd", "cl", "dl", "dag", "do", "gl", "gr", "kg", "kl", "cb", "ccm", "l", "ms", "mg", "ml", "mi", "pk", "pr", "pp", "sc", "sp", "st", "sk", "ta", "tr", "cm", "mass"];

const timeWords$g = ["sekunde", "sekunden", "minute", "minuten", "stunde", "stunden", "uhr", "tag", "tages", "tags", "tage", "tagen", "woche", "wochen", "monat", "monate", "monates", "monats", "monaten", "jahr", "jahres", "jahrs", "jahre", "jahren", "morgens", "mittags", "abends", "nachts", "heute", "gestern", "morgen", "vorgestern", "übermorgen", "uebermorgen"];

const vagueNouns$g = ["ding", "dinge", "dinges", "dinger", "dingern", "dingen", "sache", "sachen", "weise", "weisen", "wahrscheinlichkeit", "zeug", "zeuge", "zeuges", "zeugen", "mal", "einmal", "teil", "teile", "teiles", "teilen", "prozent", "prozents", "prozentes", "prozente", "prozenten", "beispiel", "beispiele", "beispieles", "beispiels", "beispielen", "aspekt", "aspekte", "aspektes", "aspekts", "aspekten", "idee", "ideen", "ahnung", "ahnungen", "thema", "themas", "themata", "themen", "fall", "falle", "falles", "fälle", "fällen", "faelle", "faellen", "mensch", "menschen", "leute"];

const miscellaneous$f = ["nix", "nixe", "nixes", "nixen", "usw.", "amen", "ja", "nein", "euro"];

const titlesPreceding$8 = ["fr", "hr", "dr", "prof"];

const titlesFollowing$5 = ["jr", "jun", "sen", "sr"];

var functionWords$f = {};

var auxiliaries$a = {};

Object.defineProperty(auxiliaries$a, "__esModule", {
	value: true
});

auxiliaries$a.default = function () {
	return {
		filteredAuxiliaries: filteredAuxiliaries,
		notFilteredAuxiliaries: notFilteredAuxiliaries,
		all: filteredAuxiliaries.concat(notFilteredAuxiliaries)
	};
};

// These auxiliaries are filtered from the beginning of word combinations in the prominent words.
var filteredAuxiliaries = ["am", "is", "are", "was", "were", "been", "get", "gets", "got", "gotten", "be", "she's", "he's", "it's", "i'm", "we're", "they're", "you're", "isn't", "weren't", "wasn't", "that's", "aren't"];

// These auxiliaries are not filtered from the beginning of word combinations in the prominent words.
var notFilteredAuxiliaries = ["being", "getting", "having", "what's"];

var transitionWords$q = {};

Object.defineProperty(transitionWords$q, "__esModule", {
	value: true
});

transitionWords$q.default = function () {
	return {
		singleWords: singleWords$e,
		multipleWords: multipleWords$e,
		allWords: singleWords$e.concat(multipleWords$e)
	};
};

/** @module config/transitionWords */

var singleWords$e = ["accordingly", "additionally", "afterward", "afterwards", "albeit", "also", "although", "altogether", "another", "basically", "because", "before", "besides", "but", "certainly", "chiefly", "comparatively", "concurrently", "consequently", "contrarily", "conversely", "correspondingly", "despite", "doubtedly", "during", "e.g.", "earlier", "emphatically", "equally", "especially", "eventually", "evidently", "explicitly", "finally", "firstly", "following", "formerly", "forthwith", "fourthly", "further", "furthermore", "generally", "hence", "henceforth", "however", "i.e.", "identically", "indeed", "initially", "instead", "last", "lastly", "later", "lest", "likewise", "markedly", "meanwhile", "moreover", "nevertheless", "nonetheless", "nor", "notwithstanding", "obviously", "occasionally", "otherwise", "overall", "particularly", "presently", "previously", "rather", "regardless", "secondly", "shortly", "significantly", "similarly", "simultaneously", "since", "so", "soon", "specifically", "still", "straightaway", "subsequently", "surely", "surprisingly", "than", "then", "thereafter", "therefore", "thereupon", "thirdly", "though", "thus", "till", "undeniably", "undoubtedly", "unless", "unlike", "unquestionably", "until", "when", "whenever", "whereas", "while"];
var multipleWords$e = ["above all", "after all", "after that", "all in all", "all of a sudden", "all things considered", "analogous to", "although this may be true", "analogous to", "another key point", "as a matter of fact", "as a result", "as an illustration", "as can be seen", "as has been noted", "as I have noted", "as I have said", "as I have shown", "as long as", "as much as", "as opposed to", "as shown above", "as soon as", "as well as", "at any rate", "at first", "at last", "at least", "at length", "at the present time", "at the same time", "at this instant", "at this point", "at this time", "balanced against", "being that", "by all means", "by and large", "by comparison", "by the same token", "by the time", "compared to", "be that as it may", "coupled with", "different from", "due to", "equally important", "even if", "even more", "even so", "even though", "first thing to remember", "for example", "for fear that", "for instance", "for one thing", "for that reason", "for the most part", "for the purpose of", "for the same reason", "for this purpose", "for this reason", "from time to time", "given that", "given these points", "important to realize", "in a word", "in addition", "in another case", "in any case", "in any event", "in brief", "in case", "in conclusion", "in contrast", "in detail", "in due time", "in effect", "in either case", "in essence", "in fact", "in general", "in light of", "in like fashion", "in like manner", "in order that", "in order to", "in other words", "in particular", "in reality", "in short", "in similar fashion", "in spite of", "in sum", "in summary", "in that case", "in the event that", "in the final analysis", "in the first place", "in the fourth place", "in the hope that", "in the light of", "in the long run", "in the meantime", "in the same fashion", "in the same way", "in the second place", "in the third place", "in this case", "in this situation", "in time", "in truth", "in view of", "inasmuch as", "most compelling evidence", "most important", "must be remembered", "not only", "not to mention", "note that", "now that", "of course", "on account of", "on balance", "on condition that", "on one hand", "on the condition that", "on the contrary", "on the negative side", "on the other hand", "on the positive side", "on the whole", "on this occasion", "once", "once in a while", "only if", "owing to", "point often overlooked", "prior to", "provided that", "seeing that", "so as to", "so far", "so long as", "so that", "sooner or later", "such as", "summing up", "take the case of", "that is", "that is to say", "then again", "this time", "to be sure", "to begin with", "to clarify", "to conclude", "to demonstrate", "to emphasize", "to enumerate", "to explain", "to illustrate", "to list", "to point out", "to put it another way", "to put it differently", "to repeat", "to rephrase it", "to say nothing of", "to sum up", "to summarize", "to that end", "to the end that", "to this end", "together with", "under those circumstances", "until now", "up against", "up to the present time", "vis a vis", "what's more", "while it may be true", "while this may be true", "with attention to", "with the result that", "with this in mind", "with this intention", "with this purpose in mind", "without a doubt", "without delay", "without doubt", "without reservation"];

Object.defineProperty(functionWords$f, "__esModule", {
	value: true
});

functionWords$f.default = function () {
	return {
		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(ordinalNumerals$f, continuousVerbs, generalAdjectivesAdverbs$c),

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(articles$b, prepositions$e, coordinatingConjunctions$a, demonstrativePronouns$b, intensifiers$f, quantifiers$f, possessivePronouns$9),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(transitionWords$p, adverbialGenitives$4, personalPronounsNominative$9, personalPronounsAccusative$7, reflexivePronouns$c, interjections$f, cardinalNumerals$f, filteredPassiveAuxiliaries$3, otherAuxiliaries$8, copula$8, interviewVerbs$f, delexicalizedVerbs$a, indefinitePronouns$f, correlativeConjunctions$5, subordinatingConjunctions$a, interrogativeDeterminers$6, interrogativePronouns$8, interrogativeProAdverbs$8, locativeAdverbs$8, miscellaneous$e, prepositionalAdverbs$4, pronominalAdverbs$4, recipeWords$e, timeWords$f, vagueNouns$f),

		// These categories are used in the passive voice assessment. If they directly precede a participle, the sentence part is not passive.
		cannotDirectlyPrecedePassiveParticiple: [].concat(articles$b, prepositions$e, demonstrativePronouns$b, possessivePronouns$9, ordinalNumerals$f, continuousVerbs, quantifiers$f),

		/*
  These categories are used in the passive voice assessment. If they appear between an auxiliary and a participle,
  the sentence part is not passive.
  */
		cannotBeBetweenPassiveAuxiliaryAndParticiple: [].concat(otherAuxiliaries$8, copula$8, interviewVerbs$f, delexicalizedVerbs$a),

		// This export contains all of the above words.
		all: [].concat(articles$b, cardinalNumerals$f, ordinalNumerals$f, demonstrativePronouns$b, possessivePronouns$9, reflexivePronouns$c, personalPronounsNominative$9, personalPronounsAccusative$7, quantifiers$f, indefinitePronouns$f, continuousVerbs, indefinitePronounsPossessive$2, interrogativeDeterminers$6, interrogativePronouns$8, interrogativeProAdverbs$8, pronominalAdverbs$4, locativeAdverbs$8, adverbialGenitives$4, prepositionalAdverbs$4, filteredPassiveAuxiliaries$3, notFilteredPassiveAuxiliaries, otherAuxiliaries$8, copula$8, prepositions$e, coordinatingConjunctions$a, correlativeConjunctions$5, subordinatingConjunctions$a, interviewVerbs$f, transitionWords$p, additionalTransitionWords$8, intensifiers$f, delexicalizedVerbs$a, interjections$f, generalAdjectivesAdverbs$c, recipeWords$e, vagueNouns$f, miscellaneous$e, titlesPreceding$7, titlesFollowing$4)
	};
};

var _auxiliaries$4 = auxiliaries$a;

var _auxiliaries2$4 = _interopRequireDefault$2W(_auxiliaries$4);

var _transitionWords$a = transitionWords$q;

var _transitionWords2$a = _interopRequireDefault$2W(_transitionWords$a);

function _interopRequireDefault$2W(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const filteredPassiveAuxiliaries$3 = (0, _auxiliaries2$4.default)().filteredAuxiliaries;

const notFilteredPassiveAuxiliaries = (0, _auxiliaries2$4.default)().notFilteredAuxiliaries;

const transitionWords$p = (0, _transitionWords2$a.default)().singleWords;

/**
 * Returns an object with exceptions for the prominent words researcher
 * @returns {Object} The object filled with exception arrays.
 */

const articles$b = ["the", "an", "a"];
const cardinalNumerals$f = ["one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen", "twenty", "hundred", "hundreds", "thousand", "thousands", "million", "millions", "billion", "billions"];

const ordinalNumerals$f = ["first", "second", "third", "fourth", "fifth", "sixth", "seventh", "eighth", "ninth", "tenth", "eleventh", "twelfth", "thirteenth", "fourteenth", "fifteenth", "sixteenth", "seventeenth", "eighteenth", "nineteenth", "twentieth"];

const personalPronounsNominative$9 = ["i", "you", "he", "she", "it", "we", "they"];
const personalPronounsAccusative$7 = ["me", "him", "us", "them"];
const demonstrativePronouns$b = ["this", "that", "these", "those"];
const possessivePronouns$9 = ["my", "your", "his", "her", "its", "their", "our", "mine", "yours", "hers", "theirs", "ours"];
const quantifiers$f = ["all", "some", "many", "lot", "lots", "ton", "tons", "bit", "no", "every", "enough", "little", "much", "more", "most", "plenty", "several", "few", "fewer", "kind", "kinds"];
const reflexivePronouns$c = ["myself", "yourself", "himself", "herself", "itself", "oneself", "ourselves", "yourselves", "themselves"];
const indefinitePronouns$f = ["none", "nobody", "everyone", "everybody", "someone", "somebody", "anyone", "anybody", "nothing", "everything", "something", "anything", "each", "other", "whatever", "whichever", "whoever", "whomever", "whomsoever", "whosoever", "others", "neither", "both", "either", "any", "such"];
const indefinitePronounsPossessive$2 = ["one's", "nobody's", "everyone's", "everybody's", "someone's", "somebody's", "anyone's", "anybody's", "nothing's", "everything's", "something's", "anything's", "whoever's", "others'", "other's", "another's", "neither's", "either's"];

const interrogativeDeterminers$6 = ["which", "what", "whose"];
const interrogativePronouns$8 = ["who", "whom"];
const interrogativeProAdverbs$8 = ["where", "how", "why", "whether", "wherever", "whyever", "wheresoever", "whensoever", "howsoever", "whysoever", "whatsoever", "whereso", "whomso", "whenso", "howso", "whyso", "whoso", "whatso"];
const pronominalAdverbs$4 = ["therefor", "therein", "hereby", "hereto", "wherein", "therewith", "herewith", "wherewith", "thereby"];
const locativeAdverbs$8 = ["there", "here", "whither", "thither", "hither", "whence", "thence"];
const adverbialGenitives$4 = ["always", "once", "twice", "thrice"];
const otherAuxiliaries$8 = ["can", "cannot", "can't", "could", "couldn't", "could've", "dare", "dares", "dared", "do", "don't", "does", "doesn't", "did", "didn't", "done", "have", "haven't", "had", "hadn't", "has", "hasn't", "i've", "you've", "we've", "they've", "i'd", "you'd", "he'd", "she'd", "it'd", "we'd", "they'd", "would", "wouldn't", "would've", "may", "might", "must", "need", "needn't", "needs", "ought", "shall", "shalln't", "shan't", "should", "shouldn't", "will", "won't", "i'll", "you'll", "he'll", "she'll", "it'll", "we'll", "they'll", "there's", "there're", "there'll", "here's", "here're", "there'll"];
const copula$8 = ["appear", "appears", "appeared", "become", "becomes", "became", "come", "comes", "came", "keep", "keeps", "kept", "remain", "remains", "remained", "stay", "stays", "stayed", "turn", "turns", "turned"];

// These verbs should only be included at the beginning of combinations.
const continuousVerbs = ["doing", "daring", "having", "appearing", "becoming", "coming", "keeping", "remaining", "staying", "saying", "asking", "stating", "seeming", "letting", "making", "setting", "showing", "putting", "adding", "going", "using", "trying", "containing"];

const prepositions$e = ["in", "from", "with", "under", "throughout", "atop", "for", "on", "of", "to", "aboard", "about", "above", "abreast", "absent", "across", "adjacent", "after", "against", "along", "alongside", "amid", "mid", "among", "apropos", "apud", "around", "as", "astride", "at", "ontop", "afore", "tofore", "behind", "ahind", "below", "ablow", "beneath", "neath", "beside", "between", "atween", "beyond", "ayond", "by", "chez", "circa", "spite", "down", "except", "into", "less", "like", "minus", "near", "nearer", "nearest", "anear", "notwithstanding", "off", "onto", "opposite", "out", "outen", "over", "past", "per", "pre", "qua", "sans", "sauf", "sithence", "through", "thru", "truout", "toward", "underneath", "up", "upon", "upside", "versus", "via", "vis-à-vis", "without", "ago", "apart", "aside", "aslant", "away", "withal", "towards", "amidst", "amongst", "midst", "whilst"];

// Many prepositional adverbs are already listed as preposition.
const prepositionalAdverbs$4 = ["back", "within", "forward", "backward", "ahead"];

const coordinatingConjunctions$a = ["and", "or", "and/or", "yet"];

// 'sooner' is part of 'no sooner...than', 'just' is part of 'just as...so',
// 'Only' is part of 'not only...but also'.
const correlativeConjunctions$5 = ["sooner", "just", "only"];
const subordinatingConjunctions$a = ["if", "even"];

// These verbs are frequently used in interviews to indicate questions and answers.
// 'Claim','claims', 'state' and 'states' are not included, because these words are also nouns.
const interviewVerbs$f = ["say", "says", "said", "claimed", "ask", "asks", "asked", "stated", "explain", "explains", "explained", "think", "thinks", "talks", "talked", "announces", "announced", "tells", "told", "discusses", "discussed", "suggests", "suggested", "understands", "understood"];

// These transition words were not included in the list for the transition word assessment for various reasons.
const additionalTransitionWords$8 = ["again", "definitely", "eternally", "expressively", "instead", "expressly", "immediately", "including", "instantly", "namely", "naturally", "next", "notably", "now", "nowadays", "ordinarily", "positively", "truly", "ultimately", "uniquely", "usually", "almost", "maybe", "probably", "granted", "initially", "too", "actually", "already", "e.g", "i.e", "often", "regularly", "simply", "optionally", "perhaps", "sometimes", "likely", "never", "ever", "else", "inasmuch", "provided", "currently", "incidentally", "elsewhere", "particular", "recently", "relatively", "f.i", "clearly", "apparently"];

const intensifiers$f = ["highly", "very", "really", "extremely", "absolutely", "completely", "totally", "utterly", "quite", "somewhat", "seriously", "fairly", "fully", "amazingly"];

/* These verbs convey little meaning. 'Show', 'shows', 'uses', 'meaning', 'set', 'sets'
 are not included, because these words could be relevant nouns.

 */
const delexicalizedVerbs$a = ["seem", "seems", "seemed", "let", "let's", "lets", "make", "makes", "made", "want", "showed", "shown", "go", "goes", "went", "gone", "take", "takes", "took", "taken", "put", "puts", "use", "used", "try", "tries", "tried", "mean", "means", "meant", "called", "based", "add", "adds", "added", "contain", "contains", "contained", "consist", "consists", "consisted", "ensure", "ensures", "ensured"];

// These adjectives and adverbs are so general, they should never be suggested as a (single) keyword.
// Keyword combinations containing these adjectives/adverbs are fine.
const generalAdjectivesAdverbs$c = ["new", "newer", "newest", "old", "older", "oldest", "previous", "good", "well", "better", "best", "big", "bigger", "biggest", "easy", "easier", "easiest", "fast", "faster", "fastest", "far", "hard", "harder", "hardest", "least", "own", "large", "larger", "largest", "long", "longer", "longest", "low", "lower", "lowest", "high", "higher", "highest", "regular", "simple", "simpler", "simplest", "small", "smaller", "smallest", "tiny", "tinier", "tiniest", "short", "shorter", "shortest", "main", "actual", "nice", "nicer", "nicest", "real", "same", "able", "certain", "usual", "so-called", "mainly", "mostly", "recent", "anymore", "complete", "lately", "possible", "commonly", "constantly", "continually", "directly", "easily", "nearly", "slightly", "somewhere", "estimated", "latest", "different", "similar", "widely", "bad", "worse", "worst", "great", "specific", "available", "average", "awful", "awesome", "basic", "beautiful", "busy", "current", "entire", "everywhere", "important", "major", "multiple", "normal", "necessary", "obvious", "partly", "special", "last", "early", "earlier", "earliest", "young", "younger", "youngest", ""];

const interjections$f = ["oh", "wow", "tut-tut", "tsk-tsk", "ugh", "whew", "phew", "yeah", "yea", "shh", "oops", "ouch", "aha", "yikes"];

// These words and abbreviations are frequently used in recipes in lists of ingredients.
const recipeWords$e = ["tbs", "tbsp", "spk", "lb", "qt", "pk", "bu", "oz", "pt", "mod", "doz", "hr", "f.g", "ml", "dl", "cl", "l", "mg", "g", "kg", "quart"];

const timeWords$f = ["seconds", "minute", "minutes", "hour", "hours", "day", "days", "week", "weeks", "month", "months", "year", "years", "today", "tomorrow", "yesterday"];

// 'People' should only be removed in combination with 'some', 'many' and 'few' (and is therefore not yet included in the list below).
const vagueNouns$f = ["thing", "things", "way", "ways", "matter", "case", "likelihood", "ones", "piece", "pieces", "stuff", "times", "part", "parts", "percent", "instance", "instances", "aspect", "aspects", "item", "items", "idea", "theme", "person", "instance", "instances", "detail", "details", "factor", "factors", "difference", "differences"];

// 'No' is already included in the quantifier list.
const miscellaneous$e = ["not", "yes", "sure", "top", "bottom", "ok", "okay", "amen", "aka", "etc", "etcetera", "sorry", "please"];

const titlesPreceding$7 = ["ms", "mss", "mrs", "mr", "dr", "prof"];

const titlesFollowing$4 = ["jr", "sr"];

var functionWords$e = {};

var transitionWords$o = {};

Object.defineProperty(transitionWords$o, "__esModule", {
	value: true
});

transitionWords$o.default = function () {
	return {
		singleWords: singleWords$d,
		multipleWords: multipleWords$d,
		allWords: singleWords$d.concat(multipleWords$d)
	};
};

const singleWords$d = ["aangezien", "al", "aldus", "allereerst", "als", "alsook", "anderzijds", "bijgevolg", "bijvoorbeeld", "bovendien", "concluderend", "daardoor", "daarentegen", "daarmee", "daarna", "daarnaast", "daarom", "daartoe", "daarvoor", "dadelijk", "dan", "desondanks", "dienovereenkomstig", "dientegevolge", "doch", "doordat", "dus", "echter", "eerst", "evenals", "eveneens", "evenzeer", "hierom", "hoewel", "immers", "indien", "integendeel", "intussen", "kortom", "later", "maar", "mits", "nadat", "namelijk", "net als", "niettemin", "noch", "ofschoon", "omdat", "ondanks", "ondertussen", "ook", "opdat", "resumerend", "samengevat", "samenvattend", "tegenwoordig", "teneinde", "tenzij", "terwijl", "tevens", "toch", "toen", "uiteindelijk", "vanwege", "vervolgens", "voorafgaand", "vooralsnog", "voordat", "voorts", "vroeger", "waardoor", "waarmee", "waaronder", "wanneer", "want", "zoals", "zodat", "zodoende", "zodra"];

const multipleWords$d = ["aan de andere kant", "aan de ene kant", "aangenomen dat", "al met al", "alles afwegend", "alles bij elkaar", "alles in aanmerking nemend", "als gevolg van", "anders gezegd", "daar staat tegenover", "daarbij komt", "daaruit volgt", "dat betekent", "dat blijkt uit", "de oorzaak daarvan is", "de oorzaak hiervan is", "door middel van", "een voorbeeld hiervan", "een voorbeeld van", "gesteld dat", "hetzelfde als", "hieruit kunnen we afleiden", "hieruit volgt", "hoe het ook zij", "in de derde plaats", "in de eerste plaats", "in de tweede plaats", "in één woord", "in het bijzonder", "in het geval dat", "in plaats van", "in tegenstelling tot", "in vergelijking met", "maar ook", "met als doel", "met andere woorden", "met behulp van", "met de bedoeling", "neem nou", "net als", "om kort te gaan", "onder andere", "op dezelfde wijze", "stel dat", "te danken aan", "te wijten aan", "ten derde", "ten eerste", "ten gevolge van", "ten slotte", "ten tweede", "ter conclusie", "ter illustratie", "ter verduidelijking", "tot nog toe", "tot slot", "vandaar dat", "vergeleken met", "voor het geval dat"];

Object.defineProperty(functionWords$e, "__esModule", {
	value: true
});

functionWords$e.default = function () {
	return {
		// These word categories are filtered at the ending of word combinations.
		filteredAtBeginning: [].concat(passiveAuxiliariesInfinitive$2, otherAuxiliariesInfinitive$5, copulaInfinitive$4, delexicalizedVerbsInfinitive$5),

		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(ordinalNumerals$e, generalAdjectivesAdverbs$b),

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(articles$a, prepositions$d, coordinatingConjunctions$9, demonstrativePronouns$a, intensifiers$e, quantifiers$e),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(transitionWords$n, personalPronounsNominative$8, personalPronounsAccusative$6, reflexivePronouns$b, interjections$e, cardinalNumerals$e, filteredPassiveAuxiliaries$2, otherAuxiliaries$7, copula$7, interviewVerbs$e, delexicalizedVerbs$9, indefinitePronouns$e, correlativeConjunctions$4, subordinatingConjunctions$9, interrogativeProAdverbs$7, relativePronouns$3, locativeAdverbs$7, miscellaneous$d, prepositionalAdverbs$3, pronominalAdverbs$3, recipeWords$d, timeWords$e, vagueNouns$e, reciprocalPronouns, possessivePronouns$8),

		cannotDirectlyPrecedePassiveParticiple: [].concat(articles$a, interrogativeProAdverbs$7, cardinalNumerals$e, possessivePronouns$8, reflexivePronouns$b, indefinitePronounsPossessive$1, copula$7, copulaInfinitive$4, prepositions$d),

		// This export contains all of the above words.
		all: [].concat(articles$a, cardinalNumerals$e, ordinalNumerals$e, demonstrativePronouns$a, possessivePronouns$8, reflexivePronouns$b, reciprocalPronouns, personalPronounsNominative$8, personalPronounsAccusative$6, quantifiers$e, indefinitePronouns$e, indefinitePronounsPossessive$1, relativePronouns$3, interrogativeProAdverbs$7, pronominalAdverbs$3, locativeAdverbs$7, prepositionalAdverbs$3, filteredPassiveAuxiliaries$2, passiveAuxiliariesInfinitive$2, otherAuxiliaries$7, otherAuxiliariesInfinitive$5, copula$7, copulaInfinitive$4, prepositions$d, coordinatingConjunctions$9, correlativeConjunctions$4, subordinatingConjunctions$9, interviewVerbs$e, transitionWords$n, additionalTransitionWords$7, intensifiers$e, delexicalizedVerbs$9, delexicalizedVerbsInfinitive$5, interjections$e, generalAdjectivesAdverbs$b, recipeWords$d, vagueNouns$e, miscellaneous$d, titlesPreceding$6, titlesFollowing$3)
	};
};

var _transitionWords$9 = transitionWords$o;

var _transitionWords2$9 = _interopRequireDefault$2V(_transitionWords$9);

function _interopRequireDefault$2V(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const transitionWords$n = (0, _transitionWords2$9.default)().singleWords;

/**
 * Returns an array with exceptions for the prominent words researcher.
 * @returns {Array} The array filled with exceptions.
 */

const articles$a = ["de", "het", "een", "der", "des", "den"];

const cardinalNumerals$e = ["eén", "één", "twee", "drie", "vier", "vijf", "zes", "zeven", "acht", "negen", "tien", "elf", "twaalf", "dertien", "veertien", "vijftien", "zestien", "zeventien", "achttien", "negentien", "twintig", "honderd", "honderden", "duizend", "duizenden", "miljoen", "miljoenen", "biljoen", "biljoenen"];

const ordinalNumerals$e = ["eerste", "tweede", "derde", "vierde", "vijfde", "zesde", "zevende", "achtste", "negende", "tiende", "elfde", "twaalfde", "dertiende", "veertiende", "vijftiende", "zestiende", "zeventiende", "achttiende", "negentiende", "twinstigste"];

// 'Het' is already included in the list of articles.
const personalPronounsNominative$8 = ["ik", "je", "jij", "hij", "ze", "we", "wij", "jullie", "zij", "u", "ge", "gij", "men"];
const personalPronounsAccusative$6 = ["mij", "jou", "hem", "haar", "hen", "hun", "uw"];
const demonstrativePronouns$a = ["dit", "dat", "deze", "die", "zelf"];

// What to do with 'zijn', since it is also a verb?
const possessivePronouns$8 = ["mijn", "mijne", "jouw", "jouwe", "zijne", "hare", "ons", "onze", "hunne", "uwe", "elkaars", "elkanders"];
const quantifiers$e = ["alle", "sommige", "sommigen", "weinig", "weinige", "weinigen", "veel", "vele", "velen", "geen", "beetje", "elke", "elk", "genoeg", "meer", "meest", "meeste", "meesten", "paar", "zoveel", "enkele", "enkelen", "zoveelste", "hoeveelste", "laatste", "laatsten", "iedere", "allemaal", "zekere", "ander", "andere", "gene", "enig", "enige", "verscheidene", "verschillende", "voldoende", "allerlei", "allerhande", "enerlei", "enerhande", "beiderlei", "beiderhande", "tweeërlei", "tweeërhande", "drieërlei", "drieërhande", "velerlei", "velerhande", "menigerlei", "menigerhande", "enigerlei", "enigerhande", "generlei", "generhande"];

const reflexivePronouns$b = ["mezelf", "mijzelf", "jezelf", "jouzelf", "zichzelf", "haarzelf", "hemzelf", "onszelf", "julliezelf", "henzelf", "hunzelf", "uzelf", "zich"];

const reciprocalPronouns = ["mekaar", "elkaar", "elkander", "mekander"];

const indefinitePronouns$e = ["iedereen", "ieder", "eenieder", "alleman", "allen", "alles", "iemand", "niemand", "iets", "niets", "menigeen"];

const indefinitePronounsPossessive$1 = ["ieders", "aller", "iedereens", "eenieders"];

const relativePronouns$3 = ["welke", "welk", "wat", "wie", "wiens", "wier"];

const interrogativeProAdverbs$7 = ["hoe", "waarom", "waar", "hoezo", "hoeveel"];

const pronominalAdverbs$3 = ["daaraan", "daarachter", "daaraf", "daarbij", "daarbinnen", "daarboven", "daarbuiten", "daardoorheen", "daarheen", "daarin", "daarjegens", "daarmede", "daarnaar", "daarnaartoe", "daaromtrent", "daaronder", "daarop", "daarover", "daaroverheen", "daarrond", "daartegen", "daartussen", "daartussenuit", "daaruit", "daarvan", "daarvandaan", "eraan", "erachter", "erachteraan", "eraf", "erbij", "erbinnen", "erboven", "erbuiten", "erdoor", "erdoorheen", "erheen", "erin", "erjegens", "ermede", "ermee", "erna", "ernaar", "ernaartoe", "ernaast", "erom", "eromtrent", "eronder", "eronderdoor", "erop", "eropaf", "eropuit", "erover", "eroverheen", "errond", "ertegen", "ertegenaan", "ertoe", "ertussen", "ertussenuit", "eruit", "ervan", "ervandaan", "ervandoor", "ervoor", "hieraan", "hierachter", "hieraf", "hierbij", "hierbinnen", "hierboven", "hierbuiten", "hierdoor", "hierdoorheen", "hierheen", "hierin", "hierjegens", "hierlangs", "hiermede", "hiermee", "hierna", "hiernaar", "hiernaartoe", "hiernaast", "hieromheen", "hieromtrent", "hieronder", "hierop", "hierover", "hieroverheen", "hierrond", "hiertegen", "hiertoe", "hiertussen", "hiertussenuit", "hieruit", "hiervan", "hiervandaan", "hiervoor", "vandaan", "waaraan", "waarachter", "waaraf", "waarbij", "waarboven", "waarbuiten", "waardoorheen", "waarheen", "waarin", "waarjegens", "waarmede", "waarna", "waarnaar", "waarnaartoe", "waarnaast", "waarop", "waarover", "waaroverheen", "waarrond", "waartegen", "waartegenin", "waartoe", "waartussen", "waartussenuit", "waaruit", "waarvan", "waarvandaan", "waarvoor"];

const locativeAdverbs$7 = ["daar", "hier", "ginder", "daarginds", "ginds", "ver", "veraf", "ergens", "nergens", "overal", "dichtbij", "kortbij"];

const filteredPassiveAuxiliaries$2 = ["word", "wordt", "werd", "werden", "ben", "bent", "is", "was", "waren"];

const passiveAuxiliariesInfinitive$2 = ["worden", "zijn"];

const otherAuxiliaries$7 = ["heb", "hebt", "heeft", "hadden", "had", "kun", "kan", "kunt", "kon", "konden", "mag", "mocht", "mochten", "dien", "dient", "diende", "dienden", "moet", "moest", "moesten", "ga", "gaat", "ging", "gingen"];

const otherAuxiliariesInfinitive$5 = ["hebben", "kunnen", "mogen", "dienen", "moeten", "gaan"];

// 'Vóórkomen' (appear) is not included, because we don't want to filter out 'voorkómen' (prevent).
const copula$7 = ["blijkt", "blijk", "bleek", "bleken", "gebleken", "dunkt", "dunk", "dunkte", "dunkten", "gedunkt", "heet", "heette", "heetten", "geheten", "lijkt", "lijk", "geleken", "leek", "leken", "schijn", "schijnt", "scheen", "schenen", "toescheen", "toeschijnt", "toeschijn", "toeschenen"];

const copulaInfinitive$4 = ["blijken", "dunken", "heten", "lijken", "schijnen", "toeschijnen"];

const prepositions$d = ["à", "aan", "aangaande", "achter", "behalve", "behoudens", "beneden", "benevens", "benoorden", "benoordoosten", "benoordwesten", "beoosten", "betreffende", "bewesten", "bezijden", "bezuiden", "bezuidoosten", "bezuidwesten", "bij", "binnen", "blijkens", "boven", "bovenaan", "buiten", "circa", "conform", "contra", "cum", "dankzij", "door", "gedurende", "gezien", "in", "ingevolge", "inzake", "jegens", "krachtens", "langs", "luidens", "met", "middels", "na", "naar", "naast", "nabij", "namens", "nevens", "niettegenstaande", "nopens", "om", "omstreeks", "omtrent", "onder", "onderaan", "ongeacht", "onverminderd", "op", "over", "overeenkomstig", "per", "plus", "post", "richting", "rond", "rondom", "spijts", "staande", "te", "tegen", "tegenover", "ten", "ter", "tijdens", "tot", "tussen", "uit", "van", "vanaf", "vanuit", "versus", "via", "vis-à-vis", "volgens", "voor", "voorbij", "wegens", "zijdens", "zonder"];

// Many prepositional adverbs are already listed as preposition.
const prepositionalAdverbs$3 = ["af", "heen", "mee", "toe", "achterop", "onderin", "voorin", "bovenop", "buitenop", "achteraan", "onderop", "binnenin", "tevoren"];

const coordinatingConjunctions$9 = ["en", "alsmede", "of", "ofwel", "en/of"];

/* 'Zowel' and 'als' are part of 'zowel...als', 'evenmin' is part of 'evenmin...als', 'zomin' is part of 'zomin...als',
 'hetzij' is part of 'hetzij...hetzij'. */
const correlativeConjunctions$4 = ["zowel", "evenmin", "zomin", "hetzij"];

const subordinatingConjunctions$9 = ["vermits", "dewijl", "dorodien", "naardien", "nademaal", "overmits", "wijl", "eer", "eerdat", "aleer", "vooraleer", "alvorens", "totdat", "zolang", "sinds", "sedert", "ingeval", "tenware", "alhoewel", "hoezeer", "uitgezonderd", "zoverre", "zover", "naargelang", "naarmate", "alsof"];

// These verbs are frequently used in interviews to indicate questions and answers.
const interviewVerbs$e = ["zegt", "zei", "vraagt", "vroeg", "denkt", "dacht", "stelt", "pleit", "pleitte"];

// These transition words were not included in the list for the transition word assessment for various reasons.
const additionalTransitionWords$7 = ["absoluut", "zeker", "ongetwijfeld", "sowieso", "onmiddelijk", "meteen", "inclusief", "direct", "ogenblikkelijk", "terstond", "natuurlijk", "vanzelfsprekend", "gewoonlijk", "normaliter", "doorgaans", "werkelijk", "daadwerkelijk", "inderdaad", "waarachtig", "oprecht", "bijna", "meestal", "misschien", "waarschijnlijk", "wellicht", "mogelijk", "vermoedelijk", "allicht", "aannemelijk", "oorspronkelijk", "aanvankelijk", "initieel", "eigenlijk", "feitelijk", "wezenlijk", "juist", "reeds", "alvast", "bijv.", "vaak", "dikwijls", "veelal", "geregeld", "menigmaal", "regelmatig", "veelvuldig", "eenvoudigweg", "simpelweg", "louter", "kortweg", "stomweg", "domweg", "zomaar", "eventueel", "mogelijkerwijs", "eens", "weleens", "nooit", "ooit", "anders", "momenteel", "thans", "incidenteel", "trouwens", "elders", "volgend", "recent", "onlangs", "recentelijk", "laatst", "zojuist", "relatief", "duidelijk", "overduidelijk", "klaarblijkelijk", "nadrukkelijk", "ogenschijnlijk", "kennelijk", "schijnbaar", "alweer", "continu", "herhaaldelijk", "nog", "steeds", "nu"];

// 'vrij' is not included because it also means 'free'.
const intensifiers$e = ["zeer", "erg", "redelijk", "flink", "tikkeltje", "bijzonder", "ernstig", "enigszins", "zo", "tamelijk", "nogal", "behoorlijk", "zwaar", "heel", "hele", "reuze", "buitengewoon", "ontzettend", "vreselijk"];

// These verbs convey little meaning.
const delexicalizedVerbs$9 = ["laat", "liet", "lieten", "kom", "komt", "kwam", "kwamen", "maakt", "maak", "maakte", "maakten", "doe", "doet", "deed", "deden", "vindt", "vind", "vond", "vonden"];

const delexicalizedVerbsInfinitive$5 = ["laten", "komen", "maken", "doen", "vinden"];

/* These adjectives and adverbs are so general, they should never be suggested as a (single) keyword.
Keyword combinations containing these adjectives/adverbs are fine. */
const generalAdjectivesAdverbs$b = ["nieuw", "nieuwe", "nieuwer", "nieuwere", "nieuwst", "nieuwste", "oud", "oude", "ouder", "oudere", "oudst", "oudste", "vorig", "vorige", "goed", "goede", "beter", "betere", "best", "beste", "groot", "grote", "groter", "grotere", "grootst", "grootste", "makkelijk", "makkelijke", "makkelijker", "makkelijkere", "makkelijkst", "makkelijste", "gemakkelijk", "gemakkelijke", "gemakkelijker", "gemakkelijkere", "gemakkelijkst", "gemakkelijste", "simpel", "simpele", "simpeler", "simpelere", "simpelst", "simpelste", "snel", "snelle", "sneller", "snellere", "snelst", "snelste", "verre", "verder", "verdere", "verst", "verste", "lang", "lange", "langer", "langere", "langst", "langste", "hard", "harde", "harder", "hardere", "hardst", "hardste", "minder", "mindere", "minst", "minste", "eigen", "laag", "lage", "lager", "lagere", "laagst", "laagste", "hoog", "hoge", "hoger", "hogere", "hoogst", "hoogste", "klein", "kleine", "kleiner", "kleinere", "kleinst", "kleinste", "kort", "korte", "korter", "kortere", "kortst", "kortste", "herhaaldelijke", "directe", "ongeveer", "slecht", "slechte", "slechter", "slechtere", "slechtst", "slechtste", "zulke", "zulk", "zo'n", "zulks", "er", "extreem", "extreme", "bijbehorende", "bijbehorend", "niet"];

const interjections$e = ["oh", "wauw", "hèhè", "hè", "hé", "au", "ai", "jaja", "welja", "jawel", "ssst", "heremijntijd", "hemeltjelief", "aha", "foei", "hmm", "nou", "nee", "tja", "nja", "okido", "ho", "halt", "komaan", "komop", "verrek", "nietwaar", "brr", "oef", "ach", "och", "bah", "enfin", "afijn", "haha", "hihi", "hatsjie", "hatsjoe", "hm", "tring", "vroem", "boem", "hopla"];

// These words and abbreviations are frequently used in recipes in lists of ingredients.
const recipeWords$d = ["ml", "cl", "dl", "l", "tl", "el", "mg", "g", "gr", "kg", "ca", "theel", "min", "sec", "uur"];

const timeWords$e = ["seconde", "secondes", "seconden", "minuut", "minuten", "uur", "uren", "dag", "dagen", "week", "weken", "maand", "maanden", "jaar", "jaren", "vandaag", "morgen", "overmorgen", "gisteren", "eergisteren", "'s", "morgens", "avonds", "middags", "nachts"];

const vagueNouns$e = ["ding", "dingen", "manier", "manieren", "item", "items", "keer", "maal", "procent", "geval", "aspect", "persoon", "personen", "deel"];

const miscellaneous$d = ["wel", "ja", "neen", "oké", "oke", "okee", "ok", "zoiets", "€", "euro"];

const titlesPreceding$6 = ["mevr", "dhr", "mr", "dr", "prof"];

const titlesFollowing$3 = ["jr", "sr"];

var functionWords$d = {};

var transitionWords$m = {};

Object.defineProperty(transitionWords$m, "__esModule", {
	value: true
});

transitionWords$m.default = function () {
	return {
		singleWords: singleWords$c,
		multipleWords: multipleWords$c,
		allWords: singleWords$c.concat(multipleWords$c)
	};
};

/** @module config/transitionWords */

const singleWords$c = ["además", "adicional", "así", "asimismo", "aún", "aunque", "ciertamente", "como", "concluyendo", "conque", "contrariamente", "cuando", "decididamente", "decisivamente", "después", "diferentemente", "efectivamente", "entonces", "especialmente", "específicamente", "eventualmente", "evidentemente", "finalmente", "frecuentemente", "generalmente", "igualmente", "lógicamente", "luego", "mas", "mientras", "pero", "por", "porque", "posteriormente", "primero", "principalmente", "pronto", "próximamente", "pues", "raramente", "realmente", "seguidamente", "segundo", "semejantemente", "si", "siguiente", "sino", "súbitamente", "supongamos", "también", "tampoco", "tercero", "verbigracia", "vice-versa", "ya"];
const multipleWords$c = ["a causa de", "a continuación", "a diferencia de", "a fin de cuentas", "a la inversa", "a la misma vez", "a más de", "a más de esto", "a menos que", "a no ser que", "a pesar de", "a pesar de eso", "a pesar de todo", "a peser de", "a propósito", "a saber", "a todo esto", "ahora bien", "al contrario", "al fin y al cabo", "al final", "al inicio", "al mismo tiempo", "al principio", "ante todo", "antes bien", "antes de", "antes de nada", "antes que nada", "aparte de", "as así como", "así como", "así mismo", "así pues", "así que", "así y todo", "aún así", "claro está que", "claro que", "claro que sí", "como caso típico", "como decíamos", "como era de esperar", "como es de esperar", "como muestra", "como resultado", "como se ha notado", "como sigue", "comparado con", "con el objeto de", "con el propósito de", "con que", "con relación a", "con tal de que", "con todo", "dado que", "de ahí", "de cierta manera", "de cualquier manera", "de cualquier modo", "de ello resulta que", "de este modo", "de golpe", "de hecho", "de igual manera", "de igual modo", "de igualmanera", "de la manera siguiente", "de la misma forma", "de la misma manera", "de manera semejante", "del mismo modo", "de modo que", "de nuevo", "de otra manera", "de otro modo", "de pronto", "de qualquier manera", "de repente", "de suerte que", "de tal modo", "de todas formas", "de todas maneras", "de todos modos", "de veras", "debido a", "debido a que", "del mismo modo", "dentro de poco", "desde entonces", "después de", "después de todo", "ejemplo de esto", "el caso es que", "en aquel tiempo", "en cambio", "en cierto modo", "en comparación con", "en conclusión", "en concreto", "en conformidad con", "en consecuencia", "en consiguiente", "en contraste con", "en cualquier caso", "en cuanto", "en cuanto a", "en definitiva", "en efecto", "en el caso de que", "en este sentido", "en fin", "en fin de cuentas", "en general", "en lugar de", "en otras palabras", "en otro orden", "en otros términos", "en particular", "en primer lugar", "en primer término", "en primera instancia", "en realidad", "en relación a", "en relación con", "en representación de", "en resumen", "en resumidas cuentas", "en segundo lugar", "en seguida", "en síntesis", "en suma", "en todo caso", "en último término", "en verdad", "en vez de", "en virtud de", "entre ellas figura", "entre ellos figura", "es cierto que", "es decir", "es evidente que", "es incuestionable", "es indudable", "es más", "está claro que", "esto indica", "excepto si", "generalmente por ejemplo", "gracias a", "hasta aquí", "hasta cierto punto", "hasta el momento", "hay que añadir", "igual que", "la mayor parte del tiempo", "la mayoría del tiempo", "lo que es peor", "más tarde", "mejor dicho", "mientras tanto", "mirándolo todo", "nadie puede ignorar", "no faltaría más", "no obstante", "o sea", "otra vez", "otro aspecto", "par ilustrar", "para concluir", "para conclusión", "para continuar", "para empezar", "para finalizar", "para mencionar una cosa", "para que", "para resumir", "para terminar", "pongamos por caso", "por añadidura", "por cierto", "por consiguiente", "por ejemplo", "por el consiguiente", "por el contrario", "por el hecho que", "por eso", "por esta razón", "por esto", "por fin", "por la mayor parte", "por lo general", "por lo que", "por lo tanto", "por otro lado", "por otra parte", "por otro lado", "por supuesto", "por tanto", "por último", "por un lado", "por una parte", "primero que nada", "primero que todo", "pues bien", "puesto que", "rara vez", "resulta que", "sea como sea", "seguidamente entre tanto", "si bien", "siempre que", "siempre y cuando", "sigue que", "sin duda", "sin embargo", "sin ir más lejos", "sobre todo", "supuesto que", "tal como", "tales como", "tan pronto como", "tanto como", "una vez", "ya que"];

Object.defineProperty(functionWords$d, "__esModule", {
	value: true
});

functionWords$d.default = function () {
	return {

		// These word categories are filtered at the beginning of word combinations.
		filteredAtBeginning: generalAdjectivesAdverbs$a,

		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(ordinalNumerals$d, otherAuxiliariesInfinitive$4, copulaEstarInfinitive, copulaSerInfinitive, delexicalizedVerbsInfinitive$4),

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(articles$9, prepositions$c, coordinatingConjunctions$8, demonstrativePronouns$9, intensifiers$d, quantifiers$d, possessivePronouns$7),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(transitionWords$l, personalPronounsNominative$7, personalPronounsAccusative$5, personalPronounsPrepositional$3, personalPronounsComitative$1, interjections$d, cardinalNumerals$d, otherAuxiliaries$6, copulaEstar, copulaSer, interviewVerbs$d, delexicalizedVerbs$8, indefinitePronouns$d, correlativeConjunctions$3, subordinatingConjunctions$8, interrogativeDeterminers$5, interrogativePronouns$7, interrogativeProAdverbs$6, locativeAdverbs$6, miscellaneous$c, prepositionalAdverbs$2, recipeWords$c, timeWords$d, vagueNouns$d),

		// These word categories cannot directly precede a passive participle.
		cannotDirectlyPrecedePassiveParticiple: [].concat(articles$9, prepositions$c, personalPronounsAccusative$5, possessivePronouns$7, indefinitePronouns$d, interrogativeProAdverbs$6, cardinalNumerals$d, ordinalNumerals$d, delexicalizedVerbs$8, delexicalizedVerbsInfinitive$4, interviewVerbs$d, interrogativeDeterminers$5, interrogativePronouns$7, personalPronounsComitative$1, personalPronounsPrepositional$3, prepositionalAdverbs$2),

		// These word categories cannot intervene between an auxiliary and a corresponding passive participle.
		cannotBeBetweenPassiveAuxiliaryAndParticiple: [].concat(copulaEstar, copulaEstarInfinitive),

		// This export contains all of the above words.
		all: [].concat(articles$9, cardinalNumerals$d, ordinalNumerals$d, demonstrativePronouns$9, possessivePronouns$7, personalPronounsNominative$7, personalPronounsComitative$1, personalPronounsPrepositional$3, personalPronounsAccusative$5, quantifiers$d, indefinitePronouns$d, interrogativeDeterminers$5, interrogativePronouns$7, interrogativeProAdverbs$6, locativeAdverbs$6, prepositionalAdverbs$2, otherAuxiliaries$6, otherAuxiliariesInfinitive$4, copulaEstar, copulaSer, copulaEstarInfinitive, copulaSerInfinitive, prepositions$c, coordinatingConjunctions$8, correlativeConjunctions$3, subordinatingConjunctions$8, interviewVerbs$d, transitionWords$l, additionalTransitionWords$6, intensifiers$d, delexicalizedVerbs$8, delexicalizedVerbsInfinitive$4, interjections$d, generalAdjectivesAdverbs$a, recipeWords$c, vagueNouns$d, miscellaneous$c, titlesPreceding$5, titlesFollowing$2)
	};
};

var _transitionWords$8 = transitionWords$m;

var _transitionWords2$8 = _interopRequireDefault$2U(_transitionWords$8);

function _interopRequireDefault$2U(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const transitionWords$l = (0, _transitionWords2$8.default)().singleWords;

/**
 * Returns an array with exceptions for the prominent words researcher
 * @returns {Array} The array filled with exceptions.
 */

const articles$9 = ["el", "la", "los", "las", "un", "una", "unos", "unas"];

// "Uno" is already included in the articles.
const cardinalNumerals$d = ["dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve", "diez", "once", "doce", "trece", "catorce", "quince", "dieciseis", "diecisiete", "dieciocho", "diecinueve", "veinte", "cien", "centena", "mil", "millon", "millones"];

const ordinalNumerals$d = ["primera", "segunda", "tercera", "cuarto", "cuarta", "quinto", "quinta", "sexto", "sexta", "septimo", "septima", "octavo", "octava", "noveno", "novena", "décimo", "décima", "vigésimo", "vigésima", "primeros", "primeras", "segundos", "segundas", "terceros", "terceras", "cuartos", "cuartas", "quintos", "quintas", "sextos", "sextas", "septimos", "septimas", "octavos", "octavas", "novenos", "novenas", "décimos", "décimas", "vigésimos", "vigésimas"];

const personalPronounsNominative$7 = ["yo", "yos", "yoes", "tú", "él", "ella", "ello", "nosotros", "nosotras", "vosotros", "vosotras", "ustedes", "ellos", "ellas"];

const personalPronounsAccusative$5 = ["me", "te", "lo", "se", "nos", "os", "les"];

const personalPronounsPrepositional$3 = ["mí", "ti", "ud", "uds", "usted"];

const personalPronounsComitative$1 = ["conmigo", "contigo", "consigo"];

const demonstrativePronouns$9 = ["este", "ese", "aquel", "esta", "esa", "aquella", "estos", "esos", "aquellos", "estas", "esas", "aquellas", "esto", "eso", "aquello"];

const possessivePronouns$7 = ["mi", "mis", "mío", "míos", "mía", "mías", "nuestro", "nuestros", "nuestra", "nuestras", "tuyo", "tuyos", "tuya", "tuyas", "tu", "tus", "vuestro", "vuestros", "vuestra", "vuestras", "suyo", "suyos", "suya", "suyas", "su", "sus"];

const quantifiers$d = ["bastante", "bastantes", "mucho", "muchas", "mucha", "muchos", "más", "muchísimo", "muchísima", "muchísimos", "muchísimas", "demasiado", "demasiada", "demasiados", "demasiadas", "poco", "poca", "pocos", "pocas", "menos", "poquísimo", "poquísima", "poquísimos", "poquísimas", "demás", "otros", "otras", "todo", "toda", "todos", "todas"];

const indefinitePronouns$d = ["alguien", "algo", "algún", "alguno", "alguna", "algunos", "algunas", "nadie", "nada", "ningún", "ninguno", "ninguna", "ningunos", "ningunas", "tanto", "tantos", "tanta", "tantas"];

const interrogativeDeterminers$5 = ["cuyas", "cual"];

const interrogativePronouns$7 = ["cuyo"];

/*
'Qué' is part of 'por qué' ('why'). The combination 'quien sea' ('whoever') is separated into two entries: 'quien' and 'sea'.
'quira' is part of 'cuando quiera' ('whenever').
 */
const interrogativeProAdverbs$6 = ["comoquiera", "cualesquiera", "cualquier", "cuanta", "cuantas", "cuanto", "cuantos", "cuál", "cuáles", "cuánta", "cuántas", "cuánto", "cuántos", "cómo", "dondequiera", "dónde", "quien", "quienes", "quienquiera", "quién", "quiénes", "qué"];

const locativeAdverbs$6 = ["allí", "ahí", "allá", "aquí", "acá", "adónde", "delante", "detrás", "debajo", "adelante", "atrás", "adentro", "afuera"];

const otherAuxiliaries$6 = ["he", "has", "ha", "hay", "hemos", "habéis", "han", "hube", "hubiste", "hubo", "hubimos", "hubisteis", "hubieron", "había", "habías", "habíamos", "habíais", "habían", "habría", "habrías", "habríais", "habrían", "habré", "habrás", "habrá", "habremos", "habréis", "habrán", "haya", "hayas", "hayamos", "hayáis", "hayan", "hubiera", "hubieras", "hubiéramos", "hubierais", "hubieran", "hubiese", "hubieses", "hubiésemos", "hubieseis", "hubiesen", "hubiere", "hubieres", "hubiéremos", "hubiereis", "hubieren", "habed", "habido", "debo", "debes", "debe", "debemos", "debéis", "deben", "debí", "debiste", "debió", "debimos", "debisteis", "debieron", "debía", "debías", "debíamos", "debíais", "debían", "debería", "deberías", "deberíamos", "deberíais", "deberían", "deberé", "deberás", "deberá", "deberemos", "deberéis", "deberán", "deba", "debas", "debamos", "debáis", "deban", "debiera", "debieras", "debiéramos", "debierais", "debieran", "debiese", "debieses", "debiésemos", "debieseis", "debiesen", "debiere", "debieres", "debiéremos", "debiereis", "debieren", "debed", "debido", "empiezo", "empiezas", "empieza", "empezáis", "empiezan", "empecé", "empezaste", "empezó", "empezamos", "empezasteis", "empezaron", "empezaba", "empezabas", "empezábamos", "empezabais", "empezaban", "empezaría", "empezarías", "empezaríamos", "empezaríais", "empezarían", "empezaré", "empezarás", "empezará", "empezaremos", "empezaréis", "empezarán", "empiece", "empieces", "empecemos", "empecéis", "empiecen", "empezara", "empezaras", "empezáramos", "empezarais", "empezaran", "empezase", "empezases", "empezásemos", "empezaseis", "empezasen", "empezare", "empezares", "empezáremos", "empezareis", "empezaren", "empezad", "empezado", "comienzo", "comienzas", "comienza", "comenzamos", "comenzáis", "comienzan", "comencé", "comenzaste", "comenzó", "comenzasteis", "comenzaron", "comenzaba", "comenzabas", "comenzábamos", "comenzabais", "comenzaban", "comenzaría", "comenzarías", "comenzaríamos", "comenzaríais", "comenzarían", "comenzaré", "comenzarás", "comenzará", "comenzaremos", "comenzaréis", "comenzarán", "comience", "comiences", "comencemos", "comencéis", "comiencen", "comenzara", "comenzaras", "comenzáramos", "comenzarais", "comenzaran", "comenzase", "comenzases", "comenzásemos", "comenzaseis", "comenzasen", "comenzare", "comenzares", "comenzáremos", "comenzareis", "comenzaren", "comenzad", "comenzado", "sigo", "sigues", "sigue", "seguimos", "seguis", "siguen", "seguí", "seguiste", "siguió", "seguisteis", "siguieron", "seguía", "seguías", "seguíamos", "seguíais", "seguían", "seguiría", "seguirías", "seguiríamos", "seguiríais", "seguirían", "seguiré", "seguirás", "seguirá", "seguiremos", "seguiréis", "seguirán", "siga", "sigas", "sigamos", "sigáis", "sigan", "siguiera", "siguieras", "siguiéramos", "siguierais", "siguieran", "siguiese", "siguieses", "siguiésemos", "siguieseis", "siguiesen", "siguiere", "siguieres", "siguiéremos", "siguiereis", "siguieren", "seguid", "seguido", "tengo", "tienes", "tiene", "tenemos", "tenéis", "tienen", "tuve", "tuviste", "tuvo", "tuvimos", "tuvisteis", "tuvieron", "tenía", "tenías", "teníamos", "teníais", "tenían", "tendría", "tendrías", "tendríamos", "tendríais", "tendrían", "tendré", "tendrás", "tendrá", "tendremos", "tendréis", "tendrán", "tenga", "tengas", "tengamos", "tengáis", "tengan", "tuviera", "tuvieras", "tuviéramos", "tuvierais", "tuvieran", "tuviese", "tuvieses", "tuviésemos", "tuvieseis", "tuviesen", "tuviere", "tuvieres", "tuviéremos", "tuviereis", "tuvieren", "ten", "tened", "tenido", "ando", "andas", "andamos", "andáis", "andan", "anduve", "anduviste", "anduvo", "anduvimos", "anduvisteis", "anduvieron", "andaba", "andabas", "andábamos", "andabais", "andaban", "andaría", "andarías", "andaríamos", "andaríais", "andarían", "andaré", "andarás", "andará", "andaremos", "andaréis", "andarán", "ande", "andes", "andemos", "andéis", "anden", "anduviera", "anduvieras", "anduviéramos", "anduvierais", "anduvieran", "anduviese", "anduvieses", "anduviésemos", "anduvieseis", "anduviesen", "anduviere", "anduvieres", "anduviéremos", "anduviereis", "anduvieren", "andad", "andado", "quedo", "quedas", "queda", "quedamos", "quedáis", "quedan", "quedé", "quedasteis", "quedaron", "quedaba", "quedabas", "quedábamos", "quedabais", "quedaban", "quedaría", "quedarías", "quedaríamos", "quedaríais", "quedarían", "quedaré", "quedarás", "quedará", "quedaremos", "quedaréis", "quedarán", "quede", "quedes", "quedemos", "quedéis", "queden", "quedara", "quedaras", "quedáramos", "quedarais", "quedaran", "quedase", "quedases", "quedásemos", "quedaseis", "quedasen", "quedare", "quedares", "quedáremos", "quedareis", "quedaren", "quedad", "quedado", "hallo", "hallas", "halla", "hallamos", "halláis", "hallan", "hallé", "hallaste", "halló", "hallasteis", "hallaron", "hallaba", "hallabas", "hallábamos", "hallabais", "hallaban", "hallaría", "hallarías", "hallaríamos", "hallaríais", "hallarían", "hallaré", "hallarás", "hallará", "hallaremos", "hallaréis", "hallarán", "halle", "halles", "hallemos", "halléis", "hallen", "hallara", "hallaras", "halláramos", "hallarais", "hallaran", "hallase", "hallases", "hallásemos", "hallaseis", "hallasen", "hallare", "hallares", "halláremos", "hallareis", "hallaren", "hallad", "hallado", "vengo", "vienes", "viene", "venimos", "venis", "vienen", "vine", "viniste", "vino", "vinimos", "vinisteis", "vinieron", "venía", "vanías", "verníamos", "veníais", "venían", "vendría", "vendrías", "vendríamos", "vendíais", "vendrían", "vendré", "vendrás", "vendrá", "vendremos", "vendréis", "vendrán", "venga", "vengas", "vengamos", "vengáis", "vengan", "viniera", "vinieras", "viniéramos", "vinierais", "vinieran", "viniese", "vinieses", "viniésemos", "vinieseis", "viniesen", "viniere", "vinieres", "viniéremos", "viniereis", "vinieren", "ven", "venid", "venido", "abro", "abres", "abre", "abrismos", "abrís", "abren", "abrí", "abriste", "abrió", "abristeis", "abrieron", "abría", "abrías", "abríais", "abrían", "abriría", "abrirías", "abriríamos", "abriríais", "abrirían", "abriré", "abrirás", "abrirá", "abriremos", "abriréis", "abrirán", "abra", "abras", "abramos", "abráis", "abran", "abriera", "abrieras", "abriéramos", "abrierais", "abrieran", "abriese", "abrieses", "abriésemos", "abrieseis", "abriesen", "abriere", "abrieres", "abriéremos", "abriereis", "abrieren", "abrid", "abierto", "voy", "vas", "va", "vamos", "vais", "van", "iba", "ibas", "íbamos", "ibais", "iban", "iría", "irías", "iríamos", "iríais", "irían", "iré", "irás", "irá", "iremos", "iréis", "irán", "vaya", "vayas", "vayamos", "vayáis", "vayan", "ve", "id", "ido", "acabo", "acabas", "acaba", "acabamos", "acabáis", "acaban", "acabé", "acabaste", "acabó", "acabasteis", "acabaron", "acababa", "acababas", "acabábamos", "acababais", "acababan", "acabaría", "acabarías", "acabaríamos", "acabaríais", "acabarían", "acabaré", "acabarás", "acabará", "acabaremos", "acabaréis", "acabarán", "acabe", "acabes", "acabemos", "acabéis", "acaben", "acabara", "acabaras", "acabáramos", "acabarais", "acabaran", "acabase", "acabases", "acabásemos", "acabaseis", "acabasen", "acabare", "acabares", "acabáremos", "acabareis", "acabaren", "acabad", "acabado", "llevo", "llevas", "lleva", "llevamos", "lleváis", "llevan", "llevé", "llevaste", "llevó", "llevasteis", "llevaron", "llevaba", "llevabas", "llevábamos", "llevabais", "llevaban", "llevaría", "llevarías", "llevaríamos", "llevaríais", "llevarían", "llevaré", "llevarás", "llevará", "llevaremos", "llevaréis", "llevarán", "lleve", "lleves", "llevemos", "llevéis", "lleven", "llevara", "llevaras", "lleváramos", "llevarais", "llevaran", "llevase", "llevases", "llevásemos", "llevaseis", "llevasen", "llevare", "llevares", "lleváremos", "llevareis", "llevaren", "llevad", "llevado", "alcanzo", "alcanzas", "alcanza", "alcanzamos", "alcanzáis", "alcanzan", "alcancé", "alcanzaste", "alcanzó", "alcanzasteis", "alcanzaron", "alcanzaba", "alcanzabas", "alcanzábamos", "alcanzabais", "alcanzaban", "alcanzaría", "alcanzarías", "alcanzaríamos", "alcanzaríais", "alcanzarían", "alcanzaré", "alcanzarás", "alcanzará", "alcanzaremos", "alcanzaréis", "alcanzarán", "alcance", "alcances", "alcancemos", "alcancéis", "alcancen", "alcanzara", "alcanzaras", "alcanzáramos", "alcanzarais", "alcanzaran", "alcanzase", "alcanzases", "alcanzásemos", "alcanzaseis", "alcanzasen", "alcanzare", "alcanzares", "alcanzáremos", "alcanzareis", "alcanzaren", "alcanzad", "alcanzado", "digo", "dices", "dice", "decimos", "decís", "dicen", "dije", "dijiste", "dijo", "dijimos", "dijisteis", "dijeron", "decía", "decías", "decíamos", "decíais", "decían", "diría", "dirías", "diríamos", "diríais", "dirían", "diré", "dirás", "dirá", "diremos", "diréis", "dirán", "diga", "digas", "digamos", "digáis", "digan", "dijera", "dijeras", "dijéramos", "dijerais", "dijeran", "dijese", "dijeses", "dijésemos", "dijeseis", "dijesen", "dijere", "dijeres", "dijéremos", "dijereis", "dijeren", "di", "decid", "dicho", "continúo", "continúas", "continúa", "continuamos", "continuáis", "continúan", "continué", "continuaste", "continuó", "continuasteis", "continuaron", "continuaba", "continuabas", "continuábamos", "continuabais", "continuaban", "continuaría", "continuarías", "continuaríamos", "continuaríais", "continuarían", "continuaré", "continuarás", "continuará", "continuaremos", "continuaréis", "continuarán", "continúe", "continúes", "continuemos", "continuéis", "continúen", "continuara", "continuaras", "continuáramos", "continuarais", "continuaran", "continuase", "continuases", "continuásemos", "continuaseis", "continuasen", "continuare", "continuares", "continuáremos", "continuareis", "continuaren", "continuad", "continuado", "resulto", "resultas", "resulta", "resultamos", "resultáis", "resultan", "resulté", "resultaste", "resultó", "resultasteis", "resultaron", "resultaba", "resultabas", "resultábamos", "resultabais", "resultaban", "resultaría", "resultarías", "resultaríamos", "resultaríais", "resultarían", "resultaré", "resultarás", "resultará", "resultaremos", "resultaréis", "resultarán", "resulte", "resultes", "resultemos", "resultéis", "resulten", "resultara", "resultaras", "resultáramos", "resultarais", "resultaran", "resultase", "resultases", "resultásemos", "resultaseis", "resultasen", "resultare", "resultares", "resultáremos", "resultareis", "resultaren", "resultad", "resultado", "puedo", "puedes", "puede", "podemos", "podéis", "pueden", "pude", "pudiste", "pudo", "pudimos", "pudisteis", "pudieron", "podía", "podías", "podíamos", "podíais", "podían", "podría", "podrías", "podríamos", "podríais", "podrían", "podré", "podrás", "podrá", "podremos", "podréis", "podrán", "pueda", "puedas", "podamos", "podáis", "puedan", "pudiera", "pudieras", "pudiéramos", "pudierais", "pudieran", "pudiese", "pudieses", "pudiésemos", "pudieseis", "pudiesen", "pudiere", "pudieres", "pudiéremos", "pudiereis", "pudieren", "poded", "podido", "quiero", "quieres", "quiere", "queremos", "queréis", "quieren", "quise", "quisiste", "quiso", "quisimos", "quisisteis", "quisieron", "quería", "querías", "queríamos", "queríais", "querían", "querría", "querrías", "querríamos", "querríais", "querrían", "querré", "querrás", "querrá", "querremos", "querréis", "querrán", "quiera", "quieras", "queramos", "queráis", "quieran", "quisiera", "quisieras", "quisiéramos", "quisierais", "quisieran", "quisiese", "quisieses", "quisiésemos", "quisieseis", "quisiesen", "quisiere", "quisieres", "quisiéremos", "quisiereis", "quisieren", "quered", "querido", "sabes", "sabe", "sabemos", "sabéis", "saben", "supe", "supiste", "supo", "supimos", "supisteis", "supieron", "sabía", "sabías", "sabíamos", "sabíais", "sabían", "sabría", "sabrías", "sabríamos", "sabríais", "sabrían", "sabré", "sabrás", "sabrá", "sabremos", "sabréis", "sabrán", "sepa", "sepas", "sepamos", "sepáis", "sepan", "supiera", "supieras", "supiéramos", "supierais", "supieran", "supiese", "supieses", "supiésemos", "supieseis", "supiesen", "supiere", "supieres", "supiéremos", "supiereis", "supieren", "sabed", "sabido", "suelo", "sueles", "suele", "solemos", "soléis", "suelen", "solí", "soliste", "solió", "solimos", "solisteis", "solieron", "solía", "solías", "solíamos", "solíais", "solían", "solería", "solerías", "soleríamos", "soleríais", "solerían", "soleré", "solerás", "solerá", "soleremos", "soleréis", "solerán", "suela", "suelas", "solamos", "soláis", "suelan", "soliera", "solieras", "soliéramos", "solierais", "solieran", "soliese", "solieses", "soliésemos", "solieseis", "soliesen", "soliere", "solieres", "soliéremos", "soliereis", "solieren", "soled", "solido", "necesito", "necesitas", "necesitamos", "necesitáis", "necesitan", "necesité", "necesitaste", "necesitó", "necesitasteis", "necesitaron", "necesitaba", "necesitabas", "necesitábamos", "necesitabais", "necesitaban", "necesitaría", "necesitarías", "necesitaríamos", "necesitaríais", "necesitarían", "necesitaré", "necesitarás", "necesitará", "necesitaremos", "necesitaréis", "necesitarán", "necesite", "necesites", "necesitemos", "necesitéis", "necesiten", "necesitara", "necesitaras", "necesitáramos", "necesitarais", "necesitaran", "necesitase", "necesitases", "necesitásemos", "necesitaseis", "necesitasen", "necesitare", "necesitares", "necesitáremos", "necesitareis", "necesitaren", "necesita", "necesitad", "necesitado"];

const otherAuxiliariesInfinitive$4 = ["haber", "deber", "empezar", "comenzar", "seguir", "tener", "andar", "quedar", "hallar", "venir", "abrir", "ir", "acabar", "llevar", "alcanzar", "decir", "continuar", "resultar", "poder", "querer", "saber", "soler", "necesitar"];

// Estar is not used to form passives in Spanish.
const copulaEstar = ["estoy", "estás", "está", "estamos", "estáis", "están", "estuve", "estuviste", "estuvo", "estuvimos", "estuvisteis", "estuvieron", "estuba", "estabas", "estábamos", "estabais", "estaban", "estraría", "estarías", "estaríamos", "estaríais", "estarían", "estaré", "estarás", "estará", "estaremos", "estaréis", "estarán", "esté", "estés", "estemos", "estéis", "estén", "estuviera", "estuviese", "estuvieras", "estuviéramos", "estuvierais", "estuvieran", "estuvieses", "estuviésemos", "estuvieseis", "estuviesen", "estuviere", "estuvieres", "estuviéremos", "estuviereis", "estuvieren", "estad", "estado"];

// Ser is the copula used to form passives in Spanish.
const copulaSer = ["soy", "eres", "es", "somos", "sois", "son", "fui", "fuiste", "fuimos", "fuisteis", "fueron", "era", "eras", "éramos", "erais", "eran", "sería", "serías", "seríamos", "seríais", "serían", "seré", "serás", "seremos", "seréis", "serán", "sea", "seas", "seamos", "seáis", "sean", "fueras", "fuéramos", "fuerais", "fueran", "fuese", "fueses", "fuésemos", "fueseis", "fuesen", "fuere", "fueres", "fuéremos", "fuereis", "fueren", "sé", "sed", "sido"];

const copulaEstarInfinitive = ["estar"];

const copulaSerInfinitive = ["ser"];

const prepositions$c = ["a", "ante", "abajo", "adonde", "al", "allende", "alrededor", "amén", "antes", "arriba", "aun", "bajo", "cabe", "cabo", "con", "contigo", "contra", "de", "dejante", "del", "dentro", "desde", "donde", "durante", "en", "encima", "entre", "excepto", "fuera", "hacia", "hasta", "incluso", "mediante", "más", "opuesto", "par", "para", "próximo", "salvo", "según", "sin", "so", "sobre", "tras", "versus", "vía"];

const prepositionalAdverbs$2 = ["cerca"];

const coordinatingConjunctions$8 = ["o", "y", "entonces", "e", "u", "ni", "bien", "ora"];

// 'Igual' is part of 'igual...que'.
const correlativeConjunctions$3 = ["igual"];

const subordinatingConjunctions$8 = ["apenas", "segun", "que"];

// These verbs are frequently used in interviews to indicate questions and answers.
// 'Dijo' is already included in the otherAuxiliaries category.
const interviewVerbs$d = ["apunto", "apunta", "confieso", "confiesa", "confesaba", "revelado", "revelo", "revela", "revelaba", "declarado", "declaro", "declara", "declaba", "señalo", "señala", "señalaba", "declaraba", "comento", "comenta"];

// These transition words were not included in the list for the transition word assessment for various reasons.
const additionalTransitionWords$6 = ["básicamente", "esencialmente", "primeramente", "siempre", "nunca", "ahora", "quizá", "acaso", "inclusive", "probablemente", "verdaderamente", "seguramente", "jamás", "obviamente", "indiscutiblement", "inmediatamente", "previamente"];

const intensifiers$d = ["muy", "tan", "completamente", "suficiente", "tal", "tales"];

// These verbs convey little meaning.
const delexicalizedVerbs$8 = ["hago", "haces", "hace", "hacemos", "hacéis", "hacen", "hice", "hiciste", "hizo", "hicimos", "hicisteis", "hicieron", "hacía", "hacías", "hacíamos", "hacíais", "hacían", "haría,", "harías", "haríamos", "haríais", "harían", "haré", "harás", "hará", "haremos", "haréis", "harán", "haga", "hagas", "hagamos", "hagáis", "hagan", "hiciera", "hicieras", "hiciéramos", "hicierais", "hicieran", "hiciese", "hicieses", "hiciésemos", "hicieseis", "hiciesen", "hiciere", "hicieres", "hiciéremos", "hiciereis", "hicieren", "haz", "haced", "hecho", "parezco", "pareces", "parece", "parecemos", "parecéis", "parecen", "parecí", "pareciste", "pareció", "parecimos", "parecisteis", "parecieron", "parecía", "parecías", "parecíamos", "parecíais", "parecían", "parecería", "parecerías", "pareceríamos", "pareceríais", "parecerían", "pareceré", "parecerás", "parecerá", "pareceremos", "pareceréis", "parecerán", "parezca", "parezcas", "parezcamos", "parezcáis", "parezcan", "pareciera", "parecieras", "pareciéramos", "parecierais", "parecieran", "pareciese", "parecieses", "pareciésemos", "parecieseis", "pareciesen", "pareciere", "parecieres", "pareciéremos", "pareciereis", "parecieren", "pareced", "parecido", "iba", "ibais", "iban", "ibas", "id", "ido", "iremos", "irá", "irán", "irás", "iré", "iréis", "iría", "iríais", "iríamos", "irían", "irías", "va", "vais", "vamos", "van", "vas", "vaya", "vayamos", "vayan", "vayas", "vayáis", "ve", "voy", "yendo", "íbamos"];

const delexicalizedVerbsInfinitive$4 = ["hacer", "parecer", "ir"];

// These adjectives and adverbs are so general, they should never be suggested as a (single) keyword.
// Keyword combinations containing these adjectives/adverbs are fine.
const generalAdjectivesAdverbs$a = ["enfrente", "claro", "bueno", "mejor", "mejores", "buena", "buenos", "buenas", "óptimo", "óptimos", "óptimas", "bonísimo", "bonísima", "bonísimos", "bonísimas", "buenísimo", "buenísima", "buenísimos", "buenísimas", "buenérrimo", "buenérrima", "buenérrimos", "buenérrimas", "nuevo", "nueva", "nuevos", "nuevas", "novísimo", "novísima", "novísimos", "novísimas", "nuevísimo", "nuevísima", "nuevísimos", "nuevísimas", "viejo", "viejos", "vieja", "viejas", "anterior", "grande", "gran", "grandes", "mayores", "mayor", "máximo", "máxima", "grandísimo", "grandísima", "máximos", "máximas", "grandísimos", "grandísimas", "fácil", "fáciles", "rápido", "rápida", "rápidos", "rápidas", "lejos", "lejas", "lejote", "lejotes", "difícil", "difíciles", "propio", "propios", "propia", "propias", "largo", "larga", "largos", "largas", "bajos", "baja", "bajas", "inferior", "ínfimo", "ínfima", "ínfimos", "ínfimas", "bajísimo", "bajísima", "bajísimos", "bajísimas", "alto", "alta", "altos", "altas", "superior", "superiores", "supremo", "suprema", "supremos", "supremas", "sumo", "suma", "sumos", "sumas", "altísimo", "altísima", "altísimos", "altísimas", "regular", "regulares", "normal", "pequeño", "pequeña", "pequeños", "pequeñas", "menor", "pequeñísimo", "pequeñísima", "pequeñísimos", "pequeñísimas", "mínimo", "mínima", "mínimos", "mínimas", "diminuta", "diminuto", "diminutas", "diminutos", "chiquitito", "chiquititos", "chiquitita", "chiquititas", "corta", "corto", "cortas", "cortos", "principal", "principales", "mismo", "mismos", "misma", "mismas", "capaz", "capaces", "cierta", "cierto", "ciertas", "ciertos", "certísimos", "certísimas", "ciertísimo", "ciertísima", "ciertísimos", "ciertísimas", "llamado", "llamada", "llamados", "llamadas", "mayormente", "reciente", "recientes", "completa", "completo", "completas", "completos", "absoluta", "absoluto", "absolutas", "absolutos", "últimamente", "posible", "común", "comúnes", "comúnmente", "constantemente", "continuamente", "directamente", "fácilmente", "casi", "ligeramente", "estima", "estimada", "estimado", "aproximada", "aproximadamente", "última", "últimas", "último", "últimos", "diferente", "diferentes", "similar", "mal", "malo", "malos", "mala", "malas", "peor", "pésimo", "pésima", "malísimo", "malísima", "pésimos", "pésimas", "malísimos", "malísimas", "perfectamente", "excelente", "final", "general"];

const interjections$d = ["ah", "eh", "ejem", "ele", "achís", "adiós", "agur", "ajá", "ajajá", "ala", "alá", "albricias", "aleluya", "alerta", "alirón", "aló", "amalaya", "ar", "aro", "arrarray", "arre", "arsa", "atatay", "aúpa", "ax", "ay", "ayayay", "bah", "banzai", "barajo", "bla", "bravo", "buf", "bum", "ca", "caguendiós", "canastos", "caracho", "caracoles", "carajo", "caramba", "carape", "caray", "cáscaras", "cáspita", "cataplum", "ce", "chao", "chau", "che", "chis", "chist", "chitón", "cho", "chucho", "chus", "cielos", "clo", "coche", "cochi", "cojones", "concho", "coño", "córcholis", "cuchí", "cuidado", "cuz", "demonio", "demontre", "despacio", "diablo", "diantre", "dios", "ea", "epa", "equilicuá", "estúpido", "eureka", "evohé", "exacto", "fantástico", "firmes", "fo", "forte", "gua", "gualá", "guarte", "guay", "hala", "hale", "he", "hi", "hin", "hola", "hopo", "huesque", "huiche", "huichó", "huifa", "hurra", "huy", "ja", "jajajá", "jajay", "jaque", "jau", "jo", "jobar", "joder", "jolín", "jopo", "leñe", "listo", "malhayas", "mamola", "mecachis", "miéchica", "mondo", "moste", "mutis", "nanay", "narices", "oh", "ojalá", "ojo", "okay", "ole", "olé", "órdiga", "oste", "ostras", "ox", "oxte", "paf", "pardiez", "paso", "pucha", "puf", "puff", "pumba", "puñeta", "quia", "quiúbole", "recórcholis", "rediez", "rediós", "salve", "sanseacabó", "sniff", "socorro", "ta", "tararira", "tate", "tururú", "uf", "uh", "ui", "upa", "uste", "uy", "victoria", "vítor", "viva", "za", "zambomba", "zapateta", "zape", "zas"];

// These words and abbreviations are frequently used in recipes in lists of ingredients.
const recipeWords$c = ["kg", "mg", "gr", "g", "km", "m", "l", "ml", "cl"];

const timeWords$d = ["minuto", "minutos", "hora", "horas", "día", "días", "semana", "semanas", "mes", "meses", "año", "años", "hoy", "mañana", "ayer"];

// 'People' should only be removed in combination with 'some', 'many' and 'few' (and is therefore not yet included in the list below).
const vagueNouns$d = ["cosa", "cosas", "manera", "maneras", "caso", "casos", "pieza", "piezas", "vez", "veces", "parte", "partes", "porcentaje", "instancia", "aspecto", "aspectos", "punto", "puntos", "objeto", "objectos", "persona", "personas"];

const miscellaneous$c = ["no", "euros", "sí", "síes", "noes"];

const titlesPreceding$5 = ["sra", "sras", "srta", "sr", "sres", "dra", "dr", "profa", "prof"];

const titlesFollowing$2 = ["jr", "sr"];

var functionWords$c = {};

var transitionWords$k = {};

Object.defineProperty(transitionWords$k, "__esModule", {
	value: true
});

transitionWords$k.default = function () {
	return {
		singleWords: singleWords$b,
		multipleWords: multipleWords$b,
		allWords: singleWords$b.concat(multipleWords$b)
	};
};

/** @module config/transitionWords */

const singleWords$b = ["abbastanza", "acciocché", "acciocchè", "adesso", "affinché", "affinchè", "allora", "almeno", "alquanto", "altrettanto", "altrimenti", "analogamente", "anche", "ancora", "antecedentemente", "anzi", "anzitutto", "apertamente", "appena", "assai", "attualmente", "benché", "benchè", "beninteso", "bensì", "brevemente", "bruscamente", "casomai", "celermente", "certamente", "certo", "chiaramente", "ciononostante", "cioé", "cioè", "comparabilmente", "come", "complessivamente", "completamente", "comunque", "concisamente", "concludendo", "conformemente", "congiuntamente", "conseguentemente", "considerando", "considerato", "considerevolmente", "contemporaneamente", "continuamente", "contrariamente", "controbilanciato", "così", "cosicché", "cosicchè", "dapprima", "dato", "davvero", "definitivamente", "dettagliatamente", "differentemente", "diversamente", "dopo", "dopodiché", "dopodichè", "durante", "dunque", "eccetto", "eccome", "effettivamente", "egualmente", "elencando", "enfaticamente", "eppure", "esaurientemente", "esplicitamente", "espressamente", "estesamente", "evidentemente", "finalmente", "finché", "finchè", "fino", "finora", "fintanto", "fintanto che", "fintantoché", "fintantochè", "fondamentalmente", "frattanto", "frequentemente", "generalmente", "già", "gradualmente", "illustrando", "immantinente", "immediatamente", "importantissimo", "incontestabilmente", "incredibilmente", "indipendentemente", "indiscutibilmente", "indubbiamente", "infatti", "infine", "innanzitutto", "innegabilmente", "inoltre", "insomma", "intanto", "interamente", "istantaneamente", "invece", "logicamente", "lentamente", "ma", "malgrado", "marcatamente", "memorabile", "mentre", "motivatamente", "naturalmente", "né", "nè", "neanche", "neppure", "nonché", "nonchè", "nondimeno", "nonostante", "notevolmente", "occasionalmente", "oltretutto", "onde", "onestamente", "ossia", "ostinatamente", "ovvero", "ovviamente", "parimenti", "particolarmente", "peraltro", "perché", "perchè", "perciò", "perlomeno", "però", "pertanto", "pesantemente", "piuttosto", "poi", "poiché", "poichè", "praticamente", "precedentemente", "preferibilmente", "precisamente", "prematuramente", "presto", "prima", "primariamente", "primo", "principalmente", "prontamente", "proporzionalmente", "pure", "purché", "purchè", "quando", "quanto", "quantomeno", "quindi", "raramente", "realmente", "relativamente", "riassumendo", "riformulando", "ripetutamente", "saltuariamente", "schiettamente", "sebbene", "secondariamente", "secondo", "sempre", "sennò", "seguente", "sensibilmente", "seppure", "seriamente", "siccome", "sicuramente", "significativamente", "similmente", "simultaneamente", "singolarmente", "sinteticamente", "solitamente", "solo", "soltanto", "soprattutto", "sopravvalutato", "sorprendentemente", "sostanzialmente", "sottolineando", "sottovalutato", "specialmente", "specificamente", "specificatamente", "subitamente", "subito", "successivamente", "successivo", "talmente", "terzo", "totalmente", "tranne", "tuttavia", "ugualmente", "ulteriormente", "ultimamente", "veramente", "verosimilmente", "visto"];

const multipleWords$b = ["a breve", "a causa", "a causa di", "a condizione che", "a conseguenza", "a conti fatti", "a differenza di", "a differenza del", "a differenza della", "a differenza dei", "a differenza degli", "a differenza delle", "a dire il vero", "a dire la verità", "a dirla tutta", "a dispetto di", "a lungo", "a lungo termine", "a maggior ragione", "a meno che non", "a parte", "a patto che", "a prescindere", "a prima vista", "a proposito", "a qualunque costo", "a quanto", "a quel proposito", "a quel tempo", "a quell'epoca", "a questo fine", "a questo proposito", "a questo punto", "a questo riguardo", "a questo scopo", "a riguardo", "a seguire", "a seguito", "a sottolineare", "a tal fine", "a tal proposito", "a tempo debito", "a tutti gli effetti", "a tutti i costi", "a una prima occhiata", "ad eccezione di", "ad esempio", "ad essere maliziosi", "ad essere sinceri", "ad ogni buon conto", "ad ogni costo", "ad ogni modo", "ad una prima occhiata", "adesso che", "al che", "al contrario", "al contrario di", "al fine di", "al fine di fare", "al giorno d'oggi", "al momento", "al momento giusto", "al momento opportuno", "al più presto", "al posto di", "al suo posto", "al termine", "all'epoca", "all'infuori di", "all'inizio", "all'opposto", "all'ultimo", "alla fine", "alla fine della fiera", "alla luce", "alla luce di", "alla lunga", "alla moda", "alla stessa maniera", "allo scopo di", "allo stesso modo", "allo stesso tempo", "anch'esso", "anch'io", "anche se", "ancora più", "ancora di più", "assumendo che", "bisogna chiarire che", "bisogna considerare che", "causato da", "ciò nondimeno", "ciò nonostante", "col tempo", "con il tempo", "come a dire", "come abbiamo dimostrato", "come è stato notato", "come è stato detto", "come è stato dimostrato", "come hanno detto", "come ho detto", "come ho dimostrato", "come ho notato", "come potete notare", "come potete vedere", "come puoi notare", "come puoi vedere", "come si è dimostrato", "come si può vedere", "come si può notare", "come sopra indicato", "comunque sia", "con attenzione", "con enfasi", "con il risultato che", "con l'obiettivo di", "con ostinazione", "con questa intenzione", "con questa idea", "con queste idee", "con questo in testa", "con questo scopo", "così che", "così da", "d'altra parte", "d'altro canto", "d'altro lato", "d'altronde", "d'ora in avanti", "d'ora in poi", "da allora", "da quando", "da quanto", "da quel momento", "da quella volta", "da questo momento in poi", "da questo momento", "da qui", "da ultimo", "da un certo punto di vista", "da un lato", "da una parte", "dall'altro lato", "dall'epoca", "dal che", "dato che", "dato per assunto che", "davanti a", "del tutto", "dell'epoca", "detto questo", "di certo", "di colpo", "di conseguenza", "di fatto", "di fronte", "di fronte a", "di lì a poco", "di punto in bianco", "di quando in quando", "di quanto non sia", "di quel tempo", "di qui a", "di rado", "di seguito", "di si", "di sicuro", "di solito", "di tanto in tanto", "di tutt'altra pasta", "di quando in quando", "differente da", "diversamente da", "diverso da", "dopotutto", "dovuto a", "e anche", "e inoltre", "entro breve", "fermo restando che", "faccia a faccia", "fin da", "fin dall'inizio", "fin quando", "finché non", "finchè non", "fin dal primo momento", "fin dall'inizio", "fino a", "fino a questo momento", "fino ad oggi", "fino ai giorni nostri", "fino adesso", "fino a un certo punto", "fino adesso", "fra quanto", "il prima possibile", "in aggiunta", "in altre parole", "in altri termini", "in ambo i casi", "in breve", "in caso di", "in conclusione", "in conformità", "in confronto", "in confronto a", "in conseguenza", "in considerazione", "in considerazione di", "in definitiva", "in dettaglio", "importante rendersi conto", "in effetti", "in entrambi i casi", "in fin dei conti", "in generale", "in genere", "in linea di massima", "in poche parole", "il più possibile", "in maggior parte", "in maniera analoga", "in maniera convincente", "in maniera esauriente", "in maniera esaustiva", "in maniera esplicita", "in maniera evidente", "in maniera incontestabile", "in maniera indiscutibile", "in maniera innegabile", "in maniera significativa", "in maniera simile", "in modo allusivo", "in modo analogo", "in modo che", "in modo convincente", "in modo da", "in modo identico", "in modo notevole", "in modo significativo", "in modo significativo", "in modo simile", "in ogni caso", "in ogni modo", "in ogni momento", "in parte considerevole", "in parti uguali", "in particolare", "in particolare per", "in particolare", "in più", "in pratica", "in precedenza", "in prima battuta", "in prima istanza", "in primo luogo", "in rapporto", "in qualche modo", "in qualsiasi modo", "in qualsiasi momento", "in qualunque modo", "in qualunque momento", "in quarta battuta", "in quarta istanza", "in quarto luogo", "in quel caso", "in quelle circostanze", "in questa occasione", "in questa situazione", "in questo caso", "in questo caso particolare", "in questo istante", "in questo momento", "in rare occasioni", "in realtà", "in seconda battuta", "in seconda istanza", "in secondo luogo", "in seguito", "in sintesi", "in sostanza", "in tempo", "in terza battuta", "in terza istanza", "in terzo luogo", "in totale", "in tutto", "in ugual maniera", "in ugual misura", "in ugual modo", "in ultima analisi", "in ultima istanza", "in un altro caso", "in una parola", "in verità", "insieme a", "insieme con", "invece che", "invece di", "la prima cosa da considerare", "la prima cosa da tenere a mente", "lo stesso", "mentre potrebbe essere vero", "motivo per cui", "motivo per il quale", "ne consegue che", "ne deriva che", "nei dettagli", "nel caso", "nel caso che", "nel caso in cui", "nel complesso", "nel corso del", "nel corso di", "nel frattempo", "nel lungo periodo", "nel mentre", "nell'eventualità che", "nella misura in cui", "nella speranza che", "nella stessa maniera", "nella stessa misura", "nello specifico", "nello stesso modo", "nello stesso momento", "nello stesso stile", "non appena", "non per essere maliziosi", "non più da", "nonostante ciò", "nonostante tutto", "ogni qualvolta", "ogni tanto", "ogni volta", "oltre a", "oltre a ciò", "ora che", "passo dopo passo", "per causa di", "per certo", "per chiarezza", "per chiarire", "per come", "per concludere", "per conto di", "per contro", "per cui", "per davvero", "per di più", "per dirla in altro modo", "per dirla meglio", "per dirla tutta", "per es.", "per esempio", "per essere sinceri", "per far vedere", "per farla breve", "per finire", "per l'avvenire", "per l'ultima volta", "per la maggior parte", "per la stessa ragione", "per la verità", "per lo più", "per mettere in luce", "per metterla in altro modo", "per non dire di", "per non parlare di", "per ora", "per ovvi motivi", "per paura di", "per paura dei", "per paura delle", "per paura degli", "per prima cosa", "per quanto", "per questa ragione", "per questo motivo", "per riassumere", "per sottolineare", "per timore", "per trarre le conclusioni", "per ultima", "per ultime", "per ultimi", "per ultimo", "per via di", "perché si", "perchè si", "perfino se", "piano piano", "più di ogni altra cosa", "più di tutto", "più facilmente", "più importante", "più tardi", "poco a poco", "poco dopo", "prendiamo il caso di", "presto o tardi", "prima che", "prima di", "prima di ogni cosa", "prima di tutto", "prima o dopo", "prima o poi", "questo è probabilmente vero", "questo potrebbe essere vero", "restando inteso che", "riassumendo", "quanto prima", "questa volta", "se confrontato con", "se e solo se", "se no", "seduta stante", "sempreché", "semprechè", "sempre che", "senz'altro", "senza alcun riguardo", "senza dubbio", "senz'ombra di dubbio", "senza ombra di dubbio", "senza riguardo per", "senza tregua", "senza ulteriore ritardo", "sia quel che sia", "solo se", "sotto questa luce", "sperando che", "sta volta", "su tutto", "subito dopo", "sul serio", "tanto per cominciare", "tanto quanto", "tra breve", "tra l'altro", "tra poco", "tra quanto", "tutte le volte", "tutti insieme", "tutto a un tratto", "tutto ad un tratto", "tutto d'un tratto", "tutto considerato", "tutto sommato", "un passo alla volta", "un tempo", "una volta", "una volta ogni tanto", "unito a", "va chiarito che", "va considerato che", "vada come vada", "vale a dire", "visto che"];

Object.defineProperty(functionWords$c, "__esModule", {
	value: true
});

functionWords$c.default = function () {
	return {
		// These word categories are filtered at the beginning of word combinations.
		filteredAtBeginning: generalAdjectivesAdverbs$9,

		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(ordinalNumerals$c, interviewVerbsInfinitive$2, passiveAuxiliariesInfinitive$1, otherAuxiliariesInfinitive$3, copulaInfinitive$3, delexicalizedVerbsInfinitive$3, generalAdjectivesAdverbsPreceding$1),

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(articles$8, prepositions$b, coordinatingConjunctions$7, demonstrativePronouns$8, intensifiers$c, quantifiers$c, possessivePronouns$6),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(transitionWords$j, personalPronounsNominative$6, personalPronounsAccusative$4, personalPronounsPrepositional$2, interjections$c, cardinalNumerals$c, filteredPassiveAuxiliaries$1, otherAuxiliaries$5, copula$6, interviewVerbs$c, delexicalizedVerbs$7, indefinitePronouns$c, correlativeConjunctions$2, subordinatingConjunctions$7, interrogativeDeterminers$4, interrogativePronouns$6, interrogativeAdverbs$1, locativeAdverbs$5, miscellaneous$b, pronominalAdverbs$2, recipeWords$b, timeWords$c, vagueNouns$c),

		// These word categories cannot directly precede a passive participle.
		cannotDirectlyPrecedePassiveParticiple: [].concat(articles$8, prepositions$b, personalPronounsAccusative$4, possessivePronouns$6, indefinitePronouns$c, cardinalNumerals$c, ordinalNumerals$c, delexicalizedVerbs$7, delexicalizedVerbsInfinitive$3, interviewVerbs$c, interrogativeDeterminers$4, interrogativePronouns$6, personalPronounsPrepositional$2, interrogativeAdverbs$1),

		// These word categories cannot intervene between an auxiliary and a corresponding passive participle.
		cannotBeBetweenPassiveAuxiliaryAndParticiple: [].concat(otherAuxiliaries$5, otherAuxiliariesInfinitive$3),

		// This export contains all of the above words.
		all: [].concat(articles$8, cardinalNumerals$c, ordinalNumerals$c, demonstrativePronouns$8, possessivePronouns$6, personalPronounsNominative$6, personalPronounsAccusative$4, personalPronounsPrepositional$2, quantifiers$c, indefinitePronouns$c, interrogativePronouns$6, interrogativeAdverbs$1, interrogativeDeterminers$4, pronominalAdverbs$2, locativeAdverbs$5, filteredPassiveAuxiliaries$1, passiveAuxiliariesInfinitive$1, otherAuxiliaries$5, otherAuxiliariesInfinitive$3, copula$6, copulaInfinitive$3, prepositions$b, coordinatingConjunctions$7, correlativeConjunctions$2, subordinatingConjunctions$7, interviewVerbs$c, interviewVerbsInfinitive$2, transitionWords$j, additionalTransitionWords$5, intensifiers$c, delexicalizedVerbs$7, delexicalizedVerbsInfinitive$3, interjections$c, generalAdjectivesAdverbs$9, generalAdjectivesAdverbsPreceding$1, recipeWords$b, vagueNouns$c, miscellaneous$b, timeWords$c, titlesPreceding$4)
	};
};

var _transitionWords$7 = transitionWords$k;

var _transitionWords2$7 = _interopRequireDefault$2T(_transitionWords$7);

function _interopRequireDefault$2T(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const transitionWords$j = (0, _transitionWords2$7.default)().singleWords;

/**
 * Returns an object with exceptions for the prominent words researcher.
 * @returns {Object} The object filled with exception arrays.
 */

const articles$8 = ["il", "i", "la", "le", "lo", "gli", "un", "uno", "una"];

const cardinalNumerals$c = ["due", "tre", "quattro", "cinque", "sette", "otto", "nove", "dieci", "undici", "dodici", "tredici", "quattordici", "quindici", "sedici", "diciassette", "diciotto", "diciannove", "venti", "cento", "mille", "mila", "duemila", "tremila", "quattromila", "cinquemila", "seimila", "settemila", "ottomila", "novemila", "diecimila", "milione", "milioni", "miliardo", "miliardi"];

const ordinalNumerals$c = ["prima", "primi", "prime", "secondo", "seconda", "secondi", "seconde", "terzo", "terza", "terzi", "terze", "quarto", "quarta", "quarti", "quarte", "quinto", "quinta", "quinti", "quinte", "sesto", "sesta", "sesti", "seste", "settimo", "settima", "settimi", "settime", "ottavo", "ottava", "ottavi", "ottave", "nono", "nona", "noni", "none", "decimo", "decima", "decimi", "decime", "undicesimo", "undicesima", "undicesimi", "undicesime", "dodicesimo", "dodicesima", "dodicesimi", "dodicesime", "tredicesimo", "tredicesima", "tredicesimi", "tredicesime", "quattordicesimo", "quattordicesima", "quattordicesimi", "quattordicesime", "quindicesimo", "quindicesima", "quindicesimi", "quindicesime", "sedicesimo", "sedicesima", "sedicesimi", "sedicesime", "diciassettesimo", "diciassettesima", "diciassettesimi", "diciassettesime", "diciannovesimo", "diciannovesima", "diciannovesimi", "diciannovesime", "ventesimo", "ventesima", "ventesimi", "ventesime"];

const personalPronounsNominative$6 = ["io", "tu", "egli", "esso", "lui", "ella", "essa", "lei", "noi", "voi", "essi", "esse", "loro"];

// 'La' and 'le' are already included in the list of articles.
const personalPronounsAccusative$4 = ["mi", "ti", "si", "ci", "vi", "li", "me", "te", "se", "glie", "glielo", "gliela", "glieli", "gliele", "gliene", "ce", "ve"];

const personalPronounsPrepositional$2 = ["sé"];

const demonstrativePronouns$8 = ["ciò", "codesto", "codesta", "codesti", "codeste", "colei", "colui", "coloro", "costei", "costui", "costoro", "medesimo", "medesima", "medesimi", "medesime", "questo", "questa", "questi", "queste", "quello", "quella", "quelli", "quelle", "quel", "quei", "quegli"];

const possessivePronouns$6 = ["mio", "mia", "miei", "mie", "tuo", "tua", "tuoi", "tue", "suo", "sua", "suoi", "sue", "nostro", "nostra", "nostri", "nostre", "vostro", "vostra", "vostri", "vostre"];

// Already in the list of transition words: appena.
const quantifiers$c = ["affatto", "alcun", "alcuna", "alcune", "alcuni", "alcuno", "bastantemente", "grandemente", "massimamente", "meno", "minimamente", "molta", "molte", "molti", "moltissimo", "molto", "nessun", "nessuna", "nessuno", "niente", "nulla", "ogni", "più", "po'", "poca", "poche", "pochi", "poco", "pochissime", "pochissimi", "qualche", "qualsiasi", "qualunque", "quintali", "rara", "rarissima", "rarissimo", "raro", "spesso", "spessissimo", "sufficientemente", "taluno", "taluna", "taluni", "talune", "tanta", "tante", "tanti", "tantissime", "tantissimi", "tanto", "tonnellate", "troppa", "troppe", "troppi", "troppo", "tutta", "tutte", "tutti", "tutto"];

// Already in the quantifier list: alcuno, molto, nessuno, poco, taluno tanto, troppo, tutto, nulla, niente.
const indefinitePronouns$c = ["alcunché", "alcunchè", "altro", "altra", "altri", "altre", "certa", "certi", "certe", "checché", "checchè", "chicchessia", "chiunque", "ciascuno", "ciascuna", "ciascun", "diverso", "diversa", "diversi", "diverse", "parecchio", "parecchia", "parecchi", "parecchie", "qualcosa", "qualcuno", "qualcuna", "vario", "varia", "vari", "varie"];

const interrogativeDeterminers$4 = ["che", "cosa", "cui", "qual", "quale", "quali"];

const interrogativePronouns$6 = ["chi", "quanta", "quante", "quanti", "quanto"];

const interrogativeAdverbs$1 = ["com'è", "com'era", "com'erano", "donde", "d'onde", "dove", "dov'è", "dov'era", "dov'erano", "dovunque"];

// 'Ci' and 'vi' are already part of the list of personal pronouns.
const pronominalAdverbs$2 = ["ne"];

// 'Via' not included because of primary meaning 'street'.
const locativeAdverbs$5 = ["accanto", "altrove", "attorno", "dappertutto", "giù", "là", "laggiù", "lassù", "lì", "ovunque", "qua", "quaggiù", "quassù", "qui"];

// 'Essere' is already part of the otherAuxiliaries list.
const filteredPassiveAuxiliaries$1 = ["vengano", "vengo", "vengono", "veniamo", "veniate", "venimmo", "venisse", "venissero", "venissi", "venissimo", "veniste", "venisti", "venite", "veniva", "venivamo", "venivano", "venivate", "venivi", "venivo", "venne", "vennero", "venni", "verrà", "verrai", "verranno", "verrebbe", "verrebbero", "verrei", "verremmo", "verremo", "verreste", "verresti", "verrete", "verrò", "viene", "vieni"];

const passiveAuxiliariesInfinitive$1 = ["venire", "venir"];

const otherAuxiliaries$5 = ["abbi", "abbia", "abbiamo", "abbiano", "abbiate", "abbiente", "avemmo", "avendo", "avente", "avesse", "avessero", "avessi", "avessimo", "aveste", "avesti", "avete", "aveva", "avevamo", "avevano", "avevate", "avevi", "avevo", "avrà", "avrai", "avranno", "avrebbe", "avrebbero", "avrei", "avremmo", "avremo", "avreste", "avresti", "avrete", "avrò", "avuto", "ebbe", "ebbero", "ebbi", "ha", "hai", "hanno", "ho", "l'abbi", "l'abbia", "l'abbiamo", "l'abbiano", "l'abbiate", "l'abbiente", "l'avemmo", "l'avendo", "l'avente", "l'avesse", "l'avessero", "l'avessi", "l'avessimo", "l'aveste", "l'avesti", "l'avete", "l'aveva", "l'avevamo", "l'avevano", "l'avevate", "l'avevi", "l'avevo", "l'avrà", "l'avrai", "l'avranno", "l'avrebbe", "l'avrebbero", "l'avrei", "l'avremmo", "l'avremo", "l'avreste", "l'avresti", "l'avrete", "l'avrò", "l'avuto", "l'ebbe", "l'ebbero", "l'ebbi", "l'ha", "l'hai", "l'hanno", "l'ho", "possa", "possano", "possiamo", "possiate", "posso", "possono", "poté", "potei", "potemmo", "potendo", "potente", "poterono", "potesse", "potessero", "potessi", "potessimo", "poteste", "potesti", "potete", "potette", "potettero", "potetti", "poteva", "potevamo", "potevano", "potevate", "potevi", "potevo", "potrà", "potrai", "potranno", "potrebbe", "potrebbero", "potrei", "potremmo", "potremo", "potreste", "potresti", "potrete", "potrò", "potuto", "può", "puoi", "voglia", "vogliamo", "vogliano", "vogliate", "voglio", "vogliono", "volemmo", "volendo", "volente", "volesse", "volessero", "volessi", "volessimo", "voleste", "volesti", "volete", "voleva", "volevamo", "volevano", "volevate", "volevi", "volevo", "volle", "vollero", "volli", "voluto", "vorrà", "vorrai", "vorranno", "vorrebbe", "vorrebbero", "vorrei", "vorremmo", "vorremo", "vorreste", "vorresti", "vorrete", "vorrò", "vuoi", "vuole", "debba", "debbano", "debbono", "deva", "deve", "devi", "devo", "devono", "dobbiamo", "dobbiate", "dové", "dovei", "dovemmo", "dovendo", "doverono", "dovesse", "dovessero", "dovessi", "dovessimo", "doveste", "dovesti", "dovete", "dovette", "dovettero", "dovetti", "doveva", "dovevamo", "dovevano", "dovevate", "dovevi", "dovevo", "dovrà", "dovrai", "dovranno", "dovrebbe", "dovrebbero", "dovrei", "dovremmo", "dovremo", "dovreste", "dovresti", "dovrete", "dovrò", "dovuto", "sa", "sai", "sanno", "sapemmo", "sapendo", "sapesse", "sapessero", "sapessi", "sapessimo", "sapeste", "sapesti", "sapete", "sapeva", "sapevamo", "sapevano", "sapevate", "sapevi", "sapevo", "sappi", "sappia", "sappiamo", "sappiano", "sappiate", "saprà", "saprai", "sapranno", "saprebbe", "saprebbero", "saprei", "sapremmo", "sapremo", "sapreste", "sapresti", "saprete", "saprò", "saputo", "seppe", "seppero", "seppi", "so", "soglia", "sogliamo", "sogliano", "sogliate", "soglio", "sogliono", "solesse", "solessero", "solessi", "solessimo", "soleste", "solete", "soleva", "solevamo", "solevano", "solevate", "solevi", "solevo", "suoli", "sta", "stai", "stando", "stanno", "stante", "starà", "starai", "staranno", "staremo", "starete", "starò", "stava", "stavamo", "stavano", "stavate", "stavi", "stavo", "stemmo", "stessero", "stessimo", "steste", "stesti", "stette", "stettero", "stetti", "stia", "stiamo", "stiano", "stiate", "sto"];

const otherAuxiliariesInfinitive$3 = ["avere", "l'avere", "aver", "l'aver", "potere", "poter", "volere", "voler", "dovere", "dover", "sapere", "saper", "solere", "stare", "star"];

const copula$6 = ["è", "e'", "era", "erano", "eravamo", "eravate", "eri", "ero", "essendo", "essente", "fosse", "fossero", "fossi", "fossimo", "foste", "fosti", "fu", "fui", "fummo", "furono", "sarà", "sarai", "saranno", "sarebbe", "sarebbero", "sarei", "saremmo", "saremo", "sareste", "saresti", "sarete", "sarò", "sei", "sia", "siamo", "siano", "siate", "siete", "sii", "sono", "stata", "state", "stati", "stato"];

const copulaInfinitive$3 = ["essere", "esser"];

/*
'Verso' ('towards') not included because it can also mean 'verse'.
Already in other lists: malgrado, nonostante.
 */
const prepositions$b = ["di", "del", "dello", "della", "dei", "degli", "delle", "a", "ad", "al", "allo", "alla", "ai", "agli", "alle", "da", "dal", "dallo", "dalla", "dai", "dagli", "dalle", "in", "nel", "nello", "nella", "nei", "negli", "nelle", "con", "col", "collo", "colla", "coi", "cogli", "colle", "su", "sul", "sullo", "sulla", "sui", "sugli", "sulle", "per", "pel", "pello", "pella", "pei", "pegli", "tra", "fra", "attraverso", "circa", "contro", "davanti", "dentro", "dietro", "entro", "escluso", "fuori", "insieme", "intorno", "lontano", "lungo", "mediante", "oltre", "presso", "rasente", "riguardo", "senza", "sopra", "sotto", "tramite", "vicino"];

const coordinatingConjunctions$7 = ["e", "ed", "o", "oppure"];

/* '
Tale' from 'tale ... quale'.
'Dall'altra' from 'da una parte... dall'altra'.
Already in other lists: vuoi...vuoi, tanto...quanto, quanto...quanto, ora...ora, non solo...ma anche, sia...sia, o...o,
più...meno, né...né, altrettanto...così, così...come.
 */
const correlativeConjunctions$2 = ["tale", "l'uno", "l'altro", "tali", "dall'altra"];

/*
Already in another list (transition words, interrogative adverbs, numerals, prepositions):
perché, quando, mentre, appena [che], sebbene, fino, affinché, finché, dato [che], visto [che], benché,
come, prima [che], dopo, per, senza [che], di, sempre, nonostante, malgrado, così [che], in modo...da,
tanto...da, con, dove, quanto, più...che, meno, peggio...che, meglio...di, se, che, di, a meno che, siccome,
ogni volta [che], anche se, cosicché, invece, bensì, [al] punto [che].
'Modo' from 'in modgiacché o che'.
'Volta' from 'una volta che.
Excluded because of primary meaning: dal momento che, allo scopo di, a furia di ('fury', 'haste', 'rage'),
a forza di ('force'), a condizione che ('condition').
*/
const subordinatingConjunctions$7 = ["anziché", "anzichè", "fuorché", "fuorchè", "giacché", "giacchè", "laddove", "modo", "ove", "qualora", "quantunque", "volta"];

/*
These verbs are frequently used in interviews to indicate questions and answers.
Not included: 'legge' ('reads', but also: 'law'), 'letto' ('(has) read', but also: bed), 'precisa' ('states', but also: 'precise').
 */
const interviewVerbs$c = ["dice", "dicono", "diceva", "dicevano", "disse", "dissero", "detto", "domanda", "domandano", "domandava", "domandavano", "domandò", "domandarono", "domandato", "afferma", "affermato", "aggiunge", "aggiunto", "ammette", "ammesso", "annuncia", "annunciato", "assicura", "assicurato", "chiede", "chiesto", "commentato", "conclude", "concluso", "continua", "continuato", "denuncia", "denunciato", "dichiara", "dichiarato", "esordisce", "esordito", "inizia", "iniziato", "precisato", "prosegue", "proseguito", "racconta", "raccontato", "recita", "recitato", "replica", "replicato", "risponde", "risposto", "rimarca", "rimarcato", "rivela", "rivelato", "scandisce", "scandito", "segnala", "segnalato", "sottolinea", "sottolineato", "spiega", "spiegato"];

const interviewVerbsInfinitive$2 = ["affermare", "aggiungere", "ammettere", "annunciare", "assicurare", "chiedere", "commentare", "concludere", "continuare", "denunciare", "dichiarare", "esordire", "iniziare", "precisare", "proseguire", "raccontare", "recitare", "replicare", "rispondere", "rimarcare", "rivelare", "scandire", "segnalare", "sottolineare", "spiegare"];

/*
These transition words were not included in the list for the transition word assessment for various reasons.
'Appunto' ('just', 'exactly') not included for the second meaning of 'note'.
*/
const additionalTransitionWords$5 = ["eventualmente", "forse", "mai", "probabilmente"];

const intensifiers$c = ["addirittura", "assolutamente", "ben", "estremamente", "mica", "nemmeno", "quasi"];

// These verbs convey little meaning.
const delexicalizedVerbs$7 = ["fa", "fa'", "faccia", "facciamo", "facciano", "facciate", "faccio", "facemmo", "facendo", "facente", "facesse", "facessero", "facessi", "facessimo", "faceste", "facesti", "faceva", "facevamo", "facevano", "facevate", "facevi", "facevo", "fai", "fanno", "farà", "farai", "faranno", "farebbe", "farebbero", "farei", "faremmo", "faremo", "fareste", "faresti", "farete", "farò", "fate", "fatto", "fece", "fecero", "feci", "fo"];

const delexicalizedVerbsInfinitive$3 = ["fare"];

/*
These adjectives and adverbs are so general, they should never be suggested as a (single) keyword.
 Keyword combinations containing these adjectives/adverbs are fine.
 */
const generalAdjectivesAdverbs$9 = ["anteriore", "anteriori", "precedente", "precedenti", "facile", "facili", "facilissimo", "facilissima", "facilissimi", "facilissime", "semplice", "semplici", "semplicissima", "semplicissimo", "semplicissimi", "semplicissime", "semplicemente", "rapido", "rapida", "rapidi", "rapide", "veloce", "veloci", "differente", "difficile", "difficili", "difficilissimo", "difficilissima", "difficilissimi", "difficilissime", "basso", "bassa", "bassi", "basse", "alto", "alta", "alti", "alte", "normale", "normali", "normalmente", "corto", "corta", "corti", "corte", "breve", "brevi", "recente", "recenti", "totale", "totali", "completo", "completa", "completi", "complete", "possibile", "possibili", "ultimo", "ultima", "ultimi", "ultime", "differenti", "simile", "simili", "prossimo", "prossima", "prossimi", "prossime", "giusto", "giusta", "giusti", "giuste", "giustamente", "cosiddetto", "bene", "meglio", "benissimo", "male", "peggio", "malissimo", "comunemente", "constantemente", "direttamente", "esattamente", "facilmente", "generalmente", "leggermente", "personalmente", "recentemente", "sinceramente", "solamente", "avanti", "indietro"];

const generalAdjectivesAdverbsPreceding$1 = ["nuovo", "nuova", "nuovi", "nuove", "vecchio", "vecchia", "vecchi", "vecchie", "bello", "bella", "belli", "belle", "bei", "begli", "bellissimo", "bellissima", "bellissimi", "bellissime", "buono", "buona", "buoni", "buone", "buonissimo", "buonissima", "buonissimi", "buonissime", "grande", "grandi", "grandissimo", "grandissima", "grandissimi", "grandissime", "lunga", "lunghi", "lunghe", "piccolo", "piccola", "piccoli", "piccole", "piccolissimo", "piccolissima", "piccolissimi", "piccolissime", "proprio", "propria", "propri", "proprie", "solito", "solita", "soliti", "solite", "stesso", "stessa", "stessi", "stesse"];

const interjections$c = ["accidenti", "acciderba", "ah", "aah", "ahi", "ahia", "ahimé", "bah", "beh", "boh", "ca", "caspita", "chissà", "de'", "diamine", "ecco", "eh", "ehi", "eeh", "ehilà", "ehm", "gna", "ih", "magari", "macché", "macchè", "mah", "mhm", "nca", "neh", "oibò", "oh", "ohe", "ohé", "ohilá", "ohibò", "ohimé", "okay", "ok", "olà", "poh", "pota", "puah", "sorbole", "to'", "toh", "ts", "uff", "uffa", "uh", "uhi"];

// These words and abbreviations are frequently used in recipes in lists of ingredients.
const recipeWords$b = ["cc", "g", "hg", "hl", "kg", "l", "prs", "pz", "q.b.", "qb", "ta", "tz"];

const timeWords$c = ["minuto", "minuti", "ora", "ore", "giorno", "giorni", "giornata", "giornate", "settimana", "settimane", "mese", "mesi", "anno", "anni", "oggi", "domani", "ieri", "stamattina", "stanotte", "stasera", "tardi"];

// Already included in other lists.
const vagueNouns$c = ["aspetto", "aspetti", "caso", "casi", "cose", "idea", "idee", "istanza", "maniera", "oggetto", "oggetti", "parte", "parti", "persona", "persone", "pezzo", "pezzi", "punto", "punti", "sorta", "sorte", "tema", "temi", "volte"];

const miscellaneous$b = ["sì", "no", "non", "€", "euro", "euros", "ecc", "eccetera"];

const titlesPreceding$4 = ["sig.na", "sig.ra", "sig", "sigg", "dr", "dr.ssa", "dott", "dott.ssa", "prof", "prof.ssa", "gent", "gent.mo", "gent.mi", "gent.ma", "gent.me", "egr", "egr.i", "egr.ia", "egr.ie", "preg.mo", "preg.mo", "preg.ma", "preg.me", "ill", "ill.mo", "ill.mi", "ill.ma", "ill.me", "cav", "on", "spett"];

var functionWords$b = {};

var transitionWords$i = {};

Object.defineProperty(transitionWords$i, "__esModule", {
	value: true
});

transitionWords$i.default = function () {
	return {
		singleWords: singleWords$a,
		multipleWords: multipleWords$a,
		allWords: singleWords$a.concat(multipleWords$a)
	};
};

/** @module config/transitionWords */

const singleWords$a = ["ainsi", "alors", "aussi", "car", "cependant", "certainement", "certes", "conséquemment", "d'abord", "d'ailleurs", "d'après", "davantage", "désormais", "deuxièmement", "donc", "dorénavant", "effectivement", "également", "enfin", "ensuite", "entre-temps", "essentiellement", "excepté", "finalement", "globalement", "jusqu'ici", "là-dessus", "lorsque", "mais", "malgré", "néanmoins", "notamment", "partant", "plutôt", "pourtant", "précédemment", "premièrement", "probablement", "puis", "puisque", "quoique", "sauf", "selon", "semblablement", "sinon", "suivant", "toutefois", "troisièmement"];

const multipleWords$a = ["à cause de", "à ce jour", "à ce propos", "à ce sujet", "à cet égard", "à cette fin", "à compter de", "à condition que", "à défaut de", "à force de", "à juste titre", "à la lumière de", "à la suite de", "à l'aide de", "à l'appui de", "à l'encontre de", "à l'époque actuelle", "à l'exception de", "à l'exclusion de", "à l'heure actuelle", "à l'image de", "à l'instar de", "à l'inverse", "à l'inverse de", "à l'opposé", "à la condition que", "à mesure que", "à moins que", "à nouveau", "à partir de", "à première vue", "à savoir", "à seule fin que", "à supposer que", "à tel point que", "à tout prendre", "à vrai dire", "afin de", "afin d'attirer l'attention sur", "afin que", "ainsi donc", "ainsi que", "alors que", "antérieurement", "après cela", "après quoi", "après que", "après réflexion", "après tout", "attendu que", "au cas où", "au contraire", "au fond", "au fur et à mesure", "au lieu de", "au même temps", "au moment où", "au moyen de", "au point que", "au risque de", "au surplus", "au total", "aussi bien que", "aussitôt que", "autant que", "autrement dit", "avant que", "avant tout", "ayant fini", "bien que", "c'est à dire que", "c'est ainsi que", "c'est dans ce but que", "c'est dire", "c'est le cas de", "c'est pour cela que", "c'est la raison pour laquelle", "c'est pourquoi", "c'est qu'en effet", "c'est-à-dire", "ça confirme que", "ça montre que", "ça prouve que", "cela étant", "cela dit", "cependant que", "compte tenu", "comme l'illustre", "comme le souligne", "comme on pouvait s'y attendre", "comme quoi", "comme si", "commençons par examiner", "comparativement à", "conformément à", "contrairement à", "considérons par exemple", "d'autant plus", "d'autant que", "d'autre part", "d'ici là", "d'où", "d'un autre côté", "d'un côté", "d'une façon générale", "dans ce cas", "dans ces conditions", "dans cet esprit", "dans l'ensemble", "dans l'état actuel des choses", "dans l'éventualité où", "dans l'hypothèse où", "dans la mesure où", "dans le but de", "dans le cadre de", "dans le cas où", "dans les circonstances actuelles", "dans les grandes lignes", "dans un autre ordre d'idée", "dans un délai de", "de ce fait", "de cette façon", "de crainte que", "de façon à", "de façon à ce que", "de façon que", "de fait", "de l'autre côté", "de la même manière", "de la même façon que", "de manière que", "de même", "de même qu'à", "de même que", "de nos jours", "de peur que", "de prime abord", "de sorte que", "de surcroît", "de telle manière que", "de telle sorte que", "de toute évidence", "de toute façon", "de toute manière", "depuis que", "dès lors que", "dès maintenant", "dès qua", "dès que", "du fait que", "du moins", "du moment que", "du point de vue de", "du reste", "d'ici là", "d'ores et déjà", "en admettant que", "en attendant que", "en bref", "en cas de", "en cas que", "en ce cas", "en ce domaine", "en ce moment", "en ce qui a trait à", "en ce qui concerne", "en ce sens", "en cela", "en comparaison de", "en conclusion", "en conformité avec", "en conséquence", "en d'autres termes", "en définitive", "en dépit de", "en dernier lieu", "en deuxième lieu", "en effet", "en face de", "en fait", "en fin de compte", "en général", "en guise de conclusion", "en matière de", "en même temps que", "en outre", "en particulier", "en plus", "en premier lieu", "en principe", "en raison de", "en réalité", "en règle générale", "en résumé", "en revanche", "en second lieu", "en somme", "en sorte que", "en supposant que", "en tant que", "en terminant", "en théorie", "en tout cas", "en tout premier lieu", "en troisième lieu", "en un mot", "en vérité", "en vue que", "encore que", "encore une fois", "entre autres", "et même", "et puis", "étant donné qu'à", "étant donné que", "face à", "grâce à", "il est à noter que", "il est indéniable que", "il est question de", "il est vrai que", "il faut dire aussi que", "il faut reconnaître que", "il faut souligner que", "il ne faut pas oublier que", "il s'ensuit que", "il suffit de prendre pour exemple", "jusqu'ici", "il y a aussi", "jusqu'à ce que", "jusqu'à ce jour", "jusqu'à maintenant", "jusqu'à présent", "jusqu'au moment où", "jusqu'ici", "l'aspect le plus important de", "l'exemple le plus significatif", "jusqu'au moment où", "la preuve c'est que", "loin que", "mais en réalité", "malgré cela", "malgré tout", "même si", "mentionnons que", "mis à part le fait que", "notons que", "nul doute que", "ou bien", "outre cela", "où que", "par ailleurs", "par conséquent", "par contre", "par exception", "par exemple", "par la suite", "par l'entremise de", "par l'intermédiaire de", "par rapport à", "par suite", "par suite de", "par surcroît", "parce que", "pareillement", "partant de ce fait", "pas du tout", "pendant que", "plus précisément", "plus tard", "pour ainsi dire", "pour autant que", "pour ce qui est de", "pour ces motifs", "pour ces raisons", "pour cette raison", "pour commencer", "pour conclure", "pour le moment", "pour marquer la causalité", "pour l'instant", "pour peu que", "pour prendre un autre exemple", "pour que", "pour résumé", "pour terminer", "pour tout dire", "pour toutes ces raisons", "pourvu que", "prenons le cas de", "quand bien même que", "quand même", "quant à", "quel que soit", "qui plus est", "qui que", "quitte à", "quoi qu'il en soit", "quoi que", "quoiqu'il en soit", "sans délai", "sans doute", "sans parler de", "sans préjuger", "sans tarder", "sauf si", "selon que", "si bien que", "si ce n'est que", "si l'on songe que", "sitôt que", "somme toute", "sous cette réserve", "sous prétexte que", "sous réserve de", "sous réserve que", "suivant que", "supposé que", "sur le plan de", "tandis que", "tant et si bien que", "tant que", "tel que", "tellement que", "touchant à", "tout à fait", "tout bien pesé", "tout compte fait", "tout d'abord", "tout d'abord examinons", "tout d'abord il faut dire que", "tout de même", "tout en reconnaissant que", "une fois de plus", "vu que"];

Object.defineProperty(functionWords$b, "__esModule", {
	value: true
});

functionWords$b.default = function () {
	return {
		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(ordinalNumerals$b, otherAuxiliariesInfinitive$2, delexicalizedVerbsInfinitive$2, copulaInfinitive$2, interviewVerbsInfinitive$1, generalAdjectivesAdverbsPreceding),

		// These word categories are filtered at the beginning of word combinations.
		filteredAtBeginning: generalAdjectivesAdverbs$8,

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(articles$7, prepositions$a, coordinatingConjunctions$6, demonstrativePronouns$7, intensifiers$b, quantifiers$b, possessivePronouns$5),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(transitionWords$h, personalPronounsNominative$5, personalPronounsAccusative$3, personalPronounsStressed, reflexivePronouns$a, interjections$b, cardinalNumerals$b, copula$5, interviewVerbs$b, otherAuxiliaries$4, delexicalizedVerbs$6, indefinitePronouns$b, correlativeConjunctions$1, subordinatingConjunctions$6, interrogativeAdjectives, relativePronouns$2, locativeAdverbs$4, miscellaneous$a, pronominalAdverbs$1, recipeWords$a, timeWords$b, vagueNouns$b),

		// These word categories cannot directly precede a passive participle.
		cannotDirectlyPrecedePassiveParticiple: [].concat(articles$7, prepositions$a, personalPronounsStressed, personalPronounsAccusative$3, possessivePronouns$5, reflexivePronouns$a, indefinitePronouns$b, interrogativeProAdverbs$5, interrogativeAdjectives, cardinalNumerals$b, ordinalNumerals$b, delexicalizedVerbs$6, interviewVerbs$b, delexicalizedVerbsInfinitive$2),

		// These word categories cannot intervene between an auxiliary and a corresponding passive participle.
		cannotBeBetweenPassiveAuxiliaryAndParticiple: [].concat(otherAuxiliaries$4, otherAuxiliariesInfinitive$2),

		// This export contains all of the above words.
		all: [].concat(articles$7, cardinalNumerals$b, ordinalNumerals$b, demonstrativePronouns$7, possessivePronouns$5, reflexivePronouns$a, personalPronounsNominative$5, personalPronounsAccusative$3, relativePronouns$2, quantifiers$b, indefinitePronouns$b, interrogativeProAdverbs$5, pronominalAdverbs$1, locativeAdverbs$4, otherAuxiliaries$4, otherAuxiliariesInfinitive$2, interrogativeAdjectives, copula$5, copulaInfinitive$2, prepositions$a, coordinatingConjunctions$6, correlativeConjunctions$1, subordinatingConjunctions$6, interviewVerbs$b, interviewVerbsInfinitive$1, transitionWords$h, additionalTransitionWords$4, intensifiers$b, delexicalizedVerbs$6, delexicalizedVerbsInfinitive$2, interjections$b, generalAdjectivesAdverbs$8, generalAdjectivesAdverbsPreceding, recipeWords$a, vagueNouns$b, miscellaneous$a, timeWords$b, titlesPreceding$3, titlesFollowing$1, personalPronounsStressed)
	};
};

var _transitionWords$6 = transitionWords$i;

var _transitionWords2$6 = _interopRequireDefault$2S(_transitionWords$6);

function _interopRequireDefault$2S(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const transitionWords$h = (0, _transitionWords2$6.default)().singleWords;

/**
 * Returns an object with exceptions for the prominent words researcher
 * @returns {Object} The object filled with exception arrays.
 */

const articles$7 = ["le", "la", "les", "un", "une", "des", "aux", "du", "au", "d'un", "d'une", "l'un", "l'une"];

const cardinalNumerals$b = ["deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf", "dix", "onze", "douze", "treize", "quatorze", "quinze", "seize", "dix-sept", "dix-huit", "dix-neuf", "vingt", "trente", "quarante", "cinquante", "soixante", "soixante-dix", "quatre-vingt", "quatre-vingt-dix", "septante", "huitante", "octante", "nonante", "cent", "mille", "million", "milliard"];

// 'premier' and 'première' are not included because of their secondary meanings ('prime minister', '[movie] premiere')
const ordinalNumerals$b = ["second", "secondes", "deuxième", "deuxièmes", "troisième", "troisièmes", "quatrième", "quatrièmes", "cinquième", "cinquièmes", "sixième", "sixièmes", "septième", "septièmes", "huitième", "huitièmes", "neuvième", "neuvièmes", "dixième", "dixièmes", "onzième", "onzièmes", "douzième", "douzièmes", "treizième", "treizièmes", "quatorzième", "quatorzièmes", "quinzième", "quinzièmes", "seizième", "seizièmes", "dix-septième", "dix-septièmes", "dix-huitième", "dix-huitièmes", "dix-neuvième", "dix-neuvièmes", "vingtième", "vingtièmes"];

const personalPronounsNominative$5 = ["je", "tu", "il", "elle", "on", "nous", "vous", "ils", "elles", "qu'il", "qu'elle", "qu'ils", "qu'elles", "qu'on", "d'elle", "d'elles"];

const personalPronounsStressed = ["moi", "toi", "lui", "soi", "eux", "d'eux", "qu'eux"];

// Le, la, les are already included in the articles list.
const personalPronounsAccusative$3 = ["me", "te"];

const demonstrativePronouns$7 = ["celui", "celle", "ceux", "celles", "ce", "celui-ci", "celui-là", "celle-ci", "celle-là", "ceux-ci", "ceux-là", "celles-ci", "celles-là", "ceci", "cela", "ça", "cette", "cet", "ces"];

const possessivePronouns$5 = ["mon", "ton", "son", "ma", "ta", "sa", "mes", "tes", "ses", "notre", "votre", "leur", "nos", "vos", "leurs"];

const quantifiers$b = ["beaucoup", "peu", "quelque", "quelques", "tous", "tout", "toute", "toutes", "plusieurs", "plein", "chaque", "suffisant", "suffisante", "suffisantes", "suffisants", "faible", "moins", "tant", "plus", "divers", "diverse", "diverses"];

// The remaining reflexive personal pronouns are already included in other pronoun lists.
const reflexivePronouns$a = ["se"];

const indefinitePronouns$b = ["aucun", "aucune", "autre", "autres", "d'autres", "certain", "certaine", "certaines", "certains", "chacun", "chacune", "même", "mêmes", "quelqu'un", "quelqu'une", "quelques'uns", "quelques'unes", "autrui", "nul", "personne", "quiconque", "rien", "d'aucunes", "d'aucuns", "nuls", "nules", "l'autre", "tel", "telle", "tels", "telles"];

const relativePronouns$2 = ["qui", "que", "lequel", "laquelle", "auquel", "auxquels", "auxquelles", "duquel", "desquels", "desquelles", "dont", "où", "quoi"];

const interrogativeProAdverbs$5 = ["combien", "comment", "pourquoi", "d'où"];

const interrogativeAdjectives = ["quel", "quels", "quelle"];

const pronominalAdverbs$1 = ["y", "n'y"];

const locativeAdverbs$4 = ["là", "ici", "d'ici", "voici"];

// 'Vins' is not included because it also means 'wines'.
const otherAuxiliaries$4 = ["a", "a-t-elle", "a-t-il", "a-t-on", "ai", "ai-je", "aie", "as", "as-tu", "aura", "aurai", "auraient", "aurais", "aurait", "auras", "aurez", "auriez", "aurons", "auront", "avaient", "avais", "avait", "avez", "avez-vous", "aviez", "avions", "avons", "avons-nous", "ayez", "ayons", "eu", "eûmes", "eurent", "eus", "eut", "eûtes", "j'ai", "j'aurai", "j'avais", "j'eus", "ont", "ont-elles", "ont-ils", "vais", "vas", "va", "allons", "allez", "vont", "vais-je", "vas-tu", "va-t-il", "va-t-elle", "va-t-on", "allons-nous", "allez-vous", "vont-elles", "vont-ils", "allé", "allés", "j'allai", "allai", "allas", "alla", "allâmes", "allâtes", "allèrent", "j'allais", "allais", "allait", "allions", "alliez", "allaient", "j'irai", "iras", "ira", "irons", "irez", "iront", "j'aille", "aille", "ailles", "aillent", "j'allasse", "allasse", "allasses", "allât", "allassions", "allassiez", "allassent", "j'irais", "irais", "irait", "irions", "iriez", "iraient", "allant", "viens", "vient", "venons", "venez", "viennent", "viens-je", "viens-de", "vient-il", "vient-elle", "vient-on", "venons-nous", "venez-vous", "viennent-elles", "viennent-ils", "vins", "vint", "vînmes", "vîntes", "vinrent", "venu", "venus", "venais", "venait", "venions", "veniez", "venaient", "viendrai", "viendras", "viendra", "viendrons", "viendrez", "viendront", "vienne", "viennes", "vinsse", "vinsses", "vînt", "vinssions", "vinssiez", "vinssent", "viendrais", "viendrait", "viendrions", "viendriez", "viendraient", "venant", "dois", "doit", "devons", "devez", "doivent", "dois-je", "dois-tu", "doit-il", "doit-elle", "doit-on", "devons-nous", "devez-vous", "doivent-elles", "doivent-ils", "dus", "dut", "dûmes", "dûtes", "durent", "dû", "devais", "devait", "devions", "deviez", "devaient", "devrai", "devras", "devra", "devrons", "devrez", "devront", "doive", "doives", "dusse", "dusses", "dût", "dussions", "dussiez", "dussent", "devrais", "devrait", "devrions", "devriez", "devraient", "peux", "peut", "pouvons", "pouvez", "peuvent", "peux-je", "peux-tu", "peut-il", "peut-elle", "peut-on", "pouvons-nous", "pouvez-vous", "peuvent-ils", "peuvent-elles", "pus", "put", "pûmes", "pûtes", "purent", "pu", "pouvais", "pouvait", "pouvions", "pouviez", "pouvaient", "pourrai", "pourras", "pourra", "pourrons", "pourrez", "pourront", "puisse", "puisses", "puissions", "puissiez", "puissent", "pusse", "pusses", "pût", "pussions", "pussiez", "pussent", "pourrais", "pourrait", "pourrions", "pourriez", "pourraient", "pouvant", "semble", "sembles", "semblons", "semblez", "semblent", "semble-je", "sembles-il", "sembles-elle", "sembles-on", "semblons-nous", "semblez-vous", "semblent-ils", "semblent-elles", "semblai", "semblas", "sembla", "semblâmes", "semblâtes", "semblèrent", "semblais", "semblait", "semblions", "sembliez", "semblaient", "semblerai", "sembleras", "semblera", "semblerons", "semblerez", "sembleront", "semblé", "semblasse", "semblasses", "semblât", "semblassions", "semblassiez", "semblassent", "semblerais", "semblerait", "semblerions", "sembleriez", "sembleraient", "parais", "paraît", "ait", "paraissons", "paraissez", "paraissent", "parais-je", "parais-tu", "paraît-il", "paraît-elle", "paraît-on", "ait-il", "ait-elle", "ait-on", "paraissons-nous", "paraissez-vous", "paraissent-ils", "paraissent-elles", "parus", "parut", "parûmes", "parûtes", "parurent", "paraissais", "paraissait", "paraissions", "paraissiez", "paraissaient", "paraîtrai", "paraîtras", "paraîtra", "paraîtrons", "paraîtrez", "paraîtront", "paru", "paraisse", "paraisses", "parusse", "parusses", "parût", "parussions", "parussiez", "parussent", "paraîtrais", "paraîtrait", "paraîtrions", "paraîtriez", "paraîtraient", "paraitrais", "paraitrait", "paraitrions", "paraitriez", "paraitraient", "paraissant", "mets", "met", "mettons", "mettez", "mettent", "mets-je", "mets-tu", "met-il", "met-elle", "met-on", "mettons-nous", "mettez-vous", "mettent-ils", "mettent-elles", "mis", "mit", "mîmes", "mîtes", "mirent", "mettais", "mettait", "mettions", "mettiez", "mettaient", "mettrai", "mettras", "mettra", "mettrons", "mettrez", "mettront", "mette", "mettes", "misse", "misses", "mît", "missions", "missiez", "missent", "mettrais", "mettrait", "mettrions", "mettriez", "mettraient", "mettant", "finis", "finit", "finissons", "finissez", "finissent", "finis-je", "finis-tu", "finit-il", "finit-elle", "finit-on", "finissons-nous", "finissez-vous", "finissent-ils", "finissent-elles", "finîmes", "finîtes", "finirent", "finissais", "finissait", "finissions", "finissiez", "finissaient", "finirai", "finiras", "finira", "finirons", "finirez", "finiront", "fini", "finisse", "finisses", "finît", "finirais", "finirait", "finirions", "finiriez", "finiraient", "finissant", "n'a", "n'ai", "n'aie", "n'as", "n'aura", "n'aurai", "n'auraient", "n'aurais", "n'aurait", "n'auras", "n'aurez", "n'auriez", "n'aurons", "n'auront", "n'avaient", "n'avais", "n'avait", "n'avez", "n'avez-vous", "n'aviez", "n'avions", "n'avons", "n'avons-nous", "n'ayez", "n'ayons", "n'ont", "n'ont-elles", "n'ont-ils", "n'allons", "n'allez", "n'allais", "n'allait", "n'allions", "n'alliez", "n'allaient", "n'iras", "n'ira", "n'irons", "n'irez", "n'iront", "qu'a"];

const otherAuxiliariesInfinitive$2 = ["avoir", "aller", "venir", "devoir", "pouvoir", "sembler", "paraître", "paraitre", "mettre", "finir", "d'avoir", "d'aller", "n'avoir", "l'avoir"];

const copula$5 = ["suis", "es", "est", "est-ce", "n'est", "sommes", "êtes", "sont", "suis-je", "es-tu", "est-il", "est-elle", "est-on", "sommes-nous", "êtes-vous", "sont-ils", "sont-elles", "étais", "était", "étions", "étiez", "étaient", "serai", "seras", "sera", "serons", "serez", "seront", "serais", "serait", "serions", "seriez", "seraient", "sois", "soit", "soyons", "soyez", "soient", "été", "n'es", "n'est-ce", "n'êtes", "n'était", "n'étais", "n'étions", "n'étiez", "n'étaient", "qu'est"];

const copulaInfinitive$2 = ["être", "d'être"];

/*
’Excepté' not filtered because might also be participle of 'excepter', 'concernant' not filtered because might also be present participle
of 'concerner'.
Not filtered because of primary meaning: 'grâce à' ('grace'), 'en face' ('face'), 'en dehors' ('outside'), 'à côté' ('side'),
'à droite' ('right'), 'à gauche' ('left'). 'voici' already included in the locative pronoun list.
'hors' for 'hors de', 'quant' for 'quant à'. ‘travers’ is part of 'à travers.'
 */

const prepositions$a = ["à", "après", "d'après", "au-delà", "au-dessous", "au-dessus", "avant", "avec", "concernant", "chez", "contre", "dans", "de", "depuis", "derrière", "dès", "devant", "durant", "en", "entre", "envers", "environ", "hormis", "hors", "jusque", "jusqu'à", "jusqu'au", "jusqu'aux", "loin", "moyennant", "outre", "par", "parmi", "pendant", "pour", "près", "quant", "sans", "sous", "sur", "travers", "vers", "voilà"];

const coordinatingConjunctions$6 = ["et", "ni", "or", "ou"];

/*
Et...et, ou...ou, ni...ni – in their simple forms already in other lists. 'd'une', 'd'autre' are part of 'd'une part…d'autre part'.
'sinon' is part of 'sinon…du moins'.
*/

const correlativeConjunctions$1 = ["non", "pas", "seulement", "sitôt", "aussitôt", "d'autre"];

/*
Many subordinating conjunctions are already included in the prepositions list, transition words list or pronominal adverbs list.
'autant', 'd'autant', 'd'ici', 'tandis' part of the complex form with 'que', 'lors' as a part of 'lors même que',
'parce' as a part of 'parce que'
 */

const subordinatingConjunctions$6 = ["afin", "autant", "comme", "d'autant", "d'ici", "quand", "lors", "parce", "si", "tandis"];

/*
 These verbs are frequently used in interviews to indicate questions and answers.
'Dire' ('to say'), 'demander' ('to ask'), 'penser' ('to think')– 16 forms; more specific verbs – 4 forms
'affirmer', 'ajouter' ('to add'), 'analyser', 'avancer', 'écrire' ('to write'), 'indiquer', 'poursuivre' ('to pursue'), 'préciser', 'résumer',
 'souvenir' ('to remember'), 'témoigner' ('to witness') – only VS forms (due to their more general nature)
 */

const interviewVerbs$b = ["dit", "disent", "dit-il", "dit-elle", "disent-ils", "disent-elles", "disait", "disait-il", "disait-elle", "disaient-ils", "disaient-elles", "dirent", "demande", "demandent", "demande-t-il", "demande-t-elle", "demandent-ils", "demandent-elles", "demandait", "demandaient", "demandait-il", "demandait-elle", "demandaient-ils", "demandaient-elles", "demanda", "demanda-t-il", "demanda-t-elle", "demandé", "pense", "pensent", "pense-t-il", "pense-t-elle", "pensent-ils", "pensent-elles", "pensait", "pensaient", "pensait-il", "pensait-elle", "pensaient-ils", "pensaient-elles", "pensa", "pensa-t-il", "pensa-t-elle", "pensé", "affirme", "affirme-t-il", "affirme-t-elle", "affirmé", "avoue", "avoue-t-il", "avoue-t-elle", "avoué", "concède", "concède-t-il", "concède-t-elle", "concédé", "confie", "confie-t-il", "confie-t-elle", "confié", "continue", "continue-t-il", "continue-t-elle", "continué", "déclame", "déclame-t-il", "déclame-t-elle", "déclamé", "déclare", "déclare-t-il", "déclare-t-elle", "déclaré", "déplore", "déplore-t-il", "déplore-t-elle", "déploré", "explique", "explique-t-il", "explique-t-elle", "expliqué", "lance", "lance-t-il", "lance-t-elle", "lancé", "narre", "narre-t-il", "narre-t-elle", "narré", "raconte", "raconte-t-il", "raconte-t-elle", "raconté", "rappelle", "rappelle-t-il", "rappelle-t-elle", "rappelé", "réagit", "réagit-il", "réagit-elle", "réagi", "répond", "répond-il", "répond-elle", "répondu", "rétorque", "rétorque-t-il", "rétorque-t-elle", "rétorqué", "souligne", "souligne-t-il", "souligne-t-elle", "souligné", "affirme-t-il", "affirme-t-elle", "ajoute-t-il", "ajoute-t-elle", "analyse-t-il", "analyse-t-elle", "avance-t-il", "avance-t-elle", "écrit-il", "écrit-elle", "indique-t-il", "indique-t-elle", "poursuit-il", "poursuit-elle", "précise-t-il", "précise-t-elle", "résume-t-il", "résume-t-elle", "souvient-il", "souvient-elle", "témoigne-t-il", "témoigne-t-elle"];

const interviewVerbsInfinitive$1 = ["dire", "penser", "demander", "concéder", "continuer", "confier", "déclamer", "déclarer", "déplorer", "expliquer", "lancer", "narrer", "raconter", "rappeler", "réagir", "répondre", "rétorquer", "souligner", "affirmer", "ajouter", "analyser", "avancer", "écrire", "indiquer", "poursuivre", "préciser", "résumer", "témoigner"];

// These transition words were not included in the list for the transition word assessment for various reasons.
const additionalTransitionWords$4 = ["encore", "éternellement", "immédiatement", "compris", "comprenant", "inclus", "naturellement", "particulièrement", "notablement", "actuellement", "maintenant", "ordinairement", "généralement", "habituellement", "d'habitude", "vraiment", "finalement", "uniquement", "peut-être", "initialement", "déjà", "c.-à-d", "souvent", "fréquemment", "régulièrement", "simplement", "éventuellement", "quelquefois", "parfois", "probable", "plausible", "jamais", "toujours", "incidemment", "accidentellement", "récemment", "dernièrement", "relativement", "clairement", "évidemment", "apparemment", "pourvu"];

const intensifiers$b = ["assez", "trop", "tellement", "presque", "très", "absolument", "extrêmement", "quasi", "quasiment", "fort"];

// These verbs convey little meaning.
const delexicalizedVerbs$6 = ["fais", "fait", "faisons", "faites", "font", "fais-je", "fait-il", "fait-elle", "fait-on", "faisons-nous", "faites-vous", "font-ils", "font-elles", "fis", "fit", "fîmes", "fîtes", "firent", "faisais", "faisait", "faisions", "faisiez", "faisaient", "ferai", "feras", "fera", "ferons", "ferez", "feront", "veux", "veut", "voulons", "voulez", "veulent", "voulus", "voulut", "voulûmes", "voulûtes", "voulurent", "voulais", "voulait", "voulions", "vouliez", "voulaient", "voudrai", "voudras", "voudra", "voudrons", "voudrez", "voudront", "voulu", "veux-je", "veux-tu", "veut-il", "veut-elle", "veut-on", "voulons-nous", "voulez-vous", "veulent-ils", "veulent-elles", "voudrais", "voudrait", "voudrions", "voudriez", "voudraient", "voulant"];

const delexicalizedVerbsInfinitive$2 = ["faire", "vouloir"];

/* These adjectives and adverbs are so general, they should never be suggested as a (single) keyword.
 Keyword combinations containing these adjectives/adverbs are fine.
 'Dernier' is also included in generalAdjectivesAdverbsPreceding because it can be used both before and after a noun,
 and it should be filtered out either way.
 */
const generalAdjectivesAdverbs$8 = ["antérieur", "antérieures", "antérieurs", "antérieure", "précédent", "précédents", "précédente", "précédentes", "facile", "faciles", "simple", "simples", "vite", "vites", "vitesse", "vitesses", "difficile", "difficiles", "propre", "propres", "long", "longe", "longs", "longes", "longue", "longues", "bas", "basse", "basses", "ordinaire", "ordinaires", "bref", "brefs", "brève", "brèves", "sûr", "sûrs", "sûre", "sûres", "sure", "sures", "surs", "habituel", "habituels", "habituelle", "habituelles", "soi-disant", "surtout", "récent", "récents", "récente", "récentes", "total", "totaux", "totale", "totales", "complet", "complets", "complète", "complètes", "possible", "possibles", "communément", "constamment", "facilement", "continuellement", "directement", "légèrement", "dernier", "derniers", "dernière", "dernières", "différent", "différents", "différente", "différentes", "similaire", "similaires", "pareil", "pareils", "pareille", "pareilles", "largement", "mal", "super", "bien", "pire", "pires", "suivants", "suivante", "suivantes", "prochain", "prochaine", "prochains", "prochaines", "proche", "proches", "fur"];

/*
 'Dernier' is also included in generalAdjectivesAdverbs because it can be used both before and after a noun,
 and it should be filtered out either way.
 */
const generalAdjectivesAdverbsPreceding = ["nouveau", "nouvel", "nouvelle", "nouveaux", "nouvelles", "vieux", "vieil", "vieille", "vieilles", "beau", "bel", "belle", "belles", "bon", "bons", "bonne", "bonnes", "grand", "grande", "grands", "grandes", "haut", "hauts", "haute", "hautes", "petit", "petite", "petits", "petites", "meilleur", "meilleurs", "meilleure", "meilleures", "joli", "jolis", "jolie", "jolies", "gros", "grosse", "grosses", "mauvais", "mauvaise", "mauvaises", "dernier", "derniers", "dernière", "dernières"];

const interjections$b = ["ah", "ha", "oh", "ho", "bis", "plouf", "vlan", "ciel", "pouf", "paf", "crac", "hurrah", "allo", "stop", "bravo", "ô", "eh", "hé", "aïe", "oef", "ahi", "fi", "zest", "hem", "holà", "chut"];

// These words and abbreviations are frequently used in recipes in lists of ingredients.
const recipeWords$a = ["mg", "g", "kg", "ml", "dl", "cl", "l", "grammes", "gram", "once", "onces", "oz", "lbs", "càc", "cc", "càd", "càs", "càt", "cd", "cs", "ct"];

const timeWords$b = ["minute", "minutes", "heure", "heures", "journée", "journées", "semaine", "semaines", "mois", "année", "années", "aujourd'hui", "demain", "hier", "après-demain", "avant-hier"];

const vagueNouns$b = ["chose", "choses", "façon", "façons", "pièce", "pièces", "truc", "trucs", "fois", "cas", "aspect", "aspects", "objet", "objets", "idée", "idées", "thème", "thèmes", "sujet", "sujets", "personnes", "manière", "manières", "sorte", "sortes"];

const miscellaneous$a = ["ne", "oui", "d'accord", "amen", "euro", "euros", "etc"];

const titlesPreceding$3 = ["mme", "mmes", "mlle", "mlles", "mm", "dr", "pr"];

const titlesFollowing$1 = ["jr", "sr"];

var functionWords$a = {};

var transitionWords$g = {};

Object.defineProperty(transitionWords$g, "__esModule", {
	value: true
});

transitionWords$g.default = function () {
	return {
		singleWords: singleWords$9,
		multipleWords: multipleWords$9,
		allWords: singleWords$9.concat(multipleWords$9)
	};
};

const singleWords$9 = ["ademais", "afinal", "aliás", "analogamente", "anteriormente", "assim", "certamente", "conforme", "conquanto", "contudo", "decerto", "embora", "enfim", "enquanto", "então", "entretanto", "eventualmente", "igualmente", "inegavelmente", "inesperadamente", "mas", "outrossim", "pois", "porquanto", "porque", "portanto", "posteriormente", "precipuamente", "primeiramente", "primordialmente", "principalmente", "salvo", "semelhantemente", "similarmente", "sobretudo", "surpreendentemente", "todavia"];

const multipleWords$9 = ["a fim de", "a fim de que", "a menos que", "a princípio", "a saber", "acima de tudo", "ainda assim", "ainda mais", "ainda que", "além disso", "antes de mais nada", "antes de tudo", "antes que", "ao mesmo tempo", "ao passo que", "ao propósito", "apesar de", "às vezes", "assim como", "assim que", "assim sendo", "assim também", "bem como", "com a finalidade de", "com efeito", "com o fim de", "com o intuito de", "com o propósito de", "com toda a certeza", "como resultado", "como se", "da mesma forma", "de acordo com", "de conformidade com", "de fato", "de maneira idêntica", "de tal forma que", "de tal sorte que", "depois que", "desde que", "dessa forma", "dessa maneira", "desse modo", "do mesmo modo", "é provável", "em conclusão", "em contrapartida", "em contraste com", "em outras palavras", "em primeiro lugar", "em princípio", "em resumo", "em seguida", "em segundo lugar", "em síntese", "em suma", "em terceiro lugar", "em virtude de", "finalmente agora atualmente", "isto é", "já que", "logo após", "logo depois", "logo que", "mesmo que", "não apenas", "nesse hiato", "nesse ínterim", "nesse meio tempo", "nesse sentido", "no entanto", "no momento em que", "ou por outra", "ou seja", "para que", "pelo contrário", "por analogia", "por causa de", "por certo", "por conseguinte", "por conseqüência", "por exemplo", "por fim", "por isso", "por mais que", "por menos que", "por outro lado", "posto que", "se acaso", "se bem que", "seja como for", "sem dúvida", "só para exemplificar", "só para ilustrar", "só que", "sob o mesmo ponto de vista", "talvez provavelmente", "tanto quanto", "uma vez que", "visto que"];

Object.defineProperty(functionWords$a, "__esModule", {
	value: true
});

functionWords$a.default = function () {
	return {
		// These word categories are filtered at the beginning of word combinations.
		filteredAtBeginning: generalAdjectivesAdverbs$7,

		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(ordinalNumerals$a, otherAuxiliariesInfinitive$1, copulaInfinitive$1, delexicalizedVerbsInfinitive$1, generalAdjectivesPreceding),

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(articles$6, prepositions$9, coordinatingConjunctions$5, demonstrativePronouns$6, intensifiers$a, quantifiers$a, possessivePronouns$4),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(transitionWords$f, cardinalNumerals$a, personalPronounsNominative$4, personalPronounsAccusative$2, personalPronounsPrepositional$1, personalPronounsComitative, reflexivePronouns$9, indefinitePronouns$a, interrogativePronouns$5, interrogativeProAdverbs$4, locativeAdverbs$3, otherAuxiliaries$3, copula$4, subordinatingConjunctions$5, interviewVerbs$a, additionalTransitionWords$3, delexicalizedVerbs$5, interjections$a, recipeWords$9, timeWords$a, vagueNouns$a, miscellaneous$9, titles$2),

		// These word categories cannot directly precede a passive participle.
		cannotDirectlyPrecedePassiveParticiple: [].concat(articles$6, prepositions$9, personalPronounsAccusative$2, possessivePronouns$4, indefinitePronouns$a, interrogativeProAdverbs$4, cardinalNumerals$a, ordinalNumerals$a, delexicalizedVerbs$5, delexicalizedVerbsInfinitive$1, interviewVerbs$a),

		// This export contains all of the above words.
		all: [].concat(articles$6, cardinalNumerals$a, ordinalNumerals$a, personalPronounsNominative$4, personalPronounsAccusative$2, personalPronounsPrepositional$1, personalPronounsComitative, reflexivePronouns$9, demonstrativePronouns$6, possessivePronouns$4, quantifiers$a, indefinitePronouns$a, interrogativePronouns$5, interrogativeProAdverbs$4, locativeAdverbs$3, otherAuxiliaries$3, otherAuxiliariesInfinitive$1, copula$4, copulaInfinitive$1, prepositions$9, coordinatingConjunctions$5, subordinatingConjunctions$5, interviewVerbs$a, additionalTransitionWords$3, intensifiers$a, delexicalizedVerbs$5, delexicalizedVerbsInfinitive$1, generalAdjectivesAdverbs$7, generalAdjectivesPreceding, interjections$a, recipeWords$9, timeWords$a, vagueNouns$a, miscellaneous$9, titles$2)
	};
};

var _transitionWords$5 = transitionWords$g;

var _transitionWords2$5 = _interopRequireDefault$2R(_transitionWords$5);

function _interopRequireDefault$2R(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const transitionWords$f = (0, _transitionWords2$5.default)().singleWords;

/**
 * Returns an array with exceptions for the prominent words researcher.
 *
 * @returns {Array} The array filled with exceptions.
 */

const articles$6 = ["o", "a", "os", "as", "um", "uns", "uma", "umas"];

// "um" is already included in the articles.
const cardinalNumerals$a = ["uma", "duas", "dois", "três", "cuatro", "cinco", "seis", "sete", "oito", "nove", "dez", "onze", "doze", "treze", "quatorze", "catorze", "quinze", "dezesseis", "dezessete", "dezasseis", "dezassete", "dezoito", "dezenove", "dezanove", "vinte", "cem", "cento", "mil", "milhão", "milhões", "bilhão", "bilhões"];

const ordinalNumerals$a = ["primeiro", "primeiros", "primeira", "primeiras", "segundo", "segunda", "segundos", "segundas", "terceiro", "terceira", "terceiros", "terceiras", "quarto", "quartos", "quarta", "quartas", "quinto", "quintos", "quinta", "quintas", "sexto", "sextos", "sexta", "sextas", "sétimo", "sétimos", "sétima", "sétimas", "oitavo", "oitavos", "oitava", "oitavas", "nono", "nonos", "nona", "nonas", "décimo", "décimos", "décima", "décimas", "vigésimo", "vigésimos", "vigésima", "vigésimas"];

const personalPronounsNominative$4 = ["eu", "tu", "ele", "ela", "nós", "vós", "você", "vocês", "eles", "elas"];

// "o", "a", "os", "as" are already included in the articles.
const personalPronounsAccusative$2 = ["me", "te", "lhe", "nos", "vos", "lhes"];

const personalPronounsPrepositional$1 = ["dele", "dela", "deles", "delas", "nele", "nela", "neles", "nelas", "mim", "ti", "si"];

const personalPronounsComitative = ["conmigo", "contigo", "consigo", "convosco", "conosco", "connosco"];

const reflexivePronouns$9 = ["se"];

const demonstrativePronouns$6 = ["aquilo", "àquele", "àquela", "àqueles", "àquelas", "àquilo", "este", "estes", "esta", "estas", "àqueles", "aqueles", "aquele", "aquela", "aquelas", "aquilo", "esse", "esses", "essa", "essas", "isto", "isso"];

const possessivePronouns$4 = ["minhas", "tuas", "suas", "minha", "tua", "sua", "minhas", "tuas", "suas", "vossa", "vossas", "meu", "meus", "teu", "teus", "seu", "seus", "nosso", "nossos", "nossa", "nossas"];

const quantifiers$a = ["apenas", "vário", "vários", "vária", "várias", "mais", "muito", "muitos", "muita", "muitas", "puoco", "puocos", "puoca", "puocas", "bastante", "todo", "todos", "toda", "todas"];

const indefinitePronouns$a = ["alguma", "algumas", "nenhuns", "nenhumas", "todo", "toda", "todas", "outro", "outra", "outros", "outras", "qualquer", "quaisquer", "outrem", "tudo", "nada", "algo", "tanto", "tanta", "tantos", "tantas", "quanto", "quanta", "quantos", "quantas", "ninguém", "cada"];

const interrogativePronouns$5 = ["quais", "qual", "quem", "cujo", "cuja", "cujos", "cujas"];

const interrogativeProAdverbs$4 = ["como", "porque", "quanto", "quanta", "onde", "quando", "quão", "quantos", "quantas", "donde", "aonde", "que"];

const locativeAdverbs$3 = ["cá", "além", "aqui", "ali", "lá", "acolá", "aí"];

const otherAuxiliaries$3 = ["tenho", "tens", "tem", "temos", "tendes", "têm", "tive", "tiveste", "teve", "tivemos", "tivestes", "tiveram", "tínhamos", "tínheis", "tinham", "tivera", "tiveras", "tivéramos", "tivéreis", "tiveram", "terei", "terás", "terá", "teremos", "tereis", "terão", "teria", "terias", "teríamos", "teríeis", "teriam", "tenha", "tenhas", "tenhamos", "tenhais", "tenham", "tivesse", "tivesses", "tivéssemos", "tivésseis", "tivessem", "tiver", "tiveres", "tivermos", "tiverdes", "tiverem", "tende", "teres", "termos", "terdes", "terem", "tido", "hei", "hás", "há", "havemos", "hemos", "haveis", "heis", "hão", "houve", "houveste", "houvemos", "houvestes", "houveram", "havia", "havias", "havíamos", "havíeis", "haviam", "houvera", "houveras", "houvéramos", "houvéreis", "houveram", "haverei", "haverás", "haverá", "haveremos", "havereis", "haverão", "haveria", "haverias", "haveríamos", "haveríeis", "haveriam", "haja", "hajas", "hajamos", "hajais", "hajam", "houvesse", "houvesses", "houvéssemos", "houvésseis", "houvessem", "houver", "houveres", "houvermos", "houverdes", "houverem", "havei", "hajais", "haveres", "havermos", "haverdes", "haverem", "havido", "poder", "posso", "podes", "pode", "podemos", "podeis", "podem", "pude", "pudeste", "pôde", "pudemos", "pudestes", "puderam", "podia", "podias", "podia", "podíamos", "podíeis", "podiam", "pudera", "puderas", "pudéramos", "pudéreis", "puderam", "poderei", "poderás", "poderá", "poderemos", "podereis", "poderão", "poderia", "poderias", "poderíamos", "poderíeis", "poderiam", "possa", "possas", "possamos", "possais", "possam", "pudesse", "pudesses", "pudéssemos", "pudésseis", "pudessem", "puder", "puderes", "pudermos", "puderdes", "puderem"];

const otherAuxiliariesInfinitive$1 = ["ter", "haver"];

const copula$4 = ["sou", "és", "é", "somos", "sois", "são", "fui", "foste", "foi", "fomos", "fostes", "foram", "era", "eras", "éramos", "éreis", "eram", "fôramos", "fôreis", "fora", "foras", "foram", "serei", "serás", "será", "seremos", "sereis", "serão", "seria", "serias", "seríamos", "seríeis", "seriam", "seja", "sejas", "seja", "sejamos", "sejais", "sejam", "fosse", "fosses", "fôssemos", "fôsseis", "fossem", "for", "fores", "formos", "fordes", "forem", "sê", "sede", "sermos", "serdes", "serem", "seres", "sido", "estou", "está", "estamos", "estás", "estás", "estais", "estão", "estive", "estiveste", "esteve", "estivemos", "estivestes", "estiveram", "estava", "estavas", "estávamos", "estáveis", "estavam", "estivera", "estiveras", "estivéramos", "estivéreis", "estiveram", "estarei", "estarás", "estará", "estaremos", "estareis", "estarão", "estaria", "estarias", "estaríamos", "estaríeis", "estariam", "esteja", "estejas", "estejamos", "estejais", "estejam", "estivesse", "estivesses", "estivéssemos", "estivésseis", "estivessem", "estiver", "estiveres", "estivermos", "estiverdes", "estiverem", "estai", "estejas", "estejais", "estares", "estarmos", "estardes", "estarem", "estado"];

const copulaInfinitive$1 = ["estar", "ser"];

const prepositions$9 = ["a", "ante", "antes", "após", "até", "através", "com", "contra", "depois", "desde", "sem", "entre", "para", "pra", "perante", "sob", "sobre", "trás", "de", "por", "em", "ao", "à", "aos", "às", "do", "da", "dos", "das", "dum", "duma", "duns", "dumas", "no", "na", "nos", "nas", "num", "numa", "nuns", "numas", "pelo", "pela", "pelos", "pelas", "deste", "desse", "daquele", "desta", "dessa", "daquela", "destes", "desses", "daqueles", "destas", "dessas", "daquelas", "neste", "nesse", "naquele", "nesta", "nessa", "naquela", "nestes", "nesses", "naqueles", "nestas", "nessas", "naquelas", "disto", "disso", "daquilo", "nisto", "nisso", "naquilo", "durante"];

const coordinatingConjunctions$5 = ["também", "e", "ou", "nem"];

const subordinatingConjunctions$5 = ["agora", "conforme", "conquanto", "contanto", "embora", "enquanto", "então", "entretanto", "malgrado", "mas", "pois", "porém", "porquanto", "porque", "senão", "contudo"];

// These verbs are frequently used in interviews to indicate questions and answers.
const interviewVerbs$a = ["diz", "dizem", "disse", "disseram", "dizia", "diziam", "reivindica", "reivindicam", "reivindicou", "reivindicaram", "reivindicava", "reivindicavam", "requer", "requerem", "requereu", "requereram", "requeria", "requeriam", "afirma", "afirmam", "afirmou", "afirmaram", "afirmava", "afirmavam", "reivindica", "reivindicam", "reivindicou", "reivindicaram", "reivindicava", "reivindicavam", "perguntam", "perguntou", "perguntaram", "perguntava", "perguntavam", "explica", "explicam", "explicou", "explicaram", "explicava", "explicavam", "relata", "relatam", "relatou", "relataram"];

// These transition words were not included in the list for the transition word assessment for various reasons.
const additionalTransitionWords$3 = ["provavelmente", "imediatamente", "ocasionalmente", "indubitavelmente", "para", "possivelmente", "logo", "simultaneamente", "exceto", "inquestionavelmente"];

const intensifiers$a = ["extremamente", "bem", "completamente", "totalmente", "grandemente", "seriamente", "absolutamente", "bastante", "sobremodo", "sobremaneira", "tão"];

// These verbs convey little meaning.
const delexicalizedVerbs$5 = ["dou", "dás", "dá", "damos", "dais", "dão", "dei", "deu", "demos", "deram", "dava", "davas", "dávamos", "dáveis", "davam", "dera", "deras", "déramos", "déreis", "deram", "darei", "darás", "dará", "daremos", "dareis", "darão", "daria", "darias", "daríamos", "daríeis", "dariam", "dê", "dês", "dêmos", "deis", "deem", "déssemos", "désseis", "dessem", "der", "deres", "dermos", "derdes", "derem", "dai", "deis", "dares", "darmos", "dardes", "darem", "fazendo", "faço", "fazes", "faz", "fazemos", "fazeis", "fazem", "fiz", "fizeste", "fez", "fizemos", "fizestes", "fizeram", "fazia", "fazias", "fazíamos", "fazíeis", "faziam", "fizera", "fizeras", "fizéramos", "fizéreis", "farei", "farás", "fará", "faremos", "fareis", "faria", "farias", "faríamos", "faríeis", "fariam", "faça", "faças", "façamos", "façais", "façam", "fizesse", "fizesses", "fizéssemos", "fizésseis", "fizessem", "fizer", "fizeres", "fizermos", "fizerdes", "fizerem", "fazei", "fazeres", "fazermos", "fazerdes", "fazerem"];

const delexicalizedVerbsInfinitive$1 = ["dar", "fazer"];

/*
 * These adjectives and adverbs are so general, they should never be suggested as a (single) keyword.
 * Keyword combinations containing these adjectives/adverbs are fine.
 */
const generalAdjectivesAdverbs$7 = ["devagar", "rapidamente", "grande", "grandes", "depressa", "claramente", "effectivamente", "realmente", "exclusivamente", "simplesemente", "somente", "unicamente", "lentamente", "raramente", "certamente", "talvez", "actualmente", "dificilmente", "principalmente", "gerlamente", "enorme", "enormes", "pequeno", "pequena", "pequenos", "pequenas", "minúsculo", "minúsculos", "minúscula", "minúsculas", "velho", "velhos", "velha", "velhas", "lindo", "linda", "lindos", "lindas", "alto", "alta", "altos", "altas", "baixo", "baixa", "baixos", "baixas", "longo", "longa", "longos", "longas", "curto", "curta", "curtos", "curtas", "fácil", "fáceis", "difícil", "difíceis", "simples", "mesmo", "mesma", "mesmos", "mesmas", "mêsmo", "mêsmos", "mêsma", "mêsmas", "cedo", "tarde", "importante", "importantes", "capaz", "capazes", "certo", "certa", "certos", "certas", "usual", "usuals", "ultimamente", "possível", "possíveis", "comum", "comuns", "freqüentemente", "constantemente", "continuamente", "diretamente", "levemente", "algures", "semelhante", "semelhantes", "similar", "similares", "sempre", "ainda", "já", "atrás", "depois"];

// "grande", "velho" and "pequeno" can appear both before and after nouns and are therefore on both lists.
const generalAdjectivesPreceding = ["pior", "melhor", "melhores", "bom", "boa", "bons", "boas", "bonito", "bonita", "bonitos", "bonitas", "grande", "grandes", "pequeno", "pequena", "pequenos", "pequenas", "velho", "velhos", "velha", "velhas", "mau", "má", "maus", "más"];

const interjections$a = ["ai", "ah", "ih", "alô", "oi", "olá", "ui", "uf", "psiu", "mau", "olha", "viva", "uau", "wow", "oh", "shi"];

// These words and abbreviations are frequently used in recipes in lists of ingredients.
const recipeWords$9 = ["kg", "mg", "gr", "g", "km", "m", "l", "ml", "cl"];

// "segundo" is already included in cardinal numbers.
const timeWords$a = ["segundos", "minuto", "minutos", "hora", "horas", "dia", "dias", "semana", "semanas", "mes", "meses", "ano", "anos", "hoje", "amanhã", "ontem"];

const vagueNouns$a = ["caso", "casos", "coisa", "coisas", "detalhe", "detalhes", "forma", "formas", "jeito", "jeitos", "maneira", "maneiras", "modo", "modos", "suijeto", "sujeitos", "tópico", "tópicos", "vez", "vezes"];

const miscellaneous$9 = ["sim", "não", "ok", "amém", "etc", "euro", "euros", "adeus", "jeitos"];

const titles$2 = ["sr", "sra", "sras", "dr", "dra", "prof"];

var functionWords$9 = {};

var transitionWords$e = {};

Object.defineProperty(transitionWords$e, "__esModule", {
	value: true
});

transitionWords$e.default = function () {
	return {
		singleWords: singleWords$8,
		multipleWords: multipleWords$8,
		allWords: singleWords$8.concat(multipleWords$8)
	};
};

/** @module config/transitionWords */

const singleWords$8 = ["безусловно", "бесспорно", "вероятно", "вестимо", "вдобавок", "видимо", "вишь", "во-вторых", "во-первых", "вообще-то", "впрочем", "дабы", "едва", "ежели", "если", "затем ", "зачем", "ибо", "итак", "кабы", "кажется", "кажись", "коли", "кстати", "лишь", "лучше", "наверно", "наверное", "например", "небось", "нежели", "несомненно", "но", "однако", "особенно", "оттого", "отчего", "поди", "пожалуй", "позволь", "позвольте", "покамест", "покуда", "поскольку", "потому", "притом", "причем", "только", "хотя", "чтоб", "чтобы", "чуть", "якобы"];

const multipleWords$8 = ["а вдобавок", "а вот", "а именно", "а не то", "а не", "а потом", "а также", "без всякого сомнения", "без того чтобы не", "без того, чтобы не", "благодаря тому", "более того", "будто бы", "будь то", "буквально", "в итоге", "в конце концов", "в общей сложности", "в общем-то", "в общем", "в отношении того что", "в отношении того, что", "в принципе", "в противовес тому что", "в противовес тому, что", "в противоположность тому", "в результате", "в самом деле", "в свою очередь", "в связи с тем что", "в связи с тем", "в силу того что", "в силу того", "в силу чего", "в случа", "в сравнении с тем", "в сущности говоря", "в сущности", "в таком случае", "в то время как", "в то время, как", "в том случае", "в частности", "в-третьих", "ввиду того", "вернее говоря", "вероятнее всего", "видите ли", "видишь ли", "вместе с тем", "вместо того", "вне всякого сомнения", "вне сомнения", "во всяком случае", "воля ваша", "воля твоя", "вообще говоря", "вопреки тому", "вплоть до того", "вроде того как", "вроде того что", "вроде того", "вроде того", "вследствие того что", "вследствие чего", "грубо говоря", "да еще", "да и то", "дай бог память", "даром что", "для того чтобы", "для того, чтобы", "до тех пор пока", "до тех пор, пока", "до того как", "до того, как", "едва лишь", "едва только", "ежели бы", "если угодно", "жалко, что", "жаль, что", "за счет того что", "за счет того, что", "знамо дело", "и вот еще", "из-за того что", "из-за того, что", "иначе говоря", "исходя из того", "к вашему сведению", "к несчастью", "к огорчению", "к примеру сказать", "к примеру", "к прискорбию", "к радости", "к слову сказать", "к сожалению", "к стыду своему", "к стыду", "к счастью", "к твоему сведению", "к тому же", "к удивлению", "к ужасу", "к чести", "как будто", "как бы там ни было", "как бы то ни было", "как бы", "как вам известно", "как вдруг", "как видите", "как видишь", "как видно", "как водится", "как выяснилось", "как выясняется", "как говорилось", "как говорится", "как если бы", "как знать", "как известно", "как на заказ", "как назло", "как нарочно", "как ни говори", "как ни говорите", "как ни странно", "как оказалось", "как оказывается", "как полагается", "как положено", "как правило", "как принято говорить", "как принято", "как сказано", "как скоро", "как следствие", "как словно", "как только", "как хотите", "как это ни странно", "ко всему прочему", "коль скоро", "коль уж", "коротко говоря", "короче говоря", "кроме всего прочего", "кстати говоря", "кстати сказать", "лишь бы", "лишь только", "мало сказать", "мало того", "между нами говоря", "между прочим", "между тем как", "может статься", "можно подумать", "мягко выражаясь", "мягко говоря", "на беду", "на ваш взгляд", "на мой взгляд", "на несчастье", "на основании того что", "на основании того, что", "на первый взгляд", "на самом деле", "на случай", "на твой взгляд", "на худой конец", "надо полагать", "наряду с тем что", "наряду с тем", "насчет того что", "насчет того, что", "не в пример тому как", "не в пример тому, как", "не то чтобы", "невзирая на то", "независимо от того", "несмотря на то", "ничего не скажешь", "но вообще-то", "кроме того", "однако же", "откровенно сказать", "относительно того что", "относительно того, что", "перед тем", "по вашему мнению", "по видимости", "по всей вероятности", "по всей видимости", "по данным", "по замыслу", "по идее", "по крайней мере", "по мере того как", "по мере того, как", "по мнению", "по моему мнению", "по обыкновению", "по обычаю", "по определению", "по поводу того", "по правде говоря", "по правде сказать", "по правде", "по преданию", "по причине того", "по прогнозам", "по сведениям", "по своему обыкновению", "по слухам", "по совести говоря", "по совести сказать", "по совести", "по сообщению", "по сообщениям", "по справедливости говоря", "по справедливости", "по сравнению", "по статистике", "по сути говоря", "по сути дела", "по сути", "по существу говоря", "по существу", "по счастью", "по твоему мнению", "по чести говоря", "по чести признаться", "по чести сказать", "по-вашему", "по-видимому", "по-ихнему", "по-моему", "по-нашему", "по-твоему", "под видом того что", "под видом того, что", "под предлогом", "подобно тому", "подумать только", "помимо всего прочего", "помимо всего", "помимо того", "помимо того", "помимо этого", "понятное дело", "попросту говоря", "попросту сказать", "после того", "потому как", "потому что", "правду говоря", "правду сказать", "правильнее говоря", "прежде всего", "прежде нежели", "прежде чем", "при всем том", "при условии что", "при условии, что", "против обыкновения", "проще говоря", "проще сказать", "прямо-таки как", "пускай бы", "равно как", "ради того чтобы", "разве что", "разумеется", "с вашего позволения", "с вашего разрешения", "с другой стороны", "с моей точки зрения", "с одной стороны", "с позволения сказать", "с твоего позволения", "с твоего разрешения", "с тем чтобы", "с тех пор как", "с той целью чтобы", "с точки зрения", "само собой разумеется", "сверх того что", "сверх того", "сказать по правде", "сказать по совести", "сказать по чести", "скорее всего", "смотря по тому", "со своей стороны", "собственно говоря", "совсем как", "стало быть", "стоит отметить", "строго говоря", "судя по всему", "судя по тому", "так или иначе", "так как", "так что", "так чтобы", "тем более что", "тем не менее", "тем паче что", "то бишь", "то есть", "тогда как", "только бы", "только лишь", "только чуть", "точнее говоря", "точнее сказать", "точно так же", "что и говорить", "что ни говори", "что ни говорите", "чуть лишь", "чуть только", "шутка ли сказать", "шутка ли", "шутка сказать", "это значит, что"];

Object.defineProperty(functionWords$9, "__esModule", {
	value: true
});

functionWords$9.default = function () {
	return {
		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(ordinalNumerals$9, generalAdjectivesAdverbs$6),

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(prepositions$8, coordinatingConjunctions$4, demonstrativePronouns$5, intensifiers$9, quantifiers$9, possessivePronouns$3),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(transitionWords$d, adverbialGenitives$3, personalPronouns$1, reflexivePronouns$8, interjections$9, cardinalNumerals$9, filteredPassiveAuxiliaries, otherAuxiliaries$2, copula$3, interviewVerbs$9, delexicalizedVerbs$4, indefinitePronouns$9, subordinatingConjunctions$4, interrogativeDeterminers$3, interrogativePronouns$4, interrogativeProAdverbs$3, locativeAdverbs$2, miscellaneous$8, recipeWords$8, timeWords$9, vagueNouns$9),

		// This export contains all of the above words.
		all: [].concat(cardinalNumerals$9, ordinalNumerals$9, demonstrativePronouns$5, possessivePronouns$3, reflexivePronouns$8, personalPronouns$1, quantifiers$9, indefinitePronouns$9, indefinitePronounsPossessive, interrogativeDeterminers$3, interrogativePronouns$4, interrogativeProAdverbs$3, locativeAdverbs$2, adverbialGenitives$3, filteredPassiveAuxiliaries, otherAuxiliaries$2, copula$3, prepositions$8, coordinatingConjunctions$4, subordinatingConjunctions$4, interviewVerbs$9, transitionWords$d, intensifiers$9, delexicalizedVerbs$4, interjections$9, generalAdjectivesAdverbs$6, recipeWords$8, vagueNouns$9, miscellaneous$8, titlesPreceding$2, titlesFollowing)
	};
};

var _transitionWords$4 = transitionWords$e;

var _transitionWords2$4 = _interopRequireDefault$2Q(_transitionWords$4);

function _interopRequireDefault$2Q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const transitionWords$d = (0, _transitionWords2$4.default)().allWords;

/**
 * Returns an object with exceptions for the prominent words researcher
 * @returns {Object} The object filled with exception arrays.
 */

// Verbs
const filteredPassiveAuxiliaries = ["быть", "был", "была", "было", "были", "будет", "будут"];
const otherAuxiliaries$2 = ["мочь", "мог", "могла", "могли", "могу", "можешь", "может", "можем", "можете", "могут", "смочь", "смогу", "сможешь", "сможет", "сможем", "сможете", "смогут", "решиться", "решился", "решилась", "решились", "решусь", "решишься", "решится", "решимся", "решитесь", "решатся", "делать", "делал", "делала", "делало", "делали", "делали", "делаю", "делаешь", "делает", "делаем", "делаете", "делают", "сделать", "сделал", "сделала", "сделало", "сделали", "сделали", "сделаю", "сделаешь", "сделает", "сделаем", "сделаете", "сделают", "иметь", "имел", "имела", "имело", "имели", "имею", "имеешь", "имеет", "имеем", "имеете", "имеют", "следует", "следовало", "необходимо", "необходим", "необходима", "необходимы", "нужно", "нужен", "нужна", "обязан", "обязана", "обязано", "обязаны", "должен", "должна", "должно", "должны", "требуется", "требуются", "имеется", "имеются", "есть", "можно"];
const copula$3 = ["появиться", "появился", "появилась", "появилось", "появились", "появлюсь", "появишься", "появится", "появимся", "появитесь", "появимся", "появляться", "появлялся", "появлялась", "появлялось", "появлялись", "появляюсь", "появляешься", "появляется", "появляемся", "появляются", "появляетесь", "стал", "стала", "стало", "стану", "станешь", "станет", "станем", "станете", "станут", "становиться", "становился", "становилось", "становилась", "становились", "становлюсь", "становишься", "становится", "становимся", "становитесь", "становятся", "прийти", "пришел", "пришёл", "пришла", "пришло", "пришли", "приду", "придешь", "придёшь", "придет", "придёт", "придем", "придём", "придете", "придёте", "придут", "приходить", "приходил", "приходила", "приходило", "приходили", "прихожу", "приходишь", "приходит", "приходим", "приходите", "происходить", "происходил", "происходила", "происходило", "происходили", "происходит", "происходят", "держать", "держал", "держала", "держало", "держали", "держу", "держишь", "держит", "держим", "держите", "держут", "содержать", "содержал", "содержала", "содержало", "содержали", "содержу", "содержишь", "содержит", "содержим", "содержите", "содержут", "остаться", "остался", "осталась", "осталось", "остались", "останусь", "останешься", "останется", "останутся", "останетесь", "останемся", "оставаться", "оставался", "оставалась", "оставалось", "оставались", "остаюсь", "остаешься", "остаёшься", "остается", "остаётся", "остаемся", "остаёмся", "остаетесь", "остаётесь", "остаются", "изменяться", "изменялся", "изменялась", "изменялось", "изменялись", "изменюсь", "изменишься", "изменится", "изменимся", "изменитесь", "изменятся", "успеть", "успел", "успела", "успело", "успели", "успею", "успеешь", "успеет", "успеем", "успеете", "успеют", "заниматься", "занимался", "занималась", "занимаюсь", "занимаешься", "занимается", "занимаемся", "занимаетесь", "занимаемся", "заняться", "занялся", "занялась", "занялись", "займусь", "займешься", "займется", "займемся", "займетесь", "займутся", "займёшься", "займётся", "займёмся", "займётесь"];

// These verbs are frequently used in interviews to indicate questions and answers.
const interviewVerbs$9 = ["сказать", "сказал", "сказала", "сказали", "говорить", "говорил", "говорила", "говорили", "говорит", "говорю", "говорим", "говоришь", "говорят", "говорите", "объявить", "объявил", "объявила", "объявили", "заявить", "заявил", "заявила", "заявили", "спросить", "спросил", "спросила", "спросили", "указать", "указал", "указала", "указали", "объяснить", "объяснил", "объяснила", "объяснили", "подумать", "подумал", "подумала", "подумали", "думать", "думал", "думала", "думали", "думаю", "думает", "думаешь", "думаем", "думаете", "думают", "рассказывать", "рассказывал", "рассказывала", "рассказывали", "рассказывают", "рассказывает", "рассказать", "рассказал", "рассказала", "рассказали", "обсудить", "обсудил", "обсудила", "обсудили", "предложить", "предложил", "предложила", "предложили", "понимать", "понимал", "понимала", "понимали", "понимаю", "понимаешь", "понимает", "понимаем", "понимаете", "понимают", "добавить", "добавил", "добавила", "добавили", "добавлю", "добавишь", "добавит", "добавим", "добавите", "добавят"];
const delexicalizedVerbs$4 = ["казаться", "кажется", "казалось", "казалась", "казался", "казались", "кажутся", "давайте", "давай", "хотеть", "хочу", "хочешь", "хочет", "хотим", "хотите", "хотят", "хотел", "хотела", "хотело", "хотели", "показать", "показал", "показала", "показало", "показали", "покажу", "покажешь", "покажет", "покажем", "покажете", "покажут", "показывать", "показывал", "показывала", "показывало", "показывали", "показываю", "показываешь", "показывает", "показываем", "показываете", "показывают", "идти", "шел", "шёл", "шла", "шло", "шли", "иду", "идешь", "идёшь", "идет", "идёт", "идем", "идём", "идете", "идёте", "идут", "брать", "брал", "брала", "брало", "брали", "беру", "берешь", "берёшь", "берёт", "берем", "берём", "берёте", "берут", "взять", "взял", "взяла", "взяло", "взяли", "возьму", "возьмешь", "возьмет", "возьмем", "возьмете", "возьмут", "класть", "кладу", "кладешь", "кладет", "кладёшь", "кладёт", "кладем", "кладете", "кладём", "кладёте", "кладут", "положить", "положил", "положила", "положило", "положили", "положу", "положишь", "положит", "положим", "положите", "положат", "использовать", "использовал", "использовала", "использовало", "использовали", "использую", "используешь", "используем", "используете", "используют", "пробовать", "пробовал", "пробовала", "пробовало", "пробовали", "пробую", "пробуешь", "пробует", "пробуем", "пробуете", "пробуют", "попробовать", "попробовал", "попробовала", "попробовало", "попробовали", "попробую", "попробуешь", "попробует", "попробуем", "попробуете", "попробуют", "иметь", "имел", "имела", "имело", "имели", "имею", "имеешь", "имеет", "имеем", "имеете", "имеют", "означать", "означал", "означала", "означало", "означали", "означает", "означают", "добавлять", "добавлял", "добавляла", "добавляло", "добавляли", "добавляю", "добавляешь", "добавляет", "добавляем", "добавляете", "добавляют", "состоять", "состоял", "состояла", "состояло", "состояли", "состою", "состоишь", "состоит", "состоим", "состоите", "состоят", "убеждаться", "убедился", "убедилась", "убедилось", "убедишься", "убедится", "убедимся", "убедитесь", "убедятся", "убеждать", "убедил", "убедила", "убедили", "убедишь", "убедит", "убедим", "убедите", "убедят", "являться", "являлся", "являлась", "являлось", "являлись", "являюсь", "являешься", "является", "являемся", "являетесь", "являются"];

// Numerals
const cardinalNumerals$9 = ["один", "одна", "одно", "одни", "два", "две", "двое", "двух", "двоих", "двум", "двоим", "двумя", "двоими", "три", "трое", "трех", "трёх", "троих", "трем", "трём", "троим", "тремя", "четыре", "пять", "шесть", "семь", "восемь", "девять", "десять", "одиннадцать", "двенадцать", "тринадцать", "четырнадцать", "пятнадцать", "шестнадцать", "семнадцать", "восемнадцать", "девятнадцать", "двадцать", "тридцать", "сорок", "пятьдесят", "шестьдесят", "семьдесят", "восемьдесят", "девяносто", "сто", "сотни", "двести", "триста", "четыреста", "пятьсот", "шестьсот", "семьсот", "восемьсот", "девятьсот", "тысяча", "тысячи", "тысяче", "тысячей", "тысячам", "тысячами", "тысячах", "тыс", "миллион", "миллиона", "миллиону", "миллионом", "миллионе", "миллионы", "миллионов", "миллионам", "миллионами", "миллионах", "миллиард", "миллиарда", "миллиарду", "миллиардом", "миллиарде", "миллиарды", "миллиардов", "миллиардам", "миллиардами", "миллиардах"];

const ordinalNumerals$9 = ["первый", "первого", "первому", "первом", "первым", "первая", "первой", "первое", "первые", "первых", "первыми", "второй", "второго", "второму", "втором", "вторым", "вторая", "второй", "второе", "вторые", "вторых", "вторыми", "третий", "третьего", "третьему", "третьим", "третьем", "третья", "третьей", "третье", "третьи", "третьих", "третьими", "четвертый", "четвертого", "четвертому", "четвертым", "четвертом", "четвертая", "четвертой", "четвертое", "четвертые", "четвертых", "четвертыми", "пятый", "пятого", "пятому", "пятом", "пятым", "пятая", "пятое", "пятые", "пятых", "пятыми", "шестой", "шестого", "шестому", "шестым", "шестая", "шестое", "шестые", "шестых", "шестыми", "седьмой", "седьмого", "седьмому", "седьмым", "седьмая", "седьмое", "седьмые", "седьмых", "седьмыми", "восьмой", "восьмого", "восьмому", "восьмым", "восьмая", "восьмое", "восьмые", "восьмых", "восьмыми", "девятый", "девятого", "девятому", "девятым", "девятая", "девятое", "девятые", "девятых", "девятыми", "десятый", "десятого", "десятому", "десятым", "десятая", "десятое", "десятые", "десятых", "десятыми", "одиннадцатый", "одиннадцатого", "одиннадцатому", "одиннадцатым", "одиннадцатая", "одиннадцатое", "одиннадцатые", "одиннадцатых", "одиннадцатыми", "двенадцатый", "двенадцатого", "двенадцатому", "двенадцатым", "двенадцатая", "двенадцатое", "двенадцатые", "двенадцатых", "двенадцатыми", "тринадцатый", "тринадцатого", "тринадцатому", "тринадцатым", "тринадцатая", "тринадцатое", "тринадцатые", "тринадцатых", "тринадцатыми", "четырнадцатый", "четырнадцатого", "четырнадцатому", "четырнадцатым", "четырнадцатая", "четырнадцатое", "четырнадцатые", "четырнадцатых", "четырнадцатыми", "пятнадцатый", "пятнадцатого", "пятнадцатому", "пятнадцатым", "пятнадцатая", "пятнадцатое", "пятнадцатые", "пятнадцатых", "пятнадцатыми", "шестнадцатый", "шестнадцатого", "шестнадцатому", "шестнадцатым", "шестнадцатая", "шестнадцатое", "шестнадцатые", "шестнадцатых", "шестнадцатыми", "семнадцатый", "семнадцатого", "семнадцатому", "семнадцатым", "семнадцатая", "семнадцатое", "семнадцатые", "семнадцатых", "семнадцатыми", "восемнадцатый", "восемнадцатого", "восемнадцатому", "восемнадцатым", "восемнадцатая", "восемнадцатое", "восемнадцатые", "восемнадцатых", "восемнадцатыми", "девятнадцатый", "девятнадцатого", "девятнадцатому", "девятнадцатым", "девятнадцатая", "девятнадцатое", "девятнадцатые", "девятнадцатых", "девятнадцатыми", "двадцатый", "двадцатого", "двадцатому", "двадцатым", "двадцатая", "двадцатое", "двадцатые", "двадцатых", "двадцатыми", "тридцатый", "тридцатого", "тридцатому", "тридцатым", "тридцатая", "тридцатое", "тридцатые", "тридцатых", "тридцатыми", "сороковой", "сорокового", "сороковому", "сороковым", "сороковая", "сороковое", "сороковые", "сороковых", "сороковыми", "пятидесятый", "пятидесятого", "пятидесятому", "пятидесятым", "пятидесятая", "пятидесятое", "пятидесятые", "пятидесятых", "пятидесятыми", "шестидесятый", "шестидесятого", "шестидесятому", "шестидесятым", "шестидесятая", "шестидесятое", "шестидесятые", "шестидесятых", "шестидесятыми", "семидесятый", "семидесятого", "семидесятому", "семидесятым", "семидесятая", "семидесятое", "семидесятые", "семидесятых", "семидесятыми", "восьмидесятый", "восьмидесятого", "восьмидесятому", "восьмидесятым", "восьмидесятая", "восьмидесятое", "восьмидесятые", "восьмидесятых", "восьмидесятыми", "девяностый", "девяностого", "девяностому", "девяностым", "девяностая", "девяностое", "девяностые", "девяностых", "девяностыми", "сотый", "сотого", "сотому", "сотым", "сотая", "сотое", "сотые", "сотых", "сотыми", "двухсотый", "двухсотого", "двухсотому", "двухсотым", "двухсотая", "двухсотое", "двухсотые", "двухсотых", "двухсотыми", "трехсотый", "трехсотого", "трехсотому", "трехсотым", "трехсотая", "трехсотое", "трехсотые", "трехсотых", "трехсотыми", "трёхсотый", "трёхсотого", "трёхсотому", "трёхсотым", "трёхсотая", "трёхсотое", "трёхсотые", "трёхсотых", "трёхсотыми", "четырехсотый", "четырехсотого", "четырехсотому", "четырехсотым", "четырехсотая", "четырехсотое", "четырехсотые", "четырехсотых", "четырехсотыми", "четырёхсотый", "четырёхсотого", "четырёхсотому", "четырёхсотым", "четырёхсотая", "четырёхсотое", "четырёхсотые", "четырёхсотых", "четырёхсотыми", "пятисотый", "пятисотого", "пятисотому", "пятисотым", "пятисотая", "пятисотое", "пятисотые", "пятисотых", "пятисотыми", "шестисотый", "шестисотого", "шестисотому", "шестисотым", "шестисотая", "шестисотое", "шестисотые", "шестисотых", "шестисотыми", "семисотый", "семисотого", "семисотому", "семисотым", "семисотая", "семисотое", "семисотые", "семисотых", "семисотыми", "восьмисотый", "восьмисотого", "восьмисотому", "восьмисотым", "восьмисотая", "восьмисотое", "восьмисотые", "восьмисотых", "восьмисотыми", "девятисотый", "девятисотого", "девятисотому", "девятисотым", "девятисотая", "девятисотое", "девятисотые", "девятисотых", "девятисотыми", "тысячный", "тысячного", "тысячному", "тысячным", "тысячная", "тысячное", "тысячные", "тысячных", "тысячными", "миллионный", "миллионного", "миллионному", "миллионным", "миллионная", "миллионное", "миллионные", "миллионных", "миллионными", "миллиардный", "миллиардного", "миллиардному", "миллиардным", "миллиардная", "миллиардное", "миллиардные", "миллиардных", "миллиардными"];

// Pronouns (in all cases)
const personalPronouns$1 = ["я", "меня", "мне", "мной", "мною", "ты", "тебя", "тебе", "тобой", "он", "его", "него", "ему", "нему", "нем", "нём", "им", "ним", "она", "ее", "нее", "неё", "её", "ей", "ею", "ней", "нею", "оно", "мы", "нам", "нас", "нами", "вы", "вас", "вам", "вами", "они", "них", "ими", "ними", "их"];
const demonstrativePronouns$5 = ["тот", "тому", "том", "тем", "того", "та", "той", "ту", "то", "те", "тех", "теми", "этот", "этому", "этом", "этим", "этого", "эта", "этой", "эту", "это", "эти", "этих", "этими", "такой", "такого", "такому", "таким", "таком", "такая", "такую", "такое", "такие", "таких", "такими", "этакий", "этакого", "этакому", "этаким", "этаком", "этакая", "этакую", "этакое", "этакие", "этаких", "этакими"];
const possessivePronouns$3 = ["мой", "моего", "моему", "моём", "моим", "моя", "моей", "мое", "моё", "мои", "моих", "моим", "твой", "твоего", "твоему", "твоём", "твоем", "твоим", "твоя", "твоей", "твою", "твое", "твоё", "твои", "твоих", "твоим", "свой", "своего", "своему", "своём", "своем", "своим", "своя", "своей", "свою", "свое", "своё", "свои", "своих", "своим",
// Words "его", "ее", "их" already included in personalPronouns
"наш", "нашего", "нашему", "нашем", "наша", "нашей", "наше", "наши", "нашим", "наших", "ваш", "вашего", "вашему", "вашем", "ваша", "вашей", "ваше", "ваши", "вашим", "ваших"];
const quantifiers$9 = ["некоторый", "некоторого", "некоторому", "некоторым", "некотором", "некоторая", "некоторую", "некоторое", "некоторые", "некоторых", "некоторыми", "многие", "многого", "многому", "многим", "многом", "многая", "многую", "многое", "многие", "многих", "многими", "много", "множество", "каждый", "каждого", "каждому", "каждым", "каждом", "каждая", "каждую", "каждое", "каждые", "каждых", "каждыми", "достаточно", "мало", "более", "больше", "большинство", "большинства", "большинству", "большинстве", "несколько", "нескольких", "менее", "меньше", "наиболее", "наименее",
// For expressions like "что угодно", "кто угодно", "зачем угодно"
"угодно", "же"];
const reflexivePronouns$8 = ["себя", "себе"];
const indefinitePronouns$9 = ["ничто", "ничего", "ничему", "ничем", "ни о чем", "ни о чём", "никто", "никого", "никому", "никем", "ни о ком", "весь", "всего", "всему", "всем", "всём", "все", "всё", "всех", "всеми", "всякий", "всякого", "всякому", "всяким", "всяком", "всякая", "всякой", "всякую", "всякое", "всякие", "всяких", "всякими", "кто-то", "кого-то", "кому-то", "кем-то", "ком-то", "что-то", "чего-то", "чему-то", "чем-то", "чём-то", "кто-либо", "кого-либо", "кому-либо", "кем-либо", "ком-либо", "что-либо", "чего-либо", "чему-либо", "чем-либо", "чём-либо", "кое-кто", "кое-кого", "кое-кому", "кое-кем", "кое-ком", "кое-что", "кое-чего", "кое-чему", "кое-чем", "кое-чём", "любой", "любого", "любому", "любым", "любом", "любая", "любую", "любое", "любые", "любых", "любыми", "какой", "какого", "какому", "каким", "каком", "какая", "какую", "какое", "какие", "каких", "какими", "какой-то", "какого-то", "какому-то", "каким-то", "каком-то", "какая-то", "какую-то", "какое-то", "какие-то", "каких-то", "какими-то"];
const indefinitePronounsPossessive = ["чей-то", "чьего-то", "чьему-то", "чьим-то", "чьем-то", "чьём-то", "чья-то", "чьей-то", "чье-то", "чьё-то", "чьи-то", "чьих-то", "чьими-то", "ничей", "чьего", "чьему", "чьим", "чьем", "чьём", "чья", "чьей", "чье", "чьё", "чьи", "чьих", "чьими", "ничейный", "ничейного", "ничейному", "ничейным", "ничейном", "ничейная", "ничейной", "ничейную", "ничейное", "ничейные", "ничейных", "ничейными"];

// Interrogatives, adverbs, intensifiers, adjectives
const interrogativeDeterminers$3 = ["который", "которого", "которому", "которым", "котором", "которая", "которую", "которое", "которые", "которых", "которыми", "чей", "чьего", "чьему", "чьим", "чьем", "чьём", "чья", "чьей", "чье", "чьё", "чьи", "чьих", "чьими"];
const interrogativePronouns$4 = ["кто", "кого", "кому", "кем", "что", "чего", "чему", "чем", "чём"];
const interrogativeProAdverbs$3 = ["где", "куда", "откуда", "как", "почему", "зачем", "сколько", "ли", "когда"];
const locativeAdverbs$2 = ["везде", "нигде", "там", "здесь", "повсюду"];
const adverbialGenitives$3 = ["никогда", "всегда", "однажды", "единожды", "дважды", "трижды", "четырежды", "уже"];
const intensifiers$9 = ["чрезвычайно", "очень", "крайне", "абсолютно", "полностью", "совершенно", "часто", "чаще", "довольно", "несколько", "значительно", "немного", "немножко", "частично", "просто"];
const generalAdjectivesAdverbs$6 = ["базовый", "базового", "базовому", "базовым", "базовом", "базовая", "базовой", "базовое", "базовые", "базовых", "базовым", "базовыми", "быстрый", "быстрого", "быстрому", "быстрым", "быстром", "быстрая", "быстрой", "быстрое", "быстрые", "быстрых", "быстрым", "быстрыми", "быстрейший", "быстрейшего", "быстрейшему", "быстрейшим", "быстрейшем", "быстрейшая", "быстрейшей", "быстрейшее", "быстрейшие", "быстрейших", "быстрейшим", "быстрейшими", "большой", "большого", "большому", "большим", "большом", "большая", "большое", "большие", "больших", "большим", "большими", "быстрее", "быстро", "важный", "важного", "важному", "важным", "важном", "важная", "важной", "важное", "важные", "важных", "важным", "важными", "важнее", "важно", "возможный", "возможного", "возможному", "возможным", "возможном", "возможная", "возможной", "возможное", "возможные", "возможных", "возможным", "возможными", "высокий", "высокого", "высокому", "высоким", "высоком", "высокая", "высокой", "высокое", "высокие", "высоких", "высоким", "высокими", "выше", "высоко", "главный", "главного", "главному", "главным", "главном", "главная", "главной", "главное", "главные", "главных", "главным", "главными", "далекий", "далекого", "далекому", "далеким", "далеком", "далекая", "далекой", "далекое", "далекие", "далеких", "далеким", "далекими", "далёкий", "далёкого", "далёкому", "далёким", "далёком", "далёкая", "далёкой", "далёкое", "далёкие", "далёких", "далёким", "далёкими", "длиннее", "длинный", "длинного", "длинному", "длинным", "длинном", "длинная", "длинной", "длинное", "длинные", "длинных", "длинным", "длинными", "доступный", "доступного", "доступному", "доступным", "доступном", "доступная", "доступной", "доступное", "доступные", "доступных", "доступным", "доступными", "жуткий", "жуткого", "жуткому", "жутким", "жутком", "жуткая", "жуткой", "жуткое", "жуткие", "жутких", "жутким", "жуткими", "законченный", "законченного", "законченному", "законченным", "законченном", "законченная", "законченной", "законченное", "законченные", "законченных", "законченным", "законченными", "занят", "занята", "заняты", "занятой", "занятого", "занятому", "занятым", "занятом", "занятая", "занятое", "занятые", "занятых", "занятым", "занятыми", "короткий", "короткого", "короткому", "коротким", "коротком", "короткая", "короткой", "короткое", "короткие", "коротких", "коротким", "короткими", "короче", "кошмарный", "кошмарного", "кошмарному", "кошмарным", "кошмарном", "кошмарная", "кошмарной", "кошмарное", "кошмарные", "кошмарных", "кошмарным", "кошмарными", "красивый", "красивого", "красивому", "красивым", "красивом", "красивая", "красивой", "красивое", "красивые", "красивых", "красивым", "красивыми", "лёгкий", "лёгкого", "лёгкому", "лёгким", "лёгком", "лёгкая", "лёгкой", "лёгкое", "лёгкие", "лёгких", "лёгким", "лёгкими", "легкий", "легкого", "легкому", "легким", "легком", "легкая", "легкой", "легкое", "легкие", "легких", "легким", "легкими", "легко", "легче", "лучше", "лучший", "лучшего", "лучшему", "лучшим", "лучшем", "лучшая", "лучшей", "лучшее", "лучшие", "лучших", "лучшим", "лучшими", "маленький", "маленького", "маленькому", "маленьким", "маленьком", "маленькая", "маленькой", "маленькое", "маленькие", "маленьких", "маленьким", "маленькими", "малюсенький", "малюсенького", "малюсенькому", "малюсеньким", "малюсеньком", "малюсенькая", "малюсенькой", "малюсенькое", "малюсенькие", "малюсеньких", "малюсеньким", "малюсенькими", "меньший", "меньшего", "меньшему", "меньшим", "меньшем", "меньшая", "меньшей", "меньшее", "меньшие", "меньших", "меньшим", "меньшими", "многочисленный", "многочисленного", "многочисленному", "многочисленным", "многочисленном", "многочисленная", "многочисленной", "многочисленное", "многочисленные", "многочисленных", "многочисленным", "многочисленными", "молодой", "молодого", "молодому", "молодым", "молодом", "молодая", "молодое", "называемый", "называемого", "называемому", "называемым", "называемом", "называемая", "называемой", "называемое", "называемые", "называемых", "называемым", "называемыми", "больший", "большего", "большему", "большим", "большем", "большая", "большей", "большее", "большие", "больших", "большим", "большими", "наибольший", "наибольшего", "наибольшему", "наибольшим", "наибольшем", "наибольшая", "наибольшей", "наибольшее", "наибольшие", "наибольших", "наибольшим", "наибольшими", "меньший", "меньшего", "меньшему", "меньшим", "меньшем", "меньшая", "меньшей", "меньшее", "меньшие", "меньших", "меньшим", "меньшими", "наименьший", "наименьшего", "наименьшему", "наименьшим", "наименьшем", "наименьшая", "наименьшей", "наименьшее", "наименьшие", "наименьших", "наименьшим", "наименьшими", "наихудший", "наихудшего", "наихудшему", "наихудшим", "наихудшем", "наихудшая", "наихудшей", "наихудшее", "наихудшие", "наихудших", "наихудшим", "наихудшими", "напрямую", "настоящий", "настоящего", "настоящему", "настоящим", "настоящем", "настоящая", "настоящей", "настоящее", "настоящие", "настоящих", "настоящим", "настоящими", "недавний", "недавнего", "недавнему", "недавним", "недавнем", "недавняя", "недавней", "недавнее", "недавние", "недавних", "недавним", "недавними", "необходимый", "необходимого", "необходимому", "необходимым", "необходимом", "необходимая", "необходимой", "необходимое", "необходимые", "необходимых", "необходимым", "необходимыми", "ниже", "низкий", "низкого", "низкому", "низким", "низком", "низкая", "низкой", "низкое", "низкие", "низких", "низким", "низкими", "новейший", "новейшего", "новейшему", "новейшим", "новейшем", "новейшая", "новейшей", "новейшее", "новейшие", "новейших", "новейшим", "новейшими", "новый", "нового", "новому", "новым", "новом", "новая", "новое", "новые", "новых", "новым", "новыми", "нормальный", "нормального", "нормальному", "нормальным", "нормальном", "нормальная", "нормальное", "нормальные", "нормальных", "нормальным", "нормальными", "обыкновенный", "обыкновенного", "обыкновенному", "обыкновенным", "обыкновенном", "обыкновенная", "обыкновенное", "обыкновенные", "обыкновенных", "обыкновенным", "обыкновенными", "обычный", "обычного", "обычному", "обычным", "обычном", "обычная", "обычное", "обычные", "обычных", "обычным", "обычными", "основной", "основного", "основному", "основным", "основном", "основная", "основное", "основные", "основных", "основным", "основными", "особенный", "особенного", "особенному", "особенным", "особенном", "особенная", "особенное", "особенные", "особенных", "особенным", "особенными", "отличный", "отличного", "отличному", "отличным", "отличном", "отличная", "отличное", "отличные", "отличных", "отличным", "отличными", "очевидный", "очевидного", "очевидному", "очевидным", "очевидном", "очевидная", "очевидное", "очевидные", "очевидных", "очевидным", "очевидными", "плохой", "плохого", "плохому", "плохим", "плохом", "плохая", "плохое", "плохие", "плохих", "плохим", "плохими", "последний", "последнего", "последнему", "последним", "последнем", "последняя", "последней", "последнее", "последние", "последних", "последним", "последними", "постоянно", "постоянный", "постоянного", "постоянному", "постоянным", "постоянном", "постоянная", "постоянное", "постоянные", "постоянных", "постоянным", "постоянными", "похожий", "похожего", "похожему", "похожим", "похожем", "похожая", "похожей", "похожее", "похожие", "похожих", "похожим", "похожими", "почти", "предыдущий", "предыдущего", "предыдущему", "предыдущим", "предыдущем", "предыдущая", "предыдущей", "предыдущее", "предыдущие", "предыдущих", "предыдущим", "предыдущими", "простейший", "простейшая", "простейшей", "простой", "простого", "простому", "простым", "простом", "простая", "простое", "простые", "простых", "простым", "простыми", "проще", "ранний", "раннего", "раннему", "ранним", "раннем", "ранняя", "ранней", "раннее", "ранние", "ранних", "ранним", "ранними", "разный", "разного", "разному", "разным", "разном", "разная", "разной", "разное", "разные", "разных", "разным", "разными", "самый", "самого", "самому", "самым", "самом", "самая", "самой", "самое", "самые", "самых", "самым", "самыми", "собственный", "собственного", "собственному", "собственным", "собственном", "собственная", "собственное", "собственные", "собственных", "собственным", "собственными", "специальный", "специального", "специальному", "специальным", "специальном", "специальная", "специальное", "специальные", "специальных", "специальным", "специальными", "специфичный", "специфичного", "специфичному", "специфичным", "специфичном", "специфичная", "специфичное", "специфичные", "специфичных", "специфичным", "специфичными", "средний", "среднего", "среднему", "средним", "среднем", "средняя", "средней", "среднее", "средние", "средних", "средним", "средними", "старейший", "старейшего", "старейшему", "старейшим", "старейшем", "старейшая", "старейшей", "старейшее", "старейшие", "старейших", "старейшим", "старейшими", "старый", "старого", "старому", "старым", "старом", "старая", "старой", "старое", "старые", "старых", "старым", "старыми", "текущий", "текущего", "текущему", "текущим", "текущем", "текущая", "текущей", "текущее", "текущие", "текущих", "текущим", "текущими", "тяжелее", "тяжёлый", "тяжёлого", "тяжёлому", "тяжёлым", "тяжёлом", "тяжёлая", "тяжёлое", "тяжёлые", "тяжёлых", "тяжёлым", "тяжёлыми", "тяжелый", "тяжелого", "тяжелому", "тяжелым", "тяжелом", "тяжелая", "тяжелое", "тяжелые", "тяжелых", "тяжелым", "тяжелыми", "хороший", "хорошего", "хорошему", "хорошим", "хорошем", "хорошая", "хорошей", "хорошее", "хорошие", "хороших", "хорошим", "хорошими", "хорошо", "худший", "худшего", "худшему", "худшим", "худшем", "худшая", "худшей", "худшее", "худшие", "худших", "худшим", "худшими", "хуже", "целый", "целого", "целому", "целым", "целом", "целая", "целой", "целое", "целые", "целых", "целым", "целыми", "именно", "обязательно", "действительно"];

// Prepositions, taken from https://github.com/sshra/database-russian-morphology/blob/master/words-russian-prepositions-morf.sql.gz
const prepositions$8 = ["а-ля", "без", "безо", "без ведома", "благодаря", "близ", "в", "во", "в адрес", "в аспекте", "в виде", "в глазах", "в глубь", "в деле", "в дополнение к", "в духе", "в завершение", "в зависимости от", "в заключение", "в знак", "в интересах", "в качестве", "в лице", "в меру", "в направлении", "в направлении к", "в направлении ко", "в нарушение", "в области", "в обмен на", "в обстановке", "в обход", "в ответ на", "в отдалении от", "в отличие от", "в отношении", "в память", "в плане", "в пользу", "в порядке", "в предвидении", "в предвкушении", "в преддверии", "в присутствии", "в продолжение", "в противность", "в противовес", "в противоположность", "в процессе", "в разрезе", "в районе", "в рамках", "в рассуждении", "в расчете на", "в результате", "в роли", "в ряду", "в свете", "в связи с", "в связи со", "в силу", "в случае", "в смысле", "в согласии с", "в сообществе с", "в соответствии с", "в соответствии со", "в сопоставлении с", "в сопровождении", "в составе", "в сравнении с", "в сравнении со", "в стороне от", "в сторону", "в сфере", "в счет", "в течение", "в угоду", "в унисон с", "в условиях", "в ущерб", "в форме", "в ходе", "в целях", "в честь", "в числе", "в число", "вблизи", "вблизи от", "вверху", "ввиду", "вглубь", "вдалеке от", "вдали", "вдали от", "вдобавок к", "вдобавок ко", "вдогон", "вдогонку", "вдоль", "вдоль по", "взамен", "включая", "вкось", "вкруг", "вместе с", "вместе со", "вместо", "вне", "вне зависимости от", "внизу", "внутри", "внутрь", "вовнутрь", "во время", "во главе", "во главе с", "во главе со", "во избежание", "во изменение", "во имя", "во исполнение", "во славу", "возле", "вокруг", "волею", "вопреки", "вперед", "впереди", "вплоть до", "впредь до", "вразрез", "времен", "вроде", "вслед", "вослед", "вслед за", "вследствие", "выше", "для", "до", "за", "за исключением", "за счет", "заботами", "из", "изо", "из числа", "из-за", "из-под", "из-подо", "изнутри", "именем", "имени", "исключая", "исходя из", "к", "ко", "к числу", "касаемо", "касательно", "кончая", "кроме", "кругом", "между", "меж", "промеж", "промежду", "на", "мимо", "минуя", "на", "на базе", "на благо", "на глазах у", "на грани", "на имя", "на манер", "на основании", "на основе", "на почве", "на правах", "на предмет", "на протяжении", "на пути", "на пути к", "на пути ко", "на путях", "на путях к", "на путях ко", "на радость", "на случай", "на смену", "на стороне", "на сторону", "на уровне", "на фоне", "наверху", "навстречу", "над", "надо", "назади", "накануне", "наперекор", "наперерез", "наперехват", "наподобие", "напротив", "наравне с", "наравне со", "наряду с", "наряду со", "насупротив", "насчет", "начиная", "начиная от", "начиная с", "начиная со", "не без", "не в пример", "не говоря о", "не говоря об", "не говоря обо", "не до", "не считая", "невдалеке от", "невзирая на", "недалеко", "недалеко от", "независимо", "независимо от", "неподалеку от", "несмотря на", "ниже", "о", "об", "обо", "около", "окрест", "от", "ото", "от имени", "от лица", "относительно", "памяти", "перед", "передо", "пред", "предо", "перед", "передо", "пред", "предо", "перед лицом", "плюс к", "плюс ко", "по", "по адресу", "по аналогии с", "по аналогии со", "по вине", "по истечении", "по линии", "по мере", "по направлению", "по направлению к", "по направлению ко", "по отношению к", "по отношению ко", "по поводу", "по праву", "по примеру", "по причине", "по прошествии", "по пути", "по случаю", "по сравнению с", "по сравнению со", "по стопам", "по части", "по-за", "по-над", "по-под", "поблизости", "поблизости от", "поверх", "погодя", "под", "подо", "под видом", "под знаком", "под предлогом", "под председательством", "под эгидой", "подле", "подобно", "позади", "позднее", "поздней", "позже", "помимо", "поодаль от", "поперед", "поперек", "порядка", "посереди", "посередине", "посередке", "посередь", "после", "посреди", "посредине", "посредством", "превыше", "прежде", "при", "при всей", "при всем", "при всех", "при помощи", "при посредстве", "при условии", "применительно к", "применительно ко", "про", "против", "противно", "путем", "ради", "раньше", "рядом с", "рядом со", "с", "со", "с ведома", "с помощью", "с учетом", "с целью", "сбоку", "сбоку от", "сверх", "сверху", "свыше", "сзади", "силами", "сквозь", "следом за", "смотря по", "снаружи", "снизу", "со стороны", "совместно с", "совместно со", "совокупно с", "согласно", "согласно с", "согласно со", "сообразно", "сообразно с", "сообразно со", "сообща с", "сообща со", "соответственно", "соответственно с", "соответственно со", "соразмерно", "соразмерно с", "соразмерно со", "спереди", "спустя", "сравнительно с", "сравнительно со", "среди", "средь", "сродни", "судя по", "супротив", "считая", "типа", "у", "ценой", "ценою", "через", "что до"];

// Conjunctions (also covered by transition words
const coordinatingConjunctions$4 = ["и", "или", "и/или", "еще", "ещё", "а"];

const subordinatingConjunctions$4 = ["если", "даже"];

const interjections$9 = ["ох", "вау", "тю-тю", "ох-ох-ох", "эх", "фуф", "ага", "угу", "упс", "ой", "бее", "ну", "вот"];

// These words and abbreviations are frequently used in recipes in lists of ingredients.
const recipeWords$8 = ["ст", "ч", "л", "кг", "полкило", "г", "гр", "мл", "дл", "пол-литра", "мг", "см", "м", "км"];

// "век" and all its forms were not added because of conflict with "веко"
const timeWords$9 = ["секунд", "секунда", "минут", "минута", "час", "часа", "часов", "день", "дня", "дней", "неделя", "недели", "недель", "месяц", "месяца", "месяцев", "год", "года", "году", "годы", "лет", "гг", "сегодня", "завтра", "послезавтра", "вчера", "позавчера", "тыс до н э", "н э", "до н э", "тыс до н"];

// 'People' should only be removed in combination with 'some', 'many' and 'few' (and is therefore not yet included in the list below).
const vagueNouns$9 = ["вещь", "вещи", "вещью", "вещей", "вещам", "вещами", "вещах", "метод", "метода", "методом", "методу", "методе", "методы", "методам", "методами", "методах", "способ", "способа", "способом", "способу", "способе", "способы", "способам", "способами", "способах", "свойство", "свойства", "свойстве", "свойств", "свойствам", "свойствах", "свойствами", "случай", "случая", "случаем", "случаю", "случае", "случаи", "случаям", "случаями", "случаях", "дело", "дела", "делом", "делу", "деле", "делам", "делами", "делах", "сходство", "сходства", "сходстве", "сходств", "сходствам", "сходствах", "сходствами", "часть", "части", "частью", "частей", "частям", "частями", "частях", "штука", "штуки", "штуке", "штуку", "штук", "штукам", "штуками", "штуках", "раз", "раза", "разом", "разу", "разе", "разы", "разам", "разами", "разах", "вид", "вида", "видом", "виду", "виде", "виды", "видам", "видами", "видах", "процент", "процента", "процентом", "проценту", "проценте", "проценты", "процентам", "процентами", "процентах", "аспект", "аспекта", "аспектом", "аспекту", "аспекте", "аспекты", "аспектам", "аспектами", "аспектах", "пункт", "пункта", "пунктом", "пункту", "пункте", "пункты", "пунктам", "пунктами", "пунктах", "идея", "идеи", "идее", "идеей", "идеям", "идеями", "идеях", "тема", "темы", "теме", "тему", "темой", "темам", "темами", "темах", "человек", "человека", "человеком", "человеку", "человеке", "деталь", "детали", "деталью", "деталей", "деталям", "деталями", "деталях", "подробность", "подробности", "подробностью", "подробностей", "подробностям", "подробностями", "подробностях", "фактор", "фактора", "фактором", "фактору", "факторе", "факторы", "факторам", "факторами", "факторах", "разница", "разницы", "разнице", "разницу", "разницей", "различие", "различия", "различию", "различий", "различиям", "различиями", "различиях", "отличие", "отличия", "отличию", "отличий", "отличиям", "отличиями", "отличиях", "ситуация", "ситуации", "ситуацией", "ситуаций", "ситуациям", "ситуациями", "ситуациях", "сфера", "сферы", "сфере", "сферу", "сферой", "сферам", "сферами", "сферах"];

// 'No' is already included in the quantifier list.
const miscellaneous$8 = ["нет", "да", "конечно", "отлично", "верх", "низ", "ок", "окей", "аминь", "и т д", "и т. д.", "и так далее", "и тому подобное", "прости", "простите", "пожалуйста", "тут", "так", "не", "вдруг", "теперь", "точно", "бы", "сам", "сама", "само", "сами", "иногда", "сейчас", "тоже", "также", "пока", "ведь", "потом", "поэтому", "явно", "ни", "не", "будто", "напрочь", "причем", "причём", "зато", "вперед", "вперёд", "назад", "сразу", "пусть", "пускай"];

const titlesPreceding$2 = ["г-н", "г-жа", "тов", "гр-н", "гр-а", "гр", "проф"];

// "ст" is already included in recipe words
const titlesFollowing = ["мл"];

var functionWords$8 = {};

var transitionWords$c = {};

Object.defineProperty(transitionWords$c, "__esModule", {
	value: true
});

transitionWords$c.default = function () {
	return {
		singleWords: singleWords$7,
		multipleWords: multipleWords$7,
		allWords: singleWords$7.concat(multipleWords$7)
	};
};

/** @module config/transitionWords */

const singleWords$7 = ["aby", "abym", "abyśmy", "abyś", "abyście", "acz", "aczkolwiek", "albowiem", "ale", "aliści", "bo", "bowiem", "bynajmniej", "choć", "chociaż", "chociażby", "czyli", "dlatego", "dodatkowo", "dopóki", "dotychczas", "faktycznie", "gdy", "gdyż", "jakkolwiek", "iż", "jednak", "jednakże", "jeśli", "kiedy", "lecz", "mianowicie", "mimo", "np", "najpierw", "następnie", "natomiast", "ni", "niemniej", "niż", "notabene", "oczywiście", "ogółem", "ostatecznie", "owszem", "podobnie", "podsumowując", "pokrótce", "pomimo", "ponadto", "ponieważ", "poprzednio", "potem", "później", "przecież", "przeto", "przynajmniej", "raczej", "również", "rzeczywiście", "skoro", "także", "też", "toteż", "tudzież", "tymczasem", "wedle", "według", "więc", "właściwie", "wobec", "wpierw", "wprawdzie", "wreszcie", "wskutek", "wstępnie", "wszakże", "wszelako", "zamiast", "zanim", "zarówno", "zaś", "zatem", "zresztą", "zwłaszcza", "żeby", "żebym", "żebyś", "żebyście", "żebyśmy"];

const multipleWords$7 = ["a konkretnie", "a propos", "aby wrocić do rzeczy", "analogicznie do", "bacząc na to że", "bądź co bądź", "bez wątpienia", "bez względu", "biorąc pod uwagę", "choćby", "chodzi o to", "chyba że", "co do", "co gorsza", "co prawda", "co się tyczy", "co ważniejsze", "co więcej", "dzięki czemu", "dzięki któremu", "dzięki której", "dzięki którym", "dzięki temu", "faktem jest że", "inaczej mówiąc", "innymi słowy", "jak dotąd", "jak już mówiłam", "jak już mówiłem", "jak już wspomniano", "jak widać", "jako przykład", "jednym słowem", "jeśli chodzi o", "jeżeli chodzi o", "konkretnie to", "krótko mówiąc", "łącznie z", "mając to na uwadzę", "mam na myśli", "mamy na myśli", "mówiąc w skrócie", "na celu", "na dłuższą metę", "na dodatek", "na koniec", "na końcu", "na przykład", "na skutek", "na wstęp", "na wypadek gdyby", "na zakończenie", "nade wszystko", "należy pamiętać", "nawiasem mówiąc", "nie mówiąc już", "nie mówiąc o tym", "nie pomijając", "nie schodząc z tematu", "nie wspominając już", "nie wspominając o", "nie wspominając to", "nie wspominając że", "nie zważając na", "o ile", "o tyle", "od czasu do czasu", "od momentu", "odnośnie do", "ogólnie mówiąc", "ogólnie rzecz biorąc", "oprócz tego", "oznacza to że", "po czwarte", "po drugie", "po piąte", "po pierwsze", "po to", "po trzecie", "pod warunkiem", "podczas gdy", "podczas kiedy", "podobnym sposobem", "ponad wszystko", "poza tym", "prawdę mówiąc", "prawdę powiedziawszy", "prędzej czy później", "przechodząc do", "przede wszystkim", "przez co", "przez tą", "przez tego", "przez to", "przy tym", "przypuściwszy że", "raz na jakiś czas", "rzecz jasna", "ściśle biorąc", "ściśle mówiąc", "skutkiem tego", "tak czy inaczej", "tak czy owak", "tak naprawdę", "takich jak", "takie jak", "to znaczy", "tym samym", "w celu", "w ciągu", "w dodatku", "w efekcie", "w innych słowach", "w istocie", "w każdym razie", "w końcu", "w konsekwencji", "w kwestii", "w międzyczasie", "w nadziei że", "w obawie że", "w odróżnieniu", "w podobny sposób", "w podsumowaniu", "w przeciwieństwie do", "w przeciwnym razie", "w przypadku", "w rezultacie", "w rozumieniu że", "w rzeczy samej", "w rzeczywistości", "w skrócie", "w szczególności", "w takim razie", "w ten sposób", "w tych okolicznościach", "w tym przypadku", "w wyniku", "w wyniku tego", "w związku z tym", "wbrew pozorom", "włącznie z", "wracając do rzeczy", "wracając do tematu", "wręcz przeciwnie", "z drugiej strony", "z drugiej zaś strony", "z jednej strony", "z mocy że", "z obawy że", "z pewnością", "z powodu", "z przyczyny", "z tą intencją", "z tego powodu", "z uwagi że", "zacznijmy od", "zakładając że", "ze względu na", "ze względu że", "zważywszy na to", "zważywszy że"];

Object.defineProperty(functionWords$8, "__esModule", {
	value: true
});

functionWords$8.default = function () {
	return {

		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(ordinalNumerals$8, generalAdjectives$1, generalAdverbs$1, delexicalisedVerbsInfinitive, otherAuxiliariesInfinitive, passiveAuxiliariesInfinitive),

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(prepositions$7, coordinatingConjunctions$3, demonstrativePronouns$4, quantifiers$8, intensifiers$8, possessivePronouns$2, reflexivePronounsNominative, reflexivePronounsOther),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(transitionWords$b, additionalTransitionWords$2, cardinalNumerals$8, personalPronounsNominative$3, personalPronounsAccusative$1, personalPronounsGenitive, personalPronounsDative, personalPronounsInstrumental, personalPronounsPast, personalPronounsPrepositional, interrogativePronouns$3, interrogativeProAdverbs$2, interrogativeDeterminers$2, indefinitePronouns$8, adverbialGenitives$2, prepositionalAdverbs$1, subordinatingConjunctions$3, delexicalizedVerbs$3, interviewVerbs$8, timeWords$8, vagueNouns$8, titles$1, interjections$8, measurementUnits, miscellaneous$7, otherAuxiliaries$1),

		// These word categories cannot directly precede a passive participle.
		cannotDirectlyPrecedePassiveParticiple: [].concat(prepositions$7, personalPronounsPast, possessivePronouns$2, cardinalNumerals$8, ordinalNumerals$8, delexicalizedVerbs$3, delexicalisedVerbsInfinitive, interviewVerbs$8, interrogativeDeterminers$2, interrogativePronouns$3, interrogativeProAdverbs$2),

		// These word categories cannot intervene between an auxiliary and a corresponding passive participle.
		cannotBeBetweenPassiveAuxiliaryAndParticiple: [].concat(otherAuxiliaries$1, otherAuxiliariesInfinitive, reflexivePronounsNominative),

		// This export contains all of the above words.
		all: [].concat(transitionWords$b, additionalTransitionWords$2, cardinalNumerals$8, personalPronounsNominative$3, personalPronounsAccusative$1, personalPronounsGenitive, personalPronounsDative, personalPronounsInstrumental, personalPronounsPast, personalPronounsPrepositional, interrogativePronouns$3, interrogativeProAdverbs$2, interrogativeDeterminers$2, indefinitePronouns$8, adverbialGenitives$2, otherAuxiliaries$1, prepositionalAdverbs$1, subordinatingConjunctions$3, delexicalizedVerbs$3, interviewVerbs$8, timeWords$8, vagueNouns$8, titles$1, interjections$8, measurementUnits, miscellaneous$7, passiveAuxiliaries, prepositions$7, coordinatingConjunctions$3, demonstrativePronouns$4, quantifiers$8, intensifiers$8, possessivePronouns$2, reflexivePronounsNominative, reflexivePronounsOther, ordinalNumerals$8, generalAdjectives$1, generalAdverbs$1, delexicalisedVerbsInfinitive, otherAuxiliariesInfinitive, passiveAuxiliariesInfinitive)
	};
};

var _transitionWords$3 = transitionWords$c;

var _transitionWords2$3 = _interopRequireDefault$2P(_transitionWords$3);

function _interopRequireDefault$2P(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const transitionWords$b = (0, _transitionWords2$3.default)().singleWords;

/**
 * Returns an array with exceptions for the prominent words researcher
 * @returns {Array} The array filled with exceptions.
 */

const cardinalNumerals$8 = ["czterech", "czterem", "czterema", "czternaście", "czternastce", "czternastek", "czternastka", "czternastką", "czternastkach", "czternastkami", "czternastkę", "czternastki", "czternastko", "czternastkom", "czternastoma", "czternastu", "cztery", "czwórce", "czwórek", "czwórka", "czwórką", "czwórkach", "czwórkami", "czwórkę", "czwórki", "czwórko", "czwórkom", "czworo", "dwa", "dwadzieścia", "dwanaście", "dwie", "dwiema", "dwóch", "dwójce", "dwoje", "dwójek", "dwójka", "dwójką", "dwójkach", "dwójkami", "dwójki", "dwójko", "dwójkom", "dwóm", "dwoma", "dwudziestce", "dwudziestek", "dwudziestka", "dwudziestką", "dwudziestkach", "dwudziestkami", "dwudziestkę", "dwudziestki", "dwudziestkom", "dwudziestoma", "dwudziestu", "dwunastce", "dwunastek", "dwunastka", "dwunastką", "dwunastkach", "dwunastkami", "dwunastkę", "dwunastki", "dwunastko", "dwunastkom", "dwunastoma", "dwunastu", "dziesiątce", "dziesiątek", "dziesiątka", "dziesiątką", "dziesiątkach", "dziesiątkami", "dziesiątkę", "dziesiątki", "dziesiątko", "dziesiątkom", "dziesięć", "dziesięcioma", "dziesięciu", "dziewiątce", "dziewiątek", "dziewiątka", "dziewiątką", "dziewiątkach", "dziewiątkami", "dziewiątkę", "dziewiątki", "dziewiątko", "dziewiątkom", "dziewięć", "dziewięcioma", "dziewięciorga", "dziewięciorgiem", "dziewięciorgu", "dziewięcioro", "dziewięciu", "dziewiętnaście", "dziewiętnastce", "dziewiętnastek", "dziewiętnastka", "dziewiętnastką", "dziewiętnastkach", "dziewiętnastkami", "dziewiętnastkę", "dziewiętnastki", "dziewiętnastkom", "dziewiętnastoma", "dziewiętnastu", "jeden", "jedenaście", "jedenastce", "jedenastek", "jedenastka", "jedenastką", "jedenastkach", "jedenastkami", "jedenastkę", "jedenastki", "jedenastko", "jedenastkom", "jedenastoma", "jedenastu", "jedna", "jedną", "jednego", "jednej", "jednemu", "jedno", "jednym", "jedynce", "jedynek", "jedynka", "jedynką", "jedynkach", "jedynkami", "jedynkę", "jedynki", "jedynko", "jedynkom", "miliard", "miliarda", "miliardach", "miliardami", "miliardem", "miliardom", "miliardów", "miliardowi", "miliardy", "miliardzie", "milion", "miliona", "milionach", "milionami", "milionem", "milionie", "milionom", "milionów", "milionowi", "miliony", "ósemce", "ósemek", "ósemka", "ósemką", "ósemkach", "ósemkami", "ósemkę", "ósemki", "ósemko", "ósemkom", "osiem", "osiemnaście", "osiemnastce", "osiemnastek", "osiemnastka", "osiemnastką", "osiemnastkach", "osiemnastkam", "osiemnastkę", "osiemnastki", "osiemnastko", "osiemnastkom", "osiemnastoma", "osiemnastu", "ośmioma", "ośmiorga", "ośmiorgiem", "ośmiorgu", "ośmioro", "ośmiu", "piątce", "piątek", "piątka", "piątką", "piątkach", "piątkami", "piątkę", "piątki", "piątko", "piątkom", "pięć", "pięcioma", "pięciorga", "pięciorgiem", "pięciorgu", "pięcioro", "pięciu", "piętnaście", "piętnastce", "piętnastek", "piętnastka", "piętnastką", "piętnastkach", "piętnastkami", "piętnastkę", "piętnastki", "piętnastko", "piętnastkom", "piętnastoma", "piętnastu", "raz", "setce", "setek", "setka", "setkach", "setkami", "setkę", "setki", "setkom", "siedem", "siedemnaście", "siedemnastce", "siedemnastek", "siedemnastka", "siedemnastką", "siedemnastkach", "siedemnastkami", "siedemnastkę", "siedemnastki", "siedemnastko", "siedemnastkom", "siedemnastoma", "siedemnastu", "siedmioma", "siedmiorga", "siedmiorgiem", "siedmiorgu", "siedmioro", "siedmiu", "siódemce", "siódemek", "siódemka", "siódemką", "siódemkach", "siódemkami", "siódemkę", "siódemki", "siódemko", "siódemkom", "sto", "stoma", "stu", "sześć", "sześcioma", "sześciorga", "sześciorgiem", "sześciorgu", "sześcioro", "sześciu", "szesnaście", "szesnastce", "szesnastek", "szesnastka", "szesnastką", "szesnastkach", "szesnastkami", "szesnastkę", "szesnastki", "szesnastko", "szesnastkom", "szesnastoma", "szesnastu", "szóstce", "szóstek", "szóstka", "szóstką", "szóstkach", "szóstkami", "szóstkę", "szóstki", "szóstko", "szóstkom", "trójce", "troje", "trójek", "trójka", "trójką", "trójkach", "trójkami", "trójki", "trójko", "trójkom", "trzech", "trzem", "trzema", "trzy", "trzynaście", "trzynastce", "trzynastek", "trzynastka", "trzynastką", "trzynastkach", "trzynastkami", "trzynastkę", "trzynastki", "trzynastko", "trzynastkom", "trzynastoma", "trzynastu", "tysiąc", "tysiąca", "tysiącach", "tysiącami", "tysiące", "tysiącem", "tysiącom", "tysiącowi", "tysiącu", "tysięcy"];

const ordinalNumerals$8 = ["czternaści", "czternasta", "czternastą", "czternaste", "czternastego", "czternastej", "czternastemu", "czternasty", "czternastych", "czternastym", "czternastymi", "czwarci", "czwarta", "czwartą", "czwarte", "czwartego", "czwartej", "czwartemu", "czwarty", "czwartych", "czwartym", "czwartymi", "drudzy", "druga", "drugą", "drugi", "drugich", "drugie", "drugiego", "drugiej", "drugiemu", "drugim", "drugimi", "dwudzieści", "dwudziesta", "dwudziestą", "dwudzieste", "dwudziestego", "dwudziestej", "dwudziestemu", "dwudziesty", "dwudziestych", "dwudziestym", "dwudziestymi", "dwunaści", "dwunasta", "dwunastą", "dwunaste", "dwunastego", "dwunastej", "dwunastemu", "dwunasty", "dwunastych", "dwunastym", "dwunastymi", "dziesiąci", "dziesiąta", "dziesiątą", "dziesiąte", "dziesiątego", "dziesiątej", "dziesiątemu", "dziesiąty", "dziesiątych", "dziesiątym", "dziesiątymi", "dziewiąci", "dziewiąta", "dziewiątą", "dziewiąte", "dziewiątego", "dziewiątej", "dziewiątemu", "dziewiąty", "dziewiątych", "dziewiątym", "dziewiątymi", "dziewiętnaści", "dziewiętnasta", "dziewiętnastą", "dziewiętnaste", "dziewiętnastego", "dziewiętnastej", "dziewiętnastemu", "dziewiętnasty", "dziewiętnastych", "dziewiętnastym", "dziewiętnastymi", "jedenaści", "jedenasta", "jedenastą", "jedenaste", "jedenastego", "jedenastej", "jedenastemu", "jedenasty", "jedenastych", "jedenastym", "jedenastymi", "osiemnaści", "osiemnasta", "osiemnastą", "osiemnaste", "osiemnastego", "osiemnastej", "osiemnastemu", "osiemnasty", "osiemnastych", "osiemnastym", "osiemnastymi", "ósma", "ósmą", "ósme", "ósmego", "ósmej", "ósmemu", "óśmi", "ósmy", "ósmych", "ósmym", "ósmymi", "piąci", "piąta", "piątą", "piąte", "piątego", "piątej", "piątemu", "piąty", "piątych", "piątym", "piątymi", "pierwsi", "pierwsza", "pierwszą", "pierwsze", "pierwszego", "pierwszej", "pierwszemu", "pierwszy", "pierwszych", "pierwszym", "pierwszymi", "piętnaści", "piętnasta", "piętnastą", "piętnaste", "piętnastego", "piętnastej", "piętnastemu", "piętnasty", "piętnastych", "piętnastym", "piętnastymi", "siedemnaści", "siedemnasta", "siedemnastą", "siedemnaste", "siedemnastego", "siedemnastej", "siedemnastemu", "siedemnasty", "siedemnastych", "siedemnastym", "siedemnastymi", "siódma", "siódmą", "siódme", "siódmego", "siódmej", "siódmemu", "siódmi", "siódmy", "siódmych", "siódmym", "siódmymi", "szesnaści", "szesnasta", "szesnastą", "szesnaste", "szesnastego", "szesnastej", "szesnastemu", "szesnasty", "szesnastych", "szesnastymi", "szóści", "szósta", "szóstą", "szóste", "szóstego", "szóstej", "szóstemu", "szósty", "szóstych", "szóstym", "szóstymi", "trzeci", "trzecia", "trzecią", "trzecich", "trzecie", "trzeciego", "trzeciej", "trzeciemu", "trzecim", "trzecimi", "trzynaści", "trzynasta", "trzynastą", "trzynaste", "trzynastego", "trzynastej", "trzynastemu", "trzynasty", "trzynastych", "trzynastym", "trzynastymi"];

const personalPronounsNominative$3 = ["ja", "my", "on", "ona", "one", "oni", "ono", "ty", "wy"];

const personalPronounsAccusative$1 = ["cię", "ciebie", "go", "ich", "ją", "je", "jego", "mnie", "nas", "nią", "nich", "nie", "niego", "was"];

const personalPronounsGenitive = ["jej", "niej"];

const personalPronounsDative = ["mi", "ci", "im", "jemu", "mu", "nam", "niemu", "nim", "tobie", "wam"];

const personalPronounsInstrumental = ["mną", "nami", "nią", "nim", "nimi", "tobą", "wami"];

const personalPronounsPast = ["myśmy", "wyście", "żeście", "żeśmy"];

const personalPronounsPrepositional = ["doń", "nań", "zeń"];

const possessivePronouns$2 = ["ich", "jego", "jej", "ma", "mą", "me", "mego", "mej", "memu", "moi", "moich", "moim", "moimi", "mój", "moja", "moją", "moje", "mojego", "mojej", "mojemu", "mych", "mym", "mymi", "nasi", "nasz", "nasza", "naszą", "nasze", "naszego", "naszej", "naszemu", "naszych", "naszym", "naszymi", "swa", "swą", "swe", "swego", "swej", "swemu", "swoi", "swoich", "swoim", "swoimi", "swój", "swoja", "swoją", "swoje", "swojego", "swojej", "swojemu", "swych", "swym", "swymi", "twa", "twą", "twe", "twego", "twej", "twemu", "twoi", "twoich", "twoim", "twoimi", "twój", "twoja", "twoją", "twoje", "twojego", "twojej", "twojemu", "twych", "twym", "twymi", "wasi", "wasz", "wasza", "waszą", "wasze", "waszego", "waszej", "waszemu", "waszych", "waszym", "waszymi"];

const reflexivePronounsNominative = ["się"];

const reflexivePronounsOther = ["siebie", "sobą"];

const interrogativePronouns$3 = ["czyi", "czyich", "czyim", "czyimi", "czyj", "czyja", "czyją", "czyje", "czyjego", "czyjej", "czyjemu", "kim", "kogo", "komu", "kto"];

const interrogativeProAdverbs$2 = ["czy", "czyś", "czyśbyś", "dlaczego", "dokąd", "dokądże", "dokądżeś", "gdzie", "gdzież", "gdzieżeś", "ile", "ileż", "jak", "jakbyś", "jakże", "jakżebyś", "jakżeś", "kiedy", "którędy", "którędyż", "skąd", "skądże", "skądżeś"];

const interrogativeDeterminers$2 = ["co", "czego", "czemu", "czym", "jacy", "jaka", "jaką", "jaki", "jakich", "jakie", "jakiego", "jakiej", "jakiemu", "jakim", "jakimi", "która", "którą", "które", "którego", "której", "któremu", "który", "których", "którym", "którymi", "którzy"];

const indefinitePronouns$8 = ["coś", "czegoś", "czemuś", "czyichkolwiek", "czyichś", "czyikolwiek", "czyimikolwiek", "czyimiś", "czyimkolwiek", "czyimkolwiem", "czyimś", "czyiś", "czyjakolwiek", "czyjąkolwiek", "czyjaś", "czyjąś", "czyjegokolwiek", "czyjegoś", "czyjejkolwiek", "czyjejś", "czyjekolwiek", "czyjemukolwiek", "czyjemuś", "czyjeś", "czyjkolwiek", "czymś", "dlaczegoś", "dokądkolwiek", "dokądś", "gdziekolwiek", "gdzieś", "ilekolwiek", "ileś", "jacykolwiek", "jacyś", "jakakolwiek", "jakąkolwiek", "jakaś", "jakąś", "jakichkolwiek", "jakichś", "jakiegokolwiek", "jakiegoś", "jakiejkolwiek", "jakiejś", "jakiekolwiek", "jakiemukolwiek", "jakiemuś", "jakieś", "jakikolwiek", "jakimikolwiek", "jakimkolwiek", "jakimś", "jakiś", "jakkolwiek", "jakoś", "każda", "każdą", "każde", "każdego", "każdej", "każdemu", "każdy", "każdym", "kiedykolwiek", "kiedyś", "kimkolwiek", "kimś", "kogokolwiek", "kogoś", "komukolwiek", "komuś", "ktokolwiek", "którakolwiek", "którąkolwiek", "któraś", "którąś", "którędykolwiek", "którędyś", "któregokolwiek", "któregoś", "którejkolwiek", "którejś", "którekolwiek", "któremukolwiek", "któremuś", "któreś", "którychkolwiek", "którychś", "którykolwiek", "którymikolwiek", "którymiś", "którymkolwiek", "którymś", "któryś", "którzykolwiek", "którzyś", "ktoś", "nawzajem", "nic", "niczego", "niczemu", "niczyi", "niczyich", "niczyim", "niczyimi", "niczyj", "niczyja", "niczyją", "niczyjego", "niczyjej", "niczyjemu", "niczym", "nikim", "nikogo", "nikogokolwiek", "nikomu", "nikt", "skądkolwiek", "skądś", "wszyscy", "wszyskiego", "wszystkich", "wszystkie", "wszystkiemu", "wszystkim", "wszystkimi", "wszystko", "żaden", "żadna", "żadną", "żadne", "żadnego", "żadnej", "żadnemu", "żadni", "żadnych", "żadnym", "żadnymi"];

const demonstrativePronouns$4 = ["ci", "dlatego", "ów", "owa", "ową", "owe", "owego", "owej", "owemu", "owi", "owo", "owych", "owym", "stąd", "stamtąd", "ta", "tacy", "tak", "taka", "taką", "taki", "takich", "takie", "takiego", "takiej", "takiemu", "takim", "takimi", "tam", "tamci", "tamta", "tamtą", "tamte", "tamtego", "tamtej", "tamtemu", "tamten", "tamto", "tamtych", "tamtym", "tamtymi", "tą", "te", "tę", "tędy", "tego", "tegoż", "tej", "temu", "ten", "to", "tu", "tutaj", "tych", "tyle", "tyloma", "tylu", "tym", "tymi", "wtedy"];

const quantifiers$8 = ["ciut", "część", "części", "częścią", "częściach", "częściami", "częściom", "dość", "dosyć", "dużo", "kilka", "kilkadziesiąt", "kilkanaście", "kilkaset", "kilknasty", "kilkoma", "kilku", "kilkudziesiąte", "kilkudziesiątego", "kilkudziesiątej", "kilkudziesiąty", "kilkudziesiątych", "kilkudziesiątym", "kilkudziesiątymi", "kilkudziesięcioma", "kilkudziesięciu", "kilkunasta", "kilkunastą", "kilkunaste", "kilkunastego", "kilkunastej", "kilkunastemu", "kilkunastoma", "kilkunastu", "kilkunastym", "kilkuset", "kilkustoma", "kiludziesiąta", "mało", "malutko", "mniej", "mnóstwa", "mnóstwem", "mnóstwie", "mnóstwo", "mnóstwu", "multum", "nadto", "najmniej", "najwięcej", "nieco", "niedużo", "niejednokroć", "niektóre", "niektórzy", "niektórych", "niektórym", "niektórymi", "niemało", "niewiele", "niewieloma", "niewielu", "oba", "obaj", "obie", "oboje", "obojga", "obojgiem", "obojgu", "obóm", "oboma", "obu", "obydwa", "obydwaj", "obydwie", "obydwiema", "obydwóch", "obydwoje", "obydwojgiem", "obydwojgu", "obydwóm", "obydwoma", "obydwu", "odrobiną", "odrobince", "odrobinę", "odrobinie", "odrobinką", "odrobinkę", "odrobinki", "odrobiny", "parę", "parędziesiąt", "parędziesięcioma", "parędziesięciu", "paręnaście", "paręnastoma", "paręnastu", "parokroć", "paroma", "paru", "parze", "pełno", "pół", "półczwarta", "połowa", "połową", "połowie", "połowy", "półtora", "półtorej", "sporo", "trochę", "trochu", "troszeczkę", "troszkę", "wcale", "więcej", "większość", "większości", "większością", "większościach", "większościami", "większościom", "wiele", "wielokrotnie", "wieloma", "wielu"];

const adverbialGenitives$2 = ["czasem", "często", "nigdy", "rzadko", "zawsze"];

const otherAuxiliaries$1 = ["chcą", "chcąc", "chcąca", "chcące", "chcący", "chce", "chcę", "chcecie", "chcemy", "chcesz", "chciał", "chciała", "chciałaby", "chciałabym", "chciałabyś", "chciałam", "chciałaś", "chciałby", "chciałbym", "chciałbyś", "chciałem", "chciałeś", "chciały", "chciałyby", "chciałybyście", "chciałybyśmy", "chciałyście", "chciałyśmy", "chcieli", "chcieliby", "chcielibyście", "chcieliście", "chcieliśmy", "chcono", "ma", "macie", "mają", "mając", "mam", "mamy", "masz", "miał", "miała", "miałaby", "miałabym", "miałabyś", "miałam", "miałaś", "miałby", "miałbym", "miałbyś", "miałem", "miałeś", "miało", "miałoby", "miały", "miałyby", "miałybyście", "miałybyśmy", "miałyście", "miałyśmy", "miano", "miej", "miejąca", "miejące", "miejący", "miejcie", "miejmy", "mieli", "mieliby", "mielibyście", "mielibyśmy", "mieliście", "mieliśmy", "mogą", "mogąc", "mogąca", "mogące", "mogący", "mogę", "mógł", "mogła", "mogłaby", "mogłabym", "mogłabyś", "mogłam", "mogłaś", "mógłby", "mógłbym", "mógłbyś", "mogłem", "mogłeś", "mogli", "mogliby", "moglibyście", "moglibyśmy", "mogliście", "mogliśmy", "mogły", "mogłyby", "mogłybyście", "mogłybyśmy", "mogłyście", "mogłyśmy", "może", "możecie", "możemy", "możesz", "można", "możnaby", "musi", "musiał", "musiała", "musiałaby", "musiałabym", "musiałabyś", "musiałam", "musiałaś", "musiałby", "musiałbym", "musiałbyś", "musiałem", "musiałeś", "musiało", "musiałoby", "musiały", "musiałyby", "musiałybyście", "musiałybyśmy", "musiałyście", "musiałyśmy", "musiano", "musicie", "musieli", "musieliby", "musielibyście", "musielibyśmy", "musieliście", "musieliśmy", "musimy", "musisz", "muszą", "musząc", "musząca", "muszące", "muszący", "muszę", "należy", "niech", "potrafi", "potrafią", "potrafiąc", "potrafiąca", "potrafiące", "potrafiący", "potraficie", "potrafię", "potrafiłaby", "potrafiłabym", "potrafiłabyś", "potrafiłam", "potrafiłaś", "potrafiłbym", "potrafiłbyś", "potrafiłem", "potrafiłeś", "potrafili", "potrafiliby", "potrafilibyście", "potrafilibyśmy", "potrafiliście", "potrafiliśmy", "potrafiło", "potrafiłoby", "potrafiłyby", "potrafiłybyście", "potrafiłybyśmy", "potrafiłyście", "potrafiłyśmy", "potrafimy", "potrafiono", "potrafisz", "powinien", "powinienem", "powinieneś", "powinna", "powinnam", "powinnaś", "powinne", "powinni", "powinniście", "powinniśmy", "powinnyście", "powinnyśmy", "pozostaje", "stają", "stając", "stająca", "stające", "stający", "staje", "staję", "stajecie", "stajemy", "stajesz", "stał", "stała", "stałaby", "stałabym", "stałabyś", "stałam", "stałaś", "stałby", "stałbym", "stałbyś", "stałem", "stałeś", "stali", "staliby", "stalibyście", "stalibyśmy", "staliście", "staliśmy", "stało", "stały", "stałyby", "stałybyście", "stałybyśmy", "stałyście", "stałyśmy", "stanie", "stano", "stawać", "stawając", "stawająca", "stawające", "stawający", "stawał", "stawała", "stawałaby", "stawałabym", "stawałabyś", "stawałabyście", "stawałam", "stawałaś", "stawałby", "stawałbym", "stawałbyś", "stawałem", "stawałeś", "stawali", "stawaliby", "stawalibyście", "stawalibyśmy", "stawaliście", "stawaliśmy", "stawały", "stawałyby", "stawałybyśmy", "stawałyście", "stawałyśmy", "stawano", "stawawszy", "stawszy", "trzeba", "warto", "wystarczy"];

const passiveAuxiliaries = ["bądź", "bądźcie", "bądźmy", "będą", "będąc", "będę", "będzie", "będziecie", "będziemy", "będziesz", "by", "był", "była", "byłaby", "byłabym", "byłabyś", "byłam", "byłaś", "byłby", "byłbym", "byłbyś", "byłem", "byłeś", "byli", "byliby", "bylibyście", "bylibyśmy", "byliście", "byliśmy", "było", "byłoby", "były", "byłyby", "byłybyście", "byłybyśmy", "byłyście", "byłyśmy", "bym", "byś", "byście", "byśmy", "byto", "bywało", "jest", "jestem", "jesteś", "jesteście", "jesteśmy", "są", "zostają", "zostając", "zostająca", "zostające", "zostający", "zostaje", "zostaję", "zostajecie", "zostajemy", "zostajesz", "został", "została", "zostałaby", "zostałabym", "zostałabyś", "zostałam", "zostałaś", "zostałby", "zostałbym", "zostałbyś", "zostałem", "zostałeś", "zostali", "zostaliby", "zostalibyście", "zostalibyśmy", "zostaliście", "zostaliśmy", "zostało", "zostaloby", "zostały", "zostałyby", "zostałybyście", "zostałybyśmy", "zostałyście", "zostałyśmy", "zostań", "zostaną", "zostańcie", "zostanę", "zostanie", "zostaniecie", "zostaniemy", "zostaniesz", "zostańmy", "zostawało", "zostawano", "zostawszy"];

const passiveAuxiliariesInfinitive = ["być", "zostać"];

const otherAuxiliariesInfinitive = ["chcieć", "mieć", "móc", "musieć", "potrafić", "stać"];

const prepositions$7 = ["bez", "beze", "blisko", "daleko", "dla", "do", "dole", "dookoła", "górze", "jako", "koło", "ku", "między", "mimo", "na", "nad", "nade", "naokoło", "naprzeciwko", "niedaleko", "nieopodal", "niż", "o", "obok", "od", "ode", "około", "oprócz", "po", "pod", "podczas", "pode", "pomiędzy", "ponad", "poniżej", "poprzek", "poprzez", "pośród", "powyżej", "poza", "przeciw", "przeciwko", "przed", "przede", "przez", "przeze", "przy", "spodem", "spośród", "spoza", "u", "w", "wbrew", "we", "wedle", "wewnątrz", "wpół", "wraz", "wśród", "wzdłuż", "z", "za", "ze", "zza"];

const prepositionalAdverbs$1 = ["bliska", "daleka", "przodu", "tyłu"];

const coordinatingConjunctions$3 = ["albo", "ani", "bądź", "i", "lub", "oraz", "tylko"];

const subordinatingConjunctions$3 = ["aż", "by", "czy", "gdyby", "jak", "jeśli", "jeżeli", "że"];

// Ciągu is part of 'w ciągu' (during)
const additionalTransitionWords$2 = ["ano", "ciągu", "coraz", "dzięki", "chyba", "jakby", "jednocześnie", "jeszcze", "już", "nadal", "nagle", "znowu", "prawdopodobnie", "niestety", "dziś", "dzisiaj", "oczywiście", "względem", "m.in.", "właśnie", "zaraz"];

const delexicalizedVerbs$3 = ["bierz", "bierzcie", "bierzecie", "bierzemy", "bierzesz", "bierzmy", "biorą", "biorąc", "biorąca", "biorące", "biorący", "biorę", "brał", "brała", "brałaby", "brałabym", "brałabyś", "brałam", "brałaś", "brałby", "brałbym", "brałbyś", "brałem", "brałeś", "brali", "braliby", "bralibyście", "bralibyśmy", "braliście", "braliśmy", "brało", "brałoby", "brały", "brałyby", "brałybyście", "brałybyśmy", "brałyście", "brałyśmy", "brany", "da", "dacie", "dadzą", "daj", "dają", "dając", "dająca", "dające", "dający", "dajcie", "daje", "daję", "dajecie", "dajemy", "dajesz", "dajmy", "dał", "dała", "dałaby", "dałabym", "dałabyś", "dałam", "dałaś", "dałby", "dałbym", "dałbyś", "dałem", "dałeś", "dali", "daliby", "dalibyście", "dalibyśmy", "daliście", "daliśmy", "dało", "dałoby", "dały", "dałyby", "dałybyście", "dałybyśmy", "dałyście", "dałyśmy", "dam", "damy", "dana", "dano", "dany", "dasz", "dawaj", "dawajcie", "dawajmy", "dawał", "dawała", "dawałaby", "dawałabym", "dawałabyś", "dawałam", "dawałaś", "dawałby", "dawałbym", "dawałbyś", "dawałem", "dawałeś", "dawali", "dawaliby", "dawalibyście", "dawalibyśmy", "dawaliście", "dawaliśmy", "dawało", "dawały", "dawałyby", "dawałybyście", "dawałybyśmy", "dawałyście", "dawałyśmy", "dawana", "dawane", "dawano", "dawany", "idą", "idąc", "idąca", "idące", "idący", "idę", "idź", "idźcie", "idzie", "idziecie", "idziemy", "idziesz", "idźmy", "rób", "róbcie", "robi", "robią", "robiąc", "robiąca", "robiące", "robiący", "robicie", "robię", "robił", "robiła", "robiłaby", "robiłabym", "robiłabyś", "robiłam", "robiłaś", "robiłby", "robiłbym", "robiłbyś", "robiłem", "robiłeś", "robili", "robilibiście", "robiliby", "robilibyśmy", "robiliście", "robiliśmy", "robiło", "robiły", "robiłyby", "robiłybyście", "robiłybyśmy", "robiłyście", "robiłyśmy", "robimy", "robiono", "robiony", "robisz", "róbmy", "stanowi", "stanowią", "stanowiły", "stanowili", "stoi", "stoicie", "stoimy", "stoisz", "stój", "stoją", "stojąc", "stojąca", "stojące", "stojący", "stójcie", "stoję", "stójmy", "świadczy", "szedł", "szedłby", "szedłbym", "szedłbyś", "szedłem", "szedłeś", "szła", "szłaby", "szłabym", "szłabyś", "szłam", "szłaś", "szli", "szliby", "szlibyście", "szlibyśmy", "szliście", "szliśmy", "szło", "szłoby", "szły", "szłyby", "szłybyście", "szłybyśmy", "szłyście", "uprawia", "uprawiacie", "uprawiają", "uprawiając", "uprawiająca", "uprawiające", "uprawiający", "uprawiał", "uprawiała", "uprawiałaby", "uprawiałabym", "uprawiałabyś", "uprawiałam", "uprawiałaś", "uprawiałby", "uprawiałbym", "uprawiałbyś", "uprawiałem", "uprawiałeś", "uprawiali", "uprawialiby", "uprawialibyście", "uprawialibyśmy", "uprawialiście", "uprawialiśmy", "uprawiało", "uprawiałoby", "uprawiały", "uprawiałyby", "uprawiałybyście", "uprawiałybyśmy", "uprawiałyście", "uprawiałyśmy", "uprawiam", "uprawiamy", "uprawiana", "uprawiane", "uprawiano", "uprawiany", "uprawiasz", "weź", "weźcie", "wezmą", "wezmę", "weźmie", "weźmiecie", "weźmiemy", "weźmiesz", "weźmy", "wykonuj", "wykonują", "wykonując", "wykonująca", "wykonujące", "wykonujący", "wykonujcie", "wykonuje", "wykonuję", "wykonujecie", "wykonujemy", "wykonujesz", "wykonujmy", "wykonywał", "wykonywała", "wykonywałaby", "wykonywałabym", "wykonywałabyś", "wykonywałam", "wykonywałaś", "wykonywałby", "wykonywałbym", "wykonywałbyś", "wykonywałem", "wykonywałeś", "wykonywali", "wykonywaliby", "wykonywalibyście", "wykonywalibyśmy", "wykonywaliście", "wykonywaliśmy", "wykonywało", "wykonywałoby", "wykonywały", "wykonywałyby", "wykonywałybyście", "wykonywałybyśmy", "wykonywałyście", "wykonywałyśmy", "wykonywana", "wykonywane", "wykonywany", "wziął", "wziąłby", "wziąłbym", "wziąłbyś", "wziąłem", "wziąłeś", "wziąwszy", "wzięła", "wzięłaby", "wzięłabym", "wzięłabyś", "wzięłam", "wzięłaś", "wzięli", "wzięliby", "wzięlibyście", "wzięlibyśmy", "wzięliście", "wzięliśmy", "wzięło", "wzięłoby", "wzięły", "wzięłyby", "wzięłybyście", "wzięłybyśmy", "wzięłyście", "wzięłyśmy", "zrób", "zróbcie", "zrobi", "zrobią", "zrobiąc", "zrobiąca", "zrobiące", "zrobiący", "zrobicie", "zrobię", "zrobił", "zrobiła", "zrobiłaby", "zrobiłabym", "zrobiłabyś", "zrobiłam", "zrobiłaś", "zrobiłby", "zrobiłbym", "zrobiłbyś", "zrobiłem", "zrobiłeś", "zrobili", "zrobilibiście", "zrobiliby", "zrobilibyśmy", "zrobiliście", "zrobiliśmy", "zrobiło", "zrobiły", "zrobiłyby", "zrobiłybyście", "zrobiłybyśmy", "zrobiłyście", "zrobiłyśmy", "zrobimy", "zrobiono", "zrobiony", "zrobisz", "zróbmy", "powinno", "bywa", "wiedzieć", "znać", "wiedział", "wiedziała", "wiedziały", "wiedzieli", "znał", "znała", "znali", "znały", "powie", "wie", "zna", "zobaczy", "powiedzą", "powiedziano", "powiem", "wiedzą", "wiedzące", "wiedzący", "wiedziało", "wiedziano", "wiem", "znają", "znające", "znający", "znało", "znam", "znane", "znano", "zobaczą", "zobaczę", "zobaczone", "zobaczono", "powiecie", "powiedz", "powiedzcie", "powiedzenie", "powiedział", "powiedziała", "powiedziałaby", "powiedziałabym", "powiedziałabyś", "powiedziałam", "powiedziałaś", "powiedziałby", "powiedziałbym", "powiedziałbyś", "powiedziałem", "powiedziałeś", "powiedziało", "powiedziałoby", "powiedziały", "powiedziałyby", "powiedziałybyście", "powiedziałybyśmy", "powiedziałyście", "powiedziałyśmy", "powiedziawszy", "powiedzieć", "powiedzieli", "powiedzieliby", "powiedzielibyście", "powiedzielibyśmy", "powiedzieliście", "powiedzieliśmy", "powiedzmy", "powiemy", "powiesz", "wiecie", "wiedz", "wiedząc", "wiedząca", "wiedzcie", "wiedziałaby", "wiedziałabym", "wiedziałabyś", "wiedziałam", "wiedziałaś", "wiedziałby", "wiedziałbym", "wiedziałbyś", "wiedziałem", "wiedziałeś", "wiedziałoby", "wiedziałyby", "wiedziałybyście", "wiedziałybyśmy", "wiedziałyście", "wiedziałyśmy", "wiedzieliby", "wiedzielibyście", "wiedzielibyśmy", "wiedzieliście", "wiedzieliśmy", "wiedzmy", "wiemy", "wiesz", "znacie", "znaj", "znając", "znająca", "znajcie", "znajmy", "znałaby", "znałabym", "znałabyś", "znałam", "znałaś", "znałby", "znałbym", "znałbyś", "znałem", "znałeś", "znaliby", "znalibyście", "znalibyśmy", "znaliście", "znaliśmy", "znałoby", "znałyby", "znałybyście", "znałybyśmy", "znałyście", "znałyśmy", "znamy", "znana", "znani", "znanie", "znany", "znasz", "zobacz", "zobaczcie", "zobaczeni", "zobaczenie", "zobaczmy", "zobaczona", "zobaczony", "zobaczyć", "zobaczycie", "zobaczył", "zobaczyła", "zobaczyłaby", "zobaczyłabym", "zobaczyłabyś", "zobaczyłam", "zobaczyłaś", "zobaczyłby", "zobaczyłbym", "zobaczyłbyś", "zobaczyłem", "zobaczyłeś", "zobaczyli", "zobaczyliby", "zobaczylibyście", "zobaczylibyśmy", "zobaczyliście", "zobaczyliśmy", "zobaczyło", "zobaczyłoby", "zobaczyły", "zobaczyłyby", "zobaczyłybyście", "zobaczyłybyśmy", "zobaczyłyście", "zobaczyłyśmy", "zobaczymy", "zobaczysz", "zobaczywszy"];

const delexicalisedVerbsInfinitive = ["brać", "dać", "dawać", "iść", "robić", "stanowić", "uprawiać", "wykonywać", "wziąć", "zrobić"];

const interviewVerbs$8 = ["informowali", "informowały", "informują", "informuje", "informuję", "mówi", "mówią", "mówię", "mówił", "mówiła", "mówili", "mówiły", "odpowiada", "odpowiadają", "odpowiadam", "odpowiedział", "odpowiedziała", "odpowiedziałam", "odpowiedziały", "odpowiedzieli", "odwiedziałam", "poinformowałam", "poinformowali", "poinformowały", "powiedział", "powiedziała", "powiedziałam", "powiedziały", "powiedzieli", "pyta", "pytać", "pytał", "pytała", "pytałam", "pytali", "pytały", "pytam", "sądzą", "sądzę", "sądzi", "sądzić", "sądziłam", "sądzili", "sądziły", "spytał", "spytała", "spytałam", "spytali", "spytały", "stwierdziały", "stwierdzieli", "stwierdził", "stwierdziła", "stwierdziłam", "twierdzą", "twierdzę", "twierdzi", "twierdziały", "twierdzić", "twierdzieli", "twierdził", "twierdziła", "twierdziłam", "uważa", "uważają", "uważał", "uważała", "uważali", "uważały", "uważam", "wyjaśnia", "wyjaśniać", "wyjaśniają", "wyjaśniam", "wyjaśnił", "wyjaśniła", "wyjaśnili", "wyjaśniły", "zapytał", "zapytała", "zapytałam", "zapytali", "zapytały", "zaznacza", "zaznaczają", "zaznaczam", "zaznaczył", "zaznaczyła", "zaznaczyłam", "zaznaczyli", "zaznaczyły"];

const intensifiers$8 = ["bardziej", "bardzo", "całkiem", "całkowicie", "doskonale", "dość", "dosyć", "kompletnie", "najbardziej", "naprawdę", "nawet", "nieco", "niezbyt", "niezmiernie", "niezwykle", "ogromnie", "strasznie", "świetnie", "wielce", "wyjątkowo", "zbyt", "znacznie", "zupełnie"];

const generalAdjectives$1 = ["cała", "całą", "całe", "całego", "całej", "całemu", "cali", "cały", "całych", "całym", "całymi", "ciekawa", "ciekawą", "ciekawe", "ciekawego", "ciekawej", "ciekawemu", "ciekawi", "ciekawy", "ciekawych", "ciekawym", "ciekawymi", "dłudzy", "długa", "długą", "długi", "długich", "długie", "długiego", "długiej", "długiemu", "długim", "długimi", "dłużsi", "dłuższa", "dłuższą", "dłuższe", "dłuższego", "dłuższej", "dłuższemu", "dłuższy", "dłuższych", "dłuższym", "dłuższymi", "dobra", "dobrą", "dobre", "dobrego", "dobrej", "dobremu", "dobry", "dobrych", "dobrym", "dobrymi", "dobrzy", "fajna", "fajną", "fajne", "fajnego", "fajnej", "fajnemu", "fajni", "fajny", "fajnych", "fajnym", "fajnymi", "główna", "główną", "główne", "głównego", "głównej", "głównemu", "główni", "główny", "głównych", "głównym", "głównymi", "inna", "inną", "inne", "innego", "innej", "innemu", "inni", "inny", "innych", "innym", "innymi", "krótcy", "krótka", "krótką", "krótki", "krótkich", "krótkie", "krótkiego", "krótkiej", "krótkiemu", "krótkim", "krótkimi", "krótsi", "krótsza", "krótszą", "krótsze", "krótszego", "krótszej", "krótszemu", "krótszych", "krótszym", "krótszymi", "łatwe", "łatwego", "łatwiejsze", "łatwym", "lepsi", "lepsza", "lepszą", "lepsze", "lepszego", "lepszej", "lepszemu", "lepszy", "lepszych", "lepszym", "lepszymi", "mała", "małą", "małe", "małego", "małej", "małemu", "mali", "mały", "małych", "małym", "małymi", "mniejsi", "mniejsza", "mniejszą", "mniejsze", "mniejszego", "mniejszej", "mniejszemu", "mniejszy", "mniejszych", "mniejszym", "mniejszymi", "najdłużsi", "najdłuższa", "najdłuższą", "najdłuższe", "najdłuższego", "najdłuższej", "najdłuższemu", "najdłuższy", "najdłuższych", "najdłuższym", "najdłuższymi", "najkrótsi", "najkrótsza", "najkrótszą", "najkrótsze", "najkrótszego", "najkrótszej", "najkrótszemu", "najkrótszych", "najkrótszym", "najkrótszymi", "najłatwiejsze", "najlepsi", "najlepsza", "najlepszą", "najlepsze", "najlepszego", "najlepszej", "najlepszemu", "najlepszych", "najlepszym", "najlepszymi", "najmniejsi", "najmniejsza", "najmniejszą", "najmniejsze", "najmniejszego", "najmniejszej", "najmniejszemu", "najmniejszy", "najmniejszych", "najmniejszym", "najmniejszymi", "najniżsi", "najniższa", "najniższą", "najniższe", "najniższego", "najniższej", "najniższemu", "najniższy", "najniższych", "najniższym", "najniższymi", "najtrudniejsze", "najwięksi", "największa", "największą", "największe", "największego", "największej", "największemu", "największych", "największym", "największymi", "najwyżsi", "najwyższa", "najwyższą", "najwyższe", "najwyższego", "najwyższej", "najwyższemu", "najwyższy", "najwyższych", "najwyższym", "najwyższymi", "następna", "następną", "następne", "następnego", "następnej", "następni", "następny", "następnych", "następnym", "następnymi", "niewłaściwa", "niewłaściwą", "niewłaściwe", "niewłaściwego", "niewłaściwej", "niewłaściwemu", "niewłaściwi", "niewłaściwy", "niewłaściwych", "niewłaściwym", "niewłaściwymi", "niscy", "niska", "niską", "niski", "niskich", "niskie", "niskiego", "niskiej", "niskiemu", "niskim", "niskimi", "niżsi", "niższa", "niższą", "niższe", "niższego", "niższej", "niższemu", "niższy", "niższych", "niższym", "niższymi", "ostatni", "ostatnia", "ostatnią", "ostatnich", "ostatnie", "ostatniego", "ostatniej", "ostatniemu", "ostatnim", "ostatnimi", "poprzedni", "poprzednia", "poprzednią", "poprzednich", "poprzednie", "poprzedniego", "poprzedniej", "poprzedniemu", "poprzednim", "poprzednimi", "sam", "sama", "samą", "same", "samego", "samej", "samemu", "sami", "samo", "samych", "samym", "samymi", "trudne", "trudnego", "trudniejsze", "trudnym", "więksi", "większa", "większą", "większe", "większego", "większej", "większemu", "większych", "większym", "większymi", "wielcy", "wielka", "wielką", "wielki", "wielkich", "wielkie", "wielkiego", "wielkiej", "wielkiemu", "wielkim", "wielkimi", "właściwa", "właściwą", "właściwe", "właściwego", "właściwej", "właściwemu", "właściwi", "właściwy", "właściwych", "właściwym", "właściwymi", "wysocy", "wysoka", "wysoką", "wysoki", "wysokich", "wysokie", "wysokiego", "wysokiej", "wysokiemu", "wysokim", "wysokimi", "wyżsi", "wyższa", "wyższą", "wyższe", "wyższego", "wyższej", "wyższemu", "wyższy", "wyższych", "wyższym", "wyższymi", "kolejne", "różne", "złe", "kolejnych", "różnych", "złych", "kolejnego", "kolejnej", "kolejny", "kolejnym", "różnego", "różnej", "różny", "różnym", "złego", "złej", "zły", "złym", "kolejna", "kolejną", "kolejnemu", "kolejni", "kolejnymi", "różna", "różną", "różnemu", "różni", "różnymi", "zła", "złą", "złemu", "źli", "złymi"];

const generalAdverbs$1 = ["blisko", "bliżej", "ciągle", "ciężko", "czasami", "czasem", "częściej", "często", "dalej", "daleko", "dawniej", "dawno", "dobrze", "dopiero", "fajnie", "fajniej", "gorzej", "inaczej", "ładnie", "łatwiej", "łatwo", "lepiej", "najbliżej", "najczęściej", "najdalej", "najdawniej", "najfajniej", "najgorzej", "najłatwiej", "najlepiej", "najniżej", "najpóźniej", "najprościej", "najszybciej", "najtrudniej", "najwcześniej", "najwyżej", "naprawdę", "niedaleko", "niedawno", "nisko", "niżej", "ostatnio", "pewno", "póżniej", "późno", "prawie", "prościej", "prosto", "prostu", "szybciej", "szybko", "trochę", "trudniej", "trudno", "wcześnie", "wcześniej", "wolno", "wszędzie", "wysoko", "wyżej", "zazwyczaj", "źle", "jedynie", "obecnie", "teraz", "szczególnie", "zwykle"];

const timeWords$8 = ["dni", "dnia", "dniach", "dniami", "dnie", "dzień", "dzisiaj", "godzin", "godzina", "godzinach", "godzinami", "godzinę", "godziny", "jutro", "lata", "latach", "latami", "miesiąc", "miesiąca", "miesiącach", "miesiącami", "miesiące", "miesiącem", "miesiącu", "miesięcy", "minut", "minuta", "minutach", "minutę", "minuty", "pojutrze", "przedwczoraj", "rok", "rokiem", "roku", "sekund", "sekunda", "sekundach", "sekundę", "sekundy", "tydzień", "tygodni", "tygodnia", "tygodniach", "tygodniami", "tygodnie", "tygodniu", "wczoraj"];

const vagueNouns$8 = ["chwila", "chwilą", "chwilach", "chwilami", "chwile", "chwilę", "chwili", "chwilom", "część", "części", "częścią", "częściach", "częściami", "częściom", "momencie", "moment", "ogóle", "osób", "osoba", "osobą", "osobach", "osobami", "osobę", "osobie", "osobom", "osoby", "powód", "powodach", "powodami", "powodem", "powodom", "powodów", "powodowi", "powodu", "powody", "powodzie", "przypadkiem", "przypadku", "raz", "razach", "razami", "razem", "razie", "razom", "razów", "razowi", "razu", "razy", "rodzaj", "rodzajach", "rodzajami", "rodzajem", "rodzajom", "rodzajów", "rodzajowi", "rodzaju", "rzecz", "rzeczą", "rzeczach", "rzeczami", "rzeczom", "rzeczy", "sposób", "sposobem", "sprawa", "sprawą", "sprawach", "sprawami", "sprawę", "sprawie", "sprawom", "sprawy", "temacie", "temat", "tematach", "tematami", "tematem", "tematom", "tematów", "tematowi", "tematu", "tematy"];

const titles$1 = ["dr", "dyr", "mgr", "p", "pan", "pani", "panie", "panowie", "prof", "hab"];

const interjections$8 = ["a", "ach", "aha", "aj", "akurat", "ał", "aua", "auć", "ba", "brawo", "e", "ech", "ehe", "ehm", "ej", "ejże", "ekhm", "ekstra", "jej", "jejku", "łał", "och", "oh", "oho", "oj", "ojej", "ojejku", "phi", "precz", "super", "uwaga", "wow"];

const measurementUnits = ["°C", "°F", "ar", "ary", "arów", "arach", "c", "cl", "cm", "cm²", "cm³", "dag", "deka", "dl", "f", "ft", "g", "gram", "gramów", "gramy", "ha", "hektar", "hektary", "hektarów", "hektarach", "in", "kg", "kilo", "km", "km²", "cm³", "l", "litr", "litrów", "litry", "łyżeczka", "łyżeczkę", "łyżeczki", "łyżka", "łyżkę", "łyżki", "m", "m²", "m³", "mg", "ml", "mm", "mm²", "mm³", "szczypta", "szczyptę", "szczypty", "szklanka", "szklankę", "szklanki", "tuzin"];

const miscellaneous$7 = ["nie", "no", "oto", "tak", "sobie", "ok", "okej", "itp", "itd", "tzw"];

var functionWords$7 = {};

/** @module config/transitionWords */

const singleWords$6 = ["alltså", "ändå", "annars", "ännu", "även", "avslutningsvis", "bl.a.", "d.v.s.", "då", "därav", "därefter", "däremot", "därför", "därmed", "därpå", "dessutom", "dock", "efteråt", "eftersom", "emellertid", "enligt", "exempelvis", "fastän", "följaktligen", "förrän", "först", "förutom", "huvudsakligen", "ifall", "inledningsvis", "innan", "jämförelsevis", "likadant", "likaså", "liksom", "medan", "men", "nämligen", "när", "oavsett", "också", "omvänt", "säkerligen", "således", "sålunda", "sammanfattningsvis", "sammantaget", "samt", "samtidigt", "särskilt", "såsom", "sist", "slutligen", "speciellt", "t.ex.", "tidigare", "tillika", "tills", "trots", "tvärtemot", "tvärtom", "tydligen", "varpå", "vidare", "uppenbarligen", "ytterligare"];

const multipleWords$6 = ["å andra sidan", "å ena sidan", "allt som allt", "anledningen är", "anledningen blir", "annorlunda än", "av den orsaken", "av detta skäl", "beroende på", "bland annat", "därtill kommer", "det beror på att", "det vill säga", "det visar", "detta beror på", "detta går ut på att", "detta innebär att", "detta leder till", "detta medför att", "effekten blir", "efter ett tag", "ej heller", "en effekt av detta", "en förklaring till detta", "ett exempel på detta", "ett liknande exempel", "exakt som", "följden blir", "för att avrunda", "för all del", "för att förklara", "för att inte säga", "för att inte tala om", "för att klargöra", "för att poängtera", "för att säga det på ett annat sätt", "för att sammanfatta", "för att understryka", "för att visa", "för det andra", "för det första", "för det tredje", "förr eller senare", "för närvarande", "framför allt", "fram till nu", "har att göra med", "härav följer", "i båda fallen", "i det fallet", "i det hela", "i det här fallet", "i det långa loppet", "i enlighet med", "i förhållande till", "i fråga om", "i jämförelse med", "i kontrast till", "i likhet med", "i ljuset av", "i motsats till", "i och med", "i relation till", "i samband med", "i sin tur", "i själva verket", "i slutändan", "i stället för", "i syfte att", "i synnerhet", "i verkligheten", "icke desto mindre", "ihop med", "inte desto mindre", "jämfört med", "kan sammanfattas", "kort sagt", "konsekvensen av detta", "lika viktigt är", "målet är att", "med andra ord", "med anledning av", "med det i åtanke", "med det i tankarna", "med ett ord", "med hänsyn till", "med härledning av", "mot bakgrund av", "mot den bakgrunden", "när allt kommer omkring", "när det gäller", "närmare bestämt", "nu när", "orsaken är", "på det sättet", "på grund av", "på liknande sätt", "på så sätt", "på samma sätt", "resultatet blir", "så länge som", "så småningom", "så snart som", "sist men inte minst", "slutsatsen blir", "som antytt", "som en följd av", "som en konsekvens av", "som ett exempel på", "som ett resultat", "som jag tidigare antytt", "som konklusion kan", "som man kan se", "som nämnt", "som tidigare nämnts", "summa summarum", "tack vare", "till att börja med", "till dess", "till exempel", "till en början", "till följd av", "till sist", "till skillnad från", "till slut", "till största delen", "tillsammans med", "tvärt om", "under de omständigheterna", "under omständigheterna", "under tiden", "vad mera är", "viktigt att inse", "vilket innebär"];

/**
 * Returns an list with transition words to be used by the assessments.
 * @returns {Object} The list filled with transition word lists.
 */
var transitionWords$a = function () {
	return {
		singleWords: singleWords$6,
		multipleWords: multipleWords$6,
		allWords: singleWords$6.concat(multipleWords$6)
	};
};

Object.defineProperty(functionWords$7, "__esModule", {
	value: true
});

functionWords$7.default = function () {
	return {
		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(ordinalNumerals$7, generalAdjectives, generalAdverbs, auxiliariesInfinitive, delexicalizedVerbsInfinitive, copulaInfinitive, interviewVerbsInfinitive),

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(articles$5, prepositions$6, coordinatingConjunctions$2, demonstrativePronouns$3, intensifiers$7, quantifiers$7, possessivePronouns$1),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(transitionWords$9, personalPronounsNominative$2, personalPronounsObjective, reflexivePronouns$7, relativePronouns$1, interjections$7, cardinalNumerals$7, copula$2, auxiliaries$9, interviewVerbs$7, delexicalizedVerbs$2, indefinitePronouns$7, otherPronouns, subordinatingConjunctions$2, interrogativePronouns$2, interrogativeProAdverbs$1, miscellaneous$6, pronominalAdverbs, recipeWords$7, timeWords$7, titles, vagueNouns$7),

		// This export contains all of the above words.
		all: [].concat(articles$5, cardinalNumerals$7, ordinalNumerals$7, personalPronounsNominative$2, personalPronounsObjective, reflexivePronouns$7, possessivePronouns$1, demonstrativePronouns$3, relativePronouns$1, interrogativePronouns$2, interrogativeProAdverbs$1, indefinitePronouns$7, otherPronouns, quantifiers$7, pronominalAdverbs, auxiliaries$9, auxiliariesInfinitive, copula$2, copulaInfinitive, delexicalizedVerbs$2, delexicalizedVerbsInfinitive, interviewVerbs$7, interviewVerbsInfinitive, generalAdjectives, generalAdverbs, vagueNouns$7, prepositions$6, intensifiers$7, coordinatingConjunctions$2, subordinatingConjunctions$2, timeWords$7, titles, interjections$7, recipeWords$7, miscellaneous$6)
	};
};

var _transitionWords$2 = transitionWords$a;

var _transitionWords2$2 = _interopRequireDefault$2O(_transitionWords$2);

function _interopRequireDefault$2O(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const transitionWords$9 = (0, _transitionWords2$2.default)().singleWords;

/**
 * Returns an object with exceptions for the prominent words researcher
 * @returns {Object} The object filled with exception arrays.
 */

const articles$5 = ["en", "ett", "det", "den", "de"];

const cardinalNumerals$7 = ["två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "tiotals", "elva", "tolv", "tretton", "fjorton", "femton", "sexton", "sjutton", "arton", "aderton", "nitton", "tjugo", "hundra", "hundratals", "tusen", "tusentals", "miljon", "miljoner", "miljontals", "miljard", "miljarder"];

const ordinalNumerals$7 = ["första", "andra", "tredje", "fjärde", "femte", "sjätte", "sjunde", "åttonde", "nionde", "tionde", "elfte", "tolfte", "trettonde", "fjortonde", "femtonde", "sextonde", "sjuttonde", "artonde", "nittonde", "tjugonde"];

const personalPronounsNominative$2 = ["jag", "du", "han", "hon", "hen", "vi", "ni"];

const personalPronounsObjective = ["mig", "dig", "honom", "henne", "oss", "er", "dem", "henom", "eder"];

const reflexivePronouns$7 = ["sig", "sin", "sitt", "sina"];

const possessivePronouns$1 = ["min", "mitt", "mina", "din", "ditt", "dina", "hans", "hennes", "dess", "ens", "vår", "vårt", "våra", "er", "ert", "era", "ers", "deras", "hens"];

const demonstrativePronouns$3 = ["denne", "denna", "detta", "dessa", "här", "där", "varifrån", "därav", "hit", "dit", "vart", "hädan", "dädan", "vadan", "hän", "sen"];

const relativePronouns$1 = ["som", "vilken", "vilket", "vilka", "vars", "då"];

const interrogativePronouns$2 = ["vem", "vems", "vad"];

const interrogativeProAdverbs$1 = ["hur", "varför"];

const indefinitePronouns$7 = ["någon", "något", "några", "nån", "nåt", "ingen", "inget", "inga", "annan", "annat", "andra", "någonstans", "ingenstans", "annastans", "överallt", "någonstädes", "ingenstädes", "annorstädes", "allestädes", "någorlunda", "ingalunda", "annorlunda", "någonting", "ingenting", "allting", "all", "allt", "alla", "somlig", "somligt", "somliga", "mången", "månget", "man", "en", "ens"];

const otherPronouns = ["varandra", "varsin", "varsitt", "envar", "varannan", "vartannat"];

const quantifiers$7 = ["andra", "åtskilliga", "bådadera", "både", "få", "fårre", "fåtalig", "fåtaliga", "flera", "flesta", "föga", "ganska", "icke", "inte", "lite", "litet", "många", "mer", "mera", "mest", "mindre", "minst", "mycket", "nog", "ollika", "tillräckligt", "vardera", "varje", "viss", "visst", "vissa", "visse"];

const pronominalAdverbs = ["bakåt", "bakifrån", "bortifrån", "däråt", "därav", "därhän", "däri", "därifrån", "därom", "därpå", "därtill", "däruti", "därvid", "ditåt", "dithän", "dittills", "efteråt", "förrut", "framåt", "hädenefter", "häråt", "härav", "härefter", "häremot", "häri", "härifrån", "härmed", "härom", "härpå", "härtill", "häruti", "härvid", "hitåt", "hittills", "ini", "inifrån", "intill", "inuti", "nedanför", "nedåt", "nedför", "nedtill", "uppåt", "uppför", "upptill", "varav", "varefter", "varemot", "varför", "varfrån", "vari", "varifrån", "varmed", "varom", "varpå", "varthän", "vartill", "varur", "varvid"];

const auxiliaries$9 = ["behövande", "behöver", "behövt", "behövde", "bör", "börande", "borde", "bort", "brukade", "brukande", "brukar", "brukat", "fående", "får", "fått", "fick", "hade", "haft", "har", "hava", "havande", "kan", "kunde", "kunnande", "kunnat", "mådde", "mående", "mår", "måste", "mått", "måtte", "skall", "skulle", "varande", "velat", "viljande", "vill", "ville"];

const auxiliariesInfinitive = ["behöva", "böra", "bruka", "få", "ha", "kunna", "må", "ska", "vilja"];

const copula$2 = ["är", "var", "varit", "vore", "blivit", "blivande", "blir", "bliver", "blev", "blitt", "funnits", "finnande", "finns", "fanns", "befunnit", "befinnande", "befinner", "befann", "tyckts", "tyckande", "tycks", "tycktes"];

const copulaInfinitive = ["vara", "bli", "finnas", "befinna", "tyckas"];

const delexicalizedVerbs$2 = ["gående", "gällande", "gällde", "gäller", "gällt", "går", "gått", "gav", "ger", "gett", "gick", "givande", "giver", "gjorde", "gjort", "gör", "görande", "kom", "kommande", "kommer", "kommit", "ligger", "ligges", "lå", "ligget", "liggande", "ställer", "ställde", "ställt", "ställ", "ställande", "ställd", "ställas", "ställs", "ställes", "ställdes", "ställts", "tagande", "tager", "tagit", "tar", "tog", "utgör", "utgjorde", "utgjort", "utgörande", "utgjord", "utgöras", "utgörs", "utgöres", "utgjordes", "utgjorts"];

const delexicalizedVerbsInfinitive = ["gå", "gälla", "ge", "göra", "komma", "ligga", "ställa", "ta", "utgöra"];

const interviewVerbs$7 = ["angav", "anger", "angett", "angiver", "angivit", "berättade", "berättar", "berättat", "föreslagit", "föreslår", "föreslått", "föreslog", "förklarade", "förklarar", "förklarat", "förstår", "förstått", "förstod", "frågade", "frågar", "frågat", "påstår", "påstått", "påstod", "sa", "sade", "säger", "sagt", "svarade", "svarar", "svarat", "talade", "talar", "talat", "tänker", "tänkt", "tänkte"];

const interviewVerbsInfinitive = ["ange", "berätta", "föreslå", "förklara", "förstå", "fråga", "påstå", "säga", "svara", "tala", "tänka"];

const generalAdjectives = ["äldre", "äldst", "äldsta", "äldste", "bäst", "bättre", "dålig", "dåliga", "dålige", "dåligt", "egen", "eget", "egna", "egne", "enkel", "enkelt", "enkla", "enklare", "enklast", "enklaste", "enkle", "fel", "gamla", "gamle", "gammal", "gammalt", "god", "goda", "godare", "godast", "godaste", "gode", "gott", "grundläggande", "hel", "hela", "helare", "helast", "helaste", "hele", "helt", "kort", "korta", "kortare", "kortast", "kortaste", "korte", "lång", "långa", "långe", "längre", "långsam", "långsamma", "långsammare", "långsammast", "långsammaste", "långsamme", "långsamt", "längst", "längsta", "längste", "långt", "liknande", "lilla", "lille", "liten", "litet", "mindre", "minst", "minsta", "minste", "möjlig", "möjliga", "möjligare", "möjligast", "möjligaste", "möjlige", "möjligt", "nödvändig", "nödvändiga", "nödvändigare", "nödvändigast", "nödvändigaste", "nödvändige", "nödvändigt", "normal", "normala", "normalare", "normalast", "normalaste", "normale", "normalt", "ny", "nya", "nyare", "nyast", "nyaste", "nye", "nytt", "olikt", "olika", "olike", "samma", "sämre", "sämst", "sämsta", "sämste", "särskild", "särskilda", "särskilde", "särskilt", "sen", "sena", "senare", "senast", "senaste", "sene", "sent", "små", "snabb", "snabba", "snabbare", "snabbast", "snabbaste", "snabbe", "snabbt", "stor", "stora", "store", "större", "störst", "största", "störste", "stort", "svår", "svåra", "svårare", "svårast", "svåraste", "svåre", "svårt", "tidig", "tidiga", "tidigare", "tidigast", "tidigaste", "tidige", "tidigt", "trevlig", "trevliga", "trevligare", "trevligast", "trevligaste", "trevlige", "trevligt", "ung", "unga", "unge", "ungt", "uppenbar", "uppenbara", "uppenbare", "uppenbart", "värre", "värst", "värsta", "värste", "verklig", "viktig", "viktiga", "viktigare", "viktigast", "viktigaste", "viktige", "viktigt", "yngre", "yngst", "yngsta", "yngste"];

const generalAdverbs = ["aldrig", "allmänt", "alltid", "delvis", "direkt", "huvudsakligen", "ibland", "långsamt", "mestadels", "nästan", "ofta", "relativt", "riktigt", "riktigare", "riktigast", "sällan", "snabbt", "ständigt", "väl", "vanligt"];

const vagueNouns$7 = ["antal", "antalet", "antals", "antalets", "antalen", "antalens", "bit", "bitar", "bitarna", "bitarnas", "bitars", "biten", "bitens", "bits", "del", "delar", "delarna", "delarnas", "delars", "delen", "delens", "dels", "detalj", "detaljen", "detaljens", "detaljer", "detaljerna", "detaljernas", "detaljers", "detaljs", "exempel", "exempels", "exemplet", "exemplets", "exemplen", "exemplens", "person", "personen", "personens", "personer", "personerna", "personernas", "personers", "persons", "procent", "punkt", "punkten", "punktens", "punkter", "punkterna", "punkternas", "punkters", "sak", "saken", "sakens", "saker", "sakerna", "sakernas", "sakers", "saks", "sätt", "sätten", "sättens", "sättet", "sättets", "sätts", "skillnad", "skillnaden", "skillnadens", "skillnader", "skillnaderna", "skillnadernas", "skillnaders", "skillnads", "sort", "sorten", "sortens", "sorter", "sorterna", "sorternas", "sorters", "sorts", "tema", "teman", "temanas", "temans", "temas", "temat", "temats", "tid", "tiden", "tidens", "tider", "tiderna", "tidernas", "tiders", "tids", "ting", "tingen", "tingens", "tinget", "tingets", "tings"];

const prepositions$6 = ["åt", "av", "bakom", "bland", "bortom", "bredvid", "cirka", "efter", "emellan", "emot", "enligt", "för", "före", "förutom", "framför", "från", "genom", "hos", "i", "igenom", "inom", "inuti", "längs", "med", "mellan", "mittemot", "mot", "nära", "nästa", "nedan", "ner", "olik", "om", "omkring", "ovanför", "ovanpå", "över", "på", "runt", "sedan", "som", "till", "tvärs", "tvärsöver", "under", "upp", "ur", "ut", "utan", "utanför", "utom", "via", "vid"];

const intensifiers$7 = ["absolut", "alldeles", "allra", "bra", "fullständigt", "fullt", "ganska", "helt", "illa", "jätte", "rysligt", "så", "storligen", "totalt", "väldigt", "ytterst"];

const coordinatingConjunctions$2 = ["eller", "och"];

const subordinatingConjunctions$2 = ["att"];

const timeWords$7 = ["år", "årens", "året", "årets", "års", "årtal", "årtalen", "årtalens", "årtaconst", "årtaconsts", "årtals", "dag", "dagar", "dagarna", "dagarnas", "dagars", "dagen", "dagens", "dags", "går", "idag", "månad", "månaden", "månadens", "månader", "månaderna", "månadernas", "månaders", "månads", "minut", "minuten", "minutens", "minuter", "minuterna", "minuternas", "minuters", "minuts", "morgon", "sekund", "sekunden", "sekundens", "sekunder", "sekunderna", "sekundernas", "sekunders", "sekunds", "timmar", "timmarna", "timmarnas", "timmars", "timme", "timmen", "timmens", "timmes", "vecka", "veckan", "veckans", "veckas", "veckor", "veckorna", "veckornas", "veckors"];

const titles = ["prof", "doc", "dr"];

const interjections$7 = ["å", "aj", "aja", "fy", "grattis", "hej", "hu", "jaså", "javisst", "o", "oj", "ojdå", "prosit", "puh", "skål", "usch"];

const recipeWords$7 = ["c", "cl", "cm", "dl", "g", "kg", "km", "krm", "l", "m", "mg", "ml", "mm", "msk", "pkt", "st", "tsk"];

const miscellaneous$6 = ["förlåt", "ja", "jo", "ju", "m.m", "nej", "ok", "okej", "tack"];

var functionWords$6 = {};

Object.defineProperty(functionWords$6, "__esModule", {
	value: true
});

functionWords$6.default = function () {
	return {
		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(otherParticles),
		// These word categories are filtered at the ending of word combinations.
		filteredAtBeginning: [].concat(ordinalNumerals$6, classifiers),

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(articles$4, coordinatingConjunctions$1, demonstrativePronouns$2, intensifiers$6, possessivePronouns, pronounSubstitutes),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(adverbialGenitives$1, personalPronounsNominative$1, reflexivePronouns$6, interjections$6, cardinalNumerals$6, auxiliaries$8, copula$1, interviewVerbs$6, delexicalizedVerbs$1, indefinitePronouns$6, correlativeConjunctions, subordinatingConjunctions$1, interrogativeDeterminers$1, interrogativePronouns$1, interrogativeAdverbs, otherAdverbs, miscellaneous$5, locativeAdverbs$1, recipeWords$6, timeWords$6, vagueNouns$6, generalAdjectivesAndAdverbs, relativePronoun, prepositions$5, quantifiers$6),

		// This export contains all of the above words.
		all: [].concat(articles$4, cardinalNumerals$6, ordinalNumerals$6, demonstrativePronouns$2, possessivePronouns, reflexivePronouns$6, personalPronounsNominative$1, quantifiers$6, indefinitePronouns$6, interrogativeDeterminers$1, interrogativePronouns$1, interrogativeAdverbs, locativeAdverbs$1, adverbialGenitives$1, auxiliaries$8, copula$1, prepositions$5, coordinatingConjunctions$1, correlativeConjunctions, subordinatingConjunctions$1, interviewVerbs$6, additionalTransitionWords$1, intensifiers$6, delexicalizedVerbs$1, interjections$6, generalAdjectivesAndAdverbs, recipeWords$6, vagueNouns$6, miscellaneous$5, titlesPreceding$1, relativePronoun)
	};
};

/**
 * Returns an object with exceptions for the prominent words researcher
 * @returns {Object} The object filled with exception arrays.
 */

const articles$4 = ["si", "sang", "kaum", "sri", "hang", "dang", "para"];
const cardinalNumerals$6 = ["nol", "satu", "dua", "tiga", "empat", "lima", "enam", "tujuh", "delapan", "sembilan", "sepuluh", "sebelas", "seratus", "seribu", "sejuta", "semiliar", "setriliun"];

const ordinalNumerals$6 = ["kesatu", "pertama", "kedua", "ketiga", "keempat", "kelima", "keenam", "ketujuh", "kedelapan", "kesembilan", "kesepuluh", "kesebelas", "keseratus", "keseribu"];

const otherParticles = ["lah", "pun", "dong", "kan", "sih", "toh", "nah", "lho", "kok", "ding"];

const classifiers = ["sebuah", "seorang", "seekor", "sebiji", "selembar", "secarik", "sehelai", "sebutir", "sebatang", "sebidang", "sebentuk", "sebilah", "sekuntum", "sepatah", "sepucuk", "setangkai", "seutas", "sebelah", "segenggam", "segugus", "sepiring", "sejenis", "semacam", "sepotong", "setetes", "suatu"];

const personalPronounsNominative$1 = ["aku", "saya", "engkau", "kau", "kamu", "anda", "kita", "kami", "kalian", "ia", "dia", "beliau", "mereka", "dikau", "daku", "beta", "sayalah", "engkaulah", "kaulah", "kamulah", "andalah", "kitalah", "kamilah", "kalianlah", "dialah", "kamu-kamu", "saya-saya", "mereka-mereka", "beliau-beliau", "anda-anda", "mereka-merekalah", "beliau-beliaulah", "kamu-kamulah", "anda-andalah"];

const relativePronoun = ["yang"];

const demonstrativePronouns$2 = ["ini", "itu", "tersebut", "tadi", "inilah", "itulah"];

const possessivePronouns = ["milikku", "milikmu", "miliknya", "punyanya", "punyaku", "punyamu", "kepunyaannya", "kepunyaanmu", "kepunyaanku"];

const pronounSubstitutes = ["bu", "pak", "bang", "nak", "kak", "dik"];

const quantifiers$6 = ["belasan", "puluhan", "ribuan", "miliaran", "triliunan", "setengah", "seperdua", "sepertiga", "seperempat", "seperlima", "seperenam", "sepertujuh", "seperdelapan", "sepersembilan", "sepersepuluh", "sedikit", "setiap", "banyak", "semua", "lebih", "kurang", "sebagian", "cukup", "beberapa", "berpuluh-puluh", "beratus-ratus", "beribu-ribu", "berjuta-juta", "ratusan", "paling", "tiap-tiap"];

const reflexivePronouns$6 = ["diriku", "dirinya", "dirimu"];

const indefinitePronouns$6 = ["lain", "lainnya", "seseorang", "sesuatu", "siapa-siapa", "apa-apa", "semuanya", "segalanya", "seluruhnya", "keduanya", "ketiganya", "ketiga-tiganya", "kedua-duanya", "dua-duanya", "tiga-tiganya", "masing-masing", "apapun", "siapapun", "manapun", "sedemikian", "demikian"];

const interrogativeDeterminers$1 = ["apa", "manakah", "mana", "apanya", "inikah", "itukah", "manalagi"];

const interrogativePronouns$1 = ["siapa", "siapakah", "kamukah", "andakah", "sayakah", "akukah", "diakah", "merekakah", "engkaukah", "kamikah", "kitakah", "beliaukah", "iakah", "dirinyakah", "dirikukah", "siapatah", "siapalah", "siapanya"];

const interrogativeAdverbs = ["bagaimana", "mengapa", "kenapa", "kapan", "berapa", "kapankah", "berapakah", "bagaimanakah", "apakah", "kapanpun", "apatah", "apalah", "berapatah", "berapalah", "mengapakah", "mengapatah", "mengapalah", "kenapakah", "kenapatah", "kenapalah", "kapantah", "kapanlah", "manatah", "mananya", "manalah", "bagaimanatah", "bagaimanalah", "bilamana", "bilamanakah", "bilamanatah", "bilamananya", "bilamanalah", "keberapa", "mampukah", "beginikah", "begitukah"];

const adverbialGenitives$1 = ["selalu", "sekali", "berkali-kali"];

const auxiliaries$8 = ["dapat", "dapatkah", "bisa", "bisakah", "boleh", "bolehkah", "akan", "akankah", "bukan", "dapatlah", "bisatah", "bisanya", "bisalah", "bolehtah", "bolehnya", "bolehlah", "akantah", "akannya", "akanlah", "harus", "haruskah", "harustah", "harusnya", "haruslah", "bukankah", "bukantah", "bukannya", "bukanlah", "mungkin", "mungkinkah", "mungkintah", "mungkinlah", "belum", "belumkah", "belumlah", "sudah", "sudahkah", "sudahlah", "takkan", "masih", "masihkah", "pernah", "pernahkah"];

const copula$1 = ["adalah", "ialah", "merupakan", "ada", "berada"];

const prepositions$5 = ["antara", "seantero", "bagai", "bagaikan", "bagi", "buat", "dari", "demi", "dengan", "di", "terhadap", "menjelang", "ke", "kecuali", "sekeliling", "mengenai", "sekitar", "melalui", "selama", "lepas", "lewat", "oleh", "selewat", "pada", "sepanjang", "per", "seputar", "bersama", "sejak", "semenjak", "seperti", "serta", "tentang", "menuju", "menurut", "untuk", "tanpa", "adapun", "antar", "diantara", "silam", "lalu", "selaku", "melalui", "sebagai", "bahwasanya"];

// These prepositional adverbs are all preceded by locative preposition "di", e.g. "di atas".
const locativeAdverbs$1 = ["atas", "bawah", "dalam", "luar", "depan", "belakang", "sebelah", "samping"];

const coordinatingConjunctions$1 = ["dan", "atau", "lalu", "kemudian", "serta", "sedangkan", "sementara", "sambil", "seraya", "ataupun", "ataukah"];

const correlativeConjunctions = ["maupun", "bukan", "begitu", "baru", "hanya"];

const subordinatingConjunctions$1 = ["setelah", "sehabis", "sejak", "sampai", "ketika", "waktu", "tatkala", "saat", "kalau", "jika", "jikalau", "bila", "bilamana", "apabila", "asal", "asalkan", "seandainya", "andaikata", "sekiranya", "karena", "sebab", "lantaran", "gara-gara", "mentang-mentang", "kalau-kalau", "supaya", "agar", "guna", "sehingga", "hingga", "sampai", "sebelum", "sesudah", "meski", "meskipun", "kendati", "kendatipun", "walau", "walaupun", "sekalipun", "biarpun", "sungguhpun", "padahal", "seakan-akan", "seolah-olah", "daripada", "alih-alih", "melainkan", "apalagi", "bahwa", "saja"];

const interviewVerbs$6 = ["kata", "bilang", "berkata", "mengeklaim", "bertanya", "menayakan", "menyatakan", "tanya", "klaim", "jelas", "jelaskan", "menjelaskan", "dijelaskan", "ditanya", "pikir", "berpikir", "berbicara", "membicarakan", "mengumumkan", "diumumkan", "dibicarakan", "mendiskusikan", "menyarankan", "disarankan", "mengerti"];

const additionalTransitionWords$1 = ["yakni", "yaitu", "artinya", "awalnya", "akhirnya", "makanya", "malahan", "malah", "memang", "nantinya", "nanti", "pula", "seketika", "sekarang", "benar-benar", "kadang", "justru", "tetapi", "tapi"];

const intensifiers$6 = ["sangat", "amat", "terlalu", "terlampau", "sungguh", "serba", "agak", "begitu", "demikian", "makin", "semakin", "kian", "tambah", "bertambah", "begini", "amatlah"];

const delexicalizedVerbs$1 = ["ada", "punya", "milik", "terlihat", "kelihatan", "mari", "marilah", "membuat", "dibuat", "menunjukkan", "ditunjukkan", "pergi", "ambil", "diambil", "meletkakkan", "letakkan", "ambilkan", "mencoba", "dicoba", "bermakna", "berarti", "terdiri", "memastikan", "dipastikan", "mengandung", "termasuk", "maknanya", "artinya", "ingin", "inginkan"];

// These adjectives and adverbs are so general, they should never be suggested as a (single) keyword.
// Keyword combinations containing these adjectives/adverbs are fine.
const generalAdjectivesAndAdverbs = ["terbesar", "besar", "terkecil", "kecil", "terbaru", "baru", "tertua", "tua", "lalu", "semudah", "termudah", "mudah", "cepat", "jauh", "susah", "keras", "panjang", "rendah", "pendek", "tinggi", "biasa", "simpel", "kebanyakan", "baru-baru", "lagi", "selesai", "mungkin", "umum", "baik", "buruk", "bagus", "utama", "sama", "tertentu", "biasanya", "spesifik", "langsung", "dekat", "terbaru", "berbeda", "beda", "sibuk", "terkini", "penting", "terpenting", "sebesar", "sekecil", "setua", "termuda", "semuda", "muda", "tercepat", "secepat", "termudah", "semudah", "terjauh", "sejauh", "tersusah", "sesusah", "terkeras", "sekeras", "sepanjang", "terpanjang", "terpendek", "sependek", "terbiasa", "tersimpel", "sesimpel", "terbaik", "sebaik", "terburuk", "seburuk", "sebagus", "terbagus", "terutama", "terdekat", "sedekat", "tersibuk", "sepenting", "lambat", "terlambat", "luas", "terluas", "seluas", "keren", "tersedia", "cepat-cepat", "erat-erat", "betul-betul", "diam-diam", "keras-keras", "jauh-jauh", "secepat-cepatnya", "baik-baik", "sebaik-baiknya", "sekeras-kerasnya", "lekas-lekas", "selekas-lekasnya", "tinggi-tinggi", "setinggi-tingginya", "seberat-beratnya", "sejauh-jauhnya", "sedikit-dikitnya", "sekurang-kurangnya", "setidak-tidaknya", "sedapat-dapatnya", "seenak-enaknya", "seenaknya", "seadanya", "sekenanya", "selambat-lambatnya", "selebih-lebihnya", "sedikitnya", "sepenuhnya", "besar-besaran", "kecil-kecilan", "habis-habisan", "mati-matian", "terang-terangan", "terus-terusan", "untung-untungan", "kesekian", "berdua-dua", "bertiga-tiga", "berdua", "bertiga", "berempat", "berlima", "berenam", "bertujuh", "berdelapan", "bersembilan", "bersepuluh", "bersebelas", "berseratus", "berseribu", "berduaan", "agaknya", "sepenting-pentingnya", "sepanjang-panjangnya", "spesifik", "spesial", "semuda-mudanya", "setua-tuanya", "seburuk-buruknya", "seluas-luasnya", "terlebih", "selamanya", "selama-lamanya", "mampu", "begini", "beginilah", "begitu", "begitulah", "sebegini", "sebegitu", "semula", "pasti", "pastilah", "pastinya", "dini", "sedini", "sering", "seringnya", "jarang", "terbanyak"];

// These adverbs are all preceded by a negative, i.e. tak, tidak, or belum. Example: tak puas-puasnya.
const otherAdverbs = ["putus-putusnya", "jemu-jemunya", "jera-jeranya", "puas-puasnya", "bosan-bosannya", "henti-hentinya", "berhenti-hentinya"];

const interjections$6 = ["bah", "cis", "ih", "idih", "sialan", "buset", "aduh", "waduh", "duh", "aduhai", "amboi", "asyik", "wah", "syukur", "alhamdulillah", "untung", "aduh", "aih", "aih", "lo", "duilah", "eh", "oh", "ah", "astaga", "astagfirullah", "masyaallah", "masa", "alamak", "gila", "ayo", "yuk", "mari", "hai", "he", "hai", "halo"];

// These words and abbreviations are frequently used in recipes in lists of ingredients.
const recipeWords$6 = ["sdm", "sdt", "gr", "kg", "cm", "mg", "ml", "l", "dl", "cl", "ons", "lbr", "cc", "bh", "ltr", "pon"];

const timeWords$6 = ["detik", "menit", "jam", "detik-detik", "menit-menit", "jam-jam", "hari", "hari-hari", "minggu", "minggu-minggu", "bulan", "bulan-bulan", "tahun", "tahun-tahun", "besok", "kemarin", "lusa", "malam-malam", "siang-siang", "subuh", "bedug", "keesokan"];

const vagueNouns$6 = ["cara", "barang", "masalah", "bagian", "bagian-bagian", "aspek", "aspek-aspek", "ide", "item", "tema", "hal", "perkara", "faktor", "faktor-faktor", "detil", "perbedaan", "adanya", "beginian", "rupanya", "diri"];

const miscellaneous$5 = ["tidak", "iya", "tak", "tentu", "ok", "oke", "amin", "dll", "maaf", "tolong", "mohon", "jangan", "sebagainya", "hanya", "cuma", "jangankan", "janganlah", "tolonglah"];

const titlesPreceding$1 = ["tuan", "nyonya", "nona", "bang", "pak", "bu", "bang", "kak", "prof", "gus", "ning", "kyai", "ustad", "ustadzah", "nyai", "raden", "tengku"];

var functionWords$5 = {};

Object.defineProperty(functionWords$5, "__esModule", {
	value: true
});

functionWords$5.default = function () {
	return {
		// This export contains all of the above words.
		all: [].concat(cardinalNumerals$5, ordinalNumerals$5, personalPronouns, demonstrativePronouns$1, interrogatives$4, quantifiers$5, reflexivePronouns$5, indefinitePronouns$5, prepositions$4, conjunctions$4, interviewVerbs$5, intensifiers$5, auxiliariesAndDelexicalizedVerbs$4, generalAdjectivesAdverbs$5, interjections$5, recipeWords$5, timeWords$5, vagueNouns$5, miscellaneous$4)
	};
};

/**
 * Returns an object with function words.
 *
 * @returns {Object} The object filled with various categories of function word arrays..
 */

const cardinalNumerals$5 = [
// 1-10
"אחת", "אחד", "שתים", "שנים", "שתיים", "שלש", "שלשה", "ארבע", "ארבעה", "חמש", "חמשה", "שש", "ששה", "שבע", "שבעה", "שמונה", "שמונה", "תשע", "תשעה", "עשר", "עשרה",
// 20
"עשרים",
// 100
"מאה",
// 1000
"אלף",
// Million
"מיליון",
// Billion
"מילירד"];

const ordinalNumerals$5 = [
// Ordinals for 1-10; for higher humbers ordinal numerals are the same as the cardinals.
"ראשון", "ראשונה", "שני", "שניה", "שלישי", "שלישית", "רביעי", "רביעית", "חמישי", "חמישית", "ששי", "ששית", "שביעי", "שביעית", "שמיני", "שמינית", "תשיעי", "תשיעית", "עשירי", "עשירית"];

const personalPronouns = ["אני‎", "אנחנו‎", "אנו‎", "אתה‎", "את‎", "אתם‎", "אתן‎", "הוא‎", "היא‎", "הם‎", "הן‎",
// Personal pronouns - prefixed forms
"שאני", "שאתה", "שהוא", "ואני", "שהיא"];

const demonstrativePronouns$1 = [
// Demonstrative pronoun "ze"
"זה", "זאת", "זו", "ההוא", "ההיא", "איזה", "איזו", "אלה", "אלו", "ההם", "ההן", "אילו", "לזה",
// Demonstrative pronoun "ze" - prefixed forms
"הזה", "שזה"];

const interrogatives$4 = [
// What
"מה",
// Who
"מי",
// Why
"למה",
// How much/many
"כמה",
// Particle for y/n questions
"האם",
// Where
"איפה",
// Which
"איזה", "איזו", "אילו",
// When
"מתי", "כאשר",
// How
"איך",
// If
"אי",
// Unless
"אלמלא"];

const quantifiers$5 = [
// All
"כולם", "כול",
// Most
"רוב",
// Part
"חלק",
// Less
"פחות",
// Few, little
"מעט",
// Many, much
"הרבה",
// Many, numerous
"רב", "רבה", "רבים", "רבות",
// At least
"לפחות"];

const reflexivePronouns$5 = ["עצמי", "לעצמי", "בעצמי", "עצמך", "לעצמך", "בעצמך", "עצמך", "לעצמך", "בעצמך", "עצמו", "עצמה", "עצמנו", "עצמכם", "עצמכן", "עצמם", "עצמן"];

const indefinitePronouns$5 = [
// Something
"משהו",
// Someone
"מישהו", "מישהי",
// Nothing
"כלום"];

const prepositions$4 = [
// Each paradigm is one preposition with different pronominal affixes and possibly prefixes
// Definite object preposition
"את", "אותי", "אותנו", "אותך", "אתכם", "אתכן", "אותו", "אותה", "אותם", "אותן", "שאת",
// Possessive preposition
"של", "שלי", "שלנו", "שלך", "שלכם", "שלכן", "שלו", "שלהם", "שלהן",
// To/for/of
"לי", "לך", "לו", "לה", "לנו", "לכם", "לכן", "להם", "להן",
// On/upon
"על", "עליי", "עלינו", "עליך", "עלייך", "עליכם", "עליכן", "עליו", "עליה", "עליהם", "עליהן", "גבי", "גבנו", "גבך", "גבה", "גבנו", "גבכם", "גבכן", "גבם", "גבן",
// To/towards/into
"אל", "אליי", "אלינו", "אליך", "אלייך", "אליכם", "אליכן", "אליו", "אליה", "אליהם", "אליהן", "ואל",
// With
"עם", "איתי", "עימי", "איתנו", "עימנו", "איתך", "עימך", "איתכם", "איתכן", "איתו", "איתה", "איתם", "עימם",
// As
"כמו", "כמוני", "כמונו", "כמוך", "כמוך", "כמוכם", "כמוכן", "כמוהו", "כמוה", "כמוהם", "כמוהן", "כמוכם", "כמוכן",
// Before
"לפני", "לפניי", "לפנינו", "לפניך", "לפנייך", "לפניו", "לפניה", "לפניכם", "לפניכן", "לפניהם", "לפניהן",
// In
"ובכן", "בן", "בי", "בנו", "בך", "בכם", "בכן", "בו", "בה", "בהם", "בהן",
// Because
"בגלל", "בגללי", "בגללנו", "בגללך", "בגללכם", "בגללכן", "בגללו", "בגללה", "בגללם", "בגללן",
// After
"אחר", "אחריי", "אחרינו", "אחריך", "אחרייך", "אחריכם", "אחריכן", "אחריו", "אחריה", "אחריהם", "אחריהן",
// For the sake of
"בשביל", "בשבילי", "בשבילנו", "בשבילך", "בשבילו", "בשבילה", "בשבילכם", "בשבילכן", "בשבילם", "בשבילן",
// Instead of
"במקום", "במקומי", "במקומנו", "במקומך", "במקומו", "במקומה", "במקומכם", "במקומכן", "במקומם", "במקומן",
// Until, up to
"עד",
// About
"אודות", "אודותי", "אודותנו", "אודותך", "אודותכם", "אודותכן", "אודותו", "אודותה", "אודותם", "אודותן",
// Behind
"מאחורי", "מאחוריי", "מאחורינו", "מאחוריך", "מאחורייך", "מאחוריכם", "מאחוריכן", "מאחוריו", "מאחוריה", "מאחוריהם", "מאחוריהן",
// At
"אצל", "אצלי", "אצלנו", "אצלך", "אצלך", "אצלכם", "אצלכן", "אצלו", "אצלה", "אצלם", "אצלן",
// By means of
"באמצעות", "באמצעותי", "באמצעותנו", "באמצעותך", "באמצעותכם", "באמצעותכן", "באמצעותו", "באמצעותה", "באמצעותם", "באמצעותן",
// Due to
"בזכות", "בזכותי", "בזכותנו", "בזכותך", "בזכותכם", "בזכותכן", "בזכותו", "בזכותה", "בזכותם", "בזכותן",
// Between
"ביני", "בינינו", "בינך", "ביניכם", "ביניכן", "בינו", "בינה", "ביניהם", "ביניהן",
// Without
"בלעדיי", "בלעדינו", "בלעדיך", "בלעדייך", "בלעדיכם", "בלעדיכן", "בלעדיו", "בלעדיה", "בלעדיהם", "בלעדיהן",
// In favor of
"בעד", "בעדי", "בעדנו", "בעדך", "בעדך", "בעדכם", "בעדכן", "בעדו", "בעדה", "בעדם", "בעדן",
// As a result of
"בעקבות", "בעקבי", "בעקביי", "בעקבינו", "בעקביך", "בעקבייך", "בעקביכם", "בעקביכן", "בעקביו", "בעקביה", "בעקביהם", "בעקביהן",
// Facing
"בפני", "בפניי", "בפנינו", "בפניך", "בפנייך", "בפניכם", "בפניכן", "בפניו", "בפניה", "בפניהם", "בפניהן",
// Among
"בקרב", "בקרבי", "בקרבנו", "בקרבך", "בקרבך", "בקרבכם", "בקרבכן", "בקרבו", "בקרבה", "בקרבם", "בקרבן",
// On behalf of
"בשם", "בשמי", "בשמנו", "בשמך", "בשמך", "בשמכם", "בשמכן", "בשמו", "בשמה", "בשמם", "בשמן",
// Inside
"בתוך", "בתוכי", "בתוכנו", "בתוכך", "בתוכך", "בתוככם", "בתוככן", "בתוכו", "בתוכה", "בתוכם", "בתוכן",
// As
"כמוני", "כמונו", "כמוך", "כמוך", "כמוכם", "כמוכן", "כמוהו", "כמוה", "כמוהם", "כמוהן",
// In relation
"כלפי", "כלפיי", "כלפינו", "כלפיך", "כלפייך", "כלפיכם", "כלפיכן", "כלפיו", "כלפיה", "כלפיהם", "כלפיהן",
// Against
"כנגד", "כנגדי", "כנגדנו", "כנגדך", "כנגדך", "כנגדכם", "כנגדכן", "כנגדו", "כנגדה", "כנגדם", "כנגדן",
// Along
"לאורך", "לאורכי", "לאורכנו", "לאורכך", "לאורכך", "לאורככם", "לאורככן", "לאורכו", "לאורכה", "לאורכם", "לאורכן",
// Regarding
"לגבי", "לגביי", "לגבינו", "לגביך", "לגבייך", "לגביכם", "לגביכן", "לגביו", "לגביה", "לגביהם", "לגביהן",
// According to
"לדברי", "לדבריי", "לדברינו", "לדבריך", "לדברייך", "לדבריכם", "לדבריכן", "לדבריו", "לדבריה", "לדבריהם", "לדבריהן",
// Near
"ליד", "לידי", "לידנו", "לידך", "לידך", "לידכם", "לידכן", "לידו", "לידה", "לידם", "לידן",
// For the sake of
"למען", "למעני", "למעננו", "למענך", "למענך", "למענכם", "למענכן", "למענו", "למענה", "למענם", "למענן",
// According to
"לפי", "לפי", "לפינו", "לפיך", "לפיך", "לפיכם", "לפיכן", "לפיו", "לפיהו", "לפיה", "לפיהם", "לפיהן",
// Towards
"לקראת", "לקראתי", "לקראתנו", "לקראתך", "לקראתך", "לקראתכם", "לקראתכן", "לקראתו", "לקראתה", "לקראתם", "לקראתן",
// Across
"לרוחב", "לרוחבי", "לרוחבנו", "לרוחבך", "לרוחבך", "לרוחבכם", "לרוחבכן", "לרוחבו", "לרוחבה", "לרוחבם", "לרוחבן",
// Opposite
"מול", "מולי", "מולנו", "מולך", "מולך", "מולכם", "מולכן", "מולו", "מולה", "מולם", "מולן",
// From
"מן", "ממני", "ממנו", "מאיתנו", "ממך", "ממך", "מכם", "מכן", "ממנו", "ממנה", "מהם", "מהן",
// Over
"מעל", "מעליי", "מעלינו", "מעליך", "מעלייך", "מעליכם", "מעליכן", "מעליו", "מעליה", "מעליהם", "מעליהן",
// From
"מפני", "מפניי", "מפנינו", "מפניך", "מפנייך", "מפניכם", "מפניכן", "מפניו", "מפניה", "מפניהם", "מפניהן",
// Below
"מתחת", "מתחתיי", "מתחתינו", "מתחתיך", "מתחתייך", "מתחתיכם", "מתחתיכן", "מתחתיו", "מתחתיה", "מתחתיהם", "מתחתם", "מתחתיהן", "מתחתן",
// For
"עבור", "עבורי", "עבורנו", "עבורך", "עבורכם", "עבורכן", "עבורו", "עבורה", "עבורם", "עבורן",
// Under
"תחת", "תחתיי", "תחתינו", "תחתיך", "תחתייך", "תחתיכם", "תחתיכן", "תחתיו", "תחתיה", "תחתיהם", "תחתם", "תחתיהן", "תחתן",
// Compared with
"לעומת", "לעומתי", "לעומתנו", "לעומתך", "לעומתך", "לעומתכם", "לעומתכן", "לעומתו", "לעומתה", "לעומתם", "לעומתן",
// Part of according to
"פי"];

const conjunctions$4 = [
// But
"אבל", "אך", "אלא",
// If
"אם",
// Then
"אז",
// Or
"או",
// In order to
"כדי",
// Because
"כי",
// Indeed
"אכן",
// By the way
"אגב",
// However
"אולם",
// Although
"אע״פ",
// Relative clause marker
"אשר",
// While
"בעוד",
// And/or
"ו/או",
// Since
"יען",
// Were it not for
"לולא",
// Unless
"פן"];

const interviewVerbs$5 = [
// Say
"אומר", "אומרת", "אומרים", "אומרות", "אמרתי", "אמרנו", "אמרת", "אמרתם", "אמרתן", "אמר", "אמרה", "אמרו", "נאמר", "תאמר", "תאמרי", "תאמרו", "תאמרנה", "יאמר", "תאמר", "תאמרנה", "יאמר", "יאמרו", "אמור", "אמרי", "אמורנה",
// Speak
"מדבר", "מדברת", "מדברים", "מדברות", "דיברתי", "דיברנו", "דיברת", "דיברתם", "דיברתן", "דיבר", "דיברה", "דיברו", "אדבר", "נדבר", "תדבר", "תדברי", "תדברו", "תדברנה", "ידבר", "ידברו", "דבר‏", "דברי‏", "דברו‏", "דברנה‏", "לדבר",
// Understand
"מבין", "מבינה", "מבינים", "מבינות", "הבנתי", "הבינותי", "הבנו", "הבינונו", "הבנת", "הבינות", "הבנתם", "הבינותם", "הבנתן", "הבינותן", "הבין", "הבינה", "הבינו", "אבין", "נבין", "תבין", "תביני", "תבינו", "תבנה", "יבין", "יבינו", "תבינינה", "הבן‏", "הביני‏", "הבנה‏", "להבין",
// Believe
"מאמין", "מאמינה", "מאמינים", "מאמינות", "האמנתי", "האמנו", "האמנת", "האמנתם", "האמנתן", "האמין", "האמינה", "האמינו", "אאמין", "נאמין", "תאמין", "תאמיני", "תאמינו", "תאמנה", "יאמין", "יאמינו", "האמן‏", "האמיני‏", "האמינו‏", "האה‏", "להאמין",
// Know
"יודע", "יודעת", "יודעים", "יודעות", "ידעתי", "ידענו", "ידעת", "ידעתם", "ידעתן", "ידע", "ידעה", "ידעו", "אדע", "נדע", "תדע", "תדעי", "תדעו", "תדענה", "דע‏", "דעי‏", "דעו‏", "דענה‏", "לדעת",
// Ask
"שואל", "שואלת", "שואלים", "שואלות", "שאלתי", "שאלנו", "שאלת", "שאלתם", "שאלתן", "שאל", "שאלה", "שאלו", "אשאל", "נשאל", "תשאל", "תשאלי", "תשאלו", "תשאלנה", "ישאל", "ישאלו", "שאל‏", "שאלי‏", "שאלו‏", "שאלנה‏", "לשאול"];

const intensifiers$5 = [
// Very
"מאוד",
// Definitely
"בהחלט",
// The most
"ביותר",
// Terribly
"נורא",
// Completely
"לגמרי",
// Enough
"די"];

const auxiliariesAndDelexicalizedVerbs$4 = [
// To be - infinitive
"להיות",
// To be - past
"היי", "הייתי", "יהיה", "היית", "הייתה", "היינו", "הייתם", "הייתן", "היו",
// To be - future
"אהיה", "תהיה", "תהיי", "יהיה", "נהיה", "תהיו", "תהיינה", "יהיו", "היינה",
// There is
"יש", "שיש",
// Here is
"הנה",
// There is not
"אין",
// Want
"רוצה", "רוצים", "רציתי", "רצה",
// Can
"יכול", "יכולה", "יכולים", "נוכל",
// Should
"צריך", "צריכה",
// Must
"חייב",
// Do, make
"לעשות", "עושה",
// Think
"חושב", "חשבתי", "חושבת",
// See
"נראה", "לראות", "רואה",
// Come
"בוא",
// Go
"הולך", "ללכת", "הולכת", "הלכתי", "הלכת", "הלכת", "הלך", "הלכה", "אלך", "תלך", "תלכי", "ילך", "לכי", "הולכים", "הולכות", "הלכנו", "הלכתם", "הלכתן", "הלכו", "נלך", "תלכו", "תלכנה", "ילכו", "לכו", "לכנה",
// To be sorry
"מצטער",
// Happen
"קרה", "קורה",
// Love
"אוהב",
// Put
"שום",
// Use
"להשתמש",
// Try
"לנסות", "מנסה",
// Take
"לוקח", "אקח",
// Put
"לשים",
// Give
"נותן", "נותנת", "נותנים", "נותנות", "נת", "תינתנו", "נתת", "נתתם", "נתתן", "נתן", "נתנה", "נתנו", "אתן", "ניתן", "תיתן", "תיתני", "תיתנותיתנה", "ייתןנתתתיתן", "ייתנו", "תיתנה", "תן‏", "תני‏", "תנו‏", "תנה‏", "לתת"];

const generalAdjectivesAdverbs$5 = [
// Only
"רק",
// All
"כל",
// More
"יותר",
// Here
"כאן",
// So, such
"כך", "כה",
// Right, correct
"נכון",
// Now
"עכשיו", "עכשיו",
// There
"שם",
// Forward
"קדימה",
// Also
"אף",
// Yet, still
"עוד",
// Really
"באמת", "ממש",
// Maybe
"אולי",
// Already
"כבר",
// Here
"פה",
// Slighly
"קצת",
// Still
"עדיין",
// Just
"בדיוק",
// Again
"שוב",
// Always
"תמיד",
// Even
"אפילו",
// Certainly
"בטח",
// Late
"מאוחר",
// Recently
"לאחרונה",
// Soon
"בקרוב",
// Immediately
"מיד",
// Outside
"בחוץ",
// Fast
"מהר",
// Hard
"קשה",
// Slowly
"לאט",
// Mostly
"לרוב",
// Almost
"כמעט",
// Usually
"בדרך", "כלל",
// Sometimes
"לפעמים",
// Together
"יחד",
// Alone
"לבד",
// Backwards
"אחורה",
// As if
"כאילו",
// Too
"גם",
// Approximately
"בערך",
// The most
"הכי",
// Full
"מלא", "מלאה", "מלאים", "מלאות",
// Good
"טוב", "טובה", "טובים", "טובות",
// New
"חדש", "חדשה", "חדשים", "חדשות",
// Old
"ישן", "ישנה", "ישנים", "ישנות",
// Young
"צעיn", "צעירה", "צעירים", "צעירות",
// Big
"גדול", "גדולה", "גדולים", "גדולות",
// Easy
"קל", "קלה", "קלים", "קלות",
// Fast
"מהיר", "מהירה", "מהירים", "מהירות",
// Far
"רחוק", "רחוקה", "רחוקים", "רחוקות",
// Nice
"נחמד", "נחמדה", "נחמדים", "נחמדות",
// Special
"מיוחד", "מיוחדת", "מיוחדים", "מיוחדות",
// Simple
"פשוט", "פשוטה", "פשוטים", "פשוטות",
// Small
"קטן", "קטנה", "קטנים", "קטנות",
// Long
"ארוך", "ארוכה", "ארוכים", "ארוכות",
// Short
"קצר", "קצרה", "קצרים", "קצרות",
// Low
"נמוך", "נמוכה", "נמוכים", "נמוכות",
// Complete
"שלם", "שלמה", "שלמים", "שלמות",
// High
"גבוה", "גבוהה", "גבוהים", "גבוהות",
// Important
"חשוב", "חשובה", "חשובים", "חשובות"];

const interjections$5 = [
// Ha (laughter)
"ח",
// Oh
"הו",
// Wow
"וואו"];

// These words and abbreviations are frequently used in recipes in lists of ingredients.
const recipeWords$5 = [
// Kg
"ק\"ג",
// G
"ג'",
// Gram
"גרם",
// Cl
"סמ\"ק",
// Ml
"מ\"ל",
// Liter
"ליטר",
// Tbsp
"כף",
// Tsp
"כפית",
// Cup
"כוס", "כוסות"];

const timeWords$5 = [
// Today
"היום",
// Yesterday
"אתמול",
// Tomorrow
"מחר",
// Day
"יום", "ימים",
// Week
"שבוע", "בשבוע", "שבועות",
// Hour
"שעה", "שעות",
// Minute
"דקה", "דקות",
// Moment
"רגע", "רגעים",
// Month
"חודש", "חודשים",
// Year
"שנה", "שנים", "השנה"];

const vagueNouns$5 = [
// Thing
"דבר",
// Time(s)
"פעם", "פעמים",
// Time
"זמן", "הזמן",
// All
"הכל", "בכל",
// Men
"אנשים",
// Place (used in multiple constructions such as e.g. "everywhere")
"מקום",
// Time (used for some adverbial constructions)
"לעתים",
// Number (e.g. in "a number of")
"מספר",
// Percent
"אחוז", "אחוזים"];

const miscellaneous$4 = [
// Yes
"כן",
// No, not (incl. prefixed forms)
"לא", "שלא",
// All right
"בסדר",
// Thank you
"תודה",
// Please
"בבקשה",
// Hello
"שלום",
// Percent
"אחוז",
// Mr
"מר", "אדוני",
// Ms, Mrs
"גברת",
// Person
"אדם"];

var functionWords$4 = {};

Object.defineProperty(functionWords$4, "__esModule", {
	value: true
});

functionWords$4.default = function () {
	return {
		// These word categories are filtered at the ending of word combinations.
		filteredAtEnding: [].concat(ordinalNumerals$4, generalAdjectivesAdverbs$4),

		// These word categories are filtered at the beginning and ending of word combinations.
		filteredAtBeginningAndEnding: [].concat(articles$3, prepositions$3, prepositionPrecedingPronouns, coordinatingConjunctions, demonstrativePronouns, intensifiers$4, quantifiers$4),

		// These word categories are filtered everywhere within word combinations.
		filteredAnywhere: [].concat(transitionWords$8, adverbialGenitives, personalPronounsNominative, personalPronounsAccusative, reflexivePronouns$4, interjections$4, cardinalNumerals$4, otherAuxiliaries, copula, interviewVerbs$4, delexicalizedVerbs, indefinitePronouns$4, subordinatingConjunctions, interrogativeDeterminers, interrogativePronouns, interrogativeProAdverbs, locativeAdverbs, miscellaneous$3, prepositionalAdverbs, recipeWords$4, timeWords$4, vagueNouns$4, vocativeParticles, relativePronouns),

		// These categories are used in the passive voice assessment. If they directly precede a participle, the sentence part is not passive.
		cannotDirectlyPrecedePassiveParticiple: [].concat(articles$3, prepositions$3, demonstrativePronouns, ordinalNumerals$4, quantifiers$4),

		/*
  These categories are used in the passive voice assessment. If they appear between an auxiliary and a participle,
  the sentence part is not passive.
  */
		cannotBeBetweenPassiveAuxiliaryAndParticiple: [].concat(otherAuxiliaries, copula, interviewVerbs$4, delexicalizedVerbs),

		// This export contains all of the above words.
		all: [].concat(articles$3, cardinalNumerals$4, ordinalNumerals$4, demonstrativePronouns, reflexivePronouns$4, personalPronounsNominative, personalPronounsAccusative, quantifiers$4, indefinitePronouns$4, interrogativeDeterminers, interrogativePronouns, interrogativeProAdverbs, locativeAdverbs, adverbialGenitives, prepositionalAdverbs, otherAuxiliaries, copula, prepositions$3, coordinatingConjunctions, subordinatingConjunctions, interviewVerbs$4, transitionWords$8, additionalTransitionWords, intensifiers$4, delexicalizedVerbs, interjections$4, generalAdjectivesAdverbs$4, recipeWords$4, vagueNouns$4, miscellaneous$3, titlesPreceding, vocativeParticles, relativePronouns, prepositionPrecedingPronouns)
	};
};

/**
 * Returns an object with exceptions for the prominent words researcher
 * @returns {Object} The object filled with exception arrays.
 */
const articles$3 = ["الـ"];

const cardinalNumerals$4 = ["صفر", "واحد", "واحدة", "أحد", "إحدى", "إثنان", "اثنتان", "إثنين", "ثنتين", "إثنتين", "إثنا", "إثنى", "إثنتا", "إثنتي", "ثلاث", "ثلاثة", "أربع", "أربعة", "خمس", "خمسة", "ست", "ستة", "سبع", "سبعة", "ثمان", "ثمانية", "تسع", "تسعة", "عشر", "عشرة", "عشرون", "ثلاثون", "أربعين", "أربعون", "خمسون", "ستون", "سبعون", "ثمانون", "تسعون", "مئة", "مائة", "مئتان", "ثلاثمئة", "ثلاثمائة", "أربعمئة", "أربعمائة", "خمسمئة", "خمسمائة", "ستمئة", "ستمائة", "سبعمئة", "سبعمائة", "ثمانمئة", "ثمانمائة", "تسعمئة", "تسعمائة", "ألف", "ألآف", "ألفا", "ألفين", "مليون", "ملايين", "مليار"];

const ordinalNumerals$4 = ["الأول", "الأولى", "الثاني", "الثانية", "الثالث", "الثالثة", "الرابع", "الرابعة", "الخامس", "الخامسة", "السادس", "السادسة", "السابع", "السابعة", "الثامن", "الثامنة", "التاسع", "التاسعة", "العاشر", "العاشرة", "الحادي", "الحادية", "العشرون", "الثلاثون", "الأربعون", "الخمسون", "الستون", "السبعون", "الثمانون", "التسعون", "المئة", "المائة"];

const personalPronounsNominative = ["أنا", "انت", "هو", "هي", "نحن", "أنتما", "هما", "أنتم", "أنتن", "هم", "هن", "وأنا", "وأنت", "وهو", "وانا", "ونحن", "وهي", "وانت", "أنتي", "فهو", "وهم", "وأنتما"];

const personalPronounsAccusative = ["إياه", "إياهما", "إياهم", "إياها", "إياكما", "إياهن", "إياك", "إياكم", "إياكن", "إياي", "إيانا"];

const demonstrativePronouns = ["هذا", "هذه", "هذان", "هذين", "هتان", "هـتين", "ذا", "ذان", "ذين", "أولئ", "ذلك", "ذانك", "ذينك", "تلك", "تانك", "تينك", "أولئك", "هؤلاء", "ذاك", "هاتان", "هاتين", "ذه", "هأولئ", "ذلكم", "ذلكم", "وهذا", "هذة", "أولئك"];

const vocativeParticles = ["يا", "أي", "هيا", "أ", "آ", "أيها", "أيتها"];

const quantifiers$4 = ["جميع", "كل", "بعض", "كثير", "كثيرة", "عديد", "عديدة", "لبعض", "قليلا", "كافية", "كافي", "صغير", "صغيرة", "قليل", "قليلة", "كثيرا", "بالكثير", "أكثر", "اكبر", "اغلب", "عديدة", "عديد", "قليلون", "أقل", "كل", "الكثير", "المزيد", "اكثر", "الأقل", "يكفي", "العديد", "كله", "جميعا", "كلها", "وكل", "كلنا", "كثيرة", "الأكثر", "ببعض", "بضعة", "عدة"];

const reflexivePronouns$4 = ["نفسي", "نفسك", "نفسه", "نفسها", "أنفسنا", "أنسفكم", "أنفسهم", "أنفسهما", "أنفسكما", "أنفسكن", "أنفسهن", "بنفسي"];

const indefinitePronouns$4 = ["ليس", "جميع", "الكل", "الجميع", "شخص", "شيء", "شيئا", "أخرى", "آخرين", "أي", "أيا", "من", "الآخرين", "أحد", "شئ", "أخرى", "شىء", "احد", "أية", "اخرى", "البعض", "أخر", "الآخر", "أحدهم", "الأخرى", "الشئ", "بعضنا", "بشيء", "شي", "الغير"];

const relativePronouns = ["الذي", "التي", "الذى", "التى", "الذين", "مالذي", "اللذان", "الذين", "اللتان", "اللاتي", "الذي", "اللتين", "اللذين"];

const intensifiers$4 = ["جدا", "حقا", "للغاية", "تماما", "فعلا"];

const interrogativeDeterminers = ["ماذا", "لمن", "ما", "أي", "أى", "وماذا", "وما", "بماذا", "ماهو", "ماهذا"];
const interrogativePronouns = ["من", "ومن"];
const interrogativeProAdverbs = ["اين", "كيف", "لماذا", "لم", "سواء", "أينما", "كيفما", "مـتى", "كم", "هل", "أين", "أهذا", "وكيف", "وهل"];

const locativeAdverbs = ["هنا", "هناك", "هنالك"];
const adverbialGenitives = ["دائما", "مرة", "مرتين"];
const otherAuxiliaries = ["يجب", "سوف", "قد", "أستطيع", "يستطيع", "نستطيع", "تستطيع", "استطيع", "تستطيعين", "استطعت", "استطاعت", "استطاع", "استطعتما", "استطاعتا", "استطاعا", "استطعنا", "استطعتن", "استطعتم", "استطعن", "استطاعوا", "تستطيعان", "يستطيعان", "تستطعن", "تستطيعون", "يستطعن", "يستطيعون", "تستطيعي", "تستطيعا", "يستطيعا", "تستطيعوا", "يستطيعوا", "استطيعت", "استطيعتا", "استطيعا", "استطيعوا", "تستطاعين", "تستطاع", "يستطاع", "نستطاع", "تستطاعان", "يستطاعان", "تستطاعون", "يستطاعون", "أستطاع", "تستطاعي", "تستطاعا", "يستطاعا", "يستطاعوا", "تستطاعوا", "استطيعي", "يمكنني", "يمكن", "يمكننى", "بإمكانك", "لابد", "ينبغي", "وسوف", "هلا", "بد", "وقد", "ولقد", "يمكنه", "يمكنهما", "يمكنهم", "يمكنها", "يمكنكما", "يمكنهن", "يمكنك", "يمكنكم", "يمكنكن", "يمكني", "يمكننا"];

const copula = ["لدي", "لديك", "لدينا", "لديه", "لديها", "لديهم", "لديهما", "لديكم", "لديكما", "لديهن", "لديكن", "صبحت", "صبح", "صبحتما", "صبحا", "صبحتا", "صبحنا", "صبحتن", "صبحتم", "صبحن", "صبحوا", "أصبح", "تصبحين", "تصبح", "يصبح", "تصبحان", "يصبحان", "نصبح", "تصبحن", "تصبحون", "تصبحي", "تصبحا", "يصبحا", "تصبحوا", "يصبحوا", "اصبحي", "اصبحوا", "اصبحا", "ابقى", "كان", "كنت", "كانت", "يكون", "كنتما", "كانتا", "كانا", "كنا", "كن", "كانوا", "كنتم", "أكون", "تكونين", "تكون", "تكونان", "يكونان", "نكون", "تكونون", "يكن", "يكونون", "تكوني", "تكونا", "يكونا", "تكونوا", "يكونوا", "كونا", "كونوا", "كن", "أكن", "اكون", "وكان", "كوني", "اكن", "سنكون", "كنا", "سيكون", "يكن", "ستكون", "تكن", "سأكون", "بت", "باتت", "بات", "بتما", "باتتا", "باتا", "بتنا", "بتن", "بتم", "باتوا", "أبيت", "بت", "صرت", "صرت", "صار", "صرتما", "صارتا", "صارا", "صرنا", "صرتن", "صرتم", "صرن", "صاروا", "أصير", "تصيرين", "تصير", "يصير", "تصيران", "يصيران", "نصير", "تصرن", "يصرن", "تصيرون", "يصيرون", "تصيري", "تصيرا", "يصيرا", "تصيروا", "يصيروا", "ليس", "وليس", "ليست", "ليسوا", "ليسا", "ليسنا", "ليسن", "أليس", "اليس", "لست", "لسنا"];

const prepositions$3 = ["أن", "في", "على", "إلى", "ان", "عن", "فى", "مع", "الى", "بعد", "بدون", "تحت", "طوال", "علي", "غير", "لدى", "حول", "خلال", "لكي", "بين", "الي", "خارج", "بشأن", "فوق", "دون", "لـ", "بـ", "بلا", "بواسطة", "ضد", "أمام", "وفي", "وشك", "نحو", "ذو", "أسفل", "ب", "خلف", "بجانب", "عدا", "طبقا", "بعد", "عكس", "منذ"];

const prepositionPrecedingPronouns = ["إليه", "إليهما", "إليهم", "إليها", "إليكما", "إليهن", "إليك", "إليكم", "إليكن", "إلي", "إلينا", "عليه", "عليهما", "عليهم", "عليها", "عليكما", "عليهن", "عليك", "عليكم", "عليكن", "علي", "علينا", "عنه", "عنهما", "عنهم", "عنها", "عنكما", "عنهن", "عنك", "عنكم", "عنكن", "عني", "عننا", "له", "لهما", "لهم", "لها", "لكما", "لهن", "لك", "لكم", "لكن", "لي", "لنا", "معه", "معهما", "معهم", "معها", "معكما", "معهن", "معك", "معكم", "معكن", "معي", "معنا", "منه", "منهما", "منهم", "منها", "منكم", "منهن", "منك", "منكم", "منكن", "مني", "منا", "فيه", "فيهما", "فيهم", "فيها", "فيكما", "فيهن", "فيك", "فيكم", "به", "بهما", "بهم", "بها", "بكما", "بهن", "بك", "بكم", "بكن", "بي", "بنا", "بينهم", "بينهما", "بينكما", "بينكم", "بتلك", "بذلك", "فأنت", "بيننا", "بهذا", "بهذه", "فأنا", "فهذا", "فيما", "أجلك", "كهذا", "لأي", "لذلك", "لما", "لنفسك", "لهذا", "لهذه"];

// Many prepositional adverbs are already listed as preposition.
const prepositionalAdverbs = ["داخل", "ضمن", "قدما"];

const coordinatingConjunctions = ["و", "و/او", "او", "أو"];

const subordinatingConjunctions = ["إذا", "لو", "اذا", "وإذا", "أذا"];

// These verbs are frequently used in interviews to indicate questions and answers.
const interviewVerbs$4 = ["أقول", "تقول", "تقولين", "تقولان", "يقول", "تقول", "يقولان", "تقولان", "نقول", "تقولون", "تقلن", "يقولون", "قلت", "قلتما", "قال", "قالت", "قالا", "قالتا", "قلنا", "قلتما", "قلتن", "قالوا", "قلنا", "تدعي", "يدعي", "تدعيان", "تدعون", "يدعون", "يدعين", "ادعيت", "ادعيت", "ادعيتما", "ادعى", "ادعت", "ادعينا", "ادعيتما", "ادعيتن", "ادعوا", "ادعينا", "تسأل", "تسألين", "يسأل", "تسأل", "نسأل", "تسألون", "تسألن", "يسألون", "يسألن", "سألت", "سألنا", "سألتم", "سألتن", "سألوا", "سألنا", "تشرح", "تشرحين", "يشرح", "تشرح", "نشرح", "تشرحون", "تشرحن", "يشرحون", "يشرحن", "شرحت", "شرح", "شرحت", "شرحنا", "شرحتم", "شرحتن", "شرحوا", "شرحنا", "شرحن", "أعتقد", "تعتقد", "تعتقدين", "يعتقد", "تعتقد", "تعتقدون", "تعتقدن", "يعتقدون", "يعتقدن", "اعتقدت", "اعتق", "اعتقدت", "أتحدث", "تتحدث", "تتحدثين", "يتحدث", "تتحدث", "نتحدث", "تحدثت", "تحدث", "تحدثت", "تحدثوا", "تحدثن", "أعلن", "تعلن", "تعلنين", "يعلن", "تعلن", "نعلن", "يعلنون", "يعلن", "أعلنت", "أعلن", "أعلنت", "أعلنا", "أعلنوا", "أعلن", "أناقش", "تناقش", "تناقشين", "يناقش", "تناقش", "نناقش", "تناقشون", "تناقشن", "يناقشون", "يناقشن", "ناقشت", "ناقشت", "ناقشت", "ناقشت", "ناقشت", "ناقشنا", "ناقشتم", "ناقشتن", "ناقشوا", "ناقشن", "أفهم", "تفهم", "تفهمين", "يفهم", "تفهم", "نفهم", "يفهمون", "يفهمن", "فهمت", "فهم", "فهمت", "فهمنا", "فهموا", "فهمن"];

// These transition words were not included in the list for the transition word assessment for various reasons.
const additionalTransitionWords = ["الآن", "كذلك", "ربما", "كما", "لذا", "الان", "الأن", "بما", "أيضا", "بالنسبة", "فحسب", "والآن", "بكل", "مما", "ايضا", "بخصوص", "القادمة", "المحتمل", "مازال", "مازلت", "طالما", "بالتأكيد", "بدلا", "بوضوح", "فورا", "حالا", "التالي", "حاليا", "بالعادة", "تقريبا", "ببساطة", "اختياريا", "أحيانا", "أبدا", "بالمناسبة", "خاصة", "مؤخرا", "نسبيا"];

// These verbs convey little meaning.
const delexicalizedVerbs = ["يعني", "أحتاج", "يعمل", "تعني", "تقوم", "أود", "عندك", "البقاء", "حاولت", "توجد", "دعونا", "تفكر", "جئت", "يريدون", "أتيت", "فعلته", "تقصد", "زال", "إرادة‎", "مريد‎", "مراد‎", "أردت‎", "أردت‎", "أردت‎", "أرادت‎", "أريد‎", "تريد‎", "تريدين‎", "يريد‎", "تريد‎", "أريد‎", "تريد‎", "يريد‎", "تريد‎", "أرد‎", "ترد‎", "يرد‎", "ترد‎", "أرد‎", "أريدي‎", "أردتما", "تريدان‎", "تريدا‎", "تريدا‎", "أريدا‎", "أرادا‎", "أرادتا‎", "يريدان‎", "تريدان‎", "يريدا‎", "تريدا‎", "أردنا‎", "نريد‎", "نريد‎", "نرد‎", "أردتم‎", "أردتن‎", "تريدون‎", "تردن‎", "تريدوا‎", "تردن‎", "تريدوا‎", "تردن‎", "أريدوا‎", "أردن‎", "أرادوا‎", "أردن‎", "يريدون‎", "يردن‎", "يريدوا‎", "أردت‎", "أراد", "أراد", "أرد‎", "أردت‎", "أريد‎", "أردتما‎", "أريدا‎", "أردنا‎", "أردتم‎", "أريدوا‎", "أردت‎", "أريدت‎", "أريدتا‎", "أردتن‎", "أردن‎", "تراد‎", "يراد‎", "ترادان‎", "يرادان‎", "نراد‎", "ترادون‎", "يرادون‎", "ترادين‎", "تراد‎", "ترادان‎", "تردن‎", "يردن‎", "تراد‎", "يراد‎", "ترادا‎", "يرادا‎", "نراد‎", "ترادوا‎", "يرادوا‎", "ترادي‎", "تراد‎", "ترادا‎", "تردن‎", "يردن‎", "ترد‎", "يرد‎", "ترادا‎", "يرادا‎", "نرد‎", "ترادوا‎", "يرادوا‎", "ترادي‎", "ترد‎", "ترادا‎", "تردن‎", "يردن‎", "أرد‎", "اعتقاد‎", "معتقد‎", "معتقد‎", "اعتقدت‎", "اعتقدت‎", "اعتقد", "اعتقدتما‎", "اعتقدا‎", "اعتقدنا‎", "اعتقدتم‎", "اعتقدوا‎", "اعتقدت‎", "اعتقدت‎", "اعتقدتا‎", "اعتقدتن‎", "اعتقدن‎", "تعتقد‎", "يعتقد‎", "تعتقدان‎", "يعتقدان‎", "نعتقد‎", "تعتقدون‎", "يعتقدون‎", "تعتقدين‎", "تعتقد‎", "تعتقدان‎", "تعتقدن‎", "يعتقدن‎", "تعتقد‎", "يعتقد‎", "تعتقدا‎", "يعتقدا‎", "نعتقد‎", "تعتقدوا‎", "يعتقدوا‎", "تعتقدي‎", "تعتقد‎", "تعتقدا‎", "تعتقدن‎", "يعتقدن‎", "تعتقد‎", "يعتقد‎", "تعتقدا‎", "يعتقدا‎", "نعتقد‎", "تعتقدوا‎", "يعتقدوا‎", "تعتقدي‎", "تعتقد‎", "تعتقدا‎", "تعتقدن‎", "يعتقدن‎", "اعتقدي‎", "اعتقدن‎", "اعتقد", "اعتقدا‎", "اعتقدوا‎", "اعتقدت‎", "اعتقدت‎", "اعتقد", "اعتقدتما‎", "اعتقدا‎", "اعتقدنا‎", "اعتقدتم‎", "اعتقدوا‎", "اعتقدت‎", "اعتقدت‎", "اعتقدتا‎", "اعتقدتن‎", "اعتقدن‎", "أعتقد‎", "تعتقد‎", "يعتقد‎", "تعتقدان‎", "يعتقدان‎", "نعتقد‎", "تعتقدون‎", "يعتقدون‎", "تعتقدين‎", "تعتقد‎", "تعتقدان‎", "تعتقدن‎", "يعتقدن‎", "أعتقد‎", "تعتقد‎", "يعتقد‎", "تعتقدا‎", "يعتقدا‎", "نعتقد‎", "تعتقدوا‎", "يعتقدوا‎", "تعتقدي‎", "تعتقد‎", "تعتقدا‎", "تعتقدن‎", "يعتقدن‎", "أعتقد‎", "تعتقد‎", "يعتقد‎", "تعتقدا‎", "يعتقدا‎", "نعتقد‎", "تعتقدوا‎", "يعتقدوا‎", "تعتقدي‎", "تعتقد‎", "تعتقدا‎", "تعتقدن‎", "يعتقدن‎", "اعتقد", "اعتقدا‎", "اعتقدوا‎", "إيجاد‎", "موجد‎", "موجد‎", "أوجدت‎", "أوجدت‎", "أوجد", "أوجدتما‎", "أوجدا‎", "أوجدنا‎", "أوجدتم‎", "أوجدوا‎", "أوجدت‎", "أوجدت‎", "أوجدتا‎", "أوجدتن‎", "أوجدن‎", "أوجد", "توجد‎", "يوجد‎", "توجدان‎", "يوجدان‎", "نوجد‎", "توجدون‎", "يوجدون‎", "توجدين‎", "توجد‎", "توجدان‎", "توجدن‎", "يوجدن‎", "أوجد", "توجد‎", "يوجد‎", "توجدا‎", "يوجدا‎", "نوجد‎", "توجدوا‎", "يوجدوا‎", "توجدي‎", "توجد‎", "توجدا‎", "توجدن‎", "يوجدن‎", "أوجد", "توجد‎", "يوجد‎", "توجدا‎", "يوجدا‎", "نوجد‎", "توجدوا‎", "يوجدوا‎", "توجدي‎", "توجد‎", "توجدا‎", "توجدن‎", "يوجدن‎", "أوجد", "أوجدا‎", "أوجدوا‎", "أوجدي‎", "أوجدن‎", "أوجدت‎", "أوجدت‎", "أوجد", "أوجدتما‎", "أوجدا‎", "أوجدنا‎", "أوجدتم‎", "أوجدوا‎", "أوجدت‎", "أوجدت‎", "أوجدتا‎", "أوجدتن‎", "أوجدن‎", "أوجد", "توجد‎", "يوجد‎", "توجدان‎", "يوجدان‎", "نوجد‎", "توجدون‎", "يوجدون‎", "توجدين‎", "توجد‎", "توجدان‎", "توجدن‎", "يوجدن‎", "أوجد", "توجد‎", "يوجد‎", "توجدا‎", "يوجدا‎", "نوجد‎", "توجدوا‎", "يوجدوا‎", "توجدي‎", "توجد‎", "توجدا‎", "توجدن‎", "يوجدن‎", "أوجد", "توجد‎", "يوجد‎", "توجدا‎", "يوجدا‎", "نوجد‎", "توجدوا‎", "يوجدوا‎", "توجدي‎", "توجد‎", "توجدا‎", "توجدن‎", "يوجدن‎", "اعتقد", "اريد", "أذهب", "إذهاب‎", "مذهب‎", "مذهب‎", "أذهبت‎", "أذهبت‎", "أذهب", "أذهبتما‎", "أذهبا‎", "أذهبنا‎", "أذهبتم‎", "أذهبوا‎", "أذهبت‎", "أذهبت‎", "أذهبتا‎", "أذهبتن‎", "أذهبن‎", "أذهب", "تذهب‎", "يذهب‎", "تذهبان‎", "يذهبان‎", "نذهب‎", "تذهبون‎", "يذهبون‎", "تذهبين‎", "تذهب‎", "تذهبان‎", "تذهبن‎", "يذهبن‎", "أذهب", "تذهب‎", "يذهب‎", "تذهبا‎", "يذهبا‎", "نذهب‎", "تذهبوا‎", "يذهبوا‎", "تذهبي‎", "تذهب‎", "تذهبا‎", "تذهبن‎", "يذهبن‎", "أذهب", "تذهب‎", "يذهب‎", "تذهبا‎", "يذهبا‎", "نذهب‎", "تذهبوا‎", "يذهبوا‎", "تذهبي‎", "تذهب‎", "تذهبا‎", "تذهبن‎", "يذهبن‎", "أذهب", "أذهبا‎", "أذهبوا‎", "أذهبي‎", "أذهبن‎", "أذهبت‎", "أذهبت‎", "أذهب", "أذهبتما‎", "أذهبا‎", "أذهبنا‎", "أذهبتم‎", "أذهبوا‎", "أذهبت‎", "أذهبت‎", "أذهبتا‎", "أذهبتن‎", "أذهبن‎", "أذهب", "تذهب‎", "يذهب‎", "تذهبان‎", "يذهبان‎", "نذهب‎", "تذهبون‎", "يذهبون‎", "تذهبين‎", "تذهب‎", "تذهبان‎", "تذهبن‎", "يذهبن‎", "أذهب", "تذهب‎", "يذهب‎", "تذهبا‎", "يذهبا‎", "نذهب‎", "تذهبوا‎", "يذهبوا‎", "تذهبي‎", "تذهب‎", "تذهبا‎", "تذهبن‎", "يذهبن‎", "أذهب", "تذهب‎", "يذهب‎", "تذهبا‎", "يذهبا‎", "نذهب‎", "تذهبوا‎", "يذهبوا‎", "تذهبي‎", "تذهب‎", "تذهبا‎", "تذهبن‎", "يذهبن‎", "نذهب", "مذهب‎", "ذاهب‎", "مذهوب‎", "ذهبت‎", "ذهبت‎", "ذهب", "ذهبتما‎", "ذهبا‎", "ذهبنا‎", "ذهبتم‎", "ذهبوا‎", "ذهبت‎", "ذهبت‎", "ذهبتا‎", "ذهبتن‎", "ذهبن‎", "أذهب‎", "تذهب‎", "يذهب‎", "تذهبان‎", "يذهبان‎", "نذهب‎", "تذهبون‎", "يذهبون‎", "تذهبين‎", "تذهب‎", "تذهبان‎", "تذهبن‎", "يذهبن‎", "أذهب‎", "تذهب‎", "يذهب‎", "تذهبا‎", "يذهبا‎", "نذهب‎", "تذهبوا‎", "يذهبوا‎", "تذهبي‎", "تذهب‎", "تذهبا‎", "تذهبن‎", "يذهبن‎", "أذهب‎", "تذهب‎", "يذهب‎", "تذهبا‎", "يذهبا‎", "نذهب‎", "تذهبوا‎", "يذهبوا‎", "تذهبي‎", "تذهب‎", "تذهبا‎", "تذهبن‎", "يذهبن‎", "اذهب‎", "اذهبا‎", "اذهبوا‎", "اذهبي‎", "اذهبن‎", "ذهب", "يذهب‎", "يذهب‎", "يذهب‎", "أظن", "ظن", "ظان‎", "مظنون‎", "ظننت‎", "ظننت‎", "ظن", "ظننتما‎", "ظنا‎", "ظننا‎", "ظننتم‎", "ظنوا‎", "ظننت‎", "ظنت‎", "ظنتا‎", "ظننتن‎", "ظنن‎", "أظن‎", "تظن‎", "يظن‎", "تظنان‎", "يظنان‎", "نظن‎", "تظنون‎", "يظنون‎", "تظنين‎", "تظن‎", "تظنان‎", "تظنن‎", "يظنن‎", "أظن‎", "تظن‎", "يظن‎", "تظنا‎", "يظنا‎", "نظن‎", "تظنوا‎", "يظنوا‎", "تظني‎", "تظن‎", "تظنا‎", "تظنن‎", "يظنن‎", "أظنن‎", "تظنا‎", "يظنا‎", "تظنوا‎", "يظنوا‎", "تظنن‎", "تظني‎", "تظنا‎", "تظنن‎", "يظنن‎", "أظن", "أظن", "تظن‎", "تظن‎", "يظنن‎", "يظن‎", "ظني‎", "اظنن‎", "يظن‎", "نظنن‎", "نظن‎", "نظن‎", "تظنن‎", "تظن‎", "تظن‎", "ظنا‎", "اظنن‎", "ظن", "ظن", "ظنوا‎", "اذهب‎", "اذهبا‎", "اذهبوا‎", "ظننت‎", "ظننت‎", "ظن", "ظننتما‎", "ظنا‎", "ظننا‎", "ظننتم‎", "ظنوا‎", "ظننت‎", "ظنت‎", "ظنتا‎", "ظننتن‎", "ظنن‎", "أظن‎", "تظن‎", "يظن‎", "تظنان‎", "يظنان‎", "نظن‎", "تظنون‎", "يظنون‎", "تظنين‎", "تظن‎", "تظنان‎", "تظنن‎", "يظنن‎", "أظن‎", "تظن‎", "يظن‎", "تظنا‎", "يظنا‎", "نظن‎", "تظنوا‎", "يظنوا‎", "تظني‎", "تظن‎", "تظنا‎", "تظنن‎", "يظنن‎", "أظنن‎", "تظنا‎", "يظنا‎", "تظنوا‎", "يظنوا‎", "أظن‎", "تظني‎", "تظنا‎", "تظنن‎", "يظنن‎", "تظنن‎", "تظن‎", "تظن‎", "يظنن‎", "يظن‎", "يظن‎", "نظنن‎", "نظن‎", "نظن‎", "تظنن‎", "تظن‎", "تظن‎", "ذهبت", "تظن", "توجدت‎", "توجدت‎", "توجد", "توجدتما‎", "توجدا‎", "توجدنا‎", "توجدتم‎", "توجدوا‎", "توجدت‎", "توجدت‎", "توجدتا‎", "توجدتن‎", "توجدن‎", "أتوجد‎", "ʾتتوجد‎", "يتوجد‎", "تتوجدان‎", "يتوجدان‎", "نتوجد‎", "تتوجدون‎", "يتوجدون‎", "تتوجدين‎", "تتوجد‎", "تتوجدان‎", "تتوجدن‎", "يتوجدن‎", "أتوجد‎", "ʾتتوجد‎", "يتوجد‎", "تتوجدا‎", "يتوجدا‎", "نتوجد‎", "تتوجدوا‎", "يتوجدوا‎", "تتوجدي‎", "تتوجد‎", "تتوجدا‎", "تتوجدن‎", "يتوجدن‎", "أتوجد‎", "ʾتتوجد‎", "يتوجد‎", "تتوجدا‎", "يتوجدا‎", "نتوجد‎", "تتوجدوا‎", "يتوجدوا‎", "تتوجدي‎", "تتوجد‎", "تتوجدا‎", "تتوجدن‎", "يتوجدن‎", "توجد", "توجدا‎", "توجدوا‎", "توجدي‎", "توجدن‎", "توجد", "يتوجد‎", "يتوجد‎", "يتوجد‎", "توجد", "متوجد‎", "متوجد‎", "دعاء‎", "داع‎", "مدعو‎", "دعوت‎", "دعوت‎", "دعا", "دعوتما‎", "دعوا‎", "دعونا‎", "دعوتم‎", "دعوا‎", "دعوت‎", "دعت‎", "دعتا‎", "دعوتن‎", "دعون‎", "أدعو‎", "تدعو‎", "يدعو‎", "تدعوان‎", "يدعوان‎", "ندعو‎", "تدعون‎", "يدعون‎", "تدعين‎", "تدعو‎", "تدعوان‎", "تدعون‎", "يدعون‎", "أدعو‎", "تدعو‎", "يدعو‎", "تدعوا‎", "يدعوا‎", "ندعو‎", "تدعوا‎", "يدعوا‎", "تدعي‎", "تدعو‎", "تدعوا‎", "تدعون‎", "يدعون‎", "أدع‎", "تدع‎", "يدع‎", "تدعوا‎", "يدعوا‎", "ندع‎", "تدعوا‎", "يدعوا‎", "تدعي‎", "تدع‎", "تدعوا‎", "تدعون‎", "يدعون‎", "ادع‎", "ادعوا‎", "ادعوا‎", "ادعي‎", "ادعون‎", "دعيت‎", "دعيت‎", "دعي‎", "دعيتما‎", "دعيا‎", "دعينا‎", "دعيتم‎", "دعوا‎", "دعيت‎", "دعيت‎", "دعيتا‎", "دعيتن‎", "دعين‎", "أدعى‎", "تدعى‎", "يدعى‎", "تدعيان‎", "يدعيان‎", "ندعى‎", "تدعون‎", "يدعون‎", "تدعين‎", "تدعى‎", "تدعيان‎", "تدعين‎", "يدعين‎", "أدعى‎", "تدعى‎", "يدعى‎", "تدعيا‎", "يدعيا‎", "ندعى‎", "تدعوا‎", "يدعوا‎", "تدعي‎", "تدعى‎", "تدعيا‎", "تدعين‎", "يدعين‎", "أدع‎", "تدع‎", "يدع‎", "تدعيا‎", "يدعيا‎", "ندع‎", "تدعوا‎", "يدعوا‎", "تدعي‎", "تدع‎", "تدعيا‎", "تدعين‎", "يدعين‎", "تفكر", "متفكر‎", "متفكر‎", "تفكرت‎", "تفكرت‎", "تفكر", "تفكرتما‎", "تفكرا‎", "تفكرنا‎", "تفكرتم‎", "تفكروا‎", "تفكرت‎", "تفكرت‎", "تفكرتا‎", "تفكرتن‎", "تفكرن‎", "أتفكر‎", "تتفكر‎", "يتفكر‎", "تتفكران‎", "يتفكران‎", "نتفكر‎", "تتفكرون‎", "يتفكرون‎", "تتفكرين‎", "تتفكر‎", "تتفكران‎", "تتفكرن‎", "يتفكرن‎", "أتفكر‎", "تتفكر‎", "يتفكر‎", "تتفكرا‎", "يتفكرا‎", "نتفكر‎", "تتفكروا‎", "يتفكروا‎", "تتفكري‎", "تتفكر‎", "تتفكرا‎", "تتفكرن‎", "يتفكرن‎", "أتفكر‎", "تتفكر‎", "يتفكر‎", "تتفكرا‎", "يتفكرا‎", "نتفكر‎", "تتفكروا‎", "يتفكروا‎", "تتفكري‎", "تتفكر‎", "تتفكرا‎", "تتفكرن‎", "يتفكرن‎", "تفكر", "تفكرا‎", "تفكروا‎", "تفكري‎", "تفكرن‎", "تفكر", "يتفكر‎", "يتفكر‎", "يتفكر‎", "مجيء‎", "جيء‎", "جيئة‎", "جيئة‎", "جاء", "مجيء‎", "جئت‎", "جئت‎", "جاء", "جئتما‎", "جاءا‎", "جئنا‎", "جئتم‎", "جائوا‎", "جاؤوا‎", "جئت‎", "جاءت‎", "جاءتا‎", "جئتن‎", "جئن‎", "أجيء‎", "تجيء‎", "يجيء‎", "تجيئان‎", "يجيئان‎", "نجيء‎", "تجيئون‎", "تجيؤون‎", "يجيئون‎", "يجيؤون‎", "تجيئين‎", "تجيء‎", "تجيئان‎", "تجئن‎", "يجئن‎", "أجيء‎", "تجيء‎", "يجيء‎", "تجيئا‎", "يجيئا‎", "نجيء‎", "تجيئوا‎", "تجيؤوا‎", "يجيئوا‎", "يجيؤوا‎", "تجيئي‎", "تجيء‎", "تجيئا‎", "تجئن‎", "يجئن‎", "أجئ‎", "تجئ‎", "يجئ‎", "تجيئا‎", "يجيئا‎", "نجئ‎", "تجيئوا‎", "تجيؤوا‎", "يجيئوا‎", "يجيؤوا‎", "تجيئي‎", "تجئ‎", "تجيئا‎", "تجئن‎", "يجئن‎", "جئ‎", "جيئا‎", "جيئوا‎", "جيؤوا‎", "جيئي‎", "جئن‎", "جئت‎", "جئت‎", "جيء‎", "جئتما‎", "جيئا‎", "جئنا‎", "جئتم‎", "جيئوا‎", "جيؤوا‎", "جئت‎", "جيئت‎", "جيئتا‎", "جئتن‎", "جئن‎", "أجاء‎", "تجاء‎", "يجاء‎", "تجاءان‎", "يجاءان‎", "نجاء‎", "تجائون‎", "تجاؤون‎", "يجائون‎", "يجاؤون‎", "تجائين‎", "تجاء‎", "تجاءان‎", "تجأن‎", "يجأن‎", "أجاء‎", "تجاء‎", "يجاء‎", "تجاءا‎", "يجاءا‎", "نجاء‎", "تجائوا‎", "تجاؤوا‎", "يجائوا‎", "يجاؤوا‎", "تجائي‎", "تجاء‎", "تجاءا‎", "تجأن‎", "يجأن‎", "أجأ‎", "تجأ‎", "يجأ‎", "تجاءا‎", "يجاءا‎", "نجأ‎", "تجائوا‎", "تجاؤوا‎", "يجائوا‎", "يجاؤوا‎", "تجائي‎", "تجأ‎", "تجاءا‎", "تجأن‎", "يجأن‎", "إرادة‎", "مريد‎", "مراد‎", "أردت‎", "أردت‎", "أراد", "أردتما‎", "أرادا‎", "أردنا‎", "أردتم‎", "أرادوا‎", "أردت‎", "أرادت‎", "أرادتا‎", "أردتن‎", "أردن‎", "أريد‎", "تريد‎", "يريد‎", "تريدان‎", "يريدان‎", "نريد‎", "تريدون‎", "يريدون‎", "تريدين‎", "تريد‎", "تريدان‎", "تردن‎", "يردن‎", "أريد‎", "تريد‎", "يريد‎", "تريدا‎", "يريدا‎", "نريد‎", "تريدوا‎", "يريدوا‎", "تريدي‎", "تريد‎", "تريدا‎", "تردن‎", "يردن‎", "أرد‎", "ترد‎", "يرد‎", "تريدا‎", "يريدا‎", "نرد‎", "تريدوا‎", "يريدوا‎", "تريدي‎", "ترد‎", "تريدا‎", "تردن‎", "يردن‎", "أرد‎", "أريدا‎", "أريدوا‎", "أريدي‎", "أردن‎", "أردت‎", "أردت‎", "أريد‎", "أردتما‎", "أريدا‎", "أردنا‎", "أردتم‎", "أريدوا‎", "أردت‎", "أريدت‎", "أريدتا‎", "أردتن‎", "أردن‎", "أراد", "تراد‎", "يراد‎", "ترادان‎", "يرادان‎", "نراد‎", "ترادون‎", "يرادون‎", "ترادين‎", "تراد‎", "ترادان‎", "تردن‎", "يردن‎", "أراد", "تراد‎", "يراد‎", "ترادا‎", "يرادا‎", "نراد‎", "ترادوا‎", "يرادوا‎", "ترادي‎", "تراد‎", "ترادا‎", "تردن‎", "يردن‎", "أرد‎", "ترد‎", "يرد‎", "ترادا‎", "يرادا‎", "نرد‎", "ترادوا‎", "يرادوا‎", "ترادي‎", "ترد‎", "ترادا‎", "تردن‎", "يردن‎", "إتيان‎", "أتي‎", "مأتاة‎", "مأتى‎", "آت‎", "مأتي‎", "أتيت‎", "أتيت‎", "أتى", "أتيتما‎", "أتيا‎", "أتينا‎", "أتيتم‎", "أتوا‎", "أتيت‎", "أتت‎", "أتتا‎", "أتيتن‎", "أتين‎", "آتي‎", "تأتي‎", "يأتي‎", "تأتيان‎", "يأتيان‎", "نأتي‎", "تأتون‎", "يأتون‎", "تأتين‎", "تأتي‎", "تأتيان‎", "تأتين‎", "يأتين‎", "آتي‎", "تأتي‎", "يأتي‎", "تأتيا‎", "يأتيا‎", "نأتي‎", "تأتوا‎", "يأتوا‎", "تأتي‎", "تأتي‎", "تأتيا‎", "تأتين‎", "يأتين‎", "آت‎", "تأت‎", "يأت‎", "تأتيا‎", "يأتيا‎", "نأت‎", "تأتوا‎", "يأتوا‎", "تأتي‎", "تأت‎", "تأتيا‎", "تأتين‎", "يأتين‎", "ايت‎", "ايتيا‎", "ايتوا‎", "ايتي‎", "ايتين‎", "أتيت‎", "أتيت‎", "أتي‎", "أتيتما‎", "أتيا‎", "أتينا‎", "أتيتم‎", "أتوا‎", "أتيت‎", "أتيت‎", "أتيتا‎", "أتيتن‎", "أتين‎", "أوتى‎", "تؤتى‎", "يؤتى‎", "تؤتيان‎", "يؤتيان‎", "نؤتى‎", "تؤتون‎", "يؤتون‎", "تؤتين‎", "تؤتى‎", "تؤتيان‎", "تؤتين‎", "يؤتين‎", "أوتى‎", "تؤتى‎", "يؤتى‎", "تؤتيا‎", "يؤتيا‎", "نؤتى‎", "تؤتوا‎", "يؤتوا‎", "تؤتي‎", "تؤتى‎", "تؤتيا‎", "تؤتين‎", "يؤتين‎", "أوت‎", "تؤت‎", "يؤت‎", "تؤتيا‎", "يؤتيا‎", "نؤت‎", "تؤتوا‎", "يؤتوا‎", "تؤتي‎", "تؤت‎", "تؤتيا‎", "تؤتين‎", "يؤتين‎", "فعلته", "فعل", "فعل", "فاعل‎", "مفعول‎", "فعلت‎", "فعلت‎", "فعل", "فعلتما‎", "فعلا‎", "فعلنا‎", "فعلتم‎", "فعلوا‎", "فعلت‎", "فعلت‎", "فعلتا‎", "فعلتن‎", "فعلن‎", "أفعل‎", "تفعل‎", "يفعل‎", "تفعلان‎", "يفعلان‎", "نفعل‎", "تفعلون‎", "يفعلون‎", "تفعلين‎", "تفعل‎", "تفعلان‎", "تفعلن‎", "يفعلن‎", "أفعل‎", "تفعل‎", "يفعل‎", "تفعلا‎", "يفعلا‎", "نفعل‎", "تفعلوا‎", "يفعلوا‎", "تفعلي‎", "تفعل‎", "تفعلا‎", "تفعلن‎", "يفعلن‎", "أفعل‎", "تفعل‎", "يفعل‎", "تفعلا‎", "يفعلا‎", "نفعل‎", "تفعلوا‎", "يفعلوا‎", "تفعلي‎", "تفعل‎", "تفعلا‎", "تفعلن‎", "يفعلن‎", "افعل‎", "افعلا‎", "افعلوا‎", "افعلي‎", "افعلن‎", "فعلت‎", "فعلت‎", "فعل", "فعلتما‎", "فعلا‎", "فعلنا‎", "فعلتم‎", "فعلوا‎", "فعلت‎", "فعلت‎", "فعلتا‎", "فعلتن‎", "فعلن‎", "أفعل‎", "تفعل‎", "يفعل‎", "تفعلان‎", "يفعلان‎", "نفعل‎", "تفعلون‎", "يفعلون‎", "تفعلين‎", "تفعل‎", "تفعلان‎", "تفعلن‎", "يفعلن‎", "أفعل‎", "تفعل‎", "يفعل‎", "تفعلا‎", "يفعلا‎", "نفعل‎", "تفعلوا‎", "يفعلوا‎", "تفعلي‎", "تفعل‎", "تفعلا‎", "تفعلن‎", "يفعلن‎", "أفعل‎", "تفعل‎", "يفعل‎", "تفعلا‎", "يفعلا‎", "نفعل‎", "تفعلوا‎", "يفعلوا‎", "تفعلي‎", "تفعل‎", "تفعلا‎", "تفعلن‎", "يفعلن‎", "قصد", "مقصد‎", "قاصد‎", "مقصود‎", "قصدت‎", "قصدت‎", "قصد", "قصدتما‎", "قصدا‎", "قصدنا‎", "قصدتم‎", "قصدوا‎", "قصدت‎", "قصدت‎", "قصدتا‎", "قصدتن‎", "قصدن‎", "أقصد‎", "تقصد‎", "يقصد‎", "تقصدان‎", "يقصدان‎", "نقصد‎", "تقصدون‎", "يقصدون‎", "تقصدين‎", "تقصد‎", "تقصدان‎", "تقصدن‎", "يقصدن‎", "أقصد‎", "تقصد‎", "يقصد‎", "تقصدا‎", "يقصدا‎", "نقصد‎", "تقصدوا‎", "يقصدوا‎", "تقصدي‎", "تقصد‎", "تقصدا‎", "تقصدن‎", "يقصدن‎", "أقصد‎", "تقصد‎", "يقصد‎", "تقصدا‎", "يقصدا‎", "نقصد‎", "تقصدوا‎", "يقصدوا‎", "تقصدي‎", "تقصد‎", "تقصدا‎", "تقصدن‎", "يقصدن‎", "اقصد‎", "اقصدا‎", "اقصدوا‎", "اقصدي‎", "اقصدن‎", "قصدت‎", "قصدت‎", "قصد", "قصدتما‎", "قصدا‎", "قصدنا‎", "قصدتم‎", "قصدوا‎", "قصدت‎", "قصدت‎", "قصدتا‎", "قصدتن‎", "قصدن‎", "أقصد‎", "تقصد‎", "يقصد‎", "تقصدان‎", "يقصدان‎", "نقصد‎", "تقصدون‎", "يقصدون‎", "تقصدين‎", "تقصد‎", "تقصدان‎", "تقصدن‎", "يقصدن‎", "أقصد‎", "تقصد‎", "يقصد‎", "تقصدا‎", "يقصدا‎", "نقصد‎", "تقصدوا‎", "يقصدوا‎", "تقصدي‎", "تقصد‎", "تقصدا‎", "تقصدن‎", "يقصدن‎", "أقصد‎", "تقصد‎", "يقصد‎", "تقصدا‎", "يقصدا‎", "نقصد‎", "تقصدوا‎", "يقصدوا‎", "تقصدي‎", "تقصد‎", "تقصدا‎", "تقصدن‎", "يقصدن‎", "زائل‎", "زلت‎", "زلت‎", "زال", "زلتما‎", "زالا‎", "زلنا‎", "زلتم‎", "زالوا‎", "زلت‎", "زالت‎", "زالتا‎", "زلتن‎", "زلن‎", "أزال‎", "تزال‎", "يزال‎", "تزالان‎", "يزالان‎", "نزال‎", "تزالون‎", "يزالون‎", "تزالين‎", "تزال‎", "تزالان‎", "تزلن‎", "يزلن‎", "أزال‎", "تزال‎", "يزال‎", "تزالا‎", "يزالا‎", "نزال‎", "تزالوا‎", "يزالوا‎", "تزالي‎", "تزال‎", "تزالا‎", "تزلن‎", "يزلن‎", "أزل‎", "تزل‎", "يزل‎", "تزالا‎", "يزالا‎", "نزل‎", "تزالوا‎", "يزالوا‎", "تزالي‎", "تزل‎", "تزالا‎", "تزلن‎", "يزلن‎", "زل‎", "زالا‎", "زالوا‎", "زالي‎", "زلن‎", "عملت‎", "عملت‎", "عمل", "عملتما‎", "عملا‎", "عملنا‎", "عملتم‎", "عملوا‎", "عملت‎", "عملت‎", "عملتا‎", "عملتن‎", "عملن‎", "أعمل‎", "تعمل‎", "يعمل‎", "تعملان‎", "يعملان‎", "نعمل‎", "تعملون‎", "يعملون‎", "تعملين‎", "تعملن‎", "يعملن‎", "أعمل‎", "تعمل‎", "يعمل‎", "تعملا‎", "يعملا‎", "نعمل‎", "تعملوا‎", "يعملوا‎", "تعملي‎", "أعمل‎", "تعمل‎", "يعمل‎", "نعمل‎", "اعمل‎", "اعملا‎", "اعملوا‎", "اعملي‎", "اعملن‎", "عملت‎", "عملت‎", "عمل", "عملتما‎", "عملا‎", "عملنا‎", "عملتم‎", "عملوا‎", "عملت‎", "عملت‎", "عملتا‎", "عملتن‎", "عملن‎", "أعمل‎", "تعمل‎", "يعمل‎", "تعملان‎", "يعملان‎", "نعمل‎", "تعملون‎", "يعملون‎", "تعملين‎", "تعملن‎", "يعملن‎", "أعمل", "تعمل‎", "يعمل‎", "تعملا‎", "يعملا‎", "نعمل‎", "تعملوا‎", "يعملوا‎", "تعملي‎", "أعمل‎", "تعمل‎", "يعمل‎", "نعمل‎", "عملت‎", "عننت‎", "عننت‎", "عن", "عننتما‎", "عنا‎", "عننا‎", "عننتم‎", "عنوا‎", "عننت‎", "عنت‎", "عنتا‎", "عننتن‎", "عنن‎", "أعن‎", "أعن‎", "تعن‎", "تعن‎", "يعن‎", "يعن‎", "تعنان‎", "تعنان‎", "يعنان‎", "يعنان‎", "نعن‎", "نعن‎", "تعنون‎", "تعنون‎", "يعنون‎", "يعنون‎", "تعنين‎", "تعنين‎", "تعنن‎", "تعنن‎", "يعنن‎", "يعنن‎", "أعن‎", "أعن‎", "تعن‎", "تعن‎", "يعن‎", "يعن‎", "تعنا‎", "تعنا‎", "يعنا‎", "يعنا‎", "نعن‎", "نعن‎", "تعنوا‎", "تعنوا‎", "يعنوا‎", "يعنوا‎", "تعني‎", "تعني‎", "أعن‎", "أعنن‎", "أعن‎", "أعنن‎", "تعن‎", "تعنن‎", "تعن‎", "تعنن‎", "يعن‎", "يعنن‎", "يعن‎", "يعنن‎", "نعن‎", "نعنن‎", "نعن‎", "نعنن‎", "عن", "عن", "اعنن‎", "عن", "عن", "اعنن‎", "عنا‎", "عنا‎", "‎عنوا‎", "عني‎", "عني‎", "اعنن‎", "اعنن‎", "يعن‎", "يعن‎", "يعن‎", "يعنن‎", "قمت‎", "قمت‎", "قام", "قمتما‎", "قاما‎", "قمنا‎", "قمتم‎", "قاموا‎", "قمت‎", "قامت‎", "قامتا‎", "قمتن‎", "قمن‎", "أقوم‎", "تقوم‎", "يقوم‎", "تقومان‎", "يقومان‎", "نقوم‎", "تقومون‎", "يقومون‎", "تقومين‎", "تقمن‎", "يقمن‎", "أقوم‎", "تقوم‎", "يقوم‎", "تقوما‎", "يقوما‎", "نقوم‎", "تقوموا‎", "يقوموا‎", "تقومي‎", "أقم‎", "تقم‎", "يقم‎", "نقم‎", "قم‎", "قوما‎", "قوموا‎", "قومي‎", "قيم‎", "يقام‎", "يقام‎", "يقم‎", "وددت‎", "وددت‎", "ود", "وددتما‎", "ودا‎", "وددنا‎", "وددتم‎", "ودوا‎", "وددت‎", "ودت‎", "ودتا‎", "وددتن‎", "وددن‎", "أود‎", "تود‎", "يود‎", "تودان‎", "يودان‎", "نود‎", "تودون‎", "يودون‎", "تودين‎", "توددن‎", "يوددن‎", "أود‎", "تود‎", "يود‎", "تودا‎", "يودا‎", "نود‎", "تودوا‎", "يودوا‎", "تودي‎", "أود‎", "أودد‎", "تود‎", "تودد‎", "يود‎", "يودد‎", "نود‎", "نودد‎", "ود", "ايدد‎", "ودي‎", "ايددن‎", "وددت‎", "وددت‎", "ود", "وددتما‎", "ودا‎", "وددنا‎", "وددتم‎", "ودوا‎", "وددت‎", "ودت‎", "ودتا‎", "وددتن‎", "وددن‎", "أود‎", "تود‎", "يود‎", "تودان‎", "يودان‎", "نود‎", "تودون‎", "يودون‎", "تودين‎", "توددن‎", "يوددن‎", "أود‎", "تود‎", "يود‎", "تودا‎", "يودا‎", "نود‎", "تودوا‎", "يودوا‎", "تودي‎", "أود‎", "أودد‎", "تود‎", "تودد‎", "يود‎", "يودد‎", "نود‎", "نودد‎", "حاولت‎", "حاولت‎", "حاول", "حاولتما‎", "حاولا‎", "حاولنا‎", "حاولتم‎", "حاولوا‎", "حاولت‎", "حاولت‎", "حاولتا‎", "حاولتن‎", "حاولن‎", "أحاول‎", "تحاول‎", "يحاول‎", "تحاولان‎", "يحاولان‎", "نحاول‎", "تحاولون‎", "يحاولون‎", "تحاولين‎", "تحاولن‎", "يحاولن‎", "أحاول‎", "تحاول‎", "يحاول‎", "تحاولا‎", "يحاولا‎", "نحاول‎", "تحاولوا‎", "يحاولوا‎", "تحاولي‎", "أحاول‎", "تحاول‎", "يحاول‎", "نحاول‎", "حاول", "حاولا‎", "حاولوا‎", "حاولي‎", "حاولن‎", "حوولت‎", "حوولت‎", "حوول‎", "حوولتما‎", "حوولا‎", "حوولنا‎", "حوولتم‎", "حوولوا‎", "حوولت‎", "حوولت‎", "حوولتا‎", "حوولتن‎", "حوولن‎", "أحاول‎", "تحاول‎", "يحاول‎", "تحاولان‎", "يحاولان‎", "نحاول‎", "تحاولون‎", "يحاولون‎", "تحاولين‎", "تحاولن‎", "يحاولن‎", "أحاول‎", "تحاول‎", "يحاول‎", "تحاولا‎", "يحاولا‎", "نحاول‎", "تحاولوا‎", "يحاولوا‎", "تحاولي‎", "أحاول‎", "تحاول‎", "يحاول‎", "نحاول‎", "احتجت‎", "احتجت‎", "احتاج", "احتجتما‎", "احتاجا‎", "احتجنا‎", "احتجتم‎", "احتاجوا‎", "احتجت‎", "احتاجت‎", "احتاجتا‎", "احتجتن‎", "احتجن‎", "أحتاج‎", "تحتاج‎", "يحتاج‎", "تحتاجان‎", "يحتاجان‎", "نحتاج‎", "تحتاجون‎", "يحتاجون‎", "تحتاجين‎", "تحتجن‎", "يحتجن‎", "أحتاج‎", "تحتاج‎", "يحتاج‎", "تحتاجا‎", "يحتاجا‎", "نحتاج‎", "تحتاجوا‎", "يحتاجوا‎", "تحتاجي‎", "أحتج‎", "تحتج‎", "يحتج‎", "نحتج‎", "احتج‎", "احتاجي‎", "احتجت‎", "احتجت‎", "احتيج‎", "احتجتما‎", "احتيجا‎", "احتجنا‎", "احتجتم‎", "احتيجوا‎", "احتجت‎", "احتيجت‎", "احتيجتا‎", "احتجتن‎", "احتجن‎", "أحتاج‎", "تحتاج‎", "يحتاج‎", "تحتاجان‎", "يحتاجان‎", "نحتاج‎", "تحتاجون‎", "يحتاجون‎", "تحتاجين‎", "تحتجن‎", "يحتجن‎", "أحتاج‎", "تحتاج‎", "يحتاج‎", "تحتاجا‎", "يحتاجا‎", "نحتاج‎", "تحتاجوا‎", "يحتاجوا‎", "تحتاجي‎", "أحتج‎", "تحتج‎", "يحتج‎", "نحتج‎", "عنيت‎", "عنيت‎", "عنى", "عنيتما‎", "عنيا‎", "عنينا‎", "عنيتم‎", "عنوا‎", "عنيت‎", "عنت‎", "عنتا‎", "عنيتن‎", "عنين‎", "أعني‎", "تعني‎", "يعني‎", "تعنيان‎", "يعنيان‎", "نعني‎", "تعنون‎", "يعنون‎", "تعنين‎", "يعنين‎", "أعني‎", "تعني‎", "يعني‎", "تعنيا‎", "يعنيا‎", "نعني‎", "تعنوا‎", "يعنوا‎", "أعن‎", "تعن‎", "يعن‎", "نعن‎", "اعن‎", "اعنيا‎", "اعنوا‎", "اعني‎", "اعنين‎", "عنيت‎", "عنيت‎", "عني‎", "عنيتما‎", "عنيا‎", "عنينا‎", "عنيتم‎", "عنوا‎", "عنيت‎", "عنيت‎", "عنيتا‎", "عنيتن‎", "عنين‎", "أعنى‎", "تعنى‎", "يعنى‎", "تعنيان‎", "يعنيان‎", "نعنى‎", "تعنون‎", "يعنون‎", "تعنين‎", "يعنين‎", "تعنيا‎", "يعنيا‎", "تعنوا‎", "يعنوا‎", "تعني‎", "أعن‎", "تعن‎", "يعن‎", "نعن‎", "يعنين", "عندي‎", "عندنا‎", "عندك‎", "عندك‎", "عندكما‎", "عندكم‎", "عندكن‎", "عنده‎", "عندها‎", "عندهما‎", "عندهم‎", "عندهن‎", "بقاء", "البقاء‎", "بقاء", "البقاء‎", "بقاء", "بقاء", "البقاء‎", "بقاء", "بقاء", "البقاء‎", "بقاء"];

// These adjectives and adverbs are so general, they should never be suggested as a (single) keyword.
// Keyword combinations containing these adjectives/adverbs are fine.
const generalAdjectivesAdverbs$4 = ["جيد", "آخر", "رائع", "أفضل", "جيدة", "نفس", "فقط", "مجرد", "كبير", "الأفضل", "عظيم", "جميلة", "كبيرة", "رائعة", "جديد", "صغيرة", "الصغير", "متأكد", "مهما", "صغير", "جيدا", "الصغيرة", "أكبر", "جديدة", "افضل", "الجديد", "طويلة", "ممكن", "اخر", "طويل", "الممكن", "الخاصة", "سيئة", "الكبير", "حقيقي", "بعيدا", "الجيد", "مهم", "الجديدة", "كثير", "الكبيرة", "القليل", "ممتاز", "الحقيقي", "سيء", "معا", "قليل", "بعيد", "واضح", "مختلف", "متأكدة", "الصعب", "أسوأ", "حوالي", "كامل", "سيئ", "بالإمكان", "بكثير", "خاص", "سوية", "مختلفة", "قريب", "الأخير", "الأخيرة", "الافضل", "خير"];

const interjections$4 = ["واو", "هيا", "آه", "هيه", "هاى", "أوه", "أخخ", "هووه", "صه", "أوبس", "أها", "آخ", "أح", "شو", "ههههه"];

// These words and abbreviations are frequently used in recipes in lists of ingredients.
const recipeWords$4 = ["كلغ", "ملغ", "الكوارت", "جرام", "جالون", "ربع ", "كوارتات", "لتر", "سنتيلتر", "مليمتر", "دزينة", "ملاعق", "ذراع", "قبضة", "عربية", "قصبة", "بريد", "قدم", "ربع"];

const timeWords$4 = ["اليوم", "يوم", "ليلة", "دقيقة", "ساعة", "عام", "دقائق", "سنة", "الساعة", "أيام", "العام", "الأسبوع", "غدا", "ساعات", "أمس", "أشهر", "الأيام", "شهر", "السنة", "الغد", "يوما", "ثانية", "ثوان", "أسبوع", "أسابيع", "أسبوعا", "بالأمس"];

const vagueNouns$4 = ["الأمر", "الأشياء", "الشيء", "الأمور", "الامر", "أشياء", "جزء", "الاشياء", "الامور", "الطريقة", "طريقا", "طرق", "قطعة", "الأجزاء", "مادة", "مرات", "بالمئة", "جانب", "جوانب", "بند", "عنصر", "عناصر", "بنود", "فكرة", "موضوع", "تفصيل", "تفاصيل", "فرق", "فروق"];

const miscellaneous$3 = ["نعم", "حسنا", "إنه", "إني", "إنها", "إنك", "إنكم", "إنهم", "إنكما", "إنهما", "إننا", "إنهن", "فإن", "إنني", "كلا", "أجل", "أنه", "أنك", "انها", "أنها", "بأن", "أنني", "أنكم", "أنهما", "أنكما", "أنهن", "أنهم", "انك", "أني", "أننا", "انهم", "بأنك", "لأنه", "بأنه", "اني", "أننى", "انني", "اننا", "بأنني", "اننى", "بأني", "بأنها", "وأن", "بأننا", "للتو", "ها", "رجاء", "تفضل", "اجل", "حالك", "فضلك", "أرجوك", "هكذا", "انة", "بلى", "أعلى", "انى", "لا", "لن", "لم", "ولا", "ألا", "ولم", "ولن", "عدم", "فلا", "فلن", "يلا", "يلة"];

const titlesPreceding = ["السيد", "السيدة", "افندم", "سعادتك", "استاذة", "استاذ", "مدام", "أستاذ", "أسـتاذة", "الأخ", "الأخت"];

const transitionWords$8 = ["عندما", "مثل", "بالطبع", "لأن", "إذن", "بشكل", "متى", "حتى", "قبل", "ثم", "عند", "حيث", "بينما", "لمدة", "مثلك", "حين", "بأي", "زلت", "وعندما", "أثناء", "حينما", "أولا", "لاحقا", "أما", "وإلا", "لفترة", "كلما", "عندنا", "إلا", "الا"];

var functionWords$3 = {};

Object.defineProperty(functionWords$3, "__esModule", {
	value: true
});

functionWords$3.default = function () {
	return {
		// This export contains all of the above words.
		all: [].concat(cardinalNumerals$3, ordinalNumerals$3, pronouns$3, interrogatives$3, quantifiers$3, reflexivePronouns$3, indefinitePronouns$3, prepositions$2, conjunctions$3, interviewVerbs$3, intensifiers$3, auxiliariesAndDelexicalizedVerbs$3, generalAdjectivesAdverbs$3, interjections$3, recipeWords$3, timeWords$3, vagueNouns$3, miscellaneous$2, transitionWords$7)
	};
};

/**
 * Returns an object with function words.
 *
 * @returns {Object} The object filled with various categories of function word arrays.
 */
const cardinalNumerals$3 = ["یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه", "ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده", "بیست", "صد", "هزار", "میلیون", "میلیارد"];

const ordinalNumerals$3 = ["اول", "اوّل", "دوم", "سوم", "چهارم", "پنجم", "ششم", "هفتم", "هشتم", "نهم", "دهم", "یازدهم", "دوازدهم", "سیزدهم", "چهاردهم", "پانزدهم", "شانزدهم", "هفدهم", "هجدهم", "نوزدهم", "بیستم"];

const pronouns$3 = ["مرا", "من را", "من‌را", "به من", "تو را", "شما را", "شما", "به تو", "به شما", "اون رو", "اونو", "به اون", "اون", "او را", "به او", "او", "به ایشان", "ایشان را", "ایشان", "به ایشون", "ایشون رو", "ایشون را", "ایشون", "این", "این را", "آن", "به این", "به آن", "آن را", "این رو", "اینو", "ما را", "به ما", "به اونا", "آن‌ها", "آنها را", "آن‌ها را", "به آنها", "به آن‌ها", "اونا", "اونارو", "اونا رو", "من", "تو", "ما", "آنها"];

const interrogatives$3 = [];

const quantifiers$3 = [];

const reflexivePronouns$3 = ["خودم", "خودت", "خودش", "یک نفر خودش", "خودمان", "خودتان", "خودشان"];

const indefinitePronouns$3 = [];

const prepositions$2 = ["با", "بی", "در", "را", "یا", "اگر", "مگر", "نه", "چه", "باری", "بر", "برای", "برای این", "برای این که", "برای آن که", "برای آن", "از برای", "خواه", "زیرا", "که", "نیز", "چون", "چونان که", "چونان‌که", "چنان", "چنان‌چه", "چنانچه", "چنان‌که", "چونکه", "چون که", "چون‌که", "چندان که", "چندان‌که", "زیرا که", "زیراکه", "همین که", "همین‌که", "همان که", "همان‌که", "بلکه", "جز", "الا", "الاّ", "الی", "تا اینکه", "تااینکه", "تا آنکه", "تاآنکه", "آن‌جا که", "آن‌گاه که", "از آن‌جا که", "ازآنجاکه", "از آن‌که", "ازآنکه", "زیرا", "چون‌که", "چون که", "از این رو", "ازاین‌رو", "ازین‌رو", "از بس", "ازبس", "از بس که", "ازبس‌که", "از بهر آن‌که", "اکنون که", "اگرچه", "اگر چنانچه", "اگرچنانچه", "الا این‌که", "با این حال", "بااین‌حال", "با این‌که", "بااین‌که", "بااینکه", "با وجود این", "باوجوداین", "با این وجود", "بس که", "از بس که", "بس‌که", "از بس‌که", "به شرط آن‌که", "به‌شرط آن‌که", "به شرطی که", "به شروطی که", "بعد از", "قبل از", "از بعد از", "از قبل از", "اندر", "بدون", "علیه", "ضد", "غیر", "واسه‎ی", "برای", "واسه", "برای"];

const conjunctions$3 = [];

const interviewVerbs$3 = [];

const intensifiers$3 = [];

const auxiliariesAndDelexicalizedVerbs$3 = [];

const generalAdjectivesAdverbs$3 = [];

const interjections$3 = [];

const recipeWords$3 = [];

const timeWords$3 = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"];

const vagueNouns$3 = [];

const miscellaneous$2 = [];

const transitionWords$7 = ["دوباره", "قطعاً", "حتماً", "اصلاً", "قاعدتاً", "ظبیعتاً", "شاید", "کاملاً", "به", "از", "و", "همچنین", "هم", "مانند", "مثل", "شبیه به", "ولی", "اما", "امّا", "لیکن", "ولو", "در ضمن", "در کنار", "ترجیحاً", "وگرنه", "پس", "سپس", "وقتی", "زمانی که", "به خاطر", "مخصوصاً", "مشخصاً", "در کل", "بعد", "قبل", "تا"];

var functionWords$2 = {};

/** @module config/transitionWords */

const singleWords$5 = ["ahányszor", "ahelyett", "ahogy", "ahol", "ahonnan", "ahová", "akár", "akárcsak", "akkor", "alapvetően", "alighogy", "ám", "ámbár", "ámde", "ameddig", "amennyiben", "amennyire", "amennyiszer", "amíg", "amikor", "amikorra", "aminthogy", "amióta", "amire", "annálfogva", "annyira", "avagy", "azaz", "azazhogy", "azért", "azonban", "azonkívül", "azután", "bár", "befejezésül", "bizony", "csakhogy", "de", "dehát", "dehogy", "egybehangzóan", "egyidejűleg", "egyöntetűen", "egyöntetűleg", "ekképpen", "ellenben", "először", "előzőleg", "elsősorban", "ennélfogva", "eredményeképp", "eredményeképpen", "és", "eszerint", "ezért", "feltétlenül", "főként", "főleg", "függetlenül", "ha", "habár", "hanem", "hányszor", "harmadjára", "harmadszor", "hasonlóan", "hasonlóképpen", "hát", "hirtelen", "hirtelenjében", "hisz", "hiszen", "hogy", "hogyha", "hol", "holott", "honnan", "hová", "így", "illetőleg", "illetve", "immár", "is", "jóllehet", "kár", "kétségtelenül", "kifejezetten", "kiváltképp", "következésképpen", "legalábbis", "legfőképp", "maga", "máskülönben", "másodsorban", "másodszor", "meg", "mégis", "megkérdőjelezhetetlenül", "megkérdőjelezhetően", "mégpedig", "mégsem", "mennél", "mennyiszer", "merre", "mert", "merthogy", "midőn", "mielőtt", "míg", "mihelyt", "miként", "miképp", "mikor", "mikorra", "mindamellett", "mindazáltal", "mindazonáltal", "mindenekelőtt", "minél", "mint", "mintha", "minthogy", "mióta", "mire", "miután", "mivel", "mivelhogy", "nahát", "nehogy", "noha", "nos", "nyilvánvalóan", "óh", "összefoglalva", "összehasonlításképp", "összehasonlításképpen", "pedig", "például", "plusz", "s", "sajna", "satöbbi", "se", "sem", "sőt", "szintén", "tagadhatatlanul", "tehát", "továbbá", "tudniillik", "úgy", "ugyan", "ugyanis", "úgyhogy", "vagy", "vagyis", "valamennyi", "valamint", "valóban", "végezetül", "végül", "végülis", "viszont", "amerről", "hiába", "miközben", "egyszersmind", "csakugyan", "különben", "mialatt", "mintegy", "miszerint", "nemde", "ugye", "vajon", "semmint", "hacsak", "úgymint", "mintsem"];

const multipleWords$5 = ["a továbbiakban", "abba, hogy", "abban, hogy", "abból, hogy", "addig, amíg", "addig, hogy", "addig, míg", "afelé, hogy", "ahelyett, hogy", "ahhoz, hogy", "ahogy fent látható", "ahogy írtam", "ahogy megmutattam", "ahogy megjegyeztem", "akként, hogy", "akkorra, hogy", "amiatt, hogy", "amellett, hogy", "amint azt megjegyeztük", "amint csak", "amint láthatjuk", "anélkül, hogy", "annak érdekében, hogy", "annak okáért", "annyi, hogy", "annyi, mint", "annyira, hogy", "annyira, mint", "arra, hogy", "arról, hogy", "attól fogva, hogy", "attól, hogy", "avégett, hogy", "avégre, hogy", "az ellen, hogy", "az első dolog", "az első dolog, amit meg kell jegyezni", "az iránt, hogy", "azelőtt, hogy", "azért, hogy", "azonos módon", "azok után, hogy", "azon, hogy", "azonkívül, hogy", "azóta, hogy", "azt követően", "aztán pedig", "azután, hogy", "azzal a feltétellel, hogy", "azzal, hogy", "bár igaz lehet", "ebből a célból", "ebből az okból", "előbb vagy utóbb", "ennek eredményeként", "ennek folytán", "ennek megfelelően", "éppen ellenkezőleg", "éppen úgy", "erre a célra", "ezen felül", "fenntartás nélkül", "ha egyébként", "ha egyszer", "ha különben", "ha ugyan", "hasonló módon", "hogy sem", "hogy sem mint", "hol hol", "holott pedig", "időről időre", "igaz, hogy", "így tehát", "ilyen körülmények között", "késedelem nélkül", "kétség nélkül", "más szóval", "más szavakkal", "másképpen fogalmazva", "még akkor is", "még ha", "mert különben", "mert tény, hogy", "mind mind", "mindaddig, amíg", "mindezek után", "mint sem hogy", "nem is beszélve", "nem különben", "nem úgy, mint", "oda, hogy", "oly módon, hogy", "sem hogy", "szem előtt tartva", "tény, hogy", "úgy, hogy", "úgy, mint", "ugyanazon okból", "ugyanolyan okból", "olybá tűnik", "egyszer s mindenkorra", "akkor, amikor", "azóta, mióta", "attól kezdve, mióta", "attól kezdve, hogy", "akkorra, amikorra", "akkor, ha", "azóta, amióta", "akkorra, amikorra", "addigra, amikorra", "akkor, hogyha", "akkor, ha", "úgy-ahogy", "mintsem hogy"];

/**
 * Returns an list with transition words to be used by the assessments.
 * @returns {Object} The list filled with transition word lists.
 */
var transitionWords$6 = function () {
	return {
		singleWords: singleWords$5,
		multipleWords: multipleWords$5,
		allWords: singleWords$5.concat(multipleWords$5)
	};
};

Object.defineProperty(functionWords$2, "__esModule", {
	value: true
});

functionWords$2.default = function () {
	return {
		// This export contains all of the above words.
		all: [].concat(articles$2, cardinalNumerals$2, ordinalNumerals$2, pronouns$2, interrogatives$2, quantifiers$2, reflexivePronouns$2, indefinitePronouns$2, postpositions, conjunctions$2, interviewVerbs$2, intensifiers$2, auxiliariesAndDelexicalizedVerbs$2, generalAdjectivesAdverbs$2, interjections$2, recipeWords$2, timeWords$2, vagueNouns$2, miscellaneous$1, transitionWords$5)
	};
};

var _transitionWords$1 = transitionWords$6;

var _transitionWords2$1 = _interopRequireDefault$2N(_transitionWords$1);

function _interopRequireDefault$2N(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const transitionWords$5 = (0, _transitionWords2$1.default)().singleWords;

/**
 * Returns an object with function words.
 *
 * @returns {Object} The object filled with various categories of function word arrays.
 */
const articles$2 = ["a", "az", "egy"];

const cardinalNumerals$2 = ["egy", "kettő", "három", "négy", "öt", "hat", "hét", "nyolc", "kilenc", "tíz", "tizenegy", "tizenkettő", "tizenhárom", "tizennégy", "tizenöt", "tizenhat", "tizenhét", "tizennyolc", "tizenkilenc", "húsz", "száz", "ezer", "tízezer", "százezer", "millió", "félmillió", "egymillió"];

const ordinalNumerals$2 = ["első", "második", "harmadik", "negyedik", "ötödik", "hatodik", "hetedik", "nyolcadik", "kilencedik", "tizedik", "tizenegyedik", "tizenkettedik", "tizenharmadik", "tizennegyedik", "tizenötödik", "tizenhatodik", "tizenhetedik", "tizennyolcadik", "tizenkilencedik", "huszadik", "századik", "ezredik", "tízezredik", "százezredik", "milliomodik", "egymilliomodik"];

const pronouns$2 = [
// Personal pronouns.
"én", "engem", "enyém", "nekem", "velem", "értem", "bennem", "belém", "belőlem", "nálam", "hozzám", "tőlem", "rajtam", "rám", "rólam", "te", "téged", "tiéd", "neked", "veled", "érted", "benned", "beléd", "belőled", "nálad", "hozzád", "tőled", "rajtad", "rád", "rólad", "ő", "őt", "övé", "neki", "vele", "érte", "benne", "bele", "belé", "nála", "hozzá", "tőle", "rajta", "rá", "róla", "mi", "minket", "mienk", "nekünk", "velünk", "értünk", "bennünk", "belénk", "nálunk", "hozzánk", "tőlünk", "rajtunk", "ránk", "rólunk", "ti", "titeket", "tiétek", "nektek", "veletek", "értetek", "bennetek", "belétek", "nálatok", "hozzátok", "tőletek", "rajtatok", "rátok", "rólatok", "ők", "őket", "övék", "nekik", "velük", "értük", "bennük", "beléjük", "náluk", "hozzájuk", "tőlük", "rajtuk", "rájuk", "róluk", "Ön", "Önt", "Öné", "Önnek", "Önnel", "Önért", "Önben", "Önbe",
// Formal pronouns.
"Ön", "Önt", "Öné", "Önnek", "Önnel", "Önért", "Önben", "Önbe", "Önből", "Önnél", "Önhöz", "Öntől", "Önön", "Önre", "Önről", "Önök", "Önöket", "Önöké", "Önöknek", "Önökkel", "Önökért", "Önökben", "Önökbe", "Önökből", "Önöknél", "Önökhöz", "Önöktől", "Önökön", "Önökre", "Önökről",
// Demonstrative pronouns.
"ez", "emez", "ugyanez", "ezt", "emezt", "ugyanezt", "ezé", "emezé", "ugyanezé", "ennek", "emennek", "ugyanennek", "ezzel", "emezzel", "ugyanezzel", "ezért", "emezért", "ugyanezért", "ebben", "emebben", "ugyanebben", "ebbe", "emebbe", "ugyanebbe", "ebből", "emebből", "ugyanebből", "ennél", "emennél", "ugyanennél", "ehhez", "emehhez", "ugyanehhez", "ettől", "emettől", "ugyanettől", "ezen", "emezen", "ugyanezen", "erre", "emerre", "ugyanerre", "erről", "emerről", "ugyanerről", "eddig", "emeddig", "ugyaneddig", "ekkor", "emekkor", "ugyanekkor", "ezzé", "emezzé", "ugyanezzé", "ekként", "emekként", "ugyanekként", "az", "amaz", "ugyanaz", "azt", "amazt", "ugyanazt", "azé", "amazé", "ugyanazé", "annak", "amannak", "ugyanannak", "azzal", "amazzal", "ugyanazzal", "azért", "amazért", "ugyanazért", "abban", "amabban", "ugyanabban", "abba", "amabba", "ugyanabba", "abból", "amabból", "ugyanabból", "annál", "amannál", "ugyanannál", "ahhoz", "amahhoz", "ugyanahhoz", "attól", "amattól", "ugyanattól", "azon", "amazon", "ugyanazon", "arra", "amarra", "ugyanarra", "arról", "amarról", "ugyanarról", "addig", "amaddig", "ugyanaddig", "akkor", "amakkor", "ugyanakkor", "azzá", "amazzá", "ugyanazzá", "akként", "amakként", "ugyanakként", "ilyen", "emilyen", "ugyanilyen", "ilyet", "emilyet", "ugyanilyet", "ilyennek", "emilyennek", "ugyanilyennek", "ilyennel", "emilyennel", "ugyanilyennel", "ilyenért", "emilyenért", "ugyanilyenért", "ilyenben", "emilyenben", "ugyanilyenben", "ilyenbe", "emilyenbe", "ugyanilyenbe", "ilyenből", "emilyenből", "ugyanilyenből", "ilyennél", "emilyennél", "ugyanilyennél", "ilyenhez", "emilyenhez", "ugyanilyenhez", "ilyentől", "emilyentől", "ugyanilyentől", "ilyenen", "emilyenen", "ugyanilyenen", "ilyenre", "emilyenre", "ugyanilyenre", "ilyenről", "emilyenről", "ugyanilyenről", "ilyenkor", "emilyenkor", "ugyanilyenkor", "ilyenné", "emilyenné", "ugyanilyenné", "olyan", "amolyan", "ugyanolyan", "olyat", "amolyat", "ugyanolyat", "olyannak", "amolyannak", "ugyanolyannak", "olyannal", "amolyannal", "ugyanolyannal", "olyanért", "amolyanért", "ugyanolyanért", "olyanban", "amolyanban", "ugyanolyanban", "olyanba", "amolyanba", "ugyanolyanba", "olyanból", "amolyanból", "ugyanolyanból", "olyannál", "amolyannál", "ugyanolyannál", "olyanhoz", "amolyanhoz", "ugyanolyanhoz", "olyantól", "amolyantól", "ugyanolyantól", "olyanon", "amolyanon", "ugyanolyanon", "olyanra", "amolyanra", "ugyanolyanra", "olyanról", "amolyanról", "ugyanolyanról", "olyankor", "amolyankor", "ugyanolyankor", "olyanná", "amolyanná", "ugyanolyanná", "ennyi", "emennyi", "ugyanennyi", "ennyit", "emennyit", "ugyanennyit", "ennyinek", "emennyinek", "ugyanennyinek", "ennyivel", "emennyivel", "ugyanennyivel", "ennyiért", "emennyiért", "ugyanennyiért", "ennyiben", "emennyiben", "ugyanennyiben", "ennyibe", "emennyibe", "ugyanennyibe", "ennyiből", "emennyiből", "ugyanennyiből", "ennyinél", "emennyinél", "ugyanennyinél", "ennyihez", "emennyihez", "ugyanennyihez", "ennyitől", "emennyitől", "ugyanennyitől", "ennyin", "emennyin", "ugyanennyin", "ennyire", "emennyire", "ugyenennyire", "ennyiről", "emennyiről", "ugyanennyiről", "ennyivé", "emennyivé", "ugyanennyivé", "annyi", "amannyi", "ugyanannyi", "annyit", "amannyit", "ugyanannyit", "annyinak", "amannyinak", "ugyanannyinak", "annyival", "amannyival", "ugyanannyival", "annyiért", "amannyiért", "ugyanannyiért", "annyiban", "amannyiban", "ugyanannyiban", "annyiba", "amannyiba", "ugyanannyiba", "annyiból", "amannyiból", "ugyanannyiból", "annyinál", "amannyinál", "ugyanannyinál", "annyihoz", "amannyihoz", "ugyanannyihoz", "annyitól", "amannyitól", "ugyananyitól", "annyin", "amannyin", "ugyanannyin", "annyira", "amannyira", "ugyanannyira", "annyiról", "amannyiról", "ugyanannyiról", "annyivá", "amannyivá", "ugyanannyivá", "így", "emígy", "ugyanígy", "úgy", "amúgy", "ugyanúgy", "itt", "ott", "ugyanitt", "ogyanott", "ide", "oda", "ugyanide", "ugyanoda", "amoda", "emide", "innen", "onnan", "ugyaninnen", "ogyanonnan", "amonnan", "eminnen", "eddig", "addig", "ezután", "azután", "ezelőtt", "azelőtt", "ugyaneddig", "ugyanaddig", "emeddig", "amaddig", "ekkora", "ekkorát", "ekkorának", "ekkorával", "ekkoráért", "ekkorában", "ekkorába", "ekkorából", "ekkoránál", "ekkorához", "ekkorától", "ekkorán", "ekkorára", "ekkoráról", "ekkorává", "akkora", "akkorát", "akkorának", "akkorával", "akkoráért", "akkorában", "akkorába", "akkorából", "akkoránál", "akkorához", "akkorától", "akkorán", "akkorára", "akkoráról", "akkorává", "ekképpen", "akképpen", "ezek", "emezek", "ugyanezek", "ezeket", "emezeket", "ugyanezeket", "ezeké", "emezeké", "ugyanezeké", "ezeknek", "emezeknek", "ugyanezeknek", "ezekkel", "emezekkel", "ugyanezekkel", "ezekért", "emezekért", "ugyanezekért", "ezekben", "emezekben", "ugyanezekben", "ezekbe", "emezekbe", "ugyanezekbe", "ezekből", "emezekből", "ugyanezekből", "ezeknél", "emezeknél", "ugyanezeknél", "ezekhez", "emezekhez", "ugyanezekhez", "ezektől", "emezektől", "ugyanezektől", "ezekre", "emezekre", "ugyanezekre", "ezekről", "emezekről", "ugyanezekről", "ezekig", "emezekig", "ugyanezekig", "ezekké", "emezekké", "ugyanezekké", "ezekként", "emezekként", "ugyanezekként", "azok", "amazok", "ugyanazok", "azokat", "amazokat", "ugyanazokat", "azoké", "amazoké", "ugyanazoké", "azoknak", "amazoknak", "ugyanazoknak", "azokkal", "amazokkal", "ugyanazokkal", "azokért", "amazokért", "ugyanazokért", "azokban", "amazokban", "ugyanazokban", "azokba", "amazokba", "ugyanazokba", "azokból", "amazokból", "ugyanazokból", "azoknál", "amazoknál", "ugyanazoknál", "azokhoz", "amazokhoz", "ugyanazokhoz", "azoktól", "amazoktól", "ugyanazoktól", "azokra", "amazokra", "ugyanazokra", "azokról", "amazokról", "ugyanazokról", "azokig", "amazokig", "ugyanazokig", "azokká", "amazokká", "ugyanazokká", "ilyenek", "emilyenek", "ugyanilyenek", "ilyeneket", "emilyeneket", "ugyanilyeneket", "ilyeneknek", "emilyeneknek", "ugyanilyeneknek", "ilyenekkel", "emilyenekkel", "ugyanilyenekkel", "ilyenekért", "emilyenekért", "ugyanilyenekért", "ilyenekben", "emilyenekben", "ugyanilyenekben", "ilyenekbe", "emilyenekbe", "ugyanilyenekbe", "ilyenekből", "emilyenekből", "ugyanilyenekből", "ilyeneknél", "emilyeneknél", "ugyanilyeneknél", "ilyenekhez", "emilyenekhez", "ugyanilyenekhez", "ilyenektől", "emilyenektől", "ugyanilyenektől", "ilyeneken", "emilyeneken", "ugyanilyeneken", "ilyenekre", "emilyenekre", "ugyanilyenekre", "ilyenekről", "emilyenekről", "ugyanilyenekről", "ilyenekké", "emilyenekké", "ugyanilyenekké", "olyanok", "amolyanok", "ugyanolyanok", "olyanokat", "amolyanokat", "ugyanolyanokat", "olyanoknak", "amolyanoknak", "ugyanolyanoknak", "olyanokkal", "amolyanokkal", "ugyanolyanokkal", "olyanokért", "amolyanokért", "ugyanolyanokért", "olyanokban", "amolyanokban", "ugyanolyanokban", "olyanokba", "amolyanokba", "ugyanolyanokba", "olyanokból", "amolyanokból", "ugyanolyanokból", "olyanoknál", "amolyanoknál", "ugyanolyanoknál", "olyanokhoz", "amolyanokhoz", "ugyanolyanokhoz", "olyanoktól", "amolyanoktól", "ugyanolyanoktól", "olyanokon", "amolyanokon", "ugyanolyanokon", "olyanokra", "amolyanokra", "ugyanolyanokra", "olyanokról", "amolyanokról", "ugyanolyanokról", "olyanokká", "amolyanokká", "ugyanolyanokká",
// Relative pronouns.
"aki", "akit", "akié", "akinek", "akivel", "akiért", "akiben", "akibe", "akiből", "akinél", "akihez", "akitől", "akin", "akire", "akiről", "akivé", "ami", "amit", "amié", "aminek", "amivel", "amiért", "amiben", "amibe", "amiből", "aminél", "amihez", "amitől", "amin", "amire", "amiről", "amivé", "amilyen", "amilyet", "amilyennek", "amilyennel", "amilyenért", "amilyenben", "amilyenbe", "amilyenből", "amilyennél", "amilyenhez", "amilyentől", "amilyenen", "amilyenre", "amilyenről", "amilyenné", "amekkora", "amekkorát", "amekkorának", "amekkorával", "amekkoráért", "amekkorában", "amekkorába", "amekkorából", "amekkoránál", "amekkorához", "amekkorától", "amekkorán", "amekkorára", "amekkoráról", "amekkorává", "amely", "amelyet", "amelynek", "amellyel", "amelyért", "amelyben", "amelybe", "amelyből", "amelynél", "amelyhez", "amelytől", "amelyen", "amelyre", "amelyről", "amellyé", "ahány", "ahányat", "ahánynak", "ahánnyal", "ahányért", "ahányban", "ahányba", "ahányból", "ahánynál", "ahányhoz", "ahánytól", "ahányan", "ahányra", "ahányról", "ahánnyá", "amennyi", "amennyit", "amennyinek", "amennyivel", "amennyiért", "amennyiben", "amennyibe", "amennyiből", "amennyinél", "amennyihez", "amennyitől", "amennyin", "amennyire", "amennyiről", "amennyivé", "ahányadik", "ahányadikat", "ahányadiknak", "ahányadika", "ahányadikért", "ahányadikban", "ahányadikba", "ahányadikból", "ahányadiknál", "ahányadikhoz", "ahányadiktól", "ahányadikon", "ahányadikra", "ahányadikról", "ahányadikká", "ahová", "ahonnan", "ahonnantól", "amerre", "amerről", "ahogy", "ahogyan", "amiért", "amikor", "amikortól", "amikorra", "akik", "akiket", "akiké", "akiknek", "akikkel", "akikért", "akikben", "akikbe", "akikból", "akiknél", "akikhez", "akiktől", "akiken", "akikre", "akikről", "akikké", "amik", "amiket", "amiké", "amiknek", "amikkel", "amikért", "amikben", "amikbe", "amikból", "amiknél", "amikhez", "amiktől", "amiken", "amikre", "amikről", "amikké", "amilyenek", "amilyeneket", "amilyeneknek", "amilyenekkel", "amilyenekért", "amilyenekben", "amilyenekbe", "amilyenekből", "amilyeneknél", "amilyenekhez", "amilyenektől", "amilyeneken", "amilyenekre", "amilyenekről", "amekkorák", "amekkorákat", "amekkoráknak", "amekkorákkal", "amekkorákért", "amekkorákban", "amekkorákba", "amekkorákból", "amekkoráknál", "amekkorákhoz", "amekkoráktól", "amekkorákon", "amekkorákra", "amekkorákról", "amekkorákká", "amelyek", "amelyeket", "amelyeknek", "amelyekkel", "amelyekért", "amelyekben", "amelyekbe", "amelyekből", "amelyeknél", "amelyekhez", "amelyektől", "amelyeken", "amelyekre", "amelyekről", "ahányak", "ahányakat", "ahányaknak", "ahányakkal", "ahányakért", "ahányakban", "ahányakba", "ahányakból", "ahányaknál", "ahányakhoz", "ahányaktól", "ahányakon", "ahányakra", "ahányakról", "ahányakká", "amennyik", "amennyiket", "amennyiknek", "amennyikkel", "amennyikért", "amennyikben", "amennyikbe", "amennyikből", "amennyiknél", "amennyikhez", "amennyiktől", "amennyiken", "amennyikre", "amennyikről", "amennyikké", "ahányadikak", "ahányadikat", "ahányadiknak", "ahányadikkal", "ahányadikért", "ahányadikban", "ahányadikba", "ahányadikból", "ahányadiknál", "ahányadikhoz", "ahányadiktól", "ahányadikon", "ahányadikra", "ahányadikról", "ahányadikká", "amikért",
// Reciprocal pronouns.
"egymás", "egymást", "egymásé", "egymásnak", "egymással", "egymásért", "egymásban", "egymásba", "egymásból", "egymásnál", "egymáshoz", "egymástól", "egymáson", "egymásra", "egymásról", "egymássá"];

const interrogatives$2 = ["ki", "kit", "kié", "kinek", "kivel", "kiért", "kiben", "kibe", "kiből", "kinél", "kihez", "kitől", "kin", "kire", "kiről", "kicsoda", "kicsodát", "kicsodának", "kicsodával", "kicsodáért", "kicsodában", "kicsodába", "kicsodából", "kicsodánál", "kicsodához", "kicsodától", "kicsodán", "kicsodára", "kicsodáról", "mi", "mit", "minek", "mivel", "miért", "miben", "mibe", "miből", "minél", "mihez", "mitől", "min", "mire", "miről", "micsoda", "micsodát", "micsodának", "micsodával", "micsodáért", "micsodában", "micsodába", "micsodából", "micsodánál", "micsodához", "micsodától", "micsodán", "micsodára", "micsodáról", "milyen", "milyet", "milyennek", "milyennel", "milyenért", "milyenben", "milyenbe", "milyenből", "milyennél", "milyenhez", "milyentől", "milyenen", "milyenre", "milyenről", "mekkora", "mekkorát", "mekkorának", "mekkorával", "mekkoráért", "mekkorában", "mekkorába", "mekkorából", "mekkoránál", "mekkorához", "mekkorától", "mekkorán", "mekkorára", "mekkoráról", "miféle", "mifélét", "mifélének", "mifélével", "miféléért", "mifélében", "mifélébe", "miféléből", "mifélénél", "miféléhez", "mifélétől", "mifélén", "mifélére", "miféléről", "melyik", "melyiket", "melyiknek", "melyikkel", "melyikért", "melyikben", "melyikbe", "melyikből", "melyiknél", "melyikhez", "melyiktől", "melyiken", "melyikre", "melyikről", "hány", "hányat", "hánynak", "hánnyal", "hányért", "hányban", "hányba", "hányból", "hánynál", "hányhoz", "hánytól", "hányon", "hányra", "hányról", "mennyi", "mennyit", "mennyinek", "mennyivel", "mennyiért", "mennyiben", "mennyibe", "mennyiből", "mennyinél", "mennyihez", "mennyitől", "mennyin", "mennyire", "mennyiről", "hányadik", "hányadikat", "hányadiknak", "hányadikkal", "hányadikért", "hányadikban", "hányadikba", "hányadikból", "hányadiknál", "hányadikhoz", "hányadiktól", "hányadikon", "hányadikra", "hányadikról", "hol", "hová", "honnan", "honnantól", "honnanról", "merre", "mettől", "merről", "meddig", "meddigtől", "meddigről", "mióta", "hogyan", "miként", "kik", "kiket", "kiknek", "kikkel", "kikért", "kikben", "kikbe", "kikből", "kiknél", "kikhez", "kiktől", "kiken", "kikre", "kikről", "kicsodák", "kicsodákat", "kicsodáknak", "kicsodákkal", "kicsodákért", "kicsodákban", "kicsodákba", "kicsodákból", "kicsodáknál", "kicsodákhoz", "kicsodáktól", "kicsodákon", "kicsodákra", "kicsodáról", "mik", "miket", "miknek", "mikkel", "mikért", "mikben", "mikbe", "mikből", "miknél", "mikhez", "miktől", "miken", "mikre", "mikről", "micsodák", "micsodákat", "micsodáknak", "micsodákkal", "micsodákért", "micsodákban", "micsodákba", "micsodákból", "micsodáknál", "micsodákhoz", "micsodáktól", "micsodákon", "micsodákra", "micsodákról", "milyenek", "milyeneket", "milyeneknek", "milyenekkel", "milyenekért", "milyenekben", "milyenekbe", "milyenekből", "milyeneknél", "milyenekhez", "milyenektől", "milyeneken", "milyenekre", "milyenekről", "mekkorák", "mekkorákat", "mekkoráknak", "mekkorákkal", "mekkorákért", "mekkorákban", "mekkorákba", "mekkorákból", "mekkoráknál", "mekkorákhoz", "mekkoráktól", "mekkorákon", "mekkorákra", "mekkorákról", "mifélék", "miféléket", "miféléknek", "mifélékkel", "mifélékért", "mifélékben", "mifélékbe", "mifélékből", "miféléknél", "mifélékhez", "miféléktől", "miféléken", "mifélékre", "mifélékről", "melyikek", "melyikeket", "melyikeknek", "melyikekkel", "melyikekért", "melyikekben", "melyikekbe", "melyikekből", "melyikeknél", "melyikekhez", "melyikektől", "melyikeken", "melyikekre", "melyikekről", "hányak", "hányakat", "hányaknak", "hányakkal", "hányakért", "hányakban", "hányakba", "hányakból", "hányaknál", "hányakhoz", "hányaktól", "hányakon", "hányakra", "hányakról", "mennyik", "mennyiket", "mennyiknek", "mennyikkel", "mennyikért", "mennyikben", "mennyikbe", "mennyikből", "mennyiknél", "mennyikhez", "mennyiktől", "mennyiken", "mennyikre", "mennyikről", "hányadikak", "hányadikakat", "hányadikaknak", "hányadikakkal", "hányadikakért", "hányadikakban", "hányadikakba", "hányadikakból", "hányadikaknál", "hányadikakhoz", "hányadikaktól", "hányadikakon", "hányadikakra", "hányadikakról"];

const quantifiers$2 = ["sok", "kevés", "elég", "jónéhány", "néhány", "rengeteg", "töredék", "temérdek", "tengernyi", "számtalan", "számos", "elegendő", "kevéske", "egy csomó", "egy rakás", "egy halom"];

const reflexivePronouns$2 = ["magam", "magamat", "magamé", "magamnak", "magammal", "magamért", "magamban", "magamba", "magamból", "magamnál", "magamhoz", "magamtól", "magamon", "magamra", "magamról", "magammá", "magad", "magadat", "magadé", "magadnak", "magaddal", "magadért", "magadban", "magadba", "magadból", "magadnál", "magadhoz", "magadtól", "magadon", "magadra", "magadról", "magaddá", "maga", "magát", "magáé", "magának", "magával", "magáért", "magában", "magába", "magából", "magánál", "magához", "magától", "magán", "magára", "magáról", "magává", "magunk", "magunkat", "magunké", "magunknak", "magunkkal", "magunkért", "magunkban", "magunkba", "magunkból", "magunknál", "magunkhoz", "magunktól", "magunkon", "magunkra", "magunkról", "magunkká", "magatok", "magatokat", "magatoké", "magatoknak", "magatokkal", "magatokért", "magatokban", "magatokba", "magatokból", "magatoknál", "magatokhoz", "magatoktól", "magatokon", "magatokra", "magatokról", "magatokká", "maguk", "magukat", "maguké", "maguknak", "magukkal", "magukért", "magukban", "magukba", "magukból", "maguknál", "magukhoz", "maguktól", "magukon", "magukra", "magukról", "magukká"];

const indefinitePronouns$2 = ["valaki", "valakit", "valakié", "valakinek", "valakivel", "valakiért", "valakiben", "valakibe", "valakiből", "valakinél", "valakihez", "valakitől", "valakin", "valakire", "valakiről", "valakivé", "valami", "valamit", "valamié", "valaminek", "valamivel", "valamiért", "valamiben", "valamibe", "valamiből", "valaminél", "valamihez", "valamitől", "valamin", "valamire", "valamiről", "valamivé", "valamilyen", "valamilyet", "valamilyennek", "valamilyennel", "valamilyenért", "valamilyenben", "valamilyenbe", "valamilyenből", "valamilyennél", "valamilyenhez", "valamilyentől", "valamilyenen", "valamilyenre", "valamilyenről", "valaminő", "valamelyes", "valamelyest", "valamekkora", "valamekkorát", "valamekkorának", "valamekkorával", "valamekkoráért", "valamekkorában", "valamekkorába", "valamekkorából", "valamekkoránál", "valamekkorához", "valamekkorától", "valamekkorán", "valamekkorára", "valamekkoráról", "valamekkorává", "valamely", "valamelyet", "valamelynek", "valamellyel", "valamelyért", "valamelyben", "valamelybe", "valamelyből", "valamelynél", "valamelyhez", "valamelytől", "valamelyen", "valamelyre", "valamelyről", "valamellyé", "valamelyik", "valamelyiket", "valemelyiknek", "valamelyikkel", "valamelyikért", "valamelyikben", "valamelyikbe", "valamelyikből", "valamelyiknél", "valamelyikhez", "valamelyiktől", "valamelyiken", "valamelyikre", "valamelyikről", "valamelyikké", "valamiféle", "valamifélét", "valamifélének", "valamifélével", "valamiféléért", "valamifélében", "valamifélébe", "valamiféléből", "valamifélénél", "valamiféléhez", "valamifélétől", "valamifélén", "valamifélére", "valamiféléről", "valamennyi", "valamennyit", "valamennyié", "valamennyinek", "valamennyivel", "valamennyiért", "valamennyiben", "valamennyibe", "valamennyiből", "valamennyinél", "valamennyihez", "valamennyitől", "valamennyin", "valamennyire", "valamennyiről", "valamennyivé", "valahány", "valahányat", "valahánynak", "valahánnyal", "valahányért", "valahányban", "valahányba", "valahányból", "valahánynál", "valahányhoz", "valahánytól", "valahányon", "valahányra", "valahányról", "valahánnyá", "némely", "némelyet", "némelynek", "némelynél", "némelyért", "némelyben", "némelybe", "némelyből", "némelynél", "némelyhez", "némelytől", "némelyen", "némelyre", "némelyről", "némi", "némelyik", "némelyiket", "némelyiknek", "némelyikkel", "némelyikért", "némelyikben", "némelyikbe", "némelyikből", "némelyiknél", "némelyikhez", "némelyiktől", "némelyiken", "némelyikre", "némelyikről", "néminemű", "néhány", "néhányat", "néhánynak", "néhánnyal", "néhányért", "néhányban", "néhányba", "néhányból", "néhánynál", "néhányhoz", "néhánytól", "néhányon", "néhányra", "néhányról", "valahol", "valahová", "valamerre", "valahonnan", "valamikor", "valaha", "valaha", "valahogyan", "valamiképpen", "valamiért", "néhol", "néha", "némelykor", "némiképpen", "némileg", "mindenki", "mindenféle", "mindegyik", "mindahány", "mindenhol", "mindenütt", "mindenhová", "mindenhonnan", "mindenkor", "mindenhogyan", "mindenképpen", "bárki", "bármi", "bármelyik", "bármilyen", "bármennyi", "bárhol", "bárhová", "bárhonnan", "bármikor", "bármeddig", "bárhogyan", "akárki", "akármi", "akármelyik", "akármilyen", "akármennyi", "akárhány", "akárhol", "akárhová", "akárhonnan", "akármikor", "akárhogyan", "senki", "semmi", "semmilyen", "semennyi", "sehány", "sehol", "sehová", "sehonnan", "semmikor", "sehogy", "semmiképp", "valakik", "valakiket", "valakiké", "valakiknek", "valakikkel", "valakikért", "valakikben", "valakikbe", "valakikből", "valakiknél", "valakikhez", "valakiktől", "valakiken", "valakikre", "valakikről", "valakikké", "valamik", "valamiket", "valamiké", "valamiknek", "valamikkel", "valamikért", "valamikben", "valamikbe", "valamikből", "valamiknél", "valamikhez", "valamiktől", "valamiken", "valamikre", "valamikről", "valamikké", "valamilyenek", "valamilyeneket", "valamilyeneknek", "valamilyenekkel", "valamilyenekért", "valamilyenekben", "valamilyenekbe", "valamilyenekből", "valamilyeneknél", "valamilyenekhez", "valamilyenektől", "valamilyeneken", "valamilyenekre", "valamilyenekről", "valamilyenekké", "valaminők", "valamekkorák", "valamekkorákat", "valamekkoráknak", "valamekkorákkal", "valamekkorákért", "valamekkorákban", "valamekkorákba", "valamekkorákból", "valamekkoráknál", "valamekkorákhoz", "valamekkoráktól", "valamekkorákon", "valamekkorákra", "valamekkorákról", "valamelyek", "valamelyeket", "valamelyeknek", "valamelyekkel", "valamelyekért", "valamelyekben", "valamelyekbe", "valamelyekből", "valamelyeknél", "valamelyekhez", "valamelyektől", "valamelyeken", "valamelyekre", "valamelyekről", "valamelyekké", "valamelyikek", "valamelyikeket", "valamelyikeknek", "valamelyikekkel", "valamelyikekért", "valamelyikekben", "valamelyikekbe", "valamelyikekből", "valamelyikeknél", "valamelyikekhez", "valamelyikektől", "valamelyikeken", "valamelyikekre", "valamelyikekről", "valamifélék", "valamiféléket", "valamiféléknek", "valamifélékkel", "valamifélékért", "valamifélékben", "valamifélékbe", "valamifélékből", "valamiféléknél", "valamifélékhez", "valamiféléktől", "valamiféléken", "valamifélékre", "valamifélékről", "valamennyik", "valamennyiket", "valamennyiknek", "valamennyikkel", "valamennyikért", "valamennyikben", "valamennyikbe", "valamennyikből", "valamennyiknél", "valamennyikhez", "valamennyiktől", "valamennyiken", "valamennyikre", "valamennyikről", "valahányak", "valahányakat", "valahányaknak", "valahányakkal", "valahányakért", "valahányakban", "valahányakba", "valahányakból", "valahányaknál", "valahányakhoz", "valahányaktól", "valahányakon", "valahányakra", "valahányakról", "némelyek", "némelyeket", "némelyeknek", "némelyekkel", "némelyekért", "némelyekben", "némelyekbe", "némelyekből", "némelyeknél", "némelyekhez", "némelyektől", "némelyeken", "némelyekre", "némelyekről", "némelyikek", "némelyikeket", "némelyikeknek", "némelyikekkel", "némelyikekért", "némelyikekben", "némelyikekbe", "némelyikekből", "némelyikeknél", "némelyikekhez", "némelyikektől", "némelyikeken", "némelyikekre", "némelyikekről", "néhányak", "néhányakat", "néhányaknak", "néhányakkal", "néhányakért", "néhányakban", "néhányakba", "néhányakból", "néhányaknál", "néhányakhoz", "néhányaktól", "néhányakon", "néhányakra", "néhányakról"];

const postpositions = ["előtt", "elé", "elől", "alatt", "alá", "alól", "túl", "alatt", "belül", "előtt", "fogva", "hosszat", "múlva", "óta", "tájt", "ellen", "helyett", "iránt", "miatt", "nélkül", "részére", "számára", "végett", "között"];

const conjunctions$2 = ["és", "s", "se", "sem", "vagy", "is", "de"];

const interviewVerbs$2 = ["mond", "bejelent", "megerősít", "kijelent", "javasol", "említ", "tájékoztat", "értesít", "kérdez", "beszél", "megkérdez", "állít", "elmagyaráz", "magyaráz", "gondol", "hisz", "megtárgyal", "tárgyal", "vitat", "megvitat", "ért", "megért", "elmond", "elmesél", "tud", "megtud", "megbeszél", "megmond", "megmagyaráz"];

const intensifiers$2 = ["alig", "kissé", "különösen", "nagyon", "teljesen", "túl", "túlságosan", "kevésbé", "nagyrészt", "kicsit", "picit", "szörnyen", "borzasztóan", "iszonyatosan", "irtó", "irtózatosan", "komolyan", "súlyosan", "könnyedén", "nehezen"];

const auxiliariesAndDelexicalizedVerbs$2 = ["fog", "volna", "akar", "bír", "kell", "kíván", "látszik", "lehet", "tud", "szabad", "tetszik", "méltóztatik", "szokott"];

const generalAdjectivesAdverbs$2 = [
// General adjective.
"nagy", "kicsi", "gyors", "lassú", "jó", "rossz", "drága", "olcsó", "vastag", "vékony", "keskeny", "széles", "puha", "hangos", "halk", "intelligens", "buta", "nedves", "száraz", "nehéz", "könnyű", "kemény", "lágy", "sekély", "mély", "gyönge", "erős", "gazdag", "szegény", "fiatal", "öreg", "hosszú", "rövid", "magas", "alacsony", "bőkezű", "fukar", "igaz", "hamis", "gyönyörű", "csúnya", "új", "régi", "boldog", "szomorú", "idős", "gyenge", "biztonságos", "veszélyes", "korán", "későn", "világos", "sötét", "nyitva", "zárva", "szoros", "laza", "teli", "üres", "sok", "kevés", "élő", "halott", "meleg", "hideg", "érdekes", "unalmas", "szerencsés", "szerencsétlen", "fontos", "lényegtelen", "messze", "közel", "tiszta", "piszkos", "kedves", "gonosz", "kellemes", "kellemetlen", "kiváló", "borzalmas", "normális", "szép",
// General adverbs.
"nagyon", "kicsit", "gyorsan", "lassan", "jól", "rosszul", "drágán", "olcsón", "hangosan", "halkan", "nehezen", "könnyen", "gyengén", "erősen", "gazdagon", "fiatalon", "öreg", "hosszan", "röviden", "magasan", "alacsonyan", "bőkezűen", "gyönyörűen", "csúnyán", "boldogan", "szomorúan", "gyengéden", "biztonságosan", "veszélyesen", "világosan", "szorosan", "lazán", "sokan", "kevesen", "élve", "melegen", "hidegen", "érdekesen", "unalmasan", "szerencsésen", "szerencsétlenül", "tisztán", "piszkosan", "kedvesen", "gonoszan", "kellemesen", "kellemetlenül", "kiválóan", "borzalmasan", "normálisan", "szépen"];

const interjections$2 = ["ó", "óh", "jaj", "a kutyafáját", "a fenébe", "a csudába", "a francba", "atyaég", "atyavilág", "azta", "aztamindenit", "juj", "juhú", "éljen", "jé", "hű", "hú", "ajjaj", "pszt", "csitt", "hess", "hé", "ej", "ejnye", "na", "nicsak", "nocsak", "natessék", "nahát", "rajta", "hajrá", "juhú", "teringettét", "nosza", "uccu", "csitt", "kuss", "dirr", "durr"];

const recipeWords$2 = ["liter", "l", "deciliter", "dl", "milliliter", "gramm", "g", "dekagramm", "dkg", "kilogramm", "kg", "milligramm", "mg", "tucat", "centiliter", "cl", "méter", "m", "deciméter", "dm", "centiméter", "cm", "milliméter", "mm", "evőkanál", "ek.", "mokkáskanál", "mk.", "kávéskanál", "kk.", "gyermekkanál", "gyk.", "kávéscsésze", "kcs.", "teáscsésze", "tcs.", "csésze", "csé.", "bögre", "bgr.", "mélytányér", "ujjnyi", "csomag", "gerezd", "csokor"];

const timeWords$2 = ["másodperc", "perc", "óra", "nap", "hét", "hónap", "év", "évtized", "évszázad", "évezred", "ma", "holnap", "tegnap", "jövő héten", "jövő hónapban", "jövő évben", "múlt héten", "múlt hónapban", "múlt évben", "tavaly", "jövőre", "reggel", "délben", "este", "éjszaka", "hajnalban", "délután", "délelőtt"];

const vagueNouns$2 = ["dolog", "izé", "valami", "személy", "ember", "alkalom", "eset", "ügy", "tárgy", "valamicsoda", "téma", "ötlet"];

const miscellaneous$1 = ["stb.",
// Fractions.
"fél", "harmad", "negyed", "ötöd", "hatod", "heted", "nyolcad", "kilenced", "tized", "egyharmad", "egynegyed", "egyötöd", "egyhatod", "egyheted", "egynyolcad", "egykilenced", "egytized", "század", "ezred"];

var functionWords$1 = {};

Object.defineProperty(functionWords$1, "__esModule", {
	value: true
});

functionWords$1.default = function () {
	return {
		// This export contains all of the above words.
		all: [].concat(articles$1, cardinalNumerals$1, ordinalNumerals$1, pronouns$1, interrogatives$1, quantifiers$1, reflexivePronouns$1, indefinitePronouns$1, prepositions$1, conjunctions$1, interviewVerbs$1, intensifiers$1, auxiliariesAndDelexicalizedVerbs$1, generalAdjectivesAdverbs$1, interjections$1, recipeWords$1, timeWords$1, vagueNouns$1, miscellaneous)
	};
};

/**
 * Returns an object with function words.
 *
 * @returns {Object} The object filled with various categories of function word arrays.
 */
const articles$1 = ["det", "en"];

const cardinalNumerals$1 = ["en", "to", "tre", "fire", "fem", "seks", "syv", "åtte", "ni", "ti", "elleve", "tolv", "tretten", "fjorten", "femten", "seksten", "sytten", "atten", "nitten", "tjue", "hundre", "tusen", "million", "milliarder"];

const ordinalNumerals$1 = ["første", "først", "sekund", "tredje", "fjerde", "femte", "sjette", "syvende", "åttende", "niende", "tiende"];

const pronouns$1 = [
// Personal pronouns.
"jeg", "du", "den", "vi", "de", "han", "hun", "henne", "oss", "meg", "ham", "dem",
// Possessive pronouns.
"vår", "deres", "ditt", "mitt", "våre", "vårt", "hans", "hennes", "dens", "egen", "egne",
// Demonstrative pronouns.
"denne", "dette", "disse",
// Reciprocal pronouns.
"hverandre", "hvert"];

const interrogatives$1 = ["hvem", "hvordan", "hvorfor", "hvor", "hva", "hvilken", "hvilket"];

const quantifiers$1 = ["mange", "hele", "mer", "ingen", "alle", "noen", "flere", "hver", "begge", "sov", "mest", "fleste"];

const reflexivePronouns$1 = [];

const indefinitePronouns$1 = ["ingenting"];

const prepositions$1 = ["sånn", "ved", "mot", "ned", "enn", "over", "inn", "sa", "opp", "der", "fra", "din", "nei", "mellom", "di", "oppe", "av", "om", "den", "de", "at", "med", "til", "å", "på", "du", "uten", "én", "under", "hos", "inne", "gjennom", "unna", "del", "nede", "kun", "innen", "blant"];

const conjunctions$1 = ["eller", "hvis", "ja", "et", "som", "i", "og"];

const interviewVerbs$1 = ["tror", "fortelle", "fortell", "fortalte", "tenkte", "tenk"];

const intensifiers$1 = ["virkelig", "akkurat", "visst"];

const auxiliariesAndDelexicalizedVerbs$1 = [];

const generalAdjectivesAdverbs$1 = [
// General adjective.
"helt", "andre", "litt", "lenge", "siste", "fint", "annet", "stor", "neste", "lenger", "annen", "nye", "alene", "flott", "klart", "liten", "langt", "gamle", "dårlig", "hyggelig", "gode", "sånt", "nytt", "best", "lang", "små", "lot", "større", "høyt", "største", "slikt",
// General adverbs.
"alltid", "godt", "sammen", "tilbake", "etter", "igjen", "bare", "så", "veldig", "bedre", "samme", "far", "eneste", "enig", "borte", "snart", "rundt", "beste", "bort", "vekk", "nesten", "ganske", "senere", "videre", "mindre", "straks", "svært"];

const interjections$1 = ["hei"];

const recipeWords$1 = [];

const timeWords$1 = ["år", "dag", "nå", "tid", "tiden", "morgen", "dager", "minutter", "dagen", "uke", "uker", "måneder", "stund"];

const vagueNouns$1 = ["ting", "tingene"];

const miscellaneous = ["ok", "okay", "ja", "jaså", "nei", "ikke", "unnskyld", "beklager", "herr", "altså"];

var functionWords = {};

Object.defineProperty(functionWords, "__esModule", {
	value: true
});

functionWords.default = function () {
	return {
		// This export contains all of the above words.
		all: [].concat(articles, cardinalNumerals, ordinalNumerals, fractions, pronouns, interrogatives, quantifiers, reflexivePronouns, indefinitePronouns, prepositions, conjunctions, interviewVerbs, intensifiers, auxiliariesAndDelexicalizedVerbs, generalAdjectivesAdverbs, interjections, recipeWords, timeWords, vagueNouns, reflectionWords, titlesPrecedingOrFollowing)
	};
};

/**
 * Returns an object with function words.
 *
 * @returns {Object} The object filled with various categories of function word arrays.
 */
const articles = ["bir"];

const cardinalNumerals = ["i̇ki", "üç", "dört", "beş", "altı", "yedi", "sekiz", "dokuz", "on", "on bir", "on i̇ki", "on üç", "on dört", "on beş", "on altı", "on yedi", "on sekiz", "on dokuz", "yirmi", "yirmi bir", "yirmi i̇ki", "yirmi üç", "yirmi dört", "yirmi beş", "yirmi altı", "yirmi yedi", "yirmi sekiz", "yirmi dokuz", "otuz", "kırk", "elli", "altmış", "yetmiş", "seksen", "doksan", "yüz", "bin", "milyon", "milyar"];

const ordinalNumerals = ["birinci", "i̇kinci", "üçüncü", "dördüncü", "beşinci", "altıncı", "yedinci", "sekizinci", "dokuzuncu", "onuncu"];

const fractions = ["tam", "yarım", "çeyrek", "üçte biri", "üçte ikisi", "tamamı", "yarısı", "çeyreği", "üçte biri", "üçte ikisi"];

const pronouns = [
// Personal pronouns.
"ben", "sen", "o", "biz", "siz", "onlar", "beni", "seni", "onu", "bizi", "sizi", "onları", "bizleri", "sizleri", "bana", "sana", "ona", "bize", "size", "onlara", "bizlere", "sizlere", "bende", "sende", "onda", "bizde", "sizde", "onlarda", "bizlerde", "sizlerde", "benden", "senden", "ondan", "bizden", "sizden", "onlardan", "bizlerden", "sizlerden",
// Possessive pronouns.
"benim", "senin", "onun", "bizim", "sizin", "onların", "bizlerin", "sizlerin",
// Demonstrative pronouns.
"bu", "şu", "o", "öteki", "beriki", "bura", "şura", "ora", "burası", "şurası", "orası", "böylesi", "şöylesi", "öylesi", "bunlar", "şunlar", "onlar", "ötekiler", "berikiler", "buralar", "şuralar", "oralar",
// Reciprocal pronouns.
"birbiri", "birbirimiz", "birbiriniz", "birbirleri", "birbirimizi", "birbirinizi", "birbirlerini", "birbirimize", "birbirinize", "birbirlerine", "birbirimizde", "birbirinizde", "birbirlerinde", "birbirimizden", "birbirinizden", "birbirlerinden", "birbirimizle", "birbirinizle", "birbirleriyle"];

const interrogatives = ["kim", "kimi", "kime", "kimde", "kimden", "kimin", "kiminle", "ne", "neyi", "neyde", "neyden", "neyle", "ne için", "niçin", "niye", "ne diye", "nere", "nereyi", "nereye", "nerede", "nereden", "neresi", "neden", "hangi", "hangisi", "kaç", "kaçı", "kaçıncı", "kaçta", "nasıl", "ne kadar", "ne zaman", "mı", "hangi", "hangisi", "kimler", "kimleri", "kimlere", "kimlerde", "kimlerden", "neler", "neleri", "nelere", "nelerde", "nelerden", "hangiler", "hangileri", "hangilere"];

const quantifiers = ["hepsi", "bazısı", "çoğu", "birçoğu", "birazı", "hepsi", "bütünü", "yeteri kadarı", "birkaçı", "biri", "her ikisi", "i̇kisinden biri", "hiç biri", "diğeri", "tümü", "bir kısmı", "pek çoğu", "her biri", "bazı", "çok", "çoğu", "birçok", "biraz", "bütün", "yeteri kadar", "birkaç", "bir", "her iki", "hiç bir", "diğer", "tüm", "bir kısım", "pek çok", "her bir"];

const reflexivePronouns = ["kendi", "kendim", "kendimi", "kendime", "kendimde", "kendimden", "kendin", "kendini", "kendine", "kendinde", "kendinden", "kendisi", "kendiyle", "kendileri", "kendilerine", "kendilerinde", "kendilerinden", "kendileriyle"];

const indefinitePronouns = ["kimi", "kimse", "biri", "birisi", "başkası", "bazısı", "bir çoğu", "bir takımı", "birkaçı", "birazı", "herkes", "hepsi", "hepimiz", "hiçbiri", "herhangi biri", "her biri", "şey", "falan", "filan", "falanca", "öteberi", "tümü", "bütünü", "kimileri", "kimseler", "birileri", "başkaları", "bazıları", "bir çokları", "herkesler"];

const prepositions = ["i̇çin", "gibi", "kadar", "ancak", "yalnız", "i̇le", "sadece", "sanki", "değil", "üzere", "dair", "karşın", "rağmen", "özgü", "doğru", "dek", "değin", "ait", "beri", "başka", "itibaren", "dolayı", "ötürü", "adeta", "sırf", "diye", "tek", "karşı"];

const conjunctions = ["ve", "i̇le", "veya", "ya da", "yahut", "veyahut", "ama", "fakat", "lakin", "yalnız", "ancak", "oysa", "oysaki", "halbu ki", "ne var ki", "çünkü", "zira", "de", "da", "ki", "meğer", "madem", "mademki", "demek", "demek ki", "üstelik", "hatta", "yani", "hem...hem", "hem de", "ne", "kah", "i̇ster", "ister", "açıkcası", "bile", "ya", "da", "ise", "öyleyse", "kim bilir", "gerek", "gerekse de", "ta ki", "zati"];

const interviewVerbs = ["demek", "dedim", "dedin", "dedi", "dedik", "dediniz", "dediler", "der", "söylemek", "söyledim", "söyledin", "söyledi", "söyledik", "söylediniz", "söylediler", "söyler", "söylerler", "sormak", "sordum", "sordun", "sordu", "sorduk", "sordunuz", "sordular", "sorar", "sorarlar", "belirtmek", "belirttim", "belirttin", "belirtti", "belirttik", "belirttiniz", "belirttiler", "belirtir", "belirtirler", "açıklamak", "açıkladım", "açıkladın", "açıkladı", "açıkladık", "açıkladınız", "açıkladılar", "açıklar", "açıklarlar", "düşünmek", "düşündüm", "düşündün", "düşündü", "düşündük", "düşündünüz", "düşündüler", "düşünür", "düşünürler", "konuşmak", "konuşdum", "konuştun", "konuştu", "konuştuk", "konuştunuz", "konuştular", "konuşur", "konuşurlar", "bildirmek", "bildirdim", "bildirdin", "bildirdi", "bildirdik", "bildirdiniz", "bildirdiler", "birdirir", "bildirirler", "ele", "almak", "aldım", "aldın", "aldı", "aldık", "aldınız", "aldılar", "önermek", "önerdim", "önerdin", "önerdi", "önerdik", "önerdiniz", "önerdiler", "önerir", "önerirler", "anlamak", "anladım", "anladın", "anladı", "anladık", "anladınız", "anladılar", "anlar", "anlarlar"];

const intensifiers = ["en", "daha", "pek çok", "en çok", "fazla", "epey", "epeyce", "bayağı", "oldukça", "pek", "gayet", "fazlaca", "fevkalede", "tamamen", "fena halde", "fena şekilde", "gerçekten", "zerre kadar", "biraz", "son derece", "deli gibi", "en", "çok", "azıcık"];

const auxiliariesAndDelexicalizedVerbs = ["etmek", "olmak", "yapmak", "kalmak", "gelmek", "kalmak", "bulunmak", "demek", "dilemek", "söylemek", "durmak", "eylemek", "yazmak", "durmak", "vermek", "kabul", "teşekkür", "memnun", "seyir", "zan", "bilmek"];

const generalAdjectivesAdverbs = [
// General adjective.
"yeni", "eski", "önceki", "i̇yi", "büyük", "küçük", "kolay", "zor", "hızlı", "yavaş", "yüksek", "alçak", "kısa", "uzun", "i̇nce", "kalın", "gerçek", "yalan", "yanlış", "basit", "zor", "aynı", "farklı", "belli", "belirsiz", "modern", "geleneksel", "muhtemel", "yaygın", "genç", "yaşlı", "zamansız", "acı", "tatlı", "tuzlu", "sıcak", "soğuk", "kalabalık", "sakin", "yalnız", "dar", "geniş", "siyah", "beyaz", "mavi", "kırmızı", "sarı", "temiz", "kirli", "muhteşem", "nazik", "kibar", "akıllı", "zeki", "gizli", "açık", "kapalı", "dikkatli", "gürültülü", "sevinçli",
// General adverbs.
"eski", "önce", "i̇yi", "büyük", "küçük", "kolay", "zor", "hızlı", "yavaş", "yüksek", "alçak", "kısa", "uzun", "i̇nce", "kalın", "gerçek", "yanlış", "basit", "zor", "aynı", "farklı", "belli", "belirsiz", "modern", "geleneksel", "muhtemel", "yaygın", "nadir", "genç", "yaşlı", "zamansız", "acı", "tatlı", "tuzlu", "sıcak", "soğuk", "kalabalık", "sakin", "yalnız", "dar", "geniş", "siyah", "beyaz", "mavi", "kırmızı", "sarı", "temiz", "kirli", "muhteşem", "nazik", "kibar", "akıllı", "zeki", "gizli", "açık", "kapalı", "dikkatle", "gürültülü", "uzun", "sevinçle", "aşağı", "yukarı", "sağa", "sola", "i̇çeri dışarı", "bugün", "yarın", "haftaya", "seneye", "ne zaman", "nereye", "neden", "niye", "ne kadar", "nasıl", "ne"];

const interjections = ["ey", "hey", "bre", "hişt", "şşt", "ah", "ahh", "ee", "vay", "i̇mdat", "hah", "ay", "aa", "aaa", "hay allah", "aman", "aman dikkat", "vah", "ya", "yaa", "ooo", "of", "tüh", "peh", "aman", "haydi", "sakın", "yuh"];

const recipeWords = ["çay kaşığı", "çay k.", "yemek kaşığı", "yemek k.", "tatlı kaşığı", "tatlı k.", "çay bardağı", "çay b.", "su bardağı", "su b.", "kahve fincanı", "kahve f.", "tepeleme", "tepeleme kaşık", "tepeleme bardak", "gr", "ml", "kg", "mg", "cl", "oz", "çeyrek", "tam", "yarım", "üçte biri", "üçte ikisi", "parmak"];

const timeWords = ["saniye", "saniyeler", "dakika", "dakikalar", "saat", "saatler", "gün", "günler", "hafta", "haftalar", "ay", "aylar", "yıl", "yıllar", "bugün", "yarın", "dün", "sabah", "öğlen", "akşam", "gece", "gündüz"];

const vagueNouns = ["şey", "şeyler", "olasılık", "çeşit", "kişi"];

const reflectionWords = ["hapşu", "hapşırık", "hapşurmak", "horr", "horultu", "horlamak", "şırıl", "şırıltı", "şırıldamak", "hışır", "hışırtı", "hışırdamak", "gıcır", "gıcırtı", "gıcırdamak", "çatır", "çatırtı", "çatırdamak", "pat", "patlamak", "vın", "vınlamak", "zırr", "zırıltı", "zırlamak", "tık", "tıkırtı", "tıkırdamak", "çıt", "çıtırtı", "çıtırdamak", "fokur", "fokurtu", "fokurdamak", "kıt", "kıtırtı", "kıtırdamak", "patırtı"];

const titlesPrecedingOrFollowing = ["bayan", "bay", "hanımefendi", "hanfendi", "hanım", "beyefendi", "beyfendi", "bey", "sayın", "profesör", "prof.", "doktor", "dr."];

Object.defineProperty(getFunctionWords$3, "__esModule", {
	value: true
});

getFunctionWords$3.default = function () {
	return {
		en: englishFunctionWords,
		de: germanFunctionWords,
		nl: dutchFunctionWords,
		fr: frenchFunctionWords,
		es: spanishFunctionWords,
		it: italianFunctionWords,
		pt: portugueseFunctionWords,
		ru: russianFunctionWords,
		pl: polishFunctionWords,
		sv: swedishFunctionWords,
		id: indonesianFunctionWords,
		he: hebrewFunctionWords,
		ar: arabicFunctionWords,
		fa: farsiFunctionWords,
		hu: hungarianFunctionWords,
		nb: norwegianFunctionWords,
		tr: turkishFunctionWords
	};
};

var _functionWords$3 = functionWords$g;

var _functionWords2$3 = _interopRequireDefault$2M(_functionWords$3);

var _functionWords3$2 = functionWords$f;

var _functionWords4$2 = _interopRequireDefault$2M(_functionWords3$2);

var _functionWords5$2 = functionWords$e;

var _functionWords6$2 = _interopRequireDefault$2M(_functionWords5$2);

var _functionWords7$2 = functionWords$d;

var _functionWords8$2 = _interopRequireDefault$2M(_functionWords7$2);

var _functionWords9$1 = functionWords$c;

var _functionWords10$1 = _interopRequireDefault$2M(_functionWords9$1);

var _functionWords11$1 = functionWords$b;

var _functionWords12$1 = _interopRequireDefault$2M(_functionWords11$1);

var _functionWords13$1 = functionWords$a;

var _functionWords14$1 = _interopRequireDefault$2M(_functionWords13$1);

var _functionWords15 = functionWords$9;

var _functionWords16 = _interopRequireDefault$2M(_functionWords15);

var _functionWords17 = functionWords$8;

var _functionWords18 = _interopRequireDefault$2M(_functionWords17);

var _functionWords19 = functionWords$7;

var _functionWords20 = _interopRequireDefault$2M(_functionWords19);

var _functionWords21 = functionWords$6;

var _functionWords22 = _interopRequireDefault$2M(_functionWords21);

var _functionWords23 = functionWords$5;

var _functionWords24 = _interopRequireDefault$2M(_functionWords23);

var _functionWords25 = functionWords$4;

var _functionWords26 = _interopRequireDefault$2M(_functionWords25);

var _functionWords27 = functionWords$3;

var _functionWords28 = _interopRequireDefault$2M(_functionWords27);

var _functionWords29 = functionWords$2;

var _functionWords30 = _interopRequireDefault$2M(_functionWords29);

var _functionWords31 = functionWords$1;

var _functionWords32 = _interopRequireDefault$2M(_functionWords31);

var _functionWords33 = functionWords;

var _functionWords34 = _interopRequireDefault$2M(_functionWords33);

function _interopRequireDefault$2M(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const germanFunctionWords = (0, _functionWords2$3.default)(); /*
                                                             * The script collects all the lists of function words per language and returns this collection to a Researcher or a
                                                             * stringProcessing script
                                                             */

const englishFunctionWords = (0, _functionWords4$2.default)();

const dutchFunctionWords = (0, _functionWords6$2.default)();

const spanishFunctionWords = (0, _functionWords8$2.default)();

const italianFunctionWords = (0, _functionWords10$1.default)();

const frenchFunctionWords = (0, _functionWords12$1.default)();

const portugueseFunctionWords = (0, _functionWords14$1.default)();

const russianFunctionWords = (0, _functionWords16.default)();

const polishFunctionWords = (0, _functionWords18.default)();

const swedishFunctionWords = (0, _functionWords20.default)();

const indonesianFunctionWords = (0, _functionWords22.default)();

const hebrewFunctionWords = (0, _functionWords24.default)();

const arabicFunctionWords = (0, _functionWords26.default)();

const farsiFunctionWords = (0, _functionWords28.default)();

const hungarianFunctionWords = (0, _functionWords30.default)();

const norwegianFunctionWords = (0, _functionWords32.default)();

const turkishFunctionWords = (0, _functionWords34.default)();

Object.defineProperty(getFunctionWordsLanguages, "__esModule", {
  value: true
});

getFunctionWordsLanguages.default = function () {
  const functionWords = (0, _getFunctionWords2$5.default)();

  return Object.keys(functionWords);
};

var _getFunctionWords$5 = getFunctionWords$3;

var _getFunctionWords2$5 = _interopRequireDefault$2L(_getFunctionWords$5);

function _interopRequireDefault$2L(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(KeyphraseLengthAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1E = require$$1$1;

var _assessment$e = assessment;

var _assessment2$e = _interopRequireDefault$2K(_assessment$e);

var _getFunctionWordsLanguages$1 = getFunctionWordsLanguages;

var _getFunctionWordsLanguages2$1 = _interopRequireDefault$2K(_getFunctionWordsLanguages$1);

var _getLanguage$k = getLanguage;

var _getLanguage2$k = _interopRequireDefault$2K(_getLanguage$k);

var _shortlinker$j = shortlinker;

var _AssessmentResult$k = AssessmentResult$1;

var _AssessmentResult2$k = _interopRequireDefault$2K(_AssessmentResult$k);

function _interopRequireDefault$2K(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assessment to check whether the keyphrase has a good length.
 */
class KeyphraseLengthAssessment extends _assessment2$e.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  * @param {number} [config.parameters.recommendedMinimum] The recommended minimum length of the keyphrase (in words).
  * @param {number} [config.parameters.acceptableMaximum] The acceptable maximum length of the keyphrase (in words).
  * @param {number} [config.scores.veryBad] The score to return if the length of the keyphrase is below recommended minimum.
  * @param {number} [config.scores.consideration] The score to return if the length of the keyphrase is above acceptable maximum.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			parameters: {
				recommendedMinimum: 1,
				recommendedMaximum: 4,
				acceptableMaximum: 8
			},
			parametersNoFunctionWordSupport: {
				recommendedMaximum: 6,
				acceptableMaximum: 9
			},
			scores: {
				veryBad: -999,
				bad: 3,
				okay: 6,
				good: 9
			},
			urlTitle: (0, _shortlinker$j.createAnchorOpeningTag)("https://yoa.st/33i"),
			urlCallToAction: (0, _shortlinker$j.createAnchorOpeningTag)("https://yoa.st/33j"),
			isRelatedKeyphrase: false
		};

		this.identifier = "keyphraseLength";
		this._config = (0, _lodashEs$1E.merge)(defaultConfig, config);
	}

	/**
  * Assesses the keyphrase presence and length.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {AssessmentResult} The result of this assessment.
  */
	getResult(paper, researcher, i18n) {
		this._keyphraseLength = researcher.getResearch("keyphraseLength");
		const assessmentResult = new _AssessmentResult2$k.default();
		this._boundaries = this._config.parameters;

		const languagesWithFunctionWords = (0, _getFunctionWordsLanguages2$1.default)();

		// Make the boundaries less strict if the language of the current paper doesn't have function word support.
		if (languagesWithFunctionWords.includes((0, _getLanguage2$k.default)(paper.getLocale())) === false) {
			this._boundaries = (0, _lodashEs$1E.merge)({}, this._config.parameters, this._config.parametersNoFunctionWordSupport);
		}

		const calculatedResult = this.calculateResult(i18n);

		if (!(0, _lodashEs$1E.isUndefined)(calculatedResult)) {
			assessmentResult.setScore(calculatedResult.score);
			assessmentResult.setText(calculatedResult.resultText);
		}

		return assessmentResult;
	}

	/**
  * Calculates the result based on the keyphraseLength research.
  *
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {Object} Object with score and text.
  */
	calculateResult(i18n) {
		if (this._keyphraseLength < this._boundaries.recommendedMinimum) {
			if (this._config.isRelatedKeyphrase) {
				return {
					score: this._config.scores.veryBad,
					resultText: i18n.sprintf(
					/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
					i18n.dgettext("js-text-analysis", "%1$sKeyphrase length%3$s: " + "%2$sSet a keyphrase in order to calculate your SEO score%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>")
				};
			}
			return {
				score: this._config.scores.veryBad,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase length%3$s: No focus keyphrase was set for this page. " + "%2$sSet a keyphrase in order to calculate your SEO score%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		if ((0, _lodashEs$1E.inRange)(this._keyphraseLength, this._boundaries.recommendedMinimum, this._boundaries.recommendedMaximum + 1)) {
			return {
				score: this._config.scores.good,
				resultText: i18n.sprintf(
				/* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase length%2$s: Good job!"), this._config.urlTitle, "</a>")
			};
		}

		if ((0, _lodashEs$1E.inRange)(this._keyphraseLength, this._boundaries.recommendedMaximum + 1, this._boundaries.acceptableMaximum + 1)) {
			return {
				score: this._config.scores.okay,
				resultText: i18n.sprintf(
				/* Translators:
    %1$d expands to the number of words in the keyphrase,
    %2$d expands to the recommended maximum of words in the keyphrase,
    %3$s and %4$s expand to links on yoast.com,
    %5$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%3$sKeyphrase length%5$s: The keyphrase is %1$d words long. That's more than the recommended maximum of %2$d words. " + "%4$sMake it shorter%5$s!"), this._keyphraseLength, this._boundaries.recommendedMaximum, this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		return {
			score: this._config.scores.bad,
			resultText: i18n.sprintf(
			/* Translators:
   %1$d expands to the number of words in the keyphrase,
   %2$d expands to the recommended maximum of words in the keyphrase,
   %3$s and %4$s expand to links on yoast.com,
   %5$s expands to the anchor end tag. */
			i18n.dgettext("js-text-analysis", "%3$sKeyphrase length%5$s: The keyphrase is %1$d words long. That's way more than the recommended maximum of %2$d words. " + "%4$sMake it shorter%5$s!"), this._keyphraseLength, this._boundaries.recommendedMaximum, this._config.urlTitle, this._config.urlCallToAction, "</a>")
		};
	}
}

KeyphraseLengthAssessment$1.default = KeyphraseLengthAssessment;

var KeywordDensityAssessment$1 = {};

var recommendedKeywordCount = {};

var countWords = {};

Object.defineProperty(countWords, "__esModule", {
  value: true
});

countWords.default = function (text) {
  return (0, _getWords2$h.default)(text).length;
};

var _getWords$h = getWords;

var _getWords2$h = _interopRequireDefault$2J(_getWords$h);

function _interopRequireDefault$2J(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keyphraseLengthFactor = {};

Object.defineProperty(keyphraseLengthFactor, "__esModule", {
  value: true
});

keyphraseLengthFactor.default = function (keyphraseLength) {
  return 0.7 + keyphraseLength / 3;
};

Object.defineProperty(recommendedKeywordCount, "__esModule", {
	value: true
});

recommendedKeywordCount.default = function (text, keyphraseLength, recommendedKeywordDensity, maxOrMin) {
	const wordCount = (0, _countWords2$a.default)(text);

	if (wordCount === 0) {
		return 0;
	}

	const lengthKeyphraseFactor = (0, _keyphraseLengthFactor2$1.default)(keyphraseLength);
	const recommendedKeywordCount = recommendedKeywordDensity * wordCount / (100 * lengthKeyphraseFactor);

	/*
  * The recommended keyword count should always be at least 2,
  * regardless of the keyword density, the word count, or the keyphrase length.
  */
	if (recommendedKeywordCount < 2) {
		return 2;
	}

	switch (maxOrMin) {
		case "min":
			// Round up for the recommended minimum count.
			return Math.ceil(recommendedKeywordCount);
		default:
		case "max":
			// Round down for the recommended maximum count.
			return Math.floor(recommendedKeywordCount);
	}
};

var _countWords$a = countWords;

var _countWords2$a = _interopRequireDefault$2I(_countWords$a);

var _keyphraseLengthFactor$1 = keyphraseLengthFactor;

var _keyphraseLengthFactor2$1 = _interopRequireDefault$2I(_keyphraseLengthFactor$1);

function _interopRequireDefault$2I(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLanguagesWithWordFormSupport = {};

var getStemForLanguage = {};

var determineStem$5 = {};

var buildFormRule = {};

Object.defineProperty(buildFormRule, "__esModule", {
  value: true
});
buildFormRule.buildOneFormFromRegex = buildOneFormFromRegex;
/**
 * Checks if the input word qualifies for the input regex and if so builds a required form.
 * This function is used for other more specific functions.
 *
 * @param {string} word The word to build forms for.
 * @param {Array} regexes The regex-based array of rules to compare the word against.
 *
 * @returns {string} The newly built form of the word.
 */
function buildOneFormFromRegex(word, regexes) {
  for (let i = 0; i < regexes.length; i++) {
    if (regexes[i].reg.test(word) === true) {
      return word.replace(regexes[i].reg, regexes[i].repl);
    }
  }
}

var createRulesFromMorphologyData$1 = {};

Object.defineProperty(createRulesFromMorphologyData$1, "__esModule", {
  value: true
});
/**
 * Creates an object with a regex and a replacement pair to be processed.
 *
 * @param {Array}   rule        A pair or triplet of strings of which the first one is the regex to match
 *                              and the second (and the third) is the replacement.
 * @param {string}  [flags=i]   The regex flags to use.
 *
 * @returns {{ reg: RegExp, repl: string }|{ reg: RegExp, repl1: string, repl2: string }} Object to be used in the regex-based rules.
 */
const createSingleRuleFromMorphologyData = function createSingleRuleFromMorphologyData(rule, flags = "i") {
  if (rule.length === 2) {
    return {
      reg: new RegExp(rule[0], flags),
      repl: rule[1]
    };
  }
  if (rule.length === 3) {
    return {
      reg: new RegExp(rule[0], flags),
      repl1: rule[1],
      repl2: rule[2]
    };
  }
};

/**
 * Creates an array of objects with a regex and a replacement pair to be processed.
 *
 * @param {Array}   rules       An array with pairs or triplets of strings of which the first one is the regex to match
 *                              and the second (and the third) is the replacement.
 * @param {string} [flags=i]    The regex flags to use.
 *
 * @returns {Array} Array of objects to be used in the regex-based rules.
 */
const createRulesFromMorphologyData = function createRulesFromMorphologyData(rules, flags = "i") {
  return rules.map(rule => createSingleRuleFromMorphologyData(rule, flags));
};

createRulesFromMorphologyData$1.createSingleRuleFromMorphologyData = createSingleRuleFromMorphologyData;
createRulesFromMorphologyData$1.createRulesFromMorphologyData = createRulesFromMorphologyData;
createRulesFromMorphologyData$1.default = createRulesFromMorphologyData;

var getAdjectiveStem = {};

Object.defineProperty(getAdjectiveStem, "__esModule", {
	value: true
});

getAdjectiveStem.default = function (word, regexAdjective, stopAdjectives) {
	/*
  * Check comparatives: Consider only words of four letters or more (otherwise, words like "per" are being treated
  * as comparatives).
  */
	const canBeComparative = constructCanBeFunction("er", 4, stopAdjectives.erExceptions);
	if (canBeComparative(word)) {
		const comparativeToBaseRegex = (0, _createRulesFromMorphologyData2$5.default)(regexAdjective.comparativeToBase);
		return {
			base: (0, _buildFormRule$5.buildOneFormFromRegex)(word, comparativeToBaseRegex) || word,
			guessedForm: "er"
		};
	}

	/*
  * Check superlatives: Consider only words of five letters or more (otherwise, words like "test" are being treated
  * as superlatives).
  */
	const canBeSuperlative = constructCanBeFunction("est", 5, stopAdjectives.estExceptions);
	if (canBeSuperlative(word)) {
		const superlativeToBaseRegex = (0, _createRulesFromMorphologyData2$5.default)(regexAdjective.superlativeToBase);
		return {
			base: (0, _buildFormRule$5.buildOneFormFromRegex)(word, superlativeToBaseRegex) || word,
			guessedForm: "est"
		};
	}

	/*
  * Check ly-adverbs: Consider only words of five letters or more (otherwise, words like "lily" are being treated
  * as ly-adverbs).
  */
	const canBeLyAdverb = constructCanBeFunction("ly", 5, stopAdjectives.lyExceptions);
	if (canBeLyAdverb(word)) {
		const adverbToBaseRegex = (0, _createRulesFromMorphologyData2$5.default)(regexAdjective.adverbToBase);
		return {
			base: (0, _buildFormRule$5.buildOneFormFromRegex)(word, adverbToBaseRegex),
			guessedForm: "ly"
		};
	}

	return {
		base: word,
		guessedForm: "base"
	};
};

var _buildFormRule$5 = buildFormRule;

var _createRulesFromMorphologyData$6 = createRulesFromMorphologyData$1;

var _createRulesFromMorphologyData2$5 = _interopRequireDefault$2H(_createRulesFromMorphologyData$6);

function _interopRequireDefault$2H(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Constructs a function that checks if the input word can be a specific adjectival form.
 *
 * @param {string}      endsWith            How the form ends.
 * @param {int}         minimumWordLength   How long the word should be to classify for this form.
 * @param {string[]}    exceptions          The list of words with that ending (endsWith) which are not this form.
 *
 * @returns {Function} A function that checks if the input word can be a specific adjectival form.
 */
// "use strict";
const constructCanBeFunction = function constructCanBeFunction(endsWith, minimumWordLength, exceptions) {
	return word => {
		const wordLength = word.length;
		if (wordLength < minimumWordLength) {
			return false;
		}

		const doesEndWith = word.substring(wordLength - endsWith.length, wordLength) === endsWith;
		return doesEndWith && !exceptions.includes(word);
	};
};

var getVerbStem = {};

Object.defineProperty(getVerbStem, "__esModule", {
	value: true
});
getVerbStem.normalizePrefixed = getVerbStem.endsWithIng = getVerbStem.checkIrregulars = getVerbStem.getInfinitive = undefined;

var _lodashEs$1D = require$$1$1;

var _createRulesFromMorphologyData$5 = createRulesFromMorphologyData$1;

var _createRulesFromMorphologyData2$4 = _interopRequireDefault$2G(_createRulesFromMorphologyData$5);

var _buildFormRule$4 = buildFormRule;

function _interopRequireDefault$2G(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const vowelRegex = /([aeiouy])/g;

/**
 * Checks if the input word has one of the standard verb prefixes and if so returns a prefix and a de-prefixed verb to be
 * further used to compare with the list of irregular verbs.
 *
 * @param {string} word The word for which to determine if it has one of the standard verb prefixes.
 * @param {Object} verbPrefixes The collection of verb prefixes to be used for normalization
 *
 * @returns {Array} Array of word forms from the exception list.
 */
// "use strict";
const normalizePrefixed = function normalizePrefixed(word, verbPrefixes) {
	for (const property in verbPrefixes) {
		if (verbPrefixes.hasOwnProperty(property)) {
			verbPrefixes[property] = new RegExp(verbPrefixes[property], "i");
		}
	}

	if (verbPrefixes.sevenLetterHyphenPrefixes.test(word) === true) {
		return {
			normalizedWord: word.replace(verbPrefixes.sevenLetterHyphenPrefixes, ""),
			prefix: word.substring(0, 8)
		};
	}

	if (verbPrefixes.sevenLetterPrefixes.test(word) === true) {
		return {
			normalizedWord: word.replace(verbPrefixes.sevenLetterPrefixes, ""),
			prefix: word.substring(0, 7)
		};
	}

	if (verbPrefixes.fiveLetterHyphenPrefixes.test(word) === true) {
		return {
			normalizedWord: word.replace(verbPrefixes.fiveLetterHyphenPrefixes, ""),
			prefix: word.substring(0, 6)
		};
	}

	if (verbPrefixes.fiveLetterPrefixes.test(word) === true) {
		return {
			normalizedWord: word.replace(verbPrefixes.fiveLetterPrefixes, ""),
			prefix: word.substring(0, 5)
		};
	}

	if (verbPrefixes.fourLetterHyphenPrefixes.test(word) === true) {
		return {
			normalizedWord: word.replace(verbPrefixes.fourLetterHyphenPrefixes, ""),
			prefix: word.substring(0, 5)
		};
	}

	if (verbPrefixes.fourLetterPrefixes.test(word) === true) {
		return {
			normalizedWord: word.replace(verbPrefixes.fourLetterPrefixes, ""),
			prefix: word.substring(0, 4)
		};
	}

	if (verbPrefixes.threeLetterHyphenPrefixes.test(word) === true) {
		return {
			normalizedWord: word.replace(verbPrefixes.threeLetterHyphenPrefixes, ""),
			prefix: word.substring(0, 4)
		};
	}

	if (verbPrefixes.threeLetterPrefixes.test(word) === true) {
		return {
			normalizedWord: word.replace(verbPrefixes.threeLetterPrefixes, ""),
			prefix: word.substring(0, 3)
		};
	}

	if (verbPrefixes.twoLetterHyphenPrefixes.test(word) === true) {
		return {
			normalizedWord: word.replace(verbPrefixes.twoLetterHyphenPrefixes, ""),
			prefix: word.substring(0, 3)
		};
	}

	if (verbPrefixes.twoLetterPrefixes.test(word) === true) {
		return {
			normalizedWord: word.replace(verbPrefixes.twoLetterPrefixes, ""),
			prefix: word.substring(0, 2)
		};
	}

	if (verbPrefixes.oneLetterPrefixes.test(word) === true) {
		return {
			normalizedWord: word.replace(verbPrefixes.oneLetterPrefixes, ""),
			prefix: word.substring(0, 1)
		};
	}
};

/**
 * Checks if the input word occurs in the list of exception verbs and if so returns all its irregular forms.
 * If not checks if it is an irregular verb with one of the standard verb prefixes, if so returns all irregular prefixed forms.
 *
 * @param {string} word The word for which to determine its irregular forms.
 * @param {Array} irregularVerbs The array of irregular verbs available for this language.
 * @param {Object} verbPrefixes The collection of verb prefixes to be used for normalization of irregular verbs.
 *
 * @returns {Array} Array of word forms from the exception list.
 */
const checkIrregulars = function checkIrregulars(word, irregularVerbs, verbPrefixes) {
	let irregulars;

	irregularVerbs.forEach(function (paradigm) {
		paradigm.forEach(function (wordInParadigm) {
			if (wordInParadigm === word) {
				irregulars = paradigm;
			}
		});
	});

	if ((0, _lodashEs$1D.isUndefined)(irregulars)) {
		const normalizedIrregular = normalizePrefixed(word, verbPrefixes);

		if (!(0, _lodashEs$1D.isUndefined)(normalizedIrregular)) {
			irregularVerbs.forEach(function (paradigm) {
				paradigm.forEach(function (wordInParadigm) {
					if (wordInParadigm === normalizedIrregular.normalizedWord) {
						irregulars = paradigm.map(function (verb) {
							return normalizedIrregular.prefix.concat(verb);
						});
					}
				});
			});
		}
	}

	return irregulars;
};

/**
 * Checks if the input word ends with "s".
 *
 * @param {string} word The word to check.
 *
 * @returns {boolean} True if the word ends with "s".
 */
const endsWithS = function endsWithS(word) {
	const wordLength = word.length;
	// Consider only words of four letters or more to be s-forms (otherwise, words like "its" are being treated as verb forms).
	if (wordLength > 3) {
		return word[word.length - 1] === "s";
	}
	return false;
};

/**
 * Checks if the input word ends with "ing".
 *
 * @param {string} word The word to check.
 *
 * @returns {boolean} True if the word ends with "ing".
 */
const endsWithIng = function endsWithIng(word) {
	const vowelCount = (word.match(vowelRegex) || []).length;

	// Consider only words that have at least one more vowel besides "i" in "ing" (otherwise, words like "ping" are being treated as verb forms).
	if (vowelCount > 1 && word.length > 4) {
		return word.substring(word.length - 3, word.length) === "ing";
	}
	return false;
};

/**
 * Checks if the input word ends with "ed".
 *
 * @param {string} word The word to check.
 *
 * @returns {boolean} True if the word ends with "ed".
 */
const endsWithEd = function endsWithEd(word) {
	const vowelCount = (word.match(vowelRegex) || []).length;

	// Consider only words that have at least one more vowel besides "e" in "ed" (otherwise, words like "red" are being treated as verb forms).
	if (vowelCount > 1 || vowelCount === 1 && word.substring(word.length - 3, word.length - 2) !== "e") {
		return word.substring(word.length - 2, word.length) === "ed";
	}
	return false;
};

/**
 * Forms the infinitive from an input word.
 *
 * @param {string} word                               The word to build the infinitive for.
 * @param {Object} regexVerb                          The list of regex rules used to bring verb forms to infinitive.
 * @param {Array}  regexVerb.sFormToInfinitiveRegex   The array of regex-based rules used to bring -s forms to infinitive.
 * @param {Array}  regexVerb.ingFormToInfinitiveRegex The array of regex-based rules used to bring -ing forms to infinitive.
 * @param {Array}  regexVerb.edFormToInfinitiveRegex  The array of regex-based rules used to bring -ed forms to infinitive.
 *
 * @returns {string} The infinitive of the input word.
 */
const getInfinitive = function getInfinitive(word, regexVerb) {
	const sFormToInfinitiveRegex = (0, _createRulesFromMorphologyData2$4.default)(regexVerb.sFormToInfinitive);
	const ingFormToInfinitiveRegex = (0, _createRulesFromMorphologyData2$4.default)(regexVerb.ingFormToInfinitive);
	const edFormToInfinitiveRegex = (0, _createRulesFromMorphologyData2$4.default)(regexVerb.edFormToInfinitive);

	if (endsWithS(word)) {
		return {
			infinitive: (0, _buildFormRule$4.buildOneFormFromRegex)(word, sFormToInfinitiveRegex),
			guessedForm: "s"
		};
	}

	if (endsWithIng(word)) {
		return {
			infinitive: (0, _buildFormRule$4.buildOneFormFromRegex)(word, ingFormToInfinitiveRegex),
			guessedForm: "ing"
		};
	}

	if (endsWithEd(word)) {
		return {
			infinitive: (0, _buildFormRule$4.buildOneFormFromRegex)(word, edFormToInfinitiveRegex) || word,
			guessedForm: "ed"
		};
	}
	return {
		infinitive: word,
		guessedForm: "inf"
	};
};

getVerbStem.getInfinitive = getInfinitive;
getVerbStem.checkIrregulars = checkIrregulars;
getVerbStem.endsWithIng = endsWithIng;
getVerbStem.normalizePrefixed = normalizePrefixed;

Object.defineProperty(determineStem$5, "__esModule", {
	value: true
});
determineStem$5.findShortestAndAlphabeticallyFirst = findShortestAndAlphabeticallyFirst;
determineStem$5.determineIrregularStem = determineIrregularStem;
determineStem$5.determineIrregularVerbStem = determineIrregularVerbStem;
determineStem$5.determineRegularStem = determineRegularStem;
determineStem$5.determineStem = determineStem$4;

var _lodashEs$1C = require$$1$1;

var _buildFormRule$3 = buildFormRule;

var _createRulesFromMorphologyData$4 = createRulesFromMorphologyData$1;

var _createRulesFromMorphologyData2$3 = _interopRequireDefault$2F(_createRulesFromMorphologyData$4);

var _getAdjectiveStem = getAdjectiveStem;

var _getAdjectiveStem2 = _interopRequireDefault$2F(_getAdjectiveStem);

var _getVerbStem = getVerbStem;

function _interopRequireDefault$2F(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the shortest of the alphabetically ordered strings from an array.
 *
 * @param {string[]} array  The array of strings.
 *
 * @returns {string|undefined}  The shortest of the alphabetically ordered strings from the input array;
 *                              undefined if the input array is empty.
 */
function findShortestAndAlphabeticallyFirst(array) {
	const strings = (0, _lodashEs$1C.flatten)(array);
	let result = strings.pop();

	strings.forEach(str => {
		const lengthDifference = str.length - result.length;
		if (lengthDifference === 0) {
			if (str.localeCompare(result) < 0) {
				result = str;
			}
		} else if (lengthDifference < 0) {
			result = str;
		}
	});

	return result;
}

/**
 * Checks if the input word occurs in the list of exceptions and if so returns the first form of the paradigm, which is
 * always the base.
 *
 * @param {string} word                 The word for which to determine its base.
 * @param {Array}  irregulars           An array of irregular nouns and adjectives.
 *
 * @returns {string|null} The base form of the irregular word; null if no irregular stem was found.
 */
function determineIrregularStem(word, irregulars) {
	for (let i = 0; i < irregulars.length; i++) {
		const paradigm = irregulars[i];
		for (let j = 0; j < paradigm.length; j++) {
			if (paradigm[j] === word) {
				return paradigm[0];
			}
		}
	}
	return null;
}

/**
 * Checks if the input word occurs in the list of exception verbs and if so returns the first form
 * of the paradigm, which is always the base. Contrary to nouns and adjectives, irregular verbs can have different prefixes
 * which are not included in the list of exceptions and have to be processed separately.
 *
 * @param {string}    word            The word for which to determine its base.
 * @param {Object}    verbMorphology  Regexes and irregulars for verb morphology, False if verb rules should not be applied.
 *
 * @returns {string|null} The base form of the irregular word; null if no irregular stem was found.
 */
function determineIrregularVerbStem(word, verbMorphology) {
	const paradigmIfIrregularVerb = (0, _getVerbStem.checkIrregulars)(word, verbMorphology.irregularVerbs, verbMorphology.regexVerb.verbPrefixes);
	if (!(0, _lodashEs$1C.isUndefined)(paradigmIfIrregularVerb)) {
		return paradigmIfIrregularVerb[0];
	}
	return null;
}

/**
 * Gets possible stems as a regular noun, adjective and verb.
 *
 * @param {string} word              The word for which to determine its base.
 * @param {Object} morphologyData    The morphology data for the language.
 *
 * @returns {string} The shortest and the alphabetically-first of possible noun-like, verb-like and adjective-like bases.
 */
function determineRegularStem(word, morphologyData) {
	// Try to singularize as a noun.
	const regexVerb = morphologyData.verbs.regexVerb;
	const baseIfPluralNoun = (0, _buildFormRule$3.buildOneFormFromRegex)(word, (0, _createRulesFromMorphologyData2$3.default)(morphologyData.nouns.regexNoun.singularize));
	if (!(0, _lodashEs$1C.isUndefined)(baseIfPluralNoun)) {
		// Bring ing-nouns to base forms ("blessings" -> "bless").
		if ((0, _getVerbStem.endsWithIng)(baseIfPluralNoun)) {
			return (0, _buildFormRule$3.buildOneFormFromRegex)(baseIfPluralNoun, (0, _createRulesFromMorphologyData2$3.default)(regexVerb.ingFormToInfinitive));
		}
		return baseIfPluralNoun;
	}

	// Check if the word ends with "ic", "ical" or "ically". Return the "ical" form for consistency.
	const regexAdjective = morphologyData.adjectives.regexAdjective;
	const baseIfIcally = (0, _buildFormRule$3.buildOneFormFromRegex)(word, (0, _createRulesFromMorphologyData2$3.default)(regexAdjective.icallyToBase));
	if (!(0, _lodashEs$1C.isUndefined)(baseIfIcally)) {
		return baseIfIcally;
	}

	// No more quick guesses, we have to determine a verbal infinitive and an adjectival base.
	const possibleRegularBases = [];

	// Verbal infinitive.
	const baseIfVerb = (0, _getVerbStem.getInfinitive)(word, regexVerb).infinitive;

	possibleRegularBases.push(baseIfVerb);

	// Adjectival base.
	const stopAdjectives = morphologyData.adjectives.stopAdjectives;

	const baseIfAdjective = (0, _getAdjectiveStem2.default)(word, regexAdjective, stopAdjectives).base;
	possibleRegularBases.push(baseIfAdjective);

	return findShortestAndAlphabeticallyFirst(possibleRegularBases);
}

/**
 * Returns the stem of the input word using the morphologyData (language-specific).
 *
 * @param   {string} word           The word to get the stem for.
 * @param   {Object} morphologyData The available morphology data per language (false if unavailable).
 *
 * @returns {string} Stemmed (or base) form of the word.
 */
function determineStem$4(word, morphologyData) {
	const nounMorphology = morphologyData.nouns;

	const baseIfPossessive = (0, _buildFormRule$3.buildOneFormFromRegex)(word, (0, _createRulesFromMorphologyData2$3.default)(nounMorphology.regexNoun.possessiveToBase));

	let stem, irregular;

	// Determine if this is an irregular noun, adjective or verb.
	if ((0, _lodashEs$1C.isUndefined)(baseIfPossessive)) {
		stem = word;
		// Word can be a noun, adjective or verb.
		irregular = determineIrregularStem(word, nounMorphology.irregularNouns) || determineIrregularStem(word, morphologyData.adjectives.irregularAdjectives) || determineIrregularVerbStem(word, morphologyData.verbs);
	} else {
		stem = baseIfPossessive;
		// The word is a possessive, it can only be a noun or an ing-noun;
		irregular = determineIrregularStem(baseIfPossessive, nounMorphology.irregularNouns);
	}

	if (irregular) {
		// Found the stem of an irregular word! Return it.
		return irregular;
	}

	// Treat the word as a regular noun, adjective or verb.
	return determineRegularStem(stem, morphologyData);
}

var determineStem$3 = {};

var detectAndStemRegularParticiple$3 = {};

var exceptionsParticiplesActive$1 = {};

Object.defineProperty(exceptionsParticiplesActive$1, "__esModule", {
	value: true
});

exceptionsParticiplesActive$1.default = function () {
	return ["geht", "gämsbart", "gemsbart", "geäst", "gebarungsbericht", "geähnelt", "geartet", "gebäudetrakt", "gebet", "gebiet", "gebietsrepräsentant", "gebildbrot", "gebirgsart", "gebirgsgrat", "gebirgskurort", "gebirgsluft", "gebirgsschlucht", "geblüt", "geblütsrecht", "gebohntkraut", "gebot", "gebrauchsgut", "gebrauchstext", "gebrauchsverlust", "gebrauchtgerät", "gebrauchtwagengeschäft", "gebrauchtwagenmarkt", "geburt", "geburtsakt", "geburtsgeschwulst", "geburtsgewicht", "geburtsort", "geburtsrecht", "geburtsstadt", "geburtstagsfest", "geckenart", "gedächtniskonzert", "gedächtniskunst", "gedächtnisverlust", "gedankenarmut", "gedankenexperiment", "gedankenflucht", "gedankengut", "gedankenschritt", "gedankenwelt", "gedenkkonzert", "gedicht", "geest", "gefahrengebiet", "gefahrenmoment", "gefahrenpunkt", "gefahrgut", "gefahrguttransport", "gefährt", "gefälligkeitsakzept", "gefallsucht", "gefangenenanstalt", "gefangenentransport", "gefängnisarzt", "gefängniskluft", "gefäßnaht", "gefecht", "gefechtsabschnitt", "gefechtsbereit", "gefechtsgebiet", "gefechtsgewicht", "gefechtshut", "gefechtsmast", "gefechtsmast", "geflecht", "geflügelaufzucht", "geflügelleberwurst", "geflügelmarkt", "geflügelmast", "geflügelpest", "geflügelsalat", "geflügelwurst", "geflügelzucht", "gefolgsleute", "gefrett", "gefriergerät", "gefriergut", "gefrierobst", "gefrierpunkt", "gefrierschnitt", "gefühlsarmut", "gefühlswelt", "gegenangebot", "gegenansicht", "gegenargument", "gegengeschäft", "gegengewalt", "gegengewicht", "gegenkandidat", "gegenkompliment", "gegenkonzept", "gegenlicht", "gegenmacht", "gegenpapst", "gegenpart", "gegensatzwort", "gegenstandpunkt", "gegenstandsgebiet", "gegenwart", "gegenwartskunst", "gegenwelt", "gegenwort", "gehaart", "gehandicapt", "gehandikapt", "geheimagent", "geheimbericht", "geheimdokument", "geheimfavorit", "geheimkontakt", "geheimkult", "geheimnisverrat", "geheimpolizist", "geheimrat", "geheimrezept", "geheimtext", "gehirnakrobat", "gehirngeschwulst", "gehirnhaut", "gehirnsandgeschwulst", "gehirntot", "gehirntrust", "gehöft", "gehörlosensport", "geigenkonzert", "geißbart", "geißblatt", "geißhirte", "geißhirt", "geist", "geisterfahrt", "geisterstadt", "geisterwelt", "geistesarmut", "geistesart", "geistesfürst", "geistesgegenwart", "geistesgestört", "geistesprodukt", "geistestat", "geistesverwandt", "geisteswelt", "geklüft", "geländefahrt", "geländeritt", "geländesport", "gelangweilt", "gelaut", "geläut", "gelblicht", "gelbrost", "gelbsucht", "gelbwurst", "gelcoat", "geldausgabeautomat", "geldautomat", "geldgeschäft", "geldheirat", "geldinstitut", "geldmarkt", "geldsurrogat", "geldtransport", "geldverlust", "gelehrtenstreit", "gelehrtenwelt", "geleit", "geleitboot", "geleitwort", "gelenkgicht", "gelenkwassersucht", "geleucht", "geltungssucht", "gelüst", "gemächt", "gemeindeamt", "gemeindebürgerrecht", "gemeindegut", "gemeindekirchenrat", "gemeindepräsident", "gemeinderat", "gemeingeist", "gemeingut", "gemeinschaftsgeist", "gemeinschaftsprojekt", "gemeinschaftsunterkunft", "gemengesaat", "gemüseart", "gemüsebeet", "gemüsegeschäft", "gemüsemarkt", "gemüsesaft", "gemüsesalat", "gemüsezucht", "gemüt", "gemütsarmut", "gemütsart", "gemütsathlet", "gemütskalt", "genausogut", "genausooft", "genausoweit", "gendefekt", "generalagent", "generalarzt", "generalat", "generalbassinstrument", "generalbaßinstrument", "generalbundesanwalt", "generalgouvernement", "generalintendant", "generalist", "generalkonsulat", "generalleutnant", "generaloberst", "generalresident", "generalsekretariat", "generalstaaten", "generalstaatsanwalt", "generalsuperintendent", "generalüberholt", "generalvikariat", "generalvollmacht", "generationenkonflikt", "generativist", "genist", "genitivattribut", "genitivobjekt", "genmanipuliert", "gennesaret", "genotzüchtigt", "gent", "genuasamt", "genussgift", "genußgift", "genusssucht", "genuss-sucht", "genußsucht", "genverändert", "geobiont", "geodät", "geografieunterricht", "geographieunterricht", "geokrat", "geophyt", "gepäckfracht", "geradeausfahrt", "geradesogut", "gefälligst", "gerant", "gerät", "gerätewart", "geräuschlaut", "gerbextrakt", "gericht", "gerichtsarzt", "gerichtsort", "gerichtspräsident", "germanisiert", "germanist", "germanistikstudent", "gerodelt", "geröllschicht", "geröllschutt", "geront", "gerontokrat", "gerstenbrot", "gerstensaft", "gerstenschrot", "gerücht", "gerüst", "gesamtansicht", "gesamtaspekt", "gesamtdurchschnitt", "gesamtgewicht", "gesamtgut", "gesamt", "gesamtklassement", "gesamtunterricht", "gesandtschaftsrat", "gesangskunst", "gesangspart", "gesangssolist", "gesangsunterricht", "gesangunterricht", "geschäft", "geschäftsaufsicht", "geschäftsbericht", "geschäftsgeist", "geschäftswelt", "geschenkpaket", "geschichtsunterricht", "geschicklichkeitstest", "geschicklichkeitstest", "geschlecht", "geschlechtsakt", "geschlechtslust", "geschlechtsprodukt", "geschlechtswort", "geschmackstest", "geschwindigkeitslimit", "geschworenengericht", "geschwulst", "gesellschaftsfahrt", "gesellschaftsschicht", "gesetzblatt", "gesetzespaket", "gesetzestext", "gesicht", "gesichtshaut", "gesichtspunkt", "gesichtsschnitt", "gesichtsverlust", "gespenst", "gespensterfurcht", "gespinst", "gespött", "gesprächstherapeut", "gestalt", "gestaltungselement", "gesteinsart", "gesteinschutt", "gesteinsschicht", "gestüt", "gestüthengst", "verantwortungsbewusst", "verantwortungsbewußt", "getast", "getränkeabholmarkt", "getränkeautomat", "getränkemarkt", "getreideart", "getreideaussaat", "getreideexport", "getreideimport", "getreideprodukt", "getreideschnitt", "getreidevorrat", "gewährfrist", "gewalt", "gewaltakt", "gewaltbereit", "gewalttat", "gesprächsbereit", "gewaltverbot", "gewaltverzicht", "gewässerbett", "gewässerwart", "gewebeschicht", "gewebsrest", "gewicht", "gewichtsprozent", "gewichtsverlust", "gewerbeamt", "gewerbearzt", "gewerbeaufsicht", "gewerbeaufsichtsamt", "gewerbegebiet", "gewerberecht", "gewerbsunzucht", "gewerkschaft", "gewerkschaftsjournalist", "gewindestift", "gewinnsucht", "gewinst", "gewissensangst", "gewissenskonflikt", "gewitterfront", "gewitterluft", "gewohnheitsrecht", "gewürzextrakt", "gewürzkraut", "gezücht", "erbbaurecht", "erbfolgerecht", "erbfolgestreit", "erbgut", "erbhofrecht", "erblast", "erbpacht", "erbrecht", "erbschaftsstreit", "erbsenkraut", "erbbedingt", "erbberechtigt", "erblasst", "erblaßt", "erbswurst", "erbverzicht", "erbwort", "erbzinsgut", "erdbebengebiet", "erdbeerjogurt", "erdbeerjoghurt", "erdbeeryoghurt", "erdbeerkompott", "erdbeerrot", "erdbeersaft", "erdbeersekt", "erdengut", "erdenlust", "erdfrucht", "erdgeist", "erdkundeunterricht", "erdlicht", "erdmittelpunkt", "erdnussfett", "erdölprodukt", "erdölproduzent", "erdsatellit", "erdschicht", "erdsicht", "erdtrabant", "erdverhaftet", "eremit", "erfahrungsbericht", "erfahrungshorizont", "erfahrungswelt", "erfindergeist", "erfolgsaussicht", "erfolgsorientiert", "erfolgsrezept", "erfolgsverwöhnt", "erfüllungsort", "erfurt", "ergänzungsheft", "ergänzungssport", "ergänzungstest", "ergostat", "ergotherapeut", "erholungsgebiet", "erholungsort", "erkundungsfahrt", "erlaucht", "erläuterungstext", "erlebnisbericht", "erlebnisorientiert", "erlebniswelt", "ernährungsamt", "ernst", "ernstgemeint", "ernteaussicht", "erntedankfest", "erntefest", "erntemonat", "ernteresultat", "eroberungsabsicht", "eroberungsgeist", "eroberungslust", "eroberungssucht", "eröffnungskonzert", "ersatzgeschwächt", "ersatzgut", "ersatzkandidat", "ersatzobjekt", "ersatzpräparat", "ersatzreservist", "ersatztorwart", "erscheinungsfest", "erscheinungsort", "erscheinungswelt", "erschließungsgebiet", "erst", "erstbundesligist", "erstfahrt", "erstgebot", "erstgeburt", "erstgeburtsrecht", "erstklassbillett", "erstklaßbillett", "erstkommunikant", "erstkonsument", "erstligist", "erstplatziert", "erstplaciert", "erstplaziert", "erstrecht", "ertragsaussicht", "erwartungsangst", "erwartungshorizont", "erwerbseinkünfte", "erythrit", "erythroblast", "erythrozyt", "erzählertalent", "erzählgut", "erzählkunst", "erzähltalent", "erzamt", "erzdemokrat", "erzeugungsschlacht", "erzfaschist", "erziehungsanstalt", "erziehungsberechtigt", "erziehungsinstitut", "erzkommunist", "erzprotestant", "veranlassungswort", "veranschaulicht", "veranschlagt", "verantwortungsbewusst", "verantwortungsbewußt", "veräußerungsverbot", "verbalist", "verbalkontrakt", "verbändestaat", "verbannungsort", "verbildlicht", "verbindungspunkt", "verbindungsstudent", "verbraucherkredit", "verbrauchermarkt", "verbrauchsgut", "verbrechernest", "verbrechersyndikat", "verbrecherwelt", "verbreitungsgebiet", "verbrennungsprodukt", "verdachtsmoment", "verdampfungsgerät", "verdauungstrakt", "verdikt", "veredelungsprodukt", "verehrerpost", "vereinspräsident", "vereinsrecht", "vereinssport", "verfahrensrecht", "verfassungsfahrt", "verfassungsgericht", "verfassungsrecht", "verfassungsstaat", "verfolgungsrecht", "verfremdungseffekt", "verfügungsgewalt", "verfügungsrecht", "verfügungsberechtigt", "verführungskunst", "vergegenständlicht", "vergegenwärtigt", "vergeltungsakt", "vergenossenschaftlicht", "vergissmeinnicht", "vergißmeinnicht", "vergleichsmonat", "vergleichsobjekt", "vergleichspunkt", "vergnügungsetablissement", "vergnügungsfahrt", "vergnügungssucht", "vergrößerungsgerät", "verhaltensgestört", "verhältniswahlrecht", "verhältniswort", "verhandlungsangebot", "verhandlungsbereit", "versandbereit", "verteidigungsbereit", "verhandlungsmandat", "verhandlungsort", "verhandlungspunkt", "verhöramt", "verist", "verjährungsfrist", "verkaufsagent", "verkaufsangebot", "verkaufsargument", "verkaufsautomat", "verkaufsfront", "verkaufshit", "verkaufsobjekt", "verkaufsorientiert", "verkaufspunkt", "verkehrsamt", "verkehrsdelikt", "verkehrsinfarkt", "verkehrsknotenpunkt", "verkehrslicht", "verkehrsnachricht", "verkehrspolizist", "verkehrsrecht", "verkehrsunterricht", "verkehrsverbot", "verklarungsbericht", "verknüpfungspunkt", "verkündungsblatt", "verlagsanstalt", "verlagsprospekt", "verlagsrecht", "verlagsrepräsentant", "verlagssignet", "verlust", "verlustgeschäft", "verlust", "verlustgeschäft", "verlustpunkt", "vermessungsamt", "vermittlungsamt", "vermögensrecht", "vermont", "vermummungsverbot", "verneinungswort", "vernichtungswut", "vernunft", "vernunftheirat", "verordnungsblatt", "verpackungsflut", "verpflichtungsgeschäft", "verrat", "versammlungsort", "versammlungsrecht", "versandgeschäft", "versandgut", "versart", "verschlusslaut", "verschnitt", "verschwendungssucht", "versehrtensport", "versicherungsagent", "versicherungsanstalt", "versicherungsrecht", "verskunst", "versöhnungsfest", "versorgungsamt", "versorgungsberechtigt", "versorgungsgebiet", "versorgungsgut", "versorgungsstaat", "verstakt", "verständigungsbereit", "verstellungskunst", "verstürznaht", "versuchsanstalt", "versuchsobjekt", "versuchsprojekt", "vertebrat", "verteidigungsbudget", "verteidigungsetat", "verteidigungspakt", "verteilungskonflikt", "verteilungszahlwort", "vertikalschnitt", "vertikutiergerät", "vertragsgerecht", "vertragspunkt", "vertragsrecht", "vertragsstaat", "vertragstext", "vertragswerkstatt", "vertrauensanwalt", "vertrauensarzt", "vertrauensverlust", "vertriebsrecht", "vervielfältigungsrecht", "vervielfältigungszahlwort", "verwaltungsakt", "verwaltungsgericht", "verwaltungsrat", "verwaltungsrecht", "verwundetentransport", "verzicht", "verzweiflungsakt", "verzweiflungstat", "entbindungsanstalt", "entdeckungsfahrt", "entenbrust", "entenfett", "entertainment", "enthusiast", "entlastungsmoment", "entlüftungsschacht", "entnazifizierungsgericht", "entoblast", "entoparasit", "entrechat", "entrefilet", "entrepot", "entscheidungsfurcht", "entscheidungsgewalt", "entscheidungsrecht", "entscheidungsschlacht", "entstehungsort", "entsteht", "entwässerungsschacht", "entwicklungsabschnitt", "entwicklungsinstitut", "entwicklungsprojekt", "entwicklungsschritt", "entziehungsanstalt", "zerat", "zerebrallaut", "zerfallsprodukt", "zergliederungskunst", "zerit", "zermatt", "zersetzungsprodukt", "zerstörungslust", "zerstörungswut", "zertifikat", "zerussit", "zervelat", "zervelatwurst", "beamtenrecht", "beamtenschicht", "beamtenstaat", "beat", "beatmungsgerät", "beaufort", "becherfrucht", "beckengurt", "becquereleffekt", "bedarfsgut", "bedenkfrist", "bedienungselement", "bedienungsgerät", "bedienungskomfort", "bedingtgut", "bedürfnisanstalt", "beeinflusst", "beeinflußt", "beerdigungsanstalt", "beerdigungsinstitut", "beerenfrucht", "beerenobst", "beerensaft", "beet", "befasst", "befaßt", "befehlsgewalt", "beförderungsentgelt", "beförderungsrecht", "begabungstest", "begegnungsort", "begleitinstrument", "begleittext", "begleitwort", "begnadigungsrecht", "begräbt", "begrenzungslicht", "begriffswelt", "begriffswort", "begrüßungswort", "behaviorist", "behebungsfrist", "behelfsausfahrt", "behelfsunterkunft", "behindertengerecht", "behindertensport", "behindertentransport", "behmlot", "beiblatt", "beiboot", "beignet", "beiheft", "beikost", "beilast", "beileidswort", "beinamputiert", "beinhaut", "beirat", "beirut", "beistandskredit", "beistandspakt", "beitritt", "beitrittsabsicht", "beitrittsgebiet", "beiwacht", "beiwort", "beizgerät", "bekehrungswut", "bekennergeist", "bekennermut", "bekleidungsamt", "bekommen", "belegarzt", "belegbett", "belegfrist", "belehrungssucht", "belemnit", "belesprit", "beleuchtungseffekt", "beleuchtungsgerät", "belfast", "belkantist", "belcantist", "belletrist", "bellizist", "belt", "benedikt", "benediktenkraut", "benefiziant", "benefiziat", "benefizkonzert", "beneluxstaat", "bentonit", "benzindunst", "beratungspunkt", "bereit", "bereicherungsabsicht", "bereitschaftsarzt", "bergamt", "bergeslast", "bergfahrt", "bergfest", "berggeist", "berggrat", "bergluft", "bergpredigt", "bergsport", "berg-und-Tal-Fahrt", "bergwacht", "bergwelt", "bericht", "berichtsmonat", "beritt", "bermudashort", "bernbiet", "berserkerwut", "berufsaussicht", "berufssoldat", "berufssport", "berufsstart", "berufstracht", "berufsverbot", "berufungsfrist", "berufungsgericht", "berufungsrecht", "berührungsangst", "berührungspunkt", "besanmast", "besatzungsgebiet", "besatzungsmacht", "besatzungsrecht", "besatzungssoldat", "besatzungsstatut", "beschaffungsamt", "beschäftigungstherapeut", "beschlächt", "beschlussrecht", "beschlußrecht", "beschmet", "beschneidungsfest", "beschlächt", "beschlussrecht", "beschlußrecht", "beschmet", "beschneidungsfest", "beschwerdefrist", "beschwerderecht", "beschwörungskunst", "beseitigungsanstalt", "besetzungsgebiet", "besetzungsmacht", "besetzungsstatut", "besichtigungsfahrt", "besitzrecht", "besoldungsrecht", "besprechungspunkt", "besserungsanstalt", "bestattungsinstitut", "bestimmungsort", "bestimmungswort", "bestinformiert", "bestqualifiziert", "bestrahlungsgerät", "bestrenommiert", "bestsituiert", "bestverkauft", "besucherrat", "besuchsrecht", "betpult", "betracht", "betreibungsamt", "betriebsarzt", "betriebsfest", "betriebsrat", "betriebswirt", "bett", "bettelmusikant", "bettelvogt", "bettstatt", "bettwurst", "beulenpest", "beutegut", "beutekunst", "beuterecht", "bevölkerungsschicht", "bewahranstalt", "bewährungsfrist", "bewegungsarmut", "beweislast", "bewußt", "bewusst", "beziehungsgeflecht", "bezirksamt", "bezirksarzt", "bezirksgericht", "bezirkskabinett", "bezirksschulrat", "bezirksstadt", "bezugspunkt", "bezugsrecht", "heraklit", "herat", "herbalist", "herbst", "herbstmonat", "herbstpunkt", "herdbuchzucht", "herdeninstinkt", "herfahrt", "heringsfilet", "heringssalat", "herkuleskraut", "herkunft", "herkunftsort", "hermaphrodit", "heroenkult", "heroinsucht", "heroldsamt", "heroldskunst", "herostrat", "herrenabfahrt", "herrenbrot", "herrendienst", "herrenfest", "herrenhut", "herrenrecht", "herrenschnitt", "herrenwelt", "herrgott", "herrnhut", "herrschaftsgebiet", "herrschaftsgewalt", "herrschaftsinstrument", "herrschergeschlecht", "herrscherkult", "herrschsucht", "herstellungsart", "herzacht", "herzangst", "herzblatt", "herzblut", "herzensangst", "herzensgut", "herzenslust", "herzenstrost", "herzgeliebt", "herzinfarkt", "herzinnenhaut", "herzklappendefekt", "herzogshut", "herzlichst", "herzpatient", "herzpunkt", "herzspezialist", "überbackt", "ueberbackt", "überbacktet", "ueberbacktet", "überbietet", "ueberbietet", "überbot", "ueberbot", "überbotet", "ueberbotet", "überbindet", "ueberbindet", "überbandet", "ueberbandet", "überbläst", "ueberblaest", "überbliest", "ueberbliest", "überbrät", "ueberbraet", "überbratet", "ueberbratet", "überbriet", "ueberbriet", "überbrietet", "ueberbrietet", "überbringt", "ueberbringt", "überbrachtet", "ueberbrachtet", "überbrücktet", "ueberbruecktet", "überbrühtet", "ueberbrühtet", "überbrülltet", "ueberbruelltet", "überbuchtet", "ueberbuchtet", "überbürdetet", "ueberbuerdetet", "überdecktet", "ueberdecktet", "überdehntet", "ueberdehntet", "überdenkt", "ueberdenkt", "überdachtet", "ueberdachtet", "überdosiertet", "ueberdosiertet", "überdrehtet", "ueberdrehtet", "überdrucktet", "ueberdrucktet", "überdüngtet", "ueberdüngtet", "übereignetet", "uebereignetet", "übereiltet", "uebereiltet", "übererfülltet", "uebererfuelltet", "überißt", "ueberisst", "ueberißt", "überisst", "überesst", "ueberesst", "übereßt", "uebereßt", "überaßt", "ueberaßt", "überesset", "ueberesset", "überäßet", "ueberaesset", "überfährt", "ueberfaehrt", "überfahrt", "ueberfahrt", "überfuhrt", "ueberfuhrt", "überfällt", "ueberfaellt", "überfallet", "ueberfallet", "überfielt", "ueberfielt", "überfielet", "ueberfielet", "überfängt", "ueberfaengt", "überfingt", "ueberfingt", "überfinget", "ueberfinget", "überfärbet", "ueberfaerbet", "überfettetet", "ueberfettetet", "überfirnisset", "ueberfirnisset", "überfirnißtet", "ueberfirnisstet", "überfischet", "ueberfischet", "überfischtet", "ueberfischtet", "überflanktet", "ueberflanktet", "überflanktet", "ueberflanktet", "überfliegt", "ueberfliegt", "überflieget", "ueberflieget", "überflöget", "ueberflöget", "überflösset", "ueberfloesset", "überflosst", "ueberflosst", "überfloßt", "ueberflosst", "überfließt", "ueberfliesst", "überflutetet", "ueberflutetet", "überformet", "ueberformet", "überformtet", "ueberformtet", "überfrachtetet", "ueberfrachtetet", "überfracht", "ueberfracht", "überfraget", "ueberfraget", "überfragtet", "ueberfragtet", "überfremdetet", "ueberfremdetet", "überfrisst", "ueberfrisst", "überfrißt", "ueberfrißt", "überfresst", "ueberfresst", "überfreßt", "ueberfreßt", "überfresset", "ueberfresset", "überfraßt", "ueberfraßt", "ueberfrasst", "überfräßet", "ueberfraesset", "überfriert", "ueberfriert", "überfrieret", "ueberfrieret", "überfrort", "ueberfrort", "überfröret", "ueberfroeret", "überfrört", "ueberfroert", "überführet", "ueberfuehret", "überführtet", "ueberfuehrtet", "überfüllet", "ueberfuellet", "übergibt", "uebergibt", "übergebt", "uebergebt", "übergebet", "uebergebet", "übergabt", "uebergabt", "übergäbet", "uebergaebet", "übergäbt", "uebergaebt", "übergeht", "uebergeht", "übergehet", "uebergehet", "übergingt", "uebergingt", "übergewichtetet", "uebergewichtetet", "übergießet", "uebergiesset", "übergießt", "uebergiesst", "übergösset", "uebergoesset", "übergosst", "uebergosst", "uebergoßt", "übergipset", "uebergipset", "übergipstet", "uebergipstet", "übergipset", "uebergipset", "übergipstet", "uebergipstet", "überglänzet", "ueberglaenzet", "überglänztet", "ueberglaenztet", "überglaset", "ueberglaset", "überglastet", "ueberglastet", "überglühet", "uebergluehet", "überglühtet", "uebergluehtet", "übergoldetet", "uebergoldetet", "übergraset", "uebergraset", "übergrastet", "uebergrastet", "übergrätschet", "uebergraetschet", "übergrätschtet", "uebergraetschtet", "übergreift", "uebergreift", "übergreifet", "uebergreifet", "übergrifft", "uebergrifft", "übergriffet", "uebergriffet", "übergreift", "uebergreift", "übergreifet", "uebergreifet", "übergriffet", "uebergriffet", "übergrifft", "uebergrifft", "übergrünet", "uebergruenet", "übergrüntet", "uebergruentet", "überhat", "ueberhat", "überhabt", "ueberhabt", "überhabet", "ueberhabet", "überhattet", "ueberhattet", "überhättet", "ueberhaettet", "überhält", "ueberhaelt", "überhaltet", "ueberhaltet", "überhielt", "ueberhielt", "überhieltet", "ueberhieltet", "überhändiget", "ueberhaendiget", "überhändigtet", "ueberhaendigtet", "überhängt", "ueberhaengt", "überhänget", "ueberhaenget", "überhingt", "ueberhingt", "überhinget", "ueberhinget", "überhängt", "ueberhaengt", "überhänget", "ueberhaenget", "überhängtet", "ueberhaengtet", "überhänget", "ueberhaenget", "überhängtet", "ueberhaengtet", "überhängt", "ueberhaengt", "überhänget", "ueberhaenget", "überhingt", "ueberhingt", "überhinget", "ueberhinget", "überhastetet", "ueberhastetet", "überhäufet", "ueberhaeufet", "überhäuftet", "ueberhaeuftet", "überhebt", "ueberhebt", "überhebet", "ueberhebet", "überhobt", "ueberhobt", "überhöbet", "ueberhoebet", "überhebt", "ueberhebt", "überhebet", "ueberhebet", "überhobt", "ueberhobt", "überheiztet", "ueberheiztet", "überheizet", "ueberheizet", "überhöhet", "ueberhoehet", "überhöhtet", "ueberhoehtet", "überhitzet", "ueberhitzet", "überhitztet", "ueberhitztet", "überholet", "ueberholet", "überholtet", "ueberholtet", "überhöret", "ueberhoeret", "überhörtet", "ueberhoertet", "überinterpretieret", "ueberinterpretieret", "überinterpretiertet", "ueberinterpretiertet", "überinterpretieret", "ueberinterpretieret", "überinterpretiertet", "ueberinterpretiertet", "überklebet", "ueberklebet", "überklebtet", "ueberklebtet", "überkleidetet", "ueberkleidetet", "überkochet", "ueberkochet", "überkochtet", "ueberkochtet", "überkommet", "ueberkommet", "überkamt", "ueberkamt", "überkämet", "ueberkaemet", "überkämt", "ueberkaemt", "überkompensieret", "ueberkompensieret", "überkompensiertet", "ueberkompensiertet", "überkreuzet", "ueberkreuzet", "überkreuztet", "ueberkreuztet", "überkronet", "ueberkronet", "überkrontet", "ueberkrontet", "überkrustetet", "ueberkrustetet", "überladet", "ueberladet", "überludet", "ueberludet", "überlüdet", "ueberluedet", "überlappet", "ueberlappet", "überlapptet", "ueberlapptet", "überlasset", "ueberlasset", "überlaßt", "ueberlaßt", "ueberlasst", "ueberlasst", "überlässt", "ueberlaesst", "überließt", "ueberließt", "ueberliesst", "überließet", "ueberließet", "ueberliesset", "überlastet", "ueberlastet", "überlastetet", "ueberlastetet", "überläuft", "ueberlaeuft", "überlaufet", "ueberlaufet", "überlieft", "ueberlieft", "überliefet", "ueberliefet", "überlebet", "ueberlebet", "überlebtet", "ueberlebtet", "überleget", "ueberleget", "überlegtet", "ueberlegtet", "überlegt", "ueberlegt", "überleget", "ueberleget", "überlegtet", "ueberlegtet", "überleitet", "ueberleitet", "überleitetet", "ueberleitetet", "überleset", "ueberleset", "überlast", "ueberlast", "überläset", "ueberlaeset", "überliegt", "ueberliegt", "überlieget", "ueberlieget", "überlagt", "ueberlagt", "überläget", "ueberlaeget", "überlägt", "ueberlaegt", "überlistetet", "ueberlistetet", "übermachet", "uebermachet", "übermachtet", "uebermachtet", "übermalet", "uebermalet", "übermaltet", "uebermaltet", "übermalet", "uebermalet", "übermaltet", "uebermaltet", "übermannet", "uebermannet", "übermanntet", "uebermanntet", "übermarchtet", "uebermarchtet", "übermarchet", "uebermarchet", "übermästetet", "uebermaestetet", "übermüdetet", "uebermuedetet", "übernächtiget", "uebernaechtiget", "übernächtigtet", "uebernaechtigtet", "übernimmt", "uebernimmt", "übernehmt", "uebernehmt", "übernehmet", "uebernehmet", "übernahmt", "uebernahmt", "übernähmet", "uebernaehmet", "übernähmt", "uebernaehmt", "übernutzet", "uebernutzet", "übernutztet", "uebernutztet", "überpflanzt", "ueberpflanzt", "überpflanzet", "ueberpflanzet", "überpflanztet", "ueberpflanztet", "überplanet", "ueberplanet", "überplantet", "ueberplantet", "überprüfet", "ueberpruefet", "überprüftet", "ueberprueftet", "überquillt", "ueberquillt", "überquellt", "ueberquellt", "überquellet", "ueberquellet", "überquollt", "ueberquollt", "überquöllet", "ueberquoellet", "ueberquöllt", "ueberquoellt", "überqueret", "ueberqueret", "überquertet", "ueberquertet", "überraget", "ueberraget", "überragtet", "ueberragtet", "überragt", "ueberragt", "überraget", "ueberraget", "überragtet", "ueberragtet", "überraschet", "ueberraschet", "überraschtet", "ueberraschtet", "überreagieret", "ueberreagieret", "überreagiertet", "ueberreagiertet", "überrechnetet", "ueberrechnetet", "überredetet", "ueberredetet", "überreglementieret", "ueberreglementieret", "überreglementiertet", "ueberreglementiertet", "überregulieret", "ueberregulieret", "überreguliertet", "ueberreguliertet", "überreichet", "ueberreichet", "überreichtet", "ueberreichtet", "überreißet", "ueberreisset", "überrisset", "ueberrisset", "überreitet", "ueberreitet", "überrittet", "ueberrittet", "überreizet", "ueberreizet", "überreiztet", "ueberreiztet", "überrennet", "ueberrennet", "überrenntet", "ueberrenntet", "überrollet", "ueberrollet", "überrolltet", "ueberrolltet", "überrundetet", "ueberrundetet", "übersäet", "uebersaeet", "übersätet", "uebersaetet", "übersättiget", "uebersaettiget", "uebersaettigtet", "übersättigtet", "überschattetet", "ueberschattetet", "überschätzet", "ueberschaetzet", "überschätztet", "ueberschaetztet", "überschauet", "ueberschauet", "überschautet", "ueberschautet", "überschäumt", "ueberschaeumt", "überschäumet", "ueberschaeumet", "überschäumtet", "ueberschaeumtet", "überschießt", "ueberschießt", "ueberschiesst", "überschießet", "ueberschiesset", "ueberschießet", "überschosst", "ueberschosst", "überschosst", "ueberschosst", "überschoßt", "ueberschoßt", "überschösset", "ueberschoesset", "überschlafet", "ueberschlafet", "überschliefet", "ueberschliefet", "überschlieft", "ueberschlieft", "überschlaget", "ueberschlaget", "überschlüget", "ueberschlueget", "überschlügt", "ueberschluegt", "überschlägt", "ueberschlaegt", "überschlagt", "ueberschlagt", "überschlaget", "ueberschlaget", "überschlugt", "ueberschlugt", "überschlüget", "ueberschlueget", "überschlügt", "ueberschluegt", "überschlägt", "ueberschlaegt", "überschlagt", "ueberschlagt", "überschlaget", "ueberschlaget", "überschlugt", "ueberschlugt", "überschlüget", "ueberschlueget", "ueberschluegt", "überschlügt", "überschließt", "ueberschließt", "ueberschliesst", "überschließet", "ueberschliesset", "überschlosst", "ueberschlosst", "überschloßt", "ueberschlosst", "überschlösset", "ueberschloesset", "überschmieret", "ueberschmieret", "überschmiertet", "ueberschmiertet", "überschminket", "ueberschminket", "überschminktet", "ueberschminktet", "überschnappt", "ueberschnappt", "überschnappet", "ueberschnappet", "überschnapptet", "ueberschnapptet", "überschneidet", "ueberschneidet", "überschnittet", "ueberschnittet", "überschneiet", "ueberschneiet", "überschneitet", "ueberschneitet", "überschreibet", "ueberschreibet", "überschriebet", "ueberschriebet", "überschriebt", "ueberschriebt", "überschreiet", "ueberschreiet", "überschrieet", "ueberschrieet", "überschriet", "ueberschriet", "überschriet", "ueberschriet", "überschreitet", "ueberschreitet", "überschritt", "ueberschritt", "überschrittet", "ueberschrittet", "überschuldetet", "ueberschuldetet", "überschüttet", "ueberschüttet", "überschüttetet", "ueberschüttetet", "überschüttetet", "ueberschuettetet", "überschwappt", "ueberschwappt", "überschwappet", "ueberschwappet", "überschwapptet", "ueberschwapptet", "überschwemmet", "ueberschwemmet", "überschwemmtet", "ueberschwemmtet", "überschwinget", "ueberschwinget", "überschwangt", "ueberschwangt", "überschwänget", "ueberschwaenget", "überschwängt", "ueberschwaengt", "übersieht", "uebersieht", "überseht", "ueberseht", "übersehet", "uebersehet", "übersaht", "uebersaht", "übersähet", "uebersaehet", "übersäht", "uebersaeht", "übersähet", "uebersaehet", "übersäht", "uebersaeht", "übersandtet", "uebersandtet", "übersendetet", "uebersendetet", "übersensibilisieret", "uebersensibilisieret", "übersensibilisiertet", "uebersensibilisiertet", "übersetzt", "uebersetzt", "übersetzet", "uebersetzet", "übersetztet", "uebersetztet", "übersetzet", "uebersetzet", "übersetztet", "uebersetztet", "übersiedet", "uebersiedet", "übersiedetet", "uebersiedetet", "übersott", "uebersott", "übersottet", "uebersottet", "übersöttet", "uebersoettet", "übersiedet", "uebersiedet", "übersiedetet", "uebersiedetet", "übersott", "uebersott", "übersottet", "uebersottet", "übersöttet", "uebersoettet", "überspannet", "ueberspannet", "überspanntet", "ueberspanntet", "überspielet", "ueberspielet", "überspieltet", "ueberspieltet", "überspinnet", "ueberspinnet", "überspännet", "ueberspaennet", "überspännt", "ueberspaennt", "überspönnet", "ueberspoennet", "überspönnt", "ueberspoennt", "überspitzet", "ueberspitzet", "überspitztet", "ueberspitztet", "übersprechet", "uebersprechet", "überspracht", "ueberspracht", "übersprächet", "ueberspraechet", "übersprächt", "ueberspraecht", "überspringt", "ueberspringt", "überspringet", "ueberspringet", "überspränget", "ueberspraenget", "übersprängt", "ueberspraengt", "überspringt", "ueberspringt", "überspringet", "ueberspringet", "übersprangt", "uebersprangt", "überspränget", "ueberspraenget", "übersprängt", "ueberspraengt", "übersprühet", "ueberspruehet", "übersprühtet", "ueberspruehtet", "übersprühet", "ueberspruehet", "übersprühtet", "ueberspruehtet", "überspület", "ueberspuelet", "überspültet", "überspueltet", "übersticht", "uebersticht", "überstecht", "ueberstecht", "überstechet", "ueberstechet", "überstacht", "ueberstacht", "überstächet", "ueberstaechet", "überstächt", "ueberstaecht", "übersticht", "uebersticht", "überstecht", "ueberstecht", "überstechet", "ueberstechet", "überstacht", "ueberstacht", "überstächet", "ueberstaechet", "überstächt", "ueberstaecht", "überstehet", "ueberstehet", "überstandet", "überstandet", "überständet", "überstaendet", "überstündet", "überstuendet", "übersteht", "uebersteht", "überstehet", "ueberstehet", "überstandet", "ueberstandet", "überständet", "ueberstaendet", "überstündet", "ueberstuendet", "übersteiget", "uebersteiget", "überstieget", "ueberstieget", "überstiegt", "ueberstiegt", "übersteigt", "uebersteigt", "übersteiget", "uebersteiget", "überstiegt", "ueberstiegt", "überstieget", "ueberstieget", "überstellet", "ueberstellet", "überstilisieret", "ueberstilisieret", "überstimmet", "ueberstimmet", "überstimmtet", "ueberstimmtet", "überstrahlet", "ueberstrahlet", "überstrahltet", "ueberstrahltet", "überstrapazieret", "ueberstrapazieret", "überstrapaziertet", "ueberstrapaziertet", "überstreicht", "ueberstreicht", "überstreichet", "ueberstreichet", "überstricht", "ueberstricht", "überstrichet", "ueberstrichet", "überstreichet", "ueberstreichet", "überstrichet", "ueberstrichet", "überstricht", "ueberstricht", "überstreift", "ueberstreift", "überstreifet", "ueberstreifet", "überstreiftet", "ueberstreiftet", "überstreuet", "ueberstreuet", "überstreutet", "ueberstreutet", "überströmet", "ueberstroemet", "überströmtet", "überstroemtet", "überstülpt", "überstuelpt", "ueberstuelpet", "überstülpet", "überstülptet", "ueberstuelptet", "überstürzet", "ueberstuerzet", "überstürztet", "ueberstuerztet", "übertäubet", "uebertaeubet", "übertäubtet", "uebertaeubtet", "übertauchet", "uebertauchet", "übertauchtet", "uebertauchtet", "übertippet", "uebertippet", "übertipptet", "uebertipptet", "übertönet", "uebertoenet", "übertöntet", "uebertoentet", "übertouret", "uebertouret", "übertourtet", "uebertourtet", "überträgt", "uebertraegt", "übertragt", "uebertragt", "übertraget", "uebertraget", "übertrugt", "uebertrugt", "übertrüget", "uebertrueget", "übertrügt", "uebertruegt", "übertrainieret", "uebertrainieret", "übertrainiertet", "uebertrainiertet", "übertreffet", "uebertreffet", "übertraft", "uebertraft", "überträfet", "uebertraefet", "überträft", "uebertraeft", "übertreibt", "uebertreibt", "übertreibet", "uebertreibet", "übertriebet", "uebertriebet", "übertriebt", "uebertriebt", "übertritt", "uebertritt", "übertretet", "uebertretet", "übertrat", "uebertrat", "übertratet", "uebertratet", "überträtet", "uebertraetet", "übertritt", "uebertritt", "übertretet", "uebertretet", "übertrat", "uebertrat", "übertratet", "uebertratet", "überträtet", "uebertraetet", "übertrumpfet", "uebertrumpfet", "übertrumpftet", "uebertrumpftet", "übertünchet", "uebertuenchet", "übertünchtet", "überversorget", "ueberversorget", "überversorgtet", "ueberversorgtet", "übervorteilet", "uebervorteilet", "übervorteiltet", "uebervorteiltet", "überwachet", "ueberwachet", "überwachtet", "ueberwachtet", "überwachset", "ueberwachset", "überwüchset", "ueberwuechset", "überwallt", "ueberwallt", "überwallet", "ueberwallet", "überwalltet", "ueberwalltet", "überwallet", "ueberwallet", "überwalltet", "ueberwalltet", "überwältiget", "ueberwaeltiget", "überwältigtet", "ueberwaeltigtet", "überwalzet", "ueberwalzet", "überwalztet", "ueberwalztet", "überwälzet", "ueberwaelzet", "überwälztet", "ueberwaelztet", "überwechtetet", "ueberwechtetet", "überwächtetet", "ueberwaechtetet", "überwehet", "ueberwehet", "überwehtet", "ueberwehtet", "überweidetet", "ueberweidetet", "überweist", "ueberweist", "überweiset", "ueberweiset", "überwiest", "ueberwiest", "überwieset", "ueberwieset", "überweißet", "ueberweisset", "überweißtet", "ueberweisstet", "überwirft", "ueberwirft", "überwerft", "ueberwerft", "überwerfet", "ueberwerfet", "überwarft", "ueberwarft", "überwürfet", "ueberwuerfet", "überwürft", "ueberwuerft", "überwirft", "ueberwirft", "überwerft", "ueberwerft", "überwerfet", "ueberwerfet", "überwarft", "ueberwarft", "überwürfet", "ueberwuerfet", "überwürft", "ueberwuerft", "überwertetet", "ueberwertetet", "überwiegt", "ueberwiegt", "überwieget", "ueberwieget", "überwogt", "ueberwogt", "überwöget", "ueberwoeget", "überwögt", "ueberwoegt", "überwindet", "ueberwindet", "überwandet", "ueberwandet", "überwändet", "ueberwaendet", "überwölbet", "ueberwoelbet", "überwölbtet", "ueberwoelbtet", "ueberwuerzet", "ueberwuerzet", "überwürztet", "ueberwuerztet", "überzahlet", "ueberzahlet", "überzahltet", "ueberzahltet", "überzahltet", "ueberzahltet", "überzeichnetet", "ueberzeichnetet", "überzeuget", "ueberzeuget", "überzeugtet", "ueberzeugtet", "überzieht", "ueberzieht", "überziehet", "ueberziehet", "überzogt", "ueberzogt", "überzöget", "ueberzoeget", "überzögt", "ueberzoegt", "überzüchtetet", "ueberzuechtetet", "überangebot", "ueberangebot", "überbrückungskredit", "ueberbrückungskredit", "übereinkunft", "uebereinkunft", "überfahrt", "ueberfahrt", "überflugverbot", "ueberflugverbot", "überflutungsgebiet", "ueberflutungsgebiet", "überfracht", "ueberfracht", "überfrucht", "ueberfrucht", "übergangslaut", "uebergangslaut", "übergebot", "uebergebot", "übergewicht", "uebergewicht", "überhangmandat", "ueberhangmandat", "überhangsrecht", "ueberhangsrecht", "überholverbot", "ueberholverbot", "überladenheit", "ueberladenheit", "überlandfahrt", "ueberlandfahrt", "überlast", "ueberlast", "überlegenheit", "ueberlegenheit", "übermacht", "uebermacht", "übermaßverbot", "uebermassverbot", "übermut", "uebermut", "überraschungseffekt", "ueberraschungseffekt", "überraschungsgast", "ueberraschungsgast", "überraschungsmoment", "ueberraschungsmoment", "überredungskunst", "ueberredungskunst", "überreiztheit", "ueberreiztheit", "überrest", "ueberrest", "überschicht", "ueberschicht", "überschnitt", "ueberschnitt", "überschrift", "ueberschrift", "überschwemmungsgebiet", "ueberschwemmungsgebiet", "überseegebiet", "ueberseegebiet", "überseegeschäft", "ueberseegeschaeft", "übersicht", "uebersicht", "überspanntheit", "ueberspanntheit", "überspitztheit", "ueberspitztheit", "übertragungsrecht", "uebertragungsrecht", "übertriebenheit", "uebertriebenheit", "übertritt", "uebertritt", "überwachungsdienst", "ueberwachungsdienst", "überwachungsstaat", "ueberwachungsstaat", "überwelt", "ueberwelt", "überwinterungsgebiet", "ueberwinterungsgebiet", "überzeugtheit", "ueberzeugtheit", "überzeugungstat", "ueberzeugungstat", "überziehungskredit", "ueberziehungskredit"];
};

var regex = {};

Object.defineProperty(regex, "__esModule", {
  value: true
});
regex.exceptions = exceptions;

regex.default = function () {
  return {
    verbsBeginningWithGe: verbsBeginningWithGe$1,
    verbsBeginningWithErVerEntBeZerHerUber: verbsBeginningWithErVerEntBeZerHerUber$1,
    verbsWithGeInMiddle: verbsWithGeInMiddle$1,
    verbsWithErVerEntBeZerHerUberInMiddle: verbsWithErVerEntBeZerHerUberInMiddle$1,
    verbsEndingWithIert: verbsEndingWithIert$1,
    exceptions: exceptions
  };
};

var verbsBeginningWithGeRegex = /^((ge)\S+t($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>]))/ig;
var verbsBeginningWithErVerEntBeZerHerUberRegex = /^(((be|ent|er|her|ver|zer|über|ueber)\S+([^s]t|sst))($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>]))/ig;
var verbsWithGeInMiddleRegex = /(ab|an|auf|aus|vor|wieder|zurück)(ge)\S+t($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>])/ig;
var verbsWithErVerEntBeZerHerUberInMiddleRegex = /((ab|an|auf|aus|vor|wieder|zurück)(be|ent|er|her|ver|zer|über|ueber)\S+([^s]t|sst))($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>])/ig;
var verbsEndingWithIertRegex = /\S+iert($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>])/ig;
var exceptionsRegex$1 = /\S+(apparat|arbeit|dienst|haft|halt|kraft|not|pflicht|schaft|schrift|tät|wert|zeit)($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>])/ig;

/**
 * Checks if the word starts with 'ge'.
 *
 * @param {string} word The word to match.
 * @returns {Array} A list with matches.
 */
var verbsBeginningWithGe$1 = function verbsBeginningWithGe(word) {
  return word.match(verbsBeginningWithGeRegex) || [];
};

/**
 * Checks if the word starts with 'er', 'ver', 'ent', 'be' or 'zer'.
 *
 * @param {string} word The word to match.
 * @returns {Array} A list with matches.
 */
var verbsBeginningWithErVerEntBeZerHerUber$1 = function verbsBeginningWithErVerEntBeZerHerUber(word) {
  return word.match(verbsBeginningWithErVerEntBeZerHerUberRegex) || [];
};

/**
 * Checks if the word contains 'ge' following 'ab', 'an', 'auf', 'aus', 'vor', 'wieder' or 'zurück'.
 *
 * @param {string} word The word to match.
 * @returns {Array} A list with matches.
 */
var verbsWithGeInMiddle$1 = function verbsWithGeInMiddle(word) {
  return word.match(verbsWithGeInMiddleRegex) || [];
};

/**
 * Checks if the word starts with 'er', 'ver', 'ent', 'be' or 'zer',
 * following  'ab', 'an', 'auf', 'aus', 'vor', 'wieder' or 'zurück'.
 *
 * @param {string} word The word to match.
 * @returns {Array} A list with matches.
 */
var verbsWithErVerEntBeZerHerUberInMiddle$1 = function verbsWithErVerEntBeZerHerUberInMiddle(word) {
  return word.match(verbsWithErVerEntBeZerHerUberInMiddleRegex) || [];
};

/**
 * Checks if the word ends in 'iert'.
 *
 * @param {string} word The word to match.
 * @returns {Array} A list with matches.
 */
var verbsEndingWithIert$1 = function verbsEndingWithIert(word) {
  return word.match(verbsEndingWithIertRegex) || [];
};

/**
 * Matches the word against the exceptions regex.
 *
 * @param {string} word The word to match.
 *
 * @returns {Array} A list with matches.
 */
function exceptions(word) {
  return word.match(exceptionsRegex$1) || [];
}

Object.defineProperty(detectAndStemRegularParticiple$3, "__esModule", {
	value: true
});
detectAndStemRegularParticiple$3.detectAndStemRegularParticiple = detectAndStemRegularParticiple$2;

var _exceptionsParticiplesActive$1 = exceptionsParticiplesActive$1;

var _exceptionsParticiplesActive2$1 = _interopRequireDefault$2E(_exceptionsParticiplesActive$1);

var _regex$1 = regex;

function _interopRequireDefault$2E(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Detects whether a word is a regular participle without a prefix and if so, returns the stem.
 *
 * @param {Object}  morphologyDataVerbs The German morphology data for verbs.
 * @param {string}  word                The word (not stemmed) to check.
 *
 * @returns {string|null} The stem or null if no participle was matched.
 */
const detectAndStemParticiplesWithoutPrefixes$1 = function detectAndStemParticiplesWithoutPrefixes(morphologyDataVerbs, word) {
	const geStemTParticipleRegex = new RegExp("^" + morphologyDataVerbs.participleStemmingClasses[1].regex);
	const geStemEtParticipleRegex = new RegExp("^" + morphologyDataVerbs.participleStemmingClasses[0].regex);

	/*
  * Check if it's a ge + stem ending in d/t + et participle.
  * As this is the more specific regex, it needs to be checked before the ge + stem + t regex.
  */
	if (geStemEtParticipleRegex.test(word)) {
		// Remove the two-letter prefix and the two-letter suffix.
		return word.slice(2, word.length - 2);
	}

	// Check if it's a ge + stem + t participle.
	if (geStemTParticipleRegex.test(word)) {
		// Remove the two-letter prefix and the one-letter suffix.
		return word.slice(2, word.length - 1);
	}

	return null;
};

/**
 * Determines whether a given participle pattern combined with prefixes from a given class applies to a given word
 * and if so, returns the stem.
 *
 * @param {string}      word        The word (not stemmed) to check.
 * @param {string[]}    prefixes    The prefixes of a certain prefix class.
 * @param {string}      regexPart   The regex part for a given class (completed to a full regex within the function).
 * @param {number}      startStem   Where to start cutting off the de-prefixed word.
 * @param {number}      endStem     Where to end cutting off the de-prefixed word (from the end index).
 *
 * @returns {string|null} The stem or null if no prefixed participle was matched.
 */
const detectAndStemParticiplePerPrefixClass$1 = function detectAndStemParticiplePerPrefixClass(word, prefixes, regexPart, startStem, endStem) {
	for (const currentPrefix of prefixes) {
		const participleRegex = new RegExp("^" + currentPrefix + regexPart);

		if (participleRegex.test(word)) {
			const wordWithoutPrefix = word.slice(currentPrefix.length - word.length);
			const wordWithoutParticipleAffixes = wordWithoutPrefix.slice(startStem, wordWithoutPrefix.length - endStem);

			return currentPrefix + wordWithoutParticipleAffixes;
		}
	}

	return null;
};

/**
 * Detects whether a word is a regular participle with a prefix and if so, returns the stem.
 *
 * @param {Object}  morphologyDataVerbs The German morphology data for verbs.
 * @param {string}  word                The word (not stemmed) to check.
 *
 * @returns {string|null} The stem or null if no participle with prefix was matched.
 */
const detectAndStemParticiplesWithPrefixes$1 = function detectAndStemParticiplesWithPrefixes(morphologyDataVerbs, word) {
	const prefixesSeparableOrInseparable = morphologyDataVerbs.prefixes.separableOrInseparable;

	/*
  * It's important to preserve order here, since the ge + stem ending in d/t + et regex is more specific than
  * the ge + stem + t regex, and therefore must be checked first.
  */
	for (const participleClass of morphologyDataVerbs.participleStemmingClasses) {
		const regex = participleClass.regex;
		const startStem = participleClass.startStem;
		const endStem = participleClass.endStem;
		const separable = participleClass.separable;

		const prefixes = separable ? morphologyDataVerbs.prefixes.separable : morphologyDataVerbs.prefixes.inseparable;

		let stem = detectAndStemParticiplePerPrefixClass$1(word, prefixes, regex, startStem, endStem);

		if (stem) {
			return stem;
		}

		stem = detectAndStemParticiplePerPrefixClass$1(word, prefixesSeparableOrInseparable, regex, startStem, endStem);

		if (stem) {
			return stem;
		}
	}

	return null;
};

/**
 * Detects whether a word is a regular participle and if so, returns the stem.
 *
 * @param {Object}  morphologyDataVerbs The German morphology data for verbs.
 * @param {string}  word                The word (not stemmed) to check.
 *
 * @returns {string} The participle stem or null if no regular participle was matched.
 */
function detectAndStemRegularParticiple$2(morphologyDataVerbs, word) {
	if ((0, _regex$1.exceptions)(word).length > 0 || (0, _exceptionsParticiplesActive2$1.default)().includes(word)) {
		return "";
	}

	let stem = detectAndStemParticiplesWithoutPrefixes$1(morphologyDataVerbs, word);

	if (stem) {
		return stem;
	}

	stem = detectAndStemParticiplesWithPrefixes$1(morphologyDataVerbs, word);

	if (stem) {
		return stem;
	}

	return null;
}

var flattenSortLength$1 = {};

Object.defineProperty(flattenSortLength$1, "__esModule", {
  value: true
});
flattenSortLength$1.flattenSortLength = flattenSortLength;

var _lodashEs$1B = require$$1$1;

/**
 * Returns combined list of strings/words, sorted by length (descending).
 *
 * @param {Object} dataWords The words data that is going to be sorted.
 *
 * @returns {Array<string>} All words, sorted by length (descending).
 */
function flattenSortLength(dataWords) {
  const allWords = (0, _lodashEs$1B.flatten)(Object.values(dataWords));

  return allWords.sort((a, b) => b.length - a.length || a.localeCompare(b));
}

var stem$t = {};

Object.defineProperty(stem$t, "__esModule", {
	value: true
});
stem$t.default = stem$s;
/**
 * @file German stemming algorithm. Adapted from:
 * @author: Joder Illi
 * @copyright (c) 2010, FormBlitz AG
 * All rights reserved.
 * Implementation of the stemming algorithm from http://snowball.tartarus.org/algorithms/german/stemmer.html
 * Copyright of the algorithm is: Copyright (c) 2001, Dr Martin Porter and can be found at http://snowball.tartarus.org/license.php
 *
 * Redistribution and use in source and binary forms, with or without modification, is covered by the standard BSD license.
 */
/**
 * Determines the start index of the R1 region.
 * R1 is the region after the first non-vowel following a vowel. It should include at least 3 letters.
 *
 * @param {string} word The word for which to determine the R1 region.
 * @returns {number} The start index of the R1 region.
 */
const determineR1$2 = function determineR1(word) {
	// Start with matching first vowel and non-vowel.
	let r1Index = word.search(/[aeiouyäöü][^aeiouyäöü]/);
	// Then add 2 since the R1 index is the index after the first vowel & non-vowel matched with the regex.
	if (r1Index !== -1) {
		r1Index += 2;
	}

	// Adjust R1 so that the region preceding it includes at least 3 letters.
	if (r1Index !== -1 && r1Index < 3) {
		r1Index = 3;
	}

	return r1Index;
};

/**
 * Search for the longest among the following suffixes,
 * (a) em   ern   er
 * (b) e   en   es
 * (c) s (preceded by a valid s-ending)
 * Define a valid s-ending as one of b, d, f, g, h, k, l, m, n, r or t.
 *
 * @param {string} word The word to check for the suffix.
 * @returns {{index1: number, optionUsed1: string}} The index of the suffix and the kind of suffix used.
 */
const findSuffixStep1 = function findSuffixStep1(word) {
	const a1Index = word.search(/(em|ern|er)$/g);
	const b1Index = word.search(/(e|en|es)$/g);
	let c1Index = word.search(/([bdfghklmnrt]s)$/g);
	// Exclude the s-ending before the s.
	if (c1Index !== -1) {
		c1Index++;
	}
	let optionUsed1 = "";
	let index1 = 10000;
	if (a1Index !== -1) {
		optionUsed1 = "a";
		index1 = a1Index;

		return { index1, optionUsed1 };
	} else if (b1Index !== -1) {
		optionUsed1 = "b";
		index1 = b1Index;

		return { index1, optionUsed1 };
	} else if (c1Index !== -1) {
		optionUsed1 = "c";
		index1 = c1Index;

		return { index1, optionUsed1 };
	}

	return { index1, optionUsed1 };
};

/**
 * Search for the longest among the following suffixes,
 * (a) en   er   est
 * (b) st (preceded by a valid st-ending, itself preceded by at least 3 letters)
 * Define a valid st-ending as one of b, d, f, g, h, k, l, m, n or t.
 *
 * @param {string} word The word to check for the suffix.
 * @returns {number} The index of the suffix.
 */
const findSuffixStep2 = function findSuffixStep2(word) {
	const a2Index = word.search(/(en|er|est)$/g);
	let b2Index = word.search(/(.{3}[bdfghklmnt]st)$/g);
	// Exclude the st-ending and the preceding 3 letters.
	if (b2Index !== -1) {
		b2Index += 4;
	}
	let index2 = 10000;
	if (a2Index !== -1) {
		index2 = a2Index;
	} else if (b2Index !== -1) {
		index2 = b2Index;
	}

	return index2;
};

/**
 * Delete the suffix found in step 1 if in R1. (The letter of the valid s-ending is not necessarily in R1.)
 * If an ending of group (b) is deleted, and the ending is preceded by niss, delete the final s.
 * (For example, äckern -> äck, ackers -> acker, armes -> arm, bedürfnissen -> bedürfnis).
 *
 * @param {string} word         The word for which to delete the suffix.
 * @param {number} index1       The index of the suffix found in step 1.
 * @param {string} optionUsed1  The type of the suffix found in step 1.
 * @param {number} r1Index      The R1 index.
 *
 * @returns {string} The word with the deleted suffix.
 */
const deleteSuffix1 = function deleteSuffix1(word, index1, optionUsed1, r1Index) {
	if (index1 !== 10000 && r1Index !== -1) {
		if (index1 >= r1Index) {
			word = word.substring(0, index1);
			if (optionUsed1 === "b") {
				if (word.search(/niss$/) !== -1) {
					word = word.substring(0, word.length - 1);
				}
			}
		}
	}
	return word;
};

/**
 * Delete the suffix found in step 2 if in R1.
 * (For example, derbsten -> derbst by step 1, and derbst -> derb by step 2,
 * since b is a valid st-ending, and is preceded by just 3 letters).
 *
 * @param {string} word     The word for which to delete the suffix.
 * @param {number} index2   The index of the suffix found in step 2.
 * @param {number} r1Index  The R1 index.
 *
 * @returns {string} The word with the deleted suffix.
 */
const deleteSuffix2 = function deleteSuffix2(word, index2, r1Index) {
	if (index2 !== 10000 && r1Index !== -1) {
		if (index2 >= r1Index) {
			word = word.substring(0, index2);
		}
	}
	return word;
};

/**
 * Stems irregular verbs.
 *
 * @param {Object} morphologyDataVerbs  The German morphology data for verbs.
 * @param {string} word                 The word to stem.
 *
 * @returns {string} The stemmed word.
 */
const stemIrregularVerbs = function stemIrregularVerbs(morphologyDataVerbs, word) {
	const irregularVerbs = morphologyDataVerbs.veryIrregularVerbs;

	const matchedParadigm = irregularVerbs.find(paradigm => {
		const forms = paradigm.forms;
		return forms.includes(word);
	});

	if (matchedParadigm) {
		return matchedParadigm.stem;
	}

	return null;
};

/**
 * Stems German words.
 *
 * @param {Object} morphologyDataVerbs  The German morphology data for verbs.
 * @param {string} word                 The word to stem.
 *
 * @returns {string} The stemmed word.
 */
function stem$s(morphologyDataVerbs, word) {
	// Check if word is a very irregular verb, and if so, return its stem.
	const veryIrregularVerbStem = stemIrregularVerbs(morphologyDataVerbs, word);

	if (veryIrregularVerbStem) {
		return veryIrregularVerbStem;
	}

	// Put u and y between vowels into upper case.
	word = word.replace(/([aeiouyäöü])u([aeiouyäöü])/g, "$1U$2");
	word = word.replace(/([aeiouyäöü])y([aeiouyäöü])/g, "$1Y$2");
	word = word.replace(/([aeiouyäöü])i([aeiouyäöü])/g, "$1I$2");
	word = word.replace(/([aeiouyäöü])e([aeiouyäöü])/g, "$1E$2");

	// Find the start index of the R1 region.
	const r1Index = determineR1$2(word);

	// Find suffixes as defined in step 1.
	const index1 = findSuffixStep1(word).index1;
	const optionUsed1 = findSuffixStep1(word).optionUsed1;

	// Delete the suffix found in step 1.
	word = deleteSuffix1(word, index1, optionUsed1, r1Index);

	// Find suffixes as defined in step 2.
	const index2 = findSuffixStep2(word);

	// Delete the suffix found in step 2.
	word = deleteSuffix2(word, index2, r1Index);

	// Turn U and Y back into lower case.
	word = word.replace(/U/g, "u");
	word = word.replace(/Y/g, "y");
	word = word.replace(/I/g, "i");
	word = word.replace(/E/g, "e");

	return word;
}

Object.defineProperty(determineStem$3, "__esModule", {
	value: true
});
determineStem$3.determineStem = determineStem$2;

var _lodashEs$1A = require$$1$1;

var _detectAndStemRegularParticiple$2 = detectAndStemRegularParticiple$3;

var _flattenSortLength$4 = flattenSortLength$1;

var _stem$2 = stem$t;

var _stem2$2 = _interopRequireDefault$2D(_stem$2);

function _interopRequireDefault$2D(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a stem for a word that appears on the noun exception lists.
 *
 * @param {Object}  morphologyDataNouns The German morphology data for nouns.
 * @param {string}  stemmedWord         The stem to check.
 *
 * @returns {string|null} The stemmed word or null if none was found.
 */
const findStemOnNounExceptionList = function findStemOnNounExceptionList(morphologyDataNouns, stemmedWord) {
	const exceptionStems = morphologyDataNouns.exceptionStems;

	for (const exceptionStemSet of exceptionStems) {
		const matchedStem = exceptionStemSet.find(exceptionStem => stemmedWord.endsWith(exceptionStem));

		if (matchedStem) {
			const precedingLexicalMaterial = stemmedWord.slice(0, stemmedWord.length - matchedStem.length);

			return precedingLexicalMaterial + exceptionStemSet[0];
		}
	}

	return null;
};

/**
 * Returns a stem for a word that appears on the adjective exception lists.
 *
 * @param {Object}  morphologyDataAdjectives    The German morphology data for adjectives.
 * @param {string}  stemmedWord                 The stem to check.
 *
 * @returns {string|null} The stemmed word or null if none was found.
 */
const findStemOnAdjectiveExceptionList = function findStemOnAdjectiveExceptionList(morphologyDataAdjectives, stemmedWord) {
	const adjectiveExceptionClasses = morphologyDataAdjectives.exceptions;

	for (const key of Object.keys(adjectiveExceptionClasses)) {
		const exceptionStems = adjectiveExceptionClasses[key];

		for (const exceptionStemSet of exceptionStems) {
			if (exceptionStemSet.includes(stemmedWord)) {
				return exceptionStemSet[0];
			}
		}
	}

	return null;
};

/**
 * Returns a stem for a word that appears on the verb exception lists.
 *
 * @param {Object}  morphologyDataVerbs The German morphology data for verbs.
 * @param {string}  stemmedWord         The stem to check.
 *
 * @returns {string|null} The stemmed word or null if none was found.
 */
const findStemOnVerbExceptionList$1 = function findStemOnVerbExceptionList(morphologyDataVerbs, stemmedWord) {
	let wordToCheck = stemmedWord;
	const strongAndIrregularVerbStems = morphologyDataVerbs.strongAndIrregularVerbs.stems;
	const prefixes = (0, _flattenSortLength$4.flattenSortLength)(morphologyDataVerbs.prefixes);

	let matchedPrefix = prefixes.find(prefix => stemmedWord.startsWith(prefix));

	if (matchedPrefix) {
		const wordWithoutPrefix = wordToCheck.slice(matchedPrefix.length, wordToCheck.length);

		/* At least 3 characters so that e.g. "be" is not found in the stem "berg". A minimum length of 3 was chosen
   * as a safe option, since 2-letter verb stems are highly unlikely to impossible.
   */
		if (wordWithoutPrefix.length > 2) {
			wordToCheck = wordWithoutPrefix;
		} else {
			matchedPrefix = null;
		}
	}

	for (const strongOrIrregularVerbParadigm of strongAndIrregularVerbStems) {
		let stems = strongOrIrregularVerbParadigm.stems;
		stems = (0, _lodashEs$1A.flatten)(Object.values(stems));

		if (stems.includes(wordToCheck)) {
			if (matchedPrefix) {
				// The present tense stem is returned as a default stem.
				return matchedPrefix + strongOrIrregularVerbParadigm.stems.present;
			}

			return strongOrIrregularVerbParadigm.stems.present;
		}
	}

	return null;
};

/**
 * Returns the stem for a given German input word.
 *
 * @param   {string} word                   The word to get the stem for.
 * @param   {Object} morphologyDataGerman   The German morphology data.
 *
 * @returns {string} Stemmed form of the word.
 */
function determineStem$2(word, morphologyDataGerman) {
	const verbData = morphologyDataGerman.verbs;
	const stemmedWord = (0, _stem2$2.default)(verbData, word);

	/*
  * Goes through the stem exception functions from left to right, returns the first stem it finds.
  * If no stem has been found, return the original, programmatically created, stem.
  */
	return findStemOnNounExceptionList(morphologyDataGerman.nouns, stemmedWord) || findStemOnAdjectiveExceptionList(morphologyDataGerman.adjectives, stemmedWord) || findStemOnVerbExceptionList$1(verbData, stemmedWord) || (0, _detectAndStemRegularParticiple$2.detectAndStemRegularParticiple)(verbData, word) || stemmedWord;
}

var determineStem$1 = {};

var stem$r = {};

var exceptionListHelpers = {};

Object.defineProperty(exceptionListHelpers, "__esModule", {
	value: true
});
exceptionListHelpers.checkIfWordEndingIsOnExceptionList = checkIfWordEndingIsOnExceptionList;
exceptionListHelpers.checkIfWordIsOnVerbExceptionList = checkIfWordIsOnVerbExceptionList;
exceptionListHelpers.checkExceptionListWithTwoStems = checkExceptionListWithTwoStems;

var _flattenSortLength$3 = flattenSortLength$1;

/**
 * Checks whether the word ends in one of the words in an exception list that is a simple array.
 *
 * @param {string}	    word            The word to check.
 * @param {string[]}	exceptionList	The list of exceptions.
 *
 * @returns {boolean}	Whether the checked word ends in one of the words in the exception list.
 */
function checkIfWordEndingIsOnExceptionList(word, exceptionList) {
	for (let i = 0; i < exceptionList.length; i++) {
		if (word.endsWith(exceptionList[i])) {
			return true;
		}
	}
	return false;
}

/**
 * Checks whether a word is on a verb exception list. Before checking the list, checks whether the word has a verb prefix
 * and if it does, removes it.
 *
 * @param {string}	 	word					The word to check.
 * @param {string[]}	exceptionList			The list of exceptions
 * @param {Object}		compoundVerbPrefixes	The list of separable and inseparable verb prefixes
 * @returns {boolean}	Whether the word was found on the exception list or not
 */
function checkIfWordIsOnVerbExceptionList(word, exceptionList, compoundVerbPrefixes) {
	const prefixes = (0, _flattenSortLength$3.flattenSortLength)(compoundVerbPrefixes);

	// Check whether the inputted word starts with one of the compound prefixes
	const foundPrefix = prefixes.find(prefix => word.startsWith(prefix));
	let stemmedWordWithoutPrefix = "";

	if (typeof foundPrefix === "string") {
		stemmedWordWithoutPrefix = word.slice(foundPrefix.length);
		// At least 3 characters left after prefix deletion so that e.g. "be" is not treated as a prefix if found in the word "berg".
		if (stemmedWordWithoutPrefix.length > 2) {
			word = stemmedWordWithoutPrefix;
		}
	}

	return exceptionList.includes(word);
}

/**
 * Checks whether the word ends in one of the words in an exception list with two stems.
 *
 * @param {Array} exceptionListWithTwoStems The exception list with two stems
 * @param {string} word	The word to check
 * @returns {string} The stem
 */
function checkExceptionListWithTwoStems(exceptionListWithTwoStems, word) {
	for (const stemSet of exceptionListWithTwoStems) {
		const foundStem = stemSet.find(stemWord => word.endsWith(stemWord));
		if (foundStem) {
			const precedingLexicalMaterial = word.slice(0, word.length - foundStem.length);

			return precedingLexicalMaterial + stemSet[0];
		}
	}
}

var stemHelpers = {};

Object.defineProperty(stemHelpers, "__esModule", {
  value: true
});
stemHelpers.removeSuffixesFromFullForm = removeSuffixesFromFullForm;
stemHelpers.removeSuffixFromFullForm = removeSuffixFromFullForm;
/**
 * Checks whether the word is started with one of the words in a given list of exceptions
 * and ends in one of the suffixes in a given suffixes list. If so, deletes the suffix.
 *
 * @param {string[]}    exceptions  The exception list.
 * @param {string[]}    suffixes      The suffixes that needs to be deleted.
 * @param {string}      word        The word to check.
 * @returns {string}	The stemmed word.
 */
function removeSuffixesFromFullForm(exceptions, suffixes, word) {
  for (let i = 0; i < exceptions.length; i++) {
    if (word.startsWith(exceptions[i])) {
      const suffixRetrieved = word.substring(exceptions[i].length);
      for (let j = 0; j < suffixes.length; j++) {
        if (suffixes[j] === suffixRetrieved) {
          return word.slice(0, -suffixRetrieved.length);
        }
      }
    }
  }
}

/**
 * Checks whether the word is in a given list of exceptions and if so, deletes a given suffix.
 *
 * @param {string[]}    exceptions  The exception list.
 * @param {string}      suffix      The suffix that needs to be deleted.
 * @param {string}      word        The word to check.
 *
 * @returns {string} The stemmed word.
 */
function removeSuffixFromFullForm(exceptions, suffix, word) {
  for (let i = 0; i < exceptions.length; i++) {
    if (word.endsWith(exceptions[i])) {
      return word.slice(0, -suffix.length);
    }
  }
}

var detectAndStemSuffixes$1 = {};

var stemModificationHelpers = {};

Object.defineProperty(stemModificationHelpers, "__esModule", {
  value: true
});
stemModificationHelpers.modifyStem = modifyStem;
stemModificationHelpers.isVowelDoublingAllowed = isVowelDoublingAllowed;

var _exceptionListHelpers$5 = exceptionListHelpers;

/**
 * Checks whether the word is on any of the sub-lists of the noVowelDoublingList (ending match, exact match,
 * and verbs) and returns true if it is.
 *
 * @param {string}	word							The word to check.
 * @param {Object}	noVowelDoublingList	The list of stems that should not have the vowel doubled.
 * @param {Object}	compoundVerbPrefixes			The list of inseparable and separable verb prefixes.
 *
 * @returns {boolean} Whether the word was found on one of the lists
 */
const checkIfWordIsOnNoVowelDoublingList = function checkIfWordIsOnNoVowelDoublingList(word, noVowelDoublingList, compoundVerbPrefixes) {
  if ((0, _exceptionListHelpers$5.checkIfWordEndingIsOnExceptionList)(word, noVowelDoublingList.endingMatch) || (0, _exceptionListHelpers$5.checkIfWordIsOnVerbExceptionList)(word, noVowelDoublingList.verbs, compoundVerbPrefixes) || noVowelDoublingList.exactMatch.includes(word)) {
    return true;
  }
};

/**
 * Checks whether the third to last and fourth to last characters of the stem are the same. This, in principle, checks
 * whether the last vowel of the stem is preceded by a double consonant (as only consonants can precede the vowel).
 * If the third and fourth to last characters are the same, it means that vowel doubling is allowed. For example, in the
 * word 'luttel', the third and fourth to last characters are both t's so it should not become 'lutteel'.
 *
 * @param {string} word The stemmed word to check.
 *
 * @returns {boolean} Whether the vowel should be doubled or not.
 */
const isVowelPrecededByDoubleConsonant = function isVowelPrecededByDoubleConsonant(word) {
  const fourthToLastLetter = word.charAt(word.length - 4);
  const thirdToLastLetter = word.charAt(word.length - 3);
  return fourthToLastLetter !== thirdToLastLetter;
};

/**
 * Checks whether the second to last syllable contains a diphthong. If it does, the vowel in the last syllable should
 * not be doubled.
 *
 * @param {string} word                 The stemmed word to check.
 * @param {string} noVowelDoublingRegex The regex to match a word with.
 *
 * @returns {boolean} Whether the vowel should be doubled or not.
 */
const doesPrecedingSyllableContainDiphthong = function doesPrecedingSyllableContainDiphthong(word, noVowelDoublingRegex) {
  return word.search(new RegExp(noVowelDoublingRegex)) === -1;
};

/**
 * Modifies the stem of the word according to the specified modification type.
 *
 * @param {string} word The stem that needs to be modified.
 * @param {string[]} modificationGroup The type of modification that needs to be done.
 * @returns {string} The modified stem, or the same stem if no modification was made.
 */
function modifyStem(word, modificationGroup) {
  const neededReplacement = modificationGroup.find(replacement => word.search(new RegExp(replacement[0])) !== -1);
  if (typeof neededReplacement !== "undefined") {
    word = word.replace(new RegExp(neededReplacement[0]), neededReplacement[1]);
  }return word;
}

/**
 * Checks whether the final vowel of the stem should be doubled by going through four checks.
 *
 * @param {string}  word                               The stemmed word that the check should be executed on.
 * @param {Object}  morphologyDataNLStemmingExceptions The Dutch morphology data for stemming exceptions.
 * @param {Object}  morphologyDataNLVerbPrefixes	   The separable and inseparable verb prefixes.
 *
 * @returns {boolean} Whether the vowel should be doubled or not.
 */
function isVowelDoublingAllowed(word, morphologyDataNLStemmingExceptions, morphologyDataNLVerbPrefixes) {
  // Check whether the word is on the list of verbs which should have the vowel doubled (exception to third check)
  const firstCheck = (0, _exceptionListHelpers$5.checkIfWordIsOnVerbExceptionList)(word, morphologyDataNLStemmingExceptions.getVowelDoubling, morphologyDataNLVerbPrefixes);
  // Check whether the word is on the list of words which should NOT have the vowel doubled
  const secondCheck = checkIfWordIsOnNoVowelDoublingList(word, morphologyDataNLStemmingExceptions.noVowelDoubling, morphologyDataNLVerbPrefixes);
  const thirdCheck = isVowelPrecededByDoubleConsonant(word);
  const fourthCheck = doesPrecedingSyllableContainDiphthong(word, morphologyDataNLStemmingExceptions.noVowelDoubling.rule);

  return firstCheck || !secondCheck && thirdCheck && fourthCheck;
}

Object.defineProperty(detectAndStemSuffixes$1, "__esModule", {
	value: true
});
detectAndStemSuffixes$1.default = detectAndStemSuffixes;

var _stemModificationHelpers$3 = stemModificationHelpers;

/**
 * Determines the start index of the R1 region.
 * R1 is the region after the first non-vowel following a vowel. It should include at least 3 letters.
 *
 * @param {string} word The word for which to determine the R1 region.
 * @returns {number} The start index of the R1 region.
 */
const determineR1$1 = function determineR1(word) {
	// Start with matching the first cluster that consists of a vowel and a non-vowel.
	let r1Index = word.search(/[aeiouyèäüëïöáéíóú][^aeiouyèäüëïöáéíóú]/);
	// Then add 2 since the R1 index is the index after the first vowel & non-vowel matched with the regex.
	if (r1Index !== -1) {
		r1Index += 2;
	}

	// Adjust R1 so that the region preceding it includes at least 3 letters.
	if (r1Index !== -1 && r1Index < 3) {
		r1Index = 3;
	}

	return r1Index;
};

/**
 * Searches for suffixes in a word.
 *
 * @param {string} word 	The word in which to look for suffixes.
 * @param {Object} suffixStep	 One of the three steps of findings suffixes.
 * @param {number} r1Index	 The index of the R1 region.
 * @returns {Object} The index of the suffix and extra information about whether, and how, the stem will need to be modified.
 */
/**
 * @file Dutch stemming algorithm. Adapted from:
 * @author:
 * @copyright
 * All rights reserved.
 * Implementation of the stemming algorithm from http://snowball.tartarus.org/algorithms/dutch/stemmer.html
 * Copyright of the algorithm is: Copyright (c) 2001, Dr Martin Porter and can be found at http://snowball.tartarus.org/license.php
 *
 * Redistribution and use in source and binary forms, with or without modification, is covered by the standard BSD license.
 */

const findSuffix = function findSuffix(word, suffixStep, r1Index) {
	for (const suffixClass in suffixStep) {
		if (suffixStep.hasOwnProperty(suffixClass)) {
			const suffixes = suffixStep[suffixClass].suffixes;

			const matchedRegex = suffixes.find(suffixRegex => new RegExp(suffixRegex).exec(word));

			if (matchedRegex) {
				const matched = new RegExp(matchedRegex).exec(word);
				const suffix = matched[matched.length - 1];
				const suffixIndex = word.lastIndexOf(suffix);

				if (r1Index !== -1 && suffixIndex >= r1Index) {
					return {
						suffixIndex: suffixIndex,
						stemModification: suffixStep[suffixClass].stemModification
					};
				}
			}
		}
	}
};

/**
 * Deletes the suffix and modifies the stem according to the required modifications.
 *
 * @param {string} word	 The word from which to delete the suffix.
 * @param {Object} suffixStep 	One of the three steps of deleting a suffix.
 * @param {number} suffixIndex	 The index of the found suffix.
 * @param {string} stemModification 	The type of stem modification that needs to be done.
 * @param {Object} morphologyDataNL	 The Dutch morphology data file.
 * @returns {string} The stemmed and modified word.
 */
const deleteSuffixAndModifyStem = function deleteSuffixAndModifyStem(word, suffixStep, suffixIndex, stemModification, morphologyDataNL) {
	if (stemModification === "hedenToHeid") {
		return (0, _stemModificationHelpers$3.modifyStem)(word, morphologyDataNL.regularStemmer.stemModifications.hedenToHeid);
	}
	word = word.substring(0, suffixIndex);
	if (stemModification === "changeIedtoId") {
		return (0, _stemModificationHelpers$3.modifyStem)(word, morphologyDataNL.regularStemmer.stemModifications.iedToId);
	} else if (stemModification === "changeInktoIng" && word.endsWith("ink")) {
		return (0, _stemModificationHelpers$3.modifyStem)(word, morphologyDataNL.regularStemmer.stemModifications.inkToIng);
	} else if (stemModification === "vowelDoubling" && (0, _stemModificationHelpers$3.isVowelDoublingAllowed)(word, morphologyDataNL.regularStemmer.stemModifications.exceptionsStemModifications, morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes)) {
		return (0, _stemModificationHelpers$3.modifyStem)(word, morphologyDataNL.regularStemmer.stemModifications.doubleVowel);
	}
	return word;
};

/**
 * Finds and deletes the suffix found in a particular step, and modifies the stem.
 *
 * @param {string} word 	The word for which to find and delete a suffix.
 * @param {Object} suffixStep	 One of the three suffix steps.
 * @param {number} r1Index	 The index of the R1 region.
 * @param {Object} morphologyDataNL	 The Dutch morphology data file.
 * @returns {string} The word with the deleted suffix.
 */
const findAndDeleteSuffix = function findAndDeleteSuffix(word, suffixStep, r1Index, morphologyDataNL) {
	const foundSuffix = findSuffix(word, suffixStep, r1Index);
	if (typeof foundSuffix !== "undefined") {
		word = deleteSuffixAndModifyStem(word, suffixStep, foundSuffix.suffixIndex, foundSuffix.stemModification, morphologyDataNL);
	}

	return word;
};

/**
 * Runs through three stemming steps that process different kinds of suffixes, determines if there is a valid suffix
 * within the R1 region that can be deleted for stemming and deletes it, as well as applies suffix-specific stem
 * modifications if needed.
 *
 * @param {string} word 	The word for which to find and delete suffixes.
 * @param {Object} suffixSteps	 All of the suffix steps.
 * @param {number} r1Index	 The index of the R1 region
 * @param {Object} morphologyDataNL 	The Dutch morphology data file.
 * @returns {string} The word with the delete suffix.
 */
const findAndDeleteSuffixes = function findAndDeleteSuffixes(word, suffixSteps, r1Index, morphologyDataNL) {
	for (const suffixStep in suffixSteps) {
		if (suffixSteps.hasOwnProperty(suffixStep)) {
			word = findAndDeleteSuffix(word, suffixSteps[suffixStep], r1Index, morphologyDataNL);
		}
	}

	return word;
};

/**
 * Search for suffixes in a word, remove them if found, and modify the stem if needed.
 *
 * @param {string} word  The word to stem.
 * @param {Object} morphologyDataNL The Dutch morphology data file.
 *
 * @returns {string} The stemmed word.
 */
function detectAndStemSuffixes(word, morphologyDataNL) {
	/*
  * Put i and y in between vowels, initial y, and y after a vowel into upper case. This is because they should
  * be treated as consonants so we want to differentiate them from other i's and y's when matching regexes.
  */
	word = (0, _stemModificationHelpers$3.modifyStem)(word, morphologyDataNL.regularStemmer.stemModifications.IAndYToUppercase);

	// Find the start index of the R1 region.
	const r1Index = determineR1$1(word);

	// Import the suffixes from all three steps.
	const suffixSteps = morphologyDataNL.regularStemmer.suffixes;

	// Run through the three steps of possible de-suffixation.
	word = findAndDeleteSuffixes(word, suffixSteps, r1Index, morphologyDataNL);

	// Do final modifications to the stem.
	return (0, _stemModificationHelpers$3.modifyStem)(word, morphologyDataNL.regularStemmer.stemModifications.finalChanges);
}

var getStemWordsWithTAndDEnding = {};

var regexHelpers = {};

Object.defineProperty(regexHelpers, "__esModule", {
  value: true
});
regexHelpers.doesWordMatchRegex = doesWordMatchRegex;
regexHelpers.searchAndReplaceWithRegex = searchAndReplaceWithRegex;
regexHelpers.applyAllReplacements = applyAllReplacements;
/**
 * Checks whether a word is matched with a regex.
 *
 * @param {string} word		The word to check.
 * @param {string} regex	The regex.
 * @returns {boolean}		Whether or not there was a match.
 */
function doesWordMatchRegex(word, regex) {
  const regexObject = RegExp(regex);
  return regexObject.test(word);
}

/**
 * Loops through a nested array with pairs of regexes and replacements, and performs the needed replacement if a match is found.
 *
 * @param {string} word 							The word that may need to be modified.
 * @param {[][]} groupOfRegexAndReplacements 	The array with the regexes and the required replacements.
 * @returns {?string} The modified stem or null if no match was found.
 */
function searchAndReplaceWithRegex(word, groupOfRegexAndReplacements) {
  for (const regexAndReplacement of groupOfRegexAndReplacements) {
    if (word.search(new RegExp(regexAndReplacement[0])) !== -1) {
      word = word.replace(new RegExp(regexAndReplacement[0]), regexAndReplacement[1]);
      return word;
    }
  }
}

/**
 * Loops through a nested array of regexes and replacement pairs, and applies all replacements for which a match is found.
 *
 * @param {string}      word                        The word that may need to be modified.
 * @param {string[]}    listOfRegexAndReplacement   The array with the regexes and the replacements.
 *
 * @returns {string} The modified word.
 */
function applyAllReplacements(word, listOfRegexAndReplacement) {
  listOfRegexAndReplacement.forEach(function (setOfRegexAndReplacement) {
    word = word.replace(new RegExp(setOfRegexAndReplacement[0]), setOfRegexAndReplacement[1]);
  });
  return word;
}

Object.defineProperty(getStemWordsWithTAndDEnding, "__esModule", {
	value: true
});
getStemWordsWithTAndDEnding.generateCorrectStemWithTAndDEnding = generateCorrectStemWithTAndDEnding;

var _exceptionListHelpers$4 = exceptionListHelpers;

var _regexHelpers$3 = regexHelpers;

var _stemModificationHelpers$2 = stemModificationHelpers;

/**
 * Checks whether the word ends in suffixes -e or -en which are preceded by -t or -d, and the -t/-d is part of the stem.
 * If it does, stem the -e/-en. Also checks if after suffix deletion the stemmed word needs modification, and applies it if
 * needed. e.g. doden -> dod -> dood
 *
 * @param {Object} 		morphologyDataNL			 	The Dutch morphology data file.
 * @param {string[]} 	regexAndReplacement				The regex to check and the string replacement that should be made.
 * @param {string} 		word							The word to be checked.
 *
 * @returns {?string}							The stem created or null.
 */
const stemWordsWithEOrEnSuffix = function stemWordsWithEOrEnSuffix(morphologyDataNL, regexAndReplacement, word) {
	if ((0, _regexHelpers$3.doesWordMatchRegex)(word, regexAndReplacement[0])) {
		const stemmedWord = word.replace(new RegExp(regexAndReplacement[0]), regexAndReplacement[1]);
		if ((0, _stemModificationHelpers$2.isVowelDoublingAllowed)(stemmedWord, morphologyDataNL.regularStemmer.stemModifications.exceptionsStemModifications, morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes)) {
			const replacement = (0, _regexHelpers$3.searchAndReplaceWithRegex)(stemmedWord, morphologyDataNL.regularStemmer.stemModifications.doubleVowel);
			return replacement ? replacement : stemmedWord;
		}
		return stemmedWord;
	}

	return null;
};

/**
 * Stems words for which we know that -t/-d is the ending of the stem (so the -t/-d is not stemmed). This is done through
 * checking lists of words and matching the word with regexes.
 *
 * @param {string}	word								The word to check.
 * @param {Object} 	morphologyDataNL 					The Dutch morphology data.
 *
 * @returns {?string} 							The stemmed word, if matched in one of the checks, or null if not matched.
 */
const checkWhetherTOrDIsPartOfStem = function checkWhetherTOrDIsPartOfStem(word, morphologyDataNL) {
	const tAndDPartOfStemData = morphologyDataNL.ambiguousTAndDEndings.tOrDArePartOfStem;
	/*
  * Step 1:
  * - If the stem ends in -tte, -tten, -dde or -dden leave the first -t/-d and stem the remaining ending.
  * - Example: "katten" (-ten should be stemmed, leaving "kat").
  */
	let stemmedWord = (0, _regexHelpers$3.searchAndReplaceWithRegex)(word, tAndDPartOfStemData.firstTOrDPartOfStem);

	if (stemmedWord) {
		return stemmedWord;
	}

	/*
  * Step 2:
  * 2a)
  * - Checks whether the word is in the exception list of verbal forms ending in long vowel + -fden/sden. If so, stems -den off.
  * - Example: "hoefden" (-den should be stemmed, leaving "hoef").
  * 2b)
  * - Check whether the word has the suffix -en preceded by -d, where the -d is part of the stem. If it is, stem only -en.
  * - Example: "eenden" (-en should be stemmed, leaving "eend").
  */
	if (tAndDPartOfStemData.verbsDenShouldBeStemmed.includes(word)) {
		return word.slice(0, -3);
	}

	if ((0, _exceptionListHelpers$4.checkIfWordEndingIsOnExceptionList)(word, tAndDPartOfStemData.wordsStemOnlyEnEnding.endingMatch) || (0, _exceptionListHelpers$4.checkIfWordIsOnVerbExceptionList)(word, tAndDPartOfStemData.wordsStemOnlyEnEnding.verbs, morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes) || (0, _regexHelpers$3.doesWordMatchRegex)(word, tAndDPartOfStemData.denEnding)) {
		stemmedWord = word.slice(0, -2);
		//	Check if the vowel needs to be doubled after deleting suffix -en.
		if ((0, _stemModificationHelpers$2.isVowelDoublingAllowed)(stemmedWord, morphologyDataNL.regularStemmer.stemModifications.exceptionsStemModifications, morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes)) {
			const replacement = (0, _regexHelpers$3.searchAndReplaceWithRegex)(stemmedWord, morphologyDataNL.regularStemmer.stemModifications.doubleVowel);
			return replacement ? replacement : stemmedWord;
		}
		return stemmedWord;
	}

	/*
  * Step 3:
  * - Checks whether the word matches the regex for words ending in -de with -d being part of the stem. If it is matched,
  * only stem the -e.
  * - Example: "beenharde" (-e should be stemmed, leaving "beenhard")
  */
	const dIsPartOfStemRegex = tAndDPartOfStemData.deEnding;
	stemmedWord = stemWordsWithEOrEnSuffix(morphologyDataNL, dIsPartOfStemRegex, word);

	if (stemmedWord) {
		return stemmedWord;
	}

	/*
  * Step 4:
  * - Checks whether the word matches the regex for words ending in -te or -ten with -t being part of the stem. If it is
  * matched, only stem the -e/-en.
  * - Example: "castraten" (-en should be stemmed, leaving "castraat")
  */
	const tIsPartOfStemRegex = tAndDPartOfStemData.teAndTenEndings;
	stemmedWord = stemWordsWithEOrEnSuffix(morphologyDataNL, tIsPartOfStemRegex, word);

	if (stemmedWord) {
		return stemmedWord;
	}

	return null;
};

/**
 * Creates the correct stem for words which end in ambiguous endings -t, -te, -ten, -de, or -den.
 *
 * @param {Object} 		morphologyDataNL 					The Dutch morphology data.
 * @param {string} 		word								The word to be checked.
 *
 * @returns {?string} 	The stemmed word or null.
 */
function generateCorrectStemWithTAndDEnding(morphologyDataNL, word) {
	/*
  * Step 1:
  * - Check whether the word is in the exception list of words in which -t ending needs to be stemmed. If it is, stem -t.
  * - Example: "squasht".
  * - This is an exception to one of the rule in step 2.
  */
	if ((0, _exceptionListHelpers$4.checkIfWordEndingIsOnExceptionList)(word, morphologyDataNL.ambiguousTAndDEndings.wordsTShouldBeStemmed)) {
		return word.slice(0, -1);
	}

	/*
  * Step 2:
  * - Check if word is matched by a regex for a t that shouldn't be stemmed.
  * - Example: "boot".
  */
	if ((0, _regexHelpers$3.doesWordMatchRegex)(word, morphologyDataNL.ambiguousTAndDEndings.tOrDArePartOfStem.tEnding)) {
		return word;
	}

	/*
  * Step 3:
  * - Check whether the word has another suffix that should be stemmed (e.g. -en) preceded by -t or -d which is part of the stem.
  *  If yes, stem the suffix that should be stemmed and return the stem which ends in -t/-d.
  * - Example: "tijden" (only -en should be removed, not -den).
  */

	const stemmedWord = checkWhetherTOrDIsPartOfStem(word, morphologyDataNL);

	if (stemmedWord) {
		return stemmedWord;
	}

	return null;
}

var checkExceptionsWithFullForms = {};

Object.defineProperty(checkExceptionsWithFullForms, "__esModule", {
	value: true
});

checkExceptionsWithFullForms.default = function (morphologyDataNL, word) {
	const exceptionListWithFullForms = morphologyDataNL.stemExceptions.stemmingExceptionStemsWithFullForms;

	let stem = checkVerbFullFormsList(word, exceptionListWithFullForms.verbs, morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes);
	if (stem) {
		return stem;
	}

	stem = checkEndingMatchFullFormsList(word, exceptionListWithFullForms.endingMatch);
	if (stem) {
		return stem;
	}

	stem = checkExactMatchFullFormsList(word, exceptionListWithFullForms.exactMatch);
	if (stem) {
		return stem;
	}

	return null;
};

var _lodashEs$1z = require$$1$1;

var _flattenSortLength$2 = flattenSortLength$1;

/**
 * Checks whether the word is on the verbs sub-list of the full forms list. Before checking the list, checks whether the word
 * begins with one of the compound verb prefixes, and the prefix is removed if one is found. If a match is found after checking
 * the full forms list, the canonical stem is returned, with the prefix attached back if there was one in the input word.
 * e.g. aanbevelen -> aanbeveel
 *
 * @param {string}			word							The word to check.
 * @param {string[]}		verbFullFormsList				The list of verb forms we search for match in.
 * @param {Object}			compoundVerbPrefixes			The list of separable and inseparable compound verb prefixes.
 *
 * @returns {string|null}	The canonical stem or null if no match found.
 */
const checkVerbFullFormsList = function checkVerbFullFormsList(word, verbFullFormsList, compoundVerbPrefixes) {
	const prefixes = (0, _flattenSortLength$2.flattenSortLength)(compoundVerbPrefixes);

	// Check whether the inputted word starts with one of the compound prefixes
	const foundPrefix = prefixes.find(prefix => word.startsWith(prefix));

	if (typeof foundPrefix === "string") {
		word = word.slice(foundPrefix.length);
	}

	for (let i = 0; i < verbFullFormsList.length; i++) {
		const stemAndForms = (0, _lodashEs$1z.flatten)(verbFullFormsList[i]);
		for (let j = 0; j < stemAndForms.length; j++) {
			if (stemAndForms.includes(word)) {
				if (typeof foundPrefix === "string") {
					return foundPrefix + stemAndForms[0];
				}
				return stemAndForms[0];
			}
		}
	}
	return null;
};

/**
 * Checks whether the word is on the sub-list of the full forms list for which we search for an ending match between one of
 * the forms and the word (i.e., whether the word ends with a form from the list). If a match is found, the canonical
 * stem is returned. e.g. fitnesscentra -> fitnesscentrum
 *
 * @param {string}			word							The word to check.
 * @param {string[]}		endingMatchFullFormsList		The list we search for an ending match in.
 * @returns {string|null}	The canonical stem or null if no match found.
 */
const checkEndingMatchFullFormsList = function checkEndingMatchFullFormsList(word, endingMatchFullFormsList) {
	for (let i = 0; i < endingMatchFullFormsList.length; i++) {
		const stemAndForms = (0, _lodashEs$1z.flatten)(endingMatchFullFormsList[i]);
		for (let j = 0; j < stemAndForms.length; j++) {
			if (word.endsWith(stemAndForms[j])) {
				/*
     * Check if the word checked is actually a compound word. e.g. familielid
     * The character/s preceding the words in the exception should be at least 2 characters in order to be a valid compound element.
    */
				const precedingLexicalMaterial = word.slice(0, -stemAndForms[j].length);

				if (precedingLexicalMaterial.length === 1) {
					return null;
				}

				if (precedingLexicalMaterial.length > 1) {
					return precedingLexicalMaterial + stemAndForms[0];
				}
				return stemAndForms[0];
			}
		}
	}
	return null;
};

/**
 * Checks whether the word is on the sub-list of the full forms list for which we search for the exact match between one of
 * the forms and the word. If a match is found, the canonical stem is returned. e.g. curricula -> curriculum
 *
 * @param {string}			word						The word to check.
 * @param {string[]}		exactMatchFullFormsList		The list we search for an exact match in.
 * @returns {string|null}	The canonical stem or null if no match found.
 */
const checkExactMatchFullFormsList = function checkExactMatchFullFormsList(word, exactMatchFullFormsList) {
	for (let i = 0; i < exactMatchFullFormsList.length; i++) {
		const stemAndForms = (0, _lodashEs$1z.flatten)(exactMatchFullFormsList[i]);
		for (let j = 0; j < stemAndForms.length; j++) {
			if (stemAndForms.includes(word)) {
				return stemAndForms[0];
			}
		}
	}
	return null;
};

var detectAndStemRegularParticiple$1 = {};

var nonParticiples = {};

Object.defineProperty(nonParticiples, "__esModule", {
	value: true
});

nonParticiples.default = function () {
	return ["gebraad", "gemoed", "gebed", "gebied", "gebod", "gebodsbord", "geboorte-eiland", "geboortestad", "gebruikspaard", "gedachtewereld", "gedenkblad", "gedenknaald", "gedichtenwedstrijd", "gedoogakkoord", "gedoogbeleid", "geduld", "geestenwereld", "geesteskind", "geestestoestand", "geesteswereld", "gehandicaptenbeleid", "gehoorafstand", "gehoorsafstand", "geitenbaard", "geitenhuid", "geld", "geldhond", "geldvoorraad", "geleidehond", "gelijkekansenbeleid", "geloofsdaad", "geloofsinhoud", "geluidswand", "gelukskind", "gemeenschapsraad", "gemeentebeleid", "gemeenteraad", "gemeenteraadslid", "gemoedstoestand", "genadeverbond", "genderbeleid", "geneesmiddelenbeleid", "generaalsbewind", "geslachtsdaad", "gespreksavond", "gespreksflard", "getijdengebied", "gevangenisbeleid", "gevangeniswereld", "gevechtsafstand", "gevelwand", "gevoelstoestand", "gevoelswereld", "gewelddaad", "geweldigaard", "geweldverbod", "gezelschapshond", "gezichtsafstand", "gezichtshuid", "gezinsbeleid", "gezinsbond", "gezinshoofd", "gezinslid", "gezinspaard", "gezinstoestand", "gezondheidsbeleid", "gezondheidstoestand", "gezondheidszorgbeleid", "gecentreerd", "geserreerd", "gepolitoerd", "gebocheld", "gebrild", "gegleufd", "gekarteld", "gemeubeld", "gesausd", "geaccidenteerd", "geaccrediteerd", "geacheveerd", "geaderd", "geaggregeerd", "geagiteerd", "geallieerd", "geanimeerd", "geanticipeerd", "gearticuleerd", "geassorteerd", "gebenedijd", "gebiedend", "geblaseerd", "geblindeerd", "geborneerd", "gebronzeerd", "gebrouilleerd", "gebruind", "gecharmeerd", "gechromeerd", "geciviliseerd", "geclausuleerd", "gecoiffeerd", "geconditioneerd", "geconstipeerd", "gecontinueerd", "gecoöpteerd", "gecrispeerd", "gecultiveerd", "gedecideerd", "gedecolleteerd", "gedegouteerd", "gedemilitariseerd", "gedemodeerd", "gedesillusioneerd", "gedesinteresseerd", "gedetailleerd", "gediplomeerd", "gedisciplineerd", "gedisponeerd", "gedistingeerd", "gedomicilieerd", "gedoteerd", "gedupeerd", "geëigend", "geestdodend", "geestverruimend", "geëxalteerd", "geëxponeerd", "gefigureerd", "gefingeerd", "geflatteerd", "geforceerd", "gefumeerd", "gegeerd", "gegeneerd", "gegradueerd", "gegriepeerd", "gehaaid", "gehandschoend", "gehavend", "gehomologeerd", "gehorend", "geïllustreerd", "geïmponeerd", "geïmproviseerd", "geïncrimineerd", "geïrriteerd", "geklasseerd", "gekmakend", "gekuifd", "gekwalificeerd", "gelardeerd", "geldend", "geldverslindend", "geleed", "geleidend", "gelieerd", "geliefkoosd", "gelijkluidend", "gelinieerd", "geluiddempend", "geluidswerend", "geluidwerend", "gemarineerd", "gematteerd", "gemiddeld", "geoccupeerd", "geoutilleerd", "geparaffineerd", "geparfumeerd", "gepatenteerd", "gepermitteerd", "geplafonneerd", "geplisseerd", "gepredisponeerd", "geprefabriceerd", "gepreoccupeerd", "geproportioneerd", "geraffineerd", "gerandomiseerd", "gereformeerd", "gereglementeerd", "geresigneerd", "geresponsabiliseerd", "gerimpeld", "geringschattend", "geruchtmakend", "geruststellend", "gesatureerd", "gesauteerd", "geschakeerd", "gesepareerd", "geseponeerd", "gesofisticeerd", "gesoigneerd", "gespeend", "gespikkeld", "gestresseerd", "geurenblind", "gevergeerd", "geverseerd", "gezaghebbend", "gezagsondermijnend", "gezichtsbepalend", "gezinsvervangend", "gezwind", "geit", "gedragstherapeut", "geveltoerist", "gezant", "gerant", "gerst", "gerstenat", "geut", "gebarenkunst", "gebedsbijeenkomst", "gebekvecht", "gebiedsagent", "gebit", "geboorterecht", "gebruikersovereenkomst", "gebruiksrecht", "gebruiksvoorschrift", "gedragsvoorschrift", "geest", "geestdrift", "geesteskracht", "geestesproduct", "geestkracht", "gefluit", "gehandicaptensport", "geheimhoudingsplicht", "geheimschrift", "geheugenkunst", "gehoorapparaat", "geitenteelt", "gekloot", "geldautomaat", "geldingskracht", "geldingszucht", "geldkist", "geldmarkt", "geldmarkttekort", "geldpot", "geldsoort", "geldtekort", "geldtransport", "gelduitgifteautomaat", "geldzucht", "gelegenheidsargument", "geloofsgenoot", "geluidseffect", "geluidsoverlast", "geluidspoort", "gemaksproduct", "gemakzucht", "gemberpot", "gemeenschapsrecht", "gemeenteadvocaat", "gemeenteraadsbesluit", "gemeenterecht", "gemeentewet", "gemeentewiet", "gemoedsrust", "geneeskracht", "geneeskundestudent", "geneeskunst", "geneesmiddelenfabrikant", "geneesmiddelenmarkt", "generatieconflict", "generatiegenoot", "generatiepact", "generatiestudent", "genetkat", "genocidewet", "genot", "genotsproduct", "genotzucht", "gent", "geodeet", "geologiedocent", "gereedschapskist", "gerucht", "geruchtencircuit", "geschiedenisdocent", "geschiedenisstudent", "geschiet", "geschrift", "gespreksgenoot", "gesprekspunt", "getijdenkracht", "gevangenispoort", "gevecht", "gevechtskracht", "gevechtssport", "gevellijst", "gevelornament", "gewest", "gewetensangst", "gewetensconflict", "gewicht", "gewinzucht", "gewondentransport", "gewoonterecht", "gewricht", "gezagsapparaat", "gezinsbudget", "gezinsrapport", "gezondheidseffect", "gezondheidsklacht", "gezondheidsproduct", "gezondheidsrecht", "gezondheidswet", "gezondheidswinst", "gerokt", "gevlekt", "gebuikt", "gesaust", "gebiedsgericht", "geel-zwart", "gehandicapt", "gereformeerd-vrijgemaakt", "gestuikt", "geëtst", "bed", "bediendevakbond", "bedrijfsbeleid", "bedrijfsblad", "bedrijfspand", "bedrijfswereld", "bedrijvenbond", "beekdonderpad", "beeld", "beginselakkoord", "begintoestand", "begripsinhoud", "begrotingsakkoord", "begrotingsbeleid", "behandelaanbod", "beheerraad", "beheersgebied", "behoud", "beiaard", "bejaardenbeleid", "bekerwedstrijd", "belastinggebied", "belastinggeld", "belastingschuld", "beleggingsbeleid", "beleggingspand", "beleid", "beleidsdaad", "beleidsgebied", "belevingswereld", "belplafond", "beltegoed", "bemanningslid", "Bemiddelingsraad", "bendehoofd", "bendelid", "benedenstad", "benefietwedstrijd", "benoemingenbeleid", "benuttingsgraad", "berberpaard", "beregeningsverbod", "bergeend", "berggebied", "bergland", "bergpaard", "bergpad", "bergwand", "beroepsarbeid", "beroepsverbod", "beroepswereld", "beschermingsbeleid", "beschermingsgebied", "beslissingswedstrijd", "besparingsbeleid", "bestand", "bestandsakkoord", "besteleend", "besturenbond", "bestuursakkoord", "bestuursbeleid", "bestuurshoofd", "bestuurslid", "beukenblad", "beursmaand", "beursrecord", "beurswaakhond", "beurswereld", "beveiligingsbeleid", "bevolkingsbeleid", "bewind", "bewustzijnsinhoud", "bewustzijnstoestand", "bezuinigingsbeleid", "beenhard", "bebrild", "beangstigend", "bebaard", "bedeesd", "bederfwerend", "bedreigend", "bedrijvend", "bedroevend", "beduidend", "beduusd", "bedwelmend", "beeldbepalend", "beeldend", "beeldvormend", "beeldvullend", "begeleidend", "begerenswaard", "begrijpend", "behartenswaard", "behartigenswaard", "behoudend", "bejaard", "beklagenswaard", "beklemmend", "belanghebbend", "belangstellend", "belangwekkend", "belastingbesparend", "belastingbetalend", "beledigend", "beleerd", "beleidsadviserend", "belendend", "belerend", "bemoedigend", "benauwend", "benijdenswaard", "bepalend", "beperkend", "beregoed", "berekenend", "beroemd", "beroepsblind", "beschaamd", "beschamend", "beschouwend", "beschrijvend", "besdragend", "beslissend", "bestaand", "bestverkopend", "beteuterd", "betoverend", "betraand", "betreffend", "betreurenswaard", "bevelend", "bevelhebbend", "bevestigend", "bevoegd", "bevredigend", "bevreemdend", "bevriend", "bewonderenswaard", "bewustzijnsverruimend", "bezwarend", "beest", "berggeit", "betaalkracht", "beerput", "bergamot", "beschuit", "beademingsapparaat", "beddenfabrikant", "bedeltocht", "bedevaart", "bedevaartstocht", "bediendecontract", "bedieningsfout", "bedilzucht", "bedoeïenentent", "bedrijfsadvocaat", "bedrijfsfeest", "bedrijfsfysiotherapeut", "bedrijfsmanagement", "bedrijfsopbrengst", "bedrijfsrestaurant", "bedrijfsresultaat", "bedrijfssport", "bedrijfswinst", "bedrijvenmarkt", "bedrust", "beeldhouwkunst", "beeldmoment", "beeldrecht", "beeldsnijkunst", "beestenmarkt", "beet", "begeleidwonenproject", "beginnersfout", "beginpunt", "begrippenapparaat", "begrotingsdebat", "begrotingsrecht", "begrotingstekort", "behaagzucht", "behandelingsresultaat", "behoudzucht", "bejaardenpaspoort", "bekerplant", "bekerwinst", "beklagrecht", "beklemrecht", "belangenconflict", "belastingafdracht", "belastingbiljet", "belastingconsulent", "belastingdienst", "belastingexpert", "belastingopbrengst", "belastingplicht", "belastingrecht", "belastingspecialist", "belastingwet", "beleggersmarkt", "beleggingsexpert", "beleggingsmarkt", "beleggingsopbrengst", "beleggingsproduct", "beleggingsresultaat", "beleidsaspect", "beleidsdebat", "beleidsfout", "beleidsresultaat", "beleidsspecialist", "belevingsrestaurant", "belgicist", "belminuut", "beltegoedkaart", "bemoeizucht", "benefiet", "benefietconcert", "benoemingsbesluit", "benzinelucht", "benzinemarkt", "benzinetekort", "beoordelingsfout", "beoordelingsrapport", "berghut", "bergklimaat", "berglucht", "bergrit", "bergsport", "bergtijdrit", "bergtocht", "berichtendienst", "berkenhout", "bermmonument", "bermrecreant", "bermsloot", "bermtoerist", "beroepsdiplomaat", "beroepsernst", "beroepsfout", "beroepsgenoot", "beroepsjournalist", "beroepskracht", "beroepsrecht", "beroepssoldaat", "beroepssport", "berufsverbot", "beschermingsbesluit", "beschikkingsrecht", "beslismoment", "beslissingsrecht", "besluit", "bestaansrecht", "bestandsformaat", "bestelbiljet", "bestelkaart", "bestuursapparaat", "bestuursassistent", "bestuursbesluit", "bestuursconflict", "bestuurskracht", "bestuurskundedocent", "bestuursmandaat", "bestuursprocesrecht", "bestuursrecht", "betaalautomaat", "betaaldienst", "betaalkaart", "betaalopdracht", "betalingsbalanstekort", "betalingsopdracht", "bètastudent", "beterschapskaart", "betrouwbaarheidsrit", "beukenhout", "beursapparaat", "beursklimaat", "beurskrant", "beursmarkt", "beursstudent", "beurt", "beverrat", "bevoegdheidsconflict", "bevrijdingsconcert", "bevrijdingsfeest", "bewaarplicht", "bewegingsapparaat", "bewegingsdocent", "bewegingskunst", "bewijskracht", "bewijsrecht", "bewustwordingsproject", "bezemkast", "bezit", "bezitsrecht", "bezoekrecht", "bezuinigingsdrift", "bezuinigingsopdracht", "bezwaarschrift", "beroepsgericht", "bedompt", "bedrijfsgericht", "beginselvast", "beleidsgericht", "bewolkt", "bezweet", "verbeterblad", "verband", "verbeeldingswereld", "verbod", "verbodsbord", "verbond", "verdwaalarmband", "verdwijnwoord", "verenigingsblad", "verenigingslid", "verfhuid", "vergismoord", "vergunningenbeleid", "verhalenpad", "verhalenwedstrijd", "verkeersaanbod", "verkeersbeleid", "verkeersbord", "verkiezingsavond", "verkleinwoord", "verkoopbeleid", "verkoopverbod", "vernieuwingsbeleid", "verpleeghuisbed", "verraad", "verschijningsverbod", "verstand", "vertoningsverbod", "vertrekbeleid", "vervalmaand", "vervoerbeleid", "vervoersaanbod", "vervoersbeleid", "vervoersbond", "vervoersverbod", "vervolgingsbeleid", "verwijderingsbeleid", "verzamelbeleid", "verzekeringswereld", "verzetsdaad", "verzetsheld", "verzuimbeleid", "verdragend", "verkeersremmend", "verbazend", "verbazingwekkend", "verbijsterend", "verblindend", "verbluffend", "verbouwereerd", "verdaagd", "verdedigend", "verdovend", "vereend", "verfrissend", "vergelijkend", "verhalend", "verheffend", "verheugend", "verkikkerd", "verklarend", "verkwikkend", "verkwistend", "verlammend", "verlangend", "verliesgevend", "verlieslatend", "verlieslijdend", "verlokkend", "verlossend", "vermeend", "vermeldenswaard", "vermeldingswaard", "vermoeiend", "vermogend", "vernederend", "vernietigend", "verontrustend", "verpletterend", "verrassend", "verscheurend", "verschillend", "verslaafd", "verspringend", "verstikkend", "verstrekkend", "verstrooid", "vertederend", "vertrouwenwekkend", "vertwijfeld", "vervelend", "verwaand", "verwarrend", "verwoestend", "verzachtend", "verziend", "verzoenend", "verwant", "verantwoordingsplicht", "verbandkist", "verbeeldingskracht", "verbintenissenrecht", "verblijfsrecht", "verbrandingsproduct", "verbroederingsfeest", "verdedigingsfout", "verdragsrecht", "verdriet", "verdringingseffect", "veredelingsproduct", "verenigingsrecht", "verffabrikant", "verfpot", "verfrest", "vergiet", "vergoedingslimiet", "vergrotingsapparaat", "vergunningplicht", "verhaalsrecht", "verhuiskist", "verhuurboot", "verjaardagsfeest", "verjaardagsgast", "verjaardagstaart", "verjaarfeest", "verjaringsfeest", "verkeersagent", "verkeersinfarct", "verkeersmanagement", "verkeersmarkt", "verkeersoverlast", "verkeerswet", "verkenningstocht", "verkiezingsbijeenkomst", "verkiezingsbiljet", "verkiezingsdebat", "verkiezingsinkt", "verkiezingsresultaat", "verkiezingswinst", "verkleedkist", "verkoopapparaat", "verkoopargument", "verkoopopbrengst", "verkoopopdracht", "verkooprecht", "verkoopresultaat", "verkopersmarkt", "verlatingsangst", "verlovingsfeest", "verminderingskaart", "vermogensrecht", "vermogenstekort", "vermogenswinst", "vernielzucht", "vernietigingskracht", "vernieuwingsdebat", "vernieuwingsproject", "veroveringstocht", "veroveringszucht", "verpleegassistent", "verrassingseffect", "verrassingsfeest", "verrijkingsmarkt", "verruimingskandidaat", "verschoningsrecht", "verschot", "versproduct", "versterfrecht", "vertaalfout", "vertaalproject", "vertaalrecht", "vertebraat", "vertegenwoordigingsrecht", "vervangingsmarkt", "vervoersmanagement", "vervoersmarkt", "vervolgbijeenkomst", "vervolgingsapparaat", "vervolgopdracht", "vervolgproject", "vervreemdingseffect", "verwijt", "verzakingsrecht", "verzamelkrant", "verzekeringsagent", "verzekeringsmarkt", "verzekeringsproduct", "verzekeringsrecht", "verzekeringsresultaat", "verzetskrant", "verzoeningsbijeenkomst", "verzorgingsproduct", "slingerpad", "avondgebed", "bibbergeld", "dageraad", "drinkgeld", "kalfsgebraad", "leefgeld", "ochtendgebed", "ongelukskind", "vluggerd", "voltigeerpaard", "voltigepaard", "aandachtsgebied", "aanlijngebod", "aardbevingsgebied", "abonnementsgeld", "achtergrondgeluid", "achterstandsgebied", "actiegebied", "afzetgebied", "akkerbouwgebied", "alpengebied", "amazonegebied", "ambtsgebied", "ambtsgewaad", "antigeluid", "aspergebed", "autonomiegebied", "baggereiland", "bangerd", "bijgeluid", "bijstandsgeld", "binnenduingebied", "blindengeleidehond", "blowgebodsbord", "boezemgebied", "bongerd", "bosgebied", "bridgeavond", "bridgebond", "bridgewedstrijd", "broedgebied", "brongebied", "budgetbeleid", "burgerbewind", "centrumgebied", "collegelid", "computergebied", "concentratiegebied", "conceptregeerakkoord", "concessiegebied", "conflictgebied", "contactgeluid", "crisisgebied", "cultuurgebied", "dankgebed", "deelgebied", "deelnemingenbeleid", "deltagebied", "deskundigheidsgebied", "dierengeluid", "doelgebied", "doodsgewaad", "doorgangsgebied", "dopgeld", "douanegebied", "drempelgeld", "driekoningenavond", "duinengebied", "duingebied", "eigendomsvoorbehoud", "energiegebied", "engerd", "eurogebied", "feestgewaad", "filmgebied", "foerageergebied", "formuliergebed", "frequentiegebied", "frontgebied", "functioneringsgebied", "gangenpaard", "gitaargeluid", "gitaargeweld", "golfgebied", "golflengtegebied", "graangebied", "grachtengebied", "grensgebied", "groeigebied", "groengebied", "groepsgeluid", "groepsgeweld", "grondgebied", "grondwaterbeschermingsgebied", "haflingerpaard", "handelsgebied", "havengebied", "heidegebied", "helikoptergeld", "herkomstgebied", "herwaarderingsgebied", "hogedrukgebied", "hogeronderwijsbeleid", "hongersnood", "hoogveengebied", "ICT-gebied", "immigratiegebied", "inburgeringsbeleid", "indicatiegebied", "industriegebied", "ingeland", "inkomgeld", "interessegebied", "jachtgebied", "jagershond", "jongerenbeleid", "jongerenblad", "kantorengebied", "kassengebied", "keelgeluid", "kennisgebied", "kerngebied", "kernwinkelgebied", "kijkgeld", "kindergeld", "kleigebied", "kloostergewaad", "knipooggeweld", "kogelwond", "koorgebed", "krapgeldbeleid", "krijgsgeweld", "krimpgebied", "kruisgebed", "kunstgebied", "kustgebied", "kwelgebied", "lagedrukgebied", "landbouwgebied", "langeafstandspaard", "langebaanwedstrijd", "langetermijnbeleid", "leefgebied", "leergebied", "leerstofgebied", "legerpaard", "legervoorraad", "levensgebied", "lidgeld", "logeerbed", "luchtvaartgebied", "luistergeld", "machtsgebied", "managementbeleid", "mandaatgebied", "manegepaard", "marktgebied", "mededelingenblad", "mededelingenbord", "mediageweld", "merengebied", "middaggebed", "middengebied", "mijngebied", "milieubeschermingsgebied", "milieugebied", "misgewaad", "missiegebied", "modegebied", "moerasgebied", "morgengebed", "Morgenland", "morgenstond", "moslimgebied", "motorgeluid", "muilkorfgebod", "nachtgewaad", "nagelbed", "natuurbeschermingsgebied", "natuurgebied", "natuurgeweld", "natuurontwikkelingsgebied", "NAVO-gebied", "NAVO-grondgebied", "nederzettingenbeleid", "neerslaggebied", "negerkind", "no-gogebied", "noodgebied", "noordpoolgebied", "Noordzeegebied", "oceaangebied", "octrooigebied", "oefengebied", "oerwoudgeluid", "oliegebied", "omgevingsbeleid", "omgevingsgeluid", "onderwijsgebied", "onderzoeksgebied", "onrustgebied", "ontwikkelingsgebied", "oorlogsgebied", "oorlogsgeweld", "oorsprongsgebied", "operatiegebied", "opleidingenaanbod", "opmarsgebied", "overgangsgebied", "overlastgebied", "overstromingsgebied", "overwinteringsgebied", "paaigebied", "partnergeweld", "ploegenwedstrijd", "poldergebied", "politiegeweld", "potpoldergebied", "presentiegeld", "priestergewaad", "regeerakkoord", "regelafstand", "regenboogkind", "regenboogzebrapad", "regenwoud", "regeringsaanbod", "regeringsbeleid", "regeringsraad", "regeringsstad", "reizigersaanbod", "richtingenstrijd", "roggebrood", "rouwgewaad", "rugzakgeld", "rustgebied", "rustgeld", "sabotagedaad", "samenwerkingsgebied", "schandegeld", "Schengenakkoord", "schietgebed", "schoolgeld", "servicegeweld", "slangenhuid", "sleutelgeld", "slotgebed", "smeekgebed", "smeergeldstad", "spaargeld", "spanningsgebied", "spiegelbeeld", "spiegelwand", "sportgebied", "spraakgeluid", "stemgeluid", "stiltegebied", "stoelgeld", "stormgeweld", "straatgeluid", "straatgeweld", "strafschopgebied", "supportersgeweld", "taalgebied", "tegelpad", "tegelwand", "tegenbod", "tegengeluid", "tegengeweld", "tegenspoed", "tegenwind", "televisiegeweld", "tussengebied", "uitgaansgeweld", "uitgeefbeleid", "uitgeversverbond", "uitgeverswereld", "ultrageluid", "vaargebied", "vagebond", "vakantiegeld", "veertigurengebed", "vegetariërsbond", "vingerhoed", "vliegtuiggeluid", "vluchtelingenbeleid", "voetbalgeweld", "vogelgeluid", "vogelwereld", "volksgezondheidsbeleid", "voorzieningenaanbod", "vormgevingsbeleid", "vredesgeluid", "vreemdelingenbeleid", "vrijdaggebed", "vrijgezellenavond", "vrijwilligersbeleid", "vuurwapengeweld", "wapengeweld", "waterbergingsgebied", "watergebied", "watergeweld", "werkgelegenheidsbeleid", "werkgeversaanbod", "werkgeversbond", "werkgeversverbond", "wetgevingsbeleid", "wiegenkind", "wijngebied", "wintersportgebied", "wisselgeld", "woestijngebied", "zakgeld", "zangersbond", "zeegebied", "zeehavengebied", "ziektegeld", "zigeunerkind", "zigeunerpaard", "zondegeld", "zorgenkind", "zwangerschapsmaand", "zwijggeld", "agent", "afgezant", "dirigent", "echtgenoot", "morgendienst", "apologeet", "budgetsupermarkt", "burgerdienst", "changement", "dorpsgenoot", "huisgenoot", "krankzinnigengesticht", "muggenbeet", "nagerecht", "omgevingsportret", "politieagent", "tijgerkat", "tussengerecht", "vogelmijt", "voorgerecht", "wegenwacht", "wegenzout", "wijkagent", "wisselagent", "zeegezicht", "zorgbudget", "aankoopbudget", "aardappelgerecht", "accountmanagement", "achterhoedegevecht", "adoptieagent", "advertentiebudget", "afspiegelingskabinet", "agendahedonist", "algemenebijstandswet", "amandelgeest", "ambtenarengerecht", "apengezicht", "arbeidsgerecht", "aspergerobot", "aspergeteelt", "assetmanagement", "baggerboot", "baggermarkt", "baggeropdracht", "baggerproject", "baggerschuit", "baggervloot", "balkanvergeet-mij-niet", "barricadegevecht", "bijgerecht", "boemerangeffect", "bouwmanagement", "bovengebit", "branchegenoot", "bridgejournalist", "bridgesport", "budget", "budgetrecht", "budgettekort", "bugnugget", "burgemeestersambt", "burgemeesterspost", "burgerdocent", "burgerplicht", "burgerpot", "burgerpresident", "burgerrecht", "burgerschapsrecht", "buurtagent", "buurtgenoot", "capaciteitsmanagement", "casemanagement", "celgenoot", "chef-dirigent", "CIA-agent", "clubgenoot", "coalitiegenoot", "collectiemanagement", "collegebesluit", "collegekaart", "collegestudent", "competentiemanagement", "crisismanagement", "defensiebudget", "depannagedienst", "deskundigenrapport", "disgenoot", "dopingexpert", "draagvleugelboot", "dreigement", "driekoningenfeest", "dubbelagent", "dwerggeit", "eerstgeboorterecht", "eigendomsrecht", "elftalgenoot", "enkelgewricht", "etalageruit", "ex-agent", "ex-echtgenoot", "exploitatiebudget", "FBI-agent", "fractiegenoot", "gadget", "garagepoort", "glogetuigschrift", "groentegerecht", "groentenugget", "grondgevecht", "halfgeleiderfabrikant", "halsgerecht", "halsgewricht", "hamburgerrestaurant", "hamburgertent", "handelsagent", "handgewricht", "hanengevecht", "hengelsport", "hersengadget", "heupgewricht", "hogeschooldocent", "hogeschoolstudent", "hokjesgeest", "hondengevecht", "hoofdagent", "hoofdgerecht", "horlogekast", "hotelmanagement", "huishoudbudget", "hulpagent", "huwelijksvermogensrecht", "inburgeringsplicht", "inburgeringstraject", "informatiemanagement", "ingenieursdienst", "ingenieursstudent", "inlichtingenrapport", "interim-management", "internetevangelist", "investeringsbudget", "inzagerecht", "jaarbudget", "jongerenkrant", "jongerenpaspoort", "kaakgewricht", "kaasgerecht", "kaasnugget", "kalfsgehakt", "kamergenoot", "kant-en-klaargerecht", "kantongerecht", "kennismanagement", "kipnugget", "klasgenoot", "kniegewricht", "kogelgewricht", "kooigevecht", "kredietmanagement", "kroegentocht", "kruidnagelsigaret", "kunstbudget", "kunstgeschiedenisdocent", "kunstgeschiedenisstudent", "kunstmanagement", "kussengevecht", "kwaliteitsmanagement", "kwelgeest", "lamsgehakt", "langetermijneffect", "leeftijdgenoot", "leeftijdsgenoot", "legercommandant", "legerdienst", "legerkrant", "legerpredikant", "legertent", "lievelingsgerecht", "logeergast", "lotgenotencontact", "loungerestaurant", "low budget", "lozingenbesluit", "luchtagent", "luchtgevecht", "lunchgerecht", "macrobudget", "management", "managementfout", "melkgeit", "mens-erger-je-niet", "mergelgrot", "milieumanagement", "miljoenenbudget", "mobiliteitsbudget", "moddergevecht", "monumentenbudget", "morgenlicht", "morgenpost", "motoragent", "muggenbult", "narcotica-agent", "NAVO-bondgenoot", "negerhut", "nepagent", "nugget", "ondergebit", "onderwijsbudget", "onderwijsmanagement", "onderzoeksbudget", "onderzoeksgerecht", "on-en-minvermogenkaart", "ongevallenwet", "onteigeningswet", "orgelconcert", "orgeldocent", "orgelkast", "overheidsbudget", "overheidsmanagement", "overnamegevecht", "overnemingsgevecht", "paardengebit", "passagebiljet", "pastagerecht", "persagent", "personeelsbudget", "personeelsmanagement", "plaggenhut", "ploegentijdrit", "pluimgewicht", "politiebudget", "polsgewricht", "postzegelformaat", "prestigeproject", "prins-regent", "procesmanagement", "productiebudget", "projectmanagement", "pseudovogelpest", "publiciteitsagent", "raffinageproduct", "reclamebudget", "reegeit", "regeerambt", "regelzucht", "regenboogtricot", "regenput", "regent", "regentaat", "regenwaterput", "regeringsapparaat", "regeringsbesluit", "regeringsbudget", "regeringskrant", "regeringsrapport", "regeringssoldaat", "reisagent", "reisbudget", "restauratiebudget", "rijksbudget", "rijstgerecht", "risicomanagement", "röntgenapparaat", "ruggenmergsvocht", "rundergehakt", "scharniergewricht", "scheidsgerecht", "schijngevecht", "schimmengevecht", "schoolagent", "schoolbegeleidingsdienst", "schoolgenoot", "schoolwijkagent", "schoudergewricht", "sergeant", "slangenbeet", "slangenhout", "slingerplant", "slowfoodgerecht", "soortgenoot", "spiegelgevecht", "spiegelkast", "spiegelruit", "spiegelschrift", "spiegeltent", "spinazienugget", "sportmanagement", "spronggewricht", "stagedocent", "stageopdracht", "stagerapport", "stierengevecht", "straatgevecht", "streekgerecht", "stressmanagement", "studentenbudget", "subsidiebudget", "taalgenoot", "tafelgenoot", "tafelgenot", "teamgeest", "tegenargument", "tegeneffect", "tegenkracht", "tentoonstellingsbudget", "tijdgeest", "tijdgenoot", "tijdmanagement", "tijdsgewricht", "tijgerpunt", "timemanagement", "titanengevecht", "titelgevecht", "topdirigent", "topmanagement", "totaalbudget", "totaalgewicht", "tweegevecht", "tweevingertest", "twintigeurobiljet", "undercoveragent", "urgentierecht", "veiligheidsagent", "veiligheidsarrangement", "veiligheidsmanagement", "vijftigeurobiljet", "vingerplant", "visgerecht", "visnugget", "vleesgerecht", "vleugelboot", "vliegenkast", "vliegerfeest", "vluchtelingenrecht", "vluchtelingentransport", "VN-gezant", "vogelmarkt", "vogeltjesmarkt", "vogelvangst", "vogelvlucht", "volksgericht", "voorlichtingsbudget", "vrachtwagenfabrikant", "vrachtwagenmarkt", "vragersmarkt", "vredegerecht", "vreemdelingenangst", "vreemdelingenbesluit", "vreemdelingendebat", "vreemdelingenrecht", "vreemdelingenstemrecht", "vuistgevecht", "vuurgevecht", "watergeest", "watergevecht", "watermanagement", "wegenbouwproject", "wereldtitelgevecht", "werkgelegenheidseffect", "werkgelegenheidsproject", "werkingsbudget", "wervelgewricht", "wetenschapsbudget", "wetgevingsproject", "wintergerst", "wintergezicht", "wrevelagent", "zadelgewricht", "zagevent", "zanger-componist", "zanger-gitarist", "zangerscast", "zangvogelsport", "zeegevecht", "zegelrecht", "zegetocht", "zelfmanagement", "ziekenhuisbudget", "zwangerschapstest", "goedgevuld", "aangebrand", "welgevuld", "afgeborsteld", "donkergekleurd", "goedgevormd", "welgevormd", "allesverzengend", "bontgekleurd", "doorgewinterd", "goedgehumeurd", "goedgeluimd", "goedgezind", "haatdragend", "kegeldragend", "lichtgekleurd", "nagelbijtend", "ongekleurd", "ongemanierd", "ongeverfd", "rentedragend", "risicodragend", "roodgekleurd", "slechtgehumeurd", "slechtgezind", "vruchtdragend", "welgemanierd", "welgezind", "welopgevoed", "woldragend", "zaaddragend", "zorgdragend", "aanbodgestuurd", "aangehuwd", "aangetekend", "aangetrouwd", "aanliggend", "aanmatigend", "aanvoegend", "achtereenvolgend", "achterliggend", "afgewend", "allesdoordringend", "allesvernietigend", "alleszeggend", "almogend", "alvermogend", "angstaanjagend", "bijstandsgerechtigd", "bloeddrukverhogend", "bloeddrukverlagend", "bloemdragend", "braakliggend", "brandvertragend", "breedgerand", "brildragend", "cholesterolverlagend", "christelijk-gereformeerd", "computergestuurd", "diepliggend", "doodgemoedereerd", "doordringend", "doorslaggevend", "dreigend", "drempelverlagend", "dringend", "dwingend", "eerstvolgend", "eierleggend", "Engelssprekend", "ergerniswekkend", "felgekleurd", "godtergend", "goedgekleed", "goedgemanierd", "goudgerand", "grensverleggend", "handenwringend", "hemeltergend", "hiernavolgend", "hogergenoemd", "hoogdringend", "hoopgevend", "indringend", "ingebeeld", "ingekankerd", "ingekeerd", "ingenaaid", "ingewikkeld", "ingeworteld", "intrigerend", "knoldragend", "kogelwerend", "laaggeletterd", "leidinggevend", "levensbedreigend", "levensbeëindigend", "levensverlengend", "lichtgevend", "lichtgewond", "liggend", "losliggend", "maatgevend", "meedogend", "minvermogend", "moedgevend", "naastliggend", "navolgend", "neerbuigend", "niet-geleidend", "nietszeggend", "normgevend", "oergezond", "omliggend", "onaangediend", "onbevredigend", "ondergewaardeerd", "onderliggend", "ondeugend", "ongeaccepteerd", "ongeanimeerd", "ongearticuleerd", "ongeautoriseerd", "ongecensureerd", "ongeciviliseerd", "ongeclausuleerd", "ongecompliceerd", "ongeconcentreerd", "ongeconditioneerd", "ongecontroleerd", "ongecoördineerd", "ongecorrigeerd", "ongecultiveerd", "ongedateerd", "ongedefinieerd", "ongedifferentieerd", "ongediplomeerd", "ongedisciplineerd", "ongedoubleerd", "ongeëmancipeerd", "ongeëmotioneerd", "ongeforceerd", "ongefrankeerd", "ongefundeerd", "ongegeneerd", "ongehavend", "ongehonoreerd", "ongeïdentificeerd", "ongeïnformeerd", "ongeïnspireerd", "ongeïnteresseerd", "ongekend", "ongekwalificeerd", "ongeleerd", "ongelimiteerd", "ongelinieerd", "ongematteerd", "ongemeend", "ongemeubileerd", "ongemonteerd", "ongemotiveerd", "ongemotoriseerd", "ongenuanceerd", "ongeoefend", "ongeopend", "ongeordend", "ongeorganiseerd", "ongepaneerd", "ongepermitteerd", "ongeprepareerd", "ongepubliceerd", "ongeraffineerd", "ongerealiseerd", "ongeregistreerd", "ongereglementeerd", "ongereguleerd", "ongesigneerd", "ongespecificeerd", "ongestoffeerd", "ongestructureerd", "ongestudeerd", "ongesubsidieerd", "ongevaccineerd", "ongewapend", "onsamenhangend", "onuitgenodigd", "onuitgevoerd", "onvermogend", "onwelgezind", "opeenvolgend", "opvliegend", "opvolgend", "orthodox-gereformeerd", "overtuigend", "overwegend", "overweldigend", "plaatsvervangend", "prangend", "raadgevend", "redengevend", "rentegevend", "rolbevestigend", "roodgeverfd", "rustgevend", "samenhangend", "schermdragend", "schrikaanjagend", "slechtgekleed", "sneldrogend", "statusverhogend", "stilzwijgend", "supergezond", "tegemoetkomend", "tergend", "toegevend", "toonaangevend", "tussenliggend", "uitdagend", "uitgekiend", "uitgeregend", "uitgerekend", "uitnodigend", "vakoverstijgend", "veelzeggend", "vigerend", "vleesvervangend", "vliegend", "volgend", "voorbijgestreefd", "vraaggestuurd", "vreesaanjagend", "Wajonggerechtigd", "waterbergend", "watergekoeld", "welgekend", "welgemeend", "werkgelegenheidsbevorderend", "wetgevend", "winstgevend", "witgehandschoend", "witgepleisterd", "witgeschilderd", "witgeverfd", "zelfcorrigerend", "zelfdragend", "zelfreinigend", "zelfvernietigend", "zelfverzorgend", "zieltogend", "zingevend", "zoetgeurend", "zogenaamd", "zogenoemd", "zwaargehavend", "zwaargewapend", "zwaargewond", "zwaarwegend", "zwartgeverfd", "zwijgend", "doelgericht", "ontwikkelingsgericht", "zwartgerokt", "arbeidsmarktgericht", "functiegericht", "goedgemutst", "kindgericht", "aanbodgericht", "aangedampt", "actiegericht", "arbeidsongeschikt", "brongericht", "buurtgericht", "cliëntgericht", "competentiegericht", "consumentgericht", "divergent", "doelgroepgericht", "doodongerust", "effectgericht", "ervaringsgericht", "exportgericht", "groepsgericht", "ingemaakt", "ingeroest", "innovatiegericht", "intelligent", "klantgericht", "kortgerokt", "maatschappijgericht", "marktgericht", "mensgericht", "nagelvast", "natuurgericht", "niet-gericht", "ongekuist", "ongericht", "onuitgebracht", "onuitgepakt", "onuitgewerkt", "oplossingsgericht", "persoonsgericht", "praktijkgericht", "prestatiegericht", "probleemgericht", "procesgericht", "productgericht", "publieksgericht", "resultaatgericht", "roodgelakt", "taakgericht", "themagericht", "toekomstgericht", "toepassingsgericht", "vakgericht", "voortgezet", "vraaggericht", "wijkgericht", "witgekalkt", "witgelakt", "zelfgemaakt", "zwartgelakt", "morgennacht", "negenduizend", "negenentwintigduizend", "negenhonderd", "negenhonderdduizend", "negentienduizend", "negentienhonderd", "negentigduizend", "morgenochtend", "desgevallend", "morgenavond", "zogezegd", "nergensland", "ontbijtbord", "onthaalbeleid", "onthaalkind", "ontmoedigingsbeleid", "ontmoetingsavond", "ontwapeningsakkoord", "ontwerpakkoord", "ontwerplandbouwakkoord", "ontwerpwedstrijd", "ontwikkelingsbeleid", "ontwikkelingshulpbeleid", "ontwikkelingsland", "ontbeend", "ontbrekend", "onthullend", "onthutsend", "ontkennend", "ontluisterend", "ontoereikend", "ontslagnemend", "ontsmettend", "ontspannend", "ontstekingsremmend", "ontstellend", "ontwapenend", "ontwijkend", "ontwikkeld", "ontzagwekkend", "ontzettend", "ontbijt", "onthardingszout", "ontzet", "ontbijtbuffet", "ontbindingsrecht", "ontdekkingstocht", "onterecht", "ontkoppelingsbesluit", "ontmijningsdienst", "ontslagbesluit", "ontslagdecreet", "ontslagrecht", "ontvangst", "ontwerpbesluit", "ontwerpfout", "ontwerpgrondwet", "ontwerpopdracht", "ontwerprapport", "ontwerpwet", "ontwikkelingspot", "ontwikkelingsproject", "herdershond", "herenakkoord", "herenblad", "herfstavond", "herfstblad", "herfstdraad", "herfstmaand", "herfstochtend", "herfstwind", "herkeuringsraad", "heroïnehond", "herseninhoud", "herstelbeleid", "hervormingsbeleid", "herfst", "hermafrodiet", "hert", "heraut", "herfstlucht", "heraanplant", "herdenkingsbijeenkomst", "herdenkingsconcert", "herdenkingsfeest", "heremietkreeft", "herfstnacht", "herfsttint", "herinneringskunst", "herkomst", "heroïnespuit", "heroïnetransport", "heroïnevangst", "herroepingsrecht", "hersenkracht", "hersenvlucht", "hersenvocht", "hersteldienst", "herstelrecht", "hervormingsproject", "erwt", "ernst", "erbovenuit", "ereambt", "eregast", "erepunt", "erfenisrecht", "erfrecht", "ergotherapeut", "ernaast", "eronderuit", "eropuit", "ertussenuit", "eruit", "ervanuit", "erytrocyt", "eredivisiewedstrijd", "erelid", "erfgoedbeleid", "erkenningsbeleid", "errond", "ervaringswereld", "gebaart", "gebeurt", "gebiedt", "gebood", "gedenkt", "gedraagt", "geeuwt", "gehoorzamt", "geilt", "geldt", "geelt", "gelooft", "geneest", "geniet", "genoot", "gerust", "geurt", "geeft", "besnuffelt", "bedeelt", "bedelt", "bekeert", "beugelt", "beamt", "beantwoordt", "beargumenteert", "beatblogt", "becijfert", "becommentariërt", "beconcurreert", "bedaart", "bedelft", "bedenkt", "bederft", "bedient", "bediscussiërt", "bedoelt", "bedraagt", "bedreigt", "bedriegt", "bedrijft", "bedroeft", "bedwingt", "beëindigt", "beeldbelt", "beetneemt", "beft", "begaat", "begeleidt", "begeert", "begeeft", "begint", "begraaft", "begrijpt", "begroeit", "behaalt", "behandelt", "behangt", "beheert", "behoedt", "behoeft", "behoort", "behoudt", "beïnvloedt", "bekent", "bekeurt", "bekijkt", "beklaagt", "bekleedt", "beklemt", "beklimt", "bekomt", "bekritiseert", "bekroont", "belandt", "beledigt", "belegt", "belemmert", "beleeft", "belt", "beloont", "belooft", "belparkeert", "beluistert", "bemeesteert", "bemeubelt", "bemoedigt", "bemoeit", "benadert", "benauwt", "beneemt", "bengelt", "benieuwt", "benoemt", "beogt", "beoordeelt", "bepaalt", "bepoteelt", "bereidt", "berekent", "berooft", "beschaamt", "beschaaft", "beschermt", "beschildert", "beschouwt", "beschrijft", "beschuldigt", "beslaat", "besloot", "besnijdt", "bespaart", "bespeurt", "bespioneert", "bespreekt", "bespringt", "bestaat", "bestempelt", "bestrijdt", "bestreed", "bestudeert", "bestuurt", "beswaffeelt", "betekent", "betert", "betont", "betonneert", "betovert", "betreedt", "betreft", "betrekt", "betreurt", "betwijfelt", "beult", "bevalt", "beeft", "bevindt", "bevoordeliigt", "bevordert", "bevraagt", "bevriest", "bewapent", "beweert", "bewijst", "bewondert", "bewoont", "bewonersparkeert", "bezaait", "bezeert", "beziet", "bezat", "bezoekt", "bezorgt", "bezuinigt", "bezweert", "verlaat", "verliet", "verschaalt", "verspringt", "vertelt", "veraangenaamt", "verabsoluteert", "verachtvoudiigt", "veradeemt", "verafgoodt", "verafschuwt", "veralgemeent", "verandert", "verankert", "verantwoordt", "verarmt", "verbabbelt", "verbaliseert", "verbant", "verbaast", "verbeeldt", "verbeidt", "verbergt", "verbetert", "verbeuzelt", "verbiedt", "verbood", "verbijstert", "verbindt", "verblijft", "verblindt", "verbouwt", "verbrandt", "verbreekt", "verdappert", "verdedigt", "verdeelt", "verdenkt", "verdient", "verdort", "verdooft", "verdraait", "verdraagt", "verdrijft", "verdringt", "verdrinkt", "verdroogt", "verdubbelt", "verdwaalt", "verdwijnt", "vereenvoudigt", "vet", "verenigt", "vereert", "vergaat", "vergadeert", "vergelijkt", "vergt", "vergeet", "vergat", "vergeeft", "vergiftigt", "vergoedt", "vergrendelt", "verhaalt", "verhangt", "verheldert", "verheugt", "verhindert", "verhoogt", "verhongert", "verhoudt", "verhuist", "verhuurt", "verifiërt", "verjaagt", "verkent", "verkeert", "verkiest", "verklaart", "verkleedt", "verkleint", "verkleurt", "verknoeit", "verkoopt", "verkreukelt", "verkrijgt", "verlaagt", "verlamt", "verlangt", "verleidt", "verleent", "verlengt", "verliest", "verloocheent", "verloopt", "verlooft", "verluiert", "verlummelt", "vermagert", "vermaalt", "vermangelt", "vermeldt", "vermengt", "vermenigvuldigt", "vermijdt", "vermindert", "vermoedt", "vermoeit", "vermolmt", "vermomt", "vermoordt", "vernauwt", "verneemt", "vernevelt", "vernielt", "vernietigt", "vernieuwt", "vernikkelt", "vernoemt", "vernummert", "veronaangenaamt", "veronachtzaamt", "veronderstelt", "verontheiliigt", "verontreinigt", "verontschuldigt", "veroordeelt", "veroorlooft", "verootmoediigt", "veropenbaart", "verordonneert", "verovert", "verpandt", "verpaupert", "verpietert", "verplegt", "verplettert", "verpulvert", "verraadt", "verried", "verrechtvaardiigt", "verregeent", "verreist", "verrekeent", "verrijdt", "verrijst", "verroert", "verrolt", "verronselt", "verruigt", "verruilt", "verruuwt", "verscheurt", "verschijnt", "verschilt", "verschimmelt", "verschoont", "verschraalt", "verschrijft", "verschroeit", "verschrompelt", "verschuilt", "versiert", "versimpelt", "versjachert", "versjouwt", "verslaat", "verslechtert", "versleutelt", "verslijt", "versleet", "verslindt", "verslond", "versluiert", "versluist", "versmaadt", "versmalt", "versmoort", "versnelt", "versnijdt", "versnippert", "versobert", "versoepelt", "versombert", "verspeelt", "verspeent", "verspert", "verspiedt", "verspilt", "verspint", "versplintert", "verspreidt", "verstaat", "verstond", "verstaalt", "verstart", "verstelt", "versteent", "versterft", "versteviigt", "verstijft", "verstilt", "verstomt", "verstoort", "verstoot", "verstiet", "verstouwt", "verstramt", "verstrengt", "verstrijkt", "verstrooit", "verstuift", "verstuurt", "verstuuwt", "versuikert", "versukkelt", "vertaalt", "vertedert", "vertegenwoordigt", "vertekeent", "verteert", "vertienvoudiigt", "vertilt", "vertimmert", "vertint", "vertoeft", "vertoont", "vertoornt", "vertraagt", "vertreedt", "vertroebelt", "vertroetelt", "vertrouwt", "vertwijfelt", "vervaagt", "vervaalt", "vervalt", "vervangt", "vervelt", "verft", "verveent", "verviervoudiigt", "vervijfvoudiigt", "vervliegt", "vervloeit", "vervluchtiigt", "vervoedeert", "vervoegt", "vervoert", "vervolgt", "vervollediigt", "vervordert", "vervormt", "vervreemdt", "vervroegt", "vervuilt", "vervult", "verwaait", "verwaardiigt", "verwaarloost", "verwarmt", "verwart", "verwaseemt", "verwatert", "verwedt", "verwelkoomt", "verweert", "verwerpt", "verwerft", "verweeft", "verwijdt", "verwijdert", "verwijlt", "verwijft", "verwikkelt", "verwildert", "verwint", "verwintert", "verwisselt", "verwittiigt", "verwondt", "verwondert", "verwoont", "verwoordt", "verwringt", "verwurgt", "verzaagt", "verzandt", "verzegelt", "verzegt", "verzeilt", "verzekert", "verzelfstandiigt", "verzendt", "verzengt", "verzesvoudiigt", "verzilvert", "verzinnebeeldt", "verzint", "verzoekt", "verzoent", "verzoolt", "verzuilt", "verzuurt", "verzusteert", "verzwagert", "verzwaart", "verzwelgt", "verzwendelt", "verzweert", "verzwijgt", "ontbiedt", "ontbood", "ontbeet", "ontbindt", "ontbolstert", "ontbraamt", "ontbreekt", "ontcijfert", "ontdoet", "ontdeed", "ontdooit", "ontdubbelt", "onteert", "onterft", "ontgaat", "ontgeldt", "ontglijdt", "ontgloeit", "ontgraaft", "ontgrendelt", "ontgroeit", "ontgroent", "onthaalt", "onthalst", "onthardt", "onthaart", "ontheft", "ontheiligt", "onthoofdt", "onthoudt", "onthield", "onthult", "ontkent", "ontketeent", "ontkiemt", "ontkleurt", "ontkoomt", "ontkoppelt", "ontlaadt", "ontleent", "ontleert", "ontloopt", "ontluist", "ontmengt", "ontmijnt", "ontmoedigt", "ontmythologiseert", "ontneemt", "ontradicaliseert", "ontroert", "ontrommeelt", "ontruimt", "ontslaat", "ontspant", "ontspult", "ontstaat", "ontstond", "ontsteekt", "ontvangt", "ontvoert", "ontvolgt", "ontvoogdt", "ontvriendt", "ontvriest", "ontwerpt", "ontwijkt", "ontwikkelt", "ontzwavelt", "herdenkt", "herdacht", "ergert", "ekent", "eruitzit", "ervaart", "erft"];
};

Object.defineProperty(detectAndStemRegularParticiple$1, "__esModule", {
	value: true
});
detectAndStemRegularParticiple$1.detectAndStemRegularParticiple = detectAndStemRegularParticiple;

var _nonParticiples$1 = nonParticiples;

var _nonParticiples2$1 = _interopRequireDefault$2C(_nonParticiples$1);

var _regexHelpers$2 = regexHelpers;

var _stemModificationHelpers$1 = stemModificationHelpers;

function _interopRequireDefault$2C(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks whether the word is on an exception list of participles that do not have a ge- prefix. If it is found on the list,
 * remove only the last letter (the suffix).
 *
 * @param {array} dataExceptionListToCheck The list of the exception words.
 * @param {string} word 	The (unstemmed) word to check.
 *
 * @returns {null|string} The stemmed word or null if the word was not found on the exception list.
 */
const checkAndStemIfExceptionWithoutGePrefix = function checkAndStemIfExceptionWithoutGePrefix(dataExceptionListToCheck, word) {
	if (dataExceptionListToCheck.includes(word)) {
		return word.slice(0, -1);
	}
	return null;
};

/**
 * Checks whether a word that was detected as a participle should not have the suffix (-t or -d) removed because it is part
 * of the stem. For example, in the participle 'geantwoord', the -d belongs to the stem so it should not be removed.
 * The checks are conducted on the word without the prefix, so 'antwoord' in the case of 'geantwoord'.
 *
 * For words ending in -t, there are three checks:
 * 1) An exception list (exceptions to a rule) containing words where -t SHOULD be stemmed,
 * 2) The rule, defined using a regex with word endings where -t is part of the stem,
 * 3) A list of verbs with stem ending in -t, to cover cases that were not possible to find using a regex.
 *
 * For words ending in -d, we check a list of verbs with stem ending in -d.
 *
 * @param {string}	wordWithoutPrefix	The word without prefix(es).
 * @param {Object}	morphologyDataNL	The Dutch morphology data.
 * @returns {boolean}					Whether the suffix should be stemmed.
 */
const shouldSuffixBeStemmed = function shouldSuffixBeStemmed(wordWithoutPrefix, morphologyDataNL) {
	if (wordWithoutPrefix.endsWith("t")) {
		// Return true (suffix should be stemmed) if word was found on the exception list of verbs which should have the final -t stemmed.
		const exceptionsTShouldBeStemmed = morphologyDataNL.ambiguousTAndDEndings.wordsTShouldBeStemmed;
		if (exceptionsTShouldBeStemmed.includes(wordWithoutPrefix)) {
			return true;
		}
		// Return false (suffix should not be stemmed) if word matches the regex for stems ending in -t.
		if ((0, _regexHelpers$2.doesWordMatchRegex)(wordWithoutPrefix, morphologyDataNL.ambiguousTAndDEndings.tOrDArePartOfStem.tEnding)) {
			return false;
		}
		/*
   * Return false (suffix should not be stemmed) if the word was found on the list of verbs with stem ending in -t (e.g. haast)
   * Otherwise, return true (if no checks are matched, the default condition is for -t to be stemmed).
   */
		const exceptionsTShouldNotBeStemmed = morphologyDataNL.stemExceptions.wordsNotToBeStemmedExceptions.verbs;
		return !exceptionsTShouldNotBeStemmed.includes(wordWithoutPrefix);
	}
	if (wordWithoutPrefix.endsWith("d")) {
		const exceptionsDShouldNotBeStemmed = morphologyDataNL.pastParticipleStemmer.doNotStemD;
		return !exceptionsDShouldNotBeStemmed.includes(wordWithoutPrefix);
	}
};

/**
 * Detects whether a word is a participle of a regular verb without prefixes other than ge-. If it is, checks whether
 * the word is an exception that should not have the prefix or the suffix stemmed. Then stems the word accordingly
 * (remove prefix, suffix, or both).
 *
 * @param {Object}  morphologyDataNL	The Dutch morphology data.
 * @param {string}  word                The word (not stemmed) to check.
 *
 * @returns {string|null} The stem or null if no participle was matched.
 */
const detectAndStemParticiplesWithoutPrefixes = function detectAndStemParticiplesWithoutPrefixes(morphologyDataNL, word) {
	const geStemTParticipleRegex = new RegExp("^" + morphologyDataNL.pastParticipleStemmer.participleStemmingClasses[0].regex);

	// Check if it's a ge + stem + t/d participle.
	if (geStemTParticipleRegex.test(word)) {
		// Check if the ge- is actually part of the stem. If yes, stem only the suffix.
		const exception = checkAndStemIfExceptionWithoutGePrefix(morphologyDataNL.pastParticipleStemmer.doNotStemGe, word);
		if (exception) {
			return exception;
		}

		// Remove the prefix.
		let wordWithoutPrefix = word.slice(2);

		// Check if stem starts with ë. If yes, replace ë with e.
		if (wordWithoutPrefix.startsWith("ë")) {
			wordWithoutPrefix = "e" + wordWithoutPrefix.slice(1);
		}
		// Check whether the suffix should be stemmed. If yes, remove it and return the stem.
		if (shouldSuffixBeStemmed(wordWithoutPrefix, morphologyDataNL)) {
			return wordWithoutPrefix.slice(0, -1);
		}

		return wordWithoutPrefix;
	}

	return null;
};

/**
 * Determines whether a given participle pattern combined with prefixes from a given class (separable or inseparable)
 * applies to a given word and if so, returns the stem.
 *
 * @param {Object}      morphologyDataNL 	The Dutch morphology data.
 * @param {string}      word        		The word (not stemmed) to check.
 * @param {boolean}     separable  			Whether the prefix is separable or not.
 * @param {string[]}    prefixes    		The prefixes of a certain prefix class.
 * @param {string}      regexPart   		The regex part for a given class (completed to a full regex within the function).
 *
 * @returns {string|null} The stem or null if no prefixed participle was matched.
 */
const detectAndStemParticiplePerPrefixClass = function detectAndStemParticiplePerPrefixClass(morphologyDataNL, word, separable, prefixes, regexPart) {
	for (const currentPrefix of prefixes) {
		const participleRegex = new RegExp("^" + currentPrefix + regexPart);

		if (participleRegex.test(word)) {
			let wordWithoutPrefix = word.slice(currentPrefix.length - word.length);
			/*
    * After removing a separable prefix, check whether the ge- belongs to the stem (e.g. the -ge- in opgebruikt).
    * If it does, stem only the suffix.
    */
			if (separable) {
				const exception = checkAndStemIfExceptionWithoutGePrefix(morphologyDataNL.pastParticipleStemmer.doNotStemGe, wordWithoutPrefix);
				if (exception) {
					return currentPrefix + exception;
				}
				wordWithoutPrefix = wordWithoutPrefix.slice(2);
			}
			// Check whether stem starts with ë. If yes, replace ë with e.
			if (wordWithoutPrefix.startsWith("ë")) {
				wordWithoutPrefix = "e" + wordWithoutPrefix.slice(1);
			}

			if (shouldSuffixBeStemmed(wordWithoutPrefix, morphologyDataNL)) {
				return currentPrefix + wordWithoutPrefix.slice(0, -1);
			}
			return currentPrefix + wordWithoutPrefix;
		}
	}

	return null;
};

/**
 * Detects whether a word is a regular participle of a compound verb. A compound verb has a prefix in addition to, or instead of, ge-.
 * For example, afgemaakt has the separable prefix af-, and beantwoord has the inseparable prefix be-. If a participle
 * of a compound verb is detected, it is stemmed by removing the ge- (in case of a verb with a separable prefix) and the suffix -t or -d.
 *
 * @param {Object}  morphologyDataNL 	The Dutch morphology data.
 * @param {string}  word                The word (not stemmed) to check.
 *
 * @returns {string|null} The stem or null if no participle with prefix was matched.
 */
const detectAndStemParticiplesWithPrefixes = function detectAndStemParticiplesWithPrefixes(morphologyDataNL, word) {
	/*
  * It's important to preserve order here, since the ge + stem ending in -t regex is more specific than
  * the stem + t regex, and therefore must be checked first.
  */
	for (const participleClass of morphologyDataNL.pastParticipleStemmer.participleStemmingClasses) {
		const regex = participleClass.regex;
		const separable = participleClass.separable;

		const prefixes = separable ? morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes.separable : morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes.inseparable;

		const stem = detectAndStemParticiplePerPrefixClass(morphologyDataNL, word, separable, prefixes, regex);

		if (stem) {
			return stem;
		}
	}

	return null;
};

/**
 *  Checks whether the word is on the list of participles that do not need to be stemmed, because the participle form
 *  is the same as the stem.
 *
 * @param {string[]} dataParticiplesSameAsStem	The list of exceptions whose stem is the same as the participle.
 * @param {string} 	 word						The word to check.
 * @returns {boolean} Whether the word is found on the exception list.
 */
const checkIfParticipleIsSameAsStem = function checkIfParticipleIsSameAsStem(dataParticiplesSameAsStem, word) {
	return dataParticiplesSameAsStem.includes(word);
};

/**
 * Check whether the word is on an exception list of past participles with inseparable prefixes and ending in -end.
 * If not, stem the word that starts with an inseparable verb prefix and ends in -end as a present participle.
 *
 * @param {array}  inseparablePrefixes      The list of inseparable prefixes.
 * @param {array}  dataExceptionListToCheck The list of the exception words.
 * @param {array}  finalChangesRules        The array of regex-based rules to be applied to the stem.
 * @param {string} word 	                The (unstemmed) word to check.
 *
 * @returns {null|string} The stemmed word or null if the word was found on the exception list.
 */
const checkAndStemIfInseparablePrefixWithEndEnding = function checkAndStemIfInseparablePrefixWithEndEnding(inseparablePrefixes, dataExceptionListToCheck, finalChangesRules, word) {
	const startsWithInseparablePrefix = inseparablePrefixes.map(prefix => word.startsWith(prefix)).some(value => value === true);

	if (startsWithInseparablePrefix && word.endsWith("end") && !dataExceptionListToCheck.includes(word)) {
		return (0, _stemModificationHelpers$1.modifyStem)(word.slice(0, -3), finalChangesRules);
	}
	return null;
};

/**
 * Detects whether a word is a regular participle and if so, returns the stem.
 *
 * @param {Object}  morphologyDataNL 	The Dutch morphology data.
 * @param {string}  word                The word (not stemmed) to check.
 *
 * @returns {string|null} The participle stem or null if no regular participle was matched.
 */
function detectAndStemRegularParticiple(morphologyDataNL, word) {
	// Check whether the word is not a participle. If it is not, return empty string.
	if (word.endsWith("heid") || word.endsWith("teit") || word.endsWith("tijd") || (0, _nonParticiples2$1.default)().includes(word)) {
		return "";
	}

	/**
  * Check whether the word is on an exception list of verbs whose participle is the same as the stem. If the word is found
  * on the list, return the stem.
  */
	if (checkIfParticipleIsSameAsStem(morphologyDataNL.pastParticipleStemmer.inseparableCompoundVerbsNotToBeStemmed, word)) {
		return word;
	}

	// Check and stem if the word is a participle without any separable or inseparable prefix
	let stem = detectAndStemParticiplesWithoutPrefixes(morphologyDataNL, word);

	if (stem) {
		return stem;
	}

	/**
  * Check whether the word is on an exception list of inseparable compound verbs with a prefix that is usually separable.
  * If it is, remove just the suffix and return the stem.
  */
	stem = checkAndStemIfExceptionWithoutGePrefix(morphologyDataNL.pastParticipleStemmer.inseparableCompoundVerbs, word);

	if (stem) {
		return stem;
	}

	/**
  * Check whether the word is on an exception list of past participles with inseparable prefixes and ending in -end.
  * If not, stem the word that starts with an inseparable verb prefix and ends in -end as a present participle.
  */
	stem = checkAndStemIfInseparablePrefixWithEndEnding(morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes.inseparable, morphologyDataNL.pastParticipleStemmer.pastParticiplesEndingOnEnd, morphologyDataNL.regularStemmer.stemModifications.finalChanges, word);

	if (stem) {
		return stem;
	}

	// Check and stem if the word is a participle with a separable or inseparable prefix
	stem = detectAndStemParticiplesWithPrefixes(morphologyDataNL, word);

	if (stem) {
		return stem;
	}

	return null;
}

Object.defineProperty(stem$r, "__esModule", {
	value: true
});
stem$r.default = stem$q;

var _exceptionListHelpers$3 = exceptionListHelpers;

var _stemHelpers = stemHelpers;

var _detectAndStemSuffixes = detectAndStemSuffixes$1;

var _detectAndStemSuffixes2 = _interopRequireDefault$2B(_detectAndStemSuffixes);

var _getStemWordsWithTAndDEnding$1 = getStemWordsWithTAndDEnding;

var _checkExceptionsWithFullForms$1 = checkExceptionsWithFullForms;

var _checkExceptionsWithFullForms2$1 = _interopRequireDefault$2B(_checkExceptionsWithFullForms$1);

var _detectAndStemRegularParticiple$1 = detectAndStemRegularParticiple$1;

var _stemModificationHelpers = stemModificationHelpers;

function _interopRequireDefault$2B(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the stem from noun diminutives and plurals exceptions.
 *
 * @param {Object}    morphologyDataNL The data for stemming exception.
 * @param {string}      word                                The word to check.
 *
 * @returns {string} The stemmed word.
 */
const removeSuffixFromFullForms = function removeSuffixFromFullForms(morphologyDataNL, word) {
	/*
  * Checks whether the word is in the exception list of words ending in -er and gets either -e or -s suffix
  * If it is, remove the corresponding suffix.
  * e.g. lekkere -> lekker, bitters -> bitter
 */
	for (const exceptionClass of morphologyDataNL.stemExceptions.removeSuffixesFromFullForms) {
		const stemmedWord = (0, _stemHelpers.removeSuffixesFromFullForm)(exceptionClass.forms, exceptionClass.suffixes, word);
		if (stemmedWord) {
			return stemmedWord;
		}
	}
	/*
  * Checks whether the word is in one of the exception lists of nouns
  * for which a specific suffix needs to be stemmed (e.g. -s, -es, -eren, -er etc.)
  * e.g. kuddes -> kud, modes -> mod, revenuen -> revenu
  */
	for (const exceptionClass of morphologyDataNL.stemExceptions.removeSuffixFromFullForms) {
		const stemmedWord = (0, _stemHelpers.removeSuffixFromFullForm)(exceptionClass.forms, exceptionClass.suffix, word);
		if (stemmedWord) {
			return stemmedWord;
		}
	}
};

/**
 * Checks if the word is on a stemming exception list.
 *
 * @param {string} word The word to check.
 * @param {Object} morphologyDataNL The Dutch morphology data file.
 * @returns {string|null} The stem or null if the word was not matched by any of the exception checks.
 */
const checkOtherStemmingExceptions = function checkOtherStemmingExceptions(word, morphologyDataNL) {
	/*
  * Checks whether the word is in the exception list of nouns or adjectives with specific suffixes that needs to be stemmed.
  * If it is return the stem here and run possible stem modification if it is required. e.g. modes -> mod -> mood
  */
	let stemFromFullForm = removeSuffixFromFullForms(morphologyDataNL, word);
	if (stemFromFullForm) {
		if ((0, _stemModificationHelpers.isVowelDoublingAllowed)(stemFromFullForm, morphologyDataNL.regularStemmer.stemModifications.exceptionsStemModifications, morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes)) {
			stemFromFullForm = (0, _stemModificationHelpers.modifyStem)(stemFromFullForm, morphologyDataNL.regularStemmer.stemModifications.doubleVowel);
			return (0, _stemModificationHelpers.modifyStem)(stemFromFullForm, morphologyDataNL.regularStemmer.stemModifications.finalChanges);
		}
		return (0, _stemModificationHelpers.modifyStem)(stemFromFullForm, morphologyDataNL.regularStemmer.stemModifications.finalChanges);
	}
	return null;
};

/**
 * Stems Dutch words.
 *
 * @param {string} word  The word to stem.
 * @param {Object} morphologyDataNL The Dutch morphology data file.
 *
 * @returns {string} The stemmed word.
 */
function stem$q(word, morphologyDataNL) {
	// Check whether the word is in the list of words with full forms for which we define the stem. If it is, return the canonical stem.
	let stemmedWord = (0, _checkExceptionsWithFullForms2$1.default)(morphologyDataNL, word);
	if (stemmedWord) {
		return stemmedWord;
	}

	// Check whether the word is a participle, and if yes, stem it and return the stem.
	stemmedWord = (0, _detectAndStemRegularParticiple$1.detectAndStemRegularParticiple)(morphologyDataNL, word);
	if (stemmedWord) {
		return stemmedWord;
	}

	// Check whether the word is on the list of words that should not be stemmed, and if yes, return the word. Example: gans -> gans
	const wordsNotToBeStemmed = morphologyDataNL.stemExceptions.wordsNotToBeStemmedExceptions;
	if ((0, _exceptionListHelpers$3.checkIfWordIsOnVerbExceptionList)(word, wordsNotToBeStemmed.verbs, morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes) || (0, _exceptionListHelpers$3.checkIfWordEndingIsOnExceptionList)(word, wordsNotToBeStemmed.endingMatch) || wordsNotToBeStemmed.exactMatch.includes(word)) {
		return word;
	}

	/*
  * Check whether the word ends in -t/-te/-ten/-tend/-de/-den/-dend. If it does, run through a series of checks aimed at
  * predicting whether the -t/d is part of the stem or the suffix. If the word was matched in one of the checks, stem it
  * accordingly and return the stem. Example: boot -> boot, squasht -> squash
  */
	const tAndDEndings = morphologyDataNL.ambiguousTAndDEndings.otherTAndDEndings;
	for (const ending of tAndDEndings) {
		if (word.endsWith(ending)) {
			stemmedWord = (0, _getStemWordsWithTAndDEnding$1.generateCorrectStemWithTAndDEnding)(morphologyDataNL, word);
			if (stemmedWord) {
				return stemmedWord;
			}
		}
	}

	// Check if the word is on any other stemming exception list, and if yes, return the correct stem.
	stemmedWord = checkOtherStemmingExceptions(word, morphologyDataNL);
	if (stemmedWord) {
		return stemmedWord;
	}

	// If the word was not stemmed in any of the previous steps, run through the stemming algorithm which detects and stems suffixes.
	return (0, _detectAndStemSuffixes2.default)(word, morphologyDataNL);
}

var stemTOrDFromEndOfWord$1 = {};

Object.defineProperty(stemTOrDFromEndOfWord$1, "__esModule", {
  value: true
});
stemTOrDFromEndOfWord$1.stemTOrDFromEndOfWord = stemTOrDFromEndOfWord;

var _exceptionListHelpers$2 = exceptionListHelpers;

var _detectAndStemRegularParticiple = detectAndStemRegularParticiple$1;

var _getStemWordsWithTAndDEnding = getStemWordsWithTAndDEnding;

var _checkExceptionsWithFullForms = checkExceptionsWithFullForms;

var _checkExceptionsWithFullForms2 = _interopRequireDefault$2A(_checkExceptionsWithFullForms);

function _interopRequireDefault$2A(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * If the word ending in -t/-d was not matched in any of the checks for whether -t/-d should be stemmed or not, other checks still need
 * to be done in order to be sure whether we need to stem the word further or not.
 * If one of these checks returns true, we do not need to stem the word further.
 *
 * @param {Object}  morphologyDataNL	The Dutch morphology data.
 * @param {string}	stemmedWord			The stemmed word.
 * @param {string}	word				The unstemmed word.
 * @returns {boolean}	Whether one of the conditions returns true or not.
 */
const checkIfTorDIsUnambiguous = function checkIfTorDIsUnambiguous(morphologyDataNL, stemmedWord, word) {
  const wordsNotToBeStemmed = morphologyDataNL.stemExceptions.wordsNotToBeStemmedExceptions;
  const adjectivesEndingInRd = morphologyDataNL.stemExceptions.removeSuffixesFromFullForms[1].forms;
  const wordsEndingInTOrDExceptionList = morphologyDataNL.ambiguousTAndDEndings.tOrDArePartOfStem.doNotStemTOrD;

  // Run the checks below. If one of the conditions returns true, return the stem.
  if ((0, _detectAndStemRegularParticiple.detectAndStemRegularParticiple)(morphologyDataNL, word) || (0, _getStemWordsWithTAndDEnding.generateCorrectStemWithTAndDEnding)(morphologyDataNL, word) || (0, _exceptionListHelpers$2.checkIfWordIsOnVerbExceptionList)(word, wordsNotToBeStemmed.verbs, morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes) || (0, _exceptionListHelpers$2.checkIfWordEndingIsOnExceptionList)(word, wordsNotToBeStemmed.endingMatch) || wordsNotToBeStemmed.exactMatch.includes(word) || adjectivesEndingInRd.includes(stemmedWord) || (0, _checkExceptionsWithFullForms2.default)(morphologyDataNL, word) || stemmedWord.endsWith("heid") || (0, _exceptionListHelpers$2.checkIfWordEndingIsOnExceptionList)(stemmedWord, wordsEndingInTOrDExceptionList)) {
    return true;
  }
};

/**
 * If the word ending in -t/-d was not matched in any of the checks for whether -t/-d should be stemmed or not, and if it
 * is not a participle (which has its separate check), then it is still ambiguous whether -t/-d is part of the stem or a suffix.
 * Therefore, a second stem should be created with the -t/-d removed in case it was a suffix. For example, in the verb 'poolt',
 * -t is a suffix, but we could not predict in any of the previous checks that -t should be stemmed. To account for such cases,
 * we stem the -t here.
 *
 * @param {Object}  morphologyDataNL	The Dutch morphology data.
 * @param {string}	stemmedWord			The stemmed word.
 * @param {string}	word				The unstemmed word.
 *
 * @returns {?string}				    The stemmed word or null if the -t/-d should not be stemmed.
 */
function stemTOrDFromEndOfWord(morphologyDataNL, stemmedWord, word) {
  if (checkIfTorDIsUnambiguous(morphologyDataNL, stemmedWord, word)) {
    return null;
  }
  // If none of the conditions above is true, stem the t/d from the word.
  return stemmedWord.slice(0, -1);
}

Object.defineProperty(determineStem$1, "__esModule", {
	value: true
});
determineStem$1.determineStem = determineStem;

var _flattenSortLength$1 = flattenSortLength$1;

var _lodashEs$1y = require$$1$1;

var _stem$1 = stem$r;

var _stem2$1 = _interopRequireDefault$2z(_stem$1);

var _stemTOrDFromEndOfWord = stemTOrDFromEndOfWord$1;

var _exceptionListHelpers$1 = exceptionListHelpers;

function _interopRequireDefault$2z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks if the word checked is in the list of strong verbs exceptions. If it is, only return the first stem from the stem set.
 * E.g. stems: help, hielp, geholp -> the stem returned would be "help".
 *
 * @param {Object} strongVerbsLists	The exception lists of strong verbs.
 * @param {string} stemmedWord The word to check.
 * @returns {string} The unique stem.
 */
const checkStrongVerbExceptionList = function checkStrongVerbExceptionList(strongVerbsLists, stemmedWord) {
	for (const key of Object.keys(strongVerbsLists)) {
		for (const stemsSet of strongVerbsLists[key]) {
			const stems = (0, _lodashEs$1y.flatten)(Object.values(stemsSet));
			if (stems.includes(stemmedWord)) {
				return stems[0];
			}
		}
	}
};

/**
 * Checks if the word checked is in the list of strong verbs exceptions. Before checking, see if the word has a prefix and delete it if it does.
 * If the stem after prefix deletion is in the verb exception list, only return the first stem from the stem set and attach back the prefix.
 * E.g. words to check: verhielp, stem set: help, hielp, geholp -> the stem returned would be "verhelp".
 *
 * @param  {Object} morphologyDataNL 	The Dutch morphology data file.
 * @param  {string} stemmedWord 		The word to check.
 *
 * @returns {string} The unique stem.
 */
const findStemOnVerbExceptionList = function findStemOnVerbExceptionList(morphologyDataNL, stemmedWord) {
	const prefixes = (0, _flattenSortLength$1.flattenSortLength)(morphologyDataNL.pastParticipleStemmer.compoundVerbsPrefixes);
	// Check whether the inputted stem is started with one of the separable compound prefixes
	let foundPrefix = prefixes.find(prefix => stemmedWord.startsWith(prefix));
	const doNotStemPrefix = morphologyDataNL.stemExceptions.stemmingExceptionsWithMultipleStems.strongAndIrregularVerbs.doNotStemPrefix;
	const doNotStemPrefixException = doNotStemPrefix.find(exception => stemmedWord.endsWith(exception));
	let stemmedWordWithoutPrefix = "";

	// Check whether the stemmedWord is in the list of strong verbs starting with be-, ont- or ver- that do not need to be stemmed.
	if (doNotStemPrefixException) {
		// Reset foundPrefix so that it won't be attached when the stem is found in the verb exception list.
		foundPrefix = null;
		// If the inputted stem is started with one of the separable compound prefixes, the prefix needs to be deleted for now.
	} else if (foundPrefix) {
		// Delete the prefix for now.
		stemmedWordWithoutPrefix = stemmedWord.slice(foundPrefix.length, stemmedWord.length);
		// At least 3 characters left after prefix deletion so that e.g. "be" is not found in the stem "berg".
		if (stemmedWordWithoutPrefix.length > 2) {
			stemmedWord = stemmedWordWithoutPrefix;
		} else {
			// Reset foundPrefix so that it won't be attached when the stem is found in the verb exception list.
			foundPrefix = null;
		}
	}

	const strongVerbExceptions = morphologyDataNL.stemExceptions.stemmingExceptionsWithMultipleStems.strongAndIrregularVerbs.strongVerbStems;
	// Find stem strong verbs lists.
	const strongVerbsExceptionLists = [strongVerbExceptions.irregularStrongVerbs, strongVerbExceptions.regularStrongVerbs, strongVerbExceptions.bothRegularAndIrregularStrongVerbs];
	for (let i = 0; i < strongVerbsExceptionLists.length; i++) {
		const checkIfWordIsException = checkStrongVerbExceptionList(strongVerbsExceptionLists[i], stemmedWord);
		if (checkIfWordIsException) {
			// If the word checked had a prefix previously, attach it back.
			if (foundPrefix) {
				return foundPrefix + checkStrongVerbExceptionList(strongVerbsExceptionLists[i], stemmedWord);
			}
			// If the word checked did not have a prefix previously, only return the first stem.
			return checkStrongVerbExceptionList(strongVerbsExceptionLists[i], stemmedWord);
		}
	}
};

/**
 * Return the unique stem for a given Dutch input word.
 *
 * @param {string} word The word to be checked.
 * @param {Object} morphologyDataNL The Dutch data file.
 *
 * @returns {string} The unique stem.
 */
function determineStem(word, morphologyDataNL) {
	const stemmedWord = (0, _stem2$1.default)(word, morphologyDataNL);

	// Check whether the stemmed word is on an exception list of words with multiple stems. If it is, return the canonical stem.
	let stemFromExceptionList = (0, _exceptionListHelpers$1.checkExceptionListWithTwoStems)(morphologyDataNL.stemExceptions.stemmingExceptionsWithMultipleStems.stemmingExceptionsWithTwoStems, stemmedWord);
	if (stemFromExceptionList) {
		return stemFromExceptionList;
	}
	stemFromExceptionList = findStemOnVerbExceptionList(morphologyDataNL, stemmedWord);
	if (stemFromExceptionList) {
		return stemFromExceptionList;
	}

	// If the stemmed word ends in -t or -d, check whether it should be stemmed further, and return the stem with or without the -t/d.
	const ambiguousEndings = morphologyDataNL.ambiguousTAndDEndings.tAndDEndings;
	for (const ending of ambiguousEndings) {
		if (stemmedWord.endsWith(ending)) {
			const stemmedWordWithoutTOrD = (0, _stemTOrDFromEndOfWord.stemTOrDFromEndOfWord)(morphologyDataNL, stemmedWord, word);
			if (stemmedWordWithoutTOrD) {
				return stemmedWordWithoutTOrD;
			}
		}
	}

	return stemmedWord;
}

var stem$p = {};

var findMatchingEndingInArray$1 = {};

Object.defineProperty(findMatchingEndingInArray$1, "__esModule", {
	value: true
});
findMatchingEndingInArray$1.findMatchingEndingInArray = findMatchingEndingInArray;
/**
 * Loops through an array of word endings and returns the longest ending that was matched at the end of the string.
 *
 * @param {string}      string       The string to check.
 * @param {string[]}    endings    The word endings to check.
 * @returns {string}    The longest matched ending.
 */
function findMatchingEndingInArray(string, endings) {
	const matches = [];
	for (const i in endings) {
		if (string.endsWith(endings[i])) {
			matches.push(endings[i]);
		}
	}

	const longest = matches.sort(function (a, b) {
		return b.length - a.length;
	})[0];

	if (longest) {
		return longest;
	}
	return "";
}

Object.defineProperty(stem$p, "__esModule", {
	value: true
});
stem$p.default = stem$o;

var _buildFormRule$2 = buildFormRule;

var _createRulesFromMorphologyData$3 = createRulesFromMorphologyData$1;

var _createRulesFromMorphologyData2$2 = _interopRequireDefault$2y(_createRulesFromMorphologyData$3);

var _findMatchingEndingInArray$1 = findMatchingEndingInArray$1;

function _interopRequireDefault$2y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (C) 2018 Domingo Martín Mancera
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 */

const isVowel$5 = function isVowel(c) {
	const regex = /[aeiouáéíóú]/gi;

	return regex.test(c);
}; /* eslint-disable max-statements, require-jsdoc, complexity */
// The function will be further adjected anyways, so it makes no sense to randomly split it in smaller functions now.
// The orginal stemmer is available at https://github.com/dmarman/lorca/blob/master/src/stemmer.js.


const nextVowelPosition$1 = function nextVowelPosition(word, start = 0) {
	const length = word.length;

	for (let position = start; position < length; position++) {
		if (isVowel$5(word[position])) {
			return position;
		}
	}

	return length;
};

const nextConsonantPosition$1 = function nextConsonantPosition(word, start = 0) {
	const length = word.length;

	for (let position = start; position < length; position++) {
		if (!isVowel$5(word[position])) {
			return position;
		}
	}

	return length;
};

const removeAccent = function removeAccent(word) {
	const accentedVowels = ["á", "é", "í", "ó", "ú"];
	const vowels = ["a", "e", "i", "o", "u"];

	for (let i = 0; i < accentedVowels.length; i++) {
		word = word.replace(accentedVowels[i], vowels[i]);
	}

	return word;
};

const endsIn = function endsIn(word, suffix) {
	if (word.length < suffix.length) {
		return false;
	}

	return word.slice(-suffix.length) === suffix;
};

/**
 * Checks whether a word is in the full-form exception list and if so returns the canonical stem.
 *
 * @param {string} word	      The word to be checked.
 * @param {Object} exceptions The list of full-form exceptions to be checked in.
 *
 * @returns {null|string} The canonical stem or null if nothing was found.
 */
const checkWordInFullFormExceptions$3 = function checkWordInFullFormExceptions(word, exceptions) {
	for (const paradigm of exceptions) {
		if (paradigm[1].includes(word)) {
			return paradigm[0];
		}
	}
	return null;
};

/**
 * The function considers if the input word can be an adverb in -mente and if so stems it.
 * @param   {string}   word                                      The word to stem.
 * @param   {string}   r1Text                                    The R1 region of the word to stem.
 * @param   {Object}   menteStemming                      An object containing information about how to stem mente-adverbs.
 * @param   {string[]} menteStemming.notMente      An array of words that look like mente-adverbs but are not.
 * @param   {Array}    menteStemming.menteToStem    An array of pairs of regexes to match.
 * @returns {string}   A stemmed adverb or the input word, if it is not an adverb.
 */
const tryStemAsMente = function tryStemAsMente(word, r1Text, menteStemming) {
	const suffix = endsIn(r1Text, "mente");

	// Immediately return the input word if no mente suffix is found or the word is in the stopList.
	if (suffix === "" || menteStemming.notMenteAdverbs.includes(word)) {
		return word;
	}

	return (0, _buildFormRule$2.buildOneFormFromRegex)(word, (0, _createRulesFromMorphologyData2$2.default)(menteStemming.menteToStem)) || word;
};

/**
 * The function considers if the input word can be a superlative and if so stems it.
 * @param   {string}   word                                      The word to stem.
 * @param   {string}   r1Text                                    The R1 region of the word to stem.
 * @param   {Object}   superlativesStemming                      An object containing information about how to stem superlatives.
 * @param   {string[]} superlativesStemming.superlativeSuffixes  An array of suffixes possible in superlatives.
 * @param   {string[]} superlativesStemming.notSuperlatives      An array of words that look like superlatives but are not.
 * @param   {Array}    superlativesStemming.superlativeToStem    An array of pairs of regexes to match.
 * @returns {string}   A stemmed superlative or the input word, if it is not a superlative.
 */
const tryStemAsSuperlative = function tryStemAsSuperlative(word, r1Text, superlativesStemming) {
	const superlativeSuffix = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(r1Text, superlativesStemming.superlativeSuffixes);

	// Immediately return the input word if no superlative suffix is found or the word is in the stopList.
	if (superlativeSuffix === "" || superlativesStemming.notSuperlatives.includes(word)) {
		return word;
	}

	return (0, _buildFormRule$2.buildOneFormFromRegex)(word, (0, _createRulesFromMorphologyData2$2.default)(superlativesStemming.superlativeToStem)) || word;
};

/**
 * The function considers if the input word can be a diminutive and if so stems it.
 * @param   {string}   word                                         The word to stem.
 * @param   {Object}   diminutivesStemming                          An object containing information about how to stem diminutives.
 * @param   {string[]} diminutivesStemming.notDiminutives           An array of words that look like diminutives but are not.
 * @param   {Array}    diminutivesStemming.diminutiveToStem         An array of pairs of regexes to match.
 * @param   {Array}    diminutivesStemming.irregularDiminutives     An array containing data for irregular diminutives.
 *
 * @returns {string}   A stemmed diminutive or the input word, if it is not a diminutive.
 */
const tryStemAsDiminutive = function tryStemAsDiminutive(word, diminutivesStemming) {
	const diminutiveSuffix = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(word, ["ito", "ita", "itos", "itas", "íto", "íta", "ítos", "ítas"]);

	// Immediately return the input word if no diminutive suffix is found or the word is in the stopList.
	if (diminutiveSuffix === "" || diminutivesStemming.notDiminutives.includes(word)) {
		return word;
	}

	// Remove o/a/os/as and check irregular diminutives ending in -it-/-ít-
	const wordWithoutEnding = word.endsWith("s") ? word.slice(0, word.length - 2) : word.slice(0, word.length - 1);

	for (const paradigm of diminutivesStemming.irregularDiminutives) {
		if (paradigm[1].includes(wordWithoutEnding)) {
			return paradigm[0];
		}
	}

	return (0, _buildFormRule$2.buildOneFormFromRegex)(word, (0, _createRulesFromMorphologyData2$2.default)(diminutivesStemming.diminutiveToStem)) || word;
};

/**
 * Checks whether a stem is in an exception list of verbs, nouns or adjectives with multiple stems and if so returns
 * the canonical stem.
 *
 * @param {string} stemmedWord	            The stemmed word to be checked.
 * @param {Object} stemsThatBelongToOneWord The POS-specific data that shows how non-canonical stems should be canonicalized.
 *
 * @returns {null|string} The canonical stem or null if nothing was found.
 */
const canonicalizeStem$2 = function canonicalizeStem(stemmedWord, stemsThatBelongToOneWord) {
	// First check for nouns with multiple stems, which are only diminutives.
	for (const paradigm of stemsThatBelongToOneWord.nouns) {
		if (paradigm.includes(stemmedWord)) {
			return paradigm[0];
		}
	}

	// Second check for adjectives with multiple stems, which are only adjectives ending in -bl/-bil.
	for (const paradigm of stemsThatBelongToOneWord.adjectives) {
		if (paradigm.includes(stemmedWord)) {
			return paradigm[0];
		}
	}

	// Last check for verbs that have irregular forms.
	for (const paradigm of stemsThatBelongToOneWord.verbs) {
		if (paradigm.includes(stemmedWord)) {
			return paradigm[0];
		}
	}
	return null;
};

/**
 * Stems verb suffixes.
 *
 * @param {string}  word                The original word.
 * @param {string}  wordAfter1          The word after step 1.
 * @param {string}  rvText              The text of the RV.
 * @param {number}  rv                  The start position of the RV.
 * @param {Object}  morphologyData      The Spanish morphology data.
 *
 * @returns {string} The word with the verb suffixes removed (if applicable).
 */
const stemVerbSuffixes$1 = function stemVerbSuffixes(word, wordAfter1, rvText, rv) {
	// Do step 2a if no ending was removed by step 1.
	const suf = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(rvText, ["ya", "ye", "yan", "yen", "yeron", "yendo", "yo", "yó", "yas", "yes", "yais", "yamos"]);

	if (suf !== "" && word.slice(-suf.length - 1, -suf.length) === "u") {
		word = word.slice(0, -suf.length);
	}

	if (word !== wordAfter1) {
		rvText = word.slice(rv);
	}

	// Do Step 2b if step 2a was done, but failed to remove a suffix.
	if (word === wordAfter1) {
		const suf11 = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(rvText, ["arían", "arías", "arán", "arás", "aríais", "aría", "aréis", "aríamos", "aremos", "ará", "aré", "erían", "erías", "erán", "erás", "eríais", "ería", "eréis", "eríamos", "eremos", "erá", "eré", "irían", "irías", "irán", "irás", "iríais", "iría", "iréis", "iríamos", "iremos", "irá", "iré", "aba", "ada", "ida", "ía", "ara", "iera", "ad", "ed", "id", "ase", "iese", "aste", "iste", "an", "aban", "ían", "aran", "ieran", "asen", "iesen", "aron", "ieron", "ado", "ido", "ando", "iendo", "ió", "ar", "er", "ir", "as", "abas", "adas", "idas", "ías", "aras", "ieras", "ases", "ieses", "ís", "áis", "abais", "íais", "arais", "ierais", "  aseis", "ieseis", "asteis", "isteis", "ados", "idos", "amos", "ábamos", "íamos", "imos", "áramos", "iéramos", "iésemos", "ásemos"]);
		const suf12 = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(rvText, ["en", "es", "éis", "emos"]);
		if (suf11 !== "") {
			word = word.slice(0, -suf11.length);
		} else if (suf12 !== "") {
			word = word.slice(0, -suf12.length);
			if (endsIn(word, "gu")) {
				word = word.slice(0, -1);
			}
		}
	}

	return word;
};

/**
 * Stems Spanish words.
 *
 * @param {string} word            The word to stem.
 * @param {Object} morphologyData  The Spanish morphology data.
 *
 * @returns {string} The stemmed word.
 */
function stem$o(word, morphologyData) {
	word.toLowerCase();

	const ifException = checkWordInFullFormExceptions$3(word, morphologyData.exceptionStemsWithFullForms);
	if (ifException) {
		return ifException;
	}

	const nonPluralsOnS = morphologyData.wordsThatLookLikeButAreNot.nonPluralsOnS;
	if (nonPluralsOnS.includes(word)) {
		return removeAccent(word);
	}

	const length = word.length;
	if (length < 2) {
		return removeAccent(word);
	}

	let r1 = length;
	let r2 = length;
	let rv = length;

	/**
  * R1 is the region after the first non-vowel following a vowel, or is the null region at the end of the word if
  * there is no such non-vowel.
  */
	for (let i = 0; i < length - 1 && r1 === length; i++) {
		if (isVowel$5(word[i]) && !isVowel$5(word[i + 1])) {
			r1 = i + 2;
		}
	}

	/**
  * R2 is the region after the first non-vowel following a vowel in R1, or is the null region at the end of the
  * word if there is no such non-vowel.
  */
	for (let i = r1; i < length - 1 && r2 === length; i++) {
		if (isVowel$5(word[i]) && !isVowel$5(word[i + 1])) {
			r2 = i + 2;
		}
	}

	if (length > 3) {
		if (!isVowel$5(word[1])) {
			rv = nextVowelPosition$1(word, 2) + 1;
		} else if (isVowel$5(word[0]) && isVowel$5(word[1])) {
			rv = nextConsonantPosition$1(word, 2) + 1;
		} else {
			rv = 3;
		}
	}

	let r1Text = word.slice(r1);
	let r2Text = word.slice(r2);
	let rvText = word.slice(rv);
	const originalWord = word;

	// Step 0: Attached pronoun
	const pronounSuffix = ["me", "se", "sela", "selo", "selas", "selos", "la", "le", "lo", "las", "les", "los", "nos"];
	const pronounSuffixPre1 = ["iéndo", "ándo", "ár", "ér", "ír"];
	const pronounSuffixPre2 = ["iendo", "ando", "ar", "er", "ir"];

	const suffix = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(word, pronounSuffix);

	if (suffix !== "" && !morphologyData.wordsThatLookLikeButAreNot.notVerbsEndingInPersonalPronouns.includes(word)) {
		let preSuffix = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(rvText.slice(0, -suffix.length), pronounSuffixPre1);

		if (preSuffix === "") {
			preSuffix = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(rvText.slice(0, -suffix.length), pronounSuffixPre2);

			if (preSuffix !== "" || endsIn(word.slice(0, -suffix.length), "uyendo")) {
				word = word.slice(0, -suffix.length);
			}
		} else {
			word = removeAccent(word.slice(0, -suffix.length));
		}
	}

	if (word !== originalWord) {
		r1Text = word.slice(r1);
		r2Text = word.slice(r2);
		rvText = word.slice(rv);
	}

	const wordAfter0 = word;

	const suf1 = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(r2Text, ["anza", "anzas", "ico", "ica", "icos", "icas", "ismo", "ismos", "able", "ables", "ible", "ibles", "ista", "istas", "oso", "osa", "osos", "osas", "amiento", "amientos", "imiento", "imientos"]);
	const suf2 = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(r2Text, ["icadora", "icador", "icación", "icadoras", "icadores", "icaciones", "icante", "icantes", "icancia", "icancias", "adora", "ador", "ación", "adoras", "adores", "aciones", "ante", "antes", "ancia", "ancias"]);
	const suf3 = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(r2Text, ["logía", "logías"]);
	const suf4 = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(r2Text, ["ución", "uciones"]);
	const suf5 = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(r2Text, ["encia", "encias"]);
	const suf9 = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(r2Text, ["abilidad", "abilidades", "icidad", "icidades", "ividad", "ividades", "idad", "idades"]);
	const suf10 = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(r2Text, ["ativa", "ativo", "ativas", "ativos", "iva", "ivo", "ivas", "ivos"]);

	if (suf1 !== "") {
		word = word.slice(0, -suf1.length);
	} else if (suf2 !== "") {
		word = word.slice(0, -suf2.length);
	} else if (suf3 !== "") {
		word = word.slice(0, -suf3.length) + "log";
	} else if (suf4 !== "") {
		word = word.slice(0, -suf4.length) + "u";
	} else if (suf5 !== "") {
		word = word.slice(0, -suf5.length) + "ente";
	} else if (suf9 !== "") {
		word = word.slice(0, -suf9.length);
	} else if (suf10 !== "") {
		word = word.slice(0, -suf10.length);
	}

	// Check if the word is an adverb in -mente. Stem it as a adverb if so, and immediately return the result.
	const ifMente = tryStemAsMente(word, r1Text, morphologyData.menteStemming);
	if (ifMente !== word) {
		return removeAccent(ifMente);
	}

	// Check if the word is a superlative. Stem it as a superlative if so, and immediately return the result.
	const ifSuperlative = tryStemAsSuperlative(word, r1Text, morphologyData.superlativesStemming);
	if (ifSuperlative !== word) {
		return removeAccent(ifSuperlative);
	}

	// Check if the word is a diminutive. Stem it as a diminutive if so, and immediately return the result.
	const ifDiminutive = tryStemAsDiminutive(word, morphologyData.diminutivesStemming);
	if (ifDiminutive !== word) {
		return removeAccent(ifDiminutive);
	}

	if (word !== wordAfter0) {
		rvText = word.slice(rv);
	}

	const wordAfter1 = word;

	// Step 2a and 2b stem verb suffixes.
	const notVerbForms = morphologyData.wordsThatLookLikeButAreNot.notVerbForms;

	if (wordAfter0 === wordAfter1) {
		// If the word ends in -s, it is removed before checking the non-verbs list, as the list does not include plural forms.
		let wordWithoutS = word;
		if (word.endsWith("s")) {
			wordWithoutS = word.slice(0, -1);
		}

		if (notVerbForms.includes(wordWithoutS)) {
			/*
    * If the word without -s is matched on the non-verbs list, we can perform the next (non-verb) stemming steps
    * with the -s removed. This is because all possible non-verb suffixes ending in -s also have an equivalent
    * without the -s (e.g. -as/a; -es/e), so will be stemmed after stripping the -s.
    */
			word = wordWithoutS;
		} else {
			word = stemVerbSuffixes$1(word, wordAfter1, rvText, rv);
		}
	}

	rvText = word.slice(rv);

	const suf13 = (0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(rvText, ["os", "a", "o", "á", "í", "ó"]);
	if (suf13 !== "") {
		word = word.slice(0, -suf13.length);
	} else if ((0, _findMatchingEndingInArray$1.findMatchingEndingInArray)(rvText, ["e", "é"]) !== "") {
		word = word.slice(0, -1);
		rvText = word.slice(rv);
		if (endsIn(rvText, "u") && endsIn(word, "gu")) {
			word = word.slice(0, -1);
		}
	}

	const canonicalStem = canonicalizeStem$2(word, morphologyData.stemsThatBelongToOneWord);
	if (canonicalStem) {
		return canonicalStem;
	}

	return removeAccent(word);
}

var stem$n = {};

Object.defineProperty(stem$n, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable max-statements, complexity */


stem$n.default = stem$m;

var _exceptionListHelpers = exceptionListHelpers;

var _regexHelpers$1 = regexHelpers;

/*
 * MIT License
 *
 * Copyright (c) 2017 Bastien Botella
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/*
 * Author: Kasun Gajasinghe, University of Moratuwa
 * E-Mail: kasunbg AT gmail DOT com
 * Date: 09.08.2010
 *
 * LICENSE:
 *
 * Copyright (c) 2010, Kasun Gajasinghe. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice,
 *       this list of conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice,
 *       this list of conditions and the following disclaimer in the documentation
 *       and/or other materials provided with the distribution.
 *
 *
 * THIS SOFTWARE IS PROVIDED BY KASUN GAJASINGHE ""AS IS"" AND ANY EXPRESS OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
 * PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL KASUN GAJASINGHE BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
 * BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE
 * USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */

/**
 * Determines R1, R2 and RV.
 *
 * @param {string} word The word for which to determine the R regions.
 * @param {Object} rIntervalsData The regexes that cover French RV and R1 intervals.
 *
 * @returns {[number]} The R1, R2 and RV.
 */
const determineRs$1 = function determineRs(word, rIntervalsData) {
	let rvIndex = -1;

	if (word.search(new RegExp(rIntervalsData.rvRegex1)) !== -1 || word.search(new RegExp(rIntervalsData.rvRegex2)) !== -1) {
		rvIndex = 3;
	} else {
		rvIndex = word.substring(1).search(new RegExp(rIntervalsData.rvRegex3));

		if (rvIndex === -1) {
			rvIndex = word.length;
		} else {
			// +2 is to supplement the substring(1) used to find rvIndex
			rvIndex += 2;
		}
	}

	/*
  * R1 is the region after the first non-vowel following a vowel, or the end of the word if there is no such non-vowel.
  * R2 is the region after the first non-vowel following a vowel in R1, or the end of the word if there is no such non-vowel.
  */
	const r1Regex = new RegExp(rIntervalsData.r1Regex);
	let r1Index = word.search(r1Regex);
	let r1 = "";
	if (r1Index === -1) {
		r1Index = word.length;
	} else {
		r1Index += 2;
		r1 = word.substring(r1Index);
	}

	let r2Index = -1;
	if (r1Index !== -1) {
		r2Index = r1.search(r1Regex);
		if (r2Index === -1) {
			r2Index = word.length;
		} else {
			r2Index += 2;
			r2Index += r1Index;
		}
	}
	if (r1Index !== -1 && r1Index < 3) {
		r1Index = 3;
	}

	return [r1Index, r2Index, rvIndex];
};

/**
 * Removes or normalizes standard suffixes.
 *
 * @param {string} word               The word for which to remove suffixes.
 * @param {Object} standardSuffixData The French morphology data covering standard suffixes.
 * @param {number} r1Index            The start index of R1.
 * @param {number} r2Index            The start index of R2.
 * @param {number} rvIndex            The start index of RV.
 *
 * @returns {string} The word with standard suffixes removed or normalized.
 */
const processStandardSuffixes = function processStandardSuffixes(word, standardSuffixData, r1Index, r2Index, rvIndex) {
	const a1Index = word.search(new RegExp(standardSuffixData.standardSuffixes1)),
	      a2Index = word.search(new RegExp(standardSuffixData.standardSuffixes2)),
	      a3Index = word.search(new RegExp(standardSuffixData.standardSuffixes3[0])),
	      a4Index = word.search(new RegExp(standardSuffixData.standardSuffixes4[0])),
	      a5Index = word.search(new RegExp(standardSuffixData.standardSuffixes5[0])),
	      a6Index = word.search(new RegExp(standardSuffixData.standardSuffixes6)),
	      a7Index = word.search(new RegExp(standardSuffixData.standardSuffixes7)),
	      a8Index = word.search(new RegExp(standardSuffixData.standardSuffixes8)),
	      a9Index = word.search(new RegExp(standardSuffixData.standardSuffixes9[0])),
	      a10Index = word.search(new RegExp(standardSuffixData.standardSuffixes10[0])),
	      a11Index = word.search(new RegExp(standardSuffixData.standardSuffixes11[0])),
	      a12Index = word.search(new RegExp(standardSuffixData.standardSuffixes12)),
	      a13Index = word.search(new RegExp(standardSuffixData.standardSuffixes13[0])),
	      a14Index = word.search(new RegExp(standardSuffixData.standardSuffixes14[0])),
	      a15Index = word.search(new RegExp(standardSuffixData.standardSuffixes15));

	if (a1Index !== -1 && a1Index >= r2Index) {
		word = word.substring(0, a1Index);
	} else if (a2Index !== -1 && a2Index >= r2Index) {
		word = word.substring(0, a2Index);
		const a2Index2 = word.search(new RegExp(standardSuffixData.suffixesPrecedingChar1[0]));

		if (a2Index2 !== -1 && a2Index2 >= r2Index) {
			// If preceded by ic, delete if in R2
			word = word.substring(0, a2Index2);
		} else {
			// Else replace by iqU
			word = word.replace(new RegExp(standardSuffixData.suffixesPrecedingChar1[0]), standardSuffixData.suffixesPrecedingChar1[1]);
		}
	} else if (a3Index !== -1 && a3Index >= r2Index) {
		// Replace with log if in R2
		word = word.slice(0, a3Index) + standardSuffixData.standardSuffixes3[1];
	} else if (a4Index !== -1 && a4Index >= r2Index) {
		// Replace with u if in R2
		word = word.slice(0, a4Index) + standardSuffixData.standardSuffixes4[1];
	} else if (a5Index !== -1 && a5Index >= r2Index) {
		// Replace with ent if in R2
		word = word.slice(0, a5Index) + standardSuffixData.standardSuffixes5[1];
	} else if (a12Index !== -1 && a12Index >= r1Index) {
		// +1- amendment to non-vowel
		word = word.substring(0, a12Index + 1);
	} else if (a6Index !== -1 && a6Index >= rvIndex) {
		word = word.substring(0, a6Index);

		const precedingCharacter2 = word.search(new RegExp(standardSuffixData.suffixesPrecedingChar2[0]));
		const a6Index2 = word.search(new RegExp(standardSuffixData.suffixesPrecedingChar4[0]));
		const precedingCharacter5 = word.search(new RegExp(standardSuffixData.suffixesPrecedingChar5[0]));
		const precedingCharacter6 = word.search(new RegExp(standardSuffixData.suffixesPrecedingChar6[0]));
		if (precedingCharacter2 >= r2Index) {
			word = word.slice(0, precedingCharacter2) + standardSuffixData.suffixesPrecedingChar2[1];

			const precedingCharacter3 = word.search(new RegExp(standardSuffixData.suffixesPrecedingChar3[0]));
			if (precedingCharacter3 >= r2Index) {
				word = word.slice(0, precedingCharacter3) + standardSuffixData.suffixesPrecedingChar3[1];
			}
		} else if (word.search(new RegExp(standardSuffixData.suffixesPrecedingChar4[0])) !== -1) {
			if (a6Index2 >= r2Index) {
				word = word.substring(0, a6Index2);
			} else if (a6Index2 >= r1Index) {
				word = word.substring(0, a6Index2) + standardSuffixData.suffixesPrecedingChar4[1];
			}
		} else if (precedingCharacter5 >= r2Index) {
			// If preceded by abl or iqU, delete if in R2
			word = word.slice(0, precedingCharacter5) + standardSuffixData.suffixesPrecedingChar5[1];
		} else if (precedingCharacter6 >= rvIndex) {
			// If preceded by abl or iqU, delete if in R2
			word = word.slice(0, precedingCharacter6) + standardSuffixData.suffixesPrecedingChar6[1];
		}
	} else if (a7Index !== -1 && a7Index >= r2Index) {
		// Delete if in R2
		word = word.substring(0, a7Index);

		const a7Index2 = word.search(new RegExp(standardSuffixData.suffixesPrecedingChar7[0]));
		const a7Index3 = word.search(new RegExp(standardSuffixData.suffixesPrecedingChar1[0]));
		if (a7Index2 !== -1) {
			// If preceded by abil, delete if in R2, else replace by abl, otherwise
			if (a7Index2 >= r2Index) {
				word = word.substring(0, a7Index2);
			} else {
				word = word.substring(0, a7Index2) + standardSuffixData.suffixesPrecedingChar7[1];
			}
		} else if (a7Index3 !== -1) {
			if (a7Index3 !== -1 && a7Index3 >= r2Index) {
				// If preceded by ic, delete if in R2
				word = word.substring(0, a7Index3);
			} else {
				// Else replace by iqU
				word = word.substring(0, a7Index3) + standardSuffixData.suffixesPrecedingChar1[1];
			}
		} else if (word.search(new RegExp(standardSuffixData.suffixesPrecedingChar2[0])) !== r2Index) {
			word = word.replace(new RegExp(standardSuffixData.suffixesPrecedingChar2[0]), standardSuffixData.suffixesPrecedingChar2[1]);
		}
	} else if (a8Index !== -1 && a8Index >= r2Index) {
		word = word.substring(0, a8Index);

		if (word.search(new RegExp(standardSuffixData.suffixesPrecedingChar3[0])) >= r2Index) {
			word = word.replace(new RegExp(standardSuffixData.suffixesPrecedingChar3[0]), standardSuffixData.suffixesPrecedingChar3[1]);

			if (word.search(new RegExp(standardSuffixData.suffixesPrecedingChar1[0])) >= r2Index) {
				word = word.replace(new RegExp(standardSuffixData.suffixesPrecedingChar1[0]), "");
			} else {
				word = word.replace(new RegExp(standardSuffixData.suffixesPrecedingChar1[0]), standardSuffixData.suffixesPrecedingChar1[1]);
			}
		}
	} else if (a9Index !== -1) {
		word = word.replace(new RegExp(standardSuffixData.standardSuffixes9[0]), standardSuffixData.standardSuffixes9[1]);
	} else if (a10Index >= r1Index) {
		word = word.replace(new RegExp(standardSuffixData.standardSuffixes10[0]), standardSuffixData.standardSuffixes10[1]);
	} else if (a11Index !== -1) {
		const a11Index2 = word.search(new RegExp(standardSuffixData.standardSuffixes11[0]));

		if (a11Index2 >= r2Index) {
			word = word.substring(0, a11Index2);
		} else if (a11Index2 >= r1Index) {
			word = word.substring(0, a11Index2) + standardSuffixData.standardSuffixes11[1];
		}
	} else if (a13Index !== -1 && a13Index >= rvIndex) {
		word = word.replace(new RegExp(standardSuffixData.standardSuffixes13[0]), standardSuffixData.standardSuffixes13[1]);
	} else if (a14Index !== -1 && a14Index >= rvIndex) {
		word = word.replace(new RegExp(standardSuffixData.standardSuffixes14[0]), standardSuffixData.standardSuffixes14[1]);
	} else if (a15Index !== -1 && a15Index >= rvIndex) {
		word = word.substring(0, a15Index + 1);
	}

	return word;
};

/**
 * Removes verb suffixes starting with i.
 *
 * @param {string} word                       The word for which to remove suffixes.
 * @param {string} originalWord               The unprocessed word.
 * @param {number} rvIndex                    The start index of RV.
 * @param {string} verbSuffixesWithIBeginning Data for checking French suffixes starting with I.
 *
 * @returns {{step2aDone: boolean, word: string}} The word and information about whether the conditions for step 2a were met.
 */
const removeVerbSuffixesStartingWithI = function removeVerbSuffixesStartingWithI(word, originalWord, rvIndex, verbSuffixesWithIBeginning) {
	let step2aDone = false;
	if (originalWord === word.toLowerCase() || (0, _exceptionListHelpers.checkIfWordEndingIsOnExceptionList)(originalWord, verbSuffixesWithIBeginning.exceptions)) {
		step2aDone = true;

		const b1Regex = new RegExp(verbSuffixesWithIBeginning.suffixes[0]);
		if (word.search(b1Regex) >= rvIndex) {
			word = word.replace(b1Regex, verbSuffixesWithIBeginning.suffixes[1]);
		}
	}

	return { word, step2aDone };
};

/**
 * Removes other verb suffixes.
 *
 * @param {string}  word              The word for which to remove suffixes.
 * @param {boolean} step2aDone        Whether step 2a was done.
 * @param {string}  wordAfterStep1    The word after step 1 was done.
 * @param {number}  r2Index           The start index of R2.
 * @param {number}  rvIndex           The start index of RV.
 * @param {Object}  morphologyData    The French morphology data.
 *
 * @returns {string} The word after other verb suffixes were removed.
 */
const removeOtherVerbSuffixes = function removeOtherVerbSuffixes(word, step2aDone, wordAfterStep1, r2Index, rvIndex, morphologyData) {
	const otherVerbSuffixes = morphologyData.regularStemmer.otherVerbSuffixes;

	if (step2aDone && wordAfterStep1 === word) {
		const suffixIons = new RegExp(otherVerbSuffixes[0]);
		if (word.search(suffixIons) >= r2Index) {
			return word.replace(suffixIons, "");
		}

		for (let i = 1; i < otherVerbSuffixes.length; i++) {
			const regex = new RegExp(otherVerbSuffixes[i]);
			if (word.search(regex) >= rvIndex) {
				return word.replace(regex, "");
			}
		}
		// Check if a word ends in "ons" preceded by "i", if it is "ons" is not stemmed.
		if (word.endsWith("ions")) {
			return word;
		}

		// Check if a word ends in "ons" preceded by other than "i" and stem it if it is in RV.
		const verbSuffixOns = new RegExp(morphologyData.regularStemmer.verbSuffixOns);
		if (word.search(verbSuffixOns) >= rvIndex) {
			word = word.replace(verbSuffixOns, "");
		}
	}

	return word;
};

/**
 * Removes residual suffixes.
 *
 * @param {string}  word                            The word for which to remove residual suffixes.
 * @param {number}  rvIndex                         The start index of RV.
 * @param {number}  r2Index                         The start index of R2.
 * @param {Object}  morphologyDataRegularStemmer    The French morphology data.
 *
 * @returns {string}                                The word after residual suffixes were removed.
 */
const removeResidualSuffixes = function removeResidualSuffixes(word, rvIndex, r2Index, morphologyDataRegularStemmer) {
	const residualSuffixes = morphologyDataRegularStemmer.residualSuffixes;
	if (word.search(new RegExp(residualSuffixes.residualSuffixes1[0])) >= rvIndex) {
		word = word.replace(new RegExp(residualSuffixes.residualSuffixes1[0]), residualSuffixes.residualSuffixes1[1]);
	}

	const e1Index = word.search(new RegExp(residualSuffixes.residualSuffix2));

	if (e1Index >= r2Index && word.search(new RegExp(residualSuffixes.residualSuffix3)) >= rvIndex) {
		word = word.substring(0, e1Index);
	} else {
		let e2Index = word.search(new RegExp(residualSuffixes.residualSuffixes4[0]));

		if (e2Index >= rvIndex) {
			word = word.substring(0, e2Index) + residualSuffixes.residualSuffixes4[1];
		} else {
			e2Index = word.search(new RegExp(residualSuffixes.residualSuffix5));
			if (e2Index >= rvIndex) {
				// Delete last e.
				word = word.substring(0, e2Index);
			} else {
				e2Index = word.search(new RegExp(residualSuffixes.residualSuffix6[0]));
				if (e2Index >= rvIndex) {
					word = word.substring(0, e2Index) + residualSuffixes.residualSuffix6[1];
				}
			}
		}
	}

	return word;
};

/**
 * Checks whether a word is in the full-form exception list and if so returns the canonical stem.
 *
 * @param {string} word	      The word to be checked.
 * @param {Object} exceptions The list of full-form exceptions to be checked in.
 *
 * @returns {null|string} The canonical stem or null if nothing was found.
 */
const checkWordInFullFormExceptions$2 = function checkWordInFullFormExceptions(word, exceptions) {
	for (const paradigm of exceptions) {
		if (paradigm[1].includes(word)) {
			return paradigm[0];
		}
	}
	return null;
};

/**
 * Check whether the stem is on the exception list of stems that belong to one word. If it is, returns the canonical stem.
 *
 * @param {string}	stemmedWord					The stemmed word.
 * @param {Object}	stemsThatBelongToOneWord	The list of stems that belong to one word.
 *
 * @returns {null|string}	The canonical stem if word was found on the list.
 */
const canonicalizeStem$1 = function canonicalizeStem(stemmedWord, stemsThatBelongToOneWord) {
	// Check the adjectives list.
	for (const paradigm of stemsThatBelongToOneWord.adjectives) {
		if (paradigm.includes(stemmedWord)) {
			return paradigm[0];
		}
	}
	// Check the verbs list. The infinitive stem is always the canonical stem for verbs.
	for (const paradigm of stemsThatBelongToOneWord.verbs) {
		if (paradigm.includes(stemmedWord)) {
			return paradigm[0];
		}
	}
};

/**
 * Checks whether the word is on the list of words which should be stemmed, even though the suffix would not be found in the
 * required region. If the word is found on the list, the stem specified in that list is returned.
 *
 * @param {string}	word				The word to check.
 * @param {Object}	shortWordsAndStems	The list to check.
 *
 * @returns {null|string} The stem or null if the word was not found on the list.
 */
const checkShortWordsExceptionList = function checkShortWordsExceptionList(word, shortWordsAndStems) {
	// First check whether the word is on the sub-list of words that cannot take an extra -s suffix.
	for (const wordStemPair of shortWordsAndStems.cannotTakeExtraSuffixS) {
		if (wordStemPair[0] === word) {
			return wordStemPair[1];
		}
	}
	// If the word was not found on the first sub-list, check the second sub-list of words that can take an extra -s suffix.
	if (word.endsWith("s")) {
		word = word.slice(0, -1);
	}
	for (const wordStemPair of shortWordsAndStems.canTakeExtraSuffixS) {
		if (wordStemPair[0] === word) {
			return wordStemPair[1];
		}
	}
};

/**
 * Stems French words.
 *
 * @param {string} word             The word to stem.
 * @param {Object} morphologyData   The French morphology data.
 *
 * @returns {string} The stemmed word.
 */
function stem$m(word, morphologyData) {
	word = word.toLowerCase();
	const originalWord = word;

	// Check if the word is on an exception list of words that should be stemmed even though the suffix is not in the required region.
	const wordAfterShortWordsCheck = checkShortWordsExceptionList(word, morphologyData.shortWordsAndStems);
	if (wordAfterShortWordsCheck) {
		return wordAfterShortWordsCheck;
	}

	// Check if the word is on an exception list for which all forms of a word and its stem are listed.
	const ifException = checkWordInFullFormExceptions$2(word, morphologyData.exceptionStemsWithFullForms);
	if (ifException) {
		return ifException;
	}

	// Check the exception list of words with plural suffix -x.
	if (word.endsWith("x")) {
		const pluralsWithXSuffix = morphologyData.pluralsWithXSuffix;
		if (pluralsWithXSuffix.includes(word)) {
			return word.slice(0, -1);
		}
	}

	// Check if the word is on the exception list of words for which -s should not be stemmed.
	if (word.endsWith("s")) {
		const sShouldNotBeStemmed = morphologyData.sShouldNotBeStemmed;
		if (sShouldNotBeStemmed.includes(word)) {
			return word;
		}
	}

	// Check if the word is on the exception list of words for which -ent should not be stemmed.
	const nonVerbsOnEnt = morphologyData.nonVerbsOnEnt;
	if (word.endsWith("ent")) {
		if (nonVerbsOnEnt.includes(word)) {
			return word;
		}
	}
	if (word.endsWith("ents")) {
		if (nonVerbsOnEnt.includes(word.slice(0, -1))) {
			return word.slice(0, -1);
		}
	}

	// Check if word is on the exception list of nouns and adjectives for which the verb suffix -ons should not be stemmed.
	const nonVerbsOnOns = morphologyData.nonVerbsOnOns;
	if (word.endsWith("ons")) {
		if (nonVerbsOnOns.includes(word)) {
			return word.slice(0, -1);
		}
	}

	// Pre-processing steps
	word = (0, _regexHelpers$1.applyAllReplacements)(word, morphologyData.regularStemmer.preProcessingStepsRegexes);

	// Determine R1, R2 & RV regions.

	var _determineRs = determineRs$1(word, morphologyData.regularStemmer.rIntervals),
	    _determineRs2 = _slicedToArray(_determineRs, 3);

	const r1Index = _determineRs2[0],
	      r2Index = _determineRs2[1],
	      rvIndex = _determineRs2[2];

	/*
  * Step 1:
  * Remove standard suffixes
  */

	word = processStandardSuffixes(word, morphologyData.regularStemmer.standardSuffixes, r1Index, r2Index, rvIndex);
	const wordAfterStep1 = word;

	/*
  * Step 2a:
  * Stem verb suffixes beginning with "i"
  */
	const verbSuffixesStartingWithIRemoved = removeVerbSuffixesStartingWithI(word, originalWord, rvIndex, morphologyData.regularStemmer.verbSuffixesWithIBeginning);
	word = verbSuffixesStartingWithIRemoved.word;
	const step2aDone = verbSuffixesStartingWithIRemoved.step2aDone;

	/*
  * Step 2b:
  * Stem other verb suffixes
  */
	if (!nonVerbsOnEnt.includes(word)) {
		word = removeOtherVerbSuffixes(word, step2aDone, wordAfterStep1, r2Index, rvIndex, morphologyData);
	}

	if (originalWord === word.toLowerCase()) {
		/* Step 4:
   * Stem residual suffixes.
   */
		word = removeResidualSuffixes(word, rvIndex, r2Index, morphologyData.regularStemmer);
	} else {
		/*
   * Step 3 (only needs to be executed if step 4 isn't executed)
   * Replace final Y with i or final ç with c.
   */
		const yEnding = morphologyData.regularStemmer.yAndSoftCEndingAndReplacement.yEndingAndReplacement;
		const softCEnding = morphologyData.regularStemmer.yAndSoftCEndingAndReplacement.softCEndingAndReplacement;
		if (word.endsWith(yEnding[0])) {
			word = word.slice(0, -1) + yEnding[1];
		} else if (word.endsWith(softCEnding[0])) {
			word = word.slice(0, -1) + softCEnding[1];
		}
	}

	/* Step 5:
  * Undouble final consonants
  */
	word = (0, _regexHelpers$1.applyAllReplacements)(word, morphologyData.regularStemmer.finalConsonantUndoubling);

	/* Step 6:
  * Un-accent
  */
	const unaccentE = morphologyData.regularStemmer.unaccentERegex;
	word = word.replace(new RegExp(unaccentE[0]), unaccentE[1]);
	word = word.toLowerCase();

	const canonicalStem = canonicalizeStem$1(word, morphologyData.stemsThatBelongToOneWord);
	if (canonicalStem) {
		return canonicalStem;
	}

	return word;
}

var stem$l = {};

Object.defineProperty(stem$l, "__esModule", {
	value: true
});
stem$l.default = stem$k;
/**
 * MIT License
 *
 * Copyright (c) 2016 Alexander Kiryukhin
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * https://github.com/neonxp/Stemmer/blob/master/src/NXP/Stemmer.php
 */

/**
 * Checks if the input character is a Russian vowel.
 *
 * @param {string} char             The character to be checked.
 * @param {Object} morphologyData   The Russian morphology data.
 *
 * @returns {boolean} Whether the input character is a Russian vowel.
 */
const isVowel$4 = function isVowel(char, morphologyData) {
	return morphologyData.externalStemmer.vowels.includes(char);
};

/**
 * Determines the RV region of the word.
 *
 * @param {string} word             The word checked.
 * @param {Object} morphologyData   The Russian morphology data.

 *
 * @returns {int} The RV region index.
 */
const findRvRegion = function findRvRegion(word, morphologyData) {
	let rv = 0;
	let state = 0;
	const wordLength = word.length;

	for (let i = 1; i < wordLength; i++) {
		const prevChar = word.substring(i - 1, i);
		const char = word.substring(i, i + 1);
		switch (state) {
			case 0:
				if (isVowel$4(char, morphologyData)) {
					rv = i + 1;
					state = 1;
				}
				break;
			case 1:
				if (isVowel$4(prevChar, morphologyData) && isVowel$4(char, morphologyData)) {
					state = 2;
				}
				break;
			case 2:
				if (isVowel$4(prevChar, morphologyData) && isVowel$4(char, morphologyData)) {
					return rv;
				}
				break;
		}
	}

	return rv;
};

/**
 * Removes the endings from the word.
 *
 * @param {string}          word	The word to check.
 * @param {string|string[]} regex	The regex or a pair of regexes to match.
 * @param {int}             region	The word region
 *
 * @returns {string|null}	The word if the stemming rule could be applied or null otherwise.
 */
const removeEndings = function removeEndings(word, regex, region) {
	const prefix = word.substr(0, region);
	const ending = word.substr(prefix.length);

	let currentRegex;

	if (Array.isArray(regex)) {
		currentRegex = new RegExp(regex[0], "i");

		if (currentRegex.test(ending)) {
			word = prefix + ending.replace(currentRegex, "");
			return word;
		}

		currentRegex = new RegExp(regex[1], "i");
	} else {
		currentRegex = new RegExp(regex, "i");
	}

	if (currentRegex.test(ending)) {
		word = prefix + ending.replace(currentRegex, "");
		return word;
	}

	return null;
};

/**
 * Removes inflectional suffixes from the word.
 *
 * @param {string} word             The word to check.
 * @param {Object} morphologyData   The Russian morphology data.
 * @param {int}    rv               The word rv region.
 *
 * @returns {string}	The word after inflectional suffixes were removed.
 */
const removeInflectionalSuffixes = function removeInflectionalSuffixes(word, morphologyData, rv) {
	const removeDerivationalNounSuffix = removeEndings(word, morphologyData.externalStemmer.regexDerivationalNounSuffix, rv);
	if (removeDerivationalNounSuffix) {
		return removeDerivationalNounSuffix;
	}
	// Try to find a PERFECTIVE GERUND ending. If it exists, remove it and finalize the step.
	const removeGerundSuffixes = removeEndings(word, [morphologyData.externalStemmer.regexPerfectiveGerunds1, morphologyData.externalStemmer.regexPerfectiveGerunds2], rv);

	if (removeGerundSuffixes) {
		word = removeGerundSuffixes;
	} else {
		// If there is no PERFECTIVE GERUND ending then try removing a REFLEXIVE ending.
		const removeReflexiveSuffixes = removeEndings(word, morphologyData.externalStemmer.regexReflexives, rv);

		if (removeReflexiveSuffixes) {
			word = removeReflexiveSuffixes;
		}

		// Try to remove following endings (in this order): ADJECTIVAL, VERB, NOUN. If one of them is found the step is finalized.
		const regexAdjective = morphologyData.externalStemmer.regexAdjective;
		const removeParticipleSuffixes = removeEndings(word, morphologyData.externalStemmer.regexParticiple + regexAdjective, rv);
		const removeAdjectiveSuffixes = removeEndings(word, regexAdjective, rv);

		if (removeParticipleSuffixes) {
			word = removeParticipleSuffixes;
		} else if (removeAdjectiveSuffixes) {
			word = removeAdjectiveSuffixes;
		} else {
			const removeVerbalSuffixes = removeEndings(word, [morphologyData.externalStemmer.regexVerb1, morphologyData.externalStemmer.regexVerb2], rv);
			if (removeVerbalSuffixes) {
				word = removeVerbalSuffixes;
			} else {
				const removeNounSuffixes = removeEndings(word, morphologyData.externalStemmer.regexNoun, rv);
				if (removeNounSuffixes) {
					word = removeNounSuffixes;
				}
			}
		}
	}

	return word;
};

/**
 * Checks whether a word is in the full-form exception list and if so returns the canonical stem.
 *
 * @param {string} word	      The word to be checked.
 * @param {Object} exceptions The list of full-form exceptions to be checked in.
 *
 * @returns {null|string} The canonical stem or null if nothing was found.
 */
const checkWordInFullFormExceptions$1 = function checkWordInFullFormExceptions(word, exceptions) {
	for (const paradigm of exceptions) {
		if (paradigm[1].includes(word)) {
			return paradigm[0];
		}
	}
	return null;
};

/**
 * Returns a canonical stem for verbs with multiple stems.
 *
 * @param {string}  word                    The word to canonicalize.
 * @param {Array}   wordsWithMultipleStems  An array of arrays of stems belonging to one word.
 *
 * @returns {string} A canonical stem or the original word.
 */
const canonicalizeStems = function canonicalizeStems(word, wordsWithMultipleStems) {
	const multipleStems = wordsWithMultipleStems.find(stems => stems.includes(word));

	if (multipleStems) {
		return multipleStems[0];
	}

	return word;
};

/**
 * Stems russian words.
 *
 * @param {string} word             The word to stem.
 * @param {Object} morphologyData   The Russian morphology data.
 *
 * @returns {string}	The stemmed word.
 */
function stem$k(word, morphologyData) {
	// Check if word is in the doNotStemSuffix exception list.
	if (morphologyData.doNotStemSuffix.includes(word)) {
		return word;
	}

	// Check if the word is on the list of exceptions for which we listed all forms and the stem.
	const fullFormException = checkWordInFullFormExceptions$1(word, morphologyData.exceptionStemsWithFullForms);
	if (fullFormException) {
		return fullFormException;
	}

	const rv = findRvRegion(word, morphologyData);

	// Step 1: Remove inflectional suffixes if they are present in the word.
	word = removeInflectionalSuffixes(word, morphologyData, rv);

	// Step 2: If the word ends in "и", remove it.
	const removeIEnding = removeEndings(word, morphologyData.externalStemmer.regexI, rv);
	if (removeIEnding) {
		word = removeIEnding;
	}

	// Step 3: There can be one of three options:
	// 1. If the word ends in нн, remove the last letter.
	if (word.endsWith(morphologyData.externalStemmer.doubleN)) {
		word = word.substr(0, word.length - 1);
	}

	// 2. If the word ends in a SUPERLATIVE ending, remove it and then again the last letter if the word ends in "нн".
	const removeSuperlativeSuffixes = removeEndings(word, morphologyData.externalStemmer.regexSuperlative, rv);
	if (removeSuperlativeSuffixes) {
		word = removeSuperlativeSuffixes;
	}

	// 3. If the word ends in "ь", remove it.
	const removeSoftSignEnding = removeEndings(word, morphologyData.externalStemmer.regexSoftSign, rv);
	if (removeSoftSignEnding) {
		word = removeSoftSignEnding;
	}

	// Check if the stem is on the list of stems that belong to one word and if so, return the canonical stem.
	const canonicalizedStem = canonicalizeStems(word, morphologyData.stemsThatBelongToOneWord);
	if (canonicalizedStem) {
		return canonicalizedStem;
	}

	return word;
}

var stem$j = {};

Object.defineProperty(stem$j, "__esModule", {
	value: true
});
stem$j.default = stem$i;

var _createRulesFromMorphologyData$2 = createRulesFromMorphologyData$1;

/**
 * Determines whether a letter is a vowel.
 *
 * @param {string} letter           The letter that has to be checked.
 * @param {Object} morphologyData   The Italian morphology data file.
 *
 * @returns {boolean} True if the letter is a vowel.
 */
function isVowel$3(letter, morphologyData) {
	return morphologyData.externalStemmer.vowels.includes(letter);
}

/**
 * Determines the next position in a word that is a vowel.
 *
 * @param {string}  word            The word to be checked.
 * @param {Object}  morphologyData  The Italian morphology data file.
 * @param {number}  start           The position of the word where you start checking.
 *
 * @returns {number} The next position in a word that is a vowel, or the final position if no vowel is found.
 */
/* eslint-disable complexity */
/* eslint-disable max-statements */
/*
Copyright (c) 2012, Leonardo Fenu, Chris Umbel
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

function getNextVowelPos(word, morphologyData, start) {
	start = start + 1;
	const length = word.length;

	for (let i = start; i < length; i++) {
		if (isVowel$3(word[i], morphologyData)) {
			return i;
		}
	}

	return length;
}

/**
 * Determines the next position in a word that is a consonant.
 *
 * @param {string}  word            The word that has to be checked.
 * @param {Object}  morphologyData  The Italian morphology data file.
 * @param {number}  start           The position of the word where you start checking.
 *
 * @returns {number} The next position in a word that is a consonant, or the final position if no consonant is found.
 */
function getNextConsonantPos(word, morphologyData, start) {
	const length = word.length;

	for (let i = start; i < length; i++) {
		if (!isVowel$3(word[i], morphologyData)) {
			return i;
		}
	}

	return length;
}

/**
 * Checks whether a word ends in a suffix and if so it returns the suffix.
 *
 * @param {string}       word           The word that has to be checked.
 * @param {string[]}     suffixes       The suffixes that have to be checked.
 *
 * @returns {string}                    The suffix that the word ends in or an empty string if the word does not end in any of the suffixes.
 */
function endsinArr(word, suffixes) {
	for (let i = 0; i < suffixes.length; i++) {
		if (word.endsWith(suffixes[i])) {
			return suffixes[i];
		}
	}

	return "";
}

/**
 * Turns acute accents into grave ones.
 *
 * @param {string}  word            The word that has to be checked.
 * @param {Object}  morphologyData  The Italian morphology data file.
 *
 * @returns {string} The word with acute accents (e.g. é) replaced by grave ones (e.g. è).
 */
function replaceAcute(word, morphologyData) {
	const acuteReplacements = (0, _createRulesFromMorphologyData$2.createRulesFromMorphologyData)(morphologyData.externalStemmer.preProcessing.acuteReplacements, "gi");

	for (const acuteReplacement of acuteReplacements) {
		word = word.replace(acuteReplacement.reg, acuteReplacement.repl);
	}

	return word;
}

/**
 * Turns an i or u in between vowels into upper case.
 *
 * @param {string}  word            The word that has to be checked.
 * @param {Object}  morphologyData  The Italian morphology data file.
 *
 *  @returns {string} The word with either i or u turned into upper case.
 */
function vowelMarking(word, morphologyData) {
	return word.replace(new RegExp(morphologyData.externalStemmer.preProcessing.vowelMarking, "g"), (match, p1, p2, p3) => p1 + p2.toUpperCase() + p3);
}

/**
 * Pre-process the word for stemming by setting it to lower case and replacing some letters.
 *
 * @param {string} word            The word to pre-process.
 * @param {Object} morphologyData  The Italian morphology data file.
 *
 * @returns {string} The pre-processed word.
 */
function preProcess(word, morphologyData) {
	word = word.toLowerCase();
	word = replaceAcute(word, morphologyData);
	const quReplacement = (0, _createRulesFromMorphologyData$2.createSingleRuleFromMorphologyData)(morphologyData.externalStemmer.preProcessing.quReplacement, "g");
	word = word.replace(quReplacement.reg, quReplacement.repl);
	word = vowelMarking(word, morphologyData);

	return word;
}

/**
 * Determines R1, R2 and RV in the word.
 *
 * @param {string}  word            The word for which Rs have to be determined.
 * @param {Object}  morphologyData  The Italian morphology data file.
 *
 * @returns {{r2: number, rv: number, r1: number}} R1, R2 and RV in the word.
 */
const determineRs = function determineRs(word, morphologyData) {
	let r1 = word.length;
	let r2 = word.length;
	let rv = word.length;

	// R1 is the region after the first non-vowel following a vowel,
	for (let i = 0; i < word.length - 1 && r1 === word.length; i++) {
		if (isVowel$3(word[i], morphologyData) && !isVowel$3(word[i + 1], morphologyData)) {
			r1 = i + 2;
		}
	}

	// R2 is the region after the first non-vowel following a vowel in R1
	for (let i = r1; i < word.length - 1 && r2 === word.length; i++) {
		if (isVowel$3(word[i], morphologyData) && !isVowel$3(word[i + 1], morphologyData)) {
			r2 = i + 2;
		}
	}

	if (word.length > 3) {
		if (!isVowel$3(word[1], morphologyData)) {
			// If the second letter is a consonant, RV is the region after the next following vowel.
			rv = getNextVowelPos(word, morphologyData, 1) + 1;
		} else if (isVowel$3(word[0], morphologyData) && isVowel$3(word[1], morphologyData)) {
			// Or if the first two letters are vowels, RV is the region after the next consonant.
			rv = getNextConsonantPos(word, morphologyData, 2) + 1;
		} else {
			/*
    * Otherwise (consonant-vowel case) RV is the region after the third letter.
    * But RV is the end of the word if these positions cannot be found.
    */
			rv = 3;
		}
	}

	return { r1, r2, rv };
};

/**
 * Removes pronoun suffixes.
 *
 * @param {string}  word            The word from which suffixes have to be removed.
 * @param {Object}  morphologyData  The Italian morphology data file.
 * @param {string}  rvText          The content of the RV.
 *
 * @returns {string} The word without pronoun suffixes.
 */
const removePronounSuffixes = function removePronounSuffixes(word, morphologyData, rvText) {
	const foundSuffix = endsinArr(word, morphologyData.externalStemmer.pronounSuffixes.suffixes);

	if (foundSuffix !== "") {
		const foundSuffixPre1 = endsinArr(rvText.slice(0, -foundSuffix.length), morphologyData.externalStemmer.pronounSuffixes.preSuffixesGerund);
		const foundSuffixPre2 = endsinArr(rvText.slice(0, -foundSuffix.length), morphologyData.externalStemmer.pronounSuffixes.preSuffixesInfinitive);

		if (foundSuffixPre1 !== "") {
			word = word.slice(0, -foundSuffix.length);
		}
		if (foundSuffixPre2 !== "") {
			word = word.slice(0, -foundSuffix.length) + morphologyData.externalStemmer.pronounSuffixes.infinitiveCompletion;
		}
	}
	return word;
};

/**
 * Removes standard suffixes.
 *
 * @param {string}  word            The word from which standard suffixes have to be removed.
 * @param {Object}  morphologyData  The Italian morphology data file.
 * @param {string}  r2Text          The content of the R2.
 * @param {string}  r1Text          The content of the R1.
 * @param {string}  rvText          The content of the RV.
 *
 * @returns {string} The word without standard suffixes.
 */
const removeStandardSuffixes = function removeStandardSuffixes(word, morphologyData, r2Text, r1Text, rvText) {
	const regions = {
		r1: r1Text,
		r2: r2Text,
		rv: rvText
	};

	for (const suffixGroup of morphologyData.externalStemmer.standardSuffixes) {
		const foundSuffix = endsinArr(regions[suffixGroup.region], suffixGroup.suffixes);

		if (foundSuffix) {
			return word.slice(0, -foundSuffix.length) + suffixGroup.replacement;
		}
	}

	return word;
};

/**
 *  Removes verb suffixes.
 *
 * @param {string}  word            The word from which verb suffixes have to be removed.
 * @param {Object}  morphologyData  The Italian morphology data file.
 * @param {string}  rvText          The content of the RV.
 *
 * @returns {string} The word without verb suffixes.
 */
const removeVerbSuffixes = function removeVerbSuffixes(word, morphologyData, rvText) {
	const foundSuffix = endsinArr(rvText, morphologyData.externalStemmer.verbSuffixes);

	if (foundSuffix) {
		word = word.slice(0, -foundSuffix.length);
	}

	return word;
};

/**
 * Normalizes digraphs ch/gh to c/g.
 *
 * @param {string}  word    The word to normalize.
 * @param {Object}  morphologyData  The Italian morphology data file.
 * @param {string}  rvText          The content of the RV.
 *
 * @returns {string} The normalized word.
 */
const normalizeDigraphs = function normalizeDigraphs(word, morphologyData, rvText) {
	const digraphCh = morphologyData.externalStemmer.digraphNormalization.digraphCh;
	const digraphGh = morphologyData.externalStemmer.digraphNormalization.digraphGh;

	if (rvText.endsWith(digraphCh[0])) {
		word = word.slice(0, -digraphGh[0].length) + digraphCh[1];
	} else if (rvText.endsWith(digraphGh[0])) {
		word = word.slice(0, -digraphGh[0].length) + digraphGh[1];
	}

	return word;
};

/**
 * Returns a canonical stem for words with multiple stems.
 *
 * @param {string}  word                       The word to canonicalize.
 * @param {Object}  stemsThatBelongToOneWord   An object of arrays of stems belonging to one word.
 *
 * @returns {string} A canonicalized stem or the original word.
 */
const canonicalizeStem = function canonicalizeStem(word, stemsThatBelongToOneWord) {
	// Check the verbs list. The infinitive stem is always the canonical stem for verbs.
	for (const paradigm of stemsThatBelongToOneWord.verbsWithMultipleStems) {
		if (paradigm.includes(word)) {
			return paradigm[0];
		}
	}
	// Check the diminutives list.
	for (const paradigm of stemsThatBelongToOneWord.irregularDiminutives) {
		if (paradigm.includes(word)) {
			return paradigm[0];
		}
	}
};

/**
 * Checks whether a word is in the full-form exception list and if so returns the canonical stem.
 *
 * @param {string} word	      The word to be checked.
 * @param {Object} exceptions The list of full-form exceptions to be checked in.
 *
 * @returns {null|string} The canonical stem or null if nothing was found.
 */
const checkWordInFullFormExceptions = function checkWordInFullFormExceptions(word, exceptions) {
	for (const paradigm of exceptions) {
		if (paradigm[1].includes(word)) {
			return paradigm[0];
		}
	}
	return null;
};

/**
 * Stems Italian words.
 *
 * @param {string} word             The word to stem.
 * @param {Object} morphologyData   The Italian morphology data file.
 *
 * @returns {string}               The stemmed word.
 */
function stem$i(word, morphologyData) {
	// Check the exception list for irregular plural nouns and adjectives.
	const irregularPluralNounsAndAdjectives = checkWordInFullFormExceptions(word, morphologyData.irregularPluralNounsAndAdjectives);
	if (irregularPluralNounsAndAdjectives) {
		return irregularPluralNounsAndAdjectives;
	}
	// Start word pre-processing.
	word = preProcess(word, morphologyData);

	// Don't stem words that consist of less than 3 letters.
	if (word.length < 3) {
		return word;
	}

	// Determines r1 ,r2, rv.

	var _determineRs = determineRs(word, morphologyData);

	const r1 = _determineRs.r1,
	      r2 = _determineRs.r2,
	      rv = _determineRs.rv;

	// Determiners the content of r1, r2, and rv.

	let r1Text = word.substring(r1);
	let r2Text = word.substring(r2);
	let rvText = word.substring(rv);

	const originalWord = word;

	// Step 0: Attached pronoun removal.
	word = removePronounSuffixes(word, morphologyData, rvText);

	if (word !== originalWord) {
		r1Text = word.substring(r1);
		r2Text = word.substring(r2);
		rvText = word.substring(rv);
	}

	const wordAfter0 = word;

	// Step 1:  Standard suffix removal.
	word = removeStandardSuffixes(word, morphologyData, r2Text, r1Text, rvText);

	if (word !== wordAfter0) {
		rvText = word.substring(rv);
	}

	const wordAfter1 = word;

	// Step 2:  Verb suffix removal.
	if (wordAfter0 === wordAfter1) {
		word = removeVerbSuffixes(word, morphologyData, rvText);
	}

	rvText = word.substring(rv);

	// Always do step 3.
	let foundSuffix = "";

	// Remove general suffixes.
	if ((foundSuffix = endsinArr(rvText, morphologyData.externalStemmer.generalSuffixes)) !== "") {
		word = word.slice(0, -foundSuffix.length);
	}

	rvText = word.substring(rv);

	// Normalize digraphs ch/gh.
	word = normalizeDigraphs(word, morphologyData, rvText);

	// Returns a canonical stem for words with multiple stems (e.g., verbs: chiudere–chiuso; diminutives: ovetto-uovo).
	const canonicalStem = canonicalizeStem(word, morphologyData.stemsThatBelongToOneWord);
	if (canonicalStem) {
		return canonicalStem;
	}
	return word.toLowerCase();
}

var stem$h = {};

Object.defineProperty(stem$h, "__esModule", {
	value: true
});
stem$h.default = stem$g;

var _findMatchingEndingInArray = findMatchingEndingInArray$1;

/**
 * Checks whether the character is a vowel.
 *
 * @param {string}	    character	The character to check.
 * @param {string[]}    vowels      The Portuguese vowels.
 *
 * @returns {boolean}	Whether the character is a vowel.
 */
const isVowel$2 = function isVowel(character, vowels) {
	return vowels.includes(character);
};

/**
 * Finds the first vowel in a string after the specified index and returns the index of the character following that vowel
 * (if found).
 *
 * @param {string}	    word	        The word to check.
 * @param {string[]}    vowels          The Portuguese vowels.
 * @param {number}	    [start=0]       The index at which the search for a vowel should begin.
 *
 * @returns {number} The index of the character following the found vowel. If this is not found, the length of the word.
 */
/* eslint-disable max-statements, complexity */

/*
Copyright (c) 2015, Luís Rodrigues
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

const nextVowelPosition = function nextVowelPosition(word, vowels, start = 0) {
	const length = word.length;

	for (let position = start; position < length; position++) {
		if (isVowel$2(word[position], vowels)) {
			return position;
		}
	}

	return length;
};

/**
 * Finds the first consonant in a string after the specified index and returns the index of the character following that
 * consonant (if found).
 *
 * @param {string}	    word	    The word to check.
 * @param {string[]}    vowels      The Portuguese vowels.
 * @param {number}	    [start=0]	The index at which the search for a consonant should begin.
 *
 * @returns {number} The index of the character following the found consonant. If this is not found, the length of the word.
 */
const nextConsonantPosition = function nextConsonantPosition(word, vowels, start = 0) {
	const length = word.length;

	for (let position = start; position < length; position++) {
		if (!isVowel$2(word[position], vowels)) {
			return position;
		}
	}

	return length;
};

/**
 * Replaces characters with other characters if found in a word.
 *
 * @param {string}		word				The word to check.
 * @param {string[]}	charactersToReplace	The characters to replace.
 * @param {string[]}	replacements		The replacement characters.
 *
 * @returns {string}	The word with the replacement characters, or the original word if no characters to replace were found.
 */
const replaceCharacters = function replaceCharacters(word, charactersToReplace, replacements) {
	for (let i = 0; i < charactersToReplace.length; i++) {
		word = word.replace(charactersToReplace[i], replacements[i]);
	}

	return word;
};

/**
 * Looks for the longest suffix in each group and removes it if it is found within the specified region (R1, R2 or RV).
 * Once a suffix is found and removed, stops searching further.
 *
 * For some of the suffix groups, replaces the suffix with another string after removing it (e.g. -logia is replaced with
 * -log).
 *
 * @param {string}	word	            The word to check.
 * @param {Object}  standardSuffixData  The data for stemming standard suffixes.
 * @param {string}	r1Text	            The text in the R1 region.
 * @param {string}	r2Text	            The text in the R2 region.
 * @param {string}	rvText	            The text in the RV region.
 *
 * @returns {string} The stemmed word or the original word if no suffix was removed.
 */
const stemStandardSuffixes = function stemStandardSuffixes(word, standardSuffixData, r1Text, r2Text, rvText) {
	const regions = {
		r1: r1Text,
		r2: r2Text,
		rv: rvText
	};

	for (const suffixGroup of standardSuffixData.standardGroups) {
		const foundSuffix = (0, _findMatchingEndingInArray.findMatchingEndingInArray)(regions[suffixGroup.region], suffixGroup.suffixes);

		if (foundSuffix) {
			return word.slice(0, -foundSuffix.length) + suffixGroup.replacement;
		}
	}

	const specialEnding = (0, _findMatchingEndingInArray.findMatchingEndingInArray)(regions[standardSuffixData.specialClass.region], standardSuffixData.specialClass.suffixes);
	if ((0, _findMatchingEndingInArray.findMatchingEndingInArray)(word, standardSuffixData.specialClass.wordEndingsToCheck) && specialEnding) {
		word = word.slice(0, -specialEnding.length) + standardSuffixData.specialClass.replacement;
	}

	return word;
};

/**
 * Stems verb suffixes.
 *
 * @param {string}      word            The original word.
 * @param {string[]}    verbSuffixes    The verb suffixes to check.
 * @param {string}      rvText          The text of the RV.
 *
 * @returns {string} The word with the verb suffixes removed (if applicable).
 */
const stemVerbSuffixes = function stemVerbSuffixes(word, verbSuffixes, rvText) {
	const verbSuffix = (0, _findMatchingEndingInArray.findMatchingEndingInArray)(rvText, verbSuffixes);

	if (verbSuffix !== "") {
		word = word.slice(0, -verbSuffix.length);
	}

	return word;
};

/**
 * Stems residual suffixes.
 *
 * @param {string}	word	            The word to check.
 * @param {Object}  residualSuffixData  The data used to stem residual suffixes.
 * @param {string}	rvText	            The text in the RV region.
 *
 * @returns {string} The word with a removed suffix, or the original input word if no suffix was removed.
 */
const stemResidualSuffixes = function stemResidualSuffixes(word, residualSuffixData, rvText) {
	const foundSuffixUe = (0, _findMatchingEndingInArray.findMatchingEndingInArray)(rvText, residualSuffixData.groupUe.suffixes);
	const foundSuffixIe = (0, _findMatchingEndingInArray.findMatchingEndingInArray)(rvText, residualSuffixData.groupIe.suffixes);
	const foundSuffixE = (0, _findMatchingEndingInArray.findMatchingEndingInArray)(rvText, residualSuffixData.groupESuffixes);

	if (foundSuffixUe && (0, _findMatchingEndingInArray.findMatchingEndingInArray)(word, residualSuffixData.groupUe.wordEndingsToCheck)) {
		word = word.slice(0, -foundSuffixUe.length);
	} else if (foundSuffixIe && (0, _findMatchingEndingInArray.findMatchingEndingInArray)(word, residualSuffixData.groupIe.wordEndingsToCheck)) {
		word = word.slice(0, -foundSuffixIe.length);
	} else if (foundSuffixE) {
		word = word.slice(0, -foundSuffixE.length);
	} else if (word.endsWith(residualSuffixData.cCedilla[0])) {
		word = word.slice(0, -1) + residualSuffixData.cCedilla[1];
	}

	return word;
};

/**
 * Stems Portuguese words.
 *
 * @param {string} word             The word to stem.
 * @param {Object} morphologyData   The Portuguese morphology data.
 *
 * @returns {string} The stemmed word.
 */
function stem$g(word, morphologyData) {
	word.toLowerCase();
	const vowels = morphologyData.externalStemmer.vowels;

	// Nasal vowels should be treated as a vowel followed by a consonant.
	const nasalVowels = morphologyData.externalStemmer.nasalVowels.originals;
	const nasalVowelsReplacement = morphologyData.externalStemmer.nasalVowels.replacements;
	word = replaceCharacters(word, nasalVowels, nasalVowelsReplacement);

	const length = word.length;
	if (length < 2) {
		return word;
	}

	let r1 = length;
	let r2 = length;
	let rv = length;

	/*
  * R1 is the region after the first non-vowel following a vowel, or is the null region at the end of the word if
  * there is no such non-vowel.
  */
	for (let i = 0; i < length - 1 && r1 === length; i++) {
		if (isVowel$2(word[i], vowels) && !isVowel$2(word[i + 1], vowels)) {
			r1 = i + 2;
		}
	}

	/*
  * R2 is the region after the first non-vowel following a vowel in R1, or is the null region at the end of the
  * word if there is no such non-vowel.
  */
	for (let i = r1; i < length - 1 && r2 === length; i++) {
		if (isVowel$2(word[i], vowels) && !isVowel$2(word[i + 1], vowels)) {
			r2 = i + 2;
		}
	}

	/*
  * If the second letter is a consonant, RV is the region after the next following vowel. If the first two letters are
  * vowels, RV is the region after the next consonant, and otherwise (consonant-vowel case) RV is the region after the
  * third letter. But RV is the end of the word if these positions cannot be found.
  */
	if (length > 3) {
		if (!isVowel$2(word[1], vowels)) {
			rv = nextVowelPosition(word, vowels, 2) + 1;
		} else if (isVowel$2(word[0], vowels) && isVowel$2(word[1], vowels)) {
			rv = nextConsonantPosition(word, vowels, 2) + 1;
		} else {
			rv = 3;
		}
	}

	const r1Text = word.slice(r1);
	const r2Text = word.slice(r2);
	let rvText = word.slice(rv);

	// Go through the first step of removing suffixes.
	const wordAfterStep1 = stemStandardSuffixes(word, morphologyData.externalStemmer.standardSuffixes, r1Text, r2Text, rvText);

	// If no suffixes were removed in the first step, search for and remove verb suffixes.
	let wordAfterStep2 = "";

	if (word === wordAfterStep1) {
		wordAfterStep2 = stemVerbSuffixes(word, morphologyData.externalStemmer.verbSuffixes, rvText);
	}

	// If suffixes were removed in one of the previous steps, replace the word with the de-suffixed word and adjust RV text.
	if (word !== wordAfterStep1) {
		word = wordAfterStep1;
		rvText = word.slice(rv);
	} else if (word !== wordAfterStep2) {
		word = wordAfterStep2;
		rvText = word.slice(rv);
	}

	/*
  * If a suffix was removed in one of the two previous steps, remove -i if preceded by -c and in RV. If no suffix was
  * removed in one of the previous steps, remove -os, -a, -i, -o, -á, í, or ó if in RV.
  */
	if (wordAfterStep1 !== word || wordAfterStep2 !== word) {
		if (word.endsWith(morphologyData.externalStemmer.ciToC[0]) && rvText.endsWith(morphologyData.externalStemmer.ciToC[1])) {
			word = word.slice(0, -1);
			rvText = word.slice(rv);
		}
	} else {
		const foundGeneralSuffix = (0, _findMatchingEndingInArray.findMatchingEndingInArray)(rvText, morphologyData.externalStemmer.generalSuffixes);
		if (foundGeneralSuffix !== "") {
			word = word.slice(0, -foundGeneralSuffix.length);
			rvText = word.slice(rv);
		}
	}

	// Stem residual suffixes, regardless of whether a suffix was removed in any of the previous steps or not.
	word = stemResidualSuffixes(word, morphologyData.externalStemmer.residualSuffixes, rvText);

	// Change the nasal vowel replacements back into the nasal vowels.
	word = replaceCharacters(word, nasalVowelsReplacement, nasalVowels);

	return word;
}

var stem$f = {};

var helpers$2 = {};

Object.defineProperty(helpers$2, "__esModule", {
  value: true
});
helpers$2.calculateTotalNumberOfSyllables = calculateTotalNumberOfSyllables;
helpers$2.removeEnding = removeEnding;
helpers$2.checkBeginningsList = checkBeginningsList;

var _buildFormRule$1 = buildFormRule;

var _createRulesFromMorphologyData$1 = createRulesFromMorphologyData$1;

var _createRulesFromMorphologyData2$1 = _interopRequireDefault$2x(_createRulesFromMorphologyData$1);

function _interopRequireDefault$2x(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const vowelCharacters = ["a", "e", "i", "o", "u"];

/**
 * Determines if an input character is a vowel.
 *
 * @param {string} character The character to check.
 *
 * @returns {boolean} Whether the input character is an Indonesian vowel.
 */
function isVowel$1(character) {
  return vowelCharacters.includes(character);
}

/**
 * Calculates the total number of syllables in the input word.
 *
 * @param {string} word The word to calculate the number of syllables in.
 *
 * @returns {int} The total number of syllables in the word.
 */
function calculateTotalNumberOfSyllables(word) {
  let result = 0;

  for (let i = 0; i < word.length; i++) {
    if (isVowel$1(word[i])) {
      result++;
    }
  }

  return result;
}

/**
 * Stems the ending of a word based on some regexRules after checking if the word is in the exception list.
 *
 * @param {string} word         The word to stem.
 * @param {Array} regexRules    The list of regex-based rules to apply to the word in order to stem it.
 * @param {string[]} exceptions The list of words that should not get the ending removed.
 * @param {Object} morphologyData The Indonesian morphology data file
 *
 * @returns {string} The stemmed word.
 */
function removeEnding(word, regexRules, exceptions, morphologyData) {
  if (exceptions.includes(word)) {
    return word;
  }

  // Check words ending in -kan whether they are words whose stem ending in -k that get suffix -an or not.
  const wordsWithKEnding = morphologyData.stemming.doNotStemWords.doNotStemK;
  if (word.endsWith("kan")) {
    const wordWithoutSuffixAn = word.substring(0, word.length - 2);
    // If a word has stem ending -k and gets suffix -an, then only stem -an here.
    if (wordsWithKEnding.includes(wordWithoutSuffixAn)) {
      word = wordWithoutSuffixAn;
    }
  }

  const removePartRegex = (0, _createRulesFromMorphologyData2$1.default)(regexRules);
  const withRemovedPart = (0, _buildFormRule$1.buildOneFormFromRegex)(word, removePartRegex);
  return withRemovedPart || word;
}

/**
 * Checks if the beginning of the word is present in an exception list.
 *
 * @param {string}   word         The word to stem.
 * @param {int}      prefixLength The length of the prefix to be trimmed before checking in the list.
 * @param {string[]} beginnings   The list of word beginnings that should be checked.
 *
 * @returns {boolean} Whether the word is found in the list with beginnings.
 */
function checkBeginningsList(word, prefixLength, beginnings) {
  const wordWithoutPrefix = word.slice(prefixLength);
  return beginnings.some(beginning => wordWithoutPrefix.startsWith(beginning));
}

Object.defineProperty(stem$f, "__esModule", {
	value: true
});
stem$f.default = stem$e;

var _buildFormRule = buildFormRule;

var _createRulesFromMorphologyData = createRulesFromMorphologyData$1;

var _createRulesFromMorphologyData2 = _interopRequireDefault$2w(_createRulesFromMorphologyData);

var _flattenSortLength = flattenSortLength$1;

var _helpers$1 = helpers$2;

function _interopRequireDefault$2w(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * MIT License
 *
 * Adapted from: Copyright (c) 2013 Adinda Praditya
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software
 * and associated documentation files (the \"Software\"), to deal in the Software without restriction,
 * including without limitation the rights to use, copy, modify, merge, publish,  distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND,  EXPRESS OR IMPLIED,
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE."
 */

/**
 * Checks if a single syllable word has one of the suffixes/suffix combination.
 *
 * @param {string} word The word to check.
 * @param {Array} suffixesArray The array of suffixes
 * @returns {boolean}   Whether the word ends in one of the suffixes or not.
 */
const checkSingleSyllableWordSuffix = function checkSingleSyllableWordSuffix(word, suffixesArray) {
	for (const suffix of suffixesArray) {
		if (word.match(suffix)) {
			return true;
		}
	}
};

/**
 * Stems the prefix of the single syllable words, i.e. di-/penge-/menge-
 *
 * @param {string}	word			The word to check.
 * @param {Object}	morphologyData	The Indonesian morphology data file.
 *
 * @returns {string} The stemmed word.
 */
const stemSingleSyllableWordsPrefixes = function stemSingleSyllableWordsPrefixes(word, morphologyData) {
	// If the word gets prefix di-, stem the prefix here. E.g. dicekkanlah -> cekkanlah, dibomi -> bomi
	if (word.startsWith("di") && (0, _helpers$1.checkBeginningsList)(word, 2, morphologyData.stemming.singleSyllableWords)) {
		return word.substring(2, word.length);
	}
	/*
  * If the word gets prefix menge-/penge- and is followed by one of the words in the list, stem the prefix here.
  * E.g. pengeboman -> boman
  */
	if (/^[mp]enge/i.test(word) && (0, _helpers$1.checkBeginningsList)(word, 5, morphologyData.stemming.singleSyllableWords)) {
		return word.substring(5, word.length);
	}
	return word;
};

/**
 * Stems Indonesian single syllable words. This function concerns single syllable words
 * with this possible word format [di/penge/menge] + single syllable word + [kan/an/i] + [ku/mu/nya] + [kah/lah/pun], with [] being optional.
 * E.g. dipel -> pel, dipelkan -> pel, dipelkanlah -> pel, pelkan -> pel, pelmulah -> pel, pengeboman -> bom, mengesahkan -> sah
 *
 *
 * @param {string}	word			The word to check.
 * @param {Object}	morphologyData	The Indonesian morphology data file.
 *
 * @returns {string} The stemmed word.
 */
const stemSingleSyllableWords = function stemSingleSyllableWords(word, morphologyData) {
	const singleSyllableWords = morphologyData.stemming.singleSyllableWords;
	const suffixCombination = morphologyData.stemming.singleSyllableWordsSuffixes;
	const inputWord = word;
	// If the word starts with prefix di-/penge-/menge-, stem the prefix here. E.g. pengeboman -> boman, dipelkan -> pelkan
	word = stemSingleSyllableWordsPrefixes(word, morphologyData);

	// Check if a word starts with one of the words in the list, has maximum 3 syllables, and ends in one of the single syllable suffixes
	if (singleSyllableWords.some(shortWord => word.startsWith(shortWord)) && (0, _helpers$1.calculateTotalNumberOfSyllables)(word) <= 3 && checkSingleSyllableWordSuffix(word, suffixCombination)) {
		// If the word gets a particle suffix, stem the particle. E.g. cekkanlah -> cekkan, pelkan -> pel, vasmulah -> vasmu
		word = (0, _helpers$1.removeEnding)(word, morphologyData.stemming.regexRules.removeParticle, morphologyData.stemming.doNotStemWords.doNotStemParticle, morphologyData);

		// If the word gets a possessive pronoun suffix, stem the possessive pronoun. E.g. vasmu -> vas
		word = (0, _helpers$1.removeEnding)(word, morphologyData.stemming.regexRules.removePronoun, morphologyData.stemming.doNotStemWords.doNotStemPronounSuffix, morphologyData);

		// If the word ends in -kan/-an/-i suffix, stem the suffix. E.g. cekkan -> cek, bomi -> bom
		const wordWithoutDerivationalSuffix = (0, _helpers$1.removeEnding)(word, morphologyData.stemming.regexRules.removeSuffixes, morphologyData.stemming.doNotStemWords.doNotStemSuffix, morphologyData);

		if (singleSyllableWords.includes(wordWithoutDerivationalSuffix)) {
			word = wordWithoutDerivationalSuffix;
		}
	}
	/*
  * We only want to stem single syllable words here.
  * Thus, if the output word has more than one syllable, we don't stem the input word at all.
  */
	if ((0, _helpers$1.calculateTotalNumberOfSyllables)(word) > 1 || word.length === 1) {
		word = inputWord;
	}
	return word;
};

/**
 * Tries stemming prefixes ke- and ter-. Ke- is always stemmed, and ter- only if it is a prefix and not part of the stem.
 * Also if the stem of the word begins with r-, only te- is stemmed, not ter-.
 *
 * @param {Object}	morphologyData	The Indonesian morphology data file.
 * @param {string}	word			The word to check.
 *
 * @returns {string|null}	The stem or null if the word did not start with ter/keter.
 */
const tryStemmingKeAndTer = function tryStemmingKeAndTer(morphologyData, word) {
	const terException = morphologyData.stemming.doNotStemWords.doNotStemPrefix.doNotStemFirstOrderPrefix.doNotStemTer;

	// If prefix -ter is preceded by prefix -ke, remove it first.
	if (word.startsWith("keter")) {
		word = word.substring(2, word.length);
	}
	if (word.startsWith("ter")) {
		// If word is on an exception list of words where -ter should not be stemmed, do not stem -ter and return the word.
		if (terException.some(wordWithTer => word.startsWith(wordWithTer))) {
			return word;
		}
		// If word (without prefixes) is on the list of words beginning with -r, remove only -te instead of -ter.
		if ((0, _helpers$1.checkBeginningsList)(word, 3, morphologyData.stemming.beginningModification.rBeginning)) {
			return word.replace(/^ter/i, "r");
		}
		// Otherwise, remove -ter.
		return word.substring(3, word.length);
	}
};
/**
 * Checks whether a word has a first order prefix and whether it is on an exception list of words which require a stem mofification
 * after removing the prefix. Returns the stem if the prefix was found and the word was matched on an exception list.
 *
 *
 * @param {string}	word			The word to check.
 * @param {Object}	morphologyData	The Indonesian morphology data file.
 *
 * @returns {string|null}	The stem or null if a prefix was not found, or was found but the word was not on the exception list.
 */
const checkFirstOrderPrefixExceptions = function checkFirstOrderPrefixExceptions(word, morphologyData) {
	const beginningModification = morphologyData.stemming.beginningModification;

	// If a word starts with "men" or "pen" and is present in the nBeginning exception list, the prefix should be replaced with "n".
	if (/^[mp]en/i.test(word)) {
		if ((0, _helpers$1.checkBeginningsList)(word, 3, beginningModification.nBeginning)) {
			return word.replace(/^[mp]en/i, "n");
		}
	}
	if (/^[mp]eng/i.test(word) && (0, _helpers$1.checkBeginningsList)(word, 4, beginningModification.kBeginning)) {
		return word.replace(/^[mp]eng/i, "k");
	}

	if (/^[mp]em/i.test(word)) {
		if ((0, _helpers$1.checkBeginningsList)(word, 3, beginningModification.pBeginning)) {
			return word.replace(/^(mem|pem)/i, "p");
		} else if ((0, _helpers$1.checkBeginningsList)(word, 3, beginningModification.mBeginning)) {
			return word.replace(/^(mem|pem)/i, "m");
		}
	}
	// Stem prefix ke- if found. Stem te(r)- unless the word was found on the exception list of words with stem beginning in -ter.
	const wordAfterKeTerCheck = tryStemmingKeAndTer(morphologyData, word);
	if (wordAfterKeTerCheck) {
		return wordAfterKeTerCheck;
	}
};

/**
 * Stems the first-order prefix of a word based on regexRules. If the word is found in an exception list, implements a stem modification.
 *
 * @param {string} word           The word to stem.
 * @param {Object} morphologyData The object that contains regex-based rules and exception lists for Indonesian stemming.
 *
 * @returns {string} The stemmed word.
 */
const removeFirstOrderPrefix = function removeFirstOrderPrefix(word, morphologyData) {
	// Checks whether the word has a first order prefix and requires a stem modification.
	const firstOrderPrefixException = checkFirstOrderPrefixExceptions(word, morphologyData);

	if (firstOrderPrefixException) {
		return firstOrderPrefixException;
	}
	const regex = (0, _createRulesFromMorphologyData2.default)(morphologyData.stemming.regexRules.removeFirstOrderPrefixes);
	const withRemovedFirstOrderPrefix = (0, _buildFormRule.buildOneFormFromRegex)(word, regex);

	return withRemovedFirstOrderPrefix || word;
};

/**
 * Stems the second-order prefix of a word based on regexRules. If the word is found in an exception list, implements a stem modification.
 *
 * @param {string} word           The word to stem.
 * @param {Object} morphologyData The object that contains regex-based rules and exception lists for Indonesian stemming.
 *
 * @returns {string} The stemmed word.
 */
const removeSecondOrderPrefix = function removeSecondOrderPrefix(word, morphologyData) {
	// If a word starts with "ber" or "per" and is present in the rBeginning exception list, the prefix should be replaced with "r".
	if ((word.startsWith("ber") || word.startsWith("per")) && (0, _helpers$1.checkBeginningsList)(word, 3, morphologyData.stemming.beginningModification.rBeginning)) {
		return word.replace(/^(ber|per)/i, "r");
	}
	// If a word starts with a first order prefix followed by peng- and is in the kBeginning exception list, then peng- should be replaced with k.
	if (/^peng/i.test(word) && (0, _helpers$1.checkBeginningsList)(word, 4, morphologyData.stemming.beginningModification.kBeginning)) {
		return word.replace(/^peng/i, "k");
	}
	const regex = (0, _createRulesFromMorphologyData2.default)(morphologyData.stemming.regexRules.removeSecondOrderPrefixes);
	const withRemovedSecondOrderPrefix = (0, _buildFormRule.buildOneFormFromRegex)(word, regex);

	return withRemovedSecondOrderPrefix || word;
};

/**
 * Stems derivational affixes of Indonesian words.
 *
 * @param {string} word           The word to stem.
 * @param {Object} morphologyData The object that contains regex-based rules and exception lists for Indonesian stemming.
 *
 * @returns {string} The stemmed word.
 */
const stemDerivational = function stemDerivational(word, morphologyData) {
	let wordLength = word.length;
	const removeSuffixRules = morphologyData.stemming.regexRules.removeSuffixes;
	const removeSuffixExceptions = morphologyData.stemming.doNotStemWords.doNotStemSuffix;
	const doNotStemFirstOrderPrefix = (0, _flattenSortLength.flattenSortLength)(morphologyData.stemming.doNotStemWords.doNotStemPrefix.doNotStemFirstOrderPrefix);
	const doNotStemSecondOrderPrefix = (0, _flattenSortLength.flattenSortLength)(morphologyData.stemming.doNotStemWords.doNotStemPrefix.doNotStemSecondOrderPrefix);

	// If a word is in the list of words with a beginning that looks like a valid suffix, do not stem the suffix
	if (!doNotStemFirstOrderPrefix.some(wordWithPrefixLookAlike => word.startsWith(wordWithPrefixLookAlike))) {
		/**
   * If the word has more than 2 syllables and starts with one of first order prefixes (i.e. meng-, meny-, men-, mem-, me-,
   * peng-, peny-, pen-, pem-, di-, ter-, ke- ), the prefix will be stemmed here. e.g. penyebaran -> sebaran, diperlebarkan -> perlebarkan
   */
		word = removeFirstOrderPrefix(word, morphologyData);
	}

	if (wordLength === word.length) {
		if (!doNotStemSecondOrderPrefix.some(wordWithPrefixLookAlike => word.startsWith(wordWithPrefixLookAlike))) {
			/**
    * If the word does not start with one of the first order prefixes but starts with one of the second order prefixes,
    * the prefix will be stemmed here, e.g., peranakan -> anakan
    */
			word = removeSecondOrderPrefix(word, morphologyData);
		}
		// If the word has more than 2 syllables and ends in either -kan, -an, or -i suffixes, the suffix will be deleted here, e.g., anakan -> anak
		if ((0, _helpers$1.calculateTotalNumberOfSyllables)(word) > 2) {
			word = (0, _helpers$1.removeEnding)(word, removeSuffixRules, removeSuffixExceptions, morphologyData);
		}
	} else {
		// If the word previously had a first order prefix, assign wordLength to the length of the word after prefix deletion.
		wordLength = word.length;
		/**
   * If the word after first order prefix deletion is bigger than 2 and ends in either -kan, -an, or -i suffixes,
   * the suffix will be stemmed here. e.g. penyebaran - sebar.
   */
		if ((0, _helpers$1.calculateTotalNumberOfSyllables)(word) > 2) {
			word = (0, _helpers$1.removeEnding)(word, removeSuffixRules, removeSuffixExceptions, morphologyData);
		}
		/**
   * If the word previously had a suffix, we check further if the word after first order prefix and suffix deletion has more than 2 syllables.
   * If it does have more than 2 syllables and starts with one of the second order prefixes (i.e. ber-, be-, per-, pe-), the prefix will
   * be stemmed here unless the word is in the exception list of words with a beginning that looks like a second order prefix.
   */
		if (wordLength !== word.length && !doNotStemSecondOrderPrefix.includes(word)) {
			if ((0, _helpers$1.calculateTotalNumberOfSyllables)(word) > 2) {
				word = removeSecondOrderPrefix(word, morphologyData);
			}
		}
	}
	return word;
};

/**
 * Stems Indonesian singular words.
 *
 * @param {string} word           The singular word to stem.
 * @param {Object} morphologyData The object that contains regex-based rules and exception lists for Indonesian stemming.
 *
 * @returns {string} The stem of an Indonesian singular word.
 */
const stemSingular = function stemSingular(word, morphologyData) {
	const singleSyllableWords = stemSingleSyllableWords(word, morphologyData);
	// Stem the single syllable words
	word = singleSyllableWords;

	const doNotStemParticle = morphologyData.stemming.doNotStemWords.doNotStemParticle;
	const doNotStemPronoun = morphologyData.stemming.doNotStemWords.doNotStemPronounSuffix;

	if ((0, _helpers$1.calculateTotalNumberOfSyllables)(word) <= 2) {
		return word;
	}

	// Check if a word after its derivational affixes stemmed exists in the exception list.
	const firstDerivationalStem = stemDerivational(word, morphologyData);
	if (doNotStemParticle.includes(firstDerivationalStem) || doNotStemPronoun.includes(firstDerivationalStem)) {
		// If it does exist in the exception list, the ending that looks like a particle or a pronoun suffix should not be stemmed.
		return firstDerivationalStem;
	}

	/**
  * If the word has more than 2 syllables and ends in of the particle endings (i.e. -kah, -lah, -pun), stem the particle here.
  * e.g. bajumulah -> bajumu, bawalah -> bawa
  */
	word = (0, _helpers$1.removeEnding)(word, morphologyData.stemming.regexRules.removeParticle, doNotStemParticle, morphologyData);

	// If the word (still) has more than 2 syllables and ends in of the possessive pronoun endings (i.e. -ku, -mu, -nya), stem the ending here.
	if ((0, _helpers$1.calculateTotalNumberOfSyllables)(word) > 2) {
		// E.g. bajumu -> baju
		word = (0, _helpers$1.removeEnding)(word, morphologyData.stemming.regexRules.removePronoun, doNotStemPronoun, morphologyData);
	}

	// If the word (still) has more than 2 syllables and has derivational affixes, the affix(es) will be stemmed here.
	if ((0, _helpers$1.calculateTotalNumberOfSyllables)(word) > 2) {
		word = stemDerivational(word, morphologyData);
	}
	return word;
};

/**
 * Stems Indonesian plural words.
 *
 * @param {string} word           The plural word to stem.
 * @param {Object} morphologyData The object that contains regex-based rules and exception lists for Indonesian stemming.
 *
 * @returns {string|null} The stem of an Indonesian plural word or null if no plural was detected.
 */
const stemPlural = function stemPlural(word, morphologyData) {
	const hyphenIndex = word.indexOf("-");

	// If there is no hyphen in the word, it can't be a reduplicated plural.
	if (hyphenIndex === -1) {
		return null;
	}

	const splitWord = word.split("-");

	if (splitWord.length === 2) {
		let firstPart = splitWord[0];
		let secondPart = splitWord[1];

		firstPart = stemSingular(firstPart, morphologyData);
		secondPart = stemSingular(secondPart, morphologyData);

		/*
   * To compare the first and second part and see whether it's actually a reduplication:
   * Trim the beginning of the word since it might be variable due to stem changes caused by prefixes.
   * For example, in "meniru-nirukan" the singular stemmer will correctly stem the first "niru" to "tiru" because
   * of the prefix "me". Since the second part of the word is stemmed individually, there is no "me" and hence
   * "niru" remains "niru". To still be able to link these two forms to each other,
   * we compare the two parts of the word after stripping the variable first or first and second letter.
   *
   */
		const firstPartBeginningTrimmed = firstPart.substr(1);
		const secondPartBeginningTrimmed = secondPart.startsWith("ng") || secondPart.startsWith("ny") ? secondPart.substr(2) : secondPart.substr(1);

		if (firstPartBeginningTrimmed === secondPartBeginningTrimmed) {
			const nonPlurals = morphologyData.stemming.nonPluralReduplications;

			// Check non-plural reduplication.
			if (nonPlurals.includes(firstPart) && nonPlurals.includes(secondPart)) {
				/*
     * In words such as "mengira-ngira" prefix "me" causes a modification on both words (k->ng). This will
     * be correctly stemmed for the first word, but not the second. Therefore, the correct base form
     * "kira-kira" is created based on a reduplication of the correctly stemmed first part, "kira".
     */
				return firstPart + "-" + firstPart;
			}

			// Return the stemmed singular form of a reduplicated plural.
			return firstPart;
		}
	}

	return null;
};

/**
 * Stems Indonesian words
 *
 * @param {string} word           The word to stem.
 * @param {Object} morphologyData The object that contains regex-based rules and exception lists for Indonesian stemming.
 *
 * @returns {string} The stem of an Indonesian word.
 */
function stem$e(word, morphologyData) {
	// Check words that shouldn't receive any stemming.
	if (morphologyData.stemming.shouldNotBeStemmed.includes(word)) {
		return word;
	}

	const stemmedPlural = stemPlural(word, morphologyData);

	if (stemmedPlural) {
		return stemmedPlural;
	}

	word = stemSingular(word, morphologyData);

	return word;
}

var stem$d = {};

Object.defineProperty(stem$d, "__esModule", {
	value: true
});
stem$d.default = stem$c;
/**
 * Copyright (c) 2017 Błażej Kubiński
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Loops through an array of word endings and returns the longest ending that was matched at the end of the word.
 *
 * @param {string}      word       The word to check.
 * @param {string[]}    endings    The word endings to check.
 * @returns {string}    The longest matched ending.
 */
const endsInArr = function endsInArr(word, endings) {
	const matches = [];
	for (const i in endings) {
		if (word.endsWith(endings[i])) {
			matches.push(endings[i]);
		}
	}

	const longest = matches.sort(function (a, b) {
		return b.length - a.length;
	})[0];

	if (longest) {
		return longest;
	}
	return "";
};

/**
 * Checks if a word is longer than the word length threshold specified for a given suffix group. If the word length does not
 * meet the threshold, it is not stemmed.
 *
 * If it does meet the threshold, checks whether the word ends with one of the endings from the inputted array. If it does,
 * it removes the suffix from the end of the word.
 *
 * The length of the actual suffix is not always equal to the length of the checked ending, so suffix length is a separate
 * parameter. For example, the word 'rowerek' ends with -erek, one of the endings from the diminutive group. However, for
 * that ending, the suffix length is defined as 2 so only -ek is stemmed.
 *
 * @param {string} word            The word to stem.
 * @param {number} wordLength      The length of the word.
 * @param {string[]} wordEndings   The suffix group.
 * @param {number} suffixLength    The length of the suffix.
 *
 * @returns {string}               The stemmed word.
 */
const findSuffixInGroupAndStem = function findSuffixInGroupAndStem(word, wordLength, wordEndings, suffixLength) {
	if (word.length > wordLength) {
		const longestMatchedWordEnding = endsInArr(word, wordEndings);

		if (longestMatchedWordEnding !== "") {
			return word.slice(0, -suffixLength);
		}
	}
};

/**
 * Goes through all the suffix groups in a given class (i.e., diminutive, noun, verb, adjective/adverb or general) and
 * stems the word if a suffix is found and should be stemmed.
 *
 * @param {string}      word            The word to stem.
 * @param {Object}      suffixClass     The class of suffixes to check.
 * @returns {string}    The stemmed word.
 */
const findSuffixInClassAndStem = function findSuffixInClassAndStem(word, suffixClass) {
	for (const suffixGroup in suffixClass) {
		if (suffixClass.hasOwnProperty(suffixGroup)) {
			const wordShouldBeLongerThan = suffixClass[suffixGroup].wordShouldBeLongerThan;
			const wordEndings = suffixClass[suffixGroup].wordEndings;
			const suffixLength = suffixClass[suffixGroup].suffixLength;

			const stemmedWord = findSuffixInGroupAndStem(word, wordShouldBeLongerThan, wordEndings, suffixLength);

			if (stemmedWord) {
				return stemmedWord;
			}
		}
	}
};

/**
 * Stems adjective and adverb suffixes. After stemming the suffixes, looks for the superlative prefix 'naj' and stems it
 * as well if found. For example, in 'najsilniejsze', first the 'ejsze' is stemmed and then the 'naj'.
 *
 * @param {string}  word                	The word to stem.
 * @param {Object}  ruleBasedStemmerData    The data for the rule-based stemmer.
 *
 * @returns {string} The word with removed adjective/adverb suffixes
 */
const stemAdjectivesAndAdverbs = function stemAdjectivesAndAdverbs(word, ruleBasedStemmerData) {
	const stemmedWord = findSuffixInClassAndStem(word, ruleBasedStemmerData.adjectiveAndAdverbSuffixes);

	if (stemmedWord) {
		// Remove superlative prefix if found
		if (word.startsWith(ruleBasedStemmerData.superlativePrefix)) {
			return stemmedWord.slice(3);
		}
		return stemmedWord;
	}
};

/**
 * Stems Polish words.
 *
 * @param {string}  word                The word to stem.
 * @param {Object}  morphologyData      The Polish morphology data file.
 *
 * @returns {string} The stemmed word.
 */
function stem$c(word, morphologyData) {
	const ruleBasedStemmerData = morphologyData.externalStemmer;
	const dictionaryStemmer = morphologyData.dictionary.stems;

	// Check if the word exists in the dictionary stemmer. If yes, replace the word with the base form of the word specified in the dictionary.
	let stemmedWord = dictionaryStemmer[word];
	if (stemmedWord) {
		word = stemmedWord;
	}

	word.toLowerCase();

	// If the word is three characters long or shorter, the stem should be the same as the word.
	if (word.length < 4) {
		return word;
	}

	/*
  * Go through diminutive, noun, verb, and adjective stemming steps. If a suffix (and optional prefix in case of adjectives/adverbs)
  *  is found, delete it and stop searching further.
  */
	stemmedWord = findSuffixInClassAndStem(word, ruleBasedStemmerData.diminutiveSuffixes);

	if (!stemmedWord) {
		stemmedWord = findSuffixInClassAndStem(word, ruleBasedStemmerData.nounSuffixes);
	}

	if (!stemmedWord) {
		stemmedWord = findSuffixInClassAndStem(word, ruleBasedStemmerData.verbSuffixes);
	}

	if (!stemmedWord) {
		stemmedWord = stemAdjectivesAndAdverbs(word, ruleBasedStemmerData);
	}

	// If the word was stemmed in any of the previous steps, replace the word with the stem.
	if (stemmedWord) {
		word = stemmedWord;
	}

	// Find and stem general suffixes
	stemmedWord = findSuffixInClassAndStem(word, ruleBasedStemmerData.generalSuffixes);

	if (stemmedWord) {
		return stemmedWord;
	}

	return word;
}

var stem$b = {};

Object.defineProperty(stem$b, "__esModule", {
	value: true
});
stem$b.default = stem$a;
/**
 * Copyright (c) 2015 Mouaffak A. Sarhan
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Tries to match a word with a regex. If matched, modifies the string according to the indicated pattern.
 *
 * @param {string}		word				The word to check.
 * @param {string[]}	regexAndReplacement	The regex to match the word with and what the word should be replaced with if it is matched.
 *
 * @returns {string}	The modified word or the original word if it was not matched.
 */
const matchWithRegexAndReplace = function matchWithRegexAndReplace(word, regexAndReplacement) {
	return word.replace(new RegExp(regexAndReplacement[0]), regexAndReplacement[1]);
};

/**
 * Check if the word is on the list of three-letter roots which had the last weak letter removed (so are now two letters long).
 * If the word is on the list, add back the removed last letter and return the three-letter root.
 * Examples: طر -> طري (word with last weak letter ي (yeh) removed) , حص -> حصا (word with last weak letter ا (alef) removed)
 *
 * @param {string}	word			The two-letter word to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {string|null}	The word with the last weak letter added back or null if the word was not found on a list.
 */
const checkWordsWithRemovedLastLetter = function checkWordsWithRemovedLastLetter(word, morphologyData) {
	const externalStemmer = morphologyData.externalStemmer;
	const characters = externalStemmer.characters;

	if (externalStemmer.wordsWithLastAlefRemoved.includes(word)) {
		return word + characters.alef;
	}
	if (externalStemmer.wordsWithLastHamzaRemoved.includes(word)) {
		return word + characters.alef_hamza_above;
	}
	if (externalStemmer.wordsWithLastMaksoraRemoved.includes(word)) {
		return word + characters.yeh_maksorah;
	}
	if (externalStemmer.wordsWithLastYehRemoved.includes(word)) {
		return word + characters.yeh;
	}
};

/**
 * Check if the word is on the list of three-letter roots which had the first weak letter removed (so are now two letters long).
 * If the word is on the list, add back the removed first letter and return the three-letter root.
 * Examples: مض -> ومض (word with first weak letter و (waw) removed) , سن -> يسن (word with first weak letter ي (yeh) removed)
 *
 * @param {string}	word			The two-letter word to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {string|null}	The word with the first weak letter added back or null if the word was not found on any list.
 */
const checkWordsWithRemovedFirstLetter = function checkWordsWithRemovedFirstLetter(word, morphologyData) {
	const externalStemmer = morphologyData.externalStemmer;
	const characters = externalStemmer.characters;

	if (externalStemmer.wordsWithFirstWawRemoved.includes(word)) {
		return characters.waw + word;
	}
	if (externalStemmer.wordsWithFirstYehRemoved.includes(word)) {
		return characters.yeh + word;
	}
};

/**
 * Check if the word is on the list of three-letter roots which had the middle weak letter removed (so are now two letters long).
 * If the word is on the list, add back the removed middle letter and return the three-letter root.
 * Examples: غز -> غوز (word with middle weak letter و (waw) removed), لن -> لين (word with middle weak letter ي (yeh) removed)
 *
 * @param {string}	word			The two-letter word to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {string|null}	The word with the middle weak letter added back or null if the word was not found on a list.
 */
const checkWordsWithRemovedMiddleLetter = function checkWordsWithRemovedMiddleLetter(word, morphologyData) {
	const externalStemmer = morphologyData.externalStemmer;
	const characters = externalStemmer.characters;

	if (externalStemmer.wordsWithMiddleWawRemoved.includes(word)) {
		return word[0] + characters.waw + word[1];
	}
	if (externalStemmer.wordsWithMiddleYehRemoved.includes(word)) {
		return word[0] + characters.yeh + word[1];
	}
};

/**
 * Find the root of two-letter words. Two-letter words usually come from three-letter roots for which a letter was deleted
 * as it is a duplicated last letter or a weak letter.
 *
 * @param {string}	word			The two-letter word to process.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {string}	The three-letter root or the input word if no root was found.
 */
const processTwoLetterWords = function processTwoLetterWords(word, morphologyData) {
	// Check whether the word is on the list of words with removed duplicate last letter. If it is, add back the removed letter to get the root.
	if (morphologyData.externalStemmer.wordsWithRemovedDuplicateLetter.includes(word)) {
		return word + word.substring(1);
	}
	// Check whether the word is on one of the lists of words with removed weak letter or hamza.
	const wordAfterLastLetterCheck = checkWordsWithRemovedLastLetter(word, morphologyData);
	if (wordAfterLastLetterCheck) {
		return wordAfterLastLetterCheck;
	}
	const wordAfterFirstLetterCheck = checkWordsWithRemovedFirstLetter(word, morphologyData);
	if (wordAfterFirstLetterCheck) {
		return wordAfterFirstLetterCheck;
	}
	const wordAfterMiddleLetterCheck = checkWordsWithRemovedMiddleLetter(word, morphologyData);
	if (wordAfterMiddleLetterCheck) {
		return wordAfterMiddleLetterCheck;
	}

	return word;
};

/**
 * Remove the middle/last weak letter or hamza in a three letter word. Find its root by checking the appropriate exception lists
 * (words with middle letter removed or words with last letter removed) and attaching the removed letter back.
 * Example: بدء -> بد -> بدأ (three letter word with (ء) hamza ending,
 * which is found on the list of words with last letter removed after removing the suffix)
 *
 * @param {string}		word					The three-letter word to check.
 * @param {Object}		morphologyData			The Arabic morphology data.
 * @param {string[]}	replacementPattern		The regex to find and remove middle or last weak letter/hamza in three letter words
 * @param {function}	functionToRunToGetRoot	The function that checks lists of words with either middle or last letter removed
 * 												and attaches it back.
 *
 * @returns {string|null}	The root or null if no root was found.
 */
const processThreeLetterWordsWithWeakLetterOrHamza = function processThreeLetterWordsWithWeakLetterOrHamza(word, morphologyData, replacementPattern, functionToRunToGetRoot) {
	// Find and remove middle or last weak letter or hamza
	const wordAfterRemovingWeakLetterOrHamza = word.replace(new RegExp(replacementPattern[0]), replacementPattern[1]);
	if (wordAfterRemovingWeakLetterOrHamza !== word) {
		/*
   * If the weak letter or hamza was removed, get the root by checking lists of words with middle/last weak letter
   * or hamza removed and attaching it back.
   */
		return functionToRunToGetRoot(wordAfterRemovingWeakLetterOrHamza, morphologyData);
	}
};

/**
 * Get the root of three letter words.
 * Examples: ؤكد -> أكد (three letter word with ؤ (waw_hamza) beginning, قدّ -> قدد (three letter word which has a shadda on the second letter)
 *
 * @param {string}	word			The three-letter word to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {string}	The root or the original input word (which may already be the root).
 */
const processThreeLetterWords = function processThreeLetterWords(word, morphologyData) {
	const characters = morphologyData.externalStemmer.characters;

	// If the word exists on the list of three letter roots, return the word.
	if (morphologyData.externalStemmer.threeLetterRoots.includes(word)) {
		return word;
	}
	// If the first letter is ا/ ؤ/ ئ (yeh_hamza/waw_hamza/alef), change it to أ (alef_hamza_above).
	if (word[0] === characters.alef || word[0] === characters.waw_hamza || word[0] === characters.yeh_hamza) {
		word = characters.alef_hamza_above + word.slice(1);
	}

	// If the last letter is a weak letter or a hamza, check if the word is a root that may get the last weak letter/hamza removed.
	const wordAfterLastWeakLetterOrHamzaCheck = processThreeLetterWordsWithWeakLetterOrHamza(word, morphologyData, morphologyData.externalStemmer.regexRemoveLastWeakLetterOrHamza, checkWordsWithRemovedLastLetter);
	if (wordAfterLastWeakLetterOrHamzaCheck) {
		return wordAfterLastWeakLetterOrHamzaCheck;
	}

	// If the middle letter is a waw, yeh, alef or a yeh_hamza, check if the word is a root that may get the middle weak letter/hamza removed..
	const wordAfterMiddleWeakLetterOrHamzaCheck = processThreeLetterWordsWithWeakLetterOrHamza(word, morphologyData, morphologyData.externalStemmer.regexRemoveMiddleWeakLetterOrHamza, checkWordsWithRemovedMiddleLetter);
	if (wordAfterMiddleWeakLetterOrHamzaCheck) {
		return wordAfterMiddleWeakLetterOrHamzaCheck;
	}

	const regexReplaceMiddleLetterWithAlef = morphologyData.externalStemmer.regexReplaceMiddleLetterWithAlef;
	const regexReplaceMiddleLetterWithAlefWithHamza = morphologyData.externalStemmer.regexReplaceMiddleLetterWithAlefWithHamza;

	// If the word has ئ/ؤ (yeh_hamza/waw_hamza) as the second letter and ends in ر/ز/ن (noon/zai/reh), change ئ/ؤ (yeh_hamza/waw_hamza) to ا (alef).
	const wordAfterReplacingMiddleLetterWithAlef = word.replace(new RegExp(regexReplaceMiddleLetterWithAlef[0]), regexReplaceMiddleLetterWithAlef[1]);
	if (wordAfterReplacingMiddleLetterWithAlef === word) {
		word = word.replace(new RegExp(regexReplaceMiddleLetterWithAlefWithHamza[0]), regexReplaceMiddleLetterWithAlefWithHamza[1]);
	} else {
		// If the second letter is a ئ/ؤ (yeh_hamza/waw_hamza) and it doesn't end in noon/zai/reh, change ئ/ؤ d to أ (alef_hamza_above).
		word = wordAfterReplacingMiddleLetterWithAlef;
	}
	// If the last letter is a shadda, remove it and duplicate the last letter.
	const regexRemoveShaddaAndDuplicateLastLetter = morphologyData.externalStemmer.regexRemoveShaddaAndDuplicateLastLetter;
	word = word.replace(new RegExp(regexRemoveShaddaAndDuplicateLastLetter[0]), regexRemoveShaddaAndDuplicateLastLetter[1]);

	return word;
};

/**
 * Check whether the word matches the pattern (it is a 6 letter-word, the fourth and sixth letter are the same, and the pattern
 * and the word share two same letters at the same index). If it does, remove the first character and the two last characters and
 * get the root.
 * Example: احولال -> حول (the stem is the 2nd to 4th character)
 *
 * @param {string}	word				The word to check.
 * @param {number}	numberSameLetters	The number of letters the word and the pattern share at the same index.
 * @param {Object}	morphologyData		The Arabic morphology data.
 *
 * @returns {string} The root or the original word if word was not matched by the pattern.
 */
const checkFirstPatternAndGetRoot = function checkFirstPatternAndGetRoot(word, numberSameLetters, morphologyData) {
	if (word.length === 6 && word[3] === word[5] && numberSameLetters === 2) {
		return processThreeLetterWords(word.substring(1, 4), morphologyData);
	}
	return word;
};

/**
 * Checks whether the word matches the pattern (the word shares three characters with the pattern) and get the root if it does.
 * Example: استكتب -> كتب (A word that matches pattern (استفعل))
 *
 * @param {string}	word				The word to check.
 * @param {string}	pattern				The pattern to check.
 * @param {number}	numberSameLetters	The number of letters the word and the pattern share at the same index.
 * @param {Object}	morphologyData		The Arabic morphology data.
 *
 * @returns {string} The root or the original word if no root was found.
 */
const checkSecondPatternAndGetRoot = function checkSecondPatternAndGetRoot(word, pattern, numberSameLetters, morphologyData) {
	const characters = morphologyData.externalStemmer.characters;
	// If the word length minus three is equal to or less than the number of same letters found in the checkPatterns function.
	if (word.length - 3 <= numberSameLetters) {
		let root = "";
		for (let i = 0; i < word.length; i++) {
			if (pattern[i] === characters.feh || pattern[i] === characters.aen || pattern[i] === characters.lam) {
				root = root.concat(word[i]);
			}
		}
		if (root.length === 3) {
			return processThreeLetterWords(root, morphologyData);
		}
	}
	return word;
};

/**
 * Count the number of letters the word and the pattern to match with share at the same index.
 *
 * @param {string}	word			The word to check.
 * @param {string}	pattern			The pattern to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {number}	The number of shared letters between the word and the pattern at the same index.
 */
const countSharedLettersBetweenWordAndPattern = function countSharedLettersBetweenWordAndPattern(word, pattern, morphologyData) {
	const characters = morphologyData.externalStemmer.characters;

	let numberSameLetters = 0;
	for (let i = 0; i < word.length; i++) {
		if (pattern[i] === word[i] && pattern[i] !== characters.feh && pattern[i] !== characters.aen && pattern[i] !== characters.lam) {
			numberSameLetters++;
		}
	}
	return numberSameLetters;
};

/**
 * Check if a word matches a specific pattern of letters, and if it does, modify the word to get the root.
 *
 * @param {string}	word			The word to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {Object|null} An object with either the root or the modified word and the information whether the root was found,
 * 						  or null if the word was not modified and the root was not found.
 */
const checkPatterns = function checkPatterns(word, morphologyData) {
	// If the first letter is an alef_madda, alef_hamza_above, or alef_hamza_below (أ/إ/آ), change it to an alef (ا)
	const wordAfterModification = matchWithRegexAndReplace(word, morphologyData.externalStemmer.regexReplaceFirstHamzaWithAlef);

	// Try and find a pattern that matches the word
	for (const pattern of morphologyData.externalStemmer.patterns) {
		if (pattern.length === wordAfterModification.length) {
			// Count the number of letters the word and the pattern share at the same index.
			const numberSameLetters = countSharedLettersBetweenWordAndPattern(wordAfterModification, pattern, morphologyData);

			const wordAfterCheckingFirstPattern = checkFirstPatternAndGetRoot(wordAfterModification, numberSameLetters, morphologyData);
			if (wordAfterCheckingFirstPattern !== wordAfterModification) {
				return { word: wordAfterCheckingFirstPattern, rootFound: true };
			}

			const wordAfterCheckingSecondPattern = checkSecondPatternAndGetRoot(wordAfterModification, pattern, numberSameLetters, morphologyData);
			if (wordAfterCheckingSecondPattern !== wordAfterModification) {
				return { word: wordAfterCheckingSecondPattern, rootFound: true };
			}
		}
	}
	// If a pattern was not matched but the word was modified, return the modified word.
	if (wordAfterModification !== word) {
		return { word: wordAfterModification, rootFound: false };
	}
};

/**
 * Tries to find the root of two-, three- and four-letter words by checking lists and/or applying modifications to the word.
 *
 * Example: the word أبطر is on the list of four-letter roots.
 *
 * @param {string} 	word			The word to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {string|null} The root or null if the root was not found.
 */
const checkIfWordIsRoot = function checkIfWordIsRoot(word, morphologyData) {
	// Check if the word consists of two letters and find its root.
	if (word.length === 2) {
		return processTwoLetterWords(word, morphologyData);
	}
	// Check if the word consists of three letters.
	if (word.length === 3) {
		// Check if it is a root.
		if (morphologyData.externalStemmer.threeLetterRoots.includes(word)) {
			return word;
		}
		// If it is not a root, process it to find its root.
		const wordAfterThreeLetterProcessing = processThreeLetterWords(word, morphologyData);
		if (wordAfterThreeLetterProcessing) {
			return wordAfterThreeLetterProcessing;
		}
	}
	// If the word consists of four letters, check if it is on the list of four-letter roots.
	if (word.length === 4) {
		if (morphologyData.externalStemmer.fourLetterRoots.includes(word)) {
			return word;
		}
	}
};

/**
 * Checks whether the word ends in a suffix, and removes it if it does.
 *
 * @param {string}		word		The word to check.
 * @param {string[]}	suffixes	The suffixes to check.
 *
 * @returns {string}	The word with the suffix removed or the input word if no suffix was found.
 */
const removeSuffix = function removeSuffix(word, suffixes) {
	for (const suffix of suffixes) {
		if (word.endsWith(suffix)) {
			return word.slice(0, -suffix.length);
		}
	}
	return word;
};

/**
 * Checks whether the word starts with a prefix, and removes it if it does.
 *
 * @param {string}		word		The word to check.
 * @param {string[]}	prefixes	The prefixes to check.
 *
 * @returns {string}	The word with the prefix removed or the input word if no prefix was found.
 */
const removePrefix$1 = function removePrefix(word, prefixes) {
	for (const prefix of prefixes) {
		if (word.startsWith(prefix)) {
			return word.substring(prefix.length, word.length);
		}
	}
	return word;
};

/**
 * Searches for a suffix, removes it if found, and tries to find the root of the stemmed word. If the root is not found, the
 * function returns null, with one exception: it is possible that in the checkPatterns function that is ran inside of this one,
 * the word is modified but no root is found. In this case, the function returns the modified word.
 *
 * Example: جمعكم -> جمع (word with suffix كم which is found on the list of three-letter roots after removing the suffix).
 *
 * @param {string}	word			The word to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {Object|null} An object with the root/modified word and information about whether the root was found, or null if
 * 						  the word is not modified and no root is found.
 */
const processWordWithSuffix = function processWordWithSuffix(word, morphologyData) {
	// If the word length is three letters or less, return null as the word is too short to have a suffix.
	if (word.length <= 3) {
		return null;
	}
	// Find and remove suffix.
	const wordAfterRemovingSuffix = removeSuffix(word, morphologyData.externalStemmer.suffixes);
	if (wordAfterRemovingSuffix !== word) {
		// If suffix was removed, check if the stemmed word is a root.
		const root = checkIfWordIsRoot(wordAfterRemovingSuffix, morphologyData);
		if (root) {
			return { word: root, rootFound: true };
		}
		// If no root was found and the stemmed word is longer than 2 characters, try to get the root by matching with a pattern.
		if (word.length > 2) {
			const outputAfterCheckingPatterns = checkPatterns(wordAfterRemovingSuffix, morphologyData);
			if (outputAfterCheckingPatterns) {
				return outputAfterCheckingPatterns;
			}
		}
	}
};

/**
 * Searches for a prefix (other than the definite article), removes it if found, and tries to find the root of the stemmed
 * word. If the root is not found, the function returns null, with one exception: it is possible that in the checkPatterns
 * function that is ran inside of this one, the word is modified but no root is found. In this case, the function returns
 * the modified word.
 *
 * Example: للزهور -> زهر (word with prefix لل that gets its root by matching with a pattern after removing the prefix).
 *
 * @param {string}	word			The word to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {Object|null}	An object with the root/modified word and information about whether the root was found, or null if
 * 						    the word is not modified and no root is found.
 */
const processWordWithPrefix = function processWordWithPrefix(word, morphologyData) {
	// If the word length is less than or the same as three letters, return null as the word is too short to have a prefix.
	if (word.length <= 3) {
		return null;
	}
	// Find and remove prefix.
	let wordAfterRemovingPrefix = removePrefix$1(word, morphologyData.externalStemmer.prefixes);
	if (wordAfterRemovingPrefix !== word) {
		// If prefix was removed, check if the stemmed word is a root.
		const root = checkIfWordIsRoot(wordAfterRemovingPrefix, morphologyData);
		if (root) {
			return { word: root, rootFound: true };
		}
		// If no root was found and the stemmed word is longer than 2 characters, try to get the root by matching with a pattern.
		if (wordAfterRemovingPrefix.length > 2) {
			const outputAfterCheckingPatterns = checkPatterns(wordAfterRemovingPrefix, morphologyData);
			if (outputAfterCheckingPatterns) {
				if (outputAfterCheckingPatterns.rootFound === true) {
					return outputAfterCheckingPatterns;
				}
				wordAfterRemovingPrefix = outputAfterCheckingPatterns.word;
			}
		}
		// If the root was still not found, try to find and remove suffixes and find the root again.
		const outputAfterCheckingForSuffixes = processWordWithSuffix(wordAfterRemovingPrefix, morphologyData);
		if (outputAfterCheckingForSuffixes) {
			return outputAfterCheckingForSuffixes;
		}
	}
};

/**
 * Checks if the word is a root. If root is not found, checks whether the root can be derived using a pattern. If the root is
 * still not found, removes affixes and tries to find the root again. If the root is not found, the function returns null,
 * with one exception: it is possible that in the checkPatterns function that is ran inside of this one, the word is modified
 * but no root is found. In this case, the function returns the modified word.
 *
 * @param {string}	word			The word to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {Object|null}	An object with the root/modified word and information about whether the root was found, or null if
 * 						    the word is not modified and no root is found.
 */
const findRoot = function findRoot(word, morphologyData) {
	// Check if the word is a root.
	const root = checkIfWordIsRoot(word, morphologyData);
	if (root) {
		return { word: root, rootFound: true };
	}
	if (word.length > 2) {
		// Check if the root can be derived by matching a pattern.
		const outputAfterCheckingPatterns = checkPatterns(word, morphologyData);
		if (outputAfterCheckingPatterns) {
			if (outputAfterCheckingPatterns.rootFound === true) {
				return outputAfterCheckingPatterns;
			}
			word = outputAfterCheckingPatterns.word;
		}
	}
	// Remove affixes and check if the stemmed word is a root
	const outputAfterProcessingSuffix = processWordWithSuffix(word, morphologyData);
	if (outputAfterProcessingSuffix) {
		if (outputAfterProcessingSuffix.rootFound === true) {
			return outputAfterProcessingSuffix;
		}
		word = outputAfterProcessingSuffix.word;
	}
	const outputAfterRemovingPrefix = processWordWithPrefix(word, morphologyData);
	if (outputAfterRemovingPrefix) {
		return outputAfterRemovingPrefix;
	}
};

/**
 * Search for and remove a definite article and try to get the root of the word. If the root was not found, but the word
 * was modified inside the checkPatterns function, returns the modified word. If the definite article was removed and the
 * stemmed word is longer than three letters, but the root was not found, returns the stemmed word. Otherwise, if the root
 * was not found, returns null.
 *
 * Example: الجدولين -> جدول (word with definite article ال and suffix ين ).
 *
 * @param {string}	word			The word to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {Object|null}	An object with the root/modified word and information about whether the root was found, or null if
 * 						    the word is not modified and no root is found.
 */
const processWordWithDefiniteArticle = function processWordWithDefiniteArticle(word, morphologyData) {
	// Search for and remove the definite article.
	let wordAfterRemovingDefiniteArticle = removePrefix$1(word, morphologyData.externalStemmer.definiteArticles);
	// If a definite article was removed, try to find the root.
	if (wordAfterRemovingDefiniteArticle !== word) {
		/**
   * If definite article was removed, try to find root by checking whether the word is a root, matching with a pattern, and/or
   * searching for and removing prefixes.
   */
		const outputAfterTryingToFindRoot = findRoot(wordAfterRemovingDefiniteArticle, morphologyData);
		if (outputAfterTryingToFindRoot) {
			if (outputAfterTryingToFindRoot.rootFound === true) {
				return outputAfterTryingToFindRoot;
			}
			wordAfterRemovingDefiniteArticle = outputAfterTryingToFindRoot.word;
		}
		// If the word after removing the definite article is longer than three words, return it even if no root was found.
		if (wordAfterRemovingDefiniteArticle > 3) {
			return { word: wordAfterRemovingDefiniteArticle, rootFound: false };
		}
	}
};

/**
 * Searches for prefix waw (و) and removes it if found, then tries to find the root. If the root is still not found, removes
 * affixes and tries to find the root again. If the root is not found, the function returns null, with one exception: it
 * is possible that in the checkPatterns function that is ran inside of this one, the word is modified but no root is found.
 * In this case, the function returns the modified word.
 *
 * Example: وتمثّل -> مثل (word with prefix waw which matches a pattern after removing the prefix).
 *
 * @param {string}	word			The word to check.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {Object|null}	An object with the root/modified word and information about whether the root was found, or null if
 * 						    the word is not modified and no root is found.
 */
const processWordWithPrefixWaw = function processWordWithPrefixWaw(word, morphologyData) {
	let wordAfterRemovingWaw = "";
	if (word.length > 3 && word.startsWith(morphologyData.externalStemmer.characters.waw)) {
		wordAfterRemovingWaw = word.substring(1);
		/*
   * If the prefix waw was removed, try to find the root by checking whether the word is a root, matching with a pattern,
   * and/or searching for and removing prefixes.
   */
		const outputAfterTryingToFindRoot = findRoot(wordAfterRemovingWaw, morphologyData);
		if (outputAfterTryingToFindRoot) {
			return outputAfterTryingToFindRoot;
		}
	}
};

/**
 * Stems Arabic words.
 *
 * @param {string}	word			The word to stem.
 * @param {Object}	morphologyData	The Arabic morphology data.
 *
 * @returns {string}	The stemmed word.
 */
function stem$a(word, morphologyData) {
	// Remove diacritics that serve as phonetic guides and are not usually used in regular writing.
	const regexRemovingDiacritics = morphologyData.externalStemmer.regexRemovingDiacritics;
	word.replace(new RegExp(regexRemovingDiacritics), "");

	const root = checkIfWordIsRoot(word, morphologyData);
	if (root) {
		return root;
	}
	// If the root still hasn't been found, check if the word matches a pattern and get its root if it does.
	const outputAfterCheckingPatterns = checkPatterns(word, morphologyData);
	if (outputAfterCheckingPatterns) {
		// Return the root if it was found in the checkPatterns function
		if (outputAfterCheckingPatterns.rootFound === true) {
			return outputAfterCheckingPatterns.word;
		}
		// If the checkPatterns function modified the word but did not find the root, replace the word with the modified word.
		word = outputAfterCheckingPatterns.word;
	}

	// If the root still hasn't been found, remove the definite article and try to find the root.
	const outputAfterProcessingDefiniteArticle = processWordWithDefiniteArticle(word, morphologyData);
	if (outputAfterProcessingDefiniteArticle) {
		// Return the root if it was found after removing the definite article.
		if (outputAfterProcessingDefiniteArticle.rootFound === true) {
			return outputAfterProcessingDefiniteArticle.word;
		}
		// If the definite article was removed but the root was not found, replace the word with the stemmed word.

		word = outputAfterProcessingDefiniteArticle.word;
	}

	// If the root still hasn't been found, remove the prefix waw and try to find the root.
	const outputAfterProcessingPrefixWaw = processWordWithPrefixWaw(word, morphologyData);
	if (outputAfterProcessingPrefixWaw) {
		if (outputAfterProcessingPrefixWaw.rootFound === true) {
			return outputAfterProcessingPrefixWaw.word;
		}
		// If the checkPatterns function modified the word but did not find the root, replace the word with the modified word.
		word = outputAfterProcessingPrefixWaw.word;
	}
	// If the root still hasn't been found, remove a suffix and try to find the root.
	const outputAfterProcessingSuffix = processWordWithSuffix(word, morphologyData);
	if (outputAfterProcessingSuffix) {
		if (outputAfterProcessingSuffix.rootFound === true) {
			return outputAfterProcessingSuffix.word;
		}
		// If the checkPatterns function modified the word but did not find the root, replace the word with the modified word.
		word = outputAfterProcessingSuffix.word;
	}

	// If the root still hasn't been found, remove a prefix and try to find the root.
	const wordAfterProcessingPrefix = processWordWithPrefix(word, morphologyData);
	if (wordAfterProcessingPrefix) {
		return wordAfterProcessingPrefix.word;
	}

	return word;
}

var stem$9 = {};

Object.defineProperty(stem$9, "__esModule", {
  value: true
});
stem$9.default = stem$8;
/*
 * MIT License
 *
 * Copyright (c) 2017, Dogan Yazar
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software
 * and associated documentation files (the "Software"), to deal in the Software without restriction,
 * including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS
 * OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * https://github.com/NaturalNode/natural/blob/master/lib/natural/stemmers/porter_stemmer_sv.js
 *
 */

/**
 * Determines the start index of the R1 region. R1 is the region after the first non-vowel following a vowel. It should include at least 3 letters.
 *
 * @param {string} word             The word for which to determine the R1 region.
 * @param {Object} morphologyData   The morphology data for Swedish.
 *
 * @returns {{rest: string, r1: string}}   The string within the R1 region and the rest string of the word.
 */
const getRegions = function getRegions(word, morphologyData) {
  const match = word.match(new RegExp(morphologyData.externalStemmer.regexR1region));
  let r1 = "";
  if (match && match[1]) {
    r1 = match[1];
    if (match.index + 2 < 3) {
      r1 = word.slice(3);
    }
  }
  return {
    r1,
    rest: word.slice(0, word.length - r1.length)
  };
};

/**
 * Searches from the longest among the following suffixes: a, arna, erna, heterna, orna, ad, e, ade, ande, arne, are, aste, en,
 * anden, aren, heten, ern, ar, er, heter, or, as, arnas, ernas, ornas, es, ades, andes, ens, arens, hetens, erns, at, andet, het, ast
 * and stems the suffix if in R1.
 *
 * @param {string} word             The word to check for the suffix.
 * @param {Object} regions          The object that contains the string within the R1 region and the rest string of the word.
 * @param {Object} morphologyData   The morphology data for Swedish.
 *
 * @returns {string} The word without the suffix.
 */
const removeSuffixes1a = function removeSuffixes1a(word, regions, morphologyData) {
  const r1 = regions.r1;
  if (!r1) {
    return word;
  }
  const regexSuffixes1a = new RegExp(morphologyData.externalStemmer.regexSuffixes1a);
  const match = r1.match(regexSuffixes1a);
  return match ? regions.rest + r1.slice(0, match.index) : word;
};

/**
 * Checks if a word ends in -s which is preceded by one of these letters: b, c, d, f, g, h, k, l, m, n, o, p, r, t, v, or y
 * and also has an R1. If it does, -s is stemmed.
 *
 * @param {string} word             The word to check for the suffix.
 * @param {Object} regions          The object that contains the string within the R1 region and the rest string of the word.
 * @param {Object} morphologyData   The morphology data for Swedish.
 *
 * @returns {Object} The word without the suffix.
 */
const removeSuffixS1b = function removeSuffixS1b(word, regions, morphologyData) {
  if (regions.r1 && word.match(new RegExp(morphologyData.externalStemmer.regexSuffixes1b))) {
    return word.slice(0, -1);
  }
  return word;
};

/**
 * Checks if a word ends in one of these suffixes:  -dd, -gd, -nn, -dt, -gt, -kt, -tt.
 * If it does, the suffix is stemmed.
 *
 * @param {string} word             The word to check for the suffix.
 * @param {Object} regions          The object that contains the string within the R1 region and the rest string of the word.
 * @param {Object} morphologyData   The morphology data for Swedish.
 *
 * @returns {string}    The word without the suffix.
 */
const removeSuffixStep2 = function removeSuffixStep2(word, regions, morphologyData) {
  const r1 = regions.r1;
  if (r1 && r1.match(new RegExp(morphologyData.externalStemmer.regexSuffixes2))) {
    return word.slice(0, -1);
  }
  return word;
};

/**
 * Searches the following suffixes in R1, and performs the action indicated:
 * (a) delete -lig, -ig, -els
 * (b) remove t ending from -löst or -fullt
 *
 * @param {string} word             The word to check for the suffix.
 * @param {Object} regions          The object that contains the string within the R1 region and the rest string of the word.
 * @param {Object} morphologyData   The morphology data for Swedish.
 *
 * @returns {string} The index of the suffix and the kind of suffix used.
 */
const removeSuffixStep3 = function removeSuffixStep3(word, regions, morphologyData) {
  const r1 = regions.r1;
  if (r1) {
    if (r1.match(new RegExp(morphologyData.externalStemmer.regexSuffixes3a))) {
      return word.slice(0, -1);
    }
    const match = r1.match(new RegExp(morphologyData.externalStemmer.regexSuffixes3b));
    return match ? regions.rest + r1.slice(0, match.index) : word;
  }
  return word;
};

/**
 * Stems a Swedish word.
 *
 * @param {string} word             The word to stem.
 * @param {Object} morphologyData   The morphology data for Swedish.
 * @returns {string}    The stemmed word.
 */
function stem$8(word, morphologyData) {
  let regions = getRegions(word, morphologyData);
  // Search and remove the suffixes from step 1, e.g. -arnas, -ernas, -ornas, -es, -ades, -andes
  const wordAfterStep1a = removeSuffixes1a(word, regions, morphologyData);
  const wordAfterStep1b = removeSuffixS1b(word, regions, morphologyData);

  // Compare length of word from step 1 (a and b) and return the shorter word
  word = wordAfterStep1a.length < wordAfterStep1b.length ? wordAfterStep1a : wordAfterStep1b;
  regions = getRegions(word, morphologyData);

  // Search and remove the suffixes from step 2, e.g. -dd, -gd, -nn, -dt, -gt, -kt, -tt.
  word = removeSuffixStep2(word, regions, morphologyData);
  regions = getRegions(word, morphologyData);

  // Search and remove the suffixes from step 3, e.g. -lig, -ig, -els
  word = removeSuffixStep3(word, regions, morphologyData);
  return word;
}

var stem$7 = {};

Object.defineProperty(stem$7, "__esModule", {
	value: true
});
stem$7.default = stem$6;
/*
 * Copyright (c) 2001, Dr Martin Porter,
 * Copyright (c) 2002, Richard Boulton.
 *
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided
 * that the following conditions are met:
 * 1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer
 * in the documentation and/or other materials provided with the distribution.
 * 3. Neither the name of the copyright holder nor the names of its contributors may be used to endorse or promote products
 * derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY,
 * OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Checks if the input character is a Hungarian vowel.
 *
 * @param {Object} morphologyData   The Hungarian morphology data.
 * @param {string} word The word to check
 * @returns {number} Whether the input character is a Hungarian vowel.
 */
const isVowel = function isVowel(morphologyData, word) {
	const vowels = morphologyData.externalStemmer.vowels;
	const regex = new RegExp(vowels);
	return word.search(regex);
};

/**
 * Defines consonants or digraphs position.
 *
 * @param {Object} morphologyData Morphology data file
 * @param {string} word the word to check
 * @returns {number} the position of the digraph or consonant
 */
const consonantOrDigraphPosition = function consonantOrDigraphPosition(morphologyData, word) {
	const digraphRegex = new RegExp(morphologyData.externalStemmer.digraphs);
	const consonantRegex = new RegExp(morphologyData.externalStemmer.consonants);
	const digraphPosition = word.search(digraphRegex);
	const consonantPosition = word.search(consonantRegex);
	if (digraphPosition === consonantPosition) {
		return digraphPosition + 1;
	}
	return consonantPosition;
};

/**
 * Defines the R1 region: Checks if the word begins with a vowel: defines R1 as the region after the first consonant or diagraph
 * Checks if the word begins with a consonant: defines R1 as the region after the first vowel
 *
 * @param {Object} morphologyData Morphology data file
 * @param {string} word The word to stem
 * @returns {number} The R1 region index.
 */
const findR1Position = function findR1Position(morphologyData, word) {
	const vowelPosition = isVowel(morphologyData, word);
	if (vowelPosition === 0) {
		const consonantOrDigraph = consonantOrDigraphPosition(morphologyData, word);
		return consonantOrDigraph + 1;
	}
	return vowelPosition + 1;
};

/**
 * Searches on of the following noun case suffixes: al, el and stems the suffix if found in R1 and preceded by a double consonant
 * and removes one of the double consonants
 *
 * @param {string} word             The word to stem
 * @param {Object} morphologyData   The morphology data file with suffix list
 *
 * @returns {string}    The stemmed word.
 *
 */
const stemSuffixes1 = function stemSuffixes1(word, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix = word.search(new RegExp(morphologyData.externalStemmer.suffixes1));
	if (suffix >= r1Position) {
		let wordAfterStemming = word.slice(0, -2);

		const doubleConsonantRegex = new RegExp(morphologyData.externalStemmer.doubleConsonants);
		const checkIfWordEndsOnDoubleConsonant = wordAfterStemming.search(doubleConsonantRegex);
		if (checkIfWordEndsOnDoubleConsonant !== -1) {
			wordAfterStemming = wordAfterStemming.slice(0, -1);
		}

		const tripleConsonantsRegex = new RegExp(morphologyData.externalStemmer.tripleDoubleConsonants);
		const checkIfWordEndsOnTripleDoubleConsonant = wordAfterStemming.search(tripleConsonantsRegex);
		if (checkIfWordEndsOnTripleDoubleConsonant !== -1) {
			wordAfterStemming = wordAfterStemming.slice(0, -2) + wordAfterStemming.charAt(wordAfterStemming.length - 1);
		}

		if (wordAfterStemming.length !== word.slice(0, -2).length) {
			return wordAfterStemming;
		}
	}
	return word;
};

/**
 * Searches for the longer of the following suffixes: ban   ben   ba   be   ra   re   nak   nek   val   vel   tól   tõl
 * ról   rõl   ból   bõl   hoz   hez   höz   nál   nél   ig   at   et   ot   öt   ért   képp   képpen   kor   ul   ül
 * vá   vé   onként   enként   anként   ként   en   on   an   ön   n   t and stems the suffix if found in R1
 * If the suffix is preceded by á replaces with a. If the suffix is preceded by é replaces with e
 *
 * @param {string} word         The word to stem
 * @param {string} suffixes2  suffixes from group 2
 * @param {Object} morphologyData Morphology data file
 *
 * @returns {string}    The stemmed word
 */
const stemSuffixes2 = function stemSuffixes2(word, suffixes2, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix2 = word.search(new RegExp(suffixes2));
	if (suffix2 >= r1Position) {
		let wordAfterStemming = word.substring(0, suffix2);
		const checkIfWordEndsOnAccentedEorE = wordAfterStemming.endsWith("á") || wordAfterStemming.endsWith("é");
		if (checkIfWordEndsOnAccentedEorE) {
			wordAfterStemming = wordAfterStemming.replace(/á$/i, "a" , "e");
		}
		return wordAfterStemming;
	}
	return word;
};

/** Searches for the longest among the following suffixes in R1: án   ánként and replace by a
 * Search for én in R1 and replace with e
 *
 * @param {string} word         The word to check for the suffix.
 * @param {Object} suffixes3    The suffixes to check.
 * @param {Object} morphologyData Morphology data file
 *
 * @returns {string} The word without the suffix.
 */
const stemSuffixes3 = function stemSuffixes3(word, suffixes3, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix3a = word.search(new RegExp(suffixes3.suffixes3a));
	if (suffix3a >= r1Position) {
		return word.substring(0, suffix3a) + "a";
	}
	const suffix3b = word.search(new RegExp(suffixes3.suffixes3b));
	if (suffix3b >= r1Position) {
		return word.substring(0, suffix3b) + "e";
	}
	return word;
};

/**
 * Searches for the longest among following suffixes astul   estül   stul   stül in R1 and delete.
 *
 * @param {string} word         The word to check for the suffix.
 * @param {string} suffixes4    The suffixes to check.
 * @param {Object} morphologyData Morphology data file
 *
 * @returns {string} The word without the suffix.
 */
const stemSuffixes4 = function stemSuffixes4(word, suffixes4, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix4 = word.search(new RegExp(suffixes4));
	if (suffix4 >= r1Position) {
		return word.substring(0, suffix4);
	}
	return word;
};

/**
 * Searhes for one of the suffixes ástul éstül, and replace ástul with a and éstül with e.
 *
 * @param {string} word         The word to check for the suffix.
 * @param {string[]} suffixes5  The suffixes to check.
 * @param {Object} morphologyData Morphology data file
 *
 * @returns {string} The word without the suffix.
 */
const stemSuffixes5 = function stemSuffixes5(word, suffixes5, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix5a = word.search(new RegExp(suffixes5.suffixes5a));
	if (suffix5a >= r1Position) {
		return word.substring(0, suffix5a) + "a";
	}
	const suffix5b = word.search(new RegExp(suffixes5.suffixes5b));
	if (suffix5b >= r1Position) {
		return word.substring(0, suffix5b) + "e";
	}
	return word;
};

/**
 * Searches for one of the suffixes Search for one of the following suffixes: á   é and delete. If preceded by double
 * Consonant, remove one of the double consonants.
 *
 * @param {string} word         The word to check for the suffix.
 * @param {string} suffixes6  The suffixes to check.
 * @param {Object} morphologyData Morphology data file
 *
 * @returns {string} The word without the suffix.
 */
const stemSuffixes6 = function stemSuffixes6(word, suffixes6, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix6 = word.search(new RegExp(suffixes6));
	if (suffix6 >= r1Position) {
		let wordAfterStemming = word.slice(0, -1);
		const doubleConsonantRegex = new RegExp(morphologyData.externalStemmer.doubleConsonants);
		const checkIfWordEndsOnDoubleConsonant = wordAfterStemming.search(doubleConsonantRegex);
		if (checkIfWordEndsOnDoubleConsonant !== -1) {
			wordAfterStemming = wordAfterStemming.slice(0, -1);
		}
		return wordAfterStemming;
	}
	return word;
};

/**
 * Searches for one of the suffixes in R1 and delete oké   öké   aké   eké   ké   éi   é.
 *
 * @param {string} word         The word to check for the suffix.
 * @param {string} suffixes7  The suffixes to check.
 * @param {Object} morphologyData Morphology data file
 *
 * @returns {string} The word without the suffix.
 */
const stemSuffixes7 = function stemSuffixes7(word, suffixes7, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix7 = word.search(new RegExp(suffixes7));
	if (suffix7 >= r1Position) {
		return word.substring(0, suffix7);
	}
	return word;
};

/**
 * Searches for one of the suffixes if R1 : áké   áéi and replace with a, or éké   ééi   éé and replace with e.
 *
 * @param {string} word         The word to check for the suffix.
 * @param {Object} suffixes8  The suffixes to check.
 * @param {Object} morphologyData Morphology data file
 * @returns {string} The word without the suffix.
 */
const stemSuffixes8 = function stemSuffixes8(word, suffixes8, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix8a = word.search(new RegExp(suffixes8.suffixes8a));
	if (suffix8a >= r1Position) {
		return word.substring(0, suffix8a) + "a";
	}
	const suffix8b = word.search(new RegExp(suffixes8.suffixes8b));
	if (suffix8b >= r1Position) {
		return word.substring(0, suffix8b) + "e";
	}
	return word;
};

/**
 * Searches for the longest one of the suffixes in R1 and delete: ünk   unk   nk   juk   jük   uk   ük   em   om   am
 * m   od   ed ad   öd   d   ja   je   a   e o
 * @param {string} word         The word to check for the suffix.
 * @param {string} suffixes9  The suffixes to check.
 * @param {Object} morphologyData Morphology data file
 * @returns {string} The word without the suffix.
 */
const stemSuffixes9 = function stemSuffixes9(word, suffixes9, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix9 = word.search(new RegExp(suffixes9));
	if (suffix9 >= r1Position) {
		return word.substring(0, suffix9);
	}
	return word;
};

/**
 * Searches for the longest one of these suffixes in R1: jaim, jeim, aim, eim, im, jaid, eid, aid, eid, id, jai, jei, ai,
 * ei, i, jaink, jeink, eink, aink, ink, jaitok, jeitek, aitok, eitek, itek, jeik, jaik, aik, eik, ik and stem it
 *
 * @param {string} word         The word to check.
 * @param {string} suffixes10     The suffixes to check.
 * @param {Object} morphologyData Morphology data file
 * @returns {string}    The stemmed word.
 */
const stemSuffixes10 = function stemSuffixes10(word, suffixes10, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix10 = word.search(new RegExp(suffixes10));
	if (suffix10 >= r1Position) {
		return word.substring(0, suffix10);
	}
	return word;
};

/**
 * Searches for the longest one of these suffixes in R1 ánk ájuk ám ád á and replace  with a
 * Searches the longest one of the suffixes in R1 énk éjük ém éd é and replace with e
 *
 * @param {string} word             The word to check for the suffix.
 * @param {string[]} suffixes11     The suffixes to check.
 * @param {Object} morphologyData Morphology data file
 * @returns {string} The word without the suffix.
 */
const stemSuffixes11 = function stemSuffixes11(word, suffixes11, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffixes11a = word.search(new RegExp(suffixes11.suffixes11a));
	if (suffixes11a >= r1Position) {
		return word.substring(0, suffixes11a) + "a";
	}
	const suffixes11b = word.search(new RegExp(suffixes11.suffixes11b));
	if (suffixes11b >= r1Position) {
		return word.substring(0, suffixes11b) + "e";
	}
	return word;
};

/**
 * Searches for the longest one of these suffixes in R1 áim   áid   ái   áink   áitok   áik and replace with a, and
 * Search for the longest one of the suffixes in R1 éim   éid     éi   éink   éitek   éik and replace with e
 *
 * @param {string} word         The word to check.
 * @param {string[]}suffixes12  The suffixes to stem.
 * @param {Object} morphologyData Morphology data file
 * @returns {string}    The stemmed word.
 */
const stemSuffixes12 = function stemSuffixes12(word, suffixes12, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix12a = word.search(new RegExp(suffixes12.suffixes12a));
	if (suffix12a >= r1Position) {
		return word.substring(0, suffix12a) + "a";
	}
	const suffix12b = word.search(new RegExp(suffixes12.suffixes12b));
	if (suffix12b >= r1Position) {
		return word.substring(0, suffix12b) + "e";
	}
	return word;
};

/**
 * Searches for suffix ák and ék in R1 and replace with a and e respectively.
 *
 * @param {string} word         The word to check.
 * @param {Object}suffixes13  The suffixes to stem.
 * @param {Object} morphologyData Morphology data file
 * @returns {string}    The stemmed word.
 */
const stemSuffixes13 = function stemSuffixes13(word, suffixes13, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix13a = word.search(new RegExp(suffixes13.suffixes13a));
	if (suffix13a >= r1Position) {
		return word.slice(0, -2) + "a";
	}
	const suffix13b = word.search(new RegExp(suffixes13.suffixes13b));
	if (suffix13b >= r1Position) {
		return word.slice(0, -2) + "e";
	}
	return word;
};

/**
 * Searches for the longest of these suffixes ök ok ek ak k in R1 and stem the suffix
 *
 * @param {string} word         The word to check.
 * @param {string}suffixes14  The suffixes to stem.
 * @param {Object} morphologyData Morphology data file
 * @returns {string}    The stemmed word.
 */
const stemSuffixes14 = function stemSuffixes14(word, suffixes14, morphologyData) {
	if (word.length < 3) {
		return word;
	}
	const r1Position = findR1Position(morphologyData, word);
	const suffix14 = word.search(new RegExp(suffixes14));
	if (suffix14 >= r1Position) {
		return word.substring(0, suffix14);
	}
	return word;
};

/**
 * Stems Hungarian words.
 *
 * @param {string} word            The word to stem.
 * @param {Object} morphologyData  The Hungarian morphology data.
 *
 * @returns {string} The stemmed word.
 */
function stem$6(word, morphologyData) {
	const wordAfterSuffixes1 = stemSuffixes1(word, morphologyData);
	const wordAfterSuffixes2 = stemSuffixes2(wordAfterSuffixes1, morphologyData.externalStemmer.suffixes2, morphologyData);
	const wordAfterSuffixes3 = stemSuffixes3(wordAfterSuffixes2, morphologyData.externalStemmer.suffixes3, morphologyData);
	const wordAfterSuffixes4 = stemSuffixes4(wordAfterSuffixes3, morphologyData.externalStemmer.suffixes4, morphologyData);
	const wordAfterSuffixes5 = stemSuffixes5(wordAfterSuffixes4, morphologyData.externalStemmer.suffixes5, morphologyData);
	const wordAfterSuffixes6 = stemSuffixes6(wordAfterSuffixes5, morphologyData.externalStemmer.suffixes6, morphologyData);
	const wordAfterSuffixes7 = stemSuffixes7(wordAfterSuffixes6, morphologyData.externalStemmer.suffixes7, morphologyData);
	const wordAfterSuffixes8 = stemSuffixes8(wordAfterSuffixes7, morphologyData.externalStemmer.suffixes8, morphologyData);
	const wordAfterSuffixes9 = stemSuffixes9(wordAfterSuffixes8, morphologyData.externalStemmer.suffixes9, morphologyData);
	const wordAfterSuffixes10 = stemSuffixes10(wordAfterSuffixes9, morphologyData.externalStemmer.suffixes10, morphologyData);
	const wordAfterSuffixes11 = stemSuffixes11(wordAfterSuffixes10, morphologyData.externalStemmer.suffixes11, morphologyData);
	const wordAfterSuffixes12 = stemSuffixes12(wordAfterSuffixes11, morphologyData.externalStemmer.suffixes12, morphologyData);
	const wordAfterSuffixes13 = stemSuffixes13(wordAfterSuffixes12, morphologyData.externalStemmer.suffixes13, morphologyData);

	return stemSuffixes14(wordAfterSuffixes13, morphologyData.externalStemmer.suffixes14, morphologyData);
}

var stem$5 = {};

Object.defineProperty(stem$5, "__esModule", {
	value: true
});
stem$5.default = stem$4;
/**
 *
 * If the word starts with one of the prefixes "ב" "ה", "ו", "כ", "ל", "מ", "ש" it should be stemmed as the dictionary
 * does not contain forms with those prefixes.
 *
 * @param {string} 		word		The word to check for a prefix.
 * @param {string[]} 	prefixes	The prefixes that should be stemmed before checking the dictionary.
 *
 * @returns {string} Word without the prefix or the original word if no prefix was found
 */
const removePrefix = function removePrefix(word, prefixes) {
	if (prefixes.some(prefix => word.startsWith(prefix))) {
		return word.slice(1);
	}
	return word;
};

/**
 * Stems Hebrew words (removes possible prefixes and returns lemma if found in the dictionary).
 *
 * @param {string}	word			The word to stem.
 * @param {Object}	morphologyData	The Hebrew morphology data.
 *
 * @returns {string} The stemmed word or the original word if no stem was found.
 */
function stem$4(word, morphologyData) {
	const dictionaryStemmer = morphologyData.dictionary;

	// Check if the word exists in the dictionary stemmer. If yes, return base form of the word specified in the dictionary.
	let stemmedWord = dictionaryStemmer[word];
	if (stemmedWord) {
		return stemmedWord;
	}

	// If the word was not found in the dictionary, try to remove a prefix from the word and see whether the deprefixed word is found.
	const wordAfterRemovingPrefix = removePrefix(word, morphologyData.prefixes);
	if (wordAfterRemovingPrefix !== word) {
		stemmedWord = dictionaryStemmer[wordAfterRemovingPrefix];
		if (stemmedWord) {
			return stemmedWord;
		}
		// If a prefix was removed but the word was still not found, try removing another prefix and search in the dictionary again.
		const wordAfterRemovingSecondPrefix = removePrefix(wordAfterRemovingPrefix, morphologyData.prefixes);
		if (wordAfterRemovingSecondPrefix !== wordAfterRemovingPrefix) {
			stemmedWord = dictionaryStemmer[wordAfterRemovingSecondPrefix];
			if (stemmedWord) {
				return stemmedWord;
			}
		}
	}
	return word;
}

var stem$3 = {};

Object.defineProperty(stem$3, "__esModule", {
  value: true
});
stem$3.default = stem$2;
/*
 * Copyright (c) 2001, Dr Martin Porter
 * Copyright (c) 2002, Richard Boulton.
 * All rights reserved.
 *
 *
 * Redistribution and use in source and binary forms, with or without modification, are permitted provided that
 * the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this list of conditions and
 * the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and
 * the following disclaimer in the documentation and/or other materials provided with the distribution.
 * 3. Neither the name of the copyright holder nor the names of its contributors may be used to endorse
 * or promote products derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY,
 * OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
 * OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Determines the start index of the R1 region.
 * R1 is the region after the first non-vowel following a vowel. It should include at least 3 letters.
 *
 * @param {string} word The word for which to determine the R1 region.
 *
 * @returns {number} The start index of the R1 region.
 */
const determineR1 = function determineR1(word) {
  // Start with matching first vowel and non-vowel.
  let r1Index = word.search(/[aeiouyøåæ][^aeiouyøåæ]/);
  // Then add 2 since the R1 index is the index after the first vowel & non-vowel matched with the regex.
  if (r1Index !== -1) {
    r1Index += 2;
  }

  // Adjust R1 so that the region preceding it includes at least 3 letters.
  if (r1Index !== -1 && r1Index < 3) {
    r1Index = 3;
  }

  return r1Index;
};

/**
 *  Searches and stems these suffixes if in R1: hetene, hetens, hetens, heten, heter, endes, ande, ende, edes, enes, ede,
 *  ane, ene, ens, ers, ets, het, ast, en, ar, er, as, es, et, a, e. After stemming the suffix, it checks if the word
 *  ends in -ert, if it is stem -t.
 *  Searches and stems suffix -s if in R1 and if preceded by a valid precedence: b, c, d, f, g, h, j, l, m, n, o, p, r, t, v, y, z,
 *  or k not preceded by a vowel.
 *
 * @param {string} word             The word to check.
 * @param {number} r1Index          The start index of the R1.
 * @param {Object} morphologyData   The morphology data file.
 *
 * @returns {string}    The stemmed word.
 */
const removeSuffixesStep1 = function removeSuffixesStep1(word, r1Index, morphologyData) {
  const suffixes1aIndex = word.search(new RegExp(morphologyData.externalStemmer.regexSuffixes1a));
  if (suffixes1aIndex >= r1Index && r1Index !== -1) {
    let wordAfterStemming = word.substring(0, suffixes1aIndex);
    if (/ert$/i.test(wordAfterStemming)) {
      wordAfterStemming = wordAfterStemming.slice(0, -1);
    }
    return wordAfterStemming;
  }

  const suffixSIndex = word.search(/s$/);
  const suffixes1bIndex = word.search(new RegExp(morphologyData.externalStemmer.regexSuffixes1b));
  if (suffixSIndex >= r1Index && suffixes1bIndex !== -1 && r1Index !== -1) {
    return word.slice(0, -1);
  }

  return word;
};

/**
 * Searches for suffixes -ert/-dt/-vt and stems -t if the suffix is in R1.
 *
 * @param {string} word             The word to check.
 * @param {number} r1Index          The start index of the R1.
 * @param {Object} morphologyData   The morphology data file.
 *
 * @returns {string}    The stemmed word.
 */
const removeSuffixesStep2 = function removeSuffixesStep2(word, r1Index, morphologyData) {
  const suffixes2Index = word.search(new RegExp(morphologyData.externalStemmer.regexSuffixes2));
  if (suffixes2Index >= r1Index && r1Index !== -1) {
    word = word.slice(0, -1);
  }
  return word;
};

/**
 * Searches and stems these suffixes if in R1: hetslov, eleg, elig, elov, slov, leg, eig, lig, els, lov, ig.
 *
 * @param {string} word             The word to check.
 * @param {number} r1Index          The start index of the R1.
 * @param {Object} morphologyData   The morphology data file.
 *
 * @returns {string}    The stemmed word.
 */
const removeSuffixesStep3 = function removeSuffixesStep3(word, r1Index, morphologyData) {
  const suffixes3Index = word.search(new RegExp(morphologyData.externalStemmer.regexSuffixes3));
  if (suffixes3Index >= r1Index && r1Index !== -1) {
    word = word.substring(0, suffixes3Index);
  }
  return word;
};

/**
 * Stems Norwegian words.
 *
 * @param {string} word             The word to check.
 * @param {Object} morphologyData   The morphology data file.
 *
 * @returns {string}    The stemmed word.
 */
function stem$2(word, morphologyData) {
  let r1Index = -1;
  for (const step of [removeSuffixesStep1, removeSuffixesStep2, removeSuffixesStep3]) {
    r1Index = determineR1(word);
    word = step(word, r1Index, morphologyData);
  }

  return word;
}

var stem$1 = {};

var turkishStemmer = {};

Object.defineProperty(turkishStemmer, "__esModule", {
	value: true
});
/* eslint-disable max-statements, require-jsdoc, complexity, camelcase, prefer-const, no-labels, no-constant-condition, no-lone-blocks, max-depth, no-return-assign, max-len, no-bitwise, no-unused-vars */
/*
 * Snowball JavaScript Library v0.5
 * http://snowball.tartarus.org/
 * https://github.com/mazko/jssnowball
 *
 * Copyright 20.12.2015 15:03:09, Oleg Mazko
 * http://www.opensource.org/licenses/bsd-license.html
 *
 * BSD 3-Clause License
 *
 * Copyright (c) 2018, Oleg Mazko
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 *
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 *
 * * Neither the name of the copyright holder nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 *
 */
class StringBuffer {
	get b() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$b") ? this._$esjava$b : this._$esjava$b = "";
	}

	set b(v) {
		this._$esjava$b = v;
	}

	length$esjava$0() {
		return this.b.length;
	}

	replace$esjava$3(start, end, str) {
		if (start === 0 && end === this.b.length) {
			this.b = str;
		} else {
			const left = this.b.substring(0, start),
			      right = this.b.substring(end);
			this.b = left + str + right;
		}
	}

	substring$esjava$2(start, end) {
		return this.b.substring(start, end);
	}

	charAt$esjava$1(index) {
		return this.b.charCodeAt(index);
	}

	subSequence$esjava$2(start, end) {
		throw new Error("NotImpl: CharSequence::subSequence");
	}

	toString$esjava$0() {
		return this.b;
	}

	length(...args) {
		switch (args.length) {
			case 0:
				return this.length$esjava$0(...args);
		}
		return super.length(...args);
	}

	replace(...args) {
		switch (args.length) {
			case 3:
				return this.replace$esjava$3(...args);
		}
		return super.replace(...args);
	}

	substring(...args) {
		switch (args.length) {
			case 2:
				return this.substring$esjava$2(...args);
		}
		return super.substring(...args);
	}

	charAt(...args) {
		switch (args.length) {
			case 1:
				return this.charAt$esjava$1(...args);
		}
		return super.charAt(...args);
	}

	subSequence(...args) {
		switch (args.length) {
			case 2:
				return this.subSequence$esjava$2(...args);
		}
		return super.subSequence(...args);
	}

	toString(...args) {
		switch (args.length) {
			case 0:
				return this.toString$esjava$0(...args);
		}
		return super.toString(...args);
	}
}
class Among {
	static toCharArray$esjava$1(s) {
		const sLength = s.length;
		const charArr = new Array(sLength);
		for (let i = 0; i < sLength; i++) {
			charArr[i] = s.charCodeAt(i);
		}
		return charArr;
	}

	constructor(s, substring_i, result, methodname, methodobject) {
		this.s_size = s.length;
		this.s = Among.toCharArray$esjava$1(s);
		this.substring_i = substring_i;
		this.result = result;
		this.methodobject = methodobject;
		this.method = methodname ? methodobject[methodname] : null;
	}

	get s_size() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$s_size") ? this._$esjava$s_size : this._$esjava$s_size = 0;
	}

	set s_size(v) {
		this._$esjava$s_size = v;
	}

	get s() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$s") ? this._$esjava$s : this._$esjava$s = null;
	}

	set s(v) {
		this._$esjava$s = v;
	}

	get substring_i() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$substring_i") ? this._$esjava$substring_i : this._$esjava$substring_i = 0;
	}

	set substring_i(v) {
		this._$esjava$substring_i = v;
	}

	get result() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$result") ? this._$esjava$result : this._$esjava$result = 0;
	}

	set result(v) {
		this._$esjava$result = v;
	}

	get method() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$method") ? this._$esjava$method : this._$esjava$method = null;
	}

	set method(v) {
		this._$esjava$method = v;
	}

	get methodobject() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$methodobject") ? this._$esjava$methodobject : this._$esjava$methodobject = null;
	}

	set methodobject(v) {
		this._$esjava$methodobject = v;
	}
}

class SnowballProgram {
	constructor() {
		this.current = new StringBuffer();
		this.setCurrent$esjava$1("");
	}

	setCurrent$esjava$1(value) {
		this.current.replace(0, this.current.length(), value);
		this.cursor = 0;
		this.limit = this.current.length();
		this.limit_backward = 0;
		this.bra = this.cursor;
		this.ket = this.limit;
	}

	getCurrent$esjava$0() {
		const result = this.current.toString();
		this.current = new StringBuffer();
		return result;
	}

	get current() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$current") ? this._$esjava$current : this._$esjava$current = null;
	}

	set current(v) {
		this._$esjava$current = v;
	}

	get cursor() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$cursor") ? this._$esjava$cursor : this._$esjava$cursor = 0;
	}

	set cursor(v) {
		this._$esjava$cursor = v;
	}

	get limit() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$limit") ? this._$esjava$limit : this._$esjava$limit = 0;
	}

	set limit(v) {
		this._$esjava$limit = v;
	}

	get limit_backward() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$limit_backward") ? this._$esjava$limit_backward : this._$esjava$limit_backward = 0;
	}

	set limit_backward(v) {
		this._$esjava$limit_backward = v;
	}

	get bra() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$bra") ? this._$esjava$bra : this._$esjava$bra = 0;
	}

	set bra(v) {
		this._$esjava$bra = v;
	}

	get ket() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$ket") ? this._$esjava$ket : this._$esjava$ket = 0;
	}

	set ket(v) {
		this._$esjava$ket = v;
	}

	copy_from$esjava$1(other) {
		this.current = other.current;
		this.cursor = other.cursor;
		this.limit = other.limit;
		this.limit_backward = other.limit_backward;
		this.bra = other.bra;
		this.ket = other.ket;
	}

	in_grouping$esjava$3(s, min, max) {
		if (this.cursor >= this.limit) {
			return false;
		}
		let ch = this.current.charAt(this.cursor);
		if (ch > max || ch < min) {
			return false;
		}
		ch -= min;
		if ((s[ch >> 3] & 0X1 << (ch & 0X7)) === 0) {
			return false;
		}
		this.cursor++;
		return true;
	}

	in_grouping_b$esjava$3(s, min, max) {
		if (this.cursor <= this.limit_backward) {
			return false;
		}
		let ch = this.current.charAt(this.cursor - 1);
		if (ch > max || ch < min) {
			return false;
		}
		ch -= min;
		if ((s[ch >> 3] & 0X1 << (ch & 0X7)) === 0) {
			return false;
		}
		this.cursor--;
		return true;
	}

	out_grouping$esjava$3(s, min, max) {
		if (this.cursor >= this.limit) {
			return false;
		}
		let ch = this.current.charAt(this.cursor);
		if (ch > max || ch < min) {
			this.cursor++;
			return true;
		}
		ch -= min;
		if ((s[ch >> 3] & 0X1 << (ch & 0X7)) === 0) {
			this.cursor++;
			return true;
		}
		return false;
	}

	out_grouping_b$esjava$3(s, min, max) {
		if (this.cursor <= this.limit_backward) {
			return false;
		}
		let ch = this.current.charAt(this.cursor - 1);
		if (ch > max || ch < min) {
			this.cursor--;
			return true;
		}
		ch -= min;
		if ((s[ch >> 3] & 0X1 << (ch & 0X7)) === 0) {
			this.cursor--;
			return true;
		}
		return false;
	}

	in_range$esjava$2(min, max) {
		if (this.cursor >= this.limit) {
			return false;
		}
		const ch = this.current.charAt(this.cursor);
		if (ch > max || ch < min) {
			return false;
		}
		this.cursor++;
		return true;
	}

	in_range_b$esjava$2(min, max) {
		if (this.cursor <= this.limit_backward) {
			return false;
		}
		const ch = this.current.charAt(this.cursor - 1);
		if (ch > max || ch < min) {
			return false;
		}
		this.cursor--;
		return true;
	}

	out_range$esjava$2(min, max) {
		if (this.cursor >= this.limit) {
			return false;
		}
		const ch = this.current.charAt(this.cursor);
		if (!(ch > max || ch < min)) {
			return false;
		}
		this.cursor++;
		return true;
	}

	out_range_b$esjava$2(min, max) {
		if (this.cursor <= this.limit_backward) {
			return false;
		}
		const ch = this.current.charAt(this.cursor - 1);
		if (!(ch > max || ch < min)) {
			return false;
		}
		this.cursor--;
		return true;
	}

	eq_s$esjava$2(s_size, s) {
		if (this.limit - this.cursor < s_size) {
			return false;
		}
		let i;
		for (i = 0; i !== s_size; i++) {
			if (this.current.charAt(this.cursor + i) !== s.charCodeAt(i)) {
				return false;
			}
		}
		this.cursor += s_size;
		return true;
	}

	eq_s_b$esjava$2(s_size, s) {
		if (this.cursor - this.limit_backward < s_size) {
			return false;
		}
		let i;
		for (i = 0; i !== s_size; i++) {
			if (this.current.charAt(this.cursor - s_size + i) !== s.charCodeAt(i)) {
				return false;
			}
		}
		this.cursor -= s_size;
		return true;
	}

	eq_v$esjava$1(s) {
		return this.eq_s$esjava$2(s.length(), s.toString());
	}

	eq_v_b$esjava$1(s) {
		return this.eq_s_b$esjava$2(s.length(), s.toString());
	}

	find_among$esjava$2(v, v_size) {
		let i = 0;
		let j = v_size;
		const c = this.cursor;
		const l = this.limit;
		let common_i = 0;
		let common_j = 0;
		let first_key_inspected = false;
		while (true) {
			const k = i + (j - i >> 1);
			let diff = 0;
			let common = common_i < common_j ? common_i : common_j;
			const w = v[k];
			let i2;
			for (i2 = common; i2 < w.s_size; i2++) {
				if (c + common === l) {
					diff = -1;
					break;
				}
				diff = this.current.charAt(c + common) - w.s[i2];
				if (diff !== 0) {
					break;
				}
				common++;
			}
			if (diff < 0) {
				j = k;
				common_j = common;
			} else {
				i = k;
				common_i = common;
			}
			if (j - i <= 1) {
				if (i > 0) {
					break;
				}
				if (j === i) {
					break;
				}
				if (first_key_inspected) {
					break;
				}
				first_key_inspected = true;
			}
		}
		while (true) {
			const w = v[i];
			if (common_i >= w.s_size) {
				this.cursor = c + w.s_size;
				if (w.method === null) {
					return w.result;
				}
				let res;
				res = w.method.call(w.methodobject);
				this.cursor = c + w.s_size;
				if (res) {
					return w.result;
				}
			}
			i = w.substring_i;
			if (i < 0) {
				return 0;
			}
		}
	}

	find_among_b$esjava$2(v, v_size) {
		let i = 0;
		let j = v_size;
		const c = this.cursor;
		const lb = this.limit_backward;
		let common_i = 0;
		let common_j = 0;
		let first_key_inspected = false;
		while (true) {
			const k = i + (j - i >> 1);
			let diff = 0;
			let common = common_i < common_j ? common_i : common_j;
			const w = v[k];
			let i2;
			for (i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
				if (c - common === lb) {
					diff = -1;
					break;
				}
				diff = this.current.charAt(c - 1 - common) - w.s[i2];
				if (diff !== 0) {
					break;
				}
				common++;
			}
			if (diff < 0) {
				j = k;
				common_j = common;
			} else {
				i = k;
				common_i = common;
			}
			if (j - i <= 1) {
				if (i > 0) {
					break;
				}
				if (j === i) {
					break;
				}
				if (first_key_inspected) {
					break;
				}
				first_key_inspected = true;
			}
		}
		while (true) {
			const w = v[i];
			if (common_i >= w.s_size) {
				this.cursor = c - w.s_size;
				if (w.method === null) {
					return w.result;
				}
				let res;
				res = w.method.call(w.methodobject);
				this.cursor = c - w.s_size;
				if (res) {
					return w.result;
				}
			}
			i = w.substring_i;
			if (i < 0) {
				return 0;
			}
		}
	}

	replace_s$esjava$3(c_bra, c_ket, s) {
		const adjustment = s.length - (c_ket - c_bra);
		this.current.replace(c_bra, c_ket, s);
		this.limit += adjustment;
		if (this.cursor >= c_ket) {
			this.cursor += adjustment;
		} else if (this.cursor > c_bra) {
			this.cursor = c_bra;
		}
		return adjustment;
	}

	slice_check$esjava$0() {
		if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit || this.limit > this.current.length()) {
			throw new Error("Snowball: faulty slice operation");
		}
	}

	slice_from$esjava$1(s) {
		this.slice_check$esjava$0();
		this.replace_s$esjava$3(this.bra, this.ket, s);
	}

	slice_del$esjava$0() {
		this.slice_from$esjava$1("");
	}

	insert$esjava$3(c_bra, c_ket, s) {
		const adjustment = this.replace_s$esjava$3(c_bra, c_ket, s);
		if (c_bra <= this.bra) {
			this.bra += adjustment;
		}
		if (c_bra <= this.ket) {
			this.ket += adjustment;
		}
	}

	slice_to$esjava$1(s) {
		this.slice_check$esjava$0();
		s.replace(0, s.length(), this.current.substring(this.bra, this.ket));
		return s;
	}

	setCurrent(...args) {
		switch (args.length) {
			case 1:
				return this.setCurrent$esjava$1(...args);
		}
		return super.setCurrent(...args);
	}

	getCurrent(...args) {
		switch (args.length) {
			case 0:
				return this.getCurrent$esjava$0(...args);
		}
		return super.getCurrent(...args);
	}

	copy_from(...args) {
		switch (args.length) {
			case 1:
				return this.copy_from$esjava$1(...args);
		}
		return super.copy_from(...args);
	}

	in_grouping(...args) {
		switch (args.length) {
			case 3:
				return this.in_grouping$esjava$3(...args);
		}
		return super.in_grouping(...args);
	}

	in_grouping_b(...args) {
		switch (args.length) {
			case 3:
				return this.in_grouping_b$esjava$3(...args);
		}
		return super.in_grouping_b(...args);
	}

	out_grouping(...args) {
		switch (args.length) {
			case 3:
				return this.out_grouping$esjava$3(...args);
		}
		return super.out_grouping(...args);
	}

	out_grouping_b(...args) {
		switch (args.length) {
			case 3:
				return this.out_grouping_b$esjava$3(...args);
		}
		return super.out_grouping_b(...args);
	}

	in_range(...args) {
		switch (args.length) {
			case 2:
				return this.in_range$esjava$2(...args);
		}
		return super.in_range(...args);
	}

	in_range_b(...args) {
		switch (args.length) {
			case 2:
				return this.in_range_b$esjava$2(...args);
		}
		return super.in_range_b(...args);
	}

	out_range(...args) {
		switch (args.length) {
			case 2:
				return this.out_range$esjava$2(...args);
		}
		return super.out_range(...args);
	}

	out_range_b(...args) {
		switch (args.length) {
			case 2:
				return this.out_range_b$esjava$2(...args);
		}
		return super.out_range_b(...args);
	}

	eq_s(...args) {
		switch (args.length) {
			case 2:
				return this.eq_s$esjava$2(...args);
		}
		return super.eq_s(...args);
	}

	eq_s_b(...args) {
		switch (args.length) {
			case 2:
				return this.eq_s_b$esjava$2(...args);
		}
		return super.eq_s_b(...args);
	}

	eq_v(...args) {
		switch (args.length) {
			case 1:
				return this.eq_v$esjava$1(...args);
		}
		return super.eq_v(...args);
	}

	eq_v_b(...args) {
		switch (args.length) {
			case 1:
				return this.eq_v_b$esjava$1(...args);
		}
		return super.eq_v_b(...args);
	}

	find_among(...args) {
		switch (args.length) {
			case 2:
				return this.find_among$esjava$2(...args);
		}
		return super.find_among(...args);
	}

	find_among_b(...args) {
		switch (args.length) {
			case 2:
				return this.find_among_b$esjava$2(...args);
		}
		return super.find_among_b(...args);
	}

	replace_s(...args) {
		switch (args.length) {
			case 3:
				return this.replace_s$esjava$3(...args);
		}
		return super.replace_s(...args);
	}

	slice_check(...args) {
		switch (args.length) {
			case 0:
				return this.slice_check$esjava$0(...args);
		}
		return super.slice_check(...args);
	}

	slice_from(...args) {
		switch (args.length) {
			case 1:
				return this.slice_from$esjava$1(...args);
		}
		return super.slice_from(...args);
	}

	slice_del(...args) {
		switch (args.length) {
			case 0:
				return this.slice_del$esjava$0(...args);
		}
		return super.slice_del(...args);
	}

	insert(...args) {
		switch (args.length) {
			case 3:
				return this.insert$esjava$3(...args);
		}
		return super.insert(...args);
	}

	slice_to(...args) {
		switch (args.length) {
			case 1:
				return this.slice_to$esjava$1(...args);
		}
		return super.slice_to(...args);
	}
}

class SnowballStemmer extends SnowballProgram {
	stem$esjava$0() {
		throw "NotImpl < stem$esjava$0 >";
	}

	stem(...args) {
		switch (args.length) {
			case 0:
				return this.stem$esjava$0(...args);
		}
		return super.stem(...args);
	}
}

class TurkishStemmer extends SnowballStemmer {
	constructor(morphologyData) {
		super();
		TurkishStemmer.morphologyData = morphologyData.externalStemmer;
	}

	static get methodObject() {
		delete TurkishStemmer.methodObject;
		return TurkishStemmer.methodObject = null;
	}

	static get a_0() {
		delete TurkishStemmer.a_0;
		return TurkishStemmer.a_0 = [new Among(TurkishStemmer.morphologyData.a_0.SuffixM, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_0.SuffixN, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_0.SuffixMiz, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_0.SuffixNiz, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_0.SuffixMuz, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_0.SuffixNuz, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_0.SuffixMuzDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_0.SuffixNuzDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_0.SuffixMizUndotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_0.SuffixNizUndotted, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_1() {
		delete TurkishStemmer.a_1;
		return TurkishStemmer.a_1 = [new Among(TurkishStemmer.morphologyData.a_1.SuffixLeri, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_1.SuffixLariUndotted, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_2() {
		delete TurkishStemmer.a_2;
		return TurkishStemmer.a_2 = [new Among(TurkishStemmer.morphologyData.a_2.SuffixNi, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_2.SuffixNu, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_2.SuffixNuDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_2.SuffixNiUndotted, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_3() {
		delete TurkishStemmer.a_3;
		return TurkishStemmer.a_3 = [new Among(TurkishStemmer.morphologyData.a_3.SuffixInDotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_3.SuffixUn, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_3.SuffixUnDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_3.SuffixInUndotted, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_4() {
		delete TurkishStemmer.a_4;
		return TurkishStemmer.a_4 = [new Among(TurkishStemmer.morphologyData.a_4.SuffixA, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_4.SuffixE, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_5() {
		delete TurkishStemmer.a_5;
		return TurkishStemmer.a_5 = [new Among(TurkishStemmer.morphologyData.a_5.SuffixNa, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_5.SuffixNe, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_6() {
		delete TurkishStemmer.a_6;
		return TurkishStemmer.a_6 = [new Among(TurkishStemmer.morphologyData.a_6.SuffixDa, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_6.SuffixTa, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_6.SuffixDe, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_6.SuffixTe, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_7() {
		delete TurkishStemmer.a_7;
		return TurkishStemmer.a_7 = [new Among(TurkishStemmer.morphologyData.a_7.SuffixNda, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_7.SuffixNde, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_8() {
		delete TurkishStemmer.a_8;
		return TurkishStemmer.a_8 = [new Among(TurkishStemmer.morphologyData.a_8.SuffixDan, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_8.SuffixTan, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_8.SuffixDen, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_8.SuffixTen, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_9() {
		delete TurkishStemmer.a_9;
		return TurkishStemmer.a_9 = [new Among(TurkishStemmer.morphologyData.a_9.SuffixNdan, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_9.SuffixNden, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_10() {
		delete TurkishStemmer.a_10;
		return TurkishStemmer.a_10 = [new Among(TurkishStemmer.morphologyData.a_10.SuffixLa, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_10.SuffixLe, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_11() {
		delete TurkishStemmer.a_11;
		return TurkishStemmer.a_11 = [new Among(TurkishStemmer.morphologyData.a_11.SuffixCa, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_11.SuffixCe, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_12() {
		delete TurkishStemmer.a_12;
		return TurkishStemmer.a_12 = [new Among(TurkishStemmer.morphologyData.a_12.SuffixImDotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_12.SuffixUm, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_12.SuffixUmDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_12.SuffixImUndotted, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_13() {
		delete TurkishStemmer.a_13;
		return TurkishStemmer.a_13 = [new Among(TurkishStemmer.morphologyData.a_13.SuffixSin, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_13.SuffixSun, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_13.SuffixSunDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_13.SuffixSinUndotted, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_14() {
		delete TurkishStemmer.a_14;
		return TurkishStemmer.a_14 = [new Among(TurkishStemmer.morphologyData.a_14.SuffixIzDotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_14.SuffixUz, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_14.SuffixUzDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_14.SuffixIzUndotted, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_15() {
		delete TurkishStemmer.a_15;
		return TurkishStemmer.a_15 = [new Among(TurkishStemmer.morphologyData.a_15.SuffixSiniz, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_15.SuffixSunuz, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_15.SuffixSunuzDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_15.SuffixSinizUndotted, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_16() {
		delete TurkishStemmer.a_16;
		return TurkishStemmer.a_16 = [new Among(TurkishStemmer.morphologyData.a_16.SuffixLar, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_16.SuffixLer, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_17() {
		delete TurkishStemmer.a_17;
		return TurkishStemmer.a_17 = [new Among(TurkishStemmer.morphologyData.a_17.SuffixNiz, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_17.SuffixNuz, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_17.SuffixNuzDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_17.SuffixNizUndotted, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_18() {
		delete TurkishStemmer.a_18;
		return TurkishStemmer.a_18 = [new Among(TurkishStemmer.morphologyData.a_18.SuffixDir, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_18.SuffixTir, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_18.SuffixDur, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_18.SuffixTur, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_18.SuffixDurDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_18.SuffixTurDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_18.SuffixDirUndotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_18.SuffixTirUndotted, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_19() {
		delete TurkishStemmer.a_19;
		return TurkishStemmer.a_19 = [new Among(TurkishStemmer.morphologyData.a_19.SuffixCasinaUndotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_19.SuffixCesine, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_20() {
		delete TurkishStemmer.a_20;
		return TurkishStemmer.a_20 = [new Among(TurkishStemmer.morphologyData.a_20.SuffixDi, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTi, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDik, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTik, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDuk, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTuk, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDukDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTukDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDikUndotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTikUndotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDim, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTim, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDum, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTum, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDumDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTumDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDimUndotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTimUndotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDin, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTin, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDun, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTun, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDunDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTunDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDinUndotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTinUndotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDu, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTu, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDuDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTuDieresis, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixDiUndotted, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_20.SuffixTiUndotted, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_21() {
		delete TurkishStemmer.a_21;
		return TurkishStemmer.a_21 = [new Among(TurkishStemmer.morphologyData.a_21.SuffixSa, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_21.SuffixSe, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_21.SuffixSak, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_21.SuffixSek, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_21.SuffixSam, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_21.SuffixSem, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_21.SuffixSan, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_21.SuffixSen, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_22() {
		delete TurkishStemmer.a_22;
		return TurkishStemmer.a_22 = [new Among(TurkishStemmer.morphologyData.a_22.SuffixMisCedilla, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_22.SuffixMusCedilla, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_22.SuffixMusDieresisCedilla, -1, -1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_22.SuffixMisUndottedCedilla, -1, -1, "", TurkishStemmer.methodObject)];
	}

	static get a_23() {
		delete TurkishStemmer.a_23;
		return TurkishStemmer.a_23 = [new Among(TurkishStemmer.morphologyData.a_23.SuffixB, -1, 1, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_23.SuffixC, -1, 2, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_23.SuffixD, -1, 3, "", TurkishStemmer.methodObject), new Among(TurkishStemmer.morphologyData.a_23.SuffixGSoft, -1, 4, "", TurkishStemmer.methodObject)];
	}

	static get g_vowel() {
		delete TurkishStemmer.g_vowel;
		return TurkishStemmer.g_vowel = [17, 65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 32, 8, 0, 0, 0, 0, 0, 0, 1];
	}

	static get g_U() {
		delete TurkishStemmer.g_U;
		return TurkishStemmer.g_U = [1, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 1];
	}

	static get g_vowel1() {
		delete TurkishStemmer.g_vowel1;
		return TurkishStemmer.g_vowel1 = [1, 64, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1];
	}

	static get g_vowel2() {
		delete TurkishStemmer.g_vowel2;
		return TurkishStemmer.g_vowel2 = [17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 130];
	}

	static get g_vowel3() {
		delete TurkishStemmer.g_vowel3;
		return TurkishStemmer.g_vowel3 = [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1];
	}

	static get g_vowel4() {
		delete TurkishStemmer.g_vowel4;
		return TurkishStemmer.g_vowel4 = [17];
	}

	static get g_vowel5() {
		delete TurkishStemmer.g_vowel5;
		return TurkishStemmer.g_vowel5 = [65];
	}

	static get g_vowel6() {
		delete TurkishStemmer.g_vowel6;
		return TurkishStemmer.g_vowel6 = [65];
	}

	get B_continue_stemming_noun_suffixes() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$B_continue_stemming_noun_suffixes") ? this._$esjava$B_continue_stemming_noun_suffixes : this._$esjava$B_continue_stemming_noun_suffixes = false;
	}

	set B_continue_stemming_noun_suffixes(v) {
		this._$esjava$B_continue_stemming_noun_suffixes = v;
	}

	get I_strlen() {
		return Object.prototype.hasOwnProperty.call(this, "_$esjava$I_strlen") ? this._$esjava$I_strlen : this._$esjava$I_strlen = 0;
	}

	set I_strlen(v) {
		this._$esjava$I_strlen = v;
	}

	r_check_vowel_harmony$esjava$0() {
		let v_1;
		let v_2;
		let v_3;
		let v_4;
		let v_5;
		let v_6;
		let v_7;
		let v_8;
		let v_9;
		let v_10;
		let v_11;
		v_1 = this.limit - this.cursor;
		golab0: while (true) {
			v_2 = this.limit - this.cursor;
			lab1: do {
				if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
					break lab1;
				}
				this.cursor = this.limit - v_2;
				break golab0;
			} while (false);
			this.cursor = this.limit - v_2;
			if (this.cursor <= this.limit_backward) {
				return false;
			}
			this.cursor--;
		}
		lab2: do {
			v_3 = this.limit - this.cursor;
			lab3: do {
				if (!this.eq_s_b$esjava$2(1, "a")) {
					break lab3;
				}
				golab4: while (true) {
					v_4 = this.limit - this.cursor;
					lab5: do {
						if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel1, 97, 305)) {
							break lab5;
						}
						this.cursor = this.limit - v_4;
						break golab4;
					} while (false);
					this.cursor = this.limit - v_4;
					if (this.cursor <= this.limit_backward) {
						break lab3;
					}
					this.cursor--;
				}
				break lab2;
			} while (false);
			this.cursor = this.limit - v_3;
			lab6: do {
				if (!this.eq_s_b$esjava$2(1, "e")) {
					break lab6;
				}
				golab7: while (true) {
					v_5 = this.limit - this.cursor;
					lab8: do {
						if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel2, 101, 252)) {
							break lab8;
						}
						this.cursor = this.limit - v_5;
						break golab7;
					} while (false);
					this.cursor = this.limit - v_5;
					if (this.cursor <= this.limit_backward) {
						break lab6;
					}
					this.cursor--;
				}
				break lab2;
			} while (false);
			this.cursor = this.limit - v_3;
			lab9: do {
				if (!this.eq_s_b$esjava$2(1, "\u0131")) {
					break lab9;
				}
				golab10: while (true) {
					v_6 = this.limit - this.cursor;
					lab11: do {
						if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel3, 97, 305)) {
							break lab11;
						}
						this.cursor = this.limit - v_6;
						break golab10;
					} while (false);
					this.cursor = this.limit - v_6;
					if (this.cursor <= this.limit_backward) {
						break lab9;
					}
					this.cursor--;
				}
				break lab2;
			} while (false);
			this.cursor = this.limit - v_3;
			lab12: do {
				if (!this.eq_s_b$esjava$2(1, "i")) {
					break lab12;
				}
				golab13: while (true) {
					v_7 = this.limit - this.cursor;
					lab14: do {
						if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel4, 101, 105)) {
							break lab14;
						}
						this.cursor = this.limit - v_7;
						break golab13;
					} while (false);
					this.cursor = this.limit - v_7;
					if (this.cursor <= this.limit_backward) {
						break lab12;
					}
					this.cursor--;
				}
				break lab2;
			} while (false);
			this.cursor = this.limit - v_3;
			lab15: do {
				if (!this.eq_s_b$esjava$2(1, "o")) {
					break lab15;
				}
				golab16: while (true) {
					v_8 = this.limit - this.cursor;
					lab17: do {
						if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel5, 111, 117)) {
							break lab17;
						}
						this.cursor = this.limit - v_8;
						break golab16;
					} while (false);
					this.cursor = this.limit - v_8;
					if (this.cursor <= this.limit_backward) {
						break lab15;
					}
					this.cursor--;
				}
				break lab2;
			} while (false);
			this.cursor = this.limit - v_3;
			lab18: do {
				if (!this.eq_s_b$esjava$2(1, "\u00F6")) {
					break lab18;
				}
				golab19: while (true) {
					v_9 = this.limit - this.cursor;
					lab20: do {
						if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel6, 246, 252)) {
							break lab20;
						}
						this.cursor = this.limit - v_9;
						break golab19;
					} while (false);
					this.cursor = this.limit - v_9;
					if (this.cursor <= this.limit_backward) {
						break lab18;
					}
					this.cursor--;
				}
				break lab2;
			} while (false);
			this.cursor = this.limit - v_3;
			lab21: do {
				if (!this.eq_s_b$esjava$2(1, "u")) {
					break lab21;
				}
				golab22: while (true) {
					v_10 = this.limit - this.cursor;
					lab23: do {
						if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel5, 111, 117)) {
							break lab23;
						}
						this.cursor = this.limit - v_10;
						break golab22;
					} while (false);
					this.cursor = this.limit - v_10;
					if (this.cursor <= this.limit_backward) {
						break lab21;
					}
					this.cursor--;
				}
				break lab2;
			} while (false);
			this.cursor = this.limit - v_3;
			if (!this.eq_s_b$esjava$2(1, "\u00FC")) {
				return false;
			}
			golab24: while (true) {
				v_11 = this.limit - this.cursor;
				lab25: do {
					if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel6, 246, 252)) {
						break lab25;
					}
					this.cursor = this.limit - v_11;
					break golab24;
				} while (false);
				this.cursor = this.limit - v_11;
				if (this.cursor <= this.limit_backward) {
					return false;
				}
				this.cursor--;
			}
		} while (false);
		this.cursor = this.limit - v_1;
		return true;
	}

	r_mark_suffix_with_optional_n_consonant$esjava$0() {
		let v_1;
		let v_2;
		let v_3;
		let v_4;
		let v_5;
		let v_6;
		let v_7;
		lab0: do {
			v_1 = this.limit - this.cursor;
			lab1: do {
				v_2 = this.limit - this.cursor;
				if (!this.eq_s_b$esjava$2(1, "n")) {
					break lab1;
				}
				this.cursor = this.limit - v_2;
				if (this.cursor <= this.limit_backward) {
					break lab1;
				}
				this.cursor--;
				v_3 = this.limit - this.cursor;
				if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
					break lab1;
				}
				this.cursor = this.limit - v_3;
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			{
				v_4 = this.limit - this.cursor;
				lab2: do {
					v_5 = this.limit - this.cursor;
					if (!this.eq_s_b$esjava$2(1, "n")) {
						break lab2;
					}
					this.cursor = this.limit - v_5;
					return false;
				} while (false);
				this.cursor = this.limit - v_4;
			}
			v_6 = this.limit - this.cursor;
			if (this.cursor <= this.limit_backward) {
				return false;
			}
			this.cursor--;
			v_7 = this.limit - this.cursor;
			if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
				return false;
			}
			this.cursor = this.limit - v_7;
			this.cursor = this.limit - v_6;
		} while (false);
		return true;
	}

	r_mark_suffix_with_optional_s_consonant$esjava$0() {
		let v_1;
		let v_2;
		let v_3;
		let v_4;
		let v_5;
		let v_6;
		let v_7;
		lab0: do {
			v_1 = this.limit - this.cursor;
			lab1: do {
				v_2 = this.limit - this.cursor;
				if (!this.eq_s_b$esjava$2(1, "s")) {
					break lab1;
				}
				this.cursor = this.limit - v_2;
				if (this.cursor <= this.limit_backward) {
					break lab1;
				}
				this.cursor--;
				v_3 = this.limit - this.cursor;
				if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
					break lab1;
				}
				this.cursor = this.limit - v_3;
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			{
				v_4 = this.limit - this.cursor;
				lab2: do {
					v_5 = this.limit - this.cursor;
					if (!this.eq_s_b$esjava$2(1, "s")) {
						break lab2;
					}
					this.cursor = this.limit - v_5;
					return false;
				} while (false);
				this.cursor = this.limit - v_4;
			}
			v_6 = this.limit - this.cursor;
			if (this.cursor <= this.limit_backward) {
				return false;
			}
			this.cursor--;
			v_7 = this.limit - this.cursor;
			if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
				return false;
			}
			this.cursor = this.limit - v_7;
			this.cursor = this.limit - v_6;
		} while (false);
		return true;
	}

	r_mark_suffix_with_optional_y_consonant$esjava$0() {
		let v_1;
		let v_2;
		let v_3;
		let v_4;
		let v_5;
		let v_6;
		let v_7;
		lab0: do {
			v_1 = this.limit - this.cursor;
			lab1: do {
				v_2 = this.limit - this.cursor;
				if (!this.eq_s_b$esjava$2(1, "y")) {
					break lab1;
				}
				this.cursor = this.limit - v_2;
				if (this.cursor <= this.limit_backward) {
					break lab1;
				}
				this.cursor--;
				v_3 = this.limit - this.cursor;
				if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
					break lab1;
				}
				this.cursor = this.limit - v_3;
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			{
				v_4 = this.limit - this.cursor;
				lab2: do {
					v_5 = this.limit - this.cursor;
					if (!this.eq_s_b$esjava$2(1, "y")) {
						break lab2;
					}
					this.cursor = this.limit - v_5;
					return false;
				} while (false);
				this.cursor = this.limit - v_4;
			}
			v_6 = this.limit - this.cursor;
			if (this.cursor <= this.limit_backward) {
				return false;
			}
			this.cursor--;
			v_7 = this.limit - this.cursor;
			if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
				return false;
			}
			this.cursor = this.limit - v_7;
			this.cursor = this.limit - v_6;
		} while (false);
		return true;
	}

	r_mark_suffix_with_optional_U_vowel$esjava$0() {
		let v_1;
		let v_2;
		let v_3;
		let v_4;
		let v_5;
		let v_6;
		let v_7;
		lab0: do {
			v_1 = this.limit - this.cursor;
			lab1: do {
				v_2 = this.limit - this.cursor;
				if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_U, 105, 305)) {
					break lab1;
				}
				this.cursor = this.limit - v_2;
				if (this.cursor <= this.limit_backward) {
					break lab1;
				}
				this.cursor--;
				v_3 = this.limit - this.cursor;
				if (!this.out_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
					break lab1;
				}
				this.cursor = this.limit - v_3;
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			{
				v_4 = this.limit - this.cursor;
				lab2: do {
					v_5 = this.limit - this.cursor;
					if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_U, 105, 305)) {
						break lab2;
					}
					this.cursor = this.limit - v_5;
					return false;
				} while (false);
				this.cursor = this.limit - v_4;
			}
			v_6 = this.limit - this.cursor;
			if (this.cursor <= this.limit_backward) {
				return false;
			}
			this.cursor--;
			v_7 = this.limit - this.cursor;
			if (!this.out_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
				return false;
			}
			this.cursor = this.limit - v_7;
			this.cursor = this.limit - v_6;
		} while (false);
		return true;
	}

	r_mark_possessives$esjava$0() {
		if (this.find_among_b$esjava$2(TurkishStemmer.a_0, 10) === 0) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_U_vowel$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_sU$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_U, 105, 305)) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_s_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_lArI$esjava$0() {
		if (this.find_among_b$esjava$2(TurkishStemmer.a_1, 2) === 0) {
			return false;
		}
		return true;
	}

	r_mark_yU$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_U, 105, 305)) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_y_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_nU$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_2, 4) === 0) {
			return false;
		}
		return true;
	}

	r_mark_nUn$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_3, 4) === 0) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_n_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_yA$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_4, 2) === 0) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_y_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_nA$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_5, 2) === 0) {
			return false;
		}
		return true;
	}

	r_mark_DA$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_6, 4) === 0) {
			return false;
		}
		return true;
	}

	r_mark_ndA$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_7, 2) === 0) {
			return false;
		}
		return true;
	}

	r_mark_DAn$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_8, 4) === 0) {
			return false;
		}
		return true;
	}

	r_mark_ndAn$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_9, 2) === 0) {
			return false;
		}
		return true;
	}

	r_mark_ylA$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_10, 2) === 0) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_y_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_ki$esjava$0() {
		if (!this.eq_s_b$esjava$2(2, "ki")) {
			return false;
		}
		return true;
	}

	r_mark_ncA$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_11, 2) === 0) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_n_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_yUm$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_12, 4) === 0) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_y_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_sUn$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_13, 4) === 0) {
			return false;
		}
		return true;
	}

	r_mark_yUz$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_14, 4) === 0) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_y_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_sUnUz$esjava$0() {
		if (this.find_among_b$esjava$2(TurkishStemmer.a_15, 4) === 0) {
			return false;
		}
		return true;
	}

	r_mark_lAr$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_16, 2) === 0) {
			return false;
		}
		return true;
	}

	r_mark_nUz$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_17, 4) === 0) {
			return false;
		}
		return true;
	}

	r_mark_DUr$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_18, 8) === 0) {
			return false;
		}
		return true;
	}

	r_mark_cAsInA$esjava$0() {
		if (this.find_among_b$esjava$2(TurkishStemmer.a_19, 2) === 0) {
			return false;
		}
		return true;
	}

	r_mark_yDU$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_20, 32) === 0) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_y_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_ysA$esjava$0() {
		if (this.find_among_b$esjava$2(TurkishStemmer.a_21, 8) === 0) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_y_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_ymUs_$esjava$0() {
		if (!this.r_check_vowel_harmony$esjava$0()) {
			return false;
		}
		if (this.find_among_b$esjava$2(TurkishStemmer.a_22, 4) === 0) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_y_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_mark_yken$esjava$0() {
		if (!this.eq_s_b$esjava$2(3, "ken")) {
			return false;
		}
		if (!this.r_mark_suffix_with_optional_y_consonant$esjava$0()) {
			return false;
		}
		return true;
	}

	r_stem_nominal_verb_suffixes$esjava$0() {
		let v_1;
		let v_2;
		let v_3;
		let v_4;
		let v_5;
		let v_6;
		let v_7;
		let v_8;
		let v_9;
		let v_10;
		this.ket = this.cursor;
		this.B_continue_stemming_noun_suffixes = true;
		lab0: do {
			v_1 = this.limit - this.cursor;
			lab1: do {
				lab2: do {
					v_2 = this.limit - this.cursor;
					lab3: do {
						if (!this.r_mark_ymUs_$esjava$0()) {
							break lab3;
						}
						break lab2;
					} while (false);
					this.cursor = this.limit - v_2;
					lab4: do {
						if (!this.r_mark_yDU$esjava$0()) {
							break lab4;
						}
						break lab2;
					} while (false);
					this.cursor = this.limit - v_2;
					lab5: do {
						if (!this.r_mark_ysA$esjava$0()) {
							break lab5;
						}
						break lab2;
					} while (false);
					this.cursor = this.limit - v_2;
					if (!this.r_mark_yken$esjava$0()) {
						break lab1;
					}
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab6: do {
				if (!this.r_mark_cAsInA$esjava$0()) {
					break lab6;
				}
				lab7: do {
					v_3 = this.limit - this.cursor;
					lab8: do {
						if (!this.r_mark_sUnUz$esjava$0()) {
							break lab8;
						}
						break lab7;
					} while (false);
					this.cursor = this.limit - v_3;
					lab9: do {
						if (!this.r_mark_lAr$esjava$0()) {
							break lab9;
						}
						break lab7;
					} while (false);
					this.cursor = this.limit - v_3;
					lab10: do {
						if (!this.r_mark_yUm$esjava$0()) {
							break lab10;
						}
						break lab7;
					} while (false);
					this.cursor = this.limit - v_3;
					lab11: do {
						if (!this.r_mark_sUn$esjava$0()) {
							break lab11;
						}
						break lab7;
					} while (false);
					this.cursor = this.limit - v_3;
					lab12: do {
						if (!this.r_mark_yUz$esjava$0()) {
							break lab12;
						}
						break lab7;
					} while (false);
					this.cursor = this.limit - v_3;
				} while (false);
				if (!this.r_mark_ymUs_$esjava$0()) {
					break lab6;
				}
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab13: do {
				if (!this.r_mark_lAr$esjava$0()) {
					break lab13;
				}
				this.bra = this.cursor;
				this.slice_del$esjava$0();
				v_4 = this.limit - this.cursor;
				lab14: do {
					this.ket = this.cursor;
					lab15: do {
						v_5 = this.limit - this.cursor;
						lab16: do {
							if (!this.r_mark_DUr$esjava$0()) {
								break lab16;
							}
							break lab15;
						} while (false);
						this.cursor = this.limit - v_5;
						lab17: do {
							if (!this.r_mark_yDU$esjava$0()) {
								break lab17;
							}
							break lab15;
						} while (false);
						this.cursor = this.limit - v_5;
						lab18: do {
							if (!this.r_mark_ysA$esjava$0()) {
								break lab18;
							}
							break lab15;
						} while (false);
						this.cursor = this.limit - v_5;
						if (!this.r_mark_ymUs_$esjava$0()) {
							this.cursor = this.limit - v_4;
							break lab14;
						}
					} while (false);
				} while (false);
				this.B_continue_stemming_noun_suffixes = false;
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab19: do {
				if (!this.r_mark_nUz$esjava$0()) {
					break lab19;
				}
				lab20: do {
					v_6 = this.limit - this.cursor;
					lab21: do {
						if (!this.r_mark_yDU$esjava$0()) {
							break lab21;
						}
						break lab20;
					} while (false);
					this.cursor = this.limit - v_6;
					if (!this.r_mark_ysA$esjava$0()) {
						break lab19;
					}
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab22: do {
				lab23: do {
					v_7 = this.limit - this.cursor;
					lab24: do {
						if (!this.r_mark_sUnUz$esjava$0()) {
							break lab24;
						}
						break lab23;
					} while (false);
					this.cursor = this.limit - v_7;
					lab25: do {
						if (!this.r_mark_yUz$esjava$0()) {
							break lab25;
						}
						break lab23;
					} while (false);
					this.cursor = this.limit - v_7;
					lab26: do {
						if (!this.r_mark_sUn$esjava$0()) {
							break lab26;
						}
						break lab23;
					} while (false);
					this.cursor = this.limit - v_7;
					if (!this.r_mark_yUm$esjava$0()) {
						break lab22;
					}
				} while (false);
				this.bra = this.cursor;
				this.slice_del$esjava$0();
				v_8 = this.limit - this.cursor;
				lab27: do {
					this.ket = this.cursor;
					if (!this.r_mark_ymUs_$esjava$0()) {
						this.cursor = this.limit - v_8;
						break lab27;
					}
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			if (!this.r_mark_DUr$esjava$0()) {
				return false;
			}
			this.bra = this.cursor;
			this.slice_del$esjava$0();
			v_9 = this.limit - this.cursor;
			lab28: do {
				this.ket = this.cursor;
				lab29: do {
					v_10 = this.limit - this.cursor;
					lab30: do {
						if (!this.r_mark_sUnUz$esjava$0()) {
							break lab30;
						}
						break lab29;
					} while (false);
					this.cursor = this.limit - v_10;
					lab31: do {
						if (!this.r_mark_lAr$esjava$0()) {
							break lab31;
						}
						break lab29;
					} while (false);
					this.cursor = this.limit - v_10;
					lab32: do {
						if (!this.r_mark_yUm$esjava$0()) {
							break lab32;
						}
						break lab29;
					} while (false);
					this.cursor = this.limit - v_10;
					lab33: do {
						if (!this.r_mark_sUn$esjava$0()) {
							break lab33;
						}
						break lab29;
					} while (false);
					this.cursor = this.limit - v_10;
					lab34: do {
						if (!this.r_mark_yUz$esjava$0()) {
							break lab34;
						}
						break lab29;
					} while (false);
					this.cursor = this.limit - v_10;
				} while (false);
				if (!this.r_mark_ymUs_$esjava$0()) {
					this.cursor = this.limit - v_9;
					break lab28;
				}
			} while (false);
		} while (false);
		this.bra = this.cursor;
		this.slice_del$esjava$0();
		return true;
	}

	r_stem_suffix_chain_before_ki$esjava$0() {
		let v_1;
		let v_2;
		let v_3;
		let v_4;
		let v_5;
		let v_6;
		let v_7;
		let v_8;
		let v_9;
		let v_10;
		let v_11;
		this.ket = this.cursor;
		if (!this.r_mark_ki$esjava$0()) {
			return false;
		}
		lab0: do {
			v_1 = this.limit - this.cursor;
			lab1: do {
				if (!this.r_mark_DA$esjava$0()) {
					break lab1;
				}
				this.bra = this.cursor;
				this.slice_del$esjava$0();
				v_2 = this.limit - this.cursor;
				lab2: do {
					this.ket = this.cursor;
					lab3: do {
						v_3 = this.limit - this.cursor;
						lab4: do {
							if (!this.r_mark_lAr$esjava$0()) {
								break lab4;
							}
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							v_4 = this.limit - this.cursor;
							lab5: do {
								if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
									this.cursor = this.limit - v_4;
									break lab5;
								}
							} while (false);
							break lab3;
						} while (false);
						this.cursor = this.limit - v_3;
						if (!this.r_mark_possessives$esjava$0()) {
							this.cursor = this.limit - v_2;
							break lab2;
						}
						this.bra = this.cursor;
						this.slice_del$esjava$0();
						v_5 = this.limit - this.cursor;
						lab6: do {
							this.ket = this.cursor;
							if (!this.r_mark_lAr$esjava$0()) {
								this.cursor = this.limit - v_5;
								break lab6;
							}
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
								this.cursor = this.limit - v_5;
								break lab6;
							}
						} while (false);
					} while (false);
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab7: do {
				if (!this.r_mark_nUn$esjava$0()) {
					break lab7;
				}
				this.bra = this.cursor;
				this.slice_del$esjava$0();
				v_6 = this.limit - this.cursor;
				lab8: do {
					this.ket = this.cursor;
					lab9: do {
						v_7 = this.limit - this.cursor;
						lab10: do {
							if (!this.r_mark_lArI$esjava$0()) {
								break lab10;
							}
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							break lab9;
						} while (false);
						this.cursor = this.limit - v_7;
						lab11: do {
							this.ket = this.cursor;
							lab12: do {
								v_8 = this.limit - this.cursor;
								lab13: do {
									if (!this.r_mark_possessives$esjava$0()) {
										break lab13;
									}
									break lab12;
								} while (false);
								this.cursor = this.limit - v_8;
								if (!this.r_mark_sU$esjava$0()) {
									break lab11;
								}
							} while (false);
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							v_9 = this.limit - this.cursor;
							lab14: do {
								this.ket = this.cursor;
								if (!this.r_mark_lAr$esjava$0()) {
									this.cursor = this.limit - v_9;
									break lab14;
								}
								this.bra = this.cursor;
								this.slice_del$esjava$0();
								if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
									this.cursor = this.limit - v_9;
									break lab14;
								}
							} while (false);
							break lab9;
						} while (false);
						this.cursor = this.limit - v_7;
						if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
							this.cursor = this.limit - v_6;
							break lab8;
						}
					} while (false);
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			if (!this.r_mark_ndA$esjava$0()) {
				return false;
			}
			lab15: do {
				v_10 = this.limit - this.cursor;
				lab16: do {
					if (!this.r_mark_lArI$esjava$0()) {
						break lab16;
					}
					this.bra = this.cursor;
					this.slice_del$esjava$0();
					break lab15;
				} while (false);
				this.cursor = this.limit - v_10;
				lab17: do {
					if (!this.r_mark_sU$esjava$0()) {
						break lab17;
					}
					this.bra = this.cursor;
					this.slice_del$esjava$0();
					v_11 = this.limit - this.cursor;
					lab18: do {
						this.ket = this.cursor;
						if (!this.r_mark_lAr$esjava$0()) {
							this.cursor = this.limit - v_11;
							break lab18;
						}
						this.bra = this.cursor;
						this.slice_del$esjava$0();
						if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
							this.cursor = this.limit - v_11;
							break lab18;
						}
					} while (false);
					break lab15;
				} while (false);
				this.cursor = this.limit - v_10;
				if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
					return false;
				}
			} while (false);
		} while (false);
		return true;
	}

	r_stem_noun_suffixes$esjava$0() {
		let v_1;
		let v_2;
		let v_3;
		let v_4;
		let v_5;
		let v_6;
		let v_7;
		let v_8;
		let v_9;
		let v_10;
		let v_11;
		let v_12;
		let v_13;
		let v_14;
		let v_15;
		let v_16;
		let v_17;
		let v_18;
		let v_19;
		let v_20;
		let v_21;
		let v_22;
		let v_23;
		let v_24;
		let v_25;
		let v_26;
		let v_27;
		lab0: do {
			v_1 = this.limit - this.cursor;
			lab1: do {
				this.ket = this.cursor;
				if (!this.r_mark_lAr$esjava$0()) {
					break lab1;
				}
				this.bra = this.cursor;
				this.slice_del$esjava$0();
				v_2 = this.limit - this.cursor;
				lab2: do {
					if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
						this.cursor = this.limit - v_2;
						break lab2;
					}
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab3: do {
				this.ket = this.cursor;
				if (!this.r_mark_ncA$esjava$0()) {
					break lab3;
				}
				this.bra = this.cursor;
				this.slice_del$esjava$0();
				v_3 = this.limit - this.cursor;
				lab4: do {
					lab5: do {
						v_4 = this.limit - this.cursor;
						lab6: do {
							this.ket = this.cursor;
							if (!this.r_mark_lArI$esjava$0()) {
								break lab6;
							}
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							break lab5;
						} while (false);
						this.cursor = this.limit - v_4;
						lab7: do {
							this.ket = this.cursor;
							lab8: do {
								v_5 = this.limit - this.cursor;
								lab9: do {
									if (!this.r_mark_possessives$esjava$0()) {
										break lab9;
									}
									break lab8;
								} while (false);
								this.cursor = this.limit - v_5;
								if (!this.r_mark_sU$esjava$0()) {
									break lab7;
								}
							} while (false);
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							v_6 = this.limit - this.cursor;
							lab10: do {
								this.ket = this.cursor;
								if (!this.r_mark_lAr$esjava$0()) {
									this.cursor = this.limit - v_6;
									break lab10;
								}
								this.bra = this.cursor;
								this.slice_del$esjava$0();
								if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
									this.cursor = this.limit - v_6;
									break lab10;
								}
							} while (false);
							break lab5;
						} while (false);
						this.cursor = this.limit - v_4;
						this.ket = this.cursor;
						if (!this.r_mark_lAr$esjava$0()) {
							this.cursor = this.limit - v_3;
							break lab4;
						}
						this.bra = this.cursor;
						this.slice_del$esjava$0();
						if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
							this.cursor = this.limit - v_3;
							break lab4;
						}
					} while (false);
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab11: do {
				this.ket = this.cursor;
				lab12: do {
					v_7 = this.limit - this.cursor;
					lab13: do {
						if (!this.r_mark_ndA$esjava$0()) {
							break lab13;
						}
						break lab12;
					} while (false);
					this.cursor = this.limit - v_7;
					if (!this.r_mark_nA$esjava$0()) {
						break lab11;
					}
				} while (false);
				lab14: do {
					v_8 = this.limit - this.cursor;
					lab15: do {
						if (!this.r_mark_lArI$esjava$0()) {
							break lab15;
						}
						this.bra = this.cursor;
						this.slice_del$esjava$0();
						break lab14;
					} while (false);
					this.cursor = this.limit - v_8;
					lab16: do {
						if (!this.r_mark_sU$esjava$0()) {
							break lab16;
						}
						this.bra = this.cursor;
						this.slice_del$esjava$0();
						v_9 = this.limit - this.cursor;
						lab17: do {
							this.ket = this.cursor;
							if (!this.r_mark_lAr$esjava$0()) {
								this.cursor = this.limit - v_9;
								break lab17;
							}
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
								this.cursor = this.limit - v_9;
								break lab17;
							}
						} while (false);
						break lab14;
					} while (false);
					this.cursor = this.limit - v_8;
					if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
						break lab11;
					}
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab18: do {
				this.ket = this.cursor;
				lab19: do {
					v_10 = this.limit - this.cursor;
					lab20: do {
						if (!this.r_mark_ndAn$esjava$0()) {
							break lab20;
						}
						break lab19;
					} while (false);
					this.cursor = this.limit - v_10;
					if (!this.r_mark_nU$esjava$0()) {
						break lab18;
					}
				} while (false);
				lab21: do {
					v_11 = this.limit - this.cursor;
					lab22: do {
						if (!this.r_mark_sU$esjava$0()) {
							break lab22;
						}
						this.bra = this.cursor;
						this.slice_del$esjava$0();
						v_12 = this.limit - this.cursor;
						lab23: do {
							this.ket = this.cursor;
							if (!this.r_mark_lAr$esjava$0()) {
								this.cursor = this.limit - v_12;
								break lab23;
							}
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
								this.cursor = this.limit - v_12;
								break lab23;
							}
						} while (false);
						break lab21;
					} while (false);
					this.cursor = this.limit - v_11;
					if (!this.r_mark_lArI$esjava$0()) {
						break lab18;
					}
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab24: do {
				this.ket = this.cursor;
				if (!this.r_mark_DAn$esjava$0()) {
					break lab24;
				}
				this.bra = this.cursor;
				this.slice_del$esjava$0();
				v_13 = this.limit - this.cursor;
				lab25: do {
					this.ket = this.cursor;
					lab26: do {
						v_14 = this.limit - this.cursor;
						lab27: do {
							if (!this.r_mark_possessives$esjava$0()) {
								break lab27;
							}
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							v_15 = this.limit - this.cursor;
							lab28: do {
								this.ket = this.cursor;
								if (!this.r_mark_lAr$esjava$0()) {
									this.cursor = this.limit - v_15;
									break lab28;
								}
								this.bra = this.cursor;
								this.slice_del$esjava$0();
								if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
									this.cursor = this.limit - v_15;
									break lab28;
								}
							} while (false);
							break lab26;
						} while (false);
						this.cursor = this.limit - v_14;
						lab29: do {
							if (!this.r_mark_lAr$esjava$0()) {
								break lab29;
							}
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							v_16 = this.limit - this.cursor;
							lab30: do {
								if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
									this.cursor = this.limit - v_16;
									break lab30;
								}
							} while (false);
							break lab26;
						} while (false);
						this.cursor = this.limit - v_14;
						if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
							this.cursor = this.limit - v_13;
							break lab25;
						}
					} while (false);
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab31: do {
				this.ket = this.cursor;
				lab32: do {
					v_17 = this.limit - this.cursor;
					lab33: do {
						if (!this.r_mark_nUn$esjava$0()) {
							break lab33;
						}
						break lab32;
					} while (false);
					this.cursor = this.limit - v_17;
					if (!this.r_mark_ylA$esjava$0()) {
						break lab31;
					}
				} while (false);
				this.bra = this.cursor;
				this.slice_del$esjava$0();
				v_18 = this.limit - this.cursor;
				lab34: do {
					lab35: do {
						v_19 = this.limit - this.cursor;
						lab36: do {
							this.ket = this.cursor;
							if (!this.r_mark_lAr$esjava$0()) {
								break lab36;
							}
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
								break lab36;
							}
							break lab35;
						} while (false);
						this.cursor = this.limit - v_19;
						lab37: do {
							this.ket = this.cursor;
							lab38: do {
								v_20 = this.limit - this.cursor;
								lab39: do {
									if (!this.r_mark_possessives$esjava$0()) {
										break lab39;
									}
									break lab38;
								} while (false);
								this.cursor = this.limit - v_20;
								if (!this.r_mark_sU$esjava$0()) {
									break lab37;
								}
							} while (false);
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							v_21 = this.limit - this.cursor;
							lab40: do {
								this.ket = this.cursor;
								if (!this.r_mark_lAr$esjava$0()) {
									this.cursor = this.limit - v_21;
									break lab40;
								}
								this.bra = this.cursor;
								this.slice_del$esjava$0();
								if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
									this.cursor = this.limit - v_21;
									break lab40;
								}
							} while (false);
							break lab35;
						} while (false);
						this.cursor = this.limit - v_19;
						if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
							this.cursor = this.limit - v_18;
							break lab34;
						}
					} while (false);
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab41: do {
				this.ket = this.cursor;
				if (!this.r_mark_lArI$esjava$0()) {
					break lab41;
				}
				this.bra = this.cursor;
				this.slice_del$esjava$0();
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab42: do {
				if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
					break lab42;
				}
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			lab43: do {
				this.ket = this.cursor;
				lab44: do {
					v_22 = this.limit - this.cursor;
					lab45: do {
						if (!this.r_mark_DA$esjava$0()) {
							break lab45;
						}
						break lab44;
					} while (false);
					this.cursor = this.limit - v_22;
					lab46: do {
						if (!this.r_mark_yU$esjava$0()) {
							break lab46;
						}
						break lab44;
					} while (false);
					this.cursor = this.limit - v_22;
					if (!this.r_mark_yA$esjava$0()) {
						break lab43;
					}
				} while (false);
				this.bra = this.cursor;
				this.slice_del$esjava$0();
				v_23 = this.limit - this.cursor;
				lab47: do {
					this.ket = this.cursor;
					lab48: do {
						v_24 = this.limit - this.cursor;
						lab49: do {
							if (!this.r_mark_possessives$esjava$0()) {
								break lab49;
							}
							this.bra = this.cursor;
							this.slice_del$esjava$0();
							v_25 = this.limit - this.cursor;
							lab50: do {
								this.ket = this.cursor;
								if (!this.r_mark_lAr$esjava$0()) {
									this.cursor = this.limit - v_25;
									break lab50;
								}
							} while (false);
							break lab48;
						} while (false);
						this.cursor = this.limit - v_24;
						if (!this.r_mark_lAr$esjava$0()) {
							this.cursor = this.limit - v_23;
							break lab47;
						}
					} while (false);
					this.bra = this.cursor;
					this.slice_del$esjava$0();
					this.ket = this.cursor;
					if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
						this.cursor = this.limit - v_23;
						break lab47;
					}
				} while (false);
				break lab0;
			} while (false);
			this.cursor = this.limit - v_1;
			this.ket = this.cursor;
			lab51: do {
				v_26 = this.limit - this.cursor;
				lab52: do {
					if (!this.r_mark_possessives$esjava$0()) {
						break lab52;
					}
					break lab51;
				} while (false);
				this.cursor = this.limit - v_26;
				if (!this.r_mark_sU$esjava$0()) {
					return false;
				}
			} while (false);
			this.bra = this.cursor;
			this.slice_del$esjava$0();
			v_27 = this.limit - this.cursor;
			lab53: do {
				this.ket = this.cursor;
				if (!this.r_mark_lAr$esjava$0()) {
					this.cursor = this.limit - v_27;
					break lab53;
				}
				this.bra = this.cursor;
				this.slice_del$esjava$0();
				if (!this.r_stem_suffix_chain_before_ki$esjava$0()) {
					this.cursor = this.limit - v_27;
					break lab53;
				}
			} while (false);
		} while (false);
		return true;
	}

	r_post_process_last_consonants$esjava$0() {
		let among_var;
		this.ket = this.cursor;
		among_var = this.find_among_b$esjava$2(TurkishStemmer.a_23, 4);
		if (among_var === 0) {
			return false;
		}
		this.bra = this.cursor;
		switch (among_var) {
			case 0:
				return false;
			case 1:
				this.slice_from$esjava$1("p");
				break;
			case 2:
				this.slice_from$esjava$1("\u00E7");
				break;
			case 3:
				this.slice_from$esjava$1("t");
				break;
			case 4:
				this.slice_from$esjava$1("k");
				break;
		}
		return true;
	}

	r_append_U_to_stems_ending_with_d_or_g$esjava$0() {
		let v_1;
		let v_2;
		let v_3;
		let v_4;
		let v_5;
		let v_6;
		let v_7;
		let v_8;
		let v_9;
		let v_10;
		let v_11;
		let v_12;
		let v_13;
		let v_14;
		let v_15;
		v_1 = this.limit - this.cursor;
		lab0: do {
			v_2 = this.limit - this.cursor;
			lab1: do {
				if (!this.eq_s_b$esjava$2(1, "d")) {
					break lab1;
				}
				break lab0;
			} while (false);
			this.cursor = this.limit - v_2;
			if (!this.eq_s_b$esjava$2(1, "g")) {
				return false;
			}
		} while (false);
		this.cursor = this.limit - v_1;
		lab2: do {
			v_3 = this.limit - this.cursor;
			lab3: do {
				v_4 = this.limit - this.cursor;
				golab4: while (true) {
					v_5 = this.limit - this.cursor;
					lab5: do {
						if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
							break lab5;
						}
						this.cursor = this.limit - v_5;
						break golab4;
					} while (false);
					this.cursor = this.limit - v_5;
					if (this.cursor <= this.limit_backward) {
						break lab3;
					}
					this.cursor--;
				}
				lab6: do {
					v_6 = this.limit - this.cursor;
					lab7: do {
						if (!this.eq_s_b$esjava$2(1, "a")) {
							break lab7;
						}
						break lab6;
					} while (false);
					this.cursor = this.limit - v_6;
					if (!this.eq_s_b$esjava$2(1, "\u0131")) {
						break lab3;
					}
				} while (false);
				this.cursor = this.limit - v_4;
				{
					const c = this.cursor;
					this.insert$esjava$3(this.cursor, this.cursor, "\u0131");
					this.cursor = c;
				}
				break lab2;
			} while (false);
			this.cursor = this.limit - v_3;
			lab8: do {
				v_7 = this.limit - this.cursor;
				golab9: while (true) {
					v_8 = this.limit - this.cursor;
					lab10: do {
						if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
							break lab10;
						}
						this.cursor = this.limit - v_8;
						break golab9;
					} while (false);
					this.cursor = this.limit - v_8;
					if (this.cursor <= this.limit_backward) {
						break lab8;
					}
					this.cursor--;
				}
				lab11: do {
					v_9 = this.limit - this.cursor;
					lab12: do {
						if (!this.eq_s_b$esjava$2(1, "e")) {
							break lab12;
						}
						break lab11;
					} while (false);
					this.cursor = this.limit - v_9;
					if (!this.eq_s_b$esjava$2(1, "i")) {
						break lab8;
					}
				} while (false);
				this.cursor = this.limit - v_7;
				{
					const c = this.cursor;
					this.insert$esjava$3(this.cursor, this.cursor, "i");
					this.cursor = c;
				}
				break lab2;
			} while (false);
			this.cursor = this.limit - v_3;
			lab13: do {
				v_10 = this.limit - this.cursor;
				golab14: while (true) {
					v_11 = this.limit - this.cursor;
					lab15: do {
						if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
							break lab15;
						}
						this.cursor = this.limit - v_11;
						break golab14;
					} while (false);
					this.cursor = this.limit - v_11;
					if (this.cursor <= this.limit_backward) {
						break lab13;
					}
					this.cursor--;
				}
				lab16: do {
					v_12 = this.limit - this.cursor;
					lab17: do {
						if (!this.eq_s_b$esjava$2(1, "o")) {
							break lab17;
						}
						break lab16;
					} while (false);
					this.cursor = this.limit - v_12;
					if (!this.eq_s_b$esjava$2(1, "u")) {
						break lab13;
					}
				} while (false);
				this.cursor = this.limit - v_10;
				{
					const c = this.cursor;
					this.insert$esjava$3(this.cursor, this.cursor, "u");
					this.cursor = c;
				}
				break lab2;
			} while (false);
			this.cursor = this.limit - v_3;
			v_13 = this.limit - this.cursor;
			golab18: while (true) {
				v_14 = this.limit - this.cursor;
				lab19: do {
					if (!this.in_grouping_b$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
						break lab19;
					}
					this.cursor = this.limit - v_14;
					break golab18;
				} while (false);
				this.cursor = this.limit - v_14;
				if (this.cursor <= this.limit_backward) {
					return false;
				}
				this.cursor--;
			}
			lab20: do {
				v_15 = this.limit - this.cursor;
				lab21: do {
					if (!this.eq_s_b$esjava$2(1, "\u00F6")) {
						break lab21;
					}
					break lab20;
				} while (false);
				this.cursor = this.limit - v_15;
				if (!this.eq_s_b$esjava$2(1, "\u00FC")) {
					return false;
				}
			} while (false);
			this.cursor = this.limit - v_13;
			{
				const c = this.cursor;
				this.insert$esjava$3(this.cursor, this.cursor, "\u00FC");
				this.cursor = c;
			}
		} while (false);
		return true;
	}

	r_more_than_one_syllable_word$esjava$0() {
		let v_1;
		let v_3;
		v_1 = this.cursor;
		{
			let v_2 = 2;
			replab0: while (true) {
				v_3 = this.cursor;
				lab1: do {
					golab2: while (true) {
						lab3: do {
							if (!this.in_grouping$esjava$3(TurkishStemmer.g_vowel, 97, 305)) {
								break lab3;
							}
							break golab2;
						} while (false);
						if (this.cursor >= this.limit) {
							break lab1;
						}
						this.cursor++;
					}
					v_2--;
					continue replab0;
				} while (false);
				this.cursor = v_3;
				break replab0;
			}
			if (v_2 > 0) {
				return false;
			}
		}
		this.cursor = v_1;
		return true;
	}

	r_is_reserved_word$esjava$0() {
		let v_1;
		let v_2;
		let v_4;
		lab0: do {
			v_1 = this.cursor;
			lab1: do {
				v_2 = this.cursor;
				golab2: while (true) {
					lab3: do {
						if (!this.eq_s$esjava$2(2, "ad")) {
							break lab3;
						}
						break golab2;
					} while (false);
					if (this.cursor >= this.limit) {
						break lab1;
					}
					this.cursor++;
				}
				this.I_strlen = 2;
				if (!(this.I_strlen === this.limit)) {
					break lab1;
				}
				this.cursor = v_2;
				break lab0;
			} while (false);
			this.cursor = v_1;
			v_4 = this.cursor;
			golab4: while (true) {
				lab5: do {
					if (!this.eq_s$esjava$2(5, "soyad")) {
						break lab5;
					}
					break golab4;
				} while (false);
				if (this.cursor >= this.limit) {
					return false;
				}
				this.cursor++;
			}
			this.I_strlen = 5;
			if (!(this.I_strlen === this.limit)) {
				return false;
			}
			this.cursor = v_4;
		} while (false);
		return true;
	}

	r_postlude$esjava$0() {
		let v_1;
		let v_2;
		let v_3;
		{
			v_1 = this.cursor;
			lab0: do {
				if (!this.r_is_reserved_word$esjava$0()) {
					break lab0;
				}
				return false;
			} while (false);
			this.cursor = v_1;
		}
		this.limit_backward = this.cursor;
		this.cursor = this.limit;
		v_2 = this.limit - this.cursor;
		lab1: do {
			if (!this.r_append_U_to_stems_ending_with_d_or_g$esjava$0()) {
				break lab1;
			}
		} while (false);
		this.cursor = this.limit - v_2;
		v_3 = this.limit - this.cursor;
		lab2: do {
			if (!this.r_post_process_last_consonants$esjava$0()) {
				break lab2;
			}
		} while (false);
		this.cursor = this.limit - v_3;
		this.cursor = this.limit_backward;
		return true;
	}

	stem$esjava$0() {
		let v_1;
		let v_2;
		if (!this.r_more_than_one_syllable_word$esjava$0()) {
			return false;
		}
		this.limit_backward = this.cursor;
		this.cursor = this.limit;
		v_1 = this.limit - this.cursor;
		lab0: do {
			if (!this.r_stem_nominal_verb_suffixes$esjava$0()) {
				break lab0;
			}
		} while (false);
		this.cursor = this.limit - v_1;
		if (!this.B_continue_stemming_noun_suffixes) {
			return false;
		}
		v_2 = this.limit - this.cursor;
		lab1: do {
			if (!this.r_stem_noun_suffixes$esjava$0()) {
				break lab1;
			}
		} while (false);
		this.cursor = this.limit - v_2;
		this.cursor = this.limit_backward;
		if (!this.r_postlude$esjava$0()) {
			return false;
		}
		return true;
	}

	stem(...args) {
		switch (args.length) {
			case 0:
				return this.stem$esjava$0(...args);
		}
		return super.stem(...args);
	}
}

turkishStemmer.default = TurkishStemmer;

Object.defineProperty(stem$1, "__esModule", {
  value: true
});
stem$1.default = stem;

var _turkishStemmer = turkishStemmer;

var _turkishStemmer2 = _interopRequireDefault$2v(_turkishStemmer);

function _interopRequireDefault$2v(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Stems Turkish words.
 *
 * @param {string} word            The word to stem.
 * @param {Object} morphologyData  The Turkish morphology data.
 *
 * @returns {string} The stemmed word.
 */
function stem(word, morphologyData) {
  word = word.toLowerCase();

  const stemmer = new _turkishStemmer2.default(morphologyData);
  stemmer.setCurrent(word);
  stemmer.stem();

  return stemmer.getCurrent();
}

Object.defineProperty(getStemForLanguage, "__esModule", {
	value: true
});

getStemForLanguage.default = function () {
	return {
		en: _determineStem.determineStem,
		de: _determineStem2.determineStem,
		nl: _determineStem3.determineStem,
		es: _stem2.default,
		fr: _stem4.default,
		ru: _stem6.default,
		it: _stem8.default,
		pt: _stem10.default,
		id: _stem12.default,
		pl: _stem14.default,
		ar: _stem16.default,
		sv: _stem18.default,
		hu: _stem20.default,
		he: _stem22.default,
		nb: _stem24.default,
		tr: _stem26.default
	};
};

var _determineStem = determineStem$5;

var _determineStem2 = determineStem$3;

var _determineStem3 = determineStem$1;

var _stem = stem$p;

var _stem2 = _interopRequireDefault$2u(_stem);

var _stem3 = stem$n;

var _stem4 = _interopRequireDefault$2u(_stem3);

var _stem5 = stem$l;

var _stem6 = _interopRequireDefault$2u(_stem5);

var _stem7 = stem$j;

var _stem8 = _interopRequireDefault$2u(_stem7);

var _stem9 = stem$h;

var _stem10 = _interopRequireDefault$2u(_stem9);

var _stem11 = stem$f;

var _stem12 = _interopRequireDefault$2u(_stem11);

var _stem13 = stem$d;

var _stem14 = _interopRequireDefault$2u(_stem13);

var _stem15 = stem$b;

var _stem16 = _interopRequireDefault$2u(_stem15);

var _stem17 = stem$9;

var _stem18 = _interopRequireDefault$2u(_stem17);

var _stem19 = stem$7;

var _stem20 = _interopRequireDefault$2u(_stem19);

var _stem21 = stem$5;

var _stem22 = _interopRequireDefault$2u(_stem21);

var _stem23 = stem$3;

var _stem24 = _interopRequireDefault$2u(_stem23);

var _stem25 = stem$1;

var _stem26 = _interopRequireDefault$2u(_stem25);

function _interopRequireDefault$2u(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(getLanguagesWithWordFormSupport, "__esModule", {
  value: true
});

getLanguagesWithWordFormSupport.default = function () {
  return Object.keys((0, _getStemForLanguage2$1.default)());
};

var _getStemForLanguage$1 = getStemForLanguage;

var _getStemForLanguage2$1 = _interopRequireDefault$2t(_getStemForLanguage$1);

function _interopRequireDefault$2t(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(KeywordDensityAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1x = require$$1$1;

var _recommendedKeywordCount = recommendedKeywordCount;

var _recommendedKeywordCount2 = _interopRequireDefault$2s(_recommendedKeywordCount);

var _assessment$d = assessment;

var _assessment2$d = _interopRequireDefault$2s(_assessment$d);

var _getLanguage$j = getLanguage;

var _getLanguage2$j = _interopRequireDefault$2s(_getLanguage$j);

var _getLanguagesWithWordFormSupport = getLanguagesWithWordFormSupport;

var _getLanguagesWithWordFormSupport2 = _interopRequireDefault$2s(_getLanguagesWithWordFormSupport);

var _AssessmentResult$j = AssessmentResult$1;

var _AssessmentResult2$j = _interopRequireDefault$2s(_AssessmentResult$j);

var _inRange$3 = inRange;

var _shortlinker$i = shortlinker;

var _keyphraseLengthFactor = keyphraseLengthFactor;

var _keyphraseLengthFactor2 = _interopRequireDefault$2s(_keyphraseLengthFactor);

var _countWords$9 = countWords;

var _countWords2$9 = _interopRequireDefault$2s(_countWords$9);

function _interopRequireDefault$2s(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents the assessment that will look if the keyphrase density is within the recommended range.
 */
class KeywordDensityAssessment extends _assessment2$d.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  *
  * If word forms are not available:
  * @param {number} [config.parameters.noWordForms.overMaximum] The percentage of keyphrase instances in the text that
  * is way over the maximum.
  * @param {number} [config.parameters.noWordForms.maximum] The maximum percentage of keyphrase instances in the text.
  * @param {number} [config.parameters.noWordForms.minimum] The minimum percentage of keyphrase instances in the text.
  *
  * If word forms are available:
  * @param {number} [config.parameters.multipleWordForms.overMaximum] The percentage of keyphrase instances in the text that
  * is way over the maximum.
  * @param {number} [config.parameters.multipleWordForms.maximum] The maximum percentage of keyphrase instances in the text.
  * @param {number} [config.parameters.multipleWordForms.minimum] The minimum percentage of keyphrase instances in the text.
  *
  * @param {number} [config.scores.wayOverMaximum] The score to return if there are way too many instances of keyphrase in the text.
  * @param {number} [config.scores.overMaximum] The score to return if there are too many instances of keyphrase in the text.
  * @param {number} [config.scores.correctDensity] The score to return if there is a good number of keyphrase instances in the text.
  * @param {number} [config.scores.underMinimum] The score to return if there is not enough keyphrase instances in the text.
  *
  * @param {string} [config.url] The URL to the relevant KB article.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			parameters: {
				noWordForms: {
					overMaximum: 4,
					maximum: 3,
					minimum: 0.5
				},
				multipleWordForms: {
					overMaximum: 4,
					maximum: 3.5,
					minimum: 0.5
				}
			},
			scores: {
				wayOverMaximum: -50,
				overMaximum: -10,
				correctDensity: 9,
				underMinimum: 4
			},
			urlTitle: (0, _shortlinker$i.createAnchorOpeningTag)("https://yoa.st/33v"),
			urlCallToAction: (0, _shortlinker$i.createAnchorOpeningTag)("https://yoa.st/33w")
		};

		this.identifier = "keywordDensity";
		this._config = (0, _lodashEs$1x.merge)(defaultConfig, config);
	}

	/**
  * Determines correct boundaries depending on the availability
  * of morphological forms.
  *
  * @param {string} text The paper text.
  * @param {number} keyphraseLength The length of the keyphrase in words.
  *
  * @returns {void}
  */
	setBoundaries(text, keyphraseLength) {
		if (this._hasMorphologicalForms) {
			this._boundaries = this._config.parameters.multipleWordForms;
		} else {
			this._boundaries = this._config.parameters.noWordForms;
		}
		this._minRecommendedKeywordCount = (0, _recommendedKeywordCount2.default)(text, keyphraseLength, this._boundaries.minimum, "min");
		this._maxRecommendedKeywordCount = (0, _recommendedKeywordCount2.default)(text, keyphraseLength, this._boundaries.maximum, "max");
	}

	/**
  * Runs the keyphrase density module, based on this returns an assessment
  * result with score.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling the
  *                                research.
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {AssessmentResult} The result of the assessment.
  */
	getResult(paper, researcher, i18n) {
		this._hasMorphologicalForms = researcher.getData("morphology") !== false && (0, _getLanguagesWithWordFormSupport2.default)().includes((0, _getLanguage2$j.default)(paper.getLocale()));

		this._keywordCount = researcher.getResearch("keywordCount");
		const keyphraseLength = this._keywordCount.length;

		this.setBoundaries(paper.getText(), keyphraseLength);

		const assessmentResult = new _AssessmentResult2$j.default();

		this._keywordDensity = researcher.getResearch("getKeywordDensity");

		this._keywordDensity = this._keywordDensity * (0, _keyphraseLengthFactor2.default)(keyphraseLength);
		const calculatedScore = this.calculateResult(i18n);

		assessmentResult.setScore(calculatedScore.score);
		assessmentResult.setText(calculatedScore.resultText);
		assessmentResult.setHasMarks(this._keywordCount.count > 0);

		return assessmentResult;
	}

	/**
  * Checks whether there are no keyphrase matches in the text.
  *
  * @returns {boolean} Returns true if the keyphrase count is 0.
  */
	hasNoMatches() {
		return this._keywordCount.count === 0;
	}

	/**
  * Checks whether there are too few keyphrase matches in the text.
  *
  * @returns {boolean} Returns true if the rounded keyword density is between 0 and the recommended minimum
  * or if there there is only 1 keyword match (regardless of the density).
  */
	hasTooFewMatches() {
		return (0, _inRange$3.inRangeStartInclusive)(this._keywordDensity, 0, this._boundaries.minimum) || this._keywordCount.count === 1;
	}

	/**
  * Checks whether there is a good number of keyphrase matches in the text.
  *
  * @returns {boolean} Returns true if the rounded keyword density is between the recommended minimum
  * and the recommended maximum or if the keyword count is 2 and the recommended minimum is lower than 2.
  */
	hasGoodNumberOfMatches() {
		return (0, _inRange$3.inRangeStartEndInclusive)(this._keywordDensity, this._boundaries.minimum, this._boundaries.maximum) || this._keywordCount.count === 2 && this._minRecommendedKeywordCount <= 2;
	}

	/**
  * Checks whether the number of keyphrase matches in the text is between the
  * recommended maximum and the specified overMaximum value.
  *
  * @returns {boolean} Returns true if the rounded keyphrase density is between
  *                    the recommended maximum and the specified overMaximum
  *                    value.
  */
	hasTooManyMatches() {
		return (0, _inRange$3.inRangeEndInclusive)(this._keywordDensity, this._boundaries.maximum, this._boundaries.overMaximum);
	}

	/**
  * Returns the score for the keyphrase density.
  *
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {Object} The object with calculated score and resultText.
  */
	calculateResult(i18n) {
		if (this.hasNoMatches()) {
			return {
				score: this._config.scores.underMinimum,
				resultText: i18n.sprintf(
				/* Translators:
    %1$s and %4$s expand to links to Yoast.com,
    %2$s expands to the anchor end tag,
    %3$d expands to the recommended minimal number of times the keyphrase should occur in the text. */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase density%2$s: The focus keyphrase was found 0 times. " + "That's less than the recommended minimum of %3$d times for a text of this length. " + "%4$sFocus on your keyphrase%2$s!"), this._config.urlTitle, "</a>", this._minRecommendedKeywordCount, this._config.urlCallToAction)
			};
		}

		if (this.hasTooFewMatches()) {
			return {
				score: this._config.scores.underMinimum,
				resultText: i18n.sprintf(
				/* Translators:
    %1$s and %4$s expand to links to Yoast.com,
    %2$s expands to the anchor end tag,
    %3$d expands to the recommended minimal number of times the keyphrase should occur in the text,
    %5$d expands to the number of times the keyphrase occurred in the text. */
				i18n.dngettext("js-text-analysis", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d time. That's less than the " + "recommended minimum of %3$d times for a text of this length. %4$sFocus on your keyphrase%2$s!", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d times. That's less than the " + "recommended minimum of %3$d times for a text of this length. %4$sFocus on your keyphrase%2$s!", this._keywordCount.count), this._config.urlTitle, "</a>", this._minRecommendedKeywordCount, this._config.urlCallToAction, this._keywordCount.count)
			};
		}

		if (this.hasGoodNumberOfMatches()) {
			return {
				score: this._config.scores.correctDensity,
				resultText: i18n.sprintf(
				/* Translators:
    %1$s expands to a link to Yoast.com,
    %2$s expands to the anchor end tag,
    %3$d expands to the number of times the keyphrase occurred in the text. */
				i18n.dngettext("js-text-analysis", "%1$sKeyphrase density%2$s: The focus keyphrase was found %3$d time. This is great!", "%1$sKeyphrase density%2$s: The focus keyphrase was found %3$d times. This is great!", this._keywordCount.count), this._config.urlTitle, "</a>", this._keywordCount.count)
			};
		}

		if (this.hasTooManyMatches()) {
			return {
				score: this._config.scores.overMaximum,
				resultText: i18n.sprintf(
				/* Translators:
    %1$s and %4$s expand to links to Yoast.com,
    %2$s expands to the anchor end tag,
    %3$d expands to the recommended maximal number of times the keyphrase should occur in the text,
    %5$d expands to the number of times the keyphrase occurred in the text. */
				i18n.dngettext("js-text-analysis", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d time. That's more than the " + "recommended maximum of %3$d times for a text of this length. %4$sDon't overoptimize%2$s!", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d times. That's more than the " + "recommended maximum of %3$d times for a text of this length. %4$sDon't overoptimize%2$s!", this._keywordCount.count), this._config.urlTitle, "</a>", this._maxRecommendedKeywordCount, this._config.urlCallToAction, this._keywordCount.count)
			};
		}

		// Implicitly returns this if the rounded keyphrase density is higher than overMaximum.
		return {
			score: this._config.scores.wayOverMaximum,
			resultText: i18n.sprintf(
			/* Translators:
   %1$s and %4$s expand to links to Yoast.com,
   %2$s expands to the anchor end tag,
   %3$d expands to the recommended maximal number of times the keyphrase should occur in the text,
   %5$d expands to the number of times the keyphrase occurred in the text. */
			i18n.dngettext("js-text-analysis", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d time. That's way more than the " + "recommended maximum of %3$d times for a text of this length. %4$sDon't overoptimize%2$s!", "%1$sKeyphrase density%2$s: The focus keyphrase was found %5$d times. That's way more than the " + "recommended maximum of %3$d times for a text of this length. %4$sDon't overoptimize%2$s!", this._keywordCount.count), this._config.urlTitle, "</a>", this._maxRecommendedKeywordCount, this._config.urlCallToAction, this._keywordCount.count)
		};
	}

	/**
  * Marks keywords in the text for the keyword density assessment.
  *
  * @returns {Array<Mark>} Marks that should be applied.
  */
	getMarks() {
		return this._keywordCount.markings;
	}

	/**
  * Checks whether the paper has a text with at least 100 words and a keyword
  * is set.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True if applicable.
  */
	isApplicable(paper) {
		return paper.hasText() && paper.hasKeyword() && (0, _countWords2$9.default)(paper.getText()) >= 100;
	}
}

KeywordDensityAssessment$1.default = KeywordDensityAssessment;

var keywordStopWordsAssessment = {};

Object.defineProperty(keywordStopWordsAssessment, "__esModule", {
	value: true
});

var _getLanguageAvailability$1 = getLanguageAvailability;

var _getLanguageAvailability2$1 = _interopRequireDefault$2r(_getLanguageAvailability$1);

var _shortlinker$h = shortlinker;

var _AssessmentResult$i = AssessmentResult$1;

var _AssessmentResult2$i = _interopRequireDefault$2r(_AssessmentResult$i);

function _interopRequireDefault$2r(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const availableLanguages$1 = ["en"];

/**
 * Calculate the score based on the amount of stop words in the keyword.
 *
 * @param {number} stopWordCount The amount of stop words to be checked against.
 * @param {Jed} i18n The locale object.
 *
 * @returns {Object} The resulting score object.
 *
 * @deprecated
 */
var calculateStopWordsCountResult = function calculateStopWordsCountResult(stopWordCount, i18n) {
	if (stopWordCount > 0) {
		return {
			score: 0,
			text: i18n.dngettext("js-text-analysis",
			/* Translators: %1$s and %2$s open links to Yoast articles, %3$s is the anchor end tag */
			"%1$sStopwords%3$s: The keyphrase contains stop words. " + "This may or may not be wise depending on the circumstances. " + "%2$sLearn more about stop words%3$s.")
		};
	}

	return {};
};

/**
 * Execute the Assessment and return a result.
 *
 * @param {Paper} paper The Paper object to assess.
 * @param {Researcher} researcher The Researcher object containing all available researches.
 * @param {Jed} i18n The locale object.
 *
 * @returns {AssessmentResult} The result of the assessment, containing both a score and a descriptive text.
 */
const keywordHasStopWordsAssessment = function keywordHasStopWordsAssessment(paper, researcher, i18n) {
	var stopWords = researcher.getResearch("stopWordsInKeyword");
	var stopWordsResult = calculateStopWordsCountResult(stopWords.length, i18n);

	var assessmentResult = new _AssessmentResult2$i.default();
	assessmentResult.setScore(stopWordsResult.score);
	assessmentResult.setText(i18n.sprintf(stopWordsResult.text, (0, _shortlinker$h.createAnchorOpeningTag)("https://yoa.st/34b"), (0, _shortlinker$h.createAnchorOpeningTag)("https://yoa.st/34c"), "</a>", stopWords.length));

	return assessmentResult;
};

/**
 * Checks if the keyword stopwords assessment is applicable to the paper.
 *
 * @param {Object} paper The paper to check.
 *
 * @returns {boolean} Returns true if the language is available and the paper has a keyword.
 */
const isApplicable$1 = function isApplicable(paper) {
	const isLanguageAvailable = (0, _getLanguageAvailability2$1.default)(paper.getLocale(), availableLanguages$1);
	return paper.hasKeyword() && isLanguageAvailable;
};

keywordStopWordsAssessment.default = {
	identifier: "keywordStopWords",
	getResult: keywordHasStopWordsAssessment,
	isApplicable: isApplicable$1
};

var MetaDescriptionKeywordAssessment$1 = {};

Object.defineProperty(MetaDescriptionKeywordAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1w = require$$1$1;

var _assessment$c = assessment;

var _assessment2$c = _interopRequireDefault$2q(_assessment$c);

var _shortlinker$g = shortlinker;

var _AssessmentResult$h = AssessmentResult$1;

var _AssessmentResult2$h = _interopRequireDefault$2q(_AssessmentResult$h);

function _interopRequireDefault$2q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assessment for checking the keyword matches in the meta description.
 */
class MetaDescriptionKeywordAssessment extends _assessment2$c.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  * @param {number} [config.parameters.recommendedMinimum] The recommended minimum of keyword occurrences in the meta description.
  * @param {number} [config.scores.good] The score to return if there are enough keyword occurrences in the meta description.
  * @param {number} [config.scores.bad] The score to return if there aren't enough keyword occurrences in the meta description.
  * @param {string} [config.url] The URL to the relevant article on Yoast.com.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			parameters: {
				recommendedMinimum: 1
			},
			scores: {
				good: 9,
				ok: 6,
				bad: 3
			},
			urlTitle: (0, _shortlinker$g.createAnchorOpeningTag)("https://yoa.st/33k"),
			urlCallToAction: (0, _shortlinker$g.createAnchorOpeningTag)("https://yoa.st/33l")
		};

		this.identifier = "metaDescriptionKeyword";
		this._config = (0, _lodashEs$1w.merge)(defaultConfig, config);
	}

	/**
  * Runs the metaDescriptionKeyword researcher and based on this, returns an assessment result with score.
  *
  * @param {Paper}      paper      The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {Jed}        i18n       The object used for translations.
  *
  * @returns {AssessmentResult} The assessment result.
  */
	getResult(paper, researcher, i18n) {
		this._keyphraseCounts = researcher.getResearch("metaDescriptionKeyword");
		const assessmentResult = new _AssessmentResult2$h.default();
		const calculatedResult = this.calculateResult(i18n);

		assessmentResult.setScore(calculatedResult.score);
		assessmentResult.setText(calculatedResult.resultText);

		return assessmentResult;
	}

	/**
  * Returns the result object based on the number of keyword matches in the meta description.
  *
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {Object} Result object with score and text.
  */
	calculateResult(i18n) {
		// GOOD result when the meta description contains a keyphrase or synonym 1 or 2 times.
		if (this._keyphraseCounts === 1 || this._keyphraseCounts === 2) {
			return {
				score: this._config.scores.good,
				resultText: i18n.sprintf(
				/* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in meta description%2$s: Keyphrase or synonym appear in the meta description. Well done!"), this._config.urlTitle, "</a>")
			};
		}

		// BAD if the description contains every keyword term more than twice.
		if (this._keyphraseCounts >= 3) {
			return {
				score: this._config.scores.bad,
				resultText: i18n.sprintf(
				/**
     * Translators:
     * %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag,
     * %3$s expands to the number of sentences containing the keyphrase,
     * %4$s expands to a link on yoast.com, %5$s expands to the anchor end tag.
     */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in meta description%2$s: The meta description contains the keyphrase %3$s times, " + "which is over the advised maximum of 2 times. %4$sLimit that%5$s!"), this._config.urlTitle, "</a>", this._keyphraseCounts, this._config.urlCallToAction, "</a>")
			};
		}

		// BAD if the keyphrases is not contained in the meta description.
		return {
			score: this._config.scores.bad,
			resultText: i18n.sprintf(
			/**
    * Translators:
    * %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag.
    * %3$s expands to a link on yoast.com, %4$s expands to the anchor end tag.
    */
			i18n.dgettext("js-text-analysis", "%1$sKeyphrase in meta description%2$s: The meta description has been specified, " + "but it does not contain the keyphrase. %3$sFix that%4$s!"), this._config.urlTitle, "</a>", this._config.urlCallToAction, "</a>")
		};
	}

	/**
  * Checks whether the paper has a keyword and a meta description.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True if the paper has a keyword and a meta description.
  */
	isApplicable(paper) {
		return paper.hasKeyword() && paper.hasDescription();
	}
}

MetaDescriptionKeywordAssessment$1.default = MetaDescriptionKeywordAssessment;

var MetaDescriptionLengthAssessment$1 = {};

var config$2 = {};

Object.defineProperty(config$2, "__esModule", {
	value: true
});
const analyzerConfig = {
	queue: ["wordCount", "keywordDensity", "subHeadings", "stopwords", "fleschReading", "linkCount", "imageCount", "urlKeyword", "urlLength", "metaDescriptionLength", "metaDescriptionKeyword", "pageTitleKeyword", "pageTitleLength", "firstParagraph", "urlStopwords", "keywordDoubles", "keyphraseSizeCheck"],
	stopWords: ["a", "about", "above", "after", "again", "against", "all", "am", "an", "and", "any", "are", "as", "at", "be", "because", "been", "before", "being", "below", "between", "both", "but", "by", "could", "did", "do", "does", "doing", "down", "during", "each", "few", "for", "from", "further", "had", "has", "have", "having", "he", "he'd", "he'll", "he's", "her", "here", "here's", "hers", "herself", "him", "himself", "his", "how", "how's", "i", "i'd", "i'll", "i'm", "i've", "if", "in", "into", "is", "it", "it's", "its", "itself", "let's", "me", "more", "most", "my", "myself", "nor", "of", "on", "once", "only", "or", "other", "ought", "our", "ours", "ourselves", "out", "over", "own", "same", "she", "she'd", "she'll", "she's", "should", "so", "some", "such", "than", "that", "that's", "the", "their", "theirs", "them", "themselves", "then", "there", "there's", "these", "they", "they'd", "they'll", "they're", "they've", "this", "those", "through", "to", "too", "under", "until", "up", "very", "was", "we", "we'd", "we'll", "we're", "we've", "were", "what", "what's", "when", "when's", "where", "where's", "which", "while", "who", "who's", "whom", "why", "why's", "with", "would", "you", "you'd", "you'll", "you're", "you've", "your", "yours", "yourself", "yourselves"],
	wordsToRemove: [" a", " in", " an", " on", " for", " the", " and"],
	maxSlugLength: 20,
	maxUrlLength: 40,
	maxMeta: 156
};

config$2.default = analyzerConfig;

Object.defineProperty(MetaDescriptionLengthAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1v = require$$1$1;

var _assessment$b = assessment;

var _assessment2$b = _interopRequireDefault$2p(_assessment$b);

var _config$2 = config$2;

var _config2$1 = _interopRequireDefault$2p(_config$2);

var _shortlinker$f = shortlinker;

var _AssessmentResult$g = AssessmentResult$1;

var _AssessmentResult2$g = _interopRequireDefault$2p(_AssessmentResult$g);

function _interopRequireDefault$2p(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const maximumMetaDescriptionLength$1 = _config2$1.default.maxMeta;

/**
 * Assessment for calculating the length of the meta description.
 */
class MetaDescriptionLengthAssessment extends _assessment2$b.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			recommendedMaximumLength: 120,
			maximumLength: maximumMetaDescriptionLength$1,
			scores: {
				noMetaDescription: 1,
				tooLong: 6,
				tooShort: 6,
				correctLength: 9
			},
			urlTitle: (0, _shortlinker$f.createAnchorOpeningTag)("https://yoa.st/34d"),
			urlCallToAction: (0, _shortlinker$f.createAnchorOpeningTag)("https://yoa.st/34e")
		};

		this.identifier = "metaDescriptionLength";
		this._config = (0, _lodashEs$1v.merge)(defaultConfig, config);
	}

	/**
  * Returns the maximum length.
  *
  * @returns {number} The maximum length.
  */
	getMaximumLength() {
		return this._config.maximumLength;
	}

	/**
  * Runs the metaDescriptionLength module, based on this returns an assessment result with score.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {Jed} i18n The object used for translations
  *
  * @returns {AssessmentResult} The assessment result.
  */
	getResult(paper, researcher, i18n) {
		const descriptionLength = researcher.getResearch("metaDescriptionLength");
		const assessmentResult = new _AssessmentResult2$g.default();

		assessmentResult.setScore(this.calculateScore(descriptionLength));
		assessmentResult.setText(this.translateScore(descriptionLength, i18n));

		// Max and actual are used in the snippet editor progress bar.
		assessmentResult.max = this._config.maximumLength;
		assessmentResult.actual = descriptionLength;

		return assessmentResult;
	}

	/**
  * Returns the score for the descriptionLength.
  *
  * @param {number} descriptionLength The length of the metadescription.
  *
  * @returns {number} The calculated score.
  */
	calculateScore(descriptionLength) {
		if (descriptionLength === 0) {
			return this._config.scores.noMetaDescription;
		}

		if (descriptionLength <= this._config.recommendedMaximumLength) {
			return this._config.scores.tooShort;
		}

		if (descriptionLength > this._config.maximumLength) {
			return this._config.scores.tooLong;
		}

		if (descriptionLength >= this._config.recommendedMaximumLength && descriptionLength <= this._config.maximumLength) {
			return this._config.scores.correctLength;
		}

		return 0;
	}

	/**
  * Translates the descriptionLength to a message the user can understand.
  *
  * @param {number} descriptionLength The length of the metadescription.
  * @param {object} i18n The object used for translations.
  *
  * @returns {string} The translated string.
  */
	translateScore(descriptionLength, i18n) {
		if (descriptionLength === 0) {
			return i18n.sprintf(
			/* Translators:  %1$s and %2$s expand to a links on yoast.com, %3$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sMeta description length%3$s:  No meta description has been specified. " + "Search engines will display copy from the page instead. %2$sMake sure to write one%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>");
		}

		if (descriptionLength <= this._config.recommendedMaximumLength) {
			return i18n.sprintf(
			/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag,
   %4$d expands to the number of characters in the meta description, %5$d expands to
   the total available number of characters in the meta description */
			i18n.dgettext("js-text-analysis", "%1$sMeta description length%3$s: The meta description is too short (under %4$d characters). " + "Up to %5$d characters are available. %2$sUse the space%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>", this._config.recommendedMaximumLength, this._config.maximumLength);
		}

		if (descriptionLength > this._config.maximumLength) {
			return i18n.sprintf(
			/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag,
   %4$d expands to	the total available number of characters in the meta description */
			i18n.dgettext("js-text-analysis", "%1$sMeta description length%3$s: The meta description is over %4$d characters. " + "To ensure the entire description will be visible, %2$syou should reduce the length%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>", this._config.maximumLength);
		}

		if (descriptionLength >= this._config.recommendedMaximumLength && descriptionLength <= this._config.maximumLength) {
			return i18n.sprintf(
			/* Translators:  %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sMeta description length%2$s: Well done!"), this._config.urlTitle, "</a>");
		}
	}
}
MetaDescriptionLengthAssessment$1.default = MetaDescriptionLengthAssessment;

var OutboundLinksAssessment$1 = {};

Object.defineProperty(OutboundLinksAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1u = require$$1$1;

var _assessment$a = assessment;

var _assessment2$a = _interopRequireDefault$2o(_assessment$a);

var _shortlinker$e = shortlinker;

var _AssessmentResult$f = AssessmentResult$1;

var _AssessmentResult2$f = _interopRequireDefault$2o(_AssessmentResult$f);

function _interopRequireDefault$2o(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assessment for calculating the outbound links in the text.
 */
class OutboundLinksAssessment extends _assessment2$a.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			scores: {
				noLinks: 3,
				allNofollowed: 7,
				someNoFollowed: 8,
				allFollowed: 9
			},
			urlTitle: (0, _shortlinker$e.createAnchorOpeningTag)("https://yoa.st/34f"),
			urlCallToAction: (0, _shortlinker$e.createAnchorOpeningTag)("https://yoa.st/34g")
		};

		this.identifier = "externalLinks";
		this._config = (0, _lodashEs$1u.merge)(defaultConfig, config);
	}

	/**
  * Runs the getLinkStatistics module, based on this returns an assessment result with score.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {Jed} i18n The object used for translations
  *
  * @returns {AssessmentResult} The assessment result.
  */
	getResult(paper, researcher, i18n) {
		const linkStatistics = researcher.getResearch("getLinkStatistics");
		const assessmentResult = new _AssessmentResult2$f.default();
		if (!(0, _lodashEs$1u.isEmpty)(linkStatistics)) {
			assessmentResult.setScore(this.calculateScore(linkStatistics));
			assessmentResult.setText(this.translateScore(linkStatistics, i18n));
		}
		return assessmentResult;
	}

	/**
  * Checks whether paper has text.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True when there is text.
  */
	isApplicable(paper) {
		return paper.hasText();
	}

	/**
  * Returns a score based on the linkStatistics object.
  *
  * @param {object} linkStatistics The object with all link statistics.
  *
  * @returns {number|null} The calculated score.
  */
	calculateScore(linkStatistics) {
		if (linkStatistics.externalTotal === 0) {
			return this._config.scores.noLinks;
		}

		if (linkStatistics.externalNofollow === linkStatistics.externalTotal) {
			return this._config.scores.allNofollowed;
		}

		if (linkStatistics.externalDofollow < linkStatistics.externalTotal) {
			return this._config.scores.someNoFollowed;
		}

		if (linkStatistics.externalDofollow === linkStatistics.externalTotal) {
			return this._config.scores.allFollowed;
		}

		return null;
	}

	/**
  * Translates the score to a message the user can understand.
  *
  * @param {Object} linkStatistics The object with all link statistics.
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {string} The translated string.
  */
	translateScore(linkStatistics, i18n) {
		if (linkStatistics.externalTotal === 0) {
			return i18n.sprintf(
			/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sOutbound links%3$s: " + "No outbound links appear in this page. " + "%2$sAdd some%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>");
		}

		if (linkStatistics.externalNofollow === linkStatistics.externalTotal) {
			return i18n.sprintf(
			/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sOutbound links%3$s: " + "All outbound links on this page are nofollowed. " + "%2$sAdd some normal links%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>");
		}

		if (linkStatistics.externalDofollow === linkStatistics.externalTotal) {
			return i18n.sprintf(
			/* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sOutbound links%2$s: " + "Good job!"), this._config.urlTitle, "</a>");
		}

		if (linkStatistics.externalDofollow < linkStatistics.externalTotal) {
			return i18n.sprintf(
			/* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sOutbound links%2$s: " + "There are both nofollowed and normal outbound links on this page. " + "Good job!"), this._config.urlTitle, "</a>");
		}

		return "";
	}
}
OutboundLinksAssessment$1.default = OutboundLinksAssessment;

var PageTitleWidthAssessment$1 = {};

Object.defineProperty(PageTitleWidthAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1t = require$$1$1;

var _assessment$9 = assessment;

var _assessment2$9 = _interopRequireDefault$2n(_assessment$9);

var _inRange$2 = inRange;

var _shortlinker$d = shortlinker;

var _AssessmentResult$e = AssessmentResult$1;

var _AssessmentResult2$e = _interopRequireDefault$2n(_AssessmentResult$e);

function _interopRequireDefault$2n(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const maximumLength = 600;
/**
 * Represents the assessment that will calculate if the width of the page title is correct.
 */
class PageTitleWidthAssessment extends _assessment2$9.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			minLength: 400,
			maxLength: maximumLength,
			scores: {
				noTitle: 1,
				widthTooShort: 6,
				widthTooLong: 3,
				widthCorrect: 9
			},
			urlTitle: (0, _shortlinker$d.createAnchorOpeningTag)("https://yoa.st/34h"),
			urlCallToAction: (0, _shortlinker$d.createAnchorOpeningTag)("https://yoa.st/34i")
		};

		this.identifier = "titleWidth";
		this._config = (0, _lodashEs$1t.merge)(defaultConfig, config);
	}

	/**
  * Returns the maximum length.
  *
  * @returns {number} The maximum length.
  */
	getMaximumLength() {
		return maximumLength;
	}

	/**
  * Runs the pageTitleWidth module, based on this returns an assessment result with score.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {Jed} i18n The object used for translations
  *
  * @returns {AssessmentResult} The assessment result.
  */
	getResult(paper, researcher, i18n) {
		const pageTitleWidth = researcher.getResearch("pageTitleWidth");
		const assessmentResult = new _AssessmentResult2$e.default();

		assessmentResult.setScore(this.calculateScore(pageTitleWidth));
		assessmentResult.setText(this.translateScore(pageTitleWidth, i18n));

		// Max and actual are used in the snippet editor progress bar.
		assessmentResult.max = this._config.maxLength;
		assessmentResult.actual = pageTitleWidth;
		return assessmentResult;
	}

	/**
  * Returns the score for the pageTitleWidth
  *
  * @param {number} pageTitleWidth The width of the pageTitle.
  *
  * @returns {number} The calculated score.
  */
	calculateScore(pageTitleWidth) {
		if ((0, _inRange$2.inRangeEndInclusive)(pageTitleWidth, 1, 400)) {
			return this._config.scores.widthTooShort;
		}

		if ((0, _inRange$2.inRangeEndInclusive)(pageTitleWidth, this._config.minLength, this._config.maxLength)) {
			return this._config.scores.widthCorrect;
		}

		if (pageTitleWidth > this._config.maxLength) {
			return this._config.scores.widthTooLong;
		}

		return this._config.scores.noTitle;
	}

	/**
  * Translates the pageTitleWidth score to a message the user can understand.
  *
  * @param {number} pageTitleWidth The width of the pageTitle.
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {string} The translated string.
  */
	translateScore(pageTitleWidth, i18n) {
		if ((0, _inRange$2.inRangeEndInclusive)(pageTitleWidth, 1, 400)) {
			return i18n.sprintf(
			/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sSEO title width%3$s: The SEO title is too short. " + "%2$sUse the space to add keyphrase variations or create compelling call-to-action copy%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>");
		}

		if ((0, _inRange$2.inRangeEndInclusive)(pageTitleWidth, this._config.minLength, this._config.maxLength)) {
			return i18n.sprintf(
			/* Translators:  %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sSEO title width%2$s: Good job!"), this._config.urlTitle, "</a>");
		}

		if (pageTitleWidth > this._config.maxLength) {
			return i18n.sprintf(
			/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sSEO title width%3$s: The SEO title is wider than the viewable limit. %2$sTry to make it shorter%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>");
		}

		return i18n.sprintf(
		/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
		i18n.dgettext("js-text-analysis", "%1$sSEO title width%3$s: %2$sPlease create an SEO title%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>");
	}
}
PageTitleWidthAssessment$1.default = PageTitleWidthAssessment;

var SingleH1Assessment = {};

Object.defineProperty(SingleH1Assessment, "__esModule", {
	value: true
});

var _lodashEs$1s = require$$1$1;

var _assessment$8 = assessment;

var _assessment2$8 = _interopRequireDefault$2m(_assessment$8);

var _shortlinker$c = shortlinker;

var _addMark = addMark;

var _addMark2 = _interopRequireDefault$2m(_addMark);

var _AssessmentResult$d = AssessmentResult$1;

var _AssessmentResult2$d = _interopRequireDefault$2m(_AssessmentResult$d);

var _Mark$3 = Mark$1;

var _Mark2$3 = _interopRequireDefault$2m(_Mark$3);

function _interopRequireDefault$2m(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assessment to check whether the body of the text contains H1s in the body (except at the very beginning,
 * where they are acceptable).
 */
class singleH1Assessment extends _assessment2$8.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} config The configuration to use.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			scores: {
				textContainsSuperfluousH1: 1
			},
			urlTitle: (0, _shortlinker$c.createAnchorOpeningTag)("https://yoa.st/3a6"),
			urlCallToAction: (0, _shortlinker$c.createAnchorOpeningTag)("https://yoa.st/3a7")
		};

		this.identifier = "singleH1";
		this._config = (0, _lodashEs$1s.merge)(defaultConfig, config);
	}

	/**
  * Runs the h1 research and based on this returns an assessment result with a score.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling the research.
  * @param {Jed} i18n The object used for translations
  *
  * @returns {AssessmentResult} The assessment result.
  */
	getResult(paper, researcher, i18n) {
		this._h1s = researcher.getResearch("h1s");

		const assessmentResult = new _AssessmentResult2$d.default();

		const calculatedResult = this.calculateResult(i18n);

		if (!(0, _lodashEs$1s.isUndefined)(calculatedResult)) {
			assessmentResult.setScore(calculatedResult.score);
			assessmentResult.setText(calculatedResult.resultText);
			assessmentResult.setHasMarks(true);
		}

		return assessmentResult;
	}

	/**
  * Checks whether an H1 is in the first position of the body.
  *
  * @returns {boolean} Returns true if there is an H1 in the first position of the body.
  */
	firstH1AtBeginning() {
		return this._h1s[0].position === 0;
	}

	/**
  * Returns the score and the feedback string for the single H1 assessment.
  *
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {Object|null} The calculated score and the feedback string.
  */
	calculateResult(i18n) {
		// Returns the default assessment result if there are no H1s in the body.
		if (this._h1s.length === 0) {
			return;
		}

		// Returns the default assessment result if there is one H1 and it's at the beginning of the body.
		if (this._h1s.length === 1 && this.firstH1AtBeginning()) {
			return;
		}

		return {
			score: this._config.scores.textContainsSuperfluousH1,
			resultText: i18n.sprintf(
			/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sSingle title%3$s: H1s should only be used as your main title. Find all H1s in your text " + "that aren't your main title and %2$schange them to a lower heading level%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
		};
	}

	/**
  * Marks all H1s in the body of the text (except at the very beginning,
  * where they are acceptable and don't need to be changed).
  *
  * @returns {Array} Array with all the marked H1s.
  */
	getMarks() {
		const h1s = this._h1s;

		/*
   * Removes the first H1 from the array if that H1 is in the first position of the body.
   * The very beginning of the body is the only position where an H1 is deemed acceptable.
   */
		if (this.firstH1AtBeginning()) {
			h1s.shift();
		}

		return (0, _lodashEs$1s.map)(h1s, function (h1) {
			return new _Mark2$3.default({
				original: "<h1>" + h1.content + "</h1>",
				marked: "<h1>" + (0, _addMark2.default)(h1.content) + "</h1>"
			});
		});
	}

	/**
  * Checks whether the paper has a text.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True when there is text.
  */
	isApplicable(paper) {
		return paper.hasText();
	}
}

SingleH1Assessment.default = singleH1Assessment;

var SubHeadingsKeywordAssessment$1 = {};

Object.defineProperty(SubHeadingsKeywordAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1r = require$$1$1;

var _assessment$7 = assessment;

var _assessment2$7 = _interopRequireDefault$2l(_assessment$7);

var _shortlinker$b = shortlinker;

var _inRange$1 = inRange;

var _getSubheadings$2 = getSubheadings$1;

var _AssessmentResult$c = AssessmentResult$1;

var _AssessmentResult2$c = _interopRequireDefault$2l(_AssessmentResult$c);

function _interopRequireDefault$2l(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents the assessment that checks if the keyword is present in one of the subheadings.
 */
class SubHeadingsKeywordAssessment extends _assessment2$7.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {object} config The configuration to use.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			parameters: {
				lowerBoundary: 0.3,
				upperBoundary: 0.75
			},
			scores: {
				noMatches: 3,
				tooFewMatches: 3,
				goodNumberOfMatches: 9,
				tooManyMatches: 3
			},
			urlTitle: (0, _shortlinker$b.createAnchorOpeningTag)("https://yoa.st/33m"),
			urlCallToAction: (0, _shortlinker$b.createAnchorOpeningTag)("https://yoa.st/33n")
		};

		this.identifier = "subheadingsKeyword";
		this._config = (0, _lodashEs$1r.merge)(defaultConfig, config);
	}

	/**
  * Runs the matchKeywordInSubheadings research and based on this returns an assessment result.
  *
  * @param {Paper} paper             The paper to use for the assessment.
  * @param {Researcher} researcher   The researcher used for calling research.
  * @param {Object} i18n             The object used for translations.
  *
  * @returns {AssessmentResult} The assessment result.
  */
	getResult(paper, researcher, i18n) {
		this._subHeadings = researcher.getResearch("matchKeywordInSubheadings");

		const assessmentResult = new _AssessmentResult2$c.default();

		this._minNumberOfSubheadings = Math.ceil(this._subHeadings.count * this._config.parameters.lowerBoundary);
		this._maxNumberOfSubheadings = Math.floor(this._subHeadings.count * this._config.parameters.upperBoundary);
		const calculatedResult = this.calculateResult(i18n);

		assessmentResult.setScore(calculatedResult.score);
		assessmentResult.setText(calculatedResult.resultText);

		return assessmentResult;
	}

	/**
  * Checks whether the paper has a subheadings.
  *
  * @param {Paper} paper The paper to use for the check.
  *
  * @returns {boolean} True when there is at least one subheading.
  */
	hasSubheadings(paper) {
		const subheadings = (0, _getSubheadings$2.getSubheadingsTopLevel)(paper.getText());
		return subheadings.length > 0;
	}

	/**
  * Checks whether the paper has a text and a keyword.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True when there is text and a keyword.
  */
	isApplicable(paper) {
		return paper.hasText() && paper.hasKeyword() && this.hasSubheadings(paper);
	}

	/**
  * Checks whether there are too few subheadings with the keyphrase.
  *
  * This is the case if the number of subheadings with the keyphrase is more than 0 but less than the specified
  * recommended minimum.
  *
  * @returns {boolean} Returns true if the keyphrase is included in too few subheadings.
  */
	hasTooFewMatches() {
		return this._subHeadings.matches > 0 && this._subHeadings.matches < this._minNumberOfSubheadings;
	}

	/**
  * Checks whether there are too many subheadings with the keyphrase.
  *
  * The upper limit is only applicable if there is more than one subheading. If there is only one subheading with
  * the keyphrase this would otherwise always lead to a 100% match rate.
  *
  * @returns {boolean} Returns true if there is more than one subheading and if the keyphrase is included in less
  *                    subheadings than the recommended maximum.
  */
	hasTooManyMatches() {
		return this._subHeadings.count > 1 && this._subHeadings.matches > this._maxNumberOfSubheadings;
	}

	/**
  * Checks whether there is only one higher-level subheading and this subheading includes the keyphrase.
  *
  * @returns {boolean} Returns true if there is exactly one higher-level subheading and this
  * subheading has a keyphrase match.
  */
	isOneOfOne() {
		return this._subHeadings.count === 1 && this._subHeadings.matches === 1;
	}

	/**
  * Checks whether there is a good number of subheadings with the keyphrase.
  *
  * This is the case if there is only one subheading and that subheading includes the keyphrase or if the number of
  * subheadings with the keyphrase is within the specified recommended range.
  *
  * @returns {boolean} Returns true if the keyphrase is included in a sufficient number of subheadings.
  */
	hasGoodNumberOfMatches() {
		return (0, _inRange$1.inRangeStartEndInclusive)(this._subHeadings.matches, this._minNumberOfSubheadings, this._maxNumberOfSubheadings);
	}

	/**
  * Determines the score and the Result text for the subheadings.
  *
  * @param {Object} i18n The object used for translations.
  *
  * @returns {Object} The object with the calculated score and the result text.
  */
	calculateResult(i18n) {
		if (this.hasTooFewMatches()) {
			return {
				score: this._config.scores.tooFewMatches,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to a link on yoast.com, %3$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in subheading%3$s: %2$sUse more keyphrases or synonyms in your H2 and H3 subheadings%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		if (this.hasTooManyMatches()) {
			return {
				score: this._config.scores.tooManyMatches,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to a link on yoast.com, %3$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in subheading%3$s: More than 75%% of your H2 and H3 subheadings reflect the topic of your copy. " + "That's too much. %2$sDon't over-optimize%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		if (this.isOneOfOne()) {
			return {
				score: this._config.scores.goodNumberOfMatches,
				resultText: i18n.sprintf(
				/* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag,
    %3$d expands to the number of subheadings containing the keyphrase. */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in subheading%2$s: Your H2 or H3 subheading reflects the topic of your copy. Good job!", this._subHeadings.matches), this._config.urlTitle, "</a>")
			};
		}

		if (this.hasGoodNumberOfMatches()) {
			return {
				score: this._config.scores.goodNumberOfMatches,
				resultText: i18n.sprintf(
				/* Translators: %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag,
    %3$d expands to the number of subheadings containing the keyphrase. */
				i18n.dngettext("js-text-analysis", "%1$sKeyphrase in subheading%2$s: %3$s of your H2 and H3 subheadings reflects the topic of your copy. Good job!", "%1$sKeyphrase in subheading%2$s: %3$s of your H2 and H3 subheadings reflect the topic of your copy. Good job!", this._subHeadings.matches), this._config.urlTitle, "</a>", this._subHeadings.matches)
			};
		}

		return {
			score: this._config.scores.noMatches,
			resultText: i18n.sprintf(
			/* Translators: %1$s and %2$s expand to a link on yoast.com, %3$s expands to the anchor end tag. */
			i18n.dgettext("js-text-analysis", "%1$sKeyphrase in subheading%3$s: %2$sUse more keyphrases or synonyms in your H2 and H3 subheadings%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
		};
	}
}
SubHeadingsKeywordAssessment$1.default = SubHeadingsKeywordAssessment;

var taxonomyTextLengthAssessment$1 = {};

Object.defineProperty(taxonomyTextLengthAssessment$1, "__esModule", {
	value: true
});

var _AssessmentResult$b = AssessmentResult$1;

var _AssessmentResult2$b = _interopRequireDefault$2k(_AssessmentResult$b);

var _lodashEs$1q = require$$1$1;

var _shortlinker$a = shortlinker;

function _interopRequireDefault$2k(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const recommendedMinimum = 150;
/**
 * Calculate the score based on the current word count.
 * @param {number} wordCount The amount of words to be checked against.
 * @param {object} i18n The locale object.
 * @returns {object} The resulting score object.
 */
const calculateWordCountResult = function calculateWordCountResult(wordCount, i18n) {
	const urlTitle = (0, _shortlinker$a.createAnchorOpeningTag)("https://yoa.st/34j");
	const urlCallToAction = (0, _shortlinker$a.createAnchorOpeningTag)("https://yoa.st/34k");

	if (wordCount >= 150) {
		return {
			score: 9,
			text: i18n.sprintf(i18n.dngettext("js-text-analysis",
			/* Translators: %1$d expands to the number of words in the text,
   %2$s expands to a link on yoast.com, %3$s expands to the anchor end tag */
			"%2$sText length%3$s: The text contains %1$d word. Good job!", "%2$sText length%3$s: The text contains %1$d words. Good job!", wordCount), wordCount, urlTitle, "</a>")
		};
	}

	if ((0, _lodashEs$1q.inRange)(wordCount, 125, 150)) {
		return {
			score: 7,
			text: i18n.sprintf(i18n.dngettext("js-text-analysis",
			/* Translators: %1$d expands to the number of words in the text,
   %2$s expands to a link on yoast.com, %4$d expands to the anchor end tag. */
			"%2$sText length%4$s: The text contains %1$d word.", "%2$sText length%4$s: The text contains %1$d words.", wordCount) + " " + i18n.dngettext("js-text-analysis",
			/* Translators: The preceding sentence is "Text length: The text contains x words.",
   %3$s expands to a link on yoast.com,
   %4$s expands to the anchor end tag,
   %5$d expands to the recommended minimum of words. */
			"This is slightly below the recommended minimum of %5$d word. %3$sAdd a bit more copy%4$s.", "This is slightly below the recommended minimum of %5$d words. %3$sAdd a bit more copy%4$s.", recommendedMinimum), wordCount, urlTitle, urlCallToAction, "</a>", recommendedMinimum)
		};
	}

	if ((0, _lodashEs$1q.inRange)(wordCount, 100, 125)) {
		return {
			score: 5,
			text: i18n.sprintf(i18n.dngettext("js-text-analysis",
			/* Translators: %1$d expands to the number of words in the text,
   %2$s expands to a link on yoast.com, %4$s expands to the anchor end tag. */
			"%2$sText length%4$s: The text contains %1$d word.", "%2$sText length%4$s: The text contains %1$d words.", wordCount) + " " + i18n.dngettext("js-text-analysis",
			/* Translators: The preceding sentence is "Text length: The text contains x words.",
   %3$s expands to a link on yoast.com,
   %4$s expands to the anchor end tag,
   %5$d expands to the recommended minimum of words. */
			"This is below the recommended minimum of %5$d word. %3$sAdd more content%4$s.", "This is below the recommended minimum of %5$d words. %3$sAdd more content%4$s.", recommendedMinimum), wordCount, urlTitle, urlCallToAction, "</a>", recommendedMinimum)
		};
	}

	if ((0, _lodashEs$1q.inRange)(wordCount, 50, 100)) {
		return {
			score: -10,
			text: i18n.sprintf(i18n.dngettext("js-text-analysis",
			/* Translators: %1$d expands to the number of words in the text,
   %2$s expands to a link on yoast.com, %4$s expands to the anchor end tag. */
			"%2$sText length%4$s: The text contains %1$d word.", "%2$sText length%4$s: The text contains %1$d words.", wordCount) + " " + i18n.dngettext("js-text-analysis",
			/* Translators: The preceding sentence is "Text length: The text contains x words.",
   %3$s expands to a link on yoast.com,
   %4$s expands to the anchor end tag,
   %5$d expands to the recommended minimum of words. */
			"This is below the recommended minimum of %5$d word. %3$sAdd more content%4$s.", "This is below the recommended minimum of %5$d words. %3$sAdd more content%4$s.", recommendedMinimum), wordCount, urlTitle, urlCallToAction, "</a>", recommendedMinimum)
		};
	}

	if ((0, _lodashEs$1q.inRange)(wordCount, 0, 50)) {
		return {
			score: -20,
			text: i18n.sprintf(i18n.dngettext("js-text-analysis",
			/* Translators: %1$d expands to the number of words in the text,
   %2$s expands to a link on yoast.com, %4$s expands to the anchor end tag. */
			"%2$sText length%4$s: The text contains %1$d word.", "%2$sText length%4$s: The text contains %1$d words.", wordCount) + " " + i18n.dngettext("js-text-analysis",
			/* Translators: The preceding sentence is "Text length: The text contains x words.",
   %3$s expands to a link on yoast.com,
   %4$s expands to the anchor end tag,
   %5$d expands to the recommended minimum of words. */
			"This is far below the recommended minimum of %5$d word. %3$sAdd more content%4$s.", "This is far below the recommended minimum of %5$d words. %3$sAdd more content%4$s.", recommendedMinimum), wordCount, urlTitle, urlCallToAction, "</a>", recommendedMinimum)
		};
	}
};

/**
 * Execute the Assessment and return a result.
 *
 * @param {Paper} paper The Paper object to assess.
 * @param {Researcher} researcher The Researcher object containing all available researches.
 * @param {Jed} i18n The locale object.
 *
 * @returns {AssessmentResult} The result of the assessment, containing both a score and a descriptive text.
 *
 * @deprecated since 1.48. Please use the TextLengthAssessment with different configuration parameters instead.
 */
const taxonomyTextLengthAssessment = function taxonomyTextLengthAssessment(paper, researcher, i18n) {
	console.warn("Deprecation Warning: This assessment has been deprecated since version 1.48. " + "Please use the TextLengthAssessment with different configuration parameters instead.");

	const wordCount = researcher.getResearch("wordCountInText");
	const wordCountResult = calculateWordCountResult(wordCount, i18n);
	const assessmentResult = new _AssessmentResult2$b.default();

	assessmentResult.setScore(wordCountResult.score);
	assessmentResult.setText(i18n.sprintf(wordCountResult.text, wordCount, recommendedMinimum));

	return assessmentResult;
};

taxonomyTextLengthAssessment$1.default = {
	identifier: "taxonomyTextLength",
	getResult: taxonomyTextLengthAssessment
};

var TextCompetingLinksAssessment$1 = {};

Object.defineProperty(TextCompetingLinksAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1p = require$$1$1;

var _assessment$6 = assessment;

var _assessment2$6 = _interopRequireDefault$2j(_assessment$6);

var _shortlinker$9 = shortlinker;

var _AssessmentResult$a = AssessmentResult$1;

var _AssessmentResult2$a = _interopRequireDefault$2j(_AssessmentResult$a);

function _interopRequireDefault$2j(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assessment to check whether you're linking to a different page with the keyword from this page.
 */
class TextCompetingLinksAssessment extends _assessment2$6.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  * @param {number} [config.parameters.recommendedMaximum] The recommended maximum number of links using the same keyword as this paper.
  * @param {string} [config.scores.bad] The score to return if there are more links with the same keyword than the recommended maximum.
  * @param {string} [config.url] The URL to the relevant article on Yoast.com.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			parameters: {
				recommendedMaximum: 0
			},
			scores: {
				bad: 2
			},
			urlTitle: (0, _shortlinker$9.createAnchorOpeningTag)("https://yoa.st/34l"),
			urlCallToAction: (0, _shortlinker$9.createAnchorOpeningTag)("https://yoa.st/34m")
		};

		this.identifier = "textCompetingLinks";
		this._config = (0, _lodashEs$1p.merge)(defaultConfig, config);
	}

	/**
  * Runs the linkCount module, based on this returns an assessment result with score.
  *
  * @param {Paper} paper The paper to use for the assessment.
  * @param {Researcher} researcher The researcher used for calling research.
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {Object} The AssessmentResult.
  */
	getResult(paper, researcher, i18n) {
		const assessmentResult = new _AssessmentResult2$a.default();

		this.linkCount = researcher.getResearch("getLinkStatistics");

		const calculatedResult = this.calculateResult(i18n);

		if ((0, _lodashEs$1p.isUndefined)(calculatedResult)) {
			return assessmentResult;
		}

		assessmentResult.setScore(calculatedResult.score);
		assessmentResult.setText(calculatedResult.resultText);
		assessmentResult.setHasMarks(false);

		return assessmentResult;
	}

	/**
  * Determines if the assessment is applicable to the paper.
  *
  * @param {Paper} paper The paper to check
  *
  * @returns {boolean} Whether the paper has text and a keyword
  */
	isApplicable(paper) {
		return paper.hasText() && paper.hasKeyword();
	}

	/**
  * Returns a result based on the number of links.
  *
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {Object} ResultObject with score and text.
  */
	calculateResult(i18n) {
		if (this.linkCount.keyword.totalKeyword > this._config.parameters.recommendedMaximum) {
			return {
				score: this._config.scores.bad,
				resultText: i18n.sprintf(
				/* Translators:  %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sLink keyphrase%3$s: " + "You're linking to another page with the words you want this page to rank for. " + "%2$sDon't do that%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}
	}
}

TextCompetingLinksAssessment$1.default = TextCompetingLinksAssessment;

var TextImagesAssessment$1 = {};

Object.defineProperty(TextImagesAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1o = require$$1$1;

var _assessment$5 = assessment;

var _assessment2$5 = _interopRequireDefault$2i(_assessment$5);

var _inRange = inRange;

var _shortlinker$8 = shortlinker;

var _AssessmentResult$9 = AssessmentResult$1;

var _AssessmentResult2$9 = _interopRequireDefault$2i(_AssessmentResult$9);

function _interopRequireDefault$2i(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents the assessment that will look if the images have alt-tags and checks if the keyword is present in one of them.
 */
class TextImagesAssessment extends _assessment2$5.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {object} config The configuration to use.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			parameters: {
				lowerBoundary: 0.3,
				upperBoundary: 0.75
			},
			scores: {
				noImages: 3,
				withAltGoodNumberOfKeywordMatches: 9,
				withAltTooFewKeywordMatches: 6,
				withAltTooManyKeywordMatches: 6,
				withAltNonKeyword: 6,
				withAlt: 6,
				noAlt: 6
			},
			urlTitle: (0, _shortlinker$8.createAnchorOpeningTag)("https://yoa.st/33c"),
			urlCallToAction: (0, _shortlinker$8.createAnchorOpeningTag)("https://yoa.st/33d")
		};

		this.identifier = "textImages";
		this._config = (0, _lodashEs$1o.merge)(defaultConfig, config);
	}

	/**
  * Execute the Assessment and return a result.
  *
  * @param {Paper} paper The Paper object to assess.
  * @param {Researcher} researcher The Researcher object containing all available researches.
  * @param {Jed} i18n The locale object.
  *
  * @returns {AssessmentResult} The result of the assessment, containing both a score and a descriptive text.
  */
	getResult(paper, researcher, i18n) {
		this.imageCount = researcher.getResearch("imageCount");
		this.altProperties = researcher.getResearch("altTagCount");

		this._minNumberOfKeywordMatches = Math.ceil(this.imageCount * this._config.parameters.lowerBoundary);
		this._maxNumberOfKeywordMatches = Math.floor(this.imageCount * this._config.parameters.upperBoundary);

		const calculatedScore = this.calculateResult(i18n);

		const assessmentResult = new _AssessmentResult2$9.default();
		assessmentResult.setScore(calculatedScore.score);
		assessmentResult.setText(calculatedScore.resultText);

		return assessmentResult;
	}

	/**
  * Checks whether the paper has text.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True when there is text.
  */
	isApplicable(paper) {
		return paper.hasText();
	}

	/**
  * Checks whether there are too few alt tags with keywords. This check is applicable when there are
  * 5 or more images.
  *
  * @returns {boolean} Returns true if there are at least 5 images and the number of alt tags
  * with keywords is under the specified recommended minimum.
  */
	hasTooFewMatches() {
		return this.imageCount > 4 && this.altProperties.withAltKeyword > 0 && this.altProperties.withAltKeyword < this._minNumberOfKeywordMatches;
	}

	/**
  * Checks whether there is a sufficient number of alt tags with keywords. There are different recommended
  * ranges for less than 5 keywords, exactly 5 keywords, and more than 5 keywords.
  *
  * @returns {boolean} Returns true if the number of alt tags with keywords is within the recommended range.
  */
	hasGoodNumberOfMatches() {
		return this.imageCount < 5 && this.altProperties.withAltKeyword > 0 || this.imageCount === 5 && (0, _inRange.inRangeStartEndInclusive)(this.altProperties.withAltKeyword, 2, 4) || this.imageCount > 4 && (0, _inRange.inRangeStartEndInclusive)(this.altProperties.withAltKeyword, this._minNumberOfKeywordMatches, this._maxNumberOfKeywordMatches);
	}

	/**
  * Checks whether there is a sufficient number of alt tags with keywords. This check is applicable when there are
  * 5 or more images.
  *
  * @returns {boolean} Returns true if there are at least 5 images and the number of alt tags with keywords
  * is within the recommended range.
  */
	hasTooManyMatches() {
		return this.imageCount > 4 && this.altProperties.withAltKeyword > this._maxNumberOfKeywordMatches;
	}

	/**
  * Calculate the result based on the current image count and current image alt-tag count.
  *
  * @param {Object} i18n The object used for translations.
  *
  * @returns {Object} The calculated result.
  */
	calculateResult(i18n) {
		// No images.
		if (this.imageCount === 0) {
			return {
				score: this._config.scores.noImages,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sImage alt attributes%3$s: No images appear on this page. %2$sAdd some%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		// Has alt-tags, but no keyword is set.
		if (this.altProperties.withAlt > 0) {
			return {
				score: this._config.scores.withAlt,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sImage alt attributes%3$s: " + "Images on this page have alt attributes, but you have not set your keyphrase. %2$sFix that%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		// Has alt-tags, but no keywords while a keyword is set.
		if (this.altProperties.withAltNonKeyword > 0 && this.altProperties.withAltKeyword === 0) {
			return {
				score: this._config.scores.withAltNonKeyword,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sImage alt attributes%3$s: " + "Images on this page do not have alt attributes that reflect the topic of your text. " + "%2$sAdd your keyphrase or synonyms to the alt tags of relevant images%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		// Image count ≥5, has alt-tags with too few keywords.
		if (this.hasTooFewMatches()) {
			return {
				score: this._config.scores.withAltTooFewKeywordMatches,
				resultText: i18n.sprintf(
				/* Translators: %1$d expands to the number of images containing an alt attribute with the keyword,
     * %2$d expands to the total number of images, %3$s and %4$s expand to links on yoast.com,
     * %5$s expands to the anchor end tag. */
				i18n.dngettext("js-text-analysis", "%3$sImage alt attributes%5$s: Out of %2$d images on this page, only %1$d has an alt attribute that " + "reflects the topic of your text. " + "%4$sAdd your keyphrase or synonyms to the alt tags of more relevant images%5$s!", "%3$sImage alt attributes%5$s: Out of %2$d images on this page, only %1$d have alt attributes that " + "reflect the topic of your text. " + "%4$sAdd your keyphrase or synonyms to the alt tags of more relevant images%5$s!", this.altProperties.withAltKeyword), this.altProperties.withAltKeyword, this.imageCount, this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		/*
   * The hasGoodNumberOfMatches check needs to be made before the check for too many matches because of the special rule for
   * exactly 5 matches.
   */
		if (this.hasGoodNumberOfMatches()) {
			return {
				score: this._config.scores.withAltGoodNumberOfKeywordMatches,
				resultText: i18n.sprintf(
				/* Translators: %1$s expands to a link on yoast.com,
     * %2$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%1$sImage alt attributes%2$s: Good job!"), this._config.urlTitle, "</a>")
			};
		}

		if (this.hasTooManyMatches()) {
			return {
				score: this._config.scores.withAltTooManyKeywordMatches,
				resultText: i18n.sprintf(
				/* Translators: %1$d expands to the number of images containing an alt attribute with the keyword,
                    * %2$d expands to the total number of images, %3$s and %4$s expand to a link on yoast.com,
     * %5$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%3$sImage alt attributes%5$s: Out of %2$d images on this page, %1$d have alt attributes with " + "words from your keyphrase or synonyms. " + "That's a bit much. %4$sOnly include the keyphrase or its synonyms when it really fits the image%5$s."), this.altProperties.withAltKeyword, this.imageCount, this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		// Images, but no alt tags.
		return {
			score: this._config.scores.noAlt,
			resultText: i18n.sprintf(
			/* Translators: %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sImage alt attributes%3$s: " + "Images on this page do not have alt attributes that reflect the topic of your text. " + "%2$sAdd your keyphrase or synonyms to the alt tags of relevant images%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
		};
	}
}
TextImagesAssessment$1.default = TextImagesAssessment;

var TextLengthAssessment$1 = {};

Object.defineProperty(TextLengthAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1n = require$$1$1;

var _assessment$4 = assessment;

var _assessment2$4 = _interopRequireDefault$2h(_assessment$4);

var _shortlinker$7 = shortlinker;

var _AssessmentResult$8 = AssessmentResult$1;

var _AssessmentResult2$8 = _interopRequireDefault$2h(_AssessmentResult$8);

function _interopRequireDefault$2h(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assessment that will test if the text is long enough.
 */
class TextLengthAssessment extends _assessment2$4.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			recommendedMinimum: 300,
			slightlyBelowMinimum: 250,
			belowMinimum: 200,
			veryFarBelowMinimum: 100,

			scores: {
				recommendedMinimum: 9,
				slightlyBelowMinimum: 6,
				belowMinimum: 3,
				farBelowMinimum: -10,
				veryFarBelowMinimum: -20
			},
			urlTitle: (0, _shortlinker$7.createAnchorOpeningTag)("https://yoa.st/34n"),
			urlCallToAction: (0, _shortlinker$7.createAnchorOpeningTag)("https://yoa.st/34o"),

			cornerstoneContent: false
		};

		this.identifier = "textLength";
		this._config = (0, _lodashEs$1n.merge)(defaultConfig, config);
	}

	/**
  * Execute the Assessment and return a result.
  *
  * @param {Paper} paper The Paper object to assess.
  * @param {Researcher} researcher The Researcher object containing all available researches.
  * @param {Jed} i18n The locale object.
  *
  * @returns {AssessmentResult} The result of the assessment, containing both a score and a descriptive text.
  */
	getResult(paper, researcher, i18n) {
		const wordCount = researcher.getResearch("wordCountInText");
		const assessmentResult = new _AssessmentResult2$8.default();
		const calculatedResult = this.calculateResult(wordCount, i18n);

		assessmentResult.setScore(calculatedResult.score);
		assessmentResult.setText(calculatedResult.resultText);

		return assessmentResult;
	}

	/**
  * Returns the score and the appropriate feedback string based on the current word count.
  *
  * @param {number} wordCount The amount of words to be checked against.
  * @param {Jed} i18n The locale object.
  *
  * @returns {Object} The score and the feedback string.
  */
	calculateResult(wordCount, i18n) {
		if (wordCount >= this._config.recommendedMinimum) {
			return {
				score: this._config.scores.recommendedMinimum,
				resultText: i18n.sprintf(i18n.dngettext("js-text-analysis",
				/* Translators: %1$d expands to the number of words in the text,
    %2$s expands to a link on yoast.com, %3$s expands to the anchor end tag */
				"%2$sText length%3$s: The text contains %1$d word. Good job!", "%2$sText length%3$s: The text contains %1$d words. Good job!", wordCount), wordCount, this._config.urlTitle, "</a>")
			};
		}

		if ((0, _lodashEs$1n.inRange)(wordCount, 0, this._config.belowMinimum)) {
			let badScore = this._config.scores.farBelowMinimum;

			if ((0, _lodashEs$1n.inRange)(wordCount, 0, this._config.veryFarBelowMinimum)) {
				badScore = this._config.scores.veryFarBelowMinimum;
			}

			return {
				score: badScore,
				resultText: i18n.sprintf(i18n.dngettext("js-text-analysis",
				/* Translators: %1$d expands to the number of words in the text,
    %2$s expands to a link on yoast.com, %4$s expands to the anchor end tag. */
				"%2$sText length%4$s: The text contains %1$d word.", "%2$sText length%4$s: The text contains %1$d words.", wordCount) + " " + i18n.dngettext("js-text-analysis",
				/* Translators: The preceding sentence is "Text length: The text contains x words.",
    %3$s expands to a link on yoast.com,
    %4$s expands to the anchor end tag,
    %5$d expands to the recommended minimum of words. */
				"This is far below the recommended minimum of %5$d word. %3$sAdd more content%4$s.", "This is far below the recommended minimum of %5$d words. %3$sAdd more content%4$s.", this._config.recommendedMinimum), wordCount, this._config.urlTitle, this._config.urlCallToAction, "</a>", this._config.recommendedMinimum)
			};
		}

		if ((0, _lodashEs$1n.inRange)(wordCount, this._config.slightlyBelowMinimum, this._config.recommendedMinimum)) {
			if (this._config.cornerstoneContent === false) {
				return {
					score: this._config.scores.slightlyBelowMinimum,
					resultText: i18n.sprintf(i18n.dngettext("js-text-analysis",
					/* Translators: %1$d expands to the number of words in the text,
     %2$s expands to a link on yoast.com, %4$s expands to the anchor end tag. */
					"%2$sText length%4$s: The text contains %1$d word.", "%2$sText length%4$s: The text contains %1$d words.", wordCount) + " " + i18n.dngettext("js-text-analysis",
					/* Translators: The preceding sentence is "Text length: The text contains x words.",
     %3$s expands to a link on yoast.com,
     %4$s expands to the anchor end tag,
     %5$d expands to the recommended minimum of words. */
					"This is slightly below the recommended minimum of %5$d word. %3$sAdd a bit more copy%4$s.", "This is slightly below the recommended minimum of %5$d words. %3$sAdd a bit more copy%4$s.", this._config.recommendedMinimum), wordCount, this._config.urlTitle, this._config.urlCallToAction, "</a>", this._config.recommendedMinimum)
				};
			}

			return {
				score: this._config.scores.slightlyBelowMinimum,
				resultText: i18n.sprintf(i18n.dngettext("js-text-analysis",
				/* Translators: %1$d expands to the number of words in the text,
    %2$s expands to a link on yoast.com, %4$s expands to the anchor end tag. */
				"%2$sText length%4$s: The text contains %1$d word.", "%2$sText length%4$s: The text contains %1$d words.", wordCount) + " " + i18n.dngettext("js-text-analysis",
				/* Translators: The preceding sentence is "Text length: The text contains x words.",
    %3$s expands to a link on yoast.com,
    %4$s expands to the anchor end tag,
    %5$d expands to the recommended minimum of words. */
				"This is below the recommended minimum of %5$d word. %3$sAdd more content%4$s.", "This is below the recommended minimum of %5$d words. %3$sAdd more content%4$s.", this._config.recommendedMinimum), wordCount, this._config.urlTitle, this._config.urlCallToAction, "</a>", this._config.recommendedMinimum)
			};
		}

		return {
			score: this._config.scores.belowMinimum,
			resultText: i18n.sprintf(i18n.dngettext("js-text-analysis",
			/* Translators: %1$d expands to the number of words in the text,
   %2$s expands to a link on yoast.com, %4$s expands to the anchor end tag. */
			"%2$sText length%4$s: The text contains %1$d word.", "%2$sText length%4$s: The text contains %1$d words.", wordCount) + " " + i18n.dngettext("js-text-analysis",
			/* Translators: The preceding sentence is "Text length: The text contains x words.",
   %3$s expands to a link on yoast.com,
   %4$s expands to the anchor end tag,
   %5$d expands to the recommended minimum of words. */
			"This is below the recommended minimum of %5$d word. %3$sAdd more content%4$s.", "This is below the recommended minimum of %5$d words. %3$sAdd more content%4$s.", this._config.recommendedMinimum), wordCount, this._config.urlTitle, this._config.urlCallToAction, "</a>", this._config.recommendedMinimum)
		};
	}
}
TextLengthAssessment$1.default = TextLengthAssessment;

var TitleKeywordAssessment$1 = {};

Object.defineProperty(TitleKeywordAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1m = require$$1$1;

var _assessment$3 = assessment;

var _assessment2$3 = _interopRequireDefault$2g(_assessment$3);

var _shortlinker$6 = shortlinker;

var _AssessmentResult$7 = AssessmentResult$1;

var _AssessmentResult2$7 = _interopRequireDefault$2g(_AssessmentResult$7);

function _interopRequireDefault$2g(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assessment to check whether the keyword is included in (the beginning of) the SEO title.
 */
class TitleKeywordAssessment extends _assessment2$3.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  * @param {number} [config.parameters.recommendedPosition] The recommended position of the keyword within the title.
  * @param {number} [config.scores.good] The score to return if the keyword is found at the recommended position.
  * @param {number} [config.scores.okay] The score to return if the keyword is found, but not at the recommended position.
  * @param {number} [config.scores.bad] The score to return if there are fewer keyword occurrences than the recommended minimum.
  * @param {string} [config.url] The URL to the relevant article on Yoast.com.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			parameters: {
				recommendedPosition: 0
			},
			scores: {
				good: 9,
				okay: 6,
				bad: 2
			},
			urlTitle: (0, _shortlinker$6.createAnchorOpeningTag)("https://yoa.st/33g"),
			urlCallToAction: (0, _shortlinker$6.createAnchorOpeningTag)("https://yoa.st/33h")
		};

		this.identifier = "titleKeyword";
		this._config = (0, _lodashEs$1m.merge)(defaultConfig, config);
	}

	/**
  * Executes the pagetitle keyword assessment and returns an assessment result.
  *
  * @param {Paper} paper The Paper object to assess.
  * @param {Researcher} researcher The Researcher object containing all available researches.
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {AssessmentResult} The result of the assessment with text and score.
  */
	getResult(paper, researcher, i18n) {
		this._keywordMatches = researcher.getResearch("findKeywordInPageTitle");
		this._keyword = (0, _lodashEs$1m.escape)(paper.getKeyword());

		const assessmentResult = new _AssessmentResult2$7.default();

		const calculatedResult = this.calculateResult(i18n, this._keyword);
		assessmentResult.setScore(calculatedResult.score);
		assessmentResult.setText(calculatedResult.resultText);

		return assessmentResult;
	}

	/**
  * Checks whether the assessment is applicable to the paper
  *
  * @param {Paper} paper The Paper object to assess.
  *
  * @returns {boolean} Whether the paper has a keyword and a title.
  */
	isApplicable(paper) {
		return paper.hasKeyword() && paper.hasTitle();
	}

	/**
  * Calculates the result based on whether and how the keyphrase was matched in the title. Returns GOOD result if
  * an exact match of the keyword is found in the beginning of the title. Returns OK results if all content words
  * from the keyphrase are in the title (in any form). Returns BAD otherwise.
  *
  * @param {Jed} i18n The object used for translations.
  * @param {string} keyword The keyword of the paper (to be returned in the feedback strings).
  *
  * @returns {Object} Object with score and text.
  */
	calculateResult(i18n, keyword) {
		const exactMatchFound = this._keywordMatches.exactMatchFound;
		const position = this._keywordMatches.position;
		const allWordsFound = this._keywordMatches.allWordsFound;
		const exactMatchKeyphrase = this._keywordMatches.exactMatchKeyphrase;

		if (exactMatchFound === true) {
			if (position === 0) {
				return {
					score: this._config.scores.good,
					resultText: i18n.sprintf(
					/* Translators: %1$s expands to a link on yoast.com,
     %2$s expands to the anchor end tag. */
					i18n.dgettext("js-text-analysis", "%1$sKeyphrase in title%2$s: The exact match of the focus keyphrase appears at the beginning " + "of the SEO title. Good job!"), this._config.urlTitle, "</a>")
				};
			}
			return {
				score: this._config.scores.okay,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to a link on yoast.com,
    %3$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in title%3$s: The exact match of the focus keyphrase appears in the SEO title, but not " + "at the beginning. %2$sMove it to the beginning for the best results%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		if (allWordsFound) {
			return {
				score: this._config.scores.okay,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to a link on yoast.com,
    %3$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in title%3$s: Does not contain the exact match. %2$sTry to write the exact match of " + "your keyphrase in the SEO title and put it at the beginning of the title%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		if (exactMatchKeyphrase) {
			return {
				score: this._config.scores.bad,
				resultText: i18n.sprintf(
				/* Translators: %1$s and %2$s expand to a link on yoast.com,
    %3$s expands to the anchor end tag. */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in title%3$s: Does not contain the exact match. %2$sTry to write the exact match of " + "your keyphrase in the SEO title and put it at the beginning of the title%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>", keyword)
			};
		}

		return {
			score: this._config.scores.bad,
			resultText: i18n.sprintf(
			/* Translators: %1$s and %2$s expand to a link on yoast.com,
   %3$s expands to the anchor end tag, %4$s expands to the keyword of the article. */
			i18n.dgettext("js-text-analysis", "%1$sKeyphrase in title%3$s: Not all the words from your keyphrase \"%4$s\" appear in the SEO title. " + "%2$sFor the best SEO results write the exact match of your keyphrase in the SEO title, and put " + "the keyphrase at the beginning of the title%3$s."), this._config.urlTitle, this._config.urlCallToAction, "</a>", keyword)
		};
	}
}

TitleKeywordAssessment$1.default = TitleKeywordAssessment;

var UrlKeywordAssessment$1 = {};

Object.defineProperty(UrlKeywordAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1l = require$$1$1;

var _assessment$2 = assessment;

var _assessment2$2 = _interopRequireDefault$2f(_assessment$2);

var _shortlinker$5 = shortlinker;

var _AssessmentResult$6 = AssessmentResult$1;

var _AssessmentResult2$6 = _interopRequireDefault$2f(_AssessmentResult$6);

function _interopRequireDefault$2f(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Represents the URL keyword assessments. This assessments will check if the keyword is present in the url.
 */
class UrlKeywordAssessment extends _assessment2$2.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} config The configuration to use.
  * @param {number} [config.scores.noKeywordInUrl] The score to return if the keyword is not in the URL.
  * @param {number} [config.scores.good] The score to return if the keyword is in the URL.
  * @param {string} [config.url] The URL to the relevant KB article.
  *
  * @returns {void}
  */
	constructor(config = {}) {
		super();

		const defaultConfig = {
			scores: {
				okay: 6,
				good: 9
			},
			urlTitle: (0, _shortlinker$5.createAnchorOpeningTag)("https://yoa.st/33o"),
			urlCallToAction: (0, _shortlinker$5.createAnchorOpeningTag)("https://yoa.st/33p")
		};

		this.identifier = "urlKeyword";
		this._config = (0, _lodashEs$1l.merge)(defaultConfig, config);
	}

	/**
  * Executes the Assessment and returns a result.
  *
  * @param {Paper} paper The Paper object to assess.
  * @param {Researcher} researcher The Researcher object containing all available researches.
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {AssessmentResult} The result of the assessment, containing both a score and a descriptive text.
  */
	getResult(paper, researcher, i18n) {
		this._keywordInURL = researcher.getResearch("keywordCountInUrl");

		const assessmentResult = new _AssessmentResult2$6.default();

		const calculatedResult = this.calculateResult(i18n);
		assessmentResult.setScore(calculatedResult.score);
		assessmentResult.setText(calculatedResult.resultText);

		return assessmentResult;
	}

	/**
  * Checks whether the paper has a keyword and a url.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True when there is a keyword and an url.
  */
	isApplicable(paper) {
		return paper.hasKeyword() && paper.hasUrl();
	}

	/**
  * Determines the score and the result text based on whether or not there's a keyword in the url.
  *
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {Object} The object with calculated score and resultText.
  */
	calculateResult(i18n) {
		if (this._keywordInURL.keyphraseLength < 3) {
			if (this._keywordInURL.percentWordMatches === 100) {
				return {
					score: this._config.scores.good,
					resultText: i18n.sprintf(
					/* Translators:  %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag */
					i18n.dgettext("js-text-analysis", "%1$sKeyphrase in slug%2$s: Great work!"), this._config.urlTitle, "</a>")
				};
			}

			return {
				score: this._config.scores.okay,
				resultText: i18n.sprintf(
				/* Translators:  %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in slug%3$s: (Part of) your keyphrase does not appear in the slug. %2$sChange that%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
			};
		}

		if (this._keywordInURL.percentWordMatches > 50) {
			return {
				score: this._config.scores.good,
				resultText: i18n.sprintf(
				/* Translators:  %1$s expands to a link on yoast.com, %2$s expands to the anchor end tag */
				i18n.dgettext("js-text-analysis", "%1$sKeyphrase in slug%2$s: More than half of your keyphrase appears in the slug. That's great!"), this._config.urlTitle, "</a>")
			};
		}
		return {
			score: this._config.scores.okay,
			resultText: i18n.sprintf(
			/* Translators:  %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sKeyphrase in slug%3$s: (Part of) your keyphrase does not appear in the slug. %2$sChange that%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>")
		};
	}
}

UrlKeywordAssessment$1.default = UrlKeywordAssessment;

var UrlLengthAssessment$1 = {};

Object.defineProperty(UrlLengthAssessment$1, "__esModule", {
	value: true
});

var _lodashEs$1k = require$$1$1;

var _assessment$1 = assessment;

var _assessment2$1 = _interopRequireDefault$2e(_assessment$1);

var _shortlinker$4 = shortlinker;

var _AssessmentResult$5 = AssessmentResult$1;

var _AssessmentResult2$5 = _interopRequireDefault$2e(_AssessmentResult$5);

function _interopRequireDefault$2e(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Assessment that checks if the url is long enough.
 */
class UrlLengthAssessment extends _assessment2$1.default {
	/**
  * Sets the identifier and the config.
  *
  * @param {Object} [config] The configuration to use.
  *
  * @returns {void}
  *
  * @deprecated since 1.48. We have removed it from the assessments since we do not consider it an important SEO factor anymore.
  */
	constructor(config = {}) {
		super();

		console.warn("Deprecation Warning: The UrlLengthAssessment has been deprecated since version 1.48. " + "We have removed it from the assessments since we do not consider it an important SEO factor anymore.");

		const defaultConfig = {
			scores: {
				tooLong: 6
			},
			urlTitle: (0, _shortlinker$4.createAnchorOpeningTag)("https://yoa.st/35b"),
			urlCallToAction: (0, _shortlinker$4.createAnchorOpeningTag)("https://yoa.st/35c")
		};

		this.identifier = "urlLength";
		this._config = (0, _lodashEs$1k.merge)(defaultConfig, config);
	}

	/**
  * Checks the length of the url.
  *
  * @param {Paper} paper The paper to run this assessment on.
  * @param {Researcher} researcher The researcher used for the assessment.
  * @param {Jed} i18n The i18n-object used for parsing translations.
  *
  * @returns {AssessmentResult} an AssessmentResult with the score and the formatted text.
  */
	getResult(paper, researcher, i18n) {
		const urlIsTooLong = researcher.getResearch("urlLength");
		const assessmentResult = new _AssessmentResult2$5.default();

		assessmentResult.setScore(this.calculateScore(urlIsTooLong));
		assessmentResult.setText(this.translateScore(urlIsTooLong, i18n));

		return assessmentResult;
	}

	/**
  * Checks whether the paper has a url.
  *
  * @param {Paper} paper The paper to use for the assessment.
  *
  * @returns {boolean} True when there is text.
  */
	isApplicable(paper) {
		return paper.hasUrl();
	}

	/**
  * Calculates the score based on the url length.
  *
  * @param {boolean} urlIsTooLong True when the URL is too long.
  *
  * @returns {number|null} The calculated score.
  */
	calculateScore(urlIsTooLong) {
		if (urlIsTooLong) {
			return this._config.scores.tooLong;
		}

		return null;
	}

	/**
  * Translates the score to a message the user can understand.
  *
  * @param {boolean} urlIsTooLong True when the URL is too long.
  * @param {Jed} i18n The object used for translations.
  *
  * @returns {string} The translated string.
  */
	translateScore(urlIsTooLong, i18n) {
		if (urlIsTooLong) {
			return i18n.sprintf(
			/* Translators:  %1$s and %2$s expand to links on yoast.com, %3$s expands to the anchor end tag */
			i18n.dgettext("js-text-analysis", "%1$sSlug too long%3$s: the slug for this page is a bit long. %2$sShorten it%3$s!"), this._config.urlTitle, this._config.urlCallToAction, "</a>");
		}

		return "";
	}
}

UrlLengthAssessment$1.default = UrlLengthAssessment;

var urlStopWordsAssessment = {};

Object.defineProperty(urlStopWordsAssessment, "__esModule", {
	value: true
});

var _AssessmentResult$4 = AssessmentResult$1;

var _AssessmentResult2$4 = _interopRequireDefault$2d(_AssessmentResult$4);

var _getLanguageAvailability = getLanguageAvailability;

var _getLanguageAvailability2 = _interopRequireDefault$2d(_getLanguageAvailability);

var _shortlinker$3 = shortlinker;

function _interopRequireDefault$2d(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const availableLanguages = ["en"];

/**
 * Calculate the score based on the amount of stop words in the url.
 *
 * @param {number} stopWordCount The amount of stop words to be checked against.
 * @param {Jed} i18n The locale object.
 *
 * @returns {Object} The resulting score object.
 */
const calculateUrlStopWordsCountResult = function calculateUrlStopWordsCountResult(stopWordCount, i18n) {
	const urlTitle = (0, _shortlinker$3.createAnchorOpeningTag)("https://yoa.st/34p");
	const urlCallToAction = (0, _shortlinker$3.createAnchorOpeningTag)("https://yoa.st/34q");

	if (stopWordCount > 0) {
		return {
			score: 5,
			text: i18n.sprintf(
			/* Translators: %1$s and %2$s open links to an articles about stopwords, %3$s closes the links */
			i18n.dngettext("js-text-analysis", "%1$sSlug stopwords%3$s: The slug for this page contains a stop word. %2$sRemove it%3$s!", "%1$sSlug stopwords%3$s: The slug for this page contains stop words. %2$sRemove them%3$s!", stopWordCount), urlTitle, urlCallToAction, "</a>")
		};
	}

	return {};
};

/**
 * Execute the Assessment and return a result.
 *
 * @param {Paper} paper The Paper object to assess.
 * @param {Researcher} researcher The Researcher object containing all available researches.
 * @param {Jed} i18n The locale object.
 *
 * @returns {AssessmentResult} The result of the assessment, containing both a score and a descriptive text.
 *
 * @deprecated since 1.48. We have removed it from the assessments since we do not consider it an important SEO factor anymore.
 */
const urlHasStopWordsAssessment = function urlHasStopWordsAssessment(paper, researcher, i18n) {
	console.warn("Deprecation Warning: The UrlLengthAssessment has been deprecated since version 1.48. " + "We have removed it from the assessments since we do not consider it an important SEO factor anymore.");

	const stopWords = researcher.getResearch("stopWordsInUrl");

	const assessmentResult = new _AssessmentResult2$4.default();

	const stopWordsResult = calculateUrlStopWordsCountResult(stopWords.length, i18n);

	assessmentResult.setScore(stopWordsResult.score);
	assessmentResult.setText(stopWordsResult.text);

	return assessmentResult;
};

/**
 * Checks if there is a list of stopwords for the language of the paper.
 *
 * @param {Object} paper The paper to check.
 *
 * @returns {boolean} Returns true if the language is available.
 */
const isApplicable = function isApplicable(paper) {
	return (0, _getLanguageAvailability2.default)(paper.getLocale(), availableLanguages);
};

urlStopWordsAssessment.default = {
	identifier: "urlStopWords",
	isApplicable: isApplicable,
	getResult: urlHasStopWordsAssessment
};

Object.defineProperty(assessments$1, "__esModule", {
	value: true
});
assessments$1.seo = assessments$1.readability = undefined;

var _fleschReadingEaseAssessment$2 = fleschReadingEaseAssessment;

var _fleschReadingEaseAssessment2$2 = _interopRequireDefault$2c(_fleschReadingEaseAssessment$2);

var _paragraphTooLongAssessment$2 = paragraphTooLongAssessment;

var _paragraphTooLongAssessment2$2 = _interopRequireDefault$2c(_paragraphTooLongAssessment$2);

var _passiveVoiceAssessment$2 = passiveVoiceAssessment$1;

var _passiveVoiceAssessment2$2 = _interopRequireDefault$2c(_passiveVoiceAssessment$2);

var _sentenceBeginningsAssessment$2 = sentenceBeginningsAssessment$1;

var _sentenceBeginningsAssessment2$2 = _interopRequireDefault$2c(_sentenceBeginningsAssessment$2);

var _sentenceLengthInDescriptionAssessment = sentenceLengthInDescriptionAssessment$1;

var _sentenceLengthInDescriptionAssessment2 = _interopRequireDefault$2c(_sentenceLengthInDescriptionAssessment);

var _sentenceLengthInTextAssessment$2 = sentenceLengthInTextAssessment;

var _sentenceLengthInTextAssessment2$2 = _interopRequireDefault$2c(_sentenceLengthInTextAssessment$2);

var _subheadingDistributionTooLongAssessment$2 = subheadingDistributionTooLongAssessment;

var _subheadingDistributionTooLongAssessment2$2 = _interopRequireDefault$2c(_subheadingDistributionTooLongAssessment$2);

var _textPresenceAssessment$2 = textPresenceAssessment$1;

var _textPresenceAssessment2$2 = _interopRequireDefault$2c(_textPresenceAssessment$2);

var _transitionWordsAssessment$2 = transitionWordsAssessment$1;

var _transitionWordsAssessment2$2 = _interopRequireDefault$2c(_transitionWordsAssessment$2);

var _wordComplexityAssessment = wordComplexityAssessment$1;

var _wordComplexityAssessment2 = _interopRequireDefault$2c(_wordComplexityAssessment);

var _FunctionWordsInKeyphraseAssessment$6 = FunctionWordsInKeyphraseAssessment$1;

var _FunctionWordsInKeyphraseAssessment2$6 = _interopRequireDefault$2c(_FunctionWordsInKeyphraseAssessment$6);

var _InternalLinksAssessment$2 = InternalLinksAssessment$1;

var _InternalLinksAssessment2$2 = _interopRequireDefault$2c(_InternalLinksAssessment$2);

var _IntroductionKeywordAssessment$6 = IntroductionKeywordAssessment$1;

var _IntroductionKeywordAssessment2$6 = _interopRequireDefault$2c(_IntroductionKeywordAssessment$6);

var _KeyphraseDistributionAssessment$1 = KeyphraseDistributionAssessment$1;

var _KeyphraseDistributionAssessment2$1 = _interopRequireDefault$2c(_KeyphraseDistributionAssessment$1);

var _KeyphraseLengthAssessment$6 = KeyphraseLengthAssessment$1;

var _KeyphraseLengthAssessment2$6 = _interopRequireDefault$2c(_KeyphraseLengthAssessment$6);

var _KeywordDensityAssessment$6 = KeywordDensityAssessment$1;

var _KeywordDensityAssessment2$6 = _interopRequireDefault$2c(_KeywordDensityAssessment$6);

var _keywordStopWordsAssessment = keywordStopWordsAssessment;

var _keywordStopWordsAssessment2 = _interopRequireDefault$2c(_keywordStopWordsAssessment);

var _MetaDescriptionKeywordAssessment$6 = MetaDescriptionKeywordAssessment$1;

var _MetaDescriptionKeywordAssessment2$6 = _interopRequireDefault$2c(_MetaDescriptionKeywordAssessment$6);

var _MetaDescriptionLengthAssessment$3 = MetaDescriptionLengthAssessment$1;

var _MetaDescriptionLengthAssessment2$3 = _interopRequireDefault$2c(_MetaDescriptionLengthAssessment$3);

var _OutboundLinksAssessment$2 = OutboundLinksAssessment$1;

var _OutboundLinksAssessment2$2 = _interopRequireDefault$2c(_OutboundLinksAssessment$2);

var _PageTitleWidthAssessment$3 = PageTitleWidthAssessment$1;

var _PageTitleWidthAssessment2$3 = _interopRequireDefault$2c(_PageTitleWidthAssessment$3);

var _SingleH1Assessment$3 = SingleH1Assessment;

var _SingleH1Assessment2$3 = _interopRequireDefault$2c(_SingleH1Assessment$3);

var _SubHeadingsKeywordAssessment$2 = SubHeadingsKeywordAssessment$1;

var _SubHeadingsKeywordAssessment2$2 = _interopRequireDefault$2c(_SubHeadingsKeywordAssessment$2);

var _taxonomyTextLengthAssessment = taxonomyTextLengthAssessment$1;

var _taxonomyTextLengthAssessment2 = _interopRequireDefault$2c(_taxonomyTextLengthAssessment);

var _TextCompetingLinksAssessment$4 = TextCompetingLinksAssessment$1;

var _TextCompetingLinksAssessment2$4 = _interopRequireDefault$2c(_TextCompetingLinksAssessment$4);

var _TextImagesAssessment$4 = TextImagesAssessment$1;

var _TextImagesAssessment2$4 = _interopRequireDefault$2c(_TextImagesAssessment$4);

var _TextLengthAssessment$3 = TextLengthAssessment$1;

var _TextLengthAssessment2$3 = _interopRequireDefault$2c(_TextLengthAssessment$3);

var _TitleKeywordAssessment$3 = TitleKeywordAssessment$1;

var _TitleKeywordAssessment2$3 = _interopRequireDefault$2c(_TitleKeywordAssessment$3);

var _UrlKeywordAssessment$3 = UrlKeywordAssessment$1;

var _UrlKeywordAssessment2$3 = _interopRequireDefault$2c(_UrlKeywordAssessment$3);

var _UrlLengthAssessment = UrlLengthAssessment$1;

var _UrlLengthAssessment2 = _interopRequireDefault$2c(_UrlLengthAssessment);

var _urlStopWordsAssessment = urlStopWordsAssessment;

var _urlStopWordsAssessment2 = _interopRequireDefault$2c(_urlStopWordsAssessment);

function _interopRequireDefault$2c(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const readability = {
	FleschReadingEaseAssessment: _fleschReadingEaseAssessment2$2.default,
	ParagraphTooLongAssessment: _paragraphTooLongAssessment2$2.default,
	PassiveVoiceAssessment: _passiveVoiceAssessment2$2.default,
	SentenceBeginningsAssessment: _sentenceBeginningsAssessment2$2.default,
	SentenceLengthInDescriptionAssessment: _sentenceLengthInDescriptionAssessment2.default,
	SentenceLengthInTextAssessment: _sentenceLengthInTextAssessment2$2.default,
	SubheadingDistributionTooLongAssessment: _subheadingDistributionTooLongAssessment2$2.default,
	TextPresenceAssessment: _textPresenceAssessment2$2.default,
	TransitionWordsAssessment: _transitionWordsAssessment2$2.default,
	WordComplexityAssessment: _wordComplexityAssessment2.default
};

const seo = {
	FunctionWordsInKeyphraseAssessment: _FunctionWordsInKeyphraseAssessment2$6.default,
	InternalLinksAssessment: _InternalLinksAssessment2$2.default,
	IntroductionKeywordAssessment: _IntroductionKeywordAssessment2$6.default,
	KeyphraseLengthAssessment: _KeyphraseLengthAssessment2$6.default,
	KeywordDensityAssessment: _KeywordDensityAssessment2$6.default,
	KeywordStopWordsAssessment: _keywordStopWordsAssessment2.default,
	KeyphraseDistributionAssessment: _KeyphraseDistributionAssessment2$1.default,
	MetaDescriptionKeywordAssessment: _MetaDescriptionKeywordAssessment2$6.default,
	MetaDescriptionLengthAssessment: _MetaDescriptionLengthAssessment2$3.default,
	OutboundLinksAssessment: _OutboundLinksAssessment2$2.default,
	PageTitleWidthAssessment: _PageTitleWidthAssessment2$3.default,
	SingleH1Assessment: _SingleH1Assessment2$3.default,
	SubheadingsKeywordAssessment: _SubHeadingsKeywordAssessment2$2.default,
	TaxonomyTextLengthAssessment: _taxonomyTextLengthAssessment2.default,
	TextCompetingLinksAssessment: _TextCompetingLinksAssessment2$4.default,
	TextImagesAssessment: _TextImagesAssessment2$4.default,
	TextLengthAssessment: _TextLengthAssessment2$3.default,
	TitleKeywordAssessment: _TitleKeywordAssessment2$3.default,
	UrlKeywordAssessment: _UrlKeywordAssessment2$3.default,
	UrlLengthAssessment: _UrlLengthAssessment2.default,
	UrlStopWordsAssessment: _urlStopWordsAssessment2.default
};

assessments$1.readability = readability;
assessments$1.seo = seo;

var bundledPlugins$1 = {};

var previouslyUsedKeywords = {};

var missingArgument = {};

Object.defineProperty(missingArgument, "__esModule", {
  value: true
});

var _util$7 = require$$2$1;

var _util2$1 = _interopRequireDefault$2b(_util$7);

function _interopRequireDefault$2b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Error that means that an argument should be passed that wasn't passed.
 *
 * @constructor
 *
 * @param {string} message The message for this error.
 *
 * @returns {void}
 */
function MissingArgumentError(message) {
  Error.captureStackTrace(this, this.constructor);
  this.name = this.constructor.name;
  this.message = message;
}

_util2$1.default.inherits(MissingArgumentError, Error);

missingArgument.default = MissingArgumentError;

Object.defineProperty(previouslyUsedKeywords, "__esModule", {
	value: true
});

var _lodashEs$1j = require$$1$1;

var _missingArgument$3 = missingArgument;

var _missingArgument2$3 = _interopRequireDefault$2a(_missingArgument$3);

var _shortlinker$2 = shortlinker;

var _AssessmentResult$3 = AssessmentResult$1;

var _AssessmentResult2$3 = _interopRequireDefault$2a(_AssessmentResult$3);

function _interopRequireDefault$2a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {object} app The app
 * @param {object} args An arguments object with usedKeywords, searchUrl, postUrl,
 * @param {object} args.usedKeywords An object with keywords and ids where they are used.
 * @param {string} args.searchUrl The url used to link to a search page when multiple usages of the keyword are found.
 * @param {string} args.postUrl The url used to link to a post when 1 usage of the keyword is found.
 * @constructor
 */
var PreviouslyUsedKeyword = function PreviouslyUsedKeyword(app, args) {
	if ((0, _lodashEs$1j.isUndefined)(app)) {
		throw new _missingArgument2$3.default("The previously keyword plugin requires the YoastSEO app");
	}

	if ((0, _lodashEs$1j.isUndefined)(args)) {
		args = {
			usedKeywords: {},
			searchUrl: "",
			postUrl: ""
		};
	}

	this.app = app;
	this.usedKeywords = args.usedKeywords;
	this.searchUrl = args.searchUrl;
	this.postUrl = args.postUrl;
	this.urlTitle = (0, _shortlinker$2.createAnchorOpeningTag)("https://yoa.st/33x");
	this.urlCallToAction = (0, _shortlinker$2.createAnchorOpeningTag)("https://yoa.st/33y");
};

/**
 * Registers the assessment with the assessor.
 *
 * @returns {void}
 */
PreviouslyUsedKeyword.prototype.registerPlugin = function () {
	this.app.registerAssessment("usedKeywords", {
		getResult: this.assess.bind(this),
		/**
   * Checks if the paper has a keyphrase, which is a prerequisite for the assessment to run.
   *
   * @param {Paper} paper The paper.
   *
   * @returns {boolean} Whether the paper has a keyphrase.
   */
		isApplicable: function isApplicable(paper) {
			return paper.hasKeyword();
		}
	}, "previouslyUsedKeywords");
};

/**
 * Updates the usedKeywords.
 *
 * @param {object} usedKeywords An object with keywords and ids where they are used.
 * @returns {void}
 */
PreviouslyUsedKeyword.prototype.updateKeywordUsage = function (usedKeywords) {
	this.usedKeywords = usedKeywords;
};

/**
 * Scores the previously used keyword assessment based on the count.
 *
 * @param {object} previouslyUsedKeywords The result of the previously used keywords research
 * @param {Paper} paper The paper object to research.
 * @param {Jed} i18n The i18n object.
 * @returns {object} the scoreobject with text and score.
 */
PreviouslyUsedKeyword.prototype.scoreAssessment = function (previouslyUsedKeywords, paper, i18n) {
	var count = previouslyUsedKeywords.count;
	var id = previouslyUsedKeywords.id;
	if (count === 0) {
		return {
			text: i18n.sprintf(
			/* Translators:
   %1$s expands to a link to an article on yoast.com,
   %2$s expands to an anchor tag. */
			i18n.dgettext("js-text-analysis", "%1$sPreviously used keyphrase%2$s: You've not used this keyphrase before, very good."), this.urlTitle, "</a>"),
			score: 9
		};
	}
	if (count === 1) {
		var url = "<a href='" + this.postUrl.replace("{id}", id) + "' target='_blank'>";
		return {
			/* Translators: %1$s and %2$s expand to an admin link where the keyword is already used. %3$s and %4$s
   expand to links on yoast.com, %4$s expands to the anchor end tag. */
			text: i18n.sprintf(i18n.dgettext("js-text-analysis", "%3$sPreviously used keyphrase%5$s: " + "You've used this keyphrase %1$sonce before%2$s. " + "%4$sDo not use your keyphrase more than once%5$s."), url, "</a>", this.urlTitle, this.urlCallToAction, "</a>"),
			score: 6
		};
	}
	if (count > 1) {
		url = "<a href='" + this.searchUrl.replace("{keyword}", encodeURIComponent(paper.getKeyword())) + "' target='_blank'>";
		return {
			/* Translators: %1$s and $3$s expand to the admin search page for the keyword, %2$d expands to the number
   of times this keyword has been used before, %4$s and %5$s expand to links to yoast.com, %6$s expands to
   the anchor end tag */
			text: i18n.sprintf(i18n.dgettext("js-text-analysis", "%4$sPreviously used keyphrase%6$s: " + "You've used this keyphrase %1$s%2$d times before%3$s. " + "%5$sDo not use your keyphrase more than once%6$s."), url, count, "</a>", this.urlTitle, this.urlCallToAction, "</a>"),
			score: 1
		};
	}
};

/**
 * Researches the previously used keywords, based on the used keywords and the keyword in the paper.
 *
 * @param {Paper} paper The paper object to research.
 * @returns {{id: number, count: number}} The object with the count and the id of the previously used keyword
 */
PreviouslyUsedKeyword.prototype.researchPreviouslyUsedKeywords = function (paper) {
	var keyword = paper.getKeyword();
	var count = 0;
	var id = 0;

	if (!(0, _lodashEs$1j.isUndefined)(this.usedKeywords[keyword])) {
		count = this.usedKeywords[keyword].length;
		id = this.usedKeywords[keyword][0];
	}

	return {
		id: id,
		count: count
	};
};

/**
 * The assessment for the previously used keywords.
 *
 * @param {Paper} paper The Paper object to assess.
 * @param {Researcher} researcher The Researcher object containing all available researches.
 * @param {object} i18n The locale object.
 * @returns {AssessmentResult} The assessment result of the assessment
 */
PreviouslyUsedKeyword.prototype.assess = function (paper, researcher, i18n) {
	var previouslyUsedKeywords = this.researchPreviouslyUsedKeywords(paper);
	var previouslyUsedKeywordsResult = this.scoreAssessment(previouslyUsedKeywords, paper, i18n);

	var assessmentResult = new _AssessmentResult2$3.default();
	assessmentResult.setScore(previouslyUsedKeywordsResult.score);
	assessmentResult.setText(previouslyUsedKeywordsResult.text);

	return assessmentResult;
};

previouslyUsedKeywords.default = PreviouslyUsedKeyword;

Object.defineProperty(bundledPlugins$1, "__esModule", {
	value: true
});
bundledPlugins$1.usedKeywords = undefined;

var _previouslyUsedKeywords = previouslyUsedKeywords;

var _previouslyUsedKeywords2 = _interopRequireDefault$29(_previouslyUsedKeywords);

function _interopRequireDefault$29(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

bundledPlugins$1.usedKeywords = _previouslyUsedKeywords2.default;

var helpers$1 = {};

var scoreToRating$3 = {};

Object.defineProperty(scoreToRating$3, "__esModule", {
	value: true
});
/**
 * Interpreters a score and gives it a particular rating.
 *
 * @param {Number} score The score to interpreter.
 * @returns {string} The rating, given based on the score.
 */
const ScoreToRating = function ScoreToRating(score) {
	if (score === -1) {
		return "error";
	}

	if (score === 0) {
		return "feedback";
	}

	if (score <= 4) {
		return "bad";
	}

	if (score > 4 && score <= 7) {
		return "ok";
	}

	if (score > 7) {
		return "good";
	}

	return "";
};

scoreToRating$3.default = ScoreToRating;

var createMeasurementElement$1 = {};

Object.defineProperty(createMeasurementElement$1, "__esModule", {
	value: true
});
const elementId = "yoast-measurement-element";

/**
 * Creates an hidden element with the purpose to calculate the sizes of elements and adds these elements to the body.
 *
 * @returns {HTMLElement} The created hidden element.
 */
const createMeasurementElement = function createMeasurementElement() {
	const hiddenElement = document.createElement("div");

	hiddenElement.id = elementId;

	// Styles to prevent unintended scrolling in Gutenberg.
	hiddenElement.style.position = "absolute";
	hiddenElement.style.left = "-9999em";
	hiddenElement.style.top = 0;
	hiddenElement.style.height = 0;
	hiddenElement.style.overflow = "hidden";
	hiddenElement.style.fontFamily = "Arial";
	hiddenElement.style.fontSize = "18px";
	hiddenElement.style.fontWeight = "400";

	document.body.appendChild(hiddenElement);
	return hiddenElement;
};

/**
 * Measures the width of the text using a hidden element.
 *
 * @param {string} text The text to measure the width for.
 * @returns {number} The width in pixels.
 */
createMeasurementElement$1.measureTextWidth = function measureTextWidth(text) {
	let element = document.getElementById(elementId);
	if (!element) {
		element = createMeasurementElement();
	}
	element.innerHTML = text;
	return element.offsetWidth;
};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getLanguagesWithWordFormSupport = exports.scoreToRating = exports.measureTextWidth = undefined;

var _inRange = inRange;

Object.keys(_inRange).forEach(function (key) {
	if (key === "default" || key === "__esModule") return;
	Object.defineProperty(exports, key, {
		enumerable: true,
		get: function get() {
			return _inRange[key];
		}
	});
});

var _scoreToRating = scoreToRating$3;

var _scoreToRating2 = _interopRequireDefault(_scoreToRating);

var _createMeasurementElement = createMeasurementElement$1;

var _getLanguagesWithWordFormSupport = getLanguagesWithWordFormSupport;

var _getLanguagesWithWordFormSupport2 = _interopRequireDefault(_getLanguagesWithWordFormSupport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.measureTextWidth = _createMeasurementElement.measureTextWidth;
exports.scoreToRating = _scoreToRating2.default;
exports.getLanguagesWithWordFormSupport = _getLanguagesWithWordFormSupport2.default;

}(helpers$1));

var markers$1 = {};

var removeMarks = {};

Object.defineProperty(removeMarks, "__esModule", {
  value: true
});

removeMarks.default = function (text) {
  return text.replace(new RegExp("<yoastmark[^>]*>", "g"), "").replace(new RegExp("</yoastmark>", "g"), "");
};

Object.defineProperty(markers$1, "__esModule", {
	value: true
});
markers$1.removeMarks = undefined;

var _removeMarks = removeMarks;

var _removeMarks2 = _interopRequireDefault$28(_removeMarks);

function _interopRequireDefault$28(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

markers$1.removeMarks = _removeMarks2.default;

var stringProcessing = {};

var transliterate = {};

var transliterations$1 = {};

Object.defineProperty(transliterations$1, "__esModule", {
	value: true
});

transliterations$1.default = function (locale) {
	if ((0, _lodashEs$1i.isUndefined)(locale)) {
		return [];
	}
	switch ((0, _getLanguage2$i.default)(locale)) {
		case "es":
			return transliterations.es;
		case "pl":
			return transliterations.pl;
		case "de":
			return transliterations.de;
		case "nb":
		case "nn":
			return transliterations.nbnn;
		case "sv":
			return transliterations.sv;
		case "fi":
			return transliterations.fi;
		case "da":
			return transliterations.da;
		case "tr":
			return transliterations.tr;
		case "lv":
			return transliterations.lv;
		case "is":
			return transliterations.is;
		case "fa":
			return transliterations.fa;
		case "cs":
			return transliterations.cs;
		case "ru":
			return transliterations.ru;
		case "eo":
			return transliterations.eo;
		case "af":
			return transliterations.af;
		case "bal":
		case "ca":
			return transliterations.ca;
		case "ast":
			return transliterations.ast;
		case "an":
			return transliterations.an;
		case "ay":
			return transliterations.ay;
		case "en":
			return transliterations.en;
		case "fr":
			return transliterations.fr;
		case "it":
			return transliterations.it;
		case "nl":
			return transliterations.nl;
		case "bm":
			return transliterations.bm;
		case "uk":
			return transliterations.uk;
		case "br":
			return transliterations.br;
		case "ch":
			return transliterations.ch;
		case "csb":
			return transliterations.csb;
		case "cy":
			return transliterations.cy;
		case "ee":
			return transliterations.ee;
		case "et":
			return transliterations.et;
		case "eu":
			return transliterations.eu;
		case "fuc":
			return transliterations.fuc;
		case "fj":
			return transliterations.fj;
		case "frp":
			return transliterations.frp;
		case "fur":
			return transliterations.fur;
		case "fy":
			return transliterations.fy;
		case "ga":
			return transliterations.ga;
		case "gd":
			return transliterations.gd;
		case "gl":
			return transliterations.gl;
		case "gn":
			return transliterations.gn;
		case "gsw":
			return transliterations.gsw;
		case "hat":
			return transliterations.hat;
		case "haw":
			return transliterations.haw;
		case "hr":
			return transliterations.hr;
		case "ka":
			return transliterations.ka;
		case "kal":
			return transliterations.kal;
		case "kin":
			return transliterations.kin;
		case "lb":
			return transliterations.lb;
		case "li":
			return transliterations.li;
		case "lin":
			return transliterations.lin;
		case "lt":
			return transliterations.lt;
		case "mg":
			return transliterations.mg;
		case "mk":
			return transliterations.mk;
		case "mri":
			return transliterations.mri;
		case "mwl":
			return transliterations.mwl;
		case "oci":
			return transliterations.oci;
		case "orm":
			return transliterations.orm;
		case "pt":
			return transliterations.pt;
		case "roh":
			return transliterations.roh;
		case "rup":
			return transliterations.rup;
		case "ro":
			return transliterations.ro;
		case "tlh":
			return transliterations.tlh;
		case "sk":
			return transliterations.sk;
		case "sl":
			return transliterations.sl;
		case "sq":
			return transliterations.sq;
		case "hu":
			return transliterations.hu;
		case "srd":
			return transliterations.srd;
		case "szl":
			return transliterations.szl;
		case "tah":
			return transliterations.tah;
		case "vec":
			return transliterations.vec;
		case "wa":
			return transliterations.wa;
		case "yor":
			return transliterations.yor;
		default:
			return [];
	}
};

var _getLanguage$i = getLanguage;

var _getLanguage2$i = _interopRequireDefault$27(_getLanguage$i);

var _lodashEs$1i = require$$1$1;

function _interopRequireDefault$27(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transliterations = {

	// Language: Spanish.
	// Source: https://en.wikipedia.org/wiki/Spanish_orthography
	es: [{ letter: /[\u00F1]/g, alternative: "n" }, { letter: /[\u00D1]/g, alternative: "N" }, { letter: /[\u00E1]/g, alternative: "a" }, { letter: /[\u00C1]/g, alternative: "A" }, { letter: /[\u00E9]/g, alternative: "e" }, { letter: /[\u00C9]/g, alternative: "E" }, { letter: /[\u00ED]/g, alternative: "i" }, { letter: /[\u00CD]/g, alternative: "I" }, { letter: /[\u00F3]/g, alternative: "o" }, { letter: /[\u00D3]/g, alternative: "O" }, { letter: /[\u00FA\u00FC]/g, alternative: "u" }, { letter: /[\u00DA\u00DC]/g, alternative: "U" }],
	// Language: Polish.
	// Source: https://en.wikipedia.org/wiki/Polish_orthography
	pl: [{ letter: /[\u0105]/g, alternative: "a" }, { letter: /[\u0104]/g, alternative: "A" }, { letter: /[\u0107]/g, alternative: "c" }, { letter: /[\u0106]/g, alternative: "C" }, { letter: /[\u0119]/g, alternative: "e" }, { letter: /[\u0118]/g, alternative: "E" }, { letter: /[\u0142]/g, alternative: "l" }, { letter: /[\u0141]/g, alternative: "L" }, { letter: /[\u0144]/g, alternative: "n" }, { letter: /[\u0143]/g, alternative: "N" }, { letter: /[\u00F3]/g, alternative: "o" }, { letter: /[\u00D3]/g, alternative: "O" }, { letter: /[\u015B]/g, alternative: "s" }, { letter: /[\u015A]/g, alternative: "S" }, { letter: /[\u017A\u017C]/g, alternative: "z" }, { letter: /[\u0179\u017B]/g, alternative: "Z" }],
	// Language: German.
	// Source: https://en.wikipedia.org/wiki/German_orthography#Special_characters
	de: [{ letter: /[\u00E4]/g, alternative: "ae" }, { letter: /[\u00C4]/g, alternative: "Ae" }, { letter: /[\u00FC]/g, alternative: "ue" }, { letter: /[\u00DC]/g, alternative: "Ue" }, { letter: /[\u00F6]/g, alternative: "oe" }, { letter: /[\u00D6]/g, alternative: "Oe" }, { letter: /[\u00DF]/g, alternative: "ss" }, { letter: /[\u1E9E]/g, alternative: "SS" }],
	// Language Bokmål
	// Source: http://www.dagbladet.no/2011/12/30/tema/reise/reiseeksperter/forbrukerrettigheter/19494227/
	// Language Nynorks
	// Source: http://www.dagbladet.no/2011/12/30/tema/reise/reiseeksperter/forbrukerrettigheter/19494227/
	// Bokmål and Nynorks use the same transliterations
	nbnn: [{ letter: /[\u00E6\u04D5]/g, alternative: "ae" }, { letter: /[\u00C6\u04D4]/g, alternative: "Ae" }, { letter: /[\u00E5]/g, alternative: "aa" }, { letter: /[\u00C5]/g, alternative: "Aa" }, { letter: /[\u00F8]/g, alternative: "oe" }, { letter: /[\u00D8]/g, alternative: "Oe" }, { letter: /[\u00E9\u00E8\u00EA]/g, alternative: "e" }, { letter: /[\u00C9\u00C8\u00CA]/g, alternative: "E" }, { letter: /[\u00F3\u00F2\u00F4]/g, alternative: "o" }, { letter: /[\u00D3\u00D2\u00D4]/g, alternative: "O" }],
	// Language: Swedish.
	// Sources: https://sv.wikipedia.org/wiki/%C3%85#Historia
	// http://forum.wordreference.com/threads/swedish-%C3%A4-ae-%C3%B6-oe-acceptable.1451839/
	sv: [{ letter: /[\u00E5]/g, alternative: "aa" }, { letter: /[\u00C5]/g, alternative: "Aa" }, { letter: /[\u00E4]/g, alternative: "ae" }, { letter: /[\u00C4]/g, alternative: "Ae" }, { letter: /[\u00F6]/g, alternative: "oe" }, { letter: /[\u00D6]/g, alternative: "Oe" }, { letter: /[\u00E9]/g, alternative: "e" }, { letter: /[\u00C9]/g, alternative: "E" }, { letter: /[\u00E0]/g, alternative: "a" }, { letter: /[\u00C0]/g, alternative: "A" }],
	// Language: Finnish.
	// Sources: https://www.cs.tut.fi/~jkorpela/lang/finnish-letters.html
	// https://en.wikipedia.org/wiki/Finnish_orthography
	fi: [{ letter: /[\u00E5]/g, alternative: "aa" }, { letter: /[\u00C5]/g, alternative: "Aa" }, { letter: /[\u00E4]/g, alternative: "a" }, { letter: /[\u00C4]/g, alternative: "A" }, { letter: /[\u00F6]/g, alternative: "o" }, { letter: /[\u00D6]/g, alternative: "O" }, { letter: /[\u017E]/g, alternative: "zh" }, { letter: /[\u017D]/g, alternative: "Zh" }, { letter: /[\u0161]/g, alternative: "sh" }, { letter: /[\u0160]/g, alternative: "Sh" }],
	// Language: Danish.
	// Sources: https://sv.wikipedia.org/wiki/%C3%85#Historia
	// https://en.wikipedia.org/wiki/Danish_orthography
	da: [{ letter: /[\u00E5]/g, alternative: "aa" }, { letter: /[\u00C5]/g, alternative: "Aa" }, { letter: /[\u00E6\u04D5]/g, alternative: "ae" }, { letter: /[\u00C6\u04D4]/g, alternative: "Ae" }, { letter: /[\u00C4]/g, alternative: "Ae" }, { letter: /[\u00F8]/g, alternative: "oe" }, { letter: /[\u00D8]/g, alternative: "Oe" }, { letter: /[\u00E9]/g, alternative: "e" }, { letter: /[\u00C9]/g, alternative: "E" }],
	// Language: Turkish.
	// Source: https://en.wikipedia.org/wiki/Turkish_alphabet
	// ‘İ’ is the capital dotted ‘i’. Its lowercase counterpart is the ‘regular’ ‘i’.
	tr: [{ letter: /[\u00E7]/g, alternative: "c" }, { letter: /[\u00C7]/g, alternative: "C" }, { letter: /[\u011F]/g, alternative: "g" }, { letter: /[\u011E]/g, alternative: "G" }, { letter: /[\u00F6]/g, alternative: "o" }, { letter: /[\u00D6]/g, alternative: "O" }, { letter: /[\u015F]/g, alternative: "s" }, { letter: /[\u015E]/g, alternative: "S" }, { letter: /[\u00E2]/g, alternative: "a" }, { letter: /[\u00C2]/g, alternative: "A" }, { letter: /[\u0131\u00EE]/g, alternative: "i" }, { letter: /[\u0130\u00CE]/g, alternative: "I" }, { letter: /[\u00FC\u00FB]/g, alternative: "u" }, { letter: /[\u00DC\u00DB]/g, alternative: "U" }],
	// Language: Latvian.
	// Source: https://en.wikipedia.org/wiki/Latvian_orthography
	lv: [{ letter: /[\u0101]/g, alternative: "a" }, { letter: /[\u0100]/g, alternative: "A" }, { letter: /[\u010D]/g, alternative: "c" }, { letter: /[\u010C]/g, alternative: "C" }, { letter: /[\u0113]/g, alternative: "e" }, { letter: /[\u0112]/g, alternative: "E" }, { letter: /[\u0123]/g, alternative: "g" }, { letter: /[\u0122]/g, alternative: "G" }, { letter: /[\u012B]/g, alternative: "i" }, { letter: /[\u012A]/g, alternative: "I" }, { letter: /[\u0137]/g, alternative: "k" }, { letter: /[\u0136]/g, alternative: "K" }, { letter: /[\u013C]/g, alternative: "l" }, { letter: /[\u013B]/g, alternative: "L" }, { letter: /[\u0146]/g, alternative: "n" }, { letter: /[\u0145]/g, alternative: "N" }, { letter: /[\u0161]/g, alternative: "s" }, { letter: /[\u0160]/g, alternative: "S" }, { letter: /[\u016B]/g, alternative: "u" }, { letter: /[\u016A]/g, alternative: "U" }, { letter: /[\u017E]/g, alternative: "z" }, { letter: /[\u017D]/g, alternative: "Z" }],
	// Language: Icelandic.
	// Sources: https://en.wikipedia.org/wiki/Thorn_(letter),
	// https://en.wikipedia.org/wiki/Eth,  https://en.wikipedia.org/wiki/Icelandic_orthography
	is: [{ letter: /[\u00E1]/g, alternative: "a" }, { letter: /[\u00C1]/g, alternative: "A" }, { letter: /[\u00F0]/g, alternative: "d" }, { letter: /[\u00D0]/g, alternative: "D" }, { letter: /[\u00E9]/g, alternative: "e" }, { letter: /[\u00C9]/g, alternative: "E" }, { letter: /[\u00ED]/g, alternative: "i" }, { letter: /[\u00CD]/g, alternative: "I" }, { letter: /[\u00F3\u00F6]/g, alternative: "o" }, { letter: /[\u00D3\u00D6]/g, alternative: "O" }, { letter: /[\u00FA]/g, alternative: "u" }, { letter: /[\u00DA]/g, alternative: "U" }, { letter: /[\u00FD]/g, alternative: "y" }, { letter: /[\u00DD]/g, alternative: "Y" }, { letter: /[\u00FE]/g, alternative: "th" }, { letter: /[\u00DE]/g, alternative: "Th" }, { letter: /[\u00E6\u04D5]/g, alternative: "ae" }, { letter: /[\u00C6\u04D4]/g, alternative: "Ae" }],
	// Language: Faroese.
	// Source: https://www.facebook.com/groups/1557965757758234/permalink/1749847165236758/ (conversation in private Facebook Group ‘Faroese Language Learning Enthusiasts’)
	// depending on the word, ð can be d, g, j, v, ng or nothing. However, ‘d’ is most frequent.
	// when writing text messages or using a foreign keyboard, í is sometimes written as ij, ý as yj, ú as uv, ó as ov, ø as oe, and á as aa or oa.
	// However, in website URLs the alternatives mentioned below are by far the most common.
	fa: [{ letter: /[\u00E1]/g, alternative: "a" }, { letter: /[\u00C1]/g, alternative: "A" }, { letter: /[\u00F0]/g, alternative: "d" }, { letter: /[\u00D0]/g, alternative: "D" }, { letter: /[\u00ED]/g, alternative: "i" }, { letter: /[\u00CD]/g, alternative: "I" }, { letter: /[\u00FD]/g, alternative: "y" }, { letter: /[\u00DD]/g, alternative: "Y" }, { letter: /[\u00FA]/g, alternative: "u" }, { letter: /[\u00DA]/g, alternative: "U" }, { letter: /[\u00F3\u00F8]/g, alternative: "o" }, { letter: /[\u00D3\u00D8]/g, alternative: "O" }, { letter: /[\u00E6\u04D5]/g, alternative: "ae" }, { letter: /[\u00C6\u04D4]/g, alternative: "Ae" }],
	// Language: Czech.
	// Source: https://en.wikipedia.org/wiki/Czech_orthography
	cs: [{ letter: /[\u00E1]/g, alternative: "a" }, { letter: /[\u00C1]/g, alternative: "A" }, { letter: /[\u010D]/g, alternative: "c" }, { letter: /[\u010C]/g, alternative: "C" }, { letter: /[\u010F]/g, alternative: "d" }, { letter: /[\u010E]/g, alternative: "D" }, { letter: /[\u00ED]/g, alternative: "i" }, { letter: /[\u00CD]/g, alternative: "I" }, { letter: /[\u0148]/g, alternative: "n" }, { letter: /[\u0147]/g, alternative: "N" }, { letter: /[\u00F3]/g, alternative: "o" }, { letter: /[\u00D3]/g, alternative: "O" }, { letter: /[\u0159]/g, alternative: "r" }, { letter: /[\u0158]/g, alternative: "R" }, { letter: /[\u0161]/g, alternative: "s" }, { letter: /[\u0160]/g, alternative: "S" }, { letter: /[\u0165]/g, alternative: "t" }, { letter: /[\u0164]/g, alternative: "T" }, { letter: /[\u00FD]/g, alternative: "y" }, { letter: /[\u00DD]/g, alternative: "Y" }, { letter: /[\u017E]/g, alternative: "z" }, { letter: /[\u017D]/g, alternative: "Z" }, { letter: /[\u00E9\u011B]/g, alternative: "e" }, { letter: /[\u00C9\u011A]/g, alternative: "E" }, { letter: /[\u00FA\u016F]/g, alternative: "u" }, { letter: /[\u00DA\u016E]/g, alternative: "U" }],
	// Language: Russian.
	// Source:  Machine Readable Travel Documents, Doc 9303, Part 1, Volume 1 (PDF) (Sixth ed.).
	// ICAO. 2006. p. IV-50—IV-52. http://www.icao.int/publications/Documents/9303_p3_cons_en.pdf
	// ‘ь’ is the so-called soft sign, indicating a sound change (palatalization) of the preceding consonant.
	// In text it is transliterated to a character similar to an apostroph: ′.
	// I recommend omittance in slugs. (https://en.wikipedia.org/wiki/Romanization_of_Russian)
	ru: [{ letter: /[\u0430]/g, alternative: "a" }, { letter: /[\u0410]/g, alternative: "A" }, { letter: /[\u0431]/g, alternative: "b" }, { letter: /[\u0411]/g, alternative: "B" }, { letter: /[\u0432]/g, alternative: "v" }, { letter: /[\u0412]/g, alternative: "V" }, { letter: /[\u0433]/g, alternative: "g" }, { letter: /[\u0413]/g, alternative: "G" }, { letter: /[\u0434]/g, alternative: "d" }, { letter: /[\u0414]/g, alternative: "D" }, { letter: /[\u0435]/g, alternative: "e" }, { letter: /[\u0415]/g, alternative: "E" }, { letter: /[\u0436]/g, alternative: "zh" }, { letter: /[\u0416]/g, alternative: "Zh" }, { letter: /[\u0437]/g, alternative: "z" }, { letter: /[\u0417]/g, alternative: "Z" }, { letter: /[\u0456\u0438\u0439]/g, alternative: "i" }, { letter: /[\u0406\u0418\u0419]/g, alternative: "I" }, { letter: /[\u043A]/g, alternative: "k" }, { letter: /[\u041A]/g, alternative: "K" }, { letter: /[\u043B]/g, alternative: "l" }, { letter: /[\u041B]/g, alternative: "L" }, { letter: /[\u043C]/g, alternative: "m" }, { letter: /[\u041C]/g, alternative: "M" }, { letter: /[\u043D]/g, alternative: "n" }, { letter: /[\u041D]/g, alternative: "N" }, { letter: /[\u0440]/g, alternative: "r" }, { letter: /[\u0420]/g, alternative: "R" }, { letter: /[\u043E]/g, alternative: "o" }, { letter: /[\u041E]/g, alternative: "O" }, { letter: /[\u043F]/g, alternative: "p" }, { letter: /[\u041F]/g, alternative: "P" }, { letter: /[\u0441]/g, alternative: "s" }, { letter: /[\u0421]/g, alternative: "S" }, { letter: /[\u0442]/g, alternative: "t" }, { letter: /[\u0422]/g, alternative: "T" }, { letter: /[\u0443]/g, alternative: "u" }, { letter: /[\u0423]/g, alternative: "U" }, { letter: /[\u0444]/g, alternative: "f" }, { letter: /[\u0424]/g, alternative: "F" }, { letter: /[\u0445]/g, alternative: "kh" }, { letter: /[\u0425]/g, alternative: "Kh" }, { letter: /[\u0446]/g, alternative: "ts" }, { letter: /[\u0426]/g, alternative: "Ts" }, { letter: /[\u0447]/g, alternative: "ch" }, { letter: /[\u0427]/g, alternative: "Ch" }, { letter: /[\u0448]/g, alternative: "sh" }, { letter: /[\u0428]/g, alternative: "Sh" }, { letter: /[\u0449]/g, alternative: "shch" }, { letter: /[\u0429]/g, alternative: "Shch" }, { letter: /[\u044A]/g, alternative: "ie" }, { letter: /[\u042A]/g, alternative: "Ie" }, { letter: /[\u044B]/g, alternative: "y" }, { letter: /[\u042B]/g, alternative: "Y" }, { letter: /[\u044C]/g, alternative: "" }, { letter: /[\u042C]/g, alternative: "" }, { letter: /[\u0451\u044D]/g, alternative: "e" }, { letter: /[\u0401\u042D]/g, alternative: "E" }, { letter: /[\u044E]/g, alternative: "iu" }, { letter: /[\u042E]/g, alternative: "Iu" }, { letter: /[\u044F]/g, alternative: "ia" }, { letter: /[\u042F]/g, alternative: "Ia" }],
	// Language: Esperanto.
	// Source: https://en.wikipedia.org/wiki/Esperanto#Writing_diacritics
	eo: [{ letter: /[\u0109]/g, alternative: "ch" }, { letter: /[\u0108]/g, alternative: "Ch" }, { letter: /[\u011d]/g, alternative: "gh" }, { letter: /[\u011c]/g, alternative: "Gh" }, { letter: /[\u0125]/g, alternative: "hx" }, { letter: /[\u0124]/g, alternative: "Hx" }, { letter: /[\u0135]/g, alternative: "jx" }, { letter: /[\u0134]/g, alternative: "Jx" }, { letter: /[\u015d]/g, alternative: "sx" }, { letter: /[\u015c]/g, alternative: "Sx" }, { letter: /[\u016d]/g, alternative: "ux" }, { letter: /[\u016c]/g, alternative: "Ux" }],
	// Language: Afrikaans.
	// Source: https://en.wikipedia.org/wiki/Afrikaans#Orthography
	af: [{ letter: /[\u00E8\u00EA\u00EB]/g, alternative: "e" }, { letter: /[\u00CB\u00C8\u00CA]/g, alternative: "E" }, { letter: /[\u00EE\u00EF]/g, alternative: "i" }, { letter: /[\u00CE\u00CF]/g, alternative: "I" }, { letter: /[\u00F4\u00F6]/g, alternative: "o" }, { letter: /[\u00D4\u00D6]/g, alternative: "O" }, { letter: /[\u00FB\u00FC]/g, alternative: "u" }, { letter: /[\u00DB\u00DC]/g, alternative: "U" }],
	// Language: Catalan.
	// Source: https://en.wikipedia.org/wiki/Catalan_orthography
	ca: [{ letter: /[\u00E0]/g, alternative: "a" }, { letter: /[\u00C0]/g, alternative: "A" }, { letter: /[\u00E9|\u00E8]/g, alternative: "e" }, { letter: /[\u00C9|\u00C8]/g, alternative: "E" }, { letter: /[\u00ED|\u00EF]/g, alternative: "i" }, { letter: /[\u00CD|\u00CF]/g, alternative: "I" }, { letter: /[\u00F3|\u00F2]/g, alternative: "o" }, { letter: /[\u00D3|\u00D2]/g, alternative: "O" }, { letter: /[\u00FA|\u00FC]/g, alternative: "u" }, { letter: /[\u00DA|\u00DC]/g, alternative: "U" }, { letter: /[\u00E7]/g, alternative: "c" }, { letter: /[\u00C7]/g, alternative: "C" }],
	// Language: Asturian.
	// Source: http://www.orbilat.com/Languages/Asturian/Grammar/Asturian-Alphabet.html
	ast: [{ letter: /[\u00F1]/g, alternative: "n" }, { letter: /[\u00D1]/g, alternative: "N" }],
	// Language: Aragonese.
	// Source: https://en.wikipedia.org/wiki/Aragonese_language#Orthography
	an: [{ letter: /[\u00FC]/g, alternative: "u" }, { letter: /[\u00F1]/g, alternative: "ny" }, { letter: /[\u00E7]/g, alternative: "c" }, { letter: /[\u00ED]/g, alternative: "i" }, { letter: /[\u00F3]/g, alternative: "o" }, { letter: /[\u00E1]/g, alternative: "a" }, { letter: /[\u00DC]/g, alternative: "U" }, { letter: /[\u00D1]/g, alternative: "Ny" }, { letter: /[\u00C7]/g, alternative: "C" }, { letter: /[\u00CD]/g, alternative: "I" }, { letter: /[\u00D3]/g, alternative: "O" }, { letter: /[\u00C1]/g, alternative: "A" }],
	// Language: Aymara.
	// Source: http://www.omniglot.com/writing/aymara.htm
	ay: [{ letter: /(([\u00EF])|([\u00ED]))/g, alternative: "i" }, { letter: /(([\u00CF])|([\u00CD]))/g, alternative: "I" }, { letter: /[\u00E4]/g, alternative: "a" }, { letter: /[\u00C4]/g, alternative: "A" }, { letter: /[\u00FC]/g, alternative: "u" }, { letter: /[\u00DC]/g, alternative: "U" }, { letter: /[\u0027]/g, alternative: "" }, { letter: /[\u00F1]/g, alternative: "n" }, { letter: /[\u00D1]/g, alternative: "N" }],
	// Language: English.
	// Sources: https://en.wikipedia.org/wiki/English_terms_with_diacritical_marks https://en.wikipedia.org/wiki/English_orthography
	en: [{ letter: /[\u00E6\u04D5]/g, alternative: "ae" }, { letter: /[\u00C6\u04D4]/g, alternative: "Ae" }, { letter: /[\u0153]/g, alternative: "oe" }, { letter: /[\u0152]/g, alternative: "Oe" }, { letter: /[\u00EB\u00E9]/g, alternative: "e" }, { letter: /[\u00C9\u00CB]/g, alternative: "E" }, { letter: /[\u00F4\u00F6]/g, alternative: "o" }, { letter: /[\u00D4\u00D6]/g, alternative: "O" }, { letter: /[\u00EF]/g, alternative: "i" }, { letter: /[\u00CF]/g, alternative: "I" }, { letter: /[\u00E7]/g, alternative: "c" }, { letter: /[\u00C7]/g, alternative: "C" }, { letter: /[\u00F1]/g, alternative: "n" }, { letter: /[\u00D1]/g, alternative: "N" }, { letter: /[\u00FC]/g, alternative: "u" }, { letter: /[\u00DC]/g, alternative: "U" }, { letter: /[\u00E4]/g, alternative: "a" }, { letter: /[\u00C4]/g, alternative: "A" }],
	// Language: French.
	// Sources: https://en.wikipedia.org/wiki/French_orthography#Ligatures https://en.wikipedia.org/wiki/French_orthography#Diacritics
	fr: [{ letter: /[\u00E6\u04D5]/g, alternative: "ae" }, { letter: /[\u00C6\u04D4]/g, alternative: "Ae" }, { letter: /[\u0153]/g, alternative: "oe" }, { letter: /[\u0152]/g, alternative: "Oe" }, { letter: /[\u00E9\u00E8\u00EB\u00EA]/g, alternative: "e" }, { letter: /[\u00C9\u00C8\u00CB\u00CA]/g, alternative: "E" }, { letter: /[\u00E0\u00E2]/g, alternative: "a" }, { letter: /[\u00C0\u00C2]/g, alternative: "A" }, { letter: /[\u00EF\u00EE]/g, alternative: "i" }, { letter: /[\u00CF\u00CE]/g, alternative: "I" }, { letter: /[\u00F9\u00FB\u00FC]/g, alternative: "u" }, { letter: /[\u00D9\u00DB\u00DC]/g, alternative: "U" }, { letter: /[\u00F4]/g, alternative: "o" }, { letter: /[\u00D4]/g, alternative: "O" }, { letter: /[\u00FF]/g, alternative: "y" }, { letter: /[\u0178]/g, alternative: "Y" }, { letter: /[\u00E7]/g, alternative: "c" }, { letter: /[\u00C7]/g, alternative: "C" }, { letter: /[\u00F1]/g, alternative: "n" }, { letter: /[\u00D1]/g, alternative: "N" }],
	// Language: Italian.
	// Source: https://en.wikipedia.org/wiki/Italian_orthography
	it: [{ letter: /[\u00E0]/g, alternative: "a" }, { letter: /[\u00C0]/g, alternative: "A" }, { letter: /[\u00E9\u00E8]/g, alternative: "e" }, { letter: /[\u00C9\u00C8]/g, alternative: "E" }, { letter: /[\u00EC\u00ED\u00EE]/g, alternative: "i" }, { letter: /[\u00CC\u00CD\u00CE]/g, alternative: "I" }, { letter: /[\u00F3\u00F2]/g, alternative: "o" }, { letter: /[\u00D3\u00D2]/g, alternative: "O" }, { letter: /[\u00F9\u00FA]/g, alternative: "u" }, { letter: /[\u00D9\u00DA]/g, alternative: "U" }],
	// Language: Dutch.
	// Sources: https://en.wikipedia.org/wiki/Dutch_orthography https://nl.wikipedia.org/wiki/Trema_in_de_Nederlandse_spelling
	nl: [{ letter: /[\u00E7]/g, alternative: "c" }, { letter: /[\u00C7]/g, alternative: "C" }, { letter: /[\u00F1]/g, alternative: "n" }, { letter: /[\u00D1]/g, alternative: "N" }, { letter: /[\u00E9\u00E8\u00EA\u00EB]/g, alternative: "e" }, { letter: /[\u00C9\u00C8\u00CA\u00CB]/g, alternative: "E" }, { letter: /[\u00F4\u00F6]/g, alternative: "o" }, { letter: /[\u00D4\u00D6]/g, alternative: "O" }, { letter: /[\u00EF]/g, alternative: "i" }, { letter: /[\u00CF]/g, alternative: "I" }, { letter: /[\u00FC]/g, alternative: "u" }, { letter: /[\u00DC]/g, alternative: "U" }, { letter: /[\u00E4]/g, alternative: "a" }, { letter: /[\u00C4]/g, alternative: "A" }],
	// Language: Bambara.
	// Sources: http://www.omniglot.com/writing/bambara.htm https://en.wikipedia.org/wiki/Bambara_language
	bm: [{ letter: /[\u025B]/g, alternative: "e" }, { letter: /[\u0190]/g, alternative: "E" }, { letter: /[\u0272]/g, alternative: "ny" }, { letter: /[\u019D]/g, alternative: "Ny" }, { letter: /[\u014B]/g, alternative: "ng" }, { letter: /[\u014A]/g, alternative: "Ng" }, { letter: /[\u0254]/g, alternative: "o" }, { letter: /[\u0186]/g, alternative: "O" }],
	// Language: Ukrainian.
	// Source: Resolution no. 55 of the Cabinet of Ministers of Ukraine, January 27, 2010 http://zakon2.rada.gov.ua/laws/show/55-2010-%D0%BF
	// ‘ь’ is the so-called soft sign, indicating a sound change (palatalization) of the preceding consonant. In text it is sometimes transliterated
	// to a character similar to an apostroph: ′. Omittance is recommended in slugs (https://en.wikipedia.org/wiki/Romanization_of_Ukrainian).
	uk: [{ letter: /[\u0431]/g, alternative: "b" }, { letter: /[\u0411]/g, alternative: "B" }, { letter: /[\u0432]/g, alternative: "v" }, { letter: /[\u0412]/g, alternative: "V" }, { letter: /[\u0433]/g, alternative: "h" }, { letter: /[\u0413]/g, alternative: "H" }, { letter: /[\u0491]/g, alternative: "g" }, { letter: /[\u0490]/g, alternative: "G" }, { letter: /[\u0434]/g, alternative: "d" }, { letter: /[\u0414]/g, alternative: "D" }, { letter: /[\u043A]/g, alternative: "k" }, { letter: /[\u041A]/g, alternative: "K" }, { letter: /[\u043B]/g, alternative: "l" }, { letter: /[\u041B]/g, alternative: "L" }, { letter: /[\u043C]/g, alternative: "m" }, { letter: /[\u041C]/g, alternative: "M" }, { letter: /[\u0070]/g, alternative: "r" }, { letter: /[\u0050]/g, alternative: "R" }, { letter: /[\u043F]/g, alternative: "p" }, { letter: /[\u041F]/g, alternative: "P" }, { letter: /[\u0441]/g, alternative: "s" }, { letter: /[\u0421]/g, alternative: "S" }, { letter: /[\u0442]/g, alternative: "t" }, { letter: /[\u0422]/g, alternative: "T" }, { letter: /[\u0443]/g, alternative: "u" }, { letter: /[\u0423]/g, alternative: "U" }, { letter: /[\u0444]/g, alternative: "f" }, { letter: /[\u0424]/g, alternative: "F" }, { letter: /[\u0445]/g, alternative: "kh" }, { letter: /[\u0425]/g, alternative: "Kh" }, { letter: /[\u0446]/g, alternative: "ts" }, { letter: /[\u0426]/g, alternative: "Ts" }, { letter: /[\u0447]/g, alternative: "ch" }, { letter: /[\u0427]/g, alternative: "Ch" }, { letter: /[\u0448]/g, alternative: "sh" }, { letter: /[\u0428]/g, alternative: "Sh" }, { letter: /[\u0449]/g, alternative: "shch" }, { letter: /[\u0429]/g, alternative: "Shch" }, { letter: /[\u044C\u042C]/g, alternative: "" }, { letter: /[\u0436]/g, alternative: "zh" }, { letter: /[\u0416]/g, alternative: "Zh" }, { letter: /[\u0437]/g, alternative: "z" }, { letter: /[\u0417]/g, alternative: "Z" }, { letter: /[\u0438]/g, alternative: "y" }, { letter: /[\u0418]/g, alternative: "Y" }, { letter: /^[\u0454]/g, alternative: "ye" }, { letter: /[\s][\u0454]/g, alternative: " ye" }, { letter: /[\u0454]/g, alternative: "ie" }, { letter: /^[\u0404]/g, alternative: "Ye" }, { letter: /[\s][\u0404]/g, alternative: " Ye" }, { letter: /[\u0404]/g, alternative: "IE" }, { letter: /^[\u0457]/g, alternative: "yi" }, { letter: /[\s][\u0457]/g, alternative: " yi" }, { letter: /[\u0457]/g, alternative: "i" }, { letter: /^[\u0407]/g, alternative: "Yi" }, { letter: /[\s][\u0407]/g, alternative: " Yi" }, { letter: /[\u0407]/g, alternative: "I" }, { letter: /^[\u0439]/g, alternative: "y" }, { letter: /[\s][\u0439]/g, alternative: " y" }, { letter: /[\u0439]/g, alternative: "i" }, { letter: /^[\u0419]/g, alternative: "Y" }, { letter: /[\s][\u0419]/g, alternative: " Y" }, { letter: /[\u0419]/g, alternative: "I" }, { letter: /^[\u044E]/g, alternative: "yu" }, { letter: /[\s][\u044E]/g, alternative: " yu" }, { letter: /[\u044E]/g, alternative: "iu" }, { letter: /^[\u042E]/g, alternative: "Yu" }, { letter: /[\s][\u042E]/g, alternative: " Yu" }, { letter: /[\u042E]/g, alternative: "IU" }, { letter: /^[\u044F]/g, alternative: "ya" }, { letter: /[\s][\u044F]/g, alternative: " ya" }, { letter: /[\u044F]/g, alternative: "ia" }, { letter: /^[\u042F]/g, alternative: "Ya" }, { letter: /[\s][\u042F]/g, alternative: " Ya" }, { letter: /[\u042F]/g, alternative: "IA" }],
	// Language: Breton
	// Source: http://www.omniglot.com/writing/breton.htm
	br: [{ letter: /\u0063\u0027\u0068/g, alternative: "ch" }, { letter: /\u0043\u0027\u0048/g, alternative: "CH" }, { letter: /[\u00e2]/g, alternative: "a" }, { letter: /[\u00c2]/g, alternative: "A" }, { letter: /[\u00ea]/g, alternative: "e" }, { letter: /[\u00ca]/g, alternative: "E" }, { letter: /[\u00ee]/g, alternative: "i" }, { letter: /[\u00ce]/g, alternative: "I" }, { letter: /[\u00f4]/g, alternative: "o" }, { letter: /[\u00d4]/g, alternative: "O" }, { letter: /[\u00fb\u00f9\u00fc]/g, alternative: "u" }, { letter: /[\u00db\u00d9\u00dc]/g, alternative: "U" }, { letter: /[\u00f1]/g, alternative: "n" }, { letter: /[\u00d1]/g, alternative: "N" }],
	// Language: Chamorro
	// Source: http://www.omniglot.com/writing/chamorro.htm
	ch: [{ letter: /[\u0027]/g, alternative: "" }, { letter: /[\u00e5]/g, alternative: "a" }, { letter: /[\u00c5]/g, alternative: "A" }, { letter: /[\u00f1]/g, alternative: "n" }, { letter: /[\u00d1]/g, alternative: "N" }],
	// Language: Corsican
	// Sources: http://www.omniglot.com/writing/corsican.htm https://en.wikipedia.org/wiki/Corsican_alphabet
	co: [{ letter: /[\u00e2\u00e0]/g, alternative: "a" }, { letter: /[\u00c2\u00c0]/g, alternative: "A" }, { letter: /[\u00e6\u04d5]/g, alternative: "ae" }, { letter: /[\u00c6\u04d4]/g, alternative: "Ae" }, { letter: /[\u00e7]/g, alternative: "c" }, { letter: /[\u00c7]/g, alternative: "C" }, { letter: /[\u00e9\u00ea\u00e8\u00eb]/g, alternative: "e" }, { letter: /[\u00c9\u00ca\u00c8\u00cb]/g, alternative: "E" }, { letter: /[\u00ec\u00ee\u00ef]/g, alternative: "i" }, { letter: /[\u00cc\u00ce\u00cf]/g, alternative: "I" }, { letter: /[\u00f1]/g, alternative: "n" }, { letter: /[\u00d1]/g, alternative: "N" }, { letter: /[\u00f4\u00f2]/g, alternative: "o" }, { letter: /[\u00d4\u00d2]/g, alternative: "O" }, { letter: /[\u0153]/g, alternative: "oe" }, { letter: /[\u0152]]/g, alternative: "Oe" }, { letter: /[\u00f9\u00fc]/g, alternative: "u" }, { letter: /[\u00d9\u00dc]/g, alternative: "U" }, { letter: /[\u00ff]/g, alternative: "y" }, { letter: /[\u0178]/g, alternative: "Y" }],
	// Language: Kashubian
	// Sources: http://www.omniglot.com/writing/kashubian.htm https://en.wikipedia.org/wiki/Kashubian_language
	csb: [{ letter: /[\u0105\u00e3]/g, alternative: "a" }, { letter: /[\u0104\u00c3]/g, alternative: "A" }, { letter: /[\u00e9\u00eb]/g, alternative: "e" }, { letter: /[\u00c9\u00cb]/g, alternative: "E" }, { letter: /[\u0142]/g, alternative: "l" }, { letter: /[\u0141]/g, alternative: "L" }, { letter: /[\u0144]/g, alternative: "n" }, { letter: /[\u0143]/g, alternative: "N" }, { letter: /[\u00f2\u00f3\u00f4]/g, alternative: "o" }, { letter: /[\u00d2\u00d3\u00d4]/g, alternative: "O" }, { letter: /[\u00f9]/g, alternative: "u" }, { letter: /[\u00d9]/g, alternative: "U" }, { letter: /[\u017c]/g, alternative: "z" }, { letter: /[\u017b]/g, alternative: "Z" }],
	// Language: Welsh
	// Sources: http://www.omniglot.com/writing/welsh.htm https://en.wikipedia.org/wiki/Welsh_orthography#Diacritics
	cy: [{ letter: /[\u00e2]/g, alternative: "a" }, { letter: /[\u00c2]/g, alternative: "A" }, { letter: /[\u00ea]/g, alternative: "e" }, { letter: /[\u00ca]/g, alternative: "E" }, { letter: /[\u00ee]/g, alternative: "i" }, { letter: /[\u00ce]/g, alternative: "I" }, { letter: /[\u00f4]/g, alternative: "o" }, { letter: /[\u00d4]/g, alternative: "O" }, { letter: /[\u00fb]/g, alternative: "u" }, { letter: /[\u00db]/g, alternative: "U" }, { letter: /[\u0175]/g, alternative: "w" }, { letter: /[\u0174]/g, alternative: "W" }, { letter: /[\u0177]/g, alternative: "y" }, { letter: /[\u0176]/g, alternative: "Y" }],
	// Language: Ewe
	// Sources: http://www.omniglot.com/writing/ewe.htm https://en.wikipedia.org/wiki/Ewe_language#Writing_system
	ee: [{ letter: /[\u0256]/g, alternative: "d" }, { letter: /[\u0189]/g, alternative: "D" }, { letter: /[\u025b]/g, alternative: "e" }, { letter: /[\u0190]/g, alternative: "E" }, { letter: /[\u0192]/g, alternative: "f" }, { letter: /[\u0191]/g, alternative: "F" }, { letter: /[\u0263]/g, alternative: "g" }, { letter: /[\u0194]/g, alternative: "G" }, { letter: /[\u014b]/g, alternative: "ng" }, { letter: /[\u014a]/g, alternative: "Ng" }, { letter: /[\u0254]/g, alternative: "o" }, { letter: /[\u0186]/g, alternative: "O" }, { letter: /[\u028b]/g, alternative: "w" }, { letter: /[\u01b2]/g, alternative: "W" }, { letter: /\u0061\u0303/g, alternative: "a" }, { letter: /[\u00e1\u00e0\u01ce\u00e2\u00e3]/g, alternative: "a" }, { letter: /\u0041\u0303/g, alternative: "A" }, { letter: /[\u00c1\u00c0\u01cd\u00c2\u00c3]/g, alternative: "A" }, { letter: /[\u00e9\u00e8\u011b\u00ea]/g, alternative: "e" }, { letter: /[\u00c9\u00c8\u011a\u00ca]/g, alternative: "E" }, { letter: /[\u00f3\u00f2\u01d2\u00f4]/g, alternative: "o" }, { letter: /[\u00d3\u00d2\u01d1\u00d4]/g, alternative: "O" }, { letter: /[\u00fa\u00f9\u01d4\u00fb]/g, alternative: "u" }, { letter: /[\u00da\u00d9\u01d3\u00db]/g, alternative: "U" }, { letter: /[\u00ed\u00ec\u01d0\u00ee]/g, alternative: "i" }, { letter: /[\u00cd\u00cc\u01cf\u00ce]/g, alternative: "I" }],
	// Language: Estonian
	// Sources: http://www.omniglot.com/writing/estonian.htm https://en.wikipedia.org/wiki/Estonian_orthography https://en.wikipedia.org/wiki/%C5%BD https://en.wikipedia.org/wiki/%C5%A0
	et: [{ letter: /[\u0161]/g, alternative: "sh" }, { letter: /[\u0160]/g, alternative: "Sh" }, { letter: /[\u017e]/g, alternative: "zh" }, { letter: /[\u017d]/g, alternative: "Zh" }, { letter: /[\u00f5\u00f6]/g, alternative: "o" }, { letter: /[\u00d6\u00d5]/g, alternative: "O" }, { letter: /[\u00e4]/g, alternative: "a" }, { letter: /[\u00c4]/g, alternative: "A" }, { letter: /[\u00fc]/g, alternative: "u" }, { letter: /[\u00dc]/g, alternative: "U" }],
	// Language: Basque
	// Sources: http://www.omniglot.com/writing/basque.htm https://en.wikipedia.org/wiki/Basque_language#Writing_system https://en	.wikipedia.org/wiki/Basque_alphabet
	eu: [{ letter: /[\u00f1]/g, alternative: "n" }, { letter: /[\u00d1]/g, alternative: "N" }, { letter: /[\u00e7]/g, alternative: "c" }, { letter: /[\u00c7]/g, alternative: "C" }, { letter: /[\u00fc]/g, alternative: "u" }, { letter: /[\u00dc]/g, alternative: "U" }],
	// Language: Fulah
	// Sources: http://www.omniglot.com/writing/fula.htm https://en.wikipedia.org/wiki/Fula_language#Writing_systems
	fuc: [{ letter: /[\u0253]/g, alternative: "b" }, { letter: /[\u0181]/g, alternative: "B" }, { letter: /[\u0257]/g, alternative: "d" }, { letter: /[\u018a]/g, alternative: "D" }, { letter: /[\u014b]/g, alternative: "ng" }, { letter: /[\u014a]/g, alternative: "Ng" }, { letter: /[\u0272\u00f1]/g, alternative: "ny" }, { letter: /[\u019d\u00d1]/g, alternative: "Ny" }, { letter: /[\u01b4]/g, alternative: "y" }, { letter: /[\u01b3]/g, alternative: "Y" }, { letter: /[\u0260]/g, alternative: "g" }, { letter: /[\u0193]/g, alternative: "G" }],
	// Language: Fijian
	// Source: http://www.omniglot.com/writing/fijian.htm
	fj: [{ letter: /[\u0101]/g, alternative: "a" }, { letter: /[\u0100]/g, alternative: "A" }, { letter: /[\u0113]/g, alternative: "e" }, { letter: /[\u0112]/g, alternative: "E" }, { letter: /[\u012b]/g, alternative: "i" }, { letter: /[\u012a]/g, alternative: "I" }, { letter: /[\u016b]/g, alternative: "u" }, { letter: /[\u016a]/g, alternative: "U" }, { letter: /[\u014d]/g, alternative: "o" }, { letter: /[\u014c]/g, alternative: "O" }],
	// Language: Arpitan (Franco-Provençal language)
	// Source: http://www.omniglot.com/writing/francoprovencal.htm
	frp: [{ letter: /[\u00e2]/g, alternative: "a" }, { letter: /[\u00c2]/g, alternative: "A" }, { letter: /[\u00ea\u00e8\u00e9]/g, alternative: "e" }, { letter: /[\u00ca\u00c8\u00c9]/g, alternative: "E" }, { letter: /[\u00ee]/g, alternative: "i" }, { letter: /[\u00ce]/g, alternative: "I" }, { letter: /[\u00fb\u00fc]/g, alternative: "u" }, { letter: /[\u00db\u00dc]/g, alternative: "U" }, { letter: /[\u00f4]/g, alternative: "o" }, { letter: /[\u00d4]/g, alternative: "O" }],
	// Language: Friulian
	// Sources: https://en.wikipedia.org/wiki/Friulian_language https://en.wikipedia.org/wiki/Faggin-Nazzi_alphabet
	// http://www.omniglot.com/writing/friulian.htm
	fur: [{ letter: /[\u00E7]/g, alternative: "c" }, { letter: /[\u00C7]/g, alternative: "C" }, { letter: /[\u00e0\u00e2]/g, alternative: "a" }, { letter: /[\u00c0\u00c2]/g, alternative: "A" }, { letter: /[\u00e8\u00ea]/g, alternative: "e" }, { letter: /[\u00c8\u00ca]/g, alternative: "E" }, { letter: /[\u00ec\u00ee]/g, alternative: "i" }, { letter: /[\u00cc\u00ce]/g, alternative: "I" }, { letter: /[\u00f2\u00f4]/g, alternative: "o" }, { letter: /[\u00d2\u00d4]/g, alternative: "O" }, { letter: /[\u00f9\u00fb]/g, alternative: "u" }, { letter: /[\u00d9\u00db]/g, alternative: "U" }, { letter: /[\u010d]/g, alternative: "c" }, { letter: /[\u010c]/g, alternative: "C" }, { letter: /[\u011f]/g, alternative: "g" }, { letter: /[\u011e]/g, alternative: "G" }, { letter: /[\u0161]/g, alternative: "s" }, { letter: /[\u0160]/g, alternative: "S" }],
	// Language: Frisian
	// Sources: https://en.wikipedia.org/wiki/West_Frisian_alphabet http://www.omniglot.com/writing/frisian.htm
	fy: [{ letter: /[\u00e2\u0101\u00e4\u00e5]/g, alternative: "a" }, { letter: /[\u00c2\u0100\u00c4\u00c5]/g, alternative: "A" }, { letter: /[\u00ea\u00e9\u0113]/g, alternative: "e" }, { letter: /[\u00ca\u00c9\u0112]/g, alternative: "E" }, { letter: /[\u00f4\u00f6]/g, alternative: "o" }, { letter: /[\u00d4\u00d6]/g, alternative: "O" }, { letter: /[\u00fa\u00fb\u00fc]/g, alternative: "u" }, { letter: /[\u00da\u00db\u00dc]/g, alternative: "U" }, { letter: /[\u00ed]/g, alternative: "i" }, { letter: /[\u00cd]/g, alternative: "I" }, { letter: /[\u0111\u00f0]/g, alternative: "d" }, { letter: /[\u0110\u00d0]/g, alternative: "D" }],
	// Language: Irish
	// Source: https://en.wikipedia.org/wiki/Irish_orthography
	ga: [{ letter: /[\u00e1]/g, alternative: "a" }, { letter: /[\u00c1]/g, alternative: "A" }, { letter: /[\u00e9]/g, alternative: "e" }, { letter: /[\u00c9]/g, alternative: "E" }, { letter: /[\u00f3]/g, alternative: "o" }, { letter: /[\u00d3]/g, alternative: "O" }, { letter: /[\u00fa]/g, alternative: "u" }, { letter: /[\u00da]/g, alternative: "U" }, { letter: /[\u00ed]/g, alternative: "i" }, { letter: /[\u00cd]/g, alternative: "I" }],
	// Language: Scottish Gaelic
	// Sources: https://en.wikipedia.org/wiki/Scottish_Gaelic_orthography http://www.omniglot.com/writing/gaelic.htm
	gd: [{ letter: /[\u00e0]/g, alternative: "a" }, { letter: /[\u00c0]/g, alternative: "A" }, { letter: /[\u00e8]/g, alternative: "e" }, { letter: /[\u00c8]/g, alternative: "E" }, { letter: /[\u00f2]/g, alternative: "o" }, { letter: /[\u00d2]/g, alternative: "O" }, { letter: /[\u00f9]/g, alternative: "u" }, { letter: /[\u00d9]/g, alternative: "U" }, { letter: /[\u00ec]/g, alternative: "i" }, { letter: /[\u00cc]/g, alternative: "I" }],
	// Language: Galician
	// Sources: https://en.wikipedia.org/wiki/Diacritic https://en.wikipedia.org/wiki/Galician_Alphabet
	gl: [{ letter: /[\u00e1\u00e0]/g, alternative: "a" }, { letter: /[\u00c1\u00c0]/g, alternative: "A" }, { letter: /[\u00e9\u00ea]/g, alternative: "e" }, { letter: /[\u00c9\u00ca]/g, alternative: "E" }, { letter: /[\u00ed\u00ef]/g, alternative: "i" }, { letter: /[\u00cd\u00cf]/g, alternative: "I" }, { letter: /[\u00f3]/g, alternative: "o" }, { letter: /[\u00d3]/g, alternative: "O" }, { letter: /[\u00fa\u00fc]/g, alternative: "u" }, { letter: /[\u00da\u00dc]/g, alternative: "U" }, { letter: /[\u00e7]/g, alternative: "c" }, { letter: /[\u00c7]/g, alternative: "C" }, { letter: /[\u00f1]/g, alternative: "n" }, { letter: /[\u00d1]/g, alternative: "N" }],
	// Language: Guarani
	// Sources: https://en.wikipedia.org/wiki/Guarani_alphabet http://www.omniglot.com/writing/guarani.htm
	gn: [{ letter: /[\u2019]/g, alternative: "" }, { letter: /\u0067\u0303/g, alternative: "g" }, { letter: /\u0047\u0303/g, alternative: "G" }, { letter: /[\u00e3]/g, alternative: "a" }, { letter: /[\u00c3]/g, alternative: "A" }, { letter: /[\u1ebd]/g, alternative: "e" }, { letter: /[\u1ebc]/g, alternative: "E" }, { letter: /[\u0129]/g, alternative: "i" }, { letter: /[\u0128]/g, alternative: "I" }, { letter: /[\u00f5]/g, alternative: "o" }, { letter: /[\u00d5]/g, alternative: "O" }, { letter: /[\u00f1]/g, alternative: "n" }, { letter: /[\u00d1]/g, alternative: "N" }, { letter: /[\u0169]/g, alternative: "u" }, { letter: /[\u0168]/g, alternative: "U" }, { letter: /[\u1ef9]/g, alternative: "y" }, { letter: /[\u1ef8]/g, alternative: "Y" }],
	// Language: Swiss German
	// Source: http://www.omniglot.com/writing/swissgerman.htm
	gsw: [{ letter: /[\u00e4]/g, alternative: "a" }, { letter: /[\u00c4]/g, alternative: "A" }, { letter: /[\u00f6]/g, alternative: "o" }, { letter: /[\u00d6]/g, alternative: "O" }, { letter: /[\u00fc]/g, alternative: "u" }, { letter: /[\u00dc]/g, alternative: "U" }],
	// Language: Haitian Creole
	// Sources: https://en.wikipedia.org/wiki/Haitian_Creole http://www.omniglot.com/writing/haitiancreole.htm
	hat: [{ letter: /[\u00e8]/g, alternative: "e" }, { letter: /[\u00c8]/g, alternative: "E" }, { letter: /[\u00f2]/g, alternative: "o" }, { letter: /[\u00d2]/g, alternative: "O" }],
	// Language: Hawaiian
	// Sources: https://en.wikipedia.org/wiki/Hawaiian_language#Macron http://www.omniglot.com/writing/hawaiian.htm
	haw: [{ letter: /[\u02bb\u0027\u2019]/g, alternative: "" }, { letter: /[\u0101]/g, alternative: "a" }, { letter: /[\u0113]/g, alternative: "e" }, { letter: /[\u012b]/g, alternative: "i" }, { letter: /[\u014d]/g, alternative: "o" }, { letter: /[\u016b]/g, alternative: "u" }, { letter: /[\u0100]/g, alternative: "A" }, { letter: /[\u0112]/g, alternative: "E" }, { letter: /[\u012a]/g, alternative: "I" }, { letter: /[\u014c]/g, alternative: "O" }, { letter: /[\u016a]/g, alternative: "U" }],
	// Language: Croatian
	// Sources: https://en.wikipedia.org/wiki/Gaj%27s_Latin_alphabet https://en.wikipedia.org/wiki/D_with_stroke
	// http://www.omniglot.com/writing/croatian.htm
	hr: [{ letter: /[\u010d\u0107]/g, alternative: "c" }, { letter: /[\u010c\u0106]/g, alternative: "C" }, { letter: /[\u0111]/g, alternative: "dj" }, { letter: /[\u0110]/g, alternative: "Dj" }, { letter: /[\u0161]/g, alternative: "s" }, { letter: /[\u0160]/g, alternative: "S" }, { letter: /[\u017e]/g, alternative: "z" }, { letter: /[\u017d]/g, alternative: "Z" }, { letter: /[\u01c4]/g, alternative: "DZ" }, { letter: /[\u01c5]/g, alternative: "Dz" }, { letter: /[\u01c6]/g, alternative: "dz" }],
	// Language: Georgian
	// The Georgian language does not use capital letters.
	// Sources: https://en.wikipedia.org/wiki/Romanization_of_Georgian (national system)
	ka: [{ letter: /[\u10d0]/g, alternative: "a" }, { letter: /[\u10d1]/g, alternative: "b" }, { letter: /[\u10d2]/g, alternative: "g" }, { letter: /[\u10d3]/g, alternative: "d" }, { letter: /[\u10d4]/g, alternative: "e" }, { letter: /[\u10d5]/g, alternative: "v" }, { letter: /[\u10d6]/g, alternative: "z" }, { letter: /[\u10d7]/g, alternative: "t" }, { letter: /[\u10d8]/g, alternative: "i" }, { letter: /[\u10d9]/g, alternative: "k" }, { letter: /[\u10da]/g, alternative: "l" }, { letter: /[\u10db]/g, alternative: "m" }, { letter: /[\u10dc]/g, alternative: "n" }, { letter: /[\u10dd]/g, alternative: "o" }, { letter: /[\u10de]/g, alternative: "p" }, { letter: /[\u10df]/g, alternative: "zh" }, { letter: /[\u10e0]/g, alternative: "r" }, { letter: /[\u10e1]/g, alternative: "s" }, { letter: /[\u10e2]/g, alternative: "t" }, { letter: /[\u10e3]/g, alternative: "u" }, { letter: /[\u10e4]/g, alternative: "p" }, { letter: /[\u10e5]/g, alternative: "k" }, { letter: /[\u10e6]/g, alternative: "gh" }, { letter: /[\u10e7]/g, alternative: "q" }, { letter: /[\u10e8]/g, alternative: "sh" }, { letter: /[\u10e9]/g, alternative: "ch" }, { letter: /[\u10ea]/g, alternative: "ts" }, { letter: /[\u10eb]/g, alternative: "dz" }, { letter: /[\u10ec]/g, alternative: "ts" }, { letter: /[\u10ed]/g, alternative: "ch" }, { letter: /[\u10ee]/g, alternative: "kh" }, { letter: /[\u10ef]/g, alternative: "j" }, { letter: /[\u10f0]/g, alternative: "h" }],
	// Language: Greenlandic.
	// Source: https://en.wikipedia.org/wiki/Greenlandic_language#Orthography
	kal: [{ letter: /[\u00E5]/g, alternative: "aa" }, { letter: /[\u00C5]/g, alternative: "Aa" }, { letter: /[\u00E6\u04D5]/g, alternative: "ae" }, { letter: /[\u00C6\u04D4]/g, alternative: "Ae" }, { letter: /[\u00C4]/g, alternative: "Ae" }, { letter: /[\u00F8]/g, alternative: "oe" }, { letter: /[\u00D8]/g, alternative: "Oe" }],
	// Language: Kinyarwanda.
	// Source: https://en.wikipedia.org/wiki/Kinyarwanda
	kin: [{ letter: /[\u2019\u0027]/g, alternative: "" }],
	// Language: Luxembourgish.
	// Source: http://www.omniglot.com/writing/luxembourgish.htm
	lb: [{ letter: /[\u00e4]/g, alternative: "a" }, { letter: /[\u00c4]/g, alternative: "A" }, { letter: /[\u00eb\u00e9]/g, alternative: "e" }, { letter: /[\u00cb\u00c9]/g, alternative: "E" }],
	// Language: Limburgish.
	// Source: http://www.omniglot.com/writing/limburgish.htm
	li: [{ letter: /[\u00e1\u00e2\u00e0\u00e4]/g, alternative: "a" }, { letter: /[\u00c1\u00c2\u00c0\u00c4]/g, alternative: "A" }, { letter: /[\u00eb\u00e8\u00ea]/g, alternative: "e" }, { letter: /[\u00cb\u00c8\u00ca]/g, alternative: "E" }, { letter: /[\u00f6\u00f3]/g, alternative: "o" }, { letter: /[\u00d6\u00d3]/g, alternative: "O" }],
	// Language: Lingala.
	// Sources: https://en.wikipedia.org/wiki/Lingala#Writing_system http://www.omniglot.com/writing/lingala.htm
	lin: [{ letter: /[\u00e1\u00e2\u01ce]/g, alternative: "a" }, { letter: /[\u00c1\u00c2\u01cd]/g, alternative: "A" }, { letter: /\u025b\u0301/g, alternative: "e" }, { letter: /\u025b\u0302/g, alternative: "e" }, { letter: /\u025b\u030c/g, alternative: "e" }, { letter: /[\u00e9\u00ea\u011b\u025b]/g, alternative: "e" }, { letter: /\u0190\u0301/g, alternative: "E" }, { letter: /\u0190\u0302/g, alternative: "E" }, { letter: /\u0190\u030c/g, alternative: "E" }, { letter: /[\u00c9\u00ca\u011a\u0190]/g, alternative: "E" }, { letter: /[\u00ed\u00ee\u01d0]/g, alternative: "i" }, { letter: /[\u00cd\u00ce\u01cf]/g, alternative: "I" }, { letter: /\u0254\u0301/g, alternative: "o" }, { letter: /\u0254\u0302/g, alternative: "o" }, { letter: /\u0254\u030c/g, alternative: "o" }, { letter: /[\u00f3\u00f4\u01d2\u0254]/g, alternative: "o" }, { letter: /\u0186\u0301/g, alternative: "O" }, { letter: /\u0186\u0302/g, alternative: "O" }, { letter: /\u0186\u030c/g, alternative: "O" }, { letter: /[\u00d3\u00d4\u01d1\u0186]/g, alternative: "O" }, { letter: /[\u00fa]/g, alternative: "u" }, { letter: /[\u00da]/g, alternative: "U" }],
	// Language: Lithuanian.
	// Sources: https://en.wikipedia.org/wiki/Lithuanian_orthography http://www.omniglot.com/writing/lithuanian.htm
	lt: [{ letter: /[\u0105]/g, alternative: "a" }, { letter: /[\u0104]/g, alternative: "A" }, { letter: /[\u010d]/g, alternative: "c" }, { letter: /[\u010c]/g, alternative: "C" }, { letter: /[\u0119\u0117]/g, alternative: "e" }, { letter: /[\u0118\u0116]/g, alternative: "E" }, { letter: /[\u012f]/g, alternative: "i" }, { letter: /[\u012e]/g, alternative: "I" }, { letter: /[\u0161]/g, alternative: "s" }, { letter: /[\u0160]/g, alternative: "S" }, { letter: /[\u0173\u016b]/g, alternative: "u" }, { letter: /[\u0172\u016a]/g, alternative: "U" }, { letter: /[\u017e]/g, alternative: "z" }, { letter: /[\u017d]/g, alternative: "Z" }],
	// Language: Malagasy.
	// Source: http://www.omniglot.com/writing/malagasy.htm
	mg: [{ letter: /[\u00f4]/g, alternative: "ao" }, { letter: /[\u00d4]/g, alternative: "Ao" }],
	// Language: Macedonian.
	// Source: http://www.omniglot.com/writing/macedonian.htm
	mk: [{ letter: /[\u0430]/g, alternative: "a" }, { letter: /[\u0410]/g, alternative: "A" }, { letter: /[\u0431]/g, alternative: "b" }, { letter: /[\u0411]/g, alternative: "B" }, { letter: /[\u0432]/g, alternative: "v" }, { letter: /[\u0412]/g, alternative: "V" }, { letter: /[\u0433]/g, alternative: "g" }, { letter: /[\u0413]/g, alternative: "G" }, { letter: /[\u0434]/g, alternative: "d" }, { letter: /[\u0414]/g, alternative: "D" }, { letter: /[\u0453]/g, alternative: "gj" }, { letter: /[\u0403]/g, alternative: "Gj" }, { letter: /[\u0435]/g, alternative: "e" }, { letter: /[\u0415]/g, alternative: "E" }, { letter: /[\u0436]/g, alternative: "zh" }, { letter: /[\u0416]/g, alternative: "Zh" }, { letter: /[\u0437]/g, alternative: "z" }, { letter: /[\u0417]/g, alternative: "Z" }, { letter: /[\u0455]/g, alternative: "dz" }, { letter: /[\u0405]/g, alternative: "Dz" }, { letter: /[\u0438]/g, alternative: "i" }, { letter: /[\u0418]/g, alternative: "I" }, { letter: /[\u0458]/g, alternative: "j" }, { letter: /[\u0408]/g, alternative: "J" }, { letter: /[\u043A]/g, alternative: "k" }, { letter: /[\u041A]/g, alternative: "K" }, { letter: /[\u043B]/g, alternative: "l" }, { letter: /[\u041B]/g, alternative: "L" }, { letter: /[\u0459]/g, alternative: "lj" }, { letter: /[\u0409]/g, alternative: "Lj" }, { letter: /[\u043C]/g, alternative: "m" }, { letter: /[\u041C]/g, alternative: "M" }, { letter: /[\u043D]/g, alternative: "n" }, { letter: /[\u041D]/g, alternative: "N" }, { letter: /[\u045A]/g, alternative: "nj" }, { letter: /[\u040A]/g, alternative: "Nj" }, { letter: /[\u043E]/g, alternative: "o" }, { letter: /[\u041E]/g, alternative: "O" }, { letter: /[\u0440]/g, alternative: "r" }, { letter: /[\u0420]/g, alternative: "R" }, { letter: /[\u043F]/g, alternative: "p" }, { letter: /[\u041F]/g, alternative: "P" }, { letter: /[\u0441]/g, alternative: "s" }, { letter: /[\u0421]/g, alternative: "S" }, { letter: /[\u0442]/g, alternative: "t" }, { letter: /[\u0422]/g, alternative: "T" }, { letter: /[\u045C]/g, alternative: "kj" }, { letter: /[\u040C]/g, alternative: "Kj" }, { letter: /[\u0443]/g, alternative: "u" }, { letter: /[\u0423]/g, alternative: "U" }, { letter: /[\u0444]/g, alternative: "f" }, { letter: /[\u0424]/g, alternative: "F" }, { letter: /[\u0445]/g, alternative: "h" }, { letter: /[\u0425]/g, alternative: "H" }, { letter: /[\u0446]/g, alternative: "c" }, { letter: /[\u0426]/g, alternative: "C" }, { letter: /[\u0447]/g, alternative: "ch" }, { letter: /[\u0427]/g, alternative: "Ch" }, { letter: /[\u045F]/g, alternative: "dj" }, { letter: /[\u040F]/g, alternative: "Dj" }, { letter: /[\u0448]/g, alternative: "sh" }, { letter: /[\u0428]/g, alternative: "Sh" }],
	// Language: Maori.
	// Source: http://www.omniglot.com/writing/maori.htm
	mri: [{ letter: /[\u0101]/g, alternative: "aa" }, { letter: /[\u0100]/g, alternative: "Aa" }, { letter: /[\u0113]/g, alternative: "ee" }, { letter: /[\u0112]/g, alternative: "Ee" }, { letter: /[\u012b]/g, alternative: "ii" }, { letter: /[\u012a]/g, alternative: "Ii" }, { letter: /[\u014d]/g, alternative: "oo" }, { letter: /[\u014c]/g, alternative: "Oo" }, { letter: /[\u016b]/g, alternative: "uu" }, { letter: /[\u016a]/g, alternative: "Uu" }],
	// Language: Mirandese.
	// Source: http://www.omniglot.com/writing/mirandese.htm
	mwl: [{ letter: /[\u00e7]/g, alternative: "c" }, { letter: /[\u00c7]/g, alternative: "C" }, { letter: /[\u00e1]/g, alternative: "a" }, { letter: /[\u00c1]/g, alternative: "A" }, { letter: /[\u00e9\u00ea]/g, alternative: "e" }, { letter: /[\u00c9\u00ca]/g, alternative: "E" }, { letter: /[\u00ed]/g, alternative: "i" }, { letter: /[\u00cd]/g, alternative: "I" }, { letter: /[\u00f3\u00f4]/g, alternative: "o" }, { letter: /[\u00d3\u00d4]/g, alternative: "O" }, { letter: /[\u00fa\u0169]/g, alternative: "u" }, { letter: /[\u00da\u0168]/g, alternative: "U" }],
	// Language: Occitan.
	// Sources: http://www.omniglot.com/writing/oromo.htm https://en.wikipedia.org/wiki/Occitan_alphabet
	oci: [{ letter: /[\u00e7]/g, alternative: "c" }, { letter: /[\u00c7]/g, alternative: "C" }, { letter: /[\u00e0\u00e1]/g, alternative: "a" }, { letter: /[\u00c0\u00c1]/g, alternative: "A" }, { letter: /[\u00e8\u00e9]/g, alternative: "e" }, { letter: /[\u00c8\u00c9]/g, alternative: "E" }, { letter: /[\u00ed\u00ef]/g, alternative: "i" }, { letter: /[\u00cd\u00cf]/g, alternative: "I" }, { letter: /[\u00f2\u00f3]/g, alternative: "o" }, { letter: /[\u00d2\u00d3]/g, alternative: "O" }, { letter: /[\u00fa\u00fc]/g, alternative: "u" }, { letter: /[\u00da\u00dc]/g, alternative: "U" }, { letter: /[\u00b7]/g, alternative: "" }],
	// Language: Oromo.
	// Source: http://www.omniglot.com/writing/occitan.htm
	orm: [{ letter: /[\u0027]/g, alternative: "" }],
	// Language: Portuguese.
	// Source: https://en.wikipedia.org/wiki/Portuguese_orthography http://www.omniglot.com/writing/portuguese.htm
	pt: [{ letter: /[\u00e7]/g, alternative: "c" }, { letter: /[\u00c7]/g, alternative: "C" }, { letter: /[\u00e1\u00e2\u00e3\u00e0]/g, alternative: "a" }, { letter: /[\u00c1\u00c2\u00c3\u00c0]/g, alternative: "A" }, { letter: /[\u00e9\u00ea]/g, alternative: "e" }, { letter: /[\u00c9\u00ca]/g, alternative: "E" }, { letter: /[\u00ed]/g, alternative: "i" }, { letter: /[\u00cd]/g, alternative: "I" }, { letter: /[\u00f3\u00f4\u00f5]/g, alternative: "o" }, { letter: /[\u00d3\u00d4\u00d5]/g, alternative: "O" }, { letter: /[\u00fa]/g, alternative: "u" }, { letter: /[\u00da]/g, alternative: "U" }],
	// Language: Romansh Vallader.
	// Source: https://en.wikipedia.org/wiki/Romansh_language#Orthography http://www.omniglot.com/writing/romansh.htm
	roh: [{ letter: /[\u00e9\u00e8\u00ea]/g, alternative: "e" }, { letter: /[\u00c9\u00c8\u00ca]/g, alternative: "E" }, { letter: /[\u00ef]/g, alternative: "i" }, { letter: /[\u00cf]/g, alternative: "I" }, { letter: /[\u00f6]/g, alternative: "oe" }, { letter: /[\u00d6]/g, alternative: "Oe" }, { letter: /[\u00fc]/g, alternative: "ue" }, { letter: /[\u00dc]/g, alternative: "Ue" }, { letter: /[\u00e4]/g, alternative: "ae" }, { letter: /[\u00c4]/g, alternative: "Ae" }],
	// Language: Aromanian.
	// Sources: https://en.wikipedia.org/wiki/Aromanian_alphabet http://www.omniglot.com/writing/aromanian.htm
	rup: [{ letter: /[\u00e3]/g, alternative: "a" }, { letter: /[\u00c3]/g, alternative: "A" }],
	// Language: Romanian.
	// Sources: http://forum.wordreference.com/threads/romanian-transliteration.3193544/#post-16161251
	// https://en.wikipedia.org/wiki/Romanian_alphabet http://www.omniglot.com/writing/romanian.htm
	ro: [{ letter: /[\u0103\u00e2]/g, alternative: "a" }, { letter: /[\u0102\u00c2]/g, alternative: "A" }, { letter: /[\u00ee]/g, alternative: "i" }, { letter: /[\u00ce]/g, alternative: "I" }, { letter: /[\u0219\u015f]/g, alternative: "s" }, { letter: /[\u0218\u015e]/g, alternative: "S" }, { letter: /[\u021b\u0163]/g, alternative: "t" }, { letter: /[\u021a\u0162]/g, alternative: "T" }],
	// Language: Klingon.
	// Sources: http://www.omniglot.com/conscripts/klingon.htm https://en.wikipedia.org/wiki/Klingon_language#Writing_systems
	// This translation module only works for Klingon written in Latin characters. KLI PlqaD script is not supported yet.
	tlh: [{ letter: /[\u2019\u0027]/g, alternative: "" }],
	// Language: Slovak.
	// Sources: https://en.wikipedia.org/wiki/Dz_(digraph) https://en.wikipedia.org/wiki/Slovak_orthography
	// http://www.omniglot.com/writing/slovak.htm
	sk: [{ letter: /[\u01c4]/g, alternative: "DZ" }, { letter: /[\u01c5]/g, alternative: "Dz" }, { letter: /[\u01c6]/g, alternative: "dz" }, { letter: /[\u00e1\u00e4]/g, alternative: "a" }, { letter: /[\u00c1\u00c4]/g, alternative: "A" }, { letter: /[\u010d]/g, alternative: "c" }, { letter: /[\u010c]/g, alternative: "C" }, { letter: /[\u010f]/g, alternative: "d" }, { letter: /[\u010e]/g, alternative: "D" }, { letter: /[\u00e9]/g, alternative: "e" }, { letter: /[\u00c9]/g, alternative: "E" }, { letter: /[\u00ed]/g, alternative: "i" }, { letter: /[\u00cd]/g, alternative: "I" }, { letter: /[\u013e\u013a]/g, alternative: "l" }, { letter: /[\u013d\u0139]/g, alternative: "L" }, { letter: /[\u0148]/g, alternative: "n" }, { letter: /[\u0147]/g, alternative: "N" }, { letter: /[\u00f3\u00f4]/g, alternative: "o" }, { letter: /[\u00d3\u00d4]/g, alternative: "O" }, { letter: /[\u0155]/g, alternative: "r" }, { letter: /[\u0154]/g, alternative: "R" }, { letter: /[\u0161]/g, alternative: "s" }, { letter: /[\u0160]/g, alternative: "S" }, { letter: /[\u0165]/g, alternative: "t" }, { letter: /[\u0164]/g, alternative: "T" }, { letter: /[\u00fa]/g, alternative: "u" }, { letter: /[\u00da]/g, alternative: "U" }, { letter: /[\u00fd]/g, alternative: "y" }, { letter: /[\u00dd]/g, alternative: "Y" }, { letter: /[\u017e]/g, alternative: "z" }, { letter: /[\u017d]/g, alternative: "Z" }],
	// Language: Slovenian.
	// Sources: https://en.wikipedia.org/wiki/Slovene_alphabet http://www.omniglot.com/writing/slovene.htm
	sl: [{ letter: /[\u010d\u0107]/g, alternative: "c" }, { letter: /[\u010c\u0106]/g, alternative: "C" }, { letter: /[\u0111]/g, alternative: "d" }, { letter: /[\u0110]/g, alternative: "D" }, { letter: /[\u0161]/g, alternative: "s" }, { letter: /[\u0160]/g, alternative: "S" }, { letter: /[\u017e]/g, alternative: "z" }, { letter: /[\u017d]/g, alternative: "Z" }, { letter: /[\u00e0\u00e1\u0203\u0201]/g, alternative: "a" }, { letter: /[\u00c0\u00c1\u0202\u0200]/g, alternative: "A" }, { letter: /[\u00e8\u00e9\u0207\u0205]/g, alternative: "e" }, { letter: /\u01dd\u0300/g, alternative: "e" }, { letter: /\u01dd\u030f/g, alternative: "e" }, { letter: /\u1eb9\u0301/g, alternative: "e" }, { letter: /\u1eb9\u0311/g, alternative: "e" }, { letter: /[\u00c8\u00c9\u0206\u0204]/g, alternative: "E" }, { letter: /\u018e\u030f/g, alternative: "E" }, { letter: /\u018e\u0300/g, alternative: "E" }, { letter: /\u1eb8\u0311/g, alternative: "E" }, { letter: /\u1eb8\u0301/g, alternative: "E" }, { letter: /[\u00ec\u00ed\u020b\u0209]/g, alternative: "i" }, { letter: /[\u00cc\u00cd\u020a\u0208]/g, alternative: "I" }, { letter: /[\u00f2\u00f3\u020f\u020d]/g, alternative: "o" }, { letter: /\u1ecd\u0311/g, alternative: "o" }, { letter: /\u1ecd\u0301/g, alternative: "o" }, { letter: /\u1ecc\u0311/g, alternative: "O" }, { letter: /\u1ecc\u0301/g, alternative: "O" }, { letter: /[\u00d2\u00d3\u020e\u020c]/g, alternative: "O" }, { letter: /[\u00f9\u00fa\u0217\u0215]/g, alternative: "u" }, { letter: /[\u00d9\u00da\u0216\u0214]/g, alternative: "U" }, { letter: /[\u0155\u0213]/g, alternative: "r" }, { letter: /[\u0154\u0212]/g, alternative: "R" }],
	// Language: Albanian.
	// Sources: https://en.wikipedia.org/wiki/Albanian_alphabet http://www.omniglot.com/writing/albanian.htm
	sq: [{ letter: /[\u00e7]/g, alternative: "c" }, { letter: /[\u00c7]/g, alternative: "C" }, { letter: /[\u00eb]/g, alternative: "e" }, { letter: /[\u00cb]/g, alternative: "E" }],
	// Language: Hungarian.
	// Sources: http://forum.wordreference.com/threads/hungarian-transliteration.3193022/#post-16166901
	// http://www.omniglot.com/writing/hungarian.htm
	hu: [{ letter: /[\u00e1]/g, alternative: "a" }, { letter: /[\u00c1]/g, alternative: "A" }, { letter: /[\u00e9]/g, alternative: "e" }, { letter: /[\u00c9]/g, alternative: "E" }, { letter: /[\u00ed]/g, alternative: "i" }, { letter: /[\u00cd]/g, alternative: "I" }, { letter: /[\u00f3\u00f6\u0151]/g, alternative: "o" }, { letter: /[\u00d3\u00d6\u0150]/g, alternative: "O" }, { letter: /[\u00fa\u00fc\u0171]/g, alternative: "u" }, { letter: /[\u00da\u00dc\u0170]/g, alternative: "U" }],
	// Language: Sardinian.
	// Sources: http://www.omniglot.com/writing/sardinian.htm https://en.wikipedia.org/wiki/Sardinian_language
	srd: [{ letter: /[\u00e7]/g, alternative: "c" }, { letter: /[\u00c7]/g, alternative: "C" }, { letter: /[\u00e0\u00e1]/g, alternative: "a" }, { letter: /[\u00c0\u00c1]/g, alternative: "A" }, { letter: /[\u00e8\u00e9]/g, alternative: "e" }, { letter: /[\u00c8\u00c9]/g, alternative: "E" }, { letter: /[\u00ed\u00ef]/g, alternative: "i" }, { letter: /[\u00cd\u00cf]/g, alternative: "I" }, { letter: /[\u00f2\u00f3]/g, alternative: "o" }, { letter: /[\u00d2\u00d3]/g, alternative: "O" }, { letter: /[\u00fa\u00f9]/g, alternative: "u" }, { letter: /[\u00da\u00d9]/g, alternative: "U" }],
	// Language: Silesian.
	// Source: https://en.wikipedia.org/wiki/Silesian_language#Writing_system
	szl: [{ letter: /[\u0107]/g, alternative: "c" }, { letter: /[\u0106]/g, alternative: "C" }, { letter: /[\u00e3]/g, alternative: "a" }, { letter: /[\u00c3]/g, alternative: "A" }, { letter: /[\u0142]/g, alternative: "u" }, { letter: /[\u0141]/g, alternative: "U" }, { letter: /[\u006e]/g, alternative: "n" }, { letter: /[\u004e]/g, alternative: "N" }, { letter: /[\u014f\u014d\u00f4\u00f5]/g, alternative: "o" }, { letter: /[\u014e\u014c\u00d4\u00d5]/g, alternative: "O" }, { letter: /[\u015b]/g, alternative: "s" }, { letter: /[\u015a]/g, alternative: "S" }, { letter: /[\u017a\u017c\u017e]/g, alternative: "z" }, { letter: /[\u0179\u017b\u017d]/g, alternative: "Z" }, { letter: /[\u016f]/g, alternative: "u" }, { letter: /[\u016e]/g, alternative: "U" }, { letter: /[\u010d]/g, alternative: "cz" }, { letter: /[\u010c]/g, alternative: "Cz" }, { letter: /[\u0159]/g, alternative: "rz" }, { letter: /[\u0158]/g, alternative: "Rz" }, { letter: /[\u0161]/g, alternative: "sz" }, { letter: /[\u0160]/g, alternative: "Sz" }],
	// Language: Tahitian.
	// Sources: https://en.wikipedia.org/wiki/Tahitian_language#Phonology http://www.omniglot.com/writing/tahitian.htm
	tah: [{ letter: /[\u0101\u00e2\u00e0]/g, alternative: "a" }, { letter: /[\u0100\u00c2\u00c0]/g, alternative: "A" }, { letter: /[\u00ef\u00ee\u00ec]/g, alternative: "i" }, { letter: /[\u00cf\u00ce\u00cc]/g, alternative: "I" }, { letter: /[\u0113\u00ea\u00e9]/g, alternative: "e" }, { letter: /[\u0112\u00ca\u00c9]/g, alternative: "E" }, { letter: /[\u016b\u00fb\u00fa]/g, alternative: "u" }, { letter: /[\u016a\u00db\u00da]/g, alternative: "U" }, { letter: /[\u00e7]/g, alternative: "c" }, { letter: /[\u00c7]/g, alternative: "C" }, { letter: /[\u00f2\u00f4\u014d]/g, alternative: "o" }, { letter: /[\u00d2\u00d4\u014c]/g, alternative: "O" }, { letter: /[\u2019\u0027\u2018]/g, alternative: "" }],
	// Language: Venetian.
	// Sources: http://www.omniglot.com/writing/venetian.htm https://en.wikipedia.org/wiki/Venetian_language#Spelling_systems
	// http://www.venipedia.org/wiki/index.php?title=Venetian_Language
	vec: [{ letter: /\u0073\u002d\u0063/g, alternative: "sc" }, { letter: /\u0053\u002d\u0043/g, alternative: "SC" }, { letter: /\u0073\u0027\u0063/g, alternative: "sc" }, { letter: /\u0053\u0027\u0043/g, alternative: "SC" }, { letter: /\u0073\u2019\u0063/g, alternative: "sc" }, { letter: /\u0053\u2019\u0043/g, alternative: "SC" }, { letter: /\u0073\u2018\u0063/g, alternative: "sc" }, { letter: /\u0053\u2018\u0043/g, alternative: "SC" }, { letter: /\u0053\u002d\u0063/g, alternative: "Sc" }, { letter: /\u0053\u0027\u0063/g, alternative: "Sc" }, { letter: /\u0053\u2019\u0063/g, alternative: "Sc" }, { letter: /\u0053\u2018\u0063/g, alternative: "Sc" }, { letter: /\u0063\u2019/g, alternative: "c" }, { letter: /\u0043\u2019/g, alternative: "C" }, { letter: /\u0063\u2018/g, alternative: "c" }, { letter: /\u0043\u2018/g, alternative: "C" }, { letter: /\u0063\u0027/g, alternative: "c" }, { letter: /\u0043\u0027/g, alternative: "C" }, { letter: /[\u00e0\u00e1\u00e2]/g, alternative: "a" }, { letter: /[\u00c0\u00c1\u00c2]/g, alternative: "A" }, { letter: /[\u00e8\u00e9]/g, alternative: "e" }, { letter: /[\u00c8\u00c9]/g, alternative: "E" }, { letter: /[\u00f2\u00f3]/g, alternative: "o" }, { letter: /[\u00d2\u00d3]/g, alternative: "O" }, { letter: /[\u00f9\u00fa]/g, alternative: "u" }, { letter: /[\u00d9\u00da]/g, alternative: "U" }, { letter: /[\u00e7\u010d\u010b]/g, alternative: "c" }, { letter: /[\u00c7\u010c\u010a]/g, alternative: "C" }, { letter: /[\u0142]/g, alternative: "l" }, { letter: /[\u00a3\u0141]/g, alternative: "L" }, { letter: /\ud835\udeff/g, alternative: "dh" }, { letter: /[\u0111\u03b4]/g, alternative: "dh" }, { letter: /[\u0110\u0394]/g, alternative: "Dh" }],
	// Language: Walloon.
	// Sources: http://www.omniglot.com/writing/walloon.htm https://en.wikipedia.org/wiki/Walloon_alphabet
	wa: [{ letter: /[\u00e2\u00e5]/g, alternative: "a" }, { letter: /[\u00c2\u00c5]/g, alternative: "A" }, { letter: /[\u00e7]/g, alternative: "c" }, { letter: /[\u00c7]/g, alternative: "C" }, { letter: /\u0065\u030a/g, alternative: "e" }, { letter: /\u0045\u030a/g, alternative: "E" }, { letter: /[\u00eb\u00ea\u00e8\u00e9]/g, alternative: "e" }, { letter: /[\u00c9\u00c8\u00ca\u00cb]/g, alternative: "E" }, { letter: /[\u00ee]/g, alternative: "i" }, { letter: /[\u00ce]/g, alternative: "I" }, { letter: /[\u00f4\u00f6]/g, alternative: "o" }, { letter: /[\u00d6\u00d4]/g, alternative: "O" }, { letter: /[\u00fb]/g, alternative: "u" }, { letter: /[\u00db]/g, alternative: "U" }],
	// Language: Yoruba.
	// Sources: http://www.omniglot.com/writing/yoruba.htm https://en.wikipedia.org/wiki/Yoruba_language
	yor: [{ letter: /[\u00e1\u00e0]/g, alternative: "a" }, { letter: /[\u00c1\u00c0]/g, alternative: "A" }, { letter: /[\u00ec\u00ed]/g, alternative: "i" }, { letter: /[\u00cc\u00cd]/g, alternative: "I" }, { letter: /\u1ecd\u0301/g, alternative: "o" }, { letter: /\u1ecc\u0301/g, alternative: "O" }, { letter: /\u1ecd\u0300/g, alternative: "o" }, { letter: /\u1ecc\u0300/g, alternative: "O" }, { letter: /[\u00f3\u00f2\u1ecd]/g, alternative: "o" }, { letter: /[\u00d3\u00d2\u1ecc]/g, alternative: "O" }, { letter: /[\u00fa\u00f9]/g, alternative: "u" }, { letter: /[\u00da\u00d9]/g, alternative: "U" }, { letter: /\u1eb9\u0301/g, alternative: "e" }, { letter: /\u1eb8\u0301/g, alternative: "E" }, { letter: /\u1eb9\u0300/g, alternative: "e" }, { letter: /\u1eb8\u0300/g, alternative: "E" }, { letter: /[\u00e9\u00e8\u1eb9]/g, alternative: "e" }, { letter: /[\u00c9\u00c8\u1eb8]/g, alternative: "E" }, { letter: /[\u1e63]/g, alternative: "s" }, { letter: /[\u1e62]/g, alternative: "S" }]
};

Object.defineProperty(transliterate, "__esModule", {
	value: true
});

transliterate.default = function (text, locale) {
	var map = (0, _transliterations2.default)(locale);
	for (var i = 0; i < map.length; i++) {
		text = text.replace(map[i].letter, map[i].alternative);
	}
	return text;
};

var _transliterations = transliterations$1;

var _transliterations2 = _interopRequireDefault$26(_transliterations);

function _interopRequireDefault$26(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var replaceDiacritics = {};

var diacritics = {};

Object.defineProperty(diacritics, "__esModule", {
	value: true
});

diacritics.default = function () {
	return [{
		base: "a",
		letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
	}, { base: "aa", letters: /[\uA733]/g }, { base: "ae", letters: /[\u00E6\u01FD\u01E3]/g }, { base: "ao", letters: /[\uA735]/g }, { base: "au", letters: /[\uA737]/g }, { base: "av", letters: /[\uA739\uA73B]/g }, { base: "ay", letters: /[\uA73D]/g }, { base: "b", letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, {
		base: "c",
		letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
	}, {
		base: "d",
		letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
	}, { base: "dz", letters: /[\u01F3\u01C6]/g }, {
		base: "e",
		letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
	}, { base: "f", letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, {
		base: "g",
		letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
	}, {
		base: "h",
		letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
	}, { base: "hv", letters: /[\u0195]/g }, {
		base: "i",
		letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
	}, { base: "j", letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, {
		base: "k",
		letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
	}, {
		base: "l",
		letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
	}, { base: "lj", letters: /[\u01C9]/g }, { base: "m", letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, {
		base: "n",
		letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
	}, { base: "nj", letters: /[\u01CC]/g }, {
		base: "o",
		letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
	}, { base: "oi", letters: /[\u01A3]/g }, { base: "ou", letters: /[\u0223]/g }, { base: "oo", letters: /[\uA74F]/g }, { base: "p", letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { base: "q", letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, {
		base: "r",
		letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
	}, {
		base: "s",
		letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
	}, {
		base: "t",
		letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
	}, { base: "tz", letters: /[\uA729]/g }, {
		base: "u",
		letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
	}, { base: "v", letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { base: "vy", letters: /[\uA761]/g }, {
		base: "w",
		letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
	}, { base: "x", letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, {
		base: "y",
		letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
	}, {
		base: "z",
		letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
	}];
};

Object.defineProperty(replaceDiacritics, "__esModule", {
	value: true
});

replaceDiacritics.default = function (text) {
	var map = (0, _diacritics2.default)();

	for (var i = 0; i < map.length; i++) {
		text = text.replace(map[i].letters, map[i].base);
	}
	return text;
};

var _diacritics = diacritics;

var _diacritics2 = _interopRequireDefault$25(_diacritics);

function _interopRequireDefault$25(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageInText = {};

var matchStringWithRegex = {};

Object.defineProperty(matchStringWithRegex, "__esModule", {
  value: true
});

matchStringWithRegex.default = function (text, regexString) {
  var regex = new RegExp(regexString, "ig");
  var matches = text.match(regex);

  if (matches === null) {
    matches = [];
  }

  return matches;
};

Object.defineProperty(imageInText, "__esModule", {
  value: true
});

imageInText.default = function (text) {
  return (0, _matchStringWithRegex2$2.default)(text, "<img(?:[^>]+)?>");
};

var _matchStringWithRegex$2 = matchStringWithRegex;

var _matchStringWithRegex2$2 = _interopRequireDefault$24(_matchStringWithRegex$2);

function _interopRequireDefault$24(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var relevantWords$2 = {};

var WordCombination$1 = {};

Object.defineProperty(WordCombination$1, "__esModule", {
  value: true
});

var _lodashEs$1h = require$$1$1;

/**
 * Returns whether or not the given word is a function word.
 *
 * @param {string} word The word to check.
 * @param {Function} functionWords The function containing the lists of function words.
 * @returns {boolean} Whether or not the word is a function word.
 */
function isFunctionWord(word, functionWords) {
  return -1 !== functionWords.indexOf(word.toLocaleLowerCase());
}

/**
 * Represents a word combination in the context of relevant words.
 *
 * @constructor
 *
 * @param {string[]} words The list of words that this combination consists of.
 * @param {number} [occurrences] The number of occurrences, defaults to 0.
 * @param {Function} functionWords The function containing the lists of function words.
 */
function WordCombination(words, occurrences, functionWords) {
  this._words = words;
  this._length = words.length;
  this._occurrences = occurrences || 0;
  this._functionWords = functionWords;
}

WordCombination.lengthBonus = {
  2: 3,
  3: 7,
  4: 12,
  5: 18
};

/**
 * Returns the base relevance based on the length of this combination.
 *
 * @returns {number} The base relevance based on the length.
 */
WordCombination.prototype.getLengthBonus = function () {
  if ((0, _lodashEs$1h.has)(WordCombination.lengthBonus, this._length)) {
    return WordCombination.lengthBonus[this._length];
  }

  return 0;
};

/**
 * Returns the list with words.
 *
 * @returns {array} The list with words.
 */
WordCombination.prototype.getWords = function () {
  return this._words;
};

/**
 * Returns the word combination length.
 *
 * @returns {number} The word combination length.
 */
WordCombination.prototype.getLength = function () {
  return this._length;
};

/**
 * Returns the combination as it occurs in the text.
 *
 * @returns {string} The combination.
 */
WordCombination.prototype.getCombination = function () {
  return this._words.join(" ");
};

/**
 * Returns the amount of occurrences of this word combination.
 *
 * @returns {number} The amount of occurrences.
 */
WordCombination.prototype.getOccurrences = function () {
  return this._occurrences;
};

/**
 * Increments the occurrences.
 *
 * @returns {void}
 */
WordCombination.prototype.incrementOccurrences = function () {
  this._occurrences += 1;
};

/**
 * Returns the relevance of the length.
 *
 * @param {number} relevantWordPercentage The relevance of the words within the combination.
 * @returns {number} The relevance based on the length and the word relevance.
 */
WordCombination.prototype.getMultiplier = function (relevantWordPercentage) {
  var lengthBonus = this.getLengthBonus();

  // The relevance scales linearly from the relevance of one word to the maximum.
  return 1 + relevantWordPercentage * lengthBonus;
};

/**
 * Returns if the given word is a relevant word based on the given word relevance.
 *
 * @param {string} word The word to check if it is relevant.
 * @returns {boolean} Whether or not it is relevant.
 */
WordCombination.prototype.isRelevantWord = function (word) {
  return (0, _lodashEs$1h.has)(this._relevantWords, word);
};

/**
 * Returns the relevance of the words within this combination.
 *
 * @returns {number} The percentage of relevant words inside this combination.
 */
WordCombination.prototype.getRelevantWordPercentage = function () {
  var relevantWordCount = 0,
      wordRelevance = 1;

  if (this._length > 1) {
    (0, _lodashEs$1h.forEach)(this._words, function (word) {
      if (this.isRelevantWord(word)) {
        relevantWordCount += 1;
      }
    }.bind(this));

    wordRelevance = relevantWordCount / this._length;
  }

  return wordRelevance;
};

/**
 * Returns the relevance for this word combination.
 *
 * @returns {number} The relevance of this word combination.
 */
WordCombination.prototype.getRelevance = function () {
  if (this._words.length === 1 && isFunctionWord(this._words[0], this._functionWords)) {
    return 0;
  }

  var wordRelevance = this.getRelevantWordPercentage();
  if (wordRelevance === 0) {
    return 0;
  }

  return this.getMultiplier(wordRelevance) * this._occurrences;
};

/**
 * Sets the relevance of single words
 *
 * @param {Object} relevantWords A mapping from a word to a relevance.
 * @returns {void}
 */
WordCombination.prototype.setRelevantWords = function (relevantWords) {
  this._relevantWords = relevantWords;
};

/**
 * Returns the density of this combination within the text.
 *
 * @param {number} wordCount The word count of the text this combination was found in.
 * @returns {number} The density of this combination.
 */
WordCombination.prototype.getDensity = function (wordCount) {
  return this._occurrences / wordCount;
};

/**
 * Serializes the WordCombination instance to an object.
 *
 * @returns {Object} The serialized WordCombination.
 */
WordCombination.prototype.serialize = function () {
  return {
    _parseClass: "WordCombination",
    words: this._words,
    occurrences: this._occurrences,
    functionWords: this._functionWords,
    relevantWords: this._relevantWords
  };
};

/**
 * Parses the object to a WordCombination.
 *
 * @param {Object} serialized The serialized object.
 *
 * @returns {WordCombination} The parsed WordCombination.
 */
WordCombination.parse = function (serialized) {
  const wordCombination = new WordCombination(serialized.words, serialized.occurrences, serialized.functionWords);
  wordCombination.setRelevantWords(serialized.relevantWords);

  return wordCombination;
};

WordCombination$1.default = WordCombination;

Object.defineProperty(relevantWords$2, "__esModule", {
	value: true
});
relevantWords$2.filterEndingWith = relevantWords$2.filterOneCharacterWordCombinations = relevantWords$2.filterOnDensity = relevantWords$2.filterFunctionWordsAnywhere = relevantWords$2.filterFunctionWords = relevantWords$2.filterFunctionWordsAtBeginning = relevantWords$2.filterFunctionWordsAtEnding = relevantWords$2.sortCombinations = relevantWords$2.getRelevantCombinations = relevantWords$2.calculateOccurrences = relevantWords$2.getRelevantWords = relevantWords$2.getWordCombinations = undefined;

var _getWords$g = getWords;

var _getWords2$g = _interopRequireDefault$23(_getWords$g);

var _getSentences$c = getSentences;

var _getSentences2$c = _interopRequireDefault$23(_getSentences$c);

var _WordCombination$1 = WordCombination$1;

var _WordCombination2$1 = _interopRequireDefault$23(_WordCombination$1);

var _quotes$8 = quotes;

var _getFunctionWords$4 = getFunctionWords$3;

var _getFunctionWords2$4 = _interopRequireDefault$23(_getFunctionWords$4);

var _getLanguage$h = getLanguage;

var _getLanguage2$h = _interopRequireDefault$23(_getLanguage$h);

var _lodashEs$1g = require$$1$1;

function _interopRequireDefault$23(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const functionWordLists$1 = (0, _getFunctionWords2$4.default)();


const densityLowerLimit = 0;
const densityUpperLimit = 0.03;
const relevantWordLimit = 100;
const wordCountLowerLimit = 200;

// First four characters: en dash, em dash, hyphen-minus, and copyright sign.
const specialCharacters$1 = ["–", "—", "-", "\u00a9", "#", "%", "/", "\\", "$", "€", "£", "*", "•", "|", "→", "←", "}", "{", "//", "||", "\u200b"];

/**
 * Returns the word combinations for the given text based on the combination size.
 *
 * @param {string} text The text to retrieve combinations for.
 * @param {number} combinationSize The size of the combinations to retrieve.
 * @param {Function} functionWords The function containing the lists of function words.
 * @returns {WordCombination[]} All word combinations for the given text.
 */
function getWordCombinations(text, combinationSize, functionWords) {
	const sentences = (0, _getSentences2$c.default)(text);

	let words, combination;

	return (0, _lodashEs$1g.flatMap)(sentences, function (sentence) {
		sentence = sentence.toLocaleLowerCase();
		sentence = (0, _quotes$8.normalize)(sentence);
		words = (0, _getWords2$g.default)(sentence);

		return (0, _lodashEs$1g.filter)((0, _lodashEs$1g.map)(words, function (word, i) {
			// If there are still enough words in the sentence to slice of.
			if (i + combinationSize - 1 < words.length) {
				combination = words.slice(i, i + combinationSize);
				return new _WordCombination2$1.default(combination, 0, functionWords);
			}

			return false;
		}));
	});
}

/**
 * Calculates occurrences for a list of word combinations.
 *
 * @param {WordCombination[]} wordCombinations The word combinations to calculate occurrences for.
 * @returns {WordCombination[]} Word combinations with their respective occurrences.
 */
function calculateOccurrences(wordCombinations) {
	const occurrences = {};

	(0, _lodashEs$1g.forEach)(wordCombinations, function (wordCombination) {
		const combination = wordCombination.getCombination();

		if (!(0, _lodashEs$1g.has)(occurrences, combination)) {
			occurrences[combination] = wordCombination;
		}

		occurrences[combination].incrementOccurrences();
	});

	return (0, _lodashEs$1g.values)(occurrences);
}

/**
 * Returns only the relevant combinations from a list of word combinations. Assumes
 * occurrences have already been calculated.
 *
 * @param {WordCombination[]} wordCombinations A list of word combinations.
 * @returns {WordCombination[]} Only relevant word combinations.
 */
function getRelevantCombinations(wordCombinations) {
	wordCombinations = wordCombinations.filter(function (combination) {
		return combination.getOccurrences() !== 1 && combination.getRelevance() !== 0;
	});
	return wordCombinations;
}

/**
 * Sorts combinations based on their relevance and length.
 *
 * @param {WordCombination[]} wordCombinations The combinations to sort.
 * @returns {void}
 */
function sortCombinations(wordCombinations) {
	wordCombinations.sort(function (combinationA, combinationB) {
		const difference = combinationB.getRelevance() - combinationA.getRelevance();
		// The combination with the highest relevance comes first.
		if (difference !== 0) {
			return difference;
		}
		// In case of a tie on relevance, the longest combination comes first.
		return combinationB.getLength() - combinationA.getLength();
	});
}

/**
 * Filters word combinations that consist of a single one-character word.
 *
 * @param {WordCombination[]} wordCombinations The word combinations to filter.
 * @returns {WordCombination[]} Filtered word combinations.
 */
function filterOneCharacterWordCombinations(wordCombinations) {
	return wordCombinations.filter(function (combination) {
		return !(combination.getLength() === 1 && combination.getWords()[0].length <= 1);
	});
}

/**
 * Filters word combinations containing certain function words at any position.
 *
 * @param {WordCombination[]} wordCombinations The word combinations to filter.
 * @param {array} functionWords The list of function words.
 * @returns {WordCombination[]} Filtered word combinations.
 */
function filterFunctionWordsAnywhere(wordCombinations, functionWords) {
	return wordCombinations.filter(function (combination) {
		return (0, _lodashEs$1g.isEmpty)((0, _lodashEs$1g.intersection)(functionWords, combination.getWords()));
	});
}

/**
 * Filters word combinations beginning with certain function words.
 *
 * @param {WordCombination[]} wordCombinations The word combinations to filter.
 * @param {array} functionWords The list of function words.
 * @returns {WordCombination[]} Filtered word combinations.
 */
function filterFunctionWordsAtBeginning(wordCombinations, functionWords) {
	return wordCombinations.filter(function (combination) {
		return !(0, _lodashEs$1g.includes)(functionWords, combination.getWords()[0]);
	});
}

/**
 * Filters word combinations ending with certain function words.
 *
 * @param {WordCombination[]} wordCombinations The word combinations to filter.
 * @param {array} functionWords The list of function words.
 * @returns {WordCombination[]} Filtered word combinations.
 */
function filterFunctionWordsAtEnding(wordCombinations, functionWords) {
	return wordCombinations.filter(function (combination) {
		const words = combination.getWords();
		const lastWordIndex = words.length - 1;
		return !(0, _lodashEs$1g.includes)(functionWords, words[lastWordIndex]);
	});
}

/**
 * Filters word combinations beginning and ending with certain function words.
 *
 * @param {WordCombination[]} wordCombinations The word combinations to filter.
 * @param {Array} functionWords The list of function words.
 * @returns {WordCombination[]} Filtered word combinations.
 */
function filterFunctionWordsAtBeginningAndEnding(wordCombinations, functionWords) {
	wordCombinations = filterFunctionWordsAtBeginning(wordCombinations, functionWords);
	wordCombinations = filterFunctionWordsAtEnding(wordCombinations, functionWords);
	return wordCombinations;
}

/**
 * Filters word combinations based on keyword density if the word count is 200 or over.
 *
 * @param {WordCombination[]} wordCombinations The word combinations to filter.
 * @param {number} wordCount The number of words in the total text.
 * @param {number} lowerLimit The lower limit of keyword density.
 * @param {number} upperLimit The upper limit of keyword density.
 * @returns {WordCombination[]} Filtered word combinations.
 */
function filterOnDensity(wordCombinations, wordCount, lowerLimit, upperLimit) {
	return wordCombinations.filter(function (combination) {
		return combination.getDensity(wordCount) >= lowerLimit && combination.getDensity(wordCount) < upperLimit;
	});
}

/**
 * Filters combinations based on whether they end with a specified string or not.
 *
 * @param {WordCombination[]} wordCombinations The array of WordCombinations to filter.
 * @param {string} str The string the WordCombinations that need to be filtered out end with.
 * @param {string[]} exceptions The array of strings containing exceptions to not filter.
 * @returns {WordCombination[]} The filtered array of WordCombinations.
 */
function filterEndingWith(wordCombinations, str, exceptions) {
	wordCombinations = wordCombinations.filter(function (combination) {
		const combinationstr = combination.getCombination();
		for (let i = 0; i < exceptions.length; i++) {
			if (combinationstr.endsWith(exceptions[i])) {
				return true;
			}
		}
		return !combinationstr.endsWith(str);
	});
	return wordCombinations;
}

/**
 * Filters the list of word combination objects based on the language-specific function word filters.
 * Word combinations with specific parts of speech are removed.
 *
 * @param {Array} combinations The list of word combination objects.
 * @param {Function} functionWords The function containing the lists of function words.
 * @returns {Array} The filtered list of word combination objects.
 */
function filterFunctionWords(combinations, functionWords) {
	combinations = filterFunctionWordsAnywhere(combinations, functionWords.filteredAnywhere);
	combinations = filterFunctionWordsAtBeginningAndEnding(combinations, functionWords.filteredAtBeginningAndEnding);
	combinations = filterFunctionWordsAtEnding(combinations, functionWords.filteredAtEnding);
	combinations = filterFunctionWordsAtBeginning(combinations, functionWords.filteredAtBeginning);
	return combinations;
}

/**
 * Filters the list of word combination objects based on function word filters, a special character filter and
 * a one-character filter.
 *
 * @param {Array} combinations The list of word combination objects.
 * @param {Function} functionWords The function containing the lists of function words.
 * @param {string} language The language for which specific filters should be applied.
 * @returns {Array} The filtered list of word combination objects.
 */
function filterCombinations(combinations, functionWords, language) {
	combinations = filterFunctionWordsAnywhere(combinations, specialCharacters$1);
	combinations = filterOneCharacterWordCombinations(combinations);
	combinations = filterFunctionWords(combinations, functionWords);
	if (language === "en") {
		combinations = filterEndingWith(combinations, "'s", []);
	}
	return combinations;
}
/**
 * Returns the relevant words in a given text.
 *
 * @param {string} text The text to retrieve the relevant words of.
 * @param {string} locale The paper's locale.
 * @returns {WordCombination[]} All relevant words sorted and filtered for this text.
 */
function getRelevantWords(text, locale) {
	let language = (0, _getLanguage2$h.default)(locale);
	if (!functionWordLists$1.hasOwnProperty(language)) {
		language = "en";
	}

	const functionWords = functionWordLists$1[language];

	const words = getWordCombinations(text, 1, functionWords.all);
	const wordCount = words.length;

	let oneWordCombinations = getRelevantCombinations(calculateOccurrences(words));

	sortCombinations(oneWordCombinations);
	oneWordCombinations = (0, _lodashEs$1g.take)(oneWordCombinations, 100);

	const oneWordRelevanceMap = {};

	(0, _lodashEs$1g.forEach)(oneWordCombinations, function (combination) {
		oneWordRelevanceMap[combination.getCombination()] = combination.getRelevance();
	});

	const twoWordCombinations = calculateOccurrences(getWordCombinations(text, 2, functionWords.all));
	const threeWordCombinations = calculateOccurrences(getWordCombinations(text, 3, functionWords.all));
	const fourWordCombinations = calculateOccurrences(getWordCombinations(text, 4, functionWords.all));
	const fiveWordCombinations = calculateOccurrences(getWordCombinations(text, 5, functionWords.all));

	let combinations = oneWordCombinations.concat(twoWordCombinations, threeWordCombinations, fourWordCombinations, fiveWordCombinations);

	combinations = filterCombinations(combinations, functionWords, language);

	(0, _lodashEs$1g.forEach)(combinations, function (combination) {
		combination.setRelevantWords(oneWordRelevanceMap);
	});

	combinations = getRelevantCombinations(combinations);
	sortCombinations(combinations);

	if (wordCount >= wordCountLowerLimit) {
		combinations = filterOnDensity(combinations, wordCount, densityLowerLimit, densityUpperLimit);
	}

	return (0, _lodashEs$1g.take)(combinations, relevantWordLimit);
}

relevantWords$2.getWordCombinations = getWordCombinations;
relevantWords$2.getRelevantWords = getRelevantWords;
relevantWords$2.calculateOccurrences = calculateOccurrences;
relevantWords$2.getRelevantCombinations = getRelevantCombinations;
relevantWords$2.sortCombinations = sortCombinations;
relevantWords$2.filterFunctionWordsAtEnding = filterFunctionWordsAtEnding;
relevantWords$2.filterFunctionWordsAtBeginning = filterFunctionWordsAtBeginning;
relevantWords$2.filterFunctionWords = filterFunctionWords;
relevantWords$2.filterFunctionWordsAnywhere = filterFunctionWordsAnywhere;
relevantWords$2.filterOnDensity = filterOnDensity;
relevantWords$2.filterOneCharacterWordCombinations = filterOneCharacterWordCombinations;
relevantWords$2.filterEndingWith = filterEndingWith;
relevantWords$2.default = {
	getWordCombinations: getWordCombinations,
	getRelevantWords: getRelevantWords,
	calculateOccurrences: calculateOccurrences,
	getRelevantCombinations: getRelevantCombinations,
	sortCombinations: sortCombinations,
	filterFunctionWordsAtEnding: filterFunctionWordsAtEnding,
	filterFunctionWordsAtBeginning: filterFunctionWordsAtBeginning,
	filterFunctionWords: filterFunctionWordsAtBeginningAndEnding,
	filterFunctionWordsAnywhere: filterFunctionWordsAnywhere,
	filterOnDensity: filterOnDensity,
	filterOneCharacterWordCombinations: filterOneCharacterWordCombinations,
	filterEndingWith: filterEndingWith
};

var htmlParser = {};

Object.defineProperty(htmlParser, "__esModule", {
	value: true
});

htmlParser.default = function (text) {
	textArray = [];
	parser.write(text);
	return textArray.join("");
};

var _htmlparser$1 = require$$0$1;

var _htmlparser2$1 = _interopRequireDefault$22(_htmlparser$1);

var _lodashEs$1f = require$$1$1;

function _interopRequireDefault$22(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The array containing the text parts without the blocks defined in inlineTags.
// We use an external library, which can be found here: https://github.com/fb55/htmlparser2.
let textArray;

// False when we are not in a block defined in inlineTags. True if we are.
let inScriptBlock = false;

// The blocks we filter out of the text that needs to be parsed.
const inlineTags = ["script", "style", "code", "pre"];

/**
 * Parses the text.
 */
const parser = new _htmlparser2$1.default.Parser({
	/**
  * Handles the opening tag. If the opening tag is included in the inlineTags array, set inScriptBlock to true.
  * If the opening tag is not included in the inlineTags array, push the tag to the textArray.
  *
  * @param {string} tagName The tag name.
  * @param {object} nodeValue The attribute with the keys and values of the tag.
  * @returns {void}
  */
	onopentag: function onopentag(tagName, nodeValue) {
		if ((0, _lodashEs$1f.includes)(inlineTags, tagName)) {
			inScriptBlock = true;
			return;
		}

		const nodeValueType = Object.keys(nodeValue);
		let nodeValueString = "";

		nodeValueType.forEach(function (node) {
			// Build the tag again.
			nodeValueString += " " + node + "='" + nodeValue[node] + "'";
		});

		textArray.push("<" + tagName + nodeValueString + ">");
	},
	/**
  * Handles the text that doesn't contain opening or closing tags. If inScriptBlock is false, the text gets pushed to the textArray array.
  *
  * @param {string} text The text that doesn't contain opening or closing tags.
  *
  * @returns {void}
  */
	ontext: function ontext(text) {
		if (!inScriptBlock) {
			textArray.push(text);
		}
	},
	/**
  * Handles the closing tag. If the closing tag is included in the inlineTags array, set inScriptBlock to false.
  * If the closing tag is not included in the inlineTags array, push the tag to the textArray.
  *
  * @param {string} tagName The tag name.
  *
  * @returns {void}
  */
	onclosetag: function onclosetag(tagName) {
		if ((0, _lodashEs$1f.includes)(inlineTags, tagName)) {
			inScriptBlock = false;
			return;
		}

		textArray.push("</" + tagName + ">");
	}
}, { decodeEntities: true });

var createWordRegex = {};

var addWordboundary = {};

Object.defineProperty(addWordboundary, "__esModule", {
  value: true
});

addWordboundary.default = function (matchString, positiveLookAhead = false, extraWordBoundary = "", locale = "") {
  var wordBoundary, wordBoundaryStart, wordBoundaryEnd;

  if (locale === "id_ID") {
    wordBoundary = "[ \\u00a0 \\n\\r\\t\.,\(\)”“〝〞〟‟„\"+;!¡?¿:\/»«‹›" + extraWordBoundary + "<>";
  } else {
    /*
     * \u00a0 - no-break space
           * \u06d4 - Urdu full stop
           * \u061f - Arabic question mark
           * \u060C - Arabic comma
           * \u061B - Arabic semicolon
           */
    wordBoundary = "[ \\u00a0\\u06d4\\u061f\\u060C\\u061B \\n\\r\\t\.,\(\)”“〝〞〟‟„\"+\\-;!¡?¿:\/»«‹›" + extraWordBoundary + "<>";
  }

  wordBoundaryStart = "(^|" + wordBoundary + "'‘’‛`])";
  if (positiveLookAhead) {
    wordBoundaryEnd = "($|((?=" + wordBoundary + "]))|((['‘’‛`])(" + wordBoundary + "])))";
  } else {
    wordBoundaryEnd = "($|(" + wordBoundary + "])|((['‘’‛`])(" + wordBoundary + "])))";
  }

  return wordBoundaryStart + matchString + wordBoundaryEnd;
};

var sanitizeString = {};

Object.defineProperty(sanitizeString, "__esModule", {
  value: true
});

sanitizeString.default = function (text) {
  text = (0, _stripHTMLTags$5.stripFullTags)(text);
  text = (0, _stripSpaces2$d.default)(text);

  return text;
};

var _stripHTMLTags$5 = stripHTMLTags;

var _stripSpaces$d = stripSpaces;

var _stripSpaces2$d = _interopRequireDefault$21(_stripSpaces$d);

function _interopRequireDefault$21(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(createWordRegex, "__esModule", {
	value: true
});

var _lodashEs$1e = require$$1$1;

var _replaceDiacritics$3 = replaceDiacritics;

var _replaceDiacritics2$3 = _interopRequireDefault$20(_replaceDiacritics$3);

var _addWordboundary$4 = addWordboundary;

var _addWordboundary2$4 = _interopRequireDefault$20(_addWordboundary$4);

var _sanitizeString$1 = sanitizeString;

var _sanitizeString2$1 = _interopRequireDefault$20(_sanitizeString$1);

function _interopRequireDefault$20(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a regex from a string so it can be matched everywhere in the same way.
 *
 * @param {string} string The string to make a regex from.
 * @param {string} [extraBoundary=""] A string that is used as extra boundary for the regex.
 * @param {boolean} [doReplaceDiacritics=true] If set to false, it doesn't replace diacritics. Defaults to true.
 * @returns {RegExp} regex The regex made from the keyword
 */
/** @module stringProcessing/stringToRegex */
createWordRegex.default = (0, _lodashEs$1e.memoize)(function (string, extraBoundary, doReplaceDiacritics) {
	if ((0, _lodashEs$1e.isUndefined)(extraBoundary)) {
		extraBoundary = "";
	}

	if ((0, _lodashEs$1e.isUndefined)(doReplaceDiacritics) || doReplaceDiacritics === true) {
		string = (0, _replaceDiacritics2$3.default)(string);
	}

	string = (0, _sanitizeString2$1.default)(string);
	string = (0, _lodashEs$1e.escapeRegExp)(string);
	string = (0, _addWordboundary2$4.default)(string, false, extraBoundary);
	return new RegExp(string, "ig");
});

var wordBoundaries$1 = {};

Object.defineProperty(wordBoundaries$1, "__esModule", {
	value: true
});

wordBoundaries$1.default = function () {
	return [
	// Whitespace is always a word boundary.
	" ", "\\n", "\\r", "\\t",
	// NO-BREAK SPACE.
	"\u00a0",
	// \u06d4 - Urdu full stop
	"\u06d4",
	// \u061f - Arabic question mark
	"\u061f",
	// \u060C - Arabic comma
	"\u060C",
	// \u061B - Arabic semicolon
	"\u061B", " ", ".", ",", "'", "(", ")", "\"", "+", "-", ";", "!", "?", ":", "/", "»", "«", "‹", "›", "<", ">", "”", "“", "〝", "〞", "〟", "‟", "„"];
};

var createRegexFromArray = {};

Object.defineProperty(createRegexFromArray, "__esModule", {
	value: true
});

createRegexFromArray.default = function (array, disableWordBoundary = false, extraBoundary = "", doReplaceDiacritics = false) {
	array = (0, _lodashEs$1d.map)(array, function (string) {
		if (doReplaceDiacritics) {
			string = (0, _replaceDiacritics2$2.default)(string);
		}

		string = (0, _sanitizeString2.default)(string);

		if (disableWordBoundary) {
			return string;
		}
		return (0, _addWordboundary2$3.default)(string, true, extraBoundary);
	});

	const regexString = "(" + array.join(")|(") + ")";

	return new RegExp(regexString, "ig");
};

var _lodashEs$1d = require$$1$1;

var _addWordboundary$3 = addWordboundary;

var _addWordboundary2$3 = _interopRequireDefault$1$(_addWordboundary$3);

var _replaceDiacritics$2 = replaceDiacritics;

var _replaceDiacritics2$2 = _interopRequireDefault$1$(_replaceDiacritics$2);

var _sanitizeString = sanitizeString;

var _sanitizeString2 = _interopRequireDefault$1$(_sanitizeString);

function _interopRequireDefault$1$(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(stringProcessing, "__esModule", {
	value: true
});
stringProcessing.__createWordRegex = stringProcessing.createRegexFromArray = stringProcessing.wordBoundaries = removeHtmlBlocks$2 = stringProcessing.removeHtmlBlocks = stringProcessing.relevantWords = stringProcessing.imageInText = stringProcessing.replaceDiacritics = stringProcessing.transliterate = stringProcessing.stripSpaces = stringProcessing.stripHTMLTags = undefined;

var _stripHTMLTags$4 = stripHTMLTags;

var _stripSpaces$c = stripSpaces;

var _stripSpaces2$c = _interopRequireDefault$1_(_stripSpaces$c);

var _transliterate$2 = transliterate;

var _transliterate2$2 = _interopRequireDefault$1_(_transliterate$2);

var _replaceDiacritics$1 = replaceDiacritics;

var _replaceDiacritics2$1 = _interopRequireDefault$1_(_replaceDiacritics$1);

var _imageInText$4 = imageInText;

var _imageInText2$4 = _interopRequireDefault$1_(_imageInText$4);

var _relevantWords$2 = relevantWords$2;

var _relevantWords2$1 = _interopRequireDefault$1_(_relevantWords$2);

var _htmlParser$1 = htmlParser;

var _htmlParser2$1 = _interopRequireDefault$1_(_htmlParser$1);

var _createWordRegex$2 = createWordRegex;

var _createWordRegex2$2 = _interopRequireDefault$1_(_createWordRegex$2);

var _wordBoundaries$1 = wordBoundaries$1;

var _wordBoundaries2$1 = _interopRequireDefault$1_(_wordBoundaries$1);

var _createRegexFromArray$6 = createRegexFromArray;

var _createRegexFromArray2$6 = _interopRequireDefault$1_(_createRegexFromArray$6);

function _interopRequireDefault$1_(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

stringProcessing.stripHTMLTags = _stripHTMLTags$4.stripFullTags;
stringProcessing.stripSpaces = _stripSpaces2$c.default;
stringProcessing.transliterate = _transliterate2$2.default;
stringProcessing.replaceDiacritics = _replaceDiacritics2$1.default;
stringProcessing.imageInText = _imageInText2$4.default;
stringProcessing.relevantWords = _relevantWords2$1.default;
var removeHtmlBlocks$2 = stringProcessing.removeHtmlBlocks = _htmlParser2$1.default;
stringProcessing.wordBoundaries = _wordBoundaries2$1.default;
stringProcessing.createRegexFromArray = _createRegexFromArray2$6.default;
stringProcessing.__createWordRegex = _createWordRegex2$2.default;

var interpreters$1 = {};

Object.defineProperty(interpreters$1, "__esModule", {
	value: true
});
var scoreToRating$2 = interpreters$1.scoreToRating = undefined;

var _scoreToRating$2 = scoreToRating$3;

var _scoreToRating2$2 = _interopRequireDefault$1Z(_scoreToRating$2);

function _interopRequireDefault$1Z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

scoreToRating$2 = interpreters$1.scoreToRating = _scoreToRating2$2.default;

var config$1 = {};

var presenter = {};

Object.defineProperty(presenter, "__esModule", {
	value: true
});

presenter.default = function (i18n) {
	const contentOptimizationLabel = i18n.dgettext("js-text-analysis", "Content optimization:");
	return {
		feedback: {
			className: "na",
			screenReaderText: i18n.dgettext("js-text-analysis", "Feedback"),
			fullText: `${contentOptimizationLabel} ${i18n.dgettext("js-text-analysis", "Has feedback")}`,
			screenReaderReadabilityText: ""
		},
		bad: {
			className: "bad",
			screenReaderText: i18n.dgettext("js-text-analysis", "Needs improvement"),
			fullText: `${contentOptimizationLabel} ${i18n.dgettext("js-text-analysis", "Needs improvement")}`,
			screenReaderReadabilityText: i18n.dgettext("js-text-analysis", "Needs improvement")
		},
		ok: {
			className: "ok",
			screenReaderText: i18n.dgettext("js-text-analysis", "OK SEO score"),
			fullText: `${contentOptimizationLabel} ${i18n.dgettext("js-text-analysis", "OK SEO score")}`,
			screenReaderReadabilityText: i18n.dgettext("js-text-analysis", "OK")
		},
		good: {
			className: "good",
			screenReaderText: i18n.dgettext("js-text-analysis", "Good SEO score"),
			fullText: `${contentOptimizationLabel} ${i18n.dgettext("js-text-analysis", "Good SEO score")}`,
			screenReaderReadabilityText: i18n.dgettext("js-text-analysis", "Good")
		}
	};
};

Object.defineProperty(config$1, "__esModule", {
	value: true
});
config$1.presenter = undefined;

var _presenter$1 = presenter;

var _presenter2$1 = _interopRequireDefault$1Y(_presenter$1);

function _interopRequireDefault$1Y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

config$1.presenter = _presenter2$1.default;

var assessor = {};

var researcher = {};

var sentences = {};

Object.defineProperty(sentences, "__esModule", {
  value: true
});

sentences.default = function (paper) {
  return (0, _getSentences2$b.default)(paper.getText());
};

var _getSentences$b = getSentences;

var _getSentences2$b = _interopRequireDefault$1X(_getSentences$b);

function _interopRequireDefault$1X(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var invalidType = {};

Object.defineProperty(invalidType, "__esModule", {
  value: true
});

var _util$6 = require$$2$1;

var _util2 = _interopRequireDefault$1W(_util$6);

function _interopRequireDefault$1W(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Throws an invalid type error
 *
 * @param {string} message The message to show when the error is thrown
 *
 * @returns {void}
 */
function InvalidTypeError(message) {
  Error.captureStackTrace(this, this.constructor);
  this.name = this.constructor.name;
  this.message = message;
}

_util2.default.inherits(InvalidTypeError, Error);

invalidType.default = InvalidTypeError;

var wordCountInText = {};

Object.defineProperty(wordCountInText, "__esModule", {
  value: true
});

wordCountInText.default = function (paper) {
  return (0, _countWords2$8.default)(paper.getText());
};

var _countWords$8 = countWords;

var _countWords2$8 = _interopRequireDefault$1V(_countWords$8);

function _interopRequireDefault$1V(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLinkStatistics = {};

var filterFunctionWordsFromArray = {};

Object.defineProperty(filterFunctionWordsFromArray, "__esModule", {
	value: true
});

filterFunctionWordsFromArray.default = function (array, language) {
	if ((0, _lodashEs$1c.isUndefined)(language) || language === "") {
		language = "en";
	}

	const functionWords = (0, _lodashEs$1c.get)(getFunctionWords$2, [language], []);

	if (array.length > 1) {
		const arrayFiltered = (0, _lodashEs$1c.filter)(array, function (word) {
			return !(0, _lodashEs$1c.includes)(functionWords.all, word.trim().toLocaleLowerCase());
		});

		if (arrayFiltered.length > 0) {
			return arrayFiltered;
		}
	}

	return array;
};

var _getFunctionWords$3 = getFunctionWords$3;

var _getFunctionWords2$3 = _interopRequireDefault$1U(_getFunctionWords$3);

var _lodashEs$1c = require$$1$1;

function _interopRequireDefault$1U(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getFunctionWords$2 = (0, _getFunctionWords2$3.default)();

var checkNofollow = {};

Object.defineProperty(checkNofollow, "__esModule", {
	value: true
});

checkNofollow.default = function (anchorHTML) {
	let linkFollow = "Dofollow";

	const parser = new _htmlparser2.default.Parser({
		/**
   * Detects if there is a `nofollow` value in the `rel` attribute of a link.
   *
   * @param {string} tagName The tag name.
   * @param {object} attributes The tag attributes with the names and values of each attribute found.
   * @returns {void}
   */
		onopentag: function onopentag(tagName, attributes) {
			if (tagName !== "a" || !attributes.rel) {
				return;
			}

			if (attributes.rel.toLowerCase().split(/\s/).includes("nofollow")) {
				linkFollow = "Nofollow";
			}
		}
	});

	parser.write(anchorHTML);
	parser.end();

	return linkFollow;
};

var _htmlparser = require$$0$1;

var _htmlparser2 = _interopRequireDefault$1T(_htmlparser);

function _interopRequireDefault$1T(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findKeywordInUrl = {};

var findKeywordFormsInString = {};

var matchTextWithArray = {};

var matchTextWithWord = {};

var stripNonTextTags = {};

Object.defineProperty(stripNonTextTags, "__esModule", {
  value: true
});

stripNonTextTags.default = function (text) {
  text = text.replace(/<(?!li|\/li|p|\/p|h1|\/h1|h2|\/h2|h3|\/h3|h4|\/h4|h5|\/h5|h6|\/h6|dd).*?>/g, "");
  text = (0, _stripSpaces2$b.default)(text);
  return text;
};

var _stripSpaces$b = stripSpaces;

var _stripSpaces2$b = _interopRequireDefault$1S(_stripSpaces$b);

function _interopRequireDefault$1S(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchTextWithTransliteration = {};

var transliterateWPstyle = {};

var transliterationsWPstyle = {};

Object.defineProperty(transliterationsWPstyle, "__esModule", {
	value: true
});

transliterationsWPstyle.default = function (locale) {
	if ((0, _lodashEs$1b.isUndefined)(locale)) {
		return [];
	}

	let transliterationObjects = transliterationsGeneral;

	transliterationObjects = transliterationObjects.concat(getLanguageSpecificTransliterations((0, _getLanguage2$g.default)(locale)));

	return transliterationObjects;
};

var _getLanguage$g = getLanguage;

var _getLanguage2$g = _interopRequireDefault$1R(_getLanguage$g);

var _lodashEs$1b = require$$1$1;

function _interopRequireDefault$1R(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * The list of accent characters and their ASCII alternatives is taken from wordpress-develop-mirror/blob/master/src/wp-includes/formatting.php.
 */

const transliterationsGeneral = [
/*
 * These transliteration objects are not language-specific, and will be applied independently on the locale.
 *
 * Currency signs:
 *
 * |   Code   | Glyph | Replacement |     Description     |
 * | -------- | ----- | ----------- | ------------------- |
 * | U+00A3   | £     | (empty)     | British Pound sign  |
 * | U+20AC   | €     | E           | Euro sign           |
 *
 * Decompositions for Latin-1 Supplement:
 *
 * |  Code   | Glyph | Replacement |               Description              |
 * | ------- | ----- | ----------- | -------------------------------------- |
 * | U+00AA  | ª     | a           | Feminine ordinal indicator             |
 * | U+00BA  | º     | o           | Masculine ordinal indicator            |
 * | U+00C0  | À     | A           | Latin capital letter A with grave      |
 * | U+00C1  | Á     | A           | Latin capital letter A with acute      |
 * | U+00C2  | Â     | A           | Latin capital letter A with circumflex |
 * | U+00C3  | Ã     | A           | Latin capital letter A with tilde      |
 * | U+00C4  | Ä     | A           | Latin capital letter A with diaeresis  |
 * | U+00C5  | Å     | A           | Latin capital letter A with ring above |
 * | U+00C6  | Æ     | AE          | Latin capital letter AE                |
 * | U+00C7  | Ç     | C           | Latin capital letter C with cedilla    |
 * | U+00C8  | È     | E           | Latin capital letter E with grave      |
 * | U+00C9  | É     | E           | Latin capital letter E with acute      |
 * | U+00CA  | Ê     | E           | Latin capital letter E with circumflex |
 * | U+00CB  | Ë     | E           | Latin capital letter E with diaeresis  |
 * | U+00CC  | Ì     | I           | Latin capital letter I with grave      |
 * | U+00CD  | Í     | I           | Latin capital letter I with acute      |
 * | U+00CE  | Î     | I           | Latin capital letter I with circumflex |
 * | U+00CF  | Ï     | I           | Latin capital letter I with diaeresis  |
 * | U+00D0  | Ð     | D           | Latin capital letter Eth               |
 * | U+00D1  | Ñ     | N           | Latin capital letter N with tilde      |
 * | U+00D2  | Ò     | O           | Latin capital letter O with grave      |
 * | U+00D3  | Ó     | O           | Latin capital letter O with acute      |
 * | U+00D4  | Ô     | O           | Latin capital letter O with circumflex |
 * | U+00D5  | Õ     | O           | Latin capital letter O with tilde      |
 * | U+00D6  | Ö     | O           | Latin capital letter O with diaeresis  |
 * | U+00D8  | Ø     | O           | Latin capital letter O with stroke     |
 * | U+00D9  | Ù     | U           | Latin capital letter U with grave      |
 * | U+00DA  | Ú     | U           | Latin capital letter U with acute      |
 * | U+00DB  | Û     | U           | Latin capital letter U with circumflex |
 * | U+00DC  | Ü     | U           | Latin capital letter U with diaeresis  |
 * | U+00DD  | Ý     | Y           | Latin capital letter Y with acute      |
 * | U+00DE  | Þ     | TH          | Latin capital letter Thorn             |
 * | U+00DF  | ß     | s           | Latin small letter sharp s             |
 * | U+00E0  | à     | a           | Latin small letter a with grave        |
 * | U+00E1  | á     | a           | Latin small letter a with acute        |
 * | U+00E2  | â     | a           | Latin small letter a with circumflex   |
 * | U+00E3  | ã     | a           | Latin small letter a with tilde        |
 * | U+00E4  | ä     | a           | Latin small letter a with diaeresis    |
 * | U+00E5  | å     | a           | Latin small letter a with ring above   |
 * | U+00E6  | æ     | ae          | Latin small letter ae                  |
 * | U+00E7  | ç     | c           | Latin small letter c with cedilla      |
 * | U+00E8  | è     | e           | Latin small letter e with grave        |
 * | U+00E9  | é     | e           | Latin small letter e with acute        |
 * | U+00EA  | ê     | e           | Latin small letter e with circumflex   |
 * | U+00EB  | ë     | e           | Latin small letter e with diaeresis    |
 * | U+00EC  | ì     | i           | Latin small letter i with grave        |
 * | U+00ED  | í     | i           | Latin small letter i with acute        |
 * | U+00EE  | î     | i           | Latin small letter i with circumflex   |
 * | U+00EF  | ï     | i           | Latin small letter i with diaeresis    |
 * | U+00F0  | ð     | d           | Latin small letter Eth                 |
 * | U+00F1  | ñ     | n           | Latin small letter n with tilde        |
 * | U+00F2  | ò     | o           | Latin small letter o with grave        |
 * | U+00F3  | ó     | o           | Latin small letter o with acute        |
 * | U+00F4  | ô     | o           | Latin small letter o with circumflex   |
 * | U+00F5  | õ     | o           | Latin small letter o with tilde        |
 * | U+00F6  | ö     | o           | Latin small letter o with diaeresis    |
 * | U+00F8  | ø     | o           | Latin small letter o with stroke       |
 * | U+00F9  | ù     | u           | Latin small letter u with grave        |
 * | U+00FA  | ú     | u           | Latin small letter u with acute        |
 * | U+00FB  | û     | u           | Latin small letter u with circumflex   |
 * | U+00FC  | ü     | u           | Latin small letter u with diaeresis    |
 * | U+00FD  | ý     | y           | Latin small letter y with acute        |
 * | U+00FE  | þ     | th          | Latin small letter Thorn               |
 * | U+00FF  | ÿ     | y           | Latin small letter y with diaeresis    |
 *
 * Decompositions for Latin Extended-A:
 *
 * |  Code   | Glyph | Replacement |                    Description                    |
 * | ------- | ----- | ----------- | ------------------------------------------------- |
 * | U+0100  | Ā     | A           | Latin capital letter A with macron                |
 * | U+0101  | ā     | a           | Latin small letter a with macron                  |
 * | U+0102  | Ă     | A           | Latin capital letter A with breve                 |
 * | U+0103  | ă     | a           | Latin small letter a with breve                   |
 * | U+0104  | Ą     | A           | Latin capital letter A with ogonek                |
 * | U+0105  | ą     | a           | Latin small letter a with ogonek                  |
 * | U+0106  | Ć     | C           | Latin capital letter C with acute                 |
 * | U+0107  | ć     | c           | Latin small letter c with acute                   |
 * | U+0108  | Ĉ     | C           | Latin capital letter C with circumflex            |
 * | U+0109  | ĉ     | c           | Latin small letter c with circumflex              |
 * | U+010A  | Ċ     | C           | Latin capital letter C with dot above             |
 * | U+010B  | ċ     | c           | Latin small letter c with dot above               |
 * | U+010C  | Č     | C           | Latin capital letter C with caron                 |
 * | U+010D  | č     | c           | Latin small letter c with caron                   |
 * | U+010E  | Ď     | D           | Latin capital letter D with caron                 |
 * | U+010F  | ď     | d           | Latin small letter d with caron                   |
 * | U+0110  | Đ     | D           | Latin capital letter D with stroke                |
 * | U+0111  | đ     | d           | Latin small letter d with stroke                  |
 * | U+0112  | Ē     | E           | Latin capital letter E with macron                |
 * | U+0113  | ē     | e           | Latin small letter e with macron                  |
 * | U+0114  | Ĕ     | E           | Latin capital letter E with breve                 |
 * | U+0115  | ĕ     | e           | Latin small letter e with breve                   |
 * | U+0116  | Ė     | E           | Latin capital letter E with dot above             |
 * | U+0117  | ė     | e           | Latin small letter e with dot above               |
 * | U+0118  | Ę     | E           | Latin capital letter E with ogonek                |
 * | U+0119  | ę     | e           | Latin small letter e with ogonek                  |
 * | U+011A  | Ě     | E           | Latin capital letter E with caron                 |
 * | U+011B  | ě     | e           | Latin small letter e with caron                   |
 * | U+011C  | Ĝ     | G           | Latin capital letter G with circumflex            |
 * | U+011D  | ĝ     | g           | Latin small letter g with circumflex              |
 * | U+011E  | Ğ     | G           | Latin capital letter G with breve                 |
 * | U+011F  | ğ     | g           | Latin small letter g with breve                   |
 * | U+0120  | Ġ     | G           | Latin capital letter G with dot above             |
 * | U+0121  | ġ     | g           | Latin small letter g with dot above               |
 * | U+0122  | Ģ     | G           | Latin capital letter G with cedilla               |
 * | U+0123  | ģ     | g           | Latin small letter g with cedilla                 |
 * | U+0124  | Ĥ     | H           | Latin capital letter H with circumflex            |
 * | U+0125  | ĥ     | h           | Latin small letter h with circumflex              |
 * | U+0126  | Ħ     | H           | Latin capital letter H with stroke                |
 * | U+0127  | ħ     | h           | Latin small letter h with stroke                  |
 * | U+0128  | Ĩ     | I           | Latin capital letter I with tilde                 |
 * | U+0129  | ĩ     | i           | Latin small letter i with tilde                   |
 * | U+012A  | Ī     | I           | Latin capital letter I with macron                |
 * | U+012B  | ī     | i           | Latin small letter i with macron                  |
 * | U+012C  | Ĭ     | I           | Latin capital letter I with breve                 |
 * | U+012D  | ĭ     | i           | Latin small letter i with breve                   |
 * | U+012E  | Į     | I           | Latin capital letter I with ogonek                |
 * | U+012F  | į     | i           | Latin small letter i with ogonek                  |
 * | U+0130  | İ     | I           | Latin capital letter I with dot above             |
 * | U+0131  | ı     | i           | Latin small letter dotless i                      |
 * | U+0132  | Ĳ     | IJ          | Latin capital ligature IJ                         |
 * | U+0133  | ĳ     | ij          | Latin small ligature ij                           |
 * | U+0134  | Ĵ     | J           | Latin capital letter J with circumflex            |
 * | U+0135  | ĵ     | j           | Latin small letter j with circumflex              |
 * | U+0136  | Ķ     | K           | Latin capital letter K with cedilla               |
 * | U+0137  | ķ     | k           | Latin small letter k with cedilla                 |
 * | U+0138  | ĸ     | k           | Latin small letter Kra                            |
 * | U+0139  | Ĺ     | L           | Latin capital letter L with acute                 |
 * | U+013A  | ĺ     | l           | Latin small letter l with acute                   |
 * | U+013B  | Ļ     | L           | Latin capital letter L with cedilla               |
 * | U+013C  | ļ     | l           | Latin small letter l with cedilla                 |
 * | U+013D  | Ľ     | L           | Latin capital letter L with caron                 |
 * | U+013E  | ľ     | l           | Latin small letter l with caron                   |
 * | U+013F  | Ŀ     | L           | Latin capital letter L with middle dot            |
 * | U+0140  | ŀ     | l           | Latin small letter l with middle dot              |
 * | U+0141  | Ł     | L           | Latin capital letter L with stroke                |
 * | U+0142  | ł     | l           | Latin small letter l with stroke                  |
 * | U+0143  | Ń     | N           | Latin capital letter N with acute                 |
 * | U+0144  | ń     | n           | Latin small letter N with acute                   |
 * | U+0145  | Ņ     | N           | Latin capital letter N with cedilla               |
 * | U+0146  | ņ     | n           | Latin small letter n with cedilla                 |
 * | U+0147  | Ň     | N           | Latin capital letter N with caron                 |
 * | U+0148  | ň     | n           | Latin small letter n with caron                   |
 * | U+0149  | ŉ     | n           | Latin small letter n preceded by apostrophe       |
 * | U+014A  | Ŋ     | N           | Latin capital letter Eng                          |
 * | U+014B  | ŋ     | n           | Latin small letter Eng                            |
 * | U+014C  | Ō     | O           | Latin capital letter O with macron                |
 * | U+014D  | ō     | o           | Latin small letter o with macron                  |
 * | U+014E  | Ŏ     | O           | Latin capital letter O with breve                 |
 * | U+014F  | ŏ     | o           | Latin small letter o with breve                   |
 * | U+0150  | Ő     | O           | Latin capital letter O with double acute          |
 * | U+0151  | ő     | o           | Latin small letter o with double acute            |
 * | U+0152  | Œ     | OE          | Latin capital ligature OE                         |
 * | U+0153  | œ     | oe          | Latin small ligature oe                           |
 * | U+0154  | Ŕ     | R           | Latin capital letter R with acute                 |
 * | U+0155  | ŕ     | r           | Latin small letter r with acute                   |
 * | U+0156  | Ŗ     | R           | Latin capital letter R with cedilla               |
 * | U+0157  | ŗ     | r           | Latin small letter r with cedilla                 |
 * | U+0158  | Ř     | R           | Latin capital letter R with caron                 |
 * | U+0159  | ř     | r           | Latin small letter r with caron                   |
 * | U+015A  | Ś     | S           | Latin capital letter S with acute                 |
 * | U+015B  | ś     | s           | Latin small letter s with acute                   |
 * | U+015C  | Ŝ     | S           | Latin capital letter S with circumflex            |
 * | U+015D  | ŝ     | s           | Latin small letter s with circumflex              |
 * | U+015E  | Ş     | S           | Latin capital letter S with cedilla               |
 * | U+015F  | ş     | s           | Latin small letter s with cedilla                 |
 * | U+0160  | Š     | S           | Latin capital letter S with caron                 |
 * | U+0161  | š     | s           | Latin small letter s with caron                   |
 * | U+0162  | Ţ     | T           | Latin capital letter T with cedilla               |
 * | U+0163  | ţ     | t           | Latin small letter t with cedilla                 |
 * | U+0164  | Ť     | T           | Latin capital letter T with caron                 |
 * | U+0165  | ť     | t           | Latin small letter t with caron                   |
 * | U+0166  | Ŧ     | T           | Latin capital letter T with stroke                |
 * | U+0167  | ŧ     | t           | Latin small letter t with stroke                  |
 * | U+0168  | Ũ     | U           | Latin capital letter U with tilde                 |
 * | U+0169  | ũ     | u           | Latin small letter u with tilde                   |
 * | U+016A  | Ū     | U           | Latin capital letter U with macron                |
 * | U+016B  | ū     | u           | Latin small letter u with macron                  |
 * | U+016C  | Ŭ     | U           | Latin capital letter U with breve                 |
 * | U+016D  | ŭ     | u           | Latin small letter u with breve                   |
 * | U+016E  | Ů     | U           | Latin capital letter U with ring above            |
 * | U+016F  | ů     | u           | Latin small letter u with ring above              |
 * | U+0170  | Ű     | U           | Latin capital letter U with double acute          |
 * | U+0171  | ű     | u           | Latin small letter u with double acute            |
 * | U+0172  | Ų     | U           | Latin capital letter U with ogonek                |
 * | U+0173  | ų     | u           | Latin small letter u with ogonek                  |
 * | U+0174  | Ŵ     | W           | Latin capital letter W with circumflex            |
 * | U+0175  | ŵ     | w           | Latin small letter w with circumflex              |
 * | U+0176  | Ŷ     | Y           | Latin capital letter Y with circumflex            |
 * | U+0177  | ŷ     | y           | Latin small letter y with circumflex              |
 * | U+0178  | Ÿ     | Y           | Latin capital letter Y with diaeresis             |
 * | U+0179  | Ź     | Z           | Latin capital letter Z with acute                 |
 * | U+017A  | ź     | z           | Latin small letter z with acute                   |
 * | U+017B  | Ż     | Z           | Latin capital letter Z with dot above             |
 * | U+017C  | ż     | z           | Latin small letter z with dot above               |
 * | U+017D  | Ž     | Z           | Latin capital letter Z with caron                 |
 * | U+017E  | ž     | z           | Latin small letter z with caron                   |
 * | U+017F  | ſ     | s           | Latin small letter long s                         |
 * | U+01A0  | Ơ     | O           | Latin capital letter O with horn                  |
 * | U+01A1  | ơ     | o           | Latin small letter o with horn                    |
 * | U+01AF  | Ư     | U           | Latin capital letter U with horn                  |
 * | U+01B0  | ư     | u           | Latin small letter u with horn                    |
 * | U+01CD  | Ǎ     | A           | Latin capital letter A with caron                 |
 * | U+01CE  | ǎ     | a           | Latin small letter a with caron                   |
 * | U+01CF  | Ǐ     | I           | Latin capital letter I with caron                 |
 * | U+01D0  | ǐ     | i           | Latin small letter i with caron                   |
 * | U+01D1  | Ǒ     | O           | Latin capital letter O with caron                 |
 * | U+01D2  | ǒ     | o           | Latin small letter o with caron                   |
 * | U+01D3  | Ǔ     | U           | Latin capital letter U with caron                 |
 * | U+01D4  | ǔ     | u           | Latin small letter u with caron                   |
 * | U+01D5  | Ǖ     | U           | Latin capital letter U with diaeresis and macron  |
 * | U+01D6  | ǖ     | u           | Latin small letter u with diaeresis and macron    |
 * | U+01D7  | Ǘ     | U           | Latin capital letter U with diaeresis and acute   |
 * | U+01D8  | ǘ     | u           | Latin small letter u with diaeresis and acute     |
 * | U+01D9  | Ǚ     | U           | Latin capital letter U with diaeresis and caron   |
 * | U+01DA  | ǚ     | u           | Latin small letter u with diaeresis and caron     |
 * | U+01DB  | Ǜ     | U           | Latin capital letter U with diaeresis and grave   |
 * | U+01DC  | ǜ     | u           | Latin small letter u with diaeresis and grave     |
 *
 * Decompositions for Latin Extended-B:
 *
 * |   Code   | Glyph | Replacement |                Description                |
 * | -------- | ----- | ----------- | ----------------------------------------- |
 * | U+0218   | Ș     | S           | Latin capital letter S with comma below   |
 * | U+0219   | ș     | s           | Latin small letter s with comma below     |
 * | U+021A   | Ț     | T           | Latin capital letter T with comma below   |
 * | U+021B   | ț     | t           | Latin small letter t with comma below     |
 *
 * Vowels with diacritic (Chinese, Hanyu Pinyin):
 *
 * |   Code   | Glyph | Replacement |                      Description                      |
 * | -------- | ----- | ----------- | ----------------------------------------------------- |
 * | U+0251   | ɑ     | a           | Latin small letter alpha                              |
 * | U+1EA0   | Ạ     | A           | Latin capital letter A with dot below                 |
 * | U+1EA1   | ạ     | a           | Latin small letter a with dot below                   |
 * | U+1EA2   | Ả     | A           | Latin capital letter A with hook above                |
 * | U+1EA3   | ả     | a           | Latin small letter a with hook above                  |
 * | U+1EA4   | Ấ     | A           | Latin capital letter A with circumflex and acute      |
 * | U+1EA5   | ấ     | a           | Latin small letter a with circumflex and acute        |
 * | U+1EA6   | Ầ     | A           | Latin capital letter A with circumflex and grave      |
 * | U+1EA7   | ầ     | a           | Latin small letter a with circumflex and grave        |
 * | U+1EA8   | Ẩ     | A           | Latin capital letter A with circumflex and hook above |
 * | U+1EA9   | ẩ     | a           | Latin small letter a with circumflex and hook above   |
 * | U+1EAA   | Ẫ     | A           | Latin capital letter A with circumflex and tilde      |
 * | U+1EAB   | ẫ     | a           | Latin small letter a with circumflex and tilde        |
 * | U+1EA6   | Ậ     | A           | Latin capital letter A with circumflex and dot below  |
 * | U+1EAD   | ậ     | a           | Latin small letter a with circumflex and dot below    |
 * | U+1EAE   | Ắ     | A           | Latin capital letter A with breve and acute           |
 * | U+1EAF   | ắ     | a           | Latin small letter a with breve and acute             |
 * | U+1EB0   | Ằ     | A           | Latin capital letter A with breve and grave           |
 * | U+1EB1   | ằ     | a           | Latin small letter a with breve and grave             |
 * | U+1EB2   | Ẳ     | A           | Latin capital letter A with breve and hook above      |
 * | U+1EB3   | ẳ     | a           | Latin small letter a with breve and hook above        |
 * | U+1EB4   | Ẵ     | A           | Latin capital letter A with breve and tilde           |
 * | U+1EB5   | ẵ     | a           | Latin small letter a with breve and tilde             |
 * | U+1EB6   | Ặ     | A           | Latin capital letter A with breve and dot below       |
 * | U+1EB7   | ặ     | a           | Latin small letter a with breve and dot below         |
 * | U+1EB8   | Ẹ     | E           | Latin capital letter E with dot below                 |
 * | U+1EB9   | ẹ     | e           | Latin small letter e with dot below                   |
 * | U+1EBA   | Ẻ     | E           | Latin capital letter E with hook above                |
 * | U+1EBB   | ẻ     | e           | Latin small letter e with hook above                  |
 * | U+1EBC   | Ẽ     | E           | Latin capital letter E with tilde                     |
 * | U+1EBD   | ẽ     | e           | Latin small letter e with tilde                       |
 * | U+1EBE   | Ế     | E           | Latin capital letter E with circumflex and acute      |
 * | U+1EBF   | ế     | e           | Latin small letter e with circumflex and acute        |
 * | U+1EC0   | Ề     | E           | Latin capital letter E with circumflex and grave      |
 * | U+1EC1   | ề     | e           | Latin small letter e with circumflex and grave        |
 * | U+1EC2   | Ể     | E           | Latin capital letter E with circumflex and hook above |
 * | U+1EC3   | ể     | e           | Latin small letter e with circumflex and hook above   |
 * | U+1EC4   | Ễ     | E           | Latin capital letter E with circumflex and tilde      |
 * | U+1EC5   | ễ     | e           | Latin small letter e with circumflex and tilde        |
 * | U+1EC6   | Ệ     | E           | Latin capital letter E with circumflex and dot below  |
 * | U+1EC7   | ệ     | e           | Latin small letter e with circumflex and dot below    |
 * | U+1EC8   | Ỉ     | I           | Latin capital letter I with hook above                |
 * | U+1EC9   | ỉ     | i           | Latin small letter i with hook above                  |
 * | U+1ECA   | Ị     | I           | Latin capital letter I with dot below                 |
 * | U+1ECB   | ị     | i           | Latin small letter i with dot below                   |
 * | U+1ECC   | Ọ     | O           | Latin capital letter O with dot below                 |
 * | U+1ECD   | ọ     | o           | Latin small letter o with dot below                   |
 * | U+1ECE   | Ỏ     | O           | Latin capital letter O with hook above                |
 * | U+1ECF   | ỏ     | o           | Latin small letter o with hook above                  |
 * | U+1ED0   | Ố     | O           | Latin capital letter O with circumflex and acute      |
 * | U+1ED1   | ố     | o           | Latin small letter o with circumflex and acute        |
 * | U+1ED2   | Ồ     | O           | Latin capital letter O with circumflex and grave      |
 * | U+1ED3   | ồ     | o           | Latin small letter o with circumflex and grave        |
 * | U+1ED4   | Ổ     | O           | Latin capital letter O with circumflex and hook above |
 * | U+1ED5   | ổ     | o           | Latin small letter o with circumflex and hook above   |
 * | U+1ED6   | Ỗ     | O           | Latin capital letter O with circumflex and tilde      |
 * | U+1ED7   | ỗ     | o           | Latin small letter o with circumflex and tilde        |
 * | U+1ED8   | Ộ     | O           | Latin capital letter O with circumflex and dot below  |
 * | U+1ED9   | ộ     | o           | Latin small letter o with circumflex and dot below    |
 * | U+1EDA   | Ớ     | O           | Latin capital letter O with horn and acute            |
 * | U+1EDB   | ớ     | o           | Latin small letter o with horn and acute              |
 * | U+1EDC   | Ờ     | O           | Latin capital letter O with horn and grave            |
 * | U+1EDD   | ờ     | o           | Latin small letter o with horn and grave              |
 * | U+1EDE   | Ở     | O           | Latin capital letter O with horn and hook above       |
 * | U+1EDF   | ở     | o           | Latin small letter o with horn and hook above         |
 * | U+1EE0   | Ỡ     | O           | Latin capital letter O with horn and tilde            |
 * | U+1EE1   | ỡ     | o           | Latin small letter o with horn and tilde              |
 * | U+1EE2   | Ợ     | O           | Latin capital letter O with horn and dot below        |
 * | U+1EE3   | ợ     | o           | Latin small letter o with horn and dot below          |
 * | U+1EE4   | Ụ     | U           | Latin capital letter U with dot below                 |
 * | U+1EE5   | ụ     | u           | Latin small letter u with dot below                   |
 * | U+1EE6   | Ủ     | U           | Latin capital letter U with hook above                |
 * | U+1EE7   | ủ     | u           | Latin small letter u with hook above                  |
 * | U+1EE8   | Ứ     | U           | Latin capital letter U with horn and acute            |
 * | U+1EE9   | ứ     | u           | Latin small letter u with horn and acute              |
 * | U+1EEA   | Ừ     | U           | Latin capital letter U with horn and grave            |
 * | U+1EEB   | ừ     | u           | Latin small letter u with horn and grave              |
 * | U+1EEC   | Ử     | U           | Latin capital letter U with horn and hook above       |
 * | U+1EED   | ử     | u           | Latin small letter u with horn and hook above         |
 * | U+1EEE   | Ữ     | U           | Latin capital letter U with horn and tilde            |
 * | U+1EEF   | ữ     | u           | Latin small letter u with horn and tilde              |
 * | U+1EF0   | Ự     | U           | Latin capital letter U with horn and dot below        |
 * | U+1EF1   | ự     | u           | Latin small letter u with horn and dot below          |
 * | U+1EF2   | Ỳ     | Y           | Latin capital letter Y with grave                     |
 * | U+1EF3   | ỳ     | y           | Latin small letter y with grave                       |
 * | U+1EF4   | Ỵ     | Y           | Latin capital letter Y with dot below                 |
 * | U+1EF5   | ỵ     | y           | Latin small letter y with dot below                   |
 * | U+1EF6   | Ỷ     | Y           | Latin capital letter Y with hook above                |
 * | U+1EF7   | ỷ     | y           | Latin small letter y with hook above                  |
 * | U+1EF8   | Ỹ     | Y           | Latin capital letter Y with tilde                     |
 * | U+1EF9   | ỹ     | y           | Latin small letter y with tilde                       |
 */

// Currency signs:
{ letter: /[\u00A3]/g, alternative: "" }, { letter: /[\u20AC]/g, alternative: "E" },
// Decompositions for Latin-1 Supplement:
{ letter: /[\u00AA]/g, alternative: "a" }, { letter: /[\u00BA]/g, alternative: "o" }, { letter: /[\u00C0]/g, alternative: "A" }, { letter: /[\u00C1]/g, alternative: "A" }, { letter: /[\u00C2]/g, alternative: "A" }, { letter: /[\u00C3]/g, alternative: "A" }, { letter: /[\u00C4]/g, alternative: "A" }, { letter: /[\u00C5]/g, alternative: "A" }, { letter: /[\u00C6]/g, alternative: "AE" }, { letter: /[\u00C7]/g, alternative: "C" }, { letter: /[\u00C8]/g, alternative: "E" }, { letter: /[\u00C9]/g, alternative: "E" }, { letter: /[\u00CA]/g, alternative: "E" }, { letter: /[\u00CB]/g, alternative: "E" }, { letter: /[\u00CC]/g, alternative: "I" }, { letter: /[\u00CD]/g, alternative: "I" }, { letter: /[\u00CE]/g, alternative: "I" }, { letter: /[\u00CF]/g, alternative: "I" }, { letter: /[\u00D0]/g, alternative: "D" }, { letter: /[\u00D1]/g, alternative: "N" }, { letter: /[\u00D2]/g, alternative: "O" }, { letter: /[\u00D3]/g, alternative: "O" }, { letter: /[\u00D4]/g, alternative: "O" }, { letter: /[\u00D5]/g, alternative: "O" }, { letter: /[\u00D6]/g, alternative: "O" }, { letter: /[\u00D8]/g, alternative: "O" }, { letter: /[\u00D9]/g, alternative: "U" }, { letter: /[\u00DA]/g, alternative: "U" }, { letter: /[\u00DB]/g, alternative: "U" }, { letter: /[\u00DC]/g, alternative: "U" }, { letter: /[\u00DD]/g, alternative: "Y" }, { letter: /[\u00DE]/g, alternative: "TH" }, { letter: /[\u00DF]/g, alternative: "s" }, { letter: /[\u00E0]/g, alternative: "a" }, { letter: /[\u00E1]/g, alternative: "a" }, { letter: /[\u00E2]/g, alternative: "a" }, { letter: /[\u00E3]/g, alternative: "a" }, { letter: /[\u00E4]/g, alternative: "a" }, { letter: /[\u00E5]/g, alternative: "a" }, { letter: /[\u00E6]/g, alternative: "ae" }, { letter: /[\u00E7]/g, alternative: "c" }, { letter: /[\u00E8]/g, alternative: "e" }, { letter: /[\u00E9]/g, alternative: "e" }, { letter: /[\u00EA]/g, alternative: "e" }, { letter: /[\u00EB]/g, alternative: "e" }, { letter: /[\u00EC]/g, alternative: "i" }, { letter: /[\u00ED]/g, alternative: "i" }, { letter: /[\u00EE]/g, alternative: "i" }, { letter: /[\u00EF]/g, alternative: "i" }, { letter: /[\u00F0]/g, alternative: "d" }, { letter: /[\u00F1]/g, alternative: "n" }, { letter: /[\u00F2]/g, alternative: "o" }, { letter: /[\u00F3]/g, alternative: "o" }, { letter: /[\u00F4]/g, alternative: "o" }, { letter: /[\u00F5]/g, alternative: "o" }, { letter: /[\u00F6]/g, alternative: "o" }, { letter: /[\u00F8]/g, alternative: "o" }, { letter: /[\u00F9]/g, alternative: "u" }, { letter: /[\u00FA]/g, alternative: "u" }, { letter: /[\u00FB]/g, alternative: "u" }, { letter: /[\u00FC]/g, alternative: "u" }, { letter: /[\u00FD]/g, alternative: "y" }, { letter: /[\u00FE]/g, alternative: "th" }, { letter: /[\u00FF]/g, alternative: "y" },
// Decompositions for Latin Extended-A:
{ letter: /[\u0100]/g, alternative: "A" }, { letter: /[\u0101]/g, alternative: "a" }, { letter: /[\u0102]/g, alternative: "A" }, { letter: /[\u0103]/g, alternative: "a" }, { letter: /[\u0104]/g, alternative: "A" }, { letter: /[\u0105]/g, alternative: "a" }, { letter: /[\u0106]/g, alternative: "C" }, { letter: /[\u0107]/g, alternative: "c" }, { letter: /[\u0108]/g, alternative: "C" }, { letter: /[\u0109]/g, alternative: "c" }, { letter: /[\u010A]/g, alternative: "C" }, { letter: /[\u010B]/g, alternative: "c" }, { letter: /[\u010C]/g, alternative: "C" }, { letter: /[\u010D]/g, alternative: "c" }, { letter: /[\u010E]/g, alternative: "D" }, { letter: /[\u010F]/g, alternative: "d" }, { letter: /[\u0110]/g, alternative: "D" }, { letter: /[\u0111]/g, alternative: "d" }, { letter: /[\u0112]/g, alternative: "E" }, { letter: /[\u0113]/g, alternative: "e" }, { letter: /[\u0114]/g, alternative: "E" }, { letter: /[\u0115]/g, alternative: "e" }, { letter: /[\u0116]/g, alternative: "E" }, { letter: /[\u0117]/g, alternative: "e" }, { letter: /[\u0118]/g, alternative: "E" }, { letter: /[\u0119]/g, alternative: "e" }, { letter: /[\u011A]/g, alternative: "E" }, { letter: /[\u011B]/g, alternative: "e" }, { letter: /[\u011C]/g, alternative: "G" }, { letter: /[\u011D]/g, alternative: "g" }, { letter: /[\u011E]/g, alternative: "G" }, { letter: /[\u011F]/g, alternative: "g" }, { letter: /[\u0120]/g, alternative: "G" }, { letter: /[\u0121]/g, alternative: "g" }, { letter: /[\u0122]/g, alternative: "G" }, { letter: /[\u0123]/g, alternative: "g" }, { letter: /[\u0124]/g, alternative: "H" }, { letter: /[\u0125]/g, alternative: "h" }, { letter: /[\u0126]/g, alternative: "H" }, { letter: /[\u0127]/g, alternative: "h" }, { letter: /[\u0128]/g, alternative: "I" }, { letter: /[\u0129]/g, alternative: "i" }, { letter: /[\u012A]/g, alternative: "I" }, { letter: /[\u012B]/g, alternative: "i" }, { letter: /[\u012C]/g, alternative: "I" }, { letter: /[\u012D]/g, alternative: "i" }, { letter: /[\u012E]/g, alternative: "I" }, { letter: /[\u012F]/g, alternative: "i" }, { letter: /[\u0130]/g, alternative: "I" }, { letter: /[\u0131]/g, alternative: "i" }, { letter: /[\u0132]/g, alternative: "IJ" }, { letter: /[\u0133]/g, alternative: "ij" }, { letter: /[\u0134]/g, alternative: "J" }, { letter: /[\u0135]/g, alternative: "j" }, { letter: /[\u0136]/g, alternative: "K" }, { letter: /[\u0137]/g, alternative: "k" }, { letter: /[\u0138]/g, alternative: "k" }, { letter: /[\u0139]/g, alternative: "L" }, { letter: /[\u013A]/g, alternative: "l" }, { letter: /[\u013B]/g, alternative: "L" }, { letter: /[\u013C]/g, alternative: "l" }, { letter: /[\u013D]/g, alternative: "L" }, { letter: /[\u013E]/g, alternative: "l" }, { letter: /[\u013F]/g, alternative: "L" }, { letter: /[\u0140]/g, alternative: "l" }, { letter: /[\u0141]/g, alternative: "L" }, { letter: /[\u0142]/g, alternative: "l" }, { letter: /[\u0143]/g, alternative: "N" }, { letter: /[\u0144]/g, alternative: "n" }, { letter: /[\u0145]/g, alternative: "N" }, { letter: /[\u0146]/g, alternative: "n" }, { letter: /[\u0147]/g, alternative: "N" }, { letter: /[\u0148]/g, alternative: "n" }, { letter: /[\u0149]/g, alternative: "n" }, { letter: /[\u014A]/g, alternative: "N" }, { letter: /[\u014B]/g, alternative: "n" }, { letter: /[\u014C]/g, alternative: "O" }, { letter: /[\u014D]/g, alternative: "o" }, { letter: /[\u014E]/g, alternative: "O" }, { letter: /[\u014F]/g, alternative: "o" }, { letter: /[\u0150]/g, alternative: "O" }, { letter: /[\u0151]/g, alternative: "o" }, { letter: /[\u0152]/g, alternative: "OE" }, { letter: /[\u0153]/g, alternative: "oe" }, { letter: /[\u0154]/g, alternative: "R" }, { letter: /[\u0155]/g, alternative: "r" }, { letter: /[\u0156]/g, alternative: "R" }, { letter: /[\u0157]/g, alternative: "r" }, { letter: /[\u0158]/g, alternative: "R" }, { letter: /[\u0159]/g, alternative: "r" }, { letter: /[\u015A]/g, alternative: "S" }, { letter: /[\u015B]/g, alternative: "s" }, { letter: /[\u015C]/g, alternative: "S" }, { letter: /[\u015D]/g, alternative: "s" }, { letter: /[\u015E]/g, alternative: "S" }, { letter: /[\u015F]/g, alternative: "s" }, { letter: /[\u0160]/g, alternative: "S" }, { letter: /[\u0161]/g, alternative: "s" }, { letter: /[\u0162]/g, alternative: "T" }, { letter: /[\u0163]/g, alternative: "t" }, { letter: /[\u0164]/g, alternative: "T" }, { letter: /[\u0165]/g, alternative: "t" }, { letter: /[\u0166]/g, alternative: "T" }, { letter: /[\u0167]/g, alternative: "t" }, { letter: /[\u0168]/g, alternative: "U" }, { letter: /[\u0169]/g, alternative: "u" }, { letter: /[\u016A]/g, alternative: "U" }, { letter: /[\u016B]/g, alternative: "u" }, { letter: /[\u016C]/g, alternative: "U" }, { letter: /[\u016D]/g, alternative: "u" }, { letter: /[\u016E]/g, alternative: "U" }, { letter: /[\u016F]/g, alternative: "u" }, { letter: /[\u0170]/g, alternative: "U" }, { letter: /[\u0171]/g, alternative: "u" }, { letter: /[\u0172]/g, alternative: "U" }, { letter: /[\u0173]/g, alternative: "u" }, { letter: /[\u0174]/g, alternative: "W" }, { letter: /[\u0175]/g, alternative: "w" }, { letter: /[\u0176]/g, alternative: "Y" }, { letter: /[\u0177]/g, alternative: "y" }, { letter: /[\u0178]/g, alternative: "Y" }, { letter: /[\u0179]/g, alternative: "Z" }, { letter: /[\u017A]/g, alternative: "z" }, { letter: /[\u017B]/g, alternative: "Z" }, { letter: /[\u017C]/g, alternative: "z" }, { letter: /[\u017D]/g, alternative: "Z" }, { letter: /[\u017E]/g, alternative: "z" }, { letter: /[\u017F]/g, alternative: "s" }, { letter: /[\u01A0]/g, alternative: "O" }, { letter: /[\u01A1]/g, alternative: "o" }, { letter: /[\u01AF]/g, alternative: "U" }, { letter: /[\u01B0]/g, alternative: "u" }, { letter: /[\u01CD]/g, alternative: "A" }, { letter: /[\u01CE]/g, alternative: "a" }, { letter: /[\u01CF]/g, alternative: "I" }, { letter: /[\u01D0]/g, alternative: "i" }, { letter: /[\u01D1]/g, alternative: "O" }, { letter: /[\u01D2]/g, alternative: "o" }, { letter: /[\u01D3]/g, alternative: "U" }, { letter: /[\u01D4]/g, alternative: "u" }, { letter: /[\u01D5]/g, alternative: "U" }, { letter: /[\u01D6]/g, alternative: "u" }, { letter: /[\u01D7]/g, alternative: "U" }, { letter: /[\u01D8]/g, alternative: "u" }, { letter: /[\u01D9]/g, alternative: "U" }, { letter: /[\u01DA]/g, alternative: "u" }, { letter: /[\u01DB]/g, alternative: "U" }, { letter: /[\u01DC]/g, alternative: "u" },
// Decompositions for Latin Extended-B:
{ letter: /[\u0218]/g, alternative: "S" }, { letter: /[\u0219]/g, alternative: "s" }, { letter: /[\u021A]/g, alternative: "T" }, { letter: /[\u021B]/g, alternative: "t" },
// Vowels with diacritic (Chinese, Hanyu Pinyin):
{ letter: /[\u0251]/g, alternative: "a" }, { letter: /[\u1EA0]/g, alternative: "A" }, { letter: /[\u1EA1]/g, alternative: "a" }, { letter: /[\u1EA2]/g, alternative: "A" }, { letter: /[\u1EA3]/g, alternative: "a" }, { letter: /[\u1EA4]/g, alternative: "A" }, { letter: /[\u1EA5]/g, alternative: "a" }, { letter: /[\u1EA6]/g, alternative: "A" }, { letter: /[\u1EA7]/g, alternative: "a" }, { letter: /[\u1EA8]/g, alternative: "A" }, { letter: /[\u1EA9]/g, alternative: "a" }, { letter: /[\u1EAA]/g, alternative: "A" }, { letter: /[\u1EAB]/g, alternative: "a" }, { letter: /[\u1EA6]/g, alternative: "A" }, { letter: /[\u1EAD]/g, alternative: "a" }, { letter: /[\u1EAE]/g, alternative: "A" }, { letter: /[\u1EAF]/g, alternative: "a" }, { letter: /[\u1EB0]/g, alternative: "A" }, { letter: /[\u1EB1]/g, alternative: "a" }, { letter: /[\u1EB2]/g, alternative: "A" }, { letter: /[\u1EB3]/g, alternative: "a" }, { letter: /[\u1EB4]/g, alternative: "A" }, { letter: /[\u1EB5]/g, alternative: "a" }, { letter: /[\u1EB6]/g, alternative: "A" }, { letter: /[\u1EB7]/g, alternative: "a" }, { letter: /[\u1EB8]/g, alternative: "E" }, { letter: /[\u1EB9]/g, alternative: "e" }, { letter: /[\u1EBA]/g, alternative: "E" }, { letter: /[\u1EBB]/g, alternative: "e" }, { letter: /[\u1EBC]/g, alternative: "E" }, { letter: /[\u1EBD]/g, alternative: "e" }, { letter: /[\u1EBE]/g, alternative: "E" }, { letter: /[\u1EBF]/g, alternative: "e" }, { letter: /[\u1EC0]/g, alternative: "E" }, { letter: /[\u1EC1]/g, alternative: "e" }, { letter: /[\u1EC2]/g, alternative: "E" }, { letter: /[\u1EC3]/g, alternative: "e" }, { letter: /[\u1EC4]/g, alternative: "E" }, { letter: /[\u1EC5]/g, alternative: "e" }, { letter: /[\u1EC6]/g, alternative: "E" }, { letter: /[\u1EC7]/g, alternative: "e" }, { letter: /[\u1EC8]/g, alternative: "I" }, { letter: /[\u1EC9]/g, alternative: "i" }, { letter: /[\u1ECA]/g, alternative: "I" }, { letter: /[\u1ECB]/g, alternative: "i" }, { letter: /[\u1ECC]/g, alternative: "O" }, { letter: /[\u1ECD]/g, alternative: "o" }, { letter: /[\u1ECE]/g, alternative: "O" }, { letter: /[\u1ECF]/g, alternative: "o" }, { letter: /[\u1ED0]/g, alternative: "O" }, { letter: /[\u1ED1]/g, alternative: "o" }, { letter: /[\u1ED2]/g, alternative: "O" }, { letter: /[\u1ED3]/g, alternative: "o" }, { letter: /[\u1ED4]/g, alternative: "O" }, { letter: /[\u1ED5]/g, alternative: "o" }, { letter: /[\u1ED6]/g, alternative: "O" }, { letter: /[\u1ED7]/g, alternative: "o" }, { letter: /[\u1ED8]/g, alternative: "O" }, { letter: /[\u1ED9]/g, alternative: "o" }, { letter: /[\u1EDA]/g, alternative: "O" }, { letter: /[\u1EDB]/g, alternative: "o" }, { letter: /[\u1EDC]/g, alternative: "O" }, { letter: /[\u1EDD]/g, alternative: "o" }, { letter: /[\u1EDE]/g, alternative: "O" }, { letter: /[\u1EDF]/g, alternative: "o" }, { letter: /[\u1EE0]/g, alternative: "O" }, { letter: /[\u1EE1]/g, alternative: "o" }, { letter: /[\u1EE2]/g, alternative: "O" }, { letter: /[\u1EE3]/g, alternative: "o" }, { letter: /[\u1EE4]/g, alternative: "U" }, { letter: /[\u1EE5]/g, alternative: "u" }, { letter: /[\u1EE6]/g, alternative: "U" }, { letter: /[\u1EE7]/g, alternative: "u" }, { letter: /[\u1EE8]/g, alternative: "U" }, { letter: /[\u1EE9]/g, alternative: "u" }, { letter: /[\u1EEA]/g, alternative: "U" }, { letter: /[\u1EEB]/g, alternative: "u" }, { letter: /[\u1EEC]/g, alternative: "U" }, { letter: /[\u1EED]/g, alternative: "u" }, { letter: /[\u1EEE]/g, alternative: "U" }, { letter: /[\u1EEF]/g, alternative: "u" }, { letter: /[\u1EF0]/g, alternative: "U" }, { letter: /[\u1EF1]/g, alternative: "u" }, { letter: /[\u1EF2]/g, alternative: "Y" }, { letter: /[\u1EF3]/g, alternative: "y" }, { letter: /[\u1EF4]/g, alternative: "Y" }, { letter: /[\u1EF5]/g, alternative: "y" }, { letter: /[\u1EF6]/g, alternative: "Y" }, { letter: /[\u1EF7]/g, alternative: "y" }, { letter: /[\u1EF8]/g, alternative: "Y" }, { letter: /[\u1EF9]/g, alternative: "y" }];

const transliterationsPerLanguage = {
	/*
  * Language: German.
  * |   Code   | Glyph | Replacement |               Description               |
  * | -------- | ----- | ----------- | --------------------------------------- |
  * | U+00C4   | Ä     | Ae          | Latin capital letter A with diaeresis   |
  * | U+00E4   | ä     | ae          | Latin small letter a with diaeresis     |
  * | U+00D6   | Ö     | Oe          | Latin capital letter O with diaeresis   |
  * | U+00F6   | ö     | oe          | Latin small letter o with diaeresis     |
  * | U+00DC   | Ü     | Ue          | Latin capital letter U with diaeresis   |
  * | U+00FC   | ü     | ue          | Latin small letter u with diaeresis     |
  * | U+1E9E   | ẞ     | ss          | Latin big letter sharp s                | This letter is not in the original WP list, was added for consistency.
  * | U+00DF   | ß     | ss          | Latin small letter sharp s              |
  */
	de: [{ letter: /[\u00C4]/g, alternative: "Ae" }, { letter: /[\u00E4]/g, alternative: "ae" }, { letter: /[\u00D6]/g, alternative: "Oe" }, { letter: /[\u00F6]/g, alternative: "oe" }, { letter: /[\u00DC]/g, alternative: "Ue" }, { letter: /[\u00FC]/g, alternative: "ue" }, { letter: /[\u1E9E]/g, alternative: "SS" }, { letter: /[\u00DF]/g, alternative: "ss" }],

	/*
  * Language: Danish.
  * |   Code   | Glyph | Replacement |               Description               |
     * | -------- | ----- | ----------- | --------------------------------------- |
     * | U+00C6   | Æ     | Ae          | Latin capital letter AE                 |
     * | U+00E6   | æ     | ae          | Latin small letter ae                   |
     * | U+00D8   | Ø     | Oe          | Latin capital letter O with stroke      |
     * | U+00F8   | ø     | oe          | Latin small letter o with stroke        |
     * | U+00C5   | Å     | Aa          | Latin capital letter A with ring above  |
     * | U+00E5   | å     | aa          | Latin small letter a with ring above    |
  */
	da: [{ letter: /[\u00C6]/g, alternative: "Ae" }, { letter: /[\u00E6]/g, alternative: "ae" }, { letter: /[\u00D8]/g, alternative: "Oe" }, { letter: /[\u00F8]/g, alternative: "oe" }, { letter: /[\u00C5]/g, alternative: "Aa" }, { letter: /[\u00E5]/g, alternative: "aa" }],

	/*
  * Language: Catalan.
  * |   Code   | Glyph | Replacement |               Description               |
     * | -------- | ----- | ----------- | --------------------------------------- |
     * | U+00B7   | l·l   | ll          | Flown dot (between two Ls)              |
  */
	ca: [{ letter: /[\u00B7]/g, alternative: "ll" }],

	/*
  * Language: Serbian and Bosnian.
  * |   Code   | Glyph | Replacement |               Description               |
     * | -------- | ----- | ----------- | --------------------------------------- |
     * | U+0110   | Đ     | DJ          | Latin capital letter D with stroke      |
     * | U+0111   | đ     | dj          | Latin small letter d with stroke        |
  */
	srAndBs: [{ letter: /[\u0110]/g, alternative: "DJ" }, { letter: /[\u0111]/g, alternative: "dj" }]
};

/**
 * The function returning an array containing transliteration objects if those were specified for a given language.
 *
 * @param {string} language The language to return transliterations for.
 *
 * @returns {Array} An array containing language-specific transliteration objects.
 */
const getLanguageSpecificTransliterations = function getLanguageSpecificTransliterations(language) {
	switch (language) {
		case "de":
			return transliterationsPerLanguage.de;
		case "da":
			return transliterationsPerLanguage.da;
		case "ca":
			return transliterationsPerLanguage.ca;
		case "sr":
			return transliterationsPerLanguage.srAndBs;
		case "bs":
			return transliterationsPerLanguage.srAndBs;
		default:
			return [];
	}
};

Object.defineProperty(transliterateWPstyle, "__esModule", {
  value: true
});

transliterateWPstyle.default = function (text, locale) {
  const map = (0, _transliterationsWPstyle2.default)(locale);
  for (let i = map.length - 1; i >= 0; i--) {
    text = text.replace(map[i].letter, map[i].alternative);
  }
  return text;
};

var _transliterationsWPstyle = transliterationsWPstyle;

var _transliterationsWPstyle2 = _interopRequireDefault$1Q(_transliterationsWPstyle);

function _interopRequireDefault$1Q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var specialCharacterMappings = {};

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$2;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$1 = createBaseFor();

var _baseFor = baseFor$1;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$8 = freeGlobal || freeSelf || Function('return this')();

var _root = root$8;

var root$7 = _root;

/** Built-in value references. */
var Symbol$5 = root$7.Symbol;

var _Symbol = Symbol$5;

var Symbol$4 = _Symbol;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$b.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$a = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$a.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$3 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$6(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$6;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$6(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$6;

var baseGetTag$5 = _baseGetTag,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$5(value) && baseGetTag$5(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$4 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$2 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$4(value) && hasOwnProperty$7.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$2;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$a = Array.isArray;

var isArray_1 = isArray$a;

var isBuffer$2 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

(function (module, exports) {
var root = _root,
    stubFalse = stubFalse_1;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
}(isBuffer$2, isBuffer$2.exports));

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$2(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$2;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$3;

var baseGetTag$4 = _baseGetTag,
    isLength$2 = isLength_1,
    isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] =
typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] =
typedArrayTags[setTag$2] = typedArrayTags[stringTag$2] =
typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$3(value) &&
    isLength$2(value.length) && !!typedArrayTags[baseGetTag$4(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$1(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$1;

var _nodeUtil = {exports: {}};

(function (module, exports) {
var freeGlobal = _freeGlobal;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
}(_nodeUtil, _nodeUtil.exports));

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$2;

var baseTimes = _baseTimes,
    isArguments$1 = isArguments_1,
    isArray$9 = isArray_1,
    isBuffer$1 = isBuffer$2.exports,
    isIndex$1 = _isIndex,
    isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$9(value),
      isArg = !isArr && isArguments$1(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$6.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$1(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$1;

/** Used for built-in method references. */

var objectProto$7 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$1(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$7;

  return value === proto;
}

var _isPrototype = isPrototype$1;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$1(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$1;

var overArg = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$5.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$1;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$4(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$4;

var baseGetTag$3 = _baseGetTag,
    isObject$3 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject$3(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$3(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

var isFunction$1 = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$3(value) {
  return value != null && isLength$1(value.length) && !isFunction$1(value);
}

var isArrayLike_1 = isArrayLike$3;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike$2 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$4(object) {
  return isArrayLike$2(object) ? arrayLikeKeys(object) : baseKeys(object);
}

var keys_1 = keys$4;

var baseFor = _baseFor,
    keys$3 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys$3);
}

var _baseForOwn = baseForOwn$1;

var isArrayLike$1 = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$1(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach$1;

var baseForOwn = _baseForOwn,
    createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$1 = createBaseEach(baseForOwn);

var _baseEach = baseEach$1;

var baseEach = _baseEach;

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter$1(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

var _baseFilter = baseFilter$1;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$2(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$2;

var eq$1 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var root$6 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$6['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction = isFunction_1,
    isMasked = _isMasked,
    isObject$2 = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$5 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$4).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$2(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$6(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$6;

var getNative$5 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var Map$3 = getNative$5(root$5, 'Map');

var _Map = Map$3;

var getNative$4 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$4(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$2.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$2 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$2 || ListCache$2),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
    Map$1 = _Map,
    MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$1 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$2.prototype.clear = stackClear;
Stack$2.prototype['delete'] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;

var _Stack = Stack$2;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache$1 = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$1;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;

var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root$4 = _root;

/** Built-in value references. */
var Uint8Array$1 = root$4.Uint8Array;

var _Uint8Array = Uint8Array$1;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var Symbol$2 = _Symbol,
    Uint8Array = _Uint8Array,
    eq = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag$1:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$1:
      var convert = mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$1:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$1(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$1;

var arrayPush = _arrayPush,
    isArray$8 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$8(object) ? result : arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$1() {
  return [];
}

var stubArray_1 = stubArray$1;

var arrayFilter$1 = _arrayFilter,
    stubArray = stubArray_1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$1(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$1;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys$2 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys$2, getSymbols);
}

var _getAllKeys = getAllKeys$1;

var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$3 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative$3(root$3, 'DataView');

var _DataView = DataView$1;

var getNative$2 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$2(root$2, 'Promise');

var _Promise = Promise$2;

var getNative$1 = _getNative,
    root$1 = _root;

/* Built-in method references that are verified to be native. */
var Set$1 = getNative$1(root$1, 'Set');

var _Set = Set$1;

var getNative = _getNative,
    root = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root, 'WeakMap');

var _WeakMap = WeakMap$1;

var DataView = _DataView,
    Map = _Map,
    Promise$1 = _Promise,
    Set = _Set,
    WeakMap = _WeakMap,
    baseGetTag$2 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$1 = baseGetTag$2;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag$1(new Map) != mapTag) ||
    (Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag) ||
    (Set && getTag$1(new Set) != setTag) ||
    (WeakMap && getTag$1(new WeakMap) != weakMapTag)) {
  getTag$1 = function(value) {
    var result = baseGetTag$2(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

var _getTag = getTag$1;

var Stack$1 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag = _getTag,
    isArray$7 = isArray_1,
    isBuffer = isBuffer$2.exports,
    isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$7(object),
      othIsArr = isArray$7(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$1);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$2 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$2(value) && !isObjectLike$2(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}

var _baseIsEqual = baseIsEqual$2;

var Stack = _Stack,
    baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$1 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$1(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$1 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var baseGetTag$1 = _baseGetTag,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$4(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && baseGetTag$1(value) == symbolTag);
}

var isSymbol_1 = isSymbol$4;

var isArray$6 = isArray_1,
    isSymbol$3 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$6(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

var MapCache = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$2;

var Symbol$1 = _Symbol,
    arrayMap$1 = _arrayMap,
    isArray$5 = isArray_1,
    isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$5(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$1(value, baseToString$1) + '';
  }
  if (isSymbol$2(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$1;

var isArray$4 = isArray_1,
    isKey$2 = _isKey,
    stringToPath = _stringToPath,
    toString = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$2(value, object) {
  if (isArray$4(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString(value));
}

var _castPath = castPath$2;

var isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$4(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey$4;

var castPath$1 = _castPath,
    toKey$3 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$2(object, path) {
  path = castPath$1(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$3(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$2;

var baseGet$1 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$1(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var castPath = _castPath,
    isArguments = isArguments_1,
    isArray$3 = isArray_1,
    isIndex = _isIndex,
    isLength = isLength_1,
    toKey$2 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$2(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray$3(object) || isArguments(object));
}

var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$1;

var baseIsEqual = _baseIsEqual,
    get = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$1 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$1(value) {
  return value;
}

var identity_1 = identity$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity = identity_1,
    isArray$2 = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$1(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray$2(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$1;

var arrayFilter = _arrayFilter,
    baseFilter = _baseFilter,
    baseIteratee = _baseIteratee,
    isArray$1 = isArray_1;

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray$1(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate));
}

var filter_1 = filter;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$1;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf$1;

var baseFindIndex = _baseFindIndex,
    baseIsNaN = _baseIsNaN,
    strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$1(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$1;

var baseGetTag = _baseGetTag,
    isArray = isArray_1,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString$1(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

var isString_1 = isString$1;

var isObject = isObject_1,
    isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber$1;

var toNumber = toNumber_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite$1;

var toFinite = toFinite_1;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger$1(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger$1;

var arrayMap = _arrayMap;

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues$1(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

var _baseValues = baseValues$1;

var baseValues = _baseValues,
    keys = keys_1;

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values$1(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

var values_1 = values$1;

var baseIndexOf = _baseIndexOf,
    isArrayLike = isArrayLike_1,
    isString = isString_1,
    toInteger = toInteger_1,
    values = values_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

var includes_1 = includes;

Object.defineProperty(specialCharacterMappings, "__esModule", {
	value: true
});
specialCharacterMappings.replaceTurkishIsMemoized = specialCharacterMappings.replaceTurkishIs = specialCharacterMappings.combinations = specialCharacterMappings.arraysOverlap = specialCharacterMappings.arraysDifference = specialCharacterMappings.getIndicesOfCharacter = specialCharacterMappings.getIndicesOfWords = undefined;

var _filter = filter_1;

var _filter2 = _interopRequireDefault$1P(_filter);

var _includes = includes_1;

var _includes2 = _interopRequireDefault$1P(_includes);

var _memoize = memoize_1;

var _memoize2 = _interopRequireDefault$1P(_memoize);

var _getWords$f = getWords;

var _getWords2$f = _interopRequireDefault$1P(_getWords$f);

function _interopRequireDefault$1P(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets positions of the first character of a word in the input text.
 *
 * @param {string} text The original text, for which the indices of word beginnings need to be determined.
 *
 * @returns {Array} indices The array of indices in the text at which words start.
 */
function getIndicesOfWords(text) {
	const indices = [];
	const words = (0, _getWords2$f.default)(text);
	let startSearchFrom = 0;

	words.forEach(function (word) {
		const currentIndex = text.indexOf(word, startSearchFrom);
		indices.push(currentIndex);
		startSearchFrom = currentIndex + word.length;
	});

	return indices;
}

/**
 * Gets indices of a specific character in the input text.
 *
 * @param {string} text The original text, for which the indices of specific characters have to be determined.
 * @param {string} characterToFind The character that needs to be found in the text.
 *
 * @returns {Array} indices The array of indices in the text at which the characterToFind occurs.
 */
function getIndicesOfCharacter(text, characterToFind) {
	const indices = [];

	if (text.indexOf(characterToFind) > -1) {
		for (let i = 0; i < text.length; i++) {
			if (text[i] === characterToFind) {
				indices.push(i);
			}
		}
	}

	return indices;
}

/**
 * Compares two arrays of which the second array is the sub-array of the first array.
 * Returns the array of elements of the first array which are not in the second array.
 *
 * @param {Array} bigArray The array with all elements.
 * @param {Array} subarray The array with some elements from the bigArray.
 *
 * @returns {Array} difference An array of all elements of bigArray which are not in subarray.
 */
function arraysDifference(bigArray, subarray) {
	return (0, _filter2.default)(bigArray, function (element) {
		return !(0, _includes2.default)(subarray, element);
	});
}

/**
 * Compares two arrays and returns the array of elements that occur in both arrays.
 *
 * @param {Array} firstArray The first array with elements to compare.
 * @param {Array} secondArray The second array with elements to compare.
 *
 * @returns {Array} overlap An array of all elements of firstArray which are also in secondArray.
 */
function arraysOverlap(firstArray, secondArray) {
	return (0, _filter2.default)(firstArray, function (element) {
		return (0, _includes2.default)(secondArray, element);
	});
}

/**
 * Generates all possible combinations of the elements of an array (treated as unique).
 * https://gist.github.com/jpillora/4435759
 *
 * @param {Array} collection The array with elements that should be combined.
 *
 * @returns {Array} result An array of all possible combinations of elements of the original array.
 */
function combinations(collection) {
	/**
  * A recursive function that iterates through all elements of an array to produce its combinations.
  *
  * @param {Array} xs The array to start accumulating with.
  * @param {Array} array The array with elements that should be combined.
  *
  * @returns {Array} result An array of all possible combinations of elements of the original array.
  */
	function acc(xs, array) {
		const x = xs[0];

		if (typeof x === "undefined") {
			return array;
		}

		for (let i = 0, l = array.length; i < l; ++i) {
			array.push(array[i].concat(x));
		}
		return acc(xs.slice(1), array);
	}
	return acc(collection, [[]]).slice(1).concat([[]]);
}

/**
 * Replaces characters on specified indices in the input text.
 *
 * @param {string} text The original text, for which the characters have to be substituted.
 * @param {Array} indices The array of indices that have to be substituted.
 * @param {string} substitute The character that is used to substitute in the text.
 *
 * @returns {string} result The string of the original text with the characters on specified indices are substituted with the substitute character.
 */
function replaceCharactersByIndex(text, indices, substitute) {
	const modifiedTextSplitByLetter = text.split("");

	indices.forEach(function (index) {
		modifiedTextSplitByLetter.splice(index, 1, substitute);
	});

	return modifiedTextSplitByLetter.join("");
}

/**
 * Generates upper and lower case for Turkish strings that contain characters İ or ı, which appear to not be processed correctly by regexes.
 *
 * @param {string} text The text to build possible upper and lower case alternatives.
 *
 * @returns {Array} An array of strings that contains all possible upper and lower case alternatives of the original string
 */
function replaceTurkishIs(text) {
	// Get indices of all occurrences of İ, I, i, or ı.
	const indicesOfAllIs = getIndicesOfCharacter(text, "İ").concat(getIndicesOfCharacter(text, "I"), getIndicesOfCharacter(text, "i"), getIndicesOfCharacter(text, "ı"));
	indicesOfAllIs.sort();

	// If there are no Is return the text
	if (indicesOfAllIs.length === 0) {
		return [text];
	}
	const indicesOfIsInWordBeginnings = arraysOverlap(getIndicesOfWords(text), indicesOfAllIs);

	const results = [];

	// First round of creating combinations: assign which indices will be replaced by İ
	const combinationsDottedI = combinations(indicesOfIsInWordBeginnings);

	combinationsDottedI.forEach(function (oneCombinationDottedI) {
		// If the combination is full array, just add it to results immediately without going through the rest of iterations.
		if (oneCombinationDottedI === indicesOfIsInWordBeginnings) {
			results.push([oneCombinationDottedI, [], [], []]);
		} else {
			const indicesNotDottedI = arraysDifference(indicesOfIsInWordBeginnings, oneCombinationDottedI);

			// Second round of creating combinations: assign which indices will be replaced by I
			const combinationsDotlessI = combinations(indicesNotDottedI);
			combinationsDotlessI.forEach(function (oneCombinationDotlessI) {
				// If the combination is full array, just add it to results immediately without going through the rest of iterations.
				if (oneCombinationDotlessI === indicesNotDottedI) {
					results.push([oneCombinationDottedI, oneCombinationDotlessI, [], []]);
				} else {
					const indicesSmalli = arraysDifference(indicesNotDottedI, oneCombinationDotlessI);

					// Third round of creating combinations: assign which indices will be replaced by i
					const combinationsDottedi = combinations(indicesSmalli);

					combinationsDottedi.forEach(function (oneCombinationDottedi) {
						// If the combination is full array, just add it to results immediately without going through the rest of iterations.
						if (oneCombinationDottedi === indicesSmalli) {
							results.push([oneCombinationDottedI, oneCombinationDotlessI, oneCombinationDottedi, []]);
						} else {
							const oneCombinationDotlessi = arraysDifference(indicesSmalli, oneCombinationDottedi);

							results.push([oneCombinationDottedI, oneCombinationDotlessI, oneCombinationDottedi, oneCombinationDotlessi]);
						}
					});
				}
			});
		}
	});

	const textAlternations = [];

	results.forEach(function (result) {
		const toDottedI = replaceCharactersByIndex(text, result[0], "İ");
		const toDotlessI = replaceCharactersByIndex(toDottedI, result[1], "I");
		const toDottedi = replaceCharactersByIndex(toDotlessI, result[2], "i");
		const toDotlessi = replaceCharactersByIndex(toDottedi, result[3], "ı");
		textAlternations.push(toDotlessi);
	});

	return textAlternations;
}

const replaceTurkishIsMemoized = (0, _memoize2.default)(replaceTurkishIs);

specialCharacterMappings.getIndicesOfWords = getIndicesOfWords;
specialCharacterMappings.getIndicesOfCharacter = getIndicesOfCharacter;
specialCharacterMappings.arraysDifference = arraysDifference;
specialCharacterMappings.arraysOverlap = arraysOverlap;
specialCharacterMappings.combinations = combinations;
specialCharacterMappings.replaceTurkishIs = replaceTurkishIs;
specialCharacterMappings.replaceTurkishIsMemoized = replaceTurkishIsMemoized;

Object.defineProperty(matchTextWithTransliteration, "__esModule", {
	value: true
});

matchTextWithTransliteration.default = function (text, keyword, locale) {
	var keywordRegex = toRegex(keyword, locale);

	if (locale === "tr_TR") {
		const turkishMappings = (0, _specialCharacterMappings.replaceTurkishIsMemoized)(keyword);
		keywordRegex = new RegExp(turkishMappings.map(x => (0, _addWordboundary2$2.default)(x)).join("|"), "ig");
	}
	var matches = text.match(keywordRegex) || [];

	text = text.replace(keywordRegex, "");

	var transliterateKeyword = (0, _transliterate2$1.default)(keyword, locale);
	var transliterateKeywordRegex = toRegex(transliterateKeyword, locale);
	var transliterateMatches = text.match(transliterateKeywordRegex) || [];
	var combinedArray = matches.concat(transliterateMatches);

	var transliterateWPKeyword = (0, _transliterateWPstyle2.default)(keyword, locale);

	if (!(transliterateWPKeyword === transliterateKeyword)) {
		var transliterateWPKeywordRegex = toRegex(transliterateWPKeyword, locale);
		var transliterateWPMatches = text.match(transliterateWPKeywordRegex) || [];

		combinedArray = combinedArray.concat(transliterateWPMatches);
	}

	return (0, _lodashEs$1a.map)(combinedArray, function (match) {
		return (0, _stripSpaces2$a.default)(match);
	});
};

var _lodashEs$1a = require$$1$1;

var _addWordboundary$2 = addWordboundary;

var _addWordboundary2$2 = _interopRequireDefault$1O(_addWordboundary$2);

var _stripSpaces$a = stripSpaces;

var _stripSpaces2$a = _interopRequireDefault$1O(_stripSpaces$a);

var _transliterate$1 = transliterate;

var _transliterate2$1 = _interopRequireDefault$1O(_transliterate$1);

var _transliterateWPstyle = transliterateWPstyle;

var _transliterateWPstyle2 = _interopRequireDefault$1O(_transliterateWPstyle);

var _specialCharacterMappings = specialCharacterMappings;

function _interopRequireDefault$1O(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a regex from the keyword with included wordboundaries.
 *
 * @param {string} keyword  The keyword to create a regex from.
 * @param {string} locale   The locale.
 *
 * @returns {RegExp} Regular expression of the keyword with word boundaries.
 */
var toRegex = function toRegex(keyword, locale) {
	keyword = (0, _addWordboundary2$2.default)(keyword, false, "", locale);
	return new RegExp(keyword, "ig");
};

Object.defineProperty(matchTextWithWord, "__esModule", {
	value: true
});

matchTextWithWord.default = function (text, wordToMatch, locale, extraBoundary) {
	text = (0, _stripNonTextTags2$1.default)(text);
	text = (0, _unifyWhitespace.unifyAllSpaces)(text);
	text = (0, _quotes$7.normalize)(text);
	wordToMatch = (0, _stripSpaces2$9.default)((0, _quotes$7.normalize)(wordToMatch));

	let matches = (0, _matchTextWithTransliteration2.default)(text, wordToMatch, locale, extraBoundary);
	matches = (0, _lodashEs$19.map)(matches, function (keyword) {
		return (0, _stripSpaces2$9.default)((0, _removePunctuation2$1.default)(keyword));
	});

	// Create an array of positions of matches to determine where in the text the wordToMatch occurred first.
	const positions = (0, _lodashEs$19.map)(matches, function (keyword) {
		return text.indexOf(keyword);
	});

	return {
		count: matches.length,
		matches: matches,
		position: Math.min(...positions)
	};
};

var _stripNonTextTags$1 = stripNonTextTags;

var _stripNonTextTags2$1 = _interopRequireDefault$1N(_stripNonTextTags$1);

var _stripSpaces$9 = stripSpaces;

var _stripSpaces2$9 = _interopRequireDefault$1N(_stripSpaces$9);

var _removePunctuation$1 = removePunctuation;

var _removePunctuation2$1 = _interopRequireDefault$1N(_removePunctuation$1);

var _unifyWhitespace = unifyWhitespace;

var _matchTextWithTransliteration = matchTextWithTransliteration;

var _matchTextWithTransliteration2 = _interopRequireDefault$1N(_matchTextWithTransliteration);

var _quotes$7 = quotes;

var _lodashEs$19 = require$$1$1;

function _interopRequireDefault$1N(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(matchTextWithArray, "__esModule", {
	value: true
});

matchTextWithArray.default = function (text, array, locale = "en_EN") {
	let count = 0;
	let matches = [];

	array = array.map(_quotes$6.normalize);

	(0, _lodashEs$18.uniq)(array).forEach(function (wordToMatch) {
		const occurrence = (0, _matchTextWithWord2$1.default)(text, wordToMatch, locale);
		count += occurrence.count;
		matches = matches.concat(occurrence.matches);
	});

	if (matches === null) {
		matches = [];
	}

	matches = matches.map(function (string) {
		return (0, _stripSpaces2$8.default)((0, _removePunctuation2.default)(string));
	});

	return {
		count: count,
		matches: matches
	};
};

var _stripSpaces$8 = stripSpaces;

var _stripSpaces2$8 = _interopRequireDefault$1M(_stripSpaces$8);

var _removePunctuation = removePunctuation;

var _removePunctuation2 = _interopRequireDefault$1M(_removePunctuation);

var _matchTextWithWord$1 = matchTextWithWord;

var _matchTextWithWord2$1 = _interopRequireDefault$1M(_matchTextWithWord$1);

var _quotes$6 = quotes;

var _lodashEs$18 = require$$1$1;

function _interopRequireDefault$1M(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(findKeywordFormsInString, "__esModule", {
	value: true
});
findKeywordFormsInString.findTopicFormsInString = findKeywordFormsInString.findWordFormsInString = undefined;

var _matchTextWithArray$5 = matchTextWithArray;

var _matchTextWithArray2$5 = _interopRequireDefault$1L(_matchTextWithArray$5);

var _lodashEs$17 = require$$1$1;

function _interopRequireDefault$1L(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Matches forms of words in the keyphrase against a given text.
 *
 * @param {Array} keywordForms The array with word forms of all (content) words from the keyphrase in a shape
 *                             [ [ form1, form2, ... ], [ form1, form2, ... ] ]
 * @param {string} text The string to match the word forms against.
 * @param {string} locale The locale of the paper.
 *
 * @returns {Object} The number and the percentage of the keyphrase words that were matched in the text by at least one form.
 */
const findWordFormsInString = function findWordFormsInString(keywordForms, text, locale) {
	const wordNumber = keywordForms.length;
	const foundWords = Array(wordNumber);

	for (let i = 0; i < wordNumber; i++) {
		const found = (0, _matchTextWithArray2$5.default)(text, keywordForms[i], locale).count > 0;
		foundWords[i] = found ? 1 : 0;
	}
	const foundNumberOfWords = (0, _lodashEs$17.sum)(foundWords);
	const result = {
		countWordMatches: foundNumberOfWords,
		percentWordMatches: 0
	};

	if (wordNumber > 0) {
		result.percentWordMatches = Math.round(foundNumberOfWords / wordNumber * 100);
	}

	return result;
};

/**
 * Matches forms of words in the keyphrase and in the synonyms against a given text.
 *
 * @param {Object} topicForms The object with word forms of all (content) words from the keyphrase and eventually synonyms,
 * comes in a shape {
 *                     keyphraseForms: [[ form1, form2, ... ], [ form1, form2, ... ]],
 *                     synonymsForms: [
 *                          [[ form1, form2, ... ], [ form1, form2, ... ]],
 *                          [[ form1, form2, ... ], [ form1, form2, ... ]],
 *                          [[ form1, form2, ... ], [ form1, form2, ... ]],
 *                     ],
 *                  }
 * @param {string} text The string to match the word forms against.
 * @param {boolean} useSynonyms Whether to use synonyms as if it was keyphrase or not (depends on the assessment).
 * @param {string} locale The locale of the paper.
 *
 * @returns {Object} The number and the percentage fo the keyphrase words or synonyms that were matched in the text by at least one form,
 * and whether the keyphrase or a synonym was matched.
 */
const findTopicFormsInString = function findTopicFormsInString(topicForms, text, useSynonyms, locale) {
	// First check if the keyword is found in the text
	let result = findWordFormsInString(topicForms.keyphraseForms, text, locale);
	result.keyphraseOrSynonym = "keyphrase";

	// If a full match found with the keyword or if no synonyms are supplied or supposed to be used, return the keyphrase search result.
	if (result.percentWordMatches === 100 || useSynonyms === false || (0, _lodashEs$17.isEmpty)(topicForms.synonymsForms)) {
		return result;
	}

	// Collect results of matching of every synonym with the text.
	const resultsSynonyms = [];
	for (let i = 0; i < topicForms.synonymsForms.length; i++) {
		const synonym = topicForms.synonymsForms[i];
		resultsSynonyms[i] = findWordFormsInString(synonym, text, locale);
	}

	// Find which synonym occurred most fully.
	const foundSynonyms = resultsSynonyms.map(resultSynonyms => resultSynonyms.percentWordMatches);
	const bestSynonymIndex = foundSynonyms.indexOf(Math.max(...foundSynonyms));

	// If the best synonym showed lower results than the keyword, return the keyword.
	if (result.percentWordMatches >= resultsSynonyms[bestSynonymIndex].percentWordMatches) {
		return result;
	}

	// If the best synonym showed better results than the keyword, return the synonym.
	result = resultsSynonyms[bestSynonymIndex];
	result.keyphraseOrSynonym = "synonym";

	return result;
};

findKeywordFormsInString.findWordFormsInString = findWordFormsInString;
findKeywordFormsInString.findTopicFormsInString = findTopicFormsInString;

Object.defineProperty(findKeywordInUrl, "__esModule", {
	value: true
});

findKeywordInUrl.default = function (url, topicForms, locale = "en_EN") {
	var formatUrl = url.match(/>(.*)/ig);
	if (formatUrl !== null) {
		formatUrl = formatUrl[0].replace(/<.*?>\s?/ig, "");
		formatUrl = formatUrl.slice(1).toString();

		const topicInLinkText = (0, _findKeywordFormsInString$6.findTopicFormsInString)(topicForms, formatUrl, true, locale);

		return topicInLinkText.percentWordMatches === 100;
	}

	return false;
};

var _findKeywordFormsInString$6 = findKeywordFormsInString;

var getAnchorsFromText = {};

Object.defineProperty(getAnchorsFromText, "__esModule", {
	value: true
});

getAnchorsFromText.default = function (text) {
	var matches;

	/*
   * Regex matches everything between <a> and </a>.
   *
   * There must be:
   * - at least one whitespace after the starting `<a`, otherwise it matches `<abbr` tags.
   * - followed by at least one not `>`, to match any attributes that are given.
   *   This could be one or zero (`*`), but an anchor tag without an `href` attribute does not make sense.
   *   The regex could be more precise here, by checking for the `href`, but this is less complex.
   * - losing tag of the opening tag `>`.
   * - content of the anchor tag. Any character, including line separators (`[\n\r\u2028\u2029]`).
   * - the closing anchor tag.
  */
	matches = text.match(/<a[\s]+(?:[^>]+)>((?:.|[\n\r\u2028\u2029])*?)<\/a>/ig);

	if (matches === null) {
		matches = [];
	}

	return matches;
};

var getLinkType = {};

var url = {};

Object.defineProperty(url, "__esModule", {
  value: true
});

var _url$3 = require$$0$2;

var _url2$3 = _interopRequireDefault$1K(_url$3);

function _interopRequireDefault$1K(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var urlFromAnchorRegex = /href=(["'])([^"']+)\1/i;


/**
 * Removes a hash from a URL, assumes a well formed URL.
 *
 * @param {string} url The URL to remove a hash from.
 * @returns {string} The URL without the hash.
 */
function removeHash(url) {
  return url.split("#")[0];
}

/**
 * Removes all query args from a URL, assumes a well formed URL.
 *
 * @param {string} url The URL to remove the query args from.
 * @returns {string} The URL without the query args.
 */
function removeQueryArgs(url) {
  return url.split("?")[0];
}

/**
 * Removes the trailing slash of a URL.
 *
 * @param {string} url The URL to remove the trailing slash from.
 * @returns {string} A URL without a trailing slash.
 */
function removeTrailingSlash(url) {
  return url.replace(/\/$/, "");
}

/**
 * Adds a trailing slash to a URL if it is not present.
 *
 * @param {string} url The URL to add a trailing slash to.
 * @returns {string} A URL with a trailing slash.
 */
function addTrailingSlash(url) {
  return removeTrailingSlash(url) + "/";
}

/**
 * Retrieves the URL from an anchor tag.
 *
 * @param {string} anchorTag An anchor tag.
 * @returns {string} The URL in the anchor tag.
 */
function getFromAnchorTag(anchorTag) {
  var urlMatch = urlFromAnchorRegex.exec(anchorTag);

  return urlMatch === null ? "" : urlMatch[2];
}

/**
 * Returns whether or not the given URLs are equal.
 *
 * @param {string} urlA The first URL to compare.
 * @param {string} urlB The second URL to compare.
 *
 * @returns {boolean} Whether or not the given URLs are equal.
 */
function areEqual(urlA, urlB) {
  // Make sure we are comparing URLs without query arguments and hashes.
  urlA = removeQueryArgs(removeHash(urlA));
  urlB = removeQueryArgs(removeHash(urlB));

  return addTrailingSlash(urlA) === addTrailingSlash(urlB);
}

/**
 * Returns the domain name of a URL.
 *
 * @param {string} url The URL to retrieve the domain name of.
 * @returns {string} The domain name of the URL.
 */
function getHostname(url) {
  url = _url2$3.default.parse(url);

  return url.hostname;
}

/**
 * Returns the protocol of a URL.
 *
 * Note that the colon (http:) is also part of the protocol, conform to node's url.parse api.
 *
 * @param {string} url The URL to retrieve the protocol of.
 * @returns {string|null} The protocol of the URL or null if no protocol is present.
 */
function getProtocol(url) {
  return _url2$3.default.parse(url).protocol;
}

/**
 * Determine whether a URL is internal.
 *
 * @param {string} url The URL to test.
 * @param {string} host The current host.
 *
 * @returns {boolean} Whether or not the URL is internal.
 */
function isInternalLink(url, host) {
  const parsedUrl = _url2$3.default.parse(url, false, true);
  // Check if the URL starts with a single slash.
  if (url.indexOf("//") === -1 && url.indexOf("/") === 0) {
    return true;
  }

  // Check if the URL starts with a # indicating a fragment.
  if (url.indexOf("#") === 0) {
    return false;
  }

  // No host indicates an internal link.
  if (!parsedUrl.host) {
    return true;
  }

  return parsedUrl.host === host;
}

/**
 * Checks whether the protocol is either HTTP: or HTTPS:.
 *
 * @param {string} protocol The protocol to test.
 *
 * @returns {boolean} Whether the protocol is http(s):.
 */
function protocolIsHttpScheme(protocol) {
  if (!protocol) {
    return false;
  }

  return protocol === "http:" || protocol === "https:";
}

/**
 * Determines whether the link is a relative fragment URL.
 *
 * @param {string} url The URL to test.
 *
 * @returns {boolean} Whether the link is a relative fragment URL.
 */
function isRelativeFragmentURL(url) {
  return url.indexOf("#") === 0;
}

url.default = {
  removeHash: removeHash,
  removeQueryArgs: removeQueryArgs,
  removeTrailingSlash: removeTrailingSlash,
  addTrailingSlash: addTrailingSlash,
  getFromAnchorTag: getFromAnchorTag,
  areEqual: areEqual,
  getHostname: getHostname,
  getProtocol: getProtocol,
  isInternalLink: isInternalLink,
  protocolIsHttpScheme: protocolIsHttpScheme,
  isRelativeFragmentURL: isRelativeFragmentURL
};

Object.defineProperty(getLinkType, "__esModule", {
	value: true
});

getLinkType.default = function (text, url) {
	const anchorUrl = _url2$2.default.getFromAnchorTag(text);

	/**
  * A link is "Other" if:
  * - The protocol is neither null, nor http, nor https.
  * - The link is a relative fragment URL (starts with #), because it won't navigate to another page.
  */
	const protocol = _url2$2.default.getProtocol(anchorUrl);
	if (protocol && !_url2$2.default.protocolIsHttpScheme(protocol) || _url2$2.default.isRelativeFragmentURL(anchorUrl)) {
		return "other";
	}

	if (_url2$2.default.isInternalLink(anchorUrl, _url2$2.default.getHostname(url))) {
		return "internal";
	}

	return "external";
};

var _url$2 = url;

var _url2$2 = _interopRequireDefault$1J(_url$2);

function _interopRequireDefault$1J(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(getLinkStatistics, "__esModule", {
	value: true
});

var _filterFunctionWordsFromArray$2 = filterFunctionWordsFromArray;

var _filterFunctionWordsFromArray2$2 = _interopRequireDefault$1I(_filterFunctionWordsFromArray$2);

var _getLanguage$f = getLanguage;

var _getLanguage2$f = _interopRequireDefault$1I(_getLanguage$f);

var _checkNofollow = checkNofollow;

var _checkNofollow2 = _interopRequireDefault$1I(_checkNofollow);

var _getWords$e = getWords;

var _getWords2$e = _interopRequireDefault$1I(_getWords$e);

var _findKeywordInUrl = findKeywordInUrl;

var _findKeywordInUrl2 = _interopRequireDefault$1I(_findKeywordInUrl);

var _getAnchorsFromText$2 = getAnchorsFromText;

var _getAnchorsFromText2$2 = _interopRequireDefault$1I(_getAnchorsFromText$2);

var _getLinkType = getLinkType;

var _getLinkType2 = _interopRequireDefault$1I(_getLinkType);

var _matchTextWithArray$4 = matchTextWithArray;

var _matchTextWithArray2$4 = _interopRequireDefault$1I(_matchTextWithArray$4);

var _url$1 = url;

var _url2$1 = _interopRequireDefault$1I(_url$1);

var _lodashEs$16 = require$$1$1;

function _interopRequireDefault$1I(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks whether the link is pointing at itself.
 * @param {string} anchor The link anchor.
 * @param {string} permalink The permalink of the paper.
 *
 * @returns {boolean} Whether the anchor is pointing at itself.
 */
const linkToSelf = function linkToSelf(anchor, permalink) {
	const anchorLink = _url2$1.default.getFromAnchorTag(anchor);

	return _url2$1.default.areEqual(anchorLink, permalink);
};

/**
 * Filters anchors that are not pointing at itself.
 * @param {Array} anchors An array with all anchors from the paper
 * @param {string} permalink The permalink of the paper.
 *
 * @returns {Array} The array of all anchors that are not pointing at the paper itself.
 */
/** @module analyses/getLinkStatistics */

const filterAnchorsLinkingToSelf = function filterAnchorsLinkingToSelf(anchors, permalink) {
	const anchorsLinkingToSelf = anchors.map(function (anchor) {
		return linkToSelf(anchor, permalink);
	});

	anchors = anchors.filter(function (anchor, index) {
		return anchorsLinkingToSelf[index] === false;
	});

	return anchors;
};

/**
 * Filters anchors that contain keyphrase or synonyms.
 * @param {Array} anchors An array with all anchors from the paper
 * @param {Object} topicForms The object with topicForms.
 * @param {string} locale The locale of the paper
 *
 * @returns {Array} The array of all anchors that contain keyphrase or synonyms.
 */
const filterAnchorsContainingTopic = function filterAnchorsContainingTopic(anchors, topicForms, locale) {
	const anchorsContainingKeyphraseOrSynonyms = anchors.map(function (anchor) {
		return (0, _findKeywordInUrl2.default)(anchor, topicForms, locale);
	});
	anchors = anchors.filter(function (anchor, index) {
		return anchorsContainingKeyphraseOrSynonyms[index] === true;
	});

	return anchors;
};

/**
 * Filters anchors that are contained within keyphrase or synonyms.
 * @param {Array}  anchors    An array with all anchors from the paper.
 * @param {Object} topicForms An object containing word forms of words included in the keyphrase or a synonym.
 * @param {string} locale     The locale of the paper.
 *
 * @returns {Array} The array of all anchors contained in the keyphrase or synonyms.
 */
const filterAnchorsContainedInTopic = function filterAnchorsContainedInTopic(anchors, topicForms, locale) {
	// Prepare keyphrase and synonym forms for comparison with anchors.
	const keyphraseAndSynonymsWords = [(0, _lodashEs$16.flatten)(topicForms.keyphraseForms)];
	const synonymsForms = topicForms.synonymsForms;
	for (let i = 0; i < synonymsForms.length; i++) {
		keyphraseAndSynonymsWords.push((0, _lodashEs$16.flatten)(synonymsForms[i]));
	}

	const language = (0, _getLanguage2$f.default)(locale);
	const anchorsContainedInTopic = [];

	anchors.forEach(function (currentAnchor) {
		// Get single words from the anchor.
		let anchorWords = (0, _lodashEs$16.uniq)((0, _getWords2$e.default)(currentAnchor));

		// Filter function words out of the anchor text.
		anchorWords = (0, _filterFunctionWordsFromArray2$2.default)(anchorWords, language);

		// Check if anchorWords are contained in the topic phrase words
		for (let i = 0; i < keyphraseAndSynonymsWords.length; i++) {
			if (anchorWords.every(anchorWord => (0, _matchTextWithArray2$4.default)(anchorWord, keyphraseAndSynonymsWords[i], locale).count > 0)) {
				anchorsContainedInTopic.push(true);
				break;
			}
		}
	});

	anchors = anchors.filter(function (anchor, index) {
		return anchorsContainedInTopic[index] === true;
	});

	return anchors;
};

/**
 * Checks whether or not an anchor contains the passed keyword.
 * @param {Paper} paper The paper to research.
 * @param {Researcher} researcher The researcher to use.
 * @param {Array} anchors The array of anchors of the links found in the paper.
 * @param {string} permalink The string with a permalink of the paper.
 *
 * @returns {Object} How many anchors contained the keyphrase or synonyms, what are these anchors
 */
const keywordInAnchor = function keywordInAnchor(paper, researcher, anchors, permalink) {
	const result = { totalKeyword: 0, matchedAnchors: [] };

	const keyword = paper.getKeyword();

	// If no keyword is set, return empty result.
	if (keyword === "") {
		return result;
	}

	// Filter out anchors that point at the paper itself.
	anchors = filterAnchorsLinkingToSelf(anchors, permalink);
	if (anchors.length === 0) {
		return result;
	}

	const locale = paper.getLocale();
	const topicForms = researcher.getResearch("morphology");

	// Check if any anchors contain keyphrase or synonyms in them.
	anchors = filterAnchorsContainingTopic(anchors, topicForms, locale);
	if (anchors.length === 0) {
		return result;
	}

	// Check if content words from the anchors are all within the keyphrase or the synonyms.
	anchors = filterAnchorsContainedInTopic(anchors, topicForms, locale);
	result.totalKeyword = anchors.length;
	result.matchedAnchors = anchors;

	return result;
};

/**
 * Counts the links found in the text.
 *
 * @param {Paper} paper The paper object containing text, keyword and url.
 * @param {Researcher} researcher The researcher to use for the paper.
 *
 * @returns {object} The object containing all linktypes.
 * total: the total number of links found.
 * totalNaKeyword: the total number of links if keyword is not available.
 * keyword: Object containing all the keyword related counts and matches.
 * keyword.totalKeyword: the total number of links with the keyword.
 * keyword.matchedAnchors: Array with the anchors that contain the keyword.
 * internalTotal: the total number of links that are internal.
 * internalDofollow: the internal links without a nofollow attribute.
 * internalNofollow: the internal links with a nofollow attribute.
 * externalTotal: the total number of links that are external.
 * externalDofollow: the external links without a nofollow attribute.
 * externalNofollow: the internal links with a dofollow attribute.
 * otherTotal: all links that are not HTTP or HTTPS.
 * otherDofollow: other links without a nofollow attribute.
 * otherNofollow: other links with a nofollow attribute.
 */
const countLinkTypes = function countLinkTypes(paper, researcher) {
	const anchors = (0, _getAnchorsFromText2$2.default)(paper.getText());
	const permalink = paper.getPermalink();

	const linkCount = {
		total: anchors.length,
		totalNaKeyword: 0,
		keyword: {
			totalKeyword: 0,
			matchedAnchors: []
		},
		internalTotal: 0,
		internalDofollow: 0,
		internalNofollow: 0,
		externalTotal: 0,
		externalDofollow: 0,
		externalNofollow: 0,
		otherTotal: 0,
		otherDofollow: 0,
		otherNofollow: 0
	};

	for (let i = 0; i < anchors.length; i++) {
		const currentAnchor = anchors[i];

		const linkType = (0, _getLinkType2.default)(currentAnchor, permalink);
		const linkFollow = (0, _checkNofollow2.default)(currentAnchor);

		linkCount[linkType + "Total"]++;
		linkCount[linkType + linkFollow]++;
	}

	const keywordInAnchors = keywordInAnchor(paper, researcher, anchors, permalink);
	linkCount.keyword.totalKeyword = keywordInAnchors.totalKeyword;
	linkCount.keyword.matchedAnchors = keywordInAnchors.matchedAnchors;

	return linkCount;
};

getLinkStatistics.default = countLinkTypes;

var countLinks = {};

var getLinks = {};

Object.defineProperty(getLinks, "__esModule", {
  value: true
});

getLinks.default = function (paper) {
  const anchors = (0, _getAnchorsFromText2$1.default)(paper.getText());

  return (0, _lodashEs$15.map)(anchors, _url2.default.getFromAnchorTag);
};

var _getAnchorsFromText$1 = getAnchorsFromText;

var _getAnchorsFromText2$1 = _interopRequireDefault$1H(_getAnchorsFromText$1);

var _lodashEs$15 = require$$1$1;

var _url = url;

var _url2 = _interopRequireDefault$1H(_url);

function _interopRequireDefault$1H(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(countLinks, "__esModule", {
  value: true
});

countLinks.default = function (paper) {
  var anchors = (0, _getLinks2$1.default)(paper);

  return anchors.length;
};

var _getLinks$1 = getLinks;

var _getLinks2$1 = _interopRequireDefault$1G(_getLinks$1);

function _interopRequireDefault$1G(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var urlIsTooLong = {};

Object.defineProperty(urlIsTooLong, "__esModule", {
	value: true
});

urlIsTooLong.default = function (paper) {
	var urlLength = paper.getUrl().length;
	var keywordLength = paper.getKeyword().length;
	var maxUrlLength = 40;
	var maxSlugLength = 20;

	if (urlLength > maxUrlLength && urlLength > keywordLength + maxSlugLength) {
		return true;
	}
	return false;
};

var findKeywordInPageTitle = {};

Object.defineProperty(findKeywordInPageTitle, "__esModule", {
	value: true
});

findKeywordInPageTitle.default = function (paper, researcher) {
	let keyword = (0, _lodashEs$14.escapeRegExp)(paper.getKeyword());
	const title = paper.getTitle();
	const locale = paper.getLocale();

	const result = { exactMatchFound: false, allWordsFound: false, position: -1, exactMatchKeyphrase: false };

	// Check if the keyphrase is enclosed in double quotation marks to ensure that only exact matches are processed.
	const exactMatchRequest = processExactMatchRequest(keyword);
	if (exactMatchRequest.exactMatchRequested) {
		keyword = exactMatchRequest.keyword;
		result.exactMatchKeyphrase = true;
	}

	// Check if the exact match of the keyphrase found in the title.
	const keywordMatched = (0, _matchTextWithWord2.default)(title, keyword, locale);

	if (keywordMatched.count > 0) {
		result.exactMatchFound = true;
		result.allWordsFound = true;
		result.position = adjustPosition(title, keywordMatched.position, locale);

		return result;
	}

	// Check 2: Are all content words from the keyphrase in the title?
	const topicForms = researcher.getResearch("morphology");

	// Use only keyphrase ( not the synonyms) to match topic words in the title.
	const useSynonyms = false;

	const separateWordsMatched = (0, _findKeywordFormsInString$5.findTopicFormsInString)(topicForms, title, useSynonyms, locale);

	if (separateWordsMatched.percentWordMatches === 100) {
		result.allWordsFound = true;
	}

	return result;
};

var _matchTextWithWord = matchTextWithWord;

var _matchTextWithWord2 = _interopRequireDefault$1F(_matchTextWithWord);

var _findKeywordFormsInString$5 = findKeywordFormsInString;

var _getFunctionWords$2 = getFunctionWords$3;

var _getFunctionWords2$2 = _interopRequireDefault$1F(_getFunctionWords$2);

var _lodashEs$14 = require$$1$1;

var _getLanguage$e = getLanguage;

var _getLanguage2$e = _interopRequireDefault$1F(_getLanguage$e);

var _getWords$d = getWords;

var _getWords2$d = _interopRequireDefault$1F(_getWords$d);

function _interopRequireDefault$1F(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module analyses/findKeywordInPageTitle */

const getFunctionWords$1 = (0, _getFunctionWords2$2.default)();

/**
 * Strips all function words from the start of the given string.
 *
 * @param {string[]} functionWords The array of function words to strip from the start.
 * @param {string} str The string from which to strip the function words.
 *
 * @returns {boolean} Whether the string consists of function words only.
 */
const stripFunctionWordsFromStart = function stripFunctionWordsFromStart(functionWords, str) {
	str = str.toLocaleLowerCase();
	let titleWords = (0, _getWords2$d.default)(str.toLocaleLowerCase());

	// Strip all function words from the start of the string.
	titleWords = (0, _lodashEs$14.filter)(titleWords, function (word) {
		return !(0, _lodashEs$14.includes)(functionWords, word.trim().toLocaleLowerCase());
	});

	return (0, _lodashEs$14.isEmpty)(titleWords);
};

/**
 * Checks if exact match functionality is requested by enclosing the keyphrase in double quotation marks.
 *
 * @param {string} keyword The keyword to check.
 *
 * @returns {Object} Whether the exact match funcionality is requested and the keyword stripped from double quotes.
 */
const processExactMatchRequest = function processExactMatchRequest(keyword) {
	const exactMatchRequest = { exactMatchRequested: false, keyword: keyword };

	// Check if morphology is suppressed. If so, strip the quotation marks from the keyphrase.
	const doubleQuotes = ["“", "”", "〝", "〞", "〟", "‟", "„", "\""];
	if ((0, _lodashEs$14.includes)(doubleQuotes, keyword[0]) && (0, _lodashEs$14.includes)(doubleQuotes, keyword[keyword.length - 1])) {
		exactMatchRequest.keyword = keyword.substring(1, keyword.length - 1);
		exactMatchRequest.exactMatchRequested = true;
	}

	return exactMatchRequest;
};

/**
 * Checks whether an exact match of the keyphrase is found in the title.
 *
 * @param {string} title The title of the paper.
 * @param {number} position The position of the keyphrase in the title.
 * @param {string} locale The locale of the paper.
 *
 * @returns {number} Potentially adjusted position of the keyphrase in the title.
 */
const adjustPosition = function adjustPosition(title, position, locale) {
	// Don't do anything if position if already 0.
	if (position === 0) {
		return position;
	}

	// Don't do anything if no function words exist for this locale.
	const language = (0, _getLanguage2$e.default)(locale);
	const functionWords = (0, _lodashEs$14.get)(getFunctionWords$1, [language], []);
	if ((0, _lodashEs$14.isUndefined)(functionWords.all)) {
		return position;
	}

	// Strip all function words from the beginning of the title.
	const titleBeforeKeyword = title.substr(0, position);
	if (stripFunctionWordsFromStart(functionWords.all, titleBeforeKeyword)) {
		/*
   * Return position 0 if there are no words left in the title before the keyword after filtering
   * the function words (such that "keyword" in "the keyword" is still counted as position 0).
  	 */
		return 0;
	}

	return position;
};

var matchKeywordInSubheadings = {};

Object.defineProperty(matchKeywordInSubheadings, "__esModule", {
	value: true
});

matchKeywordInSubheadings.default = function (paper, researcher) {
	const text = (0, _stripNonTextTags2.default)(paper.getText());
	const topicForms = researcher.getResearch("morphology");
	const locale = paper.getLocale();
	const result = { count: 0, matches: 0, percentReflectingTopic: 0 };
	const useSynonyms = true;
	const subheadings = (0, _getSubheadings$1.getSubheadingContentsTopLevel)(text);

	if (subheadings.length !== 0) {
		result.count = subheadings.length;
		result.matches = numberOfSubheadingsReflectingTopic(topicForms, subheadings, useSynonyms, locale);
		result.percentReflectingTopic = result.matches / result.count * 100;
	}

	return result;
};

var _lodashEs$13 = require$$1$1;

var _getFunctionWordsLanguages = getFunctionWordsLanguages;

var _getFunctionWordsLanguages2 = _interopRequireDefault$1E(_getFunctionWordsLanguages);

var _getLanguage$d = getLanguage;

var _getLanguage2$d = _interopRequireDefault$1E(_getLanguage$d);

var _getSubheadings$1 = getSubheadings$1;

var _stripNonTextTags = stripNonTextTags;

var _stripNonTextTags2 = _interopRequireDefault$1E(_stripNonTextTags);

var _findKeywordFormsInString$4 = findKeywordFormsInString;

function _interopRequireDefault$1E(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const functionWordLanguages = (0, _getFunctionWordsLanguages2.default)();

/**
 * Computes the amount of subheadings reflecting the topic.
 *
 * @param {Object}      topicForms      The main key phrase and its synonyms to check.
 * @param {string[]}    subheadings     The subheadings to check.
 * @param {boolean}     useSynonyms     Whether to match synonyms or only main keyphrase.
 * @param {string}      locale          The current locale.
 *
 * @returns {number} The amount of subheadings reflecting the topic.
 */
const numberOfSubheadingsReflectingTopic = function numberOfSubheadingsReflectingTopic(topicForms, subheadings, useSynonyms, locale) {
	const isFunctionWordLanguage = (0, _lodashEs$13.includes)(functionWordLanguages, (0, _getLanguage2$d.default)(locale));

	return subheadings.filter(subheading => {
		const matchedTopicForms = (0, _findKeywordFormsInString$4.findTopicFormsInString)(topicForms, subheading, useSynonyms, locale);

		if (!isFunctionWordLanguage) {
			return matchedTopicForms.percentWordMatches === 100;
		}
		return matchedTopicForms.percentWordMatches > 50;
	}).length;
};

var getKeywordDensity = {};

Object.defineProperty(getKeywordDensity, "__esModule", {
  value: true
});

getKeywordDensity.default = function (paper, researcher) {
  const wordCount = (0, _countWords2$7.default)(paper.getText());
  if (wordCount === 0) {
    return 0;
  }

  const keywordCount = researcher.getResearch("keywordCount");
  return keywordCount.count / wordCount * 100;
};

var _countWords$7 = countWords;

var _countWords2$7 = _interopRequireDefault$1D(_countWords$7);

function _interopRequireDefault$1D(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keywordCount = {};

var markWordsInSentences$1 = {};

var addMarkSingleWord = {};

var stripWordBoundaries = {};

Object.defineProperty(stripWordBoundaries, "__esModule", {
  value: true
});
/*
 * \u00a0 - No-break space
 * \u06d4 - Urdu full stop
 * \u061f - Arabic question mark
 * \u060C - Arabic comma
 * \u061B - Arabic semicolon
 */
const wordBoundary = "[ \\u00a0\\u06d4\\u061f\\u060C\\u061B \\n\\r\\t.,'()\"+\\-;!?:/»«‹›<>]";
const wordBoundaryStart = new RegExp("^(" + wordBoundary + "+)", "ig");
const wordBoundaryEnd = new RegExp("(" + wordBoundary + "+$)", "ig");

/**
 * Strip word boundary markers from text in the beginning
 *
 * @param {String} text The text to strip word boundary markers from.
 *
 * @returns {String} The text without double word boundary markers.
 */
const stripWordBoundariesStart = function stripWordBoundariesStart(text) {
  // Remove first character if word boundary
  text = text.replace(wordBoundaryStart, "");

  return text;
};

/**
 * Strip word boundary markers from text in the end
 *
 * @param {String} text The text to strip word boundary markers from.
 *
 * @returns {String} The text without double word boundary markers.
 */
const stripWordBoundariesEnd = function stripWordBoundariesEnd(text) {
  // Remove last character if word boundary
  text = text.replace(wordBoundaryEnd, "");

  return text;
};

/**
 * Strip word boundary markers from text in the beginning and in the end
 *
 * @param {String} text The text to strip word boundary markers from.
 *
 * @returns {String} The text without word boundary markers.
 */
const stripWordBoundariesEverywhere = function stripWordBoundariesEverywhere(text) {
  // Remove first/last character if word boundary
  text = text.replace(wordBoundaryStart, "");
  text = text.replace(wordBoundaryEnd, "");

  return text;
};

stripWordBoundaries.stripWordBoundariesStart = stripWordBoundariesStart;
stripWordBoundaries.stripWordBoundariesEnd = stripWordBoundariesEnd;
stripWordBoundaries.stripWordBoundariesEverywhere = stripWordBoundariesEverywhere;
stripWordBoundaries.default = {
  stripWordBoundariesStart: stripWordBoundariesStart,
  stripWordBoundariesEnd: stripWordBoundariesEnd,
  stripWordBoundariesEverywhere: stripWordBoundariesEverywhere
};

Object.defineProperty(addMarkSingleWord, "__esModule", {
	value: true
});

addMarkSingleWord.default = function (text) {
	// Strip the word boundaries at the start of the text.
	const strippedTextStart = (0, _stripWordBoundaries.stripWordBoundariesStart)(text);
	let wordBoundaryStart = "";
	let wordBoundaryEnd = "";

	// Get the actual word boundaries from the start of the text.
	if (strippedTextStart !== text) {
		const wordBoundaryStartIndex = text.search(strippedTextStart);
		wordBoundaryStart = text.substr(0, wordBoundaryStartIndex);
	}

	// Strip word boundaries at the end of the text.
	const strippedTextEnd = (0, _stripWordBoundaries.stripWordBoundariesEnd)(strippedTextStart);
	// Get the actual word boundaries from the end of the text.
	if (strippedTextEnd !== strippedTextStart) {
		const wordBoundaryEndIndex = strippedTextStart.search(strippedTextEnd) + strippedTextEnd.length;
		wordBoundaryEnd = strippedTextStart.substr(wordBoundaryEndIndex);
	}

	return wordBoundaryStart + "<yoastmark class='yoast-text-mark'>" + strippedTextEnd + "</yoastmark>" + wordBoundaryEnd;
};

var _stripWordBoundaries = stripWordBoundaries;

Object.defineProperty(markWordsInSentences$1, "__esModule", {
  value: true
});
markWordsInSentences$1.markWordsInSentences = markWordsInSentences;

var _matchTextWithArray$3 = matchTextWithArray;

var _matchTextWithArray2$3 = _interopRequireDefault$1C(_matchTextWithArray$3);

var _createRegexFromArray$5 = createRegexFromArray;

var _createRegexFromArray2$5 = _interopRequireDefault$1C(_createRegexFromArray$5);

var _addMarkSingleWord$1 = addMarkSingleWord;

var _addMarkSingleWord2$1 = _interopRequireDefault$1C(_addMarkSingleWord$1);

var _Mark$2 = Mark$1;

var _Mark2$2 = _interopRequireDefault$1C(_Mark$2);

function _interopRequireDefault$1C(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Adds marks to a sentence and merges marks if those are only separated by a space
 * (e.g., if highlighting words "ballet" and "shoes" in a sentence "I have a lot of ballet shoes and other paraphernalia."
 * the marks will be put around "ballet shoes" together, not "`ballet` `shoes`".)
 *
 * @param {string}    sentence               The sentence to mark words in.
 * @param {[string]}  topicFoundInSentence   The words to mark in the sentence.
 *
 * @returns {string} The sentence with marks.
 */
const collectMarkingsInSentence = function collectMarkingsInSentence(sentence, topicFoundInSentence) {
  const markup = sentence.replace((0, _createRegexFromArray2$5.default)(topicFoundInSentence), function (x) {
    return (0, _addMarkSingleWord2$1.default)(x);
  });

  return markup.replace(new RegExp("</yoastmark> <yoastmark class='yoast-text-mark'>", "ig"), " ");
};

/**
 * Adds marks to an array of sentences.
 *
 * @param {[string]}    wordsToMark The words to mark.
 * @param {[string]}    sentences   The sentences in which to mark these words.
 * @param {string}      locale      The locale.
 *
 * @returns {[string]} The sentences with marks.
 */
function markWordsInSentences(wordsToMark, sentences, locale) {
  let topicFoundInSentence = [];
  let markings = [];

  sentences.forEach(function (sentence) {
    topicFoundInSentence = (0, _matchTextWithArray2$3.default)(sentence, wordsToMark, locale).matches;

    if (topicFoundInSentence.length > 0) {
      markings = markings.concat(new _Mark2$2.default({
        original: sentence,
        marked: collectMarkingsInSentence(sentence, topicFoundInSentence)
      }));
    }
  });

  return markings;
}

Object.defineProperty(keywordCount, "__esModule", {
	value: true
});

keywordCount.default = function (paper, researcher) {
	const topicForms = researcher.getResearch("morphology");
	const text = paper.getText();
	const locale = paper.getLocale();

	const sentences = (0, _getSentences2$a.default)(text);

	const keywordsFound = {
		count: 0,
		matches: [],
		sentencesWithKeywords: []
	};

	/*
  * Count the amount of key phrase occurrences in the sentences.
  * An occurrence is counted when all keywords of the key phrase are contained within the sentence.
  * Each sentence can contain multiple key phrases
  * (e.g. "The apple potato is an apple and a potato." has two occurrences of the key phrase "apple potato").
  */
	sentences.forEach(sentence => {
		const matchesInSentence = topicForms.keyphraseForms.map(keywordForms => (0, _matchTextWithArray2$2.default)(sentence, keywordForms, locale));
		const hasAllKeywords = matchesInSentence.every(keywordForm => keywordForm.count > 0);

		if (hasAllKeywords) {
			const counts = matchesInSentence.map(match => match.count);
			const foundWords = (0, _lodashEs$12.flattenDeep)(matchesInSentence.map(match => match.matches));
			keywordsFound.count += Math.min(...counts);
			keywordsFound.matches.push(foundWords);
			keywordsFound.sentencesWithKeywords.push(sentence);
		}
	});

	const matches = (0, _lodashEs$12.uniq)((0, _lodashEs$12.flattenDeep)(keywordsFound.matches)).sort((a, b) => b.length - a.length);

	return {
		count: keywordsFound.count,
		matches: matches,
		markings: (0, _markWordsInSentences$1.markWordsInSentences)(matches, keywordsFound.sentencesWithKeywords, locale),
		length: topicForms.keyphraseForms.length
	};
};

var _matchTextWithArray$2 = matchTextWithArray;

var _matchTextWithArray2$2 = _interopRequireDefault$1B(_matchTextWithArray$2);

var _lodashEs$12 = require$$1$1;

var _getSentences$a = getSentences;

var _getSentences2$a = _interopRequireDefault$1B(_getSentences$a);

var _markWordsInSentences$1 = markWordsInSentences$1;

function _interopRequireDefault$1B(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stopWordsInKeyword = {};

var stopWordsInText = {};

var stopwords$a = {};

Object.defineProperty(stopwords$a, "__esModule", {
  value: true
});

stopwords$a.default = function () {
  return ["a", "about", "above", "after", "again", "against", "all", "am", "an", "and", "any", "are", "as", "at", "be", "because", "been", "before", "being", "below", "between", "both", "but", "by", "could", "did", "do", "does", "doing", "down", "during", "each", "few", "for", "from", "further", "had", "has", "have", "having", "he", "he'd", "he'll", "he's", "her", "here", "here's", "hers", "herself", "him", "himself", "his", "how", "how's", "i", "i'd", "i'll", "i'm", "i've", "if", "in", "into", "is", "it", "it's", "its", "itself", "let's", "me", "more", "most", "my", "myself", "nor", "of", "on", "once", "only", "or", "other", "ought", "our", "ours", "ourselves", "out", "over", "own", "same", "she", "she'd", "she'll", "she's", "should", "so", "some", "such", "than", "that", "that's", "the", "their", "theirs", "them", "themselves", "then", "there", "there's", "these", "they", "they'd", "they'll", "they're", "they've", "this", "those", "through", "to", "too", "under", "until", "up", "very", "was", "we", "we'd", "we'll", "we're", "we've", "were", "what", "what's", "when", "when's", "where", "where's", "which", "while", "who", "who's", "whom", "why", "why's", "with", "would", "you", "you'd", "you'll", "you're", "you've", "your", "yours", "yourself", "yourselves"];
};

Object.defineProperty(stopWordsInText, "__esModule", {
	value: true
});

stopWordsInText.default = function (text) {
	var i,
	    matches = [];

	for (i = 0; i < stopwords$9.length; i++) {
		if (text.match((0, _createWordRegex2$1.default)(stopwords$9[i])) !== null) {
			matches.push(stopwords$9[i]);
		}
	}

	return matches;
};

var _stopwords$2 = stopwords$a;

var _stopwords2$2 = _interopRequireDefault$1A(_stopwords$2);

var _createWordRegex$1 = createWordRegex;

var _createWordRegex2$1 = _interopRequireDefault$1A(_createWordRegex$1);

function _interopRequireDefault$1A(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const stopwords$9 = (0, _stopwords2$2.default)();

Object.defineProperty(stopWordsInKeyword, "__esModule", {
  value: true
});

stopWordsInKeyword.default = function (paper) {
  var keyword = (0, _lodashEs$11.escapeRegExp)(paper.getKeyword());
  return (0, _stopWordsInText2$1.default)(keyword);
};

var _stopWordsInText$1 = stopWordsInText;

var _stopWordsInText2$1 = _interopRequireDefault$1z(_stopWordsInText$1);

var _lodashEs$11 = require$$1$1;

function _interopRequireDefault$1z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stopWordsInUrl = {};

Object.defineProperty(stopWordsInUrl, "__esModule", {
  value: true
});

stopWordsInUrl.default = function (paper) {
  return (0, _stopWordsInText2.default)(paper.getUrl().replace(/[-_]/g, " "));
};

var _stopWordsInText = stopWordsInText;

var _stopWordsInText2 = _interopRequireDefault$1y(_stopWordsInText);

function _interopRequireDefault$1y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calculateFleschReading = {};

var stripNumbers = {};

Object.defineProperty(stripNumbers, "__esModule", {
	value: true
});

stripNumbers.default = function (text) {
	// Remove "words" comprised only of numbers
	text = text.replace(/\b[0-9]+\b/g, "");

	text = (0, _stripSpaces2$7.default)(text);

	if (text === ".") {
		text = "";
	}
	return text;
};

var _stripSpaces$7 = stripSpaces;

var _stripSpaces2$7 = _interopRequireDefault$1x(_stripSpaces$7);

function _interopRequireDefault$1x(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countSentences = {};

Object.defineProperty(countSentences, "__esModule", {
	value: true
});

countSentences.default = function (text) {
	var sentences = (0, _getSentences2$9.default)(text);
	var sentenceCount = 0;
	for (var i = 0; i < sentences.length; i++) {
		sentenceCount++;
	}
	return sentenceCount;
};

var _getSentences$9 = getSentences;

var _getSentences2$9 = _interopRequireDefault$1w(_getSentences$9);

function _interopRequireDefault$1w(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var count = {};

var syllables = {};

var vowels$7 = "aeiouyäöüáéâàèîêâûôœ";
var deviations$7 = {
	vowels: [
		{
			fragments: [
				"ouil",
				"deaux",
				"deau$",
				"oard",
				"äthiop",
				"euil",
				"veau",
				"eau$",
				"ueue",
				"lienisch",
				"ance$",
				"ence$",
				"time$",
				"once$",
				"ziat",
				"guette",
				"ête",
				"ôte$",
				"[hp]omme$",
				"[qdscn]ue$",
				"aire$",
				"ture$",
				"êpe$",
				"[^q]ui$",
				"tiche$",
				"vice$",
				"oile$",
				"zial",
				"cruis",
				"leas",
				"coa[ct]",
				"[^i]deal",
				"[fw]eat",
				"[lsx]ed$"
			],
			countModifier: -1
		},
		{
			fragments: [
				"aau",
				"a[äöüo]",
				"äue",
				"äeu",
				"aei",
				"aue",
				"aeu",
				"ael",
				"ai[aeo]",
				"saik",
				"aismus",
				"ä[aeoi]",
				"auä",
				"éa",
				"e[äaoö]",
				"ei[eo]",
				"ee[aeiou]",
				"eu[aäe]",
				"eum$",
				"eü",
				"o[aäöü]",
				"poet",
				"oo[eo]",
				"oie",
				"oei[^l]",
				"oeu[^f]",
				"öa",
				"[fgrz]ieu",
				"mieun",
				"tieur",
				"ieum",
				"i[aiuü]",
				"[^l]iä",
				"[^s]chien",
				"io[bcdfhjkmpqtuvwx]",
				"[bdhmprv]ion",
				"[lr]ior",
				"[^g]io[gs]",
				"[dr]ioz",
				"elioz",
				"zioni",
				"bio[lnorz]",
				"iö[^s]",
				"ie[ei]",
				"rier$",
				"öi[eg]",
				"[^r]öisch",
				"[^gqv]u[aeéioöuü]",
				"quie$",
				"quie[^s]",
				"uäu",
				"^us-",
				"^it-",
				"üe",
				"naiv",
				"aisch$",
				"aische$",
				"aische[nrs]$",
				"[lst]ien",
				"dien$",
				"gois",
				"[^g]rient",
				"[aeiou]y[aeiou]",
				"byi",
				"yä",
				"[a-z]y[ao]",
				"yau",
				"koor",
				"scient",
				"eriel",
				"[dg]oing"
			],
			countModifier: 1
		},
		{
			fragments: [
				"eauü",
				"ioi",
				"ioo",
				"ioa",
				"iii",
				"oai",
				"eueu"
			],
			countModifier: 1
		}
	],
	words: {
		full: [
			{
				word: "beach",
				syllables: 1
			},
			{
				word: "beat",
				syllables: 1
			},
			{
				word: "beau",
				syllables: 1
			},
			{
				word: "beaune",
				syllables: 1
			},
			{
				word: "belle",
				syllables: 1
			},
			{
				word: "bouche",
				syllables: 1
			},
			{
				word: "brake",
				syllables: 1
			},
			{
				word: "cache",
				syllables: 1
			},
			{
				word: "chaiselongue",
				syllables: 2
			},
			{
				word: "choke",
				syllables: 1
			},
			{
				word: "cordiale",
				syllables: 3
			},
			{
				word: "core",
				syllables: 1
			},
			{
				word: "dope",
				syllables: 1
			},
			{
				word: "eat",
				syllables: 1
			},
			{
				word: "eye",
				syllables: 1
			},
			{
				word: "fake",
				syllables: 1
			},
			{
				word: "fame",
				syllables: 1
			},
			{
				word: "fatigue",
				syllables: 2
			},
			{
				word: "femme",
				syllables: 1
			},
			{
				word: "force",
				syllables: 1
			},
			{
				word: "game",
				syllables: 1
			},
			{
				word: "games",
				syllables: 1
			},
			{
				word: "gate",
				syllables: 1
			},
			{
				word: "grande",
				syllables: 1
			},
			{
				word: "ice",
				syllables: 1
			},
			{
				word: "ion",
				syllables: 2
			},
			{
				word: "joke",
				syllables: 1
			},
			{
				word: "jupe",
				syllables: 1
			},
			{
				word: "maisch",
				syllables: 1
			},
			{
				word: "maische",
				syllables: 2
			},
			{
				word: "move",
				syllables: 1
			},
			{
				word: "native",
				syllables: 2
			},
			{
				word: "nice",
				syllables: 1
			},
			{
				word: "one",
				syllables: 1
			},
			{
				word: "pipe",
				syllables: 1
			},
			{
				word: "prime",
				syllables: 1
			},
			{
				word: "rate",
				syllables: 1
			},
			{
				word: "rhythm",
				syllables: 2
			},
			{
				word: "ride",
				syllables: 1
			},
			{
				word: "rides",
				syllables: 1
			},
			{
				word: "rien",
				syllables: 2
			},
			{
				word: "save",
				syllables: 1
			},
			{
				word: "science",
				syllables: 2
			},
			{
				word: "siècle",
				syllables: 1
			},
			{
				word: "site",
				syllables: 1
			},
			{
				word: "suite",
				syllables: 1
			},
			{
				word: "take",
				syllables: 1
			},
			{
				word: "taupe",
				syllables: 1
			},
			{
				word: "universe",
				syllables: 3
			},
			{
				word: "vogue",
				syllables: 1
			},
			{
				word: "wave",
				syllables: 1
			},
			{
				word: "zion",
				syllables: 2
			}
		],
		fragments: {
			global: [
				{
					word: "abreaktion",
					syllables: 4
				},
				{
					word: "adware",
					syllables: 2
				},
				{
					word: "affaire",
					syllables: 3
				},
				{
					word: "aiguière",
					syllables: 2
				},
				{
					word: "anisette",
					syllables: 3
				},
				{
					word: "appeal",
					syllables: 2
				},
				{
					word: "backstage",
					syllables: 2
				},
				{
					word: "bankrate",
					syllables: 2
				},
				{
					word: "baseball",
					syllables: 2
				},
				{
					word: "basejump",
					syllables: 2
				},
				{
					word: "beachcomber",
					syllables: 3
				},
				{
					word: "beachvolleyball",
					syllables: 4
				},
				{
					word: "beagle",
					syllables: 2
				},
				{
					word: "beamer",
					syllables: 2
				},
				{
					word: "beamer",
					syllables: 2
				},
				{
					word: "béarnaise",
					syllables: 3
				},
				{
					word: "beaufort",
					syllables: 2
				},
				{
					word: "beaujolais",
					syllables: 3
				},
				{
					word: "beauté",
					syllables: 2
				},
				{
					word: "beauty",
					syllables: 2
				},
				{
					word: "belgier",
					syllables: 3
				},
				{
					word: "bestien",
					syllables: 2
				},
				{
					word: "biskuit",
					syllables: 2
				},
				{
					word: "bleach",
					syllables: 1
				},
				{
					word: "blue",
					syllables: 1
				},
				{
					word: "board",
					syllables: 1
				},
				{
					word: "boat",
					syllables: 1
				},
				{
					word: "bodysuit",
					syllables: 3
				},
				{
					word: "bordelaise",
					syllables: 3
				},
				{
					word: "break",
					syllables: 1
				},
				{
					word: "build",
					syllables: 1
				},
				{
					word: "bureau",
					syllables: 2
				},
				{
					word: "business",
					syllables: 2
				},
				{
					word: "cabrio",
					syllables: 3
				},
				{
					word: "cabriolet",
					syllables: 4
				},
				{
					word: "cachesexe",
					syllables: 2
				},
				{
					word: "camaieu",
					syllables: 3
				},
				{
					word: "canyon",
					syllables: 2
				},
				{
					word: "case",
					syllables: 1
				},
				{
					word: "catsuit",
					syllables: 2
				},
				{
					word: "centime",
					syllables: 3
				},
				{
					word: "chaise",
					syllables: 2
				},
				{
					word: "champion",
					syllables: 2
				},
				{
					word: "championat",
					syllables: 3
				},
				{
					word: "chapiteau",
					syllables: 3
				},
				{
					word: "chateau",
					syllables: 2
				},
				{
					word: "château",
					syllables: 2
				},
				{
					word: "cheat",
					syllables: 1
				},
				{
					word: "cheese",
					syllables: 1
				},
				{
					word: "chihuahua",
					syllables: 3
				},
				{
					word: "choice",
					syllables: 1
				},
				{
					word: "circonflexe",
					syllables: 3
				},
				{
					word: "clean",
					syllables: 1
				},
				{
					word: "cloche",
					syllables: 1
				},
				{
					word: "close",
					syllables: 1
				},
				{
					word: "clothes",
					syllables: 1
				},
				{
					word: "commerce",
					syllables: 2
				},
				{
					word: "crime",
					syllables: 1
				},
				{
					word: "crossrate",
					syllables: 2
				},
				{
					word: "cuisine",
					syllables: 2
				},
				{
					word: "culotte",
					syllables: 2
				},
				{
					word: "death",
					syllables: 1
				},
				{
					word: "defense",
					syllables: 2
				},
				{
					word: "détente",
					syllables: 2
				},
				{
					word: "dread",
					syllables: 1
				},
				{
					word: "dream",
					syllables: 1
				},
				{
					word: "dresscode",
					syllables: 2
				},
				{
					word: "dungeon",
					syllables: 2
				},
				{
					word: "easy",
					syllables: 2
				},
				{
					word: "engagement",
					syllables: 3
				},
				{
					word: "entente",
					syllables: 2
				},
				{
					word: "eye-catcher",
					syllables: 3
				},
				{
					word: "eyecatcher",
					syllables: 3
				},
				{
					word: "eyeliner",
					syllables: 3
				},
				{
					word: "eyeword",
					syllables: 2
				},
				{
					word: "fashion",
					syllables: 2
				},
				{
					word: "feature",
					syllables: 2
				},
				{
					word: "ferien",
					syllables: 3
				},
				{
					word: "fineliner",
					syllables: 3
				},
				{
					word: "fisheye",
					syllables: 2
				},
				{
					word: "flake",
					syllables: 1
				},
				{
					word: "flambeau",
					syllables: 2
				},
				{
					word: "flatrate",
					syllables: 2
				},
				{
					word: "fleece",
					syllables: 1
				},
				{
					word: "fraîche",
					syllables: 1
				},
				{
					word: "freak",
					syllables: 1
				},
				{
					word: "frites",
					syllables: 1
				},
				{
					word: "future",
					syllables: 2
				},
				{
					word: "gaelic",
					syllables: 2
				},
				{
					word: "game-show",
					syllables: 2
				},
				{
					word: "gameboy",
					syllables: 2
				},
				{
					word: "gamepad",
					syllables: 2
				},
				{
					word: "gameplay",
					syllables: 2
				},
				{
					word: "gameport",
					syllables: 2
				},
				{
					word: "gameshow",
					syllables: 2
				},
				{
					word: "garigue",
					syllables: 2
				},
				{
					word: "garrigue",
					syllables: 2
				},
				{
					word: "gatefold",
					syllables: 2
				},
				{
					word: "gateway",
					syllables: 2
				},
				{
					word: "geflashed",
					syllables: 2
				},
				{
					word: "georgier",
					syllables: 4
				},
				{
					word: "goal",
					syllables: 1
				},
				{
					word: "grapefruit",
					syllables: 2
				},
				{
					word: "great",
					syllables: 1
				},
				{
					word: "groupware",
					syllables: 2
				},
				{
					word: "gueule",
					syllables: 1
				},
				{
					word: "guide",
					syllables: 1
				},
				{
					word: "guilloche",
					syllables: 2
				},
				{
					word: "gynäzeen",
					syllables: 4
				},
				{
					word: "gynözeen",
					syllables: 4
				},
				{
					word: "haircare",
					syllables: 2
				},
				{
					word: "hardcore",
					syllables: 2
				},
				{
					word: "hardware",
					syllables: 2
				},
				{
					word: "head",
					syllables: 1
				},
				{
					word: "hearing",
					syllables: 2
				},
				{
					word: "heart",
					syllables: 1
				},
				{
					word: "heavy",
					syllables: 2
				},
				{
					word: "hedge",
					syllables: 1
				},
				{
					word: "heroin",
					syllables: 3
				},
				{
					word: "inclusive",
					syllables: 3
				},
				{
					word: "initiative",
					syllables: 4
				},
				{
					word: "inside",
					syllables: 2
				},
				{
					word: "jaguar",
					syllables: 3
				},
				{
					word: "jalousette",
					syllables: 3
				},
				{
					word: "jeans",
					syllables: 1
				},
				{
					word: "jeunesse",
					syllables: 2
				},
				{
					word: "juice",
					syllables: 1
				},
				{
					word: "jukebox",
					syllables: 2
				},
				{
					word: "jumpsuit",
					syllables: 2
				},
				{
					word: "kanarien",
					syllables: 4
				},
				{
					word: "kapriole",
					syllables: 4
				},
				{
					word: "karosserielinie",
					syllables: 6
				},
				{
					word: "konopeen",
					syllables: 4
				},
				{
					word: "lacrosse",
					syllables: 2
				},
				{
					word: "laplace",
					syllables: 2
				},
				{
					word: "late-",
					syllables: 1
				},
				{
					word: "lead",
					syllables: 1
				},
				{
					word: "league",
					syllables: 1
				},
				{
					word: "learn",
					syllables: 1
				},
				{
					word: "légière",
					syllables: 2
				},
				{
					word: "lizenziat",
					syllables: 4
				},
				{
					word: "load",
					syllables: 1
				},
				{
					word: "lotterielos",
					syllables: 4
				},
				{
					word: "lounge",
					syllables: 1
				},
				{
					word: "lyzeen",
					syllables: 3
				},
				{
					word: "madame",
					syllables: 2
				},
				{
					word: "mademoiselle",
					syllables: 3
				},
				{
					word: "magier",
					syllables: 3
				},
				{
					word: "make-up",
					syllables: 2
				},
				{
					word: "malware",
					syllables: 2
				},
				{
					word: "management",
					syllables: 3
				},
				{
					word: "manteau",
					syllables: 2
				},
				{
					word: "mausoleen",
					syllables: 4
				},
				{
					word: "mauve",
					syllables: 1
				},
				{
					word: "medien",
					syllables: 3
				},
				{
					word: "mesdames",
					syllables: 2
				},
				{
					word: "mesopotamien",
					syllables: 6
				},
				{
					word: "milliarde",
					syllables: 3
				},
				{
					word: "missile",
					syllables: 2
				},
				{
					word: "miszellaneen",
					syllables: 5
				},
				{
					word: "mousse",
					syllables: 1
				},
				{
					word: "mousseline",
					syllables: 3
				},
				{
					word: "museen",
					syllables: 3
				},
				{
					word: "musette",
					syllables: 2
				},
				{
					word: "nahuatl",
					syllables: 2
				},
				{
					word: "noisette",
					syllables: 2
				},
				{
					word: "notebook",
					syllables: 2
				},
				{
					word: "nuance",
					syllables: 3
				},
				{
					word: "nuklease",
					syllables: 4
				},
				{
					word: "odeen",
					syllables: 3
				},
				{
					word: "offline",
					syllables: 2
				},
				{
					word: "offside",
					syllables: 2
				},
				{
					word: "oleaster",
					syllables: 4
				},
				{
					word: "on-stage",
					syllables: 2
				},
				{
					word: "online",
					syllables: 2
				},
				{
					word: "orpheen",
					syllables: 3
				},
				{
					word: "parforceritt",
					syllables: 3
				},
				{
					word: "patiens",
					syllables: 2
				},
				{
					word: "patient",
					syllables: 2
				},
				{
					word: "peace",
					syllables: 1
				},
				{
					word: "peace",
					syllables: 1
				},
				{
					word: "peanuts",
					syllables: 2
				},
				{
					word: "people",
					syllables: 2
				},
				{
					word: "perineen",
					syllables: 4
				},
				{
					word: "peritoneen",
					syllables: 5
				},
				{
					word: "picture",
					syllables: 2
				},
				{
					word: "piece",
					syllables: 1
				},
				{
					word: "pipeline",
					syllables: 2
				},
				{
					word: "plateau",
					syllables: 2
				},
				{
					word: "poesie",
					syllables: 3
				},
				{
					word: "poleposition",
					syllables: 4
				},
				{
					word: "portemanteau",
					syllables: 3
				},
				{
					word: "portemonnaie",
					syllables: 3
				},
				{
					word: "primerate",
					syllables: 2
				},
				{
					word: "primerate",
					syllables: 2
				},
				{
					word: "primetime",
					syllables: 2
				},
				{
					word: "protease",
					syllables: 4
				},
				{
					word: "protein",
					syllables: 3
				},
				{
					word: "prytaneen",
					syllables: 4
				},
				{
					word: "quotient",
					syllables: 2
				},
				{
					word: "radio",
					syllables: 3
				},
				{
					word: "reader",
					syllables: 2
				},
				{
					word: "ready",
					syllables: 2
				},
				{
					word: "reallife",
					syllables: 2
				},
				{
					word: "repeat",
					syllables: 2
				},
				{
					word: "retake",
					syllables: 2
				},
				{
					word: "rigole",
					syllables: 2
				},
				{
					word: "risolle",
					syllables: 2
				},
				{
					word: "road",
					syllables: 1
				},
				{
					word: "roaming",
					syllables: 2
				},
				{
					word: "roquefort",
					syllables: 2
				},
				{
					word: "safe",
					syllables: 1
				},
				{
					word: "savonette",
					syllables: 3
				},
				{
					word: "sciencefiction",
					syllables: 3
				},
				{
					word: "search",
					syllables: 1
				},
				{
					word: "selfmade",
					syllables: 2
				},
				{
					word: "septime",
					syllables: 3
				},
				{
					word: "serapeen",
					syllables: 4
				},
				{
					word: "service",
					syllables: 2
				},
				{
					word: "serviette",
					syllables: 2
				},
				{
					word: "share",
					syllables: 1
				},
				{
					word: "shave",
					syllables: 1
				},
				{
					word: "shore",
					syllables: 1
				},
				{
					word: "sidebar",
					syllables: 2
				},
				{
					word: "sideboard",
					syllables: 2
				},
				{
					word: "sidekick",
					syllables: 2
				},
				{
					word: "silhouette",
					syllables: 3
				},
				{
					word: "sitemap",
					syllables: 2
				},
				{
					word: "slide",
					syllables: 1
				},
				{
					word: "sneak",
					syllables: 1
				},
				{
					word: "soap",
					syllables: 1
				},
				{
					word: "softcore",
					syllables: 2
				},
				{
					word: "software",
					syllables: 2
				},
				{
					word: "soutanelle",
					syllables: 3
				},
				{
					word: "speak",
					syllables: 1
				},
				{
					word: "special",
					syllables: 2
				},
				{
					word: "spracheinstellung",
					syllables: 5
				},
				{
					word: "spyware",
					syllables: 2
				},
				{
					word: "square",
					syllables: 1
				},
				{
					word: "stagediving",
					syllables: 3
				},
				{
					word: "stakeholder",
					syllables: 3
				},
				{
					word: "statement",
					syllables: 2
				},
				{
					word: "steady",
					syllables: 2
				},
				{
					word: "steak",
					syllables: 1
				},
				{
					word: "stealth",
					syllables: 1
				},
				{
					word: "steam",
					syllables: 1
				},
				{
					word: "stoned",
					syllables: 1
				},
				{
					word: "stracciatella",
					syllables: 4
				},
				{
					word: "stream",
					syllables: 1
				},
				{
					word: "stride",
					syllables: 1
				},
				{
					word: "strike",
					syllables: 1
				},
				{
					word: "suitcase",
					syllables: 2
				},
				{
					word: "sweepstake",
					syllables: 2
				},
				{
					word: "t-bone",
					syllables: 2
				},
				{
					word: "t-shirt",
					syllables: 1
				},
				{
					word: "tailgate",
					syllables: 2
				},
				{
					word: "take-off",
					syllables: 2
				},
				{
					word: "take-over",
					syllables: 3
				},
				{
					word: "takeaway",
					syllables: 3
				},
				{
					word: "takeoff",
					syllables: 2
				},
				{
					word: "takeover",
					syllables: 3
				},
				{
					word: "throat",
					syllables: 1
				},
				{
					word: "time-out",
					syllables: 2
				},
				{
					word: "timelag",
					syllables: 2
				},
				{
					word: "timeline",
					syllables: 2
				},
				{
					word: "timesharing",
					syllables: 3
				},
				{
					word: "toast",
					syllables: 1
				},
				{
					word: "traubenmaische",
					syllables: 4
				},
				{
					word: "tristesse",
					syllables: 2
				},
				{
					word: "usenet",
					syllables: 2
				},
				{
					word: "varietät",
					syllables: 4
				},
				{
					word: "varieté",
					syllables: 4
				},
				{
					word: "vinaigrette",
					syllables: 3
				},
				{
					word: "vintage",
					syllables: 2
				},
				{
					word: "violett",
					syllables: 3
				},
				{
					word: "voice",
					syllables: 1
				},
				{
					word: "wakeboard",
					syllables: 2
				},
				{
					word: "washed",
					syllables: 1
				},
				{
					word: "waveboard",
					syllables: 2
				},
				{
					word: "wear",
					syllables: 1
				},
				{
					word: "wear",
					syllables: 1
				},
				{
					word: "website",
					syllables: 2
				},
				{
					word: "white",
					syllables: 1
				},
				{
					word: "widescreen",
					syllables: 2
				},
				{
					word: "wire",
					syllables: 1
				},
				{
					word: "yacht",
					syllables: 1
				},
				{
					word: "yorkshire",
					syllables: 2
				},
				{
					word: "éprouvette",
					syllables: 3,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "galette",
					syllables: 2,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "gigue",
					syllables: 1,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "groove",
					syllables: 1,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "morgue",
					syllables: 1,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "paillette",
					syllables: 2,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "raclette",
					syllables: 2,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "roulette",
					syllables: 2,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "spike",
					syllables: 1,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "style",
					syllables: 1,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "tablette",
					syllables: 2,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "grunge",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "size",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "value",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "quiche",
					syllables: 1,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "house",
					syllables: 1,
					notFollowedBy: [
						"n",
						"s"
					]
				},
				{
					word: "sauce",
					syllables: 1,
					notFollowedBy: [
						"n",
						"s"
					]
				},
				{
					word: "space",
					syllables: 1,
					notFollowedBy: [
						"n",
						"s"
					]
				},
				{
					word: "airline",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "autosave",
					syllables: 3,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "bagpipe",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "bike",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "dance",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "deadline",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "halfpipe",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "headline",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "home",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "hornpipe",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "hotline",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "infoline",
					syllables: 3,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "inline",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "kite",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "rollerblade",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "score",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "skyline",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "slackline",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "slice",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "snooze",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "storyline",
					syllables: 3,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "office",
					syllables: 2,
					notFollowedBy: [
						"s",
						"r"
					]
				},
				{
					word: "space",
					syllables: 1,
					notFollowedBy: [
						"n",
						"s",
						"r"
					]
				},
				{
					word: "tease",
					syllables: 1,
					notFollowedBy: [
						"n",
						"s",
						"r"
					]
				},
				{
					word: "cache",
					syllables: 1,
					notFollowedBy: [
						"t"
					]
				}
			],
			atBeginningOrEnd: [
				{
					word: "case",
					syllables: 1
				},
				{
					word: "life",
					syllables: 1
				},
				{
					word: "teak",
					syllables: 1
				},
				{
					word: "team",
					syllables: 1
				},
				{
					word: "creme",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "crème",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "drive",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "skate",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "update",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "upgrade",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				}
			],
			atBeginning: [
				{
					word: "anion",
					syllables: 3
				},
				{
					word: "facelift",
					syllables: 2
				},
				{
					word: "jiu",
					syllables: 1
				},
				{
					word: "pace",
					syllables: 1
				},
				{
					word: "shake",
					syllables: 1
				},
				{
					word: "tea",
					syllables: 1
				},
				{
					word: "trade",
					syllables: 1
				},
				{
					word: "deal",
					syllables: 1
				}
			],
			atEnd: [
				{
					word: "face",
					syllables: 1
				},
				{
					word: "file",
					syllables: 1
				},
				{
					word: "mousse",
					syllables: 1
				},
				{
					word: "plate",
					syllables: 1
				},
				{
					word: "tape",
					syllables: 1
				},
				{
					word: "byte",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "cape",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "five",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "hype",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "leak",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "like",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "make",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "phone",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "rave",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "regime",
					syllables: 2,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "statue",
					syllables: 2,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "store",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "wave",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "date",
					syllables: 1,
					notFollowedBy: [
						"n"
					]
				},
				{
					word: "image",
					syllables: 2,
					notFollowedBy: [
						"s"
					]
				}
			]
		}
	}
};
var require$$2 = {
	vowels: vowels$7,
	deviations: deviations$7
};

var vowels$6 = "aeiouy";
var deviations$6 = {
	vowels: [
		{
			fragments: [
				"cial",
				"tia",
				"cius",
				"giu",
				"ion",
				"[^bdnprv]iou",
				"sia$",
				"[^aeiuot]{2,}ed$",
				"[aeiouy][^aeiuoyts]{1,}e$",
				"[a-z]ely$",
				"[cgy]ed$",
				"rved$",
				"[aeiouy][dt]es?$",
				"eau",
				"ieu",
				"oeu",
				"[aeiouy][^aeiouydt]e[sd]?$",
				"[aeouy]rse$",
				"^eye"
			],
			countModifier: -1
		},
		{
			fragments: [
				"ia",
				"iu",
				"ii",
				"io",
				"[aeio][aeiou]{2}",
				"[aeiou]ing",
				"[^aeiou]ying",
				"ui[aeou]"
			],
			countModifier: 1
		},
		{
			fragments: [
				"^ree[jmnpqrsx]",
				"^reele",
				"^reeva",
				"riet",
				"dien",
				"[aeiouym][bdp]le$",
				"uei",
				"uou",
				"^mc",
				"ism$",
				"[^l]lien",
				"^coa[dglx].",
				"[^gqauieo]ua[^auieo]",
				"dn't$",
				"uity$",
				"ie(r|st)",
				"[aeiouw]y[aeiou]",
				"[^ao]ire[ds]",
				"[^ao]ire$"
			],
			countModifier: 1
		},
		{
			fragments: [
				"eoa",
				"eoo",
				"ioa",
				"ioe",
				"ioo"
			],
			countModifier: 1
		}
	],
	words: {
		full: [
			{
				word: "business",
				syllables: 2
			},
			{
				word: "coheiress",
				syllables: 3
			},
			{
				word: "colonel",
				syllables: 2
			},
			{
				word: "heiress",
				syllables: 2
			},
			{
				word: "i.e",
				syllables: 2
			},
			{
				word: "shoreline",
				syllables: 2
			},
			{
				word: "simile",
				syllables: 3
			},
			{
				word: "unheired",
				syllables: 2
			},
			{
				word: "wednesday",
				syllables: 2
			}
		],
		fragments: {
			global: [
				{
					word: "coyote",
					syllables: 3
				},
				{
					word: "graveyard",
					syllables: 2
				},
				{
					word: "lawyer",
					syllables: 2
				}
			]
		}
	}
};
var require$$3 = {
	vowels: vowels$6,
	deviations: deviations$6
};

var vowels$5 = "aáäâeéëêiíïîoóöôuúüûy";
var deviations$5 = {
	vowels: [
		{
			fragments: [
				"ue$",
				"dge$",
				"[tcp]iënt",
				"ace$",
				"[br]each",
				"[ainpr]tiaal",
				"[io]tiaan",
				"gua[yc]",
				"[^i]deal",
				"tive$",
				"load",
				"[^e]coke",
				"[^s]core$"
			],
			countModifier: -1
		},
		{
			fragments: [
				"aä",
				"aeu",
				"aie",
				"ao",
				"ë",
				"eo",
				"eú",
				"ieau",
				"ea$",
				"ea[^u]",
				"ei[ej]",
				"eu[iu]",
				"ï",
				"iei",
				"ienne",
				"[^l]ieu[^w]",
				"[^l]ieu$",
				"i[auiy]",
				"stion",
				"[^cstx]io",
				"^sion",
				"riè",
				"oö",
				"oa",
				"oeing",
				"oie",
				"[eu]ü",
				"[^q]u[aeèo]",
				"uie",
				"[bhnpr]ieel",
				"[bhnpr]iël"
			],
			countModifier: 1
		},
		{
			fragments: [
				"[aeolu]y[aeéèoóu]"
			],
			countModifier: 1
		}
	],
	words: {
		full: [
			{
				word: "bye",
				syllables: 1
			},
			{
				word: "core",
				syllables: 1
			},
			{
				word: "cure",
				syllables: 1
			},
			{
				word: "dei",
				syllables: 2
			},
			{
				word: "dope",
				syllables: 1
			},
			{
				word: "dude",
				syllables: 1
			},
			{
				word: "fake",
				syllables: 1
			},
			{
				word: "fame",
				syllables: 1
			},
			{
				word: "five",
				syllables: 1
			},
			{
				word: "hole",
				syllables: 1
			},
			{
				word: "least",
				syllables: 1
			},
			{
				word: "lone",
				syllables: 1
			},
			{
				word: "minute",
				syllables: 2
			},
			{
				word: "move",
				syllables: 1
			},
			{
				word: "nice",
				syllables: 1
			},
			{
				word: "one",
				syllables: 1
			},
			{
				word: "state",
				syllables: 1
			},
			{
				word: "surplace",
				syllables: 2
			},
			{
				word: "take",
				syllables: 1
			},
			{
				word: "trade",
				syllables: 1
			},
			{
				word: "wide",
				syllables: 1
			}
		],
		fragments: {
			global: [
				{
					word: "adieu",
					syllables: 2
				},
				{
					word: "airline",
					syllables: 2
				},
				{
					word: "airmiles",
					syllables: 2
				},
				{
					word: "alien",
					syllables: 3
				},
				{
					word: "ambient",
					syllables: 3
				},
				{
					word: "announcement",
					syllables: 3
				},
				{
					word: "appearance",
					syllables: 3
				},
				{
					word: "appeasement",
					syllables: 3
				},
				{
					word: "atheneum",
					syllables: 4
				},
				{
					word: "awesome",
					syllables: 2
				},
				{
					word: "baccalaurei",
					syllables: 5
				},
				{
					word: "baccalaureus",
					syllables: 5
				},
				{
					word: "baseball",
					syllables: 3
				},
				{
					word: "basejump",
					syllables: 2
				},
				{
					word: "banlieue",
					syllables: 3
				},
				{
					word: "bapao",
					syllables: 2
				},
				{
					word: "barbecue",
					syllables: 3
				},
				{
					word: "beamer",
					syllables: 2
				},
				{
					word: "beanie",
					syllables: 2
				},
				{
					word: "beat",
					syllables: 1
				},
				{
					word: "belle",
					syllables: 2
				},
				{
					word: "bête",
					syllables: 1
				},
				{
					word: "bingewatch",
					syllables: 2
				},
				{
					word: "blocnote",
					syllables: 2
				},
				{
					word: "blue",
					syllables: 1
				},
				{
					word: "board",
					syllables: 1
				},
				{
					word: "break",
					syllables: 1
				},
				{
					word: "broad",
					syllables: 1
				},
				{
					word: "bulls-eye",
					syllables: 2
				},
				{
					word: "business",
					syllables: 2
				},
				{
					word: "byebye",
					syllables: 2
				},
				{
					word: "cacao",
					syllables: 2
				},
				{
					word: "caesar",
					syllables: 2
				},
				{
					word: "camaieu",
					syllables: 3
				},
				{
					word: "caoutchouc",
					syllables: 2
				},
				{
					word: "carbolineum",
					syllables: 5
				},
				{
					word: "catchphrase",
					syllables: 1
				},
				{
					word: "carrier",
					syllables: 3
				},
				{
					word: "cheat",
					syllables: 1
				},
				{
					word: "cheese",
					syllables: 1
				},
				{
					word: "circonflexe",
					syllables: 3
				},
				{
					word: "clean",
					syllables: 1
				},
				{
					word: "cloak",
					syllables: 1
				},
				{
					word: "cobuying",
					syllables: 3
				},
				{
					word: "comeback",
					syllables: 2
				},
				{
					word: "comfortzone",
					syllables: 3
				},
				{
					word: "communiqué",
					syllables: 4
				},
				{
					word: "conopeum",
					syllables: 4
				},
				{
					word: "console",
					syllables: 2
				},
				{
					word: "corporate",
					syllables: 3
				},
				{
					word: "coûte",
					syllables: 1
				},
				{
					word: "creamer",
					syllables: 2
				},
				{
					word: "crime",
					syllables: 1
				},
				{
					word: "cruesli",
					syllables: 2
				},
				{
					word: "deadline",
					syllables: 2
				},
				{
					word: "deautoriseren",
					syllables: 6
				},
				{
					word: "deuce",
					syllables: 1
				},
				{
					word: "deum",
					syllables: 2
				},
				{
					word: "dirndl",
					syllables: 2
				},
				{
					word: "dread",
					syllables: 2
				},
				{
					word: "dreamteam",
					syllables: 2
				},
				{
					word: "drone",
					syllables: 1
				},
				{
					word: "enquête",
					syllables: 3
				},
				{
					word: "escape",
					syllables: 2
				},
				{
					word: "exposure",
					syllables: 3
				},
				{
					word: "extranei",
					syllables: 4
				},
				{
					word: "extraneus",
					syllables: 4
				},
				{
					word: "eyecatcher",
					syllables: 3
				},
				{
					word: "eyeliner",
					syllables: 3
				},
				{
					word: "eyeopener",
					syllables: 4
				},
				{
					word: "eyetracker",
					syllables: 3
				},
				{
					word: "eyetracking",
					syllables: 3
				},
				{
					word: "fairtrade",
					syllables: 2
				},
				{
					word: "fauteuil",
					syllables: 2
				},
				{
					word: "feature",
					syllables: 2
				},
				{
					word: "feuilletee",
					syllables: 3
				},
				{
					word: "feuilleton",
					syllables: 3
				},
				{
					word: "fisheye",
					syllables: 2
				},
				{
					word: "fineliner",
					syllables: 3
				},
				{
					word: "finetunen",
					syllables: 3
				},
				{
					word: "forehand",
					syllables: 2
				},
				{
					word: "freak",
					syllables: 1
				},
				{
					word: "fusioneren",
					syllables: 4
				},
				{
					word: "gayparade",
					syllables: 3
				},
				{
					word: "gaypride",
					syllables: 2
				},
				{
					word: "goal",
					syllables: 1
				},
				{
					word: "grapefruit",
					syllables: 2
				},
				{
					word: "gruyère",
					syllables: 3
				},
				{
					word: "guele",
					syllables: 1
				},
				{
					word: "guerrilla",
					syllables: 3
				},
				{
					word: "guest",
					syllables: 1
				},
				{
					word: "hardware",
					syllables: 2
				},
				{
					word: "haute",
					syllables: 1
				},
				{
					word: "healing",
					syllables: 2
				},
				{
					word: "heater",
					syllables: 2
				},
				{
					word: "heavy",
					syllables: 2
				},
				{
					word: "hoax",
					syllables: 1
				},
				{
					word: "hotline",
					syllables: 2
				},
				{
					word: "idee-fixe",
					syllables: 3
				},
				{
					word: "inclusive",
					syllables: 3
				},
				{
					word: "inline",
					syllables: 2
				},
				{
					word: "intake",
					syllables: 2
				},
				{
					word: "intensive",
					syllables: 3
				},
				{
					word: "jeans",
					syllables: 1
				},
				{
					word: "Jones",
					syllables: 1
				},
				{
					word: "jubileum",
					syllables: 4
				},
				{
					word: "kalfsribeye",
					syllables: 3
				},
				{
					word: "kraaiennest",
					syllables: 3
				},
				{
					word: "lastminute",
					syllables: 3
				},
				{
					word: "learning",
					syllables: 2
				},
				{
					word: "league",
					syllables: 1
				},
				{
					word: "line-up",
					syllables: 2
				},
				{
					word: "linoleum",
					syllables: 4
				},
				{
					word: "load",
					syllables: 1
				},
				{
					word: "loafer",
					syllables: 2
				},
				{
					word: "longread",
					syllables: 2
				},
				{
					word: "lookalike",
					syllables: 3
				},
				{
					word: "louis",
					syllables: 3
				},
				{
					word: "lyceum",
					syllables: 3
				},
				{
					word: "magazine",
					syllables: 3
				},
				{
					word: "mainstream",
					syllables: 2
				},
				{
					word: "make-over",
					syllables: 3
				},
				{
					word: "make-up",
					syllables: 2
				},
				{
					word: "malware",
					syllables: 2
				},
				{
					word: "marmoleum",
					syllables: 4
				},
				{
					word: "mausoleum",
					syllables: 4
				},
				{
					word: "medeauteur",
					syllables: 4
				},
				{
					word: "midlifecrisis",
					syllables: 4
				},
				{
					word: "migraineaura",
					syllables: 5
				},
				{
					word: "milkshake",
					syllables: 2
				},
				{
					word: "millefeuille",
					syllables: 4
				},
				{
					word: "mixed",
					syllables: 1
				},
				{
					word: "muesli",
					syllables: 2
				},
				{
					word: "museum",
					syllables: 3
				},
				{
					word: "must-have",
					syllables: 2
				},
				{
					word: "must-read",
					syllables: 2
				},
				{
					word: "notebook",
					syllables: 2
				},
				{
					word: "nonsense",
					syllables: 2
				},
				{
					word: "nowhere",
					syllables: 2
				},
				{
					word: "nurture",
					syllables: 2
				},
				{
					word: "offline",
					syllables: 2
				},
				{
					word: "oneliner",
					syllables: 3
				},
				{
					word: "onesie",
					syllables: 2
				},
				{
					word: "online",
					syllables: 2
				},
				{
					word: "opinion",
					syllables: 3
				},
				{
					word: "paella",
					syllables: 3
				},
				{
					word: "pacemaker",
					syllables: 3
				},
				{
					word: "panache",
					syllables: 2
				},
				{
					word: "papegaaienneus",
					syllables: 5
				},
				{
					word: "passe-partout",
					syllables: 3
				},
				{
					word: "peanuts",
					syllables: 2
				},
				{
					word: "perigeum",
					syllables: 4
				},
				{
					word: "perineum",
					syllables: 4
				},
				{
					word: "perpetuum",
					syllables: 4
				},
				{
					word: "petroleum",
					syllables: 4
				},
				{
					word: "phone",
					syllables: 3
				},
				{
					word: "picture",
					syllables: 2
				},
				{
					word: "placemat",
					syllables: 2
				},
				{
					word: "porte-manteau",
					syllables: 3
				},
				{
					word: "portefeuille",
					syllables: 4
				},
				{
					word: "presse-papier",
					syllables: 3
				},
				{
					word: "primetime",
					syllables: 2
				},
				{
					word: "queen",
					syllables: 1
				},
				{
					word: "questionnaire",
					syllables: 3
				},
				{
					word: "queue",
					syllables: 1
				},
				{
					word: "reader",
					syllables: 2
				},
				{
					word: "reality",
					syllables: 3
				},
				{
					word: "reallife",
					syllables: 2
				},
				{
					word: "remake",
					syllables: 2
				},
				{
					word: "repeat",
					syllables: 2
				},
				{
					word: "repertoire",
					syllables: 3
				},
				{
					word: "research",
					syllables: 2
				},
				{
					word: "reverence",
					syllables: 3
				},
				{
					word: "ribeye",
					syllables: 2
				},
				{
					word: "ringtone",
					syllables: 3
				},
				{
					word: "road",
					syllables: 1
				},
				{
					word: "roaming",
					syllables: 2
				},
				{
					word: "sciencefiction",
					syllables: 4
				},
				{
					word: "selfmade",
					syllables: 2
				},
				{
					word: "sidekick",
					syllables: 2
				},
				{
					word: "sightseeing",
					syllables: 3
				},
				{
					word: "skyline",
					syllables: 2
				},
				{
					word: "smile",
					syllables: 1
				},
				{
					word: "sneaky",
					syllables: 2
				},
				{
					word: "software",
					syllables: 2
				},
				{
					word: "sparerib",
					syllables: 2
				},
				{
					word: "speaker",
					syllables: 2
				},
				{
					word: "spread",
					syllables: 1
				},
				{
					word: "statement",
					syllables: 2
				},
				{
					word: "steak",
					syllables: 1
				},
				{
					word: "steeplechase",
					syllables: 3
				},
				{
					word: "stonewash",
					syllables: 2
				},
				{
					word: "store",
					syllables: 1
				},
				{
					word: "streaken",
					syllables: 2
				},
				{
					word: "stream",
					syllables: 1
				},
				{
					word: "streetware",
					syllables: 1
				},
				{
					word: "supersoaker",
					syllables: 4
				},
				{
					word: "surprise-party",
					syllables: 4
				},
				{
					word: "sweater",
					syllables: 2
				},
				{
					word: "teaser",
					syllables: 2
				},
				{
					word: "tenue",
					syllables: 2
				},
				{
					word: "template",
					syllables: 2
				},
				{
					word: "timeline",
					syllables: 2
				},
				{
					word: "tissue",
					syllables: 2
				},
				{
					word: "toast",
					syllables: 1
				},
				{
					word: "tête-à-tête",
					syllables: 3
				},
				{
					word: "typecast",
					syllables: 2
				},
				{
					word: "unique",
					syllables: 2
				},
				{
					word: "ureum",
					syllables: 3
				},
				{
					word: "vibe",
					syllables: 1
				},
				{
					word: "vieux",
					syllables: 1
				},
				{
					word: "ville",
					syllables: 1
				},
				{
					word: "vintage",
					syllables: 2
				},
				{
					word: "wandelyup",
					syllables: 3
				},
				{
					word: "wiseguy",
					syllables: 2
				},
				{
					word: "wake-up-call",
					syllables: 3
				},
				{
					word: "webcare",
					syllables: 2
				},
				{
					word: "winegum",
					syllables: 2
				},
				{
					word: "base",
					syllables: 1,
					notFollowedBy: [
						"e",
						"n",
						"r"
					]
				},
				{
					word: "game",
					syllables: 1,
					notFollowedBy: [
						"n",
						"l",
						"r"
					]
				},
				{
					word: "style",
					syllables: 1,
					notFollowedBy: [
						"n",
						"s"
					]
				},
				{
					word: "douche",
					syllables: 1,
					notFollowedBy: [
						"n",
						"s"
					]
				},
				{
					word: "space",
					syllables: 1,
					notFollowedBy: [
						"n",
						"s"
					]
				},
				{
					word: "striptease",
					syllables: 2,
					notFollowedBy: [
						"n",
						"s"
					]
				},
				{
					word: "jive",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "keynote",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "mountainbike",
					syllables: 3,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "face",
					syllables: 1,
					notFollowedBy: [
						"n",
						"t"
					]
				},
				{
					word: "challenge",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "cruise",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "house",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "dance",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "franchise",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "freelance",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "lease",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "linedance",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "lounge",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "merchandise",
					syllables: 3,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "performance",
					syllables: 3,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "release",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "resource",
					syllables: 2,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				},
				{
					word: "cache",
					syllables: 1,
					notFollowedBy: [
						"c",
						"l",
						"n",
						"t",
						"x"
					]
				},
				{
					word: "office",
					syllables: 2,
					notFollowedBy: [
						"r",
						"s"
					]
				},
				{
					word: "close",
					syllables: 1,
					notFollowedBy: [
						"r",
						"t"
					]
				}
			],
			atBeginningOrEnd: [
				{
					word: "byte",
					syllables: 1
				},
				{
					word: "cake",
					syllables: 1
				},
				{
					word: "care",
					syllables: 1
				},
				{
					word: "coach",
					syllables: 1
				},
				{
					word: "coat",
					syllables: 1
				},
				{
					word: "earl",
					syllables: 1
				},
				{
					word: "foam",
					syllables: 1
				},
				{
					word: "gate",
					syllables: 1
				},
				{
					word: "head",
					syllables: 1
				},
				{
					word: "home",
					syllables: 1
				},
				{
					word: "live",
					syllables: 1
				},
				{
					word: "safe",
					syllables: 1
				},
				{
					word: "site",
					syllables: 1
				},
				{
					word: "soap",
					syllables: 1
				},
				{
					word: "teak",
					syllables: 1
				},
				{
					word: "team",
					syllables: 1
				},
				{
					word: "wave",
					syllables: 1
				},
				{
					word: "brace",
					syllables: 1,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "case",
					syllables: 1,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "fleece",
					syllables: 1,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "service",
					syllables: 2,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "voice",
					syllables: 1,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "kite",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "skate",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "race",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r",
						"s"
					]
				}
			],
			atBeginning: [
				{
					word: "coke",
					syllables: 1
				},
				{
					word: "deal",
					syllables: 1
				},
				{
					word: "image",
					syllables: 2,
					notFollowedBy: [
						"s"
					]
				}
			],
			atEnd: [
				{
					word: "force",
					syllables: 1
				},
				{
					word: "tea",
					syllables: 1
				},
				{
					word: "time",
					syllables: 1
				},
				{
					word: "date",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "hype",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "quote",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "tape",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "upgrade",
					syllables: 2,
					alsoFollowedBy: [
						"s"
					]
				}
			]
		}
	}
};
var require$$4 = {
	vowels: vowels$5,
	deviations: deviations$5
};

var vowels$4 = "aeiouyàèéìîïòù";
var deviations$4 = {
	vowels: [
		{
			fragments: [
				"a[íúeo]",
				"e[íúao]",
				"o[íúaeè]",
				"í[aeo]",
				"ú[aeo]",
				"ai[aeou]",
				"àii",
				"aiì",
				"au[eé]",
				"ei[aàeèé]",
				"èia",
				"ia[èiì]",
				"iài",
				"oi[aàeèo]",
				"òia",
				"óio",
				"uí",
				"ui[aàó]",
				"ùio",
				"ouï",
				"coo[cmnpr]",
				"lcool",
				"coòf",
				"[aeuioìùèéàò]y[aeuioíìùèàó]",
				"ìa$",
				"èa$"
			],
			countModifier: 1
		},
		{
			fragments: [
				"aoi",
				"aoì",
				"ioe",
				"riae",
				"ïa$"
			],
			countModifier: 1
		}
	],
	words: {
		full: [
			{
				word: "via",
				syllables: 2
			},
			{
				word: "guaime",
				syllables: 3
			},
			{
				word: "guaina",
				syllables: 3
			},
			{
				word: "coke",
				syllables: 1
			},
			{
				word: "frame",
				syllables: 1
			},
			{
				word: "goal",
				syllables: 1
			},
			{
				word: "live",
				syllables: 1
			},
			{
				word: "mouse",
				syllables: 1
			},
			{
				word: "coon",
				syllables: 1
			}
		],
		fragments: {
			global: [
				{
					word: "mayoyào",
					syllables: 4
				},
				{
					word: "eye-liner",
					syllables: 3
				},
				{
					word: "scooner",
					syllables: 2
				},
				{
					word: "cocoon",
					syllables: 2
				},
				{
					word: "silhouette",
					syllables: 4
				},
				{
					word: "circuíto",
					syllables: 4
				},
				{
					word: "cruento",
					syllables: 3
				},
				{
					word: "cruènto",
					syllables: 3
				},
				{
					word: "rituale",
					syllables: 4
				},
				{
					word: "duello",
					syllables: 3
				},
				{
					word: "fuorviante",
					syllables: 4
				},
				{
					word: "league",
					syllables: 1
				},
				{
					word: "leader",
					syllables: 2
				},
				{
					word: "appeal",
					syllables: 2
				},
				{
					word: "backstage",
					syllables: 2
				},
				{
					word: "badge",
					syllables: 1
				},
				{
					word: "baseball",
					syllables: 2
				},
				{
					word: "beauty",
					syllables: 2
				},
				{
					word: "bondage",
					syllables: 2,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "break",
					syllables: 1
				},
				{
					word: "brokerage",
					syllables: 3
				},
				{
					word: "business",
					syllables: 2
				},
				{
					word: "cache",
					syllables: 2,
					notFollowedBy: [
						"s",
						"r"
					]
				},
				{
					word: "cashmere",
					syllables: 2
				},
				{
					word: "challenge",
					syllables: 2,
					notFollowedBy: [
						"s",
						"r"
					]
				},
				{
					word: "charleston",
					syllables: 2
				},
				{
					word: "cheap",
					syllables: 1
				},
				{
					word: "cottage",
					syllables: 2,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "cruise",
					syllables: 1,
					notFollowedBy: [
						"s",
						"r"
					]
				},
				{
					word: "device",
					syllables: 2,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "downgrade",
					syllables: 2,
					notFollowedBy: [
						"d"
					]
				},
				{
					word: "download",
					syllables: 2
				},
				{
					word: "drive",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "endorsement",
					syllables: 3
				},
				{
					word: "drive",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "executive",
					syllables: 4
				},
				{
					word: "firmware",
					syllables: 2
				},
				{
					word: "fobia",
					syllables: 3
				},
				{
					word: "float",
					syllables: 1
				},
				{
					word: "freak",
					syllables: 1
				},
				{
					word: "game",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "guideline",
					syllables: 2
				},
				{
					word: "hardware",
					syllables: 2
				},
				{
					word: "homeless",
					syllables: 2
				},
				{
					word: "hardware",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "hardware",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "hardware",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "hospice",
					syllables: 2,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "impeachment",
					syllables: 3
				},
				{
					word: "jeans",
					syllables: 1
				},
				{
					word: "jukebox",
					syllables: 2
				},
				{
					word: "leasing",
					syllables: 2
				},
				{
					word: "lease",
					syllables: 1,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "lounge",
					syllables: 1,
					notFollowedBy: [
						"r",
						"s"
					]
				},
				{
					word: "magazine",
					syllables: 3
				},
				{
					word: "notebook",
					syllables: 2
				},
				{
					word: "office",
					syllables: 2,
					notFollowedBy: [
						"r",
						"s"
					]
				},
				{
					word: "online",
					syllables: 2
				},
				{
					word: "offline",
					syllables: 2
				},
				{
					word: "overcoat",
					syllables: 3
				},
				{
					word: "offside",
					syllables: 2,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "overdrive",
					syllables: 3
				},
				{
					word: "oversize",
					syllables: 3
				},
				{
					word: "pacemaker",
					syllables: 3
				},
				{
					word: "package",
					syllables: 2,
					notFollowedBy: [
						"r",
						"s"
					]
				},
				{
					word: "pancake",
					syllables: 2
				},
				{
					word: "performance",
					syllables: 3
				},
				{
					word: "premium",
					syllables: 3
				},
				{
					word: "ragtime",
					syllables: 2
				},
				{
					word: "reading",
					syllables: 2
				},
				{
					word: "residence",
					syllables: 3,
					notFollowedBy: [
						"s"
					]
				},
				{
					word: "roaming",
					syllables: 2
				},
				{
					word: "rollerblade",
					syllables: 3,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "royalty",
					syllables: 3
				},
				{
					word: "shake",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "shale",
					syllables: 1
				},
				{
					word: "shampooing",
					syllables: 3
				},
				{
					word: "shareware",
					syllables: 2
				},
				{
					word: "shearling",
					syllables: 2
				},
				{
					word: "sidecar",
					syllables: 2
				},
				{
					word: "hardware",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "skate",
					syllables: 1,
					notFollowedBy: [
						"n",
						"r"
					]
				},
				{
					word: "trial",
					syllables: 2
				},
				{
					word: "toast",
					syllables: 1
				},
				{
					word: "texture",
					syllables: 2
				},
				{
					word: "testimonial",
					syllables: 5
				},
				{
					word: "teaser",
					syllables: 2
				},
				{
					word: "sweater",
					syllables: 2
				},
				{
					word: "suspense",
					syllables: 2,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "subroutine",
					syllables: 3
				},
				{
					word: "steadicam",
					syllables: 3
				},
				{
					word: "spread",
					syllables: 1
				},
				{
					word: "speaker",
					syllables: 2
				},
				{
					word: "board",
					syllables: 1
				},
				{
					word: "sneaker",
					syllables: 2
				},
				{
					word: "smartphone",
					syllables: 2
				},
				{
					word: "slide",
					syllables: 1,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "skyline",
					syllables: 2
				},
				{
					word: "skinhead",
					syllables: 2
				},
				{
					word: "update",
					syllables: 2,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "upgrade",
					syllables: 2,
					notFollowedBy: [
						"r"
					]
				},
				{
					word: "upload",
					syllables: 2
				},
				{
					word: "vintage",
					syllables: 2
				},
				{
					word: "wakeboard",
					syllables: 2
				},
				{
					word: "website",
					syllables: 2
				},
				{
					word: "welfare",
					syllables: 2
				},
				{
					word: "yeah",
					syllables: 1
				},
				{
					word: "yearling",
					syllables: 2
				}
			],
			atEnd: [
				{
					word: "byte",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "bite",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "beat",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				},
				{
					word: "coach",
					syllables: 1
				},
				{
					word: "line",
					syllables: 1,
					alsoFollowedBy: [
						"s"
					]
				}
			],
			atBeginning: [
				{
					word: "cheese",
					syllables: 1
				},
				{
					word: "head",
					syllables: 1
				},
				{
					word: "streak",
					syllables: 1
				}
			],
			atBeginningOrEnd: [
				{
					word: "team",
					syllables: 1
				},
				{
					word: "stream",
					syllables: 1
				}
			]
		}
	}
};
var require$$5 = {
	vowels: vowels$4,
	deviations: deviations$4
};

var vowels$3 = "аоиеёэыуюя";
var deviations$3 = {
	vowels: [
		{
			fragments: [
				"[аоиеёэыуюя][аоиеёэыуюя]"
			],
			countModifier: 1
		},
		{
			fragments: [
				"[аоиеёэыуюя][аоиеёэыуюя][аоиеёэыуюя]"
			],
			countModifier: 1
		}
	],
	words: {
		full: [
		],
		fragments: [
		]
	}
};
var require$$6 = {
	vowels: vowels$3,
	deviations: deviations$3
};

var vowels$2 = "aeiouyàâéèêëîïûüùôæœ";
var deviations$2 = {
	vowels: [
		{
			fragments: [
				"[ptf]aon(ne)?[s]?$"
			],
			countModifier: -1
		},
		{
			fragments: [
				"aoul",
				"[^eéiïou]e(s|nt)?$",
				"[qg]ue(s|nt)?$"
			],
			countModifier: -1
		},
		{
			fragments: [
				"o[ëaéèï]"
			],
			countModifier: 1
		},
		{
			fragments: [
				"a[eéèïüo]",
				"é[aâèéiîuo]",
				"ii[oe]",
				"[aeéuo]y[aâeéèoui]",
				"coe[^u]",
				"zoo",
				"coop",
				"coord",
				"poly[ae]",
				"[bcd]ry[oa]",
				"[bcdfgptv][rl](ou|u|i)[aéèouâ]",
				"ouez",
				"[blmnt]uio",
				"uoia",
				"ment$",
				"yua",
				"[bcdfgptv][rl](i|u|eu)e([ltz]|r[s]?$|n[^t])",
				"[^aeiuyàâéèêëîïûüùôæœqg]uie[rz]$"
			],
			countModifier: 1
		}
	],
	words: {
		full: [
			{
				word: "ok",
				syllables: 2
			},
			{
				word: "eyeliner",
				syllables: 3
			},
			{
				word: "coati",
				syllables: 3
			},
			{
				word: "que",
				syllables: 1
			},
			{
				word: "flouer",
				syllables: 2
			},
			{
				word: "relouer",
				syllables: 3
			},
			{
				word: "évaluons",
				syllables: 4
			},
			{
				word: "instituons",
				syllables: 4
			},
			{
				word: "atténuons",
				syllables: 4
			},
			{
				word: "remuons",
				syllables: 3
			},
			{
				word: "redestribuons",
				syllables: 5
			},
			{
				word: "suons",
				syllables: 2
			},
			{
				word: "reconstituons",
				syllables: 5
			},
			{
				word: "dent",
				syllables: 1
			},
			{
				word: "fréquent",
				syllables: 2
			},
			{
				word: "permanent",
				syllables: 3
			},
			{
				word: "mécontent",
				syllables: 3
			},
			{
				word: "grandiloquent",
				syllables: 4
			},
			{
				word: "continent",
				syllables: 3
			},
			{
				word: "occident",
				syllables: 3
			},
			{
				word: "référent",
				syllables: 3
			},
			{
				word: "indigent",
				syllables: 3
			},
			{
				word: "concurrent",
				syllables: 3
			},
			{
				word: "gent",
				syllables: 1
			},
			{
				word: "différent",
				syllables: 3
			},
			{
				word: "strident",
				syllables: 2
			},
			{
				word: "équivalent",
				syllables: 4
			},
			{
				word: "ardent",
				syllables: 2
			},
			{
				word: "impotent",
				syllables: 3
			},
			{
				word: "argent",
				syllables: 2
			},
			{
				word: "immanent",
				syllables: 3
			},
			{
				word: "indécent",
				syllables: 3
			},
			{
				word: "effluent",
				syllables: 3
			},
			{
				word: "agent",
				syllables: 2
			},
			{
				word: "dolent",
				syllables: 2
			},
			{
				word: "contingent",
				syllables: 3
			},
			{
				word: "impénitent",
				syllables: 4
			},
			{
				word: "adjacent",
				syllables: 3
			},
			{
				word: "incident",
				syllables: 3
			},
			{
				word: "content",
				syllables: 2
			},
			{
				word: "incontinent",
				syllables: 4
			},
			{
				word: "éloquent",
				syllables: 3
			},
			{
				word: "convent",
				syllables: 2
			},
			{
				word: "dissident",
				syllables: 3
			},
			{
				word: "innocent",
				syllables: 3
			},
			{
				word: "ventripotent",
				syllables: 4
			},
			{
				word: "convalescent",
				syllables: 4
			},
			{
				word: "accident",
				syllables: 3
			},
			{
				word: "récent",
				syllables: 2
			},
			{
				word: "absent",
				syllables: 2
			},
			{
				word: "décadent",
				syllables: 3
			},
			{
				word: "réticent",
				syllables: 3
			},
			{
				word: "évent",
				syllables: 2
			},
			{
				word: "souvent",
				syllables: 2
			},
			{
				word: "intelligent",
				syllables: 3
			},
			{
				word: "inhérent",
				syllables: 3
			},
			{
				word: "adolescent",
				syllables: 4
			},
			{
				word: "couvent",
				syllables: 2
			},
			{
				word: "cent",
				syllables: 1
			},
			{
				word: "urgent",
				syllables: 2
			},
			{
				word: "précédent",
				syllables: 3
			},
			{
				word: "imprudent",
				syllables: 3
			},
			{
				word: "torrent",
				syllables: 2
			},
			{
				word: "abstinent",
				syllables: 3
			},
			{
				word: "indifférent",
				syllables: 4
			},
			{
				word: "excédent",
				syllables: 3
			},
			{
				word: "déférent",
				syllables: 3
			},
			{
				word: "incandescent",
				syllables: 4
			},
			{
				word: "intermittent",
				syllables: 4
			},
			{
				word: "présent",
				syllables: 3
			},
			{
				word: "astringent",
				syllables: 3
			},
			{
				word: "trident",
				syllables: 2
			},
			{
				word: "impertinent",
				syllables: 4
			},
			{
				word: "détergent",
				syllables: 3
			},
			{
				word: "évident",
				syllables: 3
			},
			{
				word: "influent",
				syllables: 3
			},
			{
				word: "pertinent",
				syllables: 3
			},
			{
				word: "subséquent",
				syllables: 3
			},
			{
				word: "féculent",
				syllables: 3
			},
			{
				word: "déférent",
				syllables: 3
			},
			{
				word: "ambivalent",
				syllables: 4
			},
			{
				word: "omnipotent",
				syllables: 4
			},
			{
				word: "décent",
				syllables: 2
			},
			{
				word: "compétent",
				syllables: 3
			},
			{
				word: "adhérent",
				syllables: 3
			},
			{
				word: "afférent",
				syllables: 3
			},
			{
				word: "luminescent",
				syllables: 4
			},
			{
				word: "lent",
				syllables: 1
			},
			{
				word: "apparent",
				syllables: 3
			},
			{
				word: "effervescent",
				syllables: 4
			},
			{
				word: "parent",
				syllables: 2
			},
			{
				word: "pénitent",
				syllables: 3
			},
			{
				word: "fluorescent",
				syllables: 3
			},
			{
				word: "impudent",
				syllables: 3
			},
			{
				word: "diligent",
				syllables: 3
			},
			{
				word: "entregent",
				syllables: 3
			},
			{
				word: "flatulent",
				syllables: 3
			},
			{
				word: "serpent",
				syllables: 2
			},
			{
				word: "violent",
				syllables: 2
			},
			{
				word: "somnolent",
				syllables: 3
			},
			{
				word: "déliquescent",
				syllables: 4
			},
			{
				word: "proéminent",
				syllables: 4
			},
			{
				word: "résident",
				syllables: 3
			},
			{
				word: "putrescent",
				syllables: 3
			},
			{
				word: "talent",
				syllables: 2
			},
			{
				word: "spumescent",
				syllables: 3
			},
			{
				word: "tangent",
				syllables: 2
			},
			{
				word: "chiendent",
				syllables: 2
			},
			{
				word: "négligent",
				syllables: 3
			},
			{
				word: "antécédent",
				syllables: 4
			},
			{
				word: "régent",
				syllables: 2
			},
			{
				word: "polyvalent",
				syllables: 4
			},
			{
				word: "latent",
				syllables: 2
			},
			{
				word: "opulent",
				syllables: 3
			},
			{
				word: "arpent",
				syllables: 2
			},
			{
				word: "adent",
				syllables: 2
			},
			{
				word: "concupiscent",
				syllables: 4
			},
			{
				word: "sanguinolent",
				syllables: 4
			},
			{
				word: "opalescent",
				syllables: 4
			},
			{
				word: "prudent",
				syllables: 2
			},
			{
				word: "conséquent",
				syllables: 3
			},
			{
				word: "pourcent",
				syllables: 2
			},
			{
				word: "transparent",
				syllables: 3
			},
			{
				word: "sergent",
				syllables: 2
			},
			{
				word: "diligent",
				syllables: 3
			},
			{
				word: "inconséquent",
				syllables: 4
			},
			{
				word: "turbulent",
				syllables: 3
			},
			{
				word: "fervent",
				syllables: 2
			},
			{
				word: "truculent",
				syllables: 3
			},
			{
				word: "interférent",
				syllables: 4
			},
			{
				word: "confluent",
				syllables: 3
			},
			{
				word: "succulent",
				syllables: 3
			},
			{
				word: "purulent",
				syllables: 3
			},
			{
				word: "patent",
				syllables: 2
			},
			{
				word: "indulgent",
				syllables: 3
			},
			{
				word: "engoulevent",
				syllables: 4
			},
			{
				word: "auvent",
				syllables: 2
			},
			{
				word: "président",
				syllables: 3
			},
			{
				word: "confident",
				syllables: 3
			},
			{
				word: "incompétent",
				syllables: 4
			},
			{
				word: "accent",
				syllables: 2
			},
			{
				word: "arborescent",
				syllables: 4
			},
			{
				word: "contrevent",
				syllables: 3
			},
			{
				word: "cohérent",
				syllables: 3
			},
			{
				word: "relent",
				syllables: 2
			},
			{
				word: "insolent",
				syllables: 3
			},
			{
				word: "virulent",
				syllables: 3
			},
			{
				word: "rémanent",
				syllables: 3
			},
			{
				word: "vent",
				syllables: 1
			},
			{
				word: "turgescent",
				syllables: 3
			},
			{
				word: "incohérent",
				syllables: 4
			},
			{
				word: "malcontent",
				syllables: 3
			},
			{
				word: "lactescent",
				syllables: 3
			},
			{
				word: "inintelligent",
				syllables: 5
			},
			{
				word: "omniprésent",
				syllables: 4
			},
			{
				word: "récurrent",
				syllables: 3
			},
			{
				word: "covalent",
				syllables: 3
			},
			{
				word: "éminent",
				syllables: 3
			},
			{
				word: "onguent",
				syllables: 2
			},
			{
				word: "indolent",
				syllables: 3
			},
			{
				word: "event",
				syllables: 2
			},
			{
				word: "corpulent",
				syllables: 3
			},
			{
				word: "divergent",
				syllables: 3
			},
			{
				word: "excellent",
				syllables: 3
			},
			{
				word: "phosphorescent",
				syllables: 4
			},
			{
				word: "évanescent",
				syllables: 4
			},
			{
				word: "paravent",
				syllables: 3
			},
			{
				word: "avent",
				syllables: 2
			},
			{
				word: "iridescent",
				syllables: 4
			},
			{
				word: "prénomment",
				syllables: 2
			},
			{
				word: "consument",
				syllables: 2
			},
			{
				word: "dégomment",
				syllables: 2
			},
			{
				word: "enveniment",
				syllables: 3
			},
			{
				word: "proclament",
				syllables: 2
			},
			{
				word: "chôment",
				syllables: 1
			},
			{
				word: "infirment",
				syllables: 2
			},
			{
				word: "briment",
				syllables: 1
			},
			{
				word: "fument",
				syllables: 1
			},
			{
				word: "acclament",
				syllables: 2
			},
			{
				word: "referment",
				syllables: 2
			},
			{
				word: "impriment",
				syllables: 2
			},
			{
				word: "paument",
				syllables: 1
			},
			{
				word: "déciment",
				syllables: 2
			},
			{
				word: "accoutument",
				syllables: 3
			},
			{
				word: "essaiment",
				syllables: 2
			},
			{
				word: "ferment",
				syllables: 1
			},
			{
				word: "dépriment",
				syllables: 2
			},
			{
				word: "raniment",
				syllables: 2
			},
			{
				word: "programment",
				syllables: 2
			},
			{
				word: "fantasment",
				syllables: 2
			},
			{
				word: "animent",
				syllables: 2
			},
			{
				word: "affirment",
				syllables: 2
			},
			{
				word: "filment",
				syllables: 1
			},
			{
				word: "dament",
				syllables: 1
			},
			{
				word: "parsèment",
				syllables: 3
			},
			{
				word: "priment",
				syllables: 1
			},
			{
				word: "assomment",
				syllables: 2
			},
			{
				word: "rament",
				syllables: 1
			},
			{
				word: "pâment",
				syllables: 1
			},
			{
				word: "conforment",
				syllables: 2
			},
			{
				word: "embaument",
				syllables: 2
			},
			{
				word: "calment",
				syllables: 1
			},
			{
				word: "blasphèment",
				syllables: 2
			},
			{
				word: "désarment",
				syllables: 2
			},
			{
				word: "consomment",
				syllables: 2
			},
			{
				word: "griment",
				syllables: 1
			},
			{
				word: "abîment",
				syllables: 2
			},
			{
				word: "blâment",
				syllables: 1
			},
			{
				word: "endorment",
				syllables: 2
			},
			{
				word: "allument",
				syllables: 2
			},
			{
				word: "blâment",
				syllables: 1
			},
			{
				word: "confirment",
				syllables: 2
			},
			{
				word: "escriment",
				syllables: 2
			},
			{
				word: "trament",
				syllables: 1
			},
			{
				word: "hument",
				syllables: 1
			},
			{
				word: "surnomment",
				syllables: 2
			},
			{
				word: "écument",
				syllables: 2
			},
			{
				word: "triment",
				syllables: 1
			},
			{
				word: "estiment",
				syllables: 2
			},
			{
				word: "rallument",
				syllables: 2
			},
			{
				word: "enflamment",
				syllables: 2
			},
			{
				word: "riment",
				syllables: 1
			},
			{
				word: "plument",
				syllables: 1
			},
			{
				word: "suppriment",
				syllables: 2
			},
			{
				word: "gomment",
				syllables: 1
			},
			{
				word: "affament",
				syllables: 2
			},
			{
				word: "friment",
				syllables: 1
			},
			{
				word: "clament",
				syllables: 1
			},
			{
				word: "dorment",
				syllables: 1
			},
			{
				word: "dénomment",
				syllables: 2
			},
			{
				word: "entament",
				syllables: 2
			},
			{
				word: "arriment",
				syllables: 2
			},
			{
				word: "résument",
				syllables: 2
			},
			{
				word: "enrhument",
				syllables: 2
			},
			{
				word: "rendorment",
				syllables: 2
			},
			{
				word: "compriment",
				syllables: 2
			},
			{
				word: "aiment",
				syllables: 1
			},
			{
				word: "rythment",
				syllables: 1
			},
			{
				word: "périment",
				syllables: 2
			},
			{
				word: "réclament",
				syllables: 2
			},
			{
				word: "subliment",
				syllables: 2
			},
			{
				word: "brument",
				syllables: 1
			},
			{
				word: "embrument",
				syllables: 2
			},
			{
				word: "germent",
				syllables: 1
			},
			{
				word: "renferment",
				syllables: 2
			},
			{
				word: "sèment",
				syllables: 1
			},
			{
				word: "reforment",
				syllables: 2
			},
			{
				word: "liment",
				syllables: 1
			},
			{
				word: "cament",
				syllables: 1
			},
			{
				word: "parfument",
				syllables: 2
			},
			{
				word: "arment",
				syllables: 1
			},
			{
				word: "brament",
				syllables: 1
			},
			{
				word: "déforment",
				syllables: 2
			},
			{
				word: "assument",
				syllables: 2
			},
			{
				word: "crament",
				syllables: 1
			},
			{
				word: "exclament",
				syllables: 2
			},
			{
				word: "forment",
				syllables: 1
			},
			{
				word: "diffament",
				syllables: 2
			},
			{
				word: "somment",
				syllables: 1
			},
			{
				word: "oppriment",
				syllables: 2
			},
			{
				word: "miment",
				syllables: 1
			},
			{
				word: "enferment",
				syllables: 2
			},
			{
				word: "nomment",
				syllables: 1
			},
			{
				word: "reprogramment",
				syllables: 3
			},
			{
				word: "transforment",
				syllables: 2
			},
			{
				word: "expriment",
				syllables: 2
			},
			{
				word: "informent",
				syllables: 2
			},
			{
				word: "légitiment",
				syllables: 3
			},
			{
				word: "de",
				syllables: 1
			},
			{
				word: "le",
				syllables: 1
			},
			{
				word: "je",
				syllables: 1
			},
			{
				word: "te",
				syllables: 1
			},
			{
				word: "ce",
				syllables: 1
			},
			{
				word: "ne",
				syllables: 1
			},
			{
				word: "re",
				syllables: 1
			},
			{
				word: "me",
				syllables: 1
			},
			{
				word: "se",
				syllables: 1
			},
			{
				word: "ses",
				syllables: 1
			},
			{
				word: "mes",
				syllables: 1
			},
			{
				word: "mes",
				syllables: 1
			},
			{
				word: "ces",
				syllables: 1
			},
			{
				word: "des",
				syllables: 1
			},
			{
				word: "tes",
				syllables: 1
			},
			{
				word: "les",
				syllables: 1
			},
			{
				word: "oye",
				syllables: 1
			},
			{
				word: "es",
				syllables: 1
			},
			{
				word: "remerciâmes",
				syllables: 4
			},
			{
				word: "herniaires",
				syllables: 3
			},
			{
				word: "autopsiais",
				syllables: 4
			},
			{
				word: "août",
				syllables: 1
			}
		],
		fragments: {
			global: [
				{
					word: "business",
					syllables: 2
				},
				{
					word: "skate",
					syllables: 1
				},
				{
					word: "board",
					syllables: 1
				},
				{
					word: "coach",
					syllables: 1
				},
				{
					word: "roadster",
					syllables: 2
				},
				{
					word: "soap",
					syllables: 1
				},
				{
					word: "goal",
					syllables: 1
				},
				{
					word: "coaltar",
					syllables: 2
				},
				{
					word: "loader",
					syllables: 2
				},
				{
					word: "coat",
					syllables: 1
				},
				{
					word: "baseball",
					syllables: 2
				},
				{
					word: "foëne",
					syllables: 1
				},
				{
					word: "cacaoyer",
					syllables: 4
				},
				{
					word: "scoop",
					syllables: 1
				},
				{
					word: "zoom",
					syllables: 1
				},
				{
					word: "bazooka",
					syllables: 3
				},
				{
					word: "tatoueu",
					syllables: 3
				},
				{
					word: "cloueu",
					syllables: 2
				},
				{
					word: "déchouer",
					syllables: 2
				},
				{
					word: "écrouelles",
					syllables: 3
				},
				{
					word: "maestria",
					syllables: 3
				},
				{
					word: "maestro",
					syllables: 3
				},
				{
					word: "vitae",
					syllables: 3
				},
				{
					word: "paella",
					syllables: 3
				},
				{
					word: "vae",
					syllables: 2
				},
				{
					word: "thaï",
					syllables: 1
				},
				{
					word: "skaï",
					syllables: 1
				},
				{
					word: "masaï",
					syllables: 2
				},
				{
					word: "samouraï",
					syllables: 3
				},
				{
					word: "bonsaï",
					syllables: 2
				},
				{
					word: "bonzaï",
					syllables: 2
				},
				{
					word: "aïkido",
					syllables: 3
				},
				{
					word: "daïquiri",
					syllables: 3
				},
				{
					word: "pagaïe",
					syllables: 2
				},
				{
					word: "chiite",
					syllables: 2
				},
				{
					word: "pays",
					syllables: 2
				},
				{
					word: "antiaérien",
					syllables: 5
				},
				{
					word: "bleui",
					syllables: 2
				},
				{
					word: "remerciai",
					syllables: 4
				},
				{
					word: "monstrueu",
					syllables: 3
				},
				{
					word: "niakoué",
					syllables: 3
				},
				{
					word: "minoen",
					syllables: 3
				},
				{
					word: "groenlandais",
					syllables: 4
				},
				{
					word: "remerciant",
					syllables: 4
				},
				{
					word: "skiant",
					syllables: 2
				},
				{
					word: "ruade",
					syllables: 2
				},
				{
					word: "weltanschauung",
					syllables: 4
				}
			],
			atBeginning: [
				{
					word: "roast",
					syllables: 1
				},
				{
					word: "taï",
					syllables: 1
				}
			],
			atEnd: [
				{
					word: "écrouer",
					syllables: 3
				},
				{
					word: "clouer",
					syllables: 2
				}
			]
		}
	}
};
var require$$7 = {
	vowels: vowels$2,
	deviations: deviations$2
};

var vowels$1 = "aeiouáéíóúü";
var deviations$1 = {
	vowels: [
		{
			fragments: [
				"i[ií]",
				"[íú][aeo]",
				"o[aáeéíóú]",
				"uu",
				"flu[iea]",
				"ru[ie]",
				"eio",
				"eu[aá]",
				"oi[aó]",
				"[iu]ei",
				"ui[éu]",
				"^anti[aeoá]",
				"^zoo",
				"coo",
				"microo"
			],
			countModifier: 1
		},
		{
			fragments: [
				"[eéó][aáeéíoóú]"
			],
			countModifier: 1
		},
		{
			fragments: [
				"[aáü][aáeéiíoóú]",
				"eoi",
				"oeu",
				"[eu]au"
			],
			countModifier: 1
		}
	],
	words: {
		full: [
			{
				word: "scooter",
				syllables: 2
			},
			{
				word: "y",
				syllables: 1
			},
			{
				word: "beat",
				syllables: 1
			},
			{
				word: "via",
				syllables: 2
			},
			{
				word: "ok",
				syllables: 2
			}
		],
		fragments: {
			global: [
				{
					word: "business",
					syllables: 2
				},
				{
					word: "coach",
					syllables: 1
				},
				{
					word: "reggae",
					syllables: 2
				},
				{
					word: "mail",
					syllables: 1
				},
				{
					word: "airbag",
					syllables: 2
				},
				{
					word: "affaire",
					syllables: 2
				},
				{
					word: "training",
					syllables: 2
				},
				{
					word: "hawaian",
					syllables: 3
				},
				{
					word: "saharaui",
					syllables: 3
				},
				{
					word: "nouveau",
					syllables: 2
				},
				{
					word: "chapeau",
					syllables: 2
				},
				{
					word: "free",
					syllables: 1
				},
				{
					word: "green",
					syllables: 1
				},
				{
					word: "jeep",
					syllables: 1
				},
				{
					word: "toffee",
					syllables: 2
				},
				{
					word: "tweet",
					syllables: 1
				},
				{
					word: "tweed",
					syllables: 1
				},
				{
					word: "semiautomátic",
					syllables: 6
				},
				{
					word: "estadou",
					syllables: 4
				},
				{
					word: "broadway",
					syllables: 2
				},
				{
					word: "board",
					syllables: 1
				},
				{
					word: "load",
					syllables: 1
				},
				{
					word: "roaming",
					syllables: 2
				},
				{
					word: "heavy",
					syllables: 2
				},
				{
					word: "break",
					syllables: 1
				}
			]
		}
	}
};
var require$$8 = {
	vowels: vowels$1,
	deviations: deviations$1
};

var vowels = "aeiouáéíóúàâêôãõü";
var deviations = {
	vowels: [
		{
			fragments: [
				"(gu|qu)[aeoáéíóúêã]"
			],
			countModifier: -1
		},
		{
			fragments: [
				"[^(g|q|a)][aeiou][aeo]$"
			],
			countModifier: -1
		},
		{
			fragments: [
				"[aeiouáéíóúàâêôü][aeo]",
				"[aeiou][íúáéóãê]"
			],
			countModifier: 1
		},
		{
			fragments: [
				"aí[ae]"
			],
			countModifier: 1
		}
	],
	words: {
		full: [
			{
				word: "delegacia",
				syllables: 5
			},
			{
				word: "democracia",
				syllables: 5
			},
			{
				word: "parceria",
				syllables: 4
			},
			{
				word: "secretaria",
				syllables: 5
			}
		],
		fragments: [
		]
	}
};
var require$$9 = {
	vowels: vowels,
	deviations: deviations
};

Object.defineProperty(syllables, "__esModule", {
	value: true
});

syllables.default = function (locale = "en_US") {
	let language = (0, _getLanguage2$c.default)(locale);

	if (languages.hasOwnProperty(language)) {
		return languages[language];
	}

	// If an unknown locale is used, default to English.
	return languages["en"];
};

var _getLanguage$c = getLanguage;

var _getLanguage2$c = _interopRequireDefault$1v(_getLanguage$c);

var _de = require$$2;

var _de2 = _interopRequireDefault$1v(_de);

var _en = require$$3;

var _en2 = _interopRequireDefault$1v(_en);

var _nl = require$$4;

var _nl2 = _interopRequireDefault$1v(_nl);

var _it$1 = require$$5;

var _it2$1 = _interopRequireDefault$1v(_it$1);

var _ru$1 = require$$6;

var _ru2$1 = _interopRequireDefault$1v(_ru$1);

var _fr = require$$7;

var _fr2 = _interopRequireDefault$1v(_fr);

var _es$1 = require$$8;

var _es2$1 = _interopRequireDefault$1v(_es$1);

var _pt$1 = require$$9;

var _pt2$1 = _interopRequireDefault$1v(_pt$1);

function _interopRequireDefault$1v(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module config/syllables */

let languages = { de: _de2.default, nl: _nl2.default, en: _en2.default, it: _it2$1.default, ru: _ru2$1.default, fr: _fr2.default, es: _es2$1.default, pt: _pt2$1.default };

var syllableCountIterator = {};

var syllableCountStep = {};

Object.defineProperty(syllableCountStep, "__esModule", {
  value: true
});

var _lodashEs$10 = require$$1$1;

var _createRegexFromArray$4 = createRegexFromArray;

var _createRegexFromArray2$4 = _interopRequireDefault$1u(_createRegexFromArray$4);

function _interopRequireDefault$1u(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Constructs a language syllable regex that contains a regex for matching syllable exclusion.
 *
 * @param {object} syllableRegex The object containing the syllable exclusions.
 * @constructor
 */
var SyllableCountStep = function SyllableCountStep(syllableRegex) {
  this._hasRegex = false;
  this._regex = "";
  this._multiplier = "";
  this.createRegex(syllableRegex);
};

/**
 * Returns if a valid regex has been set.
 *
 * @returns {boolean} True if a regex has been set, false if not.
 */
SyllableCountStep.prototype.hasRegex = function () {
  return this._hasRegex;
};

/**
 * Creates a regex based on the given syllable exclusions, and sets the multiplier to use.
 *
 * @param {object} syllableRegex The object containing the syllable exclusions and multiplier.
 * @returns {void}
 */
SyllableCountStep.prototype.createRegex = function (syllableRegex) {
  if (!(0, _lodashEs$10.isUndefined)(syllableRegex) && !(0, _lodashEs$10.isUndefined)(syllableRegex.fragments)) {
    this._hasRegex = true;
    this._regex = (0, _createRegexFromArray2$4.default)(syllableRegex.fragments, true);
    this._multiplier = syllableRegex.countModifier;
  }
};

/**
 * Returns the stored regular expression.
 *
 * @returns {RegExp} The stored regular expression.
 */
SyllableCountStep.prototype.getRegex = function () {
  return this._regex;
};

/**
 * Matches syllable exclusions in a given word and the returns the number found multiplied with the
 * given multiplier.
 *
 * @param {String} word The word to match for syllable exclusions.
 * @returns {number} The amount of syllables found.
 */
SyllableCountStep.prototype.countSyllables = function (word) {
  if (this._hasRegex) {
    var match = word.match(this._regex) || [];
    return match.length * this._multiplier;
  }
  return 0;
};

syllableCountStep.default = SyllableCountStep;

Object.defineProperty(syllableCountIterator, "__esModule", {
  value: true
});

var _syllableCountStep = syllableCountStep;

var _syllableCountStep2 = _interopRequireDefault$1t(_syllableCountStep);

var _lodashEs$$ = require$$1$1;

function _interopRequireDefault$1t(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a syllable count iterator.
 *
 * @param {object} config The config object containing an array with syllable exclusions.
 * @constructor
 */
var SyllableCountIterator = function SyllableCountIterator(config) {
  this.countSteps = [];
  if (!(0, _lodashEs$$.isUndefined)(config)) {
    this.createSyllableCountSteps(config.deviations.vowels);
  }
};

/**
 * Creates a syllable count step object for each exclusion.
 *
 * @param {object} syllableCounts The object containing all exclusion syllables including the multipliers.
 * @returns {void}
 */
SyllableCountIterator.prototype.createSyllableCountSteps = function (syllableCounts) {
  (0, _lodashEs$$.forEach)(syllableCounts, function (syllableCountStep) {
    this.countSteps.push(new _syllableCountStep2.default(syllableCountStep));
  }.bind(this));
};

/**
 * Returns all available count steps.
 *
 * @returns {Array} All available count steps.
 */
SyllableCountIterator.prototype.getAvailableSyllableCountSteps = function () {
  return this.countSteps;
};

/**
 * Counts the syllables for all the steps and returns the total syllable count.
 *
 * @param {String} word The word to count syllables in.
 * @returns {number} The number of syllables found based on exclusions.
 */
SyllableCountIterator.prototype.countSyllables = function (word) {
  var syllableCount = 0;
  (0, _lodashEs$$.forEach)(this.countSteps, function (step) {
    syllableCount += step.countSyllables(word);
  });
  return syllableCount;
};

syllableCountIterator.default = SyllableCountIterator;

var DeviationFragment$1 = {};

Object.defineProperty(DeviationFragment$1, "__esModule", {
	value: true
});

var _lodashEs$_ = require$$1$1;

/**
 * Represents a partial deviation when counting syllables
 *
 * @param {Object} options Extra options about how to match this fragment.
 * @param {string} options.location The location in the word where this deviation can occur.
 * @param {string} options.word The actual string that should be counted differently.
 * @param {number} options.syllables The amount of syllables this fragment has.
 * @param {string[]} [options.notFollowedBy] A list of characters that this fragment shouldn't be followed with.
 * @param {string[]} [options.alsoFollowedBy] A list of characters that this fragment could be followed with.
 *
 * @constructor
 */
function DeviationFragment(options) {
	this._location = options.location;
	this._fragment = options.word;
	this._syllables = options.syllables;
	this._regex = null;

	this._options = (0, _lodashEs$_.pick)(options, ["notFollowedBy", "alsoFollowedBy"]);
}

/**
 * Creates a regex that matches this fragment inside a word.
 *
 * @returns {void}
 */
DeviationFragment.prototype.createRegex = function () {
	var regexString = "";
	var options = this._options;

	var fragment = this._fragment;

	if (!(0, _lodashEs$_.isUndefined)(options.notFollowedBy)) {
		fragment += "(?![" + options.notFollowedBy.join("") + "])";
	}

	if (!(0, _lodashEs$_.isUndefined)(options.alsoFollowedBy)) {
		fragment += "[" + options.alsoFollowedBy.join("") + "]?";
	}

	switch (this._location) {
		case "atBeginning":
			regexString = "^" + fragment;
			break;

		case "atEnd":
			regexString = fragment + "$";
			break;

		case "atBeginningOrEnd":
			regexString = "(^" + fragment + ")|(" + fragment + "$)";
			break;

		default:
			regexString = fragment;
			break;
	}

	this._regex = new RegExp(regexString);
};

/**
 * Returns the regex that matches this fragment inside a word.
 *
 * @returns {RegExp} The regexp that matches this fragment.
 */
DeviationFragment.prototype.getRegex = function () {
	if (null === this._regex) {
		this.createRegex();
	}

	return this._regex;
};

/**
 * Returns whether or not this fragment occurs in a word.
 *
 * @param {string} word The word to match the fragment in.
 * @returns {boolean} Whether or not this fragment occurs in a word.
 */
DeviationFragment.prototype.occursIn = function (word) {
	var regex = this.getRegex();

	return regex.test(word);
};

/**
 * Removes this fragment from the given word.
 *
 * @param {string} word The word to remove this fragment from.
 * @returns {string} The modified word.
 */
DeviationFragment.prototype.removeFrom = function (word) {
	// Replace by a space to keep the remaining parts separated.
	return word.replace(this._fragment, " ");
};

/**
 * Returns the amount of syllables for this fragment.
 *
 * @returns {number} The amount of syllables for this fragment.
 */
DeviationFragment.prototype.getSyllables = function () {
	return this._syllables;
};

DeviationFragment$1.default = DeviationFragment;

Object.defineProperty(count, "__esModule", {
	value: true
});

var _syllables = syllables;

var _syllables2 = _interopRequireDefault$1s(_syllables);

var _getWords$c = getWords;

var _getWords2$c = _interopRequireDefault$1s(_getWords$c);

var _lodashEs$Z = require$$1$1;

var _syllableCountIterator = syllableCountIterator;

var _syllableCountIterator2 = _interopRequireDefault$1s(_syllableCountIterator);

var _DeviationFragment = DeviationFragment$1;

var _DeviationFragment2 = _interopRequireDefault$1s(_DeviationFragment);

function _interopRequireDefault$1s(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Counts vowel groups inside a word.
 *
 * @param {string} word A text with words to count syllables.
 * @param {String} locale The locale to use for counting syllables.
 * @returns {number} the syllable count.
 */
/** @module stringProcessing/countSyllables */

var countVowelGroups = function countVowelGroups(word, locale) {
	var numberOfSyllables = 0;
	var vowelRegex = new RegExp("[^" + (0, _syllables2.default)(locale).vowels + "]", "ig");
	var foundVowels = word.split(vowelRegex);
	var filteredWords = (0, _lodashEs$Z.filter)(foundVowels, function (vowel) {
		return vowel !== "";
	});
	numberOfSyllables += filteredWords.length;

	return numberOfSyllables;
};

/**
 * Counts the syllables using vowel exclusions. These are used for groups of vowels that are more or less
 * than 1 syllable.
 *
 * @param {String} word The word to count syllables of.
 * @param {String} locale The locale to use for counting syllables.
 * @returns {number} The number of syllables found in the given word.
 */
var countVowelDeviations = function countVowelDeviations(word, locale) {
	var syllableCountIterator = new _syllableCountIterator2.default((0, _syllables2.default)(locale));
	return syllableCountIterator.countSyllables(word);
};

/**
 * Returns the number of syllables for the word if it is in the list of full word deviations.
 *
 * @param {String} word The word to retrieve the syllables for.
 * @param {String} locale The locale to use for counting syllables.
 * @returns {number} The number of syllables found.
 */
var countFullWordDeviations = function countFullWordDeviations(word, locale) {
	var fullWordDeviations = (0, _syllables2.default)(locale).deviations.words.full;

	var deviation = (0, _lodashEs$Z.find)(fullWordDeviations, function (fullWordDeviation) {
		return fullWordDeviation.word === word;
	});

	if (!(0, _lodashEs$Z.isUndefined)(deviation)) {
		return deviation.syllables;
	}

	return 0;
};

/**
 * Creates an array of deviation fragments for a certain locale.
 *
 * @param {Object} syllableConfig Syllable config for a certain locale.
 * @returns {DeviationFragment[]} A list of deviation fragments
 */
function createDeviationFragments(syllableConfig) {
	var deviationFragments = [];

	var deviations = syllableConfig.deviations;

	if (!(0, _lodashEs$Z.isUndefined)(deviations.words) && !(0, _lodashEs$Z.isUndefined)(deviations.words.fragments)) {
		deviationFragments = (0, _lodashEs$Z.flatMap)(deviations.words.fragments, function (fragments, fragmentLocation) {
			return (0, _lodashEs$Z.map)(fragments, function (fragment) {
				fragment.location = fragmentLocation;

				return new _DeviationFragment2.default(fragment);
			});
		});
	}

	return deviationFragments;
}

var createDeviationFragmentsMemoized = (0, _lodashEs$Z.memoize)(createDeviationFragments);

/**
 * Counts syllables in partial exclusions. If these are found, returns the number of syllables  found, and the modified word.
 * The word is modified so the excluded part isn't counted by the normal syllable counter.
 *
 * @param {String} word The word to count syllables of.
 * @param {String} locale The locale to use for counting syllables.
 * @returns {object} The number of syllables found and the modified word.
 */
var countPartialWordDeviations = function countPartialWordDeviations(word, locale) {
	var deviationFragments = createDeviationFragmentsMemoized((0, _syllables2.default)(locale));
	var remainingParts = word;
	var syllableCount = 0;

	(0, _lodashEs$Z.forEach)(deviationFragments, function (deviationFragment) {
		if (deviationFragment.occursIn(remainingParts)) {
			remainingParts = deviationFragment.removeFrom(remainingParts);
			syllableCount += deviationFragment.getSyllables();
		}
	});

	return { word: remainingParts, syllableCount: syllableCount };
};

/**
 * Count the number of syllables in a word, using vowels and exceptions.
 *
 * @param {String} word The word to count the number of syllables of.
 * @param {String} locale The locale to use for counting syllables.
 * @returns {number} The number of syllables found in a word.
 */
var countUsingVowels = function countUsingVowels(word, locale) {
	var syllableCount = 0;

	syllableCount += countVowelGroups(word, locale);
	syllableCount += countVowelDeviations(word, locale);

	return syllableCount;
};

/**
 * Counts the number of syllables in a word.
 *
 * @param {string} word The word to count syllables of.
 * @param {string} locale The locale of the word.
 * @returns {number} The syllable count for the word.
 */
var countSyllablesInWord = function countSyllablesInWord(word, locale) {
	var syllableCount = 0;

	var fullWordExclusion = countFullWordDeviations(word, locale);
	if (fullWordExclusion !== 0) {
		return fullWordExclusion;
	}

	var partialExclusions = countPartialWordDeviations(word, locale);
	word = partialExclusions.word;
	syllableCount += partialExclusions.syllableCount;
	syllableCount += countUsingVowels(word, locale);

	return syllableCount;
};

/**
 * Counts the number of syllables in a text per word based on vowels.
 * Uses exclusion words for words that cannot be matched with vowel matching.
 *
 * @param {String} text The text to count the syllables of.
 * @param {String} locale The locale to use for counting syllables.
 * @returns {int} The total number of syllables found in the text.
 */
var countSyllablesInText = function countSyllablesInText(text, locale) {
	text = text.toLocaleLowerCase();
	var words = (0, _getWords2$c.default)(text);

	var syllableCounts = (0, _lodashEs$Z.map)(words, function (word) {
		return countSyllablesInWord(word, locale);
	});

	return (0, _lodashEs$Z.sum)(syllableCounts);
};

count.default = countSyllablesInText;

Object.defineProperty(calculateFleschReading, "__esModule", {
	value: true
});

calculateFleschReading.default = function (paper) {
	let score;
	let text = paper.getText();
	const locale = paper.getLocale();
	const language = (0, _getLanguage2$b.default)(locale);
	if (text === "") {
		return 0;
	}

	text = (0, _stripNumbers2.default)(text);

	const numberOfSentences = (0, _countSentences2.default)(text);

	const numberOfWords = (0, _countWords2$6.default)(text);

	// Prevent division by zero errors.
	if (numberOfSentences === 0 || numberOfWords === 0) {
		return 0;
	}

	const numberOfSyllables = (0, _count2$1.default)(text, locale);
	const averageWordsPerSentence = getAverage(numberOfWords, numberOfSentences);
	const syllablesPer100Words = numberOfSyllables * (100 / numberOfWords);

	switch (language) {
		case "nl":
			score = 206.84 - 0.77 * syllablesPer100Words - 0.93 * averageWordsPerSentence;
			break;
		case "de":
			score = 180 - averageWordsPerSentence - 58.5 * numberOfSyllables / numberOfWords;
			break;
		case "it":
			score = 217 - 1.3 * averageWordsPerSentence - 0.6 * syllablesPer100Words;
			break;
		case "ru":
			score = 206.835 - 1.3 * numberOfWords / numberOfSentences - 60.1 * numberOfSyllables / numberOfWords;
			break;

		case "es":
			score = 206.84 - 1.02 * numberOfWords / numberOfSentences - 0.6 * syllablesPer100Words;
			break;

		case "fr":
			score = 207 - 1.015 * numberOfWords / numberOfSentences - 73.6 * numberOfSyllables / numberOfWords;
			break;

		case "pt":
			score = 248.835 - 1.015 * averageWordsPerSentence - 84.6 * numberOfSyllables / numberOfWords;
			break;

		case "en":
		default:
			score = 206.835 - 1.015 * averageWordsPerSentence - 84.6 * (numberOfSyllables / numberOfWords);
			break;
	}

	return (0, _formatNumber2.default)(score);
};

var _stripNumbers = stripNumbers;

var _stripNumbers2 = _interopRequireDefault$1r(_stripNumbers);

var _countSentences = countSentences;

var _countSentences2 = _interopRequireDefault$1r(_countSentences);

var _countWords$6 = countWords;

var _countWords2$6 = _interopRequireDefault$1r(_countWords$6);

var _count$1 = count;

var _count2$1 = _interopRequireDefault$1r(_count$1);

var _formatNumber = formatNumber;

var _formatNumber2 = _interopRequireDefault$1r(_formatNumber);

var _getLanguage$b = getLanguage;

var _getLanguage2$b = _interopRequireDefault$1r(_getLanguage$b);

function _interopRequireDefault$1r(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Calculates an average from a total and an amount
 *
 * @param {number} total The total.
 * @param {number} amount The amount.
 * @returns {number} The average from the total and the amount.
 */
/** @module analyses/calculateFleschReading */

const getAverage = function getAverage(total, amount) {
	return total / amount;
};

var metaDescriptionLength = {};

Object.defineProperty(metaDescriptionLength, "__esModule", {
  value: true
});

metaDescriptionLength.default = function (paper) {
  return paper.getDescription().length;
};

var imageCountInText = {};

Object.defineProperty(imageCountInText, "__esModule", {
  value: true
});

imageCountInText.default = function (paper) {
  return (0, _imageInText2$3.default)(paper.getText()).length;
};

var _imageInText$3 = imageInText;

var _imageInText2$3 = _interopRequireDefault$1q(_imageInText$3);

function _interopRequireDefault$1q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageAltTags = {};

var getAlttagContent = {};

Object.defineProperty(getAlttagContent, "__esModule", {
	value: true
});

getAlttagContent.default = function (text) {
	var alt = "";

	var matches = text.match(regexAltTag);

	if (matches !== null) {
		alt = (0, _stripSpaces2$6.default)(matches[2]);

		alt = alt.replace(/&quot;/g, "\"");
		alt = alt.replace(/&#039;/g, "'");
	}
	return alt;
};

var _stripSpaces$6 = stripSpaces;

var _stripSpaces2$6 = _interopRequireDefault$1p(_stripSpaces$6);

function _interopRequireDefault$1p(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var regexAltTag = /alt=(['"])(.*?)\1/i;

Object.defineProperty(imageAltTags, "__esModule", {
	value: true
});

imageAltTags.default = function (paper, researcher) {
	const topicForms = researcher.getResearch("morphology");

	return matchAltProperties((0, _imageInText2$2.default)(paper.getText()), topicForms, paper.getLocale());
};

var _imageInText$2 = imageInText;

var _imageInText2$2 = _interopRequireDefault$1o(_imageInText$2);

var _getAlttagContent$1 = getAlttagContent;

var _getAlttagContent2$1 = _interopRequireDefault$1o(_getAlttagContent$1);

var _findKeywordFormsInString$3 = findKeywordFormsInString;

var _lodashEs$Y = require$$1$1;

function _interopRequireDefault$1o(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Matches the alt-tags in the images found in the text.
 * Returns an object with the totals and different alt-tags.
 *
 * @param {Array} imageMatches Array with all the matched images in the text
 * @param {Object} topicForms The object with the keyphrase and the synonyms forms from the paper.
 * @param {string} locale The locale used for transliteration.
 * @returns {object} altProperties Object with all alt-tags that were found.
 */
/** @module researches/imageAltTags */

const matchAltProperties = function matchAltProperties(imageMatches, topicForms, locale) {
	const altProperties = {
		noAlt: 0,
		withAlt: 0,
		withAltKeyword: 0,
		withAltNonKeyword: 0
	};

	for (let i = 0; i < imageMatches.length; i++) {
		const alttag = (0, _getAlttagContent2$1.default)(imageMatches[i]);

		// If no alt-tag is set
		if (alttag === "") {
			altProperties.noAlt++;
			continue;
		}

		// If no keyword is set, but the alt-tag is
		if ((0, _lodashEs$Y.isEmpty)(topicForms.keyphraseForms)) {
			altProperties.withAlt++;
			continue;
		}

		// If the keyword is matched in the alt tag
		const keywordMatchedInAltTag = (0, _findKeywordFormsInString$3.findTopicFormsInString)(topicForms, alttag, true, locale);
		if (keywordMatchedInAltTag.percentWordMatches >= 50) {
			altProperties.withAltKeyword++;
			continue;
		}

		altProperties.withAltNonKeyword++;
	}

	return altProperties;
};

var keyphraseLength = {};

Object.defineProperty(keyphraseLength, "__esModule", {
  value: true
});

keyphraseLength.default = function (paper, researcher) {
  const topicForms = researcher.getResearch("morphology");

  return topicForms.keyphraseForms.length;
};

var metaDescriptionKeyword = {};

Object.defineProperty(metaDescriptionKeyword, "__esModule", {
	value: true
});

metaDescriptionKeyword.default = function (paper, researcher) {
	const description = paper.getDescription();
	const locale = paper.getLocale();

	const topicForms = researcher.getResearch("morphology");

	const sentences = (0, _getSentences2$8.default)(description);

	const sentenceMatches = sentences.map(sentence => matchPerSentence(sentence, topicForms, locale));

	return sentenceMatches.reduce((sum, count) => sum + count, 0);
};

var _matchTextWithArray$1 = matchTextWithArray;

var _matchTextWithArray2$1 = _interopRequireDefault$1n(_matchTextWithArray$1);

var _getSentences$8 = getSentences;

var _getSentences2$8 = _interopRequireDefault$1n(_getSentences$8);

function _interopRequireDefault$1n(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Replaces found keyword forms in the given description.
 *
 * @param {string} description the description to remove the matched keyword forms from.
 * @param {Object[]} matchedKeywordForms the matched keyword forms to remove from the description.
 * @param {Number} maxToRemove the maximum amount of matches of each individual keyword to remove.
 * @returns {string} the description with the keywords removed.
 */
const replaceFoundKeywordForms = function replaceFoundKeywordForms(description, matchedKeywordForms, maxToRemove) {
	// Replace matches so we do not match them for synonyms.
	matchedKeywordForms.forEach(keywordForm => keywordForm.matches.slice(0, maxToRemove).forEach(match => {
		description = description.replace(match, "");
	}));
	return description;
};

/**
 * Counts the number of full keyphrase matches in the given sentence. Takes synonyms into account.
 *
 * A full keyphrase is when all keywords in the keyphrase match.
 *
 * @param {string} sentence the sentence that needs to be analyzed.
 * @param {Object} topicForms the keyphrase (and its optional synonyms') word forms.
 * @param {string} locale the current locale
 * @returns {Number} the number of matched keyphrases in the sentence.
 */
const matchPerSentence = function matchPerSentence(sentence, topicForms, locale) {
	// Focus keyphrase matches.
	const matchesKeyphrase = topicForms.keyphraseForms.map(keywordForms => (0, _matchTextWithArray2$1.default)(sentence, keywordForms, locale));

	// Count the number of matches that contain every word in the entire keyphrase.
	const fullKeyphraseMatches = Math.min(...matchesKeyphrase.map(match => match.count));

	// Replace all full keyphrase matches so we do not match them for synonyms.
	sentence = replaceFoundKeywordForms(sentence, matchesKeyphrase, fullKeyphraseMatches);

	// Keyphrase synonyms matches.
	const fullSynonymsMatches = topicForms.synonymsForms.map(synonymForms => {
		// Synonym keyphrase matches.
		const matches = synonymForms.map(keywordForms => (0, _matchTextWithArray2$1.default)(sentence, keywordForms, locale));
		// Count the number of matches that contain every word in the entire synonym keyphrase.
		const fullSynonymMatches = Math.min(...matches.map(match => match.count));
		// Replace all full matches so we do not match them for other synonyms.
		sentence = replaceFoundKeywordForms(sentence, matchesKeyphrase, fullSynonymMatches);
		return fullSynonymMatches;
	});

	return [fullKeyphraseMatches, ...fullSynonymsMatches].reduce((sum, count) => sum + count, 0);
};

var keywordCountInUrl = {};

var parseSlug = {};

Object.defineProperty(parseSlug, "__esModule", {
  value: true
});

parseSlug.default = function (slug) {
  return slug.replace(/[-_]/ig, " ");
};

Object.defineProperty(keywordCountInUrl, "__esModule", {
	value: true
});

keywordCountInUrl.default = function (paper, researcher) {
	const topicForms = researcher.getResearch("morphology");
	const parsedSlug = (0, _parseSlug2$1.default)(paper.getUrl());

	let keyphraseInSlug = (0, _findKeywordFormsInString$2.findTopicFormsInString)(topicForms, parsedSlug, false, paper.getLocale());
	/* In case we deal with a language where dashes are part of the word (e.g., in Indonesian: buku-buku),
  * Try looking for the keywords in the unparsed slug.
  */
	if (keyphraseInSlug.percentWordMatches === 0) {
		const unparsedSlug = paper.getUrl();
		keyphraseInSlug = (0, _findKeywordFormsInString$2.findTopicFormsInString)(topicForms, unparsedSlug, false, paper.getLocale());
	}
	return {
		keyphraseLength: topicForms.keyphraseForms.length,
		percentWordMatches: keyphraseInSlug.percentWordMatches
	};
};

var _parseSlug$1 = parseSlug;

var _parseSlug2$1 = _interopRequireDefault$1m(_parseSlug$1);

var _findKeywordFormsInString$2 = findKeywordFormsInString;

function _interopRequireDefault$1m(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findKeywordInFirstParagraph = {};

var matchParagraphs = {};

Object.defineProperty(matchParagraphs, "__esModule", {
	value: true
});

matchParagraphs.default = function (text) {
	var paragraphs = getParagraphsInTags(text);

	if (paragraphs.length > 0) {
		return paragraphs;
	}

	// If no <p> tags found, split on double linebreaks.
	var blocks = (0, _html$1.getBlocks)(text);

	blocks = (0, _lodashEs$X.filter)(blocks, function (block) {
		// Match explicit paragraph tags, or if a block has no HTML tags.
		return 0 !== block.indexOf("<h");
	});

	paragraphs = (0, _lodashEs$X.flatMap)(blocks, function (block) {
		return block.split("\n\n");
	});

	if (paragraphs.length > 0) {
		return paragraphs;
	}

	// If no paragraphs are found, return an array containing the entire text.
	return [text];
};

var _lodashEs$X = require$$1$1;

var _html$1 = html;

/**
 * Matches the paragraphs in <p>-tags and returns the text in them.
 * @param {string} text The text to match paragraph in.
 * @returns {array} An array containing all paragraphs texts.
 */
var getParagraphsInTags = function getParagraphsInTags(text) {
	var paragraphs = [];
	// Matches everything between the <p> and </p> tags.
	var regex = /<p(?:[^>]+)?>(.*?)<\/p>/ig;
	var match;

	while ((match = regex.exec(text)) !== null) {
		paragraphs.push(match);
	}

	// Returns only the text from within the paragraph tags.
	return (0, _lodashEs$X.map)(paragraphs, function (paragraph) {
		return paragraph[1];
	});
};

var findEmptyDivisions = {};

Object.defineProperty(findEmptyDivisions, "__esModule", {
  value: true
});

findEmptyDivisions.default = function (text) {
  return (0, _matchStringWithRegex2$1.default)(text, "<div(?:[^>]+)?> *</div>");
};

var _matchStringWithRegex$1 = matchStringWithRegex;

var _matchStringWithRegex2$1 = _interopRequireDefault$1l(_matchStringWithRegex$1);

function _interopRequireDefault$1l(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(findKeywordInFirstParagraph, "__esModule", {
	value: true
});

findKeywordInFirstParagraph.default = function (paper, researcher) {
	const topicForms = researcher.getResearch("morphology");
	const locale = paper.getLocale();

	let paragraphs = (0, _matchParagraphs2$1.default)(paper.getText());
	paragraphs = (0, _lodashEs$W.reject)(paragraphs, _lodashEs$W.isEmpty);
	paragraphs = (0, _lodashEs$W.reject)(paragraphs, paragraphHasNoText)[0] || "";

	const result = {
		foundInOneSentence: false,
		foundInParagraph: false,
		keyphraseOrSynonym: ""
	};

	const sentences = (0, _getSentences2$7.default)(paragraphs);
	// Use both keyphrase and synonyms to match topic words in the first paragraph.
	const useSynonyms = true;

	if (!(0, _lodashEs$W.isEmpty)(sentences)) {
		sentences.forEach(function (sentence) {
			const resultSentence = (0, _findKeywordFormsInString$1.findTopicFormsInString)(topicForms, sentence, useSynonyms, locale);
			if (resultSentence.percentWordMatches === 100) {
				result.foundInOneSentence = true;
				result.foundInParagraph = true;
				result.keyphraseOrSynonym = resultSentence.keyphraseOrSynonym;
				return result;
			}
		});

		const resultParagraph = (0, _findKeywordFormsInString$1.findTopicFormsInString)(topicForms, paragraphs, useSynonyms, locale);
		if (resultParagraph.percentWordMatches === 100) {
			result.foundInParagraph = true;
			result.keyphraseOrSynonym = resultParagraph.keyphraseOrSynonym;
			return result;
		}
	}

	return result;
};

var _matchParagraphs$1 = matchParagraphs;

var _matchParagraphs2$1 = _interopRequireDefault$1k(_matchParagraphs$1);

var _getSentences$7 = getSentences;

var _getSentences2$7 = _interopRequireDefault$1k(_getSentences$7);

var _findKeywordFormsInString$1 = findKeywordFormsInString;

var _imageInText$1 = imageInText;

var _imageInText2$1 = _interopRequireDefault$1k(_imageInText$1);

var _findEmptyDivisions = findEmptyDivisions;

var _findEmptyDivisions2 = _interopRequireDefault$1k(_findEmptyDivisions);

var _getAnchorsFromText = getAnchorsFromText;

var _getAnchorsFromText2 = _interopRequireDefault$1k(_getAnchorsFromText);

var _matchStringWithRegex = matchStringWithRegex;

var _matchStringWithRegex2 = _interopRequireDefault$1k(_matchStringWithRegex);

var _lodashEs$W = require$$1$1;

function _interopRequireDefault$1k(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Removes links from text.
 *
 * @param {string} text The text string to analyze.
 *
 * @returns {string} The text with links stripped away.
 */
function removeLinksFromText(text) {
	const anchors = (0, _getAnchorsFromText2.default)(text);
	if (anchors.length > 0) {
		anchors.forEach(function (anchor) {
			text = text.replace(anchor, "");
		});
	}

	return text;
}

/**
 * Removes images from text.
 *
 * @param {string} text The text string to analyze.
 *
 * @returns {string} The text with images stripped away.
 */
/** @module analyses/findKeywordInFirstParagraph */

function removeImagesFromText(text) {
	const images = (0, _imageInText2$1.default)(text);
	const imageTags = (0, _matchStringWithRegex2.default)(text, "</img>");

	if (images.length > 0) {
		images.forEach(function (image) {
			text = text.replace(image, "");
		});

		imageTags.forEach(function (imageTag) {
			text = text.replace(imageTag, "");
		});
	}

	return text;
}

/**
 * Checks if the paragraph has no text.
 *
 * @param {string} text The text string to analyze.
 *
 * @returns {boolean} True if the paragraph has no text, false otherwise.
 */
function paragraphHasNoText(text) {
	// Strip links and check if paragraph consists of links only
	text = removeLinksFromText(text);
	if (text === "") {
		return true;
	}

	text = removeImagesFromText(text);
	if (text === "") {
		return true;
	}

	// Remove empty divisions from the text
	const emptyDivisions = (0, _findEmptyDivisions2.default)(text);
	if (emptyDivisions.length < 1) {
		return false;
	}

	emptyDivisions.forEach(function (emptyDivision) {
		text = text.replace(emptyDivision, "");
	});

	return text === "";
}

var pageTitleWidth = {};

Object.defineProperty(pageTitleWidth, "__esModule", {
  value: true
});

pageTitleWidth.default = function (paper) {
  if (paper.hasTitle()) {
    return paper.getTitleWidth();
  }
  return 0;
};

var getWordComplexity = {};

Object.defineProperty(getWordComplexity, "__esModule", {
	value: true
});

getWordComplexity.default = function (paper) {
	var sentences = (0, _getSentences2$6.default)(paper.getText());

	return (0, _lodashEs$V.map)(sentences, function (sentence) {
		return {
			sentence: sentence,
			words: getWordComplexityForSentence(sentence)
		};
	});
};

var _getWords$b = getWords;

var _getWords2$b = _interopRequireDefault$1j(_getWords$b);

var _count = count;

var _count2 = _interopRequireDefault$1j(_count);

var _getSentences$6 = getSentences;

var _getSentences2$6 = _interopRequireDefault$1j(_getSentences$6);

var _lodashEs$V = require$$1$1;

function _interopRequireDefault$1j(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the complexity per word, along with the index for the sentence.
 * @param {string} sentence The sentence to get wordComplexity from.
 * @returns {Array} A list with words, the index and the complexity per word.
 */
var getWordComplexityForSentence = function getWordComplexityForSentence(sentence) {
	var words = (0, _getWords2$b.default)(sentence);
	var results = [];

	(0, _lodashEs$V.forEach)(words, function (word, i) {
		results.push({
			word: word,
			wordIndex: i,
			complexity: (0, _count2.default)(word)
		});
	});

	return results;
};

var getParagraphLength = {};

Object.defineProperty(getParagraphLength, "__esModule", {
	value: true
});

getParagraphLength.default = function (paper) {
	var text = paper.getText();
	var paragraphs = (0, _matchParagraphs2.default)(text);
	var paragraphsLength = [];
	paragraphs.map(function (paragraph) {
		paragraphsLength.push({
			wordCount: (0, _countWords2$5.default)(paragraph),
			text: paragraph
		});
	});

	return (0, _lodashEs$U.filter)(paragraphsLength, function (paragraphLength) {
		return paragraphLength.wordCount > 0;
	});
};

var _countWords$5 = countWords;

var _countWords2$5 = _interopRequireDefault$1i(_countWords$5);

var _matchParagraphs = matchParagraphs;

var _matchParagraphs2 = _interopRequireDefault$1i(_matchParagraphs);

var _lodashEs$U = require$$1$1;

function _interopRequireDefault$1i(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countSentencesFromText = {};

var sentencesLength = {};

Object.defineProperty(sentencesLength, "__esModule", {
	value: true
});

sentencesLength.default = function (sentences) {
	var sentencesWordCount = [];
	(0, _lodashEs$T.forEach)(sentences, function (sentence) {
		// For counting words we want to omit the HTMLtags.
		var strippedSentence = (0, _stripHTMLTags$3.stripFullTags)(sentence);
		var length = (0, _countWords2$4.default)(strippedSentence);

		if (length <= 0) {
			return;
		}

		sentencesWordCount.push({
			sentence: sentence,
			sentenceLength: (0, _countWords2$4.default)(sentence)
		});
	});
	return sentencesWordCount;
};

var _countWords$4 = countWords;

var _countWords2$4 = _interopRequireDefault$1h(_countWords$4);

var _lodashEs$T = require$$1$1;

var _stripHTMLTags$3 = stripHTMLTags;

function _interopRequireDefault$1h(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(countSentencesFromText, "__esModule", {
  value: true
});

countSentencesFromText.default = function (paper) {
  var sentences = (0, _getSentences2$5.default)(paper.getText());
  return (0, _sentencesLength2$1.default)(sentences);
};

var _getSentences$5 = getSentences;

var _getSentences2$5 = _interopRequireDefault$1g(_getSentences$5);

var _sentencesLength$1 = sentencesLength;

var _sentencesLength2$1 = _interopRequireDefault$1g(_sentencesLength$1);

function _interopRequireDefault$1g(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countSentencesFromDescription = {};

Object.defineProperty(countSentencesFromDescription, "__esModule", {
  value: true
});

countSentencesFromDescription.default = function (paper) {
  var sentences = (0, _getSentences2$4.default)(paper.getDescription());
  return (0, _sentencesLength2.default)(sentences);
};

var _getSentences$4 = getSentences;

var _getSentences2$4 = _interopRequireDefault$1f(_getSentences$4);

var _sentencesLength = sentencesLength;

var _sentencesLength2 = _interopRequireDefault$1f(_sentencesLength);

function _interopRequireDefault$1f(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSubheadingTextLengths = {};

var getSubheadingTexts = {};

Object.defineProperty(getSubheadingTexts, "__esModule", {
	value: true
});

getSubheadingTexts.default = function (text) {
	/*
  Matching this in a regex is pretty hard, since we need to find a way for matching the text after a heading, and before the end of the text.
  The hard thing capturing this is with a capture, it captures the next subheading as well, so it skips the next part of the text,
  since the subheading is already matched.
  For now we use this method to be sure we capture the right blocks of text. We remove all | 's from text,
  then replace all headings with a | and split on a |.
  */
	text = text.replace(/\|/ig, "");
	text = text.replace(/<h([1-6])(?:[^>]+)?>(.*?)<\/h\1>/ig, "|");

	const subheadingsTexts = text.split("|");

	if ((0, _lodashEs$S.isEmpty)(subheadingsTexts[0])) {
		subheadingsTexts.shift();
	}

	return subheadingsTexts;
};

var _lodashEs$S = require$$1$1;

Object.defineProperty(getSubheadingTextLengths, "__esModule", {
	value: true
});

getSubheadingTextLengths.default = function (paper) {
	const text = paper.getText();
	const matches = (0, _getSubheadingTexts2.default)(text);

	const subHeadingTexts = [];
	(0, _lodashEs$R.forEach)(matches, function (subHeading) {
		subHeadingTexts.push({
			text: subHeading,
			wordCount: (0, _countWords2$3.default)(subHeading)
		});
	});
	return subHeadingTexts;
};

var _getSubheadingTexts = getSubheadingTexts;

var _getSubheadingTexts2 = _interopRequireDefault$1e(_getSubheadingTexts);

var _countWords$3 = countWords;

var _countWords2$3 = _interopRequireDefault$1e(_countWords$3);

var _lodashEs$R = require$$1$1;

function _interopRequireDefault$1e(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findTransitionWords = {};

var createRegexFromDoubleArray = {};

Object.defineProperty(createRegexFromDoubleArray, "__esModule", {
	value: true
});

createRegexFromDoubleArray.default = function (array) {
	array = array.map(function (wordCombination) {
		return wordCombinationToRegexString(wordCombination);
	});
	const regexString = "(" + array.join(")|(") + ")";
	return new RegExp(regexString, "ig");
};

var _addWordboundary$1 = addWordboundary;

var _addWordboundary2$1 = _interopRequireDefault$1d(_addWordboundary$1);

function _interopRequireDefault$1d(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a regex string of combined strings from the input array.
 * @param {array} array The array containing the various parts of a transition word combination.
 * @returns {array} The array with replaced entries.
 */
const wordCombinationToRegexString = function wordCombinationToRegexString(array) {
	array = array.map(function (word) {
		return (0, _addWordboundary2$1.default)(word);
	});
	return array.join("(.*?)");
};

var getTransitionWords = {};

var twoPartTransitionWords$f = {};

Object.defineProperty(twoPartTransitionWords$f, "__esModule", {
  value: true
});

twoPartTransitionWords$f.default = function () {
  return [["both", "and"], ["if", "then"], ["not only", "but also"], ["neither", "nor"], ["either", "or"], ["not", "but"], ["whether", "or"], ["no sooner", "than"]];
};

var twoPartTransitionWords$e = {};

Object.defineProperty(twoPartTransitionWords$e, "__esModule", {
	value: true
});

twoPartTransitionWords$e.default = function () {
	return [["anstatt", "dass"], ["bald", "bald"], ["dadurch", "dass"], ["dessen ungeachtet", "dass"], ["entweder", "oder"], ["einerseits", "andererseits"], ["erst", "wenn"], ["je", "desto"], ["je", "umso"], ["umso", "umso"], ["mal", "mal"], ["nicht nur", "sondern auch"], ["ob", "oder"], ["ohne", "dass"], ["so", "dass"], ["sowohl", "als auch"], ["sowohl", "wie auch"], ["teils", "teils"], ["unbeschadet dessen", "dass"], ["weder", "noch"], ["wenn", "auch"], ["wenn", "schon"], ["nicht weil", "sondern"]];
};

var twoPartTransitionWords$d = {};

Object.defineProperty(twoPartTransitionWords$d, "__esModule", {
	value: true
});

twoPartTransitionWords$d.default = function () {
	return [["à première vue", "mais à bien considérer les choses"], ["à première vue", "mais toute réflexion faite"], ["aussi", "que"], ["autant de", "que"], ["certes", "mais"], ["d'un côté", "de l'autre côté"], ["d'un côté", "de l'autre"], ["d'un côté", "d'un autre côté"], ["d'une part", "d'autre part"], ["d'une parte", "de l'autre parte"], ["moins de", "que"], ["non seulement", "mais aussi"], ["non seulement", "mais en outre"], ["non seulement", "mais encore"], ["plus de", "que"], ["quelque", "que"], ["si", "que"], ["soit", "soit"], ["tantôt", "tantôt"], ["tout d'abord", "ensuite"], ["tout", "que"]];
};

var twoPartTransitionWords$c = {};

Object.defineProperty(twoPartTransitionWords$c, "__esModule", {
  value: true
});

twoPartTransitionWords$c.default = function () {
  return [["de un lado", "de otra parte"], ["de un lado", "de otro"], ["no", "sino que"], ["no", "sino"], ["por un lado", "por otro lado"], ["por una parte", "por otra parte"], ["por una parte", "por otra"], ["tanto", "como"], ["bien", "bien"]];
};

var twoPartTransitionWords$b = {};

Object.defineProperty(twoPartTransitionWords$b, "__esModule", {
	value: true
});

twoPartTransitionWords$b.default = function () {
	return [["aan de ene kant", "aan de andere kant"], ["enerzijds", "anderzijds"], ["natuurlijk", "maar"], ["niet alleen", "maar ook"], ["noch", "noch"], ["zowel", "als"]];
};

var twoPartTransitionWords$a = {};

Object.defineProperty(twoPartTransitionWords$a, "__esModule", {
  value: true
});

twoPartTransitionWords$a.default = function () {
  return [["né", "né"], ["non", "ma"], ["non prima", "che"], ["non prima", "di"], ["non solo", "ma anche"], ["o", "o"], ["se", "allora"], ["se", "o"], ["sia", "che"]];
};

var twoPartTransitionWords$9 = {};

Object.defineProperty(twoPartTransitionWords$9, "__esModule", {
	value: true
});

twoPartTransitionWords$9.default = function () {
	return [["não apenas", "como também"], ["não só", "bem como"], ["não só", "como também"], ["não só", "mas também"], ["ora", "ora"], ["ou", "ou"], ["quer", "quer"]];
};

var twoPartTransitionWords$8 = {};

Object.defineProperty(twoPartTransitionWords$8, "__esModule", {
	value: true
});

twoPartTransitionWords$8.default = function () {
	return [["будь то", "или"], ["возможно", "а может быть"], ["возможно", "возможно"], ["достаточно", "чтобы"], ["едва", "как"], ["ежели", "то"], ["если говорить о", "то"], ["если и не", "то"], ["если не", "то"], ["если", "то"], ["мало того что", "еще и"], ["мало того, что", "еще и"], ["не сказать чтобы", "но"], ["не сказать, чтобы", "но"], ["не столько", "сколько"], ["не то чтобы", "но"], ["не только не", "но и"], ["стоило", "как"], ["так как", "то"], ["только", "как"], ["хоть бы", "а то"], ["хоть", "хоть"], ["хотя", "но"], ["чем", "лучше бы"], ["чем", "тем"], ["что касается", "то"]];
};

var transitionWords$4 = {};

Object.defineProperty(transitionWords$4, "__esModule", {
	value: true
});

transitionWords$4.default = function () {
	return {
		singleWords: singleWords$4,
		multipleWords: multipleWords$4,
		allWords: singleWords$4.concat(multipleWords$4)
	};
};

/** @module config/transitionWords */

const singleWords$4 = ["abans", "així", "alhora", "aleshores", "altrament", "anteriorment", "breument", "bàsicament", "contràriament", "després", "doncs", "efectivament", "endemés", "especialment", "evidentment", "finalment", "fins a", "fins que", "generalment", "igualment", "malgrat", "mentre", "mentrestant", "parallelament", "paral·lelament", "però", "perquè", "quan", "primerament", "resumidament", "resumint", "segurament", "segons això", "sens dubte", "sinó", "sobretot", "també", "tanmateix"];

const multipleWords$4 = ["a banda d'això", "a continuació", "a diferència de", "a fi de", "a fi que", "a força de", "a manera de resum", "a més", "a partir d'aquí", "a partir d'ara", "a tall d'exemple", "a tall de recapitulació", "a tall de resum", "al capdavall", "al contrari", "al mateix temps", "amb relació a", "tot plegat", "ara bé", "atès que", "com a conseqüència", "com a exemple", "com a resultat", "com a resum", "com que", "comptat i debatut", "considerant que", "convé destacar", "convé recalcar", "convé ressaltar que", "d'altra banda", "d’una banda", "d’una forma breu", "de la mateixa manera", "de manera parallela", "de manera paral·lela", "de manera que", "de tota manera", "degut a", "deixant de banda", "dit d'una altra manera", "donat que", "en a resum", "en lloc de", "en altres paraules", "en aquest sentit", "en canvi", "en conclusió", "en conjunt", "en conseqüència", "encara que", "en darrer lloc", "en darrer terme", "en definitiva", "en efecte", "en general", "en particular", "en pocs mots", "en poques paraules", "en primer lloc", "en relació amb", "en resum", "en segon lloc", "en síntesi", "en suma", "en tercer lloc", "en últim terme", "és a dir", "és més", "és per això que", "fins i tot", "gràcies a", "gràcies de", "igual com", "igual que", "ja que", "llevat que", "més aviat", "més tard", "més endavant", "no obstant", "o sia", "o sigui", "òbviament", "pel fet que", "pel general", "pel que", "per acabar", "per això", "per altra banda", "per aquest motiu", "per causa de", "per causa que", "per cert", "per començar", "per concloure", "per concretar", "per contra", "per exemple", "per illustrar", "per il·lustrar", "per l'altra part", "per l'altre cantó", "per la qual cosa", "per mitjà de", "per posar un exemple", "per raó de", "per raó que", "per tal de", "per tal que", "per tant", "per últim", "per un cantó", "per un costat", "per una altra banda", "per una part", "quant a", "recapitulant", "respecte de", "s'ha de tenir en compte que", "sempre que", "tal com s’ha dit", "tan bon punt", "tan aviat com", "tenint en compte que", "tot i", "tot seguit", "val a dir", "val la pena dir que", "vist que"];

var twoPartTransitionWords$7 = {};

Object.defineProperty(twoPartTransitionWords$7, "__esModule", {
  value: true
});

twoPartTransitionWords$7.default = function () {
  return [["ara", "ara"], ["ni", "ni"]];
};

var twoPartTransitionWords$6 = {};

Object.defineProperty(twoPartTransitionWords$6, "__esModule", {
  value: true
});

twoPartTransitionWords$6.default = function () {
  return [["albo", "albo"], ["ani", "ani"], ["czy", "czy"], ["im", "tym"], ["tak", "jak"]];
};

/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */
var twoPartTransitionWords$5 = function () {
  return [["antingen", "eller"], ["icke blott", "utan afven"], ["ju", "desto"]];
};

var twoPartTransitionWords$4 = {};

Object.defineProperty(twoPartTransitionWords$4, "__esModule", {
	value: true
});

twoPartTransitionWords$4.default = function () {
	return [["nemcsak", "hanem", "is"], ["ahogy", "akkor"], ["ahogy", "azonnal"], ["ahogy", "azután"], ["ahogy", "máris"], ["ahogy", "nyomban"], ["ahogy", "tüstént"], ["akkor", "amikor"], ["akkor", "ha"], ["akkor", "hogy"], ["akkor", "hogyha"], ["akkor", "mikor"], ["akkorra", "amikorra"], ["akkorra", "mikorra"], ["akkorra", "mire"], ["akkortól", "amikor"], ["akkortól", "mikor"], ["alighogy", "máris"], ["alighogy", "nyomban"], ["alighogy", "tüstént"], ["addig", "ameddig"], ["ameddig", "addig"], ["abba", "hogy"], ["abban", "hogy"], ["abból", "hogy"], ["addig", "amíg"], ["addig", "hogy"], ["addig", "míg"], ["afelé", "hogy"], ["ahelyett", "hogy"], ["ahhoz", "hogy"], ["akként", "hogy"], ["akkorra", "hogy"], ["amiatt", "hogy"], ["amellett", "hogy"], ["anélkül", "hogy"], ["annyi", "hogy"], ["annyi", "mint"], ["annyira", "hogy"], ["annyira", "mint"], ["arra", "hogy"], ["arról", "hogy"], ["attól fogva", "hogy"], ["attól", "hogy"], ["avégett", "hogy"], ["avégre", "hogy"], ["az ellen", "hogy"], ["az iránt", "hogy"], ["azelőtt", "hogy"], ["azért", "hogy"], ["azon", "hogy"], ["azonkívül", "hogy"], ["azóta", "hogy"], ["azután", "hogy"], ["azzal", "hogy"], ["hol", "hol"], ["igaz", "hogy"], ["mind", "mind"], ["nem úgy", "mint"], ["oly módon", "hogy"], ["inkább", "semhogy"], ["úgy", "hogy"], ["úgy", "mint"], ["vagy", "vagy"], ["se", "se"], ["sem", "sem"], ["is", "is"], ["akár", "akár"], ["is", "meg"], ["nem", "hanem"], ["egyrészt", "másrészt"], ["minél", "annál"], ["amíg", "addig"], ["amíg", "addigra"], ["amikor", "akkor"], ["akkor", "amikor"], ["amikor", "aközben"], ["amikor", "azalatt"], ["addigra", "amikorra"], ["amikorra", "addigra"], ["amikorra", "akkorra"], ["amint", "akkor"], ["amint", "azonnal"], ["amint", "máris"], ["amint", "nyomban"], ["amint", "tüstént"], ["amióta", "attól kezdve"], ["azóta", "amióta"], ["amióta", "azóta"], ["amire", "addig"], ["amire", "addigra"], ["azóta", "hogy"], ["ha", "akkor"], ["hogyha", "akkor"], ["is", "is"], ["azalatt", "mialatt"], ["mialatt", "azalatt"], ["mielőtt", "azelőtt"], ["azelőtt", "mielőtt"], ["mihelyt", "azonnal"], ["mihelyt", "máris"], ["mihelyt", "nyomban"], ["mihelyt", "tüstént"], ["mikor", "akkor"], ["mikor", "aközben"], ["mikor", "azalatt"], ["mikor", "azután"], ["mikorra", "addigra"], ["akkorra", "mikorra"], ["mikorra", "akkorra"], ["miközben", "azalatt"], ["mióta", "attól kezdve"], ["mire", "addigra"], ["miután", "azután"], ["attól kezdve", "mióta"], ["mióta", "azóta"], ["azóta", "mióta"], ["mire", "addig"], ["addigra", "mire"], ["azután", "miután"], ["nemcsak", "hanem"], ["sem", "sem"], ["vagy", "vagy"]];
};

var transitionWords$3 = {};

Object.defineProperty(transitionWords$3, "__esModule", {
	value: true
});

transitionWords$3.default = function () {
	return {
		singleWords: singleWords$3,
		multipleWords: multipleWords$3,
		allWords: singleWords$3.concat(multipleWords$3)
	};
};

/** @module config/transitionWords */

var singleWords$3 = ["adakalanya", "agak", "agar", "akhirnya", "alhasil", "andaikan", "bahkan", "bahwasannya", "berikut", "betapapun", "biarpun", "biasanya", "contohnya", "dahulunya", "diantaranya", "dikarenakan", "disebabkan", "dulunya", "faktanya", "hasilnya", "intinya", "jadi", "jua", "juga", "kadang-kadang", "kapanpun", "karena", "karenanya", "kedua", "kelak", "kemudian", "kesimpulannya", "khususnya", "langsung", "lantaran", "maka", "makanya", "masih", "memang", "meski", "meskipun", "misalnya", "mulanya", "nantinya", "nyatanya", "pendeknya", "pertama", "ringkasnya", "rupanya", "seakan-akan", "sebaliknya", "sebelum", "sebetulnya", "sedangkan", "segera", "sehingga", "sekali-sekali", "sekalipun", "sekiranya", "selagi", "selain", "selama", "selanjutnya", "semasa", "semasih", "semenjak", "sementara", "semula", "sepanjang", "serasa", "seraya", "seringkali", "sesungguhnya", "setelahnya", "seterusnya", "setidak-tidaknya", "setidaknya", "sewaktu-waktu", "sewaktu", "tadinya", "tentunya", "terakhir", "terdahulu", "terlebih", "ternyata", "terpenting", "terutama", "terutamanya", "tetapi", "umpamanya", "umumnya", "utamanya", "walau", "walaupun", "yaitu", "yakni", "akibatnya", "hingga", "kadang", "kendatipun", "ketiga", "lainnya", "manakala", "namun", "pastinya", "pertama-tama", "sampai-sampai", "sebaliknya", "sebelumnya", "sebetulnya", "sesekali"];
var multipleWords$3 = ["agar supaya", "akan tetapi", "apa lagi", "asal saja", "bagaimanapun juga", "bahkan jika", "bahkan lebih", "begitu juga", "berbeda dari", "biarpun begitu", "biarpun demikian", "bilamana saja", "cepat atau lambat", "dalam hal ini", "dalam jangka panjang", "dalam kasus ini", "dalam kasus lain", "dalam kedua kasus", "dalam kenyataannya", "dalam pandangan", "dalam situasi ini", "dalam situasi seperti itu", "dan lagi", "dari awal", "dari pada", "dari waktu ke waktu", "demikian juga", "demikian pula", "dengan serentak", "dengan cara yang sama", "dengan jelas", "dengan kata lain", "dengan ketentuan", "dengan nyata", "dengan panjang lebar", "dengan pemikiran ini", "dengan syarat bahwa", "dengan terang", "di pihak lain", "di sisi lain", "dibandingkan dengan", "disebabkan oleh", "ditambah dengan", "hanya jika", "harus diingat", "hasil dari", "hingga kini", "kalau tidak", "kalau-kalau", "kali ini", "kapan saja", "karena alasan itulah", "karena alasan tersebut", "kecuali kalau", "kendatipun begitu", "kendatipun demikian", "lebih jauh", "lebih lanjut", "maka dari itu", "meskipun demikian", "oleh karena itu", "oleh karenanya", "oleh sebab itu", "pada akhirnya", "pada awalnya", "pada dasarnya", "pada intinya", "pada kenyataannya", "pada kesempatan ini", "pada mulanya", "pada saat ini", "pada saat", "pada situasi ini", "pada umumnya", "pada waktu yang sama", "pada waktunya", "paling tidak", "pendek kata", "penting untuk disadari", "poin penting lainnya", "saat ini", "sama halnya", "sama pentingnya", "sama sekali", "sampai sekarang", "sebab itu", "sebagai akibatnya", "sebagai contoh", "sebagai gambaran", "sebagai gantinya", "sebagai hasilnya", "sebagai tambahan", "sebelum itu", "secara bersamaan", "secara eksplisit", "secara keseluruhan", "secara keseluruhan", "secara khusus", "secara menyeluruh", "secara signifikan", "secara singkat", "secara umum", "sejalan dengan ini", "sejalan dengan itu", "sejauh ini", "sekali lagi", "sekalipun begitu", "sekalipun demikian", "sementara itu", "seperti yang bisa dilihat", "seperti yang sudah saya katakan", "seperti yang sudah saya tunjukkan", "sesudah itu", "setelah ini", "setelah itu", "tak pelak lagi", "tanpa menunda-nunda lagi", "tentu saja", "terutama sekali", "tidak perlu dipertanyakan lagi", "tidak sama", "tidak seperti", "untuk alasan ini", "untuk alasan yang sama", "untuk memperjelas", "untuk menekankan", "untuk menyimpulkan", "untuk satu hal", "untuk sebagian besar", "untuk selanjutnya", "untuk tujuan ini", "walaupun demikian", "yang lain", "yang terakhir", "yang terpenting", "begitu pula", "berbeda dengan", "betapapun juga", "dalam hal itu", "di samping itu", "hal pertama yang perlu diingat", "kadang kala", "karena itu", "lagi pula", "lambat laun", "mengingat bahwa", "meskipun begitu", "pada umumnya", "pada waktu", "saat ini juga", "sampai saat ini", "sebagian besar", "secara terperinci", "selain itu", "seperti yang sudah dijelaskan", "seperti yang tertera di", "tak seperti", "tanpa memperhatikan", "tentu saja", "untuk memastikan", "untuk menggambarkan", "walaupun begitu"];

var twoPartTransitionWords$3 = {};

Object.defineProperty(twoPartTransitionWords$3, "__esModule", {
	value: true
});

twoPartTransitionWords$3.default = function () {
	return [["baik", "maupun"], ["bukan", "melainkan"], ["bukan", "tetapi"], ["bukannya", "melainkan"], ["bukannya", "tetapi"], ["tidak", "melainkan"], ["tidak", "tetapi"], ["tidak hanya", "tetapi juga"], ["begitu", "sehingga"], ["begitu", "sampai"], ["demikian", "sehingga"], ["demikian", "sampai"], ["sedemikian", "sehingga"], ["sedemikian", "sampai"], ["meskipun", "namun"], ["biarpun", "namun"], ["bukan hanya", "melainkan juga"], ["sedemikian rupa", "sehingga"], ["sebaiknya", "daripada"], ["entah", "entah"], ["kalau", "maka"], ["apabila", "maka"], ["apa", "atau"], ["jangankan", "pun"], ["saja", "apalagi"], ["apakah", "atau"]];
};

var transitionWords$2 = {};

Object.defineProperty(transitionWords$2, "__esModule", {
	value: true
});

transitionWords$2.default = function () {
	return {
		singleWords: singleWords$2,
		multipleWords: multipleWords$2,
		allWords: singleWords$2.concat(multipleWords$2)
	};
};

/** @module config/transitionWords */

const singleWords$2 = ["לכן", "משום‎", "בגלל", "מפני", "אחרי", "לפני", "חוץ", "בזכות", "כתוצאה", "הודות", "בשביל", "למרות‎", "בשל‎", "ו", "או", "אבל", "אולם", "אך", "אם", "גם", "רק", "אכן", "אלא", "עדיין", "כאשר", "אז", "לכן", "כבר", "לאחר", "אפילו", "אף", "כך", "כדי", "על", "עד", "בשנת", "כמו", "שני", "באופן", "במהלך", "במקום", "וכן", "בעיקר", "מאז", " בינתיים", "במקום", "תחת", "מתוך", "מול", "כגון", "באמצעות", "מכן", "במשך", "ואף", "ועל", "לעתים", "בנוסף", "בעקבות", "לפי", "בקרב", "כי", "ראשית", "שנית", "תחילה", "לבסוף", "הבא", "ברם", "ואילו", "להפך", "כנגד", "מנגד", "אמנם", "אדרבא", "לחילופין", "בייחוד", "במיוחד", "ודאי", "ואפילו", "לו", "אילו", "לולא", "אלמלא", "אילולא", "מאחורי", "בקרבת", "כאן", "שם", "כן", "למעט", "בלבד", "מלבד", "שוב", "כלומר", "דהיינו", "לאמור", "כאמור", "כידוע", "כש", "אחר-כך", "כעבור", "לאחרונה", "בטרם", "עכשיו", "עתה", "מלכתחילה", "למען", "פן", "לבל", "שמא", "עקב", "לרגל", "מפאת", "בגין", "בהתאם", "לפיכך", "למשל", "לדוגמה", "כדוגמת", "לסיכום", "בהתחשב", "בקיצור", "בקצרה", "חרף"];
const multipleWords$2 = ["כתוצאה מכך", "כתוצאה מ", "בעקבות ה", "בעקבות זאת", "לעומת זאת", "אלא אם כן", "בזמן ש", "מתי ש", "אף על פי ש", "אף על פי", "חוץ מ", "אחרי ש", "לפני ש", "בעוד ש", "בגלל ה", "הודות ל", "בניגוד ל", "מפני ש", "אלא ש", "קודם כל", "והחשוב ביותר", "לפני כן", "לאחר מכן", "אחר כך", "שלב ראשון", "בניגוד לכך", "ראוי לציין", "יש להדגיש", "ללא ספק", "קל וחומר", "אין ספק ש", "לא כל שכן", "בתנאי ש", "בדומה ל", "כשם ש", "כפי ש", "כך גם", "יחסית ל", "בהשוואה ל", "לשם כך", "במקביל ל", "במידה ש", "במקום ש", "על יד", "בסמוך ל", "במרחק מה", "אל אשר", "מעבר ל", "כמו כן", "יתר על כן", "זאת ועוד", "נוסף על כך", "פרט ל", "למעלה מכך", "פנים נוספות לעניין", "יתרה מכך", "אך ורק", "מעבר לכך", "זאת אומרת", "במילים אחרות", "רוצה לומר", "הווה אומר", "משתמע מזאת", "הוא אשר", "ללמד ש", "פירושו של דבר", "לשון אחרת", "בהקשר זה", "דרך אגב", "כדי ש", "כנזכר לעיל", "בקשר לכך", "במסגרת זו", "עד ש", "בשעה ש", "כל זמן ש", "לפי שעה", "בזמן האחרון", "עד כה", "בו בזמן", "כל אימת ש", "על מנת", "לתכלית זו", "במטרה ל", "מחמת ה", "הואיל ו", "מאחר ש", "היות ש", "כיוון ש", "יען כי", "באופן ש", "בצורה ש", "כמו ש", "אם כן", "אפוא", "על כן", "משום כך", "עקב כך", "בשל כך", "אי לכך", "נובע מכך", "הודות לכך", "כמו למשל", "סיכומו של דבר", "מכל האמור ניתן לומר", "בסך הכול", "בכל מקרה", "בסיכום כולל", "לטווח ארוך", "על כל פנים", "אף על פי כן", "על אף ש", "על אף זאת", "אף ש", "למרות זאת", "בכל אופן", "עם זאת", "אם כי", "גם אם"];

var twoPartTransitionWords$2 = {};

Object.defineProperty(twoPartTransitionWords$2, "__esModule", {
  value: true
});

twoPartTransitionWords$2.default = function () {
  return [["או", "או"], ["אין", "אלא"], ["לא", "אלא"], ["מצד אחד", "מצד אחר"], ["מחד גיסא", "מאידך גיסא"], ["ראשית", "שנית"], ["תחילה", "לבסוף"], ["משום ש", "מפני ש"], ["לכאורה", "אך"]];
};

var transitionWords$1 = {};

Object.defineProperty(transitionWords$1, "__esModule", {
	value: true
});

transitionWords$1.default = function () {
	return {
		singleWords: singleWords$1,
		multipleWords: multipleWords$1,
		allWords: singleWords$1.concat(multipleWords$1)
	};
};

/** @module config/transitionWords */

const singleWords$1 = ["كذلك", "ولكن", "ولذلك", "حاليا", "أخيرا", "بالطبع", "ثم", "بما", "كما", "لما", "إنما", "ليتما", "إما", "أينما", "حيثما", "كيفما", "أيما", "أيّما", "بينما", "ممّا", "إلاّ", "ألّا", "لئلّا", "حبّذا", "سيّما", "لكن", "بالتالي", "هكذا", "أو", "أم", "لذلك", "مثلا", "تحديدا", "عموما", "لاسيما", "خصوصا", "بالأخص", "خاصة", "بالمثل", "لأن", "بسبب", "إذا", "عندما", "حين", "متى", "قبل", "بعد", "منذ", "أيضا", "ريثما", "بين"];
const multipleWords$1 = ["إلا إذا", "إلا أن", "إلى آخره", "إلى الأبد", "إلى أن", "آن لك أن", "آن له أن", "آن لعلي", "بعد ذلك", "بما أن", "بما فيه", "حتى لا", "حتى لو", "عليك أن", "علينا أن", "عليه أن", "عليكم أن", "على محمد أن", "فيما بعد", "لا أحد", "لا بأس أن", "لا بد من", "لا بد من أن", "لا سيما", "لا شيء", "لا غير", "لا هذا ولا ذاك", "له أن", "لها أن", "لك أن", "لكم أن", "ما لم", "مع هذا ، مع ذلك", "من أجل أن", "من أجلك", "من أجلها", "من أجل سارة", "من أجل اليمن", "من دون ، بدون", "منذ ذلك الحين", "بالإضافة إلى ذلك", "في نهاية المطاف", "في الوقت الحالي", "علاوة على ذلك", "أنا أيضا", "بدلا من ذلك", "في الواقع", "بناء على ذلك", "ومع ذلك", "في الحقيقة", "من ناحية أخرى", "لا يزال", "وفي الوقت نفسه", "زيادة على ذلك", "زيادة على", "علاوة على", "ما عدا", "مع ذلك", "غير أن", "من جهة أخرى", "على عكس ذلك", "نتيجة لذلك", "من ثم", "على سبيل المثال", "على وجه الخصوص", "على وجه التحديد", "بصفة عامة", "قبل كل شيء", "في النهاية", "بصورة شاملة", "رغم أن", "مع ان", "على الرغم من", "من هنا", " لهذا السبب", "في حالة", "في أقرب وقت", "على أي حال", "في نفس الوقت", "من بين"];

var twoPartTransitionWords$1 = {};

Object.defineProperty(twoPartTransitionWords$1, "__esModule", {
  value: true
});

twoPartTransitionWords$1.default = function () {
  return [["لا", "ولا"], ["إما", "أو"], ["ربما", "ربما"], ["حينئذ", "عندئذ"], ["إما", "وإما"], ["كل من", "و"]];
};

/** @module config/transitionWords */

const singleWords = ["fakat", "halbuki", "hatta", "üstelik", "ancak", "oysa", "sonuçta", "yalnız", "çünkü", "oysaki", "kısacası", "özetle", "böylelikle", "ama", "lakin", "ayrıca", "açıkcası", "yani", "sonucunda", "böylece", "kısaca", "veya", "veyahut", "zira", "öyleyse", "sonrasında", "ardından", "vakıa", "gerçi", "karşın", "tümüyle", "bütünüyle", "tamamıyla", "genelde", "diğer", "başka", "önce", "öncesinde", "sonra", "yanısıra", "ama", "muhakkak", "kesinlikle", "şüphesiz", "elbet", "elbette", "kuşkusuz", "başlıca", "bilakis", "aksine", "tersine", "devamında", "özellikle", "bilhassa", "nihayet", "nihayetinde", "neticede", "ayrıyeten", "dahası", "çoğunlukla", "genellikle", "genelde", "dolayısıyla", "gelgelelim", "aslında", "doğrusu", "mamafih", "binaenaleyh", "evvelce", "önceden", "şöylelikle", "örneğin", "mesela", "nitekim", "mademki", "şimdi", "halihazırda", "i̇laveten", "aynen", "nazaran", "nedeniyle", "yüzünden", "umumiyetle", "ekseriye", "amacıyla", "gayesiyle", "velhasıl", "ezcümle", "özetlersek", "etraflıca", "tafsilatlı", "genişçe", "bilfiil", "filhakika", "evvela", "i̇lkin", "en önce", "birincisi", "i̇kincisi", "üçüncüsü", "sonuncusu", "tıpkı", "topyekun", "hem", "ne", "kah", "ister", "ya", "gerek", "ha"];

const multipleWords = ["o halde", "bundan böyle", "demek ki", "ne yazık ki", "görüldüğü gibi", "i̇lk olarak", "son olarak", "ne var ki", "buna rağmen", "yine de", "başka bir deyişle", "açıklamak gerekirse", "özetlemek gerekirse", "kısaca söylemek gerekirse", "görüldüğü gibi", "ve bunun gibi", "halbu ki", "buna göre", "ona göre", "ek olarak", "her ne kadar", "velev ki", "olmakla beraber", "bile olsa", "i̇le beaber", "i̇le birlikte", "her şeye rağmen", "bütün yanlarıyla", "bütün yönleriyle", "ele alacak olursak", "baştan sona", "diğer bir", "başka bir", "daha önce", "daha sonra", "bundan başka", "bunun yanında", "bunun yanı sıra", "bununla birlikte", "buna ilaveten", "bunun dışında", "elbette ki", "muhakkak ki", "belli başlı", "karşılaştırmak gerekirse", "karşılaştırmalı olarak", "aynı zamanda", "sonuç olarak", "diğer taraftan", "diğer bir taraftan", "buna karşılık", "tam tersine", "buna bağlı olarak", "buna parelel olarak", "i̇kinci olarak", "üçüncü olarak", "aynı derecede", "eşit olarak", "başta olmak üzere", "en sonunda", "açık bir şekilde", "ana hatlarıyla", "genel itibariyle", "genel anlamda", "genel olarak", "bunun için", "bu nedenle", "bundan dolayı", "bu sebeple", "dolayısı ile", "her halükarda", "aynı biçimde", "aynı şekilde", "bu esnada", "bu arada", "hal böyleyken", "bağlı kalmaksızın", "açık olarak", "belli ki", "ayrıntılı olarak", "bundan önce", "sözün kısası", "az ve öz bir şekilde", "tüm ayrıntılarıyla", "bu şekilde", "o yüzden", "bu sayede", "buradan hareketle", "buna mukabil", "en önemlisi", "her şeyden önce", "esas olarak", "hepsinden önce", "hepsinden öte", "hepsinden ötesi", "her şeyin üzerinde", "her şeyin ötesinde", "hepsinden önemlisi", "asıl önemlisi", "her şeyi hesaba katarak", "bütün olarak", "her şey göz önüne alındığında", "pararel olarak", "diğer bir nokta", "diğer açıdan", "öyle ya da böyle", "doğrusunu söylemek gerekirse", "i̇şin doğrusu", "aslına bakılırsa", "gerçek şu ki", "hattı zatında", "aslına bakıldığında", "aslına bakarsak", "i̇şin aslı", "sonuç itibariyle", "örnek olarak", "örneleyecek olursak", "görülebileceği gibi", "görülebileceği üzere", "görüldüğü üzere", "söylendiği gibi", "söylenildiği gibi", "söylediği gibi", "söylediğim gibi", "olduğu kadar", "önceden belirtildiği gibi", "önceden söylendiği gibi", "yukarıda gösterildiği gibi", "eninde sonunda", "önünde sonunda", "şu anda", "bu sırada", "bununla beraber", "bu noktada", "bunun ışığında", "bunların ışığında", "aşikar olarak", "aynı sebeple", "bir de", "doğru da olsa", "doğru bile olsa", "öyle bile olsa", "öyle de olsa", "i̇le ilgili", "olsa bile", "eğer ki", "olsa dahi", "ondan dolayı", "o sebepten dolayı", "bu yüzden", "onun için", "esas itibarıyla", "aynı sebepten dolayı", "bu amaçla", "zaman zaman", "arada sırada", "dönem dönem", "arada bir", "diyelim ki", "farz edelim ki", "farz edersek", "kısaca söylecek olursak", "tek kelimeyle", "birkaç kelimeyle", "sözün özü", "en nihayetinde", "uzun uzadıya", "her iki durumda da", "özü itibariyle", "amacı ile", "olması için", "başka bir ifadeyle", "diğer bir deyişle", "i̇lk önce", "bir yandan", "bir taraftan", "hatırlatmak gerekirse", "bu bağlamda", "gel gelelim", "her şey hesaba katılırsa", "bütüne bakıldığında", "belirtildiği gibi", "bir başka ifadeyle", "lafı toparlamak gerekirse", "bu düşünceyle", "bu maksatla", "bu doğrultuda", "bu niyetle", "hem de", "ne de", "ya da", "gerekse de"];

/**
 * Returns an list with transition words to be used by the assessments.
 * @returns {Object} The list filled with transition word lists.
 */
var transitionWords = function () {
	return {
		singleWords: singleWords,
		multipleWords: multipleWords,
		allWords: singleWords.concat(multipleWords)
	};
};

var twoPartTransitionWords = {};

Object.defineProperty(twoPartTransitionWords, "__esModule", {
  value: true
});

twoPartTransitionWords.default = function () {
  return [["hem", "hem de"], ["ne", "ne de"], ["ya", "ya da"], ["gerek", "gerekse de"]];
};

Object.defineProperty(getTransitionWords, "__esModule", {
	value: true
});

getTransitionWords.default = function (locale) {
	switch ((0, _getLanguage2$a.default)(locale)) {
		case "de":
			return {
				transitionWords: transitionWordsGerman,
				twoPartTransitionWords: _twoPartTransitionWords4.default
			};
		case "es":
			return {
				transitionWords: transitionWordsSpanish,
				twoPartTransitionWords: _twoPartTransitionWords8.default
			};
		case "fr":
			return {
				transitionWords: transitionWordsFrench,
				twoPartTransitionWords: _twoPartTransitionWords6.default
			};
		case "nl":
			return {
				transitionWords: transitionWordsDutch,
				twoPartTransitionWords: _twoPartTransitionWords10.default
			};
		case "it":
			return {
				transitionWords: transitionWordsItalian,
				twoPartTransitionWords: _twoPartTransitionWords12.default
			};
		case "pt":
			return {
				transitionWords: transitionWordsPortuguese,
				twoPartTransitionWords: _twoPartTransitionWords14.default
			};
		case "ru":
			return {
				transitionWords: transitionWordsRussian,
				twoPartTransitionWords: _twoPartTransitionWords16.default
			};
		case "ca":
			return {
				transitionWords: transitionWordsCatalan,
				twoPartTransitionWords: _twoPartTransitionWords18.default
			};
		case "pl":
			return {
				transitionWords: transitionWordsPolish,
				twoPartTransitionWords: _twoPartTransitionWords20.default
			};
		case "sv":
			return {
				transitionWords: transitionWordsSwedish,
				twoPartTransitionWords: _twoPartTransitionWords22.default
			};
		case "hu":
			return {
				transitionWords: transitionWordsHungarian,
				twoPartTransitionWords: _twoPartTransitionWords24.default
			};
		case "id":
			return {
				transitionWords: transitionWordsIndonesian,
				twoPartTransitionWords: _twoPartTransitionWords26.default
			};
		case "he":
			return {
				transitionWords: transitionWordsHebrew,
				twoPartTransitionWords: _twoPartTransitionWords28.default
			};
		case "ar":
			return {
				transitionWords: transitionWordsArabic,
				twoPartTransitionWords: _twoPartTransitionWords30.default
			};
		case "tr":
			return {
				transitionWords: transitionWordsTurkish,
				twoPartTransitionWords: _twoPartTransitionWords32.default
			};
		default:
		case "en":
			return {
				transitionWords: transitionWordsEnglish,
				twoPartTransitionWords: _twoPartTransitionWords2.default
			};
	}
};

var _transitionWords = transitionWords$q;

var _transitionWords2 = _interopRequireDefault$1c(_transitionWords);

var _twoPartTransitionWords = twoPartTransitionWords$f;

var _twoPartTransitionWords2 = _interopRequireDefault$1c(_twoPartTransitionWords);

var _transitionWords3 = transitionWords$s;

var _transitionWords4 = _interopRequireDefault$1c(_transitionWords3);

var _twoPartTransitionWords3 = twoPartTransitionWords$e;

var _twoPartTransitionWords4 = _interopRequireDefault$1c(_twoPartTransitionWords3);

var _transitionWords5 = transitionWords$i;

var _transitionWords6 = _interopRequireDefault$1c(_transitionWords5);

var _twoPartTransitionWords5 = twoPartTransitionWords$d;

var _twoPartTransitionWords6 = _interopRequireDefault$1c(_twoPartTransitionWords5);

var _transitionWords7 = transitionWords$m;

var _transitionWords8 = _interopRequireDefault$1c(_transitionWords7);

var _twoPartTransitionWords7 = twoPartTransitionWords$c;

var _twoPartTransitionWords8 = _interopRequireDefault$1c(_twoPartTransitionWords7);

var _transitionWords9 = transitionWords$o;

var _transitionWords10 = _interopRequireDefault$1c(_transitionWords9);

var _twoPartTransitionWords9 = twoPartTransitionWords$b;

var _twoPartTransitionWords10 = _interopRequireDefault$1c(_twoPartTransitionWords9);

var _transitionWords11 = transitionWords$k;

var _transitionWords12 = _interopRequireDefault$1c(_transitionWords11);

var _twoPartTransitionWords11 = twoPartTransitionWords$a;

var _twoPartTransitionWords12 = _interopRequireDefault$1c(_twoPartTransitionWords11);

var _transitionWords13 = transitionWords$g;

var _transitionWords14 = _interopRequireDefault$1c(_transitionWords13);

var _twoPartTransitionWords13 = twoPartTransitionWords$9;

var _twoPartTransitionWords14 = _interopRequireDefault$1c(_twoPartTransitionWords13);

var _transitionWords15 = transitionWords$e;

var _transitionWords16 = _interopRequireDefault$1c(_transitionWords15);

var _twoPartTransitionWords15 = twoPartTransitionWords$8;

var _twoPartTransitionWords16 = _interopRequireDefault$1c(_twoPartTransitionWords15);

var _transitionWords17 = transitionWords$4;

var _transitionWords18 = _interopRequireDefault$1c(_transitionWords17);

var _twoPartTransitionWords17 = twoPartTransitionWords$7;

var _twoPartTransitionWords18 = _interopRequireDefault$1c(_twoPartTransitionWords17);

var _transitionWords19 = transitionWords$c;

var _transitionWords20 = _interopRequireDefault$1c(_transitionWords19);

var _twoPartTransitionWords19 = twoPartTransitionWords$6;

var _twoPartTransitionWords20 = _interopRequireDefault$1c(_twoPartTransitionWords19);

var _transitionWords21 = transitionWords$a;

var _transitionWords22 = _interopRequireDefault$1c(_transitionWords21);

var _twoPartTransitionWords21 = twoPartTransitionWords$5;

var _twoPartTransitionWords22 = _interopRequireDefault$1c(_twoPartTransitionWords21);

var _transitionWords23 = transitionWords$6;

var _transitionWords24 = _interopRequireDefault$1c(_transitionWords23);

var _twoPartTransitionWords23 = twoPartTransitionWords$4;

var _twoPartTransitionWords24 = _interopRequireDefault$1c(_twoPartTransitionWords23);

var _transitionWords25 = transitionWords$3;

var _transitionWords26 = _interopRequireDefault$1c(_transitionWords25);

var _twoPartTransitionWords25 = twoPartTransitionWords$3;

var _twoPartTransitionWords26 = _interopRequireDefault$1c(_twoPartTransitionWords25);

var _transitionWords27 = transitionWords$2;

var _transitionWords28 = _interopRequireDefault$1c(_transitionWords27);

var _twoPartTransitionWords27 = twoPartTransitionWords$2;

var _twoPartTransitionWords28 = _interopRequireDefault$1c(_twoPartTransitionWords27);

var _getLanguage$a = getLanguage;

var _getLanguage2$a = _interopRequireDefault$1c(_getLanguage$a);

var _transitionWords29 = transitionWords$1;

var _transitionWords30 = _interopRequireDefault$1c(_transitionWords29);

var _twoPartTransitionWords29 = twoPartTransitionWords$1;

var _twoPartTransitionWords30 = _interopRequireDefault$1c(_twoPartTransitionWords29);

var _transitionWords31 = transitionWords;

var _transitionWords32 = _interopRequireDefault$1c(_transitionWords31);

var _twoPartTransitionWords31 = twoPartTransitionWords;

var _twoPartTransitionWords32 = _interopRequireDefault$1c(_twoPartTransitionWords31);

function _interopRequireDefault$1c(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const transitionWordsEnglish = (0, _transitionWords2.default)().allWords;

const transitionWordsGerman = (0, _transitionWords4.default)().allWords;

const transitionWordsFrench = (0, _transitionWords6.default)().allWords;

const transitionWordsSpanish = (0, _transitionWords8.default)().allWords;

const transitionWordsDutch = (0, _transitionWords10.default)().allWords;

const transitionWordsItalian = (0, _transitionWords12.default)().allWords;

const transitionWordsPortuguese = (0, _transitionWords14.default)().allWords;

const transitionWordsRussian = (0, _transitionWords16.default)().allWords;

const transitionWordsCatalan = (0, _transitionWords18.default)().allWords;

const transitionWordsPolish = (0, _transitionWords20.default)().allWords;

const transitionWordsSwedish = (0, _transitionWords22.default)().allWords;

const transitionWordsHungarian = (0, _transitionWords24.default)().allWords;

const transitionWordsIndonesian = (0, _transitionWords26.default)().allWords;

const transitionWordsHebrew = (0, _transitionWords28.default)().allWords;

const transitionWordsArabic = (0, _transitionWords30.default)().allWords;

const transitionWordsTurkish = (0, _transitionWords32.default)().allWords;

var matchWordInSentence = {};

Object.defineProperty(matchWordInSentence, "__esModule", {
	value: true
});
matchWordInSentence.isWordInSentence = matchWordInSentence.characterInBoundary = undefined;

var _wordBoundaries = wordBoundaries$1;

var _wordBoundaries2 = _interopRequireDefault$1b(_wordBoundaries);

var _lodashEs$Q = require$$1$1;

var _addWordboundary = addWordboundary;

var _addWordboundary2 = _interopRequireDefault$1b(_addWordboundary);

function _interopRequireDefault$1b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const wordBoundaries = (0, _wordBoundaries2.default)();


/**
 * Checks whether a character is present in the list of word boundaries.
 *
 * @param {string} character The character to look for.
 * @returns {boolean} Whether or not the character is present in the list of word boundaries.
 */
const characterInBoundary = function characterInBoundary(character) {
	return (0, _lodashEs$Q.includes)(wordBoundaries, character);
};

/**
 * Checks whether a word is present in a sentence.
 *
 * @param {string} word The word to search for in the sentence.
 * @param {string} sentence The sentence to look through.
 * @returns {boolean} Whether or not the word is present in the sentence.
 */
const isWordInSentence = function isWordInSentence(word, sentence) {
	// To ensure proper matching, make everything lowercase.
	word = word.toLocaleLowerCase();
	sentence = sentence.toLocaleLowerCase();

	// Escape regex in word, since we use regex characters like in abbreviations ("e.g.").
	const wordWithBoundaries = (0, _addWordboundary2.default)((0, _lodashEs$Q.escapeRegExp)(word));
	let occurrenceStart = sentence.search(new RegExp(wordWithBoundaries, "ig"));
	// Return false if no match has been found.
	if (occurrenceStart === -1) {
		return false;
	}
	/*
 If there is a word boundary before the matched word, the regex includes this word boundary in the match.
 This means that occurrenceStart is the index of the word boundary before the match. Therefore 1 has to
 be added to occurrenceStart, except when there is no word boundary before the match (i.e. at the start
 of a sentence).
  */
	if (occurrenceStart > 0) {
		occurrenceStart += 1;
	}
	const occurrenceEnd = occurrenceStart + word.length;

	// Check if the previous and next character are word boundaries to determine if a complete word was detected
	const previousCharacter = characterInBoundary(sentence[occurrenceStart - 1]) || occurrenceStart === 0;
	const nextCharacter = characterInBoundary(sentence[occurrenceEnd]) || occurrenceEnd === sentence.length;

	return previousCharacter && nextCharacter;
};

matchWordInSentence.characterInBoundary = characterInBoundary;
matchWordInSentence.isWordInSentence = isWordInSentence;
matchWordInSentence.default = {
	characterInBoundary,
	isWordInSentence
};

Object.defineProperty(findTransitionWords, "__esModule", {
	value: true
});

findTransitionWords.default = function (paper) {
	const locale = paper.getLocale();
	const transitionWords = (0, _getTransitionWords2.default)(locale);
	const sentences = (0, _getSentences2$3.default)(paper.getText());
	const sentenceResults = checkSentencesForTransitionWords(sentences, transitionWords);

	return {
		totalSentences: sentences.length,
		sentenceResults: sentenceResults,
		transitionWordSentences: sentenceResults.length
	};
};

var _createRegexFromDoubleArray = createRegexFromDoubleArray;

var _createRegexFromDoubleArray2 = _interopRequireDefault$1a(_createRegexFromDoubleArray);

var _getSentences$3 = getSentences;

var _getSentences2$3 = _interopRequireDefault$1a(_getSentences$3);

var _quotes$5 = quotes;

var _getTransitionWords = getTransitionWords;

var _getTransitionWords2 = _interopRequireDefault$1a(_getTransitionWords);

var _matchWordInSentence$1 = matchWordInSentence;

var _lodashEs$P = require$$1$1;

function _interopRequireDefault$1a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let regexFromDoubleArray = null;
let regexFromDoubleArrayCacheKey = "";

/**
 * Memoizes the createRegexFromDoubleArray with the twoPartTransitionWords.
 *
 * @param {Array} twoPartTransitionWords The array containing two-part transition words.
 *
 * @returns {RegExp} The RegExp to match text with a double array.
 */
function getRegexFromDoubleArray(twoPartTransitionWords) {
	const cacheKey = (0, _lodashEs$P.flattenDeep)(twoPartTransitionWords).join("");
	if (regexFromDoubleArrayCacheKey !== cacheKey || regexFromDoubleArray === null) {
		regexFromDoubleArrayCacheKey = cacheKey;
		regexFromDoubleArray = (0, _createRegexFromDoubleArray2.default)(twoPartTransitionWords);
	}
	return regexFromDoubleArray;
}

/**
 * Matches the sentence against two part transition words.
 *
 * @param {string} sentence The sentence to match against.
 * @param {Array} twoPartTransitionWords The array containing two-part transition words.
 * @returns {Array} The found transitional words.
 */
const matchTwoPartTransitionWords = function matchTwoPartTransitionWords(sentence, twoPartTransitionWords) {
	sentence = (0, _quotes$5.normalizeSingle)(sentence);
	const twoPartTransitionWordsRegex = getRegexFromDoubleArray(twoPartTransitionWords);
	return sentence.match(twoPartTransitionWordsRegex);
};

/**
 * Matches the sentence against transition words.
 *
 * @param {string} sentence The sentence to match against.
 * @param {Array} transitionWords The array containing transition words.
 * @returns {Array} The found transitional words.
 */
const matchTransitionWords = function matchTransitionWords(sentence, transitionWords) {
	sentence = (0, _quotes$5.normalizeSingle)(sentence);
	return transitionWords.filter(word => (0, _matchWordInSentence$1.isWordInSentence)(word, sentence));
};

/**
 * Checks the passed sentences to see if they contain transition words.
 *
 * @param {Array} sentences The sentences to match against.
 * @param {Object} transitionWords The object containing both transition words and two part transition words.
 * @returns {Array} Array of sentence objects containing the complete sentence and the transition words.
 */
const checkSentencesForTransitionWords = function checkSentencesForTransitionWords(sentences, transitionWords) {
	const results = [];

	sentences.forEach(sentence => {
		const twoPartMatches = matchTwoPartTransitionWords(sentence, transitionWords.twoPartTransitionWords());

		if (twoPartMatches !== null) {
			results.push({
				sentence: sentence,
				transitionWords: twoPartMatches
			});

			return;
		}

		const transitionWordMatches = matchTransitionWords(sentence, transitionWords.transitionWords);

		if (transitionWordMatches.length !== 0) {
			results.push({
				sentence: sentence,
				transitionWords: transitionWordMatches
			});

			return;
		}
	});

	return results;
};

var getPassiveVoice = {};

var Sentence$1 = {};

Object.defineProperty(Sentence$1, "__esModule", {
  value: true
});
/**
 * Default attributes to be used by the Sentence if they are left undefined.
 * @type {{locale: string}}
 */
var defaultAttributes$2 = {
  locale: "en_US"
};

/**
 * Construct the Sentence object and set the sentence text and locale.
 *
 * @param {string} sentence The text of the sentence.
 * @param {string} locale The locale.
 * @constructor
 */
var Sentence = function Sentence(sentence, locale) {
  this._sentenceText = sentence || "";
  this._locale = locale || defaultAttributes$2.locale;
  this._isPassive = false;
};

/**
 * Returns the sentence text.
 * @returns {String} The sentence.
 */
Sentence.prototype.getSentenceText = function () {
  return this._sentenceText;
};

/**
 * Returns the locale.
 * @returns {String} The locale.
 */
Sentence.prototype.getLocale = function () {
  return this._locale;
};

/**
 * Returns the passiveness of a sentence.
 *
 * @returns {boolean} True if passive, otherwise returns false.
 */
Sentence.prototype.isPassive = function () {
  return this._isPassive;
};

/**
 * Sets the passiveness of the sentence.
 *
 * @param {boolean} passive Whether the sentence is passive or not.
 * @returns {void}
 */
Sentence.prototype.setPassive = function (passive) {
  this._isPassive = passive;
};

/**
 * Serializes the Sentence instance to an object.
 *
 * @returns {Object} The serialized Participle.
 */
Sentence.prototype.serialize = function () {
  return {
    _parseClass: "Sentence",
    sentenceText: this._sentenceText,
    locale: this._locale,
    isPassive: this._isPassive
  };
};

/**
 * Parses the object to a Sentence.
 *
 * @param {Object} serialized The serialized object.
 *
 * @returns {Sentence} The parsed Sentence.
 */
Sentence.parse = function (serialized) {
  const sentence = new Sentence(serialized.sentenceText, serialized.locale);
  sentence.setPassive(serialized.isPassive);

  return sentence;
};

Sentence$1.default = Sentence;

var determinePassiveSentencePart = {};

var determineSentencePartIsPassive = {};

Object.defineProperty(determineSentencePartIsPassive, "__esModule", {
	value: true
});

determineSentencePartIsPassive.default = function (participles) {
	let passive = false;
	(0, _lodashEs$O.forEach)(participles, function (participle) {
		if (participle.determinesSentencePartIsPassive()) {
			passive = true;
		}
	});
	return passive;
};

var _lodashEs$O = require$$1$1;

var getParticiples$2 = {};

var matchParticiples$1 = {};

var irregulars$3 = {};

Object.defineProperty(irregulars$3, "__esModule", {
	value: true
});

irregulars$3.default = function () {
	return ["arisen", "awoken", "reawoken", "babysat", "backslid", "backslidden", "beat", "beaten", "become", "begun", "bent", "unbent", "bet", "bid", "outbid", "rebid", "underbid", "overbid", "bidden", "bitten", "blown", "bought", "overbought", "bound", "unbound", "rebound", "broadcast", "rebroadcast", "broken", "brought", "browbeat", "browbeaten", "built", "prebuilt", "rebuilt", "overbuilt", "burnt", "burst", "bust", "cast", "miscast", "recast", "caught", "chosen", "clung", "come", "overcome", "cost", "crept", "cut", "undercut", "recut", "daydreamt", "dealt", "misdealt", "redealt", "disproven", "done", "predone", "outdone", "misdone", "redone", "overdone", "undone", "drawn", "outdrawn", "redrawn", "overdrawn", "dreamt", "driven", "outdriven", "drunk", "outdrunk", "overdrunk", "dug", "dwelt", "eaten", "overeaten", "fallen", "felt", "fit", "refit", "retrofit", "flown", "outflown", "flung", "forbidden", "forecast", "foregone", "foreseen", "foretold", "forgiven", "forgotten", "forsaken", "fought", "outfought", "found", "frostbitten", "frozen", "unfrozen", "given", "gone", "undergone",
	//	Is also auxiliary: "got",
	"gotten", "ground", "reground", "grown", "outgrown", "regrown", "had", "handwritten", "heard", "reheard", "misheard", "overheard", "held", "hewn", "hidden", "unhidden", "hit", "hung", "rehung", "overhung", "unhung", "hurt", "inlaid", "input", "interwound", "interwoven", "jerry-built", "kept", "knelt", "knit", "reknit", "unknit", "known", "laid", "mislaid", "relaid", "overlaid", "lain", "underlain", "leant", "leapt", "outleapt", "learnt", "unlearnt", "relearnt", "mislearnt", "left", "lent", "let", "lip-read", "lit", "relit", "lost", "made", "premade", "remade", "meant", "met", "mown", "offset", "paid", "prepaid", "repaid", "overpaid", "partaken", "proofread", "proven", "put", "quick-frozen", "quit", "read", "misread", "reread", "retread", "rewaken", "rid", "ridden", "outridden", "overridden", "risen", "roughcast", "run", "outrun", "rerun", "overrun", "rung", "said", "sand-cast", "sat", "outsat", "sawn", "seen", "overseen", "sent", "resent", "set", "preset", "reset", "misset", "sewn", "resewn", "oversewn", "unsewn", "shaken", "shat", "shaven", "shit", "shone", "outshone", "shorn", "shot", "outshot", "overshot", "shown", "shrunk", "preshrunk", "shut", "sight-read", "slain", "slept", "outslept", "overslept", "slid", "slit", "slung", "unslung", "slunk", "smelt", "outsmelt", "snuck", "sold", "undersold", "presold", "outsold", "resold", "oversold", "sought", "sown", "spat", "spelt", "misspelt", "spent", "underspent", "outspent", "misspent", "overspent", "spilt", "overspilt", "spit", "split", "spoilt", "spoken", "outspoken", "misspoken", "overspoken", "spread", "sprung", "spun", "unspun", "stolen", "stood", "understood", "misunderstood", "strewn", "stricken", "stridden", "striven", "struck", "strung", "unstrung", "stuck", "unstuck", "stung", "stunk", "sublet", "sunburnt", "sung", "outsung", "sunk", "sweat", "swept", "swollen", "sworn", "outsworn", "swum", "outswum", "swung", "taken", "undertaken", "mistaken", "retaken", "overtaken", "taught", "mistaught", "retaught", "telecast", "test-driven", "test-flown", "thought", "outthought", "rethought", "overthought", "thrown", "outthrown", "overthrown", "thrust", "told", "retold", "torn", "retorn", "trod", "trodden", "typecast", "typeset", "upheld", "waylaid", "wept", "wet", "rewet", "withdrawn", "withheld", "withstood", "woken", "won", "rewon", "worn", "reworn", "wound", "rewound", "overwound", "unwound", "woven", "rewoven", "unwoven", "written", "typewritten", "underwritten", "outwritten", "miswritten", "rewritten", "overwritten", "wrung"];
};

var irregulars$2 = {};

Object.defineProperty(irregulars$2, "__esModule", {
	value: true
});

irregulars$2.default = function () {
	return {
		irregularsRegular: irregularsRegular,
		irregularsIrregular: irregularsIrregular,
		irregularsEndingInS: irregularsEndingInS
	};
};

/*
This is a list of irregular participles used in French.
These participles have an irregular stem but follow a regular conjugation pattern for feminine and plural forms (adding -e, -es, -s).
The following participles were excluded because they are intransitive verbs that cannot be passive:
apparu, réapparu, devenu, redevenu, intervenu, mort, parti, parvenu, provenu, resurvenu, revenu, survenu, venu.
 */
var irregularsRegular = ["abâtardi", "abattu", "abêti", "aboli", "abouti", "abruti", "abstenu", "abstrait", "accompli", "accouru", "accroupi", "accru", "accueilli", "adjoint", "adouci", "advenu", "affadi", "affaibli", "affermi", "agi", "agrandi", "aguerri", "ahuri", "aigri", "alangui", "alenti", "alourdi", "aluni", "amaigri", "amati", "amerri", "aminci", "amoindri", "amolli", "amorti", "anéanti", "apâli", "aperçu", "aplani", "appartenu", "appauvri", "appendu", "appesanti", "applaudi", "approfondi", "arrondi", "assagi", "assailli", "assaini", "asservi", "assombri", "assorti", "assoupi", "assoupli", "assourdi", "assouvi", "assujetti", "astreint", "attendri", "attendu", "atterri", "attiédi", "attrait", "autodétruit", "avachi", "aveuli", "avili", "banni", "barri", "bâti", "battu", "béni", "blanchi", "blêmi", "bleui", "blondi", "blotti", "bonni", "bouffi", "bouilli", "bruni", "bu", "calmi", "candi", "ceint", "chéri", "choisi", "circonscrit", "circonvenu", "combattu", "comparu", "compati", "conclu", "concouru", "condescendu", "conduit", "confit", "confondu", "conjoint", "connu", "consenti", "construit", "contenu", "contraint", "contredit", "contrefait", "contrevenu", "convaincu", "convenu", "converti", "coproduit", "correspondu", "couru", "cousu", "craint", "cramoisi", "crépi", "croupi", "cru", "cueilli", "cuit", "débattu", "décati", "déchu", "déconfit", "déconstruit", "décousu", "découvert", "décrépi", "décrit", "décru", "déçu", "dédit", "déduit", "défailli", "défendu", "défini", "défleuri", "défraîchi", "dégarni", "dégluti", "dégourdi", "démenti", "démoli", "démordu", "démuni", "départi", "dépeint", "dépendu", "dépéri", "déplu", "dépoli", "dépourvu", "désobéi", "desservi", "déteint", "détendu", "détenu", "détruit", "dévêtu", "discouru", "disjoint", "disparu", "distendu", "distrait", "dit", "diverti", "dormi", "durci", "ébahi", "ébaubi", "ébaudi", "éclairci", "éconduit", "écrit", "élargi", "élu", "embelli", "embouti", "émoulu", "empli", "empreint", "empuanti", "ému", "enchéri", "encouru", "endolori", "endormi", "enduit", "endurci", "enfoui", "enfreint", "enfui", "englouti", "engourdi", "enhardi", "enjoint", "enlaidi", "ennobli", "enorgueilli", "enrichi", "enseveli", "entendu", "entr'aperçu", "entraperçu", "entreclos", "entremis", "entretenu", "entrevu", "entrouvert", "envahi", "épanoui", "éperdu", "équarri", "équivalu", "estourbi", "établi", "éteint", "étendu", "étourdi", "étréci", "étreint", "eu", "évanoui", "exclu", "extrait", "faibli", "fait", "fallu", "farci", "feint", "fendu", "fini", "fléchi", "fleuri", "fondu", "forci", "foui", "fourbi", "fourni", "foutu", "fraîchi", "franchi", "frémi", "frit", "fui", "garanti", "garni", "gauchi", "gémi", "glapi", "grandi", "grossi", "guéri", "haï", "imparti", "induit", "infléchi", "inscrit", "instruit", "interdit", "interrompu", "interverti", "introduit", "inverti", "investi", "jailli", "jauni", "joint", "joui", "langui", "loti", "lu", "maintenu", "méconnu", "mécru", "médit", "menti", "minci", "moisi", "moiti", "molli", "mordu", "morfondu", "moulu", "mugi", "muni", "nanti", "noirci", "nourri", "nui", "obéi", "obscurci", "obtenu", "offert", "oint", "ouï", "ourdi", "ouvert", "pâli", "parcouru", "paru", "pâti", "peint", "pendu", "perçu", "péri", "perverti", "pétri", "plaint", "portrait", "pourfendu", "pourri", "poursuivi", "pourvu", "prédéfini", "prédit", "préétabli", "prémuni", "prescrit", "prétendu", "prévalu", "prévenu", "prévu", "produit", "promu", "proscrit", "pu", "puni", "rabattu", "rabougri", "radouci", "raffermi", "ragaillardi", "raidi", "rajeuni", "ralenti", "ramolli", "ranci", "ravi", "réadmis", "réagi", "réappris", "rebâti", "rebattu", "rebondi", "rebu", "reconnu", "reconstruit", "reconverti", "recouru", "recouvert", "recrépi", "récrit", "recru", "reçu", "recueilli", "recuit", "redécouvert", "redéfini", "redit", "réduit", "réécrit", "réélu", "réentendu", "refendu", "réfléchi", "refondu", "refoutu", "refroidi", "regarni", "régi", "réinscrit", "réintroduit", "réinvesti", "rejoint", "réjoui", "relu", "relui", "rembruni", "remordu", "rempli", "renchéri", "rendormi", "rendu", "rentrait", "répandu", "reparcouru", "réparti", "reparu", "repeint", "rependu", "repenti", "reperdu", "répondu", "reproduit", "résolu", "resplendi", "ressaisi", "resservi", "restreint", "resurgi", "rétabli", "retendu", "retenu", "retraduit", "retrait", "retranscrit", "rétréci", "réuni", "réussi", "revécu", "revendu", "reverdi", "reverni", "revêtu", "revu", "ri", "roidi", "rosi", "rôti", "rougi", "roussi", "rousti", "rouvert", "rugi", "saisi", "sali", "satisfait", "sauri", "secouru", "séduit", "senti", "serti", "servi", "sévi", "souffert", "souri", "sous-entendu", "sous-tendu", "souscrit", "soustrait", "soutenu", "souvenu", "su", "subi", "subvenu", "suffi", "suivi", "surenchéri", "surgi", "suri", "survécu", "suspendu", "tapi", "tari", "teint", "tendu", "tenu", "terni", "terri", "tiédi", "tondu", "tordu", "traduit", "trahi", "trait", "transcrit", "transi", "travesti", "tressailli", "uni", "vagi", "vaincu", "valu", "vécu", "vendu", "verdi", "verni", "vêtu", "vieilli", "vomi", "voulu", "vu"];

/*
This is a list of irregular participles used in French.
These participles have an irregular stem and follow an irregular conjugation pattern. Therefore all forms are included in the list.
 */
var irregularsIrregular = ["absous", "absoute", "absoutes", "dissous", "dissoute", "dissoutes", "crû", "crus", "crue", "crues", "dû", "dus", "dues", "mû", "mus", "mue", "mues"];

/*
This is a list of irregular participles used in French.
These participles have an irregular stem ending in -s. They have the same form in the masculine singular and plural.
For feminine singular and feminine plural forms -e and -es are added.
 */
var irregularsEndingInS = ["repris", "démis", "omis", "dépris", "retransmis", "assis", "promis", "circoncis", "permis", "compris", "mépris", "inclus", "soumis", "rassis", "sursis", "enclos", "acquis", "compromis", "commis", "désappris", "appris", "conquis", "transmis", "remis", "surpris", "reconquis", "mis", "enquis", "pris", "admis", "clos", "émis", "entrepris", "épris", "requis"];

var participles$5 = {};

Object.defineProperty(participles$5, "__esModule", {
	value: true
});

participles$5.default = function () {
	return ["abajado", "abalanzado", "abaleado", "abandonado", "abaratado", "abarcado", "abarrotado", "abastecido", "abatido", "abdicado", "abierto", "abismado", "abjurado", "ablandado", "abocado", "abochornado", "abofeteado", "abolido", "abollado", "abombado", "abominado", "abonado", "abordado", "aborrecido", "aborregado", "abortado", "abotonado", "abrasado", "abrazado", "abrevado", "abreviado", "abrigado", "abrochado", "abrogado", "abroquelado", "abrumado", "absorbido", "abstenido", "abstraído", "absuelto", "abucheado", "abultado", "abundado", "aburguesado", "aburrido", "abusado", "acabado", "acallado", "acalorado", "acaparado", "acariciado", "acarreado", "acatado", "acaudillado", "accedido", "accionado", "acechado", "aceitado", "acelerado", "acentuado", "aceptado", "acerado", "acercado", "acertado", "achacado", "achantado", "achatado", "achicado", "acicalado", "acidificado", "aclarado", "aclimatado", "acobardado", "acodado", "acogido", "acojonado", "acometido", "acomodado", "acompañado", "acompasado", "acongojado", "aconsejado", "acontecido", "acopiado", "acoplado", "acordado", "acordonado", "acorralado", "acortado", "acosado", "acostado", "acostumbrado", "acotado", "acrecentado", "acreditado", "acrisolado", "activado", "actuado", "acuchillado", "acuciado", "acudido", "acuerpado", "acumulado", "acunado", "acuñado", "acurrucado", "acusado", "adaptado", "adecentado", "adelantado", "adelgazado", "adentrado", "adeudado", "adherido", "adicionado", "adiestrado", "adivinado", "adjetivado", "adjudicado", "adjuntado", "administrado", "admirado", "admitido", "adoctrinado", "adolecido", "adoptado", "adorado", "adormecido", "adornado", "adquirido", "aducido", "adueñado", "adulado", "adulterado", "advertido", "afanado", "afeado", "afectado", "afeitado", "aferrado", "afianzado", "afinado", "afirmado", "afligido", "aflorado", "afrentado", "afrontado", "agachado", "agarrado", "agarrotado", "agasajado", "agenciado", "agigantado", "agilizado", "agitado", "aglutinado", "agobiado", "agolpado", "agonizado", "agostado", "agotado", "agradado", "agradecido", "agrandado", "agravado", "agraviado", "agredido", "agregado", "agriado", "agrietado", "agrupado", "aguado", "aguantado", "aguardado", "agudizado", "aguijoneado", "agujereado", "aguzado", "ahogado", "ahondado", "ahorcado", "ahorrado", "ahuecado", "ahuyentado", "aireado", "aislado", "ajustado", "ajusticiado", "alabado", "alagado", "alambrado", "alardeado", "alargado", "alarmado", "albergado", "alborotado", "alcanzado", "aleccionado", "alegado", "alegrado", "alejado", "alentado", "alertado", "alfabetizado", "alfombrado", "aliado", "alienado", "aligerado", "alimentado", "aliñado", "alineado", "alisado", "alistado", "aliviado", "alivianado", "allanado", "almacenado", "almorzado", "alojado", "alquilado", "alterado", "alternado", "alucinado", "aludido", "alumbrado", "alzado", "amado", "amaestrado", "amagado", "amainado", "amalgamado", "amamantado", "amansado", "amargado", "amarrado", "amasado", "ambicionado", "amedrentado", "amenazado", "amenizado", "ameritado", "ametrallado", "amilanado", "aminorado", "amnistiado", "amoldado", "amonestado", "amontonado", "amordazado", "amortajado", "amortiguado", "amortizado", "amotinado", "amparado", "ampayado", "ampliado", "amplificado", "amputado", "amueblado", "añadido", "analizado", "anatematizado", "andado", "anegado", "anestesiado", "anexado", "anexionado", "anhelado", "anidado", "anillado", "animado", "aniquilado", "anisado", "añorado", "anotado", "anoticiado", "ansiado", "antecedido", "antepuesto", "anticipado", "antojado", "anudado", "anulado", "anunciado", "apabullado", "apachurrado", "apaciguado", "apadrinado", "apagado", "apalancado", "apaleado", "apañado", "apantallado", "aparcado", "apareado", "aparecido", "aparentado", "apartado", "apeado", "apedreado", "apelado", "apellidado", "apelmazado", "apercibido", "apersonado", "apestado", "apetecido", "apiadado", "apilado", "apiñado", "apisonado", "aplacado", "aplanado", "aplastado", "aplaudido", "aplazado", "aplicado", "apoderado", "apoltronado", "aporreado", "aportado", "aposentado", "apostado", "apostatado", "apostillado", "apoyado", "apreciado", "aprehendido", "apremiado", "aprendido", "apresado", "apresurado", "apretado", "apretujado", "aprisionado", "aprobado", "aprovechado", "aprovisionado", "aproximado", "apuñalado", "apuñaleado", "apuntado", "apuntalado", "apuntillado", "apurado", "aquejado", "aquietado", "aquilatado", "arañado", "arbitrado", "archivado", "arengado", "argüido", "argumentado", "armado", "armonizado", "aromatizado", "arqueado", "arrancado", "arrasado", "arrastrado", "arreado", "arrebatado", "arreciado", "arreglado", "arrellanado", "arremangado", "arremetido", "arrendado", "arrepentido", "arrestado", "arriado", "arribado", "arriesgado", "arrimado", "arrinconado", "arrodillado", "arrogado", "arrojado", "arrollado", "arropado", "arruinado", "arrullado", "articulado", "asado", "asaltado", "ascendido", "aseado", "asechado", "asediado", "asegurado", "asemejado", "asentado", "asentido", "aserrado", "asesinado", "asesorado", "asestado", "aseverado", "asfixiado", "asido", "asignado", "asilado", "asimilado", "asistido", "asolado", "asoleado", "asomado", "asombrado", "aspirado", "astillado", "asumido", "asustado", "atacado", "atado", "atajado", "atarantado", "atascado", "atemorizado", "atemperado", "atenazado", "atendido", "atenido", "atentado", "atenuado", "aterrado", "aterrorizado", "atesorado", "atestiguado", "atiborrado", "atisbado", "atizado", "atomizado", "atontado", "atorado", "atormentado", "atornillado", "atosigado", "atracado", "atragantado", "atraído", "atrancado", "atrapado", "atrasado", "atravesado", "atrevido", "atribuido", "atrincherado", "atrofiado", "atropellado", "aturdido", "auditado", "augurado", "aumentado", "aunado", "aupado", "auscultado", "ausentado", "autenticado", "autentificado", "autodefinido", "autoeditado", "automatizado", "autorizado", "autorregulado", "auxiliado", "avalado", "avanzado", "avasallado", "avenido", "aventado", "aventajado", "aventurado", "averiado", "averiguado", "avezado", "avisado", "avispado", "avistado", "avivado", "avizorado", "avocado", "ayudado", "azotado", "azuzado", "babeado", "bailado", "bajado", "balaceado", "balanceado", "bañado", "banalizado", "bancado", "bandeado", "barajado", "barrido", "basado", "bastardeado", "basureado", "batallado", "bateado", "batido", "bautizado", "beatificado", "bebido", "beneficiado", "besado", "bifurcado", "birlado", "blandido", "blanqueado", "blasfemado", "blindado", "bloqueado", "boicoteado", "bombardeado", "bombeado", "bonificado", "bordeado", "borrado", "borroneado", "bosquejado", "bostezado", "botado", "boxeado", "bregado", "brillado", "brincado", "brindado", "bromeado", "brotado", "bruñido", "buceado", "burlado", "buscado", "cabeceado", "cabido", "cabildeado", "cabreado", "cacareado", "cachado", "cacheado", "cacheteado", "caducado", "cagado", "calado", "calculado", "caldeado", "calefaccionado", "calendarizado", "calentado", "calibrado", "calificado", "caligrafiado", "callado", "calmado", "calumniado", "calzado", "cambiado", "caminado", "camuflado", "canalizado", "cancelado", "canjeado", "cansado", "cantado", "capado", "capeado", "capitalizado", "capitulado", "captado", "capturado", "caracterizado", "carburado", "carcomido", "cardado", "careado", "carecido", "cargado", "caricaturizado", "cartografiado", "cascado", "castigado", "castrado", "catado", "catalizado", "catalogado", "catapultado", "cateado", "categorizado", "causado", "cauterizado", "cautivado", "cavado", "cavilado", "cazado", "cebado", "cedido", "cegado", "cejado", "celebrado", "cenado", "ceñido", "censurado", "centrifugado", "centuplicado", "cepillado", "cercado", "cercenado", "cerciorado", "cernido", "cerrado", "cesado", "chafado", "chamuscado", "chantajeado", "chapado", "charlado", "chateado", "chequeado", "chiflado", "chillado", "chingado", "chirriado", "chivado", "chocado", "chorreado", "choteado", "chupado", "chutado", "cicatrizado", "cifrado", "cimentado", "cincelado", "circulado", "circuncidado", "circundado", "citado", "clamado", "clarificado", "clasificado", "claudicado", "clausurado", "clavado", "clicado", "clonado", "coaccionado", "coadyuvado", "coagulado", "coaligado", "coartado", "cobijado", "cobrado", "cocido", "cocinado", "codeado", "codiciado", "codificado", "codirigido", "coexistido", "cofinanciado", "cogido", "cohabitado", "cohibido", "coincidido", "colaborado", "colacionado", "colado", "colapsado", "coleccionado", "colectado", "colectivizado", "colgado", "colisionado", "colmado", "colocado", "colonizado", "coloreado", "columpiado", "combatido", "combinado", "comentado", "comenzado", "comerciado", "comercializado", "cometido", "comido", "comisionado", "compactado", "compadecido", "compaginado", "comparado", "comparecido", "compartido", "compatibilizado", "compelido", "compendiado", "compenetrado", "compensado", "compilado", "complacido", "complementado", "completado", "complotado", "comportado", "comprado", "comprendido", "comprimido", "comprobado", "comprometido", "compuesto", "compulsado", "computado", "comulgado", "comunicado", "concatenado", "concebido", "concedido", "concelebrado", "concentrado", "conceptuado", "conceptualizado", "concertado", "concienciado", "concientizado", "conciliado", "concitado", "concluido", "concordado", "concretado", "concretizado", "conculcado", "concursado", "condenado", "condensado", "condicionado", "condimentado", "condolido", "condonado", "conducido", "conectado", "conexionado", "confabulado", "confeccionado", "conferido", "confesado", "confiado", "configurado", "confirmado", "confiscado", "confluido", "conformado", "confortado", "confrontado", "confundido", "congeniado", "congestionado", "congratulado", "congregado", "conjeturado", "conjugado", "conjuntado", "conjurado", "conllevado", "conmemorado", "conminado", "conmocionado", "conmovido", "conmutado", "connotado", "conquistado", "consagrado", "conseguido", "consensuado", "consentido", "conservado", "considerado", "consignado", "consistido", "consolado", "consolidado", "conspirado", "constado", "constatado", "constelado", "constitucionalizado", "constituido", "constreñido", "construido", "consultado", "consumado", "consumido", "contabilizado", "contactado", "contado", "contagiado", "contemplado", "contendido", "contenido", "contentado", "contestado", "contextualizado", "continuado", "contorneado", "contraatacado", "contrabandeado", "contradicho", "contrahecho", "contraído", "contrapesado", "contrapuesto", "contrariado", "contrarrestado", "contrastado", "contratado", "contravenido", "contribuido", "contristado", "controlado", "convalidado", "convencido", "convenido", "convergido", "conversado", "convertido", "convidado", "convivido", "convocado", "convulsionado", "cooperado", "cooptado", "coordinado", "copado", "copiado", "coproducido", "copulado", "coqueteado", "corchado", "coreado", "coreografiado", "corneado", "coronado", "corporizado", "corregido", "correlacionado", "correspondido", "correteado", "corrido", "corroborado", "corroído", "corrompido", "cortado", "cortejado", "cosechado", "cosido", "cosificado", "costado", "costeado", "cotejado", "cotizado", "creado", "creído", "criado", "cribado", "criminalizado", "crispado", "cristalizado", "cristianizado", "criticado", "cronometrado", "crucificado", "crujido", "cruzado", "cuadriplicado", "cuadruplicado", "cuajado", "cuantificado", "cuarteado", "cubierto", "cuestionado", "cuidado", "culeado", "culminado", "culpabilizado", "culpado", "cultivado", "culturizado", "cumplido", "cumplimentado", "cundido", "curado", "curioseado", "currado", "cursado", "curvado", "custodiado", "dado", "dañado", "danzado", "datado", "dateado", "debatido", "debido", "debilitado", "debitado", "debutado", "decaído", "decantado", "decapitado", "decepcionado", "decidido", "declamado", "declarado", "declinado", "decodificado", "decolorado", "decomisado", "decrecido", "decretado", "dedicado", "deducido", "defecado", "defendido", "defenestrado", "deferido", "definido", "deformado", "defraudado", "degenerado", "deglutido", "degollado", "degradado", "degustado", "deificado", "dejado", "delatado", "delegado", "deleitado", "deletreado", "deliberado", "delimitado", "delineado", "delinquido", "demandado", "demarcado", "demediado", "demeritado", "democratizado", "demolido", "demonizado", "demorado", "demostrado", "demudado", "denegado", "denigrado", "denominado", "denostado", "denotado", "denunciado", "deparado", "departido", "dependido", "depilado", "deplorado", "deportado", "depositado", "depreciado", "depredado", "deprimido", "depuesto", "depurado", "derechizado", "derivado", "derogado", "derramado", "derretido", "derribado", "derrocado", "derrochado", "derrotado", "derruido", "derrumbado", "desabrochado", "desacatado", "desacelerado", "desacomodado", "desaconsejado", "desacoplado", "desacralizado", "desacreditado", "desactivado", "desafiado", "desafinado", "desaguado", "desahogado", "desairado", "desajustado", "desalentado", "desalineado", "desalojado", "desandado", "desangrado", "desanimado", "desaparecido", "desapegado", "desaprendido", "desaprobado", "desaprovechado", "desarmado", "desarraigado", "desarreglado", "desarrollado", "desarticulado", "desaseado", "desasido", "desasosegado", "desatado", "desatendido", "desautorizado", "desayunado", "desbancado", "desbandado", "desbaratado", "desbarrancado", "desbastado", "desbloqueado", "desbocado", "desbordado", "desbrozado", "descabalgado", "descabezado", "descaderado", "descalabrado", "descalificado", "descansado", "descargado", "descarriado", "descarrilado", "descartado", "descascarado", "descascarillado", "descendido", "descentrado", "descifrado", "descocido", "descodificado", "descojonado", "descolgado", "descolocado", "descolonizado", "descompensado", "descomprimido", "descompuesto", "desconectado", "desconfiado", "descongelado", "desconocido", "descontado", "descontaminado", "descontextualizado", "descontinuado", "desconvocado", "descorazonado", "descorchado", "descorrido", "descosido", "descoyuntado", "descreído", "descristianizado", "descuadrado", "descuartizado", "descubierto", "descuidado", "desdeñado", "desdibujado", "desdicho", "desdoblado", "deseado", "desecado", "desechado", "desembarazado", "desembarcado", "desembocado", "desembolsado", "desempacado", "desempañado", "desempaquetado", "desempeñado", "desempolvado", "desenamorado", "desencadenado", "desencajado", "desencarnado", "desenchufado", "desenfocado", "desenfundado", "desenganchado", "desengrasado", "desenmascarado", "desenredado", "desenrollado", "desentendido", "desenterrado", "desentonado", "desentrañado", "desenvainado", "desenvuelto", "desequilibrado", "desertado", "desestabilizado", "desestimado", "desfalcado", "desfallecido", "desfigurado", "desfondado", "desgajado", "desgañitado", "desgarrado", "desgastado", "desglosado", "desgobernado", "desgranado", "desguazado", "deshecho", "desheredado", "deshidratado", "deshilachado", "deshojado", "deshonrado", "deshuesado", "deshumanizado", "designado", "desilusionado", "desincentivado", "desinfectado", "desinflado", "desinflamado", "desinformado", "desinhibido", "desinstalado", "desintegrado", "desintoxicado", "desistido", "desjarretado", "deslegitimado", "desleído", "desligado", "deslindado", "deslizado", "deslucido", "deslumbrado", "desmadrado", "desmalezado", "desmantelado", "desmaquillado", "desmarcado", "desmayado", "desmejorado", "desmembrado", "desmentido", "desmenuzado", "desmerecido", "desmigado", "desmitificado", "desmoldado", "desmontado", "desmoralizado", "desmoronado", "desmotivado", "desmovilizado", "desnaturalizado", "desnivelado", "desnucado", "desnudado", "desobedecido", "desobligado", "desoído", "desollado", "desorganizado", "desorientado", "despachado", "desparasitado", "desparecido", "desparramado", "despedazado", "despedido", "despegado", "despeinado", "despejado", "despellejado", "despeñado", "despenalizado", "desperdiciado", "despersonalizado", "despertado", "despilfarrado", "despintado", "despiojado", "despistado", "desplazado", "desplegado", "desplomado", "desplumado", "despojado", "despolitizado", "desposado", "desposeído", "despotricado", "despreciado", "desprendido", "despreocupado", "desprestigiado", "desprogramado", "despulpado", "despuntado", "desquiciado", "desquitado", "destacado", "destapado", "desteñido", "desterrado", "destetado", "destilado", "destituido", "destrabado", "destripado", "destronado", "destrozado", "destruido", "desunido", "desvalijado", "desvalorizado", "desvanecido", "desvelado", "desvestido", "desviado", "desvinculado", "desvirtuado", "desvivido", "detectado", "detenido", "detentado", "deteriorado", "determinado", "detestado", "detonado", "devaluado", "devanado", "devastado", "develado", "devengado", "devenido", "devorado", "devuelto", "diagnosticado", "diagramado", "dializado", "dialogado", "dibujado", "dicho", "dictado", "dictaminado", "diezmado", "difamado", "diferenciado", "diferido", "dificultado", "difuminado", "difundido", "digerido", "digitado", "dignado", "dignificado", "dilapidado", "dilatado", "diligenciado", "dilucidado", "diluido", "dimensionado", "dimitido", "dinamitado", "dinamizado", "dirimido", "discernido", "disciplinado", "discontinuado", "discrepado", "discriminado", "disculpado", "discurrido", "discutido", "diseccionado", "diseminado", "diseñado", "disentido", "disertado", "disfrazado", "disfrutado", "disgregado", "disgustado", "disimulado", "disipado", "dislocado", "disminuido", "disociado", "dispensado", "dispersado", "dispuesto", "disputado", "distado", "distanciado", "distendido", "distinguido", "distorsionado", "distraído", "distribuido", "disuadido", "disuelto", "divagado", "diversificado", "divertido", "dividido", "divinizado", "divisado", "divorciado", "divulgado", "doblado", "doblegado", "doctorado", "documentado", "dogmatizado", "dolido", "domado", "domesticado", "dominado", "donado", "dopado", "dormido", "dosificado", "dotado", "dragado", "dramatizado", "drenado", "drogado", "duchado", "dudado", "dulcificado", "duplicado", "durado", "echado", "eclipsado", "eclosionado", "economizado", "ecualizado", "edificado", "editado", "educado", "efectuado", "ejecutado", "ejemplificado", "ejercido", "ejercitado", "elaborado", "electrizado", "electrocutado", "elevado", "elidido", "eliminado", "elogiado", "elucubrado", "eludido", "emanado", "emancipado", "embadurnado", "embalado", "embalsamado", "embanderado", "embarcado", "embargado", "embarrado", "embarrancado", "embaucado", "embebido", "embelesado", "embellecido", "embestido", "embolado", "embolsado", "emborrachado", "emborronado", "emboscado", "embotado", "embriagado", "embrollado", "embrutecido", "embuchado", "emergido", "emigrado", "emitido", "emocionado", "empacado", "empachado", "empadronado", "empalado", "empalmado", "empanado", "empañado", "empantanado", "empapelado", "empaquetado", "emparejado", "empastado", "empatado", "empecinado", "empeñado", "empeorado", "empequeñecido", "emperrado", "empezado", "empinado", "emplazado", "empleado", "empobrecido", "empoderado", "empollado", "empolvado", "emponzoñado", "emprendido", "empujado", "empuñado", "emputado", "emulado", "emulsionado", "enajenado", "enaltecido", "enamorado", "enarbolado", "enardecido", "encabezado", "encabritado", "encabronado", "encadenado", "encajado", "encajonado", "encallado", "encamado", "encaminado", "encandilado", "encanecido", "encañonado", "encantado", "encaprichado", "encapsulado", "encarado", "encaramado", "encarecido", "encargado", "encariñado", "encarnado", "encarrilado", "encartado", "encasillado", "encasquetado", "encasquillado", "encastrado", "encausado", "encauzado", "enceguecido", "encendido", "encerado", "encerrado", "encharcado", "enchufado", "encimado", "encogido", "encolado", "encolerizado", "encolumnado", "encomendado", "enconado", "encontrado", "encordado", "encrespado", "encuadrado", "encubierto", "encuerado", "encumbrado", "enderezado", "endeudado", "endilgado", "endiosado", "endosado", "endulzado", "endurecido", "enemistado", "energizado", "enervado", "enfadado", "enfangado", "enfatizado", "enfermado", "enfiestado", "enfilado", "enflaquecido", "enfocado", "enfrascado", "enfrentado", "enfriado", "enfurecido", "engalanado", "engañado", "enganchado", "engarzado", "engatusado", "engendrado", "englobado", "engolosinado", "engordado", "engranado", "engrandecido", "engrasado", "engreído", "engrosado", "engullido", "enharinado", "enhebrado", "enjuagado", "enjugado", "enjuiciado", "enlazado", "enlistado", "enlodado", "enloquecido", "enlozado", "enlutado", "enmarañado", "enmascarado", "enmendado", "enmohecido", "enmudecido", "ennegrecido", "ennoblecido", "enorgullecido", "enrarecido", "enredado", "enripiado", "enriquecido", "enrocado", "enrojecido", "enrolado", "enrollado", "enroscado", "enrumbado", "ensalzado", "ensamblado", "ensañado", "ensanchado", "ensartado", "ensayado", "ensebado", "enseñado", "enseñoreado", "ensillado", "ensoberbecido", "ensogado", "ensombrecido", "ensoñado", "ensordecido", "ensuciado", "entablado", "entallado", "entendido", "enterado", "enternecido", "enterrado", "entibiado", "entintado", "entonado", "entorpecido", "entrado", "entrampado", "entrañado", "entreabierto", "entrecomillado", "entrecruzado", "entregado", "entrelazado", "entremetido", "entremezclado", "entrenado", "entresacado", "entretejido", "entretenido", "entreverado", "entrevistado", "entristecido", "entrometido", "entronado", "entroncado", "entronizado", "entumecido", "enturbiado", "entusiasmado", "enumerado", "enunciado", "envainado", "envalentonado", "envanecido", "envasado", "envejecido", "envenenado", "envestido", "enviado", "enviciado", "envidiado", "envilecido", "enviudado", "envuelto", "enzarzado", "equilibrado", "equiparado", "equivocado", "erigido", "erizado", "erogado", "erosionado", "erotizado", "erradicado", "errado", "esbozado", "escabullido", "escalado", "escaldado", "escalfado", "escamado", "escamoteado", "escampado", "escandalizado", "escaneado", "escapado", "escaqueado", "escarbado", "escarchado", "escarmentado", "escarnecido", "escaseado", "escatimado", "escenificado", "escindido", "esclarecido", "esclavizado", "escocido", "escogido", "escolarizado", "escoltado", "escondido", "escorado", "escrachado", "escrito", "escrutado", "escuchado", "escudado", "escudriñado", "esculpido", "escupido", "escurrido", "esforzado", "esfumado", "esgrimido", "esmerado", "esmerilado", "espabilado", "espaciado", "españolizado", "espantado", "esparcido", "especificado", "especulado", "esperado", "espesado", "espetado", "espiado", "espigado", "espinado", "espirado", "espiritualizado", "espoleado", "espolvoreado", "esponjado", "esponsorizado", "esposado", "esquematizado", "esquiado", "esquilado", "esquilmado", "esquivado", "estabilizado", "establecido", "estacionado", "estafado", "estallado", "estampado", "estancado", "estaqueado", "estatizado", "estatuido", "esterificado", "esterilizado", "estigmatizado", "estilizado", "estimado", "estimulado", "estipulado", "estirado", "estorbado", "estornudado", "estragado", "estrangulado", "estrechado", "estrellado", "estremecido", "estrenado", "estresado", "estriado", "estropeado", "estructurado", "estrujado", "estudiado", "eternizado", "etiquetado", "evacuado", "evadido", "evaluado", "evangelizado", "evaporado", "evidenciado", "eviscerado", "evitado", "evocado", "evolucionado", "exacerbado", "exagerado", "exaltado", "examinado", "exasperado", "excarcelado", "excavado", "excedido", "exceptuado", "excitado", "exclamado", "excluido", "excretado", "exculpado", "excusado", "execrado", "exhalado", "exhibido", "exhortado", "exhumado", "exigido", "exilado", "eximido", "existido", "exonerado", "exorcizado", "expandido", "expedido", "expedientado", "expelido", "expendido", "experimentado", "expiado", "expirado", "explayado", "explicado", "explicitado", "explorado", "explosionado", "explotado", "expoliado", "exportado", "expresado", "exprimido", "expropiado", "expuesto", "expulsado", "expurgado", "extendido", "exteriorizado", "exterminado", "externado", "externalizado", "extinguido", "extirpado", "extorsionado", "extractado", "extraditado", "extraído", "extralimitado", "extrañado", "extrapolado", "extraviado", "extremado", "extruido", "exudado", "eyaculado", "eyectado", "fabricado", "fabulado", "facilitado", "facturado", "facultado", "fagocitado", "fajado", "fallado", "fallecido", "falsado", "falseado", "falsificado", "familiarizado", "fantaseado", "fascinado", "fastidiado", "fatigado", "favorecido", "fecundado", "felicitado", "feminizado", "fenecido", "fermentado", "fertilizado", "festejado", "fiado", "fichado", "fidelizado", "figurado", "fijado", "filmado", "filosofado", "filtrado", "finalizado", "financiado", "fincado", "fingido", "finiquitado", "firmado", "fiscalizado", "fisurado", "flagelado", "flameado", "flanqueado", "flaqueado", "fletado", "flexibilizado", "flexionado", "flipado", "floreado", "florecido", "flotado", "fluctuado", "focalizado", "fogueado", "foliado", "follado", "fomentado", "fondeado", "forcejeado", "forestado", "forjado", "formado", "formalizado", "formateado", "formulado", "fornicado", "forrado", "fortalecido", "forzado", "fotocopiado", "fotografiado", "fracasado", "fraccionado", "fracturado", "fragmentado", "fraguado", "franqueado", "frecuentado", "fregado", "frenado", "fresado", "friccionado", "frotado", "fructificado", "fruncido", "fugado", "fulminado", "fumado", "fumigado", "funcionado", "fundado", "fundamentado", "fundido", "fungido", "fusilado", "fusionado", "fustigado", "gafado", "ganado", "gangrenado", "garabateado", "garantido", "garantizado", "garrido", "gaseado", "gastado", "gemido", "generado", "generalizado", "gerenciado", "germinado", "gestado", "gestionado", "girado", "glorificado", "glosado", "gobernado", "goleado", "golpeado", "gozado", "grabado", "graduado", "graficado", "granjeado", "grapado", "gratificado", "gravado", "gravitado", "gritado", "gruñido", "guardado", "guarecido", "guarnecido", "guerreado", "guiado", "guillotinado", "guiñado", "guindado", "guisado", "gustado", "habilitado", "habitado", "habituado", "hablado", "halado", "halagado", "hallado", "hartado", "hechizado", "hecho", "helenizado", "henchido", "hendido", "heredado", "herido", "hermanado", "herrado", "hervido", "hibernado", "hibridado", "hidratado", "higienizado", "hilado", "hilvanado", "hincado", "hinchado", "hipnotizado", "hipotecado", "historiado", "hojeado", "holgado", "hollado", "homenajeado", "homogeneizado", "homologado", "honrado", "horadado", "horneado", "horrorizado", "hospedado", "hostigado", "hostilizado", "huido", "humanado", "humanizado", "humectado", "humedecido", "humillado", "hundido", "hurgado", "hurtado", "ideado", "idealizado", "identificado", "ideologizado", "idiotizado", "idolatrado", "ignorado", "igualado", "ilegalizado", "iluminado", "ilusionado", "ilustrado", "imaginado", "imbricado", "imitado", "impactado", "impartido", "impedido", "impelido", "imperado", "impermeabilizado", "implantado", "implementado", "implicado", "implorado", "importado", "importunado", "imposibilitado", "impresionado", "improvisado", "impuesto", "impugnado", "impulsado", "imputado", "inaugurado", "incautado", "incendiado", "incentivado", "incinerado", "incitado", "inclinado", "incluido", "incoado", "incomodado", "incorporado", "incrementado", "increpado", "incriminado", "incubado", "inculcado", "inculpado", "incumplido", "incurrido", "incursionado", "indagado", "indemnizado", "independizado", "indexado", "indicado", "indigestado", "indignado", "indispuesto", "individuado", "inducido", "indultado", "inervado", "infamado", "infartado", "infectado", "inferido", "inficionado", "infiltrado", "inflado", "inflamado", "infligido", "influenciado", "influido", "informado", "infravalorado", "infringido", "infundido", "ingeniado", "ingerido", "ingresado", "inhabilitado", "inhalado", "inhibido", "inhumado", "iniciado", "inicializado", "injertado", "injuriado", "inmigrado", "inmiscuido", "inmolado", "inmortalizado", "inmovilizado", "inmunizado", "innovado", "inoculado", "inquietado", "inquirido", "insensibilizado", "insertado", "insinuado", "insistido", "inspeccionado", "inspirado", "instado", "instalado", "instaurado", "instigado", "instituido", "instruido", "instrumentado", "instrumentalizado", "insuflado", "insultado", "insumido", "integrado", "intelectualizado", "intensificado", "intentado", "interactuado", "intercalado", "intercambiado", "intercedido", "interceptado", "interesado", "interferido", "interiorizado", "intermediado", "internacionalizado", "internalizado", "interpelado", "interpolado", "interpretado", "interpuesto", "interrogado", "interrumpido", "intervenido", "intimado", "intimidado", "intitulado", "intoxicado", "intrigado", "introducido", "intuido", "inundado", "inutilizado", "invadido", "invalidado", "inventado", "inventariado", "invertido", "investido", "investigado", "invitado", "invocado", "involucionado", "inyectado", "ionizado", "ironizado", "irradiado", "irrespetado", "irrigado", "irritado", "irrogado", "irrumpido", "jactado", "jalado", "jaleado", "jalonado", "jaqueado", "jerarquizado", "jodido", "jorobado", "jubilado", "jugado", "juntado", "jurado", "juramentado", "justificado", "juzgado", "laborado", "labrado", "laburado", "lacado", "lacerado", "lactado", "ladeado", "ladrado", "lamentado", "lamido", "laminado", "languidecido", "lanzado", "lapidado", "laqueado", "largado", "lastimado", "lastrado", "latido", "laudado", "lavado", "legalizado", "legislado", "legitimado", "leído", "lesionado", "leudado", "levantado", "liado", "liberado", "liberalizado", "libertado", "librado", "licitado", "licuado", "liderizado", "lidiado", "ligado", "lijado", "limado", "limitado", "limpiado", "linchado", "liquidado", "litigado", "llagado", "llamado", "llegado", "llenado", "llevado", "llorado", "localizado", "logrado", "lubricado", "luchado", "lucido", "lucrado", "lustrado", "macerado", "machacado", "macheteado", "machucado", "madreado", "madrugado", "madurado", "magnetizado", "magnificado", "malacostumbrado", "malbaratado", "malcriado", "maleado", "malentendido", "malgastado", "malinterpretado", "malogrado", "maltratado", "malversado", "mamado", "manchado", "mancillado", "mandado", "manejado", "mangado", "mangoneado", "manifestado", "maniobrado", "manipulado", "manoseado", "manteado", "mantenido", "manufacturado", "maquillado", "maquinado", "maravillado", "marcado", "marchitado", "mareado", "marginado", "maridado", "martillado", "martirizado", "masacrado", "masajeado", "mascado", "masificado", "masticado", "masturbado", "matado", "materializado", "matizado", "matriculado", "maximizado", "meado", "mecanografiado", "mechado", "mecido", "mediado", "mediatizado", "medicado", "medido", "meditado", "medrado", "mejorado", "mellado", "memorizado", "mencionado", "meneado", "menguado", "menoscabado", "menospreciado", "menstruado", "mensualizado", "mensurado", "mentado", "mentalizado", "mentido", "mercadeado", "mercantilizado", "merecido", "merendado", "mermado", "merodeado", "mesurado", "metamorfoseado", "metido", "mezclado", "migrado", "militado", "militarizado", "mimado", "mimetizado", "minado", "minimizado", "ministrado", "minusvalorado", "mirado", "mistificado", "mitificado", "mitigado", "modelado", "modernizado", "modificado", "modulado", "mofado", "mojado", "moldeado", "molestado", "molido", "monetizado", "monitorizado", "monopolizado", "montado", "morado", "moralizado", "mordido", "mordisqueado", "mortificado", "mosqueado", "mostrado", "motejado", "motivado", "movido", "movilizado", "mudado", "muestreado", "multado", "multiplicado", "munido", "murmurado", "mutado", "mutilado", "nacionalizado", "narcotizado", "narrado", "naufragado", "navegado", "necesitado", "negado", "negociado", "neutralizado", "ninguneado", "nivelado", "nombrado", "nominado", "noqueado", "normado", "normalizado", "notado", "notificado", "nutrido", "obcecado", "obedecido", "objetado", "objetivado", "obligado", "obliterado", "obnubilado", "obrado", "obsequiado", "observado", "obsesionado", "obstaculizado", "obstruido", "obtenido", "obturado", "obviado", "ocasionado", "ocluido", "ocultado", "ocupado", "odiado", "ofendido", "ofertado", "oficiado", "oficializado", "ofrecido", "ofrendado", "ofuscado", "oído", "ojeado", "olfateado", "olido", "olvidado", "omitido", "ondeado", "ondulado", "opacado", "operado", "opinado", "oprimido", "optado", "optimizado", "opuesto", "orado", "orbitado", "ordenado", "ordeñado", "organizado", "orientado", "originado", "orillado", "orinado", "ornado", "ornamentado", "orquestado", "osado", "oscilado", "oscurecido", "osificado", "ostentado", "otorgado", "ovacionado", "ovulado", "oxidado", "oxigenado", "pacificado", "pactado", "padecido", "paganizado", "paginado", "paladeado", "paliado", "palpado", "parado", "parafraseado", "paralizado", "parapetado", "parasitado", "parcelado", "parchado", "parcheado", "pareado", "parido", "parodiado", "parqueado", "participado", "particularizado", "partido", "pasado", "paseado", "pastoreado", "pataleado", "pateado", "patentado", "patentizado", "patinado", "patrullado", "pecado", "pedaleado", "pedido", "pegado", "peinado", "pellizcado", "penalizado", "penetrado", "pensado", "percatado", "percibido", "percutido", "perdido", "perdonado", "perdurado", "perecido", "peregrinado", "perfeccionado", "perfilado", "perforado", "perfumado", "pergeñado", "peritado", "perjudicado", "perjurado", "permeado", "permitido", "permutado", "pernoctado", "perpetrado", "perpetuado", "perseguido", "perseverado", "persistido", "personado", "personalizado", "personificado", "persuadido", "pertenecido", "pertrechado", "perturbado", "pervertido", "pervivido", "pescado", "petado", "peticionado", "picado", "picaneado", "picoteado", "pifiado", "pignorado", "pillado", "pilotado", "piloteado", "pincelado", "pinchado", "pintado", "pintarrajeado", "pinzado", "pirado", "pirateado", "pisado", "pisoteado", "pitado", "placido", "plagiado", "planchado", "planeado", "plantado", "planteado", "plasmado", "platicado", "plegado", "pluralizado", "podado", "poetizado", "polemizado", "politizado", "pololeado", "ponderado", "pontificado", "popularizado", "porfiado", "portado", "porteado", "posado", "posesionado", "posibilitado", "posicionado", "pospuesto", "posteado", "postergado", "postrado", "postulado", "potenciado", "practicado", "precarizado", "precedido", "preceptuado", "precintado", "precipitado", "precisado", "preconizado", "predicado", "predicho", "predispuesto", "predominado", "preferido", "prefigurado", "pregonado", "preguntado", "prejuzgado", "premiado", "prendado", "prendido", "preocupado", "preparado", "presagiado", "prescindido", "presenciado", "presentado", "presentido", "preservado", "presidido", "presionado", "prestado", "prestigiado", "presumido", "presurizado", "pretendido", "preterido", "prevalecido", "prevalido", "prevaricado", "prevenido", "previsto", "primado", "principiado", "pringado", "priorizado", "privatizado", "probado", "problematizado", "procedido", "procesado", "proclamado", "procreado", "procurado", "prodigado", "producido", "profanado", "proferido", "profesado", "profesionalizado", "profetizado", "profundizado", "programado", "progresado", "prohibido", "prohijado", "proletarizado", "proliferado", "prologado", "prolongado", "promediado", "prometido", "promocionado", "promovido", "promulgado", "pronosticado", "pronunciado", "propagado", "propalado", "propendido", "propiciado", "propinado", "proporcionado", "propuesto", "propugnado", "propulsado", "prorrateado", "prorrogado", "proseguido", "prosperado", "prostituido", "protegido", "protestado", "protocolizado", "provenido", "provocado", "proyectado", "psicoanalizado", "publicado", "publicitado", "puesto", "pugnado", "pujado", "pulido", "pulsado", "pululado", "pulverizado", "punado", "punteado", "puntuado", "puntualizado", "punzado", "purgado", "purificado", "puteado", "quebrado", "quebrantado", "quejado", "quemado", "querellado", "querido", "quintuplicado", "quitado", "racionado", "racionalizado", "radiado", "radicado", "radicalizado", "raído", "rajado", "ralentizado", "rapado", "rapeado", "raptado", "rascado", "rasgado", "rasguñado", "raspado", "rastreado", "rasurado", "ratificado", "rayado", "razonado", "reabierto", "reabsorbido", "reaccionado", "reactivado", "readaptado", "readmitido", "reafirmado", "reagrupado", "reajustado", "realimentado", "realizado", "realzado", "reanimado", "reanudado", "reaparecido", "rearmado", "reasumido", "reavivado", "rebajado", "rebalsado", "rebanado", "rebasado", "rebatido", "rebautizado", "rebelado", "reblandecido", "rebobinado", "rebosado", "rebotado", "rebozado", "rebuscado", "recabado", "recaído", "recalado", "recalcado", "recalentado", "recalificado", "recapacitado", "recapitulado", "recargado", "recatado", "recaudado", "receptado", "recetado", "rechazado", "recibido", "reciclado", "recitado", "reclamado", "reclinado", "reclutado", "recobrado", "recocido", "recogido", "recolectado", "recomendado", "recomenzado", "recompensado", "recompuesto", "reconcentrado", "reconciliado", "reconducido", "reconfortado", "reconocido", "reconquistado", "reconsiderado", "reconstituido", "reconstruido", "reconvenido", "reconvertido", "recopilado", "recordado", "recorrido", "recortado", "recreado", "recriminado", "recrudecido", "rectificado", "recubierto", "reculado", "recuperado", "recurrido", "recusado", "redactado", "redefinido", "redescubierto", "redimensionado", "redimido", "rediseñado", "redistribuido", "redituado", "redoblado", "redondeado", "reducido", "redundado", "reedificado", "reeditado", "reeducado", "reelaborado", "reembolsado", "reemplazado", "reencarnado", "reencauchado", "reencontrado", "reenganchado", "reenviado", "reescrito", "reestructurado", "reexaminado", "refaccionado", "referido", "refinado", "refinanciado", "reflejado", "reflexionado", "reflotado", "reforestado", "reformado", "reforzado", "refractado", "refrenado", "refrendado", "refrescado", "refrigerado", "refundido", "refutado", "regado", "regalado", "regañado", "regateado", "regenerado", "regentado", "regenteado", "regido", "regionalizado", "registrado", "reglado", "reglamentado", "regocijado", "regodeado", "regresado", "regulado", "regularizado", "regurgitado", "rehabilitado", "rehecho", "rehogado", "rehuido", "rehusado", "reído", "reinado", "reincidido", "reincorporado", "reingresado", "reiniciado", "reinsertado", "reinstalado", "reinstaurado", "reintegrado", "reinventado", "reinvertido", "reiterado", "reivindicado", "rejuvenecido", "relajado", "relamido", "relanzado", "relatado", "relativizado", "relegado", "releído", "relevado", "religado", "rellenado", "remachado", "remado", "remangado", "remarcado", "rematado", "remecido", "remediado", "rememorado", "remendado", "remitido", "remodelado", "remojado", "remolcado", "remontado", "removido", "remplazado", "renacido", "rendido", "renegado", "renegociado", "reñido", "renombrado", "renovado", "rentabilizado", "rentado", "renunciado", "reordenado", "reorganizado", "reorientado", "reparado", "repartido", "repasado", "repatriado", "repelido", "repensado", "repercutido", "repescado", "repetido", "repicado", "repintado", "replanteado", "replegado", "replicado", "repoblado", "reportado", "reporteado", "reposado", "repreguntado", "reprendido", "represado", "representado", "reprimido", "reprobado", "reprochado", "reproducido", "repudiado", "repuesto", "repugnado", "repuntado", "reputado", "requerido", "requisado", "resaltado", "resarcido", "resbalado", "rescatado", "rescindido", "resecado", "reseñado", "reservado", "reseteado", "resguardado", "residido", "resignado", "resistido", "resonado", "respaldado", "respetado", "respirado", "resplandecido", "respondido", "responsabilizado", "resquebrajado", "restablecido", "restado", "restaurado", "restituido", "restregado", "resucitado", "resuelto", "resumido", "resurgido", "retado", "retardado", "retenido", "retirado", "retocado", "retomado", "retorcido", "retornado", "retractado", "retraído", "retransmitido", "retrasado", "retratado", "retribuido", "retrotraído", "retumbado", "reunido", "reunificado", "reutilizado", "revalidado", "revalorizado", "revaluado", "revelado", "revendido", "reventado", "reverdecido", "reverenciado", "revertido", "revestido", "revirado", "revisado", "revitalizado", "revivido", "revocado", "revolcado", "revoloteado", "revolucionado", "revuelto", "ridiculizado", "rifado", "rimado", "rivalizado", "rizado", "robado", "robustecido", "rociado", "rodado", "rodeado", "rogado", "roído", "rondado", "rotado", "roto", "rotulado", "roturado", "rozado", "ruborizado", "rubricado", "rugido", "rumiado", "rumorado", "sabido", "saboreado", "saboteado", "sacado", "saciado", "sacralizado", "sacrificado", "sacudido", "saldado", "salpimentado", "salpullido", "saltado", "salteado", "saludado", "salvado", "salvaguardado", "sanado", "saneado", "sangrado", "santificado", "saqueado", "satanizado", "satirizado", "satisfecho", "sazonado", "secado", "seccionado", "secretado", "secuenciado", "secuestrado", "secundado", "sedimentado", "seducido", "segado", "segmentado", "segregado", "seguido", "seleccionado", "sembrado", "señalado", "sensibilizado", "sentado", "sentenciado", "sentido", "separado", "serenado", "serrado", "servido", "significado", "silenciado", "simbolizado", "simpatizado", "simplificado", "simulado", "sincerado", "sincronizado", "sindicado", "sindicalizado", "singularizado", "sintetizado", "sintonizado", "sistematizado", "situado", "sobado", "sobornado", "sobrado", "sobrecargado", "sobrecogido", "sobreentendido", "sobreestimado", "sobrellevado", "sobrentendido", "sobrepasado", "sobrepuesto", "sobresalido", "sobresaltado", "sobrestimado", "sobrevenido", "sobrevivido", "sobrevolado", "socavado", "socializado", "socorrido", "sodomizado", "sofocado", "sojuzgado", "solapado", "solicitado", "solidarizado", "solidificado", "soliviantado", "soltado", "solucionado", "solventado", "sombreado", "sometido", "sonado", "soñado", "sondeado", "sonreído", "sonrojado", "sopesado", "soplado", "soportado", "sorbido", "sorprendido", "sorteado", "sosegado", "soslayado", "sospechado", "sostenido", "suavizado", "subastado", "subcontratado", "subdividido", "subestimado", "subido", "sublevado", "sublimado", "subrayado", "subrogado", "subsanado", "subsidiado", "subsistido", "substraído", "subsumido", "subvertido", "subyugado", "succionado", "sucedido", "sucumbido", "sudado", "sufragado", "sufrido", "sugerido", "sugestionado", "suicidado", "sujetado", "sumado", "sumergido", "suministrado", "supeditado", "superado", "superpuesto", "supervisado", "suplantado", "suplicado", "suplido", "suprimido", "supuesto", "surcado", "surtido", "suscitado", "suspendido", "suspirado", "sustanciado", "sustantivado", "sustentado", "sustituido", "sustraído", "susurrado", "suturado", "tabulado", "tachado", "talado", "taladrado", "tallado", "tambaleado", "tamizado", "tañido", "tanteado", "tapado", "tapizado", "taponado", "tarareado", "tardado", "tasado", "tatuado", "tecleado", "tejido", "telefoneado", "televisado", "temido", "templado", "tendido", "tenido", "tensado", "tentado", "teorizado", "terciado", "tergiversado", "terminado", "territorializado", "testado", "testeado", "testificado", "testimoniado", "tildado", "timado", "timbrado", "tinturado", "tipeado", "tipificado", "tirado", "tiranizado", "tironeado", "tiroteado", "titubeado", "tiznado", "tocado", "tolerado", "tomado", "tonificado", "topado", "toqueteado", "torcido", "toreado", "tornado", "tornasolado", "torneado", "torpedeado", "torturado", "tosido", "tostado", "totalizado", "trabado", "trabajado", "traducido", "traficado", "tragado", "traicionado", "traído", "trajinado", "tramado", "tramitado", "trancado", "tranquilizado", "transcendido", "transcurrido", "transferido", "transfigurado", "transformado", "transfundido", "transgredido", "transigido", "transitado", "transliterado", "translucido", "transmitido", "transmutado", "transparentado", "transpirado", "transportado", "transpuesto", "trasegado", "trasgredido", "trasladado", "traslapado", "traslucido", "trasnochado", "traspapelado", "traspasado", "trasplantado", "traspuesto", "trasquilado", "trasteado", "trastocado", "trastornado", "trasvasado", "tratado", "trazado", "trenzado", "trepado", "tributado", "trincado", "triplicado", "triturado", "triunfado", "trivializado", "trocado", "troceado", "tronado", "tronchado", "truncado", "tumbado", "tuneado", "turbado", "turnado", "tutelado", "ufanado", "ultimado", "uncido", "ungido", "unido", "universalizado", "untado", "urbanizado", "urdido", "usado", "usufructuado", "usurpado", "utilizado", "vacado", "vaciado", "vacilado", "vacunado", "vagado", "validado", "valido", "valorado", "valorizado", "valuado", "vanagloriado", "vandalizado", "vaporizado", "variado", "vaticinado", "vedado", "vehiculado", "vejado", "velado", "vencido", "vendado", "vendido", "venerado", "vengado", "ventilado", "veraneado", "verbalizado", "verificado", "versado", "versionado", "vertebrado", "vertido", "vestido", "vetado", "viabilizado", "viajado", "vibrado", "victimado", "victimizado", "vigilado", "vigorizado", "vilipendiado", "vindicado", "violado", "violentado", "virado", "visado", "visibilizado", "visitado", "vislumbrado", "visto", "visualizado", "vitoreado", "vitrificado", "vituperado", "vivido", "vivificado", "vocalizado", "voceado", "vociferado", "volado", "volatilizado", "volcado", "volteado", "vomitado", "votado", "vuelto", "vulcanizado", "vulgarizado", "vulnerado", "yuxtapuesto", "zafado", "zambullido", "zampado", "zanjado", "zarandeado", "zarpado", "zozobrado", "zumbado", "zurcido", "zurrado", "abajada", "abalanzada", "abaleada", "abandonada", "abaratada", "abarcada", "abarrotada", "abastecida", "abatida", "abdicada", "abierta", "abismada", "abjurada", "ablandada", "abocada", "abochornada", "abofeteada", "abolida", "abollada", "abombada", "abominada", "abonada", "abordada", "aborrecida", "aborregada", "abortada", "abotonada", "abrasada", "abrazada", "abrevada", "abreviada", "abrigada", "abrochada", "abrogada", "abroquelada", "abrumada", "absorbida", "abstenida", "abstraída", "absuelta", "abucheada", "abultada", "abundada", "aburguesada", "aburrida", "abusada", "acabada", "acallada", "acalorada", "acaparada", "acariciada", "acarreada", "acatada", "acaudillada", "accedida", "accionada", "acechada", "aceitada", "acelerada", "acentuada", "aceptada", "acerada", "acercada", "acertada", "achacada", "achantada", "achatada", "achicada", "acicalada", "acidificada", "aclarada", "aclimatada", "acobardada", "acodada", "acogida", "acojonada", "acometida", "acomodada", "acompañada", "acompasada", "acongojada", "aconsejada", "acontecida", "acopiada", "acoplada", "acordada", "acordonada", "acorralada", "acortada", "acosada", "acostada", "acostumbrada", "acotada", "acrecentada", "acreditada", "acrisolada", "activada", "actuada", "acuchillada", "acuciada", "acudida", "acuerpada", "acumulada", "acunada", "acuñada", "acurrucada", "acusada", "adaptada", "adecentada", "adelantada", "adelgazada", "adentrada", "adeudada", "adherida", "adicionada", "adiestrada", "adivinada", "adjetivada", "adjudicada", "adjuntada", "administrada", "admirada", "admitida", "adoctrinada", "adolecida", "adoptada", "adorada", "adormecida", "adornada", "adquirida", "aducida", "adueñada", "adulada", "adulterada", "advertida", "afanada", "afeada", "afectada", "afeitada", "aferrada", "afianzada", "afinada", "afirmada", "afligida", "aflorada", "afrentada", "afrontada", "agachada", "agarrada", "agarrotada", "agasajada", "agenciada", "agigantada", "agilizada", "agitada", "aglutinada", "agobiada", "agolpada", "agonizada", "agostada", "agotada", "agradada", "agradecida", "agrandada", "agravada", "agraviada", "agredida", "agregada", "agriada", "agrietada", "agrupada", "aguada", "aguantada", "aguardada", "agudizada", "aguijoneada", "agujereada", "aguzada", "ahogada", "ahondada", "ahorcada", "ahorrada", "ahuecada", "ahuyentada", "aireada", "aislada", "ajustada", "ajusticiada", "alabada", "alagada", "alambrada", "alardeada", "alargada", "alarmada", "albergada", "alborotada", "alcanzada", "aleccionada", "alegada", "alegrada", "alejada", "alentada", "alertada", "alfabetizada", "alfombrada", "aliada", "alienada", "aligerada", "alimentada", "aliñada", "alineada", "alisada", "alistada", "aliviada", "alivianada", "allanada", "almacenada", "almorzada", "alojada", "alquilada", "alterada", "alternada", "alucinada", "aludida", "alumbrada", "alzada", "amada", "amaestrada", "amagada", "amainada", "amalgamada", "amamantada", "amansada", "amargada", "amarrada", "amasada", "ambicionada", "amedrentada", "amenazada", "amenizada", "ameritada", "ametrallada", "amilanada", "aminorada", "amnistiada", "amoldada", "amonestada", "amontonada", "amordazada", "amortajada", "amortiguada", "amortizada", "amotinada", "amparada", "ampayada", "ampliada", "amplificada", "amputada", "amueblada", "añadida", "analizada", "anatematizada", "andada", "anegada", "anestesiada", "anexada", "anexionada", "anhelada", "anidada", "anillada", "animada", "aniquilada", "anisada", "añorada", "anotada", "anoticiada", "ansiada", "antecedida", "antepuesta", "anticipada", "antojada", "anudada", "anulada", "anunciada", "apabullada", "apachurrada", "apaciguada", "apadrinada", "apagada", "apalancada", "apaleada", "apañada", "apantallada", "aparcada", "apareada", "aparecida", "aparentada", "apartada", "apeada", "apedreada", "apelada", "apellidada", "apelmazada", "apercibida", "apersonada", "apestada", "apetecida", "apiadada", "apilada", "apiñada", "apisonada", "aplacada", "aplanada", "aplastada", "aplaudida", "aplazada", "aplicada", "apoderada", "apoltronada", "aporreada", "aportada", "aposentada", "apostada", "apostatada", "apostillada", "apoyada", "apreciada", "aprehendida", "apremiada", "aprendida", "apresada", "apresurada", "apretada", "apretujada", "aprisionada", "aprobada", "aprovechada", "aprovisionada", "aproximada", "apuñalada", "apuñaleada", "apuntada", "apuntalada", "apuntillada", "apurada", "aquejada", "aquietada", "aquilatada", "arañada", "arbitrada", "archivada", "arengada", "argüida", "argumentada", "armada", "armonizada", "aromatizada", "arqueada", "arrancada", "arrasada", "arrastrada", "arreada", "arrebatada", "arreciada", "arreglada", "arrellanada", "arremangada", "arremetida", "arrendada", "arrepentida", "arrestada", "arriada", "arribada", "arriesgada", "arrimada", "arrinconada", "arrodillada", "arrogada", "arrojada", "arrollada", "arropada", "arruinada", "arrullada", "articulada", "asada", "asaltada", "ascendida", "aseada", "asechada", "asediada", "asegurada", "asemejada", "asentada", "asentida", "aserrada", "asesinada", "asesorada", "asestada", "aseverada", "asfixiada", "asida", "asignada", "asilada", "asimilada", "asistida", "asolada", "asoleada", "asomada", "asombrada", "aspirada", "astillada", "asumida", "asustada", "atacada", "atada", "atajada", "atarantada", "atascada", "atemorizada", "atemperada", "atenazada", "atendida", "atenida", "atentada", "atenuada", "aterrada", "aterrorizada", "atesorada", "atestiguada", "atiborrada", "atisbada", "atizada", "atomizada", "atontada", "atorada", "atormentada", "atornillada", "atosigada", "atracada", "atragantada", "atraída", "atrancada", "atrapada", "atrasada", "atravesada", "atrevida", "atribuida", "atrincherada", "atrofiada", "atropellada", "aturdida", "auditada", "augurada", "aumentada", "aunada", "aupada", "auscultada", "ausentada", "autenticada", "autentificada", "autodefinida", "autoeditada", "automatizada", "autorizada", "autorregulada", "auxiliada", "avalada", "avanzada", "avasallada", "avenida", "aventada", "aventajada", "aventurada", "averiada", "averiguada", "avezada", "avisada", "avispada", "avistada", "avivada", "avizorada", "avocada", "ayudada", "azotada", "azuzada", "babeada", "bailada", "bajada", "balaceada", "balanceada", "bañada", "banalizada", "bancada", "bandeada", "barajada", "barrida", "basada", "bastardeada", "basureada", "batallada", "bateada", "batida", "bautizada", "beatificada", "bebida", "beneficiada", "besada", "bifurcada", "birlada", "blandida", "blanqueada", "blasfemada", "blindada", "bloqueada", "boicoteada", "bombardeada", "bombeada", "bonificada", "bordeada", "borrada", "borroneada", "bosquejada", "bostezada", "botada", "boxeada", "bregada", "brillada", "brincada", "brindada", "bromeada", "brotada", "bruñida", "buceada", "burlada", "buscada", "cabeceada", "cabida", "cabildeada", "cabreada", "cacareada", "cachada", "cacheada", "cacheteada", "caducada", "cagada", "calada", "calculada", "caldeada", "calefaccionada", "calendarizada", "calentada", "calibrada", "calificada", "caligrafiada", "callada", "calmada", "calumniada", "calzada", "cambiada", "caminada", "camuflada", "canalizada", "cancelada", "canjeada", "cansada", "cantada", "capada", "capeada", "capitalizada", "capitulada", "captada", "capturada", "caracterizada", "carburada", "carcomida", "cardada", "careada", "carecida", "cargada", "caricaturizada", "cartografiada", "cascada", "castigada", "castrada", "catada", "catalizada", "catalogada", "catapultada", "cateada", "categorizada", "causada", "cauterizada", "cautivada", "cavada", "cavilada", "cazada", "cebada", "cedida", "cegada", "cejada", "celebrada", "cenada", "ceñida", "censurada", "centrifugada", "centuplicada", "cepillada", "cercada", "cercenada", "cerciorada", "cernida", "cerrada", "cesada", "chafada", "chamuscada", "chantajeada", "chapada", "charlada", "chateada", "chequeada", "chiflada", "chillada", "chingada", "chirriada", "chivada", "chocada", "chorreada", "choteada", "chupada", "chutada", "cicatrizada", "cifrada", "cimentada", "cincelada", "circulada", "circuncidada", "circundada", "citada", "clamada", "clarificada", "clasificada", "claudicada", "clausurada", "clavada", "clicada", "clonada", "coaccionada", "coadyuvada", "coagulada", "coaligada", "coartada", "cobijada", "cobrada", "cocida", "cocinada", "codeada", "codiciada", "codificada", "codirigida", "coexistida", "cofinanciada", "cogida", "cohabitada", "cohibida", "coincidida", "colaborada", "colacionada", "colada", "colapsada", "coleccionada", "colectada", "colectivizada", "colgada", "colisionada", "colmada", "colocada", "colonizada", "coloreada", "columpiada", "combatida", "combinada", "comentada", "comenzada", "comerciada", "comercializada", "cometida", "comida", "comisionada", "compactada", "compadecida", "compaginada", "comparada", "comparecida", "compartida", "compatibilizada", "compelida", "compendiada", "compenetrada", "compensada", "compilada", "complacida", "complementada", "completada", "complotada", "comportada", "comprada", "comprendida", "comprimida", "comprobada", "comprometida", "compuesta", "compulsada", "computada", "comulgada", "comunicada", "concatenada", "concebida", "concedida", "concelebrada", "concentrada", "conceptuada", "conceptualizada", "concertada", "concienciada", "concientizada", "conciliada", "concitada", "concluida", "concordada", "concretada", "concretizada", "conculcada", "concursada", "condenada", "condensada", "condicionada", "condimentada", "condolida", "condonada", "conducida", "conectada", "conexionada", "confabulada", "confeccionada", "conferida", "confesada", "confiada", "configurada", "confirmada", "confiscada", "confluida", "conformada", "confortada", "confrontada", "confundida", "congeniada", "congestionada", "congratulada", "congregada", "conjeturada", "conjugada", "conjuntada", "conjurada", "conllevada", "conmemorada", "conminada", "conmocionada", "conmovida", "conmutada", "connotada", "conquistada", "consagrada", "conseguida", "consensuada", "consentida", "conservada", "considerada", "consignada", "consistida", "consolada", "consolidada", "conspirada", "constada", "constatada", "constelada", "constitucionalizada", "constituida", "constreñida", "construida", "consultada", "consumada", "consumida", "contabilizada", "contactada", "contada", "contagiada", "contemplada", "contendida", "contenida", "contentada", "contestada", "contextualizada", "continuada", "contorneada", "contraatacada", "contrabandeada", "contradicha", "contrahecha", "contraída", "contrapesada", "contrapuesta", "contrariada", "contrarrestada", "contrastada", "contratada", "contravenida", "contribuida", "contristada", "controlada", "convalidada", "convencida", "convenida", "convergida", "conversada", "convertida", "convidada", "convivida", "convocada", "convulsionada", "cooperada", "cooptada", "coordinada", "copada", "copiada", "coproducida", "copulada", "coqueteada", "corchada", "coreada", "coreografiada", "corneada", "coronada", "corporizada", "corregida", "correlacionada", "correspondida", "correteada", "corrida", "corroborada", "corroída", "corrompida", "cortada", "cortejada", "cosechada", "cosida", "cosificada", "costada", "costeada", "cotejada", "cotizada", "creada", "creída", "criada", "cribada", "criminalizada", "crispada", "cristalizada", "cristianizada", "criticada", "cronometrada", "crucificada", "crujida", "cruzada", "cuadriplicada", "cuadruplicada", "cuajada", "cuantificada", "cuarteada", "cubierta", "cuestionada", "cuidada", "culeada", "culminada", "culpabilizada", "culpada", "cultivada", "culturizada", "cumplida", "cumplimentada", "cundida", "curada", "curioseada", "currada", "cursada", "curvada", "custodiada", "dada", "dañada", "danzada", "datada", "dateada", "debatida", "debida", "debilitada", "debitada", "debutada", "decaída", "decantada", "decapitada", "decepcionada", "decidida", "declamada", "declarada", "declinada", "decodificada", "decolorada", "decomisada", "decrecida", "decretada", "dedicada", "deducida", "defecada", "defendida", "defenestrada", "deferida", "definida", "deformada", "defraudada", "degenerada", "deglutida", "degollada", "degradada", "degustada", "deificada", "dejada", "delatada", "delegada", "deleitada", "deletreada", "deliberada", "delimitada", "delineada", "delinquida", "demandada", "demarcada", "demediada", "demeritada", "democratizada", "demolida", "demonizada", "demorada", "demostrada", "demudada", "denegada", "denigrada", "denominada", "denostada", "denotada", "denunciada", "deparada", "departida", "dependida", "depilada", "deplorada", "deportada", "depositada", "depreciada", "depredada", "deprimida", "depuesta", "depurada", "derechizada", "derivada", "derogada", "derramada", "derretida", "derribada", "derrocada", "derrochada", "derrotada", "derruida", "derrumbada", "desabrochada", "desacatada", "desacelerada", "desacomodada", "desaconsejada", "desacoplada", "desacralizada", "desacreditada", "desactivada", "desafiada", "desafinada", "desaguada", "desahogada", "desairada", "desajustada", "desalentada", "desalineada", "desalojada", "desandada", "desangrada", "desanimada", "desaparecida", "desapegada", "desaprendida", "desaprobada", "desaprovechada", "desarmada", "desarraigada", "desarreglada", "desarrollada", "desarticulada", "desaseada", "desasida", "desasosegada", "desatada", "desatendida", "desautorizada", "desayunada", "desbancada", "desbandada", "desbaratada", "desbarrancada", "desbastada", "desbloqueada", "desbocada", "desbordada", "desbrozada", "descabalgada", "descabezada", "descaderada", "descalabrada", "descalificada", "descansada", "descargada", "descarriada", "descarrilada", "descartada", "descascarada", "descascarillada", "descendida", "descentrada", "descifrada", "descocida", "descodificada", "descojonada", "descolgada", "descolocada", "descolonizada", "descompensada", "descomprimida", "descompuesta", "desconectada", "desconfiada", "descongelada", "desconocida", "descontada", "descontaminada", "descontextualizada", "descontinuada", "desconvocada", "descorazonada", "descorchada", "descorrida", "descosida", "descoyuntada", "descreída", "descristianizada", "descuadrada", "descuartizada", "descubierta", "descuidada", "desdeñada", "desdibujada", "desdicha", "desdoblada", "deseada", "desecada", "desechada", "desembarazada", "desembarcada", "desembocada", "desembolsada", "desempacada", "desempañada", "desempaquetada", "desempeñada", "desempolvada", "desenamorada", "desencadenada", "desencajada", "desencarnada", "desenchufada", "desenfocada", "desenfundada", "desenganchada", "desengrasada", "desenmascarada", "desenredada", "desenrollada", "desentendida", "desenterrada", "desentonada", "desentrañada", "desenvainada", "desenvuelta", "desequilibrada", "desertada", "desestabilizada", "desestimada", "desfalcada", "desfallecida", "desfigurada", "desfondada", "desgajada", "desgañitada", "desgarrada", "desgastada", "desglosada", "desgobernada", "desgranada", "desguazada", "deshecha", "desheredada", "deshidratada", "deshilachada", "deshojada", "deshonrada", "deshuesada", "deshumanizada", "designada", "desilusionada", "desincentivada", "desinfectada", "desinflada", "desinflamada", "desinformada", "desinhibida", "desinstalada", "desintegrada", "desintoxicada", "desistida", "desjarretada", "deslegitimada", "desleída", "desligada", "deslindada", "deslizada", "deslucida", "deslumbrada", "desmadrada", "desmalezada", "desmantelada", "desmaquillada", "desmarcada", "desmayada", "desmejorada", "desmembrada", "desmentida", "desmenuzada", "desmerecida", "desmigada", "desmitificada", "desmoldada", "desmontada", "desmoralizada", "desmoronada", "desmotivada", "desmovilizada", "desnaturalizada", "desnivelada", "desnucada", "desnudada", "desobedecida", "desobligada", "desoída", "desollada", "desorganizada", "desorientada", "despachada", "desparasitada", "desparecida", "desparramada", "despedazada", "despedida", "despegada", "despeinada", "despejada", "despellejada", "despeñada", "despenalizada", "desperdiciada", "despersonalizada", "despertada", "despilfarrada", "despintada", "despiojada", "despistada", "desplazada", "desplegada", "desplomada", "desplumada", "despojada", "despolitizada", "desposada", "desposeída", "despotricada", "despreciada", "desprendida", "despreocupada", "desprestigiada", "desprogramada", "despulpada", "despuntada", "desquiciada", "desquitada", "destacada", "destapada", "desteñida", "desterrada", "destetada", "destilada", "destituida", "destrabada", "destripada", "destronada", "destrozada", "destruida", "desunida", "desvalijada", "desvalorizada", "desvanecida", "desvelada", "desvestida", "desviada", "desvinculada", "desvirtuada", "desvivida", "detectada", "detenida", "detentada", "deteriorada", "determinada", "detestada", "detonada", "devaluada", "devanada", "devastada", "develada", "devengada", "devenida", "devorada", "devuelta", "diagnosticada", "diagramada", "dializada", "dialogada", "dibujada", "dicha", "dictada", "dictaminada", "diezmada", "difamada", "diferenciada", "diferida", "dificultada", "difuminada", "difundida", "digerida", "digitada", "dignada", "dignificada", "dilapidada", "dilatada", "diligenciada", "dilucidada", "diluida", "dimensionada", "dimitida", "dinamitada", "dinamizada", "dirimida", "discernida", "disciplinada", "discontinuada", "discrepada", "discriminada", "disculpada", "discurrida", "discutida", "diseccionada", "diseminada", "diseñada", "disentida", "disertada", "disfrazada", "disfrutada", "disgregada", "disgustada", "disimulada", "disipada", "dislocada", "disminuida", "disociada", "dispensada", "dispersada", "dispuesta", "disputada", "distada", "distanciada", "distendida", "distinguida", "distorsionada", "distraída", "distribuida", "disuadida", "disuelta", "divagada", "diversificada", "divertida", "dividida", "divinizada", "divisada", "divorciada", "divulgada", "doblada", "doblegada", "doctorada", "documentada", "dogmatizada", "dolida", "domada", "domesticada", "dominada", "donada", "dopada", "dormida", "dosificada", "dotada", "dragada", "dramatizada", "drenada", "drogada", "duchada", "dudada", "dulcificada", "duplicada", "durada", "echada", "eclipsada", "eclosionada", "economizada", "ecualizada", "edificada", "editada", "educada", "efectuada", "ejecutada", "ejemplificada", "ejercida", "ejercitada", "elaborada", "electrizada", "electrocutada", "elevada", "elidida", "eliminada", "elogiada", "elucubrada", "eludida", "emanada", "emancipada", "embadurnada", "embalada", "embalsamada", "embanderada", "embarcada", "embargada", "embarrada", "embarrancada", "embaucada", "embebida", "embelesada", "embellecida", "embestida", "embolada", "embolsada", "emborrachada", "emborronada", "emboscada", "embotada", "embriagada", "embrollada", "embrutecida", "embuchada", "emergida", "emigrada", "emitida", "emocionada", "empacada", "empachada", "empadronada", "empalada", "empalmada", "empanada", "empañada", "empantanada", "empapelada", "empaquetada", "emparejada", "empastada", "empatada", "empecinada", "empeñada", "empeorada", "empequeñecida", "emperrada", "empezada", "empinada", "emplazada", "empleada", "empobrecida", "empoderada", "empollada", "empolvada", "emponzoñada", "emprendida", "empujada", "empuñada", "emputada", "emulada", "emulsionada", "enajenada", "enaltecida", "enamorada", "enarbolada", "enardecida", "encabezada", "encabritada", "encabronada", "encadenada", "encajada", "encajonada", "encallada", "encamada", "encaminada", "encandilada", "encanecida", "encañonada", "encantada", "encaprichada", "encapsulada", "encarada", "encaramada", "encarecida", "encargada", "encariñada", "encarnada", "encarrilada", "encartada", "encasillada", "encasquetada", "encasquillada", "encastrada", "encausada", "encauzada", "enceguecida", "encendida", "encerada", "encerrada", "encharcada", "enchufada", "encimada", "encogida", "encolada", "encolerizada", "encolumnada", "encomendada", "enconada", "encontrada", "encordada", "encrespada", "encuadrada", "encubierta", "encuerada", "encumbrada", "enderezada", "endeudada", "endilgada", "endiosada", "endosada", "endulzada", "endurecida", "enemistada", "energizada", "enervada", "enfadada", "enfangada", "enfatizada", "enfermada", "enfiestada", "enfilada", "enflaquecida", "enfocada", "enfrascada", "enfrentada", "enfriada", "enfurecida", "engalanada", "engañada", "enganchada", "engarzada", "engatusada", "engendrada", "englobada", "engolosinada", "engordada", "engranada", "engrandecida", "engrasada", "engreída", "engrosada", "engullida", "enharinada", "enhebrada", "enjuagada", "enjugada", "enjuiciada", "enlazada", "enlistada", "enlodada", "enloquecida", "enlozada", "enlutada", "enmarañada", "enmascarada", "enmendada", "enmohecida", "enmudecida", "ennegrecida", "ennoblecida", "enorgullecida", "enrarecida", "enredada", "enripiada", "enriquecida", "enrocada", "enrojecida", "enrolada", "enrollada", "enroscada", "enrumbada", "ensalzada", "ensamblada", "ensañada", "ensanchada", "ensartada", "ensayada", "ensebada", "enseñada", "enseñoreada", "ensillada", "ensoberbecida", "ensogada", "ensombrecida", "ensoñada", "ensordecida", "ensuciada", "entablada", "entallada", "entendida", "enterada", "enternecida", "enterrada", "entibiada", "entintada", "entonada", "entorpecida", "entrada", "entrampada", "entrañada", "entreabierta", "entrecomillada", "entrecruzada", "entregada", "entrelazada", "entremetida", "entremezclada", "entrenada", "entresacada", "entretejida", "entretenida", "entreverada", "entrevistada", "entristecida", "entrometida", "entronada", "entroncada", "entronizada", "entumecida", "enturbiada", "entusiasmada", "enumerada", "enunciada", "envainada", "envalentonada", "envanecida", "envasada", "envejecida", "envenenada", "envestida", "enviada", "enviciada", "envidiada", "envilecida", "enviudada", "envuelta", "enzarzada", "equilibrada", "equiparada", "equivocada", "erigida", "erizada", "erogada", "erosionada", "erotizada", "erradicada", "errada", "esbozada", "escabullida", "escalada", "escaldada", "escalfada", "escamada", "escamoteada", "escampada", "escandalizada", "escaneada", "escapada", "escaqueada", "escarbada", "escarchada", "escarmentada", "escarnecida", "escaseada", "escatimada", "escenificada", "escindida", "esclarecida", "esclavizada", "escocida", "escogida", "escolarizada", "escoltada", "escondida", "escorada", "escrachada", "escrita", "escrutada", "escuchada", "escudada", "escudriñada", "esculpida", "escupida", "escurrida", "esforzada", "esfumada", "esgrimida", "esmerada", "esmerilada", "espabilada", "espaciada", "españolizada", "espantada", "esparcida", "especificada", "especulada", "esperada", "espesada", "espetada", "espiada", "espigada", "espinada", "espirada", "espiritualizada", "espoleada", "espolvoreada", "esponjada", "esponsorizada", "esposada", "esquematizada", "esquiada", "esquilada", "esquilmada", "esquivada", "estabilizada", "establecida", "estacionada", "estafada", "estallada", "estampada", "estancada", "estaqueada", "estatizada", "estatuida", "esterificada", "esterilizada", "estigmatizada", "estilizada", "estimada", "estimulada", "estipulada", "estirada", "estorbada", "estornudada", "estragada", "estrangulada", "estrechada", "estrellada", "estremecida", "estrenada", "estresada", "estriada", "estropeada", "estructurada", "estrujada", "estudiada", "eternizada", "etiquetada", "evacuada", "evadida", "evaluada", "evangelizada", "evaporada", "evidenciada", "eviscerada", "evitada", "evocada", "evolucionada", "exacerbada", "exagerada", "exaltada", "examinada", "exasperada", "excarcelada", "excavada", "excedida", "exceptuada", "excitada", "exclamada", "excluida", "excretada", "exculpada", "excusada", "execrada", "exhalada", "exhibida", "exhortada", "exhumada", "exigida", "exilada", "eximida", "existida", "exonerada", "exorcizada", "expandida", "expedida", "expedientada", "expelida", "expendida", "experimentada", "expiada", "expirada", "explayada", "explicada", "explicitada", "explorada", "explosionada", "explotada", "expoliada", "exportada", "expresada", "exprimida", "expropiada", "expuesta", "expulsada", "expurgada", "extendida", "exteriorizada", "exterminada", "externada", "externalizada", "extinguida", "extirpada", "extorsionada", "extractada", "extraditada", "extraída", "extralimitada", "extrañada", "extrapolada", "extraviada", "extremada", "extruida", "exudada", "eyaculada", "eyectada", "fabricada", "fabulada", "facilitada", "facturada", "facultada", "fagocitada", "fajada", "fallada", "fallecida", "falsada", "falseada", "falsificada", "familiarizada", "fantaseada", "fascinada", "fastidiada", "fatigada", "favorecida", "fecundada", "felicitada", "feminizada", "fenecida", "fermentada", "fertilizada", "festejada", "fiada", "fichada", "fidelizada", "figurada", "fijada", "filmada", "filosofada", "filtrada", "finalizada", "financiada", "fincada", "fingida", "finiquitada", "firmada", "fiscalizada", "fisurada", "flagelada", "flameada", "flanqueada", "flaqueada", "fletada", "flexibilizada", "flexionada", "flipada", "floreada", "florecida", "flotada", "fluctuada", "focalizada", "fogueada", "foliada", "follada", "fomentada", "fondeada", "forcejeada", "forestada", "forjada", "formada", "formalizada", "formateada", "formulada", "fornicada", "forrada", "fortalecida", "forzada", "fotocopiada", "fotografiada", "fracasada", "fraccionada", "fracturada", "fragmentada", "fraguada", "franqueada", "frecuentada", "fregada", "frenada", "fresada", "friccionada", "frotada", "fructificada", "fruncida", "fugada", "fulminada", "fumada", "fumigada", "funcionada", "fundada", "fundamentada", "fundida", "fungida", "fusilada", "fusionada", "fustigada", "gafada", "ganada", "gangrenada", "garabateada", "garantida", "garantizada", "garrida", "gaseada", "gastada", "gemida", "generada", "generalizada", "gerenciada", "germinada", "gestada", "gestionada", "girada", "glorificada", "glosada", "gobernada", "goleada", "golpeada", "gozada", "grabada", "graduada", "graficada", "granjeada", "grapada", "gratificada", "gravada", "gravitada", "gritada", "gruñida", "guardada", "guarecida", "guarnecida", "guerreada", "guiada", "guillotinada", "guiñada", "guindada", "guisada", "gustada", "habilitada", "habitada", "habituada", "hablada", "halada", "halagada", "hallada", "hartada", "hechizada", "hecha", "helenizada", "henchida", "hendida", "heredada", "herida", "hermanada", "herrada", "hervida", "hibernada", "hibridada", "hidratada", "higienizada", "hilada", "hilvanada", "hincada", "hinchada", "hipnotizada", "hipotecada", "historiada", "hojeada", "holgada", "hollada", "homenajeada", "homogeneizada", "homologada", "honrada", "horadada", "horneada", "horrorizada", "hospedada", "hostigada", "hostilizada", "huida", "humanada", "humanizada", "humectada", "humedecida", "humillada", "hundida", "hurgada", "hurtada", "ideada", "idealizada", "identificada", "ideologizada", "idiotizada", "idolatrada", "ignorada", "igualada", "ilegalizada", "iluminada", "ilusionada", "ilustrada", "imaginada", "imbricada", "imitada", "impactada", "impartida", "impedida", "impelida", "imperada", "impermeabilizada", "implantada", "implementada", "implicada", "implorada", "importada", "importunada", "imposibilitada", "impresionada", "improvisada", "impuesta", "impugnada", "impulsada", "imputada", "inaugurada", "incautada", "incendiada", "incentivada", "incinerada", "incitada", "inclinada", "incluida", "incoada", "incomodada", "incorporada", "incrementada", "increpada", "incriminada", "incubada", "inculcada", "inculpada", "incumplida", "incurrida", "incursionada", "indagada", "indemnizada", "independizada", "indexada", "indicada", "indigestada", "indignada", "indispuesta", "individuada", "inducida", "indultada", "inervada", "infamada", "infartada", "infectada", "inferida", "inficionada", "infiltrada", "inflada", "inflamada", "infligida", "influenciada", "influida", "informada", "infravalorada", "infringida", "infundida", "ingeniada", "ingerida", "ingresada", "inhabilitada", "inhalada", "inhibida", "inhumada", "iniciada", "inicializada", "injertada", "injuriada", "inmigrada", "inmiscuida", "inmolada", "inmortalizada", "inmovilizada", "inmunizada", "innovada", "inoculada", "inquietada", "inquirida", "insensibilizada", "insertada", "insinuada", "insistida", "inspeccionada", "inspirada", "instada", "instalada", "instaurada", "instigada", "instituida", "instruida", "instrumentada", "instrumentalizada", "insuflada", "insultada", "insumida", "integrada", "intelectualizada", "intensificada", "intentada", "interactuada", "intercalada", "intercambiada", "intercedida", "interceptada", "interesada", "interferida", "interiorizada", "intermediada", "internacionalizada", "internalizada", "interpelada", "interpolada", "interpretada", "interpuesta", "interrogada", "interrumpida", "intervenida", "intimada", "intimidada", "intitulada", "intoxicada", "intrigada", "introducida", "intuida", "inundada", "inutilizada", "invadida", "invalidada", "inventada", "inventariada", "invertida", "investida", "investigada", "invitada", "invocada", "involucionada", "inyectada", "ionizada", "ironizada", "irradiada", "irrespetada", "irrigada", "irritada", "irrogada", "irrumpida", "jactada", "jalada", "jaleada", "jalonada", "jaqueada", "jerarquizada", "jodida", "jorobada", "jubilada", "jugada", "juntada", "jurada", "juramentada", "justificada", "juzgada", "laborada", "labrada", "laburada", "lacada", "lacerada", "lactada", "ladeada", "ladrada", "lamentada", "lamida", "laminada", "languidecida", "lanzada", "lapidada", "laqueada", "largada", "lastimada", "lastrada", "latida", "laudada", "lavada", "legalizada", "legislada", "legitimada", "leída", "lesionada", "leudada", "levantada", "liada", "liberada", "liberalizada", "libertada", "librada", "licitada", "licuada", "liderizada", "lidiada", "ligada", "lijada", "limada", "limitada", "limpiada", "linchada", "liquidada", "litigada", "llagada", "llamada", "llegada", "llenada", "llevada", "llorada", "localizada", "lograda", "lubricada", "luchada", "lucida", "lucrada", "lustrada", "macerada", "machacada", "macheteada", "machucada", "madreada", "madrugada", "madurada", "magnetizada", "magnificada", "malacostumbrada", "malbaratada", "malcriada", "maleada", "malentendida", "malgastada", "malinterpretada", "malograda", "maltratada", "malversada", "mamada", "manchada", "mancillada", "mandada", "manejada", "mangada", "mangoneada", "manifestada", "maniobrada", "manipulada", "manoseada", "manteada", "mantenida", "manufacturada", "maquillada", "maquinada", "maravillada", "marcada", "marchitada", "mareada", "marginada", "maridada", "martillada", "martirizada", "masacrada", "masajeada", "mascada", "masificada", "masticada", "masturbada", "matada", "materializada", "matizada", "matriculada", "maximizada", "meada", "mecanografiada", "mechada", "mecida", "mediada", "mediatizada", "medicada", "medida", "meditada", "medrada", "mejorada", "mellada", "memorizada", "mencionada", "meneada", "menguada", "menoscabada", "menospreciada", "menstruada", "mensualizada", "mensurada", "mentada", "mentalizada", "mentida", "mercadeada", "mercantilizada", "merecida", "merendada", "mermada", "merodeada", "mesurada", "metamorfoseada", "metida", "mezclada", "migrada", "militada", "militarizada", "mimada", "mimetizada", "minada", "minimizada", "ministrada", "minusvalorada", "mirada", "mistificada", "mitificada", "mitigada", "modelada", "modernizada", "modificada", "modulada", "mofada", "mojada", "moldeada", "molestada", "molida", "monetizada", "monitorizada", "monopolizada", "montada", "morada", "moralizada", "mordida", "mordisqueada", "mortificada", "mosqueada", "mostrada", "motejada", "motivada", "movida", "movilizada", "mudada", "muestreada", "multada", "multiplicada", "munida", "murmurada", "mutada", "mutilada", "nacionalizada", "narcotizada", "narrada", "naufragada", "navegada", "necesitada", "negada", "negociada", "neutralizada", "ninguneada", "nivelada", "nombrada", "nominada", "noqueada", "normada", "normalizada", "notada", "notificada", "nutrida", "obcecada", "obedecida", "objetada", "objetivada", "obligada", "obliterada", "obnubilada", "obrada", "obsequiada", "observada", "obsesionada", "obstaculizada", "obstruida", "obtenida", "obturada", "obviada", "ocasionada", "ocluida", "ocultada", "ocupada", "odiada", "ofendida", "ofertada", "oficiada", "oficializada", "ofrecida", "ofrendada", "ofuscada", "oída", "ojeada", "olfateada", "olida", "olvidada", "omitida", "ondeada", "ondulada", "opacada", "operada", "opinada", "oprimida", "optada", "optimizada", "opuesta", "orada", "orbitada", "ordenada", "ordeñada", "organizada", "orientada", "originada", "orillada", "orinada", "ornada", "ornamentada", "orquestada", "osada", "oscilada", "oscurecida", "osificada", "ostentada", "otorgada", "ovacionada", "ovulada", "oxidada", "oxigenada", "pacificada", "pactada", "padecida", "paganizada", "paginada", "paladeada", "paliada", "palpada", "parada", "parafraseada", "paralizada", "parapetada", "parasitada", "parcelada", "parchada", "parcheada", "pareada", "parida", "parodiada", "parqueada", "participada", "particularizada", "partida", "pasada", "paseada", "pastoreada", "pataleada", "pateada", "patentada", "patentizada", "patinada", "patrullada", "pecada", "pedaleada", "pedida", "pegada", "peinada", "pellizcada", "penalizada", "penetrada", "pensada", "percatada", "percibida", "percutida", "perdida", "perdonada", "perdurada", "perecida", "peregrinada", "perfeccionada", "perfilada", "perforada", "perfumada", "pergeñada", "peritada", "perjudicada", "perjurada", "permeada", "permitida", "permutada", "pernoctada", "perpetrada", "perpetuada", "perseguida", "perseverada", "persistida", "personada", "personalizada", "personificada", "persuadida", "pertenecida", "pertrechada", "perturbada", "pervertida", "pervivida", "pescada", "petada", "peticionada", "picada", "picaneada", "picoteada", "pifiada", "pignorada", "pillada", "pilotada", "piloteada", "pincelada", "pinchada", "pintada", "pintarrajeada", "pinzada", "pirada", "pirateada", "pisada", "pisoteada", "pitada", "placida", "plagiada", "planchada", "planeada", "plantada", "planteada", "plasmada", "platicada", "plegada", "pluralizada", "podada", "poetizada", "polemizada", "politizada", "pololeada", "ponderada", "pontificada", "popularizada", "porfiada", "portada", "porteada", "posada", "posesionada", "posibilitada", "posicionada", "pospuesta", "posteada", "postergada", "postrada", "postulada", "potenciada", "practicada", "precarizada", "precedida", "preceptuada", "precintada", "precipitada", "precisada", "preconizada", "predicada", "predicha", "predispuesta", "predominada", "preferida", "prefigurada", "pregonada", "preguntada", "prejuzgada", "premiada", "prendada", "prendida", "preocupada", "preparada", "presagiada", "prescindida", "presenciada", "presentada", "presentida", "preservada", "presidida", "presionada", "prestada", "prestigiada", "presumida", "presurizada", "pretendida", "preterida", "prevalecida", "prevalida", "prevaricada", "prevenida", "prevista", "primada", "principiada", "pringada", "priorizada", "privatizada", "probada", "problematizada", "procedida", "procesada", "proclamada", "procreada", "procurada", "prodigada", "producida", "profanada", "proferida", "profesada", "profesionalizada", "profetizada", "profundizada", "programada", "progresada", "prohibida", "prohijada", "proletarizada", "proliferada", "prologada", "prolongada", "promediada", "prometida", "promocionada", "promovida", "promulgada", "pronosticada", "pronunciada", "propagada", "propalada", "propendida", "propiciada", "propinada", "proporcionada", "propuesta", "propugnada", "propulsada", "prorrateada", "prorrogada", "proseguida", "prosperada", "prostituida", "protegida", "protestada", "protocolizada", "provenida", "provocada", "proyectada", "psicoanalizada", "publicada", "publicitada", "puesta", "pugnada", "pujada", "pulida", "pulsada", "pululada", "pulverizada", "punada", "punteada", "puntuada", "puntualizada", "punzada", "purgada", "purificada", "puteada", "quebrada", "quebrantada", "quejada", "quemada", "querellada", "querida", "quintuplicada", "quitada", "racionada", "racionalizada", "radiada", "radicada", "radicalizada", "raída", "rajada", "ralentizada", "rapada", "rapeada", "raptada", "rascada", "rasgada", "rasguñada", "raspada", "rastreada", "rasurada", "ratificada", "rayada", "razonada", "reabierta", "reabsorbida", "reaccionada", "reactivada", "readaptada", "readmitida", "reafirmada", "reagrupada", "reajustada", "realimentada", "realizada", "realzada", "reanimada", "reanudada", "reaparecida", "rearmada", "reasumida", "reavivada", "rebajada", "rebalsada", "rebanada", "rebasada", "rebatida", "rebautizada", "rebelada", "reblandecida", "rebobinada", "rebosada", "rebotada", "rebozada", "rebuscada", "recabada", "recaída", "recalada", "recalcada", "recalentada", "recalificada", "recapacitada", "recapitulada", "recargada", "recatada", "recaudada", "receptada", "recetada", "rechazada", "recibida", "reciclada", "recitada", "reclamada", "reclinada", "reclutada", "recobrada", "recocida", "recogida", "recolectada", "recomendada", "recomenzada", "recompensada", "recompuesta", "reconcentrada", "reconciliada", "reconducida", "reconfortada", "reconocida", "reconquistada", "reconsiderada", "reconstituida", "reconstruida", "reconvenida", "reconvertida", "recopilada", "recordada", "recorrida", "recortada", "recreada", "recriminada", "recrudecida", "rectificada", "recubierta", "reculada", "recuperada", "recurrida", "recusada", "redactada", "redefinida", "redescubierta", "redimensionada", "redimida", "rediseñada", "redistribuida", "redituada", "redoblada", "redondeada", "reducida", "redundada", "reedificada", "reeditada", "reeducada", "reelaborada", "reembolsada", "reemplazada", "reencarnada", "reencauchada", "reencontrada", "reenganchada", "reenviada", "reescrita", "reestructurada", "reexaminada", "refaccionada", "referida", "refinada", "refinanciada", "reflejada", "reflexionada", "reflotada", "reforestada", "reformada", "reforzada", "refractada", "refrenada", "refrendada", "refrescada", "refrigerada", "refundida", "refutada", "regada", "regalada", "regañada", "regateada", "regenerada", "regentada", "regenteada", "regida", "regionalizada", "registrada", "reglada", "reglamentada", "regocijada", "regodeada", "regresada", "regulada", "regularizada", "regurgitada", "rehabilitada", "rehecha", "rehogada", "rehuida", "rehusada", "reída", "reinada", "reincidida", "reincorporada", "reingresada", "reiniciada", "reinsertada", "reinstalada", "reinstaurada", "reintegrada", "reinventada", "reinvertida", "reiterada", "reivindicada", "rejuvenecida", "relajada", "relamida", "relanzada", "relatada", "relativizada", "relegada", "releída", "relevada", "religada", "rellenada", "remachada", "remada", "remangada", "remarcada", "rematada", "remecida", "remediada", "rememorada", "remendada", "remitida", "remodelada", "remojada", "remolcada", "remontada", "removida", "remplazada", "renacida", "rendida", "renegada", "renegociada", "reñida", "renombrada", "renovada", "rentabilizada", "rentada", "renunciada", "reordenada", "reorganizada", "reorientada", "reparada", "repartida", "repasada", "repatriada", "repelida", "repensada", "repercutida", "repescada", "repetida", "repicada", "repintada", "replanteada", "replegada", "replicada", "repoblada", "reportada", "reporteada", "reposada", "repreguntada", "reprendida", "represada", "representada", "reprimida", "reprobada", "reprochada", "reproducida", "repudiada", "repuesta", "repugnada", "repuntada", "reputada", "requerida", "requisada", "resaltada", "resarcida", "resbalada", "rescatada", "rescindida", "resecada", "reseñada", "reservada", "reseteada", "resguardada", "residida", "resignada", "resistida", "resonada", "respaldada", "respetada", "respirada", "resplandecida", "respondida", "responsabilizada", "resquebrajada", "restablecida", "restada", "restaurada", "restituida", "restregada", "resucitada", "resuelta", "resumida", "resurgida", "retada", "retardada", "retenida", "retirada", "retocada", "retomada", "retorcida", "retornada", "retractada", "retraída", "retransmitida", "retrasada", "retratada", "retribuida", "retrotraída", "retumbada", "reunida", "reunificada", "reutilizada", "revalidada", "revalorizada", "revaluada", "revelada", "revendida", "reventada", "reverdecida", "reverenciada", "revertida", "revestida", "revirada", "revisada", "revitalizada", "revivida", "revocada", "revolcada", "revoloteada", "revolucionada", "revuelta", "ridiculizada", "rifada", "rimada", "rivalizada", "rizada", "robada", "robustecida", "rociada", "rodada", "rodeada", "rogada", "roída", "rondada", "rotada", "rota", "rotulada", "roturada", "rozada", "ruborizada", "rubricada", "rugida", "rumiada", "rumorada", "sabida", "saboreada", "saboteada", "sacada", "saciada", "sacralizada", "sacrificada", "sacudida", "saldada", "salpimentada", "salpullida", "saltada", "salteada", "saludada", "salvada", "salvaguardada", "sanada", "saneada", "sangrada", "santificada", "saqueada", "satanizada", "satirizada", "satisfecha", "sazonada", "secada", "seccionada", "secretada", "secuenciada", "secuestrada", "secundada", "sedimentada", "seducida", "segada", "segmentada", "segregada", "seguida", "seleccionada", "sembrada", "señalada", "sensibilizada", "sentada", "sentenciada", "sentida", "separada", "serenada", "serrada", "servida", "significada", "silenciada", "simbolizada", "simpatizada", "simplificada", "simulada", "sincerada", "sincronizada", "sindicada", "sindicalizada", "singularizada", "sintetizada", "sintonizada", "sistematizada", "situada", "sobada", "sobornada", "sobrada", "sobrecargada", "sobrecogida", "sobreentendida", "sobreestimada", "sobrellevada", "sobrentendida", "sobrepasada", "sobrepuesta", "sobresalida", "sobresaltada", "sobrestimada", "sobrevenida", "sobrevivida", "sobrevolada", "socavada", "socializada", "socorrida", "sodomizada", "sofocada", "sojuzgada", "solapada", "solicitada", "solidarizada", "solidificada", "soliviantada", "soltada", "solucionada", "solventada", "sombreada", "sometida", "sonada", "soñada", "sondeada", "sonreída", "sonrojada", "sopesada", "soplada", "soportada", "sorbida", "sorprendida", "sorteada", "sosegada", "soslayada", "sospechada", "sostenida", "suavizada", "subastada", "subcontratada", "subdividida", "subestimada", "subida", "sublevada", "sublimada", "subrayada", "subrogada", "subsanada", "subsidiada", "subsistida", "substraída", "subsumida", "subvertida", "subyugada", "succionada", "sucedida", "sucumbida", "sudada", "sufragada", "sufrida", "sugerida", "sugestionada", "suicidada", "sujetada", "sumada", "sumergida", "suministrada", "supeditada", "superada", "superpuesta", "supervisada", "suplantada", "suplicada", "suplida", "suprimida", "supuesta", "surcada", "surtida", "suscitada", "suspendida", "suspirada", "sustanciada", "sustantivada", "sustentada", "sustituida", "sustraída", "susurrada", "suturada", "tabulada", "tachada", "talada", "taladrada", "tallada", "tambaleada", "tamizada", "tañida", "tanteada", "tapada", "tapizada", "taponada", "tarareada", "tardada", "tasada", "tatuada", "tecleada", "tejida", "telefoneada", "televisada", "temida", "templada", "tendida", "tenida", "tensada", "tentada", "teorizada", "terciada", "tergiversada", "terminada", "territorializada", "testada", "testeada", "testificada", "testimoniada", "tildada", "timada", "timbrada", "tinturada", "tipeada", "tipificada", "tirada", "tiranizada", "tironeada", "tiroteada", "titubeada", "tiznada", "tocada", "tolerada", "tomada", "tonificada", "topada", "toqueteada", "torcida", "toreada", "tornada", "tornasolada", "torneada", "torpedeada", "torturada", "tosida", "tostada", "totalizada", "trabada", "trabajada", "traducida", "traficada", "tragada", "traicionada", "traída", "trajinada", "tramada", "tramitada", "trancada", "tranquilizada", "transcendida", "transcurrida", "transferida", "transfigurada", "transformada", "transfundida", "transgredida", "transigida", "transitada", "transliterada", "translucida", "transmitida", "transmutada", "transparentada", "transpirada", "transportada", "transpuesta", "trasegada", "trasgredida", "trasladada", "traslapada", "traslucida", "trasnochada", "traspapelada", "traspasada", "trasplantada", "traspuesta", "trasquilada", "trasteada", "trastocada", "trastornada", "trasvasada", "tratada", "trazada", "trenzada", "trepada", "tributada", "trincada", "triplicada", "triturada", "triunfada", "trivializada", "trocada", "troceada", "tronada", "tronchada", "truncada", "tumbada", "tuneada", "turbada", "turnada", "tutelada", "ufanada", "ultimada", "uncida", "ungida", "unida", "universalizada", "untada", "urbanizada", "urdida", "usada", "usufructuada", "usurpada", "utilizada", "vacada", "vaciada", "vacilada", "vacunada", "vagada", "validada", "valida", "valorada", "valorizada", "valuada", "vanagloriada", "vandalizada", "vaporizada", "variada", "vaticinada", "vedada", "vehiculada", "vejada", "velada", "vencida", "vendada", "vendida", "venerada", "vengada", "ventilada", "veraneada", "verbalizada", "verificada", "versada", "versionada", "vertebrada", "vertida", "vestida", "vetada", "viabilizada", "viajada", "vibrada", "victimada", "victimizada", "vigilada", "vigorizada", "vilipendiada", "vindicada", "violada", "violentada", "virada", "visada", "visibilizada", "visitada", "vislumbrada", "vista", "visualizada", "vitoreada", "vitrificada", "vituperada", "vivida", "vivificada", "vocalizada", "voceada", "vociferada", "volada", "volatilizada", "volcada", "volteada", "vomitada", "votada", "vuelta", "vulcanizada", "vulgarizada", "vulnerada", "yuxtapuesta", "zafada", "zambullida", "zampada", "zanjada", "zarandeada", "zarpada", "zozobrada", "zumbada", "zurcida", "zurrada", "abajados", "abalanzados", "abaleados", "abandonados", "abaratados", "abarcados", "abarrotados", "abastecidos", "abatidos", "abdicados", "abiertos", "abismados", "abjurados", "ablandados", "abocados", "abochornados", "abofeteados", "abolidos", "abollados", "abombados", "abominados", "abonados", "abordados", "aborrecidos", "aborregados", "abortados", "abotonados", "abrasados", "abrazados", "abrevados", "abreviados", "abrigados", "abrochados", "abrogados", "abroquelados", "abrumados", "absorbidos", "abstenidos", "abstraídos", "absueltos", "abucheados", "abultados", "abundados", "aburguesados", "aburridos", "abusados", "acabados", "acallados", "acalorados", "acaparados", "acariciados", "acarreados", "acatados", "acaudillados", "accedidos", "accionados", "acechados", "aceitados", "acelerados", "acentuados", "aceptados", "acerados", "acercados", "acertados", "achacados", "achantados", "achatados", "achicados", "acicalados", "acidificados", "aclarados", "aclimatados", "acobardados", "acodados", "acogidos", "acojonados", "acometidos", "acomodados", "acompañados", "acompasados", "acongojados", "aconsejados", "acontecidos", "acopiados", "acoplados", "acordados", "acordonados", "acorralados", "acortados", "acosados", "acostados", "acostumbrados", "acotados", "acrecentados", "acreditados", "acrisolados", "activados", "actuados", "acuchillados", "acuciados", "acudidos", "acuerpados", "acumulados", "acunados", "acuñados", "acurrucados", "acusados", "adaptados", "adecentados", "adelantados", "adelgazados", "adentrados", "adeudados", "adheridos", "adicionados", "adiestrados", "adivinados", "adjetivados", "adjudicados", "adjuntados", "administrados", "admirados", "admitidos", "adoctrinados", "adolecidos", "adoptados", "adorados", "adormecidos", "adornados", "adquiridos", "aducidos", "adueñados", "adulados", "adulterados", "advertidos", "afanados", "afeados", "afectados", "afeitados", "aferrados", "afianzados", "afinados", "afirmados", "afligidos", "aflorados", "afrentados", "afrontados", "agachados", "agarrados", "agarrotados", "agasajados", "agenciados", "agigantados", "agilizados", "agitados", "aglutinados", "agobiados", "agolpados", "agonizados", "agostados", "agotados", "agradados", "agradecidos", "agrandados", "agravados", "agraviados", "agredidos", "agregados", "agriados", "agrietados", "agrupados", "aguados", "aguantados", "aguardados", "agudizados", "aguijoneados", "agujereados", "aguzados", "ahogados", "ahondados", "ahorcados", "ahorrados", "ahuecados", "ahuyentados", "aireados", "aislados", "ajustados", "ajusticiados", "alabados", "alagados", "alambrados", "alardeados", "alargados", "alarmados", "albergados", "alborotados", "alcanzados", "aleccionados", "alegados", "alegrados", "alejados", "alentados", "alertados", "alfabetizados", "alfombrados", "aliados", "alienados", "aligerados", "alimentados", "aliñados", "alineados", "alisados", "alistados", "aliviados", "alivianados", "allanados", "almacenados", "almorzados", "alojados", "alquilados", "alterados", "alternados", "alucinados", "aludidos", "alumbrados", "alzados", "amados", "amaestrados", "amagados", "amainados", "amalgamados", "amamantados", "amansados", "amargados", "amarrados", "amasados", "ambicionados", "amedrentados", "amenazados", "amenizados", "ameritados", "ametrallados", "amilanados", "aminorados", "amnistiados", "amoldados", "amonestados", "amontonados", "amordazados", "amortajados", "amortiguados", "amortizados", "amotinados", "amparados", "ampayados", "ampliados", "amplificados", "amputados", "amueblados", "añadidos", "analizados", "anatematizados", "andados", "anegados", "anestesiados", "anexados", "anexionados", "anhelados", "anidados", "anillados", "animados", "aniquilados", "anisados", "añorados", "anotados", "anoticiados", "ansiados", "antecedidos", "antepuestos", "anticipados", "antojados", "anudados", "anulados", "anunciados", "apabullados", "apachurrados", "apaciguados", "apadrinados", "apagados", "apalancados", "apaleados", "apañados", "apantallados", "aparcados", "apareados", "aparecidos", "aparentados", "apartados", "apeados", "apedreados", "apelados", "apellidados", "apelmazados", "apercibidos", "apersonados", "apestados", "apetecidos", "apiadados", "apilados", "apiñados", "apisonados", "aplacados", "aplanados", "aplastados", "aplaudidos", "aplazados", "aplicados", "apoderados", "apoltronados", "aporreados", "aportados", "aposentados", "apostados", "apostatados", "apostillados", "apoyados", "apreciados", "aprehendidos", "apremiados", "aprendidos", "apresados", "apresurados", "apretados", "apretujados", "aprisionados", "aprobados", "aprovechados", "aprovisionados", "aproximados", "apuñalados", "apuñaleados", "apuntados", "apuntalados", "apuntillados", "apurados", "aquejados", "aquietados", "aquilatados", "arañados", "arbitrados", "archivados", "arengados", "argüidos", "argumentados", "armados", "armonizados", "aromatizados", "arqueados", "arrancados", "arrasados", "arrastrados", "arreados", "arrebatados", "arreciados", "arreglados", "arrellanados", "arremangados", "arremetidos", "arrendados", "arrepentidos", "arrestados", "arriados", "arribados", "arriesgados", "arrimados", "arrinconados", "arrodillados", "arrogados", "arrojados", "arrollados", "arropados", "arruinados", "arrullados", "articulados", "asados", "asaltados", "ascendidos", "aseados", "asechados", "asediados", "asegurados", "asemejados", "asentados", "asentidos", "aserrados", "asesinados", "asesorados", "asestados", "aseverados", "asfixiados", "asidos", "asignados", "asilados", "asimilados", "asistidos", "asolados", "asoleados", "asomados", "asombrados", "aspirados", "astillados", "asumidos", "asustados", "atacados", "atados", "atajados", "atarantados", "atascados", "atemorizados", "atemperados", "atenazados", "atendidos", "atenidos", "atentados", "atenuados", "aterrados", "aterrorizados", "atesorados", "atestiguados", "atiborrados", "atisbados", "atizados", "atomizados", "atontados", "atorados", "atormentados", "atornillados", "atosigados", "atracados", "atragantados", "atraídos", "atrancados", "atrapados", "atrasados", "atravesados", "atrevidos", "atribuidos", "atrincherados", "atrofiados", "atropellados", "aturdidos", "auditados", "augurados", "aumentados", "aunados", "aupados", "auscultados", "ausentados", "autenticados", "autentificados", "autodefinidos", "autoeditados", "automatizados", "autorizados", "autorregulados", "auxiliados", "avalados", "avanzados", "avasallados", "avenidos", "aventados", "aventajados", "aventurados", "averiados", "averiguados", "avezados", "avisados", "avispados", "avistados", "avivados", "avizorados", "avocados", "ayudados", "azotados", "azuzados", "babeados", "bailados", "bajados", "balaceados", "balanceados", "bañados", "banalizados", "bancados", "bandeados", "barajados", "barridos", "basados", "bastardeados", "basureados", "batallados", "bateados", "batidos", "bautizados", "beatificados", "bebidos", "beneficiados", "besados", "bifurcados", "birlados", "blandidos", "blanqueados", "blasfemados", "blindados", "bloqueados", "boicoteados", "bombardeados", "bombeados", "bonificados", "bordeados", "borrados", "borroneados", "bosquejados", "bostezados", "botados", "boxeados", "bregados", "brillados", "brincados", "brindados", "bromeados", "brotados", "bruñidos", "buceados", "burlados", "buscados", "cabeceados", "cabidos", "cabildeados", "cabreados", "cacareados", "cachados", "cacheados", "cacheteados", "caducados", "cagados", "calados", "calculados", "caldeados", "calefaccionados", "calendarizados", "calentados", "calibrados", "calificados", "caligrafiados", "callados", "calmados", "calumniados", "calzados", "cambiados", "caminados", "camuflados", "canalizados", "cancelados", "canjeados", "cansados", "cantados", "capados", "capeados", "capitalizados", "capitulados", "captados", "capturados", "caracterizados", "carburados", "carcomidos", "cardados", "careados", "carecidos", "cargados", "caricaturizados", "cartografiados", "cascados", "castigados", "castrados", "catados", "catalizados", "catalogados", "catapultados", "cateados", "categorizados", "causados", "cauterizados", "cautivados", "cavados", "cavilados", "cazados", "cebados", "cedidos", "cegados", "cejados", "celebrados", "cenados", "ceñidos", "censurados", "centrifugados", "centuplicados", "cepillados", "cercados", "cercenados", "cerciorados", "cernidos", "cerrados", "cesados", "chafados", "chamuscados", "chantajeados", "chapados", "charlados", "chateados", "chequeados", "chiflados", "chillados", "chingados", "chirriados", "chivados", "chocados", "chorreados", "choteados", "chupados", "chutados", "cicatrizados", "cifrados", "cimentados", "cincelados", "circulados", "circuncidados", "circundados", "citados", "clamados", "clarificados", "clasificados", "claudicados", "clausurados", "clavados", "clicados", "clonados", "coaccionados", "coadyuvados", "coagulados", "coaligados", "coartados", "cobijados", "cobrados", "cocidos", "cocinados", "codeados", "codiciados", "codificados", "codirigidos", "coexistidos", "cofinanciados", "cogidos", "cohabitados", "cohibidos", "coincididos", "colaborados", "colacionados", "colados", "colapsados", "coleccionados", "colectados", "colectivizados", "colgados", "colisionados", "colmados", "colocados", "colonizados", "coloreados", "columpiados", "combatidos", "combinados", "comentados", "comenzados", "comerciados", "comercializados", "cometidos", "comidos", "comisionados", "compactados", "compadecidos", "compaginados", "comparados", "comparecidos", "compartidos", "compatibilizados", "compelidos", "compendiados", "compenetrados", "compensados", "compilados", "complacidos", "complementados", "completados", "complotados", "comportados", "comprados", "comprendidos", "comprimidos", "comprobados", "comprometidos", "compuestos", "compulsados", "computados", "comulgados", "comunicados", "concatenados", "concebidos", "concedidos", "concelebrados", "concentrados", "conceptuados", "conceptualizados", "concertados", "concienciados", "concientizados", "conciliados", "concitados", "concluidos", "concordados", "concretados", "concretizados", "conculcados", "concursados", "condenados", "condensados", "condicionados", "condimentados", "condolidos", "condonados", "conducidos", "conectados", "conexionados", "confabulados", "confeccionados", "conferidos", "confesados", "confiados", "configurados", "confirmados", "confiscados", "confluidos", "conformados", "confortados", "confrontados", "confundidos", "congeniados", "congestionados", "congratulados", "congregados", "conjeturados", "conjugados", "conjuntados", "conjurados", "conllevados", "conmemorados", "conminados", "conmocionados", "conmovidos", "conmutados", "connotados", "conquistados", "consagrados", "conseguidos", "consensuados", "consentidos", "conservados", "considerados", "consignados", "consistidos", "consolados", "consolidados", "conspirados", "constados", "constatados", "constelados", "constitucionalizados", "constituidos", "constreñidos", "construidos", "consultados", "consumados", "consumidos", "contabilizados", "contactados", "contados", "contagiados", "contemplados", "contendidos", "contenidos", "contentados", "contestados", "contextualizados", "continuados", "contorneados", "contraatacados", "contrabandeados", "contradichos", "contrahechos", "contraídos", "contrapesados", "contrapuestos", "contrariados", "contrarrestados", "contrastados", "contratados", "contravenidos", "contribuidos", "contristados", "controlados", "convalidados", "convencidos", "convenidos", "convergidos", "conversados", "convertidos", "convidados", "convividos", "convocados", "convulsionados", "cooperados", "cooptados", "coordinados", "copados", "copiados", "coproducidos", "copulados", "coqueteados", "corchados", "coreados", "coreografiados", "corneados", "coronados", "corporizados", "corregidos", "correlacionados", "correspondidos", "correteados", "corridos", "corroborados", "corroídos", "corrompidos", "cortados", "cortejados", "cosechados", "cosidos", "cosificados", "costados", "costeados", "cotejados", "cotizados", "creados", "creídos", "criados", "cribados", "criminalizados", "crispados", "cristalizados", "cristianizados", "criticados", "cronometrados", "crucificados", "crujidos", "cruzados", "cuadriplicados", "cuadruplicados", "cuajados", "cuantificados", "cuarteados", "cubiertos", "cuestionados", "cuidados", "culeados", "culminados", "culpabilizados", "culpados", "cultivados", "culturizados", "cumplidos", "cumplimentados", "cundidos", "curados", "curioseados", "currados", "cursados", "curvados", "custodiados", "dados", "dañados", "danzados", "datados", "dateados", "debatidos", "debidos", "debilitados", "debitados", "debutados", "decaídos", "decantados", "decapitados", "decepcionados", "decididos", "declamados", "declarados", "declinados", "decodificados", "decolorados", "decomisados", "decrecidos", "decretados", "dedicados", "deducidos", "defecados", "defendidos", "defenestrados", "deferidos", "definidos", "deformados", "defraudados", "degenerados", "deglutidos", "degollados", "degradados", "degustados", "deificados", "dejados", "delatados", "delegados", "deleitados", "deletreados", "deliberados", "delimitados", "delineados", "delinquidos", "demandados", "demarcados", "demediados", "demeritados", "democratizados", "demolidos", "demonizados", "demorados", "demostrados", "demudados", "denegados", "denigrados", "denominados", "denostados", "denotados", "denunciados", "deparados", "departidos", "dependidos", "depilados", "deplorados", "deportados", "depositados", "depreciados", "depredados", "deprimidos", "depuestos", "depurados", "derechizados", "derivados", "derogados", "derramados", "derretidos", "derribados", "derrocados", "derrochados", "derrotados", "derruidos", "derrumbados", "desabrochados", "desacatados", "desacelerados", "desacomodados", "desaconsejados", "desacoplados", "desacralizados", "desacreditados", "desactivados", "desafiados", "desafinados", "desaguados", "desahogados", "desairados", "desajustados", "desalentados", "desalineados", "desalojados", "desandados", "desangrados", "desanimados", "desaparecidos", "desapegados", "desaprendidos", "desaprobados", "desaprovechados", "desarmados", "desarraigados", "desarreglados", "desarrollados", "desarticulados", "desaseados", "desasidos", "desasosegados", "desatados", "desatendidos", "desautorizados", "desayunados", "desbancados", "desbandados", "desbaratados", "desbarrancados", "desbastados", "desbloqueados", "desbocados", "desbordados", "desbrozados", "descabalgados", "descabezados", "descaderados", "descalabrados", "descalificados", "descansados", "descargados", "descarriados", "descarrilados", "descartados", "descascarados", "descascarillados", "descendidos", "descentrados", "descifrados", "descocidos", "descodificados", "descojonados", "descolgados", "descolocados", "descolonizados", "descompensados", "descomprimidos", "descompuestos", "desconectados", "desconfiados", "descongelados", "desconocidos", "descontados", "descontaminados", "descontextualizados", "descontinuados", "desconvocados", "descorazonados", "descorchados", "descorridos", "descosidos", "descoyuntados", "descreídos", "descristianizados", "descuadrados", "descuartizados", "descubiertos", "descuidados", "desdeñados", "desdibujados", "desdichos", "desdoblados", "deseados", "desecados", "desechados", "desembarazados", "desembarcados", "desembocados", "desembolsados", "desempacados", "desempañados", "desempaquetados", "desempeñados", "desempolvados", "desenamorados", "desencadenados", "desencajados", "desencarnados", "desenchufados", "desenfocados", "desenfundados", "desenganchados", "desengrasados", "desenmascarados", "desenredados", "desenrollados", "desentendidos", "desenterrados", "desentonados", "desentrañados", "desenvainados", "desenvueltos", "desequilibrados", "desertados", "desestabilizados", "desestimados", "desfalcados", "desfallecidos", "desfigurados", "desfondados", "desgajados", "desgañitados", "desgarrados", "desgastados", "desglosados", "desgobernados", "desgranados", "desguazados", "deshechos", "desheredados", "deshidratados", "deshilachados", "deshojados", "deshonrados", "deshuesados", "deshumanizados", "designados", "desilusionados", "desincentivados", "desinfectados", "desinflados", "desinflamados", "desinformados", "desinhibidos", "desinstalados", "desintegrados", "desintoxicados", "desistidos", "desjarretados", "deslegitimados", "desleídos", "desligados", "deslindados", "deslizados", "deslucidos", "deslumbrados", "desmadrados", "desmalezados", "desmantelados", "desmaquillados", "desmarcados", "desmayados", "desmejorados", "desmembrados", "desmentidos", "desmenuzados", "desmerecidos", "desmigados", "desmitificados", "desmoldados", "desmontados", "desmoralizados", "desmoronados", "desmotivados", "desmovilizados", "desnaturalizados", "desnivelados", "desnucados", "desnudados", "desobedecidos", "desobligados", "desoídos", "desollados", "desorganizados", "desorientados", "despachados", "desparasitados", "desparecidos", "desparramados", "despedazados", "despedidos", "despegados", "despeinados", "despejados", "despellejados", "despeñados", "despenalizados", "desperdiciados", "despersonalizados", "despertados", "despilfarrados", "despintados", "despiojados", "despistados", "desplazados", "desplegados", "desplomados", "desplumados", "despojados", "despolitizados", "desposados", "desposeídos", "despotricados", "despreciados", "desprendidos", "despreocupados", "desprestigiados", "desprogramados", "despulpados", "despuntados", "desquiciados", "desquitados", "destacados", "destapados", "desteñidos", "desterrados", "destetados", "destilados", "destituidos", "destrabados", "destripados", "destronados", "destrozados", "destruidos", "desunidos", "desvalijados", "desvalorizados", "desvanecidos", "desvelados", "desvestidos", "desviados", "desvinculados", "desvirtuados", "desvividos", "detectados", "detenidos", "detentados", "deteriorados", "determinados", "detestados", "detonados", "devaluados", "devanados", "devastados", "develados", "devengados", "devenidos", "devorados", "devueltos", "diagnosticados", "diagramados", "dializados", "dialogados", "dibujados", "dichos", "dictados", "dictaminados", "diezmados", "difamados", "diferenciados", "diferidos", "dificultados", "difuminados", "difundidos", "digeridos", "digitados", "dignados", "dignificados", "dilapidados", "dilatados", "diligenciados", "dilucidados", "diluidos", "dimensionados", "dimitidos", "dinamitados", "dinamizados", "dirimidos", "discernidos", "disciplinados", "discontinuados", "discrepados", "discriminados", "disculpados", "discurridos", "discutidos", "diseccionados", "diseminados", "diseñados", "disentidos", "disertados", "disfrazados", "disfrutados", "disgregados", "disgustados", "disimulados", "disipados", "dislocados", "disminuidos", "disociados", "dispensados", "dispersados", "dispuestos", "disputados", "distados", "distanciados", "distendidos", "distinguidos", "distorsionados", "distraídos", "distribuidos", "disuadidos", "disueltos", "divagados", "diversificados", "divertidos", "divididos", "divinizados", "divisados", "divorciados", "divulgados", "doblados", "doblegados", "doctorados", "documentados", "dogmatizados", "dolidos", "domados", "domesticados", "dominados", "donados", "dopados", "dormidos", "dosificados", "dotados", "dragados", "dramatizados", "drenados", "drogados", "duchados", "dudados", "dulcificados", "duplicados", "durados", "echados", "eclipsados", "eclosionados", "economizados", "ecualizados", "edificados", "editados", "educados", "efectuados", "ejecutados", "ejemplificados", "ejercidos", "ejercitados", "elaborados", "electrizados", "electrocutados", "elevados", "elididos", "eliminados", "elogiados", "elucubrados", "eludidos", "emanados", "emancipados", "embadurnados", "embalados", "embalsamados", "embanderados", "embarcados", "embargados", "embarrados", "embarrancados", "embaucados", "embebidos", "embelesados", "embellecidos", "embestidos", "embolados", "embolsados", "emborrachados", "emborronados", "emboscados", "embotados", "embriagados", "embrollados", "embrutecidos", "embuchados", "emergidos", "emigrados", "emitidos", "emocionados", "empacados", "empachados", "empadronados", "empalados", "empalmados", "empanados", "empañados", "empantanados", "empapelados", "empaquetados", "emparejados", "empastados", "empatados", "empecinados", "empeñados", "empeorados", "empequeñecidos", "emperrados", "empezados", "empinados", "emplazados", "empleados", "empobrecidos", "empoderados", "empollados", "empolvados", "emponzoñados", "emprendidos", "empujados", "empuñados", "emputados", "emulados", "emulsionados", "enajenados", "enaltecidos", "enamorados", "enarbolados", "enardecidos", "encabezados", "encabritados", "encabronados", "encadenados", "encajados", "encajonados", "encallados", "encamados", "encaminados", "encandilados", "encanecidos", "encañonados", "encantados", "encaprichados", "encapsulados", "encarados", "encaramados", "encarecidos", "encargados", "encariñados", "encarnados", "encarrilados", "encartados", "encasillados", "encasquetados", "encasquillados", "encastrados", "encausados", "encauzados", "enceguecidos", "encendidos", "encerados", "encerrados", "encharcados", "enchufados", "encimados", "encogidos", "encolados", "encolerizados", "encolumnados", "encomendados", "enconados", "encontrados", "encordados", "encrespados", "encuadrados", "encubiertos", "encuerados", "encumbrados", "enderezados", "endeudados", "endilgados", "endiosados", "endosados", "endulzados", "endurecidos", "enemistados", "energizados", "enervados", "enfadados", "enfangados", "enfatizados", "enfermados", "enfiestados", "enfilados", "enflaquecidos", "enfocados", "enfrascados", "enfrentados", "enfriados", "enfurecidos", "engalanados", "engañados", "enganchados", "engarzados", "engatusados", "engendrados", "englobados", "engolosinados", "engordados", "engranados", "engrandecidos", "engrasados", "engreídos", "engrosados", "engullidos", "enharinados", "enhebrados", "enjuagados", "enjugados", "enjuiciados", "enlazados", "enlistados", "enlodados", "enloquecidos", "enlozados", "enlutados", "enmarañados", "enmascarados", "enmendados", "enmohecidos", "enmudecidos", "ennegrecidos", "ennoblecidos", "enorgullecidos", "enrarecidos", "enredados", "enripiados", "enriquecidos", "enrocados", "enrojecidos", "enrolados", "enrollados", "enroscados", "enrumbados", "ensalzados", "ensamblados", "ensañados", "ensanchados", "ensartados", "ensayados", "ensebados", "enseñados", "enseñoreados", "ensillados", "ensoberbecidos", "ensogados", "ensombrecidos", "ensoñados", "ensordecidos", "ensuciados", "entablados", "entallados", "entendidos", "enterados", "enternecidos", "enterrados", "entibiados", "entintados", "entonados", "entorpecidos", "entrados", "entrampados", "entrañados", "entreabiertos", "entrecomillados", "entrecruzados", "entregados", "entrelazados", "entremetidos", "entremezclados", "entrenados", "entresacados", "entretejidos", "entretenidos", "entreverados", "entrevistados", "entristecidos", "entrometidos", "entronados", "entroncados", "entronizados", "entumecidos", "enturbiados", "entusiasmados", "enumerados", "enunciados", "envainados", "envalentonados", "envanecidos", "envasados", "envejecidos", "envenenados", "envestidos", "enviados", "enviciados", "envidiados", "envilecidos", "enviudados", "envueltos", "enzarzados", "equilibrados", "equiparados", "equivocados", "erigidos", "erizados", "erogados", "erosionados", "erotizados", "erradicados", "errados", "esbozados", "escabullidos", "escalados", "escaldados", "escalfados", "escamados", "escamoteados", "escampados", "escandalizados", "escaneados", "escapados", "escaqueados", "escarbados", "escarchados", "escarmentados", "escarnecidos", "escaseados", "escatimados", "escenificados", "escindidos", "esclarecidos", "esclavizados", "escocidos", "escogidos", "escolarizados", "escoltados", "escondidos", "escorados", "escrachados", "escritos", "escrutados", "escuchados", "escudados", "escudriñados", "esculpidos", "escupidos", "escurridos", "esforzados", "esfumados", "esgrimidos", "esmerados", "esmerilados", "espabilados", "espaciados", "españolizados", "espantados", "esparcidos", "especificados", "especulados", "esperados", "espesados", "espetados", "espiados", "espigados", "espinados", "espirados", "espiritualizados", "espoleados", "espolvoreados", "esponjados", "esponsorizados", "esposados", "esquematizados", "esquiados", "esquilados", "esquilmados", "esquivados", "estabilizados", "establecidos", "estacionados", "estafados", "estallados", "estampados", "estancados", "estaqueados", "estatizados", "estatuidos", "esterificados", "esterilizados", "estigmatizados", "estilizados", "estimados", "estimulados", "estipulados", "estirados", "estorbados", "estornudados", "estragados", "estrangulados", "estrechados", "estrellados", "estremecidos", "estrenados", "estresados", "estriados", "estropeados", "estructurados", "estrujados", "estudiados", "eternizados", "etiquetados", "evacuados", "evadidos", "evaluados", "evangelizados", "evaporados", "evidenciados", "eviscerados", "evitados", "evocados", "evolucionados", "exacerbados", "exagerados", "exaltados", "examinados", "exasperados", "excarcelados", "excavados", "excedidos", "exceptuados", "excitados", "exclamados", "excluidos", "excretados", "exculpados", "excusados", "execrados", "exhalados", "exhibidos", "exhortados", "exhumados", "exigidos", "exilados", "eximidos", "existidos", "exonerados", "exorcizados", "expandidos", "expedidos", "expedientados", "expelidos", "expendidos", "experimentados", "expiados", "expirados", "explayados", "explicados", "explicitados", "explorados", "explosionados", "explotados", "expoliados", "exportados", "expresados", "exprimidos", "expropiados", "expuestos", "expulsados", "expurgados", "extendidos", "exteriorizados", "exterminados", "externados", "externalizados", "extinguidos", "extirpados", "extorsionados", "extractados", "extraditados", "extraídos", "extralimitados", "extrañados", "extrapolados", "extraviados", "extremados", "extruidos", "exudados", "eyaculados", "eyectados", "fabricados", "fabulados", "facilitados", "facturados", "facultados", "fagocitados", "fajados", "fallados", "fallecidos", "falsados", "falseados", "falsificados", "familiarizados", "fantaseados", "fascinados", "fastidiados", "fatigados", "favorecidos", "fecundados", "felicitados", "feminizados", "fenecidos", "fermentados", "fertilizados", "festejados", "fiados", "fichados", "fidelizados", "figurados", "fijados", "filmados", "filosofados", "filtrados", "finalizados", "financiados", "fincados", "fingidos", "finiquitados", "firmados", "fiscalizados", "fisurados", "flagelados", "flameados", "flanqueados", "flaqueados", "fletados", "flexibilizados", "flexionados", "flipados", "floreados", "florecidos", "flotados", "fluctuados", "focalizados", "fogueados", "foliados", "follados", "fomentados", "fondeados", "forcejeados", "forestados", "forjados", "formados", "formalizados", "formateados", "formulados", "fornicados", "forrados", "fortalecidos", "forzados", "fotocopiados", "fotografiados", "fracasados", "fraccionados", "fracturados", "fragmentados", "fraguados", "franqueados", "frecuentados", "fregados", "frenados", "fresados", "friccionados", "frotados", "fructificados", "fruncidos", "fugados", "fulminados", "fumados", "fumigados", "funcionados", "fundados", "fundamentados", "fundidos", "fungidos", "fusilados", "fusionados", "fustigados", "gafados", "ganados", "gangrenados", "garabateados", "garantidos", "garantizados", "garridos", "gaseados", "gastados", "gemidos", "generados", "generalizados", "gerenciados", "germinados", "gestados", "gestionados", "girados", "glorificados", "glosados", "gobernados", "goleados", "golpeados", "gozados", "grabados", "graduados", "graficados", "granjeados", "grapados", "gratificados", "gravados", "gravitados", "gritados", "gruñidos", "guardados", "guarecidos", "guarnecidos", "guerreados", "guiados", "guillotinados", "guiñados", "guindados", "guisados", "gustados", "habilitados", "habitados", "habituados", "hablados", "halados", "halagados", "hallados", "hartados", "hechizados", "hechos", "helenizados", "henchidos", "hendidos", "heredados", "heridos", "hermanados", "herrados", "hervidos", "hibernados", "hibridados", "hidratados", "higienizados", "hilados", "hilvanados", "hincados", "hinchados", "hipnotizados", "hipotecados", "historiados", "hojeados", "holgados", "hollados", "homenajeados", "homogeneizados", "homologados", "honrados", "horadados", "horneados", "horrorizados", "hospedados", "hostigados", "hostilizados", "huidos", "humanados", "humanizados", "humectados", "humedecidos", "humillados", "hundidos", "hurgados", "hurtados", "ideados", "idealizados", "identificados", "ideologizados", "idiotizados", "idolatrados", "ignorados", "igualados", "ilegalizados", "iluminados", "ilusionados", "ilustrados", "imaginados", "imbricados", "imitados", "impactados", "impartidos", "impedidos", "impelidos", "imperados", "impermeabilizados", "implantados", "implementados", "implicados", "implorados", "importados", "importunados", "imposibilitados", "impresionados", "improvisados", "impuestos", "impugnados", "impulsados", "imputados", "inaugurados", "incautados", "incendiados", "incentivados", "incinerados", "incitados", "inclinados", "incluidos", "incoados", "incomodados", "incorporados", "incrementados", "increpados", "incriminados", "incubados", "inculcados", "inculpados", "incumplidos", "incurridos", "incursionados", "indagados", "indemnizados", "independizados", "indexados", "indicados", "indigestados", "indignados", "indispuestos", "individuados", "inducidos", "indultados", "inervados", "infamados", "infartados", "infectados", "inferidos", "inficionados", "infiltrados", "inflados", "inflamados", "infligidos", "influenciados", "influidos", "informados", "infravalorados", "infringidos", "infundidos", "ingeniados", "ingeridos", "ingresados", "inhabilitados", "inhalados", "inhibidos", "inhumados", "iniciados", "inicializados", "injertados", "injuriados", "inmigrados", "inmiscuidos", "inmolados", "inmortalizados", "inmovilizados", "inmunizados", "innovados", "inoculados", "inquietados", "inquiridos", "insensibilizados", "insertados", "insinuados", "insistidos", "inspeccionados", "inspirados", "instados", "instalados", "instaurados", "instigados", "instituidos", "instruidos", "instrumentados", "instrumentalizados", "insuflados", "insultados", "insumidos", "integrados", "intelectualizados", "intensificados", "intentados", "interactuados", "intercalados", "intercambiados", "intercedidos", "interceptados", "interesados", "interferidos", "interiorizados", "intermediados", "internacionalizados", "internalizados", "interpelados", "interpolados", "interpretados", "interpuestos", "interrogados", "interrumpidos", "intervenidos", "intimados", "intimidados", "intitulados", "intoxicados", "intrigados", "introducidos", "intuidos", "inundados", "inutilizados", "invadidos", "invalidados", "inventados", "inventariados", "invertidos", "investidos", "investigados", "invitados", "invocados", "involucionados", "inyectados", "ionizados", "ironizados", "irradiados", "irrespetados", "irrigados", "irritados", "irrogados", "irrumpidos", "jactados", "jalados", "jaleados", "jalonados", "jaqueados", "jerarquizados", "jodidos", "jorobados", "jubilados", "jugados", "juntados", "jurados", "juramentados", "justificados", "juzgados", "laborados", "labrados", "laburados", "lacados", "lacerados", "lactados", "ladeados", "ladrados", "lamentados", "lamidos", "laminados", "languidecidos", "lanzados", "lapidados", "laqueados", "largados", "lastimados", "lastrados", "latidos", "laudados", "lavados", "legalizados", "legislados", "legitimados", "leídos", "lesionados", "leudados", "levantados", "liados", "liberados", "liberalizados", "libertados", "librados", "licitados", "licuados", "liderizados", "lidiados", "ligados", "lijados", "limados", "limitados", "limpiados", "linchados", "liquidados", "litigados", "llagados", "llamados", "llegados", "llenados", "llevados", "llorados", "localizados", "logrados", "lubricados", "luchados", "lucidos", "lucrados", "lustrados", "macerados", "machacados", "macheteados", "machucados", "madreados", "madrugados", "madurados", "magnetizados", "magnificados", "malacostumbrados", "malbaratados", "malcriados", "maleados", "malentendidos", "malgastados", "malinterpretados", "malogrados", "maltratados", "malversados", "mamados", "manchados", "mancillados", "mandados", "manejados", "mangados", "mangoneados", "manifestados", "maniobrados", "manipulados", "manoseados", "manteados", "mantenidos", "manufacturados", "maquillados", "maquinados", "maravillados", "marcados", "marchitados", "mareados", "marginados", "maridados", "martillados", "martirizados", "masacrados", "masajeados", "mascados", "masificados", "masticados", "masturbados", "matados", "materializados", "matizados", "matriculados", "maximizados", "meados", "mecanografiados", "mechados", "mecidos", "mediados", "mediatizados", "medicados", "medidos", "meditados", "medrados", "mejorados", "mellados", "memorizados", "mencionados", "meneados", "menguados", "menoscabados", "menospreciados", "menstruados", "mensualizados", "mensurados", "mentados", "mentalizados", "mentidos", "mercadeados", "mercantilizados", "merecidos", "merendados", "mermados", "merodeados", "mesurados", "metamorfoseados", "metidos", "mezclados", "migrados", "militados", "militarizados", "mimados", "mimetizados", "minados", "minimizados", "ministrados", "minusvalorados", "mirados", "mistificados", "mitificados", "mitigados", "modelados", "modernizados", "modificados", "modulados", "mofados", "mojados", "moldeados", "molestados", "molidos", "monetizados", "monitorizados", "monopolizados", "montados", "morados", "moralizados", "mordidos", "mordisqueados", "mortificados", "mosqueados", "mostrados", "motejados", "motivados", "movidos", "movilizados", "mudados", "muestreados", "multados", "multiplicados", "munidos", "murmurados", "mutados", "mutilados", "nacionalizados", "narcotizados", "narrados", "naufragados", "navegados", "necesitados", "negados", "negociados", "neutralizados", "ninguneados", "nivelados", "nombrados", "nominados", "noqueados", "normados", "normalizados", "notados", "notificados", "nutridos", "obcecados", "obedecidos", "objetados", "objetivados", "obligados", "obliterados", "obnubilados", "obrados", "obsequiados", "observados", "obsesionados", "obstaculizados", "obstruidos", "obtenidos", "obturados", "obviados", "ocasionados", "ocluidos", "ocultados", "ocupados", "odiados", "ofendidos", "ofertados", "oficiados", "oficializados", "ofrecidos", "ofrendados", "ofuscados", "oídos", "ojeados", "olfateados", "olidos", "olvidados", "omitidos", "ondeados", "ondulados", "opacados", "operados", "opinados", "oprimidos", "optados", "optimizados", "opuestos", "orados", "orbitados", "ordenados", "ordeñados", "organizados", "orientados", "originados", "orillados", "orinados", "ornados", "ornamentados", "orquestados", "osados", "oscilados", "oscurecidos", "osificados", "ostentados", "otorgados", "ovacionados", "ovulados", "oxidados", "oxigenados", "pacificados", "pactados", "padecidos", "paganizados", "paginados", "paladeados", "paliados", "palpados", "parados", "parafraseados", "paralizados", "parapetados", "parasitados", "parcelados", "parchados", "parcheados", "pareados", "paridos", "parodiados", "parqueados", "participados", "particularizados", "partidos", "pasados", "paseados", "pastoreados", "pataleados", "pateados", "patentados", "patentizados", "patinados", "patrullados", "pecados", "pedaleados", "pedidos", "pegados", "peinados", "pellizcados", "penalizados", "penetrados", "pensados", "percatados", "percibidos", "percutidos", "perdidos", "perdonados", "perdurados", "perecidos", "peregrinados", "perfeccionados", "perfilados", "perforados", "perfumados", "pergeñados", "peritados", "perjudicados", "perjurados", "permeados", "permitidos", "permutados", "pernoctados", "perpetrados", "perpetuados", "perseguidos", "perseverados", "persistidos", "personados", "personalizados", "personificados", "persuadidos", "pertenecidos", "pertrechados", "perturbados", "pervertidos", "pervividos", "pescados", "petados", "peticionados", "picados", "picaneados", "picoteados", "pifiados", "pignorados", "pillados", "pilotados", "piloteados", "pincelados", "pinchados", "pintados", "pintarrajeados", "pinzados", "pirados", "pirateados", "pisados", "pisoteados", "pitados", "placidos", "plagiados", "planchados", "planeados", "plantados", "planteados", "plasmados", "platicados", "plegados", "pluralizados", "podados", "poetizados", "polemizados", "politizados", "pololeados", "ponderados", "pontificados", "popularizados", "porfiados", "portados", "porteados", "posados", "posesionados", "posibilitados", "posicionados", "pospuestos", "posteados", "postergados", "postrados", "postulados", "potenciados", "practicados", "precarizados", "precedidos", "preceptuados", "precintados", "precipitados", "precisados", "preconizados", "predicados", "predichos", "predispuestos", "predominados", "preferidos", "prefigurados", "pregonados", "preguntados", "prejuzgados", "premiados", "prendados", "prendidos", "preocupados", "preparados", "presagiados", "prescindidos", "presenciados", "presentados", "presentidos", "preservados", "presididos", "presionados", "prestados", "prestigiados", "presumidos", "presurizados", "pretendidos", "preteridos", "prevalecidos", "prevalidos", "prevaricados", "prevenidos", "previstos", "primados", "principiados", "pringados", "priorizados", "privatizados", "probados", "problematizados", "procedidos", "procesados", "proclamados", "procreados", "procurados", "prodigados", "producidos", "profanados", "proferidos", "profesados", "profesionalizados", "profetizados", "profundizados", "programados", "progresados", "prohibidos", "prohijados", "proletarizados", "proliferados", "prologados", "prolongados", "promediados", "prometidos", "promocionados", "promovidos", "promulgados", "pronosticados", "pronunciados", "propagados", "propalados", "propendidos", "propiciados", "propinados", "proporcionados", "propuestos", "propugnados", "propulsados", "prorrateados", "prorrogados", "proseguidos", "prosperados", "prostituidos", "protegidos", "protestados", "protocolizados", "provenidos", "provocados", "proyectados", "psicoanalizados", "publicados", "publicitados", "puestos", "pugnados", "pujados", "pulidos", "pulsados", "pululados", "pulverizados", "punados", "punteados", "puntuados", "puntualizados", "punzados", "purgados", "purificados", "puteados", "quebrados", "quebrantados", "quejados", "quemados", "querellados", "queridos", "quintuplicados", "quitados", "racionados", "racionalizados", "radiados", "radicados", "radicalizados", "raídos", "rajados", "ralentizados", "rapados", "rapeados", "raptados", "rascados", "rasgados", "rasguñados", "raspados", "rastreados", "rasurados", "ratificados", "rayados", "razonados", "reabiertos", "reabsorbidos", "reaccionados", "reactivados", "readaptados", "readmitidos", "reafirmados", "reagrupados", "reajustados", "realimentados", "realizados", "realzados", "reanimados", "reanudados", "reaparecidos", "rearmados", "reasumidos", "reavivados", "rebajados", "rebalsados", "rebanados", "rebasados", "rebatidos", "rebautizados", "rebelados", "reblandecidos", "rebobinados", "rebosados", "rebotados", "rebozados", "rebuscados", "recabados", "recaídos", "recalados", "recalcados", "recalentados", "recalificados", "recapacitados", "recapitulados", "recargados", "recatados", "recaudados", "receptados", "recetados", "rechazados", "recibidos", "reciclados", "recitados", "reclamados", "reclinados", "reclutados", "recobrados", "recocidos", "recogidos", "recolectados", "recomendados", "recomenzados", "recompensados", "recompuestos", "reconcentrados", "reconciliados", "reconducidos", "reconfortados", "reconocidos", "reconquistados", "reconsiderados", "reconstituidos", "reconstruidos", "reconvenidos", "reconvertidos", "recopilados", "recordados", "recorridos", "recortados", "recreados", "recriminados", "recrudecidos", "rectificados", "recubiertos", "reculados", "recuperados", "recurridos", "recusados", "redactados", "redefinidos", "redescubiertos", "redimensionados", "redimidos", "rediseñados", "redistribuidos", "redituados", "redoblados", "redondeados", "reducidos", "redundados", "reedificados", "reeditados", "reeducados", "reelaborados", "reembolsados", "reemplazados", "reencarnados", "reencauchados", "reencontrados", "reenganchados", "reenviados", "reescritos", "reestructurados", "reexaminados", "refaccionados", "referidos", "refinados", "refinanciados", "reflejados", "reflexionados", "reflotados", "reforestados", "reformados", "reforzados", "refractados", "refrenados", "refrendados", "refrescados", "refrigerados", "refundidos", "refutados", "regados", "regalados", "regañados", "regateados", "regenerados", "regentados", "regenteados", "regidos", "regionalizados", "registrados", "reglados", "reglamentados", "regocijados", "regodeados", "regresados", "regulados", "regularizados", "regurgitados", "rehabilitados", "rehechos", "rehogados", "rehuidos", "rehusados", "reídos", "reinados", "reincididos", "reincorporados", "reingresados", "reiniciados", "reinsertados", "reinstalados", "reinstaurados", "reintegrados", "reinventados", "reinvertidos", "reiterados", "reivindicados", "rejuvenecidos", "relajados", "relamidos", "relanzados", "relatados", "relativizados", "relegados", "releídos", "relevados", "religados", "rellenados", "remachados", "remados", "remangados", "remarcados", "rematados", "remecidos", "remediados", "rememorados", "remendados", "remitidos", "remodelados", "remojados", "remolcados", "remontados", "removidos", "remplazados", "renacidos", "rendidos", "renegados", "renegociados", "reñidos", "renombrados", "renovados", "rentabilizados", "rentados", "renunciados", "reordenados", "reorganizados", "reorientados", "reparados", "repartidos", "repasados", "repatriados", "repelidos", "repensados", "repercutidos", "repescados", "repetidos", "repicados", "repintados", "replanteados", "replegados", "replicados", "repoblados", "reportados", "reporteados", "reposados", "repreguntados", "reprendidos", "represados", "representados", "reprimidos", "reprobados", "reprochados", "reproducidos", "repudiados", "repuestos", "repugnados", "repuntados", "reputados", "requeridos", "requisados", "resaltados", "resarcidos", "resbalados", "rescatados", "rescindidos", "resecados", "reseñados", "reservados", "reseteados", "resguardados", "resididos", "resignados", "resistidos", "resonados", "respaldados", "respetados", "respirados", "resplandecidos", "respondidos", "responsabilizados", "resquebrajados", "restablecidos", "restados", "restaurados", "restituidos", "restregados", "resucitados", "resueltos", "resumidos", "resurgidos", "retados", "retardados", "retenidos", "retirados", "retocados", "retomados", "retorcidos", "retornados", "retractados", "retraídos", "retransmitidos", "retrasados", "retratados", "retribuidos", "retrotraídos", "retumbados", "reunidos", "reunificados", "reutilizados", "revalidados", "revalorizados", "revaluados", "revelados", "revendidos", "reventados", "reverdecidos", "reverenciados", "revertidos", "revestidos", "revirados", "revisados", "revitalizados", "revividos", "revocados", "revolcados", "revoloteados", "revolucionados", "revueltos", "ridiculizados", "rifados", "rimados", "rivalizados", "rizados", "robados", "robustecidos", "rociados", "rodados", "rodeados", "rogados", "roídos", "rondados", "rotados", "rotos", "rotulados", "roturados", "rozados", "ruborizados", "rubricados", "rugidos", "rumiados", "rumorados", "sabidos", "saboreados", "saboteados", "sacados", "saciados", "sacralizados", "sacrificados", "sacudidos", "saldados", "salpimentados", "salpullidos", "saltados", "salteados", "saludados", "salvados", "salvaguardados", "sanados", "saneados", "sangrados", "santificados", "saqueados", "satanizados", "satirizados", "satisfechos", "sazonados", "secados", "seccionados", "secretados", "secuenciados", "secuestrados", "secundados", "sedimentados", "seducidos", "segados", "segmentados", "segregados", "seguidos", "seleccionados", "sembrados", "señalados", "sensibilizados", "sentados", "sentenciados", "sentidos", "separados", "serenados", "serrados", "servidos", "significados", "silenciados", "simbolizados", "simpatizados", "simplificados", "simulados", "sincerados", "sincronizados", "sindicados", "sindicalizados", "singularizados", "sintetizados", "sintonizados", "sistematizados", "situados", "sobados", "sobornados", "sobrados", "sobrecargados", "sobrecogidos", "sobreentendidos", "sobreestimados", "sobrellevados", "sobrentendidos", "sobrepasados", "sobrepuestos", "sobresalidos", "sobresaltados", "sobrestimados", "sobrevenidos", "sobrevividos", "sobrevolados", "socavados", "socializados", "socorridos", "sodomizados", "sofocados", "sojuzgados", "solapados", "solicitados", "solidarizados", "solidificados", "soliviantados", "soltados", "solucionados", "solventados", "sombreados", "sometidos", "sonados", "soñados", "sondeados", "sonreídos", "sonrojados", "sopesados", "soplados", "soportados", "sorbidos", "sorprendidos", "sorteados", "sosegados", "soslayados", "sospechados", "sostenidos", "suavizados", "subastados", "subcontratados", "subdivididos", "subestimados", "subidos", "sublevados", "sublimados", "subrayados", "subrogados", "subsanados", "subsidiados", "subsistidos", "substraídos", "subsumidos", "subvertidos", "subyugados", "succionados", "sucedidos", "sucumbidos", "sudados", "sufragados", "sufridos", "sugeridos", "sugestionados", "suicidados", "sujetados", "sumados", "sumergidos", "suministrados", "supeditados", "superados", "superpuestos", "supervisados", "suplantados", "suplicados", "suplidos", "suprimidos", "supuestos", "surcados", "surtidos", "suscitados", "suspendidos", "suspirados", "sustanciados", "sustantivados", "sustentados", "sustituidos", "sustraídos", "susurrados", "suturados", "tabulados", "tachados", "talados", "taladrados", "tallados", "tambaleados", "tamizados", "tañidos", "tanteados", "tapados", "tapizados", "taponados", "tarareados", "tardados", "tasados", "tatuados", "tecleados", "tejidos", "telefoneados", "televisados", "temidos", "templados", "tendidos", "tenidos", "tensados", "tentados", "teorizados", "terciados", "tergiversados", "terminados", "territorializados", "testados", "testeados", "testificados", "testimoniados", "tildados", "timados", "timbrados", "tinturados", "tipeados", "tipificados", "tirados", "tiranizados", "tironeados", "tiroteados", "titubeados", "tiznados", "tocados", "tolerados", "tomados", "tonificados", "topados", "toqueteados", "torcidos", "toreados", "tornados", "tornasolados", "torneados", "torpedeados", "torturados", "tosidos", "tostados", "totalizados", "trabados", "trabajados", "traducidos", "traficados", "tragados", "traicionados", "traídos", "trajinados", "tramados", "tramitados", "trancados", "tranquilizados", "transcendidos", "transcurridos", "transferidos", "transfigurados", "transformados", "transfundidos", "transgredidos", "transigidos", "transitados", "transliterados", "translucidos", "transmitidos", "transmutados", "transparentados", "transpirados", "transportados", "transpuestos", "trasegados", "trasgredidos", "trasladados", "traslapados", "traslucidos", "trasnochados", "traspapelados", "traspasados", "trasplantados", "traspuestos", "trasquilados", "trasteados", "trastocados", "trastornados", "trasvasados", "tratados", "trazados", "trenzados", "trepados", "tributados", "trincados", "triplicados", "triturados", "triunfados", "trivializados", "trocados", "troceados", "tronados", "tronchados", "truncados", "tumbados", "tuneados", "turbados", "turnados", "tutelados", "ufanados", "ultimados", "uncidos", "ungidos", "unidos", "universalizados", "untados", "urbanizados", "urdidos", "usados", "usufructuados", "usurpados", "utilizados", "vacados", "vaciados", "vacilados", "vacunados", "vagados", "validados", "validos", "valorados", "valorizados", "valuados", "vanagloriados", "vandalizados", "vaporizados", "variados", "vaticinados", "vedados", "vehiculados", "vejados", "velados", "vencidos", "vendados", "vendidos", "venerados", "vengados", "ventilados", "veraneados", "verbalizados", "verificados", "versados", "versionados", "vertebrados", "vertidos", "vestidos", "vetados", "viabilizados", "viajados", "vibrados", "victimados", "victimizados", "vigilados", "vigorizados", "vilipendiados", "vindicados", "violados", "violentados", "virados", "visados", "visibilizados", "visitados", "vislumbrados", "vistos", "visualizados", "vitoreados", "vitrificados", "vituperados", "vividos", "vivificados", "vocalizados", "voceados", "vociferados", "volados", "volatilizados", "volcados", "volteados", "vomitados", "votados", "vueltos", "vulcanizados", "vulgarizados", "vulnerados", "yuxtapuestos", "zafados", "zambullidos", "zampados", "zanjados", "zarandeados", "zarpados", "zozobrados", "zumbados", "zurcidos", "zurrados", "abajadas", "abalanzadas", "abaleadas", "abandonadas", "abaratadas", "abarcadas", "abarrotadas", "abastecidas", "abatidas", "abdicadas", "abiertas", "abismadas", "abjuradas", "ablandadas", "abocadas", "abochornadas", "abofeteadas", "abolidas", "abolladas", "abombadas", "abominadas", "abonadas", "abordadas", "aborrecidas", "aborregadas", "abortadas", "abotonadas", "abrasadas", "abrazadas", "abrevadas", "abreviadas", "abrigadas", "abrochadas", "abrogadas", "abroqueladas", "abrumadas", "absorbidas", "abstenidas", "abstraídas", "absueltas", "abucheadas", "abultadas", "abundadas", "aburguesadas", "aburridas", "abusadas", "acabadas", "acalladas", "acaloradas", "acaparadas", "acariciadas", "acarreadas", "acatadas", "acaudilladas", "accedidas", "accionadas", "acechadas", "aceitadas", "aceleradas", "acentuadas", "aceptadas", "aceradas", "acercadas", "acertadas", "achacadas", "achantadas", "achatadas", "achicadas", "acicaladas", "acidificadas", "aclaradas", "aclimatadas", "acobardadas", "acodadas", "acogidas", "acojonadas", "acometidas", "acomodadas", "acompañadas", "acompasadas", "acongojadas", "aconsejadas", "acontecidas", "acopiadas", "acopladas", "acordadas", "acordonadas", "acorraladas", "acortadas", "acosadas", "acostadas", "acostumbradas", "acotadas", "acrecentadas", "acreditadas", "acrisoladas", "activadas", "actuadas", "acuchilladas", "acuciadas", "acudidas", "acuerpadas", "acumuladas", "acunadas", "acuñadas", "acurrucadas", "acusadas", "adaptadas", "adecentadas", "adelantadas", "adelgazadas", "adentradas", "adeudadas", "adheridas", "adicionadas", "adiestradas", "adivinadas", "adjetivadas", "adjudicadas", "adjuntadas", "administradas", "admiradas", "admitidas", "adoctrinadas", "adolecidas", "adoptadas", "adoradas", "adormecidas", "adornadas", "adquiridas", "aducidas", "adueñadas", "aduladas", "adulteradas", "advertidas", "afanadas", "afeadas", "afectadas", "afeitadas", "aferradas", "afianzadas", "afinadas", "afirmadas", "afligidas", "afloradas", "afrentadas", "afrontadas", "agachadas", "agarradas", "agarrotadas", "agasajadas", "agenciadas", "agigantadas", "agilizadas", "agitadas", "aglutinadas", "agobiadas", "agolpadas", "agonizadas", "agostadas", "agotadas", "agradadas", "agradecidas", "agrandadas", "agravadas", "agraviadas", "agredidas", "agregadas", "agriadas", "agrietadas", "agrupadas", "aguadas", "aguantadas", "aguardadas", "agudizadas", "aguijoneadas", "agujereadas", "aguzadas", "ahogadas", "ahondadas", "ahorcadas", "ahorradas", "ahuecadas", "ahuyentadas", "aireadas", "aisladas", "ajustadas", "ajusticiadas", "alabadas", "alagadas", "alambradas", "alardeadas", "alargadas", "alarmadas", "albergadas", "alborotadas", "alcanzadas", "aleccionadas", "alegadas", "alegradas", "alejadas", "alentadas", "alertadas", "alfabetizadas", "alfombradas", "aliadas", "alienadas", "aligeradas", "alimentadas", "aliñadas", "alineadas", "alisadas", "alistadas", "aliviadas", "alivianadas", "allanadas", "almacenadas", "almorzadas", "alojadas", "alquiladas", "alteradas", "alternadas", "alucinadas", "aludidas", "alumbradas", "alzadas", "amadas", "amaestradas", "amagadas", "amainadas", "amalgamadas", "amamantadas", "amansadas", "amargadas", "amarradas", "amasadas", "ambicionadas", "amedrentadas", "amenazadas", "amenizadas", "ameritadas", "ametralladas", "amilanadas", "aminoradas", "amnistiadas", "amoldadas", "amonestadas", "amontonadas", "amordazadas", "amortajadas", "amortiguadas", "amortizadas", "amotinadas", "amparadas", "ampayadas", "ampliadas", "amplificadas", "amputadas", "amuebladas", "añadidas", "analizadas", "anatematizadas", "andadas", "anegadas", "anestesiadas", "anexadas", "anexionadas", "anheladas", "anidadas", "anilladas", "animadas", "aniquiladas", "anisadas", "añoradas", "anotadas", "anoticiadas", "ansiadas", "antecedidas", "antepuestas", "anticipadas", "antojadas", "anudadas", "anuladas", "anunciadas", "apabulladas", "apachurradas", "apaciguadas", "apadrinadas", "apagadas", "apalancadas", "apaleadas", "apañadas", "apantalladas", "aparcadas", "apareadas", "aparecidas", "aparentadas", "apartadas", "apeadas", "apedreadas", "apeladas", "apellidadas", "apelmazadas", "apercibidas", "apersonadas", "apestadas", "apetecidas", "apiadadas", "apiladas", "apiñadas", "apisonadas", "aplacadas", "aplanadas", "aplastadas", "aplaudidas", "aplazadas", "aplicadas", "apoderadas", "apoltronadas", "aporreadas", "aportadas", "aposentadas", "apostadas", "apostatadas", "apostilladas", "apoyadas", "apreciadas", "aprehendidas", "apremiadas", "aprendidas", "apresadas", "apresuradas", "apretadas", "apretujadas", "aprisionadas", "aprobadas", "aprovechadas", "aprovisionadas", "aproximadas", "apuñaladas", "apuñaleadas", "apuntadas", "apuntaladas", "apuntilladas", "apuradas", "aquejadas", "aquietadas", "aquilatadas", "arañadas", "arbitradas", "archivadas", "arengadas", "argüidas", "argumentadas", "armadas", "armonizadas", "aromatizadas", "arqueadas", "arrancadas", "arrasadas", "arrastradas", "arreadas", "arrebatadas", "arreciadas", "arregladas", "arrellanadas", "arremangadas", "arremetidas", "arrendadas", "arrepentidas", "arrestadas", "arriadas", "arribadas", "arriesgadas", "arrimadas", "arrinconadas", "arrodilladas", "arrogadas", "arrojadas", "arrolladas", "arropadas", "arruinadas", "arrulladas", "articuladas", "asadas", "asaltadas", "ascendidas", "aseadas", "asechadas", "asediadas", "aseguradas", "asemejadas", "asentadas", "asentidas", "aserradas", "asesinadas", "asesoradas", "asestadas", "aseveradas", "asfixiadas", "asidas", "asignadas", "asiladas", "asimiladas", "asistidas", "asoladas", "asoleadas", "asomadas", "asombradas", "aspiradas", "astilladas", "asumidas", "asustadas", "atacadas", "atadas", "atajadas", "atarantadas", "atascadas", "atemorizadas", "atemperadas", "atenazadas", "atendidas", "atenidas", "atentadas", "atenuadas", "aterradas", "aterrorizadas", "atesoradas", "atestiguadas", "atiborradas", "atisbadas", "atizadas", "atomizadas", "atontadas", "atoradas", "atormentadas", "atornilladas", "atosigadas", "atracadas", "atragantadas", "atraídas", "atrancadas", "atrapadas", "atrasadas", "atravesadas", "atrevidas", "atribuidas", "atrincheradas", "atrofiadas", "atropelladas", "aturdidas", "auditadas", "auguradas", "aumentadas", "aunadas", "aupadas", "auscultadas", "ausentadas", "autenticadas", "autentificadas", "autodefinidas", "autoeditadas", "automatizadas", "autorizadas", "autorreguladas", "auxiliadas", "avaladas", "avanzadas", "avasalladas", "avenidas", "aventadas", "aventajadas", "aventuradas", "averiadas", "averiguadas", "avezadas", "avisadas", "avispadas", "avistadas", "avivadas", "avizoradas", "avocadas", "ayudadas", "azotadas", "azuzadas", "babeadas", "bailadas", "bajadas", "balaceadas", "balanceadas", "bañadas", "banalizadas", "bancadas", "bandeadas", "barajadas", "barridas", "basadas", "bastardeadas", "basureadas", "batalladas", "bateadas", "batidas", "bautizadas", "beatificadas", "bebidas", "beneficiadas", "besadas", "bifurcadas", "birladas", "blandidas", "blanqueadas", "blasfemadas", "blindadas", "bloqueadas", "boicoteadas", "bombardeadas", "bombeadas", "bonificadas", "bordeadas", "borradas", "borroneadas", "bosquejadas", "bostezadas", "botadas", "boxeadas", "bregadas", "brilladas", "brincadas", "brindadas", "bromeadas", "brotadas", "bruñidas", "buceadas", "burladas", "buscadas", "cabeceadas", "cabidas", "cabildeadas", "cabreadas", "cacareadas", "cachadas", "cacheadas", "cacheteadas", "caducadas", "cagadas", "caladas", "calculadas", "caldeadas", "calefaccionadas", "calendarizadas", "calentadas", "calibradas", "calificadas", "caligrafiadas", "calladas", "calmadas", "calumniadas", "calzadas", "cambiadas", "caminadas", "camufladas", "canalizadas", "canceladas", "canjeadas", "cansadas", "cantadas", "capadas", "capeadas", "capitalizadas", "capituladas", "captadas", "capturadas", "caracterizadas", "carburadas", "carcomidas", "cardadas", "careadas", "carecidas", "cargadas", "caricaturizadas", "cartografiadas", "cascadas", "castigadas", "castradas", "catadas", "catalizadas", "catalogadas", "catapultadas", "cateadas", "categorizadas", "causadas", "cauterizadas", "cautivadas", "cavadas", "caviladas", "cazadas", "cebadas", "cedidas", "cegadas", "cejadas", "celebradas", "cenadas", "ceñidas", "censuradas", "centrifugadas", "centuplicadas", "cepilladas", "cercadas", "cercenadas", "cercioradas", "cernidas", "cerradas", "cesadas", "chafadas", "chamuscadas", "chantajeadas", "chapadas", "charladas", "chateadas", "chequeadas", "chifladas", "chilladas", "chingadas", "chirriadas", "chivadas", "chocadas", "chorreadas", "choteadas", "chupadas", "chutadas", "cicatrizadas", "cifradas", "cimentadas", "cinceladas", "circuladas", "circuncidadas", "circundadas", "citadas", "clamadas", "clarificadas", "clasificadas", "claudicadas", "clausuradas", "clavadas", "clicadas", "clonadas", "coaccionadas", "coadyuvadas", "coaguladas", "coaligadas", "coartadas", "cobijadas", "cobradas", "cocidas", "cocinadas", "codeadas", "codiciadas", "codificadas", "codirigidas", "coexistidas", "cofinanciadas", "cogidas", "cohabitadas", "cohibidas", "coincididas", "colaboradas", "colacionadas", "coladas", "colapsadas", "coleccionadas", "colectadas", "colectivizadas", "colgadas", "colisionadas", "colmadas", "colocadas", "colonizadas", "coloreadas", "columpiadas", "combatidas", "combinadas", "comentadas", "comenzadas", "comerciadas", "comercializadas", "cometidas", "comidas", "comisionadas", "compactadas", "compadecidas", "compaginadas", "comparadas", "comparecidas", "compartidas", "compatibilizadas", "compelidas", "compendiadas", "compenetradas", "compensadas", "compiladas", "complacidas", "complementadas", "completadas", "complotadas", "comportadas", "compradas", "comprendidas", "comprimidas", "comprobadas", "comprometidas", "compuestas", "compulsadas", "computadas", "comulgadas", "comunicadas", "concatenadas", "concebidas", "concedidas", "concelebradas", "concentradas", "conceptuadas", "conceptualizadas", "concertadas", "concienciadas", "concientizadas", "conciliadas", "concitadas", "concluidas", "concordadas", "concretadas", "concretizadas", "conculcadas", "concursadas", "condenadas", "condensadas", "condicionadas", "condimentadas", "condolidas", "condonadas", "conducidas", "conectadas", "conexionadas", "confabuladas", "confeccionadas", "conferidas", "confesadas", "confiadas", "configuradas", "confirmadas", "confiscadas", "confluidas", "conformadas", "confortadas", "confrontadas", "confundidas", "congeniadas", "congestionadas", "congratuladas", "congregadas", "conjeturadas", "conjugadas", "conjuntadas", "conjuradas", "conllevadas", "conmemoradas", "conminadas", "conmocionadas", "conmovidas", "conmutadas", "connotadas", "conquistadas", "consagradas", "conseguidas", "consensuadas", "consentidas", "conservadas", "consideradas", "consignadas", "consistidas", "consoladas", "consolidadas", "conspiradas", "constadas", "constatadas", "consteladas", "constitucionalizadas", "constituidas", "constreñidas", "construidas", "consultadas", "consumadas", "consumidas", "contabilizadas", "contactadas", "contadas", "contagiadas", "contempladas", "contendidas", "contenidas", "contentadas", "contestadas", "contextualizadas", "continuadas", "contorneadas", "contraatacadas", "contrabandeadas", "contradichas", "contrahechas", "contraídas", "contrapesadas", "contrapuestas", "contrariadas", "contrarrestadas", "contrastadas", "contratadas", "contravenidas", "contribuidas", "contristadas", "controladas", "convalidadas", "convencidas", "convenidas", "convergidas", "conversadas", "convertidas", "convidadas", "convividas", "convocadas", "convulsionadas", "cooperadas", "cooptadas", "coordinadas", "copadas", "copiadas", "coproducidas", "copuladas", "coqueteadas", "corchadas", "coreadas", "coreografiadas", "corneadas", "coronadas", "corporizadas", "corregidas", "correlacionadas", "correspondidas", "correteadas", "corridas", "corroboradas", "corroídas", "corrompidas", "cortadas", "cortejadas", "cosechadas", "cosidas", "cosificadas", "costadas", "costeadas", "cotejadas", "cotizadas", "creadas", "creídas", "criadas", "cribadas", "criminalizadas", "crispadas", "cristalizadas", "cristianizadas", "criticadas", "cronometradas", "crucificadas", "crujidas", "cruzadas", "cuadriplicadas", "cuadruplicadas", "cuajadas", "cuantificadas", "cuarteadas", "cubiertas", "cuestionadas", "cuidadas", "culeadas", "culminadas", "culpabilizadas", "culpadas", "cultivadas", "culturizadas", "cumplidas", "cumplimentadas", "cundidas", "curadas", "curioseadas", "curradas", "cursadas", "curvadas", "custodiadas", "dadas", "dañadas", "danzadas", "datadas", "dateadas", "debatidas", "debidas", "debilitadas", "debitadas", "debutadas", "decaídas", "decantadas", "decapitadas", "decepcionadas", "decididas", "declamadas", "declaradas", "declinadas", "decodificadas", "decoloradas", "decomisadas", "decrecidas", "decretadas", "dedicadas", "deducidas", "defecadas", "defendidas", "defenestradas", "deferidas", "definidas", "deformadas", "defraudadas", "degeneradas", "deglutidas", "degolladas", "degradadas", "degustadas", "deificadas", "dejadas", "delatadas", "delegadas", "deleitadas", "deletreadas", "deliberadas", "delimitadas", "delineadas", "delinquidas", "demandadas", "demarcadas", "demediadas", "demeritadas", "democratizadas", "demolidas", "demonizadas", "demoradas", "demostradas", "demudadas", "denegadas", "denigradas", "denominadas", "denostadas", "denotadas", "denunciadas", "deparadas", "departidas", "dependidas", "depiladas", "deploradas", "deportadas", "depositadas", "depreciadas", "depredadas", "deprimidas", "depuestas", "depuradas", "derechizadas", "derivadas", "derogadas", "derramadas", "derretidas", "derribadas", "derrocadas", "derrochadas", "derrotadas", "derruidas", "derrumbadas", "desabrochadas", "desacatadas", "desaceleradas", "desacomodadas", "desaconsejadas", "desacopladas", "desacralizadas", "desacreditadas", "desactivadas", "desafiadas", "desafinadas", "desaguadas", "desahogadas", "desairadas", "desajustadas", "desalentadas", "desalineadas", "desalojadas", "desandadas", "desangradas", "desanimadas", "desaparecidas", "desapegadas", "desaprendidas", "desaprobadas", "desaprovechadas", "desarmadas", "desarraigadas", "desarregladas", "desarrolladas", "desarticuladas", "desaseadas", "desasidas", "desasosegadas", "desatadas", "desatendidas", "desautorizadas", "desayunadas", "desbancadas", "desbandadas", "desbaratadas", "desbarrancadas", "desbastadas", "desbloqueadas", "desbocadas", "desbordadas", "desbrozadas", "descabalgadas", "descabezadas", "descaderadas", "descalabradas", "descalificadas", "descansadas", "descargadas", "descarriadas", "descarriladas", "descartadas", "descascaradas", "descascarilladas", "descendidas", "descentradas", "descifradas", "descocidas", "descodificadas", "descojonadas", "descolgadas", "descolocadas", "descolonizadas", "descompensadas", "descomprimidas", "descompuestas", "desconectadas", "desconfiadas", "descongeladas", "desconocidas", "descontadas", "descontaminadas", "descontextualizadas", "descontinuadas", "desconvocadas", "descorazonadas", "descorchadas", "descorridas", "descosidas", "descoyuntadas", "descreídas", "descristianizadas", "descuadradas", "descuartizadas", "descubiertas", "descuidadas", "desdeñadas", "desdibujadas", "desdichas", "desdobladas", "deseadas", "desecadas", "desechadas", "desembarazadas", "desembarcadas", "desembocadas", "desembolsadas", "desempacadas", "desempañadas", "desempaquetadas", "desempeñadas", "desempolvadas", "desenamoradas", "desencadenadas", "desencajadas", "desencarnadas", "desenchufadas", "desenfocadas", "desenfundadas", "desenganchadas", "desengrasadas", "desenmascaradas", "desenredadas", "desenrolladas", "desentendidas", "desenterradas", "desentonadas", "desentrañadas", "desenvainadas", "desenvueltas", "desequilibradas", "desertadas", "desestabilizadas", "desestimadas", "desfalcadas", "desfallecidas", "desfiguradas", "desfondadas", "desgajadas", "desgañitadas", "desgarradas", "desgastadas", "desglosadas", "desgobernadas", "desgranadas", "desguazadas", "deshechas", "desheredadas", "deshidratadas", "deshilachadas", "deshojadas", "deshonradas", "deshuesadas", "deshumanizadas", "designadas", "desilusionadas", "desincentivadas", "desinfectadas", "desinfladas", "desinflamadas", "desinformadas", "desinhibidas", "desinstaladas", "desintegradas", "desintoxicadas", "desistidas", "desjarretadas", "deslegitimadas", "desleídas", "desligadas", "deslindadas", "deslizadas", "deslucidas", "deslumbradas", "desmadradas", "desmalezadas", "desmanteladas", "desmaquilladas", "desmarcadas", "desmayadas", "desmejoradas", "desmembradas", "desmentidas", "desmenuzadas", "desmerecidas", "desmigadas", "desmitificadas", "desmoldadas", "desmontadas", "desmoralizadas", "desmoronadas", "desmotivadas", "desmovilizadas", "desnaturalizadas", "desniveladas", "desnucadas", "desnudadas", "desobedecidas", "desobligadas", "desoídas", "desolladas", "desorganizadas", "desorientadas", "despachadas", "desparasitadas", "desparecidas", "desparramadas", "despedazadas", "despedidas", "despegadas", "despeinadas", "despejadas", "despellejadas", "despeñadas", "despenalizadas", "desperdiciadas", "despersonalizadas", "despertadas", "despilfarradas", "despintadas", "despiojadas", "despistadas", "desplazadas", "desplegadas", "desplomadas", "desplumadas", "despojadas", "despolitizadas", "desposadas", "desposeídas", "despotricadas", "despreciadas", "desprendidas", "despreocupadas", "desprestigiadas", "desprogramadas", "despulpadas", "despuntadas", "desquiciadas", "desquitadas", "destacadas", "destapadas", "desteñidas", "desterradas", "destetadas", "destiladas", "destituidas", "destrabadas", "destripadas", "destronadas", "destrozadas", "destruidas", "desunidas", "desvalijadas", "desvalorizadas", "desvanecidas", "desveladas", "desvestidas", "desviadas", "desvinculadas", "desvirtuadas", "desvividas", "detectadas", "detenidas", "detentadas", "deterioradas", "determinadas", "detestadas", "detonadas", "devaluadas", "devanadas", "devastadas", "develadas", "devengadas", "devenidas", "devoradas", "devueltas", "diagnosticadas", "diagramadas", "dializadas", "dialogadas", "dibujadas", "dichas", "dictadas", "dictaminadas", "diezmadas", "difamadas", "diferenciadas", "diferidas", "dificultadas", "difuminadas", "difundidas", "digeridas", "digitadas", "dignadas", "dignificadas", "dilapidadas", "dilatadas", "diligenciadas", "dilucidadas", "diluidas", "dimensionadas", "dimitidas", "dinamitadas", "dinamizadas", "dirimidas", "discernidas", "disciplinadas", "discontinuadas", "discrepadas", "discriminadas", "disculpadas", "discurridas", "discutidas", "diseccionadas", "diseminadas", "diseñadas", "disentidas", "disertadas", "disfrazadas", "disfrutadas", "disgregadas", "disgustadas", "disimuladas", "disipadas", "dislocadas", "disminuidas", "disociadas", "dispensadas", "dispersadas", "dispuestas", "disputadas", "distadas", "distanciadas", "distendidas", "distinguidas", "distorsionadas", "distraídas", "distribuidas", "disuadidas", "disueltas", "divagadas", "diversificadas", "divertidas", "divididas", "divinizadas", "divisadas", "divorciadas", "divulgadas", "dobladas", "doblegadas", "doctoradas", "documentadas", "dogmatizadas", "dolidas", "domadas", "domesticadas", "dominadas", "donadas", "dopadas", "dormidas", "dosificadas", "dotadas", "dragadas", "dramatizadas", "drenadas", "drogadas", "duchadas", "dudadas", "dulcificadas", "duplicadas", "duradas", "echadas", "eclipsadas", "eclosionadas", "economizadas", "ecualizadas", "edificadas", "editadas", "educadas", "efectuadas", "ejecutadas", "ejemplificadas", "ejercidas", "ejercitadas", "elaboradas", "electrizadas", "electrocutadas", "elevadas", "elididas", "eliminadas", "elogiadas", "elucubradas", "eludidas", "emanadas", "emancipadas", "embadurnadas", "embaladas", "embalsamadas", "embanderadas", "embarcadas", "embargadas", "embarradas", "embarrancadas", "embaucadas", "embebidas", "embelesadas", "embellecidas", "embestidas", "emboladas", "embolsadas", "emborrachadas", "emborronadas", "emboscadas", "embotadas", "embriagadas", "embrolladas", "embrutecidas", "embuchadas", "emergidas", "emigradas", "emitidas", "emocionadas", "empacadas", "empachadas", "empadronadas", "empaladas", "empalmadas", "empanadas", "empañadas", "empantanadas", "empapeladas", "empaquetadas", "emparejadas", "empastadas", "empatadas", "empecinadas", "empeñadas", "empeoradas", "empequeñecidas", "emperradas", "empezadas", "empinadas", "emplazadas", "empleadas", "empobrecidas", "empoderadas", "empolladas", "empolvadas", "emponzoñadas", "emprendidas", "empujadas", "empuñadas", "emputadas", "emuladas", "emulsionadas", "enajenadas", "enaltecidas", "enamoradas", "enarboladas", "enardecidas", "encabezadas", "encabritadas", "encabronadas", "encadenadas", "encajadas", "encajonadas", "encalladas", "encamadas", "encaminadas", "encandiladas", "encanecidas", "encañonadas", "encantadas", "encaprichadas", "encapsuladas", "encaradas", "encaramadas", "encarecidas", "encargadas", "encariñadas", "encarnadas", "encarriladas", "encartadas", "encasilladas", "encasquetadas", "encasquilladas", "encastradas", "encausadas", "encauzadas", "enceguecidas", "encendidas", "enceradas", "encerradas", "encharcadas", "enchufadas", "encimadas", "encogidas", "encoladas", "encolerizadas", "encolumnadas", "encomendadas", "enconadas", "encontradas", "encordadas", "encrespadas", "encuadradas", "encubiertas", "encueradas", "encumbradas", "enderezadas", "endeudadas", "endilgadas", "endiosadas", "endosadas", "endulzadas", "endurecidas", "enemistadas", "energizadas", "enervadas", "enfadadas", "enfangadas", "enfatizadas", "enfermadas", "enfiestadas", "enfiladas", "enflaquecidas", "enfocadas", "enfrascadas", "enfrentadas", "enfriadas", "enfurecidas", "engalanadas", "engañadas", "enganchadas", "engarzadas", "engatusadas", "engendradas", "englobadas", "engolosinadas", "engordadas", "engranadas", "engrandecidas", "engrasadas", "engreídas", "engrosadas", "engullidas", "enharinadas", "enhebradas", "enjuagadas", "enjugadas", "enjuiciadas", "enlazadas", "enlistadas", "enlodadas", "enloquecidas", "enlozadas", "enlutadas", "enmarañadas", "enmascaradas", "enmendadas", "enmohecidas", "enmudecidas", "ennegrecidas", "ennoblecidas", "enorgullecidas", "enrarecidas", "enredadas", "enripiadas", "enriquecidas", "enrocadas", "enrojecidas", "enroladas", "enrolladas", "enroscadas", "enrumbadas", "ensalzadas", "ensambladas", "ensañadas", "ensanchadas", "ensartadas", "ensayadas", "ensebadas", "enseñadas", "enseñoreadas", "ensilladas", "ensoberbecidas", "ensogadas", "ensombrecidas", "ensoñadas", "ensordecidas", "ensuciadas", "entabladas", "entalladas", "entendidas", "enteradas", "enternecidas", "enterradas", "entibiadas", "entintadas", "entonadas", "entorpecidas", "entradas", "entrampadas", "entrañadas", "entreabiertas", "entrecomilladas", "entrecruzadas", "entregadas", "entrelazadas", "entremetidas", "entremezcladas", "entrenadas", "entresacadas", "entretejidas", "entretenidas", "entreveradas", "entrevistadas", "entristecidas", "entrometidas", "entronadas", "entroncadas", "entronizadas", "entumecidas", "enturbiadas", "entusiasmadas", "enumeradas", "enunciadas", "envainadas", "envalentonadas", "envanecidas", "envasadas", "envejecidas", "envenenadas", "envestidas", "enviadas", "enviciadas", "envidiadas", "envilecidas", "enviudadas", "envueltas", "enzarzadas", "equilibradas", "equiparadas", "equivocadas", "erigidas", "erizadas", "erogadas", "erosionadas", "erotizadas", "erradicadas", "erradas", "esbozadas", "escabullidas", "escaladas", "escaldadas", "escalfadas", "escamadas", "escamoteadas", "escampadas", "escandalizadas", "escaneadas", "escapadas", "escaqueadas", "escarbadas", "escarchadas", "escarmentadas", "escarnecidas", "escaseadas", "escatimadas", "escenificadas", "escindidas", "esclarecidas", "esclavizadas", "escocidas", "escogidas", "escolarizadas", "escoltadas", "escondidas", "escoradas", "escrachadas", "escritas", "escrutadas", "escuchadas", "escudadas", "escudriñadas", "esculpidas", "escupidas", "escurridas", "esforzadas", "esfumadas", "esgrimidas", "esmeradas", "esmeriladas", "espabiladas", "espaciadas", "españolizadas", "espantadas", "esparcidas", "especificadas", "especuladas", "esperadas", "espesadas", "espetadas", "espiadas", "espigadas", "espinadas", "espiradas", "espiritualizadas", "espoleadas", "espolvoreadas", "esponjadas", "esponsorizadas", "esposadas", "esquematizadas", "esquiadas", "esquiladas", "esquilmadas", "esquivadas", "estabilizadas", "establecidas", "estacionadas", "estafadas", "estalladas", "estampadas", "estancadas", "estaqueadas", "estatizadas", "estatuidas", "esterificadas", "esterilizadas", "estigmatizadas", "estilizadas", "estimadas", "estimuladas", "estipuladas", "estiradas", "estorbadas", "estornudadas", "estragadas", "estranguladas", "estrechadas", "estrelladas", "estremecidas", "estrenadas", "estresadas", "estriadas", "estropeadas", "estructuradas", "estrujadas", "estudiadas", "eternizadas", "etiquetadas", "evacuadas", "evadidas", "evaluadas", "evangelizadas", "evaporadas", "evidenciadas", "evisceradas", "evitadas", "evocadas", "evolucionadas", "exacerbadas", "exageradas", "exaltadas", "examinadas", "exasperadas", "excarceladas", "excavadas", "excedidas", "exceptuadas", "excitadas", "exclamadas", "excluidas", "excretadas", "exculpadas", "excusadas", "execradas", "exhaladas", "exhibidas", "exhortadas", "exhumadas", "exigidas", "exiladas", "eximidas", "existidas", "exoneradas", "exorcizadas", "expandidas", "expedidas", "expedientadas", "expelidas", "expendidas", "experimentadas", "expiadas", "expiradas", "explayadas", "explicadas", "explicitadas", "exploradas", "explosionadas", "explotadas", "expoliadas", "exportadas", "expresadas", "exprimidas", "expropiadas", "expuestas", "expulsadas", "expurgadas", "extendidas", "exteriorizadas", "exterminadas", "externadas", "externalizadas", "extinguidas", "extirpadas", "extorsionadas", "extractadas", "extraditadas", "extraídas", "extralimitadas", "extrañadas", "extrapoladas", "extraviadas", "extremadas", "extruidas", "exudadas", "eyaculadas", "eyectadas", "fabricadas", "fabuladas", "facilitadas", "facturadas", "facultadas", "fagocitadas", "fajadas", "falladas", "fallecidas", "falsadas", "falseadas", "falsificadas", "familiarizadas", "fantaseadas", "fascinadas", "fastidiadas", "fatigadas", "favorecidas", "fecundadas", "felicitadas", "feminizadas", "fenecidas", "fermentadas", "fertilizadas", "festejadas", "fiadas", "fichadas", "fidelizadas", "figuradas", "fijadas", "filmadas", "filosofadas", "filtradas", "finalizadas", "financiadas", "fincadas", "fingidas", "finiquitadas", "firmadas", "fiscalizadas", "fisuradas", "flageladas", "flameadas", "flanqueadas", "flaqueadas", "fletadas", "flexibilizadas", "flexionadas", "flipadas", "floreadas", "florecidas", "flotadas", "fluctuadas", "focalizadas", "fogueadas", "foliadas", "folladas", "fomentadas", "fondeadas", "forcejeadas", "forestadas", "forjadas", "formadas", "formalizadas", "formateadas", "formuladas", "fornicadas", "forradas", "fortalecidas", "forzadas", "fotocopiadas", "fotografiadas", "fracasadas", "fraccionadas", "fracturadas", "fragmentadas", "fraguadas", "franqueadas", "frecuentadas", "fregadas", "frenadas", "fresadas", "friccionadas", "frotadas", "fructificadas", "fruncidas", "fugadas", "fulminadas", "fumadas", "fumigadas", "funcionadas", "fundadas", "fundamentadas", "fundidas", "fungidas", "fusiladas", "fusionadas", "fustigadas", "gafadas", "ganadas", "gangrenadas", "garabateadas", "garantidas", "garantizadas", "garridas", "gaseadas", "gastadas", "gemidas", "generadas", "generalizadas", "gerenciadas", "germinadas", "gestadas", "gestionadas", "giradas", "glorificadas", "glosadas", "gobernadas", "goleadas", "golpeadas", "gozadas", "grabadas", "graduadas", "graficadas", "granjeadas", "grapadas", "gratificadas", "gravadas", "gravitadas", "gritadas", "gruñidas", "guardadas", "guarecidas", "guarnecidas", "guerreadas", "guiadas", "guillotinadas", "guiñadas", "guindadas", "guisadas", "gustadas", "habilitadas", "habitadas", "habituadas", "habladas", "haladas", "halagadas", "halladas", "hartadas", "hechizadas", "hechas", "helenizadas", "henchidas", "hendidas", "heredadas", "heridas", "hermanadas", "herradas", "hervidas", "hibernadas", "hibridadas", "hidratadas", "higienizadas", "hiladas", "hilvanadas", "hincadas", "hinchadas", "hipnotizadas", "hipotecadas", "historiadas", "hojeadas", "holgadas", "holladas", "homenajeadas", "homogeneizadas", "homologadas", "honradas", "horadadas", "horneadas", "horrorizadas", "hospedadas", "hostigadas", "hostilizadas", "huidas", "humanadas", "humanizadas", "humectadas", "humedecidas", "humilladas", "hundidas", "hurgadas", "hurtadas", "ideadas", "idealizadas", "identificadas", "ideologizadas", "idiotizadas", "idolatradas", "ignoradas", "igualadas", "ilegalizadas", "iluminadas", "ilusionadas", "ilustradas", "imaginadas", "imbricadas", "imitadas", "impactadas", "impartidas", "impedidas", "impelidas", "imperadas", "impermeabilizadas", "implantadas", "implementadas", "implicadas", "imploradas", "importadas", "importunadas", "imposibilitadas", "impresionadas", "improvisadas", "impuestas", "impugnadas", "impulsadas", "imputadas", "inauguradas", "incautadas", "incendiadas", "incentivadas", "incineradas", "incitadas", "inclinadas", "incluidas", "incoadas", "incomodadas", "incorporadas", "incrementadas", "increpadas", "incriminadas", "incubadas", "inculcadas", "inculpadas", "incumplidas", "incurridas", "incursionadas", "indagadas", "indemnizadas", "independizadas", "indexadas", "indicadas", "indigestadas", "indignadas", "indispuestas", "individuadas", "inducidas", "indultadas", "inervadas", "infamadas", "infartadas", "infectadas", "inferidas", "inficionadas", "infiltradas", "infladas", "inflamadas", "infligidas", "influenciadas", "influidas", "informadas", "infravaloradas", "infringidas", "infundidas", "ingeniadas", "ingeridas", "ingresadas", "inhabilitadas", "inhaladas", "inhibidas", "inhumadas", "iniciadas", "inicializadas", "injertadas", "injuriadas", "inmigradas", "inmiscuidas", "inmoladas", "inmortalizadas", "inmovilizadas", "inmunizadas", "innovadas", "inoculadas", "inquietadas", "inquiridas", "insensibilizadas", "insertadas", "insinuadas", "insistidas", "inspeccionadas", "inspiradas", "instadas", "instaladas", "instauradas", "instigadas", "instituidas", "instruidas", "instrumentadas", "instrumentalizadas", "insufladas", "insultadas", "insumidas", "integradas", "intelectualizadas", "intensificadas", "intentadas", "interactuadas", "intercaladas", "intercambiadas", "intercedidas", "interceptadas", "interesadas", "interferidas", "interiorizadas", "intermediadas", "internacionalizadas", "internalizadas", "interpeladas", "interpoladas", "interpretadas", "interpuestas", "interrogadas", "interrumpidas", "intervenidas", "intimadas", "intimidadas", "intituladas", "intoxicadas", "intrigadas", "introducidas", "intuidas", "inundadas", "inutilizadas", "invadidas", "invalidadas", "inventadas", "inventariadas", "invertidas", "investidas", "investigadas", "invitadas", "invocadas", "involucionadas", "inyectadas", "ionizadas", "ironizadas", "irradiadas", "irrespetadas", "irrigadas", "irritadas", "irrogadas", "irrumpidas", "jactadas", "jaladas", "jaleadas", "jalonadas", "jaqueadas", "jerarquizadas", "jodidas", "jorobadas", "jubiladas", "jugadas", "juntadas", "juradas", "juramentadas", "justificadas", "juzgadas", "laboradas", "labradas", "laburadas", "lacadas", "laceradas", "lactadas", "ladeadas", "ladradas", "lamentadas", "lamidas", "laminadas", "languidecidas", "lanzadas", "lapidadas", "laqueadas", "largadas", "lastimadas", "lastradas", "latidas", "laudadas", "lavadas", "legalizadas", "legisladas", "legitimadas", "leídas", "lesionadas", "leudadas", "levantadas", "liadas", "liberadas", "liberalizadas", "libertadas", "libradas", "licitadas", "licuadas", "liderizadas", "lidiadas", "ligadas", "lijadas", "limadas", "limitadas", "limpiadas", "linchadas", "liquidadas", "litigadas", "llagadas", "llamadas", "llegadas", "llenadas", "llevadas", "lloradas", "localizadas", "logradas", "lubricadas", "luchadas", "lucidas", "lucradas", "lustradas", "maceradas", "machacadas", "macheteadas", "machucadas", "madreadas", "madrugadas", "maduradas", "magnetizadas", "magnificadas", "malacostumbradas", "malbaratadas", "malcriadas", "maleadas", "malentendidas", "malgastadas", "malinterpretadas", "malogradas", "maltratadas", "malversadas", "mamadas", "manchadas", "mancilladas", "mandadas", "manejadas", "mangadas", "mangoneadas", "manifestadas", "maniobradas", "manipuladas", "manoseadas", "manteadas", "mantenidas", "manufacturadas", "maquilladas", "maquinadas", "maravilladas", "marcadas", "marchitadas", "mareadas", "marginadas", "maridadas", "martilladas", "martirizadas", "masacradas", "masajeadas", "mascadas", "masificadas", "masticadas", "masturbadas", "matadas", "materializadas", "matizadas", "matriculadas", "maximizadas", "meadas", "mecanografiadas", "mechadas", "mecidas", "mediadas", "mediatizadas", "medicadas", "medidas", "meditadas", "medradas", "mejoradas", "melladas", "memorizadas", "mencionadas", "meneadas", "menguadas", "menoscabadas", "menospreciadas", "menstruadas", "mensualizadas", "mensuradas", "mentadas", "mentalizadas", "mentidas", "mercadeadas", "mercantilizadas", "merecidas", "merendadas", "mermadas", "merodeadas", "mesuradas", "metamorfoseadas", "metidas", "mezcladas", "migradas", "militadas", "militarizadas", "mimadas", "mimetizadas", "minadas", "minimizadas", "ministradas", "minusvaloradas", "miradas", "mistificadas", "mitificadas", "mitigadas", "modeladas", "modernizadas", "modificadas", "moduladas", "mofadas", "mojadas", "moldeadas", "molestadas", "molidas", "monetizadas", "monitorizadas", "monopolizadas", "montadas", "moradas", "moralizadas", "mordidas", "mordisqueadas", "mortificadas", "mosqueadas", "mostradas", "motejadas", "motivadas", "movidas", "movilizadas", "mudadas", "muestreadas", "multadas", "multiplicadas", "munidas", "murmuradas", "mutadas", "mutiladas", "nacionalizadas", "narcotizadas", "narradas", "naufragadas", "navegadas", "necesitadas", "negadas", "negociadas", "neutralizadas", "ninguneadas", "niveladas", "nombradas", "nominadas", "noqueadas", "normadas", "normalizadas", "notadas", "notificadas", "nutridas", "obcecadas", "obedecidas", "objetadas", "objetivadas", "obligadas", "obliteradas", "obnubiladas", "obradas", "obsequiadas", "observadas", "obsesionadas", "obstaculizadas", "obstruidas", "obtenidas", "obturadas", "obviadas", "ocasionadas", "ocluidas", "ocultadas", "ocupadas", "odiadas", "ofendidas", "ofertadas", "oficiadas", "oficializadas", "ofrecidas", "ofrendadas", "ofuscadas", "oídas", "ojeadas", "olfateadas", "olidas", "olvidadas", "omitidas", "ondeadas", "onduladas", "opacadas", "operadas", "opinadas", "oprimidas", "optadas", "optimizadas", "opuestas", "oradas", "orbitadas", "ordenadas", "ordeñadas", "organizadas", "orientadas", "originadas", "orilladas", "orinadas", "ornadas", "ornamentadas", "orquestadas", "osadas", "osciladas", "oscurecidas", "osificadas", "ostentadas", "otorgadas", "ovacionadas", "ovuladas", "oxidadas", "oxigenadas", "pacificadas", "pactadas", "padecidas", "paganizadas", "paginadas", "paladeadas", "paliadas", "palpadas", "paradas", "parafraseadas", "paralizadas", "parapetadas", "parasitadas", "parceladas", "parchadas", "parcheadas", "pareadas", "paridas", "parodiadas", "parqueadas", "participadas", "particularizadas", "partidas", "pasadas", "paseadas", "pastoreadas", "pataleadas", "pateadas", "patentadas", "patentizadas", "patinadas", "patrulladas", "pecadas", "pedaleadas", "pedidas", "pegadas", "peinadas", "pellizcadas", "penalizadas", "penetradas", "pensadas", "percatadas", "percibidas", "percutidas", "perdidas", "perdonadas", "perduradas", "perecidas", "peregrinadas", "perfeccionadas", "perfiladas", "perforadas", "perfumadas", "pergeñadas", "peritadas", "perjudicadas", "perjuradas", "permeadas", "permitidas", "permutadas", "pernoctadas", "perpetradas", "perpetuadas", "perseguidas", "perseveradas", "persistidas", "personadas", "personalizadas", "personificadas", "persuadidas", "pertenecidas", "pertrechadas", "perturbadas", "pervertidas", "pervividas", "pescadas", "petadas", "peticionadas", "picadas", "picaneadas", "picoteadas", "pifiadas", "pignoradas", "pilladas", "pilotadas", "piloteadas", "pinceladas", "pinchadas", "pintadas", "pintarrajeadas", "pinzadas", "piradas", "pirateadas", "pisadas", "pisoteadas", "pitadas", "placidas", "plagiadas", "planchadas", "planeadas", "plantadas", "planteadas", "plasmadas", "platicadas", "plegadas", "pluralizadas", "podadas", "poetizadas", "polemizadas", "politizadas", "pololeadas", "ponderadas", "pontificadas", "popularizadas", "porfiadas", "portadas", "porteadas", "posadas", "posesionadas", "posibilitadas", "posicionadas", "pospuestas", "posteadas", "postergadas", "postradas", "postuladas", "potenciadas", "practicadas", "precarizadas", "precedidas", "preceptuadas", "precintadas", "precipitadas", "precisadas", "preconizadas", "predicadas", "predichas", "predispuestas", "predominadas", "preferidas", "prefiguradas", "pregonadas", "preguntadas", "prejuzgadas", "premiadas", "prendadas", "prendidas", "preocupadas", "preparadas", "presagiadas", "prescindidas", "presenciadas", "presentadas", "presentidas", "preservadas", "presididas", "presionadas", "prestadas", "prestigiadas", "presumidas", "presurizadas", "pretendidas", "preteridas", "prevalecidas", "prevalidas", "prevaricadas", "prevenidas", "previstas", "primadas", "principiadas", "pringadas", "priorizadas", "privatizadas", "probadas", "problematizadas", "procedidas", "procesadas", "proclamadas", "procreadas", "procuradas", "prodigadas", "producidas", "profanadas", "proferidas", "profesadas", "profesionalizadas", "profetizadas", "profundizadas", "programadas", "progresadas", "prohibidas", "prohijadas", "proletarizadas", "proliferadas", "prologadas", "prolongadas", "promediadas", "prometidas", "promocionadas", "promovidas", "promulgadas", "pronosticadas", "pronunciadas", "propagadas", "propaladas", "propendidas", "propiciadas", "propinadas", "proporcionadas", "propuestas", "propugnadas", "propulsadas", "prorrateadas", "prorrogadas", "proseguidas", "prosperadas", "prostituidas", "protegidas", "protestadas", "protocolizadas", "provenidas", "provocadas", "proyectadas", "psicoanalizadas", "publicadas", "publicitadas", "puestas", "pugnadas", "pujadas", "pulidas", "pulsadas", "pululadas", "pulverizadas", "punadas", "punteadas", "puntuadas", "puntualizadas", "punzadas", "purgadas", "purificadas", "puteadas", "quebradas", "quebrantadas", "quejadas", "quemadas", "querelladas", "queridas", "quintuplicadas", "quitadas", "racionadas", "racionalizadas", "radiadas", "radicadas", "radicalizadas", "raídas", "rajadas", "ralentizadas", "rapadas", "rapeadas", "raptadas", "rascadas", "rasgadas", "rasguñadas", "raspadas", "rastreadas", "rasuradas", "ratificadas", "rayadas", "razonadas", "reabiertas", "reabsorbidas", "reaccionadas", "reactivadas", "readaptadas", "readmitidas", "reafirmadas", "reagrupadas", "reajustadas", "realimentadas", "realizadas", "realzadas", "reanimadas", "reanudadas", "reaparecidas", "rearmadas", "reasumidas", "reavivadas", "rebajadas", "rebalsadas", "rebanadas", "rebasadas", "rebatidas", "rebautizadas", "rebeladas", "reblandecidas", "rebobinadas", "rebosadas", "rebotadas", "rebozadas", "rebuscadas", "recabadas", "recaídas", "recaladas", "recalcadas", "recalentadas", "recalificadas", "recapacitadas", "recapituladas", "recargadas", "recatadas", "recaudadas", "receptadas", "recetadas", "rechazadas", "recibidas", "recicladas", "recitadas", "reclamadas", "reclinadas", "reclutadas", "recobradas", "recocidas", "recogidas", "recolectadas", "recomendadas", "recomenzadas", "recompensadas", "recompuestas", "reconcentradas", "reconciliadas", "reconducidas", "reconfortadas", "reconocidas", "reconquistadas", "reconsideradas", "reconstituidas", "reconstruidas", "reconvenidas", "reconvertidas", "recopiladas", "recordadas", "recorridas", "recortadas", "recreadas", "recriminadas", "recrudecidas", "rectificadas", "recubiertas", "reculadas", "recuperadas", "recurridas", "recusadas", "redactadas", "redefinidas", "redescubiertas", "redimensionadas", "redimidas", "rediseñadas", "redistribuidas", "redituadas", "redobladas", "redondeadas", "reducidas", "redundadas", "reedificadas", "reeditadas", "reeducadas", "reelaboradas", "reembolsadas", "reemplazadas", "reencarnadas", "reencauchadas", "reencontradas", "reenganchadas", "reenviadas", "reescritas", "reestructuradas", "reexaminadas", "refaccionadas", "referidas", "refinadas", "refinanciadas", "reflejadas", "reflexionadas", "reflotadas", "reforestadas", "reformadas", "reforzadas", "refractadas", "refrenadas", "refrendadas", "refrescadas", "refrigeradas", "refundidas", "refutadas", "regadas", "regaladas", "regañadas", "regateadas", "regeneradas", "regentadas", "regenteadas", "regidas", "regionalizadas", "registradas", "regladas", "reglamentadas", "regocijadas", "regodeadas", "regresadas", "reguladas", "regularizadas", "regurgitadas", "rehabilitadas", "rehechas", "rehogadas", "rehuidas", "rehusadas", "reídas", "reinadas", "reincididas", "reincorporadas", "reingresadas", "reiniciadas", "reinsertadas", "reinstaladas", "reinstauradas", "reintegradas", "reinventadas", "reinvertidas", "reiteradas", "reivindicadas", "rejuvenecidas", "relajadas", "relamidas", "relanzadas", "relatadas", "relativizadas", "relegadas", "releídas", "relevadas", "religadas", "rellenadas", "remachadas", "remadas", "remangadas", "remarcadas", "rematadas", "remecidas", "remediadas", "rememoradas", "remendadas", "remitidas", "remodeladas", "remojadas", "remolcadas", "remontadas", "removidas", "remplazadas", "renacidas", "rendidas", "renegadas", "renegociadas", "reñidas", "renombradas", "renovadas", "rentabilizadas", "rentadas", "renunciadas", "reordenadas", "reorganizadas", "reorientadas", "reparadas", "repartidas", "repasadas", "repatriadas", "repelidas", "repensadas", "repercutidas", "repescadas", "repetidas", "repicadas", "repintadas", "replanteadas", "replegadas", "replicadas", "repobladas", "reportadas", "reporteadas", "reposadas", "repreguntadas", "reprendidas", "represadas", "representadas", "reprimidas", "reprobadas", "reprochadas", "reproducidas", "repudiadas", "repuestas", "repugnadas", "repuntadas", "reputadas", "requeridas", "requisadas", "resaltadas", "resarcidas", "resbaladas", "rescatadas", "rescindidas", "resecadas", "reseñadas", "reservadas", "reseteadas", "resguardadas", "resididas", "resignadas", "resistidas", "resonadas", "respaldadas", "respetadas", "respiradas", "resplandecidas", "respondidas", "responsabilizadas", "resquebrajadas", "restablecidas", "restadas", "restauradas", "restituidas", "restregadas", "resucitadas", "resueltas", "resumidas", "resurgidas", "retadas", "retardadas", "retenidas", "retiradas", "retocadas", "retomadas", "retorcidas", "retornadas", "retractadas", "retraídas", "retransmitidas", "retrasadas", "retratadas", "retribuidas", "retrotraídas", "retumbadas", "reunidas", "reunificadas", "reutilizadas", "revalidadas", "revalorizadas", "revaluadas", "reveladas", "revendidas", "reventadas", "reverdecidas", "reverenciadas", "revertidas", "revestidas", "reviradas", "revisadas", "revitalizadas", "revividas", "revocadas", "revolcadas", "revoloteadas", "revolucionadas", "revueltas", "ridiculizadas", "rifadas", "rimadas", "rivalizadas", "rizadas", "robadas", "robustecidas", "rociadas", "rodadas", "rodeadas", "rogadas", "roídas", "rondadas", "rotadas", "rotas", "rotuladas", "roturadas", "rozadas", "ruborizadas", "rubricadas", "rugidas", "rumiadas", "rumoradas", "sabidas", "saboreadas", "saboteadas", "sacadas", "saciadas", "sacralizadas", "sacrificadas", "sacudidas", "saldadas", "salpimentadas", "salpullidas", "saltadas", "salteadas", "saludadas", "salvadas", "salvaguardadas", "sanadas", "saneadas", "sangradas", "santificadas", "saqueadas", "satanizadas", "satirizadas", "satisfechas", "sazonadas", "secadas", "seccionadas", "secretadas", "secuenciadas", "secuestradas", "secundadas", "sedimentadas", "seducidas", "segadas", "segmentadas", "segregadas", "seguidas", "seleccionadas", "sembradas", "señaladas", "sensibilizadas", "sentadas", "sentenciadas", "sentidas", "separadas", "serenadas", "serradas", "servidas", "significadas", "silenciadas", "simbolizadas", "simpatizadas", "simplificadas", "simuladas", "sinceradas", "sincronizadas", "sindicadas", "sindicalizadas", "singularizadas", "sintetizadas", "sintonizadas", "sistematizadas", "situadas", "sobadas", "sobornadas", "sobradas", "sobrecargadas", "sobrecogidas", "sobreentendidas", "sobreestimadas", "sobrellevadas", "sobrentendidas", "sobrepasadas", "sobrepuestas", "sobresalidas", "sobresaltadas", "sobrestimadas", "sobrevenidas", "sobrevividas", "sobrevoladas", "socavadas", "socializadas", "socorridas", "sodomizadas", "sofocadas", "sojuzgadas", "solapadas", "solicitadas", "solidarizadas", "solidificadas", "soliviantadas", "soltadas", "solucionadas", "solventadas", "sombreadas", "sometidas", "sonadas", "soñadas", "sondeadas", "sonreídas", "sonrojadas", "sopesadas", "sopladas", "soportadas", "sorbidas", "sorprendidas", "sorteadas", "sosegadas", "soslayadas", "sospechadas", "sostenidas", "suavizadas", "subastadas", "subcontratadas", "subdivididas", "subestimadas", "subidas", "sublevadas", "sublimadas", "subrayadas", "subrogadas", "subsanadas", "subsidiadas", "subsistidas", "substraídas", "subsumidas", "subvertidas", "subyugadas", "succionadas", "sucedidas", "sucumbidas", "sudadas", "sufragadas", "sufridas", "sugeridas", "sugestionadas", "suicidadas", "sujetadas", "sumadas", "sumergidas", "suministradas", "supeditadas", "superadas", "superpuestas", "supervisadas", "suplantadas", "suplicadas", "suplidas", "suprimidas", "supuestas", "surcadas", "surtidas", "suscitadas", "suspendidas", "suspiradas", "sustanciadas", "sustantivadas", "sustentadas", "sustituidas", "sustraídas", "susurradas", "suturadas", "tabuladas", "tachadas", "taladas", "taladradas", "talladas", "tambaleadas", "tamizadas", "tañidas", "tanteadas", "tapadas", "tapizadas", "taponadas", "tarareadas", "tardadas", "tasadas", "tatuadas", "tecleadas", "tejidas", "telefoneadas", "televisadas", "temidas", "templadas", "tendidas", "tenidas", "tensadas", "tentadas", "teorizadas", "terciadas", "tergiversadas", "terminadas", "territorializadas", "testadas", "testeadas", "testificadas", "testimoniadas", "tildadas", "timadas", "timbradas", "tinturadas", "tipeadas", "tipificadas", "tiradas", "tiranizadas", "tironeadas", "tiroteadas", "titubeadas", "tiznadas", "tocadas", "toleradas", "tomadas", "tonificadas", "topadas", "toqueteadas", "torcidas", "toreadas", "tornadas", "tornasoladas", "torneadas", "torpedeadas", "torturadas", "tosidas", "tostadas", "totalizadas", "trabadas", "trabajadas", "traducidas", "traficadas", "tragadas", "traicionadas", "traídas", "trajinadas", "tramadas", "tramitadas", "trancadas", "tranquilizadas", "transcendidas", "transcurridas", "transferidas", "transfiguradas", "transformadas", "transfundidas", "transgredidas", "transigidas", "transitadas", "transliteradas", "translucidas", "transmitidas", "transmutadas", "transparentadas", "transpiradas", "transportadas", "transpuestas", "trasegadas", "trasgredidas", "trasladadas", "traslapadas", "traslucidas", "trasnochadas", "traspapeladas", "traspasadas", "trasplantadas", "traspuestas", "trasquiladas", "trasteadas", "trastocadas", "trastornadas", "trasvasadas", "tratadas", "trazadas", "trenzadas", "trepadas", "tributadas", "trincadas", "triplicadas", "trituradas", "triunfadas", "trivializadas", "trocadas", "troceadas", "tronadas", "tronchadas", "truncadas", "tumbadas", "tuneadas", "turbadas", "turnadas", "tuteladas", "ufanadas", "ultimadas", "uncidas", "ungidas", "unidas", "universalizadas", "untadas", "urbanizadas", "urdidas", "usadas", "usufructuadas", "usurpadas", "utilizadas", "vacadas", "vaciadas", "vaciladas", "vacunadas", "vagadas", "validadas", "validas", "valoradas", "valorizadas", "valuadas", "vanagloriadas", "vandalizadas", "vaporizadas", "variadas", "vaticinadas", "vedadas", "vehiculadas", "vejadas", "veladas", "vencidas", "vendadas", "vendidas", "veneradas", "vengadas", "ventiladas", "veraneadas", "verbalizadas", "verificadas", "versadas", "versionadas", "vertebradas", "vertidas", "vestidas", "vetadas", "viabilizadas", "viajadas", "vibradas", "victimadas", "victimizadas", "vigiladas", "vigorizadas", "vilipendiadas", "vindicadas", "violadas", "violentadas", "viradas", "visadas", "visibilizadas", "visitadas", "vislumbradas", "vistas", "visualizadas", "vitoreadas", "vitrificadas", "vituperadas", "vividas", "vivificadas", "vocalizadas", "voceadas", "vociferadas", "voladas", "volatilizadas", "volcadas", "volteadas", "vomitadas", "votadas", "vueltas", "vulcanizadas", "vulgarizadas", "vulneradas", "yuxtapuestas", "zafadas", "zambullidas", "zampadas", "zanjadas", "zarandeadas", "zarpadas", "zozobradas", "zumbadas", "zurcidas", "zurradas"];
};

var participles$4 = {};

Object.defineProperty(participles$4, "__esModule", {
	value: true
});

participles$4.default = function () {
	return ["encontrado", "levado", "considdo", "condenado", "registrado", "encaminhado", "realizado", "lançado", "aprovado", "acusado", "divulgado", "apresentado", "usado", "dado", "localizado", "identido", "publicado", "votado", "anuncdo", "abordado", "libdo", "baleado", "mcado", "ado", "assassinado", "informado", "prepado", "utilizado", "resultado", "assinado", "revelado", "confirmado", "chamado", "acionado", "notido", "formado", "passado", "contratado", "autuado", "invigado", "nomeado", "retirado", "chegado", "convidado", "quionado", "colocado", "apontado", "acabado", "flagrado", "limitado", "denuncdo", "julgado", "innado", "envdo", "deixado", "constatado", "pticipado", "complicado", "obrigado", "relacionado", "derrotado", "inaugurado", "espdo", "dinado", "afastado", "cuidado", "aplicado", "ligado", "tratado", "eliminado", "baseado", "convocado", "matado", "grdo", "registado", "entrado", "fechado", "dgnosticado", "indicado", "analisado", "preocupado", "addo", "começado", "prorrogado", "agendado", "capturado", "negado", "acompanhado", "indicdo", "aumentado", "executado", "resgatado", "enrado", "casado", "inaproprdo", "recomendado", "citado", "procurado", "alcançado", "declado", "organizado", "roubado", "elaborado", "mado", "instaurado", "trabalhado", "transportado", "errado", "voltado", "inicdo", "achado", "gdo", "logado", "cancelado", "mostrado", "atacado", "minado", "comprado", "solicitado", "emprado", "conquistado", "inessado", "alado", "tentado", "derrubado", "do", "encerrado", "acostumado", "montado", "fundado", "demasdo", "autorizado", "advogado", "disputado", "atropelado", "assocdo", "recupdo", "filmado", "ajudado", "abandonado", "crdo", "causado", "jogado", "rejeitado", "alvejado", "falado", "apaixonado", "multado", "firmado", "inrogado", "premdo", "libertado", "noticdo", "homenageado", "deminado", "pensado", "comemorado", "negocdo", "comunicado", "dedicado", "demonstrado", "criticado", "instalado", "obvado", "esfaqueado", "culpado", "inspirado", "sepultado", "pado", "adotado", "controlado", "acendido", "notado", "opdo", "acessado", "assaltado", "projetado", "mudado", "apanhado", "disponibilizado", "engraçado", "inditado", "calculado", "programado", "consultado", "cobrado", "celebrado", "responsabilizado", "respeitado", "detectado", "cortado", "eleito deputado", "falhado", "implementado", "selecionado", "motivado", "afetado", "verido", "sentado", "forçado", "acordado", "batizado", "reforçado", "exondo", "atuado", "imado", "provocado", "espancado", "fotografado", "tado", "baixado", "aceitado", "licencdo", "deputado", "enfrentado", "quivado", "implantado", "ldo", "dispensado", "supdo", "protocolado", "evitado", "ultrapassado", "repassado", "apagado", "recusado", "desenhado", "anulado", "provado", "avisado", "perguntado", "nformado", "relatado", "explicado", "afirmado", "apurado", "encado", "focado", "comerclizado", "modido", "explorado", "inpretado", "lembrado", "classido", "empenhado", "reado", "incenddo", "escalado", "vicdo", "afogado", "aprecdo", "equipado", "empatado", "inceptado", "praticado", "designado", "aproveitado", "orientado", "sequrado", "direcionado", "velado", "tirado", "buscado", "transformado", "habituado", "violado", "adequado", "prejudicado", "oficlizado", "confrontado", "beneficdo", "dominado", "isolado", "ampldo", "detetado", "apostado", "processado", "comprovado", "compado", "situado", "atualizado", "ganhado", "vedado", "cansado", "coordenado", "idealizado", "conectado", "tornado", "rastado", "ameaçado", "finalizado", "ocupado", "renovado", "reivindicado", "elevado", "desempregado", "planejado", "cercado", "nçado", "vetado", "integrado", "remessado", "melhorado", "efetuado", "hospitalizado", "financdo", "republicado", "mencionado", "bloqueado", "atirado", "apodo", "concentrado", "atrasado", "acertado", "abusado", "poupado", "doado", "editado", "embrgado", "lavrado", "entrevistado", "comandado", "gostado", "ordenado", "em ado", "vinculado", "lotado", "em chegado", "udado", "elogdo", "cruzado", "desvdo", "sentencdo", "fixado", "cacizado", "andado", "em passado", "representado", "administrado", "desctado", "furtado", "puxado", "agudado", "intimado", "adaptado", "funcionado", "visitado", "conplado", "lesionado", "conversado", "fildo", "hospedado", "avistado", "assegurado", "alimentado", "trocado", "empossado", "facultado", "vado", "configurado", "ministrado", "evacuado", "quebrado", "cassado", "cotado", "homologado", "enquadrado", "dacado", "revado", "mandado", "graduado", "penalizado", "monitorado", "rebaixado", "copdo", "ferdo", "justido", "impulsionado", "concretizado", "decretado", "agracdo", "viu obrigado", "m chegado", "torturado", "levantado", "recapturado", "trdo", "extraditado", "m pticipado", "apelidado", "antecipado", "captado", "postado", "noticiado", "prestado", "impressionado", "compartilhado", "contado", "optado", "fabricado", "dasiado", "medicado", "ampliado", "estado", "estimado", "questionado", "confessado", "estuprado", "prevado", "calado", "criado", "queimado", "descartado", "encarado", "á levado", "estudado", "alertado", "tomado", "carregado", "barrado", "patado", "associado", "preparado", "marcado", "sancionado", "esgotado", "influenciado", "irritado", "ovacionado", "iniciado", "contactado", "estreado", "apoiado", "partilhado", "bêbado", "alargado", "arriscado", "participado", "cadastrado", "gravado", "disparado", "ignorado", "faltado", "implentado", "colaborado", "encomendado", "depositado", "danido", "normalizado", "enganado", "donstrado", "diagnosticado", "avançado", "denunciado", "enviado", "valorizado", "beneficiado", "condecorado", "aliado", "negociado", "deslocado", "parcelado", "desativado", "comercializado", "tivesse do", "completado", "incorporado", "pressionado", "comorado", "desligado", "desviado", "especializado", "treinado", "virado", "briagado", "orçado", "reavaliado", "delicado", "despertado", "pesado", "financiado", "despregado", "sorteado", "sequestrado", "possado", "condicionado", "chumbado", "ativado", "tenham do", "armado", "alinhado", "encontrado carbonizado", "acatado", "delegado", "presenciado", "sondado", "viajado", "pecado", "tenham passado", "solucionado", "crado", "dificultado", "apropriado", "tivesse passado", "adiado", "regressado", "assinalado", "inocentado", "compensado", "tocado", "deitado", "amado", "reformado", "amarrado", "goleado", "arratado", "castigado", "animado", "destinado", "m dado", "indagado", "entregado", "rodado", "lutado", "inventado", "combinado", "investigado", "purrado", "efetivado", "liddo", "avaliado", "aconselhado", "ateado", "retratado", "protagonizado", "arranjado", "parado", "á marcado", "iam do", "continuado", "replicado", "arbitrado", "reportado", "equilibrado", "apreciado", "decretar estado", "tombado", "preditado", "manifestado", "m deixado", "imobilizado", "destacado", "contestado", "declarado", "pagado", "dorado", "suscitado", "moddo", "revogado", "guardado", "adicionado", "estipulado", "ajustado", "intensido", "desafiado", "examinado", "comparado", "galardoado", "adiantado", "arrombado", "reajustado", "á fechado", "á deixado", "vê obrigado", "privado", "sagrado", "mercado", "arquivado", "importado", "formalizado", "priado", "vazado", "atravessado", "suportado", "pregado", "testado", "diferenciado", "separado", "comentado", "reprovado", "circulado", "armazenado", "alcoolizado", "clicado", "matriculado", "arrastado", "patrocinado", "atrelado", "chocado", "aposentado", "pintado", "filiado", "os obvado", "despenhado", "tivesse chegado", "sacado", "recepcionado", "recado", "incetado", "m entrado", "anunciado", "cogitado", "agradado", "contabilizado", "paralisado", "cursado", "escapado", "recompensado", "aclamado", "chateado", "á entrado", "acreditado", "recuado", "encantado", "indiciado", "regulamentado", "facilitado", "revisado", "arrancado", "dotado", "anexado", "arrecadado", "recheado", "retornado", "desarmado", "encontrados", "publicados", "registrados", "mediados", "levados", "utilizados", "encaminhados", "denunciados", "bloqueados", "identificados", "divulgados", "votados", "considerados", "usados", "realizados", "apresentados", "condenados", "vetados", "acionados", "tratados", "retirados", "localizados", "alados", "acusados", "obrigados", "liberados", "chamados", "criados", "esperados", "confirmados", "colocados", "abordados", "notificados", "autuados", "aprovados", "informados", "convidados", "enviados", "revelados", "marcados", "preocupados", "selecionados", "recuperados", "resgatados", "registados", "assassinados", "flagrados", "invigados", "lançados", "preparados", "convocados", "contratados", "afetados", "dinados", "cancelados", "relacionados", "baleados", "roubados", "transportados", "o invigados", "prados", "disponibilizados", "anunciados", "instalados", "comprados", "mobilizados", "dados", "ligados", "indiciados", "contabilizados", "julgados", "fechados", "avaliados", "ar preparados", "analisados", "afastados", "consultados", "executados", "capturados", "assinados", "repassados", "apontados", "aplicados", "atacados", "eliminados", "o realizados", "beneficiados", "parados", "inessados", "armados", "disparados", "habituados", "concentrados", "evitados", "doados", "acostumados", "coletados", "armazenados", "citados", "achados", "incendiados", "orientados", "nomeados", "libertados", "associados", "armazenar dados", "descartados", "avisados", "autorizados", "innados", "responsabilizados", "furtados", "focados", "acompanhados", "indicados", "detectados", "deixados", "formados", "contplados", "multados", "queimados", "espalhados", "arrecadados", "priados", "derrotados", "obvados", "somos obrigados", "deslocados", "efetuados", "resultados", "respeitados", "fiscalizados", "acessados", "programados", "iniciados", "detetados", "tomados", "ob resultados", "esgotados", "desviados", "danificados", "dispensados", "limitados", "classificados", "solicitados", "abandonados", "recapturados", "levantados", "casados", "apanhados", "comercializados", "baseados", "alcançados", "instaurados", "o procurados", "iam usados", "procurados", "homenageados", "diagnosticados", "separados", "trocados", "prejudicados", "enrados", "vinculados", "o utilizados", "leiloados", "cobrados", "entrevistados", "declarados", "fomos informados", "disputados", "penhados", "praticados", "fabricados", "mandados", "rejeitados", "incentivados", "cortados", "gerados", "dacados", "aproveitados", "apresentar resultados", "ocupados", "relatados", "agendados", "deletados", "tados", "representados", "treinados", "forçados", "adotados", "constatados", "causados", "cumpre mandados", "alertados", "fotografados", "atrasados", "comunicados", "assaltados", "vacinados", "apaixonados", "inditados", "considere inadequados", "depositados", "quionados", "negociados", "ofertados", "cansados", "ar fechados", "apurados", "evacuados", "elaborados", "matriculados", "voltados", "encerrados", "negados", "sorteados", "sequrados", "gravados", "montados", "cumprir mandados", "reportados", "integrados", "ob dados", "processados", "lotados", "importados", "entusiasmados", "errados", "o analisados", "despregados", "exonerados", "fornecer dados", "arrastados", "firmados", "inceptados", "retomados", "moderados", "arquivados", "equipados", "organizados", "ameaçados", "prar cuidados", "visualizados", "recolher dados", "controlados", "patados", "jogados", "adicionados", "monitorados", "poupados", "vistoriados", "verificados", "celebrados", "elevados", "administrados", "iam utilizados", "produzir resultados", "possados", "visitados", "direcionados", "quebrados", "aliados", "variados", "hospitalizados", "apresenta resultados", "alinhados", "roubar dados", "aguardados", "incorporados", "implantados", "cadastrados", "lesionados", "revoltados", "filmados", "mostrados", "ar acompanhados", "hospedados", "conquistados", "avançados", "ficaram assustados", "considerados culpados", "apresentou resultados", "exist dados", "culpados", "editados", "ar ligados", "penalizados", "recomendados", "atualizados", "desligados", "imputados", "transformados", "conectados", "teve resultados", "lbrados", "o encaminhados", "inrogados", "arressados", "atropelados", "revados", "sentados", "adiados", "escalados", "inspira cuidados", "inaugurados", "financiados", "apreciados", "o colocados", "projetados", "passados", "cuidados", "compensados", "intimados", "enquadrados", "derrubados", "explorados", "designados", "melhorados", "calculados", "implentados", "tirados", "barrados", "assustados", "alvejados", "superados", "runerados", "adequados", "enganados", "chocados", "afogados", "alimentados", "ministrados", "cumpriram mandados", "ultrapassados", "renovados", "alcançar resultados", "pensados", "desafiados", "assegurados", "prevados", "guardados", "paralisados", "habilitados", "agraciados", "acampados", "ar focados", "o apurados", "reforçados", "apresentaram resultados", "baixados", "o obrigados", "o prejudicados", "provocados", "cassados", "capacitados", "imulados", "apoiados", "desesperados", "o avaliados", "dedicados", "pertences roubados", "desenhados", "ficaram espalhados", "inpretados", "ficaram impressionados", "pregados", "protocolados", "torturados", "indignados", "trabalhados", "suportados", "analisou dados", "avistados", "recepcionados", "reúne dados", "animados", "divulgou dados", "recrutados", "parcelados", "indexados", "lavrados", "ficaram danificados", "o executados", "somos confrontados", "anotados", "ranejados", "efugiados", "listados", "ignorados", "computados", "for considerados", "adaptados", "captados", "movimentados", "indicam dados", "retratados", "solucionados", "contactados", "confrontados", "cercados", "sepultados", "plantados", "mencionados", "reivindicados", "comparados", "udados", "imados", "imunizados", "mostram dados", "refugiados", "confiscados", "arratados", "pesquisados", "infectados", "compartilhados", "situados", "arrancados", "anulados", "encarados", "apresentadados", "motivados", "exportados", "alocados", "finalizados", "inspirados", "violados", "operados", "incetados", "criticados", "realizada", "encontrada", "criada", "considerada", "tomada", "limitada", "aprovada", "divulgada", "nada", "marcada", "levada", "confirmada", "acionada", "publicada", "registrada", "apresentada", "anunciada", "encaminhada", "usada", "lançada", "deu entrada", "chamada", "mada", "pagar nada", "inmada", "identida", "aplicada", "utilizada", "decada", "relacionada", "condenada", "adiada", "encerrada", "inaugurada", "liberada", "revelada", "abordada", "localizada", "estão cada", "colocada", "são cada", "agendada", "fundada", "enviada", "retirada", "cada", "iniciada", "baseada", "acusada", "notida", "assassinada", "avançada", "convidada", "vetada", "dar entrada", "vedada", "ligada", "dada", "disputada", "autorizada", "internada", "deflagrada", "baleada", "contratada", "preparada", "votada", "assinada", "acompanhada", "tratada", "tinha nada", "convocada", "obrigada", "fechada", "determinada", "cancelada", "analisada", "diagnosticada", "casada", "adotada", "procurada", "comunicada", "partilhada", "motivada", "atacada", "flagrada", "destinada", "montada", "solicitada", "associada", "apontada", "faz nada", "organizada", "entrada", "nomeada", "decretada", "interditada", "deram entrada", "eliminada", "questionada", "rejeitada", "preocupada", "instalada", "programada", "gravada", "alterada", "criticada", "tirada", "constatada", "esperada", "visitada", "investigada", "comprada", "voltada", "deixada", "resgatada", "assaltada", "declarada", "derrotada", "reçada", "liderada", "batizada", "atropelada", "afetada", "roubada", "indicada", "parada", "descartada", "respeitada", "causada", "recuperada", "estuprada", "sancionada", "autuada", "transportada", "avaliada", "julgada", "controlada", "inspirada", "dizer nada", "afastada", "fotografada", "havnada", "retomada", "denunciada", "executada", "pensada", "dedicada", "ameaçada", "abandonada", "contada", "citada", "provocada", "filmada", "cobrada", "cortada", "levantada", "antecipada", "concentrada", "implementada", "repassada", "efetuada", "consultada", "elaborada", "falar nada", "acessada", "focada", "empenhada", "encarada", "achada", "detectada", "negada", "complicada", "situada", "avisada", "sentada", "projetada", "orientada", "multada", "passada", "comentada", "desencadeada", "ajuizada", "justida", "alimentada", "premiada", "apreciada", "feito nada", "compartilhada", "celebrada", "disponibilizada", "aconteceu nada", "interpretada", "isolada", "recomendada", "caracterizada", "errada", "derrubada", "registada", "disse nada", "obvada", "transmada", "protocolada", "interessada", "esfaqueada", "selecionada", "sequestrada", "estudada", "alcançada", "integrada", "çada", "condicionada", "fixada", "evitada", "ampliada", "oficializada", "classida", "explicada", "ocupada", "editada", "finalizada", "implantada", "apaixonada", "detetada", "revogada", "comandada", "coordenada", "enterrada", "custa nada", "superada", "responsabilizada", "bloqueada", "especializada", "alertada", "homenageada", "conquistada", "acertada", "fazem nada", "desenhada", "negociada", "verida", "elevada", "testada", "jogada", "apoiada", "representada", "orçada", "arrastada", "recusada", "explorada", "concretizada", "capturada", "acostumada", "comprovada", "sabe nada", "estimada", "furtada", "libertada", "calculada", "promulgada", "trabalhada", "elogiada", "direcionada", "planejada", "assegurada", "clicada", "postada", "abusada", "comparada", "renovada", "arremessada", "arrombada", "alvejada", "administrada", "anulada", "prejudicada", "violada", "adequada", "operada", "advogada", "prestada", "espancada", "puxada", "tornada", "aproveitada", "ministrada", "indiciada", "alinhada", "acordada", "comemorada", "comercializada", "noticiada", "vinculada", "quebrada", "evacuada", "conplada", "adaptada", "chumbada", "contestada", "dominada", "danida", "beneficiada", "atrasada", "licenciada", "chegada", "hospedada", "prorrogada", "idealizada", "atualizada", "apanhada", "destacada", "aguardada", "revada", "mostrada", "viu nada", "cercada", "melhorada", "prevada", "privilegiada", "sediada", "instaurada", "regulamentada", "gerada", "barrada", "ultrapassada", "relatada", "intimada", "hospitalizada", "malizada", "aumentada", "arquivada", "normalizada", "desativada", "lembrada", "financiada", "influenciada", "sabnada", "encomendada", "cansada", "desempregada", "praticada", "doada", "deslocada", "trocada", "paralisada", "homologada", "captada", "apagada", "lotada", "designada", "adjudicada", "modida", "acatada", "medicada", "ver nada", "processada", "violentada", "ignorada", "incendiada", "acontecer nada", "fazer piada", "tornar cada", "alargada", "estamos cada", "r parada", "equipada", "estacionada", "incorporada", "ganhar nada", "afogada", "escalada", "empatada", "mudada", "remada", "habituada", "encabeçada", "delicada", "contactada", "coroada", "impulsionada", "sei nada", "deitada", "veiculada", "mencionada", "atrelada", "monitorada", "agravada", "raptada", "penalizada", "apurada", "queimada", "pintada", "entrevistada", "adiantada", "fazer cada", "ordenada", "sepultada", "inventada", "dispensada", "esgotada", "arrancada", "firmada", "apelidada", "sustentada", "chocada", "faz piada", "terá entrada", "exonerada", "ratida", "retratada", "protagonizada", "torturada", "assolapada", "abalada", "plantada", "centrada", "manifestada", "generalizada", "dar risada", "desesperada", "enquadrada", "culpada", "enfrentada", "efetivada", "alagada", "ambientada", "complementada", "espalhada", "piada", "frustrada", "sejam cada", "compensada", "valorizada", "descarregada", "examinada", "assinalada", "consolidada", "tocada", "notada", "trancada", "carregada", "privada", "pesada", "travada", "rebaixada", "restaurada", "arrematada", "intensida", "interceptada", "revoltada", "assustada", "r marcada", "crescer cada", "equacionada", "confrontada", "recheada", "irritada", "deputada", "animada", "calada", "cotada", "encantada", "ponderada", "desvendada", "remarcada", "armazenada", "assediada", "depositada", "vem equipada", "sorteada", "encenada", "ajustada", "impressionada", "regulada", "perguntada", "desviada", "amarrada", "leiloada", "revisada", "sagrada", "fabricada", "empregada", "m cada", "estipulada", "investido cada", "mandada", "adicionada", "enganada", "equivocada", "empurrada", "aconselhada", "armada", "demonstrada", "ativada", "arbitrada", "exportada", "separada", "validada", "pautada", "privatizada", "rá marcada", "desclassida", "cassada", "agraciada", "viabilizada", "ver cada", "guardada", "anexada", "estrangulada", "redobrada", "repensada", "denominada", "estimulada", "baixada", "dando risada", "emocionada", "faz cada", "comer nada", "cogitada", "reivindicada", "desligada", "avistada", "replicada", "arrasada", "suportada", "picada", "importada", "tombada", "mobilizada", "narrada", "namorada", "curada", "desmantelada", "contatada", "recepcionada", "indignada", "equilibrada", "saudada", "contraindicada", "interrogada", "amada", "confiada", "reportada", "efectuada", "vazada", "pressionada", "conectada", "graduada", "cultivada", "articulada", "vira piada", "filiada", "censurada", "mergulhada", "aliada", "subordinada", "congelada", "governada", "devastada", "desarticulada", "acendida", "golpeada", "reprovada", "estagnada", "regularizada", "prestigiada", "ovacionada", "variada", "amparada", "infundada", "corroborada", "diferenciada", "poupada", "saqueada", "vandalizada", "chateada", "molhada", "contaminada", "frequentada", "desafiada", "embargada", "morre afogada", "exagerada", "mulada", "patrocinada", "treinada", "apostada", "investir cada", "cresce cada", "presenciada", "alojada", "do cada", "inadequada", "dourada", "cuidada", "impetrada", "estarrelacionada", "reajustada", "ofertada", "acrescentada", "cantada", "deu risada", "ocasionada", "galardoada", "prolongada", "aperfeiçoada", "licitada", "atirada", "infectada", "engraçada", "empossada", "consumada", "inundada", "quitada", "facilitada", "empolgada", "embriagada", "completada", "rechaçada", "contabilizada", "bombardeada", "detonada", "incentivada", "imputada", "enraizada", "estrelada", "provada", "manipulada", "falada", "viciada", "consagrada", "abortada", "alugada", "intrigada", "sentenciada", "reavaliada", "vaiada", "farnada", "derivada", "dotada", "condecorada", "ternada", "remulada", "terminada", "estabilizada", "desacordada", "arriscada", "indenizada", "habitada", "proclamada", "mudarnada", "abraçada", "rodeada", "posicionada", "apropriada", "solucionada", "estruturada", "décadas", "realizadas", "relacionadas", "tomadas", "estradas", "armadas", "apresentadas", "privadas", "ligadas", "chamadas", "usadas", "divulgadas", "encontradas", "temporadas", "polegadas", "aplicadas", "consideradas", "entradas", "registradas", "criadas", "utilizadas", "afetadas", "jornadas", "publicadas", "dadas", "fechadas", "determinadas", "controladas", "levadas", "destinadas", "jogadas", "aprovadas", "enviadas", "paradas", "rodadas", "colocadas", "identificadas", "associadas", "bancadas", "instaladas", "adotadas", "veiculadas", "voltadas", "retiradas", "elevadas", "marcadas", "pancadas", "olimpíadas", "registadas", "localizadas", "camadas", "diferenciadas", "encaminhadas", "espalhadas", "adequadas", "interessadas", "variadas", "partilhadas", "passadas", "anunciadas", "confirmadas", "organizadas", "investigadas", "analisadas", "especializadas", "citadas", "toleradas", "acompanhadas", "facadas", "avançadas", "calçadas", "disponibilizadas", "lançadas", "autorizadas", "rajadas", "causadas", "piadas", "disputadas", "baseadas", "apontadas", "avaliadas", "antecipadas", "isoladas", "lâmpadas", "pesadas", "escadas", "ocupadas", "queimadas", "integradas", "obrigadas", "arquibancadas", "guardadas", "preparadas", "iniciadas", "selecionadas", "apuradas", "separadas", "gravadas", "efetuadas", "limitadas", "esperadas", "executadas", "beneficiadas", "tratadas", "pesquisadas", "informadas", "implementadas", "programadas", "reveladas", "provocadas", "tiradas", "contratadas", "repassadas", "ofertadas", "retomadas", "coletadas", "liberadas", "erradas", "convidadas", "premiadas", "dedicadas", "classificadas", "levantadas", "ameaçadas", "roubadas", "comentadas", "cotadas", "direcionadas", "deixadas", "formadas", "caminhadas", "encerradas", "acusadas", "agendadas", "cobradas", "praticadas", "reservadas", "cadastradas", "alegadas", "indicadas", "geradas", "trocadas", "prestadas", "apoiadas", "assassinadas", "cortadas", "observadas", "contempladas", "chegadas", "compartilhadas", "fadas", "complicadas", "negociadas", "procuradas", "trovoadas", "abandonadas", "solicitadas", "internadas", "representadas", "captadas", "empregadas", "danificadas", "compradas", "pousadas", "detalhadas", "comercializadas", "paralisadas", "visitadas", "carregadas", "elaboradas", "inspiradas", "bloqueadas", "vinculadas", "montadas", "resgatadas", "condenadas", "respeitadas", "coordenadas", "abordadas", "convocadas", "trabalhadas", "pedaladas", "interditadas", "acionadas", "gargalhadas", "somadas", "armazenadas", "embaixadas", "ministradas", "transportadas", "plantadas", "alteradas", "situadas", "atualizadas", "preocupadas", "granadas", "contadas", "prejudicadas", "vacinadas", "atrasadas", "quebradas", "guiadas", "saladas", "risadas", "concentradas", "listadas", "canceladas", "adaptadas", "fachadas", "mencionadas", "declaradas", "focadas", "verificadas", "aliadas", "personalizadas", "carenciadas", "movimentadas", "implantadas", "adiadas", "público-privadas", "infectadas", "enfrentadas", "julgadas", "comprovadas", "moderadas", "assinadas", "forçadas", "pintadas", "influenciadas", "alcançadas", "recuperadas", "orientadas", "baladas", "desalojadas", "picadas", "contabilizadas", "destacadas", "equipadas", "estudadas", "exploradas", "consultadas", "detetadas", "qualificadas", "financiadas", "estruturadas", "rejeitadas", "congeladas", "privilegiadas", "afectadas", "acumuladas", "cruzadas", "alagadas", "cantadas", "votadas", "fabricadas", "animadas", "entrevistadas", "detectadas", "denunciadas", "deslocadas", "afastadas", "mostradas", "transformadas", "inesperadas", "recomendadas", "motivadas", "consolidadas", "reforçadas", "degradadas", "comparadas", "importadas", "pensadas", "tocadas", "monitoradas", "doadas", "fixadas", "lotadas", "pauladas", "touradas", "conectadas", "camaradas", "sofisticadas", "combinadas", "eliminadas", "conquistadas", "desenhadas", "administradas", "autoestradas", "interpretadas", "brigadas", "inauguradas", "projetadas", "desabrigadas", "viradas", "ousadas", "empreitadas", "furtadas", "testadas", "capturadas", "lideradas", "apagadas", "planejadas", "contaminadas", "atacadas", "almofadas", "barricadas", "esgotadas", "apropriadas", "postadas", "diagnosticadas", "inusitadas", "credenciadas", "filmadas", "evitadas", "deputadas", "notificadas", "apertadas", "preservadas", "delicadas", "incorporadas", "enterradas", "sentadas", "operadas", "engraçadas", "processadas", "alinhadas", "espadas", "efectuadas", "equilibradas", "sorteadas", "estimadas", "pegadas", "comandadas", "terceirizadas", "actualizadas", "asseguradas", "comunicadas", "constatadas", "infundadas", "arrancadas", "descartadas", "lembradas", "baleadas", "acordadas", "questionadas", "namoradas", "inadequadas", "modificadas", "frustradas", "equivocadas", "evacuadas", "barradas", "relatadas", "centradas", "finalizadas", "ossadas", "demasiadas", "amarradas", "douradas", "valorizadas", "sediadas", "apreciadas", "consagradas", "editadas", "fiscalizadas", "habilitadas", "hospitalizadas", "apaixonadas", "desejadas", "dominadas", "aguardadas", "cultivadas", "casadas", "madrugadas", "andradas", "depositadas", "derrubadas", "ultrapassadas", "renovadas", "refugiadas", "acentuadas", "diversificadas", "exageradas", "mobilizadas", "inundadas", "desempregadas", "vazadas", "decretadas", "ignoradas", "concretizadas", "derivadas", "denominadas", "remuneradas", "acertadas", "superadas", "adicionadas", "flagradas", "pedradas", "imunizadas", "melhoradas", "recheadas", "aproveitadas", "enquadradas", "desesperadas", "inalteradas", "improvisadas", "certificadas", "afiliadas", "intensificadas", "adiantadas", "libertadas", "prolongadas", "deflagradas", "justificadas", "condicionadas", "licenciadas", "salgadas", "sinalizadas", "exportadas", "fundamentadas", "conveniadas", "prestigiadas", "endividadas", "reguladas", "ajustadas", "badaladas", "formuladas", "generalizadas", "advogadas", "autuadas", "abusadas", "violadas", "ampliadas", "designadas", "criticadas", "nomeadas", "celebradas", "posicionadas", "acessadas", "inacabadas", "empenhadas", "decoradas", "esplanadas", "lusíadas", "impulsionadas", "embaladas", "homenageadas", "treinadas", "lombadas", "retratadas", "pisadas", "arriscadas", "alimentadas", "traçadas", "explicadas", "reiteradas", "estipuladas", "cilindradas", "conceituadas", "desligadas", "desativadas", "anuladas", "geladas", "moradas", "ajuizadas", "fundadas", "iluminadas", "pressionadas", "contactadas", "calculadas", "travadas", "necessitadas", "filiadas", "penduradas", "confeccionadas", "cercadas", "interligadas", "incentivadas", "goleadas", "estacionadas", "suportadas", "habitadas", "indesejadas", "desempenhadas", "matriculadas", "reportadas", "motorizadas", "impactadas", "sagradas", "indiciadas", "misturadas", "faladas", "alugadas", "manipuladas", "sequestradas", "validadas", "penalizadas", "atropeladas", "arroladas", "infetadas", "terminadas", "multadas", "acostumadas", "desperdiçadas", "atadas", "cansadas", "ilimitadas", "auto-estradas", "trapalhadas", "articuladas", "enxurradas", "dotadas", "visadas", "renomadas", "homologadas", "subordinadas", "falsificadas", "arquivadas", "saturadas", "regulamentadas", "injustificadas", "efetivadas", "reformadas", "capacitadas", "protagonizadas", "fotografadas", "soterradas", "planeadas", "tornadas", "elencadas", "educadas", "desencadeadas", "estupradas", "falhadas", "agravadas", "desocupadas", "assustadas", "assadas", "requisitadas", "leiloadas", "especificadas", "açucaradas", "arrecadadas", "estampadas", "assaltadas", "agrupadas", "estimuladas", "caracterizadas", "encomendadas", "pavimentadas", "firmadas", "inventadas", "largadas", "interceptadas", "emplacadas", "trancadas", "aumentadas", "achadas", "protocoladas", "desviadas", "abrigadas", "arrastadas", "ativadas", "empatadas", "agitadas", "prorrogadas", "avultadas", "torradas", "geadas", "regularizadas", "examinadas", "sustentadas", "participadas", "proporcionadas", "orçadas", "ensinadas", "imputadas", "contestadas", "amadas", "negadas", "culpadas", "disparadas", "anexadas", "pautadas", "cuidadas", "alargadas", "adoptadas", "custeadas", "coladas", "lavadas", "responsabilizadas", "baixadas", "reprovadas", "licitadas", "manifestadas", "desencontradas", "dispensadas", "demarcadas", "puxadas", "restauradas", "derrotadas", "pitadas", "alojadas", "provadas", "assinaladas", "encaradas", "povoadas", "molhadas", "patrocinadas", "familiarizadas", "compensadas", "catalogadas", "rasgadas", "confrontadas", "atreladas", "vistoriadas", "privatizadas", "referenciadas", "quitadas", "esburacadas", "sanadas", "originadas", "aprofundadas", "demonstradas", "embarcadas", "enganadas", "automatizadas", "suscitadas", "vedadas", "adulteradas", "delegadas", "habituadas", "viciadas", "precipitadas", "avisadas", "despejadas", "descontadas", "regadas", "lesadas", "paralimpíadas", "atiradas", "devastadas", "apanhadas", "vigiadas", "ordenadas", "formalizadas", "herdadas", "legalizadas", "documentadas", "arrojadas", "escaladas", "datadas", "sacadas", "aceleradas", "chumbadas", "discriminadas", "elogiadas", "parceladas", "conservadas", "descentralizadas", "reclamadas", "revogadas", "tripuladas", "tributadas", "padronizadas", "noticiadas", "superlotadas", "frequentadas", "demoradas", "marginalizadas", "recicladas", "ponderadas", "negligenciadas", "afogadas", "acrescentadas", "raptadas", "engajadas", "alertadas", "pinceladas", "disseminadas", "avermelhadas", "encarregadas", "intercaladas", "seleccionadas", "torturadas", "incendiadas", "indignadas", "alocadas", "asfaltadas", "emprestadas", "violentadas", "veladas", "clonadas", "auditadas", "mapeadas", "arcadas", "assediadas", "compiladas", "customizadas", "arredondadas", "ocasionadas", "coronhadas", "solucionadas", "sancionadas", "xadas", "preconizadas", "ditadas", "arremessadas", "caçadas", "chicotadas", "encantadas", "desmatadas", "deitadas", "industrializadas", "perpetradas", "fragilizadas", "encarceradas", "supervisionadas", "mudadas", "ilustradas", "abastadas", "fracassadas", "cobiçadas", "afiadas", "buscadas", "franqueadas", "inapropriadas", "completadas", "notadas", "forjadas", "confinadas", "continuadas", "destelhadas", "pacificadas", "priorizadas", "ancoradas", "agregadas", "vocacionadas", "amparadas", "acampadas", "unificadas", "encenadas", "noitadas", "despachadas", "vetadas", "mediadas", "peladas", "recusadas", "cotoveladas", "subsidiadas", "descarregadas", "narradas", "criptografadas", "bofetadas", "alternadas", "computadas", "realojadas", "recrutadas", "lacradas", "alfinetadas", "dinamizadas", "emocionadas", "derrocadas", "ajudadas", "blindadas", "numeradas", "invocadas", "intencionadas", "liquidadas", "desatualizadas", "vivenciadas", "emboscadas", "poupadas", "hospedadas", "encarnadas", "acirradas", "congestionadas", "entrelaçadas", "pomadas", "juntadas", "fragmentadas", "anotadas", "beiradas", "assentadas", "ensaiadas", "batizadas", "temperadas", "abaladas", "revisadas", "rodeadas", "ilhadas", "arrimadas", "revoltadas", "curadas", "digitalizadas", "admiradas", "facilitadas", "carbonizadas", "delimitadas", "acatadas", "intimadas", "arrendadas", "reajustadas", "endereçadas", "pronunciadas", "aprimoradas", "cabeçadas", "traficadas", "duplicadas", "cristalizadas", "enfeitadas", "charqueadas", "superfaturadas", "arrumadas", "desmontadas", "nómadas", "simuladas", "reivindicadas", "centralizadas", "aclamadas", "pernadas", "fraudadas", "dobradas", "acabadas", "fracionadas", "videochamadas", "visualizadas", "fantasiadas", "manchadas", "monitorizadas", "emanadas", "bordadas", "rebaixadas", "gratificadas", "arrombadas", "disfarçadas", "acaloradas", "copiadas", "checadas", "implicadas", "saqueadas", "sepultadas", "caladas", "enraizadas", "estadas", "confiscadas", "civilizadas", "valadas", "desgastadas", "coligadas", "afixadas", "oficializadas", "entusiasmadas", "equiparadas", "estagnadas", "complementadas", "evidenciadas", "incomodadas", "inspecionadas", "arborizadas", "inflamadas", "desbloqueadas", "grelhadas", "palmadas", "rabanadas", "inclinadas", "individualizadas", "apressadas", "experimentadas", "castigadas", "conjugadas", "gerenciadas", "encriptadas", "delineadas", "banhadas", "replicadas", "creditadas", "comissionadas", "acopladas", "reabilitadas", "esmagadas", "sobrecarregadas", "desacompanhadas", "joelhadas", "ressalvadas", "contextualizadas", "sincronizadas", "tombadas", "sitiadas", "aconselhadas", "demandadas", "cunhadas", "mandadas", "humoradas", "pichadas", "empadas", "camufladas", "institucionalizadas", "simplificadas", "censuradas", "empurradas", "desafiadas", "canalizadas", "angariadas", "embargadas", "enxadas", "encostadas", "esvaziadas", "normalizadas", "escravizadas", "concessionadas", "autenticadas", "refinadas", "palhaçadas", "furadas", "vaquejadas", "sensibilizadas", "amputadas", "acomodadas", "espancadas", "extremadas", "malvadas", "empanadas", "empilhadas", "deterioradas", "enroladas", "direccionadas", "estocadas", "estragadas", "interrogadas", "revistadas", "quadradas", "encaixadas", "reparadas", "escutadas", "toadas", "idealizadas", "marteladas", "tapadas", "federadas", "desapropriadas", "indenizadas", "maltratadas", "intervencionadas", "chocadas", "climatizadas", "braçadas", "rastreadas", "abraçadas", "confiadas", "aposentadas", "contrabandeadas", "descoladas", "pactuadas", "tacadas", "retrógradas", "equacionadas", "agarradas", "avistadas", "encorajadas", "pontuadas", "moldadas", "honradas", "empoderadas", "erradicadas", "enferrujadas", "clicadas", "adjudicadas", "tentadas", "silenciadas", "depredadas", "inchadas", "realocadas", "viabilizadas", "vincadas", "espelhadas", "carimbadas", "cavalgadas", "amontoadas", "confecionadas", "lavradas", "reaproveitadas", "afinadas", "arruadas", "alfabetizadas", "ex-namoradas", "reavaliadas", "configuradas", "mutiladas", "colegiadas", "impossibilitadas", "imaginadas", "bem-humoradas", "atravessadas", "agraciadas", "irritadas", "remarcadas", "irrigadas", "olímpiadas", "alçadas", "alongadas", "promulgadas", "assemelhadas", "concertadas", "averiguadas", "espaçadas", "desrespeitadas", "edificadas", "esfaqueadas", "obcecadas", "vandalizadas", "tuteladas", "estilizadas", "desvalorizadas", "enlutadas", "instauradas", "contatadas", "amareladas", "descontroladas", "consignadas", "cassadas", "espetadas", "machucadas", "prateadas", "enumeradas", "enteadas", "desequilibradas", "descongeladas", "desajustadas", "penhoradas", "sacrificadas", "juradas", "otimizadas", "uniformizadas", "torneadas", "sedeadas", "orquestradas", "recriadas", "esfarrapadas", "cromadas", "acauteladas", "onças-pintadas", "mascaradas", "deletadas", "desidratadas", "subcontratadas", "escancaradas", "reutilizadas", "providenciadas", "traumatizadas", "ratificadas", "periciadas", "estabilizadas", "incubadas", "desconsideradas", "conturbadas", "forradas", "taxadas", "zeradas", "urbanizadas", "reputadas", "debilitadas", "deliberadas", "apelidadas", "sucateadas", "amassadas", "encabeçadas", "enunciadas", "desamparadas", "acreditadas", "projectadas", "medicadas", "transitadas", "mal-intencionadas", "intoxicadas", "pré-fabricadas", "exaltadas", "coroadas", "vitimadas", "transplantadas", "chuvadas", "aperfeiçoadas", "esticadas", "indexadas", "remanejadas", "mesadas", "empolgadas", "acondicionadas", "segregadas", "tituladas", "aproximadas", "encalhadas", "encurraladas", "embasadas", "coreografadas", "entoadas", "estreladas", "propagadas", "autografadas", "chibatadas", "acidentadas", "queijadas", "escapadas", "hasteadas", "infestadas", "cavadas", "arrematadas", "impregnadas", "salvaguardadas", "jangadas", "envenenadas", "descascadas", "renegociadas", "intermediadas", "impugnadas", "geminadas", "dubladas", "dissipadas", "segmentadas", "disciplinadas", "galardoadas", "sobrelotadas", "intocadas", "recortadas", "cogitadas", "desadequadas", "minimizadas", "chefiadas", "abarrotadas", "desabitadas", "gozadas", "relegadas", "outorgadas", "seladas", "requalificadas", "codificadas", "encapuzadas", "alienadas", "recuadas", "freadas", "bombardeadas", "acarinhadas", "metalizadas", "mergulhadas", "divorciadas", "decapitadas", "desprezadas", "intituladas", "humilhadas", "materializadas", "contratualizadas", "alvejadas", "abençoadas", "arrasadas", "despojadas", "transacionadas", "tipificadas", "costuradas", "chapadas", "ceifadas", "alcoolizadas", "comemoradas", "destiladas", "desestruturadas", "mecanizadas", "ranqueadas", "dificultadas", "desconectadas", "semeadas", "pré-selecionadas", "pirateadas", "perdoadas", "ciladas", "aliviadas", "manadas", "incineradas", "estressadas", "perturbadas", "polarizadas", "refrigeradas", "compromissadas", "algemadas", "exacerbadas", "impetradas", "legendadas", "modernizadas", "aliciadas", "consorciadas", "saradas", "seguradas", "estereotipadas", "filtradas", "olhadas", "recarregadas", "presenteadas", "dizimadas", "descontinuadas", "governadas", "escrutinadas", "revitalizadas", "pormenorizadas", "perfumadas", "deportadas", "detonadas", "domiciliadas", "recordadas", "tesouradas", "relaxadas", "rosadas", "deturpadas", "arranjadas", ":noticiasrelacionadas", "despreparadas", "embriagadas", "reembolsadas", "redobradas", "intercetadas", "desclassificadas", "talhadas", "deformadas", "encruzilhadas", "adoradas", "lesionadas", "respaldadas", "radicadas", "marretadas", "impressionadas", "alicerçadas", "assimiladas", "emolduradas", "inutilizadas", "intrincadas", "cronometradas", "rotuladas", "dissimuladas", "lança-granadas", "goradas", "avariadas", "caramelizadas", "militarizadas", "redesenhadas", "reiniciadas", "lecionadas", "desvendadas", "comparticipadas", "descaracterizadas", "embrulhadas", "escavadas", "requintadas", "ninhadas", "raspadas", "eternizadas", "injetadas", "engarrafadas", "defasadas", "tatuadas", "graduadas", "famigeradas", "pulverizadas", "comportadas", "encetadas", "chateadas", "ambientadas", "antenadas", "corroboradas", "desacreditadas", "remodeladas", "pleiteadas", "fincadas", "podadas", "cozinhadas", "atenuadas", "auxiliadas", "envergonhadas", "desordenadas", "estigmatizadas", "sufocadas", "ocultadas", "desorganizadas", "consumadas", "decepadas", "esbranquiçadas", "extraviadas", "grudadas", "porradas", "cravadas", "cifradas", "borradas", "pré-determinadas", "politizadas", "capitaneadas", "decadas", "enviesadas", "multiplicadas", "recompensadas", "hackeadas", "feijoadas", "represadas", "ensanguentadas", "descontextualizadas", "assombradas", "legitimadas", "musculadas", "cavalhadas", "desconfiadas", "desmanteladas", "harmonizadas", "magistradas", "ozadas", "pescadas", "disparatadas", "enfileiradas", "bêbadas", "acamadas", "abafadas", "reformuladas", "evocadas", "trituradas", "intimidadas", "recolocadas", "balanceadas", "carradas", "angustiadas", "despropositadas", "pilotadas", "escoltadas", "ventiladas", "zangadas", "sintonizadas", "fustigadas", "incapacitadas", "incrementadas", "mescladas", "explicitadas", "resguardadas", "subestimadas", "sentenciadas", "defraudadas", "dentadas", "computadorizadas", "alavancadas", "aparadas", "orçamentadas", "expressadas", "eletrificadas", "apetrechadas", "guitarradas", "nadas", "nevadas", "incrustadas", "dilatadas", "clarificadas", "decotadas", "arruinadas", "aventadas", "encharcadas", "inconformadas", "infiltradas", "reprogramadas", "regionalizadas", "reassentadas", "meadas", "aprisionadas", "massacradas", "inexploradas", "guinadas", "patenteadas", "supracitadas", "desfocadas", "desastradas", "contrariadas", "atestadas", "rechaçadas", "rachadas", "parparticipadas", "fraturadas", "antiquadas", "desmarcadas", "higienizadas", "humanizadas", "molestadas", "avantajadas", "apostadas", "assoalhadas", "calcadas", "apavoradas", "abaixadas", "reviradas", "paraolimpíadas", "potenciadas", "digitadas", "garrafadas", "folgadas", "esterilizadas", "fadadas", "gaseificadas", "laminadas", "pré-moldadas", "recepcionadas", "relembradas", "desarmadas", "derramadas", "cursadas", "asfixiadas", "sub-representadas", "caneladas", "desqualificadas", "pisoteadas", "maquiadas", "escolarizadas", "posadas", "ornamentadas", "desmembradas", "curvadas", "aradas", "sintetizadas", "subutilizadas", "acorrentadas", "coitadas", "portadas", "remasterizadas", "machadadas", "fornadas", "quantificadas", "popularizadas", "desorientadas", "apimentadas", "amamentadas", "destroçadas", "grampeadas", "transaccionadas", "fermentadas", "indeterminadas", "prensadas", "desproporcionadas", "cartadas", "arraigadas", "aterrorizadas", "contornadas", "criminalizadas", "reativadas", "gritadas", "referendadas", "repensadas", "custodiadas", "descaradas", "conflagradas", "amenizadas", "ressecadas", "reagendadas", "odiadas", "fascinadas", "mimadas", "universíadas", "trajadas", "adornadas", "assalariadas", "caprichadas", "correlacionadas", "desinformadas", "ensolaradas", "enfiadas", "sonhadas", "serradas", "tostadas", "emperradas", "consertadas", "colheradas", "facultadas", "olimpiadas", "revisitadas", "pedagiadas", "inviabilizadas", "englobadas", "dimensionadas", "cerradas", "truncadas", "suadas", "batucadas", "cacheadas", "amplificadas", "mamadas", "flechadas", "gigatoneladas", "perfuradas", "potencializadas", "reclassificadas", "presenciadas", "apadrinhadas", "descansadas", "aglomeradas", "bastonadas", "rebuscadas", "inabilitadas", "bem-intencionadas", "charadas", "desgarradas", "empoeiradas", "degustadas", "consubstanciadas", "informatizadas", "imobilizadas", "publicitadas", "roçadas", "reencaminhadas", "adas", "abortadas", "sublinhadas", "aromatizadas", "reestruturadas", "pré-instaladas", "radicalizadas", "pregadas", "formatadas", "abóbadas", "calendarizadas", "decepcionadas", "enseadas", "dissociadas", "arrecadas", "balançadas", "estreadas", "exterminadas", "estranguladas", "replantadas", "plasmadas", "abonadas", "aviadas", "atrapalhadas", "arregaçadas", "boicotadas", "flexibilizadas", "imortalizadas", "exoneradas", "minadas", "condensadas", "convencionadas", "envidraçadas", "partido", "devido", "sentido", "pedido", "conhecido", "marido", "unido", "rápido", "recebido", "detido", "ocorrido", "tido", "atingido", "seguido", "desenvolvido", "escolhido", "proibido", "ouvido", "válido", "perdido", "ferido", "definido", "líquido", "vendido", "produzido", "envolvido", "conseguido", "vestido", "reconhecido", "promovido", "acontecido", "mantido", "sofrido", "cumprido", "nascido", "dirigido", "reduzido", "apreendido", "decidido", "permitido", "garantido", "referido", "oferecido", "estabelecido", "cometido", "conduzido", "exibido", "arguido", "vencido", "transferido", "dividido", "obtido", "ido", "concedido", "resolvido", "havido", "tecido", "parecido", "emitido", "surpreendido", "submetido", "desaparecido", "socorrido", "discutido", "foragido", "agredido", "adquirido", "divertido", "impedido", "desconhecido", "atendido", "bandido", "vivido", "preferido", "escondido", "lido", "assumido", "investido", "falecido", "demitido", "apelido", "exigido", "punido", "transmitido", "querido", "interrompido", "servido", "protegido", "cândido", "batido", "ex-marido", "defendido", "esquecido", "sucedido", "prometido", "morrido", "comprometido", "assistido", "cedido", "aparecido", "recolhido", "convencido", "crescido", "ácido", "reunido", "indevido", "removido", "inserido", "percebido", "sugerido", "sólido", "trazido", "colorido", "perseguido", "expedido", "consumido", "entendido", "presidido", "sabido", "fugido", "devolvido", "movido", "rígido", "fornecido", "surgido", "concebido", "abatido", "gerido", "invadido", "estendido", "híbrido", "guido", "admitido", "corrigido", "esclarecido", "distinguido", "debatido", "contido", "recém-nascido", "absolvido", "corrido", "bem-sucedido", "dióxido", "exercido", "tímido", "subido", "traduzido", "rendido", "acrescido", "repetido", "temido", "preenchido", "merecido", "compreendido", "pretendido", "convertido", "requerido", "aplaudido", "respondido", "introduzido", "ofendido", "duvido", "medido", "agido", "arrependido", "percorrido", "aprendido", "despedido", "retido", "banido", "combatido", "acolhido", "existido", "erguido", "cozido", "comprido", "despercebido", "revertido", "remetido", "proferido", "recorrido", "semiárido", "confundido", "doido", "sobrevivido", "comprimido", "aquecido", "ingerido", "concorrido", "colhido", "decorrido", "garrido", "falido", "induzido", "conferido", "expandido", "úmido", "descuido", "indefinido", "nítido", "estúpido", "desistido", "embutido", "agradecido", "desiludido", "favorecido", "difundido", "candido", "fluido", "munido", "abastecido", "rompido", "reagido", "reproduzido", "desmentido", "indeferido", "plácido", "refletido", "advertido", "fortalecido", "sumido", "mentido", "restabelecido", "reconduzido", "demolido", "metido", "insistido", "bebido", "absorvido", "permanecido", "amido", "repartido", "comido", "valido", "invertido", "descido", "enfraquecido", "enriquecido", "deferido", "rescindido", "revestido", "constrangido", "óxido", "suspendido", "regido", "presumido", "aborrecido", "preterido", "aderido", "deprimido", "monóxido", "envelhecido", "cuido", "dormido", "redigido", "mal-entendido", "resistido", "mexido", "divido", "lúcido", "mordido", "ressarcido", "engolido", "adormecido", "desprovido", "decido", "comparecido", "dissolvido", "correspondido", "libido", "abrangido", "comovido", "derretido", "precedido", "corrompido", "podido", "convido", "florido", "omitido", "explodido", "consentido", "fundido", "despromovido", "resumido", "descumprido", "ávido", "deduzido", "atrevido", "despido", "expelido", "desferido", "acometido", "aguerrido", "dolorido", "inválido", "repreendido", "comedido", "seduzido", "pulido", "destemido", "auferido", "polido", "cido", "penido", "apercebido", "descabido", "desentendido", "distorcido", "curtido", "cupido", "oprimido", "procedido", "adido", "incumbido", "ardido", "coagido", "desprotegido", "restringido", "hokkaido", "húmido", "acedido", "provido", "zumbido", "pertencido", "despendido", "recém-promovido", "prendido", "inquirido", "interferido", "pré-aquecido", "alarido", "extrovertido", "antecedido", "reprimido", "aludido", "suprimido", "liquido", "árido", "colidido", "enfurecido", "chovido", "esculpido", "surtido", "desprevenido", "pálido", "rapido", "excedido", "renascido", "empreendido", "enchido", "convivido", "prosseguido", "entupido", "obedecido", "repercutido", "amadurecido", "aferido", "prevenido", "abolido", "espremido", "desmedido", "tripartido", "varrido", "encolhido", "travestido", "transcorrido", "aminoácido", "saburido", "rebatido", "contundido", "esplêndido", "evadido", "diferido", "renhido", "introvertido", "combalido", "estarrecido", "ressentido", "cuspido", "ingressorapido", "torcido", "inibido", "pré-definido", "iludido", "sórdido", "mórbido", "enaltecido", "incompreendido", "competido", "ungido", "brígido", "ascendido", "pré-estabelecido", "infringido", "entretido", "embatido", "entristecido", "enlouquecido", "cabido", "preaquecido", "compelido", "madrido", "translúcido", "precavido", "bólido", "ríspido", "incorrido", "subentendido", "rugido", "prevalecido", "volvido", "peróxido", "reflectido", "empobrecido", "sacudido", "gélido", "digerido", "controvertido", "límpido", "walfrido", "vido", "revendido", "margarido", "erigido", "fingido", "progredido", "impávido", "tingido", "estampido", "semi-árido", "vertido", "endurecido", "lava-rápido", "reestabelecido", "tórrido", "quirido", "rejuvenescido", "extorquido", "latido", "nutrido", "yupido", "retorcido", "coproduzido", "olido", "desprendido", "embebido", "sortido", "elegido", "desapercebido", "arrefecido", "prurido", "subdesenvolvido", "infligido", "resido", "emagrecido", "construido", "intrépido", "abduzido", "[respondido", "incluido", "exaurido", "predefinido", "pervertido", "saido", "desobedecido", "enrustido", "reinvestido", "desinibido", "dido", "grávido", "escurecido", "suprido", "desnutrido", "[partido", "repelido", "revivido", "sucumbido", "substituido", "tremido", "incutido", "coibido", "persuadido", "impelido", "coincidido", "fétido", "hidróxido", "implodido", "emergido", "imprimido", "umedecido", "guarnecido", "peido", "multicolorido", "reabastecido", "fervido", "residido", "carvalhido", "acorrido", "enraivecido", "extinguido", "vívido", "rossido", "hibrido", "gemido", "presido", "co-produzido", "subdividido", "tolhido", "desimpedido", "sorrido", "ruido", "desfavorecido", "flácido", "incidido", "redefinido", "dorido", "decrescido", "prescindido", "zoido", "parido", "malsucedido", "fedido", "ilíquido", "descomprometido", "apodrecido", "preestabelecido", "readmitido", "escorrido", "guaido", "fido", "reconvertido", "apetecido", "estupido", "insípido", "atribuido", "dispendido", "intrometido", "rediscutido", "premido", "braido", "bipartido", "retransmitido", "rido", "interagido", "amanhecido", "adoecido", "desassistido", "abstido", "superaquecido", "empedernido", "borlido", "estremecido", "destruido", "valfrido", "divergido", "desfalecido", "aikido", "distribuido", "distendido", "urdido", "cumplido", "irrefletido", "reintroduzido", "contribuido", "shiseido", "recém-falecido", "pérfido", "fodido", "insurgido", "codirigido", "concluido", "caido", "masellido", "placido", "remexido", "insculpido", "submergido", "amortecido", "bem-recebido", "reerguido", "persistido", "recém-adquirido", "incontido", "desparecido", "encardido", "embevecido", "dependido", "franzido", "diminuido", "redimido", "pedorido", "extendido", "intercedido", "desunido", "super-rápido", "descolorido", "carcomido", "mido", "aturdido", "contorcido", "dirimido", "nido", "regredido", "dissuadido", "entorpecido", "consabido", "dúvido", "desaquecido", "[devido", "reinserido", "improvido", "ex-partido", "supreendido", "inadvertido", "olvido", "perecido", "demovido", "nabonido", "ultrarrápido", "r?pido", "ensandecido", "benzido", "obscurecido", "subvertido", "reaparecido", "amolecido", "arpinido", "acido", "envaidecido", "lambido", "cosido", "shido", "constituido", "líbido", "kido", "lânguido", "esquálido", "esbatido", "sustenido", "desguarnecido", "desabrido", "pressentido", "hígido", "desabastecido", "bushido", "imerecido", "recém-demitido", "remido", "nérido", "pré-cozido", "intervido", "exprimido", "esbaforido", "consistido", "afligido", "relido", "antiácido", "coarguido", "subnutrido", "sonido", "mal-sucedido", "mantovanido", "encarecido", "valentinido", "gramido", "redistribuido", "engrandecido", "convergido", "proíbido", "esgrimido", "esmorecido", "fudido", "lagido", "namorido", "denegrido", "desvanecido", "turionido", "ultra-rápido", "lépido", "flórido", "hapkido", "impingido", "pendido", "reincidido", "ressurgido", "vida", "medida", "partida", "avenida", "seguida", "dívida", "proibida", "corrida", "conhecida", "almeida", "dúvida", "torcida", "rápida", "comida", "subida", "ida", "devida", "grávida", "bebida", "atingida", "definida", "aparecida", "descida", "desenvolvida", "reduzida", "reconhecida", "contrapartida", "escolhida", "promovida", "despedida", "dirigida", "mantida", "concedida", "produzida", "permitida", "batida", "líquida", "recebida", "válida", "referida", "garantida", "perdida", "dividida", "vendida", "exibida", "ferida", "detida", "envolvida", "flórida", "margarida", "apreendida", "cumprida", "convida", "cuida", "transmitida", "ocorrida", "conduzida", "estabelecida", "oferecida", "lida", "presidida", "socorrida", "parecida", "pedida", "divertida", "discutida", "decidida", "indevida", "banida", "atendida", "obtida", "nascida", "proferida", "emitida", "ouvida", "sólida", "escondida", "sofrida", "resolvida", "interrompida", "agredida", "vivida", "defendida", "transferida", "submetida", "movida", "florida", "desconhecida", "comprometida", "exigida", "adquirida", "querida", "protegida", "desaparecida", "assistida", "contida", "inserida", "vencida", "suicida", "surpreendida", "unida", "vestida", "assumida", "investida", "prometida", "decida", "acolhida", "impedida", "exercida", "bem-sucedida", "consumida", "preferida", "duvida", "invadida", "erguida", "recolhida", "esquecida", "tímida", "sentida", "sucedida", "estendida", "conseguida", "revertida", "servida", "trazida", "colorida", "tida", "fornecida", "gerida", "corrigida", "rígida", "cometida", "acrescida", "repetida", "convertida", "concebida", "reunida", "preenchida", "debatida", "requerida", "arguida", "divida", "conferida", "cândida", "híbrida", "cida", "sida", "consolida", "emicida", "arrábida", "introduzida", "expedida", "esclarecida", "frida", "entendida", "traduzida", "nítida", "perseguida", "falecida", "removida", "distinguida", "punida", "pretendida", "ardida", "mordida", "colhida", "antártida", "cedida", "sobrevida", "despercebida", "demitida", "admitida", "homicida", "reproduzida", "falida", "percebida", "sugerida", "devolvida", "convencida", "comprida", "ofendida", "merecida", "difundida", "restabelecida", "recém-nascida", "aquecida", "compreendida", "aplaudida", "deferida", "indefinida", "reprimida", "remetida", "distorcida", "dida", "envelhecida", "percorrida", "cozida", "confundida", "combatida", "refletida", "estúpida", "inseticida", "invertida", "rendida", "resumida", "respondida", "temida", "adormecida", "valida", "atlântida", "doida", "precedida", "concorrida", "fortalecida", "absorvida", "constrangida", "rebatida", "abastecida", "ermida", "demolida", "retida", "regida", "mexida", "desmentida", "expandida", "revalida", "favorecida", "desprovida", "descabida", "agradecida", "úmida", "abatida", "absolvida", "foragida", "vih/sida", "aida", "fluida", "deprimida", "embutida", "desmedida", "invalida", "arrependida", "intimida", "enfraquecida", "presumida", "deduzida", "lúcida", "indeferida", "abrangida", "herbicida", "induzida", "renhida", "enriquecida", "redigida", "revestida", "guida", "surgida", "liquida", "ácida", "ingerida", "aguerrida", "descumprida", "machida", "rompida", "jazida", "mórbida", "destemida", "dormida", "despida", "mérida", "consentida", "comovida", "pálida", "abolida", "repartida", "suprimida", "aprendida", "boavida", "aborrecida", "bandida", "curtida", "al-qaida", "guarida", "apelida", "derretida", "esculpida", "yoshida", "hodeida", "desprotegida", "metida", "antecedida", "desiludida", "hapvida", "dissolvida", "atrevida", "proíbida", "saida", "inválida", "ressarcida", "recorrida", "engolida", "sumida", "dolorida", "brígida", "sacudida", "pesticida", "empreendida", "extrovertida", "elucida", "pró-vida", "aludida", "resida", "engravida", "arida", "coagida", "reconduzida", "munida", "aferida", "corrompida", "ávida", "ríspida", "acometida", "crescida", "polida", "comedida", "suprida", "árida", "incumbida", "restringida", "varrida", "húmida", "prevenida", "sórdida", "oprimida", "amadurecida", "combalida", "límpida", "genocida", "élida", "eneida", "decorrida", "preterida", "controvertida", "tripartida", "enfurecida", "descuida", "seduzida", "larvicida", "fida", "empobrecida", "fratricida", "auferida", "advertida", "compadecida", "desinibida", "obedecida", "travestida", "provida", "esplêndida", "correspondida", "pegida", "fungicida", "hiv/sida", "bipartida", "enlouquecida", "diferida", "digerida", "despromovida", "translúcida", "estarrecida", "flácida", "repreendida", "estremecida", "havida", "incida", "omitida", "candida", "cressida", "apátrida", "reflectida", "antárctida", "pré-definida", "nélida", "espremida", "expelida", "gravida", "desprevenida", "vertida", "desassistida", "lleida", "coincida", "prosseguida", "merida", "desfavorecida", "repercutida", "gélida", "rodovida", "revendida", "entupida", "fundida", "prócida", "tremida", "reestabelecida", "vívida", "talidomida", "iludida", "pré-estabelecida", "comprimida", "fervida", "elida", "derrida", "fugida", "sabida", "acedida", "retorcida", "zuraida", "pré-preenchida", "nutrida", "inibida", "ressentida", "infligida", "enaltecida", "kishida", "rapida", "progrida", "malsucedida", "explodida", "renascida", "sachsida", "desnutrida", "erigida", "incompreendida", "tecida", "inquirida", "bífida", "urdida", "rejuvenescida", "bactericida", "introvertida", "#conexãopelavida", "ebtida", "inadvertida", "revida", "desimpedida", "militar/cedida", "codevida", "escurecida", "entristecida", "exaurida", "desapercebida", "embebida", "agrida", "entretida", "nereida", "acontecida", "ishida", "irrefletida", "poliamida", "descomprometida", "cheida", "lampre-merida", "encolhida", "incontida", "imprimida", "procedida", "tingida", "endurecida", "onusida", "desferida", "desprendida", "predefinida", "tiida", "multicolorida", "druida", "subdividida", "repelida", "lambida", "rashida", "despendida", "lérida", "hidroclorotiazida", "compelida", "tolhida", "semiárida", "bida", "preestabelecida", "leida", "freixo-arrábida", "carótida", "guarnecida", "reintroduzida", "coibida", "pervertida", "revivida", "uchida", "dirimida", "construida", "precavida", "intrépida", "zaida", "fingida", "giufrida", "insecticida", "parida", "desunida", "desfalecida", "pérfida", "coproduzida", "recém-adquirida", "apodrecida", "ultrarrápida", "amortecida", "denegrida", "vih-sida", "farida", "remexida", "endivida", "insípida", "incutida", "pida", "meia-vida", "cuspida", "hemorroida", "rida", "arremetida", "finasterida", "fedida", "fuenzalida", "hermida", "tórrida", "semirrígida", "subvertida", "preconcebida", "recém-promovida", "desabastecida", "desguarnecida", "baida", "umedecida", "fétida", "redefinida", "raticida", "extorquida", "ensandecida", "ilíquida", "pré-concebida", "benzida", "colida", "d?vida", "concluida", "aderida", "retransmitida", "splendida", "amolecida", "carcomida", "brida", "mal-sucedida", "envida", "rediscutida", "reinvestida", "presida", "embevecida", "impelida", "impávida", "aleida", "rescindida", "distribuida", "excedida", "crisálida", "reerguida", "subdesenvolvida", "desabrida", "acrilamida", "estupida", "lenalidomida", "khálida", "volvida", "reconvertida", "cindida", "destruida", "constituida", "brigida", "incluida", "insculpida", "oxida", "nishida", "convalida", "desaquecida", "suthida", "ressequida", "desobedecida", "arrefecida", "obscurecida", "esbatida", "enzalutamida", "hiv-sida", "plácida", "lânguida", "implodida", "furosemida", "enraivecida", "reabastecida", "zida", "subentendida", "envaidecida", "imerecida", "pré-cozida", "desentendida", "civil/cedida", "enegrecida", "dorida", "subnutrida", "suspendida", "qaida", "entorpecida", "lollobrigida", "bem-resolvida", "desparecida", "tépida", "avida", "cara-pálida", "adida", "franzida", "frígida", "esquálida", "oneida", "apparecida", "bem-recebida", "ungida", "superaquecida", "khalida", "guarda-vida", "hibrida", "freida", "carrapaticida", "co-produzida", "dalida", "atribuida", "maida", "nida", "extendida", "atentado-suicida", "encardida", "marcha-corrida", "bombista-suicida", "substituida", "readmitida", "vilaneida", "cálida", "apalutamida", "intrometida", "okaida", "zoraida", "peida", "contra-partida", "descolorida", "clarida", "brízida", "abduzida", "áida", "apetecida", "persuadida", "marida", "distendida", "resistida", "solida", "revolvida", "ultra-rápida", "escorrida", "aramida", "comvida", "erodida", "inferida", "regicida", "reexibida", "protevida", "neida", "moraleida", "enchida", "enrustida", "sortida", "unidos", "partidos", "feridos", "pedidos", "envolvidos", "detidos", "conhecidos", "produzidos", "apreendidos", "bandidos", "estabelecidos", "vendidos", "ouvidos", "referidos", "arguidos", "oferecidos", "recebidos", "sentidos", "cometidos", "obtidos", "atingidos", "desenvolvidos", "reconhecidos", "escolhidos", "definidos", "seguidos", "atendidos", "desaparecidos", "vestidos", "adquiridos", "inseridos", "divididos", "recolhidos", "cumpridos", "tecidos", "rápidos", "transferidos", "sólidos", "reunidos", "ocorridos", "submetidos", "mantidos", "concedidos", "líquidos", "investidos", "perdidos", "proibidos", "válidos", "emitidos", "desconhecidos", "protegidos", "exigidos", "escondidos", "devidos", "exibidos", "sofridos", "surpreendidos", "nascidos", "conduzidos", "impedidos", "garantidos", "reduzidos", "fornecidos", "inquiridos", "resolvidos", "parecidos", "queridos", "punidos", "discutidos", "preferidos", "foragidos", "comprometidos", "promovidos", "vencidos", "comprimidos", "assumidos", "demitidos", "consumidos", "abrangidos", "coloridos", "óbidos", "expedidos", "recém-nascidos", "removidos", "permitidos", "suprimidos", "devolvidos", "híbridos", "dirigidos", "trazidos", "transmitidos", "esquecidos", "servidos", "movidos", "perseguidos", "socorridos", "geridos", "divertidos", "maridos", "colhidos", "retidos", "cedidos", "vividos", "agredidos", "assistidos", "abatidos", "corrigidos", "convencidos", "conseguidos", "corridos", "preenchidos", "contidos", "admitidos", "acolhidos", "debatidos", "rígidos", "redigidos", "regidos", "embutidos", "bem-sucedidos", "esclarecidos", "tidos", "apelidos", "acrescidos", "indevidos", "decididos", "sucedidos", "ácidos", "falecidos", "munidos", "convertidos", "repetidos", "interrompidos", "lidos", "distinguidos", "percorridos", "enchidos", "volvidos", "prometidos", "fluidos", "desfavorecidos", "absolvidos", "defendidos", "introduzidos", "ofendidos", "remetidos", "concebidos", "sugeridos", "rendidos", "abastecidos", "banidos", "requeridos", "favorecidos", "entendidos", "batidos", "idos", "traduzidos", "conferidos", "tímidos", "decorridos", "concorridos", "compreendidos", "medidos", "percebidos", "repartidos", "cozidos", "despedidos", "reproduzidos", "aminoácidos", "pretendidos", "despercebidos", "compridos", "erguidos", "revertidos", "absorvidos", "ávidos", "ressarcidos", "invadidos", "revestidos", "oprimidos", "corrompidos", "desiludidos", "combatidos", "confundidos", "estendidos", "desprotegidos", "auferidos", "proferidos", "aquecidos", "úmidos", "estúpidos", "aplaudidos", "distribuidos", "desprovidos", "respondidos", "agradecidos", "inválidos", "crescidos", "ingeridos", "aprendidos", "reprimidos", "temidos", "demolidos", "falidos", "deduzidos", "doidos", "mal-entendidos", "deferidos", "exercidos", "difundidos", "desmentidos", "constrangidos", "indeferidos", "mexidos", "metidos", "induzidos", "arrependidos", "surgidos", "fortalecidos", "revendidos", "nítidos", "deprimidos", "óxidos", "acometidos", "distorcidos", "consentidos", "pré-definidos", "refletidos", "diferidos", "advertidos", "envelhecidos", "coagidos", "esculpidos", "adormecidos", "engolidos", "gemidos", "rompidos", "invertidos", "providos", "preteridos", "desprevenidos", "latidos", "desferidos", "subdesenvolvidos", "aborrecidos", "comovidos", "enfraquecidos", "entupidos", "travestidos", "ardidos", "fugidos", "comidos", "seduzidos", "pré-estabelecidos", "destemidos", "escurecidos", "iludidos", "floridos", "reconduzidos", "aferidos", "incumbidos", "prevenidos", "despidos", "enriquecidos", "despendidos", "merecidos", "rescindidos", "lúcidos", "resumidos", "indefinidos", "empreendidos", "rebatidos", "omitidos", "explodidos", "fundidos", "entretidos", "intrépidos", "enlouquecidos", "restabelecidos", "atrevidos", "retorcidos", "varridos", "despromovidos", "incorridos", "húmidos", "descuidos", "precedidos", "espremidos", "reinvestidos", "expandidos", "aguerridos", "sórdidos", "desassistidos", "introvertidos", "acedidos", "desnutridos", "dissolvidos", "desvalidos", "acontecidos", "presididos", "adidos", "enfurecidos", "precavidos", "infligidos", "obedecidos", "comedidos", "transcorridos", "predefinidos", "grávidos", "estarrecidos", "havidos", "restringidos", "extrovertidos", "derretidos", "umedecidos", "tingidos", "inibidos", "empobrecidos", "áridos", "evadidos", "ilíquidos", "estampidos", "preestabelecidos", "presumidos", "reabastecidos", "doloridos", "controvertidos", "polidos", "imunodeprimidos", "compelidos", "repreendidos", "multicoloridos", "abolidos", "contundidos", "digeridos", "lípidos", "desabastecidos", "ressentidos", "reintroduzidos", "pruridos", "mordidos", "aludidos", "entristecidos", "ex-maridos", "repelidos", "desimpedidos", "rugidos", "vertidos", "descumpridos", "impelidos", "grunhidos", "incompreendidos", "readmitidos", "descabidos", "subdivididos", "sumidos", "expelidos", "avidos", "coligidos", "embebidos", "nutridos", "curtidos", "eidos", "exauridos", "extorquidos", "remidos", "zumbidos", "recém-promovidos", "impávidos", "coarguidos", "vívidos", "ungidos", "mórbidos", "correspondidos", "sabidos", "reinseridos", "bólidos", "coibidos", "pálidos", "repercutidos", "atribuidos", "subnutridos", "subidos", "amidos", "amadurecidos", "encolhidos", "incluidos", "desmedidos", "combalidos", "sortidos", "translúcidos", "antiácidos", "recorridos", "reflectidos", "bebidos", "torcidos", "antecedidos", "enaltecidos", "desparecidos", "alaridos", "reconvertidos", "pervertidos", "renhidos", "persuadidos", "empedernidos", "aduzidos", "garridos", "descoloridos", "ríspidos", "revividos", "dividos", "excedidos", "malsucedidos", "desapercebidos", "desinibidos", "supridos", "desunidos", "insculpidos", "flácidos", "embevecidos", "dispendidos", "aderidos", "apodrecidos", "endurecidos", "gélidos", "redefinidos", "validos", "lava-rápidos", "tolhidos", "esplêndidos", "enrustidos", "desprendidos", "enraivecidos", "inadimplidos", "franzidos", "divergidos", "sacudidos", "triglicéridos", "esgrimidos", "prosseguidos", "erigidos", "substituidos", "construidos", "abduzidos", "guarnecidos", "ensandecidos", "doridos", "dirimidos", "límpidos", "estupidos", "benzidos", "tremidos", "ultrarrápidos", "aturdidos", "aidos", "fervidos", "tórridos", "incutidos", "péptidos", "descomprometidos", "entorpecidos", "arrefecidos", "rapidos", "ex-detidos", "escorridos", "supreendidos", "infringidos", "peidos", "cuspidos", "cupidos", "premidos", "fétidos", "tripartidos", "renascidos", "subentendidos", "fingidos", "esquálidos", "hidróxidos", "candidatos/partidos", "hibridos", "recém-adquiridos", "cândidos", "encardidos", "dissuadidos", "desguarnecidos", "refugidos", "rangidos", "pré-medidos", "estados-unidos", "excluidos", "imunossuprimidos", "peróxidos", "desentendidos", "desentupidos", "amanhecidos", "apetecidos", "shidos", "cosidos", "erodidos", "fodidos", "fedidos", "paridos", "destruidos", "coproduzidos", "co-arguidos", "aparecidos", "adoecidos", "bem-nascidos", "intrometidos", "expendidos", "anti-partidos", "androidos", "enternecidos", "elegidos", "evolvidos", "imunocomprometidos", "insípidos", "obidos", "pré-preenchidos", "rediscutidos", "remexidos", "tchauqueridos", "pérfidos", "estalidos", "caleidos", "bem-recebidos", "lânguidos", "obscurecidos", "superaquecidos", "subvertidos", "pré-concebidos", "bipartidos", "contorcidos", "reestabelecidos", "inadmitidos", "rejuvenescidos", "ressequidos", "fudidos", "esbatidos", "desatendidos", "estadosunidos", "liquidos", "pré-cozidos", "preconcebidos", "urdidos", "super-rápidos", "revolvidos", "submergidos", "carcomidos", "embrutecidos", "dormidos", "bem-vestidos", "antipartidos", "afligidos", "constituidos", "reexibidos", "imprimidos", "resistidos", "inadvertidos", "hígidos", "distendidos", "enegrecidos", "autopropelidos", "autoinfligidos", "carecidos", "encarecidos", "inqueridos", "medidas", "dúvidas", "partidas", "unidas", "dívidas", "vidas", "bebidas", "feridas", "envolvidas", "conhecidas", "corridas", "oferecidas", "ouvidas", "apreendidas", "vendidas", "avenidas", "seguidas", "desenvolvidas", "obtidas", "atendidas", "detidas", "atingidas", "definidas", "produzidas", "rápidas", "recebidas", "estabelecidas", "grávidas", "protegidas", "desaparecidas", "recolhidas", "cumpridas", "comidas", "divididas", "devidas", "referidas", "mantidas", "escolhidas", "proibidas", "fornecidas", "reunidas", "torcidas", "lidas", "promovidas", "perdidas", "emitidas", "transmitidas", "escondidas", "subidas", "cometidas", "ocorridas", "coloridas", "desconhecidas", "reduzidas", "reconhecidas", "dirigidas", "discutidas", "preenchidas", "idas", "adquiridas", "investidas", "concedidas", "indevidas", "parecidas", "submetidas", "batidas", "contidas", "curtidas", "exigidas", "exibidas", "colhidas", "contrapartidas", "conduzidas", "dormidas", "proferidas", "adidas", "resolvidas", "salva-vidas", "repetidas", "divertidas", "inseridas", "válidas", "introduzidas", "suicidas", "rígidas", "transferidas", "compreendidas", "trazidas", "sofridas", "preferidas", "sólidas", "garantidas", "sentidas", "pedidas", "líquidas", "permitidas", "socorridas", "vividas", "esclarecidas", "assumidas", "descidas", "servidas", "interrompidas", "abrangidas", "nascidas", "comprometidas", "vencidas", "vestidas", "pesticidas", "reproduzidas", "defendidas", "esquecidas", "tidas", "removidas", "bem-sucedidas", "respondidas", "consumidas", "decididas", "queridas", "assistidas", "movidas", "debatidas", "impedidas", "prometidas", "sugeridas", "agredidas", "corrigidas", "acolhidas", "geridas", "sucedidas", "mexidas", "cedidas", "invadidas", "exercidas", "devolvidas", "acrescidas", "guarda-vidas", "conseguidas", "convertidas", "desfavorecidas", "duvidas", "punidas", "conferidas", "despedidas", "erguidas", "compridas", "requeridas", "inseticidas", "admitidas", "mordidas", "abastecidas", "retidas", "concebidas", "dividas", "difundidas", "surpreendidas", "abatidas", "leônidas", "aprendidas", "traduzidas", "híbridas", "favorecidas", "jazidas", "expedidas", "nítidas", "ardidas", "distinguidas", "concorridas", "demolidas", "entendidas", "despercebidas", "herbicidas", "estendidas", "tímidas", "midas", "combatidas", "distorcidas", "percebidas", "estúpidas", "remetidas", "perseguidas", "arguidas", "ácidas", "rebatidas", "homicidas", "inquiridas", "revertidas", "surgidas", "demitidas", "cozidas", "desprovidas", "percorridas", "banidas", "pretendidas", "ofendidas", "merecidas", "úmidas", "revestidas", "margaridas", "ingeridas", "desprotegidas", "repartidas", "aquecidas", "deferidas", "absorvidas", "esculpidas", "suprimidas", "húmidas", "foragidas", "empreendidas", "temidas", "deduzidas", "descabidas", "embutidas", "reprimidas", "induzidas", "presididas", "regidas", "acometidas", "refletidas", "envelhecidas", "convencidas", "confundidas", "apátridas", "rendidas", "desmentidas", "deprimidas", "falidas", "falecidas", "fungicidas", "fluidas", "fortalecidas", "pré-definidas", "floridas", "adormecidas", "invertidas", "áridas", "crescidas", "decorridas", "despidas", "recém-nascidas", "munidas", "indeferidas", "pré-estabelecidas", "engolidas", "precedidas", "aplaudidas", "entupidas", "ressarcidas", "fundidas", "desnutridas", "restabelecidas", "resumidas", "oprimidas", "supridas", "constrangidas", "descumpridas", "rompidas", "obedecidas", "límpidas", "prevenidas", "tecidas", "consentidas", "doidas", "travestidas", "indefinidas", "revendidas", "enfraquecidas", "hemorroidas", "ávidas", "auferidas", "contramedidas", "redigidas", "aborrecidas", "vertidas", "coagidas", "expelidas", "perseidas", "inválidas", "tira-dúvidas", "abolidas", "vívidas", "pelópidas", "omitidas", "atrevidas", "pré-concebidas", "desassistidas", "escurecidas", "dissolvidas", "multicoloridas", "volvidas", "havidas", "doloridas", "gélidas", "preestabelecidas", "restringidas", "preconcebidas", "polidas", "garridas", "ríspidas", "incumbidas", "superprotegidas", "empobrecidas", "tremidas", "expandidas", "genocidas", "lúcidas", "corrompidas", "subnutridas", "providas", "enriquecidas", "predefinidas", "renhidas", "absolvidas", "incorridas", "varridas", "larvicidas", "metidas", "aferidas", "enlouquecidas", "translúcidas", "desferidas", "preteridas", "leonidas", "retorcidas", "espremidas", "lambidas", "infligidas", "malsucedidas", "desmedidas", "controvertidas", "desiludidas", "sórdidas", "aguerridas", "aludidas", "pálidas", "tingidas", "fratricidas", "derretidas", "extrovertidas", "comprimidas", "ermidas", "comedidas", "correspondidas", "dirimidas", "digeridas", "inibidas", "insecticidas", "destemidas", "estremecidas", "druidas", "antecedidas", "subdivididas", "acedidas", "amadurecidas", "iludidas", "repercutidas", "nutridas", "endurecidas", "embebidas", "reflectidas", "redefinidas", "tórridas", "seduzidas", "explodidas", "advertidas", "bipartidas", "combalidas", "acontecidas", "agradecidas", "prosseguidas", "despendidas", "setevidas", "entretidas", "esplêndidas", "comovidas", "sabidas", "reintroduzidas", "despromovidas", "desprevenidas", "exauridas", "imunodeprimidas", "subdesenvolvidas", "sumidas", "distribuidas", "coibidas", "mórbidas", "arrependidas", "semiáridas", "leónidas", "introvertidas", "reabastecidas", "coligidas", "fugidas", "bactericidas", "apodrecidas", "enfurecidas", "construidas", "compelidas", "esbatidas", "enaltecidas", "hemorróidas", "incompreendidas", "sacudidas", "desapercebidas", "bandidas", "d?vidas", "retransmitidas", "liquidas", "gravidas", "saidas", "desinibidas", "almeidas", "desabastecidas", "encolhidas", "erigidas", "incluidas", "latrocidas", "decidas", "fétidas", "gemínidas", "sortidas", "repelidas", "pervertidas", "raticidas", "revividas", "desguarnecidas", "carótidas", "desparecidas", "flácidas", "guarnecidas", "oriónidas", "reestabelecidas", "enegrecidas", "cálidas", "excluidas", "excedidas", "extorquidas", "presumidas", "paridas", "irrefletidas", "reinseridas", "benzidas", "aderidas", "estupidas", "recorridas", "transcorridas", "diferidas", "destruidas", "escorridas", "fervidas", "bombistas-suicidas", "procedidas", "reconvertidas", "biocidas", "encardidas", "desimpedidas", "urdidas", "validas", "cuidas", "repreendidas", "quadrântidas", "enchidas", "ciberdúvidas", "amazônidas", "ceramidas", "reconduzidas", "precavidas", "impelidas", "imerecidas", "parótidas", "aquáridas", "envidas", "fingidas", "cosidas", "tolhidas", "tépidas", "descomprometidas", "aduzidas", "laxmidas", "infundidas", "reinvestidas", "semi-rápidas", "subvertidas", "incontidas", "descoloridas", "desobedecidas", "carrapaticidas", "hibridas", "ressentidas", "rediscutidas", "recém-adquiridas", "táuridas", "ultrarrápidas", "pré-preenchidas", "remexidas", "infringidas", "mal-sucedidas", "maldormidas", "carcomidas", "atribuidas", "bem-vestidas", "contra-medidas", "desprendidas", "cuspidas", "acendidas", "umedecidas", "fura-vidas", "ilíquidas", "insípidas", "malnutridas", "substituidas", "subentendidas", "pérfidas", "persuadidas", "rapidas", "sádidas", "inadimplidas", "lânguidas", "hébridas", "bastidas", "cândidas", "ensandecidas", "doridas", "tripartidas", "descurtidas", "amolecidas", "liberticidas", "oriônidas", "insculpidas", "reerguidas", "plácidas", "cefeidas", "aparecidas", "arrefecidas", "desatendidas", "concluidas", "esgrimidas", "erodidas", "esquálidas", "renascidas", "incumpridas", "incutidas", "obscurecidas", "líridas", "crisálidas", "ungidas", "arremetidas", "estarrecidas", "entorpecidas", "meias-medidas", "não-assistidas", "imprimidas", "reileonidas", "premidas", "solidas", "implodidas"];
};

var participles$3 = {};

Object.defineProperty(participles$3, "__esModule", {
	value: true
});

participles$3.default = function () {
	return ["abalienato", "abbacchiato", "abbacinato", "abbadato", "abbagliato", "abbaiato", "abballato", "abbambinato", "abbancato", "abbandonato", "abbarbagliato", "abbarbato", "abbarcato", "abbaruffato", "abbassato", "abbatacchiato", "abbattuto", "abbatuffolato", "abbelito", "abbellato", "abbellito", "abbendato", "abbeverato", "abbiadato", "abbicato", "abbigliato", "abbinato", "abbindolato", "abbioccato", "abbiosciato", "abbisciato", "abbittato", "abboccato", "abboffato", "abbominato", "abbonacciato", "abbonato", "abbonito", "abbordato", "abborracciato", "abborrato", "abborrito", "abbottinato", "abbottonato", "abbozzacchiato", "abbozzato", "abbozzolato", "abbracciato", "abbraciato", "abbrancato", "abbreviato", "abbriccato", "abbrigliato", "abbrivato", "abbriviato", "abbrividito", "abbronzato", "abbrostolato", "abbrostolito", "abbruciacchiato", "abbruciato", "abbrunato", "abbrunito", "abbruscato", "abbrusciato", "abbrustiato", "abbrustolato", "abbrustolito", "abbrutito", "abbruttito", "abbuffato", "abbuiato", "abbuonato", "abburattato", "abbuzzito", "abdicato", "abdotto", "abiettato", "abilitato", "abissato", "abitato", "abituato", "abiurato", "abolito", "abominato", "abondato", "aborrito", "abraso", "abrogato", "abusato", "accaffato", "accagionato", "accagliato", "accalappiato", "accalcato", "accaldato", "accallato", "accalorato", "accalorito", "accambiato", "accampato", "accampionato", "accanalato", "accanato", "accaneggiato", "accanito", "accantonato", "accaparrato", "accapezzato", "accapigliato", "accapottato", "accappiato", "accappiettato", "accapponato", "accappucciato", "accaprettato", "accareggiato", "accarezzato", "accarnato", "accarpionato", "accartocciato", "accasato", "accasciato", "accasellato", "accasermato", "accastellato", "accastellinato", "accatarrato", "accatastato", "accattato", "accattivato", "accavalcato", "accavalciato", "accavallato", "accavezzato", "accecato", "acceffato", "accelerato", "accellerato", "accennato", "accensato", "accentato", "accentrato", "accentuato", "acceppato", "accerchiato", "accercinato", "accertato", "acceso", "accessoriato", "accettato", "acchetato", "acchiappato", "acchiocciolato", "acchitato", "acchiuduto", "acciabattato", "acciaiato", "acciambellato", "acciarpato", "acciecato", "accigliato", "acciglionato", "accignuto", "accincignato", "accinto", "acciocchito", "acciottolato", "accipigliato", "accismato", "acciso", "acciucchito", "acciuffato", "accivettato", "acclamato", "acclarato", "acclimatato", "accluso", "accoccato", "accoccolato", "accoccovato", "accodato", "accollato", "accoltellato", "accolto", "accomandato", "accomiatato", "accommiatato", "accomodato", "accompagnato", "accomunato", "acconciato", "acconigliato", "accontato", "accontentato", "accoppato", "accoppiato", "accorato", "accorciato", "accorcito", "accordato", "accordellato", "accorpato", "accorto", "accosciato", "accostato", "accostumato", "accotonato", "accottimato", "accovacciato", "accovato", "accovonato", "accozzato", "accreditato", "accresciuto", "accrespato", "accucciato", "accucciolato", "accudito", "acculato", "acculturato", "accumulato", "accumunato", "accusato", "acetificato", "acetilato", "acetito", "acidato", "acidificato", "acidulato", "acquadernato", "acquarellato", "acquartierato", "acquato", "acquattato", "acquerellato", "acquetato", "acquietato", "acquisito", "acquistato", "acromatizzato", "acuito", "acuminato", "acutizzato", "adacquato", "adagiato", "adattato", "addaziato", "addebbiato", "addebitato", "addecimato", "addensato", "addentato", "addentellato", "addentrato", "addestrato", "addetto", "addiacciato", "addimandato", "addimesticato", "addimorato", "addimostrato", "addipanato", "addirizzato", "additato", "additivato", "addizionato", "addobbato", "addocilito", "addogliato", "addolcato", "addolciato", "addolcito", "addolorato", "addomandato", "addomesticato", "addoppiato", "addormentato", "addossato", "addotto", "addottorato", "addottrinato", "addrizzato", "adduato", "addugliato", "adeguato", "adempito", "adempiuto", "adequato", "aderizzato", "adescato", "adibito", "adirato", "adito", "adiuvato", "adizzato", "adocchiato", "adombrato", "adonato", "adonestato", "adontato", "adoperato", "adoprato", "adorato", "adornato", "adottato", "adsorbito", "aduggiato", "adugnato", "adulato", "adulterato", "adunato", "adunghiato", "adusato", "aerato", "aereato", "aerotrainato", "aerotrasportato", "affabulato", "affaccendato", "affacchinato", "affacciato", "affagottato", "affaldato", "affamato", "affamigliato", "affannato", "affardellato", "affascinato", "affastellato", "affaticato", "affattucchiato", "affatturato", "affermato", "afferrato", "affettato", "affezionato", "affiancato", "affiatato", "affibbiato", "affidato", "affienato", "affievolito", "affigliato", "affigurato", "affilato", "affilettato", "affiliato", "affinato", "affiochito", "affiorato", "affisato", "affissato", "affisso", "affittato", "affittito", "afflitto", "afflosciato", "affocato", "affogato", "affogliato", "affollato", "affoltato", "affondato", "afforcato", "afforestato", "afforzato", "affossato", "affralito", "affrancato", "affranto", "affratellato", "affrenato", "affrenellato", "affrescato", "affrettato", "affrittellato", "affrontato", "affumato", "affumicato", "affumigato", "affuocato", "affusolato", "africanizzato", "ageminato", "agevolato", "aggallato", "agganciato", "aggangherato", "aggarbato", "aggattonato", "aggavignato", "aggelato", "aggettivato", "agghiacciato", "agghiadato", "agghiaiato", "agghindato", "aggiaccato", "aggiogato", "aggiornato", "aggirato", "aggiucchito", "aggiudicato", "aggiuntato", "aggiunto", "aggiustato", "agglomerato", "agglutinato", "aggomitolato", "aggottato", "aggradito", "aggraffato", "aggranchiato", "aggranchito", "aggrandito", "aggrappato", "aggraticciato", "aggravato", "aggredito", "aggregato", "aggrevato", "aggricciato", "aggrinzato", "aggrinzito", "aggrommato", "aggrondato", "aggroppato", "aggrottato", "aggrovigliato", "aggrumato", "aggruppato", "aggruzzolato", "agguagliato", "agguantato", "agguardato", "agguatato", "aggueffato", "agitato", "agognato", "agrarizzato", "aguatato", "agucchiato", "agunato", "agurato", "aguzzato", "aitato", "aiutato", "aizzato", "alato", "alberato", "albergato", "alcalinizzato", "alchilato", "alchimiato", "alchimizzato", "alcolizzato", "alcoolizzato", "alenato", "alesato", "alettato", "alfabetato", "alfabetizzato", "alidito", "alienato", "alimentato", "allacciato", "allagato", "allappato", "allargato", "allascato", "allattato", "alleato", "allegato", "alleggerito", "alleggiato", "allegorizzato", "alleluiato", "allenato", "allenito", "allentato", "allertato", "allessato", "allestito", "allettato", "allevato", "alleviato", "allibato", "allibito", "allibrato", "allicciato", "allietato", "allindato", "allineato", "alliso", "allocato", "allogato", "alloggiato", "allontanato", "allottato", "allucchettato", "allucciolato", "allucinato", "allumato", "alluminato", "alluminiato", "allungato", "allupato", "alluso", "alluzzato", "alogenato", "alonato", "alpeggiato", "alterato", "alternato", "alzato", "amalgamato", "amareggiato", "amaricato", "amato", "ambientato", "ambiguato", "ambito", "americanizzato", "amicato", "ammaccato", "ammaestrato", "ammainato", "ammalato", "ammaliato", "ammalinconito", "ammaltato", "ammanettato", "ammanicato", "ammanierato", "ammanigliato", "ammannato", "ammannellato", "ammannito", "ammansato", "ammansito", "ammantato", "ammantellato", "ammarato", "ammarezzato", "ammassato", "ammassellato", "ammassicciato", "ammatassato", "ammattonato", "ammazzato", "ammelmato", "ammencito", "ammendato", "ammennicolato", "ammesso", "ammetato", "ammezzito", "amministrato", "amminutato", "ammirato", "ammiserito", "ammobiliato", "ammodernato", "ammodernizzato", "ammogliato", "ammoinato", "ammollato", "ammollito", "ammonito", "ammonticchiato", "ammonticellato", "ammorbato", "ammorbidato", "ammorbidito", "ammorsato", "ammortato", "ammortito", "ammortizzato", "ammorzato", "ammosciato", "ammoscito", "ammostato", "ammotinato", "ammucchiato", "ammulinato", "ammusato", "ammutato", "ammutinato", "amnistiato", "amoracciato", "ampiato", "ampliato", "amplificato", "amputato", "anagrammato", "analizzato", "anamorfizzato", "anastomizzato", "anatematizzato", "anatomizzato", "anchilosato", "anciso", "ancorato", "andatoseno", "andicappato", "anellato", "anemizzato", "anestetizzato", "angariato", "anglicizzato", "angolato", "angosciato", "angustiato", "animato", "annacquato", "annaffiato", "annasato", "annaspato", "annaspicato", "annebbiato", "annegato", "annerato", "annerito", "annesso", "annestato", "annichilato", "annichilito", "annidato", "annientato", "annitrito", "annobilito", "annodato", "annodicchiato", "annoiato", "annotato", "annottato", "annottolato", "annoverato", "annullato", "annunciato", "annunziato", "annusato", "annuvolato", "anodizzato", "anonimizzato", "anteceduto", "anteposto", "antergato", "anticheggiato", "antichizzato", "anticipato", "anticonosciuto", "antidatato", "antiveduto", "antivisto", "antologizzato", "antropizzato", "antropomorfizzato", "aocchiato", "aombrato", "aonestato", "aontato", "aperto", "apocopato", "apologizzato", "apostrofato", "appaciato", "appacificato", "appagato", "appaiato", "appalesato", "appallottolato", "appaltato", "appanettato", "appannato", "apparato", "apparecchiato", "apparentato", "apparigliato", "apparito", "appartato", "appassionato", "appastato", "appastellato", "appellato", "appennellato", "appercepito", "appertizzato", "appesantito", "appesito", "appeso", "appestato", "appetito", "appezzato", "appiacevolito", "appianato", "appiastrato", "appiatato", "appiattato", "appiattito", "appiccato", "appiccicato", "appiccolito", "appiedato", "appigionato", "appigliato", "appinzato", "appiombato", "appioppato", "appisolato", "applaudito", "applicato", "appoderato", "appoggiato", "appollaiato", "appoppato", "apportato", "appostato", "apposto", "appratito", "appresentato", "appreso", "appressato", "apprestato", "apprettato", "apprezzato", "approcciato", "approfittato", "approfondato", "approfondito", "approntato", "appropinquato", "appropriato", "approssimato", "approvato", "approvisionato", "approvvigionato", "appruato", "appulcrato", "appuntato", "appuntellato", "appuntito", "appurato", "appuzzato", "arabescato", "arabizzato", "arato", "arbitrato", "arborato", "arcaizzato", "arcato", "architettato", "archiviato", "arcuato", "ardito", "areato", "argentato", "arginato", "argomentato", "arguito", "arianizzato", "arieggiato", "armato", "armonizzato", "aromatizzato", "arpeggiato", "arpionato", "arponato", "arrabattato", "arraffato", "arraffiato", "arrandellato", "arrangiato", "arrapato", "arrapinato", "arrappato", "arrazzato", "arrecato", "arredato", "arreggimentato", "arrembato", "arrenato", "arresiso", "arreso", "arrestato", "arretrato", "arricchito", "arricciato", "arricciolato", "arriffato", "arringato", "arrischiato", "arrisicato", "arriso", "arrocato", "arroccato", "arrochito", "arrogato", "arrolato", "arroncato", "arronzato", "arrosato", "arrossato", "arrostato", "arrostito", "arrotato", "arrotolato", "arrotondato", "arrovellato", "arroventato", "arroventito", "arrovesciato", "arrubinato", "arruffato", "arruffianato", "arrugginito", "arruncigliato", "arruolato", "arruvidito", "arsicciato", "arso", "artefatto", "articolato", "artigliato", "asceso", "asciato", "asciolvuto", "asciugato", "ascoltato", "ascoso", "ascosto", "ascritto", "asfaltato", "asfissiato", "asperso", "aspettato", "aspirato", "asportato", "aspreggiato", "assaettato", "assaggiato", "assalito", "assaltato", "assaporato", "assaporito", "assassinato", "assecondato", "assecurato", "assediato", "asseggiato", "assegnato", "assembiato", "assemblato", "assembrato", "assemprato", "assentato", "asserito", "asserragliato", "asservito", "assestato", "assetato", "assettato", "asseverato", "assibilato", "assicurato", "assiderato", "assiemato", "assiepato", "assillato", "assimigliato", "assimilato", "assiomatizzato", "assiso", "assistito", "associato", "assodato", "assoggettato", "assolcato", "assoldato", "assolto", "assolutizzato", "assomato", "assommato", "assonato", "assonnato", "assopito", "assorbito", "assordato", "assordito", "assortito", "assottigliato", "assuefatto", "assunto", "asteggiato", "astenuto", "asterso", "astratto", "astretto", "atomizzato", "atrofizzato", "atrovato", "attaccato", "attagliato", "attanagliato", "attardato", "attediato", "atteggiato", "attempato", "attendato", "attentato", "attenuato", "attenuto", "attergato", "atterrato", "atterrito", "atterzato", "atteso", "attestato", "atticizzato", "attillato", "attinto", "attirato", "attivato", "attivizzato", "attizzato", "attorcigliato", "attorniato", "attorto", "attoscato", "attossicato", "attraccato", "attrappito", "attratto", "attraversato", "attrezzato", "attribuito", "attristato", "attristito", "attruppato", "attualizzato", "attuato", "attuffato", "attutato", "attutito", "auggiato", "augumentato", "augurato", "aulito", "aumentato", "aunghiato", "ausato", "auscultato", "auspicato", "autenticato", "autentificato", "autoaccusato", "autoaffondato", "autoalimentato", "autoassolto", "autocandidato", "autocensurato", "autocitato", "autocommiserato", "autoconsumato", "autoconvinto", "autodefinito", "autodenunciato", "autodistrutto", "autofinanziato", "autogestito", "autogovernato", "autografato", "autoincensato", "autointersecato", "autoinvitato", "autolesionato", "autolimitato", "automaticizzato", "automatizzato", "automotivato", "autonominato", "autoproclamato", "autoprodotto", "autoprotetto", "autopubblicato", "autopubblicizzato", "autoregolamentato", "autoregolato", "autoridotto", "autoriparato", "autorizzato", "autosomministrato", "autosostenuto", "autosuggestionato", "autotassato", "autotrapiantato", "autotrasportato", "autovalutato", "avallato", "avampato", "avanzato", "avariato", "avinto", "aviolanciato", "aviotrasportato", "avocato", "avolterato", "avulso", "avutacelo", "avuto", "avvalorato", "avvalso", "avvantaggiato", "avvelato", "avvelenato", "avventato", "avventurato", "avverato", "avversato", "avvertito", "avvezzato", "avviato", "avvicendato", "avvicinato", "avvignato", "avvilito", "avviluppato", "avvinato", "avvinchiato", "avvinghiato", "avvinto", "avvisato", "avvistato", "avvitato", "avviticchiato", "avvitito", "avvivato", "avvolto", "avvoltolato", "aziendalizzato", "azionato", "azotato", "azzannato", "azzardato", "azzeccato", "azzerato", "azzimato", "azzittato", "azzittito", "azzoppato", "azzoppito", "azzuffato", "azzurrato", "bacato", "baccagliato", "bacchettato", "bacchiato", "baciato", "badato", "bagnato", "baipassato", "balbettato", "balcanizzato", "ballato", "baloccato", "balzato", "banalizzato", "bancato", "bandito", "bannato", "baraccato", "barattato", "barbarizzato", "barcamenato", "bardato", "barellato", "barrato", "barricato", "basato", "basciato", "basculato", "bassato", "bastato", "bastionato", "bastito", "bastonato", "battezzato", "battuto", "bazzicato", "beatificato", "beato", "beccato", "beccheggiato", "becchettato", "beffato", "beffeggiato", "bendato", "benedetto", "beneficato", "benvoluto", "berlusconizzato", "bersagliato", "bestemmiato", "bevuto", "biadato", "bianchettato", "bianchito", "biascicato", "biasimato", "biasmato", "bidonato", "biennalizzato", "biforcato", "bigiato", "bilanciato", "binato", "bindolato", "biodegradato", "biografato", "bipartito", "bisbigliato", "biscottato", "bisecato", "bisellato", "bisognato", "bissato", "bistrato", "bistrattato", "bitumato", "bituminato", "blandito", "bleffato", "blindato", "bloccato", "bobinato", "boccheggiato", "bocciato", "boicottato", "bollato", "bollito", "bombardato", "bombato", "bonderizzato", "bonificato", "bootato", "borbottato", "bordato", "boriato", "borrato", "borseggiato", "braccato", "bracciato", "bramato", "bramito", "brancicato", "brandeggiato", "brandito", "brasato", "bravato", "brevettato", "breviato", "brillantato", "brillato", "brinato", "broccato", "brocciato", "broccolato", "brontolato", "bronzato", "brucato", "bruciacchiato", "bruciato", "brunito", "bruscato", "bruschinato", "brutalizzato", "bruttato", "bucato", "bucherellato", "bufato", "buffato", "bufferizzato", "buggerato", "bugnato", "bulicato", "bulinato", "bullettato", "bullonato", "burattato", "burlato", "burocratizzato", "burrificato", "buscato", "buttato", "butterato", "bypassato", "cablato", "cabrato", "cacato", "cacciato", "cadenzato", "cadmiato", "caducato", "cagato", "caggiato", "cagionato", "cagliato", "calafatato", "calamitato", "calandrato", "calato", "calcato", "calciato", "calcificato", "calcolato", "caldeggiato", "calettato", "calibrato", "calmato", "calmierato", "calpestato", "calumato", "calunniato", "calzato", "cambiato", "camerato", "campionato", "campito", "camuffato", "canalizzato", "cancellato", "cancerizzato", "candeggiato", "candidato", "candito", "canforato", "cangiato", "cannato", "canneggiato", "cannibalizzato", "cannoneggiato", "canonizzato", "cantato", "canterellato", "canticchiato", "cantilenato", "canzonato", "caolinizzato", "capacitato", "capeggiato", "capillarizzato", "capitalizzato", "capitanato", "capitaneggiato", "capito", "capitozzato", "capivolto", "caponato", "capotato", "capottato", "capovolto", "capponato", "captato", "caramellato", "caramellizzato", "caratato", "caratterizzato", "carbonizzato", "carbossilato", "carburato", "carcato", "carcerato", "cardato", "carenato", "carezzato", "cariato", "caricato", "caricaturato", "caricaturizzato", "carotato", "carpionato", "carpito", "carreggiato", "carrozzato", "cartavetrato", "carteggiato", "cartellinato", "cartografato", "cartolarizzato", "cartonato", "cascolato", "cassato", "casso", "castigato", "castrato", "casualizzato", "catabolizzato", "catalizzato", "catalogato", "catapultato", "catechizzato", "categorizzato", "cateterizzato", "catramato", "cattolicizzato", "catturato", "causato", "cautelato", "cauterizzato", "cauzionato", "cavalcato", "cavataselo", "cavato", "cazzato", "cazziato", "cazzottato", "cedrato", "ceduto", "celato", "celebrato", "cellofanato", "cementato", "cementificato", "cennato", "censito", "censurato", "centellato", "centellinato", "centimetrato", "centinato", "centralizzato", "centrato", "centrifugato", "centuplicato", "cerato", "cercato", "cerchiato", "cernuto", "certificato", "cesellato", "cessato", "cestinato", "cheratinizzato", "chetato", "chiamato", "chiappato", "chiarificato", "chiarito", "chiaroscurato", "chiavato", "chiazzato", "chiesto", "chilificato", "chilometrato", "chimificato", "chinato", "chinizzato", "chiodato", "chiosato", "chiuso", "choccato", "ciancicato", "cianfrinato", "cianfrugliato", "ciangottato", "ciattato", "cibato", "cicatrizzato", "ciccato", "cicchettato", "ciclizzato", "ciclostilato", "cifrato", "cilindrato", "cimato", "cimentato", "cincischiato", "cinematografato", "cintato", "cinto", "cioncato", "ciondolato", "circolato", "circoncinto", "circonciso", "circondato", "circondotto", "circonflesso", "circonfluito", "circonfuso", "circonscritto", "circonvenuto", "circoscritto", "circostanziato", "circuito", "circumcinto", "circumnavigato", "citato", "ciucciato", "ciurmato", "civettato", "civilizzato", "clamato", "classato", "classicizzato", "classificato", "cliccato", "climatizzato", "clivato", "clonato", "cloroformizzato", "clorurato", "clusterizzato", "co-diretto", "coacervato", "coadiuvato", "coagulato", "coalizzato", "coartato", "coccolato", "codificato", "coeditato", "coesistito", "cofinanziato", "cofirmato", "cofondato", "cogestito", "cogitato", "coglionato", "cognosciuto", "coibentato", "coinciso", "cointeressato", "cointestato", "coinvolto", "cokificato", "colato", "colettato", "collassato", "collaudato", "collazionato", "collegato", "collettivizzato", "collezionato", "collimato", "colliquato", "colliso", "collocato", "colluttato", "colmato", "colonizzato", "colorato", "colorito", "colorizzato", "colpevolizzato", "colpito", "coltellato", "coltivato", "colto", "coltrato", "comandato", "combattuto", "combinato", "comburuto", "comicizzato", "cominciato", "commemorato", "commendato", "commensurato", "commentato", "commercializzato", "commesso", "comminato", "commiserato", "commissariato", "commissionato", "commisurato", "commosso", "commutato", "comodato", "compaginato", "comparito", "compartimentalizzato", "compartito", "compassionato", "compatibilizzato", "compatito", "compattato", "compendiato", "compenetrato", "compensato", "comperato", "compiaciuto", "compianto", "compilato", "compitato", "compiuto", "complessato", "complessificato", "complesso", "completato", "complicato", "complimentato", "comportato", "compostato", "composto", "comprato", "compravenduto", "compreso", "compresso", "compromesso", "comprovato", "compulsato", "compunto", "computato", "computerizzato", "comunicato", "comunistizzato", "concatenato", "conceduto", "concelebrato", "concentrato", "concepito", "concertato", "concesso", "concettato", "concettualizzato", "conchiuso", "conciato", "conciliato", "concimato", "concitato", "conclamato", "concluso", "concordato", "concotto", "concretato", "concretizzato", "conculcato", "concupito", "condannato", "condensato", "condito", "condiviso", "condizionato", "condoluto", "condonato", "condotto", "confatto", "confederato", "conferito", "confermato", "confessato", "confettato", "confezionato", "conficcato", "confidato", "configurato", "confinato", "confinto", "confiscato", "confitto", "conformato", "confortato", "confricato", "confrontato", "confuso", "confutato", "congedato", "congegnato", "congelato", "congestionato", "congetturato", "congiunto", "conglobato", "conglomerato", "conglutinato", "congratulato", "congregato", "conguagliato", "coniato", "coniugato", "connaturato", "connesso", "connotato", "connumerato", "conosciuto", "conquistato", "consacrato", "consapevolizzato", "consegnato", "conseguito", "consentito", "conservato", "considerato", "consigliato", "consistito", "consociato", "consolato", "consolidato", "consorziato", "consparso", "consperso", "constatato", "constretto", "construito", "consultato", "consumato", "consunto", "contabilizzato", "contagiato", "containerizzato", "contaminato", "contato", "contattato", "conteggiato", "contemperato", "contemplato", "contentato", "contenuto", "conteso", "contestato", "contestualizzato", "contingentato", "continuato", "contornato", "contorto", "contrabbandato", "contraccambiato", "contraddetto", "contraddistinto", "contradetto", "contraffatto", "contrappesato", "contrapposto", "contrappuntato", "contrariato", "contrassegnato", "contrastato", "contrato", "contrattaccato", "contrattato", "contratto", "contravvalso", "contristato", "controbattuto", "controbilanciato", "controdatato", "controfirmato", "controindicato", "controllato", "controminato", "contronotato", "controproposto", "controprovato", "controquerelato", "controsoffittato", "controstampato", "controventato", "conturbato", "contuso", "convalidato", "convenuto", "convenzionato", "convertito", "convinto", "convitato", "convocato", "convogliato", "convolto", "coobato", "cooptato", "coordinato", "coperchiato", "coperto", "copiaincollato", "copiato", "copolimerizzato", "coppellato", "coprodotto", "corazzato", "corbellato", "corcato", "cordonato", "coreografato", "coricato", "cornificato", "coronato", "corredato", "correlato", "corresponsabilizzato", "corretto", "corricchiato", "corrisposto", "corroborato", "corroso", "corrotto", "corrucciato", "corrugato", "corso", "corteato", "corteggiato", "cortocircuitato", "coruscato", "cosato", "coscritto", "cosparso", "cosperso", "costatato", "costeggiato", "costellato", "costernato", "costicchiato", "costipato", "costituito", "costituzionalizzato", "costretto", "costruito", "costudito", "cotonato", "cotto", "covato", "coventrizzato", "coverchiato", "craccato", "creato", "creduto", "cremato", "crepato", "cresciuto", "cresimato", "crespato", "criminalizzato", "crioconcentrato", "criptato", "cristallizzato", "cristianizzato", "criticato", "crittato", "crittografato", "crivellato", "crocchiato", "crocefisso", "crocefitto", "crocifisso", "crocifitto", "crogiolato", "cromato", "cronicizzato", "cronometrato", "crostato", "crucciato", "crucifisso", "crucifitto", "cuccato", "cucinato", "cucito", "cullato", "cumulato", "cuntato", "curato", "curvato", "curvato", "custodito", "customizzato", "damascato", "damaschinato", "damato", "dannato", "danneggiato", "danzato", "dardeggiato", "datato", "dato", "dattilografato", "dattiloscritto", "daziato", "deacidificato", "deattivato", "debbiato", "debellato", "debilitato", "decaffeinato", "decaffeinizzato", "decalcato", "decalcificato", "decantato", "decapato", "decapitato", "decappottato", "decarbossilato", "decarburato", "decatizzato", "decelerato", "decentralizzato", "decentrato", "decerebrato", "decernuto", "decespugliato", "deciferato", "decifrato", "decimalizzato", "decimato", "deciso", "declamato", "declassato", "declassificato", "declinato", "declorato", "decodificato", "decolonizzato", "decolorato", "decompartimentato", "decompilato", "decomposto", "decompresso", "deconcentrato", "decondizionato", "decongelato", "decongestionato", "decontaminato", "decontestualizzato", "decontratto", "decorato", "decorticato", "decostruito", "decrementato", "decretato", "decriminalizzato", "decriptato", "decrittato", "decuplicato", "decurtato", "dedicato", "dedotto", "defacciato", "defalcato", "defascistizzato", "defecato", "defenestrato", "deferito", "defilato", "definito", "defiscalizzato", "defitto", "deflazionato", "deflemmato", "deflorato", "defogliato", "defoliato", "deforestato", "deformato", "defosforato", "defosforilato", "deframmentato", "defraudato", "degassato", "degassificato", "deglutito", "degnato", "degradato", "degustato", "deidratato", "deidrogenato", "deificato", "deindicizzato", "deindustrializzato", "deionizzato", "delegato", "delegificato", "delegittimato", "delibato", "deliberato", "delimitato", "delineato", "delirato", "deliziato", "delocalizzato", "delucidato", "deluso", "demagnetizzato", "demandato", "demanializzato", "demarcato", "demeritato", "demerso", "demetallizzato", "demilitarizzato", "demineralizzato", "demistificato", "demitizzato", "democratizzato", "demodulato", "demolito", "demoltiplicato", "demonetato", "demonetizzato", "demonizzato", "demoralizzato", "demorso", "demotivato", "denaturalizzato", "denaturato", "denazificato", "denazionalizzato", "denicotinizzato", "denigrato", "denitrificato", "denocciolato", "denominato", "denotato", "dentellato", "denuclearizzato", "denudato", "denunciato", "denunziato", "deodorato", "deossidato", "deossigenato", "deostruito", "depauperato", "depenalizzato", "depennato", "depilato", "depinto", "depistato", "deplorato", "depolarizzato", "depolimerizzato", "depoliticizzato", "depolverizzato", "deportato", "depositato", "deposto", "depotenziato", "depravato", "deprecato", "depredato", "depresso", "depressurizzato", "deprezzato", "deprivato", "deprotonato", "depulso", "depurato", "dequalificato", "deratizzato", "derattizzato", "dereferenziato", "deregolamentato", "deregolato", "derequisito", "deresponsabilizzato", "deriso", "derubato", "derubricato", "desacralizzato", "desalato", "desalinizzato", "descolarizzato", "descritto", "desecretato", "desegretato", "deselezionato", "desensibilizzato", "desessualizzato", "desiato", "desiderato", "designato", "desinato", "desirato", "desolato", "desolforato", "desonorizzato", "desorbito", "desossidato", "desquamato", "destabilizzato", "destagionalizzato", "destalinizzato", "destatalizzato", "destatizzato", "destato", "destinato", "destituito", "destoricizzato", "destreggiato", "destrutto", "destrutturato", "desunto", "detassato", "detenuto", "deteriorato", "determinato", "deterso", "detestato", "detonato", "detorto", "detossificato", "detratto", "detronizzato", "dettagliato", "dettato", "detto", "deturpato", "deumidificato", "devastato", "deventato", "deviato", "deviscerato", "devitalizzato", "devitaminizzato", "devoluto", "dezippato", "diaframmato", "diagnosticato", "diagonalizzato", "diagrammato", "dializzato", "dialogato", "dialogizzato", "diazotato", "dibattuto", "diboscato", "dichiarato", "diesato", "diesizzato", "difeso", "diffamato", "differito", "diffidato", "diffranto", "diffratto", "diffuso", "digerito", "digitalizzato", "digitato", "digiunto", "digrassato", "digrignato", "digrossato", "dilacerato", "dilaniato", "dilapidato", "dilatato", "dilavato", "dilazionato", "dileggiato", "dileguato", "dilettato", "diletto", "diliscato", "dilucidato", "diluito", "dilungato", "dimagrato", "dimandato", "dimenato", "dimensionato", "dimenticato", "dimerizzato", "dimesso", "dimezzato", "diminuito", "dimissionato", "dimostrato", "dimunto", "dinamizzato", "dinoccato", "dipanato", "dipelato", "dipinto", "diplomato", "diposto", "diradato", "diramato", "diretto", "direzionato", "dirimuto", "diroccato", "dirottato", "dirotto", "dirozzato", "disabilitato", "disabituato", "disaccentato", "disaccoppiato", "disaccordato", "disacerbato", "disacidato", "disacidificato", "disacidito", "disaerato", "disaffezionato", "disaggregato", "disalberato", "disallineato", "disamato", "disambiguato", "disaminato", "disamorato", "disancorato", "disanimato", "disappannato", "disapplicato", "disappreso", "disapprovato", "disarcionato", "disarmato", "disarticolato", "disascosto", "disassemblato", "disassuefatto", "disatomizzato", "disatteso", "disattivato", "disattrezzato", "disavvezzato", "disboscato", "disbrigato", "discacciato", "discalzato", "discantato", "discaricato", "discernuto", "disceso", "disceverato", "dischiesto", "dischiuso", "discinto", "disciolto", "disciplinato", "discolorato", "discolpato", "discommesso", "discompagnato", "discomposto", "disconcluso", "disconfitto", "discongiunto", "disconnesso", "disconosciuto", "discoperto", "discordato", "discosceso", "discostato", "discreditato", "discresciuto", "discriminato", "discritto", "discucito", "discuoiato", "discusso", "disdegnato", "disdettato", "disdetto", "diseccato", "diseccitato", "diseducato", "disegnato", "diserbato", "diseredato", "disertato", "diserto", "disfatto", "disgelato", "disgiunto", "disgraziato", "disgregato", "disgustato", "disidentificato", "disiderato", "disidratato", "disilluso", "disimballato", "disimparato", "disimpegnato", "disimpresso", "disincagliato", "disincantato", "disincentivato", "disincrostato", "disindustrializzato", "disinfestato", "disinfettato", "disinflazionato", "disinformato", "disingannato", "disingranato", "disinibito", "disinnamorato", "disinnescato", "disinnestato", "disinquinato", "disinserito", "disinstallato", "disintasato", "disintegrato", "disinteressato", "disinteso", "disintossicato", "disinvestito", "disinvolto", "disistimato", "dislocato", "dismesso", "disobbedito", "disobbligato", "disonorato", "disordinato", "disorganizzato", "disorientato", "disormeggiato", "disossato", "disossidato", "disostruito", "disotterrato", "disparito", "dispensato", "dispento", "disperduto", "disperso", "dispeso", "dispiegato", "dispinto", "dispogliato", "disposto", "dispregiato", "disprezzato", "dispromesso", "disproporzionato", "disputato", "disqualificato", "disrotto", "dissacrato", "dissalato", "dissaldato", "dissanguato", "dissecato", "disseccato", "disselciato", "dissellato", "disseminato", "dissepolto", "disseppellito", "dissequestrato", "disserrato", "dissestato", "dissetato", "dissezionato", "dissigillato", "dissimulato", "dissipato", "dissociato", "dissodato", "dissolto", "dissomigliato", "dissotterrato", "dissuaso", "dissuggellato", "distaccato", "distanziato", "disteso", "distillato", "distinto", "distolto", "distorto", "distratto", "distretto", "distribuito", "districato", "distrigato", "distrutto", "disturbato", "disubbidito", "disumanato", "disumanizzato", "disunito", "disusato", "disveduto", "disvelato", "disvestito", "disviato", "disvisto", "disvolto", "disvoluto", "dittongato", "divallato", "divaricato", "divelto", "diversificato", "divertito", "divezzato", "divinato", "divincolato", "divinizzato", "diviso", "divolto", "divorato", "divorziato", "divulgato", "documentato", "dogato", "dogmatizzato", "dolcificato", "dollarizzato", "dolorato", "doluto", "domandato", "domato", "domesticato", "domiciliato", "dominato", "donato", "dondolato", "dopato", "doppiato", "dorato", "dormitoco", "dosato", "dotato", "dovuto", "dragato", "drammatizzato", "drappeggiato", "drenato", "dribblato", "drizzato", "drogato", "dugliato", "duplicato", "duramificato", "ebraizzato", "ecceduto", "eccepito", "eccettuato", "eccitato", "echeggiato", "eclissato", "economizzato", "edificato", "editato", "edotto", "educato", "edulcorato", "effettuato", "efficientato", "effigiato", "effinto", "effluito", "effuso", "egemonizzato", "eguagliato", "eiettato", "elaborato", "elargito", "elasticizzato", "elementarizzato", "elemosinato", "elencato", "eletto", "elettrificato", "elettrizzato", "elettrocoagulato", "elettrolizzato", "elevato", "eliminato", "eliso", "elitrasportato", "ellenizzato", "elogiato", "elucidato", "elucubrato", "eluito", "eluso", "emanato", "emancipato", "emarginato", "embricato", "emendato", "emesso", "emozionato", "empito", "empiuto", "emulato", "emulsionato", "emunto", "encomiato", "endocitato", "energizzato", "enfatizzato", "enfiato", "entusiasmato", "enucleato", "enumerato", "enunciato", "epicureggiato", "epurato", "equalizzato", "equilibrato", "equipaggiato", "equiparato", "eradicato", "eraso", "ereditato", "eretto", "erogato", "eroicizzato", "eroso", "erotizzato", "erpicato", "erso", "erudito", "eruttato", "esacerbato", "esagerato", "esagitato", "esalato", "esaltato", "esaminato", "esasperato", "esaudito", "esaurito", "esautorato", "esborsato", "escluso", "escogitato", "escomiato", "escoriato", "escosso", "escusso", "esecrato", "esecutato", "eseguito", "esemplificato", "esentato", "esercitato", "esfoliato", "esibito", "esilarato", "esiliato", "esimuto", "esitato", "esonerato", "esorbitato", "esorcizzato", "esortato", "espanso", "esparso", "esperimentato", "esperito", "espettorato", "espiantato", "espiato", "espirato", "espletato", "esplicato", "esplicitato", "esplorato", "esploso", "esportato", "esposto", "espresso", "espropriato", "espugnato", "espulso", "espunto", "espurgato", "essiccato", "essuto", "estasiato", "estenuato", "esterificato", "esteriorizzato", "esterminato", "esternalizzato", "esternato", "esteso", "estimato", "estinto", "estirpato", "estivato", "estorto", "estradato", "estraniato", "estrapolato", "estratto", "estremizzato", "estrinsecato", "estromesso", "estruso", "estubato", "esulcerato", "esultato", "esumato", "eterificato", "eterizzato", "eternato", "eternizzato", "etichettato", "etossilato", "euforizzato", "europeizzato", "evacuato", "evangelizzato", "evaso", "eveto", "evidenziato", "evinto", "evirato", "eviscerato", "evitato", "evocato", "evolto", "evoluto", "evulso", "fabbricato", "faccettato", "facilitato", "fagocitato", "falciato", "falcidiato", "fallito", "falsato", "falsificato", "familiarizzato", "fanatizzato", "fantasticato", "farcito", "farfugliato", "fasciato", "fascicolato", "fascistizzato", "fattacelo", "fatto", "fattorizzato", "fatturato", "favellato", "favoreggiato", "favorito", "faxato", "fecondato", "fedecommesso", "federalizzato", "federato", "felicitato", "felpato", "feltrato", "femminilizzato", "fenduto", "ferito", "fermato", "fermentato", "ferrato", "fertilizzato", "fesso", "fessurato", "festeggiato", "festonato", "feudalizzato", "fiaccato", "fiammeggiato", "fiancheggiato", "ficcato", "fidanzato", "fidato", "fidecommesso", "fidelizzato", "figliato", "figurato", "filato", "filettato", "filmato", "filosofato", "filtrato", "finalizzato", "finanziato", "finitalo", "finito", "finlandizzato", "fintato", "finto", "fiocinato", "fiondato", "fiorettato", "firmato", "fiscalizzato", "fischiato", "fischiettato", "fissato", "fissionato", "fitto", "fiutato", "flagellato", "flaggato", "flambato", "flangiato", "flemmatizzato", "flesso", "flippato", "flottato", "fluidificato", "fluidizzato", "fluorizzato", "fluorurato", "focalizzato", "focheggiato", "foderato", "foggiato", "fognato", "folgorato", "follato", "fomentato", "fonato", "fondato", "foracchiato", "foraggiato", "forato", "forestato", "forfettizzato", "forgiato", "formalizzato", "formato", "formattato", "formilato", "formulato", "fornito", "fortificato", "forviato", "forwardato", "forzato", "fosfatato", "fosforato", "fosforilato", "fossilizzato", "fotocomposto", "fotocopiato", "fotografato", "fottuto", "fracassato", "frainteso", "framesso", "frammentato", "frammesso", "frammezzato", "frammischiato", "franceseggiato", "francesizzato", "frangiato", "franto", "frantumato", "frappato", "frapposto", "fraseggiato", "frastagliato", "frastornato", "fratturato", "frazionato", "freddato", "fregato", "fregiato", "frenato", "frequentato", "fresato", "frettato", "friendzonato", "fritto", "frizionato", "frodato", "frollato", "fronteggiato", "frugato", "fruito", "frullato", "frusciato", "frustato", "frustrato", "fruttato", "fucilato", "fucinato", "fugato", "fuggito", "fulminato", "fumato", "fumigato", "funestato", "funto", "funzionato", "fuoriuscito", "fuorviato", "fuso", "fustellato", "fustigato", "gabbato", "gabellato", "gallato", "gallicizzato", "gallonato", "galvanizzato", "gambizzato", "garantito", "garnettato", "garrotato", "garzato", "gasato", "gassato", "gassificato", "gazato", "gelatinizzato", "gelato", "gelificato", "gemellato", "gemicato", "geminato", "generalizzato", "generato", "gentrificato", "genuflesso", "geometrizzato", "georeferenziato", "gerarchizzato", "germanizzato", "gestito", "gettato", "gettonato", "ghermito", "ghettizzato", "ghigliottinato", "ghindato", "gibollato", "gingillato", "ginnato", "giocato", "gioito", "gionglato", "giovaneggiato", "girandolato", "girato", "giudicato", "giulebbato", "giuntato", "giunto", "giuracchiato", "giurato", "giustapposto", "giustificato", "giustiziato", "glamourizzato", "glassato", "glissato", "globalizzato", "gloriato", "glorificato", "glossato", "godronato", "goduto", "goffrato", "gommato", "gonfiato", "googlato", "gottato", "governato", "gradinato", "gradito", "gradualizzato", "graduato", "graffato", "graffiato", "graffito", "graficato", "grafitato", "gramolato", "granagliato", "grandinato", "granellato", "granito", "granulato", "graticciato", "graticolato", "gratificato", "gratinato", "grattato", "grattugiato", "gravato", "graziato", "grecheggiato", "grecizzato", "gremito", "gridato", "griffato", "grigliato", "grippato", "groccato", "grondato", "grugato", "grugnito", "guadagnato", "gualcito", "guardato", "guarito", "guarnito", "guastato", "guatato", "guerreggiato", "gufato", "guidato", "gustato", "hackerato", "handicappato", "ibridato", "idealizzato", "ideato", "identificato", "ideologizzato", "idolatrato", "idoleggiato", "idratato", "idrogenato", "idrolizzato", "iettato", "igienizzato", "ignifugato", "ignorato", "illanguidito", "illeggiadrito", "illividito", "illuminato", "illuso", "illustrato", "imbacuccato", "imbaldanzito", "imballato", "imbalsamato", "imbambolato", "imbandierato", "imbandito", "imbarbarito", "imbarcato", "imbarilato", "imbastardito", "imbastito", "imbattuto", "imbavagliato", "imbeccato", "imbellettato", "imbellito", "imbestialito", "imbestiato", "imbevuto", "imbiaccato", "imbiancato", "imbianchito", "imbibito", "imbiettato", "imbiondito", "imbizzarrito", "imboccato", "imbonito", "imborghesito", "imboscato", "imboschito", "imbottato", "imbottigliato", "imbottito", "imbozzimato", "imbracato", "imbracciato", "imbragato", "imbrancato", "imbrattato", "imbrecciato", "imbrigliato", "imbrillantinato", "imbroccato", "imbrodato", "imbrogliato", "imbronciato", "imbruttito", "imbucato", "imbudellato", "imbullettato", "imbullonato", "imburrato", "imbussolato", "imbustato", "imbutito", "imitato", "immagazzinato", "immaginato", "immalinconito", "immatricolato", "immedesimato", "immerso", "immesso", "immischiato", "immiserito", "immobilizzato", "immolato", "immortalato", "immunizzato", "immusonito", "impaccato", "impacchettato", "impacciato", "impadronito", "impaginato", "impagliato", "impalato", "impalcato", "impallato", "impallinato", "impalmato", "impaludato", "impanato", "impaniato", "impannato", "impantanato", "impaperato", "impapocchiato", "impappinato", "imparentato", "imparruccato", "impartito", "impastato", "impasticcato", "impasticciato", "impastocchiato", "impastoiato", "impataccato", "impattato", "impaurito", "impavesato", "impeciato", "impedicato", "impedito", "impegnato", "impegolato", "impelagato", "impellicciato", "impennacchiato", "impennato", "impensierito", "impepato", "imperlato", "impermalito", "impermeabilizzato", "imperniato", "impersonato", "impersonificato", "impestato", "impetrato", "impiallacciato", "impiantato", "impiastrato", "impiastricciato", "impiccato", "impicciato", "impicciolito", "impiccolito", "impidocchiato", "impiegato", "impietosito", "impietrito", "impigliato", "impigrito", "impilato", "impillaccherato", "impinguato", "impinto", "impinzato", "impiombato", "impipato", "impiumato", "implementato", "implicato", "implorato", "impollinato", "impolpato", "impoltronito", "impolverato", "impomatato", "imporcato", "imporporato", "importato", "importunato", "impossessato", "impossibilitato", "impostato", "imposto", "impratichito", "impregnato", "impreso", "impressionato", "impresso", "imprestato", "impreziosito", "imprigionato", "impromesso", "improntato", "improsciuttito", "impugnato", "impuntito", "impunturato", "impupato", "imputato", "impuzzolentito", "inabilitato", "inabissato", "inacerbito", "inacetito", "inacidito", "inacutito", "inaffiato", "inalato", "inalberato", "inalveato", "inalzato", "inamidato", "inanellato", "inarcato", "inargentato", "inaridito", "inasprito", "inastato", "inattivato", "inaugurato", "incacchiato", "incalcinato", "incalorito", "incalzato", "incamerato", "incamiciato", "incamminato", "incanaglito", "incanalato", "incannato", "incannucciato", "incaponito", "incappottato", "incappucciato", "incaprettato", "incapricciato", "incapsulato", "incarcerato", "incardinato", "incaricato", "incarnato", "incarrozzato", "incartato", "incartocciato", "incartonato", "incasellato", "incasinato", "incassato", "incastellato", "incastonato", "incastrato", "incatenato", "incatramato", "incattivito", "incavato", "incavigliato", "incavolato", "incazzato", "incellofanato", "incendiato", "incenerito", "incensato", "incentivato", "incentrato", "inceppato", "incerato", "incernierato", "incerottato", "inceso", "incettato", "inchiappettato", "inchiavardato", "inchiesto", "inchinato", "inchiodato", "inchiostrato", "incipriato", "inciso", "incistato", "incitato", "inciuccato", "incivilito", "inclinato", "incluso", "incoccato", "incocciato", "incoiato", "incollato", "incolonnato", "incolpato", "incominciato", "incomodato", "incontrato", "incoraggiato", "incordato", "incornato", "incorniciato", "incoronato", "incorporato", "incotto", "incravattato", "incrementato", "increspato", "incretinito", "incriminato", "incrinato", "incrociato", "incrostato", "incrudelito", "incrudito", "incruscato", "incubato", "inculato", "inculcato", "incuneato", "incuoiato", "incuorato", "incupito", "incuriosito", "incurvato", "incusso", "indagato", "indebitato", "indebolito", "indemaniato", "indennizzato", "indetto", "indicato", "indicizzato", "indignato", "indiretto", "indirizzato", "indispettito", "indisposto", "individualizzato", "individuato", "indolenzito", "indorato", "indossato", "indotto", "indottomo", "indottrinato", "indovinato", "indugiato", "indulto", "indurato", "indurito", "industrializzato", "industriato", "inebetito", "inebriato", "inerito", "inerpicato", "infagottato", "infamato", "infangato", "infarcito", "infarinato", "infastidito", "infatuato", "infeltrito", "inferito", "inferocito", "inferto", "infervorato", "infestato", "infettato", "infeudato", "infiacchito", "infialato", "infialettato", "infiammato", "infiascato", "infibulato", "inficiato", "infilato", "infiltrato", "infilzato", "infingardito", "infinocchiato", "infinto", "infioccato", "infiocchettato", "infiochito", "infiorato", "infirmato", "infischiato", "infisso", "infittito", "inflazionato", "inflesso", "inflitto", "influenzato", "infocato", "infoderato", "infognato", "infoibato", "infoltito", "inforcato", "informatizzato", "informato", "informicolato", "informicolito", "infornaciato", "infornato", "infortunato", "infoscato", "infossato", "infradiciato", "inframesso", "inframezzato", "inframmesso", "inframmezzato", "infrancesato", "infrapposto", "infrascato", "infrattato", "infreddato", "infronzolato", "infuocato", "infurbito", "infuriato", "ingabbiato", "ingaggiato", "ingagliardito", "ingannato", "ingarbugliato", "ingavonato", "ingegnato", "ingegnerizzato", "ingelosito", "ingemmato", "ingenerato", "ingentilito", "ingerito", "ingessato", "inghiaiato", "inghiottito", "inghirlandato", "ingiallito", "ingigantito", "inginocchiato", "ingioiellato", "ingiunto", "ingiuriato", "inglesizzato", "inglobato", "ingoffito", "ingoiato", "ingolfato", "ingollato", "ingolosito", "ingombrato", "ingommato", "ingorgato", "ingozzato", "ingranato", "ingrandito", "ingrassato", "ingraticciato", "ingraticolato", "ingravidato", "ingraziato", "ingraziosito", "ingrigito", "ingrommato", "ingrossato", "ingrullito", "inguaiato", "inguainato", "ingualdrappato", "inguantato", "ingurgitato", "inibito", "iniettato", "inimicato", "inizializzato", "iniziato", "inmillato", "innacquato", "innaffiato", "innalzato", "innamorato", "innastato", "innervato", "innervosito", "innescato", "innestato", "innevato", "innocentato", "innocuizzato", "innovato", "inoculato", "inoltrato", "inondato", "inorgoglito", "inorpellato", "inorridito", "inquadrato", "inquietato", "inquisito", "insabbiato", "insacchettato", "insalato", "insaldato", "insalivato", "insanguinato", "insaponato", "insaporito", "inscatolato", "inscenato", "inscritto", "insecchito", "insediato", "insegnato", "inseguito", "insellato", "inselvatichito", "inserito", "insidiato", "insignito", "insilato", "insinuato", "insolentito", "insonnolito", "insonorizzato", "insordito", "insospettito", "insozzato", "inspessito", "inspirato", "installato", "instaurato", "insterilito", "instillato", "instituito", "instradato", "insudiciato", "insufflato", "insultato", "insuperbito", "intabaccato", "intabarrato", "intaccato", "intagliato", "intarsiato", "intasato", "intascato", "intavolato", "integrato", "intelaiato", "intelato", "intellettualizzato", "intenebrato", "intenerito", "intensificato", "intentato", "intepidito", "intercalato", "intercambiato", "intercettato", "interciso", "intercluso", "intercollegato", "interconnesso", "interconvertito", "interdetto", "interessato", "interfacciato", "interfogliato", "interfoliato", "interiorizzato", "interlacciato", "interlineato", "intermesso", "intermezzato", "internalizzato", "internato", "internazionalizzato", "interpellato", "interpenetrato", "interpolato", "interposto", "interpretato", "interpunto", "interrato", "interrogato", "interrotto", "intersecato", "intervallato", "intervistato", "inteso", "intessuto", "intestardito", "intestato", "intiepidito", "intimato", "intimidito", "intimorito", "intinto", "intirizzito", "intitolato", "intonacato", "intonato", "intontito", "intorbidato", "intorbidito", "intorpidito", "intortato", "intossicato", "intralciato", "intramesso", "intramezzato", "intrappolato", "intrapreso", "intrattenuto", "intraveduto", "intravisto", "intravveduto", "intravvisto", "intrecciato", "intricato", "intrigato", "intrinsecato", "intrippato", "intriso", "introdotto", "introflesso", "introiettato", "introitato", "intromesso", "intronato", "intronizzato", "intruduto", "intrufolato", "intrugliato", "intruppato", "intruso", "intubato", "intubettato", "intuito", "inumato", "inumidito", "inurbato", "inutilizzato", "invaghito", "invaginato", "invalidato", "invasato", "invaso", "invelenito", "inventariato", "inventato", "invenuto", "inverdito", "invergato", "inverniciato", "investigato", "investito", "invetriato", "inviato", "invidiato", "invigorito", "inviluppato", "invischiato", "invitato", "invocato", "invogliato", "involato", "involgarito", "involtato", "involto", "inzaccherato", "inzeppato", "inzigato", "inzolfato", "inzuccato", "inzuccherato", "inzuppato", "iodurato", "ionizzato", "ipertrofizzato", "ipnotizzato", "ipostatizzato", "ipotecato", "ipotizzato", "iridato", "irradiato", "irraggiato", "irreggimentato", "irretito", "irrigato", "irrigidito", "irriso", "irritato", "irrobustito", "irrogato", "irrorato", "irrugginito", "irruvidito", "ischeletrito", "iscritto", "islamizzato", "isolato", "isomerizzato", "ispanizzato", "ispessito", "ispezionato", "ispirato", "issato", "istallato", "istanziato", "istaurato", "isterilito", "istigato", "istillato", "istituito", "istituzionalizzato", "istoriato", "istradato", "istruito", "istupidito", "italianeggiato", "italianizzato", "iterato", "iudicato", "killerato", "labbreggiato", "labializzato", "laccato", "lacerato", "laconizzato", "lacrimato", "ladroneggiato", "lagnato", "lagrimato", "laicizzato", "lambiccato", "lambito", "lamentato", "laminato", "lanciato", "lapidato", "lappato", "lardato", "lardellato", "largito", "larvato", "lascato", "lasciato", "lastricato", "latinizzato", "laudato", "laureato", "lavato", "lavorato", "leccato", "legalizzato", "legato", "leggicchiato", "leggiucchiato", "legittimato", "legittimizzato", "legnato", "lemmatizzato", "lenito", "lesinato", "lesionato", "leso", "lessato", "letto", "levato", "levigato", "liberalizzato", "liberato", "licenziato", "lievitato", "liftato", "lignificato", "limato", "limitato", "linciato", "linearizzato", "lineato", "linkato", "liofilizzato", "liquefatto", "liquidato", "lisato", "lisciato", "lisciviato", "listato", "litografato", "livellato", "lizzato", "lobotomizzato", "localizzato", "locato", "lodato", "logorato", "lordato", "lottato", "lottizzato", "lubrificato", "lucchettato", "lucidato", "lucrato", "lumeggiato", "luppolizzato", "lusingato", "lussato", "lustrato", "macadamizzato", "macchiato", "macchinato", "macellato", "macerato", "maciullato", "maggesato", "maggiorato", "magnato", "magnetizzato", "magnificato", "maiolicato", "maledetto", "malfatto", "malignato", "malmenato", "malmesso", "maltato", "maltrattato", "malveduto", "malversato", "malvisto", "malvoluto", "mandato", "mandrinato", "manducato", "maneggiato", "manganato", "manganellato", "mangiato", "mangiucchiato", "manifatturato", "manifestato", "manimesso", "manipolato", "manlevato", "manomesso", "manoscritto", "manovrato", "mansuefatto", "mantecato", "mantenutaso", "mantenuto", "manualizzato", "manutenuto", "mappato", "marcato", "marchiato", "marcito", "marezzato", "marginalizzato", "marginato", "margottato", "marimesso", "marinato", "maritato", "marmorizzato", "marnato", "marocchinato", "martellato", "martellinato", "martirizzato", "martoriato", "mascherato", "maschiato", "maschiettato", "mascolinizzato", "massacrato", "massaggiato", "massellato", "massicciato", "massificato", "massimato", "massimizzato", "mastectomizzato", "masterizzato", "masticato", "masturbato", "matematizzato", "materializzato", "matricolato", "mattonato", "maturato", "mazziato", "mazzolato", "meccanizzato", "medagliato", "mediato", "medicalizzato", "medicato", "meditato", "membrato", "memorizzato", "menato", "mendicato", "menomato", "mentovato", "menzionato", "meravigliato", "mercanteggiato", "mercerizzato", "mercificato", "meriato", "meridionalizzato", "meritato", "merlato", "merlettato", "merso", "mesciato", "mesciuto", "mescolato", "mescuto", "mesmerizzato", "messaggiato", "messo", "messoco", "mestato", "mesticato", "mestruato", "metabolizzato", "metaforeggiato", "metaforizzato", "metallizzato", "metamorfizzato", "metamorfosato", "metanizzato", "metilato", "metodizzato", "microfilmato", "microfonato", "microminiaturizzato", "micronizzato", "mietuto", "migliorato", "militarizzato", "millantato", "millimetrato", "mimato", "mimeografato", "mimetizzato", "minacciato", "minato", "minchionato", "mineralizzato", "miniato", "miniaturizzato", "minimizzato", "minuito", "minuzzato", "miracolato", "miscelato", "mischiato", "misconosciuto", "missato", "mistificato", "misturato", "misurato", "miticizzato", "mitigato", "mitizzato", "mitragliato", "mitrato", "mixato", "mobiliato", "mobilitato", "mobilizzato", "modanato", "modellato", "modellizzato", "moderato", "modernizzato", "modificato", "modulato", "molato", "molestato", "mollato", "molleggiato", "moltiplicato", "monacato", "mondato", "mondializzato", "monetarizzato", "monetato", "monetizzato", "monitorato", "monitorizzato", "monocromatizzato", "monopolizzato", "monottongato", "montato", "monumentalizzato", "mordenzato", "mordicchiato", "mormorato", "morphato", "morsicato", "morsicchiato", "morso", "mortasato", "mortificato", "mosso", "mostrato", "motivato", "motorizzato", "motteggiato", "movimentato", "mozzato", "mugolato", "mulcito", "multato", "multiplexato", "mummificato", "municipalizzato", "munito", "munto", "murato", "musato", "musicato", "mussato", "mutato", "mutilato", "mutizzato", "mutuato", "nappato", "narcotizzato", "narrativizzato", "narrato", "nasalizzato", "nascoso", "nascosto", "nastrato", "naturaleggiato", "naturalizzato", "nauseato", "naverato", "navicato", "navigato", "nazificato", "nazionalizzato", "nebulizzato", "necessitato", "necrosato", "necrotizzato", "negativizzato", "negato", "negletto", "negoziato", "negreggiato", "neologizzato", "nerbato", "nericato", "nettato", "neutralizzato", "nevato", "nevicato", "nevischiato", "nevrotizzato", "nichelato", "niellato", "ninfeggiato", "ninnato", "ninnolato", "nitratato", "nitrificato", "nobilitato", "noiato", "noleggiato", "nomato", "nominalizzato", "nominato", "normalizzato", "normato", "notato", "notificato", "notiziato", "notricato", "noverato", "nuclearizzato", "nudricato", "nullificato", "numerato", "numerizzato", "nuotato", "nutrito", "obbiettato", "obbliato", "obbligato", "oberato", "obiettato", "obiettivato", "obiettivizzato", "obiurgato", "obliato", "obliterato", "obnubilato", "occasionato", "occhieggiato", "occidentalizzato", "occiso", "occluso", "occultato", "occupato", "ocheggiato", "odiato", "odorato", "odorizzato", "offerito", "offerto", "offeso", "officiato", "offiziato", "offuscato", "ofiziato", "oggettivato", "oggettivizzato", "oggettualizzato", "oliato", "olito", "olografato", "oltraggiato", "oltrapassato", "oltrepassato", "omaggiato", "ombrato", "ombreggiato", "omesso", "omogeneizzato", "omogenizzato", "omologato", "ondato", "ondulato", "onestato", "onnubilato", "onorato", "opacato", "opacizzato", "operato", "opinato", "oppiato", "oppignorato", "oppilato", "opposto", "oppresso", "oppugnato", "oprato", "opsonizzato", "optato", "opzionato", "orbitato", "orchestrato", "ordinato", "ordito", "orecchiato", "organato", "organicato", "organizzato", "orgasmato", "orientalizzato", "orientato", "originato", "origliato", "orizzontato", "orlato", "orlettato", "ormato", "ormeggiato", "ornato", "orpellato", "orrato", "orripilato", "ortogonalizzato", "osannato", "osato", "osculato", "oscurato", "ospedalizzato", "ospitato", "osseduto", "ossequiato", "osservato", "ossessionato", "ossidato", "ossificato", "ossitonizzato", "ostacolato", "osteggiato", "ostentato", "ostinato", "ostracizzato", "ostruito", "ottemperato", "ottenebrato", "ottenuto", "ottimalizzato", "ottimato", "ottimizzato", "ottonato", "ottriato", "ottuplicato", "otturato", "ottuso", "ottusso", "ovalizzato", "ovariectomizzato", "ovattato", "overcloccato", "ovrato", "ovviato", "ozieggiato", "ozonizzato", "pacato", "pacciamato", "pacificato", "padroneggiato", "paganizzato", "pagato", "paginato", "palafittato", "palatalizzato", "palato", "palesato", "palettato", "palettizzato", "palificato", "palleggiato", "pallettizzato", "palpato", "palpeggiato", "panato", "panneggiato", "panoramicato", "pappato", "paracadutato", "parafato", "paraffinato", "parafrasato", "paragonato", "paragrafato", "paralizzato", "parallelizzato", "parametrato", "parametrizzato", "parassitato", "parato", "parcato", "parcellizzato", "parcheggiato", "pareggiato", "parificato", "parkerizzato", "parlato", "parlucchiato", "parodiato", "partecipato", "particolareggiato", "particolarizzato", "partizionato", "partorito", "parzializzato", "pasciuto", "pascolato", "passato", "passeggiato", "passionato", "passivato", "pasticciato", "pastorizzato", "pasturato", "patinato", "patito", "patrocinato", "patteggiato", "pattugliato", "pattuito", "paventato", "pavesato", "pavimentato", "pavoneggiato", "pazziato", "pedinato", "pedonalizzato", "peggiorato", "pelato", "pellettizzato", "penalizzato", "penetrato", "pennellato", "pensato", "pensionato", "pentito", "pepato", "peptonizzato", "peragrato", "percentualizzato", "percepito", "percolato", "percorso", "percosso", "perdonato", "perdotto", "perduto", "perequato", "perfatto", "perfezionato", "perforato", "performato", "perito", "periziato", "perlustrato", "permeato", "permesso", "perorato", "perpetrato", "perpetuato", "perplimuto", "perquisito", "perscrutato", "perseguitato", "perseguito", "perso", "personalizzato", "personificato", "persuaso", "perturbato", "pervaso", "pervertito", "pesato", "pescato", "pestato", "petrarcheggiato", "pettegolato", "pettinato", "piagato", "piaggiato", "piallato", "pianeggiato", "pianificato", "piantato", "piantatalo", "piantato", "pianto", "piantonato", "piantumato", "piastrellato", "piatito", "piazzato", "picchettato", "picchiato", "picchierellato", "picchiettato", "picconato", "piegato", "pieghettato", "pietrificato", "pigiato", "pigliato", "pigmentato", "pignorato", "pigolato", "pilotato", "pimentato", "pinto", "pinzato", "piombato", "piovigginato", "piovuto", "pipato", "pippato", "piratato", "pirogenato", "pisciato", "pitoccato", "pittato", "pitturato", "pizzicato", "pizzicottato", "placato", "placcato", "plagiato", "plasmato", "plasticato", "plastificato", "platinato", "plissettato", "pluralizzato", "poetato", "poeticizzato", "poggiato", "polarizzato", "poligrafato", "polimerizzato", "politicizzato", "polverizzato", "pomiciato", "pompato", "ponderato", "ponzato", "popolarizzato", "popolato", "poppato", "porcellanato", "porfirizzato", "portato", "porteso", "porto", "porzionato", "posato", "posdatato", "positivizzato", "posizionato", "posposto", "posseduto", "postato", "postdatato", "posteggiato", "posticipato", "postillato", "posto", "postsincronizzato", "postulato", "potabilizzato", "potato", "potenziato", "potuto", "pralinato", "praticato", "preaccennato", "preannunciato", "preannunziato", "preavvertito", "preavvisato", "precaricato", "preceduto", "precettato", "precinto", "precisato", "precluso", "precompilato", "precompresso", "preconfezionato", "preconizzato", "preconosciuto", "precorso", "precostituito", "predato", "predefinito", "predestinato", "predeterminato", "predetto", "predicato", "predigerito", "prediletto", "predisposto", "preeletto", "preesistuto", "prefabbricato", "prefato", "prefatto", "prefazionato", "preferito", "prefigurato", "prefinanziato", "prefissato", "prefisso", "preformato", "pregato", "pregiato", "pregiudicato", "pregustato", "preimpregnato", "prelevato", "premeditato", "premescolato", "premesso", "premiato", "premonito", "premunito", "premurato", "premuto", "prenotato", "preoccupato", "preordinato", "preparato", "prepensionato", "prepigmentato", "preposto", "preprogrammato", "preraffreddato", "prerefrigerato", "preregistrato", "preregolato", "preriscaldato", "preso", "presagito", "presaputo", "presaselo", "prescelto", "prescritto", "preseduto", "presegnalato", "preselezionato", "presentato", "presentito", "preservato", "presidiato", "presieduto", "preso", "pressato", "presso", "pressurizzato", "prestabilito", "prestampato", "prestato", "prestigiato", "presunto", "presupposto", "pretermesso", "preteso", "pretrattato", "prevaricato", "preveduto", "prevenduto", "preventivato", "prevenuto", "previsto", "prezzato", "prezzolato", "principiato", "privatizzato", "privato", "privilegiato", "problematizzato", "procacciato", "processato", "proclamato", "procrastinato", "procreato", "procurato", "prodigato", "prodotto", "profanato", "proferito", "professato", "professionalizzato", "profetato", "profetizzato", "profferito", "profilato", "profondato", "profumato", "profuso", "progettato", "prognosticato", "programmato", "proibito", "proiettato", "proletarizzato", "prolungato", "promanato", "promesso", "promosso", "promozionato", "promulgato", "pronosticato", "pronunciato", "pronunziato", "propagandato", "propagato", "propagginato", "propalato", "propinato", "propiziato", "proporzionato", "proposto", "propugnato", "propulso", "prorogato", "prosciolto", "prosciugato", "proscritto", "proseguito", "prospettato", "prosternato", "prosteso", "prostituito", "prostrato", "prosunto", "proteso", "protestato", "protetto", "protocollato", "protonato", "protratto", "protruso", "provato", "proveduto", "provincializzato", "provisto", "provocato", "provveduto", "provvisto", "psicanalizzato", "psichiatrizzato", "psicoanalizzato", "psicologizzato", "pubblicato", "pubblicizzato", "puddellato", "pugnalato", "pulito", "pungolato", "punito", "puntato", "punteggiato", "puntellato", "punto", "puntualizzato", "punzecchiato", "punzonato", "purgato", "purificato", "putito", "putrefatto", "putrito", "quadrato", "quadrettato", "quadriennalizzato", "quadruplicato", "qualificato", "quantificato", "quantizzato", "querelato", "questuato", "quetato", "quietanzato", "quietato", "quintessenziato", "quintuplicato", "quotato", "quotizzato", "rabberciato", "rabboccato", "rabbonito", "rabbuffato", "rabuffato", "raccapezzato", "raccapricciato", "raccattato", "raccerchiato", "racceso", "racchetato", "racchiuso", "raccolto", "raccolto", "raccomandato", "raccomodato", "raccontato", "raccorciato", "raccorcito", "raccordato", "raccostato", "raccozzato", "racemizzato", "racimolato", "radazzato", "raddensato", "raddobbato", "raddolcito", "raddoppiato", "raddotto", "raddrizzato", "radiato", "radicalizzato", "radioassistito", "radioattivato", "radiocomandato", "radiodiffuso", "radiografato", "radioguidato", "radiolocalizzato", "radiomarcato", "radiotelegrafato", "radiotrasmesso", "radunato", "raffazzonato", "raffermato", "raffigurato", "raffilato", "raffinato", "rafforzato", "raffreddato", "raffrenato", "raffrescato", "raffrontato", "raggelato", "raggentilito", "ragghiato", "raggirato", "raggiunto", "raggiustato", "raggomitolato", "raggranchiato", "raggranchito", "raggranellato", "raggrinzato", "raggrinzito", "raggrumato", "raggruppato", "raggruzzolato", "ragguagliato", "ralingato", "rallegrato", "rallentato", "ramato", "ramazzato", "rammagliato", "rammaricato", "rammemorato", "rammendato", "rammentato", "rammodernato", "rammollito", "rammorbidito", "rampognato", "randellato", "randomizzato", "rannicchiato", "rannuvolato", "ranzato", "rapato", "rapinato", "rapito", "rappacificato", "rappato", "rappattumato", "rappezzato", "rapportato", "rappresantato", "rappresentato", "rappreso", "rarefatto", "rasato", "raschiato", "raschiettato", "rasentato", "raso", "raspato", "rassegnato", "rasserenato", "rassettato", "rassicurato", "rassodato", "rassomigliato", "rassottigliato", "rassunto", "rastrellato", "rastremato", "rateato", "rateizzato", "ratificato", "ratinato", "rattizzato", "rattoppato", "rattorto", "rattrappito", "rattristato", "rattristito", "raunato", "ravvalorato", "ravveduto", "ravviato", "ravvicinato", "ravviluppato", "ravvisato", "ravvisto", "ravvivato", "ravvolto", "ravvoltolato", "razionalizzato", "razionato", "razziato", "razzolato", "realizzato", "reassunto", "recapitato", "recato", "receduto", "recensito", "recepito", "recidivato", "recintato", "recinto", "reciprocato", "reciso", "recitato", "reclamato", "reclamizzato", "reclinato", "recluso", "reclutato", "recuperato", "redarguito", "redatto", "redazzato", "redduto", "redento", "redistribuito", "redotto", "referenziato", "refertato", "refilato", "reflesso", "reflettuto", "refranto", "refrigerato", "regalato", "regimato", "regimentato", "regionalizzato", "registrato", "regolamentato", "regolarizzato", "regolato", "reidratato", "reificato", "reimbarcato", "reimmerso", "reimmesso", "reimparato", "reimpastato", "reimpiantato", "reimpiegato", "reimportato", "reimpostato", "reincarcerato", "reincaricato", "reincarnato", "reinciso", "reincontrato", "reindirizzato", "reindustrializzato", "reinfettato", "reingaggiato", "reinizializzato", "reinnestato", "reinoltrato", "reinscritto", "reinsediato", "reinserito", "reinstallato", "reinstaurato", "reintegrato", "reinterpretato", "reintitolato", "reintrodotto", "reinventato", "reinvestito", "reiterato", "relativizzato", "relazionato", "relegato", "remixato", "remunerato", "renderizzato", "reperito", "repertato", "replicato", "represso", "repulso", "reputato", "requisito", "rescisso", "resecato", "resettato", "residuato", "resinificato", "reso", "resolato", "resolto", "respinto", "respirato", "responsabilizzato", "resposto", "restaurato", "restituito", "resunto", "resuscitato", "reticolato", "retinato", "retribuito", "retroceduto", "retrocesso", "retrodatato", "rettificato", "retto", "reumatizzato", "revisionato", "revocato", "riabbassato", "riabbellito", "riabbonato", "riabbottonato", "riabbracciato", "riabilitato", "riabitato", "riabituato", "riaccaduto", "riaccasato", "riacceso", "riaccettato", "riacchiappato", "riacciuffato", "riaccolto", "riaccomodato", "riaccompagnato", "riaccordato", "riaccostato", "riaccreditato", "riacquisito", "riacquistato", "riacutizzato", "riadattato", "riaddestrato", "riaddormentato", "riadoperato", "riaffacciato", "riaffermato", "riafferrato", "riaffiorato", "riaffittato", "riaffrontato", "riagganciato", "riaggiornato", "riaggiustato", "riaggravato", "riaggregato", "riagguantato", "rialimentato", "riallacciato", "riallargato", "riallineato", "riallocato", "riallungato", "rialzato", "riamato", "riambientato", "riammalato", "riammesso", "riammodernato", "riammogliato", "rianimato", "riannesso", "riannodato", "riannunciato", "riaperto", "riappacificato", "riappaltato", "riapparecchiato", "riapparito", "riappeso", "riappiccicato", "riapplicato", "riappreso", "riapprodato", "riappropriato", "riapprovato", "riarmato", "riarrangiato", "riarredato", "riascoltato", "riasfaltato", "riassalito", "riassaporato", "riassegnato", "riassemblato", "riassestato", "riassettato", "riassicurato", "riassociato", "riassopito", "riassorbito", "riassunto", "riattaccato", "riattato", "riatteso", "riattinto", "riattivato", "riattizzato", "riattraversato", "riaumentato", "riavuto", "riavventato", "riavvertito", "riavviato", "riavvicinato", "riavvinto", "riavvisato", "riavvistato", "riavvolto", "riazzuffato", "ribaciato", "ribadito", "ribaltato", "ribassato", "ribattezzato", "ribattuto", "ribellato", "ribenedetto", "ribevuto", "ributtato", "ricacciato", "ricalato", "ricalcato", "ricalcificato", "ricalcitrato", "ricalcolato", "ricalibrato", "ricamato", "ricambiato", "ricanalizzato", "ricandidato", "ricantato", "ricapitalizzato", "ricapitolato", "ricaricato", "ricategorizzato", "ricattato", "ricavato", "ricelebrato", "ricercato", "ricetrasmesso", "ricettato", "ricevuto", "richiamato", "richiesto", "richiuso", "riciclato", "ricinto", "ricircolato", "riclassificato", "ricodificato", "ricollegato", "ricollocato", "ricolmato", "ricolonizzato", "ricolorato", "ricolorito", "ricoltivato", "ricombinato", "ricominciato", "ricommesso", "ricomparito", "ricompattato", "ricompensato", "ricomperato", "ricompilato", "ricompiuto", "ricomposto", "ricomprato", "ricompresso", "ricomunicato", "riconceduto", "riconcesso", "riconciliato", "ricondizionato", "ricondotto", "riconfermato", "riconfezionato", "riconfigurato", "riconfortato", "riconfuso", "ricongelato", "ricongiunto", "riconnesso", "riconosciuto", "riconquistato", "riconsacrato", "riconsegnato", "riconsiderato", "riconsigliato", "riconsolato", "ricontato", "ricontattato", "ricontrattato", "ricontratto", "ricontrollato", "riconvalidato", "riconvenuto", "riconvertito", "riconvinto", "riconvocato", "riconvogliato", "ricoperto", "ricopiato", "ricordato", "ricoricato", "ricorretto", "ricosparso", "ricostituito", "ricostretto", "ricostruito", "ricotto", "ricoverato", "ricreato", "ricristallizzato", "ricrocifisso", "ricucito", "ricuperato", "ricusato", "ridato", "ridecorato", "ridefinito", "ridenominato", "ridestato", "rideterminato", "ridetto", "ridicolizzato", "ridigitato", "ridimensionato", "ridipinto", "ridisceso", "ridisciolto", "ridisciplinato", "ridiscusso", "ridisegnato", "ridisfatto", "ridisposto", "ridisteso", "ridistinto", "ridistribuito", "ridiviso", "ridomandato", "ridonato", "ridondato", "ridorato", "ridotato", "ridotto", "ridovuto", "riecheggiato", "riedificato", "rieducato", "rielaborato", "rieletto", "riemesso", "riempito", "riempiuto", "rientrato", "riepilogato", "riequilibrato", "riequipaggiato", "riesaminato", "rieseguito", "riesercitato", "riesploso", "riesportato", "riesposto", "riespresso", "riespulso", "riesteso", "riesumato", "rietichettato", "rievaporato", "rievocato", "rifabbricato", "rifasciato", "rifatto", "rifenduto", "riferito", "rifermato", "rifermentato", "rifesso", "rificcato", "rifilato", "rifiltrato", "rifinanziato", "rifinito", "rifirmato", "rifischiato", "rifisso", "rifiutato", "riflesso", "riflettuto", "rifocillato", "rifoderato", "rifondato", "riforestato", "riforgiato", "riformato", "riformattato", "riformulato", "rifornito", "rifranto", "rifritto", "rifrugato", "rifuggito", "rifugiato", "rifuso", "rigassificato", "rigato", "rigelato", "rigenerato", "rigettato", "righettato", "rigiocato", "rigirato", "rigiudicato", "rigiunto", "rigoduto", "rigonfiato", "rigovernato", "riguadagnato", "riguardato", "rigurgitato", "rilanciato", "rilasciato", "rilassato", "rilavato", "rilavorato", "rilegato", "riletto", "rilevato", "rilocalizzato", "rimagliato", "rimandato", "rimaneggiato", "rimangiato", "rimappato", "rimarcato", "rimarchiato", "rimarginato", "rimaritato", "rimasticato", "rimato", "rimbacuccato", "rimbaldanzito", "rimbarcato", "rimbeccato", "rimbecillito", "rimbellito", "rimbiancato", "rimbiondito", "rimboccato", "rimbombato", "rimborsato", "rimboscato", "rimboschito", "rimbrottato", "rimediato", "rimembrato", "rimemorato", "rimenato", "rimeritato", "rimescolato", "rimesso", "rimestato", "rimilitarizzato", "rimirato", "rimischiato", "rimisurato", "rimodellato", "rimodernato", "rimodulato", "rimondato", "rimontato", "rimorchiato", "rimorso", "rimosso", "rimostrato", "rimotivato", "rimpacchettato", "rimpadronito", "rimpaginato", "rimpagliato", "rimpannucciato", "rimpastato", "rimpatriato", "rimpiallacciato", "rimpianto", "rimpiattato", "rimpiazzato", "rimpicciolito", "rimpiccolito", "rimpiegato", "rimpinguato", "rimpinzato", "rimpolpato", "rimpossessato", "rimpresso", "rimproverato", "rimuginato", "rimunerato", "rimunto", "rimusicato", "rimutato", "rinarrato", "rinascosto", "rincalcato", "rincalzato", "rincamminato", "rincantucciato", "rincarato", "rincarcerato", "rincarnato", "rincentrato", "rinchiesto", "rinchiodato", "rinchiuso", "rincitrullito", "rincivilito", "rincoglionito", "rincollato", "rincominciato", "rincontrato", "rincoraggiato", "rincorato", "rincorporato", "rincorso", "rincretinito", "rincrudito", "rinculcato", "rincuorato", "rindossato", "rindurito", "rinegoziato", "rinfacciato", "rinfagottato", "rinfiammato", "rinfiancato", "rinfilato", "rinfittito", "rinfocolato", "rinfoderato", "rinforzato", "rinfrancato", "rinfranto", "rinfrescato", "rinfuso", "ringagliardito", "ringalluzzito", "ringiovanito", "ringiovenito", "ringoiato", "ringorgato", "ringraziato", "ringuainato", "rinnamorato", "rinnegato", "rinnestato", "rinnovato", "rinnovellato", "rinociuto", "rinomato", "rinominato", "rinormalizzato", "rinquadrato", "rinsaccato", "rinsaldato", "rinsanguato", "rinselvatichito", "rinselvato", "rinserrato", "rintanato", "rintasato", "rintascato", "rintavolato", "rintenerito", "rinterrato", "rinterrogato", "rinteso", "rintiepidito", "rintoccato", "rintonacato", "rintontito", "rintorpidito", "rintracciato", "rintrodotto", "rintronato", "rintuzzato", "rinunciato", "rinunziato", "rinutrito", "rinvangato", "rinvasato", "rinvenuto", "rinverdito", "rinvestito", "rinviato", "rinvigorito", "rinvilito", "rinvitato", "rinvoltato", "rinvolto", "rinvoltolato", "rinzaffato", "rinzeppato", "riobbligato", "rioccupato", "riofferto", "rioffeso", "rioperato", "riordinato", "riorganizzato", "riorientato", "riosservato", "riottenuto", "riottimizzato", "riotturato", "ripagato", "riparametrizzato", "riparato", "ripartito", "ripassato", "ripercorso", "ripercosso", "riperduto", "riperso", "ripesato", "ripescato", "ripestato", "ripetuto", "ripianato", "ripianificato", "ripiantato", "ripianto", "ripicchiato", "ripiegato", "ripigliato", "ripinto", "ripiovuto", "ripitturato", "riplasmato", "ripolarizzato", "ripopolato", "riportato", "riporto", "riposato", "riposizionato", "riposseduto", "riposto", "ripotuto", "ripresentato", "ripreso", "riprestato", "ripreteso", "riprincipiato", "ripristinato", "riprivatizzato", "riprodotto", "riprogettato", "riprogrammato", "ripromesso", "riproposto", "riprotetto", "riprovato", "riprovveduto", "riprovvisto", "ripubblicato", "ripudiato", "ripugnato", "ripulito", "ripuntato", "ripunto", "ripurgato", "riputato", "riquadrato", "riqualificato", "rireso", "rirotto", "risaldato", "risalito", "risaltato", "risalutato", "risanato", "risaputo", "risarcito", "riscalato", "riscaldato", "riscattato", "riscelto", "risceso", "rischiarato", "rischiato", "risciacquato", "risciolto", "riscommesso", "riscontato", "riscontrato", "risconvolto", "riscoperto", "riscoppiato", "riscorso", "riscosso", "riscritto", "risecato", "riseduto", "risegato", "risegnato", "riselciato", "riselezionato", "riseminato", "risentito", "riseppellito", "riserbato", "riservato", "risicato", "risigillato", "risistemato", "riso", "risoffiato", "risoggiunto", "risolato", "risolidificato", "risollevato", "risolto", "risommato", "risommerso", "risonato", "risorpassato", "risospeso", "risospinto", "risottomesso", "risparmiato", "risparso", "rispecchiato", "rispedito", "rispento", "risperso", "rispettato", "rispiegato", "rispinto", "rispolverato", "risposato", "risposto", "rissato", "ristabilito", "ristagnato", "ristampato", "ristaurato", "risteso", "ristilizzato", "ristorato", "ristretto", "ristrutto", "ristrutturato", "ristuccato", "ristudiato", "risucchiato", "risultato", "risuolato", "risuonato", "risuscitato", "risvegliato", "risvolto", "ritagliato", "ritarato", "ritardato", "ritemprato", "ritentato", "ritenuto", "riterso", "riteso", "ritinto", "ritirato", "ritoccato", "ritolto", "ritorto", "ritracciato", "ritradotto", "ritrascorso", "ritrascritto", "ritrasferito", "ritrasformato", "ritrasmesso", "ritrasposto", "ritrattato", "ritratto", "ritrovato", "ritualizzato", "rituffato", "riudito", "riunificato", "riunito", "riusato", "riutilizzato", "rivaccinato", "rivaleggiato", "rivalorizzato", "rivalso", "rivalutato", "rivangato", "riveduto", "rivelato", "rivendicato", "rivenduto", "riverberato", "riverito", "riverniciato", "riversato", "rivestito", "rivettato", "rivinto", "rivisitato", "rivissuto", "rivisto", "rivitalizzato", "rivivificato", "rivoltato", "rivolto", "rivoltolato", "rivoluto", "rivoluzionato", "rizappato", "rizzato", "robotizzato", "rodato", "rogato", "rollato", "romanizzato", "romanticizzato", "romanzato", "roncolato", "rosicato", "rosicchiato", "roso", "rosolato", "rotacizzato", "rotato", "roteato", "rotolato", "rottamato", "rotto", "rovesciato", "rovinato", "rovistato", "rubacchiato", "rubato", "rullato", "ruminato", "ruotato", "russificato", "ruzzolato", "sabbiato", "sabotato", "saccarificato", "saccheggiato", "sacralizzato", "sacramentato", "sacrificato", "saettato", "saggiato", "sagginato", "sagomato", "salamoiato", "salariato", "salassato", "salato", "saldato", "salificato", "salinizzato", "salito", "salmeggiato", "salmistrato", "salpato", "saltato", "salutato", "salvaguardato", "salvato", "sanato", "sancito", "sanforizzato", "sanificato", "sanitizzato", "santificato", "sanzionato", "saponificato", "saputo", "sarchiato", "sarchiellato", "sartiato", "satellizzato", "satinato", "satireggiato", "satisfatto", "satollato", "saturato", "saziato", "sbaccellato", "sbaciucchiato", "sbafato", "sbaffato", "sbalestrato", "sballato", "sballottato", "sballottolato", "sbalordito", "sbalzato", "sbancato", "sbandato", "sbandierato", "sbandito", "sbaraccato", "sbaragliato", "sbarazzato", "sbarbato", "sbarcato", "sbardato", "sbarrato", "sbassato", "sbastito", "sbatacchiato", "sbattezzato", "sbattuto", "sbeccato", "sbeffeggiato", "sbellicato", "sbendato", "sbertucciato", "sbiadito", "sbiancato", "sbianchito", "sbiellato", "sbiettato", "sbigottito", "sbilanciato", "sbirbato", "sbirciato", "sbizzarrito", "sbloccato", "sbobinato", "sboccato", "sbocconcellato", "sbollentato", "sbolognato", "sborniato", "sborsato", "sboscato", "sbottonato", "sbozzato", "sbozzimato", "sbozzolato", "sbracato", "sbracciato", "sbraciato", "sbraitato", "sbranato", "sbrancato", "sbrattato", "sbreccato", "sbriciolato", "sbrigato", "sbrigliato", "sbrinato", "sbrindellato", "sbrodolato", "sbrogliato", "sbronzato", "sbruffato", "sbucciato", "sbudellato", "sbuffato", "sbugiardato", "sbullettato", "sbullonato", "sburrato", "scacazzato", "scacchiato", "scacciato", "scaccolato", "scadenzato", "scafato", "scaffalato", "scagionato", "scagliato", "scaglionato", "scalato", "scalcato", "scalcinato", "scaldato", "scalettato", "scalfato", "scalfito", "scalmanato", "scaloppato", "scalpato", "scalpellato", "scalpellinato", "scaltrito", "scalzato", "scambiato", "scamiciato", "scamosciato", "scamozzato", "scampato", "scampatalo", "scampato", "scamuffato", "scanalato", "scancellato", "scandagliato", "scandalizzato", "scandito", "scannato", "scannellato", "scannerato", "scannerizato", "scannerizzato", "scansato", "scansionato", "scapecchiato", "scapezzato", "scapicollato", "scapigliato", "scapitozzato", "scapocchiato", "scappato", "scappellato", "scappottato", "scapricciato", "scapsulato", "scarabocchiato", "scaracchiato", "scaraventato", "scarcerato", "scardassato", "scardato", "scardinato", "scaricato", "scarificato", "scarmigliato", "scarnato", "scarnificato", "scarnito", "scarrellato", "scarrocciato", "scarrozzato", "scarruffato", "scartabellato", "scartato", "scartavetrato", "scartinato", "scartocciato", "scassato", "scassinato", "scatenato", "scattato", "scavalcato", "scavallato", "scavato", "scavezzato", "scazzottato", "scekerato", "scelto", "scempiato", "sceneggiato", "scernuto", "scervellato", "sceso", "sceverato", "schedato", "schedulato", "scheggiato", "scheletrito", "schematizzato", "schermato", "schermito", "schermografato", "schernito", "schiacciato", "schiaffato", "schiaffeggiato", "schiantato", "schiarito", "schiavardato", "schiavizzato", "schiccherato", "schierato", "schifato", "schinciato", "schioccato", "schiodato", "schiumato", "schiuso", "schivato", "schizzato", "schizzettato", "sciabolato", "sciabordato", "sciacquato", "scialacquato", "sciamanizzato", "sciamannato", "sciancato", "sciancrato", "scimmieggiato", "scimmiottato", "scinto", "scioccato", "sciolinato", "sciolto", "sciorinato", "scippato", "sciroppato", "scisso", "sciupacchiato", "sciupato", "sclamato", "sclerosato", "sclerotizzato", "scoccato", "scocciato", "scodato", "scodellato", "scoiato", "scolarizzato", "scolato", "scollacciato", "scollato", "scollegato", "scolorato", "scolorito", "scolpato", "scolpito", "scombaciato", "scombinato", "scombussolato", "scommesso", "scomodato", "scompaginato", "scompagnato", "scompartito", "scompattato", "scompensato", "scompiacuto", "scompigliato", "scomposto", "scomputato", "scomunicato", "sconcertato", "sconciato", "sconcluso", "sconfessato", "sconficcato", "sconﬁtto", "sconfortato", "sconfuso", "scongelato", "scongiurato", "sconnesso", "sconosciuto", "sconquassato", "sconsacrato", "sconsigliato", "sconsolato", "scontato", "scontentato", "scontornato", "scontorto", "scontrato", "sconvolto", "scopato", "scoperchiato", "scoperto", "scopiazzato", "scoraggiato", "scoraggito", "scorato", "scorazzato", "scorciato", "scorcito", "scordato", "scoreggiato", "scorificato", "scornato", "scorniciato", "scoronato", "scorporato", "scorrazzato", "scorreggiato", "scorretto", "scorso", "scortato", "scortecciato", "scorticato", "scorto", "scorzato", "scosceso", "scosciato", "scosso", "scostato", "scostolato", "scotennato", "scoticato", "scotolato", "scotomizzato", "scottato", "scotto", "scovato", "scoverto", "scozzato", "scozzonato", "screditato", "scremato", "screpolato", "screziato", "scribacchiato", "scriminato", "scristianizzato", "scritto", "scritturato", "scroccato", "scrocchiato", "scrollato", "scrostato", "scrutato", "scrutinato", "scucito", "scudisciato", "scuffiato", "sculacciato", "sculettato", "scuoiato", "scuriosato", "scurito", "scusato", "sdaziato", "sdebitato", "sdegnato", "sdemanializzato", "sdentato", "sdilinquito", "sdoganato", "sdoluto", "sdoppiato", "sdraiato", "sdrammatizzato", "sdrucito", "secato", "seccato", "secernuto", "secolarizzato", "secondato", "secretato", "secreto", "sedato", "sedentarizzato", "sedotto", "segato", "seghettato", "segmentato", "segnalato", "segnato", "segnoreggiato", "segregato", "segretato", "seguitato", "seguito", "selciato", "selezionato", "sellato", "sembrato", "sementato", "semicinto", "seminato", "semplificato", "senilizzato", "sensibilizzato", "sensorizzato", "sentenziato", "sentito", "sentitaselo", "sentito", "sentito", "separato", "sepolto", "seppellito", "sequenziato", "sequestrato", "serbato", "serrato", "servito", "servoassistito", "sessualizzato", "sestuplicato", "setacciato", "setificato", "settato", "settorializzato", "settuplicato", "seviziato", "sezionato", "sfaccettato", "sfagliato", "sfaldato", "sfalsato", "sfamato", "sfanalato", "sfangato", "sfarinato", "sfasato", "sfasciato", "sfatato", "sfatto", "sfavillato", "sfavorito", "sfegatato", "sfeltrato", "sfenduto", "sferragliato", "sferrato", "sferzato", "sfesso", "sfiancato", "sfiatato", "sfiato", "sfibbiato", "sfibrato", "sfidato", "sfiduciato", "sfigurato", "sfilato", "sfilettato", "sfinito", "sfioccato", "sfiorato", "sfittato", "sfocato", "sfociato", "sfoderato", "sfogato", "sfoggiato", "sfogliato", "sfollato", "sfoltito", "sfondato", "sforacchiato", "sforato", "sforbiciato", "sformato", "sfornaciato", "sfornato", "sfornito", "sforzato", "sfottuto", "sfracellato", "sfrangiato", "sfrascato", "sfratato", "sfrattato", "sfrecciato", "sfregato", "sfregiato", "sfrenato", "sfrisato", "sfrondato", "sfrucugliato", "sfruculiato", "sfruttato", "sfumato", "sfuocato", "sgamato", "sganasciato", "sganciato", "sgarbugliato", "sgattaiolato", "sgelato", "sghiacciato", "sgocciolato", "sgolato", "sgomberato", "sgombrato", "sgomentato", "sgominato", "sgomitato", "sgomitolato", "sgonfiato", "sgorbiato", "sgottato", "sgovernato", "sgozzato", "sgraffiato", "sgraffignato", "sgranato", "sgranchito", "sgranellato", "sgrassato", "sgravato", "sgretolato", "sgridato", "sgrommato", "sgrondato", "sgroppato", "sgrossato", "sgrovigliato", "sgrugnato", "sguainato", "sgualcito", "sguanciato", "sguarnito", "sguinzagliato", "sgusciato", "shakerato", "shoccato", "shuntato", "sigillato", "siglato", "significato", "signoreggiato", "silenziato", "silicizzato", "sillabato", "sillogizzato", "silurato", "simboleggiato", "simbolizzato", "simmetrizzato", "simpatizzato", "simulato", "sincerato", "sincopato", "sincretizzato", "sincronizzato", "sindacalizzato", "sindacato", "singolarizzato", "sinistrato", "sinizzato", "sinterizzato", "sintetizzato", "sintonizzato", "siringato", "sistematizzato", "sistemato", "situato", "slabbrato", "slacciato", "slamato", "slanciato", "slappolato", "slargato", "slavizzato", "slegato", "slentato", "slinguato", "slogato", "sloggato", "sloggiato", "slombato", "slungato", "smaccato", "smacchiato", "smagliato", "smagnetizzato", "smagrito", "smaliziato", "smallato", "smaltato", "smaltito", "smammato", "smanacciato", "smangiato", "smantellato", "smarcato", "smarginato", "smarrito", "smascellato", "smascherato", "smaterializzato", "smattonato", "smembrato", "smentito", "smerciato", "smerdato", "smerigliato", "smerlato", "smerlettato", "smessalo", "smesso", "smezzato", "smidollato", "smielato", "smilitarizzato", "sminato", "sminuito", "sminuzzato", "smistato", "smitizzato", "smobiliato", "smobilitato", "smobilizzato", "smoccolato", "smollicato", "smonacato", "smontato", "smorbato", "smorzato", "smosso", "smozzicato", "smunto", "smurato", "smussato", "smutandato", "snaturato", "snazionalizzato", "snebbiato", "snellito", "snervato", "snidato", "sniffato", "snobbato", "snocciolato", "snodato", "snudato", "sobbarcato", "sobbollito", "sobillato", "socchiuso", "soccorso", "soddisfatto", "sodisfatto", "sodomizzato", "sofferito", "soffermato", "sofferto", "soffiato", "soffocato", "soffregato", "soffritto", "soffuso", "sofisticato", "soggettivato", "soggettivizzato", "sogghignato", "soggiogato", "soggiunto", "sogguardato", "sognato", "solarizzato", "solcato", "soleggiato", "solennizzato", "solfeggiato", "solfitato", "solfonato", "solforato", "solidificato", "solito", "sollazzato", "sollecitato", "solleticato", "sollevato", "solto", "solubilizzato", "soluto", "soluzionato", "solvatato", "somatizzato", "someggiato", "somigliato", "sommato", "sommerso", "sommesso", "somministrato", "sommosso", "sonato", "sondato", "sonorizzato", "sopito", "soppalcato", "soppesato", "soppiantato", "sopportato", "sopposto", "soppresso", "sopraddotato", "sopraeccitato", "sopraedificato", "sopraelevato", "sopraffato", "sopraffatto", "sopraggiunto", "soprainteso", "soprammesso", "soprannominato", "sopraposto", "soprappreso", "soprascritto", "sopraspeso", "soprassaturato", "soprasseduto", "sopravanzato", "sopravvalutato", "sopravveduto", "sopravvinto", "sopravvisto", "sopreccitato", "sopredificato", "soprelevato", "soprinteso", "sorbettato", "sorbito", "sorgiunto", "sormontato", "sorpassato", "sorpreso", "sorraso", "sorretto", "sorseggiato", "sorteggiato", "sortito", "sorvegliato", "sorvolato", "soscritto", "sospeso", "sospettato", "sospinto", "sospirato", "sostantivato", "sostanziato", "sostentato", "sostenuto", "sostituito", "sottaciuto", "sotterrato", "sotteso", "sottinteso", "sottoalimentato", "sottocapitalizzato", "sottodiviso", "sottoesposto", "sottofirmato", "sottolineato", "sottomesso", "sottomurato", "sottopagato", "sottopassato", "sottoposto", "sottorappresentato", "sottoriso", "sottoscritto", "sottostimato", "sottosviluppato", "sottotitolato", "sottovalutato", "sottratto", "soverchiato", "sovesciato", "sovietizzato", "sovracapitalizzato", "sovraccaricato", "sovradimensionato", "sovraeccitato", "sovraesposto", "sovraffaticato", "sovraffollato", "sovraggiunto", "sovraimposto", "sovrainteso", "sovralimentato", "sovramodulato", "sovrappopolato", "sovrapposto", "sovrariscaldato", "sovrasaturato", "sovrascritto", "sovrastampato", "sovrastato", "sovrastimato", "sovrautilizzato", "sovreccitato", "sovresposto", "sovrimposto", "sovrinteso", "sovvenuto", "sovvenzionato", "sovvertito", "spaccato", "spacchettato", "spacciato", "spaginato", "spaiato", "spalancato", "spalato", "spalcato", "spalleggiato", "spalmato", "spammato", "spampanato", "spampinato", "spanato", "spanciato", "spanduto", "spannato", "spannocchiato", "spanso", "spantanato", "spanto", "spaparacchiato", "spaparanzato", "spappolato", "sparato", "sparecchiato", "sparigliato", "sparito", "sparlato", "sparpagliato", "spartito", "spassato", "spassatoselo", "spastoiato", "spaurato", "spaurito", "spaventato", "spazializzato", "spaziato", "spazieggiato", "spazientito", "spazzato", "spazzolato", "specchiato", "specializzato", "specificato", "specillato", "specolato", "spedito", "spegnato", "spelacchiato", "spelato", "spellato", "spennacchiato", "spennato", "spennellato", "spento", "spenzolato", "sperato", "sperimentato", "spernacchiato", "speronato", "sperperato", "spersonalizzato", "sperticato", "spesato", "speso", "spessito", "spettacolarizzato", "spettinato", "spezzato", "spezzettato", "spezziato", "spezzonato", "spiaccicato", "spianato", "spiantato", "spiato", "spiattellato", "spiazzato", "spiccato", "spicciato", "spiccicato", "spicciolato", "spicconato", "spidocchiato", "spiegato", "spiegazzato", "spietrato", "spifferato", "spigionato", "spignorato", "spigolato", "spigrito", "spillato", "spilluzzicato", "spiluccato", "spinto", "spintonato", "spiombato", "spiralizzato", "spirantizzato", "spirato", "spiritualizzato", "spiumato", "spizzicato", "spodestato", "spoetizzato", "spogliato", "spolettato", "spoliato", "spoliticizzato", "spollonato", "spolmonato", "spolpato", "spoltronito", "spolverato", "spolverizzato", "spompato", "spompinato", "sponsorizzato", "spopolato", "spoppato", "sporcato", "sportato", "sporto", "sposato", "sposseduto", "spossessato", "spostato", "sposto", "sprangato", "sprecato", "spregiato", "spremuto", "spretato", "sprezzato", "sprigionato", "sprimacciato", "spromesso", "spronato", "sprotetto", "sprovincializzato", "sprovveduto", "sprovvisto", "spruzzato", "spugnato", "spulato", "spulciato", "spuntato", "spuntellato", "spupazzato", "spurgato", "sputacchiato", "sputato", "sputtanato", "squadernato", "squadrato", "squagliato", "squagliataselo", "squagliato", "squalificato", "squamato", "squarciato", "squartato", "squassato", "squattrinato", "squilibrato", "squinternato", "sradicato", "srotolato", "srugginito", "stabbiato", "stabilito", "stabilizzato", "stabulato", "staccato", "stacciato", "staffato", "staffilato", "staggiato", "staggito", "stagionato", "stagliato", "stagnato", "stamburato", "stampato", "stampigliato", "stanato", "stancato", "standardizzato", "stangato", "stanziato", "stappato", "starato", "starnazzato", "stasato", "statalizzato", "statizzato", "statoco", "statoseno", "statuito", "stazzato", "stazzonato", "steccacciato", "steccato", "stecchito", "stecconato", "stemperato", "stempiato", "stenografato", "stereotipato", "sterilito", "sterilizzato", "sterpato", "sterrato", "sterzato", "steso", "stigliato", "stigmatizzato", "stilato", "stilettato", "stilizzato", "stillato", "stimato", "stimolato", "stinto", "stipato", "stipendiato", "stipulato", "stiracchiato", "stirato", "stivato", "stizzito", "stoccato", "stolto", "stomacato", "stonato", "stondato", "stoppato", "stordito", "storicizzato", "stornato", "storpiato", "stortato", "storto", "stozzato", "strabenedetto", "strabuzzato", "stracannato", "straccato", "stracciato", "stracotto", "strafogato", "stragoduto", "stralciato", "stralodato", "stralunato", "stramaledetto", "stramortito", "strangolato", "straniato", "stranito", "straorzato", "strapagato", "strapazzato", "straperduto", "straperso", "strappato", "strasaputo", "strascicato", "strascinato", "strasformato", "stratificato", "strattonato", "stravaccato", "stravinto", "stravolto", "stravoluto", "straziato", "stregato", "stremato", "stressato", "striato", "stridulato", "strigato", "strigliato", "strillato", "striminzito", "strimpellato", "strinato", "stringato", "strisciato", "stritolato", "strizzato", "strofinato", "strombato", "strombazzato", "stroncato", "stronzato", "stropicciato", "stroppato", "stroppiato", "strozzato", "struccato", "strumentalizzato", "strumentato", "strusciato", "strutto", "strutturalizzato", "strutturato", "stuccato", "studiacchiato", "studiato", "stuellato", "stufato", "stupefatto", "stupito", "stuprato", "sturato", "stutato", "stuzzicato", "suaso", "subaffittato", "subappaltato", "subbiato", "subdelegato", "subissato", "subito", "sublicenziato", "sublimato", "sublocato", "subodorato", "subordinato", "subornato", "suburbanizzato", "sucato", "succhiato", "succhiellato", "succiato", "succinto", "succiso", "suddistinto", "suddiviso", "suffissato", "suffisso", "suffragato", "suffumicato", "suffuso", "suggellato", "suggerito", "suggestionato", "suicidato", "sunteggiato", "sunto", "suolato", "suonato", "superato", "superpagato", "superraffreddato", "supervalutato", "supervisionato", "supplicato", "supplito", "supportato", "supposto", "suppurato", "surclassato", "surfato", "surgelato", "surraffreddato", "surriscaldato", "surrogato", "survoltato", "suscitato", "susseguito", "sussidiato", "sussunto", "sussurrato", "suturato", "svaccato", "svagato", "svaligiato", "svalutato", "svapato", "svariato", "svasato", "svecchiato", "svegliato", "svelato", "svelenito", "sveltito", "svelto", "svenato", "svenduto", "sventagliato", "sventato", "sventolato", "sventrato", "sverginato", "svergognato", "svergolato", "sverminato", "sverniciato", "svestito", "svettato", "svezzato", "sviato", "svignatoselo", "svigorito", "svilito", "svillaneggiato", "sviluppato", "svinato", "svincolato", "sviolinato", "svirgolato", "svirilizzato", "svisato", "sviscerato", "svitato", "sviticchiato", "svolato", "svolazzato", "svolto", "svoluto", "svuotato", "tabuizzato", "tabulato", "taccato", "taccheggiato", "tacciato", "tacitato", "taciuto", "tagliato", "taglieggiato", "tagliuzzato", "talebanizzato", "tallonato", "tampinato", "tamponato", "tanguto", "tannato", "tappato", "tappezzato", "tarato", "tardato", "targato", "tariffato", "tarlato", "tarmato", "taroccato", "tarpato", "tartagliato", "tartassato", "tartufato", "tassato", "tassellato", "tastato", "tasteggiato", "tatuato", "tecnicizzato", "tecnologizzato", "tedeschizzato", "tediato", "teflonato", "telecomandato", "telecontrollato", "telediffuso", "telefonato", "telegrafato", "teleguidato", "telematizzato", "telemetrato", "teleradiotrasmesso", "teletrasmesso", "teletrasportato", "tematizzato", "temperato", "tempestato", "tempificato", "templatizzato", "temporizzato", "temprato", "temuto", "tentato", "tenuto", "teologizzato", "teorizzato", "tepefatto", "terebrato", "terminato", "termostatato", "terrazzato", "terrificato", "terrorizzato", "terso", "terzarolato", "terziarizzato", "terziato", "tesato", "tesaurizzato", "teso", "tesserato", "testato", "testificato", "testimoniato", "timbrato", "tindalizzato", "tinteggiato", "tinto", "tipicizzato", "tipizzato", "tippato", "tiranneggiato", "tirato", "titillato", "titolato", "toccato", "toelettato", "tollerato", "tolto", "tonalizzato", "tonificato", "tonneggiato", "tonsurato", "torchiato", "tormentato", "tornatoseno", "tornito", "torrefatto", "torto", "tortoreggiato", "torturato", "tosato", "toscaneggiato", "toscanizzato", "tostato", "totalizzato", "traboccato", "trabuccato", "tracannato", "tracciato", "tradito", "tradotto", "trafficato", "trafilato", "trafitto", "traforato", "trafugato", "traghettato", "traguardato", "trainato", "tralasciato", "tralignato", "tramandato", "tramato", "trambasciato", "tramesso", "tramestato", "tramezzato", "tramortito", "tramutato", "tranciato", "trangugiato", "tranquillato", "tranquillizzato", "transatto", "transceso", "transcodificato", "transcorso", "transcritto", "transennato", "transfluito", "transfuso", "transistorizzato", "translitterato", "transposto", "transricevuto", "transustanziato", "transveduto", "transvisto", "trapanato", "trapassato", "trapiantato", "traportato", "traposto", "trapposto", "trapuntato", "trapunto", "trarotto", "trasandato", "trasbordato", "trascelto", "trasceso", "trascinato", "trascorso", "trascritto", "trascurato", "trasdotto", "trasferito", "trasfigurato", "trasformato", "trasfuso", "trasgredito", "traslato", "traslitterato", "traslocato", "trasmesso", "trasmutato", "trasparito", "traspirato", "trasportato", "trasposto", "trastullato", "trasudato", "trasvolato", "trasvolto", "trattato", "tratteggiato", "trattenuto", "tratto", "traumatizzato", "travagliato", "travalicato", "travasato", "traveduto", "traversato", "travestito", "traviato", "travisato", "travisto", "travolto", "trebbiato", "triangolato", "tribbiato", "tribolato", "tributato", "triennalizzato", "trimestralizzato", "trincato", "trincerato", "trinciato", "tripartito", "triplicato", "trisecato", "trisezionato", "tritato", "triturato", "trivellato", "trollato", "trombato", "troncato", "tropicalizzato", "trovato", "truccato", "trucidato", "truffato", "tuffato", "tumefatto", "tumulato", "turato", "turbato", "turlupinato", "tutelato", "ubbligato", "ubicato", "ubidito", "ubiquitinato", "ubriacato", "uccellato", "uccellinato", "ucciso", "udito", "ufficializzato", "uggito", "ugnato", "uguagliato", "ulcerato", "ulito", "ulolato", "ultimato", "ultracentrifugato", "ululato", "umanato", "umanizzato", "umettato", "umidificato", "umidito", "umiliato", "uncinato", "unguentato", "unificato", "uniformato", "unito", "univerbato", "universaleggiato", "universalizzato", "untato", "unto", "uperizzato", "urbanizzato", "urgenzato", "urlato", "urtacchiato", "urtato", "urticchiato", "usato", "usciolato", "usolato", "ustionato", "usucapito", "usurato", "usurpato", "utilitato", "utilizzato", "vaccinato", "vagabondeggiato", "vagellato", "vagheggiato", "vagillato", "vagliato", "valcato", "valicato", "validato", "valorizzato", "valso", "valutato", "vanagloriato", "vanato", "vandalizzato", "vangato", "vangelizzato", "vanificato", "vanito", "vantaggiato", "vantato", "vaporato", "vaporizzato", "varato", "varcato", "variato", "vasectomizzato", "vaticinato", "vedovato", "veduto", "vegetato", "veggiato", "vegliato", "veicolato", "velarizzato", "velato", "velettato", "velinato", "vellicato", "vellutato", "velocizzato", "vendemmiato", "vendicato", "vendicchiato", "venducchiato", "venduto", "venerato", "vengiato", "ventagliato", "ventilato", "ventolato", "verbalizzato", "vergato", "vergheggiato", "vergognato", "vergolato", "verificato", "verminato", "vernalizzato", "verniciato", "verrinato", "versato", "verseggiato", "versificato", "verticalizzato", "vessato", "vestito", "vestito", "vetrificato", "vetrinato", "vetrioleggiato", "vettovagliato", "vezzeggiato", "viaggiato", "vicinato", "vicitato", "videochattato", "videochiamato", "videocomunicato", "videoregistrato", "videotrasmesso", "vidimato", "vigilato", "vigliato", "vigoreggiato", "vigorito", "vilificato", "vilipeso", "villaneggiato", "vincolato", "vinto", "violato", "violentato", "violinato", "virgolato", "virgoleggiato", "virgolettato", "virilizzato", "virtualizzato", "visionato", "visitato", "vissuto", "vistato", "visto", "visualizzato", "vitaliziato", "vitalizzato", "vitaminizzato", "vittimizzato", "vituperato", "vivacizzato", "vivandato", "vivificato", "vivisezionato", "viziato", "vocabolarizzato", "vocalizzato", "vocato", "vociferato", "volantinato", "volatilizzato", "volgarizzato", "volicchiato", "volpeggiato", "voltato", "volto", "voltolato", "volturato", "voluminizzato", "voluto", "volutoco", "vomitato", "vorato", "votato", "vulcanizzato", "vuotato", "wappato", "wikificato", "xerocopiato", "zaffato", "zampato", "zampettato", "zampillato", "zannato", "zappato", "zappettato", "zapponato", "zavorrato", "zeppato", "zigrinato", "zigzagato", "zimbellato", "zincato", "zinnato", "zipolato", "zippato", "zirlato", "zittito", "zizzagato", "zoccolato", "zollato", "zombato", "zonato", "zonizzato", "zoppato", "zoppeggiato", "zoppicato", "zucconato", "zufolato", "zumato", "zuppato", "abalienata", "abbacchiata", "abbacinata", "abbadata", "abbagliata", "abbaiata", "abballata", "abbambinata", "abbancata", "abbandonata", "abbarbagliata", "abbarbata", "abbarcata", "abbaruffata", "abbassata", "abbatacchiata", "abbattuta", "abbatuffolata", "abbelita", "abbellata", "abbellita", "abbendata", "abbeverata", "abbiadata", "abbicata", "abbigliata", "abbinata", "abbindolata", "abbioccata", "abbiosciata", "abbisciata", "abbittata", "abboccata", "abboffata", "abbominata", "abbonacciata", "abbonata", "abbonita", "abbordata", "abborracciata", "abborrata", "abborrita", "abbottinata", "abbottonata", "abbozzacchiata", "abbozzata", "abbozzolata", "abbracciata", "abbraciata", "abbrancata", "abbreviata", "abbriccata", "abbrigliata", "abbrivata", "abbriviata", "abbrividita", "abbronzata", "abbrostolata", "abbrostolita", "abbruciacchiata", "abbruciata", "abbrunata", "abbrunita", "abbruscata", "abbrusciata", "abbrustiata", "abbrustolata", "abbrustolita", "abbrutita", "abbruttita", "abbuffata", "abbuiata", "abbuonata", "abburattata", "abbuzzita", "abdicata", "abdotta", "abiettata", "abilitata", "abissata", "abitata", "abituata", "abiurata", "abolita", "abominata", "abondata", "aborrita", "abrasa", "abrogata", "abusata", "accaffata", "accagionata", "accagliata", "accalappiata", "accalcata", "accaldata", "accallata", "accalorata", "accalorita", "accambiata", "accampata", "accampionata", "accanalata", "accanata", "accaneggiata", "accanita", "accantonata", "accaparrata", "accapezzata", "accapigliata", "accapottata", "accappiata", "accappiettata", "accapponata", "accappucciata", "accaprettata", "accareggiata", "accarezzata", "accarnata", "accarpionata", "accartocciata", "accasata", "accasciata", "accasellata", "accasermata", "accastellata", "accastellinata", "accatarrata", "accatastata", "accattata", "accattivata", "accavalcata", "accavalciata", "accavallata", "accavezzata", "accecata", "acceffata", "accelerata", "accellerata", "accennata", "accensata", "accentata", "accentrata", "accentuata", "acceppata", "accerchiata", "accercinata", "accertata", "accesa", "accessoriata", "accettata", "acchetata", "acchiappata", "acchiocciolata", "acchitata", "acchiuduta", "acciabattata", "acciaiata", "acciambellata", "acciarpata", "acciecata", "accigliata", "acciglionata", "accignuta", "accincignata", "accinta", "acciocchita", "acciottolata", "accipigliata", "accismata", "accisa", "acciucchita", "acciuffata", "accivettata", "acclamata", "acclarata", "acclimatata", "acclusa", "accoccata", "accoccolata", "accoccovata", "accodata", "accollata", "accoltellata", "accolta", "accomandata", "accomiatata", "accommiatata", "accomodata", "accompagnata", "accomunata", "acconciata", "acconigliata", "accontata", "accontentata", "accoppata", "accoppiata", "accorata", "accorciata", "accorcita", "accordata", "accordellata", "accorpata", "accorta", "accosciata", "accostata", "accostumata", "accotonata", "accottimata", "accovacciata", "accovata", "accovonata", "accozzata", "accreditata", "accresciuta", "accrespata", "accucciata", "accucciolata", "accudita", "acculata", "acculturata", "accumulata", "accumunata", "accusata", "acetificata", "acetilata", "acetita", "acidata", "acidificata", "acidulata", "acquadernata", "acquarellata", "acquartierata", "acquata", "acquattata", "acquerellata", "acquetata", "acquietata", "acquisita", "acquistata", "acromatizzata", "acuita", "acuminata", "acutizzata", "adacquata", "adagiata", "adattata", "addaziata", "addebbiata", "addebitata", "addecimata", "addensata", "addentata", "addentellata", "addentrata", "addestrata", "addetta", "addiacciata", "addimandata", "addimesticata", "addimorata", "addimostrata", "addipanata", "addirizzata", "additata", "additivata", "addizionata", "addobbata", "addocilita", "addogliata", "addolcata", "addolciata", "addolcita", "addolorata", "addomandata", "addomesticata", "addoppiata", "addormentata", "addossata", "addotta", "addottorata", "addottrinata", "addrizzata", "adduata", "addugliata", "adeguata", "adempita", "adempiuta", "adequata", "aderizzata", "adescata", "adibita", "adirata", "adita", "adiuvata", "adizzata", "adocchiata", "adombrata", "adonata", "adonestata", "adontata", "adoperata", "adoprata", "adorata", "adornata", "adottata", "adsorbita", "aduggiata", "adugnata", "adulata", "adulterata", "adunata", "adunghiata", "adusata", "aerata", "aereata", "aerotrainata", "aerotrasportata", "affabulata", "affaccendata", "affacchinata", "affacciata", "affagottata", "affaldata", "affamata", "affamigliata", "affannata", "affardellata", "affascinata", "affastellata", "affaticata", "affattucchiata", "affatturata", "affermata", "afferrata", "affettata", "affezionata", "affiancata", "affiatata", "affibbiata", "affidata", "affienata", "affievolita", "affigliata", "affigurata", "affilata", "affilettata", "affiliata", "affinata", "affiochita", "affiorata", "affisata", "affissata", "affissa", "affittata", "affittita", "afflitta", "afflosciata", "affocata", "affogata", "affogliata", "affollata", "affoltata", "affondata", "afforcata", "afforestata", "afforzata", "affossata", "affralita", "affrancata", "affranta", "affratellata", "affrenata", "affrenellata", "affrescata", "affrettata", "affrittellata", "affrontata", "affumata", "affumicata", "affumigata", "affuocata", "affusolata", "africanizzata", "ageminata", "agevolata", "aggallata", "agganciata", "aggangherata", "aggarbata", "aggattonata", "aggavignata", "aggelata", "aggettivata", "agghiacciata", "agghiadata", "agghiaiata", "agghindata", "aggiaccata", "aggiogata", "aggiornata", "aggirata", "aggiucchita", "aggiudicata", "aggiuntata", "aggiunta", "aggiustata", "agglomerata", "agglutinata", "aggomitolata", "aggottata", "aggradita", "aggraffata", "aggranchiata", "aggranchita", "aggrandita", "aggrappata", "aggraticciata", "aggravata", "aggredita", "aggregata", "aggrevata", "aggricciata", "aggrinzata", "aggrinzita", "aggrommata", "aggrondata", "aggroppata", "aggrottata", "aggrovigliata", "aggrumata", "aggruppata", "aggruzzolata", "agguagliata", "agguantata", "agguardata", "agguatata", "aggueffata", "agitata", "agognata", "agrarizzata", "aguatata", "agucchiata", "agunata", "agurata", "aguzzata", "aitata", "aiutata", "aizzata", "alata", "alberata", "albergata", "alcalinizzata", "alchilata", "alchimiata", "alchimizzata", "alcolizzata", "alcoolizzata", "alenata", "alesata", "alettata", "alfabetata", "alfabetizzata", "alidita", "alienata", "alimentata", "allacciata", "allagata", "allappata", "allargata", "allascata", "allattata", "alleata", "allegata", "alleggerita", "alleggiata", "allegorizzata", "alleluiata", "allenata", "allenita", "allentata", "allertata", "allessata", "allestita", "allettata", "allevata", "alleviata", "allibata", "allibita", "allibrata", "allicciata", "allietata", "allindata", "allineata", "allisa", "allocata", "allogata", "alloggiata", "allontanata", "allottata", "allucchettata", "allucciolata", "allucinata", "allumata", "alluminata", "alluminiata", "allungata", "allupata", "allusa", "alluzzata", "alogenata", "alonata", "alpeggiata", "alterata", "alternata", "alzata", "amalgamata", "amareggiata", "amaricata", "amata", "ambientata", "ambiguata", "ambita", "americanizzata", "amicata", "ammaccata", "ammaestrata", "ammainata", "ammalata", "ammaliata", "ammalinconita", "ammaltata", "ammanettata", "ammanicata", "ammanierata", "ammanigliata", "ammannata", "ammannellata", "ammannita", "ammansata", "ammansita", "ammantata", "ammantellata", "ammarata", "ammarezzata", "ammassata", "ammassellata", "ammassicciata", "ammatassata", "ammattonata", "ammazzata", "ammelmata", "ammencita", "ammendata", "ammennicolata", "ammessa", "ammetata", "ammezzita", "amministrata", "amminutata", "ammirata", "ammiserita", "ammobiliata", "ammodernata", "ammodernizzata", "ammogliata", "ammoinata", "ammollata", "ammollita", "ammonita", "ammonticchiata", "ammonticellata", "ammorbata", "ammorbidata", "ammorbidita", "ammorsata", "ammortata", "ammortita", "ammortizzata", "ammorzata", "ammosciata", "ammoscita", "ammostata", "ammotinata", "ammucchiata", "ammulinata", "ammusata", "ammutata", "ammutinata", "amnistiata", "amoracciata", "ampiata", "ampliata", "amplificata", "amputata", "anagrammata", "analizzata", "anamorfizzata", "anastomizzata", "anatematizzata", "anatomizzata", "anchilosata", "ancisa", "ancorata", "andatosena", "andicappata", "anellata", "anemizzata", "anestetizzata", "angariata", "anglicizzata", "angolata", "angosciata", "angustiata", "animata", "annacquata", "annaffiata", "annasata", "annaspata", "annaspicata", "annebbiata", "annegata", "annerata", "annerita", "annessa", "annestata", "annichilata", "annichilita", "annidata", "annientata", "annitrita", "annobilita", "annodata", "annodicchiata", "annoiata", "annotata", "annottata", "annottolata", "annoverata", "annullata", "annunciata", "annunziata", "annusata", "annuvolata", "anodizzata", "anonimizzata", "anteceduta", "anteposta", "antergata", "anticheggiata", "antichizzata", "anticipata", "anticonosciuta", "antidatata", "antiveduta", "antivista", "antologizzata", "antropizzata", "antropomorfizzata", "aocchiata", "aombrata", "aonestata", "aontata", "aperta", "apocopata", "apologizzata", "apostrofata", "appaciata", "appacificata", "appagata", "appaiata", "appalesata", "appallottolata", "appaltata", "appanettata", "appannata", "apparata", "apparecchiata", "apparentata", "apparigliata", "apparita", "appartata", "appassionata", "appastata", "appastellata", "appellata", "appennellata", "appercepita", "appertizzata", "appesantita", "appesita", "appesa", "appestata", "appetita", "appezzata", "appiacevolita", "appianata", "appiastrata", "appiatata", "appiattata", "appiattita", "appiccata", "appiccicata", "appiccolita", "appiedata", "appigionata", "appigliata", "appinzata", "appiombata", "appioppata", "appisolata", "applaudita", "applicata", "appoderata", "appoggiata", "appollaiata", "appoppata", "apportata", "appostata", "apposta", "appratita", "appresentata", "appresa", "appressata", "apprestata", "apprettata", "apprezzata", "approcciata", "approfittata", "approfondata", "approfondita", "approntata", "appropinquata", "appropriata", "approssimata", "approvata", "approvisionata", "approvvigionata", "appruata", "appulcrata", "appuntata", "appuntellata", "appuntita", "appurata", "appuzzata", "arabescata", "arabizzata", "arata", "arbitrata", "arborata", "arcaizzata", "arcata", "architettata", "archiviata", "arcuata", "ardita", "areata", "argentata", "arginata", "argomentata", "arguita", "arianizzata", "arieggiata", "armata", "armonizzata", "aromatizzata", "arpeggiata", "arpionata", "arponata", "arrabattata", "arraffata", "arraffiata", "arrandellata", "arrangiata", "arrapata", "arrapinata", "arrappata", "arrazzata", "arrecata", "arredata", "arreggimentata", "arrembata", "arrenata", "arresisa", "arresa", "arrestata", "arretrata", "arricchita", "arricciata", "arricciolata", "arriffata", "arringata", "arrischiata", "arrisicata", "arrisa", "arrocata", "arroccata", "arrochita", "arrogata", "arrolata", "arroncata", "arronzata", "arrosata", "arrossata", "arrostata", "arrostita", "arrotata", "arrotolata", "arrotondata", "arrovellata", "arroventata", "arroventita", "arrovesciata", "arrubinata", "arruffata", "arruffianata", "arrugginita", "arruncigliata", "arruolata", "arruvidita", "arsicciata", "arsa", "artefatta", "articolata", "artigliata", "ascesa", "asciata", "asciolvuta", "asciugata", "ascoltata", "ascosa", "ascosta", "ascritta", "asfaltata", "asfissiata", "aspersa", "aspettata", "aspirata", "asportata", "aspreggiata", "assaettata", "assaggiata", "assalita", "assaltata", "assaporata", "assaporita", "assassinata", "assecondata", "assecurata", "assediata", "asseggiata", "assegnata", "assembiata", "assemblata", "assembrata", "assemprata", "assentata", "asserita", "asserragliata", "asservita", "assestata", "assetata", "assettata", "asseverata", "assibilata", "assicurata", "assiderata", "assiemata", "assiepata", "assillata", "assimigliata", "assimilata", "assiomatizzata", "assisa", "assistita", "associata", "assodata", "assoggettata", "assolcata", "assoldata", "assolta", "assolutizzata", "assomata", "assommata", "assonata", "assonnata", "assopita", "assorbita", "assordata", "assordita", "assortita", "assottigliata", "assuefatta", "assunta", "asteggiata", "astenuta", "astersa", "astratta", "astretta", "atomizzata", "atrofizzata", "atrovata", "attaccata", "attagliata", "attanagliata", "attardata", "attediata", "atteggiata", "attempata", "attendata", "attentata", "attenuata", "attenuta", "attergata", "atterrata", "atterrita", "atterzata", "attesa", "attestata", "atticizzata", "attillata", "attinta", "attirata", "attivata", "attivizzata", "attizzata", "attorcigliata", "attorniata", "attorta", "attoscata", "attossicata", "attraccata", "attrappita", "attratta", "attraversata", "attrezzata", "attribuita", "attristata", "attristita", "attruppata", "attualizzata", "attuata", "attuffata", "attutata", "attutita", "auggiata", "augumentata", "augurata", "aulita", "aumentata", "aunghiata", "ausata", "auscultata", "auspicata", "autenticata", "autentificata", "autoaccusata", "autoaffondata", "autoalimentata", "autoassolta", "autocandidata", "autocensurata", "autocitata", "autocommiserata", "autoconsumata", "autoconvinta", "autodefinita", "autodenunciata", "autodistrutta", "autofinanziata", "autogestita", "autogovernata", "autografata", "autoincensata", "autointersecata", "autoinvitata", "autolesionata", "autolimitata", "automaticizzata", "automatizzata", "automotivata", "autonominata", "autoproclamata", "autoprodotta", "autoprotetta", "autopubblicata", "autopubblicizzata", "autoregolamentata", "autoregolata", "autoridotta", "autoriparata", "autorizzata", "autosomministrata", "autosostenuta", "autosuggestionata", "autotassata", "autotrapiantata", "autotrasportata", "autovalutata", "avallata", "avampata", "avanzata", "avariata", "avinta", "aviolanciata", "aviotrasportata", "avocata", "avolterata", "avulsa", "avutacela", "avuta", "avvalorata", "avvalsa", "avvantaggiata", "avvelata", "avvelenata", "avventata", "avventurata", "avverata", "avversata", "avvertita", "avvezzata", "avviata", "avvicendata", "avvicinata", "avvignata", "avvilita", "avviluppata", "avvinata", "avvinchiata", "avvinghiata", "avvinta", "avvisata", "avvistata", "avvitata", "avviticchiata", "avvitita", "avvivata", "avvolta", "avvoltolata", "aziendalizzata", "azionata", "azotata", "azzannata", "azzardata", "azzeccata", "azzerata", "azzimata", "azzittata", "azzittita", "azzoppata", "azzoppita", "azzuffata", "azzurrata", "bacata", "baccagliata", "bacchettata", "bacchiata", "baciata", "badata", "bagnata", "baipassata", "balbettata", "balcanizzata", "ballata", "baloccata", "balzata", "banalizzata", "bancata", "bandita", "bannata", "baraccata", "barattata", "barbarizzata", "barcamenata", "bardata", "barellata", "barrata", "barricata", "basata", "basciata", "basculata", "bassata", "bastata", "bastionata", "bastita", "bastonata", "battezzata", "battuta", "bazzicata", "beatificata", "beata", "beccata", "beccheggiata", "becchettata", "beffata", "beffeggiata", "bendata", "benedetta", "beneficata", "benvoluta", "berlusconizzata", "bersagliata", "bestemmiata", "bevuta", "biadata", "bianchettata", "bianchita", "biascicata", "biasimata", "biasmata", "bidonata", "biennalizzata", "biforcata", "bigiata", "bilanciata", "binata", "bindolata", "biodegradata", "biografata", "bipartita", "bisbigliata", "biscottata", "bisecata", "bisellata", "bisognata", "bissata", "bistrata", "bistrattata", "bitumata", "bituminata", "blandita", "bleffata", "blindata", "bloccata", "bobinata", "boccheggiata", "bocciata", "boicottata", "bollata", "bollita", "bombardata", "bombata", "bonderizzata", "bonificata", "bootata", "borbottata", "bordata", "boriata", "borrata", "borseggiata", "braccata", "bracciata", "bramata", "bramita", "brancicata", "brandeggiata", "brandita", "brasata", "bravata", "brevettata", "breviata", "brillantata", "brillata", "brinata", "broccata", "brocciata", "broccolata", "brontolata", "bronzata", "brucata", "bruciacchiata", "bruciata", "brunita", "bruscata", "bruschinata", "brutalizzata", "bruttata", "bucata", "bucherellata", "bufata", "buffata", "bufferizzata", "buggerata", "bugnata", "bulicata", "bulinata", "bullettata", "bullonata", "burattata", "burlata", "burocratizzata", "burrificata", "buscata", "buttata", "butterata", "bypassata", "cablata", "cabrata", "cacata", "cacciata", "cadenzata", "cadmiata", "caducata", "cagata", "caggiata", "cagionata", "cagliata", "calafatata", "calamitata", "calandrata", "calata", "calcata", "calciata", "calcificata", "calcolata", "caldeggiata", "calettata", "calibrata", "calmata", "calmierata", "calpestata", "calumata", "calunniata", "calzata", "cambiata", "camerata", "campionata", "campita", "camuffata", "canalizzata", "cancellata", "cancerizzata", "candeggiata", "candidata", "candita", "canforata", "cangiata", "cannata", "canneggiata", "cannibalizzata", "cannoneggiata", "canonizzata", "cantata", "canterellata", "canticchiata", "cantilenata", "canzonata", "caolinizzata", "capacitata", "capeggiata", "capillarizzata", "capitalizzata", "capitanata", "capitaneggiata", "capita", "capitozzata", "capivolta", "caponata", "capotata", "capottata", "capovolta", "capponata", "captata", "caramellata", "caramellizzata", "caratata", "caratterizzata", "carbonizzata", "carbossilata", "carburata", "carcata", "carcerata", "cardata", "carenata", "carezzata", "cariata", "caricata", "caricaturata", "caricaturizzata", "carotata", "carpionata", "carpita", "carreggiata", "carrozzata", "cartavetrata", "carteggiata", "cartellinata", "cartografata", "cartolarizzata", "cartonata", "cascolata", "cassata", "cassa", "castigata", "castrata", "casualizzata", "catabolizzata", "catalizzata", "catalogata", "catapultata", "catechizzata", "categorizzata", "cateterizzata", "catramata", "cattolicizzata", "catturata", "causata", "cautelata", "cauterizzata", "cauzionata", "cavalcata", "cavatasela", "cavata", "cazzata", "cazziata", "cazzottata", "cedrata", "ceduta", "celata", "celebrata", "cellofanata", "cementata", "cementificata", "cennata", "censita", "censurata", "centellata", "centellinata", "centimetrata", "centinata", "centralizzata", "centrata", "centrifugata", "centuplicata", "cerata", "cercata", "cerchiata", "cernuta", "certificata", "cesellata", "cessata", "cestinata", "cheratinizzata", "chetata", "chiamata", "chiappata", "chiarificata", "chiarita", "chiaroscurata", "chiavata", "chiazzata", "chiesta", "chilificata", "chilometrata", "chimificata", "chinata", "chinizzata", "chiodata", "chiosata", "chiusa", "choccata", "ciancicata", "cianfrinata", "cianfrugliata", "ciangottata", "ciattata", "cibata", "cicatrizzata", "ciccata", "cicchettata", "ciclizzata", "ciclostilata", "cifrata", "cilindrata", "cimata", "cimentata", "cincischiata", "cinematografata", "cintata", "cinta", "cioncata", "ciondolata", "circolata", "circoncinta", "circoncisa", "circondata", "circondotta", "circonflessa", "circonfluita", "circonfusa", "circonscritta", "circonvenuta", "circoscritta", "circostanziata", "circuita", "circumcinta", "circumnavigata", "citata", "ciucciata", "ciurmata", "civettata", "civilizzata", "clamata", "classata", "classicizzata", "classificata", "cliccata", "climatizzata", "clivata", "clonata", "cloroformizzata", "clorurata", "clusterizzata", "co-diretta", "coacervata", "coadiuvata", "coagulata", "coalizzata", "coartata", "coccolata", "codificata", "coeditata", "coesistita", "cofinanziata", "cofirmata", "cofondata", "cogestita", "cogitata", "coglionata", "cognosciuta", "coibentata", "coincisa", "cointeressata", "cointestata", "coinvolta", "cokificata", "colata", "colettata", "collassata", "collaudata", "collazionata", "collegata", "collettivizzata", "collezionata", "collimata", "colliquata", "collisa", "collocata", "colluttata", "colmata", "colonizzata", "colorata", "colorita", "colorizzata", "colpevolizzata", "colpita", "coltellata", "coltivata", "colta", "coltrata", "comandata", "combattuta", "combinata", "comburuta", "comicizzata", "cominciata", "commemorata", "commendata", "commensurata", "commentata", "commercializzata", "commessa", "comminata", "commiserata", "commissariata", "commissionata", "commisurata", "commossa", "commutata", "comodata", "compaginata", "comparita", "compartimentalizzata", "compartita", "compassionata", "compatibilizzata", "compatita", "compattata", "compendiata", "compenetrata", "compensata", "comperata", "compiaciuta", "compianta", "compilata", "compitata", "compiuta", "complessata", "complessificata", "complessa", "completata", "complicata", "complimentata", "comportata", "compostata", "composta", "comprata", "compravenduta", "compresa", "compressa", "compromessa", "comprovata", "compulsata", "compunta", "computata", "computerizzata", "comunicata", "comunistizzata", "concatenata", "conceduta", "concelebrata", "concentrata", "concepita", "concertata", "concessa", "concettata", "concettualizzata", "conchiusa", "conciata", "conciliata", "concimata", "concitata", "conclamata", "conclusa", "concordata", "concotta", "concretata", "concretizzata", "conculcata", "concupita", "condannata", "condensata", "condita", "condivisa", "condizionata", "condoluta", "condonata", "condotta", "confatta", "confederata", "conferita", "confermata", "confessata", "confettata", "confezionata", "conficcata", "confidata", "configurata", "confinata", "confinta", "confiscata", "confitta", "conformata", "confortata", "confricata", "confrontata", "confusa", "confutata", "congedata", "congegnata", "congelata", "congestionata", "congetturata", "congiunta", "conglobata", "conglomerata", "conglutinata", "congratulata", "congregata", "conguagliata", "coniata", "coniugata", "connaturata", "connessa", "connotata", "connumerata", "conosciuta", "conquistata", "consacrata", "consapevolizzata", "consegnata", "conseguita", "consentita", "conservata", "considerata", "consigliata", "consistita", "consociata", "consolata", "consolidata", "consorziata", "consparsa", "conspersa", "constatata", "constretta", "construita", "consultata", "consumata", "consunta", "contabilizzata", "contagiata", "containerizzata", "contaminata", "contata", "contattata", "conteggiata", "contemperata", "contemplata", "contentata", "contenuta", "contesa", "contestata", "contestualizzata", "contingentata", "continuata", "contornata", "contorta", "contrabbandata", "contraccambiata", "contraddetta", "contraddistinta", "contradetta", "contraffatta", "contrappesata", "contrapposta", "contrappuntata", "contrariata", "contrassegnata", "contrastata", "contrata", "contrattaccata", "contrattata", "contratta", "contravvalsa", "contristata", "controbattuta", "controbilanciata", "controdatata", "controfirmata", "controindicata", "controllata", "controminata", "contronotata", "controproposta", "controprovata", "controquerelata", "controsoffittata", "controstampata", "controventata", "conturbata", "contusa", "convalidata", "convenuta", "convenzionata", "convertita", "convinta", "convitata", "convocata", "convogliata", "convolta", "coobata", "cooptata", "coordinata", "coperchiata", "coperta", "copiaincollata", "copiata", "copolimerizzata", "coppellata", "coprodotta", "corazzata", "corbellata", "corcata", "cordonata", "coreografata", "coricata", "cornificata", "coronata", "corredata", "correlata", "corresponsabilizzata", "corretta", "corricchiata", "corrisposta", "corroborata", "corrosa", "corrotta", "corrucciata", "corrugata", "corsa", "corteata", "corteggiata", "cortocircuitata", "coruscata", "cosata", "coscritta", "cosparsa", "cospersa", "costatata", "costeggiata", "costellata", "costernata", "costicchiata", "costipata", "costituita", "costituzionalizzata", "costretta", "costruita", "costudita", "cotonata", "cotta", "covata", "coventrizzata", "coverchiata", "craccata", "creata", "creduta", "cremata", "crepata", "cresciuta", "cresimata", "crespata", "criminalizzata", "crioconcentrata", "criptata", "cristallizzata", "cristianizzata", "criticata", "crittata", "crittografata", "crivellata", "crocchiata", "crocefissa", "crocefitta", "crocifissa", "crocifitta", "crogiolata", "cromata", "cronicizzata", "cronometrata", "crostata", "crucciata", "crucifissa", "crucifitta", "cuccata", "cucinata", "cucita", "cullata", "cumulata", "cuntata", "curata", "curvata", "curvata", "custodita", "customizzata", "damascata", "damaschinata", "damata", "dannata", "danneggiata", "danzata", "dardeggiata", "datata", "data", "dattilografata", "dattiloscritta", "daziata", "deacidificata", "deattivata", "debbiata", "debellata", "debilitata", "decaffeinata", "decaffeinizzata", "decalcata", "decalcificata", "decantata", "decapata", "decapitata", "decappottata", "decarbossilata", "decarburata", "decatizzata", "decelerata", "decentralizzata", "decentrata", "decerebrata", "decernuta", "decespugliata", "deciferata", "decifrata", "decimalizzata", "decimata", "decisa", "declamata", "declassata", "declassificata", "declinata", "declorata", "decodificata", "decolonizzata", "decolorata", "decompartimentata", "decompilata", "decomposta", "decompressa", "deconcentrata", "decondizionata", "decongelata", "decongestionata", "decontaminata", "decontestualizzata", "decontratta", "decorata", "decorticata", "decostruita", "decrementata", "decretata", "decriminalizzata", "decriptata", "decrittata", "decuplicata", "decurtata", "dedicata", "dedotta", "defacciata", "defalcata", "defascistizzata", "defecata", "defenestrata", "deferita", "defilata", "definita", "defiscalizzata", "defitta", "deflazionata", "deflemmata", "deflorata", "defogliata", "defoliata", "deforestata", "deformata", "defosforata", "defosforilata", "deframmentata", "defraudata", "degassata", "degassificata", "deglutita", "degnata", "degradata", "degustata", "deidratata", "deidrogenata", "deificata", "deindicizzata", "deindustrializzata", "deionizzata", "delegata", "delegificata", "delegittimata", "delibata", "deliberata", "delimitata", "delineata", "delirata", "deliziata", "delocalizzata", "delucidata", "delusa", "demagnetizzata", "demandata", "demanializzata", "demarcata", "demeritata", "demersa", "demetallizzata", "demilitarizzata", "demineralizzata", "demistificata", "demitizzata", "democratizzata", "demodulata", "demolita", "demoltiplicata", "demonetata", "demonetizzata", "demonizzata", "demoralizzata", "demorsa", "demotivata", "denaturalizzata", "denaturata", "denazificata", "denazionalizzata", "denicotinizzata", "denigrata", "denitrificata", "denocciolata", "denominata", "denotata", "dentellata", "denuclearizzata", "denudata", "denunciata", "denunziata", "deodorata", "deossidata", "deossigenata", "deostruita", "depauperata", "depenalizzata", "depennata", "depilata", "depinta", "depistata", "deplorata", "depolarizzata", "depolimerizzata", "depoliticizzata", "depolverizzata", "deportata", "depositata", "deposta", "depotenziata", "depravata", "deprecata", "depredata", "depressa", "depressurizzata", "deprezzata", "deprivata", "deprotonata", "depulsa", "depurata", "dequalificata", "deratizzata", "derattizzata", "dereferenziata", "deregolamentata", "deregolata", "derequisita", "deresponsabilizzata", "derisa", "derubata", "derubricata", "desacralizzata", "desalata", "desalinizzata", "descolarizzata", "descritta", "desecretata", "desegretata", "deselezionata", "desensibilizzata", "desessualizzata", "desiata", "desiderata", "designata", "desinata", "desirata", "desolata", "desolforata", "desonorizzata", "desorbita", "desossidata", "desquamata", "destabilizzata", "destagionalizzata", "destalinizzata", "destatalizzata", "destatizzata", "destata", "destinata", "destituita", "destoricizzata", "destreggiata", "destrutta", "destrutturata", "desunta", "detassata", "detenuta", "deteriorata", "determinata", "detersa", "detestata", "detonata", "detorta", "detossificata", "detratta", "detronizzata", "dettagliata", "dettata", "detta", "deturpata", "deumidificata", "devastata", "deventata", "deviata", "deviscerata", "devitalizzata", "devitaminizzata", "devoluta", "dezippata", "diaframmata", "diagnosticata", "diagonalizzata", "diagrammata", "dializzata", "dialogata", "dialogizzata", "diazotata", "dibattuta", "diboscata", "dichiarata", "diesata", "diesizzata", "difesa", "diffamata", "differita", "diffidata", "diffranta", "diffratta", "diffusa", "digerita", "digitalizzata", "digitata", "digiunta", "digrassata", "digrignata", "digrossata", "dilacerata", "dilaniata", "dilapidata", "dilatata", "dilavata", "dilazionata", "dileggiata", "dileguata", "dilettata", "diletta", "diliscata", "dilucidata", "diluita", "dilungata", "dimagrata", "dimandata", "dimenata", "dimensionata", "dimenticata", "dimerizzata", "dimessa", "dimezzata", "diminuita", "dimissionata", "dimostrata", "dimunta", "dinamizzata", "dinoccata", "dipanata", "dipelata", "dipinta", "diplomata", "diposta", "diradata", "diramata", "diretta", "direzionata", "dirimuta", "diroccata", "dirottata", "dirotta", "dirozzata", "disabilitata", "disabituata", "disaccentata", "disaccoppiata", "disaccordata", "disacerbata", "disacidata", "disacidificata", "disacidita", "disaerata", "disaffezionata", "disaggregata", "disalberata", "disallineata", "disamata", "disambiguata", "disaminata", "disamorata", "disancorata", "disanimata", "disappannata", "disapplicata", "disappresa", "disapprovata", "disarcionata", "disarmata", "disarticolata", "disascosta", "disassemblata", "disassuefatta", "disatomizzata", "disattesa", "disattivata", "disattrezzata", "disavvezzata", "disboscata", "disbrigata", "discacciata", "discalzata", "discantata", "discaricata", "discernuta", "discesa", "disceverata", "dischiesta", "dischiusa", "discinta", "disciolta", "disciplinata", "discolorata", "discolpata", "discommessa", "discompagnata", "discomposta", "disconclusa", "disconfitta", "discongiunta", "disconnessa", "disconosciuta", "discoperta", "discordata", "discoscesa", "discostata", "discreditata", "discresciuta", "discriminata", "discritta", "discucita", "discuoiata", "discussa", "disdegnata", "disdettata", "disdetta", "diseccata", "diseccitata", "diseducata", "disegnata", "diserbata", "diseredata", "disertata", "diserta", "disfatta", "disgelata", "disgiunta", "disgraziata", "disgregata", "disgustata", "disidentificata", "disiderata", "disidratata", "disillusa", "disimballata", "disimparata", "disimpegnata", "disimpressa", "disincagliata", "disincantata", "disincentivata", "disincrostata", "disindustrializzata", "disinfestata", "disinfettata", "disinflazionata", "disinformata", "disingannata", "disingranata", "disinibita", "disinnamorata", "disinnescata", "disinnestata", "disinquinata", "disinserita", "disinstallata", "disintasata", "disintegrata", "disinteressata", "disintesa", "disintossicata", "disinvestita", "disinvolta", "disistimata", "dislocata", "dismessa", "disobbedita", "disobbligata", "disonorata", "disordinata", "disorganizzata", "disorientata", "disormeggiata", "disossata", "disossidata", "disostruita", "disotterrata", "disparita", "dispensata", "dispenta", "disperduta", "dispersa", "dispesa", "dispiegata", "dispinta", "dispogliata", "disposta", "dispregiata", "disprezzata", "dispromessa", "disproporzionata", "disputata", "disqualificata", "disrotta", "dissacrata", "dissalata", "dissaldata", "dissanguata", "dissecata", "disseccata", "disselciata", "dissellata", "disseminata", "dissepolta", "disseppellita", "dissequestrata", "disserrata", "dissestata", "dissetata", "dissezionata", "dissigillata", "dissimulata", "dissipata", "dissociata", "dissodata", "dissolta", "dissomigliata", "dissotterrata", "dissuasa", "dissuggellata", "distaccata", "distanziata", "distesa", "distillata", "distinta", "distolta", "distorta", "distratta", "distretta", "distribuita", "districata", "distrigata", "distrutta", "disturbata", "disubbidita", "disumanata", "disumanizzata", "disunita", "disusata", "disveduta", "disvelata", "disvestita", "disviata", "disvista", "disvolta", "disvoluta", "dittongata", "divallata", "divaricata", "divelta", "diversificata", "divertita", "divezzata", "divinata", "divincolata", "divinizzata", "divisa", "divolta", "divorata", "divorziata", "divulgata", "documentata", "dogata", "dogmatizzata", "dolcificata", "dollarizzata", "dolorata", "doluta", "domandata", "domata", "domesticata", "domiciliata", "dominata", "donata", "dondolata", "dopata", "doppiata", "dorata", "dormitoca", "dosata", "dotata", "dovuta", "dragata", "drammatizzata", "drappeggiata", "drenata", "dribblata", "drizzata", "drogata", "dugliata", "duplicata", "duramificata", "ebraizzata", "ecceduta", "eccepita", "eccettuata", "eccitata", "echeggiata", "eclissata", "economizzata", "edificata", "editata", "edotta", "educata", "edulcorata", "effettuata", "efficientata", "effigiata", "effinta", "effluita", "effusa", "egemonizzata", "eguagliata", "eiettata", "elaborata", "elargita", "elasticizzata", "elementarizzata", "elemosinata", "elencata", "eletta", "elettrificata", "elettrizzata", "elettrocoagulata", "elettrolizzata", "elevata", "eliminata", "elisa", "elitrasportata", "ellenizzata", "elogiata", "elucidata", "elucubrata", "eluita", "elusa", "emanata", "emancipata", "emarginata", "embricata", "emendata", "emessa", "emozionata", "empita", "empiuta", "emulata", "emulsionata", "emunta", "encomiata", "endocitata", "energizzata", "enfatizzata", "enfiata", "entusiasmata", "enucleata", "enumerata", "enunciata", "epicureggiata", "epurata", "equalizzata", "equilibrata", "equipaggiata", "equiparata", "eradicata", "erasa", "ereditata", "eretta", "erogata", "eroicizzata", "erosa", "erotizzata", "erpicata", "ersa", "erudita", "eruttata", "esacerbata", "esagerata", "esagitata", "esalata", "esaltata", "esaminata", "esasperata", "esaudita", "esaurita", "esautorata", "esborsata", "esclusa", "escogitata", "escomiata", "escoriata", "escossa", "escussa", "esecrata", "esecutata", "eseguita", "esemplificata", "esentata", "esercitata", "esfoliata", "esibita", "esilarata", "esiliata", "esimuta", "esitata", "esonerata", "esorbitata", "esorcizzata", "esortata", "espansa", "esparsa", "esperimentata", "esperita", "espettorata", "espiantata", "espiata", "espirata", "espletata", "esplicata", "esplicitata", "esplorata", "esplosa", "esportata", "esposta", "espressa", "espropriata", "espugnata", "espulsa", "espunta", "espurgata", "essiccata", "essuta", "estasiata", "estenuata", "esterificata", "esteriorizzata", "esterminata", "esternalizzata", "esternata", "estesa", "estimata", "estinta", "estirpata", "estivata", "estorta", "estradata", "estraniata", "estrapolata", "estratta", "estremizzata", "estrinsecata", "estromessa", "estrusa", "estubata", "esulcerata", "esultata", "esumata", "eterificata", "eterizzata", "eternata", "eternizzata", "etichettata", "etossilata", "euforizzata", "europeizzata", "evacuata", "evangelizzata", "evasa", "eveta", "evidenziata", "evinta", "evirata", "eviscerata", "evitata", "evocata", "evolta", "evoluta", "evulsa", "fabbricata", "faccettata", "facilitata", "fagocitata", "falciata", "falcidiata", "fallita", "falsata", "falsificata", "familiarizzata", "fanatizzata", "fantasticata", "farcita", "farfugliata", "fasciata", "fascicolata", "fascistizzata", "fattacela", "fatta", "fattorizzata", "fatturata", "favellata", "favoreggiata", "favorita", "faxata", "fecondata", "fedecommessa", "federalizzata", "federata", "felicitata", "felpata", "feltrata", "femminilizzata", "fenduta", "ferita", "fermata", "fermentata", "ferrata", "fertilizzata", "fessa", "fessurata", "festeggiata", "festonata", "feudalizzata", "fiaccata", "fiammeggiata", "fiancheggiata", "ficcata", "fidanzata", "fidata", "fidecommessa", "fidelizzata", "figliata", "figurata", "filata", "filettata", "filmata", "filosofata", "filtrata", "finalizzata", "finanziata", "finitala", "finita", "finlandizzata", "fintata", "finta", "fiocinata", "fiondata", "fiorettata", "firmata", "fiscalizzata", "fischiata", "fischiettata", "fissata", "fissionata", "fitta", "fiutata", "flagellata", "flaggata", "flambata", "flangiata", "flemmatizzata", "flessa", "flippata", "flottata", "fluidificata", "fluidizzata", "fluorizzata", "fluorurata", "focalizzata", "focheggiata", "foderata", "foggiata", "fognata", "folgorata", "follata", "fomentata", "fonata", "fondata", "foracchiata", "foraggiata", "forata", "forestata", "forfettizzata", "forgiata", "formalizzata", "formata", "formattata", "formilata", "formulata", "fornita", "fortificata", "forviata", "forwardata", "forzata", "fosfatata", "fosforata", "fosforilata", "fossilizzata", "fotocomposta", "fotocopiata", "fotografata", "fottuta", "fracassata", "fraintesa", "framessa", "frammentata", "frammessa", "frammezzata", "frammischiata", "franceseggiata", "francesizzata", "frangiata", "franta", "frantumata", "frappata", "frapposta", "fraseggiata", "frastagliata", "frastornata", "fratturata", "frazionata", "freddata", "fregata", "fregiata", "frenata", "frequentata", "fresata", "frettata", "friendzonata", "fritta", "frizionata", "frodata", "frollata", "fronteggiata", "frugata", "fruita", "frullata", "frusciata", "frustata", "frustrata", "fruttata", "fucilata", "fucinata", "fugata", "fuggita", "fulminata", "fumata", "fumigata", "funestata", "funta", "funzionata", "fuoriuscita", "fuorviata", "fusa", "fustellata", "fustigata", "gabbata", "gabellata", "gallata", "gallicizzata", "gallonata", "galvanizzata", "gambizzata", "garantita", "garnettata", "garrotata", "garzata", "gasata", "gassata", "gassificata", "gazata", "gelatinizzata", "gelata", "gelificata", "gemellata", "gemicata", "geminata", "generalizzata", "generata", "gentrificata", "genuflessa", "geometrizzata", "georeferenziata", "gerarchizzata", "germanizzata", "gestita", "gettata", "gettonata", "ghermita", "ghettizzata", "ghigliottinata", "ghindata", "gibollata", "gingillata", "ginnata", "giocata", "gioita", "gionglata", "giovaneggiata", "girandolata", "girata", "giudicata", "giulebbata", "giuntata", "giunta", "giuracchiata", "giurata", "giustapposta", "giustificata", "giustiziata", "glamourizzata", "glassata", "glissata", "globalizzata", "gloriata", "glorificata", "glossata", "godronata", "goduta", "goffrata", "gommata", "gonfiata", "googlata", "gottata", "governata", "gradinata", "gradita", "gradualizzata", "graduata", "graffata", "graffiata", "graffita", "graficata", "grafitata", "gramolata", "granagliata", "grandinata", "granellata", "granita", "granulata", "graticciata", "graticolata", "gratificata", "gratinata", "grattata", "grattugiata", "gravata", "graziata", "grecheggiata", "grecizzata", "gremita", "gridata", "griffata", "grigliata", "grippata", "groccata", "grondata", "grugata", "grugnita", "guadagnata", "gualcita", "guardata", "guarita", "guarnita", "guastata", "guatata", "guerreggiata", "gufata", "guidata", "gustata", "hackerata", "handicappata", "ibridata", "idealizzata", "ideata", "identificata", "ideologizzata", "idolatrata", "idoleggiata", "idratata", "idrogenata", "idrolizzata", "iettata", "igienizzata", "ignifugata", "ignorata", "illanguidita", "illeggiadrita", "illividita", "illuminata", "illusa", "illustrata", "imbacuccata", "imbaldanzita", "imballata", "imbalsamata", "imbambolata", "imbandierata", "imbandita", "imbarbarita", "imbarcata", "imbarilata", "imbastardita", "imbastita", "imbattuta", "imbavagliata", "imbeccata", "imbellettata", "imbellita", "imbestialita", "imbestiata", "imbevuta", "imbiaccata", "imbiancata", "imbianchita", "imbibita", "imbiettata", "imbiondita", "imbizzarrita", "imboccata", "imbonita", "imborghesita", "imboscata", "imboschita", "imbottata", "imbottigliata", "imbottita", "imbozzimata", "imbracata", "imbracciata", "imbragata", "imbrancata", "imbrattata", "imbrecciata", "imbrigliata", "imbrillantinata", "imbroccata", "imbrodata", "imbrogliata", "imbronciata", "imbruttita", "imbucata", "imbudellata", "imbullettata", "imbullonata", "imburrata", "imbussolata", "imbustata", "imbutita", "imitata", "immagazzinata", "immaginata", "immalinconita", "immatricolata", "immedesimata", "immersa", "immessa", "immischiata", "immiserita", "immobilizzata", "immolata", "immortalata", "immunizzata", "immusonita", "impaccata", "impacchettata", "impacciata", "impadronita", "impaginata", "impagliata", "impalata", "impalcata", "impallata", "impallinata", "impalmata", "impaludata", "impanata", "impaniata", "impannata", "impantanata", "impaperata", "impapocchiata", "impappinata", "imparentata", "imparruccata", "impartita", "impastata", "impasticcata", "impasticciata", "impastocchiata", "impastoiata", "impataccata", "impattata", "impaurita", "impavesata", "impeciata", "impedicata", "impedita", "impegnata", "impegolata", "impelagata", "impellicciata", "impennacchiata", "impennata", "impensierita", "impepata", "imperlata", "impermalita", "impermeabilizzata", "imperniata", "impersonata", "impersonificata", "impestata", "impetrata", "impiallacciata", "impiantata", "impiastrata", "impiastricciata", "impiccata", "impicciata", "impicciolita", "impiccolita", "impidocchiata", "impiegata", "impietosita", "impietrita", "impigliata", "impigrita", "impilata", "impillaccherata", "impinguata", "impinta", "impinzata", "impiombata", "impipata", "impiumata", "implementata", "implicata", "implorata", "impollinata", "impolpata", "impoltronita", "impolverata", "impomatata", "imporcata", "imporporata", "importata", "importunata", "impossessata", "impossibilitata", "impostata", "imposta", "impratichita", "impregnata", "impresa", "impressionata", "impressa", "imprestata", "impreziosita", "imprigionata", "impromessa", "improntata", "improsciuttita", "impugnata", "impuntita", "impunturata", "impupata", "imputata", "impuzzolentita", "inabilitata", "inabissata", "inacerbita", "inacetita", "inacidita", "inacutita", "inaffiata", "inalata", "inalberata", "inalveata", "inalzata", "inamidata", "inanellata", "inarcata", "inargentata", "inaridita", "inasprita", "inastata", "inattivata", "inaugurata", "incacchiata", "incalcinata", "incalorita", "incalzata", "incamerata", "incamiciata", "incamminata", "incanaglita", "incanalata", "incannata", "incannucciata", "incaponita", "incappottata", "incappucciata", "incaprettata", "incapricciata", "incapsulata", "incarcerata", "incardinata", "incaricata", "incarnata", "incarrozzata", "incartata", "incartocciata", "incartonata", "incasellata", "incasinata", "incassata", "incastellata", "incastonata", "incastrata", "incatenata", "incatramata", "incattivita", "incavata", "incavigliata", "incavolata", "incazzata", "incellofanata", "incendiata", "incenerita", "incensata", "incentivata", "incentrata", "inceppata", "incerata", "incernierata", "incerottata", "incesa", "incettata", "inchiappettata", "inchiavardata", "inchiesta", "inchinata", "inchiodata", "inchiostrata", "incipriata", "incisa", "incistata", "incitata", "inciuccata", "incivilita", "inclinata", "inclusa", "incoccata", "incocciata", "incoiata", "incollata", "incolonnata", "incolpata", "incominciata", "incomodata", "incontrata", "incoraggiata", "incordata", "incornata", "incorniciata", "incoronata", "incorporata", "incotta", "incravattata", "incrementata", "increspata", "incretinita", "incriminata", "incrinata", "incrociata", "incrostata", "incrudelita", "incrudita", "incruscata", "incubata", "inculata", "inculcata", "incuneata", "incuoiata", "incuorata", "incupita", "incuriosita", "incurvata", "incussa", "indagata", "indebitata", "indebolita", "indemaniata", "indennizzata", "indetta", "indicata", "indicizzata", "indignata", "indiretta", "indirizzata", "indispettita", "indisposta", "individualizzata", "individuata", "indolenzita", "indorata", "indossata", "indotta", "indottoma", "indottrinata", "indovinata", "indugiata", "indulta", "indurata", "indurita", "industrializzata", "industriata", "inebetita", "inebriata", "inerita", "inerpicata", "infagottata", "infamata", "infangata", "infarcita", "infarinata", "infastidita", "infatuata", "infeltrita", "inferita", "inferocita", "inferta", "infervorata", "infestata", "infettata", "infeudata", "infiacchita", "infialata", "infialettata", "infiammata", "infiascata", "infibulata", "inficiata", "infilata", "infiltrata", "infilzata", "infingardita", "infinocchiata", "infinta", "infioccata", "infiocchettata", "infiochita", "infiorata", "infirmata", "infischiata", "infissa", "infittita", "inflazionata", "inflessa", "inflitta", "influenzata", "infocata", "infoderata", "infognata", "infoibata", "infoltita", "inforcata", "informatizzata", "informata", "informicolata", "informicolita", "infornaciata", "infornata", "infortunata", "infoscata", "infossata", "infradiciata", "inframessa", "inframezzata", "inframmessa", "inframmezzata", "infrancesata", "infrapposta", "infrascata", "infrattata", "infreddata", "infronzolata", "infuocata", "infurbita", "infuriata", "ingabbiata", "ingaggiata", "ingagliardita", "ingannata", "ingarbugliata", "ingavonata", "ingegnata", "ingegnerizzata", "ingelosita", "ingemmata", "ingenerata", "ingentilita", "ingerita", "ingessata", "inghiaiata", "inghiottita", "inghirlandata", "ingiallita", "ingigantita", "inginocchiata", "ingioiellata", "ingiunta", "ingiuriata", "inglesizzata", "inglobata", "ingoffita", "ingoiata", "ingolfata", "ingollata", "ingolosita", "ingombrata", "ingommata", "ingorgata", "ingozzata", "ingranata", "ingrandita", "ingrassata", "ingraticciata", "ingraticolata", "ingravidata", "ingraziata", "ingraziosita", "ingrigita", "ingrommata", "ingrossata", "ingrullita", "inguaiata", "inguainata", "ingualdrappata", "inguantata", "ingurgitata", "inibita", "iniettata", "inimicata", "inizializzata", "iniziata", "inmillata", "innacquata", "innaffiata", "innalzata", "innamorata", "innastata", "innervata", "innervosita", "innescata", "innestata", "innevata", "innocentata", "innocuizzata", "innovata", "inoculata", "inoltrata", "inondata", "inorgoglita", "inorpellata", "inorridita", "inquadrata", "inquietata", "inquisita", "insabbiata", "insacchettata", "insalata", "insaldata", "insalivata", "insanguinata", "insaponata", "insaporita", "inscatolata", "inscenata", "inscritta", "insecchita", "insediata", "insegnata", "inseguita", "insellata", "inselvatichita", "inserita", "insidiata", "insignita", "insilata", "insinuata", "insolentita", "insonnolita", "insonorizzata", "insordita", "insospettita", "insozzata", "inspessita", "inspirata", "installata", "instaurata", "insterilita", "instillata", "instituita", "instradata", "insudiciata", "insufflata", "insultata", "insuperbita", "intabaccata", "intabarrata", "intaccata", "intagliata", "intarsiata", "intasata", "intascata", "intavolata", "integrata", "intelaiata", "intelata", "intellettualizzata", "intenebrata", "intenerita", "intensificata", "intentata", "intepidita", "intercalata", "intercambiata", "intercettata", "intercisa", "interclusa", "intercollegata", "interconnessa", "interconvertita", "interdetta", "interessata", "interfacciata", "interfogliata", "interfoliata", "interiorizzata", "interlacciata", "interlineata", "intermessa", "intermezzata", "internalizzata", "internata", "internazionalizzata", "interpellata", "interpenetrata", "interpolata", "interposta", "interpretata", "interpunta", "interrata", "interrogata", "interrotta", "intersecata", "intervallata", "intervistata", "intesa", "intessuta", "intestardita", "intestata", "intiepidita", "intimata", "intimidita", "intimorita", "intinta", "intirizzita", "intitolata", "intonacata", "intonata", "intontita", "intorbidata", "intorbidita", "intorpidita", "intortata", "intossicata", "intralciata", "intramessa", "intramezzata", "intrappolata", "intrapresa", "intrattenuta", "intraveduta", "intravista", "intravveduta", "intravvista", "intrecciata", "intricata", "intrigata", "intrinsecata", "intrippata", "intrisa", "introdotta", "introflessa", "introiettata", "introitata", "intromessa", "intronata", "intronizzata", "intruduta", "intrufolata", "intrugliata", "intruppata", "intrusa", "intubata", "intubettata", "intuita", "inumata", "inumidita", "inurbata", "inutilizzata", "invaghita", "invaginata", "invalidata", "invasata", "invasa", "invelenita", "inventariata", "inventata", "invenuta", "inverdita", "invergata", "inverniciata", "investigata", "investita", "invetriata", "inviata", "invidiata", "invigorita", "inviluppata", "invischiata", "invitata", "invocata", "invogliata", "involata", "involgarita", "involtata", "involta", "inzaccherata", "inzeppata", "inzigata", "inzolfata", "inzuccata", "inzuccherata", "inzuppata", "iodurata", "ionizzata", "ipertrofizzata", "ipnotizzata", "ipostatizzata", "ipotecata", "ipotizzata", "iridata", "irradiata", "irraggiata", "irreggimentata", "irretita", "irrigata", "irrigidita", "irrisa", "irritata", "irrobustita", "irrogata", "irrorata", "irrugginita", "irruvidita", "ischeletrita", "iscritta", "islamizzata", "isolata", "isomerizzata", "ispanizzata", "ispessita", "ispezionata", "ispirata", "issata", "istallata", "istanziata", "istaurata", "isterilita", "istigata", "istillata", "istituita", "istituzionalizzata", "istoriata", "istradata", "istruita", "istupidita", "italianeggiata", "italianizzata", "iterata", "iudicata", "killerata", "labbreggiata", "labializzata", "laccata", "lacerata", "laconizzata", "lacrimata", "ladroneggiata", "lagnata", "lagrimata", "laicizzata", "lambiccata", "lambita", "lamentata", "laminata", "lanciata", "lapidata", "lappata", "lardata", "lardellata", "largita", "larvata", "lascata", "lasciata", "lastricata", "latinizzata", "laudata", "laureata", "lavata", "lavorata", "leccata", "legalizzata", "legata", "leggicchiata", "leggiucchiata", "legittimata", "legittimizzata", "legnata", "lemmatizzata", "lenita", "lesinata", "lesionata", "lesa", "lessata", "letta", "levata", "levigata", "liberalizzata", "liberata", "licenziata", "lievitata", "liftata", "lignificata", "limata", "limitata", "linciata", "linearizzata", "lineata", "linkata", "liofilizzata", "liquefatta", "liquidata", "lisata", "lisciata", "lisciviata", "listata", "litografata", "livellata", "lizzata", "lobotomizzata", "localizzata", "locata", "lodata", "logorata", "lordata", "lottata", "lottizzata", "lubrificata", "lucchettata", "lucidata", "lucrata", "lumeggiata", "luppolizzata", "lusingata", "lussata", "lustrata", "macadamizzata", "macchiata", "macchinata", "macellata", "macerata", "maciullata", "maggesata", "maggiorata", "magnata", "magnetizzata", "magnificata", "maiolicata", "maledetta", "malfatta", "malignata", "malmenata", "malmessa", "maltata", "maltrattata", "malveduta", "malversata", "malvista", "malvoluta", "mandata", "mandrinata", "manducata", "maneggiata", "manganata", "manganellata", "mangiata", "mangiucchiata", "manifatturata", "manifestata", "manimessa", "manipolata", "manlevata", "manomessa", "manoscritta", "manovrata", "mansuefatta", "mantecata", "mantenutasa", "mantenuta", "manualizzata", "manutenuta", "mappata", "marcata", "marchiata", "marcita", "marezzata", "marginalizzata", "marginata", "margottata", "marimessa", "marinata", "maritata", "marmorizzata", "marnata", "marocchinata", "martellata", "martellinata", "martirizzata", "martoriata", "mascherata", "maschiata", "maschiettata", "mascolinizzata", "massacrata", "massaggiata", "massellata", "massicciata", "massificata", "massimata", "massimizzata", "mastectomizzata", "masterizzata", "masticata", "masturbata", "matematizzata", "materializzata", "matricolata", "mattonata", "maturata", "mazziata", "mazzolata", "meccanizzata", "medagliata", "mediata", "medicalizzata", "medicata", "meditata", "membrata", "memorizzata", "menata", "mendicata", "menomata", "mentovata", "menzionata", "meravigliata", "mercanteggiata", "mercerizzata", "mercificata", "meriata", "meridionalizzata", "meritata", "merlata", "merlettata", "mersa", "mesciata", "mesciuta", "mescolata", "mescuta", "mesmerizzata", "messaggiata", "messa", "messoca", "mestata", "mesticata", "mestruata", "metabolizzata", "metaforeggiata", "metaforizzata", "metallizzata", "metamorfizzata", "metamorfosata", "metanizzata", "metilata", "metodizzata", "microfilmata", "microfonata", "microminiaturizzata", "micronizzata", "mietuta", "migliorata", "militarizzata", "millantata", "millimetrata", "mimata", "mimeografata", "mimetizzata", "minacciata", "minata", "minchionata", "mineralizzata", "miniata", "miniaturizzata", "minimizzata", "minuita", "minuzzata", "miracolata", "miscelata", "mischiata", "misconosciuta", "missata", "mistificata", "misturata", "misurata", "miticizzata", "mitigata", "mitizzata", "mitragliata", "mitrata", "mixata", "mobiliata", "mobilitata", "mobilizzata", "modanata", "modellata", "modellizzata", "moderata", "modernizzata", "modificata", "modulata", "molata", "molestata", "mollata", "molleggiata", "moltiplicata", "monacata", "mondata", "mondializzata", "monetarizzata", "monetata", "monetizzata", "monitorata", "monitorizzata", "monocromatizzata", "monopolizzata", "monottongata", "montata", "monumentalizzata", "mordenzata", "mordicchiata", "mormorata", "morphata", "morsicata", "morsicchiata", "morsa", "mortasata", "mortificata", "mossa", "mostrata", "motivata", "motorizzata", "motteggiata", "movimentata", "mozzata", "mugolata", "mulcita", "multata", "multiplexata", "mummificata", "municipalizzata", "munita", "munta", "murata", "musata", "musicata", "mussata", "mutata", "mutilata", "mutizzata", "mutuata", "nappata", "narcotizzata", "narrativizzata", "narrata", "nasalizzata", "nascosa", "nascosta", "nastrata", "naturaleggiata", "naturalizzata", "nauseata", "naverata", "navicata", "navigata", "nazificata", "nazionalizzata", "nebulizzata", "necessitata", "necrosata", "necrotizzata", "negativizzata", "negata", "negletta", "negoziata", "negreggiata", "neologizzata", "nerbata", "nericata", "nettata", "neutralizzata", "nevata", "nevicata", "nevischiata", "nevrotizzata", "nichelata", "niellata", "ninfeggiata", "ninnata", "ninnolata", "nitratata", "nitrificata", "nobilitata", "noiata", "noleggiata", "nomata", "nominalizzata", "nominata", "normalizzata", "normata", "notata", "notificata", "notiziata", "notricata", "noverata", "nuclearizzata", "nudricata", "nullificata", "numerata", "numerizzata", "nuotata", "nutrita", "obbiettata", "obbliata", "obbligata", "oberata", "obiettata", "obiettivata", "obiettivizzata", "obiurgata", "obliata", "obliterata", "obnubilata", "occasionata", "occhieggiata", "occidentalizzata", "occisa", "occlusa", "occultata", "occupata", "ocheggiata", "odiata", "odorata", "odorizzata", "offerita", "offerta", "offesa", "officiata", "offiziata", "offuscata", "ofiziata", "oggettivata", "oggettivizzata", "oggettualizzata", "oliata", "olita", "olografata", "oltraggiata", "oltrapassata", "oltrepassata", "omaggiata", "ombrata", "ombreggiata", "omessa", "omogeneizzata", "omogenizzata", "omologata", "ondata", "ondulata", "onestata", "onnubilata", "onorata", "opacata", "opacizzata", "operata", "opinata", "oppiata", "oppignorata", "oppilata", "opposta", "oppressa", "oppugnata", "oprata", "opsonizzata", "optata", "opzionata", "orbitata", "orchestrata", "ordinata", "ordita", "orecchiata", "organata", "organicata", "organizzata", "orgasmata", "orientalizzata", "orientata", "originata", "origliata", "orizzontata", "orlata", "orlettata", "ormata", "ormeggiata", "ornata", "orpellata", "orrata", "orripilata", "ortogonalizzata", "osannata", "osata", "osculata", "oscurata", "ospedalizzata", "ospitata", "osseduta", "ossequiata", "osservata", "ossessionata", "ossidata", "ossificata", "ossitonizzata", "ostacolata", "osteggiata", "ostentata", "ostinata", "ostracizzata", "ostruita", "ottemperata", "ottenebrata", "ottenuta", "ottimalizzata", "ottimata", "ottimizzata", "ottonata", "ottriata", "ottuplicata", "otturata", "ottusa", "ottussa", "ovalizzata", "ovariectomizzata", "ovattata", "overcloccata", "ovrata", "ovviata", "ozieggiata", "ozonizzata", "pacata", "pacciamata", "pacificata", "padroneggiata", "paganizzata", "pagata", "paginata", "palafittata", "palatalizzata", "palata", "palesata", "palettata", "palettizzata", "palificata", "palleggiata", "pallettizzata", "palpata", "palpeggiata", "panata", "panneggiata", "panoramicata", "pappata", "paracadutata", "parafata", "paraffinata", "parafrasata", "paragonata", "paragrafata", "paralizzata", "parallelizzata", "parametrata", "parametrizzata", "parassitata", "parata", "parcata", "parcellizzata", "parcheggiata", "pareggiata", "parificata", "parkerizzata", "parlata", "parlucchiata", "parodiata", "partecipata", "particolareggiata", "particolarizzata", "partizionata", "partorita", "parzializzata", "pasciuta", "pascolata", "passata", "passeggiata", "passionata", "passivata", "pasticciata", "pastorizzata", "pasturata", "patinata", "patita", "patrocinata", "patteggiata", "pattugliata", "pattuita", "paventata", "pavesata", "pavimentata", "pavoneggiata", "pazziata", "pedinata", "pedonalizzata", "peggiorata", "pelata", "pellettizzata", "penalizzata", "penetrata", "pennellata", "pensata", "pensionata", "pentita", "pepata", "peptonizzata", "peragrata", "percentualizzata", "percepita", "percolata", "percorsa", "percossa", "perdonata", "perdotta", "perduta", "perequata", "perfatta", "perfezionata", "perforata", "performata", "perita", "periziata", "perlustrata", "permeata", "permessa", "perorata", "perpetrata", "perpetuata", "perplimuta", "perquisita", "perscrutata", "perseguitata", "perseguita", "persa", "personalizzata", "personificata", "persuasa", "perturbata", "pervasa", "pervertita", "pesata", "pescata", "pestata", "petrarcheggiata", "pettegolata", "pettinata", "piagata", "piaggiata", "piallata", "pianeggiata", "pianificata", "piantata", "piantatala", "piantata", "pianta", "piantonata", "piantumata", "piastrellata", "piatita", "piazzata", "picchettata", "picchiata", "picchierellata", "picchiettata", "picconata", "piegata", "pieghettata", "pietrificata", "pigiata", "pigliata", "pigmentata", "pignorata", "pigolata", "pilotata", "pimentata", "pinta", "pinzata", "piombata", "piovigginata", "piovuta", "pipata", "pippata", "piratata", "pirogenata", "pisciata", "pitoccata", "pittata", "pitturata", "pizzicata", "pizzicottata", "placata", "placcata", "plagiata", "plasmata", "plasticata", "plastificata", "platinata", "plissettata", "pluralizzata", "poetata", "poeticizzata", "poggiata", "polarizzata", "poligrafata", "polimerizzata", "politicizzata", "polverizzata", "pomiciata", "pompata", "ponderata", "ponzata", "popolarizzata", "popolata", "poppata", "porcellanata", "porfirizzata", "portata", "portesa", "porta", "porzionata", "posata", "posdatata", "positivizzata", "posizionata", "posposta", "posseduta", "postata", "postdatata", "posteggiata", "posticipata", "postillata", "posta", "postsincronizzata", "postulata", "potabilizzata", "potata", "potenziata", "potuta", "pralinata", "praticata", "preaccennata", "preannunciata", "preannunziata", "preavvertita", "preavvisata", "precaricata", "preceduta", "precettata", "precinta", "precisata", "preclusa", "precompilata", "precompressa", "preconfezionata", "preconizzata", "preconosciuta", "precorsa", "precostituita", "predata", "predefinita", "predestinata", "predeterminata", "predetta", "predicata", "predigerita", "prediletta", "predisposta", "preeletta", "preesistuta", "prefabbricata", "prefata", "prefatta", "prefazionata", "preferita", "prefigurata", "prefinanziata", "prefissata", "prefissa", "preformata", "pregata", "pregiata", "pregiudicata", "pregustata", "preimpregnata", "prelevata", "premeditata", "premescolata", "premessa", "premiata", "premonita", "premunita", "premurata", "premuta", "prenotata", "preoccupata", "preordinata", "preparata", "prepensionata", "prepigmentata", "preposta", "preprogrammata", "preraffreddata", "prerefrigerata", "preregistrata", "preregolata", "preriscaldata", "presa", "presagita", "presaputa", "presasela", "prescelta", "prescritta", "preseduta", "presegnalata", "preselezionata", "presentata", "presentita", "preservata", "presidiata", "presieduta", "presa", "pressata", "pressa", "pressurizzata", "prestabilita", "prestampata", "prestata", "prestigiata", "presunta", "presupposta", "pretermessa", "pretesa", "pretrattata", "prevaricata", "preveduta", "prevenduta", "preventivata", "prevenuta", "prevista", "prezzata", "prezzolata", "principiata", "privatizzata", "privata", "privilegiata", "problematizzata", "procacciata", "processata", "proclamata", "procrastinata", "procreata", "procurata", "prodigata", "prodotta", "profanata", "proferita", "professata", "professionalizzata", "profetata", "profetizzata", "profferita", "profilata", "profondata", "profumata", "profusa", "progettata", "prognosticata", "programmata", "proibita", "proiettata", "proletarizzata", "prolungata", "promanata", "promessa", "promossa", "promozionata", "promulgata", "pronosticata", "pronunciata", "pronunziata", "propagandata", "propagata", "propagginata", "propalata", "propinata", "propiziata", "proporzionata", "proposta", "propugnata", "propulsa", "prorogata", "prosciolta", "prosciugata", "proscritta", "proseguita", "prospettata", "prosternata", "prostesa", "prostituita", "prostrata", "prosunta", "protesa", "protestata", "protetta", "protocollata", "protonata", "protratta", "protrusa", "provata", "proveduta", "provincializzata", "provista", "provocata", "provveduta", "provvista", "psicanalizzata", "psichiatrizzata", "psicoanalizzata", "psicologizzata", "pubblicata", "pubblicizzata", "puddellata", "pugnalata", "pulita", "pungolata", "punita", "puntata", "punteggiata", "puntellata", "punta", "puntualizzata", "punzecchiata", "punzonata", "purgata", "purificata", "putita", "putrefatta", "putrita", "quadrata", "quadrettata", "quadriennalizzata", "quadruplicata", "qualificata", "quantificata", "quantizzata", "querelata", "questuata", "quetata", "quietanzata", "quietata", "quintessenziata", "quintuplicata", "quotata", "quotizzata", "rabberciata", "rabboccata", "rabbonita", "rabbuffata", "rabuffata", "raccapezzata", "raccapricciata", "raccattata", "raccerchiata", "raccesa", "racchetata", "racchiusa", "raccolta", "raccolta", "raccomandata", "raccomodata", "raccontata", "raccorciata", "raccorcita", "raccordata", "raccostata", "raccozzata", "racemizzata", "racimolata", "radazzata", "raddensata", "raddobbata", "raddolcita", "raddoppiata", "raddotta", "raddrizzata", "radiata", "radicalizzata", "radioassistita", "radioattivata", "radiocomandata", "radiodiffusa", "radiografata", "radioguidata", "radiolocalizzata", "radiomarcata", "radiotelegrafata", "radiotrasmessa", "radunata", "raffazzonata", "raffermata", "raffigurata", "raffilata", "raffinata", "rafforzata", "raffreddata", "raffrenata", "raffrescata", "raffrontata", "raggelata", "raggentilita", "ragghiata", "raggirata", "raggiunta", "raggiustata", "raggomitolata", "raggranchiata", "raggranchita", "raggranellata", "raggrinzata", "raggrinzita", "raggrumata", "raggruppata", "raggruzzolata", "ragguagliata", "ralingata", "rallegrata", "rallentata", "ramata", "ramazzata", "rammagliata", "rammaricata", "rammemorata", "rammendata", "rammentata", "rammodernata", "rammollita", "rammorbidita", "rampognata", "randellata", "randomizzata", "rannicchiata", "rannuvolata", "ranzata", "rapata", "rapinata", "rapita", "rappacificata", "rappata", "rappattumata", "rappezzata", "rapportata", "rappresantata", "rappresentata", "rappresa", "rarefatta", "rasata", "raschiata", "raschiettata", "rasentata", "rasa", "raspata", "rassegnata", "rasserenata", "rassettata", "rassicurata", "rassodata", "rassomigliata", "rassottigliata", "rassunta", "rastrellata", "rastremata", "rateata", "rateizzata", "ratificata", "ratinata", "rattizzata", "rattoppata", "rattorta", "rattrappita", "rattristata", "rattristita", "raunata", "ravvalorata", "ravveduta", "ravviata", "ravvicinata", "ravviluppata", "ravvisata", "ravvista", "ravvivata", "ravvolta", "ravvoltolata", "razionalizzata", "razionata", "razziata", "razzolata", "realizzata", "reassunta", "recapitata", "recata", "receduta", "recensita", "recepita", "recidivata", "recintata", "recinta", "reciprocata", "recisa", "recitata", "reclamata", "reclamizzata", "reclinata", "reclusa", "reclutata", "recuperata", "redarguita", "redatta", "redazzata", "redduta", "redenta", "redistribuita", "redotta", "referenziata", "refertata", "refilata", "reflessa", "reflettuta", "refranta", "refrigerata", "regalata", "regimata", "regimentata", "regionalizzata", "registrata", "regolamentata", "regolarizzata", "regolata", "reidratata", "reificata", "reimbarcata", "reimmersa", "reimmessa", "reimparata", "reimpastata", "reimpiantata", "reimpiegata", "reimportata", "reimpostata", "reincarcerata", "reincaricata", "reincarnata", "reincisa", "reincontrata", "reindirizzata", "reindustrializzata", "reinfettata", "reingaggiata", "reinizializzata", "reinnestata", "reinoltrata", "reinscritta", "reinsediata", "reinserita", "reinstallata", "reinstaurata", "reintegrata", "reinterpretata", "reintitolata", "reintrodotta", "reinventata", "reinvestita", "reiterata", "relativizzata", "relazionata", "relegata", "remixata", "remunerata", "renderizzata", "reperita", "repertata", "replicata", "repressa", "repulsa", "reputata", "requisita", "rescissa", "resecata", "resettata", "residuata", "resinificata", "resa", "resolata", "resolta", "respinta", "respirata", "responsabilizzata", "resposta", "restaurata", "restituita", "resunta", "resuscitata", "reticolata", "retinata", "retribuita", "retroceduta", "retrocessa", "retrodatata", "rettificata", "retta", "reumatizzata", "revisionata", "revocata", "riabbassata", "riabbellita", "riabbonata", "riabbottonata", "riabbracciata", "riabilitata", "riabitata", "riabituata", "riaccaduta", "riaccasata", "riaccesa", "riaccettata", "riacchiappata", "riacciuffata", "riaccolta", "riaccomodata", "riaccompagnata", "riaccordata", "riaccostata", "riaccreditata", "riacquisita", "riacquistata", "riacutizzata", "riadattata", "riaddestrata", "riaddormentata", "riadoperata", "riaffacciata", "riaffermata", "riafferrata", "riaffiorata", "riaffittata", "riaffrontata", "riagganciata", "riaggiornata", "riaggiustata", "riaggravata", "riaggregata", "riagguantata", "rialimentata", "riallacciata", "riallargata", "riallineata", "riallocata", "riallungata", "rialzata", "riamata", "riambientata", "riammalata", "riammessa", "riammodernata", "riammogliata", "rianimata", "riannessa", "riannodata", "riannunciata", "riaperta", "riappacificata", "riappaltata", "riapparecchiata", "riapparita", "riappesa", "riappiccicata", "riapplicata", "riappresa", "riapprodata", "riappropriata", "riapprovata", "riarmata", "riarrangiata", "riarredata", "riascoltata", "riasfaltata", "riassalita", "riassaporata", "riassegnata", "riassemblata", "riassestata", "riassettata", "riassicurata", "riassociata", "riassopita", "riassorbita", "riassunta", "riattaccata", "riattata", "riattesa", "riattinta", "riattivata", "riattizzata", "riattraversata", "riaumentata", "riavuta", "riavventata", "riavvertita", "riavviata", "riavvicinata", "riavvinta", "riavvisata", "riavvistata", "riavvolta", "riazzuffata", "ribaciata", "ribadita", "ribaltata", "ribassata", "ribattezzata", "ribattuta", "ribellata", "ribenedetta", "ribevuta", "ributtata", "ricacciata", "ricalata", "ricalcata", "ricalcificata", "ricalcitrata", "ricalcolata", "ricalibrata", "ricamata", "ricambiata", "ricanalizzata", "ricandidata", "ricantata", "ricapitalizzata", "ricapitolata", "ricaricata", "ricategorizzata", "ricattata", "ricavata", "ricelebrata", "ricercata", "ricetrasmessa", "ricettata", "ricevuta", "richiamata", "richiesta", "richiusa", "riciclata", "ricinta", "ricircolata", "riclassificata", "ricodificata", "ricollegata", "ricollocata", "ricolmata", "ricolonizzata", "ricolorata", "ricolorita", "ricoltivata", "ricombinata", "ricominciata", "ricommessa", "ricomparita", "ricompattata", "ricompensata", "ricomperata", "ricompilata", "ricompiuta", "ricomposta", "ricomprata", "ricompressa", "ricomunicata", "riconceduta", "riconcessa", "riconciliata", "ricondizionata", "ricondotta", "riconfermata", "riconfezionata", "riconfigurata", "riconfortata", "riconfusa", "ricongelata", "ricongiunta", "riconnessa", "riconosciuta", "riconquistata", "riconsacrata", "riconsegnata", "riconsiderata", "riconsigliata", "riconsolata", "ricontata", "ricontattata", "ricontrattata", "ricontratta", "ricontrollata", "riconvalidata", "riconvenuta", "riconvertita", "riconvinta", "riconvocata", "riconvogliata", "ricoperta", "ricopiata", "ricordata", "ricoricata", "ricorretta", "ricosparsa", "ricostituita", "ricostretta", "ricostruita", "ricotta", "ricoverata", "ricreata", "ricristallizzata", "ricrocifissa", "ricucita", "ricuperata", "ricusata", "ridata", "ridecorata", "ridefinita", "ridenominata", "ridestata", "rideterminata", "ridetta", "ridicolizzata", "ridigitata", "ridimensionata", "ridipinta", "ridiscesa", "ridisciolta", "ridisciplinata", "ridiscussa", "ridisegnata", "ridisfatta", "ridisposta", "ridistesa", "ridistinta", "ridistribuita", "ridivisa", "ridomandata", "ridonata", "ridondata", "ridorata", "ridotata", "ridotta", "ridovuta", "riecheggiata", "riedificata", "rieducata", "rielaborata", "rieletta", "riemessa", "riempita", "riempiuta", "rientrata", "riepilogata", "riequilibrata", "riequipaggiata", "riesaminata", "rieseguita", "riesercitata", "riesplosa", "riesportata", "riesposta", "riespressa", "riespulsa", "riestesa", "riesumata", "rietichettata", "rievaporata", "rievocata", "rifabbricata", "rifasciata", "rifatta", "rifenduta", "riferita", "rifermata", "rifermentata", "rifessa", "rificcata", "rifilata", "rifiltrata", "rifinanziata", "rifinita", "rifirmata", "rifischiata", "rifissa", "rifiutata", "riflessa", "riflettuta", "rifocillata", "rifoderata", "rifondata", "riforestata", "riforgiata", "riformata", "riformattata", "riformulata", "rifornita", "rifranta", "rifritta", "rifrugata", "rifuggita", "rifugiata", "rifusa", "rigassificata", "rigata", "rigelata", "rigenerata", "rigettata", "righettata", "rigiocata", "rigirata", "rigiudicata", "rigiunta", "rigoduta", "rigonfiata", "rigovernata", "riguadagnata", "riguardata", "rigurgitata", "rilanciata", "rilasciata", "rilassata", "rilavata", "rilavorata", "rilegata", "riletta", "rilevata", "rilocalizzata", "rimagliata", "rimandata", "rimaneggiata", "rimangiata", "rimappata", "rimarcata", "rimarchiata", "rimarginata", "rimaritata", "rimasticata", "rimata", "rimbacuccata", "rimbaldanzita", "rimbarcata", "rimbeccata", "rimbecillita", "rimbellita", "rimbiancata", "rimbiondita", "rimboccata", "rimbombata", "rimborsata", "rimboscata", "rimboschita", "rimbrottata", "rimediata", "rimembrata", "rimemorata", "rimenata", "rimeritata", "rimescolata", "rimessa", "rimestata", "rimilitarizzata", "rimirata", "rimischiata", "rimisurata", "rimodellata", "rimodernata", "rimodulata", "rimondata", "rimontata", "rimorchiata", "rimorsa", "rimossa", "rimostrata", "rimotivata", "rimpacchettata", "rimpadronita", "rimpaginata", "rimpagliata", "rimpannucciata", "rimpastata", "rimpatriata", "rimpiallacciata", "rimpianta", "rimpiattata", "rimpiazzata", "rimpicciolita", "rimpiccolita", "rimpiegata", "rimpinguata", "rimpinzata", "rimpolpata", "rimpossessata", "rimpressa", "rimproverata", "rimuginata", "rimunerata", "rimunta", "rimusicata", "rimutata", "rinarrata", "rinascosta", "rincalcata", "rincalzata", "rincamminata", "rincantucciata", "rincarata", "rincarcerata", "rincarnata", "rincentrata", "rinchiesta", "rinchiodata", "rinchiusa", "rincitrullita", "rincivilita", "rincoglionita", "rincollata", "rincominciata", "rincontrata", "rincoraggiata", "rincorata", "rincorporata", "rincorsa", "rincretinita", "rincrudita", "rinculcata", "rincuorata", "rindossata", "rindurita", "rinegoziata", "rinfacciata", "rinfagottata", "rinfiammata", "rinfiancata", "rinfilata", "rinfittita", "rinfocolata", "rinfoderata", "rinforzata", "rinfrancata", "rinfranta", "rinfrescata", "rinfusa", "ringagliardita", "ringalluzzita", "ringiovanita", "ringiovenita", "ringoiata", "ringorgata", "ringraziata", "ringuainata", "rinnamorata", "rinnegata", "rinnestata", "rinnovata", "rinnovellata", "rinociuta", "rinomata", "rinominata", "rinormalizzata", "rinquadrata", "rinsaccata", "rinsaldata", "rinsanguata", "rinselvatichita", "rinselvata", "rinserrata", "rintanata", "rintasata", "rintascata", "rintavolata", "rintenerita", "rinterrata", "rinterrogata", "rintesa", "rintiepidita", "rintoccata", "rintonacata", "rintontita", "rintorpidita", "rintracciata", "rintrodotta", "rintronata", "rintuzzata", "rinunciata", "rinunziata", "rinutrita", "rinvangata", "rinvasata", "rinvenuta", "rinverdita", "rinvestita", "rinviata", "rinvigorita", "rinvilita", "rinvitata", "rinvoltata", "rinvolta", "rinvoltolata", "rinzaffata", "rinzeppata", "riobbligata", "rioccupata", "riofferta", "rioffesa", "rioperata", "riordinata", "riorganizzata", "riorientata", "riosservata", "riottenuta", "riottimizzata", "riotturata", "ripagata", "riparametrizzata", "riparata", "ripartita", "ripassata", "ripercorsa", "ripercossa", "riperduta", "ripersa", "ripesata", "ripescata", "ripestata", "ripetuta", "ripianata", "ripianificata", "ripiantata", "ripianta", "ripicchiata", "ripiegata", "ripigliata", "ripinta", "ripiovuta", "ripitturata", "riplasmata", "ripolarizzata", "ripopolata", "riportata", "riporta", "riposata", "riposizionata", "riposseduta", "riposta", "ripotuta", "ripresentata", "ripresa", "riprestata", "ripretesa", "riprincipiata", "ripristinata", "riprivatizzata", "riprodotta", "riprogettata", "riprogrammata", "ripromessa", "riproposta", "riprotetta", "riprovata", "riprovveduta", "riprovvista", "ripubblicata", "ripudiata", "ripugnata", "ripulita", "ripuntata", "ripunta", "ripurgata", "riputata", "riquadrata", "riqualificata", "riresa", "rirotta", "risaldata", "risalita", "risaltata", "risalutata", "risanata", "risaputa", "risarcita", "riscalata", "riscaldata", "riscattata", "riscelta", "riscesa", "rischiarata", "rischiata", "risciacquata", "risciolta", "riscommessa", "riscontata", "riscontrata", "risconvolta", "riscoperta", "riscoppiata", "riscorsa", "riscossa", "riscritta", "risecata", "riseduta", "risegata", "risegnata", "riselciata", "riselezionata", "riseminata", "risentita", "riseppellita", "riserbata", "riservata", "risicata", "risigillata", "risistemata", "risa", "risoffiata", "risoggiunta", "risolata", "risolidificata", "risollevata", "risolta", "risommata", "risommersa", "risonata", "risorpassata", "risospesa", "risospinta", "risottomessa", "risparmiata", "risparsa", "rispecchiata", "rispedita", "rispenta", "rispersa", "rispettata", "rispiegata", "rispinta", "rispolverata", "risposata", "risposta", "rissata", "ristabilita", "ristagnata", "ristampata", "ristaurata", "ristesa", "ristilizzata", "ristorata", "ristretta", "ristrutta", "ristrutturata", "ristuccata", "ristudiata", "risucchiata", "risultata", "risuolata", "risuonata", "risuscitata", "risvegliata", "risvolta", "ritagliata", "ritarata", "ritardata", "ritemprata", "ritentata", "ritenuta", "ritersa", "ritesa", "ritinta", "ritirata", "ritoccata", "ritolta", "ritorta", "ritracciata", "ritradotta", "ritrascorsa", "ritrascritta", "ritrasferita", "ritrasformata", "ritrasmessa", "ritrasposta", "ritrattata", "ritratta", "ritrovata", "ritualizzata", "rituffata", "riudita", "riunificata", "riunita", "riusata", "riutilizzata", "rivaccinata", "rivaleggiata", "rivalorizzata", "rivalsa", "rivalutata", "rivangata", "riveduta", "rivelata", "rivendicata", "rivenduta", "riverberata", "riverita", "riverniciata", "riversata", "rivestita", "rivettata", "rivinta", "rivisitata", "rivissuta", "rivista", "rivitalizzata", "rivivificata", "rivoltata", "rivolta", "rivoltolata", "rivoluta", "rivoluzionata", "rizappata", "rizzata", "robotizzata", "rodata", "rogata", "rollata", "romanizzata", "romanticizzata", "romanzata", "roncolata", "rosicata", "rosicchiata", "rosa", "rosolata", "rotacizzata", "rotata", "roteata", "rotolata", "rottamata", "rotta", "rovesciata", "rovinata", "rovistata", "rubacchiata", "rubata", "rullata", "ruminata", "ruotata", "russificata", "ruzzolata", "sabbiata", "sabotata", "saccarificata", "saccheggiata", "sacralizzata", "sacramentata", "sacrificata", "saettata", "saggiata", "sagginata", "sagomata", "salamoiata", "salariata", "salassata", "salata", "saldata", "salificata", "salinizzata", "salita", "salmeggiata", "salmistrata", "salpata", "saltata", "salutata", "salvaguardata", "salvata", "sanata", "sancita", "sanforizzata", "sanificata", "sanitizzata", "santificata", "sanzionata", "saponificata", "saputa", "sarchiata", "sarchiellata", "sartiata", "satellizzata", "satinata", "satireggiata", "satisfatta", "satollata", "saturata", "saziata", "sbaccellata", "sbaciucchiata", "sbafata", "sbaffata", "sbalestrata", "sballata", "sballottata", "sballottolata", "sbalordita", "sbalzata", "sbancata", "sbandata", "sbandierata", "sbandita", "sbaraccata", "sbaragliata", "sbarazzata", "sbarbata", "sbarcata", "sbardata", "sbarrata", "sbassata", "sbastita", "sbatacchiata", "sbattezzata", "sbattuta", "sbeccata", "sbeffeggiata", "sbellicata", "sbendata", "sbertucciata", "sbiadita", "sbiancata", "sbianchita", "sbiellata", "sbiettata", "sbigottita", "sbilanciata", "sbirbata", "sbirciata", "sbizzarrita", "sbloccata", "sbobinata", "sboccata", "sbocconcellata", "sbollentata", "sbolognata", "sborniata", "sborsata", "sboscata", "sbottonata", "sbozzata", "sbozzimata", "sbozzolata", "sbracata", "sbracciata", "sbraciata", "sbraitata", "sbranata", "sbrancata", "sbrattata", "sbreccata", "sbriciolata", "sbrigata", "sbrigliata", "sbrinata", "sbrindellata", "sbrodolata", "sbrogliata", "sbronzata", "sbruffata", "sbucciata", "sbudellata", "sbuffata", "sbugiardata", "sbullettata", "sbullonata", "sburrata", "scacazzata", "scacchiata", "scacciata", "scaccolata", "scadenzata", "scafata", "scaffalata", "scagionata", "scagliata", "scaglionata", "scalata", "scalcata", "scalcinata", "scaldata", "scalettata", "scalfata", "scalfita", "scalmanata", "scaloppata", "scalpata", "scalpellata", "scalpellinata", "scaltrita", "scalzata", "scambiata", "scamiciata", "scamosciata", "scamozzata", "scampata", "scampatala", "scampata", "scamuffata", "scanalata", "scancellata", "scandagliata", "scandalizzata", "scandita", "scannata", "scannellata", "scannerata", "scannerizata", "scannerizzata", "scansata", "scansionata", "scapecchiata", "scapezzata", "scapicollata", "scapigliata", "scapitozzata", "scapocchiata", "scappata", "scappellata", "scappottata", "scapricciata", "scapsulata", "scarabocchiata", "scaracchiata", "scaraventata", "scarcerata", "scardassata", "scardata", "scardinata", "scaricata", "scarificata", "scarmigliata", "scarnata", "scarnificata", "scarnita", "scarrellata", "scarrocciata", "scarrozzata", "scarruffata", "scartabellata", "scartata", "scartavetrata", "scartinata", "scartocciata", "scassata", "scassinata", "scatenata", "scattata", "scavalcata", "scavallata", "scavata", "scavezzata", "scazzottata", "scekerata", "scelta", "scempiata", "sceneggiata", "scernuta", "scervellata", "scesa", "sceverata", "schedata", "schedulata", "scheggiata", "scheletrita", "schematizzata", "schermata", "schermita", "schermografata", "schernita", "schiacciata", "schiaffata", "schiaffeggiata", "schiantata", "schiarita", "schiavardata", "schiavizzata", "schiccherata", "schierata", "schifata", "schinciata", "schioccata", "schiodata", "schiumata", "schiusa", "schivata", "schizzata", "schizzettata", "sciabolata", "sciabordata", "sciacquata", "scialacquata", "sciamanizzata", "sciamannata", "sciancata", "sciancrata", "scimmieggiata", "scimmiottata", "scinta", "scioccata", "sciolinata", "sciolta", "sciorinata", "scippata", "sciroppata", "scissa", "sciupacchiata", "sciupata", "sclamata", "sclerosata", "sclerotizzata", "scoccata", "scocciata", "scodata", "scodellata", "scoiata", "scolarizzata", "scolata", "scollacciata", "scollata", "scollegata", "scolorata", "scolorita", "scolpata", "scolpita", "scombaciata", "scombinata", "scombussolata", "scommessa", "scomodata", "scompaginata", "scompagnata", "scompartita", "scompattata", "scompensata", "scompiacuta", "scompigliata", "scomposta", "scomputata", "scomunicata", "sconcertata", "sconciata", "sconclusa", "sconfessata", "sconficcata", "sconﬁtta", "sconfortata", "sconfusa", "scongelata", "scongiurata", "sconnessa", "sconosciuta", "sconquassata", "sconsacrata", "sconsigliata", "sconsolata", "scontata", "scontentata", "scontornata", "scontorta", "scontrata", "sconvolta", "scopata", "scoperchiata", "scoperta", "scopiazzata", "scoraggiata", "scoraggita", "scorata", "scorazzata", "scorciata", "scorcita", "scordata", "scoreggiata", "scorificata", "scornata", "scorniciata", "scoronata", "scorporata", "scorrazzata", "scorreggiata", "scorretta", "scorsa", "scortata", "scortecciata", "scorticata", "scorta", "scorzata", "scoscesa", "scosciata", "scossa", "scostata", "scostolata", "scotennata", "scoticata", "scotolata", "scotomizzata", "scottata", "scotta", "scovata", "scoverta", "scozzata", "scozzonata", "screditata", "scremata", "screpolata", "screziata", "scribacchiata", "scriminata", "scristianizzata", "scritta", "scritturata", "scroccata", "scrocchiata", "scrollata", "scrostata", "scrutata", "scrutinata", "scucita", "scudisciata", "scuffiata", "sculacciata", "sculettata", "scuoiata", "scuriosata", "scurita", "scusata", "sdaziata", "sdebitata", "sdegnata", "sdemanializzata", "sdentata", "sdilinquita", "sdoganata", "sdoluta", "sdoppiata", "sdraiata", "sdrammatizzata", "sdrucita", "secata", "seccata", "secernuta", "secolarizzata", "secondata", "secretata", "secreta", "sedata", "sedentarizzata", "sedotta", "segata", "seghettata", "segmentata", "segnalata", "segnata", "segnoreggiata", "segregata", "segretata", "seguitata", "seguita", "selciata", "selezionata", "sellata", "sembrata", "sementata", "semicinta", "seminata", "semplificata", "senilizzata", "sensibilizzata", "sensorizzata", "sentenziata", "sentita", "sentitasela", "sentita", "sentita", "separata", "sepolta", "seppellita", "sequenziata", "sequestrata", "serbata", "serrata", "servita", "servoassistita", "sessualizzata", "sestuplicata", "setacciata", "setificata", "settata", "settorializzata", "settuplicata", "seviziata", "sezionata", "sfaccettata", "sfagliata", "sfaldata", "sfalsata", "sfamata", "sfanalata", "sfangata", "sfarinata", "sfasata", "sfasciata", "sfatata", "sfatta", "sfavillata", "sfavorita", "sfegatata", "sfeltrata", "sfenduta", "sferragliata", "sferrata", "sferzata", "sfessa", "sfiancata", "sfiatata", "sfiata", "sfibbiata", "sfibrata", "sfidata", "sfiduciata", "sfigurata", "sfilata", "sfilettata", "sfinita", "sfioccata", "sfiorata", "sfittata", "sfocata", "sfociata", "sfoderata", "sfogata", "sfoggiata", "sfogliata", "sfollata", "sfoltita", "sfondata", "sforacchiata", "sforata", "sforbiciata", "sformata", "sfornaciata", "sfornata", "sfornita", "sforzata", "sfottuta", "sfracellata", "sfrangiata", "sfrascata", "sfratata", "sfrattata", "sfrecciata", "sfregata", "sfregiata", "sfrenata", "sfrisata", "sfrondata", "sfrucugliata", "sfruculiata", "sfruttata", "sfumata", "sfuocata", "sgamata", "sganasciata", "sganciata", "sgarbugliata", "sgattaiolata", "sgelata", "sghiacciata", "sgocciolata", "sgolata", "sgomberata", "sgombrata", "sgomentata", "sgominata", "sgomitata", "sgomitolata", "sgonfiata", "sgorbiata", "sgottata", "sgovernata", "sgozzata", "sgraffiata", "sgraffignata", "sgranata", "sgranchita", "sgranellata", "sgrassata", "sgravata", "sgretolata", "sgridata", "sgrommata", "sgrondata", "sgroppata", "sgrossata", "sgrovigliata", "sgrugnata", "sguainata", "sgualcita", "sguanciata", "sguarnita", "sguinzagliata", "sgusciata", "shakerata", "shoccata", "shuntata", "sigillata", "siglata", "significata", "signoreggiata", "silenziata", "silicizzata", "sillabata", "sillogizzata", "silurata", "simboleggiata", "simbolizzata", "simmetrizzata", "simpatizzata", "simulata", "sincerata", "sincopata", "sincretizzata", "sincronizzata", "sindacalizzata", "sindacata", "singolarizzata", "sinistrata", "sinizzata", "sinterizzata", "sintetizzata", "sintonizzata", "siringata", "sistematizzata", "sistemata", "situata", "slabbrata", "slacciata", "slamata", "slanciata", "slappolata", "slargata", "slavizzata", "slegata", "slentata", "slinguata", "slogata", "sloggata", "sloggiata", "slombata", "slungata", "smaccata", "smacchiata", "smagliata", "smagnetizzata", "smagrita", "smaliziata", "smallata", "smaltata", "smaltita", "smammata", "smanacciata", "smangiata", "smantellata", "smarcata", "smarginata", "smarrita", "smascellata", "smascherata", "smaterializzata", "smattonata", "smembrata", "smentita", "smerciata", "smerdata", "smerigliata", "smerlata", "smerlettata", "smessala", "smessa", "smezzata", "smidollata", "smielata", "smilitarizzata", "sminata", "sminuita", "sminuzzata", "smistata", "smitizzata", "smobiliata", "smobilitata", "smobilizzata", "smoccolata", "smollicata", "smonacata", "smontata", "smorbata", "smorzata", "smossa", "smozzicata", "smunta", "smurata", "smussata", "smutandata", "snaturata", "snazionalizzata", "snebbiata", "snellita", "snervata", "snidata", "sniffata", "snobbata", "snocciolata", "snodata", "snudata", "sobbarcata", "sobbollita", "sobillata", "socchiusa", "soccorsa", "soddisfatta", "sodisfatta", "sodomizzata", "sofferita", "soffermata", "sofferta", "soffiata", "soffocata", "soffregata", "soffritta", "soffusa", "sofisticata", "soggettivata", "soggettivizzata", "sogghignata", "soggiogata", "soggiunta", "sogguardata", "sognata", "solarizzata", "solcata", "soleggiata", "solennizzata", "solfeggiata", "solfitata", "solfonata", "solforata", "solidificata", "solita", "sollazzata", "sollecitata", "solleticata", "sollevata", "solta", "solubilizzata", "soluta", "soluzionata", "solvatata", "somatizzata", "someggiata", "somigliata", "sommata", "sommersa", "sommessa", "somministrata", "sommossa", "sonata", "sondata", "sonorizzata", "sopita", "soppalcata", "soppesata", "soppiantata", "sopportata", "sopposta", "soppressa", "sopraddotata", "sopraeccitata", "sopraedificata", "sopraelevata", "sopraffata", "sopraffatta", "sopraggiunta", "sopraintesa", "soprammessa", "soprannominata", "sopraposta", "soprappresa", "soprascritta", "sopraspesa", "soprassaturata", "soprasseduta", "sopravanzata", "sopravvalutata", "sopravveduta", "sopravvinta", "sopravvista", "sopreccitata", "sopredificata", "soprelevata", "soprintesa", "sorbettata", "sorbita", "sorgiunta", "sormontata", "sorpassata", "sorpresa", "sorrasa", "sorretta", "sorseggiata", "sorteggiata", "sortita", "sorvegliata", "sorvolata", "soscritta", "sospesa", "sospettata", "sospinta", "sospirata", "sostantivata", "sostanziata", "sostentata", "sostenuta", "sostituita", "sottaciuta", "sotterrata", "sottesa", "sottintesa", "sottoalimentata", "sottocapitalizzata", "sottodivisa", "sottoesposta", "sottofirmata", "sottolineata", "sottomessa", "sottomurata", "sottopagata", "sottopassata", "sottoposta", "sottorappresentata", "sottorisa", "sottoscritta", "sottostimata", "sottosviluppata", "sottotitolata", "sottovalutata", "sottratta", "soverchiata", "sovesciata", "sovietizzata", "sovracapitalizzata", "sovraccaricata", "sovradimensionata", "sovraeccitata", "sovraesposta", "sovraffaticata", "sovraffollata", "sovraggiunta", "sovraimposta", "sovraintesa", "sovralimentata", "sovramodulata", "sovrappopolata", "sovrapposta", "sovrariscaldata", "sovrasaturata", "sovrascritta", "sovrastampata", "sovrastata", "sovrastimata", "sovrautilizzata", "sovreccitata", "sovresposta", "sovrimposta", "sovrintesa", "sovvenuta", "sovvenzionata", "sovvertita", "spaccata", "spacchettata", "spacciata", "spaginata", "spaiata", "spalancata", "spalata", "spalcata", "spalleggiata", "spalmata", "spammata", "spampanata", "spampinata", "spanata", "spanciata", "spanduta", "spannata", "spannocchiata", "spansa", "spantanata", "spanta", "spaparacchiata", "spaparanzata", "spappolata", "sparata", "sparecchiata", "sparigliata", "sparita", "sparlata", "sparpagliata", "spartita", "spassata", "spassatosela", "spastoiata", "spaurata", "spaurita", "spaventata", "spazializzata", "spaziata", "spazieggiata", "spazientita", "spazzata", "spazzolata", "specchiata", "specializzata", "specificata", "specillata", "specolata", "spedita", "spegnata", "spelacchiata", "spelata", "spellata", "spennacchiata", "spennata", "spennellata", "spenta", "spenzolata", "sperata", "sperimentata", "spernacchiata", "speronata", "sperperata", "spersonalizzata", "sperticata", "spesata", "spesa", "spessita", "spettacolarizzata", "spettinata", "spezzata", "spezzettata", "spezziata", "spezzonata", "spiaccicata", "spianata", "spiantata", "spiata", "spiattellata", "spiazzata", "spiccata", "spicciata", "spiccicata", "spicciolata", "spicconata", "spidocchiata", "spiegata", "spiegazzata", "spietrata", "spifferata", "spigionata", "spignorata", "spigolata", "spigrita", "spillata", "spilluzzicata", "spiluccata", "spinta", "spintonata", "spiombata", "spiralizzata", "spirantizzata", "spirata", "spiritualizzata", "spiumata", "spizzicata", "spodestata", "spoetizzata", "spogliata", "spolettata", "spoliata", "spoliticizzata", "spollonata", "spolmonata", "spolpata", "spoltronita", "spolverata", "spolverizzata", "spompata", "spompinata", "sponsorizzata", "spopolata", "spoppata", "sporcata", "sportata", "sporta", "sposata", "sposseduta", "spossessata", "spostata", "sposta", "sprangata", "sprecata", "spregiata", "spremuta", "spretata", "sprezzata", "sprigionata", "sprimacciata", "spromessa", "spronata", "sprotetta", "sprovincializzata", "sprovveduta", "sprovvista", "spruzzata", "spugnata", "spulata", "spulciata", "spuntata", "spuntellata", "spupazzata", "spurgata", "sputacchiata", "sputata", "sputtanata", "squadernata", "squadrata", "squagliata", "squagliatasela", "squagliata", "squalificata", "squamata", "squarciata", "squartata", "squassata", "squattrinata", "squilibrata", "squinternata", "sradicata", "srotolata", "srugginita", "stabbiata", "stabilita", "stabilizzata", "stabulata", "staccata", "stacciata", "staffata", "staffilata", "staggiata", "staggita", "stagionata", "stagliata", "stagnata", "stamburata", "stampata", "stampigliata", "stanata", "stancata", "standardizzata", "stangata", "stanziata", "stappata", "starata", "starnazzata", "stasata", "statalizzata", "statizzata", "statoca", "statosena", "statuita", "stazzata", "stazzonata", "steccacciata", "steccata", "stecchita", "stecconata", "stemperata", "stempiata", "stenografata", "stereotipata", "sterilita", "sterilizzata", "sterpata", "sterrata", "sterzata", "stesa", "stigliata", "stigmatizzata", "stilata", "stilettata", "stilizzata", "stillata", "stimata", "stimolata", "stinta", "stipata", "stipendiata", "stipulata", "stiracchiata", "stirata", "stivata", "stizzita", "stoccata", "stolta", "stomacata", "stonata", "stondata", "stoppata", "stordita", "storicizzata", "stornata", "storpiata", "stortata", "storta", "stozzata", "strabenedetta", "strabuzzata", "stracannata", "straccata", "stracciata", "stracotta", "strafogata", "stragoduta", "stralciata", "stralodata", "stralunata", "stramaledetta", "stramortita", "strangolata", "straniata", "stranita", "straorzata", "strapagata", "strapazzata", "straperduta", "strapersa", "strappata", "strasaputa", "strascicata", "strascinata", "strasformata", "stratificata", "strattonata", "stravaccata", "stravinta", "stravolta", "stravoluta", "straziata", "stregata", "stremata", "stressata", "striata", "stridulata", "strigata", "strigliata", "strillata", "striminzita", "strimpellata", "strinata", "stringata", "strisciata", "stritolata", "strizzata", "strofinata", "strombata", "strombazzata", "stroncata", "stronzata", "stropicciata", "stroppata", "stroppiata", "strozzata", "struccata", "strumentalizzata", "strumentata", "strusciata", "strutta", "strutturalizzata", "strutturata", "stuccata", "studiacchiata", "studiata", "stuellata", "stufata", "stupefatta", "stupita", "stuprata", "sturata", "stutata", "stuzzicata", "suasa", "subaffittata", "subappaltata", "subbiata", "subdelegata", "subissata", "subita", "sublicenziata", "sublimata", "sublocata", "subodorata", "subordinata", "subornata", "suburbanizzata", "sucata", "succhiata", "succhiellata", "succiata", "succinta", "succisa", "suddistinta", "suddivisa", "suffissata", "suffissa", "suffragata", "suffumicata", "suffusa", "suggellata", "suggerita", "suggestionata", "suicidata", "sunteggiata", "sunta", "suolata", "suonata", "superata", "superpagata", "superraffreddata", "supervalutata", "supervisionata", "supplicata", "supplita", "supportata", "supposta", "suppurata", "surclassata", "surfata", "surgelata", "surraffreddata", "surriscaldata", "surrogata", "survoltata", "suscitata", "susseguita", "sussidiata", "sussunta", "sussurrata", "suturata", "svaccata", "svagata", "svaligiata", "svalutata", "svapata", "svariata", "svasata", "svecchiata", "svegliata", "svelata", "svelenita", "sveltita", "svelta", "svenata", "svenduta", "sventagliata", "sventata", "sventolata", "sventrata", "sverginata", "svergognata", "svergolata", "sverminata", "sverniciata", "svestita", "svettata", "svezzata", "sviata", "svignatosela", "svigorita", "svilita", "svillaneggiata", "sviluppata", "svinata", "svincolata", "sviolinata", "svirgolata", "svirilizzata", "svisata", "sviscerata", "svitata", "sviticchiata", "svolata", "svolazzata", "svolta", "svoluta", "svuotata", "tabuizzata", "tabulata", "taccata", "taccheggiata", "tacciata", "tacitata", "taciuta", "tagliata", "taglieggiata", "tagliuzzata", "talebanizzata", "tallonata", "tampinata", "tamponata", "tanguta", "tannata", "tappata", "tappezzata", "tarata", "tardata", "targata", "tariffata", "tarlata", "tarmata", "taroccata", "tarpata", "tartagliata", "tartassata", "tartufata", "tassata", "tassellata", "tastata", "tasteggiata", "tatuata", "tecnicizzata", "tecnologizzata", "tedeschizzata", "tediata", "teflonata", "telecomandata", "telecontrollata", "telediffusa", "telefonata", "telegrafata", "teleguidata", "telematizzata", "telemetrata", "teleradiotrasmessa", "teletrasmessa", "teletrasportata", "tematizzata", "temperata", "tempestata", "tempificata", "templatizzata", "temporizzata", "temprata", "temuta", "tentata", "tenuta", "teologizzata", "teorizzata", "tepefatta", "terebrata", "terminata", "termostatata", "terrazzata", "terrificata", "terrorizzata", "tersa", "terzarolata", "terziarizzata", "terziata", "tesata", "tesaurizzata", "tesa", "tesserata", "testata", "testificata", "testimoniata", "timbrata", "tindalizzata", "tinteggiata", "tinta", "tipicizzata", "tipizzata", "tippata", "tiranneggiata", "tirata", "titillata", "titolata", "toccata", "toelettata", "tollerata", "tolta", "tonalizzata", "tonificata", "tonneggiata", "tonsurata", "torchiata", "tormentata", "tornatosena", "tornita", "torrefatta", "torta", "tortoreggiata", "torturata", "tosata", "toscaneggiata", "toscanizzata", "tostata", "totalizzata", "traboccata", "trabuccata", "tracannata", "tracciata", "tradita", "tradotta", "trafficata", "trafilata", "trafitta", "traforata", "trafugata", "traghettata", "traguardata", "trainata", "tralasciata", "tralignata", "tramandata", "tramata", "trambasciata", "tramessa", "tramestata", "tramezzata", "tramortita", "tramutata", "tranciata", "trangugiata", "tranquillata", "tranquillizzata", "transatta", "transcesa", "transcodificata", "transcorsa", "transcritta", "transennata", "transfluita", "transfusa", "transistorizzata", "translitterata", "transposta", "transricevuta", "transustanziata", "transveduta", "transvista", "trapanata", "trapassata", "trapiantata", "traportata", "traposta", "trapposta", "trapuntata", "trapunta", "trarotta", "trasandata", "trasbordata", "trascelta", "trascesa", "trascinata", "trascorsa", "trascritta", "trascurata", "trasdotta", "trasferita", "trasfigurata", "trasformata", "trasfusa", "trasgredita", "traslata", "traslitterata", "traslocata", "trasmessa", "trasmutata", "trasparita", "traspirata", "trasportata", "trasposta", "trastullata", "trasudata", "trasvolata", "trasvolta", "trattata", "tratteggiata", "trattenuta", "tratta", "traumatizzata", "travagliata", "travalicata", "travasata", "traveduta", "traversata", "travestita", "traviata", "travisata", "travista", "travolta", "trebbiata", "triangolata", "tribbiata", "tribolata", "tributata", "triennalizzata", "trimestralizzata", "trincata", "trincerata", "trinciata", "tripartita", "triplicata", "trisecata", "trisezionata", "tritata", "triturata", "trivellata", "trollata", "trombata", "troncata", "tropicalizzata", "trovata", "truccata", "trucidata", "truffata", "tuffata", "tumefatta", "tumulata", "turata", "turbata", "turlupinata", "tutelata", "ubbligata", "ubicata", "ubidita", "ubiquitinata", "ubriacata", "uccellata", "uccellinata", "uccisa", "udita", "ufficializzata", "uggita", "ugnata", "uguagliata", "ulcerata", "ulita", "ulolata", "ultimata", "ultracentrifugata", "ululata", "umanata", "umanizzata", "umettata", "umidificata", "umidita", "umiliata", "uncinata", "unguentata", "unificata", "uniformata", "unita", "univerbata", "universaleggiata", "universalizzata", "untata", "unta", "uperizzata", "urbanizzata", "urgenzata", "urlata", "urtacchiata", "urtata", "urticchiata", "usata", "usciolata", "usolata", "ustionata", "usucapita", "usurata", "usurpata", "utilitata", "utilizzata", "vaccinata", "vagabondeggiata", "vagellata", "vagheggiata", "vagillata", "vagliata", "valcata", "valicata", "validata", "valorizzata", "valsa", "valutata", "vanagloriata", "vanata", "vandalizzata", "vangata", "vangelizzata", "vanificata", "vanita", "vantaggiata", "vantata", "vaporata", "vaporizzata", "varata", "varcata", "variata", "vasectomizzata", "vaticinata", "vedovata", "veduta", "vegetata", "veggiata", "vegliata", "veicolata", "velarizzata", "velata", "velettata", "velinata", "vellicata", "vellutata", "velocizzata", "vendemmiata", "vendicata", "vendicchiata", "venducchiata", "venduta", "venerata", "vengiata", "ventagliata", "ventilata", "ventolata", "verbalizzata", "vergata", "vergheggiata", "vergognata", "vergolata", "verificata", "verminata", "vernalizzata", "verniciata", "verrinata", "versata", "verseggiata", "versificata", "verticalizzata", "vessata", "vestita", "vestita", "vetrificata", "vetrinata", "vetrioleggiata", "vettovagliata", "vezzeggiata", "viaggiata", "vicinata", "vicitata", "videochattata", "videochiamata", "videocomunicata", "videoregistrata", "videotrasmessa", "vidimata", "vigilata", "vigliata", "vigoreggiata", "vigorita", "vilificata", "vilipesa", "villaneggiata", "vincolata", "vinta", "violata", "violentata", "violinata", "virgolata", "virgoleggiata", "virgolettata", "virilizzata", "virtualizzata", "visionata", "visitata", "vissuta", "vistata", "vista", "visualizzata", "vitaliziata", "vitalizzata", "vitaminizzata", "vittimizzata", "vituperata", "vivacizzata", "vivandata", "vivificata", "vivisezionata", "viziata", "vocabolarizzata", "vocalizzata", "vocata", "vociferata", "volantinata", "volatilizzata", "volgarizzata", "volicchiata", "volpeggiata", "voltata", "volta", "voltolata", "volturata", "voluminizzata", "voluta", "volutoca", "vomitata", "vorata", "votata", "vulcanizzata", "vuotata", "wappata", "wikificata", "xerocopiata", "zaffata", "zampata", "zampettata", "zampillata", "zannata", "zappata", "zappettata", "zapponata", "zavorrata", "zeppata", "zigrinata", "zigzagata", "zimbellata", "zincata", "zinnata", "zipolata", "zippata", "zirlata", "zittita", "zizzagata", "zoccolata", "zollata", "zombata", "zonata", "zonizzata", "zoppata", "zoppeggiata", "zoppicata", "zucconata", "zufolata", "zumata", "zuppata", "abalienate", "abbacchiate", "abbacinate", "abbadate", "abbagliate", "abbaiate", "abballate", "abbambinate", "abbancate", "abbandonate", "abbarbagliate", "abbarbate", "abbarcate", "abbaruffate", "abbassate", "abbatacchiate", "abbattute", "abbatuffolate", "abbelite", "abbellate", "abbellite", "abbendate", "abbeverate", "abbiadate", "abbicate", "abbigliate", "abbinate", "abbindolate", "abbioccate", "abbiosciate", "abbisciate", "abbittate", "abboccate", "abboffate", "abbominate", "abbonacciate", "abbonate", "abbonite", "abbordate", "abborracciate", "abborrate", "abborrite", "abbottinate", "abbottonate", "abbozzacchiate", "abbozzate", "abbozzolate", "abbracciate", "abbraciate", "abbrancate", "abbreviate", "abbriccate", "abbrigliate", "abbrivate", "abbriviate", "abbrividite", "abbronzate", "abbrostolate", "abbrostolite", "abbruciacchiate", "abbruciate", "abbrunate", "abbrunite", "abbruscate", "abbrusciate", "abbrustiate", "abbrustolate", "abbrustolite", "abbrutite", "abbruttite", "abbuffate", "abbuiate", "abbuonate", "abburattate", "abbuzzite", "abdicate", "abdotte", "abiettate", "abilitate", "abissate", "abitate", "abituate", "abiurate", "abolite", "abominate", "abondate", "aborrite", "abrase", "abrogate", "abusate", "accaffate", "accagionate", "accagliate", "accalappiate", "accalcate", "accaldate", "accallate", "accalorate", "accalorite", "accambiate", "accampate", "accampionate", "accanalate", "accanate", "accaneggiate", "accanite", "accantonate", "accaparrate", "accapezzate", "accapigliate", "accapottate", "accappiate", "accappiettate", "accapponate", "accappucciate", "accaprettate", "accareggiate", "accarezzate", "accarnate", "accarpionate", "accartocciate", "accasate", "accasciate", "accasellate", "accasermate", "accastellate", "accastellinate", "accatarrate", "accatastate", "accattate", "accattivate", "accavalcate", "accavalciate", "accavallate", "accavezzate", "accecate", "acceffate", "accelerate", "accellerate", "accennate", "accensate", "accentate", "accentrate", "accentuate", "acceppate", "accerchiate", "accercinate", "accertate", "accese", "accessoriate", "accettate", "acchetate", "acchiappate", "acchiocciolate", "acchitate", "acchiudute", "acciabattate", "acciaiate", "acciambellate", "acciarpate", "acciecate", "accigliate", "acciglionate", "accignute", "accincignate", "accinte", "acciocchite", "acciottolate", "accipigliate", "accismate", "accise", "acciucchite", "acciuffate", "accivettate", "acclamate", "acclarate", "acclimatate", "accluse", "accoccate", "accoccolate", "accoccovate", "accodate", "accollate", "accoltellate", "accolte", "accomandate", "accomiatate", "accommiatate", "accomodate", "accompagnate", "accomunate", "acconciate", "acconigliate", "accontate", "accontentate", "accoppate", "accoppiate", "accorate", "accorciate", "accorcite", "accordate", "accordellate", "accorpate", "accorte", "accosciate", "accostate", "accostumate", "accotonate", "accottimate", "accovacciate", "accovate", "accovonate", "accozzate", "accreditate", "accresciute", "accrespate", "accucciate", "accucciolate", "accudite", "acculate", "acculturate", "accumulate", "accumunate", "accusate", "acetificate", "acetilate", "acetite", "acidate", "acidificate", "acidulate", "acquadernate", "acquarellate", "acquartierate", "acquate", "acquattate", "acquerellate", "acquetate", "acquietate", "acquisite", "acquistate", "acromatizzate", "acuite", "acuminate", "acutizzate", "adacquate", "adagiate", "adattate", "addaziate", "addebbiate", "addebitate", "addecimate", "addensate", "addentate", "addentellate", "addentrate", "addestrate", "addette", "addiacciate", "addimandate", "addimesticate", "addimorate", "addimostrate", "addipanate", "addirizzate", "additate", "additivate", "addizionate", "addobbate", "addocilite", "addogliate", "addolcate", "addolciate", "addolcite", "addolorate", "addomandate", "addomesticate", "addoppiate", "addormentate", "addossate", "addotte", "addottorate", "addottrinate", "addrizzate", "adduate", "addugliate", "adeguate", "adempite", "adempiute", "adequate", "aderizzate", "adescate", "adibite", "adirate", "adite", "adiuvate", "adizzate", "adocchiate", "adombrate", "adonate", "adonestate", "adontate", "adoperate", "adoprate", "adorate", "adornate", "adottate", "adsorbite", "aduggiate", "adugnate", "adulate", "adulterate", "adunate", "adunghiate", "adusate", "aerate", "aereate", "aerotrainate", "aerotrasportate", "affabulate", "affaccendate", "affacchinate", "affacciate", "affagottate", "affaldate", "affamate", "affamigliate", "affannate", "affardellate", "affascinate", "affastellate", "affaticate", "affattucchiate", "affatturate", "affermate", "afferrate", "affettate", "affezionate", "affiancate", "affiatate", "affibbiate", "affidate", "affienate", "affievolite", "affigliate", "affigurate", "affilate", "affilettate", "affiliate", "affinate", "affiochite", "affiorate", "affisate", "affissate", "affisse", "affittate", "affittite", "afflitte", "afflosciate", "affocate", "affogate", "affogliate", "affollate", "affoltate", "affondate", "afforcate", "afforestate", "afforzate", "affossate", "affralite", "affrancate", "affrante", "affratellate", "affrenate", "affrenellate", "affrescate", "affrettate", "affrittellate", "affrontate", "affumate", "affumicate", "affumigate", "affuocate", "affusolate", "africanizzate", "ageminate", "agevolate", "aggallate", "agganciate", "aggangherate", "aggarbate", "aggattonate", "aggavignate", "aggelate", "aggettivate", "agghiacciate", "agghiadate", "agghiaiate", "agghindate", "aggiaccate", "aggiogate", "aggiornate", "aggirate", "aggiucchite", "aggiudicate", "aggiuntate", "aggiunte", "aggiustate", "agglomerate", "agglutinate", "aggomitolate", "aggottate", "aggradite", "aggraffate", "aggranchiate", "aggranchite", "aggrandite", "aggrappate", "aggraticciate", "aggravate", "aggredite", "aggregate", "aggrevate", "aggricciate", "aggrinzate", "aggrinzite", "aggrommate", "aggrondate", "aggroppate", "aggrottate", "aggrovigliate", "aggrumate", "aggruppate", "aggruzzolate", "agguagliate", "agguantate", "agguardate", "agguatate", "aggueffate", "agitate", "agognate", "agrarizzate", "aguatate", "agucchiate", "agunate", "agurate", "aguzzate", "aitate", "aiutate", "aizzate", "alate", "alberate", "albergate", "alcalinizzate", "alchilate", "alchimiate", "alchimizzate", "alcolizzate", "alcoolizzate", "alenate", "alesate", "alettate", "alfabetate", "alfabetizzate", "alidite", "alienate", "alimentate", "allacciate", "allagate", "allappate", "allargate", "allascate", "allattate", "alleate", "allegate", "alleggerite", "alleggiate", "allegorizzate", "alleluiate", "allenate", "allenite", "allentate", "allertate", "allessate", "allestite", "allettate", "allevate", "alleviate", "allibate", "allibite", "allibrate", "allicciate", "allietate", "allindate", "allineate", "allise", "allocate", "allogate", "alloggiate", "allontanate", "allottate", "allucchettate", "allucciolate", "allucinate", "allumate", "alluminate", "alluminiate", "allungate", "allupate", "alluse", "alluzzate", "alogenate", "alonate", "alpeggiate", "alterate", "alternate", "alzate", "amalgamate", "amareggiate", "amaricate", "amate", "ambientate", "ambiguate", "ambite", "americanizzate", "amicate", "ammaccate", "ammaestrate", "ammainate", "ammalate", "ammaliate", "ammalinconite", "ammaltate", "ammanettate", "ammanicate", "ammanierate", "ammanigliate", "ammannate", "ammannellate", "ammannite", "ammansate", "ammansite", "ammantate", "ammantellate", "ammarate", "ammarezzate", "ammassate", "ammassellate", "ammassicciate", "ammatassate", "ammattonate", "ammazzate", "ammelmate", "ammencite", "ammendate", "ammennicolate", "ammesse", "ammetate", "ammezzite", "amministrate", "amminutate", "ammirate", "ammiserite", "ammobiliate", "ammodernate", "ammodernizzate", "ammogliate", "ammoinate", "ammollate", "ammollite", "ammonite", "ammonticchiate", "ammonticellate", "ammorbate", "ammorbidate", "ammorbidite", "ammorsate", "ammortate", "ammortite", "ammortizzate", "ammorzate", "ammosciate", "ammoscite", "ammostate", "ammotinate", "ammucchiate", "ammulinate", "ammusate", "ammutate", "ammutinate", "amnistiate", "amoracciate", "ampiate", "ampliate", "amplificate", "amputate", "anagrammate", "analizzate", "anamorfizzate", "anastomizzate", "anatematizzate", "anatomizzate", "anchilosate", "ancise", "ancorate", "andatosene", "andicappate", "anellate", "anemizzate", "anestetizzate", "angariate", "anglicizzate", "angolate", "angosciate", "angustiate", "animate", "annacquate", "annaffiate", "annasate", "annaspate", "annaspicate", "annebbiate", "annegate", "annerate", "annerite", "annesse", "annestate", "annichilate", "annichilite", "annidate", "annientate", "annitrite", "annobilite", "annodate", "annodicchiate", "annoiate", "annotate", "annottate", "annottolate", "annoverate", "annullate", "annunciate", "annunziate", "annusate", "annuvolate", "anodizzate", "anonimizzate", "antecedute", "anteposte", "antergate", "anticheggiate", "antichizzate", "anticipate", "anticonosciute", "antidatate", "antivedute", "antiviste", "antologizzate", "antropizzate", "antropomorfizzate", "aocchiate", "aombrate", "aonestate", "aontate", "aperte", "apocopate", "apologizzate", "apostrofate", "appaciate", "appacificate", "appagate", "appaiate", "appalesate", "appallottolate", "appaltate", "appanettate", "appannate", "apparate", "apparecchiate", "apparentate", "apparigliate", "apparite", "appartate", "appassionate", "appastate", "appastellate", "appellate", "appennellate", "appercepite", "appertizzate", "appesantite", "appesite", "appese", "appestate", "appetite", "appezzate", "appiacevolite", "appianate", "appiastrate", "appiatate", "appiattate", "appiattite", "appiccate", "appiccicate", "appiccolite", "appiedate", "appigionate", "appigliate", "appinzate", "appiombate", "appioppate", "appisolate", "applaudite", "applicate", "appoderate", "appoggiate", "appollaiate", "appoppate", "apportate", "appostate", "apposte", "appratite", "appresentate", "apprese", "appressate", "apprestate", "apprettate", "apprezzate", "approcciate", "approfittate", "approfondate", "approfondite", "approntate", "appropinquate", "appropriate", "approssimate", "approvate", "approvisionate", "approvvigionate", "appruate", "appulcrate", "appuntate", "appuntellate", "appuntite", "appurate", "appuzzate", "arabescate", "arabizzate", "arate", "arbitrate", "arborate", "arcaizzate", "arcate", "architettate", "archiviate", "arcuate", "ardite", "areate", "argentate", "arginate", "argomentate", "arguite", "arianizzate", "arieggiate", "armate", "armonizzate", "aromatizzate", "arpeggiate", "arpionate", "arponate", "arrabattate", "arraffate", "arraffiate", "arrandellate", "arrangiate", "arrapate", "arrapinate", "arrappate", "arrazzate", "arrecate", "arredate", "arreggimentate", "arrembate", "arrenate", "arresise", "arrese", "arrestate", "arretrate", "arricchite", "arricciate", "arricciolate", "arriffate", "arringate", "arrischiate", "arrisicate", "arrise", "arrocate", "arroccate", "arrochite", "arrogate", "arrolate", "arroncate", "arronzate", "arrosate", "arrossate", "arrostate", "arrostite", "arrotate", "arrotolate", "arrotondate", "arrovellate", "arroventate", "arroventite", "arrovesciate", "arrubinate", "arruffate", "arruffianate", "arrugginite", "arruncigliate", "arruolate", "arruvidite", "arsicciate", "arse", "artefatte", "articolate", "artigliate", "ascese", "asciate", "asciolvute", "asciugate", "ascoltate", "ascose", "ascoste", "ascritte", "asfaltate", "asfissiate", "asperse", "aspettate", "aspirate", "asportate", "aspreggiate", "assaettate", "assaggiate", "assalite", "assaltate", "assaporate", "assaporite", "assassinate", "assecondate", "assecurate", "assediate", "asseggiate", "assegnate", "assembiate", "assemblate", "assembrate", "assemprate", "assentate", "asserite", "asserragliate", "asservite", "assestate", "assetate", "assettate", "asseverate", "assibilate", "assicurate", "assiderate", "assiemate", "assiepate", "assillate", "assimigliate", "assimilate", "assiomatizzate", "assise", "assistite", "associate", "assodate", "assoggettate", "assolcate", "assoldate", "assolte", "assolutizzate", "assomate", "assommate", "assonate", "assonnate", "assopite", "assorbite", "assordate", "assordite", "assortite", "assottigliate", "assuefatte", "assunte", "asteggiate", "astenute", "asterse", "astratte", "astrette", "atomizzate", "atrofizzate", "atrovate", "attaccate", "attagliate", "attanagliate", "attardate", "attediate", "atteggiate", "attempate", "attendate", "attentate", "attenuate", "attenute", "attergate", "atterrate", "atterrite", "atterzate", "attese", "attestate", "atticizzate", "attillate", "attinte", "attirate", "attivate", "attivizzate", "attizzate", "attorcigliate", "attorniate", "attorte", "attoscate", "attossicate", "attraccate", "attrappite", "attratte", "attraversate", "attrezzate", "attribuite", "attristate", "attristite", "attruppate", "attualizzate", "attuate", "attuffate", "attutate", "attutite", "auggiate", "augumentate", "augurate", "aulite", "aumentate", "aunghiate", "ausate", "auscultate", "auspicate", "autenticate", "autentificate", "autoaccusate", "autoaffondate", "autoalimentate", "autoassolte", "autocandidate", "autocensurate", "autocitate", "autocommiserate", "autoconsumate", "autoconvinte", "autodefinite", "autodenunciate", "autodistrutte", "autofinanziate", "autogestite", "autogovernate", "autografate", "autoincensate", "autointersecate", "autoinvitate", "autolesionate", "autolimitate", "automaticizzate", "automatizzate", "automotivate", "autonominate", "autoproclamate", "autoprodotte", "autoprotette", "autopubblicate", "autopubblicizzate", "autoregolamentate", "autoregolate", "autoridotte", "autoriparate", "autorizzate", "autosomministrate", "autosostenute", "autosuggestionate", "autotassate", "autotrapiantate", "autotrasportate", "autovalutate", "avallate", "avampate", "avanzate", "avariate", "avinte", "aviolanciate", "aviotrasportate", "avocate", "avolterate", "avulse", "avutacele", "avute", "avvalorate", "avvalse", "avvantaggiate", "avvelate", "avvelenate", "avventate", "avventurate", "avverate", "avversate", "avvertite", "avvezzate", "avviate", "avvicendate", "avvicinate", "avvignate", "avvilite", "avviluppate", "avvinate", "avvinchiate", "avvinghiate", "avvinte", "avvisate", "avvistate", "avvitate", "avviticchiate", "avvitite", "avvivate", "avvolte", "avvoltolate", "aziendalizzate", "azionate", "azotate", "azzannate", "azzardate", "azzeccate", "azzerate", "azzimate", "azzittate", "azzittite", "azzoppate", "azzoppite", "azzuffate", "azzurrate", "bacate", "baccagliate", "bacchettate", "bacchiate", "baciate", "badate", "bagnate", "baipassate", "balbettate", "balcanizzate", "ballate", "baloccate", "balzate", "banalizzate", "bancate", "bandite", "bannate", "baraccate", "barattate", "barbarizzate", "barcamenate", "bardate", "barellate", "barrate", "barricate", "basate", "basciate", "basculate", "bassate", "bastate", "bastionate", "bastite", "bastonate", "battezzate", "battute", "bazzicate", "beatificate", "beate", "beccate", "beccheggiate", "becchettate", "beffate", "beffeggiate", "bendate", "benedette", "beneficate", "benvolute", "berlusconizzate", "bersagliate", "bestemmiate", "bevute", "biadate", "bianchettate", "bianchite", "biascicate", "biasimate", "biasmate", "bidonate", "biennalizzate", "biforcate", "bigiate", "bilanciate", "binate", "bindolate", "biodegradate", "biografate", "bipartite", "bisbigliate", "biscottate", "bisecate", "bisellate", "bisognate", "bissate", "bistrate", "bistrattate", "bitumate", "bituminate", "blandite", "bleffate", "blindate", "bloccate", "bobinate", "boccheggiate", "bocciate", "boicottate", "bollate", "bollite", "bombardate", "bombate", "bonderizzate", "bonificate", "bootate", "borbottate", "bordate", "boriate", "borrate", "borseggiate", "braccate", "bracciate", "bramate", "bramite", "brancicate", "brandeggiate", "brandite", "brasate", "bravate", "brevettate", "breviate", "brillantate", "brillate", "brinate", "broccate", "brocciate", "broccolate", "brontolate", "bronzate", "brucate", "bruciacchiate", "bruciate", "brunite", "bruscate", "bruschinate", "brutalizzate", "bruttate", "bucate", "bucherellate", "bufate", "buffate", "bufferizzate", "buggerate", "bugnate", "bulicate", "bulinate", "bullettate", "bullonate", "burattate", "burlate", "burocratizzate", "burrificate", "buscate", "buttate", "butterate", "bypassate", "cablate", "cabrate", "cacate", "cacciate", "cadenzate", "cadmiate", "caducate", "cagate", "caggiate", "cagionate", "cagliate", "calafatate", "calamitate", "calandrate", "calate", "calcate", "calciate", "calcificate", "calcolate", "caldeggiate", "calettate", "calibrate", "calmate", "calmierate", "calpestate", "calumate", "calunniate", "calzate", "cambiate", "camerate", "campionate", "campite", "camuffate", "canalizzate", "cancellate", "cancerizzate", "candeggiate", "candidate", "candite", "canforate", "cangiate", "cannate", "canneggiate", "cannibalizzate", "cannoneggiate", "canonizzate", "cantate", "canterellate", "canticchiate", "cantilenate", "canzonate", "caolinizzate", "capacitate", "capeggiate", "capillarizzate", "capitalizzate", "capitanate", "capitaneggiate", "capite", "capitozzate", "capivolte", "caponate", "capotate", "capottate", "capovolte", "capponate", "captate", "caramellate", "caramellizzate", "caratate", "caratterizzate", "carbonizzate", "carbossilate", "carburate", "carcate", "carcerate", "cardate", "carenate", "carezzate", "cariate", "caricate", "caricaturate", "caricaturizzate", "carotate", "carpionate", "carpite", "carreggiate", "carrozzate", "cartavetrate", "carteggiate", "cartellinate", "cartografate", "cartolarizzate", "cartonate", "cascolate", "cassate", "casse", "castigate", "castrate", "casualizzate", "catabolizzate", "catalizzate", "catalogate", "catapultate", "catechizzate", "categorizzate", "cateterizzate", "catramate", "cattolicizzate", "catturate", "causate", "cautelate", "cauterizzate", "cauzionate", "cavalcate", "cavatasele", "cavate", "cazzate", "cazziate", "cazzottate", "cedrate", "cedute", "celate", "celebrate", "cellofanate", "cementate", "cementificate", "cennate", "censite", "censurate", "centellate", "centellinate", "centimetrate", "centinate", "centralizzate", "centrate", "centrifugate", "centuplicate", "cerate", "cercate", "cerchiate", "cernute", "certificate", "cesellate", "cessate", "cestinate", "cheratinizzate", "chetate", "chiamate", "chiappate", "chiarificate", "chiarite", "chiaroscurate", "chiavate", "chiazzate", "chieste", "chilificate", "chilometrate", "chimificate", "chinate", "chinizzate", "chiodate", "chiosate", "chiuse", "choccate", "ciancicate", "cianfrinate", "cianfrugliate", "ciangottate", "ciattate", "cibate", "cicatrizzate", "ciccate", "cicchettate", "ciclizzate", "ciclostilate", "cifrate", "cilindrate", "cimate", "cimentate", "cincischiate", "cinematografate", "cintate", "cinte", "cioncate", "ciondolate", "circolate", "circoncinte", "circoncise", "circondate", "circondotte", "circonflesse", "circonfluite", "circonfuse", "circonscritte", "circonvenute", "circoscritte", "circostanziate", "circuite", "circumcinte", "circumnavigate", "citate", "ciucciate", "ciurmate", "civettate", "civilizzate", "clamate", "classate", "classicizzate", "classificate", "cliccate", "climatizzate", "clivate", "clonate", "cloroformizzate", "clorurate", "clusterizzate", "co-dirette", "coacervate", "coadiuvate", "coagulate", "coalizzate", "coartate", "coccolate", "codificate", "coeditate", "coesistite", "cofinanziate", "cofirmate", "cofondate", "cogestite", "cogitate", "coglionate", "cognosciute", "coibentate", "coincise", "cointeressate", "cointestate", "coinvolte", "cokificate", "colate", "colettate", "collassate", "collaudate", "collazionate", "collegate", "collettivizzate", "collezionate", "collimate", "colliquate", "collise", "collocate", "colluttate", "colmate", "colonizzate", "colorate", "colorite", "colorizzate", "colpevolizzate", "colpite", "coltellate", "coltivate", "colte", "coltrate", "comandate", "combattute", "combinate", "comburute", "comicizzate", "cominciate", "commemorate", "commendate", "commensurate", "commentate", "commercializzate", "commesse", "comminate", "commiserate", "commissariate", "commissionate", "commisurate", "commosse", "commutate", "comodate", "compaginate", "comparite", "compartimentalizzate", "compartite", "compassionate", "compatibilizzate", "compatite", "compattate", "compendiate", "compenetrate", "compensate", "comperate", "compiaciute", "compiante", "compilate", "compitate", "compiute", "complessate", "complessificate", "complesse", "completate", "complicate", "complimentate", "comportate", "compostate", "composte", "comprate", "compravendute", "comprese", "compresse", "compromesse", "comprovate", "compulsate", "compunte", "computate", "computerizzate", "comunicate", "comunistizzate", "concatenate", "concedute", "concelebrate", "concentrate", "concepite", "concertate", "concesse", "concettate", "concettualizzate", "conchiuse", "conciate", "conciliate", "concimate", "concitate", "conclamate", "concluse", "concordate", "concotte", "concretate", "concretizzate", "conculcate", "concupite", "condannate", "condensate", "condite", "condivise", "condizionate", "condolute", "condonate", "condotte", "confatte", "confederate", "conferite", "confermate", "confessate", "confettate", "confezionate", "conficcate", "confidate", "configurate", "confinate", "confinte", "confiscate", "confitte", "conformate", "confortate", "confricate", "confrontate", "confuse", "confutate", "congedate", "congegnate", "congelate", "congestionate", "congetturate", "congiunte", "conglobate", "conglomerate", "conglutinate", "congratulate", "congregate", "conguagliate", "coniate", "coniugate", "connaturate", "connesse", "connotate", "connumerate", "conosciute", "conquistate", "consacrate", "consapevolizzate", "consegnate", "conseguite", "consentite", "conservate", "considerate", "consigliate", "consistite", "consociate", "consolate", "consolidate", "consorziate", "consparse", "consperse", "constatate", "constrette", "construite", "consultate", "consumate", "consunte", "contabilizzate", "contagiate", "containerizzate", "contaminate", "contate", "contattate", "conteggiate", "contemperate", "contemplate", "contentate", "contenute", "contese", "contestate", "contestualizzate", "contingentate", "continuate", "contornate", "contorte", "contrabbandate", "contraccambiate", "contraddette", "contraddistinte", "contradette", "contraffatte", "contrappesate", "contrapposte", "contrappuntate", "contrariate", "contrassegnate", "contrastate", "contrate", "contrattaccate", "contrattate", "contratte", "contravvalse", "contristate", "controbattute", "controbilanciate", "controdatate", "controfirmate", "controindicate", "controllate", "controminate", "contronotate", "controproposte", "controprovate", "controquerelate", "controsoffittate", "controstampate", "controventate", "conturbate", "contuse", "convalidate", "convenute", "convenzionate", "convertite", "convinte", "convitate", "convocate", "convogliate", "convolte", "coobate", "cooptate", "coordinate", "coperchiate", "coperte", "copiaincollate", "copiate", "copolimerizzate", "coppellate", "coprodotte", "corazzate", "corbellate", "corcate", "cordonate", "coreografate", "coricate", "cornificate", "coronate", "corredate", "correlate", "corresponsabilizzate", "corrette", "corricchiate", "corrisposte", "corroborate", "corrose", "corrotte", "corrucciate", "corrugate", "corse", "corteate", "corteggiate", "cortocircuitate", "coruscate", "cosate", "coscritte", "cosparse", "cosperse", "costatate", "costeggiate", "costellate", "costernate", "costicchiate", "costipate", "costituite", "costituzionalizzate", "costrette", "costruite", "costudite", "cotonate", "cotte", "covate", "coventrizzate", "coverchiate", "craccate", "create", "credute", "cremate", "crepate", "cresciute", "cresimate", "crespate", "criminalizzate", "crioconcentrate", "criptate", "cristallizzate", "cristianizzate", "criticate", "crittate", "crittografate", "crivellate", "crocchiate", "crocefisse", "crocefitte", "crocifisse", "crocifitte", "crogiolate", "cromate", "cronicizzate", "cronometrate", "crostate", "crucciate", "crucifisse", "crucifitte", "cuccate", "cucinate", "cucite", "cullate", "cumulate", "cuntate", "curate", "curvate", "curvate", "custodite", "customizzate", "damascate", "damaschinate", "damate", "dannate", "danneggiate", "danzate", "dardeggiate", "datate", "date", "dattilografate", "dattiloscritte", "daziate", "deacidificate", "deattivate", "debbiate", "debellate", "debilitate", "decaffeinate", "decaffeinizzate", "decalcate", "decalcificate", "decantate", "decapate", "decapitate", "decappottate", "decarbossilate", "decarburate", "decatizzate", "decelerate", "decentralizzate", "decentrate", "decerebrate", "decernute", "decespugliate", "deciferate", "decifrate", "decimalizzate", "decimate", "decise", "declamate", "declassate", "declassificate", "declinate", "declorate", "decodificate", "decolonizzate", "decolorate", "decompartimentate", "decompilate", "decomposte", "decompresse", "deconcentrate", "decondizionate", "decongelate", "decongestionate", "decontaminate", "decontestualizzate", "decontratte", "decorate", "decorticate", "decostruite", "decrementate", "decretate", "decriminalizzate", "decriptate", "decrittate", "decuplicate", "decurtate", "dedicate", "dedotte", "defacciate", "defalcate", "defascistizzate", "defecate", "defenestrate", "deferite", "defilate", "definite", "defiscalizzate", "defitte", "deflazionate", "deflemmate", "deflorate", "defogliate", "defoliate", "deforestate", "deformate", "defosforate", "defosforilate", "deframmentate", "defraudate", "degassate", "degassificate", "deglutite", "degnate", "degradate", "degustate", "deidratate", "deidrogenate", "deificate", "deindicizzate", "deindustrializzate", "deionizzate", "delegate", "delegificate", "delegittimate", "delibate", "deliberate", "delimitate", "delineate", "delirate", "deliziate", "delocalizzate", "delucidate", "deluse", "demagnetizzate", "demandate", "demanializzate", "demarcate", "demeritate", "demerse", "demetallizzate", "demilitarizzate", "demineralizzate", "demistificate", "demitizzate", "democratizzate", "demodulate", "demolite", "demoltiplicate", "demonetate", "demonetizzate", "demonizzate", "demoralizzate", "demorse", "demotivate", "denaturalizzate", "denaturate", "denazificate", "denazionalizzate", "denicotinizzate", "denigrate", "denitrificate", "denocciolate", "denominate", "denotate", "dentellate", "denuclearizzate", "denudate", "denunciate", "denunziate", "deodorate", "deossidate", "deossigenate", "deostruite", "depauperate", "depenalizzate", "depennate", "depilate", "depinte", "depistate", "deplorate", "depolarizzate", "depolimerizzate", "depoliticizzate", "depolverizzate", "deportate", "depositate", "deposte", "depotenziate", "depravate", "deprecate", "depredate", "depresse", "depressurizzate", "deprezzate", "deprivate", "deprotonate", "depulse", "depurate", "dequalificate", "deratizzate", "derattizzate", "dereferenziate", "deregolamentate", "deregolate", "derequisite", "deresponsabilizzate", "derise", "derubate", "derubricate", "desacralizzate", "desalate", "desalinizzate", "descolarizzate", "descritte", "desecretate", "desegretate", "deselezionate", "desensibilizzate", "desessualizzate", "desiate", "desiderate", "designate", "desinate", "desirate", "desolate", "desolforate", "desonorizzate", "desorbite", "desossidate", "desquamate", "destabilizzate", "destagionalizzate", "destalinizzate", "destatalizzate", "destatizzate", "destate", "destinate", "destituite", "destoricizzate", "destreggiate", "destrutte", "destrutturate", "desunte", "detassate", "detenute", "deteriorate", "determinate", "deterse", "detestate", "detonate", "detorte", "detossificate", "detratte", "detronizzate", "dettagliate", "dettate", "dette", "deturpate", "deumidificate", "devastate", "deventate", "deviate", "deviscerate", "devitalizzate", "devitaminizzate", "devolute", "dezippate", "diaframmate", "diagnosticate", "diagonalizzate", "diagrammate", "dializzate", "dialogate", "dialogizzate", "diazotate", "dibattute", "diboscate", "dichiarate", "diesate", "diesizzate", "difese", "diffamate", "differite", "diffidate", "diffrante", "diffratte", "diffuse", "digerite", "digitalizzate", "digitate", "digiunte", "digrassate", "digrignate", "digrossate", "dilacerate", "dilaniate", "dilapidate", "dilatate", "dilavate", "dilazionate", "dileggiate", "dileguate", "dilettate", "dilette", "diliscate", "dilucidate", "diluite", "dilungate", "dimagrate", "dimandate", "dimenate", "dimensionate", "dimenticate", "dimerizzate", "dimesse", "dimezzate", "diminuite", "dimissionate", "dimostrate", "dimunte", "dinamizzate", "dinoccate", "dipanate", "dipelate", "dipinte", "diplomate", "diposte", "diradate", "diramate", "dirette", "direzionate", "dirimute", "diroccate", "dirottate", "dirotte", "dirozzate", "disabilitate", "disabituate", "disaccentate", "disaccoppiate", "disaccordate", "disacerbate", "disacidate", "disacidificate", "disacidite", "disaerate", "disaffezionate", "disaggregate", "disalberate", "disallineate", "disamate", "disambiguate", "disaminate", "disamorate", "disancorate", "disanimate", "disappannate", "disapplicate", "disapprese", "disapprovate", "disarcionate", "disarmate", "disarticolate", "disascoste", "disassemblate", "disassuefatte", "disatomizzate", "disattese", "disattivate", "disattrezzate", "disavvezzate", "disboscate", "disbrigate", "discacciate", "discalzate", "discantate", "discaricate", "discernute", "discese", "disceverate", "dischieste", "dischiuse", "discinte", "disciolte", "disciplinate", "discolorate", "discolpate", "discommesse", "discompagnate", "discomposte", "disconcluse", "disconfitte", "discongiunte", "disconnesse", "disconosciute", "discoperte", "discordate", "discoscese", "discostate", "discreditate", "discresciute", "discriminate", "discritte", "discucite", "discuoiate", "discusse", "disdegnate", "disdettate", "disdette", "diseccate", "diseccitate", "diseducate", "disegnate", "diserbate", "diseredate", "disertate", "diserte", "disfatte", "disgelate", "disgiunte", "disgraziate", "disgregate", "disgustate", "disidentificate", "disiderate", "disidratate", "disilluse", "disimballate", "disimparate", "disimpegnate", "disimpresse", "disincagliate", "disincantate", "disincentivate", "disincrostate", "disindustrializzate", "disinfestate", "disinfettate", "disinflazionate", "disinformate", "disingannate", "disingranate", "disinibite", "disinnamorate", "disinnescate", "disinnestate", "disinquinate", "disinserite", "disinstallate", "disintasate", "disintegrate", "disinteressate", "disintese", "disintossicate", "disinvestite", "disinvolte", "disistimate", "dislocate", "dismesse", "disobbedite", "disobbligate", "disonorate", "disordinate", "disorganizzate", "disorientate", "disormeggiate", "disossate", "disossidate", "disostruite", "disotterrate", "disparite", "dispensate", "dispente", "disperdute", "disperse", "dispese", "dispiegate", "dispinte", "dispogliate", "disposte", "dispregiate", "disprezzate", "dispromesse", "disproporzionate", "disputate", "disqualificate", "disrotte", "dissacrate", "dissalate", "dissaldate", "dissanguate", "dissecate", "disseccate", "disselciate", "dissellate", "disseminate", "dissepolte", "disseppellite", "dissequestrate", "disserrate", "dissestate", "dissetate", "dissezionate", "dissigillate", "dissimulate", "dissipate", "dissociate", "dissodate", "dissolte", "dissomigliate", "dissotterrate", "dissuase", "dissuggellate", "distaccate", "distanziate", "distese", "distillate", "distinte", "distolte", "distorte", "distratte", "distrette", "distribuite", "districate", "distrigate", "distrutte", "disturbate", "disubbidite", "disumanate", "disumanizzate", "disunite", "disusate", "disvedute", "disvelate", "disvestite", "disviate", "disviste", "disvolte", "disvolute", "dittongate", "divallate", "divaricate", "divelte", "diversificate", "divertite", "divezzate", "divinate", "divincolate", "divinizzate", "divise", "divolte", "divorate", "divorziate", "divulgate", "documentate", "dogate", "dogmatizzate", "dolcificate", "dollarizzate", "dolorate", "dolute", "domandate", "domate", "domesticate", "domiciliate", "dominate", "donate", "dondolate", "dopate", "doppiate", "dorate", "dormitoce", "dosate", "dotate", "dovute", "dragate", "drammatizzate", "drappeggiate", "drenate", "dribblate", "drizzate", "drogate", "dugliate", "duplicate", "duramificate", "ebraizzate", "eccedute", "eccepite", "eccettuate", "eccitate", "echeggiate", "eclissate", "economizzate", "edificate", "editate", "edotte", "educate", "edulcorate", "effettuate", "efficientate", "effigiate", "effinte", "effluite", "effuse", "egemonizzate", "eguagliate", "eiettate", "elaborate", "elargite", "elasticizzate", "elementarizzate", "elemosinate", "elencate", "elette", "elettrificate", "elettrizzate", "elettrocoagulate", "elettrolizzate", "elevate", "eliminate", "elise", "elitrasportate", "ellenizzate", "elogiate", "elucidate", "elucubrate", "eluite", "eluse", "emanate", "emancipate", "emarginate", "embricate", "emendate", "emesse", "emozionate", "empite", "empiute", "emulate", "emulsionate", "emunte", "encomiate", "endocitate", "energizzate", "enfatizzate", "enfiate", "entusiasmate", "enucleate", "enumerate", "enunciate", "epicureggiate", "epurate", "equalizzate", "equilibrate", "equipaggiate", "equiparate", "eradicate", "erase", "ereditate", "erette", "erogate", "eroicizzate", "erose", "erotizzate", "erpicate", "erse", "erudite", "eruttate", "esacerbate", "esagerate", "esagitate", "esalate", "esaltate", "esaminate", "esasperate", "esaudite", "esaurite", "esautorate", "esborsate", "escluse", "escogitate", "escomiate", "escoriate", "escosse", "escusse", "esecrate", "esecutate", "eseguite", "esemplificate", "esentate", "esercitate", "esfoliate", "esibite", "esilarate", "esiliate", "esimute", "esitate", "esonerate", "esorbitate", "esorcizzate", "esortate", "espanse", "esparse", "esperimentate", "esperite", "espettorate", "espiantate", "espiate", "espirate", "espletate", "esplicate", "esplicitate", "esplorate", "esplose", "esportate", "esposte", "espresse", "espropriate", "espugnate", "espulse", "espunte", "espurgate", "essiccate", "essute", "estasiate", "estenuate", "esterificate", "esteriorizzate", "esterminate", "esternalizzate", "esternate", "estese", "estimate", "estinte", "estirpate", "estivate", "estorte", "estradate", "estraniate", "estrapolate", "estratte", "estremizzate", "estrinsecate", "estromesse", "estruse", "estubate", "esulcerate", "esultate", "esumate", "eterificate", "eterizzate", "eternate", "eternizzate", "etichettate", "etossilate", "euforizzate", "europeizzate", "evacuate", "evangelizzate", "evase", "evete", "evidenziate", "evinte", "evirate", "eviscerate", "evitate", "evocate", "evolte", "evolute", "evulse", "fabbricate", "faccettate", "facilitate", "fagocitate", "falciate", "falcidiate", "fallite", "falsate", "falsificate", "familiarizzate", "fanatizzate", "fantasticate", "farcite", "farfugliate", "fasciate", "fascicolate", "fascistizzate", "fattacele", "fatte", "fattorizzate", "fatturate", "favellate", "favoreggiate", "favorite", "faxate", "fecondate", "fedecommesse", "federalizzate", "federate", "felicitate", "felpate", "feltrate", "femminilizzate", "fendute", "ferite", "fermate", "fermentate", "ferrate", "fertilizzate", "fesse", "fessurate", "festeggiate", "festonate", "feudalizzate", "fiaccate", "fiammeggiate", "fiancheggiate", "ficcate", "fidanzate", "fidate", "fidecommesse", "fidelizzate", "figliate", "figurate", "filate", "filettate", "filmate", "filosofate", "filtrate", "finalizzate", "finanziate", "finitale", "finite", "finlandizzate", "fintate", "finte", "fiocinate", "fiondate", "fiorettate", "firmate", "fiscalizzate", "fischiate", "fischiettate", "fissate", "fissionate", "fitte", "fiutate", "flagellate", "flaggate", "flambate", "flangiate", "flemmatizzate", "flesse", "flippate", "flottate", "fluidificate", "fluidizzate", "fluorizzate", "fluorurate", "focalizzate", "focheggiate", "foderate", "foggiate", "fognate", "folgorate", "follate", "fomentate", "fonate", "fondate", "foracchiate", "foraggiate", "forate", "forestate", "forfettizzate", "forgiate", "formalizzate", "formate", "formattate", "formilate", "formulate", "fornite", "fortificate", "forviate", "forwardate", "forzate", "fosfatate", "fosforate", "fosforilate", "fossilizzate", "fotocomposte", "fotocopiate", "fotografate", "fottute", "fracassate", "fraintese", "framesse", "frammentate", "frammesse", "frammezzate", "frammischiate", "franceseggiate", "francesizzate", "frangiate", "frante", "frantumate", "frappate", "frapposte", "fraseggiate", "frastagliate", "frastornate", "fratturate", "frazionate", "freddate", "fregate", "fregiate", "frenate", "frequentate", "fresate", "frettate", "friendzonate", "fritte", "frizionate", "frodate", "frollate", "fronteggiate", "frugate", "fruite", "frullate", "frusciate", "frustate", "frustrate", "fruttate", "fucilate", "fucinate", "fugate", "fuggite", "fulminate", "fumate", "fumigate", "funestate", "funte", "funzionate", "fuoriuscite", "fuorviate", "fuse", "fustellate", "fustigate", "gabbate", "gabellate", "gallate", "gallicizzate", "gallonate", "galvanizzate", "gambizzate", "garantite", "garnettate", "garrotate", "garzate", "gasate", "gassate", "gassificate", "gazate", "gelatinizzate", "gelate", "gelificate", "gemellate", "gemicate", "geminate", "generalizzate", "generate", "gentrificate", "genuflesse", "geometrizzate", "georeferenziate", "gerarchizzate", "germanizzate", "gestite", "gettate", "gettonate", "ghermite", "ghettizzate", "ghigliottinate", "ghindate", "gibollate", "gingillate", "ginnate", "giocate", "gioite", "gionglate", "giovaneggiate", "girandolate", "girate", "giudicate", "giulebbate", "giuntate", "giunte", "giuracchiate", "giurate", "giustapposte", "giustificate", "giustiziate", "glamourizzate", "glassate", "glissate", "globalizzate", "gloriate", "glorificate", "glossate", "godronate", "godute", "goffrate", "gommate", "gonfiate", "googlate", "gottate", "governate", "gradinate", "gradite", "gradualizzate", "graduate", "graffate", "graffiate", "graffite", "graficate", "grafitate", "gramolate", "granagliate", "grandinate", "granellate", "granite", "granulate", "graticciate", "graticolate", "gratificate", "gratinate", "grattate", "grattugiate", "gravate", "graziate", "grecheggiate", "grecizzate", "gremite", "gridate", "griffate", "grigliate", "grippate", "groccate", "grondate", "grugate", "grugnite", "guadagnate", "gualcite", "guardate", "guarite", "guarnite", "guastate", "guatate", "guerreggiate", "gufate", "guidate", "gustate", "hackerate", "handicappate", "ibridate", "idealizzate", "ideate", "identificate", "ideologizzate", "idolatrate", "idoleggiate", "idratate", "idrogenate", "idrolizzate", "iettate", "igienizzate", "ignifugate", "ignorate", "illanguidite", "illeggiadrite", "illividite", "illuminate", "illuse", "illustrate", "imbacuccate", "imbaldanzite", "imballate", "imbalsamate", "imbambolate", "imbandierate", "imbandite", "imbarbarite", "imbarcate", "imbarilate", "imbastardite", "imbastite", "imbattute", "imbavagliate", "imbeccate", "imbellettate", "imbellite", "imbestialite", "imbestiate", "imbevute", "imbiaccate", "imbiancate", "imbianchite", "imbibite", "imbiettate", "imbiondite", "imbizzarrite", "imboccate", "imbonite", "imborghesite", "imboscate", "imboschite", "imbottate", "imbottigliate", "imbottite", "imbozzimate", "imbracate", "imbracciate", "imbragate", "imbrancate", "imbrattate", "imbrecciate", "imbrigliate", "imbrillantinate", "imbroccate", "imbrodate", "imbrogliate", "imbronciate", "imbruttite", "imbucate", "imbudellate", "imbullettate", "imbullonate", "imburrate", "imbussolate", "imbustate", "imbutite", "imitate", "immagazzinate", "immaginate", "immalinconite", "immatricolate", "immedesimate", "immerse", "immesse", "immischiate", "immiserite", "immobilizzate", "immolate", "immortalate", "immunizzate", "immusonite", "impaccate", "impacchettate", "impacciate", "impadronite", "impaginate", "impagliate", "impalate", "impalcate", "impallate", "impallinate", "impalmate", "impaludate", "impanate", "impaniate", "impannate", "impantanate", "impaperate", "impapocchiate", "impappinate", "imparentate", "imparruccate", "impartite", "impastate", "impasticcate", "impasticciate", "impastocchiate", "impastoiate", "impataccate", "impattate", "impaurite", "impavesate", "impeciate", "impedicate", "impedite", "impegnate", "impegolate", "impelagate", "impellicciate", "impennacchiate", "impennate", "impensierite", "impepate", "imperlate", "impermalite", "impermeabilizzate", "imperniate", "impersonate", "impersonificate", "impestate", "impetrate", "impiallacciate", "impiantate", "impiastrate", "impiastricciate", "impiccate", "impicciate", "impicciolite", "impiccolite", "impidocchiate", "impiegate", "impietosite", "impietrite", "impigliate", "impigrite", "impilate", "impillaccherate", "impinguate", "impinte", "impinzate", "impiombate", "impipate", "impiumate", "implementate", "implicate", "implorate", "impollinate", "impolpate", "impoltronite", "impolverate", "impomatate", "imporcate", "imporporate", "importate", "importunate", "impossessate", "impossibilitate", "impostate", "imposte", "impratichite", "impregnate", "imprese", "impressionate", "impresse", "imprestate", "impreziosite", "imprigionate", "impromesse", "improntate", "improsciuttite", "impugnate", "impuntite", "impunturate", "impupate", "imputate", "impuzzolentite", "inabilitate", "inabissate", "inacerbite", "inacetite", "inacidite", "inacutite", "inaffiate", "inalate", "inalberate", "inalveate", "inalzate", "inamidate", "inanellate", "inarcate", "inargentate", "inaridite", "inasprite", "inastate", "inattivate", "inaugurate", "incacchiate", "incalcinate", "incalorite", "incalzate", "incamerate", "incamiciate", "incamminate", "incanaglite", "incanalate", "incannate", "incannucciate", "incaponite", "incappottate", "incappucciate", "incaprettate", "incapricciate", "incapsulate", "incarcerate", "incardinate", "incaricate", "incarnate", "incarrozzate", "incartate", "incartocciate", "incartonate", "incasellate", "incasinate", "incassate", "incastellate", "incastonate", "incastrate", "incatenate", "incatramate", "incattivite", "incavate", "incavigliate", "incavolate", "incazzate", "incellofanate", "incendiate", "incenerite", "incensate", "incentivate", "incentrate", "inceppate", "incerate", "incernierate", "incerottate", "incese", "incettate", "inchiappettate", "inchiavardate", "inchieste", "inchinate", "inchiodate", "inchiostrate", "incipriate", "incise", "incistate", "incitate", "inciuccate", "incivilite", "inclinate", "incluse", "incoccate", "incocciate", "incoiate", "incollate", "incolonnate", "incolpate", "incominciate", "incomodate", "incontrate", "incoraggiate", "incordate", "incornate", "incorniciate", "incoronate", "incorporate", "incotte", "incravattate", "incrementate", "increspate", "incretinite", "incriminate", "incrinate", "incrociate", "incrostate", "incrudelite", "incrudite", "incruscate", "incubate", "inculate", "inculcate", "incuneate", "incuoiate", "incuorate", "incupite", "incuriosite", "incurvate", "incusse", "indagate", "indebitate", "indebolite", "indemaniate", "indennizzate", "indette", "indicate", "indicizzate", "indignate", "indirette", "indirizzate", "indispettite", "indisposte", "individualizzate", "individuate", "indolenzite", "indorate", "indossate", "indotte", "indottome", "indottrinate", "indovinate", "indugiate", "indulte", "indurate", "indurite", "industrializzate", "industriate", "inebetite", "inebriate", "inerite", "inerpicate", "infagottate", "infamate", "infangate", "infarcite", "infarinate", "infastidite", "infatuate", "infeltrite", "inferite", "inferocite", "inferte", "infervorate", "infestate", "infettate", "infeudate", "infiacchite", "infialate", "infialettate", "infiammate", "infiascate", "infibulate", "inficiate", "infilate", "infiltrate", "infilzate", "infingardite", "infinocchiate", "infinte", "infioccate", "infiocchettate", "infiochite", "infiorate", "infirmate", "infischiate", "infisse", "infittite", "inflazionate", "inflesse", "inflitte", "influenzate", "infocate", "infoderate", "infognate", "infoibate", "infoltite", "inforcate", "informatizzate", "informate", "informicolate", "informicolite", "infornaciate", "infornate", "infortunate", "infoscate", "infossate", "infradiciate", "inframesse", "inframezzate", "inframmesse", "inframmezzate", "infrancesate", "infrapposte", "infrascate", "infrattate", "infreddate", "infronzolate", "infuocate", "infurbite", "infuriate", "ingabbiate", "ingaggiate", "ingagliardite", "ingannate", "ingarbugliate", "ingavonate", "ingegnate", "ingegnerizzate", "ingelosite", "ingemmate", "ingenerate", "ingentilite", "ingerite", "ingessate", "inghiaiate", "inghiottite", "inghirlandate", "ingiallite", "ingigantite", "inginocchiate", "ingioiellate", "ingiunte", "ingiuriate", "inglesizzate", "inglobate", "ingoffite", "ingoiate", "ingolfate", "ingollate", "ingolosite", "ingombrate", "ingommate", "ingorgate", "ingozzate", "ingranate", "ingrandite", "ingrassate", "ingraticciate", "ingraticolate", "ingravidate", "ingraziate", "ingraziosite", "ingrigite", "ingrommate", "ingrossate", "ingrullite", "inguaiate", "inguainate", "ingualdrappate", "inguantate", "ingurgitate", "inibite", "iniettate", "inimicate", "inizializzate", "iniziate", "inmillate", "innacquate", "innaffiate", "innalzate", "innamorate", "innastate", "innervate", "innervosite", "innescate", "innestate", "innevate", "innocentate", "innocuizzate", "innovate", "inoculate", "inoltrate", "inondate", "inorgoglite", "inorpellate", "inorridite", "inquadrate", "inquietate", "inquisite", "insabbiate", "insacchettate", "insalate", "insaldate", "insalivate", "insanguinate", "insaponate", "insaporite", "inscatolate", "inscenate", "inscritte", "insecchite", "insediate", "insegnate", "inseguite", "insellate", "inselvatichite", "inserite", "insidiate", "insignite", "insilate", "insinuate", "insolentite", "insonnolite", "insonorizzate", "insordite", "insospettite", "insozzate", "inspessite", "inspirate", "installate", "instaurate", "insterilite", "instillate", "instituite", "instradate", "insudiciate", "insufflate", "insultate", "insuperbite", "intabaccate", "intabarrate", "intaccate", "intagliate", "intarsiate", "intasate", "intascate", "intavolate", "integrate", "intelaiate", "intelate", "intellettualizzate", "intenebrate", "intenerite", "intensificate", "intentate", "intepidite", "intercalate", "intercambiate", "intercettate", "intercise", "intercluse", "intercollegate", "interconnesse", "interconvertite", "interdette", "interessate", "interfacciate", "interfogliate", "interfoliate", "interiorizzate", "interlacciate", "interlineate", "intermesse", "intermezzate", "internalizzate", "internate", "internazionalizzate", "interpellate", "interpenetrate", "interpolate", "interposte", "interpretate", "interpunte", "interrate", "interrogate", "interrotte", "intersecate", "intervallate", "intervistate", "intese", "intessute", "intestardite", "intestate", "intiepidite", "intimate", "intimidite", "intimorite", "intinte", "intirizzite", "intitolate", "intonacate", "intonate", "intontite", "intorbidate", "intorbidite", "intorpidite", "intortate", "intossicate", "intralciate", "intramesse", "intramezzate", "intrappolate", "intraprese", "intrattenute", "intravedute", "intraviste", "intravvedute", "intravviste", "intrecciate", "intricate", "intrigate", "intrinsecate", "intrippate", "intrise", "introdotte", "introflesse", "introiettate", "introitate", "intromesse", "intronate", "intronizzate", "intrudute", "intrufolate", "intrugliate", "intruppate", "intruse", "intubate", "intubettate", "intuite", "inumate", "inumidite", "inurbate", "inutilizzate", "invaghite", "invaginate", "invalidate", "invasate", "invase", "invelenite", "inventariate", "inventate", "invenute", "inverdite", "invergate", "inverniciate", "investigate", "investite", "invetriate", "inviate", "invidiate", "invigorite", "inviluppate", "invischiate", "invitate", "invocate", "invogliate", "involate", "involgarite", "involtate", "involte", "inzaccherate", "inzeppate", "inzigate", "inzolfate", "inzuccate", "inzuccherate", "inzuppate", "iodurate", "ionizzate", "ipertrofizzate", "ipnotizzate", "ipostatizzate", "ipotecate", "ipotizzate", "iridate", "irradiate", "irraggiate", "irreggimentate", "irretite", "irrigate", "irrigidite", "irrise", "irritate", "irrobustite", "irrogate", "irrorate", "irrugginite", "irruvidite", "ischeletrite", "iscritte", "islamizzate", "isolate", "isomerizzate", "ispanizzate", "ispessite", "ispezionate", "ispirate", "issate", "istallate", "istanziate", "istaurate", "isterilite", "istigate", "istillate", "istituite", "istituzionalizzate", "istoriate", "istradate", "istruite", "istupidite", "italianeggiate", "italianizzate", "iterate", "iudicate", "killerate", "labbreggiate", "labializzate", "laccate", "lacerate", "laconizzate", "lacrimate", "ladroneggiate", "lagnate", "lagrimate", "laicizzate", "lambiccate", "lambite", "lamentate", "laminate", "lanciate", "lapidate", "lappate", "lardate", "lardellate", "largite", "larvate", "lascate", "lasciate", "lastricate", "latinizzate", "laudate", "laureate", "lavate", "lavorate", "leccate", "legalizzate", "legate", "leggicchiate", "leggiucchiate", "legittimate", "legittimizzate", "legnate", "lemmatizzate", "lenite", "lesinate", "lesionate", "lese", "lessate", "lette", "levate", "levigate", "liberalizzate", "liberate", "licenziate", "lievitate", "liftate", "lignificate", "limate", "limitate", "linciate", "linearizzate", "lineate", "linkate", "liofilizzate", "liquefatte", "liquidate", "lisate", "lisciate", "lisciviate", "listate", "litografate", "livellate", "lizzate", "lobotomizzate", "localizzate", "locate", "lodate", "logorate", "lordate", "lottate", "lottizzate", "lubrificate", "lucchettate", "lucidate", "lucrate", "lumeggiate", "luppolizzate", "lusingate", "lussate", "lustrate", "macadamizzate", "macchiate", "macchinate", "macellate", "macerate", "maciullate", "maggesate", "maggiorate", "magnate", "magnetizzate", "magnificate", "maiolicate", "maledette", "malfatte", "malignate", "malmenate", "malmesse", "maltate", "maltrattate", "malvedute", "malversate", "malviste", "malvolute", "mandate", "mandrinate", "manducate", "maneggiate", "manganate", "manganellate", "mangiate", "mangiucchiate", "manifatturate", "manifestate", "manimesse", "manipolate", "manlevate", "manomesse", "manoscritte", "manovrate", "mansuefatte", "mantecate", "mantenutase", "mantenute", "manualizzate", "manutenute", "mappate", "marcate", "marchiate", "marcite", "marezzate", "marginalizzate", "marginate", "margottate", "marimesse", "marinate", "maritate", "marmorizzate", "marnate", "marocchinate", "martellate", "martellinate", "martirizzate", "martoriate", "mascherate", "maschiate", "maschiettate", "mascolinizzate", "massacrate", "massaggiate", "massellate", "massicciate", "massificate", "massimate", "massimizzate", "mastectomizzate", "masterizzate", "masticate", "masturbate", "matematizzate", "materializzate", "matricolate", "mattonate", "maturate", "mazziate", "mazzolate", "meccanizzate", "medagliate", "mediate", "medicalizzate", "medicate", "meditate", "membrate", "memorizzate", "menate", "mendicate", "menomate", "mentovate", "menzionate", "meravigliate", "mercanteggiate", "mercerizzate", "mercificate", "meriate", "meridionalizzate", "meritate", "merlate", "merlettate", "merse", "mesciate", "mesciute", "mescolate", "mescute", "mesmerizzate", "messaggiate", "messe", "messoce", "mestate", "mesticate", "mestruate", "metabolizzate", "metaforeggiate", "metaforizzate", "metallizzate", "metamorfizzate", "metamorfosate", "metanizzate", "metilate", "metodizzate", "microfilmate", "microfonate", "microminiaturizzate", "micronizzate", "mietute", "migliorate", "militarizzate", "millantate", "millimetrate", "mimate", "mimeografate", "mimetizzate", "minacciate", "minate", "minchionate", "mineralizzate", "miniate", "miniaturizzate", "minimizzate", "minuite", "minuzzate", "miracolate", "miscelate", "mischiate", "misconosciute", "missate", "mistificate", "misturate", "misurate", "miticizzate", "mitigate", "mitizzate", "mitragliate", "mitrate", "mixate", "mobiliate", "mobilitate", "mobilizzate", "modanate", "modellate", "modellizzate", "moderate", "modernizzate", "modificate", "modulate", "molate", "molestate", "mollate", "molleggiate", "moltiplicate", "monacate", "mondate", "mondializzate", "monetarizzate", "monetate", "monetizzate", "monitorate", "monitorizzate", "monocromatizzate", "monopolizzate", "monottongate", "montate", "monumentalizzate", "mordenzate", "mordicchiate", "mormorate", "morphate", "morsicate", "morsicchiate", "morse", "mortasate", "mortificate", "mosse", "mostrate", "motivate", "motorizzate", "motteggiate", "movimentate", "mozzate", "mugolate", "mulcite", "multate", "multiplexate", "mummificate", "municipalizzate", "munite", "munte", "murate", "musate", "musicate", "mussate", "mutate", "mutilate", "mutizzate", "mutuate", "nappate", "narcotizzate", "narrativizzate", "narrate", "nasalizzate", "nascose", "nascoste", "nastrate", "naturaleggiate", "naturalizzate", "nauseate", "naverate", "navicate", "navigate", "nazificate", "nazionalizzate", "nebulizzate", "necessitate", "necrosate", "necrotizzate", "negativizzate", "negate", "neglette", "negoziate", "negreggiate", "neologizzate", "nerbate", "nericate", "nettate", "neutralizzate", "nevate", "nevicate", "nevischiate", "nevrotizzate", "nichelate", "niellate", "ninfeggiate", "ninnate", "ninnolate", "nitratate", "nitrificate", "nobilitate", "noiate", "noleggiate", "nomate", "nominalizzate", "nominate", "normalizzate", "normate", "notate", "notificate", "notiziate", "notricate", "noverate", "nuclearizzate", "nudricate", "nullificate", "numerate", "numerizzate", "nuotate", "nutrite", "obbiettate", "obbliate", "obbligate", "oberate", "obiettate", "obiettivate", "obiettivizzate", "obiurgate", "obliate", "obliterate", "obnubilate", "occasionate", "occhieggiate", "occidentalizzate", "occise", "occluse", "occultate", "occupate", "ocheggiate", "odiate", "odorate", "odorizzate", "offerite", "offerte", "offese", "officiate", "offiziate", "offuscate", "ofiziate", "oggettivate", "oggettivizzate", "oggettualizzate", "oliate", "olite", "olografate", "oltraggiate", "oltrapassate", "oltrepassate", "omaggiate", "ombrate", "ombreggiate", "omesse", "omogeneizzate", "omogenizzate", "omologate", "ondate", "ondulate", "onestate", "onnubilate", "onorate", "opacate", "opacizzate", "operate", "opinate", "oppiate", "oppignorate", "oppilate", "opposte", "oppresse", "oppugnate", "oprate", "opsonizzate", "optate", "opzionate", "orbitate", "orchestrate", "ordinate", "ordite", "orecchiate", "organate", "organicate", "organizzate", "orgasmate", "orientalizzate", "orientate", "originate", "origliate", "orizzontate", "orlate", "orlettate", "ormate", "ormeggiate", "ornate", "orpellate", "orrate", "orripilate", "ortogonalizzate", "osannate", "osate", "osculate", "oscurate", "ospedalizzate", "ospitate", "ossedute", "ossequiate", "osservate", "ossessionate", "ossidate", "ossificate", "ossitonizzate", "ostacolate", "osteggiate", "ostentate", "ostinate", "ostracizzate", "ostruite", "ottemperate", "ottenebrate", "ottenute", "ottimalizzate", "ottimate", "ottimizzate", "ottonate", "ottriate", "ottuplicate", "otturate", "ottuse", "ottusse", "ovalizzate", "ovariectomizzate", "ovattate", "overcloccate", "ovrate", "ovviate", "ozieggiate", "ozonizzate", "pacate", "pacciamate", "pacificate", "padroneggiate", "paganizzate", "pagate", "paginate", "palafittate", "palatalizzate", "palate", "palesate", "palettate", "palettizzate", "palificate", "palleggiate", "pallettizzate", "palpate", "palpeggiate", "panate", "panneggiate", "panoramicate", "pappate", "paracadutate", "parafate", "paraffinate", "parafrasate", "paragonate", "paragrafate", "paralizzate", "parallelizzate", "parametrate", "parametrizzate", "parassitate", "parate", "parcate", "parcellizzate", "parcheggiate", "pareggiate", "parificate", "parkerizzate", "parlate", "parlucchiate", "parodiate", "partecipate", "particolareggiate", "particolarizzate", "partizionate", "partorite", "parzializzate", "pasciute", "pascolate", "passate", "passeggiate", "passionate", "passivate", "pasticciate", "pastorizzate", "pasturate", "patinate", "patite", "patrocinate", "patteggiate", "pattugliate", "pattuite", "paventate", "pavesate", "pavimentate", "pavoneggiate", "pazziate", "pedinate", "pedonalizzate", "peggiorate", "pelate", "pellettizzate", "penalizzate", "penetrate", "pennellate", "pensate", "pensionate", "pentite", "pepate", "peptonizzate", "peragrate", "percentualizzate", "percepite", "percolate", "percorse", "percosse", "perdonate", "perdotte", "perdute", "perequate", "perfatte", "perfezionate", "perforate", "performate", "perite", "periziate", "perlustrate", "permeate", "permesse", "perorate", "perpetrate", "perpetuate", "perplimute", "perquisite", "perscrutate", "perseguitate", "perseguite", "perse", "personalizzate", "personificate", "persuase", "perturbate", "pervase", "pervertite", "pesate", "pescate", "pestate", "petrarcheggiate", "pettegolate", "pettinate", "piagate", "piaggiate", "piallate", "pianeggiate", "pianificate", "piantate", "piantatale", "piantate", "piante", "piantonate", "piantumate", "piastrellate", "piatite", "piazzate", "picchettate", "picchiate", "picchierellate", "picchiettate", "picconate", "piegate", "pieghettate", "pietrificate", "pigiate", "pigliate", "pigmentate", "pignorate", "pigolate", "pilotate", "pimentate", "pinte", "pinzate", "piombate", "piovigginate", "piovute", "pipate", "pippate", "piratate", "pirogenate", "pisciate", "pitoccate", "pittate", "pitturate", "pizzicate", "pizzicottate", "placate", "placcate", "plagiate", "plasmate", "plasticate", "plastificate", "platinate", "plissettate", "pluralizzate", "poetate", "poeticizzate", "poggiate", "polarizzate", "poligrafate", "polimerizzate", "politicizzate", "polverizzate", "pomiciate", "pompate", "ponderate", "ponzate", "popolarizzate", "popolate", "poppate", "porcellanate", "porfirizzate", "portate", "portese", "porte", "porzionate", "posate", "posdatate", "positivizzate", "posizionate", "posposte", "possedute", "postate", "postdatate", "posteggiate", "posticipate", "postillate", "poste", "postsincronizzate", "postulate", "potabilizzate", "potate", "potenziate", "potute", "pralinate", "praticate", "preaccennate", "preannunciate", "preannunziate", "preavvertite", "preavvisate", "precaricate", "precedute", "precettate", "precinte", "precisate", "precluse", "precompilate", "precompresse", "preconfezionate", "preconizzate", "preconosciute", "precorse", "precostituite", "predate", "predefinite", "predestinate", "predeterminate", "predette", "predicate", "predigerite", "predilette", "predisposte", "preelette", "preesistute", "prefabbricate", "prefate", "prefatte", "prefazionate", "preferite", "prefigurate", "prefinanziate", "prefissate", "prefisse", "preformate", "pregate", "pregiate", "pregiudicate", "pregustate", "preimpregnate", "prelevate", "premeditate", "premescolate", "premesse", "premiate", "premonite", "premunite", "premurate", "premute", "prenotate", "preoccupate", "preordinate", "preparate", "prepensionate", "prepigmentate", "preposte", "preprogrammate", "preraffreddate", "prerefrigerate", "preregistrate", "preregolate", "preriscaldate", "prese", "presagite", "presapute", "presasele", "prescelte", "prescritte", "presedute", "presegnalate", "preselezionate", "presentate", "presentite", "preservate", "presidiate", "presiedute", "prese", "pressate", "presse", "pressurizzate", "prestabilite", "prestampate", "prestate", "prestigiate", "presunte", "presupposte", "pretermesse", "pretese", "pretrattate", "prevaricate", "prevedute", "prevendute", "preventivate", "prevenute", "previste", "prezzate", "prezzolate", "principiate", "privatizzate", "private", "privilegiate", "problematizzate", "procacciate", "processate", "proclamate", "procrastinate", "procreate", "procurate", "prodigate", "prodotte", "profanate", "proferite", "professate", "professionalizzate", "profetate", "profetizzate", "profferite", "profilate", "profondate", "profumate", "profuse", "progettate", "prognosticate", "programmate", "proibite", "proiettate", "proletarizzate", "prolungate", "promanate", "promesse", "promosse", "promozionate", "promulgate", "pronosticate", "pronunciate", "pronunziate", "propagandate", "propagate", "propagginate", "propalate", "propinate", "propiziate", "proporzionate", "proposte", "propugnate", "propulse", "prorogate", "prosciolte", "prosciugate", "proscritte", "proseguite", "prospettate", "prosternate", "prostese", "prostituite", "prostrate", "prosunte", "protese", "protestate", "protette", "protocollate", "protonate", "protratte", "protruse", "provate", "provedute", "provincializzate", "proviste", "provocate", "provvedute", "provviste", "psicanalizzate", "psichiatrizzate", "psicoanalizzate", "psicologizzate", "pubblicate", "pubblicizzate", "puddellate", "pugnalate", "pulite", "pungolate", "punite", "puntate", "punteggiate", "puntellate", "punte", "puntualizzate", "punzecchiate", "punzonate", "purgate", "purificate", "putite", "putrefatte", "putrite", "quadrate", "quadrettate", "quadriennalizzate", "quadruplicate", "qualificate", "quantificate", "quantizzate", "querelate", "questuate", "quetate", "quietanzate", "quietate", "quintessenziate", "quintuplicate", "quotate", "quotizzate", "rabberciate", "rabboccate", "rabbonite", "rabbuffate", "rabuffate", "raccapezzate", "raccapricciate", "raccattate", "raccerchiate", "raccese", "racchetate", "racchiuse", "raccolte", "raccolte", "raccomandate", "raccomodate", "raccontate", "raccorciate", "raccorcite", "raccordate", "raccostate", "raccozzate", "racemizzate", "racimolate", "radazzate", "raddensate", "raddobbate", "raddolcite", "raddoppiate", "raddotte", "raddrizzate", "radiate", "radicalizzate", "radioassistite", "radioattivate", "radiocomandate", "radiodiffuse", "radiografate", "radioguidate", "radiolocalizzate", "radiomarcate", "radiotelegrafate", "radiotrasmesse", "radunate", "raffazzonate", "raffermate", "raffigurate", "raffilate", "raffinate", "rafforzate", "raffreddate", "raffrenate", "raffrescate", "raffrontate", "raggelate", "raggentilite", "ragghiate", "raggirate", "raggiunte", "raggiustate", "raggomitolate", "raggranchiate", "raggranchite", "raggranellate", "raggrinzate", "raggrinzite", "raggrumate", "raggruppate", "raggruzzolate", "ragguagliate", "ralingate", "rallegrate", "rallentate", "ramate", "ramazzate", "rammagliate", "rammaricate", "rammemorate", "rammendate", "rammentate", "rammodernate", "rammollite", "rammorbidite", "rampognate", "randellate", "randomizzate", "rannicchiate", "rannuvolate", "ranzate", "rapate", "rapinate", "rapite", "rappacificate", "rappate", "rappattumate", "rappezzate", "rapportate", "rappresantate", "rappresentate", "rapprese", "rarefatte", "rasate", "raschiate", "raschiettate", "rasentate", "rase", "raspate", "rassegnate", "rasserenate", "rassettate", "rassicurate", "rassodate", "rassomigliate", "rassottigliate", "rassunte", "rastrellate", "rastremate", "rateate", "rateizzate", "ratificate", "ratinate", "rattizzate", "rattoppate", "rattorte", "rattrappite", "rattristate", "rattristite", "raunate", "ravvalorate", "ravvedute", "ravviate", "ravvicinate", "ravviluppate", "ravvisate", "ravviste", "ravvivate", "ravvolte", "ravvoltolate", "razionalizzate", "razionate", "razziate", "razzolate", "realizzate", "reassunte", "recapitate", "recate", "recedute", "recensite", "recepite", "recidivate", "recintate", "recinte", "reciprocate", "recise", "recitate", "reclamate", "reclamizzate", "reclinate", "recluse", "reclutate", "recuperate", "redarguite", "redatte", "redazzate", "reddute", "redente", "redistribuite", "redotte", "referenziate", "refertate", "refilate", "reflesse", "reflettute", "refrante", "refrigerate", "regalate", "regimate", "regimentate", "regionalizzate", "registrate", "regolamentate", "regolarizzate", "regolate", "reidratate", "reificate", "reimbarcate", "reimmerse", "reimmesse", "reimparate", "reimpastate", "reimpiantate", "reimpiegate", "reimportate", "reimpostate", "reincarcerate", "reincaricate", "reincarnate", "reincise", "reincontrate", "reindirizzate", "reindustrializzate", "reinfettate", "reingaggiate", "reinizializzate", "reinnestate", "reinoltrate", "reinscritte", "reinsediate", "reinserite", "reinstallate", "reinstaurate", "reintegrate", "reinterpretate", "reintitolate", "reintrodotte", "reinventate", "reinvestite", "reiterate", "relativizzate", "relazionate", "relegate", "remixate", "remunerate", "renderizzate", "reperite", "repertate", "replicate", "represse", "repulse", "reputate", "requisite", "rescisse", "resecate", "resettate", "residuate", "resinificate", "rese", "resolate", "resolte", "respinte", "respirate", "responsabilizzate", "resposte", "restaurate", "restituite", "resunte", "resuscitate", "reticolate", "retinate", "retribuite", "retrocedute", "retrocesse", "retrodatate", "rettificate", "rette", "reumatizzate", "revisionate", "revocate", "riabbassate", "riabbellite", "riabbonate", "riabbottonate", "riabbracciate", "riabilitate", "riabitate", "riabituate", "riaccadute", "riaccasate", "riaccese", "riaccettate", "riacchiappate", "riacciuffate", "riaccolte", "riaccomodate", "riaccompagnate", "riaccordate", "riaccostate", "riaccreditate", "riacquisite", "riacquistate", "riacutizzate", "riadattate", "riaddestrate", "riaddormentate", "riadoperate", "riaffacciate", "riaffermate", "riafferrate", "riaffiorate", "riaffittate", "riaffrontate", "riagganciate", "riaggiornate", "riaggiustate", "riaggravate", "riaggregate", "riagguantate", "rialimentate", "riallacciate", "riallargate", "riallineate", "riallocate", "riallungate", "rialzate", "riamate", "riambientate", "riammalate", "riammesse", "riammodernate", "riammogliate", "rianimate", "riannesse", "riannodate", "riannunciate", "riaperte", "riappacificate", "riappaltate", "riapparecchiate", "riapparite", "riappese", "riappiccicate", "riapplicate", "riapprese", "riapprodate", "riappropriate", "riapprovate", "riarmate", "riarrangiate", "riarredate", "riascoltate", "riasfaltate", "riassalite", "riassaporate", "riassegnate", "riassemblate", "riassestate", "riassettate", "riassicurate", "riassociate", "riassopite", "riassorbite", "riassunte", "riattaccate", "riattate", "riattese", "riattinte", "riattivate", "riattizzate", "riattraversate", "riaumentate", "riavute", "riavventate", "riavvertite", "riavviate", "riavvicinate", "riavvinte", "riavvisate", "riavvistate", "riavvolte", "riazzuffate", "ribaciate", "ribadite", "ribaltate", "ribassate", "ribattezzate", "ribattute", "ribellate", "ribenedette", "ribevute", "ributtate", "ricacciate", "ricalate", "ricalcate", "ricalcificate", "ricalcitrate", "ricalcolate", "ricalibrate", "ricamate", "ricambiate", "ricanalizzate", "ricandidate", "ricantate", "ricapitalizzate", "ricapitolate", "ricaricate", "ricategorizzate", "ricattate", "ricavate", "ricelebrate", "ricercate", "ricetrasmesse", "ricettate", "ricevute", "richiamate", "richieste", "richiuse", "riciclate", "ricinte", "ricircolate", "riclassificate", "ricodificate", "ricollegate", "ricollocate", "ricolmate", "ricolonizzate", "ricolorate", "ricolorite", "ricoltivate", "ricombinate", "ricominciate", "ricommesse", "ricomparite", "ricompattate", "ricompensate", "ricomperate", "ricompilate", "ricompiute", "ricomposte", "ricomprate", "ricompresse", "ricomunicate", "riconcedute", "riconcesse", "riconciliate", "ricondizionate", "ricondotte", "riconfermate", "riconfezionate", "riconfigurate", "riconfortate", "riconfuse", "ricongelate", "ricongiunte", "riconnesse", "riconosciute", "riconquistate", "riconsacrate", "riconsegnate", "riconsiderate", "riconsigliate", "riconsolate", "ricontate", "ricontattate", "ricontrattate", "ricontratte", "ricontrollate", "riconvalidate", "riconvenute", "riconvertite", "riconvinte", "riconvocate", "riconvogliate", "ricoperte", "ricopiate", "ricordate", "ricoricate", "ricorrette", "ricosparse", "ricostituite", "ricostrette", "ricostruite", "ricotte", "ricoverate", "ricreate", "ricristallizzate", "ricrocifisse", "ricucite", "ricuperate", "ricusate", "ridate", "ridecorate", "ridefinite", "ridenominate", "ridestate", "rideterminate", "ridette", "ridicolizzate", "ridigitate", "ridimensionate", "ridipinte", "ridiscese", "ridisciolte", "ridisciplinate", "ridiscusse", "ridisegnate", "ridisfatte", "ridisposte", "ridistese", "ridistinte", "ridistribuite", "ridivise", "ridomandate", "ridonate", "ridondate", "ridorate", "ridotate", "ridotte", "ridovute", "riecheggiate", "riedificate", "rieducate", "rielaborate", "rielette", "riemesse", "riempite", "riempiute", "rientrate", "riepilogate", "riequilibrate", "riequipaggiate", "riesaminate", "rieseguite", "riesercitate", "riesplose", "riesportate", "riesposte", "riespresse", "riespulse", "riestese", "riesumate", "rietichettate", "rievaporate", "rievocate", "rifabbricate", "rifasciate", "rifatte", "rifendute", "riferite", "rifermate", "rifermentate", "rifesse", "rificcate", "rifilate", "rifiltrate", "rifinanziate", "rifinite", "rifirmate", "rifischiate", "rifisse", "rifiutate", "riflesse", "riflettute", "rifocillate", "rifoderate", "rifondate", "riforestate", "riforgiate", "riformate", "riformattate", "riformulate", "rifornite", "rifrante", "rifritte", "rifrugate", "rifuggite", "rifugiate", "rifuse", "rigassificate", "rigate", "rigelate", "rigenerate", "rigettate", "righettate", "rigiocate", "rigirate", "rigiudicate", "rigiunte", "rigodute", "rigonfiate", "rigovernate", "riguadagnate", "riguardate", "rigurgitate", "rilanciate", "rilasciate", "rilassate", "rilavate", "rilavorate", "rilegate", "rilette", "rilevate", "rilocalizzate", "rimagliate", "rimandate", "rimaneggiate", "rimangiate", "rimappate", "rimarcate", "rimarchiate", "rimarginate", "rimaritate", "rimasticate", "rimate", "rimbacuccate", "rimbaldanzite", "rimbarcate", "rimbeccate", "rimbecillite", "rimbellite", "rimbiancate", "rimbiondite", "rimboccate", "rimbombate", "rimborsate", "rimboscate", "rimboschite", "rimbrottate", "rimediate", "rimembrate", "rimemorate", "rimenate", "rimeritate", "rimescolate", "rimesse", "rimestate", "rimilitarizzate", "rimirate", "rimischiate", "rimisurate", "rimodellate", "rimodernate", "rimodulate", "rimondate", "rimontate", "rimorchiate", "rimorse", "rimosse", "rimostrate", "rimotivate", "rimpacchettate", "rimpadronite", "rimpaginate", "rimpagliate", "rimpannucciate", "rimpastate", "rimpatriate", "rimpiallacciate", "rimpiante", "rimpiattate", "rimpiazzate", "rimpicciolite", "rimpiccolite", "rimpiegate", "rimpinguate", "rimpinzate", "rimpolpate", "rimpossessate", "rimpresse", "rimproverate", "rimuginate", "rimunerate", "rimunte", "rimusicate", "rimutate", "rinarrate", "rinascoste", "rincalcate", "rincalzate", "rincamminate", "rincantucciate", "rincarate", "rincarcerate", "rincarnate", "rincentrate", "rinchieste", "rinchiodate", "rinchiuse", "rincitrullite", "rincivilite", "rincoglionite", "rincollate", "rincominciate", "rincontrate", "rincoraggiate", "rincorate", "rincorporate", "rincorse", "rincretinite", "rincrudite", "rinculcate", "rincuorate", "rindossate", "rindurite", "rinegoziate", "rinfacciate", "rinfagottate", "rinfiammate", "rinfiancate", "rinfilate", "rinfittite", "rinfocolate", "rinfoderate", "rinforzate", "rinfrancate", "rinfrante", "rinfrescate", "rinfuse", "ringagliardite", "ringalluzzite", "ringiovanite", "ringiovenite", "ringoiate", "ringorgate", "ringraziate", "ringuainate", "rinnamorate", "rinnegate", "rinnestate", "rinnovate", "rinnovellate", "rinociute", "rinomate", "rinominate", "rinormalizzate", "rinquadrate", "rinsaccate", "rinsaldate", "rinsanguate", "rinselvatichite", "rinselvate", "rinserrate", "rintanate", "rintasate", "rintascate", "rintavolate", "rintenerite", "rinterrate", "rinterrogate", "rintese", "rintiepidite", "rintoccate", "rintonacate", "rintontite", "rintorpidite", "rintracciate", "rintrodotte", "rintronate", "rintuzzate", "rinunciate", "rinunziate", "rinutrite", "rinvangate", "rinvasate", "rinvenute", "rinverdite", "rinvestite", "rinviate", "rinvigorite", "rinvilite", "rinvitate", "rinvoltate", "rinvolte", "rinvoltolate", "rinzaffate", "rinzeppate", "riobbligate", "rioccupate", "riofferte", "rioffese", "rioperate", "riordinate", "riorganizzate", "riorientate", "riosservate", "riottenute", "riottimizzate", "riotturate", "ripagate", "riparametrizzate", "riparate", "ripartite", "ripassate", "ripercorse", "ripercosse", "riperdute", "riperse", "ripesate", "ripescate", "ripestate", "ripetute", "ripianate", "ripianificate", "ripiantate", "ripiante", "ripicchiate", "ripiegate", "ripigliate", "ripinte", "ripiovute", "ripitturate", "riplasmate", "ripolarizzate", "ripopolate", "riportate", "riporte", "riposate", "riposizionate", "ripossedute", "riposte", "ripotute", "ripresentate", "riprese", "riprestate", "ripretese", "riprincipiate", "ripristinate", "riprivatizzate", "riprodotte", "riprogettate", "riprogrammate", "ripromesse", "riproposte", "riprotette", "riprovate", "riprovvedute", "riprovviste", "ripubblicate", "ripudiate", "ripugnate", "ripulite", "ripuntate", "ripunte", "ripurgate", "riputate", "riquadrate", "riqualificate", "rirese", "rirotte", "risaldate", "risalite", "risaltate", "risalutate", "risanate", "risapute", "risarcite", "riscalate", "riscaldate", "riscattate", "riscelte", "riscese", "rischiarate", "rischiate", "risciacquate", "risciolte", "riscommesse", "riscontate", "riscontrate", "risconvolte", "riscoperte", "riscoppiate", "riscorse", "riscosse", "riscritte", "risecate", "risedute", "risegate", "risegnate", "riselciate", "riselezionate", "riseminate", "risentite", "riseppellite", "riserbate", "riservate", "risicate", "risigillate", "risistemate", "rise", "risoffiate", "risoggiunte", "risolate", "risolidificate", "risollevate", "risolte", "risommate", "risommerse", "risonate", "risorpassate", "risospese", "risospinte", "risottomesse", "risparmiate", "risparse", "rispecchiate", "rispedite", "rispente", "risperse", "rispettate", "rispiegate", "rispinte", "rispolverate", "risposate", "risposte", "rissate", "ristabilite", "ristagnate", "ristampate", "ristaurate", "ristese", "ristilizzate", "ristorate", "ristrette", "ristrutte", "ristrutturate", "ristuccate", "ristudiate", "risucchiate", "risultate", "risuolate", "risuonate", "risuscitate", "risvegliate", "risvolte", "ritagliate", "ritarate", "ritardate", "ritemprate", "ritentate", "ritenute", "riterse", "ritese", "ritinte", "ritirate", "ritoccate", "ritolte", "ritorte", "ritracciate", "ritradotte", "ritrascorse", "ritrascritte", "ritrasferite", "ritrasformate", "ritrasmesse", "ritrasposte", "ritrattate", "ritratte", "ritrovate", "ritualizzate", "rituffate", "riudite", "riunificate", "riunite", "riusate", "riutilizzate", "rivaccinate", "rivaleggiate", "rivalorizzate", "rivalse", "rivalutate", "rivangate", "rivedute", "rivelate", "rivendicate", "rivendute", "riverberate", "riverite", "riverniciate", "riversate", "rivestite", "rivettate", "rivinte", "rivisitate", "rivissute", "riviste", "rivitalizzate", "rivivificate", "rivoltate", "rivolte", "rivoltolate", "rivolute", "rivoluzionate", "rizappate", "rizzate", "robotizzate", "rodate", "rogate", "rollate", "romanizzate", "romanticizzate", "romanzate", "roncolate", "rosicate", "rosicchiate", "rose", "rosolate", "rotacizzate", "rotate", "roteate", "rotolate", "rottamate", "rotte", "rovesciate", "rovinate", "rovistate", "rubacchiate", "rubate", "rullate", "ruminate", "ruotate", "russificate", "ruzzolate", "sabbiate", "sabotate", "saccarificate", "saccheggiate", "sacralizzate", "sacramentate", "sacrificate", "saettate", "saggiate", "sagginate", "sagomate", "salamoiate", "salariate", "salassate", "salate", "saldate", "salificate", "salinizzate", "salite", "salmeggiate", "salmistrate", "salpate", "saltate", "salutate", "salvaguardate", "salvate", "sanate", "sancite", "sanforizzate", "sanificate", "sanitizzate", "santificate", "sanzionate", "saponificate", "sapute", "sarchiate", "sarchiellate", "sartiate", "satellizzate", "satinate", "satireggiate", "satisfatte", "satollate", "saturate", "saziate", "sbaccellate", "sbaciucchiate", "sbafate", "sbaffate", "sbalestrate", "sballate", "sballottate", "sballottolate", "sbalordite", "sbalzate", "sbancate", "sbandate", "sbandierate", "sbandite", "sbaraccate", "sbaragliate", "sbarazzate", "sbarbate", "sbarcate", "sbardate", "sbarrate", "sbassate", "sbastite", "sbatacchiate", "sbattezzate", "sbattute", "sbeccate", "sbeffeggiate", "sbellicate", "sbendate", "sbertucciate", "sbiadite", "sbiancate", "sbianchite", "sbiellate", "sbiettate", "sbigottite", "sbilanciate", "sbirbate", "sbirciate", "sbizzarrite", "sbloccate", "sbobinate", "sboccate", "sbocconcellate", "sbollentate", "sbolognate", "sborniate", "sborsate", "sboscate", "sbottonate", "sbozzate", "sbozzimate", "sbozzolate", "sbracate", "sbracciate", "sbraciate", "sbraitate", "sbranate", "sbrancate", "sbrattate", "sbreccate", "sbriciolate", "sbrigate", "sbrigliate", "sbrinate", "sbrindellate", "sbrodolate", "sbrogliate", "sbronzate", "sbruffate", "sbucciate", "sbudellate", "sbuffate", "sbugiardate", "sbullettate", "sbullonate", "sburrate", "scacazzate", "scacchiate", "scacciate", "scaccolate", "scadenzate", "scafate", "scaffalate", "scagionate", "scagliate", "scaglionate", "scalate", "scalcate", "scalcinate", "scaldate", "scalettate", "scalfate", "scalfite", "scalmanate", "scaloppate", "scalpate", "scalpellate", "scalpellinate", "scaltrite", "scalzate", "scambiate", "scamiciate", "scamosciate", "scamozzate", "scampate", "scampatale", "scampate", "scamuffate", "scanalate", "scancellate", "scandagliate", "scandalizzate", "scandite", "scannate", "scannellate", "scannerate", "scannerizate", "scannerizzate", "scansate", "scansionate", "scapecchiate", "scapezzate", "scapicollate", "scapigliate", "scapitozzate", "scapocchiate", "scappate", "scappellate", "scappottate", "scapricciate", "scapsulate", "scarabocchiate", "scaracchiate", "scaraventate", "scarcerate", "scardassate", "scardate", "scardinate", "scaricate", "scarificate", "scarmigliate", "scarnate", "scarnificate", "scarnite", "scarrellate", "scarrocciate", "scarrozzate", "scarruffate", "scartabellate", "scartate", "scartavetrate", "scartinate", "scartocciate", "scassate", "scassinate", "scatenate", "scattate", "scavalcate", "scavallate", "scavate", "scavezzate", "scazzottate", "scekerate", "scelte", "scempiate", "sceneggiate", "scernute", "scervellate", "scese", "sceverate", "schedate", "schedulate", "scheggiate", "scheletrite", "schematizzate", "schermate", "schermite", "schermografate", "schernite", "schiacciate", "schiaffate", "schiaffeggiate", "schiantate", "schiarite", "schiavardate", "schiavizzate", "schiccherate", "schierate", "schifate", "schinciate", "schioccate", "schiodate", "schiumate", "schiuse", "schivate", "schizzate", "schizzettate", "sciabolate", "sciabordate", "sciacquate", "scialacquate", "sciamanizzate", "sciamannate", "sciancate", "sciancrate", "scimmieggiate", "scimmiottate", "scinte", "scioccate", "sciolinate", "sciolte", "sciorinate", "scippate", "sciroppate", "scisse", "sciupacchiate", "sciupate", "sclamate", "sclerosate", "sclerotizzate", "scoccate", "scocciate", "scodate", "scodellate", "scoiate", "scolarizzate", "scolate", "scollacciate", "scollate", "scollegate", "scolorate", "scolorite", "scolpate", "scolpite", "scombaciate", "scombinate", "scombussolate", "scommesse", "scomodate", "scompaginate", "scompagnate", "scompartite", "scompattate", "scompensate", "scompiacute", "scompigliate", "scomposte", "scomputate", "scomunicate", "sconcertate", "sconciate", "sconcluse", "sconfessate", "sconficcate", "sconﬁtte", "sconfortate", "sconfuse", "scongelate", "scongiurate", "sconnesse", "sconosciute", "sconquassate", "sconsacrate", "sconsigliate", "sconsolate", "scontate", "scontentate", "scontornate", "scontorte", "scontrate", "sconvolte", "scopate", "scoperchiate", "scoperte", "scopiazzate", "scoraggiate", "scoraggite", "scorate", "scorazzate", "scorciate", "scorcite", "scordate", "scoreggiate", "scorificate", "scornate", "scorniciate", "scoronate", "scorporate", "scorrazzate", "scorreggiate", "scorrette", "scorse", "scortate", "scortecciate", "scorticate", "scorte", "scorzate", "scoscese", "scosciate", "scosse", "scostate", "scostolate", "scotennate", "scoticate", "scotolate", "scotomizzate", "scottate", "scotte", "scovate", "scoverte", "scozzate", "scozzonate", "screditate", "scremate", "screpolate", "screziate", "scribacchiate", "scriminate", "scristianizzate", "scritte", "scritturate", "scroccate", "scrocchiate", "scrollate", "scrostate", "scrutate", "scrutinate", "scucite", "scudisciate", "scuffiate", "sculacciate", "sculettate", "scuoiate", "scuriosate", "scurite", "scusate", "sdaziate", "sdebitate", "sdegnate", "sdemanializzate", "sdentate", "sdilinquite", "sdoganate", "sdolute", "sdoppiate", "sdraiate", "sdrammatizzate", "sdrucite", "secate", "seccate", "secernute", "secolarizzate", "secondate", "secretate", "secrete", "sedate", "sedentarizzate", "sedotte", "segate", "seghettate", "segmentate", "segnalate", "segnate", "segnoreggiate", "segregate", "segretate", "seguitate", "seguite", "selciate", "selezionate", "sellate", "sembrate", "sementate", "semicinte", "seminate", "semplificate", "senilizzate", "sensibilizzate", "sensorizzate", "sentenziate", "sentite", "sentitasele", "sentite", "sentite", "separate", "sepolte", "seppellite", "sequenziate", "sequestrate", "serbate", "serrate", "servite", "servoassistite", "sessualizzate", "sestuplicate", "setacciate", "setificate", "settate", "settorializzate", "settuplicate", "seviziate", "sezionate", "sfaccettate", "sfagliate", "sfaldate", "sfalsate", "sfamate", "sfanalate", "sfangate", "sfarinate", "sfasate", "sfasciate", "sfatate", "sfatte", "sfavillate", "sfavorite", "sfegatate", "sfeltrate", "sfendute", "sferragliate", "sferrate", "sferzate", "sfesse", "sfiancate", "sfiatate", "sfiate", "sfibbiate", "sfibrate", "sfidate", "sfiduciate", "sfigurate", "sfilate", "sfilettate", "sfinite", "sfioccate", "sfiorate", "sfittate", "sfocate", "sfociate", "sfoderate", "sfogate", "sfoggiate", "sfogliate", "sfollate", "sfoltite", "sfondate", "sforacchiate", "sforate", "sforbiciate", "sformate", "sfornaciate", "sfornate", "sfornite", "sforzate", "sfottute", "sfracellate", "sfrangiate", "sfrascate", "sfratate", "sfrattate", "sfrecciate", "sfregate", "sfregiate", "sfrenate", "sfrisate", "sfrondate", "sfrucugliate", "sfruculiate", "sfruttate", "sfumate", "sfuocate", "sgamate", "sganasciate", "sganciate", "sgarbugliate", "sgattaiolate", "sgelate", "sghiacciate", "sgocciolate", "sgolate", "sgomberate", "sgombrate", "sgomentate", "sgominate", "sgomitate", "sgomitolate", "sgonfiate", "sgorbiate", "sgottate", "sgovernate", "sgozzate", "sgraffiate", "sgraffignate", "sgranate", "sgranchite", "sgranellate", "sgrassate", "sgravate", "sgretolate", "sgridate", "sgrommate", "sgrondate", "sgroppate", "sgrossate", "sgrovigliate", "sgrugnate", "sguainate", "sgualcite", "sguanciate", "sguarnite", "sguinzagliate", "sgusciate", "shakerate", "shoccate", "shuntate", "sigillate", "siglate", "significate", "signoreggiate", "silenziate", "silicizzate", "sillabate", "sillogizzate", "silurate", "simboleggiate", "simbolizzate", "simmetrizzate", "simpatizzate", "simulate", "sincerate", "sincopate", "sincretizzate", "sincronizzate", "sindacalizzate", "sindacate", "singolarizzate", "sinistrate", "sinizzate", "sinterizzate", "sintetizzate", "sintonizzate", "siringate", "sistematizzate", "sistemate", "situate", "slabbrate", "slacciate", "slamate", "slanciate", "slappolate", "slargate", "slavizzate", "slegate", "slentate", "slinguate", "slogate", "sloggate", "sloggiate", "slombate", "slungate", "smaccate", "smacchiate", "smagliate", "smagnetizzate", "smagrite", "smaliziate", "smallate", "smaltate", "smaltite", "smammate", "smanacciate", "smangiate", "smantellate", "smarcate", "smarginate", "smarrite", "smascellate", "smascherate", "smaterializzate", "smattonate", "smembrate", "smentite", "smerciate", "smerdate", "smerigliate", "smerlate", "smerlettate", "smessale", "smesse", "smezzate", "smidollate", "smielate", "smilitarizzate", "sminate", "sminuite", "sminuzzate", "smistate", "smitizzate", "smobiliate", "smobilitate", "smobilizzate", "smoccolate", "smollicate", "smonacate", "smontate", "smorbate", "smorzate", "smosse", "smozzicate", "smunte", "smurate", "smussate", "smutandate", "snaturate", "snazionalizzate", "snebbiate", "snellite", "snervate", "snidate", "sniffate", "snobbate", "snocciolate", "snodate", "snudate", "sobbarcate", "sobbollite", "sobillate", "socchiuse", "soccorse", "soddisfatte", "sodisfatte", "sodomizzate", "sofferite", "soffermate", "sofferte", "soffiate", "soffocate", "soffregate", "soffritte", "soffuse", "sofisticate", "soggettivate", "soggettivizzate", "sogghignate", "soggiogate", "soggiunte", "sogguardate", "sognate", "solarizzate", "solcate", "soleggiate", "solennizzate", "solfeggiate", "solfitate", "solfonate", "solforate", "solidificate", "solite", "sollazzate", "sollecitate", "solleticate", "sollevate", "solte", "solubilizzate", "solute", "soluzionate", "solvatate", "somatizzate", "someggiate", "somigliate", "sommate", "sommerse", "sommesse", "somministrate", "sommosse", "sonate", "sondate", "sonorizzate", "sopite", "soppalcate", "soppesate", "soppiantate", "sopportate", "sopposte", "soppresse", "sopraddotate", "sopraeccitate", "sopraedificate", "sopraelevate", "sopraffate", "sopraffatte", "sopraggiunte", "sopraintese", "soprammesse", "soprannominate", "sopraposte", "soprapprese", "soprascritte", "sopraspese", "soprassaturate", "soprassedute", "sopravanzate", "sopravvalutate", "sopravvedute", "sopravvinte", "sopravviste", "sopreccitate", "sopredificate", "soprelevate", "soprintese", "sorbettate", "sorbite", "sorgiunte", "sormontate", "sorpassate", "sorprese", "sorrase", "sorrette", "sorseggiate", "sorteggiate", "sortite", "sorvegliate", "sorvolate", "soscritte", "sospese", "sospettate", "sospinte", "sospirate", "sostantivate", "sostanziate", "sostentate", "sostenute", "sostituite", "sottaciute", "sotterrate", "sottese", "sottintese", "sottoalimentate", "sottocapitalizzate", "sottodivise", "sottoesposte", "sottofirmate", "sottolineate", "sottomesse", "sottomurate", "sottopagate", "sottopassate", "sottoposte", "sottorappresentate", "sottorise", "sottoscritte", "sottostimate", "sottosviluppate", "sottotitolate", "sottovalutate", "sottratte", "soverchiate", "sovesciate", "sovietizzate", "sovracapitalizzate", "sovraccaricate", "sovradimensionate", "sovraeccitate", "sovraesposte", "sovraffaticate", "sovraffollate", "sovraggiunte", "sovraimposte", "sovraintese", "sovralimentate", "sovramodulate", "sovrappopolate", "sovrapposte", "sovrariscaldate", "sovrasaturate", "sovrascritte", "sovrastampate", "sovrastate", "sovrastimate", "sovrautilizzate", "sovreccitate", "sovresposte", "sovrimposte", "sovrintese", "sovvenute", "sovvenzionate", "sovvertite", "spaccate", "spacchettate", "spacciate", "spaginate", "spaiate", "spalancate", "spalate", "spalcate", "spalleggiate", "spalmate", "spammate", "spampanate", "spampinate", "spanate", "spanciate", "spandute", "spannate", "spannocchiate", "spanse", "spantanate", "spante", "spaparacchiate", "spaparanzate", "spappolate", "sparate", "sparecchiate", "sparigliate", "sparite", "sparlate", "sparpagliate", "spartite", "spassate", "spassatosele", "spastoiate", "spaurate", "spaurite", "spaventate", "spazializzate", "spaziate", "spazieggiate", "spazientite", "spazzate", "spazzolate", "specchiate", "specializzate", "specificate", "specillate", "specolate", "spedite", "spegnate", "spelacchiate", "spelate", "spellate", "spennacchiate", "spennate", "spennellate", "spente", "spenzolate", "sperate", "sperimentate", "spernacchiate", "speronate", "sperperate", "spersonalizzate", "sperticate", "spesate", "spese", "spessite", "spettacolarizzate", "spettinate", "spezzate", "spezzettate", "spezziate", "spezzonate", "spiaccicate", "spianate", "spiantate", "spiate", "spiattellate", "spiazzate", "spiccate", "spicciate", "spiccicate", "spicciolate", "spicconate", "spidocchiate", "spiegate", "spiegazzate", "spietrate", "spifferate", "spigionate", "spignorate", "spigolate", "spigrite", "spillate", "spilluzzicate", "spiluccate", "spinte", "spintonate", "spiombate", "spiralizzate", "spirantizzate", "spirate", "spiritualizzate", "spiumate", "spizzicate", "spodestate", "spoetizzate", "spogliate", "spolettate", "spoliate", "spoliticizzate", "spollonate", "spolmonate", "spolpate", "spoltronite", "spolverate", "spolverizzate", "spompate", "spompinate", "sponsorizzate", "spopolate", "spoppate", "sporcate", "sportate", "sporte", "sposate", "spossedute", "spossessate", "spostate", "sposte", "sprangate", "sprecate", "spregiate", "spremute", "spretate", "sprezzate", "sprigionate", "sprimacciate", "spromesse", "spronate", "sprotette", "sprovincializzate", "sprovvedute", "sprovviste", "spruzzate", "spugnate", "spulate", "spulciate", "spuntate", "spuntellate", "spupazzate", "spurgate", "sputacchiate", "sputate", "sputtanate", "squadernate", "squadrate", "squagliate", "squagliatasele", "squagliate", "squalificate", "squamate", "squarciate", "squartate", "squassate", "squattrinate", "squilibrate", "squinternate", "sradicate", "srotolate", "srugginite", "stabbiate", "stabilite", "stabilizzate", "stabulate", "staccate", "stacciate", "staffate", "staffilate", "staggiate", "staggite", "stagionate", "stagliate", "stagnate", "stamburate", "stampate", "stampigliate", "stanate", "stancate", "standardizzate", "stangate", "stanziate", "stappate", "starate", "starnazzate", "stasate", "statalizzate", "statizzate", "statoce", "statosene", "statuite", "stazzate", "stazzonate", "steccacciate", "steccate", "stecchite", "stecconate", "stemperate", "stempiate", "stenografate", "stereotipate", "sterilite", "sterilizzate", "sterpate", "sterrate", "sterzate", "stese", "stigliate", "stigmatizzate", "stilate", "stilettate", "stilizzate", "stillate", "stimate", "stimolate", "stinte", "stipate", "stipendiate", "stipulate", "stiracchiate", "stirate", "stivate", "stizzite", "stoccate", "stolte", "stomacate", "stonate", "stondate", "stoppate", "stordite", "storicizzate", "stornate", "storpiate", "stortate", "storte", "stozzate", "strabenedette", "strabuzzate", "stracannate", "straccate", "stracciate", "stracotte", "strafogate", "stragodute", "stralciate", "stralodate", "stralunate", "stramaledette", "stramortite", "strangolate", "straniate", "stranite", "straorzate", "strapagate", "strapazzate", "straperdute", "straperse", "strappate", "strasapute", "strascicate", "strascinate", "strasformate", "stratificate", "strattonate", "stravaccate", "stravinte", "stravolte", "stravolute", "straziate", "stregate", "stremate", "stressate", "striate", "stridulate", "strigate", "strigliate", "strillate", "striminzite", "strimpellate", "strinate", "stringate", "strisciate", "stritolate", "strizzate", "strofinate", "strombate", "strombazzate", "stroncate", "stronzate", "stropicciate", "stroppate", "stroppiate", "strozzate", "struccate", "strumentalizzate", "strumentate", "strusciate", "strutte", "strutturalizzate", "strutturate", "stuccate", "studiacchiate", "studiate", "stuellate", "stufate", "stupefatte", "stupite", "stuprate", "sturate", "stutate", "stuzzicate", "suase", "subaffittate", "subappaltate", "subbiate", "subdelegate", "subissate", "subite", "sublicenziate", "sublimate", "sublocate", "subodorate", "subordinate", "subornate", "suburbanizzate", "sucate", "succhiate", "succhiellate", "succiate", "succinte", "succise", "suddistinte", "suddivise", "suffissate", "suffisse", "suffragate", "suffumicate", "suffuse", "suggellate", "suggerite", "suggestionate", "suicidate", "sunteggiate", "sunte", "suolate", "suonate", "superate", "superpagate", "superraffreddate", "supervalutate", "supervisionate", "supplicate", "supplite", "supportate", "supposte", "suppurate", "surclassate", "surfate", "surgelate", "surraffreddate", "surriscaldate", "surrogate", "survoltate", "suscitate", "susseguite", "sussidiate", "sussunte", "sussurrate", "suturate", "svaccate", "svagate", "svaligiate", "svalutate", "svapate", "svariate", "svasate", "svecchiate", "svegliate", "svelate", "svelenite", "sveltite", "svelte", "svenate", "svendute", "sventagliate", "sventate", "sventolate", "sventrate", "sverginate", "svergognate", "svergolate", "sverminate", "sverniciate", "svestite", "svettate", "svezzate", "sviate", "svignatosele", "svigorite", "svilite", "svillaneggiate", "sviluppate", "svinate", "svincolate", "sviolinate", "svirgolate", "svirilizzate", "svisate", "sviscerate", "svitate", "sviticchiate", "svolate", "svolazzate", "svolte", "svolute", "svuotate", "tabuizzate", "tabulate", "taccate", "taccheggiate", "tacciate", "tacitate", "taciute", "tagliate", "taglieggiate", "tagliuzzate", "talebanizzate", "tallonate", "tampinate", "tamponate", "tangute", "tannate", "tappate", "tappezzate", "tarate", "tardate", "targate", "tariffate", "tarlate", "tarmate", "taroccate", "tarpate", "tartagliate", "tartassate", "tartufate", "tassate", "tassellate", "tastate", "tasteggiate", "tatuate", "tecnicizzate", "tecnologizzate", "tedeschizzate", "tediate", "teflonate", "telecomandate", "telecontrollate", "telediffuse", "telefonate", "telegrafate", "teleguidate", "telematizzate", "telemetrate", "teleradiotrasmesse", "teletrasmesse", "teletrasportate", "tematizzate", "temperate", "tempestate", "tempificate", "templatizzate", "temporizzate", "temprate", "temute", "tentate", "tenute", "teologizzate", "teorizzate", "tepefatte", "terebrate", "terminate", "termostatate", "terrazzate", "terrificate", "terrorizzate", "terse", "terzarolate", "terziarizzate", "terziate", "tesate", "tesaurizzate", "tese", "tesserate", "testate", "testificate", "testimoniate", "timbrate", "tindalizzate", "tinteggiate", "tinte", "tipicizzate", "tipizzate", "tippate", "tiranneggiate", "tirate", "titillate", "titolate", "toccate", "toelettate", "tollerate", "tolte", "tonalizzate", "tonificate", "tonneggiate", "tonsurate", "torchiate", "tormentate", "tornatosene", "tornite", "torrefatte", "torte", "tortoreggiate", "torturate", "tosate", "toscaneggiate", "toscanizzate", "tostate", "totalizzate", "traboccate", "trabuccate", "tracannate", "tracciate", "tradite", "tradotte", "trafficate", "trafilate", "trafitte", "traforate", "trafugate", "traghettate", "traguardate", "trainate", "tralasciate", "tralignate", "tramandate", "tramate", "trambasciate", "tramesse", "tramestate", "tramezzate", "tramortite", "tramutate", "tranciate", "trangugiate", "tranquillate", "tranquillizzate", "transatte", "transcese", "transcodificate", "transcorse", "transcritte", "transennate", "transfluite", "transfuse", "transistorizzate", "translitterate", "transposte", "transricevute", "transustanziate", "transvedute", "transviste", "trapanate", "trapassate", "trapiantate", "traportate", "traposte", "trapposte", "trapuntate", "trapunte", "trarotte", "trasandate", "trasbordate", "trascelte", "trascese", "trascinate", "trascorse", "trascritte", "trascurate", "trasdotte", "trasferite", "trasfigurate", "trasformate", "trasfuse", "trasgredite", "traslate", "traslitterate", "traslocate", "trasmesse", "trasmutate", "trasparite", "traspirate", "trasportate", "trasposte", "trastullate", "trasudate", "trasvolate", "trasvolte", "trattate", "tratteggiate", "trattenute", "tratte", "traumatizzate", "travagliate", "travalicate", "travasate", "travedute", "traversate", "travestite", "traviate", "travisate", "traviste", "travolte", "trebbiate", "triangolate", "tribbiate", "tribolate", "tributate", "triennalizzate", "trimestralizzate", "trincate", "trincerate", "trinciate", "tripartite", "triplicate", "trisecate", "trisezionate", "tritate", "triturate", "trivellate", "trollate", "trombate", "troncate", "tropicalizzate", "trovate", "truccate", "trucidate", "truffate", "tuffate", "tumefatte", "tumulate", "turate", "turbate", "turlupinate", "tutelate", "ubbligate", "ubicate", "ubidite", "ubiquitinate", "ubriacate", "uccellate", "uccellinate", "uccise", "udite", "ufficializzate", "uggite", "ugnate", "uguagliate", "ulcerate", "ulite", "ulolate", "ultimate", "ultracentrifugate", "ululate", "umanate", "umanizzate", "umettate", "umidificate", "umidite", "umiliate", "uncinate", "unguentate", "unificate", "uniformate", "unite", "univerbate", "universaleggiate", "universalizzate", "untate", "unte", "uperizzate", "urbanizzate", "urgenzate", "urlate", "urtacchiate", "urtate", "urticchiate", "usate", "usciolate", "usolate", "ustionate", "usucapite", "usurate", "usurpate", "utilitate", "utilizzate", "vaccinate", "vagabondeggiate", "vagellate", "vagheggiate", "vagillate", "vagliate", "valcate", "valicate", "validate", "valorizzate", "valse", "valutate", "vanagloriate", "vanate", "vandalizzate", "vangate", "vangelizzate", "vanificate", "vanite", "vantaggiate", "vantate", "vaporate", "vaporizzate", "varate", "varcate", "variate", "vasectomizzate", "vaticinate", "vedovate", "vedute", "vegetate", "veggiate", "vegliate", "veicolate", "velarizzate", "velate", "velettate", "velinate", "vellicate", "vellutate", "velocizzate", "vendemmiate", "vendicate", "vendicchiate", "venducchiate", "vendute", "venerate", "vengiate", "ventagliate", "ventilate", "ventolate", "verbalizzate", "vergate", "vergheggiate", "vergognate", "vergolate", "verificate", "verminate", "vernalizzate", "verniciate", "verrinate", "versate", "verseggiate", "versificate", "verticalizzate", "vessate", "vestite", "vestite", "vetrificate", "vetrinate", "vetrioleggiate", "vettovagliate", "vezzeggiate", "viaggiate", "vicinate", "vicitate", "videochattate", "videochiamate", "videocomunicate", "videoregistrate", "videotrasmesse", "vidimate", "vigilate", "vigliate", "vigoreggiate", "vigorite", "vilificate", "vilipese", "villaneggiate", "vincolate", "vinte", "violate", "violentate", "violinate", "virgolate", "virgoleggiate", "virgolettate", "virilizzate", "virtualizzate", "visionate", "visitate", "vissute", "vistate", "viste", "visualizzate", "vitaliziate", "vitalizzate", "vitaminizzate", "vittimizzate", "vituperate", "vivacizzate", "vivandate", "vivificate", "vivisezionate", "viziate", "vocabolarizzate", "vocalizzate", "vocate", "vociferate", "volantinate", "volatilizzate", "volgarizzate", "volicchiate", "volpeggiate", "voltate", "volte", "voltolate", "volturate", "voluminizzate", "volute", "volutoce", "vomitate", "vorate", "votate", "vulcanizzate", "vuotate", "wappate", "wikificate", "xerocopiate", "zaffate", "zampate", "zampettate", "zampillate", "zannate", "zappate", "zappettate", "zapponate", "zavorrate", "zeppate", "zigrinate", "zigzagate", "zimbellate", "zincate", "zinnate", "zipolate", "zippate", "zirlate", "zittite", "zizzagate", "zoccolate", "zollate", "zombate", "zonate", "zonizzate", "zoppate", "zoppeggiate", "zoppicate", "zucconate", "zufolate", "zumate", "zuppate", "abalienati", "abbacchiati", "abbacinati", "abbadati", "abbagliati", "abbaiati", "abballati", "abbambinati", "abbancati", "abbandonati", "abbarbagliati", "abbarbati", "abbarcati", "abbaruffati", "abbassati", "abbatacchiati", "abbattuti", "abbatuffolati", "abbeliti", "abbellati", "abbelliti", "abbendati", "abbeverati", "abbiadati", "abbicati", "abbigliati", "abbinati", "abbindolati", "abbioccati", "abbiosciati", "abbisciati", "abbittati", "abboccati", "abboffati", "abbominati", "abbonacciati", "abbonati", "abboniti", "abbordati", "abborracciati", "abborrati", "abborriti", "abbottinati", "abbottonati", "abbozzacchiati", "abbozzati", "abbozzolati", "abbracciati", "abbraciati", "abbrancati", "abbreviati", "abbriccati", "abbrigliati", "abbrivati", "abbriviati", "abbrividiti", "abbronzati", "abbrostolati", "abbrostoliti", "abbruciacchiati", "abbruciati", "abbrunati", "abbruniti", "abbruscati", "abbrusciati", "abbrustiati", "abbrustolati", "abbrustoliti", "abbrutiti", "abbruttiti", "abbuffati", "abbuiati", "abbuonati", "abburattati", "abbuzziti", "abdicati", "abdotti", "abiettati", "abilitati", "abissati", "abitati", "abituati", "abiurati", "aboliti", "abominati", "abondati", "aborriti", "abrasi", "abrogati", "abusati", "accaffati", "accagionati", "accagliati", "accalappiati", "accalcati", "accaldati", "accallati", "accalorati", "accaloriti", "accambiati", "accampati", "accampionati", "accanalati", "accanati", "accaneggiati", "accaniti", "accantonati", "accaparrati", "accapezzati", "accapigliati", "accapottati", "accappiati", "accappiettati", "accapponati", "accappucciati", "accaprettati", "accareggiati", "accarezzati", "accarnati", "accarpionati", "accartocciati", "accasati", "accasciati", "accasellati", "accasermati", "accastellati", "accastellinati", "accatarrati", "accatastati", "accattati", "accattivati", "accavalcati", "accavalciati", "accavallati", "accavezzati", "accecati", "acceffati", "accelerati", "accellerati", "accennati", "accensati", "accentati", "accentrati", "accentuati", "acceppati", "accerchiati", "accercinati", "accertati", "accesi", "accessoriati", "accettati", "acchetati", "acchiappati", "acchiocciolati", "acchitati", "acchiuduti", "acciabattati", "acciaiati", "acciambellati", "acciarpati", "acciecati", "accigliati", "acciglionati", "accignuti", "accincignati", "accinti", "acciocchiti", "acciottolati", "accipigliati", "accismati", "accisi", "acciucchiti", "acciuffati", "accivettati", "acclamati", "acclarati", "acclimatati", "acclusi", "accoccati", "accoccolati", "accoccovati", "accodati", "accollati", "accoltellati", "accolti", "accomandati", "accomiatati", "accommiatati", "accomodati", "accompagnati", "accomunati", "acconciati", "acconigliati", "accontati", "accontentati", "accoppati", "accoppiati", "accorati", "accorciati", "accorciti", "accordati", "accordellati", "accorpati", "accorti", "accosciati", "accostati", "accostumati", "accotonati", "accottimati", "accovacciati", "accovati", "accovonati", "accozzati", "accreditati", "accresciuti", "accrespati", "accucciati", "accucciolati", "accuditi", "acculati", "acculturati", "accumulati", "accumunati", "accusati", "acetificati", "acetilati", "acetiti", "acidati", "acidificati", "acidulati", "acquadernati", "acquarellati", "acquartierati", "acquati", "acquattati", "acquerellati", "acquetati", "acquietati", "acquisiti", "acquistati", "acromatizzati", "acuiti", "acuminati", "acutizzati", "adacquati", "adagiati", "adattati", "addaziati", "addebbiati", "addebitati", "addecimati", "addensati", "addentati", "addentellati", "addentrati", "addestrati", "addetti", "addiacciati", "addimandati", "addimesticati", "addimorati", "addimostrati", "addipanati", "addirizzati", "additati", "additivati", "addizionati", "addobbati", "addociliti", "addogliati", "addolcati", "addolciati", "addolciti", "addolorati", "addomandati", "addomesticati", "addoppiati", "addormentati", "addossati", "addotti", "addottorati", "addottrinati", "addrizzati", "adduati", "addugliati", "adeguati", "adempiti", "adempiuti", "adequati", "aderizzati", "adescati", "adibiti", "adirati", "aditi", "adiuvati", "adizzati", "adocchiati", "adombrati", "adonati", "adonestati", "adontati", "adoperati", "adoprati", "adorati", "adornati", "adottati", "adsorbiti", "aduggiati", "adugnati", "adulati", "adulterati", "adunati", "adunghiati", "adusati", "aerati", "aereati", "aerotrainati", "aerotrasportati", "affabulati", "affaccendati", "affacchinati", "affacciati", "affagottati", "affaldati", "affamati", "affamigliati", "affannati", "affardellati", "affascinati", "affastellati", "affaticati", "affattucchiati", "affatturati", "affermati", "afferrati", "affettati", "affezionati", "affiancati", "affiatati", "affibbiati", "affidati", "affienati", "affievoliti", "affigliati", "affigurati", "affilati", "affilettati", "affiliati", "affinati", "affiochiti", "affiorati", "affisati", "affissati", "affissi", "affittati", "affittiti", "afflitti", "afflosciati", "affocati", "affogati", "affogliati", "affollati", "affoltati", "affondati", "afforcati", "afforestati", "afforzati", "affossati", "affraliti", "affrancati", "affranti", "affratellati", "affrenati", "affrenellati", "affrescati", "affrettati", "affrittellati", "affrontati", "affumati", "affumicati", "affumigati", "affuocati", "affusolati", "africanizzati", "ageminati", "agevolati", "aggallati", "agganciati", "aggangherati", "aggarbati", "aggattonati", "aggavignati", "aggelati", "aggettivati", "agghiacciati", "agghiadati", "agghiaiati", "agghindati", "aggiaccati", "aggiogati", "aggiornati", "aggirati", "aggiucchiti", "aggiudicati", "aggiuntati", "aggiunti", "aggiustati", "agglomerati", "agglutinati", "aggomitolati", "aggottati", "aggraditi", "aggraffati", "aggranchiati", "aggranchiti", "aggranditi", "aggrappati", "aggraticciati", "aggravati", "aggrediti", "aggregati", "aggrevati", "aggricciati", "aggrinzati", "aggrinziti", "aggrommati", "aggrondati", "aggroppati", "aggrottati", "aggrovigliati", "aggrumati", "aggruppati", "aggruzzolati", "agguagliati", "agguantati", "agguardati", "agguatati", "aggueffati", "agitati", "agognati", "agrarizzati", "aguatati", "agucchiati", "agunati", "agurati", "aguzzati", "aitati", "aiutati", "aizzati", "alati", "alberati", "albergati", "alcalinizzati", "alchilati", "alchimiati", "alchimizzati", "alcolizzati", "alcoolizzati", "alenati", "alesati", "alettati", "alfabetati", "alfabetizzati", "aliditi", "alienati", "alimentati", "allacciati", "allagati", "allappati", "allargati", "allascati", "allattati", "alleati", "allegati", "alleggeriti", "alleggiati", "allegorizzati", "alleluiati", "allenati", "alleniti", "allentati", "allertati", "allessati", "allestiti", "allettati", "allevati", "alleviati", "allibati", "allibiti", "allibrati", "allicciati", "allietati", "allindati", "allineati", "allisi", "allocati", "allogati", "alloggiati", "allontanati", "allottati", "allucchettati", "allucciolati", "allucinati", "allumati", "alluminati", "alluminiati", "allungati", "allupati", "allusi", "alluzzati", "alogenati", "alonati", "alpeggiati", "alterati", "alternati", "alzati", "amalgamati", "amareggiati", "amaricati", "amati", "ambientati", "ambiguati", "ambiti", "americanizzati", "amicati", "ammaccati", "ammaestrati", "ammainati", "ammalati", "ammaliati", "ammalinconiti", "ammaltati", "ammanettati", "ammanicati", "ammanierati", "ammanigliati", "ammannati", "ammannellati", "ammanniti", "ammansati", "ammansiti", "ammantati", "ammantellati", "ammarati", "ammarezzati", "ammassati", "ammassellati", "ammassicciati", "ammatassati", "ammattonati", "ammazzati", "ammelmati", "ammenciti", "ammendati", "ammennicolati", "ammessi", "ammetati", "ammezziti", "amministrati", "amminutati", "ammirati", "ammiseriti", "ammobiliati", "ammodernati", "ammodernizzati", "ammogliati", "ammoinati", "ammollati", "ammolliti", "ammoniti", "ammonticchiati", "ammonticellati", "ammorbati", "ammorbidati", "ammorbiditi", "ammorsati", "ammortati", "ammortiti", "ammortizzati", "ammorzati", "ammosciati", "ammosciti", "ammostati", "ammotinati", "ammucchiati", "ammulinati", "ammusati", "ammutati", "ammutinati", "amnistiati", "amoracciati", "ampiati", "ampliati", "amplificati", "amputati", "anagrammati", "analizzati", "anamorfizzati", "anastomizzati", "anatematizzati", "anatomizzati", "anchilosati", "ancisi", "ancorati", "andatoseni", "andicappati", "anellati", "anemizzati", "anestetizzati", "angariati", "anglicizzati", "angolati", "angosciati", "angustiati", "animati", "annacquati", "annaffiati", "annasati", "annaspati", "annaspicati", "annebbiati", "annegati", "annerati", "anneriti", "annessi", "annestati", "annichilati", "annichiliti", "annidati", "annientati", "annitriti", "annobiliti", "annodati", "annodicchiati", "annoiati", "annotati", "annottati", "annottolati", "annoverati", "annullati", "annunciati", "annunziati", "annusati", "annuvolati", "anodizzati", "anonimizzati", "anteceduti", "anteposti", "antergati", "anticheggiati", "antichizzati", "anticipati", "anticonosciuti", "antidatati", "antiveduti", "antivisti", "antologizzati", "antropizzati", "antropomorfizzati", "aocchiati", "aombrati", "aonestati", "aontati", "aperti", "apocopati", "apologizzati", "apostrofati", "appaciati", "appacificati", "appagati", "appaiati", "appalesati", "appallottolati", "appaltati", "appanettati", "appannati", "apparati", "apparecchiati", "apparentati", "apparigliati", "appariti", "appartati", "appassionati", "appastati", "appastellati", "appellati", "appennellati", "appercepiti", "appertizzati", "appesantiti", "appesiti", "appesi", "appestati", "appetiti", "appezzati", "appiacevoliti", "appianati", "appiastrati", "appiatati", "appiattati", "appiattiti", "appiccati", "appiccicati", "appiccoliti", "appiedati", "appigionati", "appigliati", "appinzati", "appiombati", "appioppati", "appisolati", "applauditi", "applicati", "appoderati", "appoggiati", "appollaiati", "appoppati", "apportati", "appostati", "apposti", "appratiti", "appresentati", "appresi", "appressati", "apprestati", "apprettati", "apprezzati", "approcciati", "approfittati", "approfondati", "approfonditi", "approntati", "appropinquati", "appropriati", "approssimati", "approvati", "approvisionati", "approvvigionati", "appruati", "appulcrati", "appuntati", "appuntellati", "appuntiti", "appurati", "appuzzati", "arabescati", "arabizzati", "arati", "arbitrati", "arborati", "arcaizzati", "arcati", "architettati", "archiviati", "arcuati", "arditi", "areati", "argentati", "arginati", "argomentati", "arguiti", "arianizzati", "arieggiati", "armati", "armonizzati", "aromatizzati", "arpeggiati", "arpionati", "arponati", "arrabattati", "arraffati", "arraffiati", "arrandellati", "arrangiati", "arrapati", "arrapinati", "arrappati", "arrazzati", "arrecati", "arredati", "arreggimentati", "arrembati", "arrenati", "arresisi", "arresi", "arrestati", "arretrati", "arricchiti", "arricciati", "arricciolati", "arriffati", "arringati", "arrischiati", "arrisicati", "arrisi", "arrocati", "arroccati", "arrochiti", "arrogati", "arrolati", "arroncati", "arronzati", "arrosati", "arrossati", "arrostati", "arrostiti", "arrotati", "arrotolati", "arrotondati", "arrovellati", "arroventati", "arroventiti", "arrovesciati", "arrubinati", "arruffati", "arruffianati", "arrugginiti", "arruncigliati", "arruolati", "arruviditi", "arsicciati", "arsi", "artefatti", "articolati", "artigliati", "ascesi", "asciati", "asciolvuti", "asciugati", "ascoltati", "ascosi", "ascosti", "ascritti", "asfaltati", "asfissiati", "aspersi", "aspettati", "aspirati", "asportati", "aspreggiati", "assaettati", "assaggiati", "assaliti", "assaltati", "assaporati", "assaporiti", "assassinati", "assecondati", "assecurati", "assediati", "asseggiati", "assegnati", "assembiati", "assemblati", "assembrati", "assemprati", "assentati", "asseriti", "asserragliati", "asserviti", "assestati", "assetati", "assettati", "asseverati", "assibilati", "assicurati", "assiderati", "assiemati", "assiepati", "assillati", "assimigliati", "assimilati", "assiomatizzati", "assisi", "assistiti", "associati", "assodati", "assoggettati", "assolcati", "assoldati", "assolti", "assolutizzati", "assomati", "assommati", "assonati", "assonnati", "assopiti", "assorbiti", "assordati", "assorditi", "assortiti", "assottigliati", "assuefatti", "assunti", "asteggiati", "astenuti", "astersi", "astratti", "astretti", "atomizzati", "atrofizzati", "atrovati", "attaccati", "attagliati", "attanagliati", "attardati", "attediati", "atteggiati", "attempati", "attendati", "attentati", "attenuati", "attenuti", "attergati", "atterrati", "atterriti", "atterzati", "attesi", "attestati", "atticizzati", "attillati", "attinti", "attirati", "attivati", "attivizzati", "attizzati", "attorcigliati", "attorniati", "attorti", "attoscati", "attossicati", "attraccati", "attrappiti", "attratti", "attraversati", "attrezzati", "attribuiti", "attristati", "attristiti", "attruppati", "attualizzati", "attuati", "attuffati", "attutati", "attutiti", "auggiati", "augumentati", "augurati", "auliti", "aumentati", "aunghiati", "ausati", "auscultati", "auspicati", "autenticati", "autentificati", "autoaccusati", "autoaffondati", "autoalimentati", "autoassolti", "autocandidati", "autocensurati", "autocitati", "autocommiserati", "autoconsumati", "autoconvinti", "autodefiniti", "autodenunciati", "autodistrutti", "autofinanziati", "autogestiti", "autogovernati", "autografati", "autoincensati", "autointersecati", "autoinvitati", "autolesionati", "autolimitati", "automaticizzati", "automatizzati", "automotivati", "autonominati", "autoproclamati", "autoprodotti", "autoprotetti", "autopubblicati", "autopubblicizzati", "autoregolamentati", "autoregolati", "autoridotti", "autoriparati", "autorizzati", "autosomministrati", "autosostenuti", "autosuggestionati", "autotassati", "autotrapiantati", "autotrasportati", "autovalutati", "avallati", "avampati", "avanzati", "avariati", "avinti", "aviolanciati", "aviotrasportati", "avocati", "avolterati", "avulsi", "avutaceli", "avuti", "avvalorati", "avvalsi", "avvantaggiati", "avvelati", "avvelenati", "avventati", "avventurati", "avverati", "avversati", "avvertiti", "avvezzati", "avviati", "avvicendati", "avvicinati", "avvignati", "avviliti", "avviluppati", "avvinati", "avvinchiati", "avvinghiati", "avvinti", "avvisati", "avvistati", "avvitati", "avviticchiati", "avvititi", "avvivati", "avvolti", "avvoltolati", "aziendalizzati", "azionati", "azotati", "azzannati", "azzardati", "azzeccati", "azzerati", "azzimati", "azzittati", "azzittiti", "azzoppati", "azzoppiti", "azzuffati", "azzurrati", "bacati", "baccagliati", "bacchettati", "bacchiati", "baciati", "badati", "bagnati", "baipassati", "balbettati", "balcanizzati", "ballati", "baloccati", "balzati", "banalizzati", "bancati", "banditi", "bannati", "baraccati", "barattati", "barbarizzati", "barcamenati", "bardati", "barellati", "barrati", "barricati", "basati", "basciati", "basculati", "bassati", "bastati", "bastionati", "bastiti", "bastonati", "battezzati", "battuti", "bazzicati", "beatificati", "beati", "beccati", "beccheggiati", "becchettati", "beffati", "beffeggiati", "bendati", "benedetti", "beneficati", "benvoluti", "berlusconizzati", "bersagliati", "bestemmiati", "bevuti", "biadati", "bianchettati", "bianchiti", "biascicati", "biasimati", "biasmati", "bidonati", "biennalizzati", "biforcati", "bigiati", "bilanciati", "binati", "bindolati", "biodegradati", "biografati", "bipartiti", "bisbigliati", "biscottati", "bisecati", "bisellati", "bisognati", "bissati", "bistrati", "bistrattati", "bitumati", "bituminati", "blanditi", "bleffati", "blindati", "bloccati", "bobinati", "boccheggiati", "bocciati", "boicottati", "bollati", "bolliti", "bombardati", "bombati", "bonderizzati", "bonificati", "bootati", "borbottati", "bordati", "boriati", "borrati", "borseggiati", "braccati", "bracciati", "bramati", "bramiti", "brancicati", "brandeggiati", "branditi", "brasati", "bravati", "brevettati", "breviati", "brillantati", "brillati", "brinati", "broccati", "brocciati", "broccolati", "brontolati", "bronzati", "brucati", "bruciacchiati", "bruciati", "bruniti", "bruscati", "bruschinati", "brutalizzati", "bruttati", "bucati", "bucherellati", "bufati", "buffati", "bufferizzati", "buggerati", "bugnati", "bulicati", "bulinati", "bullettati", "bullonati", "burattati", "burlati", "burocratizzati", "burrificati", "buscati", "buttati", "butterati", "bypassati", "cablati", "cabrati", "cacati", "cacciati", "cadenzati", "cadmiati", "caducati", "cagati", "caggiati", "cagionati", "cagliati", "calafatati", "calamitati", "calandrati", "calati", "calcati", "calciati", "calcificati", "calcolati", "caldeggiati", "calettati", "calibrati", "calmati", "calmierati", "calpestati", "calumati", "calunniati", "calzati", "cambiati", "camerati", "campionati", "campiti", "camuffati", "canalizzati", "cancellati", "cancerizzati", "candeggiati", "candidati", "canditi", "canforati", "cangiati", "cannati", "canneggiati", "cannibalizzati", "cannoneggiati", "canonizzati", "cantati", "canterellati", "canticchiati", "cantilenati", "canzonati", "caolinizzati", "capacitati", "capeggiati", "capillarizzati", "capitalizzati", "capitanati", "capitaneggiati", "capiti", "capitozzati", "capivolti", "caponati", "capotati", "capottati", "capovolti", "capponati", "captati", "caramellati", "caramellizzati", "caratati", "caratterizzati", "carbonizzati", "carbossilati", "carburati", "carcati", "carcerati", "cardati", "carenati", "carezzati", "cariati", "caricati", "caricaturati", "caricaturizzati", "carotati", "carpionati", "carpiti", "carreggiati", "carrozzati", "cartavetrati", "carteggiati", "cartellinati", "cartografati", "cartolarizzati", "cartonati", "cascolati", "cassati", "cassi", "castigati", "castrati", "casualizzati", "catabolizzati", "catalizzati", "catalogati", "catapultati", "catechizzati", "categorizzati", "cateterizzati", "catramati", "cattolicizzati", "catturati", "causati", "cautelati", "cauterizzati", "cauzionati", "cavalcati", "cavataseli", "cavati", "cazzati", "cazziati", "cazzottati", "cedrati", "ceduti", "celati", "celebrati", "cellofanati", "cementati", "cementificati", "cennati", "censiti", "censurati", "centellati", "centellinati", "centimetrati", "centinati", "centralizzati", "centrati", "centrifugati", "centuplicati", "cerati", "cercati", "cerchiati", "cernuti", "certificati", "cesellati", "cessati", "cestinati", "cheratinizzati", "chetati", "chiamati", "chiappati", "chiarificati", "chiariti", "chiaroscurati", "chiavati", "chiazzati", "chiesti", "chilificati", "chilometrati", "chimificati", "chinati", "chinizzati", "chiodati", "chiosati", "chiusi", "choccati", "ciancicati", "cianfrinati", "cianfrugliati", "ciangottati", "ciattati", "cibati", "cicatrizzati", "ciccati", "cicchettati", "ciclizzati", "ciclostilati", "cifrati", "cilindrati", "cimati", "cimentati", "cincischiati", "cinematografati", "cintati", "cinti", "cioncati", "ciondolati", "circolati", "circoncinti", "circoncisi", "circondati", "circondotti", "circonflessi", "circonfluiti", "circonfusi", "circonscritti", "circonvenuti", "circoscritti", "circostanziati", "circuiti", "circumcinti", "circumnavigati", "citati", "ciucciati", "ciurmati", "civettati", "civilizzati", "clamati", "classati", "classicizzati", "classificati", "cliccati", "climatizzati", "clivati", "clonati", "cloroformizzati", "clorurati", "clusterizzati", "co-diretti", "coacervati", "coadiuvati", "coagulati", "coalizzati", "coartati", "coccolati", "codificati", "coeditati", "coesistiti", "cofinanziati", "cofirmati", "cofondati", "cogestiti", "cogitati", "coglionati", "cognosciuti", "coibentati", "coincisi", "cointeressati", "cointestati", "coinvolti", "cokificati", "colati", "colettati", "collassati", "collaudati", "collazionati", "collegati", "collettivizzati", "collezionati", "collimati", "colliquati", "collisi", "collocati", "colluttati", "colmati", "colonizzati", "colorati", "coloriti", "colorizzati", "colpevolizzati", "colpiti", "coltellati", "coltivati", "colti", "coltrati", "comandati", "combattuti", "combinati", "comburuti", "comicizzati", "cominciati", "commemorati", "commendati", "commensurati", "commentati", "commercializzati", "commessi", "comminati", "commiserati", "commissariati", "commissionati", "commisurati", "commossi", "commutati", "comodati", "compaginati", "compariti", "compartimentalizzati", "compartiti", "compassionati", "compatibilizzati", "compatiti", "compattati", "compendiati", "compenetrati", "compensati", "comperati", "compiaciuti", "compianti", "compilati", "compitati", "compiuti", "complessati", "complessificati", "complessi", "completati", "complicati", "complimentati", "comportati", "compostati", "composti", "comprati", "compravenduti", "compresi", "compressi", "compromessi", "comprovati", "compulsati", "compunti", "computati", "computerizzati", "comunicati", "comunistizzati", "concatenati", "conceduti", "concelebrati", "concentrati", "concepiti", "concertati", "concessi", "concettati", "concettualizzati", "conchiusi", "conciati", "conciliati", "concimati", "concitati", "conclamati", "conclusi", "concordati", "concotti", "concretati", "concretizzati", "conculcati", "concupiti", "condannati", "condensati", "conditi", "condivisi", "condizionati", "condoluti", "condonati", "condotti", "confatti", "confederati", "conferiti", "confermati", "confessati", "confettati", "confezionati", "conficcati", "confidati", "configurati", "confinati", "confinti", "confiscati", "confitti", "conformati", "confortati", "confricati", "confrontati", "confusi", "confutati", "congedati", "congegnati", "congelati", "congestionati", "congetturati", "congiunti", "conglobati", "conglomerati", "conglutinati", "congratulati", "congregati", "conguagliati", "coniati", "coniugati", "connaturati", "connessi", "connotati", "connumerati", "conosciuti", "conquistati", "consacrati", "consapevolizzati", "consegnati", "conseguiti", "consentiti", "conservati", "considerati", "consigliati", "consistiti", "consociati", "consolati", "consolidati", "consorziati", "consparsi", "conspersi", "constatati", "constretti", "construiti", "consultati", "consumati", "consunti", "contabilizzati", "contagiati", "containerizzati", "contaminati", "contati", "contattati", "conteggiati", "contemperati", "contemplati", "contentati", "contenuti", "contesi", "contestati", "contestualizzati", "contingentati", "continuati", "contornati", "contorti", "contrabbandati", "contraccambiati", "contraddetti", "contraddistinti", "contradetti", "contraffatti", "contrappesati", "contrapposti", "contrappuntati", "contrariati", "contrassegnati", "contrastati", "contrati", "contrattaccati", "contrattati", "contratti", "contravvalsi", "contristati", "controbattuti", "controbilanciati", "controdatati", "controfirmati", "controindicati", "controllati", "controminati", "contronotati", "controproposti", "controprovati", "controquerelati", "controsoffittati", "controstampati", "controventati", "conturbati", "contusi", "convalidati", "convenuti", "convenzionati", "convertiti", "convinti", "convitati", "convocati", "convogliati", "convolti", "coobati", "cooptati", "coordinati", "coperchiati", "coperti", "copiaincollati", "copiati", "copolimerizzati", "coppellati", "coprodotti", "corazzati", "corbellati", "corcati", "cordonati", "coreografati", "coricati", "cornificati", "coronati", "corredati", "correlati", "corresponsabilizzati", "corretti", "corricchiati", "corrisposti", "corroborati", "corrosi", "corrotti", "corrucciati", "corrugati", "corsi", "corteati", "corteggiati", "cortocircuitati", "coruscati", "cosati", "coscritti", "cosparsi", "cospersi", "costatati", "costeggiati", "costellati", "costernati", "costicchiati", "costipati", "costituiti", "costituzionalizzati", "costretti", "costruiti", "costuditi", "cotonati", "cotti", "covati", "coventrizzati", "coverchiati", "craccati", "creati", "creduti", "cremati", "crepati", "cresciuti", "cresimati", "crespati", "criminalizzati", "crioconcentrati", "criptati", "cristallizzati", "cristianizzati", "criticati", "crittati", "crittografati", "crivellati", "crocchiati", "crocefissi", "crocefitti", "crocifissi", "crocifitti", "crogiolati", "cromati", "cronicizzati", "cronometrati", "crostati", "crucciati", "crucifissi", "crucifitti", "cuccati", "cucinati", "cuciti", "cullati", "cumulati", "cuntati", "curati", "curvati", "curvati", "custoditi", "customizzati", "damascati", "damaschinati", "damati", "dannati", "danneggiati", "danzati", "dardeggiati", "datati", "dati", "dattilografati", "dattiloscritti", "daziati", "deacidificati", "deattivati", "debbiati", "debellati", "debilitati", "decaffeinati", "decaffeinizzati", "decalcati", "decalcificati", "decantati", "decapati", "decapitati", "decappottati", "decarbossilati", "decarburati", "decatizzati", "decelerati", "decentralizzati", "decentrati", "decerebrati", "decernuti", "decespugliati", "deciferati", "decifrati", "decimalizzati", "decimati", "decisi", "declamati", "declassati", "declassificati", "declinati", "declorati", "decodificati", "decolonizzati", "decolorati", "decompartimentati", "decompilati", "decomposti", "decompressi", "deconcentrati", "decondizionati", "decongelati", "decongestionati", "decontaminati", "decontestualizzati", "decontratti", "decorati", "decorticati", "decostruiti", "decrementati", "decretati", "decriminalizzati", "decriptati", "decrittati", "decuplicati", "decurtati", "dedicati", "dedotti", "defacciati", "defalcati", "defascistizzati", "defecati", "defenestrati", "deferiti", "defilati", "definiti", "defiscalizzati", "defitti", "deflazionati", "deflemmati", "deflorati", "defogliati", "defoliati", "deforestati", "deformati", "defosforati", "defosforilati", "deframmentati", "defraudati", "degassati", "degassificati", "deglutiti", "degnati", "degradati", "degustati", "deidratati", "deidrogenati", "deificati", "deindicizzati", "deindustrializzati", "deionizzati", "delegati", "delegificati", "delegittimati", "delibati", "deliberati", "delimitati", "delineati", "delirati", "deliziati", "delocalizzati", "delucidati", "delusi", "demagnetizzati", "demandati", "demanializzati", "demarcati", "demeritati", "demersi", "demetallizzati", "demilitarizzati", "demineralizzati", "demistificati", "demitizzati", "democratizzati", "demodulati", "demoliti", "demoltiplicati", "demonetati", "demonetizzati", "demonizzati", "demoralizzati", "demorsi", "demotivati", "denaturalizzati", "denaturati", "denazificati", "denazionalizzati", "denicotinizzati", "denigrati", "denitrificati", "denocciolati", "denominati", "denotati", "dentellati", "denuclearizzati", "denudati", "denunciati", "denunziati", "deodorati", "deossidati", "deossigenati", "deostruiti", "depauperati", "depenalizzati", "depennati", "depilati", "depinti", "depistati", "deplorati", "depolarizzati", "depolimerizzati", "depoliticizzati", "depolverizzati", "deportati", "depositati", "deposti", "depotenziati", "depravati", "deprecati", "depredati", "depressi", "depressurizzati", "deprezzati", "deprivati", "deprotonati", "depulsi", "depurati", "dequalificati", "deratizzati", "derattizzati", "dereferenziati", "deregolamentati", "deregolati", "derequisiti", "deresponsabilizzati", "derisi", "derubati", "derubricati", "desacralizzati", "desalati", "desalinizzati", "descolarizzati", "descritti", "desecretati", "desegretati", "deselezionati", "desensibilizzati", "desessualizzati", "desiati", "desiderati", "designati", "desinati", "desirati", "desolati", "desolforati", "desonorizzati", "desorbiti", "desossidati", "desquamati", "destabilizzati", "destagionalizzati", "destalinizzati", "destatalizzati", "destatizzati", "destati", "destinati", "destituiti", "destoricizzati", "destreggiati", "destrutti", "destrutturati", "desunti", "detassati", "detenuti", "deteriorati", "determinati", "detersi", "detestati", "detonati", "detorti", "detossificati", "detratti", "detronizzati", "dettagliati", "dettati", "detti", "deturpati", "deumidificati", "devastati", "deventati", "deviati", "deviscerati", "devitalizzati", "devitaminizzati", "devoluti", "dezippati", "diaframmati", "diagnosticati", "diagonalizzati", "diagrammati", "dializzati", "dialogati", "dialogizzati", "diazotati", "dibattuti", "diboscati", "dichiarati", "diesati", "diesizzati", "difesi", "diffamati", "differiti", "diffidati", "diffranti", "diffratti", "diffusi", "digeriti", "digitalizzati", "digitati", "digiunti", "digrassati", "digrignati", "digrossati", "dilacerati", "dilaniati", "dilapidati", "dilatati", "dilavati", "dilazionati", "dileggiati", "dileguati", "dilettati", "diletti", "diliscati", "dilucidati", "diluiti", "dilungati", "dimagrati", "dimandati", "dimenati", "dimensionati", "dimenticati", "dimerizzati", "dimessi", "dimezzati", "diminuiti", "dimissionati", "dimostrati", "dimunti", "dinamizzati", "dinoccati", "dipanati", "dipelati", "dipinti", "diplomati", "diposti", "diradati", "diramati", "diretti", "direzionati", "dirimuti", "diroccati", "dirottati", "dirotti", "dirozzati", "disabilitati", "disabituati", "disaccentati", "disaccoppiati", "disaccordati", "disacerbati", "disacidati", "disacidificati", "disaciditi", "disaerati", "disaffezionati", "disaggregati", "disalberati", "disallineati", "disamati", "disambiguati", "disaminati", "disamorati", "disancorati", "disanimati", "disappannati", "disapplicati", "disappresi", "disapprovati", "disarcionati", "disarmati", "disarticolati", "disascosti", "disassemblati", "disassuefatti", "disatomizzati", "disattesi", "disattivati", "disattrezzati", "disavvezzati", "disboscati", "disbrigati", "discacciati", "discalzati", "discantati", "discaricati", "discernuti", "discesi", "disceverati", "dischiesti", "dischiusi", "discinti", "disciolti", "disciplinati", "discolorati", "discolpati", "discommessi", "discompagnati", "discomposti", "disconclusi", "disconfitti", "discongiunti", "disconnessi", "disconosciuti", "discoperti", "discordati", "discoscesi", "discostati", "discreditati", "discresciuti", "discriminati", "discritti", "discuciti", "discuoiati", "discussi", "disdegnati", "disdettati", "disdetti", "diseccati", "diseccitati", "diseducati", "disegnati", "diserbati", "diseredati", "disertati", "diserti", "disfatti", "disgelati", "disgiunti", "disgraziati", "disgregati", "disgustati", "disidentificati", "disiderati", "disidratati", "disillusi", "disimballati", "disimparati", "disimpegnati", "disimpressi", "disincagliati", "disincantati", "disincentivati", "disincrostati", "disindustrializzati", "disinfestati", "disinfettati", "disinflazionati", "disinformati", "disingannati", "disingranati", "disinibiti", "disinnamorati", "disinnescati", "disinnestati", "disinquinati", "disinseriti", "disinstallati", "disintasati", "disintegrati", "disinteressati", "disintesi", "disintossicati", "disinvestiti", "disinvolti", "disistimati", "dislocati", "dismessi", "disobbediti", "disobbligati", "disonorati", "disordinati", "disorganizzati", "disorientati", "disormeggiati", "disossati", "disossidati", "disostruiti", "disotterrati", "dispariti", "dispensati", "dispenti", "disperduti", "dispersi", "dispesi", "dispiegati", "dispinti", "dispogliati", "disposti", "dispregiati", "disprezzati", "dispromessi", "disproporzionati", "disputati", "disqualificati", "disrotti", "dissacrati", "dissalati", "dissaldati", "dissanguati", "dissecati", "disseccati", "disselciati", "dissellati", "disseminati", "dissepolti", "disseppelliti", "dissequestrati", "disserrati", "dissestati", "dissetati", "dissezionati", "dissigillati", "dissimulati", "dissipati", "dissociati", "dissodati", "dissolti", "dissomigliati", "dissotterrati", "dissuasi", "dissuggellati", "distaccati", "distanziati", "distesi", "distillati", "distinti", "distolti", "distorti", "distratti", "distretti", "distribuiti", "districati", "distrigati", "distrutti", "disturbati", "disubbiditi", "disumanati", "disumanizzati", "disuniti", "disusati", "disveduti", "disvelati", "disvestiti", "disviati", "disvisti", "disvolti", "disvoluti", "dittongati", "divallati", "divaricati", "divelti", "diversificati", "divertiti", "divezzati", "divinati", "divincolati", "divinizzati", "divisi", "divolti", "divorati", "divorziati", "divulgati", "documentati", "dogati", "dogmatizzati", "dolcificati", "dollarizzati", "dolorati", "doluti", "domandati", "domati", "domesticati", "domiciliati", "dominati", "donati", "dondolati", "dopati", "doppiati", "dorati", "dormitoci", "dosati", "dotati", "dovuti", "dragati", "drammatizzati", "drappeggiati", "drenati", "dribblati", "drizzati", "drogati", "dugliati", "duplicati", "duramificati", "ebraizzati", "ecceduti", "eccepiti", "eccettuati", "eccitati", "echeggiati", "eclissati", "economizzati", "edificati", "editati", "edotti", "educati", "edulcorati", "effettuati", "efficientati", "effigiati", "effinti", "effluiti", "effusi", "egemonizzati", "eguagliati", "eiettati", "elaborati", "elargiti", "elasticizzati", "elementarizzati", "elemosinati", "elencati", "eletti", "elettrificati", "elettrizzati", "elettrocoagulati", "elettrolizzati", "elevati", "eliminati", "elisi", "elitrasportati", "ellenizzati", "elogiati", "elucidati", "elucubrati", "eluiti", "elusi", "emanati", "emancipati", "emarginati", "embricati", "emendati", "emessi", "emozionati", "empiti", "empiuti", "emulati", "emulsionati", "emunti", "encomiati", "endocitati", "energizzati", "enfatizzati", "enfiati", "entusiasmati", "enucleati", "enumerati", "enunciati", "epicureggiati", "epurati", "equalizzati", "equilibrati", "equipaggiati", "equiparati", "eradicati", "erasi", "ereditati", "eretti", "erogati", "eroicizzati", "erosi", "erotizzati", "erpicati", "ersi", "eruditi", "eruttati", "esacerbati", "esagerati", "esagitati", "esalati", "esaltati", "esaminati", "esasperati", "esauditi", "esauriti", "esautorati", "esborsati", "esclusi", "escogitati", "escomiati", "escoriati", "escossi", "escussi", "esecrati", "esecutati", "eseguiti", "esemplificati", "esentati", "esercitati", "esfoliati", "esibiti", "esilarati", "esiliati", "esimuti", "esitati", "esonerati", "esorbitati", "esorcizzati", "esortati", "espansi", "esparsi", "esperimentati", "esperiti", "espettorati", "espiantati", "espiati", "espirati", "espletati", "esplicati", "esplicitati", "esplorati", "esplosi", "esportati", "esposti", "espressi", "espropriati", "espugnati", "espulsi", "espunti", "espurgati", "essiccati", "essuti", "estasiati", "estenuati", "esterificati", "esteriorizzati", "esterminati", "esternalizzati", "esternati", "estesi", "estimati", "estinti", "estirpati", "estivati", "estorti", "estradati", "estraniati", "estrapolati", "estratti", "estremizzati", "estrinsecati", "estromessi", "estrusi", "estubati", "esulcerati", "esultati", "esumati", "eterificati", "eterizzati", "eternati", "eternizzati", "etichettati", "etossilati", "euforizzati", "europeizzati", "evacuati", "evangelizzati", "evasi", "eveti", "evidenziati", "evinti", "evirati", "eviscerati", "evitati", "evocati", "evolti", "evoluti", "evulsi", "fabbricati", "faccettati", "facilitati", "fagocitati", "falciati", "falcidiati", "falliti", "falsati", "falsificati", "familiarizzati", "fanatizzati", "fantasticati", "farciti", "farfugliati", "fasciati", "fascicolati", "fascistizzati", "fattaceli", "fatti", "fattorizzati", "fatturati", "favellati", "favoreggiati", "favoriti", "faxati", "fecondati", "fedecommessi", "federalizzati", "federati", "felicitati", "felpati", "feltrati", "femminilizzati", "fenduti", "feriti", "fermati", "fermentati", "ferrati", "fertilizzati", "fessi", "fessurati", "festeggiati", "festonati", "feudalizzati", "fiaccati", "fiammeggiati", "fiancheggiati", "ficcati", "fidanzati", "fidati", "fidecommessi", "fidelizzati", "figliati", "figurati", "filati", "filettati", "filmati", "filosofati", "filtrati", "finalizzati", "finanziati", "finitali", "finiti", "finlandizzati", "fintati", "finti", "fiocinati", "fiondati", "fiorettati", "firmati", "fiscalizzati", "fischiati", "fischiettati", "fissati", "fissionati", "fitti", "fiutati", "flagellati", "flaggati", "flambati", "flangiati", "flemmatizzati", "flessi", "flippati", "flottati", "fluidificati", "fluidizzati", "fluorizzati", "fluorurati", "focalizzati", "focheggiati", "foderati", "foggiati", "fognati", "folgorati", "follati", "fomentati", "fonati", "fondati", "foracchiati", "foraggiati", "forati", "forestati", "forfettizzati", "forgiati", "formalizzati", "formati", "formattati", "formilati", "formulati", "forniti", "fortificati", "forviati", "forwardati", "forzati", "fosfatati", "fosforati", "fosforilati", "fossilizzati", "fotocomposti", "fotocopiati", "fotografati", "fottuti", "fracassati", "fraintesi", "framessi", "frammentati", "frammessi", "frammezzati", "frammischiati", "franceseggiati", "francesizzati", "frangiati", "franti", "frantumati", "frappati", "frapposti", "fraseggiati", "frastagliati", "frastornati", "fratturati", "frazionati", "freddati", "fregati", "fregiati", "frenati", "frequentati", "fresati", "frettati", "friendzonati", "fritti", "frizionati", "frodati", "frollati", "fronteggiati", "frugati", "fruiti", "frullati", "frusciati", "frustati", "frustrati", "fruttati", "fucilati", "fucinati", "fugati", "fuggiti", "fulminati", "fumati", "fumigati", "funestati", "funti", "funzionati", "fuoriusciti", "fuorviati", "fusi", "fustellati", "fustigati", "gabbati", "gabellati", "gallati", "gallicizzati", "gallonati", "galvanizzati", "gambizzati", "garantiti", "garnettati", "garrotati", "garzati", "gasati", "gassati", "gassificati", "gazati", "gelatinizzati", "gelati", "gelificati", "gemellati", "gemicati", "geminati", "generalizzati", "generati", "gentrificati", "genuflessi", "geometrizzati", "georeferenziati", "gerarchizzati", "germanizzati", "gestiti", "gettati", "gettonati", "ghermiti", "ghettizzati", "ghigliottinati", "ghindati", "gibollati", "gingillati", "ginnati", "giocati", "gioiti", "gionglati", "giovaneggiati", "girandolati", "girati", "giudicati", "giulebbati", "giuntati", "giunti", "giuracchiati", "giurati", "giustapposti", "giustificati", "giustiziati", "glamourizzati", "glassati", "glissati", "globalizzati", "gloriati", "glorificati", "glossati", "godronati", "goduti", "goffrati", "gommati", "gonfiati", "googlati", "gottati", "governati", "gradinati", "graditi", "gradualizzati", "graduati", "graffati", "graffiati", "graffiti", "graficati", "grafitati", "gramolati", "granagliati", "grandinati", "granellati", "graniti", "granulati", "graticciati", "graticolati", "gratificati", "gratinati", "grattati", "grattugiati", "gravati", "graziati", "grecheggiati", "grecizzati", "gremiti", "gridati", "griffati", "grigliati", "grippati", "groccati", "grondati", "grugati", "grugniti", "guadagnati", "gualciti", "guardati", "guariti", "guarniti", "guastati", "guatati", "guerreggiati", "gufati", "guidati", "gustati", "hackerati", "handicappati", "ibridati", "idealizzati", "ideati", "identificati", "ideologizzati", "idolatrati", "idoleggiati", "idratati", "idrogenati", "idrolizzati", "iettati", "igienizzati", "ignifugati", "ignorati", "illanguiditi", "illeggiadriti", "illividiti", "illuminati", "illusi", "illustrati", "imbacuccati", "imbaldanziti", "imballati", "imbalsamati", "imbambolati", "imbandierati", "imbanditi", "imbarbariti", "imbarcati", "imbarilati", "imbastarditi", "imbastiti", "imbattuti", "imbavagliati", "imbeccati", "imbellettati", "imbelliti", "imbestialiti", "imbestiati", "imbevuti", "imbiaccati", "imbiancati", "imbianchiti", "imbibiti", "imbiettati", "imbionditi", "imbizzarriti", "imboccati", "imboniti", "imborghesiti", "imboscati", "imboschiti", "imbottati", "imbottigliati", "imbottiti", "imbozzimati", "imbracati", "imbracciati", "imbragati", "imbrancati", "imbrattati", "imbrecciati", "imbrigliati", "imbrillantinati", "imbroccati", "imbrodati", "imbrogliati", "imbronciati", "imbruttiti", "imbucati", "imbudellati", "imbullettati", "imbullonati", "imburrati", "imbussolati", "imbustati", "imbutiti", "imitati", "immagazzinati", "immaginati", "immalinconiti", "immatricolati", "immedesimati", "immersi", "immessi", "immischiati", "immiseriti", "immobilizzati", "immolati", "immortalati", "immunizzati", "immusoniti", "impaccati", "impacchettati", "impacciati", "impadroniti", "impaginati", "impagliati", "impalati", "impalcati", "impallati", "impallinati", "impalmati", "impaludati", "impanati", "impaniati", "impannati", "impantanati", "impaperati", "impapocchiati", "impappinati", "imparentati", "imparruccati", "impartiti", "impastati", "impasticcati", "impasticciati", "impastocchiati", "impastoiati", "impataccati", "impattati", "impauriti", "impavesati", "impeciati", "impedicati", "impediti", "impegnati", "impegolati", "impelagati", "impellicciati", "impennacchiati", "impennati", "impensieriti", "impepati", "imperlati", "impermaliti", "impermeabilizzati", "imperniati", "impersonati", "impersonificati", "impestati", "impetrati", "impiallacciati", "impiantati", "impiastrati", "impiastricciati", "impiccati", "impicciati", "impiccioliti", "impiccoliti", "impidocchiati", "impiegati", "impietositi", "impietriti", "impigliati", "impigriti", "impilati", "impillaccherati", "impinguati", "impinti", "impinzati", "impiombati", "impipati", "impiumati", "implementati", "implicati", "implorati", "impollinati", "impolpati", "impoltroniti", "impolverati", "impomatati", "imporcati", "imporporati", "importati", "importunati", "impossessati", "impossibilitati", "impostati", "imposti", "impratichiti", "impregnati", "impresi", "impressionati", "impressi", "imprestati", "impreziositi", "imprigionati", "impromessi", "improntati", "improsciuttiti", "impugnati", "impuntiti", "impunturati", "impupati", "imputati", "impuzzolentiti", "inabilitati", "inabissati", "inacerbiti", "inacetiti", "inaciditi", "inacutiti", "inaffiati", "inalati", "inalberati", "inalveati", "inalzati", "inamidati", "inanellati", "inarcati", "inargentati", "inariditi", "inaspriti", "inastati", "inattivati", "inaugurati", "incacchiati", "incalcinati", "incaloriti", "incalzati", "incamerati", "incamiciati", "incamminati", "incanagliti", "incanalati", "incannati", "incannucciati", "incaponiti", "incappottati", "incappucciati", "incaprettati", "incapricciati", "incapsulati", "incarcerati", "incardinati", "incaricati", "incarnati", "incarrozzati", "incartati", "incartocciati", "incartonati", "incasellati", "incasinati", "incassati", "incastellati", "incastonati", "incastrati", "incatenati", "incatramati", "incattiviti", "incavati", "incavigliati", "incavolati", "incazzati", "incellofanati", "incendiati", "inceneriti", "incensati", "incentivati", "incentrati", "inceppati", "incerati", "incernierati", "incerottati", "incesi", "incettati", "inchiappettati", "inchiavardati", "inchiesti", "inchinati", "inchiodati", "inchiostrati", "incipriati", "incisi", "incistati", "incitati", "inciuccati", "inciviliti", "inclinati", "inclusi", "incoccati", "incocciati", "incoiati", "incollati", "incolonnati", "incolpati", "incominciati", "incomodati", "incontrati", "incoraggiati", "incordati", "incornati", "incorniciati", "incoronati", "incorporati", "incotti", "incravattati", "incrementati", "increspati", "incretiniti", "incriminati", "incrinati", "incrociati", "incrostati", "incrudeliti", "incruditi", "incruscati", "incubati", "inculati", "inculcati", "incuneati", "incuoiati", "incuorati", "incupiti", "incuriositi", "incurvati", "incussi", "indagati", "indebitati", "indeboliti", "indemaniati", "indennizzati", "indetti", "indicati", "indicizzati", "indignati", "indiretti", "indirizzati", "indispettiti", "indisposti", "individualizzati", "individuati", "indolenziti", "indorati", "indossati", "indotti", "indottomi", "indottrinati", "indovinati", "indugiati", "indulti", "indurati", "induriti", "industrializzati", "industriati", "inebetiti", "inebriati", "ineriti", "inerpicati", "infagottati", "infamati", "infangati", "infarciti", "infarinati", "infastiditi", "infatuati", "infeltriti", "inferiti", "inferociti", "inferti", "infervorati", "infestati", "infettati", "infeudati", "infiacchiti", "infialati", "infialettati", "infiammati", "infiascati", "infibulati", "inficiati", "infilati", "infiltrati", "infilzati", "infingarditi", "infinocchiati", "infinti", "infioccati", "infiocchettati", "infiochiti", "infiorati", "infirmati", "infischiati", "infissi", "infittiti", "inflazionati", "inflessi", "inflitti", "influenzati", "infocati", "infoderati", "infognati", "infoibati", "infoltiti", "inforcati", "informatizzati", "informati", "informicolati", "informicoliti", "infornaciati", "infornati", "infortunati", "infoscati", "infossati", "infradiciati", "inframessi", "inframezzati", "inframmessi", "inframmezzati", "infrancesati", "infrapposti", "infrascati", "infrattati", "infreddati", "infronzolati", "infuocati", "infurbiti", "infuriati", "ingabbiati", "ingaggiati", "ingagliarditi", "ingannati", "ingarbugliati", "ingavonati", "ingegnati", "ingegnerizzati", "ingelositi", "ingemmati", "ingenerati", "ingentiliti", "ingeriti", "ingessati", "inghiaiati", "inghiottiti", "inghirlandati", "ingialliti", "ingigantiti", "inginocchiati", "ingioiellati", "ingiunti", "ingiuriati", "inglesizzati", "inglobati", "ingoffiti", "ingoiati", "ingolfati", "ingollati", "ingolositi", "ingombrati", "ingommati", "ingorgati", "ingozzati", "ingranati", "ingranditi", "ingrassati", "ingraticciati", "ingraticolati", "ingravidati", "ingraziati", "ingraziositi", "ingrigiti", "ingrommati", "ingrossati", "ingrulliti", "inguaiati", "inguainati", "ingualdrappati", "inguantati", "ingurgitati", "inibiti", "iniettati", "inimicati", "inizializzati", "iniziati", "inmillati", "innacquati", "innaffiati", "innalzati", "innamorati", "innastati", "innervati", "innervositi", "innescati", "innestati", "innevati", "innocentati", "innocuizzati", "innovati", "inoculati", "inoltrati", "inondati", "inorgogliti", "inorpellati", "inorriditi", "inquadrati", "inquietati", "inquisiti", "insabbiati", "insacchettati", "insalati", "insaldati", "insalivati", "insanguinati", "insaponati", "insaporiti", "inscatolati", "inscenati", "inscritti", "insecchiti", "insediati", "insegnati", "inseguiti", "insellati", "inselvatichiti", "inseriti", "insidiati", "insigniti", "insilati", "insinuati", "insolentiti", "insonnoliti", "insonorizzati", "insorditi", "insospettiti", "insozzati", "inspessiti", "inspirati", "installati", "instaurati", "insteriliti", "instillati", "instituiti", "instradati", "insudiciati", "insufflati", "insultati", "insuperbiti", "intabaccati", "intabarrati", "intaccati", "intagliati", "intarsiati", "intasati", "intascati", "intavolati", "integrati", "intelaiati", "intelati", "intellettualizzati", "intenebrati", "inteneriti", "intensificati", "intentati", "intepiditi", "intercalati", "intercambiati", "intercettati", "intercisi", "interclusi", "intercollegati", "interconnessi", "interconvertiti", "interdetti", "interessati", "interfacciati", "interfogliati", "interfoliati", "interiorizzati", "interlacciati", "interlineati", "intermessi", "intermezzati", "internalizzati", "internati", "internazionalizzati", "interpellati", "interpenetrati", "interpolati", "interposti", "interpretati", "interpunti", "interrati", "interrogati", "interrotti", "intersecati", "intervallati", "intervistati", "intesi", "intessuti", "intestarditi", "intestati", "intiepiditi", "intimati", "intimiditi", "intimoriti", "intinti", "intirizziti", "intitolati", "intonacati", "intonati", "intontiti", "intorbidati", "intorbiditi", "intorpiditi", "intortati", "intossicati", "intralciati", "intramessi", "intramezzati", "intrappolati", "intrapresi", "intrattenuti", "intraveduti", "intravisti", "intravveduti", "intravvisti", "intrecciati", "intricati", "intrigati", "intrinsecati", "intrippati", "intrisi", "introdotti", "introflessi", "introiettati", "introitati", "intromessi", "intronati", "intronizzati", "intruduti", "intrufolati", "intrugliati", "intruppati", "intrusi", "intubati", "intubettati", "intuiti", "inumati", "inumiditi", "inurbati", "inutilizzati", "invaghiti", "invaginati", "invalidati", "invasati", "invasi", "inveleniti", "inventariati", "inventati", "invenuti", "inverditi", "invergati", "inverniciati", "investigati", "investiti", "invetriati", "inviati", "invidiati", "invigoriti", "inviluppati", "invischiati", "invitati", "invocati", "invogliati", "involati", "involgariti", "involtati", "involti", "inzaccherati", "inzeppati", "inzigati", "inzolfati", "inzuccati", "inzuccherati", "inzuppati", "iodurati", "ionizzati", "ipertrofizzati", "ipnotizzati", "ipostatizzati", "ipotecati", "ipotizzati", "iridati", "irradiati", "irraggiati", "irreggimentati", "irretiti", "irrigati", "irrigiditi", "irrisi", "irritati", "irrobustiti", "irrogati", "irrorati", "irrugginiti", "irruviditi", "ischeletriti", "iscritti", "islamizzati", "isolati", "isomerizzati", "ispanizzati", "ispessiti", "ispezionati", "ispirati", "issati", "istallati", "istanziati", "istaurati", "isteriliti", "istigati", "istillati", "istituiti", "istituzionalizzati", "istoriati", "istradati", "istruiti", "istupiditi", "italianeggiati", "italianizzati", "iterati", "iudicati", "killerati", "labbreggiati", "labializzati", "laccati", "lacerati", "laconizzati", "lacrimati", "ladroneggiati", "lagnati", "lagrimati", "laicizzati", "lambiccati", "lambiti", "lamentati", "laminati", "lanciati", "lapidati", "lappati", "lardati", "lardellati", "largiti", "larvati", "lascati", "lasciati", "lastricati", "latinizzati", "laudati", "laureati", "lavati", "lavorati", "leccati", "legalizzati", "legati", "leggicchiati", "leggiucchiati", "legittimati", "legittimizzati", "legnati", "lemmatizzati", "leniti", "lesinati", "lesionati", "lesi", "lessati", "letti", "levati", "levigati", "liberalizzati", "liberati", "licenziati", "lievitati", "liftati", "lignificati", "limati", "limitati", "linciati", "linearizzati", "lineati", "linkati", "liofilizzati", "liquefatti", "liquidati", "lisati", "lisciati", "lisciviati", "listati", "litografati", "livellati", "lizzati", "lobotomizzati", "localizzati", "locati", "lodati", "logorati", "lordati", "lottati", "lottizzati", "lubrificati", "lucchettati", "lucidati", "lucrati", "lumeggiati", "luppolizzati", "lusingati", "lussati", "lustrati", "macadamizzati", "macchiati", "macchinati", "macellati", "macerati", "maciullati", "maggesati", "maggiorati", "magnati", "magnetizzati", "magnificati", "maiolicati", "maledetti", "malfatti", "malignati", "malmenati", "malmessi", "maltati", "maltrattati", "malveduti", "malversati", "malvisti", "malvoluti", "mandati", "mandrinati", "manducati", "maneggiati", "manganati", "manganellati", "mangiati", "mangiucchiati", "manifatturati", "manifestati", "manimessi", "manipolati", "manlevati", "manomessi", "manoscritti", "manovrati", "mansuefatti", "mantecati", "mantenutasi", "mantenuti", "manualizzati", "manutenuti", "mappati", "marcati", "marchiati", "marciti", "marezzati", "marginalizzati", "marginati", "margottati", "marimessi", "marinati", "maritati", "marmorizzati", "marnati", "marocchinati", "martellati", "martellinati", "martirizzati", "martoriati", "mascherati", "maschiati", "maschiettati", "mascolinizzati", "massacrati", "massaggiati", "massellati", "massicciati", "massificati", "massimati", "massimizzati", "mastectomizzati", "masterizzati", "masticati", "masturbati", "matematizzati", "materializzati", "matricolati", "mattonati", "maturati", "mazziati", "mazzolati", "meccanizzati", "medagliati", "mediati", "medicalizzati", "medicati", "meditati", "membrati", "memorizzati", "menati", "mendicati", "menomati", "mentovati", "menzionati", "meravigliati", "mercanteggiati", "mercerizzati", "mercificati", "meriati", "meridionalizzati", "meritati", "merlati", "merlettati", "mersi", "mesciati", "mesciuti", "mescolati", "mescuti", "mesmerizzati", "messaggiati", "messi", "messoci", "mestati", "mesticati", "mestruati", "metabolizzati", "metaforeggiati", "metaforizzati", "metallizzati", "metamorfizzati", "metamorfosati", "metanizzati", "metilati", "metodizzati", "microfilmati", "microfonati", "microminiaturizzati", "micronizzati", "mietuti", "migliorati", "militarizzati", "millantati", "millimetrati", "mimati", "mimeografati", "mimetizzati", "minacciati", "minati", "minchionati", "mineralizzati", "miniati", "miniaturizzati", "minimizzati", "minuiti", "minuzzati", "miracolati", "miscelati", "mischiati", "misconosciuti", "missati", "mistificati", "misturati", "misurati", "miticizzati", "mitigati", "mitizzati", "mitragliati", "mitrati", "mixati", "mobiliati", "mobilitati", "mobilizzati", "modanati", "modellati", "modellizzati", "moderati", "modernizzati", "modificati", "modulati", "molati", "molestati", "mollati", "molleggiati", "moltiplicati", "monacati", "mondati", "mondializzati", "monetarizzati", "monetati", "monetizzati", "monitorati", "monitorizzati", "monocromatizzati", "monopolizzati", "monottongati", "montati", "monumentalizzati", "mordenzati", "mordicchiati", "mormorati", "morphati", "morsicati", "morsicchiati", "morsi", "mortasati", "mortificati", "mossi", "mostrati", "motivati", "motorizzati", "motteggiati", "movimentati", "mozzati", "mugolati", "mulciti", "multati", "multiplexati", "mummificati", "municipalizzati", "muniti", "munti", "murati", "musati", "musicati", "mussati", "mutati", "mutilati", "mutizzati", "mutuati", "nappati", "narcotizzati", "narrativizzati", "narrati", "nasalizzati", "nascosi", "nascosti", "nastrati", "naturaleggiati", "naturalizzati", "nauseati", "naverati", "navicati", "navigati", "nazificati", "nazionalizzati", "nebulizzati", "necessitati", "necrosati", "necrotizzati", "negativizzati", "negati", "negletti", "negoziati", "negreggiati", "neologizzati", "nerbati", "nericati", "nettati", "neutralizzati", "nevati", "nevicati", "nevischiati", "nevrotizzati", "nichelati", "niellati", "ninfeggiati", "ninnati", "ninnolati", "nitratati", "nitrificati", "nobilitati", "noiati", "noleggiati", "nomati", "nominalizzati", "nominati", "normalizzati", "normati", "notati", "notificati", "notiziati", "notricati", "noverati", "nuclearizzati", "nudricati", "nullificati", "numerati", "numerizzati", "nuotati", "nutriti", "obbiettati", "obbliati", "obbligati", "oberati", "obiettati", "obiettivati", "obiettivizzati", "obiurgati", "obliati", "obliterati", "obnubilati", "occasionati", "occhieggiati", "occidentalizzati", "occisi", "occlusi", "occultati", "occupati", "ocheggiati", "odiati", "odorati", "odorizzati", "offeriti", "offerti", "offesi", "officiati", "offiziati", "offuscati", "ofiziati", "oggettivati", "oggettivizzati", "oggettualizzati", "oliati", "oliti", "olografati", "oltraggiati", "oltrapassati", "oltrepassati", "omaggiati", "ombrati", "ombreggiati", "omessi", "omogeneizzati", "omogenizzati", "omologati", "ondati", "ondulati", "onestati", "onnubilati", "onorati", "opacati", "opacizzati", "operati", "opinati", "oppiati", "oppignorati", "oppilati", "opposti", "oppressi", "oppugnati", "oprati", "opsonizzati", "optati", "opzionati", "orbitati", "orchestrati", "ordinati", "orditi", "orecchiati", "organati", "organicati", "organizzati", "orgasmati", "orientalizzati", "orientati", "originati", "origliati", "orizzontati", "orlati", "orlettati", "ormati", "ormeggiati", "ornati", "orpellati", "orrati", "orripilati", "ortogonalizzati", "osannati", "osati", "osculati", "oscurati", "ospedalizzati", "ospitati", "osseduti", "ossequiati", "osservati", "ossessionati", "ossidati", "ossificati", "ossitonizzati", "ostacolati", "osteggiati", "ostentati", "ostinati", "ostracizzati", "ostruiti", "ottemperati", "ottenebrati", "ottenuti", "ottimalizzati", "ottimati", "ottimizzati", "ottonati", "ottriati", "ottuplicati", "otturati", "ottusi", "ottussi", "ovalizzati", "ovariectomizzati", "ovattati", "overcloccati", "ovrati", "ovviati", "ozieggiati", "ozonizzati", "pacati", "pacciamati", "pacificati", "padroneggiati", "paganizzati", "pagati", "paginati", "palafittati", "palatalizzati", "palati", "palesati", "palettati", "palettizzati", "palificati", "palleggiati", "pallettizzati", "palpati", "palpeggiati", "panati", "panneggiati", "panoramicati", "pappati", "paracadutati", "parafati", "paraffinati", "parafrasati", "paragonati", "paragrafati", "paralizzati", "parallelizzati", "parametrati", "parametrizzati", "parassitati", "parati", "parcati", "parcellizzati", "parcheggiati", "pareggiati", "parificati", "parkerizzati", "parlati", "parlucchiati", "parodiati", "partecipati", "particolareggiati", "particolarizzati", "partizionati", "partoriti", "parzializzati", "pasciuti", "pascolati", "passati", "passeggiati", "passionati", "passivati", "pasticciati", "pastorizzati", "pasturati", "patinati", "patiti", "patrocinati", "patteggiati", "pattugliati", "pattuiti", "paventati", "pavesati", "pavimentati", "pavoneggiati", "pazziati", "pedinati", "pedonalizzati", "peggiorati", "pelati", "pellettizzati", "penalizzati", "penetrati", "pennellati", "pensati", "pensionati", "pentiti", "pepati", "peptonizzati", "peragrati", "percentualizzati", "percepiti", "percolati", "percorsi", "percossi", "perdonati", "perdotti", "perduti", "perequati", "perfatti", "perfezionati", "perforati", "performati", "periti", "periziati", "perlustrati", "permeati", "permessi", "perorati", "perpetrati", "perpetuati", "perplimuti", "perquisiti", "perscrutati", "perseguitati", "perseguiti", "persi", "personalizzati", "personificati", "persuasi", "perturbati", "pervasi", "pervertiti", "pesati", "pescati", "pestati", "petrarcheggiati", "pettegolati", "pettinati", "piagati", "piaggiati", "piallati", "pianeggiati", "pianificati", "piantati", "piantatali", "piantati", "pianti", "piantonati", "piantumati", "piastrellati", "piatiti", "piazzati", "picchettati", "picchiati", "picchierellati", "picchiettati", "picconati", "piegati", "pieghettati", "pietrificati", "pigiati", "pigliati", "pigmentati", "pignorati", "pigolati", "pilotati", "pimentati", "pinti", "pinzati", "piombati", "piovigginati", "piovuti", "pipati", "pippati", "piratati", "pirogenati", "pisciati", "pitoccati", "pittati", "pitturati", "pizzicati", "pizzicottati", "placati", "placcati", "plagiati", "plasmati", "plasticati", "plastificati", "platinati", "plissettati", "pluralizzati", "poetati", "poeticizzati", "poggiati", "polarizzati", "poligrafati", "polimerizzati", "politicizzati", "polverizzati", "pomiciati", "pompati", "ponderati", "ponzati", "popolarizzati", "popolati", "poppati", "porcellanati", "porfirizzati", "portati", "portesi", "porti", "porzionati", "posati", "posdatati", "positivizzati", "posizionati", "posposti", "posseduti", "postati", "postdatati", "posteggiati", "posticipati", "postillati", "posti", "postsincronizzati", "postulati", "potabilizzati", "potati", "potenziati", "potuti", "pralinati", "praticati", "preaccennati", "preannunciati", "preannunziati", "preavvertiti", "preavvisati", "precaricati", "preceduti", "precettati", "precinti", "precisati", "preclusi", "precompilati", "precompressi", "preconfezionati", "preconizzati", "preconosciuti", "precorsi", "precostituiti", "predati", "predefiniti", "predestinati", "predeterminati", "predetti", "predicati", "predigeriti", "prediletti", "predisposti", "preeletti", "preesistuti", "prefabbricati", "prefati", "prefatti", "prefazionati", "preferiti", "prefigurati", "prefinanziati", "prefissati", "prefissi", "preformati", "pregati", "pregiati", "pregiudicati", "pregustati", "preimpregnati", "prelevati", "premeditati", "premescolati", "premessi", "premiati", "premoniti", "premuniti", "premurati", "premuti", "prenotati", "preoccupati", "preordinati", "preparati", "prepensionati", "prepigmentati", "preposti", "preprogrammati", "preraffreddati", "prerefrigerati", "preregistrati", "preregolati", "preriscaldati", "presi", "presagiti", "presaputi", "presaseli", "prescelti", "prescritti", "preseduti", "presegnalati", "preselezionati", "presentati", "presentiti", "preservati", "presidiati", "presieduti", "presi", "pressati", "pressi", "pressurizzati", "prestabiliti", "prestampati", "prestati", "prestigiati", "presunti", "presupposti", "pretermessi", "pretesi", "pretrattati", "prevaricati", "preveduti", "prevenduti", "preventivati", "prevenuti", "previsti", "prezzati", "prezzolati", "principiati", "privatizzati", "privati", "privilegiati", "problematizzati", "procacciati", "processati", "proclamati", "procrastinati", "procreati", "procurati", "prodigati", "prodotti", "profanati", "proferiti", "professati", "professionalizzati", "profetati", "profetizzati", "profferiti", "profilati", "profondati", "profumati", "profusi", "progettati", "prognosticati", "programmati", "proibiti", "proiettati", "proletarizzati", "prolungati", "promanati", "promessi", "promossi", "promozionati", "promulgati", "pronosticati", "pronunciati", "pronunziati", "propagandati", "propagati", "propagginati", "propalati", "propinati", "propiziati", "proporzionati", "proposti", "propugnati", "propulsi", "prorogati", "prosciolti", "prosciugati", "proscritti", "proseguiti", "prospettati", "prosternati", "prostesi", "prostituiti", "prostrati", "prosunti", "protesi", "protestati", "protetti", "protocollati", "protonati", "protratti", "protrusi", "provati", "proveduti", "provincializzati", "provisti", "provocati", "provveduti", "provvisti", "psicanalizzati", "psichiatrizzati", "psicoanalizzati", "psicologizzati", "pubblicati", "pubblicizzati", "puddellati", "pugnalati", "puliti", "pungolati", "puniti", "puntati", "punteggiati", "puntellati", "punti", "puntualizzati", "punzecchiati", "punzonati", "purgati", "purificati", "putiti", "putrefatti", "putriti", "quadrati", "quadrettati", "quadriennalizzati", "quadruplicati", "qualificati", "quantificati", "quantizzati", "querelati", "questuati", "quetati", "quietanzati", "quietati", "quintessenziati", "quintuplicati", "quotati", "quotizzati", "rabberciati", "rabboccati", "rabboniti", "rabbuffati", "rabuffati", "raccapezzati", "raccapricciati", "raccattati", "raccerchiati", "raccesi", "racchetati", "racchiusi", "raccolti", "raccolti", "raccomandati", "raccomodati", "raccontati", "raccorciati", "raccorciti", "raccordati", "raccostati", "raccozzati", "racemizzati", "racimolati", "radazzati", "raddensati", "raddobbati", "raddolciti", "raddoppiati", "raddotti", "raddrizzati", "radiati", "radicalizzati", "radioassistiti", "radioattivati", "radiocomandati", "radiodiffusi", "radiografati", "radioguidati", "radiolocalizzati", "radiomarcati", "radiotelegrafati", "radiotrasmessi", "radunati", "raffazzonati", "raffermati", "raffigurati", "raffilati", "raffinati", "rafforzati", "raffreddati", "raffrenati", "raffrescati", "raffrontati", "raggelati", "raggentiliti", "ragghiati", "raggirati", "raggiunti", "raggiustati", "raggomitolati", "raggranchiati", "raggranchiti", "raggranellati", "raggrinzati", "raggrinziti", "raggrumati", "raggruppati", "raggruzzolati", "ragguagliati", "ralingati", "rallegrati", "rallentati", "ramati", "ramazzati", "rammagliati", "rammaricati", "rammemorati", "rammendati", "rammentati", "rammodernati", "rammolliti", "rammorbiditi", "rampognati", "randellati", "randomizzati", "rannicchiati", "rannuvolati", "ranzati", "rapati", "rapinati", "rapiti", "rappacificati", "rappati", "rappattumati", "rappezzati", "rapportati", "rappresantati", "rappresentati", "rappresi", "rarefatti", "rasati", "raschiati", "raschiettati", "rasentati", "rasi", "raspati", "rassegnati", "rasserenati", "rassettati", "rassicurati", "rassodati", "rassomigliati", "rassottigliati", "rassunti", "rastrellati", "rastremati", "rateati", "rateizzati", "ratificati", "ratinati", "rattizzati", "rattoppati", "rattorti", "rattrappiti", "rattristati", "rattristiti", "raunati", "ravvalorati", "ravveduti", "ravviati", "ravvicinati", "ravviluppati", "ravvisati", "ravvisti", "ravvivati", "ravvolti", "ravvoltolati", "razionalizzati", "razionati", "razziati", "razzolati", "realizzati", "reassunti", "recapitati", "recati", "receduti", "recensiti", "recepiti", "recidivati", "recintati", "recinti", "reciprocati", "recisi", "recitati", "reclamati", "reclamizzati", "reclinati", "reclusi", "reclutati", "recuperati", "redarguiti", "redatti", "redazzati", "redduti", "redenti", "redistribuiti", "redotti", "referenziati", "refertati", "refilati", "reflessi", "reflettuti", "refranti", "refrigerati", "regalati", "regimati", "regimentati", "regionalizzati", "registrati", "regolamentati", "regolarizzati", "regolati", "reidratati", "reificati", "reimbarcati", "reimmersi", "reimmessi", "reimparati", "reimpastati", "reimpiantati", "reimpiegati", "reimportati", "reimpostati", "reincarcerati", "reincaricati", "reincarnati", "reincisi", "reincontrati", "reindirizzati", "reindustrializzati", "reinfettati", "reingaggiati", "reinizializzati", "reinnestati", "reinoltrati", "reinscritti", "reinsediati", "reinseriti", "reinstallati", "reinstaurati", "reintegrati", "reinterpretati", "reintitolati", "reintrodotti", "reinventati", "reinvestiti", "reiterati", "relativizzati", "relazionati", "relegati", "remixati", "remunerati", "renderizzati", "reperiti", "repertati", "replicati", "repressi", "repulsi", "reputati", "requisiti", "rescissi", "resecati", "resettati", "residuati", "resinificati", "resi", "resolati", "resolti", "respinti", "respirati", "responsabilizzati", "resposti", "restaurati", "restituiti", "resunti", "resuscitati", "reticolati", "retinati", "retribuiti", "retroceduti", "retrocessi", "retrodatati", "rettificati", "retti", "reumatizzati", "revisionati", "revocati", "riabbassati", "riabbelliti", "riabbonati", "riabbottonati", "riabbracciati", "riabilitati", "riabitati", "riabituati", "riaccaduti", "riaccasati", "riaccesi", "riaccettati", "riacchiappati", "riacciuffati", "riaccolti", "riaccomodati", "riaccompagnati", "riaccordati", "riaccostati", "riaccreditati", "riacquisiti", "riacquistati", "riacutizzati", "riadattati", "riaddestrati", "riaddormentati", "riadoperati", "riaffacciati", "riaffermati", "riafferrati", "riaffiorati", "riaffittati", "riaffrontati", "riagganciati", "riaggiornati", "riaggiustati", "riaggravati", "riaggregati", "riagguantati", "rialimentati", "riallacciati", "riallargati", "riallineati", "riallocati", "riallungati", "rialzati", "riamati", "riambientati", "riammalati", "riammessi", "riammodernati", "riammogliati", "rianimati", "riannessi", "riannodati", "riannunciati", "riaperti", "riappacificati", "riappaltati", "riapparecchiati", "riappariti", "riappesi", "riappiccicati", "riapplicati", "riappresi", "riapprodati", "riappropriati", "riapprovati", "riarmati", "riarrangiati", "riarredati", "riascoltati", "riasfaltati", "riassaliti", "riassaporati", "riassegnati", "riassemblati", "riassestati", "riassettati", "riassicurati", "riassociati", "riassopiti", "riassorbiti", "riassunti", "riattaccati", "riattati", "riattesi", "riattinti", "riattivati", "riattizzati", "riattraversati", "riaumentati", "riavuti", "riavventati", "riavvertiti", "riavviati", "riavvicinati", "riavvinti", "riavvisati", "riavvistati", "riavvolti", "riazzuffati", "ribaciati", "ribaditi", "ribaltati", "ribassati", "ribattezzati", "ribattuti", "ribellati", "ribenedetti", "ribevuti", "ributtati", "ricacciati", "ricalati", "ricalcati", "ricalcificati", "ricalcitrati", "ricalcolati", "ricalibrati", "ricamati", "ricambiati", "ricanalizzati", "ricandidati", "ricantati", "ricapitalizzati", "ricapitolati", "ricaricati", "ricategorizzati", "ricattati", "ricavati", "ricelebrati", "ricercati", "ricetrasmessi", "ricettati", "ricevuti", "richiamati", "richiesti", "richiusi", "riciclati", "ricinti", "ricircolati", "riclassificati", "ricodificati", "ricollegati", "ricollocati", "ricolmati", "ricolonizzati", "ricolorati", "ricoloriti", "ricoltivati", "ricombinati", "ricominciati", "ricommessi", "ricompariti", "ricompattati", "ricompensati", "ricomperati", "ricompilati", "ricompiuti", "ricomposti", "ricomprati", "ricompressi", "ricomunicati", "riconceduti", "riconcessi", "riconciliati", "ricondizionati", "ricondotti", "riconfermati", "riconfezionati", "riconfigurati", "riconfortati", "riconfusi", "ricongelati", "ricongiunti", "riconnessi", "riconosciuti", "riconquistati", "riconsacrati", "riconsegnati", "riconsiderati", "riconsigliati", "riconsolati", "ricontati", "ricontattati", "ricontrattati", "ricontratti", "ricontrollati", "riconvalidati", "riconvenuti", "riconvertiti", "riconvinti", "riconvocati", "riconvogliati", "ricoperti", "ricopiati", "ricordati", "ricoricati", "ricorretti", "ricosparsi", "ricostituiti", "ricostretti", "ricostruiti", "ricotti", "ricoverati", "ricreati", "ricristallizzati", "ricrocifissi", "ricuciti", "ricuperati", "ricusati", "ridati", "ridecorati", "ridefiniti", "ridenominati", "ridestati", "rideterminati", "ridetti", "ridicolizzati", "ridigitati", "ridimensionati", "ridipinti", "ridiscesi", "ridisciolti", "ridisciplinati", "ridiscussi", "ridisegnati", "ridisfatti", "ridisposti", "ridistesi", "ridistinti", "ridistribuiti", "ridivisi", "ridomandati", "ridonati", "ridondati", "ridorati", "ridotati", "ridotti", "ridovuti", "riecheggiati", "riedificati", "rieducati", "rielaborati", "rieletti", "riemessi", "riempiti", "riempiuti", "rientrati", "riepilogati", "riequilibrati", "riequipaggiati", "riesaminati", "rieseguiti", "riesercitati", "riesplosi", "riesportati", "riesposti", "riespressi", "riespulsi", "riestesi", "riesumati", "rietichettati", "rievaporati", "rievocati", "rifabbricati", "rifasciati", "rifatti", "rifenduti", "riferiti", "rifermati", "rifermentati", "rifessi", "rificcati", "rifilati", "rifiltrati", "rifinanziati", "rifiniti", "rifirmati", "rifischiati", "rifissi", "rifiutati", "riflessi", "riflettuti", "rifocillati", "rifoderati", "rifondati", "riforestati", "riforgiati", "riformati", "riformattati", "riformulati", "riforniti", "rifranti", "rifritti", "rifrugati", "rifuggiti", "rifugiati", "rifusi", "rigassificati", "rigati", "rigelati", "rigenerati", "rigettati", "righettati", "rigiocati", "rigirati", "rigiudicati", "rigiunti", "rigoduti", "rigonfiati", "rigovernati", "riguadagnati", "riguardati", "rigurgitati", "rilanciati", "rilasciati", "rilassati", "rilavati", "rilavorati", "rilegati", "riletti", "rilevati", "rilocalizzati", "rimagliati", "rimandati", "rimaneggiati", "rimangiati", "rimappati", "rimarcati", "rimarchiati", "rimarginati", "rimaritati", "rimasticati", "rimati", "rimbacuccati", "rimbaldanziti", "rimbarcati", "rimbeccati", "rimbecilliti", "rimbelliti", "rimbiancati", "rimbionditi", "rimboccati", "rimbombati", "rimborsati", "rimboscati", "rimboschiti", "rimbrottati", "rimediati", "rimembrati", "rimemorati", "rimenati", "rimeritati", "rimescolati", "rimessi", "rimestati", "rimilitarizzati", "rimirati", "rimischiati", "rimisurati", "rimodellati", "rimodernati", "rimodulati", "rimondati", "rimontati", "rimorchiati", "rimorsi", "rimossi", "rimostrati", "rimotivati", "rimpacchettati", "rimpadroniti", "rimpaginati", "rimpagliati", "rimpannucciati", "rimpastati", "rimpatriati", "rimpiallacciati", "rimpianti", "rimpiattati", "rimpiazzati", "rimpiccioliti", "rimpiccoliti", "rimpiegati", "rimpinguati", "rimpinzati", "rimpolpati", "rimpossessati", "rimpressi", "rimproverati", "rimuginati", "rimunerati", "rimunti", "rimusicati", "rimutati", "rinarrati", "rinascosti", "rincalcati", "rincalzati", "rincamminati", "rincantucciati", "rincarati", "rincarcerati", "rincarnati", "rincentrati", "rinchiesti", "rinchiodati", "rinchiusi", "rincitrulliti", "rinciviliti", "rincoglioniti", "rincollati", "rincominciati", "rincontrati", "rincoraggiati", "rincorati", "rincorporati", "rincorsi", "rincretiniti", "rincruditi", "rinculcati", "rincuorati", "rindossati", "rinduriti", "rinegoziati", "rinfacciati", "rinfagottati", "rinfiammati", "rinfiancati", "rinfilati", "rinfittiti", "rinfocolati", "rinfoderati", "rinforzati", "rinfrancati", "rinfranti", "rinfrescati", "rinfusi", "ringagliarditi", "ringalluzziti", "ringiovaniti", "ringioveniti", "ringoiati", "ringorgati", "ringraziati", "ringuainati", "rinnamorati", "rinnegati", "rinnestati", "rinnovati", "rinnovellati", "rinociuti", "rinomati", "rinominati", "rinormalizzati", "rinquadrati", "rinsaccati", "rinsaldati", "rinsanguati", "rinselvatichiti", "rinselvati", "rinserrati", "rintanati", "rintasati", "rintascati", "rintavolati", "rinteneriti", "rinterrati", "rinterrogati", "rintesi", "rintiepiditi", "rintoccati", "rintonacati", "rintontiti", "rintorpiditi", "rintracciati", "rintrodotti", "rintronati", "rintuzzati", "rinunciati", "rinunziati", "rinutriti", "rinvangati", "rinvasati", "rinvenuti", "rinverditi", "rinvestiti", "rinviati", "rinvigoriti", "rinviliti", "rinvitati", "rinvoltati", "rinvolti", "rinvoltolati", "rinzaffati", "rinzeppati", "riobbligati", "rioccupati", "riofferti", "rioffesi", "rioperati", "riordinati", "riorganizzati", "riorientati", "riosservati", "riottenuti", "riottimizzati", "riotturati", "ripagati", "riparametrizzati", "riparati", "ripartiti", "ripassati", "ripercorsi", "ripercossi", "riperduti", "ripersi", "ripesati", "ripescati", "ripestati", "ripetuti", "ripianati", "ripianificati", "ripiantati", "ripianti", "ripicchiati", "ripiegati", "ripigliati", "ripinti", "ripiovuti", "ripitturati", "riplasmati", "ripolarizzati", "ripopolati", "riportati", "riporti", "riposati", "riposizionati", "riposseduti", "riposti", "ripotuti", "ripresentati", "ripresi", "riprestati", "ripretesi", "riprincipiati", "ripristinati", "riprivatizzati", "riprodotti", "riprogettati", "riprogrammati", "ripromessi", "riproposti", "riprotetti", "riprovati", "riprovveduti", "riprovvisti", "ripubblicati", "ripudiati", "ripugnati", "ripuliti", "ripuntati", "ripunti", "ripurgati", "riputati", "riquadrati", "riqualificati", "riresi", "rirotti", "risaldati", "risaliti", "risaltati", "risalutati", "risanati", "risaputi", "risarciti", "riscalati", "riscaldati", "riscattati", "riscelti", "riscesi", "rischiarati", "rischiati", "risciacquati", "risciolti", "riscommessi", "riscontati", "riscontrati", "risconvolti", "riscoperti", "riscoppiati", "riscorsi", "riscossi", "riscritti", "risecati", "riseduti", "risegati", "risegnati", "riselciati", "riselezionati", "riseminati", "risentiti", "riseppelliti", "riserbati", "riservati", "risicati", "risigillati", "risistemati", "risi", "risoffiati", "risoggiunti", "risolati", "risolidificati", "risollevati", "risolti", "risommati", "risommersi", "risonati", "risorpassati", "risospesi", "risospinti", "risottomessi", "risparmiati", "risparsi", "rispecchiati", "rispediti", "rispenti", "rispersi", "rispettati", "rispiegati", "rispinti", "rispolverati", "risposati", "risposti", "rissati", "ristabiliti", "ristagnati", "ristampati", "ristaurati", "ristesi", "ristilizzati", "ristorati", "ristretti", "ristrutti", "ristrutturati", "ristuccati", "ristudiati", "risucchiati", "risultati", "risuolati", "risuonati", "risuscitati", "risvegliati", "risvolti", "ritagliati", "ritarati", "ritardati", "ritemprati", "ritentati", "ritenuti", "ritersi", "ritesi", "ritinti", "ritirati", "ritoccati", "ritolti", "ritorti", "ritracciati", "ritradotti", "ritrascorsi", "ritrascritti", "ritrasferiti", "ritrasformati", "ritrasmessi", "ritrasposti", "ritrattati", "ritratti", "ritrovati", "ritualizzati", "rituffati", "riuditi", "riunificati", "riuniti", "riusati", "riutilizzati", "rivaccinati", "rivaleggiati", "rivalorizzati", "rivalsi", "rivalutati", "rivangati", "riveduti", "rivelati", "rivendicati", "rivenduti", "riverberati", "riveriti", "riverniciati", "riversati", "rivestiti", "rivettati", "rivinti", "rivisitati", "rivissuti", "rivisti", "rivitalizzati", "rivivificati", "rivoltati", "rivolti", "rivoltolati", "rivoluti", "rivoluzionati", "rizappati", "rizzati", "robotizzati", "rodati", "rogati", "rollati", "romanizzati", "romanticizzati", "romanzati", "roncolati", "rosicati", "rosicchiati", "rosi", "rosolati", "rotacizzati", "rotati", "roteati", "rotolati", "rottamati", "rotti", "rovesciati", "rovinati", "rovistati", "rubacchiati", "rubati", "rullati", "ruminati", "ruotati", "russificati", "ruzzolati", "sabbiati", "sabotati", "saccarificati", "saccheggiati", "sacralizzati", "sacramentati", "sacrificati", "saettati", "saggiati", "sagginati", "sagomati", "salamoiati", "salariati", "salassati", "salati", "saldati", "salificati", "salinizzati", "saliti", "salmeggiati", "salmistrati", "salpati", "saltati", "salutati", "salvaguardati", "salvati", "sanati", "sanciti", "sanforizzati", "sanificati", "sanitizzati", "santificati", "sanzionati", "saponificati", "saputi", "sarchiati", "sarchiellati", "sartiati", "satellizzati", "satinati", "satireggiati", "satisfatti", "satollati", "saturati", "saziati", "sbaccellati", "sbaciucchiati", "sbafati", "sbaffati", "sbalestrati", "sballati", "sballottati", "sballottolati", "sbalorditi", "sbalzati", "sbancati", "sbandati", "sbandierati", "sbanditi", "sbaraccati", "sbaragliati", "sbarazzati", "sbarbati", "sbarcati", "sbardati", "sbarrati", "sbassati", "sbastiti", "sbatacchiati", "sbattezzati", "sbattuti", "sbeccati", "sbeffeggiati", "sbellicati", "sbendati", "sbertucciati", "sbiaditi", "sbiancati", "sbianchiti", "sbiellati", "sbiettati", "sbigottiti", "sbilanciati", "sbirbati", "sbirciati", "sbizzarriti", "sbloccati", "sbobinati", "sboccati", "sbocconcellati", "sbollentati", "sbolognati", "sborniati", "sborsati", "sboscati", "sbottonati", "sbozzati", "sbozzimati", "sbozzolati", "sbracati", "sbracciati", "sbraciati", "sbraitati", "sbranati", "sbrancati", "sbrattati", "sbreccati", "sbriciolati", "sbrigati", "sbrigliati", "sbrinati", "sbrindellati", "sbrodolati", "sbrogliati", "sbronzati", "sbruffati", "sbucciati", "sbudellati", "sbuffati", "sbugiardati", "sbullettati", "sbullonati", "sburrati", "scacazzati", "scacchiati", "scacciati", "scaccolati", "scadenzati", "scafati", "scaffalati", "scagionati", "scagliati", "scaglionati", "scalati", "scalcati", "scalcinati", "scaldati", "scalettati", "scalfati", "scalfiti", "scalmanati", "scaloppati", "scalpati", "scalpellati", "scalpellinati", "scaltriti", "scalzati", "scambiati", "scamiciati", "scamosciati", "scamozzati", "scampati", "scampatali", "scampati", "scamuffati", "scanalati", "scancellati", "scandagliati", "scandalizzati", "scanditi", "scannati", "scannellati", "scannerati", "scannerizati", "scannerizzati", "scansati", "scansionati", "scapecchiati", "scapezzati", "scapicollati", "scapigliati", "scapitozzati", "scapocchiati", "scappati", "scappellati", "scappottati", "scapricciati", "scapsulati", "scarabocchiati", "scaracchiati", "scaraventati", "scarcerati", "scardassati", "scardati", "scardinati", "scaricati", "scarificati", "scarmigliati", "scarnati", "scarnificati", "scarniti", "scarrellati", "scarrocciati", "scarrozzati", "scarruffati", "scartabellati", "scartati", "scartavetrati", "scartinati", "scartocciati", "scassati", "scassinati", "scatenati", "scattati", "scavalcati", "scavallati", "scavati", "scavezzati", "scazzottati", "scekerati", "scelti", "scempiati", "sceneggiati", "scernuti", "scervellati", "scesi", "sceverati", "schedati", "schedulati", "scheggiati", "scheletriti", "schematizzati", "schermati", "schermiti", "schermografati", "scherniti", "schiacciati", "schiaffati", "schiaffeggiati", "schiantati", "schiariti", "schiavardati", "schiavizzati", "schiccherati", "schierati", "schifati", "schinciati", "schioccati", "schiodati", "schiumati", "schiusi", "schivati", "schizzati", "schizzettati", "sciabolati", "sciabordati", "sciacquati", "scialacquati", "sciamanizzati", "sciamannati", "sciancati", "sciancrati", "scimmieggiati", "scimmiottati", "scinti", "scioccati", "sciolinati", "sciolti", "sciorinati", "scippati", "sciroppati", "scissi", "sciupacchiati", "sciupati", "sclamati", "sclerosati", "sclerotizzati", "scoccati", "scocciati", "scodati", "scodellati", "scoiati", "scolarizzati", "scolati", "scollacciati", "scollati", "scollegati", "scolorati", "scoloriti", "scolpati", "scolpiti", "scombaciati", "scombinati", "scombussolati", "scommessi", "scomodati", "scompaginati", "scompagnati", "scompartiti", "scompattati", "scompensati", "scompiacuti", "scompigliati", "scomposti", "scomputati", "scomunicati", "sconcertati", "sconciati", "sconclusi", "sconfessati", "sconficcati", "sconﬁtti", "sconfortati", "sconfusi", "scongelati", "scongiurati", "sconnessi", "sconosciuti", "sconquassati", "sconsacrati", "sconsigliati", "sconsolati", "scontati", "scontentati", "scontornati", "scontorti", "scontrati", "sconvolti", "scopati", "scoperchiati", "scoperti", "scopiazzati", "scoraggiati", "scoraggiti", "scorati", "scorazzati", "scorciati", "scorciti", "scordati", "scoreggiati", "scorificati", "scornati", "scorniciati", "scoronati", "scorporati", "scorrazzati", "scorreggiati", "scorretti", "scorsi", "scortati", "scortecciati", "scorticati", "scorti", "scorzati", "scoscesi", "scosciati", "scossi", "scostati", "scostolati", "scotennati", "scoticati", "scotolati", "scotomizzati", "scottati", "scotti", "scovati", "scoverti", "scozzati", "scozzonati", "screditati", "scremati", "screpolati", "screziati", "scribacchiati", "scriminati", "scristianizzati", "scritti", "scritturati", "scroccati", "scrocchiati", "scrollati", "scrostati", "scrutati", "scrutinati", "scuciti", "scudisciati", "scuffiati", "sculacciati", "sculettati", "scuoiati", "scuriosati", "scuriti", "scusati", "sdaziati", "sdebitati", "sdegnati", "sdemanializzati", "sdentati", "sdilinquiti", "sdoganati", "sdoluti", "sdoppiati", "sdraiati", "sdrammatizzati", "sdruciti", "secati", "seccati", "secernuti", "secolarizzati", "secondati", "secretati", "secreti", "sedati", "sedentarizzati", "sedotti", "segati", "seghettati", "segmentati", "segnalati", "segnati", "segnoreggiati", "segregati", "segretati", "seguitati", "seguiti", "selciati", "selezionati", "sellati", "sembrati", "sementati", "semicinti", "seminati", "semplificati", "senilizzati", "sensibilizzati", "sensorizzati", "sentenziati", "sentiti", "sentitaseli", "sentiti", "sentiti", "separati", "sepolti", "seppelliti", "sequenziati", "sequestrati", "serbati", "serrati", "serviti", "servoassistiti", "sessualizzati", "sestuplicati", "setacciati", "setificati", "settati", "settorializzati", "settuplicati", "seviziati", "sezionati", "sfaccettati", "sfagliati", "sfaldati", "sfalsati", "sfamati", "sfanalati", "sfangati", "sfarinati", "sfasati", "sfasciati", "sfatati", "sfatti", "sfavillati", "sfavoriti", "sfegatati", "sfeltrati", "sfenduti", "sferragliati", "sferrati", "sferzati", "sfessi", "sfiancati", "sfiatati", "sfiati", "sfibbiati", "sfibrati", "sfidati", "sfiduciati", "sfigurati", "sfilati", "sfilettati", "sfiniti", "sfioccati", "sfiorati", "sfittati", "sfocati", "sfociati", "sfoderati", "sfogati", "sfoggiati", "sfogliati", "sfollati", "sfoltiti", "sfondati", "sforacchiati", "sforati", "sforbiciati", "sformati", "sfornaciati", "sfornati", "sforniti", "sforzati", "sfottuti", "sfracellati", "sfrangiati", "sfrascati", "sfratati", "sfrattati", "sfrecciati", "sfregati", "sfregiati", "sfrenati", "sfrisati", "sfrondati", "sfrucugliati", "sfruculiati", "sfruttati", "sfumati", "sfuocati", "sgamati", "sganasciati", "sganciati", "sgarbugliati", "sgattaiolati", "sgelati", "sghiacciati", "sgocciolati", "sgolati", "sgomberati", "sgombrati", "sgomentati", "sgominati", "sgomitati", "sgomitolati", "sgonfiati", "sgorbiati", "sgottati", "sgovernati", "sgozzati", "sgraffiati", "sgraffignati", "sgranati", "sgranchiti", "sgranellati", "sgrassati", "sgravati", "sgretolati", "sgridati", "sgrommati", "sgrondati", "sgroppati", "sgrossati", "sgrovigliati", "sgrugnati", "sguainati", "sgualciti", "sguanciati", "sguarniti", "sguinzagliati", "sgusciati", "shakerati", "shoccati", "shuntati", "sigillati", "siglati", "significati", "signoreggiati", "silenziati", "silicizzati", "sillabati", "sillogizzati", "silurati", "simboleggiati", "simbolizzati", "simmetrizzati", "simpatizzati", "simulati", "sincerati", "sincopati", "sincretizzati", "sincronizzati", "sindacalizzati", "sindacati", "singolarizzati", "sinistrati", "sinizzati", "sinterizzati", "sintetizzati", "sintonizzati", "siringati", "sistematizzati", "sistemati", "situati", "slabbrati", "slacciati", "slamati", "slanciati", "slappolati", "slargati", "slavizzati", "slegati", "slentati", "slinguati", "slogati", "sloggati", "sloggiati", "slombati", "slungati", "smaccati", "smacchiati", "smagliati", "smagnetizzati", "smagriti", "smaliziati", "smallati", "smaltati", "smaltiti", "smammati", "smanacciati", "smangiati", "smantellati", "smarcati", "smarginati", "smarriti", "smascellati", "smascherati", "smaterializzati", "smattonati", "smembrati", "smentiti", "smerciati", "smerdati", "smerigliati", "smerlati", "smerlettati", "smessali", "smessi", "smezzati", "smidollati", "smielati", "smilitarizzati", "sminati", "sminuiti", "sminuzzati", "smistati", "smitizzati", "smobiliati", "smobilitati", "smobilizzati", "smoccolati", "smollicati", "smonacati", "smontati", "smorbati", "smorzati", "smossi", "smozzicati", "smunti", "smurati", "smussati", "smutandati", "snaturati", "snazionalizzati", "snebbiati", "snelliti", "snervati", "snidati", "sniffati", "snobbati", "snocciolati", "snodati", "snudati", "sobbarcati", "sobbolliti", "sobillati", "socchiusi", "soccorsi", "soddisfatti", "sodisfatti", "sodomizzati", "sofferiti", "soffermati", "sofferti", "soffiati", "soffocati", "soffregati", "soffritti", "soffusi", "sofisticati", "soggettivati", "soggettivizzati", "sogghignati", "soggiogati", "soggiunti", "sogguardati", "sognati", "solarizzati", "solcati", "soleggiati", "solennizzati", "solfeggiati", "solfitati", "solfonati", "solforati", "solidificati", "soliti", "sollazzati", "sollecitati", "solleticati", "sollevati", "solti", "solubilizzati", "soluti", "soluzionati", "solvatati", "somatizzati", "someggiati", "somigliati", "sommati", "sommersi", "sommessi", "somministrati", "sommossi", "sonati", "sondati", "sonorizzati", "sopiti", "soppalcati", "soppesati", "soppiantati", "sopportati", "sopposti", "soppressi", "sopraddotati", "sopraeccitati", "sopraedificati", "sopraelevati", "sopraffati", "sopraffatti", "sopraggiunti", "sopraintesi", "soprammessi", "soprannominati", "sopraposti", "soprappresi", "soprascritti", "sopraspesi", "soprassaturati", "soprasseduti", "sopravanzati", "sopravvalutati", "sopravveduti", "sopravvinti", "sopravvisti", "sopreccitati", "sopredificati", "soprelevati", "soprintesi", "sorbettati", "sorbiti", "sorgiunti", "sormontati", "sorpassati", "sorpresi", "sorrasi", "sorretti", "sorseggiati", "sorteggiati", "sortiti", "sorvegliati", "sorvolati", "soscritti", "sospesi", "sospettati", "sospinti", "sospirati", "sostantivati", "sostanziati", "sostentati", "sostenuti", "sostituiti", "sottaciuti", "sotterrati", "sottesi", "sottintesi", "sottoalimentati", "sottocapitalizzati", "sottodivisi", "sottoesposti", "sottofirmati", "sottolineati", "sottomessi", "sottomurati", "sottopagati", "sottopassati", "sottoposti", "sottorappresentati", "sottorisi", "sottoscritti", "sottostimati", "sottosviluppati", "sottotitolati", "sottovalutati", "sottratti", "soverchiati", "sovesciati", "sovietizzati", "sovracapitalizzati", "sovraccaricati", "sovradimensionati", "sovraeccitati", "sovraesposti", "sovraffaticati", "sovraffollati", "sovraggiunti", "sovraimposti", "sovraintesi", "sovralimentati", "sovramodulati", "sovrappopolati", "sovrapposti", "sovrariscaldati", "sovrasaturati", "sovrascritti", "sovrastampati", "sovrastati", "sovrastimati", "sovrautilizzati", "sovreccitati", "sovresposti", "sovrimposti", "sovrintesi", "sovvenuti", "sovvenzionati", "sovvertiti", "spaccati", "spacchettati", "spacciati", "spaginati", "spaiati", "spalancati", "spalati", "spalcati", "spalleggiati", "spalmati", "spammati", "spampanati", "spampinati", "spanati", "spanciati", "spanduti", "spannati", "spannocchiati", "spansi", "spantanati", "spanti", "spaparacchiati", "spaparanzati", "spappolati", "sparati", "sparecchiati", "sparigliati", "spariti", "sparlati", "sparpagliati", "spartiti", "spassati", "spassatoseli", "spastoiati", "spaurati", "spauriti", "spaventati", "spazializzati", "spaziati", "spazieggiati", "spazientiti", "spazzati", "spazzolati", "specchiati", "specializzati", "specificati", "specillati", "specolati", "spediti", "spegnati", "spelacchiati", "spelati", "spellati", "spennacchiati", "spennati", "spennellati", "spenti", "spenzolati", "sperati", "sperimentati", "spernacchiati", "speronati", "sperperati", "spersonalizzati", "sperticati", "spesati", "spesi", "spessiti", "spettacolarizzati", "spettinati", "spezzati", "spezzettati", "spezziati", "spezzonati", "spiaccicati", "spianati", "spiantati", "spiati", "spiattellati", "spiazzati", "spiccati", "spicciati", "spiccicati", "spicciolati", "spicconati", "spidocchiati", "spiegati", "spiegazzati", "spietrati", "spifferati", "spigionati", "spignorati", "spigolati", "spigriti", "spillati", "spilluzzicati", "spiluccati", "spinti", "spintonati", "spiombati", "spiralizzati", "spirantizzati", "spirati", "spiritualizzati", "spiumati", "spizzicati", "spodestati", "spoetizzati", "spogliati", "spolettati", "spoliati", "spoliticizzati", "spollonati", "spolmonati", "spolpati", "spoltroniti", "spolverati", "spolverizzati", "spompati", "spompinati", "sponsorizzati", "spopolati", "spoppati", "sporcati", "sportati", "sporti", "sposati", "sposseduti", "spossessati", "spostati", "sposti", "sprangati", "sprecati", "spregiati", "spremuti", "spretati", "sprezzati", "sprigionati", "sprimacciati", "spromessi", "spronati", "sprotetti", "sprovincializzati", "sprovveduti", "sprovvisti", "spruzzati", "spugnati", "spulati", "spulciati", "spuntati", "spuntellati", "spupazzati", "spurgati", "sputacchiati", "sputati", "sputtanati", "squadernati", "squadrati", "squagliati", "squagliataseli", "squagliati", "squalificati", "squamati", "squarciati", "squartati", "squassati", "squattrinati", "squilibrati", "squinternati", "sradicati", "srotolati", "srugginiti", "stabbiati", "stabiliti", "stabilizzati", "stabulati", "staccati", "stacciati", "staffati", "staffilati", "staggiati", "staggiti", "stagionati", "stagliati", "stagnati", "stamburati", "stampati", "stampigliati", "stanati", "stancati", "standardizzati", "stangati", "stanziati", "stappati", "starati", "starnazzati", "stasati", "statalizzati", "statizzati", "statoci", "statoseni", "statuiti", "stazzati", "stazzonati", "steccacciati", "steccati", "stecchiti", "stecconati", "stemperati", "stempiati", "stenografati", "stereotipati", "steriliti", "sterilizzati", "sterpati", "sterrati", "sterzati", "stesi", "stigliati", "stigmatizzati", "stilati", "stilettati", "stilizzati", "stillati", "stimati", "stimolati", "stinti", "stipati", "stipendiati", "stipulati", "stiracchiati", "stirati", "stivati", "stizziti", "stoccati", "stolti", "stomacati", "stonati", "stondati", "stoppati", "storditi", "storicizzati", "stornati", "storpiati", "stortati", "storti", "stozzati", "strabenedetti", "strabuzzati", "stracannati", "straccati", "stracciati", "stracotti", "strafogati", "stragoduti", "stralciati", "stralodati", "stralunati", "stramaledetti", "stramortiti", "strangolati", "straniati", "straniti", "straorzati", "strapagati", "strapazzati", "straperduti", "strapersi", "strappati", "strasaputi", "strascicati", "strascinati", "strasformati", "stratificati", "strattonati", "stravaccati", "stravinti", "stravolti", "stravoluti", "straziati", "stregati", "stremati", "stressati", "striati", "stridulati", "strigati", "strigliati", "strillati", "striminziti", "strimpellati", "strinati", "stringati", "strisciati", "stritolati", "strizzati", "strofinati", "strombati", "strombazzati", "stroncati", "stronzati", "stropicciati", "stroppati", "stroppiati", "strozzati", "struccati", "strumentalizzati", "strumentati", "strusciati", "strutti", "strutturalizzati", "strutturati", "stuccati", "studiacchiati", "studiati", "stuellati", "stufati", "stupefatti", "stupiti", "stuprati", "sturati", "stutati", "stuzzicati", "suasi", "subaffittati", "subappaltati", "subbiati", "subdelegati", "subissati", "subiti", "sublicenziati", "sublimati", "sublocati", "subodorati", "subordinati", "subornati", "suburbanizzati", "sucati", "succhiati", "succhiellati", "succiati", "succinti", "succisi", "suddistinti", "suddivisi", "suffissati", "suffissi", "suffragati", "suffumicati", "suffusi", "suggellati", "suggeriti", "suggestionati", "suicidati", "sunteggiati", "sunti", "suolati", "suonati", "superati", "superpagati", "superraffreddati", "supervalutati", "supervisionati", "supplicati", "suppliti", "supportati", "supposti", "suppurati", "surclassati", "surfati", "surgelati", "surraffreddati", "surriscaldati", "surrogati", "survoltati", "suscitati", "susseguiti", "sussidiati", "sussunti", "sussurrati", "suturati", "svaccati", "svagati", "svaligiati", "svalutati", "svapati", "svariati", "svasati", "svecchiati", "svegliati", "svelati", "sveleniti", "sveltiti", "svelti", "svenati", "svenduti", "sventagliati", "sventati", "sventolati", "sventrati", "sverginati", "svergognati", "svergolati", "sverminati", "sverniciati", "svestiti", "svettati", "svezzati", "sviati", "svignatoseli", "svigoriti", "sviliti", "svillaneggiati", "sviluppati", "svinati", "svincolati", "sviolinati", "svirgolati", "svirilizzati", "svisati", "sviscerati", "svitati", "sviticchiati", "svolati", "svolazzati", "svolti", "svoluti", "svuotati", "tabuizzati", "tabulati", "taccati", "taccheggiati", "tacciati", "tacitati", "taciuti", "tagliati", "taglieggiati", "tagliuzzati", "talebanizzati", "tallonati", "tampinati", "tamponati", "tanguti", "tannati", "tappati", "tappezzati", "tarati", "tardati", "targati", "tariffati", "tarlati", "tarmati", "taroccati", "tarpati", "tartagliati", "tartassati", "tartufati", "tassati", "tassellati", "tastati", "tasteggiati", "tatuati", "tecnicizzati", "tecnologizzati", "tedeschizzati", "tediati", "teflonati", "telecomandati", "telecontrollati", "telediffusi", "telefonati", "telegrafati", "teleguidati", "telematizzati", "telemetrati", "teleradiotrasmessi", "teletrasmessi", "teletrasportati", "tematizzati", "temperati", "tempestati", "tempificati", "templatizzati", "temporizzati", "temprati", "temuti", "tentati", "tenuti", "teologizzati", "teorizzati", "tepefatti", "terebrati", "terminati", "termostatati", "terrazzati", "terrificati", "terrorizzati", "tersi", "terzarolati", "terziarizzati", "terziati", "tesati", "tesaurizzati", "tesi", "tesserati", "testati", "testificati", "testimoniati", "timbrati", "tindalizzati", "tinteggiati", "tinti", "tipicizzati", "tipizzati", "tippati", "tiranneggiati", "tirati", "titillati", "titolati", "toccati", "toelettati", "tollerati", "tolti", "tonalizzati", "tonificati", "tonneggiati", "tonsurati", "torchiati", "tormentati", "tornatoseni", "torniti", "torrefatti", "torti", "tortoreggiati", "torturati", "tosati", "toscaneggiati", "toscanizzati", "tostati", "totalizzati", "traboccati", "trabuccati", "tracannati", "tracciati", "traditi", "tradotti", "trafficati", "trafilati", "trafitti", "traforati", "trafugati", "traghettati", "traguardati", "trainati", "tralasciati", "tralignati", "tramandati", "tramati", "trambasciati", "tramessi", "tramestati", "tramezzati", "tramortiti", "tramutati", "tranciati", "trangugiati", "tranquillati", "tranquillizzati", "transatti", "transcesi", "transcodificati", "transcorsi", "transcritti", "transennati", "transfluiti", "transfusi", "transistorizzati", "translitterati", "transposti", "transricevuti", "transustanziati", "transveduti", "transvisti", "trapanati", "trapassati", "trapiantati", "traportati", "traposti", "trapposti", "trapuntati", "trapunti", "trarotti", "trasandati", "trasbordati", "trascelti", "trascesi", "trascinati", "trascorsi", "trascritti", "trascurati", "trasdotti", "trasferiti", "trasfigurati", "trasformati", "trasfusi", "trasgrediti", "traslati", "traslitterati", "traslocati", "trasmessi", "trasmutati", "traspariti", "traspirati", "trasportati", "trasposti", "trastullati", "trasudati", "trasvolati", "trasvolti", "trattati", "tratteggiati", "trattenuti", "tratti", "traumatizzati", "travagliati", "travalicati", "travasati", "traveduti", "traversati", "travestiti", "traviati", "travisati", "travisti", "travolti", "trebbiati", "triangolati", "tribbiati", "tribolati", "tributati", "triennalizzati", "trimestralizzati", "trincati", "trincerati", "trinciati", "tripartiti", "triplicati", "trisecati", "trisezionati", "tritati", "triturati", "trivellati", "trollati", "trombati", "troncati", "tropicalizzati", "trovati", "truccati", "trucidati", "truffati", "tuffati", "tumefatti", "tumulati", "turati", "turbati", "turlupinati", "tutelati", "ubbligati", "ubicati", "ubiditi", "ubiquitinati", "ubriacati", "uccellati", "uccellinati", "uccisi", "uditi", "ufficializzati", "uggiti", "ugnati", "uguagliati", "ulcerati", "uliti", "ulolati", "ultimati", "ultracentrifugati", "ululati", "umanati", "umanizzati", "umettati", "umidificati", "umiditi", "umiliati", "uncinati", "unguentati", "unificati", "uniformati", "uniti", "univerbati", "universaleggiati", "universalizzati", "untati", "unti", "uperizzati", "urbanizzati", "urgenzati", "urlati", "urtacchiati", "urtati", "urticchiati", "usati", "usciolati", "usolati", "ustionati", "usucapiti", "usurati", "usurpati", "utilitati", "utilizzati", "vaccinati", "vagabondeggiati", "vagellati", "vagheggiati", "vagillati", "vagliati", "valcati", "valicati", "validati", "valorizzati", "valsi", "valutati", "vanagloriati", "vanati", "vandalizzati", "vangati", "vangelizzati", "vanificati", "vaniti", "vantaggiati", "vantati", "vaporati", "vaporizzati", "varati", "varcati", "variati", "vasectomizzati", "vaticinati", "vedovati", "veduti", "vegetati", "veggiati", "vegliati", "veicolati", "velarizzati", "velati", "velettati", "velinati", "vellicati", "vellutati", "velocizzati", "vendemmiati", "vendicati", "vendicchiati", "venducchiati", "venduti", "venerati", "vengiati", "ventagliati", "ventilati", "ventolati", "verbalizzati", "vergati", "vergheggiati", "vergognati", "vergolati", "verificati", "verminati", "vernalizzati", "verniciati", "verrinati", "versati", "verseggiati", "versificati", "verticalizzati", "vessati", "vestiti", "vestiti", "vetrificati", "vetrinati", "vetrioleggiati", "vettovagliati", "vezzeggiati", "viaggiati", "vicinati", "vicitati", "videochattati", "videochiamati", "videocomunicati", "videoregistrati", "videotrasmessi", "vidimati", "vigilati", "vigliati", "vigoreggiati", "vigoriti", "vilificati", "vilipesi", "villaneggiati", "vincolati", "vinti", "violati", "violentati", "violinati", "virgolati", "virgoleggiati", "virgolettati", "virilizzati", "virtualizzati", "visionati", "visitati", "vissuti", "vistati", "visti", "visualizzati", "vitaliziati", "vitalizzati", "vitaminizzati", "vittimizzati", "vituperati", "vivacizzati", "vivandati", "vivificati", "vivisezionati", "viziati", "vocabolarizzati", "vocalizzati", "vocati", "vociferati", "volantinati", "volatilizzati", "volgarizzati", "volicchiati", "volpeggiati", "voltati", "volti", "voltolati", "volturati", "voluminizzati", "voluti", "volutoci", "vomitati", "vorati", "votati", "vulcanizzati", "vuotati", "wappati", "wikificati", "xerocopiati", "zaffati", "zampati", "zampettati", "zampillati", "zannati", "zappati", "zappettati", "zapponati", "zavorrati", "zeppati", "zigrinati", "zigzagati", "zimbellati", "zincati", "zinnati", "zipolati", "zippati", "zirlati", "zittiti", "zizzagati", "zoccolati", "zollati", "zombati", "zonati", "zonizzati", "zoppati", "zoppeggiati", "zoppicati", "zucconati", "zufolati", "zumati", "zuppati"];
};

var irregulars$1 = {};

Object.defineProperty(irregulars$1, "__esModule", {
	value: true
});

irregulars$1.default = function () {
	return ["aaneengedraaid", "aaneengeschakeld", "aanschouwd", "aanvaard", "achtergebleven", "achtergelaten", "achterhaald", "achteromgekeken", "achteropgekomen", "achteruitgegaan", "achtervolgd", "ademgehaald", "bedolven", "bedongen", "bedorven", "bedragen", "bedreven", "bedrogen", "bedropen", "bedwongen", "beetgenomen", "begeven", "begonnen", "begraven", "begrepen", "behangen", "behouden", "bekeken", "beklommen", "bekomen", "bekropen", "beleden", "belezen", "benomen", "beraden", "beschenen", "beschoten", "beschreven", "beslagen", "beslopen", "besloten", "besneden", "besproken", "besprongen", "bestegen", "bestolen", "bestorven", "bestreden", "bestreken", "betreden", "betroffen", "betrokken", "bevallen", "bevochten", "bevolen", "bevonden", "bevroren", "bewezen", "bewogen", "bezeten", "bezien", "beziggehouden", "bezonnen", "bezweken", "bezworen", "bijeengehouden", "bijeengeroepen", "blootgelegd", "blootgesteld", "bovengehaald", "brandgesticht", "buitengesloten", "buitgemaakt", "deelgenomen", "dichtgebonden", "dichtgedaan", "diepgevroren", "doodgegaan", "doorbladerd", "doorboord", "doorbroken", "doordacht", "doordrongen", "doorgrond", "doorkruist", "doorlopen", "doorsneden", "doorstaan", "doorverteld", "doorzien", "doorzocht", "drooggelegd", "dwarsgezeten", "ervaren", "flauwgevallen", "gebakken", "gebannen", "gebarsten", "gebeden", "gebersten", "gebeten", "geblazen", "gebleken", "gebleven", "geblonken", "geboden", "gebogen", "gebonden", "geboren", "geborgen", "geborsten", "gebraden", "gebroken", "gebrouwen", "gedaan", "gedoken", "gedolven", "gedongen", "gedragen", "gedreten", "gedreven", "gedrongen", "gedronken", "gedropen", "gedwongen", "gefloten", "gegeten", "gegeven", "gegleden", "geglommen", "gegolden", "gegoten", "gegraven", "gegrepen", "gehangen", "gehesen", "geheven", "geholpen", "gehouden", "gehouwen", "gekeken", "geklommen", "geklonken", "gekloven", "geknepen", "gekomen", "gekorven", "gekozen", "gekregen", "gekresen", "gekreten", "gekrompen", "gekrooien", "gekropen", "gekunnen", "gekweten", "gelachen", "geladen", "gelaten", "geleden", "gelegen", "geleken", "gelezen", "gelogen", "geloken", "gelopen", "gemalen", "gemeden", "gemeten", "gemoeten", "gemogen", "gemolken", "genegen", "genezen", "genomen", "genoten", "geprezen", "geraden", "gereden", "geregen", "gereten", "gerezen", "geroepen", "geroken", "geschapen", "gescheiden", "geschenen", "gescheten", "gescholden", "gescholen", "geschonden", "geschonken", "geschoren", "geschoten", "geschoven", "geschreden", "geschreven", "geschrokken", "geslagen", "geslapen", "geslepen", "gesleten", "geslonken", "geslopen", "gesloten", "gesmeten", "gesmolten", "gesneden", "gesnoten", "gesnoven", "gespannen", "gespeten", "gespleten", "gesponnen", "gespoten", "gesproken", "gesprongen", "gesproten", "gestegen", "gestoken", "gestolen", "gestonken", "gestoten", "gestoven", "gestreden", "gestreken", "getreden", "getroffen", "getrokken", "gevallen", "gevangen", "gevangengenomen", "gevaren", "gevezen", "gevlochten", "gevloden", "gevlogen", "gevloten", "gevochten", "gevonden", "gevouwen", "gevreten", "gevroren", "gewassen", "geweken", "geweten", "geweven", "gewezen", "gewogen", "gewonden", "gewonnen", "geworden", "geworpen", "geworven", "gewoven", "gewreten", "gewreven", "gewrongen", "gezegen", "gezeken", "gezeten", "gezien", "gezoden", "gezogen", "gezonden", "gezongen", "gezonken", "gezonnen", "gezopen", "gezouten", "gezwegen", "gezwolgen", "gezwollen", "gezwommen", "gezwonden", "gezworen", "gezworven", "hardgelopen", "herladen", "hernomen", "herwonnen", "herzien", "huisgehouden", "kennisgemaakt", "klaargekomen", "kortgesloten", "kwaadgesproken", "kwijtgeraakt", "kwijtgescholden", "langsgekomen", "leeggelopen", "leeggemaakt", "lesgegeven", "liefgehad", "lipgelezen", "meebetaald", "misbruikt", "misleid", "mislukt", "misprezen", "nabewerkt", "nedergedaald", "omarmd", "omfloerst", "omhelsd", "omkleed", "omklemd", "ommuurd", "omringd", "omschreven", "omsingeld", "omsloten", "omvat", "omvergeworpen", "omwikkeld", "omwonden", "omzeild", "omzoomd", "omzworven", "onderbouwd", "onderbroken", "onderdrukt", "ondergaan", "ondergraven", "onderhandeld", "onderhouden", "onderkend", "ondermijnd", "ondernomen", "onderscheiden", "onderschept", "ondersteund", "onderstreept", "ondertekend", "onderverdeeld", "ondervonden", "ondervraagd", "onderwezen", "onderworpen", "onderzocht", "ontbeten", "ontboden", "ontbonden", "ontbroken", "ontdoken", "ontgonnen", "onthouden", "ontkomen", "ontladen", "ontloken", "ontlopen", "ontnomen", "ontraden", "ontslagen", "ontsloten", "ontspannen", "ontsprongen", "ontsproten", "ontstoken", "onttrokken", "ontvangen", "ontweken", "schoongemaakt", "schoongewassen", "stilgestaan", "tandengepoetst", "tegemoetgekomen", "teleurgesteld", "teloorgegaan", "terechtgekomen", "terechtgesteld", "teweeggebracht", "thuisbezorgd", "thuisgekomen", "toebehoord", "toevertrouwd", "tussengekomen", "tussengeworpen", "uitbesteed", "uitbetaald", "uitvergroot", "uitverkocht", "valsgespeeld", "verbannen", "verbleven", "verboden", "verbogen", "verbonden", "verborgen", "verbroken", "verdragen", "verdreven", "verdrongen", "verdronken", "verdroten", "verdwenen", "vergeleken", "vergeten", "vergeven", "vergleden", "vergolden", "vergoten", "vergrepen", "verhangen", "verheven", "verholpen", "verhouden", "verkozen", "verkregen", "verladen", "verlaten", "verlopen", "verloren", "vermeden", "vermogen", "vernomen", "verraden", "verrezen", "verscheiden", "verschenen", "verscholen", "verschoten", "verschoven", "verschreven", "verschrokken", "verslagen", "verslapen", "versleten", "verslonden", "versmolten", "verstoten", "verstreken", "vertrokken", "vervallen", "vervangen", "vervlogen", "verweten", "verweven", "verwezen", "verworpen", "verworven", "verwrongen", "verzonden", "verzonken", "verzonnen", "verzopen", "verzouten", "verzwonden", "volbracht", "voldaan", "voleindigd", "volhard", "volmaakt", "volstaan", "voltooid", "voltrokken", "voorbehouden", "voorkomen", "voorspeld", "voorzien", "wederhaald", "weergalmd", "weerhouden", "weerkaatst", "weerlegd", "weerstaan"];
};

var participles$2 = {};

Object.defineProperty(participles$2, "__esModule", {
	value: true
});

participles$2.default = function () {
	return ["abdykowany", "absorbowany", "adaptowany", "administrowany", "adoptowany", "adorowany", "adresowany", "afiszowany", "agitowany", "akcentowany", "akceptowany", "aklimatyzowany", "akompaniowany", "aktualizowany", "aktywowany", "akumulowany", "alaromowany", "alienowany", "amerykanizowany", "amortyzowany", "amputowany", "analizowany", "angażowany", "anihilowany", "animowany", "anonsowany", "antropomorfizowany", "antydatowany", "anulowany", "apelowany", "aportowany", "aranżowany", "archiwizowany", "aresztowany", "argumentowany", "artykułowany", "ascendowany", "asekurowany", "asymilowany", "asystowany", "atakowany", "autoryzowany", "awanturowany", "babrany", "baczony", "badany", "bagatelizowany", "bajerowany", "bałamucony", "balangowany", "balansowany", "banalizowany", "bandażowany", "bankrutowany", "baraszkowany", "barwiony", "bawiony", "bazgrany", "bazowany", "bębniony", "bełkotany", "besztany", "biadolony", "biczowany", "bity", "błagany", "błaznowany", "blefowany", "błogosławiony", "blokowany", "bluzgany", "błyskany", "błyszczący", "boczony", "bogacony", "bojkotowany", "boksowany", "bombardowany", "bopowany", "borowany", "brandzlowany", "brany", "brasowany", "bratany", "bredzony", "brnięty", "brodzony", "broniony", "brudzony", "brylowany", "budowany", "budzony", "bujany", "bulony", "bulwersowany", "bumelowany", "burzony", "butelkowany", "bywany", "cackany", "całowany", "capnięty", "cechowany", "celebrowany", "celowany", "ceniony", "cenzurowany", "chciany", "chlany", "chlapany", "chlapnięty", "chlastany", "chłodzony", "chlostany", "chlubiony", "chodowany", "chomikowany", "chorowany", "chowany", "chroniony", "chrupany", "chrzczony", "chuty", "chwalony", "chwycony", "chwytany", "chybotany", "chylony", "ciachnięty", "ciągany", "ciągnięty", "ciemiężony", "cierpiany", "cieszony", "cięty", "ciskany", "ciśnięty", "ciułany", "cmokany", "cmoknięty", "cofany", "cofnięty", "ćpany", "cucony", "cudzołożony", "cumowany", "ćwiartowany", "ćwiczony", "cykany", "cytowany", "czajony", "czarowany", "czczony", "czepiany", "czepiony", "czerpany", "czesany", "częstowany", "czochrany", "czołgany", "czuty", "czytany", "czyty", "darowany", "darty", "darzony", "datowany", "dawany", "dbany", "deaktywowany", "debatowany", "dedukowany", "dedykowany", "defibrylowany", "defilowany", "definiowany", "defraudowany", "degradowany", "degustowany", "deklamowany", "deklarowany", "dekodowany", "dekompresowany", "dekorowany", "dekretowany", "delegowany", "delektowany", "deliberowany", "demaskowany", "dementowany", "demolowany", "demonizowany", "demonstrowany", "demoralizowany", "denerwowany", "denuncjowany", "depeszowany", "depilowany", "deportowany", "deprawowany", "deptany", "deratyzowany", "destabilizowany", "destylowany", "desygnowany", "determinowany", "detonowany", "dewastowany", "dewaulowany", "dezaktywowany", "dezorientowany", "dezynfekowany", "diagnozowany", "dilowany", "dłubany", "dłużony", "dmuchany", "dmuchnięty", "dobiegany", "dobierany", "dobijany", "dobity", "dobrany", "dobudzony", "dobyty", "doceniany", "doceniony", "dochodzony", "dochowany", "dochowywany", "dociągnięty", "dociekany", "docięty", "docinany", "dociskany", "dociśnięty", "doczekany", "doczepiony", "doczołgany", "doczyszczony", "doczytany", "dodany", "dodawany", "dodrukowany", "dodrukowywany", "dofinansowany", "dofinansowywany", "dogadany", "dogadywany", "dogadzany", "doganiany", "doglądany", "doglądnięty", "dognany", "dogodzony", "dogoniony", "dograny", "dogryzany", "dogryziony", "dogrzany", "dogrzebany", "doinformowany", "dojeżdżany", "dojony", "dojrzany", "dojrzewany", "dokańczany", "dokarmiany", "dokarmiony", "dokazany", "dokazywany", "dokładany", "doklejony", "dokonany", "dokończony", "dokonywany", "dokopany", "dokopywany", "dokowany", "dokręcany", "dokręcony", "dokształcany", "dokształcony", "dokuczany", "dokumentowany", "dokupiony", "dołączany", "dołączony", "doładowany", "dolany", "dolewany", "doliczony", "dołowany", "dołożony", "domagany", "domalowany", "domknięty", "domniewywany", "domówiony", "domyślany", "domyślony", "domyty", "doniesiony", "donoszony", "dopadany", "dopadnięty", "dopakowany", "dopalony", "dopasowany", "dopasowywany", "dopatrywany", "dopatrzony", "dopchany", "dopchnięty", "dopełniany", "dopełniony", "dopieszczony", "dopięty", "dopijany", "dopilnowany", "dopingowany", "dopisany", "dopisywany", "dopity", "dopłacany", "dopłacony", "dopłynięty", "dopolerowany", "dopompowany", "dopowiedziany", "dopracowany", "dopracowywany", "doprany", "doprawiony", "doprecyzowany", "doproszony", "doprowadzany", "doprowadzony", "dopucowany", "dopuszczany", "dopuszczony", "dopytywany", "dorabiany", "doradzany", "doradzony", "doręczany", "doręczony", "dorobiony", "dorównany", "dorównywany", "dorwany", "dorysowany", "dorzucany", "dorzucony", "doścignięty", "dosiadany", "dosięgnięty", "doskoczony", "doskonalony", "dosładzany", "dosłany", "dosłyszany", "dosolony", "dośrodkowany", "dossany", "dostany", "dostąpiony", "dostarczany", "dostarczony", "dostawany", "dostawiany", "dostawiony", "dostosowany", "dostosowywany", "dostrajany", "dostrojony", "dostrzegany", "dosunięty", "dosuwany", "doświadczany", "Doświetlony", "dosypany", "dosypywany", "doszkolony", "doszlifowany", "doszorowany", "doszukany", "doszukiwany", "doszyty", "dotankowany", "dotankowywany", "dotargany", "dotaszczony", "dotknięty", "dotleniony", "dotłumaczony", "dotowany", "dotrwany", "dotrzymany", "dotrzymywany", "dotykany", "douczany", "douczony", "dowalony", "dowieziony", "dowodzony", "dowożony", "doznany", "doznawany", "dozorowany", "dozowany", "dożyty", "dożywiony", "dramatyzowany", "drapany", "drapnięty", "draśnięty", "drażniony", "drążony", "dręczony", "drenowany", "drgany", "drgnięty", "drukowany", "dryblowany", "dryfowany", "drzemany", "dubbingowany", "dublowany", "duplikowany", "duszony", "dworowany", "dygotany", "dyktowany", "dymany", "dymiony", "dyrygowany", "dyscyplinowany", "dyskredytowany", "dyskryminowany", "dyskutowany", "dyskwalifikowany", "dysponowany", "dystansowany", "dystrybuowany", "dywagowany", "dźgany", "dźgnięty", "dziabnięty", "dziedziczony", "dziękowany", "dzielony", "dziergany", "dzierżony", "dziobany", "dziurawiony", "dziurkowany", "dźwigany", "dźwignięty", "edukowany", "edytowany", "egzaminowany", "egzekutowany", "egzekwowany", "ekscytowany", "ekshumowany", "ekskomunikowany", "eksmitowany", "ekspandowany", "eksperymentowany", "eksploatowany", "eksplorowany", "eksponowany", "eksportowany", "eksterminowany", "ekstradowany", "ekstrapolowany", "eliminowany", "emancypowany", "emanoway", "emigrowany", "emitowany", "energetyzowany", "eskortowany", "etykietowany", "ewakuowany", "ewaluowany", "fabrykowany", "falowany", "fałszowany", "farbowany", "faszerowany", "faulowany", "faworyzowany", "fechtowany", "fermentowany", "ferowany", "figurowany", "filetowany", "filmowany", "filtrowany", "finalizowany", "finansowany", "firmowany", "fleszowany", "folgowany", "formułowany", "forsowany", "fotografowany", "fundowany", "gadany", "ganiany", "garbiony", "gardzony", "garnirowany", "gaszony", "gawędzony", "gaworzony", "gazowany", "gdakany", "gderany", "generalizowany", "generowany", "gięty", "gilgotany", "gładzony", "głaskany", "głodowany", "głodzony", "gloryfikowany", "głosowany", "głoszony", "głowiony", "gmatwany", "gmerany", "gnany", "gnębiony", "gnieciony", "gnity", "gnojony", "godzony", "gojony", "golnięty", "golony", "goniony", "googlowany", "gospodarowany", "goszczony", "gotowany", "grabiony", "grany", "grasowany", "gratulowany", "grillowany", "grilowany", "gromadzony", "gromiony", "grożony", "gruchany", "gruchnięty", "grupowany", "grywany", "gryziony", "grzany", "grzechotany", "gubiony", "gustowany", "gwałcony", "gwarantowany", "gwizdany", "gwizdnięty", "hackowany", "haftowany", "hajtnięty", "hamowany", "hańbiony", "handlowany", "harcowany", "harmonizowany", "harowany", "hartowany", "hibernowany", "hipnotyzowany", "hodowany", "holowany", "hołubiony", "honorowany", "hospitalizowany", "huknięty", "hulany", "huśtany", "idealizowany", "identyfikowany", "ignorowany", "igrany", "ilustrowany", "imitowany", "implantowany", "implodowany", "imponowany", "importowany", "improwizowany", "indokrynowany", "indukowany", "infekowany", "infiltrowany", "informowany", "ingerowany", "inhalowany", "inscenizowany", "inspirowany", "instalowany", "instruowany", "insynuowany", "integrowany", "interpretowany", "interweniowany", "intonowany", "intubowany", "inwestowany", "inwigilowany", "irytowany", "iskrzony", "izolowany", "jadany", "jawiony", "jazgotany", "jednoczony", "jedzony", "kablowany", "kadzony", "kalany", "kaleczony", "kalkulowany", "kamerowany", "kamienowany", "kamuflowany", "kanalizowany", "kantowanty", "kąpany", "kapitulowany", "kapowany", "karany", "karbonizowany", "karcony", "karczowany", "karmiony", "kartkowany", "kąsany", "kasowany", "kastrowany", "katalogowany", "katapultowany", "katowany", "katrupiony", "kierowany", "kimany", "kiszony", "kiwany", "kiwnięty", "kłaniany", "klapany", "klapnięty", "klarowany", "klasyfikowany", "klębiony", "klejony", "klepany", "klepnięty", "klikany", "kliknięty", "klonowany", "kłopotany", "kłuty", "knocony", "knuty", "kochany", "koczowany", "kodowany", "kojarzony", "kojfnięty", "kojony", "kolekcjonowany", "kolektywizowany", "kolidowany", "kolonizowany", "kolorowany", "koloryzowany", "kołowany", "kołysany", "kombinowany", "komenderowany", "komentowany", "komercjalizowany", "kompensowany", "komplementowany", "komplikowany", "komponowany", "kompromitowany", "komunikowany", "konany", "koncentrowany", "kończony", "konfabulowany", "konfiskowany", "konfrontowany", "konserwowany", "konspirowany", "konstruowany", "konsultowany", "konsumowany", "kontaktowany", "kontestowany", "kontrastowany", "kontrolowany", "kontrowany", "kontynuowany", "kontynuuowany", "konwertowany", "konwojowany", "koordynowany", "kopany", "kopcony", "kopiowany", "kopnięty", "kopulowany", "korelowany", "korkowany", "koronowany", "korygowany", "korzony", "korzystany", "koszony", "kotwiczony", "kozaczony", "kozłowany", "kpity", "kradziony", "krajany", "krążony", "kręcony", "kremowany", "kreowany", "krochmalony", "krojony", "kropiony", "kruszony", "krystalizowany", "kryty", "krytykowany", "krzepnięty", "krzyczany", "krzyknięty", "krzywdzony", "krzywiony", "krzyżowany", "kserowany", "księgowany", "kształcony", "kształtowany", "kulony", "kultywowany", "kumulowany", "kupczony", "kupiony", "kupowany", "kupywany", "kurczony", "kurowany", "kursowany", "kurzony", "kuszony", "kuty", "kwalifikowany", "kwestionowany", "łączony", "ładowany", "łagodzony", "łajdaczony", "lakierowany", "łamany", "lamentowany", "lansowany", "lany", "łapany", "łaskotany", "łaszony", "latany", "łatany", "lawirowany", "leczony", "legalizowany", "legitymowany", "lekceważony", "lepiony", "lewitowany", "liberowany", "licencjonowany", "licytowany", "liczony", "likwidowany", "linczowany", "liniowany", "literowany", "litowany", "lizany", "liznięty", "lobbowany", "lokalizowany", "losowany", "łowiony", "łożony", "lubiany", "łudzony", "lunatykowany", "łupany", "łupiony", "łuskany", "lustrowany", "łuszczony", "luzowany", "łykany", "łyknięty", "łyżeczkowany", "macany", "machany", "machnięty", "mącony", "maczany", "maganyzowany", "maglowany", "majaczony", "majsterkowany", "majtany", "maksymalizowany", "malowany", "maltretowany", "mamiony", "mamrotany", "manewrowany", "manifestowany", "manipulowany", "markowany", "marnotrawiony", "marnowany", "marszczony", "marynowany", "marznięty", "masakrowany", "maskowany", "masowany", "masturbowany", "mataczony", "materializowany", "mawiany", "mazany", "maznięty", "męczony", "meldowany", "merdany", "metabolizowany", "miażdżony", "mielony", "mierzony", "mierzwiony", "mieszany", "miętolony", "migany", "migdalony", "migotany", "mijany", "miksowany", "milowany", "minięty", "minimalizowany", "miotany", "mistyfikowany", "mitygowany", "mizdrzony", "mlany", "mniemany", "mnożony", "mobilizowany", "mocowany", "moczony", "modelowany", "modernizowany", "modlony", "modulowany", "modyfikowany", "molestowany", "monitorowany", "monopolizowany", "montowany", "mordowany", "motywowany", "mówiony", "mrożony", "mrugany", "mrużony", "muskany", "mutowany", "mydlony", "mylony", "myszkowany", "myty", "nabazgrany", "nabiegany", "nabierany", "nabity", "nabrany", "nabrojony", "nabrudzony", "nabyty", "nabywany", "nacelowany", "nachapany", "nachodzony", "nachwalony", "nachylony", "naciągany", "naciągnięty", "nacierany", "nacięty", "nacinany", "naciskany", "naciśnięty", "nacjonalizowany", "naczepiony", "nadany", "nadawany", "nadchodzony", "nadciągany", "nadciągnięty", "nadcięty", "nadesłany", "nadgoniony", "nadgryzany", "nadgryziony", "nadinterpretowany", "nadłożony", "nadmieniany", "nadmieniony", "nadmuchany", "nadrabiany", "nadrobiony", "nadskakiwany", "nadsłuchiwany", "nadstawiany", "nadstawiony", "nadszarpnięty", "naduszony", "nadużyty", "nadużywany", "nadwerężany", "nadwyrężany", "nadwyrężony", "nadziany", "nadzorowany", "naelektryzowany", "nafaszerowany", "nagabywany", "nagadany", "nagięty", "naginany", "nagłaszany", "nagłośniony", "nagoniony", "nagradzany", "nagrany", "nagrodzony", "nagromadzony", "nagrywany", "nagryzmolony", "nagrzany", "nagrzebany", "nagrzewany", "nagwizdany", "naigrywany", "najechany", "najęty", "najmowany", "nakarmiany", "nakarmiony", "nakazany", "nakazywany", "nakierowany", "nakierowywany", "nakładany", "nakłamany", "nakłaniany", "naklejany", "naklejony", "naklepany", "nakłoniony", "nakłuty", "nakłuwany", "nakopany", "nakręcany", "nakręcony", "nakreślany", "nakreślony", "nakruszony", "nakryty", "nakrywany", "nakrzyczany", "nakupiony", "naładowany", "nalany", "nałapany", "nalepiony", "nalewany", "naliczony", "nałowiony", "nałożony", "namaczany", "namagnetyzowany", "namalowany", "namaszczany", "namaszczony", "namawiany", "namęczony", "namierzany", "namieszany", "namoczony", "namówiony", "namydlany", "namyślony", "naniesiony", "naoliwiany", "naoliwiony", "naopowiadany", "naostrzony", "napadany", "napadnięty", "napakowany", "napalony", "naparzany", "napastowany", "napawany", "napchany", "napędzany", "napełniany", "napełniony", "napierany", "napiętnowany", "napięty", "napinany", "napisany", "napluty", "napływany", "napoczęty", "napojony", "napompowany", "napotkany", "napotykany", "napraszany", "naprawiany", "naprawiony", "naprężany", "naprężony", "napromieniowany", "naprostowany", "naprowadzany", "naprowadzony", "napsuty", "napuszczany", "napuszczony", "napychany", "napytany", "narąbany", "naradzany", "naradzony", "narastany", "narażany", "narażony", "nareperowany", "narkotyzowany", "narodzony", "naruszany", "naruszony", "narwany", "narysowany", "narzucany", "narzucony", "nasączany", "nasączony", "nasadzony", "nasiąkany", "nasilany", "nasilony", "naskakiwany", "naskoczony", "naskrobany", "naśladowany", "nasłany", "nasłuchany", "nasłuchiwany", "nasmarowany", "nastąpiony", "nastawiany", "nastawiony", "nastraszany", "nastrojony", "nastukany", "nasunięty", "nasuwany", "naświetlany", "nasycony", "nasyłany", "nasypany", "naszczany", "naszkicowany", "naszpikowany", "naszprycowany", "naszykowany", "naszyty", "naszywany", "natarty", "natchnięty", "natknięty", "natleniony", "natłuszczony", "natrafiony", "natrząsany", "natrząsnięty", "nauczany", "nauczony", "nawadniany", "nawalony", "nawiązany", "nawiązywany", "nawiedzany", "nawiedzony", "nawiercony", "nawiewany", "nawieziony", "nawigowany", "nawijany", "nawilżany", "nawilżony", "nawinięty", "nawlekany", "nawodniony", "nawoływany", "nawoskowany", "nawożony", "nawpychany", "nawracany", "nawrócony", "nawrzucany", "nawtykany", "nawymyślany", "nazbierany", "nazmyślany", "naznaczany", "naznaczony", "nazrywany", "nazwany", "nazywany", "nęcony", "negocjowany", "negowany", "nękany", "neutralizowany", "niańczony", "niecierpliwiony", "niedoceniany", "niedowidziany", "nienawidzony", "niesiony", "nikolony", "niszczony", "nitkowany", "niuchany", "niweczony", "niwelowany", "nokautowany", "nominowany", "notowany", "nucony", "numerowany", "nurtowany", "obaczony", "obadany", "obalany", "obalony", "obandażowany", "obarczany", "obarczony", "obawiany", "obchodzony", "obciągnięty", "obciążony", "obcięty", "obcinany", "obcyndalany", "obczajany", "obczajony", "obdarowany", "obdarty", "obdarzany", "obdarzony", "obdzielony", "obdzierany", "obdzwaniany", "obdzwoniony", "obejmowany", "oberwany", "obessany", "obezwładniany", "obezwładniony", "obfotografowany", "obfotografowywany", "obgadany", "obgadywany", "obgryzany", "obgryziony", "obiecany", "obiecywany", "obierany", "obijany", "obity", "objadany", "objaśniany", "objawiany", "objawiony", "objechany", "objęty", "objeżdżany", "obkręcany", "oblany", "obłapiany", "obłapywany", "obłaskawiany", "obłaskawiony", "obleciany", "obleganu", "oblewany", "obliczany", "obliczony", "oblizany", "obłowiony", "obłożony", "obluzowany", "obluzowywany", "obmacany", "obmacywany", "obmawiany", "obmyślany", "obmyślony", "obmyty", "obmywany", "obnażany", "obniżany", "obniżony", "obnoszony", "obowiązywany", "obozowany", "obrabiany", "obrabowany", "obracany", "obradowany", "obramowany", "obraniany", "obrany", "obrastany", "obrażany", "obrażony", "obrobiony", "obrócony", "obrodzony", "obroniony", "obrysowany", "obrywany", "obryzgany", "obrzezany", "obrzucany", "obrzucony", "obrzygany", "obsadzany", "obsadzony", "obściskiwany", "obserwowany", "obsiany", "obsikany", "obsikiwany", "obskakiwany", "obskoczony", "obskubany", "obskubywany", "obśliniany", "obśliniony", "obsługiwany", "obsłużony", "obsmarowany", "obstawiany", "obstawiony", "obstrzeliwany", "obsunięty", "obsuwany", "obsypany", "obsypywany", "obszukany", "obszukiwany", "obtaczany", "obtarty", "obtoczony", "obudzony", "obwąchany", "obwąchiwany", "obwiązany", "obwiązywany", "obwieszany", "obwieszczany", "obwieszczony", "obwieszony", "obwijany", "obwiniany", "obwinięty", "obwołany", "obyty", "obżerany", "ocalany", "ocalony", "ocechowany", "oceniany", "oceniony", "ocenzurowany", "ochładzany", "ochlapany", "ochlapywany", "ochłodzony", "ochłonięty", "ochraniany", "ochroniony", "ochrzaniany", "ochrzczony", "ociągany", "ocielony", "ocieplany", "ocieplony", "ocierany", "ocknięty", "ocucony", "ocuty", "oczarowywany", "oczekiwany", "oczerniany", "oczerniony", "oczyszczany", "oczyszczony", "odarty", "odbębniony", "odbetonowany", "odbezpieczany", "odbezpieczony", "odbijany", "odbity", "odblokowany", "odbudowany", "odbudowywany", "odbutowany", "odbyty", "odcedzany", "odchorowany", "odchowany", "odchudzany", "odchudzony", "odchylany", "odchylony", "odciągany", "odciągnięty", "odciążony", "odcierpiony", "odcięty", "odcinany", "odcisnięty", "odcumowany", "odcyfrowany", "odcyfrowywany", "odczarowany", "odczekany", "odczepiany", "odczepiony", "odczuty", "odczuwany", "odczyniony", "odczytany", "odczytywany", "oddalany", "oddany", "oddawany", "oddelegowany", "oddychany", "oddzielany", "oddzielony", "odebrany", "odegnany", "odegrany", "odejmowany", "odepchnięty", "oderwany", "odeskortowany", "odesłany", "odespany", "odessany", "odetkany", "odetnięty", "odezwany", "odfiltrowany", "odgadnięty", "odgadywany", "odganiany", "odgarniany", "odgarnięty", "odgięty", "odgniatany", "odgoniony", "odgradzany", "odgrażany", "odgrodzony", "odgruzowany", "odgrywany", "odgryzany", "odgryziony", "odgrzany", "odgrzebany", "odgrzebywany", "odgrzewany", "odgwizdany", "odhaczony", "odholowany", "odinstalowany", "odizolowany", "odjedzony", "odjęty", "odjonizowany", "odkażany", "odkażony", "odkładany", "odklejony", "odkochany", "odkodowany", "odkodowywany", "odkopany", "odkopywany", "odkorkowany", "odkręcany", "odkręcony", "odkrojony", "odkryty", "odkrywany", "odkupiony", "odkupywany", "odkurzany", "odkurzony", "odkuty", "odłączany", "odłączony", "odłamywany", "odlany", "odlatywany", "odlepiany", "odlewany", "odliczany", "odliczony", "odłożony", "odłupany", "odmachany", "odmachiwany", "odmalowany", "odmarszczony", "odmawiany", "odmeldowany", "odmieniany", "odmieniony", "odmierzany", "odmierzony", "odmieszany", "odmontowany", "odmówiony", "odmrażany", "odmrożony", "odnajdowany", "odnaleziony", "odnawiany", "odniesiony", "odnoszony", "odnotowany", "odnotowywany", "odnowiony", "odpakowany", "odpakowywany", "odpalany", "odpalony", "odpałzowany", "odparowany", "odparty", "odpędzany", "odpicowany", "odpieczętowany", "odpierany", "odpięty", "odpiłowany", "odpiłowywany", "odpinany", "odpisany", "odpisywany", "odpłacany", "odplamiony", "odplątany", "odpłynięty", "odpowietrzony", "odpracowany", "odpracowywany", "odprasowany", "odprawiany", "odprawiony", "odprężany", "odprostowany", "odprowadzany", "odprowadzony", "odpruty", "odpryskany", "odpukany", "odpukiwany", "odpuszczany", "odpuszczony", "odpychany", "odrąbany", "odrabiany", "odrąbywany", "odradzany", "odradzony", "odrapany", "odrastany", "odratowany", "odreagowany", "odremontowany", "odrestaurowany", "odrestaurowywany", "odrobaczany", "odrobiony", "odroczony", "odrodzony", "odrośnięty", "odróżniany", "odróżniony", "odrysowany", "odrywany", "odrzucany", "odrzucony", "odsączany", "odsączony", "odsadzony", "odseparowany", "odsiadywany", "odsiany", "odsiewany", "odsłaniany", "odsłonięty", "odsłuchany", "odsłuchiwany", "odsłużony", "odśnieżany", "odśnieżony", "odsolony", "odśpiewany", "odsprzedany", "odsprzedawany", "odstąpiony", "odstawiany", "odstawiony", "odstępowany", "odstraszany", "odstręczony", "odstresowany", "odstrzeliwany", "odstrzelony", "odsunięty", "odsuwany", "odświeżany", "odświeżony", "odsyłany", "odsypywany", "odsysany", "odszczekany", "odszczekiwany", "odsztafirowany", "odszukany", "odszyfrowany", "odszyfrowywany", "odszykowany", "odtrąbiony", "odtrącony", "odtruty", "odtwarzany", "odtworzony", "oduczony", "odurzony", "odwalany", "odwalony", "odwiązany", "odwiązywany", "odwiedzany", "odwiedzony", "odwieszony", "odwieziony", "odwijany", "odwinięty", "odwlekany", "odwodniony", "odwodzony", "odwołany", "odwoływany", "odwożony", "odwracany", "odwrócony", "odwzajemniony", "odwzorowany", "odżegnany", "odziany", "odziedziczony", "odznaczany", "odznaczony", "odzwieciedlony", "odzwierciedlany", "odzwoniony", "odzwyczajony", "odzyskany", "odzyskiwany", "odżyty", "odzywiany", "odżywiony", "oferowany", "ofiarowany", "ofiarowywany", "ogarniany", "ogarnięty", "oglądany", "ogłaszany", "ogłoszony", "ogłupiany", "ogłupiony", "ogłuszony", "ogołocony", "ogolony", "ograbiany", "ograbiony", "ograniczany", "ograniczony", "ograny", "ogrodzony", "ogryziony", "ogrzany", "ogrzewany", "okablowany", "okaleczony", "okantowany", "okąpany", "okazany", "okazywany", "okiełznany", "okładany", "okłamany", "okłamywany", "oklaskiwany", "oklejony", "oklepany", "okopany", "okopywany", "okpiony", "okradany", "okradziony", "okraszony", "okrążany", "okrążony", "okręcany", "okręcony", "określany", "określony", "okrojony", "okryty", "okrywany", "okrzyknięty", "okulawiony", "okupiony", "okupowany", "olany", "olewany", "olśnięty", "omamiony", "omawiany", "omdlewany", "omijany", "ominięty", "omotany", "omówiony", "onanizowany", "onieśmielany", "onieśmielony", "opadnięty", "opakowany", "opalany", "opalony", "opancerzony", "opanowany", "opanowywany", "oparty", "oparzony", "opasany", "opatentowany", "opatrywany", "opatrzony", "opatulony", "opchnięty", "opędzany", "opędzony", "operowany", "opętany", "opętywany", "opieczętowany", "opiekowany", "opierany", "opijany", "opisany", "opisywany", "opity", "opłacany", "opłacony", "opłakany", "opłakiwany", "opłukany", "opluty", "opluwany", "opływany", "opodatkowany", "opodatkowywany", "oponowany", "oporządzany", "oporządzony", "opowiadany", "opowiedziany", "opóźniany", "opóźniony", "opracowany", "opracowywany", "oprawiany", "oprawiony", "oprowadzany", "oprowadzony", "opróżniany", "opróżniony", "opryskany", "opryskiwany", "opublikowany", "opukany", "opuszczany", "opuszczony", "opychany", "opylony", "orany", "orbowany", "organizowany", "orientowany", "oroszony", "orzekany", "orżnięty", "osaczany", "osaczony", "osadzany", "osądzany", "osadzony", "osądzony", "oscylowany", "osiadany", "osiągany", "osiągnięty", "osiedlany", "osiedlony", "osiedzony", "osierocony", "osiodłany", "oskalpowany", "oskarżony", "oskrobany", "oskrzydlany", "oskrzydlony", "oskubany", "oskubywany", "osłabiany", "osłabiony", "oślepiany", "oślepiony", "oślepnięty", "ośliniany", "osłodzony", "osłoniony", "osłuchany", "osmalony", "ośmielony", "ośmieszany", "ośmieszony", "ostrzegany", "ostrzelany", "ostrzelity", "ostrzony", "ostudzony", "osunięty", "osuszany", "osuszony", "osuwany", "oswajany", "oświadczany", "oświadczony", "oświecany", "oświeciony", "oświetlany", "oświetlony", "oswobadzany", "oswobodzony", "oswojony", "oszacowany", "oszałamiany", "oszczany", "oszczędzany", "oszczędzony", "oszklony", "oszlifowany", "oszołomiony", "oszpecony", "oszukany", "oszukiwany", "oszwabiony", "otaczany", "otarty", "otoczony", "otruty", "otruwany", "otrząsany", "otrząśnięty", "otrzepany", "otrzeźwiony", "otrzymany", "otrzymywany", "otulony", "otumaniony", "otwierany", "otworzony", "otwarty", "owany", "owdowiony", "owiany", "owijany", "owinięty", "ozdabiany", "ozdobiony", "ozdrowiony", "ożeniony", "oznaczany", "oznaczony", "oznajmiany", "oznajmiony", "oznakowany", "ożyty", "ożywany", "ożywiany", "ożywiony", "pachnący", "pacnąty", "pakowany", "paktowany", "pałany", "pałaszowany", "palnięty", "palony", "pamiętany", "panoszony", "paprany", "parafrazowany", "paraliżowany", "parkowany", "parowany", "partaczony", "parzony", "pastowany", "paszony", "patrolowany", "patroszony", "patrzony", "pauzowany", "pchany", "pchnięty", "pdholowany", "pedałowany", "pękany", "pęknięty", "pełniony", "penetrowany", "perforowany", "perfumowany", "perswadowany", "piastowany", "pichcony", "pielęgnowany", "pielony", "pieniony", "pieszczony", "piętnowany", "pięty", "pijany", "pikietowany", "piknikowany", "pikowany", "pilnowany", "pilotowany", "piłowany", "pisany", "pisywany", "pity", "płacony", "plądrowany", "plamiony", "planowany", "płaszczony", "plątany", "płatany", "pławiony", "plewiony", "płonący", "płoszony", "plotkowany", "plugawiony", "płukany", "pluskany", "pluty", "pobaraszkowany", "pobierany", "pobity", "pobłażany", "pobłogosławiony", "pobrany", "pobrudzony", "pobudzany", "pobudzony", "pobujany", "pocałowany", "pocerowany", "pochłaniany", "pochlapany", "pochlebiany", "pochłonięty", "pochowany", "pochwalany", "pochwalony", "pochwycony", "pochylany", "pochylony", "pociachany", "pociągany", "pociągnięty", "pocierany", "pocieszany", "pocieszony", "pocięty", "pocony", "pocukrowany", "poćwiartowany", "poczesany", "poczęstowany", "poczęty", "poczochrany", "poczuty", "poczytany", "poczytywany", "podany", "podarowany", "podarty", "podawany", "podążony", "podbierany", "podbijany", "podbity", "podbudowany", "podbudowywany", "podburzany", "podburzony", "podchwycony", "podciągany", "podciągnięty", "podcierany", "podcięty", "podcinany", "podczepiony", "poddany", "poddawany", "podebrany", "podejmowany", "podejrzany", "podejrzewany", "podelektowany", "podeptany", "poderwany", "podesłany", "podglądany", "podgolony", "podgoniony", "podgryzany", "podgrzany", "podgrzewany", "podjadany", "podjedzony", "podjęty", "podkablowany", "podkarmiony", "podkładany", "podklejony", "podkolorowany", "podkołowany", "podkopany", "podkopywany", "podkradany", "podkradnięty", "podkręcany", "podkręcony", "podkreślany", "podkreślony", "podkształcony", "podkulony", "podkupiony", "podkurzony", "podkuty", "podłączany", "podłączony", "podładowany", "podłamany", "podlany", "podłapany", "podleczony", "podlegany", "podlewany", "podliczany", "podliczony", "podlizany", "podlizywany", "podłożony", "podmalowany", "podmieniany", "podmieniony", "podmuchany", "podmyty", "podnajęty", "podniecany", "podniecony", "podniesiony", "podnoszony", "podołany", "podopingowany", "podostrzony", "podotykany", "podpadnięty", "podpalany", "podpalony", "podparty", "podpatrywany", "podpatrzony", "podpieczętowany", "podpiekany", "podpierany", "podpięty", "podpiłowany", "podpinany", "podpisany", "podpisywany", "podpłacony", "podpłynięty", "podpompowany", "podporządkowany", "podporządkowywany", "podpowiadany", "podpowiedziany", "podprowadzany", "podpuszczany", "podpuszczony", "podpychany", "podpytany", "podrabiany", "podrapany", "podrasowany", "podratowany", "podrażniony", "podręczony", "podregulowany", "podreperowany", "podretuszowany", "podrobiony", "podroczony", "podróżowany", "podrygiwany", "podrywany", "podrzucany", "podrzucony", "podrzynany", "podsadzony", "podskubywany", "podsłuchany", "podsłuchiwany", "podsmażany", "podsmażony", "podśpiewywany", "podstawiany", "podstawiony", "podstemplowany", "podstrojony", "podsumowany", "podsumowywany", "podsunięty", "podsuwany", "podświetlany", "podsycany", "podsycony", "podsyłany", "podsypany", "podszczypywany", "podszkolony", "podszlifowany", "podszykowany", "podszyty", "podszywany", "podtapiany", "podtarty", "podtopiony", "podtrzymany", "podtrzymywany", "podtuczony", "poduczany", "podupadany", "poduszony", "podwajany", "podwalany", "podważany", "podwędzony", "podwiązany", "podwieszany", "podwieziony", "podwijany", "podwinięty", "podwojony", "podwożony", "podwyżany", "podwyższany", "podwyższony", "podyktowany", "podyskutowany", "podziabany", "podziałany", "podziałkowany", "podziękowany", "podzielony", "podziurawiony", "podziwiany", "podźwignięty", "poeksperymentowany", "pofarbowany", "pofatygowany", "pofilmowany", "poganiany", "pogardzany", "pogardzony", "pogarszany", "pogaszony", "pogładzony", "pogłaskany", "pogłębiany", "pogłębiony", "pogłośniony", "pogmatwany", "pognębiony", "pognieciony", "pogodzony", "pogoniony", "pogorszony", "pogotowany", "pograbiony", "pogrążany", "pogrążony", "pogrożony", "pogrubiany", "pogrubiony", "pogruchany", "pogruchotany", "pogrupowany", "pogrywany", "pogryzany", "pogryziony", "pogrzany", "pogrzebany", "pogubiony", "pogwałcany", "pohamowany", "pohandlowany", "poharatowany", "pohuśtany", "poinformowany", "poinstruowany", "pojednany", "pojęty", "pojmięty", "pojmowany", "pojony", "pokajany", "pokaleczony", "pokarany", "pokarmiony", "pokąsany", "pokatalogowany", "pokazany", "pokazywany", "pokiereszowany", "pokierowany", "pokiwany", "pokładany", "poklepany", "poklepywany", "pokłoniony", "pokłuty", "pokochany", "pokolorowany", "pokoloryzowany", "pokołysany", "pokombinowany", "pokomplikowany", "pokonany", "pokończony", "pokonywany", "pokopany", "pokrajany", "pokrążony", "pokręcony", "pokrojony", "pokruszony", "pokryty", "pokrywany", "pokrzepiany", "pokrzepiony", "pokrzyżowany", "pokuszony", "pokutowany", "połączony", "polakierowany", "połamany", "polany", "połapany", "połaskotany", "połatany", "polecany", "połechtany", "polecony", "poleczony", "polegany", "polemizowany", "polepszany", "polepszony", "polerowany", "polewany", "policzkowany", "policzony", "polimeryzowany", "polizany", "połknięty", "polowany", "połowiony", "położony", "polubiony", "poluźniony", "poluzowany", "połykany", "pomacany", "pomachany", "pomagany", "pomalowany", "pomarynowany", "pomasowany", "pomazany", "pomęczony", "pomiatany", "pomieszany", "pomieszczony", "pomijany", "pominięty", "pomiziany", "pomknięty", "pomnażany", "pomniejszany", "pomniejszony", "pomnożony", "pomoczony", "pompowany", "pomydlony", "pomylony", "pomyszkowany", "pomywany", "ponabijany", "ponaciskany", "ponadziewany", "ponaglany", "ponaglony", "ponagrywany", "ponaklejany", "ponakłuwany", "ponakrywany", "ponaprawiany", "ponawiany", "poniańczony", "poniechany", "ponieiwerany", "poniesiony", "poniszczony", "poniżany", "poniżony", "ponoszony", "ponowiony", "ponudzony", "poobcinany", "poobcowany", "poobczajany", "poobijany", "poobmacywany", "poobracany", "poobserwowany", "poodbijany", "poodcinany", "poodgryzany", "poodkurzany", "poodprawiany", "poodsuwany", "poodwalany", "pooglądany", "poograniczany", "poopalany", "poopiekany", "poopwiadany", "pootwierany", "popadany", "popakowany", "popalony", "poparty", "poparzony", "popchany", "popchnięty", "popędzany", "popędzony", "popękany", "popełniany", "popełniony", "poperfumowany", "popierany", "popieszczony", "popijany", "popilnowany", "popisany", "popity", "popłacony", "popłakiwany", "poplamiony", "poplątany", "popluskany", "popodcinany", "popodziwiany", "popoprawiany", "poprany", "poprasowany", "poprawiany", "poprawiony", "poproszony", "poprowadzony", "popryskany", "poprzebierany", "poprzeciągany", "poprzecinany", "poprzedzany", "poprzeglądany", "poprzeklinany", "poprzekopywany", "poprzemieszczany", "poprzenoszony", "poprzesadzany", "poprześladowany", "poprzestawiany", "poprzesuwany", "poprzewieszany", "poprzewracany", "poprzycinany", "poprzymierzany", "poprzytulany", "poprzywiązywany", "popsuty", "popudrowany", "popukany", "popularyzowany", "popuszczany", "popuszczony", "popychany", "popykany", "popytany", "porabiany", "porachowany", "poraniony", "poratowany", "porażony", "poręczony", "porównany", "porozbierany", "porozbijany", "porozciągany", "porozcinany", "porozdawany", "porozdzielany", "porozmieszczany", "poróżniony", "porozpędzany", "porozpieszczany", "porozprowadzany", "porozpruwany", "porozrzucany", "porozstawiany", "porozsyłany", "porozumiewany", "porozwalany", "porozwiązywany", "porozwieszany", "porozwożony", "portretowany", "poruszany", "poruszony", "porwany", "porysowany", "porywany", "porządkowany", "porządzony", "porzucany", "porzucony", "posądzany", "posadzony", "posądzony", "pościągany", "pościelony", "pościerany", "pościgany", "pościnany", "pościskany", "posegregowany", "posiadany", "posiany", "posiekany", "posilany", "posiłkowany", "posilony", "posiłowany", "posiniaczony", "posiorbany", "poskąpiony", "poskładany", "posklejany", "poskramiany", "poskręcany", "poskrobany", "poskromiony", "poskubany", "posłany", "posłodzony", "poślubiany", "poślubiony", "posługiwany", "posmakowany", "posmarowany", "posolony", "posortowany", "pospekulowany", "pospieszany", "pośpieszany", "pośpiewany", "pospinany", "pospłacany", "posprawdzany", "posprzątany", "posprzedawany", "pośredniczony", "possany", "postanowiony", "postany", "postarany", "postawiony", "postemplowany", "posterowany", "postradany", "postraszony", "postrugany", "postrzegany", "postrzelany", "postrzelony", "postukany", "postymulowany", "posunięty", "posuwany", "poświącany", "poświadczony", "poświecony", "poświęcony", "poświętowany", "poświntuszony", "posyłany", "posypany", "posypywany", "poszarpany", "poszastany", "poszatkowany", "poszczuty", "poszczycony", "poszczypany", "poszerzany", "poszerzony", "poszorowany", "poszpiegowany", "poszturchany", "poszukany", "poszukiwany", "poszwędany", "poszybowany", "potakiwany", "potarmoszony", "potarty", "potasowany", "potęgowany", "potępiany", "potępiony", "potknięty", "potoczony", "potopiony", "potorturowany", "potrącany", "potrącony", "potraktowany", "potrojony", "potruty", "potrząsany", "potrzaskany", "potrząsnięty", "potrząśnięty", "potrzymany", "Poturbowany", "poturlany", "potwierdzony", "potykany", "poucinany", "pouczany", "pouczony", "poudawany", "poukładany", "pouprawiany", "poupychany", "pourywany", "poustawiany", "poużywany", "powąchany", "powachlowany", "powalany", "powalony", "poważany", "powbijany", "powciągany", "powciskany", "powdychany", "powęszony", "powetowany", "powiadamiany", "powiadomiony", "powiązany", "powiedziany", "powiedzony", "powiększany", "powielany", "powielony", "powierzany", "powierzony", "powieszony", "powiewany", "powinszowany", "powitany", "powity", "powkładany", "powlekany", "powłóczony", "powodowany", "powołany", "powoływany", "powożony", "powpychany", "powrócony", "powrzucany", "powsadzany", "powściągnięty", "powspominany", "powstrzymany", "powtarzany", "powtórzony", "powybierany", "powybijany", "powycierany", "powycinany", "powyciskany", "powydawany", "powyganiany", "powyginany", "powyjaśniany", "powyjmowany", "powyłączany", "powymiatany", "powymieniany", "powynoszony", "powypełniany", "powypisywany", "powyrywany", "powyrzucany", "powystrzelany", "powysyłany", "powywalany", "powywieszany", "powywracany", "powzięty", "pozabawiany", "pozabijany", "pozacierany", "pożądany", "pożądlony", "pozadzierany", "pozakładany", "pozaklinany", "pozałatwiany", "pozamiatany", "pozamieniany", "pozamrażany", "pozamykany", "pozapalany", "pozapinany", "pozapisywany", "pozapraszany", "pożarty", "pozasłaniany", "pozastrzelany", "pozatykany", "pozbawiany", "pozbawiony", "pozbierany", "pozbyty", "pozbywany", "pozdejmowany", "pozdrawiany", "pozdrowiony", "pożegnany", "pożerany", "pozmiatany", "pozmieniany", "pozmywany", "poznaczony", "poznany", "poznawany", "poznęcany", "pozorowany", "pozostawiany", "pozostawiony", "pozowany", "pozrywany", "pozszywany", "pożuty", "pozwalniany", "pozwany", "pozwiązywany", "pozwiedzany", "pozwolony", "pożyczany", "pożyczony", "pozyskany", "pożyty", "pozywany", "pożywiany", "pożywiony", "praktykowany", "prany", "prasowany", "prawiony", "prażony", "precyzowany", "preferowany", "prenumerowany", "prezentowany", "próbowany", "procesowany", "produkowany", "profanowany", "profilowany", "prognozowany", "programowany", "projektowany", "proklamowany", "prolongowany", "promieniowany", "promowany", "propagowany", "proponowany", "prosperowany", "prostowany", "proszkowany", "proszony", "protestowany", "protokołowany", "prowadzony", "prowokowany", "pruty", "pryskany", "pryśnięty", "przeanalizowany", "przearanżowany", "przebaczany", "przebaczony", "przebadany", "przebiegnięty", "przebierany", "przebijany", "przebity", "przebolony", "przebrany", "przebudowany", "przebudowywany", "przebudzany", "przebudzony", "przebukowany", "przebyty", "przebywany", "przeceniany", "przeceniony", "przechlapany", "przechodzony", "przechowany", "przechowywany", "przechrzcony", "przechwycony", "przechwytywany", "przechylany", "przechylony", "przechytrzany", "przechytrzony", "przeciągany", "przeciągnięty", "przeciążany", "przeciążony", "przeciekany", "przecierany", "przecierpiany", "przecięty", "przecinany", "przeciskany", "przeciśnięty", "przeciwstawiany", "przećwiczony", "przeczekany", "przeczesany", "przeczesywany", "przeczołgany", "przeczuty", "przeczuwany", "przeczyszczony", "przeczytany", "przedarty", "przedawkowany", "przedawkowywany", "przedekorowany", "przedłożony", "przedłużany", "przedłużony", "przedmuchany", "przedobrzony", "przedostany", "przedostawany", "przedsiewzięty", "przedstawiany", "przedstawiony", "przedymany", "przedyskutowany", "przedzierany", "przedziurawiony", "przedziurkowany", "przeegzaminowany", "przefaksowany", "przefarbowany", "przefasonowany", "przefasowany", "przefaxowany", "przefiltrowany", "przeformowany", "przeforsowany", "przegadany", "przeganany", "przeganiany", "przegapiany", "przegapiony", "przegięty", "przeginany", "przeglądany", "przeglądnięty", "przegłodzony", "przegłosowany", "przegoniony", "przegotowany", "przegotowywany", "przegrabiony", "przegradzany", "przegrany", "przegrupowany", "przegrupowywany", "przegrywany", "przegryzany", "przegryziony", "przegrzany", "przegrzebany", "przegrzewany", "przehandlowany", "przeholowany", "przeinstalowany", "przeistoczony", "przejadany", "przejaskrawiany", "przejaśniony", "przejawiany", "przejawiony", "przejechany", "przejęty", "przejeżdżany", "przejmowany", "przejrzany", "przekabacany", "przekabacony", "przekablowany", "przekalibrowany", "przekalkulowany", "przekarmiany", "przekąszony", "przekazywany", "przekierowany", "przekierowywany", "przekimany", "przekładany", "przeklejony", "przeklęty", "przeklinany", "przeklnięty", "przekłuty", "przekonany", "przekonfigurowany", "przekonstruowany", "przekonwertowany", "przekonywany", "przekopany", "przekopywany", "przekoziołkowany", "przekraczany", "przekręcany", "przekręcony", "przekreślany", "przekreślony", "przekroczony", "przekrojony", "przekrzyczony", "przekrzywiony", "przekształcany", "przekształcony", "przekupiony", "przekupywany", "przekuty", "przekwalifikowany", "przełączany", "przełączony", "przeładowany", "przeładowywany", "przełamany", "przełamywany", "przelany", "przelatywany", "przeleciany", "przelewany", "przeleżany", "przelicytowany", "przeliczany", "przeliczony", "przeliterowany", "przełknięty", "przełożony", "przełykany", "przełyknięty", "przemalowany", "przemalowywany", "przemaszerowany", "przemawiany", "przemeblowany", "przemęczony", "przemielony", "przemieniany", "przemierzony", "przemieszczany", "przemieszczony", "przemijany", "przemilczany", "przemilczony", "przeminięty", "przemknięty", "przemodelowany", "przemusztrowany", "przemycany", "przemycony", "przemyślany", "przemyślony", "przemyty", "przemywany", "przenegocjowany", "przeniesiony", "przenikany", "przeniknięty", "przenoszony", "przeobrażany", "przeobrażony", "przeoczany", "przeoczony", "przeorany", "przeorganizowany", "przeorientowany", "przepadany", "przepakowany", "przepalony", "przeparkowany", "przepchany", "przepchnięty", "przepędzany", "przepędzony", "przepełniany", "przepełniony", "przepijany", "przepiłowany", "przepisany", "przepisywany", "przepity", "przepłacany", "przepłacony", "przepłakany", "przeplanowany", "przepłoszony", "przepłukany", "przepłukiwany", "przepłynięty", "przepływany", "przepompowany", "przepompowywany", "przepowiadany", "przepowiedziany", "przepracowany", "przepracowywany", "przeprany", "przeprawiany", "przeprawiony", "przeprogramowany", "przeprojektowany", "przeprowadzany", "przeprowadzony", "przepuszczany", "przepuszczony", "przepychany", "przepytany", "przepytywany", "przerąbany", "przerabiany", "przeradzany", "przerastany", "przerażony", "przeredagowany", "przerejestrowany", "przerobiony", "przerodzony", "przerośnięty", "przerwany", "przerysowany", "przerywany", "przerzedzany", "przerzucany", "przerzucony", "przesączony", "przesadzany", "przesądzany", "przesadzony", "przesądzony", "prześcigany", "prześcignięty", "przesiadany", "przesiadywany", "przesiany", "przesiedlany", "przesiedlony", "przesiedziany", "przesiewany", "przesilony", "przeskakiwany", "przeskalowany", "przeskanowany", "przeskoczony", "przeskrobany", "prześladowany", "przesłaniany", "przesłany", "prześledzony", "prześlizgnięty", "przesłodzony", "przesłonięty", "przesłuchany", "przesłuchiwany", "przesmarowany", "przesolony", "przesortowany", "przespany", "prześpiewany", "przessany", "przestawiany", "przestawiony", "przestemplowany", "przestraszony", "przestrojony", "przestrzegany", "przestrzelony", "przestudiowany", "przesunięty", "przesuwany", "prześwietlany", "prześwietlony", "przesyłany", "przesypany", "przesypiany", "przesypywany", "przeszarżowany", "przeszczepiany", "przeszczepiony", "przeszkadzany", "przeszkolony", "przeszmuglowany", "przeszukany", "przeszukiwany", "przeszyty", "przeszywany", "przetaczany", "przetańczony", "przetapetowany", "przetarty", "przetestowany", "przetkany", "przetoczony", "przetopiony", "przetrącony", "przetransformowany", "przetransmitowany", "przetransponowany", "przetransportowany", "przetrawiony", "przetrwany", "przetrząsany", "przetrząśnięty", "przetrzepany", "przetrzymany", "przetrzymywany", "przetwarzany", "przetworzony", "przewalany", "przewalczony", "przewaletowany", "przewalony", "przeważany", "przeważony", "przewertowany", "przewiązany", "przewiązywany", "przewidywany", "przewidziany", "przewiercany", "przewiercony", "przewieszany", "przewieszony", "przewietrzony", "przewieziony", "przewijany", "przewinięty", "przewitany", "przewodniczony", "przewodzony", "przewożony", "przewracany", "przewrócony", "przewyższany", "przeymierzany", "przeżarty", "przeżeglowany", "przeżegnany", "przeziębiony", "przezimowany", "przeznaczany", "przeznaczony", "przeżuty", "przezwyciężany", "przezwyciężony", "przeżyty", "przezywany", "przeżywany", "przodowany", "przpochlebiony", "przwdziewany", "przybastowany", "przybierany", "przybijany", "przybity", "przybliżany", "przybliżony", "przybrany", "przycelowany", "przycepiony", "przychylony", "przyciągany", "przyciągnięty", "przyciemniony", "przycięty", "przycinany", "przyciskany", "przyciśnięty", "przyciszony", "przyćmiewany", "przyćmiony", "przycumowany", "przyczepiany", "przyczesany", "przyczołgany", "przyczyniony", "przydepnięty", "przydeptany", "przyduszony", "przydzielany", "przydzielony", "przygarnięty", "przygaszony", "przygazowany", "przygładzany", "przygnębiany", "przygniatany", "przygnieciony", "przygotowany", "przygruchany", "przygrywany", "przygryzany", "przygryziony", "przygrzany", "przygwożdżony", "przyhamowany", "przyholowany", "przyjany", "przyjęty", "przyjmowany", "przyjrzany", "przykładany", "przyklejony", "przyklepany", "przykopany", "przykręcany", "przykręcony", "przykrócony", "przykryty", "przykrywany", "przykurzony", "przykuty", "przykuwany", "przyłączany", "przyłączony", "przylany", "przyłapany", "przylegany", "przylepiany", "przylepiony", "przyłożony", "przymierzony", "przymilany", "przymknięty", "przymocowany", "przymuszany", "przynależony", "przyniesiony", "przynoszony", "przynudzany", "przyostrzony", "przyozdabiany", "przyozdobiony", "przypadnięty", "przypakowany", "przypakowywany", "przypalany", "przypalony", "przyparty", "przypasowany", "przypatrywany", "przypatrzony", "przypieczętowany", "przypiekany", "przypierany", "przypięty", "przypilnowany", "przypiłowany", "przypinany", "przypisany", "przypisywany", "przypłacony", "przyplątany", "przypłynięty", "przypodobany", "przypominany", "przypomniany", "przyporządkowany", "przyprawiany", "przyprawiony", "przyprowadzony", "przypucowany", "przypudrowany", "przypuszczany", "przypuszczony", "przyrównany", "przyrządzany", "przyrządzony", "przysiadany", "przysiągnięty", "przyskrzydlony", "przyskrzyniany", "przyskrzyniony", "przysłaniany", "przysłany", "przysłodzony", "przysłoniony", "przysłuchiwany", "przysługiwany", "przysłużony", "przysmażany", "przysmażony", "przyspieszany", "przyspieszony", "przysporzony", "przysposobiony", "przyśrubowywany", "przyssany", "przystąpiony", "przystawiany", "przystawiony", "przystemplowany", "przystopowany", "przystosowany", "przystrojony", "przysunięty", "przysuwany", "przyswajany", "przyświecany", "przyświęcony", "przyswojony", "przysyłany", "przysypany", "przyszpilony", "przyszykowany", "przyszyty", "przyszywany", "przytaczany", "przytargany", "przytarty", "przytaszczany", "przytępiany", "przytępiony", "przytkany", "przytłaczany", "przytłoczony", "przytłumiony", "przytoczony", "przytrafiony", "przytroczony", "przytruwany", "przytrzasnięty", "przytrzymany", "przytrzymywany", "przytulany", "przytulony", "przytwierdzany", "przytwierdzony", "przytykany", "przyuczony", "przyuważony", "przywabiony", "przywalany", "przywalony", "przywarowany", "przywarty", "przywdziany", "przywiązany", "przywiązywany", "przywidziany", "przywieziony", "przywitany", "przywłaszczany", "przywłaszczony", "przywołany", "przywoływany", "przywożony", "przywracany", "przywrócony", "przyznaczony", "przyznany", "przyznawany", "przyzwalany", "przyzwany", "przyzwyczajany", "przyzwyczajony", "przyzywany", "psiamany", "pstrykany", "pstryknięty", "psuty", "publikowany", "puchnięty", "pucowany", "pudłowany", "pudrowany", "puknięty", "punktowany", "pustoszony", "puszczany", "puszczony", "puszkowany", "puszony", "pykany", "pytany", "rabowany", "rachowany", "racjonalizowany", "racjonowany", "raczony", "radowany", "raniony", "raportowany", "ratowany", "ratyfikowany", "reaktywowany", "realizowany", "reanimowany", "recytowany", "ręczony", "redagowany", "redukowany", "reformowany", "refowany", "regenerowany", "regionalizowany", "regulowany", "reinkarnowany", "rejestrowany", "reklamowany", "rekomendowany", "rekompensowany", "rekonstruowany", "rekreowany", "rekrutowany", "rekwirowany", "relacjonowany", "relaksowany", "remodulowany", "remontowany", "renegocjowany", "reorganizowany", "reperowany", "replikowany", "represejonowany", "reprezentowany", "reprodukowany", "resetowany", "resocjalizowany", "respektowany", "resuscytowany", "retuszowany", "rewanżowany", "rewidowany", "rezerwowany", "rezonowany", "rezygnowany", "reżyserowany", "robiony", "rodzony", "rojony", "rolowany", "romansowany", "roniony", "rozbawiany", "rozbawiony", "rozbierany", "rozbijany", "rozbity", "rozbłyśnięty", "rozbrajany", "rozbrojony", "rozbudowany", "rozbudowywany", "rozbudzany", "rozbudzony", "rozbujany", "rozcapierzony", "rozchmurzony", "rozchodzony", "rozchylany", "rozchylony", "rozciągany", "rozciągnięty", "rozcieńczany", "rozcieńczony", "rozcierany", "rozcięty", "rozcinany", "rozczarowany", "rozczarowywany", "rozczesany", "rozczłonkowany", "rozczulany", "rozczytany", "rozdany", "rozdawany", "rozdeptany", "rozdmuchany", "rozdmuchiwany", "rozdrabniany", "rozdrapany", "rozdrapywany", "rozdrażniany", "rozdrażniony", "rozduszony", "rozdwojony", "rozdysponowany", "rozdzielany", "rozdzielony", "rozdzierany", "rozdziewiczony", "rozebrany", "rozedrany", "rozegrany", "rozegrywany", "rozepchany", "rozerwany", "rozesłany", "rozgarnięty", "rozgaszczany", "rozgięty", "rozglaszany", "rozgłoszony", "rozgniatany", "rozgnieciony", "rozgniewany", "rozgoniony", "rozgraniczony", "rozgrany", "rozgromiony", "rozgrywany", "rozgryzany", "rozgryziony", "rozgrzany", "rozgrzebywany", "rozgrzeszony", "rozgrzewany", "rozhuśtany", "rozjaśniany", "rozjaśniony", "rozjechany", "rozjedzony", "rozjuszany", "rozjuszony", "rozkazany", "rozkazywany", "rozkładany", "rozklejany", "rozklejony", "rozkołysany", "rozkopany", "rozkopywany", "rozkoszowany", "rozkręcany", "rozkręcony", "rozkrojony", "rozkruszony", "rozkuty", "rozkuwany", "rozkwaszony", "rozkwaterowany", "rozkwitany", "rozkwitnięty", "rozłączony", "rozładowany", "rozładowywany", "rozłamany", "rozlany", "rozlewany", "rozliczany", "rozliczony", "rozlokowany", "rozłożony", "rozłupany", "rozluźniany", "rozmanażany", "rozmasowany", "rozmawiany", "rozmazany", "rozmazywany", "rozmiękczony", "rozmieniany", "rozmieniony", "rozmieszczany", "rozmieszczony", "rozminięty", "rozmnożony", "rozmontowany", "rozmówiony", "rozmrażany", "rozmrożony", "rozmyślany", "rozmyty", "różnicowany", "rozniecany", "roznieciony", "rozniesiony", "różniony", "roznoszony", "rozochocony", "rozpaczany", "rozpakowany", "rozpakowywany", "rozpalany", "rozpalony", "rozpamiętywany", "rozpaskudzany", "rozpatrywany", "rozpatrzony", "rozpędzany", "rozpędzony", "rozpętany", "rozpieszczany", "rozpieszczony", "rozpięty", "rozpiłowany", "rozpinany", "rozpisany", "rozpisywany", "rozplanowany", "rozpłaszczany", "rozpłaszczony", "rozplątany", "rozplątywany", "rozpłynięty", "rozpoczęty", "rozpoczynany", "rozpogodzony", "rozporządzany", "rozporządzony", "rozpościerany", "rozpostrzony", "rozpowiadany", "rozpowiedziany", "rozpowszechniany", "rozpowszechniony", "rozpoznany", "rozpoznawany", "rozpracowany", "rozpraszany", "rozprawiany", "rozprawiczony", "rozprawiony", "rozprostowany", "rozproszony", "rozprowadzany", "rozprowadzony", "rozpruty", "rozpruwany", "rozprzestrzeniany", "rozprzestrzeniony", "rozpuszczany", "rozpuszczony", "rozpychany", "rozpylany", "rozpylony", "rozpytany", "rozpytywany", "rozrastany", "rozreklamowany", "rozrobiony", "rozrośnięty", "rozróżniany", "rozróżniony", "rozruszany", "rozrysowany", "rozrywany", "rozrzucany", "rozsadzany", "rozsadzony", "rozsądzony", "rozścielony", "rozsiany", "rozsiekany", "rozsiewany", "rozsiodłany", "rozsławiany", "rozsławiony", "rozsmarowany", "rozsmarowywany", "rozśmieszany", "rozstany", "rozstąpiony", "rozstawany", "rozstawiany", "rozstawiony", "rozstrojony", "rozstrząsany", "rozstrzeliwany", "rozstrzelony", "rozstrzygany", "rozstrzygnięty", "rozsunięty", "rozsupłany", "rozświetlany", "rozświetlony", "rozsyłany", "rozsypany", "rozsypywany", "rozszarpany", "rozszarpywany", "rozszczepiany", "rozszczepiony", "rozszerzany", "rozszerzony", "rozszyfrowany", "roztaczany", "roztapiany", "roztarty", "roztoczony", "roztopiony", "roztrwoniony", "roztrząsany", "roztrzaskany", "rozumiany", "rozumowany", "rozwalany", "rozwalony", "rozwarty", "rozważany", "rozważony", "rozweselany", "rozweselony", "rozwiany", "rozwiązany", "rozwiązywany", "rozwidniany", "rozwiedziony", "rozwierany", "rozwiercony", "rozwieszany", "rozwieszony", "rozwiewany", "rozwieziony", "rozwikłany", "rozwinięty", "rozwlekany", "rozwodzony", "rozwścieczany", "rozwścieczony", "rozzłoszczony", "rugany", "ruinowany", "rujnowany", "runięty", "ruszany", "ruszony", "rwany", "ryczany", "ryglowany", "rymowany", "rysowany", "ryty", "ryzykowany", "rządzony", "rzeźbiony", "rżnięty", "rzucany", "rzucony", "rzygany", "sabotażowany", "sączony", "sadzany", "sadzony", "sądzony", "salutowany", "salwowany", "sankcjonowany", "satysfakcjonowany", "scalony", "scementowany", "scentrowany", "scharakteryzowany", "schładzany", "schlany", "schlapany", "schlebiony", "schłodzony", "schowany", "schroniony", "schrupany", "schrzaniony", "schwytany", "schylany", "ściągnięty", "ścielony", "ściemniany", "ściemniony", "ścierany", "ścierpiony", "ścięty", "ścigany", "ścinany", "ściskany", "ściśnięty", "ściszany", "ściszony", "sędziowany", "segregowany", "selekcjonowany", "separowany", "sępiony", "serwowany", "sfabrykowany", "sfajczony", "sfałszowany", "sfaulowany", "sfilmowany", "sfinalizowany", "sfinansowany", "sfingowany", "sformalizowany", "sformatowany", "sformowany", "sformułowany", "sforsowany", "sfotografowany", "shimmerowany", "siany", "siekany", "siorbany", "skadrowany", "skakany", "skalany", "skaleczony", "skalibrowany", "skalkulowany", "skalpowany", "skanalizowany", "skandowany", "skanowany", "skapitulowany", "skarcony", "skarżony", "skasowany", "skatalogowany", "skazany", "skażony", "skazywany", "skierowany", "składany", "składowany", "skłaniany", "sklasyfikowany", "skleciony", "sklejany", "sklejony", "sklepany", "skłócony", "skłoniony", "sklonowany", "sknocony", "skojarzony", "skolonizowany", "skołowany", "skombinowany", "skomentowany", "skompensowany", "skompletowany", "skomplikowany", "skomponowany", "skompresowany", "skompromitowany", "skomunikowany", "skonany", "skoncentrowany", "skończony", "skondensowany", "skonfigurowany", "skonfiskowany", "skonfrontowany", "skonkretyzowany", "skonsolidowany", "skonstruowany", "skonsultowany", "skonsumowany", "skontaktowany", "skontrolowany", "skoordynowany", "skopany", "skopiowany", "skorektowany", "skorumpowany", "skorygowany", "skorzystany", "skoszony", "skracany", "skradziony", "skręcany", "skręcony", "skremowany", "skreślany", "skreślony", "skrobany", "skrobnięty", "skrócony", "skrojony", "skropiony", "skruszony", "skrystalizowany", "skryty", "skrytykowany", "skrywany", "skrzecowany", "skrzepnięty", "skrzyczany", "skrzyty", "skrzywdzony", "skrzyżowany", "skserowany", "skubany", "skubnięty", "skulony", "skumulowany", "skupiany", "skupiony", "skupowany", "skurczony", "skuszony", "skuty", "skuwany", "skwitowany", "słany", "sławiony", "śledzony", "śliniony", "ślizgany", "słodzony", "słuchany", "słyszany", "smagany", "smarowany", "smażony", "śmiecony", "smuty", "smyrany", "snuty", "sondowany", "sortowany", "spafycikowany", "spakowany", "spalany", "spałaszowany", "spalony", "spałowany", "spamiętany", "spaprany", "sparafrazowany", "sparaliżowany", "sparowany", "spartaczony", "spartolony", "sparzony", "spasowany", "spatałaszony", "spauzowany", "spawany", "spawiony", "specjalizowany", "spędzany", "spędzony", "spekulowany", "spełniany", "spełniony", "spenetrowany", "spętany", "spierany", "spięty", "śpiewany", "spiłowany", "spinany", "spisany", "spiskowany", "spisywany", "spity", "spłacany", "spłacony", "splądrowany", "splajtowany", "splamiony", "spłaszczony", "splatany", "splątany", "spłatany", "spławiany", "spławiony", "spłodzony", "spłonięty", "spłoszony", "spłukany", "spłukiwany", "spluwany", "spływany", "spoczęty", "spoczywany", "spodziewany", "spojony", "spolaryzowany", "spoliczkowany", "sponiewierany", "sponsorowany", "spopielany", "spopielony", "spopularyzowany", "sportretowany", "sporządzany", "sporządzony", "spostrzegany", "spotęgowany", "spotkany", "spotykany", "spoufalany", "spowalniany", "spowiadany", "spowodowany", "spowolniony", "spoźniony", "spóźniony", "spożytkowany", "spożyty", "spożywany", "sprany", "sprasowany", "spraszany", "sprawdzony", "sprawiony", "sprawowany", "sprecyzowany", "spreparowany", "sprężany", "sprężony", "spróbowany", "sprofanowany", "sprofilowany", "sprostowany", "sproszkowany", "sproszony", "sprowadzany", "sprowadzony", "sprowokowany", "spryskany", "spryskiwany", "sprywatyzowany", "sprzątany", "sprzątnięty", "sprzeczany", "sprzedany", "sprzedawany", "sprzeniewierzony", "spudłowany", "spustoszony", "spuszczany", "spuszczony", "spychany", "ssany", "stabilizowany", "stacjonowany", "staczany", "staranowany", "starczany", "stargowany", "startowany", "stawiany", "stawiony", "stemplowany", "stenografowany", "stepowany", "sterowany", "sterroryzowany", "sterylizowany", "stłamszony", "stłumiony", "stnięty", "stoczony", "stołowany", "stonowany", "stopiony", "stopniowany", "storpedowany", "stosowany", "strącany", "stracony", "strącony", "strajkowany", "straszony", "stratowany", "strawiony", "streamowany", "stresowany", "streszczany", "streszczony", "strofowany", "strojony", "stroszony", "strugany", "struty", "strymowany", "strząsany", "strzaskany", "strząśnięty", "strzelony", "strzepany", "strzępiony", "strzepnięty", "strzepywany", "studiowany", "studzony", "stukany", "stuknięty", "stulony", "stwardniony", "stwarzany", "stwierdzany", "stwierdzony", "stworzony", "stykany", "stylizowany", "stymulowany", "sugerowany", "sumowany", "sunięty", "swatany", "swawolony", "świadczony", "świecony", "święcony", "świerzbiony", "świętowany", "świntuszony", "sycony", "sygnalizowany", "symulowany", "synchronizowany", "sypany", "sypnięty", "szachrowany", "szacowany", "szafowany", "szamotany", "szanowany", "szargany", "szarpany", "szarpnięty", "szarżowany", "szasowany", "szastany", "szatkowany", "szczędzony", "szczepiony", "szczerzony", "szczuty", "szczycony", "szczypany", "szczytowany", "szefowany", "szemrany", "szepnięty", "szeptany", "szerzony", "szkalowany", "szkicowany", "szklony", "szkodzony", "szkolony", "szlachtowany", "szlifowany", "szmuglowany", "szokowany", "szorowany", "szpachlowany", "szpanowany", "szperany", "szprycowany", "sztachnięty", "szturchany", "szturchnięty", "szturmowany", "szufladkowany", "szuflowany", "szukany", "szulerowany", "szwankowany", "szydełkowany", "szydzony", "szyfrowany", "szykanowany", "szykowany", "szyty", "taktowany", "tamowany", "tankowany", "tapetowany", "taplany", "taranowany", "targany", "targnięty", "targowany", "tarmoszony", "tarty", "tarzany", "tasowany", "taszczony", "tatuowany", "tchnięty", "telefonowany", "telegrfowany", "teleportowany", "temperowany", "teoretyzowany", "tępiony", "terroryzowany", "testowany", "tkany", "tknięty", "tłamszony", "tłoczony", "tłumaczony", "tłumiony", "toczony", "tolerowany", "tonowany", "topiony", "torowany", "torturowany", "towarzyszony", "trąbiony", "trącany", "tracony", "trącony", "trafiany", "trafiony", "tragizowany", "traktowany", "transferowany", "transformowany", "transmitowany", "transportowany", "tratowany", "trawiony", "trenowany", "tresowany", "triumfowany", "tropiony", "troszczony", "truty", "trwoniony", "trymowany", "tryskany", "tryśnięty", "tryumfowany", "trywializowany", "trzaskany", "trzasnięty", "trzepany", "trzepnięty", "trzepotany", "trzęsiony", "trzymany", "tuczony", "tułany", "tulony", "turlany", "tuszowany", "twistowany", "tworzony", "tykany", "tyranizowany", "tyrany", "tytułowany", "uaktualniany", "uaktualniony", "uaktywniany", "uaktywniony", "uargumentowany", "uatrakcyjniony", "ubabrany", "ubarwiany", "ubarwiony", "ubawiony", "ubezpieczany", "ubezpieczony", "ubezwłasnowolniony", "ubiczowany", "ubiegany", "ubierany", "ubijany", "ubity", "ubłagany", "ubliżany", "ubliżony", "ubolewany", "ubóstwiany", "ubrany", "ubroczony", "ubrudzony", "ucałowany", "ucharakteryzowany", "uchowany", "uchroniony", "uchwalany", "uchwalony", "uchwycony", "uchylany", "uchylony", "uciągnięty", "ucieleśniany", "ucierany", "ucierpiany", "ucięty", "ucinany", "uciskany", "uciśnięty", "uciszany", "uciszony", "uciułany", "ucywilizowany", "uczczony", "uczepiony", "uczesany", "uczęszczany", "uczony", "ucztowany", "uczuty", "uczyniony", "udany", "udaremniony", "udawany", "udekorowany", "udeptywany", "uderzany", "uderzony", "udobruchany", "udokumentowany", "udomawiany", "udomowiony", "udoskonalany", "udoskonalony", "udostępniany", "udostępniony", "udowadniany", "udowodniony", "Udramatyzowany", "udręczony", "udrożniony", "udupiony", "uduszony", "udzielany", "udzielony", "udźwignięty", "ueiwarygodniony", "ufany", "ufarbowany", "uformowany", "ufortyfikowany", "ufundowany", "ugadany", "uganiany", "ugaszany", "ugaszony", "ugięty", "uginany", "ugłaskany", "ugniatany", "ugodzony", "ugoszczony", "ugotowany", "ugrany", "ugruntowany", "ugryziony", "ugrzęznięty", "uhistoryzowany", "uhonorowany", "uiścity", "ujadany", "ujarzmiany", "ujarzmiony", "ujawniany", "ujawniony", "ujęty", "ujeżdżany", "ujeżdżony", "ujmowany", "ujrzany", "ukamieniowany", "ukarany", "ukartowany", "ukąszony", "ukatrupiony", "ukazany", "ukazywany", "ukierowany", "ukierunkowany", "układany", "uklepany", "ukłoniony", "ukłuty", "uknuty", "ukojony", "ukołysany", "ukończony", "ukonkretniony", "ukoronowany", "ukradziony", "ukręcany", "ukręcony", "ukrojony", "ukryty", "ukrywany", "ukrzyżowany", "ukształtowany", "ukuty", "ułagodzony", "ułaskawiany", "ułaskawiony", "ulatniany", "ułatwiany", "ułatwiony", "uleczany", "uleczony", "ulegany", "ulepiony", "ulepszany", "ulepszony", "ulokowany", "ulotniony", "ułożony", "umacniany", "umalowany", "umartwiany", "umawiany", "umazany", "umeblowany", "umiejscowiony", "umieszczany", "umieszczony", "umilany", "umilony", "umknięty", "umniejszany", "umniejszony", "umocniony", "umocowany", "umoczony", "umodelowany", "umorzony", "umotywowany", "umówiony", "umożliwiany", "umożliwiony", "umroczniony", "umyty", "unaoczniony", "unicestwiany", "unicestwiony", "uniemożliwainy", "uniemożliwiony", "unierochomiony", "uniesiony", "unieszczęśliwiany", "unieszczęśliwiony", "unieszkodliwiany", "unieszkodliwiony", "unieważniany", "unieważniony", "uniewinniony", "uniezależniony", "unikany", "uniknięty", "unormowany", "unoszony", "unowoczesniany", "unowocześniany", "uodporniony", "uogólniany", "upakowany", "upalany", "upalony", "upamiętniany", "upamiętniony", "upaństwowiony", "upaprany", "uparty", "upaskudzony", "upchany", "upchnięty", "upewniany", "upewniony", "upgradowany", "upichcony", "upiększany", "upiększony", "upierany", "upierdolony", "upięty", "upijany", "upilnowany", "upinany", "upity", "uplastyczniony", "upłynięty", "upodabniany", "upodobniony", "upojony", "upokorzany", "upokorzony", "upolowany", "upominany", "uporządkowany", "upowszechniony", "upozorowany", "upozowany", "uprany", "uprasowany", "upraszczany", "uprawdopodobniony", "uprawiany", "uproszczony", "uproszony", "uprowadzany", "uprowadzony", "uprzątany", "uprzątnięty", "uprzedony", "uprzedzany", "uprzyjemniany", "uprzyjemniony", "uprzykrzany", "uprzytomniony", "upubliczniany", "upubliczniony", "upudrowany", "upuszczany", "upuszczony", "upychany", "urabiany", "uraczany", "uradowany", "Urągany", "uratowany", "urażany", "urażony", "uregulowany", "urobiony", "uroniony", "urośnięty", "urozmaicany", "urozmaicony", "uruchamiany", "uruchomiony", "urwany", "urywany", "urządzany", "urządzony", "urzeczywistniany", "urzeczywistniony", "urżnięty", "usadowiony", "usadzony", "usamowolniony", "usankcjonowany", "usatyfakcjonowany", "uschnięty", "uściskany", "uścislony", "uściśnięty", "usidlony", "usiedzony", "uskładany", "uskoczony", "uskuteczniany", "uskuteczniony", "usłuchany", "usługiwany", "usłużony", "usłyszany", "usmażony", "uśmiany", "uśmiercany", "uśmiercony", "uśmierzony", "uspany", "uśpiony", "uspokajany", "uspokojony", "uspołeczniany", "usprawiedliwiany", "usprawiedliwiony", "usprawniony", "usprzątany", "ustabilizowany", "ustalany", "ustalony", "ustanawiany", "ustanowiony", "ustąpiony", "ustatkowany", "ustawiany", "ustawiony", "ustępowany", "ustosunkowany", "ustrojony", "ustrzegany", "ustrzelony", "usunięty", "ususzony", "usuwany", "uświadamiany", "uświadczony", "uświadomiony", "uświęcony", "uświniony", "usychany", "usypany", "usypiany", "usystematyzowany", "usytuowany", "uszanowany", "uszczelniany", "uszczęśliwiany", "uszczęśliwiony", "uszczuplony", "uszczypnięty", "uszkadzany", "uszkodzony", "uszlachetniany", "uszlachetniony", "usztywniony", "uszykowany", "uszyty", "utajniony", "utargowany", "utarty", "utemperowany", "utkany", "utknięty", "utkwiony", "utoczony", "utopiony", "utorowany", "utożsamiany", "utożsamiony", "utracony", "utrącony", "utrudniany", "utrudniony", "utrwalany", "utrwalony", "utrzymywany", "utuczony", "utulony", "utwierdzany", "utwierdzony", "utworzony", "utylizowany", "uwalniany", "uwalony", "uwarunkowany", "uważany", "uwiązany", "uwiązywany", "uwidoczniony", "uwieczniany", "uwieczniony", "uwielbiany", "uwielbiony", "uwieńczony", "uwierany", "uwierzony", "uwieszony", "uwieziony", "uwięziony", "uwijany", "uwikłany", "uwinięty", "uwity", "uwłaczany", "uwłaszczony", "uwodzony", "uwolniony", "uwsteczniany", "uwsteczniony", "uwydatniany", "uwypiklony", "uwzględniany", "uwzględniony", "użądlony", "uzależniany", "uzależniony", "uzasadniany", "uzasadniony", "uzbierany", "uzbrajany", "uzbrojony", "uzdrawiany", "uzdrowiony", "użerany", "uzewnętrzniany", "uzewnętrzniony", "uzgadniany", "uzgodniony", "uziemiony", "uzmysłowiony", "uznany", "uznawany", "uzupełniany", "uzupełniony", "uzurpowany", "użyczany", "użyczony", "uzyskany", "uzyskiwany", "użyty", "używany", "wabiony", "wąchany", "wachlowany", "wahany", "walczony", "wałkowany", "walnięty", "walony", "ważony", "wbijany", "wbity", "wcelowany", "wchłonięty", "wciągany", "wciągnięty", "wcielany", "wcielony", "wcierany", "wcięty", "wcinany", "wciskany", "wciśnięty", "wczepiony", "wczołgany", "wczuty", "wczytany", "wczytywany", "wdany", "wdarty", "wdawany", "wdepnięty", "wdeptany", "wdetonowany", "wdmuchiwany", "wdrapany", "wdrapywany", "wdrażany", "wdrążony", "wdrożony", "wduszony", "wdychany", "wdzierany", "wędkowany", "wentylowany", "wepchany", "wepchnięty", "werbowany", "weryfikowany", "wessany", "wetkany", "wetknięty", "wezwany", "wgłębiany", "wgniatany", "wgnieciony", "wgrany", "wgryzany", "wgryziony", "wiązany", "wibrowany", "widywany", "widziany", "wiedzony", "wielbiony", "wiercony", "wierzgany", "wierzony", "wieszany", "wietrzony", "więżony", "wikłany", "windowany", "winszowany", "wiosłowany", "wirowany", "witany", "wity", "wizualizowany", "wjeżdżany", "wkalkulowany", "wkładany", "wklejany", "wklejony", "wklepany", "wkłuty", "wkomponowany", "wkopany", "wkopywany", "wkraczany", "wkradany", "wkradziony", "wkręcany", "wkręcony", "wkupiony", "wkurwiany", "wkuty", "wkuwany", "włączany", "włączony", "władany", "władowany", "włamany", "włamywany", "wlany", "wlepiany", "wlepiony", "wlewany", "wliczany", "wliczony", "włożony", "wmanewrowany", "wmanipulowany", "wmawiany", "wmieszany", "wmówiony", "wmurowany", "wmuszony", "wnerwiany", "wnerwiony", "wniesiony", "wnikany", "wniknięty", "wnioskowany", "wnoszony", "wodowany", "wojowany", "wołany", "woskowany", "wożony", "wpajany", "wpakowany", "wparowany", "wpasowany", "wpatrywany", "wpędzany", "wpędzony", "wperswadowany", "wpieniony", "wpięty", "wpisany", "wpisywany", "wpłacany", "wpłacony", "wplatany", "wplątany", "wplątywany", "wpojony", "wpompowany", "wpraszany", "wprawiany", "wproszony", "wprowadzany", "wprowadzony", "wpuszczony", "wpychany", "wrabiany", "wręczany", "wrobiony", "wróżony", "wryty", "wrzucany", "wrzucony", "wrzynany", "wsadzany", "wsadzony", "wskazany", "wskazywany", "wskórany", "wskrzeszany", "wskrzeszony", "wślizgiwany", "wślizgnięty", "wsłuchany", "wsparty", "wspierany", "wspięty", "współczuty", "współodczuwany", "współtworzony", "współżyty", "wspomagany", "wspominany", "wspomniany", "wstąpiony", "wstawiany", "wstawiony", "wstrząsany", "wstrząśnięty", "wstrzelony", "wstrzykiwany", "wstrzyknięty", "wstrzymany", "wstrzymywany", "wstukany", "wsunięty", "wsuwany", "wsypany", "wszamany", "wszczepiany", "wszczepiony", "wszczęty", "wszczynany", "wszyty", "wtajemniczany", "wtajemniczony", "wtapiany", "wtargnięty", "wtarty", "wtaszczony", "wtłoczony", "wtopiony", "wtrącony", "wtryniany", "wtulany", "wtulony", "wtykany", "wwalony", "wwiercany", "wwiercony", "wwieziony", "wwożony", "wyartykułowany", "wyautowany", "wybaczany", "wybaczony", "wybadany", "wybatożony", "wybawiony", "wybebeszony", "wybełkotany", "wybiczowany", "wybielany", "wybielony", "wybierany", "wybijany", "wybity", "wybłagany", "wyblaknięty", "wybrandzlowany", "wybrany", "wybroniony", "wybrzydzany", "wybuchany", "wybuchnięty", "wybudowany", "wybudzany", "wybudzony", "wyburzany", "wyburzony", "wycackany", "wycałowany", "wyceniany", "wyceniony", "wychlany", "wychłostany", "wychodowany", "wychowany", "wychowywany", "wychrobotany", "wychwalany", "wychwycony", "wychylany", "wychylony", "wyciągany", "wyciągnięty", "wyciekany", "wycieniowany", "wycierany", "wycięty", "wycinany", "wyciskany", "wyciśnięty", "wyciszany", "wyciszony", "wycofany", "wyćwiczony", "wycyckany", "wycyganiony", "wyczarowany", "wyczarterowany", "wyczekany", "wyczekiwany", "wyczerpany", "wyczesany", "wyczołgany", "wyczołgiwany", "wyczuty", "wyczuwany", "wyczyniany", "wyczyszczony", "wyczytany", "wyczytywany", "wydalany", "wydalony", "wydany", "wydębiony", "wydedukowany", "wydelegowany", "wydepilowany", "wydeptywany", "wydłubany", "wydłubywany", "wydłużany", "wydłużony", "wydmuchany", "wydmuchiwany", "wydobyty", "wydobywany", "wydojony", "wydoroślany", "wydostany", "wydrany", "wydrapany", "wydrapywany", "wydrążony", "wydrukowany", "wydukany", "wyduszony", "wydychany", "wydziedziczony", "wydzielany", "wydzielony", "wydzierany", "wydzierżawiony", "wydziobany", "wydziwiany", "wydzwaniany", "wyedukowany", "wyedytowany", "wyeeliminowany", "wyegzekwowany", "wyeksmitowany", "wyekspediowany", "wyeksploatowany", "wyeksponowany", "wyeksportowany", "wyeliminowany", "wyemigrowany", "wyemitowany", "wyewoluowany", "wyfrunięty", "wygadany", "wygadywany", "wyganiany", "wygarbowany", "wygarniany", "wygarnięty", "wygasany", "wygaśnięty", "wygaszany", "wygaszony", "wygenerowany", "wygięty", "wyginany", "wygładzany", "wygładzony", "wygłaszany", "wygłodzony", "wygłosowany", "wygłoszony", "wygłówkowany", "wygnany", "wygolony", "wygoniony", "wygooglowany", "wygospodarowany", "wygotowany", "wygrany", "wygrawerowany", "wygrażany", "wygrywany", "wygryziony", "wygrzany", "wygrzebany", "wygrzebywany", "wygrzewany", "wygubiony", "wyhaczony", "wyhaftowany", "wyhamowany", "wyhodowany", "wyizolowany", "wyjadany", "wyjaśniany", "wyjaśniony", "wyjawiany", "wyjawiony", "wyjedzony", "wyjęty", "wyjmowany", "wykadrowany", "wykalibrowany", "wykalkulowany", "wykańczany", "wykantowany", "wykąpany", "wykaraskany", "wykarczowany", "wykarmiany", "wykasowany", "wykastrowany", "wykazany", "wykazywany", "wykierowany", "wykitowany", "wykiwany", "wykładany", "wyklarowany", "wyklepany", "wyklinany", "wykłócany", "wykluczany", "wykluczony", "wykluty", "wykłuty", "wykminiony", "wykolejony", "wykołowany", "wykombinowany", "wykonany", "wykończony", "wykonywany", "wykopany", "wykopnięty", "wykopywany", "wykorkowany", "wykorzeniany", "wykorzeniony", "wykorzystany", "wykorzystywany", "wykoszony", "wykpity", "wykradany", "wykradnięty", "wykręcany", "wykręcony", "wykreowany", "wykreślany", "wykreślony", "wykrochmalony", "wykrojony", "wykrwawiany", "wykrwawiony", "wykryty", "wykrywany", "wykrzesany", "wykrztuszony", "wykrzyczony", "wykrzykiwany", "wykrzyknięty", "wykrzywiany", "wykształcony", "wyksztuszony", "wykupiony", "wykupywany", "wykuty", "wykuwany", "wyłączany", "wyłączony", "wylądowany", "wyładowany", "wyładowywany", "wyłajany", "wyłamany", "wyłamywany", "wyłaniany", "wylansowany", "wylany", "wyłapany", "wyłapywany", "wyławiany", "wyleasingowany", "wyleczony", "wylęgany", "wylegimytowany", "wylewany", "wyłgany", "wylicytowany", "wyliczany", "wyliczony", "wylizany", "wylizywany", "wylogowany", "wyłoniony", "wylosowany", "wyłowiony", "wyłożony", "wyłudzany", "wyłudzony", "wyłupany", "wyłuskany", "wyłuskiwany", "wyłuszczony", "wyluzowany", "wymacany", "wymachiwany", "wymagany", "wymahiwany", "wymalowany", "wymamrotany", "wymanewrowany", "wymarzony", "wymasowany", "wymawiany", "wymazany", "wymazywany", "wymeldowany", "wymeldowywany", "wymiatany", "wymieciony", "wymieniany", "wymieniony", "wymierzany", "wymieszany", "wymigany", "wymigiwany", "wymijany", "wyminięty", "wymknięty", "wymoczony", "wymodelowany", "wymontowany", "wymordowany", "wymsknięty", "wymuszany", "wymyślany", "wymyślony", "wymyty", "wynagradzany", "wynagrodzony", "wynajdowany", "wynajdywany", "wynajęty", "wynajmowany", "wynaleziony", "wynarodowiony", "wynegocjowany", "wyniesiony", "wyniknięty", "wyniszczany", "wyniszczony", "wyniuchany", "wynoszony", "wynurzany", "wyobrażany", "wyobrażony", "wyodrębniony", "wyolbrzymiany", "wyolbrzymiony", "wyorbowany", "wyosiowany", "wyostrzany", "wyostrzony", "wypaczany", "wypakowany", "wypakowywany", "wypalany", "wypalony", "wypałowany", "wyparowany", "wyparty", "wypasany", "wypastowany", "wypatroszony", "wypatrywany", "wypatrzony", "wypchany", "wypchnięty", "wypędzany", "wypędzlowany", "wypełniany", "wypełniony", "wypersfadowany", "wyperswadowany", "wypierany", "wypięty", "wypijany", "wypinany", "wypisany", "wypisywany", "wypity", "wypłacany", "wypłacony", "wypłakany", "wypłakiwany", "wypłaszczony", "wyplatany", "wyplątany", "wypleniony", "wyplewiony", "wypłoszony", "wypłukany", "wypłukiwany", "wypluty", "wypluwany", "wypocony", "wypoczęty", "wypolerowany", "wypominany", "wypomniany", "wypompowany", "wypompowywany", "wyposażony", "wypowiadany", "wypowiedziany", "wypoziomowany", "wypożyczany", "wypracowany", "wypracowywany", "wyprany", "wyprasowany", "wypraszany", "wyprawiany", "wyprawiony", "wypróbowany", "wyprodukowany", "wyprojektowany", "wypromieniowany", "wypromowany", "wyprostowany", "wyprostowywany", "wyproszony", "wyprowadzany", "wyprowadzony", "wypróżniany", "wypróżniony", "wypruty", "wypruwany", "wyprzedany", "wyprzedawany", "wyprzedzany", "wyprzedzony", "wyprzęgany", "wypstrykany", "wypucowany", "wypuszczany", "wypuszczony", "wypychany", "wypytany", "wypytywany", "wyrąbany", "wyrabiany", "wyrąbywany", "wyratowany", "wyrażany", "wyrażony", "wyrecytowany", "wyręczany", "wyręczony", "wyregulowany", "wyrejestrowany", "wyremontowany", "wyreżyserowany", "wyrobiony", "wyrolowany", "wyrośnięty", "wyrównany", "wyrównywany", "wyróżniany", "wyróżniony", "wyrugowany", "wyruszany", "wyrwany", "wyrypany", "wyrysowany", "wyryty", "wyrywany", "wyrządzony", "wyrzeźbiony", "wyrżnięty", "wyrzucany", "wyrzucony", "wyrzygany", "wyrzynany", "wyrzywany", "wysączony", "wysadzany", "wysadzony", "wyschnięty", "wyściskany", "wyselekcjonowany", "wysępiony", "wysiadywany", "wysiedzony", "wysilany", "wysilony", "wyskakiwany", "wyskalowany", "wyskoczony", "wyskrobany", "wyskubywany", "wysłany", "wyśledzony", "wyślizgiwany", "wyślizgnięty", "wysłowiony", "wysłuchany", "wysłuchiwany", "wysmagany", "wysmarkany", "wysmarowany", "wysmażany", "wysmażony", "wyśmiany", "wyśmiewany", "wysmołowany", "wysmyrany", "wyśniony", "wysnuty", "wysnuwany", "wysondowany", "wyspecjalizowany", "wyśpiewany", "wyśpiewywany", "wyspowiadany", "wysprzątany", "wysprzedany", "wyssany", "wystartowany", "wystawiony", "wysterelizowany", "wysterylizowany", "wystosowany", "wystosowywany", "wystraszony", "wystrojony", "wystrugany", "wystrychnięty", "wystrzegany", "wystrzelany", "wystrzeliwany", "wystrzelony", "wystudzony", "wystukany", "wystukiwany", "wystygnięty", "wysunięty", "wysuszany", "wysuwany", "wyswatany", "wyświadczany", "wyświadczony", "wyświetlany", "wyświetlony", "wyswobodzony", "wysyłany", "wysypany", "wysypywany", "wysysany", "wyszabrowany", "wyszalany", "wyszarpany", "wyszarpnięty", "wyszasowany", "wyszczotkowany", "wyszczuplony", "wyszeptany", "wyszkolony", "wyszlifowany", "wyszorowany", "wyszperany", "wyszukany", "wyszukiwany", "wyszumiony", "wyszykowany", "wyszyty", "wytapetowany", "wytargany", "wytargowany", "wytarty", "wytarzany", "wytaszczony", "wytatuowany", "wytchnięty", "wytępiony", "wytknięty", "wytłoczony", "wytłumaczony", "wytłumiony", "wytoczony", "wytrąbiony", "wytrącany", "wytrącony", "wytransmitowany", "wytransportowany", "wytrenowany", "wytresowany", "wytriangulowany", "wytropiony", "wytruty", "wytrząsany", "wytrzasnięty", "wytrząśnięty", "wytrzebiony", "wytrzepany", "wytrzeszczany", "wytrzeźwiany", "wytrzymany", "wytrzymywany", "wytwarzany", "wytworzony", "wytyczony", "wytykany", "wytypowany", "wyuczony", "wywabiany", "wywabiony", "wywąchany", "wywalany", "wywalczony", "wywalony", "wywarty", "wywarzany", "wyważany", "wyważony", "wywęszany", "wywężykowany", "wywiany", "wywiązany", "wywiązywany", "wywierany", "wywiercony", "wywieszany", "wywieszony", "wywietrzony", "wywieziony", "wywijany", "wywindowany", "wywinięty", "wywłaszczony", "wywlekany", "wywnętrzniony", "wywnioskowany", "wywodzony", "wywolany", "wywoływany", "wywoskowany", "wywożony", "wywracany", "wywrócony", "wywróżony", "wywyższany", "wyżalony", "wyzbyty", "wyzdrowiony", "wyżebrany", "wyżerany", "wyzerowany", "wyzionięty", "wyznaczany", "wyznaczony", "wyznany", "wyznawany", "wyzwalany", "wyzwany", "wyzwolony", "wyzygzakowany", "wyżynany", "wyzyskany", "wyzyskiwany", "wyżyty", "wyzywany", "wyżywany", "wyżywiony", "wzbijany", "wzbity", "wzbogacany", "wzbogacony", "wzbraniany", "wzbudzany", "wzbudzony", "wzburzany", "wzburzony", "wżeniony", "wzięty", "wzmacniony", "wzmagany", "wzmocniony", "wznawiany", "wzniecany", "wznieciony", "wzniesięty", "wznoszony", "wznowiony", "wzorowany", "wzrośnięty", "wzruszony", "wzwyżany", "wzywany", "zaabordowany", "zaadaptowany", "zaadoptowany", "zaadresowany", "zaakcentowany", "zaakceptowany", "zaaklimatyzowany", "zaalarmowany", "zaanektowany", "zaangażowany", "zaanonsowany", "zaapelowany", "zaaplikowany", "zaaportowany", "zaaprobowany", "zaaranżowany", "zaaresztowany", "zaatakowany", "zabaczony", "zabalowany", "zabandażowany", "zabarwiony", "zabarykadowany", "zabawiany", "zabawiony", "zabepieczany", "zabetonowany", "zabezpieczony", "zabierany", "zabity", "zabłądzony", "zablefowany", "zabłocony", "zablokowany", "zabraniany", "zabrany", "zabrnięty", "zabroniony", "zabrudzony", "zabudowany", "zabukowany", "zabulony", "zaburzony", "zabutelkowany", "zacementowany", "zacerowany", "zachciany", "zachęcany", "zachęcony", "zachlapany", "zachodzony", "zachomikowany", "zachorowany", "zachowany", "zachowywany", "zachwalany", "zachwalony", "zachwiany", "zachwycony", "zaciągany", "zaciągnięty", "zaciążony", "zaciekawiony", "zaciemniany", "zaciemniony", "zacierany", "zacieśniony", "zacięty", "zacinany", "zaciskany", "zaciśnięty", "zaćmiony", "zacumowany", "zacytowany", "zaczadzony", "zaczarowany", "Zaczepiany", "zaczepiony", "zaczerpany", "zaczesany", "zaczęty", "zaczołgany", "zaczynany", "zadarty", "zadawalany", "zadawany", "zadbany", "zadebiutowany", "zadedykowany", "zadeklamowany", "zadeklarowany", "zademonstrowany", "zadenucjowany", "zadepeszowany", "zadeptany", "zadeptywany", "zadęty", "zadławiony", "żądlony", "zadłużany", "zadłużony", "zadokowany", "zadomowiony", "zadowalany", "zadrapany", "zadraśnięty", "zadręczany", "zadręczony", "zadrutowany", "zadurzany", "zadurzony", "zaduszony", "zadymiony", "zadźgany", "zadziobany", "zadziwiany", "zadziwiony", "zafakturowany", "zafałszowany", "zafarbowany", "zafiksowany", "zafundowany", "zagadany", "zagadnięty", "zagadywany", "zagajony", "zaganiany", "zagapiony", "zagarażowany", "zagarniany", "zagarnięty", "zagaszony", "zagazowany", "zagęszczony", "zagięty", "zaginany", "zaginięty", "zagłębiany", "zagłębiony", "zagłodzony", "zagłuszany", "zagłuszony", "zagmatwany", "zagnany", "zagnieżdżony", "zagojony", "zagoniony", "zagospodarowany", "zagotowany", "zagrabiony", "zagradzany", "zagrażany", "zagrodzony", "zagrywany", "zagryzany", "zagryziony", "zagrzany", "zagrzebany", "zagrzewany", "zagubiony", "zagwarantowany", "zahaczony", "zahamowany", "zahandlowany", "zaharowany", "zahartowany", "zahipnotyzowany", "zaholowany", "zaimitowany", "zaimplantowany", "zaimplementowany", "zaimprowizowany", "zainaugurowany", "zainfekowany", "zainicjowany", "zainkasowany", "zainscenizowany", "zainspirowany", "zainstalowany", "zainteresowany", "zaintrygowany", "zaintubowany", "zainwestowany", "zaizolowany", "zajadany", "zajany", "zajarany", "zajechany", "zajęty", "zajmowany", "zakablowany", "zakamuflowany", "zakasany", "zakasowany", "zakąszany", "zakatalogowany", "zakatowany", "zakatrupiony", "zakazany", "zakażany", "zakazywany", "zakiszony", "zakładany", "zaklasyfikowany", "zaklejany", "zaklejony", "zaklepany", "zaklepywany", "zaklinany", "zaklinowany", "zakłócany", "zakłócony", "zaklopotany", "zakłuty", "zakneblowany", "zakodowany", "zakolczykowany", "zakolorowany", "zakołysany", "zakomunikowany", "zakończony", "zakonserwowany", "zakopany", "zakopywany", "zakorzeniany", "zakorzeniony", "zakoszony", "zakosztowany", "zakotwiczany", "zakotwiczony", "zakpiony", "zakradany", "zakręcany", "zakręcony", "zakreślany", "zakreślony", "zakrwawiony", "zakryty", "zakrywany", "zakrzyczany", "zakrzyknięty", "zakrzywiany", "zakrzywiony", "zaksięgowany", "zaktualizowany", "zaktywizowany", "zaktywowany", "zakumany", "zakupiony", "zakurzony", "zakuty", "zakuwany", "zakwaterowany", "zakwestionować", "zakwitnięty", "załączony", "załadowany", "załagodzony", "zalamany", "zalaminowany", "załamywany", "zalany", "załapany", "załatany", "załatwiany", "załatwiony", "zalatywany", "zalecany", "zalecony", "zaleczony", "zalegalizowany", "zalegany", "zalepiany", "zalepiony", "zalewany", "zaliczany", "zaliczony", "załkany", "zalogowany", "żałowany", "założony", "zaludniony", "zamacany", "zamachnięty", "zamącony", "zamalowany", "zamanewrowany", "zamanifestowany", "zamarkowany", "zamartwiany", "zamarynowany", "zamarzany", "zamarznięty", "zamaskowany", "zamawiany", "zamazany", "zamazywany", "zamęczany", "zamęczony", "zameldowany", "zamelinowany", "zamerykanizowany", "zamiatany", "zamieniany", "zamieniony", "zamieszany", "zamieszczany", "zamieszczony", "zamieszkany", "zamieszkiwany", "zaminowany", "zamknięty", "zamocowany", "zamoczony", "zamontowany", "zamordowany", "zamortyzowany", "zamotany", "zamówiony", "zamrażany", "zamroczony", "zamrożony", "zamulany", "zamurowany", "zamydlony", "zamykany", "zanalizowany", "zanegowany", "zaniechany", "zanieczyszczany", "zanieczyszczony", "zaniedbany", "zaniedbywany", "zaniepokojony", "zaniesiony", "zanihilowany", "zanikany", "zaniknięty", "zaniżany", "zaniżony", "zanoszony", "zanotowany", "zanucony", "zanudzany", "zanudzony", "zanurzany", "zanurzony", "zanużony", "zaobaczony", "zaobserwowany", "zaoferowany", "zaofiarowany", "zaogniany", "zaogniony", "zaokrąglany", "zaokrąglony", "zaokrętowany", "zaopatrywany", "zaopatrzony", "zaopiekowany", "zaorany", "zaostrzany", "zaostrzony", "zaoszczędzony", "zapadany", "zapakowany", "zapalany", "zapalony", "zapamiętany", "zapamiętywany", "zapanowany", "zaparkowany", "zaparowywany", "zaparzany", "zaparzony", "zapaskudzony", "zapauzowany", "zapchany", "zapędzany", "zapełniany", "zapełniony", "zaperfumowany", "zapeszany", "zapewniany", "zapewniony", "zapieczętowany", "zapierany", "zapięty", "zapijany", "zapinany", "zapisany", "zapisuwany", "zapity", "zapłacony", "zapładniany", "zaplamiony", "zaplanowany", "zaplątany", "zapłodniony", "zaplombowany", "zapobiegany", "zapodany", "zapodawany", "zapodziany", "zapokojony", "zapolowany", "zapominany", "zapomniany", "zapowiadany", "zapowiedziany", "zapoznany", "zapoznawany", "zapożyczony", "zapracowywany", "zaprany", "zaprasowywany", "zapraszany", "zaprawiony", "zaprenumerowany", "zaprezentowany", "Zaprogramowany", "zaprojektowany", "zaproponowany", "zaproszony", "zaprotokołowany", "zaprowadzany", "zaprowadzony", "zaprzątany", "zaprzeczany", "zaprzeczony", "zaprzedany", "zaprzedawany", "zaprzęgany", "zaprzepaszczany", "zaprzestany", "zaprzestawany", "zaprzyjaźniony", "zapudłowany", "zapunktowany", "zapuszczany", "zapuszczony", "zapuszkowany", "zapychany", "zapylany", "zapylony", "zapytany", "zarabiany", "zaranżowany", "zarażany", "zarażony", "zarecytowany", "zaręczany", "zaręczony", "zarejestrowany", "zareklamowany", "zarekomendowany", "zarekomondowany", "zarekwirowany", "zarezerwowany", "zarobiony", "żartowany", "zarwany", "zaryglowany", "zarymowany", "zarysowany", "zarywany", "zaryzykowany", "zarządzany", "zarżnięty", "zarzucany", "zarzynany", "zasadzony", "zaścielony", "zasegurowany", "zaserwowany", "zasiadany", "zasiany", "zasiedlony", "zasięgany", "zasięgnięty", "zasiewany", "zasilany", "zasilony", "zaskakiwany", "zaskarbiony", "zaskoczony", "zaskrobany", "zasłaniany", "zaślepiany", "zaślepiony", "zasłodzony", "zasłoniony", "zasłużony", "zasmakowany", "zaśmiecany", "zaśmiecony", "zasmradzany", "zasmrodzony", "zasmucany", "zasmucony", "zasolony", "zaspakajany", "zaśpiewany", "zaspokajany", "zaspokojony", "zasponsorowany", "zaśrubowywany", "zassany", "zastany", "zastąpiony", "zastawiany", "zastawiony", "zastępowany", "zastopowany", "zastosowany", "zastraszany", "zastraszony", "zastrzelony", "zasugerowany", "zasunięty", "zasuwany", "zaświadczony", "zaświecony", "zaświoniony", "zasyfiony", "zasygnalizowany", "zasymilowany", "zasymulowany", "zasypany", "zasypywany", "zasysany", "zaszachowany", "zaszantażowany", "zaszargany", "zaszczepiany", "zaszczepiony", "zaszczuty", "zaszczycany", "zaszczycony", "zaszeptany", "zaszeregowany", "zaszlachtowany", "zasznurowany", "zaszpachlowany", "zasztyletowany", "zaszufladkowany", "zaszyfrowany", "zaszyty", "zaszywany", "zataczany", "zatajany", "zatajony", "zatamowany", "zatankowany", "zatapiany", "zatargany", "zatarty", "zatelegrafowany", "zatemperowany", "zatęskniony", "zatkany", "zatknięty", "zatoczony", "zatonięty", "zatopiony", "zatracany", "zatracony", "zatriumfowany", "zatrudniany", "zatrudniony", "zatruty", "zatruwany", "zatrzaskiwany", "zatrzaśnięty", "zatrząśnięty", "zatrzymany", "zatrzymywany", "zatuszowany", "zatwierdzany", "zatwierdzony", "zatykany", "zatynkowany", "zatytułowany", "zauploadowany", "zauroczony", "zautomatyzowany", "zauważany", "zauważony", "zawadzany", "zawalany", "zawalczony", "zawalony", "zawarty", "zaważony", "zawdzięczany", "zawetowany", "zawężony", "zawiadamiany", "zawiadomiony", "zawiązany", "zawiązywany", "zawiedzony", "zawierany", "zawierzony", "zawieszany", "zawieszony", "zawieziony", "zawijany", "zawinięty", "zawiniony", "zawiśnięty", "zawitany", "zawładnięty", "zawłaszczony", "zawodzony", "zawojowany", "zawołany", "zawoskowany", "zawożony", "zawracany", "zawrócony", "zawstydzany", "zażądany", "zażartowany", "zazdroszczony", "zażegnany", "zażenowany", "zaznaczany", "zaznajomiony", "zaznany", "zaznawany", "zażyczony", "zażyty", "zażywany", "zbaczany", "zbadany", "zbagatelizowany", "zbajerowany", "zbałamucony", "zbalansowany", "zbalsamowany", "zbankrutowany", "zbawiany", "zbawiony", "zbesztany", "zbezczeszczony", "zbierany", "zbijany", "zbity", "zbliżony", "zbluzgany", "zbojkotowany", "zbrojony", "zbrukany", "zbszczecony", "zbudowany", "zbudzony", "zbuntowany", "zburzony", "zbyty", "zbywany", "zchwytany", "zcięty", "zciszony", "zdany", "zdarty", "zdeaktywowany", "zdecydowany", "zdefiniowany", "zdeflorowany", "zdegradowany", "zdejmowany", "zdeklarowany", "zdekodowany", "zdekompresowany", "zdekoncentrowany", "zdekonstruowany", "zdelegalizowany", "zdemaskowany", "zdementowany", "zdemolowany", "zdemontowany", "zdemoralizowany", "zdenerwowany", "zdeponowany", "zdeprymowany", "zdeptany", "zderzany", "zderzony", "zdestabilizowany", "Zdetonowany", "zdetronizowany", "zdewastowany", "zdewaulowany", "zdezerterowany", "zdezintegrowany", "zdezorientowany", "zdezynfektowany", "zdiagnozowany", "zdjęty", "zdławiony", "zdmuchiwany", "zdmuchnięty", "zdobyty", "zdobywany", "zdołowany", "zdominowany", "zdopingowany", "zdrabniany", "zdradzany", "zdradzony", "zdrapany", "zdrapywany", "zdrutowany", "zdruzgotany", "zduplikowany", "zduszony", "zdwojony", "zdyscyplinowany", "zdyskredytowany", "zdyskwalifikowany", "zdystansowany", "zdzielony", "zdzierany", "zdzierżony", "zdziesiątkowany", "Zdzwoniony", "zebrany", "zechciany", "zedytowany", "żegnany", "żeniony", "zepchnięty", "zepsuty", "żerowany", "zerwany", "zerżnięty", "zeskakiwany", "zeskanowany", "zeskrobywany", "zesłany", "ześlizgiwany", "ześlizgnięty", "zesmolony", "zespawiany", "zespolony", "zessany", "zestawiany", "zestawiony", "zestresowany", "zestrzeliwany", "zestrzelony", "zeswatany", "zeszklony", "zeszlifowany", "zetknięty", "zezłoszczony", "zeznany", "zeznawany", "zezwalany", "zezwolony", "zfinansowany", "zgadany", "zgadywany", "zgajany", "zganiony", "zgarnięty", "zgaśnięty", "zgaszony", "zgięty", "zginany", "zgładzony", "zgłaszany", "zgłębiany", "zgłębiony", "zgłośniony", "zgłoszony", "zgłuszony", "zgniatany", "zgnieciony", "zgnity", "zgnojony", "zgodzony", "zgolony", "zgoniony", "zgotowany", "zgrabiony", "zgrillowany", "zgromadzany", "zgromadzony", "zgrupowany", "zgrzeszony", "zgrzytany", "zgubiony", "zgwałcony", "zhackowany", "zhakowany", "zhańbiony", "zhandlowany", "zharmonizowany", "zidentyfikowany", "ziewany", "zignorowany", "zilustrowany", "zinfiltrowany", "zintegrowany", "zintensyfikowany", "zinterpretowany", "zinwentaryzowany", "zirytowany", "zjadany", "zjawiany", "zjednany", "zjednoczony", "zjedzony", "zjeżdżony", "zkontaktowany", "zkserowany", "złączony", "złagodzony", "złajany", "złamany", "zlany", "złapany", "zlecany", "zlecony", "zlekceważony", "zlepiany", "zlepiony", "zlewany", "zlicytowany", "zliczany", "zliczony", "zlikwidowany", "zlinczowany", "zlitowany", "zlizany", "zlizywany", "złoity", "zlokalizowany", "złomowany", "żłopany", "złowiony", "złożony", "złupiony", "złuszczany", "zluzowany", "zmacany", "zmącony", "zmagany", "zmagazynowany", "zmajstrowany", "zmaksylizowany", "zmanipulowany", "zmarnowany", "zmartwychwstany", "zmarznięty", "zmasakrowany", "zmaterializowany", "zmawiany", "zmazany", "zmazywany", "zmbobardowany", "zmiatany", "zmiażdżony", "zmiękczony", "zmielony", "zmieniany", "zmieniony", "zmierzany", "zmierzony", "zmierzwiony", "zmieszany", "zmieszczony", "zmiksowany", "zminiaturyzowany", "zminimalizowany", "zmniejszany", "zmniejszony", "zmobilizowany", "zmoczony", "zmodernizowany", "zmodyfikowany", "zmoknięty", "zmonopolizowany", "zmontowany", "zmostkowany", "zmotywowany", "zmówiony", "zmrożony", "zmrużony", "zmumifikowany", "zmuszany", "zmuszony", "zmutowany", "zmyślany", "zmyty", "zmywany", "znacjonalizowany", "znajdowany", "znajdywany", "znakowany", "znaleziony", "znany", "znęcany", "zneutralizowany", "zniechęcony", "znieczulony", "zniekształcany", "zniekształcony", "znienawidzony", "znieprawiony", "zniesiony", "zniesławiany", "zniesławiony", "zniewalany", "znieważany", "znieważony", "zniewolony", "zniszczony", "zniweczony", "zniwelowany", "zniżany", "zniżony", "znokautowany", "znormalniony", "znoszony", "znudzony", "zobaczony", "zobowiązany", "zobrazowany", "zogniskowany", "żonglowany", "zoomowany", "zoperowany", "zoptymalizowany", "zorbity", "zorganizowany", "zorientowany", "zostawiany", "zostawiony", "zpłacony", "zprowokowany", "zrabowany", "zrachowany", "zracjonalizowany", "zraniony", "zraportowany", "zrażany", "zrażony", "zrealizowany", "zrecenzowany", "zredagowany", "zredukowany", "zreferowany", "zreformowany", "zrefowany", "zrefundowany", "zregenerowany", "zrehabilitowany", "zreinkarnowany", "zreintegrowany", "zrekonfigurowany", "zrekonstruowany", "zrekrutowany", "zrekrystalizowany", "zrelacjonowany", "zrelaksowany", "zremiksowany", "zremisowany", "zreorganizowany", "zreperowany", "zreplikowany", "zresetowany", "zresocjalizowany", "zrestartowany", "zrestrukturyzowany", "zrewanżowany", "zrewidowany", "zrewolucjonizowany", "zrezygnowany", "zrobiony", "zrolowany", "zroszony", "zrównany", "zrównoważony", "zrównywany", "zróżnicowany", "zrozumiany", "zrugany", "zruinowany", "zrujnowany", "zrymowany", "zrywany", "zrzędzony", "zrzeszony", "zrzucany", "zrzucony", "zsumowany", "zsunięty", "zsuwany", "zsynchronizowany", "zsyntetyzowany", "zsypywany", "zszargany", "zszokowany", "zszyty", "zszywany", "ztarty", "żuty", "zutylizowany", "zużyty", "zużywany", "zwabiany", "zwabiony", "zwalany", "zwalczony", "zwalniany", "zwalony", "zwany", "zwaporyzowany", "zwątpiony", "zważany", "zważony", "zwędzony", "zwerbalizowany", "zwerbowany", "zweryfikowany", "zwęszony", "zwężony", "zwiastowany", "związany", "związywany", "zwichnięty", "zwiedzany", "zwiedzony", "zwiększony", "zwieńczony", "zwierzany", "zwieszany", "zwieszony", "zwietrzony", "zwijany", "zwilżony", "zwinięty", "zwizualizowany", "zwlekany", "zwodowany", "zwodzony", "zwołany", "zwolniony", "zwoływany", "zwożony", "zwracany", "zwrócony", "zwyciężany", "zwymiotowany", "życzony", "żygany", "zygzakowany", "zyskany", "zyskiwany", "żyty", "zżarty", "zżerany", "zżynany", "zżyty", "abdykowana", "absorbowana", "adaptowana", "administrowana", "adoptowana", "adorowana", "adresowana", "afiszowana", "agitowana", "akcentowana", "akceptowana", "aklimatyzowana", "akompaniowana", "aktualizowana", "aktywowana", "akumulowana", "alaromowana", "alienowana", "amerykanizowana", "amortyzowana", "amputowana", "analizowana", "angażowana", "anihilowana", "animowana", "anonsowana", "antropomorfizowana", "antydatowana", "anulowana", "apelowana", "aportowana", "aranżowana", "archiwizowana", "aresztowana", "argumentowana", "artykułowana", "ascendowana", "asekurowana", "asymilowana", "asystowana", "atakowana", "autoryzowana", "awanturowana", "babrana", "baczona", "badana", "bagatelizowana", "bajerowana", "bałamucona", "balangowana", "balansowana", "banalizowana", "bandażowana", "bankrutowana", "baraszkowana", "barwiona", "bawiona", "bazgrana", "bazowana", "bębniona", "bełkotana", "besztana", "biadolona", "biczowana", "bita", "błagana", "błaznowana", "blefowana", "błogosławiona", "blokowana", "bluzgana", "błyskana", "błyszcząca", "boczona", "bogacona", "bojkotowana", "boksowana", "bombardowana", "bopowana", "borowana", "brandzlowana", "brana", "brasowana", "bratana", "bredzona", "brnięta", "brodzona", "broniona", "brudzona", "brylowana", "budowana", "budzona", "bujana", "bulona", "bulwersowana", "bumelowana", "burzona", "butelkowana", "bywana", "cackana", "całowana", "capnięta", "cechowana", "celebrowana", "celowana", "ceniona", "cenzurowana", "chciana", "chlana", "chlapana", "chlapnięta", "chlastana", "chłodzona", "chlostana", "chlubiona", "chodowana", "chomikowana", "chorowana", "chowana", "chroniona", "chrupana", "chrzczona", "chuta", "chwalona", "chwycona", "chwytana", "chybotana", "chylona", "ciachnięta", "ciągana", "ciągnięta", "ciemiężona", "cierpiana", "cieszona", "cięta", "ciskana", "ciśnięta", "ciułana", "cmokana", "cmoknięta", "cofana", "cofnięta", "ćpana", "cucona", "cudzołożona", "cumowana", "ćwiartowana", "ćwiczona", "cykana", "cytowana", "czajona", "czarowana", "czczona", "czepiana", "czepiona", "czerpana", "czesana", "częstowana", "czochrana", "czołgana", "czuta", "czytana", "czyta", "darowana", "darta", "darzona", "datowana", "dawana", "dbana", "deaktywowana", "debatowana", "dedukowana", "dedykowana", "defibrylowana", "defilowana", "definiowana", "defraudowana", "degradowana", "degustowana", "deklamowana", "deklarowana", "dekodowana", "dekompresowana", "dekorowana", "dekretowana", "delegowana", "delektowana", "deliberowana", "demaskowana", "dementowana", "demolowana", "demonizowana", "demonstrowana", "demoralizowana", "denerwowana", "denuncjowana", "depeszowana", "depilowana", "deportowana", "deprawowana", "deptana", "deratyzowana", "destabilizowana", "destylowana", "desygnowana", "determinowana", "detonowana", "dewastowana", "dewaulowana", "dezaktywowana", "dezorientowana", "dezynfekowana", "diagnozowana", "dilowana", "dłubana", "dłużona", "dmuchana", "dmuchnięta", "dobiegana", "dobierana", "dobijana", "dobita", "dobrana", "dobudzona", "dobyta", "doceniana", "doceniona", "dochodzona", "dochowana", "dochowywana", "dociągnięta", "dociekana", "docięta", "docinana", "dociskana", "dociśnięta", "doczekana", "doczepiona", "doczołgana", "doczyszczona", "doczytana", "dodana", "dodawana", "dodrukowana", "dodrukowywana", "dofinansowana", "dofinansowywana", "dogadana", "dogadywana", "dogadzana", "doganiana", "doglądana", "doglądnięta", "dognana", "dogodzona", "dogoniona", "dograna", "dogryzana", "dogryziona", "dogrzana", "dogrzebana", "doinformowana", "dojeżdżana", "dojona", "dojrzana", "dojrzewana", "dokańczana", "dokarmiana", "dokarmiona", "dokazana", "dokazywana", "dokładana", "doklejona", "dokonana", "dokończona", "dokonywana", "dokopana", "dokopywana", "dokowana", "dokręcana", "dokręcona", "dokształcana", "dokształcona", "dokuczana", "dokumentowana", "dokupiona", "dołączana", "dołączona", "doładowana", "dolana", "dolewana", "doliczona", "dołowana", "dołożona", "domagana", "domalowana", "domknięta", "domniewywana", "domówiona", "domyślana", "domyślona", "domyta", "doniesiona", "donoszona", "dopadana", "dopadnięta", "dopakowana", "dopalona", "dopasowana", "dopasowywana", "dopatrywana", "dopatrzona", "dopchana", "dopchnięta", "dopełniana", "dopełniona", "dopieszczona", "dopięta", "dopijana", "dopilnowana", "dopingowana", "dopisana", "dopisywana", "dopita", "dopłacana", "dopłacona", "dopłynięta", "dopolerowana", "dopompowana", "dopowiedziana", "dopracowana", "dopracowywana", "doprana", "doprawiona", "doprecyzowana", "doproszona", "doprowadzana", "doprowadzona", "dopucowana", "dopuszczana", "dopuszczona", "dopytywana", "dorabiana", "doradzana", "doradzona", "doręczana", "doręczona", "dorobiona", "dorównana", "dorównywana", "dorwana", "dorysowana", "dorzucana", "dorzucona", "doścignięta", "dosiadana", "dosięgnięta", "doskoczona", "doskonalona", "dosładzana", "dosłana", "dosłyszana", "dosolona", "dośrodkowana", "dossana", "dostana", "dostąpiona", "dostarczana", "dostarczona", "dostawana", "dostawiana", "dostawiona", "dostosowana", "dostosowywana", "dostrajana", "dostrojona", "dostrzegana", "dosunięta", "dosuwana", "doświadczana", "doświetlona", "dosypana", "dosypywana", "doszkolona", "doszlifowana", "doszorowana", "doszukana", "doszukiwana", "doszyta", "dotankowana", "dotankowywana", "dotargana", "dotaszczona", "dotknięta", "dotleniona", "dotłumaczona", "dotowana", "dotrwana", "dotrzymana", "dotrzymywana", "dotykana", "douczana", "douczona", "dowalona", "dowieziona", "dowodzona", "dowożona", "doznana", "doznawana", "dozorowana", "dozowana", "dożyta", "dożywiona", "dramatyzowana", "drapana", "drapnięta", "draśnięta", "drażniona", "drążona", "dręczona", "drenowana", "drgana", "drgnięta", "drukowana", "dryblowana", "dryfowana", "drzemana", "dubbingowana", "dublowana", "duplikowana", "duszona", "dworowana", "dygotana", "dyktowana", "dymana", "dymiona", "dyrygowana", "dyscyplinowana", "dyskredytowana", "dyskryminowana", "dyskutowana", "dyskwalifikowana", "dysponowana", "dystansowana", "dystrybuowana", "dywagowana", "dźgana", "dźgnięta", "dziabnięta", "dziedziczona", "dziękowana", "dzielona", "dziergana", "dzierżona", "dziobana", "dziurawiona", "dziurkowana", "dźwigana", "dźwignięta", "edukowana", "edytowana", "egzaminowana", "egzekutowana", "egzekwowana", "ekscytowana", "ekshumowana", "ekskomunikowana", "eksmitowana", "ekspandowana", "eksperymentowana", "eksploatowana", "eksplorowana", "eksponowana", "eksportowana", "eksterminowana", "ekstradowana", "ekstrapolowana", "eliminowana", "emancypowana", "emanowaa", "emigrowana", "emitowana", "energetyzowana", "eskortowana", "etykietowana", "ewakuowana", "ewaluowana", "fabrykowana", "falowana", "fałszowana", "farbowana", "faszerowana", "faulowana", "faworyzowana", "fechtowana", "fermentowana", "ferowana", "figurowana", "filetowana", "filmowana", "filtrowana", "finalizowana", "finansowana", "firmowana", "fleszowana", "folgowana", "formułowana", "forsowana", "fotografowana", "fundowana", "gadana", "ganiana", "garbiona", "gardzona", "garnirowana", "gaszona", "gawędzona", "gaworzona", "gazowana", "gdakana", "gderana", "generalizowana", "generowana", "gięta", "gilgotana", "gładzona", "głaskana", "głodowana", "głodzona", "gloryfikowana", "głosowana", "głoszona", "głowiona", "gmatwana", "gmerana", "gnana", "gnębiona", "gnieciona", "gnita", "gnojona", "godzona", "gojona", "golnięta", "golona", "goniona", "googlowana", "gospodarowana", "goszczona", "gotowana", "grabiona", "grana", "grasowana", "gratulowana", "grillowana", "grilowana", "gromadzona", "gromiona", "grożona", "gruchana", "gruchnięta", "grupowana", "grywana", "gryziona", "grzana", "grzechotana", "gubiona", "gustowana", "gwałcona", "gwarantowana", "gwizdana", "gwizdnięta", "hackowana", "haftowana", "hajtnięta", "hamowana", "hańbiona", "handlowana", "harcowana", "harmonizowana", "harowana", "hartowana", "hibernowana", "hipnotyzowana", "hodowana", "holowana", "hołubiona", "honorowana", "hospitalizowana", "huknięta", "hulana", "huśtana", "idealizowana", "identyfikowana", "ignorowana", "igrana", "ilustrowana", "imitowana", "implantowana", "implodowana", "imponowana", "importowana", "improwizowana", "indokrynowana", "indukowana", "infekowana", "infiltrowana", "informowana", "ingerowana", "inhalowana", "inscenizowana", "inspirowana", "instalowana", "instruowana", "insynuowana", "integrowana", "interpretowana", "interweniowana", "intonowana", "intubowana", "inwestowana", "inwigilowana", "irytowana", "iskrzona", "izolowana", "jadana", "jawiona", "jazgotana", "jednoczona", "jedzona", "kablowana", "kadzona", "kalana", "kaleczona", "kalkulowana", "kamerowana", "kamienowana", "kamuflowana", "kanalizowana", "kantowanta", "kąpana", "kapitulowana", "kapowana", "karana", "karbonizowana", "karcona", "karczowana", "karmiona", "kartkowana", "kąsana", "kasowana", "kastrowana", "katalogowana", "katapultowana", "katowana", "katrupiona", "kierowana", "kimana", "kiszona", "kiwana", "kiwnięta", "kłaniana", "klapana", "klapnięta", "klarowana", "klasyfikowana", "klębiona", "klejona", "klepana", "klepnięta", "klikana", "kliknięta", "klonowana", "kłopotana", "kłuta", "knocona", "knuta", "kochana", "koczowana", "kodowana", "kojarzona", "kojfnięta", "kojona", "kolekcjonowana", "kolektywizowana", "kolidowana", "kolonizowana", "kolorowana", "koloryzowana", "kołowana", "kołysana", "kombinowana", "komenderowana", "komentowana", "komercjalizowana", "kompensowana", "komplementowana", "komplikowana", "komponowana", "kompromitowana", "komunikowana", "konana", "koncentrowana", "kończona", "konfabulowana", "konfiskowana", "konfrontowana", "konserwowana", "konspirowana", "konstruowana", "konsultowana", "konsumowana", "kontaktowana", "kontestowana", "kontrastowana", "kontrolowana", "kontrowana", "kontynuowana", "konwertowana", "konwojowana", "koordynowana", "kopana", "kopcona", "kopiowana", "kopnięta", "kopulowana", "korelowana", "korkowana", "koronowana", "korygowana", "korzona", "korzystana", "koszona", "kotwiczona", "kozaczona", "kozłowana", "kpita", "kradziona", "krajana", "krążona", "kręcona", "kremowana", "kreowana", "krochmalona", "krojona", "kropiona", "kruszona", "krystalizowana", "kryta", "krytykowana", "krzepnięta", "krzyczana", "krzyknięta", "krzywdzona", "krzywiona", "krzyżowana", "kserowana", "księgowana", "kształcona", "kształtowana", "kulona", "kultywowana", "kumulowana", "kupczona", "kupiona", "kupowana", "kupywana", "kurczona", "kurowana", "kursowana", "kurzona", "kuszona", "kuta", "kwalifikowana", "kwestionowana", "łączona", "ładowana", "łagodzona", "łajdaczona", "lakierowana", "łamana", "lamentowana", "lansowana", "lana", "łapana", "łaskotana", "łaszona", "latana", "łatana", "lawirowana", "leczona", "legalizowana", "legitymowana", "lekceważona", "lepiona", "lewitowana", "liberowana", "licencjonowana", "licytowana", "liczona", "likwidowana", "linczowana", "liniowana", "literowana", "litowana", "lizana", "liznięta", "lobbowana", "lokalizowana", "losowana", "łowiona", "łożona", "lubiana", "łudzona", "lunatykowana", "łupana", "łupiona", "łuskana", "lustrowana", "łuszczona", "luzowana", "łykana", "łyknięta", "łyżeczkowana", "macana", "machana", "machnięta", "mącona", "maczana", "maganyzowana", "maglowana", "majaczona", "majsterkowana", "majtana", "maksymalizowana", "malowana", "maltretowana", "mamiona", "mamrotana", "manewrowana", "manifestowana", "manipulowana", "markowana", "marnotrawiona", "marnowana", "marszczona", "marynowana", "marznięta", "masakrowana", "maskowana", "masowana", "masturbowana", "mataczona", "materializowana", "mawiana", "mazana", "maznięta", "męczona", "meldowana", "merdana", "metabolizowana", "miażdżona", "mielona", "mierzona", "mierzwiona", "mieszana", "miętolona", "migana", "migdalona", "migotana", "mijana", "miksowana", "milowana", "minięta", "minimalizowana", "miotana", "mistyfikowana", "mitygowana", "mizdrzona", "mlana", "mniemana", "mnożona", "mobilizowana", "mocowana", "moczona", "modelowana", "modernizowana", "modlona", "modulowana", "modyfikowana", "molestowana", "monitorowana", "monopolizowana", "montowana", "mordowana", "motywowana", "mówiona", "mrożona", "mrugana", "mrużona", "muskana", "mutowana", "mydlona", "mylona", "myszkowana", "myta", "nabazgrana", "nabiegana", "nabierana", "nabita", "nabrana", "nabrojona", "nabrudzona", "nabyta", "nabywana", "nacelowana", "nachapana", "nachodzona", "nachwalona", "nachylona", "naciągana", "naciągnięta", "nacierana", "nacięta", "nacinana", "naciskana", "naciśnięta", "nacjonalizowana", "naczepiona", "nadana", "nadawana", "nadchodzona", "nadciągana", "nadciągnięta", "nadcięta", "nadesłana", "nadgoniona", "nadgryzana", "nadgryziona", "nadinterpretowana", "nadłożona", "nadmieniana", "nadmieniona", "nadmuchana", "nadrabiana", "nadrobiona", "nadskakiwana", "nadsłuchiwana", "nadstawiana", "nadstawiona", "nadszarpnięta", "naduszona", "nadużyta", "nadużywana", "nadwerężana", "nadwyrężana", "nadwyrężona", "nadziana", "nadzorowana", "naelektryzowana", "nafaszerowana", "nagabywana", "nagadana", "nagięta", "naginana", "nagłaszana", "nagłośniona", "nagoniona", "nagradzana", "nagrana", "nagrodzona", "nagromadzona", "nagrywana", "nagryzmolona", "nagrzana", "nagrzebana", "nagrzewana", "nagwizdana", "naigrywana", "najechana", "najęta", "najmowana", "nakarmiana", "nakarmiona", "nakazana", "nakazywana", "nakierowana", "nakierowywana", "nakładana", "nakłamana", "nakłaniana", "naklejana", "naklejona", "naklepana", "nakłoniona", "nakłuta", "nakłuwana", "nakopana", "nakręcana", "nakręcona", "nakreślana", "nakreślona", "nakruszona", "nakryta", "nakrywana", "nakrzyczana", "nakupiona", "naładowana", "nalana", "nałapana", "nalepiona", "nalewana", "naliczona", "nałowiona", "nałożona", "namaczana", "namagnetyzowana", "namalowana", "namaszczana", "namaszczona", "namawiana", "namęczona", "namierzana", "namieszana", "namoczona", "namówiona", "namydlana", "namyślona", "naniesiona", "naoliwiana", "naoliwiona", "naopowiadana", "naostrzona", "napadana", "napadnięta", "napakowana", "napalona", "naparzana", "napastowana", "napawana", "napchana", "napędzana", "napełniana", "napełniona", "napierana", "napiętnowana", "napięta", "napinana", "napisana", "napluta", "napływana", "napoczęta", "napojona", "napompowana", "napotkana", "napotykana", "napraszana", "naprawiana", "naprawiona", "naprężana", "naprężona", "napromieniowana", "naprostowana", "naprowadzana", "naprowadzona", "napsuta", "napuszczana", "napuszczona", "napychana", "napytana", "narąbana", "naradzana", "naradzona", "narastana", "narażana", "narażona", "nareperowana", "narkotyzowana", "narodzona", "naruszana", "naruszona", "narwana", "narysowana", "narzucana", "narzucona", "nasączana", "nasączona", "nasadzona", "nasiąkana", "nasilana", "nasilona", "naskakiwana", "naskoczona", "naskrobana", "naśladowana", "nasłana", "nasłuchana", "nasłuchiwana", "nasmarowana", "nastąpiona", "nastawiana", "nastawiona", "nastraszana", "nastrojona", "nastukana", "nasunięta", "nasuwana", "naświetlana", "nasycona", "nasyłana", "nasypana", "naszczana", "naszkicowana", "naszpikowana", "naszprycowana", "naszykowana", "naszyta", "naszywana", "natarta", "natchnięta", "natknięta", "natleniona", "natłuszczona", "natrafiona", "natrząsana", "natrząsnięta", "nauczana", "nauczona", "nawadniana", "nawalona", "nawiązana", "nawiązywana", "nawiedzana", "nawiedzona", "nawiercona", "nawiewana", "nawieziona", "nawigowana", "nawijana", "nawilżana", "nawilżona", "nawinięta", "nawlekana", "nawodniona", "nawoływana", "nawoskowana", "nawożona", "nawpychana", "nawracana", "nawrócona", "nawrzucana", "nawtykana", "nawymyślana", "nazbierana", "nazmyślana", "naznaczana", "naznaczona", "nazrywana", "nazwana", "nazywana", "nęcona", "negocjowana", "negowana", "nękana", "neutralizowana", "niańczona", "niecierpliwiona", "niedoceniana", "niedowidziana", "nienawidzona", "niesiona", "nikolona", "niszczona", "nitkowana", "niuchana", "niweczona", "niwelowana", "nokautowana", "nominowana", "notowana", "nucona", "numerowana", "nurtowana", "obaczona", "obadana", "obalana", "obalona", "obandażowana", "obarczana", "obarczona", "obawiana", "obchodzona", "obciągnięta", "obciążona", "obcięta", "obcinana", "obcyndalana", "obczajana", "obczajona", "obdarowana", "obdarta", "obdarzana", "obdarzona", "obdzielona", "obdzierana", "obdzwaniana", "obdzwoniona", "obejmowana", "oberwana", "obessana", "obezwładniana", "obezwładniona", "obfotografowana", "obfotografowywana", "obgadana", "obgadywana", "obgryzana", "obgryziona", "obiecana", "obiecywana", "obierana", "obijana", "obita", "objadana", "objaśniana", "objawiana", "objawiona", "objechana", "objęta", "objeżdżana", "obkręcana", "oblana", "obłapiana", "obłapywana", "obłaskawiana", "obłaskawiona", "obleciana", "oblegana", "oblewana", "obliczana", "obliczona", "oblizana", "obłowiona", "obłożona", "obluzowana", "obluzowywana", "obmacana", "obmacywana", "obmawiana", "obmyślana", "obmyślona", "obmyta", "obmywana", "obnażana", "obniżana", "obniżona", "obnoszona", "obowiązywana", "obozowana", "obrabiana", "obrabowana", "obracana", "obradowana", "obramowana", "obraniana", "obrana", "obrastana", "obrażana", "obrażona", "obrobiona", "obrócona", "obrodzona", "obroniona", "obrysowana", "obrywana", "obryzgana", "obrzezana", "obrzucana", "obrzucona", "obrzygana", "obsadzana", "obsadzona", "obściskiwana", "obserwowana", "obsiana", "obsikana", "obsikiwana", "obskakiwana", "obskoczona", "obskubana", "obskubywana", "obśliniana", "obśliniona", "obsługiwana", "obsłużona", "obsmarowana", "obstawiana", "obstawiona", "obstrzeliwana", "obsunięta", "obsuwana", "obsypana", "obsypywana", "obszukana", "obszukiwana", "obtaczana", "obtarta", "obtoczona", "obudzona", "obwąchana", "obwąchiwana", "obwiązana", "obwiązywana", "obwieszana", "obwieszczana", "obwieszczona", "obwieszona", "obwijana", "obwiniana", "obwinięta", "obwołana", "obyta", "obżerana", "ocalana", "ocalona", "ocechowana", "oceniana", "oceniona", "ocenzurowana", "ochładzana", "ochlapana", "ochlapywana", "ochłodzona", "ochłonięta", "ochraniana", "ochroniona", "ochrzaniana", "ochrzczona", "ociągana", "ocielona", "ocieplana", "ocieplona", "ocierana", "ocknięta", "ocucona", "ocuta", "oczarowywana", "oczekiwana", "oczerniana", "oczerniona", "oczyszczana", "oczyszczona", "odarta", "odbębniona", "odbetonowana", "odbezpieczana", "odbezpieczona", "odbijana", "odbita", "odblokowana", "odbudowana", "odbudowywana", "odbutowana", "odbyta", "odcedzana", "odchorowana", "odchowana", "odchudzana", "odchudzona", "odchylana", "odchylona", "odciągana", "odciągnięta", "odciążona", "odcierpiona", "odcięta", "odcinana", "odcisnięta", "odcumowana", "odcyfrowana", "odcyfrowywana", "odczarowana", "odczekana", "odczepiana", "odczepiona", "odczuta", "odczuwana", "odczyniona", "odczytana", "odczytywana", "oddalana", "oddana", "oddawana", "oddelegowana", "oddychana", "oddzielana", "oddzielona", "odebrana", "odegnana", "odegrana", "odejmowana", "odepchnięta", "oderwana", "odeskortowana", "odesłana", "odespana", "odessana", "odetkana", "odetnięta", "odezwana", "odfiltrowana", "odgadnięta", "odgadywana", "odganiana", "odgarniana", "odgarnięta", "odgięta", "odgniatana", "odgoniona", "odgradzana", "odgrażana", "odgrodzona", "odgruzowana", "odgrywana", "odgryzana", "odgryziona", "odgrzana", "odgrzebana", "odgrzebywana", "odgrzewana", "odgwizdana", "odhaczona", "odholowana", "odinstalowana", "odizolowana", "odjedzona", "odjęta", "odjonizowana", "odkażana", "odkażona", "odkładana", "odklejona", "odkochana", "odkodowana", "odkodowywana", "odkopana", "odkopywana", "odkorkowana", "odkręcana", "odkręcona", "odkrojona", "odkryta", "odkrywana", "odkupiona", "odkupywana", "odkurzana", "odkurzona", "odkuta", "odłączana", "odłączona", "odłamywana", "odlana", "odlatywana", "odlepiana", "odlewana", "odliczana", "odliczona", "odłożona", "odłupana", "odmachana", "odmachiwana", "odmalowana", "odmarszczona", "odmawiana", "odmeldowana", "odmieniana", "odmieniona", "odmierzana", "odmierzona", "odmieszana", "odmontowana", "odmówiona", "odmrażana", "odmrożona", "odnajdowana", "odnaleziona", "odnawiana", "odniesiona", "odnoszona", "odnotowana", "odnotowywana", "odnowiona", "odpakowana", "odpakowywana", "odpalana", "odpalona", "odpałzowana", "odparowana", "odparta", "odpędzana", "odpicowana", "odpieczętowana", "odpierana", "odpięta", "odpiłowana", "odpiłowywana", "odpinana", "odpisana", "odpisywana", "odpłacana", "odplamiona", "odplątana", "odpłynięta", "odpowietrzona", "odpracowana", "odpracowywana", "odprasowana", "odprawiana", "odprawiona", "odprężana", "odprostowana", "odprowadzana", "odprowadzona", "odpruta", "odpryskana", "odpukana", "odpukiwana", "odpuszczana", "odpuszczona", "odpychana", "odrąbana", "odrabiana", "odrąbywana", "odradzana", "odradzona", "odrapana", "odrastana", "odratowana", "odreagowana", "odremontowana", "odrestaurowana", "odrestaurowywana", "odrobaczana", "odrobiona", "odroczona", "odrodzona", "odrośnięta", "odróżniana", "odróżniona", "odrysowana", "odrywana", "odrzucana", "odrzucona", "odsączana", "odsączona", "odsadzona", "odseparowana", "odsiadywana", "odsiana", "odsiewana", "odsłaniana", "odsłonięta", "odsłuchana", "odsłuchiwana", "odsłużona", "odśnieżana", "odśnieżona", "odsolona", "odśpiewana", "odsprzedana", "odsprzedawana", "odstąpiona", "odstawiana", "odstawiona", "odstępowana", "odstraszana", "odstręczona", "odstresowana", "odstrzeliwana", "odstrzelona", "odsunięta", "odsuwana", "odświeżana", "odświeżona", "odsyłana", "odsypywana", "odsysana", "odszczekana", "odszczekiwana", "odsztafirowana", "odszukana", "odszyfrowana", "odszyfrowywana", "odszykowana", "odtrąbiona", "odtrącona", "odtruta", "odtwarzana", "odtworzona", "oduczona", "odurzona", "odwalana", "odwalona", "odwiązana", "odwiązywana", "odwiedzana", "odwiedzona", "odwieszona", "odwieziona", "odwijana", "odwinięta", "odwlekana", "odwodniona", "odwodzona", "odwołana", "odwoływana", "odwożona", "odwracana", "odwrócona", "odwzajemniona", "odwzorowana", "odżegnana", "odziana", "odziedziczona", "odznaczana", "odznaczona", "odzwieciedlona", "odzwierciedlana", "odzwoniona", "odzwyczajona", "odzyskana", "odzyskiwana", "odżyta", "odzywiana", "odżywiona", "oferowana", "ofiarowana", "ofiarowywana", "ogarniana", "ogarnięta", "oglądana", "ogłaszana", "ogłoszona", "ogłupiana", "ogłupiona", "ogłuszona", "ogołocona", "ogolona", "ograbiana", "ograbiona", "ograniczana", "ograniczona", "ograna", "ogrodzona", "ogryziona", "ogrzana", "ogrzewana", "okablowana", "okaleczona", "okantowana", "okąpana", "okazana", "okazywana", "okiełznana", "okładana", "okłamana", "okłamywana", "oklaskiwana", "oklejona", "oklepana", "okopana", "okopywana", "okpiona", "okradana", "okradziona", "okraszona", "okrążana", "okrążona", "okręcana", "okręcona", "określana", "określona", "okrojona", "okryta", "okrywana", "okrzyknięta", "okulawiona", "okupiona", "okupowana", "olana", "olewana", "olśnięta", "omamiona", "omawiana", "omdlewana", "omijana", "ominięta", "omotana", "omówiona", "onanizowana", "onieśmielana", "onieśmielona", "opadnięta", "opakowana", "opalana", "opalona", "opancerzona", "opanowana", "opanowywana", "oparta", "oparzona", "opasana", "opatentowana", "opatrywana", "opatrzona", "opatulona", "opchnięta", "opędzana", "opędzona", "operowana", "opętana", "opętywana", "opieczętowana", "opiekowana", "opierana", "opijana", "opisana", "opisywana", "opita", "opłacana", "opłacona", "opłakana", "opłakiwana", "opłukana", "opluta", "opluwana", "opływana", "opodatkowana", "opodatkowywana", "oponowana", "oporządzana", "oporządzona", "opowiadana", "opowiedziana", "opóźniana", "opóźniona", "opracowana", "opracowywana", "oprawiana", "oprawiona", "oprowadzana", "oprowadzona", "opróżniana", "opróżniona", "opryskana", "opryskiwana", "opublikowana", "opukana", "opuszczana", "opuszczona", "opychana", "opylona", "orana", "orbowana", "organizowana", "orientowana", "oroszona", "orzekana", "orżnięta", "osaczana", "osaczona", "osadzana", "osądzana", "osadzona", "osądzona", "oscylowana", "osiadana", "osiągana", "osiągnięta", "osiedlana", "osiedlona", "osiedzona", "osierocona", "osiodłana", "oskalpowana", "oskarżona", "oskrobana", "oskrzydlana", "oskrzydlona", "oskubana", "oskubywana", "osłabiana", "osłabiona", "oślepiana", "oślepiona", "oślepnięta", "ośliniana", "osłodzona", "osłoniona", "osłuchana", "osmalona", "ośmielona", "ośmieszana", "ośmieszona", "ostrzegana", "ostrzelana", "ostrzelita", "ostrzona", "ostudzona", "osunięta", "osuszana", "osuszona", "osuwana", "oswajana", "oświadczana", "oświadczona", "oświecana", "oświeciona", "oświetlana", "oświetlona", "oswobadzana", "oswobodzona", "oswojona", "oszacowana", "oszałamiana", "oszczana", "oszczędzana", "oszczędzona", "oszklona", "oszlifowana", "oszołomiona", "oszpecona", "oszukana", "oszukiwana", "oszwabiona", "otaczana", "otarta", "otoczona", "otruta", "otruwana", "otrząsana", "otrząśnięta", "otrzepana", "otrzeźwiona", "otrzymana", "otrzymywana", "otulona", "otumaniona", "otwierana", "otworzona", "otwarta", "owana", "owdowiona", "owiana", "owijana", "owinięta", "ozdabiana", "ozdobiona", "ozdrowiona", "ożeniona", "oznaczana", "oznaczona", "oznajmiana", "oznajmiona", "oznakowana", "ożyta", "ożywana", "ożywiana", "ożywiona", "pachnąca", "pacnąta", "pakowana", "paktowana", "pałana", "pałaszowana", "palnięta", "palona", "pamiętana", "panoszona", "paprana", "parafrazowana", "paraliżowana", "parkowana", "parowana", "partaczona", "parta", "parzona", "pastowana", "paszona", "patrolowana", "patroszona", "patrzona", "pauzowana", "pchana", "pchnięta", "pdholowana", "pedałowana", "pękana", "pęknięta", "pełniona", "penetrowana", "perforowana", "perfumowana", "perswadowana", "piastowana", "pichcona", "pielęgnowana", "pielona", "pieniona", "pieszczona", "piętnowana", "pięta", "pijana", "pikietowana", "piknikowana", "pikowana", "pilnowana", "pilotowana", "piłowana", "pisana", "pisywana", "pita", "płacona", "plądrowana", "plamiona", "planowana", "płaszczona", "plątana", "płatana", "pławiona", "plewiona", "płonąca", "płoszona", "plotkowana", "plugawiona", "płukana", "pluskana", "pluta", "pobaraszkowana", "pobierana", "pobita", "pobłażana", "pobłogosławiona", "pobrana", "pobrudzona", "pobudzana", "pobudzona", "pobujana", "pocałowana", "pocerowana", "pochłaniana", "pochlapana", "pochlebiana", "pochłonięta", "pochowana", "pochwalana", "pochwalona", "pochwycona", "pochylana", "pochylona", "pociachana", "pociągana", "pociągnięta", "pocierana", "pocieszana", "pocieszona", "pocięta", "pocona", "pocukrowana", "poćwiartowana", "poczesana", "poczęstowana", "poczęta", "poczochrana", "poczuta", "poczytana", "poczytywana", "podana", "podarowana", "podarta", "podawana", "podążona", "podbierana", "podbijana", "podbita", "podbudowana", "podbudowywana", "podburzana", "podburzona", "podchwycona", "podciągana", "podciągnięta", "podcierana", "podcięta", "podcinana", "podczepiona", "poddana", "poddawana", "podebrana", "podejmowana", "podejrzana", "podejrzewana", "podelektowana", "podeptana", "poderwana", "podesłana", "podglądana", "podgolona", "podgoniona", "podgryzana", "podgrzana", "podgrzewana", "podjadana", "podjedzona", "podjęta", "podkablowana", "podkarmiona", "podkładana", "podklejona", "podkolorowana", "podkołowana", "podkopana", "podkopywana", "podkradana", "podkradnięta", "podkręcana", "podkręcona", "podkreślana", "podkreślona", "podkształcona", "podkulona", "podkupiona", "podkurzona", "podkuta", "podłączana", "podłączona", "podładowana", "podłamana", "podlana", "podłapana", "podleczona", "podlegana", "podlewana", "podliczana", "podliczona", "podlizana", "podlizywana", "podłożona", "podmalowana", "podmieniana", "podmieniona", "podmuchana", "podmyta", "podnajęta", "podniecana", "podniecona", "podniesiona", "podnoszona", "podołana", "podopingowana", "podostrzona", "podotykana", "podpadnięta", "podpalana", "podpalona", "podparta", "podpatrywana", "podpatrzona", "podpieczętowana", "podpiekana", "podpierana", "podpięta", "podpiłowana", "podpinana", "podpisana", "podpisywana", "podpłacona", "podpłynięta", "podpompowana", "podporządkowana", "podporządkowywana", "podpowiadana", "podpowiedziana", "podprowadzana", "podpuszczana", "podpuszczona", "podpychana", "podpytana", "podrabiana", "podrapana", "podrasowana", "podratowana", "podrażniona", "podręczona", "podregulowana", "podreperowana", "podretuszowana", "podrobiona", "podroczona", "podróżowana", "podrygiwana", "podrywana", "podrzucana", "podrzucona", "podrzynana", "podsadzona", "podskubywana", "podsłuchana", "podsłuchiwana", "podsmażana", "podsmażona", "podśpiewywana", "podstawiana", "podstawiona", "podstemplowana", "podstrojona", "podsumowana", "podsumowywana", "podsunięta", "podsuwana", "podświetlana", "podsycana", "podsycona", "podsyłana", "podsypana", "podszczypywana", "podszkolona", "podszlifowana", "podszykowana", "podszyta", "podszywana", "podtapiana", "podtarta", "podtopiona", "podtrzymana", "podtrzymywana", "podtuczona", "poduczana", "podupadana", "poduszona", "podwajana", "podwalana", "podważana", "podwędzona", "podwiązana", "podwieszana", "podwieziona", "podwijana", "podwinięta", "podwojona", "podwożona", "podwyżana", "podwyższana", "podwyższona", "podyktowana", "podyskutowana", "podziabana", "podziałana", "podziałkowana", "podziękowana", "podzielona", "podziurawiona", "podziwiana", "podźwignięta", "poeksperymentowana", "pofarbowana", "pofatygowana", "pofilmowana", "poganiana", "pogardzana", "pogardzona", "pogarszana", "pogaszona", "pogładzona", "pogłaskana", "pogłębiana", "pogłębiona", "pogłośniona", "pogmatwana", "pognębiona", "pognieciona", "pogodzona", "pogoniona", "pogorszona", "pogotowana", "pograbiona", "pogrążana", "pogrążona", "pogrożona", "pogrubiana", "pogrubiona", "pogruchana", "pogruchotana", "pogrupowana", "pogrywana", "pogryzana", "pogryziona", "pogrzana", "pogrzebana", "pogubiona", "pogwałcana", "pohamowana", "pohandlowana", "poharatowana", "pohuśtana", "poinformowana", "poinstruowana", "pojednana", "pojęta", "pojmięta", "pojmowana", "pojona", "pokajana", "pokaleczona", "pokarana", "pokarmiona", "pokąsana", "pokatalogowana", "pokazana", "pokazywana", "pokiereszowana", "pokierowana", "pokiwana", "pokładana", "poklepana", "poklepywana", "pokłoniona", "pokłuta", "pokochana", "pokolorowana", "pokoloryzowana", "pokołysana", "pokombinowana", "pokomplikowana", "pokonana", "pokończona", "pokonywana", "pokopana", "pokrajana", "pokrążona", "pokręcona", "pokrojona", "pokruszona", "pokryta", "pokrywana", "pokrzepiana", "pokrzepiona", "pokrzyżowana", "pokuszona", "pokutowana", "połączona", "polakierowana", "połamana", "polana", "połapana", "połaskotana", "połatana", "polecana", "połechtana", "polecona", "poleczona", "polegana", "polemizowana", "polepszana", "polepszona", "polerowana", "polewana", "policzkowana", "policzona", "polimeryzowana", "polizana", "połknięta", "polowana", "połowiona", "położona", "polubiona", "poluźniona", "poluzowana", "połykana", "pomacana", "pomachana", "pomagana", "pomalowana", "pomarynowana", "pomasowana", "pomazana", "pomęczona", "pomiatana", "pomieszana", "pomieszczona", "pomijana", "pominięta", "pomiziana", "pomknięta", "pomnażana", "pomniejszana", "pomniejszona", "pomnożona", "pomoczona", "pompowana", "pomydlona", "pomylona", "pomyszkowana", "pomywana", "ponabijana", "ponaciskana", "ponadziewana", "ponaglana", "ponaglona", "ponagrywana", "ponaklejana", "ponakłuwana", "ponakrywana", "ponaprawiana", "ponawiana", "poniańczona", "poniechana", "ponieiwerana", "poniesiona", "poniszczona", "poniżana", "poniżona", "ponoszona", "ponowiona", "ponudzona", "poobcinana", "poobcowana", "poobczajana", "poobijana", "poobmacywana", "poobracana", "poobserwowana", "poodbijana", "poodcinana", "poodgryzana", "poodkurzana", "poodprawiana", "poodsuwana", "poodwalana", "pooglądana", "poograniczana", "poopalana", "poopiekana", "poopwiadana", "pootwierana", "popadana", "popakowana", "popalona", "poparta", "poparzona", "popchana", "popchnięta", "popędzana", "popędzona", "popękana", "popełniana", "popełniona", "poperfumowana", "popierana", "popieszczona", "popijana", "popilnowana", "popisana", "popita", "popłacona", "popłakiwana", "poplamiona", "poplątana", "popluskana", "popodcinana", "popodziwiana", "popoprawiana", "poprana", "poprasowana", "poprawiana", "poprawiona", "poproszona", "poprowadzona", "popryskana", "poprzebierana", "poprzeciągana", "poprzecinana", "poprzedzana", "poprzeglądana", "poprzeklinana", "poprzekopywana", "poprzemieszczana", "poprzenoszona", "poprzesadzana", "poprześladowana", "poprzestawiana", "poprzesuwana", "poprzewieszana", "poprzewracana", "poprzycinana", "poprzymierzana", "poprzytulana", "poprzywiązywana", "popsuta", "popudrowana", "popukana", "popularyzowana", "popuszczana", "popuszczona", "popychana", "popykana", "popytana", "porabiana", "porachowana", "poraniona", "poratowana", "porażona", "poręczona", "porównana", "porozbierana", "porozbijana", "porozciągana", "porozcinana", "porozdawana", "porozdzielana", "porozmieszczana", "poróżniona", "porozpędzana", "porozpieszczana", "porozprowadzana", "porozpruwana", "porozrzucana", "porozstawiana", "porozsyłana", "porozumiewana", "porozwalana", "porozwiązywana", "porozwieszana", "porozwożona", "portretowana", "poruszana", "poruszona", "porwana", "porysowana", "porywana", "porządkowana", "porządzona", "porzucana", "porzucona", "posądzana", "posadzona", "posądzona", "pościągana", "pościelona", "pościerana", "pościgana", "pościnana", "pościskana", "posegregowana", "posiadana", "posiana", "posiekana", "posilana", "posiłkowana", "posilona", "posiłowana", "posiniaczona", "posiorbana", "poskąpiona", "poskładana", "posklejana", "poskramiana", "poskręcana", "poskrobana", "poskromiona", "poskubana", "posłana", "posłodzona", "poślubiana", "poślubiona", "posługiwana", "posmakowana", "posmarowana", "posolona", "posortowana", "pospekulowana", "pospieszana", "pośpieszana", "pośpiewana", "pospinana", "pospłacana", "posprawdzana", "posprzątana", "posprzedawana", "pośredniczona", "possana", "postanowiona", "postana", "postarana", "postawiona", "postemplowana", "posterowana", "postradana", "postraszona", "postrugana", "postrzegana", "postrzelana", "postrzelona", "postukana", "postymulowana", "posunięta", "posuwana", "poświącana", "poświadczona", "poświecona", "poświęcona", "poświętowana", "poświntuszona", "posyłana", "posypana", "posypywana", "poszarpana", "poszastana", "poszatkowana", "poszczuta", "poszczycona", "poszczypana", "poszerzana", "poszerzona", "poszorowana", "poszpiegowana", "poszturchana", "poszukana", "poszukiwana", "poszwędana", "poszybowana", "potakiwana", "potarmoszona", "potarta", "potasowana", "potęgowana", "potępiana", "potępiona", "potknięta", "potoczona", "potopiona", "potorturowana", "potrącana", "potrącona", "potraktowana", "potrojona", "potruta", "potrząsana", "potrzaskana", "potrząsnięta", "potrząśnięta", "potrzymana", "Poturbowana", "poturlana", "potwierdzona", "potykana", "poucinana", "pouczana", "pouczona", "poudawana", "poukładana", "pouprawiana", "poupychana", "pourywana", "poustawiana", "poużywana", "powąchana", "powachlowana", "powalana", "powalona", "poważana", "powbijana", "powciągana", "powciskana", "powdychana", "powęszona", "powetowana", "powiadamiana", "powiadomiona", "powiązana", "powiedziana", "powiedzona", "powiększana", "powielana", "powielona", "powierzana", "powierzona", "powieszona", "powiewana", "powinszowana", "powitana", "powita", "powkładana", "powlekana", "powłóczona", "powodowana", "powołana", "powoływana", "powożona", "powpychana", "powrócona", "powrzucana", "powsadzana", "powściągnięta", "powspominana", "powstrzymana", "powtarzana", "powtórzona", "powybierana", "powybijana", "powycierana", "powycinana", "powyciskana", "powydawana", "powyganiana", "powyginana", "powyjaśniana", "powyjmowana", "powyłączana", "powymiatana", "powymieniana", "powynoszona", "powypełniana", "powypisywana", "powyrywana", "powyrzucana", "powystrzelana", "powysyłana", "powywalana", "powywieszana", "powywracana", "powzięta", "pozabawiana", "pozabijana", "pozacierana", "pożądana", "pożądlona", "pozadzierana", "pozakładana", "pozaklinana", "pozałatwiana", "pozamiatana", "pozamieniana", "pozamrażana", "pozamykana", "pozapalana", "pozapinana", "pozapisywana", "pozapraszana", "pożarta", "pozasłaniana", "pozastrzelana", "pozatykana", "pozbawiana", "pozbawiona", "pozbierana", "pozbyta", "pozbywana", "pozdejmowana", "pozdrawiana", "pozdrowiona", "pożegnana", "pożerana", "pozmiatana", "pozmieniana", "pozmywana", "poznaczona", "poznana", "poznawana", "poznęcana", "pozorowana", "pozostawiana", "pozostawiona", "pozowana", "pozrywana", "pozszywana", "pożuta", "pozwalniana", "pozwana", "pozwiązywana", "pozwiedzana", "pozwolona", "pożyczana", "pożyczona", "pozyskana", "pożyta", "pozywana", "pożywiana", "pożywiona", "praktykowana", "prana", "prasowana", "prawiona", "prażona", "precyzowana", "preferowana", "prenumerowana", "prezentowana", "próbowana", "procesowana", "produkowana", "profanowana", "profilowana", "prognozowana", "programowana", "projektowana", "proklamowana", "prolongowana", "promieniowana", "promowana", "propagowana", "proponowana", "prosperowana", "prostowana", "proszkowana", "proszona", "protestowana", "protokołowana", "prowadzona", "prowokowana", "pruta", "pryskana", "pryśnięta", "przeanalizowana", "przearanżowana", "przebaczana", "przebaczona", "przebadana", "przebiegnięta", "przebierana", "przebijana", "przebita", "przebolona", "przebrana", "przebudowana", "przebudowywana", "przebudzana", "przebudzona", "przebukowana", "przebyta", "przebywana", "przeceniana", "przeceniona", "przechlapana", "przechodzona", "przechowana", "przechowywana", "przechrzcona", "przechwycona", "przechwytywana", "przechylana", "przechylona", "przechytrzana", "przechytrzona", "przeciągana", "przeciągnięta", "przeciążana", "przeciążona", "przeciekana", "przecierana", "przecierpiana", "przecięta", "przecinana", "przeciskana", "przeciśnięta", "przeciwstawiana", "przećwiczona", "przeczekana", "przeczesana", "przeczesywana", "przeczołgana", "przeczuta", "przeczuwana", "przeczyszczona", "przeczytana", "przedarta", "przedawkowana", "przedawkowywana", "przedekorowana", "przedłożona", "przedłużana", "przedłużona", "przedmuchana", "przedobrzona", "przedostana", "przedostawana", "przedsiewzięta", "przedstawiana", "przedstawiona", "przedymana", "przedyskutowana", "przedzierana", "przedziurawiona", "przedziurkowana", "przeegzaminowana", "przefaksowana", "przefarbowana", "przefasonowana", "przefasowana", "przefaxowana", "przefiltrowana", "przeformowana", "przeforsowana", "przegadana", "przeganana", "przeganiana", "przegapiana", "przegapiona", "przegięta", "przeginana", "przeglądana", "przeglądnięta", "przegłodzona", "przegłosowana", "przegoniona", "przegotowana", "przegotowywana", "przegrabiona", "przegradzana", "przegrana", "przegrupowana", "przegrupowywana", "przegrywana", "przegryzana", "przegryziona", "przegrzana", "przegrzebana", "przegrzewana", "przehandlowana", "przeholowana", "przeinstalowana", "przeistoczona", "przejadana", "przejaskrawiana", "przejaśniona", "przejawiana", "przejawiona", "przejechana", "przejęta", "przejeżdżana", "przejmowana", "przejrzana", "przekabacana", "przekabacona", "przekablowana", "przekalibrowana", "przekalkulowana", "przekarmiana", "przekąszona", "przekazywana", "przekierowana", "przekierowywana", "przekimana", "przekładana", "przeklejona", "przeklęta", "przeklinana", "przeklnięta", "przekłuta", "przekonana", "przekonfigurowana", "przekonstruowana", "przekonwertowana", "przekonywana", "przekopana", "przekopywana", "przekoziołkowana", "przekraczana", "przekręcana", "przekręcona", "przekreślana", "przekreślona", "przekroczona", "przekrojona", "przekrzyczona", "przekrzywiona", "przekształcana", "przekształcona", "przekupiona", "przekupywana", "przekuta", "przekwalifikowana", "przełączana", "przełączona", "przeładowana", "przeładowywana", "przełamana", "przełamywana", "przelana", "przelatywana", "przeleciana", "przelewana", "przeleżana", "przelicytowana", "przeliczana", "przeliczona", "przeliterowana", "przełknięta", "przełożona", "przełykana", "przełyknięta", "przemalowana", "przemalowywana", "przemaszerowana", "przemawiana", "przemeblowana", "przemęczona", "przemielona", "przemieniana", "przemierzona", "przemieszczana", "przemieszczona", "przemijana", "przemilczana", "przemilczona", "przeminięta", "przemknięta", "przemodelowana", "przemusztrowana", "przemycana", "przemycona", "przemyślana", "przemyślona", "przemyta", "przemywana", "przenegocjowana", "przeniesiona", "przenikana", "przeniknięta", "przenoszona", "przeobrażana", "przeobrażona", "przeoczana", "przeoczona", "przeorana", "przeorganizowana", "przeorientowana", "przepadana", "przepakowana", "przepalona", "przeparkowana", "przepchana", "przepchnięta", "przepędzana", "przepędzona", "przepełniana", "przepełniona", "przepijana", "przepiłowana", "przepisana", "przepisywana", "przepita", "przepłacana", "przepłacona", "przepłakana", "przeplanowana", "przepłoszona", "przepłukana", "przepłukiwana", "przepłynięta", "przepływana", "przepompowana", "przepompowywana", "przepowiadana", "przepowiedziana", "przepracowana", "przepracowywana", "przeprana", "przeprawiana", "przeprawiona", "przeprogramowana", "przeprojektowana", "przeprowadzana", "przeprowadzona", "przepuszczana", "przepuszczona", "przepychana", "przepytana", "przepytywana", "przerąbana", "przerabiana", "przeradzana", "przerastana", "przerażona", "przeredagowana", "przerejestrowana", "przerobiona", "przerodzona", "przerośnięta", "przerwana", "przerysowana", "przerywana", "przerzedzana", "przerzucana", "przerzucona", "przesączona", "przesadzana", "przesądzana", "przesadzona", "przesądzona", "prześcigana", "prześcignięta", "przesiadana", "przesiadywana", "przesiana", "przesiedlana", "przesiedlona", "przesiedziana", "przesiewana", "przesilona", "przeskakiwana", "przeskalowana", "przeskanowana", "przeskoczona", "przeskrobana", "prześladowana", "przesłaniana", "przesłana", "prześledziona", "prześlizgnięta", "przesłodzona", "przesłonięta", "przesłuchana", "przesłuchiwana", "przesmarowana", "przesolona", "przesortowana", "przespana", "prześpiewana", "przessana", "przestawiana", "przestawiona", "przestemplowana", "przestraszona", "przestrojona", "przestrzegana", "przestrzelona", "przestudiowana", "przesunięta", "przesuwana", "prześwietlana", "prześwietlona", "przesyłana", "przesypana", "przesypiana", "przesypywana", "przeszarżowana", "przeszczepiana", "przeszczepiona", "przeszkadzana", "przeszkolona", "przeszmuglowana", "przeszukana", "przeszukiwana", "przeszyta", "przeszywana", "przetaczana", "przetańczona", "przetapetowana", "przetarta", "przetestowana", "przetkana", "przetoczona", "przetopiona", "przetrącona", "przetransformowana", "przetransmitowana", "przetransponowana", "przetransportowana", "przetrawiona", "przetrwana", "przetrząsana", "przetrząśnięta", "przetrzepana", "przetrzymana", "przetrzymywana", "przetwarzana", "przetworzona", "przewalana", "przewalczona", "przewaletowana", "przewalona", "przeważana", "przeważona", "przewertowana", "przewiązana", "przewiązywana", "przewidywana", "przewidziana", "przewiercana", "przewiercona", "przewieszana", "przewieszona", "przewietrzona", "przewieziona", "przewijana", "przewinięta", "przewitana", "przewodniczona", "przewodzona", "przewożona", "przewracana", "przewrócona", "przewyższana", "przeymierzana", "przeżarta", "przeżeglowana", "przeżegnana", "przeziębiona", "przezimowana", "przeznaczana", "przeznaczona", "przeżuta", "przezwyciężana", "przezwyciężona", "przeżyta", "przezywana", "przeżywana", "przodowana", "przpochlebiona", "przwdziewana", "przybastowana", "przybierana", "przybijana", "przybita", "przybliżana", "przybliżona", "przybrana", "przycelowana", "przycepiona", "przychylona", "przyciągana", "przyciągnięta", "przyciemniona", "przycięta", "przycinana", "przyciskana", "przyciśnięta", "przyciszona", "przyćmiewana", "przyćmiona", "przycumowana", "przyczepiana", "przyczesana", "przyczołgana", "przyczyniona", "przydepnięta", "przydeptana", "przyduszona", "przydzielana", "przydzielona", "przygarnięta", "przygaszona", "przygazowana", "przygładzana", "przygnębiana", "przygniatana", "przygnieciona", "przygotowana", "przygruchana", "przygrywana", "przygryzana", "przygryziona", "przygrzana", "przygwożdżona", "przyhamowana", "przyholowana", "przyjana", "przyjęta", "przyjmowana", "przyjrzana", "przykładana", "przyklejona", "przyklepana", "przykopana", "przykręcana", "przykręcona", "przykrócona", "przykryta", "przykrywana", "przykurzona", "przykuta", "przykuwana", "przyłączana", "przyłączona", "przylana", "przyłapana", "przylegana", "przylepiana", "przylepiona", "przyłożona", "przymierzona", "przymilana", "przymknięta", "przymocowana", "przymuszana", "przynależona", "przyniesiona", "przynoszona", "przynudzana", "przyostrzona", "przyozdabiana", "przyozdobiona", "przypadnięta", "przypakowana", "przypakowywana", "przypalana", "przypalona", "przyparta", "przypasowana", "przypatrywana", "przypatrzona", "przypieczętowana", "przypiekana", "przypierana", "przypięta", "przypilnowana", "przypiłowana", "przypinana", "przypisana", "przypisywana", "przypłacona", "przyplątana", "przypłynięta", "przypodobana", "przypominana", "przypomniana", "przyporządkowana", "przyprawiana", "przyprawiona", "przyprowadzona", "przypucowana", "przypudrowana", "przypuszczana", "przypuszczona", "przyrównana", "przyrządzana", "przyrządzona", "przysiadana", "przysiągnięta", "przyskrzydlona", "przyskrzyniana", "przyskrzyniona", "przysłaniana", "przysłana", "przysłodzona", "przysłoniona", "przysłuchiwana", "przysługiwana", "przysłużona", "przysmażana", "przysmażona", "przyspieszana", "przyspieszona", "przysporzona", "przysposobiona", "przyśrubowywana", "przyssana", "przystąpiona", "przystawiana", "przystawiona", "przystemplowana", "przystopowana", "przystosowana", "przystrojona", "przysunięta", "przysuwana", "przyswajana", "przyświecana", "przyświęcona", "przyswojona", "przysyłana", "przysypana", "przyszpilona", "przyszykowana", "przyszyta", "przyszywana", "przytaczana", "przytargana", "przytarta", "przytaszczana", "przytępiana", "przytępiona", "przytkana", "przytłaczana", "przytłoczona", "przytłumiona", "przytoczona", "przytrafiona", "przytroczona", "przytruwana", "przytrzasnięta", "przytrzymana", "przytrzymywana", "przytulana", "przytulona", "przytwierdzana", "przytwierdzona", "przytykana", "przyuczona", "przyuważona", "przywabiona", "przywalana", "przywalona", "przywarowana", "przywarta", "przywdziana", "przywiązana", "przywiązywana", "przywidziana", "przywieziona", "przywitana", "przywłaszczana", "przywłaszczona", "przywołana", "przywoływana", "przywożona", "przywracana", "przywrócona", "przyznaczona", "przyznana", "przyznawana", "przyzwalana", "przyzwana", "przyzwyczajana", "przyzwyczajona", "przyzywana", "psiamana", "pstrykana", "pstryknięta", "psuta", "publikowana", "puchnięta", "pucowana", "pudłowana", "pudrowana", "puknięta", "punktowana", "pustoszona", "puszczana", "puszczona", "puszkowana", "puszona", "pykana", "pytana", "rabowana", "rachowana", "racjonalizowana", "racjonowana", "raczona", "radowana", "raniona", "raportowana", "ratowana", "ratyfikowana", "reaktywowana", "realizowana", "reanimowana", "recytowana", "ręczona", "redagowana", "redukowana", "reformowana", "refowana", "regenerowana", "regionalizowana", "regulowana", "reinkarnowana", "rejestrowana", "reklamowana", "rekomendowana", "rekompensowana", "rekonstruowana", "rekreowana", "rekrutowana", "rekwirowana", "relacjonowana", "relaksowana", "remodulowana", "remontowana", "renegocjowana", "reorganizowana", "reperowana", "replikowana", "represejonowana", "reprezentowana", "reprodukowana", "resetowana", "resocjalizowana", "respektowana", "resuscytowana", "retuszowana", "rewanżowana", "rewidowana", "rezerwowana", "rezonowana", "rezygnowana", "reżyserowana", "robiona", "rodzona", "rojona", "rolowana", "romansowana", "roniona", "rozbawiana", "rozbawiona", "rozbierana", "rozbijana", "rozbita", "rozbłyśnięta", "rozbrajana", "rozbrojona", "rozbudowana", "rozbudowywana", "rozbudzana", "rozbudzona", "rozbujana", "rozcapierzona", "rozchmurzona", "rozchodzona", "rozchylana", "rozchylona", "rozciągana", "rozciągnięta", "rozcieńczana", "rozcieńczona", "rozcierana", "rozcięta", "rozcinana", "rozczarowana", "rozczarowywana", "rozczesana", "rozczłonkowana", "rozczulana", "rozczytana", "rozdana", "rozdawana", "rozdeptana", "rozdmuchana", "rozdmuchiwana", "rozdrabniana", "rozdrapana", "rozdrapywana", "rozdrażniana", "rozdrażniona", "rozduszona", "rozdwojona", "rozdysponowana", "rozdzielana", "rozdzielona", "rozdzierana", "rozdziewiczona", "rozebrana", "rozedrana", "rozegrana", "rozegrywana", "rozepchana", "rozerwana", "rozesłana", "rozgarnięta", "rozgaszczana", "rozgięta", "rozglaszana", "rozgłoszona", "rozgniatana", "rozgnieciona", "rozgniewana", "rozgoniona", "rozgraniczona", "rozgrana", "rozgromiona", "rozgrywana", "rozgryzana", "rozgryziona", "rozgrzana", "rozgrzebywana", "rozgrzeszona", "rozgrzewana", "rozhuśtana", "rozjaśniana", "rozjaśniona", "rozjechana", "rozjedzona", "rozjuszana", "rozjuszona", "rozkazana", "rozkazywana", "rozkładana", "rozklejana", "rozklejona", "rozkołysana", "rozkopana", "rozkopywana", "rozkoszowana", "rozkręcana", "rozkręcona", "rozkrojona", "rozkruszona", "rozkuta", "rozkuwana", "rozkwaszona", "rozkwaterowana", "rozkwitana", "rozkwitnięta", "rozłączona", "rozładowana", "rozładowywana", "rozłamana", "rozlana", "rozlewana", "rozliczana", "rozliczona", "rozlokowana", "rozłożona", "rozłupana", "rozluźniana", "rozmanażana", "rozmasowana", "rozmawiana", "rozmazana", "rozmazywana", "rozmiękczona", "rozmieniana", "rozmieniona", "rozmieszczana", "rozmieszczona", "rozminięta", "rozmnożona", "rozmontowana", "rozmówiona", "rozmrażana", "rozmrożona", "rozmyślana", "rozmyta", "różnicowana", "rozniecana", "roznieciona", "rozniesiona", "różniona", "roznoszona", "rozochocona", "rozpaczana", "rozpakowana", "rozpakowywana", "rozpalana", "rozpalona", "rozpamiętywana", "rozpaskudzana", "rozpatrywana", "rozpatrzona", "rozpędzana", "rozpędzona", "rozpętana", "rozpieszczana", "rozpieszczona", "rozpięta", "rozpiłowana", "rozpinana", "rozpisana", "rozpisywana", "rozplanowana", "rozpłaszczana", "rozpłaszczona", "rozplątana", "rozplątywana", "rozpłynięta", "rozpoczęta", "rozpoczynana", "rozpogodzona", "rozporządzana", "rozporządzona", "rozpościerana", "rozpostrzona", "rozpowiadana", "rozpowiedziana", "rozpowszechniana", "rozpowszechniona", "rozpoznana", "rozpoznawana", "rozpracowana", "rozpraszana", "rozprawiana", "rozprawiczona", "rozprawiona", "rozprostowana", "rozproszona", "rozprowadzana", "rozprowadzona", "rozpruta", "rozpruwana", "rozprzestrzeniana", "rozprzestrzeniona", "rozpuszczana", "rozpuszczona", "rozpychana", "rozpylana", "rozpylona", "rozpytana", "rozpytywana", "rozrastana", "rozreklamowana", "rozrobiona", "rozrośnięta", "rozróżniana", "rozróżniona", "rozruszana", "rozrysowana", "rozrywana", "rozrzucana", "rozsadzana", "rozsadzona", "rozsądzona", "rozścielona", "rozsiana", "rozsiekana", "rozsiewana", "rozsiodłana", "rozsławiana", "rozsławiona", "rozsmarowana", "rozsmarowywana", "rozśmieszana", "rozstana", "rozstąpiona", "rozstawana", "rozstawiana", "rozstawiona", "rozstrojona", "rozstrząsana", "rozstrzeliwana", "rozstrzelona", "rozstrzygana", "rozstrzygnięta", "rozsunięta", "rozsupłana", "rozświetlana", "rozświetlona", "rozsyłana", "rozsypana", "rozsypywana", "rozszarpana", "rozszarpywana", "rozszczepiana", "rozszczepiona", "rozszerzana", "rozszerzona", "rozszyfrowana", "roztaczana", "roztapiana", "roztarta", "roztoczona", "roztopiona", "roztrwoniona", "roztrząsana", "roztrzaskana", "rozumiana", "rozumowana", "rozwalana", "rozwalona", "rozwarta", "rozważana", "rozważona", "rozweselana", "rozweselona", "rozwiana", "rozwiązana", "rozwiązywana", "rozwidniana", "rozwiedziona", "rozwierana", "rozwiercona", "rozwieszana", "rozwieszona", "rozwiewana", "rozwieziona", "rozwikłana", "rozwinięta", "rozwlekana", "rozwodzona", "rozwścieczana", "rozwścieczona", "rozzłoszczona", "rugana", "ruinowana", "rujnowana", "runięta", "ruszana", "ruszona", "rwana", "ryczana", "ryglowana", "rymowana", "rysowana", "ryta", "ryzykowana", "rządzona", "rzeźbiona", "rżnięta", "rzucana", "rzucona", "rzygana", "sabotażowana", "sączona", "sadzana", "sadzona", "sądzona", "salutowana", "salwowana", "sankcjonowana", "satysfakcjonowana", "scalona", "scementowana", "scentrowana", "scharakteryzowana", "schładzana", "schlana", "schlapana", "schlebiona", "schłodzona", "schowana", "schroniona", "schrupana", "schrzaniona", "schwytana", "schylana", "ściągnięta", "ścielona", "ściemniana", "ściemniona", "ścierana", "ścierpiona", "ścięta", "ścigana", "ścinana", "ściskana", "ściśnięta", "ściszana", "ściszona", "sędziowana", "segregowana", "selekcjonowana", "separowana", "sępiona", "serwowana", "sfabrykowana", "sfajczona", "sfałszowana", "sfaulowana", "sfilmowana", "sfinalizowana", "sfinansowana", "sfingowana", "sformalizowana", "sformatowana", "sformowana", "sformułowana", "sforsowana", "sfotografowana", "shimmerowana", "siana", "siekana", "siorbana", "skadrowana", "skakana", "skalana", "skaleczona", "skalibrowana", "skalkulowana", "skalpowana", "skanalizowana", "skandowana", "skanowana", "skapitulowana", "skarcona", "skarżona", "skasowana", "skatalogowana", "skazana", "skażona", "skazywana", "skierowana", "składana", "składowana", "skłaniana", "sklasyfikowana", "skleciona", "sklejana", "sklejona", "sklepana", "skłócona", "skłoniona", "sklonowana", "sknocona", "skojarzona", "skolonizowana", "skołowana", "skombinowana", "skomentowana", "skompensowana", "skompletowana", "skomplikowana", "skomponowana", "skompresowana", "skompromitowana", "skomunikowana", "skonana", "skoncentrowana", "skończona", "skondensowana", "skonfigurowana", "skonfiskowana", "skonfrontowana", "skonkretyzowana", "skonsolidowana", "skonstruowana", "skonsultowana", "skonsumowana", "skontaktowana", "skontrolowana", "skoordynowana", "skopana", "skopiowana", "skorektowana", "skorumpowana", "skorygowana", "skorzystana", "skoszona", "skracana", "skradziona", "skręcana", "skręcona", "skremowana", "skreślana", "skreślona", "skrobana", "skrobnięta", "skrócona", "skrojona", "skropiona", "skruszona", "skrystalizowana", "skryta", "skrytykowana", "skrywana", "skrzecowana", "skrzepnięta", "skrzyczana", "skrzyta", "skrzywdzona", "skrzyżowana", "skserowana", "skubana", "skubnięta", "skulona", "skumulowana", "skupiana", "skupiona", "skupowana", "skurczona", "skuszona", "skuta", "skuwana", "skwitowana", "słana", "sławiona", "śledzona", "śliniona", "ślizgana", "słodzona", "słuchana", "słyszana", "smagana", "smarowana", "smażona", "śmiecona", "smuta", "smyrana", "snuta", "sondowana", "sortowana", "spafycikowana", "spakowana", "spalana", "spałaszowana", "spalona", "spałowana", "spamiętana", "spaprana", "sparafrazowana", "sparaliżowana", "sparowana", "spartaczona", "spartolona", "sparzona", "spasowana", "spatałaszona", "spauzowana", "spawana", "spawiona", "specjalizowana", "spędzana", "spędzona", "spekulowana", "spełniana", "spełniona", "spenetrowana", "spętana", "spierana", "spięta", "śpiewana", "spiłowana", "spinana", "spisana", "spiskowana", "spisywana", "spita", "spłacana", "spłacona", "splądrowana", "splajtowana", "splamiona", "spłaszczona", "splatana", "splątana", "spłatana", "spławiana", "spławiona", "spłodzona", "spłonięta", "spłoszona", "spłukana", "spłukiwana", "spluwana", "spływana", "spoczęta", "spoczywana", "spodziewana", "spojona", "spolaryzowana", "spoliczkowana", "sponiewierana", "sponsorowana", "spopielana", "spopielona", "spopularyzowana", "sportretowana", "sporządzana", "sporządzona", "spostrzegana", "spotęgowana", "spotkana", "spotykana", "spoufalana", "spowalniana", "spowiadana", "spowodowana", "spowolniona", "spoźniona", "spóźniona", "spożytkowana", "spożyta", "spożywana", "sprana", "sprasowana", "spraszana", "sprawdzona", "sprawiona", "sprawowana", "sprecyzowana", "spreparowana", "sprężana", "sprężona", "spróbowana", "sprofanowana", "sprofilowana", "sprostowana", "sproszkowana", "sproszona", "sprowadzana", "sprowadzona", "sprowokowana", "spryskana", "spryskiwana", "sprywatyzowana", "sprzątana", "sprzątnięta", "sprzeczana", "sprzedana", "sprzedawana", "sprzeniewierzona", "spudłowana", "spustoszona", "spuszczana", "spuszczona", "spychana", "ssana", "stabilizowana", "stacjonowana", "staczana", "staranowana", "starczana", "stargowana", "startowana", "stawiana", "stawiona", "stemplowana", "stenografowana", "stepowana", "sterowana", "sterroryzowana", "sterylizowana", "stłamszona", "stłumiona", "stnięta", "stoczona", "stołowana", "stonowana", "stopiona", "stopniowana", "storpedowana", "stosowana", "strącana", "stracona", "strącona", "strajkowana", "straszona", "stratowana", "strawiona", "streamowana", "stresowana", "streszczana", "streszczona", "strofowana", "strojona", "stroszona", "strugana", "struta", "strymowana", "strząsana", "strzaskana", "strząśnięta", "strzelona", "strzepana", "strzępiona", "strzepnięta", "strzepywana", "studiowana", "studzona", "stukana", "stuknięta", "stulona", "stwardniona", "stwarzana", "stwierdzana", "stwierdzona", "stworzona", "stykana", "stylizowana", "stymulowana", "sugerowana", "sumowana", "sunięta", "swatana", "swawolona", "świadczona", "świecona", "święcona", "świerzbiona", "świętowana", "świntuszona", "sycona", "sygnalizowana", "symulowana", "synchronizowana", "sypana", "sypnięta", "szachrowana", "szacowana", "szafowana", "szamotana", "szanowana", "szargana", "szarpana", "szarpnięta", "szarżowana", "szasowana", "szastana", "szatkowana", "szczędzona", "szczepiona", "szczerzona", "szczuta", "szczycona", "szczypana", "szczytowana", "szefowana", "szemrana", "szepnięta", "szeptana", "szerzona", "szkalowana", "szkicowana", "szklona", "szkodzona", "szkolona", "szlachtowana", "szlifowana", "szmuglowana", "szokowana", "szorowana", "szpachlowana", "szpanowana", "szperana", "szprycowana", "sztachnięta", "szturchana", "szturchnięta", "szturmowana", "szufladkowana", "szuflowana", "szukana", "szulerowana", "szwankowana", "szydełkowana", "szydzona", "szyfrowana", "szykanowana", "szykowana", "szyta", "taktowana", "tamowana", "tankowana", "tapetowana", "taplana", "taranowana", "targana", "targnięta", "targowana", "tarmoszona", "tarta", "tarzana", "tasowana", "taszczona", "tatuowana", "tchnięta", "telefonowana", "telegrfowana", "teleportowana", "temperowana", "teoretyzowana", "tępiona", "terroryzowana", "testowana", "tkana", "tknięta", "tłamszona", "tłoczona", "tłumaczona", "tłumiona", "toczona", "tolerowana", "tonowana", "topiona", "torowana", "torturowana", "towarzyszona", "trąbiona", "trącana", "tracona", "trącona", "trafiana", "trafiona", "tragizowana", "traktowana", "transferowana", "transformowana", "transmitowana", "transportowana", "tratowana", "trawiona", "trenowana", "tresowana", "triumfowana", "tropiona", "troszczona", "truta", "trwoniona", "trymowana", "tryskana", "tryśnięta", "tryumfowana", "trywializowana", "trzaskana", "trzasnięta", "trzepana", "trzepnięta", "trzepotana", "trzęsiona", "trzymana", "tuczona", "tułana", "tulona", "turlana", "tuszowana", "twistowana", "tworzona", "tykana", "tyranizowana", "tyrana", "tytułowana", "uaktualniana", "uaktualniona", "uaktywniana", "uaktywniona", "uargumentowana", "uatrakcyjniona", "ubabrana", "ubarwiana", "ubarwiona", "ubawiona", "ubezpieczana", "ubezpieczona", "ubezwłasnowolniona", "ubiczowana", "ubiegana", "ubierana", "ubijana", "ubita", "ubłagana", "ubliżana", "ubliżona", "ubolewana", "ubóstwiana", "ubrana", "ubroczona", "ubrudzona", "ucałowana", "ucharakteryzowana", "uchowana", "uchroniona", "uchwalana", "uchwalona", "uchwycona", "uchylana", "uchylona", "uciągnięta", "ucieleśniana", "ucierana", "ucierpiana", "ucięta", "ucinana", "uciskana", "uciśnięta", "uciszana", "uciszona", "uciułana", "ucywilizowana", "uczczona", "uczepiona", "uczesana", "uczęszczana", "uczona", "ucztowana", "uczuta", "uczyniona", "udana", "udaremniona", "udawana", "udekorowana", "udeptywana", "uderzana", "uderzona", "udobruchana", "udokumentowana", "udomawiana", "udomowiona", "udoskonalana", "udoskonalona", "udostępniana", "udostępniona", "udowadniana", "udowodniona", "Udramatyzowana", "udręczona", "udrożniona", "udupiona", "uduszona", "udzielana", "udzielona", "udźwignięta", "ueiwarygodniona", "ufana", "ufarbowana", "uformowana", "ufortyfikowana", "ufundowana", "ugadana", "uganiana", "ugaszana", "ugaszona", "ugięta", "uginana", "ugłaskana", "ugniatana", "ugodzona", "ugoszczona", "ugotowana", "ugrana", "ugruntowana", "ugryziona", "ugrzęznięta", "uhistoryzowana", "uhonorowana", "uiścita", "ujadana", "ujarzmiana", "ujarzmiona", "ujawniana", "ujawniona", "ujęta", "ujeżdżana", "ujeżdżona", "ujmowana", "ujrzana", "ukamieniowana", "ukarana", "ukartowana", "ukąszona", "ukatrupiona", "ukazana", "ukazywana", "ukierowana", "ukierunkowana", "układana", "uklepana", "ukłoniona", "ukłuta", "uknuta", "ukojona", "ukołysana", "ukończona", "ukonkretniona", "ukoronowana", "ukradziona", "ukręcana", "ukręcona", "ukrojona", "ukryta", "ukrywana", "ukrzyżowana", "ukształtowana", "ukuta", "ułagodzona", "ułaskawiana", "ułaskawiona", "ulatniana", "ułatwiana", "ułatwiona", "uleczana", "uleczona", "ulegana", "ulepiona", "ulepszana", "ulepszona", "ulokowana", "ulotniona", "ułożona", "umacniana", "umalowana", "umartwiana", "umawiana", "umazana", "umeblowana", "umiejscowiona", "umieszczana", "umieszczona", "umilana", "umilona", "umknięta", "umniejszana", "umniejszona", "umocniona", "umocowana", "umoczona", "umodelowana", "umorzona", "umotywowana", "umówiona", "umożliwiana", "umożliwiona", "umroczniona", "umyta", "unaoczniona", "unicestwiana", "unicestwiona", "uniemożliwaina", "uniemożliwiona", "unierochomiona", "uniesiona", "unieszczęśliwiana", "unieszczęśliwiona", "unieszkodliwiana", "unieszkodliwiona", "unieważniana", "unieważniona", "uniewinniona", "uniezależniona", "unikana", "uniknięta", "unormowana", "unoszona", "unowoczesniana", "unowocześniana", "uodporniona", "uogólniana", "upakowana", "upalana", "upalona", "upamiętniana", "upamiętniona", "upaństwowiona", "upaprana", "uparta", "upaskudzona", "upchana", "upchnięta", "upewniana", "upewniona", "upgradowana", "upichcona", "upiększana", "upiększona", "upierana", "upierdolona", "upięta", "upijana", "upilnowana", "upinana", "upita", "uplastyczniona", "upłynięta", "upodabniana", "upodobniona", "upojona", "upokorzana", "upokorzona", "upolowana", "upominana", "uporządkowana", "upowszechniona", "upozorowana", "upozowana", "uprana", "uprasowana", "upraszczana", "uprawdopodobniona", "uprawiana", "uproszczona", "uproszona", "uprowadzana", "uprowadzona", "uprzątana", "uprzątnięta", "uprzedona", "uprzedzana", "uprzyjemniana", "uprzyjemniona", "uprzykrzana", "uprzytomniona", "upubliczniana", "upubliczniona", "upudrowana", "upuszczana", "upuszczona", "upychana", "urabiana", "uraczana", "uradowana", "Urągana", "uratowana", "urażana", "urażona", "uregulowana", "urobiona", "uroniona", "urośnięta", "urozmaicana", "urozmaicona", "uruchamiana", "uruchomiona", "urwana", "urywana", "urządzana", "urządzona", "urzeczywistniana", "urzeczywistniona", "urżnięta", "usadowiona", "usadzona", "usamowolniona", "usankcjonowana", "usatyfakcjonowana", "uschnięta", "uściskana", "uścislona", "uściśnięta", "usidlona", "usiedzona", "uskładana", "uskoczona", "uskuteczniana", "uskuteczniona", "usłuchana", "usługiwana", "usłużona", "usłyszana", "usmażona", "uśmiana", "uśmiercana", "uśmiercona", "uśmierzona", "uspana", "uśpiona", "uspokajana", "uspokojona", "uspołeczniana", "usprawiedliwiana", "usprawiedliwiona", "usprawniona", "usprzątana", "ustabilizowana", "ustalana", "ustalona", "ustanawiana", "ustanowiona", "ustąpiona", "ustatkowana", "ustawiana", "ustawiona", "ustępowana", "ustosunkowana", "ustrojona", "ustrzegana", "ustrzelona", "usunięta", "ususzona", "usuwana", "uświadamiana", "uświadczona", "uświadomiona", "uświęcona", "uświniona", "usychana", "usypana", "usypiana", "usystematyzowana", "usytuowana", "uszanowana", "uszczelniana", "uszczęśliwiana", "uszczęśliwiona", "uszczuplona", "uszczypnięta", "uszkadzana", "uszkodzona", "uszlachetniana", "uszlachetniona", "usztywniona", "uszykowana", "uszyta", "utajniona", "utargowana", "utarta", "utemperowana", "utkana", "utknięta", "utkwiona", "utoczona", "utopiona", "utorowana", "utożsamiana", "utożsamiona", "utracona", "utrącona", "utrudniana", "utrudniona", "utrwalana", "utrwalona", "utrzymywana", "utuczona", "utulona", "utwierdzana", "utwierdzona", "utworzona", "utylizowana", "uwalniana", "uwalona", "uwarunkowana", "uważana", "uwiązana", "uwiązywana", "uwidoczniona", "uwieczniana", "uwieczniona", "uwielbiana", "uwielbiona", "uwieńczona", "uwierana", "uwierzona", "uwieszona", "uwieziona", "uwięziona", "uwijana", "uwikłana", "uwinięta", "uwita", "uwłaczana", "uwłaszczona", "uwodzona", "uwolniona", "uwsteczniana", "uwsteczniona", "uwydatniana", "uwypiklona", "uwzględniana", "uwzględniona", "użądlona", "uzależniana", "uzależniona", "uzasadniana", "uzasadniona", "uzbierana", "uzbrajana", "uzbrojona", "uzdrawiana", "uzdrowiona", "użerana", "uzewnętrzniana", "uzewnętrzniona", "uzgadniana", "uzgodniona", "uziemiona", "uzmysłowiona", "uznana", "uznawana", "uzupełniana", "uzupełniona", "uzurpowana", "użyczana", "użyczona", "uzyskana", "uzyskiwana", "użyta", "używana", "wabiona", "wąchana", "wachlowana", "wahana", "walczona", "wałkowana", "walnięta", "walona", "ważona", "wbijana", "wbita", "wcelowana", "wchłonięta", "wciągana", "wciągnięta", "wcielana", "wcielona", "wcierana", "wcięta", "wcinana", "wciskana", "wciśnięta", "wczepiona", "wczołgana", "wczuta", "wczytana", "wczytywana", "wdana", "wdarta", "wdawana", "wdepnięta", "wdeptana", "wdetonowana", "wdmuchiwana", "wdrapana", "wdrapywana", "wdrażana", "wdrążona", "wdrożona", "wduszona", "wdychana", "wdzierana", "wędkowana", "wentylowana", "wepchana", "wepchnięta", "werbowana", "weryfikowana", "wessana", "wetkana", "wetknięta", "wezwana", "wgłębiana", "wgniatana", "wgnieciona", "wgrana", "wgryzana", "wgryziona", "wiązana", "wibrowana", "widywana", "widziana", "wiedzona", "wielbiona", "wiercona", "wierzgana", "wierzona", "wieszana", "wietrzona", "więżona", "wikłana", "windowana", "winszowana", "wiosłowana", "wirowana", "witana", "wita", "wizualizowana", "wjeżdżana", "wkalkulowana", "wkładana", "wklejana", "wklejona", "wklepana", "wkłuta", "wkomponowana", "wkopana", "wkopywana", "wkraczana", "wkradana", "wkradziona", "wkręcana", "wkręcona", "wkupiona", "wkurwiana", "wkuta", "wkuwana", "włączana", "włączona", "władana", "władowana", "włamana", "włamywana", "wlana", "wlepiana", "wlepiona", "wlewana", "wliczana", "wliczona", "włożona", "wmanewrowana", "wmanipulowana", "wmawiana", "wmieszana", "wmówiona", "wmurowana", "wmuszona", "wnerwiana", "wnerwiona", "wniesiona", "wnikana", "wniknięta", "wnioskowana", "wnoszona", "wodowana", "wojowana", "wołana", "woskowana", "wożona", "wpajana", "wpakowana", "wparowana", "wpasowana", "wpatrywana", "wpędzana", "wpędzona", "wperswadowana", "wpieniona", "wpięta", "wpisana", "wpisywana", "wpłacana", "wpłacona", "wplatana", "wplątana", "wplątywana", "wpojona", "wpompowana", "wpraszana", "wprawiana", "wproszona", "wprowadzana", "wprowadzona", "wpuszczona", "wpychana", "wrabiana", "wręczana", "wrobiona", "wróżona", "wryta", "wrzucana", "wrzucona", "wrzynana", "wsadzana", "wsadzona", "wskazana", "wskazywana", "wskórana", "wskrzeszana", "wskrzeszona", "wślizgiwana", "wślizgnięta", "wsłuchana", "wsparta", "wspierana", "wspięta", "współczuta", "współodczuwana", "współtworzona", "współżyta", "wspomagana", "wspominana", "wspomniana", "wstąpiona", "wstawiana", "wstawiona", "wstrząsana", "wstrząśnięta", "wstrzelona", "wstrzykiwana", "wstrzyknięta", "wstrzymana", "wstrzymywana", "wstukana", "wsunięta", "wsuwana", "wsypana", "wszamana", "wszczepiana", "wszczepiona", "wszczęta", "wszczynana", "wszyta", "wtajemniczana", "wtajemniczona", "wtapiana", "wtargnięta", "wtarta", "wtaszczona", "wtłoczona", "wtopiona", "wtrącona", "wtryniana", "wtulana", "wtulona", "wtykana", "wwalona", "wwiercana", "wwiercona", "wwieziona", "wwożona", "wyartykułowana", "wyautowana", "wybaczana", "wybaczona", "wybadana", "wybatożona", "wybawiona", "wybebeszona", "wybełkotana", "wybiczowana", "wybielana", "wybielona", "wybierana", "wybijana", "wybita", "wybłagana", "wyblaknięta", "wybrandzlowana", "wybrana", "wybroniona", "wybrzydzana", "wybuchana", "wybuchnięta", "wybudowana", "wybudzana", "wybudzona", "wyburzana", "wyburzona", "wycackana", "wycałowana", "wyceniana", "wyceniona", "wychlana", "wychłostana", "wychodowana", "wychowana", "wychowywana", "wychrobotana", "wychwalana", "wychwycona", "wychylana", "wychylona", "wyciągana", "wyciągnięta", "wyciekana", "wycieniowana", "wycierana", "wycięta", "wycinana", "wyciskana", "wyciśnięta", "wyciszana", "wyciszona", "wycofana", "wyćwiczona", "wycyckana", "wycyganiona", "wyczarowana", "wyczarterowana", "wyczekana", "wyczekiwana", "wyczerpana", "wyczesana", "wyczołgana", "wyczołgiwana", "wyczuta", "wyczuwana", "wyczyniana", "wyczyszczona", "wyczytana", "wyczytywana", "wydalana", "wydalona", "wydana", "wydębiona", "wydedukowana", "wydelegowana", "wydepilowana", "wydeptywana", "wydłubana", "wydłubywana", "wydłużana", "wydłużona", "wydmuchana", "wydmuchiwana", "wydobyta", "wydobywana", "wydojona", "wydoroślana", "wydostana", "wydrana", "wydrapana", "wydrapywana", "wydrążona", "wydrukowana", "wydukana", "wyduszona", "wydychana", "wydziedziczona", "wydzielana", "wydzielona", "wydzierana", "wydzierżawiona", "wydziobana", "wydziwiana", "wydzwaniana", "wyedukowana", "wyedytowana", "wyeeliminowana", "wyegzekwowana", "wyeksmitowana", "wyekspediowana", "wyeksploatowana", "wyeksponowana", "wyeksportowana", "wyeliminowana", "wyemigrowana", "wyemitowana", "wyewoluowana", "wyfrunięta", "wygadana", "wygadywana", "wyganiana", "wygarbowana", "wygarniana", "wygarnięta", "wygasana", "wygaśnięta", "wygaszana", "wygaszona", "wygenerowana", "wygięta", "wyginana", "wygładzana", "wygładzona", "wygłaszana", "wygłodzona", "wygłosowana", "wygłoszona", "wygłówkowana", "wygnana", "wygolona", "wygoniona", "wygooglowana", "wygospodarowana", "wygotowana", "wygrana", "wygrawerowana", "wygrażana", "wygrywana", "wygryziona", "wygrzana", "wygrzebana", "wygrzebywana", "wygrzewana", "wygubiona", "wyhaczona", "wyhaftowana", "wyhamowana", "wyhodowana", "wyizolowana", "wyjadana", "wyjaśniana", "wyjaśniona", "wyjawiana", "wyjawiona", "wyjedzona", "wyjęta", "wyjmowana", "wykadrowana", "wykalibrowana", "wykalkulowana", "wykańczana", "wykantowana", "wykąpana", "wykaraskana", "wykarczowana", "wykarmiana", "wykasowana", "wykastrowana", "wykazana", "wykazywana", "wykierowana", "wykitowana", "wykiwana", "wykładana", "wyklarowana", "wyklepana", "wyklinana", "wykłócana", "wykluczana", "wykluczona", "wykluta", "wykłuta", "wykminiona", "wykolejona", "wykołowana", "wykombinowana", "wykonana", "wykończona", "wykonywana", "wykopana", "wykopnięta", "wykopywana", "wykorkowana", "wykorzeniana", "wykorzeniona", "wykorzystana", "wykorzystywana", "wykoszona", "wykpita", "wykradana", "wykradnięta", "wykręcana", "wykręcona", "wykreowana", "wykreślana", "wykreślona", "wykrochmalona", "wykrojona", "wykrwawiana", "wykrwawiona", "wykryta", "wykrywana", "wykrzesana", "wykrztuszona", "wykrzyczona", "wykrzykiwana", "wykrzyknięta", "wykrzywiana", "wykształcona", "wyksztuszona", "wykupiona", "wykupywana", "wykuta", "wykuwana", "wyłączana", "wyłączona", "wylądowana", "wyładowana", "wyładowywana", "wyłajana", "wyłamana", "wyłamywana", "wyłaniana", "wylansowana", "wylana", "wyłapana", "wyłapywana", "wyławiana", "wyleasingowana", "wyleczona", "wylęgana", "wylegimytowana", "wylewana", "wyłgana", "wylicytowana", "wyliczana", "wyliczona", "wylizana", "wylizywana", "wylogowana", "wyłoniona", "wylosowana", "wyłowiona", "wyłożona", "wyłudzana", "wyłudzona", "wyłupana", "wyłuskana", "wyłuskiwana", "wyłuszczona", "wyluzowana", "wymacana", "wymachiwana", "wymagana", "wymahiwana", "wymalowana", "wymamrotana", "wymanewrowana", "wymarzona", "wymasowana", "wymawiana", "wymazana", "wymazywana", "wymeldowana", "wymeldowywana", "wymiatana", "wymieciona", "wymieniana", "wymieniona", "wymierzana", "wymieszana", "wymigana", "wymigiwana", "wymijana", "wyminięta", "wymknięta", "wymoczona", "wymodelowana", "wymontowana", "wymordowana", "wymsknięta", "wymuszana", "wymyślana", "wymyślona", "wymyta", "wynagradzana", "wynagrodzona", "wynajdowana", "wynajdywana", "wynajęta", "wynajmowana", "wynaleziona", "wynarodowiona", "wynegocjowana", "wyniesiona", "wyniknięta", "wyniszczana", "wyniszczona", "wyniuchana", "wynoszona", "wynurzana", "wyobrażana", "wyobrażona", "wyodrębniona", "wyolbrzymiana", "wyolbrzymiona", "wyorbowana", "wyosiowana", "wyostrzana", "wyostrzona", "wypaczana", "wypakowana", "wypakowywana", "wypalana", "wypalona", "wypałowana", "wyparowana", "wyparta", "wypasana", "wypastowana", "wypatroszona", "wypatrywana", "wypatrzona", "wypchana", "wypchnięta", "wypędzana", "wypędzlowana", "wypełniana", "wypełniona", "wypersfadowana", "wyperswadowana", "wypierana", "wypięta", "wypijana", "wypinana", "wypisana", "wypisywana", "wypita", "wypłacana", "wypłacona", "wypłakana", "wypłakiwana", "wypłaszczona", "wyplatana", "wyplątana", "wypleniona", "wyplewiona", "wypłoszona", "wypłukana", "wypłukiwana", "wypluta", "wypluwana", "wypocona", "wypoczęta", "wypolerowana", "wypominana", "wypomniana", "wypompowana", "wypompowywana", "wyposażona", "wypowiadana", "wypowiedziana", "wypoziomowana", "wypożyczana", "wypracowana", "wypracowywana", "wyprana", "wyprasowana", "wypraszana", "wyprawiana", "wyprawiona", "wypróbowana", "wyprodukowana", "wyprojektowana", "wypromieniowana", "wypromowana", "wyprostowana", "wyprostowywana", "wyproszona", "wyprowadzana", "wyprowadzona", "wypróżniana", "wypróżniona", "wypruta", "wypruwana", "wyprzedana", "wyprzedawana", "wyprzedzana", "wyprzedzona", "wyprzęgana", "wypstrykana", "wypucowana", "wypuszczana", "wypuszczona", "wypychana", "wypytana", "wypytywana", "wyrąbana", "wyrabiana", "wyrąbywana", "wyratowana", "wyrażana", "wyrażona", "wyrecytowana", "wyręczana", "wyręczona", "wyregulowana", "wyrejestrowana", "wyremontowana", "wyreżyserowana", "wyrobiona", "wyrolowana", "wyrośnięta", "wyrównana", "wyrównywana", "wyróżniana", "wyróżniona", "wyrugowana", "wyruszana", "wyrwana", "wyrypana", "wyrysowana", "wyryta", "wyrywana", "wyrządzona", "wyrzeźbiona", "wyrżnięta", "wyrzucana", "wyrzucona", "wyrzygana", "wyrzynana", "wyrzywana", "wysączona", "wysadzana", "wysadzona", "wyschnięta", "wyściskana", "wyselekcjonowana", "wysępiona", "wysiadywana", "wysiedzona", "wysilana", "wysilona", "wyskakiwana", "wyskalowana", "wyskoczona", "wyskrobana", "wyskubywana", "wysłana", "wyśledzona", "wyślizgiwana", "wyślizgnięta", "wysłowiona", "wysłuchana", "wysłuchiwana", "wysmagana", "wysmarkana", "wysmarowana", "wysmażana", "wysmażona", "wyśmiana", "wyśmiewana", "wysmołowana", "wysmyrana", "wyśniona", "wysnuta", "wysnuwana", "wysondowana", "wyspecjalizowana", "wyśpiewana", "wyśpiewywana", "wyspowiadana", "wysprzątana", "wysprzedana", "wyssana", "wystartowana", "wystawiona", "wysterelizowana", "wysterylizowana", "wystosowana", "wystosowywana", "wystraszona", "wystrojona", "wystrugana", "wystrychnięta", "wystrzegana", "wystrzelana", "wystrzeliwana", "wystrzelona", "wystudzona", "wystukana", "wystukiwana", "wystygnięta", "wysunięta", "wysuszana", "wysuwana", "wyswatana", "wyświadczana", "wyświadczona", "wyświetlana", "wyświetlona", "wyswobodzona", "wysyłana", "wysypana", "wysypywana", "wysysana", "wyszabrowana", "wyszalana", "wyszarpana", "wyszarpnięta", "wyszasowana", "wyszczotkowana", "wyszczuplona", "wyszeptana", "wyszkolona", "wyszlifowana", "wyszorowana", "wyszperana", "wyszukana", "wyszukiwana", "wyszumiona", "wyszykowana", "wyszyta", "wytapetowana", "wytargana", "wytargowana", "wytarta", "wytarzana", "wytaszczona", "wytatuowana", "wytchnięta", "wytępiona", "wytknięta", "wytłoczona", "wytłumaczona", "wytłumiona", "wytoczona", "wytrąbiona", "wytrącana", "wytrącona", "wytransmitowana", "wytransportowana", "wytrenowana", "wytresowana", "wytriangulowana", "wytropiona", "wytruta", "wytrząsana", "wytrzasnięta", "wytrząśnięta", "wytrzebiona", "wytrzepana", "wytrzeszczana", "wytrzeźwiana", "wytrzymana", "wytrzymywana", "wytwarzana", "wytworzona", "wytyczona", "wytykana", "wytypowana", "wyuczona", "wywabiana", "wywabiona", "wywąchana", "wywalana", "wywalczona", "wywalona", "wywarta", "wywarzana", "wyważana", "wyważona", "wywęszana", "wywężykowana", "wywiana", "wywiązana", "wywiązywana", "wywierana", "wywiercona", "wywieszana", "wywieszona", "wywietrzona", "wywieziona", "wywijana", "wywindowana", "wywinięta", "wywłaszczona", "wywlekana", "wywnętrzniona", "wywnioskowana", "wywodzona", "wywolana", "wywoływana", "wywoskowana", "wywożona", "wywracana", "wywrócona", "wywróżona", "wywyższana", "wyżalona", "wyzbyta", "wyzdrowiona", "wyżebrana", "wyżerana", "wyzerowana", "wyzionięta", "wyznaczana", "wyznaczona", "wyznana", "wyznawana", "wyzwalana", "wyzwana", "wyzwolona", "wyzygzakowana", "wyżynana", "wyzyskana", "wyzyskiwana", "wyżyta", "wyzywana", "wyżywana", "wyżywiona", "wzbijana", "wzbita", "wzbogacana", "wzbogacona", "wzbraniana", "wzbudzana", "wzbudzona", "wzburzana", "wzburzona", "wżeniona", "wzięta", "wzmacniona", "wzmagana", "wzmocniona", "wznawiana", "wzniecana", "wznieciona", "wzniesięta", "wznoszona", "wznowiona", "wzorowana", "wzrośnięta", "wzruszona", "wzwyżana", "wzywana", "zaabordowana", "zaadaptowana", "zaadoptowana", "zaadresowana", "zaakcentowana", "zaakceptowana", "zaaklimatyzowana", "zaalarmowana", "zaanektowana", "zaangażowana", "zaanonsowana", "zaapelowana", "zaaplikowana", "zaaportowana", "zaaprobowana", "zaaranżowana", "zaaresztowana", "zaatakowana", "zabaczona", "zabalowana", "zabandażowana", "zabarwiona", "zabarykadowana", "zabawiana", "zabawiona", "zabepieczana", "zabetonowana", "zabezpieczona", "zabierana", "zabita", "zabłądzona", "zablefowana", "zabłocona", "zablokowana", "zabraniana", "zabrana", "zabrnięta", "zabroniona", "zabrudzona", "zabudowana", "zabukowana", "zabulona", "zaburzona", "zabutelkowana", "zacementowana", "zacerowana", "zachciana", "zachęcana", "zachęcona", "zachlapana", "zachodzona", "zachomikowana", "zachorowana", "zachowana", "zachowywana", "zachwalana", "zachwalona", "zachwiana", "zachwycona", "zaciągana", "zaciągnięta", "zaciążona", "zaciekawiona", "zaciemniana", "zaciemniona", "zacierana", "zacieśniona", "zacięta", "zacinana", "zaciskana", "zaciśnięta", "zaćmiona", "zacumowana", "zacytowana", "zaczadzona", "zaczarowana", "Zaczepiana", "zaczepiona", "zaczerpana", "zaczesana", "zaczęta", "zaczołgana", "zaczynana", "zadarta", "zadawalana", "zadawana", "zadbana", "zadebiutowana", "zadedykowana", "zadeklamowana", "zadeklarowana", "zademonstrowana", "zadenucjowana", "zadepeszowana", "zadeptana", "zadeptywana", "zadęta", "zadławiona", "żądlona", "zadłużana", "zadłużona", "zadokowana", "zadomowiona", "zadowalana", "zadrapana", "zadraśnięta", "zadręczana", "zadręczona", "zadrutowana", "zadurzana", "zadurzona", "zaduszona", "zadymiona", "zadźgana", "zadziobana", "zadziwiana", "zadziwiona", "zafakturowana", "zafałszowana", "zafarbowana", "zafiksowana", "zafundowana", "zagadana", "zagadnięta", "zagadywana", "zagajona", "zaganiana", "zagapiona", "zagarażowana", "zagarniana", "zagarnięta", "zagaszona", "zagazowana", "zagęszczona", "zagięta", "zaginana", "zaginięta", "zagłębiana", "zagłębiona", "zagłodzona", "zagłuszana", "zagłuszona", "zagmatwana", "zagnana", "zagnieżdżona", "zagojona", "zagoniona", "zagospodarowana", "zagotowana", "zagrabiona", "zagradzana", "zagrażana", "zagrodzona", "zagrywana", "zagryzana", "zagryziona", "zagrzana", "zagrzebana", "zagrzewana", "zagubiona", "zagwarantowana", "zahaczona", "zahamowana", "zahandlowana", "zaharowana", "zahartowana", "zahipnotyzowana", "zaholowana", "zaimitowana", "zaimplantowana", "zaimplementowana", "zaimprowizowana", "zainaugurowana", "zainfekowana", "zainicjowana", "zainkasowana", "zainscenizowana", "zainspirowana", "zainstalowana", "zainteresowana", "zaintrygowana", "zaintubowana", "zainwestowana", "zaizolowana", "zajadana", "zajana", "zajarana", "zajechana", "zajęta", "zajmowana", "zakablowana", "zakamuflowana", "zakasana", "zakasowana", "zakąszana", "zakatalogowana", "zakatowana", "zakatrupiona", "zakazana", "zakażana", "zakazywana", "zakiszona", "zakładana", "zaklasyfikowana", "zaklejana", "zaklejona", "zaklepana", "zaklepywana", "zaklinana", "zaklinowana", "zakłócana", "zakłócona", "zaklopotana", "zakłuta", "zakneblowana", "zakodowana", "zakolczykowana", "zakolorowana", "zakołysana", "zakomunikowana", "zakończona", "zakonserwowana", "zakopana", "zakopywana", "zakorzeniana", "zakorzeniona", "zakoszona", "zakosztowana", "zakotwiczana", "zakotwiczona", "zakpiona", "zakradana", "zakręcana", "zakręcona", "zakreślana", "zakreślona", "zakrwawiona", "zakryta", "zakrywana", "zakrzyczana", "zakrzyknięta", "zakrzywiana", "zakrzywiona", "zaksięgowana", "zaktualizowana", "zaktywizowana", "zaktywowana", "zakumana", "zakupiona", "zakurzona", "zakuta", "zakuwana", "zakwaterowana", "zakwestionowaa", "zakwitnięta", "załączona", "załadowana", "załagodzona", "zalamana", "zalaminowana", "załamywana", "zalana", "załapana", "załatana", "załatwiana", "załatwiona", "zalatywana", "zalecana", "zalecona", "zaleczona", "zalegalizowana", "zalegana", "zalepiana", "zalepiona", "zalewana", "zaliczana", "zaliczona", "załkana", "zalogowana", "żałowana", "założona", "zaludniona", "zamacana", "zamachnięta", "zamącona", "zamalowana", "zamanewrowana", "zamanifestowana", "zamarkowana", "zamartwiana", "zamarynowana", "zamarzana", "zamarznięta", "zamaskowana", "zamawiana", "zamazana", "zamazywana", "zamęczana", "zamęczona", "zameldowana", "zamelinowana", "zamerykanizowana", "zamiatana", "zamieniana", "zamieniona", "zamieszana", "zamieszczana", "zamieszczona", "zamieszkana", "zamieszkiwana", "zaminowana", "zamknięta", "zamocowana", "zamoczona", "zamontowana", "zamordowana", "zamortyzowana", "zamotana", "zamówiona", "zamrażana", "zamroczona", "zamrożona", "zamulana", "zamurowana", "zamydlona", "zamykana", "zanalizowana", "zanegowana", "zaniechana", "zanieczyszczana", "zanieczyszczona", "zaniedbana", "zaniedbywana", "zaniepokojona", "zaniesiona", "zanihilowana", "zanikana", "zaniknięta", "zaniżana", "zaniżona", "zanoszona", "zanotowana", "zanucona", "zanudzana", "zanudzona", "zanurzana", "zanurzona", "zanużona", "zaobaczona", "zaobserwowana", "zaoferowana", "zaofiarowana", "zaogniana", "zaogniona", "zaokrąglana", "zaokrąglona", "zaokrętowana", "zaopatrywana", "zaopatrzona", "zaopiekowana", "zaorana", "zaostrzana", "zaostrzona", "zaoszczędzona", "zapadana", "zapakowana", "zapalana", "zapalona", "zapamiętana", "zapamiętywana", "zapanowana", "zaparkowana", "zaparowywana", "zaparzana", "zaparzona", "zapaskudzona", "zapauzowana", "zapchana", "zapędzana", "zapełniana", "zapełniona", "zaperfumowana", "zapeszana", "zapewniana", "zapewniona", "zapieczętowana", "zapierana", "zapięta", "zapijana", "zapinana", "zapisana", "zapisuwana", "zapita", "zapłacona", "zapładniana", "zaplamiona", "zaplanowana", "zaplątana", "zapłodniona", "zaplombowana", "zapobiegana", "zapodana", "zapodawana", "zapodziana", "zapokojona", "zapolowana", "zapominana", "zapomniana", "zapowiadana", "zapowiedziana", "zapoznana", "zapoznawana", "zapożyczona", "zapracowywana", "zaprana", "zaprasowywana", "zapraszana", "zaprawiona", "zaprenumerowana", "zaprezentowana", "Zaprogramowana", "zaprojektowana", "zaproponowana", "zaproszona", "zaprotokołowana", "zaprowadzana", "zaprowadzona", "zaprzątana", "zaprzeczana", "zaprzeczona", "zaprzedana", "zaprzedawana", "zaprzęgana", "zaprzepaszczana", "zaprzestana", "zaprzestawana", "zaprzyjaźniona", "zapudłowana", "zapunktowana", "zapuszczana", "zapuszczona", "zapuszkowana", "zapychana", "zapylana", "zapylona", "zapytana", "zarabiana", "zaranżowana", "zarażana", "zarażona", "zarecytowana", "zaręczana", "zaręczona", "zarejestrowana", "zareklamowana", "zarekomendowana", "zarekomondowana", "zarekwirowana", "zarezerwowana", "zarobiona", "żartowana", "zarwana", "zaryglowana", "zarymowana", "zarysowana", "zarywana", "zaryzykowana", "zarządzana", "zarżnięta", "zarzucana", "zarzynana", "zasadzona", "zaścielona", "zasegurowana", "zaserwowana", "zasiadana", "zasiana", "zasiedlona", "zasięgana", "zasięgnięta", "zasiewana", "zasilana", "zasilona", "zaskakiwana", "zaskarbiona", "zaskoczona", "zaskrobana", "zasłaniana", "zaślepiana", "zaślepiona", "zasłodzona", "zasłoniona", "zasłużona", "zasmakowana", "zaśmiecana", "zaśmiecona", "zasmradzana", "zasmrodzona", "zasmucana", "zasmucona", "zasolona", "zaspakajana", "zaśpiewana", "zaspokajana", "zaspokojona", "zasponsorowana", "zaśrubowywana", "zassana", "zastana", "zastąpiona", "zastawiana", "zastawiona", "zastępowana", "zastopowana", "zastosowana", "zastraszana", "zastraszona", "zastrzelona", "zasugerowana", "zasunięta", "zasuwana", "zaświadczona", "zaświecona", "zaświoniona", "zasyfiona", "zasygnalizowana", "zasymilowana", "zasymulowana", "zasypana", "zasypywana", "zasysana", "zaszachowana", "zaszantażowana", "zaszargana", "zaszczepiana", "zaszczepiona", "zaszczuta", "zaszczycana", "zaszczycona", "zaszeptana", "zaszeregowana", "zaszlachtowana", "zasznurowana", "zaszpachlowana", "zasztyletowana", "zaszufladkowana", "zaszyfrowana", "zaszyta", "zaszywana", "zataczana", "zatajana", "zatajona", "zatamowana", "zatankowana", "zatapiana", "zatargana", "zatarta", "zatelegrafowana", "zatemperowana", "zatęskniona", "zatkana", "zatknięta", "zatoczona", "zatonięta", "zatopiona", "zatracana", "zatracona", "zatriumfowana", "zatrudniana", "zatrudniona", "zatruta", "zatruwana", "zatrzaskiwana", "zatrzaśnięta", "zatrząśnięta", "zatrzymana", "zatrzymywana", "zatuszowana", "zatwierdzana", "zatwierdzona", "zatykana", "zatynkowana", "zatytułowana", "zauploadowana", "zauroczona", "zautomatyzowana", "zauważana", "zauważona", "zawadzana", "zawalana", "zawalczona", "zawalona", "zawarta", "zaważona", "zawdzięczana", "zawetowana", "zawężona", "zawiadamiana", "zawiadomiona", "zawiązana", "zawiązywana", "zawiedzona", "zawierana", "zawierzona", "zawieszana", "zawieszona", "zawieziona", "zawijana", "zawinięta", "zawiniona", "zawiśnięta", "zawitana", "zawładnięta", "zawłaszczona", "zawodzona", "zawojowana", "zawołana", "zawoskowana", "zawożona", "zawracana", "zawrócona", "zawstydzana", "zażądana", "zażartowana", "zazdroszczona", "zażegnana", "zażenowana", "zaznaczana", "zaznajomiona", "zaznana", "zaznawana", "zażyczona", "zażyta", "zażywana", "zbaczana", "zbadana", "zbagatelizowana", "zbajerowana", "zbałamucona", "zbalansowana", "zbalsamowana", "zbankrutowana", "zbawiana", "zbawiona", "zbesztana", "zbezczeszczona", "zbierana", "zbijana", "zbita", "zbliżona", "zbluzgana", "zbojkotowana", "zbrojona", "zbrukana", "zbszczecona", "zbudowana", "zbudzona", "zbuntowana", "zburzona", "zbyta", "zbywana", "zchwytana", "zcięta", "zciszona", "zdana", "zdarta", "zdeaktywowana", "zdecydowana", "zdefiniowana", "zdeflorowana", "zdegradowana", "zdejmowana", "zdeklarowana", "zdekodowana", "zdekompresowana", "zdekoncentrowana", "zdekonstruowana", "zdelegalizowana", "zdemaskowana", "zdementowana", "zdemolowana", "zdemontowana", "zdemoralizowana", "zdenerwowana", "zdeponowana", "zdeprymowana", "zdeptana", "zderzana", "zderzona", "zdestabilizowana", "Zdetonowana", "zdetronizowana", "zdewastowana", "zdewaulowana", "zdezerterowana", "zdezintegrowana", "zdezorientowana", "zdezynfektowana", "zdiagnozowana", "zdjęta", "zdławiona", "zdmuchiwana", "zdmuchnięta", "zdobyta", "zdobywana", "zdołowana", "zdominowana", "zdopingowana", "zdrabniana", "zdradzana", "zdradzona", "zdrapana", "zdrapywana", "zdrutowana", "zdruzgotana", "zduplikowana", "zduszona", "zdwojona", "zdyscyplinowana", "zdyskredytowana", "zdyskwalifikowana", "zdystansowana", "zdzielona", "zdzierana", "zdzierżona", "zdziesiątkowana", "Zdzwoniona", "zebrana", "zechciana", "zedytowana", "żegnana", "żeniona", "zepchnięta", "zepsuta", "żerowana", "zerwana", "zerżnięta", "zeskakiwana", "zeskanowana", "zeskrobywana", "zesłana", "ześlizgiwana", "ześlizgnięta", "zesmolona", "zespawiana", "zespolona", "zessana", "zestawiana", "zestawiona", "zestresowana", "zestrzeliwana", "zestrzelona", "zeswatana", "zeszklona", "zeszlifowana", "zetknięta", "zezłoszczona", "zeznana", "zeznawana", "zezwalana", "zezwolona", "zfinansowana", "zgadana", "zgadywana", "zgajana", "zganiona", "zgarnięta", "zgaśnięta", "zgaszona", "zgięta", "zginana", "zgładzona", "zgłaszana", "zgłębiana", "zgłębiona", "zgłośniona", "zgłoszona", "zgłuszona", "zgniatana", "zgnieciona", "zgnita", "zgnojona", "zgodzona", "zgolona", "zgoniona", "zgotowana", "zgrabiona", "zgrillowana", "zgromadzana", "zgromadzona", "zgrupowana", "zgrzeszona", "zgrzytana", "zgubiona", "zgwałcona", "zhackowana", "zhakowana", "zhańbiona", "zhandlowana", "zharmonizowana", "zidentyfikowana", "ziewana", "zignorowana", "zilustrowana", "zinfiltrowana", "zintegrowana", "zintensyfikowana", "zinterpretowana", "zinwentaryzowana", "zirytowana", "zjadana", "zjawiana", "zjednana", "zjednoczona", "zjedzona", "zjeżdżona", "zkontaktowana", "zkserowana", "złączona", "złagodzona", "złajana", "złamana", "zlana", "złapana", "zlecana", "zlecona", "zlekceważona", "zlepiana", "zlepiona", "zlewana", "zlicytowana", "zliczana", "zliczona", "zlikwidowana", "zlinczowana", "zlitowana", "zlizana", "zlizywana", "złoita", "zlokalizowana", "złomowana", "żłopana", "złowiona", "złożona", "złupiona", "złuszczana", "zluzowana", "zmacana", "zmącona", "zmagana", "zmagazynowana", "zmajstrowana", "zmaksylizowana", "zmanipulowana", "zmarnowana", "zmartwychwstana", "zmarznięta", "zmasakrowana", "zmaterializowana", "zmawiana", "zmazana", "zmazywana", "zmbobardowana", "zmiatana", "zmiażdżona", "zmiękczona", "zmielona", "zmieniana", "zmieniona", "zmierzana", "zmierzona", "zmierzwiona", "zmieszana", "zmieszczona", "zmiksowana", "zminiaturyzowana", "zminimalizowana", "zmniejszana", "zmniejszona", "zmobilizowana", "zmoczona", "zmodernizowana", "zmodyfikowana", "zmoknięta", "zmonopolizowana", "zmontowana", "zmostkowana", "zmotywowana", "zmówiona", "zmrożona", "zmrużona", "zmumifikowana", "zmuszana", "zmuszona", "zmutowana", "zmyślana", "zmyta", "zmywana", "znacjonalizowana", "znajdowana", "znajdywana", "znakowana", "znaleziona", "znana", "znęcana", "zneutralizowana", "zniechęcona", "znieczulona", "zniekształcana", "zniekształcona", "znienawidzona", "znieprawiona", "zniesiona", "zniesławiana", "zniesławiona", "zniewalana", "znieważana", "znieważona", "zniewolona", "zniszczona", "zniweczona", "zniwelowana", "zniżana", "zniżona", "znokautowana", "znormalniona", "znoszona", "znudzona", "zobaczona", "zobowiązana", "zobrazowana", "zogniskowana", "żonglowana", "zoomowana", "zoperowana", "zoptymalizowana", "zorbita", "zorganizowana", "zorientowana", "zostawiana", "zostawiona", "zpłacona", "zprowokowana", "zrabowana", "zrachowana", "zracjonalizowana", "zraniona", "zraportowana", "zrażana", "zrażona", "zrealizowana", "zrecenzowana", "zredagowana", "zredukowana", "zreferowana", "zreformowana", "zrefowana", "zrefundowana", "zregenerowana", "zrehabilitowana", "zreinkarnowana", "zreintegrowana", "zrekonfigurowana", "zrekonstruowana", "zrekrutowana", "zrekrystalizowana", "zrelacjonowana", "zrelaksowana", "zremiksowana", "zremisowana", "zreorganizowana", "zreperowana", "zreplikowana", "zresetowana", "zresocjalizowana", "zrestartowana", "zrestrukturyzowana", "zrewanżowana", "zrewidowana", "zrewolucjonizowana", "zrezygnowana", "zrobiona", "zrolowana", "zroszona", "zrównana", "zrównoważona", "zrównywana", "zróżnicowana", "zrozumiana", "zrugana", "zruinowana", "zrujnowana", "zrymowana", "zrywana", "zrzędzona", "zrzeszona", "zrzucana", "zrzucona", "zsumowana", "zsunięta", "zsuwana", "zsynchronizowana", "zsyntetyzowana", "zsypywana", "zszargana", "zszokowana", "zszyta", "zszywana", "ztarta", "żuta", "zutylizowana", "zużyta", "zużywana", "zwabiana", "zwabiona", "zwalana", "zwalczona", "zwalniana", "zwalona", "zwana", "zwaporyzowana", "zwątpiona", "zważana", "zważona", "zwędzona", "zwerbalizowana", "zwerbowana", "zweryfikowana", "zwęszona", "zwężona", "zwiastowana", "związana", "związywana", "zwichnięta", "zwiedzana", "zwiedzona", "zwiększona", "zwieńczona", "zwierzana", "zwieszana", "zwieszona", "zwietrzona", "zwijana", "zwilżona", "zwinięta", "zwizualizowana", "zwlekana", "zwodowana", "zwodzona", "zwołana", "zwolniona", "zwoływana", "zwożona", "zwracana", "zwrócona", "zwyciężana", "zwymiotowana", "życzona", "żygana", "zygzakowana", "zyskana", "zyskiwana", "żyta", "zżarta", "zżerana", "zżynana", "zżyta", "abdykowane", "absorbowane", "adaptowane", "administrowane", "adoptowane", "adorowane", "adresowane", "afiszowane", "agitowane", "akcentowane", "akceptowane", "aklimatyzowane", "akompaniowane", "aktualizowane", "aktywowane", "akumulowane", "alaromowane", "alienowane", "amerykanizowane", "amortyzowane", "amputowane", "analizowane", "angażowane", "anihilowane", "animowane", "anonsowane", "antropomorfizowane", "antydatowane", "anulowane", "apelowane", "aportowane", "aranżowane", "archiwizowane", "aresztowane", "argumentowane", "artykułowane", "ascendowane", "asekurowane", "asymilowane", "asystowane", "atakowane", "autoryzowane", "awanturowane", "babrane", "baczone", "badane", "bagatelizowane", "bajerowane", "bałamucone", "balangowane", "balansowane", "banalizowane", "bandażowane", "bankrutowane", "baraszkowane", "barwione", "bawione", "bazgrane", "bazowane", "bębnione", "bełkotane", "besztane", "biadolone", "biczowane", "bite", "błagane", "błaznowane", "blefowane", "błogosławione", "blokowane", "bluzgane", "błyskane", "błyszczące", "boczone", "bogacone", "bojkotowane", "boksowane", "bombardowane", "bopowane", "borowane", "brandzlowane", "brane", "brasowane", "bratane", "bredzone", "brnięte", "brodzone", "bronione", "brudzone", "brylowane", "budowane", "budzone", "bujane", "bulone", "bulwersowane", "bumelowane", "burzone", "butelkowane", "bywane", "cackane", "całowane", "capnięte", "cechowane", "celebrowane", "celowane", "cenione", "cenzurowane", "chciane", "chlane", "chlapane", "chlapnięte", "chlastane", "chłodzone", "chlostane", "chlubione", "chodowane", "chomikowane", "chorowane", "chowane", "chronione", "chrupane", "chrzczone", "chute", "chwalone", "chwycone", "chwytane", "chybotane", "chylone", "ciachnięte", "ciągane", "ciągnięte", "ciemiężone", "cierpiane", "cieszone", "cięte", "ciskane", "ciśnięte", "ciułane", "cmokane", "cmoknięte", "cofane", "cofnięte", "ćpane", "cucone", "cudzołożone", "cumowane", "ćwiartowane", "ćwiczone", "cykane", "cytowane", "czajone", "czarowane", "czczone", "czepiane", "czepione", "czerpane", "czesane", "częstowane", "czochrane", "czołgane", "czute", "czytane", "czyte", "darowane", "darte", "darzone", "datowane", "dawane", "dbane", "deaktywowane", "debatowane", "dedukowane", "dedykowane", "defibrylowane", "defilowane", "definiowane", "defraudowane", "degradowane", "degustowane", "deklamowane", "deklarowane", "dekodowane", "dekompresowane", "dekorowane", "dekretowane", "delegowane", "delektowane", "deliberowane", "demaskowane", "dementowane", "demolowane", "demonizowane", "demonstrowane", "demoralizowane", "denerwowane", "denuncjowane", "depeszowane", "depilowane", "deportowane", "deprawowane", "deptane", "deratyzowane", "destabilizowane", "destylowane", "desygnowane", "determinowane", "detonowane", "dewastowane", "dewaulowane", "dezaktywowane", "dezorientowane", "dezynfekowane", "diagnozowane", "dilowane", "dłubane", "dłużone", "dmuchane", "dmuchnięte", "dobiegane", "dobierane", "dobijane", "dobite", "dobrane", "dobudzone", "dobyte", "doceniane", "docenione", "dochodzone", "dochowane", "dochowywane", "dociągnięte", "dociekane", "docięte", "docinane", "dociskane", "dociśnięte", "doczekane", "doczepione", "doczołgane", "doczyszczone", "doczytane", "dodane", "dodawane", "dodrukowane", "dodrukowywane", "dofinansowane", "dofinansowywane", "dogadane", "dogadywane", "dogadzane", "doganiane", "doglądane", "doglądnięte", "dognane", "dogodzone", "dogonione", "dograne", "dogryzane", "dogryzione", "dogrzane", "dogrzebane", "doinformowane", "dojeżdżane", "dojone", "dojrzane", "dojrzewane", "dokańczane", "dokarmiane", "dokarmione", "dokazane", "dokazywane", "dokładane", "doklejone", "dokonane", "dokończone", "dokonywane", "dokopane", "dokopywane", "dokowane", "dokręcane", "dokręcone", "dokształcane", "dokształcone", "dokuczane", "dokumentowane", "dokupione", "dołączane", "dołączone", "doładowane", "dolane", "dolewane", "doliczone", "dołowane", "dołożone", "domagane", "domalowane", "domknięte", "domniewywane", "domówione", "domyślane", "domyślone", "domyte", "doniesione", "donoszone", "dopadane", "dopadnięte", "dopakowane", "dopalone", "dopasowane", "dopasowywane", "dopatrywane", "dopatrzone", "dopchane", "dopchnięte", "dopełniane", "dopełnione", "dopieszczone", "dopięte", "dopijane", "dopilnowane", "dopingowane", "dopisane", "dopisywane", "dopite", "dopłacane", "dopłacone", "dopłynięte", "dopolerowane", "dopompowane", "dopowiedziane", "dopracowane", "dopracowywane", "doprane", "doprawione", "doprecyzowane", "doproszone", "doprowadzane", "doprowadzone", "dopucowane", "dopuszczane", "dopuszczone", "dopytywane", "dorabiane", "doradzane", "doradzone", "doręczane", "doręczone", "dorobione", "dorównane", "dorównywane", "dorwane", "dorysowane", "dorzucane", "dorzucone", "doścignięte", "dosiadane", "dosięgnięte", "doskoczone", "doskonalone", "dosładzane", "dosłane", "dosłyszane", "dosolone", "dośrodkowane", "dossane", "dostane", "dostąpione", "dostarczane", "dostarczone", "dostawane", "dostawiane", "dostawione", "dostosowane", "dostosowywane", "dostrajane", "dostrojone", "dostrzegane", "dosunięte", "dosuwane", "doświadczane", "Doświetlone", "dosypane", "dosypywane", "doszkolone", "doszlifowane", "doszorowane", "doszukane", "doszukiwane", "doszyte", "dotankowane", "dotankowywane", "dotargane", "dotaszczone", "dotknięte", "dotlenione", "dotłumaczone", "dotowane", "dotrwane", "dotrzymane", "dotrzymywane", "dotykane", "douczane", "douczone", "dowalone", "dowiezione", "dowodzone", "dowożone", "doznane", "doznawane", "dozorowane", "dozowane", "dożyte", "dożywione", "dramatyzowane", "drapane", "drapnięte", "draśnięte", "drażnione", "drążone", "dręczone", "drenowane", "drgane", "drgnięte", "drukowane", "dryblowane", "dryfowane", "drzemane", "dubbingowane", "dublowane", "duplikowane", "duszone", "dworowane", "dygotane", "dyktowane", "dymane", "dymione", "dyrygowane", "dyscyplinowane", "dyskredytowane", "dyskryminowane", "dyskutowane", "dyskwalifikowane", "dysponowane", "dystansowane", "dystrybuowane", "dywagowane", "dźgane", "dźgnięte", "dziabnięte", "dziedziczone", "dziękowane", "dzielone", "dziergane", "dzierżone", "dziobane", "dziurawione", "dziurkowane", "dźwigane", "dźwignięte", "edukowane", "edytowane", "egzaminowane", "egzekutowane", "egzekwowane", "ekscytowane", "ekshumowane", "ekskomunikowane", "eksmitowane", "ekspandowane", "eksperymentowane", "eksploatowane", "eksplorowane", "eksponowane", "eksportowane", "eksterminowane", "ekstradowane", "ekstrapolowane", "eliminowane", "emancypowane", "emanowae", "emigrowane", "emitowane", "energetyzowane", "eskortowane", "etykietowane", "ewakuowane", "ewaluowane", "fabrykowane", "falowane", "fałszowane", "farbowane", "faszerowane", "faulowane", "faworyzowane", "fechtowane", "fermentowane", "ferowane", "figurowane", "filetowane", "filmowane", "filtrowane", "finalizowane", "finansowane", "firmowane", "fleszowane", "folgowane", "formułowane", "forsowane", "fotografowane", "fundowane", "gadane", "ganiane", "garbione", "gardzone", "garnirowane", "gaszone", "gawędzone", "gaworzone", "gazowane", "gdakane", "gderane", "generalizowane", "generowane", "gięte", "gilgotane", "gładzone", "głaskane", "głodowane", "głodzone", "gloryfikowane", "głosowane", "głoszone", "głowione", "gmatwane", "gmerane", "gnane", "gnębione", "gniecione", "gnite", "gnojone", "godzone", "gojone", "golnięte", "golone", "gonione", "googlowane", "gospodarowane", "goszczone", "gotowane", "grabione", "grane", "grasowane", "gratulowane", "grillowane", "grilowane", "gromadzone", "gromione", "grożone", "gruchane", "gruchnięte", "grupowane", "grywane", "gryzione", "grzane", "grzechotane", "gubione", "gustowane", "gwałcone", "gwarantowane", "gwizdane", "gwizdnięte", "hackowane", "haftowane", "hajtnięte", "hamowane", "hańbione", "handlowane", "harcowane", "harmonizowane", "harowane", "hartowane", "hibernowane", "hipnotyzowane", "hodowane", "holowane", "hołubione", "honorowane", "hospitalizowane", "huknięte", "hulane", "huśtane", "idealizowane", "identyfikowane", "ignorowane", "igrane", "ilustrowane", "imitowane", "implantowane", "implodowane", "imponowane", "importowane", "improwizowane", "indokrynowane", "indukowane", "infekowane", "infiltrowane", "informowane", "ingerowane", "inhalowane", "inscenizowane", "inspirowane", "instalowane", "instruowane", "insynuowane", "integrowane", "interpretowane", "interweniowane", "intonowane", "intubowane", "inwestowane", "inwigilowane", "irytowane", "iskrzone", "izolowane", "jadane", "jawione", "jazgotane", "jednoczone", "jedzone", "kablowane", "kadzone", "kalane", "kaleczone", "kalkulowane", "kamerowane", "kamienowane", "kamuflowane", "kanalizowane", "kantowante", "kąpane", "kapitulowane", "kapowane", "karane", "karbonizowane", "karcone", "karczowane", "karmione", "kartkowane", "kąsane", "kasowane", "kastrowane", "katalogowane", "katapultowane", "katowane", "katrupione", "kierowane", "kimane", "kiszone", "kiwane", "kiwnięte", "kłaniane", "klapane", "klapnięte", "klarowane", "klasyfikowane", "klębione", "klejone", "klepane", "klepnięte", "klikane", "kliknięte", "klonowane", "kłopotane", "kłute", "knocone", "knute", "kochane", "koczowane", "kodowane", "kojarzone", "kojfnięte", "kojone", "kolekcjonowane", "kolektywizowane", "kolidowane", "kolonizowane", "kolorowane", "koloryzowane", "kołowane", "kołysane", "kombinowane", "komenderowane", "komentowane", "komercjalizowane", "kompensowane", "komplementowane", "komplikowane", "komponowane", "kompromitowane", "komunikowane", "konane", "koncentrowane", "kończone", "konfabulowane", "konfiskowane", "konfrontowane", "konserwowane", "konspirowane", "konstruowane", "konsultowane", "konsumowane", "kontaktowane", "kontestowane", "kontrastowane", "kontrolowane", "kontrowane", "kontynuowane", "kontynuuowane", "konwertowane", "konwojowane", "koordynowane", "kopane", "kopcone", "kopiowane", "kopnięte", "kopulowane", "korelowane", "korkowane", "koronowane", "korygowane", "korzone", "korzystane", "koszone", "kotwiczone", "kozaczone", "kozłowane", "kpite", "kradzione", "krajane", "krążone", "kręcone", "kremowane", "kreowane", "krochmalone", "krojone", "kropione", "kruszone", "krystalizowane", "kryte", "krytykowane", "krzepnięte", "krzyczane", "krzyknięte", "krzywdzone", "krzywione", "krzyżowane", "kserowane", "księgowane", "kształcone", "kształtowane", "kulone", "kultywowane", "kumulowane", "kupczone", "kupione", "kupowane", "kupywane", "kurczone", "kurowane", "kursowane", "kurzone", "kuszone", "kute", "kwalifikowane", "kwestionowane", "łączone", "ładowane", "łagodzone", "łajdaczone", "lakierowane", "łamane", "lamentowane", "lansowane", "lane", "łapane", "łaskotane", "łaszone", "latane", "łatane", "lawirowane", "leczone", "legalizowane", "legitymowane", "lekceważone", "lepione", "lewitowane", "liberowane", "licencjonowane", "licytowane", "liczone", "likwidowane", "linczowane", "liniowane", "literowane", "litowane", "lizane", "liznięte", "lobbowane", "lokalizowane", "losowane", "łowione", "łożone", "lubiane", "łudzone", "lunatykowane", "łupane", "łupione", "łuskane", "lustrowane", "łuszczone", "luzowane", "łykane", "łyknięte", "łyżeczkowane", "macane", "machane", "machnięte", "mącone", "maczane", "maganyzowane", "maglowane", "majaczone", "majsterkowane", "majtane", "maksymalizowane", "malowane", "maltretowane", "mamione", "mamrotane", "manewrowane", "manifestowane", "manipulowane", "markowane", "marnotrawione", "marnowane", "marszczone", "marynowane", "marznięte", "masakrowane", "maskowane", "masowane", "masturbowane", "mataczone", "materializowane", "mawiane", "mazane", "maznięte", "męczone", "meldowane", "merdane", "metabolizowane", "miażdżone", "mielone", "mierzone", "mierzwione", "mieszane", "miętolone", "migane", "migdalone", "migotane", "mijane", "miksowane", "milowane", "minięte", "minimalizowane", "miotane", "mistyfikowane", "mitygowane", "mizdrzone", "mlane", "mniemane", "mnożone", "mobilizowane", "mocowane", "moczone", "modelowane", "modernizowane", "modlone", "modulowane", "modyfikowane", "molestowane", "monitorowane", "monopolizowane", "montowane", "mordowane", "motywowane", "mówione", "mrożone", "mrugane", "mrużone", "muskane", "mutowane", "mydlone", "mylone", "myszkowane", "myte", "nabazgrane", "nabiegane", "nabierane", "nabite", "nabrane", "nabrojone", "nabrudzone", "nabyte", "nabywane", "nacelowane", "nachapane", "nachodzone", "nachwalone", "nachylone", "naciągane", "naciągnięte", "nacierane", "nacięte", "nacinane", "naciskane", "naciśnięte", "nacjonalizowane", "naczepione", "nadane", "nadawane", "nadchodzone", "nadciągane", "nadciągnięte", "nadcięte", "nadesłane", "nadgonione", "nadgryzane", "nadgryzione", "nadinterpretowane", "nadłożone", "nadmieniane", "nadmienione", "nadmuchane", "nadrabiane", "nadrobione", "nadskakiwane", "nadsłuchiwane", "nadstawiane", "nadstawione", "nadszarpnięte", "naduszone", "nadużyte", "nadużywane", "nadwerężane", "nadwyrężane", "nadwyrężone", "nadziane", "nadzorowane", "naelektryzowane", "nafaszerowane", "nagabywane", "nagadane", "nagięte", "naginane", "nagłaszane", "nagłośnione", "nagonione", "nagradzane", "nagrane", "nagrodzone", "nagromadzone", "nagrywane", "nagryzmolone", "nagrzane", "nagrzebane", "nagrzewane", "nagwizdane", "naigrywane", "najechane", "najęte", "najmowane", "nakarmiane", "nakarmione", "nakazane", "nakazywane", "nakierowane", "nakierowywane", "nakładane", "nakłamane", "nakłaniane", "naklejane", "naklejone", "naklepane", "nakłonione", "nakłute", "nakłuwane", "nakopane", "nakręcane", "nakręcone", "nakreślane", "nakreślone", "nakruszone", "nakryte", "nakrywane", "nakrzyczane", "nakupione", "naładowane", "nalane", "nałapane", "nalepione", "nalewane", "naliczone", "nałowione", "nałożone", "namaczane", "namagnetyzowane", "namalowane", "namaszczane", "namaszczone", "namawiane", "namęczone", "namierzane", "namieszane", "namoczone", "namówione", "namydlane", "namyślone", "naniesione", "naoliwiane", "naoliwione", "naopowiadane", "naostrzone", "napadane", "napadnięte", "napakowane", "napalone", "naparzane", "napastowane", "napawane", "napchane", "napędzane", "napełniane", "napełnione", "napierane", "napiętnowane", "napięte", "napinane", "napisane", "naplute", "napływane", "napoczęte", "napojone", "napompowane", "napotkane", "napotykane", "napraszane", "naprawiane", "naprawione", "naprężane", "naprężone", "napromieniowane", "naprostowane", "naprowadzane", "naprowadzone", "napsute", "napuszczane", "napuszczone", "napychane", "napytane", "narąbane", "naradzane", "naradzone", "narastane", "narażane", "narażone", "nareperowane", "narkotyzowane", "narodzone", "naruszane", "naruszone", "narwane", "narysowane", "narzucane", "narzucone", "nasączane", "nasączone", "nasadzone", "nasiąkane", "nasilane", "nasilone", "naskakiwane", "naskoczone", "naskrobane", "naśladowane", "nasłane", "nasłuchane", "nasłuchiwane", "nasmarowane", "nastąpione", "nastawiane", "nastawione", "nastraszane", "nastrojone", "nastukane", "nasunięte", "nasuwane", "naświetlane", "nasycone", "nasyłane", "nasypane", "naszczane", "naszkicowane", "naszpikowane", "naszprycowane", "naszykowane", "naszyte", "naszywane", "natarte", "natchnięte", "natknięte", "natlenione", "natłuszczone", "natrafione", "natrząsane", "natrząsnięte", "nauczane", "nauczone", "nawadniane", "nawalone", "nawiązane", "nawiązywane", "nawiedzane", "nawiedzone", "nawiercone", "nawiewane", "nawiezione", "nawigowane", "nawijane", "nawilżane", "nawilżone", "nawinięte", "nawlekane", "nawodnione", "nawoływane", "nawoskowane", "nawożone", "nawpychane", "nawracane", "nawrócone", "nawrzucane", "nawtykane", "nawymyślane", "nazbierane", "nazmyślane", "naznaczane", "naznaczone", "nazrywane", "nazwane", "nazywane", "nęcone", "negocjowane", "negowane", "nękane", "neutralizowane", "niańczone", "niecierpliwione", "niedoceniane", "niedowidziane", "nienawidzone", "niesione", "nikolone", "niszczone", "nitkowane", "niuchane", "niweczone", "niwelowane", "nokautowane", "nominowane", "notowane", "nucone", "numerowane", "nurtowane", "obaczone", "obadane", "obalane", "obalone", "obandażowane", "obarczane", "obarczone", "obawiane", "obchodzone", "obciągnięte", "obciążone", "obcięte", "obcinane", "obcyndalane", "obczajane", "obczajone", "obdarowane", "obdarte", "obdarzane", "obdarzone", "obdzielone", "obdzierane", "obdzwaniane", "obdzwonione", "obejmowane", "oberwane", "obessane", "obezwładniane", "obezwładnione", "obfotografowane", "obfotografowywane", "obgadane", "obgadywane", "obgryzane", "obgryzione", "obiecane", "obiecywane", "obierane", "obijane", "obite", "objadane", "objaśniane", "objawiane", "objawione", "objechane", "objęte", "objeżdżane", "obkręcane", "oblane", "obłapiane", "obłapywane", "obłaskawiane", "obłaskawione", "obleciane", "oblegane", "oblewane", "obliczane", "obliczone", "oblizane", "obłowione", "obłożone", "obluzowane", "obluzowywane", "obmacane", "obmacywane", "obmawiane", "obmyślane", "obmyślone", "obmyte", "obmywane", "obnażane", "obniżane", "obniżone", "obnoszone", "obowiązywane", "obozowane", "obrabiane", "obrabowane", "obracane", "obradowane", "obramowane", "obraniane", "obrane", "obrastane", "obrażane", "obrażone", "obrobione", "obrócone", "obrodzone", "obronione", "obrysowane", "obrywane", "obryzgane", "obrzezane", "obrzucane", "obrzucone", "obrzygane", "obsadzane", "obsadzone", "obściskiwane", "obserwowane", "obsiane", "obsikane", "obsikiwane", "obskakiwane", "obskoczone", "obskubane", "obskubywane", "obśliniane", "obślinione", "obsługiwane", "obsłużone", "obsmarowane", "obstawiane", "obstawione", "obstrzeliwane", "obsunięte", "obsuwane", "obsypane", "obsypywane", "obszukane", "obszukiwane", "obtaczane", "obtarte", "obtoczone", "obudzone", "obwąchane", "obwąchiwane", "obwiązane", "obwiązywane", "obwieszane", "obwieszczane", "obwieszczone", "obwieszone", "obwijane", "obwiniane", "obwinięte", "obwołane", "obyte", "obżerane", "ocalane", "ocalone", "ocechowane", "oceniane", "ocenione", "ocenzurowane", "ochładzane", "ochlapane", "ochlapywane", "ochłodzone", "ochłonięte", "ochraniane", "ochronione", "ochrzaniane", "ochrzczone", "ociągane", "ocielone", "ocieplane", "ocieplone", "ocierane", "ocknięte", "ocucone", "ocute", "oczarowywane", "oczekiwane", "oczerniane", "oczernione", "oczyszczane", "oczyszczone", "odarte", "odbębnione", "odbetonowane", "odbezpieczane", "odbezpieczone", "odbijane", "odbite", "odblokowane", "odbudowane", "odbudowywane", "odbutowane", "odbyte", "odcedzane", "odchorowane", "odchowane", "odchudzane", "odchudzone", "odchylane", "odchylone", "odciągane", "odciągnięte", "odciążone", "odcierpione", "odcięte", "odcinane", "odcisnięte", "odcumowane", "odcyfrowane", "odcyfrowywane", "odczarowane", "odczekane", "odczepiane", "odczepione", "odczute", "odczuwane", "odczynione", "odczytane", "odczytywane", "oddalane", "oddane", "oddawane", "oddelegowane", "oddychane", "oddzielane", "oddzielone", "odebrane", "odegnane", "odegrane", "odejmowane", "odepchnięte", "oderwane", "odeskortowane", "odesłane", "odespane", "odessane", "odetkane", "odetnięte", "odezwane", "odfiltrowane", "odgadnięte", "odgadywane", "odganiane", "odgarniane", "odgarnięte", "odgięte", "odgniatane", "odgonione", "odgradzane", "odgrażane", "odgrodzone", "odgruzowane", "odgrywane", "odgryzane", "odgryzione", "odgrzane", "odgrzebane", "odgrzebywane", "odgrzewane", "odgwizdane", "odhaczone", "odholowane", "odinstalowane", "odizolowane", "odjedzone", "odjęte", "odjonizowane", "odkażane", "odkażone", "odkładane", "odklejone", "odkochane", "odkodowane", "odkodowywane", "odkopane", "odkopywane", "odkorkowane", "odkręcane", "odkręcone", "odkrojone", "odkryte", "odkrywane", "odkupione", "odkupywane", "odkurzane", "odkurzone", "odkute", "odłączane", "odłączone", "odłamywane", "odlane", "odlatywane", "odlepiane", "odlewane", "odliczane", "odliczone", "odłożone", "odłupane", "odmachane", "odmachiwane", "odmalowane", "odmarszczone", "odmawiane", "odmeldowane", "odmieniane", "odmienione", "odmierzane", "odmierzone", "odmieszane", "odmontowane", "odmówione", "odmrażane", "odmrożone", "odnajdowane", "odnalezione", "odnawiane", "odniesione", "odnoszone", "odnotowane", "odnotowywane", "odnowione", "odpakowane", "odpakowywane", "odpalane", "odpalone", "odpałzowane", "odparowane", "odparte", "odpędzane", "odpicowane", "odpieczętowane", "odpierane", "odpięte", "odpiłowane", "odpiłowywane", "odpinane", "odpisane", "odpisywane", "odpłacane", "odplamione", "odplątane", "odpłynięte", "odpowietrzone", "odpracowane", "odpracowywane", "odprasowane", "odprawiane", "odprawione", "odprężane", "odprostowane", "odprowadzane", "odprowadzone", "odprute", "odpryskane", "odpukane", "odpukiwane", "odpuszczane", "odpuszczone", "odpychane", "odrąbane", "odrabiane", "odrąbywane", "odradzane", "odradzone", "odrapane", "odrastane", "odratowane", "odreagowane", "odremontowane", "odrestaurowane", "odrestaurowywane", "odrobaczane", "odrobione", "odroczone", "odrodzone", "odrośnięte", "odróżniane", "odróżnione", "odrysowane", "odrywane", "odrzucane", "odrzucone", "odsączane", "odsączone", "odsadzone", "odseparowane", "odsiadywane", "odsiane", "odsiewane", "odsłaniane", "odsłonięte", "odsłuchane", "odsłuchiwane", "odsłużone", "odśnieżane", "odśnieżone", "odsolone", "odśpiewane", "odsprzedane", "odsprzedawane", "odstąpione", "odstawiane", "odstawione", "odstępowane", "odstraszane", "odstręczone", "odstresowane", "odstrzeliwane", "odstrzelone", "odsunięte", "odsuwane", "odświeżane", "odświeżone", "odsyłane", "odsypywane", "odsysane", "odszczekane", "odszczekiwane", "odsztafirowane", "odszukane", "odszyfrowane", "odszyfrowywane", "odszykowane", "odtrąbione", "odtrącone", "odtrute", "odtwarzane", "odtworzone", "oduczone", "odurzone", "odwalane", "odwalone", "odwiązane", "odwiązywane", "odwiedzane", "odwiedzone", "odwieszone", "odwiezione", "odwijane", "odwinięte", "odwlekane", "odwodnione", "odwodzone", "odwołane", "odwoływane", "odwożone", "odwracane", "odwrócone", "odwzajemnione", "odwzorowane", "odżegnane", "odziane", "odziedziczone", "odznaczane", "odznaczone", "odzwieciedlone", "odzwierciedlane", "odzwonione", "odzwyczajone", "odzyskane", "odzyskiwane", "odżyte", "odzywiane", "odżywione", "oferowane", "ofiarowane", "ofiarowywane", "ogarniane", "ogarnięte", "oglądane", "ogłaszane", "ogłoszone", "ogłupiane", "ogłupione", "ogłuszone", "ogołocone", "ogolone", "ograbiane", "ograbione", "ograniczane", "ograniczone", "ograne", "ogrodzone", "ogryzione", "ogrzane", "ogrzewane", "okablowane", "okaleczone", "okantowane", "okąpane", "okazane", "okazywane", "okiełznane", "okładane", "okłamane", "okłamywane", "oklaskiwane", "oklejone", "oklepane", "okopane", "okopywane", "okpione", "okradane", "okradzione", "okraszone", "okrążane", "okrążone", "okręcane", "okręcone", "określane", "określone", "okrojone", "okryte", "okrywane", "okrzyknięte", "okulawione", "okupione", "okupowane", "olane", "olewane", "olśnięte", "omamione", "omawiane", "omdlewane", "omijane", "ominięte", "omotane", "omówione", "onanizowane", "onieśmielane", "onieśmielone", "opadnięte", "opakowane", "opalane", "opalone", "opancerzone", "opanowane", "opanowywane", "oparte", "oparzone", "opasane", "opatentowane", "opatrywane", "opatrzone", "opatulone", "opchnięte", "opędzane", "opędzone", "operowane", "opętane", "opętywane", "opieczętowane", "opiekowane", "opierane", "opijane", "opisane", "opisywane", "opite", "opłacane", "opłacone", "opłakane", "opłakiwane", "opłukane", "oplute", "opluwane", "opływane", "opodatkowane", "opodatkowywane", "oponowane", "oporządzane", "oporządzone", "opowiadane", "opowiedziane", "opóźniane", "opóźnione", "opracowane", "opracowywane", "oprawiane", "oprawione", "oprowadzane", "oprowadzone", "opróżniane", "opróżnione", "opryskane", "opryskiwane", "opublikowane", "opukane", "opuszczane", "opuszczone", "opychane", "opylone", "orane", "orbowane", "organizowane", "orientowane", "oroszone", "orzekane", "orżnięte", "osaczane", "osaczone", "osadzane", "osądzane", "osadzone", "osądzone", "oscylowane", "osiadane", "osiągane", "osiągnięte", "osiedlane", "osiedlone", "osiedzone", "osierocone", "osiodłane", "oskalpowane", "oskarżone", "oskrobane", "oskrzydlane", "oskrzydlone", "oskubane", "oskubywane", "osłabiane", "osłabione", "oślepiane", "oślepione", "oślepnięte", "ośliniane", "osłodzone", "osłonione", "osłuchane", "osmalone", "ośmielone", "ośmieszane", "ośmieszone", "ostrzegane", "ostrzelane", "ostrzelite", "ostrzone", "ostudzone", "osunięte", "osuszane", "osuszone", "osuwane", "oswajane", "oświadczane", "oświadczone", "oświecane", "oświecione", "oświetlane", "oświetlone", "oswobadzane", "oswobodzone", "oswojone", "oszacowane", "oszałamiane", "oszczane", "oszczędzane", "oszczędzone", "oszklone", "oszlifowane", "oszołomione", "oszpecone", "oszukane", "oszukiwane", "oszwabione", "otaczane", "otarte", "otoczone", "otrute", "otruwane", "otrząsane", "otrząśnięte", "otrzepane", "otrzeźwione", "otrzymane", "otrzymywane", "otulone", "otumanione", "otwierane", "otworzone", "otwarte", "owane", "owdowione", "owiane", "owijane", "owinięte", "ozdabiane", "ozdobione", "ozdrowione", "ożenione", "oznaczane", "oznaczone", "oznajmiane", "oznajmione", "oznakowane", "ożyte", "ożywane", "ożywiane", "ożywione", "pachnące", "pacnąte", "pakowane", "paktowane", "pałane", "pałaszowane", "palnięte", "palone", "pamiętane", "panoszone", "paprane", "parafrazowane", "paraliżowane", "parkowane", "parowane", "partaczone", "parte", "parzone", "pastowane", "paszone", "patrolowane", "patroszone", "patrzone", "pauzowane", "pchane", "pchnięte", "pdholowane", "pedałowane", "pękane", "pęknięte", "pełnione", "penetrowane", "perforowane", "perfumowane", "perswadowane", "piastowane", "pichcone", "pielęgnowane", "pielone", "pienione", "pieszczone", "piętnowane", "pięte", "pijane", "pikietowane", "piknikowane", "pikowane", "pilnowane", "pilotowane", "piłowane", "pisane", "pisywane", "pite", "płacone", "plądrowane", "plamione", "planowane", "płaszczone", "plątane", "płatane", "pławione", "plewione", "płonące", "płoszone", "plotkowane", "plugawione", "płukane", "pluskane", "plute", "pobaraszkowane", "pobierane", "pobite", "pobłażane", "pobłogosławione", "pobrane", "pobrudzone", "pobudzane", "pobudzone", "pobujane", "pocałowane", "pocerowane", "pochłaniane", "pochlapane", "pochlebiane", "pochłonięte", "pochowane", "pochwalane", "pochwalone", "pochwycone", "pochylane", "pochylone", "pociachane", "pociągane", "pociągnięte", "pocierane", "pocieszane", "pocieszone", "pocięte", "pocone", "pocukrowane", "poćwiartowane", "poczesane", "poczęstowane", "poczęte", "poczochrane", "poczute", "poczytane", "poczytywane", "podane", "podarowane", "podarte", "podawane", "podążone", "podbierane", "podbijane", "podbite", "podbudowane", "podbudowywane", "podburzane", "podburzone", "podchwycone", "podciągane", "podciągnięte", "podcierane", "podcięte", "podcinane", "podczepione", "poddane", "poddawane", "podebrane", "podejmowane", "podejrzane", "podejrzewane", "podelektowane", "podeptane", "poderwane", "podesłane", "podglądane", "podgolone", "podgonione", "podgryzane", "podgrzane", "podgrzewane", "podjadane", "podjedzone", "podjęte", "podkablowane", "podkarmione", "podkładane", "podklejone", "podkolorowane", "podkołowane", "podkopane", "podkopywane", "podkradane", "podkradnięte", "podkręcane", "podkręcone", "podkreślane", "podkreślone", "podkształcone", "podkulone", "podkupione", "podkurzone", "podkute", "podłączane", "podłączone", "podładowane", "podłamane", "podlane", "podłapane", "podleczone", "podlegane", "podlewane", "podliczane", "podliczone", "podlizane", "podlizywane", "podłożone", "podmalowane", "podmieniane", "podmienione", "podmuchane", "podmyte", "podnajęte", "podniecane", "podniecone", "podniesione", "podnoszone", "podołane", "podopingowane", "podostrzone", "podotykane", "podpadnięte", "podpalane", "podpalone", "podparte", "podpatrywane", "podpatrzone", "podpieczętowane", "podpiekane", "podpierane", "podpięte", "podpiłowane", "podpinane", "podpisane", "podpisywane", "podpłacone", "podpłynięte", "podpompowane", "podporządkowane", "podporządkowywane", "podpowiadane", "podpowiedziane", "podprowadzane", "podpuszczane", "podpuszczone", "podpychane", "podpytane", "podrabiane", "podrapane", "podrasowane", "podratowane", "podrażnione", "podręczone", "podregulowane", "podreperowane", "podretuszowane", "podrobione", "podroczone", "podróżowane", "podrygiwane", "podrywane", "podrzucane", "podrzucone", "podrzynane", "podsadzone", "podskubywane", "podsłuchane", "podsłuchiwane", "podsmażane", "podsmażone", "podśpiewywane", "podstawiane", "podstawione", "podstemplowane", "podstrojone", "podsumowane", "podsumowywane", "podsunięte", "podsuwane", "podświetlane", "podsycane", "podsycone", "podsyłane", "podsypane", "podszczypywane", "podszkolone", "podszlifowane", "podszykowane", "podszyte", "podszywane", "podtapiane", "podtarte", "podtopione", "podtrzymane", "podtrzymywane", "podtuczone", "poduczane", "podupadane", "poduszone", "podwajane", "podwalane", "podważane", "podwędzone", "podwiązane", "podwieszane", "podwiezione", "podwijane", "podwinięte", "podwojone", "podwożone", "podwyżane", "podwyższane", "podwyższone", "podyktowane", "podyskutowane", "podziabane", "podziałane", "podziałkowane", "podziękowane", "podzielone", "podziurawione", "podziwiane", "podźwignięte", "poeksperymentowane", "pofarbowane", "pofatygowane", "pofilmowane", "poganiane", "pogardzane", "pogardzone", "pogarszane", "pogaszone", "pogładzone", "pogłaskane", "pogłębiane", "pogłębione", "pogłośnione", "pogmatwane", "pognębione", "pogniecione", "pogodzone", "pogonione", "pogorszone", "pogotowane", "pograbione", "pogrążane", "pogrążone", "pogrożone", "pogrubiane", "pogrubione", "pogruchane", "pogruchotane", "pogrupowane", "pogrywane", "pogryzane", "pogryzione", "pogrzane", "pogrzebane", "pogubione", "pogwałcane", "pohamowane", "pohandlowane", "poharatowane", "pohuśtane", "poinformowane", "poinstruowane", "pojednane", "pojęte", "pojmięte", "pojmowane", "pojone", "pokajane", "pokaleczone", "pokarane", "pokarmione", "pokąsane", "pokatalogowane", "pokazane", "pokazywane", "pokiereszowane", "pokierowane", "pokiwane", "pokładane", "poklepane", "poklepywane", "pokłonione", "pokłute", "pokochane", "pokolorowane", "pokoloryzowane", "pokołysane", "pokombinowane", "pokomplikowane", "pokonane", "pokończone", "pokonywane", "pokopane", "pokrajane", "pokrążone", "pokręcone", "pokrojone", "pokruszone", "pokryte", "pokrywane", "pokrzepiane", "pokrzepione", "pokrzyżowane", "pokuszone", "pokutowane", "połączone", "polakierowane", "połamane", "polane", "połapane", "połaskotane", "połatane", "polecane", "połechtane", "polecone", "poleczone", "polegane", "polemizowane", "polepszane", "polepszone", "polerowane", "polewane", "policzkowane", "policzone", "polimeryzowane", "polizane", "połknięte", "polowane", "połowione", "położone", "polubione", "poluźnione", "poluzowane", "połykane", "pomacane", "pomachane", "pomagane", "pomalowane", "pomarynowane", "pomasowane", "pomazane", "pomęczone", "pomiatane", "pomieszane", "pomieszczone", "pomijane", "pominięte", "pomiziane", "pomknięte", "pomnażane", "pomniejszane", "pomniejszone", "pomnożone", "pomoczone", "pompowane", "pomydlone", "pomylone", "pomyszkowane", "pomywane", "ponabijane", "ponaciskane", "ponadziewane", "ponaglane", "ponaglone", "ponagrywane", "ponaklejane", "ponakłuwane", "ponakrywane", "ponaprawiane", "ponawiane", "poniańczone", "poniechane", "ponieiwerane", "poniesione", "poniszczone", "poniżane", "poniżone", "ponoszone", "ponowione", "ponudzone", "poobcinane", "poobcowane", "poobczajane", "poobijane", "poobmacywane", "poobracane", "poobserwowane", "poodbijane", "poodcinane", "poodgryzane", "poodkurzane", "poodprawiane", "poodsuwane", "poodwalane", "pooglądane", "poograniczane", "poopalane", "poopiekane", "poopwiadane", "pootwierane", "popadane", "popakowane", "popalone", "poparte", "poparzone", "popchane", "popchnięte", "popędzane", "popędzone", "popękane", "popełniane", "popełnione", "poperfumowane", "popierane", "popieszczone", "popijane", "popilnowane", "popisane", "popite", "popłacone", "popłakiwane", "poplamione", "poplątane", "popluskane", "popodcinane", "popodziwiane", "popoprawiane", "poprane", "poprasowane", "poprawiane", "poprawione", "poproszone", "poprowadzone", "popryskane", "poprzebierane", "poprzeciągane", "poprzecinane", "poprzedzane", "poprzeglądane", "poprzeklinane", "poprzekopywane", "poprzemieszczane", "poprzenoszone", "poprzesadzane", "poprześladowane", "poprzestawiane", "poprzesuwane", "poprzewieszane", "poprzewracane", "poprzycinane", "poprzymierzane", "poprzytulane", "poprzywiązywane", "popsute", "popudrowane", "popukane", "popularyzowane", "popuszczane", "popuszczone", "popychane", "popykane", "popytane", "porabiane", "porachowane", "poranione", "poratowane", "porażone", "poręczone", "porównane", "porozbierane", "porozbijane", "porozciągane", "porozcinane", "porozdawane", "porozdzielane", "porozmieszczane", "poróżnione", "porozpędzane", "porozpieszczane", "porozprowadzane", "porozpruwane", "porozrzucane", "porozstawiane", "porozsyłane", "porozumiewane", "porozwalane", "porozwiązywane", "porozwieszane", "porozwożone", "portretowane", "poruszane", "poruszone", "porwane", "porysowane", "porywane", "porządkowane", "porządzone", "porzucane", "porzucone", "posądzane", "posadzone", "posądzone", "pościągane", "pościelone", "pościerane", "pościgane", "pościnane", "pościskane", "posegregowane", "posiadane", "posiane", "posiekane", "posilane", "posiłkowane", "posilone", "posiłowane", "posiniaczone", "posiorbane", "poskąpione", "poskładane", "posklejane", "poskramiane", "poskręcane", "poskrobane", "poskromione", "poskubane", "posłane", "posłodzone", "poślubiane", "poślubione", "posługiwane", "posmakowane", "posmarowane", "posolone", "posortowane", "pospekulowane", "pospieszane", "pośpieszane", "pośpiewane", "pospinane", "pospłacane", "posprawdzane", "posprzątane", "posprzedawane", "pośredniczone", "possane", "postanowione", "postane", "postarane", "postawione", "postemplowane", "posterowane", "postradane", "postraszone", "postrugane", "postrzegane", "postrzelane", "postrzelone", "postukane", "postymulowane", "posunięte", "posuwane", "poświącane", "poświadczone", "poświecone", "poświęcone", "poświętowane", "poświntuszone", "posyłane", "posypane", "posypywane", "poszarpane", "poszastane", "poszatkowane", "poszczute", "poszczycone", "poszczypane", "poszerzane", "poszerzone", "poszorowane", "poszpiegowane", "poszturchane", "poszukane", "poszukiwane", "poszwędane", "poszybowane", "potakiwane", "potarmoszone", "potarte", "potasowane", "potęgowane", "potępiane", "potępione", "potknięte", "potoczone", "potopione", "potorturowane", "potrącane", "potrącone", "potraktowane", "potrojone", "potrute", "potrząsane", "potrzaskane", "potrząsnięte", "potrząśnięte", "potrzymane", "Poturbowane", "poturlane", "potwierdzone", "potykane", "poucinane", "pouczane", "pouczone", "poudawane", "poukładane", "pouprawiane", "poupychane", "pourywane", "poustawiane", "poużywane", "powąchane", "powachlowane", "powalane", "powalone", "poważane", "powbijane", "powciągane", "powciskane", "powdychane", "powęszone", "powetowane", "powiadamiane", "powiadomione", "powiązane", "powiedziane", "powiedzone", "powiększane", "powielane", "powielone", "powierzane", "powierzone", "powieszone", "powiewane", "powinszowane", "powitane", "powite", "powkładane", "powlekane", "powłóczone", "powodowane", "powołane", "powoływane", "powożone", "powpychane", "powrócone", "powrzucane", "powsadzane", "powściągnięte", "powspominane", "powstrzymane", "powtarzane", "powtórzone", "powybierane", "powybijane", "powycierane", "powycinane", "powyciskane", "powydawane", "powyganiane", "powyginane", "powyjaśniane", "powyjmowane", "powyłączane", "powymiatane", "powymieniane", "powynoszone", "powypełniane", "powypisywane", "powyrywane", "powyrzucane", "powystrzelane", "powysyłane", "powywalane", "powywieszane", "powywracane", "powzięte", "pozabawiane", "pozabijane", "pozacierane", "pożądane", "pożądlone", "pozadzierane", "pozakładane", "pozaklinane", "pozałatwiane", "pozamiatane", "pozamieniane", "pozamrażane", "pozamykane", "pozapalane", "pozapinane", "pozapisywane", "pozapraszane", "pożarte", "pozasłaniane", "pozastrzelane", "pozatykane", "pozbawiane", "pozbawione", "pozbierane", "pozbyte", "pozbywane", "pozdejmowane", "pozdrawiane", "pozdrowione", "pożegnane", "pożerane", "pozmiatane", "pozmieniane", "pozmywane", "poznaczone", "poznane", "poznawane", "poznęcane", "pozorowane", "pozostawiane", "pozostawione", "pozowane", "pozrywane", "pozszywane", "pożute", "pozwalniane", "pozwane", "pozwiązywane", "pozwiedzane", "pozwolone", "pożyczane", "pożyczone", "pozyskane", "pożyte", "pozywane", "pożywiane", "pożywione", "praktykowane", "prane", "prasowane", "prawione", "prażone", "precyzowane", "preferowane", "prenumerowane", "prezentowane", "próbowane", "procesowane", "produkowane", "profanowane", "profilowane", "prognozowane", "programowane", "projektowane", "proklamowane", "prolongowane", "promieniowane", "promowane", "propagowane", "proponowane", "prosperowane", "prostowane", "proszkowane", "proszone", "protestowane", "protokołowane", "prowadzone", "prowokowane", "prute", "pryskane", "pryśnięte", "przeanalizowane", "przearanżowane", "przebaczane", "przebaczone", "przebadane", "przebiegnięte", "przebierane", "przebijane", "przebite", "przebolone", "przebrane", "przebudowane", "przebudowywane", "przebudzane", "przebudzone", "przebukowane", "przebyte", "przebywane", "przeceniane", "przecenione", "przechlapane", "przechodzone", "przechowane", "przechowywane", "przechrzcone", "przechwycone", "przechwytywane", "przechylane", "przechylone", "przechytrzane", "przechytrzone", "przeciągane", "przeciągnięte", "przeciążane", "przeciążone", "przeciekane", "przecierane", "przecierpiane", "przecięte", "przecinane", "przeciskane", "przeciśnięte", "przeciwstawiane", "przećwiczone", "przeczekane", "przeczesane", "przeczesywane", "przeczołgane", "przeczute", "przeczuwane", "przeczyszczone", "przeczytane", "przedarte", "przedawkowane", "przedawkowywane", "przedekorowane", "przedłożone", "przedłużane", "przedłużone", "przedmuchane", "przedobrzone", "przedostane", "przedostawane", "przedsiewzięte", "przedstawiane", "przedstawione", "przedymane", "przedyskutowane", "przedzierane", "przedziurawione", "przedziurkowane", "przeegzaminowane", "przefaksowane", "przefarbowane", "przefasonowane", "przefasowane", "przefaxowane", "przefiltrowane", "przeformowane", "przeforsowane", "przegadane", "przeganane", "przeganiane", "przegapiane", "przegapione", "przegięte", "przeginane", "przeglądane", "przeglądnięte", "przegłodzone", "przegłosowane", "przegonione", "przegotowane", "przegotowywane", "przegrabione", "przegradzane", "przegrane", "przegrupowane", "przegrupowywane", "przegrywane", "przegryzane", "przegryzione", "przegrzane", "przegrzebane", "przegrzewane", "przehandlowane", "przeholowane", "przeinstalowane", "przeistoczone", "przejadane", "przejaskrawiane", "przejaśnione", "przejawiane", "przejawione", "przejechane", "przejęte", "przejeżdżane", "przejmowane", "przejrzane", "przekabacane", "przekabacone", "przekablowane", "przekalibrowane", "przekalkulowane", "przekarmiane", "przekąszone", "przekazywane", "przekierowane", "przekierowywane", "przekimane", "przekładane", "przeklejone", "przeklęte", "przeklinane", "przeklnięte", "przekłute", "przekonane", "przekonfigurowane", "przekonstruowane", "przekonwertowane", "przekonywane", "przekopane", "przekopywane", "przekoziołkowane", "przekraczane", "przekręcane", "przekręcone", "przekreślane", "przekreślone", "przekroczone", "przekrojone", "przekrzyczone", "przekrzywione", "przekształcane", "przekształcone", "przekupione", "przekupywane", "przekute", "przekwalifikowane", "przełączane", "przełączone", "przeładowane", "przeładowywane", "przełamane", "przełamywane", "przelane", "przelatywane", "przeleciane", "przelewane", "przeleżane", "przelicytowane", "przeliczane", "przeliczone", "przeliterowane", "przełknięte", "przełożone", "przełykane", "przełyknięte", "przemalowane", "przemalowywane", "przemaszerowane", "przemawiane", "przemeblowane", "przemęczone", "przemielone", "przemieniane", "przemierzone", "przemieszczane", "przemieszczone", "przemijane", "przemilczane", "przemilczone", "przeminięte", "przemknięte", "przemodelowane", "przemusztrowane", "przemycane", "przemycone", "przemyślane", "przemyślone", "przemyte", "przemywane", "przenegocjowane", "przeniesione", "przenikane", "przeniknięte", "przenoszone", "przeobrażane", "przeobrażone", "przeoczane", "przeoczone", "przeorane", "przeorganizowane", "przeorientowane", "przepadane", "przepakowane", "przepalone", "przeparkowane", "przepchane", "przepchnięte", "przepędzane", "przepędzone", "przepełniane", "przepełnione", "przepijane", "przepiłowane", "przepisane", "przepisywane", "przepite", "przepłacane", "przepłacone", "przepłakane", "przeplanowane", "przepłoszone", "przepłukane", "przepłukiwane", "przepłynięte", "przepływane", "przepompowane", "przepompowywane", "przepowiadane", "przepowiedziane", "przepracowane", "przepracowywane", "przeprane", "przeprawiane", "przeprawione", "przeprogramowane", "przeprojektowane", "przeprowadzane", "przeprowadzone", "przepuszczane", "przepuszczone", "przepychane", "przepytane", "przepytywane", "przerąbane", "przerabiane", "przeradzane", "przerastane", "przerażone", "przeredagowane", "przerejestrowane", "przerobione", "przerodzone", "przerośnięte", "przerwane", "przerysowane", "przerywane", "przerzedzane", "przerzucane", "przerzucone", "przesączone", "przesadzane", "przesądzane", "przesadzone", "przesądzone", "prześcigane", "prześcignięte", "przesiadane", "przesiadywane", "przesiane", "przesiedlane", "przesiedlone", "przesiedziane", "przesiewane", "przesilone", "przeskakiwane", "przeskalowane", "przeskanowane", "przeskoczone", "przeskrobane", "prześladowane", "przesłaniane", "przesłane", "prześledzone", "prześlizgnięte", "przesłodzone", "przesłonięte", "przesłuchane", "przesłuchiwane", "przesmarowane", "przesolone", "przesortowane", "przespane", "prześpiewane", "przessane", "przestawiane", "przestawione", "przestemplowane", "przestraszone", "przestrojone", "przestrzegane", "przestrzelone", "przestudiowane", "przesunięte", "przesuwane", "prześwietlane", "prześwietlone", "przesyłane", "przesypane", "przesypiane", "przesypywane", "przeszarżowane", "przeszczepiane", "przeszczepione", "przeszkadzane", "przeszkolone", "przeszmuglowane", "przeszukane", "przeszukiwane", "przeszyte", "przeszywane", "przetaczane", "przetańczone", "przetapetowane", "przetarte", "przetestowane", "przetkane", "przetoczone", "przetopione", "przetrącone", "przetransformowane", "przetransmitowane", "przetransponowane", "przetransportowane", "przetrawione", "przetrwane", "przetrząsane", "przetrząśnięte", "przetrzepane", "przetrzymane", "przetrzymywane", "przetwarzane", "przetworzone", "przewalane", "przewalczone", "przewaletowane", "przewalone", "przeważane", "przeważone", "przewertowane", "przewiązane", "przewiązywane", "przewidywane", "przewidziane", "przewiercane", "przewiercone", "przewieszane", "przewieszone", "przewietrzone", "przewiezione", "przewijane", "przewinięte", "przewitane", "przewodniczone", "przewodzone", "przewożone", "przewracane", "przewrócone", "przewyższane", "przeymierzane", "przeżarte", "przeżeglowane", "przeżegnane", "przeziębione", "przezimowane", "przeznaczane", "przeznaczone", "przeżute", "przezwyciężane", "przezwyciężone", "przeżyte", "przezywane", "przeżywane", "przodowane", "przpochlebione", "przwdziewane", "przybastowane", "przybierane", "przybijane", "przybite", "przybliżane", "przybliżone", "przybrane", "przycelowane", "przycepione", "przychylone", "przyciągane", "przyciągnięte", "przyciemnione", "przycięte", "przycinane", "przyciskane", "przyciśnięte", "przyciszone", "przyćmiewane", "przyćmione", "przycumowane", "przyczepiane", "przyczesane", "przyczołgane", "przyczynione", "przydepnięte", "przydeptane", "przyduszone", "przydzielane", "przydzielone", "przygarnięte", "przygaszone", "przygazowane", "przygładzane", "przygnębiane", "przygniatane", "przygniecione", "przygotowane", "przygruchane", "przygrywane", "przygryzane", "przygryzione", "przygrzane", "przygwożdżone", "przyhamowane", "przyholowane", "przyjane", "przyjęte", "przyjmowane", "przyjrzane", "przykładane", "przyklejone", "przyklepane", "przykopane", "przykręcane", "przykręcone", "przykrócone", "przykryte", "przykrywane", "przykurzone", "przykute", "przykuwane", "przyłączane", "przyłączone", "przylane", "przyłapane", "przylegane", "przylepiane", "przylepione", "przyłożone", "przymierzone", "przymilane", "przymknięte", "przymocowane", "przymuszane", "przynależone", "przyniesione", "przynoszone", "przynudzane", "przyostrzone", "przyozdabiane", "przyozdobione", "przypadnięte", "przypakowane", "przypakowywane", "przypalane", "przypalone", "przyparte", "przypasowane", "przypatrywane", "przypatrzone", "przypieczętowane", "przypiekane", "przypierane", "przypięte", "przypilnowane", "przypiłowane", "przypinane", "przypisane", "przypisywane", "przypłacone", "przyplątane", "przypłynięte", "przypodobane", "przypominane", "przypomniane", "przyporządkowane", "przyprawiane", "przyprawione", "przyprowadzone", "przypucowane", "przypudrowane", "przypuszczane", "przypuszczone", "przyrównane", "przyrządzane", "przyrządzone", "przysiadane", "przysiągnięte", "przyskrzydlone", "przyskrzyniane", "przyskrzynione", "przysłaniane", "przysłane", "przysłodzone", "przysłonione", "przysłuchiwane", "przysługiwane", "przysłużone", "przysmażane", "przysmażone", "przyspieszane", "przyspieszone", "przysporzone", "przysposobione", "przyśrubowywane", "przyssane", "przystąpione", "przystawiane", "przystawione", "przystemplowane", "przystopowane", "przystosowane", "przystrojone", "przysunięte", "przysuwane", "przyswajane", "przyświecane", "przyświęcone", "przyswojone", "przysyłane", "przysypane", "przyszpilone", "przyszykowane", "przyszyte", "przyszywane", "przytaczane", "przytargane", "przytarte", "przytaszczane", "przytępiane", "przytępione", "przytkane", "przytłaczane", "przytłoczone", "przytłumione", "przytoczone", "przytrafione", "przytroczone", "przytruwane", "przytrzasnięte", "przytrzymane", "przytrzymywane", "przytulane", "przytulone", "przytwierdzane", "przytwierdzone", "przytykane", "przyuczone", "przyuważone", "przywabione", "przywalane", "przywalone", "przywarowane", "przywarte", "przywdziane", "przywiązane", "przywiązywane", "przywidziane", "przywiezione", "przywitane", "przywłaszczane", "przywłaszczone", "przywołane", "przywoływane", "przywożone", "przywracane", "przywrócone", "przyznaczone", "przyznane", "przyznawane", "przyzwalane", "przyzwane", "przyzwyczajane", "przyzwyczajone", "przyzywane", "psiamane", "pstrykane", "pstryknięte", "psute", "publikowane", "puchnięte", "pucowane", "pudłowane", "pudrowane", "puknięte", "punktowane", "pustoszone", "puszczane", "puszczone", "puszkowane", "puszone", "pykane", "pytane", "rabowane", "rachowane", "racjonalizowane", "racjonowane", "raczone", "radowane", "ranione", "raportowane", "ratowane", "ratyfikowane", "reaktywowane", "realizowane", "reanimowane", "recytowane", "ręczone", "redagowane", "redukowane", "reformowane", "refowane", "regenerowane", "regionalizowane", "regulowane", "reinkarnowane", "rejestrowane", "reklamowane", "rekomendowane", "rekompensowane", "rekonstruowane", "rekreowane", "rekrutowane", "rekwirowane", "relacjonowane", "relaksowane", "remodulowane", "remontowane", "renegocjowane", "reorganizowane", "reperowane", "replikowane", "represejonowane", "reprezentowane", "reprodukowane", "resetowane", "resocjalizowane", "respektowane", "resuscytowane", "retuszowane", "rewanżowane", "rewidowane", "rezerwowane", "rezonowane", "rezygnowane", "reżyserowane", "robione", "rodzone", "rojone", "rolowane", "romansowane", "ronione", "rozbawiane", "rozbawione", "rozbierane", "rozbijane", "rozbite", "rozbłyśnięte", "rozbrajane", "rozbrojone", "rozbudowane", "rozbudowywane", "rozbudzane", "rozbudzone", "rozbujane", "rozcapierzone", "rozchmurzone", "rozchodzone", "rozchylane", "rozchylone", "rozciągane", "rozciągnięte", "rozcieńczane", "rozcieńczone", "rozcierane", "rozcięte", "rozcinane", "rozczarowane", "rozczarowywane", "rozczesane", "rozczłonkowane", "rozczulane", "rozczytane", "rozdane", "rozdawane", "rozdeptane", "rozdmuchane", "rozdmuchiwane", "rozdrabniane", "rozdrapane", "rozdrapywane", "rozdrażniane", "rozdrażnione", "rozduszone", "rozdwojone", "rozdysponowane", "rozdzielane", "rozdzielone", "rozdzierane", "rozdziewiczone", "rozebrane", "rozedrane", "rozegrane", "rozegrywane", "rozepchane", "rozerwane", "rozesłane", "rozgarnięte", "rozgaszczane", "rozgięte", "rozglaszane", "rozgłoszone", "rozgniatane", "rozgniecione", "rozgniewane", "rozgonione", "rozgraniczone", "rozgrane", "rozgromione", "rozgrywane", "rozgryzane", "rozgryzione", "rozgrzane", "rozgrzebywane", "rozgrzeszone", "rozgrzewane", "rozhuśtane", "rozjaśniane", "rozjaśnione", "rozjechane", "rozjedzone", "rozjuszane", "rozjuszone", "rozkazane", "rozkazywane", "rozkładane", "rozklejane", "rozklejone", "rozkołysane", "rozkopane", "rozkopywane", "rozkoszowane", "rozkręcane", "rozkręcone", "rozkrojone", "rozkruszone", "rozkute", "rozkuwane", "rozkwaszone", "rozkwaterowane", "rozkwitane", "rozkwitnięte", "rozłączone", "rozładowane", "rozładowywane", "rozłamane", "rozlane", "rozlewane", "rozliczane", "rozliczone", "rozlokowane", "rozłożone", "rozłupane", "rozluźniane", "rozmanażane", "rozmasowane", "rozmawiane", "rozmazane", "rozmazywane", "rozmiękczone", "rozmieniane", "rozmienione", "rozmieszczane", "rozmieszczone", "rozminięte", "rozmnożone", "rozmontowane", "rozmówione", "rozmrażane", "rozmrożone", "rozmyślane", "rozmyte", "różnicowane", "rozniecane", "rozniecione", "rozniesione", "różnione", "roznoszone", "rozochocone", "rozpaczane", "rozpakowane", "rozpakowywane", "rozpalane", "rozpalone", "rozpamiętywane", "rozpaskudzane", "rozpatrywane", "rozpatrzone", "rozpędzane", "rozpędzone", "rozpętane", "rozpieszczane", "rozpieszczone", "rozpięte", "rozpiłowane", "rozpinane", "rozpisane", "rozpisywane", "rozplanowane", "rozpłaszczane", "rozpłaszczone", "rozplątane", "rozplątywane", "rozpłynięte", "rozpoczęte", "rozpoczynane", "rozpogodzone", "rozporządzane", "rozporządzone", "rozpościerane", "rozpostrzone", "rozpowiadane", "rozpowiedziane", "rozpowszechniane", "rozpowszechnione", "rozpoznane", "rozpoznawane", "rozpracowane", "rozpraszane", "rozprawiane", "rozprawiczone", "rozprawione", "rozprostowane", "rozproszone", "rozprowadzane", "rozprowadzone", "rozprute", "rozpruwane", "rozprzestrzeniane", "rozprzestrzenione", "rozpuszczane", "rozpuszczone", "rozpychane", "rozpylane", "rozpylone", "rozpytane", "rozpytywane", "rozrastane", "rozreklamowane", "rozrobione", "rozrośnięte", "rozróżniane", "rozróżnione", "rozruszane", "rozrysowane", "rozrywane", "rozrzucane", "rozsadzane", "rozsadzone", "rozsądzone", "rozścielone", "rozsiane", "rozsiekane", "rozsiewane", "rozsiodłane", "rozsławiane", "rozsławione", "rozsmarowane", "rozsmarowywane", "rozśmieszane", "rozstane", "rozstąpione", "rozstawane", "rozstawiane", "rozstawione", "rozstrojone", "rozstrząsane", "rozstrzeliwane", "rozstrzelone", "rozstrzygane", "rozstrzygnięte", "rozsunięte", "rozsupłane", "rozświetlane", "rozświetlone", "rozsyłane", "rozsypane", "rozsypywane", "rozszarpane", "rozszarpywane", "rozszczepiane", "rozszczepione", "rozszerzane", "rozszerzone", "rozszyfrowane", "roztaczane", "roztapiane", "roztarte", "roztoczone", "roztopione", "roztrwonione", "roztrząsane", "roztrzaskane", "rozumiane", "rozumowane", "rozwalane", "rozwalone", "rozwarte", "rozważane", "rozważone", "rozweselane", "rozweselone", "rozwiane", "rozwiązane", "rozwiązywane", "rozwidniane", "rozwiedzione", "rozwierane", "rozwiercone", "rozwieszane", "rozwieszone", "rozwiewane", "rozwiezione", "rozwikłane", "rozwinięte", "rozwlekane", "rozwodzone", "rozwścieczane", "rozwścieczone", "rozzłoszczone", "rugane", "ruinowane", "rujnowane", "runięte", "ruszane", "ruszone", "rwane", "ryczane", "ryglowane", "rymowane", "rysowane", "ryte", "ryzykowane", "rządzone", "rzeźbione", "rżnięte", "rzucane", "rzucone", "rzygane", "sabotażowane", "sączone", "sadzane", "sadzone", "sądzone", "salutowane", "salwowane", "sankcjonowane", "satysfakcjonowane", "scalone", "scementowane", "scentrowane", "scharakteryzowane", "schładzane", "schlane", "schlapane", "schlebione", "schłodzone", "schowane", "schronione", "schrupane", "schrzanione", "schwytane", "schylane", "ściągnięte", "ścielone", "ściemniane", "ściemnione", "ścierane", "ścierpione", "ścięte", "ścigane", "ścinane", "ściskane", "ściśnięte", "ściszane", "ściszone", "sędziowane", "segregowane", "selekcjonowane", "separowane", "sępione", "serwowane", "sfabrykowane", "sfajczone", "sfałszowane", "sfaulowane", "sfilmowane", "sfinalizowane", "sfinansowane", "sfingowane", "sformalizowane", "sformatowane", "sformowane", "sformułowane", "sforsowane", "sfotografowane", "shimmerowane", "siane", "siekane", "siorbane", "skadrowane", "skakane", "skalane", "skaleczone", "skalibrowane", "skalkulowane", "skalpowane", "skanalizowane", "skandowane", "skanowane", "skapitulowane", "skarcone", "skarżone", "skasowane", "skatalogowane", "skazane", "skażone", "skazywane", "skierowane", "składane", "składowane", "skłaniane", "sklasyfikowane", "sklecione", "sklejane", "sklejone", "sklepane", "skłócone", "skłonione", "sklonowane", "sknocone", "skojarzone", "skolonizowane", "skołowane", "skombinowane", "skomentowane", "skompensowane", "skompletowane", "skomplikowane", "skomponowane", "skompresowane", "skompromitowane", "skomunikowane", "skonane", "skoncentrowane", "skończone", "skondensowane", "skonfigurowane", "skonfiskowane", "skonfrontowane", "skonkretyzowane", "skonsolidowane", "skonstruowane", "skonsultowane", "skonsumowane", "skontaktowane", "skontrolowane", "skoordynowane", "skopane", "skopiowane", "skorektowane", "skorumpowane", "skorygowane", "skorzystane", "skoszone", "skracane", "skradzione", "skręcane", "skręcone", "skremowane", "skreślane", "skreślone", "skrobane", "skrobnięte", "skrócone", "skrojone", "skropione", "skruszone", "skrystalizowane", "skryte", "skrytykowane", "skrywane", "skrzecowane", "skrzepnięte", "skrzyczane", "skrzyte", "skrzywdzone", "skrzyżowane", "skserowane", "skubane", "skubnięte", "skulone", "skumulowane", "skupiane", "skupione", "skupowane", "skurczone", "skuszone", "skute", "skuwane", "skwitowane", "słane", "sławione", "śledzone", "ślinione", "ślizgane", "słodzone", "słuchane", "słyszane", "smagane", "smarowane", "smażone", "śmiecone", "smute", "smyrane", "snute", "sondowane", "sortowane", "spafycikowane", "spakowane", "spalane", "spałaszowane", "spalone", "spałowane", "spamiętane", "spaprane", "sparafrazowane", "sparaliżowane", "sparowane", "spartaczone", "spartolone", "sparzone", "spasowane", "spatałaszone", "spauzowane", "spawane", "spawione", "specjalizowane", "spędzane", "spędzone", "spekulowane", "spełniane", "spełnione", "spenetrowane", "spętane", "spierane", "spięte", "śpiewane", "spiłowane", "spinane", "spisane", "spiskowane", "spisywane", "spite", "spłacane", "spłacone", "splądrowane", "splajtowane", "splamione", "spłaszczone", "splatane", "splątane", "spłatane", "spławiane", "spławione", "spłodzone", "spłonięte", "spłoszone", "spłukane", "spłukiwane", "spluwane", "spływane", "spoczęte", "spoczywane", "spodziewane", "spojone", "spolaryzowane", "spoliczkowane", "sponiewierane", "sponsorowane", "spopielane", "spopielone", "spopularyzowane", "sportretowane", "sporządzane", "sporządzone", "spostrzegane", "spotęgowane", "spotkane", "spotykane", "spoufalane", "spowalniane", "spowiadane", "spowodowane", "spowolnione", "spoźnione", "spóźnione", "spożytkowane", "spożyte", "spożywane", "sprane", "sprasowane", "spraszane", "sprawdzone", "sprawione", "sprawowane", "sprecyzowane", "spreparowane", "sprężane", "sprężone", "spróbowane", "sprofanowane", "sprofilowane", "sprostowane", "sproszkowane", "sproszone", "sprowadzane", "sprowadzone", "sprowokowane", "spryskane", "spryskiwane", "sprywatyzowane", "sprzątane", "sprzątnięte", "sprzeczane", "sprzedane", "sprzedawane", "sprzeniewierzone", "spudłowane", "spustoszone", "spuszczane", "spuszczone", "spychane", "ssane", "stabilizowane", "stacjonowane", "staczane", "staranowane", "starczane", "stargowane", "startowane", "stawiane", "stawione", "stemplowane", "stenografowane", "stepowane", "sterowane", "sterroryzowane", "sterylizowane", "stłamszone", "stłumione", "stnięte", "stoczone", "stołowane", "stonowane", "stopione", "stopniowane", "storpedowane", "stosowane", "strącane", "stracone", "strącone", "strajkowane", "straszone", "stratowane", "strawione", "streamowane", "stresowane", "streszczane", "streszczone", "strofowane", "strojone", "stroszone", "strugane", "strute", "strymowane", "strząsane", "strzaskane", "strząśnięte", "strzelone", "strzepane", "strzępione", "strzepnięte", "strzepywane", "studiowane", "studzone", "stukane", "stuknięte", "stulone", "stwardnione", "stwarzane", "stwierdzane", "stwierdzone", "stworzone", "stykane", "stylizowane", "stymulowane", "sugerowane", "sumowane", "sunięte", "swatane", "swawolone", "świadczone", "świecone", "święcone", "świerzbione", "świętowane", "świntuszone", "sycone", "sygnalizowane", "symulowane", "synchronizowane", "sypane", "sypnięte", "szachrowane", "szacowane", "szafowane", "szamotane", "szanowane", "szargane", "szarpane", "szarpnięte", "szarżowane", "szasowane", "szastane", "szatkowane", "szczędzone", "szczepione", "szczerzone", "szczute", "szczycone", "szczypane", "szczytowane", "szefowane", "szemrane", "szepnięte", "szeptane", "szerzone", "szkalowane", "szkicowane", "szklone", "szkodzone", "szkolone", "szlachtowane", "szlifowane", "szmuglowane", "szokowane", "szorowane", "szpachlowane", "szpanowane", "szperane", "szprycowane", "sztachnięte", "szturchane", "szturchnięte", "szturmowane", "szufladkowane", "szuflowane", "szukane", "szulerowane", "szwankowane", "szydełkowane", "szydzone", "szyfrowane", "szykanowane", "szykowane", "szyte", "taktowane", "tamowane", "tankowane", "tapetowane", "taplane", "taranowane", "targane", "targnięte", "targowane", "tarmoszone", "tarte", "tarzane", "tasowane", "taszczone", "tatuowane", "tchnięte", "telefonowane", "telegrfowane", "teleportowane", "temperowane", "teoretyzowane", "tępione", "terroryzowane", "testowane", "tkane", "tknięte", "tłamszone", "tłoczone", "tłumaczone", "tłumione", "toczone", "tolerowane", "tonowane", "topione", "torowane", "torturowane", "towarzyszone", "trąbione", "trącane", "tracone", "trącone", "trafiane", "trafione", "tragizowane", "traktowane", "transferowane", "transformowane", "transmitowane", "transportowane", "tratowane", "trawione", "trenowane", "tresowane", "triumfowane", "tropione", "troszczone", "trute", "trwonione", "trymowane", "tryskane", "tryśnięte", "tryumfowane", "trywializowane", "trzaskane", "trzasnięte", "trzepane", "trzepnięte", "trzepotane", "trzęsione", "trzymane", "tuczone", "tułane", "tulone", "turlane", "tuszowane", "twistowane", "tworzone", "tykane", "tyranizowane", "tyrane", "tytułowane", "uaktualniane", "uaktualnione", "uaktywniane", "uaktywnione", "uargumentowane", "uatrakcyjnione", "ubabrane", "ubarwiane", "ubarwione", "ubawione", "ubezpieczane", "ubezpieczone", "ubezwłasnowolnione", "ubiczowane", "ubiegane", "ubierane", "ubijane", "ubite", "ubłagane", "ubliżane", "ubliżone", "ubolewane", "ubóstwiane", "ubrane", "ubroczone", "ubrudzone", "ucałowane", "ucharakteryzowane", "uchowane", "uchronione", "uchwalane", "uchwalone", "uchwycone", "uchylane", "uchylone", "uciągnięte", "ucieleśniane", "ucierane", "ucierpiane", "ucięte", "ucinane", "uciskane", "uciśnięte", "uciszane", "uciszone", "uciułane", "ucywilizowane", "uczczone", "uczepione", "uczesane", "uczęszczane", "uczone", "ucztowane", "uczute", "uczynione", "udane", "udaremnione", "udawane", "udekorowane", "udeptywane", "uderzane", "uderzone", "udobruchane", "udokumentowane", "udomawiane", "udomowione", "udoskonalane", "udoskonalone", "udostępniane", "udostępnione", "udowadniane", "udowodnione", "Udramatyzowane", "udręczone", "udrożnione", "udupione", "uduszone", "udzielane", "udzielone", "udźwignięte", "ueiwarygodnione", "ufane", "ufarbowane", "uformowane", "ufortyfikowane", "ufundowane", "ugadane", "uganiane", "ugaszane", "ugaszone", "ugięte", "uginane", "ugłaskane", "ugniatane", "ugodzone", "ugoszczone", "ugotowane", "ugrane", "ugruntowane", "ugryzione", "ugrzęznięte", "uhistoryzowane", "uhonorowane", "uiścite", "ujadane", "ujarzmiane", "ujarzmione", "ujawniane", "ujawnione", "ujęte", "ujeżdżane", "ujeżdżone", "ujmowane", "ujrzane", "ukamieniowane", "ukarane", "ukartowane", "ukąszone", "ukatrupione", "ukazane", "ukazywane", "ukierowane", "ukierunkowane", "układane", "uklepane", "ukłonione", "ukłute", "uknute", "ukojone", "ukołysane", "ukończone", "ukonkretnione", "ukoronowane", "ukradzione", "ukręcane", "ukręcone", "ukrojone", "ukryte", "ukrywane", "ukrzyżowane", "ukształtowane", "ukute", "ułagodzone", "ułaskawiane", "ułaskawione", "ulatniane", "ułatwiane", "ułatwione", "uleczane", "uleczone", "ulegane", "ulepione", "ulepszane", "ulepszone", "ulokowane", "ulotnione", "ułożone", "umacniane", "umalowane", "umartwiane", "umawiane", "umazane", "umeblowane", "umiejscowione", "umieszczane", "umieszczone", "umilane", "umilone", "umknięte", "umniejszane", "umniejszone", "umocnione", "umocowane", "umoczone", "umodelowane", "umorzone", "umotywowane", "umówione", "umożliwiane", "umożliwione", "umrocznione", "umyte", "unaocznione", "unicestwiane", "unicestwione", "uniemożliwaine", "uniemożliwione", "unierochomione", "uniesione", "unieszczęśliwiane", "unieszczęśliwione", "unieszkodliwiane", "unieszkodliwione", "unieważniane", "unieważnione", "uniewinnione", "uniezależnione", "unikane", "uniknięte", "unormowane", "unoszone", "unowoczesniane", "unowocześniane", "uodpornione", "uogólniane", "upakowane", "upalane", "upalone", "upamiętniane", "upamiętnione", "upaństwowione", "upaprane", "uparte", "upaskudzone", "upchane", "upchnięte", "upewniane", "upewnione", "upgradowane", "upichcone", "upiększane", "upiększone", "upierane", "upierdolone", "upięte", "upijane", "upilnowane", "upinane", "upite", "uplastycznione", "upłynięte", "upodabniane", "upodobnione", "upojone", "upokorzane", "upokorzone", "upolowane", "upominane", "uporządkowane", "upowszechnione", "upozorowane", "upozowane", "uprane", "uprasowane", "upraszczane", "uprawdopodobnione", "uprawiane", "uproszczone", "uproszone", "uprowadzane", "uprowadzone", "uprzątane", "uprzątnięte", "uprzedone", "uprzedzane", "uprzyjemniane", "uprzyjemnione", "uprzykrzane", "uprzytomnione", "upubliczniane", "upublicznione", "upudrowane", "upuszczane", "upuszczone", "upychane", "urabiane", "uraczane", "uradowane", "Urągane", "uratowane", "urażane", "urażone", "uregulowane", "urobione", "uronione", "urośnięte", "urozmaicane", "urozmaicone", "uruchamiane", "uruchomione", "urwane", "urywane", "urządzane", "urządzone", "urzeczywistniane", "urzeczywistnione", "urżnięte", "usadowione", "usadzone", "usamowolnione", "usankcjonowane", "usatyfakcjonowane", "uschnięte", "uściskane", "uścislone", "uściśnięte", "usidlone", "usiedzone", "uskładane", "uskoczone", "uskuteczniane", "uskutecznione", "usłuchane", "usługiwane", "usłużone", "usłyszane", "usmażone", "uśmiane", "uśmiercane", "uśmiercone", "uśmierzone", "uspane", "uśpione", "uspokajane", "uspokojone", "uspołeczniane", "usprawiedliwiane", "usprawiedliwione", "usprawnione", "usprzątane", "ustabilizowane", "ustalane", "ustalone", "ustanawiane", "ustanowione", "ustąpione", "ustatkowane", "ustawiane", "ustawione", "ustępowane", "ustosunkowane", "ustrojone", "ustrzegane", "ustrzelone", "usunięte", "ususzone", "usuwane", "uświadamiane", "uświadczone", "uświadomione", "uświęcone", "uświnione", "usychane", "usypane", "usypiane", "usystematyzowane", "usytuowane", "uszanowane", "uszczelniane", "uszczęśliwiane", "uszczęśliwione", "uszczuplone", "uszczypnięte", "uszkadzane", "uszkodzone", "uszlachetniane", "uszlachetnione", "usztywnione", "uszykowane", "uszyte", "utajnione", "utargowane", "utarte", "utemperowane", "utkane", "utknięte", "utkwione", "utoczone", "utopione", "utorowane", "utożsamiane", "utożsamione", "utracone", "utrącone", "utrudniane", "utrudnione", "utrwalane", "utrwalone", "utrzymywane", "utuczone", "utulone", "utwierdzane", "utwierdzone", "utworzone", "utylizowane", "uwalniane", "uwalone", "uwarunkowane", "uważane", "uwiązane", "uwiązywane", "uwidocznione", "uwieczniane", "uwiecznione", "uwielbiane", "uwielbione", "uwieńczone", "uwierane", "uwierzone", "uwieszone", "uwiezione", "uwięzione", "uwijane", "uwikłane", "uwinięte", "uwite", "uwłaczane", "uwłaszczone", "uwodzone", "uwolnione", "uwsteczniane", "uwstecznione", "uwydatniane", "uwypiklone", "uwzględniane", "uwzględnione", "użądlone", "uzależniane", "uzależnione", "uzasadniane", "uzasadnione", "uzbierane", "uzbrajane", "uzbrojone", "uzdrawiane", "uzdrowione", "użerane", "uzewnętrzniane", "uzewnętrznione", "uzgadniane", "uzgodnione", "uziemione", "uzmysłowione", "uznane", "uznawane", "uzupełniane", "uzupełnione", "uzurpowane", "użyczane", "użyczone", "uzyskane", "uzyskiwane", "użyte", "używane", "wabione", "wąchane", "wachlowane", "wahane", "walczone", "wałkowane", "walnięte", "walone", "ważone", "wbijane", "wbite", "wcelowane", "wchłonięte", "wciągane", "wciągnięte", "wcielane", "wcielone", "wcierane", "wcięte", "wcinane", "wciskane", "wciśnięte", "wczepione", "wczołgane", "wczute", "wczytane", "wczytywane", "wdane", "wdarte", "wdawane", "wdepnięte", "wdeptane", "wdetonowane", "wdmuchiwane", "wdrapane", "wdrapywane", "wdrażane", "wdrążone", "wdrożone", "wduszone", "wdychane", "wdzierane", "wędkowane", "wentylowane", "wepchane", "wepchnięte", "werbowane", "weryfikowane", "wessane", "wetkane", "wetknięte", "wezwane", "wgłębiane", "wgniatane", "wgniecione", "wgrane", "wgryzane", "wgryzione", "wiązane", "wibrowane", "widywane", "widziane", "wiedzone", "wielbione", "wiercone", "wierzgane", "wierzone", "wieszane", "wietrzone", "więżone", "wikłane", "windowane", "winszowane", "wiosłowane", "wirowane", "witane", "wite", "wizualizowane", "wjeżdżane", "wkalkulowane", "wkładane", "wklejane", "wklejone", "wklepane", "wkłute", "wkomponowane", "wkopane", "wkopywane", "wkraczane", "wkradane", "wkradzione", "wkręcane", "wkręcone", "wkupione", "wkurwiane", "wkute", "wkuwane", "włączane", "włączone", "władane", "władowane", "włamane", "włamywane", "wlane", "wlepiane", "wlepione", "wlewane", "wliczane", "wliczone", "włożone", "wmanewrowane", "wmanipulowane", "wmawiane", "wmieszane", "wmówione", "wmurowane", "wmuszone", "wnerwiane", "wnerwione", "wniesione", "wnikane", "wniknięte", "wnioskowane", "wnoszone", "wodowane", "wojowane", "wołane", "woskowane", "wożone", "wpajane", "wpakowane", "wparowane", "wpasowane", "wpatrywane", "wpędzane", "wpędzone", "wperswadowane", "wpienione", "wpięte", "wpisane", "wpisywane", "wpłacane", "wpłacone", "wplatane", "wplątane", "wplątywane", "wpojone", "wpompowane", "wpraszane", "wprawiane", "wproszone", "wprowadzane", "wprowadzone", "wpuszczone", "wpychane", "wrabiane", "wręczane", "wrobione", "wróżone", "wryte", "wrzucane", "wrzucone", "wrzynane", "wsadzane", "wsadzone", "wskazane", "wskazywane", "wskórane", "wskrzeszane", "wskrzeszone", "wślizgiwane", "wślizgnięte", "wsłuchane", "wsparte", "wspierane", "wspięte", "współczute", "współodczuwane", "współtworzone", "współżyte", "wspomagane", "wspominane", "wspomniane", "wstąpione", "wstawiane", "wstawione", "wstrząsane", "wstrząśnięte", "wstrzelone", "wstrzykiwane", "wstrzyknięte", "wstrzymane", "wstrzymywane", "wstukane", "wsunięte", "wsuwane", "wsypane", "wszamane", "wszczepiane", "wszczepione", "wszczęte", "wszczynane", "wszyte", "wtajemniczane", "wtajemniczone", "wtapiane", "wtargnięte", "wtarte", "wtaszczone", "wtłoczone", "wtopione", "wtrącone", "wtryniane", "wtulane", "wtulone", "wtykane", "wwalone", "wwiercane", "wwiercone", "wwiezione", "wwożone", "wyartykułowane", "wyautowane", "wybaczane", "wybaczone", "wybadane", "wybatożone", "wybawione", "wybebeszone", "wybełkotane", "wybiczowane", "wybielane", "wybielone", "wybierane", "wybijane", "wybite", "wybłagane", "wyblaknięte", "wybrandzlowane", "wybrane", "wybronione", "wybrzydzane", "wybuchane", "wybuchnięte", "wybudowane", "wybudzane", "wybudzone", "wyburzane", "wyburzone", "wycackane", "wycałowane", "wyceniane", "wycenione", "wychlane", "wychłostane", "wychodowane", "wychowane", "wychowywane", "wychrobotane", "wychwalane", "wychwycone", "wychylane", "wychylone", "wyciągane", "wyciągnięte", "wyciekane", "wycieniowane", "wycierane", "wycięte", "wycinane", "wyciskane", "wyciśnięte", "wyciszane", "wyciszone", "wycofane", "wyćwiczone", "wycyckane", "wycyganione", "wyczarowane", "wyczarterowane", "wyczekane", "wyczekiwane", "wyczerpane", "wyczesane", "wyczołgane", "wyczołgiwane", "wyczute", "wyczuwane", "wyczyniane", "wyczyszczone", "wyczytane", "wyczytywane", "wydalane", "wydalone", "wydane", "wydębione", "wydedukowane", "wydelegowane", "wydepilowane", "wydeptywane", "wydłubane", "wydłubywane", "wydłużane", "wydłużone", "wydmuchane", "wydmuchiwane", "wydobyte", "wydobywane", "wydojone", "wydoroślane", "wydostane", "wydrane", "wydrapane", "wydrapywane", "wydrążone", "wydrukowane", "wydukane", "wyduszone", "wydychane", "wydziedziczone", "wydzielane", "wydzielone", "wydzierane", "wydzierżawione", "wydziobane", "wydziwiane", "wydzwaniane", "wyedukowane", "wyedytowane", "wyeeliminowane", "wyegzekwowane", "wyeksmitowane", "wyekspediowane", "wyeksploatowane", "wyeksponowane", "wyeksportowane", "wyeliminowane", "wyemigrowane", "wyemitowane", "wyewoluowane", "wyfrunięte", "wygadane", "wygadywane", "wyganiane", "wygarbowane", "wygarniane", "wygarnięte", "wygasane", "wygaśnięte", "wygaszane", "wygaszone", "wygenerowane", "wygięte", "wyginane", "wygładzane", "wygładzone", "wygłaszane", "wygłodzone", "wygłosowane", "wygłoszone", "wygłówkowane", "wygnane", "wygolone", "wygonione", "wygooglowane", "wygospodarowane", "wygotowane", "wygrane", "wygrawerowane", "wygrażane", "wygrywane", "wygryzione", "wygrzane", "wygrzebane", "wygrzebywane", "wygrzewane", "wygubione", "wyhaczone", "wyhaftowane", "wyhamowane", "wyhodowane", "wyizolowane", "wyjadane", "wyjaśniane", "wyjaśnione", "wyjawiane", "wyjawione", "wyjedzone", "wyjęte", "wyjmowane", "wykadrowane", "wykalibrowane", "wykalkulowane", "wykańczane", "wykantowane", "wykąpane", "wykaraskane", "wykarczowane", "wykarmiane", "wykasowane", "wykastrowane", "wykazane", "wykazywane", "wykierowane", "wykitowane", "wykiwane", "wykładane", "wyklarowane", "wyklepane", "wyklinane", "wykłócane", "wykluczane", "wykluczone", "wyklute", "wykłute", "wykminione", "wykolejone", "wykołowane", "wykombinowane", "wykonane", "wykończone", "wykonywane", "wykopane", "wykopnięte", "wykopywane", "wykorkowane", "wykorzeniane", "wykorzenione", "wykorzystane", "wykorzystywane", "wykoszone", "wykpite", "wykradane", "wykradnięte", "wykręcane", "wykręcone", "wykreowane", "wykreślane", "wykreślone", "wykrochmalone", "wykrojone", "wykrwawiane", "wykrwawione", "wykryte", "wykrywane", "wykrzesane", "wykrztuszone", "wykrzyczone", "wykrzykiwane", "wykrzyknięte", "wykrzywiane", "wykształcone", "wyksztuszone", "wykupione", "wykupywane", "wykute", "wykuwane", "wyłączane", "wyłączone", "wylądowane", "wyładowane", "wyładowywane", "wyłajane", "wyłamane", "wyłamywane", "wyłaniane", "wylansowane", "wylane", "wyłapane", "wyłapywane", "wyławiane", "wyleasingowane", "wyleczone", "wylęgane", "wylegimytowane", "wylewane", "wyłgane", "wylicytowane", "wyliczane", "wyliczone", "wylizane", "wylizywane", "wylogowane", "wyłonione", "wylosowane", "wyłowione", "wyłożone", "wyłudzane", "wyłudzone", "wyłupane", "wyłuskane", "wyłuskiwane", "wyłuszczone", "wyluzowane", "wymacane", "wymachiwane", "wymagane", "wymahiwane", "wymalowane", "wymamrotane", "wymanewrowane", "wymarzone", "wymasowane", "wymawiane", "wymazane", "wymazywane", "wymeldowane", "wymeldowywane", "wymiatane", "wymiecione", "wymieniane", "wymienione", "wymierzane", "wymieszane", "wymigane", "wymigiwane", "wymijane", "wyminięte", "wymknięte", "wymoczone", "wymodelowane", "wymontowane", "wymordowane", "wymsknięte", "wymuszane", "wymyślane", "wymyślone", "wymyte", "wynagradzane", "wynagrodzone", "wynajdowane", "wynajdywane", "wynajęte", "wynajmowane", "wynalezione", "wynarodowione", "wynegocjowane", "wyniesione", "wyniknięte", "wyniszczane", "wyniszczone", "wyniuchane", "wynoszone", "wynurzane", "wyobrażane", "wyobrażone", "wyodrębnione", "wyolbrzymiane", "wyolbrzymione", "wyorbowane", "wyosiowane", "wyostrzane", "wyostrzone", "wypaczane", "wypakowane", "wypakowywane", "wypalane", "wypalone", "wypałowane", "wyparowane", "wyparte", "wypasane", "wypastowane", "wypatroszone", "wypatrywane", "wypatrzone", "wypchane", "wypchnięte", "wypędzane", "wypędzlowane", "wypełniane", "wypełnione", "wypersfadowane", "wyperswadowane", "wypierane", "wypięte", "wypijane", "wypinane", "wypisane", "wypisywane", "wypite", "wypłacane", "wypłacone", "wypłakane", "wypłakiwane", "wypłaszczone", "wyplatane", "wyplątane", "wyplenione", "wyplewione", "wypłoszone", "wypłukane", "wypłukiwane", "wyplute", "wypluwane", "wypocone", "wypoczęte", "wypolerowane", "wypominane", "wypomniane", "wypompowane", "wypompowywane", "wyposażone", "wypowiadane", "wypowiedziane", "wypoziomowane", "wypożyczane", "wypracowane", "wypracowywane", "wyprane", "wyprasowane", "wypraszane", "wyprawiane", "wyprawione", "wypróbowane", "wyprodukowane", "wyprojektowane", "wypromieniowane", "wypromowane", "wyprostowane", "wyprostowywane", "wyproszone", "wyprowadzane", "wyprowadzone", "wypróżniane", "wypróżnione", "wyprute", "wypruwane", "wyprzedane", "wyprzedawane", "wyprzedzane", "wyprzedzone", "wyprzęgane", "wypstrykane", "wypucowane", "wypuszczane", "wypuszczone", "wypychane", "wypytane", "wypytywane", "wyrąbane", "wyrabiane", "wyrąbywane", "wyratowane", "wyrażane", "wyrażone", "wyrecytowane", "wyręczane", "wyręczone", "wyregulowane", "wyrejestrowane", "wyremontowane", "wyreżyserowane", "wyrobione", "wyrolowane", "wyrośnięte", "wyrównane", "wyrównywane", "wyróżniane", "wyróżnione", "wyrugowane", "wyruszane", "wyrwane", "wyrypane", "wyrysowane", "wyryte", "wyrywane", "wyrządzone", "wyrzeźbione", "wyrżnięte", "wyrzucane", "wyrzucone", "wyrzygane", "wyrzynane", "wyrzywane", "wysączone", "wysadzane", "wysadzone", "wyschnięte", "wyściskane", "wyselekcjonowane", "wysępione", "wysiadywane", "wysiedzone", "wysilane", "wysilone", "wyskakiwane", "wyskalowane", "wyskoczone", "wyskrobane", "wyskubywane", "wysłane", "wyśledzone", "wyślizgiwane", "wyślizgnięte", "wysłowione", "wysłuchane", "wysłuchiwane", "wysmagane", "wysmarkane", "wysmarowane", "wysmażane", "wysmażone", "wyśmiane", "wyśmiewane", "wysmołowane", "wysmyrane", "wyśnione", "wysnute", "wysnuwane", "wysondowane", "wyspecjalizowane", "wyśpiewane", "wyśpiewywane", "wyspowiadane", "wysprzątane", "wysprzedane", "wyssane", "wystartowane", "wystawione", "wysterelizowane", "wysterylizowane", "wystosowane", "wystosowywane", "wystraszone", "wystrojone", "wystrugane", "wystrychnięte", "wystrzegane", "wystrzelane", "wystrzeliwane", "wystrzelone", "wystudzone", "wystukane", "wystukiwane", "wystygnięte", "wysunięte", "wysuszane", "wysuwane", "wyswatane", "wyświadczane", "wyświadczone", "wyświetlane", "wyświetlone", "wyswobodzone", "wysyłane", "wysypane", "wysypywane", "wysysane", "wyszabrowane", "wyszalane", "wyszarpane", "wyszarpnięte", "wyszasowane", "wyszczotkowane", "wyszczuplone", "wyszeptane", "wyszkolone", "wyszlifowane", "wyszorowane", "wyszperane", "wyszukane", "wyszukiwane", "wyszumione", "wyszykowane", "wyszyte", "wytapetowane", "wytargane", "wytargowane", "wytarte", "wytarzane", "wytaszczone", "wytatuowane", "wytchnięte", "wytępione", "wytknięte", "wytłoczone", "wytłumaczone", "wytłumione", "wytoczone", "wytrąbione", "wytrącane", "wytrącone", "wytransmitowane", "wytransportowane", "wytrenowane", "wytresowane", "wytriangulowane", "wytropione", "wytrute", "wytrząsane", "wytrzasnięte", "wytrząśnięte", "wytrzebione", "wytrzepane", "wytrzeszczane", "wytrzeźwiane", "wytrzymane", "wytrzymywane", "wytwarzane", "wytworzone", "wytyczone", "wytykane", "wytypowane", "wyuczone", "wywabiane", "wywabione", "wywąchane", "wywalane", "wywalczone", "wywalone", "wywarte", "wywarzane", "wyważane", "wyważone", "wywęszane", "wywężykowane", "wywiane", "wywiązane", "wywiązywane", "wywierane", "wywiercone", "wywieszane", "wywieszone", "wywietrzone", "wywiezione", "wywijane", "wywindowane", "wywinięte", "wywłaszczone", "wywlekane", "wywnętrznione", "wywnioskowane", "wywodzone", "wywolane", "wywoływane", "wywoskowane", "wywożone", "wywracane", "wywrócone", "wywróżone", "wywyższane", "wyżalone", "wyzbyte", "wyzdrowione", "wyżebrane", "wyżerane", "wyzerowane", "wyzionięte", "wyznaczane", "wyznaczone", "wyznane", "wyznawane", "wyzwalane", "wyzwane", "wyzwolone", "wyzygzakowane", "wyżynane", "wyzyskane", "wyzyskiwane", "wyżyte", "wyzywane", "wyżywane", "wyżywione", "wzbijane", "wzbite", "wzbogacane", "wzbogacone", "wzbraniane", "wzbudzane", "wzbudzone", "wzburzane", "wzburzone", "wżenione", "wzięte", "wzmacnione", "wzmagane", "wzmocnione", "wznawiane", "wzniecane", "wzniecione", "wzniesięte", "wznoszone", "wznowione", "wzorowane", "wzrośnięte", "wzruszone", "wzwyżane", "wzywane", "zaabordowane", "zaadaptowane", "zaadoptowane", "zaadresowane", "zaakcentowane", "zaakceptowane", "zaaklimatyzowane", "zaalarmowane", "zaanektowane", "zaangażowane", "zaanonsowane", "zaapelowane", "zaaplikowane", "zaaportowane", "zaaprobowane", "zaaranżowane", "zaaresztowane", "zaatakowane", "zabaczone", "zabalowane", "zabandażowane", "zabarwione", "zabarykadowane", "zabawiane", "zabawione", "zabepieczane", "zabetonowane", "zabezpieczone", "zabierane", "zabite", "zabłądzone", "zablefowane", "zabłocone", "zablokowane", "zabraniane", "zabrane", "zabrnięte", "zabronione", "zabrudzone", "zabudowane", "zabukowane", "zabulone", "zaburzone", "zabutelkowane", "zacementowane", "zacerowane", "zachciane", "zachęcane", "zachęcone", "zachlapane", "zachodzone", "zachomikowane", "zachorowane", "zachowane", "zachowywane", "zachwalane", "zachwalone", "zachwiane", "zachwycone", "zaciągane", "zaciągnięte", "zaciążone", "zaciekawione", "zaciemniane", "zaciemnione", "zacierane", "zacieśnione", "zacięte", "zacinane", "zaciskane", "zaciśnięte", "zaćmione", "zacumowane", "zacytowane", "zaczadzone", "zaczarowane", "Zaczepiane", "zaczepione", "zaczerpane", "zaczesane", "zaczęte", "zaczołgane", "zaczynane", "zadarte", "zadawalane", "zadawane", "zadbane", "zadebiutowane", "zadedykowane", "zadeklamowane", "zadeklarowane", "zademonstrowane", "zadenucjowane", "zadepeszowane", "zadeptane", "zadeptywane", "zadęte", "zadławione", "żądlone", "zadłużane", "zadłużone", "zadokowane", "zadomowione", "zadowalane", "zadrapane", "zadraśnięte", "zadręczane", "zadręczone", "zadrutowane", "zadurzane", "zadurzone", "zaduszone", "zadymione", "zadźgane", "zadziobane", "zadziwiane", "zadziwione", "zafakturowane", "zafałszowane", "zafarbowane", "zafiksowane", "zafundowane", "zagadane", "zagadnięte", "zagadywane", "zagajone", "zaganiane", "zagapione", "zagarażowane", "zagarniane", "zagarnięte", "zagaszone", "zagazowane", "zagęszczone", "zagięte", "zaginane", "zaginięte", "zagłębiane", "zagłębione", "zagłodzone", "zagłuszane", "zagłuszone", "zagmatwane", "zagnane", "zagnieżdżone", "zagojone", "zagonione", "zagospodarowane", "zagotowane", "zagrabione", "zagradzane", "zagrażane", "zagrodzone", "zagrywane", "zagryzane", "zagryzione", "zagrzane", "zagrzebane", "zagrzewane", "zagubione", "zagwarantowane", "zahaczone", "zahamowane", "zahandlowane", "zaharowane", "zahartowane", "zahipnotyzowane", "zaholowane", "zaimitowane", "zaimplantowane", "zaimplementowane", "zaimprowizowane", "zainaugurowane", "zainfekowane", "zainicjowane", "zainkasowane", "zainscenizowane", "zainspirowane", "zainstalowane", "zainteresowane", "zaintrygowane", "zaintubowane", "zainwestowane", "zaizolowane", "zajadane", "zajane", "zajarane", "zajechane", "zajęte", "zajmowane", "zakablowane", "zakamuflowane", "zakasane", "zakasowane", "zakąszane", "zakatalogowane", "zakatowane", "zakatrupione", "zakazane", "zakażane", "zakazywane", "zakiszone", "zakładane", "zaklasyfikowane", "zaklejane", "zaklejone", "zaklepane", "zaklepywane", "zaklinane", "zaklinowane", "zakłócane", "zakłócone", "zaklopotane", "zakłute", "zakneblowane", "zakodowane", "zakolczykowane", "zakolorowane", "zakołysane", "zakomunikowane", "zakończone", "zakonserwowane", "zakopane", "zakopywane", "zakorzeniane", "zakorzenione", "zakoszone", "zakosztowane", "zakotwiczane", "zakotwiczone", "zakpione", "zakradane", "zakręcane", "zakręcone", "zakreślane", "zakreślone", "zakrwawione", "zakryte", "zakrywane", "zakrzyczane", "zakrzyknięte", "zakrzywiane", "zakrzywione", "zaksięgowane", "zaktualizowane", "zaktywizowane", "zaktywowane", "zakumane", "zakupione", "zakurzone", "zakute", "zakuwane", "zakwaterowane", "zakwestionowae", "zakwitnięte", "załączone", "załadowane", "załagodzone", "zalamane", "zalaminowane", "załamywane", "zalane", "załapane", "załatane", "załatwiane", "załatwione", "zalatywane", "zalecane", "zalecone", "zaleczone", "zalegalizowane", "zalegane", "zalepiane", "zalepione", "zalewane", "zaliczane", "zaliczone", "załkane", "zalogowane", "żałowane", "założone", "zaludnione", "zamacane", "zamachnięte", "zamącone", "zamalowane", "zamanewrowane", "zamanifestowane", "zamarkowane", "zamartwiane", "zamarynowane", "zamarzane", "zamarznięte", "zamaskowane", "zamawiane", "zamazane", "zamazywane", "zamęczane", "zamęczone", "zameldowane", "zamelinowane", "zamerykanizowane", "zamiatane", "zamieniane", "zamienione", "zamieszane", "zamieszczane", "zamieszczone", "zamieszkane", "zamieszkiwane", "zaminowane", "zamknięte", "zamocowane", "zamoczone", "zamontowane", "zamordowane", "zamortyzowane", "zamotane", "zamówione", "zamrażane", "zamroczone", "zamrożone", "zamulane", "zamurowane", "zamydlone", "zamykane", "zanalizowane", "zanegowane", "zaniechane", "zanieczyszczane", "zanieczyszczone", "zaniedbane", "zaniedbywane", "zaniepokojone", "zaniesione", "zanihilowane", "zanikane", "zaniknięte", "zaniżane", "zaniżone", "zanoszone", "zanotowane", "zanucone", "zanudzane", "zanudzone", "zanurzane", "zanurzone", "zanużone", "zaobaczone", "zaobserwowane", "zaoferowane", "zaofiarowane", "zaogniane", "zaognione", "zaokrąglane", "zaokrąglone", "zaokrętowane", "zaopatrywane", "zaopatrzone", "zaopiekowane", "zaorane", "zaostrzane", "zaostrzone", "zaoszczędzone", "zapadane", "zapakowane", "zapalane", "zapalone", "zapamiętane", "zapamiętywane", "zapanowane", "zaparkowane", "zaparowywane", "zaparzane", "zaparzone", "zapaskudzone", "zapauzowane", "zapchane", "zapędzane", "zapełniane", "zapełnione", "zaperfumowane", "zapeszane", "zapewniane", "zapewnione", "zapieczętowane", "zapierane", "zapięte", "zapijane", "zapinane", "zapisane", "zapisuwane", "zapite", "zapłacone", "zapładniane", "zaplamione", "zaplanowane", "zaplątane", "zapłodnione", "zaplombowane", "zapobiegane", "zapodane", "zapodawane", "zapodziane", "zapokojone", "zapolowane", "zapominane", "zapomniane", "zapowiadane", "zapowiedziane", "zapoznane", "zapoznawane", "zapożyczone", "zapracowywane", "zaprane", "zaprasowywane", "zapraszane", "zaprawione", "zaprenumerowane", "zaprezentowane", "Zaprogramowane", "zaprojektowane", "zaproponowane", "zaproszone", "zaprotokołowane", "zaprowadzane", "zaprowadzone", "zaprzątane", "zaprzeczane", "zaprzeczone", "zaprzedane", "zaprzedawane", "zaprzęgane", "zaprzepaszczane", "zaprzestane", "zaprzestawane", "zaprzyjaźnione", "zapudłowane", "zapunktowane", "zapuszczane", "zapuszczone", "zapuszkowane", "zapychane", "zapylane", "zapylone", "zapytane", "zarabiane", "zaranżowane", "zarażane", "zarażone", "zarecytowane", "zaręczane", "zaręczone", "zarejestrowane", "zareklamowane", "zarekomendowane", "zarekomondowane", "zarekwirowane", "zarezerwowane", "zarobione", "żartowane", "zarwane", "zaryglowane", "zarymowane", "zarysowane", "zarywane", "zaryzykowane", "zarządzane", "zarżnięte", "zarzucane", "zarzynane", "zasadzone", "zaścielone", "zasegurowane", "zaserwowane", "zasiadane", "zasiane", "zasiedlone", "zasięgane", "zasięgnięte", "zasiewane", "zasilane", "zasilone", "zaskakiwane", "zaskarbione", "zaskoczone", "zaskrobane", "zasłaniane", "zaślepiane", "zaślepione", "zasłodzone", "zasłonione", "zasłużone", "zasmakowane", "zaśmiecane", "zaśmiecone", "zasmradzane", "zasmrodzone", "zasmucane", "zasmucone", "zasolone", "zaspakajane", "zaśpiewane", "zaspokajane", "zaspokojone", "zasponsorowane", "zaśrubowywane", "zassane", "zastane", "zastąpione", "zastawiane", "zastawione", "zastępowane", "zastopowane", "zastosowane", "zastraszane", "zastraszone", "zastrzelone", "zasugerowane", "zasunięte", "zasuwane", "zaświadczone", "zaświecone", "zaświonione", "zasyfione", "zasygnalizowane", "zasymilowane", "zasymulowane", "zasypane", "zasypywane", "zasysane", "zaszachowane", "zaszantażowane", "zaszargane", "zaszczepiane", "zaszczepione", "zaszczute", "zaszczycane", "zaszczycone", "zaszeptane", "zaszeregowane", "zaszlachtowane", "zasznurowane", "zaszpachlowane", "zasztyletowane", "zaszufladkowane", "zaszyfrowane", "zaszyte", "zaszywane", "zataczane", "zatajane", "zatajone", "zatamowane", "zatankowane", "zatapiane", "zatargane", "zatarte", "zatelegrafowane", "zatemperowane", "zatęsknione", "zatkane", "zatknięte", "zatoczone", "zatonięte", "zatopione", "zatracane", "zatracone", "zatriumfowane", "zatrudniane", "zatrudnione", "zatrute", "zatruwane", "zatrzaskiwane", "zatrzaśnięte", "zatrząśnięte", "zatrzymane", "zatrzymywane", "zatuszowane", "zatwierdzane", "zatwierdzone", "zatykane", "zatynkowane", "zatytułowane", "zauploadowane", "zauroczone", "zautomatyzowane", "zauważane", "zauważone", "zawadzane", "zawalane", "zawalczone", "zawalone", "zawarte", "zaważone", "zawdzięczane", "zawetowane", "zawężone", "zawiadamiane", "zawiadomione", "zawiązane", "zawiązywane", "zawiedzone", "zawierane", "zawierzone", "zawieszane", "zawieszone", "zawiezione", "zawijane", "zawinięte", "zawinione", "zawiśnięte", "zawitane", "zawładnięte", "zawłaszczone", "zawodzone", "zawojowane", "zawołane", "zawoskowane", "zawożone", "zawracane", "zawrócone", "zawstydzane", "zażądane", "zażartowane", "zazdroszczone", "zażegnane", "zażenowane", "zaznaczane", "zaznajomione", "zaznane", "zaznawane", "zażyczone", "zażyte", "zażywane", "zbaczane", "zbadane", "zbagatelizowane", "zbajerowane", "zbałamucone", "zbalansowane", "zbalsamowane", "zbankrutowane", "zbawiane", "zbawione", "zbesztane", "zbezczeszczone", "zbierane", "zbijane", "zbite", "zbliżone", "zbluzgane", "zbojkotowane", "zbrojone", "zbrukane", "zbszczecone", "zbudowane", "zbudzone", "zbuntowane", "zburzone", "zbyte", "zbywane", "zchwytane", "zcięte", "zciszone", "zdane", "zdarte", "zdeaktywowane", "zdecydowane", "zdefiniowane", "zdeflorowane", "zdegradowane", "zdejmowane", "zdeklarowane", "zdekodowane", "zdekompresowane", "zdekoncentrowane", "zdekonstruowane", "zdelegalizowane", "zdemaskowane", "zdementowane", "zdemolowane", "zdemontowane", "zdemoralizowane", "zdenerwowane", "zdeponowane", "zdeprymowane", "zdeptane", "zderzane", "zderzone", "zdestabilizowane", "Zdetonowane", "zdetronizowane", "zdewastowane", "zdewaulowane", "zdezerterowane", "zdezintegrowane", "zdezorientowane", "zdezynfektowane", "zdiagnozowane", "zdjęte", "zdławione", "zdmuchiwane", "zdmuchnięte", "zdobyte", "zdobywane", "zdołowane", "zdominowane", "zdopingowane", "zdrabniane", "zdradzane", "zdradzone", "zdrapane", "zdrapywane", "zdrutowane", "zdruzgotane", "zduplikowane", "zduszone", "zdwojone", "zdyscyplinowane", "zdyskredytowane", "zdyskwalifikowane", "zdystansowane", "zdzielone", "zdzierane", "zdzierżone", "zdziesiątkowane", "Zdzwonione", "zebrane", "zechciane", "zedytowane", "żegnane", "żenione", "zepchnięte", "zepsute", "żerowane", "zerwane", "zerżnięte", "zeskakiwane", "zeskanowane", "zeskrobywane", "zesłane", "ześlizgiwane", "ześlizgnięte", "zesmolone", "zespawiane", "zespolone", "zessane", "zestawiane", "zestawione", "zestresowane", "zestrzeliwane", "zestrzelone", "zeswatane", "zeszklone", "zeszlifowane", "zetknięte", "zezłoszczone", "zeznane", "zeznawane", "zezwalane", "zezwolone", "zfinansowane", "zgadane", "zgadywane", "zgajane", "zganione", "zgarnięte", "zgaśnięte", "zgaszone", "zgięte", "zginane", "zgładzone", "zgłaszane", "zgłębiane", "zgłębione", "zgłośnione", "zgłoszone", "zgłuszone", "zgniatane", "zgniecione", "zgnite", "zgnojone", "zgodzone", "zgolone", "zgonione", "zgotowane", "zgrabione", "zgrillowane", "zgromadzane", "zgromadzone", "zgrupowane", "zgrzeszone", "zgrzytane", "zgubione", "zgwałcone", "zhackowane", "zhakowane", "zhańbione", "zhandlowane", "zharmonizowane", "zidentyfikowane", "ziewane", "zignorowane", "zilustrowane", "zinfiltrowane", "zintegrowane", "zintensyfikowane", "zinterpretowane", "zinwentaryzowane", "zirytowane", "zjadane", "zjawiane", "zjednane", "zjednoczone", "zjedzone", "zjeżdżone", "zkontaktowane", "zkserowane", "złączone", "złagodzone", "złajane", "złamane", "zlane", "złapane", "zlecane", "zlecone", "zlekceważone", "zlepiane", "zlepione", "zlewane", "zlicytowane", "zliczane", "zliczone", "zlikwidowane", "zlinczowane", "zlitowane", "zlizane", "zlizywane", "złoite", "zlokalizowane", "złomowane", "żłopane", "złowione", "złożone", "złupione", "złuszczane", "zluzowane", "zmacane", "zmącone", "zmagane", "zmagazynowane", "zmajstrowane", "zmaksylizowane", "zmanipulowane", "zmarnowane", "zmartwychwstane", "zmarznięte", "zmasakrowane", "zmaterializowane", "zmawiane", "zmazane", "zmazywane", "zmbobardowane", "zmiatane", "zmiażdżone", "zmiękczone", "zmielone", "zmieniane", "zmienione", "zmierzane", "zmierzone", "zmierzwione", "zmieszane", "zmieszczone", "zmiksowane", "zminiaturyzowane", "zminimalizowane", "zmniejszane", "zmniejszone", "zmobilizowane", "zmoczone", "zmodernizowane", "zmodyfikowane", "zmoknięte", "zmonopolizowane", "zmontowane", "zmostkowane", "zmotywowane", "zmówione", "zmrożone", "zmrużone", "zmumifikowane", "zmuszane", "zmuszone", "zmutowane", "zmyślane", "zmyte", "zmywane", "znacjonalizowane", "znajdowane", "znajdywane", "znakowane", "znalezione", "znane", "znęcane", "zneutralizowane", "zniechęcone", "znieczulone", "zniekształcane", "zniekształcone", "znienawidzone", "znieprawione", "zniesione", "zniesławiane", "zniesławione", "zniewalane", "znieważane", "znieważone", "zniewolone", "zniszczone", "zniweczone", "zniwelowane", "zniżane", "zniżone", "znokautowane", "znormalnione", "znoszone", "znudzone", "zobaczone", "zobowiązane", "zobrazowane", "zogniskowane", "żonglowane", "zoomowane", "zoperowane", "zoptymalizowane", "zorbite", "zorganizowane", "zorientowane", "zostawiane", "zostawione", "zpłacone", "zprowokowane", "zrabowane", "zrachowane", "zracjonalizowane", "zranione", "zraportowane", "zrażane", "zrażone", "zrealizowane", "zrecenzowane", "zredagowane", "zredukowane", "zreferowane", "zreformowane", "zrefowane", "zrefundowane", "zregenerowane", "zrehabilitowane", "zreinkarnowane", "zreintegrowane", "zrekonfigurowane", "zrekonstruowane", "zrekrutowane", "zrekrystalizowane", "zrelacjonowane", "zrelaksowane", "zremiksowane", "zremisowane", "zreorganizowane", "zreperowane", "zreplikowane", "zresetowane", "zresocjalizowane", "zrestartowane", "zrestrukturyzowane", "zrewanżowane", "zrewidowane", "zrewolucjonizowane", "zrezygnowane", "zrobione", "zrolowane", "zroszone", "zrównane", "zrównoważone", "zrównywane", "zróżnicowane", "zrozumiane", "zrugane", "zruinowane", "zrujnowane", "zrymowane", "zrywane", "zrzędzone", "zrzeszone", "zrzucane", "zrzucone", "zsumowane", "zsunięte", "zsuwane", "zsynchronizowane", "zsyntetyzowane", "zsypywane", "zszargane", "zszokowane", "zszyte", "zszywane", "ztarte", "żute", "zutylizowane", "zużyte", "zużywane", "zwabiane", "zwabione", "zwalane", "zwalczone", "zwalniane", "zwalone", "zwane", "zwaporyzowane", "zwątpione", "zważane", "zważone", "zwędzone", "zwerbalizowane", "zwerbowane", "zweryfikowane", "zwęszone", "zwężone", "zwiastowane", "związane", "związywane", "zwichnięte", "zwiedzane", "zwiedzone", "zwiększone", "zwieńczone", "zwierzane", "zwieszane", "zwieszone", "zwietrzone", "zwijane", "zwilżone", "zwinięte", "zwizualizowane", "zwlekane", "zwodowane", "zwodzone", "zwołane", "zwolnione", "zwoływane", "zwożone", "zwracane", "zwrócone", "zwyciężane", "zwymiotowane", "życzone", "żygane", "zygzakowane", "zyskane", "zyskiwane", "żyte", "zżarte", "zżerane", "zżynane", "zżyte", "bici", "brnięci", "capnięci", "chlapnięci", "chuci", "ciachnięci", "ciągnięci", "cięci", "ciśnięci", "cmoknięci", "cofnięci", "czuci", "czyci", "darci", "dmuchnięci", "dobici", "dobyci", "dociągnięci", "docięci", "dociśnięci", "doglądnięci", "domknięci", "domyci", "dopadnięci", "dopchnięci", "dopięci", "dopici", "dopłynięci", "doścignięci", "dosięgnięci", "dosunięci", "doszyci", "dotknięci", "dożyci", "drapnięci", "draśnięci", "drgnięci", "dźgnięci", "dziabnięci", "dźwignięci", "gięci", "gnici", "golnięci", "gruchnięci", "gwizdnięci", "hajtnięci", "huknięci", "kantowanci", "kiwnięci", "klapnięci", "klepnięci", "kliknięci", "kłuci", "knuci", "kojfnięci", "kopnięci", "kpici", "kryci", "krzepnięci", "krzyknięci", "kuci", "liznięci", "łyknięci", "machnięci", "marznięci", "maznięci", "minięci", "myci", "nabici", "nabyci", "naciągnięci", "nacięci", "naciśnięci", "nadciągnięci", "nadcięci", "nadszarpnięci", "nadużyci", "nagięci", "najęci", "nakłuci", "nakryci", "napadnięci", "napięci", "napluci", "napoczęci", "napsuci", "nasunięci", "naszyci", "natarci", "natchnięci", "natknięci", "natrząsnięci", "nawinięci", "obciągnięci", "obcięci", "obdarci", "obici", "objęci", "obmyci", "obsunięci", "obtarci", "obwinięci", "obyci", "ochłonięci", "ocknięci", "ocuci", "odarci", "odbici", "odbyci", "odciągnięci", "odcięci", "odcisnięci", "odczuci", "odepchnięci", "odetnięci", "odgadnięci", "odgarnięci", "odgięci", "odjęci", "odkryci", "odkuci", "odparci", "odpięci", "odpłynięci", "odpruci", "odrośnięci", "odsłonięci", "odsunięci", "odtruci", "odwinięci", "odżyci", "ogarnięci", "okryci", "okrzyknięci", "olśnięci", "ominięci", "opadnięci", "oparci", "opchnięci", "opici", "opluci", "orżnięci", "osiągnięci", "oślepnięci", "ostrzelici", "osunięci", "otarci", "otruci", "otrząśnięci", "owinięci", "ożyci", "pacnąci", "palnięci", "parci", "pchnięci", "pęknięci", "pięci", "pici", "pluci", "pobici", "pochłonięci", "pociągnięci", "pocięci", "poczęci", "poczuci", "podarci", "podbici", "podciągnięci", "podcięci", "podjęci", "podkradnięci", "podkuci", "podmyci", "podnajęci", "podpadnięci", "podparci", "podpięci", "podpłynięci", "podsunięci", "podszyci", "podtarci", "podwinięci", "podźwignięci", "pojęci", "pojmięci", "pokłuci", "pokryci", "połknięci", "pominięci", "pomknięci", "poparci", "popchnięci", "popici", "popsuci", "posunięci", "poszczuci", "potarci", "potknięci", "potruci", "potrząsnięci", "potrząśnięci", "powici", "powściągnięci", "powzięci", "pożarci", "pozbyci", "pożuci", "pożyci", "pruci", "pryśnięci", "przebiegnięci", "przebici", "przebyci", "przeciągnięci", "przecięci", "przeciśnięci", "przeczuci", "przedarci", "przedsiewzięci", "przegięci", "przeglądnięci", "przejęci", "przeklęci", "przeklnięci", "przekłuci", "przekuci", "przełknięci", "przełyknięci", "przeminięci", "przemknięci", "przemyci", "przeniknięci", "przepchnięci", "przepici", "przepłynięci", "przerośnięci", "prześcignięci", "prześlizgnięci", "przesłonięci", "przesunięci", "przeszyci", "przetarci", "przetrząśnięci", "przewinięci", "przeżarci", "przeżuci", "przeżyci", "przybici", "przyciągnięci", "przycięci", "przyciśnięci", "przydepnięci", "przygarnięci", "przyjęci", "przykryci", "przykuci", "przymknięci", "przypadnięci", "przyparci", "przypięci", "przypłynięci", "przysiągnięci", "przysunięci", "przyszyci", "przytarci", "przytrzasnięci", "przywarci", "pstryknięci", "psuci", "puchnięci", "puknięci", "rozbici", "rozbłyśnięci", "rozciągnięci", "rozcięci", "rozgarnięci", "rozgięci", "rozkuci", "rozkwitnięci", "rozminięci", "rozmyci", "rozpięci", "rozpłynięci", "rozpoczęci", "rozpruci", "rozrośnięci", "rozstrzygnięci", "rozsunięci", "roztarci", "rozwarci", "rozwinięci", "runięci", "ryci", "rżnięci", "ściągnięci", "ścięci", "ściśnięci", "skrobnięci", "skryci", "skrzepnięci", "skrzyci", "skubnięci", "skuci", "smuci", "snuci", "spięci", "spici", "spłonięci", "spoczęci", "spożyci", "sprzątnięci", "stnięci", "struci", "strząśnięci", "strzepnięci", "stuknięci", "sunięci", "sypnięci", "szarpnięci", "szczuci", "szepnięci", "sztachnięci", "szturchnięci", "szyci", "targnięci", "tarci", "tchnięci", "tknięci", "truci", "tryśnięci", "trzasnięci", "trzepnięci", "ubici", "uciągnięci", "ucięci", "uciśnięci", "uczuci", "udźwignięci", "ugięci", "ugrzęznięci", "uiścici", "ujęci", "ukłuci", "uknuci", "ukryci", "ukuci", "umknięci", "umyci", "uniknięci", "uparci", "upchnięci", "upięci", "upici", "upłynięci", "uprzątnięci", "urośnięci", "urżnięci", "uschnięci", "uściśnięci", "usunięci", "uszczypnięci", "uszyci", "utarci", "utknięci", "uwinięci", "uwici", "użyci", "walnięci", "wbici", "wchłonięci", "wciągnięci", "wcięci", "wciśnięci", "wczuci", "wdarci", "wdepnięci", "wepchnięci", "wetknięci", "wici", "wkłuci", "wkuci", "wniknięci", "wpięci", "wryci", "wślizgnięci", "wsparci", "wspięci", "współczuci", "współżyci", "wstrząśnięci", "wstrzyknięci", "wsunięci", "wszczęci", "wszyci", "wtargnięci", "wtarci", "wybici", "wyblaknięci", "wybuchnięci", "wyciągnięci", "wycięci", "wyciśnięci", "wyczuci", "wydobyci", "wyfrunięci", "wygarnięci", "wygaśnięci", "wygięci", "wyjęci", "wykluci", "wykłuci", "wykopnięci", "wykpici", "wykradnięci", "wykryci", "wykrzyknięci", "wykuci", "wyminięci", "wymknięci", "wymsknięci", "wymyci", "wynajęci", "wyniknięci", "wyparci", "wypchnięci", "wypięci", "wypici", "wypluci", "wypoczęci", "wypruci", "wyrośnięci", "wyryci", "wyrżnięci", "wyschnięci", "wyślizgnięci", "wysnuci", "wystrychnięci", "wystygnięci", "wysunięci", "wyszarpnięci", "wyszyci", "wytarci", "wytchnięci", "wytknięci", "wytruci", "wytrzasnięci", "wytrząśnięci", "wywarci", "wywinięci", "wyzbyci", "wyzionięci", "wyżyci", "wzbici", "wzięci", "wzniesięci", "wzrośnięci", "zabici", "zabrnięci", "zaciągnięci", "zacięci", "zaciśnięci", "zaczęci", "zadarci", "zadęci", "zadraśnięci", "zagadnięci", "zagarnięci", "zagięci", "zaginięci", "zajęci", "zakłuci", "zakryci", "zakrzyknięci", "zakuci", "zakwitnięci", "zamachnięci", "zamarznięci", "zamknięci", "zaniknięci", "zapięci", "zapici", "zarżnięci", "zasięgnięci", "zasunięci", "zaszczuci", "zaszyci", "zatarci", "zatknięci", "zatonięci", "zatruci", "zatrzaśnięci", "zatrząśnięci", "zawarci", "zawinięci", "zawiśnięci", "zawładnięci", "zażyci", "zbici", "zbyci", "zcięci", "zdarci", "zdjęci", "zdmuchnięci", "zdobyci", "zepchnięci", "zepsuci", "zerżnięci", "ześlizgnięci", "zetknięci", "zgarnięci", "zgaśnięci", "zgięci", "zgnici", "złoici", "zmarznięci", "zmoknięci", "zmyci", "zorbici", "zsunięci", "zszyci", "ztarci", "żuci", "zużyci", "zwichnięci", "zwinięci", "życi", "zżarci", "zżyci", "abdykowani", "absorbowani", "adaptowani", "administrowani", "adoptowani", "adorowani", "adresowani", "afiszowani", "agitowani", "akcentowani", "akceptowani", "aklimatyzowani", "akompaniowani", "aktualizowani", "aktywowani", "akumulowani", "alaromowani", "alienowani", "amerykanizowani", "amortyzowani", "amputowani", "analizowani", "angażowani", "anihilowani", "animowani", "anonsowani", "antropomorfizowani", "antydatowani", "anulowani", "apelowani", "aportowani", "aranżowani", "archiwizowani", "aresztowani", "argumentowani", "artykułowani", "ascendowani", "asekurowani", "asymilowani", "asystowani", "atakowani", "autoryzowani", "awanturowani", "babrani", "baczeni", "badani", "bagatelizowani", "bajerowani", "bałamuceni", "balangowani", "balansowani", "banalizowani", "bandażowani", "bankrutowani", "baraszkowani", "barwieni", "bawieni", "bazgrani", "bazowani", "bębnieni", "bełkotani", "besztani", "biczowani", "błagani", "błaznowani", "blefowani", "błogosławieni", "blokowani", "bluzgani", "błyskani", "boczeni", "bogaceni", "bojkotowani", "boksowani", "bombardowani", "bopowani", "borowani", "brandzlowani", "brani", "brasowani", "bratani", "brodzeni", "bronieni", "brudzeni", "brylowani", "budowani", "budzeni", "bujani", "buleni", "bulwersowani", "bumelowani", "burzeni", "butelkowani", "bywani", "cackani", "całowani", "cechowani", "celebrowani", "celowani", "cenieni", "cenzurowani", "chciani", "chlani", "chlapani", "chlastani", "chłodzeni", "chlostani", "chlubieni", "chodowani", "chomikowani", "chorowani", "chowani", "chronieni", "chrupani", "chrzczeni", "chwaleni", "chwyceni", "chwytani", "chybotani", "chyleni", "ciągani", "ciemiężeni", "cierpiani", "cieszeni", "ciskani", "ciułani", "cmokani", "cofani", "ćpani", "cuceni", "cudzołożeni", "cumowani", "ćwiartowani", "ćwiczeni", "cykani", "cytowani", "czajeni", "czarowani", "czczeni", "czepiani", "czepieni", "czerpani", "czesani", "częstowani", "czochrani", "czołgani", "czytani", "darowani", "darzeni", "datowani", "dawani", "dbani", "deaktywowani", "debatowani", "dedukowani", "dedykowani", "defibrylowani", "defilowani", "definiowani", "defraudowani", "degradowani", "degustowani", "deklamowani", "deklarowani", "dekodowani", "dekompresowani", "dekorowani", "dekretowani", "delegowani", "delektowani", "deliberowani", "demaskowani", "dementowani", "demolowani", "demonizowani", "demonstrowani", "demoralizowani", "denerwowani", "denuncjowani", "depeszowani", "depilowani", "deportowani", "deprawowani", "deptani", "deratyzowani", "destabilizowani", "destylowani", "desygnowani", "determinowani", "detonowani", "dewastowani", "dewaulowani", "dezaktywowani", "dezorientowani", "dezynfekowani", "diagnozowani", "dilowani", "dłubani", "dłużeni", "dmuchani", "dobiegani", "dobierani", "dobijani", "dobrani", "dobudzeni", "doceniani", "docenieni", "dochodzeni", "dochowani", "dochowywani", "dociekani", "docinani", "dociskani", "doczekani", "doczepieni", "doczołgani", "doczyszczeni", "doczytani", "dodani", "dodawani", "dodrukowani", "dodrukowywani", "dofinansowani", "dofinansowywani", "dogadani", "dogadywani", "dogadzani", "doganiani", "doglądani", "dognani", "dogodzeni", "dogonieni", "dograni", "dogryzani", "dogryzioni", "dogrzani", "dogrzebani", "doinformowani", "dojeżdżani", "dojeni", "dojrzani", "dojrzewani", "dokańczani", "dokarmiani", "dokarmieni", "dokazani", "dokazywani", "dokładani", "doklejeni", "dokonani", "dokończeni", "dokonywani", "dokopani", "dokopywani", "dokowani", "dokręcani", "dokręceni", "dokształcani", "dokształceni", "dokuczani", "dokumentowani", "dokupieni", "dołączani", "dołączeni", "doładowani", "dolani", "dolewani", "doliczeni", "dołowani", "dołożeni", "domagani", "domalowani", "domniewywani", "domówieni", "domyślani", "domyśleni", "doniesieni", "donoszeni", "dopadani", "dopakowani", "dopaleni", "dopasowani", "dopasowywani", "dopatrywani", "dopatrzeni", "dopchani", "dopełniani", "dopełnieni", "dopieszczeni", "dopijani", "dopilnowani", "dopingowani", "dopisani", "dopisywani", "dopłacani", "dopłaceni", "dopolerowani", "dopompowani", "dopowiedziani", "dopracowani", "dopracowywani", "doprani", "doprawieni", "doprecyzowani", "doproszeni", "doprowadzani", "doprowadzeni", "dopucowani", "dopuszczani", "dopuszczeni", "dopytywani", "dorabiani", "doradzani", "doradzeni", "doręczani", "doręczeni", "dorobieni", "dorównani", "dorównywani", "dorwani", "dorysowani", "dorzucani", "dorzuceni", "dosiadani", "doskoczeni", "doskonaleni", "dosładzani", "dosłani", "dosłyszani", "dosoleni", "dośrodkowani", "dossani", "dostani", "dostąpieni", "dostarczani", "dostarczeni", "dostawani", "dostawiani", "dostawieni", "dostosowani", "dostosowywani", "dostrajani", "dostrojeni", "dostrzegani", "dosuwani", "doświadczani", "doświetleni", "dosypani", "dosypywani", "doszkoleni", "doszlifowani", "doszorowani", "doszukani", "doszukiwani", "dotankowani", "dotankowywani", "dotargani", "dotaszczeni", "dotlenieni", "dotłumaczeni", "dotowani", "dotrwani", "dotrzymani", "dotrzymywani", "dotykani", "douczani", "douczeni", "dowaleni", "dowiezieni", "dowodzeni", "dowożeni", "doznani", "doznawani", "dozorowani", "dozowani", "dożywieni", "dramatyzowani", "drapani", "drażnieni", "drążeni", "dręczeni", "drenowani", "drgani", "drukowani", "dryblowani", "dryfowani", "drzemani", "dubbingowani", "dublowani", "duplikowani", "duszeni", "dworowani", "dygotani", "dyktowani", "dymani", "dymieni", "dyrygowani", "dyscyplinowani", "dyskredytowani", "dyskryminowani", "dyskutowani", "dyskwalifikowani", "dysponowani", "dystansowani", "dystrybuowani", "dywagowani", "dźgani", "dziedziczeni", "dziękowani", "dzieleni", "dziergani", "dzierżeni", "dziobani", "dziurawieni", "dziurkowani", "dźwigani", "edukowani", "edytowani", "egzaminowani", "egzekutowani", "egzekwowani", "ekscytowani", "ekshumowani", "ekskomunikowani", "eksmitowani", "ekspandowani", "eksperymentowani", "eksploatowani", "eksplorowani", "eksponowani", "eksportowani", "eksterminowani", "ekstradowani", "ekstrapolowani", "eliminowani", "emancypowani", "emigrowani", "emitowani", "energetyzowani", "eskortowani", "etykietowani", "ewakuowani", "ewaluowani", "fabrykowani", "falowani", "fałszowani", "farbowani", "faszerowani", "faulowani", "faworyzowani", "fechtowani", "fermentowani", "ferowani", "figurowani", "filetowani", "filmowani", "filtrowani", "finalizowani", "finansowani", "firmowani", "fleszowani", "folgowani", "formułowani", "forsowani", "fotografowani", "fundowani", "gadani", "ganiani", "garbieni", "gardzeni", "garnirowani", "gaszeni", "gawędzeni", "gaworzeni", "gazowani", "gdakani", "gderani", "generalizowani", "generowani", "gilgotani", "gładzeni", "głaskani", "głodowani", "głodzeni", "gloryfikowani", "głosowani", "głoszeni", "głowieni", "gmatwani", "gmerani", "gnani", "gnębieni", "gnieceni", "gnojeni", "godzeni", "goleni", "gonieni", "googlowani", "gospodarowani", "goszczeni", "gotowani", "grabieni", "grani", "grasowani", "gratulowani", "grillowani", "grilowani", "gromadzeni", "gromieni", "grożeni", "gruchani", "grupowani", "grywani", "gryzieni", "grzani", "grzechotani", "gubieni", "gustowani", "gwałceni", "gwarantowani", "gwizdani", "hackowani", "haftowani", "hamowani", "hańbieni", "handlowani", "harcowani", "harmonizowani", "harowani", "hartowani", "hibernowani", "hipnotyzowani", "hodowani", "holowani", "hołubieni", "honorowani", "hospitalizowani", "hulani", "huśtani", "idealizowani", "identyfikowani", "ignorowani", "igrani", "ilustrowani", "imitowani", "implantowani", "implodowani", "imponowani", "importowani", "improwizowani", "indokrynowani", "indukowani", "infekowani", "infiltrowani", "informowani", "ingerowani", "inhalowani", "inscenizowani", "inspirowani", "instalowani", "instruowani", "insynuowani", "integrowani", "interpretowani", "interweniowani", "intonowani", "intubowani", "inwestowani", "inwigilowani", "irytowani", "iskrzeni", "izolowani", "jadani", "jawieni", "jazgotani", "jednoczeni", "jedzeni", "kablowani", "kadzeni", "kalani", "kaleczeni", "kalkulowani", "kamerowani", "kamienowani", "kamuflowani", "kanalizowani", "kąpani", "kapitulowani", "kapowani", "karani", "karbonizowani", "karceni", "karczowani", "karmieni", "kartkowani", "kąsani", "kasowani", "kastrowani", "katalogowani", "katapultowani", "katowani", "katrupieni", "kierowani", "kimani", "kiszeni", "kiwani", "kłaniani", "klapani", "klarowani", "klasyfikowani", "klębieni", "klejeni", "klepani", "klikani", "klonowani", "kłopotani", "knoceni", "kochani", "koczowani", "kodowani", "kojarzeni", "kojeni", "kolekcjonowani", "kolektywizowani", "kolidowani", "kolonizowani", "kolorowani", "koloryzowani", "kołowani", "kołysani", "kombinowani", "komenderowani", "komentowani", "komercjalizowani", "kompensowani", "komplementowani", "komplikowani", "komponowani", "kompromitowani", "komunikowani", "konani", "koncentrowani", "kończeni", "konfabulowani", "konfiskowani", "konfrontowani", "konserwowani", "konspirowani", "konstruowani", "konsultowani", "konsumowani", "kontaktowani", "kontestowani", "kontrastowani", "kontrolowani", "kontrowani", "kontynuowani", "kontynuuowani", "konwertowani", "konwojowani", "koordynowani", "kopani", "kopceni", "kopiowani", "kopulowani", "korelowani", "korkowani", "koronowani", "korygowani", "korzystani", "koszeni", "kotwiczeni", "kozaczeni", "kozłowani", "kradzieni", "krajani", "krążeni", "kręceni", "kremowani", "kreowani", "krochmaleni", "krojeni", "kropieni", "kruszeni", "krystalizowani", "krytykowani", "krzyczani", "krzywdzeni", "krzywieni", "krzyżowani", "kserowani", "księgowani", "kształceni", "kształtowani", "kuleni", "kultywowani", "kumulowani", "kupczeni", "kupieni", "kupowani", "kupywani", "kurczeni", "kurowani", "kursowani", "kurzeni", "kuszeni", "kwalifikowani", "kwestionowani", "łączeni", "ładowani", "łagodzeni", "łajdaczeni", "lakierowani", "łamani", "lamentowani", "lansowani", "lani", "łapani", "łaskotani", "łaszeni", "latani", "łatani", "lawirowani", "leczeni", "legalizowani", "legitymowani", "lekceważeni", "lepieni", "lewitowani", "liberowani", "licencjonowani", "licytowani", "liczeni", "likwidowani", "linczowani", "liniowani", "literowani", "litowani", "lizani", "lobbowani", "lokalizowani", "losowani", "łowieni", "łożeni", "lubiani", "łudzeni", "lunatykowani", "łupani", "łupieni", "łuskani", "lustrowani", "łuszczeni", "luzowani", "łykani", "łyżeczkowani", "macani", "machani", "mąceni", "maczani", "maganyzowani", "maglowani", "majaczeni", "majsterkowani", "majtani", "maksymalizowani", "malowani", "maltretowani", "mamieni", "mamrotani", "manewrowani", "manifestowani", "manipulowani", "markowani", "marnotrawieni", "marnowani", "marszczeni", "marynowani", "masakrowani", "maskowani", "masowani", "masturbowani", "mataczeni", "materializowani", "mawiani", "mazani", "męczeni", "meldowani", "merdani", "metabolizowani", "miażdżeni", "mieleni", "mierzeni", "mierzwieni", "mieszani", "miętoleni", "migani", "migdaleni", "migotani", "mijani", "miksowani", "milowani", "minimalizowani", "miotani", "mistyfikowani", "mitygowani", "mizdrzeni", "mlani", "mniemani", "mnożeni", "mobilizowani", "mocowani", "moczeni", "modelowani", "modernizowani", "modleni", "modulowani", "modyfikowani", "molestowani", "monitorowani", "monopolizowani", "montowani", "mordowani", "motywowani", "mrożeni", "mrugani", "mrużeni", "muskani", "mutowani", "mydleni", "myleni", "myszkowani", "nabazgrani", "nabiegani", "nabierani", "nabrani", "nabrojeni", "nabrudzeni", "nabywani", "nacelowani", "nachapani", "nachodzeni", "nachwaleni", "nachyleni", "naciągani", "nacierani", "nacinani", "naciskani", "nacjonalizowani", "naczepieni", "nadani", "nadawani", "nadchodzeni", "nadciągani", "nadesłani", "nadgonieni", "nadgryzani", "nadgryzieni", "nadinterpretowani", "nadłożeni", "nadmieniani", "nadmienieni", "nadmuchani", "nadrabiani", "nadrobieni", "nadskakiwani", "nadsłuchiwani", "nadstawiani", "nadstawieni", "naduszeni", "nadużywani", "nadwerężani", "nadwyrężani", "nadwyrężeni", "nadziani", "nadzorowani", "naelektryzowani", "nafaszerowani", "nagabywani", "nagadani", "naginani", "nagłaszani", "nagłośnieni", "nagonieni", "nagradzani", "nagrani", "nagrodzeni", "nagromadzeni", "nagrywani", "nagryzmoleni", "nagrzani", "nagrzebani", "nagrzewani", "nagwizdani", "naigrywani", "najechani", "najmowani", "nakarmiani", "nakarmieni", "nakazani", "nakazywani", "nakierowani", "nakierowywani", "nakładani", "nakłamani", "nakłaniani", "naklejani", "naklejeni", "naklepani", "nakłonieni", "nakłuwani", "nakopani", "nakręcani", "nakręceni", "nakreślani", "nakreśleni", "nakruszeni", "nakrywani", "nakrzyczani", "nakupieni", "naładowani", "nalani", "nałapani", "nalepieni", "nalewani", "naliczeni", "nałowieni", "nałożeni", "namaczani", "namagnetyzowani", "namalowani", "namaszczani", "namaszczeni", "namawiani", "namęczeni", "namierzani", "namieszani", "namoczeni", "namówieni", "namydlani", "namyśleni", "naniesieni", "naoliwiani", "naoliwieni", "naopowiadani", "naostrzeni", "napadani", "napakowani", "napaleni", "naparzani", "napastowani", "napawani", "napchani", "napędzani", "napełniani", "napełnieni", "napierani", "napiętnowani", "napinani", "napisani", "napływani", "napojeni", "napompowani", "napotkani", "napotykani", "napraszani", "naprawiani", "naprawieni", "naprężani", "naprężeni", "napromieniowani", "naprostowani", "naprowadzani", "naprowadzeni", "napuszczani", "napuszczeni", "napychani", "napytani", "narąbani", "naradzani", "naradzeni", "narastani", "narażani", "narażeni", "nareperowani", "narkotyzowani", "narodzeni", "naruszani", "naruszeni", "narwani", "narysowani", "narzucani", "narzuceni", "nasączani", "nasączeni", "nasadzeni", "nasiąkani", "nasilani", "nasileni", "naskakiwani", "naskoczeni", "naskrobani", "naśladowani", "nasłani", "nasłuchani", "nasłuchiwani", "nasmarowani", "nastąpieni", "nastawiani", "nastawieni", "nastraszani", "nastrojeni", "nastukani", "nasuwani", "naświetlani", "nasyceni", "nasyłani", "nasypani", "naszczani", "naszkicowani", "naszpikowani", "naszprycowani", "naszykowani", "naszywani", "natlenieni", "natłuszczeni", "natrafieni", "natrząsani", "nauczani", "nauczeni", "nawadniani", "nawaleni", "nawiązani", "nawiązywani", "nawiedzani", "nawiedzeni", "nawierceni", "nawiewani", "nawiezieni", "nawigowani", "nawijani", "nawilżani", "nawilżeni", "nawlekani", "nawodnieni", "nawoływani", "nawoskowani", "nawożeni", "nawpychani", "nawracani", "nawróceni", "nawrzucani", "nawtykani", "nawymyślani", "nazbierani", "nazmyślani", "naznaczani", "naznaczeni", "nazrywani", "nazwani", "nazywani", "nęceni", "negocjowani", "negowani", "nękani", "neutralizowani", "niańczeni", "niecierpliwieni", "niedoceniani", "niedowidziani", "nienawidzeni", "niesieni", "nikoleni", "niszczeni", "nitkowani", "niuchani", "niweczeni", "niwelowani", "nokautowani", "nominowani", "notowani", "nuceni", "numerowani", "nurtowani", "obaczeni", "obadani", "obalani", "obaleni", "obandażowani", "obarczani", "obarczeni", "obawiani", "obchodzeni", "obciążeni", "obcinani", "obcyndalani", "obczajani", "obczajeni", "obdarowani", "obdarzani", "obdarzeni", "obdzieleni", "obdzierani", "obdzwaniani", "obdzwonieni", "obejmowani", "oberwani", "obessani", "obezwładniani", "obezwładnieni", "obfotografowani", "obfotografowywani", "obgadani", "obgadywani", "obgryzani", "obgryzieni", "obiecani", "obiecywani", "obierani", "obijani", "objadani", "objaśniani", "objawiani", "objawieni", "objechani", "objeżdżani", "obkręcani", "oblani", "obłapiani", "obłapywani", "obłaskawiani", "obłaskawieni", "obleciani", "oblewani", "obliczani", "obliczeni", "oblizani", "obłowieni", "obłożeni", "obluzowani", "obluzowywani", "obmacani", "obmacywani", "obmawiani", "obmyślani", "obmyśleni", "obmywani", "obnażani", "obniżani", "obniżeni", "obnoszeni", "obowiązywani", "obozowani", "obrabiani", "obrabowani", "obracani", "obradowani", "obramowani", "obraniani", "obrani", "obrastani", "obrażani", "obrażeni", "obrobieni", "obróceni", "obrodzeni", "obronieni", "obrysowani", "obrywani", "obryzgani", "obrzezani", "obrzucani", "obrzuceni", "obrzygani", "obsadzani", "obsadzeni", "obściskiwani", "obserwowani", "obsiani", "obsikani", "obsikiwani", "obskakiwani", "obskoczeni", "obskubani", "obskubywani", "obśliniani", "obślinieni", "obsługiwani", "obsłużeni", "obsmarowani", "obstawiani", "obstawieni", "obstrzeliwani", "obsuwani", "obsypani", "obsypywani", "obszukani", "obszukiwani", "obtaczani", "obtoczeni", "obudzeni", "obwąchani", "obwąchiwani", "obwiązani", "obwiązywani", "obwieszani", "obwieszczani", "obwieszczeni", "obwieszeni", "obwijani", "obwiniani", "obwołani", "obżerani", "ocalani", "ocaleni", "ocechowani", "oceniani", "ocenieni", "ocenzurowani", "ochładzani", "ochlapani", "ochlapywani", "ochłodzeni", "ochraniani", "ochronieni", "ochrzaniani", "ochrzczeni", "ociągani", "ocieleni", "ocieplani", "ociepleni", "ocierani", "ocuceni", "oczarowywani", "oczekiwani", "oczerniani", "oczernieni", "oczyszczani", "oczyszczeni", "odbębnieni", "odbetonowani", "odbezpieczani", "odbezpieczeni", "odbijani", "odblokowani", "odbudowani", "odbudowywani", "odbutowani", "odcedzani", "odchorowani", "odchowani", "odchudzani", "odchudzeni", "odchylani", "odchyleni", "odciągani", "odciążeni", "odcierpieni", "odcinani", "odcumowani", "odcyfrowani", "odcyfrowywani", "odczarowani", "odczekani", "odczepiani", "odczepieni", "odczuwani", "odczynieni", "odczytani", "odczytywani", "oddalani", "oddani", "oddawani", "oddelegowani", "oddychani", "oddzielani", "oddzieleni", "odebrani", "odegnani", "odegrani", "odejmowani", "oderwani", "odeskortowani", "odesłani", "odespani", "odessani", "odetkani", "odezwani", "odfiltrowani", "odgadywani", "odganiani", "odgarniani", "odgniatani", "odgonieni", "odgradzani", "odgrażani", "odgrodzeni", "odgruzowani", "odgrywani", "odgryzani", "odgryzieni", "odgrzani", "odgrzebani", "odgrzebywani", "odgrzewani", "odgwizdani", "odhaczeni", "odholowani", "odinstalowani", "odizolowani", "odjedzeni", "odjonizowani", "odkażani", "odkażeni", "odkładani", "odklejeni", "odkochani", "odkodowani", "odkodowywani", "odkopani", "odkopywani", "odkorkowani", "odkręcani", "odkręceni", "odkrojeni", "odkrywani", "odkupieni", "odkupywani", "odkurzani", "odkurzeni", "odłączani", "odłączeni", "odłamywani", "odlani", "odlatywani", "odlepiani", "odlewani", "odliczani", "odliczeni", "odłożeni", "odłupani", "odmachani", "odmachiwani", "odmalowani", "odmarszczeni", "odmawiani", "odmeldowani", "odmieniani", "odmienieni", "odmierzani", "odmierzeni", "odmieszani", "odmontowani", "odmówieni", "odmrażani", "odmrożeni", "odnajdowani", "odnalezieni", "odnawiani", "odniesieni", "odnoszeni", "odnotowani", "odnotowywani", "odnowieni", "odpakowani", "odpakowywani", "odpalani", "odpaleni", "odpałzowani", "odparowani", "odpędzani", "odpicowani", "odpieczętowani", "odpierani", "odpiłowani", "odpiłowywani", "odpinani", "odpisani", "odpisywani", "odpłacani", "odplamieni", "odplątani", "odpowietrzeni", "odpracowani", "odpracowywani", "odprasowani", "odprawiani", "odprawieni", "odprężani", "odprostowani", "odprowadzani", "odprowadzeni", "odpryskani", "odpukani", "odpukiwani", "odpuszczani", "odpuszczeni", "odpychani", "odrąbani", "odrabiani", "odrąbywani", "odradzani", "odradzeni", "odrapani", "odrastani", "odratowani", "odreagowani", "odremontowani", "odrestaurowani", "odrestaurowywani", "odrobaczani", "odrobieni", "odroczeni", "odrodzeni", "odróżniani", "odróżnieni", "odrysowani", "odrywani", "odrzucani", "odrzuceni", "odsączani", "odsączeni", "odsadzeni", "odseparowani", "odsiadywani", "odsiani", "odsiewani", "odsłaniani", "odsłuchani", "odsłuchiwani", "odsłużeni", "odśnieżani", "odśnieżeni", "odsoleni", "odśpiewani", "odsprzedani", "odsprzedawani", "odstąpieni", "odstawiani", "odstawieni", "odstępowani", "odstraszani", "odstręczeni", "odstresowani", "odstrzeliwani", "odstrzeleni", "odsuwani", "odświeżani", "odświeżeni", "odsyłani", "odsypywani", "odsysani", "odszczekani", "odszczekiwani", "odsztafirowani", "odszukani", "odszyfrowani", "odszyfrowywani", "odszykowani", "odtrąbieni", "odtrąceni", "odtwarzani", "odtworzeni", "oduczeni", "odurzeni", "odwalani", "odwaleni", "odwiązani", "odwiązywani", "odwiedzani", "odwiedzeni", "odwieszeni", "odwiezieni", "odwijani", "odwlekani", "odwodnieni", "odwodzeni", "odwołani", "odwoływani", "odwożeni", "odwracani", "odwróceni", "odwzajemnieni", "odwzorowani", "odżegnani", "odziani", "odziedziczeni", "odznaczani", "odznaczeni", "odzwieciedleni", "odzwierciedlani", "odzwonieni", "odzwyczajeni", "odzyskani", "odzyskiwani", "odzywiani", "odżywieni", "oferowani", "ofiarowani", "ofiarowywani", "ogarniani", "oglądani", "ogłaszani", "ogłoszeni", "ogłupiani", "ogłupieni", "ogłuszeni", "ogołoceni", "ogoleni", "ograbiani", "ograbieni", "ograniczani", "ograniczni", "ograni", "ogrodzeni", "ogryzieni", "ogrzani", "ogrzewani", "okablowani", "okaleczeni", "okantowani", "okąpani", "okazani", "okazywani", "okiełznani", "okładani", "okłamani", "okłamywani", "oklaskiwani", "oklejeni", "oklepani", "okopani", "okopywani", "okpieni", "okradani", "okradzieni", "okraszeni", "okrążani", "okrążeni", "okręcani", "okręceni", "określani", "określeni", "okrojeni", "okrywani", "okulawieni", "okupieni", "okupowani", "olani", "olewani", "omamieni", "omawiani", "omdlewani", "omijani", "omotani", "omówieni", "onanizowani", "onieśmielani", "onieśmieleni", "opakowani", "opalani", "opaleni", "opancerzeni", "opanowani", "opanowywani", "oparzeni", "opasani", "opatentowani", "opatrywani", "opatrzeni", "opatuleni", "opędzani", "opędzeni", "operowani", "opętani", "opętywani", "opieczętowani", "opiekowani", "opierani", "opijani", "opisani", "opisywani", "opłacani", "opłaceni", "opłakani", "opłakiwani", "opłukani", "opluwani", "opływani", "opodatkowani", "opodatkowywani", "oponowani", "oporządzani", "oporządzeni", "opowiadani", "opowiedziani", "opóźniani", "opóźnieni", "opracowani", "opracowywani", "oprawiani", "oprawieni", "oprowadzani", "oprowadzeni", "opróżniani", "opróżnieni", "opryskani", "opryskiwani", "opublikowani", "opukani", "opuszczani", "opuszczeni", "opychani", "opyleni", "orani", "orbowani", "organizowani", "orientowani", "oroszeni", "orzekani", "osaczani", "osaczeni", "osadzani", "osądzani", "osadzeni", "osądzeni", "oscylowani", "osiadani", "osiągani", "osiedlani", "osiedleni", "osiedzeni", "osieroceni", "osiodłani", "oskalpowani", "oskarżeni", "oskrobani", "oskrzydlani", "oskrzydleni", "oskubani", "oskubywani", "osłabiani", "osłabieni", "oślepiani", "oślepieni", "ośliniani", "osłodzeni", "osłonieni", "osłuchani", "osmaleni", "ośmieleni", "ośmieszani", "ośmieszeni", "ostrzegani", "ostrzelani", "ostrzeni", "ostudzeni", "osuszani", "osuszeni", "osuwani", "oswajani", "oświadczani", "oświadczeni", "oświecani", "oświecieni", "oświetlani", "oświetleni", "oswobadzani", "oswobodzeni", "oswojeni", "oszacowani", "oszałamiani", "oszczani", "oszczędzani", "oszczędzeni", "oszkleni", "oszlifowani", "oszołomieni", "oszpeceni", "oszukani", "oszukiwani", "oszwabieni", "otaczani", "otoczeni", "otruwani", "otrząsani", "otrzepani", "otrzeźwieni", "otrzymani", "otrzymywani", "otuleni", "otumanieni", "otwierani", "otwarci", "owani", "owdowieni", "owiani", "owijani", "ozdabiani", "ozdobieni", "ozdrowieni", "ożenieni", "oznaczani", "oznaczeni", "oznajmiani", "oznajmieni", "oznakowani", "ożywani", "ożywiani", "ożywieni", "pakowani", "paktowani", "pałani", "pałaszowani", "paleni", "pamiętani", "panoszeni", "paprani", "parafrazowani", "paraliżowani", "parkowani", "parowani", "partaczeni", "parzeni", "pastowani", "paszeni", "patrolowani", "patroszeni", "pauzowani", "pchani", "pdholowani", "pedałowani", "pękani", "pełnieni", "penetrowani", "perforowani", "perfumowani", "perswadowani", "piastowani", "pichceni", "pielęgnowani", "pieleni", "pienieni", "pieszczeni", "piętnowani", "pijani", "pikietowani", "piknikowani", "pikowani", "pilnowani", "pilotowani", "piłowani", "pisani", "pisywani", "płaceni", "plądrowani", "planowani", "płaszczeni", "plątani", "płatani", "pławieni", "plewieni", "płoszeni", "plotkowani", "plugawieni", "płukani", "pluskani", "pobaraszkowani", "pobierani", "pobłażani", "pobłogosławieni", "pobrani", "pobrudzeni", "pobudzani", "pobudzeni", "pobujani", "pocałowani", "pocerowani", "pochłaniani", "pochlapani", "pochlebiani", "pochowani", "pochwalani", "pochwaleni", "pochwyceni", "pochylani", "pochyleni", "pociachani", "pociągani", "pocierani", "pocieszani", "pocieszeni", "poceni", "pocukrowani", "poćwiartowani", "poczesani", "poczęstowani", "poczochrani", "poczytani", "poczytywani", "podani", "podarowani", "podawani", "podążeni", "podbierani", "podbijani", "podbudowani", "podbudowywani", "podburzani", "podburzeni", "podchwyceni", "podciągani", "podcierani", "podcinani", "podczepieni", "poddani", "poddawani", "podebrani", "podejmowani", "podejrzani", "podejrzewani", "podelektowani", "podeptani", "poderwani", "podesłani", "podglądani", "podgoleni", "podgonieni", "podgryzani", "podgrzani", "podgrzewani", "podjadani", "podjedzeni", "podkablowani", "podkarmieni", "podkładani", "podklejeni", "podkolorowani", "podkołowani", "podkopani", "podkopywani", "podkradani", "podkręcani", "podkręceni", "podkreślani", "podkreśleni", "podkształceni", "podkuleni", "podkupieni", "podkurzeni", "podłączani", "podłączeni", "podładowani", "podłamani", "podlani", "podłapani", "podleczeni", "podlegani", "podlewani", "podliczani", "podliczeni", "podlizani", "podlizywani", "podłożeni", "podmalowani", "podmieniani", "podmienieni", "podmuchani", "podniecani", "podnieceni", "podniesieni", "podnoszeni", "podołani", "podopingowani", "podostrzeni", "podotykani", "podpalani", "podpaleni", "podpatrywani", "podpatrzeni", "podpieczętowani", "podpiekani", "podpierani", "podpiłowani", "podpinani", "podpisani", "podpisywani", "podpłaceni", "podpompowani", "podporządkowani", "podporządkowywani", "podpowiadani", "podpowiedziani", "podprowadzani", "podpuszczani", "podpuszczeni", "podpychani", "podpytani", "podrabiani", "podrapani", "podrasowani", "podratowani", "podrażnieni", "podręczeni", "podregulowani", "podreperowani", "podretuszowani", "podrobieni", "podroczeni", "podróżowani", "podrygiwani", "podrywani", "podrzucani", "podrzuceni", "podrzynani", "podsadzeni", "podskubywani", "podsłuchani", "podsłuchiwani", "podsmażani", "podsmażeni", "podśpiewywani", "podstawiani", "podstawieni", "podstemplowani", "podstrojeni", "podsumowani", "podsumowywani", "podsuwani", "podświetlani", "podsycani", "podsyceni", "podsyłani", "podsypani", "podszczypywani", "podszkoleni", "podszlifowani", "podszykowani", "podszywani", "podtapiani", "podtopieni", "podtrzymani", "podtrzymywani", "podtuczeni", "poduczani", "podupadani", "poduszeni", "podwajani", "podwalani", "podważani", "podwędzeni", "podwiązani", "podwieszani", "podwiezieni", "podwijani", "podwojeni", "podwożeni", "podwyżani", "podwyższani", "podwyższeni", "podyktowani", "podyskutowani", "podziabani", "podziałani", "podziałkowani", "podziękowani", "podzieleni", "podziurawieni", "podziwiani", "poeksperymentowani", "pofarbowani", "pofatygowani", "pofilmowani", "poganiani", "pogardzani", "pogardzeni", "pogarszani", "pogaszeni", "pogładzeni", "pogłaskani", "pogłębiani", "pogłębieni", "pogłośnieni", "pogmatwani", "pognębieni", "pogniecieni", "pogodzeni", "pogonieni", "pogorszeni", "pogotowani", "pograbieni", "pogrążani", "pogrążeni", "pogrożeni", "pogrubiani", "pogrubieni", "pogruchani", "pogruchotani", "pogrupowani", "pogrywani", "pogryzani", "pogryzieni", "pogrzani", "pogrzebani", "pogubieni", "pogwałcani", "pohamowani", "pohandlowani", "poharatowani", "pohuśtani", "poinformowani", "poinstruowani", "pojednani", "pojmowani", "pojeni", "pokajani", "pokaleczeni", "pokarani", "pokarmieni", "pokąsani", "pokatalogowani", "pokazani", "pokazywani", "pokiereszowani", "pokierowani", "pokiwani", "pokładani", "poklepani", "poklepywani", "pokłonieni", "pokochani", "pokolorowani", "pokoloryzowani", "pokołysani", "pokombinowani", "pokomplikowani", "pokonani", "pokończeni", "pokonywani", "pokopani", "pokrajani", "pokrążeni", "pokręceni", "pokrojeni", "pokruszeni", "pokrywani", "pokrzepiani", "pokrzepieni", "pokrzyżowani", "pokuszeni", "pokutowani", "połączeni", "polakierowani", "połamani", "polani", "połapani", "połaskotani", "połatani", "polecani", "połechtani", "poleceni", "poleczeni", "polegani", "polemizowani", "polepszani", "polepszeni", "polerowani", "polewani", "policzkowani", "policzeni", "polimeryzowani", "polizani", "polowani", "połowieni", "położeni", "polubieni", "poluźnieni", "poluzowani", "połykani", "pomacani", "pomachani", "pomagani", "pomalowani", "pomarynowani", "pomasowani", "pomazani", "pomęczeni", "pomiatani", "pomieszani", "pomieszczeni", "pomijani", "pomiziani", "pomnażani", "pomniejszani", "pomniejszeni", "pomnożeni", "pomoczeni", "pompowani", "pomydleni", "pomyleni", "pomyszkowani", "pomywani", "ponabijani", "ponaciskani", "ponadziewani", "ponaglani", "ponagleni", "ponagrywani", "ponaklejani", "ponakłuwani", "ponakrywani", "ponaprawiani", "ponawiani", "poniańczeni", "poniechani", "ponieiwerani", "poniesieni", "poniszczeni", "poniżani", "poniżeni", "ponoszeni", "ponowieni", "ponudzeni", "poobcinani", "poobcowani", "poobczajani", "poobijani", "poobmacywani", "poobracani", "poobserwowani", "poodbijani", "poodcinani", "poodgryzani", "poodkurzani", "poodprawiani", "poodsuwani", "poodwalani", "pooglądani", "poograniczani", "poopalani", "poopiekani", "poopwiadani", "pootwierani", "popadani", "popakowani", "popaleni", "poparzeni", "popchani", "popędzani", "popędzeni", "popękani", "popełniani", "popełnieni", "poperfumowani", "popierani", "popieszczeni", "popijani", "popilnowani", "popisani", "popłaceni", "popłakiwani", "poplamieni", "poplątani", "popluskani", "popodcinani", "popodziwiani", "popoprawiani", "poprani", "poprasowani", "poprawiani", "poprawieni", "poproszeni", "poprowadzeni", "popryskani", "poprzebierani", "poprzeciągani", "poprzecinani", "poprzedzani", "poprzeglądani", "poprzeklinani", "poprzekopywani", "poprzemieszczani", "poprzenoszeni", "poprzesadzani", "poprześladowani", "poprzestawiani", "poprzesuwani", "poprzewieszani", "poprzewracani", "poprzycinani", "poprzymierzani", "poprzytulani", "poprzywiązywani", "popudrowani", "popukani", "popularyzowani", "popuszczani", "popuszczeni", "popychani", "popykani", "popytani", "porabiani", "porachowani", "poranieni", "poratowani", "porażeni", "poręczeni", "porównani", "porozbierani", "porozbijani", "porozciągani", "porozcinani", "porozdawani", "porozdzielani", "porozmieszczani", "poróżnieni", "porozpędzani", "porozpieszczani", "porozprowadzani", "porozpruwani", "porozrzucani", "porozstawiani", "porozsyłani", "porozumiewani", "porozwalani", "porozwiązywani", "porozwieszani", "porozwożeni", "portretowani", "poruszani", "poruszeni", "porwani", "porysowani", "porywani", "porządkowani", "porządzeni", "porzucani", "porzuceni", "posądzani", "posadzeni", "posądzeni", "pościągani", "pościeleni", "pościerani", "pościgani", "pościnani", "pościskani", "posegregowani", "posiadani", "posiani", "posiekani", "posilani", "posiłkowani", "posileni", "posiłowani", "posiniaczeni", "posiorbani", "poskąpieni", "poskładani", "posklejani", "poskramiani", "poskręcani", "poskrobani", "poskromieni", "poskubani", "posłani", "posłodzeni", "poślubiani", "poślubieni", "posługiwani", "posmakowani", "posmarowani", "posoleni", "posortowani", "pospekulowani", "pospieszani", "pośpieszani", "pośpiewani", "pospinani", "pospłacani", "posprawdzani", "posprzątani", "posprzedawani", "pośredniczeni", "possani", "postanowieni", "postani", "postarani", "postawieni", "postemplowani", "posterowani", "postradani", "postraszeni", "postrugani", "postrzegani", "postrzelani", "postrzeleni", "postukani", "postymulowani", "posuwani", "poświącani", "poświadczeni", "poświeceni", "poświęceni", "poświętowani", "poświntuszeni", "posyłani", "posypani", "posypywani", "poszarpani", "poszastani", "poszatkowani", "poszczyceni", "poszczypani", "poszerzani", "poszerzeni", "poszorowani", "poszpiegowani", "poszturchani", "poszukani", "poszukiwani", "poszwędani", "poszybowani", "potakiwani", "potarmoszeni", "potasowani", "potęgowani", "potępiani", "potępieni", "potoczeni", "potopieni", "potorturowani", "potrącani", "potrąceni", "potraktowani", "potrojeni", "potrząsani", "potrzaskani", "potrzymani", "Poturbowani", "poturlani", "potwierdzeni", "potykani", "poucinani", "pouczani", "pouczeni", "poudawani", "poukładani", "pouprawiani", "poupychani", "pourywani", "poustawiani", "poużywani", "powąchani", "powachlowani", "powalani", "powaleni", "poważani", "powbijani", "powciągani", "powciskani", "powdychani", "powęszeni", "powetowani", "powiadamiani", "powiadomieni", "powiązani", "powiedziani", "powiedzeni", "powiększani", "powielani", "powieleni", "powierzani", "powierzeni", "powieszeni", "powiewani", "powinszowani", "powitani", "powkładani", "powlekani", "powłóczeni", "powodowani", "powołani", "powoływani", "powożeni", "powpychani", "powróceni", "powrzucani", "powsadzani", "powspominani", "powstrzymani", "powtarzani", "powtórzeni", "powybierani", "powybijani", "powycierani", "powycinani", "powyciskani", "powydawani", "powyganiani", "powyginani", "powyjaśniani", "powyjmowani", "powyłączani", "powymiatani", "powymieniani", "powynoszeni", "powypełniani", "powypisywani", "powyrywani", "powyrzucani", "powystrzelani", "powysyłani", "powywalani", "powywieszani", "powywracani", "pozabawiani", "pozabijani", "pozacierani", "pożądani", "pożądleni", "pozadzierani", "pozakładani", "pozaklinani", "pozałatwiani", "pozamiatani", "pozamieniani", "pozamrażani", "pozamykani", "pozapalani", "pozapinani", "pozapisywani", "pozapraszani", "pozasłaniani", "pozastrzelani", "pozatykani", "pozbawiani", "pozbawieni", "pozbierani", "pozbywani", "pozdejmowani", "pozdrawiani", "pozdrowieni", "pożegnani", "pożerani", "pozmiatani", "pozmieniani", "pozmywani", "poznaczeni", "poznani", "poznawani", "poznęcani", "pozorowani", "pozostawiani", "pozostawieni", "pozowani", "pozrywani", "pozszywani", "pozwalniani", "pozwani", "pozwiązywani", "pozwiedzani", "pozwoleni", "pożyczani", "pożyczeni", "pozyskani", "pozywani", "pożywiani", "pożywieni", "praktykowani", "prani", "prasowani", "prawieni", "prażeni", "precyzowani", "preferowani", "prenumerowani", "prezentowani", "próbowani", "procesowani", "produkowani", "profanowani", "profilowani", "prognozowani", "programowani", "projektowani", "proklamowani", "prolongowani", "promieniowani", "promowani", "propagowani", "proponowani", "prosperowani", "prostowani", "proszkowani", "proszeni", "protestowani", "protokołowani", "prowadzeni", "prowokowani", "pryskani", "przeanalizowani", "przearanżowani", "przebaczani", "przebaczeni", "przebadani", "przebierani", "przebijani", "przeboleni", "przebrani", "przebudowani", "przebudowywani", "przebudzani", "przebudzeni", "przebukowani", "przebywani", "przeceniani", "przecenieni", "przechlapani", "przechodzeni", "przechowani", "przechowywani", "przechrzceni", "przechwyceni", "przechwytywani", "przechylani", "przechyleni", "przechytrzani", "przechytrzeni", "przeciągani", "przeciążani", "przeciążeni", "przeciekani", "przecierani", "przecierpiani", "przecinani", "przeciskani", "przeciwstawiani", "przećwiczeni", "przeczekani", "przeczesani", "przeczesywani", "przeczołgani", "przeczuwani", "przeczyszczeni", "przeczytani", "przedawkowani", "przedawkowywani", "przedekorowani", "przedłożeni", "przedłużani", "przedłużeni", "przedmuchani", "przedobrzeni", "przedostani", "przedostawani", "przedstawiani", "przedstawieni", "przedymani", "przedyskutowani", "przedzierani", "przedziurawieni", "przedziurkowani", "przeegzaminowani", "przefaksowani", "przefarbowani", "przefasonowani", "przefasowani", "przefaxowani", "przefiltrowani", "przeformowani", "przeforsowani", "przegadani", "przeganani", "przeganiani", "przegapiani", "przegapieni", "przeginani", "przeglądani", "przegłodzeni", "przegłosowani", "przegonieni", "przegotowani", "przegotowywani", "przegrabieni", "przegradzani", "przegrani", "przegrupowani", "przegrupowywani", "przegrywani", "przegryzani", "przegryzieni", "przegrzani", "przegrzebani", "przegrzewani", "przehandlowani", "przeholowani", "przeinstalowani", "przeistoczeni", "przejadani", "przejaskrawiani", "przejaśnieni", "przejawiani", "przejawieni", "przejechani", "przejeżdżani", "przejmowani", "przejrzani", "przekabacani", "przekabaceni", "przekablowani", "przekalibrowani", "przekalkulowani", "przekarmiani", "przekąszeni", "przekazywani", "przekierowani", "przekierowywani", "przekimani", "przekładani", "przeklejeni", "przeklinani", "przekonani", "przekonfigurowani", "przekonstruowani", "przekonwertowani", "przekonywani", "przekopani", "przekopywani", "przekoziołkowani", "przekraczani", "przekręcani", "przekręceni", "przekreślani", "przekreśleni", "przekroczeni", "przekrojeni", "przekrzyczeni", "przekrzywieni", "przekształcani", "przekształceni", "przekupieni", "przekupywani", "przekwalifikowani", "przełączani", "przełączeni", "przeładowani", "przeładowywani", "przełamani", "przełamywani", "przelani", "przelatywani", "przeleciani", "przelewani", "przeleżani", "przelicytowani", "przeliczani", "przeliczeni", "przeliterowani", "przełożeni", "przełykani", "przemalowani", "przemalowywani", "przemaszerowani", "przemawiani", "przemeblowani", "przemęczeni", "przemieleni", "przemieniani", "przemierzeni", "przemieszczani", "przemieszczeni", "przemijani", "przemilczani", "przemilczeni", "przemodelowani", "przemusztrowani", "przemycani", "przemyceni", "przemyślani", "przemyśleni", "przemywani", "przenegocjowani", "przeniesieni", "przenikani", "przenoszeni", "przeobrażani", "przeobrażeni", "przeoczani", "przeoczeni", "przeorani", "przeorganizowani", "przeorientowani", "przepadani", "przepakowani", "przepaleni", "przeparkowani", "przepchani", "przepędzani", "przepędzeni", "przepełniani", "przepełnieni", "przepijani", "przepiłowani", "przepisani", "przepisywani", "przepłacani", "przepłaceni", "przepłakani", "przeplanowani", "przepłoszeni", "przepłukani", "przepłukiwani", "przepływani", "przepompowani", "przepompowywani", "przepowiadani", "przepowiedziani", "przepracowani", "przepracowywani", "przeprani", "przeprawiani", "przeprawieni", "przeprogramowani", "przeprojektowani", "przeprowadzani", "przeprowadzeni", "przepuszczani", "przepuszczeni", "przepychani", "przepytani", "przepytywani", "przerąbani", "przerabiani", "przeradzani", "przerastani", "przerażeni", "przeredagowani", "przerejestrowani", "przerobieni", "przerodzeni", "przerwani", "przerysowani", "przerywani", "przerzedzani", "przerzucani", "przerzuceni", "przesączeni", "przesadzani", "przesądzani", "przesadzeni", "przesądzeni", "prześcigani", "przesiadani", "przesiadywani", "przesiani", "przesiedlani", "przesiedleni", "przesiedziani", "przesiewani", "przesileni", "przeskakiwani", "przeskalowani", "przeskanowani", "przeskoczeni", "przeskrobani", "prześladowani", "przesłaniani", "przesłani", "prześledzeni", "przesłodzeni", "przesłuchani", "przesłuchiwani", "przesmarowani", "przesoleni", "przesortowani", "przespani", "prześpiewani", "przessani", "przestawiani", "przestawieni", "przestemplowani", "przestraszeni", "przestrojeni", "przestrzegani", "przestrzeleni", "przestudiowani", "przesuwani", "prześwietlani", "prześwietleni", "przesyłani", "przesypani", "przesypiani", "przesypywani", "przeszarżowani", "przeszczepiani", "przeszczepieni", "przeszkadzani", "przeszkoleni", "przeszmuglowani", "przeszukani", "przeszukiwani", "przeszywani", "przetaczani", "przetapetowani", "przetestowani", "przetkani", "przetoczeni", "przetopieni", "przetrąceni", "przetransformowani", "przetransmitowani", "przetransponowani", "przetransportowani", "przetrawieni", "przetrwani", "przetrząsani", "przetrzepani", "przetrzymani", "przetrzymywani", "przetwarzani", "przetworzeni", "przewalani", "przewalczeni", "przewaletowani", "przewaleni", "przeważani", "przeważeni", "przewertowani", "przewiązani", "przewiązywani", "przewidywani", "przewidziani", "przewiercani", "przewierceni", "przewieszani", "przewieszeni", "przewietrzeni", "przewiezieni", "przewijani", "przewitani", "przewodniczeni", "przewodzeni", "przewożeni", "przewracani", "przewróceni", "przewyższani", "przeymierzani", "przeżeglowani", "przeżegnani", "przeziębieni", "przezimowani", "przeznaczani", "przeznaczeni", "przezwyciężani", "przezwyciężeni", "przezywani", "przeżywani", "przodowani", "przpochlebieni", "przwdziewani", "przybastowani", "przybierani", "przybijani", "przybliżani", "przybliżeni", "przybrani", "przycelowani", "przycepieni", "przychyleni", "przyciągani", "przyciemnieni", "przycinani", "przyciskani", "przyciszeni", "przyćmiewani", "przyćmieni", "przycumowani", "przyczepiani", "przyczesani", "przyczołgani", "przyczynieni", "przydeptani", "przyduszeni", "przydzielani", "przydzieleni", "przygaszeni", "przygazowani", "przygładzani", "przygnębiani", "przygniatani", "przygniecieni", "przygotowani", "przygruchani", "przygrywani", "przygryzani", "przygryzieni", "przygrzani", "przygwożdżeni", "przyhamowani", "przyholowani", "przyjani", "przyjmowani", "przyjrzani", "przykładani", "przyklejeni", "przyklepani", "przykopani", "przykręcani", "przykręceni", "przykróceni", "przykrywani", "przykurzeni", "przykuwani", "przyłączani", "przyłączeni", "przylani", "przyłapani", "przylegani", "przylepiani", "przylepieni", "przyłożeni", "przymierzeni", "przymilani", "przymocowani", "przymuszani", "przynależeni", "przyniesieni", "przynoszeni", "przynudzani", "przyostrzeni", "przyozdabiani", "przyozdobieni", "przypakowani", "przypakowywani", "przypalani", "przypaleni", "przypasowani", "przypatrywani", "przypatrzeni", "przypieczętowani", "przypiekani", "przypierani", "przypilnowani", "przypiłowani", "przypinani", "przypisani", "przypisywani", "przypłaceni", "przyplątani", "przypodobani", "przypominani", "przypomniani", "przyporządkowani", "przyprawiani", "przyprawieni", "przyprowadzeni", "przypucowani", "przypudrowani", "przypuszczani", "przypuszczeni", "przyrównani", "przyrządzani", "przyrządzeni", "przysiadani", "przyskrzydleni", "przyskrzyniani", "przyskrzynieni", "przysłaniani", "przysłani", "przysłodzeni", "przysłonieni", "przysłuchiwani", "przysługiwani", "przysłużeni", "przysmażani", "przysmażeni", "przyspieszani", "przyspieszeni", "przysporzeni", "przysposobieni", "przyśrubowywani", "przyssani", "przystąpieni", "przystawiani", "przystawieni", "przystemplowani", "przystopowani", "przystosowani", "przystrojeni", "przysuwani", "przyswajani", "przyświecani", "przyświęceni", "przyswojeni", "przysyłani", "przysypani", "przyszpileni", "przyszykowani", "przyszywani", "przytaczani", "przytargani", "przytaszczani", "przytępiani", "przytępieni", "przytkani", "przytłaczani", "przytłoczeni", "przytłumieni", "przytoczeni", "przytrafieni", "przytroczeni", "przytruwani", "przytrzymani", "przytrzymywani", "przytulani", "przytuleni", "przytwierdzani", "przytwierdzeni", "przytykani", "przyuczeni", "przyuważeni", "przywabieni", "przywalani", "przywaleni", "przywarowani", "przywdziani", "przywiązani", "przywiązywani", "przywidziani", "przywiezieni", "przywitani", "przywłaszczani", "przywłaszczeni", "przywołani", "przywoływani", "przywożeni", "przywracani", "przywróceni", "przyznaczeni", "przyznani", "przyznawani", "przyzwalani", "przyzwani", "przyzwyczajani", "przyzwyczajeni", "przyzywani", "psiamani", "pstrykani", "publikowani", "pucowani", "pudłowani", "pudrowani", "punktowani", "pustoszeni", "puszczani", "puszczeni", "puszkowani", "puszeni", "pykani", "pytani", "rabowani", "rachowani", "racjonalizowani", "racjonowani", "raczeni", "radowani", "ranieni", "raportowani", "ratowani", "ratyfikowani", "reaktywowani", "realizowani", "reanimowani", "recytowani", "ręczeni", "redagowani", "redukowani", "reformowani", "refowani", "regenerowani", "regionalizowani", "regulowani", "reinkarnowani", "rejestrowani", "reklamowani", "rekomendowani", "rekompensowani", "rekonstruowani", "rekreowani", "rekrutowani", "rekwirowani", "relacjonowani", "relaksowani", "remodulowani", "remontowani", "renegocjowani", "reorganizowani", "reperowani", "replikowani", "represejonowani", "reprezentowani", "reprodukowani", "resetowani", "resocjalizowani", "respektowani", "resuscytowani", "retuszowani", "rewanżowani", "rewidowani", "rezerwowani", "rezonowani", "rezygnowani", "reżyserowani", "robieni", "rodzeni", "rojeni", "rolowani", "romansowani", "ronieni", "rozbawiani", "rozbawieni", "rozbierani", "rozbijani", "rozbrajani", "rozbrojeni", "rozbudowani", "rozbudowywani", "rozbudzani", "rozbudzeni", "rozbujani", "rozcapierzeni", "rozchmurzeni", "rozchodzeni", "rozchylani", "rozchyleni", "rozciągani", "rozcieńczani", "rozcieńczeni", "rozcierani", "rozcinani", "rozczarowani", "rozczarowywani", "rozczesani", "rozczłonkowani", "rozczulani", "rozczytani", "rozdani", "rozdawani", "rozdeptani", "rozdmuchani", "rozdmuchiwani", "rozdrabniani", "rozdrapani", "rozdrapywani", "rozdrażniani", "rozdrażnieni", "rozduszeni", "rozdwojeni", "rozdysponowani", "rozdzielani", "rozdzieleni", "rozdzierani", "rozdziewiczeni", "rozebrani", "rozedrani", "rozegrani", "rozegrywani", "rozepchani", "rozerwani", "rozesłani", "rozgaszczani", "rozglaszani", "rozgłoszeni", "rozgniatani", "rozgniecieni", "rozgniewani", "rozgonieni", "rozgraniczeni", "rozgrani", "rozgromieni", "rozgrywani", "rozgryzani", "rozgryzieni", "rozgrzani", "rozgrzebywani", "rozgrzeszeni", "rozgrzewani", "rozhuśtani", "rozjaśniani", "rozjaśnieni", "rozjechani", "rozjedzeni", "rozjuszani", "rozjuszeni", "rozkazani", "rozkazywani", "rozkładani", "rozklejani", "rozklejeni", "rozkołysani", "rozkopani", "rozkopywani", "rozkoszowani", "rozkręcani", "rozkręceni", "rozkrojeni", "rozkruszeni", "rozkuwani", "rozkwaszeni", "rozkwaterowani", "rozkwitani", "rozłączeni", "rozładowani", "rozładowywani", "rozłamani", "rozlani", "rozlewani", "rozliczani", "rozliczeni", "rozlokowani", "rozłożeni", "rozłupani", "rozluźniani", "rozmanażani", "rozmasowani", "rozmawiani", "rozmazani", "rozmazywani", "rozmiękczeni", "rozmieniani", "rozmienieni", "rozmieszczani", "rozmieszczeni", "rozmnożeni", "rozmontowani", "rozmówieni", "rozmrażani", "rozmrożeni", "rozmyślani", "różnicowani", "rozniecani", "rozniecieni", "rozniesieni", "różnieni", "roznoszeni", "rozochoceni", "rozpaczani", "rozpakowani", "rozpakowywani", "rozpalani", "rozpaleni", "rozpamiętywani", "rozpaskudzani", "rozpatrywani", "rozpatrzeni", "rozpędzani", "rozpędzeni", "rozpętani", "rozpieszczani", "rozpieszczeni", "rozpiłowani", "rozpinani", "rozpisani", "rozpisywani", "rozplanowani", "rozpłaszczani", "rozpłaszczeni", "rozplątani", "rozplątywani", "rozpoczynani", "rozpogodzeni", "rozporządzani", "rozporządzeni", "rozpościerani", "rozpostrzeni", "rozpowiadani", "rozpowiedziani", "rozpowszechniani", "rozpowszechnieni", "rozpoznani", "rozpoznawani", "rozpracowani", "rozpraszani", "rozprawiani", "rozprawiczeni", "rozprawieni", "rozprostowani", "rozproszeni", "rozprowadzani", "rozprowadzeni", "rozpruwani", "rozprzestrzeniani", "rozprzestrzenieni", "rozpuszczani", "rozpuszczeni", "rozpychani", "rozpylani", "rozpyleni", "rozpytani", "rozpytywani", "rozrastani", "rozreklamowani", "rozrobieni", "rozróżniani", "rozróżnieni", "rozruszani", "rozrysowani", "rozrywani", "rozrzucani", "rozsadzani", "rozsadzeni", "rozsądzeni", "rozścieleni", "rozsiani", "rozsiekani", "rozsiewani", "rozsiodłani", "rozsławiani", "rozsławieni", "rozsmarowani", "rozsmarowywani", "rozśmieszani", "rozstani", "rozstąpieni", "rozstawani", "rozstawiani", "rozstawieni", "rozstrojeni", "rozstrząsani", "rozstrzeliwani", "rozstrzeleni", "rozstrzygani", "rozsupłani", "rozświetlani", "rozświetleni", "rozsyłani", "rozsypani", "rozsypywani", "rozszarpani", "rozszarpywani", "rozszczepiani", "rozszczepieni", "rozszerzani", "rozszerzeni", "rozszyfrowani", "roztaczani", "roztapiani", "roztoczeni", "roztopieni", "roztrwonieni", "roztrząsani", "roztrzaskani", "rozumiani", "rozumowani", "rozwalani", "rozwaleni", "rozważani", "rozważeni", "rozweselani", "rozweseleni", "rozwiani", "rozwiązani", "rozwiązywani", "rozwidniani", "rozwiedzieni", "rozwierani", "rozwierceni", "rozwieszani", "rozwieszeni", "rozwiewani", "rozwiezieni", "rozwikłani", "rozwlekani", "rozwodzeni", "rozwścieczani", "rozwścieczeni", "rozzłoszczeni", "rugani", "ruinowani", "rujnowani", "ruszani", "ruszeni", "rwani", "ryczani", "ryglowani", "rymowani", "rysowani", "ryzykowani", "rządzeni", "rzeźbieni", "rzucani", "rzuceni", "rzygani", "sabotażowani", "sączeni", "sadzani", "sadzeni", "sądzeni", "salutowani", "salwowani", "sankcjonowani", "satysfakcjonowani", "scaleni", "scementowani", "scentrowani", "scharakteryzowani", "schładzani", "schlani", "schlapani", "schlebieni", "schłodzeni", "schowani", "schronieni", "schrupani", "schrzanieni", "schwytani", "schylani", "ścieleni", "ściemniani", "ściemnieni", "ścierani", "ścierpieni", "ścigani", "ścinani", "ściskani", "ściszani", "ściszeni", "sędziowani", "segregowani", "selekcjonowani", "separowani", "sępieni", "serwowani", "sfabrykowani", "sfajczeni", "sfałszowani", "sfaulowani", "sfilmowani", "sfinalizowani", "sfinansowani", "sfingowani", "sformalizowani", "sformatowani", "sformowani", "sformułowani", "sforsowani", "sfotografowani", "shimmerowani", "siani", "siekani", "siorbani", "skadrowani", "skakani", "skalani", "skaleczeni", "skalibrowani", "skalkulowani", "skalpowani", "skanalizowani", "skandowani", "skanowani", "skapitulowani", "skarceni", "skarżeni", "skasowani", "skatalogowani", "skazani", "skażeni", "skazywani", "skierowani", "składani", "składowani", "skłaniani", "sklasyfikowani", "sklecieni", "sklejani", "sklejeni", "sklepani", "skłóceni", "skłonieni", "sklonowani", "sknoceni", "skojarzeni", "skolonizowani", "skołowani", "skombinowani", "skomentowani", "skompensowani", "skompletowani", "skomplikowani", "skomponowani", "skompresowani", "skompromitowani", "skomunikowani", "skonani", "skoncentrowani", "skończeni", "skondensowani", "skonfigurowani", "skonfiskowani", "skonfrontowani", "skonkretyzowani", "skonsolidowani", "skonstruowani", "skonsultowani", "skonsumowani", "skontaktowani", "skontrolowani", "skoordynowani", "skopani", "skopiowani", "skorektowani", "skorumpowani", "skorygowani", "skorzystani", "skoszeni", "skracani", "skradzieni", "skręcani", "skręceni", "skremowani", "skreślani", "skreśleni", "skrobani", "skróceni", "skrojeni", "skropieni", "skruszeni", "skrystalizowani", "skrytykowani", "skrywani", "skrzecowani", "skrzyczani", "skrzywdzeni", "skrzyżowani", "skserowani", "skubani", "skuleni", "skumulowani", "skupiani", "skupieni", "skupowani", "skurczeni", "skuszeni", "skuwani", "skwitowani", "słani", "sławieni", "śledzeni", "ślinieni", "ślizgani", "słodzeni", "słuchani", "słyszani", "smagani", "smarowani", "smażeni", "śmieceni", "smyrani", "sondowani", "sortowani", "spafycikowani", "spakowani", "spalani", "spałaszowani", "spaleni", "spałowani", "spamiętani", "spaprani", "sparafrazowani", "sparaliżowani", "sparowani", "spartaczeni", "spartoleni", "sparzeni", "spasowani", "spatałaszeni", "spauzowani", "spawani", "spawieni", "specjalizowani", "spędzani", "spędzeni", "spekulowani", "spełniani", "spełnieni", "spenetrowani", "spętani", "spierani", "śpiewani", "spiłowani", "spinani", "spisani", "spiskowani", "spisywani", "spłacani", "spłaceni", "splądrowani", "splajtowani", "splamieni", "spłaszczeni", "splatani", "splątani", "spłatani", "spławiani", "spławieni", "spłodzeni", "spłoszeni", "spłukani", "spłukiwani", "spluwani", "spływani", "spoczywani", "spodziewani", "spojeni", "spolaryzowani", "spoliczkowani", "sponiewierani", "sponsorowani", "spopielani", "spopieleni", "spopularyzowani", "sportretowani", "sporządzani", "sporządzeni", "spostrzegani", "spotęgowani", "spotkani", "spotykani", "spoufalani", "spowalniani", "spowiadani", "spowodowani", "spowolnieni", "spoźnieni", "spóźnieni", "spożytkowani", "spożywani", "sprani", "sprasowani", "spraszani", "sprawdzeni", "sprawieni", "sprawowani", "sprecyzowani", "spreparowani", "sprężani", "sprężeni", "spróbowani", "sprofanowani", "sprofilowani", "sprostowani", "sproszkowani", "sproszeni", "sprowadzani", "sprowadzeni", "sprowokowani", "spryskani", "spryskiwani", "sprywatyzowani", "sprzątani", "sprzeczani", "sprzedani", "sprzedawani", "sprzeniewierzeni", "spudłowani", "spustoszeni", "spuszczani", "spuszczeni", "spychani", "ssani", "stabilizowani", "stacjonowani", "staczani", "staranowani", "starczani", "stargowani", "startowani", "stawiani", "stawieni", "stemplowani", "stenografowani", "stepowani", "sterowani", "sterroryzowani", "sterylizowani", "stłamszeni", "stłumieni", "stoczeni", "stołowani", "stonowani", "stopieni", "stopniowani", "storpedowani", "stosowani", "strącani", "straceni", "strąceni", "strajkowani", "straszeni", "stratowani", "strawieni", "streamowani", "stresowani", "streszczani", "streszczeni", "strofowani", "strojeni", "stroszeni", "strugani", "strymowani", "strząsani", "strzaskani", "strzeleni", "strzepani", "strzępieni", "strzepywani", "studiowani", "studzeni", "stukani", "stuleni", "stwardnieni", "stwarzani", "stwierdzani", "stwierdzeni", "stworzeni", "stykani", "stylizowani", "stymulowani", "sugerowani", "sumowani", "swatani", "swawoleni", "świadczeni", "świeceni", "święceni", "świerzbieni", "świętowani", "świntuszeni", "syceni", "sygnalizowani", "symulowani", "synchronizowani", "sypani", "szachrowani", "szacowani", "szafowani", "szamotani", "szanowani", "szargani", "szarpani", "szarżowani", "szasowani", "szastani", "szatkowani", "szczędzeni", "szczepieni", "szczerzeni", "szczyceni", "szczypani", "szczytowani", "szefowani", "szemrani", "szeptani", "szerzeni", "szkalowani", "szkicowani", "szkleni", "szkodzeni", "szkoleni", "szlachtowani", "szlifowani", "szmuglowani", "szokowani", "szorowani", "szpachlowani", "szpanowani", "szperani", "szprycowani", "szturchani", "szturmowani", "szufladkowani", "szuflowani", "szukani", "szulerowani", "szwankowani", "szydełkowani", "szydzeni", "szyfrowani", "szykanowani", "szykowani", "taktowani", "tamowani", "tankowani", "tapetowani", "taplani", "taranowani", "targani", "targowani", "tarmoszeni", "tarzani", "tasowani", "taszczeni", "tatuowani", "telefonowani", "telegrfowani", "teleportowani", "temperowani", "teoretyzowani", "tępieni", "terroryzowani", "testowani", "tkani", "tłamszeni", "tłoczeni", "tłumaczeni", "tłumieni", "toczeni", "tolerowani", "tonowani", "topieni", "torowani", "torturowani", "towarzyszeni", "trąbieni", "trącani", "traceni", "trąceni", "trafiani", "trafieni", "tragizowani", "traktowani", "transferowani", "transformowani", "transmitowani", "transportowani", "tratowani", "trawieni", "trenowani", "tresowani", "triumfowani", "tropieni", "troszczeni", "trwonieni", "trymowani", "tryskani", "tryumfowani", "trywializowani", "trzaskani", "trzepani", "trzepotani", "trzęsieni", "trzymani", "tuczeni", "tułani", "tuleni", "turlani", "tuszowani", "twistowani", "tworzeni", "tykani", "tyranizowani", "tyrani", "tytułowani", "uaktualniani", "uaktualnieni", "uaktywniani", "uaktywnieni", "uargumentowani", "uatrakcyjnieni", "ubabrani", "ubarwiani", "ubarwieni", "ubawieni", "ubezpieczani", "ubezpieczeni", "ubezwłasnowolnieni", "ubiczowani", "ubiegani", "ubierani", "ubijani", "ubłagani", "ubliżani", "ubliżeni", "ubolewani", "ubóstwiani", "ubrani", "ubroczeni", "ubrudzeni", "ucałowani", "ucharakteryzowani", "uchowani", "uchronieni", "uchwalani", "uchwaleni", "uchwyceni", "uchylani", "uchyleni", "ucieleśniani", "ucierani", "ucierpiani", "ucinani", "uciskani", "uciszani", "uciszeni", "uciułani", "ucywilizowani", "uczczeni", "uczepieni", "uczesani", "uczęszczani", "uczeni", "ucztowani", "uczynieni", "udani", "udaremnieni", "udawani", "udekorowani", "udeptywani", "uderzani", "uderzeni", "udobruchani", "udokumentowani", "udomawiani", "udomowieni", "udoskonalani", "udoskonaleni", "udostępniani", "udostępnieni", "udowadniani", "udowodnieni", "Udramatyzowani", "udręczeni", "udrożnieni", "udupieni", "uduszeni", "udzielani", "udzieleni", "ueiwarygodnieni", "ufani", "ufarbowani", "uformowani", "ufortyfikowani", "ufundowani", "ugadani", "uganiani", "ugaszani", "ugaszeni", "uginani", "ugłaskani", "ugniatani", "ugodzeni", "ugoszczeni", "ugotowani", "ugrani", "ugruntowani", "ugryzieni", "uhistoryzowani", "uhonorowani", "ujadani", "ujarzmiani", "ujarzmieni", "ujawniani", "ujawnieni", "ujeżdżani", "ujeżdżeni", "ujmowani", "ujrzani", "ukamieniowani", "ukarani", "ukartowani", "ukąszeni", "ukatrupieni", "ukazani", "ukazywani", "ukierowani", "ukierunkowani", "układani", "uklepani", "ukłonieni", "ukojeni", "ukołysani", "ukończeni", "ukonkretnieni", "ukoronowani", "ukradzieni", "ukręcani", "ukręceni", "ukrojeni", "ukrywani", "ukrzyżowani", "ukształtowani", "ułagodzeni", "ułaskawiani", "ułaskawieni", "ulatniani", "ułatwiani", "ułatwieni", "uleczani", "uleczeni", "ulegani", "ulepieni", "ulepszani", "ulepszeni", "ulokowani", "ulotnieni", "ułożeni", "umacniani", "umalowani", "umartwiani", "umawiani", "umazani", "umeblowani", "umiejscowieni", "umieszczani", "umieszczeni", "umilani", "umileni", "umniejszani", "umniejszeni", "umocnieni", "umocowani", "umoczeni", "umodelowani", "umorzeni", "umotywowani", "umówieni", "umożliwiani", "umożliwieni", "umrocznieni", "unaocznieni", "unicestwiani", "unicestwieni", "uniemożliwaini", "uniemożliwieni", "unierochomieni", "uniesieni", "unieszczęśliwiani", "unieszczęśliwieni", "unieszkodliwiani", "unieszkodliwieni", "unieważniani", "unieważnieni", "uniewinnieni", "uniezależnieni", "unikani", "unormowani", "unoszeni", "unowoczesniani", "unowocześniani", "uodpornieni", "uogólniani", "upakowani", "upalani", "upaleni", "upamiętniani", "upamiętnieni", "upaństwowieni", "upaprani", "upaskudzeni", "upchani", "upewniani", "upewnieni", "upgradowani", "upiększani", "upiększeni", "upierani", "upierdoleni", "upijani", "upilnowani", "upinani", "uplastycznieni", "upodabniani", "upodobnieni", "upojeni", "upokorzani", "upokorzeni", "upolowani", "upominani", "uporządkowani", "upowszechnieni", "upozorowani", "upozowani", "uprani", "uprasowani", "upraszczani", "uprawdopodobnieni", "uprawiani", "uproszczeni", "uproszeni", "uprowadzani", "uprowadzeni", "uprzątani", "uprzedeni", "uprzedzani", "uprzyjemniani", "uprzyjemnieni", "uprzykrzani", "uprzytomnieni", "upubliczniani", "upublicznieni", "upudrowani", "upuszczani", "upuszczeni", "upychani", "urabiani", "uraczani", "uradowani", "Urągani", "uratowani", "urażani", "urażeni", "uregulowani", "urobieni", "uronieni", "urozmaicani", "urozmaiceni", "uruchamiani", "uruchomieni", "urwani", "urywani", "urządzani", "urządzeni", "urzeczywistniani", "urzeczywistnieni", "usadowieni", "usadzeni", "usamowolnieni", "usankcjonowani", "usatyfakcjonowani", "uściskani", "uścisleni", "usidleni", "usiedzeni", "uskładani", "uskoczeni", "uskuteczniani", "uskutecznieni", "usłuchani", "usługiwani", "usłużeni", "usłyszani", "usmażeni", "uśmiani", "uśmiercani", "uśmierceni", "uśmierzeni", "uspani", "uśpieni", "uspokajani", "uspokojeni", "uspołeczniani", "usprawiedliwiani", "usprawiedliwieni", "usprawnieni", "usprzątani", "ustabilizowani", "ustalani", "ustaleni", "ustanawiani", "ustanowieni", "ustąpieni", "ustatkowani", "ustawiani", "ustawieni", "ustępowani", "ustosunkowani", "ustrojeni", "ustrzegani", "ustrzeleni", "ususzeni", "usuwani", "uświadamiani", "uświadczeni", "uświadomieni", "uświęceni", "uświnieni", "usychani", "usypani", "usypiani", "usystematyzowani", "usytuowani", "uszanowani", "uszczelniani", "uszczęśliwiani", "uszczęśliwieni", "uszczupleni", "uszkadzani", "uszkodzeni", "uszlachetniani", "uszlachetnieni", "usztywnieni", "uszykowani", "utajnieni", "utargowani", "utemperowani", "utkani", "utkwieni", "utoczeni", "utopieni", "utorowani", "utożsamiani", "utożsamieni", "utraceni", "utrąceni", "utrudniani", "utrudnieni", "utrwalani", "utrwaleni", "utrzymywani", "utuczeni", "utuleni", "utwierdzani", "utwierdzeni", "utworzeni", "utylizowani", "uwalniani", "uwaleni", "uwarunkowani", "uważani", "uwiązani", "uwiązywani", "uwidocznieni", "uwieczniani", "uwiecznieni", "uwielbiani", "uwielbieni", "uwieńczeni", "uwierani", "uwierzeni", "uwieszeni", "uwiezieni", "uwięzieni", "uwijani", "uwikłani", "uwłaczani", "uwłaszczeni", "uwodzeni", "uwolnieni", "uwsteczniani", "uwstecznieni", "uwydatniani", "uwypikleni", "uwzględniani", "uwzględnieni", "użądleni", "uzależniani", "uzależnieni", "uzasadniani", "uzasadnieni", "uzbierani", "uzbrajani", "uzbrojeni", "uzdrawiani", "uzdrowieni", "użerani", "uzewnętrzniani", "uzewnętrznieni", "uzgadniani", "uzgodnieni", "uziemieni", "uzmysłowieni", "uznani", "uznawani", "uzupełniani", "uzupełnieni", "uzurpowani", "użyczani", "użyczeni", "uzyskani", "uzyskiwani", "używani", "wabieni", "wąchani", "wachlowani", "wahani", "walczeni", "wałkowani", "waleni", "ważeni", "wbijani", "wcelowani", "wciągani", "wcielani", "wcieleni", "wcierani", "wcinani", "wciskani", "wczepieni", "wczołgani", "wczytani", "wczytywani", "wdani", "wdawani", "wdeptani", "wdetonowani", "wdmuchiwani", "wdrapani", "wdrapywani", "wdrażani", "wdrążeni", "wdrożeni", "wduszeni", "wdychani", "wdzierani", "wędkowani", "wentylowani", "wepchani", "werbowani", "weryfikowani", "wessani", "wetkani", "wezwani", "wgłębiani", "wgniatani", "wgniecieni", "wgrani", "wgryzani", "wgryzieni", "wiązani", "wibrowani", "widywani", "widziani", "wiedzeni", "wielbieni", "wierceni", "wierzgani", "wierzeni", "wieszani", "wietrzeni", "więżeni", "wikłani", "windowani", "winszowani", "wiosłowani", "wirowani", "witani", "wizualizowani", "wjeżdżani", "wkalkulowani", "wkładani", "wklejani", "wklejeni", "wklepani", "wkomponowani", "wkopani", "wkopywani", "wkraczani", "wkradani", "wkradzieni", "wkręcani", "wkręceni", "wkupieni", "wkurwiani", "wkuwani", "włączani", "włączeni", "władani", "władowani", "włamani", "włamywani", "wlani", "wlepiani", "wlepieni", "wlewani", "wliczani", "wliczeni", "włożeni", "wmanewrowani", "wmanipulowani", "wmawiani", "wmieszani", "wmówieni", "wmurowani", "wmuszeni", "wnerwiani", "wnerwieni", "wniesieni", "wnikani", "wnioskowani", "wnoszeni", "wodowani", "wojowani", "wołani", "woskowani", "wożeni", "wpajani", "wpakowani", "wparowani", "wpasowani", "wpatrywani", "wpędzani", "wpędzeni", "wperswadowani", "wpienieni", "wpisani", "wpisywani", "wpłacani", "wpłaceni", "wplatani", "wplątani", "wplątywani", "wpojeni", "wpompowani", "wpraszani", "wprawiani", "wproszeni", "wprowadzani", "wprowadzeni", "wpuszczeni", "wpychani", "wrabiani", "wręczani", "wrobieni", "wróżeni", "wrzucani", "wrzuceni", "wrzynani", "wsadzani", "wsadzeni", "wskazani", "wskazywani", "wskórani", "wskrzeszani", "wskrzeszeni", "wślizgiwani", "wsłuchani", "wspierani", "współodczuwani", "współtworzeni", "wspomagani", "wspominani", "wspomniani", "wstąpieni", "wstawiani", "wstawieni", "wstrząsani", "wstrzeleni", "wstrzykiwani", "wstrzymani", "wstrzymywani", "wstukani", "wsuwani", "wsypani", "wszamani", "wszczepiani", "wszczepieni", "wszczynani", "wtajemniczani", "wtajemniczeni", "wtapiani", "wtaszczeni", "wtłoczeni", "wtopieni", "wtrąceni", "wtryniani", "wtulani", "wtuleni", "wtykani", "wwaleni", "wwiercani", "wwierceni", "wwiezieni", "wwożeni", "wyartykułowani", "wyautowani", "wybaczani", "wybaczeni", "wybadani", "wybatożeni", "wybawieni", "wybebeszeni", "wybełkotani", "wybiczowani", "wybielani", "wybieleni", "wybierani", "wybijani", "wybłagani", "wybrandzlowani", "wybrani", "wybronieni", "wybrzydzani", "wybuchani", "wybudowani", "wybudzani", "wybudzeni", "wyburzani", "wyburzeni", "wycackani", "wycałowani", "wyceniani", "wycenieni", "wychlani", "wychłostani", "wychodowani", "wychowani", "wychowywani", "wychrobotani", "wychwalani", "wychwyceni", "wychylani", "wychyleni", "wyciągani", "wyciekani", "wycieniowani", "wycierani", "wycinani", "wyciskani", "wyciszani", "wyciszeni", "wycofani", "wyćwiczeni", "wycyckani", "wycyganieni", "wyczarowani", "wyczarterowani", "wyczekani", "wyczekiwani", "wyczerpani", "wyczesani", "wyczołgani", "wyczołgiwani", "wyczuwani", "wyczyniani", "wyczyszczeni", "wyczytani", "wyczytywani", "wydalani", "wydaleni", "wydani", "wydębieni", "wydedukowani", "wydelegowani", "wydepilowani", "wydeptywani", "wydłubani", "wydłubywani", "wydłużani", "wydłużeni", "wydmuchani", "wydmuchiwani", "wydobywani", "wydojeni", "wydoroślani", "wydostani", "wydrani", "wydrapani", "wydrapywani", "wydrążeni", "wydrukowani", "wydukani", "wyduszeni", "wydychani", "wydziedziczeni", "wydzielani", "wydzieleni", "wydzierani", "wydzierżawieni", "wydziobani", "wydziwiani", "wydzwaniani", "wyedukowani", "wyedytowani", "wyeeliminowani", "wyegzekwowani", "wyeksmitowani", "wyekspediowani", "wyeksploatowani", "wyeksponowani", "wyeksportowani", "wyeliminowani", "wyemigrowani", "wyemitowani", "wyewoluowani", "wygadani", "wygadywani", "wyganiani", "wygarbowani", "wygarniani", "wygasani", "wygaszani", "wygaszeni", "wygenerowani", "wyginani", "wygładzani", "wygładzeni", "wygłaszani", "wygłodzeni", "wygłosowani", "wygłoszeni", "wygłówkowani", "wygnani", "wygoleni", "wygonieni", "wygooglowani", "wygospodarowani", "wygotowani", "wygrani", "wygrawerowani", "wygrażani", "wygrywani", "wygryzieni", "wygrzani", "wygrzebani", "wygrzebywani", "wygrzewani", "wygubieni", "wyhaczeni", "wyhaftowani", "wyhamowani", "wyhodowani", "wyizolowani", "wyjadani", "wyjaśniani", "wyjaśnieni", "wyjawiani", "wyjawieni", "wyjedzeni", "wyjmowani", "wykadrowani", "wykalibrowani", "wykalkulowani", "wykańczani", "wykantowani", "wykąpani", "wykaraskani", "wykarczowani", "wykarmiani", "wykasowani", "wykastrowani", "wykazani", "wykazywani", "wykierowani", "wykitowani", "wykiwani", "wykładani", "wyklarowani", "wyklepani", "wyklinani", "wykłócani", "wykluczani", "wykluczeni", "wykminieni", "wykolejeni", "wykołowani", "wykombinowani", "wykonani", "wykończeni", "wykonywani", "wykopani", "wykopywani", "wykorkowani", "wykorzeniani", "wykorzenieni", "wykorzystani", "wykorzystywani", "wykoszeni", "wykradani", "wykręcani", "wykręceni", "wykreowani", "wykreślani", "wykreśleni", "wykrochmaleni", "wykrojeni", "wykrwawiani", "wykrwawieni", "wykrywani", "wykrzesani", "wykrztuszeni", "wykrzyczeni", "wykrzykiwani", "wykrzywiani", "wykształceni", "wyksztuszeni", "wykupieni", "wykupywani", "wykuwani", "wyłączani", "wyłączeni", "wylądowani", "wyładowani", "wyładowywani", "wyłajani", "wyłamani", "wyłamywani", "wyłaniani", "wylansowani", "wylani", "wyłapani", "wyłapywani", "wyławiani", "wyleasingowani", "wyleczeni", "wylęgani", "wylegimytowani", "wylewani", "wyłgani", "wylicytowani", "wyliczani", "wyliczeni", "wylizani", "wylizywani", "wylogowani", "wyłonieni", "wylosowani", "wyłowieni", "wyłożeni", "wyłudzani", "wyłudzeni", "wyłupani", "wyłuskani", "wyłuskiwani", "wyłuszczeni", "wyluzowani", "wymacani", "wymachiwani", "wymagani", "wymahiwani", "wymalowani", "wymamrotani", "wymanewrowani", "wymarzeni", "wymasowani", "wymawiani", "wymazani", "wymazywani", "wymeldowani", "wymeldowywani", "wymiatani", "wymiecieni", "wymieniani", "wymienieni", "wymierzani", "wymieszani", "wymigani", "wymigiwani", "wymijani", "wymoczeni", "wymodelowani", "wymontowani", "wymordowani", "wymuszani", "wymyślani", "wymyśleni", "wynagradzani", "wynagrodzeni", "wynajdowani", "wynajdywani", "wynajmowani", "wynalezieni", "wynarodowieni", "wynegocjowani", "wyniesieni", "wyniszczani", "wyniszczeni", "wyniuchani", "wynoszeni", "wynurzani", "wyobrażani", "wyobrażeni", "wyodrębnieni", "wyolbrzymiani", "wyolbrzymieni", "wyorbowani", "wyosiowani", "wyostrzani", "wyostrzeni", "wypaczani", "wypakowani", "wypakowywani", "wypalani", "wypaleni", "wypałowani", "wyparowani", "wypasani", "wypastowani", "wypatroszeni", "wypatrywani", "wypatrzeni", "wypchani", "wypędzani", "wypędzlowani", "wypełniani", "wypełnieni", "wypersfadowani", "wyperswadowani", "wypierani", "wypijani", "wypinani", "wypisani", "wypisywani", "wypłacani", "wypłaceni", "wypłakani", "wypłakiwani", "wypłaszczeni", "wyplatani", "wyplątani", "wyplenieni", "wyplewieni", "wypłoszeni", "wypłukani", "wypłukiwani", "wypluwani", "wypoceni", "wypolerowani", "wypominani", "wypomniani", "wypompowani", "wypompowywani", "wyposażeni", "wypowiadani", "wypowiedziani", "wypoziomowani", "wypożyczani", "wypracowani", "wypracowywani", "wyprani", "wyprasowani", "wypraszani", "wyprawiani", "wyprawieni", "wypróbowani", "wyprodukowani", "wyprojektowani", "wypromieniowani", "wypromowani", "wyprostowani", "wyprostowywani", "wyproszeni", "wyprowadzani", "wyprowadzeni", "wypróżniani", "wypróżnieni", "wypruwani", "wyprzedani", "wyprzedawani", "wyprzedzani", "wyprzedzeni", "wyprzęgani", "wypstrykani", "wypucowani", "wypuszczani", "wypuszczeni", "wypychani", "wypytani", "wypytywani", "wyrąbani", "wyrabiani", "wyrąbywani", "wyratowani", "wyrażani", "wyrażeni", "wyrecytowani", "wyręczani", "wyręczeni", "wyregulowani", "wyrejestrowani", "wyremontowani", "wyreżyserowani", "wyrobieni", "wyrolowani", "wyrównani", "wyrównywani", "wyróżniani", "wyróżnieni", "wyrugowani", "wyruszani", "wyrwani", "wyrypani", "wyrysowani", "wyrywani", "wyrządzeni", "wyrzeźbieni", "wyrzucani", "wyrzuceni", "wyrzygani", "wyrzynani", "wyrzywani", "wysączeni", "wysadzani", "wysadzeni", "wyściskani", "wyselekcjonowani", "wysępieni", "wysiadywani", "wysiedzeni", "wysilani", "wysileni", "wyskakiwani", "wyskalowani", "wyskoczeni", "wyskrobani", "wyskubywani", "wysłani", "wyśledzeni", "wyślizgiwani", "wysłowieni", "wysłuchani", "wysłuchiwani", "wysmagani", "wysmarkani", "wysmarowani", "wysmażani", "wysmażeni", "wyśmiani", "wyśmiewani", "wysmołowani", "wysmyrani", "wyśnieni", "wysnuwani", "wysondowani", "wyspecjalizowani", "wyśpiewani", "wyśpiewywani", "wyspowiadani", "wysprzątani", "wysprzedani", "wyssani", "wystartowani", "wystawieni", "wysterelizowani", "wysterylizowani", "wystosowani", "wystosowywani", "wystraszeni", "wystrojeni", "wystrugani", "wystrzegani", "wystrzelani", "wystrzeliwani", "wystrzeleni", "wystudzeni", "wystukani", "wystukiwani", "wysuszani", "wysuwani", "wyswatani", "wyświadczani", "wyświadczeni", "wyświetlani", "wyświetleni", "wyswobodzeni", "wysyłani", "wysypani", "wysypywani", "wysysani", "wyszabrowani", "wyszalani", "wyszarpani", "wyszasowani", "wyszczotkowani", "wyszczupleni", "wyszeptani", "wyszkoleni", "wyszlifowani", "wyszorowani", "wyszperani", "wyszukani", "wyszukiwani", "wyszumieni", "wyszykowani", "wytapetowani", "wytargani", "wytargowani", "wytarzani", "wytaszczeni", "wytatuowani", "wytępieni", "wytłoczeni", "wytłumaczeni", "wytłumieni", "wytoczeni", "wytrąbieni", "wytrącani", "wytrąceni", "wytransmitowani", "wytransportowani", "wytrenowani", "wytresowani", "wytriangulowani", "wytropieni", "wytrząsani", "wytrzebieni", "wytrzepani", "wytrzeszczani", "wytrzeźwiani", "wytrzymani", "wytrzymywani", "wytwarzani", "wytworzeni", "wytyczeni", "wytykani", "wytypowani", "wyuczeni", "wywabiani", "wywabieni", "wywąchani", "wywalani", "wywalczeni", "wywaleni", "wywarzani", "wyważani", "wyważeni", "wywęszani", "wywężykowani", "wywiani", "wywiązani", "wywiązywani", "wywierani", "wywierceni", "wywieszani", "wywieszeni", "wywietrzeni", "wywiezieni", "wywijani", "wywindowani", "wywłaszczeni", "wywlekani", "wywnętrznieni", "wywnioskowani", "wywodzeni", "wywolani", "wywoływani", "wywoskowani", "wywożeni", "wywracani", "wywróceni", "wywróżeni", "wywyższani", "wyżaleni", "wyzdrowieni", "wyżebrani", "wyżerani", "wyzerowani", "wyznaczani", "wyznaczeni", "wyznani", "wyznawani", "wyzwalani", "wyzwani", "wyzwoleni", "wyzygzakowani", "wyżynani", "wyzyskani", "wyzyskiwani", "wyzywani", "wyżywani", "wyżywieni", "wzbijani", "wzbogacani", "wzbogaceni", "wzbraniani", "wzbudzani", "wzbudzeni", "wzburzani", "wzburzeni", "wżenieni", "wzmacnieni", "wzmagani", "wzmocnieni", "wznawiani", "wzniecani", "wzniecieni", "wznoszeni", "wznowieni", "wzorowani", "wzruszeni", "wzwyżani", "wzywani", "zaabordowani", "zaadaptowani", "zaadoptowani", "zaadresowani", "zaakcentowani", "zaakceptowani", "zaaklimatyzowani", "zaalarmowani", "zaanektowani", "zaangażowani", "zaanonsowani", "zaapelowani", "zaaplikowani", "zaaportowani", "zaaprobowani", "zaaranżowani", "zaaresztowani", "zaatakowani", "zabaczeni", "zabalowani", "zabandażowani", "zabarwieni", "zabarykadowani", "zabawiani", "zabawieni", "zabepieczani", "zabetonowani", "zabezpieczeni", "zabierani", "zabłądzeni", "zablefowani", "zabłoceni", "zablokowani", "zabraniani", "zabrani", "zabronieni", "zabrudzeni", "zabudowani", "zabukowani", "zabuleni", "zaburzeni", "zabutelkowani", "zacementowani", "zacerowani", "zachciani", "zachęcani", "zachęceni", "zachlapani", "zachodzeni", "zachomikowani", "zachorowani", "zachowani", "zachowywani", "zachwalani", "zachwaleni", "zachwiani", "zachwyceni", "zaciągani", "zaciążeni", "zaciekawieni", "zaciemniani", "zaciemnieni", "zacierani", "zacieśnieni", "zacinani", "zaciskani", "zaćmieni", "zacumowani", "zacytowani", "zaczadzeni", "zaczarowani", "zaczepiani", "zaczepieni", "zaczerpani", "zaczesani", "zaczołgani", "zaczynani", "zadawalani", "zadawani", "zadbani", "zadebiutowani", "zadedykowani", "zadeklamowani", "zadeklarowani", "zademonstrowani", "zadenucjowani", "zadepeszowani", "zadeptani", "zadeptywani", "zadławieni", "żądleni", "zadłużani", "zadłużeni", "zadokowani", "zadomowieni", "zadowalani", "zadrapani", "zadręczani", "zadręczeni", "zadrutowani", "zadurzani", "zadurzeni", "zaduszeni", "zadymieni", "zadźgani", "zadziobani", "zadziwiani", "zadziwieni", "zafakturowani", "zafałszowani", "zafarbowani", "zafiksowani", "zafundowani", "zagadani", "zagadywani", "zagajeni", "zaganiani", "zagapieni", "zagarażowani", "zagarniani", "zagaszeni", "zagazowani", "zagęszczeni", "zaginani", "zagłębiani", "zagłębieni", "zagłodzeni", "zagłuszani", "zagłuszeni", "zagmatwani", "zagnani", "zagnieżdżeni", "zagojeni", "zagonieni", "zagospodarowani", "zagotowani", "zagrabieni", "zagradzani", "zagrażani", "zagrodzeni", "zagrywani", "zagryzani", "zagryzieni", "zagrzani", "zagrzebani", "zagrzewani", "zagubieni", "zagwarantowani", "zahaczeni", "zahamowani", "zahandlowani", "zaharowani", "zahartowani", "zahipnotyzowani", "zaholowani", "zaimitowani", "zaimplantowani", "zaimplementowani", "zaimprowizowani", "zainaugurowani", "zainfekowani", "zainicjowani", "zainkasowani", "zainscenizowani", "zainspirowani", "zainstalowani", "zainteresowani", "zaintrygowani", "zaintubowani", "zainwestowani", "zaizolowani", "zajadani", "zajani", "zajarani", "zajechani", "zajmowani", "zakablowani", "zakamuflowani", "zakasani", "zakasowani", "zakąszani", "zakatalogowani", "zakatowani", "zakatrupieni", "zakazani", "zakażani", "zakazywani", "zakiszeni", "zakładani", "zaklasyfikowani", "zaklejani", "zaklejeni", "zaklepani", "zaklepywani", "zaklinani", "zaklinowani", "zakłócani", "zakłóceni", "zaklopotani", "zakneblowani", "zakodowani", "zakolczykowani", "zakolorowani", "zakołysani", "zakomunikowani", "zakończeni", "zakonserwowani", "zakopani", "zakopywani", "zakorzeniani", "zakorzenieni", "zakoszeni", "zakosztowani", "zakotwiczani", "zakotwiczeni", "zakpieni", "zakradani", "zakręcani", "zakręceni", "zakreślani", "zakreśleni", "zakrwawieni", "zakrywani", "zakrzyczani", "zakrzywiani", "zakrzywieni", "zaksięgowani", "zaktualizowani", "zaktywizowani", "zaktywowani", "zakumani", "zakupieni", "zakurzeni", "zakuwani", "zakwaterowani", "załączeni", "załadowani", "załagodzeni", "zalamani", "zalaminowani", "załamywani", "zalani", "załapani", "załatani", "załatwiani", "załatwieni", "zalatywani", "zalecani", "zaleceni", "zaleczeni", "zalegalizowani", "zalegani", "zalepiani", "zalepieni", "zalewani", "zaliczani", "zaliczeni", "załkani", "zalogowani", "żałowani", "założeni", "zaludnieni", "zamacani", "zamąceni", "zamalowani", "zamanewrowani", "zamanifestowani", "zamarkowani", "zamartwiani", "zamarynowani", "zamarzani", "zamaskowani", "zamawiani", "zamazani", "zamazywani", "zamęczani", "zamęczeni", "zameldowani", "zamelinowani", "zamerykanizowani", "zamiatani", "zamieniani", "zamienieni", "zamieszani", "zamieszczani", "zamieszczeni", "zamieszkani", "zamieszkiwani", "zaminowani", "zamocowani", "zamoczeni", "zamontowani", "zamordowani", "zamortyzowani", "zamotani", "zamówieni", "zamrażani", "zamroczeni", "zamrożeni", "zamulani", "zamurowani", "zamydleni", "zamykani", "zanalizowani", "zanegowani", "zaniechani", "zanieczyszczani", "zanieczyszczeni", "zaniedbani", "zaniedbywani", "zaniepokojeni", "zaniesieni", "zanihilowani", "zanikani", "zaniżani", "zaniżeni", "zanoszeni", "zanotowani", "zanuceni", "zanudzani", "zanudzeni", "zanurzani", "zanurzeni", "zanużeni", "zaobaczeni", "zaobserwowani", "zaoferowani", "zaofiarowani", "zaogniani", "zaognieni", "zaokrąglani", "zaokrągleni", "zaokrętowani", "zaopatrywani", "zaopatrzeni", "zaopiekowani", "zaorani", "zaostrzani", "zaostrzeni", "zaoszczędzeni", "zapadani", "zapakowani", "zapalani", "zapaleni", "zapamiętani", "zapamiętywani", "zapanowani", "zaparkowani", "zaparowywani", "zaparzani", "zaparzeni", "zapaskudzeni", "zapauzowani", "zapchani", "zapędzani", "zapełniani", "zapełnieni", "zaperfumowani", "zapeszani", "zapewniani", "zapewnieni", "zapieczętowani", "zapierani", "zapijani", "zapinani", "zapisani", "zapisuwani", "zapłaceni", "zapładniani", "zaplamieni", "zaplanowani", "zaplątani", "zapłodnieni", "zaplombowani", "zapobiegani", "zapodani", "zapodawani", "zapodziani", "zapokojeni", "zapolowani", "zapominani", "zapomniani", "zapowiadani", "zapowiedziani", "zapoznani", "zapoznawani", "zapożyczeni", "zapracowywani", "zaprani", "zaprasowywani", "zapraszani", "zaprawieni", "zaprenumerowani", "zaprezentowani", "Zaprogramowani", "zaprojektowani", "zaproponowani", "zaproszeni", "zaprotokołowani", "zaprowadzani", "zaprowadzeni", "zaprzątani", "zaprzeczani", "zaprzeczeni", "zaprzedani", "zaprzedawani", "zaprzęgani", "zaprzepaszczani", "zaprzestani", "zaprzestawani", "zaprzyjaźnieni", "zapudłowani", "zapunktowani", "zapuszczani", "zapuszczeni", "zapuszkowani", "zapychani", "zapylani", "zapyleni", "zapytani", "zarabiani", "zaranżowani", "zarażani", "zarażeni", "zarecytowani", "zaręczani", "zaręczeni", "zarejestrowani", "zareklamowani", "zarekomendowani", "zarekomondowani", "zarekwirowani", "zarezerwowani", "zarobieni", "żartowani", "zarwani", "zaryglowani", "zarymowani", "zarysowani", "zarywani", "zaryzykowani", "zarządzani", "zarzucani", "zarzynani", "zasadzeni", "zaścieleni", "zasegurowani", "zaserwowani", "zasiadani", "zasiani", "zasiedleni", "zasięgani", "zasiewani", "zasilani", "zasileni", "zaskakiwani", "zaskarbieni", "zaskoczeni", "zaskrobani", "zasłaniani", "zaślepiani", "zaślepieni", "zasłodzeni", "zasłonieni", "zasłużeni", "zasmakowani", "zaśmiecani", "zaśmieceni", "zasmradzani", "zasmrodzeni", "zasmucani", "zasmuceni", "zasoleni", "zaspakajani", "zaśpiewani", "zaspokajani", "zaspokojeni", "zasponsorowani", "zaśrubowywani", "zassani", "zastani", "zastąpieni", "zastawiani", "zastawieni", "zastępowani", "zastopowani", "zastosowani", "zastraszani", "zastraszeni", "zastrzeleni", "zasugerowani", "zasuwani", "zaświadczeni", "zaświeceni", "zaświonieni", "zasyfieni", "zasygnalizowani", "zasymilowani", "zasymulowani", "zasypani", "zasypywani", "zasysani", "zaszachowani", "zaszantażowani", "zaszargani", "zaszczepiani", "zaszczepieni", "zaszczycani", "zaszczyceni", "zaszeptani", "zaszeregowani", "zaszlachtowani", "zasznurowani", "zaszpachlowani", "zasztyletowani", "zaszufladkowani", "zaszyfrowani", "zaszywani", "zataczani", "zatajani", "zatajeni", "zatamowani", "zatankowani", "zatapiani", "zatargani", "zatelegrafowani", "zatemperowani", "zatęsknieni", "zatkani", "zatoczeni", "zatopieni", "zatracani", "zatraceni", "zatriumfowani", "zatrudniani", "zatrudnieni", "zatruwani", "zatrzaskiwani", "zatrzymani", "zatrzymywani", "zatuszowani", "zatwierdzani", "zatwierdzeni", "zatykani", "zatynkowani", "zatytułowani", "zauploadowani", "zauroczeni", "zautomatyzowani", "zauważani", "zauważeni", "zawadzani", "zawalani", "zawalczeni", "zawaleni", "zaważeni", "zawdzięczani", "zawetowani", "zawężeni", "zawiadamiani", "zawiadomieni", "zawiązani", "zawiązywani", "zawiedzeni", "zawierani", "zawierzeni", "zawieszani", "zawieszeni", "zawiezieni", "zawijani", "zawinieni", "zawitani", "zawłaszczeni", "zawodzeni", "zawojowani", "zawołani", "zawoskowani", "zawożeni", "zawracani", "zawróceni", "zawstydzani", "zażądani", "zażartowani", "zazdroszczeni", "zażegnani", "zażenowani", "zaznaczani", "zaznajomieni", "zaznani", "zaznawani", "zażyczeni", "zażywani", "zbaczani", "zbadani", "zbagatelizowani", "zbajerowani", "zbałamuceni", "zbalansowani", "zbalsamowani", "zbankrutowani", "zbawiani", "zbawieni", "zbesztani", "zbezczeszczeni", "zbierani", "zbijani", "zbliżeni", "zbluzgani", "zbojkotowani", "zbrojeni", "zbrukani", "zbszczeceni", "zbudowani", "zbudzeni", "zbuntowani", "zburzeni", "zbywani", "zchwytani", "zciszeni", "zdani", "zdeaktywowani", "zdecydowani", "zdefiniowani", "zdeflorowani", "zdegradowani", "zdejmowani", "zdeklarowani", "zdekodowani", "zdekompresowani", "zdekoncentrowani", "zdekonstruowani", "zdelegalizowani", "zdemaskowani", "zdementowani", "zdemolowani", "zdemontowani", "zdemoralizowani", "zdenerwowani", "zdeponowani", "zdeprymowani", "zdeptani", "zderzani", "zderzeni", "zdestabilizowani", "Zdetonowani", "zdetronizowani", "zdewastowani", "zdewaulowani", "zdezerterowani", "zdezintegrowani", "zdezorientowani", "zdezynfektowani", "zdiagnozowani", "zdławieni", "zdmuchiwani", "zdobywani", "zdołowani", "zdominowani", "zdopingowani", "zdrabniani", "zdradzani", "zdradzeni", "zdrapani", "zdrapywani", "zdrutowani", "zdruzgotani", "zduplikowani", "zduszeni", "zdwojeni", "zdyscyplinowani", "zdyskredytowani", "zdyskwalifikowani", "zdystansowani", "zdzieleni", "zdzierani", "zdzierżeni", "zdziesiątkowani", "zdzwonieni", "zebrani", "zechciani", "zedytowani", "żegnani", "żenieni", "żerowani", "zerwani", "zeskakiwani", "zeskanowani", "zeskrobywani", "zesłani", "ześlizgiwani", "zesmoleni", "zespawiani", "zespoleni", "zessani", "zestawiani", "zestawieni", "zestresowani", "zestrzeliwani", "zestrzeleni", "zeswatani", "zeszkleni", "zeszlifowani", "zezłoszczeni", "zeznani", "zeznawani", "zezwalani", "zezwoleni", "zfinansowani", "zgadani", "zgadywani", "zgajani", "zganieni", "zgaszeni", "zginani", "zgładzeni", "zgłaszani", "zgłębiani", "zgłębieni", "zgłośnieni", "zgłoszeni", "zgłuszeni", "zgniatani", "zgniecieni", "zgnojeni", "zgodzeni", "zgoleni", "zgonieni", "zgotowani", "zgrabieni", "zgrillowani", "zgromadzani", "zgromadzeni", "zgrupowani", "zgrzeszeni", "zgrzytani", "zgubieni", "zgwałceni", "zhackowani", "zhakowani", "zhańbieni", "zhandlowani", "zharmonizowani", "zidentyfikowani", "ziewani", "zignorowani", "zilustrowani", "zinfiltrowani", "zintegrowani", "zintensyfikowani", "zinterpretowani", "zinwentaryzowani", "zirytowani", "zjadani", "zjawiani", "zjednani", "zjednoczeni", "zjedzeni", "zjeżdżeni", "zkontaktowani", "zkserowani", "złączeni", "złagodzeni", "złajani", "złamani", "zlani", "złapani", "zlecani", "zleceni", "zlekceważeni", "zlepiani", "zlepieni", "zlewani", "zlicytowani", "zliczani", "zliczeni", "zlikwidowani", "zlinczowani", "zlitowani", "zlizani", "zlizywani", "zlokalizowani", "złomowani", "żłopani", "złowieni", "złożeni", "złupieni", "złuszczani", "zluzowani", "zmacani", "zmąceni", "zmagani", "zmagazynowani", "zmajstrowani", "zmaksylizowani", "zmanipulowani", "zmarnowani", "zmartwychwstani", "zmasakrowani", "zmaterializowani", "zmawiani", "zmazani", "zmazywani", "zmbobardowani", "zmiatani", "zmiażdżeni", "zmiękczeni", "zmieleni", "zmieniani", "zmienieni", "zmierzani", "zmierzeni", "zmierzwieni", "zmieszani", "zmieszczeni", "zmiksowani", "zminiaturyzowani", "zminimalizowani", "zmniejszani", "zmniejszeni", "zmobilizowani", "zmoczeni", "zmodernizowani", "zmodyfikowani", "zmonopolizowani", "zmontowani", "zmostkowani", "zmotywowani", "zmówieni", "zmrożeni", "zmrużeni", "zmumifikowani", "zmuszani", "zmuszeni", "zmutowani", "zmyślani", "zmywani", "znacjonalizowani", "znajdowani", "znajdywani", "znakowani", "znalezieni", "znani", "znęcani", "zneutralizowani", "zniechęceni", "znieczuleni", "zniekształcani", "zniekształceni", "znienawidzeni", "znieprawieni", "zniesieni", "zniesławiani", "zniesławieni", "zniewalani", "znieważani", "znieważeni", "zniewoleni", "zniszczeni", "zniweczeni", "zniwelowani", "zniżani", "zniżeni", "znokautowani", "znormalnieni", "znoszeni", "znudzeni", "zobaczeni", "zobowiązani", "zobrazowani", "zogniskowani", "żonglowani", "zoomowani", "zoperowani", "zoptymalizowani", "zorganizowani", "zorientowani", "zostawiani", "zostawieni", "zpłaceni", "zprowokowani", "zrabowani", "zrachowani", "zracjonalizowani", "zranieni", "zraportowani", "zrażani", "zrażeni", "zrealizowani", "zrecenzowani", "zredagowani", "zredukowani", "zreferowani", "zreformowani", "zrefowani", "zrefundowani", "zregenerowani", "zrehabilitowani", "zreinkarnowani", "zreintegrowani", "zrekonfigurowani", "zrekonstruowani", "zrekrutowani", "zrekrystalizowani", "zrelacjonowani", "zrelaksowani", "zremiksowani", "zremisowani", "zreorganizowani", "zreperowani", "zreplikowani", "zresetowani", "zresocjalizowani", "zrestartowani", "zrestrukturyzowani", "zrewanżowani", "zrewidowani", "zrewolucjenizowani", "zrezygnowani", "zrobieni", "zrolowani", "zroszeni", "zrównani", "zrównoważeni", "zrównywani", "zróżnicowani", "zrozumiani", "zrugani", "zruinowani", "zrujnowani", "zrymowani", "zrywani", "zrzędzeni", "zrzeszeni", "zrzucani", "zrzuceni", "zsumowani", "zsuwani", "zsynchronizowani", "zsyntetyzowani", "zsypywani", "zszargani", "zszokowani", "zszywani", "zutylizowani", "zużywani", "zwabiani", "zwabieni", "zwalani", "zwalczeni", "zwalniani", "zwaleni", "zwani", "zwaporyzowani", "zwątpieni", "zważani", "zważeni", "zwędzeni", "zwerbalizowani", "zwerbowani", "zweryfikowani", "zwęszeni", "zwężeni", "zwiastowani", "związani", "związywani", "zwiedzani", "zwiedzeni", "zwiększeni", "zwieńczeni", "zwierzani", "zwieszani", "zwieszeni", "zwietrzeni", "zwijani", "zwilżeni", "zwizualizowani", "zwlekani", "zwodowani", "zwodzeni", "zwołani", "zwolnieni", "zwoływani", "zwożeni", "zwracani", "zwróceni", "zwyciężani", "zwymiotowani", "życzeni", "żygani", "zygzakowani", "zyskani", "zyskiwani", "zżerani", "zżynani", "konsakrowany", "konsakrowana", "konsakrowane", "konsakrowani"];
};

Object.defineProperty(matchParticiples$1, "__esModule", {
	value: true
});

matchParticiples$1.default = function () {
	return {
		regularParticiples: (0, _lodashEs$N.memoize)(regularParticiples),
		irregularParticiples: (0, _lodashEs$N.memoize)(irregularParticiples$1)
	};
};

var _lodashEs$N = require$$1$1;

var _irregulars$1 = irregulars$3;

var _irregulars2$1 = _interopRequireDefault$19(_irregulars$1);

var _irregulars3 = irregulars$2;

var _irregulars4 = _interopRequireDefault$19(_irregulars3);

var _participles$2 = participles$5;

var _participles2$2 = _interopRequireDefault$19(_participles$2);

var _participles3 = participles$4;

var _participles4 = _interopRequireDefault$19(_participles3);

var _participles5 = participles$3;

var _participles6 = _interopRequireDefault$19(_participles5);

var _irregulars5 = irregulars$1;

var _irregulars6 = _interopRequireDefault$19(_irregulars5);

var _participles7 = participles$2;

var _participles8 = _interopRequireDefault$19(_participles7);

function _interopRequireDefault$19(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const irregularsEnglish = (0, _irregulars2$1.default)();

const irregularsFrench = (0, _irregulars4.default)();

const irregularsRegularFrench = irregularsFrench.irregularsRegular;
const irregularsIrregularFrench = irregularsFrench.irregularsIrregular;
const irregularsEndingInSFrench = irregularsFrench.irregularsEndingInS;

const spanishParticiples = (0, _participles2$2.default)();

const portugueseParticiples = (0, _participles4.default)();

const italianParticiples = (0, _participles6.default)();

const irregularsDutch = (0, _irregulars6.default)();
const nlRegex1 = /^(ge|be|ont|ver|her|er)\S+(d|t)($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>])/ig;
const nlRegex2 = /^(aan|af|bij|binnen|los|mee|na|neer|om|onder|samen|terug|tegen|toe|uit|vast)(ge)\S+(d|t|n)($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>])/ig;

const polishParticiples = (0, _participles8.default)();

// The language-specific participle regexes.
const languageVariables$3 = {
	en: {
		regularParticiplesRegex: /\w+ed($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>])/ig
	},
	fr: {
		regularParticiplesRegex: /\S+(é|ée|és|ées)($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>])/ig
	},
	nl: {
		regularParticipleRegexPattern1: nlRegex1,
		regularParticipleRegexPattern2: nlRegex2
	}
};
const languagesWithoutRegularParticiples = ["es", "it", "pl", "pt"];

/**
 * Returns words that have been determined to be a regular participle.
 *
 * @param {string} word The word to check.
 * @param {string} language The language in which to match.
 *
 * @returns {Array} A list with the matches.
 */
const regularParticiples = function regularParticiples(word, language) {
	// In certain languages we don't match participles with a regular regex pattern.
	if (languagesWithoutRegularParticiples.includes(language)) {
		return [];
	}

	// Matches word with language-specific participle regexes.
	let matches = [];

	Object.keys(languageVariables$3[language]).forEach(function (regex) {
		const match = word.match(languageVariables$3[language][regex]);
		if (match !== null) {
			matches.push(match);
		}
	});

	matches = (0, _lodashEs$N.flattenDeep)(matches);

	return matches;
};

/**
 * Returns an array of matches of irregular participles with suffixes.
 *
 * @param {string} word The word to match on.
 * @param {Array} irregulars The list of irregulars to match.
 * @param {string} suffixes The suffixes to match the word with.
 *
 * @returns {Array} A list with matched irregular participles.
 */
const matchFrenchParticipleWithSuffix = function matchFrenchParticipleWithSuffix(word, irregulars, suffixes) {
	const matches = [];
	(0, _lodashEs$N.forEach)(irregulars, function (irregular) {
		const irregularParticiplesRegex = new RegExp("^" + irregular + suffixes + "?$", "ig");
		const participleMatch = word.match(irregularParticiplesRegex);
		if (participleMatch) {
			matches.push(participleMatch[0]);
		}
	});
	return matches;
};

/**
 * Returns the matches for a word in the list of irregulars.
 *
 * @param {string} word The word to match in the list.
 * @param {string} language The language for which to match.
 *
 * @returns {Array} A list with the matches.
 */
const irregularParticiples$1 = function irregularParticiples(word, language) {
	let matches = [];

	switch (language) {
		case "fr":
			// Match different classes of participles with suffixes.
			matches = matches.concat(matchFrenchParticipleWithSuffix(word, irregularsRegularFrench, "(e|s|es)"));
			matches = matches.concat(matchFrenchParticipleWithSuffix(word, irregularsEndingInSFrench, "(e|es)"));

			// Match irregular participles that don't require adding a suffix.
			(0, _lodashEs$N.find)(irregularsIrregularFrench, function (irregularParticiple) {
				if (irregularParticiple === word) {
					matches.push(irregularParticiple);
				}
			});
			break;
		case "es":
			// In Spanish, we only match passives from a word list.
			if ((0, _lodashEs$N.includes)(spanishParticiples, word)) {
				matches.push(word);
			}
			break;
		case "it":
			// In Italian, we only match passives from a word list.
			if ((0, _lodashEs$N.includes)(italianParticiples, word)) {
				matches.push(word);
			}
			break;
		case "nl":
			if ((0, _lodashEs$N.includes)(irregularsDutch, word)) {
				matches.push(word);
			}
			break;
		case "pl":
			// In Polish, we only match passives from a word list.
			if ((0, _lodashEs$N.includes)(polishParticiples, word)) {
				matches.push(word);
			}
			break;
		case "pt":
			// In Portuguese, we only match passives from a word list.
			if ((0, _lodashEs$N.includes)(portugueseParticiples, word)) {
				matches.push(word);
			}
			break;
		case "en":
		default:
			(0, _lodashEs$N.find)(irregularsEnglish, function (irregularParticiple) {
				if (irregularParticiple === word) {
					matches.push(irregularParticiple);
				}
			});
			break;
	}
	return matches;
};

var EnglishParticiple$1 = {};

var Participle$1 = {};

var types = {};

Object.defineProperty(types, "__esModule", {
  value: true
});
/**
 * Gets the parsed type name of subjects.
 *
 * @param {array|object|string|number} subject The subject to get the parsed type from.
 * @returns {string} The parsed type name.
 */
var getType = function getType(subject) {
  if (Array.isArray(subject)) {
    return "array";
  }
  return typeof subject;
};

/**
 * Validates the type of subjects. Throws an error if the type is invalid.
 *
 * @param {object} subject The object containing all subjects.
 * @param {string} expectedType The expected type.
 * @returns {boolean} Returns true if types matches expected type. Otherwise returns false.
 */
var isSameType = function isSameType(subject, expectedType) {
  var passedType = getType(subject);
  return passedType === expectedType;
};

types.getType = getType;
types.isSameType = isSameType;
types.default = {
  getType: getType,
  isSameType: isSameType
};

Object.defineProperty(Participle$1, "__esModule", {
  value: true
});

var _lodashEs$M = require$$1$1;

var _types = types;

/**
 * Default attributes to be used by the Participle if they are left undefined.
 * @type { { auxiliaries: array, type: string } }
 */
var defaultAttributes$1 = {
  auxiliaries: [],
  type: "",
  language: ""
};

/**
 * Validates the type of all attributes. Throws an error if the type is invalid.
 *
 * @param {object} attributes The object containing all attributes.
 * @returns {void}
 */
var validateAttributes = function validateAttributes(attributes) {
  (0, _lodashEs$M.forEach)(attributes, function (attributeValue, attributeName) {
    var expectedType = (0, _types.getType)(defaultAttributes$1[attributeName]);
    if ((0, _types.isSameType)(attributeValue, expectedType) === false) {
      throw Error("Attribute " + attributeName + " has invalid type. Expected " + expectedType + ", got " + (0, _types.getType)(attributeValue) + ".");
    }
  });
};

/**
 * Construct the Participle object and set the participle, sentence part, auxiliary and type.
 *
 * @param {string} participle The participle.
 * @param {string} sentencePart The sentence part where the participle is from.
 * @param {object} attributes The object containing all attributes.
 * @constructor
 */
var Participle = function Participle(participle, sentencePart, attributes) {
  this.setParticiple(participle);
  this.setSentencePart(sentencePart);
  this._determinesSentencePartIsPassive = false;

  attributes = attributes || {};

  (0, _lodashEs$M.defaults)(attributes, defaultAttributes$1);

  validateAttributes(attributes);

  this._attributes = attributes;
};

/**
 * Sets the participle.
 * @param {string} participle The participle.
 * @returns {void}.
 */
Participle.prototype.setParticiple = function (participle) {
  if (participle === "") {
    throw Error("The participle should not be empty.");
  }
  if (!(0, _lodashEs$M.isString)(participle)) {
    throw Error("The participle should be a string.");
  }
  this._participle = participle;
};

/**
 * Returns the participle.
 * @returns {String} The participle.
 */
Participle.prototype.getParticiple = function () {
  return this._participle;
};

/**
 * Sets the SentencePart.
 *
 * @param {string} sentencePart The sentence part.
 * @returns {void}.
 */
Participle.prototype.setSentencePart = function (sentencePart) {
  if (sentencePart === "") {
    throw Error("The sentence part should not be empty.");
  }
  this._sentencePart = sentencePart;
};

/**
 * Returns the sentence part.
 * @returns {String} The sentence part.
 */
Participle.prototype.getSentencePart = function () {
  return this._sentencePart;
};

/**
 * Returns the type.
 * @returns {String} The type.
 */
Participle.prototype.getType = function () {
  return this._attributes.type;
};

/**
 * Returns the auxiliaries.
 * @returns {String} The auxiliaries.
 */
Participle.prototype.getAuxiliaries = function () {
  return this._attributes.auxiliaries;
};

/**
 * Returns the language.
 * @returns {string} The language.
 */
Participle.prototype.getLanguage = function () {
  return this._attributes.language;
};

/**
 * Returns if the participle is passive or not.
 * @returns {boolean} True if it is passive.
 */
Participle.prototype.determinesSentencePartIsPassive = function () {
  return this._determinesSentencePartIsPassive;
};

/**
 * Determines if the sentence is passive or not.
 * @param {boolean} passive Whether the sentence part is passive.
 * @returns {void}
 */
Participle.prototype.setSentencePartPassiveness = function (passive) {
  if (!(0, _types.isSameType)(passive, "boolean")) {
    throw Error("Passiveness had invalid type. Expected boolean, got " + (0, _types.getType)(passive) + ".");
  }
  this._determinesSentencePartIsPassive = passive;
};

/**
 * Serializes the Participle instance to an object.
 *
 * @returns {Object} The serialized Participle.
 */
Participle.prototype.serialize = function () {
  return {
    _parseClass: "Participle",
    attributes: this._attributes,
    participle: this._participle,
    sentencePart: this._sentencePart,
    determinesSentencePartIsPassive: this._determinesSentencePartIsPassive
  };
};

/**
 * Parses the object to a Participle.
 *
 * @param {Object} serialized The serialized object.
 *
 * @returns {Participle} The parsed Participle.
 */
Participle.parse = function (serialized) {
  const participle = new Participle(serialized.participle, serialized.sentencePart, serialized.attributes);
  participle.setSentencePartPassiveness(serialized.determinesSentencePartIsPassive);

  return participle;
};

Participle$1.default = Participle;

var checkException = {};

Object.defineProperty(checkException, "__esModule", {
	value: true
});

checkException.default = function () {
	if ((0, _lodashEs$L.isEmpty)(this.getParticiple())) {
		this.setSentencePartPassiveness(false);
		return;
	}

	this.setSentencePartPassiveness(this.isPassive());
};

var _lodashEs$L = require$$1$1;

var nonVerbEndingEd = {};

Object.defineProperty(nonVerbEndingEd, "__esModule", {
	value: true
});

nonVerbEndingEd.default = function () {
	return ["ablebodied", "abovementioned", "absentminded", "accoladed", "accompanied", "acculturized", "accursed", "acerated", "acerbated", "acetylized", "achromatised", "achromatized", "acidified", "acned", "actualised", "adrenalised", "adulated", "adversed", "aestheticised", "affectioned", "affined", "affricated", "aforementioned", "agerelated", "aggrieved", "airbed", "aircooled", "airspeed", "alcoholized", "alcoved", "alkalised", "allianced", "aluminized", "alveolated", "ambered", "ammonified", "amplified", "anagrammatised", "anagrammatized", "anathematised", "aniseed", "ankled", "annoyed", "annualized", "anonymised", "anthologized", "antlered", "anucleated", "anviled", "anvilshaped", "apostrophised", "apostrophized", "appliqued", "apprized", "arbitrated", "armored", "articled", "ashamed", "assented", "atomised", "atrophied", "auricled", "auriculated", "aurified", "autopsied", "axled", "babied", "backhoed", "badmannered", "badtempered", "balustered", "baned", "barcoded", "bareboned", "barefooted", "barelegged", "barnacled", "based", "bayoneted", "beadyeyed", "beaked", "beaned", "beatified", "beautified", "beavered", "bed", "bedamned", "bedecked", "behoved", "belated", "bellbottomed", "bellshaped", "benighted", "bequeathed", "berried", "bespectacled", "bewhiskered", "bighearted", "bigmouthed", "bigoted", "bindweed", "binucleated", "biopsied", "bioturbed", "biped", "bipinnated", "birdfeed", "birdseed", "bisegmented", "bitterhearted", "blabbermouthed", "blackhearted", "bladed", "blankminded", "blearyeyed", "bleed", "blissed", "blobbed", "blondhaired", "bloodied", "bloodred", "bloodshed", "blueblooded", "boatshaped", "bobsled", "bodied", "boldhearted", "boogied", "boosed", "bosomed", "bottlefed", "bottlefeed", "bottlenecked", "bouldered", "bowlegged", "bowlshaped", "brandied", "bravehearted", "breastfed", "breastfeed", "breed", "brighteyed", "brindled", "broadhearted", "broadleaved", "broadminded", "brokenhearted", "broomed", "broomweed", "buccaned", "buckskinned", "bucktoothed", "buddied", "buffaloed", "bugeyed", "bugleweed", "bugweed", "bulletined", "bunked", "busied", "butterfingered", "cabbed", "caddied", "cairned", "calcified", "canalized", "candied", "cannulated", "canoed", "canopied", "canvased", "caped", "capsulated", "cassocked", "castellated", "catabolised", "catheterised", "caudated", "cellmediated", "cellulosed", "certified", "chagrined", "chambered", "chested", "chevroned", "chickenfeed", "chickenhearted", "chickweed", "chilblained", "childbed", "chinned", "chromatographed", "ciliated", "cindered", "cingulated", "circumstanced", "cisgendered", "citrullinated", "clappered", "clarified", "classified", "clawshaped", "claysized", "cleanhearted", "clearminded", "clearsighted", "cliched", "clodded", "cloistered", "closefisted", "closehearted", "closelipped", "closemouthed", "closeted", "cloudseed", "clubfooted", "clubshaped", "clued", "cockeyed", "codified", "coed", "coevolved", "coffined", "coiffed", "coinfected", "coldblooded", "coldhearted", "collateralised", "colonialised", "colorcoded", "colorised", "colourised", "columned", "commoditized", "compactified", "companioned", "complexioned", "conceited", "concerned", "concussed", "coneshaped", "congested", "contented", "convexed", "coralled", "corymbed", "cottonseed", "countrified", "countrybred", "courtmartialled", "coved", "coveralled", "cowshed", "cozied", "cragged", "crayoned", "credentialed", "creed", "crenulated", "crescentshaped", "cressweed", "crewed", "cricked", "crispated", "crossbarred", "crossbed", "crossbred", "crossbreed", "crossclassified", "crosseyed", "crossfertilised", "crossfertilized", "crossindexed", "crosslegged", "crossshaped", "crossstratified", "crossstriated", "crotched", "crucified", "cruelhearted", "crutched", "cubeshaped", "cubified", "cuckolded", "cucumbershaped", "cumbered", "cuminseed", "cupshaped", "curated", "curded", "curfewed", "curlicued", "curlycued", "curried", "curtsied", "cyclized", "cylindershaped", "damed", "dandified", "dangered", "darkhearted", "daybed", "daylighted", "deacidified", "deacylated", "deadhearted", "deadlined", "deaminized", "deathbed", "decalcified", "decertified", "deckbed", "declassified", "declutched", "decolourated", "decreed", "deed", "deeprooted", "deepseated", "defensed", "defied", "deflexed", "deglamorised", "degunkified", "dehumidified", "deified", "deled", "delegitimised", "demoded", "demystified", "denasalized", "denazified", "denied", "denitrified", "denticulated", "depressed", "deseed", "desexualised", "desposited", "detoxified", "deuced", "devitrified", "dewlapped", "dezincified", "diagonalised", "dialogued", "died", "digitated", "dignified", "dilled", "dimwitted", "diphthonged", "disaffected", "disaggregated", "disappointed", "disarrayed", "discalced", "discolorated", "discolourated", "discshaped", "diseased", "disembodied", "disencumbered", "disfranchised", "diskshaped", "disproportionated", "disproportioned", "disqualified", "distempered", "districted", "diversified", "diverticulated", "divested", "divvied", "dizzied", "dogged", "dogsbodied", "dogsled", "domeshaped", "domiciled", "dormered", "doublebarrelled", "doublestranded", "doublewalled", "downhearted", "duckbilled", "eared", "echeloned", "eddied", "edified", "eggshaped", "elasticated", "electrified", "elegized", "embed", "embodied", "emceed", "empaneled", "empanelled", "emptyhearted", "emulsified", "engined", "ennobled", "envied", "enzymecatalysed", "enzymecatalyzed", "epitomised", "epoxidized", "epoxied", "etherised", "etherized", "evilhearted", "evilminded", "exceed", "excited", "exemplified", "exponentiated", "expurgated", "extravasated", "extraverted", "extroverted", "fabled", "facelifted", "facsimiled", "fainthearted", "falcated", "falsehearted", "falsified", "famed", "fancified", "fanged", "fanshaped", "fantasied", "farsighted", "fated", "fatted", "fazed", "featherbed", "fed", "federalized", "feeblehearted", "feebleminded", "feeblewitted", "feed", "fendered", "fenestrated", "ferried", "fevered", "fibered", "fibred", "ficklehearted", "fiercehearted", "figged", "filigreed", "filterfeed", "fireweed", "firmhearted", "fissured", "flanged", "flanneled", "flannelled", "flatbed", "flatfooted", "flatted", "flawed", "flaxenhaired", "flaxseed", "flaxweed", "flighted", "floodgenerated", "flowerbed", "fluidised", "fluidized", "flurried", "fobbed", "fonded", "forcefeed", "foreshortened", "foresighted", "forkshaped", "formfeed", "fortified", "fortressed", "foulmouthed", "foureyed", "foxtailed", "fractionalised", "fractionalized", "frankhearted", "freed", "freehearted", "freespirited", "frenzied", "friezed", "frontiered", "fructified", "frumped", "fullblooded", "fullbodied", "fullfledged", "fullhearted", "funnelshaped", "furnaced", "gaitered", "galleried", "gangliated", "ganglionated", "gangrened", "gargoyled", "gasified", "gaunted", "gauntleted", "gauzed", "gavelled", "gelatinised", "gemmed", "genderized", "gentled", "gentlehearted", "gerrymandered", "gladhearted", "glamored", "globed", "gloried", "glorified", "glycosylated", "goateed", "gobletshaped", "godspeed", "goodhearted", "goodhumored", "goodhumoured", "goodnatured", "goodtempered", "goosed", "goosenecked", "goutweed", "grainfed", "grammaticalized", "grapeseed", "gratified", "graved", "gravelbed", "grayhaired", "greathearted", "greed", "greenweed", "grommeted", "groundspeed", "groved", "gruffed", "guiled", "gulled", "gumshoed", "gunkholed", "gussied", "guyed", "gyrostabilized", "hackneyed", "hagged", "haired", "halfcivilized", "halfhearted", "halfwitted", "haloed", "handballed", "handfed", "handfeed", "hardcoded", "hardhearted", "hardnosed", "hared", "harelipped", "hasted", "hatred", "haunched", "hawkeyed", "hayseed", "hayweed", "hearsed", "hearted", "heartshaped", "heavenlyminded", "heavyfooted", "heavyhearted", "heed", "heired", "heisted", "helicoptered", "helmed", "helmeted", "hemagglutinated", "hemolyzed", "hempseed", "hempweed", "heparinised", "heparinized", "herbed", "highheeled", "highminded", "highpriced", "highspeed", "highspirited", "hilled", "hipped", "hispanicised", "hocked", "hoed", "hogweed", "holstered", "homaged", "hoodooed", "hoofed", "hooknosed", "hooved", "horned", "horrified", "horseshoed", "horseweed", "hotbed", "hotblooded", "hothearted", "hotted", "hottempered", "hued", "humansized", "humidified", "humped", "hundred", "hutched", "hyperinflated", "hyperpigmented", "hyperstimulated", "hypertrophied", "hyphened", "hypophysectomised", "hypophysectomized", "hypopigmented", "hypostatised", "hysterectomized", "iconified", "iconised", "iconized", "ideologised", "illbred", "illconceived", "illdefined", "illdisposed", "illequipped", "illfated", "illfavored", "illfavoured", "illflavored", "illfurnished", "illhumored", "illhumoured", "illimited", "illmannered", "illnatured", "illomened", "illproportioned", "illqualified", "illscented", "illtempered", "illumed", "illusioned", "imbed", "imbossed", "imbued", "immatured", "impassioned", "impenetrated", "imperfected", "imperialised", "imperturbed", "impowered", "imputed", "inarticulated", "inbred", "inbreed", "incapsulated", "incased", "incrustated", "incrusted", "indebted", "indeed", "indemnified", "indentured", "indigested", "indisposed", "inexperienced", "infrared", "intensified", "intentioned", "interbedded", "interbred", "interbreed", "interluded", "introverted", "inured", "inventoried", "iodinated", "iodised", "irked", "ironfisted", "ironweed", "itchweed", "ivied", "ivyweed", "jagged", "jellified", "jerseyed", "jetlagged", "jetpropelled", "jeweled", "jewelled", "jewelweed", "jiggered", "jimmyweed", "jimsonweed", "jointweed", "joyweed", "jungled", "juried", "justiceweed", "justified", "karstified", "kerchiefed", "kettleshaped", "kibbled", "kidneyshaped", "kimonoed", "kindhearted", "kindred", "kingsized", "kirtled", "knacked", "knapweed", "kneed", "knobbed", "knobweed", "knopweed", "knotweed", "lakebed", "lakeweed", "lamed", "lamellated", "lanceshaped", "lanceted", "landbased", "lapeled", "lapelled", "largehearted", "lariated", "lased", "latticed", "lauded", "lavaged", "lavendered", "lawned", "led", "lefteyed", "legitimatised", "legitimatized", "leisured", "lensshaped", "leveed", "levied", "lichened", "lichenized", "lidded", "lifesized", "lightfingered", "lightfooted", "lighthearted", "lightminded", "lightspeed", "lignified", "likeminded", "lilylivered", "limbed", "linearised", "linearized", "linefeed", "linseed", "lionhearted", "liquefied", "liquified", "lithified", "liveried", "lobbied", "located", "locoweed", "longarmed", "longhaired", "longhorned", "longlegged", "longnecked", "longsighted", "longwinded", "lopsided", "loudmouthed", "louvered", "louvred", "lowbred", "lowpriced", "lowspirited", "lozenged", "lunated", "lyrated", "lysinated", "maced", "macroaggregated", "macrodissected", "maculated", "madweed", "magnified", "maidenweed", "maladapted", "maladjusted", "malnourished", "malrotated", "maned", "mannered", "manuevered", "manyhued", "manyshaped", "manysided", "masted", "mealymouthed", "meanspirited", "membered", "membraned", "metaled", "metalized", "metallised", "metallized", "metamerized", "metathesized", "meted", "methylated", "mettled", "microbrecciated", "microminiaturized", "microstratified", "middleaged", "midsized", "miffed", "mildhearted", "milkweed", "miniskirted", "misactivated", "misaligned", "mischiefed", "misclassified", "misdeed", "misdemeaned", "mismannered", "misnomered", "misproportioned", "miswired", "mitred", "mitted", "mittened", "moneyed", "monocled", "mononucleated", "monospaced", "monotoned", "monounsaturated", "mortified", "moseyed", "motorised", "motorized", "moussed", "moustached", "muddied", "mugweed", "multiarmed", "multibarreled", "multibladed", "multicelled", "multichambered", "multichanneled", "multichannelled", "multicoated", "multidirected", "multiengined", "multifaceted", "multilaminated", "multilaned", "multilayered", "multilobed", "multilobulated", "multinucleated", "multipronged", "multisegmented", "multisided", "multispeed", "multistemmed", "multistoried", "multitalented", "multitoned", "multitowered", "multivalued", "mummied", "mummified", "mustached", "mustachioed", "mutinied", "myelinated", "mystified", "mythicised", "naked", "narcotised", "narrowminded", "natured", "neaped", "nearsighted", "necrosed", "nectared", "need", "needleshaped", "newfangled", "newlywed", "nibbed", "nimblewitted", "nippled", "nixed", "nobled", "noduled", "noised", "nonaccented", "nonactivated", "nonadsorbed", "nonadulterated", "nonaerated", "nonaffiliated", "nonaliased", "nonalienated", "nonaligned", "nonarchived", "nonarmored", "nonassociated", "nonattenuated", "nonblackened", "nonbreastfed", "nonbrecciated", "nonbuffered", "nonbuttered", "noncarbonated", "noncarbonized", "noncatalogued", "noncatalyzed", "noncategorized", "noncertified", "nonchlorinated", "nonciliated", "noncircumcised", "noncivilized", "nonclassified", "noncoated", "noncodified", "noncoerced", "noncommercialized", "noncommissioned", "noncompacted", "noncompiled", "noncomplicated", "noncomposed", "noncomputed", "noncomputerized", "nonconcerted", "nonconditioned", "nonconfirmed", "noncongested", "nonconjugated", "noncooled", "noncorrugated", "noncoupled", "noncreated", "noncrowded", "noncultured", "noncurated", "noncushioned", "nondecoded", "nondecomposed", "nondedicated", "nondeferred", "nondeflated", "nondegenerated", "nondegraded", "nondelegated", "nondelimited", "nondelineated", "nondemarcated", "nondeodorized", "nondeployed", "nonderivatized", "nonderived", "nondetached", "nondetailed", "nondifferentiated", "nondigested", "nondigitized", "nondilapidated", "nondilated", "nondimensionalised", "nondimensionalized", "nondirected", "nondisabled", "nondisciplined", "nondispersed", "nondisputed", "nondisqualified", "nondisrupted", "nondisseminated", "nondissipated", "nondissolved", "nondistressed", "nondistributed", "nondiversified", "nondiverted", "nondocumented", "nondomesticated", "nondoped", "nondrafted", "nondrugged", "nondubbed", "nonducted", "nonearthed", "noneclipsed", "nonedged", "nonedited", "nonelasticized", "nonelectrified", "nonelectroplated", "nonelectroporated", "nonelevated", "noneliminated", "nonelongated", "nonembedded", "nonembodied", "nonemphasized", "nonencapsulated", "nonencoded", "nonencrypted", "nonendangered", "nonengraved", "nonenlarged", "nonenriched", "nonentangled", "nonentrenched", "nonepithelized", "nonequilibrated", "nonestablished", "nonetched", "nonethoxylated", "nonethylated", "nonetiolated", "nonexaggerated", "nonexcavated", "nonexhausted", "nonexperienced", "nonexpired", "nonfabricated", "nonfalsified", "nonfeathered", "nonfeatured", "nonfed", "nonfederated", "nonfeed", "nonfenestrated", "nonfertilized", "nonfilamented", "nonfinanced", "nonfinished", "nonfinned", "nonfissured", "nonflagellated", "nonflagged", "nonflared", "nonflavored", "nonfluidized", "nonfluorinated", "nonfluted", "nonforested", "nonformalized", "nonformatted", "nonfragmented", "nonfragranced", "nonfranchised", "nonfreckled", "nonfueled", "nonfumigated", "nonfunctionalized", "nonfunded", "nongalvanized", "nongated", "nongelatinized", "nongendered", "nongeneralized", "nongenerated", "nongifted", "nonglazed", "nonglucosated", "nonglucosylated", "nonglycerinated", "nongraded", "nongrounded", "nonhalogenated", "nonhandicapped", "nonhospitalised", "nonhospitalized", "nonhydrated", "nonincorporated", "nonindexed", "noninfected", "noninfested", "noninitialized", "noninitiated", "noninoculated", "noninseminated", "noninstitutionalized", "noninsured", "nonintensified", "noninterlaced", "noninterpreted", "nonintroverted", "noninvestigated", "noninvolved", "nonirrigated", "nonisolated", "nonisomerized", "nonissued", "nonitalicized", "nonitemized", "noniterated", "nonjaded", "nonlabelled", "nonlaminated", "nonlateralized", "nonlayered", "nonlegalized", "nonlegislated", "nonlesioned", "nonlexicalized", "nonliberated", "nonlichenized", "nonlighted", "nonlignified", "nonlimited", "nonlinearized", "nonlinked", "nonlobed", "nonlobotomized", "nonlocalized", "nonlysed", "nonmachined", "nonmalnourished", "nonmandated", "nonmarginalized", "nonmassaged", "nonmatriculated", "nonmatted", "nonmatured", "nonmechanized", "nonmedicated", "nonmedullated", "nonmentioned", "nonmetabolized", "nonmetallized", "nonmetastasized", "nonmetered", "nonmethoxylated", "nonmilled", "nonmineralized", "nonmirrored", "nonmodeled", "nonmoderated", "nonmodified", "nonmonetized", "nonmonitored", "nonmortgaged", "nonmotorized", "nonmottled", "nonmounted", "nonmultithreaded", "nonmutilated", "nonmyelinated", "nonnormalized", "nonnucleated", "nonobjectified", "nonobligated", "nonoccupied", "nonoiled", "nonopinionated", "nonoxygenated", "nonpaginated", "nonpaired", "nonparalyzed", "nonparameterized", "nonparasitized", "nonpasteurized", "nonpatterned", "nonphased", "nonphosphatized", "nonphosphorized", "nonpierced", "nonpigmented", "nonpiloted", "nonpipelined", "nonpitted", "nonplussed", "nonpuffed", "nonrandomized", "nonrated", "nonrefined", "nonregistered", "nonregulated", "nonrelated", "nonretarded", "nonsacred", "nonsalaried", "nonsanctioned", "nonsaturated", "nonscented", "nonscheduled", "nonseasoned", "nonsecluded", "nonsegmented", "nonsegregated", "nonselected", "nonsolidified", "nonspecialized", "nonspored", "nonstandardised", "nonstandardized", "nonstratified", "nonstressed", "nonstriated", "nonstriped", "nonstructured", "nonstylised", "nonstylized", "nonsubmerged", "nonsubscripted", "nonsubsidised", "nonsubsidized", "nonsubstituted", "nonsyndicated", "nonsynthesised", "nontabulated", "nontalented", "nonthreaded", "nontinted", "nontolerated", "nontranslated", "nontunnelled", "nonunified", "nonunionised", "nonupholstered", "nonutilised", "nonutilized", "nonvalued", "nonvaried", "nonverbalized", "nonvitrified", "nonvolatilised", "nonvolatilized", "normed", "nosebleed", "notated", "notified", "nuanced", "nullified", "numerated", "oarweed", "objectified", "obliqued", "obtunded", "occupied", "octupled", "odored", "oilseed", "oinked", "oldfashioned", "onesided", "oophorectomized", "opaqued", "openhearted", "openminded", "openmouthed", "opiated", "opinionated", "oracled", "oreweed", "ossified", "outbreed", "outmoded", "outrigged", "outriggered", "outsized", "outskated", "outspeed", "outtopped", "outtrumped", "outvoiced", "outweed", "ovated", "overadorned", "overaged", "overalled", "overassured", "overbred", "overbreed", "overcomplicated", "overdamped", "overdetailed", "overdiversified", "overdyed", "overequipped", "overfatigued", "overfed", "overfeed", "overindebted", "overintensified", "overinventoried", "overmagnified", "overmodified", "overpreoccupied", "overprivileged", "overproportionated", "overqualified", "overseed", "oversexed", "oversimplified", "oversized", "oversophisticated", "overstudied", "oversulfated", "ovicelled", "ovoidshaped", "ozonated", "pacified", "packeted", "palatalized", "paled", "palsied", "paned", "panicled", "parabled", "parallelepiped", "parallelized", "parallelopiped", "parenthesised", "parodied", "parqueted", "passioned", "paunched", "pauperised", "pedigreed", "pedimented", "pedunculated", "pegged", "peglegged", "penanced", "pencilshaped", "permineralized", "personified", "petrified", "photodissociated", "photoduplicated", "photoed", "photoinduced", "photolysed", "photolyzed", "pied", "pigeoned", "pigtailed", "pigweed", "pilastered", "pillared", "pilloried", "pimpled", "pinealectomised", "pinealectomized", "pinfeathered", "pinnacled", "pinstriped", "pixellated", "pixilated", "pixillated", "plainclothed", "plantarflexed", "pled", "plumaged", "pocked", "pokeweed", "polychlorinated", "polyunsaturated", "ponytailed", "pooched", "poorspirited", "popeyed", "poppyseed", "porcelainized", "porched", "poshed", "pottered", "poxed", "preachified", "precertified", "preclassified", "preconized", "preinoculated", "premed", "prenotified", "preoccupied", "preposed", "prequalified", "preshaped", "presignified", "prespecified", "prettified", "pried", "principled", "proceed", "prophesied", "propounded", "prosed", "protonated", "proudhearted", "proxied", "pulpified", "pumpkinseed", "puppied", "purebred", "pured", "pureed", "purified", "pustuled", "putrefied", "pyjamaed", "quadruped", "qualified", "quantified", "quantised", "quantized", "quarried", "queried", "questoned", "quicktempered", "quickwitted", "quiesced", "quietened", "quizzified", "racemed", "radiosensitised", "ragweed", "raindrenched", "ramped", "rapeseed", "rarefied", "rarified", "ratified", "razoredged", "reaccelerated", "reaccompanied", "reachieved", "reacknowledged", "readdicted", "readied", "reamplified", "reannealed", "reassociated", "rebadged", "rebiopsied", "recabled", "recategorised", "receipted", "recentred", "recertified", "rechoreographed", "reclarified", "reclassified", "reconferred", "recrystalized", "rectified", "recursed", "red", "redblooded", "redefied", "redenied", "rednecked", "redshifted", "redweed", "redyed", "reed", "reembodied", "reenlighted", "refeed", "refereed", "reflexed", "refortified", "refronted", "refuged", "reglorified", "reimpregnated", "reinitialized", "rejustified", "related", "reliquefied", "remedied", "remodified", "remonetized", "remythologized", "renotified", "renullified", "renumerated", "reoccupied", "repacified", "repurified", "reputed", "requalified", "rescinded", "reseed", "reshoed", "resolidified", "resorbed", "respecified", "restudied", "retabulated", "reticulated", "retinted", "retreed", "retroacted", "reunified", "reverified", "revested", "revivified", "rewed", "ridgepoled", "riffled", "rightminded", "rigidified", "rinded", "riped", "rited", "ritualised", "riverbed", "rivered", "roached", "roadbed", "robotised", "robotized", "romanized", "rosetted", "rosined", "roughhearted", "rubied", "ruddied", "runcinated", "russeted", "sabled", "sabred", "sabretoothed", "sacheted", "sacred", "saddlebred", "sainted", "salaried", "samoyed", "sanctified", "satellited", "savvied", "sawtoothed", "scandalled", "scarified", "scarped", "sceptred", "scissored", "screed", "screwshaped", "scrupled", "sculked", "scurried", "scuttled", "seabed", "seaweed", "seed", "seedbed", "selfassured", "selforganized", "semicivilized", "semidetached", "semidisassembled", "semidomesticated", "semipetrified", "semipronated", "semirefined", "semivitrified", "sentineled", "sepaled", "sepalled", "sequinned", "sexed", "shagged", "shaggycoated", "shaggyhaired", "shaled", "shammed", "sharpangled", "sharpclawed", "sharpcornered", "sharpeared", "sharpedged", "sharpeyed", "sharpflavored", "sharplimbed", "sharpnosed", "sharpsighted", "sharptailed", "sharptongued", "sharptoothed", "sharpwitted", "sharpworded", "shed", "shellbed", "shieldshaped", "shimmied", "shinned", "shirted", "shirtsleeved", "shoed", "shortbeaked", "shortbilled", "shortbodied", "shorthaired", "shortlegged", "shortlimbed", "shortnecked", "shortnosed", "shortsighted", "shortsleeved", "shortsnouted", "shortstaffed", "shorttailed", "shorttempered", "shorttoed", "shorttongued", "shortwinded", "shortwinged", "shotted", "shred", "shrewsized", "shrined", "shrinkproofed", "sickbed", "sickleshaped", "sickleweed", "signalised", "signified", "silicified", "siliconized", "silkweed", "siltsized", "silvertongued", "simpleminded", "simplified", "singlebarreled", "singlebarrelled", "singlebed", "singlebladed", "singlebreasted", "singlecelled", "singlefooted", "singlelayered", "singleminded", "singleseeded", "singleshelled", "singlestranded", "singlevalued", "sissified", "sistered", "sixgilled", "sixmembered", "sixsided", "sixstoried", "skulled", "slickered", "slipcased", "slowpaced", "slowwitted", "slurried", "smallminded", "smoothened", "smoothtongued", "snaggletoothed", "snouted", "snowballed", "snowcapped", "snowshed", "snowshoed", "snubnosed", "so-called", "sofabed", "softhearted", "sogged", "soled", "solidified", "soliped", "sorbed", "souled", "spearshaped", "specified", "spectacled", "sped", "speeched", "speechified", "speed", "spied", "spiffied", "spindleshaped", "spiritualised", "spirted", "splayfooted", "spoonfed", "spoonfeed", "spoonshaped", "spreadeagled", "squarejawed", "squareshaped", "squareshouldered", "squaretoed", "squeegeed", "staled", "starshaped", "starspangled", "starstudded", "statechartered", "statesponsored", "statued", "steadied", "steampowered", "steed", "steelhearted", "steepled", "sterned", "stiffnecked", "stilettoed", "stimied", "stinkweed", "stirrupshaped", "stockinged", "storeyed", "storied", "stouthearted", "straitlaced", "stratified", "strawberryflavored", "streambed", "stressinduced", "stretchered", "strictured", "strongbodied", "strongboned", "strongflavored", "stronghearted", "stronglimbed", "strongminded", "strongscented", "strongwilled", "stubbled", "studied", "stultified", "stupefied", "styed", "stymied", "subclassified", "subcommissioned", "subminiaturised", "subsaturated", "subulated", "suburbanised", "suburbanized", "suburbed", "succeed", "sueded", "sugarrelated", "sulfurized", "sunbed", "superhardened", "superinfected", "supersimplified", "surefooted", "sweetscented", "swifted", "swordshaped", "syllabified", "syphilized", "tabularized", "talented", "tarpapered", "tautomerized", "teated", "teed", "teenaged", "teetotaled", "tenderhearted", "tentacled", "tenured", "termed", "ternated", "testbed", "testified", "theatricalised", "theatricalized", "themed", "thicketed", "thickskinned", "thickwalled", "thighed", "thimbled", "thimblewitted", "thonged", "thoroughbred", "thralled", "threated", "throated", "throughbred", "thyroidectomised", "thyroidectomized", "tiaraed", "ticktocked", "tidied", "tightassed", "tightfisted", "tightlipped", "timehonoured", "tindered", "tined", "tinselled", "tippytoed", "tiptoed", "titled", "toed", "tomahawked", "tonged", "toolshed", "toothplated", "toplighted", "torchlighted", "toughhearted", "traditionalized", "trajected", "tranced", "transgendered", "transliterated", "translocated", "transmogrified", "treadled", "treed", "treelined", "tressed", "trialled", "triangled", "trifoliated", "trifoliolated", "trilobed", "trucklebed", "truehearted", "trumpetshaped", "trumpetweed", "tuberculated", "tumbleweed", "tunnelshaped", "turbaned", "turreted", "turtlenecked", "tuskshaped", "tweed", "twigged", "typified", "ulcered", "ultracivilised", "ultracivilized", "ultracooled", "ultradignified", "ultradispersed", "ultrafiltered", "ultrared", "ultrasimplified", "ultrasophisticated", "unabandoned", "unabashed", "unabbreviated", "unabetted", "unabolished", "unaborted", "unabraded", "unabridged", "unabsolved", "unabsorbed", "unaccelerated", "unaccented", "unaccentuated", "unacclimatised", "unacclimatized", "unaccompanied", "unaccomplished", "unaccosted", "unaccredited", "unaccrued", "unaccumulated", "unaccustomed", "unacidulated", "unacquainted", "unacquitted", "unactivated", "unactuated", "unadapted", "unaddicted", "unadjourned", "unadjudicated", "unadjusted", "unadmonished", "unadopted", "unadored", "unadorned", "unadsorbed", "unadulterated", "unadvertised", "unaerated", "unaffiliated", "unaggregated", "unagitated", "unaimed", "unaired", "unaliased", "unalienated", "unaligned", "unallocated", "unalloyed", "unalphabetized", "unamassed", "unamortized", "unamplified", "unanaesthetised", "unanaesthetized", "unaneled", "unanesthetised", "unanesthetized", "unangered", "unannealed", "unannexed", "unannihilated", "unannotated", "unanointed", "unanticipated", "unappareled", "unappendaged", "unapportioned", "unapprenticed", "unapproached", "unappropriated", "unarbitrated", "unarched", "unarchived", "unarmored", "unarmoured", "unarticulated", "unascertained", "unashamed", "unaspirated", "unassembled", "unasserted", "unassessed", "unassociated", "unassorted", "unassuaged", "unastonished", "unastounded", "unatoned", "unattained", "unattainted", "unattenuated", "unattributed", "unauctioned", "unaudited", "unauthenticated", "unautographed", "unaverted", "unawaked", "unawakened", "unawarded", "unawed", "unbaffled", "unbaited", "unbalconied", "unbanded", "unbanished", "unbaptised", "unbaptized", "unbarreled", "unbarrelled", "unbattered", "unbeaded", "unbearded", "unbeneficed", "unbesotted", "unbetrayed", "unbetrothed", "unbiased", "unbiassed", "unbigoted", "unbilled", "unblackened", "unblanketed", "unblasphemed", "unblazoned", "unblistered", "unblockaded", "unbloodied", "unbodied", "unbonded", "unbothered", "unbounded", "unbracketed", "unbranded", "unbreaded", "unbrewed", "unbridged", "unbridled", "unbroached", "unbudgeted", "unbuffed", "unbuffered", "unburnished", "unbutchered", "unbuttered", "uncached", "uncaked", "uncalcified", "uncalibrated", "uncamouflaged", "uncamphorated", "uncanceled", "uncancelled", "uncapitalized", "uncarbonated", "uncarpeted", "uncased", "uncashed", "uncastrated", "uncatalogued", "uncatalysed", "uncatalyzed", "uncategorised", "uncatered", "uncaulked", "uncelebrated", "uncensored", "uncensured", "uncertified", "unchambered", "unchanneled", "unchannelled", "unchaperoned", "uncharacterized", "uncharted", "unchartered", "unchastened", "unchastised", "unchelated", "uncherished", "unchilled", "unchristened", "unchronicled", "uncircumcised", "uncircumscribed", "uncited", "uncivilised", "uncivilized", "unclarified", "unclassed", "unclassified", "uncleaved", "unclimbed", "unclustered", "uncluttered", "uncoagulated", "uncoded", "uncodified", "uncoerced", "uncoined", "uncollapsed", "uncollated", "uncolonised", "uncolonized", "uncolumned", "uncombined", "uncommented", "uncommercialised", "uncommercialized", "uncommissioned", "uncommitted", "uncompacted", "uncompartmentalized", "uncompartmented", "uncompensated", "uncompiled", "uncomplicated", "uncompounded", "uncomprehened", "uncomputed", "unconcealed", "unconceded", "unconcluded", "uncondensed", "unconditioned", "unconfined", "unconfirmed", "uncongested", "unconglomerated", "uncongratulated", "unconjugated", "unconquered", "unconsecrated", "unconsoled", "unconsolidated", "unconstipated", "unconstricted", "unconstructed", "unconsumed", "uncontacted", "uncontracted", "uncontradicted", "uncontrived", "unconverted", "unconveyed", "unconvicted", "uncooked", "uncooled", "uncoordinated", "uncopyrighted", "uncored", "uncorrelated", "uncorroborated", "uncosted", "uncounseled", "uncounselled", "uncounterfeited", "uncoveted", "uncrafted", "uncramped", "uncrannied", "uncrazed", "uncreamed", "uncreased", "uncreated", "uncredentialled", "uncredited", "uncrested", "uncrevassed", "uncrippled", "uncriticised", "uncriticized", "uncropped", "uncrosslinked", "uncrowded", "uncrucified", "uncrumbled", "uncrystalized", "uncrystallised", "uncrystallized", "uncubed", "uncuddled", "uncued", "unculled", "uncultivated", "uncultured", "uncupped", "uncurated", "uncurbed", "uncurried", "uncurtained", "uncushioned", "undamped", "undampened", "undappled", "undarkened", "undated", "undaubed", "undazzled", "undeadened", "undeafened", "undebated", "undebunked", "undeceased", "undecimalized", "undeciphered", "undecked", "undeclared", "undecomposed", "undeconstructed", "undedicated", "undefeated", "undeferred", "undefied", "undefined", "undeflected", "undefrauded", "undefrayed", "undegassed", "undejected", "undelegated", "undeleted", "undelimited", "undelineated", "undemented", "undemolished", "undemonstrated", "undenatured", "undenied", "undented", "undeodorized", "undepicted", "undeputized", "underaged", "underarmed", "underassessed", "underbred", "underbudgeted", "undercapitalised", "undercapitalized", "underdiagnosed", "underdocumented", "underequipped", "underexploited", "underexplored", "underfed", "underfeed", "underfurnished", "undergoverned", "undergrazed", "underinflated", "underinsured", "underinvested", "underived", "undermaintained", "undermentioned", "undermotivated", "underperceived", "underpowered", "underprivileged", "underqualified", "underrehearsed", "underresourced", "underripened", "undersaturated", "undersexed", "undersized", "underspecified", "understaffed", "understocked", "understressed", "understudied", "underutilised", "underventilated", "undescaled", "undesignated", "undetached", "undetailed", "undetained", "undeteriorated", "undeterred", "undetonated", "undevised", "undevoted", "undevoured", "undiagnosed", "undialed", "undialysed", "undialyzed", "undiapered", "undiffracted", "undigested", "undignified", "undiluted", "undiminished", "undimmed", "undipped", "undirected", "undisciplined", "undiscouraged", "undiscussed", "undisfigured", "undisguised", "undisinfected", "undismayed", "undisposed", "undisproved", "undisputed", "undisrupted", "undissembled", "undissipated", "undissociated", "undissolved", "undistilled", "undistorted", "undistracted", "undistributed", "undisturbed", "undiversified", "undiverted", "undivulged", "undoctored", "undocumented", "undomesticated", "undosed", "undramatised", "undrilled", "undrugged", "undubbed", "unduplicated", "uneclipsed", "unedged", "unedited", "unejaculated", "unejected", "unelaborated", "unelapsed", "unelected", "unelectrified", "unelevated", "unelongated", "unelucidated", "unemaciated", "unemancipated", "unemasculated", "unembalmed", "unembed", "unembellished", "unembodied", "unemboldened", "unemerged", "unenacted", "unencoded", "unencrypted", "unencumbered", "unendangered", "unendorsed", "unenergized", "unenfranchised", "unengraved", "unenhanced", "unenlarged", "unenlivened", "unenraptured", "unenriched", "unentangled", "unentitled", "unentombed", "unentranced", "unentwined", "unenumerated", "unenveloped", "unenvied", "unequaled", "unequalised", "unequalized", "unequalled", "unequipped", "unerased", "unerected", "uneroded", "unerupted", "unescorted", "unestablished", "unevaluated", "unexaggerated", "unexampled", "unexcavated", "unexceeded", "unexcelled", "unexecuted", "unexerted", "unexhausted", "unexpensed", "unexperienced", "unexpired", "unexploited", "unexplored", "unexposed", "unexpurgated", "unextinguished", "unfabricated", "unfaceted", "unfanned", "unfashioned", "unfathered", "unfathomed", "unfattened", "unfavored", "unfavoured", "unfazed", "unfeathered", "unfed", "unfeigned", "unfermented", "unfertilised", "unfertilized", "unfilleted", "unfiltered", "unfinished", "unflavored", "unflavoured", "unflawed", "unfledged", "unfleshed", "unflurried", "unflushed", "unflustered", "unfluted", "unfocussed", "unforested", "unformatted", "unformulated", "unfortified", "unfractionated", "unfractured", "unfragmented", "unfrequented", "unfretted", "unfrosted", "unfueled", "unfunded", "unfurnished", "ungarbed", "ungarmented", "ungarnished", "ungeared", "ungerminated", "ungifted", "unglazed", "ungoverned", "ungraded", "ungrasped", "ungratified", "ungroomed", "ungrounded", "ungrouped", "ungummed", "ungusseted", "unhabituated", "unhampered", "unhandicapped", "unhardened", "unharvested", "unhasped", "unhatched", "unheralded", "unhindered", "unhomogenised", "unhomogenized", "unhonored", "unhonoured", "unhooded", "unhusked", "unhyphenated", "unified", "unillustrated", "unimpacted", "unimpaired", "unimpassioned", "unimpeached", "unimpelled", "unimplemented", "unimpregnated", "unimprisoned", "unimpugned", "unincorporated", "unincubated", "unincumbered", "unindemnified", "unindexed", "unindicted", "unindorsed", "uninduced", "unindustrialised", "unindustrialized", "uninebriated", "uninfected", "uninflated", "uninflected", "uninhabited", "uninhibited", "uninitialised", "uninitialized", "uninitiated", "uninoculated", "uninseminated", "uninsulated", "uninsured", "uninterpreted", "unintimidated", "unintoxicated", "unintroverted", "uninucleated", "uninverted", "uninvested", "uninvolved", "unissued", "unjaundiced", "unjointed", "unjustified", "unkeyed", "unkindled", "unlabelled", "unlacquered", "unlamented", "unlaminated", "unlarded", "unlaureled", "unlaurelled", "unleaded", "unleavened", "unled", "unlettered", "unlicenced", "unlighted", "unlimbered", "unlimited", "unlined", "unlipped", "unliquidated", "unlithified", "unlittered", "unliveried", "unlobed", "unlocalised", "unlocalized", "unlocated", "unlogged", "unlubricated", "unmagnified", "unmailed", "unmaimed", "unmaintained", "unmalted", "unmangled", "unmanifested", "unmanipulated", "unmannered", "unmanufactured", "unmapped", "unmarred", "unmastered", "unmatriculated", "unmechanised", "unmechanized", "unmediated", "unmedicated", "unmentioned", "unmerged", "unmerited", "unmetabolised", "unmetabolized", "unmetamorphosed", "unmethylated", "unmineralized", "unmitigated", "unmoderated", "unmodernised", "unmodernized", "unmodified", "unmodulated", "unmolded", "unmolested", "unmonitored", "unmortgaged", "unmotivated", "unmotorised", "unmotorized", "unmounted", "unmutated", "unmutilated", "unmyelinated", "unnaturalised", "unnaturalized", "unnotched", "unnourished", "unobligated", "unobstructed", "unoccupied", "unoiled", "unopposed", "unoptimised", "unordained", "unorganised", "unorganized", "unoriented", "unoriginated", "unornamented", "unoxidized", "unoxygenated", "unpacified", "unpackaged", "unpaired", "unparalleled", "unparallelled", "unparasitized", "unpardoned", "unparodied", "unpartitioned", "unpasteurised", "unpasteurized", "unpatented", "unpaved", "unpedigreed", "unpenetrated", "unpenned", "unperfected", "unperjured", "unpersonalised", "unpersuaded", "unperturbed", "unperverted", "unpestered", "unphosphorylated", "unphotographed", "unpigmented", "unpiloted", "unpledged", "unploughed", "unplumbed", "unpoised", "unpolarized", "unpoliced", "unpolled", "unpopulated", "unposed", "unpowered", "unprecedented", "unpredicted", "unprejudiced", "unpremeditated", "unprescribed", "unpressurised", "unpressurized", "unpriced", "unprimed", "unprincipled", "unprivileged", "unprized", "unprocessed", "unprofaned", "unprofessed", "unprohibited", "unprompted", "unpronounced", "unproposed", "unprospected", "unproved", "unpruned", "unpublicised", "unpublicized", "unpublished", "unpuckered", "unpunctuated", "unpurified", "unqualified", "unquantified", "unquenched", "unquoted", "unranked", "unrated", "unratified", "unrebuked", "unreckoned", "unrecompensed", "unreconciled", "unreconstructed", "unrectified", "unredeemed", "unrefined", "unrefreshed", "unrefrigerated", "unregarded", "unregimented", "unregistered", "unregulated", "unrehearsed", "unrelated", "unrelieved", "unrelinquished", "unrenewed", "unrented", "unrepealed", "unreplicated", "unreprimanded", "unrequited", "unrespected", "unrestricted", "unretained", "unretarded", "unrevised", "unrevived", "unrevoked", "unrifled", "unripened", "unrivaled", "unrivalled", "unroasted", "unroofed", "unrounded", "unruffled", "unsalaried", "unsalted", "unsanctified", "unsanctioned", "unsanded", "unsaponified", "unsated", "unsatiated", "unsatisfied", "unsaturated", "unscaled", "unscarred", "unscathed", "unscented", "unscheduled", "unschooled", "unscreened", "unscripted", "unseamed", "unseared", "unseasoned", "unseeded", "unsegmented", "unsegregated", "unselected", "unserviced", "unsexed", "unshamed", "unshaped", "unsharpened", "unsheared", "unshielded", "unshifted", "unshirted", "unshoed", "unshuttered", "unsifted", "unsighted", "unsilenced", "unsimplified", "unsized", "unskewed", "unskinned", "unslaked", "unsliced", "unsloped", "unsmoothed", "unsoiled", "unsoldered", "unsolicited", "unsolved", "unsophisticated", "unsorted", "unsourced", "unsoured", "unspaced", "unspanned", "unspecialised", "unspecialized", "unspecified", "unspiced", "unstaged", "unstandardised", "unstandardized", "unstapled", "unstarched", "unstarred", "unstated", "unsteadied", "unstemmed", "unsterilised", "unsterilized", "unstickered", "unstiffened", "unstifled", "unstigmatised", "unstigmatized", "unstilted", "unstippled", "unstipulated", "unstirred", "unstocked", "unstoked", "unstoppered", "unstratified", "unstressed", "unstriped", "unstructured", "unstudied", "unstumped", "unsubdued", "unsubmitted", "unsubsidised", "unsubsidized", "unsubstantiated", "unsubstituted", "unsugared", "unsummarized", "unsupervised", "unsuprised", "unsurveyed", "unswayed", "unsweetened", "unsyllabled", "unsymmetrized", "unsynchronised", "unsynchronized", "unsyncopated", "unsyndicated", "unsynthesized", "unsystematized", "untagged", "untainted", "untalented", "untanned", "untaped", "untapered", "untargeted", "untarnished", "untattooed", "untelevised", "untempered", "untenanted", "unterminated", "untextured", "unthickened", "unthinned", "unthrashed", "unthreaded", "unthrottled", "unticketed", "untiled", "untilled", "untilted", "untimbered", "untinged", "untinned", "untinted", "untitled", "untoasted", "untoggled", "untoothed", "untopped", "untoughened", "untracked", "untrammeled", "untrammelled", "untranscribed", "untransduced", "untransferred", "untranslated", "untransmitted", "untraumatized", "untraversed", "untufted", "untuned", "untutored", "unupgraded", "unupholstered", "unutilised", "unutilized", "unuttered", "unvaccinated", "unvacuumed", "unvalidated", "unvalued", "unvandalized", "unvaned", "unvanquished", "unvapourised", "unvapourized", "unvaried", "unvariegated", "unvarnished", "unvented", "unventilated", "unverbalised", "unverbalized", "unverified", "unversed", "unvetted", "unvictimized", "unviolated", "unvitrified", "unvocalized", "unvoiced", "unwaged", "unwarped", "unwarranted", "unwaxed", "unweakened", "unweaned", "unwearied", "unweathered", "unwebbed", "unwed", "unwedded", "unweeded", "unweighted", "unwelded", "unwinterized", "unwired", "unwitnessed", "unwonted", "unwooded", "unworshipped", "unwounded", "unzoned", "uprated", "uprighted", "upset", "upsized", "upswelled", "vacuolated", "valanced", "valueoriented", "varied", "vascularised", "vascularized", "vasectomised", "vaunted", "vectorised", "vectorized", "vegged", "verdured", "verified", "vermiculated", "vernacularized", "versified", "verticillated", "vesiculated", "vied", "vilified", "virtualised", "vitrified", "vivified", "volumed", "vulcanised", "wabbled", "wafered", "waisted", "walleyed", "wared", "warmblooded", "warmhearted", "warted", "waterbased", "waterbed", "watercooled", "watersaturated", "watershed", "wavegenerated", "waxweed", "weakhearted", "weakkneed", "weakminded", "wearied", "weatherised", "weatherstriped", "webfooted", "wedgeshaped", "weed", "weeviled", "welladapted", "welladjusted", "wellbred", "wellconducted", "welldefined", "welldisposed", "welldocumented", "wellequipped", "wellestablished", "wellfavored", "wellfed", "wellgrounded", "wellintentioned", "wellmannered", "wellminded", "wellorganised", "wellrounded", "wellshaped", "wellstructured", "whinged", "whinnied", "whiplashed", "whiskered", "wholehearted", "whorled", "widebased", "wideeyed", "widemeshed", "widemouthed", "widenecked", "widespaced", "wilded", "wildered", "wildeyed", "willinghearted", "windspeed", "winterfed", "winterfeed", "winterised", "wirehaired", "wised", "witchweed", "woaded", "wombed", "wooded", "woodshed", "wooled", "woolled", "woollyhaired", "woollystemmed", "woolyhaired", "woolyminded", "wormholed", "wormshaped", "wrappered", "wretched", "wronghearted", "ycleped", "yolked", "zincified", "zinckified", "zinkified", "zombified"];
};

var directPrecedenceExceptionWithoutRegex = {};

Object.defineProperty(directPrecedenceExceptionWithoutRegex, "__esModule", {
	value: true
});

directPrecedenceExceptionWithoutRegex.default = function (sentencePart, participle, language) {
	// Break the sentence part up into words and convert to lower case.
	const wordsInSentencePart = (0, _getWords2$a.default)(sentencePart).map(word => word.toLowerCase());

	// Search the participle in the word list.
	const participleIndex = wordsInSentencePart.indexOf(participle.toLowerCase());

	/*
  * There can be no exception in the following situations:
  *
  * -1 The participle is not found.
  *  0 There is no word before the participle.
  */
	if (participleIndex < 1) {
		return false;
	}

	const wordPrecedingParticiple = wordsInSentencePart[participleIndex - 1];

	// Get the exceptions word list.
	const directPrecedenceExceptions = (0, _lodashEs$K.get)(cannotDirectlyPrecedePassiveParticiples, language, []);

	// Check if the word preceding the participle is in the exceptions list.
	return (0, _lodashEs$K.includes)(directPrecedenceExceptions, wordPrecedingParticiple);
};

var _lodashEs$K = require$$1$1;

var _functionWords$2 = functionWords$e;

var _functionWords2$2 = _interopRequireDefault$18(_functionWords$2);

var _functionWords3$1 = functionWords$f;

var _functionWords4$1 = _interopRequireDefault$18(_functionWords3$1);

var _functionWords5$1 = functionWords$b;

var _functionWords6$1 = _interopRequireDefault$18(_functionWords5$1);

var _functionWords7$1 = functionWords$c;

var _functionWords8$1 = _interopRequireDefault$18(_functionWords7$1);

var _functionWords9 = functionWords$8;

var _functionWords10 = _interopRequireDefault$18(_functionWords9);

var _functionWords11 = functionWords$d;

var _functionWords12 = _interopRequireDefault$18(_functionWords11);

var _functionWords13 = functionWords$a;

var _functionWords14 = _interopRequireDefault$18(_functionWords13);

var _getWords$a = getWords;

var _getWords2$a = _interopRequireDefault$18(_getWords$a);

function _interopRequireDefault$18(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const cannotDirectlyPrecedePassiveParticiples = {
	nl: (0, _functionWords2$2.default)().cannotDirectlyPrecedePassiveParticiple,
	en: (0, _functionWords4$1.default)().cannotDirectlyPrecedePassiveParticiple,
	fr: (0, _functionWords6$1.default)().cannotDirectlyPrecedePassiveParticiple,
	it: (0, _functionWords8$1.default)().cannotDirectlyPrecedePassiveParticiple,
	pl: (0, _functionWords10.default)().cannotDirectlyPrecedePassiveParticiple,
	es: (0, _functionWords12.default)().cannotDirectlyPrecedePassiveParticiple,
	pt: (0, _functionWords14.default)().cannotDirectlyPrecedePassiveParticiple
};

var precedenceExceptionWithoutRegex = {};

Object.defineProperty(precedenceExceptionWithoutRegex, "__esModule", {
	value: true
});

precedenceExceptionWithoutRegex.default = function (sentencePart, participle, language) {
	// Break the sentence part up into words and convert to lower case.
	const wordsInSentencePart = (0, _getWords2$9.default)(sentencePart).map(word => word.toLowerCase());

	// Search the participle in the word list.
	const participleIndex = wordsInSentencePart.indexOf(participle.toLowerCase());

	/*
  * There can be no exception in the following situations:
  *
  * -1 The participle is not found.
  *  0 There is no word before the participle.
  */
	if (participleIndex < 1) {
		return false;
	}

	// Get the exceptions word list.
	const precedenceExceptions = (0, _lodashEs$J.get)(cannotBeBetweenPassiveAuxiliaryAndParticiple, language, []);

	// Check if the words preceding the participle are in the exceptions list.
	for (let i = 0; i < participleIndex; i++) {
		if ((0, _lodashEs$J.includes)(precedenceExceptions, wordsInSentencePart[i])) {
			return true;
		}
	}

	return false;
};

var _lodashEs$J = require$$1$1;

var _functionWords$1 = functionWords$f;

var _functionWords2$1 = _interopRequireDefault$17(_functionWords$1);

var _functionWords3 = functionWords$b;

var _functionWords4 = _interopRequireDefault$17(_functionWords3);

var _functionWords5 = functionWords$c;

var _functionWords6 = _interopRequireDefault$17(_functionWords5);

var _functionWords7 = functionWords$d;

var _functionWords8 = _interopRequireDefault$17(_functionWords7);

var _getWords$9 = getWords;

var _getWords2$9 = _interopRequireDefault$17(_getWords$9);

function _interopRequireDefault$17(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const cannotBeBetweenPassiveAuxiliaryAndParticiple = {
	en: (0, _functionWords2$1.default)().cannotBeBetweenPassiveAuxiliaryAndParticiple,
	fr: (0, _functionWords4.default)().cannotBeBetweenPassiveAuxiliaryAndParticiple,
	it: (0, _functionWords6.default)().cannotBeBetweenPassiveAuxiliaryAndParticiple,
	es: (0, _functionWords8.default)().cannotBeBetweenPassiveAuxiliaryAndParticiple
};

Object.defineProperty(EnglishParticiple$1, "__esModule", {
  value: true
});

var _Participle$9 = Participle$1;

var _Participle2$9 = _interopRequireDefault$16(_Participle$9);

var _checkException$7 = checkException;

var _checkException2$7 = _interopRequireDefault$16(_checkException$7);

var _nonVerbEndingEd = nonVerbEndingEd;

var _nonVerbEndingEd2 = _interopRequireDefault$16(_nonVerbEndingEd);

var _directPrecedenceExceptionWithoutRegex$6 = directPrecedenceExceptionWithoutRegex;

var _directPrecedenceExceptionWithoutRegex2$6 = _interopRequireDefault$16(_directPrecedenceExceptionWithoutRegex$6);

var _precedenceExceptionWithoutRegex$4 = precedenceExceptionWithoutRegex;

var _precedenceExceptionWithoutRegex2$4 = _interopRequireDefault$16(_precedenceExceptionWithoutRegex$4);

var _lodashEs$I = require$$1$1;

function _interopRequireDefault$16(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const nonVerbsEndingEd = (0, _nonVerbEndingEd2.default)();


var irregularExclusionArray = ["get", "gets", "getting", "got", "gotten"];

/**
 * Creates an Participle object for the English language.
 *
 * @param {string} participle The participle.
 * @param {string} sentencePart The sentence part that contains the participle.
 * @param {Object} attributes  The attributes object.
 *
 * @constructor
 */
var EnglishParticiple = function EnglishParticiple(participle, sentencePart, attributes) {
  _Participle2$9.default.call(this, participle, sentencePart, attributes);
  _checkException2$7.default.call(this);
};

require$$2$1.inherits(EnglishParticiple, _Participle2$9.default);

/**
 * Checks if any exceptions are applicable to this participle that would result in the sentence part not being passive.
 * If no exceptions are found, the sentence part is passive.
 *
 * @returns {boolean} Returns true if no exception is found.
 */
EnglishParticiple.prototype.isPassive = function () {
  const sentencePart = this.getSentencePart();
  const participle = this.getParticiple();
  const language = this.getLanguage();

  return !this.isNonVerbEndingEd() && !this.hasRidException() && !this.directPrecedenceException(sentencePart, participle, language) && !this.precedenceException(sentencePart, participle, language);
};

/**
 * Checks whether a found participle is in the nonVerbsEndingEd list.
 * If a word is in the nonVerbsEndingEd list, it isn't a participle.
 * Irregular participles do not end in -ed, and therefore cannot be in the nonVerbsEndingEd list.
 *
 * @returns {boolean} Returns true if it is in the nonVerbsEndingEd list, otherwise returns false.
 */
EnglishParticiple.prototype.isNonVerbEndingEd = function () {
  if (this.getType() === "irregular") {
    return false;
  }
  return (0, _lodashEs$I.includes)(nonVerbsEndingEd, this.getParticiple());
};

/**
 * Checks whether the participle is 'rid' in combination with 'get', 'gets', 'getting', 'got' or 'gotten'.
 * If this is true, the participle is not passive.
 *
 * @returns {boolean} Returns true if 'rid' is found in combination with a form of 'get'
 * otherwise returns false.
 */
EnglishParticiple.prototype.hasRidException = function () {
  if (this.getParticiple() === "rid") {
    var auxiliaries = this.getAuxiliaries();
    return !(0, _lodashEs$I.isEmpty)((0, _lodashEs$I.intersection)(irregularExclusionArray, auxiliaries));
  }
  return false;
};

EnglishParticiple.prototype.directPrecedenceException = _directPrecedenceExceptionWithoutRegex2$6.default;

EnglishParticiple.prototype.precedenceException = _precedenceExceptionWithoutRegex2$4.default;

EnglishParticiple$1.default = EnglishParticiple;

var FrenchParticiple$1 = {};

var exceptionsParticiples = {};

Object.defineProperty(exceptionsParticiples, "__esModule", {
	value: true
});

exceptionsParticiples.default = function () {
	return {
		adjectivesVerbs: adjectivesVerbs,
		nounsStartingWithVowel: nounsStartingWithVowel,
		nounsStartingWithConsonant: nounsStartingWithConsonant,
		others: others
	};
};

// These word need to be checked with s/e/es suffixes.
var adjectivesVerbs = [
// The following words are participles of verbs that cannot be passives.
"allé", "arrivé", "décédé", "demeuré", "entré", "été", "né", "resté", "retombé", "tombé",
// The following words are non-participles ending in é.
"achalandé", "aéroporté", "affilé", "affixé", "âgé", "aîné", "aisé", "aligoté", "alizé", "alliacé", "alluré", "alphabétisé", "alvéolé", "aminé", "ammoniaqué", "ampoulé", "archi-prouvé", "archi-usé", "asexué", "autoguidé", "autopropulsé", "aviné", "baleiné", "barbelé", "baryté", "bien-aimé", "bisexué", "bouqueté", "brioché", "burkinabé", "cagoulé", "calamistré", "cannelé", "carabiné", "carboné", "caréné", "carié", "carminé", "carné", "carpé", "censé", "cérusé", "charançonné", "chenillé", "chocolaté", "chtarbé", "citronné", "cofondé", "contrecollé", "côtelé", "courbaturé", "crawlé", "crossé", "crustacé", "cutané", "damasquiné", "damassé", "débellé", "décavé", "déguenillé", "demi-paralysé", "denté", "dépenaillé", "désenchanté", "désodé", "diapré", "ébranché", "écervelé", "effréné", "effronté", "éhonté", "embourgeoisé", "embroussaillé", "embruiné", "émerillonné", "encalminé", "encaustiqué", "encorné", "endiablé", "endiamanté", "enfoiré", "enfouraillé", "ensellé", "entrelardé", "éploré", "ergoté", "erroné", "étagé", "éthéré", "éversé", "éwé", "ex-associé", "exorbité", "expansé", "famé", "férié", "fibré", "filoguidé", "flammé", "fleurdelisé", "fliqué", "flûté", "forcené", "fortuné", "foulbé", "frelaté", "friqué", "futé", "gazonné", "gracieusé", "gradé", "granulé", "herminé", "hiérarchisé", "huppé", "hydrogéné", "igné", "illettré", "illimité", "imbriqué", "immaculé", "immérité", "immodéré", "immunodéprimé", "impayé", "impensé", "impollué", "imprononcé", "inaccoutumé", "inachevé", "inactivé", "inadapté", "inaltéré", "inanimé", "inapproprié", "inarticulé", "inavoué", "inchangé", "inconditionné", "inconsidéré", "inconsolé", "incontesté", "incontrôlé", "incréé", "indéfriché", "indéterminé", "indifférencié", "indiscipliné", "indiscuté", "indivisé", "indompté", "inébranlé", "inemployé", "inentamé", "inespéré", "inexpérimenté", "inexpliqué", "inexploité", "inexploré", "inexprimé", "infondé", "informulé", "infortuné", "inhabité", "inimité", "injustifié", "inné", "innommé", "inoccupé", "inopiné", "inorganisé", "inoublié", "insensé", "insoupçonné", "instantané", "insubordonné", "insurpassé", "intentionné", "interallié", "intouché", "inusité", "inutilisé", "invertébré", "inviolé", "iodé", "irraisonné", "irréalisé", "lacté", "lamé", "lamifié", "larvé", "laryngé", "léopardé", "lettré", "lié", "lifté", "losangé", "luné", "lunetté", "madré", "maillé", "malaisé", "malavisé", "maléficié", "malfamé", "malformé", "malintentionné", "mendé", "ménopausé", "mentholé", "mi-accablé", "mi-allongé", "mi-café", "mi-consterné", "mi-enterré", "mi-étonné", "mi-pincé", "mi-terrorisé", "miellé", "millimétré", "miraculé", "momentané", "monoclé", "monté", "mordoré", "mort-né", "névrosé", "nitré", "non-initié", "nouveau-né", "olé-olé", "ongulé", "paillé", "palé", "papilionacé", "paqueté", "paraffiné", "passé", "pasteurisé", "patenté", "paysagé", "pédonculé", "pestiféré", "platiné", "pocheté", "polychromé", "poplité", "potelé", "pourpré", "praliné", "précité", "prédigéré", "préencollé", "préfabriqué", "prématuré", "premier-né", "préprogrammé", "prostré", "protéiné", "pyramidé", "quadrilobé", "racé", "re-café", "re-rêvé", "re-vérifié", "rebarré", "redécoré", "relargué", "remonté", "rentré", "résiné", "ressuscité", "réticulé", "retourné", "revérifié", "revivifié", "rose-thé", "safrané", "satiné", "saumoné", "sébacé", "sensé", "sexué", "sigillé", "silicosé", "simultané", "sinistré", "soufré", "sous-cutané", "sous-développé", "sous-qualifié", "soussigné", "spiralé", "spontané", "stratifié", "sulfaté", "sulfuré", "sulfurisé", "suractivé", "suranné", "surbooké", "surbrodé", "surdéveloppé", "surdimensionné", "surdoué", "surentraîné", "suroxygéné", "surpeuplé", "surqualifié", "susmentionné", "susnommé", "systématisé", "tarabiscoté", "taupé", "thrombosé", "tiercé", "timoré", "tiqueté", "transcutané", "triphasé", "usagé", "usité", "vallonné", "vanillé", "vascularisé", "veinulé", "venté", "vergé", "vert-de-grisé", "vertébré", "vitaminé", "vulcanisé", "zélé"];

/*
The following words are nouns ending in -é or -ée and starting with a vowel.
These words need to be checked with -s suffixes and l' and d' prefixes.
 */
var nounsStartingWithVowel = ["à-côté", "abbé", "absurdité", "accessibilité", "acerbité", "acidité", "acmé", "acné", "âcreté", "activité", "actualité", "acuité", "adaptabilité", "adiposité", "admissibilité", "adversité", "affabilité", "affectivité", "affidé", "affinité", "agilité", "agressivité", "alacrité", "alcalinité", "altérité", "amabilité", "ambiguïté", "amé", "aménité", "américanité", "amirauté", "amitié", "amoralité", "ancestralité", "ancienneté", "anfractuosité", "angulosité", "animalité", "animosité", "anormalité", "anti-acné", "anti-cité", "anti-criminalité", "anti-gravité", "anti-intimité", "anti-société", "antigravité", "antiquité", "anxiété", "aparté", "applicabilité", "âpreté", "archevêché", "aridité", "artificialité", "asexualité", "asociabilité", "aspérité", "assiduité", "astarté", "atrocité", "austérité", "authenticité", "autodafé", "autorité", "avé", "aveugle-né", "avidité", "ébriété", "effectivité", "efficacité", "égalité", "élasticité", "électricité", "élément-clé", "élémentarité", "éligibilité", "émotivité", "empaffé", "énormité", "entièreté", "entité", "enviandé", "épitomé", "équanimité", "équité", "étanchéité", "éternité", "ethnicité", "étrangéité", "étrangeté", "euromarché", "évêché", "éventualité", "ex-abbé", "ex-fiancé", "excentricité", "exclusivité", "exemplarité", "exhaustivité", "exiguïté", "extériorité", "externalité", "exterritorialité", "extrémité", "idée-clé", "identité", "illégalité", "illégitimité", "imbécillité", "immatérialité", "immaturité", "immédiateté", "immensité", "immobilité", "immoralité", "immortalité", "immuabilité", "immunité", "immutabilité", "impalpabilité", "impartialité", "impassibilité", "impeccabilité", "impécuniosité", "impénétrabilité", "imperméabilité", "impersonnalité", "impétuosité", "impiété", "implacabilité", "impopularité", "impossibilité", "impraticabilité", "imprévisibilité", "improbabilité", "impudicité", "impulsivité", "impunité", "impureté", "inaccessibilité", "inactivité", "inanité", "inauthenticité", "incapacité", "incommodité", "incommunicabilité", "incompatibilité", "incongruité", "incorruptibilité", "incrédibilité", "incrédulité", "incuriosité", "indemnité", "indestructibilité", "indignité", "indisponibilité", "individualité", "indivisibilité", "indocilité", "industrie-clé", "inefficacité", "inégalité", "inéligibilité", "inéluctabilité", "inévitabilité", "inexorabilité", "infaillibilité", "infécondité", "infériorité", "infertilité", "infidélité", "infinité", "infirmité", "inflammabilité", "inflexibilité", "ingéniosité", "ingénuité", "inhospitalité", "inhumanité", "inimitié", "iniquité", "innocuité", "inopportunité", "insalubrité", "insanité", "insécurité", "insensibilité", "inséparabilité", "insincérité", "insipidité", "insonorité", "instabilité", "instantanéité", "insularité", "intangibilité", "intégralité", "intégrité", "intelligibilité", "intemporalité", "intensité", "intentionnalité", "interactivité", "intériorité", "intimité", "intrépidité", "inusabilité", "inutilité", "invalidité", "inventivité", "invincibilité", "inviolabilité", "invisibilité", "invulnérabilité", "irrationalité", "irréalité", "irrecevabilité", "irrégularité", "irréligiosité", "irresponsabilité", "irréversibilité", "irrévocabilité", "irritabilité", "obésité", "objectivité", "obliquité", "obscénité", "obscurité", "obséquiosité", "officialité", "oiseau-clé", "oisiveté", "okoumé", "onctuosité", "opacité", "opiniâtreté", "opportunité", "oralité", "originalité", "ubiquité", "ukulélé", "unanimité", "unicité", "uniformité", "unilatéralité", "unité", "universalité", "université", "urbanité", "utilité", "yé-yé", "yéyé", "achillée", "almée", "aménorrhée", "année", "anti-nausée", "apnée", "apogée", "araignée", "arrière-pensée", "assiettée", "athénée", "auloffée", "aveugle-née", "avrillée", "azalée", "échauffourée", "écuellée", "élysée", "embardée", "empyrée", "épée", "épopée", "étuvée", "ex-allée", "ex-dulcinée", "ex-fiancée", "ex-lycée", "idée", "ipomée", "odyssée", "onomatopée", "orchidée", "orée", "orphée", "urée"];

/*
The following words are nouns ending in -é or -ée and starting with a consonant.
These words need to be checked with -s suffixes.
*/
var nounsStartingWithConsonant = ["banalité", "bas-côté", "beaupré", "beauté", "bébé", "bédé", "bénédicité", "bénignité", "bestialité", "bien-fondé", "biodiversité", "bipolarité", "bisexualité", "blé", "bonté", "bout-rimé", "bovidé", "brièveté", "brutalité", "caducité", "café", "callosité", "camélidé", "canapé", "capacité", "capillarité", "captivité", "carte-clé", "caté", "catholicité", "causalité", "causticité", "cavité", "cécité", "célébrité", "célérité", "cérébralité", "cétacé", "charité", "chassé-croisé", "chasteté", "cherté", "chétivité", "chimpanzé", "chrétienté", "ciné", "cinéma-vérité", "circularité", "citoyenneté", "civilité", "clandé", "clandestinité", "clarté", "clé", "clergé", "co-propriété", "coaccusé", "cochonceté", "code-clé", "collectivité", "collégialité", "combativité", "comestibilité", "comité", "commodité", "communauté", "communicabilité", "compacité", "comparabilité", "compatibilité", "compétitivité", "complémentarité", "complexité", "complicité", "comptabilité", "comté", "concavité", "condé", "conductibilité", "conductivité", "confidentialité", "conformité", "confraternité", "congé", "conjugalité", "connectivité", "consanguinité", "constitutionnalité", "contiguïté", "continuité", "contrariété", "contre-gré", "contre-plaqué", "contre-vérité", "contreplaqué", "contrevérité", "convexité", "convivialité", "coopé", "copropriété", "cordialité", "coré", "coriacité", "corporalité", "côté", "créativité", "crédibilité", "crédulité", "crétacé", "criminalité", "cruauté", "crudité", "culpabilité", "cupidité", "curiosité", "cybercafé", "cyprinidé", "dangerosité", "daphné", "dé", "débotté", "décimalité", "décision-clé", "déclivité", "déductibilité", "défectuosité", "degré", "déité", "déloyauté", "demi-clarté", "demi-degré", "demi-liberté", "demi-obscurité", "demi-vérité", "dénatalité", "densité", "député", "dératé", "dernier-né", "désirabilité", "dextérité", "difficulté", "difformité", "dignité", "discontinuité", "disparité", "disponibilité", "diversité", "divinité", "docilité", "domesticité", "doyenné", "dualité", "duché", "duplicité", "durabilité", "dureté", "faculté", "faillibilité", "faisabilité", "familiarité", "fatalité", "fatuité", "fausseté", "fébrilité", "fécondité", "félidé", "félinité", "féminité", "féodalité", "fermeté", "férocité", "ferté", "fertilité", "festivité", "fétidité", "fiabilité", "fibrillé", "fidélité", "fierté", "finalité", "fiscalité", "fixité", "flaccidité", "flatuosité", "flexibilité", "flexuosité", "flottabilité", "fluidité", "fonctionnalité", "formalité", "fossé", "fragilité", "francité", "fraternité", "friabilité", "frigidité", "frilosité", "fringillidé", "frivolité", "frugalité", "fugacité", "furtivité", "futilité", "gaieté", "gaîté", "gallinacé", "gémellité", "généralité", "générosité", "génialité", "génitalité", "germanité", "gibbosité", "globalité", "godemiché", "gracieuseté", "gracilité", "grand-duché", "granité", "gratuité", "gravidité", "gré", "grossièreté", "habileté", "habitabilité", "haute-fidélité", "henné", "hérédité", "hétérogénéité", "hétérosexualité", "hilarité", "histocompatibilité", "historicité", "homme-clé", "homogénéité", "homosexualité", "honnêteté", "honorabilité", "horizontalité", "hospitalité", "hostilité", "humanité", "humidité", "humilité", "hyperacidité", "hyperactivité", "hypercoagulabilité", "hyperémotivité", "hypermarché", "hyperréactivité", "hypersensibilité", "jovialité", "joyeuseté", "jubé", "judaïcité", "judaïté", "judéité", "juvénilité", "karaoké", "karaté", "karité", "kiné", "koré", "lâcheté", "laïcité", "lamedé", "lascivité", "latéralité", "latinité", "laubé", "laxité", "lé", "légalité", "légèreté", "légitimité", "lèse-majesté", "létalité", "lettre-clé", "libéralité", "liberté", "licéité", "limpidité", "liquidité", "lisibilité", "littéralité", "lividité", "localité", "longanimité", "longévité", "loquacité", "loyauté", "lubricité", "lucidité", "luminosité", "macramé", "magnanimité", "majesté", "majorité", "mal-aimé", "mal-baisé", "malhonnêteté", "malignité", "malinké", "malléabilité", "malpropreté", "maniabilité", "manoeuvrabilité", "marginalité", "masculinité", "maskinongé", "massivité", "matérialité", "maternité", "matité", "maturité", "mauvaiseté", "méchanceté", "médiocrité", "médiumnité", "mémé", "mémorabilité", "mendicité", "mensualité", "mentalité", "merveillosité", "méticulosité", "mi-capacité", "mi-été", "mi-meublé", "mi-porté", "mi-réalité", "mi-résigné", "miché", "microgravité", "minorité", "mitoyenneté", "mixité", "mobilité", "mocheté", "modalité", "modernité", "modicité", "moment-clé", "mondanité", "monstruosité", "mont-de-piété", "monumentalité", "mooré", "moralité", "morbidité", "morosité", "mortalité", "mot-clé", "motilité", "motricité", "mousmé", "mucosité", "multiplicité", "multipropriété", "municipalité", "musicalité", "mutabilité", "mutité", "mutualité", "naïveté", "narghilé", "narguilé", "natalité", "nationalité", "nativité", "navigabilité", "nébulosité", "négativité", "néné", "nervosité", "nescafé", "netteté", "neutralité", "névé", "niakoué", "niébé", "nocivité", "non-conformité", "non-culpabilité", "nordicité", "normalité", "notabilité", "notoriété", "nouveauté", "nouvelleté", "nubilité", "nudité", "nue-propriété", "nullité", "nuptialité", "papauté", "papé", "parenté", "parité", "partialité", "particularité", "passiveté", "passivité", "pâté", "paternité", "pause-café", "pauses-café", "pauvreté", "pédé", "pédégé", "pénalité", "pépé", "pérennité", "perfectibilité", "périodicité", "perméabilité", "permissivité", "péroné", "perpétuité", "perplexité", "perré", "personnage-clé", "personnalité", "perspicacité", "perversité", "pèse-bébé", "petit-salé", "photosensibilité", "phrase-clé", "pilosité", "pisé", "pitié", "placidité", "plasticité", "plausibilité", "pluralité", "pluviosité", "point-clé", "poiré", "poire-vérité", "polarité", "polycopié", "polytonalité", "ponctualité", "pongé", "popularité", "porosité", "portabilité", "porte-bébé", "porte-clé", "position-clé", "positivité", "possessivité", "possibilité", "poste-clé", "postérité", "potentialité", "pousse-café", "pré", "pré-salé", "précarité", "préciosité", "précocité", "prématurité", "prévisibilité", "prévôté", "prieuré", "primauté", "principauté", "priorité", "privauté", "probabilité", "probité", "prodigalité", "productivité", "profitabilité", "prolixité", "promiscuité", "proportionnalité", "propreté", "propriété", "prospérité", "proximité", "psyché", "puberté", "publicité", "pudicité", "puérilité", "pugnacité", "puîné", "pureté", "pusillanimité", "qualité", "quantité", "quarté", "quasi-impossibilité", "quasi-impunité", "quasi-nudité", "quasi-totalité", "quasi-unanimité", "question-clé", "quinté", "quotidienneté", "quotité", "radioactivité", "raisiné", "rapacité", "raphé", "rapidité", "rareté", "rationalité", "raucité", "ré", "réactivité", "réalité", "récépissé", "réceptivité", "recevabilité", "réciprocité", "récré", "régularité", "relativité", "religiosité", "rentabilité", "reportage-vérité", "respectabilité", "responsabilité", "réversibilité", "rigidité", "risibilité", "rivalité", "romanité", "rotondité", "roulé-boulé", "royauté", "rugosité", "rusticité", "sagacité", "saint-honoré", "sainteté", "saké", "salacité", "saleté", "salinité", "salmonidé", "salubrité", "santé", "sapidité", "satiété", "sauveté", "scène-clé", "scientificité", "scissiparité", "scolarité", "scrupulosité", "sécurité", "sédentarité", "sélectivité", "semi-liberté", "séné", "sénevé", "sénilité", "sensibilité", "sensorialité", "sensualité", "sentimentalité", "septicité", "sérénité", "sergé", "séropositivité", "sérosité", "serviabilité", "servilité", "sévérité", "sexualité", "similarité", "simplicité", "simultanéité", "sincérité", "singularité", "sinuosité", "sobriété", "sociabilité", "société", "solennité", "solidarité", "solidité", "solubilité", "soluté", "solvabilité", "sommité", "somptuosité", "sonorité", "sordidité", "sororité", "soudaineté", "sous-comité", "sous-humanité", "souveraineté", "spasticité", "spécialité", "spécificité", "sphéricité", "spiritualité", "spontanéité", "sportivité", "spumosité", "stabilité", "sténopé", "stérilité", "stupidité", "suavité", "subjectivité", "sublimité", "subtilité", "succédané", "suggestibilité", "suggestivité", "superficialité", "superfluité", "supériorité", "supermarché", "supraconductivité", "suractivité", "surcapacité", "surdité", "sûreté", "surgé", "surhumanité", "surintensité", "surréalité", "susceptibilité", "suzeraineté", "synthé", "taboulé", "taciturnité", "tamouré", "tangibilité", "tarpé", "technicité", "télé", "témérité", "témoin-clé", "temporalité", "ténacité", "tendreté", "ténébrionidé", "ténuité", "territorialité", "tévé", "thé", "théâtralité", "tiaré", "timidité", "tollé", "tonalité", "tonicité", "totalité", "toxicité", "traçabilité", "tranquillité", "translucidité", "transsexualité", "trinité", "trivialité", "tsé-tsé", "tubérosité", "turbé", "vacuité", "vahiné", "validité", "vanité", "variabilité", "variété", "vassalité", "vastité", "velléité", "vélocité", "vénalité", "vénusté", "véracité", "verbosité", "vérité", "versatilité", "verticalité", "vétusté", "viabilité", "vicinalité", "vicomté", "viduité", "virginité", "virilité", "virtualité", "virtuosité", "viscosité", "visibilité", "vitalité", "vivacité", "volatilité", "volonté", "volubilité", "volupté", "voracité", "vulgarité", "vulnérabilité", "batée", "becquée", "billevesée", "bolée", "bondrée", "borée", "bouée", "bougainvillée", "brouettée", "buée", "caducée", "canne-épée", "casserolée", "cavée", "centaurée", "cépée", "céphalée", "charretée", "chaudronnée", "chicorée", "chorée", "cochlée", "cochonnée", "colée", "contre-allée", "contre-plongée", "corvée", "coryphée", "cucurbitacée", "cuillerée", "culée", "cylindrée", "demi-journée", "demi-volée", "denrée", "dernière-née", "diarrhée", "diatomée", "dionée", "dragée", "dulcinée", "dysménorrhée", "dyspnée", "fée", "feuillée", "flopée", "fournée", "fricassée", "friselée", "galathée", "galée", "giboulée", "giroflée", "gonorrhée", "goulée", "graminée", "guinée", "gynécée", "haquenée", "hottée", "hyménée", "hyperborée", "hypogée", "journée", "lance-fusée", "litée", "logorrhée", "lycée", "macchabée", "mainlevée", "maisonnée", "mal-aimée", "mal-baisée", "maréchaussée", "marée", "mausolée", "mélopée", "mi-effrontée", "mi-journée", "miellée", "mijaurée", "mosquée", "moteur-fusée", "muflée", "nausée", "nuée", "nuitée", "panacée", "pâtée", "peignée", "pelletée", "pépée", "périgée", "périnée", "pharmacopée", "pipée", "platée", "pochetée", "pochetée", "poignée", "poirée", "poisson-épée", "porte-épée", "potée", "poupée", "première-née", "prérentrée", "presse-purée", "prytanée", "purée", "quasi-fiancée", "ramée", "raz-de-marée", "resucée", "rétrofusée", "rez-de-chaussée", "risée", "ruchée", "scarabée", "séborrhée", "sigisbée", "simagrée", "singe-araignée", "soirée", "solanacée", "tablée", "tinée", "trachée", "trâlée", "transfusée", "travée", "trépanée", "trochée", "trophée", "vallée", "ventrée", "vesprée"];

// These words do not need to be checked with any suffixes.
var others = ["bé", "cré", "crédié", "é", "loucedé", "eussé", "hé", "malgré", "moitié-moitié", "ohé", "olé", "ollé", "sacrédié", "d'emblée", "quasi-instantanée"];

Object.defineProperty(FrenchParticiple$1, "__esModule", {
	value: true
});

var _lodashEs$H = require$$1$1;

var _directPrecedenceExceptionWithoutRegex$5 = directPrecedenceExceptionWithoutRegex;

var _directPrecedenceExceptionWithoutRegex2$5 = _interopRequireDefault$15(_directPrecedenceExceptionWithoutRegex$5);

var _precedenceExceptionWithoutRegex$3 = precedenceExceptionWithoutRegex;

var _precedenceExceptionWithoutRegex2$3 = _interopRequireDefault$15(_precedenceExceptionWithoutRegex$3);

var _Participle$8 = Participle$1;

var _Participle2$8 = _interopRequireDefault$15(_Participle$8);

var _checkException$6 = checkException;

var _checkException2$6 = _interopRequireDefault$15(_checkException$6);

var _exceptionsParticiples = exceptionsParticiples;

var _exceptionsParticiples2 = _interopRequireDefault$15(_exceptionsParticiples);

function _interopRequireDefault$15(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _exceptionsParticiple = (0, _exceptionsParticiples2.default)();

const exceptionsParticiplesAdjectivesVerbs = _exceptionsParticiple.adjectivesVerbs,
      exceptionsParticiplesNounsVowel = _exceptionsParticiple.nounsStartingWithVowel,
      exceptionsParticiplesNounsConsonant = _exceptionsParticiple.nounsStartingWithConsonant,
      exceptionsParticiplesOthers = _exceptionsParticiple.others;

/**
 * Creates an Participle object for the French language.
 *
 * @param {string} participle The participle.
 * @param {string} sentencePart The sentence part that contains the participle.
 * @param {Object} attributes  The attributes object.
 *
 * @constructor
 */

var FrenchParticiple = function FrenchParticiple(participle, sentencePart, attributes) {
	_Participle2$8.default.call(this, participle, sentencePart, attributes);
	_checkException2$6.default.call(this);
};

require$$2$1.inherits(FrenchParticiple, _Participle2$8.default);

/**
 * Checks whether the participle is irregular.
 *
 * @returns {boolean} Returns true if the passive is irregular.
 */
var checkIrregular = function checkIrregular() {
	if (this.getType() === "irregular") {
		return true;
	}
};

/**
 * Checks if any exceptions are applicable to this participle that would result in the sentence part not being passive.
 * If no exceptions are found, the sentence part is passive.
 *
 * @returns {boolean} Returns true if no exception is found.
 */
FrenchParticiple.prototype.isPassive = function () {
	const sentencePart = this.getSentencePart();
	const participle = this.getParticiple();
	const language = this.getLanguage();

	// Only check precedence exceptions for irregular participles.
	if (checkIrregular.call(this)) {
		return !this.directPrecedenceException(sentencePart, participle, language) && !this.precedenceException(sentencePart, participle, language);
	}
	// Check precedence exceptions and exception lists for regular participles.
	return !this.isOnAdjectivesVerbsExceptionList() && !this.isOnNounsExceptionList() && !this.isOnOthersExceptionList() && !this.directPrecedenceException(sentencePart, participle, language) && !this.precedenceException(sentencePart, participle, language);
};

/**
 * Creates regexes to match adjective and verb participle exceptions (including suffixes) and memoizes them.
 *
 * @returns {Array} Returns an array with all adjective and verb participle exceptions.
 */
var getExceptionsParticiplesAdjectivesVerbsRegexes = (0, _lodashEs$H.memoize)(function () {
	const exceptionsParticiplesAdjectivesVerbsRegexes = [];
	(0, _lodashEs$H.forEach)(exceptionsParticiplesAdjectivesVerbs, function (exceptionParticiplesAdjectivesVerbs) {
		exceptionsParticiplesAdjectivesVerbsRegexes.push(new RegExp("^" + exceptionParticiplesAdjectivesVerbs + "(e|s|es)?$", "ig"));
	});
	return exceptionsParticiplesAdjectivesVerbsRegexes;
});

/**
 * Creates regexes to match noun participle exceptions (including suffixes) and memoizes them.
 *
 * @returns {Array} Returns an array with all noun participle exceptions.
 */
var getExceptionsParticiplesNounsRegexes = (0, _lodashEs$H.memoize)(function () {
	const exceptionsParticiplesNounsRegexes = [];

	// Nouns starting with a vowel are checked with -s suffix and l' and d' prefixes.
	(0, _lodashEs$H.forEach)(exceptionsParticiplesNounsVowel, function (exceptionParticipleNounVowel) {
		exceptionsParticiplesNounsRegexes.push(new RegExp("^(l'|d')?" + exceptionParticipleNounVowel + "(s)?$", "ig"));
	});
	// Nouns starting with a consonant are checked with -s suffix.
	(0, _lodashEs$H.forEach)(exceptionsParticiplesNounsConsonant, function (exceptionParticipleNounConsonant) {
		exceptionsParticiplesNounsRegexes.push(new RegExp("^" + exceptionParticipleNounConsonant + "(s)?$", "ig"));
	});

	return exceptionsParticiplesNounsRegexes;
});

/**
 * Checks whether a given participle matches a list of regex exceptions.
 *
 * @param {Array} participleExceptionRegexes The array of regexes to check.
 * @returns {boolean} Returns true if the participle matches a regex.
 */
var checkParticipleExceptionRegexes = function checkParticipleExceptionRegexes(participleExceptionRegexes) {
	var participle = this.getParticiple();
	var match = [];

	(0, _lodashEs$H.forEach)(participleExceptionRegexes, function (participleExceptionRegex) {
		var exceptionMatch = participle.match(participleExceptionRegex);
		if (exceptionMatch) {
			match.push(exceptionMatch[0]);
		}
	});

	if (match.length > 0) {
		return true;
	}

	return false;
};

/**
 * Checks whether a found participle is in the exception list of adjectives and verbs.
 * These words are checked with e/s/es as possible suffixes.
 * If a word is on the list, it isn't a participle.
 *
 * @returns {boolean} Returns true if it is in the exception list of adjectives and verbs, otherwise returns false.
 */
FrenchParticiple.prototype.isOnAdjectivesVerbsExceptionList = function () {
	var exceptionParticiplesAdjectivesVerbs = getExceptionsParticiplesAdjectivesVerbsRegexes();
	return checkParticipleExceptionRegexes.call(this, exceptionParticiplesAdjectivesVerbs);
};

/**
 * Checks whether a found participle is in the exception list of nouns.
 * These words are checked with s as a possible suffix.
 * If a word is on the list, it isn't a participle.
 *
 * @returns {boolean} Returns true if it is in the exception list of nouns, otherwise returns false.
 */
FrenchParticiple.prototype.isOnNounsExceptionList = function () {
	var exceptionsParticiplesNouns = getExceptionsParticiplesNounsRegexes();
	return checkParticipleExceptionRegexes.call(this, exceptionsParticiplesNouns);
};

/**
 * Checks whether a found participle is in the exception list in the 'other' category.
 * If a word is on the list, it isn't a participle.
 * Irregular participles do not end in -é and therefore can't be on the list.
 *
 * @returns {boolean} Returns true if it is in the exception list of nouns, otherwise returns false.
 */
FrenchParticiple.prototype.isOnOthersExceptionList = function () {
	return (0, _lodashEs$H.includes)(exceptionsParticiplesOthers, this.getParticiple());
};

FrenchParticiple.prototype.directPrecedenceException = _directPrecedenceExceptionWithoutRegex2$5.default;

FrenchParticiple.prototype.precedenceException = _precedenceExceptionWithoutRegex2$3.default;

FrenchParticiple$1.default = FrenchParticiple;

var SpanishParticiple$1 = {};

Object.defineProperty(SpanishParticiple$1, "__esModule", {
  value: true
});

var _Participle$7 = Participle$1;

var _Participle2$7 = _interopRequireDefault$14(_Participle$7);

var _checkException$5 = checkException;

var _checkException2$5 = _interopRequireDefault$14(_checkException$5);

var _directPrecedenceExceptionWithoutRegex$4 = directPrecedenceExceptionWithoutRegex;

var _directPrecedenceExceptionWithoutRegex2$4 = _interopRequireDefault$14(_directPrecedenceExceptionWithoutRegex$4);

var _precedenceExceptionWithoutRegex$2 = precedenceExceptionWithoutRegex;

var _precedenceExceptionWithoutRegex2$2 = _interopRequireDefault$14(_precedenceExceptionWithoutRegex$2);

function _interopRequireDefault$14(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates an Participle object for the Spanish language.
 *
 * @param {string} participle The participle.
 * @param {string} sentencePart The sentence part that contains the participle.
 * @param {Object} attributes The attributes object.
 *
 * @constructor
 */
var SpanishParticiple = function SpanishParticiple(participle, sentencePart, attributes) {
  _Participle2$7.default.call(this, participle, sentencePart, attributes);
  _checkException2$5.default.call(this);
};

require$$2$1.inherits(SpanishParticiple, _Participle2$7.default);

/**
 * Checks if any exceptions are applicable to this participle that would result in the sentence part not being passive.
 * If no exceptions are found, the sentence part is passive.
 *
 * @returns {boolean} Returns true if no exception is found.
 */
SpanishParticiple.prototype.isPassive = function () {
  const sentencePart = this.getSentencePart();
  const participle = this.getParticiple();
  const language = this.getLanguage();

  return !this.directPrecedenceException(sentencePart, participle, language) && !this.precedenceException(sentencePart, participle, language);
};

SpanishParticiple.prototype.directPrecedenceException = _directPrecedenceExceptionWithoutRegex2$4.default;

SpanishParticiple.prototype.precedenceException = _precedenceExceptionWithoutRegex2$2.default;

SpanishParticiple$1.default = SpanishParticiple;

var ItalianParticiple$1 = {};

Object.defineProperty(ItalianParticiple$1, "__esModule", {
  value: true
});

var _Participle$6 = Participle$1;

var _Participle2$6 = _interopRequireDefault$13(_Participle$6);

var _checkException$4 = checkException;

var _checkException2$4 = _interopRequireDefault$13(_checkException$4);

var _directPrecedenceExceptionWithoutRegex$3 = directPrecedenceExceptionWithoutRegex;

var _directPrecedenceExceptionWithoutRegex2$3 = _interopRequireDefault$13(_directPrecedenceExceptionWithoutRegex$3);

var _precedenceExceptionWithoutRegex$1 = precedenceExceptionWithoutRegex;

var _precedenceExceptionWithoutRegex2$1 = _interopRequireDefault$13(_precedenceExceptionWithoutRegex$1);

function _interopRequireDefault$13(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates an Participle object for the Italian language.
 *
 * @param {string} participle The participle.
 * @param {string} sentencePart The sentence part that contains the participle.
 * @param {Object} attributes The attributes object.
 *
 * @constructor
 */
var ItalianParticiple = function ItalianParticiple(participle, sentencePart, attributes) {
  _Participle2$6.default.call(this, participle, sentencePart, attributes);
  _checkException2$4.default.call(this);
};

require$$2$1.inherits(ItalianParticiple, _Participle2$6.default);

/**
 * Checks if any exceptions are applicable to this participle that would result in the sentence part not being passive.
 * If no exceptions are found, the sentence part is passive.
 *
 * @returns {boolean} Returns true if no exception is found.
 */
ItalianParticiple.prototype.isPassive = function () {
  const sentencePart = this.getSentencePart();
  const participle = this.getParticiple();
  const language = this.getLanguage();

  return !this.directPrecedenceException(sentencePart, participle, language) && !this.precedenceException(sentencePart, participle, language);
};

ItalianParticiple.prototype.directPrecedenceException = _directPrecedenceExceptionWithoutRegex2$3.default;

ItalianParticiple.prototype.precedenceException = _precedenceExceptionWithoutRegex2$1.default;

ItalianParticiple$1.default = ItalianParticiple;

var DutchParticiple$1 = {};

Object.defineProperty(DutchParticiple$1, "__esModule", {
  value: true
});

var _lodashEs$G = require$$1$1;

var _Participle$5 = Participle$1;

var _Participle2$5 = _interopRequireDefault$12(_Participle$5);

var _checkException$3 = checkException;

var _checkException2$3 = _interopRequireDefault$12(_checkException$3);

var _nonParticiples = nonParticiples;

var _nonParticiples2 = _interopRequireDefault$12(_nonParticiples);

var _directPrecedenceExceptionWithoutRegex$2 = directPrecedenceExceptionWithoutRegex;

var _directPrecedenceExceptionWithoutRegex2$2 = _interopRequireDefault$12(_directPrecedenceExceptionWithoutRegex$2);

function _interopRequireDefault$12(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates an Participle object for the Dutch language.
 *
 * @param {string} participle The participle.
 * @param {string} sentencePart The sentence part that contains the participle.
 * @param {Object} attributes The attributes object.
 *
 * @constructor
 */
const DutchParticiple = function DutchParticiple(participle, sentencePart, attributes) {
  _Participle2$5.default.call(this, participle, sentencePart, attributes);
  _checkException2$3.default.call(this);
};

require$$2$1.inherits(DutchParticiple, _Participle2$5.default);

/**
 * Checks if any exceptions are applicable to this participle that would result in the sentence part not being passive.
 * If no exceptions are found, the sentence part is passive.
 *
 * @returns {boolean} Returns true if no exception is found.
 */
DutchParticiple.prototype.isPassive = function () {
  const sentencePart = this.getSentencePart();
  const participle = this.getParticiple();
  const language = this.getLanguage();

  return !this.isOnNonParticiplesList() && !this.hasNonParticipleEnding() && !this.directPrecedenceException(sentencePart, participle, language);
};

/**
 * Checks whether a found participle is in the nonParticiples list.
 *
 * @returns {boolean} Returns true if it is in the nonParticiples list, otherwise returns false.
 */
DutchParticiple.prototype.isOnNonParticiplesList = function () {
  if (this.getType() === "irregular") {
    return false;
  }

  return (0, _lodashEs$G.includes)((0, _nonParticiples2.default)(), this.getParticiple());
};

/**
 * Checks whether a found participle has a non-participle ending and is therefore not really a participle.
 *
 * @returns {boolean} Returns true if the participle has a non-participle ending, otherwise returns false.
 */
DutchParticiple.prototype.hasNonParticipleEnding = function () {
  return (/\S+(heid|teit|tijd)($|[ \n\r\t.,'()"+\-;!?:/»«‹›<>])/ig.test(this.getParticiple())
  );
};

DutchParticiple.prototype.directPrecedenceException = _directPrecedenceExceptionWithoutRegex2$2.default;

DutchParticiple$1.default = DutchParticiple;

var PolishParticiple$1 = {};

var nonDirectParticiplePrecedenceException = {};

var getIndicesWithRegex = {};

Object.defineProperty(getIndicesWithRegex, "__esModule", {
	value: true
});

getIndicesWithRegex.default = function (sentencePart, regex) {
	const results = [];
	/* Decided to use a for loop here so that we could retrieve all matches while keeping result objects intact.
 For every match there is in the sentence part, an object with the match and its index will be pushed into
 the results array. */
	for (let match = regex.exec(sentencePart); match !== null; match = regex.exec(sentencePart)) {
		results.push({
			match: match[0],
			index: match.index
		});
	}
	return results;
};

var indices = {};

Object.defineProperty(indices, "__esModule", {
	value: true
});
indices.getIndicesByWordListSorted = indices.sortIndices = indices.filterIndices = indices.getIndicesByWordList = indices.getIndicesByWord = undefined;

var _lodashEs$F = require$$1$1;

var _stripSpaces$5 = stripSpaces;

var _stripSpaces2$5 = _interopRequireDefault$11(_stripSpaces$5);

var _matchWordInSentence = matchWordInSentence;

function _interopRequireDefault$11(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the indices of a string in a text. If it is found multiple times, it will return multiple indices.
 *
 * @param {string} word The word to find in the text.
 * @param {string} text The text to check for the given word.
 * @returns {Array} All indices found.
 */
function getIndicesByWord(word, text) {
	var startIndex = 0;
	var searchStringLength = word.length;
	var index,
	    indices = [];
	while ((index = text.indexOf(word, startIndex)) > -1) {
		// Check if the previous and next character are word boundaries to determine if a complete word was detected
		var isPreviousCharacterWordBoundary = (0, _matchWordInSentence.characterInBoundary)(text[index - 1]) || index === 0;

		var isNextCharacterWordBoundary = (0, _matchWordInSentence.characterInBoundary)(text[index + searchStringLength]) || text.length === index + searchStringLength;

		if (isPreviousCharacterWordBoundary && isNextCharacterWordBoundary) {
			indices.push({
				index: index,
				match: word
			});
		}
		startIndex = index + searchStringLength;
	}
	return indices;
}

/**
 * Matches string with an array, returns the word and the index it was found on.
 *
 * @param {Array} words The array with strings to match.
 * @param {string} text The text to match the strings from the array to.
 * @returns {Array} The array with words, containing the index of the match and the matched string.
 * Returns an empty array if none are found.
 */
var getIndicesByWordList = function getIndicesByWordList(words, text) {
	var matchedWords = [];

	(0, _lodashEs$F.forEach)(words, function (word) {
		word = (0, _stripSpaces2$5.default)(word);
		if (!(0, _matchWordInSentence.isWordInSentence)(word, text)) {
			return;
		}
		matchedWords = matchedWords.concat(getIndicesByWord(word, text));
	});
	return matchedWords;
};

/**
 * Sorts the array on the index property of each entry.
 *
 * @param {Array} indices The array with indices.
 * @returns {Array} The sorted array with indices.
 */
var sortIndices$1 = function sortIndices(indices) {
	return indices.sort(function (a, b) {
		return a.index > b.index;
	});
};

/**
 * Filters duplicate entries if the indices overlap.
 *
 * @param {Array} indices The array with indices to be filtered.
 * @returns {Array} The filtered array.
 */
var filterIndices$1 = function filterIndices(indices) {
	indices = sortIndices$1(indices);
	var filtered = [];
	for (var i = 0; i < indices.length; i++) {
		// If the next index is within the range of the current index and the length of the word, remove it
		// This makes sure we don't match combinations twice, like "even though" and "though".
		if (!(0, _lodashEs$F.isUndefined)(indices[i + 1]) && indices[i + 1].index < indices[i].index + indices[i].match.length) {
			filtered.push(indices[i]);

			// Adds 1 to i, so we skip the next index that is overlapping with the current index.
			i++;
			continue;
		}
		filtered.push(indices[i]);
	}
	return filtered;
};

/**
 * Matches string with an array, returns the word and the index it was found on, and sorts the match instances based on
 * the index property of the match.
 *
 * @param {Array} words The array with strings to match.
 * @param {string} text The text to match the strings from the array to.
 * @returns {Array} The array with words, containing the index of the match and the matched string.
 * Returns an empty array if none are found.
 */
var getIndicesByWordListSorted = function getIndicesByWordListSorted(words, text) {
	var matchedWords = [];

	(0, _lodashEs$F.forEach)(words, function (word) {
		word = (0, _stripSpaces2$5.default)(word);
		if (!(0, _matchWordInSentence.isWordInSentence)(word, text)) {
			return matchedWords;
		}
		matchedWords = matchedWords.concat(getIndicesByWord(word, text));
	});

	matchedWords = matchedWords.sort(function (a, b) {
		if (a.index < b.index) {
			return -1;
		}
		if (a.index > b.index) {
			return 1;
		}
		return 0;
	});

	return matchedWords;
};

indices.getIndicesByWord = getIndicesByWord;
indices.getIndicesByWordList = getIndicesByWordList;
indices.filterIndices = filterIndices$1;
indices.sortIndices = sortIndices$1;
indices.getIndicesByWordListSorted = getIndicesByWordListSorted;
indices.default = {
	getIndicesByWord: getIndicesByWord,
	getIndicesByWordList: getIndicesByWordList,
	filterIndices: filterIndices$1,
	sortIndices: sortIndices$1,
	getIndicesByWordListSorted: getIndicesByWordListSorted
};

Object.defineProperty(nonDirectParticiplePrecedenceException, "__esModule", {
	value: true
});

nonDirectParticiplePrecedenceException.default = function (sentencePart, participle, auxiliaries, language) {
	const auxiliariesUnique = (0, _lodashEs$E.uniq)(auxiliaries);

	const auxiliaryIndices = (0, _indices$2.getIndicesByWordListSorted)(auxiliariesUnique, sentencePart);

	const participleIndex = sentencePart.indexOf(participle);
	let nonDirectParticiplePrecendenceExceptionRegex;

	switch (language) {
		case "pl":
			nonDirectParticiplePrecendenceExceptionRegex = (0, _createRegexFromArray2$3.default)(cannotBeBetweenAuxiliaryAndParticiplePolish);
			break;
	}

	// This exception is only applicable for passive constructions in which the auxiliary precedes the participle.
	const matches = auxiliaryIndices.filter(auxiliaryIndex => auxiliaryIndex.index < participleIndex);

	// If there are no auxiliaries before the participle, this exception is not applicable.
	if (matches.length === 0) {
		return false;
	}

	// We pick the auxiliary closest to the participle, since that is most likely the one belonging to the participle.
	const participleAuxiliary = matches[matches.length - 1];

	const precedenceExceptionIndices = (0, _getIndicesWithRegex2$1.default)(sentencePart, nonDirectParticiplePrecendenceExceptionRegex);

	// Check whether there are any precendence words between the auxiliary and the participle.
	const remaningPrecedenceExceptionIndices = precedenceExceptionIndices.filter(precedenceExceptionIndex => precedenceExceptionIndex.index > participleAuxiliary.index && precedenceExceptionIndex.index < participleIndex);

	return remaningPrecedenceExceptionIndices.length > 0;
};

var _lodashEs$E = require$$1$1;

var _createRegexFromArray$3 = createRegexFromArray;

var _createRegexFromArray2$3 = _interopRequireDefault$10(_createRegexFromArray$3);

var _getIndicesWithRegex$1 = getIndicesWithRegex;

var _getIndicesWithRegex2$1 = _interopRequireDefault$10(_getIndicesWithRegex$1);

var _functionWords = functionWords$8;

var _functionWords2 = _interopRequireDefault$10(_functionWords);

var _indices$2 = indices;

function _interopRequireDefault$10(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const cannotBeBetweenAuxiliaryAndParticiplePolish = (0, _functionWords2.default)().cannotBeBetweenPassiveAuxiliaryAndParticiple;

Object.defineProperty(PolishParticiple$1, "__esModule", {
  value: true
});

var _Participle$4 = Participle$1;

var _Participle2$4 = _interopRequireDefault$$(_Participle$4);

var _checkException$2 = checkException;

var _checkException2$2 = _interopRequireDefault$$(_checkException$2);

var _directPrecedenceExceptionWithoutRegex$1 = directPrecedenceExceptionWithoutRegex;

var _directPrecedenceExceptionWithoutRegex2$1 = _interopRequireDefault$$(_directPrecedenceExceptionWithoutRegex$1);

var _nonDirectParticiplePrecedenceException = nonDirectParticiplePrecedenceException;

var _nonDirectParticiplePrecedenceException2 = _interopRequireDefault$$(_nonDirectParticiplePrecedenceException);

function _interopRequireDefault$$(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates an Participle object for the Polish language.
 *
 * @param {string} participle The participle.
 * @param {string} sentencePart The sentence part that contains the participle.
 * @param {Object} attributes The attributes object.
 *
 * @constructor
 */
const PolishParticiple = function PolishParticiple(participle, sentencePart, attributes) {
  _Participle2$4.default.call(this, participle, sentencePart, attributes);
  _checkException2$2.default.call(this);
};

require$$2$1.inherits(PolishParticiple, _Participle2$4.default);

/**
 * Checks if any exceptions are applicable to this participle that would result in the sentence part not being passive.
 * If no exceptions are found, the sentence part is passive.
 *
 * @returns {boolean} Returns true if no exception is found.
 */
PolishParticiple.prototype.isPassive = function () {
  const sentencePart = this.getSentencePart();
  const participle = this.getParticiple();
  const auxiliaries = this.getAuxiliaries();
  const language = this.getLanguage();

  return !this.directPrecedenceException(sentencePart, participle, language) && !this.nonDirectPrecedenceException(sentencePart, participle, auxiliaries, language);
};

PolishParticiple.prototype.directPrecedenceException = _directPrecedenceExceptionWithoutRegex2$1.default;

PolishParticiple.prototype.nonDirectPrecedenceException = _nonDirectParticiplePrecedenceException2.default;

PolishParticiple$1.default = PolishParticiple;

var PortugueseParticiple$1 = {};

Object.defineProperty(PortugueseParticiple$1, "__esModule", {
  value: true
});

var _Participle$3 = Participle$1;

var _Participle2$3 = _interopRequireDefault$_(_Participle$3);

var _checkException$1 = checkException;

var _checkException2$1 = _interopRequireDefault$_(_checkException$1);

var _directPrecedenceExceptionWithoutRegex = directPrecedenceExceptionWithoutRegex;

var _directPrecedenceExceptionWithoutRegex2 = _interopRequireDefault$_(_directPrecedenceExceptionWithoutRegex);

var _precedenceExceptionWithoutRegex = precedenceExceptionWithoutRegex;

var _precedenceExceptionWithoutRegex2 = _interopRequireDefault$_(_precedenceExceptionWithoutRegex);

function _interopRequireDefault$_(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates an Participle object for the Portuguese language.
 *
 * @param {string} participle The participle.
 * @param {string} sentencePart The sentence part that contains the participle.
 * @param {Object} attributes The attributes object.
 *
 * @constructor
 */
const PortugueseParticiple = function PortugueseParticiple(participle, sentencePart, attributes) {
  _Participle2$3.default.call(this, participle, sentencePart, attributes);
  _checkException2$1.default.call(this);
};

require$$2$1.inherits(PortugueseParticiple, _Participle2$3.default);

/**
 * Checks if any exceptions are applicable to this participle that would result in the sentence part not being passive.
 * If no exceptions are found, the sentence part is passive.
 *
 * @returns {boolean} Returns true if no exception is found.
 */
PortugueseParticiple.prototype.isPassive = function () {
  const sentencePart = this.getSentencePart();
  const participle = this.getParticiple();
  const language = this.getLanguage();

  return !this.directPrecedenceException(sentencePart, participle, language) && !this.precedenceException(sentencePart, participle, language);
};

PortugueseParticiple.prototype.directPrecedenceException = _directPrecedenceExceptionWithoutRegex2.default;

PortugueseParticiple.prototype.precedenceException = _precedenceExceptionWithoutRegex2.default;

PortugueseParticiple$1.default = PortugueseParticiple;

Object.defineProperty(getParticiples$2, "__esModule", {
	value: true
});

getParticiples$2.default = function (sentencePartText, auxiliaries, language) {
	const words = (0, _getWords2$8.default)(sentencePartText);
	const foundParticiples = [];

	(0, _lodashEs$D.forEach)(words, function (word) {
		let type = "";
		if (regularParticipleRegex(word, language).length !== 0) {
			type = "regular";
		}
		if (irregularParticipleRegex(word, language).length !== 0) {
			type = "irregular";
		}
		if (type !== "") {
			switch (language) {
				case "fr":
					foundParticiples.push(new _FrenchParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: type, language: language }));
					break;
				case "es":
					foundParticiples.push(new _SpanishParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: type, language: language }));
					break;
				case "it":
					foundParticiples.push(new _ItalianParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: type, language: language }));
					break;
				case "nl":
					foundParticiples.push(new _DutchParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: type, language: language }));
					break;
				case "pl":
					foundParticiples.push(new _PolishParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: type, language: language }));
					break;
				case "pt":
					foundParticiples.push(new _PortugueseParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: type, language: language }));
					break;
				case "en":
				default:
					foundParticiples.push(new _EnglishParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: type, language: language }));
					break;
			}
		}
	});
	return foundParticiples;
};

var _lodashEs$D = require$$1$1;

var _getWords$8 = getWords;

var _getWords2$8 = _interopRequireDefault$Z(_getWords$8);

var _matchParticiples = matchParticiples$1;

var _matchParticiples2 = _interopRequireDefault$Z(_matchParticiples);

var _EnglishParticiple = EnglishParticiple$1;

var _EnglishParticiple2 = _interopRequireDefault$Z(_EnglishParticiple);

var _FrenchParticiple = FrenchParticiple$1;

var _FrenchParticiple2 = _interopRequireDefault$Z(_FrenchParticiple);

var _SpanishParticiple = SpanishParticiple$1;

var _SpanishParticiple2 = _interopRequireDefault$Z(_SpanishParticiple);

var _ItalianParticiple = ItalianParticiple$1;

var _ItalianParticiple2 = _interopRequireDefault$Z(_ItalianParticiple);

var _DutchParticiple = DutchParticiple$1;

var _DutchParticiple2 = _interopRequireDefault$Z(_DutchParticiple);

var _PolishParticiple = PolishParticiple$1;

var _PolishParticiple2 = _interopRequireDefault$Z(_PolishParticiple);

var _PortugueseParticiple = PortugueseParticiple$1;

var _PortugueseParticiple2 = _interopRequireDefault$Z(_PortugueseParticiple);

function _interopRequireDefault$Z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const matchParticiples = (0, _matchParticiples2.default)();
const regularParticipleRegex = matchParticiples.regularParticiples;
const irregularParticipleRegex = matchParticiples.irregularParticiples;

var getParticiples$1 = {};

var irregulars = {};

Object.defineProperty(irregulars, "__esModule", {
	value: true
});

irregulars.default = function () {
	return ["angefangen", "aufgerissen", "ausgesehen", "befohlen", "befunden", "begonnen", "bekommen", "bewiesen", "beworben", "empfohlen", "empfunden", "entschieden", "erschrocken", "erwogen", "gebacken", "gebeten", "gebissen", "geblasen", "geblieben", "gebogen", "geboren", "geborgen", "geboten", "gebraten", "gebrochen", "gebunden", "gediehen", "gedroschen", "gedrungen", "gefahren", "gefallen", "gefangen", "geflogen", "geflohen", "geflossen", "gefressen", "gefroren", "gefunden", "gegangen", "gegeben", "gegessen", "geglichen", "geglitten", "gelungen", "gegolten", "gegoren", "gegossen", "gegraben", "gegriffen", "gehalten", "gehangen", "gehauen", "geheissen", "geheißen", "gehoben", "geholfen", "geklungen", "gekniffen", "gekommen", "gekrochen", "geladen", "gelassen", "gelaufen", "gelegen", "gelesen", "geliehen", "gelitten", "gelogen", "gelungen", "gemessen", "gemieden", "genesen", "genommen", "genossen", "gepfiffen", "gepriesen", "gequollen", "geraten", "gerieben", "gerissen", "geritten", "gerochen", "geronnen", "gerufen", "gerungen", "geschaffen", "geschehen", "geschieden", "geschienen", "geschlafen", "geschlagen", "geschlichen", "geschliffen", "geschlossen", "geschlungen", "geschmissen", "geschmolzen", "geschnitten", "geschoben", "gescholten", "geschoren", "geschossen", "geschrieben", "geschrien", "geschritten", "geschunden", "geschwiegen", "geschwollen", "geschwommen", "geschworen", "geschwunden", "geschwungen", "gesehen", "gesessen", "gesoffen", "gesonnen", "gespien", "gesponnen", "gesprochen", "gesprossen", "gesprungen", "gestanden", "gestiegen", "gestochen", "gestohlen", "gestorben", "gestoßen", "gestossen", "gestrichen", "gestritten", "gesungen", "gesunken", "getan", "getragen", "getreten", "getrieben", "getroffen", "getrogen", "getrunken", "gewachsen", "gewaschen", "gewichen", "gewiesen", "gewoben", "gewogen", "gewonnen", "geworben", "geworfen", "gewrungen", "gezogen", "gezwungen", "misslungen", "überbacken", "ueberbacken", "überbehalten", "ueberbehalten", "überbekommen", "ueberbekommen", "überbelegen", "ueberbelegen", "überbezahlen", "ueberbezahlen", "überboten", "ueberboten", "übergebunden", "uebergebunden", "überbunden", "ueberbunden", "überblasen", "ueberblasen", "überbraten", "ueberbraten", "übergebraten", "uebergebraten",
	// Participles ending in -st are not found with the regex to avoid second person singular verbs.
	"überbremst", "ueberbremst", "übergeblieben", "uebergeblieben", "übereinandergelegen", "uebereinandergelegen", "übereinandergeschlagen", "uebereinandergeschlagen", "übereinandergesessen", "uebereinandergesessen", "übereinandergestanden", "uebereinandergestanden", "übereingefallen", "uebereingefallen", "übereingekommen", "uebereingekommen", "übereingetroffen", "uebereingetroffen", "übergefallen", "uebergefallen", "übergessen", "uebergessen", "überfahren", "ueberfahren", "übergefahren", "uebergefahren", "überfallen", "ueberfallen", "überfangen", "ueberfangen", "überflogen", "ueberflogen", "überflossen", "ueberflossen", "übergeflossen", "uebergeflossen", "überfressen", "ueberfressen", "überfroren", "ueberfroren", "übergegeben", "uebergegeben", "übergeben", "uebergeben", "übergegangen", "uebergegangen", "übergangen", "uebergangen", "übergangen", "uebergangen", "übergossen", "uebergossen", "übergriffen", "uebergriffen", "übergegriffen", "uebergegriffen", "übergehalten", "uebergehalten", "überhandgenommen", "ueberhandgenommen", "überhangen", "ueberhangen", "übergehangen", "uebergehangen", "übergehoben", "uebergehoben", "überhoben", "ueberhoben", "überkommen", "ueberkommen", "übergekommen", "uebergekommen", "überladen", "ueberladen", "übergeladen", "uebergeladen", "überlassen", "ueberlassen", "übergelassen", "uebergelassen", "überlaufen", "ueberlaufen", "übergelaufen", "uebergelaufen", "überlesen", "ueberlesen", "übergelegen", "uebergelegen", "übergenommen", "uebergenommen", "übernommen", "uebernommen", "übergequollen", "uebergequollen", "überrissen", "ueberrissen", "überritten", "ueberritten", "übergeschossen", "uebergeschossen", "überschlafen", "ueberschlafen", "überschlagen", "ueberschlagen", "übergeschlagen", "uebergeschlagen", "übergeschlossen", "uebergeschlossen", "überschnitten", "ueberschnitten", "überschrieben", "ueberschrieben", "überschrieen", "ueberschrieen", "überschrien", "ueberschrien", "überschritten", "ueberschritten", "überschwungen", "ueberschwungen", "übergesehen", "uebergesehen", "übersehen", "uebersehen", "übergesotten", "uebergesotten", "übergesotten", "uebergesotten", "übersponnen", "uebersponnen", "übersprochen", "uebersprochen", "übersprungen", "uebersprungen", "übergesprungen", "uebergesprungen", "überstochen", "ueberstochen", "übergestochen", "uebergestochen", "überstanden", "ueberstanden", "übergestanden", "uebergestanden", "überstiegen", "ueberstiegen", "übergestiegen", "uebergestiegen", "übergestrichen", "uebergestrichen", "überstrichen", "ueberstrichen", "übertragen", "uebertragen", "übertroffen", "uebertroffen", "übertrieben", "uebertrieben", "übertreten", "uebertreten", "übergetreten", "uebergetreten", "überwachsen", "ueberwachsen", "überwiesen", "ueberwiesen", "überworfen", "ueberworfen", "übergeworfen", "uebergeworfen", "überwogen", "ueberwogen", "überwunden", "ueberwunden", "überzogen", "ueberzogen", "übergezogen", "uebergezogen", "verdorben", "vergessen", "verglichen", "verloren", "verstanden", "verschwunden", "vorgeschlagen"];
};

var GermanParticiple$1 = {};

Object.defineProperty(GermanParticiple$1, "__esModule", {
  value: true
});

var _Participle$2 = Participle$1;

var _Participle2$2 = _interopRequireDefault$Y(_Participle$2);

var _indices$1 = indices;

var _exceptionsParticiplesActive = exceptionsParticiplesActive$1;

var _exceptionsParticiplesActive2 = _interopRequireDefault$Y(_exceptionsParticiplesActive);

var _auxiliaries$3 = auxiliaries$b;

var _auxiliaries2$3 = _interopRequireDefault$Y(_auxiliaries$3);

var _lodashEs$C = require$$1$1;

function _interopRequireDefault$Y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const exceptionsParticiplesActive = (0, _exceptionsParticiplesActive2.default)();

const auxiliaries$7 = (0, _auxiliaries2$3.default)().participleLike;

const exceptionsRegex = /\S+(apparat|arbeit|dienst|haft|halt|keit|kraft|not|pflicht|schaft|schrift|tät|wert|zeit)($|[ \n\r\t.,'()"+-;!?:/»«‹›<>])/ig;

/**
 * Creates an Participle object for the German language.
 *
 * @param {string} participle The participle.
 * @param {string} sentencePart The sentence part that contains the participle.
 * @param {object} attributes  The attributes object.
 *
 * @constructor
 */
const GermanParticiple = function GermanParticiple(participle, sentencePart, attributes) {
  _Participle2$2.default.call(this, participle, sentencePart, attributes);
  this.setSentencePartPassiveness(this.isPassive());
};

require$$2$1.inherits(GermanParticiple, _Participle2$2.default);

/**
 * Checks if the text is passive based on the participle exceptions.
 *
 * @returns {boolean} Returns true if there is no exception, and the sentence is passive.
 */
GermanParticiple.prototype.isPassive = function () {
  return !this.hasNounSuffix() && !this.isInExceptionList() && !this.hasHabenSeinException() && !this.isAuxiliary();
};

/**
 * Checks whether a found participle is in the exception list.
 * If a word is in the exceptionsParticiplesActive list, it isn't a participle.
 *
 * @returns {boolean} Returns true if it is in the exception list, otherwise returns false.
 */
GermanParticiple.prototype.isInExceptionList = function () {
  return (0, _lodashEs$C.includes)(exceptionsParticiplesActive, this.getParticiple());
};

/**
 * Checks whether a found participle ends in a noun suffix.
 * If a word ends in a noun suffix from the exceptionsRegex, it isn't a participle.
 *
 * @returns {boolean} Returns true if it ends in a noun suffix, otherwise returns false.
 */
GermanParticiple.prototype.hasNounSuffix = function () {
  return this.getParticiple().match(exceptionsRegex) !== null;
};

/**
 * Checks whether a participle is followed by 'haben' or 'sein'.
 * If a participle is followed by one of these, the sentence is not passive.
 *
 * @returns {boolean} Returns true if it is an exception, otherwise returns false.
 */
GermanParticiple.prototype.hasHabenSeinException = function () {
  const participleIndices = (0, _indices$1.getIndicesByWord)(this.getParticiple(), this.getSentencePart());
  let habenSeinIndices = (0, _indices$1.getIndicesByWordList)(["haben", "sein"], this.getSentencePart());

  // Don't check further if there is no participle or no haben/sein.
  if (participleIndices.length === 0 || habenSeinIndices.length === 0) {
    return false;
  }

  habenSeinIndices = (0, _lodashEs$C.map)(habenSeinIndices, "index");
  const currentParticiple = participleIndices[0];

  return (0, _lodashEs$C.includes)(habenSeinIndices, currentParticiple.index + currentParticiple.match.length + 1);
};

/**
 * Checks whether a found participle is an auxiliary.
 * If a word is an auxiliary, it isn't a participle.
 *
 * @returns {boolean} Returns true if it is an auxiliary, otherwise returns false.
 */
GermanParticiple.prototype.isAuxiliary = function () {
  return (0, _lodashEs$C.includes)(auxiliaries$7, this.getParticiple());
};

GermanParticiple$1.default = GermanParticiple;

Object.defineProperty(getParticiples$1, "__esModule", {
	value: true
});

getParticiples$1.default = function (sentencePartText, auxiliaries, language) {
	var words = (0, _getWords2$7.default)(sentencePartText);

	var foundParticiples = [];

	(0, _lodashEs$B.forEach)(words, function (word) {
		if (verbsBeginningWithGe(word).length !== 0) {
			foundParticiples.push(new _GermanParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: "ge at beginning", language: language }));
			return;
		}
		if (verbsWithGeInMiddle(word).length !== 0) {
			foundParticiples.push(new _GermanParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: "ge in the middle", language: language }));
			return;
		}
		if (verbsBeginningWithErVerEntBeZerHerUber(word).length !== 0) {
			foundParticiples.push(new _GermanParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: "er/ver/ent/be/zer/her at beginning", language: language }));
			return;
		}
		if (verbsWithErVerEntBeZerHerUberInMiddle(word).length !== 0) {
			foundParticiples.push(new _GermanParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: "er/ver/ent/be/zer/her in the middle", language: language }));
			return;
		}
		if (verbsEndingWithIert(word).length !== 0) {
			foundParticiples.push(new _GermanParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: "iert at the end", language: language }));
		}
		if ((0, _lodashEs$B.includes)(irregularParticiples, word)) {
			foundParticiples.push(new _GermanParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: "irregular", language: language }));
		}
	});
	return foundParticiples;
};

var _getWords$7 = getWords;

var _getWords2$7 = _interopRequireDefault$X(_getWords$7);

var _regex = regex;

var _regex2 = _interopRequireDefault$X(_regex);

var _irregulars = irregulars;

var _irregulars2 = _interopRequireDefault$X(_irregulars);

var _GermanParticiple = GermanParticiple$1;

var _GermanParticiple2 = _interopRequireDefault$X(_GermanParticiple);

var _lodashEs$B = require$$1$1;

function _interopRequireDefault$X(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const regexFunction = (0, _regex2.default)();
var verbsBeginningWithErVerEntBeZerHerUber = regexFunction.verbsBeginningWithErVerEntBeZerHerUber;
var verbsBeginningWithGe = regexFunction.verbsBeginningWithGe;
var verbsWithGeInMiddle = regexFunction.verbsWithGeInMiddle;
var verbsWithErVerEntBeZerHerUberInMiddle = regexFunction.verbsWithErVerEntBeZerHerUberInMiddle;
var verbsEndingWithIert = regexFunction.verbsEndingWithIert;

const irregularParticiples = (0, _irregulars2.default)();

var auxiliaries$6 = {};

Object.defineProperty(auxiliaries$6, "__esModule", {
	value: true
});

auxiliaries$6.default = function () {
	return ["word", "wordt", "worden", "werd", "werden", "wordend"];
};

var auxiliaries$5 = {};

Object.defineProperty(auxiliaries$5, "__esModule", {
	value: true
});

auxiliaries$5.default = function () {
	return ["być", "jestem", "jesteś", "jest", "jesteśmy", "jesteście", "są", "byłam", "byłem", "byłeś", "byłaś", "był", "była", "było", "byłoby", "byliśmy", "byłyśmy", "byliście", "byłyście", "byli", "były", "będę", "będziesz", "będzie", "będziemy", "będziecie", "będą", "byłabym", "byłbym", "byłbyś", "byłabyś", "byłaby", "byłby", "bylibyśmy", "byłybyśmy", "bylibyście", "byłybyście", "byłby", "byłaby", "byliby", "byłyby", "zostać", "zostaje", "zostajesz", "zostaję", "zostajecie", "zostajemy", "zostają", "zostanę", "zostaniesz", "zostanie", "zostaniemy", "zostaniecie", "zostaną", "zostałem", "zostałam", "zostałaś", "zostałeś", "został", "została", "zostało", "zostaliśmy", "zostałyśmy", "zostaliście", "zostałyście", "zostali", "zostały", "zostałbym", "zostałabym", "zostałbyś", "zostałabyś", "zostałby", "zostałaby", "zostałybyśmy", "zostalibyśmy", "zostalibyście", "zostałybyście", "zostaliby", "zostałyby"];
};

var getParticiples = {};

var participles$1 = {};

Object.defineProperty(participles$1, "__esModule", {
	value: true
});
/*
 * Adapted from: Kornai, A, Halácsy, P, Nagy, V, Oravecz, Cs, Trón, V, and Varga, D (2006). Web-based frequency
 * dictionaries for medium density languages. In: Proceedings of the 2nd International Workshop on Web as Corpus,
 * edited by Adam Kilgarriff, Marco Baroni  ACL-06, pages 1-9, under Creative Commons Attribution-ShareAlike 4.0
 * Internation (CC BY-SA 4.0) license. Common Crawl Terms of Use apply. The corpus user-interface can be found here:
 * http://szotar.mokk.bme.hu/szoszablya/searchq.php
 */

/**
 * Returns a list of the participles used for the Hungarian passive voice assessment.
 * This list only includes participles ending in -re and -ra.
 *
 * @returns {Array}                The list with participles.
 */
participles$1.default = [
// Participles ending in -re.
"megvételre", "megrendezésre", "képzésre", "kifejezésre", "következtetésre", "fejlesztésre", "bevezetésre", "kezelésre", "ellenőrzésre", "elhelyezésre", "értékesítésre", "cselekvésre", "beépítésre", "intézkedésre", "kifizetésre", "működésre", "értékelésre", "egyeztetésre", "rögzítésre", "megjelenésre", "meghirdetésre", "fizetésre", "megbeszélésre", "bejelentésre", "bekezdésre", "közreműködésre", "teljesítésre", "elküldésre", "kivitelezésre", "kihirdetésre", "korszerűsítésre", "előterjesztésre", "üzemeltetésre", "szerződéskötésre", "visszafizetésre", "befektetésre", "minősítésre", "telepítésre", "megfigyelésre", "berendezésre", "megerősítésre", "megtekintésre", "feltüntetésre", "megkülönböztetésre", "befizetésre", "megszüntetésre", "kinevezésre", "előkészítésre", "felmentésre", "megszervezésre", "gyógykezelésre", "mérlegelésre", "végkielégítésre", "engedélyezésre", "kihelyezésre", "megsemmisítésre", "előrelépésre", "tenyésztésre", "elnevezésre", "befejezésre", "ismétlésre", "egyesülésre", "közvetítésre", "lekérdezésre", "szervezésre", "csökkentésre", "területfejlesztésre", "költségtérítésre", "felfüggesztésre", "frissítésre", "vámfizetésre", "kifejlesztésre", "elhelyezkedésre", "teremtésre", "megjelölésre", "töltésre", "kiegyenlítésre", "kifejtésre", "megépítésre", "átszervezésre", "termesztésre", "felemelkedésre", "átépítésre", "áremelésre", "áthelyezésre", "újjáépítésre", "megbecsülésre", "átültetésre", "visszaigénylésre", "feljegyzésre", "törlesztésre", "helyettesítésre", "követelésre", "érvelésre", "elkülönítésre", "átképzésre", "kiértékelésre", "térítésre", "továbbfejlesztésre", "ösztönzésre", "szerkesztésre", "megítélésre", "letöltésre", "selejtezésre", "segélyezésre", "érintkezésre", "emelkedésre", "megküldésre", "erősítésre", "felderítésre", "védésre", "elbeszélgetésre", "megemlítésre", "felépítésre", "megfejtésre", "mentesítésre", "előfizetésre", "megtervezésre", "szakképesítésre", "hitelesítésre", "megnevezésre", "érvényesítésre", "számonkérésre", "terjeszkedésre", "beterjesztésre", "összevetésre", "jogsértésre", "véglegesítésre", "kiküldetésre", "megörökítésre", "kivégzésre", "költözésre", "megtérülésre", "kézbesítésre", "közmegegyezésre", "idézésre", "kirekesztésre", "visszaesésre", "beszerelésre", "beültetésre", "kiterjesztésre", "kifüggesztésre", "leépítésre", "megismerkedésre", "végzésre", "részletfizetésre", "megfizetésre", "kiürítésre", "ízesítésre", "méregtelenítésre", "rendszerezésre", "felterjesztésre", "szemléltetésre", "megtermékenyítésre", "lekötésre", "kiegyezésre", "előrejelzésre", "ellenvetésre", "növelésre", "képesítésre", "beszedésre", "ellenjegyzésre", "áttelepítésre", "egységesítésre", "akadálymentesítésre", "előtörlesztésre",
// Participles ending in -ra.
"azonosításra", "aktiválásra", "hasznosításra", "foglalkoztatásra", "finanszírozásra", "megfinanszírozásra", "benyújtásra", "pontosításra", "forgalmazásra", "beszállításra", "felzárkózásra", "továbbításra", "differenciálásra", "folyósításra", "kiszállításra", "átcsoportosításra", "kártalanításra", "továbbgondolásra", "felzárkóztatásra", "megválaszolásra", "átállásra", "számlázásra", "fotózásra", "megvásárlásra", "felszámításra", "kiszámlázásra", "lehívásra", "leszámlázásra", "továbbjutásra", "szaporításra", "raktározásra", "kinyomtatásra", "reklámozásra", "újrahasznosításra", "archiválásra", "elővásárlásra", "visszautalásra", "létrehozásra", "tanúsításra", "ártalmatlanításra", "adományozásra", "kisorsolásra", "utalványozásra", "átgondolásra", "azonosulásra", "postázásra", "televíziózásra", "átsorolásra", "finomításra", "privatizálásra", "dokumentálásra", "beiskolázásra", "digitalizálásra", "újragondolásra", "aktualizálásra", "delegálásra", "pályáztatásra", "voksolásra", "felhordásra", "moderálásra", "áthaladásra", "gyámolításra", "lajstromozásra", "sokszorosításra", "elsajátításra", "szigorításra", "klónozásra", "elhatárolódásra", "elbontásra", "kiaknázásra", "befolyásolásra", "renoválásra", "kivárásra", "feliratozásra", "akkreditálásra", "parkosításra", "szakosodásra", "legyártásra", "továbbgondolkodásra", "magánosításra", "összehangolásra", "megvilágosodásra", "titkosításra", "integrálásra", "visszaadásra", "rangsorolásra", "kilábalásra", "szponzorálásra", "szankcionálásra", "modernizálásra", "leltározásra", "koordinálásra", "apostolkodásra", "definiálásra", "komposztálásra", "elvándorlásra", "átváltásra", "kódolásra", "naplózásra", "adagolásra", "megtámadásra", "exportálásra", "betáplálásra", "kompenzálásra", "kapaszkodásra", "áthallgatásra", "dedikálásra", "beindításra", "kimunkálásra", "hamisításra", "megigazulásra", "újratárgyalásra", "visszaszállításra", "megalapításra", "szabványosításra", "tartósításra", "meditálásra", "palackozásra", "bírságolásra", "listázásra", "liberalizálásra", "iskoláztatásra", "auditálásra", "monitorozásra", "visszapótlásra", "sugalmazásra", "kipostázásra", "előrejutásra", "gyarapításra", "visszaosztásra", "konzerválásra", "adóztatásra", "decentralizálásra", "diagnosztizálásra", "harmonizálásra", "konszolidálásra", "átszállításra", "realizálásra", "beazonosításra", "szelektálásra", "újraszabályozásra", "kihúzásra", "optimalizálásra", "bevizsgálásra", "kiválogatásra", "leosztásra", "szállítmányozásra", "torzításra", "visszaigazolásra", "visszaszolgáltatásra", "rehabilitálásra", "továbbtartásra", "darabolásra", "felhasználásra", "bemutatásra", "ellátásra", "felújításra", "kialakításra", "átadásra", "kiállításra", "feldolgozásra", "módosításra", "változásra", "kiosztásra", "beavatkozásra", "megvalósításra", "megállapodásra", "jóváhagyásra", "szabályozásra", "változtatásra", "elszámolásra", "felhívásra", "meghallgatásra", "elbírálásra", "végrehajtásra", "lemondásra", "elhatározásra", "kiírásra", "megfogalmazásra", "népszavazásra", "kiválasztásra", "hozzájárulásra", "bemutatkozásra", "felszólalásra", "elutasításra", "megvitatásra", "levonásra", "átutalásra", "kizárásra", "előállításra", "bizonyításra", "kárpótlásra", "nyomtatásra", "felállításra", "beszámításra", "pótlásra", "publikálásra", "megbízásra", "felbontásra", "megválasztásra", "kibocsátásra", "kivizsgálásra", "lebontásra", "feltárásra", "felosztásra", "visszavonásra", "elosztásra", "felvásárlásra", "megbocsátásra", "szétosztásra", "megújításra", "megnyitásra", "korlátozásra", "bérbeadásra", "eltiltásra", "elbocsátásra", "meghosszabbításra", "bebocsátásra", "levágásra", "restaurálásra", "felajánlásra", "kivágásra", "kormányalakításra", "megmunkálásra", "osztályozásra", "sorozatgyártásra", "betakarításra", "leszámolásra"];

var HungarianParticiple$1 = {};

var nonPassivesInVaAndVe = {};

Object.defineProperty(nonPassivesInVaAndVe, "__esModule", {
	value: true
});
/*
 * Adapted from: Kornai, A, Halácsy, P, Nagy, V, Oravecz, Cs, Trón, V, and Varga, D (2006). Web-based frequency
 * dictionaries for medium density languages. In: Proceedings of the 2nd International Workshop on Web as Corpus,
 * edited by Adam Kilgarriff, Marco Baroni  ACL-06, pages 1-9, under Creative Commons Attribution-ShareAlike 4.0
 * Internation (CC BY-SA 4.0) license. Common Crawl Terms of Use apply. The corpus user-interface can be found here:
 * http://szotar.mokk.bme.hu/szoszablya/searchq.php
 */

/**
 * Returns a list of words that look like the participles used for the Hungarian passive voice assessment.
 * This list only includes words that look like participles ending in -re and -ra.
 *
 * @returns {Array}                The list with words that look like participles.
 */
nonPassivesInVaAndVe.default = [
// Non passives ending in -va.
"éva", "szava", "moszkva", "alternatíva", "normatíva", "java", "jelszava", "direktíva", "perspektíva", "dráva", "lova", "kurva", "szilva", "páva", "kollektíva", "lárva", "szarva", "tava", "láva", "díva", "ponyva", "hava", "offenzíva", "előszava", "borotva", "színe-java", "hamva", "káva", "legjava", "mályva", "murva", "olíva", "híre-hamva", "pelyva", "címszava", "dudva", "sava", "csóva", "golyva", "árva", "fénycsóva", "utószava", "antikva", "közjava", "aktíva", "hadiárva", "morotva", "gyomorsava", "villanyborotva", "alapszava", "szerva", "odva", "naiva", "szupernova", "félárva", "harangszava", "szlalomozva", "halastava", "vezényszava", "falova", "defenzíva", "lángcsóva", "varázsszava", "végszava", "hadova", "dzsuva", "pányva", "sátorponyva", "parancsszava", "vezérszava", "falva", "durva", "gyáva", "tétova", "zagyva", "mogorva", "morva", "híva", "báva", "hova", "fordítva", "ahova", "felváltva", "valahova", "kurva", "sehova", "kisvártatva", "játszva", "hivatva", "mindenhova", "tova", "bárhova", "lopva", "idestova", "elragadtatva", "lélekszakadva", "fejcsóválva", "akárhova", "fogcsikorgatva", "tárva-nyitva", "hagyatva", "szájtátva", "készakarva", "karonfogva", "szívdobogva", "lélegzet-visszafojtva", "szívszorongva", "orozva", "fogvacogva", "szívszakadva", "fogvicsorítva", "bélapátfalva", "albertfalva",
// Non passives ending in -ve.
"éve", "neve", "könyve", "szíve", "teve", "elve", "műve", "kedve", "terve", "nyelve", "szerve", "medve", "híve", "alapelve", "törvénykönyve", "életműve", "irányelve", "kézikönyve", "felhasználóneve", "jegyzőkönyve", "diáknyelve", "leve", "ismérve", "tanterve", "hírneve", "objektíve", "íve", "emlékműve", "anyanyelve", "beceneve", "forgatókönyve", "féléve", "orgonaműve", "tankönyve", "alapköve", "jókedve", "évkönyve", "járműve", "köve", "keresztneve", "ráckeve", "munkaterve", "vezetékneve", "remekműve", "túrkeve", "töve", "öve", "futóműve", "heve", "sarokköve", "életéve", "vendégkönyve", "negyedéve", "jegesmedve", "csöve", "szócsöve", "keve", "üdve", "nedve", "gyűjtőneve", "fedőneve", "mérföldköve", "kéve", "ütemterve", "próbaköve", "gépjárműve", "domborműve", "ékköve", "rokonszenve", "érzékszerve", "kollektíve", "életkedve", "örve", "sérve", "verseskönyve", "füve", "építőköve", "ellenszenve", "álneve", "tanulmányterve", "szakácskönyve", "erőműve", "sarkköve", "barnamedve", "hajtóműve", "mesterműve", "színműve", "törzskönyve", "utóneve", "családneve", "formanyelve", "távcsöve", "tanéve", "mosómedve", "talpköve", "szövegkönyve", "sírköve", "keserve", "boltíve", "márkaneve", "munkakedve", "kérdőíve", "rosszkedve", "emlékkönyve", "gúnyneve", "szakkönyve", "pályaműve", "olvasókönyve", "előneve", "csúcsszerve", "személyneve", "atomerőműve", "útikönyve", "cséve", "telefonkönyve", "képeskönyve", "szabálykönyve", "nyakörve", "cseppköve", "látószerve", "mozgásszerve", "daloskönyve", "halászleve", "heresérve", "jogelve", "köldöksérve", "utcaneve", "eleve", "közvetve", "elvétve", "relatíve", "karöltve", "együttvéve", "vállvetve"];

Object.defineProperty(HungarianParticiple$1, "__esModule", {
  value: true
});

var _Participle$1 = Participle$1;

var _Participle2$1 = _interopRequireDefault$W(_Participle$1);

var _checkException = checkException;

var _checkException2 = _interopRequireDefault$W(_checkException);

var _nonPassivesInVaAndVe = nonPassivesInVaAndVe;

var _nonPassivesInVaAndVe2 = _interopRequireDefault$W(_nonPassivesInVaAndVe);

function _interopRequireDefault$W(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a Participle object for the Hungarian language.
 *
 * @param {string} participle           The participle.
 * @param {string} sentencePart         The sentence part that contains the participle.
 * @param {Object} attributes           The attributes object.
 *
 * @constructor
 */
const HungarianParticiple = function HungarianParticiple(participle, sentencePart, attributes) {
  _Participle2$1.default.call(this, participle, sentencePart, attributes);
  _checkException2.default.call(this);
};

require$$2$1.inherits(HungarianParticiple, _Participle2$1.default);

/**
 * Checks whether a found participle is in the nonPassivesInVaAndVe list.
 * If a word is in the nonPassivesInVaAndVe list, it isn't a participle.
 *
 * @returns {boolean} Returns true if it is in the nonVerbsEndingEd list, otherwise returns false.
 */
HungarianParticiple.prototype.isNonPassivesInVaAndVe = function () {
  return _nonPassivesInVaAndVe2.default.includes(this.getParticiple());
};

/**
 * Returns Hungarian participles used as passives unless they are on an exception list.
 *
 * @returns {boolean}       Returns true unless the participles are on an exception list.
 */
HungarianParticiple.prototype.isPassive = function () {
  return !this.isNonPassivesInVaAndVe();
};

HungarianParticiple$1.default = HungarianParticiple;

Object.defineProperty(getParticiples, "__esModule", {
	value: true
});

getParticiples.default = function (sentencePartText, auxiliaries, language) {
	const words = (0, _getWords2$6.default)(sentencePartText);

	const foundParticiples = [];

	(0, _lodashEs$A.forEach)(words, function (word) {
		if (word.endsWith("ve")) {
			foundParticiples.push(new _HungarianParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: "ve at the end", language: language }));
			return;
		}
		if (word.endsWith("va")) {
			foundParticiples.push(new _HungarianParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: "va at the end", language: language }));
			return;
		}
		if (word.endsWith("ódni")) {
			foundParticiples.push(new _HungarianParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: "ódni at the end", language: language }));
			return;
		}
		if (word.endsWith("ődni")) {
			foundParticiples.push(new _HungarianParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: "ődni at the end", language: language }));
			return;
		}
		if (_participles2$1.default.includes(word)) {
			foundParticiples.push(new _HungarianParticiple2.default(word, sentencePartText, { auxiliaries: auxiliaries, type: "re/ra at the end", language: language }));
		}
	});
	return foundParticiples;
};

var _getWords$6 = getWords;

var _getWords2$6 = _interopRequireDefault$V(_getWords$6);

var _participles$1 = participles$1;

var _participles2$1 = _interopRequireDefault$V(_participles$1);

var _HungarianParticiple = HungarianParticiple$1;

var _HungarianParticiple2 = _interopRequireDefault$V(_HungarianParticiple);

var _lodashEs$A = require$$1$1;

function _interopRequireDefault$V(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a list with auxiliaries for the Hungarian passive voice assessment.
 * @returns {Array}             The list with auxiliaries.
 */
const auxiliariesParticipleRaAndRe = ["kerülök", "kerülsz", "kerül", "kerülünk", "kerültök", "kerülnek", "kerüljek", "kerülj", "kerüljön", "kerüljünk", "kerüljetek", "kerüljenek", "kerülnék", "kerülnél", "kerülne", "kerülnénk", "kerülnétek", "kerülnének", "kerültem", "kerültél", "került", "kerültünk", "kerültetek", "kerültek", "kerültem volna", "kerültél volna", "került volna", "kerültünk volna", "kerültetek vola", "kerültek volna", "fogok kerülni", "fogsz kerülni", "fog kerülni", "fogunk kerülni", "fogtok kerülni", "fognak kerülni"];

const auxiliariesParticipleVaAndVe = ["vagyok", "vagy", "van", "vagyunk", "vagytok", "vannak", "legyek", "legyél", "legyen", "legyünk", "legyetek", "legyenek", "lennék", "lennél", "lenne", "lennénk", "lennétek", "lennének", "leszek", "leszel", "lesz", "leszünk", "lesztek", "lesznek", "voltam", "voltál", "volt", "voltunk", "voltatok", "voltak", "lettem volna", "lettél volna", "lett volna", "lettünk volna", "lettetek volna", "lettek volna"];

const auxiliariesParticipleOdni = ["fogok", "fogsz", "fog", "fogunk", "fogtok", "fognak"];

/**
 * Returns an list with transition words to be used by the assessments.
 * @returns {Object} The list filled with transition word lists.
 */
var auxiliaries$4 = function () {
	return {
		auxiliaries1: auxiliariesParticipleRaAndRe,
		auxiliaries2: auxiliariesParticipleVaAndVe,
		auxiliaries3: auxiliariesParticipleOdni,
		allAuxiliaries: [].concat(auxiliariesParticipleRaAndRe, auxiliariesParticipleVaAndVe, auxiliariesParticipleOdni)
	};
};

Object.defineProperty(determinePassiveSentencePart, "__esModule", {
	value: true
});

determinePassiveSentencePart.default = function (sentencePartText, sentencePartAuxiliaries, language) {
	let participles = [];
	// For German, Dutch, Hungarian, and Polish, this path is taken in order to ensure that sentence parts without auxiliaries are not set to passive.
	if (language === "de" || language === "nl" || language === "pl" || language === "hu") {
		// Return false if there are no auxiliaries in the sentence part.
		if (!sentencePartAuxiliaries.some(auxiliary => languageVariables$2[language].auxiliaries.includes(auxiliary))) {
			return false;
		}
		// For German, we use a separate function to get participles.
		if (language === "de") {
			participles = (0, _getParticiples4.default)(sentencePartText, sentencePartAuxiliaries, language);
		}
		// For Dutch and Polish, we use the same function as for other languages.
		if (language === "nl" || language === "pl") {
			participles = (0, _getParticiples2$9.default)(sentencePartText, sentencePartAuxiliaries, language);
		}
		if (language === "hu") {
			participles = (0, _getParticiples6.default)(sentencePartText, sentencePartAuxiliaries, language);
		}
	} else {
		participles = (0, _getParticiples2$9.default)(sentencePartText, sentencePartAuxiliaries, language);
	}

	return (0, _determineSentencePartIsPassive2.default)(participles);
};

var _determineSentencePartIsPassive = determineSentencePartIsPassive;

var _determineSentencePartIsPassive2 = _interopRequireDefault$U(_determineSentencePartIsPassive);

var _getParticiples$9 = getParticiples$2;

var _getParticiples2$9 = _interopRequireDefault$U(_getParticiples$9);

var _auxiliaries$2 = auxiliaries$b;

var _auxiliaries2$2 = _interopRequireDefault$U(_auxiliaries$2);

var _getParticiples3 = getParticiples$1;

var _getParticiples4 = _interopRequireDefault$U(_getParticiples3);

var _auxiliaries3$2 = auxiliaries$6;

var _auxiliaries4$2 = _interopRequireDefault$U(_auxiliaries3$2);

var _auxiliaries5$2 = auxiliaries$5;

var _auxiliaries6$2 = _interopRequireDefault$U(_auxiliaries5$2);

var _getParticiples5 = getParticiples;

var _getParticiples6 = _interopRequireDefault$U(_getParticiples5);

var _auxiliaries7$2 = auxiliaries$4;

var _auxiliaries8$2 = _interopRequireDefault$U(_auxiliaries7$2);

function _interopRequireDefault$U(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const auxiliariesGerman$1 = (0, _auxiliaries2$2.default)().allAuxiliaries;

// Imports specific for German.


// Imports specific for Dutch.

const auxiliariesDutch$1 = (0, _auxiliaries4$2.default)();

// Imports specific for Polish.

const auxiliariesPolish$1 = (0, _auxiliaries6$2.default)();

// Imports specific for Hungarian.

const auxiliariesHungarian$1 = (0, _auxiliaries8$2.default)().allAuxiliaries;

// The language-specific auxiliaries.
const languageVariables$2 = {
	de: {
		auxiliaries: auxiliariesGerman$1
	},
	nl: {
		auxiliaries: auxiliariesDutch$1
	},
	pl: {
		auxiliaries: auxiliariesPolish$1
	},
	hu: {
		auxiliaries: auxiliariesHungarian$1
	}
};

var determinePassiveSentence = {};

var participlesShortenedList = {};

Object.defineProperty(participlesShortenedList, "__esModule", {
	value: true
});

participlesShortenedList.default = function () {
	return {
		all: passiveVerbs$1.concat(orthographicFormsPassiveVerbs, alternativeVerbForms, adjectiveParticiples)
	};
};

/**
 * Returns a list of all frequent participles used for the Russian passive voice assessment.
 * For each participle, versions for all four possible suffixes (-[], -а, -о, -ы) are included for masculine, feminine,
 * neuter, and plural respectively.
 * @returns {Array} The list with participles.
 */
const passiveVerbs$1 = ["абсолютизирован", "абсолютизирована", "абсолютизировано", "абсолютизированы", "абстрагирован", "абстрагирована", "абстрагировано", "абстрагированы", "автоматизирован", "автоматизирована", "автоматизировано", "автоматизированы", "адаптирован", "адаптирована", "адаптировано", "адаптированы", "адресован", "адресована", "адресовано", "адресованы", "адсорбирован", "адсорбирована", "адсорбировано", "адсорбированы", "аккредитован", "аккредитована", "аккредитовано", "аккредитованы", "аккумулирован", "аккумулирована", "аккумулировано", "аккумулированы", "активизирован", "активизирована", "активизировано", "активизированы", "активирован", "активирована", "активировано", "активированы", "актуализирован", "актуализирована", "актуализировано", "актуализированы", "акцентирован", "акцентирована", "акцентировано", "акцентированы", "амнистирован", "амнистирована", "амнистировано", "амнистированы", "амортизирован", "амортизирована", "амортизировано", "амортизированы", "ампутирован", "ампутирована", "ампутировано", "ампутированы", "ангажирован", "ангажирована", "ангажировано", "ангажированы", "аннулирован", "аннулирована", "аннулировано", "аннулированы", "анонсирован", "анонсирована", "анонсировано", "анонсированы", "апробирован", "апробирована", "апробировано", "апробированы", "аранжирован", "аранжирована", "аранжировано", "аранжированы", "аргументирован", "аргументирована", "аргументировано", "аргументированы", "арендован", "арендована", "арендовано", "арендованы", "арестован", "арестована", "арестовано", "арестованы", "ассигнован", "ассигнована", "ассигновано", "ассигнованы", "ассимилирован", "ассимилирована", "ассимилировано", "ассимилированы", "ассоциирован", "ассоциирована", "ассоциировано", "ассоциированы", "атакован", "атакована", "атаковано", "атакованы", "аттестован", "аттестована", "аттестовано", "аттестованы", "благословлен", "благословлена", "благословлено", "благословлены", "благоустроен", "благоустроена", "благоустроено", "благоустроены", "блокирован", "блокирована", "блокировано", "блокированы", "бойкотирован", "бойкотирована", "бойкотировано", "бойкотированы", "бронирован", "бронирована", "бронировано", "бронированы", "брошен", "брошена", "брошено", "брошены", "вакцинирован", "вакцинирована", "вакцинировано", "вакцинированы", "вбит", "вбита", "вбито", "вбиты", "вброшен", "вброшена", "вброшено", "вброшены", "вбухан", "вбухана", "вбухано", "вбуханы", "введен", "введена", "введено", "введены", "ввезен", "ввезена", "ввезено", "ввезены", "ввергнут", "ввергнута", "ввергнуто", "ввергнуты", "вверен", "вверена", "вверено", "вверены", "ввернут", "ввернута", "ввернуто", "ввернуты", "ввинчен", "ввинчена", "ввинчено", "ввинчены", "вдавлен", "вдавлена", "вдавлено", "вдавлены", "вдарен", "вдарена", "вдарено", "вдарены", "вдвинут", "вдвинута", "вдвинуто", "вдвинуты", "вделан", "вделана", "вделано", "вделаны", "вдет", "вдета", "вдето", "вдеты", "вдолблен", "вдолблена", "вдолблено", "вдолблены", "вдохновлен", "вдохновлена", "вдохновлено", "вдохновлены", "венчан", "венчана", "венчано", "венчаны", "вжат", "вжата", "вжато", "вжаты", "вживлен", "вживлена", "вживлено", "вживлены", "взбаламучен", "взбаламучена", "взбаламучено", "взбаламучены", "взбешен", "взбешена", "взбешено", "взбешены", "взбит", "взбита", "взбито", "взбиты", "взбодрен", "взбодрена", "взбодрено", "взбодрены", "взболтан", "взболтана", "взболтано", "взболтаны", "взбудоражена", "взбудоражено", "взбудоражены", "взведен", "взведена", "взведено", "взведены", "взвешен", "взвешена", "взвешено", "взвешены", "взвинчен", "взвинчена", "взвинчено", "взвинчены", "взвихрен", "взвихрена", "взвихрено", "взвихрены", "взволнована", "взволновано", "взволнованы", "взгромозжден", "взгромозждена", "взгромозждено", "взгромозждены", "вздернут", "вздернута", "вздернуто", "вздернуты", "вздет", "вздета", "вздето", "вздеты", "вздут", "вздута", "вздуто", "вздуты", "вздыблен", "вздыблена", "вздыблено", "вздыблены", "взлелеян", "взлелеяна", "взлелеяно", "взлелеяны", "взломан", "взломана", "взломано", "взломаны", "взлохмачен", "взлохмачена", "взлохмачено", "взлохмачены", "взметнут", "взметнута", "взметнуто", "взметнуты", "взмылен", "взмылена", "взмылено", "взмылены", "взнуздан", "взнуздана", "взнуздано", "взнузданы", "взорван", "взорвана", "взорвано", "взорваны", "взращен", "взращена", "взращено", "взращены", "взрезан", "взрезана", "взрезано", "взрезаны", "взрыхлен", "взрыхлена", "взрыхлено", "взрыхлены", "взъерошен", "взъерошена", "взъерошено", "взъерошены", "взыскан", "взыскана", "взыскано", "взысканы", "взят", "взята", "взято", "взяты", "видоизменен", "видоизменена", "видоизменено", "видоизменены", "визирован", "визирована", "визировано", "визированы", "вкачен", "вкачена", "вкачено", "вкачены", "вклеен", "вклеена", "вклеено", "вклеены", "включен", "включена", "включено", "включены", "вколот", "вколота", "вколото", "вколоты", "вколочен", "вколочена", "вколочено", "вколочены", "вкопан", "вкопана", "вкопано", "вкопаны", "вкраплен", "вкраплена", "вкраплено", "вкраплены", "вкушен", "вкушена", "вкушено", "вкушены", "влеплен", "влеплена", "влеплено", "влеплены", "влит", "влита", "влито", "влиты", "вложен", "вложена", "вложено", "вложены", "вмазан", "вмазана", "вмазано", "вмазаны", "вменен", "вменена", "вменено", "вменены", "вмещен", "вмещена", "вмещено", "вмещены", "вмонтирован", "вмонтирована", "вмонтировано", "вмонтированы", "вмурован", "вмурована", "вмуровано", "вмурованы", "вмят", "вмята", "вмято", "вмяты", "внедрен", "внедрена", "внедрено", "внедрены", "внесен", "внесена", "внесено", "внесены", "внушен", "внушена", "внушено", "внушены", "вобран", "вобрана", "вобрано", "вобраны", "вовлечен", "вовлечена", "вовлечено", "вовлечены", "вогнан", "вогнана", "вогнано", "вогнаны", "водворен", "водворена", "водворено", "водворены", "водружен", "водружена", "водружено", "водружены", "возбуждена", "возбуждено", "возбуждены", "возведен", "возведена", "возведено", "возведены", "возвеличен", "возвеличена", "возвеличено", "возвеличены", "возвещен", "возвещена", "возвещено", "возвещены", "возвращен", "возвращена", "возвращено", "возвращены", "возвышен", "возвышена", "возвышено", "возвышены", "возглавлен", "возглавлена", "возглавлено", "возглавлены", "возглашен", "возглашена", "возглашено", "возглашены", "воздвигнут", "воздвигнута", "воздвигнуто", "воздвигнуты", "возделан", "возделана", "возделано", "возделаны", "возложен", "возложена", "возложено", "возложены", "возмещен", "возмещена", "возмещено", "возмещены", "возмущена", "возмущено", "возмущены", "вознагражден", "вознаграждена", "вознаграждено", "вознаграждены", "вознесен", "вознесена", "вознесено", "вознесены", "возобновлен", "возобновлена", "возобновлено", "возобновлены", "возрожден", "возрождена", "возрождено", "возрождены", "воображен", "воображена", "воображено", "воображены", "воодушевлен", "воодушевлена", "воодушевлено", "воодушевлены", "вооружен", "вооружена", "вооружено", "вооружены", "воплощен", "воплощена", "воплощено", "воплощены", "вопрошен", "вопрошена", "вопрошено", "вопрошены", "воскрешен", "воскрешена", "воскрешено", "воскрешены", "воспет", "воспета", "воспето", "воспеты", "воспитана", "воспитано", "воспитаны", "воспламенен", "воспламенена", "воспламенено", "воспламенены", "восполнен", "восполнена", "восполнено", "восполнены", "воспрещен", "воспрещена", "воспрещено", "воспрещены", "воспринят", "воспринята", "воспринято", "восприняты", "воспроизведен", "воспроизведена", "воспроизведено", "воспроизведены", "восславлен", "восславлена", "восславлено", "восславлены", "восстановлен", "восстановлена", "восстановлено", "восстановлены", "востребована", "востребовано", "востребованы", "восхищен", "восхищена", "восхищено", "восхищены", "воткнут", "воткнута", "воткнуто", "воткнуты", "впаян", "впаяна", "впаяно", "впаяны", "впечатлен", "впечатлена", "впечатлено", "впечатлены", "вписан", "вписана", "вписано", "вписаны", "впитан", "впитана", "впитано", "впитаны", "впихнут", "впихнута", "впихнуто", "впихнуты", "вплетен", "вплетена", "вплетено", "вплетены", "вправлен", "вправлена", "вправлено", "вправлены", "впрыснут", "впрыснута", "впрыснуто", "впрыснуты", "впряжен", "впряжена", "впряжено", "впряжены", "впущен", "впущена", "впущено", "впущены", "вразумлен", "вразумлена", "вразумлено", "вразумлены", "врезан", "врезана", "врезано", "врезаны", "врублен", "врублена", "врублено", "врублены", "вручен", "вручена", "вручено", "вручены", "врыт", "врыта", "врыто", "врыты", "всажен", "всажена", "всажено", "всажены", "вселен", "вселена", "вселено", "вселены", "вскинут", "вскинута", "вскинуто", "вскинуты", "вскипячен", "вскипячена", "вскипячено", "вскипячены", "всколыхнут", "всколыхнута", "всколыхнуто", "всколыхнуты", "вскопан", "вскопана", "вскопано", "вскопаны", "вскормлен", "вскормлена", "вскормлено", "вскормлены", "вскружен", "вскружена", "вскружено", "вскружены", "вскрыт", "вскрыта", "вскрыто", "вскрыты", "всосан", "всосана", "всосано", "всосаны", "вспахан", "вспахана", "вспахано", "вспаханы", "вспенен", "вспенена", "вспенено", "вспенены", "всплеснут", "всплеснута", "всплеснуто", "всплеснуты", "всполошен", "всполошена", "всполошено", "всполошены", "вспорот", "вспорота", "вспорото", "вспороты", "вставлен", "вставлена", "вставлено", "вставлены", "встревожен", "встревожена", "встревожено", "встревожены", "встречен", "встречена", "встречено", "встречены", "встроен", "встроена", "встроено", "встроены", "встряхнут", "встряхнута", "встряхнуто", "встряхнуты", "всунут", "всунута", "всунуто", "всунуты", "всучен", "всучена", "всучено", "всучены", "втащен", "втащена", "втащено", "втащены", "втерт", "втерта", "втерто", "втерты", "втиснут", "втиснута", "втиснуто", "втиснуты", "втолкнут", "втолкнута", "втолкнуто", "втолкнуты", "втолкован", "втолкована", "втолковано", "втолкованы", "втоптан", "втоптана", "втоптано", "втоптаны", "втравлен", "втравлена", "втравлено", "втравлены", "втянут", "втянута", "втянуто", "втянуты", "вшит", "вшита", "вшито", "вшиты", "выбелен", "выбелена", "выбелено", "выбелены", "выбит", "выбита", "выбито", "выбиты", "выболтан", "выболтана", "выболтано", "выболтаны", "выбран", "выбрана", "выбрано", "выбраны", "выбрит", "выбрита", "выбрито", "выбриты", "выброшен", "выброшена", "выброшено", "выброшены", "вывален", "вывалена", "вывалено", "вывалены", "вывалян", "вываляна", "вываляно", "вываляны", "выварен", "выварена", "выварено", "выварены", "выведан", "выведана", "выведано", "выведаны", "выведен", "выведена", "выведено", "выведены", "вывезен", "вывезена", "вывезено", "вывезены", "выверен", "выверена", "выверено", "выверены", "вывернут", "вывернута", "вывернуто", "вывернуты", "выветрен", "выветрена", "выветрено", "выветрены", "вывешен", "вывешена", "вывешено", "вывешены", "вывихнут", "вывихнута", "вывихнуто", "вывихнуты", "вывожен", "вывожена", "вывожено", "вывожены", "выворочен", "выворочена", "выворочено", "выворочены", "выгадан", "выгадана", "выгадано", "выгаданы", "выглажен", "выглажена", "выглажено", "выглажены", "выгнан", "выгнана", "выгнано", "выгнаны", "выгнут", "выгнута", "выгнуто", "выгнуты", "выговорен", "выговорена", "выговорено", "выговорены", "выгорожен", "выгорожена", "выгорожено", "выгорожены", "выгравирован", "выгравирована", "выгравировано", "выгравированы", "выгребен", "выгребена", "выгребено", "выгребены", "выгружен", "выгружена", "выгружено", "выгружены", "выдавлен", "выдавлена", "выдавлено", "выдавлены", "выдвинут", "выдвинута", "выдвинуто", "выдвинуты", "выдворен", "выдворена", "выдворено", "выдворены", "выделан", "выделана", "выделано", "выделаны", "выделен", "выделена", "выделено", "выделены", "выдержан", "выдержана", "выдержано", "выдержаны", "выдернут", "выдернута", "выдернуто", "выдернуты", "выдолблен", "выдолблена", "выдолблено", "выдолблены", "выдохнут", "выдохнута", "выдохнуто", "выдохнуты", "выдран", "выдрана", "выдрано", "выдраны", "выдрессирована", "выдрессировано", "выдрессированы", "выдуман", "выдумана", "выдумано", "выдуманы", "выдут", "выдута", "выдуто", "выдуты", "выжат", "выжата", "выжато", "выжаты", "выждан", "выждана", "выждано", "выжданы", "выжит", "выжита", "выжито", "выжиты", "выжран", "выжрана", "выжрано", "выжраны", "вызван", "вызвана", "вызвано", "вызваны", "вызволен", "вызволена", "вызволено", "вызволены", "вызнан", "вызнана", "вызнано", "вызнаны", "вызубрен", "вызубрена", "вызубрено", "вызубрены", "выигран", "выиграна", "выиграно", "выиграны", "выискан", "выискана", "выискано", "выисканы", "выказан", "выказана", "выказано", "выказаны", "выкачан", "выкачана", "выкачано", "выкачаны", "выкачен", "выкачена", "выкачено", "выкачены", "выкинут", "выкинута", "выкинуто", "выкинуты", "выклеван", "выклевана", "выклевано", "выклеваны", "выкликнут", "выкликнута", "выкликнуто", "выкликнуты", "выключен", "выключена", "выключено", "выключены", "выклянчен", "выклянчена", "выклянчено", "выклянчены", "выкован", "выкована", "выковано", "выкованы", "выковырян", "выковыряна", "выковыряно", "выковыряны", "выколот", "выколота", "выколото", "выколоты", "выколочен", "выколочена", "выколочено", "выколочены", "выкопан", "выкопана", "выкопано", "выкопаны", "выкормлен", "выкормлена", "выкормлено", "выкормлены", "выкорчеван", "выкорчевана", "выкорчевано", "выкорчеваны", "выкошен", "выкошена", "выкошено", "выкошены", "выкраден", "выкрадена", "выкрадено", "выкрадены", "выкрашен", "выкрашена", "выкрашено", "выкрашены", "выкрикнут", "выкрикнута", "выкрикнуто", "выкрикнуты", "выкроен", "выкроена", "выкроено", "выкроены", "выкручен", "выкручена", "выкручено", "выкручены", "выкупан", "выкупана", "выкупано", "выкупаны", "выкуплен", "выкуплена", "выкуплено", "выкуплены", "выкурен", "выкурена", "выкурено", "выкурены", "выкушен", "выкушена", "выкушено", "выкушены", "вылакан", "вылакана", "вылакано", "вылаканы", "вылеплен", "вылеплена", "вылеплено", "вылеплены", "вылечен", "вылечена", "вылечено", "вылечены", "вылизан", "вылизана", "вылизано", "вылизаны", "вылит", "вылита", "вылито", "вылиты", "выловлен", "выловлена", "выловлено", "выловлены", "выложен", "выложена", "выложено", "выложены", "выломан", "выломана", "выломано", "выломаны", "вылуплен", "вылуплена", "вылуплено", "вылуплены", "вымазан", "вымазана", "вымазано", "вымазаны", "выманен", "выманена", "выманено", "выманены", "вымаран", "вымарана", "вымарано", "вымараны", "вымахан", "вымахана", "вымахано", "вымаханы", "выменян", "выменяна", "выменяно", "выменяны", "выметен", "выметена", "выметено", "выметены", "вымолвлен", "вымолвлена", "вымолвлено", "вымолвлены", "вымолен", "вымолена", "вымолено", "вымолены", "вымотан", "вымотана", "вымотано", "вымотаны", "вымочен", "вымочена", "вымочено", "вымочены", "вымощен", "вымощена", "вымощено", "вымощены", "вымучен", "вымучена", "вымучено", "вымучены", "вымуштрован", "вымуштрована", "вымуштровано", "вымуштрованы", "вымыт", "вымыта", "вымыто", "вымыты", "вымышлен", "вымышлена", "вымышлено", "вымышлены", "вынесен", "вынесена", "вынесено", "вынесены", "выношен", "выношена", "выношено", "выношены", "вынужден", "вынуждена", "вынуждено", "вынуждены", "вынут", "вынута", "вынуто", "вынуты", "выпачкан", "выпачкана", "выпачкано", "выпачканы", "выпестован", "выпестована", "выпестовано", "выпестованы", "выпечен", "выпечена", "выпечено", "выпечены", "выпилен", "выпилена", "выпилено", "выпилены", "выписан", "выписана", "выписано", "выписаны", "выпит", "выпита", "выпито", "выпиты", "выпихнут", "выпихнута", "выпихнуто", "выпихнуты", "выплавлен", "выплавлена", "выплавлено", "выплавлены", "выплакан", "выплакана", "выплакано", "выплаканы", "выплачен", "выплачена", "выплачено", "выплачены", "выплеснут", "выплеснута", "выплеснуто", "выплеснуты", "выплюнут", "выплюнута", "выплюнуто", "выплюнуты", "выполнен", "выполнена", "выполнено", "выполнены", "выпорот", "выпорота", "выпорото", "выпороты", "выпотрошен", "выпотрошена", "выпотрошено", "выпотрошены", "выправлен", "выправлена", "выправлено", "выправлены", "выпровожен", "выпровожена", "выпровожено", "выпровожены", "выпростан", "выпростана", "выпростано", "выпростаны", "выпрошен", "выпрошена", "выпрошено", "выпрошены", "выпрямлен", "выпрямлена", "выпрямлено", "выпрямлены", "выпучен", "выпучена", "выпучено", "выпучены", "выпущен", "выпущена", "выпущено", "выпущены", "выпытан", "выпытана", "выпытано", "выпытаны", "выпячен", "выпячена", "выпячено", "выпячены", "выработан", "выработана", "выработано", "выработаны", "выражен", "выражена", "выражено", "выражены", "выращен", "выращена", "выращено", "выращены", "вырван", "вырвана", "вырвано", "вырваны", "вырезан", "вырезана", "вырезано", "вырезаны", "выровнян", "выровняна", "выровняно", "выровняны", "выронен", "выронена", "выронено", "выронены", "вырублен", "вырублена", "вырублено", "вырублены", "выруган", "выругана", "выругано", "выруганы", "выручен", "выручена", "выручено", "выручены", "вырыт", "вырыта", "вырыто", "вырыты", "высажен", "высажена", "высажено", "высажены", "высвечен", "высвечена", "высвечено", "высвечены", "высвобожден", "высвобождена", "высвобождено", "высвобождены", "выселен", "выселена", "выселено", "выселены", "высечен", "высечена", "высечено", "высечены", "высеян", "высеяна", "высеяно", "высеяны", "высижен", "высижена", "высижено", "высижены", "высказан", "высказана", "высказано", "высказаны", "выскоблен", "выскоблена", "выскоблено", "выскоблены", "выскребен", "выскребена", "выскребено", "выскребены", "выслан", "выслана", "выслано", "высланы", "выслежен", "выслежена", "выслежено", "выслежены", "выслужен", "выслужена", "выслужено", "выслужены", "выслушан", "выслушана", "выслушано", "выслушаны", "высмеян", "высмеяна", "высмеяно", "высмеяны", "высмотрен", "высмотрена", "высмотрено", "высмотрены", "высосан", "высосана", "высосано", "высосаны", "выспрошен", "выспрошена", "выспрошено", "выспрошены", "выставлен", "выставлена", "выставлено", "выставлены", "выстиран", "выстирана", "выстирано", "выстираны", "выстлан", "выстлана", "выстлано", "выстланы", "выстоян", "выстояна", "выстояно", "выстояны", "выстрадан", "выстрадана", "выстрадано", "выстраданы", "выстрелен", "выстрелена", "выстрелено", "выстрелены", "выстрижен", "выстрижена", "выстрижено", "выстрижены", "выстроен", "выстроена", "выстроено", "выстроены", "выструган", "выстругана", "выстругано", "выструганы", "выстужен", "выстужена", "выстужено", "выстужены", "высунут", "высунута", "высунуто", "высунуты", "высушен", "высушена", "высушено", "высушены", "высчитан", "высчитана", "высчитано", "высчитаны", "вытаращен", "вытаращена", "вытаращено", "вытаращены", "вытащен", "вытащена", "вытащено", "вытащены", "вытерплен", "вытерплена", "вытерплено", "вытерплены", "вытерт", "вытерта", "вытерто", "вытерты", "вытесан", "вытесана", "вытесано", "вытесаны", "вытеснен", "вытеснена", "вытеснено", "вытеснены", "выткан", "выткана", "выткано", "вытканы", "вытолкнут", "вытолкнута", "вытолкнуто", "вытолкнуты", "вытоптан", "вытоптана", "вытоптано", "вытоптаны", "выторгован", "выторгована", "выторговано", "выторгованы", "выточен", "выточена", "выточено", "выточены", "вытравлен", "вытравлена", "вытравлено", "вытравлены", "вытребован", "вытребована", "вытребовано", "вытребованы", "вытрясен", "вытрясена", "вытрясено", "вытрясены", "вытряхнут", "вытряхнута", "вытряхнуто", "вытряхнуты", "вытурен", "вытурена", "вытурено", "вытурены", "вытянут", "вытянута", "вытянуто", "вытянуты", "выужен", "выужена", "выужено", "выужены", "выучен", "выучена", "выучено", "выучены", "выхвачен", "выхвачена", "выхвачено", "выхвачены", "выхлебан", "выхлебана", "выхлебано", "выхлебаны", "выхлопотан", "выхлопотана", "выхлопотано", "выхлопотаны", "выхожен", "выхожена", "выхожено", "выхожены", "выхолощен", "выхолощена", "выхолощено", "выхолощены", "выцарапан", "выцарапана", "выцарапано", "выцарапаны", "вычеркнут", "вычеркнута", "вычеркнуто", "вычеркнуты", "вычерпан", "вычерпана", "вычерпано", "вычерпаны", "вычерчен", "вычерчена", "вычерчено", "вычерчены", "вычислен", "вычислена", "вычислено", "вычислены", "вычитан", "вычитана", "вычитано", "вычитаны", "вычищен", "вычищена", "вычищено", "вычищены", "вычленен", "вычленена", "вычленено", "вычленены", "вычтен", "вычтена", "вычтено", "вычтены", "вышвырнут", "вышвырнута", "вышвырнуто", "вышвырнуты", "вышит", "вышита", "вышито", "вышиты", "вышколен", "вышколена", "вышколено", "вышколены", "выщерблен", "выщерблена", "выщерблено", "выщерблены", "выщипан", "выщипана", "выщипано", "выщипаны", "выявлен", "выявлена", "выявлено", "выявлены", "выяснен", "выяснена", "выяснено", "выяснены", "газирована", "газировано", "газированы", "гарантирован", "гарантирована", "гарантировано", "гарантированы", "гаркнут", "гаркнута", "гаркнуто", "гаркнуты", "гармонизирован", "гармонизирована", "гармонизировано", "гармонизированы", "герметизирован", "герметизирована", "герметизировано", "герметизированы", "глазирован", "глазирована", "глазировано", "глазированы", "госпитализирован", "госпитализирована", "госпитализировано", "госпитализированы", "грохнут", "грохнута", "грохнуто", "грохнуты", "дарован", "дарована", "даровано", "дарованы", "датирован", "датирована", "датировано", "датированы", "двинут", "двинута", "двинуто", "двинуты", "девальвирован", "девальвирована", "девальвировано", "девальвированы", "дегустирован", "дегустирована", "дегустировано", "дегустированы", "дезавуирован", "дезавуирована", "дезавуировано", "дезавуированы", "дезинфицирован", "дезинфицирована", "дезинфицировано", "дезинфицированы", "дезинформирован", "дезинформирована", "дезинформировано", "дезинформированы", "дезорганизован", "дезорганизована", "дезорганизовано", "дезорганизованы", "дезориентирован", "дезориентирована", "дезориентировано", "дезориентированы", "декларирован", "декларирована", "декларировано", "декларированы", "декорирован", "декорирована", "декорировано", "декорированы", "делегирован", "делегирована", "делегировано", "делегированы", "демаскирован", "демаскирована", "демаскировано", "демаскированы", "демобилизован", "демобилизована", "демобилизовано", "демобилизованы", "демонтирован", "демонтирована", "демонтировано", "демонтированы", "деморализован", "деморализована", "деморализовано", "деморализованы", "депонирован", "депонирована", "депонировано", "депонированы", "детализирован", "детализирована", "детализировано", "детализированы", "детерминирован", "детерминирована", "детерминировано", "детерминированы", "деформирован", "деформирована", "деформировано", "деформированы", "диагностирован", "диагностирована", "диагностировано", "диагностированы", "дисквалифицирован", "дисквалифицирована", "дисквалифицировано", "дисквалифицированы", "дискредитирован", "дискредитирована", "дискредитировано", "дискредитированы", "дискриминирован", "дискриминирована", "дискриминировано", "дискриминированы", "дислоцирован", "дислоцирована", "дислоцировано", "дислоцированы", "дисциплинирован", "дисциплинирована", "дисциплинировано", "дисциплинированы", "дифференцирован", "дифференцирована", "дифференцировано", "дифференцированы", "добавлен", "добавлена", "добавлено", "добавлены", "добит", "добита", "добито", "добиты", "доведен", "доведена", "доведено", "доведены", "довезен", "довезена", "довезено", "довезены", "доверен", "доверена", "доверено", "доверены", "довершен", "довершена", "довершено", "довершены", "довожен", "довожена", "довожено", "довожены", "догляжен", "догляжена", "догляжено", "догляжены", "догнан", "догнана", "догнано", "догнаны", "договорен", "договорена", "договорено", "договорены", "догонян", "догоняна", "догоняно", "догоняны", "доделан", "доделана", "доделано", "доделаны", "додуман", "додумана", "додумано", "додуманы", "дожат", "дожата", "дожато", "дожаты", "дожеван", "дожевана", "дожевано", "дожеваны", "дожит", "дожита", "дожито", "дожиты", "дозволен", "дозволена", "дозволено", "дозволены", "дозирован", "дозирована", "дозировано", "дозированы", "доигран", "доиграна", "доиграно", "доиграны", "доказан", "доказана", "доказано", "доказаны", "докончен", "докончена", "докончено", "докончены", "документирован", "документирована", "документировано", "документированы", "докурен", "докурена", "докурено", "докурены", "долбанут", "долбанута", "долбануто", "долбануты", "долит", "долита", "долито", "долиты", "доложен", "доложена", "доложено", "доложены", "домчан", "домчана", "домчано", "домчаны", "домыслен", "домыслена", "домыслено", "домыслены", "донесен", "донесена", "донесено", "донесены", "доношена", "доношено", "доношены", "допет", "допета", "допето", "допеты", "допечен", "допечена", "допечено", "допечены", "дописан", "дописана", "дописано", "дописаны", "допит", "допита", "допито", "допиты", "доплачен", "доплачена", "доплачено", "доплачены", "дополнен", "дополнена", "дополнено", "дополнены", "допрошен", "допрошена", "допрошено", "допрошены", "допущен", "допущена", "допущено", "допущены", "доработан", "доработана", "доработано", "доработаны", "дорисован", "дорисована", "дорисовано", "дорисованы", "досажен", "досажена", "досажено", "досажены", "досказан", "досказана", "досказано", "досказаны", "дослушан", "дослушана", "дослушано", "дослушаны", "досмотрен", "досмотрена", "досмотрено", "досмотрены", "доставлен", "доставлена", "доставлено", "доставлены", "достроен", "достроена", "достроено", "достроены", "досчитан", "досчитана", "досчитано", "досчитаны", "дотащен", "дотащена", "дотащено", "дотащены", "дотянут", "дотянута", "дотянуто", "дотянуты", "дочитан", "дочитана", "дочитано", "дочитаны", "драматизирован", "драматизирована", "драматизировано", "драматизированы", "дренирован", "дренирована", "дренировано", "дренированы", "дублирован", "дублирована", "дублировано", "дублированы", "жахнут", "жахнута", "жахнуто", "жахнуты", "заасфальтирован", "заасфальтирована", "заасфальтировано", "заасфальтированы", "забаррикадирован", "забаррикадирована", "забаррикадировано", "забаррикадированы", "забинтован", "забинтована", "забинтовано", "забинтованы", "забит", "забита", "забито", "забиты", "заблеван", "заблевана", "заблевано", "заблеваны", "заблокирован", "заблокирована", "заблокировано", "заблокированы", "заболочена", "заболочено", "заболочены", "заболтан", "заболтана", "заболтано", "заболтаны", "забракован", "забракована", "забраковано", "забракованы", "забран", "забрана", "забрано", "забраны", "забронирован", "забронирована", "забронировано", "забронированы", "забросан", "забросана", "забросано", "забросаны", "заброшен", "заброшена", "заброшено", "заброшены", "забрызган", "забрызгана", "забрызгано", "забрызганы", "завален", "завалена", "завалено", "завалены", "заварен", "заварена", "заварено", "заварены", "заведен", "заведена", "заведено", "заведены", "завезен", "завезена", "завезено", "завезены", "завербован", "завербована", "завербовано", "завербованы", "заверен", "заверена", "заверено", "заверены", "завернут", "завернута", "завернуто", "завернуты", "заверчен", "заверчена", "заверчено", "заверчены", "завершен", "завершена", "завершено", "завершены", "завешан", "завешана", "завешано", "завешаны", "завещан", "завещана", "завещано", "завещаны", "завиден", "завидена", "завидено", "завидены", "завизирован", "завизирована", "завизировано", "завизированы", "завинчен", "завинчена", "завинчено", "завинчены", "завит", "завита", "завито", "завиты", "завлечен", "завлечена", "завлечено", "завлечены", "завоеван", "завоевана", "завоевано", "завоеваны", "заворожен", "заворожена", "заворожено", "заворожены", "завуалирован", "завуалирована", "завуалировано", "завуалированы", "завышен", "завышена", "завышено", "завышены", "завязан", "завязана", "завязано", "завязаны", "загадан", "загадана", "загадано", "загаданы", "загажен", "загажена", "загажено", "загажены", "загашен", "загашена", "загашено", "загашены", "загипнотизирован", "загипнотизирована", "загипнотизировано", "загипнотизированы", "загипсован", "загипсована", "загипсовано", "загипсованы", "заглажен", "заглажена", "заглажено", "заглажены", "заглушен", "заглушена", "заглушено", "заглушены", "загнан", "загнана", "загнано", "загнаны", "загнут", "загнута", "загнуто", "загнуты", "заговорен", "заговорена", "заговорено", "заговорены", "загорожен", "загорожена", "загорожено", "загорожены", "заготовлен", "заготовлена", "заготовлено", "заготовлены", "заграбастан", "заграбастана", "заграбастано", "заграбастаны", "загребен", "загребена", "загребено", "загребены", "загримирован", "загримирована", "загримировано", "загримированы", "загромозжден", "загромозждена", "загромозждено", "загромозждены", "загружен", "загружена", "загружено", "загружены", "загрызен", "загрызена", "загрызено", "загрызены", "загрязнен", "загрязнена", "загрязнено", "загрязнены", "загублен", "загублена", "загублено", "загублены", "задавлен", "задавлена", "задавлено", "задавлены", "задвинут", "задвинута", "задвинуто", "задвинуты", "задействован", "задействована", "задействовано", "задействованы", "заделан", "заделана", "заделано", "заделаны", "задерган", "задергана", "задергано", "задерганы", "задержан", "задержана", "задержано", "задержаны", "задернут", "задернута", "задернуто", "задернуты", "задет", "задета", "задето", "задеты", "задобрен", "задобрена", "задобрено", "задобрены", "задолбан", "задолбана", "задолбано", "задолбаны", "задраен", "задраена", "задраено", "задраены", "задран", "задрана", "задрано", "задраны", "задрапирован", "задрапирована", "задрапировано", "задрапированы", "задуман", "задумана", "задумано", "задуманы", "задурен", "задурена", "задурено", "задурены", "задут", "задута", "задуто", "задуты", "задушен", "задушена", "задушено", "задушены", "задымлен", "задымлена", "задымлено", "задымлены", "заезжен", "заезжена", "заезжено", "заезжены", "зажарен", "зажарена", "зажарено", "зажарены", "зажат", "зажата", "зажато", "зажаты", "зажеван", "зажевана", "зажевано", "зажеваны", "зажит", "зажита", "зажито", "зажиты", "зажмурен", "зажмурена", "зажмурено", "зажмурены", "зазван", "зазвана", "зазвано", "зазваны", "заземлен", "заземлена", "заземлено", "заземлены", "зазубрен", "зазубрена", "зазубрено", "зазубрены", "заигран", "заиграна", "заиграно", "заиграны", "заимствован", "заимствована", "заимствовано", "заимствованы", "заинтересована", "заинтересовано", "заинтересованы", "заинтригована", "заинтриговано", "заинтригованы", "заказан", "заказана", "заказано", "заказаны", "закалена", "закалено", "закалены", "закамуфлирован", "закамуфлирована", "закамуфлировано", "закамуфлированы", "закапан", "закапана", "закапано", "закапаны", "закатан", "закатана", "закатано", "закатаны", "закачан", "закачана", "закачано", "закачаны", "закачен", "закачена", "закачено", "закачены", "закидан", "закидана", "закидано", "закиданы", "закинут", "закинута", "закинуто", "закинуты", "заклеван", "заклевана", "заклевано", "заклеваны", "заклеен", "заклеена", "заклеено", "заклеены", "заклеймен", "заклеймена", "заклеймено", "заклеймены", "заклинен", "заклинена", "заклинено", "заклинены", "заключен", "заключена", "заключено", "заключены", "закован", "закована", "заковано", "закованы", "закодирован", "закодирована", "закодировано", "закодированы", "заколдован", "заколдована", "заколдовано", "заколдованы", "заколот", "заколота", "заколото", "заколоты", "заколочен", "заколочена", "заколочено", "заколочены", "закольцеван", "закольцевана", "закольцевано", "закольцеваны", "законсервирован", "законсервирована", "законсервировано", "законсервированы", "законспирирован", "законспирирована", "законспирировано", "законспирированы", "закончен", "закончена", "закончено", "закончены", "закопан", "закопана", "закопано", "закопаны", "закопчен", "закопчена", "закопчено", "закопчены", "закошен", "закошена", "закошено", "закошены", "закрашен", "закрашена", "закрашено", "закрашены", "закреплен", "закреплена", "закреплено", "закреплены", "закроен", "закроена", "закроено", "закроены", "закруглен", "закруглена", "закруглено", "закруглены", "закручен", "закручена", "закручено", "закручены", "закрыт", "закрыта", "закрыто", "закрыты", "закуплен", "закуплена", "закуплено", "закуплены", "закупорен", "закупорена", "закупорено", "закупорены", "закурен", "закурена", "закурено", "закурены", "закутан", "закутана", "закутано", "закутаны", "залажен", "залажена", "залажено", "залажены", "залатан", "залатана", "залатано", "залатаны", "залеплен", "залеплена", "залеплено", "залеплены", "залечен", "залечена", "залечено", "залечены", "зализан", "зализана", "зализано", "зализаны", "залит", "залита", "залито", "залиты", "заложен", "заложена", "заложено", "заложены", "заломлен", "заломлена", "заломлено", "заломлены", "заляпан", "заляпана", "заляпано", "заляпаны", "замазан", "замазана", "замазано", "замазаны", "заманен", "заманена", "заманено", "заманены", "замаран", "замарана", "замарано", "замараны", "замаскирован", "замаскирована", "замаскировано", "замаскированы", "замаслен", "замаслена", "замаслено", "замаслены", "замедлен", "замедлена", "замедлено", "замедлены", "заменен", "заменена", "заменено", "заменены", "замерен", "замерена", "замерено", "замерены", "замерян", "замеряна", "замеряно", "замеряны", "заметан", "заметана", "заметано", "заметаны", "заметен", "заметена", "заметено", "заметены", "замечен", "замечена", "замечено", "замечены", "замешан", "замешана", "замешано", "замешаны", "замешен", "замешена", "замешено", "замешены", "замещен", "замещена", "замещено", "замещены", "заминирован", "заминирована", "заминировано", "заминированы", "замкнут", "замкнута", "замкнуто", "замкнуты", "замолвлен", "замолвлена", "замолвлено", "замолвлены", "замолчан", "замолчана", "замолчано", "замолчаны", "замордован", "замордована", "замордовано", "замордованы", "заморен", "заморена", "заморено", "заморены", "заморожен", "заморожена", "заморожено", "заморожены", "заморочен", "заморочена", "заморочено", "заморочены", "замотан", "замотана", "замотано", "замотаны", "замочен", "замочена", "замочено", "замочены", "замурован", "замурована", "замуровано", "замурованы", "замусолен", "замусолена", "замусолено", "замусолены", "замутнен", "замутнена", "замутнено", "замутнены", "замучан", "замучана", "замучано", "замучаны", "замучен", "замучена", "замучено", "замучены", "замыкан", "замыкана", "замыкано", "замыканы", "замыт", "замыта", "замыто", "замыты", "замыщлен", "замыщлена", "замыщлено", "замыщлены", "замят", "замята", "замято", "замяты", "занавешен", "занавешена", "занавешено", "занавешены", "занесен", "занесена", "занесено", "занесены", "занижен", "занижена", "занижено", "занижены", "заношен", "заношена", "заношено", "заношены", "занят", "занята", "занято", "заняты", "заострен", "заострена", "заострено", "заострены", "запакован", "запакована", "запаковано", "запакованы", "запален", "запалена", "запалено", "запалены", "запасен", "запасена", "запасено", "запасены", "запатентован", "запатентована", "запатентовано", "запатентованы", "запахнут", "запахнута", "запахнуто", "запахнуты", "запачкан", "запачкана", "запачкано", "запачканы", "запаян", "запаяна", "запаяно", "запаяны", "запеленан", "запеленана", "запеленано", "запеленаны", "запеленгован", "запеленгована", "запеленговано", "запеленгованы", "заперт", "заперта", "заперто", "заперты", "запечатан", "запечатана", "запечатано", "запечатаны", "запечатлен", "запечатлена", "запечатлено", "запечатлены", "запечен", "запечена", "запечено", "запечены", "записан", "записана", "записано", "записаны", "запит", "запита", "запито", "запиты", "запихан", "запихана", "запихано", "запиханы", "запихнут", "запихнута", "запихнуто", "запихнуты", "запланирован", "запланирована", "запланировано", "запланированы", "заплатан", "заплатана", "заплатано", "заплатаны", "заплачен", "заплачена", "заплачено", "заплачены", "заплеван", "заплевана", "заплевано", "заплеваны", "заплетен", "заплетена", "заплетено", "заплетены", "запломбирован", "запломбирована", "запломбировано", "запломбированы", "заподозрен", "заподозрена", "заподозрено", "заподозрены", "заполнен", "заполнена", "заполнено", "заполнены", "заполонен", "заполонена", "заполонено", "заполонены", "заполучен", "заполучена", "заполучено", "заполучены", "запомнен", "запомнена", "запомнено", "запомнены", "запорот", "запорота", "запорото", "запороты", "запорошен", "запорошена", "запорошено", "запорошены", "заправлен", "заправлена", "заправлено", "заправлены", "запрещен", "запрещена", "запрещено", "запрещены", "запримечен", "запримечена", "запримечено", "запримечены", "запрограммирован", "запрограммирована", "запрограммировано", "запрограммированы", "запроектирован", "запроектирована", "запроектировано", "запроектированы", "запрокинут", "запрокинута", "запрокинуто", "запрокинуты", "запротоколирован", "запротоколирована", "запротоколировано", "запротоколированы", "запрошен", "запрошена", "запрошено", "запрошены", "запружен", "запружена", "запружено", "запружены", "запряжен", "запряжена", "запряжено", "запряжены", "запрятан", "запрятана", "запрятано", "запрятаны", "запуган", "запугана", "запугано", "запуганы", "запудрен", "запудрена", "запудрено", "запудрены", "запутан", "запутана", "запутано", "запутаны", "запущен", "запущена", "запущено", "запущены", "запылен", "запылена", "запылено", "запылены", "запятнан", "запятнана", "запятнано", "запятнаны", "заработан", "заработана", "заработано", "заработаны", "заражен", "заражена", "заражено", "заражены", "зарегистрирован", "зарегистрирована", "зарегистрировано", "зарегистрированы", "зарезан", "зарезана", "зарезано", "зарезаны", "зарезервирован", "зарезервирована", "зарезервировано", "зарезервированы", "зарекомендован", "зарекомендована", "зарекомендовано", "зарекомендованы", "зарешечен", "зарешечена", "зарешечено", "зарешечены", "зарисован", "зарисована", "зарисовано", "зарисованы", "зарифмован", "зарифмована", "зарифмовано", "зарифмованы", "зарублен", "зарублена", "зарублено", "зарублены", "зарыт", "зарыта", "зарыто", "зарыты", "заряжен", "заряжена", "заряжено", "заряжены", "засажен", "засажена", "засажено", "засажены", "засахарен", "засахарена", "засахарено", "засахарены", "засвечен", "засвечена", "засвечено", "засвечены", "засвидетельствован", "засвидетельствована", "засвидетельствовано", "засвидетельствованы", "засекречен", "засекречена", "засекречено", "засекречены", "заселен", "заселена", "заселено", "заселены", "засечен", "засечена", "засечено", "засечены", "засеян", "засеяна", "засеяно", "засеяны", "засижен", "засижена", "засижено", "засижены", "заскребен", "заскребена", "заскребено", "заскребены", "заслан", "заслана", "заслано", "засланы", "заслонен", "заслонена", "заслонено", "заслонены", "заслужен", "заслужена", "заслужено", "заслужены", "заслушан", "заслушана", "заслушано", "заслушаны", "заслышан", "заслышана", "заслышано", "заслышаны", "засмеян", "засмеяна", "засмеяно", "засмеяны", "заснят", "заснята", "заснято", "засняты", "засолен", "засолена", "засолено", "засолены", "засорен", "засорена", "засорено", "засорены", "засосан", "засосана", "засосано", "засосаны", "заспиртован", "заспиртована", "заспиртовано", "заспиртованы", "заставлен", "заставлена", "заставлено", "заставлены", "застазастат", "застазастата", "застазастато", "застазастаты", "застегнут", "застегнута", "застегнуто", "застегнуты", "застелен", "застелена", "застелено", "застелены", "застигнут", "застигнута", "застигнуто", "застигнуты", "застиран", "застирана", "застирано", "застираны", "застолблен", "застолблена", "застолблено", "застолблены", "застопорен", "застопорена", "застопорено", "застопорены", "застрахован", "застрахована", "застраховано", "застрахованы", "застрелен", "застрелена", "застрелено", "застрелены", "застроен", "застроена", "застроено", "застроены", "застрочен", "застрочена", "застрочено", "застрочены", "застужен", "застужена", "застужено", "застужены", "застукан", "застукана", "застукано", "застуканы", "заступлен", "заступлена", "заступлено", "заступлены", "засужен", "засужена", "засужено", "засужены", "засунут", "засунута", "засунуто", "засунуты", "засучен", "засучена", "засучено", "засучены", "засушен", "засушена", "засушено", "засушены", "засчитан", "засчитана", "засчитано", "засчитаны", "затаен", "затаена", "затаено", "затаены", "затаскан", "затаскана", "затаскано", "затасканы", "затащен", "затащена", "затащено", "затащены", "затворен", "затворена", "затворено", "затворены", "затемнен", "затемнена", "затемнено", "затемнены", "затенен", "затенена", "затенено", "затенены", "затерт", "затерта", "затерто", "затерты", "затерян", "затеряна", "затеряно", "затеряны", "затеян", "затеяна", "затеяно", "затеяны", "заткнут", "заткнута", "заткнуто", "заткнуты", "затмлен", "затмлена", "затмлено", "затмлены", "затолкан", "затолкана", "затолкано", "затолканы", "затоплен", "затоплена", "затоплено", "затоплены", "затоптан", "затоптана", "затоптано", "затоптаны", "заторможен", "заторможена", "заторможено", "заторможены", "затороплен", "затороплена", "затороплено", "затороплены", "заточен", "заточена", "заточено", "заточены", "затошнен", "затошнена", "затошнено", "затошнены", "затравлен", "затравлена", "затравлено", "затравлены", "затрачен", "затрачена", "затрачено", "затрачены", "затребован", "затребована", "затребовано", "затребованы", "затронут", "затронута", "затронуто", "затронуты", "затруднен", "затруднена", "затруднено", "затруднены", "затуманен", "затуманена", "затуманено", "затуманены", "затушеван", "затушевана", "затушевано", "затушеваны", "затушен", "затушена", "затушено", "затушены", "затыкан", "затыкана", "затыкано", "затыканы", "затянут", "затянута", "затянуто", "затянуты", "заужен", "заужена", "заужено", "заужены", "заучен", "заучена", "заучено", "заучены", "зафиксирован", "зафиксирована", "зафиксировано", "зафиксированы", "зафрахтован", "зафрахтована", "зафрахтовано", "зафрахтованы", "захвачен", "захвачена", "захвачено", "захвачены", "захламлен", "захламлена", "захламлено", "захламлены", "захлестнут", "захлестнута", "захлестнуто", "захлестнуты", "захлопнут", "захлопнута", "захлопнуто", "захлопнуты", "захожен", "захожена", "захожено", "захожены", "захоронен", "захоронена", "захоронено", "захоронены", "зацеплен", "зацеплена", "зацеплено", "зацеплены", "зачарована", "зачаровано", "зачарованы", "зачат", "зачата", "зачато", "зачаты", "зачеркнут", "зачеркнута", "зачеркнуто", "зачеркнуты", "зачерпнут", "зачерпнута", "зачерпнуто", "зачерпнуты", "зачесан", "зачесана", "зачесано", "зачесаны", "зачехлен", "зачехлена", "зачехлено", "зачехлены", "зачислен", "зачислена", "зачислено", "зачислены", "зачитан", "зачитана", "зачитано", "зачитаны", "зачищен", "зачищена", "зачищено", "зачищены", "зачтен", "зачтена", "зачтено", "зачтены", "зашаркан", "зашаркана", "зашаркано", "зашарканы", "зашвырнут", "зашвырнута", "зашвырнуто", "зашвырнуты", "зашевелен", "зашевелена", "зашевелено", "зашевелены", "зашептан", "зашептана", "зашептано", "зашептаны", "зашит", "зашита", "зашито", "зашиты", "зашифрована", "зашифровано", "зашифрованы", "зашнурован", "зашнурована", "зашнуровано", "зашнурованы", "заштопан", "заштопана", "заштопано", "заштопаны", "зашторен", "зашторена", "зашторено", "зашторены", "заштрихован", "заштрихована", "заштриховано", "заштрихованы", "защелкнут", "защелкнута", "защелкнуто", "защелкнуты", "защемлен", "защемлена", "защемлено", "защемлены", "защипан", "защипана", "защипано", "защипаны", "защищен", "защищена", "защищено", "защищены", "заявлен", "заявлена", "заявлено", "заявлены", "звезданут", "звезданута", "звездануто", "звездануты", "идеализирован", "идеализирована", "идеализировано", "идеализированы", "идентифицирован", "идентифицирована", "идентифицировано", "идентифицированы", "избавлен", "избавлена", "избавлено", "избавлены", "избалован", "избалована", "избаловано", "избалованы", "избит", "избита", "избито", "избиты", "изборозжден", "изборозждена", "изборозждено", "изборозждены", "избран", "избрана", "избрано", "избраны", "изваян", "изваяна", "изваяно", "изваяны", "изведан", "изведана", "изведано", "изведаны", "извергнут", "извергнута", "извергнуто", "извергнуты", "извещен", "извещена", "извещено", "извещены", "извинен", "извинена", "извинено", "извинены", "извлечен", "извлечена", "извлечено", "извлечены", "извращен", "извращена", "извращено", "извращены", "изгажен", "изгажена", "изгажено", "изгажены", "изгнан", "изгнана", "изгнано", "изгнаны", "изготовлен", "изготовлена", "изготовлено", "изготовлены", "изгрызен", "изгрызена", "изгрызено", "изгрызены", "издерган", "издергана", "издергано", "издерганы", "изжарен", "изжарена", "изжарено", "изжарены", "изжит", "изжита", "изжито", "изжиты", "излажен", "излажена", "излажено", "излажены", "излечен", "излечена", "излечено", "излечены", "излит", "излита", "излито", "излиты", "изловлен", "изловлена", "изловлено", "изловлены", "изложен", "изложена", "изложено", "изложены", "изломан", "изломана", "изломано", "изломаны", "измазан", "измазана", "измазано", "измазаны", "измельчен", "измельчена", "измельчено", "измельчены", "изменен", "изменена", "изменено", "изменены", "измерен", "измерена", "измерено", "измерены", "измерян", "измеряна", "измеряно", "измеряны", "измотан", "измотана", "измотано", "измотаны", "измочален", "измочалена", "измочалено", "измочалены", "измучен", "измучена", "измучено", "измучены", "измышлен", "измышлена", "измышлено", "измышлены", "измят", "измята", "измято", "измяты", "изнасилован", "изнасилована", "изнасиловано", "изнасилованы", "изничтожен", "изничтожена", "изничтожено", "изничтожены", "изношен", "изношена", "изношено", "изношены", "изнурен", "изнурена", "изнурено", "изнурены", "изобличен", "изобличена", "изобличено", "изобличены", "изображен", "изображена", "изображено", "изображены", "изобретен", "изобретена", "изобретено", "изобретены", "изодран", "изодрана", "изодрано", "изодраны", "изолирован", "изолирована", "изолировано", "изолированы", "изорван", "изорвана", "изорвано", "изорваны", "изранен", "изранена", "изранено", "изранены", "израсходован", "израсходована", "израсходовано", "израсходованы", "изрезан", "изрезана", "изрезано", "изрезаны", "изречен", "изречена", "изречено", "изречены", "изрешечен", "изрешечена", "изрешечено", "изрешечены", "изрисован", "изрисована", "изрисовано", "изрисованы", "изрублен", "изрублена", "изрублено", "изрублены", "изрыт", "изрыта", "изрыто", "изрыты", "изувечен", "изувечена", "изувечено", "изувечены", "изукрашен", "изукрашена", "изукрашено", "изукрашены", "изумлен", "изумлена", "изумлено", "изумлены", "изуродован", "изуродована", "изуродовано", "изуродованы", "изучен", "изучена", "изучено", "изучены", "изъезжен", "изъезжена", "изъезжено", "изъезжены", "изъявлен", "изъявлена", "изъявлено", "изъявлены", "изъят", "изъята", "изъято", "изъяты", "изыскан", "изыскана", "изыскано", "изысканы", "иллюстрирован", "иллюстрирована", "иллюстрировано", "иллюстрированы", "иммобилизован", "иммобилизована", "иммобилизовано", "иммобилизованы", "иммунизирован", "иммунизирована", "иммунизировано", "иммунизированы", "импортирован", "импортирована", "импортировано", "импортированы", "инвестирован", "инвестирована", "инвестировано", "инвестированы", "индивидуализирован", "индивидуализирована", "индивидуализировано", "индивидуализированы", "индуцирован", "индуцирована", "индуцировано", "индуцированы", "инкорпорирован", "инкорпорирована", "инкорпорировано", "инкорпорированы", "инкриминирован", "инкриминирована", "инкриминировано", "инкриминированы", "инкрустирован", "инкрустирована", "инкрустировано", "инкрустированы", "инкубирован", "инкубирована", "инкубировано", "инкубированы", "инспирирован", "инспирирована", "инспирировано", "инспирированы", "инсценирован", "инсценирована", "инсценировано", "инсценированы", "интегрирован", "интегрирована", "интегрировано", "интегрированы", "интенсифицирован", "интенсифицирована", "интенсифицировано", "интенсифицированы", "интервьюирован", "интервьюирована", "интервьюировано", "интервьюированы", "интернирован", "интернирована", "интернировано", "интернированы", "интерпретирован", "интерпретирована", "интерпретировано", "интерпретированы", "интонирован", "интонирована", "интонировано", "интонированы", "инфицирован", "инфицирована", "инфицировано", "инфицированы", "информирован", "информирована", "информировано", "информированы", "искажен", "искажена", "искажено", "искажены", "искалечен", "искалечена", "искалечено", "искалечены", "исключен", "исключена", "исключено", "исключены", "исковеркан", "исковеркана", "исковеркано", "исковерканы", "исколот", "исколота", "исколото", "исколоты", "искорежен", "искорежена", "искорежено", "искорежены", "искоренен", "искоренена", "искоренено", "искоренены", "искривлен", "искривлена", "искривлено", "искривлены", "искромсан", "искромсана", "искромсано", "искромсаны", "искрошен", "искрошена", "искрошено", "искрошены", "искупан", "искупана", "искупано", "искупаны", "искуплен", "искуплена", "искуплено", "искуплены", "искусан", "искусана", "искусано", "искусаны", "искушен", "искушена", "искушено", "искушены", "испачкан", "испачкана", "испачкано", "испачканы", "испепелен", "испепелена", "испепелено", "испепелены", "испечен", "испечена", "испечено", "испечены", "испещрен", "испещрена", "испещрено", "испещрены", "исписан", "исписана", "исписано", "исписаны", "испит", "испита", "испито", "испиты", "исповедан", "исповедана", "исповедано", "исповеданы", "исповедован", "исповедована", "исповедовано", "исповедованы", "испоганен", "испоганена", "испоганено", "испоганены", "исполнен", "исполнена", "исполнено", "исполнены", "исполосован", "исполосована", "исполосовано", "исполосованы", "использован", "использована", "использовано", "использованы", "испорчен", "испорчена", "испорчено", "испорчены", "исправлен", "исправлена", "исправлено", "исправлены", "испробован", "испробована", "испробовано", "испробованы", "испрошен", "испрошена", "испрошено", "испрошены", "испуган", "испугана", "испугано", "испуганы", "испущен", "испущена", "испущено", "испущены", "испытан", "испытана", "испытано", "испытаны", "иссечен", "иссечена", "иссечено", "иссечены", "исследован", "исследована", "исследовано", "исследованы", "иссушен", "иссушена", "иссушено", "иссушены", "истерзан", "истерзана", "истерзано", "истерзаны", "истерт", "истерта", "истерто", "истерты", "истолкован", "истолкована", "истолковано", "истолкованы", "истончен", "истончена", "истончено", "истончены", "истоплен", "истоплена", "истоплено", "истоплены", "истоптан", "истоптана", "истоптано", "истоптаны", "исторгнут", "исторгнута", "исторгнуто", "исторгнуты", "источен", "источена", "источено", "источены", "истощен", "истощена", "истощено", "истощены", "истрачен", "истрачена", "истрачено", "истрачены", "истреблен", "истреблена", "истреблено", "истреблены", "истребован", "истребована", "истребовано", "истребованы", "истрепан", "истрепана", "истрепано", "истрепаны", "исхожен", "исхожена", "исхожено", "исхожены", "исцарапан", "исцарапана", "исцарапано", "исцарапаны", "исцелен", "исцелена", "исцелено", "исцелены", "исчеркан", "исчеркана", "исчеркано", "исчерканы", "исчерпан", "исчерпана", "исчерпано", "исчерпаны", "исчислен", "исчислена", "исчислено", "исчислены", "казнен", "казнена", "казнено", "казнены", "канонизирован", "канонизирована", "канонизировано", "канонизированы", "капитализирован", "капитализирована", "капитализировано", "капитализированы", "кастрирован", "кастрирована", "кастрировано", "кастрированы", "катализирован", "катализирована", "катализировано", "катализированы", "катапультирован", "катапультирована", "катапультировано", "катапультированы", "квалифицирован", "квалифицирована", "квалифицировано", "квалифицированы", "кинут", "кинута", "кинуто", "кинуты", "классифицирован", "классифицирована", "классифицировано", "классифицированы", "кликнут", "кликнута", "кликнуто", "кликнуты", "клюнут", "клюнута", "клюнуто", "клюнуты", "ковырнут", "ковырнута", "ковырнуто", "ковырнуты", "кодирован", "кодирована", "кодировано", "кодированы", "кокнут", "кокнута", "кокнуто", "кокнуты", "командирован", "командирована", "командировано", "командированы", "комиссован", "комиссована", "комиссовано", "комиссованы", "компенсирован", "компенсирована", "компенсировано", "компенсированы", "конвертирован", "конвертирована", "конвертировано", "конвертированы", "конденсирован", "конденсирована", "конденсировано", "конденсированы", "кондиционирован", "кондиционирована", "кондиционировано", "кондиционированы", "конкретизирован", "конкретизирована", "конкретизировано", "конкретизированы", "консолидирован", "консолидирована", "консолидировано", "консолидированы", "констатирован", "констатирована", "констатировано", "констатированы", "конституирован", "конституирована", "конституировано", "конституированы", "контратакован", "контратакована", "контратаковано", "контратакованы", "контужен", "контужена", "контужено", "контужены", "конфискован", "конфискована", "конфисковано", "конфискованы", "кончен", "кончена", "кончено", "кончены", "координирован", "координирована", "координировано", "координированы", "коронован", "коронована", "короновано", "коронованы", "коррумпирована", "коррумпировано", "коррумпированы", "кредитован", "кредитована", "кредитовано", "кредитованы", "кремирован", "кремирована", "кремировано", "кремированы", "крещен", "крещена", "крещено", "крещены", "куплен", "куплена", "куплено", "куплены", "курнут", "курнута", "курнуто", "курнуты", "куснут", "куснута", "куснуто", "куснуты", "легализован", "легализована", "легализовано", "легализованы", "легирован", "легирована", "легировано", "легированы", "ликвидирован", "ликвидирована", "ликвидировано", "ликвидированы", "лимитирован", "лимитирована", "лимитировано", "лимитированы", "лишен", "лишена", "лишено", "лишены", "лоббирован", "лоббирована", "лоббировано", "лоббированы", "локализован", "локализована", "локализовано", "локализованы", "лягнут", "лягнута", "лягнуто", "лягнуты", "маркирован", "маркирована", "маркировано", "маркированы", "массирован", "массирована", "массировано", "массированы", "материализован", "материализована", "материализовано", "материализованы", "механизирован", "механизирована", "механизировано", "механизированы", "минимизирован", "минимизирована", "минимизировано", "минимизированы", "минирован", "минирована", "минировано", "минированы", "минован", "минована", "миновано", "минованы", "мистифицирован", "мистифицирована", "мистифицировано", "мистифицированы", "мобилизован", "мобилизована", "мобилизовано", "мобилизованы", "моделирован", "моделирована", "моделировано", "моделированы", "модернизирован", "модернизирована", "модернизировано", "модернизированы", "модифицирован", "модифицирована", "модифицировано", "модифицированы", "монополизирован", "монополизирована", "монополизировано", "монополизированы", "мотивирована", "мотивировано", "мотивированы", "мотнут", "мотнута", "мотнуто", "мотнуты", "набеган", "набегана", "набегано", "набеганы", "набит", "набита", "набито", "набиты", "наболтан", "наболтана", "наболтано", "наболтаны", "набран", "набрана", "набрано", "набраны", "набросан", "набросана", "набросано", "набросаны", "наброшен", "наброшена", "наброшено", "наброшены", "навален", "навалена", "навалено", "навалены", "наварен", "наварена", "наварено", "наварены", "наведен", "наведена", "наведено", "наведены", "навезен", "навезена", "навезено", "навезены", "навернут", "навернута", "навернуто", "навернуты", "наверстан", "наверстана", "наверстано", "наверстаны", "навешан", "навешана", "навешано", "навешаны", "навешен", "навешена", "навешено", "навешены", "навещен", "навещена", "навещено", "навещены", "навеян", "навеяна", "навеяно", "навеяны", "навлечен", "навлечена", "навлечено", "навлечены", "наводнен", "наводнена", "наводнено", "наводнены", "наворован", "наворована", "наворовано", "наворованы", "наворочен", "наворочена", "наворочено", "наворочены", "навострен", "навострена", "навострено", "навострены", "навьючен", "навьючена", "навьючено", "навьючены", "навязан", "навязана", "навязано", "навязаны", "нагадан", "нагадана", "нагадано", "нагаданы", "нагажен", "нагажена", "нагажено", "нагажены", "нагнан", "нагнана", "нагнано", "нагнаны", "нагнут", "нагнута", "нагнуто", "нагнуты", "наговорен", "наговорена", "наговорено", "наговорены", "нагонян", "нагоняна", "нагоняно", "нагоняны", "наготовлен", "наготовлена", "наготовлено", "наготовлены", "награблен", "награблена", "награблено", "награблены", "награжден", "награждена", "награждено", "награждены", "нагрет", "нагрета", "нагрето", "нагреты", "нагромозжден", "нагромозждена", "нагромозждено", "нагромозждены", "нагружен", "нагружена", "нагружено", "нагружены", "нагулян", "нагуляна", "нагуляно", "нагуляны", "надавлен", "надавлена", "надавлено", "надавлены", "надвинут", "надвинута", "надвинуто", "надвинуты", "наделан", "наделана", "наделано", "наделаны", "надерган", "надергана", "надергано", "надерганы", "надет", "надета", "надето", "надеты", "надкушен", "надкушена", "надкушено", "надкушены", "надломлен", "надломлена", "надломлено", "надломлены", "надоен", "надоена", "надоено", "надоены", "надорван", "надорвана", "надорвано", "надорваны", "надоумлен", "надоумлена", "надоумлено", "надоумлены", "надписан", "надписана", "надписано", "надписаны", "надраен", "надраена", "надраено", "надраены", "надран", "надрана", "надрано", "надраны", "надрезан", "надрезана", "надрезано", "надрезаны", "надстроен", "надстроена", "надстроено", "надстроены", "надуман", "надумана", "надумано", "надуманы", "надут", "надута", "надуто", "надуты", "надушен", "надушена", "надушено", "надушены", "нажарен", "нажарена", "нажарено", "нажарены", "нажат", "нажата", "нажато", "нажаты", "нажит", "нажита", "нажито", "нажиты", "назван", "названа", "названо", "названы", "назначен", "назначена", "назначено", "назначены", "наигран", "наиграна", "наиграно", "наиграны", "наказан", "наказана", "наказано", "наказаны", "накален", "накалена", "накалено", "накалены", "накапан", "накапана", "накапано", "накапаны", "накаркан", "накаркана", "накаркано", "накарканы", "накатан", "накатана", "накатано", "накатаны", "накачан", "накачана", "накачано", "накачаны", "накачен", "накачена", "накачено", "накачены", "накидан", "накидана", "накидано", "накиданы", "накинут", "накинута", "накинуто", "накинуты", "наклеен", "наклеена", "наклеено", "наклеены", "накликан", "накликана", "накликано", "накликаны", "наклонен", "наклонена", "наклонено", "наклонены", "наковырян", "наковыряна", "наковыряно", "наковыряны", "наколот", "наколота", "наколото", "наколоты", "накопан", "накопана", "накопано", "накопаны", "накоплен", "накоплена", "накоплено", "накоплены", "накормлен", "накормлена", "накормлено", "накормлены", "накостылян", "накостыляна", "накостыляно", "накостыляны", "накошен", "накошена", "накошено", "накошены", "накрахмален", "накрахмалена", "накрахмалено", "накрахмалены", "накрашен", "накрашена", "накрашено", "накрашены", "накрошен", "накрошена", "накрошено", "накрошены", "накручен", "накручена", "накручено", "накручены", "накрыт", "накрыта", "накрыто", "накрыты", "накуплен", "накуплена", "накуплено", "накуплены", "накурен", "накурена", "накурено", "накурены", "налажен", "налажена", "налажено", "налажены", "налеплен", "налеплена", "налеплено", "налеплены", "налетан", "налетана", "налетано", "налетаны", "налит", "налита", "налито", "налиты", "наловлен", "наловлена", "наловлено", "наловлены", "наложен", "наложена", "наложено", "наложены", "наломан", "наломана", "наломано", "наломаны", "намагничен", "намагничена", "намагничено", "намагничены", "намазан", "намазана", "намазано", "намазаны", "намалеван", "намалевана", "намалевано", "намалеваны", "наметан", "наметана", "наметано", "наметаны", "наметен", "наметена", "наметено", "наметены", "намечен", "намечена", "намечено", "намечены", "намешан", "намешана", "намешано", "намешаны", "намозолен", "намозолена", "намозолено", "намозолены", "наморщен", "наморщена", "наморщено", "наморщены", "намотан", "намотана", "намотано", "намотаны", "намочен", "намочена", "намочено", "намочены", "намылен", "намылена", "намылено", "намылены", "намыт", "намыта", "намыто", "намыты", "намят", "намята", "намято", "намяты", "нанесен", "нанесена", "нанесено", "нанесены", "нанизан", "нанизана", "нанизано", "нанизаны", "наношен", "наношена", "наношено", "наношены", "нанят", "нанята", "нанято", "наняты", "напет", "напета", "напето", "напеты", "напечатан", "напечатана", "напечатано", "напечатаны", "напечен", "напечена", "напечено", "напечены", "напилен", "напилена", "напилено", "напилены", "написан", "написана", "написано", "написаны", "напитан", "напитана", "напитано", "напитаны", "напихан", "напихана", "напихано", "напиханы", "напичкан", "напичкана", "напичкано", "напичканы", "наплакан", "наплакана", "наплакано", "наплаканы", "наплеван", "наплевана", "наплевано", "наплеваны", "наплетен", "наплетена", "наплетено", "наплетены", "напложен", "напложена", "напложено", "напложены", "напоен", "напоена", "напоено", "напоены", "наползан", "наползана", "наползано", "наползаны", "наполнен", "наполнена", "наполнено", "наполнены", "напомажен", "напомажена", "напомажено", "напомажены", "напомнен", "напомнена", "напомнено", "напомнены", "напорчен", "напорчена", "напорчено", "напорчены", "направлен", "направлена", "направлено", "направлены", "напророчен", "напророчена", "напророчено", "напророчены", "напряжен", "напряжена", "напряжено", "напряжены", "напуган", "напугана", "напугано", "напуганы", "напудрен", "напудрена", "напудрено", "напудрены", "напутан", "напутана", "напутано", "напутаны", "напутствован", "напутствована", "напутствовано", "напутствованы", "напущен", "напущена", "напущено", "напущены", "напялен", "напялена", "напялено", "напялены", "наработан", "наработана", "наработано", "наработаны", "наращен", "наращена", "наращено", "наращены", "нарезан", "нарезана", "нарезано", "нарезаны", "наречен", "наречена", "наречено", "наречены", "нарисован", "нарисована", "нарисовано", "нарисованы", "нарожден", "нарождена", "нарождено", "нарождены", "нарублен", "нарублена", "нарублено", "нарублены", "нарушен", "нарушена", "нарушено", "нарушены", "нарыт", "нарыта", "нарыто", "нарыты", "наряжен", "наряжена", "наряжено", "наряжены", "насажден", "насаждена", "насаждено", "насаждены", "насажен", "насажена", "насажено", "насажены", "населен", "населена", "населено", "населены", "насижен", "насижена", "насижено", "насижены", "наскребен", "наскребена", "наскребено", "наскребены", "наслан", "наслана", "наслано", "насланы", "наследован", "наследована", "наследовано", "наследованы", "насмешен", "насмешена", "насмешено", "насмешены", "насобиран", "насобирана", "насобирано", "насобираны", "насован", "насована", "насовано", "насованы", "насолен", "насолена", "насолено", "насолены", "наставлен", "наставлена", "наставлено", "наставлены", "настелен", "настелена", "настелено", "настелены", "настигнут", "настигнута", "настигнуто", "настигнуты", "настоян", "настояна", "настояно", "настояны", "настроен", "настроена", "настроено", "настроены", "настрочен", "настрочена", "настрочено", "настрочены", "насуплен", "насуплена", "насуплено", "насуплены", "насчитан", "насчитана", "насчитано", "насчитаны", "насыщен", "насыщена", "насыщено", "насыщены", "натаскан", "натаскана", "натаскано", "натасканы", "натерт", "натерта", "натерто", "натерты", "натолкнут", "натолкнута", "натолкнуто", "натолкнуты", "натоплен", "натоплена", "натоплено", "натоплены", "натоптан", "натоптана", "натоптано", "натоптаны", "наточен", "наточена", "наточено", "наточены", "натравлен", "натравлена", "натравлено", "натравлены", "натренирован", "натренирована", "натренировано", "натренированы", "натружен", "натружена", "натружено", "натружены", "натыкан", "натыкана", "натыкано", "натыканы", "натянут", "натянута", "натянуто", "натянуты", "научен", "научена", "научено", "научены", "нафарширован", "нафарширована", "нафаршировано", "нафаршированы", "нахлобучен", "нахлобучена", "нахлобучено", "нахлобучены", "нахмурен", "нахмурена", "нахмурено", "нахмурены", "нахожен", "нахожена", "нахожено", "нахожены", "нахохлен", "нахохлена", "нахохлено", "нахохлены", "нацарапан", "нацарапана", "нацарапано", "нацарапаны", "нацежен", "нацежена", "нацежено", "нацежены", "нацелен", "нацелена", "нацелено", "нацелены", "нацеплен", "нацеплена", "нацеплено", "нацеплены", "национализирован", "национализирована", "национализировано", "национализированы", "начат", "начата", "начато", "начаты", "начертан", "начертана", "начертано", "начертаны", "начерчен", "начерчена", "начерчено", "начерчены", "начинен", "начинена", "начинено", "начинены", "начислен", "начислена", "начислено", "начислены", "начищен", "начищена", "начищено", "начищены", "нашарен", "нашарена", "нашарено", "нашарены", "нашептан", "нашептана", "нашептано", "нашептаны", "нашинкован", "нашинкована", "нашинковано", "нашинкованы", "нашит", "нашита", "нашито", "нашиты", "нашпигован", "нашпигована", "нашпиговано", "нашпигованы", "нащупан", "нащупана", "нащупано", "нащупаны", "наэлектризован", "наэлектризована", "наэлектризовано", "наэлектризованы", "невзлюблен", "невзлюблена", "невзлюблено", "невзлюблены", "недогляжен", "недогляжена", "недогляжено", "недогляжены", "недоговорен", "недоговорена", "недоговорено", "недоговорены", "недоделан", "недоделана", "недоделано", "недоделаны", "недооценен", "недооценена", "недооценено", "недооценены", "недопит", "недопита", "недопито", "недопиты", "недоплачен", "недоплачена", "недоплачено", "недоплачены", "недополучен", "недополучена", "недополучено", "недополучены", "недопонят", "недопонята", "недопонято", "недопоняты", "недосказан", "недосказана", "недосказано", "недосказаны", "недослышан", "недослышана", "недослышано", "недослышаны", "недосмотрен", "недосмотрена", "недосмотрено", "недосмотрены", "опосредован", "опосредована", "опосредовано", "опосредованы", "оптимизирован", "оптимизирована", "оптимизировано", "оптимизированы", "отслежен", "отслежена", "отслежено", "отслежены", "перечеркнут", "перечеркнута", "перечеркнуто", "перечеркнуты", "перечислен", "перечислена", "перечислено", "перечислены", "перечитан", "перечитана", "перечитано", "перечитаны", "перечтен", "перечтена", "перечтено", "перечтены", "перешит", "перешита", "перешито", "перешиты", "персонифицирован", "персонифицирована", "персонифицировано", "персонифицированы", "пикирован", "пикирована", "пикировано", "пикированы", "пленен", "пленена", "пленено", "пленены", "плеснут", "плеснута", "плеснуто", "плеснуты", "пнут", "пнута", "пнуто", "пнуты", "побалован", "побалована", "побаловано", "побалованы", "побежден", "побеждена", "побеждено", "побеждены", "побелен", "побелена", "побелено", "побелены", "побережен", "побережена", "побережено", "побережены", "побеспокоен", "побеспокоена", "побеспокоено", "побеспокоены", "побит", "побита", "побито", "побиты", "поблагодарен", "поблагодарена", "поблагодарено", "поблагодарены", "побрит", "побрита", "побрито", "побриты", "побросан", "побросана", "побросано", "побросаны", "побужден", "побуждена", "побуждено", "побуждены", "побужен", "побужена", "побужено", "побужены", "повален", "повалена", "повалено", "повалены", "поведан", "поведана", "поведано", "поведаны", "поведен", "поведена", "поведено", "поведены", "повезен", "повезена", "повезено", "повезены", "повенчан", "повенчана", "повенчано", "повенчаны", "повергнут", "повергнута", "повергнуто", "повергнуты", "поверен", "поверена", "поверено", "поверены", "повернут", "повернута", "повернуто", "повернуты", "поверчен", "поверчена", "поверчено", "поверчены", "повешен", "повешена", "повешено", "повешены", "повеян", "повеяна", "повеяно", "повеяны", "повидан", "повидана", "повидано", "повиданы", "поврежден", "повреждена", "повреждено", "повреждены", "повторен", "повторена", "повторено", "повторены", "повышен", "повышена", "повышено", "повышены", "повязан", "повязана", "повязано", "повязаны", "погашен", "погашена", "погашено", "погашены", "поглажен", "поглажена", "поглажено", "поглажены", "поглощен", "поглощена", "поглощено", "поглощены", "погнут", "погнута", "погнуто", "погнуты", "пограблен", "пограблена", "пограблено", "пограблены", "погребен", "погребена", "погребено", "погребены", "погрет", "погрета", "погрето", "погреты", "погружен", "погружена", "погружено", "погружены", "погрызен", "погрызена", "погрызено", "погрызены", "погублен", "погублена", "погублено", "погублены", "подавлен", "подавлена", "подавлено", "подавлены", "подарен", "подарена", "подарено", "подарены", "подбит", "подбита", "подбито", "подбиты", "подбодрен", "подбодрена", "подбодрено", "подбодрены", "подброшен", "подброшена", "подброшено", "подброшены", "подвален", "подвалена", "подвалено", "подвалены", "подведен", "подведена", "подведено", "подведены", "подвезен", "подвезена", "подвезено", "подвезены", "подвергнут", "подвергнута", "подвергнуто", "подвергнуты", "подвернут", "подвернута", "подвернуто", "подвернуты", "подвешен", "подвешена", "подвешено", "подвешены", "подвигнут", "подвигнута", "подвигнуто", "подвигнуты", "подвинут", "подвинута", "подвинуто", "подвинуты", "подвязан", "подвязана", "подвязано", "подвязаны", "подгляжен", "подгляжена", "подгляжено", "подгляжены", "подговорен", "подговорена", "подговорено", "подговорены", "подготовлен", "подготовлена", "подготовлено", "подготовлены", "подделан", "подделана", "подделано", "подделаны", "поддержан", "поддержана", "поддержано", "поддержаны", "поддернут", "поддернута", "поддернуто", "поддернуты", "поддет", "поддета", "поддето", "поддеты", "поделен", "поделена", "поделено", "поделены", "подерган", "подергана", "подергано", "подерганы", "подержан", "подержана", "подержано", "подержаны", "подернут", "подернута", "подернуто", "подернуты", "поджарен", "поджарена", "поджарено", "поджарены", "поджат", "поджата", "поджато", "поджаты", "подзаработан", "подзаработана", "подзаработано", "подзаработаны", "подкараулен", "подкараулена", "подкараулено", "подкараулены", "подкачан", "подкачана", "подкачано", "подкачаны", "подкачен", "подкачена", "подкачено", "подкачены", "подкинут", "подкинута", "подкинуто", "подкинуты", "подклеен", "подклеена", "подклеено", "подклеены", "подключен", "подключена", "подключено", "подключены", "подкован", "подкована", "подковано", "подкованы", "подколот", "подколота", "подколото", "подколоты", "подкоплен", "подкоплена", "подкоплено", "подкоплены", "подкормлен", "подкормлена", "подкормлено", "подкормлены", "подкошен", "подкошена", "подкошено", "подкошены", "подкрашен", "подкрашена", "подкрашено", "подкрашены", "подкреплен", "подкреплена", "подкреплено", "подкреплены", "подкручен", "подкручена", "подкручено", "подкручены", "подкуплен", "подкуплена", "подкуплено", "подкуплены", "подлатан", "подлатана", "подлатано", "подлатаны", "подлечен", "подлечена", "подлечено", "подлечены", "подлит", "подлита", "подлито", "подлиты", "подловлен", "подловлена", "подловлено", "подловлены", "подложен", "подложена", "подложено", "подложены", "подмазан", "подмазана", "подмазано", "подмазаны", "подменен", "подменена", "подменено", "подменены", "подметан", "подметана", "подметано", "подметаны", "подметен", "подметена", "подметено", "подметены", "подмечен", "подмечена", "подмечено", "подмечены", "подмешан", "подмешана", "подмешано", "подмешаны", "подморожен", "подморожена", "подморожено", "подморожены", "подмочен", "подмочена", "подмочено", "подмочены", "подмыт", "подмыта", "подмыто", "подмыты", "подмят", "подмята", "подмято", "подмяты", "поднажат", "поднажата", "поднажато", "поднажаты", "поднесен", "поднесена", "поднесено", "поднесены", "подновлен", "подновлена", "подновлено", "подновлены", "подношен", "подношена", "подношено", "подношены", "поднят", "поднята", "поднято", "подняты", "подобран", "подобрана", "подобрано", "подобраны", "подогнан", "подогнана", "подогнано", "подогнаны", "подогнут", "подогнута", "подогнуто", "подогнуты", "подогрет", "подогрета", "подогрето", "подогреты", "пододвинут", "пододвинута", "пододвинуто", "пододвинуты", "подоен", "подоена", "подоено", "подоены", "подожжен", "подожжена", "подожжено", "подожжены", "подозван", "подозвана", "подозвано", "подозваны", "подорван", "подорвана", "подорвано", "подорваны", "подослан", "подослана", "подослано", "подосланы", "подоткнут", "подоткнута", "подоткнуто", "подоткнуты", "подпален", "подпалена", "подпалено", "подпалены", "подперт", "подперта", "подперто", "подперты", "подпилен", "подпилена", "подпилено", "подпилены", "подписан", "подписана", "подписано", "подписаны", "подпорчен", "подпорчена", "подпорчено", "подпорчены", "подпоясан", "подпоясана", "подпоясано", "подпоясаны", "подправлен", "подправлена", "подправлено", "подправлены", "подпущен", "подпущена", "подпущено", "подпущены", "подразделен", "подразделена", "подразделено", "подразделены", "подран", "подрана", "подрано", "подраны", "подрезан", "подрезана", "подрезано", "подрезаны", "подровнян", "подровняна", "подровняно", "подровняны", "подрублен", "подрублена", "подрублено", "подрублены", "подрулен", "подрулена", "подрулено", "подрулены", "подрумянен", "подрумянена", "подрумянено", "подрумянены", "подсажен", "подсажена", "подсажено", "подсажены", "подсвечен", "подсвечена", "подсвечено", "подсвечены", "подселен", "подселена", "подселено", "подселены", "подсечен", "подсечена", "подсечено", "подсечены", "подсказан", "подсказана", "подсказано", "подсказаны", "подслащен", "подслащена", "подслащено", "подслащены", "подслушан", "подслушана", "подслушано", "подслушаны", "подсмотрен", "подсмотрена", "подсмотрено", "подсмотрены", "подсоединен", "подсоединена", "подсоединено", "подсоединены", "подсолен", "подсолена", "подсолено", "подсолены", "подставлен", "подставлена", "подставлено", "подставлены", "подстегнут", "подстегнута", "подстегнуто", "подстегнуты", "подстелен", "подстелена", "подстелено", "подстелены", "подстережен", "подстережена", "подстережено", "подстережены", "подстрелен", "подстрелена", "подстрелено", "подстрелены", "подстрижен", "подстрижена", "подстрижено", "подстрижены", "подстроен", "подстроена", "подстроено", "подстроены", "подсунут", "подсунута", "подсунуто", "подсунуты", "подсушен", "подсушена", "подсушено", "подсушены", "подсчитан", "подсчитана", "подсчитано", "подсчитаны", "подтащен", "подтащена", "подтащено", "подтащены", "подтвержден", "подтверждена", "подтверждено", "подтверждены", "подтолкнут", "подтолкнута", "подтолкнуто", "подтолкнуты", "подточен", "подточена", "подточено", "подточены", "подтыкан", "подтыкана", "подтыкано", "подтыканы", "подтянут", "подтянута", "подтянуто", "подтянуты", "подучен", "подучена", "подучено", "подучены", "подхвачен", "подхвачена", "подхвачено", "подхвачены", "подцеплен", "подцеплена", "подцеплено", "подцеплены", "подчеркнут", "подчеркнута", "подчеркнуто", "подчеркнуты", "подчинен", "подчинена", "подчинено", "подчинены", "подчищен", "подчищена", "подчищено", "подчищены", "подшит", "подшита", "подшито", "подшиты", "подыгран", "подыграна", "подыграно", "подыграны", "подытожен", "подытожена", "подытожено", "подытожены", "пожалован", "пожалована", "пожаловано", "пожалованы", "пожарен", "пожарена", "пожарено", "пожарены", "пожат", "пожата", "пожато", "пожаты", "пожеван", "пожевана", "пожевано", "пожеваны", "пожертвован", "пожертвована", "пожертвовано", "пожертвованы", "пожран", "пожрана", "пожрано", "пожраны", "пожурен", "пожурена", "пожурено", "пожурены", "позабавлен", "позабавлена", "позабавлено", "позабавлены", "позаимствован", "позаимствована", "позаимствовано", "позаимствованы", "позван", "позвана", "позвано", "позваны", "позволен", "позволена", "позволено", "позволены", "поздравлен", "поздравлена", "поздравлено", "поздравлены", "позиционирован", "позиционирована", "позиционировано", "позиционированы", "познакомлен", "познакомлена", "познакомлено", "познакомлены", "познан", "познана", "познано", "познаны", "позолочен", "позолочена", "позолочено", "позолочены", "поигран", "поиграна", "поиграно", "поиграны", "поименован", "поименована", "поименовано", "поименованы", "пойман", "поймана", "поймано", "пойманы", "показан", "показана", "показано", "показаны", "покалечен", "покалечена", "покалечено", "покалечены", "покатан", "покатана", "покатано", "покатаны", "покачан", "покачана", "покачано", "покачаны", "покачен", "покачена", "покачено", "покачены", "покидан", "покидана", "покидано", "покиданы", "покинут", "покинута", "покинуто", "покинуты", "поклеван", "поклевана", "поклевано", "поклеваны", "поколебан", "поколебана", "поколебано", "поколебаны", "поколочен", "поколочена", "поколочено", "поколочены", "покончен", "покончена", "покончено", "покончены", "покорежен", "покорежена", "покорежено", "покорежены", "покорен", "покорена", "покорено", "покорены", "покормлен", "покормлена", "покормлено", "покормлены", "покороблен", "покороблена", "покороблено", "покороблены", "покошен", "покошена", "покошено", "покошены", "покрашен", "покрашена", "покрашено", "покрашены", "покривлен", "покривлена", "покривлено", "покривлены", "покритикован", "покритикована", "покритиковано", "покритикованы", "покрошен", "покрошена", "покрошено", "покрошены", "покружен", "покружена", "покружено", "покружены", "покручен", "покручена", "покручено", "покручены", "покрыт", "покрыта", "покрыто", "покрыты", "покупан", "покупана", "покупано", "покупаны", "покурен", "покурена", "покурено", "покурены", "покусан", "покусана", "покусано", "покусаны", "покушан", "покушана", "покушано", "покушаны", "полажен", "полажена", "полажено", "полажены", "полечен", "полечена", "полечено", "полечены", "полит", "полита", "полито", "политы", "половлен", "половлена", "половлено", "половлены", "положен", "положена", "положено", "положены", "поломан", "поломана", "поломано", "поломаны", "полоснут", "полоснута", "полоснуто", "полоснуты", "получен", "получена", "получено", "получены", "поляризован", "поляризована", "поляризовано", "поляризованы", "помазан", "помазана", "помазано", "помазаны", "помассирован", "помассирована", "помассировано", "помассированы", "поменян", "поменяна", "поменяно", "поменяны", "померен", "померена", "померено", "померены", "помечен", "помечена", "помечено", "помечены", "помешан", "помешана", "помешано", "помешаны", "помещен", "помещена", "помещено", "помещены", "помилован", "помилована", "помиловано", "помилованы", "помножен", "помножена", "помножено", "помножены", "помолвлен", "помолвлена", "помолвлено", "помолвлены", "помотан", "помотана", "помотано", "помотаны", "помрачен", "помрачена", "помрачено", "помрачены", "помыт", "помыта", "помыто", "помыты", "помянут", "помянута", "помянуто", "помянуты", "понаделан", "понаделана", "понаделано", "понаделаны", "понастроен", "понастроена", "понастроено", "понастроены", "понесен", "понесена", "понесено", "понесены", "понижен", "понижена", "понижено", "понижены", "поношена", "поношено", "поношены", "понят", "понята", "понято", "поняты", "пообещан", "пообещана", "пообещано", "пообещаны", "поощрен", "поощрена", "поощрено", "поощрены", "поперчен", "поперчена", "поперчено", "поперчены", "попет", "попета", "попето", "попеты", "пописан", "пописана", "пописано", "пописаны", "попит", "попита", "попито", "попиты", "пополнен", "пополнена", "пополнено", "пополнены", "попорчен", "попорчена", "попорчено", "попорчены", "поправлен", "поправлена", "поправлено", "поправлены", "попран", "попрана", "попрано", "попраны", "попрекнут", "попрекнута", "попрекнуто", "попрекнуты", "поприветствован", "поприветствована", "поприветствовано", "поприветствованы", "попробован", "попробована", "попробовано", "попробованы", "попрошен", "попрошена", "попрошено", "попрошены", "попуган", "попугана", "попугано", "попуганы", "популяризирован", "популяризирована", "популяризировано", "популяризированы", "попутан", "попутана", "попутано", "попутаны", "порабощен", "порабощена", "порабощено", "порабощены", "порадован", "порадована", "порадовано", "порадованы", "поражен", "поражена", "поражено", "поражены", "поранен", "поранена", "поранено", "поранены", "пораскинут", "пораскинута", "пораскинуто", "пораскинуты", "порассказан", "порассказана", "порассказано", "порассказаны", "порасспрошен", "порасспрошена", "порасспрошено", "порасспрошены", "порван", "порвана", "порвано", "порваны", "порезан", "порезана", "порезано", "порезаны", "порекомендован", "порекомендована", "порекомендовано", "порекомендованы", "порешен", "порешена", "порешено", "порешены", "порожден", "порождена", "порождено", "порождены", "порубан", "порубана", "порубано", "порубаны", "порублен", "порублена", "порублено", "порублены", "поруган", "поругана", "поругано", "поруганы", "поручен", "поручена", "поручено", "поручены", "порушен", "порушена", "порушено", "порушены", "посажен", "посажена", "посажено", "посажены", "посвящен", "посвящена", "посвящено", "посвящены", "поселен", "поселена", "поселено", "поселены", "посеребрен", "посеребрена", "посеребрено", "посеребрены", "посещен", "посещена", "посещено", "посещены", "посеян", "посеяна", "посеяно", "посеяны", "поскребен", "поскребена", "поскребено", "поскребены", "послан", "послана", "послано", "посланы", "послушан", "послушана", "послушано", "послушаны", "посмотрен", "посмотрена", "посмотрено", "посмотрены", "посниман", "поснимана", "поснимано", "посниманы", "посолен", "посолена", "посолено", "посолены", "пососан", "пососана", "пососано", "пососаны", "посрамлен", "посрамлена", "посрамлено", "посрамлены", "поставлен", "поставлена", "поставлено", "поставлены", "постановлен", "постановлена", "постановлено", "постановлены", "постелен", "постелена", "постелено", "постелены", "постигнут", "постигнута", "постигнуто", "постигнуты", "постиран", "постирана", "постирано", "постираны", "пострелян", "постреляна", "постреляно", "постреляны", "пострижен", "пострижена", "пострижено", "пострижены", "построен", "построена", "построено", "построены", "постулирован", "постулирована", "постулировано", "постулированы", "посчитан", "посчитана", "посчитано", "посчитаны", "потереблен", "потереблена", "потереблено", "потереблены", "потерплен", "потерплена", "потерплено", "потерплены", "потерт", "потерта", "потерто", "потерты", "потерян", "потеряна", "потеряно", "потеряны", "потеснен", "потеснена", "потеснено", "потеснены", "потешен", "потешена", "потешено", "потешены", "потискан", "потискана", "потискано", "потисканы", "потоплен", "потоплена", "потоплено", "потоплены", "потоптан", "потоптана", "потоптано", "потоптаны", "потороплен", "потороплена", "потороплено", "потороплены", "потравлен", "потравлена", "потравлено", "потравлены", "потрачен", "потрачена", "потрачено", "потрачены", "потреблен", "потреблена", "потреблено", "потреблены", "потребован", "потребована", "потребовано", "потребованы", "потревожен", "потревожена", "потревожено", "потревожены", "потрепан", "потрепана", "потрепано", "потрепаны", "потроган", "потрогана", "потрогано", "потроганы", "потрушен", "потрушена", "потрушено", "потрушены", "потрясен", "потрясена", "потрясено", "потрясены", "потуплен", "потуплена", "потуплено", "потуплены", "потушен", "потушена", "потушено", "потушены", "потыкан", "потыкана", "потыкано", "потыканы", "потянут", "потянута", "потянуто", "потянуты", "поубавлен", "поубавлена", "поубавлено", "поубавлены", "поучен", "поучена", "поучено", "поучены", "похвален", "похвалена", "похвалено", "похвалены", "похерен", "похерена", "похерено", "похерены", "похищен", "похищена", "похищено", "похищены", "похлебан", "похлебана", "похлебано", "похлебаны", "похлопан", "похлопана", "похлопано", "похлопаны", "похоронен", "похоронена", "похоронено", "похоронены", "поцарапан", "поцарапана", "поцарапано", "поцарапаны", "поцелован", "поцелована", "поцеловано", "поцелованы", "почат", "почата", "почато", "початы", "почерпнут", "почерпнута", "почерпнуто", "почерпнуты", "почесан", "почесана", "почесано", "почесаны", "починен", "починена", "починено", "починены", "почитан", "почитана", "почитано", "почитаны", "почищен", "почищена", "почищено", "почищены", "почтен", "почтена", "почтено", "почтены", "почувствован", "почувствована", "почувствовано", "почувствованы", "пошатнут", "пошатнута", "пошатнуто", "пошатнуты", "пошевелен", "пошевелена", "пошевелено", "пошевелены", "пошит", "пошита", "пошито", "пошиты", "пощелкан", "пощелкана", "пощелкано", "пощелканы", "пощипан", "пощипана", "пощипано", "пощипаны", "пощупан", "пощупана", "пощупано", "пощупаны", "пояснен", "пояснена", "пояснено", "пояснены", "превозможен", "превозможена", "превозможено", "превозможены", "превращен", "превращена", "превращено", "превращены", "превышен", "превышена", "превышено", "превышены", "прегражен", "прегражена", "прегражено", "прегражены", "предварен", "предварена", "предварено", "предварены", "предвосхищен", "предвосхищена", "предвосхищено", "предвосхищены", "предложен", "предложена", "предложено", "предложены", "предназначен", "предназначена", "предназначено", "предназначены", "предначертан", "предначертана", "предначертано", "предначертаны", "предопределен", "предопределена", "предопределено", "предопределены", "предоставлен", "предоставлена", "предоставлено", "предоставлены", "предостережен", "предостережена", "предостережено", "предостережены", "предотвращен", "предотвращена", "предотвращено", "предотвращены", "предохранен", "предохранена", "предохранено", "предохранены", "предписан", "предписана", "предписано", "предписаны", "предположен", "предположена", "предположено", "предположены", "предпослан", "предпослана", "предпослано", "предпосланы", "предпочтен", "предпочтена", "предпочтено", "предпочтены", "предпринят", "предпринята", "предпринято", "предприняты", "предрасположен", "предрасположена", "предрасположено", "предрасположены", "предречен", "предречена", "предречено", "предречены", "предрешен", "предрешена", "предрешено", "предрешены", "предсказан", "предсказана", "предсказано", "предсказаны", "представлен", "представлена", "представлено", "представлены", "предугадан", "предугадана", "предугадано", "предугаданы", "предубежден", "предубеждена", "предубеждено", "предубеждены", "предусмотрен", "предусмотрена", "предусмотрено", "предусмотрены", "предъявлен", "предъявлена", "предъявлено", "предъявлены", "презентован", "презентована", "презентовано", "презентованы", "преисполнен", "преисполнена", "преисполнено", "преисполнены", "преклонен", "преклонена", "преклонено", "преклонены", "прекращен", "прекращена", "прекращено", "прекращены", "преломлен", "преломлена", "преломлено", "преломлены", "прельщен", "прельщена", "прельщено", "прельщены", "премирован", "премирована", "премировано", "премированы", "преображен", "преображена", "преображено", "преображены", "преодолен", "преодолена", "преодолено", "преодолены", "препарирован", "препарирована", "препарировано", "препарированы", "преподнесен", "преподнесена", "преподнесено", "преподнесены", "препровожен", "препровожена", "препровожено", "препровожены", "прерван", "прервана", "прервано", "прерваны", "пресечен", "пресечена", "пресечено", "пресечены", "преступлен", "преступлена", "преступлено", "преступлены", "претворен", "претворена", "претворено", "претворены", "претерплен", "претерплена", "претерплено", "претерплены", "преувеличен", "преувеличена", "преувеличено", "преувеличены", "прибавлен", "прибавлена", "прибавлено", "прибавлены", "прибережен", "прибережена", "прибережено", "прибережены", "прибит", "прибита", "прибито", "прибиты", "приближен", "приближена", "приближено", "приближены", "прибран", "прибрана", "прибрано", "прибраны", "привален", "привалена", "привалено", "привалены", "приварен", "приварена", "приварено", "приварены", "приведен", "приведена", "приведено", "приведены", "привезен", "привезена", "привезено", "привезены", "привешен", "привешена", "привешено", "привешены", "привинчен", "привинчена", "привинчено", "привинчены", "привит", "привита", "привито", "привиты", "привлечен", "привлечена", "привлечено", "привлечены", "привнесен", "привнесена", "привнесено", "привнесены", "приворожен", "приворожена", "приворожено", "приворожены", "привязан", "привязана", "привязано", "привязаны", "пригвозжен", "пригвозжена", "пригвозжено", "пригвозжены", "приглажен", "приглажена", "приглажено", "приглажены", "приглашен", "приглашена", "приглашено", "приглашены", "приглушен", "приглушена", "приглушено", "приглушены", "пригнан", "пригнана", "пригнано", "пригнаны", "пригнут", "пригнута", "пригнуто", "пригнуты", "приговорен", "приговорена", "приговорено", "приговорены", "приголублен", "приголублена", "приголублено", "приголублены", "приготовлен", "приготовлена", "приготовлено", "приготовлены", "пригрет", "пригрета", "пригрето", "пригреты", "пригублен", "пригублена", "пригублено", "пригублены", "придавлен", "придавлена", "придавлено", "придавлены", "придвинут", "придвинута", "придвинуто", "придвинуты", "приделан", "приделана", "приделано", "приделаны", "придержан", "придержана", "придержано", "придержаны", "придуман", "придумана", "придумано", "придуманы", "придушен", "придушена", "придушено", "придушены", "прижат", "прижата", "прижато", "прижаты", "прижит", "прижита", "прижито", "прижиты", "призван", "призвана", "призвано", "призваны", "приземлен", "приземлена", "приземлено", "приземлены", "признан", "признана", "признано", "признаны", "приказан", "приказана", "приказано", "приказаны", "прикарманен", "прикарманена", "прикарманено", "прикарманены", "прикачен", "прикачена", "прикачено", "прикачены", "прикинут", "прикинута", "прикинуто", "прикинуты", "приклеен", "приклеена", "приклеено", "приклеены", "приклонен", "приклонена", "приклонено", "приклонены", "прикован", "прикована", "приковано", "прикованы", "приколот", "приколота", "приколото", "приколоты", "приколочен", "приколочена", "приколочено", "приколочены", "прикомандирован", "прикомандирована", "прикомандировано", "прикомандированы", "прикончен", "прикончена", "прикончено", "прикончены", "прикормлен", "прикормлена", "прикормлено", "прикормлены", "прикреплен", "прикреплена", "прикреплено", "прикреплены", "прикручен", "прикручена", "прикручено", "прикручены", "прикрыт", "прикрыта", "прикрыто", "прикрыты", "прикуплен", "прикуплена", "прикуплено", "прикуплены", "прикушен", "прикушена", "прикушено", "прикушены", "прилажен", "прилажена", "прилажено", "прилажены", "приласкан", "приласкана", "приласкано", "приласканы", "прилеплен", "прилеплена", "прилеплено", "прилеплены", "прилит", "прилита", "прилито", "прилиты", "приложен", "приложена", "приложено", "приложены", "приманен", "приманена", "приманено", "приманены", "применен", "применена", "применено", "применены", "примерен", "примерена", "примерено", "примерены", "примерян", "примеряна", "примеряно", "примеряны", "примечен", "примечена", "примечено", "примечены", "примирен", "примирена", "примирено", "примирены", "приморожен", "приморожена", "приморожено", "приморожены", "примотан", "примотана", "примотано", "примотаны", "примят", "примята", "примято", "примяты", "принаряжен", "принаряжена", "принаряжено", "принаряжены", "принесен", "принесена", "принесено", "принесены", "принижен", "принижена", "принижено", "принижены", "принужден", "принуждена", "принуждено", "принуждены", "принят", "принята", "принято", "приняты", "приободрен", "приободрена", "приободрено", "приободрены", "приобретен", "приобретена", "приобретено", "приобретены", "приобщен", "приобщена", "приобщено", "приобщены", "приодет", "приодета", "приодето", "приодеты", "приостановлен", "приостановлена", "приостановлено", "приостановлены", "приотворен", "приотворена", "приотворено", "приотворены", "приоткрыт", "приоткрыта", "приоткрыто", "приоткрыты", "припаркован", "припаркована", "припарковано", "припаркованы", "припасен", "припасена", "припасено", "припасены", "припаян", "припаяна", "припаяно", "припаяны", "приперт", "приперта", "приперто", "приперты", "припечатан", "припечатана", "припечатано", "припечатаны", "припечен", "припечена", "припечено", "припечены", "приписан", "приписана", "приписано", "приписаны", "приплетен", "приплетена", "приплетено", "приплетены", "приплюснут", "приплюснута", "приплюснуто", "приплюснуты", "приплюсован", "приплюсована", "приплюсовано", "приплюсованы", "приподнят", "приподнята", "приподнято", "приподняты", "припомнен", "припомнена", "припомнено", "припомнены", "припорошен", "припорошена", "припорошено", "припорошены", "приправлен", "приправлена", "приправлено", "приправлены", "припрятан", "припрятана", "припрятано", "припрятаны", "припудрен", "припудрена", "припудрено", "припудрены", "припущен", "припущена", "припущено", "припущены", "приравнян", "приравняна", "приравняно", "приравняны", "приревнован", "приревнована", "приревновано", "приревнованы", "прирезан", "прирезана", "прирезано", "прирезаны", "пририсован", "пририсована", "пририсовано", "пририсованы", "приручен", "приручена", "приручено", "приручены", "присвоен", "присвоена", "присвоено", "присвоены", "прислан", "прислана", "прислано", "присланы", "прислонен", "прислонена", "прислонено", "прислонены", "присмотрен", "присмотрена", "присмотрено", "присмотрены", "присобачен", "присобачена", "присобачено", "присобачены", "присовокуплен", "присовокуплена", "присовокуплено", "присовокуплены", "присоединен", "присоединена", "присоединено", "присоединены", "присочинен", "присочинена", "присочинено", "присочинены", "приспособлен", "приспособлена", "приспособлено", "приспособлены", "приспущен", "приспущена", "приспущено", "приспущены", "приставлен", "приставлена", "приставлено", "приставлены", "пристегнут", "пристегнута", "пристегнуто", "пристегнуты", "пристрелен", "пристрелена", "пристрелено", "пристрелены", "пристрелян", "пристреляна", "пристреляно", "пристреляны", "пристроен", "пристроена", "пристроено", "пристроены", "приструнен", "приструнена", "приструнено", "приструнены", "пристукнут", "пристукнута", "пристукнуто", "пристукнуты", "пристыжен", "пристыжена", "пристыжено", "пристыжены", "присужден", "присуждена", "присуждено", "присуждены", "притащен", "притащена", "притащено", "притащены", "притворен", "притворена", "притворено", "притворены", "притерт", "притерта", "притерто", "притерты", "притиснут", "притиснута", "притиснуто", "притиснуты", "приткнут", "приткнута", "приткнуто", "приткнуты", "притоптан", "притоптана", "притоптано", "притоптаны", "приторможен", "приторможена", "приторможено", "приторможены", "притуплен", "притуплена", "притуплено", "притуплены", "притянут", "притянута", "притянуто", "притянуты", "приукрашен", "приукрашена", "приукрашено", "приукрашены", "приумножен", "приумножена", "приумножено", "приумножены", "приурочен", "приурочена", "приурочено", "приурочены", "приучен", "приучена", "приучено", "приучены", "прихвастнут", "прихвастнута", "прихвастнуто", "прихвастнуты", "прихвачен", "прихвачена", "прихвачено", "прихвачены", "прихлопнут", "прихлопнута", "прихлопнуто", "прихлопнуты", "прицеплен", "прицеплена", "прицеплено", "прицеплены", "причален", "причалена", "причалено", "причалены", "причащен", "причащена", "причащено", "причащены", "причесан", "причесана", "причесано", "причесаны", "причинен", "причинена", "причинено", "причинены", "причислен", "причислена", "причислено", "причислены", "пришит", "пришита", "пришито", "пришиты", "пришпилен", "пришпилена", "пришпилено", "пришпилены", "пришпорен", "пришпорена", "пришпорено", "пришпорены", "прищелкнут", "прищелкнута", "прищелкнуто", "прищелкнуты", "прищемлен", "прищемлена", "прищемлено", "прищемлены", "прищурен", "прищурена", "прищурено", "прищурены", "прищучен", "прищучена", "прищучено", "прищучены", "проанализирован", "проанализирована", "проанализировано", "проанализированы", "пробит", "пробита", "пробито", "пробиты", "проварен", "проварена", "проварено", "проварены", "проведан", "проведана", "проведано", "проведаны", "проведен", "проведена", "проведено", "проведены", "провезен", "провезена", "провезено", "провезены", "проверен", "проверена", "проверено", "проверены", "провернут", "провернута", "провернуто", "провернуты", "проветрен", "проветрена", "проветрено", "проветрены", "провозглашен", "провозглашена", "провозглашено", "провозглашены", "проглочен", "проглочена", "проглочено", "проглочены", "прогнан", "прогнана", "прогнано", "прогнаны", "прогнусавлен", "прогнусавлена", "прогнусавлено", "прогнусавлены", "проговорен", "проговорена", "проговорено", "проговорены", "прогрет", "прогрета", "прогрето", "прогреты", "прогрызен", "прогрызена", "прогрызено", "прогрызены", "прогулян", "прогуляна", "прогуляно", "прогуляны", "продавлен", "продавлена", "продавлено", "продавлены", "продвинут", "продвинута", "продвинуто", "продвинуты", "продезинфицирован", "продезинфицирована", "продезинфицировано", "продезинфицированы", "продекламирован", "продекламирована", "продекламировано", "продекламированы", "проделан", "проделана", "проделано", "проделаны", "продемонстрирован", "продемонстрирована", "продемонстрировано", "продемонстрированы", "продержан", "продержана", "продержано", "продержаны", "продернут", "продернута", "продернуто", "продернуты", "продет", "продета", "продето", "продеты", "продешевлен", "продешевлена", "продешевлено", "продешевлены", "продиктован", "продиктована", "продиктовано", "продиктованы", "продлен", "продлена", "продлено", "продлены", "продолжен", "продолжена", "продолжено", "продолжены", "продран", "продрана", "продрано", "продраны", "продублирован", "продублирована", "продублировано", "продублированы", "продуман", "продумана", "продумано", "продуманы", "продут", "продута", "продуто", "продуты", "продырявлен", "продырявлена", "продырявлено", "продырявлены", "прожарен", "прожарена", "прожарено", "прожарены", "прожеван", "прожевана", "прожевано", "прожеваны", "прожит", "прожита", "прожито", "прожиты", "прозван", "прозвана", "прозвано", "прозваны", "прозвонен", "прозвонена", "прозвонено", "прозвонены", "прознан", "прознана", "прознано", "прознаны", "проигран", "проиграна", "проиграно", "проиграны", "произведен", "произведена", "произведено", "произведены", "произнесен", "произнесена", "произнесено", "произнесены", "проиллюстрирован", "проиллюстрирована", "проиллюстрировано", "проиллюстрированы", "проинструктирован", "проинструктирована", "проинструктировано", "проинструктированы", "проинформирован", "проинформирована", "проинформировано", "проинформированы", "прокален", "прокалена", "прокалено", "прокалены", "прокатан", "прокатана", "прокатано", "прокатаны", "прокачан", "прокачана", "прокачано", "прокачаны", "прокачен", "прокачена", "прокачено", "прокачены", "прокипячен", "прокипячена", "прокипячено", "прокипячены", "проколот", "проколота", "проколото", "проколоты", "прокомментирован", "прокомментирована", "прокомментировано", "прокомментированы", "проконсультирован", "проконсультирована", "проконсультировано", "проконсультированы", "проконтролирован", "проконтролирована", "проконтролировано", "проконтролированы", "прокопан", "прокопана", "прокопано", "прокопаны", "прокопчен", "прокопчена", "прокопчено", "прокопчены", "прокручен", "прокручена", "прокручено", "прокручены", "прокурен", "прокурена", "прокурено", "прокурены", "прокушен", "прокушена", "прокушено", "прокушены", "пролечен", "пролечена", "пролечено", "пролечены", "пролистан", "пролистана", "пролистано", "пролистаны", "пролит", "пролита", "пролито", "пролиты", "проложен", "проложена", "проложено", "проложены", "проломлен", "проломлена", "проломлено", "проломлены", "пролонгирован", "пролонгирована", "пролонгировано", "пролонгированы", "промазан", "промазана", "промазано", "промазаны", "променян", "променяна", "променяно", "променяны", "промокнут", "промокнута", "промокнуто", "промокнуты", "промолвлен", "промолвлена", "промолвлено", "промолвлены", "проморожен", "проморожена", "проморожено", "проморожены", "промотан", "промотана", "промотано", "промотаны", "промочен", "промочена", "промочено", "промочены", "промыт", "промыта", "промыто", "промыты", "промямлен", "промямлена", "промямлено", "промямлены", "пронесен", "пронесена", "пронесено", "пронесены", "пронзен", "пронзена", "пронзено", "пронзены", "пронизан", "пронизана", "пронизано", "пронизаны", "проношен", "проношена", "проношено", "проношены", "пронумерован", "пронумерована", "пронумеровано", "пронумерованы", "пронюхан", "пронюхана", "пронюхано", "пронюханы", "пропахан", "пропахана", "пропахано", "пропаханы", "пропет", "пропета", "пропето", "пропеты", "пропечатан", "пропечатана", "пропечатано", "пропечатаны", "прописан", "прописана", "прописано", "прописаны", "пропит", "пропита", "пропито", "пропиты", "пропитан", "пропитана", "пропитано", "пропитаны", "пропихнут", "пропихнута", "пропихнуто", "пропихнуты", "проплакан", "проплакана", "проплакано", "проплаканы", "проплыт", "проплыта", "проплыто", "проплыты", "прополоскан", "прополоскана", "прополоскано", "прополосканы", "прополот", "прополота", "прополото", "прополоты", "пропорот", "пропорота", "пропорото", "пропороты", "пропущен", "пропущена", "пропущено", "пропущены", "пропылен", "пропылена", "пропылено", "пропылены", "проработан", "проработана", "проработано", "проработаны", "прорван", "прорвана", "прорвано", "прорваны", "прорежен", "прорежена", "прорежено", "прорежены", "прорезан", "прорезана", "прорезано", "прорезаны", "прорисован", "прорисована", "прорисовано", "прорисованы", "проронен", "проронена", "проронено", "проронены", "прорублен", "прорублена", "прорублено", "прорублены", "прорыт", "прорыта", "прорыто", "прорыты", "просажен", "просажена", "просажено", "просажены", "просверлен", "просверлена", "просверлено", "просверлены", "просветлен", "просветлена", "просветлено", "просветлены", "просвечен", "просвечена", "просвечено", "просвечены", "просвещен", "просвещена", "просвещено", "просвещены", "просвищен", "просвищена", "просвищено", "просвищены", "просечен", "просечена", "просечено", "просечены", "просеян", "просеяна", "просеяно", "просеяны", "просигнален", "просигналена", "просигналено", "просигналены", "просижен", "просижена", "просижено", "просижены", "просиплен", "просиплена", "просиплено", "просиплены", "прославлен", "прославлена", "прославлено", "прославлены", "прослежен", "прослежена", "прослежено", "прослежены", "прослушан", "прослушана", "прослушано", "прослушаны", "прослышан", "прослышана", "прослышано", "прослышаны", "просмолен", "просмолена", "просмолено", "просмолены", "просмотрен", "просмотрена", "просмотрено", "просмотрены", "просолен", "просолена", "просолено", "просолены", "просрочен", "просрочена", "просрочено", "просрочены", "проставлен", "проставлена", "проставлено", "проставлены", "простерт", "простерта", "простерто", "простерты", "простиран", "простирана", "простирано", "простираны", "прострелен", "прострелена", "прострелено", "прострелены", "прострочен", "прострочена", "прострочено", "прострочены", "простужен", "простужена", "простужено", "простужены", "простучан", "простучана", "простучано", "простучаны", "просунут", "просунута", "просунуто", "просунуты", "просушен", "просушена", "просушено", "просушены", "просчитан", "просчитана", "просчитано", "просчитаны", "протаранен", "протаранена", "протаранено", "протаранены", "протащен", "протащена", "протащено", "протащены", "протерт", "протерта", "протерто", "протерты", "противопоставлен", "противопоставлена", "противопоставлено", "противопоставлены", "проткнут", "проткнута", "проткнуто", "проткнуты", "протолкнут", "протолкнута", "протолкнуто", "протолкнуты", "протоплен", "протоплена", "протоплено", "протоплены", "протоптан", "протоптана", "протоптано", "протоптаны", "проторен", "проторена", "проторено", "проторены", "протыкан", "протыкана", "протыкано", "протыканы", "протянут", "протянута", "протянуто", "протянуты", "проучен", "проучена", "проучено", "проучены", "профильтрован", "профильтрована", "профильтровано", "профильтрованы", "профинансирован", "профинансирована", "профинансировано", "профинансированы", "профукан", "профукана", "профукано", "профуканы", "прохвачен", "прохвачена", "прохвачено", "прохвачены", "прохриплен", "прохриплена", "прохриплено", "прохриплены", "процарапан", "процарапана", "процарапано", "процарапаны", "процежен", "процежена", "процежено", "процежены", "процитирован", "процитирована", "процитировано", "процитированы", "прочерчен", "прочерчена", "прочерчено", "прочерчены", "прочесан", "прочесана", "прочесано", "прочесаны", "прочитан", "прочитана", "прочитано", "прочитаны", "прочищен", "прочищена", "прочищено", "прочищены", "прочтен", "прочтена", "прочтено", "прочтены", "прочувствован", "прочувствована", "прочувствовано", "прочувствованы", "прошаган", "прошагана", "прошагано", "прошаганы", "прошамкан", "прошамкана", "прошамкано", "прошамканы", "прошептан", "прошептана", "прошептано", "прошептаны", "прошиплен", "прошиплена", "прошиплено", "прошиплены", "прошит", "прошита", "прошито", "прошиты", "прошляплен", "прошляплена", "прошляплено", "прошляплены", "проштудирован", "проштудирована", "проштудировано", "проштудированы", "прощен", "прощена", "прощено", "прощены", "прощупан", "прощупана", "прощупано", "прощупаны", "проявлен", "проявлена", "проявлено", "проявлены", "прояснен", "прояснена", "прояснено", "прояснены", "пущен", "пущена", "пущено", "пущены", "пырнут", "пырнута", "пырнуто", "пырнуты", "радирован", "радирована", "радировано", "радированы", "разбавлен", "разбавлена", "разбавлено", "разбавлены", "разбазарен", "разбазарена", "разбазарено", "разбазарены", "разбережен", "разбережена", "разбережено", "разбережены", "разбит", "разбита", "разбито", "разбиты", "разболтан", "разболтана", "разболтано", "разболтаны", "разбомблен", "разбомблена", "разбомблено", "разбомблены", "разбросан", "разбросана", "разбросано", "разбросаны", "разбужен", "разбужена", "разбужено", "разбужены", "развален", "развалена", "развалено", "развалены", "разварен", "разварена", "разварено", "разварены", "разведан", "разведана", "разведано", "разведаны", "разведен", "разведена", "разведено", "разведены", "развезен", "развезена", "развезено", "развезены", "развенчан", "развенчана", "развенчано", "развенчаны", "развернут", "развернута", "развернуто", "развернуты", "развеселен", "развеселена", "развеселено", "развеселены", "развешан", "развешана", "развешано", "развешаны", "развешен", "развешена", "развешено", "развешены", "развеян", "развеяна", "развеяно", "развеяны", "развинчен", "развинчена", "развинчено", "развинчены", "развит", "развита", "развито", "развиты", "развлечен", "развлечена", "развлечено", "развлечены", "разворован", "разворована", "разворовано", "разворованы", "разворочен", "разворочена", "разворочено", "разворочены", "разворошен", "разворошена", "разворошено", "разворошены", "развращен", "развращена", "развращено", "развращены", "развязан", "развязана", "развязано", "развязаны", "разгадан", "разгадана", "разгадано", "разгаданы", "разглажен", "разглажена", "разглажено", "разглажены", "разглашен", "разглашена", "разглашено", "разглашены", "разгневан", "разгневана", "разгневано", "разгневаны", "разговорен", "разговорена", "разговорено", "разговорены", "разгорожен", "разгорожена", "разгорожено", "разгорожены", "разгорячен", "разгорячена", "разгорячено", "разгорячены", "разграблен", "разграблена", "разграблено", "разграблены", "разграничен", "разграничена", "разграничено", "разграничены", "разграфлен", "разграфлена", "разграфлено", "разграфлены", "разгребен", "разгребена", "разгребено", "разгребены", "разгромлен", "разгромлена", "разгромлено", "разгромлены", "разгружен", "разгружена", "разгружено", "разгружены", "разгрызен", "разгрызена", "разгрызено", "разгрызены", "раздавлен", "раздавлена", "раздавлено", "раздавлены", "раздарен", "раздарена", "раздарено", "раздарены", "раздвинут", "раздвинута", "раздвинуто", "раздвинуты", "раздвоен", "раздвоена", "раздвоено", "раздвоены", "разделан", "разделана", "разделано", "разделаны", "разделен", "разделена", "разделено", "разделены", "раздернут", "раздернута", "раздернуто", "раздернуты", "раздет", "раздета", "раздето", "раздеты", "раздолбан", "раздолбана", "раздолбано", "раздолбаны", "раздосадован", "раздосадована", "раздосадовано", "раздосадованы", "раздражен", "раздражена", "раздражено", "раздражены", "раздроблен", "раздроблена", "раздроблено", "раздроблены", "раздут", "раздута", "раздуто", "раздуты", "разжалоблен", "разжалоблена", "разжалоблено", "разжалоблены", "разжалован", "разжалована", "разжаловано", "разжалованы", "разжат", "разжата", "разжато", "разжаты", "разжеван", "разжевана", "разжевано", "разжеваны", "раззадорен", "раззадорена", "раззадорено", "раззадорены", "раззявлен", "раззявлена", "раззявлено", "раззявлены", "разинут", "разинута", "разинуто", "разинуты", "разлеплен", "разлеплена", "разлеплено", "разлеплены", "разлинован", "разлинована", "разлиновано", "разлинованы", "разлит", "разлита", "разлито", "разлиты", "различен", "различена", "различено", "различены", "разложен", "разложена", "разложено", "разложены", "разломан", "разломана", "разломано", "разломаны", "разломлен", "разломлена", "разломлено", "разломлены", "разлохмачен", "разлохмачена", "разлохмачено", "разлохмачены", "разлучен", "разлучена", "разлучено", "разлучены", "размазан", "размазана", "размазано", "размазаны", "размалеван", "размалевана", "размалевано", "размалеваны", "разменян", "разменяна", "разменяно", "разменяны", "разметан", "разметана", "разметано", "разметаны", "размечен", "размечена", "размечено", "размечены", "размешан", "размешана", "размешано", "размешаны", "размещен", "размещена", "размещено", "размещены", "разминирован", "разминирована", "разминировано", "разминированы", "размножен", "размножена", "размножено", "размножены", "размозжен", "размозжена", "размозжено", "размозжены", "размолот", "размолота", "размолото", "размолоты", "разморожен", "разморожена", "разморожено", "разморожены", "размотан", "размотана", "размотано", "размотаны", "размочен", "размочена", "размочено", "размочены", "размыкан", "размыкана", "размыкано", "размыканы", "размыт", "размыта", "размыто", "размыты", "размягчен", "размягчена", "размягчено", "размягчены", "размят", "размята", "размято", "размяты", "разнесен", "разнесена", "разнесено", "разнесены", "разношен", "разношена", "разношено", "разношены", "разнюхан", "разнюхана", "разнюхано", "разнюханы", "разнят", "разнята", "разнято", "разняты", "разоблачен", "разоблачена", "разоблачено", "разоблачены", "разобран", "разобрана", "разобрано", "разобраны", "разобщен", "разобщена", "разобщено", "разобщены", "разогнан", "разогнана", "разогнано", "разогнаны", "разогнут", "разогнута", "разогнуто", "разогнуты", "разогрет", "разогрета", "разогрето", "разогреты", "разодет", "разодета", "разодето", "разодеты", "разодран", "разодрана", "разодрано", "разодраны", "разожжен", "разожжена", "разожжено", "разожжены", "разозлен", "разозлена", "разозлено", "разозлены", "разомкнут", "разомкнута", "разомкнуто", "разомкнуты", "разорван", "разорвана", "разорвано", "разорваны", "разорен", "разорена", "разорено", "разорены", "разоружен", "разоружена", "разоружено", "разоружены", "разослан", "разослана", "разослано", "разосланы", "разостлан", "разостлана", "разостлано", "разостланы", "разочарован", "разочарована", "разочаровано", "разочарованы", "разработан", "разработана", "разработано", "разработаны", "разрежен", "разрежена", "разрежено", "разрежены", "разрезан", "разрезана", "разрезано", "разрезаны", "разрекламирован", "разрекламирована", "разрекламировано", "разрекламированы", "разрешен", "разрешена", "разрешено", "разрешены", "разрисован", "разрисована", "разрисовано", "разрисованы", "разрознен", "разрознена", "разрознено", "разрознены", "разрублен", "разрублена", "разрублено", "разрублены", "разрушен", "разрушена", "разрушено", "разрушены", "разрыт", "разрыта", "разрыто", "разрыты", "разряжен", "разряжена", "разряжено", "разряжены", "разубежден", "разубеждена", "разубеждено", "разубеждены", "разузнан", "разузнана", "разузнано", "разузнаны", "разукрашен", "разукрашена", "разукрашено", "разукрашены", "разут", "разута", "разуто", "разуты", "разучен", "разучена", "разучено", "разучены", "разъединен", "разъединена", "разъединено", "разъединены", "разъярен", "разъярена", "разъярено", "разъярены", "разъяснен", "разъяснена", "разъяснено", "разъяснены", "разъят", "разъята", "разъято", "разъяты", "разыгран", "разыграна", "разыграно", "разыграны", "разыскан", "разыскана", "разыскано", "разысканы", "ранен", "ранена", "ранено", "ранены", "ранжирован", "ранжирована", "ранжировано", "ранжированы", "раскален", "раскалена", "раскалено", "раскалены", "раскатан", "раскатана", "раскатано", "раскатаны", "раскачан", "раскачана", "раскачано", "раскачаны", "расквартирован", "расквартирована", "расквартировано", "расквартированы", "расквашен", "расквашена", "расквашено", "расквашены", "раскидан", "раскидана", "раскидано", "раскиданы", "раскинут", "раскинута", "раскинуто", "раскинуты", "расклеван", "расклевана", "расклевано", "расклеваны", "расклеен", "расклеена", "расклеено", "расклеены", "раскован", "раскована", "расковано", "раскованы", "расковырян", "расковыряна", "расковыряно", "расковыряны", "расколдован", "расколдована", "расколдовано", "расколдованы", "расколот", "расколота", "расколото", "расколоты", "расколочен", "расколочена", "расколочено", "расколочены", "раскопан", "раскопана", "раскопано", "раскопаны", "раскрашен", "раскрашена", "раскрашено", "раскрашены", "раскрепощен", "раскрепощена", "раскрепощено", "раскрепощены", "раскритикован", "раскритикована", "раскритиковано", "раскритикованы", "раскроен", "раскроена", "раскроено", "раскроены", "раскрошен", "раскрошена", "раскрошено", "раскрошены", "раскручен", "раскручена", "раскручено", "раскручены", "раскрыт", "раскрыта", "раскрыто", "раскрыты", "раскулачен", "раскулачена", "раскулачено", "раскулачены", "раскуплен", "раскуплена", "раскуплено", "раскуплены", "раскупорен", "раскупорена", "раскупорено", "раскупорены", "раскурен", "раскурена", "раскурено", "раскурены", "раскушен", "раскушена", "раскушено", "раскушены", "распакован", "распакована", "распаковано", "распакованы", "распален", "распалена", "распалено", "распалены", "распарен", "распарена", "распарено", "распарены", "распахан", "распахана", "распахано", "распаханы", "распахнут", "распахнута", "распахнуто", "распахнуты", "распечатан", "распечатана", "распечатано", "распечатаны", "распилен", "распилена", "распилено", "распилены", "расписан", "расписана", "расписано", "расписаны", "распит", "распита", "распито", "распиты", "расплавлен", "расплавлена", "расплавлено", "расплавлены", "распланирован", "распланирована", "распланировано", "распланированы", "распластан", "распластана", "распластано", "распластаны", "расплескан", "расплескана", "расплескано", "расплесканы", "расплющен", "расплющена", "расплющено", "расплющены", "распознан", "распознана", "распознано", "распознаны", "расположен", "расположена", "расположено", "расположены", "располосован", "располосована", "располосовано", "располосованы", "распорот", "распорота", "распорото", "распороты", "распотрошен", "распотрошена", "распотрошено", "распотрошены", "расправлен", "расправлена", "расправлено", "расправлены", "распределен", "распределена", "распределено", "распределены", "распробован", "распробована", "распробовано", "распробованы", "распростерт", "распростерта", "распростерто", "распростерты", "распространен", "распространена", "распространено", "распространены", "распряжен", "распряжена", "распряжено", "распряжены", "распрямлен", "распрямлена", "распрямлено", "распрямлены", "распуган", "распугана", "распугано", "распуганы", "распушен", "распушена", "распушено", "распушены", "распущен", "распущена", "распущено", "распущены", "распылен", "распылена", "распылено", "распылены", "распялен", "распялена", "распялено", "распялены", "распят", "распята", "распято", "распяты", "рассажен", "рассажена", "рассажено", "рассажены", "рассекречен", "рассекречена", "рассекречено", "рассекречены", "расселен", "расселена", "расселено", "расселены", "рассержен", "рассержена", "рассержено", "рассержены", "рассечен", "рассечена", "рассечено", "рассечены", "рассеян", "рассеяна", "рассеяно", "рассеяны", "рассказан", "рассказана", "рассказано", "рассказаны", "расследован", "расследована", "расследовано", "расследованы", "расслышан", "расслышана", "расслышано", "расслышаны", "рассмешен", "рассмешена", "рассмешено", "рассмешены", "рассмотрен", "рассмотрена", "рассмотрено", "рассмотрены", "рассортирован", "рассортирована", "рассортировано", "рассортированы", "расспрошен", "расспрошена", "расспрошено", "расспрошены", "рассредоточен", "рассредоточена", "рассредоточено", "рассредоточены", "расставлен", "расставлена", "расставлено", "расставлены", "расстегнут", "расстегнута", "расстегнуто", "расстегнуты", "расстелен", "расстелена", "расстелено", "расстелены", "расстрелян", "расстреляна", "расстреляно", "расстреляны", "расстроен", "расстроена", "расстроено", "расстроены", "рассчитан", "рассчитана", "рассчитано", "рассчитаны", "растащен", "растащена", "растащено", "растащены", "растворен", "растворена", "растворено", "растворены", "растерзан", "растерзана", "растерзано", "растерзаны", "растерт", "растерта", "растерто", "растерты", "растерян", "растеряна", "растеряно", "растеряны", "растлен", "растлена", "растлено", "растлены", "растолкан", "растолкана", "растолкано", "растолканы", "растолкован", "растолкована", "растолковано", "растолкованы", "растоплен", "растоплена", "растоплено", "растоплены", "растоптан", "растоптана", "растоптано", "растоптаны", "растопырен", "растопырена", "растопырено", "растопырены", "расторгнут", "расторгнута", "расторгнуто", "расторгнуты", "растормошен", "растормошена", "растормошено", "растормошены", "растравлен", "растравлена", "растравлено", "растравлены", "растрачен", "растрачена", "растрачено", "растрачены", "растревожен", "растревожена", "растревожено", "растревожены", "растрепан", "растрепана", "растрепано", "растрепаны", "растроган", "растрогана", "растрогано", "растроганы", "растрясен", "растрясена", "растрясено", "растрясены", "растянут", "растянута", "растянуто", "растянуты", "расфасован", "расфасована", "расфасовано", "расфасованы", "расформирован", "расформирована", "расформировано", "расформированы", "расхвален", "расхвалена", "расхвалено", "расхвалены", "расхлебан", "расхлебана", "расхлебано", "расхлебаны", "расцарапан", "расцарапана", "расцарапано", "расцарапаны", "расцвечен", "расцвечена", "расцвечено", "расцвечены", "расцелован", "расцелована", "расцеловано", "расцелованы", "расценен", "расценена", "расценено", "расценены", "расцеплен", "расцеплена", "расцеплено", "расцеплены", "расчерчен", "расчерчена", "расчерчено", "расчерчены", "расчесан", "расчесана", "расчесано", "расчесаны", "расчищен", "расчищена", "расчищено", "расчищены", "расчленен", "расчленена", "расчленено", "расчленены", "расшатан", "расшатана", "расшатано", "расшатаны", "расшвырян", "расшвыряна", "расшвыряно", "расшвыряны", "расшевелен", "расшевелена", "расшевелено", "расшевелены", "расширен", "расширена", "расширено", "расширены", "расшит", "расшита", "расшито", "расшиты", "расшифрован", "расшифрована", "расшифровано", "расшифрованы", "расщеплен", "расщеплена", "расщеплено", "расщеплены", "ратифицирован", "ратифицирована", "ратифицировано", "ратифицированы", "рационализирован", "рационализирована", "рационализировано", "рационализированы", "реабилитирован", "реабилитирована", "реабилитировано", "реабилитированы", "реализован", "реализована", "реализовано", "реализованы", "ревизован", "ревизована", "ревизовано", "ревизованы", "регенерирован", "регенерирована", "регенерировано", "регенерированы", "регламентирован", "регламентирована", "регламентировано", "регламентированы", "редуцирован", "редуцирована", "редуцировано", "редуцированы", "резервирован", "резервирована", "резервировано", "резервированы", "резюмирован", "резюмирована", "резюмировано", "резюмированы", "реквизирован", "реквизирована", "реквизировано", "реквизированы", "рекомендован", "рекомендована", "рекомендовано", "рекомендованы", "реконструирован", "реконструирована", "реконструировано", "реконструированы", "рекрутирован", "рекрутирована", "рекрутировано", "рекрутированы", "ремонтирован", "ремонтирована", "ремонтировано", "ремонтированы", "репрессирован", "репрессирована", "репрессировано", "репрессированы", "реставрирован", "реставрирована", "реставрировано", "реставрированы", "реформирован", "реформирована", "реформировано", "реформированы", "решен", "решена", "решено", "решены", "рожден", "рождена", "рождено", "рождены", "романтизирован", "романтизирована", "романтизировано", "романтизированы", "рукоположен", "рукоположена", "рукоположено", "рукоположены", "русифицирован", "русифицирована", "русифицировано", "русифицированы", "саботирован", "саботирована", "саботировано", "саботированы", "сагитирован", "сагитирована", "сагитировано", "сагитированы", "санкционирован", "санкционирована", "санкционировано", "санкционированы", "сбалансирован", "сбалансирована", "сбалансировано", "сбалансированы", "сбережен", "сбережена", "сбережено", "сбережены", "сбит", "сбита", "сбито", "сбиты", "сближен", "сближена", "сближено", "сближены", "сбрит", "сбрита", "сбрито", "сбриты", "сброшен", "сброшена", "сброшено", "сброшены", "сбрызнут", "сбрызнута", "сбрызнуто", "сбрызнуты", "свален", "свалена", "свалено", "свалены", "сварганен", "сварганена", "сварганено", "сварганены", "сварен", "сварена", "сварено", "сварены", "сведен", "сведена", "сведено", "сведены", "свезен", "свезена", "свезено", "свезены", "свергнут", "свергнута", "свергнуто", "свергнуты", "сверен", "сверена", "сверено", "сверены", "свернут", "свернута", "свернуто", "свернуты", "сверстан", "сверстана", "сверстано", "сверстаны", "свершен", "свершена", "свершено", "свершены", "свешен", "свешена", "свешено", "свешены", "свинчен", "свинчена", "свинчено", "свинчены", "свистнут", "свистнута", "свистнуто", "свистнуты", "свит", "свита", "свито", "свиты", "сворован", "сворована", "своровано", "сворованы", "сворочен", "сворочена", "сворочено", "сворочены", "связан", "связана", "связано", "связаны", "сглажен", "сглажена", "сглажено", "сглажены", "сгноен", "сгноена", "сгноено", "сгноены", "сгорблена", "сгорблено", "сгорблены", "сготовлен", "сготовлена", "сготовлено", "сготовлены", "сгруппирован", "сгруппирована", "сгруппировано", "сгруппированы", "сгрызен", "сгрызена", "сгрызено", "сгрызены", "сгублен", "сгублена", "сгублено", "сгублены", "сгущен", "сгущена", "сгущено", "сгущены", "сдавлен", "сдавлена", "сдавлено", "сдавлены", "сдвинут", "сдвинута", "сдвинуто", "сдвинуты", "сдвоен", "сдвоена", "сдвоено", "сдвоены", "сделан", "сделана", "сделано", "сделаны", "сдержан", "сдержана", "сдержано", "сдержаны", "сдернут", "сдернута", "сдернуто", "сдернуты", "сдобрен", "сдобрена", "сдобрено", "сдобрены", "сдут", "сдута", "сдуто", "сдуты", "секуляризован", "секуляризована", "секуляризовано", "секуляризованы", "сенсибилизирован", "сенсибилизирована", "сенсибилизировано", "сенсибилизированы", "сервирован", "сервирована", "сервировано", "сервированы", "сжат", "сжата", "сжато", "сжаты", "сжеван", "сжевана", "сжевано", "сжеваны", "сжит", "сжита", "сжито", "сжиты", "сигнализирован", "сигнализирована", "сигнализировано", "сигнализированы", "симулирован", "симулирована", "симулировано", "симулированы", "синдицирован", "синдицирована", "синдицировано", "синдицированы", "синтезирован", "синтезирована", "синтезировано", "синтезированы", "синхронизирован", "синхронизирована", "синхронизировано", "синхронизированы", "систематизирован", "систематизирована", "систематизировано", "систематизированы", "сказан", "сказана", "сказано", "сказаны", "сказанут", "сказанута", "сказануто", "сказануты", "скачан", "скачана", "скачано", "скачаны", "скинут", "скинута", "скинуто", "скинуты", "складирован", "складирована", "складировано", "складированы", "склеван", "склевана", "склевано", "склеваны", "склеен", "склеена", "склеено", "склеены", "склонен", "склонена", "склонено", "склонены", "скован", "скована", "сковано", "скованы", "сколот", "сколота", "сколото", "сколоты", "сколочен", "сколочена", "сколочено", "сколочены", "скомандован", "скомандована", "скомандовано", "скомандованы", "скомкан", "скомкана", "скомкано", "скомканы", "скомпенсирован", "скомпенсирована", "скомпенсировано", "скомпенсированы", "скомпонован", "скомпонована", "скомпоновано", "скомпонованы", "скомпрометирован", "скомпрометирована", "скомпрометировано", "скомпрометированы", "сконструирован", "сконструирована", "сконструировано", "сконструированы", "сконцентрирован", "сконцентрирована", "сконцентрировано", "сконцентрированы", "скоординирован", "скоординирована", "скоординировано", "скоординированы", "скопирован", "скопирована", "скопировано", "скопированы", "скормлен", "скормлена", "скормлено", "скормлены", "скорректирован", "скорректирована", "скорректировано", "скорректированы", "скособочен", "скособочена", "скособочено", "скособочены", "скошен", "скошена", "скошено", "скошены", "скрашен", "скрашена", "скрашено", "скрашены", "скреплен", "скреплена", "скреплено", "скреплены", "скрещен", "скрещена", "скрещено", "скрещены", "скривлен", "скривлена", "скривлено", "скривлены", "скроен", "скроена", "скроено", "скроены", "скручен", "скручена", "скручено", "скручены", "скрыт", "скрыта", "скрыто", "скрыты", "скрючен", "скрючена", "скрючено", "скрючены", "скуплен", "скуплена", "скуплено", "скуплены", "скушан", "скушана", "скушано", "скушаны", "слажен", "слажена", "слажено", "слажены", "слеплен", "слеплена", "слеплено", "слеплены", "слизан", "слизана", "слизано", "слизаны", "слизнут", "слизнута", "слизнуто", "слизнуты", "слит", "слита", "слито", "слиты", "сличен", "сличена", "сличено", "сличены", "словлен", "словлена", "словлено", "словлены", "сложен", "сложена", "сложено", "сложены", "сломан", "сломана", "сломано", "сломаны", "сломлен", "сломлена", "сломлено", "сломлены", "слопан", "слопана", "слопано", "слопаны", "слуплен", "слуплена", "слуплено", "слуплены", "смазана", "смазано", "смазаны", "смастерен", "смастерена", "смастерено", "смастерены", "сменен", "сменена", "сменено", "сменены", "сменян", "сменяна", "сменяно", "сменяны", "смерен", "смерена", "смерено", "смерены", "сметен", "сметена", "сметено", "сметены", "смешан", "смешана", "смешано", "смешаны", "смещен", "смещена", "смещено", "смещены", "смирен", "смирена", "смирено", "смирены", "смоделирован", "смоделирована", "смоделировано", "смоделированы", "смонтирован", "смонтирована", "смонтировано", "смонтированы", "сморен", "сморена", "сморено", "сморены", "сморожен", "сморожена", "сморожено", "сморожены", "сморщен", "сморщена", "сморщено", "сморщены", "смотан", "смотана", "смотано", "смотаны", "смочен", "смочена", "смочено", "смочены", "смыт", "смыта", "смыто", "смыты", "смягчен", "смягчена", "смягчено", "смягчены", "смят", "смята", "смято", "смяты", "снабжен", "снабжена", "снабжено", "снабжены", "снаряжен", "снаряжена", "снаряжено", "снаряжены", "снесен", "снесена", "снесено", "снесены", "снижен", "снижена", "снижено", "снижены", "снискан", "снискана", "снискано", "снисканы", "сношен", "сношена", "сношено", "сношены", "снят", "снята", "снято", "сняты", "соблазнен", "соблазнена", "соблазнено", "соблазнены", "соблюден", "соблюдена", "соблюдено", "соблюдены", "собран", "собрана", "собрано", "собраны", "совершен", "совершена", "совершено", "совершены", "совмещен", "совмещена", "совмещено", "совмещены", "совращен", "совращена", "совращено", "совращены", "согласован", "согласована", "согласовано", "согласованы", "согнан", "согнана", "согнано", "согнаны", "согнут", "согнута", "согнуто", "согнуты", "согрет", "согрета", "согрето", "согреты", "содеян", "содеяна", "содеяно", "содеяны", "содран", "содрана", "содрано", "содраны", "соединен", "соединена", "соединено", "соединены", "сожжен", "сожжена", "сожжено", "сожжены", "сожран", "сожрана", "сожрано", "сожраны", "созван", "созвана", "созвано", "созваны", "сокращен", "сокращена", "сокращено", "сокращены", "сокрушен", "сокрушена", "сокрушено", "сокрушены", "сокрыт", "сокрыта", "сокрыто", "сокрыты", "соображен", "соображена", "соображено", "соображены", "сообщен", "сообщена", "сообщено", "сообщены", "сооружен", "сооружена", "сооружено", "сооружены", "соотнесен", "соотнесена", "соотнесено", "соотнесены", "сопоставлен", "сопоставлена", "сопоставлено", "сопоставлены", "сопровожден", "сопровождена", "сопровождено", "сопровождены", "сопряжен", "сопряжена", "сопряжено", "сопряжены", "сорван", "сорвана", "сорвано", "сорваны", "сориентирован", "сориентирована", "сориентировано", "сориентированы", "сосватан", "сосватана", "сосватано", "сосватаны", "соскребен", "соскребена", "соскребено", "соскребены", "сослан", "сослана", "сослано", "сосланы", "сослужен", "сослужена", "сослужено", "сослужены", "сосредоточен", "сосредоточена", "сосредоточено", "сосредоточены", "составлен", "составлена", "составлено", "составлены", "состарен", "состарена", "состарено", "состарены", "сострижен", "сострижена", "сострижено", "сострижены", "состроен", "состроена", "состроено", "состроены", "состряпан", "состряпана", "состряпано", "состряпаны", "состыкован", "состыкована", "состыковано", "состыкованы", "сосчитан", "сосчитана", "сосчитано", "сосчитаны", "сотворен", "сотворена", "сотворено", "сотворены", "соткан", "соткана", "соткано", "сотканы", "сотрясен", "сотрясена", "сотрясено", "сотрясены", "сохранен", "сохранена", "сохранено", "сохранены", "сочинен", "сочинена", "сочинено", "сочинены", "сочтен", "сочтена", "сочтено", "сочтены", "спалена", "спалено", "спалены", "спасен", "спасена", "спасено", "спасены", "спаян", "спаяна", "спаяно", "спаяны", "спеленан", "спеленана", "спеленано", "спеленаны", "сперт", "сперта", "сперто", "сперты", "спет", "спета", "спето", "спеты", "специализирован", "специализирована", "специализировано", "специализированы", "спешен", "спешена", "спешено", "спешены", "спилен", "спилена", "спилено", "спилены", "списан", "списана", "списано", "списаны", "спихнут", "спихнута", "спихнуто", "спихнуты", "сплавлен", "сплавлена", "сплавлено", "сплавлены", "спланирован", "спланирована", "спланировано", "спланированы", "сплетен", "сплетена", "сплетено", "сплетены", "сплочен", "сплочена", "сплочено", "сплочены", "сплюнут", "сплюнута", "сплюнуто", "сплюнуты", "сплющен", "сплющена", "сплющено", "сплющены", "сподоблен", "сподоблена", "сподоблено", "сподоблены", "сполоснут", "сполоснута", "сполоснуто", "сполоснуты", "спорот", "спорота", "спорото", "спороты", "справлен", "справлена", "справлено", "справлены", "спрессован", "спрессована", "спрессовано", "спрессованы", "спроважен", "спроважена", "спроважено", "спроважены", "спровоцирован", "спровоцирована", "спровоцировано", "спровоцированы", "спроектирован", "спроектирована", "спроектировано", "спроектированы", "спроецирован", "спроецирована", "спроецировано", "спроецированы", "спрошен", "спрошена", "спрошено", "спрошены", "спрятан", "спрятана", "спрятано", "спрятаны", "спущен", "спущена", "спущено", "спущены", "сработан", "сработана", "сработано", "сработаны", "сравнен", "сравнена", "сравнено", "сравнены", "сражен", "сражена", "сражено", "сражены", "сращен", "сращена", "сращено", "сращены", "срезан", "срезана", "срезано", "срезаны", "срисован", "срисована", "срисовано", "срисованы", "сровнян", "сровняна", "сровняно", "сровняны", "срубан", "срубана", "срубано", "срубаны", "срублен", "срублена", "срублено", "срублены", "ссажен", "ссажена", "ссажено", "ссажены", "ссужен", "ссужена", "ссужено", "ссужены", "стабилизирован", "стабилизирована", "стабилизировано", "стабилизированы", "станцеван", "станцевана", "станцевано", "станцеваны", "стащен", "стащена", "стащено", "стащены", "стерилизован", "стерилизована", "стерилизовано", "стерилизованы", "стерт", "стерта", "стерто", "стерты", "стесан", "стесана", "стесано", "стесаны", "стеснен", "стеснена", "стеснено", "стеснены", "стилизован", "стилизована", "стилизовано", "стилизованы", "стимулирован", "стимулирована", "стимулировано", "стимулированы", "стиснут", "стиснута", "стиснуто", "стиснуты", "столкнут", "столкнута", "столкнуто", "столкнуты", "стоптан", "стоптана", "стоптано", "стоптаны", "сточен", "сточена", "сточено", "сточены", "стравлен", "стравлена", "стравлено", "стравлены", "стрельнут", "стрельнута", "стрельнуто", "стрельнуты", "стреножен", "стреножена", "стреножено", "стреножены", "структурирован", "структурирована", "структурировано", "структурированы", "стряхнут", "стряхнута", "стряхнуто", "стряхнуты", "стукнут", "стукнута", "стукнуто", "стукнуты", "стырен", "стырена", "стырено", "стырены", "стянут", "стянута", "стянуто", "стянуты", "сублимирован", "сублимирована", "сублимировано", "сублимированы", "субсидирован", "субсидирована", "субсидировано", "субсидированы", "суммирован", "суммирована", "суммировано", "суммированы", "сунут", "сунута", "сунуто", "сунуты", "сфабрикован", "сфабрикована", "сфабриковано", "сфабрикованы", "сфокусирован", "сфокусирована", "сфокусировано", "сфокусированы", "сформирован", "сформирована", "сформировано", "сформированы", "сформулирован", "сформулирована", "сформулировано", "сформулированы", "сфотографирован", "сфотографирована", "сфотографировано", "сфотографированы", "схвачен", "схвачена", "схвачено", "схвачены", "схлопотан", "схлопотана", "схлопотано", "схлопотаны", "схоронен", "схоронена", "схоронено", "схоронены", "сцапан", "сцапана", "сцапано", "сцапаны", "сцементирован", "сцементирована", "сцементировано", "сцементированы", "сцеплен", "сцеплена", "сцеплено", "сцеплены", "сшит", "сшита", "сшито", "сшиты", "сыгран", "сыграна", "сыграно", "сыграны", "сэкономлен", "сэкономлена", "сэкономлено", "сэкономлены", "таранен", "таранена", "таранено", "таранены", "татуирован", "татуирована", "татуировано", "татуированы", "телеграфирован", "телеграфирована", "телеграфировано", "телеграфированы", "терроризирован", "терроризирована", "терроризировано", "терроризированы", "тиражирован", "тиражирована", "тиражировано", "тиражированы", "титулована", "титуловано", "титулованы", "ткнут", "ткнута", "ткнуто", "ткнуты", "толкнут", "толкнута", "толкнуто", "толкнуты", "тонизирован", "тонизирована", "тонизировано", "тонизированы", "тонирован", "тонирована", "тонировано", "тонированы", "торпедирован", "торпедирована", "торпедировано", "торпедированы", "травмирован", "травмирована", "травмировано", "травмированы", "транслирован", "транслирована", "транслировано", "транслированы", "транспортирован", "транспортирована", "транспортировано", "транспортированы", "трансформирован", "трансформирована", "трансформировано", "трансформированы", "трассирован", "трассирована", "трассировано", "трассированы", "трахнут", "трахнута", "трахнуто", "трахнуты", "треснут", "треснута", "треснуто", "треснуты", "тронут", "тронута", "тронуто", "тронуты", "трудоустроен", "трудоустроена", "трудоустроено", "трудоустроены", "турнут", "турнута", "турнуто", "турнуты", "тюкнут", "тюкнута", "тюкнуто", "тюкнуты", "тяпнут", "тяпнута", "тяпнуто", "тяпнуты", "убавлен", "убавлена", "убавлено", "убавлены", "убаюкан", "убаюкана", "убаюкано", "убаюканы", "убежден", "убеждена", "убеждено", "убеждены", "убелен", "убелена", "убелено", "убелены", "убережен", "убережена", "убережено", "убережены", "убит", "убита", "убито", "убиты", "ублажен", "ублажена", "ублажено", "ублажены", "убран", "убрана", "убрано", "убраны", "убыстрен", "убыстрена", "убыстрено", "убыстрены", "уважен", "уважена", "уважено", "уважены", "уварен", "уварена", "уварено", "уварены", "уведен", "уведена", "уведено", "уведены", "уведомлен", "уведомлена", "уведомлено", "уведомлены", "увезен", "увезена", "увезено", "увезены", "увековечен", "увековечена", "увековечено", "увековечены", "увеличен", "увеличена", "увеличено", "увеличены", "увенчан", "увенчана", "увенчано", "увенчаны", "уверен", "уверена", "уверено", "уверены", "увешан", "увешана", "увешано", "увешаны", "увешен", "увешена", "увешено", "увешены", "увидан", "увидана", "увидано", "увиданы", "увиден", "увидена", "увидено", "увидены", "увит", "увита", "увито", "увиты", "увлажнен", "увлажнена", "увлажнено", "увлажнены", "увлечен", "увлечена", "увлечено", "увлечены", "увожен", "увожена", "увожено", "увожены", "уволен", "уволена", "уволено", "уволены", "уворован", "уворована", "уворовано", "уворованы", "увязан", "увязана", "увязано", "увязаны", "угадан", "угадана", "угадано", "угаданы", "углублен", "углублена", "углублено", "углублены", "угляжен", "угляжена", "угляжено", "угляжены", "угнан", "угнана", "угнано", "угнаны", "угнетен", "угнетена", "угнетено", "угнетены", "уговорен", "уговорена", "уговорено", "уговорены", "угомонен", "угомонена", "угомонено", "угомонены", "угонян", "угоняна", "угоняно", "угоняны", "угоразжен", "угоразжена", "угоразжено", "угоразжены", "уготован", "уготована", "уготовано", "уготованы", "уготовлен", "уготовлена", "уготовлено", "уготовлены", "угощен", "угощена", "угощено", "угощены", "угроблен", "угроблена", "угроблено", "угроблены", "угрохан", "угрохана", "угрохано", "угроханы", "удавлен", "удавлена", "удавлено", "удавлены", "удален", "удалена", "удалено", "удалены", "ударен", "ударена", "ударено", "ударены", "удвоен", "удвоена", "удвоено", "удвоены", "уделан", "уделана", "уделано", "уделаны", "уделен", "уделена", "уделено", "уделены", "удержан", "удержана", "удержано", "удержаны", "удесятерен", "удесятерена", "удесятерено", "удесятерены", "удешевлен", "удешевлена", "удешевлено", "удешевлены", "удивлен", "удивлена", "удивлено", "удивлены", "удлинен", "удлинена", "удлинено", "удлинены", "удобрен", "удобрена", "удобрено", "удобрены", "удовлетворен", "удовлетворена", "удовлетворено", "удовлетворены", "удостоверен", "удостоверена", "удостоверено", "удостоверены", "удостоен", "удостоена", "удостоено", "удостоены", "удочерен", "удочерена", "удочерено", "удочерены", "удружен", "удружена", "удружено", "удружены", "удручен", "удручена", "удручено", "удручены", "удуман", "удумана", "удумано", "удуманы", "удушен", "удушена", "удушено", "удушены", "ужален", "ужалена", "ужалено", "ужалены", "ужаснут", "ужаснута", "ужаснуто", "ужаснуты", "ужат", "ужата", "ужато", "ужаты", "узаконен", "узаконена", "узаконено", "узаконены", "узнан", "узнана", "узнано", "узнаны", "узурпирован", "узурпирована", "узурпировано", "узурпированы", "указан", "указана", "указано", "указаны", "укатан", "укатана", "укатано", "укатаны", "укачан", "укачана", "укачано", "укачаны", "укачен", "укачена", "укачено", "укачены", "укокошен", "укокошена", "укокошено", "укокошены", "уколот", "уколота", "уколото", "уколоты", "укомплектован", "укомплектована", "укомплектовано", "укомплектованы", "укорен", "укорена", "укорено", "укорены", "укоренен", "укоренена", "укоренено", "укоренены", "укорочен", "укорочена", "укорочено", "укорочены", "украден", "украдена", "украдено", "украдены", "украшен", "украшена", "украшено", "украшены", "укреплен", "укреплена", "укреплено", "укреплены", "укрощен", "укрощена", "укрощено", "укрощены", "укрупнен", "укрупнена", "укрупнено", "укрупнены", "укрыт", "укрыта", "укрыто", "укрыты", "укупорен", "укупорена", "укупорено", "укупорены", "укутан", "укутана", "укутано", "укутаны", "укушен", "укушена", "укушено", "укушены", "улажен", "улажена", "улажено", "улажены", "уличен", "уличена", "уличено", "уличены", "уловлен", "уловлена", "уловлено", "уловлены", "уложен", "уложена", "уложено", "уложены", "уломан", "уломана", "уломано", "уломаны", "улучен", "улучена", "улучено", "улучены", "улучшен", "улучшена", "улучшено", "улучшены", "умален", "умалена", "умалено", "умалены", "уменьшен", "уменьшена", "уменьшено", "уменьшены", "умерен", "умерена", "умерено", "умерены", "умерщвлен", "умерщвлена", "умерщвлено", "умерщвлены", "умещен", "умещена", "умещено", "умещены", "умилен", "умилена", "умилено", "умилены", "умиротворен", "умиротворена", "умиротворено", "умиротворены", "умножен", "умножена", "умножено", "умножены", "умолен", "умолена", "умолено", "умолены", "уморен", "уморена", "уморено", "уморены", "умотан", "умотана", "умотано", "умотаны", "умудрен", "умудрена", "умудрено", "умудрены", "умыкнут", "умыкнута", "умыкнуто", "умыкнуты", "умыт", "умыта", "умыто", "умыты", "умят", "умята", "умято", "умяты", "унаследован", "унаследована", "унаследовано", "унаследованы", "унесен", "унесена", "унесено", "унесены", "унижен", "унижена", "унижено", "унижены", "унизан", "унизана", "унизано", "унизаны", "унифицирован", "унифицирована", "унифицировано", "унифицированы", "уничтожен", "уничтожена", "уничтожено", "уничтожены", "унюхан", "унюхана", "унюхано", "унюханы", "унят", "унята", "унято", "уняты", "упакован", "упакована", "упаковано", "упакованы", "упасен", "упасена", "упасено", "упасены", "упечен", "упечена", "упечено", "упечены", "уплачен", "уплачена", "уплачено", "уплачены", "уплотнен", "уплотнена", "уплотнено", "уплотнены", "уподоблен", "уподоблена", "уподоблено", "уподоблены", "упоен", "упоена", "упоено", "упоены", "упокоен", "упокоена", "упокоено", "упокоены", "уполномочен", "уполномочена", "уполномочено", "уполномочены", "упомнен", "упомнена", "упомнено", "упомнены", "упомянут", "упомянута", "упомянуто", "упомянуты", "упорядочен", "упорядочена", "упорядочено", "упорядочены", "употреблен", "употреблена", "употреблено", "употреблены", "упразднен", "упразднена", "упразднено", "упразднены", "упрежден", "упреждена", "упреждено", "упреждены", "упрекнут", "упрекнута", "упрекнуто", "упрекнуты", "упрочен", "упрочена", "упрочено", "упрочены", "упрошен", "упрошена", "упрошено", "упрошены", "упрощен", "упрощена", "упрощено", "упрощены", "упрятан", "упрятана", "упрятано", "упрятаны", "упущен", "упущена", "упущено", "упущены", "уравновешен", "уравновешена", "уравновешено", "уравновешены", "уравнян", "уравняна", "уравняно", "уравняны", "урегулирован", "урегулирована", "урегулировано", "урегулированы", "урезан", "урезана", "урезано", "урезаны", "урезонен", "урезонена", "урезонено", "урезонены", "уронен", "уронена", "уронено", "уронены", "усажен", "усажена", "усажено", "усажены", "усвоен", "усвоена", "усвоено", "усвоены", "усечен", "усечена", "усечено", "усечены", "усеян", "усеяна", "усеяно", "усеяны", "усижен", "усижена", "усижено", "усижены", "усилен", "усилена", "усилено", "усилены", "ускорен", "ускорена", "ускорено", "ускорены", "услан", "услана", "услано", "усланы", "усложнен", "усложнена", "усложнено", "усложнены", "услыхан", "услыхана", "услыхано", "услыханы", "услышан", "услышана", "услышано", "услышаны", "усмирен", "усмирена", "усмирено", "усмирены", "усмотрен", "усмотрена", "усмотрено", "усмотрены", "усовершенствован", "усовершенствована", "усовершенствовано", "усовершенствованы", "успокоен", "успокоена", "успокоено", "успокоены", "усреднен", "усреднена", "усреднено", "усреднены", "уставлен", "уставлена", "уставлено", "уставлены", "установлен", "установлена", "установлено", "установлены", "устлан", "устлана", "устлано", "устланы", "устранен", "устранена", "устранено", "устранены", "устрашен", "устрашена", "устрашено", "устрашены", "устремлен", "устремлена", "устремлено", "устремлены", "устроен", "устроена", "устроено", "устроены", "уступлен", "уступлена", "уступлено", "уступлены", "усугублен", "усугублена", "усугублено", "усугублены", "усыновлен", "усыновлена", "усыновлено", "усыновлены", "усыплен", "усыплена", "усыплено", "усыплены", "утаен", "утаена", "утаено", "утаены", "утащен", "утащена", "утащено", "утащены", "утвержден", "утверждена", "утверждено", "утверждены", "утеплен", "утеплена", "утеплено", "утеплены", "утерт", "утерта", "утерто", "утерты", "утерян", "утеряна", "утеряно", "утеряны", "утешен", "утешена", "утешено", "утешены", "утилизирован", "утилизирована", "утилизировано", "утилизированы", "утихомирен", "утихомирена", "утихомирено", "утихомирены", "утолен", "утолена", "утолено", "утолены", "утопан", "утопана", "утопано", "утопаны", "утоплен", "утоплена", "утоплено", "утоплены", "утоптан", "утоптана", "утоптано", "утоптаны", "уточнен", "уточнена", "уточнено", "уточнены", "утрамбован", "утрамбована", "утрамбовано", "утрамбованы", "утрачен", "утрачена", "утрачено", "утрачены", "утрирован", "утрирована", "утрировано", "утрированы", "утроен", "утроена", "утроено", "утроены", "утрясен", "утрясена", "утрясено", "утрясены", "утыкан", "утыкана", "утыкано", "утыканы", "утяжелен", "утяжелена", "утяжелено", "утяжелены", "утянут", "утянута", "утянуто", "утянуты", "ухвачен", "ухвачена", "ухвачено", "ухвачены", "ухлопан", "ухлопана", "ухлопано", "ухлопаны", "ухожен", "ухожена", "ухожено", "ухожены", "ухудшен", "ухудшена", "ухудшено", "ухудшены", "уценен", "уценена", "уценено", "уценены", "учинен", "учинена", "учинено", "учинены", "учрежден", "учреждена", "учреждено", "учреждены", "учтен", "учтена", "учтено", "учтены", "учуян", "учуяна", "учуяно", "учуяны", "ушит", "ушита", "ушито", "ушиты", "ущемлен", "ущемлена", "ущемлено", "ущемлены", "ущипнут", "ущипнута", "ущипнуто", "ущипнуты", "уязвлен", "уязвлена", "уязвлено", "уязвлены", "уяснен", "уяснена", "уяснено", "уяснены", "фальсифицирован", "фальсифицирована", "фальсифицировано", "фальсифицированы", "фиксирован", "фиксирована", "фиксировано", "фиксированы", "финансирован", "финансирована", "финансировано", "финансированы", "фланкирован", "фланкирована", "фланкировано", "фланкированы", "форсирован", "форсирована", "форсировано", "форсированы", "характеризован", "характеризована", "характеризовано", "характеризованы", "хлестнут", "хлестнута", "хлестнуто", "хлестнуты", "хлопнут", "хлопнута", "хлопнуто", "хлопнуты", "цапнут", "цапнута", "цапнуто", "цапнуты", "царапнут", "царапнута", "царапнуто", "царапнуты", "централизован", "централизована", "централизовано", "централизованы", "центрифугирован", "центрифугирована", "центрифугировано", "центрифугированы", "цивилизован", "цивилизована", "цивилизовано", "цивилизованы", "черкнут", "черкнута", "черкнуто", "черкнуты", "четвертован", "четвертована", "четвертовано", "четвертованы", "чмокнут", "чмокнута", "чмокнуто", "чмокнуты", "шарахнут", "шарахнута", "шарахнуто", "шарахнуты", "швырнут", "швырнута", "швырнуто", "швырнуты", "шлепнут", "шлепнута", "шлепнуто", "шлепнуты", "шмякнут", "шмякнута", "шмякнуто", "шмякнуты", "шокирован", "шокирована", "шокировано", "шокированы", "щелкнут", "щелкнута", "щелкнуто", "щелкнуты", "эвакуирован", "эвакуирована", "эвакуировано", "эвакуированы", "экипирован", "экипирована", "экипировано", "экипированы", "экранизирован", "экранизирована", "экранизировано", "экранизированы", "экранирован", "экранирована", "экранировано", "экранированы", "экспонирован", "экспонирована", "экспонировано", "экспонированы", "экспортирован", "экспортирована", "экспортировано", "экспортированы", "экспроприирован", "экспроприирована", "экспроприировано", "экспроприированы", "экстрагирован", "экстрагирована", "экстрагировано", "экстрагированы", "экстраполирован", "экстраполирована", "экстраполировано", "экстраполированы", "эмитирован", "эмитирована", "эмитировано", "эмитированы", "эпатирован", "эпатирована", "эпатировано", "эпатированы", "этапирован", "этапирована", "этапировано", "этапированы", "эшелонирован", "эшелонирована", "эшелонировано", "эшелонированы", "явлен", "явлена", "явлено", "явлены"];
// Participles that can take a "ё"-form. This and the following verb groups should be taken away as soon as Ё-functionality
// Is implemented
const orthographicFormsPassiveVerbs = ["благословлён", "введён", "ввезён", "вдохновлён", "вживлён", "взбешён", "взбодрён", "взведён", "взвихрён", "взгромозждён", "взращён", "взрыхлён", "видоизменён", "включён", "вколочён", "вкраплён", "вкушён", "вменён", "вмещён", "внедрён", "внесён", "внушён", "вовлечён", "водворён", "водружён", "возблагодарён", "возбуждён", "возведён", "возвещён", "возвращён", "возглашён", "возлюблён", "возмещён", "возмущён", "вознаграждён", "вознесён", "возобновлён", "возомнён", "возрождён", "вонждён", "воображён", "воодушевлён", "вооружён", "воплощён", "вопрошён", "ворочён", "воскрешён", "воспалён", "воспламенён", "воспрещён", "воспроизведён", "восстановлён", "восхищён", "вперён", "впечатлён", "вплетён", "впряжён", "вразумлён", "врублён", "вручён", "вселён", "вскипячён", "вскормлён", "вскружён", "всполошён", "выведён", "доведён", "довезён", "довершён", "догляжён", "договорён", "дозволён", "донесён", "допечён", "дотерплён", "завезён", "завершён", "завлечён", "завожён", "заворожён", "загашён", "заглублён", "заглушён", "заговорён", "загорожён", "загромозждён", "загружён", "загрязнён", "задурён", "задушён", "задымлён", "заземлён", "зазубрён", "закалён", "заклеймён", "заключён", "закопчё", "закреплён", "закруглён", "замедлён", "заменён", "заметён", "замещён", "заморён", "занесён", "заострён", "запалён", "запасён", "запечатлён", "запечён", "заплетён", "заполонён", "запорошён", "запрещён", "запримечён", "запрошён", "запряжён", "запылён", "заражён", "заряжён", "заселён", "заслонён", "засолён", "застолблён", "застопорён", "затаён", "затворён", "затемнён", "затенён", "затмлён", "затруднён", "захламлён", "зацеплён", "зачехлён", "зачищён", "зачтён", "зашевелён", "защемлён", "защищён", "избавлён", "изборозждён", "изведён", "извещён", "извинён", "извлечён", "извращён", "измельчён", "изменён", "измышлён", "изнурён", "изобличён", "изображён", "изобретён", "изречён", "изумлён", "изъявлён", "искажён", "исключён", "искоренён", "искривлён", "искуплён", "испепелён", "испечён", "испещрён", "иссечён", "иссушён", "истончён", "истощён", "истреблён", "казнён", "крещён", "лишён", "наводнён", "навострён", "наговорён", "награждён", "нагромозждён", "наделён", "накалён", "наклонён", "наметён", "нанесён", "напечён", "наплетён", "напоён", "напряжён", "наречён", "нарождён", "насаждён", "населён", "насмешён", "насторожён", "натравлён", "невзлюблён", "недогляжён", "недоговорён", "недооценён", "перечтён", "пленён", "побеждён", "побелён", "побережён", "погашён", "поглощён", "погребён", "погружён", "подведён", "подвезён", "подговорён", "подгребён", "подключён", "подкреплён", "подкручён", "подменён", "поднесён", "подожжён", "подпалён", "подразделён", "подрублён", "подрулён", "подселён", "подсечён", "подслащён", "подсоединён", "подстелён", "подстережён", "подтверждён", "подцеплён", "подчинён", "подчищён", "поздравлён", "позолочён", "покорён", "покривлён", "помещён", "понесён", "поощрён", "порабощён", "поражён", "порешён", "порождён", "посвящён", "посеребрён", "посмотрён", "посрамлён", "постановлён", "потереблён", "похоронён", "почтён", "пошевелён", "пощажён", "пояснён", "превращён", "прегражён", "предварён", "предвосхищён", "предопределён", "предостережён", "предотвращён", "предохранён", "предпочтён", "предречён", "предрешён", "предупреждён", "презрён", "преклонён", "прекращён", "преломлён", "прельщён", "преображён", "преодолён", "преподнесён", "пресечён", "преступлён", "претворён", "претерплён", "прибережён", "приближён", "приведён", "привезён", "привлечён", "привнесён", "приворожён", "пригвозжён", "приглашён", "приглушён", "приговорён", "приголублён", "приземлён", "приклонён", "прикреплён", "применён", "принаряжён", "принесён", "принуждён", "приободрён", "приобретён", "приобщён", "приостановлён", "приотворён", "припасён", "припечён", "приплетён", "приручён", "прислонён", "присмотрён", "присовокуплён", "присоединён", "присочинён", "приспособлён", "приструнён", "присуждён", "притворён", "провезён", "проговорён", "продешевлён", "продлён", "прозвонён", "произведён", "произнесён", "прокалён", "прокипячён", "прокопчён", "пронзён", "пропылён", "просверлён", "просветлён", "просвещён", "просечён", "просквожён", "проторён", "прочтён", "прощён", "проявлён", "прояснён", "разбережён", "разбомблён", "разведён", "развезён", "развеселён", "разворошён", "развращён", "разглашён", "разговорён", "разгорожён", "разгорячён", "разграфлён", "разгребён", "разгромлён", "разделён", "раздражён", "раздразнён", "раздроблён", "разлеплён", "разлучён", "размещён", "размозжён", "разморён", "размягчён", "разнесён", "разоблачён", "разобщён", "разожжён", "разозлён", "разорён", "разоружён", "разрежён", "разрешён", "разубеждён", "разъединён", "разъярён", "разъяснён", "раскалён", "расклешён", "раскрепощён", "раскроён", "распалён", "распотрошён", "распределён", "распространён", "распряжён", "распрямлён", "рассмешён", "растворён", "растлён", "растормошён", "растрясён", "расценён", "расцеплён", "расчленён", "расшевелён", "расщеплён", "сбережён", "свершён", "сгноён", "сгущён", "сожжён", "склонён", "скреплён", "скрещён", "скривлён", "скручён", "сличён", "словлён", "сметён", "смещён", "смущён", "смягчён", "снабжён", "снаряжён", "снесён", "соблазнён", "соблюдён", "совершён", "совмещён", "совращён", "соединён", "сокращён", "сокрушён", "соображён", "сообщён", "сооружён", "соотнесён", "сопоставлён", "сопровождён", "сопряжён", "сотворён", "сотрясён", "сохранён", "сочинён", "сочтён", "спалён", "сплетён", "сравнён", "сражён", "стеснён", "съязвлён", "убеждён", "убелён", "убережён", "ублажён", "убыстрён", "уведён", "увезён", "увлажнён", "увлечён", "углублён", "угнетён", "уговорён", "угомонён", "угощён", "удесятерён", "удешевлён", "удлинён", "удобрён", "удовлетворён", "удочерён", "удручён", "укоренён", "укреплён", "укрощён", "укрупнён", "уличён", "улучён", "умалён", "умерщвлён", "умещён", "умилён", "умиротворён", "умолён", "уморён", "умудрён", "унесён", "упасён", "упечён", "уплотнён", "упоён", "употреблён", "упразднён", "упреждён", "упрощён", "усечён", "усложнён", "усреднён", "устранён", "устрашён", "устремлён", "усыновлён", "усыплён", "утаён", "утверждён", "утеплён", "утолён", "утомлён", "уточнён", "утрясён", "утяжелён", "учреждён", "учтён", "ущемлён", "уязвлён", "уяснён", "явлён"];

// Participles that have ё in the middle of the word. This and the previous verb groups should be taken away as soon as
// Ё-functionality is implemented.
const alternativeVerbForms = ["ввёрнут", "ввёрнута", "ввёрнуто", "ввёрнуты", "вздёрнут", "вздёрнута", "вздёрнуто", "вздёрнуты", "втёрт", "втёрта", "втёрто", "втёрты", "завёрнут", "завёрнута", "завёрнуто", "завёрнуты", "задёрнут", "задёрнута", "задёрнуто", "задёрнуты", "замётан", "замётана", "замётано", "замётаны", "запелёнан", "запелёнана", "запелёнано", "запелёнаны", "заплёван", "заплёвана", "заплёвано", "заплёваны", "затёрт", "затёрта", "затёрто", "затёрты", "зачёркнут", "зачёркнута", "зачёркнуто", "зачёркнуты", "зачёрпнут", "зачёрпнута", "зачёрпнуто", "зачёрпнуты", "зачёсан", "зачёсана", "зачёсано", "зачёсаны", "зашёптан", "зашёптана", "зашёптано", "зашёптаны", "защёлкнут", "защёлкнута", "защёлкнуто", "защёлкнуты", "искорёжен", "искорёжена", "искорёжено", "искорёжены", "истёрт", "истёрта", "истёрто", "истёрты", "исчёркан", "исчёркана", "исчёркано", "исчёрканы", "исчёрпан", "исчёрпана", "исчёрпано", "исчёрпаны", "навёрнут", "навёрнута", "навёрнуто", "навёрнуты", "намётан", "намётана", "намётано", "намётаны", "наплёван", "наплёвана", "наплёвано", "наплёваны", "натёрт", "натёрта", "натёрто", "натёрты", "начёртан", "начёртана", "начёртано", "начёртаны", "начёрчен", "начёрчена", "начёрчено", "начёрчены", "нашёптан", "нашёптана", "нашёптано", "нашёптаны", "перечёркнут", "перечёркнута", "перечёркнуто", "перечёркнуты", "повёрнут", "повёрнута", "повёрнуто", "повёрнуты", "подвёрнут", "подвёрнута", "подвёрнуто", "подвёрнуты", "подёрнут", "подёрнута", "подёрнуто", "подёрнуты", "поддёрнут", "поддёрнута", "поддёрнуто", "поддёрнуты", "подмётан", "подмётана", "подмётано", "подмётаны", "подпёрт", "подпёрта", "подпёрто", "подпёрты", "подчёркнут", "подчёркнута", "подчёркнуто", "подчёркнуты", "пожёван", "пожёвана", "пожёвано", "пожёваны", "покорёжен", "покорёжена", "покорёжено", "покорёжены", "потёрт", "потёрта", "потёрто", "потёрты", "пощёлкан", "пощёлкана", "пощёлкано", "пощёлканы", "почёрпнут", "почёрпнута", "почёрпнуто", "почёрпнуты", "почёсан", "почёсана", "почёсано", "почёсаны", "притёрт", "притёрта", "притёрто", "притёрты", "причёсан", "причёсана", "причёсано", "причёсаны", "прищёлкнут", "прищёлкнута", "прищёлкнуто", "прищёлкнуты", "провёрнут", "провёрнута", "провёрнуто", "провёрнуты", "продёрнут", "продёрнута", "продёрнуто", "продёрнуты", "прожёван", "прожёвана", "прожёвано", "прожёваны", "простёрт", "простёрта", "простёрто", "простёрты", "протёрт", "протёрта", "протёрто", "протёрты", "прочёсан", "прочёсана", "прочёсано", "прочёсаны", "прошёптан", "прошёптана", "прошёптано", "прошёптаны", "развёрнут", "развёрнута", "развёрнуто", "развёрнуты", "раздёрнут", "раздёрнута", "раздёрнуто", "раздёрнуты", "разжёван", "разжёвана", "разжёвано", "разжёваны", "размётан", "размётана", "размётано", "размётаны", "распростёрт", "распростёрта", "распростёрто", "распростёрты", "растёрт", "растёрта", "растёрто", "растёрты", "расчёсан", "расчёсана", "расчёсано", "расчёсаны", "свёрнут", "свёрнута", "свёрнуто", "свёрнуты", "свёрстан", "свёрстана", "свёрстано", "свёрстаны", "сдёрнут", "сдёрнута", "сдёрнуто", "сдёрнуты", "сжёван", "сжёвана", "сжёвано", "сжёваны", "склёван", "склёвана", "склёвано", "склёваны", "спелёнан", "спелёнана", "спелёнано", "спелёнаны", "стёрт", "стёрта", "стёрто", "стёрты", "стёсан", "стёсана", "стёсано", "стёсаны", "утёрт", "утёрта", "утёрто", "утёрты", "утомлён", "утомлёна", "утомлёно", "утомлёны", "чёркнут", "чёркнута", "чёркнуто", "чёркнуты", "щёлкнут", "щёлкнута", "щёлкнуто", "щёлкнуты"];

// These participles can also be adjectives, so we need to be careful. If they cause a lot of trouble, can be easily
// Removed from analysis, if not they can also be merged with the big list.
const adjectiveParticiples = ["взбудоражен", "взволнован", "возбужден", "возмущен", "воспитан", "востребован", "выдрессирован", "газирован", "доношен", "заболочен", "заинтересован", "заинтригован", "закален", "зачарован", "зашифрован", "изогнут", "изогнута", "изогнуто", "изогнуты", "коррумпирован", "мотивирован", "помят", "помята", "помято", "помяты", "поношен", "потаскан", "потаскана", "потаскано", "потасканы", "сгорблен", "сконфужен", "сконфужена", "сконфужено", "сконфужены", "смазан", "титулован", "утомлен", "утомлена", "утомлено", "утомлены"];

var participles = {};

Object.defineProperty(participles, "__esModule", {
	value: true
});

participles.default = function () {
	return {
		all: passiveVerbs
	};
};

/**
 * Returns a list of all participles used for the Swedish passive voice assessment.
 * @returns {Array} The list with participles.
 */

const passiveVerbs = ["åberopades", "åberopas", "åberopats", "aborterades", "aborteras", "absorberades", "absorberas", "abstraherats", "acceleras", "accelereras", "accentuerades", "accentueras", "accentuerats", "accepeteras", "accepterades", "accepteras", "accepterats", "äcklades", "äcklas", "äcklats", "ackompagnerades", "ackompanjerades", "ackompanjeras", "ackompanjerats", "ackumuleras", "ackumulerats", "ådagalades", "ådagaläggs", "adderades", "adderas", "adderats", "adelspalats", "åderlåtas", "åderlåtits", "adidas", "adlades", "adlas", "adlats", "administrerades", "administreras", "ådömas", "ådömdes", "ådömes", "ådöms", "ådömts", "adopterades", "adopteras", "adopterats", "adresserades", "adresseras", "adresserats", "adventures", "affaires", "affischeras", "aflägsnas", "agades", "agas", "ägas", "ägdes", "ageras", "ägnades", "agnas", "ägnas", "ägnats", "ägs", "ägts", "åhördes", "aidstestas", "ajournerades", "ajourneras", "åkallades", "åkallas", "åkas", "aklagas", "åks", "aktades", "aktas", "akterseglas", "åktes", "äkthetsförklarades", "aktietips", "aktiverades", "aktiveras", "aktiverats", "aktivierats", "aktualiserades", "aktualiseras", "aktualiserats", "ålades", "åläggas", "åläggs", "ålagts", "alarmerades", "åldersbestämmas", "algas", "alienerades", "alldeldes", "alldelses", "alleles", "allendes", "allergiskadades", "allierades", "allokeras", "almsicks", "alouettes", "älskas", "älskats", "alstrades", "alstras", "alstrats", "ältades", "ältas", "ältats", "amatöriserades", "amerikaniseras", "ammades", "ammas", "ammats", "amores", "amorteras", "amorterats", "amputerades", "amputeras", "amputerats", "anades", "analyserades", "analyseras", "analyserats", "anammades", "anammas", "anammats", "anas", "anats", "anbefalldes", "anbefalles", "anbefalls", "anbringas", "anbringats", "anbudsupphandlas", "ändhållplats", "ändrades", "andras", "ändras", "ändrats", "anfäktades", "anfäktas", "anfäktats", "anfallas", "anfallits", "anfalls", "anfölls", "anföras", "anfördes", "anföres", "anförs", "anförtroddes", "anförtros", "anförtrotts", "anförts", "anfrätas", "ångades", "ångas", "ångats", "angavs", "anges", "angetts", "angives", "angivits", "angivs", "angjordes", "ångkokas", "angöras", "angörs", "ångras", "ångrats", "angreps", "angripas", "angripits", "angrips", "ängslades", "ängslas", "ängslats", "anhållas", "anhålles", "anhållits", "anhålls", "anhölls", "anhopas", "animeras", "ankalagas", "anklagades", "anklagas", "anklagats", "anklagts", "anknyts", "ankrades", "anlades", "anläggas", "anläggs", "anlagts", "anlitades", "anlitas", "anlitats", "anmälas", "anmäldes", "anmäles", "anmäls", "anmälts", "anmanas", "anmärkas", "anmärks", "anmärkts", "anmodades", "anmodas", "anmodats", "annekterades", "annekteras", "annekterats", "annonserades", "annonseras", "annonserats", "annuleras", "annullerades", "annulleras", "annvänds", "anordnades", "anordnas", "anordnats", "anpassades", "anpassas", "anpassats", "anrås", "anrättas", "anrättats", "anrikas", "anropas", "ansades", "ansågs", "ansamlades", "ansamlas", "ansamlats", "ansas", "ansättas", "ansattes", "ansatts", "ansätts", "anses", "ansetts", "anskaffades", "anskaffas", "anskaffats", "anslagits", "anslagsfinansierats", "anslås", "anslogs", "anslöts", "anslutas", "anslutits", "ansluts", "ansökas", "ansökes", "ansöktes", "ansökts", "anspelas", "anställas", "anställdes", "anställes", "anställs", "anställts", "ansträngas", "ansträngdes", "ansträngs", "ansträngts", "ansvisas", "antagas", "antages", "antagits", "antändas", "antändes", "antänds", "antänts", "antas", "antastas", "antastats", "anteciperas", "antecknades", "antecknas", "antecknats", "anteras", "antogs", "antologiserats", "anträddes", "anträffas", "anträffats", "äntras", "antydas", "antyddes", "antydes", "antyds", "antytts", "anvämdas", "användas", "användes", "används", "använts", "anvisades", "anvisas", "anvisats", "apéritifdags", "apostroferades", "applåderades", "applåderas", "applåderats", "applicerades", "appliceras", "applicerats", "apprecieras", "aprilskämtas", "apterades", "apteras", "apterats", "ärades", "åräknas", "äras", "ärats", "arbetades", "arbetas", "arbetats", "argumenterades", "argumenteras", "arielvas", "aristokratpalats", "arkebuserades", "arkebuseras", "arkebuserats", "arkiverades", "arkiveras", "arkiverats", "armbågas", "armeras", "armerats", "ärnas", "arrangerades", "arrangeras", "arrangerats", "arrenderades", "arrenderas", "arrenderats", "arresterades", "arresteras", "arresterats", "årsundas", "artbestäms", "artbestämts", "artikulerades", "artikuleras", "ärvas", "arvoderades", "arvoderas", "ärvs", "ärvts", "åsågs", "åsamkades", "åsamkas", "åsamkats", "åsättas", "åsatts", "åsätts", "åsetts", "asfalteras", "asfalterats", "åsidosättas", "åsidosattes", "åsidosättes", "åsidosatts", "åsidosätts", "åsiktsnäts", "åskades", "åskådliggjorts", "åskådliggöras", "åskådliggörs", "åskådligörs", "äskas", "assimilerades", "assimileras", "assimilerats", "assisterades", "assisteras", "associationeras", "associerades", "associeras", "åstadkommas", "åstadkommes", "åstadkommits", "åstadkoms", "åstakommas", "åstakoms", "asturias", "åsyftades", "åsyftas", "åtalades", "åtalas", "åtalats", "åtaldes", "ätas", "åteförenas", "ateljéplats", "återanpassas", "återanställdes", "återanställs", "återanställts", "återantändas", "återanvändas", "återanvändes", "återanvänds", "återbefolkades", "återbefolkas", "återberättades", "återberättas", "återbesättas", "återbesätts", "återbetalades", "återbetalas", "återbetalats", "återbildas", "återbildats", "återbördades", "återbördas", "återbördats", "återbrukas", "återerövras", "återerövrats", "återexploateras", "återfångas", "återfanns", "återfås", "återfinnas", "återfinnes", "återfinns", "återfödas", "återföddes", "återföds", "återföras", "återfördes", "återförenades", "återförenas", "återförenats", "återförs", "återförts", "återförvildas", "återförvisades", "återförvisas", "återfunnits", "återgavs", "återges", "återgetts", "återgives", "återgivits", "återhämtades", "återhämtats", "återiföras", "återimporteras", "återinföras", "återinfördes", "återinförs", "återinförts", "återinrättades", "återinrättas", "återinsättas", "återinsattes", "återinstallerades", "återintegreras", "återinvesterades", "återinvesteras", "återinvigas", "återinvigdes", "återinvigs", "återkallades", "återkallas", "återkallats", "återkastades", "återkastas", "återkatoliceras", "återknutits", "återknytas", "återköpas", "återkopplas", "återköptes", "återkrävas", "återladdas", "återlämnades", "återlämnas", "återlämnats", "återlevererats", "återlöses", "återmatas", "åternationaliseras", "åternoterades", "återönskas", "återöppnas", "återöppnats", "återplanteras", "återreglerades", "återregleras", "återremitterades", "återremitteras", "återremitterats", "återropades", "återsågs", "återsamlades", "återsamlas", "återsändas", "återsändes", "återsänds", "återses", "återskapades", "återskapas", "återskapats", "återskolas", "återspeglades", "återspeglas", "återspeglats", "återställas", "återställdes", "återställes", "återställs", "återställts", "återstartas", "återtagas", "återtas", "återtogs", "återuppbyggas", "återuppbyggdes", "återuppbyggts", "återuppföras", "återuppfördes", "återuppförts", "återupplevs", "återupplivades", "återupplivas", "återupplivats", "återuppnås", "återupprättades", "återupprättas", "återupprättats", "återupprepades", "återupprepas", "återuppsattes", "återupptäckas", "återupptäcktes", "återupptäckts", "återupptagits", "återupptas", "återupptogs", "återuppväckas", "återuppväcks", "återuppväcktes", "återuppväckts", "återutges", "återutgetts", "återutgivits", "återutnämnas", "återutnämnts", "återväcktes", "återvaldes", "återväljs", "återvändas", "återvanns", "återvinnas", "återvinns", "återvisades", "återvisas", "återvunnits", "ätes", "åtföljas", "åtföljdes", "åtföljs", "åtföljts", "åtgärdades", "åtgärdas", "åtgärdats", "åthutas", "ätits", "åtlydas", "åtlyddes", "åtlyds", "åtnjuts", "åtrås", "åts", "äts", "åtsadkommas", "åtskildes", "åtskiljas", "åtskiljs", "attackerades", "attackeras", "attackerats", "attackutrustas", "attesterades", "attesterats", "attraherades", "attraheras", "attraherats", "auktionerades", "auktioneras", "auktoriserades", "auktoriseras", "automatiserades", "automatiseras", "automatiserats", "avanmälas", "avanmäls", "avåts", "avbalkats", "avbeställdes", "avbeställts", "avbetades", "avbetalas", "avbildades", "avbildas", "avbildats", "avblåsas", "avblåses", "avblåstes", "avblåsts", "avblockerades", "avböjas", "avböjdes", "avbokas", "avbördas", "avbröts", "avbrutits", "avbrytas", "avbryts", "avdelas", "avdelats", "avdemokratiserades", "avdömas", "avdömdes", "avdramatiseras", "avdramatiserats", "äventyras", "äventyrats", "averages", "averotiseras", "avfärdades", "avfärdas", "avfärdats", "avfattades", "avfattas", "avfestas", "avfiras", "avfolkades", "avfolkas", "avfolkats", "avföras", "avfördes", "avföres", "avförs", "avförts", "avfotograferades", "avfyrades", "avfyras", "avfyrats", "avges", "avgiftades", "avgiftas", "avgiftsbelades", "avgiftsbeskattas", "avgivits", "avgjordes", "avgjorts", "avgöras", "avgöres", "avgörs", "avgränsades", "avgränsas", "avhållas", "avhålles", "avhållits", "avhålls", "avhånades", "avhånas", "avhändes", "avhandlades", "avhandlas", "avhandlats", "avhänds", "avhästades", "avhjälpas", "avhjälps", "avhjälptes", "avhjälpts", "avhölls", "avhöras", "avhördes", "avhörts", "avhysas", "avhyses", "avidentifieras", "avideologiseras", "avindividualiserats", "avisades", "avisas", "aviserades", "aviseras", "aviserats", "avjapaniseras", "avjoniserats", "avklädas", "avkläddes", "avklarades", "avklaras", "avklassificerades", "avknoppades", "avknoppas", "avknoppats", "avkodas", "avkrävas", "avkrävdes", "avkrävs", "avkrävts", "avkriminaliseras", "avkunnades", "avkunnas", "avkunnats", "avkyls", "avlades", "avläggas", "avlägges", "avlägsnades", "avlägsnas", "avlägsnats", "avlämnades", "avlämnas", "avlämnats", "avlas", "avläs", "avläsas", "avläses", "avlastades", "avlastas", "avlästes", "avlats", "avledas", "avleds", "avlevereras", "avlivades", "avlivas", "avlivats", "avlockas", "avlockats", "avlöjas", "avlönades", "avlönas", "avlönats", "avlösas", "avlöses", "avlossades", "avlossas", "avlossats", "avlöstes", "avlösts", "avlövas", "avlutas", "avlyssnades", "avlyssnas", "avlystes", "avmagnetiseras", "avmattas", "avmobiliserades", "avmumiefieras", "avmystifieras", "avnavlades", "avnjöts", "avnjutas", "avnjutes", "avnjuts", "avnoterades", "avnoteras", "avpassas", "avpatrulleras", "avpolitiseras", "avpolleterades", "avpolleteras", "avpolletterades", "avpolletteras", "avporträtterades", "avporträtteras", "avprogrammeras", "avprogrammerats", "avprutades", "avrådas", "avråddes", "avråds", "avräknas", "avrapporteras", "avrapporterats", "avrättades", "avrättas", "avrättats", "avråtts", "avregistrerades", "avregistreras", "avregistrerats", "avreglerades", "avregleras", "avreglerats", "avritas", "avrundades", "avrundas", "avrustades", "avrustas", "avs", "avsågs", "avsändas", "avsändes", "avsänds", "avsänts", "avsättas", "avsattes", "avsatts", "avsätts", "avses", "avsetts", "avskaffades", "avskaffas", "avskaffats", "avskäras", "avskärmas", "avskedades", "avskedas", "avskedats", "avskedshyllades", "avskildes", "avskiljas", "avskiljes", "avskiljs", "avskilts", "avskjutas", "avskjutits", "avskräckas", "avskräcks", "avskräcktes", "avskräckts", "avskrevs", "avskrivas", "avskrivits", "avskrivs", "avskurits", "avskys", "avslagits", "avslås", "avslogs", "avslöjades", "avslöjas", "avslöjats", "avslöjtas", "avslutades", "avslutas", "avslutats", "avsmakades", "avsökas", "avsöndras", "avspänningsglödgas", "avspärrades", "avspärrats", "avspeglades", "avspeglas", "avspeglats", "avspelas", "avspisades", "avspisas", "avstängas", "avstängdes", "avstängs", "avstängts", "avstyras", "avstyrks", "avstyrktes", "avstyrkts", "avsynas", "avsyras", "avtackades", "avtackas", "avtäckas", "avtackats", "avtäcks", "avtäcktes", "avtäckts", "avtagas", "avtalades", "avtalas", "avtalats", "avtecknas", "avtjänas", "avtjänats", "avträdas", "avträddes", "avtrappas", "avtrubbas", "avtrubbats", "avtvås", "avtvingades", "avtvingas", "avundades", "avundats", "avvägas", "avvaktas", "avväpnades", "avväpnas", "avväpnats", "avvaras", "avvärjas", "avvärjdes", "avvärjs", "avvärjts", "avvattnas", "avvecklades", "avvecklas", "avvecklats", "avverkades", "avverkas", "avverkats", "avvinnas", "avvisades", "avvisas", "avvisats", "avyttrades", "avyttras", "avyttrats", "axlades", "axlas", "axlats", "babblades", "babettes", "backades", "backas", "backats", "badades", "badas", "bäddades", "baddas", "bäddas", "bäddats", "bads", "bagatelliserades", "bagatelliseras", "bagatelliserats", "bagoas", "bakades", "bakas", "bakats", "bakbands", "bakbinds", "baksits", "baktalas", "baktalats", "balanserades", "balanseras", "balanserats", "balas", "balsamerades", "balsameras", "banaliseras", "bananas", "banats", "bandades", "bandas", "bandats", "banderas", "bändes", "bands", "bänds", "bänkades", "bankas", "bankats", "bannas", "bannlysas", "bannlyses", "bannlystes", "bantades", "bantas", "bantats", "barabbas", "bäras", "bäres", "bärgades", "bärgas", "bärgats", "barings", "barnablods", "barnes", "barrantes", "bars", "bärs", "barthes", "baserades", "baseras", "baserats", "basunerades", "basuneras", "basunerats", "bättrades", "bättras", "bättrats", "baxades", "baxas", "baxats", "beaktades", "beaktas", "beaktats", "bearbetades", "bearbetas", "bearbetats", "beättas", "bebådas", "beblandas", "beboddes", "bebos", "bebotts", "bebyggas", "bebyggdes", "bebyggs", "bedårades", "bedåras", "bedjas", "bedömas", "bedömdes", "bedömms", "bedöms", "bedömts", "bedövades", "bedövas", "bedragas", "bedras", "bedrevs", "bedrivas", "bedrives", "bedrivits", "bedrivs", "beds", "bedyras", "bedyrats", "beers", "befalldes", "befallts", "befanns", "befarades", "befaras", "befarats", "befästas", "befästes", "befästs", "befinnas", "befinnes", "befinns", "befläckats", "befodrats", "befolkades", "befolkas", "befolkats", "befordrades", "befordras", "befordrats", "befrämjades", "befrämjas", "befriades", "befrias", "befriats", "befruktades", "befruktas", "befruktats", "befunnits", "begagnas", "begapas", "begäras", "begärdes", "begärs", "begärts", "begås", "begåtts", "begåvades", "begåvas", "begåvats", "begicks", "begöts", "begränas", "begränsades", "begränsas", "begränsats", "begravas", "begravdes", "begravs", "begravts", "begreps", "begripas", "begrips", "begrovs", "begrundades", "begrundas", "behäftas", "behagas", "behållas", "behållits", "behålls", "behandlades", "behandlas", "behandlats", "behängts", "behärskades", "behärskas", "behölls", "behövas", "behövdes", "behöves", "behövs", "behovsprövas", "behövts", "beivras", "beivrats", "bejakas", "bejakats", "bejublades", "bejublas", "bejublats", "bekämpades", "bekämpas", "bekämpats", "bekändes", "bekännas", "bekänns", "bekantas", "bekantgjorts", "békas", "bekikas", "bekläddes", "beklagades", "beklagas", "beklagats", "beklas", "beklätts", "bekommas", "bekostades", "bekostas", "bekostats", "beköts", "bekräftades", "bekräftas", "bekräftats", "bekymras", "belades", "beläggas", "beläggs", "belägrades", "belägras", "belägrats", "belagts", "belamrades", "belamras", "belastades", "belastas", "belastats", "beledsagades", "beledsagas", "beles", "belönades", "belönas", "belönats", "belys", "belysas", "belyses", "belystes", "belysts", "bemålats", "bemannades", "bemannas", "bemannats", "bemästras", "bemästrats", "bemötas", "bemöts", "bemöttes", "bemötts", "bemyndigades", "bemyndigas", "benådades", "benådas", "benådats", "benaissas", "benämnas", "benämndes", "benämnes", "benämns", "benämnts", "benas", "benedikts", "bennetts", "benskadats", "beöms", "beordrades", "beordras", "beordrats", "bepudrades", "beräknades", "beräknas", "beräknats", "berättades", "berättas", "berättats", "berättigades", "berättigas", "berättigats", "beredas", "bereddes", "beredes", "bereds", "beretts", "berikades", "berikas", "berikats", "berishas", "bermudas", "berömdes", "berömmas", "beröms", "beröras", "berördes", "berörs", "berörts", "berövades", "berövas", "berövats", "berusades", "berusats", "bes", "besåddes", "besågs", "besannades", "besannas", "besannats", "besås", "besättas", "besattes", "besatts", "besätts", "besegarades", "besegerades", "beseglades", "beseglas", "besegrades", "besegras", "besegrats", "beses", "besiktas", "besiktigas", "besiktigats", "besittes", "besitts", "besjälas", "besjöngs", "besjungas", "besjungits", "besjungs", "beskådades", "beskådas", "beskälls", "beskäras", "beskars", "beskärs", "beskattades", "beskattas", "beskattats", "beskedas", "beskevs", "beskjutas", "beskjutits", "beskjuts", "beskogats", "besköts", "beskrevs", "beskrivas", "beskrives", "beskrivits", "beskrivs", "beskurits", "beskyddades", "beskyddas", "beskyllas", "beskylldes", "beskylls", "beskyllts", "beslagits", "beslagtagits", "beslagtas", "beslagtogs", "beslås", "beslogs", "beslöjades", "beslöjas", "beslöts", "beslutades", "beslutas", "beslutats", "besmittats", "besökas", "besöks", "besöktes", "besökts", "besparades", "besparas", "besparats", "bespisas", "bespottas", "bespottats", "besprutades", "besprutas", "besprutats", "beställas", "beställdes", "beställes", "beställs", "beställts", "bestals", "bestämdes", "bestämmas", "bestämmes", "bestäms", "bestämts", "bestänktes", "bestås", "bestigas", "bestigits", "bestjäls", "bestods", "bestormas", "bestraffades", "bestraffas", "bestraffats", "bestrålas", "bestrålats", "bestreds", "bestridas", "bestriddes", "bestrids", "beströddes", "bestulits", "bestyckas", "bestyckats", "bestyras", "bestyrkas", "bestyrkes", "bestyrks", "besudlas", "besudlats", "besvarades", "besvärades", "besvaras", "besväras", "besvarats", "besvärats", "besvärjas", "betäckas", "betäcktes", "betäckts", "betades", "betalades", "betalas", "betalats", "betalts", "betänkas", "betas", "betats", "betcknas", "betecknades", "betecknas", "betecknats", "betingades", "betingas", "betitlades", "betjänas", "betonades", "betonas", "betonats", "beträdas", "beträddes", "betrakats", "betraktades", "betraktas", "betraktats", "betroddes", "betrotts", "bets", "betsas", "betslas", "betts", "betvingas", "betvingats", "betvivlas", "betvivlats", "betygas", "betygsättas", "betygsattes", "betygsatts", "betygsätts", "betygssättas", "beundrades", "beundras", "beundrats", "bevakades", "bevakas", "bevakats", "beväpnades", "beväpnats", "bevarades", "bevaras", "bevarats", "bevärdigades", "bevärdigats", "bevattnades", "bevattnas", "bevekas", "beviljades", "beviljas", "beviljats", "bevisades", "bevisas", "bevisats", "bevistas", "bevittnades", "bevittnas", "bevittnats", "bhopas", "bibehållas", "bibehålles", "bibehållits", "bibehålls", "bibehölls", "bibliograferas", "bibringades", "bibringas", "bibringats", "bidrags", "biesmes", "bifallas", "bifalles", "bifallits", "bifalls", "bifogades", "bifogas", "bifogats", "bifölls", "bilades", "biläggas", "biläggs", "bilagts", "bildades", "bildas", "bildats", "bildsättas", "bildsätts", "bilfraktas", "billhälls", "bilskjuts", "bindas", "bindes", "binds", "bisättas", "bisattes", "biscuits", "bitas", "bitits", "biträdas", "biträddes", "biträdes", "biträds", "bits", "bjöds", "bjudas", "bjudes", "bjudits", "bjuds", "bläddrades", "bläddras", "blades", "blåfärgats", "blåmärkas", "blandades", "bländades", "blandas", "bländas", "blandats", "bländats", "blandfärs", "blankslipades", "blankslitits", "blås", "blåsas", "blåses", "blåstes", "blästrades", "blästras", "blästrats", "blåsts", "blekas", "blekläggas", "bleks", "blekts", "blidkades", "blidkas", "blindmes", "blindtarmsopererats", "blindtestas", "blinkas", "blixtinkallades", "blixtinkallas", "blixtinkallats", "blixtutredas", "blockerades", "blockeras", "blockerats", "blodfylls", "blodfyllts", "blomsterhyllas", "blossas", "blötas", "blötläggas", "blötläggs", "blöts", "blottades", "blottas", "blottats", "blöttes", "blottlades", "blottläggas", "blottläggs", "blottlagts", "blötts", "blottställas", "bluddrats", "bluffas", "blygas", "blygdes", "blygs", "blylastas", "bockas", "bogserades", "bogseras", "bogserats", "böjas", "böjdes", "bojkottades", "bojkottas", "böjs", "böjts", "bokades", "bokas", "bokats", "bokföras", "bokfördes", "bokförs", "bokförts", "bolagiserades", "bolagiseras", "bolagiserats", "bolas", "bolivares", "bollades", "bollas", "bollats", "bombades", "bombarderades", "bombarderas", "bombarderats", "bombas", "bombats", "bombhotades", "bombhotas", "bombhotats", "bommades", "bommats", "bonades", "bonas", "bönhördes", "bordades", "bordlades", "bordläggas", "bordläggs", "bordlagts", "börgades", "börjades", "börjas", "borrades", "borras", "borrats", "börsintroducerades", "börsintroduceras", "börsnoterades", "börsnoteras", "börsnoterats", "börsstoppades", "borstas", "bortauktioneras", "bortdribblas", "bortfördes", "bortförklaras", "bortförklarats", "bortförlovades", "bortförts", "bortopereras", "borträknats", "bortrationaliserades", "bortrationaliseras", "bortses", "borttages", "bortträngts", "bortväljes", "botades", "botas", "botats", "bötfällas", "bötfälldes", "bötfälls", "bötfällts", "bothas", "bötläggas", "böts", "bottenskrapades", "bottenskrapats", "bottnas", "bräckas", "brackets", "bräcks", "bräcktes", "brädas", "bräddas", "bråddes", "brädfodras", "bragtes", "bragts", "bråkades", "bråkas", "bråkats", "brandmärkts", "brandskattas", "brännmärkas", "brännmärks", "brännmärktes", "branns", "brännskadades", "bräserats", "brassades", "breakas", "bredas", "breddades", "breddas", "breddats", "breddes", "brehmers", "bres", "bretts", "bricoles", "bringas", "bringats", "broddas", "broderades", "broderas", "broderats", "brölas", "bromsades", "bromsas", "bromsats", "bröts", "brudås", "brugueras", "brukades", "brukas", "brukats", "brunsminkades", "brutaliseras", "brutaliserats", "brutits", "bryggas", "brynas", "bryns", "bryssellörs", "brytas", "brytes", "bryts", "buades", "buas", "buats", "budades", "budgeterades", "budgeteras", "budgeterats", "buffas", "bugas", "buggas", "bullerbegränsas", "bullerisoleras", "bultas", "bundes", "bundits", "buntas", "buntats", "buras", "burits", "burrades", "busats", "bussades", "bussas", "bussats", "buteljeras", "buteljerats", "bygdes", "byggas", "byggdes", "bygges", "byggnadsminnesförklarades", "byggnadsminnesförklaras", "byggnadsminnesmärks", "byggs", "byggstartas", "byggts", "bykas", "bytas", "bytits", "byts", "byttes", "bytts", "caceres", "cajs", "cambrils", "camoufleras", "capras", "carlshamns", "catenas", "celebrerades", "celebreras", "cementas", "cementerades", "cementeras", "cementerats", "censurerades", "censureras", "censurerats", "centimes", "centraldirigeras", "centraliserades", "centraliseras", "centraliserats", "centralregleras", "centralstyrs", "centras", "centrats", "centrifugerats", "centrsimes", "ceres", "certifierats", "charmades", "charmas", "charmats", "chartras", "chartrats", "checkas", "chiapas", "chikanerats", "chines", "chivas", "chockades", "chockas", "chockats", "chockerades", "chockeras", "chockhöjs", "chockskadades", "chockskadas", "christmas", "cirkuleras", "citerades", "citeras", "citerats", "civiliseras", "coachas", "components", "comviqs", "contras", "cripps", "crosscheckades", "cruises", "cuplottades", "cyberfrogs", "cyklas", "däckades", "däckas", "däckats", "dagits", "daglidags", "dalaras", "dalas", "daltades", "daltas", "dämdes", "dammades", "dammas", "dämmas", "dammats", "dammsögs", "dammsugits", "dammsugs", "dammtorkas", "dämpades", "dämpas", "dämpats", "däms", "dämts", "danades", "danas", "danats", "danidas", "daniells", "dansades", "dansas", "dansats", "darras", "das", "databaseras", "databehandlas", "daterades", "dateras", "daterats", "datoriseras", "dealas", "debatterades", "debatteras", "debatterats", "debiteras", "debiterats", "decentraliserades", "decentraliseras", "dechiffreras", "decimaliseras", "decimerades", "decimeras", "decimerats", "dedicerades", "defineras", "definierades", "definieras", "definierats", "deformeras", "deformerats", "degas", "degenererats", "degraderades", "degraderas", "degraderats", "degradras", "deklamerades", "deklameras", "deklarerades", "deklareras", "deklarerats", "dekonstruerades", "dekonstrueras", "dekonstruerats", "dekorerades", "dekoreras", "dekorerats", "dekrypteras", "delades", "delas", "delats", "delegerades", "delegeras", "delegerats", "delexpedieras", "delfinansierades", "delfinansieras", "delgavs", "delges", "delgetts", "delgivits", "deltas", "delvalveras", "demaskerades", "demaskeras", "dematerialiseras", "dementerades", "dementeras", "dementerats", "demilitariserats", "demobiliserades", "demobiliseras", "demokratiserades", "demokratiseras", "demokratiserats", "demolerades", "demoleras", "demolerats", "demoniseras", "demonstrerades", "demonstreras", "demonstrerats", "demonterades", "demonteras", "demystifieras", "deponeras", "deponerats", "deporterades", "deporteras", "deporterats", "deppas", "desarmerades", "desarmerats", "deserves", "designas", "designats", "desillusioneras", "desinficeras", "desinficerats", "desorienteras", "destabiliserades", "destilleras", "destillerats", "destineras", "destrueras", "detaljgranskas", "detaljregleras", "detaljstuderas", "detaljstyrs", "detekteras", "detroniserades", "detroniseras", "detroniserats", "dettalas", "devalverades", "devalveras", "devalverats", "diagnosticerades", "diagnosticeras", "diagnosticerats", "diagnostiserades", "diagnostiseras", "diagnostiserats", "diagosticeras", "diarieföras", "diarieförs", "diarieförts", "dias", "differentieras", "differentierats", "diggats", "digitaliseras", "digitaliserats", "dikats", "diktats", "dikterades", "dikteras", "dikterats", "dikvalificerats", "dimensionerades", "dimensioneras", "dimensionerats", "diminueras", "dineras", "diplomerades", "directes", "direktavskrivas", "direktavvisas", "direktkonfronterades", "direktnoterades", "direktsändas", "direktsändes", "direktsänds", "direktsänts", "direktteleviserades", "direktväljas", "dirigerades", "dirigeras", "dirigerats", "disciplineras", "diskades", "diskas", "diskats", "diskonterades", "diskonteras", "diskonterats", "diskrediterades", "diskrediterats", "diskriminerades", "diskrimineras", "diskriminerats", "diskuterades", "diskuteras", "diskuterats", "diskvalificerades", "diskvalificeras", "diskvalificerats", "disponerades", "disponeras", "disponerats", "disputerades", "dissekerades", "dissekeras", "dissekerats", "dissikerades", "distanserades", "distanseras", "distraheras", "distribuerades", "distribueras", "distribuerats", "distribureras", "dites", "dittransporterats", "diversifieras", "divideras", "dividerats", "djäklas", "djärvas", "djärvdes", "djärves", "djävlades", "djävlas", "djilas", "djupdykas", "djupfrysas", "djupfryses", "djupintervjuas", "djupintervjuats", "dödades", "dödas", "dödats", "dödförklarades", "dödförklaras", "dödförklarats", "dödskallemärkas", "dogs", "dokes", "dokumenterades", "dokumenteras", "dokumenterats", "doldes", "döljas", "döljs", "döljts", "dollarras", "dolts", "domarbedömas", "dömas", "domderas", "dömdes", "dömes", "domesticeras", "domesticerats", "dominerades", "domineras", "dominerats", "dompteras", "döms", "dömts", "donerades", "doneras", "donerats", "döpas", "dopingtestades", "dopingtestas", "doppades", "doppas", "doppats", "döps", "döptes", "döpts", "doserades", "doseras", "douradores", "dövades", "dövas", "dövats", "dövtolkas", "drabbades", "drabbas", "drabbats", "drabbbades", "dracks", "draftades", "draftas", "dragas", "dragits", "dramatiseras", "dramatiserats", "drämdes", "dränerades", "dräneras", "dränerats", "dränkas", "dränkes", "dränks", "dränktes", "dränkts", "dräpas", "draperades", "draperas", "draperats", "dräps", "dräptes", "dras", "dreams", "drejades", "drejats", "dressas", "dresseras", "dresserats", "dressyrbas", "drevades", "drevs", "dribblades", "dribblas", "dribblats", "drickas", "drickes", "drillades", "drillas", "drillats", "drivas", "drives", "drivgas", "drivits", "drivs", "drogades", "drogas", "drogats", "drogs", "drogtestats", "drömdes", "drömmas", "droppades", "druckits", "drukpas", "dryftades", "dryftas", "dryftats", "drygades", "dubbas", "dubbats", "dubbelexponeras", "dubbelriktas", "dubblades", "dubblas", "dubblats", "dubblerades", "dubbleras", "dubblerats", "dukades", "dukas", "dukats", "dumpades", "dumpas", "dumpats", "dunas", "dundrades", "dundras", "dunkades", "dunkas", "duperades", "duperas", "duperats", "duplicerades", "durres", "duschades", "duschas", "dvaldes", "dväljs", "dvalts", "dyrkades", "dyrkas", "ebbas", "effektiverades", "effektiveras", "effektiviserades", "effektiviseras", "effektiviserats", "effektueras", "effektureras", "efteranmäldes", "efterbildas", "efterföljas", "efterföljdes", "efterföljs", "efterfrågades", "efterfrågas", "efterfrågats", "efterhördes", "efterkomposteras", "efterlämnades", "efterlämnas", "efterlevas", "efterlevdes", "efterlevs", "efterliknats", "efterlysas", "efterlyses", "efterlystes", "efterlysts", "eftersänds", "eftersänts", "eftersättas", "eftersattes", "eftersatts", "eftersätts", "efterskänkas", "eftersökas", "eftersöks", "eftersöktes", "efterspanas", "eftersträvades", "eftersträvas", "eftersynkroniseras", "eftertaxerades", "efterträdas", "efterträddes", "efterträdes", "efterträds", "efterträtts", "eggades", "eggas", "eggers", "ekas", "ekiperats", "eklärerades", "eklaterades", "eklateras", "eklaterats", "eldades", "eldas", "eldats", "eldhärjades", "eldhärjas", "eldhärjats", "elektras", "elektrifierades", "elektrifieras", "eliminerades", "elimineras", "eliminerats", "elitiseras", "ellerströms", "emballerades", "emitterades", "emitteras", "emotsågs", "emotses", "emottagas", "emottas", "emtungas", "enades", "enas", "enats", "engagerades", "engageras", "engagerats", "engagererats", "engells", "enhetliggöras", "enkelriktades", "enkelriktas", "enkelriktats", "enleverades", "enleveras", "enrollerades", "enrolleras", "enrollerats", "enskommits", "entledigades", "entledigas", "entledigats", "entusiasmeras", "envisades", "envisats", "erades", "erbjöds", "erbjudas", "erbjudes", "erbjudits", "erbjuds", "erfaras", "erfodras", "erfordrades", "erfordras", "erfors", "erhållas", "erhålles", "erhållits", "erhålls", "erhölls", "erinrades", "erinras", "erkändes", "erkännas", "erkännes", "erkännnas", "erkänns", "erkänts", "erlades", "erläggas", "erlägges", "erläggs", "erlagts", "eroderas", "erotiseras", "erövrades", "erövras", "erövrats", "ersättas", "ersattes", "ersättes", "ersatts", "ersätts", "ertappades", "ertappas", "ertappats", "esbjörs", "eskaleras", "eskorterades", "eskorteras", "eskorterats", "esseltes", "estetiseras", "etablerades", "etableras", "etablerats", "etappindelas", "etiketterades", "etiketteras", "etnifieras", "etnifierats", "etsades", "etsas", "eudokias", "europeiseras", "europes", "evakuerades", "evakueras", "evakuerats", "evalueras", "everglades", "evkuerats", "examinerades", "examineras", "examinerats", "exekverades", "exekveras", "exemplifieras", "exkluderas", "exkluderats", "exkommuniceras", "expanderas", "expedierades", "expedieras", "experimenterades", "experimenteras", "experimenterats", "explicitgjorts", "exploaterades", "exploateras", "exploaterats", "exponerades", "exponeras", "exponerats", "exporterades", "exporteras", "exporterats", "expropieras", "exproprierades", "exproprieras", "extrainkallas", "extraskjuts", "fackbas", "fägnats", "fajtades", "fajtas", "fajtats", "fäktades", "fäktas", "fakturerades", "faktureras", "fakturerats", "fållas", "fällas", "fälldes", "falles", "falls", "fälls", "fällts", "falsifieras", "fältprovas", "famnas", "fångades", "fångas", "fångats", "fängslades", "fängslas", "fängslats", "fanzines", "fårades", "färas", "fårats", "färdigbehandlas", "färdigförhandlades", "färdigrepareras", "färdigspelades", "färdigspelas", "färdigspelats", "färdigställas", "färdigställdes", "färdigställs", "färdigställts", "färdigutrustas", "fares", "färgades", "färgas", "färgats", "färgläggas", "färgläggs", "färgsättas", "färgsattes", "färgsätts", "färjades", "färjas", "farpas", "fås", "fasadputsas", "fasas", "fascinerades", "fascineras", "fascinerats", "fassetts", "fästas", "fästes", "fastlades", "fastläggas", "fastlagts", "fastnades", "fästs", "fastslagits", "fastslås", "fastslogs", "fastställas", "fastställdes", "fastställs", "fastställts", "fattades", "fattats", "fattiggjorts", "fåtts", "favoriserades", "favoriseras", "favoriserats", "favoritspelas", "faxades", "faxats", "fejas", "felbalanserades", "felbedöms", "felbetonades", "felciteras", "felkopplas", "felsökas", "feltolkades", "feltolkas", "feltolkats", "femdubblades", "femdubblas", "femdubblats", "femfaldigades", "femfaldigats", "feminiseras", "femmes", "fermentas", "fernissas", "fes", "festades", "festas", "festes", "festplats", "fickparkeras", "fifflas", "fightades", "fightas", "fightats", "figueras", "figureras", "fikas", "fiktionaliserats", "filas", "filmades", "filmas", "filmatiserades", "filmatiseras", "filmatiserats", "filmats", "filmtricks", "filotas", "filtreras", "filtrerats", "fimpas", "fimpats", "finalbesegrades", "finalbrottas", "finaniseras", "finanseras", "finanserats", "finanserias", "finansierades", "finansieras", "finansierats", "finansierieras", "finfördelats", "fingeras", "fingranskas", "fininställas", "fininställs", "finjusteras", "finkammades", "finkammas", "finkammats", "finkrattats", "finnes", "finnns", "finputsas", "finputsats", "finslipas", "finslipats", "fintades", "fintas", "firades", "firas", "firats", "fiskades", "fiskas", "fiskats", "fixades", "fixas", "fixats", "fixerades", "fixeras", "fixerats", "fjärmas", "fjärrstyras", "fjärrstyrs", "fjärtas", "fjäskas", "fjättrades", "fjättrats", "fläckades", "fläckas", "fläckats", "flåddes", "flaggades", "flaggas", "flaggats", "fläkas", "flakes", "flamberats", "flankerades", "flankeras", "flätades", "flätas", "flätats", "flerdubblades", "flerdubblas", "flerdubblats", "flerfaldigas", "flerfaldigats", "flintstones", "flirtas", "flögs", "flörtas", "flottades", "flugits", "flyers", "flygas", "flygbesprutas", "flygbombades", "flygbombas", "flygbombats", "flygfotograferades", "flygpats", "flygs", "flyttades", "flyttas", "flyttats", "fnissas", "fnissats", "fnös", "fnystes", "födas", "födddes", "föddes", "föds", "fogades", "fogas", "fogats", "fögelkes", "föjdes", "fokuserades", "fokuseras", "fokuserats", "föläggs", "följas", "följdes", "följs", "följts", "folkas", "fonderades", "fonderas", "fonderats", "fönsterspröjs", "förädlades", "förädlas", "förädlats", "föraktades", "föraktas", "föraktats", "föräldrarsomdeklasserats", "förändats", "förändrades", "förändrarts", "forandras", "förändras", "forändrats", "förändrats", "förångades", "förångas", "förångats", "förankrades", "förankras", "förankrats", "föranledas", "föranleddes", "föranleds", "föranletts", "föranmälts", "förannonserats", "föranstaltades", "förärades", "föräras", "förärats", "förargas", "förargats", "föras", "förbands", "förbannades", "förbannas", "förbannats", "förbättrades", "förbättras", "förbättrats", "förbegicks", "förbehållas", "förbehållits", "förbehålls", "förbehandlas", "förbehölls", "förberdas", "förberedas", "förbereddes", "förberedes", "förbereds", "förberetts", "förbeställas", "förbeställts", "förbigås", "förbigåtts", "förbigicks", "förbindas", "förbinds", "förbisågs", "förbises", "förbisetts", "förbittrades", "förbjöds", "förbjudas", "förbjudes", "förbjudits", "förbjuds", "förblandades", "förblandas", "förblindades", "förblindas", "förblindats", "förbluffades", "förbluffas", "förborgerligades", "förborgerligas", "förborgerligats", "förbrändes", "förbrännas", "förbränns", "förbränts", "förbrödrades", "förbrödras", "förbrukades", "förbrukas", "förbrukats", "förbryllades", "förbryllas", "förbryllats", "förbuskats", "förbyggts", "förbytas", "förbyts", "förbyttes", "förbytts", "forcerades", "forceras", "forcerats", "fördärvades", "fördärvas", "fördärvats", "fördelades", "fördelas", "fördelats", "fördeltas", "fördes", "fördjupades", "fördjupas", "fördjupats", "fördömas", "fördömdes", "fördöms", "fördömts", "fordrades", "fördragas", "fördrages", "fordras", "fördras", "fordrats", "fördrevs", "fördrivas", "fördrivits", "fördrivs", "fördröjas", "fördröjdes", "fördröjes", "fördröjs", "fördröjts", "fördubblades", "fördubblas", "fördubblats", "fördummas", "fördunklades", "fördunklas", "fördunklats", "fördyrades", "fördyras", "fördyrats", "fördystrades", "förebådades", "förebådas", "förebådats", "föreberedas", "förebragts", "förebrås", "förebyggas", "förebyggs", "föredömdes", "föredrages", "föredras", "föredrogs", "föregås", "föregåtts", "föregicks", "föregreps", "föregripits", "föregrips", "föreknippas", "förekommas", "förekommits", "förelades", "föreläggas", "föreläggs", "förelagts", "förelås", "förelästes", "förenades", "förenas", "förenats", "förenhetligas", "förenklades", "förenklas", "förenklats", "föres", "föreskrevs", "föreskrivas", "föreskrivs", "föreslagits", "föreslås", "föreslogs", "förespås", "förespeglades", "förespeglas", "förespeglats", "förespråkades", "förespråkas", "förespråkats", "föreställas", "föreställdes", "föreställs", "förestås", "förestods", "forests", "företagas", "företagits", "företas", "företeddes", "företogs", "företrädas", "företräddes", "företräds", "förevigades", "förevigas", "förevigats", "förevisades", "förevisas", "förevisats", "förfäktas", "förfalskades", "förfalskas", "förfalskats", "förfärades", "förfäras", "förfärats", "förfärdigades", "förfärdigats", "förfares", "förfasades", "förfasas", "författades", "författas", "författats", "förfelades", "förfelas", "förfinades", "förfinas", "förfinats", "förfinskas", "förflackas", "förflackats", "förflyktats", "förflyktigades", "förflyktigas", "förflyktigats", "förflyttades", "förflyttas", "förflyttats", "förföljas", "förföljdes", "förföljs", "förföljts", "förföras", "förfördelas", "förfördes", "förförs", "förförts", "förfranskas", "förfrös", "förfulas", "förfulats", "förfuskades", "förfuskas", "förfuskats", "förgasades", "förgasas", "förgasats", "förgiftades", "förgiftas", "förgiftats", "förglömmas", "förgöras", "förgrovades", "förgrovas", "förgrovats", "förgrymmas", "förgubbas", "förgudas", "förgylldes", "förgylls", "förgyllts", "förhalades", "förhalas", "förhalats", "förhållas", "förhånades", "förhånas", "förhånats", "förhandlades", "förhandlas", "förhandlats", "förhandscensureras", "förhandsetiketteras", "förhandsgranskas", "förhandsnomineras", "förhandsvisades", "förhärdas", "förhärligades", "förhärligas", "förhäxas", "förhindrades", "förhindras", "förhindrats", "förhöjas", "förhöjs", "förhöras", "förhördes", "förhörs", "förhörts", "förintades", "förintas", "förintats", "förjagas", "förkalkas", "förkapslats", "förkastades", "förkastas", "förkastats", "förkläds", "förklarades", "förklarars", "förklaras", "förklarats", "förknippades", "förknippas", "förknippats", "förkortades", "förkortas", "förkortats", "förkroppsligas", "förkrossas", "förkunnades", "förkunnas", "förkunnats", "förkvävas", "förkvävs", "förlades", "förläggas", "förläggs", "förlagts", "förlamades", "förlamas", "förlamats", "förlänades", "förlänas", "förlänats", "förlängas", "förlängdes", "förlängs", "förlängts", "förlåtas", "förlåts", "förläts", "förledas", "förledes", "förleds", "förletts", "förlikades", "förlikas", "förlikats", "förliknas", "förliks", "förliktes", "förlikts", "förljuvades", "förlöjligades", "förlöjligas", "förlöjligats", "förlorades", "förloras", "förlorats", "förlösas", "förlöses", "förlöstes", "förlustanmälas", "förmåddes", "formades", "formaliserades", "formaliseras", "förmanades", "förmanas", "förmånsbeskattades", "förmånsbeskattas", "förmänskligades", "förmänskligas", "förmärkas", "förmärks", "förmärktes", "förmärkts", "formas", "förmås", "formats", "förmåtts", "förmedlades", "förmedlas", "förmedlats", "förmenades", "förmenas", "förmenats", "formerades", "formeras", "förmeras", "formerats", "förmerats", "formges", "formgetts", "formgivits", "förminskades", "förminskas", "förminskats", "förmodades", "förmodas", "förmögenhetsbeskattas", "förmörkades", "förmörkas", "förmörkats", "formsprutas", "formulerades", "formuleras", "formulerats", "förnams", "förnedrades", "förnedras", "förnedrats", "förnekades", "förnekas", "förnekats", "förnimmas", "förnims", "förnöjts", "förnyades", "förnyas", "förnyats", "förödas", "föröddes", "förödes", "förodlas", "förödmjukades", "förödmjukas", "förödmjukats", "föröds", "förökas", "förökats", "förolämpas", "förolämpats", "förolyckades", "förolyckas", "förolyckats", "förolycklades", "förorättats", "förordades", "förordas", "förordats", "förordnades", "förordnas", "förordnats", "förorenas", "förorenats", "förorsakades", "förorsakas", "förorsakats", "förövades", "förövas", "förövats", "förpackades", "förpackas", "förpackats", "förpassades", "förpassas", "förpassats", "förpasssades", "förpestades", "förpestas", "förpliktades", "förpliktas", "förpuppades", "förpuppas", "förråats", "förrådas", "förråddes", "förräntas", "förrättades", "förrättas", "förrättats", "förringades", "förringas", "förringats", "förrycks", "förrycktes", "fors", "förs", "försågs", "försakas", "försäkrades", "försäkras", "försäkrats", "försåldes", "försäljas", "försäljes", "församhälleligats", "församlades", "försämrades", "försämras", "försämrats", "försänkas", "försättas", "försattes", "försatts", "försätts", "förseglades", "förseglats", "forselles", "försenades", "försenas", "försenats", "förses", "försetts", "försinkas", "forskades", "forskas", "forskats", "förskingrades", "förskingras", "förskingrats", "förskjöts", "förskjutas", "förskjutits", "förskjuts", "förskonades", "förskonas", "förskönas", "förskonats", "förskönats", "försköts", "förskräckas", "förskräckes", "förskräcks", "förskrivas", "förskrivits", "förskrivs", "forslades", "förslagits", "förslappats", "forslas", "förslås", "forslats", "förslavas", "förslavats", "förslits", "förslöats", "förslogs", "förslösades", "förslösas", "förslösats", "förslummades", "förslummas", "förslutits", "försmåddes", "försnävas", "försnillas", "försökas", "försöktes", "försonades", "försonas", "försonats", "försörjas", "försörjdes", "försörjs", "försörjts", "förspillas", "förspilldes", "förspills", "förspordes", "försports", "försprödas", "förstärkas", "förstärks", "förstärktes", "förstärkts", "förstås", "förståss", "förstatligades", "förstatligas", "förstatligats", "förståtts", "förstenades", "förstenas", "förstods", "förstoppas", "förstorades", "förstoras", "förstöras", "förstorats", "förstördes", "förstörs", "förstörts", "förströddes", "förströs", "förstuckits", "förstummades", "förstummas", "förstummats", "försummades", "försummas", "försummats", "försumpats", "försuras", "försvagades", "försvagas", "försvagats", "försvarades", "försvårades", "försvaras", "försvåras", "försvarats", "försvårats", "försvenskas", "försvenskats", "försvunnes", "förtages", "förtalas", "förtalats", "förtäljas", "förtamats", "förtäras", "förtärdes", "förtärs", "förtärts", "förtas", "förtås", "förtätades", "förtätas", "förtätats", "fortbildas", "förtecknas", "förtecknats", "förtegs", "förtidsinlösas", "förtidspensionerades", "förtidspensioneras", "förtidspensionerats", "förtigas", "förtiges", "förtigits", "förtigs", "förtingligas", "förtjänas", "förtjänats", "förtjusas", "förtjustes", "förtöjas", "förtöjdes", "förtöjs", "förtorkats", "fortplantades", "fortplantas", "förtrampades", "förträngas", "förträngs", "förtrollades", "förtrollas", "förtröttades", "förtröttas", "förtröttats", "förtryckas", "förtrycks", "förtrycktes", "förtryckts", "förts", "fortsättas", "fortsattes", "förtullades", "förtullas", "förtunnades", "förtunnas", "förtydligades", "förtydligas", "förundrades", "förundradts", "förundras", "förundrats", "förunnades", "förunnas", "förunnats", "förustspås", "förutbestäms", "förutsades", "förutsägas", "förutsågs", "förutsägs", "förutsagts", "förutsättas", "förutsattes", "förutsättes", "förutsatts", "förutsätts", "förutses", "förutsetts", "förutskickades", "förutskickas", "förutspåddes", "förutspås", "förutspåtts", "förvägrades", "förvägras", "förvägrats", "förvälls", "förvaltades", "förvaltas", "förvaltats", "förvånades", "förvånas", "förvånats", "förvandlades", "förvandlas", "förvandlats", "förvänds", "förvanskades", "förvanskas", "förvanskats", "förväntades", "förväntas", "förväntats", "förvarades", "förvaras", "förvarats", "förvärms", "förvarnas", "förvarnats", "förvärrades", "förvärras", "förvärrats", "förvärvades", "förvärvas", "förvärvats", "förväxlades", "förväxlas", "förväxlats", "förvedas", "förvekligades", "förvekligas", "förverkas", "förverkats", "förverkligades", "förverkligas", "förverkligats", "förvillas", "förvirrades", "förvirras", "förvisades", "förvisas", "förvisats", "förvissades", "förvrängas", "förvrängdes", "förvrängs", "förvrängts", "förvreds", "förvridas", "förvridits", "förvrids", "föryngrades", "föryngras", "föryngrats", "fös", "fösas", "föses", "fosforyleras", "föstes", "fostrades", "fostras", "fostrats", "fösts", "fotats", "fotodokumenterades", "fotograferades", "fotograferas", "fotograferats", "fotokopieras", "fötts", "frågades", "frågasättas", "frågats", "fragmenteras", "fragmentiserades", "fraktades", "fraktas", "fraktats", "fräls", "frälsas", "framarbetats", "frambäras", "frambäres", "frambesvärjas", "frambesvärjs", "frambringats", "framdrivits", "framflyttats", "framföras", "framfördes", "framföres", "framförhandlades", "framförhandlats", "framförs", "framförts", "framfötts", "framhållas", "framhålles", "framhållits", "framhålls", "framhävas", "framhävdes", "framhävs", "framhölls", "främjades", "främjas", "främjats", "framkallades", "framkallas", "framkallats", "framkastades", "framkastas", "framlades", "framläggas", "framlagts", "framledes", "frammanas", "framräknas", "framräknats", "framställas", "framställdes", "framställs", "framställts", "framtagits", "framtvingas", "framtvingats", "frångås", "frånhändas", "frånkännas", "frankeras", "frankerats", "frånräknas", "fransats", "fråntagits", "fråntas", "fråntogs", "frapperades", "frapperas", "frapperats", "fräs", "fräschades", "fräschats", "fräses", "frästs", "fräts", "frättes", "frätts", "fredades", "fredas", "freddes", "fredells", "fredrikornas", "frekvensplaneras", "frekventerades", "frekventeras", "freongas", "frestades", "frestas", "frestats", "friades", "frias", "friats", "friderikas", "fridlysas", "fridlyses", "fridlystes", "frigavs", "friges", "frigetts", "frigivits", "frigjordes", "frigjorts", "frigöras", "frigöres", "frigörs", "frihetsberövades", "frikändes", "frikännas", "frikänns", "frikänts", "friklassas", "frikopplades", "frikopplas", "frikopplats", "friköptes", "frilades", "friläggas", "friläggs", "frisätts", "friserades", "friseras", "friserats", "friskförklarats", "frisläppas", "frisläpps", "frisläpptes", "frisläppts", "frisöranställdas", "frispelades", "friställas", "friställdes", "friställs", "friställts", "fritagits", "fritällts", "fritas", "friteras", "friterats", "fritidshemsplats", "fritogs", "frodades", "frodas", "frodats", "fröjdades", "fröjdas", "frölundagrabbarnas", "frontalpressades", "frös", "frossas", "frössvettades", "frostats", "frotterades", "frotteras", "frotterats", "frubjudas", "fruktades", "fruktas", "fruktats", "fruktmos", "frusits", "frustrerades", "frustreras", "frys", "frysas", "fryses", "frystes", "frysts", "fudgsicles", "fuentes", "fuktades", "fuktats", "fulländades", "fulländas", "fullbordades", "fullbordas", "fullbordats", "fullföljas", "fullföljdes", "fullföljs", "fullföljts", "fullförts", "fullgjorts", "fullgöras", "fullgörs", "fullkomnas", "fullkomnats", "funderades", "funderas", "funderats", "funnes", "fusionerades", "fusioneras", "fusionerats", "fuskades", "fuskas", "fuskats", "fylkades", "fylkas", "fylkats", "fyllas", "fylldes", "fylles", "fylls", "fyllts", "fyndas", "fyrdubblades", "fyrdubblas", "fyrdubblats", "fyrfaldigades", "gäckades", "gäckas", "gäckats", "gafflas", "gagnades", "gagnas", "gagnats", "galas", "gäldas", "gäldats", "gales", "gallottas", "gallras", "gallrats", "galopperades", "gals", "gammeldags", "gängas", "gapas", "garanterades", "garanteras", "garanterats", "garderas", "garnerades", "garneras", "garrotterades", "garvats", "gås", "gasades", "gasas", "gäspas", "gastades", "gästades", "gästas", "gästats", "gastkramades", "gastkramats", "gåtts", "gaulles", "gauloises", "gavs", "geddes", "geels", "gefundenes", "gekås", "genas", "generades", "generaliseras", "generas", "genererades", "genereras", "genererats", "geniförklarades", "geniförklarats", "genmanipuleras", "genmanipulerats", "genmföras", "gennes", "genomblåsts", "genomborrades", "genomborras", "genomborrats", "genombröts", "genombrutits", "genomdrevs", "genomdrivas", "genomfares", "genomfars", "genomföras", "genomfördes", "genomfors", "genomförs", "genomförts", "genomgås", "genomgörs", "genomkorsades", "genomkorsas", "genomläsas", "genomleds", "genomlidas", "genomlidits", "genomlids", "genomlysas", "genomskådades", "genomskådas", "genomskådats", "genomskärs", "genomsköljdes", "genomsökas", "genomsöks", "genomsöktes", "genomsökts", "genomströmmades", "genomströmmas", "genomsyrades", "genomsyras", "genrebestämmas", "gensköts", "geomfördes", "ges", "gestaltades", "gestaltas", "gestaltats", "getts", "gicks", "giftas", "giftes", "giftmördas", "gifts", "gillades", "gillas", "gillrades", "gillras", "gills", "giltigförklarats", "gipsas", "gipsats", "gissas", "gisslas", "givas", "gives", "givits", "givs", "gjirokastras", "gjordes", "gjöres", "gjors", "gjorts", "gjöts", "gjutas", "gjutits", "gjuts", "gladdes", "glädjas", "glädjs", "gläds", "glammas", "glamourdags", "gläns", "gläntades", "glasas", "glaseras", "glatts", "glesades", "glesas", "globaliseras", "glömmas", "glömmes", "glöms", "glorifierades", "glorifieras", "glunkas", "gnabbades", "gnabbandes", "gnagdes", "gnags", "gnällts", "gneds", "gnetas", "gnidas", "gnidits", "gnids", "gnisslas", "gnolas", "gnolats", "gnuggades", "gnuggas", "gnuggats", "gödas", "godkändes", "godkännas", "godkännes", "godkänns", "godkänts", "gödslades", "gödslas", "gödslats", "godspelas", "godtagas", "godtagits", "godtas", "godtogs", "golas", "golvades", "golvats", "gömdes", "gömmas", "göms", "gömts", "göras", "göres", "görs", "gosas", "götas", "götes", "göts", "gottgöras", "gottgörs", "gräddades", "gräddas", "gräddsås", "graderas", "graderats", "grälas", "grälats", "grämas", "grammisbelönats", "grändes", "granquists", "granskades", "granskas", "granskats", "gränsöverskrids", "gråtas", "gratineras", "gratinerats", "gråts", "gräts", "grattas", "gratulerades", "gratuleras", "grävas", "grävdes", "graveras", "graverats", "grävs", "gravsättas", "gravsattes", "gravsatts", "gravsätts", "grävts", "grejades", "greps", "grigorjevs", "grillas", "grillats", "grimaseras", "gripas", "gripes", "gripits", "grips", "groggys", "gröps", "gröpts", "gros", "grovhackas", "grovindelas", "grubblas", "grumlades", "grumlas", "grummes", "grundades", "grundas", "grundats", "grundförstärkas", "grundlades", "grundläggas", "grundlägges", "grundläggs", "grundlagsfästas", "grundlagts", "grundlurades", "grundlurats", "grundutbildas", "grundutbildats", "grupperades", "grupperas", "grupperats", "gruppvåldtas", "grusades", "grusas", "grusats", "guidades", "guidas", "guidats", "gullades", "gungades", "gynnades", "gynnas", "gynnats", "gyttras", "habermas", "hackades", "hackas", "hackats", "häcklades", "häcklas", "häcklats", "hades", "haemoplas", "haffades", "haffas", "hafsas", "hägnas", "hägnats", "hagsätras", "hajas", "hakades", "hakas", "hakats", "hakkas", "häktades", "häktas", "häktats", "halades", "halas", "halats", "hållas", "hällas", "hälldes", "hålles", "hälles", "hållits", "hålls", "hälls", "hållts", "hällts", "hälsades", "halsas", "hälsas", "hälsats", "halshöggs", "halshuggas", "halshuggits", "halshuggs", "hälsningstalas", "halstrades", "halstras", "halvägs", "halverades", "halveras", "halverats", "halvglas", "halvpensioneras", "hamas", "hämmades", "hämmas", "hämmats", "hamnas", "hamrades", "hamras", "hamrats", "hämtades", "hämtas", "hämtats", "hånades", "hånas", "hånats", "handelsstoppades", "handhas", "handikappades", "handikappanpassas", "handikappas", "handlades", "handläggas", "handläggs", "handlagts", "handlas", "handlats", "handlingsförlamas", "handplockades", "handplockas", "handplockats", "handskadades", "handskades", "handskas", "handskats", "handvevas", "hänföras", "hänfördes", "hänförs", "hänförts", "hängas", "hängdes", "hänges", "hängs", "hängts", "hanhals", "hanns", "hänryckas", "hanses", "hänskjutas", "hänskjutits", "hänskjuts", "hänsköts", "hånskrattas", "hanterades", "hanteras", "hanterats", "hänvisades", "hänvisas", "hänvisats", "harangerades", "harangeras", "härbärgerades", "härbärgeras", "härbärgerats", "härdades", "härdas", "härdats", "hårdbantas", "hårdbevakas", "hårddrillas", "hårdexploaterats", "hårdgranskas", "hårdlanserades", "hårdlanseras", "hårdpumpats", "härjades", "härjas", "härjats", "härledas", "härleds", "härletts", "harmades", "harmas", "harmonieras", "harmonierats", "harmoniseras", "härröras", "härrydas", "harvas", "has", "hasades", "hässjades", "hässles", "hastas", "hastats", "hatades", "hatas", "haussades", "haussas", "håvas", "hävas", "hävdades", "hävdas", "hävdats", "hävdes", "häves", "hävs", "hävts", "hedrades", "hedras", "hedrats", "hejas", "hejdades", "hejdas", "hejdats", "helas", "helgades", "helgarderas", "helgas", "helgonförklarades", "hellacopters", "hells", "helrenoverades", "helrenoverats", "helsingfors", "heltidsanställs", "helvittes", "hemfördes", "hemförlovades", "hemförlovas", "hemkallas", "hemlighållas", "hemlighållits", "hemlighålls", "hemlighölls", "hemligstämplades", "hemligstämplas", "hemligstämplats", "hemskjuts", "hemsökas", "hemsöks", "hemsöktes", "hemsökts", "hetsades", "hetsas", "hetsats", "hettades", "hettas", "hilaritas", "himbas", "himlalots", "hindrades", "hindras", "hindrats", "hinnas", "hinns", "hispaniseras", "hissades", "hissas", "hissats", "hitleriseras", "hittades", "hittas", "hittats", "hivades", "hivas", "hivinfekterades", "hjälpas", "hjälps", "hjälpsåtts", "hjälptes", "hjälpts", "hjärntvättats", "hjärtopereras", "hjärtopererats", "hoas", "höegs", "höggs", "högindustrialiseras", "högpromiskuösas", "högtalarförmedlas", "högtidlighållas", "högtidlighålls", "höjas", "höjdes", "höjs", "hojtas", "höjts", "höljas", "höljdes", "höljes", "holkades", "holkas", "holkats", "hölls", "hollywoodiserades", "homogeniserades", "homogeniseras", "honaratiores", "honkas", "honoreras", "honorerats", "hopfogades", "hoppasts", "horas", "höras", "hördes", "höres", "horisontaliseras", "hormonstimulerats", "hormontestas", "hörs", "hörsammades", "hörsammas", "hörsammats", "hortas", "hörts", "hotades", "hotas", "hotats", "hottas", "hottats", "höves", "hudflängas", "hudflängs", "hudflängts", "hudstrykas", "huggas", "huggits", "huggs", "hukandes", "humaniserades", "humaniseras", "humaniserats", "hummades", "hundradubblats", "hundratas", "hunnits", "hunsades", "hunsas", "hunsats", "hurrades", "hurras", "hutades", "hutas", "huttlas", "huttrades", "huttras", "hutus", "huvudstas", "hycklas", "hyfsats", "hygieniseras", "hyllades", "hyllas", "hyllats", "hypas", "hypats", "hyras", "hyrdes", "hyressättas", "hyrs", "hyrts", "hys", "hysas", "hystes", "hysts", "hyvlades", "hyvlas", "iaktas", "iaktatagas", "iakttagas", "iakttages", "iakttagits", "iakttas", "iakttogs", "idénförverkligades", "identifierades", "identifieras", "identifieratas", "identifierats", "ideologiserats", "idkades", "idkas", "idoliseras", "idrottas", "idrottsskadas", "idylliseras", "ifrågasättas", "ifrågasattes", "ifrågasättes", "ifrågasatts", "ifrågasätts", "ifrågsattes", "igångsättas", "igångsattes", "igångsatts", "igångsätts", "igenkännes", "igenkänns", "ignorerades", "ignoreras", "ignorerats", "ihågkommas", "ihågkommes", "ihågkommits", "ihågkoms", "iklädas", "ikläddes", "ikläds", "ikläs", "iklätts", "ilijas", "illfänas", "illuminerades", "illumineras", "illusteras", "illustrerades", "illustreras", "illustrerats", "illustrererades", "illustrereras", "imiterades", "implementeras", "imponerades", "imponeras", "imponerats", "importerades", "importeras", "importerats", "impregneras", "impregnerats", "improviserades", "improviseras", "improviserats", "impulsas", "inackorderades", "inaktiveras", "inandades", "inandandes", "inandas", "inandats", "inarbetades", "inbegripas", "inbegrips", "inberäknas", "inbesparas", "inbetalas", "inbillas", "inbjöds", "inbjudas", "inbjudes", "inbjudits", "inbjuds", "inblandades", "inblandas", "inböjds", "indefinieras", "indelades", "indelas", "indelats", "indelsas", "indentifierats", "independentfilmernas", "indikeras", "individanpassas", "individualiseras", "individualiserats", "indoktrineras", "indoktrinerats", "indragas", "indunstas", "industrialiserades", "industrialiseras", "industrialiserats", "infångades", "infångas", "infasas", "infattades", "infattas", "infekteras", "infekterats", "infiltrerades", "infiltreras", "inflammeras", "inflammerats", "inflationsskyddas", "inflikas", "influerades", "influeras", "influerats", "infogades", "infogas", "infogats", "införas", "infördes", "infordrades", "infordras", "infordrats", "införes", "införlivades", "införlivas", "införlivats", "informerades", "informeras", "informerats", "införs", "införskaffades", "införskaffas", "införskaffats", "införts", "infriades", "infrias", "infriats", "ingås", "ingåtts", "ingavs", "inges", "ingicks", "ingjutits", "ingjuts", "inhägnas", "inhägnats", "inhämtades", "inhämtas", "inhämtats", "inhandlades", "inhandlas", "inhandlats", "inhängnas", "inhiberades", "inhiberas", "inhöstats", "inhysas", "inhystes", "inhysts", "initierades", "initieras", "initierats", "injicerades", "injiceras", "injicerats", "inkallades", "inkallas", "inkallats", "inkarnerades", "inkarneras", "inkasserades", "inkluderades", "inkluderas", "inkluderats", "inkoms", "inkomstprövas", "inköpas", "inköptes", "inköpts", "inkorpererades", "inkorporerades", "inkorporeras", "inkorporerats", "inkrävas", "inkvarterades", "inkvarteras", "inkvarterats", "inlades", "inlämnades", "inlämnas", "inlämnats", "inlånades", "inläras", "inledas", "inledddes", "inleddes", "inledes", "inleds", "inlemmades", "inlemmas", "inlemmats", "inletts", "inlevereras", "inlevererats", "inlines", "inlösas", "inlöses", "inlöstes", "inmonteras", "inmundigades", "inmundigas", "innebrändes", "innefattades", "innefattas", "innehades", "innehafts", "innehållas", "innehållsdeklareras", "innehas", "inneslutas", "innesluts", "inordnades", "inordnas", "inordnats", "inplaneras", "inplanterades", "inplanteras", "inplanterats", "inpräglas", "inpräglats", "inpräntades", "inpräntas", "inpräntats", "inprogrammerats", "inräknades", "inräknas", "inräknats", "inramades", "inramas", "inramats", "inrangeras", "inrangerats", "inrapporterades", "inrapporteras", "inrapporterats", "inrättades", "inrättas", "inrättats", "inredas", "inreddes", "inreds", "inregistrerades", "inregistreras", "inregistrerats", "inretts", "inriktades", "inriktas", "inriktats", "inringas", "inristats", "inrymdes", "inrymmas", "inryms", "inrymts", "insågs", "insamlades", "insamlas", "insamlats", "insänts", "insättas", "insattes", "insatts", "inseminerades", "insemineras", "inses", "insinueras", "insinuerats", "insisteras", "inskaffades", "inskärpas", "inskärptes", "inskeppades", "inskjutas", "inskolas", "inskränkas", "inskränks", "inskränktes", "inskränkts", "inskrevs", "inskrivas", "insöndras", "insorteras", "inspärras", "inspekterades", "inspekteras", "inspekterats", "inspelats", "inspirationsgivs", "inspirerades", "inspireras", "inspirerats", "inställas", "inställdes", "installerades", "installeras", "installerats", "inställs", "inställts", "instängas", "instiftades", "instiftas", "instiftats", "institutionaliserades", "institutionaliseras", "instruerades", "instrueras", "instruerats", "instrumentaliseras", "insvepas", "insveps", "insveptes", "insvepts", "intagas", "intagits", "intalleras", "intas", "intecknades", "intecknas", "intecknats", "integrerades", "integreras", "integrerats", "intellektualiseras", "intellektualiserats", "intensifierades", "intensifieras", "intensifierats", "interfolierades", "interfolieras", "interfolierats", "internationales", "internationaliserades", "internationaliseras", "internationaliserats", "internerades", "interneras", "internerats", "internrekryterats", "internutbildas", "interpelleras", "interpunkterades", "intervjuades", "intervjuas", "intervjuats", "intevjuas", "intimiseras", "intimiserats", "intjänas", "intogs", "intressestyras", "intrigeras", "introducerades", "introduceras", "introducerats", "intvingas", "intygades", "intygas", "invaderades", "invaderas", "invaderats", "invaggades", "invaggas", "invaggats", "invaldes", "invalidiserades", "invalidiseras", "invalidiserats", "inväljas", "inväljs", "invalts", "invändas", "invandrades", "inväntades", "inväntas", "invecklas", "inventeras", "inventerats", "investerades", "investeras", "investerats", "invigas", "invigdes", "invigs", "inviskas", "inviteras", "inviterats", "invlades", "involverades", "involveras", "involverats", "inympas", "inympats", "iordningsställts", "iordningställas", "iordningställdes", "iordningställs", "iordningställts", "irriterades", "irriteras", "irriterats", "isades", "isas", "iscensättas", "iscensattes", "iscensatts", "iscensätts", "isolerades", "isoleras", "isolerats", "iståndsätts", "ives", "jagades", "jagas", "jagats", "jäktas", "jamas", "jämföras", "jämfördes", "jämförs", "jämförts", "jämkades", "jämkas", "jämnades", "jämnas", "jämnats", "jämnsides", "jämnställs", "jämställas", "jämställdes", "jämställes", "jämställs", "jämställts", "järfällas", "järnberikats", "järnvägsgods", "järvas", "jäs", "jäses", "jävas", "jävats", "jävlas", "jävlats", "jayhawkes", "jenufas", "jesses", "jippofieras", "jobbades", "jobbas", "jobbats", "jonglerades", "jonhälls", "joniseras", "joniserats", "jordbegravas", "jordfästas", "jordfästes", "jordgas", "journalföras", "journalistbas", "jublades", "jublas", "jublats", "juckas", "julas", "justerades", "justeras", "justerats", "kabilas", "kablades", "kablas", "kablats", "kacklades", "kåges", "käkopererats", "kalätas", "kalfatras", "kalhöggs", "kalkades", "kalkas", "kalkats", "kalkylerades", "kalkyleras", "kalkylerats", "kallades", "kallas", "kallats", "kallistenes", "kallpressas", "kallrökas", "kallrökts", "källsorteras", "kallsvettades", "kallsvettas", "kambodjas", "kammades", "kammas", "kammats", "kamouflagemålats", "kamoufleras", "kämpas", "kanaliserades", "kanaliseras", "kanaliserats", "kånkades", "kånkas", "kånkats", "känndes", "kännetecknades", "kännetecknas", "kännetecknats", "kännts", "kanoniserades", "kanoniseras", "käns", "kantades", "kantas", "kantats", "kantfållas", "kantställas", "kapades", "kapas", "kapats", "kapitaliseras", "kappades", "kappseglas", "kapslades", "kapslas", "kapslats", "karaktäriserades", "karaktäriseras", "karaktäriserats", "karakteriserades", "karakteriseras", "karakteriserats", "karikeras", "kärnades", "kärnats", "kartlades", "kartläggas", "kartläggs", "kartlagts", "karvas", "kasserades", "kasseras", "kasserats", "kastades", "kastas", "kastats", "kastreras", "kastrerats", "katalas", "katalogiseras", "katalogiserats", "kategoriseras", "kategoriserats", "kattas", "kavlades", "kavlas", "keats", "kedjades", "kedjats", "keldereks", "kemtvättas", "keynes", "kickades", "kickats", "kidnappades", "kidnappas", "kidnappats", "kikås", "kilades", "kilas", "killas", "kindpussas", "kinshasas", "kissas", "kittades", "kittlades", "kittlas", "klaas", "kläckas", "kläckningsplats", "kläcks", "kläcktes", "kläckts", "klädas", "kladdades", "kladdas", "kladdats", "kläddes", "kläds", "klagades", "klagas", "klagats", "klämdes", "klämmas", "kläms", "klämtas", "klämts", "klandrades", "klandras", "klandrats", "klankas", "klappades", "klappas", "klarades", "klaras", "klarats", "klargjordes", "klargjorts", "klargöras", "klargörs", "klarlades", "klarläggas", "klarläggs", "klarlagts", "kläs", "klassades", "klassas", "klassats", "klassificerades", "klassificeras", "klassificerats", "klättrades", "klättras", "klätts", "klemas", "kletas", "kletats", "klias", "klickas", "klimpades", "klippas", "klipps", "klipptes", "klippts", "klipsades", "klistrades", "klistras", "klistrats", "klockades", "klockas", "klockats", "klonas", "klonats", "kloreras", "klorgas", "klös", "klösts", "klottras", "klottrats", "klövs", "klubbades", "klubbas", "klubbats", "klubbhus", "kluddats", "klumpades", "klumpas", "kluvits", "klyftas", "klyvas", "klyvs", "klyvts", "knackades", "knäckas", "knackats", "knäcks", "knäcktes", "knäckts", "knådas", "knådats", "knallas", "knäopereras", "knåpades", "knåpas", "knäppas", "knäpps", "knäpptes", "knarkas", "knas", "knäsattes", "knäsatts", "kneps", "knipas", "knips", "knivdödades", "knivdödas", "knivhöggs", "knivhotas", "knivhuggits", "knivhuggs", "knivmördades", "knivskars", "knivskärs", "knockades", "knockas", "knockats", "knölades", "knopas", "knorrades", "knorras", "knöts", "knottrades", "knuckles", "knuffades", "knuffas", "knuffats", "knusslades", "knutits", "knycklas", "knycktes", "knypplats", "knystas", "knytas", "knyts", "köas", "kodas", "kodats", "kodifieras", "kodifierats", "kokades", "kokas", "kokats", "kolgrillas", "kollades", "kollas", "kollats", "kollektivansluts", "kolles", "kolonialiseras", "koloniserades", "koloniseras", "koloniserats", "koloreras", "kombinerades", "kombineras", "kombinerats", "kommenderades", "kommenderas", "kommenderats", "kommenterades", "kommenteras", "kommenterats", "kommersialiseras", "kommersialiserats", "kommits", "kommunaliserades", "kommunaliseras", "kommuniceras", "kommunplacerades", "kompades", "kompas", "kompenserades", "kompenseras", "kompenserats", "kompetensutvecklas", "komplettaras", "kompletterades", "kompletteras", "kompletterats", "komplicerades", "kompliceras", "komplicerats", "komponerades", "komponeras", "komponerats", "komposterades", "komposteras", "komposterats", "komprimeras", "komprimissas", "komprometterats", "kompromissas", "kompromissats", "könas", "koncenteras", "koncenterats", "koncentreades", "koncentrerades", "koncentreras", "koncentrerats", "koncipierades", "koncipieras", "koncipierats", "kondenserades", "kondenseras", "konditionstestas", "konfektioneras", "konfirmerades", "konfirmeras", "konfirmerats", "konfiskerades", "konfiskeras", "konfiskerats", "konfronterades", "konfronteras", "konfronterats", "kongeliges", "konkretiserades", "konkretiseras", "konkretiserats", "konkurrensutsättas", "konkurrensutsattes", "konkurrensutsatts", "konkurrerades", "konkurreras", "konkurrerats", "konserverades", "konserveras", "konserverats", "könskvoteras", "könskvoterats", "konsoliderades", "konsolideras", "konsoliderats", "konspirerades", "konstaterades", "konstateras", "konstaterats", "konstgods", "konstigtueras", "konstituerades", "konstitueras", "konstmanifesteras", "konstruerades", "konstrueras", "konstruerats", "konsulterades", "konsulteras", "konsulterats", "konsumerades", "konsumeras", "konsumerats", "kontaktades", "kontaktas", "kontaktats", "konterfejas", "kontinentaliserats", "kontollerats", "kontrakteras", "kontrakterats", "kontras", "kontrasterades", "kontrasteras", "kontrollerades", "kontrolleras", "kontrollerats", "kontrollvägdes", "kontrollvägts", "konverteras", "koordinerades", "koordineras", "köpas", "kopierades", "kopieras", "kopierats", "köplats", "kopplades", "kopplas", "kopplats", "köprekommenderades", "köps", "köptes", "köpts", "kopuleras", "korades", "koras", "köras", "korats", "kördes", "koreograferats", "köres", "korkades", "korkas", "korngolds", "korporativiserats", "korrekturläses", "korreleras", "korrigerades", "korrigeras", "korrigerats", "korrumperas", "korrumperats", "körs", "korsades", "korsas", "korsats", "korsfästas", "korsfästes", "korsfästs", "kortades", "kortas", "kortats", "körts", "kortslöts", "kortsluts", "korvas", "kosroes", "kostas", "kostaterades", "kostnadsberäknades", "kostnadsberäknas", "kostnadsberäknats", "kostnadsföras", "kotrollvägdes", "kovacs", "krackeleras", "kramades", "kramas", "kramats", "kramkalas", "krängdes", "krånglats", "krängts", "kränkas", "kränks", "kränktes", "kränkts", "kransats", "krattas", "krävas", "krävdes", "kräves", "krävs", "krävts", "kreerades", "kremerades", "kremeras", "kretsloppsanpassas", "krigsplaceras", "kriminaliserades", "kriminaliseras", "kringgärdades", "kringgärdas", "kringgås", "kringgåtts", "kringgicks", "kringgjutits", "kringränts", "kringskäras", "kringskars", "kringvärvs", "kristalliserades", "kristalliseras", "kristnades", "kritas", "kritiserades", "kritiseras", "kritiserats", "krockades", "krockprovas", "krokades", "krökas", "krokats", "kröks", "kröktes", "krönas", "krönes", "kröns", "kröntes", "krönts", "kroppsvisiterades", "kroppsvisiteras", "krossades", "krossas", "krossats", "krusades", "krusas", "kryddades", "kryddas", "kryddats", "krympas", "krymps", "krymptes", "krympts", "krypteras", "krypterats", "krypts", "kryssas", "kryssats", "kryssgarderas", "kubbas", "kuggades", "kuggas", "kullas", "kullkastas", "kultiveras", "kultiverats", "kulturminnesmärkas", "kulturminnesskyddats", "kulturprofileras", "kulverteras", "kulverterats", "kumquats", "kundanpassas", "kundbas", "kundes", "kungjordes", "kungjorts", "kungörs", "kunnas", "kupades", "kuperas", "kuppats", "kureras", "kursas", "kursras", "kuvas", "kuvats", "kvackas", "kvaddades", "kvaddats", "kvalificeras", "kvalitetsäkras", "kvalitetsprövats", "kvalitetssäkras", "kvalitetssäkrats", "kvalitetsutbildats", "kväljdes", "kvällades", "kvalplats", "kvantifieras", "kvarhållas", "kvarhållits", "kvarhålls", "kvarhölls", "kväsas", "kvästes", "kvävas", "kvävdes", "kvävs", "kvinnoplats", "kvittas", "kvittats", "kvitterades", "kvitteras", "kvotbelades", "kvoteras", "kvoterats", "kylas", "kyldes", "kyls", "kylts", "kyssas", "kysstes", "laborades", "laboreras", "lackeras", "lackerats", "läcks", "läckts", "laddades", "laddas", "laddats", "lades", "lafis", "lagades", "lagas", "lagats", "lagerhållas", "lagfästes", "lagfästs", "lagföras", "lagfördes", "läggas", "lägges", "lägggas", "läggs", "lagrades", "lagrådsremitteras", "lagras", "lagrats", "lagregleras", "lagstadgades", "lagstiftas", "lagtrots", "lågtrycksgjuts", "lagts", "läkarundersökas", "läkarundersöktes", "lakas", "läkas", "lakats", "läks", "läktes", "läktrats", "läkts", "lambrecks", "lamineras", "lämnades", "lämnas", "lämnats", "lämpades", "lämpas", "lämpats", "lamslagits", "lamslås", "lamslogs", "lånades", "lånas", "lånats", "lanceras", "landades", "landsattes", "landsatts", "landsförvisades", "landsförvisas", "landsförvisats", "lånefinansieras", "langades", "langas", "långås", "långsits", "långtidslagras", "långtidsparkerades", "långtidsskolats", "längts", "languages", "länkades", "länkas", "länkats", "länsades", "länsas", "länsats", "lanserades", "lanseras", "lanserats", "lansertas", "länspumpas", "lapas", "lappades", "lappas", "lappats", "läras", "lärdes", "larmades", "larmas", "larmats", "lärs", "larses", "lårskadades", "lärts", "las", "lås", "läs", "låsas", "läsas", "laserats", "låses", "läses", "lassades", "lassas", "låssas", "lassats", "låssats", "lastades", "lastas", "lastats", "låstes", "lästes", "låsts", "lästs", "låtits", "lättades", "lättas", "lättats", "läxats", "leasades", "leasas", "leasats", "ledas", "leddes", "ledes", "ledigförklarades", "ledigförklaras", "ledigförklarats", "leds", "ledsagades", "ledsagas", "legalförskrevs", "legaliserades", "legaliseras", "legaliserats", "legeras", "legitimerades", "legitimeras", "legitimerats", "lekas", "leks", "lektes", "lemlästades", "lemlästas", "lemlästats", "lemströms", "lenas", "letades", "letas", "letats", "letts", "levandegörs", "levas", "levdes", "leverades", "leveraras", "levererades", "levereras", "levererats", "levertransplanteras", "leves", "levs", "levts", "lfinns", "liberaliseras", "liberaliserats", "licensbryggs", "licenserats", "licenstillverkats", "lidas", "lidits", "likformas", "liknades", "liknas", "liknats", "likställas", "likställdes", "likställs", "likviderades", "likvideras", "limmades", "limmas", "limmats", "lindades", "lindas", "lindats", "lindrades", "lindras", "lindrats", "linjeras", "linoljebränns", "lipas", "lirades", "liras", "lirkas", "lirkats", "listades", "listas", "listats", "livades", "livas", "lives", "livnärs", "livstidsförlängdes", "ljögs", "ljudas", "ljudisoleras", "ljugas", "ljugs", "ljummades", "ljummas", "ljumskskadades", "ljussatts", "lockades", "lockas", "lockats", "lockoutas", "lodas", "lödas", "löds", "loggas", "logothetis", "logrones", "lokaliserades", "lokaliseras", "lokaliserats", "lomas", "lönades", "lönas", "lönediskrimineras", "lönediskriminerats", "löneras", "lönesättas", "longeras", "lönnbrännes", "loopas", "loopats", "loosegoats", "löpas", "löps", "lösas", "löses", "lösgivas", "lösgjordes", "lösgjorts", "lösgöras", "lösgöres", "lösgörs", "lossades", "lossas", "lossats", "löstes", "lösts", "lotsades", "lotsas", "lotsats", "lottades", "lottas", "lottats", "lovades", "lövades", "lovas", "lövas", "lovats", "lövats", "lovordades", "lovordas", "lovordats", "lovprisades", "lovprisas", "lovsjungits", "lovsjungs", "luckrades", "luckras", "luckrats", "luftades", "luftas", "luftats", "luftlandsattes", "lugnades", "lugnas", "lukkes", "lurades", "luras", "lurats", "lusläses", "luslästes", "lussas", "lutades", "lutas", "luttras", "luttrats", "lyckes", "lyckets", "lyckönskas", "lycksönskades", "lycktas", "lydas", "lyddes", "lyftas", "lyftes", "lyfts", "lynchades", "lynchats", "lys", "lysas", "lyses", "lyss", "lyssnas", "lystes", "lysts", "lyxrenoveras", "lyxsanerades", "lyxsaneras", "lyxsanerats", "macoutes", "måddes", "mades", "magallanes", "magasinerades", "magasineras", "magasinerats", "magpumpas", "magpumpats", "magras", "majos", "mäklades", "makulerades", "makuleras", "målades", "malas", "målas", "målats", "malbas", "målbestäms", "maldes", "mals", "malts", "mammograferats", "manades", "manas", "månas", "manats", "mångdubblades", "mångdubblas", "mångdubblats", "mångfaldigades", "mångfaldigas", "mångfaldigats", "manglades", "manglas", "manglats", "månglats", "manifesterades", "manifesteras", "manifesterats", "manipulerades", "manipuleras", "manipulerats", "manövrerades", "manövreras", "manövrerats", "mantalskrivas", "mantalsskrivas", "marantas", "marginaliserades", "marginaliseras", "marginaliserats", "marineras", "marinerats", "märkas", "markerades", "markeras", "markerats", "märkes", "markets", "markledes", "marknadsanpassas", "marknadsföras", "marknadsfördes", "marknadsförs", "marknadsförts", "marknadsintroducerades", "märks", "märktes", "märkts", "markurells", "marples", "marterades", "martikas", "mås", "maskas", "maskerades", "maskeras", "maskerats", "maskintvättas", "maskinveks", "massakrerades", "massakreras", "mässas", "masserades", "masseras", "massproduceras", "masstillverkas", "mastas", "mästras", "matades", "matas", "mätas", "matats", "matchades", "matchas", "matchats", "matchinsats", "materialiserades", "materialiseras", "materialiserats", "mätes", "matplats", "mäts", "mattades", "mattas", "måttas", "mättas", "mattats", "mättats", "mättes", "mätts", "matutes", "maximeras", "medagerandes", "medaljeras", "medaljhyllades", "meddelades", "meddelas", "meddelats", "medfinansieras", "medföras", "medfördes", "medföres", "medförs", "medgavs", "medges", "medgivits", "medhavas", "medialiserats", "medicineras", "medicinerats", "medikaliserades", "medlas", "medräknas", "medtagas", "medtages", "medtas", "medtogs", "medvetandegöras", "mefistofeles", "mejades", "mejas", "mejats", "mejslades", "mekaniserats", "memoreras", "menades", "menas", "mennas", "meritvärderas", "mestadelas", "metroiseras", "midas", "mikrats", "mikrofilmades", "mikrofilmas", "mildrades", "mildras", "mildrats", "miles", "militariserades", "militariseras", "militariserats", "miljöanpassas", "miljöcertifierats", "miljödeklareras", "miljögranskats", "miljöklassas", "miljömärkas", "miljömärkts", "miljöprövas", "miljöskyddas", "mills", "mimades", "mimas", "mineraliseras", "mineras", "minerats", "minglats", "minimerades", "minimeras", "minimerats", "minnns", "minskades", "minskas", "minskats", "minsprängdes", "minutes", "misbruges", "missades", "missas", "missats", "missbrukades", "missbrukas", "missbrukats", "missfärgas", "missförstås", "missförståtts", "missförstods", "missgynnades", "missgynnas", "missgynnats", "misshandlades", "misshandlas", "misshandlats", "misshushållas", "missköts", "misskötts", "misskrediterades", "missledas", "missletts", "misssgynnas", "misssköts", "misstänkas", "misstänkliggjordes", "misstänkliggöras", "misstänkliggörs", "misstänks", "misstänktes", "misstänkts", "misstas", "misstolkas", "misstolkats", "misstroddes", "misstros", "misstydas", "missunnnas", "missupfattas", "missuppattades", "missuppfattades", "missuppfattas", "missuppfattats", "mixas", "mjölkades", "mjölkas", "mjukades", "mjukas", "mjukats", "mjukpressats", "mobbades", "mobbas", "mobbats", "mobiliserades", "mobiliseras", "mobiliserats", "möblerades", "möbleras", "möblerats", "mockades", "modeinitierades", "moderninserats", "moderniserades", "moderniseras", "moderniserats", "modifierades", "modifieras", "modifierats", "mognadslagras", "mogulrikets", "möjas", "möjliggjordes", "möjliggjorts", "möjliggöras", "möjliggörs", "möjligjorts", "momsbefrias", "momsbeläggas", "momsbeläggs", "momsbelagts", "mondes", "monkees", "monograferats", "monopoliseras", "monopoliserats", "monsterras", "mönsterskyddats", "mönstrades", "mönstras", "mönstrats", "monterades", "monteras", "monterats", "monumentaliseras", "moraliseras", "mörbultats", "mördades", "mördas", "mördats", "mordhotades", "mordhotats", "mörkas", "mörklades", "mörkläggas", "mörkläggs", "mörklagts", "morrades", "morras", "mortuis", "mosades", "mosas", "motades", "motarbetades", "motarbetas", "motarbetats", "motas", "motats", "motbevisas", "motionerades", "motioneras", "motiverades", "motiveras", "motiverats", "motoriseras", "motsades", "motsägas", "motsäges", "motsägs", "motsagts", "motstås", "motsvarades", "motsvaras", "motsvarats", "mottagas", "mottages", "mottagits", "mottas", "mottogs", "motverkades", "motverkas", "motverkats", "muddras", "multipliceras", "mulugetas", "mumifieras", "mumifierats", "mumlades", "mumlas", "mumlats", "mungnabbas", "munhöggs", "munhuggas", "munhuggs", "murades", "muras", "murats", "musicerades", "musiceras", "mutades", "mutas", "mutats", "muttrades", "muttras", "muttrats", "mutts", "muzungos", "myers", "myglades", "myndigförklaras", "myndighetsförklarats", "myntades", "myntas", "myntats", "mysas", "mystifieras", "mystifierats", "mytifieras", "nackas", "nádas", "nåddes", "nådes", "nafsades", "nagelfaras", "nagelfarits", "nagelfars", "nagelfors", "naggades", "naggas", "naggats", "naglades", "naglas", "nålas", "nålats", "namnades", "nämnas", "nämndes", "nämnes", "namngavs", "namnges", "namngetts", "namngivits", "nämns", "namnskyddas", "nämnts", "näms", "nämts", "nändes", "nännas", "nänns", "näns", "nänts", "näpsas", "näras", "närdes", "näres", "närmas", "narracotts", "narrades", "narras", "narrats", "närs", "närts", "nas", "nås", "nasas", "nästas", "nationaliserades", "nationaliseras", "nationaliserats", "natoanpassas", "natofieras", "nattas", "nåtts", "nattstädas", "nattstängs", "naturaliseras", "naturligtivs", "navotas", "nedbringas", "nedbringats", "nedbrytas", "nedflyttningsplats", "nedgjordes", "nedgraderas", "nedkämpas", "nedkämpats", "nedlades", "nedläggas", "nedlagts", "nedmonterades", "nedmonteras", "nedrangeras", "nedreviderades", "nedreviderats", "nedrustas", "nedsättas", "nedsätts", "nedsköljes", "nedskrivas", "nedslås", "nedtecknades", "nedtecknats", "nedtynges", "nedtystas", "nedvärderas", "nedvärderats", "negeras", "negligeras", "negligerats", "nekades", "nekas", "nekats", "nerslås", "nettoamorteras", "nettoexporterades", "nettoköptes", "nettoköpts", "nettosåldes", "nettosålts", "neurosedynskadades", "neutraliserades", "neutraliseras", "neutraliserats", "nickades", "nickas", "nitas", "nivågrupperas", "njutas", "njutes", "njuts", "nobbades", "nobbas", "nobbats", "nobelprisförbigåtts", "nödbromsas", "nödgades", "nödgats", "nödsakats", "nödslaktades", "nödslaktas", "nödslaktats", "nödstoppades", "nödvändiggjordes", "nollades", "nollställas", "nollställs", "nollställts", "nolltaxeras", "nominerades", "nomineras", "nominerats", "noms", "nonchalerades", "nonchaleras", "nonchalerats", "nordstedts", "normalförklaras", "normaliserades", "normaliseras", "normaliserats", "nös", "nötas", "noterades", "noteras", "noterats", "noteringsstoppades", "nöts", "nöttes", "nötts", "nuddas", "numererats", "numreras", "numrerats", "nuvärdeberäknas", "nuvärdeberäknats", "nuvärdesberäknas", "nyanlagts", "nyanmäldes", "nyanserades", "nyanseras", "nyanserats", "nyanställas", "nyanställdes", "nyanställs", "nyanställts", "nybeställas", "nybyggas", "nydanades", "nyemitteras", "nyetableras", "nygestaltades", "nyindustrialiseras", "nyinvandrades", "nyinvigts", "nykryddats", "nynnades", "nynnas", "nyordnas", "nyorienteras", "nyöversattes", "nyöversatts", "nyplanterades", "nyprövas", "nyps", "nyrekryteras", "nyritades", "nyskapas", "nystades", "nystas", "nystats", "nytillverkas", "nytolkas", "nytrycktes", "nyttjades", "nyttjas", "nyttjats", "nyutexamineras", "nyutgavs", "nyvaldes", "nyväljs", "oakes", "oates", "obducerades", "obduceras", "obducerats", "obligationsras", "obs", "observerades", "observeras", "observerats", "ocksåses", "ocksåstärkts", "ocksåtas", "ockuperades", "ockuperas", "ockuperats", "ödas", "ödelades", "ödeläggas", "ödeläggs", "ödelagts", "odlades", "odlas", "odlats", "odödligförklarats", "odödliggjordes", "ödslas", "ödslats", "odugligförklarats", "odyssevs", "offentliggjordes", "offentliggjorts", "offentliggöras", "offentliggörs", "offereras", "offererats", "offetliggjordes", "offrades", "offras", "offrats", "ofredas", "ogilitigförklaras", "ogillades", "ogillas", "ogillats", "ogiltigförklarades", "ogiltigförklaras", "ogiltigförklarats", "öis", "ojades", "ojas", "ökades", "ökas", "ökats", "olagligförklaras", "olagligförklarats", "olas", "olåtandes", "oliktänkades", "oljas", "oljats", "olövanes", "olyckas", "olycksfallsförsäkras", "omarbetades", "omarbetas", "omarbetats", "ombads", "ombedas", "ombedes", "ombeds", "ombes", "ombesörjas", "ombesörjdes", "ombesörjs", "ombesörjts", "ombetts", "ombildades", "ombildas", "ombildats", "omdanades", "omdanas", "omdanats", "omdaterats", "omdefinieras", "omdirigerades", "omdirigeras", "omdirigerats", "omdisponeras", "omdöpas", "omdöps", "omfamnades", "omfamnas", "omfatas", "omfattades", "omfattas", "omfattats", "omfatttas", "omflytes", "omfördelades", "omfördelas", "omfördelats", "omförhandlades", "omförhandlas", "omförhandlats", "omformades", "omformas", "omformulerades", "omformuleras", "omgärdades", "omgärdas", "omgärdats", "omgavs", "omges", "omgestaltades", "omgestaltas", "omgestaltats", "omgetts", "omgivits", "omgrupperas", "omhäktades", "omhändertagas", "omhändertagits", "omhändertas", "omhändertogs", "omhuldades", "omhuldas", "omhuldats", "omintetgjordes", "omintetgjorts", "omintetgöras", "omintetgörs", "omisoleras", "ömkas", "omlokaliseras", "ommöbleras", "omnamnades", "omnämnas", "omnämndes", "omnämns", "omnämnts", "omöjliggjordes", "omöjliggjorts", "omöjliggöras", "omöjliggöres", "omöjliggörs", "omorganiserades", "omorganiseras", "omorganiserats", "omorienteras", "omplacerades", "omplaceras", "omplacerats", "omplanteras", "omprioriteras", "omprogrammeras", "omprövades", "omprövas", "omräknas", "omramades", "omregistreras", "omringades", "omringas", "omritades", "omröres", "omsättas", "omsattes", "omsatts", "omsätts", "omskapades", "omskapas", "omskäras", "omskolas", "omskolats", "omskrivas", "omskrivits", "omskrivs", "omslingrades", "omslöts", "omslutas", "omslutes", "omsluts", "omställas", "omstöpas", "omstöps", "omstöpts", "omstrukturerades", "omstruktureras", "omstrukturerats", "omsusas", "omsvärmades", "omsvärmas", "omtalades", "omtalas", "omtalats", "omtöcknas", "omtolkas", "omvaldes", "omväljas", "omväljs", "omvalts", "omvändas", "omvändes", "omvandlades", "omvandlas", "omvandlats", "omvänds", "omvänts", "omvärderades", "omvärderas", "omvärderats", "omvittnades", "omvittnas", "omvittnats", "omyndigförklaras", "omyndigförklarats", "onderwijs", "onödiggöras", "önskades", "önskas", "operades", "opererades", "opereras", "opererats", "öppnades", "öppnas", "öppnats", "optimeras", "ordas", "ordats", "ordinerades", "ordineras", "ordinerats", "ordnades", "ordnas", "ordnats", "oreras", "orerats", "organiserades", "organiseras", "organiserats", "orienteras", "orienterats", "oroades", "oroas", "oroats", "öronklippas", "öronmärkas", "öronmärks", "öronmärktes", "öronmärkts", "örontisslas", "orsakades", "orsakas", "orsakats", "orsaksförklaras", "ortelgas", "ös", "osäkras", "ösas", "oscarnominerades", "oskadliggjordes", "oskadliggöras", "oskadliggörs", "oskarsnominerats", "östbergas", "östes", "ostgratinerats", "östrogenbehandlas", "östs", "osynliggjorts", "osynliggöras", "osynliggörs", "övades", "övas", "övats", "öveföres", "överanvänds", "överarbetas", "överås", "överbefolkas", "överbejakas", "överbelastades", "överbelastas", "överbeskattas", "överbetonades", "överbetonats", "överbevisades", "överbevisas", "överbevisats", "överblickas", "överbryggas", "överdäckas", "överdebiterats", "överdimensionerats", "överdoseras", "överdramatiseras", "överdrevs", "överdrivas", "överdrivits", "överdrivs", "överdrogs", "överenskommits", "överenskoms", "överexponeras", "överexponerats", "överfallas", "överfallits", "överfalls", "överflödades", "överflyglades", "överflyglas", "överflyttades", "överflyttas", "överfölls", "överföras", "överfördes", "överförs", "överförts", "överfyllas", "övergavs", "överges", "övergetts", "övergivas", "övergivits", "överglänses", "överglänstes", "övergöts", "överhettades", "överhettas", "överinskrivas", "överklagades", "överklagas", "överklagats", "överklistras", "överkompenseras", "överlagras", "överlämnades", "överlämnas", "överlämnats", "överlappas", "överlåtas", "överlåtits", "överlåts", "överläts", "överlevas", "överlistas", "övermannades", "övermannas", "övermannats", "övermättas", "överordnas", "överös", "överösas", "överöses", "överöstes", "överösts", "överprocuderas", "överprövas", "överprövats", "överpudras", "överräcks", "överräcktes", "överraskades", "överraskas", "överraskats", "överröstades", "överröstas", "överrumplades", "överrumplas", "överrumplats", "översändas", "översändes", "översänts", "översättas", "översattes", "översatts", "översätts", "överskattades", "överskattas", "överskattats", "översköljas", "översköljs", "översköljts", "överskreds", "överskridas", "överskridits", "överskrids", "överskuggades", "överskuggas", "överskuggats", "överspolas", "överstigas", "överstigs", "överstimuleras", "översvämmades", "översvämmas", "översvämmats", "övertäckas", "övertäcks", "övertäcktes", "övertages", "övertagits", "övertalades", "övertalas", "övertalats", "övertas", "övertecknades", "övertecknas", "övertecknats", "övertogs", "övertolkas", "övertolkats", "överträdas", "överträdes", "överträffades", "överträffas", "överträffats", "övertrasserades", "övertrasseras", "övertrumfas", "övertygades", "övertygas", "övertygats", "överutnyttjades", "överutnyttjas", "övervägas", "övervägdes", "övervägs", "övervägts", "övervakades", "övervakas", "övervakats", "överväldigades", "överväldigas", "överväldigats", "övervältras", "övervämmas", "övervärderas", "övervärderats", "övervinnas", "övervinns", "övervintras", "övervunnits", "oxideras", "påannonserades", "påannonseras", "påbjöds", "påbjudes", "påbjudits", "påbjuds", "påbörjades", "påbörjas", "påbörjats", "pacificeras", "packades", "packas", "packats", "pådyvlades", "pådyvlas", "påfodras", "påföras", "påförs", "påförts", "påfrestas", "påhejas", "påkallas", "påkallats", "paketeras", "paketerats", "påkördes", "påläggas", "påläggs", "pålagts", "pålas", "pålats", "pallas", "pallats", "palmas", "påmindes", "påminnas", "påminns", "påmints", "paneras", "pangas", "pantas", "pantsattes", "pånyttfödas", "påområdes", "påpekades", "påpekas", "påpekats", "påprackas", "parades", "paraferades", "påräknas", "parallellkopplades", "parallellkopplas", "paralyseras", "paralyserats", "paras", "parats", "pareras", "parkerades", "parkeras", "parkerats", "parodieras", "parras", "parsas", "påskrivs", "påskyndades", "påskyndas", "påskyndats", "passades", "passas", "passats", "passerades", "passeras", "passerats", "passglas", "passiviseras", "påstås", "påståtts", "pasteuriserades", "pastischeras", "påstods", "pastöriseras", "pastöriserats", "påtalades", "påtalas", "påtalats", "patentbeläggs", "patenteras", "patenterats", "påträffades", "påträffas", "påträffats", "patrokles", "patrullerades", "patrulleras", "patrullerats", "pats", "påtvingades", "påtvingas", "påtvingats", "påverkades", "påverkanmotarbetades", "påverkas", "påverkats", "påvisades", "påvisas", "påvisats", "payrolls", "pejlas", "pekades", "pekas", "pekats", "pelleas", "pendlades", "penetrerades", "penetreras", "penetrerats", "pensionerades", "pensioneras", "pensionerats", "penslas", "peppades", "peppas", "peppras", "peps", "perforerades", "perforeras", "permanentades", "permanentas", "permanentats", "permitteras", "permitterats", "perriéres", "persenteras", "personalförsörjs", "personifierades", "personifieras", "personkontrolleras", "personröstas", "perverteras", "pessoas", "pestas", "pestsmittades", "petades", "petas", "petats", "pharmacias", "philos", "piffades", "piffas", "piggats", "pihelgas", "pilats", "pillas", "pillras", "pinades", "pinas", "pinats", "pints", "pips", "piskades", "piskas", "piskats", "pizzasås", "pjoskades", "placerades", "placeras", "placerats", "pladdrats", "plågades", "plågas", "plågats", "plagieras", "plagierats", "plånades", "planas", "plånas", "planats", "plånats", "planerades", "planeras", "planerats", "plankades", "plankas", "planlades", "planläggs", "planlagts", "planterades", "planteras", "planterats", "plastades", "plastas", "plåstras", "plåstrats", "plåtas", "platsbyggdes", "plattades", "plattats", "plockades", "plockas", "plockats", "plogades", "plogas", "plogats", "plöjas", "plöjdes", "plöjs", "plöjts", "plomberades", "plomberas", "plomberats", "plottats", "plottras", "plottrats", "pluggas", "plundrades", "plundras", "plundrats", "plussades", "plussas", "plussats", "plutades", "poängbedöms", "poängsättas", "poängsattes", "poängsatts", "poängsätts", "poängterades", "poängteras", "poängterats", "poängvärderas", "pocahontas", "pocheras", "pockas", "pokuleras", "polariserades", "polariseras", "polariserats", "polerades", "poleras", "polerats", "polinas", "polisanmälas", "polisanmäldes", "polisanmäls", "polisanmälts", "politiserades", "politiseras", "politiserats", "polydamas", "polymeras", "poneras", "populariserats", "portades", "portas", "portförbjudas", "portförbjudits", "portionerades", "portioneras", "porträtteras", "porträtterats", "porträttrades", "portugaliseras", "positioneras", "postades", "postas", "postats", "posterades", "poststämplades", "postuleras", "prackats", "präglades", "präglas", "präglats", "praktiserades", "praktiseras", "praktiserats", "prånglades", "prånglats", "präntades", "präntas", "prasslas", "prästvigas", "prästvigdes", "prästvigs", "prästvigts", "pratades", "pratas", "pratats", "preciserades", "preciseras", "preciserats", "precisionsstyras", "predestineras", "predikades", "predikas", "predikats", "prefabriceras", "prejas", "premiärprövades", "premiärsändes", "premiäruppförs", "premiärutdelas", "premiärvisades", "premiärvisas", "premiärvisats", "premierades", "premieras", "premierats", "prepareras", "preparerats", "presenterades", "presenteras", "presenterats", "presenteres", "preskriberas", "preskriberats", "pressades", "pressas", "pressats", "prestenteras", "presterades", "presteras", "presterats", "prices", "prickades", "prickas", "prickats", "pricktestades", "primärnoterats", "printas", "prioriterades", "prioriteras", "prioriterats", "pripps", "prisades", "prisas", "prisats", "prisbelönades", "prisbelönas", "prisbelönats", "prissättas", "prissätts", "privatimporterades", "privatimporterats", "privatiserades", "privatiseras", "privatiserats", "problematiseras", "problematiserats", "proceedings", "processas", "processats", "prodotes", "producerades", "produceras", "producerats", "profaneras", "professionaliserades", "professionaliseras", "profeterats", "proffsförklarades", "profilerades", "profileras", "prognosticerades", "prognostiseras", "programmerades", "programmeras", "projekterades", "projekteras", "projicerades", "projiceras", "projicerats", "pröjts", "proklamerades", "proklameras", "proklamerats", "proletariseras", "prolongerades", "prolongeras", "promenerades", "promeneras", "promoverades", "promoveras", "promoverats", "propagerades", "propageras", "propangas", "proportioneras", "proppades", "proppas", "prosperas", "prostituerades", "protokollfördes", "provades", "prövades", "provas", "prövas", "provats", "prövats", "provbyggs", "provflugits", "provfotograferas", "provköras", "provkördes", "provkörs", "provmålats", "provmäts", "provocerades", "provoceras", "provocerats", "provsås", "provsittas", "provsmakades", "provsmakas", "provtagas", "prsenterats", "prutades", "prutas", "prutats", "pryddes", "pryds", "pryglas", "prytts", "pseudomonas", "publicerades", "publiceras", "publicerats", "publiserades", "pudrats", "puffas", "pulvriserades", "pulvriserats", "pumpades", "pumpas", "pumpats", "pundits", "punktades", "punkterades", "punkteras", "punkterats", "punktmarkerats", "purprades", "pussades", "pussas", "pussats", "pusslades", "pusslas", "pustas", "putsades", "putsas", "putsats", "puttades", "puttas", "puttats", "puttrades", "pyntas", "pyntats", "pysslades", "pysslas", "pytsas", "pytsats", "rabatteras", "rabblas", "räckes", "räcktes", "räckts", "radades", "radas", "rådas", "radats", "räddades", "räddas", "räddats", "råddes", "raderades", "raderas", "raderats", "rädes", "rådfrågats", "radiaksmittades", "radikaliserades", "radikaliseras", "radikaliserats", "radonsanerats", "råds", "raffineras", "raffinerats", "rafsas", "raggades", "raggats", "raggefanns", "rakades", "rakas", "rakats", "råknas", "raljerades", "raljeras", "ramades", "ramas", "ramats", "rammades", "rammas", "rånades", "rånas", "rånats", "rändes", "rangeras", "rangordnades", "rangordnas", "rankades", "rankas", "rankats", "rankingras", "rannsakades", "rannsakas", "rannsakats", "ransonerades", "ransoneras", "rapporterades", "rapporteras", "rapporterats", "rasas", "raserades", "raseras", "raserats", "rasslades", "rastas", "ratades", "rätades", "ratas", "rätas", "ratatas", "ratats", "rätats", "ratificerades", "ratificeras", "ratificerats", "ratifieras", "rationaliseras", "rationaliserats", "rattades", "rättades", "rättas", "rättats", "ravennas", "reades", "readymades", "reageras", "reaktiveras", "realiserades", "realiseras", "realiserats", "reas", "reavinstbeskattas", "rebbes", "recenserades", "recenseras", "recenserats", "reciteras", "redas", "redbergslids", "reddes", "redigerades", "redigeras", "redigerats", "redogjordes", "redogjorts", "redogörs", "redovisades", "redovisas", "redovisats", "reds", "reducerades", "reduceras", "reducerats", "refererades", "refereras", "refererats", "reflekterades", "reflekteras", "reflexräddades", "reformerades", "reformeras", "reformerats", "refuserades", "refuseras", "refuserats", "regelsattes", "regenereras", "regerades", "regeras", "regerats", "regeringsbehandlas", "regisserades", "regisseras", "regisserats", "registeras", "registerkontrolleras", "registrerades", "registreras", "registrerats", "registreringsbesiktigas", "reglats", "reglerades", "regleras", "reglerats", "regummeras", "rehabiliterades", "rehabiliteras", "rehabiliterats", "reintegreras", "reinvesteras", "rekapituleras", "rekatolicerades", "reklamas", "reklamerades", "reklameras", "reklamfinansieras", "reklamplats", "reklamspots", "rekommederas", "rekommenderades", "rekommenderas", "rekommenderats", "rekommeneras", "rekonstruerades", "rekonstrueras", "rekonstruerats", "rekontextualiseras", "rekryterades", "rekryteras", "rekryterats", "rekryteringsbas", "rekvierades", "rekvirerades", "rekvireras", "rekvirerats", "relanserades", "relaterades", "relateras", "relaterats", "relativiserades", "relativiseras", "relegerades", "relegeras", "relegerats", "remissbehandlades", "remissbehandlas", "remissbehandlats", "remitterades", "remitteras", "remitterats", "remixas", "renas", "renats", "rengjordes", "rengjorts", "rengöras", "rengörs", "rennes", "renodlades", "renodlas", "renodlats", "renoverades", "renoveras", "renoverats", "renrakats", "rensades", "rensas", "rensats", "renskrapas", "renskrivas", "rentvås", "reopererades", "reparerades", "repareras", "reparerats", "repas", "repatrierades", "repatrieras", "repats", "repererades", "repeterades", "repeteras", "repeterats", "reppas", "reprenteras", "representerades", "representeras", "representerats", "repriserades", "repriseras", "reprisvisas", "reproduceras", "reproducerats", "res", "resas", "reservades", "reserverades", "reserveras", "reserverats", "reserves", "reses", "resonerades", "resoneras", "respekterades", "respekteras", "respekterats", "restaurerades", "restaureras", "restaurerats", "restes", "rests", "resulterades", "results", "retts", "returnerades", "returneras", "returnerats", "retuscherades", "retuscheras", "retuscherats", "revalveras", "revbensopereras", "reviderades", "revideras", "reviderats", "revolutioneras", "revolutionerats", "revs", "rhodes", "rias", "ridas", "rids", "riggades", "riggas", "riksdagsbehandlas", "riktades", "riktas", "riktats", "rimmas", "ringades", "ringaktas", "ringas", "ringats", "ringbarkas", "ringdes", "ringmärks", "ringmärktes", "rings", "ringts", "risades", "risas", "risats", "riseras", "riskerades", "riskeras", "riskerats", "rispades", "rispats", "ristades", "ristas", "ristats", "ritades", "ritas", "ritats", "ritualiserades", "ritualiseras", "rivas", "rives", "rivits", "rivs", "roades", "roas", "roats", "robotbesköts", "robotiseras", "rockas", "roddes", "rohmers", "rojas", "röjas", "röjdes", "röjs", "röjts", "rökas", "rökfylldes", "roks", "röks", "rökskadas", "röktes", "rökts", "rollas", "rollbesatts", "rollerblades", "romanes", "romantiserades", "romantiseras", "rommas", "röntes", "röntgades", "röntgas", "röntgats", "rönts", "ropades", "ropas", "ropats", "röras", "rördes", "röres", "rörs", "rörts", "ros", "rös", "rosades", "rosafärgas", "rosas", "rosats", "rosenqvists", "rostades", "röstades", "rostas", "röstas", "rostats", "röstats", "rostkyddsbehandlas", "rostskyddsbehandlas", "rotades", "rotas", "rötas", "rotats", "rövades", "rövas", "rövats", "rovdjursdödas", "rubbades", "rubbas", "rubbats", "rubricerades", "rubriceras", "rubricerats", "ruckades", "ruckas", "ruckats", "rufsats", "ruggats", "ruinerades", "ruineras", "ruinerats", "rules", "rullades", "rullas", "rullats", "rumlades", "rundades", "rundas", "rundats", "rusades", "ruskades", "ruskas", "rustades", "rustas", "rustats", "ryckas", "rycks", "rycktes", "ryckts", "ryggskadas", "ryktades", "ryktas", "ryktats", "rymms", "rynkades", "rynkas", "rynkats", "sabbats", "sablades", "sablas", "sablats", "saboterades", "saboteras", "saboterats", "såddes", "sades", "saftades", "saftas", "sågades", "sågas", "sägas", "sågats", "säges", "sägs", "sagts", "säjs", "sakades", "sakas", "sakbehandlas", "säkerhetsklassas", "säkerhetsklassats", "säkerhetskontrollerats", "säkerhetslås", "säkerhetsprövas", "säkerställas", "säkerställs", "säkerställts", "saknades", "saknas", "saknats", "säkrades", "säkras", "säkrats", "saktades", "saktas", "såldes", "salinas", "säljas", "säljes", "säljs", "sållades", "sållas", "sållats", "saltades", "saltas", "saltats", "sålts", "saluföras", "salufördes", "saluförs", "samägas", "samägs", "sambos", "samhälls", "samköras", "samlades", "samlas", "samlats", "samlokaliserats", "sammanbindas", "sammanblandas", "sammanblandats", "sammanbringats", "sammanbyggts", "sammandragits", "sammandrogs", "sammanfattades", "sammanfattas", "sammanfattats", "sammanflätades", "sammanflätas", "sammanfogades", "sammanfogas", "sammanfogats", "sammanföras", "sammanfördes", "sammanförs", "sammanförts", "sammanhålles", "sammanhålls", "sammanjämkas", "sammankallades", "sammankallas", "sammankallats", "sammanknippades", "sammanknippas", "sammankopplas", "sammanlänkas", "sammanlyses", "sammansatts", "sammanslås", "sammansmälts", "sammanställas", "sammanställdes", "sammanställs", "sammanställts", "sammansvetsas", "sammanvägas", "sammanvägs", "sammanvävas", "sammanvigs", "samordnades", "samordnas", "samordnats", "samövas", "sampas", "samplades", "sams", "samtalas", "samverkas", "sandas", "sändas", "sandblästrats", "sändes", "sänds", "sanerades", "saneras", "sanerats", "sängplats", "sänkas", "sänkes", "sänks", "sänktes", "sanktioneras", "sanktionerats", "sänkts", "sänts", "saperas", "sårades", "såras", "säras", "sårats", "särbehandlades", "särbehandlas", "särbehandlats", "särbeskattas", "sargades", "sargas", "sargats", "särmärkas", "särnoteras", "sarrautes", "särredovisas", "särskildes", "särskiljas", "sas", "sås", "satanas", "satsades", "satsas", "satsats", "sättas", "sattes", "sättes", "satts", "såtts", "sätts", "scarletts", "schabblas", "schablonberäknas", "schabloniserats", "schackras", "schackrats", "schaktades", "schaktas", "schasas", "schemalades", "schemaläggas", "schemaläggs", "schnapps", "schweppes", "scorseses", "scoutades", "scoutats", "seedades", "seedas", "seglades", "seglarskolas", "seglas", "seglats", "segregerats", "sehlstedts", "sehnsuchts", "sekretessbeläggs", "sekretessbelagts", "sekretessläggs", "sekretesstämplas", "sekulariserades", "sekulariseras", "sekunderades", "sekunderas", "sekvenseras", "selekteras", "senarelades", "senareläggas", "senareläggs", "senarelagts", "sentimentaliserades", "separerades", "separeras", "separerats", "seriekopplas", "serieproducerades", "serietillverkas", "serietillverkats", "servas", "serverades", "serveras", "serverats", "setts", "severas", "sexdubblades", "sexfaldigats", "sextrakasseras", "sfinnas", "shardiks", "shinglas", "shonas", "sias", "sicas", "sidenförsätts", "sidoackrediteras", "sidoordnas", "sidsteppades", "sifferbestämmas", "signalerades", "signaleras", "signaliserades", "signerades", "signeras", "signerats", "siktades", "siktas", "siktats", "silades", "silas", "simmas", "simuleras", "simulerats", "sindings", "sinkades", "sinkas", "sinkats", "sintras", "sirpas", "sittas", "sivas", "sjabblades", "sjabblas", "självfinansieras", "självregleras", "sjanghajas", "sjasas", "sjöds", "sjöngs", "sjösättas", "sjösattes", "sjösatts", "sjösätts", "sjufaldigats", "sjukdomsförklarats", "sjukskrivas", "sjukskrivits", "sjukskrivs", "sjungas", "sjunges", "sjungits", "sjungs", "skadades", "skadas", "skådas", "skadats", "skådats", "skades", "skaffades", "skaffas", "skaffats", "skakades", "skakas", "skakats", "skäktas", "skalades", "skålades", "skalas", "skålas", "skalats", "skalkeas", "skallades", "skållas", "skällas", "skälldes", "skälls", "skålslipas", "skambeläggs", "skämdes", "skamfilats", "skämmas", "skäms", "skämtades", "skämtas", "skämts", "skändades", "skandaliserades", "skändas", "skändats", "skanderades", "skanderas", "skänkas", "skänkes", "skänks", "skänktes", "skänkts", "skapades", "skåpades", "skapas", "skåpas", "skapats", "skåras", "skäras", "skäres", "skärhöras", "skärmades", "skärmas", "skärpas", "skarpnäcks", "skärps", "skärptes", "skärpts", "skars", "skärs", "skärscannrats", "skärskådades", "skärskådas", "skarvades", "skarvas", "skattades", "skattas", "skattebefrias", "skattefinansieras", "skatteprivilegieras", "skattesubventineras", "skattesubventioneras", "skattlades", "skavas", "skavdes", "skavts", "skenbeskattas", "skeppades", "skeppas", "skeppats", "skickades", "skickas", "skickats", "skickliggjordes", "skiftades", "skiftas", "skiftats", "skiktas", "skildes", "skildrades", "skildras", "skildrats", "skiljas", "skiljdes", "skiljs", "skiljts", "skilldes", "skils", "skilts", "skingrades", "skingras", "skingrats", "skinnades", "skinnas", "skinnheads", "skins", "skipades", "skipas", "skipats", "skippades", "skissades", "skissas", "skissats", "skisserades", "skisseras", "skisserats", "skivas", "skivats", "skivinspelas", "skjöts", "skjutas", "skjutits", "skjuts", "skjutsades", "skjutsas", "skockades", "skockas", "skockats", "skogas", "skogås", "skojades", "skojas", "skojats", "skolades", "skolas", "skolats", "sköljas", "sköljdes", "sköljs", "sköljts", "skolmognadstestas", "skonades", "skonas", "skonats", "skönjas", "skönjdes", "skönjes", "skönjs", "sköntaxeras", "sköras", "skördades", "skördas", "skördats", "skörtats", "skotas", "skötas", "sköts", "skottas", "skottats", "sköttes", "skötts", "skottskadades", "skottskadas", "skottskadats", "skovlades", "skövlades", "skovlas", "skövlas", "skövlats", "skräddarsyddes", "skräddarsys", "skräddarsytts", "skräddas", "skrålades", "skrålas", "skrämdes", "skrämmas", "skräms", "skränas", "skrapades", "skrapas", "skrapats", "skrattades", "skrattas", "skrattats", "skrävlas", "skreds", "skreks", "skrevs", "skrikas", "skriks", "skringrats", "skrinlades", "skrinläggas", "skrinläggs", "skrinlagts", "skrivas", "skrives", "skrivits", "skrivs", "skrotades", "skrotas", "skrotats", "skröts", "skrubbades", "skrubbas", "skrubbats", "skrudas", "skruvades", "skruvas", "skruvats", "skrynklades", "skuffades", "skuffas", "skuffats", "skuggades", "skuggas", "skuggats", "skuggboxades", "skuggboxas", "skuldbeläggs", "skulpterades", "skulpteras", "skulpterats", "skummas", "skummats", "skurades", "skuras", "skurats", "skurits", "skvallrades", "skvallras", "skvalpas", "skvätts", "skyddades", "skyddas", "skyddats", "skyddes", "skyfflades", "skyfflas", "skyfflats", "skylas", "skyles", "skyllas", "skylldes", "skylls", "skyllts", "skyls", "skyltades", "skyltas", "skyltats", "skymdes", "skymfas", "skymfats", "skymmas", "skyms", "skymtades", "skymtas", "skymts", "skyndas", "skyttegilles", "släckas", "släcks", "släcktes", "släckts", "slaktades", "slaktas", "slaktats", "slammades", "slammas", "slamras", "slamsas", "slängas", "slängdes", "slänges", "slängs", "slängts", "släpades", "släpas", "släpats", "slappades", "släppas", "släppptes", "släpps", "släpptes", "släppts", "slarvades", "slarvas", "slarvats", "slås", "slätades", "slätas", "slätats", "slåttrades", "slåttras", "slavas", "slets", "slickades", "slickas", "slickats", "slipades", "slipas", "slipats", "slitas", "slites", "slitits", "slits", "slopades", "slopas", "slopats", "slösas", "slösats", "slöts", "slukades", "slukas", "slukats", "slumpades", "slumpas", "slumsaneras", "slungades", "slungas", "slungats", "slussades", "slussas", "slussats", "slutades", "slutas", "slutavverkades", "slutbearbetas", "slutbehandlas", "slutbetalades", "slutbetalas", "slutes", "slutföras", "slutfördes", "slutförhandlades", "slutförhandlas", "slutförhandlats", "slutförs", "slutförts", "slutförvaras", "slutits", "slutlevereras", "slutmonteras", "slutnoterades", "slutrepeteras", "sluts", "slutspelas", "sluttestas", "småbråkas", "smädas", "småfräs", "småfrös", "småjävlas", "smakas", "smaksättas", "smaksättes", "smaksatts", "smaksätts", "smakvarieras", "smälldes", "smalls", "smälls", "smällts", "smalnas", "smältas", "smältes", "smälts", "småretades", "smekas", "smeks", "smektes", "smetades", "smetas", "smetats", "smets", "smidas", "smiddes", "smides", "smidits", "smids", "sminkades", "sminkas", "smiskas", "smittades", "smittas", "smittats", "smitts", "smögs", "smordes", "smörjas", "smörjs", "smorts", "smugglades", "smugglas", "smugglats", "smugits", "smulades", "smulas", "smulats", "smusslades", "smusslas", "smusslats", "smutsades", "smutsas", "smutsats", "smutskastas", "smuttas", "smyckades", "smyckas", "smyckats", "smygas", "smygavlyssnades", "smygfilmades", "smygits", "smygs", "snabbbehandlas", "snabbehandlas", "snabbfrysas", "snabbinkallades", "snabbinkallas", "snabbkäftades", "snabbkopieras", "snabbladdas", "snabbredigeras", "snabbreparerats", "snabbstoppades", "snabbstoppas", "snabbtolkas", "snabbutbildas", "snabbutredas", "snabbutreds", "snackades", "snackas", "snackats", "snålas", "snålkodas", "snappades", "snappas", "snarats", "snärjas", "snärjdes", "snärjs", "snärjts", "snattas", "snävas", "snävats", "snedgås", "snedvridas", "snedvridits", "snedvrids", "sneglas", "snickrades", "snickrats", "sniffas", "snittas", "snöpas", "snördes", "snörptes", "snörs", "snörts", "snörvlades", "snos", "snotts", "snubblas", "snuddades", "snurrades", "snurras", "snuttas", "snuvades", "snuvas", "snuvats", "snyftades", "snyggas", "snyggats", "snyltas", "soares", "socialdelegerades", "socialiseras", "socialiserats", "socialistes", "sockras", "sockrats", "södras", "sögs", "sökas", "sökes", "söks", "söktes", "sökts", "sölades", "solas", "solkas", "solkats", "solochvåras", "sonas", "soncks", "sönderdelas", "sönderskakas", "sönderslets", "sönderslitas", "sönderstyckades", "sondmatades", "söndras", "songs", "sopades", "sopas", "sopats", "söps", "sörjdes", "sörjes", "sörjs", "sorlades", "sorlas", "sörplas", "sorterades", "sorteras", "sorterats", "sotades", "sötades", "sotas", "sötas", "sötats", "sovas", "sövas", "sövdes", "sovelbitarnas", "sovras", "sovs", "sövs", "sövts", "späckas", "spacklas", "spädas", "spåddes", "späddes", "späds", "spaghettisås", "spaltades", "spaltas", "spanas", "spändes", "spångas", "spännas", "spanns", "spänns", "spänts", "sparades", "spårades", "sparas", "spåras", "sparats", "spårats", "sparkades", "sparkas", "sparkats", "spärrades", "spärras", "spärrats", "spärrförklarats", "spås", "späs", "spåtts", "spätts", "specialbeställas", "specialbeställdes", "specialbeställts", "specialbevakas", "specialbyggdes", "specialbyggts", "specialdesignats", "specialdestineras", "specialdrillas", "specialgranskades", "specialgranskats", "specialinretts", "specialiseras", "specialistutbildades", "specialkonstruerades", "speciallottats", "specialpreparerats", "specialrekryterats", "specialriktats", "specialskrevs", "specialskrivs", "specialstuderades", "specialtillverkas", "specialutbildas", "specialutbildats", "specificerades", "specificeras", "specificerats", "speedas", "speglades", "speglas", "speglats", "spejas", "spekulerades", "spekuleras", "spekulerats", "spelades", "spelas", "spelats", "spenderades", "spenderas", "spenderats", "spetsades", "spetsas", "spetsats", "spikades", "spikas", "spikats", "spillas", "spilldes", "spills", "spillts", "spinnas", "spinns", "spioneras", "spionmisstänktes", "spiras", "spisas", "spjälkades", "spjälkas", "splitsas", "splitterskadades", "splittrades", "splittras", "splittrats", "spolades", "spolas", "spolats", "spolierades", "spolieras", "spolierats", "sponsrades", "sponsras", "sponsrats", "spörjs", "sporrades", "sporras", "spörs", "sports", "spottades", "spottas", "spräckas", "spräcks", "spräcktes", "spräckts", "språktestas", "sprängas", "sprangs", "sprängs", "sprängts", "sprättades", "sprättas", "sprätts", "sprayas", "sprayats", "spreds", "sprejas", "sprejats", "spridas", "spriddes", "sprides", "spridits", "sprids", "springas", "springs", "spritas", "spritsas", "spritsats", "spritts", "sprödvärmts", "sprungits", "sprutades", "sprutas", "spunnits", "spurtades", "stabiliserades", "stabiliseras", "stabiliserats", "stäckas", "stacks", "stäcktes", "städades", "städas", "städats", "städes", "stadfästas", "stadfästes", "stadfästs", "stadgas", "stadgats", "städslades", "städslas", "städslats", "stagades", "stagas", "stajlas", "stakades", "stakas", "stakats", "stålas", "stallas", "ställas", "ställdes", "ställes", "ställs", "ställts", "stals", "stämdes", "stammas", "stämmas", "stampades", "stampas", "stämplades", "stämplas", "stämplats", "stäms", "stämts", "ständigtmåstegöras", "stångades", "stångas", "stängas", "stångats", "stängdes", "stängs", "stängts", "stånkas", "stänkas", "stänkts", "stannades", "stansas", "stansats", "staplades", "staplas", "staplats", "starkars", "stärkas", "stärks", "stärktes", "stärkts", "startades", "startas", "startats", "startgas", "stås", "stationerades", "stationeras", "stationerats", "statuerades", "statueras", "stavades", "stavas", "stavats", "stävjas", "stegas", "steglas", "stegrades", "stegras", "stegrats", "stekas", "steks", "stektes", "stekts", "stenades", "stenas", "stencilerats", "stenungsundshems", "steriliseras", "stickas", "stickats", "sticks", "stiftades", "stiftas", "stiftats", "stigmatiserades", "stigmatiseras", "stiliserats", "stillas", "stillats", "stills", "stimmades", "stimulerades", "stimuleras", "stimulerats", "stipendierats", "stipulerades", "stipuleras", "stjälas", "stjälpas", "stjälps", "stjälptes", "stjäls", "stockas", "stockholmsanpassats", "stockholmutsätts", "stöddes", "stödjas", "stöds", "stöldanmäldes", "stöldanmälts", "stöldresas", "stomiopererades", "stomiopereras", "stöpas", "stoppades", "stoppas", "stoppats", "stopppades", "stöps", "stöptes", "stöpts", "störas", "stördes", "storklas", "stormades", "stormas", "stormats", "stormfälldes", "stormtrivas", "stormtrivs", "störs", "storstädas", "storstädats", "störtades", "störtas", "störtats", "stortrivas", "stortrivdes", "stortrivs", "stortrutades", "störts", "stötas", "stötes", "stöts", "stöttades", "stöttas", "stöttats", "stöttes", "stötts", "sträckas", "sträcks", "sträcktes", "sträckts", "straffades", "straffas", "straffats", "straffbeläggas", "straffbeskattas", "straffsanktioneras", "strålas", "strålbehandlas", "strålbehandlats", "strålningstestas", "strålskadades", "stramades", "stramas", "stramats", "strandades", "strandats", "strandsattes", "strävas", "streckas", "strejkas", "strejkats", "stressades", "stressas", "stretchats", "strids", "strilas", "strimlas", "strimlats", "strimmades", "ströddes", "ströks", "strömlinjeformas", "ströps", "strös", "strötts", "strukits", "strukturerades", "struktureras", "strukturerats", "strukturrationaliserades", "strykas", "strykes", "stryks", "strypas", "strypes", "stryps", "stryptes", "strypts", "stuckits", "studerades", "studeras", "studerats", "stuffas", "stukades", "stukas", "stukats", "stulits", "stunts", "stuvades", "stuvas", "stuvats", "styckades", "styckas", "styckats", "stylades", "stylas", "stylats", "stympades", "stympas", "stympats", "styras", "styrdes", "styrkas", "styrks", "styrktes", "styrkts", "styrs", "styrts", "sublimeras", "subtraheras", "subventionerades", "subventioneras", "subventionerats", "suckas", "suddades", "suddas", "suddats", "sufflerats", "sugas", "suges", "sugits", "sugs", "summerades", "summeras", "summerats", "supes", "supits", "sups", "surkörs", "surrades", "surras", "susades", "suspenderades", "suspenderas", "suspenderats", "svagbegåvades", "svaldes", "sväljas", "sväljs", "svalkas", "svälldes", "svältas", "svälts", "svämmas", "svämmats", "svängdes", "svängs", "svängts", "svanskuperas", "svarades", "svaras", "sväras", "svärs", "svärtades", "svärtas", "svärtats", "svartlistades", "svartlistas", "svartlistats", "svartmålades", "svartmålas", "svartmålats", "svedas", "svekivs", "sveks", "svennevads", "svepas", "svepes", "sveps", "sveptes", "svepts", "svetlas", "svetsades", "svetsas", "svikas", "svikits", "sviks", "svinas", "svingades", "svingas", "svors", "svurits", "swandes", "syddes", "sydgas", "syds", "syftas", "sykes", "syltades", "syltas", "symboliserades", "symboliseras", "sympatilockoutas", "sympatiseras", "synades", "synats", "syndats", "synkroniseras", "synliggjordes", "synliggjorts", "synliggöras", "synliggörs", "syntetiserats", "syresättas", "syresätts", "syrsätts", "sys", "sysselsättas", "sysselsattes", "sysselsätts", "sytts", "tackades", "tackas", "täckas", "tacklades", "tacklas", "täcks", "täcktes", "täckts", "tagas", "tages", "tagits", "tags", "talades", "talas", "tålas", "talats", "tåldes", "tallas", "tallriksserveras", "tåls", "talts", "tämjas", "tämjs", "tämjts", "tändas", "tändes", "tänds", "tångas", "tangerades", "tangeras", "tangerats", "tangiers", "tångonduleras", "tänjas", "tänjdes", "tänjes", "tänjs", "tänjts", "tankas", "tänkas", "tänkes", "tänks", "tänkts", "tänts", "tapetserades", "tapetserats", "tappades", "tappas", "tappats", "täpps", "tårades", "tareras", "tärnas", "tärts", "tarvas", "tas", "tasslades", "tasslas", "tätades", "tätas", "tävlades", "tävlas", "tävlats", "taxeras", "taxerats", "technologies", "tecknades", "tecknas", "tecknats", "tegs", "teiresias", "tejakulas", "tejpades", "tejpas", "tejpats", "teknologiseras", "telefaxbekräftas", "telefonavlyssnas", "telefonerades", "telefonintervjuades", "telefonterroriseras", "telegraferats", "televiserades", "televiseras", "telias", "telomeras", "tematiserades", "tematiseras", "tempereras", "terminerats", "terminssäkras", "terroriserades", "terroriseras", "terroriserats", "terroriststämplas", "terroriststämplats", "testades", "testamenterats", "testas", "testats", "testkörs", "textas", "thorgils", "tidigarelades", "tidigareläggas", "tidigareläggs", "tidigarelagts", "tidsbegränsas", "tidsbegränsats", "tidsbestämdes", "tidsbestämmas", "tidsbestäms", "tidsbestämts", "tidsflödes", "tidsordnats", "tietotehdas", "tigits", "tigs", "tillades", "tillagas", "tillägas", "tilläggas", "tilläggs", "tilläggsdebiteras", "tillägnades", "tillägnas", "tillägnats", "tillämmpas", "tillämpades", "tillämpas", "tillämpats", "tillåtas", "tillåtes", "tillåtits", "tillåts", "tilläts", "tillbads", "tillbakabildas", "tillbakabildats", "tillbakavisades", "tillbakavisas", "tillbakavisats", "tillbakes", "tillbes", "tillbetts", "tillbringades", "tillbringas", "tillbyggts", "tillbytas", "tilldelades", "tilldelas", "tilldelats", "tilldömas", "tilldömdes", "tilldöms", "tilldömts", "tillerkändes", "tillerkännas", "tillerkänns", "tillerkänts", "tillfångatagits", "tillfångatas", "tillfångatogs", "tillfogades", "tillfogas", "tillfogats", "tillföras", "tillfördes", "tillförs", "tillförsäkras", "tillförsäkrats", "tillförts", "tillfrågades", "tillfrågas", "tillfrågats", "tillfredsställas", "tillfredsställdes", "tillfredsställs", "tillgivits", "tillgodoräknas", "tillgodosågs", "tillgodoses", "tillgodosetts", "tillgreps", "tillgripas", "tillgripes", "tillgripits", "tillgrips", "tillhållas", "tillhålls", "tillhandahållas", "tillhandahålles", "tillhandahålls", "tillhandahölls", "tillhandhölls", "tillhölls", "tillintetgjorts", "tillintetgörs", "tillkallades", "tillkallas", "tillkallats", "tillkännagavs", "tillkännages", "tillkännagetts", "tillkännagivits", "tillläggas", "tilllämpas", "tilllämpats", "tilllåtas", "tilllåtits", "tilllåts", "tillläts", "tillmätas", "tillmätits", "tillmäts", "tillmättes", "tillmätts", "tillmötesgås", "tillönskas", "tillordnas", "tillråddes", "tillrådes", "tillråds", "tillrättaläggs", "tillrättavisas", "tillredas", "tillreds", "tillretts", "tillryggalades", "tillsägs", "tillsagts", "tillsamamns", "tillsammamns", "tillsammas", "tillsammns", "tillsändas", "tillsas", "tillsättas", "tillsattes", "tillsatts", "tillsätts", "tillses", "tillskapas", "tillskapats", "tillskjuts", "tillskrevs", "tillskrivas", "tillskrives", "tillskrivits", "tillskrivs", "tillspetsades", "tillspetsas", "tillspetsats", "tillställas", "tillställdes", "tillställs", "tillställts", "tillstås", "tillstyrks", "tillstyrktes", "tillstyrkts", "tilltalades", "tilltalas", "tilltalats", "tillträdas", "tilltros", "tillvaratagas", "tillvaratagits", "tillvaratas", "tillvaratogs", "tillverkades", "tillverkas", "tillverkats", "tillvitades", "tillvitas", "tillvitats", "tillyxas", "tinas", "tinats", "tingades", "tingas", "tingats", "tiodubblades", "tiodubblas", "tiodubblats", "tiofaldigades", "tiofaldigas", "tiofaldigats", "tippades", "tippas", "tippats", "tipsades", "tipsas", "tipsats", "tisslades", "tisslas", "tittas", "titulerades", "tituleras", "tivs", "tjafsas", "tjågas", "tjänades", "tjänas", "tjänats", "tjatades", "tjatas", "tjatats", "tjoas", "tjubajs", "tjudras", "tjusades", "tjusas", "tjusats", "tjuvkopplas", "tjuvlästes", "tjyvröktes", "togs", "töjdes", "töjs", "tolererades", "tolereras", "tolererats", "tolkades", "tolkas", "tolkats", "tolvdubblats", "tolvfaldigats", "tömdes", "tömmas", "tommingas", "töms", "tömts", "tonades", "tonas", "tonats", "toppades", "toppas", "toppats", "topplaceras", "topprenoverats", "toppseedats", "toppstyras", "tordas", "torgföras", "torgfördes", "torgförs", "torkades", "torkas", "torkats", "tornbas", "torpederades", "torpederas", "torpederats", "torrkokas", "torrlades", "torrläggas", "torrläggs", "torrlagts", "torrmarineras", "torrsättas", "torrsätts", "torterades", "torteras", "torterats", "torts", "totalassimilerats", "totalavvekas", "totalbojkottats", "totaldemolerats", "totalfinansieras", "totalförbjöds", "totalförbjudas", "totalförbjudits", "totalförbjuds", "totalförlamades", "totalförlamas", "totalförstöras", "totalförstördes", "totalförstörs", "totalförstörts", "totalförsvarspliktigas", "totalfredades", "totalintegrerats", "totalredovisas", "totalrenoverades", "totalrenoveras", "totalsaneras", "totalstoppas", "tråcklas", "tradades", "tråddes", "träddes", "traderas", "traderats", "trades", "trådhäftades", "trådhäftas", "träds", "träffades", "träffats", "trafikerades", "trafikeras", "trafikerats", "tragglas", "trakasserades", "trakasseras", "trakasserats", "trakterades", "trakteras", "trakterats", "trampades", "trampats", "tramsas", "tränades", "tränas", "tränats", "trängas", "trängdes", "trängs", "trängts", "transformerades", "transformeras", "transformerats", "transkriberas", "transplanterades", "transplanteras", "transplanterats", "transponeras", "transporterades", "transporteras", "transporterats", "transportvigas", "trappades", "trappas", "trappats", "träs", "trasades", "trasas", "trasats", "trasslas", "trätas", "trätts", "traumatiserats", "travades", "travas", "travats", "travintresserades", "tredskades", "tredskas", "tredubblades", "tredubblas", "tredubblats", "trefaldigades", "trefaldigas", "trefaldigats", "triffids", "trimmades", "trimmas", "trimmats", "trissades", "trissats", "trivialiserats", "trixas", "troddes", "trollades", "trollas", "trollats", "trollbands", "trollbindas", "trollbinds", "trollbundits", "tros", "tröskas", "tröskats", "tröstades", "tröstas", "tröstats", "tröttas", "trotts", "trotzigs", "trubbades", "trubbas", "trubbats", "trumfades", "trumfas", "trummas", "trummats", "trumpetades", "tryckas", "tryckes", "trycks", "trycktes", "tryckts", "tryfferades", "tryfferas", "tryfferats", "tryggas", "trygghetsavtalets", "tryzas", "tsokas", "tsvetajevas", "tubbades", "tubbas", "tudelades", "tudelas", "tuggades", "tuggas", "tuggats", "tugindas", "tuktades", "tuktas", "tuktats", "tullas", "tullbehandlas", "tullinges", "tullvisiteras", "tummas", "tunnades", "tunnas", "tunnats", "turades", "turas", "turats", "turistifierats", "turneras", "tusendubblats", "tussas", "tutades", "tutas", "tvåddes", "tvålades", "tvangs", "tvångsanslutas", "tvångsavverkades", "tvångsevakuerats", "tvångsförflyttades", "tvångsförflyttas", "tvångsförflyttats", "tvångsförvaltas", "tvångsinlösas", "tvångsintagits", "tvångskommenderades", "tvångskommenderas", "tvångsmatades", "tvångsmatas", "tvångsmatats", "tvångsnedflyttades", "tvångsomhändertagits", "tvångsomhändertas", "tvångsomhändertogs", "tvångspensionerats", "tvångsplaceras", "tvångsrekryterades", "tvångsrekryteras", "tvångstömdes", "tvångsvårdas", "tvångsvårdats", "tvångsvärvas", "tvås", "tvättades", "tvättas", "tvättats", "tvingades", "tvingas", "tvingats", "tvinnades", "tvinnas", "tvistades", "tvistas", "tvistats", "tyas", "tydas", "tyddes", "tydliggjordes", "tydliggjorts", "tydliggöras", "tydliggörs", "tyds", "tyglades", "tyglas", "tyngas", "tyngdes", "tyngs", "tyngts", "typiseras", "tyranniserats", "tyrolersås", "tystades", "tystas", "tystats", "uefas", "ugnsbakas", "undandras", "undanhållas", "undanhållits", "undanhålls", "undanhölls", "undanröjas", "undanröjdes", "undanröjs", "undanröjts", "undantagits", "undantas", "undantogs", "undanträngas", "undanträngs", "underbalanseras", "underblåses", "underblåstes", "underbyggs", "underdånas", "underförstås", "undergrävas", "undergrävdes", "undergrävs", "undergrävts", "underhållas", "underhållits", "underhålls", "underhölls", "underkändes", "underkännas", "underkänns", "underkänts", "underkastades", "underkastas", "underkastats", "underkuvas", "underkuvats", "underlåtas", "underlättades", "underlättas", "underlättats", "underminerades", "undermineras", "underminerats", "underordnades", "underordnas", "underordnats", "underrättades", "underrättas", "underrättats", "underskattades", "underskattas", "underskattats", "underskreds", "underskridas", "underskridits", "underskrids", "undersökas", "undersöks", "undersöktes", "undersökts", "underställas", "underställs", "understöddes", "understödjas", "understöds", "understötts", "underströks", "understrukits", "understrykas", "understryks", "undertecknades", "undertecknas", "undertecknats", "underträffades", "undertryckas", "undertrycks", "undertryckts", "undervärderas", "undervärderats", "undervisades", "undervisas", "undervisats", "undfägnades", "undfägnas", "undfägnats", "undrades", "undras", "undrats", "undsättas", "undsattes", "undvaras", "undveks", "undvikas", "undvikes", "undvikits", "undviks", "unitas", "unlimiteds", "unnades", "unnas", "unnras", "uoppskattas", "upgavs", "upmanades", "uppammas", "uppammats", "upparbetas", "upparbetats", "uppättades", "uppbådades", "uppbådas", "uppbäras", "uppbars", "uppblandas", "uppbrännas", "uppbringades", "uppbringas", "uppbringats", "uppbyggas", "uppbyggnadsfas", "uppdagades", "uppdagas", "uppdagats", "uppdateras", "uppdaterats", "uppdelades", "uppdelas", "uppdragits", "uppdras", "uppdrogs", "uppehållas", "uppehölls", "uppenbarades", "uppenbaras", "uppenbarats", "uppfångades", "uppfångas", "uppfångats", "uppfanns", "uppfattades", "uppfattas", "uppfattats", "uppfinnas", "uppfinns", "uppfödas", "uppföddes", "uppföds", "uppföras", "uppfördes", "uppförs", "uppförstorades", "uppförstoras", "uppförts", "uppfostrades", "uppfostras", "uppfostrats", "uppfunnits", "uppfyllas", "uppfylles", "uppfylls", "uppgavs", "uppges", "uppgetts", "uppgives", "uppgivits", "uppgraderades", "uppgraderas", "uppgraderats", "upphandlades", "upphandlas", "upphandlats", "upphävas", "upphävdes", "upphävs", "upphävts", "upphettades", "upphettas", "upphöjas", "upphöjdes", "upphöjs", "upphöjts", "uppjusteras", "uppjusterats", "uppkallades", "uppkallas", "uppkallats", "upplageras", "uppläsas", "uppläses", "upplästes", "upplästs", "upplåtas", "upplåtes", "upplåtits", "upplåts", "uppläts", "uppletas", "upplevas", "upplevdes", "upplevs", "upplevts", "upplivades", "upplös", "upplösas", "upplöses", "upplöstes", "upplösts", "upplysas", "upplyses", "upplystes", "upplysts", "uppmäksammats", "uppmålas", "uppmanades", "uppmanas", "uppmanats", "uppmandes", "uppmärksammades", "uppmärksammas", "uppmärksammats", "uppmätas", "uppmäts", "uppmättes", "uppmätts", "uppmuntrades", "uppmuntras", "uppmuntrats", "uppnåddes", "uppnås", "uppnåtts", "uppövats", "upppdagas", "uppräknades", "upprätas", "upprättades", "upprättas", "upprättats", "upprätthållas", "upprätthålles", "upprätthållits", "upprätthålls", "upprätthölls", "upprepades", "upprepas", "upprepats", "uppresas", "uppreses", "upprestes", "uppröras", "upprördes", "upprörs", "upprörts", "upprustas", "uppsamlades", "uppsändas", "uppsättas", "uppsattes", "uppsatts", "uppskalas", "uppskattades", "uppskattas", "uppskattats", "uppskjutas", "uppskjutits", "uppskjuts", "uppsköts", "uppslukades", "uppslukas", "uppslukats", "uppsnappas", "uppsökas", "uppsöks", "uppsöktes", "uppsökts", "uppställas", "uppställs", "uppställts", "upptäckas", "upptäcks", "upptäcktes", "upptäckts", "upptagas", "upptages", "upptagits", "upptändes", "upptänds", "upptänts", "upptas", "upptaxeras", "upptecknades", "upptecknats", "upptogs", "uppväckas", "uppväcktes", "uppvägas", "uppvägdes", "uppvägs", "uppvägts", "uppvaktades", "uppvaktas", "uppvaktats", "uppvärderades", "uppvärderas", "uppvärmdes", "uppvisades", "uppvisas", "uppvisningflygas", "urbaniserats", "urgröps", "urholkades", "urholkas", "urholkats", "urkalkas", "urladdas", "urlakats", "ursäktas", "ursäktats", "urskiljas", "urskiljs", "urskuldas", "uruppföras", "uruppfördes", "uruppförs", "uruppförts", "urvattnas", "usurperats", "utandades", "utandas", "utandats", "utannonserades", "utannonseras", "utannonserats", "utanordnats", "utarbetades", "utarbetas", "utarbetats", "utarmades", "utarmas", "utarmats", "utarrenderas", "utbasunerades", "utbasuneras", "utbetalades", "utbetalas", "utbetalats", "utbildades", "utbildas", "utbildats", "utbjöds", "utbjudas", "utbjuds", "utbringades", "utbringas", "utbroderas", "utbyts", "utbyttes", "utbytts", "utdefinieras", "utdelades", "utdelas", "utdelats", "utdikades", "utdömas", "utdömdes", "utdöms", "utdömts", "utdrivas", "utelämnas", "utelämnats", "uteslöts", "uteslutas", "uteslutits", "utesluts", "utestängas", "utestängdes", "utestängs", "utestängts", "utexaminerades", "utexamineras", "utexaminerats", "utfalls", "utfärdades", "utfärdas", "utfärdats", "utfästas", "utfästs", "utflyttas", "utfodras", "utföras", "utfördelas", "utfördes", "utfordras", "utfordrats", "utföres", "utformades", "utformas", "utformats", "utförs", "utförsäkras", "utförsäljas", "utforskades", "utforskas", "utförts", "utfösas", "utfrågades", "utfrågas", "utfrågats", "utgavs", "utges", "utgetts", "utgivits", "utgjordes", "utgjorts", "utgjutits", "utglesas", "utgöras", "utgöres", "utgörs", "uthärdas", "uthyrdes", "utjämnades", "utjämnas", "utjämnats", "utkämpades", "utkämpas", "utkämpats", "utklassats", "utkommenderades", "utkonkurrerades", "utkonkurreras", "utkoras", "utkorats", "utkrävas", "utkrävdes", "utkräves", "utkrävts", "utkrisalliseras", "utkristalliserades", "utkristalliseras", "utkristalliserats", "utkvitteras", "utlades", "utläggas", "utläggs", "utlämnades", "utlämnas", "utlämnats", "utlandsstationerades", "utlandstationerades", "utläs", "utläsas", "utläses", "utlokaliserades", "utlokaliseras", "utlokaliserats", "utlösas", "utlöses", "utlöstes", "utlösts", "utlottades", "utlottas", "utlovades", "utlovas", "utlovats", "utlys", "utlysas", "utlyses", "utlystes", "utlysts", "utmålades", "utmålas", "utmålats", "utmanades", "utmanas", "utmanats", "utmanövrerades", "utmanövreras", "utmärkas", "utmärks", "utmärktes", "utmärkts", "utmätas", "utmäts", "utmattas", "utmättes", "utmätts", "utmejslades", "utminuterades", "utmönstrades", "utmönstras", "utnämnas", "utnämndes", "utnämns", "utnämnts", "utnyttjades", "utnyttjas", "utnyttjats", "utoands", "utökades", "utökas", "utökats", "utövades", "utövas", "utövats", "utpekades", "utpekas", "utpekats", "utplacerades", "utplaceras", "utplacerats", "utplånades", "utplånas", "utplånats", "utplanteras", "utposteras", "utpressas", "utpressats", "utprovades", "utprovas", "utprovats", "utraderades", "utraderas", "utraderats", "utrangeras", "utrangerats", "uträttades", "uträttas", "uträttats", "utredas", "utreddes", "utredningshäktades", "utreds", "utrensades", "utretts", "utropades", "utropas", "utropats", "utrotades", "utrotas", "utrotats", "utrustades", "utrustas", "utrustats", "utrycks", "utrymdes", "utrymmas", "utryms", "utrymts", "utsades", "utsägas", "utsågs", "utsägs", "utsagts", "utsändas", "utsändes", "utsänds", "utsänts", "utsättas", "utsattes", "utsättes", "utsatts", "utsätts", "utses", "utsetts", "utsiras", "utskeppas", "utskiljas", "utslungas", "utslungats", "utsmyckas", "utsöndras", "utspanns", "utspelades", "utspelas", "utspelats", "utspionerades", "utspisades", "utspisas", "utspisats", "utstakades", "utstakats", "utställas", "utställdes", "utställs", "utstöttes", "utsträckas", "utsträcks", "utsträcktes", "utstrålas", "utströs", "uttages", "uttagits", "uttalades", "uttalas", "uttalats", "uttänkas", "uttas", "uttnyttjas", "uttogs", "uttolkas", "uttöms", "utträttats", "uttröttas", "uttryckas", "uttrycks", "uttrycktes", "uttryckts", "utttrycks", "uttunnades", "uttunnas", "uttydas", "uttydes", "uttyds", "utuppfördes", "utvaldes", "utväljas", "utvalts", "utvanns", "utvärderades", "utvärderas", "utvärderats", "utvattnas", "utväxlades", "utväxlas", "utväxlats", "utveckas", "utvecklades", "utvecklas", "utvecklats", "utveklas", "utverkats", "utvidgades", "utvidgas", "utvidgats", "utvinnas", "utvinns", "utvisades", "utvisas", "utvisats", "utvunnits", "uvecklas", "uvecklats", "vaccinerades", "vaccineras", "vaccinerats", "vachettes", "väckas", "väcks", "väcktes", "väckts", "vådaskjuts", "vådasköts", "vades", "vädrades", "vädras", "vädrats", "vågas", "vägas", "vägdes", "väges", "vaggades", "vaggas", "vaggats", "vägledas", "vägleddes", "vägleds", "vägletts", "vägrades", "vägras", "vägrats", "vägs", "vägts", "vakantsätts", "vaktades", "vaktas", "vakuummöras", "valderas", "valdes", "våldtagits", "våldtas", "våldtogs", "valenciennes", "väljas", "väljes", "väljs", "välkomnades", "välkomnas", "välkomnats", "vallades", "vållades", "vallas", "vallås", "vållas", "vållats", "vallfärdas", "valsas", "välsignades", "välsignas", "välsignats", "vältas", "vältes", "vältrades", "vältras", "vältrats", "valts", "välts", "välvdes", "välvs", "vämjdes", "vanäras", "våndades", "vandaliserades", "vandaliseras", "vandaliserats", "våndas", "vändas", "våndats", "vandes", "vändes", "vandkunsts", "vandrades", "vandras", "vänds", "vändsteks", "vanhedrats", "vanhelgas", "vanhelgats", "vänjas", "vankades", "vankats", "vanns", "vanprydas", "vanskötas", "vansköts", "vansköttes", "vansläktades", "vansläktas", "vansläktats", "vanställs", "vanstyrs", "väntades", "väntas", "väntats", "vantolkas", "vantolkats", "vänts", "vanvårdas", "vanvårdats", "våransas", "varas", "vårdades", "vårdas", "vårdats", "värdebas", "värderades", "värderas", "värderats", "värdes", "värdesättas", "värdesattes", "värdesatts", "värdesätts", "värdigades", "värdigas", "vares", "vargas", "varieras", "varierats", "värks", "värmas", "värmdes", "varmhållas", "varmkörs", "varmmanglades", "varmrökas", "värms", "värmts", "varnades", "värnades", "varnas", "värnas", "varnats", "värnats", "vårseglats", "varslades", "varslas", "varslats", "varsnas", "varvades", "värvades", "varvas", "värvas", "varvats", "värvats", "väs", "vaskades", "vaskas", "vaskats", "vässas", "västallierades", "västs", "vattenfyllas", "vattenfylls", "vattengjutits", "vattnades", "vattnas", "vattnats", "vattrades", "vattras", "vävas", "vävdes", "vävs", "vävts", "växlades", "växlas", "växlats", "växtfärgats", "veckats", "vecklades", "vecklas", "vederfaras", "vederfares", "vederfarits", "vederfars", "vederfors", "vederlades", "vederläggas", "vederläggs", "vederlagts", "veks", "veldes", "venables", "vendanges", "veninivas", "venstres", "ventilerades", "ventileras", "ventilerats", "verbaliseras", "verderfarits", "verdes", "verifieras", "verifierats", "verkställas", "verkställdes", "verkställs", "verkställts", "vetas", "veterinärundersökas", "vetetortillas", "vevades", "vevas", "vevats", "vickas", "vidarebefodrades", "vidarebefordrades", "vidarebefordras", "vidarebefordrats", "vidarebehandlas", "vidareexporteras", "vidareexporterats", "vidareförsäljas", "vidareförsäljs", "vidaresändas", "vidaresänts", "vidareutbildas", "vidareutvecklades", "vidareutvecklas", "vidareutvecklats", "videodokumenteras", "videofilmades", "videofilmas", "videofilmats", "videoinspelats", "vidgades", "vidgas", "vidgats", "vidgåtts", "vidhållas", "vidimerades", "vidimeras", "vidkännas", "vidmakthållas", "vidmakthålles", "vidmakthålls", "vidmakthölls", "vidröras", "vidrörs", "vidrörts", "vidtagas", "vidtages", "vidtagits", "vidtalades", "vidtalas", "vidtas", "vidtogs", "viftades", "viftas", "viftats", "vigas", "vigdes", "vigs", "vigts", "vikas", "vikits", "viks", "viktas", "vikts", "vilas", "villfaras", "villkoras", "villkorats", "villkorsändrades", "vilseförts", "vilseledas", "vilseleddes", "vilseleds", "vilseletts", "vimlades", "vimlats", "vindas", "vindfälldes", "vindtorkas", "vineras", "vingklippas", "vinglas", "vinifieras", "vinkades", "vinkas", "vinklades", "vinklas", "vinnas", "vinnes", "vinns", "vinschas", "vinterförvarats", "vinterkonserverats", "vintersportades", "vippas", "virades", "viras", "virats", "virkats", "virvlades", "virvlas", "visades", "visas", "visats", "visiones", "visiterades", "visiteras", "viskades", "viskas", "viskats", "vispades", "vispas", "vispats", "visslades", "visslas", "visslats", "visstes", "visualiseras", "vitaliserades", "vitaliseras", "vitaliserats", "vitesföreläggas", "vitesförelagts", "vitlimmas", "vitsordas", "vittjas", "vittjats", "vittnas", "vittras", "vogts", "voltas", "vördades", "vördas", "voterades", "vrakades", "vräkas", "vräks", "vräktes", "vräkts", "vrålas", "vrängas", "vrängs", "vranjes", "vredgades", "vredgas", "vredgats", "vreds", "vrenskades", "vrenskas", "vridas", "vrides", "vridits", "vrids", "vunnits", "walesas", "walkabouts", "wannadies", "wästfelts", "waves", "williams", "wokas", "yeats", "ylikangas", "ympades", "ympas", "ympats", "yorkbörs", "yppades", "yppas", "yrkades", "yrkas", "ystades", "ytbehandlas", "yttrades", "yttras", "yttrats", "zappas", "zonindelades", "zoomas"];

var passiveEndings = {};

Object.defineProperty(passiveEndings, "__esModule", {
	value: true
});

passiveEndings.default = function () {
	return ["nmak", "nmek", "nir", "nır", "nür", "nur", "nıyor", "niyor", "ndı", "ndi", "ndu", "ndü", "nmış", "nmiş", "nmuş", "nmüş", "necek", "nacak", "nmıştı", "nmişti", "nmuştu", "nmüştü", "nıyordu", "niyordu", "nuyordu", "nüyordu", "necekti", "nacaktı", "nsa", "nse", "nmalı", "nmeli", "nmaz", "nmez", "anmak", "enmek", "ınmak", "inmek", "unmak", "ünmek", "anır", "enir", "ınır", "inir", "unur", "ünür", "anıyor", "eniyor", "ınıyor", "iniyor", "unuyor", "ünüyor", "andı", "endi", "ındı", "indi", "undu", "ündü", "anmış", "enmiş", "ınmış", "inmiş", "unmuş", "ünmüş", "anacak", "enecek", "ınacak", "inecek", "unacak", "ünecek", "ınmıştı", "inmişti", "unmuştu", "ünmüştü", "ınıyordu", "iniyordu", "unuyordu", "ünüyordu", "necekti", "nacaktı", "ansa", "ense", "ınsa", "inse", "unsa", "ünse", "anmalı", "enmeli", "ınmalı", "inmeli", "unmalı", "ünmeli", "anmaz", "enmez", "ınmaz", "inmez", "unmaz", "ünmez", "ılmak", "ilmek", "ulmak", "ülmek", "ılır", "ilir", "ulur", "ülür", "ılınıyor", "iliniyor", "ulunuyor", "ülüyor", "ıldı", "ildi", "uldu", "üldü", "ılmış", "ilmiş", "ulmuş", "ülmül", "ılacak", "ilecek", "ulacak", "ülecek", "ılmıştı", "ilmişti", "ulmuştu", "ülmüştü", "ılıyordu", "iliyordu", "uluyordu", "ülüyordu", "necekti", "nacaktı", "ılsa", "ilse", "ulsa", "ülse", "ılmalı", "ilmeli", "ulmalı", "ülmeli", "ılmaz", "ilmez", "ulmaz", "ülmez"];
};

var nonPassivesTurkish = {};

Object.defineProperty(nonPassivesTurkish, "__esModule", {
	value: true
});
/**
 * Returns a list with nonPassive exceptions for the Turkish passive voice assessment.
 * @returns {Array}             The list with non-passive words
 */
const nonPassivesFullForms = ["övünür", "tutuş", "kullanmak", "lanmak", "baglanmak", "alinmak", "bosanmak", "kaçinmak", "hazirlanmak", "lunmak", "siginmak", "tasinmak", "rlanmak", "sakinmak", "zanmak", "tirmanmak", "inanmak", "arinmak", "kulllanmak", "isinmak", "yikanmak", "ögrenmek", "ogrenmek", "düsünmek", "renmek", "dusunmek", "ünmek", "donmek", "deginmek", "eglenmek", "lenmek", "öğünmek", "deyinmek", "örenmek", "gorunmek", "oğrenmek", "guvenmek", "begenmek", "şünmek", "nmek", "gecinmek", "tukenmek", "kabüllenmek", "öirenmek", "kabulenmek", "sinir", "peynir", "münir", "alinir", "kazanir", "yorumlanir", "kullanir", "uygulanir", "dayanir", "saglanir", "inanir", "özenir", "lenir", "ögrenir", "tersinir", "yasanir", "toplanir", "tanir", "senir", "rastlanir", "renir", "munir", "kaynaklanir", "baglanir", "hazirlanir", "güvenir", "enir", "soylenir", "baslanir", "davranir", "kapanir", "oynanir", "uzanir", "tanimlanir", "taninir", "souvenir", "ogrenir", "tasinir", "konteynir", "uyanir", "begenir", "hesaplanir", "sanir", "saklanir", "yakalanir", "aranir", "algilanir", "hoslanir", "karsilanir", "tamamlanir", "mounir", "yayinlanir", "yikanir", "tekrarlanir", "atanir", "bnir", "karasenir", "indüklenir", "zorlanir", "avenir", "erdenir", "kas-sinir", "utanir", "ültanir", "katlanir", "beyazpeynir", "sekillenir", "sonuçlanır", "dogranir", "nwanir", "faydalanir", "kilinir", "hizlanir", "yararlanir", "kutlanir", "saptanir", "nedenir", "kalinir", "ayarlanir", "kiskanir", "hastalanir", "suvenir", "yapilabilinir", "canlanir", "ekillenir", "hacklenir", "inir", "haslanir", "sonuclanir", "resetlenir", "beyenir", "açiklanir", "programming-sinir", "isinir", "odaklanir", "pionir", "çalinir", "penir", "tutuklanir", "lanmalı", "ögrenmeli", "düsünmeli", "ünmeli", "lanmaz", "osanmaz", "hoslanmaz", "üşenmez", "üşenmez", "üşenmez", "taşınmaz", "sınmaz", "yinmez", "hükmolunmaz", "bölünmez", "görünmez", "görüntülüyebilmek", "sen-ebilmek", "gorebilmek", "abilmek", "layabilmek", "ulasabilmek", "rabilmek", "saglayabilmek", "yaşabilmek", "tirebilmek", "tirebilmek", "tanılır", "sayılır", "olabılır", "kulanılır", "anlasılır", "lanılır", "acılır", "kimbilir", "labilir", "yapilir", "kullanilir", "yapilabilir", "kullanilabilir", "sayilir", "bilir", "anlasilir", "işbilir", "abilir", "ebilir", "nabilir", "ayrilir", "tirilir", "lanabilir", "ilir", "gorebilir", "guvenilir", "çikabilir", "alinabilir", "layabilir", "kabilir", "sayilabilir", "tartisilir", "yazilir", "rabilir", "açilir", "tirilebilir", "cikabilir", "lebilir", "atilir", "saglayabilir", "rilir", "katilir", "degisebilir", "acilir", "saglanabilir", "acabilir", "anlasilabilir", "degerlendirilir", "tirebilir", "anlatilir", "adlandirilir", "gorulebilir", "düsünülebilir", "olusabilir", "yabilir", "ulasabilir", "yaşabilir", "duyrulur", "buyrulur", "pulur", "gorulur", "olusturulur", "konusulur", "turulur", "rülür", "külür", "düsünülür", "büyülüyor", "görüntülüyor", "kötülüyor", "törpülüyor", "düsünülüyor", "acıldı", "imambayıldı", "rıldı", "tıldı", "ıldı", "anlasıldı", "degıldı", "dagıldı", "acıldı", "imambayıldı", "rıldı", "tıldı", "anlasıldı", "degıldı", "dagıldı", "degildi", "yapildi", "ayrildi", "deildi", "ögrenildi", "açildi", "azledildi", "atildi", "renildi", "cekildi", "rildi", "yazildi", "kullanildi", "lağvedildi", "anlasildi", "diildi", "kaldirildi", "Stem", "takildi", "birakildi", "gerçeklestirildi", "yayildi", "deyildi", "secildi", "yikildi", "çikarildi", "kapatildi", "kirildi", "ğildi", "baslatildi", "gonderildi", "deiildi", "yaratildi", "vahyedildi", "dagildi", "duyruldu", "buyruldu", "turuldu", "uldu", "meşguldu", "olusturuldu", "konusuldu", "özbuldu", "ruldu", "goruldu", "hasanboğuldu", "dokuldu", "rüldü", "ünüldü", "büründürüldü", "üldü", "türüldü", "satılmış", "geri-bıraktırılmış", "yaradılmış", "pılmış", "rılmış", "acılmış", "tılmış", "ılmış", "kulanılmış", "çokbilmiş", "vaadedilmiş", "vahyedilmiş", "akdedilmiş", "ehlileştirilmiş", "azledilmiş", "gasbedilmiş", "rilmiş", "degilmiş", "hasredilmiş", "neshedilmiş", "gaspedilmiş", "kasdedilmiş", "cekilmiş", "lağvedilmiş", "yapilmiş", "leştirilmiş", "deilmiş", "kavrulmuş", "kurtulmuş", "buyrulmuş", "karşılacak", "acılacak", "kulanılacak", "ılacak", "ailecek", "silecek", "labilecek", "ölçüşebilecek", "yapilabilecek", "sayilabilecek", "abilecek", "kullanilabilecek", "gerçeklestirilecek", "olusabilecek", "layabilecek", "alinabilecek", "nabilecek", "çikabilecek", "saglayabilecek", "rabilecek", "ebilecek", "cekilecek", "secilecek", "turulacak", "olusturulacak", "konusulacak", "ulacak", "vukubulacak", "azledilmişti", "duyrulmuştu", "sergiliyordu", "etkiliyordu", "sorguluyordu", "büyülüyordu", "nasılsa", "degilse", "kurulmali", "düsünülmeli", "yılmaz", "kaçınılmaz", "eryılmaz", "türkyılmaz", "özyılmaz", "yanılmaz", "hiçyılmaz", "kanyılmaz", "küçükyılmaz", "kacınılmaz", "yavuzyılmaz", "ınanılmaz", "inanılmaz", "akyılmaz", "yamanyılmaz", "büyükyılmaz", "ağaryılmaz", "tartısılmaz", "yenilmez", "eğilmez", "vazgecilmez", "bilmez", "cekilmez", "yorulmaz", "üzülmez"];

const nonPassiveStems = ["sevi", "giyi", "gezi", "ayrı", "tıka", "ayrı", "sarı", "övü", "boşa", "besle", "kırı", "soyu", "yıka", "süsle", "içle", "besle", "tara", "çeki", "çözü", "hazırla", "üzü", "yıkı", "yıka", "kovu", "sıkı", "söyle", "kaçı", "kapa", "kası", "koru", "sarsı", "sığı", "kurula", "yakı", "yoru", "taşı", "uza", "takı", "yala", "atı", "iyileş", "sinirle", "dövü"];

nonPassivesTurkish.nonPassivesFullForms = nonPassivesFullForms;
nonPassivesTurkish.nonPassiveStems = nonPassiveStems;

var nonPassiveVerbsStartingDi = {};

Object.defineProperty(nonPassiveVerbsStartingDi, "__esModule", {
	value: true
});

nonPassiveVerbsStartingDi.default = function () {
	return ["diskontinuitas", "diskualifikasi", "diskriminatif", "diskriminator", "digitalisasi", "disinformasi", "disintegrasi", "diskriminasi", "disorientasi", "distabilitas", "diktatorial", "disinfektan", "disinsentif", "diskrepansi", "distributor", "diagnostik", "dialketika", "diktatoris", "dinosaurus", "diplomatik", "diplomatis", "direktorat", "dirgantara", "disimilasi", "diskontinu", "diskulpasi", "disparitas", "dispensasi", "distilator", "distingtif", "distribusi", "diversitas", "diafragma", "diagnosis", "diakritik", "diakronis", "dialektal", "dialektik", "dialektis", "digenesis", "digitalis", "dilematik", "diminutif", "dinamisme", "dingklang", "diplomasi", "dirgahayu", "disertasi", "disfungsi", "diskredit", "diskursif", "disleksia", "dislokasi", "dismutasi", "disonansi", "disosiasi", "dispenser", "disposisi", "distilasi", "distingsi", "divestasi", "diabeter", "diagonal", "dialisis", "diameter", "diaspora", "difraksi", "digestif", "diglosia", "dikotomi", "diktator", "dilatasi", "dimorfik", "dinamika", "dioksida", "diopsida", "diplomat", "direktur", "disentri", "disensus", "disiplin", "diskotek", "diskresi", "dispersi", "disrupsi", "distansi", "distorsi", "diagram", "difabel", "digdaya", "digital", "digresi", "diletan", "dimensi", "dinamik", "dinamis", "dinamit", "dinasti", "dioksin", "diorama", "diploma", "diptera", "direksi", "dirigen", "disagio", "disiden", "disjoki", "diskoid", "diskusi", "disuasi", "dividen", "diadem", "diakon", "dialek", "dialog", "diaper", "diayah", "diesel", "dilasi", "dinamo", "diniah", "diorit", "diare", "diode", "didih", "didik", "didis", "digit", "dikau", "dikir", "diksi", "dikte", "dinas", "dipan", "dirah", "direk", "disko", "dinda", "difusi", "dilema", "dingin", "diniah", "diorit", "dirham", "disket", "diskon", "divisi", "diftong", "difteri", "dinding", "dingkis", "dingkit", "dioksin", "diorama", "diploma", "dirigen", "disiden", "displin", "disjoki", "diskusi", "distrik", "dividen", "digestif", "diglosia", "dikotomi", "dingklik", "dioksida", "diplomat", "direktur", "disentri", "diskresi", "disorder", "dispersi", "distansi", "disrupsi", "divergen", "dingklang", "diplomasi", "dirgahayu", "disertasi", "disfungsi", "disilabik", "diskredit", "disleksia", "dislokasi", "disosiasi", "dispenser", "disposisi", "distilasi", "dinosaurus", "diplomatik", "diplomatis", "dirgantara", "disimilasi", "diskontinu", "disparitas", "distilator", "distribusi", "divergensi", "diversitas", "disabilitas", "disinfektan", "diskrepansi", "disintegrasi", "diskriminasi", "diskriminatif", "diskontinuitas", "diskualifikasi"];
};

var passiveVerbsWithLongVowel = {};

Object.defineProperty(passiveVerbsWithLongVowel, "__esModule", {
	value: true
});

passiveVerbsWithLongVowel.default = function () {
	return ["غودرت", "غودر", "غودرتما", "غودرا", "غودرتا", "غودرنا", "غودرتم", "غودرتنّ", "غودروا", "غودرن", "مغادر", "محثوث", "تجرى", "يجرى", "مجرى", "تبقى", "يبقى", "مبقى", "تجوهلت", "تجوهل", "تجوهلت", "تجوهلتما", "تجوهلا", "تجوهلتا", "تجوهلنا", "تجوهلتم", "تجوهلتنّ", "تجوهلوا", "تجوهلن", "متجاهل", "تشوورت", "تشوور", "تشوورتما", "تشوورا", "تشوورتا", "تشوورنا", "تشوورتم", "تشوورتنّ", "تشووروا", "تشوورن", "متشاور", "نوقشت", "نوقش", "نوقشتما", "نوقشا", "نوقشتا", "نوقشنا", "نوقشتم", "نوقشتنّ", "نوقشوا", "نوقشن", "مناقش", "معود", "ترتدى", "يرتدى", "نرتدى", "مرتدى", "تنتهى", "ينتهى", "ننتهى", "تجووزت", "تجووز", "تجووزتما", "تجووزا", "تجووزتا", "تجووزنا", "تجووزتم", "تجووزتنّ", "تجووزوا", "تجووزن", "حوولت", "حوول", "حوولتما", "حوولا", "حوولتا", "حوولنا", "حوولتم", "حوولتنّ", "حوولوا", "حوولن", "تعولجت", "تعولج", "تعولجتما", "تعولجا", "تعولجتا", "تعولجنا", "تعولجتم", "تعولجتنّ", "تعولجوا", "تعولجن", "متعالج", "أشير", "أشيرا", "أشيرتا", "أشيروا", "تشار", "تشارين", "يشار", "تشاران", "يشاران", "نشار", "تشارون", "يشارون", "جيء", "جيئت", "جيئا", "جيئتا", "جيئوا", "أجاء", "تجاء", "تجائين", "يجاء", "تجاءان", "يجاءان", "نجاء", "تجائون", "تجأن", "يجائون", "يجأن", "يوصى", "توصى", "نوصى", "موصى", "احتيج", "احتيجت", "احتيجا", "احتيجتا", "احتيجوا", "تعطى", "يعطى", "نعطى", "معطى", "تعوليت", "تعولي", "تعوليتما", "تعوليا", "تعوليتا", "تعولينا", "تعوليتم", "تعوليتنّ", "تعولوا", "تعولين", " شوركت", "شورك", "شوركتما", "شوركا", "شوركتا", "شوركنا", "شوركتم", "شوركتنّ", "شوركوا", "شوركن", "تتولّى", "يتولّى", "نتولّى", "زيد", "زيدت", "زيدا", "زيدتا", "زيدوا", "أزاد", "تزاد", "تزادين", "يزاد", "تزادان", "يزادان", "نزاد", "تزادون", "يزادون", "سوعدت", "سوعد", "سوعدتما", "سوعدا", "سوعدتا", "سوعدنا", "سوعدتم", "سوعدتنّ", "سوعدوا", "سوعدن", "رئيت", "رئي", "رئيتما", "رئيا", "رئيتا", "رئينا", "رئيتم", "رئيتنّ", "رؤوا", "رئين", "تفووضت", "تفووض", "تفووضتما", "تفووضا", "تفووضتا", "تفووضنا", "تفووضتم", "تفووضتنّ", "تفووضوا", "تفووضن", "تزويدت", "تزويد", "تزويدتما", "تزويدا", "تزويدتا", "تزويدنا", "تزويدتم", "تزويدتنّ", "تزويدوا", "تزويدن", "تتلقّى", "يتلقّى", "نتلقّى", "لوحظت", "لوحظ", "لوحظتما", "لوحظا", "لوحظتا", "لوحظنا", "لوحظتم", "لوحظتنّ", "لوحظوا", "لوحظن", "تسعى", "يسعى", "نسعى", "أوتيت", "أوتي", "أوتيتما", "أوتيا", "أوتيتا", "أوتينا", "أوتيتم", "أوتيتنّ", "أوتوا", "أوتين", "ووفقت", "ووفق", "ووفقتما", "ووفقا", "ووفقتا", "ووفقنا", "ووفقتم", "ووفقتنّ", "ووفقوا", "ووفقن", "إين", "إينت", "إينا", "إينتا", "إينوا", "أؤان", "تؤان", "تؤانين", "يؤان", "تؤانان", "يؤانان", "نؤان", "تؤانون", "يؤانون", "أوخذت", "أوخذ", "أوخذتما", "أوخذا", "أوخذتا", "أوخذنا", "أوخذتم", "أوخذتنّ", "أوخذوا", "أوخذن", "لهيت", "لهي", "لهيتما", "لهيا", "لهيتا", "لهينا", "لهيتم", "لهيتم", "لهوا", "لهين", "ألهى", "تلهى", "يلهى", "تلهى", "تلهيان", "يلهيان", "نلهى", "يلهين", "تتبقّى", "يتبقّى", "نتبقّى", "تنوولت", "تنوول", "تنوولتما", "تنوولا", "تنوولتا", "تنوولنا", "تنوولتم", "تنوولتنّ", "تنوولوا", "تنوولن", "تووجهت", "تووجه", "تووجهتما", "تووجها", "تووجهتا", "تووجهنا", "تووجهتم", "تووجهتنّ", "تووجهوا", "تووجهن", "تبودلت", "تبودل", "تبودلتما", "تبودلا", "تبودلتا", "تبودلنا", "تبودلتم", "تبودلتم", "تبودلوا", "تبودلن", "تعورضت", "تعورض", "تعورضتما", "تعورضا", "تعورضتا", "تعورضنا", "تعورضتم", "تعورضتنّ", "تعورضوا", "تعورضن", "تعورضن", "تعنى", "يعنى", "نعنى", "طولبت", "طولب", "طولبتما", "طولبا", "طولبتا", "طولبنا", "طولبتم", "طولبتنّ", "طولبوا", "طولبن", "قيم", "قيمت", "قيما", "قيمتا", "قيموا", "أقام", "تقام", "تقامين", "يقام", "تقامان", "يقامان", "نقام", "تقامون", "يقامون", "أنشئت", "أنشئ", "أنشئتما", "أنشئا", "أنشئتا", "أنشئنا", "أنشئتم", "أنشئتنّ", "أنشئوا", "أنشئن", "تنشأ", "تنشئين", "ينشأ", "تنشآن", "ينشآن", "ننشأ", "تنشأون", "ينشأون", "ينشأن", "تنشأن", "غطّي", "تغطّى", "يغطّى", "نغطّى", "قوتلت", "قوتل", "قوتلتما", "قوتلا", "قوتلتا", "قوتلنا", "قوتلنا", "قوتلتنّ", "قوتلوا", "قوتلن", "أسمى", "تسمى", "يسمى", "نسمى", "أوثرت", "أوثر", "أوثرتما", "أوثرا", "أوثرتا", "أوثرنا", "أوثرتم", "أوثرتنّ", "أوثروا", "أوثرن", "غنّي", "أغنّى", "تغنّى", "يغنّى", "نغنّى", "استفيد", "استفيدت", "استفيدا", "استفيدتا", "استفيدوا", "أستفاد", "تستفاد", "تستفادين", "يستفاد", "تستفادان", "يستفادان", "نستفاد", "تستفادون", "يستفادون", "أثير", "أثيرت", "أثيرا", "أثيرا", "أثيروا", "أثار", "تثار", "تثارين", "يثار", "تثاران", "يثاران", "نثار", "تثارون", "يثارون", "تدّعى", "يدّعى", "ندّعى", "عيش", "عيشت", "عيشا", "عيشتا", "عيشوا", "أعاش", "تعاش", "تعاشين", "يعاش", "تعاشان", "يعاشان", "نعاش", "تعاشون", "يعاشون", "ووجهت", "ووجه", "ووجهتما", "ووجها", "ووجهتا", "ووجهنا", "ووجهتم", "ووجهتنّ", "ووجهوا", "ووجهن", "دعيت", "دعي", "دعيا", "دعيتا", "دعينا", "دعيتم", "دعيتنّ", "دعوا", "دعين", "أدعى", "تدعى", "تدعين", "تدعين", "تدعيان", "يدعيان", "يدعين", "اختير", "اختيرت", "اختيرا", "اختيرتا", "اختيروا", "اخترن", "شوهدت", "شوهد", "شوهدتما", "شوهدا", "شوهدتا", "شوهدنا", "شوهدتم", "شوهدتنّ", "شوهدوا", "شوهدن", "أدّي", "أؤدّى", "تؤدّى", "يؤدّى", "نؤدّى", "أفيدت", "أفيدا", "أفيدتا", "أفيدوا", "يفادون", "تفادون", "نفاد", "تفادان", "يفادان", "تفاد", "يفاد", "تفادين", "أفاد", "تكوملت", "تكومل", "تكوملتما", "تكوملا", "تكوملتا", "تكوملنا", "تكوملتم", "تكوملتنّ", "تكوملوا", "تكوملن", "أهنّئ", "تهنّئ", "تهنّئين", "يهنّئ", "يهنّئ", "يهنّئان", "تهنّئان", "نهنّئ", "تهنّئون", "تهنّئن", "هنّئوا", "هنّئن", "أهنّأ", "تهنّأ", "يهنّأ", "تهنّآن", "نهنّأ", "تهنّأون", "تهنّأن", "يهنّأون", "يهنّأن", "سوهمت", "سوهم", "سوهمتما", "سوهما", "سوهمتا", "سوهمنا", "سوهمتم", "سوهمتنّ", "سوهموا", "سوهمن", "أرمى", "ترمى", "يرمى", "نرمى", "أبلغت"];
};

var regularRootsNifal = {};

Object.defineProperty(regularRootsNifal, "__esModule", {
	value: true
});

regularRootsNifal.default = function () {
	return ["אכל", "אמר", "לקח", "נשא", "נתן", "קרא", "שלח", "שמע", "אהב", "אסף", "כרת", "כתב", "מצא", "פקד", "שמר", "שפט", "אבד", "אמן", "גאל", "דרש", "הרג", "חשב", "טמא", "יתר", "לכד", "ספר", "עזב", "קבץ", "קבר", "רדף", "שרף", "שאל", "שבר", "שחת", "שכח", "שלם", "שפך", "אסר", "בחר", "בלע", "בקע", "ברא", "דרך", "זרע", "חלק", "חנן", "חרש", "טהר", "למד", "מכר", "משל", "סגר", "סתר", "עזר", "ערך", "פרד", "פרש", "צפה", "קנה", "קרע", "רחץ", "רפא", "שבע", "שחט", "שמר", "תפש", "תקע", "אשם", "בגד", "בדל", "בחן", "גזל", "גמל", "גנב", "הרס", "זרק", "חבא", "חבש", "חלץ", "חצב", "חקר", "חרב", "חתם", "טמן", "טרף", "לקט", "מנע", "סלח", "סמך", "ספר", "עצר", "פגע", "פלט", "פרד", "פרץ", "פשט", "צפן", "קצר", "קשר", "רעש", "רצח", "שחק", "שטף", "אטם", "אלם", "ארג", "בצע", "גאל", "גדר", "גזז", "גזר", "גלח", "גרע", "דחה", "דקר", "חבל", "חרש", "חכה", "חפר", "חקק", "חרץ", "חשק", "טבח", "טבל", "טבע", "כבש", "כלא", "לחץ", "מחץ", "מסס", "משל", "נשא", "סחר", "סלל", "סער", "סקל", "סתם", "עטף", "עכר", "פרע", "פרק", "רמס", "שאב", "שאף", "שבר", "שכר", "שלל", "שלף", "שקל", "שקף", "שתל", "תכן", "תמך", "תעב", "שפכ‎", "דרכ‎", "ערכ‎", "סמכ‎", "תמכ‎", "נתנ", "אמנ", "חננ", "בחנ", "טמנ", "צפנ", "תכנ", "שלמ", "אשמ", "חתמ", "אטמ", "אלמ", "סתמ", "אספ", "רדפ", "שרפ", "טרפ", "שטפ", "עטפ", "שאפ", "שלפ", "שקפ", "קבצ", "רחצ", "חלצ", "פרצ", "חרצ", "לחצ", "מחצ"];
};

var regularRootsPual = {};

Object.defineProperty(regularRootsPual, "__esModule", {
	value: true
});

regularRootsPual.default = function () {
	return ["אכל", "דבר", "עבר", "שלח", "בקש", "ברך", "חזק", "חטא", "כתב", "נצל", "עבר", "פקד", "רום", "שמר", "אבד", "אמן", "בטח", "גדל", "הלל", "חלל", "חשב", "טמא", "יתר", "כבד", "כסה", "כפר", "לחם", "לכד", "נבא", "נגע", "סבב", "ספר", "קבץ", "קדש", "קרב", "שמח", "שבר", "שכן", "שלם", "שרת", "בער", "בקע", "ברא", "חלק", "חנן", "טהר", "כבס", "למד", "מרר", "מהר", "מלט", "נכר", "נצח", "פלל", "פרש", "צפה", "קלל", "רחם", "רחק", "רנן", "רפא", "שמר", "בדל", "בצר", "בשל", "גרש", "דמם", "זמר", "חבר", "מאן", "נשק", "נתץ", "נתק", "ספר", "ערב", "פשט", "צרף", "קדם", "קנא", "קצר", "קשר", "רגל", "שחק", "בצע", "ברר", "בשר", "גדר", "גלל", "דכא", "דשן", "חבל", "חבק", "חמם", "חפש", "חשק", "כהן", "כזב", "כנס", "מסס", "מעט", "מרר", "נגן", "נדב", "נהל", "נחש", "נער", "נפח", "נפץ", "נשך", "סכך", "סכן", "סקל", "עלל", "ענג", "עצב", "פאר", "פזר", "פצה", "פקח", "פרק", "פתה", "קבל", "קדד", "קצץ", "רמה", "רצץ", "רקע", "שבח", "שבר", "שנה", "שקר", "שקף", "תכן", "תעב", "ברכ‎", "נשכ‎", "סככ‎", "אמנ", "שכנ", "חננ", "רננ", "מאנ", "דשנ", "כהנ", "נגנ", "סכנ", "תכנ", "רומ", "לחמ", "שלמ", "רחמ", "דממ", "קדמ", "חממ", "צרפ", "שקפ", "קבצ", "נתצ", "קצצ", "רצצ", "נפצ"];
};

var regularRootsHufal = {};

Object.defineProperty(regularRootsHufal, "__esModule", {
	value: true
});

regularRootsHufal.default = function () {
	return ["אכל", "דבר", "עבר", "עמד", "קרא", "שמע", "זכר", "חזק", "חטא", "כתב", "מלך", "מצא", "נגד", "נפל", "עבר", "פקד", "רום", "שכב", "אבד", "אמן", "גדל", "חשב", "יטב", "כבד", "לבש", "קדש", "קרב", "שנא", "שאל", "שאר", "שבע", "שחת", "שכן", "שכח", "שלך", "שלם", "בער", "בקע", "ברא", "ברח", "דבק", "דרך", "זעק", "חלק", "חרם", "חרש", "כעס", "כשל", "מאס", "משל", "נבט", "נחל", "נצח", "סגר", "סתר", "ערך", "פרה", "פלא", "פלל", "פעל", "פרד", "פרש", "צלח", "צרר", "קלל", "קנה", "רחק", "רכב", "רעע", "שבע", "שכל", "שכם", "אשם", "בדל", "בהל", "בחן", "בשל", "גבה", "גנב", "זרק", "חלם", "חלף", "חרב", "חרד", "חרף", "חשך", "חתם", "טמן", "טרף", "כלם", "כנע", "כרע", "משך", "נהג", "סמך", "פחד", "פרד", "פרח", "פשט", "צדק", "צמח", "צפן", "קדם", "קצף", "קשב", "רבץ", "רגז", "רגל", "רחב", "רעש", "רשע", "שפל", "שקט", "ברר", "גבר", "געל", "טעם", "כזב", "כחש", "כנס", "לחץ", "מטר", "מעט", "מרד", "משל", "נגש", "נזל", "עלם", "עצב", "עשר", "פגש", "פרע", "צבא", "צמת", "קסם", "רבע", "רגע", "רעב", "רעם", "רקע", "שאב", "שבח", "שחר", "שכל", "שכר", "שען", "שקף", "שתל", "שלכ‎", "מלכ‎", "דרכ‎", "ערכ‎", "חשכ‎", "משכ‎", "סמכ‎", "אמנ", "שכנ", "בחנ", "טמנ", "צפנ", "שענ", "רומ", "שלמ", "חרמ", "שכמ", "אשמ", "חלמ", "חתמ", "כלמ", "קדמ", "עלמ", "טעמ", "חלפ", "חרפ", "טרפ", "קצפ", "שקפ", "רבצ", "לחצ"];
};

var odikVerbs = {};

Object.defineProperty(odikVerbs, "__esModule", {
	value: true
});
/*
 * Adapted from: Kornai, A, Halácsy, P, Nagy, V, Oravecz, Cs, Trón, V, and Varga, D (2006). Web-based frequency
 * dictionaries for medium density languages. In: Proceedings of the 2nd International Workshop on Web as Corpus,
 * edited by Adam Kilgarriff, Marco Baroni  ACL-06, pages 1-9, under Creative Commons Attribution-ShareAlike 4.0
 * Internation (CC BY-SA 4.0) license. Common Crawl Terms of Use apply. The corpus user-interface can be found here:
 * http://szotar.mokk.bme.hu/szoszablya/searchq.php
 */

// The verb stems that can have -ódik suffix.
const odikVerbStems1 = ["ábrázol", "ad", "adományoz", "ajándékoz", "akadályoz", "alakít", "alapít", "álcáz", "áldoz", "alkalmaz", "alkot", "állít", "arat", "ás", "automatizál", "azonosít", "befolyásol", "bírál", "bizonyít", "bocsát", "bont", "bonyolít", "csatol", "definiál", "deklarál", "digitalizál", "dob", "dokumentál", "dolgoz", "finanszíroz", "fogalmaz", "foglal", "foglalkoztat", "fogyaszt", "fojt", "fokoz", "fontol", "fordít", "forgalmaz", "garantál", "gyakorl", "gyárt", "gyógyít", "hagy", "hajt", "hálál", "hallgat", "hamisít", "hárít", "használ", "határoz", "hidal", "hoz", "igazít", "igazol", "illusztrál", "importál", "indít", "ír", "irányít", "istáz", "javasol", "javít", "jutalmaz", "kattint", "kínál", "kombinál", "kompenzál", "komponál", "kritizál", "kutat", "lapoz", "listáz", "locsol", "magyaráz", "másol", "moderál", "mond", "motivál", "mozgósít", "mulaszt", "mutat", "nyomtat", "nyújt", "olvas", "oszt", "parancsol", "postáz", "pótl", "próbál", "produkál", "ragaszt", "rak", "ráz", "regisztrál", "reklámoz", "rombol", "ront", "ruház", "sajátít", "sorol", "strukturál", "sugárz", "szabályoz", "szakít", "szállít", "számít", "számláz", "számol", "szavaz", "szimbolizál", "szólít", "szorít", "talál", "támogat", "tanít", "tárol", "tart", "taszít", "távolít", "tilt", "tisztít", "továbbít", "tudósít", "tulajdonít", "újít", "utal", "utasít", "válaszol", "választ", "válogat", "vált", "változtat", "varázsol", "világít", "világosít", "vitat", "vizsgál", "von"];

// The verb stems that can have -ődik suffix.
const odikVerbStems2 = ["beszél", "böngész", "bővít", "címz", "cserél", "derít", "díszít", "dönt", "egészít", "egyeztet", "egyszerűsít", "elégít", "emel", "említ", "engedélyez", "enyhít", "épít", "érint", "erősít", "ért", "értékel", "értelmez", "érzékeltet", "ev", "fedez", "fejleszt", "fejt", "fektet", "felejt", "feltev", "figyel", "fizet", "győz", "gyűjt", "hegeszt", "helyettesít", "helyez", "hirdet", "idéz", "igényl", "illeszt", "intéz", "ismer", "ítél", "ízesít", "jegyz", "jelenít", "jelent", "jelentkez", "jelöl", "kényszerít", "képvisel", "kérdez", "kerekít", "keresztel", "készít", "késztet", "kezel", "kivitelez", "kölcsönz", "köt", "követ", "közl", "közvetít", "küld", "különít", "küszöböl", "melegít", "mellékl", "mér", "nevez", "néz", "nyel", "nyer", "örökít", "őrz", "összegz", "összesít", "rendel", "rendez", "rögzít", "semmisít", "sürget", "szed", "szeg", "szennyez", "szerel", "szerkeszt", "szervez", "szigetel", "színez", "tekint", "telepít", "teljesít", "tenyészt", "teremt", "térít", "terjeszt", "tervez", "testesít", "tesztel", "tev", "tölt", "tömörít", "törl", "üldöz", "ültet", "végz", "veszélyeztet", "vet", "vetít", "vev", "vezet"];

odikVerbs.default = {
	odikVerbStems1: odikVerbStems1,
	odikVerbStems2: odikVerbStems2,
	all: odikVerbStems1.concat(odikVerbStems2)
};

var morphologicalPassiveAffixes = {};

Object.defineProperty(morphologicalPassiveAffixes, "__esModule", {
	value: true
});
// These are the suffixes for the verbs in -ódik.
morphologicalPassiveAffixes.odikSuffixes1 = ["ódom", "ódsz", "ódik", "ódunk", "ódtok", "ódnak", "ódtam", "ódtál", "ódott", "ódtunk", "ódtatok", "ódtak", "ódjak", "ódj", "ódjon", "ódjunk", "ódjatok", "ódjanak", "ódnék", "ódnál", "ódna", "ódnánk", "ódnátok", "ódnának"];
// These are the suffixes for the verbs in -ődik.
morphologicalPassiveAffixes.odikSuffixes2 = ["ődöm", "ődsz", "ődik", "ődünk", "ődtök", "ődnek", "ődtem", "ődtél", "ődött", "ődtünk", "ődtetek", "ődtek", "ődjek", "ődj", "ődjön", "ődjünk", "ődjetek", "ődjenek", "ődnék", "ődnél", "ődne", "dnénk", "ődnétek", "ődnének"];

morphologicalPassiveAffixes.verbPrefixes = ["abba", "agyon", "alul", "alá", "alább", "által", "át", "be", "bele", "belé", "benn", "egybe", "együtt", "el", "ellen", "elő", "előre", "észre", "fel", "föl", "félbe", "félre", "felül", "fölül", "fenn", "fönn", "hátra", "haza", "helyre", "hozzá", "ide", "jóvá", "keresztül", "ketté", "ki", "kölcsön", "körül", "körbe", "közbe", "közre", "közzé", "külön", "le", "létre", "meg", "mellé", "neki", "oda", "össze", "rá", "rajta", "széjjel", "szembe", "szerte", "szét", "tele", "teli", "tova", "tovább", "tönkre", "utol", "túl", "újjá", "újra", "utána", "végbe", "végig", "vissza"];

Object.defineProperty(determinePassiveSentence, "__esModule", {
	value: true
});

determinePassiveSentence.default = function (sentenceText, language) {
	if (["ru", "sv"].includes(language)) {
		return determineSentenceIsPassiveListBased(sentenceText, language);
	}

	if (language === "id") {
		return determineSentenceIsPassiveIndonesian(sentenceText);
	}

	if (language === "tr") {
		return determineSentenceIsPassiveTurkish(sentenceText);
	}

	if (language === "ar") {
		return determineSentenceIsPassiveArabic(sentenceText);
	}
	if (language === "he") {
		return determineSentenceIsPassiveHebrew(sentenceText);
	}
	if (language === "hu") {
		return determineSentenceIsPassiveHungarian(sentenceText);
	}
};

var _lodashEs$z = require$$1$1;

var _getWords$5 = getWords;

var _getWords2$5 = _interopRequireDefault$T(_getWords$5);

var _participlesShortenedList = participlesShortenedList;

var _participlesShortenedList2 = _interopRequireDefault$T(_participlesShortenedList);

var _participles = participles;

var _participles2 = _interopRequireDefault$T(_participles);

var _passiveEndings = passiveEndings;

var _passiveEndings2 = _interopRequireDefault$T(_passiveEndings);

var _nonPassivesTurkish = nonPassivesTurkish;

var _nonPassiveVerbsStartingDi = nonPassiveVerbsStartingDi;

var _nonPassiveVerbsStartingDi2 = _interopRequireDefault$T(_nonPassiveVerbsStartingDi);

var _passiveVerbsWithLongVowel = passiveVerbsWithLongVowel;

var _passiveVerbsWithLongVowel2 = _interopRequireDefault$T(_passiveVerbsWithLongVowel);

var _regularRootsNifal = regularRootsNifal;

var _regularRootsNifal2 = _interopRequireDefault$T(_regularRootsNifal);

var _regularRootsPual = regularRootsPual;

var _regularRootsPual2 = _interopRequireDefault$T(_regularRootsPual);

var _regularRootsHufal = regularRootsHufal;

var _regularRootsHufal2 = _interopRequireDefault$T(_regularRootsHufal);

var _odikVerbs = odikVerbs;

var _odikVerbs2 = _interopRequireDefault$T(_odikVerbs);

var _morphologicalPassiveAffixes = morphologicalPassiveAffixes;

function _interopRequireDefault$T(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getPassiveVerbsRussian = (0, _participlesShortenedList2.default)().all;

// Verb-form lists per language

const getPassiveVerbsSwedish = (0, _participles2.default)().all;

const passiveEndingsTurkish = (0, _passiveEndings2.default)();


const passivePrefixIndonesian = "di";

const nonPassivesIndonesian = (0, _nonPassiveVerbsStartingDi2.default)();

const getPassiveVerbsArabic = (0, _passiveVerbsWithLongVowel2.default)();

const nifalVerbsHebrew = (0, _regularRootsNifal2.default)();

const pualVerbsHebrew = (0, _regularRootsPual2.default)();

const hufalVerbsHebrew = (0, _regularRootsHufal2.default)();

/**
 * Matches the sentence against passive verbs.
 *
 * @param {string} sentence       The sentence to match against.
 * @param {Array}  passiveVerbs   The array containing passive verb-forms.
 *
 * @returns {Array}               The found passive verbs.
 */
const matchPassiveVerbs = function matchPassiveVerbs(sentence, passiveVerbs) {
	return (0, _lodashEs$z.filter)((0, _getWords2$5.default)(sentence), function (word) {
		return passiveVerbs.includes(word.toLocaleLowerCase());
	});
};

/**
 * Checks the passed sentence to see if it contains passive verb-forms.
 *
 * @param {string} sentence   The sentence to match against.
 * @param {string} language   The language of the text.
 *
 * @returns {Boolean}         Whether the sentence contains passive voice.
 */
const determineSentenceIsPassiveListBased = function determineSentenceIsPassiveListBased(sentence, language) {
	let passiveVerbs = [];

	switch (language) {
		case "ru":
			passiveVerbs = getPassiveVerbsRussian;
			break;
		case "sv":
			passiveVerbs = getPassiveVerbsSwedish;
			break;
	}
	return matchPassiveVerbs(sentence, passiveVerbs).length !== 0;
};

/**
 * Checks the passed sentence to see if it contains Indonesian passive verb-forms.
 *
 * @param {string} sentence   The sentence to match against.
 *
 * @returns {Boolean}         Whether the sentence contains Indonesian passive voice.
 */
const determineSentenceIsPassiveIndonesian = function determineSentenceIsPassiveIndonesian(sentence) {
	const words = (0, _getWords2$5.default)(sentence);
	let matchedPassives = words.filter(word => word.length > 4);
	matchedPassives = matchedPassives.filter(word => word.startsWith(passivePrefixIndonesian));
	if (matchedPassives.length === 0) {
		return false;
	}

	// Check exception list.
	for (const nonPassive of nonPassivesIndonesian) {
		matchedPassives = matchedPassives.filter(word => !word.startsWith(nonPassive));
	}

	// Check direct precedence exceptions.
	matchedPassives = matchedPassives.filter(function (matchedPassive) {
		let matchedPassivesShouldStay = true;
		const passiveIndex = words.indexOf(matchedPassive);
		const wordPrecedingPassive = words[passiveIndex - 1];
		if (wordPrecedingPassive === "untuk") {
			matchedPassivesShouldStay = false;
		}
		return matchedPassivesShouldStay;
	});
	return matchedPassives.length !== 0;
};

/**
 * Filters out words that are passive exceptions from an array.
 *
 * @param {string[]} nonPassivesTurkish      The list of exceptions to check
 * @param {string[]} passiveEndings          The list of passive verb endings
 * @param {string[]} matchedPassives         The words from the sentence that could be passives
 * @returns {string[]}               		 The array of words with the non-passives filtered out
 *
 */
const checkTurkishNonPassivesStemsList = function checkTurkishNonPassivesStemsList(nonPassivesTurkish, passiveEndings, matchedPassives) {
	return matchedPassives.filter(passive => nonPassivesTurkish.some(stem => passiveEndings.some(function (ending) {
		const pattern = new RegExp("^" + stem + ending + "$");
		return !pattern.test(passive);
	})));
};

/**
 * Checks the passed sentence to see if it contains Turkish passive verb forms and is not found in the non-passive full forms exception list.
 *
 * @param {string} sentence   The sentence to match against.
 *
 * @returns {Boolean}         Whether the sentence contains a Turkish verb passive voice.
 */
const determineSentenceIsPassiveTurkish = function determineSentenceIsPassiveTurkish(sentence) {
	const words = (0, _getWords2$5.default)(sentence);
	let matchedPassives = words.filter(word => word.length > 5);
	matchedPassives = matchedPassives.filter(word => !_nonPassivesTurkish.nonPassivesFullForms.includes(word));
	matchedPassives = checkTurkishNonPassivesStemsList(_nonPassivesTurkish.nonPassiveStems, passiveEndingsTurkish, matchedPassives);
	return matchedPassives.some(word => passiveEndingsTurkish.some(ending => word.endsWith(ending)));
};

/**
 * Checks the passed sentence to see if it contains Arabic passive verb-forms.
 *
 * @param {string} sentence     The sentence to match against.
 *
 * @returns {Boolean}           Whether the sentence contains Arabic passive voice.
 */
const determineSentenceIsPassiveArabic = function determineSentenceIsPassiveArabic(sentence) {
	const arabicPrepositionalPrefix = "و";
	const words = (0, _getWords2$5.default)(sentence);
	const passiveVerbs = [];

	for (let word of words) {
		// Check if the word starts with prefix و
		if (word.startsWith(arabicPrepositionalPrefix)) {
			word = word.slice(1);
		}
		let wordWithDamma = -1;
		// Check if the first character has a damma or if the word is in the list of Arabic passive verbs
		if (word.length >= 2) {
			wordWithDamma = word[1].search("\u064F");
		}
		if (wordWithDamma !== -1 || getPassiveVerbsArabic.includes(word)) {
			passiveVerbs.push(word);
		}
	}

	return passiveVerbs.length !== 0;
};

/**
 * Checks if the input word's root is in the Hebrew verb roots list.
 *
 * @param {string} word             The word to check.
 * @param {string[]} verbRootsList  The Hebrew verb roots list.
 * @param {Object[]} affixesList    The list of prefixes and suffixes.
 *
 * @returns {Boolean}           Returns true if the root of the input word is in the list.
 */
const checkHebrewVerbRootsList = function checkHebrewVerbRootsList(word, verbRootsList, affixesList) {
	return verbRootsList.some(root => affixesList.some(function (affixes) {
		const pattern = new RegExp("^" + affixes.prefix + root + affixes.suffix + "$");
		return pattern.test(word);
	}));
};

/**
 * Checks the passed sentence to see if it contains Hebrew passive verb-forms.
 *
 * @param {string} sentence    The sentence to match against.
 *
 * @returns {Boolean}          Whether the sentence contains Hebrew passive voice.
 */
const determineSentenceIsPassiveHebrew = function determineSentenceIsPassiveHebrew(sentence) {
	const words = (0, _getWords2$5.default)(sentence);
	for (const word of words) {
		// The list of prefixes and suffixes for nif'al.
		const nifalAffixes = [{ prefix: "(נ|אי|תי|הי|יי|ני|להי)", suffix: "" }, { prefix: "(תי|הי)", suffix: "(י|ו|נה)" }, { prefix: "נ", suffix: "(ים|ת|ות|תי|ה|נו|תם|תן|ו)" }, { prefix: "יי", suffix: "ו" }];

		// Check if the root is in nif'al.
		const nifalPassive = checkHebrewVerbRootsList(word, nifalVerbsHebrew, nifalAffixes);

		if (nifalPassive) {
			return true;
		}

		// The list of prefixes and suffixes for pu'al.
		const pualAffixes = [{ prefix: "(מ|א|ת|י|נ)", suffix: "" }, { prefix: "תי", suffix: "נה" }, { prefix: "מ", suffix: "(ת|ים|ות)" }, { prefix: "ת", suffix: "(י|ו|נה)" }, { prefix: "י", suffix: "ו" }, { prefix: "", suffix: "(תי|ת|ה|נו|תם|תן|ו)" }, { prefix: "", suffix: "" }];
		const pualInfix = "ו";

		// Check if the root is in pu'al.
		const pualPassive = pualVerbsHebrew.some(root => pualAffixes.some(function (affixes) {
			const pualPattern = new RegExp("^" + affixes.prefix + root[0] + pualInfix + root[1] + root[2] + affixes.suffix + "$");

			return pualPattern.test(word);
		}));

		if (pualPassive) {
			return true;
		}

		// The list of prefixes and suffixes for huf'al.
		const hufalAffixes = [{ prefix: "(מו|הו|או|תו|יו|נו)", suffix: "" }, { prefix: "מו", suffix: "(ת|ים|ות)" }, { prefix: "הו", suffix: "(תי|ת|ית|ה|נו|תם|תן|ו)" }, { prefix: "תו", suffix: "(ו|נה|י)" }, { prefix: "יו", suffix: "ו" }];

		// Check if the root is in huf'al.
		const hufalPassive = checkHebrewVerbRootsList(word, hufalVerbsHebrew, hufalAffixes);

		if (hufalPassive) {
			return true;
		}
	}

	return false;
};

/**
 * Checks if the input word's root is in the Hungarian verb roots list.
 *
 * @param {string} word             The word to check.
 * @param {string[]} verbRootsList  The Hungarian verb roots list.
 * @param {string[]} prefixes       The list of prefixes.
 * @param {string[]} suffixes       The list of suffixes.
 *
 * @returns {Boolean}               Returns true if the root of the input word is in the list.
 */
const checkHungarianPassive = function checkHungarianPassive(word, verbRootsList, prefixes, suffixes) {
	return verbRootsList.some(root => {
		return suffixes.some(function (suffix) {
			const rootAndSuffix = root + suffix;

			// Check whether the word ends in a root + suffix combination.
			if (word.endsWith(rootAndSuffix)) {
				const beforeRoot = word.slice(0, word.indexOf(rootAndSuffix));

				// Word is passive if nothing precedes the root or the root is preceded by a valid prefix.
				return beforeRoot === "" || prefixes.includes(beforeRoot);
			}
		});
	});
};

/**
 * Checks the passed sentence to see if it contains Hungarian passive verb-forms.
 *
 * @param {string} sentence     The sentence to match against.
 *
 * @returns {Boolean}           Whether the sentence contains Hungarian passive voice.
 */
const determineSentenceIsPassiveHungarian = function determineSentenceIsPassiveHungarian(sentence) {
	const words = (0, _getWords2$5.default)(sentence);
	const passiveVerbs1 = _odikVerbs2.default.odikVerbStems1;
	const passiveVerbs2 = _odikVerbs2.default.odikVerbStems2;

	for (const word of words) {
		const checkPassiveVerb1 = checkHungarianPassive(word, passiveVerbs1, _morphologicalPassiveAffixes.verbPrefixes, _morphologicalPassiveAffixes.odikSuffixes1);
		if (checkPassiveVerb1) {
			return true;
		}

		const checkPassiveVerbs2 = checkHungarianPassive(word, passiveVerbs2, _morphologicalPassiveAffixes.verbPrefixes, _morphologicalPassiveAffixes.odikSuffixes2);
		if (checkPassiveVerbs2) {
			return true;
		}
	}

	return false;
};

var getSentenceParts$1 = {};

var includesIndex = {};

Object.defineProperty(includesIndex, "__esModule", {
	value: true
});

includesIndex.default = function (precedingWords, matchIndex, addSpace = true) {
	/*
 1 if there is a space between the match and the preceding word
 (because the end word boundary is not included in the match).
 0 if the preceding word is a contraction.
 */
	var space = addSpace ? 1 : 0;

	if ((0, _lodashEs$y.isEmpty)(precedingWords)) {
		return false;
	}

	var precedingWordsEndIndices = [];
	(0, _lodashEs$y.forEach)(precedingWords, function (precedingWord) {
		var precedingWordsEndIndex = precedingWord.index + precedingWord.match.length + space;
		precedingWordsEndIndices.push(precedingWordsEndIndex);
	});
	return (0, _lodashEs$y.includes)(precedingWordsEndIndices, matchIndex);
};

var _lodashEs$y = require$$1$1;

var followsIndex = {};

Object.defineProperty(followsIndex, "__esModule", {
	value: true
});

followsIndex.default = function (followingWords, match) {
	if ((0, _lodashEs$x.isEmpty)(followingWords)) {
		return false;
	}

	// The followingWordIndices include the preceding space.
	var wordAfterMatchIndex = match.index + match.match.length;
	var followingWordsIndices = [];

	(0, _lodashEs$x.forEach)(followingWords, function (followingWord) {
		followingWordsIndices.push(followingWord.index);
	});

	return (0, _lodashEs$x.includes)(followingWordsIndices, wordAfterMatchIndex);
};

var _lodashEs$x = require$$1$1;

var SentencePart$a = {};

var SentencePart$9 = {};

Object.defineProperty(SentencePart$9, "__esModule", {
  value: true
});
/**
 * Constructs a sentence part object.
 *
 * @param {string} sentencePartText The text in the sentence part.
 * @param {Array} auxiliaries The list of auxiliaries from the sentence part.
 * @param {string} locale The locale used for this sentence part.
 *
 * @constructor
 */
var SentencePart$8 = function SentencePart(sentencePartText, auxiliaries, locale) {
  this._sentencePartText = sentencePartText;
  this._auxiliaries = auxiliaries;
  this._locale = locale;
  this._isPassive = false;
};

/**
 * Returns the sentence part string.
 *
 * @returns {string} The sentence part.
 */
SentencePart$8.prototype.getSentencePartText = function () {
  return this._sentencePartText;
};

/**
 * Returns the passiveness of a sentence part.
 *
 * @returns {boolean} returns true if passive, otherwise returns false.
 */
SentencePart$8.prototype.isPassive = function () {
  return this._isPassive;
};

/**
 * Returns the list of auxiliaries from a sentence part.
 *
 * @returns {Array} The list of auxiliaries.
 */
SentencePart$8.prototype.getAuxiliaries = function () {
  return this._auxiliaries;
};

/**
 * Returns the locale of the sentence part.
 *
 * @returns {string} The locale of the sentence part.
 */
SentencePart$8.prototype.getLocale = function () {
  return this._locale;
};

/**
 * Sets the passiveness of the sentence part.
 *
 * @param {boolean} passive Whether the sentence part is passive or not.
 *
 * @returns {void}
 */
SentencePart$8.prototype.setPassive = function (passive) {
  this._isPassive = passive;
};

/**
 * Serializes the SentencePart instance to an object.
 *
 * @returns {Object} The serialized SentencePart.
 */
SentencePart$8.prototype.serialize = function () {
  return {
    _parseClass: "SentencePart",
    sentencePartText: this._sentencePartText,
    auxiliaries: this._auxiliaries,
    locale: this._locale,
    isPassive: this._isPassive
  };
};

/**
 * Parses the object to a SentencePart.
 *
 * @param {Object} serialized The serialized object.
 *
 * @returns {SentencePart} The parsed SentencePart.
 */
SentencePart$8.parse = function (serialized) {
  const sentencePart = new SentencePart$8(serialized.sentencePartText, serialized.auxiliaries, serialized.locale);
  sentencePart.setPassive(serialized.isPassive);

  return sentencePart;
};

SentencePart$9.default = SentencePart$8;

Object.defineProperty(SentencePart$a, "__esModule", {
  value: true
});

var _SentencePart$b = SentencePart$9;

var _SentencePart2$b = _interopRequireDefault$S(_SentencePart$b);

var _getParticiples$8 = getParticiples$2;

var _getParticiples2$8 = _interopRequireDefault$S(_getParticiples$8);

function _interopRequireDefault$S(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a English specific sentence part.
 *
 * @param {string} sentencePartText The text from the sentence part.
 * @param {Array} auxiliaries The list of auxiliaries from the sentence part.
 * @param {string} locale The locale used for this sentence part.
 * @constructor
 */
var EnglishSentencePart = function EnglishSentencePart(sentencePartText, auxiliaries, locale) {
  _SentencePart2$b.default.call(this, sentencePartText, auxiliaries, locale);
};

require$$2$1.inherits(EnglishSentencePart, _SentencePart2$b.default);

/**
 * Returns the participle objects for the participles found in the sentence part.
 * @returns {Array} The list of participle objects.
 */

EnglishSentencePart.prototype.getParticiples = function () {
  return (0, _getParticiples2$8.default)(this.getSentencePartText(), this.getAuxiliaries(), "en");
};

SentencePart$a.default = EnglishSentencePart;

var stopwords$8 = {};

Object.defineProperty(stopwords$8, "__esModule", {
	value: true
});

stopwords$8.default = function () {
	return ["to", "which", "who", "whom", "that", "whose", "after", "although", "as", "because", "before", "even if", "even though", "how", "if", "in order that", "inasmuch", "lest", "once", "provided", "since", "so that", "than", "though", "till", "unless", "until", "when", "whenever", "where", "whereas", "wherever", "whether", "while", "why", "by the time", "supposing", "no matter", "how", "what", "won't", "do", "does", "–", "and", "but", "or"];
};

var SentencePart$7 = {};

Object.defineProperty(SentencePart$7, "__esModule", {
  value: true
});

var _SentencePart$a = SentencePart$9;

var _SentencePart2$a = _interopRequireDefault$R(_SentencePart$a);

var _getParticiples$7 = getParticiples$2;

var _getParticiples2$7 = _interopRequireDefault$R(_getParticiples$7);

function _interopRequireDefault$R(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a French-specific sentence part.
 *
 * @param {string} sentencePartText The text from the sentence part.
 * @param {Array} auxiliaries The list with auxiliaries.
 * @constructor
 */
var FrenchSentencePart = function FrenchSentencePart(sentencePartText, auxiliaries) {
  _SentencePart2$a.default.call(this, sentencePartText, auxiliaries, "fr_FR");
};

require$$2$1.inherits(FrenchSentencePart, _SentencePart2$a.default);

/**
 * Returns the participles found in the sentence part.
 *
 * @returns {Array} The array of Participle Objects.
 */
FrenchSentencePart.prototype.getParticiples = function () {
  return (0, _getParticiples2$7.default)(this.getSentencePartText(), this.getAuxiliaries(), "fr");
};

SentencePart$7.default = FrenchSentencePart;

var auxiliaries$3 = {};

Object.defineProperty(auxiliaries$3, "__esModule", {
	value: true
});

auxiliaries$3.default = function () {
	return ["être", "d'être", "suis", "es", "est", "sommes", "êtes", "sont", "n'est", "n'es", "n'êtes", "été", "j'étais", "étais", "était", "étions", "étiez", "étaient", "c'était", "n'étais", "n'était", "n'étions", "n'étiez", "n'étaient", "serai", "seras", "sera", "serons", "serez", "seront", "sois", "soit", "soyons", "soyez", "soient", "fusse", "fusses", "fût", "fussions", "fussiez", "fussent", "serais", "serait", "serions", "seriez", "seraient", "fus", "fut", "fûmes", "fûtes", "furent", "suis-je", "es-tu", "est-il", "est-elle", "est-on", "sommes-nous", "êtes-vous", "sont-ils", "sont-elles", "est-ce", "étais-je", "étais-tu", "était-il", "était-elle", "était-on", "était-ce", "étions-nous", "étiez-vous", "étaient-ils", "étaient-elles", "serai-je", "seras-tu", "sera-t-il", "sera-t-elle", "sera-t-on", "sera-ce", "serons-nous", "serez-vous", "seront-ils", "seront-elles", "serais-je", "serais-tu", "serait-il", "serait-elle", "serait-on", "serait-ce", "serions-nous", "seriez-vous", "seraient-ils", "seraient-elles", "fus-je", "fus-tu", "fut-il", "fut-elle", "fut-on", "fut-ce", "fûmes-nous", "fûtes-vous", "furent-ils", "furent-elles"];
};

var stopwords$7 = {};

Object.defineProperty(stopwords$7, "__esModule", {
	value: true
});

stopwords$7.default = function () {
	return ["et", "ou", "car", "or", "puisque", "puisqu'il", "puisqu'ils", "puisqu'elle", "puisqu'elles", "puisqu'un", "puisqu'une", "puisqu'on", "quand", "lorsque", "lorsqu'il", "lorsqu'elle", "lorsqu'ils", "lorsqu'elles", "lorsqu'on", "lorsqu'un", "lorsqu'une", "quoique", "quoiqu'il", "quoiqu'ils", "quoiqu'elle", "quoiqu'elles", "quoiqu'on", "quoiqu'un", "quoiqu'une", "qu'elle", "qu'il", "qu'ils", "qu'elles", "qu'on", "qu'un", "qu'une", "si", "s'ils", "s'il", "quand bien même", "pourquoi", "après", "avant", "afin de", "compte tenu de", "pour ne pas dire", "sinon", "une fois", "sitôt", "dont", "lequel", "laquelle", "lesquels", "lesquelles", "auquel", "auxquels", "auxquelles", "duquel", "desquels", "desquelles", "qui", "où", "d'où", ":", "allé", "entré", "resté", "retombé", "apparu", "réapparu", "devenu", "redevenu", "intervenu", "provenu", "resurvenu", "survenu", "allés", "entrés", "restés", "retombés", "apparus", "réapparus", "devenus", "redevenus", "intervenus", "provenus", "resurvenus", "survenus", "allée", "entrée", "restée", "retombée", "apparue", "réapparue", "devenue", "redevenue", "intervenue", "provenue", "resurvenue", "survenue", "allées", "entrées", "restées", "retombées", "apparues", "réapparues", "devenues", "redevenues", "intervenues", "provenues", "resurvenues", "survenues"];
};

var SentencePart$6 = {};

Object.defineProperty(SentencePart$6, "__esModule", {
  value: true
});

var _SentencePart$9 = SentencePart$9;

var _SentencePart2$9 = _interopRequireDefault$Q(_SentencePart$9);

var _getParticiples$6 = getParticiples$2;

var _getParticiples2$6 = _interopRequireDefault$Q(_getParticiples$6);

function _interopRequireDefault$Q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a Spanish-specific sentence part.
 *
 * @param {string} sentencePartText The text from the sentence part.
 * @param {Array} auxiliaries The list with auxiliaries.
 * @constructor
 */
var SpanishSentencePart = function SpanishSentencePart(sentencePartText, auxiliaries) {
  _SentencePart2$9.default.call(this, sentencePartText, auxiliaries, "es_ES");
};

require$$2$1.inherits(SpanishSentencePart, _SentencePart2$9.default);

/**
 * Returns the participles found in the sentence part.
 *
 * @returns {Array} The array of Participle Objects.
 */
SpanishSentencePart.prototype.getParticiples = function () {
  return (0, _getParticiples2$6.default)(this.getSentencePartText(), this.getAuxiliaries(), "es");
};

SentencePart$6.default = SpanishSentencePart;

var auxiliaries$2 = {};

Object.defineProperty(auxiliaries$2, "__esModule", {
	value: true
});

auxiliaries$2.default = function () {
	return ["ser", "soy", "eres", "es", "somos", "sois", "son", "fui", "fuiste", "fue", "fuimos", "fuisteis", "fueron", "era", "eras", "era", "éramos", "erais", "eran", "sería", "serías", "seríamos", "seríais", "serían", "seré", "serás", "será", "seremos", "seréis", "serán", "seas", "sea", "seamos", "seáis", "sean", "fuera", "fueras", "fuéramos", "fuerais", "fueran", "fuese", "fueses", "fuésemos", "fueseis", "fuesen", "fuere", "fueres", "fuéremos", "fuereis", "fueren", "sé", "sed", "siendo", "sido"];
};

var stopwords$6 = {};

Object.defineProperty(stopwords$6, "__esModule", {
	value: true
});

stopwords$6.default = function () {
	return ["pero", "ora", "aunque", "aun", "mientras", "porque", "apenas", "si", "antes", "después", "cómo", "como", "empero", "que", "cuanto", "cuando", "cual", "cuales", "quién", "quien", "quienes", "dónde", "adónde", "cuyo", "cuyos", "cuya", "cuyas"];
};

var SentencePart$5 = {};

Object.defineProperty(SentencePart$5, "__esModule", {
  value: true
});

var _SentencePart$8 = SentencePart$9;

var _SentencePart2$8 = _interopRequireDefault$P(_SentencePart$8);

var _getParticiples$5 = getParticiples$2;

var _getParticiples2$5 = _interopRequireDefault$P(_getParticiples$5);

function _interopRequireDefault$P(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a Portuguese-specific sentence part.
 *
 * @param {string} sentencePartText The text from the sentence part.
 * @param {Array} auxiliaries The list with auxiliaries.
 * @constructor
 */
var PortugueseSentencePart = function PortugueseSentencePart(sentencePartText, auxiliaries) {
  _SentencePart2$8.default.call(this, sentencePartText, auxiliaries, "pt_PT");
};

require$$2$1.inherits(PortugueseSentencePart, _SentencePart2$8.default);

/**
 * Returns the participles found in the sentence part.
 *
 * @returns {Array} The array of Participle Objects.
 */
PortugueseSentencePart.prototype.getParticiples = function () {
  return (0, _getParticiples2$5.default)(this.getSentencePartText(), this.getAuxiliaries(), "pt");
};

SentencePart$5.default = PortugueseSentencePart;

var auxiliaries$1 = {};

Object.defineProperty(auxiliaries$1, "__esModule", {
	value: true
});

auxiliaries$1.default = function () {
	return ["sou", "és", "é", "somos", "sois", "são", "era", "eras", "era", "éramos", "éreis", "eram", "serei", "serás", "será", "seremos", "sereis", "serão", "sido", "foste", "foi", "fomos", "fostes", "fora", "foras", "fôramos", "fôreis", "foram", "seja", "sejas", "seja", "sejamos", "sejais", "sejam", "fui", "fosse", "fosses", "fosse", "fôssemos", "fôsseis", "fossem", "for", "fores", "for", "formos", "fordes", "forem", "seria", "serias", "seria", "seríamos", "seríeis", "seriam", "ser", "seres", "ser", "sermos", "serdes", "serem"];
};

var stopwords$5 = {};

Object.defineProperty(stopwords$5, "__esModule", {
	value: true
});

stopwords$5.default = function () {
	return ["que ", "como", "e", "nem", "se", "caso", "conforme", "consoante", "porque", "pois", "segundo ", "enquanto", "embora", "conquanto", "quanto menos", "quanto mais", "quando", "mal ", "apenas", "ora", "seja", "quer", "já", "logo", "portanto", "por isso", "pois", "рог conseguinte", "ou seja ", "isto é", "quer dizer", "a saber", "ou melhor", "mas", "também", "sim", "porém", "contudo", "senão", "todavia", "mas ainda", "no entanto", "entretanto"];
};

var SentencePart$4 = {};

Object.defineProperty(SentencePart$4, "__esModule", {
  value: true
});

var _SentencePart$7 = SentencePart$9;

var _SentencePart2$7 = _interopRequireDefault$O(_SentencePart$7);

var _getParticiples$4 = getParticiples$2;

var _getParticiples2$4 = _interopRequireDefault$O(_getParticiples$4);

function _interopRequireDefault$O(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates an Italian-specific sentence part.
 *
 * @param {string} sentencePartText The text from the sentence part.
 * @param {Array} auxiliaries The list with auxiliaries.
 * @constructor
 */
var ItalianSentencePart = function ItalianSentencePart(sentencePartText, auxiliaries) {
  _SentencePart2$7.default.call(this, sentencePartText, auxiliaries, "it_IT");
};

require$$2$1.inherits(ItalianSentencePart, _SentencePart2$7.default);

/**
 * Returns the participles found in the sentence part.
 *
 * @returns {Array} The array of Participle Objects.
 */
ItalianSentencePart.prototype.getParticiples = function () {
  return (0, _getParticiples2$4.default)(this.getSentencePartText(), this.getAuxiliaries(), "it");
};

SentencePart$4.default = ItalianSentencePart;

var auxiliaries = {};

Object.defineProperty(auxiliaries, "__esModule", {
	value: true
});

auxiliaries.default = function () {
	return ["fui", "fu", "fosti", "fummo", "foste", "furono", "stato", "stati", "stata", "state", "venire", "vengo", "vieni", "viene", "veniamo", "venite", "vengono", "venivo", "venivi", "veniva", "venivamo", "venivate", "venivano", "verrò", "verrai", "verrà", "verremo", "verrete", "verranno", "venni", "venisti", "venne", "venimmo", "veniste", "vennero", "verrei", "verresti", "verrebbe", "verremmo", "verreste", "verrebbero", "venga", "veniamo", "venite", "vengano", "veniate", "venissi", "venisse", "venissimo", "veniste", "venissero", "andare", "vado", "vai", "va", "andiamo", "andate", "vanno", "andavo", "andavi", "andava", "andavamo", "andavate", "andavano", "vada", "andiate", "andante", "andato", "andassi", "andasse", "andassimo", "andaste", "andassero", "andai", "andasti", "andò", "andammo", "andarono", "andrò", "andrai", "andrà", "andremo", "andrete", "andranno", "andrei", "andresti", "andrebbe", "andremmo", "andreste", "andrebbero", "vadano", "andando"];
};

var stopwords$4 = {};

Object.defineProperty(stopwords$4, "__esModule", {
	value: true
});

stopwords$4.default = function () {
	return ["a condizione che", "a meno che non", "a patto che", "a seconda che", "acché", "affinché", "al fine di", "allorché", "allorquando", "anche se", "anziché", "avvegnaché", "basta que", "benché", "beninteso que", "chi", "cui", "dal momento che", "dopo che", "dove", "finché non", "fintantoché", "i quali", "il quale", "in caso", "in modo che", "la quale", "le quali", "malgrado", "mentre", "nel caso in cui", "nel eventualità che", "nonostante che", "ogni volta che", "per il fatto che", "perché", "piuttosto che", "piuttosto di", "poiche", "prima che", "purché", "qualora", "quando", "quantunque", "quello che", "sebbene", "senza che", "siccome", "tranne che", "una volta che"];
};

Object.defineProperty(getSentenceParts$1, "__esModule", {
	value: true
});

getSentenceParts$1.default = function (sentence, language) {
	return getSentenceParts(sentence, language);
};

var _indices = indices;

var _indices2 = _interopRequireDefault$N(_indices);

var _stripSpaces$4 = stripSpaces;

var _stripSpaces2$4 = _interopRequireDefault$N(_stripSpaces$4);

var _quotes$4 = quotes;

var _createRegexFromArray$2 = createRegexFromArray;

var _createRegexFromArray2$2 = _interopRequireDefault$N(_createRegexFromArray$2);

var _getIndicesWithRegex = getIndicesWithRegex;

var _getIndicesWithRegex2 = _interopRequireDefault$N(_getIndicesWithRegex);

var _includesIndex = includesIndex;

var _includesIndex2 = _interopRequireDefault$N(_includesIndex);

var _followsIndex = followsIndex;

var _followsIndex2 = _interopRequireDefault$N(_followsIndex);

var _lodashEs$w = require$$1$1;

var _SentencePart$6 = SentencePart$a;

var _SentencePart2$6 = _interopRequireDefault$N(_SentencePart$6);

var _auxiliaries$1 = auxiliaries$a;

var _auxiliaries2$1 = _interopRequireDefault$N(_auxiliaries$1);

var _stopwords$1 = stopwords$8;

var _stopwords2$1 = _interopRequireDefault$N(_stopwords$1);

var _SentencePart3$1 = SentencePart$7;

var _SentencePart4$1 = _interopRequireDefault$N(_SentencePart3$1);

var _auxiliaries3$1 = auxiliaries$3;

var _auxiliaries4$1 = _interopRequireDefault$N(_auxiliaries3$1);

var _stopwords3$1 = stopwords$7;

var _stopwords4$1 = _interopRequireDefault$N(_stopwords3$1);

var _SentencePart5$1 = SentencePart$6;

var _SentencePart6$1 = _interopRequireDefault$N(_SentencePart5$1);

var _auxiliaries5$1 = auxiliaries$2;

var _auxiliaries6$1 = _interopRequireDefault$N(_auxiliaries5$1);

var _stopwords5$1 = stopwords$6;

var _stopwords6$1 = _interopRequireDefault$N(_stopwords5$1);

var _SentencePart7$1 = SentencePart$5;

var _SentencePart8$1 = _interopRequireDefault$N(_SentencePart7$1);

var _auxiliaries7$1 = auxiliaries$1;

var _auxiliaries8$1 = _interopRequireDefault$N(_auxiliaries7$1);

var _stopwords7$1 = stopwords$5;

var _stopwords8$1 = _interopRequireDefault$N(_stopwords7$1);

var _SentencePart9 = SentencePart$4;

var _SentencePart10 = _interopRequireDefault$N(_SentencePart9);

var _auxiliaries9 = auxiliaries;

var _auxiliaries10 = _interopRequireDefault$N(_auxiliaries9);

var _stopwords9 = stopwords$4;

var _stopwords10 = _interopRequireDefault$N(_stopwords9);

function _interopRequireDefault$N(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getIndicesOfList = _indices2.default.getIndicesByWordList;
const filterIndices = _indices2.default.filterIndices;
const sortIndices = _indices2.default.sortIndices;

// English-specific variables and imports.

const auxiliariesEnglish = (0, _auxiliaries2$1.default)().all;

const stopwordsEnglish = (0, _stopwords2$1.default)();
const stopCharacterRegexEnglish = /([:,]|('ll)|('ve))(?=[ \n\r\t'"+\-»«‹›<>])/ig;
const verbEndingInIngRegex = /\w+ing(?=$|[ \n\r\t.,'()"+\-;!?:/»«‹›<>])/ig;
const ingExclusionArray = ["king", "cling", "ring", "being", "thing", "something", "anything"];

// French-specific variables and imports.

const auxiliariesFrench = (0, _auxiliaries4$1.default)();

const stopwordsFrench = (0, _stopwords4$1.default)();
const stopCharacterRegexFrench = /(,)(?=[ \n\r\t'"+\-»«‹›<>])/ig;
const followingAuxiliaryExceptionWordsFrench = ["le", "la", "les", "une", "l'un", "l'une"];
const reflexivePronounsFrench = ["se", "me", "te", "s'y", "m'y", "t'y", "nous nous", "vous vous"];
const directPrecedenceExceptionRegexFrench = (0, _createRegexFromArray2$2.default)(reflexivePronounsFrench);
const elisionAuxiliaryExceptionWords = ["c'", "s'", "peut-"];
const elisionAuxiliaryExceptionRegex = (0, _createRegexFromArray2$2.default)(elisionAuxiliaryExceptionWords, true);

// Spanish-specific variables and imports.

const auxiliariesSpanish = (0, _auxiliaries6$1.default)();

const stopwordsSpanish = (0, _stopwords6$1.default)();
const followingAuxiliaryExceptionWordsSpanish = ["el", "la", "los", "las", "una"];

// Portuguese-specific variables and imports.

const auxiliariesPortuguese = (0, _auxiliaries8$1.default)();

const stopwordsPortuguese = (0, _stopwords8$1.default)();
const followingAuxiliaryExceptionWordsPortuguese = ["o", "a", "os", "as", "um", "ums", "uma", "umas"];

// Italian-specific variables and imports.

const auxiliariesItalian = (0, _auxiliaries10.default)();

const stopwordsItalian = (0, _stopwords10.default)();
const followingAuxiliaryExceptionWordsItalian = ["il", "i", "la", "le", "lo", "gli", "uno", "una"];
const reflexivePronounsItalian = ["mi", "ti", "si", "ci", "vi"];
const directPrecedenceExceptionRegexItalian = (0, _createRegexFromArray2$2.default)(reflexivePronounsItalian);

/*
 * Variables applying to multiple languages
 * This regex applies to Spanish, Italian and  Portuguese.
 */
const stopCharacterRegexOthers = /([:,])(?=[ \n\r\t'"+\-»«‹›<>])/ig;

// The language-specific variables used to split sentences into sentence parts.
const languageVariables$1 = {
	en: {
		stopwords: stopwordsEnglish,
		auxiliaryRegex: (0, _createRegexFromArray2$2.default)(auxiliariesEnglish),
		SentencePart: _SentencePart2$6.default,
		auxiliaries: auxiliariesEnglish,
		stopCharacterRegex: stopCharacterRegexEnglish
	},
	fr: {
		stopwords: stopwordsFrench,
		auxiliaryRegex: (0, _createRegexFromArray2$2.default)(auxiliariesFrench),
		SentencePart: _SentencePart4$1.default,
		auxiliaries: auxiliariesFrench,
		stopCharacterRegex: stopCharacterRegexFrench,
		followingAuxiliaryExceptionRegex: (0, _createRegexFromArray2$2.default)(followingAuxiliaryExceptionWordsFrench),
		directPrecedenceExceptionRegex: directPrecedenceExceptionRegexFrench
	},
	es: {
		stopwords: stopwordsSpanish,
		auxiliaryRegex: (0, _createRegexFromArray2$2.default)(auxiliariesSpanish),
		SentencePart: _SentencePart6$1.default,
		auxiliaries: auxiliariesSpanish,
		stopCharacterRegex: stopCharacterRegexOthers,
		followingAuxiliaryExceptionRegex: (0, _createRegexFromArray2$2.default)(followingAuxiliaryExceptionWordsSpanish)
	},
	pt: {
		stopwords: stopwordsPortuguese,
		auxiliaryRegex: (0, _createRegexFromArray2$2.default)(auxiliariesPortuguese),
		SentencePart: _SentencePart8$1.default,
		auxiliaries: auxiliariesPortuguese,
		stopCharacterRegex: stopCharacterRegexOthers,
		followingAuxiliaryExceptionRegex: (0, _createRegexFromArray2$2.default)(followingAuxiliaryExceptionWordsPortuguese)
	},
	it: {
		stopwords: stopwordsItalian,
		auxiliaryRegex: (0, _createRegexFromArray2$2.default)(auxiliariesItalian),
		SentencePart: _SentencePart10.default,
		auxiliaries: auxiliariesItalian,
		stopCharacterRegex: stopCharacterRegexOthers,
		followingAuxiliaryExceptionRegex: (0, _createRegexFromArray2$2.default)(followingAuxiliaryExceptionWordsItalian),
		directPrecedenceExceptionRegex: directPrecedenceExceptionRegexItalian
	}
};

/**
 * Gets active verbs (ending in ing) to determine sentence breakers in English.
 *
 * @param {string} sentence             The sentence to get the active verbs from.
 *
 * @returns {Array}                     The array with valid matches.
 */
const getVerbsEndingInIng = function getVerbsEndingInIng(sentence) {
	// Matches the sentences with words ending in ing.
	const matches = sentence.match(verbEndingInIngRegex) || [];
	// Filters out words ending in -ing that aren't verbs.
	return (0, _lodashEs$w.filter)(matches, function (match) {
		return !(0, _lodashEs$w.includes)(ingExclusionArray, (0, _stripSpaces2$4.default)(match));
	});
};

/**
 * Gets stop characters to determine sentence breakers.
 *
 * @param {string} sentence             The sentence to get the stop characters from.
 * @param {string} language             The language for which to get the stop characters.
 *
 * @returns {Array}                     The array with stop characters.
 */
const getStopCharacters = function getStopCharacters(sentence, language) {
	const stopCharacterRegex = languageVariables$1[language].stopCharacterRegex;
	let match;
	const matches = [];

	stopCharacterRegex.lastIndex = 0;

	while ((match = stopCharacterRegex.exec(sentence)) !== null) {
		matches.push({
			index: match.index,
			match: match[0]
		});
	}
	return matches;
};

/**
 * Filters auxiliaries preceded by a reflexive pronoun.
 *
 * @param {string} text                      The text part in which to check.
 * @param {Array} auxiliaryMatches           The auxiliary matches for which to check.
 * @param {string} language                  The language for which to check auxiliary precedence exceptions.
 *
 * @returns {Array}                          The filtered list of auxiliary indices.
 */
const auxiliaryPrecedenceExceptionFilter = function auxiliaryPrecedenceExceptionFilter(text, auxiliaryMatches, language) {
	const directPrecedenceExceptionMatches = (0, _getIndicesWithRegex2.default)(text, languageVariables$1[language].directPrecedenceExceptionRegex);

	(0, _lodashEs$w.forEach)(auxiliaryMatches, function (auxiliaryMatch) {
		if ((0, _includesIndex2.default)(directPrecedenceExceptionMatches, auxiliaryMatch.index)) {
			auxiliaryMatches = auxiliaryMatches.filter(function (auxiliaryObject) {
				return auxiliaryObject.index !== auxiliaryMatch.index;
			});
		}
	});

	return auxiliaryMatches;
};

/**
 * Filters auxiliaries followed by a word on the followingAuxiliaryExceptionWords list.
 *
 * @param {string} text                       The text part in which to check.
 * @param {Array} auxiliaryMatches            The auxiliary matches for which to check.
 * @param {string} language                   The language for which to filter the auxiliaries.
 *
 * @returns {Array}                           The filtered list of auxiliary indices.
 */
const followingAuxiliaryExceptionFilter = function followingAuxiliaryExceptionFilter(text, auxiliaryMatches, language) {
	const followingAuxiliaryExceptionRegex = languageVariables$1[language].followingAuxiliaryExceptionRegex;
	const followingAuxiliaryExceptionMatches = (0, _getIndicesWithRegex2.default)(text, followingAuxiliaryExceptionRegex);

	(0, _lodashEs$w.forEach)(auxiliaryMatches, function (auxiliaryMatch) {
		if ((0, _followsIndex2.default)(followingAuxiliaryExceptionMatches, auxiliaryMatch)) {
			auxiliaryMatches = auxiliaryMatches.filter(function (auxiliaryObject) {
				return auxiliaryObject.index !== auxiliaryMatch.index;
			});
		}
	});

	return auxiliaryMatches;
};

/**
 * Filters auxiliaries preceded by an elided word (e.g., s') on the elisionAuxiliaryExceptionWords list.
 *
 * @param {string} text                         The text part in which to check.
 * @param {Array} auxiliaryMatches              The auxiliary matches for which to check.
 *
 * @returns {Array}                             The filtered list of auxiliary indices.
 */
const elisionAuxiliaryExceptionFilter = function elisionAuxiliaryExceptionFilter(text, auxiliaryMatches) {
	const elisionAuxiliaryExceptionMatches = (0, _getIndicesWithRegex2.default)(text, elisionAuxiliaryExceptionRegex);

	(0, _lodashEs$w.forEach)(auxiliaryMatches, function (auxiliaryMatch) {
		if ((0, _includesIndex2.default)(elisionAuxiliaryExceptionMatches, auxiliaryMatch.index, false)) {
			auxiliaryMatches = auxiliaryMatches.filter(function (auxiliaryObject) {
				return auxiliaryObject.index !== auxiliaryMatch.index;
			});
		}
	});

	return auxiliaryMatches;
};

/**
 * Gets the indexes of sentence breakers (auxiliaries, stopwords and stop characters;
 * in English also active verbs) to determine sentence parts.
 * Indices are filtered because there could be duplicate matches, like "even though" and "though".
 * In addition, 'having' will be matched both as a -ing verb as well as an auxiliary.
 *
 * @param {string} sentence                       The sentence to check for indices of sentence breakers.
 * @param {string} language                       The language for which to match the sentence breakers.
 *
 * @returns {Array}                               The array with valid indices to use for determining sentence parts.
 */
const getSentenceBreakers = function getSentenceBreakers(sentence, language) {
	sentence = sentence.toLocaleLowerCase();
	const stopwords = languageVariables$1[language].stopwords;
	const auxiliaries = languageVariables$1[language].auxiliaries;
	let auxiliaryIndices = getIndicesOfList(auxiliaries, sentence);
	const stopwordIndices = getIndicesOfList(stopwords, sentence);
	const stopCharacterIndices = getStopCharacters(sentence, language);
	let indices;

	// Concat all indices arrays, filter them and sort them.
	switch (language) {
		case "fr":
			// Filters auxiliaries matched in the sentence based on a precedence exception filter.
			auxiliaryIndices = auxiliaryPrecedenceExceptionFilter(sentence, auxiliaryIndices, "fr");
			// Filters auxiliaries matched in the sentence based on a elision exception filter.
			auxiliaryIndices = elisionAuxiliaryExceptionFilter(sentence, auxiliaryIndices);

			indices = [].concat(auxiliaryIndices, stopwordIndices, stopCharacterIndices);
			break;
		case "es":
			indices = [].concat(auxiliaryIndices, stopwordIndices, stopCharacterIndices);
			break;
		case "pt":
			indices = [].concat(auxiliaryIndices, stopwordIndices, stopCharacterIndices);
			break;
		case "it":
			// Filters auxiliaries matched in the sentence based on a precedence exception filter.
			auxiliaryIndices = auxiliaryPrecedenceExceptionFilter(sentence, auxiliaryIndices, "it");
			indices = [].concat(auxiliaryIndices, stopwordIndices, stopCharacterIndices);
			break;
		case "en":
		default:
			var ingVerbs = getVerbsEndingInIng(sentence);
			var ingVerbsIndices = getIndicesOfList(ingVerbs, sentence);
			indices = [].concat(auxiliaryIndices, stopwordIndices, ingVerbsIndices, stopCharacterIndices);
			break;
	}
	indices = filterIndices(indices);
	return sortIndices(indices);
};

/**
 * Gets the auxiliaries from a sentence.
 *
 * @param {string} sentencePart                The part of the sentence to match for auxiliaries.
 * @param {string} language                    The language for which to match the auxiliaries.
 *
 * @returns {Array}                            All formatted matches from the sentence part.
 */
const getAuxiliaryMatches = function getAuxiliaryMatches(sentencePart, language) {
	const auxiliaryRegex = languageVariables$1[language].auxiliaryRegex;
	const auxiliaryMatches = sentencePart.match(auxiliaryRegex) || [];

	switch (language) {
		case "fr":
		case "es":
		case "pt":
		case "it":
			// An array with the matched auxiliaries and their indices.
			var auxiliaryMatchIndices = getIndicesOfList(auxiliaryMatches, sentencePart);

			if (language === "fr" || language === "it") {
				// Filters auxiliaries matched in the sentence part based on a precedence exception filter.
				auxiliaryMatchIndices = auxiliaryPrecedenceExceptionFilter(sentencePart, auxiliaryMatchIndices, language);
			}
			// Filters auxiliaries matched in the sentence part based on a exception filter for words following the auxiliary.
			auxiliaryMatchIndices = followingAuxiliaryExceptionFilter(sentencePart, auxiliaryMatchIndices, language);

			// An array with the matched auxiliary verbs (without indices).
			var auxiliaryMatchWords = [];

			(0, _lodashEs$w.forEach)(auxiliaryMatchIndices, function (auxiliaryMatchIndex) {
				auxiliaryMatchWords.push(auxiliaryMatchIndex.match);
			});

			return (0, _lodashEs$w.map)(auxiliaryMatchWords, function (auxiliaryMatch) {
				return (0, _stripSpaces2$4.default)(auxiliaryMatch);
			});
		case "en":
		default:
			return (0, _lodashEs$w.map)(auxiliaryMatches, function (auxiliaryMatch) {
				return (0, _stripSpaces2$4.default)(auxiliaryMatch);
			});
	}
};

/**
 * Gets the sentence parts from a sentence by determining sentence breakers.
 *
 * @param {string} sentence                 The sentence to split up in sentence parts.
 * @param {string} language                 The language for which to get the sentence parts.
 *
 * @returns {Array}                         The array with all parts of a sentence that have an auxiliary.
 */
const getSentenceParts = function getSentenceParts(sentence, language) {
	const sentenceParts = [];
	const auxiliaryRegex = languageVariables$1[language].auxiliaryRegex;
	const SentencePart = languageVariables$1[language].SentencePart;

	sentence = (0, _quotes$4.normalizeSingle)(sentence);

	// First check if there is an auxiliary in the sentence.
	if (sentence.match(auxiliaryRegex) === null) {
		return sentenceParts;
	}

	const indices = getSentenceBreakers(sentence, language);
	// Get the words after the found auxiliary.
	for (let i = 0; i < indices.length; i++) {
		let endIndex = sentence.length;
		if (!(0, _lodashEs$w.isUndefined)(indices[i + 1])) {
			endIndex = indices[i + 1].index;
		}

		// Cut the sentence from the current index to the endIndex (start of next breaker, of end of sentence).
		const sentencePart = (0, _stripSpaces2$4.default)(sentence.substr(indices[i].index, endIndex - indices[i].index));

		const auxiliaryMatches = getAuxiliaryMatches(sentencePart, language);
		// If a sentence part doesn't have an auxiliary, we don't need it, so it can be filtered out.
		if (auxiliaryMatches.length !== 0) {
			sentenceParts.push(new SentencePart(sentencePart, auxiliaryMatches));
		}
	}
	return sentenceParts;
};

var getSentencePartsSplitOnStopwords = {};

var SentencePart$3 = {};

Object.defineProperty(SentencePart$3, "__esModule", {
  value: true
});

var _SentencePart$5 = SentencePart$9;

var _SentencePart2$5 = _interopRequireDefault$M(_SentencePart$5);

var _getParticiples$3 = getParticiples$1;

var _getParticiples2$3 = _interopRequireDefault$M(_getParticiples$3);

function _interopRequireDefault$M(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a German-specific sentence part.
 *
 * @param {string} sentencePartText The text from the sentence part.
 * @param {Array} auxiliaries The list with auxiliaries.
 * @constructor
 */
var GermanSentencePart = function GermanSentencePart(sentencePartText, auxiliaries) {
  _SentencePart2$5.default.call(this, sentencePartText, auxiliaries, "de_DE");
};

require$$2$1.inherits(GermanSentencePart, _SentencePart2$5.default);

/**
 * Returns the participles found in the sentence part.
 *
 * @returns {Array} The array of Participle Objects.
 */
GermanSentencePart.prototype.getParticiples = function () {
  return (0, _getParticiples2$3.default)(this.getSentencePartText(), this.getAuxiliaries());
};

SentencePart$3.default = GermanSentencePart;

var stopwords$3 = {};

Object.defineProperty(stopwords$3, "__esModule", {
	value: true
});

stopwords$3.default = function () {
	return [":", "aber", "als", "bevor", "bis", "da", "damit", "daß", "dass", "denn", "doch", "ehe", "falls", "gleichwohl", "indem", "indes", "indessen", "insofern", "insoweit", "nachdem", "nun", "ob", "obgleich", "obschon", "obwohl", "obzwar", "oder", "seitdem", "sobald", "sodass", "sofern", "solange", "sondern", "sooft", "soviel", "soweit", "sowie", "trotz", "und", "ungeachtet", "waehrend", "während", "weil", "welche", "welchem", "welchen", "welcher", "welches", "wem", "wen", "wenn", "wenngleich", "wennschon", "wer", "wes", "wessen", "wie", "wiewohl", "wohingegen", "zumal"];
};

var SentencePart$2 = {};

Object.defineProperty(SentencePart$2, "__esModule", {
  value: true
});

var _SentencePart$4 = SentencePart$9;

var _SentencePart2$4 = _interopRequireDefault$L(_SentencePart$4);

var _getParticiples$2 = getParticiples$2;

var _getParticiples2$2 = _interopRequireDefault$L(_getParticiples$2);

function _interopRequireDefault$L(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a Dutch-specific sentence part.
 *
 * @param {string} sentencePartText The text from the sentence part.
 * @param {Array} auxiliaries The list with auxiliaries.
 * @constructor
 */
var DutchSentencePart = function DutchSentencePart(sentencePartText, auxiliaries) {
  _SentencePart2$4.default.call(this, sentencePartText, auxiliaries, "nl_NL");
};

require$$2$1.inherits(DutchSentencePart, _SentencePart2$4.default);

/**
 * Returns the participles found in the sentence part.
 *
 * @returns {Array} The array of Participle Objects.
 */
DutchSentencePart.prototype.getParticiples = function () {
  return (0, _getParticiples2$2.default)(this.getSentencePartText(), this.getAuxiliaries(), "nl");
};

SentencePart$2.default = DutchSentencePart;

var stopwords$2 = {};

Object.defineProperty(stopwords$2, "__esModule", {
	value: true
});

stopwords$2.default = function () {
	return ["alhoewel", "als", "dan", "doordat", "hoewel", "hoezeer", "indien", "mits", "naargelang", "naarmate", "nadat", "ofschoon", "omdat", "opdat", "tenzij", "toen", "voordat", "voorzover", "wanneer", "zoals", "zodat", "zodra", "zolang", "wie", "wiens", "wier", "welke", "welk"];
};

var SentencePart$1 = {};

Object.defineProperty(SentencePart$1, "__esModule", {
  value: true
});

var _SentencePart$3 = SentencePart$9;

var _SentencePart2$3 = _interopRequireDefault$K(_SentencePart$3);

var _getParticiples$1 = getParticiples$2;

var _getParticiples2$1 = _interopRequireDefault$K(_getParticiples$1);

function _interopRequireDefault$K(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a Polish-specific sentence part.
 *
 * @param {string} sentencePartText The text from the sentence part.
 * @param {Array} auxiliaries The list with auxiliaries.
 * @constructor
 */
const PolishSentencePart = function PolishSentencePart(sentencePartText, auxiliaries) {
  _SentencePart2$3.default.call(this, sentencePartText, auxiliaries, "pl_PL");
};

require$$2$1.inherits(PolishSentencePart, _SentencePart2$3.default);

/**
 * Returns the participles found in the sentence part.
 *
 * @returns {Array} The array of Participle Objects.
 */
PolishSentencePart.prototype.getParticiples = function () {
  return (0, _getParticiples2$1.default)(this.getSentencePartText(), this.getAuxiliaries(), "pl");
};

SentencePart$1.default = PolishSentencePart;

var stopwords$1 = {};

Object.defineProperty(stopwords$1, "__esModule", {
	value: true
});

stopwords$1.default = function () {
	return ["a", "aby", "albo", "albowiem", "ale", "bo", "bowiem", "czy", "gdy", "gdyby", "gdyż", "iż", "jeśli", "jeżeli", "lub", "ponieważ", "zanim", "żeby", "który", "która", "które", "którzy", "którego", "której", "których", "któremu", "którym", "którą", "którymi", "że"];
};

var SentencePart = {};

Object.defineProperty(SentencePart, "__esModule", {
  value: true
});

var _SentencePart$2 = SentencePart$9;

var _SentencePart2$2 = _interopRequireDefault$J(_SentencePart$2);

var _getParticiples = getParticiples;

var _getParticiples2 = _interopRequireDefault$J(_getParticiples);

function _interopRequireDefault$J(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a Hungarian specific sentence part.
 *
 * @param {string} sentencePartText     The text from the sentence part.
 * @param {Array} auxiliaries           The list of auxiliaries from the sentence part.
 * @param {string} locale               The locale used for this sentence part.
 *
 * @constructor
 */
const HungarianSentencePart = function HungarianSentencePart(sentencePartText, auxiliaries, locale) {
  _SentencePart2$2.default.call(this, sentencePartText, auxiliaries, locale);
};

require$$2$1.inherits(HungarianSentencePart, _SentencePart2$2.default);

/**
 * Returns the participle objects for the participles found in the sentence part.
 *
 * @returns {Array}                              The list of participle objects.
 */

HungarianSentencePart.prototype.getParticiples = function () {
  return (0, _getParticiples2.default)(this.getSentencePartText(), this.getAuxiliaries(), "hu");
};

SentencePart.default = HungarianSentencePart;

var stopwords = {};

Object.defineProperty(stopwords, "__esModule", {
	value: true
});

stopwords.default = function () {
	return ["a", "ahogy", "ahol", "aki", "akik", "akkor", "alatt", "által", "általában", "amely", "amelyek", "amelyekben", "amelyeket", "amelyet", "amelynek", "ami", "amit", "amolyan", "amíg", "amikor", "át", "abban", "ahhoz", "annak", "arra", "arról", "az", "azok", "azon", "azt", "azzal", "azért", "aztán", "azután", "azonban", "bár", "be", "belül", "benne", "cikk", "cikkek", "cikkeket", "csak", "de", "e", "eddig", "egész", "egy", "egyes", "egyetlen", "egyéb", "egyik", "egyre", "ekkor", "el", "elég", "ellen", "elé", "először", "előtt", "első", "én", "éppen", "ebben", "ehhez", "emilyen", "ennek", "erre", "ez", "ezt", "ezek", "ezen", "ezzel", "ezért", "és", "fel", "felé", "hanem", "hiszen", "hogy", "hogyan", "igen", "így", "illetve", "ill.", "ill", "ilyen", "ilyenkor", "ismét", "itt", "jó", "jól", "jobban", "kell", "kellett", "keresztül", "keressünk", "ki", "kívül", "között", "közül", "legalább", "lehet", "lehetett", "legyen", "lenne", "lenni", "lesz", "lett", "maga", "magát", "majd", "majd", "már", "más", "másik", "meg", "még", "mellett", "mert", "mely", "melyek", "mi", "mit", "míg", "miért", "milyen", "mikor", "minden", "mindent", "mindenki", "mindig", "mint", "mintha", "mivel", "most", "nagy", "nagyobb", "nagyon", "ne", "néha", "nekem", "neki", "nem", "néhány", "nélkül", "nincs", "olyan", "ott", "össze", "ő", "ők", "őket", "pedig", "persze", "rá", "s", "saját", "sem", "semmi", "sok", "sokat", "sokkal", "számára", "szemben", "szerint", "szinte", "talán", "tehát", "teljes", "tovább", "továbbá", "több", "úgy", "ugyanis", "új", "újabb", "újra", "után", "utána", "utolsó", "vagy", "vagyis", "valaki", "valami", "valamint", "való", "vissza", "viszont"];
};

Object.defineProperty(getSentencePartsSplitOnStopwords, "__esModule", {
	value: true
});

var _lodashEs$v = require$$1$1;

var _createRegexFromArray$1 = createRegexFromArray;

var _createRegexFromArray2$1 = _interopRequireDefault$I(_createRegexFromArray$1);

var _stripSpaces$3 = stripSpaces;

var _stripSpaces2$3 = _interopRequireDefault$I(_stripSpaces$3);

var _SentencePart$1 = SentencePart$3;

var _SentencePart2$1 = _interopRequireDefault$I(_SentencePart$1);

var _auxiliaries = auxiliaries$b;

var _auxiliaries2 = _interopRequireDefault$I(_auxiliaries);

var _stopwords = stopwords$3;

var _stopwords2 = _interopRequireDefault$I(_stopwords);

var _SentencePart3 = SentencePart$2;

var _SentencePart4 = _interopRequireDefault$I(_SentencePart3);

var _stopwords3 = stopwords$2;

var _stopwords4 = _interopRequireDefault$I(_stopwords3);

var _auxiliaries3 = auxiliaries$6;

var _auxiliaries4 = _interopRequireDefault$I(_auxiliaries3);

var _SentencePart5 = SentencePart$1;

var _SentencePart6 = _interopRequireDefault$I(_SentencePart5);

var _stopwords5 = stopwords$1;

var _stopwords6 = _interopRequireDefault$I(_stopwords5);

var _auxiliaries5 = auxiliaries$5;

var _auxiliaries6 = _interopRequireDefault$I(_auxiliaries5);

var _SentencePart7 = SentencePart;

var _SentencePart8 = _interopRequireDefault$I(_SentencePart7);

var _stopwords7 = stopwords;

var _stopwords8 = _interopRequireDefault$I(_stopwords7);

var _auxiliaries7 = auxiliaries$4;

var _auxiliaries8 = _interopRequireDefault$I(_auxiliaries7);

function _interopRequireDefault$I(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// German-specific imports.
const auxiliariesGerman = (0, _auxiliaries2.default)().allAuxiliaries;

const stopwordsGerman = (0, _stopwords2.default)();

// Dutch-specific imports.

const stopwordsDutch = (0, _stopwords4.default)();

const auxiliariesDutch = (0, _auxiliaries4.default)();

// Polish-specific imports.

const stopwordsPolish = (0, _stopwords6.default)();

const auxiliariesPolish = (0, _auxiliaries6.default)();

// Hungarian-specific imports.

const stopwordsHungarian = (0, _stopwords8.default)();

const auxiliariesHungarian = (0, _auxiliaries8.default)().allAuxiliaries;

// The language-specific variables.
const languageVariables = {
	de: {
		SentencePart: _SentencePart2$1.default,
		stopwordRegex: (0, _createRegexFromArray2$1.default)(stopwordsGerman),
		auxiliaryRegex: (0, _createRegexFromArray2$1.default)(auxiliariesGerman),
		locale: "de_DE"
	},
	nl: {
		SentencePart: _SentencePart4.default,
		stopwordRegex: (0, _createRegexFromArray2$1.default)(stopwordsDutch),
		auxiliaryRegex: (0, _createRegexFromArray2$1.default)(auxiliariesDutch),
		locale: "nl_NL"
	},
	pl: {
		SentencePart: _SentencePart6.default,
		stopwordRegex: (0, _createRegexFromArray2$1.default)(stopwordsPolish),
		auxiliaryRegex: (0, _createRegexFromArray2$1.default)(auxiliariesPolish),
		locale: "pl_PL"
	},
	hu: {
		SentencePart: _SentencePart8.default,
		stopwordRegex: (0, _createRegexFromArray2$1.default)(stopwordsHungarian),
		auxiliaryRegex: (0, _createRegexFromArray2$1.default)(auxiliariesHungarian),
		locale: "hu_HU"
	}
};

/**
 * Strips spaces from the auxiliary matches.
 *
 * @param {Array} matches       A list with matches of auxiliaries.
 *
 * @returns {Array}             A list with matches with spaces removed.
 */
function sanitizeMatches(matches) {
	return (0, _lodashEs$v.map)(matches, function (match) {
		return (0, _stripSpaces2$3.default)(match);
	});
}

/**
 * Splits sentences into sentence parts based on stopwords.
 *
 * @param {string} sentence     The sentence to split.
 * @param {Array} stopwords     The array with matched stopwords.
 *
 * @returns {Array}             The array with sentence parts.
 */
function splitOnWords(sentence, stopwords) {
	const splitSentences = [];

	// Split the sentence on each found stopword and push this part in an array.
	(0, _lodashEs$v.forEach)(stopwords, function (stopword) {
		const sentenceSplit = sentence.split(stopword);
		if (!(0, _lodashEs$v.isEmpty)(sentenceSplit[0])) {
			splitSentences.push(sentenceSplit[0]);
		}
		const startIndex = sentence.indexOf(stopword);
		const endIndex = sentence.length;
		sentence = (0, _stripSpaces2$3.default)(sentence.substr(startIndex, endIndex));
	});

	// Push the remainder of the sentence in the sentence parts array.
	splitSentences.push(sentence);
	return splitSentences;
}

/**
 * Creates sentence parts based on split sentences.

 * @param {Array}   sentences   The array with split sentences.
 * @param {string}  language    The language for which to create sentence parts.
 *
 * @returns {Array}             The array with sentence parts.
 */
function createSentenceParts(sentences, language) {
	const auxiliaryRegex = languageVariables[language].auxiliaryRegex;
	const SentencePart = languageVariables[language].SentencePart;
	const sentenceParts = [];
	(0, _lodashEs$v.forEach)(sentences, function (part) {
		const foundAuxiliaries = sanitizeMatches(part.match(auxiliaryRegex || []));
		sentenceParts.push(new SentencePart(part, foundAuxiliaries, languageVariables[language].locale));
	});
	return sentenceParts;
}

/**
 * Splits the sentence into sentence parts based on stopwords.
 *
 * @param {string} sentence     The text to split into sentence parts.
 * @param {string} language     The language for which to split sentences.
 *
 * @returns {Array}             The array with sentence parts.
 */
function splitSentence(sentence, language) {
	const stopwordRegex = languageVariables[language].stopwordRegex;
	const stopwords = sentence.match(stopwordRegex) || [];
	const splitSentences = splitOnWords(sentence, stopwords);
	return createSentenceParts(splitSentences, language);
}

getSentencePartsSplitOnStopwords.default = splitSentence;

Object.defineProperty(getPassiveVoice, "__esModule", {
	value: true
});

getPassiveVoice.default = function (paper) {
	const text = paper.getText();
	const locale = paper.getLocale();
	const language = (0, _getLanguage2$9.default)(locale);
	const sentences = (0, _getSentences2$2.default)(text).map(function (sentence) {
		return new _Sentence2$1.default(sentence, locale);
	});
	const totalNumberSentences = sentences.length;

	if (morphologicalLanguages.includes(language)) {
		return {
			total: totalNumberSentences,
			passives: getMorphologicalPassives(sentences, language)
		};
	}
	if (periphrasticLanguages.includes(language)) {
		return {
			total: totalNumberSentences,
			passives: getPeriphrasticPassives(sentences, language)
		};
	}
	if (morphologicalAndPeriphrasticLanguages.includes(language)) {
		return {
			total: totalNumberSentences,
			passives: getMorphologicalAndPeriphrasticPassive(sentences, language)
		};
	}
};

var _getSentences$2 = getSentences;

var _getSentences2$2 = _interopRequireDefault$H(_getSentences$2);

var _stripHTMLTags$2 = stripHTMLTags;

var _getLanguage$9 = getLanguage;

var _getLanguage2$9 = _interopRequireDefault$H(_getLanguage$9);

var _Sentence$1 = Sentence$1;

var _Sentence2$1 = _interopRequireDefault$H(_Sentence$1);

var _lodashEs$u = require$$1$1;

var _determinePassiveSentencePart = determinePassiveSentencePart;

var _determinePassiveSentencePart2 = _interopRequireDefault$H(_determinePassiveSentencePart);

var _determinePassiveSentence = determinePassiveSentence;

var _determinePassiveSentence2 = _interopRequireDefault$H(_determinePassiveSentence);

var _getSentenceParts = getSentenceParts$1;

var _getSentenceParts2 = _interopRequireDefault$H(_getSentenceParts);

var _getSentencePartsSplitOnStopwords = getSentencePartsSplitOnStopwords;

var _getSentencePartsSplitOnStopwords2 = _interopRequireDefault$H(_getSentencePartsSplitOnStopwords);

function _interopRequireDefault$H(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const morphologicalLanguages = ["ru", "tr", "sv", "id", "ar", "he", "tr"];
const periphrasticLanguages = ["en", "de", "nl", "fr", "es", "it", "pt", "cn", "pl"];
const morphologicalAndPeriphrasticLanguages = ["hu"];

/**
 * Looks for morphological passive voice.
 *
 * @param {Array} sentences Sentences extracted from the text.
 * @param {string} language Language of the text.
 * @returns {Object} The found passive sentences.
 */
const getMorphologicalPassives = function getMorphologicalPassives(sentences, language) {
	const passiveSentences = [];

	(0, _lodashEs$u.forEach)(sentences, function (sentence) {
		const strippedSentence = (0, _stripHTMLTags$2.stripFullTags)(sentence.getSentenceText()).toLocaleLowerCase();

		sentence.setPassive((0, _determinePassiveSentence2.default)(strippedSentence, language));

		if (sentence.isPassive() === true) {
			passiveSentences.push(sentence.getSentenceText());
		}
	});

	return passiveSentences;
};

/**
 * Looks for periphrastic passive voice.
 *
 * @param {Array} sentences Sentences extracted from the text.
 * @param {string} language Language of the text.
 * @returns {Object} The found passive sentences.
 */
const getPeriphrasticPassives = function getPeriphrasticPassives(sentences, language) {
	const passiveSentences = [];

	(0, _lodashEs$u.forEach)(sentences, function (sentence) {
		const strippedSentence = (0, _stripHTMLTags$2.stripFullTags)(sentence.getSentenceText()).toLocaleLowerCase();

		// The functionality based on sentencePart objects should be rewritten using array indices of stopwords and auxiliaries.
		let sentenceParts = [];

		if (language === "de" || language === "nl" || language === "pl" || language === "hu") {
			sentenceParts = (0, _getSentencePartsSplitOnStopwords2.default)(strippedSentence, language);
		} else {
			sentenceParts = (0, _getSentenceParts2.default)(strippedSentence, language);
		}

		let passive = false;
		(0, _lodashEs$u.forEach)(sentenceParts, function (sentencePart) {
			sentencePart.setPassive((0, _determinePassiveSentencePart2.default)(sentencePart.getSentencePartText(), sentencePart.getAuxiliaries(), language));
			passive = passive || sentencePart.isPassive();
		});
		if (passive) {
			passiveSentences.push(sentence.getSentenceText());
		}
	});

	return passiveSentences;
};

/**
 * Looks for both morphological and periphrastic passive voice
 *
 * @param {Array} sentences Sentences extracted from the text.
 * @param {string} language Language of the text.
 *
 * @returns {Object} The found passive sentences.
 */
const getMorphologicalAndPeriphrasticPassive = function getMorphologicalAndPeriphrasticPassive(sentences, language) {
	const morphologicalSentences = getMorphologicalPassives(sentences, language);
	const periphrasticSentences = getPeriphrasticPassives(sentences, language);

	return morphologicalSentences.concat(periphrasticSentences);
};

var getSentenceBeginnings = {};

var getFirstWordExceptions = {};

var firstWordExceptions$e = {};

Object.defineProperty(firstWordExceptions$e, "__esModule", {
	value: true
});

firstWordExceptions$e.default = function () {
	return [
	// Definite articles:
	"the",
	// Indefinite articles:
	"a", "an",
	// Numbers 1-10:
	"one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten",
	// Demonstrative pronouns:
	"this", "that", "these", "those"];
};

var firstWordExceptions$d = {};

Object.defineProperty(firstWordExceptions$d, "__esModule", {
	value: true
});

firstWordExceptions$d.default = function () {
	return [
	// Definite articles:
	"das", "dem", "den", "der", "des", "die",
	// Indefinite articles:
	"ein", "eine", "einem", "einen", "einer", "eines",
	// Numbers 1-10:
	"eins", "zwei", "drei", "vier", "fünf", "sechs", "sieben", "acht", "neun", "zehn",
	// Demonstrative pronouns:
	"denen", "deren", "derer", "dessen", "diese", "diesem", "diesen", "dieser", "dieses", "jene", "jenem", "jenen", "jener", "jenes", "welch", "welcher", "welches"];
};

var firstWordExceptions$c = {};

Object.defineProperty(firstWordExceptions$c, "__esModule", {
	value: true
});

firstWordExceptions$c.default = function () {
	return [
	// Definite articles:
	"el", "los", "la", "las",
	// Indefinite articles:
	"un", "una", "unas", "unos",
	// Numbers 1-10:
	"uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve", "diez",
	// Demonstrative pronouns:
	"este", "estos", "esta", "estas", "ese", "esos", "esa", "esas", "aquel", "aquellos", "aquella", "aquellas", "esto", "eso", "aquello"];
};

var firstWordExceptions$b = {};

Object.defineProperty(firstWordExceptions$b, "__esModule", {
	value: true
});

firstWordExceptions$b.default = function () {
	return [
	// Definite articles:
	"le", "la", "les",
	// Indefinite articles:
	"un", "une",
	// Numbers 2-10 ('une' is already included in the indefinite articles):
	"deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf", "dix",
	// Demonstrative pronouns:
	"celui", "celle", "ceux", "celles", "celui-ci", "celle-là", "celui-là", "celle-ci"];
};

var firstWordExceptions$a = {};

Object.defineProperty(firstWordExceptions$a, "__esModule", {
	value: true
});

firstWordExceptions$a.default = function () {
	return [
	// Definite articles:
	"de", "het",
	// Indefinite articles:
	"een",
	// Numbers 1-10:
	"één", "eén", "twee", "drie", "vier", "vijf", "zes", "zeven", "acht", "negen", "tien",
	// Demonstrative pronouns:
	"dit", "dat", "die", "deze"];
};

var firstWordExceptions$9 = {};

Object.defineProperty(firstWordExceptions$9, "__esModule", {
	value: true
});

firstWordExceptions$9.default = function () {
	return [
	// Definite articles:
	"il", "lo", "la", "i", "gli", "le",
	// Indefinite articles:
	"uno", "un", "una",
	// Numbers 1-10 ('uno' is already included above):
	"due", "tre", "quattro", "cinque", "sei", "sette", "otto", "nove", "dieci",
	// Demonstrative pronouns:
	"questo", "questa", "quello", "quella", "questi", "queste", "quelli", "quelle", "codesto", "codesti", "codesta", "codeste"];
};

var firstWordExceptions$8 = {};

Object.defineProperty(firstWordExceptions$8, "__esModule", {
	value: true
});

firstWordExceptions$8.default = function () {
	return [
	// Numbers 1-10:
	"один", "одна", "одно", "два", "две", "три", "четыре", "пять", "шесть", "семь", "восемь", "девять", "десять",
	// Demonstrative pronouns: тот, этот, такой, таков, столько
	"этот", "этого", "этому", "этим", "этом", "эта", "этой", "эту", "это", "этого", "этому", "эти", "этих", "этим", "этими", "тот", "того", "тому", "тем", "том", "та", "той", "ту", "те", "тех", "тем", "теми", "тех", "такой", "такого", "такому", "таким", "такая", "такую", "такое", "такие", "таких", "таким", "такими", "стольких", "стольким", "столько", "столькими", "вот"];
};

var firstWordExceptions$7 = {};

Object.defineProperty(firstWordExceptions$7, "__esModule", {
	value: true
});

firstWordExceptions$7.default = function () {
	return [
	// Numbers 1-10:
	"jeden", "jedna", "jedno", "dwa", "dwie", "trzy", "cztery", "pięć", "sześć", "siedem", "osiem", "dziewięć", "dziesięć",
	// Demonstrative pronouns:
	"ta", "to", "ten", "te", "ci", "taki", "tacy", "taka", "taką", "takich", "takie", "takiego", "takiej", "takiemu", "takim", "takimi", "tamten", "tamta", "tamto", "tamci", "tamte", "tamtą", "tamtego", "tamtej", "tamtemu", "tamtych", "tamtym", "tamtymi", "tą", "tę", "tego", "tej", "temu", "tych", "tymi", "tym", "tak"];
};

var firstWordExceptions$6 = {};

Object.defineProperty(firstWordExceptions$6, "__esModule", {
	value: true
});

firstWordExceptions$6.default = function () {
	return [
	// Indefinite articles:
	"ett",
	// Definite articles:
	"det", "den", "de",
	// Numbers 1-10:
	"en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio",
	// Demonstrative pronouns:
	"denne", "denna", "detta", "dessa"];
};

var firstWordExceptions$5 = {};

Object.defineProperty(firstWordExceptions$5, "__esModule", {
	value: true
});

firstWordExceptions$5.default = function () {
	return [
	// Definite articles:
	"o", "a", "os", "as",
	// Indefinite articles:
	"um", "uma", "uns", "umas",
	// Numbers 1-10:
	"um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove", "dez",
	// Demonstrative pronouns:
	"este", "estes", "esta", "estas", "esse", "esses", "essa", "essas", "aquele", "aqueles", "aquela", "aquelas", "isto", "isso", "aquilo"];
};

var firstWordExceptions$4 = {};

Object.defineProperty(firstWordExceptions$4, "__esModule", {
	value: true
});

firstWordExceptions$4.default = function () {
	return [
	// Indefinite articles:
	"sebuah", "seorang", "sang", "si",
	// Numbers 1-10:
	"satu", "dua", "tiga", "empat", "lima", "enam", "tujuh", "delapan", "sembilan", "sepuluh", "sebelas", "seratus", "seribu", "sejuta", "semiliar", "setriliun",
	// Demonstrative pronouns:
	"ini", "itu", "hal", "ia"];
};

var firstWordExceptions$3 = {};

Object.defineProperty(firstWordExceptions$3, "__esModule", {
	value: true
});

firstWordExceptions$3.default = function () {
	return [
	// Indefinite articles:
	"אחד", "כמה", "מעטים",
	// Numbers 1-10 (feminine-masculine pairs):
	"אחת", "שנים", "שתים", "שלשה", "שלש", "ארבעה", "ארבע", "חמשה", "חמש", "ששה", "שש", "שבעה", "שבע", "שמונה", "שמונה", "תשעה", "תשע", "עשרה", "עשר",
	// Demonstrative pronouns:
	"זה", "זאת", "אלה", "אוה", "היא", "אלה", "המה", "הם", "הנה"];
};

var firstWordExceptions$2 = {};

Object.defineProperty(firstWordExceptions$2, "__esModule", {
	value: true
});

firstWordExceptions$2.default = function () {
	return [
	// Articles (those which are not prefixes):
	"قليل", "بعض", "واحد",
	// Numbers 1-10:
	"واحد", "إثنان", "ثلاثة", "أربعة", "خمسة", "ستة", "سبعة", "ثمانية", "تسعة", "عشرة",
	// Demonstrative pronouns:
	"هذا", "هذه", "ذلك", "تلك", "هذين", "هذان", "هتين", "هتان", "هؤلا", "أولائك", "هؤلاء"];
};

var firstWordExceptions$1 = {};

Object.defineProperty(firstWordExceptions$1, "__esModule", {
	value: true
});

firstWordExceptions$1.default = function () {
	return [
	// Definite articles:
	"az", "a",
	// Indefinite article:
	"egy",
	// Numbers 0 to 10, 100, 1000:
	"nulla", "egy", "kettő", "kettő", "három", "négy", "öt", "hat", "hét", "nyolc", "kilenc", "tíz", "száz", "ezer",
	// Conjunctions:
	"és", "se", "sem", "vagy", "de",
	// Adverbs:
	"aztán", "ezután", "azután", "majd", "ezek után", "nagyon", "kicsit", "nagy", "kevés", "sok", "sokan", "kevesen", "jól",
	// Demonstrative pronouns:
	"ez", "ezek", "az", "azok", "néhány", "aki", "ami",
	// Personal pronouns:
	"én", "mi", "ő", "ők", "engem", "nekem", "velem", "nálam", "hozzám", "tőlem", "rajtam", "rám", "rólam", "téged", "neked", "veled", "érted", "nálad", "hozzád", "tőled", "rólad", "őt", "neki", "vele", "érte", "nála", "hozzá", "tőle", "rajta", "rá", "róla", "minket", "nekünk", "velünk", "értünk", "nálunk", "hozzánk", "tőlünk", "rólunk", "titeket", "nektek", "veletek", "értetek", "nálatok", "hozzátok", "tőletek", "rajtatok", "rátok", "rólatok", "őket", "nekik", "velük", "értük", "bennük", "náluk", "hozzájuk", "tőlük", "rajtuk", "rájuk", "róluk",
	// Transition words:
	"azonban", "ám", "ha", "szerintem", "míg", "bár", "habár", "hát", "ha", "amennyiben", "mivel", "azonban", "amíg", "azért", "ezért",
	// Interrogatives:
	"mi", "mit", "miért", "meddig", "mikor", "hány", "mennyi", "ki", "kit", "merre", "hogy", "hogyan", "miként", "hol", "honnan", "hová", "mivel", "milyen",
	// Interjections:
	"ó", "óh", "jaj",
	// Colours:
	"kék", "zöld", "fekete", "sárga", "piros", "szürke",
	// Miscellaneous:
	"ne", "nem", "hát", "nos"];
};

var firstWordExceptions = {};

Object.defineProperty(firstWordExceptions, "__esModule", {
	value: true
});

firstWordExceptions.default = function () {
	return [
	// Demonstrative pronouns:
	"bunlar", "şunlar", "onlar”, “burası", "orası", "şurası", "burayı", "orayı", "şurayı”, “buraya", "oraya", "şuraya”, “burada", "orada", "şurada”, “buradan", "oradan", "şuradan",
	// Demonstrative adjectives:
	"bu", "şu", "o",
	// Numbers:
	"bir", "íki", "üç", "dört", "beş", "altı", "yedi", "sekiz", "dokuz", "on"];
};

Object.defineProperty(getFirstWordExceptions, "__esModule", {
	value: true
});

getFirstWordExceptions.default = function (locale) {
	const firstWordExceptions = {
		en: _firstWordExceptions2.default,
		de: _firstWordExceptions4.default,
		fr: _firstWordExceptions8.default,
		es: _firstWordExceptions6.default,
		nl: _firstWordExceptions10.default,
		it: _firstWordExceptions12.default,
		ru: _firstWordExceptions14.default,
		pl: _firstWordExceptions16.default,
		sv: _firstWordExceptions18.default,
		pt: _firstWordExceptions20.default,
		id: _firstWordExceptions22.default,
		he: _firstWordExceptions24.default,
		ar: _firstWordExceptions26.default,
		hu: _firstWordExceptions28.default,
		tr: _firstWordExceptions30.default
	};

	// If available, return the language-specific first word exceptions.
	if (Object.keys(firstWordExceptions).includes((0, _getLanguage2$8.default)(locale))) {
		return firstWordExceptions[(0, _getLanguage2$8.default)(locale)];
	}

	// Return the English first word exceptions as a default.
	return _firstWordExceptions2.default;
};

var _firstWordExceptions = firstWordExceptions$e;

var _firstWordExceptions2 = _interopRequireDefault$G(_firstWordExceptions);

var _firstWordExceptions3 = firstWordExceptions$d;

var _firstWordExceptions4 = _interopRequireDefault$G(_firstWordExceptions3);

var _firstWordExceptions5 = firstWordExceptions$c;

var _firstWordExceptions6 = _interopRequireDefault$G(_firstWordExceptions5);

var _firstWordExceptions7 = firstWordExceptions$b;

var _firstWordExceptions8 = _interopRequireDefault$G(_firstWordExceptions7);

var _firstWordExceptions9 = firstWordExceptions$a;

var _firstWordExceptions10 = _interopRequireDefault$G(_firstWordExceptions9);

var _firstWordExceptions11 = firstWordExceptions$9;

var _firstWordExceptions12 = _interopRequireDefault$G(_firstWordExceptions11);

var _firstWordExceptions13 = firstWordExceptions$8;

var _firstWordExceptions14 = _interopRequireDefault$G(_firstWordExceptions13);

var _firstWordExceptions15 = firstWordExceptions$7;

var _firstWordExceptions16 = _interopRequireDefault$G(_firstWordExceptions15);

var _firstWordExceptions17 = firstWordExceptions$6;

var _firstWordExceptions18 = _interopRequireDefault$G(_firstWordExceptions17);

var _firstWordExceptions19 = firstWordExceptions$5;

var _firstWordExceptions20 = _interopRequireDefault$G(_firstWordExceptions19);

var _firstWordExceptions21 = firstWordExceptions$4;

var _firstWordExceptions22 = _interopRequireDefault$G(_firstWordExceptions21);

var _firstWordExceptions23 = firstWordExceptions$3;

var _firstWordExceptions24 = _interopRequireDefault$G(_firstWordExceptions23);

var _firstWordExceptions25 = firstWordExceptions$2;

var _firstWordExceptions26 = _interopRequireDefault$G(_firstWordExceptions25);

var _firstWordExceptions27 = firstWordExceptions$1;

var _firstWordExceptions28 = _interopRequireDefault$G(_firstWordExceptions27);

var _firstWordExceptions29 = firstWordExceptions;

var _firstWordExceptions30 = _interopRequireDefault$G(_firstWordExceptions29);

var _getLanguage$8 = getLanguage;

var _getLanguage2$8 = _interopRequireDefault$G(_getLanguage$8);

function _interopRequireDefault$G(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(getSentenceBeginnings, "__esModule", {
	value: true
});

getSentenceBeginnings.default = function (paper, researcher) {
	let sentences = researcher.getResearch("sentences");
	const firstWordExceptions = (0, _getFirstWordExceptions2.default)(paper.getLocale())();

	let sentenceBeginnings = sentences.map(function (sentence) {
		return getSentenceBeginning(sentence, firstWordExceptions);
	});

	sentences = sentences.filter(function (sentence) {
		return (0, _getWords2$4.default)((0, _stripSpaces2$2.default)(sentence)).length > 0;
	});
	sentenceBeginnings = (0, _lodashEs$t.filter)(sentenceBeginnings);

	return compareFirstWords(sentenceBeginnings, sentences);
};

var _getWords$4 = getWords;

var _getWords2$4 = _interopRequireDefault$F(_getWords$4);

var _stripSpaces$2 = stripSpaces;

var _stripSpaces2$2 = _interopRequireDefault$F(_stripSpaces$2);

var _getFirstWordExceptions = getFirstWordExceptions;

var _getFirstWordExceptions2 = _interopRequireDefault$F(_getFirstWordExceptions);

var _stripHTMLTags$1 = stripHTMLTags;

var _lodashEs$t = require$$1$1;

function _interopRequireDefault$F(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Compares the first word of each sentence with the first word of the following sentence.
 *
 * @param {string} currentSentenceBeginning The first word of the current sentence.
 * @param {string} nextSentenceBeginning The first word of the next sentence.
 * @returns {boolean} Returns true if sentence beginnings match.
 */
const startsWithSameWord = function startsWithSameWord(currentSentenceBeginning, nextSentenceBeginning) {
	if (!(0, _lodashEs$t.isEmpty)(currentSentenceBeginning) && currentSentenceBeginning === nextSentenceBeginning) {
		return true;
	}

	return false;
};

/**
 * Counts the number of similar sentence beginnings.
 *
 * @param {Array} sentenceBeginnings The array containing the first word of each sentence.
 * @param {Array} sentences The array containing all sentences.
 * @returns {Array} The array containing the objects containing the first words and the corresponding counts.
 */
const compareFirstWords = function compareFirstWords(sentenceBeginnings, sentences) {
	const consecutiveFirstWords = [];
	let foundSentences = [];
	let sameBeginnings = 1;

	(0, _lodashEs$t.forEach)(sentenceBeginnings, function (beginning, i) {
		const currentSentenceBeginning = beginning;
		const nextSentenceBeginning = sentenceBeginnings[i + 1];
		foundSentences.push(sentences[i]);

		if (startsWithSameWord(currentSentenceBeginning, nextSentenceBeginning)) {
			sameBeginnings++;
		} else {
			consecutiveFirstWords.push({ word: currentSentenceBeginning, count: sameBeginnings, sentences: foundSentences });
			sameBeginnings = 1;
			foundSentences = [];
		}
	});

	return consecutiveFirstWords;
};

/**
 * Retrieves the first word from the sentence.
 *
 * @param {string} sentence The sentence to retrieve the first word from.
 * @param {Array} firstWordExceptions Exceptions to match against.
 * @returns {string} The first word of the sentence.
 */
function getSentenceBeginning(sentence, firstWordExceptions) {
	const words = (0, _getWords2$4.default)((0, _stripHTMLTags$1.stripFullTags)((0, _stripSpaces2$2.default)(sentence)));

	if (words.length === 0) {
		return "";
	}

	let firstWord = words[0].toLocaleLowerCase();

	if (firstWordExceptions.indexOf(firstWord) > -1 && words.length > 1) {
		firstWord += " " + words[1];
	}

	return firstWord;
}

var relevantWords$1 = {};

Object.defineProperty(relevantWords$1, "__esModule", {
	value: true
});

var _relevantWords$1 = relevantWords$2;

var _countWords$2 = countWords;

var _countWords2$2 = _interopRequireDefault$E(_countWords$2);

function _interopRequireDefault$E(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Retrieves the relevant words from the given paper.
 *
 * @param {Paper} paper The paper to determine the relevant words of.
 *
 * @returns {Object}            result                     A compound result object.
 * @returns {WordCombination[]} result.prominentWords      Relevant words for this paper, filtered and sorted.
 * @returns {boolean}           result.hasMetaDescription  Whether the metadescription is available in the input paper.
 * @returns {boolean}           result.hasTitle            Whether the title is available in the input paper.
 */
function relevantWords(paper) {
	const text = paper.getText();
	const metadescription = paper.getDescription();
	const title = paper.getTitle();

	const result = {};
	result.hasMetaDescription = metadescription !== "";
	result.hasTitle = title !== "";
	result.prominentWords = [];

	/**
  * We only want to return suggestions (and spend time calculating prominent words) if the text is at least 300 words
  * and has a title or a metadescription of if the text is at least 400 words if it has neither.
  */
	if ((0, _countWords2$2.default)(text) < 400) {
		return result;
	}

	result.prominentWords = (0, _relevantWords$1.getRelevantWords)(paper.getText(), paper.getLocale());
	return result;
}

relevantWords$1.default = relevantWords;

var readingTime = {};

Object.defineProperty(readingTime, "__esModule", {
	value: true
});

readingTime.default = function (paper) {
	const language = (0, _getLanguage2$7.default)(paper.getLocale());

	/*
  * These numbers are based on research into average reading times:
  * Susanne Trauzettel-Klosinski, Klaus Dietz, the IReST Study Group;
  * Standardized Assessment of Reading Performance: The New International Reading Speed Texts IReST.
  * Invest. Ophthalmol. Vis. Sci. 2012;53(9):5452-5461
  */
	const wordsPerMinute = {
		ar: 138,
		cn: 158,
		de: 179,
		en: 228,
		es: 218,
		fi: 161,
		fr: 195,
		he: 187,
		it: 188,
		ja: 193,
		nl: 202,
		pl: 166,
		pt: 181,
		ru: 184,
		sl: 180,
		sv: 199,
		tr: 166
	};
	const minutesPerImage = 0.2;

	let wordsPerMinuteScore = wordsPerMinute[language];

	// If the language is not on the list, assign the average of all language-dependent reading times as the score.
	if (!wordsPerMinuteScore) {
		const sumWordsPerMinute = Object.values(wordsPerMinute).reduce((a, b) => a + b);
		const sumNumberOfLanguages = Object.keys(wordsPerMinute).length;
		wordsPerMinuteScore = sumWordsPerMinute / sumNumberOfLanguages;
	}

	const numberOfWords = (0, _wordCountInText2$1.default)(paper);
	const numberOfImages = (0, _imageCountInText2$1.default)(paper);

	/*
  * This formula is based on the average number of words a person is expected to read per minute,
  * plus extra time for each image in the text. It returns the expected reading time in whole minutes,
  * rounded up to the nearest minute.
  */
	return Math.ceil(numberOfWords / wordsPerMinuteScore + numberOfImages * minutesPerImage);
};

var _getLanguage$7 = getLanguage;

var _getLanguage2$7 = _interopRequireDefault$D(_getLanguage$7);

var _wordCountInText$1 = wordCountInText;

var _wordCountInText2$1 = _interopRequireDefault$D(_wordCountInText$1);

var _imageCountInText$1 = imageCountInText;

var _imageCountInText2$1 = _interopRequireDefault$D(_imageCountInText$1);

function _interopRequireDefault$D(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTopicDensity = {};

var topicCount = {};

var parseSynonyms = {};

var removePunctuationExceptQuotes = {};

Object.defineProperty(removePunctuationExceptQuotes, "__esModule", {
  value: true
});

removePunctuationExceptQuotes.default = function (text) {
  text = text.replace(punctuationRegexStart, "");
  text = text.replace(punctuationRegexEnd, "");

  return text;
};

// Replace all other punctuation characters at the beginning or at the end of a word.
const punctuationRegexString = "[\\–\\-\\(\\)_\\[\\]’'.?!:;,¿¡«»‹›\u2014\u00d7\u002b\u0026\<\>]+";
const punctuationRegexStart = new RegExp("^" + punctuationRegexString);
const punctuationRegexEnd = new RegExp(punctuationRegexString + "$");

Object.defineProperty(parseSynonyms, "__esModule", {
	value: true
});

parseSynonyms.default = function (synonyms) {
	let synonymsSplit = synonyms.split(",");

	synonymsSplit = synonymsSplit.map(function (synonym) {
		return (0, _removePunctuationExceptQuotes2.default)((0, _stripSpaces2$1.default)(synonym));
	}).filter(function (synonym) {
		return synonym;
	});
	return synonymsSplit;
};

var _stripSpaces$1 = stripSpaces;

var _stripSpaces2$1 = _interopRequireDefault$C(_stripSpaces$1);

var _removePunctuationExceptQuotes = removePunctuationExceptQuotes;

var _removePunctuationExceptQuotes2 = _interopRequireDefault$C(_removePunctuationExceptQuotes);

function _interopRequireDefault$C(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(topicCount, "__esModule", {
	value: true
});

topicCount.default = function (paper, onlyKeyword = false) {
	const keyword = paper.getKeyword();
	const synonyms = (0, _parseSynonyms2$1.default)(paper.getSynonyms());
	const text = (0, _quotes$3.normalize)(paper.getText());
	const sentences = (0, _getSentences2$1.default)(text);
	let topicWords = [];

	if (onlyKeyword === true) {
		topicWords = topicWords.concat(keyword);
	} else {
		topicWords = topicWords.concat(keyword, synonyms).filter(Boolean);
		topicWords.sort((a, b) => b.length - a.length);
	}

	if ((0, _lodashEs$s.isEmpty)(topicWords)) {
		return {
			count: 0,
			matches: [],
			markings: [],
			matchesIndices: []
		};
	}

	let topicFound = [];
	let topicFoundInSentence = [];
	let markings = [];
	let indexOfSentence = 0;
	let indexRunningThroughSentence = 0;
	const matchesIndices = [];

	sentences.forEach(function (sentence) {
		topicFoundInSentence = (0, _matchTextWithArray2.default)(sentence, topicWords, paper.getLocale()).matches;
		if (topicFoundInSentence.length > 0) {
			topicFoundInSentence.forEach(function (occurrence) {
				const indexOfOccurrenceInSentence = sentence.indexOf(occurrence, indexRunningThroughSentence);
				matchesIndices.push({
					index: indexOfOccurrenceInSentence + indexOfSentence,
					match: occurrence
				});
				indexRunningThroughSentence += indexOfOccurrenceInSentence + occurrence.length;
			});

			markings = markings.concat(new _Mark2$1.default({
				original: sentence,
				marked: sentence.replace((0, _createRegexFromArray2.default)(topicFoundInSentence), function (x) {
					return (0, _addMarkSingleWord2.default)(x);
				})
			}));
		}

		topicFound = topicFound.concat(topicFoundInSentence);
		indexOfSentence += sentence.length + 1;
	});

	return {
		count: topicFound.length,
		matches: (0, _lodashEs$s.uniq)(topicFound).sort((a, b) => b.length - a.length),
		markings: markings,
		matchesIndices: matchesIndices
	};
};

var _matchTextWithArray = matchTextWithArray;

var _matchTextWithArray2 = _interopRequireDefault$B(_matchTextWithArray);

var _quotes$3 = quotes;

var _parseSynonyms$1 = parseSynonyms;

var _parseSynonyms2$1 = _interopRequireDefault$B(_parseSynonyms$1);

var _lodashEs$s = require$$1$1;

var _getSentences$1 = getSentences;

var _getSentences2$1 = _interopRequireDefault$B(_getSentences$1);

var _createRegexFromArray = createRegexFromArray;

var _createRegexFromArray2 = _interopRequireDefault$B(_createRegexFromArray);

var _addMarkSingleWord = addMarkSingleWord;

var _addMarkSingleWord2 = _interopRequireDefault$B(_addMarkSingleWord);

var _Mark$1 = Mark$1;

var _Mark2$1 = _interopRequireDefault$B(_Mark$1);

function _interopRequireDefault$B(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(getTopicDensity, "__esModule", {
	value: true
});

getTopicDensity.default = function (paper) {
	const wordCount = (0, _countWords2$1.default)(paper.getText());
	if (wordCount === 0) {
		return 0;
	}
	const topicCountResult = (0, _topicCount2$1.default)(paper).count;
	return topicCountResult / wordCount * 100;
};

var _countWords$1 = countWords;

var _countWords2$1 = _interopRequireDefault$A(_countWords$1);

var _topicCount$1 = topicCount;

var _topicCount2$1 = _interopRequireDefault$A(_topicCount$1);

function _interopRequireDefault$A(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keyphraseDistribution$3 = {};

var mergeListItems$1 = {};

Object.defineProperty(mergeListItems$1, "__esModule", {
	value: true
});
mergeListItems$1.mergeListItems = mergeListItems;
/**
 * Removes list-related html tags in a text to be used for the keyphrase distribution assessment.
 * That way, lists with single words don't result in a skewed keyphrase distribution result.
 *
 * @param {string}  text    The text in which to remove the list structures.
 *
 * @returns {string} The text with all list structures removed.
 */
function mergeListItems(text) {
	const listTags = /<\/?(o|ul)(?:[^>]+)?>/g;
	const listItemTags = /\s?<\/?li(?:[^>]+)?>\s?/g;

	/*
  * Steps:
  * 1) Remove all ul and ol tags.
  * 2) Replace all li tags with spaces to avoid list items being stuck together.
  * 3) Replace multiple instances of whitespace with a single instance.
  */
	text = text.replace(listTags, "");
	text = text.replace(listItemTags, " ");
	text = text.replace(/\s+/g, " ");

	return text;
}

Object.defineProperty(keyphraseDistribution$3, "__esModule", {
	value: true
});
keyphraseDistribution$3.getDistraction = keyphraseDistribution$3.keyphraseDistributionResearcher = keyphraseDistribution$3.maximizeSentenceScores = keyphraseDistribution$3.computeScoresPerSentenceLongTopic = keyphraseDistribution$3.computeScoresPerSentenceShortTopic = undefined;

var _getSentences = getSentences;

var _getSentences2 = _interopRequireDefault$z(_getSentences);

var _mergeListItems = mergeListItems$1;

var _findKeywordFormsInString = findKeywordFormsInString;

var _lodashEs$r = require$$1$1;

var _markWordsInSentences = markWordsInSentences$1;

var _getLanguage$6 = getLanguage;

var _getLanguage2$6 = _interopRequireDefault$z(_getLanguage$6);

function _interopRequireDefault$z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks whether at least half of the content words from the topic are found within the sentence.
 * Assigns a score to every sentence following the following schema:
 * 9 if at least half of the content words from the topic are in the sentence,
 * 3 otherwise.
 *
 * @param {Array}  topic     The word forms of all content words in a keyphrase or a synonym.
 * @param {Array}  sentences An array of all sentences in the text.
 * @param {string} locale    The locale of the paper to analyse.
 *
 * @returns {Array} The scores per sentence.
 */
const computeScoresPerSentenceLongTopic = function computeScoresPerSentenceLongTopic(topic, sentences, locale) {
	const sentenceScores = Array(sentences.length);

	for (let i = 0; i < sentences.length; i++) {
		const foundInCurrentSentence = (0, _findKeywordFormsInString.findWordFormsInString)(topic, sentences[i], locale);

		if (foundInCurrentSentence.percentWordMatches >= 50) {
			sentenceScores[i] = 9;
		} else {
			sentenceScores[i] = 3;
		}
	}

	return sentenceScores;
};

/**
 * Checks whether all content words from the topic are found within one sentence.
 * Assigns a score to every sentence following the following schema:
 * 9 if all content words from the topic are in the sentence,
 * 3 if not all content words from the topic were found in the sentence.
 *
 * @param {Array}  topic     The word forms of all content words in a keyphrase or a synonym.
 * @param {Array}  sentences An array of all sentences in the text.
 * @param {string} locale    The locale of the paper to analyse.
 *
 * @returns {Array} The scores per sentence.
 */
const computeScoresPerSentenceShortTopic = function computeScoresPerSentenceShortTopic(topic, sentences, locale) {
	const sentenceScores = Array(sentences.length);

	for (let i = 0; i < sentences.length; i++) {
		const currentSentence = sentences[i];
		const foundInCurrentSentence = (0, _findKeywordFormsInString.findWordFormsInString)(topic, currentSentence, locale);
		if (foundInCurrentSentence.percentWordMatches === 100) {
			sentenceScores[i] = 9;
		} else {
			sentenceScores[i] = 3;
		}
	}
	return sentenceScores;
};

/**
 * Maximizes scores: Give every sentence a maximal score that it got from analysis of all topics
 *
 * @param {Array} sentenceScores The scores for every sentence, as assessed per keyphrase and every synonym.
 *
 * @returns {Array} Maximal scores of topic relevance per sentence.
 */
const maximizeSentenceScores = function maximizeSentenceScores(sentenceScores) {
	const sentenceScoresTransposed = sentenceScores[0].map(function (col, i) {
		return sentenceScores.map(function (row) {
			return row[i];
		});
	});

	return sentenceScoresTransposed.map(function (scoresForOneSentence) {
		return (0, _lodashEs$r.max)(scoresForOneSentence);
	});
};

/**
 * Computes the maximally long piece of text that does not include the topic.
 *
 * @param {Array} sentenceScores The array of scores per sentence.
 *
 * @returns {number} The maximum number of sentences that do not include the topic.
 */
const getDistraction = function getDistraction(sentenceScores) {
	const numberOfSentences = sentenceScores.length;
	const allTopicSentencesIndices = [];

	for (let i = 0; i < numberOfSentences; i++) {
		if (sentenceScores[i] > 3) {
			allTopicSentencesIndices.push(i);
		}
	}

	const numberOfTopicSentences = allTopicSentencesIndices.length;

	if (numberOfTopicSentences === 0) {
		return numberOfSentences;
	}

	/**
  * Add fake topic sentences at the very beginning and at the very end
  * to account for cases when the text starts or ends with a train of distraction.
  */
	allTopicSentencesIndices.unshift(-1);
	allTopicSentencesIndices.push(numberOfSentences);

	const distances = [];

	for (let i = 1; i < numberOfTopicSentences + 2; i++) {
		distances.push(allTopicSentencesIndices[i] - allTopicSentencesIndices[i - 1] - 1);
	}

	return (0, _lodashEs$r.max)(distances);
};

/**
 * Computes the per-sentence scores depending on the length of the topic phrase and maximizes them over all topic phrases.
 *
 * @param {Array}  sentences              The sentences to get scores for.
 * @param {Array}  topicFormsInOneArray   The topic phrases forms to search for in the sentences.
 * @param {string} locale                 The locale to work in.
 *
 * @returns {Object} An array with maximized score per sentence and an array with all sentences that do not contain the topic.
 */
const getSentenceScores = function getSentenceScores(sentences, topicFormsInOneArray, locale) {
	// Compute per-sentence scores of topic-relatedness.
	const topicNumber = topicFormsInOneArray.length;

	const sentenceScores = Array(topicNumber);

	// Determine whether the language has function words.
	const language = (0, _getLanguage2$6.default)(locale);

	// For languages with function words apply either full match or partial match depending on topic length
	if ((0, _lodashEs$r.indexOf)(["en", "de", "nl", "fr", "es", "it", "pt", "ru", "pl", "sv", "id", "ar", "he", "fa"], language) >= 0) {
		for (let i = 0; i < topicNumber; i++) {
			const topic = topicFormsInOneArray[i];
			if (topic.length < 4) {
				sentenceScores[i] = computeScoresPerSentenceShortTopic(topic, sentences, locale);
			} else {
				sentenceScores[i] = computeScoresPerSentenceLongTopic(topic, sentences, locale);
			}
		}
	} else {
		// For languages without function words apply the full match always
		for (let i = 0; i < topicNumber; i++) {
			const topic = topicFormsInOneArray[i];
			sentenceScores[i] = computeScoresPerSentenceShortTopic(topic, sentences, locale);
		}
	}

	// Maximize scores: Give every sentence a maximal score that it got from analysis of all topics
	const maximizedSentenceScores = maximizeSentenceScores(sentenceScores);

	// Zip an array combining each sentence with the associated maximized score.
	const sentencesWithMaximizedScores = (0, _lodashEs$r.zipWith)(sentences, maximizedSentenceScores, (sentence, score) => {
		return { sentence, score };
	});

	// Filter sentences that contain topic words for future highlights.
	const sentencesWithTopic = sentencesWithMaximizedScores.filter(sentenceObject => sentenceObject.score > 3);

	return {
		maximizedSentenceScores: maximizedSentenceScores,
		sentencesWithTopic: sentencesWithTopic.map(sentenceObject => sentenceObject.sentence)
	};
};

/**
 * Determines which portions of the text did not receive a lot of content words from keyphrase and synonyms.
 *
 * @param {Paper}       paper       The paper to check the keyphrase distribution for.
 * @param {Researcher}  researcher  The researcher to use for analysis.
 *
 * @returns {Object} The scores of topic relevance per portion of text and an array of all word forms to highlight.
 */
const keyphraseDistributionResearcher = function keyphraseDistributionResearcher(paper, researcher) {
	let text = paper.getText();
	text = (0, _mergeListItems.mergeListItems)(text);
	const sentences = (0, _getSentences2.default)(text);
	const topicForms = researcher.getResearch("morphology");
	const locale = paper.getLocale();
	const topicFormsInOneArray = [topicForms.keyphraseForms];

	topicForms.synonymsForms.forEach(function (synonym) {
		topicFormsInOneArray.push(synonym);
	});

	const allTopicWords = (0, _lodashEs$r.uniq)((0, _lodashEs$r.flattenDeep)(topicFormsInOneArray)).sort((a, b) => b.length - a.length);

	// Get per-sentence scores and sentences that have topic.
	const sentenceScores = getSentenceScores(sentences, topicFormsInOneArray, locale);
	const maximizedSentenceScores = sentenceScores.maximizedSentenceScores;
	const maxLengthDistraction = getDistraction(maximizedSentenceScores);

	return {
		sentencesToHighlight: (0, _markWordsInSentences.markWordsInSentences)(allTopicWords, sentenceScores.sentencesWithTopic, locale),
		keyphraseDistributionScore: maxLengthDistraction / sentences.length * 100
	};
};

keyphraseDistribution$3.computeScoresPerSentenceShortTopic = computeScoresPerSentenceShortTopic;
keyphraseDistribution$3.computeScoresPerSentenceLongTopic = computeScoresPerSentenceLongTopic;
keyphraseDistribution$3.maximizeSentenceScores = maximizeSentenceScores;
keyphraseDistribution$3.keyphraseDistributionResearcher = keyphraseDistributionResearcher;
keyphraseDistribution$3.getDistraction = getDistraction;

var functionWordsInKeyphrase = {};

Object.defineProperty(functionWordsInKeyphrase, "__esModule", {
	value: true
});

functionWordsInKeyphrase.default = function (paper) {
	const keyphrase = paper.getKeyword();

	// Return false if there are double quotes around the keyphrase.
	const doubleQuotes = ["“", "”", "〝", "〞", "〟", "‟", "„", "\""];
	if ((0, _lodashEs$q.includes)(doubleQuotes, keyphrase[0]) && (0, _lodashEs$q.includes)(doubleQuotes, keyphrase[keyphrase.length - 1])) {
		return false;
	}

	let keyphraseWords = (0, _getWords2$3.default)(keyphrase);
	const functionWords = (0, _lodashEs$q.get)(getFunctionWords, [(0, _getLanguage2$5.default)(paper.getLocale())], []);

	keyphraseWords = (0, _lodashEs$q.filter)(keyphraseWords, function (word) {
		return !(0, _lodashEs$q.includes)(functionWords.all, word.trim().toLocaleLowerCase());
	});

	return (0, _lodashEs$q.isEmpty)(keyphraseWords);
};

var _lodashEs$q = require$$1$1;

var _getWords$3 = getWords;

var _getWords2$3 = _interopRequireDefault$y(_getWords$3);

var _getLanguage$5 = getLanguage;

var _getLanguage2$5 = _interopRequireDefault$y(_getLanguage$5);

var _getFunctionWords$1 = getFunctionWords$3;

var _getFunctionWords2$1 = _interopRequireDefault$y(_getFunctionWords$1);

function _interopRequireDefault$y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getFunctionWords = (0, _getFunctionWords2$1.default)();

var h1s = {};

Object.defineProperty(h1s, "__esModule", {
	value: true
});

h1s.default = function (paper) {
	const text = paper.getText();

	let blocks = (0, _html.getBlocks)(text);
	blocks = (0, _lodashEs$p.reject)(blocks, emptyBlock);

	const h1s = [];
	blocks.forEach((block, index) => {
		const match = h1Regex.exec(block);
		if (match) {
			h1s.push({
				tag: "h1",
				content: match[1],
				position: index
			});
		}
	});

	return h1s;
};

var _html = html;

var _lodashEs$p = require$$1$1;

const h1Regex = /<h1.*?>(.*?)<\/h1>/;

/**
 * Gets a block from a text and checks if it is totally empty or if it is an empty paragraph.
 *
 * @param {string} block A HTML block extracted from the paper.
 *
 * @returns {boolean} Whether the block is empty or not.
 */
const emptyBlock = function emptyBlock(block) {
	block = block.trim();
	return block === "<p></p>" || block === "";
};

var getProminentWordsForInsights$1 = {};

var determineProminentWords = {};

var retrieveStemmer = {};

Object.defineProperty(retrieveStemmer, "__esModule", {
  value: true
});

retrieveStemmer.default = function (language, morphologyData) {
  const stemFunction = stemFunctions[language];

  // Return the stem function if there is one for the given language and if morphology data is available.
  if (morphologyData && stemFunction) {
    return stemFunction;
  }

  // Return an identity function if the stem function and/or morphology data aren't available.
  return word => word;
};

var _getStemForLanguage = getStemForLanguage;

var _getStemForLanguage2 = _interopRequireDefault$x(_getStemForLanguage);

function _interopRequireDefault$x(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const stemFunctions = (0, _getStemForLanguage2.default)();

var ProminentWord$1 = {};

Object.defineProperty(ProminentWord$1, "__esModule", {
  value: true
});
/**
 * Represents a prominent word in the context of relevant words.
 *
 * @constructor
 *
 * @param {string} word             The word.
 * @param {string} [stem]           The stem / base form of the word, defaults to the word.
 * @param {number} [occurrences]    The number of occurrences, defaults to 0.
 */
function ProminentWord(word, stem, occurrences) {
  this._word = word;
  this._stem = stem ? stem : word;
  this._occurrences = occurrences || 0;
}

/**
 * Sets the word to the word combination.
 *
 * @param {string} word The word to set.
 *
 * @returns {void}.
 */
ProminentWord.prototype.setWord = function (word) {
  this._word = word;
};

/**
 * Returns the word.
 *
 * @returns {string} The word.
 */
ProminentWord.prototype.getWord = function () {
  return this._word;
};

/**
 * Returns the stem of the word.
 *
 * @returns {string} The stem.
 */
ProminentWord.prototype.getStem = function () {
  return this._stem;
};

/**
 * Sets the number of occurrences to the word.
 *
 * @param {int} numberOfOccurrences The number of occurrences to set.
 *
 * @returns {void}.
 */
ProminentWord.prototype.setOccurrences = function (numberOfOccurrences) {
  this._occurrences = numberOfOccurrences;
};

/**
 * Returns the amount of occurrences of this word combination.
 *
 * @returns {number} The number of occurrences.
 */
ProminentWord.prototype.getOccurrences = function () {
  return this._occurrences;
};

/**
 * Serializes the ProminentWord instance to an object.
 *
 * @returns {Object} The serialized ProminentWord.
 */
ProminentWord.prototype.serialize = function () {
  return {
    _parseClass: "ProminentWord",
    word: this._word,
    stem: this._stem,
    occurrences: this._occurrences
  };
};

/**
 * Parses the object to a WordCombination.
 *
 * @param {Object} serialized The serialized object.
 *
 * @returns {ProminentWord} The parsed WordCombination.
 */
ProminentWord.parse = function (serialized) {
  return new ProminentWord(serialized.word, serialized.stem, serialized.occurrences);
};

ProminentWord$1.default = ProminentWord;

Object.defineProperty(determineProminentWords, "__esModule", {
	value: true
});
determineProminentWords.retrieveAbbreviations = determineProminentWords.collapseProminentWordsOnStem = determineProminentWords.sortProminentWords = determineProminentWords.filterProminentWords = determineProminentWords.getProminentWordsFromPaperAttributes = determineProminentWords.getProminentWords = undefined;

var _lodashEs$o = require$$1$1;

var _retrieveStemmer$2 = retrieveStemmer;

var _retrieveStemmer2$2 = _interopRequireDefault$w(_retrieveStemmer$2);

var _getWords$2 = getWords;

var _getWords2$2 = _interopRequireDefault$w(_getWords$2);

var _quotes$2 = quotes;

var _ProminentWord$1 = ProminentWord$1;

var _ProminentWord2$1 = _interopRequireDefault$w(_ProminentWord$1);

var _getFunctionWords = getFunctionWords$3;

var _getFunctionWords2 = _interopRequireDefault$w(_getFunctionWords);

function _interopRequireDefault$w(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const functionWordLists = (0, _getFunctionWords2.default)();
const specialCharacters = /[1234567890‘’“”"'.…?!:;,¿¡«»&*@#±^%$|~=+§`[\](){}⟨⟩<>/\\–\-\u2014\u00d7\s]/g;

/**
 * Returns only those prominent words that occur more than a certain number of times and do not consist of special characters.
 *
 * @param {ProminentWord[]} prominentWords A list of prominent words.
 * @param {int} [minimalNumberOfOccurrences] A minimal number of occurrences that is needed for a relevant prominentWord, default 2.
 *
 * @returns {ProminentWord[]} Only relevant word combinations.
 */
function filterProminentWords(prominentWords, minimalNumberOfOccurrences = 2) {
	prominentWords = prominentWords.filter(function (combination) {
		return combination.getOccurrences() >= minimalNumberOfOccurrences && combination.getWord().replace(specialCharacters, "") !== "";
	});
	return prominentWords;
}

/**
 * Sorts prominent words based on their number of occurrences and length.
 *
 * @param {ProminentWord[]} prominentWords The prominent words to sort.
 *
 * @returns {void}
 */
function sortProminentWords(prominentWords) {
	prominentWords.sort(function (wordA, wordB) {
		const difference = wordB.getOccurrences() - wordA.getOccurrences();
		// The combination with the highest number of occurrences comes first.
		if (difference !== 0) {
			return difference;
		}

		// In case of a tie on occurrence number, the alphabetically first combination comes first.
		return wordA.getStem().localeCompare(wordB.getStem());
	});
}

/**
 * Collapses prominent words that have the same stem.
 *
 * @param {ProminentWord[]} prominentWords All prominentWords.
 *
 * @returns {ProminentWord[]} The original array with collapsed duplicates.
 */
function collapseProminentWordsOnStem(prominentWords) {
	if (prominentWords.length === 0) {
		return [];
	}

	// Sort the input array by stem
	prominentWords.sort(function (wordA, wordB) {
		return wordA.getStem().localeCompare(wordB.getStem());
	});

	const collapsedProminentWords = [];
	let previousWord = new _ProminentWord2$1.default(prominentWords[0].getWord(), prominentWords[0].getStem(), prominentWords[0].getOccurrences());

	for (let i = 1; i < prominentWords.length; i++) {
		const currentWord = new _ProminentWord2$1.default(prominentWords[i].getWord(), prominentWords[i].getStem(), prominentWords[i].getOccurrences());

		/*
   * Compare the stem of the current word in the loop with the previously available stem.
   * If they equal, word combinations should be collapsed.
   * When collapsing, the numbers of occurrences get summed.
   * If the stem happens to equal the real word that occurred in the text, we can be sure it's ok to display it
   * to the customer. So, the stem reassigns the word.
   */
		if (currentWord.getStem() === previousWord.getStem()) {
			previousWord.setOccurrences(previousWord.getOccurrences() + currentWord.getOccurrences());

			if (currentWord.getWord() === previousWord.getStem() || currentWord.getWord().toLocaleLowerCase() === previousWord.getStem()) {
				previousWord.setWord(currentWord.getWord());
			}
		} else {
			collapsedProminentWords.push(previousWord);
			previousWord = currentWord;
		}
	}

	collapsedProminentWords.push(previousWord);

	return collapsedProminentWords;
}

/**
 * Retrieves a function words list from the factory. Returns an empty array if the language does not have function words.
 *
 * @param {string} language The language to retrieve function words for.
 *
 * @returns {string[]} A list of function words for the language.
 */
function retrieveFunctionWords(language) {
	return (0, _lodashEs$o.get)(functionWordLists, language.concat(".all"), []);
}

/**
 * Retrieves a list of all abbreviations from the text. Returns an empty array if the input text is empty.
 *
 * @param {string} text A text.
 *
 * @returns {string[]} A list of abbreviations from the list.
 */
function retrieveAbbreviations(text) {
	const words = (0, _getWords2$2.default)((0, _quotes$2.normalizeSingle)(text));
	const abbreviations = [];

	words.forEach(function (word) {
		if (word.length > 1 && word.length < 5 && word === word.toLocaleUpperCase()) {
			abbreviations.push(word.toLocaleLowerCase());
		}
	});

	return (0, _lodashEs$o.uniq)(abbreviations);
}

/**
 * Computes prominent words from an array of words. In order to do so, checks whether the word is included in the list of
 * function words and determines the number of occurrences for every word. Then checks if any two words have the same stem
 * and if so collapses over them.
 *
 * @param {string[]} words          The words to determine relevance for.
 * @param {string[]} abbreviations  Abbreviations that should not be stemmed.
 * @param {string} language         The paper's language.
 * @param {Object} morphologyData   The morphologyData available for the language of the paper.
 *
 * @returns {ProminentWord[]} All prominent words sorted and filtered for this text.
 */
function computeProminentWords(words, abbreviations, language, morphologyData) {
	const functionWords = retrieveFunctionWords(language);
	const determineStem = (0, _retrieveStemmer2$2.default)(language, morphologyData);

	if (words.length === 0) {
		return [];
	}

	const uniqueContentWords = (0, _lodashEs$o.uniq)(words.filter(word => !functionWords.includes(word.trim())));
	const prominentWords = [];

	uniqueContentWords.forEach(function (word) {
		if (abbreviations.includes(word)) {
			prominentWords.push(new _ProminentWord2$1.default(word.toLocaleUpperCase(), word, words.filter(element => element === word).length));
		} else {
			prominentWords.push(new _ProminentWord2$1.default(word, determineStem(word, morphologyData), words.filter(element => element === word).length));
		}
	});

	return collapseProminentWordsOnStem(prominentWords);
}

/**
 * Caches prominent words depending on the currently available morphologyData and (separately) text words and language.
 * In this way, if the morphologyData remains the same in multiple calls of this function, the function
 * that collects actual prominent words only needs to check if the text words and language also remain the
 * same to return the cached result. The joining of words and language for this function is needed,
 * because by default memoize caches by the first key only, which in the current case would mean that the function would
 * return the cached forms if the text has not changed (without checking if language was changed).
 *
 * @param {Object|boolean}  morphologyData  The available morphology data.
 *
 * @returns {function} The function that collects prominent words for a given set of text words, language and morphologyData.
 */
const primeProminentWords = (0, _lodashEs$o.memoize)(morphologyData => {
	return (0, _lodashEs$o.memoize)((words, abbreviations, language) => {
		return computeProminentWords(words, abbreviations, language, morphologyData);
	}, (words, abbreviations, language) => {
		return words.join(",") + "," + abbreviations.join(",") + "," + language;
	});
});

/**
 * Gets prominent words from the paper text.
 *
 * @param {string}      text            The text to retrieve the prominent words from.
 * @param {string[]}    abbreviations   The abbreviations that occur in the text and attributes of the paper.
 * @param {string}      language        The paper's language.
 * @param {Object}      morphologyData  The morphologyData available for the language of the paper.
 *
 * @returns {ProminentWord[]} All prominent words sorted and filtered for this text.
 */
function getProminentWords(text, abbreviations, language, morphologyData) {
	if (text === "") {
		return [];
	}

	const words = (0, _getWords2$2.default)((0, _quotes$2.normalizeSingle)(text).toLocaleLowerCase());
	const computeProminentWordsMemoized = primeProminentWords(morphologyData);

	return computeProminentWordsMemoized(words, abbreviations, language, morphologyData);
}

/**
 * Gets prominent words from keyphrase and synonyms, metadescription, title, and subheadings.
 *
 * @param {string[]}    attributes       The array with attributes to process.
 * @param {string[]}    abbreviations    The abbreviations that occur in the text and attributes of the paper.
 * @param {string}      language         The language of the paper.
 * @param {Object}      morphologyData   The morphologyData available for the language of the paper.
 *
 * @returns {ProminentWord[]} Prominent words from the paper attributes.
 */
function getProminentWordsFromPaperAttributes(attributes, abbreviations, language, morphologyData) {
	const wordsFromAttributes = (0, _getWords2$2.default)(attributes.join(" ").toLocaleLowerCase());

	return computeProminentWords(wordsFromAttributes, abbreviations, language, morphologyData);
}

determineProminentWords.getProminentWords = getProminentWords;
determineProminentWords.getProminentWordsFromPaperAttributes = getProminentWordsFromPaperAttributes;
determineProminentWords.filterProminentWords = filterProminentWords;
determineProminentWords.sortProminentWords = sortProminentWords;
determineProminentWords.collapseProminentWordsOnStem = collapseProminentWordsOnStem;
determineProminentWords.retrieveAbbreviations = retrieveAbbreviations;
determineProminentWords.default = {
	getProminentWords,
	getProminentWordsFromPaperAttributes,
	filterProminentWords,
	sortProminentWords,
	collapseProminentWordsOnStem,
	retrieveAbbreviations
};

Object.defineProperty(getProminentWordsForInsights$1, "__esModule", {
	value: true
});

var _lodashEs$n = require$$1$1;

var _getLanguage$4 = getLanguage;

var _getLanguage2$4 = _interopRequireDefault$v(_getLanguage$4);

var _determineProminentWords$1 = determineProminentWords;

function _interopRequireDefault$v(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Retrieves the prominent words from the given paper.
 *
 * @param {Paper} paper The paper to determine the prominent words of.
 * @param {Researcher} researcher The researcher to use for analysis.
 *
 * @returns {WordCombination[]} Prominent words for this paper, filtered and sorted.
 */
function getProminentWordsForInsights(paper, researcher) {
	const text = paper.getText();
	const language = (0, _getLanguage2$4.default)(paper.getLocale());
	const morphologyData = (0, _lodashEs$n.get)(researcher.getData("morphology"), language, false);

	const abbreviations = (0, _determineProminentWords$1.retrieveAbbreviations)(text);

	const prominentWordsFromText = (0, _determineProminentWords$1.getProminentWords)(text, abbreviations, language, morphologyData);

	const collapsedWords = (0, _determineProminentWords$1.collapseProminentWordsOnStem)(prominentWordsFromText);
	(0, _determineProminentWords$1.sortProminentWords)(collapsedWords);

	/*
  * Collapse the list of prominent words on stems, sort it, filter out all words that occur less than
  * 5 times in the text. Return the 20 top items from this list.
  */
	return (0, _lodashEs$n.take)((0, _determineProminentWords$1.filterProminentWords)(collapsedWords, 5), 20);
}

getProminentWordsForInsights$1.default = getProminentWordsForInsights;

var getProminentWordsForInternalLinking$1 = {};

Object.defineProperty(getProminentWordsForInternalLinking$1, "__esModule", {
	value: true
});

var _lodashEs$m = require$$1$1;

var _getLanguage$3 = getLanguage;

var _getLanguage2$3 = _interopRequireDefault$u(_getLanguage$3);

var _countWords = countWords;

var _countWords2 = _interopRequireDefault$u(_countWords);

var _determineProminentWords = determineProminentWords;

var _getSubheadings = getSubheadings$1;

function _interopRequireDefault$u(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Retrieves the prominent words from the given paper.
 *
 * @param {Paper}       paper       The paper to determine the prominent words of.
 * @param {Researcher}  researcher  The researcher to use for analysis.
 *
 * @returns {Object}          result                    A compound result object.
 * @returns {ProminentWord[]} result.prominentWords     Prominent words for this paper, filtered and sorted.
 * @returns {boolean}         result.hasMetaDescription Whether the metadescription is available in the input paper.
 * @returns {boolean}         result.hasTitle           Whether the title is available in the input paper.
 */
function getProminentWordsForInternalLinking(paper, researcher) {
	const text = paper.getText();
	const metadescription = paper.getDescription();
	const title = paper.getTitle();

	const result = {};
	result.hasMetaDescription = metadescription !== "";
	result.hasTitle = title !== "";
	result.prominentWords = [];

	/**
  * We only want to return suggestions (and spend time calculating prominent words) if the text is at least 100 words.
 	 */
	const textLength = (0, _countWords2.default)(text);
	if (textLength < 100) {
		return result;
	}

	const language = (0, _getLanguage2$3.default)(paper.getLocale());
	const morphologyData = (0, _lodashEs$m.get)(researcher.getData("morphology"), language, false);

	const subheadings = (0, _getSubheadings.getSubheadingsTopLevel)(text).map(subheading => subheading[2]);
	const attributes = [paper.getKeyword(), paper.getSynonyms(), title, metadescription, subheadings.join(" ")];

	const abbreviations = (0, _determineProminentWords.retrieveAbbreviations)(text.concat(attributes.join(" ")));

	const prominentWordsFromText = (0, _determineProminentWords.getProminentWords)((0, _getSubheadings.removeSubheadingsTopLevel)(text), abbreviations, language, morphologyData);

	const prominentWordsFromPaperAttributes = (0, _determineProminentWords.getProminentWordsFromPaperAttributes)(attributes, abbreviations, language, morphologyData);

	/*
  * If a word is used in any of the attributes, its weight is automatically high.
  * To make sure the word survives weight filters and gets saved in the database, make the number of occurrences times-3.
  */
	prominentWordsFromPaperAttributes.forEach(relevantWord => relevantWord.setOccurrences(relevantWord.getOccurrences() * 3));

	const collapsedWords = (0, _determineProminentWords.collapseProminentWordsOnStem)(prominentWordsFromPaperAttributes.concat(prominentWordsFromText));
	(0, _determineProminentWords.sortProminentWords)(collapsedWords);

	/*
  * If morphology data are available for a language, the minimum number of occurrences to consider a word to be prominent is 4.
  * This minimum number was chosen in order to avoid premature suggestions of words from the paper attributes.
  * These get a times-3 boost and would therefore be prominent with just 1 occurrence.
  *
  * If morphology data are not available, and therefore word forms are not recognized, the minimum threshold is lowered to 2.
  */
	let minimumNumberOfOccurrences = 4;

	if (!morphologyData) {
		minimumNumberOfOccurrences = 2;
	}

	/*
  * Return the 100 top items from the collapsed and sorted list. The number is picked deliberately to prevent larger
  * articles from getting too long of lists.
  */
	result.prominentWords = (0, _lodashEs$m.take)((0, _determineProminentWords.filterProminentWords)(collapsedWords, minimumNumberOfOccurrences), 100);

	return result;
}

getProminentWordsForInternalLinking$1.default = getProminentWordsForInternalLinking;

var getWordForms$1 = {};

var require$$1 = /*@__PURE__*/getAugmentedNamespace(flattenDeep$1);

var getBasicWordForms = {};

var createBasicWordForms$5 = {};

Object.defineProperty(createBasicWordForms$5, "__esModule", {
	value: true
});
createBasicWordForms$5.createBasicWordForms = createBasicWordForms$4;
/**
 * Creates basic word forms for a given Hebrew word.
 *
 * @param {string} word     The word for which to create basic word forms.
 *
 * @returns {string}        Prefixed and de-prefixed variations of a word.
 */
function createBasicWordForms$4(word) {
	const prefixes = ["ב", "ה", "ו", "כ", "ל", "מ", "ש"];
	const forms = [];

	/*
  * Add prefixes to the input word. We always do this, since some words
  * beginning with a prefix-like letter might be exceptions where this is the
  * actual first letter of the word.
  */
	forms.push(...prefixes.map(prefix => prefix + word));

	let stemmedWord = "";

	/*
  * If a word starts with one of the prefixes, we strip it and create all possible
  * prefixed forms based on this stem.
  */
	if (prefixes.some(prefix => word.startsWith(prefix))) {
		stemmedWord = word.slice(1);
	}

	if (stemmedWord.length > 0) {
		forms.push(stemmedWord);
		forms.push(...prefixes.map(prefix => prefix + stemmedWord));
	}

	return forms;
}

var createBasicWordForms$3 = {};

Object.defineProperty(createBasicWordForms$3, "__esModule", {
	value: true
});
createBasicWordForms$3.createBasicWordForms = createBasicWordForms$2;
/**
 * Creates basic word forms for a given Arabic word.
 *
 * @param {string} word     The word for which to create basic word forms.
 *
 * @returns {Array}        Prefixed and de-prefixed variations of a word.
 */
function createBasicWordForms$2(word) {
	const prefixes = ["ل", "ب", "ك", "و", "ف", "س", "أ", "ال", "وب", "ول", "لل", "فس", "فب", "فل", "وس", "وال", "بال", "فال", "كال", "ولل", "وبال"];

	const forms = [];

	/*
  * Add prefixes to the input word. We always do this, since some words
  * beginning with a prefix-like letter might be exceptions where this is the
  * actual first letter of the word.
  */
	forms.push(...prefixes.map(prefix => prefix + word));

	let stemmedWord = "";

	/*
  * If a word starts with one of the prefixes, we strip it and create all possible
  * prefixed forms based on this stem.
  */
	for (const prefix of prefixes) {
		if (word.startsWith(prefix)) {
			stemmedWord = word.slice(prefix.length);
		}
	}

	if (stemmedWord.length > 0) {
		forms.push(stemmedWord);
		forms.push(...prefixes.map(prefix => prefix + stemmedWord));
	}

	return forms;
}

var createBasicWordForms$1 = {};

Object.defineProperty(createBasicWordForms$1, "__esModule", {
	value: true
});
createBasicWordForms$1.createBasicWordForms = createBasicWordForms;

var _regexHelpers = regexHelpers;

/**
 * Creates the basic affixed-forms of a given Farsi word
 *
 * @param {string} word      The word to check
 *
 * @returns {Array} The created forms
 */
const createForms = function createForms(word) {
	const prefix = "ن";
	// Regular suffixes
	const suffixes1 = ["مان", "شان", "تان", "ش", "ت", "م", "ی"];
	// Suffixes for words that end in ا or و
	const suffixes2 = ["یی", "یم", "یت", "یش"];
	// Suffixes for words that end in silent ه
	const suffixes3 = ["‌ای", "‌یی", "‌ام", "‌ات", "‌اش"];
	// Suffixes for words that end in ها
	const suffixes4 = ["یی", "ی"];

	const createdForms = [];

	// Create prefixed form.
	createdForms.push(prefix + word);

	// Create suffixed forms using suffixes from one of the four groups, depending on the word's ending.
	if (word.endsWith("ها")) {
		createdForms.push(...suffixes4.map(suffix => word + suffix));
	} else if (/([^وای]ه)$/i.test(word)) {
		createdForms.push(...suffixes3.map(suffix => word + suffix));
	} else if (/([وا])$/i.test(word)) {
		createdForms.push(...suffixes2.map(suffix => word + suffix));
	} else {
		if (word.endsWith("ی")) {
			createdForms.push(word + "‌ای");
		}
		createdForms.push(...suffixes1.map(suffix => word + suffix));
	}
	return createdForms;
};

/**
 * Stem the basic affixes of a given Farsi word
 *
 * @param {string} word  The word to check
 *
 * @returns {string}    The stemmed word
 */
const stemWord = function stemWord(word) {
	const prefix = "ن";
	const suffixesAndReplacements = [["(و|ا)(یش|یت|یم|یی)$", "$1"], ["([^وای]ه)(‌یی|‌ای|‌اش|‌ات|‌ام)$", "$1"], ["(ی)‌ای$", "$1"], ["(ها)یی$", "$1"], ["(مان|شان|تان|ش|ت|م|ی)$", ""]];
	// Remove prefix.
	if (word.startsWith(prefix)) {
		return word.slice(1, word.length);
	}
	// Search for and remove suffixes.
	return (0, _regexHelpers.searchAndReplaceWithRegex)(word, suffixesAndReplacements);
};

/**
 * Creates basic word forms for a given Farsi word.
 *
 * @param {string} word     The word for which to create basic word forms.
 *
 * @returns {Array}        Prefixed and de-prefixed variations of a word.
 */
function createBasicWordForms(word) {
	const forms = [];

	/*
  * Add prefixes and suffixes to the input word. We always do this, since some words
  * beginning with an affix-like letter might be exceptions where this is the
  * actual first letter or last letter of the word.
  */

	forms.push(...createForms(word));

	/*
  * If a word starts with a prefix or is it ends with one of the suffixes, we strip it and create all possible
  * affixed forms based on this stem.
  */
	const stemmedWord = stemWord(word);
	if (stemmedWord) {
		forms.push(stemmedWord);
		forms.push(...createForms(stemmedWord));
	}
	return forms;
}

Object.defineProperty(getBasicWordForms, "__esModule", {
	value: true
});

getBasicWordForms.default = function () {
	return {
		he: _createBasicWordForms.createBasicWordForms,
		ar: _createBasicWordForms2.createBasicWordForms,
		fa: _createBasicWordForms3.createBasicWordForms
	};
};

var _createBasicWordForms = createBasicWordForms$5;

var _createBasicWordForms2 = createBasicWordForms$3;

var _createBasicWordForms3 = createBasicWordForms$1;

var buildTopicStems = {};

Object.defineProperty(buildTopicStems, "__esModule", {
  value: true
});
buildTopicStems.StemOriginalPair = buildTopicStems.TopicPhrase = buildTopicStems.collectStems = buildTopicStems.buildStems = undefined;

var _filterFunctionWordsFromArray$1 = filterFunctionWordsFromArray;

var _filterFunctionWordsFromArray2$1 = _interopRequireDefault$t(_filterFunctionWordsFromArray$1);

var _retrieveStemmer$1 = retrieveStemmer;

var _retrieveStemmer2$1 = _interopRequireDefault$t(_retrieveStemmer$1);

var _getWords$1 = getWords;

var _getWords2$1 = _interopRequireDefault$t(_getWords$1);

var _parseSynonyms = parseSynonyms;

var _parseSynonyms2 = _interopRequireDefault$t(_parseSynonyms);

var _quotes$1 = quotes;

var _lodashEs$l = require$$1$1;

function _interopRequireDefault$t(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A topic phrase (i.e., a keyphrase or synonym) with stem-original pairs for the words in the topic phrase.
 *
 * @param {StemOriginalPair[]} stemOriginalPairs   The stem-original pairs for the words in the topic phrase.
 * @param {boolean}            exactMatch          Whether the topic phrase is an exact match.
 *
 * @constructor
 */
function TopicPhrase(stemOriginalPairs = [], exactMatch = false) {
  this.stemOriginalPairs = stemOriginalPairs;
  this.exactMatch = exactMatch;
}

/**
 * Returns all stems in the topic phrase.
 *
 * @returns {string[]|[]} The stems in the topic phrase or empty array if the topic phrase is exact match.
 */
TopicPhrase.prototype.getStems = function () {
  // An exact match keyphrase doesn't have stems.
  if (this.exactMatch) {
    return [];
  }

  return this.stemOriginalPairs.map(stemOriginalPair => stemOriginalPair.stem);
};

/**
 * A stem-original pair ƒor a word in a topic phrase.
 *
 * @param {string}  stem        The stem of the topic phrase word.
 * @param {string}  original    The original word form the topic phrase (unsanitized)
 *
 * @constructor
 */
function StemOriginalPair(stem, original) {
  this.stem = stem;
  this.original = original;
}

/**
 * Analyzes the focus keyword string or one synonym phrase.
 * Checks if morphology is requested or if the user wants to match exact string.
 * If morphology is required the module finds a stem for all words (if no function words list available) or
 * for all content words (i.e., excluding prepositions, articles, conjunctions, if the function words list is available).
 *
 * @param {string} keyphrase The keyphrase of the paper (or a synonym phrase) to get stem for.
 * @param {string} language The language to use for morphological analyzer and for function words.
 * @param {Object} morphologyData The available morphology data per language (false if unavailable).
 *
 * @returns {TopicPhrase} Object with an array of StemOriginalPairs of all (content) words in the keyphrase or synonym
 * phrase and information about whether the keyphrase/synonym should be matched exactly.
 */
const buildStems = function buildStems(keyphrase, language, morphologyData) {
  if ((0, _lodashEs$l.isUndefined)(keyphrase) || keyphrase === "") {
    return new TopicPhrase();
  }

  // If the keyphrase is embedded in double quotation marks, return keyword itself, without outer-most quotation marks.
  const doubleQuotes = ["“", "”", "〝", "〞", "〟", "‟", "„", "\""];
  if ((0, _lodashEs$l.includes)(doubleQuotes, keyphrase[0]) && (0, _lodashEs$l.includes)(doubleQuotes, keyphrase[keyphrase.length - 1])) {
    keyphrase = keyphrase.substring(1, keyphrase.length - 1);
    return new TopicPhrase([new StemOriginalPair((0, _lodashEs$l.escapeRegExp)(keyphrase), keyphrase)], true);
  }

  const words = (0, _filterFunctionWordsFromArray2$1.default)((0, _getWords2$1.default)(keyphrase), language);

  /**
   * Extract a stemming function (if available, and if there is morphologyData available for this language).
   * Otherwise, take an identity function.
   */
  const getStem = (0, _retrieveStemmer2$1.default)(language, morphologyData);

  const stemOriginalPairs = words.map(word => {
    const lowCaseWord = (0, _lodashEs$l.escapeRegExp)(word.toLocaleLowerCase(language));
    return new StemOriginalPair(getStem((0, _quotes$1.normalizeSingle)(lowCaseWord), morphologyData), word);
  });

  return new TopicPhrase(stemOriginalPairs);
};

/**
 * Builds stems of words of the keyphrase and of each synonym phrase.
 *
 * @param {string} keyphrase The paper's keyphrase.
 * @param {string} synonyms The paper's synonyms.
 * @param {string} language The paper's language.
 * @param {Object} morphologyData The available morphology data to be used by the getStem function (language specific).
 *
 * @returns {Object} Object with an array of stems of words in the keyphrase and an array of arrays of stems of words in the synonyms.
 */
const collectKeyphraseAndSynonymsStems = function collectKeyphraseAndSynonymsStems(keyphrase, synonyms, language = "en", morphologyData) {
  const synonymsSplit = (0, _parseSynonyms2.default)(synonyms);

  const keyphraseStems = buildStems(keyphrase, language, morphologyData);
  const synonymsStems = synonymsSplit.map(synonym => buildStems(synonym, language, morphologyData));

  return {
    keyphraseStems,
    synonymsStems
  };
};

/**
 * Caches stems depending on the currently available morphologyData and (separately) keyphrase, synonyms,
 * and language. In this way, if the morphologyData remains the same in multiple calls of this function, the function
 * that collects actual stems only needs to check if the keyphrase, synonyms and language also remain the
 * same to return the cached result. The joining of keyphrase, synonyms and language for this function is needed,
 * because by default memoize caches by the first key only, which in the current case would mean that the function would
 * return the cached forms if the keyphrase has not changed (without checking if synonyms and language were changed).
 *
 * @param {Object|boolean} morphologyData The available morphology data.
 *
 * @returns {function} The function that collects the stems for a given set of keyphrase, synonyms, language and
 * morphologyData.
 */
const primeMorphologyData = (0, _lodashEs$l.memoize)(morphologyData => {
  return (0, _lodashEs$l.memoize)((keyphrase, synonyms, language = "en") => {
    return collectKeyphraseAndSynonymsStems(keyphrase, synonyms, language, morphologyData);
  }, (keyphrase, synonyms, language) => {
    return keyphrase + "," + synonyms + "," + language;
  });
});

/**
 * Retrieves stems of words of the keyphrase and of each synonym phrase using the function that caches
 * the results of previous calls of this function.
 *
 * @param {string} keyphrase The paper's keyphrase.
 * @param {string} synonyms The paper's synonyms.
 * @param {string} language The paper's language.
 * @param {Object} morphologyData The available morphology data to be used by the getStems function (language specific).
 *
 * @returns {Object} Object with an array of stems of words in the keyphrase and an array of arrays of stems of words in the synonyms.
 */
function collectStems(keyphrase, synonyms, language = "en", morphologyData) {
  const collectStemsWithMorphologyData = primeMorphologyData(morphologyData);

  return collectStemsWithMorphologyData(keyphrase, synonyms, language);
}

buildTopicStems.buildStems = buildStems;
buildTopicStems.collectStems = collectStems;
buildTopicStems.TopicPhrase = TopicPhrase;
buildTopicStems.StemOriginalPair = StemOriginalPair;

Object.defineProperty(getWordForms$1, "__esModule", {
	value: true
});

var _lodashEs$k = require$$1$1;

var _flattenDeep = require$$1;

var _flattenDeep2 = _interopRequireDefault$s(_flattenDeep);

var _filterFunctionWordsFromArray = filterFunctionWordsFromArray;

var _filterFunctionWordsFromArray2 = _interopRequireDefault$s(_filterFunctionWordsFromArray);

var _getBasicWordForms = getBasicWordForms;

var _getBasicWordForms2 = _interopRequireDefault$s(_getBasicWordForms);

var _getLanguage$2 = getLanguage;

var _getLanguage2$2 = _interopRequireDefault$s(_getLanguage$2);

var _retrieveStemmer = retrieveStemmer;

var _retrieveStemmer2 = _interopRequireDefault$s(_retrieveStemmer);

var _getAlttagContent = getAlttagContent;

var _getAlttagContent2 = _interopRequireDefault$s(_getAlttagContent);

var _getWords = getWords;

var _getWords2 = _interopRequireDefault$s(_getWords);

var _imageInText = imageInText;

var _imageInText2 = _interopRequireDefault$s(_imageInText);

var _parseSlug = parseSlug;

var _parseSlug2 = _interopRequireDefault$s(_parseSlug);

var _quotes = quotes;

var _buildTopicStems = buildTopicStems;

function _interopRequireDefault$s(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A stem with accompanying forms.
 *
 * @param {string}      stem    The word stem.
 * @param {string[]}    forms   The word forms for the stem.
 *
 * @constructor
 */
function StemWithForms(stem, forms) {
	this.stem = stem;
	this.forms = forms;
}

/**
 * A result for all topic forms.
 *
 * @param {string[]}    keyphraseForms  All keyphrase forms.
 * @param {Array<string[]>[]}    synonymsForms   All synonym forms.
 * @constructor
 */
function Result$2(keyphraseForms = [], synonymsForms = []) {
	this.keyphraseForms = keyphraseForms;
	this.synonymsForms = synonymsForms;
}

/**
 * Gets all words found in the text, title, slug and meta description of a given paper.
 *
 * @param {Paper} paper     The paper for which to get the words.
 * @param {string} language The language of the paper.
 *
 * @returns {string[]} All words found.
 */
function getAllWordsFromPaper(paper, language) {
	const paperText = paper.getText();
	const altTagsInText = (0, _imageInText2.default)(paperText).map(image => (0, _getAlttagContent2.default)(image));

	const paperContent = [paperText, paper.getTitle(), (0, _parseSlug2.default)(paper.getUrl()), paper.getDescription(), altTagsInText.join(" ")].join(" ");

	return (0, _getWords2.default)(paperContent).map(word => (0, _quotes.normalizeSingle)((0, _lodashEs$k.escapeRegExp)(word.toLocaleLowerCase(language))));
}

/**
 * Takes a stem-original pair and returns the accompanying forms for the stem that were found in the paper. Additionally
 * adds a sanitized version of the original word and (for specific languages) creates basic word forms.
 *
 * @param {StemOriginalPair}    stemOriginalPair            The stem-original pair for which to get forms.
 * @param {StemWithForms[]}     paperWordsGroupedByStems    All word forms in the paper grouped by stem.
 * @param {string}              language                    The language for which to get forms.
 *
 * @returns {string[]} All forms found in the paper for the given stem, plus a sanitized version of the original word.
 */
function replaceStemWithForms(stemOriginalPair, paperWordsGroupedByStems, language) {
	const matchingStemFormPair = paperWordsGroupedByStems.find(element => element.stem === stemOriginalPair.stem);
	const originalSanitized = (0, _quotes.normalizeSingle)((0, _lodashEs$k.escapeRegExp)(stemOriginalPair.original.toLocaleLowerCase(language)));

	const forms = matchingStemFormPair ? [originalSanitized, ...matchingStemFormPair.forms] : [originalSanitized];

	// Add extra forms for languages for which we have basic word form support.
	if (Object.keys((0, _getBasicWordForms2.default)()).includes(language)) {
		const createBasicWordForms = (0, _getBasicWordForms2.default)()[language];
		forms.push(...createBasicWordForms(stemOriginalPair.original));
	}

	/*
  * Return original and found or created forms.
  * Only return original if no matching forms were found in the text and no forms could be created.
  */
	return (0, _lodashEs$k.uniq)(forms);
}

/**
 * Extracts the stems from all keyphrase and synonym stems.
 *
 * @param {TopicPhrase}   keyphrase  A topic phrase.
 * @param {TopicPhrase[]} synonyms   An array of topic phrases.
 *
 * @returns {string[]} All word stems of they keyphrase and synonyms.
 */
function extractStems(keyphrase, synonyms) {
	const keyphraseStemsOnly = keyphrase.stemOriginalPairs.length === 0 ? [] : keyphrase.getStems();

	const synonymsStemsOnly = synonyms.length === 0 ? [] : synonyms.map(topicPhrase => topicPhrase.getStems());

	return [...keyphraseStemsOnly, ...(0, _flattenDeep2.default)(synonymsStemsOnly)];
}

/**
 * Constructs the result with forms for a topic phrase (i.e., a keyphrase or a synonym).
 *
 * @param {TopicPhrase}     topicPhrase                 The topic phrase for which to construct the result.
 * @param {StemWithForms[]} paperWordsGroupedByStems    All word forms in the paper grouped by stem.
 * @param {string}          language                    The language of the paper.
 *
 * @returns {Array.<string[]>} The word forms for a given topic phrase, grouped by original topic phrase word.
 */
function constructTopicPhraseResult(topicPhrase, paperWordsGroupedByStems, language) {
	// Empty result for an empty topic phrase.
	if (topicPhrase.stemOriginalPairs.length === 0) {
		return [];
	}

	if (topicPhrase.exactMatch) {
		return [[topicPhrase.stemOriginalPairs[0].stem]];
	}

	return topicPhrase.stemOriginalPairs.map(function (stemOriginalPair) {
		return replaceStemWithForms(stemOriginalPair, paperWordsGroupedByStems, language);
	});
}

/**
 * Gets all matching word forms for the stems of the keyphrase and synonyms. Stems are either colleced from
 * the paper or, for specific languages, directly created.
 *
 * @param {Paper}       paper       The paper to build keyphrase and synonym forms for.
 * @param {Researcher}  researcher  The researcher.
 *
 * @returns {Object} Object with an array of keyphrase forms and an array of arrays of synonyms forms, based on the forms
 * found in the text or created forms.
 */
function getWordForms(paper, researcher) {
	const language = (0, _getLanguage2$2.default)(paper.getLocale());
	const morphologyData = (0, _lodashEs$k.get)(researcher.getData("morphology"), language, false);
	const determineStem = (0, _retrieveStemmer2.default)(language, morphologyData);
	const topicPhrases = (0, _buildTopicStems.collectStems)(paper.getKeyword(), paper.getSynonyms(), language, morphologyData);
	const keyphrase = topicPhrases.keyphraseStems;
	const synonyms = topicPhrases.synonymsStems;

	// Return an empty result when no keyphrase and synonyms have been set.
	if (keyphrase.stemOriginalPairs.length === 0 && synonyms.length === 0) {
		return new Result$2();
	}

	// Return exact match if all topic phrases contain exact match. Forms don't need to be built in that case.
	const allTopicPhrases = [keyphrase, ...synonyms];

	if (allTopicPhrases.every(topicPhrase => topicPhrase.exactMatch === true)) {
		return new Result$2([[keyphrase.stemOriginalPairs[0].stem]], synonyms.map(synonym => [[synonym.stemOriginalPairs[0].stem]]));
	}

	// Get all stems from the keyphrase and synonyms.
	const topicStemsFlat = (0, _lodashEs$k.uniq)(extractStems(keyphrase, synonyms));

	// Get all words from the paper text, title, meta description and slug.
	let paperWords = getAllWordsFromPaper(paper, language);

	// Filter doubles and function words.
	paperWords = (0, _filterFunctionWordsFromArray2.default)((0, _lodashEs$k.uniq)(paperWords), language);

	// Add stems to words from the paper, filter out all forms that aren't in the keyphrase or synonyms and order alphabetically.
	const paperWordsWithStems = paperWords.map(word => new _buildTopicStems.StemOriginalPair(determineStem(word, morphologyData), word)).filter(stemOriginalPair => topicStemsFlat.includes(stemOriginalPair.stem)).sort((a, b) => a.stem.localeCompare(b.stem));

	// Group word-stem pairs from the paper by stems.
	const paperWordsGroupedByStems = paperWordsWithStems.reduce(function (accumulator, stemOriginalPair) {
		const lastItem = accumulator[accumulator.length - 1];

		if (accumulator.length === 0 || lastItem.stem !== stemOriginalPair.stem) {
			accumulator.push(new StemWithForms(stemOriginalPair.stem, [stemOriginalPair.original]));
		} else {
			lastItem.forms.push(stemOriginalPair.original);
		}

		return accumulator;
	}, []);

	return new Result$2(constructTopicPhraseResult(keyphrase, paperWordsGroupedByStems, language), synonyms.map(synonym => constructTopicPhraseResult(synonym, paperWordsGroupedByStems, language)));
}

getWordForms$1.default = getWordForms;

Object.defineProperty(researcher, "__esModule", {
	value: true
});

var _sentences = sentences;

var _sentences2 = _interopRequireDefault$r(_sentences);

var _lodashEs$j = require$$1$1;

var _invalidType$2 = invalidType;

var _invalidType2$2 = _interopRequireDefault$r(_invalidType$2);

var _missingArgument$2 = missingArgument;

var _missingArgument2$2 = _interopRequireDefault$r(_missingArgument$2);

var _wordCountInText = wordCountInText;

var _wordCountInText2 = _interopRequireDefault$r(_wordCountInText);

var _getLinkStatistics = getLinkStatistics;

var _getLinkStatistics2 = _interopRequireDefault$r(_getLinkStatistics);

var _countLinks = countLinks;

var _countLinks2 = _interopRequireDefault$r(_countLinks);

var _getLinks = getLinks;

var _getLinks2 = _interopRequireDefault$r(_getLinks);

var _urlIsTooLong = urlIsTooLong;

var _urlIsTooLong2 = _interopRequireDefault$r(_urlIsTooLong);

var _findKeywordInPageTitle = findKeywordInPageTitle;

var _findKeywordInPageTitle2 = _interopRequireDefault$r(_findKeywordInPageTitle);

var _matchKeywordInSubheadings = matchKeywordInSubheadings;

var _matchKeywordInSubheadings2 = _interopRequireDefault$r(_matchKeywordInSubheadings);

var _getKeywordDensity = getKeywordDensity;

var _getKeywordDensity2 = _interopRequireDefault$r(_getKeywordDensity);

var _keywordCount = keywordCount;

var _keywordCount2 = _interopRequireDefault$r(_keywordCount);

var _stopWordsInKeyword = stopWordsInKeyword;

var _stopWordsInKeyword2 = _interopRequireDefault$r(_stopWordsInKeyword);

var _stopWordsInUrl = stopWordsInUrl;

var _stopWordsInUrl2 = _interopRequireDefault$r(_stopWordsInUrl);

var _calculateFleschReading = calculateFleschReading;

var _calculateFleschReading2 = _interopRequireDefault$r(_calculateFleschReading);

var _metaDescriptionLength = metaDescriptionLength;

var _metaDescriptionLength2 = _interopRequireDefault$r(_metaDescriptionLength);

var _imageCountInText = imageCountInText;

var _imageCountInText2 = _interopRequireDefault$r(_imageCountInText);

var _imageAltTags = imageAltTags;

var _imageAltTags2 = _interopRequireDefault$r(_imageAltTags);

var _keyphraseLength = keyphraseLength;

var _keyphraseLength2 = _interopRequireDefault$r(_keyphraseLength);

var _metaDescriptionKeyword = metaDescriptionKeyword;

var _metaDescriptionKeyword2 = _interopRequireDefault$r(_metaDescriptionKeyword);

var _keywordCountInUrl = keywordCountInUrl;

var _keywordCountInUrl2 = _interopRequireDefault$r(_keywordCountInUrl);

var _findKeywordInFirstParagraph = findKeywordInFirstParagraph;

var _findKeywordInFirstParagraph2 = _interopRequireDefault$r(_findKeywordInFirstParagraph);

var _pageTitleWidth = pageTitleWidth;

var _pageTitleWidth2 = _interopRequireDefault$r(_pageTitleWidth);

var _getWordComplexity = getWordComplexity;

var _getWordComplexity2 = _interopRequireDefault$r(_getWordComplexity);

var _getParagraphLength = getParagraphLength;

var _getParagraphLength2 = _interopRequireDefault$r(_getParagraphLength);

var _countSentencesFromText = countSentencesFromText;

var _countSentencesFromText2 = _interopRequireDefault$r(_countSentencesFromText);

var _countSentencesFromDescription = countSentencesFromDescription;

var _countSentencesFromDescription2 = _interopRequireDefault$r(_countSentencesFromDescription);

var _getSubheadingTextLengths = getSubheadingTextLengths;

var _getSubheadingTextLengths2 = _interopRequireDefault$r(_getSubheadingTextLengths);

var _findTransitionWords = findTransitionWords;

var _findTransitionWords2 = _interopRequireDefault$r(_findTransitionWords);

var _getPassiveVoice = getPassiveVoice;

var _getPassiveVoice2 = _interopRequireDefault$r(_getPassiveVoice);

var _getSentenceBeginnings = getSentenceBeginnings;

var _getSentenceBeginnings2 = _interopRequireDefault$r(_getSentenceBeginnings);

var _relevantWords = relevantWords$1;

var _relevantWords2 = _interopRequireDefault$r(_relevantWords);

var _readingTime = readingTime;

var _readingTime2 = _interopRequireDefault$r(_readingTime);

var _getTopicDensity = getTopicDensity;

var _getTopicDensity2 = _interopRequireDefault$r(_getTopicDensity);

var _topicCount = topicCount;

var _topicCount2 = _interopRequireDefault$r(_topicCount);

var _keyphraseDistribution = keyphraseDistribution$3;

var _functionWordsInKeyphrase = functionWordsInKeyphrase;

var _functionWordsInKeyphrase2 = _interopRequireDefault$r(_functionWordsInKeyphrase);

var _h1s = h1s;

var _h1s2 = _interopRequireDefault$r(_h1s);

var _getProminentWordsForInsights = getProminentWordsForInsights$1;

var _getProminentWordsForInsights2 = _interopRequireDefault$r(_getProminentWordsForInsights);

var _getProminentWordsForInternalLinking = getProminentWordsForInternalLinking$1;

var _getProminentWordsForInternalLinking2 = _interopRequireDefault$r(_getProminentWordsForInternalLinking);

var _getWordForms = getWordForms$1;

var _getWordForms2 = _interopRequireDefault$r(_getWordForms);

function _interopRequireDefault$r(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const keyphraseDistribution$2 = _keyphraseDistribution.keyphraseDistributionResearcher;

// Researches


/**
 * This contains all possible, default researches.
 * @param {Paper} paper The Paper object that is needed within the researches.
 * @constructor
 * @throws {InvalidTypeError} Parameter needs to be an instance of the Paper object.
 */
var Researcher = function Researcher(paper) {
	this.setPaper(paper);

	this.defaultResearches = {
		urlLength: _urlIsTooLong2.default,
		wordCountInText: _wordCountInText2.default,
		findKeywordInPageTitle: _findKeywordInPageTitle2.default,
		calculateFleschReading: _calculateFleschReading2.default,
		getLinkStatistics: _getLinkStatistics2.default,
		getLinks: _getLinks2.default,
		linkCount: _countLinks2.default,
		imageCount: _imageCountInText2.default,
		altTagCount: _imageAltTags2.default,
		matchKeywordInSubheadings: _matchKeywordInSubheadings2.default,
		keywordCount: _keywordCount2.default,
		getKeywordDensity: _getKeywordDensity2.default,
		stopWordsInKeyword: _stopWordsInKeyword2.default,
		stopWordsInUrl: _stopWordsInUrl2.default,
		metaDescriptionLength: _metaDescriptionLength2.default,
		keyphraseLength: _keyphraseLength2.default,
		keywordCountInUrl: _keywordCountInUrl2.default,
		firstParagraph: _findKeywordInFirstParagraph2.default,
		metaDescriptionKeyword: _metaDescriptionKeyword2.default,
		pageTitleWidth: _pageTitleWidth2.default,
		wordComplexity: _getWordComplexity2.default,
		getParagraphLength: _getParagraphLength2.default,
		countSentencesFromText: _countSentencesFromText2.default,
		countSentencesFromDescription: _countSentencesFromDescription2.default,
		getSubheadingTextLengths: _getSubheadingTextLengths2.default,
		findTransitionWords: _findTransitionWords2.default,
		passiveVoice: _getPassiveVoice2.default,
		getSentenceBeginnings: _getSentenceBeginnings2.default,
		relevantWords: _relevantWords2.default,
		readingTime: _readingTime2.default,
		getTopicDensity: _getTopicDensity2.default,
		topicCount: _topicCount2.default,
		sentences: _sentences2.default,
		keyphraseDistribution: keyphraseDistribution$2,
		morphology: _getWordForms2.default,
		functionWordsInKeyphrase: _functionWordsInKeyphrase2.default,
		h1s: _h1s2.default,
		prominentWordsForInsights: _getProminentWordsForInsights2.default,
		prominentWordsForInternalLinking: _getProminentWordsForInternalLinking2.default
	};

	this._data = {};

	this.customResearches = {};
};

/**
 * Set the Paper associated with the Researcher.
 * @param {Paper} paper The Paper to use within the Researcher
 * @throws {InvalidTypeError} Parameter needs to be an instance of the Paper object.
 * @returns {void}
 */
Researcher.prototype.setPaper = function (paper) {
	this.paper = paper;
};

/**
 * Add a custom research that will be available within the Researcher.
 * @param {string} name A name to reference the research by.
 * @param {function} research The function to be added to the Researcher.
 * @throws {MissingArgument} Research name cannot be empty.
 * @throws {InvalidTypeError} The research requires a valid Function callback.
 * @returns {void}
 */
Researcher.prototype.addResearch = function (name, research) {
	if ((0, _lodashEs$j.isUndefined)(name) || (0, _lodashEs$j.isEmpty)(name)) {
		throw new _missingArgument2$2.default("Research name cannot be empty");
	}

	if (!(research instanceof Function)) {
		throw new _invalidType2$2.default("The research requires a Function callback.");
	}

	this.customResearches[name] = research;
};

/**
 * Check whether or not the research is known by the Researcher.
 * @param {string} name The name to reference the research by.
 * @returns {boolean} Whether or not the research is known by the Researcher
 */
Researcher.prototype.hasResearch = function (name) {
	return Object.keys(this.getAvailableResearches()).filter(function (research) {
		return research === name;
	}).length > 0;
};

/**
 * Return all available researches.
 * @returns {Object} An object containing all available researches.
 */
Researcher.prototype.getAvailableResearches = function () {
	return (0, _lodashEs$j.merge)(this.defaultResearches, this.customResearches);
};

/**
 * Return the Research by name.
 * @param {string} name The name to reference the research by.
 *
 * @returns {*} Returns the result of the research or false if research does not exist.
 * @throws {MissingArgument} Research name cannot be empty.
 */
Researcher.prototype.getResearch = function (name) {
	if ((0, _lodashEs$j.isUndefined)(name) || (0, _lodashEs$j.isEmpty)(name)) {
		throw new _missingArgument2$2.default("Research name cannot be empty");
	}

	if (!this.hasResearch(name)) {
		return false;
	}

	return this.getAvailableResearches()[name](this.paper, this);
};

/**
 * Add research data to the researcher by the research name.
 *
 * @param {string} research The identifier of the research.
 * @param {Object} data     The data object.
 *
 * @returns {void}.
 */
Researcher.prototype.addResearchData = function (research, data) {
	this._data[research] = data;
};

/**
 * Return the research data from a research data provider by research name.
 *
 * @param {string} research The identifier of the research.
 *
 * @returns {*} The data provided by the provider, false if the data do not exist
 */
Researcher.prototype.getData = function (research) {
	if (this._data.hasOwnProperty(research)) {
		return this._data[research];
	}

	return false;
};

researcher.default = Researcher;

var removeDuplicateMarks$1 = {};

Object.defineProperty(removeDuplicateMarks$1, "__esModule", {
  value: true
});

var _lodashEs$i = require$$1$1;

/**
 * Removes duplicate marks from an array
 *
 * @param {Array} marks The marks to remove duplications from
 * @returns {Array} A list of de-duplicated marks.
 */
function removeDuplicateMarks(marks) {
  return (0, _lodashEs$i.uniqBy)(marks, function (mark) {
    return mark.getOriginal();
  });
}

removeDuplicateMarks$1.default = removeDuplicateMarks;

var errors = {};

Object.defineProperty(errors, "__esModule", {
	value: true
});
errors.showTrace = undefined;

var _lodashEs$h = require$$1$1;

/**
 * Shows and error trace of the error message in the console if the console is available.
 *
 * @param {string} [errorMessage=""] The error message.
 * @returns {void}
 */
function showTrace(errorMessage) {
	if ((0, _lodashEs$h.isUndefined)(errorMessage)) {
		errorMessage = "";
	}

	if (!(0, _lodashEs$h.isUndefined)(console) && !(0, _lodashEs$h.isUndefined)(console.trace)) {
		console.trace(errorMessage);
	}
}

errors.showTrace = showTrace;
errors.default = {
	showTrace: showTrace
};

Object.defineProperty(assessor, "__esModule", {
  value: true
});

var _researcher$2 = researcher;

var _researcher2$2 = _interopRequireDefault$q(_researcher$2);

var _missingArgument$1 = missingArgument;

var _missingArgument2$1 = _interopRequireDefault$q(_missingArgument$1);

var _removeDuplicateMarks = removeDuplicateMarks$1;

var _removeDuplicateMarks2 = _interopRequireDefault$q(_removeDuplicateMarks);

var _AssessmentResult$2 = AssessmentResult$1;

var _AssessmentResult2$2 = _interopRequireDefault$q(_AssessmentResult$2);

var _errors = errors;

var _lodashEs$g = require$$1$1;

function _interopRequireDefault$q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScoreRating = 9;

/**
 * Creates the Assessor.
 *
 * @param {Object} i18n The i18n object used for translations.
 * @param {Object} options The options for this assessor.
 * @param {Object} options.marker The marker to pass the list of marks to.
 * @param {Object} options.researcher The researcher to use in the assessor.
 *
 * @constructor
 */
var Assessor = function Assessor(i18n, options) {
  this.type = "Assessor";
  this.setI18n(i18n);
  this._assessments = [];

  this._options = options || {};

  if (!(0, _lodashEs$g.isUndefined)(this._options.researcher)) {
    this._researcher = this._options.researcher;
  }
};

/**
 * Checks if the i18n object is defined and sets it.
 *
 * @param {Object} i18n The i18n object used for translations.
 * @throws {MissingArgument} Parameter needs to be a valid i18n object.
 * @returns {void}
 */
Assessor.prototype.setI18n = function (i18n) {
  if ((0, _lodashEs$g.isUndefined)(i18n)) {
    throw new _missingArgument2$1.default("The assessor requires an i18n object.");
  }
  this.i18n = i18n;
};

/**
 * Gets all available assessments.
 * @returns {object} assessment
 */
Assessor.prototype.getAvailableAssessments = function () {
  return this._assessments;
};

/**
 * Checks whether or not the Assessment is applicable.
 *
 * @param {Object} assessment The Assessment object that needs to be checked.
 * @param {Paper} paper The Paper object to check against.
 * @param {Researcher} [researcher] The Researcher object containing additional information.
 * @returns {boolean} Whether or not the Assessment is applicable.
 */
Assessor.prototype.isApplicable = function (assessment, paper, researcher) {
  if (assessment.hasOwnProperty("isApplicable") || typeof assessment.isApplicable === "function") {
    return assessment.isApplicable(paper, researcher);
  }

  return true;
};

/**
 * Determines whether or not an assessment has a marker.
 *
 * @param {Object} assessment The assessment to check for.
 * @returns {boolean} Whether or not the assessment has a marker.
 */
Assessor.prototype.hasMarker = function (assessment) {
  return (0, _lodashEs$g.isFunction)(this._options.marker) && (assessment.hasOwnProperty("getMarks") || typeof assessment.getMarks === "function");
};

/**
 * Returns the specific marker for this assessor.
 *
 * @returns {Function} The specific marker for this assessor.
 */
Assessor.prototype.getSpecificMarker = function () {
  return this._options.marker;
};

/**
 * Returns the paper that was most recently assessed.
 *
 * @returns {Paper} The paper that was most recently assessed.
 */
Assessor.prototype.getPaper = function () {
  return this._lastPaper;
};

/**
 * Returns the marker for a given assessment, composes the specific marker with the assessment getMarks function.
 *
 * @param {Object} assessment The assessment for which we are retrieving the composed marker.
 * @param {Paper} paper The paper to retrieve the marker for.
 * @param {Researcher} researcher The researcher for the paper.
 * @returns {Function} A function that can mark the given paper according to the given assessment.
 */
Assessor.prototype.getMarker = function (assessment, paper, researcher) {
  var specificMarker = this._options.marker;

  return function () {
    let marks = assessment.getMarks(paper, researcher);
    marks = (0, _removeDuplicateMarks2.default)(marks);

    specificMarker(paper, marks);
  };
};

/**
 * Runs the researches defined in the tasklist or the default researches.
 *
 * @param {Paper} paper The paper to run assessments on.
 * @returns {void}
 */
Assessor.prototype.assess = function (paper) {
  if ((0, _lodashEs$g.isUndefined)(this._researcher)) {
    this._researcher = new _researcher2$2.default(paper);
  } else {
    this._researcher.setPaper(paper);
  }

  var assessments = this.getAvailableAssessments();
  this.results = [];

  assessments = (0, _lodashEs$g.filter)(assessments, function (assessment) {
    return this.isApplicable(assessment, paper, this._researcher);
  }.bind(this));

  this.setHasMarkers(false);
  this.results = (0, _lodashEs$g.map)(assessments, this.executeAssessment.bind(this, paper, this._researcher));

  this._lastPaper = paper;
};

/**
 * Sets the value of has markers with a boolean to determine if there are markers.
 *
 * @param {boolean} hasMarkers True when there are markers, otherwise it is false.
 * @returns {void}
 */
Assessor.prototype.setHasMarkers = function (hasMarkers) {
  this._hasMarkers = hasMarkers;
};

/**
 * Returns true when there are markers.
 *
 * @returns {boolean} Are there markers
 */
Assessor.prototype.hasMarkers = function () {
  return this._hasMarkers;
};

/**
 * Executes an assessment and returns the AssessmentResult.
 *
 * @param {Paper} paper The paper to pass to the assessment.
 * @param {Researcher} researcher The researcher to pass to the assessment.
 * @param {Object} assessment The assessment to execute.
 * @returns {AssessmentResult} The result of the assessment.
 */
Assessor.prototype.executeAssessment = function (paper, researcher, assessment) {
  var result;

  try {
    result = assessment.getResult(paper, researcher, this.i18n);
    result.setIdentifier(assessment.identifier);

    if (result.hasMarks()) {
      result.marks = assessment.getMarks(paper, researcher);
      result.marks = (0, _removeDuplicateMarks2.default)(result.marks);
    }

    if (result.hasMarks() && this.hasMarker(assessment)) {
      this.setHasMarkers(true);

      result.setMarker(this.getMarker(assessment, paper, researcher));
    }
  } catch (assessmentError) {
    (0, _errors.showTrace)(assessmentError);

    result = new _AssessmentResult2$2.default();

    result.setScore(-1);
    result.setText(this.i18n.sprintf(
    /* Translators: %1$s expands to the name of the assessment. */
    this.i18n.dgettext("js-text-analysis", "An error occurred in the '%1$s' assessment"), assessment.identifier, assessmentError));
  }
  return result;
};

/**
 * Filters out all assessmentresults that have no score and no text.
 *
 * @returns {Array<AssessmentResult>} The array with all the valid assessments.
 */
Assessor.prototype.getValidResults = function () {
  return (0, _lodashEs$g.filter)(this.results, function (result) {
    return this.isValidResult(result);
  }.bind(this));
};

/**
 * Returns if an assessmentResult is valid.
 *
 * @param {object} assessmentResult The assessmentResult to validate.
 * @returns {boolean} whether or not the result is valid.
 */
Assessor.prototype.isValidResult = function (assessmentResult) {
  return assessmentResult.hasScore() && assessmentResult.hasText();
};

/**
 * Returns the overallscore. Calculates the totalscore by adding all scores and dividing these
 * by the number of results times the ScoreRating.
 *
 * @returns {number} The overallscore
 */
Assessor.prototype.calculateOverallScore = function () {
  var results = this.getValidResults();
  var totalScore = 0;

  (0, _lodashEs$g.forEach)(results, function (assessmentResult) {
    totalScore += assessmentResult.getScore();
  });

  return Math.round(totalScore / (results.length * ScoreRating) * 100) || 0;
};

/**
 * Register an assessment to add it to the internal assessments object.
 *
 * @param {string} name The name of the assessment.
 * @param {object} assessment The object containing function to run as an assessment and it's requirements.
 * @returns {boolean} Whether registering the assessment was successful.
 * @private
 */
Assessor.prototype.addAssessment = function (name, assessment) {
  if (!assessment.hasOwnProperty("identifier")) {
    assessment.identifier = name;
  }

  this._assessments.push(assessment);
  return true;
};

/**
 * Remove a specific Assessment from the list of Assessments.
 *
 * @param {string} name The Assessment to remove from the list of assessments.
 * @returns {void}
 */
Assessor.prototype.removeAssessment = function (name) {
  var toDelete = (0, _lodashEs$g.findIndex)(this._assessments, function (assessment) {
    return assessment.hasOwnProperty("identifier") && name === assessment.identifier;
  });

  if (-1 !== toDelete) {
    this._assessments.splice(toDelete, 1);
  }
};

/**
 * Returns an assessment by identifier
 *
 * @param {string} identifier The identifier of the assessment.
 * @returns {undefined|Object} The object if found, otherwise undefined.
 */
Assessor.prototype.getAssessment = function (identifier) {
  return (0, _lodashEs$g.find)(this._assessments, function (assessment) {
    return assessment.hasOwnProperty("identifier") && identifier === assessment.identifier;
  });
};

/**
 * Checks which of the available assessments are applicable and returns an array with applicable assessments.
 *
 * @returns {Array} The array with applicable assessments.
 */
Assessor.prototype.getApplicableAssessments = function () {
  var availableAssessments = this.getAvailableAssessments();
  return (0, _lodashEs$g.filter)(availableAssessments, function (availableAssessment) {
    return this.isApplicable(availableAssessment, this.getPaper());
  }.bind(this));
};

assessor.default = Assessor;

var seoAssessor$1 = {};

Object.defineProperty(seoAssessor$1, "__esModule", {
	value: true
});

var _util$5 = require$$2$1;

var _IntroductionKeywordAssessment$5 = IntroductionKeywordAssessment$1;

var _IntroductionKeywordAssessment2$5 = _interopRequireDefault$p(_IntroductionKeywordAssessment$5);

var _KeyphraseLengthAssessment$5 = KeyphraseLengthAssessment$1;

var _KeyphraseLengthAssessment2$5 = _interopRequireDefault$p(_KeyphraseLengthAssessment$5);

var _KeywordDensityAssessment$5 = KeywordDensityAssessment$1;

var _KeywordDensityAssessment2$5 = _interopRequireDefault$p(_KeywordDensityAssessment$5);

var _MetaDescriptionKeywordAssessment$5 = MetaDescriptionKeywordAssessment$1;

var _MetaDescriptionKeywordAssessment2$5 = _interopRequireDefault$p(_MetaDescriptionKeywordAssessment$5);

var _TextCompetingLinksAssessment$3 = TextCompetingLinksAssessment$1;

var _TextCompetingLinksAssessment2$3 = _interopRequireDefault$p(_TextCompetingLinksAssessment$3);

var _InternalLinksAssessment$1 = InternalLinksAssessment$1;

var _InternalLinksAssessment2$1 = _interopRequireDefault$p(_InternalLinksAssessment$1);

var _TitleKeywordAssessment$2 = TitleKeywordAssessment$1;

var _TitleKeywordAssessment2$2 = _interopRequireDefault$p(_TitleKeywordAssessment$2);

var _UrlKeywordAssessment$2 = UrlKeywordAssessment$1;

var _UrlKeywordAssessment2$2 = _interopRequireDefault$p(_UrlKeywordAssessment$2);

var _assessor$8 = assessor;

var _assessor2$8 = _interopRequireDefault$p(_assessor$8);

var _MetaDescriptionLengthAssessment$2 = MetaDescriptionLengthAssessment$1;

var _MetaDescriptionLengthAssessment2$2 = _interopRequireDefault$p(_MetaDescriptionLengthAssessment$2);

var _SubHeadingsKeywordAssessment$1 = SubHeadingsKeywordAssessment$1;

var _SubHeadingsKeywordAssessment2$1 = _interopRequireDefault$p(_SubHeadingsKeywordAssessment$1);

var _TextImagesAssessment$3 = TextImagesAssessment$1;

var _TextImagesAssessment2$3 = _interopRequireDefault$p(_TextImagesAssessment$3);

var _TextLengthAssessment$2 = TextLengthAssessment$1;

var _TextLengthAssessment2$2 = _interopRequireDefault$p(_TextLengthAssessment$2);

var _OutboundLinksAssessment$1 = OutboundLinksAssessment$1;

var _OutboundLinksAssessment2$1 = _interopRequireDefault$p(_OutboundLinksAssessment$1);

var _PageTitleWidthAssessment$2 = PageTitleWidthAssessment$1;

var _PageTitleWidthAssessment2$2 = _interopRequireDefault$p(_PageTitleWidthAssessment$2);

var _FunctionWordsInKeyphraseAssessment$5 = FunctionWordsInKeyphraseAssessment$1;

var _FunctionWordsInKeyphraseAssessment2$5 = _interopRequireDefault$p(_FunctionWordsInKeyphraseAssessment$5);

var _SingleH1Assessment$2 = SingleH1Assessment;

var _SingleH1Assessment2$2 = _interopRequireDefault$p(_SingleH1Assessment$2);

function _interopRequireDefault$p(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates the Assessor
 *
 * @param {object} i18n The i18n object used for translations.
 * @param {Object} options The options for this assessor.
 * @param {Object} options.marker The marker to pass the list of marks to.
 *
 * @constructor
 */
const SEOAssessor = function SEOAssessor(i18n, options) {
	_assessor2$8.default.call(this, i18n, options);
	this.type = "SEOAssessor";

	this._assessments = [new _IntroductionKeywordAssessment2$5.default(), new _KeyphraseLengthAssessment2$5.default(), new _KeywordDensityAssessment2$5.default(), new _MetaDescriptionKeywordAssessment2$5.default(), new _MetaDescriptionLengthAssessment2$2.default(), new _SubHeadingsKeywordAssessment2$1.default(), new _TextCompetingLinksAssessment2$3.default(), new _TextImagesAssessment2$3.default(), new _TextLengthAssessment2$2.default(), new _OutboundLinksAssessment2$1.default(), new _TitleKeywordAssessment2$2.default(), new _InternalLinksAssessment2$1.default(), new _PageTitleWidthAssessment2$2.default(), new _UrlKeywordAssessment2$2.default(), new _FunctionWordsInKeyphraseAssessment2$5.default(), new _SingleH1Assessment2$2.default()];
};

(0, _util$5.inherits)(SEOAssessor, _assessor2$8.default);

var _default$4 = seoAssessor$1.default = SEOAssessor;

var contentAssessor$1 = {};

var combinedConfig = {};

var _default$3 = {};

Object.defineProperty(_default$3, "__esModule", {
	value: true
});
_default$3.default = {
	sentenceLength: {
		recommendedWordCount: 20,
		slightlyTooMany: 25,
		farTooMany: 30
	},
	fleschReading: {
		borders: {
			veryEasy: 90,
			easy: 80,
			fairlyEasy: 70,
			okay: 60,
			fairlyDifficult: 50,
			difficult: 30,
			veryDifficult: 0
		},
		scores: {
			veryEasy: 9,
			easy: 9,
			fairlyEasy: 9,
			okay: 9,
			fairlyDifficult: 6,
			difficult: 3,
			veryDifficult: 3
		}
	}
};

var it = {};

Object.defineProperty(it, "__esModule", {
	value: true
});
it.default = {
	sentenceLength: {
		recommendedWordCount: 25
	}
};

var ru = {};

Object.defineProperty(ru, "__esModule", {
	value: true
});
ru.default = {
	sentenceLength: {
		recommendedWordCount: 15
	},
	fleschReading: {
		borders: {
			veryEasy: 80,
			easy: 70,
			fairlyEasy: 60,
			okay: 50,
			fairlyDifficult: 40,
			difficult: 20
		}
	}
};

var pl = {};

Object.defineProperty(pl, "__esModule", {
	value: true
});
pl.default = {
	sentenceLength: {
		slightlyTooMany: 15,
		farTooMany: 20
	}
};

var es = {};

Object.defineProperty(es, "__esModule", {
  value: true
});
/**
 * Spanish sentences tend to be longer than English ones (for which the recommended limit is 20 words).
 * This is why the sentence length limit was increased to 25 for Spanish. For more detailed explanation, see:
 * https://github.com/Yoast/research/wiki/Sentence-Length-Spanish
 */

es.default = {
  sentenceLength: {
    recommendedWordCount: 25
  }
};

var ca = {};

Object.defineProperty(ca, "__esModule", {
  value: true
});
/**
 * Sentences in Catalan have a similar length distribution as in Spanish, so use the same 25 word limit. For a more detailed explanation, see:
 * https://github.com/Yoast/research/wiki/Sentence-Length-Catalan
 */

ca.default = {
  sentenceLength: {
    recommendedWordCount: 25
  }
};

var pt = {};

Object.defineProperty(pt, "__esModule", {
  value: true
});
/**
 * Portuguese sentences tend to be longer than English ones (for which the recommended word limit is 20 words).
 * This is why the sentence length limit was increased to 25 for Portuguese. For more detailed explanation, see:
 * https://github.com/Yoast/research/wiki/Sentence-length-in-Portuguese
 */

pt.default = {
  sentenceLength: {
    recommendedWordCount: 25
  }
};

var he = {};

Object.defineProperty(he, "__esModule", {
  value: true
});
/**
 * According to our research (see https://github.com/Yoast/research/wiki/Sentence-length-Hebrew) sentences in Hebrew
 * tend to be shorter than sentences in English. One article particularly advises to use no more than 10-12 words per sentence.
 */
he.default = {
  sentenceLength: {
    recommendedWordCount: 15
  }
};

var tr = {};

Object.defineProperty(tr, "__esModule", {
	value: true
});
/**
 * Turkish sentences tend to be shorter because it is a synthetic language. According to our research, sentences that consist of 10 words or above
 * diffciult to read because each word contains suffixes.
 */

tr.default = {
	sentenceLength: {
		recommendedWordCount: 15,
		slightlyTooMany: 20,
		farTooMany: 25
	}
};

Object.defineProperty(combinedConfig, "__esModule", {
	value: true
});

combinedConfig.default = function (locale) {
	const language = (0, _getLanguage2$1.default)(locale);
	if (configurations.hasOwnProperty(language)) {
		return (0, _lodashEs$f.defaultsDeep)(configurations[language], _default2.default);
	}

	return _default2.default;
};

var _lodashEs$f = require$$1$1;

var _getLanguage$1 = getLanguage;

var _getLanguage2$1 = _interopRequireDefault$o(_getLanguage$1);

var _default$2 = _default$3;

var _default2 = _interopRequireDefault$o(_default$2);

var _it = it;

var _it2 = _interopRequireDefault$o(_it);

var _ru = ru;

var _ru2 = _interopRequireDefault$o(_ru);

var _pl = pl;

var _pl2 = _interopRequireDefault$o(_pl);

var _es = es;

var _es2 = _interopRequireDefault$o(_es);

var _ca = ca;

var _ca2 = _interopRequireDefault$o(_ca);

var _pt = pt;

var _pt2 = _interopRequireDefault$o(_pt);

var _he = he;

var _he2 = _interopRequireDefault$o(_he);

var _tr = tr;

var _tr2 = _interopRequireDefault$o(_tr);

function _interopRequireDefault$o(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const configurations = {
	it: _it2.default,
	ru: _ru2.default,
	pl: _pl2.default,
	es: _es2.default,
	ca: _ca2.default,
	pt: _pt2.default,
	he: _he2.default,
	tr: _tr2.default
};

Object.defineProperty(contentAssessor$1, "__esModule", {
	value: true
});

var _assessor$7 = assessor;

var _assessor2$7 = _interopRequireDefault$n(_assessor$7);

var _fleschReadingEaseAssessment$1 = fleschReadingEaseAssessment;

var _fleschReadingEaseAssessment2$1 = _interopRequireDefault$n(_fleschReadingEaseAssessment$1);

var _paragraphTooLongAssessment$1 = paragraphTooLongAssessment;

var _paragraphTooLongAssessment2$1 = _interopRequireDefault$n(_paragraphTooLongAssessment$1);

var _sentenceLengthInTextAssessment$1 = sentenceLengthInTextAssessment;

var _sentenceLengthInTextAssessment2$1 = _interopRequireDefault$n(_sentenceLengthInTextAssessment$1);

var _subheadingDistributionTooLongAssessment$1 = subheadingDistributionTooLongAssessment;

var _subheadingDistributionTooLongAssessment2$1 = _interopRequireDefault$n(_subheadingDistributionTooLongAssessment$1);

var _transitionWordsAssessment$1 = transitionWordsAssessment$1;

var _transitionWordsAssessment2$1 = _interopRequireDefault$n(_transitionWordsAssessment$1);

var _passiveVoiceAssessment$1 = passiveVoiceAssessment$1;

var _passiveVoiceAssessment2$1 = _interopRequireDefault$n(_passiveVoiceAssessment$1);

var _sentenceBeginningsAssessment$1 = sentenceBeginningsAssessment$1;

var _sentenceBeginningsAssessment2$1 = _interopRequireDefault$n(_sentenceBeginningsAssessment$1);

var _textPresenceAssessment$1 = textPresenceAssessment$1;

var _textPresenceAssessment2$1 = _interopRequireDefault$n(_textPresenceAssessment$1);

var _combinedConfig$1 = combinedConfig;

var _combinedConfig2$1 = _interopRequireDefault$n(_combinedConfig$1);

var _scoreToRating$1 = scoreToRating$3;

var _scoreToRating2$1 = _interopRequireDefault$n(_scoreToRating$1);

var _lodashEs$e = require$$1$1;

function _interopRequireDefault$n(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates the Assessor
 *
 * @param {object} i18n The i18n object used for translations.
 * @param {Object} options The options for this assessor.
 * @param {Object} options.marker The marker to pass the list of marks to.
 * @param {string} options.locale The locale.
 *
 * @constructor
 */
const ContentAssessor = function ContentAssessor(i18n, options = {}) {
	_assessor2$7.default.call(this, i18n, options);
	this.type = "ContentAssessor";
	const locale = options.hasOwnProperty("locale") ? options.locale : "en_US";

	this._assessments = [new _fleschReadingEaseAssessment2$1.default((0, _combinedConfig2$1.default)(locale).fleschReading), new _subheadingDistributionTooLongAssessment2$1.default(), _paragraphTooLongAssessment2$1.default, new _sentenceLengthInTextAssessment2$1.default((0, _combinedConfig2$1.default)(locale).sentenceLength), _transitionWordsAssessment2$1.default, _passiveVoiceAssessment2$1.default, _textPresenceAssessment2$1.default, _sentenceBeginningsAssessment2$1.default];
};

/*
	Temporarily disabled:

	var wordComplexity = require( "./assessments/wordComplexityAssessment.js" );
	var sentenceLengthInDescription = require( "./assessments/sentenceLengthInDescriptionAssessment.js" );
 */

require$$2$1.inherits(ContentAssessor, _assessor2$7.default);

/**
 * Calculates the weighted rating for languages that have all assessments based on a given rating.
 *
 * @param {number} rating The rating to be weighted.
 * @returns {number} The weighted rating.
 */
ContentAssessor.prototype.calculatePenaltyPointsFullSupport = function (rating) {
	switch (rating) {
		case "bad":
			return 3;
		case "ok":
			return 2;
		default:
		case "good":
			return 0;
	}
};

/**
 * Calculates the weighted rating for languages that don't have all assessments based on a given rating.
 *
 * @param {number} rating The rating to be weighted.
 * @returns {number} The weighted rating.
 */
ContentAssessor.prototype.calculatePenaltyPointsPartialSupport = function (rating) {
	switch (rating) {
		case "bad":
			return 4;
		case "ok":
			return 2;
		default:
		case "good":
			return 0;
	}
};

/**
 * Determines whether a language is fully supported. If a language supports 8 content assessments
 * it is fully supported
 *
 * @returns {boolean} True if fully supported.
 */
ContentAssessor.prototype._allAssessmentsSupported = function () {
	const numberOfAssessments = 8;
	const applicableAssessments = this.getApplicableAssessments();
	return applicableAssessments.length === numberOfAssessments;
};

/**
 * Calculates the penalty points based on the assessment results.
 *
 * @returns {number} The total penalty points for the results.
 */
ContentAssessor.prototype.calculatePenaltyPoints = function () {
	const results = this.getValidResults();

	const penaltyPoints = (0, _lodashEs$e.map)(results, function (result) {
		const rating = (0, _scoreToRating2$1.default)(result.getScore());

		if (this._allAssessmentsSupported()) {
			return this.calculatePenaltyPointsFullSupport(rating);
		}

		return this.calculatePenaltyPointsPartialSupport(rating);
	}.bind(this));

	return (0, _lodashEs$e.sum)(penaltyPoints);
};

/**
 * Rates the penalty points
 *
 * @param {number} totalPenaltyPoints The amount of penalty points.
 * @returns {number} The score based on the amount of penalty points.
 *
 * @private
 */
ContentAssessor.prototype._ratePenaltyPoints = function (totalPenaltyPoints) {
	if (this.getValidResults().length === 1) {
		// If we have only 1 result, we only have a "no content" result
		return 30;
	}

	if (this._allAssessmentsSupported()) {
		// Determine the total score based on the total penalty points.
		if (totalPenaltyPoints > 6) {
			// A red indicator.
			return 30;
		}

		if (totalPenaltyPoints > 4) {
			// An orange indicator.
			return 60;
		}
	} else {
		if (totalPenaltyPoints > 4) {
			// A red indicator.
			return 30;
		}

		if (totalPenaltyPoints > 2) {
			// An orange indicator.
			return 60;
		}
	}
	// A green indicator.
	return 90;
};

/**
 * Calculates the overall score based on the assessment results.
 *
 * @returns {number} The overall score.
 */
ContentAssessor.prototype.calculateOverallScore = function () {
	const results = this.getValidResults();

	// If you have no content, you have a red indicator.
	if (results.length === 0) {
		return 30;
	}

	const totalPenaltyPoints = this.calculatePenaltyPoints();

	return this._ratePenaltyPoints(totalPenaltyPoints);
};

var _default$1 = contentAssessor$1.default = ContentAssessor;

var taxonomyAssessor = {};

Object.defineProperty(taxonomyAssessor, "__esModule", {
	value: true
});
taxonomyAssessor.getTextLengthAssessment = undefined;

var _util$4 = require$$2$1;

var _IntroductionKeywordAssessment$4 = IntroductionKeywordAssessment$1;

var _IntroductionKeywordAssessment2$4 = _interopRequireDefault$m(_IntroductionKeywordAssessment$4);

var _KeyphraseLengthAssessment$4 = KeyphraseLengthAssessment$1;

var _KeyphraseLengthAssessment2$4 = _interopRequireDefault$m(_KeyphraseLengthAssessment$4);

var _KeywordDensityAssessment$4 = KeywordDensityAssessment$1;

var _KeywordDensityAssessment2$4 = _interopRequireDefault$m(_KeywordDensityAssessment$4);

var _MetaDescriptionKeywordAssessment$4 = MetaDescriptionKeywordAssessment$1;

var _MetaDescriptionKeywordAssessment2$4 = _interopRequireDefault$m(_MetaDescriptionKeywordAssessment$4);

var _TitleKeywordAssessment$1 = TitleKeywordAssessment$1;

var _TitleKeywordAssessment2$1 = _interopRequireDefault$m(_TitleKeywordAssessment$1);

var _UrlKeywordAssessment$1 = UrlKeywordAssessment$1;

var _UrlKeywordAssessment2$1 = _interopRequireDefault$m(_UrlKeywordAssessment$1);

var _assessor$6 = assessor;

var _assessor2$6 = _interopRequireDefault$m(_assessor$6);

var _MetaDescriptionLengthAssessment$1 = MetaDescriptionLengthAssessment$1;

var _MetaDescriptionLengthAssessment2$1 = _interopRequireDefault$m(_MetaDescriptionLengthAssessment$1);

var _TextLengthAssessment$1 = TextLengthAssessment$1;

var _TextLengthAssessment2$1 = _interopRequireDefault$m(_TextLengthAssessment$1);

var _PageTitleWidthAssessment$1 = PageTitleWidthAssessment$1;

var _PageTitleWidthAssessment2$1 = _interopRequireDefault$m(_PageTitleWidthAssessment$1);

var _FunctionWordsInKeyphraseAssessment$4 = FunctionWordsInKeyphraseAssessment$1;

var _FunctionWordsInKeyphraseAssessment2$4 = _interopRequireDefault$m(_FunctionWordsInKeyphraseAssessment$4);

var _SingleH1Assessment$1 = SingleH1Assessment;

var _SingleH1Assessment2$1 = _interopRequireDefault$m(_SingleH1Assessment$1);

var _shortlinker$1 = shortlinker;

function _interopRequireDefault$m(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the text length assessment to use.
 *
 * @returns {TextLengthAssessment} The text length assessment (with taxonomy configuration) to use.
 */
const getTextLengthAssessment = taxonomyAssessor.getTextLengthAssessment = function getTextLengthAssessment() {
	// Export so it can be used in tests.
	return new _TextLengthAssessment2$1.default({
		recommendedMinimum: 250,
		slightlyBelowMinimum: 200,
		belowMinimum: 100,
		veryFarBelowMinimum: 50,
		urlTitle: (0, _shortlinker$1.createAnchorOpeningTag)("https://yoa.st/34j"),
		urlCallToAction: (0, _shortlinker$1.createAnchorOpeningTag)("https://yoa.st/34k")
	});
};

/**
 * Creates the Assessor used for taxonomy pages.
 *
 * @param {object} i18n The i18n object used for translations.
 * @param {Object} options The options for this assessor.
 * @constructor
 */
const TaxonomyAssessor = function TaxonomyAssessor(i18n, options) {
	_assessor2$6.default.call(this, i18n, options);
	this.type = "TaxonomyAssessor";

	this._assessments = [new _IntroductionKeywordAssessment2$4.default(), new _KeyphraseLengthAssessment2$4.default(), new _KeywordDensityAssessment2$4.default(), new _MetaDescriptionKeywordAssessment2$4.default(), new _MetaDescriptionLengthAssessment2$1.default(), getTextLengthAssessment(), new _TitleKeywordAssessment2$1.default(), new _PageTitleWidthAssessment2$1.default(), new _UrlKeywordAssessment2$1.default(), new _FunctionWordsInKeyphraseAssessment2$4.default(), new _SingleH1Assessment2$1.default()];
};

(0, _util$4.inherits)(TaxonomyAssessor, _assessor2$6.default);

taxonomyAssessor.default = TaxonomyAssessor;

var pluggable = {};

Object.defineProperty(pluggable, "__esModule", {
	value: true
});

var _lodashEs$d = require$$1$1;

var _invalidType$1 = invalidType;

var _invalidType2$1 = _interopRequireDefault$l(_invalidType$1);

function _interopRequireDefault$l(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The plugins object takes care of plugin registrations, preloading and managing data modifications.
 *
 * A plugin for YoastSEO.js is basically a piece of JavaScript that hooks into YoastSEO.js by registering modifications.
 * In order to do so, it must first register itself as a plugin with YoastSEO.js. To keep our content analysis fast, we
 * don't allow asynchronous modifications. That's why we require plugins to preload all data they need in order to modify
 * the content. If plugins need to preload data, they can first register, then preload using AJAX and call `ready` once
 * preloaded.
 *
 * To minimize client side memory usage, we request plugins to preload as little data as possible. If you need to dynamically
 * fetch more data in the process of content creation, you can reload your data set and let YoastSEO.js know you've reloaded
 * by calling `reloaded`.
 */

/**
 * Setup Pluggable and set its default values.
 *
 * @constructor
 * @param       {App}       app                 The App object to attach to.
 * @property    {number}    preloadThreshold	The maximum time plugins are allowed to preload before we load our content analysis.
 * @property    {object}    plugins             The plugins that have been registered.
 * @property    {object}    modifications 	    The modifications that have been registered. Every modification contains an array with callables.
 * @property    {Array}     customTests         All tests added by plugins.
 */
var Pluggable = function Pluggable(app) {
	this.app = app;
	this.loaded = false;
	this.preloadThreshold = 3000;
	this.plugins = {};
	this.modifications = {};
	this.customTests = [];

	// Allow plugins 1500 ms to register before we start polling their
	setTimeout(this._pollLoadingPlugins.bind(this), 1500);
};

//  ***** DSL IMPLEMENTATION ***** //

/**
 * Register a plugin with YoastSEO. A plugin can be declared "ready" right at registration or later using `this.ready`.
 *
 * @param {string}  pluginName      The name of the plugin to be registered.
 * @param {object}  options         The options passed by the plugin.
 * @param {string}  options.status  The status of the plugin being registered. Can either be "loading" or "ready".
 * @returns {boolean}               Whether or not the plugin was successfully registered.
 */
Pluggable.prototype._registerPlugin = function (pluginName, options) {
	if (typeof pluginName !== "string") {
		console.error("Failed to register plugin. Expected parameter `pluginName` to be a string.");
		return false;
	}

	if (!(0, _lodashEs$d.isUndefined)(options) && typeof options !== "object") {
		console.error("Failed to register plugin " + pluginName + ". Expected parameters `options` to be a object.");
		return false;
	}

	if (this._validateUniqueness(pluginName) === false) {
		console.error("Failed to register plugin. Plugin with name " + pluginName + " already exists");
		return false;
	}

	this.plugins[pluginName] = options;

	return true;
};

/**
 * Declare a plugin "ready". Use this if you need to preload data with AJAX.
 *
 * @param {string} pluginName	The name of the plugin to be declared as ready.
 * @returns {boolean}           Whether or not the plugin was successfully declared ready.
 */
Pluggable.prototype._ready = function (pluginName) {
	if (typeof pluginName !== "string") {
		console.error("Failed to modify status for plugin " + pluginName + ". Expected parameter `pluginName` to be a string.");
		return false;
	}

	if ((0, _lodashEs$d.isUndefined)(this.plugins[pluginName])) {
		console.error("Failed to modify status for plugin " + pluginName + ". The plugin was not properly registered.");
		return false;
	}

	this.plugins[pluginName].status = "ready";

	return true;
};

/**
 * Used to declare a plugin has been reloaded. If an analysis is currently running. We will reset it to ensure running the latest modifications.
 *
 * @param {string} pluginName   The name of the plugin to be declared as reloaded.
 * @returns {boolean}           Whether or not the plugin was successfully declared as reloaded.
 */
Pluggable.prototype._reloaded = function (pluginName) {
	if (typeof pluginName !== "string") {
		console.error("Failed to reload Content Analysis for " + pluginName + ". Expected parameter `pluginName` to be a string.");
		return false;
	}

	if ((0, _lodashEs$d.isUndefined)(this.plugins[pluginName])) {
		console.error("Failed to reload Content Analysis for plugin " + pluginName + ". The plugin was not properly registered.");
		return false;
	}

	this.app.refresh();
	return true;
};

/**
 * Enables hooking a callable to a specific data filter supported by YoastSEO. Can only be performed for plugins that have finished loading.
 *
 * @param {string}      modification	The name of the filter
 * @param {function}    callable 	    The callable
 * @param {string}      pluginName 	    The plugin that is registering the modification.
 * @param {number}      priority	    (optional) Used to specify the order in which the callables associated with a particular filter are called.
 * 									    Lower numbers correspond with earlier execution.
 * @returns {boolean}                   Whether or not applying the hook was successfull.
 */
Pluggable.prototype._registerModification = function (modification, callable, pluginName, priority) {
	if (typeof modification !== "string") {
		console.error("Failed to register modification for plugin " + pluginName + ". Expected parameter `modification` to be a string.");
		return false;
	}

	if (typeof callable !== "function") {
		console.error("Failed to register modification for plugin " + pluginName + ". Expected parameter `callable` to be a function.");
		return false;
	}

	if (typeof pluginName !== "string") {
		console.error("Failed to register modification for plugin " + pluginName + ". Expected parameter `pluginName` to be a string.");
		return false;
	}

	// Validate origin
	if (this._validateOrigin(pluginName) === false) {
		console.error("Failed to register modification for plugin " + pluginName + ". The integration has not finished loading yet.");
		return false;
	}

	// Default priority to 10
	var prio = typeof priority === "number" ? priority : 10;

	var callableObject = {
		callable: callable,
		origin: pluginName,
		priority: prio
	};

	// Make sure modification is defined on modifications object
	if ((0, _lodashEs$d.isUndefined)(this.modifications[modification])) {
		this.modifications[modification] = [];
	}

	this.modifications[modification].push(callableObject);

	return true;
};

/**
 * Register test for a specific plugin
 *
 * @returns {void}
 *
 * @deprecated
 */
Pluggable.prototype._registerTest = function () {
	console.error("This function is deprecated, please use _registerAssessment");
};

/**
 * Register an assessment for a specific plugin
 *
 * @param {object} assessor The assessor object where the assessments needs to be added.
 * @param {string} name The name of the assessment.
 * @param {function} assessment The function to run as an assessment.
 * @param {string} pluginName The name of the plugin associated with the assessment.
 * @returns {boolean} Whether registering the assessment was successful.
 * @private
 */
Pluggable.prototype._registerAssessment = function (assessor, name, assessment, pluginName) {
	if (!(0, _lodashEs$d.isString)(name)) {
		throw new _invalidType2$1.default("Failed to register test for plugin " + pluginName + ". Expected parameter `name` to be a string.");
	}

	if (!(0, _lodashEs$d.isObject)(assessment)) {
		throw new _invalidType2$1.default("Failed to register assessment for plugin " + pluginName + ". Expected parameter `assessment` to be a function.");
	}

	if (!(0, _lodashEs$d.isString)(pluginName)) {
		throw new _invalidType2$1.default("Failed to register assessment for plugin " + pluginName + ". Expected parameter `pluginName` to be a string.");
	}

	// Prefix the name with the pluginName so the test name is always unique.
	name = pluginName + "-" + name;

	assessor.addAssessment(name, assessment);

	return true;
};

// ***** PRIVATE HANDLERS *****//

/**
 * Poller to handle loading of plugins. Plugins can register with our app to let us know they are going to hook into our Javascript. They are allowed
 * 5 seconds of pre-loading time to fetch all the data they need to be able to perform their data modifications. We will only apply data modifications
 * from plugins that have declared ready within the pre-loading time in order to safeguard UX and data integrity.
 *
 * @param   {number} pollTime (optional) The accumulated time to compare with the pre-load threshold.
 * @returns {void}
 * @private
 */
Pluggable.prototype._pollLoadingPlugins = function (pollTime) {
	pollTime = (0, _lodashEs$d.isUndefined)(pollTime) ? 0 : pollTime;
	if (this._allReady() === true) {
		this.loaded = true;
		this.app.pluginsLoaded();
	} else if (pollTime >= this.preloadThreshold) {
		this._pollTimeExceeded();
	} else {
		pollTime += 50;
		setTimeout(this._pollLoadingPlugins.bind(this, pollTime), 50);
	}
};

/**
 * Checks if all registered plugins have finished loading
 *
 * @returns {boolean} Whether or not all registered plugins are loaded.
 * @private
 */
Pluggable.prototype._allReady = function () {
	return (0, _lodashEs$d.reduce)(this.plugins, function (allReady, plugin) {
		return allReady && plugin.status === "ready";
	}, true);
};

/**
 * Removes the plugins that were not loaded within time and calls `pluginsLoaded` on the app.
 *
 * @returns {void}
 * @private
 */
Pluggable.prototype._pollTimeExceeded = function () {
	(0, _lodashEs$d.forEach)(this.plugins, function (plugin, pluginName) {
		if (!(0, _lodashEs$d.isUndefined)(plugin.options) && plugin.options.status !== "ready") {
			console.error("Error: Plugin " + pluginName + ". did not finish loading in time.");
			delete this.plugins[pluginName];
		}
	});
	this.loaded = true;
	this.app.pluginsLoaded();
};

/**
 * Calls the callables added to a modification hook. See the YoastSEO.js Readme for a list of supported modification hooks.
 *
 * @param	{string}    modification	The name of the filter
 * @param   {*}         data 		    The data to filter
 * @param   {*}         context		    (optional) Object for passing context parameters to the callable.
 * @returns {*} 		                The filtered data
 * @private
 */
Pluggable.prototype._applyModifications = function (modification, data, context) {
	var callChain = this.modifications[modification];

	if (callChain instanceof Array && callChain.length > 0) {
		callChain = this._stripIllegalModifications(callChain);

		callChain.sort(function (a, b) {
			return a.priority - b.priority;
		});
		(0, _lodashEs$d.forEach)(callChain, function (callableObject) {
			var callable = callableObject.callable;
			var newData = callable(data, context);
			if (typeof newData === typeof data) {
				data = newData;
			} else {
				console.error("Modification with name " + modification + " performed by plugin with name " + callableObject.origin + " was ignored because the data that was returned by it was of a different type than the data we had passed it.");
			}
		});
	}
	return data;
};

/**
 * Adds new tests to the analyzer and it's scoring object.
 *
 * @param {YoastSEO.Analyzer} analyzer The analyzer object to add the tests to
 * @returns {void}
 * @private
 */
Pluggable.prototype._addPluginTests = function (analyzer) {
	this.customTests.map(function (customTest) {
		this._addPluginTest(analyzer, customTest);
	}, this);
};

/**
 * Adds one new test to the analyzer and it's scoring object.
 *
 * @param {YoastSEO.Analyzer} analyzer              The analyzer that the test will be added to.
 * @param {Object}            pluginTest            The test to be added.
 * @param {string}            pluginTest.name       The name of the test.
 * @param {function}          pluginTest.callable   The function associated with the test.
 * @param {function}          pluginTest.analysis   The function associated with the analyzer.
 * @param {Object}            pluginTest.scoring    The scoring object to be used.
 * @returns {void}
 * @private
 */
Pluggable.prototype._addPluginTest = function (analyzer, pluginTest) {
	analyzer.addAnalysis({
		name: pluginTest.name,
		callable: pluginTest.analysis
	});

	analyzer.analyzeScorer.addScoring({
		name: pluginTest.name,
		scoring: pluginTest.scoring
	});
};

/**
 * Strips modifications from a callChain if they were not added with a valid origin.
 *
 * @param   {Array} callChain	 The callChain that contains items with possible invalid origins.
 * @returns {Array} callChain 	 The stripped version of the callChain.
 * @private
 */
Pluggable.prototype._stripIllegalModifications = function (callChain) {
	(0, _lodashEs$d.forEach)(callChain, function (callableObject, index) {
		if (this._validateOrigin(callableObject.origin) === false) {
			delete callChain[index];
		}
	}.bind(this));

	return callChain;
};

/**
 * Validates if origin of a modification has been registered and finished preloading.
 *
 * @param 	{string}    pluginName      The name of the plugin that needs to be validated.
 * @returns {boolean}                   Whether or not the origin is valid.
 * @private
 */
Pluggable.prototype._validateOrigin = function (pluginName) {
	if (this.plugins[pluginName].status !== "ready") {
		return false;
	}
	return true;
};

/**
 * Validates if registered plugin has a unique name.
 *
 * @param 	{string}    pluginName      The name of the plugin that needs to be validated for uniqueness.
 * @returns {boolean}                   Whether or not the plugin has a unique name.
 * @private
 */
Pluggable.prototype._validateUniqueness = function (pluginName) {
	if (!(0, _lodashEs$d.isUndefined)(this.plugins[pluginName])) {
		return false;
	}
	return true;
};

pluggable.default = Pluggable;

var snippetPreview = {};

var templates = {exports: {}};

(function (module, exports) {
(function () {
  var undefined$1;

  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  var root = freeGlobal || freeSelf || Function('return this')();

  var freeExports = exports && !exports.nodeType && exports;

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined$1;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]';

  /** Used to match HTML entities and HTML characters. */
  var reUnescapedHtml = /[&<>"']/g,
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /*--------------------------------------------------------------------------*/

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function (key) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /*--------------------------------------------------------------------------*/

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Built-in value references. */
  var Symbol = root.Symbol,
      symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = Symbol ? Symbol.prototype : undefined$1,
      symbolToString = symbolProto ? symbolProto.toString : undefined$1;

  /*------------------------------------------------------------------------*/

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined$1 ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isArray(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
  }

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined$1;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  /*------------------------------------------------------------------------*/

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
  }

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString(value) {
    return value == null ? '' : baseToString(value);
  }

  /*------------------------------------------------------------------------*/

  /**
   * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
   * corresponding HTML entities.
   *
   * **Note:** No other characters are escaped. To escape additional
   * characters use a third-party library like [_he_](https://mths.be/he).
   *
   * Though the ">" character is escaped for symmetry, characters like
   * ">" and "/" don't need escaping in HTML and have no special meaning
   * unless they're part of a tag or unquoted attribute value. See
   * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
   * (under "semi-related fun fact") for more details.
   *
   * When working with HTML you should always
   * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
   * XSS vectors.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category String
   * @param {string} [string=''] The string to escape.
   * @returns {string} Returns the escaped string.
   * @example
   *
   * _.escape('fred, barney, & pebbles');
   * // => 'fred, barney, &amp; pebbles'
   */
  function escape(string) {
    string = toString(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
  }

  var _ = { 'escape': escape };

  /*----------------------------------------------------------------------------*/

  var templates = {
    'assessmentPresenterResult': {},
    'hiddenSpan': {},
    'relevantWords': {},
    'snippetEditor': {}
  };

  templates['assessmentPresenterResult'] = function (obj) {
    obj || (obj = {});
    var _obj = obj;
    const scores = _obj.scores,
          markerButtonsDisabled = _obj.markerButtonsDisabled,
          i18n = _obj.i18n,
          activeMarker = _obj.activeMarker;

    var __t,
        __p = '',
        __e = _.escape;
    __p += '<ul class="wpseoanalysis assessment-results">\n    ';
    for (var i in scores) {
      __p += '\n        <li class="score">\n            <span class="assessment-results__mark-container">\n                ';
      if (scores[i].marker) {
        __p += '\n                    <button type="button" ';
        if (markerButtonsDisabled) {
          __p += ' disabled="disabled" ';
        }
        __p += '\n                        aria-label="';
        if (markerButtonsDisabled) {
          __p += (__t = i18n.disabledMarkText) == null ? '' : __t;
        } else if (scores[i].identifier === activeMarker) {
          __p += (__t = i18n.removeMarksInText) == null ? '' : __t;
        } else {
          __p += (__t = i18n.markInText) == null ? '' : __t;
        }
        __p += '"\n                        class="assessment-results__mark ';

        if (markerButtonsDisabled) {
          __p += ' icon-eye-disabled ';
        } else if (scores[i].identifier === activeMarker) {
          __p += '\n                            icon-eye-active\n                        ';
        } else {
          __p += '\n                            icon-eye-inactive\n                        ';
        }
        __p += '\n                        js-assessment-results__mark-' + ((__t = scores[i].identifier) == null ? '' : __t) + ' yoast-tooltip yoast-tooltip-s">\n                        <span class="screen-reader-text">';
        if (markerButtonsDisabled) {
          __p += (__t = i18n.disabledMarkText) == null ? '' : __t;
        } else if (scores[i].identifier === activeMarker) {
          __p += (__t = i18n.removeMarksInText) == null ? '' : __t;
        } else {
          __p += (__t = i18n.markInText) == null ? '' : __t;
        }
        __p += '\n                        </span></button>\n                ';
      }
      __p += '\n            </span>\n            <span class="wpseo-score-icon ' + __e(scores[i].className) + '"></span>\n            <span class="screen-reader-text">' + ((__t = scores[i].screenReaderText) == null ? '' : __t) + '</span>\n            <span class="wpseo-score-text">' + ((__t = scores[i].text) == null ? '' : __t) + '</span>\n        </li>\n    ';
    }
    __p += '\n</ul>\n';
    return __p;
  };

  templates['hiddenSpan'] = function (obj) {
    obj || (obj = {});
    var _obj2 = obj;
    const whiteSpace = _obj2.whiteSpace,
          width = _obj2.width;

    var __p = '',
        __e = _.escape;
    __p += '<span aria-hidden="true" style="width: ' + __e(width) + '; height: auto; position: absolute; visibility: hidden; ';
    if ("" !== whiteSpace) {
      __p += 'white-space: ' + __e(whiteSpace);
    }
    __p += '">\n\n</span>\n';
    return __p;
  };

  templates['relevantWords'] = function (obj) {
    obj || (obj = {});
    var _obj3 = obj;
    const words = _obj3.words;

    var __t,
        __p = '';
    __p += '<table>\n    <tr>\n        <th>Word</th>\n        <th>Density</th>\n        <th>Occurrences</th>\n        <th>Length</th>\n        <th>Relevant word percentage</th>\n        <th>Length bonus</th>\n        <th>Multiplier</th>\n        <th>Relevance</th>\n    </tr>\n    ';
    for (var i in words) {
      __p += '\n        <tr>\n            <td>' + ((__t = words[i].word) == null ? '' : __t) + '</td>\n            <td>' + ((__t = words[i].density) == null ? '' : __t) + '</td>\n            <td>' + ((__t = words[i].occurrences) == null ? '' : __t) + '</td>\n            <td>' + ((__t = words[i].length) == null ? '' : __t) + '</td>\n            <td>' + ((__t = words[i].relevantWordPercentage) == null ? '' : __t) + '</td>\n            <td>' + ((__t = words[i].lengthBonus) == null ? '' : __t) + '</td>\n            <td>' + ((__t = words[i].multiplier) == null ? '' : __t) + '</td>\n            <td>' + ((__t = words[i].relevance) == null ? '' : __t) + '</td>\n        </tr>\n    ';
    }
    __p += '\n</table>\n';
    return __p;
  };

  templates['snippetEditor'] = function (obj) {
    obj || (obj = {});
    var _obj4 = obj;
    const i18n = _obj4.i18n,
          rendered = _obj4.rendered,
          metaDescriptionDate = _obj4.metaDescriptionDate,
          raw = _obj4.raw,
          placeholder = _obj4.placeholder;

    var __p = '',
        __e = _.escape;
    __p += '<div id="snippet_preview" class="yoast-section">\n	<section class="snippet-editor__preview">\n		<h3 class="snippet-editor__heading snippet-editor__heading-icon snippet-editor__heading-icon-eye">' + __e(i18n.snippetPreview) + '</h3>\n	<p class="screen-reader-text">' + __e(i18n.snippetPreviewDescription) + '</p>\n\n		<div id="snippet-preview-view" class="snippet-editor__view">\n			<div class="snippet_container snippet_container__title snippet-editor__container" id="title_container">\n				<span class="screen-reader-text">' + __e(i18n.titleLabel) + '</span>\n				<span class="title" id="render_title_container">\n					<span id="snippet_title">\n						' + __e(rendered.title) + '\n					</span>\n				</span>\n				<span class="title" id="snippet_sitename"></span>\n			</div>\n			<div class="snippet_container snippet_container__url snippet-editor__container" id="url_container">\n				<span class="screen-reader-text">' + __e(i18n.slugLabel) + '</span>\n				<span class="urlFull">\n					<cite class="url urlBase" id="snippet_citeBase">\n						' + __e(rendered.baseUrl) + '\n					</cite><cite class="url" id="snippet_cite">\n						' + __e(rendered.snippetCite) + '\n					</cite>\n				</span><span class="down_arrow"></span>\n			</div>\n			<div class="snippet_container snippet_container__meta snippet-editor__container" id="meta_container">\n				<span class="screen-reader-text">' + __e(i18n.metaDescriptionLabel) + '</span>\n				';
    if ("" !== metaDescriptionDate) {
      __p += '\n					<span class="snippet-editor__date">\n						' + __e(metaDescriptionDate) + ' -\n					</span>\n				';
    }
    __p += '\n				<span class="desc" id="snippet_meta">\n					' + __e(rendered.meta) + '\n				</span>\n			</div>\n		</div>\n\n		<div class="snippet-editor__is-scrollable-hintwrapper">\n			<span class=\'snippet-editor__is-scrollable-hint\' aria-hidden=\'true\'>' + __e(i18n.isScrollableHint) + '</span>\n		</div>\n\n		<div class="snippet-editor__view-toggle">\n			<button class="snippet-editor__view-icon snippet-editor__view-icon-mobile yoast-tooltip yoast-tooltip-se" type="button" data-type="mobile" aria-label="' + __e(i18n.mobilePreviewMode) + '" />\n			<button class="snippet-editor__view-icon snippet-editor__view-icon-desktop yoast-tooltip yoast-tooltip-se" type="button" data-type="desktop" aria-label="' + __e(i18n.desktopPreviewMode) + '" />\n		</div>\n		<button class="snippet-editor__button snippet-editor__edit-button" type="button" aria-expanded="false">\n			' + __e(i18n.edit) + '\n		</button>\n	</section>\n\n	<div class="snippet-editor__form snippet-editor--hidden">\n		<label for="snippet-editor-title" class="snippet-editor__label">\n			' + __e(i18n.title) + '\n			<input type="text" class="snippet-editor__input snippet-editor__title js-snippet-editor-title" id="snippet-editor-title" value="' + __e(raw.title) + '" placeholder="' + __e(placeholder.title) + '" />\n		</label>\n		<progress value="0.0" class="snippet-editor__progress snippet-editor__progress-title" aria-hidden="true">\n			<div class="snippet-editor__progress-bar"></div>\n		</progress>\n		<label for="snippet-editor-slug" class="snippet-editor__label">\n			' + __e(i18n.slug) + '\n			<input type="text" class="snippet-editor__input snippet-editor__slug js-snippet-editor-slug" id="snippet-editor-slug" value="' + __e(raw.snippetCite) + '" placeholder="' + __e(placeholder.urlPath) + '" />\n		</label>\n		<label for="snippet-editor-meta-description" class="snippet-editor__label">\n			' + __e(i18n.metaDescription) + '\n			<textarea class="snippet-editor__input snippet-editor__meta-description js-snippet-editor-meta-description" id="snippet-editor-meta-description" placeholder="' + __e(placeholder.metaDesc) + '">' + __e(raw.meta) + '</textarea>\n		</label>\n		<progress value="0.0" class="snippet-editor__progress snippet-editor__progress-meta-description" aria-hidden="true">\n			<div class="snippet-editor__progress-bar"></div>\n		</progress>\n\n		<button class="snippet-editor__submit snippet-editor__button" type="button">' + __e(i18n.save) + '</button>\n	</div>\n</div>\n';
    return __p;
  };

  /*----------------------------------------------------------------------------*/

  if (freeModule) {
    (freeModule.exports = templates).templates = templates;
    freeExports.templates = templates;
  } else {
    root.templates = templates;
  }
}).call(undefined);

}(templates, templates.exports));

var snippetPreviewToggler = {};

var domManipulation = {};

Object.defineProperty(domManipulation, "__esModule", {
  value: true
});

var _lodashEs$c = require$$1$1;

/**
 * Adds a class to an element
 *
 * @param {HTMLElement} element The element to add the class to.
 * @param {string} className The class to add.
 * @returns {void}
 */
var addClass = function addClass(element, className) {
  var classes = element.className.split(" ");

  if (-1 === classes.indexOf(className)) {
    classes.push(className);
  }

  element.className = classes.join(" ");
};

/**
 * Removes a class from an element
 *
 * @param {HTMLElement} element The element to remove the class from.
 * @param {string} className The class to remove.
 * @returns {void}
 */
var removeClass = function removeClass(element, className) {
  var classes = element.className.split(" ");
  var foundClass = classes.indexOf(className);

  if (-1 !== foundClass) {
    classes.splice(foundClass, 1);
  }

  element.className = classes.join(" ");
};

/**
 * Removes multiple classes from an element
 *
 * @param {HTMLElement} element The element to remove the classes from.
 * @param {Array} classes A list of classes to remove
 * @returns {void}
 */
var removeClasses = function removeClasses(element, classes) {
  (0, _lodashEs$c.forEach)(classes, this.removeClass.bind(null, element));
};

/**
 * Checks whether an element has a specific class.
 *
 * @param {HTMLElement} element The element to check for the class.
 * @param {string} className The class to look for.
 * @returns {boolean} Whether or not the class is present.
 */
var hasClass = function hasClass(element, className) {
  return element.className.indexOf(className) > -1;
};

domManipulation.default = {
  hasClass: hasClass,
  addClass: addClass,
  removeClass: removeClass,
  removeClasses: removeClasses
};

Object.defineProperty(snippetPreviewToggler, "__esModule", {
  value: true
});

var _lodashEs$b = require$$1$1;

var _domManipulation$1 = domManipulation;

var _domManipulation2$1 = _interopRequireDefault$k(_domManipulation$1);

function _interopRequireDefault$k(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var previewModes = {
  desktop: "snippet-editor__view--desktop",
  mobile: "snippet-editor__view--mobile"
};

var minimumDesktopWidth = 640;

/**
 * Constructs the snippet preview toggle.
 *
 * @param {string}    previewMode    The default preview mode.
 * @param {Element[]} previewToggles Array with toggle elements.
 *
 * @property {string}    previewMode    The current preview mode.
 * @property {Element[]} previewToggles The array with toggle elements.
 * @property {Element}   viewElement    The target element.
 * @constructor
 */
var SnippetPreviewToggler = function SnippetPreviewToggler(previewMode, previewToggles) {
  this.previewMode = previewMode;
  this.previewToggles = previewToggles;
  this.viewElement = document.getElementById("snippet-preview-view");
};

/**
 * Initializes the object by setting the current previewMode as the active one.
 *
 * @returns {void}
 */
SnippetPreviewToggler.prototype.initialize = function () {
  this._setPreviewMode(this.previewMode, this._findElementByMode(this.previewMode));
};

/**
 * Binds a function on the click event of the preview toggle.
 *
 * @param {string} previewToggle The previewToggle to bind the click event on.
 *
 * @returns {void}
 */
SnippetPreviewToggler.prototype.bindClickEvent = function (previewToggle) {
  previewToggle.addEventListener("click", function () {
    this._setPreviewMode(previewToggle.getAttribute("data-type"), previewToggle);
    this.removeTooltipAbility(previewToggle);
  }.bind(this));
};

/**
 * Binds a function on the mouseleave event of the preview toggle.
 *
 * @param {string} previewToggle The previewToggle to bind the mouseleave event on.
 *
 * @returns {void}
 */
SnippetPreviewToggler.prototype.bindMouseleaveEvent = function (previewToggle) {
  previewToggle.addEventListener("mouseleave", function () {
    this.removeTooltipAbility(previewToggle);
  }.bind(this));
};

/**
 * Binds a function on the blur event of the preview toggle.
 *
 * @param {string} previewToggle The previewToggle to bind the blur event on.
 *
 * @returns {void}
 */
SnippetPreviewToggler.prototype.bindBlurEvent = function (previewToggle) {
  previewToggle.addEventListener("blur", function () {
    this.restoreTooltipAbility(previewToggle);
  }.bind(this));
};

/**
 * Binds a function on the mouseenter event of the preview toggle.
 *
 * @param {string} previewToggle The previewToggle to bind the mouseenter event on.
 *
 * @returns {void}
 */
SnippetPreviewToggler.prototype.bindMouseenterEvent = function (previewToggle) {
  previewToggle.addEventListener("mouseenter", function () {
    this.restoreTooltipAbility(previewToggle);
  }.bind(this));
};

/**
 * Sets the events for the preview toggles to switch between the preview modes and handle the tooltips.
 *
 * @returns {void}
 */
SnippetPreviewToggler.prototype.bindEvents = function () {
  (0, _lodashEs$b.forEach)(this.previewToggles, function (previewToggle) {
    this.bindClickEvent(previewToggle);
    this.bindMouseleaveEvent(previewToggle);
    this.bindBlurEvent(previewToggle);
    this.bindMouseenterEvent(previewToggle);
  }.bind(this));
};

/**
 * Returns the element by given mode.
 *
 * @param {string} previewMode The mode used to find the element.
 * @returns {Element} The found element.
 * @private
 */
SnippetPreviewToggler.prototype._findElementByMode = function (previewMode) {
  return document.getElementsByClassName("snippet-editor__view-icon-" + previewMode)[0];
};

/**
 * Sets the preview mode.
 *
 * @param {string}  previewMode   The preview mode that has to be set.
 * @param {Element} toggleElement The element that has been triggered.
 *
 * @returns {void}
 * @private
 */
SnippetPreviewToggler.prototype._setPreviewMode = function (previewMode, toggleElement) {
  this._removeActiveStates();
  this._setActiveState(toggleElement);

  _domManipulation2$1.default.removeClass(this.viewElement, previewModes[this.previewMode]);
  _domManipulation2$1.default.addClass(this.viewElement, previewModes[previewMode]);

  this.previewMode = previewMode;
};

/**
 * Sets the Snippet Preview Toggler to desktop mode.
 *
 * @returns {void}
 */
SnippetPreviewToggler.prototype.setDesktopMode = function () {
  this._setPreviewMode("desktop", this._findElementByMode("desktop"));
};

/**
 * Sets the Snippet Preview Toggler to mobile mode.
 *
 * @returns {void}
 */
SnippetPreviewToggler.prototype.setMobileMode = function () {
  this._setPreviewMode("mobile", this._findElementByMode("mobile"));
};

/**
 * Sets the initial view to desktop or mobile based on the width of the Snippet Preview container.
 *
 * @param {number} previewWidth the width of the Snippet Preview container.
 *
 * @returns {void}
 */
SnippetPreviewToggler.prototype.setVisibility = function (previewWidth) {
  if (previewWidth < minimumDesktopWidth) {
    this.setMobileMode();
    // At this point the desktop view is scrollable: set a CSS class to show the Scroll Hint message.
    _domManipulation2$1.default.addClass(this.viewElement, "snippet-editor__view--desktop-has-scroll");
  } else {
    this.setDesktopMode();
  }
};

/**
 * When the window is resized, sets the visibility of the Scroll Hint message.
 *
 * @param {number} previewWidth the width of the Snippet Preview container.
 *
 * @returns {void}
 */
SnippetPreviewToggler.prototype.setScrollHintVisibility = function (previewWidth) {
  _domManipulation2$1.default.removeClass(this.viewElement, "snippet-editor__view--desktop-has-scroll");
  if (previewWidth < minimumDesktopWidth) {
    _domManipulation2$1.default.addClass(this.viewElement, "snippet-editor__view--desktop-has-scroll");
  }
};

/**
 * Removes all active state for the preview toggles.
 *
 * @returns {void}
 * @private
 */
SnippetPreviewToggler.prototype._removeActiveStates = function () {
  (0, _lodashEs$b.forEach)(this.previewToggles, this._removeActiveState.bind(this));
};

/**
 * Removes the active state for the given element.
 *
 * @param {Element} previewToggle The element to remove its state for.
 * @returns {void}
 * @private
 */
SnippetPreviewToggler.prototype._removeActiveState = function (previewToggle) {
  _domManipulation2$1.default.removeClass(previewToggle, "snippet-editor__view-icon-" + previewToggle.getAttribute("data-type") + "--active");
  _domManipulation2$1.default.removeClass(previewToggle, "snippet-editor__view-icon--active");
  previewToggle.setAttribute("aria-pressed", "false");
};

/**
 * Makes an element tooltip hidden.
 *
 * @param {Element} previewToggle The element on which the tooltip should be hidden.
 * @returns {void}
 */
SnippetPreviewToggler.prototype.removeTooltipAbility = function (previewToggle) {
  _domManipulation2$1.default.addClass(previewToggle, "yoast-tooltip-hidden");
};

/**
 * Makes an element tooltip visible.
 *
 * @param {Element} previewToggle The element on which the tooltip should be visible.
 * @returns {void}
 */
SnippetPreviewToggler.prototype.restoreTooltipAbility = function (previewToggle) {
  _domManipulation2$1.default.removeClass(previewToggle, "yoast-tooltip-hidden");
};

/**
 * Adds active state to the given element.
 *
 * @param {Element} elementToActivate The element that will be activated.
 * @returns {void}
 * @private
 */
SnippetPreviewToggler.prototype._setActiveState = function (elementToActivate) {
  _domManipulation2$1.default.addClass(elementToActivate, "snippet-editor__view-icon-" + elementToActivate.getAttribute("data-type") + "--active");
  _domManipulation2$1.default.addClass(elementToActivate, "snippet-editor__view-icon--active");
  elementToActivate.setAttribute("aria-pressed", "true");
};

snippetPreviewToggler.default = SnippetPreviewToggler;

Object.defineProperty(snippetPreview, "__esModule", {
	value: true
});

var _lodashEs$a = require$$1$1;

var _createWordRegex = createWordRegex;

var _createWordRegex2 = _interopRequireDefault$j(_createWordRegex);

var _stripHTMLTags = stripHTMLTags;

var _stripSpaces = stripSpaces;

var _stripSpaces2 = _interopRequireDefault$j(_stripSpaces);

var _replaceDiacritics = replaceDiacritics;

var _replaceDiacritics2 = _interopRequireDefault$j(_replaceDiacritics);

var _transliterate = transliterate;

var _transliterate2 = _interopRequireDefault$j(_transliterate);

var _templates$1 = templates.exports;

var _templates2 = _interopRequireDefault$j(_templates$1);

var _snippetPreviewToggler = snippetPreviewToggler;

var _snippetPreviewToggler2 = _interopRequireDefault$j(_snippetPreviewToggler);

var _domManipulation = domManipulation;

var _domManipulation2 = _interopRequireDefault$j(_domManipulation);

var _config$1 = config$2;

var _config2 = _interopRequireDefault$j(_config$1);

function _interopRequireDefault$j(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var snippetEditorTemplate = _templates2.default.snippetEditor;
var hiddenElement = _templates2.default.hiddenSpan;

var defaults$1 = {
	data: {
		title: "",
		metaDesc: "",
		urlPath: "",
		titleWidth: 0,
		metaHeight: 0
	},
	placeholder: {
		title: "This is an example title - edit by clicking here",
		metaDesc: "Modify your meta description by editing it right here",
		urlPath: "example-post/"
	},
	defaultValue: {
		title: "",
		metaDesc: ""
	},
	baseURL: "http://example.com/",
	callbacks: {
		/**
   * Empty function.
   * @returns {void}
   */
		saveSnippetData: function saveSnippetData() {}
	},
	addTrailingSlash: true,
	metaDescriptionDate: "",
	previewMode: "desktop"

};

var titleMaxLength = 600;
const maximumMetaDescriptionLength = _config2.default.maxMeta;

var inputPreviewBindings = [{
	preview: "title_container",
	inputField: "title"
}, {
	preview: "url_container",
	inputField: "urlPath"
}, {
	preview: "meta_container",
	inputField: "metaDesc"
}];

/**
 * Get's the base URL for this instance of the Snippet Preview.
 *
 * @private
 * @this SnippetPreview
 *
 * @returns {string} The base URL.
 */
var getBaseURL = function getBaseURL() {
	var baseURL = this.opts.baseURL;

	/*
  * For backwards compatibility, if no URL was passed to the snippet editor we try to retrieve the base URL from the
  * rawData in the App. This is because the scrapers used to be responsible for retrieving the baseURL, but the base
  * URL is static so we can just pass it to the snippet editor.
  */
	if (this.hasApp() && !(0, _lodashEs$a.isEmpty)(this.refObj.rawData.baseUrl) && this.opts.baseURL === defaults$1.baseURL) {
		baseURL = this.refObj.rawData.baseUrl;
	}

	return baseURL;
};

/**
 * Retrieves unformatted text from the data object
 *
 * @private
 * @this SnippetPreview
 *
 * @param {string} key The key to retrieve.
 *
 * @returns {string} The unformatted text.
 */
function retrieveUnformattedText(key) {
	return this.data[key];
}

/**
 * Update data and DOM objects when the unformatted text is updated, here for backwards compatibility
 *
 * @private
 * @this SnippetPreview
 *
 * @param {string} key The data key to update.
 * @param {string} value The value to update.
 *
 * @returns {void}
 */
function updateUnformattedText(key, value) {
	this.element.input[key].value = value;

	this.data[key] = value;
}

/**
 * Returns if a url has a trailing slash or not.
 *
 * @param {string} url The url to check for a trailing slash.
 *
 * @returns {boolean} Whether or not the url contains a trailing slash.
 */
function hasTrailingSlash(url) {
	return url.indexOf("/") === url.length - 1;
}

/**
 * Detects if this browser has <progress> support. Also serves as a poor man's HTML5shiv.
 *
 * @private
 *
 * @returns {boolean} Whether or not the browser supports a <progress> element
 */
function hasProgressSupport() {
	var progressElement = document.createElement("progress");

	return !(0, _lodashEs$a.isUndefined)(progressElement.max);
}

/**
 * Returns a rating based on the length of the title
 *
 * @param {number} titleLength the length of the title.
 *
 * @returns {string} The rating given based on the title length.
 */
function rateTitleLength$1(titleLength) {
	var rating;

	switch (true) {
		case titleLength > 0 && titleLength <= 399:
		case titleLength > 600:
			rating = "ok";
			break;

		case titleLength >= 400 && titleLength <= 600:
			rating = "good";
			break;

		default:
			rating = "bad";
			break;
	}

	return rating;
}

/**
 * Returns a rating based on the length of the meta description
 *
 * @param {number} metaDescLength the length of the meta description.
 *
 * @returns {string} The rating given based on the description length.
 */
function rateMetaDescLength$1(metaDescLength) {
	var rating;

	switch (true) {
		case metaDescLength > 0 && metaDescLength < 120:
		case metaDescLength > maximumMetaDescriptionLength:
			rating = "ok";
			break;

		case metaDescLength >= 120 && metaDescLength <= maximumMetaDescriptionLength:
			rating = "good";
			break;

		default:
			rating = "bad";
			break;
	}

	return rating;
}

/**
 * Updates a progress bar
 *
 * @private
 * @this SnippetPreview
 *
 * @param {HTMLElement} element The progress element that's rendered.
 * @param {number} value The current value.
 * @param {number} maximum The maximum allowed value.
 * @param {string} rating The SEO score rating for this value.
 *
 * @returns {void}
 */
function updateProgressBar(element, value, maximum, rating) {
	var barElement,
	    progress,
	    allClasses = ["snippet-editor__progress--bad", "snippet-editor__progress--ok", "snippet-editor__progress--good"];

	element.value = value;
	_domManipulation2.default.removeClasses(element, allClasses);
	_domManipulation2.default.addClass(element, "snippet-editor__progress--" + rating);

	if (!this.hasProgressSupport) {
		barElement = element.getElementsByClassName("snippet-editor__progress-bar")[0];
		progress = value / maximum * 100;

		barElement.style.width = progress + "%";
	}
}

/**
 * @module snippetPreview
 */

/**
 * Defines the config and outputTarget for the SnippetPreview
 *
 * @param {Object}         opts                           - Snippet preview options.
 * @param {App}            opts.analyzerApp               - The app object the Snippet Preview is part of.
 * @param {Object}         opts.placeholder               - The placeholder values for the fields, will be shown as
 * actual placeholders in the inputs and as a fallback for the preview.
 * @param {string}         opts.placeholder.title         - The placeholder title.
 * @param {string}         opts.placeholder.metaDesc      - The placeholder meta description.
 * @param {string}         opts.placeholder.urlPath       - The placeholder url.
 *
 * @param {Object}         opts.defaultValue              - The default value for the fields, if the user has not
 * changed a field, this value will be used for the analyzer, preview and the progress bars.
 * @param {string}         opts.defaultValue.title        - The default title.
 * @param {string}         opts.defaultValue.metaDesc     - The default meta description.
 * it.
 *
 * @param {string}         opts.baseURL                   - The basic URL as it will be displayed in google.
 * @param {HTMLElement}    opts.targetElement             - The target element that contains this snippet editor.
 *
 * @param {Object}         opts.callbacks                 - Functions that are called on specific instances.
 * @param {Function}       opts.callbacks.saveSnippetData - Function called when the snippet data is changed.
 *
 * @param {boolean}        opts.addTrailingSlash          - Whether or not to add a trailing slash to the URL.
 * @param {string}         opts.metaDescriptionDate       - The date to display before the meta description.
 *
 * @param {Jed}            opts.i18n                      - The translation object.
 *
 * @param {string}         opts.previewMode               - The current preview mode.
 *
 * @property {App}         refObj                         - The connected app object.
 * @property {Jed}         i18n                           - The translation object.
 *
 * @property {HTMLElement} targetElement                  - The target element that contains this snippet editor.
 *
 * @property {Object}      element                        - The elements for this snippet editor.
 * @property {Object}      element.rendered               - The rendered elements.
 * @property {HTMLElement} element.rendered.title         - The rendered title element.
 * @property {HTMLElement} element.rendered.urlPath       - The rendered url path element.
 * @property {HTMLElement} element.rendered.urlBase       - The rendered url base element.
 * @property {HTMLElement} element.rendered.metaDesc      - The rendered meta description element.
 *
 * @property {HTMLElement} element.measurers.titleWidth   - The rendered title width element.
 * @property {HTMLElement} element.measurers.metaHeight   - The rendered meta height element.
 *
 * @property {Object}      element.input                  - The input elements.
 * @property {HTMLElement} element.input.title            - The title input element.
 * @property {HTMLElement} element.input.urlPath          - The url path input element.
 * @property {HTMLElement} element.input.metaDesc         - The meta description input element.
 *
 * @property {HTMLElement} element.container              - The main container element.
 * @property {HTMLElement} element.formContainer          - The form container element.
 * @property {HTMLElement} element.editToggle             - The button that toggles the editor form.
 *
 * @property {Object}      data                           - The data for this snippet editor.
 * @property {string}      data.title                     - The title.
 * @property {string}      data.urlPath                   - The url path.
 * @property {string}      data.metaDesc                  - The meta description.
 * @property {int}         data.titleWidth                - The width of the title in pixels.
 * @property {int}         data.metaHeight                - The height of the meta description in pixels.
 *
 * @property {string}      baseURL                        - The basic URL as it will be displayed in google.
 *
 * @property {boolean}     hasProgressSupport             - Whether this browser supports the <progress> element.
 *
 * @constructor
 */
var SnippetPreview = function SnippetPreview(opts) {
	(0, _lodashEs$a.defaultsDeep)(opts, defaults$1);

	this.data = opts.data;

	if (!(0, _lodashEs$a.isUndefined)(opts.analyzerApp)) {
		this.refObj = opts.analyzerApp;
		this.i18n = this.refObj.i18n;

		this.data = {
			title: this.refObj.rawData.snippetTitle || "",
			urlPath: this.refObj.rawData.snippetCite || "",
			metaDesc: this.refObj.rawData.snippetMeta || ""
		};

		// For backwards compatibility set the metaTitle as placeholder.
		if (!(0, _lodashEs$a.isEmpty)(this.refObj.rawData.metaTitle)) {
			opts.placeholder.title = this.refObj.rawData.metaTitle;
		}
	}

	if (!(0, _lodashEs$a.isUndefined)(opts.i18n)) {
		this.i18n = opts.i18n;
	}

	if (!(0, _lodashEs$a.isElement)(opts.targetElement)) {
		throw new Error("The snippet preview requires a valid target element");
	}

	this.opts = opts;
	this._currentFocus = null;
	this._currentHover = null;

	// For backwards compatibility monitor the unformatted text for changes and reflect them in the preview
	this.unformattedText = {};
	Object.defineProperty(this.unformattedText, "snippet_cite", {
		get: retrieveUnformattedText.bind(this, "urlPath"),
		set: updateUnformattedText.bind(this, "urlPath")
	});
	Object.defineProperty(this.unformattedText, "snippet_meta", {
		get: retrieveUnformattedText.bind(this, "metaDesc"),
		set: updateUnformattedText.bind(this, "metaDesc")
	});
	Object.defineProperty(this.unformattedText, "snippet_title", {
		get: retrieveUnformattedText.bind(this, "title"),
		set: updateUnformattedText.bind(this, "title")
	});
};

/**
 * Renders snippet editor and adds it to the targetElement
 * @returns {void}
 */
SnippetPreview.prototype.renderTemplate = function () {
	var targetElement = this.opts.targetElement;

	targetElement.innerHTML = snippetEditorTemplate({
		raw: {
			title: this.data.title,
			snippetCite: this.data.urlPath,
			meta: this.data.metaDesc
		},
		rendered: {
			title: this.formatTitle(),
			baseUrl: this.formatUrl(),
			snippetCite: this.formatCite(),
			meta: this.formatMeta()
		},
		metaDescriptionDate: this.opts.metaDescriptionDate,
		placeholder: this.opts.placeholder,
		i18n: {
			edit: this.i18n.dgettext("js-text-analysis", "Edit snippet"),
			title: this.i18n.dgettext("js-text-analysis", "SEO title"),
			slug: this.i18n.dgettext("js-text-analysis", "Slug"),
			metaDescription: this.i18n.dgettext("js-text-analysis", "Meta description"),
			save: this.i18n.dgettext("js-text-analysis", "Close snippet editor"),
			snippetPreview: this.i18n.dgettext("js-text-analysis", "Google preview"),
			titleLabel: this.i18n.dgettext("js-text-analysis", "SEO title preview:"),
			slugLabel: this.i18n.dgettext("js-text-analysis", "Slug preview:"),
			metaDescriptionLabel: this.i18n.dgettext("js-text-analysis", "Meta description preview:"),
			snippetPreviewDescription: this.i18n.dgettext("js-text-analysis", "You can click on each element in the preview to jump to the Snippet Editor."),
			desktopPreviewMode: this.i18n.dgettext("js-text-analysis", "Desktop preview"),
			mobilePreviewMode: this.i18n.dgettext("js-text-analysis", "Mobile preview"),
			isScrollableHint: this.i18n.dgettext("js-text-analysis", "Scroll to see the preview content.")
		}
	});

	this.element = {
		measurers: {
			metaHeight: null
		},
		rendered: {
			title: document.getElementById("snippet_title"),
			urlBase: document.getElementById("snippet_citeBase"),
			urlPath: document.getElementById("snippet_cite"),
			metaDesc: document.getElementById("snippet_meta")
		},
		input: {
			title: targetElement.getElementsByClassName("js-snippet-editor-title")[0],
			urlPath: targetElement.getElementsByClassName("js-snippet-editor-slug")[0],
			metaDesc: targetElement.getElementsByClassName("js-snippet-editor-meta-description")[0]
		},
		progress: {
			title: targetElement.getElementsByClassName("snippet-editor__progress-title")[0],
			metaDesc: targetElement.getElementsByClassName("snippet-editor__progress-meta-description")[0]
		},
		container: document.getElementById("snippet_preview"),
		formContainer: targetElement.getElementsByClassName("snippet-editor__form")[0],
		editToggle: targetElement.getElementsByClassName("snippet-editor__edit-button")[0],
		closeEditor: targetElement.getElementsByClassName("snippet-editor__submit")[0],
		formFields: targetElement.getElementsByClassName("snippet-editor__form-field")
	};

	this.element.label = {
		title: this.element.input.title.parentNode,
		urlPath: this.element.input.urlPath.parentNode,
		metaDesc: this.element.input.metaDesc.parentNode
	};

	this.element.preview = {
		title: this.element.rendered.title.parentNode,
		urlPath: this.element.rendered.urlPath.parentNode,
		metaDesc: this.element.rendered.metaDesc.parentNode
	};

	this.hasProgressSupport = hasProgressSupport();

	if (this.hasProgressSupport) {
		this.element.progress.title.max = titleMaxLength;
		this.element.progress.metaDesc.max = maximumMetaDescriptionLength;
	} else {
		(0, _lodashEs$a.forEach)(this.element.progress, function (progressElement) {
			_domManipulation2.default.addClass(progressElement, "snippet-editor__progress--fallback");
		});
	}

	this.initPreviewToggler();
	this.setInitialView();

	this.opened = false;
	this.createMeasurementElements();
	this.updateProgressBars();
};

/**
 * Initializes the Snippet Preview Toggler.
 *
 * @returns {void}
 */
SnippetPreview.prototype.initPreviewToggler = function () {
	this.snippetPreviewToggle = new _snippetPreviewToggler2.default(this.opts.previewMode, this.opts.targetElement.getElementsByClassName("snippet-editor__view-icon"));
	this.snippetPreviewToggle.initialize();
	this.snippetPreviewToggle.bindEvents();
};

/**
 * Refreshes the snippet editor rendered HTML
 * @returns {void}
 */
SnippetPreview.prototype.refresh = function () {
	this.output = this.htmlOutput();
	this.renderOutput();
	this.renderSnippetStyle();
	this.measureTitle();
	this.measureMetaDescription();
	this.updateProgressBars();
};

/**
 * Returns the title as meant for the analyzer
 *
 * @private
 * @this SnippetPreview
 *
 * @returns {string} The title that is meant for the analyzer.
 */
function getAnalyzerTitle() {
	var title = this.data.title;

	if ((0, _lodashEs$a.isEmpty)(title)) {
		title = this.opts.defaultValue.title;
	}

	if (this.hasPluggable()) {
		title = this.refObj.pluggable._applyModifications("data_page_title", title);
	}

	return (0, _stripSpaces2.default)(title);
}

/**
 * Returns the metaDescription, includes the date if it is set.
 *
 * @private
 * @this SnippetPreview
 *
 * @returns {string} The meta data for the analyzer.
 */
var getAnalyzerMetaDesc = function getAnalyzerMetaDesc() {
	var metaDesc = this.data.metaDesc;

	if ((0, _lodashEs$a.isEmpty)(metaDesc)) {
		metaDesc = this.opts.defaultValue.metaDesc;
	}

	if (this.hasPluggable()) {
		metaDesc = this.refObj.pluggable._applyModifications("data_meta_desc", metaDesc);
	}

	if (!(0, _lodashEs$a.isEmpty)(this.opts.metaDescriptionDate) && !(0, _lodashEs$a.isEmpty)(metaDesc)) {
		metaDesc = this.opts.metaDescriptionDate + " - " + this.data.metaDesc;
	}

	return (0, _stripSpaces2.default)(metaDesc);
};

/**
 * Returns the data from the Snippet Preview.
 *
 * @returns {Object} The collected data for the analyzer.
 */
SnippetPreview.prototype.getAnalyzerData = function () {
	return {
		title: getAnalyzerTitle.call(this),
		url: this.data.urlPath,
		metaDesc: getAnalyzerMetaDesc.call(this)
	};
};

/**
 * Calls the event binder that has been registered using the callbacks option in the arguments of the App.
 *
 * @returns {void}
 */
SnippetPreview.prototype.callRegisteredEventBinder = function () {
	if (this.hasApp()) {
		this.refObj.callbacks.bindElementEvents(this.refObj);
	}
};

/**
 *  Checks if title and url are set so they can be rendered in the Snippet Preview.
 *
 *  @returns {void}
 */
SnippetPreview.prototype.init = function () {
	if (this.hasApp() && this.refObj.rawData.metaTitle !== null && this.refObj.rawData.cite !== null) {
		this.refresh();
	}
};

/**
 * Creates html object to contain the strings for the Snippet Preview.
 *
 * @returns {Object} The HTML output of the collected data.
 */
SnippetPreview.prototype.htmlOutput = function () {
	var html = {};
	html.title = this.formatTitle();
	html.cite = this.formatCite();
	html.meta = this.formatMeta();
	html.url = this.formatUrl();
	return html;
};

/**
 * Formats the title for the Snippet Preview. If title and pageTitle are empty, sampletext is used.
 *
 * @returns {string} The correctly formatted title.
 */
SnippetPreview.prototype.formatTitle = function () {
	var title = this.data.title;

	// Fallback to the default if the title is empty.
	if ((0, _lodashEs$a.isEmpty)(title)) {
		title = this.opts.defaultValue.title;
	}

	// For rendering we can fallback to the placeholder as well.
	if ((0, _lodashEs$a.isEmpty)(title)) {
		title = this.opts.placeholder.title;
	}

	// Apply modification to the title before showing it.
	if (this.hasPluggable() && this.refObj.pluggable.loaded) {
		title = this.refObj.pluggable._applyModifications("data_page_title", title);
	}

	title = (0, _stripHTMLTags.stripFullTags)(title);

	// As an ultimate fallback provide the user with a helpful message.
	if ((0, _lodashEs$a.isEmpty)(title)) {
		title = this.i18n.dgettext("js-text-analysis", "Please provide an SEO title by editing the snippet below.");
	}

	return title;
};

/**
 * Formats the base url for the Snippet Preview. Removes the protocol name from the URL.
 *
 * @returns {string} Formatted base url for the Snippet Preview.
 */
SnippetPreview.prototype.formatUrl = function () {
	var url = getBaseURL.call(this);

	// Removes the http part of the url, google displays https:// if the website supports it.
	return url.replace(/http:\/\//ig, "");
};

/**
 * Formats the url for the Snippet Preview.
 *
 * @returns {string} Formatted URL for the Snippet Preview.
 */
SnippetPreview.prototype.formatCite = function () {
	var cite = this.data.urlPath;

	cite = (0, _replaceDiacritics2.default)((0, _stripHTMLTags.stripFullTags)(cite));

	// Fallback to the default if the cite is empty.
	if ((0, _lodashEs$a.isEmpty)(cite)) {
		cite = this.opts.placeholder.urlPath;
	}

	if (this.hasApp() && !(0, _lodashEs$a.isEmpty)(this.refObj.rawData.keyword)) {
		cite = this.formatKeywordUrl(cite);
	}

	if (this.opts.addTrailingSlash && !hasTrailingSlash(cite)) {
		cite = cite + "/";
	}

	// URL's cannot contain whitespace so replace it by dashes.
	cite = cite.replace(/\s/g, "-");
	// Strip out question mark and hash characters from the raw URL.
	cite = cite.replace(/\?|#/g, "");

	return cite;
};

/**
 * Formats the meta description for the Snippet Preview, if it's empty retrieves it using getMetaText.
 *
 * @returns {string} Formatted meta description.
 */
SnippetPreview.prototype.formatMeta = function () {
	var meta = this.data.metaDesc;

	// If no meta has been set, generate one.
	if ((0, _lodashEs$a.isEmpty)(meta)) {
		meta = this.getMetaText();
	}

	// Apply modification to the desc before showing it.
	if (this.hasPluggable() && this.refObj.pluggable.loaded) {
		meta = this.refObj.pluggable._applyModifications("data_meta_desc", meta);
	}

	meta = (0, _stripHTMLTags.stripFullTags)(meta);

	// Cut-off the meta description according to the maximum length
	meta = meta.substring(0, maximumMetaDescriptionLength);

	if (this.hasApp() && !(0, _lodashEs$a.isEmpty)(this.refObj.rawData.keyword)) {
		meta = this.formatKeyword(meta);
	}

	// As an ultimate fallback provide the user with a helpful message.
	if ((0, _lodashEs$a.isEmpty)(meta)) {
		meta = this.i18n.dgettext("js-text-analysis", "Please provide a meta description by editing the snippet below.");
	}

	return meta;
};

/**
 * Generates a meta description with an educated guess based on the passed text and excerpt.
 * It uses the keyword to select an appropriate part of the text. If the keyword isn't present it takes the maximum
 * meta description length of the text. If both the keyword, text and excerpt are empty this function returns the
 * sample text.
 *
 * @returns {string} A generated meta description.
 */
SnippetPreview.prototype.getMetaText = function () {
	var metaText = this.opts.defaultValue.metaDesc;

	if (this.hasApp() && !(0, _lodashEs$a.isUndefined)(this.refObj.rawData.excerpt) && (0, _lodashEs$a.isEmpty)(metaText)) {
		metaText = this.refObj.rawData.excerpt;
	}

	if (this.hasApp() && !(0, _lodashEs$a.isUndefined)(this.refObj.rawData.text) && (0, _lodashEs$a.isEmpty)(metaText)) {
		metaText = this.refObj.rawData.text;

		if (this.hasPluggable() && this.refObj.pluggable.loaded) {
			metaText = this.refObj.pluggable._applyModifications("content", metaText);
		}
	}

	metaText = (0, _stripHTMLTags.stripFullTags)(metaText);

	return metaText.substring(0, maximumMetaDescriptionLength);
};

/**
 * Builds an array with all indexes of the keyword.
 *
 * @returns {Array} Array with matches
 */
SnippetPreview.prototype.getIndexMatches = function () {
	var indexMatches = [];
	var i = 0;

	// Starts at 0, locates first match of the keyword.
	var match = this.refObj.rawData.text.indexOf(this.refObj.rawData.keyword, i);

	// Runs the loop untill no more indexes are found, and match returns -1.
	while (match > -1) {
		indexMatches.push(match);

		// Pushes location to indexMatches and increase i with the length of keyword.
		i = match + this.refObj.rawData.keyword.length;
		match = this.refObj.rawData.text.indexOf(this.refObj.rawData.keyword, i);
	}
	return indexMatches;
};

/**
 * Builds an array with indexes of all sentence ends (select on .).
 *
 * @returns {Array} Array with sentences.
 */
SnippetPreview.prototype.getPeriodMatches = function () {
	var periodMatches = [0];
	var match;
	var i = 0;
	while ((match = this.refObj.rawData.text.indexOf(".", i)) > -1) {
		periodMatches.push(match);
		i = match + 1;
	}
	return periodMatches;
};

/**
 * Formats the keyword for use in the snippetPreview by adding <strong>-tags
 * strips unwanted characters that could break the regex or give unwanted results.
 *
 * @param {string} textString The keyword string that needs to be formatted.
 *
 * @returns {string} The formatted keyword.
 */
SnippetPreview.prototype.formatKeyword = function (textString) {
	// Removes characters from the keyword that could break the regex, or give unwanted results.
	var keyword = this.refObj.rawData.keyword;

	// Match keyword case-insensitively.
	var keywordRegex = (0, _createWordRegex2.default)(keyword, "", false);

	textString = textString.replace(keywordRegex, function (str) {
		return "<strong>" + str + "</strong>";
	});

	// Transliterate the keyword for highlighting
	var transliterateKeyword = (0, _transliterate2.default)(keyword, this.refObj.rawData.locale);
	if (transliterateKeyword !== keyword) {
		keywordRegex = (0, _createWordRegex2.default)(transliterateKeyword, "", false);
		textString = textString.replace(keywordRegex, function (str) {
			return "<strong>" + str + "</strong>";
		});
	}
	return textString;
};

/**
 * Formats the keyword for use in the URL by accepting - and _ instead of spaces and by adding <strong>-tags.
 * Strips unwanted characters that could break the regex or give unwanted results.
 *
 * @param {string} textString The keyword string that needs to be formatted.
 *
 * @returns {XML|string|void} The formatted keyword string to be used in the URL.
 */
SnippetPreview.prototype.formatKeywordUrl = function (textString) {
	var keyword = this.refObj.rawData.keyword;
	keyword = (0, _transliterate2.default)(keyword, this.refObj.rawData.locale);
	keyword = keyword.replace(/'/, "");

	var dashedKeyword = keyword.replace(/\s/g, "-");

	// Match keyword case-insensitively.
	var keywordRegex = (0, _createWordRegex2.default)(dashedKeyword, "\\-");

	// Make the keyword bold in the textString.
	return textString.replace(keywordRegex, function (str) {
		return "<strong>" + str + "</strong>";
	});
};

/**
 * Renders the outputs to the elements on the page.
 *
 * @returns {void}
 */
SnippetPreview.prototype.renderOutput = function () {
	this.element.rendered.title.innerHTML = this.output.title;
	this.element.rendered.urlPath.innerHTML = this.output.cite;
	this.element.rendered.urlBase.innerHTML = this.output.url;
	this.element.rendered.metaDesc.innerHTML = this.output.meta;
};

/**
 * Makes the rendered meta description gray if no meta description has been set by the user.
 *
 * @returns {void}
 */
SnippetPreview.prototype.renderSnippetStyle = function () {
	var metaDescElement = this.element.rendered.metaDesc;
	var metaDesc = getAnalyzerMetaDesc.call(this);

	if ((0, _lodashEs$a.isEmpty)(metaDesc)) {
		_domManipulation2.default.addClass(metaDescElement, "desc-render");
		_domManipulation2.default.removeClass(metaDescElement, "desc-default");
	} else {
		_domManipulation2.default.addClass(metaDescElement, "desc-default");
		_domManipulation2.default.removeClass(metaDescElement, "desc-render");
	}
};

/**
 * Function to call init, to rerender the Snippet Preview.
 *
 * @returns {void}
 */
SnippetPreview.prototype.reRender = function () {
	this.init();
};

/**
 * Checks text length of the snippetmeta and snippet title, shortens it if it is too long.
 * @param {Object} event The event to check the text length from.
 *
 * @returns {void}
 */
SnippetPreview.prototype.checkTextLength = function (event) {
	var text = event.currentTarget.textContent;
	switch (event.currentTarget.id) {
		case "snippet_meta":
			event.currentTarget.className = "desc";
			if (text.length > maximumMetaDescriptionLength) {
				/* eslint-disable */
				YoastSEO.app.snippetPreview.unformattedText.snippet_meta = event.currentTarget.textContent;
				/* eslint-enable */
				event.currentTarget.textContent = text.substring(0, maximumMetaDescriptionLength);
			}
			break;
		case "snippet_title":
			event.currentTarget.className = "title";
			if (text.length > titleMaxLength) {
				/* eslint-disable */
				YoastSEO.app.snippetPreview.unformattedText.snippet_title = event.currentTarget.textContent;
				/* eslint-enable */
				event.currentTarget.textContent = text.substring(0, titleMaxLength);
			}
			break;
	}
};

/**
 * Get the unformatted text.
 *
 * When clicking on an element in the Snippet Preview, this checks and fills the textContent with the data from the
 * unformatted text. This removes the keyword highlighting and modified data so the original content can be editted.
 *
 * @param {Object} event The event to get the unformatted text from.
 *
 * @returns {void}
 */
SnippetPreview.prototype.getUnformattedText = function (event) {
	var currentElement = event.currentTarget.id;
	if (typeof this.unformattedText[currentElement] !== "undefined") {
		event.currentTarget.textContent = this.unformattedText[currentElement];
	}
};

/**
 * Sets the unformatted text.
 *
 * When text is entered into the snippetPreview elements, the text is set in the unformattedText object.
 * This allows the visible data to be editted in the snippetPreview.
 *
 * @param {Object} event The event to set the unformatted text from.
 *
 * @returns {void}
 */
SnippetPreview.prototype.setUnformattedText = function (event) {
	var elem = event.currentTarget.id;
	this.unformattedText[elem] = document.getElementById(elem).textContent;
};

/**
 * Validates all fields and highlights errors.
 *
 * @returns {void}
 */
SnippetPreview.prototype.validateFields = function () {
	var metaDescription = getAnalyzerMetaDesc.call(this);
	var title = getAnalyzerTitle.call(this);

	if (metaDescription.length > maximumMetaDescriptionLength) {
		_domManipulation2.default.addClass(this.element.input.metaDesc, "snippet-editor__field--invalid");
	} else {
		_domManipulation2.default.removeClass(this.element.input.metaDesc, "snippet-editor__field--invalid");
	}

	if (title.length > titleMaxLength) {
		_domManipulation2.default.addClass(this.element.input.title, "snippet-editor__field--invalid");
	} else {
		_domManipulation2.default.removeClass(this.element.input.title, "snippet-editor__field--invalid");
	}
};

/**
 * Updates progress bars based on the available data.
 *
 * @returns {void}
 */
SnippetPreview.prototype.updateProgressBars = function () {
	var metaDescriptionRating, titleRating, metaDescription;

	metaDescription = getAnalyzerMetaDesc.call(this);

	titleRating = rateTitleLength$1(this.data.titleWidth);
	metaDescriptionRating = rateMetaDescLength$1(metaDescription.length);

	updateProgressBar.call(this, this.element.progress.title, this.data.titleWidth, titleMaxLength, titleRating);

	updateProgressBar.call(this, this.element.progress.metaDesc, metaDescription.length, maximumMetaDescriptionLength, metaDescriptionRating);
};

/**
 * Gets the width of the Snippet Preview to set its initial view to desktop or mobile.
 *
 * @returns {void}
 */
SnippetPreview.prototype.setInitialView = function () {
	var previewWidth = document.getElementById("snippet_preview").getBoundingClientRect().width;
	this.snippetPreviewToggle.setVisibility(previewWidth);
};

/**
 * When the window is resized, gets the width of the Snippet Preview to set the Scroll Hint visibility.
 *
 * @returns {void}
 */
SnippetPreview.prototype.handleWindowResizing = (0, _lodashEs$a.debounce)(function () {
	var previewWidth = document.getElementById("snippet_preview").getBoundingClientRect().width;
	this.snippetPreviewToggle.setScrollHintVisibility(previewWidth);
}, 25);

/**
 * Binds the reloadSnippetText function to the blur of the snippet inputs.
 *
 * @returns {void}
 */
SnippetPreview.prototype.bindEvents = function () {
	var targetElement,
	    elems = ["title", "slug", "meta-description"];

	(0, _lodashEs$a.forEach)(elems, function (elem) {
		targetElement = document.getElementsByClassName("js-snippet-editor-" + elem)[0];

		targetElement.addEventListener("keydown", this.changedInput.bind(this));
		targetElement.addEventListener("keyup", this.changedInput.bind(this));

		targetElement.addEventListener("input", this.changedInput.bind(this));
		targetElement.addEventListener("focus", this.changedInput.bind(this));
		targetElement.addEventListener("blur", this.changedInput.bind(this));
	}.bind(this));

	this.element.editToggle.addEventListener("click", this.toggleEditor.bind(this));
	this.element.closeEditor.addEventListener("click", this.closeEditor.bind(this));

	// Note: `handleWindowResizing` is called also in Yoast SEO when the WP admin menu state changes.
	window.addEventListener("resize", this.handleWindowResizing.bind(this));

	// Loop through the bindings and bind a click handler to the click to focus the focus element.
	(0, _lodashEs$a.forEach)(inputPreviewBindings, function (binding) {
		var previewElement = document.getElementById(binding.preview);
		var inputElement = this.element.input[binding.inputField];

		// Make the preview element click open the editor and focus the correct input.
		previewElement.addEventListener("click", function () {
			this.openEditor();
			inputElement.focus();
		}.bind(this));

		// Make focusing an input, update the carets.
		inputElement.addEventListener("focus", function () {
			this._currentFocus = binding.inputField;

			this._updateFocusCarets();
		}.bind(this));

		// Make removing focus from an element, update the carets.
		inputElement.addEventListener("blur", function () {
			this._currentFocus = null;

			this._updateFocusCarets();
		}.bind(this));

		previewElement.addEventListener("mouseover", function () {
			this._currentHover = binding.inputField;

			this._updateHoverCarets();
		}.bind(this));

		previewElement.addEventListener("mouseout", function () {
			this._currentHover = null;

			this._updateHoverCarets();
		}.bind(this));
	}.bind(this));
};

/**
 * Updates Snippet Preview on changed input. It's debounced so that we can call this function as much as we want.
 *
 * @returns {void}
 */
SnippetPreview.prototype.changedInput = (0, _lodashEs$a.debounce)(function () {
	this.updateDataFromDOM();
	this.validateFields();
	this.updateProgressBars();

	this.refresh();

	if (this.hasApp()) {
		this.refObj.refresh();
	}
}, 25);

/**
 * Updates our data object from the DOM.
 *
 * @returns {void}
 */
SnippetPreview.prototype.updateDataFromDOM = function () {
	this.data.title = this.element.input.title.value;
	this.data.urlPath = this.element.input.urlPath.value;
	this.data.metaDesc = this.element.input.metaDesc.value;

	// Clone so the data isn't changeable.
	this.opts.callbacks.saveSnippetData((0, _lodashEs$a.clone)(this.data));
};

/**
 * Opens the snippet editor.
 *
 * @returns {void}
 */
SnippetPreview.prototype.openEditor = function () {
	this.element.editToggle.setAttribute("aria-expanded", "true");

	// Show these elements.
	_domManipulation2.default.removeClass(this.element.formContainer, "snippet-editor--hidden");

	this.opened = true;
};

/**
 * Closes the snippet editor.
 *
 * @returns {void}
 */
SnippetPreview.prototype.closeEditor = function () {
	// Hide these elements.
	_domManipulation2.default.addClass(this.element.formContainer, "snippet-editor--hidden");

	this.element.editToggle.setAttribute("aria-expanded", "false");
	this.element.editToggle.focus();

	this.opened = false;
};

/**
 * Toggles the snippet editor.
 *
 * @returns {void}
 */
SnippetPreview.prototype.toggleEditor = function () {
	if (this.opened) {
		this.closeEditor();
	} else {
		this.openEditor();
	}
};

/**
 * Updates carets before the preview and input fields.
 *
 * @private
 *
 * @returns {void}
 */
SnippetPreview.prototype._updateFocusCarets = function () {
	var focusedLabel, focusedPreview;

	// Disable all carets on the labels.
	(0, _lodashEs$a.forEach)(this.element.label, function (element) {
		_domManipulation2.default.removeClass(element, "snippet-editor__label--focus");
	});

	// Disable all carets on the previews.
	(0, _lodashEs$a.forEach)(this.element.preview, function (element) {
		_domManipulation2.default.removeClass(element, "snippet-editor__container--focus");
	});

	if (null !== this._currentFocus) {
		focusedLabel = this.element.label[this._currentFocus];
		focusedPreview = this.element.preview[this._currentFocus];

		_domManipulation2.default.addClass(focusedLabel, "snippet-editor__label--focus");
		_domManipulation2.default.addClass(focusedPreview, "snippet-editor__container--focus");
	}
};

/**
 * Updates hover carets before the input fields.
 *
 * @private
 *
 * @returns {void}
 */
SnippetPreview.prototype._updateHoverCarets = function () {
	var hoveredLabel;

	(0, _lodashEs$a.forEach)(this.element.label, function (element) {
		_domManipulation2.default.removeClass(element, "snippet-editor__label--hover");
	});

	if (null !== this._currentHover) {
		hoveredLabel = this.element.label[this._currentHover];

		_domManipulation2.default.addClass(hoveredLabel, "snippet-editor__label--hover");
	}
};

/**
 * Updates the title data and the title input field. This also means the snippet editor view is updated.
 *
 * @param {string} title The title to use in the input field.
 *
 * @returns {void}
 */
SnippetPreview.prototype.setTitle = function (title) {
	this.element.input.title.value = title;

	this.changedInput();
};

/**
 * Updates the url path data and the url path input field. This also means the snippet editor view is updated.
 *
 * @param {string} urlPath the URL path to use in the input field.
 *
 * @returns {void}
 */
SnippetPreview.prototype.setUrlPath = function (urlPath) {
	this.element.input.urlPath.value = urlPath;

	this.changedInput();
};

/**
 * Updates the meta description data and the meta description input field. This also means the snippet editor view is updated.
 *
 * @param {string} metaDesc the meta description to use in the input field.
 *
 * @returns {void}
 */
SnippetPreview.prototype.setMetaDescription = function (metaDesc) {
	this.element.input.metaDesc.value = metaDesc;

	this.changedInput();
};

/**
 * Creates elements with the purpose to calculate the sizes of elements and puts these elements to the body.
 *
 * @returns {void}
 */
SnippetPreview.prototype.createMeasurementElements = function () {
	var metaDescriptionElement, spanHolder;
	metaDescriptionElement = hiddenElement({
		width: document.getElementById("meta_container").offsetWidth + "px",
		whiteSpace: ""
	});

	spanHolder = document.createElement("div");
	spanHolder.className = "yoast-measurement-elements-holder";

	spanHolder.innerHTML = metaDescriptionElement;

	document.body.appendChild(spanHolder);

	this.element.measurers.metaHeight = spanHolder.childNodes[0];
};

/**
 * Copies the title text to the title measure element to calculate the width in pixels.
 *
 * @returns {void}
 */
SnippetPreview.prototype.measureTitle = function () {
	if (this.element.rendered.title.offsetWidth !== 0 || this.element.rendered.title.textContent === "") {
		this.data.titleWidth = this.element.rendered.title.offsetWidth;
	}
};

/**
 * Copies the metadescription text to the metadescription measure element to calculate the height in pixels.
 *
 * @returns {void}
 */
SnippetPreview.prototype.measureMetaDescription = function () {
	var metaHeightElement = this.element.measurers.metaHeight;

	metaHeightElement.innerHTML = this.element.rendered.metaDesc.innerHTML;

	this.data.metaHeight = metaHeightElement.offsetHeight;
};

/**
 * Returns the width of the title in pixels.
 *
 * @returns {Number} The width of the title in pixels.
 */
SnippetPreview.prototype.getTitleWidth = function () {
	return this.data.titleWidth;
};

/**
 * Allows to manually set the title width.
 *
 * This may be useful in setups where the title field will not always be rendered.
 *
 * @param {Number} titleWidth The width of the title in pixels.
 *
 * @returns {void}
 */
SnippetPreview.prototype.setTitleWidth = function (titleWidth) {
	this.data.titleWidth = titleWidth;
};

/**
 * Returns whether or not an app object is present.
 *
 * @returns {boolean} Whether or not there is an App object present.
 */
SnippetPreview.prototype.hasApp = function () {
	return !(0, _lodashEs$a.isUndefined)(this.refObj);
};

/**
 * Returns whether or not a pluggable object is present.
 *
 * @returns {boolean} Whether or not there is a Pluggable object present.
 */
SnippetPreview.prototype.hasPluggable = function () {
	return !(0, _lodashEs$a.isUndefined)(this.refObj) && !(0, _lodashEs$a.isUndefined)(this.refObj.pluggable);
};

/* eslint-disable */

/**
 * Disables Enter as input.
 *
 * Used to disable enter as input. Returns false to prevent enter, and preventDefault and
 * cancelBubble to prevent other elements from capturing this event.
 *
 * @deprecated
 *
 * @param {KeyboardEvent} ev The keyboard event.
 */
SnippetPreview.prototype.disableEnter = function (ev) {};

/**
 * Adds and removes the tooLong class when a text is too long.
 *
 * @deprecated
 * @param ev The event.
 */
SnippetPreview.prototype.textFeedback = function (ev) {};

/**
 * Shows the edit icon corresponding to the hovered element.
 *
 * @deprecated
 *
 * @param ev The event.
 */
SnippetPreview.prototype.showEditIcon = function (ev) {};

/**
 * Removes all editIcon-classes, sets to snippet_container.
 *
 * @deprecated
 */
SnippetPreview.prototype.hideEditIcon = function () {};

/**
 * Sets focus on child element of the snippet_container that is clicked. Hides the editicon.
 *
 * @deprecated
 *
 * @param ev The event.
 */
SnippetPreview.prototype.setFocus = function (ev) {};

/* eslint-disable */
snippetPreview.default = SnippetPreview;

var Paper$1 = {};

Object.defineProperty(Paper$1, "__esModule", {
  value: true
});

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodashEs$9 = require$$1$1;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Default attributes to be used by the Paper if they are left undefined.
 * @type {{keyword: string, synonyms: string, description: string, title: string, url: string}}
 */
var defaultAttributes = {
  keyword: "",
  synonyms: "",
  description: "",
  title: "",
  titleWidth: 0,
  url: "",
  locale: "en_US",
  permalink: ""
};

/**
 * Construct the Paper object and set the keyword property.
 *
 * @param {string} text                     The text to use in the analysis.
 * @param {object} [attributes]             The object containing all attributes.
 * @param {string} [attributes.keyword]     The main keyword.
 * @param {string} [attributes.synonyms]    The main keyword's synonyms.
 * @param {string} [attributes.title]       The SEO title.
 * @param {string} [attributes.description] The SEO description.
 * @param {number} [attributes.titleWidth]  The width of the title in pixels.
 * @param {string} [attributes.url]         The slug.
 * @param {string} [attributes.permalink]   The base url + slug.
 * @param {string} [attributes.locale]      The locale.
 * @param {Object} [attributes.wpBlocks]    The text, encoded in WordPress block editor blocks.
 *
 * @constructor
 */
var Paper = function Paper(text, attributes) {
  this._text = text || "";

  attributes = attributes || {};
  (0, _lodashEs$9.defaults)(attributes, defaultAttributes);

  if (attributes.locale === "") {
    attributes.locale = defaultAttributes.locale;
  }

  const onlyLetters = attributes.keyword.replace(/[‘’“”"'.?!:;,¿¡«»&*@#±^%|~`[\](){}⟨⟩<>/\\–\-\u2014\u00d7\u002b\u0026\s]/g, "");

  if ((0, _lodashEs$9.isEmpty)(onlyLetters)) {
    attributes.keyword = defaultAttributes.keyword;
  }

  this._attributes = attributes;
};

/**
 * Check whether a keyword is available.
 * @returns {boolean} Returns true if the Paper has a keyword.
 */
Paper.prototype.hasKeyword = function () {
  return this._attributes.keyword !== "";
};

/**
 * Return the associated keyword or an empty string if no keyword is available.
 * @returns {string} Returns Keyword
 */
Paper.prototype.getKeyword = function () {
  return this._attributes.keyword;
};

/**
 * Check whether synonyms is available.
 * @returns {boolean} Returns true if the Paper has synonyms.
 */
Paper.prototype.hasSynonyms = function () {
  return this._attributes.synonyms !== "";
};

/**
 * Return the associated synonyms or an empty string if no synonyms is available.
 * @returns {string} Returns synonyms.
 */
Paper.prototype.getSynonyms = function () {
  return this._attributes.synonyms;
};

/**
 * Check whether the text is available.
 * @returns {boolean} Returns true if the paper has a text.
 */
Paper.prototype.hasText = function () {
  return this._text !== "";
};

/**
 * Return the associated text or am empty string if no text is available.
 * @returns {string} Returns text
 */
Paper.prototype.getText = function () {
  return this._text;
};

/**
 * Check whether a description is available.
 * @returns {boolean} Returns true if the paper has a description.
 */
Paper.prototype.hasDescription = function () {
  return this._attributes.description !== "";
};

/**
 * Return the description or an empty string if no description is available.
 * @returns {string} Returns the description.
 */
Paper.prototype.getDescription = function () {
  return this._attributes.description;
};

/**
 * Check whether an title is available
 * @returns {boolean} Returns true if the Paper has a title.
 */
Paper.prototype.hasTitle = function () {
  return this._attributes.title !== "";
};

/**
 * Return the title, or an empty string of no title is available.
 * @returns {string} Returns the title
 */
Paper.prototype.getTitle = function () {
  return this._attributes.title;
};

/**
 * Check whether an title width in pixels is available
 * @returns {boolean} Returns true if the Paper has a title.
 */
Paper.prototype.hasTitleWidth = function () {
  return this._attributes.titleWidth !== 0;
};

/**
 * Return the title width in pixels, or an empty string of no title width in pixels is available.
 * @returns {string} Returns the title
 */
Paper.prototype.getTitleWidth = function () {
  return this._attributes.titleWidth;
};

/**
 * Check whether an url is available
 * @returns {boolean} Returns true if the Paper has an Url.
 */
Paper.prototype.hasUrl = function () {
  return this._attributes.url !== "";
};

/**
 * Return the url, or an empty string of no url is available.
 * @returns {string} Returns the url
 */
Paper.prototype.getUrl = function () {
  return this._attributes.url;
};

/**
 * Check whether a locale is available
 * @returns {boolean} Returns true if the paper has a locale
 */
Paper.prototype.hasLocale = function () {
  return this._attributes.locale !== "";
};

/**
 * Return the locale or an empty string if no locale is available
 * @returns {string} Returns the locale
 */
Paper.prototype.getLocale = function () {
  return this._attributes.locale;
};

/**
 * Check whether a permalink is available
 * @returns {boolean} Returns true if the Paper has a permalink.
 */
Paper.prototype.hasPermalink = function () {
  return this._attributes.permalink !== "";
};

/**
 * Return the permalink, or an empty string of no permalink is available.
 * @returns {string} Returns the permalink.
 */
Paper.prototype.getPermalink = function () {
  return this._attributes.permalink;
};

/*
 * Serializes the Paper instance to an object.
 *
 * @returns {Object} The serialized Paper.
 */
Paper.prototype.serialize = function () {
  return _extends$1({
    _parseClass: "Paper",
    text: this._text
  }, this._attributes);
};

/**
 * Checks whether the given paper has the same properties as this instance.
 *
 * @param {Paper} paper The paper to compare to.
 *
 * @returns {boolean} Whether the given paper is identical or not.
 */
Paper.prototype.equals = function (paper) {
  return this._text === paper.getText() && (0, _lodashEs$9.isEqual)(this._attributes, paper._attributes);
};

/**
 * Parses the object to a Paper.
 *
 * @param {Object} serialized The serialized object.
 *
 * @returns {Paper} The parsed Paper.
 */
Paper.parse = function (serialized) {
  // _parseClass is taken here so it doesn't end up in the attributes.
  // eslint-disable-next-line no-unused-vars
  const text = serialized.text;
        serialized._parseClass;
        const attributes = _objectWithoutProperties(serialized, ["text", "_parseClass"]);

  return new Paper(text, attributes);
};

var _default = Paper$1.default = Paper;

var relatedKeywordAssessor$3 = {};

Object.defineProperty(relatedKeywordAssessor$3, "__esModule", {
	value: true
});

var _util$3 = require$$2$1;

var _assessor$5 = assessor;

var _assessor2$5 = _interopRequireDefault$i(_assessor$5);

var _IntroductionKeywordAssessment$3 = IntroductionKeywordAssessment$1;

var _IntroductionKeywordAssessment2$3 = _interopRequireDefault$i(_IntroductionKeywordAssessment$3);

var _KeyphraseLengthAssessment$3 = KeyphraseLengthAssessment$1;

var _KeyphraseLengthAssessment2$3 = _interopRequireDefault$i(_KeyphraseLengthAssessment$3);

var _KeywordDensityAssessment$3 = KeywordDensityAssessment$1;

var _KeywordDensityAssessment2$3 = _interopRequireDefault$i(_KeywordDensityAssessment$3);

var _MetaDescriptionKeywordAssessment$3 = MetaDescriptionKeywordAssessment$1;

var _MetaDescriptionKeywordAssessment2$3 = _interopRequireDefault$i(_MetaDescriptionKeywordAssessment$3);

var _TextImagesAssessment$2 = TextImagesAssessment$1;

var _TextImagesAssessment2$2 = _interopRequireDefault$i(_TextImagesAssessment$2);

var _TextCompetingLinksAssessment$2 = TextCompetingLinksAssessment$1;

var _TextCompetingLinksAssessment2$2 = _interopRequireDefault$i(_TextCompetingLinksAssessment$2);

var _FunctionWordsInKeyphraseAssessment$3 = FunctionWordsInKeyphraseAssessment$1;

var _FunctionWordsInKeyphraseAssessment2$3 = _interopRequireDefault$i(_FunctionWordsInKeyphraseAssessment$3);

function _interopRequireDefault$i(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates the Assessor
 *
 * @param {object} i18n The i18n object used for translations.
 * @param {Object} options The options for this assessor.
 * @param {Object} options.marker The marker to pass the list of marks to.
 *
 * @constructor
 */
const relatedKeywordAssessor$2 = function relatedKeywordAssessor(i18n, options) {
	_assessor2$5.default.call(this, i18n, options);

	this._assessments = [new _IntroductionKeywordAssessment2$3.default(), new _KeyphraseLengthAssessment2$3.default({ isRelatedKeyphrase: true }), new _KeywordDensityAssessment2$3.default(), new _MetaDescriptionKeywordAssessment2$3.default(), new _TextCompetingLinksAssessment2$2.default(), new _TextImagesAssessment2$2.default(), new _FunctionWordsInKeyphraseAssessment2$3.default()];
};

(0, _util$3.inherits)(relatedKeywordAssessor$2, _assessor2$5.default);

relatedKeywordAssessor$3.default = relatedKeywordAssessor$2;

var contentAssessor = {};

Object.defineProperty(contentAssessor, "__esModule", {
	value: true
});

var _assessor$4 = assessor;

var _assessor2$4 = _interopRequireDefault$h(_assessor$4);

var _contentAssessor$2 = contentAssessor$1;

var _contentAssessor2$2 = _interopRequireDefault$h(_contentAssessor$2);

var _fleschReadingEaseAssessment = fleschReadingEaseAssessment;

var _fleschReadingEaseAssessment2 = _interopRequireDefault$h(_fleschReadingEaseAssessment);

var _paragraphTooLongAssessment = paragraphTooLongAssessment;

var _paragraphTooLongAssessment2 = _interopRequireDefault$h(_paragraphTooLongAssessment);

var _sentenceLengthInTextAssessment = sentenceLengthInTextAssessment;

var _sentenceLengthInTextAssessment2 = _interopRequireDefault$h(_sentenceLengthInTextAssessment);

var _subheadingDistributionTooLongAssessment = subheadingDistributionTooLongAssessment;

var _subheadingDistributionTooLongAssessment2 = _interopRequireDefault$h(_subheadingDistributionTooLongAssessment);

var _transitionWordsAssessment = transitionWordsAssessment$1;

var _transitionWordsAssessment2 = _interopRequireDefault$h(_transitionWordsAssessment);

var _passiveVoiceAssessment = passiveVoiceAssessment$1;

var _passiveVoiceAssessment2 = _interopRequireDefault$h(_passiveVoiceAssessment);

var _sentenceBeginningsAssessment = sentenceBeginningsAssessment$1;

var _sentenceBeginningsAssessment2 = _interopRequireDefault$h(_sentenceBeginningsAssessment);

var _textPresenceAssessment = textPresenceAssessment$1;

var _textPresenceAssessment2 = _interopRequireDefault$h(_textPresenceAssessment);

var _combinedConfig = combinedConfig;

var _combinedConfig2 = _interopRequireDefault$h(_combinedConfig);

function _interopRequireDefault$h(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 Temporarily disabled:

 var wordComplexity = require( "./assessments/readability/wordComplexityAssessment.js" );
 var sentenceLengthInDescription = require( "./assessments/readability/sentenceLengthInDescriptionAssessment.js" );
 */

/**
 * Creates the Assessor
 *
 * @param {object} i18n The i18n object used for translations.
 * @param {Object} options The options for this assessor.
 * @param {Object} options.marker The marker to pass the list of marks to.
 * @param {string} options.locale The locale.
 *
 * @constructor
 */
const CornerStoneContentAssessor = function CornerStoneContentAssessor(i18n, options = {}) {
	_assessor2$4.default.call(this, i18n, options);
	this.type = "CornerstoneContentAssessor";
	const locale = options.hasOwnProperty("locale") ? options.locale : "en_US";

	this._assessments = [new _fleschReadingEaseAssessment2.default((0, _combinedConfig2.default)(locale).fleschReading), new _subheadingDistributionTooLongAssessment2.default({
		parameters: {
			slightlyTooMany: 250,
			farTooMany: 300,
			recommendedMaximumWordCount: 250
		}
	}), _paragraphTooLongAssessment2.default, new _sentenceLengthInTextAssessment2.default({
		recommendedWordCount: (0, _combinedConfig2.default)(locale).sentenceLength.recommendedWordCount,
		slightlyTooMany: 20,
		farTooMany: 25
	}), _transitionWordsAssessment2.default, _passiveVoiceAssessment2.default, _textPresenceAssessment2.default, _sentenceBeginningsAssessment2.default];
};

require$$2$1.inherits(CornerStoneContentAssessor, _contentAssessor2$2.default);

contentAssessor.default = CornerStoneContentAssessor;

var relatedKeywordAssessor$1 = {};

Object.defineProperty(relatedKeywordAssessor$1, "__esModule", {
	value: true
});

var _util$2 = require$$2$1;

var _assessor$3 = assessor;

var _assessor2$3 = _interopRequireDefault$g(_assessor$3);

var _IntroductionKeywordAssessment$2 = IntroductionKeywordAssessment$1;

var _IntroductionKeywordAssessment2$2 = _interopRequireDefault$g(_IntroductionKeywordAssessment$2);

var _KeyphraseLengthAssessment$2 = KeyphraseLengthAssessment$1;

var _KeyphraseLengthAssessment2$2 = _interopRequireDefault$g(_KeyphraseLengthAssessment$2);

var _KeywordDensityAssessment$2 = KeywordDensityAssessment$1;

var _KeywordDensityAssessment2$2 = _interopRequireDefault$g(_KeywordDensityAssessment$2);

var _MetaDescriptionKeywordAssessment$2 = MetaDescriptionKeywordAssessment$1;

var _MetaDescriptionKeywordAssessment2$2 = _interopRequireDefault$g(_MetaDescriptionKeywordAssessment$2);

var _TextImagesAssessment$1 = TextImagesAssessment$1;

var _TextImagesAssessment2$1 = _interopRequireDefault$g(_TextImagesAssessment$1);

var _TextCompetingLinksAssessment$1 = TextCompetingLinksAssessment$1;

var _TextCompetingLinksAssessment2$1 = _interopRequireDefault$g(_TextCompetingLinksAssessment$1);

var _FunctionWordsInKeyphraseAssessment$2 = FunctionWordsInKeyphraseAssessment$1;

var _FunctionWordsInKeyphraseAssessment2$2 = _interopRequireDefault$g(_FunctionWordsInKeyphraseAssessment$2);

function _interopRequireDefault$g(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates the Assessor
 *
 * @param {object} i18n The i18n object used for translations.
 * @param {Object} options The options for this assessor.
 * @param {Object} options.marker The marker to pass the list of marks to.
 *
 * @constructor
 */
const relatedKeywordAssessor = function relatedKeywordAssessor(i18n, options) {
	_assessor2$3.default.call(this, i18n, options);

	this._assessments = [new _IntroductionKeywordAssessment2$2.default(), new _KeyphraseLengthAssessment2$2.default(), new _KeywordDensityAssessment2$2.default(), new _MetaDescriptionKeywordAssessment2$2.default(), new _TextCompetingLinksAssessment2$1.default(), new _TextImagesAssessment2$1.default({
		scores: {
			noImages: 3,
			withAltNonKeyword: 3,
			withAlt: 3,
			noAlt: 3
		}
	}), new _FunctionWordsInKeyphraseAssessment2$2.default()];
};

(0, _util$2.inherits)(relatedKeywordAssessor, _assessor2$3.default);

relatedKeywordAssessor$1.default = relatedKeywordAssessor;

var seoAssessor = {};

Object.defineProperty(seoAssessor, "__esModule", {
	value: true
});

var _util$1 = require$$2$1;

var _IntroductionKeywordAssessment$1 = IntroductionKeywordAssessment$1;

var _IntroductionKeywordAssessment2$1 = _interopRequireDefault$f(_IntroductionKeywordAssessment$1);

var _KeyphraseLengthAssessment$1 = KeyphraseLengthAssessment$1;

var _KeyphraseLengthAssessment2$1 = _interopRequireDefault$f(_KeyphraseLengthAssessment$1);

var _KeywordDensityAssessment$1 = KeywordDensityAssessment$1;

var _KeywordDensityAssessment2$1 = _interopRequireDefault$f(_KeywordDensityAssessment$1);

var _MetaDescriptionKeywordAssessment$1 = MetaDescriptionKeywordAssessment$1;

var _MetaDescriptionKeywordAssessment2$1 = _interopRequireDefault$f(_MetaDescriptionKeywordAssessment$1);

var _TextCompetingLinksAssessment = TextCompetingLinksAssessment$1;

var _TextCompetingLinksAssessment2 = _interopRequireDefault$f(_TextCompetingLinksAssessment);

var _InternalLinksAssessment = InternalLinksAssessment$1;

var _InternalLinksAssessment2 = _interopRequireDefault$f(_InternalLinksAssessment);

var _TitleKeywordAssessment = TitleKeywordAssessment$1;

var _TitleKeywordAssessment2 = _interopRequireDefault$f(_TitleKeywordAssessment);

var _UrlKeywordAssessment = UrlKeywordAssessment$1;

var _UrlKeywordAssessment2 = _interopRequireDefault$f(_UrlKeywordAssessment);

var _assessor$2 = assessor;

var _assessor2$2 = _interopRequireDefault$f(_assessor$2);

var _seoAssessor$2 = seoAssessor$1;

var _seoAssessor2$2 = _interopRequireDefault$f(_seoAssessor$2);

var _MetaDescriptionLengthAssessment = MetaDescriptionLengthAssessment$1;

var _MetaDescriptionLengthAssessment2 = _interopRequireDefault$f(_MetaDescriptionLengthAssessment);

var _SubHeadingsKeywordAssessment = SubHeadingsKeywordAssessment$1;

var _SubHeadingsKeywordAssessment2 = _interopRequireDefault$f(_SubHeadingsKeywordAssessment);

var _TextImagesAssessment = TextImagesAssessment$1;

var _TextImagesAssessment2 = _interopRequireDefault$f(_TextImagesAssessment);

var _TextLengthAssessment = TextLengthAssessment$1;

var _TextLengthAssessment2 = _interopRequireDefault$f(_TextLengthAssessment);

var _OutboundLinksAssessment = OutboundLinksAssessment$1;

var _OutboundLinksAssessment2 = _interopRequireDefault$f(_OutboundLinksAssessment);

var _PageTitleWidthAssessment = PageTitleWidthAssessment$1;

var _PageTitleWidthAssessment2 = _interopRequireDefault$f(_PageTitleWidthAssessment);

var _FunctionWordsInKeyphraseAssessment$1 = FunctionWordsInKeyphraseAssessment$1;

var _FunctionWordsInKeyphraseAssessment2$1 = _interopRequireDefault$f(_FunctionWordsInKeyphraseAssessment$1);

var _SingleH1Assessment = SingleH1Assessment;

var _SingleH1Assessment2 = _interopRequireDefault$f(_SingleH1Assessment);

function _interopRequireDefault$f(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates the Assessor
 *
 * @param {Object} i18n The i18n object used for translations.
 * @param {Object} options The options for this assessor.
 * @param {Object} options.marker The marker to pass the list of marks to.
 *
 * @constructor
 */
const CornerstoneSEOAssessor = function CornerstoneSEOAssessor(i18n, options) {
	_assessor2$2.default.call(this, i18n, options);
	this.type = "CornerstoneSEOAssessor";

	this._assessments = [new _IntroductionKeywordAssessment2$1.default(), new _KeyphraseLengthAssessment2$1.default(), new _KeywordDensityAssessment2$1.default(), new _MetaDescriptionKeywordAssessment2$1.default(), new _MetaDescriptionLengthAssessment2.default({
		scores: {
			tooLong: 3,
			tooShort: 3
		}
	}), new _SubHeadingsKeywordAssessment2.default(), new _TextCompetingLinksAssessment2.default(), new _TextImagesAssessment2.default({
		scores: {
			noImages: 3,
			withAltNonKeyword: 3,
			withAlt: 3,
			noAlt: 3
		}
	}), new _TextLengthAssessment2.default({
		recommendedMinimum: 900,
		slightlyBelowMinimum: 400,
		belowMinimum: 300,

		scores: {
			belowMinimum: -20,
			farBelowMinimum: -20
		},

		cornerstoneContent: true
	}), new _OutboundLinksAssessment2.default({
		scores: {
			noLinks: 3
		}
	}), new _TitleKeywordAssessment2.default(), new _InternalLinksAssessment2.default(), new _PageTitleWidthAssessment2.default({
		scores: {
			widthTooShort: 3,
			widthTooLong: 3
		}
	}), new _UrlKeywordAssessment2.default({
		scores: {
			okay: 3
		}
	}), new _FunctionWordsInKeyphraseAssessment2$1.default(), new _SingleH1Assessment2.default()];
};

(0, _util$1.inherits)(CornerstoneSEOAssessor, _seoAssessor2$2.default);

seoAssessor.default = CornerstoneSEOAssessor;

var includesAny$1 = {};

Object.defineProperty(includesAny$1, "__esModule", {
  value: true
});
includesAny$1.default = includesAny;

var _lodashEs$8 = require$$1$1;

/**
 * Checks if any of the values is in the collection.
 *
 * @param {Object|array} collection The collection to check in.
 * @param {array}        values     The array of values.
 *
 * @returns {boolean} Whether a value was found in the collection.
 */
function includesAny(collection, values) {
  for (let i = 0; i < values.length; i++) {
    if ((0, _lodashEs$8.includes)(collection, values[i])) {
      return true;
    }
  }

  return false;
}

var relatedKeywordTaxonomyAssessor = {};

Object.defineProperty(relatedKeywordTaxonomyAssessor, "__esModule", {
	value: true
});

var _util = require$$2$1;

var _IntroductionKeywordAssessment = IntroductionKeywordAssessment$1;

var _IntroductionKeywordAssessment2 = _interopRequireDefault$e(_IntroductionKeywordAssessment);

var _KeyphraseLengthAssessment = KeyphraseLengthAssessment$1;

var _KeyphraseLengthAssessment2 = _interopRequireDefault$e(_KeyphraseLengthAssessment);

var _KeywordDensityAssessment = KeywordDensityAssessment$1;

var _KeywordDensityAssessment2 = _interopRequireDefault$e(_KeywordDensityAssessment);

var _MetaDescriptionKeywordAssessment = MetaDescriptionKeywordAssessment$1;

var _MetaDescriptionKeywordAssessment2 = _interopRequireDefault$e(_MetaDescriptionKeywordAssessment);

var _assessor$1 = assessor;

var _assessor2$1 = _interopRequireDefault$e(_assessor$1);

var _FunctionWordsInKeyphraseAssessment = FunctionWordsInKeyphraseAssessment$1;

var _FunctionWordsInKeyphraseAssessment2 = _interopRequireDefault$e(_FunctionWordsInKeyphraseAssessment);

function _interopRequireDefault$e(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates the Assessor used for taxonomy pages.
 *
 * @param {object} i18n The i18n object used for translations.
 * @param {Object} options The options for this assessor.
 * @constructor
 */
const RelatedKeywordTaxonomyAssessor = function RelatedKeywordTaxonomyAssessor(i18n, options) {
	_assessor2$1.default.call(this, i18n, options);
	this.type = "RelatedKeywordsTaxonomyAssessor";

	this._assessments = [new _IntroductionKeywordAssessment2.default(), new _KeyphraseLengthAssessment2.default({ isRelatedKeyphrase: true }), new _KeywordDensityAssessment2.default(), new _MetaDescriptionKeywordAssessment2.default(),
	// Text Images assessment here.
	new _FunctionWordsInKeyphraseAssessment2.default()];
};

(0, _util.inherits)(RelatedKeywordTaxonomyAssessor, _assessor2$1.default);

relatedKeywordTaxonomyAssessor.default = RelatedKeywordTaxonomyAssessor;

var scheduler = {};

var Scheduler$1 = {};

var Task$1 = {};

Object.defineProperty(Task$1, "__esModule", {
	value: true
});

var _lodashEs$7 = require$$1$1;

/**
 * Represents a scheduler task.
 */
class Task {
	/**
  * Initializes a task.
  *
  * @param {number}   id      The task identifier.
  * @param {Function} execute Executes the job with the data.
  * @param {Function} done    Callback for the scheduler.
  * @param {Object}   [data]  Optional data for when executing the task.
  * @param {string}   type    The type of the task (analyze, analyzeRelatedKeywords, loadScript or customMessage)
  */
	constructor(id, execute, done, data = {}, type = "analyze") {
		if (!(0, _lodashEs$7.isNumber)(id)) {
			throw new Error("Task.id should be a number.");
		}
		if (!(0, _lodashEs$7.isFunction)(execute)) {
			throw new Error("Task.execute should be a function.");
		}
		if (!(0, _lodashEs$7.isFunction)(done)) {
			throw new Error("Task.done should be a function.");
		}
		if (!(0, _lodashEs$7.isObject)(data)) {
			throw new Error("Task.data should be an object.");
		}
		this.id = id;
		this.execute = execute;
		this.done = done;
		this.data = data;
		this.type = type;
	}
}
Task$1.default = Task;

Object.defineProperty(Scheduler$1, "__esModule", {
	value: true
});

var _lodashEs$6 = require$$1$1;

var _Task = Task$1;

var _Task2 = _interopRequireDefault$d(_Task);

function _interopRequireDefault$d(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External dependencies.
const DEFAULT_CONFIGURATION = {
	pollTime: 50
};

/**
 * The scheduler is used in the analysis web worker to schedule tasks.
 *
 * Tasks have priorities based on their type.
 * When a task is executed, the task id and data are its arguments.
 * When a task is done, the task id and the execute result are its arguments.
 *
 * Start polling runs tick.
 * 1. Tick tries to run the next task.
 * 2. After the task is run, a timeout is set (configuration.pollTime).
 * 3. On the timeout execution, tick is called again (back to step 1).
 */


// Internal dependencies.
class Scheduler {
	/**
  * Initializes a Scheduler.
  *
  * @param {Object}  [configuration]             The configuration.
  * @param {number}  [configuration.pollTime]    The time in between each task
  *                                              poll in milliseconds,
  *                                              defaults to 50.
  */
	constructor(configuration = {}) {
		this._configuration = (0, _lodashEs$6.merge)(DEFAULT_CONFIGURATION, configuration);
		this._tasks = {
			standard: [],
			extensions: [],
			analyze: [],
			analyzeRelatedKeywords: []
		};
		this._pollHandle = null;
		this._started = false;

		// Bind functions to this scope.
		this.startPolling = this.startPolling.bind(this);
		this.stopPolling = this.stopPolling.bind(this);
		this.tick = this.tick.bind(this);
	}

	/**
  * Initialize polling.
  *
  * @returns {void}
  */
	startPolling() {
		if (this._started) {
			return;
		}

		this._started = true;

		this.tick();
	}

	/**
  * Do a tick and execute a task.
  *
  * @returns {void}
  */
	tick() {
		this.executeNextTask().then(() => {
			this._pollHandle = setTimeout(this.tick, this._configuration.pollTime);
		});
	}

	/**
  * Stop polling.
  *
  * @returns {void}
  */
	stopPolling() {
		clearTimeout(this._pollHandle);
		this._pollHandle = null;
		this._started = false;
	}

	/**
  * Schedule a task.
  *
  * @param {Object}   task         The task object.
  * @param {number}   task.id      The task id.
  * @param {function} task.execute The function to run for task execution.
  * @param {function} task.done    The function to run when the task is done.
  * @param {Object}   task.data    The data object to execute with.
  * @param {string}   task.type    The type of the task.
  *
  * @returns {void}
  */
	schedule({ id, execute, done, data, type }) {
		const task = new _Task2.default(id, execute, done, data, type);
		switch (type) {
			case "customMessage":
			case "loadScript":
				this._tasks.extensions.push(task);
				break;
			case "analyze":
				this._tasks.analyze = [task];
				break;
			case "analyzeRelatedKeywords":
				this._tasks.analyzeRelatedKeywords = [task];
				break;
			default:
				this._tasks.standard.push(task);
		}
	}

	/**
  * Retrieves the next task from the queue. Queues are sorted from lowest to highest priority.
  *
  * @returns {Task|null} The next task or null if none are available.
  */
	getNextTask() {
		if (this._tasks.extensions.length > 0) {
			return this._tasks.extensions.shift();
		}

		if (this._tasks.analyze.length > 0) {
			return this._tasks.analyze.shift();
		}

		if (this._tasks.analyzeRelatedKeywords.length > 0) {
			return this._tasks.analyzeRelatedKeywords.shift();
		}

		if (this._tasks.standard.length > 0) {
			return this._tasks.standard.shift();
		}

		return null;
	}

	/**
  * Executes the next task.
  *
  * @returns {Promise} Resolves once the task is done, with the result of the task.
  */
	executeNextTask() {
		const task = this.getNextTask();
		if (task === null) {
			return Promise.resolve(null);
		}

		return Promise.resolve().then(() => {
			return task.execute(task.id, task.data);
		}).then(result => {
			task.done(task.id, result);

			return result;
		});
	}
}
Scheduler$1.default = Scheduler;

Object.defineProperty(scheduler, "__esModule", {
  value: true
});

var _Scheduler = Scheduler$1;

var _Scheduler2 = _interopRequireDefault$c(_Scheduler);

function _interopRequireDefault$c(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

scheduler.default = _Scheduler2.default;

var transporter = {};

var parse$1 = {};

Object.defineProperty(parse$1, "__esModule", {
	value: true
});
parse$1.default = parse;

var _lodashEs$5 = require$$1$1;

var _AssessmentResult$1 = AssessmentResult$1;

var _AssessmentResult2$1 = _interopRequireDefault$b(_AssessmentResult$1);

var _Mark = Mark$1;

var _Mark2 = _interopRequireDefault$b(_Mark);

var _Paper$2 = Paper$1;

var _Paper2$2 = _interopRequireDefault$b(_Paper$2);

var _Participle = Participle$1;

var _Participle2 = _interopRequireDefault$b(_Participle);

var _Sentence = Sentence$1;

var _Sentence2 = _interopRequireDefault$b(_Sentence);

var _SentencePart = SentencePart$9;

var _SentencePart2 = _interopRequireDefault$b(_SentencePart);

var _WordCombination = WordCombination$1;

var _WordCombination2 = _interopRequireDefault$b(_WordCombination);

var _ProminentWord = ProminentWord$1;

var _ProminentWord2 = _interopRequireDefault$b(_ProminentWord);

function _interopRequireDefault$b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PARSE_CLASSES = {
	AssessmentResult: _AssessmentResult2$1.default,
	Mark: _Mark2.default,
	Paper: _Paper2$2.default,
	Participle: _Participle2.default,
	Sentence: _Sentence2.default,
	SentencePart: _SentencePart2.default,
	WordCombination: _WordCombination2.default,
	ProminentWord: _ProminentWord2.default
};

/**
 * Parses a data structure that has previously been serialized.
 *
 * @param {*} thing The data structure to parse.
 *
 * @returns {*} The parsed data structure.
 */
function parse(thing) {
	if ((0, _lodashEs$5.isArray)(thing)) {
		return thing.map(parse);
	}

	const thingIsObject = (0, _lodashEs$5.isObject)(thing);

	if (thingIsObject && thing._parseClass && PARSE_CLASSES[thing._parseClass]) {
		return PARSE_CLASSES[thing._parseClass].parse(thing);
	}

	if (thingIsObject) {
		return (0, _lodashEs$5.mapValues)(thing, value => parse(value));
	}

	return thing;
}

var serialize$1 = {};

Object.defineProperty(serialize$1, "__esModule", {
	value: true
});
serialize$1.default = serialize;

var _lodashEs$4 = require$$1$1;

/**
 * Serializes a data structure to transfer it over a web worker message.
 *
 * @param {*} thing The data structure to serialize.
 *
 * @returns {*} The serialized data structure.
 */
function serialize(thing) {
	if ((0, _lodashEs$4.isArray)(thing)) {
		return thing.map(serialize);
	}

	const thingIsObject = (0, _lodashEs$4.isObject)(thing);

	if (thingIsObject && thing.serialize) {
		return thing.serialize();
	}

	if (thingIsObject) {
		return (0, _lodashEs$4.mapValues)(thing, value => serialize(value));
	}

	return thing;
}

Object.defineProperty(transporter, "__esModule", {
	value: true
});

var _parse = parse$1;

var _parse2 = _interopRequireDefault$a(_parse);

var _serialize = serialize$1;

var _serialize2 = _interopRequireDefault$a(_serialize);

function _interopRequireDefault$a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

transporter.default = {
	parse: _parse2.default,
	serialize: _serialize2.default
};

var wrapTryCatchAroundAction$1 = {};

var formatString = {};

Object.defineProperty(formatString, "__esModule", {
	value: true
});

formatString.default = function (string, formatMap, delimiter = "%%") {
	delimiter = (0, _lodashEs$3.escapeRegExp)(delimiter);
	const parameterRegex = new RegExp(`${delimiter}(.+?)${delimiter}`, "g");
	let match;
	let formattedString = string;

	// Try to match and replace each occurrence of "%%something%%" in the string.
	while ((match = parameterRegex.exec(string)) !== null) {
		const key = match[1];
		// Create regex from parameter (e.g. "%%key%%")
		const replaceRegex = new RegExp(`${delimiter}${(0, _lodashEs$3.escapeRegExp)(key)}${delimiter}`, "g");
		// Replace occurrence (if parameter exists in the format map).
		if (key in formatMap) {
			formattedString = formattedString.replace(replaceRegex, formatMap[key]);
		}
	}

	return formattedString;
};

var _lodashEs$3 = require$$1$1;

Object.defineProperty(wrapTryCatchAroundAction$1, "__esModule", {
	value: true
});
wrapTryCatchAroundAction$1.default = wrapTryCatchAroundAction;

var _formatString = formatString;

var _formatString2 = _interopRequireDefault$9(_formatString);

function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Logs and formats the error message to send back to the plugin
 * when an analysis web worker action fails.
 *
 * @param {Logger}	logger					The logger instance to log with.
 * @param {Error} 	error					The error to log.
 * @param {Object}	payload					The action payload.
 * @param {string} 	[errorMessagePrefix=""]	The prefix of the error message.
 *
 * @returns {string} the error message to send back.
 */
const handleError = function handleError(logger, error, payload, errorMessagePrefix = "") {
	// Try to format the string with payload parameters, if there are any.
	if (payload) {
		errorMessagePrefix = (0, _formatString2.default)(errorMessagePrefix, payload);
	}

	let errorMessage = errorMessagePrefix ? [errorMessagePrefix] : [];

	if (error.name && error.message) {
		if (error.stack) {
			logger.debug(error.stack);
		}
		// Standard JavaScript error (e.g. when calling `throw new Error( message )`).
		errorMessage.push(`${error.name}: ${error.message}`);
	}

	errorMessage = errorMessage.join("\n\t");
	logger.error(errorMessage);
	return errorMessage;
};

/**
 * Wraps the given action in a try-catch that logs the error message.
 *
 * @param {Logger}   logger                  The logger instance to log with.
 * @param {Function} action                  The action to safely run.
 * @param {string}   [errorMessagePrefix=""] The prefix of the error message.
 *
 * @returns {Function} The wrapped action.
 */
function wrapTryCatchAroundAction(logger, action, errorMessagePrefix = "") {
	return async (...args) => {
		try {
			return await action(...args);
		} catch (error) {
			const errorMessage = handleError(logger, error, args[1], errorMessagePrefix);
			return { error: errorMessage };
		}
	};
}

var scoreAggregators = {};

var ReadabilityScoreAggregator$1 = {};

var ScoreAggregator$1 = {};

Object.defineProperty(ScoreAggregator$1, "__esModule", {
	value: true
});
/**
 * Aggregates assessment results into a single score.
 *
 * @memberOf module:parsedPaper/assess
 *
 * @abstract
 */
class ScoreAggregator {
	/**
  * Aggregates the given assessment results into a single score.
  *
  * @param {AssessmentResult[]} results The assessment results.
  *
  * @returns {number} The aggregated score.
  *
  * @abstract
  */
	aggregate(results) {
		// eslint-disable-line no-unused-vars
		console.warn("'aggregate' must be implemented by a child class of 'ScoreAggregator'");
	}
}

ScoreAggregator$1.default = ScoreAggregator;

Object.defineProperty(ReadabilityScoreAggregator$1, "__esModule", {
	value: true
});
ReadabilityScoreAggregator$1.READABILITY_SCORES = undefined;

var _getLanguage = getLanguage;

var _getLanguage2 = _interopRequireDefault$8(_getLanguage);

var _interpreters$1 = interpreters$1;

var _ScoreAggregator$1 = ScoreAggregator$1;

var _ScoreAggregator2$1 = _interopRequireDefault$8(_ScoreAggregator$1);

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Penalties that can be given on each assessment
 * when all assessments are currently supported
 * for the user's language.
 *
 * @type {{ok: number, bad: number, good: number}}
 * @const
 *
 * @memberOf module:parsedPaper/assess
 */
const PENALTY_MAPPING_FULL_SUPPORT = {
	bad: 3,
	ok: 2,
	good: 0
};

/**
 * Penalties that can be given on each assessment
 * when only a part of the assessments are currently supported
 * for the user's language.
 *
 * @type {{ok: number, bad: number, good: number}}
 * @const
 *
 * @memberOf module:parsedPaper/assess
 */


/* Internal dependencies */
const PENALTY_MAPPING_PARTIAL_SUPPORT = {
	bad: 4,
	ok: 2,
	good: 0
};

/**
 * The scores that can be given on the readability analysis.
 *
 * @type {{GOOD: number, OKAY: number, NEEDS_IMPROVEMENT: number, NOT_AVAILABLE: number}}
 * @const
 *
 * @memberOf module:parsedPaper/assess
 */
const READABILITY_SCORES = ReadabilityScoreAggregator$1.READABILITY_SCORES = {
	GOOD: 90,
	OKAY: 60,
	NEEDS_IMPROVEMENT: 30,
	NOT_AVAILABLE: 0
};

/**
 * A list of all the languages that have full support in the readability analysis.
 *
 * @type {string[]}
 * @const
 */
const FULLY_SUPPORTED_LANGUAGES = ["en", "nl", "de", "it", "ru", "fr", "es"];

/**
 * Aggregates the results of the readability analysis into a single score.
 *
 * @memberOf module:parsedPaper/assess
 */
class ReadabilityScoreAggregator extends _ScoreAggregator2$1.default {
	/**
  * Determines whether a language is fully supported.
  *
  * @param {string} locale The locale for which the content is written, e.g. `sv-SE` for Sweden.
  *
  * @returns {boolean} `true` if fully supported.
  */
	isFullySupported(locale) {
		// Sanity check if this is actually a locale string.
		if (locale && locale.includes("_")) {
			const language = (0, _getLanguage2.default)(locale);
			return FULLY_SUPPORTED_LANGUAGES.includes(language);
		}
		// Default to not fully supported.
		return false;
	}

	/**
  * Calculates the overall score (GOOD, OKAY or NEEDS IMPROVEMENT)
  * based on the penalty.
  *
  * @param {boolean} isFullySupported Whether this language is fully supported.
  * @param {number}  penalty          The total penalty.
  *
  * @returns {number} The overall score.
  */
	calculateScore(isFullySupported, penalty) {
		if (isFullySupported) {
			/*
    * If the language is fully supported, we are more lenient.
    * A higher penalty is needed to get lower scores.
    */
			if (penalty > 6) {
				return READABILITY_SCORES.NEEDS_IMPROVEMENT;
			}

			if (penalty > 4) {
				/*
     * A penalty between 4 and 6 means either:
     *  - One "ok" and one "bad" result (5).
     *  - Two "bad" results of 3 points each (6).
     *  - Three "ok" results of 2 points each (6).
     */
				return READABILITY_SCORES.OKAY;
			}
		} else {
			/*
    * If the language is NOT fully supported, we are more stringent.
    * The penalty threshold for getting lower scores is set lower.
    */
			if (penalty > 4) {
				return READABILITY_SCORES.NEEDS_IMPROVEMENT;
			}

			if (penalty > 2) {
				/*
     * A penalty of 3 or 4 means:
     *  - Two "ok" results of 2 points each (4).
     *  - One "bad" result of 4 points (4).
     */
				return READABILITY_SCORES.OKAY;
			}
		}
		return READABILITY_SCORES.GOOD;
	}

	/**
  * Calculates the total penalty based on the given assessment results.
  *
  * @param {AssessmentResult[]} results The valid results from which to calculate the total penalty.
  *
  * @returns {number} The total penalty for the results.
  */
	calculatePenalty(results) {
		return results.reduce((sum, result) => {
			// Compute the rating ("error", "feedback", "bad", "ok" or "good").
			const rating = (0, _interpreters$1.scoreToRating)(result.getScore());

			const penalty = this.isFullySupported(this.locale) ? PENALTY_MAPPING_FULL_SUPPORT[rating] : PENALTY_MAPPING_PARTIAL_SUPPORT[rating];

			// Add penalty when available.
			return penalty ? sum + penalty : sum;
		}, 0);
	}

	/**
  * Returns the list of valid results.
  * Valid results are all results that have a score and a text.
  *
  * @param {AssessmentResult[]} results The results to filter the valid results from.
  *
  * @returns {AssessmentResult[]} The list of valid results.
  */
	getValidResults(results) {
		return results.filter(result => result.hasScore() && result.hasText());
	}

	/**
  * Sets the locale of the content. We are more lenient on languages
  * that are fully supported in the analysis.
  *
  * @param {string} locale The locale of the content.
  *
  * @returns {void}
  */
	setLocale(locale) {
		this.locale = locale;
	}

	/**
  * Aggregates the given assessment results into a single analysis score.
  *
  * @param {AssessmentResult[]} results The assessment results.
  *
  * @returns {number} The aggregated score.
  */
	aggregate(results) {
		const validResults = this.getValidResults(results);

		/*
   * If you have no content, you have a gray indicator.
   * (Assume that one result always means the 'no content' assessment result).
   */
		if (validResults.length <= 1) {
			return READABILITY_SCORES.NOT_AVAILABLE;
		}

		const penalty = this.calculatePenalty(validResults);
		const isFullySupported = this.isFullySupported(this.locale);
		return this.calculateScore(isFullySupported, penalty);
	}
}

ReadabilityScoreAggregator$1.default = ReadabilityScoreAggregator;

var SEOScoreAggregator$1 = {};

Object.defineProperty(SEOScoreAggregator$1, "__esModule", {
  value: true
});

var _ScoreAggregator = ScoreAggregator$1;

var _ScoreAggregator2 = _interopRequireDefault$7(_ScoreAggregator);

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The number to scale the score to.
 *
 * Individual scores are from 1 to 9.
 * The total score should be multiplied by this number to scale up.
 *
 * @type {number}
 * @const
 *
 * @memberOf module:parsedPaper/assess
 */
const ScoreScale = 100;

/**
 * The factor to multiply the amount of results with.
 *
 * Individual scores are from 1 to 9.
 * The make the total score work in the 100 scale, the amount of results needs to get multiplied by this factor.
 *
 * @type {number}
 * @const
 *
 * @memberOf module:parsedPaper/assess
 */
const ScoreFactor = 9;

/**
 * Aggregates SEO assessment results into a single score.
 *
 * @memberOf module:parsedPaper/assess
 */
class SEOScoreAggregator extends _ScoreAggregator2.default {
  /**
   * Aggregates the given assessment results into a single score.
   *
   * @param {AssessmentResult[]} results The assessment results.
   *
   * @returns {number} The aggregated score.
   */
  aggregate(results) {
    const score = results.reduce((sum, result) => sum + result.getScore(), 0);

    /*
     * Whenever the divide by part is 0 this can result in a `NaN` value. Then 0 should be returned as fallback.
     * This seemed better than the if check `results.length === 0`,
     * because it also protects against ScoreFactor being 0.
     */
    return Math.round(score * ScoreScale / (results.length * ScoreFactor)) || 0;
  }
}

SEOScoreAggregator$1.default = SEOScoreAggregator;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ReadabilityScoreAggregator = ReadabilityScoreAggregator$1;

Object.defineProperty(exports, "ReadabilityScoreAggregator", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ReadabilityScoreAggregator).default;
  }
});

var _ScoreAggregator = ScoreAggregator$1;

Object.defineProperty(exports, "ScoreAggregator", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScoreAggregator).default;
  }
});

var _SEOScoreAggregator = SEOScoreAggregator$1;

Object.defineProperty(exports, "SEOScoreAggregator", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SEOScoreAggregator).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

}(scoreAggregators));

Object.defineProperty(AnalysisWebWorker$1, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // External dependencies.


// YoastSEO.js dependencies.


var _autop = require$$0;

var _featureFlag = require$$1$2;

var _jed$1 = jed.exports;

var _jed2$1 = _interopRequireDefault$6(_jed$1);

var _lodashEs$2 = require$$1$1;

var _loglevel = loglevel.exports;

var _assessments = assessments$1;

var assessments = _interopRequireWildcard(_assessments);

var _bundledPlugins = bundledPlugins$1;

var bundledPlugins = _interopRequireWildcard(_bundledPlugins);

var _helpers = helpers$1;

var helpers = _interopRequireWildcard(_helpers);

var _markers = markers$1;

var markers = _interopRequireWildcard(_markers);

var _stringProcessing = stringProcessing;

var string = _interopRequireWildcard(_stringProcessing);

var _interpreters = interpreters$1;

var interpreters = _interopRequireWildcard(_interpreters);

var _config = config$1;

var config = _interopRequireWildcard(_config);

var _assessor = assessor;

var _assessor2 = _interopRequireDefault$6(_assessor);

var _assessment = assessment;

var _assessment2 = _interopRequireDefault$6(_assessment);

var _seoAssessor$1 = seoAssessor$1;

var _seoAssessor2$1 = _interopRequireDefault$6(_seoAssessor$1);

var _contentAssessor$1 = contentAssessor$1;

var _contentAssessor2$1 = _interopRequireDefault$6(_contentAssessor$1);

var _taxonomyAssessor = taxonomyAssessor;

var _taxonomyAssessor2 = _interopRequireDefault$6(_taxonomyAssessor);

var _pluggable$1 = pluggable;

var _pluggable2$1 = _interopRequireDefault$6(_pluggable$1);

var _researcher$1 = researcher;

var _researcher2$1 = _interopRequireDefault$6(_researcher$1);

var _snippetPreview$1 = snippetPreview;

var _snippetPreview2$1 = _interopRequireDefault$6(_snippetPreview$1);

var _Paper$1 = Paper$1;

var _Paper2$1 = _interopRequireDefault$6(_Paper$1);

var _AssessmentResult = AssessmentResult$1;

var _AssessmentResult2 = _interopRequireDefault$6(_AssessmentResult);

var _relatedKeywordAssessor = relatedKeywordAssessor$3;

var _relatedKeywordAssessor2 = _interopRequireDefault$6(_relatedKeywordAssessor);

var _contentAssessor3$1 = contentAssessor;

var _contentAssessor4$1 = _interopRequireDefault$6(_contentAssessor3$1);

var _relatedKeywordAssessor3 = relatedKeywordAssessor$1;

var _relatedKeywordAssessor4 = _interopRequireDefault$6(_relatedKeywordAssessor3);

var _seoAssessor3$1 = seoAssessor;

var _seoAssessor4$1 = _interopRequireDefault$6(_seoAssessor3$1);

var _invalidType = invalidType;

var _invalidType2 = _interopRequireDefault$6(_invalidType);

var _includesAny = includesAny$1;

var _includesAny2 = _interopRequireDefault$6(_includesAny);

var _shortlinker = shortlinker;

var _relatedKeywordTaxonomyAssessor = relatedKeywordTaxonomyAssessor;

var _relatedKeywordTaxonomyAssessor2 = _interopRequireDefault$6(_relatedKeywordTaxonomyAssessor);

var _scheduler = scheduler;

var _scheduler2 = _interopRequireDefault$6(_scheduler);

var _transporter$1 = transporter;

var _transporter2$1 = _interopRequireDefault$6(_transporter$1);

var _wrapTryCatchAroundAction = wrapTryCatchAroundAction$1;

var _wrapTryCatchAroundAction2 = _interopRequireDefault$6(_wrapTryCatchAroundAction);

var _scoreAggregators = scoreAggregators;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const YoastSEO$1 = {
	Assessor: _assessor2.default,
	Assessment: _assessment2.default,
	SEOAssessor: _seoAssessor2$1.default,
	ContentAssessor: _contentAssessor2$1.default,
	TaxonomyAssessor: _taxonomyAssessor2.default,
	Pluggable: _pluggable2$1.default,
	Researcher: _researcher2$1.default,
	SnippetPreview: _snippetPreview2$1.default,
	RelatedKeywordAssessor: _relatedKeywordAssessor2.default,

	Paper: _Paper2$1.default,
	AssessmentResult: _AssessmentResult2.default,

	assessments,
	bundledPlugins,
	helpers,
	markers,
	string,
	interpreters,
	config
};

// Internal dependencies.


// Tree assessor functionality.


const keyphraseDistribution$1 = new assessments.seo.KeyphraseDistributionAssessment();

const logger = (0, _loglevel.getLogger)("yoast-analysis-worker");
logger.setDefaultLevel("error");

/**
 * Analysis Web Worker.
 *
 * Worker API:     https://developer.mozilla.org/en-US/docs/Web/API/Worker
 * Webpack loader: https://github.com/webpack-contrib/worker-loader
 */
class AnalysisWebWorker {
	/**
  * Initializes the AnalysisWebWorker class.
  *
  * @param {Object} scope The scope for the messaging. Expected to have the
  *                       `onmessage` event and the `postMessage` function.
  */
	constructor(scope) {
		this._scope = scope;

		this._configuration = {
			contentAnalysisActive: true,
			keywordAnalysisActive: true,
			useCornerstone: false,
			useTaxonomy: false,
			useKeywordDistribution: false,
			// The locale used for language-specific configurations in Flesch-reading ease and Sentence length assessments.
			locale: "en_US"
		};

		this._scheduler = new _scheduler2.default();

		this._paper = null;
		this._relatedKeywords = {};

		this._i18n = AnalysisWebWorker.createI18n();
		this._researcher = new _researcher2$1.default(this._paper);

		this._contentAssessor = null;
		this._seoAssessor = null;
		this._relatedKeywordAssessor = null;

		/*
   * The cached analyses results.
   *
   * A single result has the following structure:
   * {AssessmentResult[]} readability.results An array of assessment results; in serialized format.
   * {number}             readability.score   The overall score.
   *
   * The results have the following structure.
   * {Object} readability Content assessor results.
   * {Object} seo         SEO assessor results, per keyword identifier or empty string for the main.
   * {Object} seo[ "" ]   The result of the paper analysis for the main keyword.
   * {Object} seo[ key ]  Same as above, but instead for a related keyword.
   */
		this._results = {
			readability: {
				results: [],
				score: 0
			},
			seo: {
				"": {
					results: [],
					score: 0
				}
			}
		};
		this._registeredAssessments = [];
		this._registeredMessageHandlers = {};
		this._registeredParsers = [];

		// Set up everything for the analysis on the tree.
		this.setupTreeAnalysis();

		this.bindActions();

		this.assessRelatedKeywords = this.assessRelatedKeywords.bind(this);

		// Bind register functions to this scope.
		this.registerAssessment = this.registerAssessment.bind(this);
		this.registerMessageHandler = this.registerMessageHandler.bind(this);
		this.refreshAssessment = this.refreshAssessment.bind(this);

		// Bind event handlers to this scope.
		this.handleMessage = this.handleMessage.bind(this);

		// Wrap try/catch around actions.
		this.analyzeRelatedKeywords = (0, _wrapTryCatchAroundAction2.default)(logger, this.analyze, "An error occurred while running the related keywords analysis.");
		/*
   * Overwrite this.analyze after we use it in this.analyzeRelatedKeywords so that this.analyzeRelatedKeywords
   * doesn't use the overwritten version. Therefore, this order shouldn't be changed.
   */
		this.analyze = (0, _wrapTryCatchAroundAction2.default)(logger, this.analyze, "An error occurred while running the analysis.");
		this.runResearch = (0, _wrapTryCatchAroundAction2.default)(logger, this.runResearch, "An error occurred after running the '%%name%%' research.");
	}

	/**
  * Binds actions to this scope.
  *
  * @returns {void}
  */
	bindActions() {
		// Bind actions to this scope.
		this.analyze = this.analyze.bind(this);
		this.analyzeDone = this.analyzeDone.bind(this);
		this.analyzeRelatedKeywordsDone = this.analyzeRelatedKeywordsDone.bind(this);
		this.loadScript = this.loadScript.bind(this);
		this.loadScriptDone = this.loadScriptDone.bind(this);
		this.customMessage = this.customMessage.bind(this);
		this.customMessageDone = this.customMessageDone.bind(this);
		this.clearCache = this.clearCache.bind(this);
		this.runResearch = this.runResearch.bind(this);
		this.runResearchDone = this.runResearchDone.bind(this);
	}

	/**
  * Sets up the web worker for running the tree readability and SEO analysis.
  *
  * @returns {void}
  */
	setupTreeAnalysis() {
		// Researcher
		/*
   * Disabled code:
   * this._treeResearcher = new TreeResearcher();
   */
		this._treeResearcher = null;

		// Assessors
		this._contentTreeAssessor = null;
		this._seoTreeAssessor = null;
		this._relatedKeywordTreeAssessor = null;

		// Registered assessments
		this._registeredTreeAssessments = [];

		// Score aggregators
		this._seoScoreAggregator = new _scoreAggregators.SEOScoreAggregator();
		this._contentScoreAggregator = new _scoreAggregators.ReadabilityScoreAggregator();

		// Tree representation of text to analyze
		this._tree = null;

		// Tree builder.
		this._treeBuilder = null;
	}

	/**
  * Registers this web worker with the scope passed to it's constructor.
  *
  * @returns {void}
  */
	register() {
		this._scope.onmessage = this.handleMessage;
		this._scope.analysisWorker = {
			registerAssessment: this.registerAssessment,
			registerParser: this.registerParser,
			registerMessageHandler: this.registerMessageHandler,
			refreshAssessment: this.refreshAssessment
		};
		this._scope.yoast = this._scope.yoast || {};
		this._scope.yoast.analysis = YoastSEO$1;
	}

	/**
  * Receives the post message and determines the action.
  *
  * See: https://developer.mozilla.org/en-US/docs/Web/API/Worker/onmessage
  *
  * @param {MessageEvent} event              The post message event.
  * @param {Object}       event.data         The data object.
  * @param {string}       event.data.type    The action type.
  * @param {string}       event.data.id      The request id.
  * @param {string}       event.data.payload The payload of the action.
  *
  * @returns {void}
  */
	handleMessage({ data: { type, id, payload } }) {
		payload = _transporter2$1.default.parse(payload);

		logger.debug("AnalysisWebWorker incoming:", type, id, payload);

		switch (type) {
			case "initialize":
				this.initialize(id, payload);
				this._scheduler.startPolling();
				break;
			case "analyze":
				this._scheduler.schedule({
					id,
					execute: this.analyze,
					done: this.analyzeDone,
					data: payload,
					type: type
				});
				break;
			case "analyzeRelatedKeywords":
				this._scheduler.schedule({
					id,
					execute: this.analyzeRelatedKeywords,
					done: this.analyzeRelatedKeywordsDone,
					data: payload,
					type: type
				});
				break;
			case "loadScript":
				this._scheduler.schedule({
					id,
					execute: this.loadScript,
					done: this.loadScriptDone,
					data: payload,
					type: type
				});
				break;
			case "runResearch":
				this._scheduler.schedule({
					id,
					execute: this.runResearch,
					done: this.runResearchDone,
					data: payload
				});
				break;
			case "customMessage":
				{
					const name = payload.name;
					if (name && this._registeredMessageHandlers[name]) {
						this._scheduler.schedule({
							id,
							execute: this.customMessage,
							done: this.customMessageDone,
							data: payload,
							type: type
						});
						break;
					}
					this.customMessageDone(id, { error: new Error("No message handler registered for messages with name: " + name) });
					break;
				}
			default:
				console.warn("AnalysisWebWorker unrecognized action:", type);
		}
	}

	/**
  * Initializes i18n object based on passed configuration.
  *
  * @param {Object} [translations] The translations to be used in the current
  *                                instance.
  *
  * @returns {Jed} Jed instance.
  */
	static createI18n(translations) {
		// Use default object to prevent Jed from erroring out.
		translations = translations || {
			domain: "js-text-analysis",
			// eslint-disable-next-line camelcase
			locale_data: {
				"js-text-analysis": {
					"": {}
				}
			}
		};

		return new _jed2$1.default(translations);
	}

	/**
  * Initializes the appropriate content assessor.
  *
  * @returns {null|ContentAssessor|CornerstoneContentAssessor} The chosen
  *                                                            content
  *                                                            assessor.
  */
	createContentAssessor() {
		var _configuration = this._configuration;
		const contentAnalysisActive = _configuration.contentAnalysisActive,
		      useCornerstone = _configuration.useCornerstone,
		      locale = _configuration.locale;


		if (contentAnalysisActive === false) {
			return null;
		}

		const assessor = useCornerstone === true ? new _contentAssessor4$1.default(this._i18n, { locale }) : new _contentAssessor2$1.default(this._i18n, { locale });

		return assessor;
	}

	/**
  * Initializes the appropriate SEO assessor.
  *
  * @returns {null|SEOAssessor|CornerstoneSEOAssessor|TaxonomyAssessor} The chosen
  *                                                                     SEO
  *                                                                     assessor.
  */
	createSEOAssessor() {
		var _configuration2 = this._configuration;
		const keywordAnalysisActive = _configuration2.keywordAnalysisActive,
		      useCornerstone = _configuration2.useCornerstone,
		      useKeywordDistribution = _configuration2.useKeywordDistribution,
		      useTaxonomy = _configuration2.useTaxonomy,
		      locale = _configuration2.locale;


		if (keywordAnalysisActive === false) {
			return null;
		}

		let assessor;

		if (useTaxonomy === true) {
			assessor = new _taxonomyAssessor2.default(this._i18n, { locale: locale, researcher: this._researcher });
		} else {
			assessor = useCornerstone === true ? new _seoAssessor4$1.default(this._i18n, { locale: locale, researcher: this._researcher }) : new _seoAssessor2$1.default(this._i18n, { locale: locale, researcher: this._researcher });
		}

		if (useKeywordDistribution && (0, _lodashEs$2.isUndefined)(assessor.getAssessment("keyphraseDistribution"))) {
			assessor.addAssessment("keyphraseDistribution", keyphraseDistribution$1);
		}

		this._registeredAssessments.forEach(({ name, assessment }) => {
			if ((0, _lodashEs$2.isUndefined)(assessor.getAssessment(name))) {
				assessor.addAssessment(name, assessment);
			}
		});

		return assessor;
	}

	/**
  * Initializes the appropriate SEO assessor for related keywords.
  *
  * @returns {null|SEOAssessor|CornerstoneSEOAssessor|TaxonomyAssessor} The chosen
  *                                                                     related keywords
  *                                                                     assessor.
  */
	createRelatedKeywordsAssessor() {
		var _configuration3 = this._configuration;
		const keywordAnalysisActive = _configuration3.keywordAnalysisActive,
		      useCornerstone = _configuration3.useCornerstone,
		      useTaxonomy = _configuration3.useTaxonomy,
		      locale = _configuration3.locale;


		if (keywordAnalysisActive === false) {
			return null;
		}

		let assessor;

		if (useTaxonomy === true) {
			assessor = new _relatedKeywordTaxonomyAssessor2.default(this._i18n, { locale: locale, researcher: this._researcher });
		} else {
			assessor = useCornerstone === true ? new _relatedKeywordAssessor4.default(this._i18n, { locale: locale, researcher: this._researcher }) : new _relatedKeywordAssessor2.default(this._i18n, { locale: locale, researcher: this._researcher });
		}

		this._registeredAssessments.forEach(({ name, assessment }) => {
			if ((0, _lodashEs$2.isUndefined)(assessor.getAssessment(name))) {
				assessor.addAssessment(name, assessment);
			}
		});

		return assessor;
	}

	/**
  * Creates an SEO assessor for a tree, based on the given combination of cornerstone, taxonomy and related keyphrase flags.
  *
  * @param {Object}  assessorConfig                    The assessor configuration.
  * @param {boolean} [assessorConfig.relatedKeyphrase] If this assessor is for a related keyphrase, instead of the main one.
  * @param {boolean} [assessorConfig.taxonomy]         If this assessor is for a taxonomy page, instead of a regular page.
  * @param {boolean} [assessorConfig.cornerstone]      If this assessor is for cornerstone content.
  *
  * @returns {module:parsedPaper/assess.TreeAssessor} The created tree assessor.
  */
	/*
  * Disabled code:
  * createSEOTreeAssessor( assessorConfig ) {
  * 	 return constructSEOAssessor( this._i18n, this._treeResearcher, assessorConfig );
  * }
  */

	/**
  * Sends a message.
  *
  * @param {string} type      The message type.
  * @param {number} id        The request id.
  * @param {Object} [payload] The payload to deliver.
  *
  * @returns {void}
  */
	send(type, id, payload = {}) {
		logger.debug("AnalysisWebWorker outgoing:", type, id, payload);

		payload = _transporter2$1.default.serialize(payload);

		this._scope.postMessage({
			type,
			id,
			payload
		});
	}

	/**
  * Checks which assessors should update giving a configuration.
  *
  * @param {Object}   configuration          The configuration to check.
  * @param {Assessor} [contentAssessor=null] The content assessor.
  * @param {Assessor} [seoAssessor=null]     The SEO assessor.
  *
  * @returns {Object} Containing seo and readability with true or false.
  */
	static shouldAssessorsUpdate(configuration, contentAssessor = null, seoAssessor = null) {
		const readability = ["contentAnalysisActive", "useCornerstone", "locale", "translations"];
		const seo = ["keywordAnalysisActive", "useCornerstone", "useTaxonomy", "useKeywordDistribution", "locale", "translations", "researchData"];
		const configurationKeys = Object.keys(configuration);

		return {
			readability: (0, _lodashEs$2.isNull)(contentAssessor) || (0, _includesAny2.default)(configurationKeys, readability),
			seo: (0, _lodashEs$2.isNull)(seoAssessor) || (0, _includesAny2.default)(configurationKeys, seo)
		};
	}

	/**
  * Configures the analysis worker.
  *
  * @param {number}   id                                     The request id.
  * @param {Object}   configuration                          The configuration object.
  * @param {boolean}  [configuration.contentAnalysisActive]  Whether the content analysis is active.
  * @param {boolean}  [configuration.keywordAnalysisActive]  Whether the keyword analysis is active.
  * @param {boolean}  [configuration.useCornerstone]         Whether the paper is cornerstone or not.
  * @param {boolean}  [configuration.useTaxonomy]            Whether the taxonomy assessor should be used.
  * @param {boolean}  [configuration.useKeywordDistribution] Whether the keyphraseDistribution assessment should run.
  * @param {string}   [configuration.locale]                 The locale used in the seo assessor.
  * @param {Object}   [configuration.translations]           The translation strings.
  * @param {Object}   [configuration.researchData]           Extra research data.
  * @param {Object}   [configuration.defaultQueryParams]     The default query params for the Shortlinker.
  * @param {string}   [configuration.logLevel]               Log level, see: https://github.com/pimterry/loglevel#documentation
  * @param {string[]} [configuration.enabledFeatures]        A list of feature name flags of the experimental features to enable.
  *
  * @returns {void}
  */
	initialize(id, configuration) {
		const update = AnalysisWebWorker.shouldAssessorsUpdate(configuration, this._contentAssessor, this._seoAssessor);

		if ((0, _lodashEs$2.has)(configuration, "translations")) {
			this._i18n = AnalysisWebWorker.createI18n(configuration.translations);
			delete configuration.translations;
		}

		if ((0, _lodashEs$2.has)(configuration, "researchData")) {
			(0, _lodashEs$2.forEach)(configuration.researchData, (data, research) => {
				this._researcher.addResearchData(research, data);
			});
			delete configuration.researchData;
		}

		if ((0, _lodashEs$2.has)(configuration, "defaultQueryParams")) {
			(0, _shortlinker.configureShortlinker)({ params: configuration.defaultQueryParams });
			delete configuration.defaultQueryParams;
		}

		if ((0, _lodashEs$2.has)(configuration, "logLevel")) {
			logger.setLevel(configuration.logLevel, false);
			delete configuration.logLevel;
		}

		if ((0, _lodashEs$2.has)(configuration, "enabledFeatures")) {
			// Make feature flags available inside of the web worker.
			(0, _featureFlag.enableFeatures)(configuration.enabledFeatures);
			delete configuration.enabledFeatures;
		}

		this._configuration = (0, _lodashEs$2.merge)(this._configuration, configuration);

		if (update.readability) {
			this._contentAssessor = this.createContentAssessor();
			/*
    * Disabled code:
    * this._contentTreeAssessor = constructReadabilityAssessor( this._i18n, this._treeResearcher, configuration.useCornerstone );
    */
			this._contentTreeAssessor = null;
		}
		if (update.seo) {
			this._seoAssessor = this.createSEOAssessor();
			this._relatedKeywordAssessor = this.createRelatedKeywordsAssessor();
			// Tree assessors
			/*
    * Disabled code:
    * const { useCornerstone, useTaxonomy } = this._configuration;
    * this._seoTreeAssessor = useTaxonomy
    * 	? this.createSEOTreeAssessor( { taxonomy: true } )
    * 	: this.createSEOTreeAssessor( { cornerstone: useCornerstone } );
    * this._relatedKeywordTreeAssessor = this.createSEOTreeAssessor( {
    * 	cornerstone: useCornerstone, relatedKeyphrase: true,
    * } );
    */
		}

		// Reset the paper in order to not use the cached results on analyze.
		this.clearCache();

		this.send("initialize:done", id);
	}

	/**
  * Register an assessment for a specific plugin.
  *
  * @param {string}   name       The name of the assessment.
  * @param {function} assessment The function to run as an assessment.
  * @param {string}   pluginName The name of the plugin associated with the assessment.
  *
  * @returns {boolean} Whether registering the assessment was successful.
  */
	registerAssessment(name, assessment, pluginName) {
		if (!(0, _lodashEs$2.isString)(name)) {
			throw new _invalidType2.default("Failed to register assessment for plugin " + pluginName + ". Expected parameter `name` to be a string.");
		}

		if (!(0, _lodashEs$2.isObject)(assessment)) {
			throw new _invalidType2.default("Failed to register assessment for plugin " + pluginName + ". Expected parameter `assessment` to be a function.");
		}

		if (!(0, _lodashEs$2.isString)(pluginName)) {
			throw new _invalidType2.default("Failed to register assessment for plugin " + pluginName + ". Expected parameter `pluginName` to be a string.");
		}

		// Prefix the name with the pluginName so the test name is always unique.
		const combinedName = pluginName + "-" + name;

		if (this._seoAssessor !== null) {
			this._seoAssessor.addAssessment(combinedName, assessment);
		}
		this._registeredAssessments.push({ combinedName, assessment });

		this.refreshAssessment(name, pluginName);

		return true;
	}

	/**
  * Register a message handler for a specific plugin.
  *
  * @param {string}   name       The name of the message handler.
  * @param {function} handler    The function to run as an message handler.
  * @param {string}   pluginName The name of the plugin associated with the message handler.
  *
  * @returns {boolean} Whether registering the message handler was successful.
  */
	registerMessageHandler(name, handler, pluginName) {
		if (!(0, _lodashEs$2.isString)(name)) {
			throw new _invalidType2.default("Failed to register handler for plugin " + pluginName + ". Expected parameter `name` to be a string.");
		}

		if (!(0, _lodashEs$2.isObject)(handler)) {
			throw new _invalidType2.default("Failed to register handler for plugin " + pluginName + ". Expected parameter `handler` to be a function.");
		}

		if (!(0, _lodashEs$2.isString)(pluginName)) {
			throw new _invalidType2.default("Failed to register handler for plugin " + pluginName + ". Expected parameter `pluginName` to be a string.");
		}

		// Prefix the name with the pluginName so the test name is always unique.
		name = pluginName + "-" + name;

		this._registeredMessageHandlers[name] = handler;
	}

	/**
  * Refreshes an assessment in the analysis.
  *
  * Custom assessments can use this to mark their assessment as needing a
  * refresh.
  *
  * @param {string} name The name of the assessment.
  * @param {string} pluginName The name of the plugin associated with the assessment.
  *
  * @returns {boolean} Whether refreshing the assessment was successful.
  */
	refreshAssessment(name, pluginName) {
		if (!(0, _lodashEs$2.isString)(name)) {
			throw new _invalidType2.default("Failed to refresh assessment for plugin " + pluginName + ". Expected parameter `name` to be a string.");
		}

		if (!(0, _lodashEs$2.isString)(pluginName)) {
			throw new _invalidType2.default("Failed to refresh assessment for plugin " + pluginName + ". Expected parameter `pluginName` to be a string.");
		}

		this.clearCache();
	}

	/**
  * Register a parser that parses a formatted text
  * to a structured tree representation that can be further analyzed.
  *
  * @param {Object}   parser                              The parser to register.
  * @param {function(Paper): boolean} parser.isApplicable A method that checks whether this parser is applicable for a paper.
  * @param {function(Paper): module:parsedPaper/structure.Node } parser.parse A method that parses a paper to a structured tree representation.
  *
  * @returns {void}
  */
	registerParser(parser) {
		if (typeof parser.isApplicable !== "function") {
			throw new _invalidType2.default("Failed to register the custom parser. Expected parameter 'parser' to have a method 'isApplicable'.");
		}
		if (typeof parser.parse !== "function") {
			throw new _invalidType2.default("Failed to register the custom parser. Expected parameter 'parser' to have a method 'parse'.");
		}

		this._registeredParsers.push(parser);
	}

	/**
  * Clears the worker cache to force a new analysis.
  *
  * @returns {void}
  */
	clearCache() {
		this._paper = null;
	}

	/**
  * Changes the locale in the configuration.
  *
  * If the locale is different:
  * - Update the configuration locale.
  * - Create the content assessor.
  *
  * @param {string} locale The locale to set.
  *
  * @returns {void}
  */
	setLocale(locale) {
		if (this._configuration.locale === locale) {
			return;
		}
		this._configuration.locale = locale;
		this._contentAssessor = this.createContentAssessor();
	}

	/**
  * Checks if the paper contains changes that are used for readability.
  *
  * @param {Paper} paper The paper to check against the cached paper.
  *
  * @returns {boolean} True if there are changes detected.
  */
	shouldReadabilityUpdate(paper) {
		if (this._paper === null) {
			return true;
		}

		if (this._paper.getText() !== paper.getText()) {
			return true;
		}

		return this._paper.getLocale() !== paper.getLocale();
	}

	/**
  * Checks if the related keyword contains changes that are used for seo.
  *
  * @param {string} key                     The identifier of the related keyword.
  * @param {Object} relatedKeyword          The related keyword object.
  * @param {string} relatedKeyword.keyword  The keyword.
  * @param {string} relatedKeyword.synonyms The synonyms.
  *
  * @returns {boolean} True if there are changes detected.
  */
	shouldSeoUpdate(key, { keyword, synonyms }) {
		if ((0, _lodashEs$2.isUndefined)(this._relatedKeywords[key])) {
			return true;
		}

		if (this._relatedKeywords[key].keyword !== keyword) {
			return true;
		}

		return this._relatedKeywords[key].synonyms !== synonyms;
	}

	/**
  * Runs analyses on a paper.
  *
  * The paper includes the keyword and synonyms data. However, this is
  * possibly just one instance of these. From here we are going to split up
  * this data and keep track of the different sets of keyword-synonyms and
  * their results.
  *
  * @param {number} id                        The request id.
  * @param {Object} payload                   The payload object.
  * @param {Object} payload.paper             The paper to analyze.
  * @param {Object} [payload.relatedKeywords] The related keywords.
  *
  * @returns {Object} The result, may not contain readability or seo.
  */
	async analyze(id, { paper, relatedKeywords = {} }) {
		// Automatically add paragraph tags, like Wordpress does, on blocks padded by double newlines or html elements.
		paper._text = (0, _autop.autop)(paper._text);
		paper._text = string.removeHtmlBlocks(paper._text);
		const paperHasChanges = this._paper === null || !this._paper.equals(paper);
		const shouldReadabilityUpdate = this.shouldReadabilityUpdate(paper);

		// Only set the paper and build the tree if the paper has any changes.
		if (paperHasChanges) {
			this._paper = paper;
			this._researcher.setPaper(this._paper);

			// Update the configuration locale to the paper locale.
			this.setLocale(this._paper.getLocale());
		}

		if (this._configuration.keywordAnalysisActive && this._seoAssessor) {
			// Only assess the focus keyphrase if the paper has any changes.
			if (paperHasChanges) {
				// Assess the SEO of the content regarding the main keyphrase.
				this._results.seo[""] = await this.assess(this._paper, this._tree, {
					oldAssessor: this._seoAssessor,
					treeAssessor: this._seoTreeAssessor,
					scoreAggregator: this._seoScoreAggregator
				});
			}

			// Only assess the related keyphrases when they have been given.
			if (!(0, _lodashEs$2.isEmpty)(relatedKeywords)) {
				// Get the related keyphrase keys (one for each keyphrase).
				const requestedRelatedKeywordKeys = Object.keys(relatedKeywords);

				// Analyze the SEO for each related keyphrase and wait for the results.
				const relatedKeyphraseResults = await this.assessRelatedKeywords(paper, this._tree, relatedKeywords);

				// Put the related keyphrase results on the SEO results, under the right key.
				relatedKeyphraseResults.forEach(result => {
					this._results.seo[result.key] = result.results;
				});

				// Clear the unrequested results, but only if there are requested related keywords.
				if (requestedRelatedKeywordKeys.length > 1) {
					this._results.seo = (0, _lodashEs$2.pickBy)(this._results.seo, (relatedKeyword, key) => (0, _lodashEs$2.includes)(requestedRelatedKeywordKeys, key));
				}
			}
		}

		if (this._configuration.contentAnalysisActive && this._contentAssessor && shouldReadabilityUpdate) {
			const analysisCombination = {
				oldAssessor: this._contentAssessor,
				treeAssessor: this._contentTreeAssessor,
				scoreAggregator: this._contentScoreAggregator
			};
			// Set the locale (we are more lenient for languages that have full analysis support).
			analysisCombination.scoreAggregator.setLocale(this._configuration.locale);
			this._results.readability = await this.assess(this._paper, this._tree, analysisCombination);
		}

		return this._results;
	}

	/**
  * Assesses a given paper and tree combination
  * using an original Assessor (that works on a string representation of the text)
  * and a new Tree Assessor (that works on a tree representation).
  *
  * The results of both analyses are combined using the given score aggregator.
  *
  * @param {Paper}                      paper The paper to analyze.
  * @param {module:parsedPaper/structure.Node} tree  The tree to analyze.
  *
  * @param {Object}                             analysisCombination                 Which assessors and score aggregator to use.
  * @param {Assessor}                           analysisCombination.oldAssessor     The original assessor.
  * @param {module:parsedPaper/assess.TreeAssessor}    analysisCombination.treeAssessor    The new assessor.
  * @param {module:parsedPaper/assess.ScoreAggregator} analysisCombination.scoreAggregator The score aggregator to use.
  *
  * @returns {Promise<{score: number, results: AssessmentResult[]}>} The analysis results.
  */
	async assess(paper, tree, analysisCombination) {
		// Disabled code: The variable `treeAssessor` is removed from here.
		const oldAssessor = analysisCombination.oldAssessor,
		      scoreAggregator = analysisCombination.scoreAggregator;
		/*
   * Assess the paper and the tree
   * using the original assessor and the tree assessor.
   */

		oldAssessor.assess(paper);
		const oldAssessmentResults = oldAssessor.results;

		const treeAssessmentResults = [];

		/*
   * Disable code:
   * // Only assess tree if it has been built.
   * if ( tree ) {
   * const treeAssessorResult = await treeAssessor.assess( paper, tree );
   * treeAssessmentResults = treeAssessorResult.results;
   * } else {
   * // Cannot assess the tree, generate errors on the assessments that use the tree assessor.
   * const treeAssessments = treeAssessor.getAssessments();
   * treeAssessmentResults = treeAssessments.map( assessment => this.generateAssessmentError( assessment ) );
   * }
   */

		// Combine the results of the tree assessor and old assessor.
		const results = [...treeAssessmentResults, ...oldAssessmentResults];

		// Aggregate the results.
		const score = scoreAggregator.aggregate(results);

		return {
			results: results,
			score: score
		};
	}

	/**
  * Generates an error message ("grey bullet") for the given assessment.
  *
  * @param {module:parsedPaper/assess.Assessment} assessment The assessment to generate an error message for.
  *
  * @returns {AssessmentResult} The generated assessment result.
  */
	generateAssessmentError(assessment) {
		const result = new _AssessmentResult2.default();

		result.setScore(-1);
		result.setText(this._i18n.sprintf(
		/* Translators: %1$s expands to the name of the assessment. */
		this._i18n.dgettext("js-text-analysis", "An error occurred in the '%1$s' assessment"), assessment.name));

		return result;
	}

	/**
  * Assesses the SEO of a paper and tree combination on the given related keyphrases and their synonyms.
  *
  * The old assessor as well as the new tree assessor are used and their results are combined.
  *
  * @param {Paper}                 paper           The paper to analyze.
  * @param {module:parsedPaper/structure} tree            The tree to analyze.
  * @param {Object}                relatedKeywords The related keyphrases to use in the analysis.
  *
  * @returns {Promise<[{results: {score: number, results: AssessmentResult[]}, key: string}]>} The results, one for each keyphrase.
  */
	async assessRelatedKeywords(paper, tree, relatedKeywords) {
		const keywordKeys = Object.keys(relatedKeywords);
		return await Promise.all(keywordKeys.map(key => {
			this._relatedKeywords[key] = relatedKeywords[key];

			const relatedPaper = _Paper2$1.default.parse(_extends({}, paper.serialize(), {
				keyword: this._relatedKeywords[key].keyword,
				synonyms: this._relatedKeywords[key].synonyms
			}));

			// Which combination of (tree) assessors and score aggregator to use.
			const analysisCombination = {
				oldAssessor: this._relatedKeywordAssessor,
				treeAssessor: this._relatedKeywordTreeAssessor,
				scoreAggregator: this._seoScoreAggregator
			};

			// We need to remember the key, since the SEO results are stored in an object, not an array.
			return this.assess(relatedPaper, tree, analysisCombination).then(results => ({ key: key, results: results }));
		}));
	}

	/**
  * Loads a new script from an external source.
  *
  * @param {number} id  The request id.
  * @param {string} url The url of the script to load;
  *
  * @returns {Object} An object containing whether or not the url was loaded, the url and possibly an error message.
  */
	loadScript(id, { url }) {
		if ((0, _lodashEs$2.isUndefined)(url)) {
			return { loaded: false, url, message: "Load Script was called without an URL." };
		}

		try {
			this._scope.importScripts(url);
		} catch (error) {
			return { loaded: false, url, message: error.message };
		}

		return { loaded: true, url };
	}

	/**
  * Sends the load script result back.
  *
  * @param {number} id     The request id.
  * @param {Object} result The result.
  *
  * @returns {void}
  */
	loadScriptDone(id, result) {
		if (!result.loaded) {
			this.send("loadScript:failed", id, result);
			return;
		}

		this.send("loadScript:done", id, result);
	}

	/**
  * Sends the analyze result back.
  *
  * @param {number} id     The request id.
  * @param {Object} result The result.
  *
  * @returns {void}
  */
	analyzeDone(id, result) {
		if (result.error) {
			this.send("analyze:failed", id, result);
			return;
		}
		this.send("analyze:done", id, result);
	}

	/**
  * Sends the analyze related keywords result back.
  *
  * @param {number} id     The request id.
  * @param {Object} result The result.
  *
  * @returns {void}
  */
	analyzeRelatedKeywordsDone(id, result) {
		if (result.error) {
			this.send("analyzeRelatedKeywords:failed", id, result);
			return;
		}
		this.send("analyzeRelatedKeywords:done", id, result);
	}

	/**
  * Handle a custom message using the registered handler.
  *
  * @param {number} id   The request id.
  * @param {string} name The name of the message.
  * @param {Object} data The data of the message.
  *
  * @returns {Object} An object containing either success and data or an error.
  */
	customMessage(id, { name, data }) {
		try {
			return {
				success: true,
				data: this._registeredMessageHandlers[name](data)
			};
		} catch (error) {
			return { error };
		}
	}

	/**
  * Send the result of a custom message back.
  *
  * @param {number} id     The request id.
  * @param {Object} result The result.
  *
  * @returns {void}
  */
	customMessageDone(id, result) {
		if (result.success) {
			this.send("customMessage:done", id, result.data);
			return;
		}
		this.send("customMessage:failed", result.error);
	}

	/**
  * Runs the specified research in the worker. Optionally pass a paper.
  *
  * @param {number} id     The request id.
  * @param {string} name   The name of the research to run.
  * @param {Paper} [paper] The paper to run the research on if it shouldn't
  *                        be run on the latest paper.
  *
  * @returns {Object} The result of the research.
  */
	runResearch(id, { name, paper = null }) {
		// Save morphology data if it is available in the current researcher.
		const morphologyData = this._researcher.getData("morphology");

		let researcher = this._researcher;
		// When a specific paper is passed we create a temporary new researcher.
		if (paper !== null) {
			researcher = new _researcher2$1.default(paper);
			researcher.addResearchData("morphology", morphologyData);
		}

		return researcher.getResearch(name);
	}

	/**
  * Send the result of a custom message back.
  *
  * @param {number} id     The request id.
  * @param {Object} result The result.
  *
  * @returns {void}
  */
	runResearchDone(id, result) {
		if (result.error) {
			this.send("runResearch:failed", id, result);
			return;
		}
		this.send("runResearch:done", id, result);
	}
}
AnalysisWebWorker$1.default = AnalysisWebWorker;

var AnalysisWorkerWrapper$1 = {};

var request = {};

var Request$1 = {};

var Result$1 = {};

Object.defineProperty(Result$1, "__esModule", {
	value: true
});
/**
 * Result serves as data structure for the AnalysisWorkerWrapper request result.
 */
class Result {
	/**
  * Initializes a result.
  *
  * @param {Object} result The result.
  * @param {Object} [data] Optional extra data.
  */
	constructor(result, data = {}) {
		this.result = result;
		this.data = data;
	}
}
Result$1.default = Result;

Object.defineProperty(Request$1, "__esModule", {
	value: true
});

var _Result = Result$1;

var _Result2 = _interopRequireDefault$5(_Result);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Request serves as helper for the AnalysisWorkerWrapper.
 *
 * It holds the resolve and reject functions that it needs to fulfill the
 * promise. Any optional data will get included in the Result it can generate.
 */
class Request {
	/**
  * Initializes a request.
  *
  * @param {Function} resolve The resolve function.
  * @param {Function} reject  The reject function.
  * @param {Object}  [data]   Optional extra data.
  */
	constructor(resolve, reject, data = {}) {
		this._resolve = resolve;
		this._reject = reject;
		this._data = data;
	}

	/**
  * Resolves the request with a result.
  *
  * @param {Object} [payload] Optional payload.
  *
  * @returns {void}
  */
	resolve(payload = {}) {
		const result = new _Result2.default(payload, this._data);
		this._resolve(result);
	}

	/**
  * Rejects the request with a result.
  *
  * @param {Object} [payload] Optional payload.
  *
  * @returns {void}
  */
	reject(payload = {}) {
		const result = new _Result2.default(payload, this._data);
		this._reject(result);
	}
}
Request$1.default = Request;

Object.defineProperty(request, "__esModule", {
  value: true
});

var _Request = Request$1;

var _Request2 = _interopRequireDefault$4(_Request);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

request.default = _Request2.default;

Object.defineProperty(AnalysisWorkerWrapper$1, "__esModule", {
	value: true
});

var _request = request;

var _request2 = _interopRequireDefault$3(_request);

var _transporter = transporter;

var _transporter2 = _interopRequireDefault$3(_transporter);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Analysis worker is an API around the Web Worker.
 */
// Internal dependencies.
class AnalysisWorkerWrapper {
	/**
  * Initializes the AnalysisWorkerWrapper class.
  *
  * @param {Worker} worker The worker to wrap.
  *
  * @constructor
  */
	constructor(worker) {
		// Initialize instance variables.
		this._worker = worker;
		this._requests = {};
		this._autoIncrementedRequestId = -1;

		// Bind actions to this scope.
		this.initialize = this.initialize.bind(this);
		this.analyze = this.analyze.bind(this);
		this.analyzeRelatedKeywords = this.analyzeRelatedKeywords.bind(this);
		this.loadScript = this.loadScript.bind(this);
		this.sendMessage = this.sendMessage.bind(this);
		this.runResearch = this.runResearch.bind(this);

		// Bind event handlers to this scope.
		this.handleMessage = this.handleMessage.bind(this);
		this.handleMessageError = this.handleMessageError.bind(this);
		this.handleError = this.handleError.bind(this);

		// Initialize the worker event handlers.
		this._worker.onmessage = this.handleMessage;
		this._worker.onmessageerror = this.handleMessageError;
		this._worker.onerror = this.handleError;
	}

	/**
  * Receives the messages and determines the action.
  *
  * See: https://developer.mozilla.org/en-US/docs/Web/API/Worker/onmessage
  *
  * @param {MessageEvent} event              The post message event.
  * @param {Object}       event.data         The data object.
  * @param {string}       event.data.type    The action type.
  * @param {number}       event.data.id      The request id.
  * @param {string}       event.data.payload The payload of the action.
  *
  * @returns {void}
  */
	handleMessage({ data: { type, id, payload } }) {
		const request = this._requests[id];
		if (!request) {
			console.warn("AnalysisWebWorker unmatched response:", payload);
			return;
		}

		payload = _transporter2.default.parse(payload);

		switch (type) {
			case "initialize:done":
			case "loadScript:done":
			case "customMessage:done":
			case "runResearch:done":
			case "analyzeRelatedKeywords:done":
			case "analyze:done":
				request.resolve(payload);
				break;
			case "analyze:failed":
			case "loadScript:failed":
			case "customMessage:failed":
			case "runResearch:failed":
			case "analyzeRelatedKeywords:failed":
				request.reject(payload);
				break;
			default:
				console.warn("AnalysisWebWorker unrecognized action:", type);
		}

		// Remove the handled request from our queue.
		delete this._requests[id];
	}

	/**
  * Receives the message errors.
  *
  * See: https://developer.mozilla.org/en-US/docs/Web/Events/messageerror
  *
  * @param {MessageEvent} event The message event for the error that
  *                             occurred.
  *
  * @returns {void}
  */
	handleMessageError(event) {
		console.warn("AnalysisWebWorker message error:", event);
	}

	/**
  * Receives the errors.
  *
  * See:
  * https://developer.mozilla.org/en-US/docs/Web/API/AbstractWorker/onerror
  *
  * @param {Error} event The error event.
  *
  * @returns {void}
  */
	handleError(event) {
		/*
   * Try to get the last request. This might not perfectly match the request error.
   * However, that is not as bad as not being able to reject it like this.
   *
   * This is not the _autoIncrementedRequestId because that might be a
   * request that is handled already. Instead the last object key is used.
   */
		const requestKeys = Object.keys(this._requests);
		const lastRequestId = requestKeys[requestKeys.length - 1];
		const lastRequest = this._requests[lastRequestId];
		if (!lastRequest) {
			console.error("AnalysisWebWorker error:", event);
			return;
		}
		lastRequest.reject(event);
	}

	/**
  * Increments the request id.
  *
  * @returns {number} The incremented id.
  */
	createRequestId() {
		this._autoIncrementedRequestId++;
		return this._autoIncrementedRequestId;
	}

	/**
  * Creates a new request inside a Promise.
  *
  * @param {number} id     The request id.
  * @param {Object} [data] Optional extra data.
  *
  * @returns {Promise} The callback promise.
  */
	createRequestPromise(id, data = {}) {
		return new Promise((resolve, reject) => {
			this._requests[id] = new _request2.default(resolve, reject, data);
		});
	}

	/**
  * Sends a request to the worker and returns a promise that will resolve or reject once the worker finishes.
  *
  * @param {string} action  The action of the request.
  * @param {Object} payload The payload of the request.
  * @param {Object} [data]  Optional extra data.
  *
  * @returns {Promise} A promise that will resolve or reject once the worker finishes.
  */
	sendRequest(action, payload, data = {}) {
		const id = this.createRequestId();
		const promise = this.createRequestPromise(id, data);

		this.send(action, id, payload);
		return promise;
	}

	/**
  * Sends a message to the worker.
  *
  * @param {string} type      The message type.
  * @param {number} id        The request id.
  * @param {Object} [payload] The payload to deliver.
  *
  * @returns {void}
  */
	send(type, id, payload = {}) {
		payload = _transporter2.default.serialize(payload);

		this._worker.postMessage({
			type,
			id,
			payload
		});
	}

	/**
  * Initializes the worker with a configuration.
  *
  * @param {Object} configuration The configuration to initialize the worker
  *                               with.
  *
  * @returns {Promise} The promise of initialization.
  */
	initialize(configuration) {
		return this.sendRequest("initialize", configuration);
	}

	/**
  * Analyzes the paper.
  *
  * @param {Object} paper           The paper to analyze.
  * @param {Object} relatedKeywords The related keywords.
  *
  * @returns {Promise} The promise of analyses.
  */
	analyzeRelatedKeywords(paper, relatedKeywords = {}) {
		return this.sendRequest("analyzeRelatedKeywords", { paper, relatedKeywords });
	}

	/**
  * Analyzes the paper.
  *
  * @param {Object} paper           The paper to analyze.
  *
  * @returns {Promise} The promise of analyses.
  */
	analyze(paper) {
		return this.sendRequest("analyze", { paper });
	}

	/**
  * Imports a script to the worker.
  *
  * @param {string} url The relative url to the script to be loaded.
  *
  * @returns {Promise} The promise of the script import.
  */
	loadScript(url) {
		return this.sendRequest("loadScript", { url });
	}

	/**
  * Sends a custom message to the worker.
  *
  * @param {string} name       The name of the message.
  * @param {string} data       The data of the message.
  * @param {string} pluginName The plugin that registered this type of message.
  *
  * @returns {Promise} The promise of the custom message.
  */
	sendMessage(name, data, pluginName) {
		name = pluginName + "-" + name;
		return this.sendRequest("customMessage", { name, data }, data);
	}

	/**
  * Runs the specified research in the worker. Optionally pass a paper.
  *
  * @param {string} name    The name of the research to run.
  * @param {Paper} [paper] The paper to run the research on if it shouldn't
  *                         be run on the latest paper.
  *
  * @returns {Promise} The promise of the research.
  */
	runResearch(name, paper = null) {
		return this.sendRequest("runResearch", { name, paper });
	}
}

AnalysisWorkerWrapper$1.default = AnalysisWorkerWrapper;

var createWorker$1 = {};

Object.defineProperty(createWorker$1, "__esModule", {
	value: true
});
/**
 * Creates a try catch for a web worker around a script.
 *
 * @param {string} originalScript The script to put a try-catch around.
 * @returns {string} The new script including a try-catch.
 */
function createExceptionHandler(originalScript) {
	return `
		try {
			${originalScript}
		} catch ( error ) {
			console.log( "Error occured during worker initialization:" );
			console.log( error );
		}
	`;
}

/**
 * Creates the script to run inside the fallback web worker.
 *
 * @param {string} url The URL for which to create a script.
 * @returns {string} A script that can be run inside a worker as a blob.
 */
function createBlobScript(url) {
	return `
		self.yoastOriginalUrl = '${url}';
		importScripts('${url}');
	`;
}

/**
 * Determines whether or not two URLs have the same origin.
 *
 * @param {string} urlA First URL to test.
 * @param {string} urlB Second URL to test.
 *
 * @returns {boolean} Whether the URLs have the same origin.
 */
function isSameOrigin(urlA, urlB) {
	urlA = new URL(urlA, window.location.origin);
	urlB = new URL(urlB, window.location.origin);

	return urlA.hostname === urlB.hostname && urlA.port === urlB.port && urlA.protocol === urlB.protocol;
}

/**
 * Creates an URL to a blob. This blob imports a script for use in a web worker (using `importScripts`).
 *
 * @param {string} url The URL to the script that has to be loaded.
 * @returns {string} the URL to the blob.
 */
function createBlobURL(url) {
	const URL = window.URL || window.webkitURL;
	const BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder;

	const blobScript = createExceptionHandler(createBlobScript(url));

	let blob;
	try {
		blob = new Blob([blobScript], { type: "application/javascript" });
	} catch (e1) {
		const blobBuilder = new BlobBuilder();
		blobBuilder.append(blobScript);
		blob = blobBuilder.getBlob("application/javascript");
	}
	return URL.createObjectURL(blob);
}

/**
 * Creates a worker fallback using the blob URL method.
 *
 * @param {string} url The URL to create a worker for.
 * @returns {Worker} The web worker.
 */
function createWorkerFallback(url) {
	const blobUrl = createBlobURL(url);

	return new Worker(blobUrl);
}

/**
 * Creates a WebWorker using the given url.
 *
 * @param {string} url The url of the worker.
 *
 * @returns {Worker} The worker.
 */
function createWorker(url) {
	// If we are not on the same domain, we require a fallback worker.
	if (!isSameOrigin(window.location, url)) {
		return createWorkerFallback(url);
	}

	let worker = null;
	try {
		worker = new Worker(url);
	} catch (e) {
		try {
			worker = createWorkerFallback(url);
		} catch (e2) {
			throw e2;
		}
	}
	return worker;
}

createWorker$1.default = createWorker;

Object.defineProperty(worker, "__esModule", {
	value: true
});
worker.createWorker = worker.AnalysisWorkerWrapper = worker.AnalysisWebWorker = undefined;

var _AnalysisWebWorker = AnalysisWebWorker$1;

var _AnalysisWebWorker2 = _interopRequireDefault$2(_AnalysisWebWorker);

var _AnalysisWorkerWrapper = AnalysisWorkerWrapper$1;

var _AnalysisWorkerWrapper2 = _interopRequireDefault$2(_AnalysisWorkerWrapper);

var _createWorker = createWorker$1;

var _createWorker2 = _interopRequireDefault$2(_createWorker);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

worker.AnalysisWebWorker = _AnalysisWebWorker2.default;
worker.AnalysisWorkerWrapper = _AnalysisWorkerWrapper2.default;
worker.createWorker = _createWorker2.default;

var app = {};

var AssessorPresenter$1 = {};

Object.defineProperty(AssessorPresenter$1, "__esModule", {
  value: true
});

var _lodashEs$1 = require$$1$1;

var _templates = templates.exports;

var _scoreToRating = scoreToRating$3;

var _scoreToRating2 = _interopRequireDefault$1(_scoreToRating);

var _presenter = presenter;

var _presenter2 = _interopRequireDefault$1(_presenter);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Constructs the AssessorPresenter.
 *
 * @param {Object} args A list of arguments to use in the presenter.
 * @param {object} args.targets The HTML elements to render the output to.
 * @param {string} args.targets.output The HTML element to render the individual ratings out to.
 * @param {string} args.targets.overall The HTML element to render the overall rating out to.
 * @param {string} args.keyword The keyword to use for checking, when calculating the overall rating.
 * @param {SEOAssessor} args.assessor The Assessor object to retrieve assessment results from.
 * @param {Jed} args.i18n The translation object.
 *
 * @constructor
 */
var AssessorPresenter = function AssessorPresenter(args) {
  this.keyword = args.keyword;
  this.assessor = args.assessor;
  this.i18n = args.i18n;
  this.output = args.targets.output;
  this.overall = args.targets.overall || "overallScore";
  this.presenterConfig = (0, _presenter2.default)(args.i18n);

  this._disableMarkerButtons = false;

  this._activeMarker = false;
};

/**
 * Sets the keyword.
 *
 * @param {string} keyword The keyword to use.
 * @returns {void}
 */
AssessorPresenter.prototype.setKeyword = function (keyword) {
  this.keyword = keyword;
};

/**
 * Checks whether or not a specific property exists in the presenter configuration.
 *
 * @param {string} property The property name to search for.
 * @returns {boolean} Whether or not the property exists.
 */
AssessorPresenter.prototype.configHasProperty = function (property) {
  return this.presenterConfig.hasOwnProperty(property);
};

/**
 * Gets a fully formatted indicator object that can be used.
 *
 * @param {string} rating The rating to use.
 * @returns {Object} An object containing the class, the screen reader text, and the full text.
 */
AssessorPresenter.prototype.getIndicator = function (rating) {
  return {
    className: this.getIndicatorColorClass(rating),
    screenReaderText: this.getIndicatorScreenReaderText(rating),
    fullText: this.getIndicatorFullText(rating),
    screenReaderReadabilityText: this.getIndicatorScreenReaderReadabilityText(rating)
  };
};

/**
 * Gets the indicator color class from the presenter configuration, if it exists.
 *
 * @param {string} rating The rating to check against the config.
 * @returns {string} String containing the CSS class to be used.
 */
AssessorPresenter.prototype.getIndicatorColorClass = function (rating) {
  if (!this.configHasProperty(rating)) {
    return "";
  }

  return this.presenterConfig[rating].className;
};

/**
 * Get the indicator screen reader text from the presenter configuration, if it exists.
 *
 * @param {string} rating The rating to check against the config.
 * @returns {string} Translated string containing the screen reader text to be used.
 */
AssessorPresenter.prototype.getIndicatorScreenReaderText = function (rating) {
  if (!this.configHasProperty(rating)) {
    return "";
  }

  return this.presenterConfig[rating].screenReaderText;
};

/**
 * Get the indicator screen reader readability text from the presenter configuration, if it exists.
 *
 * @param {string} rating The rating to check against the config.
 * @returns {string} Translated string containing the screen reader readability text to be used.
 */
AssessorPresenter.prototype.getIndicatorScreenReaderReadabilityText = function (rating) {
  if (!this.configHasProperty(rating)) {
    return "";
  }

  return this.presenterConfig[rating].screenReaderReadabilityText;
};

/**
 * Get the indicator full text from the presenter configuration, if it exists.
 *
 * @param {string} rating The rating to check against the config.
 * @returns {string} Translated string containing the full text to be used.
 */
AssessorPresenter.prototype.getIndicatorFullText = function (rating) {
  if (!this.configHasProperty(rating)) {
    return "";
  }

  return this.presenterConfig[rating].fullText;
};

/**
 * Adds a rating based on the numeric score.
 *
 * @param {Object} result Object based on the Assessment result. Requires a score property to work.
 * @returns {Object} The Assessment result object with the rating added.
 */
AssessorPresenter.prototype.resultToRating = function (result) {
  if (!(0, _lodashEs$1.isObject)(result)) {
    return "";
  }

  result.rating = (0, _scoreToRating2.default)(result.score);

  return result;
};

/**
 * Takes the individual assessment results, sorts and rates them.
 *
 * @returns {Object} Object containing all the individual ratings.
 */
AssessorPresenter.prototype.getIndividualRatings = function () {
  var ratings = {};
  var validResults = this.sort(this.assessor.getValidResults());
  var mappedResults = validResults.map(this.resultToRating);

  (0, _lodashEs$1.forEach)(mappedResults, function (item, key) {
    ratings[key] = this.addRating(item);
  }.bind(this));

  return ratings;
};

/**
 * Excludes items from the results that are present in the exclude array.
 *
 * @param {Array} results Array containing the items to filter through.
 * @param {Array} exclude Array of results to exclude.
 * @returns {Array} Array containing items that remain after exclusion.
 */
AssessorPresenter.prototype.excludeFromResults = function (results, exclude) {
  return (0, _lodashEs$1.difference)(results, exclude);
};

/**
 * Sorts results based on their score property and always places items considered to be unsortable, at the top.
 *
 * @param {Array} results Array containing the results that need to be sorted.
 * @returns {Array} Array containing the sorted results.
 */
AssessorPresenter.prototype.sort = function (results) {
  var unsortables = this.getUndefinedScores(results);
  var sortables = this.excludeFromResults(results, unsortables);

  sortables.sort(function (a, b) {
    return a.score - b.score;
  });

  return unsortables.concat(sortables);
};

/**
 * Returns a subset of results that have an undefined score or a score set to zero.
 *
 * @param {Array} results The results to filter through.
 * @returns {Array} A subset of results containing items with an undefined score or where the score is zero.
 */
AssessorPresenter.prototype.getUndefinedScores = function (results) {
  return results.filter(function (result) {
    return (0, _lodashEs$1.isUndefined)(result.score) || result.score === 0;
  });
};

/**
 * Creates a rating object based on the item that is being passed.
 *
 * @param {AssessmentResult} item The item to check and create a rating object from.
 * @returns {Object} Object containing a parsed item, including a colored indicator.
 */
AssessorPresenter.prototype.addRating = function (item) {
  var indicator = this.getIndicator(item.rating);
  indicator.text = item.text;
  indicator.identifier = item.getIdentifier();

  if (item.hasMarker()) {
    indicator.marker = item.getMarker();
  }

  return indicator;
};

/**
 * Calculates the overall rating score based on the overall score.
 *
 * @param {Number} overallScore The overall score to use in the calculation.
 * @returns {Object} The rating based on the score.
 */
AssessorPresenter.prototype.getOverallRating = function (overallScore) {
  var rating = 0;

  if (this.keyword === "") {
    return this.resultToRating({ score: rating });
  }

  if ((0, _lodashEs$1.isNumber)(overallScore)) {
    rating = overallScore / 10;
  }

  return this.resultToRating({ score: rating });
};

/**
 * Mark with a given marker. This will set the active marker to the correct value.
 *
 * @param {string} identifier The identifier for the assessment/marker.
 * @param {Function} marker The marker function.
 * @returns {void}
 */
AssessorPresenter.prototype.markAssessment = function (identifier, marker) {
  if (this._activeMarker === identifier) {
    this.removeAllMarks();
    this._activeMarker = false;
  } else {
    marker();
    this._activeMarker = identifier;
  }

  this.render();
};

/**
 * Disables the currently active marker in the UI.
 *
 * @returns {void}
 */
AssessorPresenter.prototype.disableMarker = function () {
  this._activeMarker = false;
  this.render();
};

/**
 * Disables the marker buttons.
 *
 * @returns {void}
 */
AssessorPresenter.prototype.disableMarkerButtons = function () {
  this._disableMarkerButtons = true;
  this.render();
};

/**
 * Enables the marker buttons.
 *
 * @returns {void}
 */
AssessorPresenter.prototype.enableMarkerButtons = function () {
  this._disableMarkerButtons = false;
  this.render();
};

/**
 * Adds an event listener for the marker button
 *
 * @param {string} identifier The identifier for the assessment the marker belongs to.
 * @param {Function} marker The marker function that can mark the assessment in the text.
 * @returns {void}
 */
AssessorPresenter.prototype.addMarkerEventHandler = function (identifier, marker) {
  var container = document.getElementById(this.output);
  var markButton = container.getElementsByClassName("js-assessment-results__mark-" + identifier)[0];

  markButton.addEventListener("click", this.markAssessment.bind(this, identifier, marker));
};

/**
 * Renders out both the individual and the overall ratings.
 *
 * @returns {void}
 */
AssessorPresenter.prototype.render = function () {
  this.renderIndividualRatings();
  this.renderOverallRating();
};

/**
 * Adds event handlers to the mark buttons
 *
 * @param {Array} scores The list of rendered scores.
 *
 * @returns {void}
 */
AssessorPresenter.prototype.bindMarkButtons = function (scores) {
  // Make sure the button works for every score with a marker.
  (0, _lodashEs$1.forEach)(scores, function (score) {
    if (score.hasOwnProperty("marker")) {
      this.addMarkerEventHandler(score.identifier, score.marker);
    }
  }.bind(this));
};

/**
 * Removes all marks currently on the text
 *
 * @returns {void}
 */
AssessorPresenter.prototype.removeAllMarks = function () {
  var marker = this.assessor.getSpecificMarker();

  marker(this.assessor.getPaper(), []);
};

/**
 * Renders out the individual ratings.
 *
 * @returns {void}
 */
AssessorPresenter.prototype.renderIndividualRatings = function () {
  var outputTarget = document.getElementById(this.output);
  var scores = this.getIndividualRatings();

  outputTarget.innerHTML = (0, _templates.assessmentPresenterResult)({
    scores: scores,
    i18n: {
      disabledMarkText: this.i18n.dgettext("js-text-analysis", "Marks are disabled in current view"),
      markInText: this.i18n.dgettext("js-text-analysis", "Mark this result in the text"),
      removeMarksInText: this.i18n.dgettext("js-text-analysis", "Remove marks in the text")
    },
    activeMarker: this._activeMarker,
    markerButtonsDisabled: this._disableMarkerButtons
  });

  this.bindMarkButtons(scores);
};

/**
 * Renders out the overall rating.
 *
 * @returns {void}
 */
AssessorPresenter.prototype.renderOverallRating = function () {
  var overallRating = this.getOverallRating(this.assessor.calculateOverallScore());
  var overallRatingElement = document.getElementById(this.overall);

  if (!overallRatingElement) {
    return;
  }

  overallRatingElement.className = "overallScore " + this.getIndicatorColorClass(overallRating.rating);
};

AssessorPresenter$1.default = AssessorPresenter;

Object.defineProperty(app, "__esModule", {
	value: true
});



var _snippetPreview = snippetPreview;

var _snippetPreview2 = _interopRequireDefault(_snippetPreview);

var _lodashEs = require$$1$1;

var _missingArgument = missingArgument;

var _missingArgument2 = _interopRequireDefault(_missingArgument);

var _jed = jed.exports;

var _jed2 = _interopRequireDefault(_jed);

var _seoAssessor = seoAssessor$1;

var _seoAssessor2 = _interopRequireDefault(_seoAssessor);

var _KeyphraseDistributionAssessment = KeyphraseDistributionAssessment$1;

var _KeyphraseDistributionAssessment2 = _interopRequireDefault(_KeyphraseDistributionAssessment);

var _contentAssessor = contentAssessor$1;

var _contentAssessor2 = _interopRequireDefault(_contentAssessor);

var _seoAssessor3 = seoAssessor;

var _seoAssessor4 = _interopRequireDefault(_seoAssessor3);

var _contentAssessor3 = contentAssessor;

var _contentAssessor4 = _interopRequireDefault(_contentAssessor3);

var _researcher = researcher;

var _researcher2 = _interopRequireDefault(_researcher);

var _AssessorPresenter = AssessorPresenter$1;

var _AssessorPresenter2 = _interopRequireDefault(_AssessorPresenter);

var _pluggable = pluggable;

var _pluggable2 = _interopRequireDefault(_pluggable);

var _Paper = Paper$1;

var _Paper2 = _interopRequireDefault(_Paper);

var _createMeasurementElement = createMeasurementElement$1;

var _htmlParser = htmlParser;

var _htmlParser2 = _interopRequireDefault(_htmlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const keyphraseDistribution = new _KeyphraseDistributionAssessment2.default();

var inputDebounceDelay = 800;

/**
 * Default config for YoastSEO.js
 *
 * @type {Object}
 */
var defaults = {
	callbacks: {
		bindElementEvents: function bindElementEvents() {},
		updateSnippetValues: function updateSnippetValues() {},
		saveScores: function saveScores() {},
		saveContentScore: function saveContentScore() {},
		updatedContentResults: function updatedContentResults() {},
		updatedKeywordsResults: function updatedKeywordsResults() {}
	},
	sampleText: {
		baseUrl: "example.org/",
		snippetCite: "example-post/",
		title: "This is an example title - edit by clicking here",
		keyword: "Choose a focus keyword",
		meta: "Modify your meta description by editing it right here",
		text: "Start writing your text!"
	},
	queue: ["wordCount", "keywordDensity", "subHeadings", "stopwords", "fleschReading", "linkCount", "imageCount", "urlKeyword", "urlLength", "metaDescription", "pageTitleKeyword", "pageTitleWidth", "firstParagraph", "'keywordDoubles"],
	typeDelay: 3000,
	typeDelayStep: 1500,
	maxTypeDelay: 5000,
	dynamicDelay: true,
	locale: "en_US",
	translations: {
		domain: "js-text-analysis",
		// eslint-disable-next-line camelcase
		locale_data: {
			"js-text-analysis": {
				"": {}
			}
		}
	},
	replaceTarget: [],
	resetTarget: [],
	elementTarget: [],
	marker: function marker() {},
	keywordAnalysisActive: true,
	contentAnalysisActive: true,
	hasSnippetPreview: true,
	debounceRefresh: true
};

/**
 * Creates a default snippet preview, this can be used if no snippet preview has been passed.
 *
 * @private
 * @this App
 *
 * @returns {SnippetPreview} The SnippetPreview object.
 */
function createDefaultSnippetPreview() {
	var targetElement = document.getElementById(this.config.targets.snippet);

	return new _snippetPreview2.default({
		analyzerApp: this,
		targetElement: targetElement,
		callbacks: {
			saveSnippetData: this.config.callbacks.saveSnippetData
		}
	});
}

/**
 * Returns whether or not the given argument is a valid SnippetPreview object.
 *
 * @param   {*}         snippetPreview  The 'object' to check against.
 * @returns {boolean}                   Whether or not it's a valid SnippetPreview object.
 */
function isValidSnippetPreview(snippetPreview) {
	return !(0, _lodashEs.isUndefined)(snippetPreview) && _snippetPreview2.default.prototype.isPrototypeOf(snippetPreview);
}

/**
 * Check arguments passed to the App to check if all necessary arguments are set.
 *
 * @private
 * @param {Object}      args            The arguments object passed to the App.
 * @returns {void}
 */
function verifyArguments(args) {
	if (!(0, _lodashEs.isObject)(args.callbacks.getData)) {
		throw new _missingArgument2.default("The app requires an object with a getdata callback.");
	}

	if (!(0, _lodashEs.isObject)(args.targets)) {
		throw new _missingArgument2.default("`targets` is a required App argument, `targets` is not an object.");
	}

	// The args.targets.snippet argument is only required if not SnippetPreview object has been passed.
	if (args.hasSnippetPreview && !isValidSnippetPreview(args.snippetPreview) && !(0, _lodashEs.isString)(args.targets.snippet)) {
		throw new _missingArgument2.default("A snippet preview is required. When no SnippetPreview object isn't passed to " + "the App, the `targets.snippet` is a required App argument. `targets.snippet` is not a string.");
	}
}

/**
 * This should return an object with the given properties
 *
 * @callback YoastSEO.App~getData
 * @returns {Object} data
 * @returns {String} data.keyword The keyword that should be used
 * @returns {String} data.meta
 * @returns {String} data.text The text to analyze
 * @returns {String} data.metaTitle The text in the HTML title tag
 * @returns {String} data.title The title to analyze
 * @returns {String} data.url The URL for the given page
 * @returns {String} data.excerpt Excerpt for the pages
 */

/**
 * @callback YoastSEO.App~getAnalyzerInput
 *
 * @returns {Array} An array containing the analyzer queue
 */

/**
 * @callback YoastSEO.App~bindElementEvents
 *
 * @param {YoastSEO.App} app A reference to the YoastSEO.App from where this is called.
 */

/**
 * @callback YoastSEO.App~updateSnippetValues
 *
 * @param {Object} ev The event emitted from the DOM
 */

/**
 * @callback YoastSEO.App~saveScores
 *
 * @param {int} score The overall keyword score as determined by the assessor.
 * @param {AssessorPresenter} assessorPresenter The assessor presenter that will be used to render the keyword score.
 */

/**
 * @callback YoastSEO.App~saveContentScore
 *
 * @param {int} score The overall content score as determined by the assessor.
 * @param {AssessorPresenter} assessorPresenter The assessor presenter that will be used to render the content score.
 */

/**
 * @callback YoastSEO.App~updatedContentResults
 *
 * @param {Object[]} result The updated content analysis results.
 * @param {number} result[].score The SEO score.
 * @param {string} result[].rating String representation of the SEO score.
 * @param {string} result[].text Textual explanation of the score.
 * @param {number} overallContentScore The overall content SEO score.
 */

/**
 * @callback YoastSEO.App~updatedKeywordsResults
 *
 * @param {Object[]} result The updated keywords analysis results.
 * @param {number} result[].score The SEO score.
 * @param {string} result[].rating String representation of the SEO score.
 * @param {string} result[].text Textual explanation of the score.
 * @param {number} overallContentScore The overall keywords SEO score.
 */

/**
 * Loader for the analyzer, loads the eventbinder and the elementdefiner
 *
 * @param {Object} args The arguments passed to the loader.
 * @param {Object} args.translations Jed compatible translations.
 * @param {Object} args.targets Targets to retrieve or set on.
 * @param {String} args.targets.snippet ID for the snippet preview element.
 * @param {String} args.targets.output ID for the element to put the output of the analyzer in.
 * @param {int} args.typeDelay Number of milliseconds to wait between typing to refresh the analyzer output.
 * @param {boolean} args.dynamicDelay   Whether to enable dynamic delay, will ignore type delay if the analyzer takes a long time.
 *                                      Applicable on slow devices.
 * @param {int} args.maxTypeDelay The maximum amount of type delay even if dynamic delay is on.
 * @param {int} args.typeDelayStep The amount with which to increase the typeDelay on each step when dynamic delay is enabled.
 * @param {Object} args.callbacks The callbacks that the app requires.
 * @param {Object} args.assessor The Assessor to use instead of the default assessor.
 * @param {YoastSEO.App~getData} args.callbacks.getData Called to retrieve input data
 * @param {YoastSEO.App~getAnalyzerInput} args.callbacks.getAnalyzerInput Called to retrieve input for the analyzer.
 * @param {YoastSEO.App~bindElementEvents} args.callbacks.bindElementEvents Called to bind events to the DOM elements.
 * @param {YoastSEO.App~updateSnippetValues} args.callbacks.updateSnippetValues Called when the snippet values need to be updated.
 * @param {YoastSEO.App~saveScores} args.callbacks.saveScores Called when the score has been determined by the analyzer.
 * @param {YoastSEO.App~saveContentScore} args.callback.saveContentScore Called when the content score has been
 *                                                                       determined by the assessor.
 * @param {YoastSEO.App~updatedContentResults} args.callbacks.updatedContentResults Called when the score has been determined
 *                                                                                  by the analyzer.
 * @param {YoastSEO.App~updatedKeywordsResults} args.callback.updatedKeywordsResults Called when the content score has been
 *                                                                                   determined by the assessor.
 * @param {Function} args.callbacks.saveSnippetData Function called when the snippet data is changed.
 * @param {Function} args.marker The marker to use to apply the list of marks retrieved from an assessment.
 *
 * @param {SnippetPreview} args.snippetPreview The SnippetPreview object to be used.
 * @param {boolean} [args.debouncedRefresh] Whether or not to debounce the
 *                                          refresh function. Defaults to true.
 *
 * @constructor
 */
var App = function App(args) {
	if (!(0, _lodashEs.isObject)(args)) {
		args = {};
	}

	(0, _lodashEs.defaultsDeep)(args, defaults);

	verifyArguments(args);

	this.config = args;

	if (args.debouncedRefresh === true) {
		this.refresh = (0, _lodashEs.debounce)(this.refresh.bind(this), inputDebounceDelay);
	}
	this._pureRefresh = (0, _lodashEs.throttle)(this._pureRefresh.bind(this), this.config.typeDelay);

	this.callbacks = this.config.callbacks;
	this.i18n = this.constructI18n(this.config.translations);

	this.initializeAssessors(args);

	this.pluggable = new _pluggable2.default(this);

	this.getData();

	this.defaultOutputElement = this.getDefaultOutputElement(args);

	if (this.defaultOutputElement !== "") {
		this.showLoadingDialog();
	}

	if (isValidSnippetPreview(args.snippetPreview)) {
		this.snippetPreview = args.snippetPreview;

		/* Hack to make sure the snippet preview always has a reference to this App. This way we solve the circular
  dependency issue. In the future this should be solved by the snippet preview not having a reference to the
  app.*/
		if (this.snippetPreview.refObj !== this) {
			this.snippetPreview.refObj = this;
			this.snippetPreview._i18n = this.i18n;
		}
	} else if (args.hasSnippetPreview) {
		this.snippetPreview = createDefaultSnippetPreview.call(this);
	}

	this._assessorOptions = {
		useCornerStone: false,
		useKeywordDistribution: false
	};

	this.initSnippetPreview();
	this.initAssessorPresenters();
};

/**
 * Returns the default output element based on which analyses are active.
 *
 * @param {Object} args The arguments passed to the App.
 * @returns {string} The ID of the target that is active.
 */
App.prototype.getDefaultOutputElement = function (args) {
	if (args.keywordAnalysisActive) {
		return args.targets.output;
	}

	if (args.contentAnalysisActive) {
		return args.targets.contentOutput;
	}

	return "";
};

/**
 * Sets the assessors based on the assessor options and refreshes them.
 *
 * @param {Object} assessorOptions The specific options.
 * @returns {void}
 */
App.prototype.changeAssessorOptions = function (assessorOptions) {
	this._assessorOptions = (0, _lodashEs.merge)(this._assessorOptions, assessorOptions);

	// Set the assessors based on the new assessor options.
	this.seoAssessor = this.getSeoAssessor();
	this.contentAssessor = this.getContentAssessor();

	// Refresh everything so the user sees the changes.
	this.initAssessorPresenters();
	this.refresh();
};

/**
 * Returns an instance of the seo assessor to use.
 *
 * @returns {Assessor} The assessor instance.
 */
App.prototype.getSeoAssessor = function () {
	var _assessorOptions = this._assessorOptions;
	const useCornerStone = _assessorOptions.useCornerStone,
	      useKeywordDistribution = _assessorOptions.useKeywordDistribution;


	const assessor = useCornerStone ? this.cornerStoneSeoAssessor : this.defaultSeoAssessor;
	if (useKeywordDistribution && (0, _lodashEs.isUndefined)(assessor.getAssessment("keyphraseDistribution"))) {
		assessor.addAssessment("keyphraseDistribution", keyphraseDistribution);
	}

	return assessor;
};

/**
 * Returns an instance of the content assessor to use.
 *
 * @returns {Assessor} The assessor instance.
 */
App.prototype.getContentAssessor = function () {
	const useCornerStone = this._assessorOptions.useCornerStone;


	if (useCornerStone) {
		return this.cornerStoneContentAssessor;
	}

	return this.defaultContentAssessor;
};

/**
 * Initializes assessors based on if the respective analysis is active.
 *
 * @param {Object} args The arguments passed to the App.
 * @returns {void}
 */
App.prototype.initializeAssessors = function (args) {
	this.initializeSEOAssessor(args);
	this.initializeContentAssessor(args);
};

/**
 * Initializes the SEO assessor.
 *
 * @param {Object} args The arguments passed to the App.
 * @returns {void}
 */
App.prototype.initializeSEOAssessor = function (args) {
	if (!args.keywordAnalysisActive) {
		return;
	}

	this.defaultSeoAssessor = new _seoAssessor2.default(this.i18n, { marker: this.config.marker });
	this.cornerStoneSeoAssessor = new _seoAssessor4.default(this.i18n, { marker: this.config.marker });

	// Set the assessor
	if ((0, _lodashEs.isUndefined)(args.seoAssessor)) {
		this.seoAssessor = this.defaultSeoAssessor;
	} else {
		this.seoAssessor = args.seoAssessor;
	}
};

/**
 * Initializes the content assessor.
 *
 * @param {Object} args The arguments passed to the App.
 * @returns {void}
 */
App.prototype.initializeContentAssessor = function (args) {
	if (!args.contentAnalysisActive) {
		return;
	}

	this.defaultContentAssessor = new _contentAssessor2.default(this.i18n, { marker: this.config.marker, locale: this.config.locale });
	this.cornerStoneContentAssessor = new _contentAssessor4.default(this.i18n, { marker: this.config.marker, locale: this.config.locale });

	// Set the content assessor
	if ((0, _lodashEs.isUndefined)(args._contentAssessor)) {
		this.contentAssessor = this.defaultContentAssessor;
	} else {
		this.contentAssessor = args._contentAssessor;
	}
};

/**
 * Extend the config with defaults.
 *
 * @param   {Object}    args    The arguments to be extended.
 * @returns {Object}    args    The extended arguments.
 */
App.prototype.extendConfig = function (args) {
	args.sampleText = this.extendSampleText(args.sampleText);
	args.locale = args.locale || "en_US";

	return args;
};

/**
 * Extend sample text config with defaults.
 *
 * @param   {Object}    sampleText  The sample text to be extended.
 * @returns {Object}    sampleText  The extended sample text.
 */
App.prototype.extendSampleText = function (sampleText) {
	var defaultSampleText = defaults.sampleText;

	if ((0, _lodashEs.isUndefined)(sampleText)) {
		return defaultSampleText;
	}

	for (var key in sampleText) {
		if ((0, _lodashEs.isUndefined)(sampleText[key])) {
			sampleText[key] = defaultSampleText[key];
		}
	}

	return sampleText;
};

/**
 * Initializes i18n object based on passed configuration
 *
 * @param {Object}  translations    The translations to be used in the current instance.
 * @returns {void}
 */
App.prototype.constructI18n = function (translations) {
	var defaultTranslations = {
		domain: "js-text-analysis",
		// eslint-disable-next-line camelcase
		locale_data: {
			"js-text-analysis": {
				"": {}
			}
		}
	};

	// Use default object to prevent Jed from erroring out.
	translations = translations || defaultTranslations;

	return new _jed2.default(translations);
};

/**
 * Registers a custom data callback.
 *
 * @param {Function} callback The callback to register.
 *
 * @returns {void}
 */
App.prototype.registerCustomDataCallback = function (callback) {
	if (!this.callbacks.custom) {
		this.callbacks.custom = [];
	}

	if ((0, _lodashEs.isFunction)(callback)) {
		this.callbacks.custom.push(callback);
	}
};

/**
 * Retrieves data from the callbacks.getData and applies modification to store these in this.rawData.
 *
 * @returns {void}
 */
App.prototype.getData = function () {
	this.rawData = this.callbacks.getData();

	// Add the custom data to the raw data.
	if ((0, _lodashEs.isArray)(this.callbacks.custom)) {
		this.callbacks.custom.forEach(customCallback => {
			const customData = customCallback();

			this.rawData = (0, _lodashEs.merge)(this.rawData, customData);
		});
	}

	if (this.hasSnippetPreview()) {
		// Gets the data FOR the analyzer
		var data = this.snippetPreview.getAnalyzerData();

		this.rawData.metaTitle = data.title;
		this.rawData.url = data.url;
		this.rawData.meta = data.metaDesc;
	}

	if (this.pluggable.loaded) {
		this.rawData.metaTitle = this.pluggable._applyModifications("data_page_title", this.rawData.metaTitle);
		this.rawData.meta = this.pluggable._applyModifications("data_meta_desc", this.rawData.meta);
	}

	this.rawData.titleWidth = (0, _createMeasurementElement.measureTextWidth)(this.rawData.metaTitle);

	this.rawData.locale = this.config.locale;
};

/**
 * Refreshes the analyzer and output of the analyzer, is debounced for a better experience.
 *
 * @returns {void}
 */
App.prototype.refresh = function () {
	// Until all plugins are loaded, do not trigger a refresh.
	if (!this.pluggable.loaded) {
		return;
	}

	this._pureRefresh();
};

/**
 * Refreshes the analyzer and output of the analyzer, is throttled to prevent performance issues.
 *
 * @returns {void}
 *
 * @private
 */
App.prototype._pureRefresh = function () {
	this.getData();
	this.runAnalyzer();
};

/**
 * Determines whether or not this app has a snippet preview.
 *
 * @returns {boolean} Whether or not this app has a snippet preview.
 */
App.prototype.hasSnippetPreview = function () {
	return this.snippetPreview !== null && !(0, _lodashEs.isUndefined)(this.snippetPreview);
};

/**
 * Initializes the snippet preview for this App.
 *
 * @returns {void}
 */
App.prototype.initSnippetPreview = function () {
	if (this.hasSnippetPreview()) {
		this.snippetPreview.renderTemplate();
		this.snippetPreview.callRegisteredEventBinder();
		this.snippetPreview.bindEvents();
		this.snippetPreview.init();
	}
};

/**
 * Initializes the assessorpresenters for content and SEO.
 *
 * @returns {void}
 */
App.prototype.initAssessorPresenters = function () {
	// Pass the assessor result through to the formatter
	if (!(0, _lodashEs.isUndefined)(this.config.targets.output)) {
		this.seoAssessorPresenter = new _AssessorPresenter2.default({
			targets: {
				output: this.config.targets.output
			},
			assessor: this.seoAssessor,
			i18n: this.i18n
		});
	}

	if (!(0, _lodashEs.isUndefined)(this.config.targets.contentOutput)) {
		// Pass the assessor result through to the formatter
		this.contentAssessorPresenter = new _AssessorPresenter2.default({
			targets: {
				output: this.config.targets.contentOutput
			},
			assessor: this.contentAssessor,
			i18n: this.i18n
		});
	}
};

/**
 * Binds the refresh function to the input of the targetElement on the page.
 *
 * @returns {void}
 */
App.prototype.bindInputEvent = function () {
	for (var i = 0; i < this.config.elementTarget.length; i++) {
		var elem = document.getElementById(this.config.elementTarget[i]);
		elem.addEventListener("input", this.refresh.bind(this));
	}
};

/**
 * Runs the rerender function of the snippetPreview if that object is defined.
 *
 * @returns {void}
 */
App.prototype.reloadSnippetText = function () {
	if (this.hasSnippetPreview()) {
		this.snippetPreview.reRender();
	}
};

/**
 * Sets the startTime timestamp.
 *
 * @returns {void}
 */
App.prototype.startTime = function () {
	this.startTimestamp = new Date().getTime();
};

/**
 * Sets the endTime timestamp and compares with startTime to determine typeDelayincrease.
 *
 * @returns {void}
 */
App.prototype.endTime = function () {
	this.endTimestamp = new Date().getTime();
	if (this.endTimestamp - this.startTimestamp > this.config.typeDelay) {
		if (this.config.typeDelay < this.config.maxTypeDelay - this.config.typeDelayStep) {
			this.config.typeDelay += this.config.typeDelayStep;
		}
	}
};

/**
 * Inits a new pageAnalyzer with the inputs from the getInput function and calls the scoreFormatter
 * to format outputs.
 *
 * @returns {void}
 */
App.prototype.runAnalyzer = function () {
	if (this.pluggable.loaded === false) {
		return;
	}

	if (this.config.dynamicDelay) {
		this.startTime();
	}

	this.analyzerData = this.modifyData(this.rawData);

	if (this.hasSnippetPreview()) {
		this.snippetPreview.refresh();
	}

	let text = this.analyzerData.text;

	// Insert HTML stripping code
	text = (0, _htmlParser2.default)(text);

	let titleWidth = this.analyzerData.titleWidth;
	if (this.hasSnippetPreview()) {
		titleWidth = this.snippetPreview.getTitleWidth();
	}

	// Create a paper object for the Researcher
	this.paper = new _Paper2.default(text, {
		keyword: this.analyzerData.keyword,
		synonyms: this.analyzerData.synonyms,
		description: this.analyzerData.meta,
		url: this.analyzerData.url,
		title: this.analyzerData.metaTitle,
		titleWidth: titleWidth,
		locale: this.config.locale,
		permalink: this.analyzerData.permalink
	});

	// The new researcher
	if ((0, _lodashEs.isUndefined)(this.researcher)) {
		this.researcher = new _researcher2.default(this.paper);
	} else {
		this.researcher.setPaper(this.paper);
	}

	this.runKeywordAnalysis();

	this.runContentAnalysis();

	this._renderAnalysisResults();

	if (this.config.dynamicDelay) {
		this.endTime();
	}

	if (this.hasSnippetPreview()) {
		this.snippetPreview.reRender();
	}
};

/**
 * Runs the keyword analysis and calls the appropriate callbacks.
 *
 * @returns {void}
 */
App.prototype.runKeywordAnalysis = function () {
	if (this.config.keywordAnalysisActive) {
		this.seoAssessor.assess(this.paper);
		const overallSeoScore = this.seoAssessor.calculateOverallScore();

		if (!(0, _lodashEs.isUndefined)(this.callbacks.updatedKeywordsResults)) {
			this.callbacks.updatedKeywordsResults(this.seoAssessor.results, overallSeoScore);
		}

		if (!(0, _lodashEs.isUndefined)(this.callbacks.saveScores)) {
			this.callbacks.saveScores(overallSeoScore, this.seoAssessorPresenter);
		}
	}
};

/**
 * Runs the content analysis and calls the appropriate callbacks.
 *
 * @returns {void}
 */
App.prototype.runContentAnalysis = function () {
	if (this.config.contentAnalysisActive) {
		this.contentAssessor.assess(this.paper);
		const overallContentScore = this.contentAssessor.calculateOverallScore();

		if (!(0, _lodashEs.isUndefined)(this.callbacks.updatedContentResults)) {
			this.callbacks.updatedContentResults(this.contentAssessor.results, overallContentScore);
		}

		if (!(0, _lodashEs.isUndefined)(this.callbacks.saveContentScore)) {
			this.callbacks.saveContentScore(overallContentScore, this.contentAssessorPresenter);
		}
	}
};

/**
 * Modifies the data with plugins before it is sent to the analyzer.
 *
 * @param   {Object}  data      The data to be modified.
 * @returns {Object}            The data with the applied modifications.
 */
App.prototype.modifyData = function (data) {
	// Copy rawdata to lose object reference.
	data = JSON.parse(JSON.stringify(data));

	data.text = this.pluggable._applyModifications("content", data.text);
	data.metaTitle = this.pluggable._applyModifications("title", data.metaTitle);

	return data;
};

/**
 * Function to fire the analyzer when all plugins are loaded, removes the loading dialog.
 *
 * @returns {void}
 */
App.prototype.pluginsLoaded = function () {
	this.removeLoadingDialog();
	this.refresh();
};

/**
 * Shows the loading dialog which shows the loading of the plugins.
 *
 * @returns {void}
 */
App.prototype.showLoadingDialog = function () {
	var outputElement = document.getElementById(this.defaultOutputElement);

	if (this.defaultOutputElement !== "" && !(0, _lodashEs.isEmpty)(outputElement)) {
		var dialogDiv = document.createElement("div");
		dialogDiv.className = "YoastSEO_msg";
		dialogDiv.id = "YoastSEO-plugin-loading";
		document.getElementById(this.defaultOutputElement).appendChild(dialogDiv);
	}
};

/**
 * Updates the loading plugins. Uses the plugins as arguments to show which plugins are loading.
 *
 * @param   {Object}  plugins   The plugins to be parsed into the dialog.
 * @returns {void}
 */
App.prototype.updateLoadingDialog = function (plugins) {
	var outputElement = document.getElementById(this.defaultOutputElement);

	if (this.defaultOutputElement === "" || (0, _lodashEs.isEmpty)(outputElement)) {
		return;
	}

	var dialog = document.getElementById("YoastSEO-plugin-loading");
	dialog.textContent = "";

	(0, _lodashEs.forEach)(plugins, function (plugin, pluginName) {
		dialog.innerHTML += "<span class=left>" + pluginName + "</span><span class=right " + plugin.status + ">" + plugin.status + "</span><br />";
	});

	dialog.innerHTML += "<span class=bufferbar></span>";
};

/**
 * Removes the pluging load dialog.
 *
 * @returns {void}
 */
App.prototype.removeLoadingDialog = function () {
	var outputElement = document.getElementById(this.defaultOutputElement);
	var loadingDialog = document.getElementById("YoastSEO-plugin-loading");

	if (this.defaultOutputElement !== "" && !(0, _lodashEs.isEmpty)(outputElement) && !(0, _lodashEs.isEmpty)(loadingDialog)) {
		document.getElementById(this.defaultOutputElement).removeChild(document.getElementById("YoastSEO-plugin-loading"));
	}
};

// ***** PLUGGABLE PUBLIC DSL ***** //

/**
 * Delegates to `YoastSEO.app.pluggable.registerPlugin`
 *
 * @param {string}  pluginName      The name of the plugin to be registered.
 * @param {object}  options         The options object.
 * @param {string}  options.status  The status of the plugin being registered. Can either be "loading" or "ready".
 * @returns {boolean}               Whether or not it was successfully registered.
 */
App.prototype.registerPlugin = function (pluginName, options) {
	return this.pluggable._registerPlugin(pluginName, options);
};

/**
 * Delegates to `YoastSEO.app.pluggable.ready`
 *
 * @param {string}  pluginName  The name of the plugin to check.
 * @returns {boolean}           Whether or not the plugin is ready.
 */
App.prototype.pluginReady = function (pluginName) {
	return this.pluggable._ready(pluginName);
};

/**
 * Delegates to `YoastSEO.app.pluggable.reloaded`
 *
 * @param {string} pluginName   The name of the plugin to reload
 * @returns {boolean}           Whether or not the plugin was reloaded.
 */
App.prototype.pluginReloaded = function (pluginName) {
	return this.pluggable._reloaded(pluginName);
};

/**
 * Delegates to `YoastSEO.app.pluggable.registerModification`.
 *
 * @param {string}   modification   The name of the filter
 * @param {function} callable       The callable function
 * @param {string}   pluginName     The plugin that is registering the modification.
 * @param {number}   [priority]     Used to specify the order in which the callables associated with a particular filter are called.
 *                                  Lower numbers correspond with earlier execution.
 *
 * @returns {boolean} Whether or not the modification was successfully registered.
 */
App.prototype.registerModification = function (modification, callable, pluginName, priority) {
	return this.pluggable._registerModification(modification, callable, pluginName, priority);
};

/**
 * Registers a custom assessment for use in the analyzer, this will result in a new line in the analyzer results.
 * The function needs to use the assessmentresult to return an result  based on the contents of the page/posts.
 *
 * Score 0 results in a grey circle if it is not explicitly set by using setscore
 * Scores 0, 1, 2, 3 and 4 result in a red circle
 * Scores 6 and 7 result in a yellow circle
 * Scores 8, 9 and 10 result in a green circle
 *
 * @param {string} name Name of the test.
 * @param {function} assessment The assessment to run
 * @param {string}   pluginName The plugin that is registering the test.
 * @returns {boolean} Whether or not the test was successfully registered.
 */
App.prototype.registerAssessment = function (name, assessment, pluginName) {
	if (!(0, _lodashEs.isUndefined)(this.seoAssessor)) {
		return this.pluggable._registerAssessment(this.defaultSeoAssessor, name, assessment, pluginName) && this.pluggable._registerAssessment(this.cornerStoneSeoAssessor, name, assessment, pluginName);
	}
};

/**
 * Disables markers visually in the UI.
 *
 * @returns {void}
 */
App.prototype.disableMarkers = function () {
	if (!(0, _lodashEs.isUndefined)(this.seoAssessorPresenter)) {
		this.seoAssessorPresenter.disableMarker();
	}

	if (!(0, _lodashEs.isUndefined)(this.contentAssessorPresenter)) {
		this.contentAssessorPresenter.disableMarker();
	}
};

/**
 * Renders the content and keyword analysis results.
 *
 * @returns {void}
 */
App.prototype._renderAnalysisResults = function () {
	if (this.config.contentAnalysisActive && !(0, _lodashEs.isUndefined)(this.contentAssessorPresenter)) {
		this.contentAssessorPresenter.renderIndividualRatings();
	}
	if (this.config.keywordAnalysisActive && !(0, _lodashEs.isUndefined)(this.seoAssessorPresenter)) {
		this.seoAssessorPresenter.setKeyword(this.paper.getKeyword());
		this.seoAssessorPresenter.render();
	}
};

// Deprecated functions
/**
 * The analyzeTimer calls the checkInputs function with a delay, so the function won't be executed
 * at every keystroke checks the reference object, so this function can be called from anywhere,
 * without problems with different scopes.
 *
 * @deprecated: 1.3 - Use this.refresh() instead.
 *
 * @returns {void}
 */
App.prototype.analyzeTimer = function () {
	this.refresh();
};

/**
 * Registers a custom test for use in the analyzer, this will result in a new line in the analyzer results. The function
 * has to return a result based on the contents of the page/posts.
 *
 * The scoring object is a special object with definitions about how to translate a result from your analysis function
 * to a SEO score.
 *
 * Negative scores result in a red circle
 * Scores 1, 2, 3, 4 and 5 result in a orange circle
 * Scores 6 and 7 result in a yellow circle
 * Scores 8, 9 and 10 result in a red circle
 *
 * @returns {void}
 *
 * @deprecated since version 1.2
 */
App.prototype.registerTest = function () {
	console.error("This function is deprecated, please use registerAssessment");
};

/**
 * Creates the elements for the snippetPreview
 *
 * @deprecated Don't create a snippet preview using this method, create it directly using the prototype and pass it as
 * an argument instead.
 *
 * @returns {void}
 */
App.prototype.createSnippetPreview = function () {
	this.snippetPreview = createDefaultSnippetPreview.call(this);
	this.initSnippetPreview();
};

/**
 * Switches between the cornerstone and default assessors.
 *
 * @deprecated 1.35.0 - Use changeAssessorOption instead.
 *
 * @param {boolean} useCornerStone True when cornerstone should be used.
 *
 * @returns {void}
 */
App.prototype.switchAssessors = function (useCornerStone) {
	// eslint-disable-next-line no-console
	console.warn("Switch assessor is deprecated since YoastSEO.js version 1.35.0");

	this.changeAssessorOptions({
		useCornerStone
	});
};

app.default = App;

function getI18n (translations) {
  const defaultTranslations = {
    domain: 'js-text-analysis',
    // eslint-disable-next-line camelcase
    locale_data: {
      'js-text-analysis': {
        '': {}
      }
    }
  };
  // Use default object to prevent Jed from erroring out.
  translations = translations || defaultTranslations;
  return new Jed(translations)
}

function rateTitleLength (titleLength) {
  let rating;
  switch (true) {
    case titleLength > 0 && titleLength <= 399:
    case titleLength > 600:
      rating = 'ok';
      break

    case titleLength >= 400 && titleLength <= 600:
      rating = 'good';
      break

    default:
      rating = 'bad';
      break
  }
  return rating
}

function rateMetaDescLength (metaDescLength) {
  let rating;
  switch (true) {
    case metaDescLength > 0 && metaDescLength < 120:
    case metaDescLength > 320:
      rating = 'ok';
      break

    case metaDescLength >= 120 && metaDescLength <= 320:
      rating = 'good';
      break

    default:
      rating = 'bad';
      break
  }
  return rating
}

function getAssessorRatings () {
  return ['feedback', 'bad', 'ok', 'good']
}

//

const removeHtmlBlocks$1 = removeHtmlBlocks$2;
const scoreToRating$1 = scoreToRating$2;
const ratings$1 = getAssessorRatings();

var script$2 = {
  props: {
    title: {
      type: String,
      default: ''
    },
    titleWidth: {
      type: Number,
      default: 0
    },
    description: {
      type: String,
      default: ''
    },
    keyword: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    locale: {
      type: String,
      default: 'en_US'
    },
    marker: {
      type: [Object, null],
      default () {
        return null
      }
    },
    permalink: {
      type: String,
      default: ''
    },
    translations: {
      type: Object,
      default () {
        return null
      }
    },
    resultFilter: {
      type: Function,
      default (result) {
        return result
      }
    }
  },
  data () {
    return {
      assessorResults: [],
      assessorResultsByRating: {},
      overallContentScore: null,
      overallContentRating: null,
      contentAssessor: null
    }
  },
  computed: {
    items () {
      const res = [];
      ratings$1.forEach((rating) => {
        const items = this.assessorResultsByRating[rating];
        if (typeof items === 'undefined') return
        items.forEach((item) => {
          item._class = [
            'vue-yoast-assessor-item',
            'vue-yoast-assessor-item-' + item.rating
          ];
          res.push(item);
        });
      });
      return res
    }
  },
  watch: {
    title (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    description (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    keyword (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    url (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    text (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    translations (newVal) {
      this.i18n = getI18n(newVal);
      this._debouncedRefresh();
    },
    locale (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    overallContentScore () {
      this.$emit('update:overallScore', {
        score: this.overallContentScore,
        rating: this.overallContentRating
      });
    }
  },
  created () {
    this._debouncedRefresh = debounce_1(this.refresh, 1000);
  },
  mounted () {
    this.i18n = getI18n(this.translations);
    this.refresh();
  },
  methods: {
    refreshPaper () {
      const text = removeHtmlBlocks$1(this.text);
      this.paper = new _default(text, {
        keyword: this.keyword,
        description: this.description,
        url: this.url,
        title: this.title,
        titleWidth: this.titleWidth,
        locale: this.locale,
        permalink: this.permalink
      });
    },
    refresh () {
      this.refreshPaper();
      this.contentAssessor = new _default$1(this.i18n, { marker: this.marker });
      this.contentAssessor.assess(this.paper);
      this.overallScore = this.contentAssessor.calculateOverallScore();
      this.overallRating = scoreToRating$1(this.contentAssessor.calculateOverallScore() / 10);
      this.assessorResults = [];
      this.assessorResultsByRating = {};
      this.contentAssessor.results.forEach(item => {
        const result = this.resultFilter({
          rating: scoreToRating$1(item.score),
          socre: item.score,
          text: item.text
        });
        this.assessorResults.push(result);
        if (this.assessorResultsByRating.hasOwnProperty(result.rating)) {
          this.assessorResultsByRating[result.rating].push(result);
        } else {
          this.assessorResultsByRating[result.rating] = [result];
        }
      });
      this.$emit('update', {
        results: this.assessorResults,
        resultsByRating: this.assessorResultsByRating,
        overallScore: this.overallScore,
        overallRating: this.overallRating
      });
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$2 = script$2;
/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-yoast vue-yoast-assessor vue-yoast-content-assessor"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,class:item._class},[_vm._t("item",[_c('span',{staticClass:"vue-yoast-assessor-badge"},[_vm._v(" ")]),_c('span',{staticClass:"vue-yoast-assessor-text",domProps:{"innerHTML":_vm._s(item.text)}})],{"item":item})],2)}),0)};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

//

const removeHtmlBlocks = removeHtmlBlocks$2;
const scoreToRating = scoreToRating$2;
const ratings = getAssessorRatings();

var script$1 = {
  props: {
    title: {
      type: String,
      default: ''
    },
    titleWidth: {
      type: Number,
      default: 320
    },
    description: {
      type: String,
      default: ''
    },
    keyword: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    locale: {
      type: String,
      default: 'en_US'
    },
    marker: {
      type: [Object, null],
      default () {
        return null
      }
    },
    permalink: {
      type: String,
      default: ''
    },
    translations: {
      type: Object,
      default () {
        return null
      }
    },
    resultFilter: {
      type: Function,
      default (result) {
        return result
      }
    }
  },
  data () {
    return {
      assessorResults: [],
      assessorResultsByRating: {},
      overallSeoScore: null,
      overallSeoRating: null,
      seoAssessor: null
    }
  },
  computed: {
    items () {
      const res = [];
      ratings.forEach((rating) => {
        const items = this.assessorResultsByRating[rating];
        if (typeof items === 'undefined') return
        items.forEach((item) => {
          if (item.text.length === 0) return
          item._class = [
            'vue-yoast-assessor-item',
            'vue-yoast-assessor-item-' + item.rating
          ];
          res.push(item);
        });
      });
      return res
    }
  },
  watch: {
    title (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    titleWidth (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    description (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    keyword (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    url (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    text (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    translations (newVal) {
      this.i18n = getI18n(newVal);
      this.refresh();
    },
    locale (newVal, oldVal) {
      if (newVal !== oldVal) this._debouncedRefresh();
    },
    overallSeoScore () {
      this.$emit('update:overallScore', {
        score: this.overallSeoScore,
        rating: this.overallSeoRating
      });
    }
  },
  created () {
    this._debouncedRefresh = debounce_1(this.refresh, 1000);
  },
  mounted () {
    this.i18n = getI18n(this.translations);
    this.refresh();
  },
  methods: {
    refreshPaper () {
      const text = removeHtmlBlocks(this.text);
      this.paper = new _default(text, {
        keyword: this.keyword,
        description: this.description,
        url: this.url,
        title: this.title,
        titleWidth: this.titleWidth,
        locale: this.locale,
        permalink: this.permalink
      });
    },
    refresh () {
      this.refreshPaper();
      this.seoAssessor = new _default$4(this.i18n, { marker: this.marker });
      this.seoAssessor.assess(this.paper);
      this.overallSeoScore = this.seoAssessor.calculateOverallScore();
      this.overallSeoRating = scoreToRating(this.seoAssessor.calculateOverallScore() / 10);
      this.assessorResults = [];
      this.assessorResultsByRating = {};
      this.seoAssessor.results.forEach(item => {
        const result = this.resultFilter({
          rating: scoreToRating(item.score),
          socre: item.score,
          text: item.text
        });
        this.assessorResults.push(result);
        if (this.assessorResultsByRating.hasOwnProperty(result.rating)) {
          this.assessorResultsByRating[result.rating].push(result);
        } else {
          this.assessorResultsByRating[result.rating] = [result];
        }
      });
      this.$emit('update:results', this.assessorResults);
      this.$emit('update:resultsByRating', this.assessorResultsByRating);
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-yoast vue-yoast-assessor vue-yoast-content-assessor"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,class:item._class},[_vm._t("item",[_c('span',{staticClass:"vue-yoast-assessor-badge"},[_vm._v(" ")]),_c('span',{staticClass:"vue-yoast-assessor-text",domProps:{"innerHTML":_vm._s(item.text)}})],{"item":item})],2)}),0)};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

//

var script = {
  props: {
    title: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    metaHeight: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: Object,
      default () {
        return {
          title: 'This is an example title',
          metaDesc: 'This is meta description',
          urlPath: 'example-post/'
        }
      }
    },
    defaultValue: {
      type: Object,
      default () {
        return {
          title: '',
          metaDesc: ''
        }
      }
    },
    addTrailingSlash: {
      type: Boolean,
      default: true
    },
    metaDescriptionDate: {
      type: String,
      default: ''
    },
    previewMode: {
      type: String,
      default: 'desktop'
    },
    baseUrl: {
      type: String,
      default: 'http://example.com/'
    },
    hasProgressSupport: {
      type: Boolean,
      default: true
    },
    maxTitleWidth: {
      type: Number,
      default: 600
    },
    maxDescriptionLength: {
      type: Number,
      default: 320
    }
  },
  computed: {
    description_ () {
      const desc = this.description;
      const maxLength = this.maxDescriptionLength;
      const more = desc.length > maxLength ? ' ...' : '';
      return desc.substr(0, maxLength) + more
    }
  },
  watch: {
    title () {
      this.onTitleUpdated();
    },
    description () {
      this.$emit('update:descriptionLengthPercent', (this.description.length / this.maxDescriptionLength) * 100);
    }
  },
  methods: {
    titleRate () {
      const el = this.$refs.title;
      if (el) {
        return rateTitleLength(this.$refs.title.offsetWidth)
      }
      return ''
    },
    descriptionRate () {
      return rateMetaDescLength(this.description.length)
    },
    onTitleUpdated () {
      const w = this.$refs.title.offsetWidth;
      this.$emit('update:titleWidth', w);
      this.$emit('update:titleLengthPercent', (w / this.maxTitleWidth) * 100);
    }
  },
  mounted () {
    this.onTitleUpdated();
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-yoast vue-yoast-snippet-preview"},[_c('div',{staticClass:"vue-yoast-snippet-preview-title"},[_c('span',{ref:"title",domProps:{"textContent":_vm._s(_vm.title)}})]),_c('div',{staticClass:"vue-yoast-snippet-preview-url"},[_c('span',{ref:"url",domProps:{"textContent":_vm._s(_vm.baseUrl + _vm.url)}})]),_c('div',{staticClass:"vue-yoast-snippet-preview-description"},[_c('span',{ref:"description",domProps:{"textContent":_vm._s(_vm.description_)}})])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__$2 as ContentAssessor, __vue_component__$1 as SeoAssessor, __vue_component__ as SnippetPreview };
